/* !
 * jQuery JavaScript Library v1.11.3
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:19Z
 */

(function ( global, factory ) {

  if ( typeof module === "object" && typeof module.exports === "object" ) {
    // For CommonJS and CommonJS-like environments where a proper window is present,
    // execute the factory and get jQuery
    // For environments that do not inherently posses a window with a document
    // (such as Node.js), expose a jQuery-making factory as module.exports
    // This accentuates the need for the creation of a real window
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info
    module.exports = global.document ?
      factory( global, true ) :
      function ( w ) {
        if ( !w.document ) {
          throw new Error( "jQuery requires a window with a document" );
        }
        return factory( w );
      };
  } else {
    factory( global );
  }

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function ( window, noGlobal ) {

  // Can't do this because several apps including ASP.NET trace
  // the stack via arguments.caller.callee and Firefox dies if
  // you try to trace through "use strict" call chains. (#13335)
  // Support: Firefox 18+
  //

  var deletedIds = [];

  var slice = deletedIds.slice;

  var concat = deletedIds.concat;

  var push = deletedIds.push;

  var indexOf = deletedIds.indexOf;

  var class2type = {};

  var toString = class2type.toString;

  var hasOwn = class2type.hasOwnProperty;

  var support = {};

  var
    version = "1.11.3",

    // Define a local copy of jQuery
    jQuery = function ( selector, context ) {
      // The jQuery object is actually just the init constructor 'enhanced'
      // Need init if jQuery is called (just allow error to be thrown if not included)
      return new jQuery.fn.init( selector, context );
    },

    // Support: Android<4.1, IE<9
    // Make sure we trim BOM and NBSP
    rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

    // Matches dashed string for camelizing
    rmsPrefix = /^-ms-/,
    rdashAlpha = /-([\da-z])/gi,

    // Used by jQuery.camelCase as callback to replace()
    fcamelCase = function ( all, letter ) {
      return letter.toUpperCase();
    };

  jQuery.fn = jQuery.prototype = {
    // The current version of jQuery being used
    jquery: version,

    constructor: jQuery,

    // Start with an empty selector
    selector: "",

    // The default length of a jQuery object is 0
    length: 0,

    toArray: function () {
      return slice.call( this );
    },

    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function ( num ) {
      return num != null ?

      // Return just the one element from the set
        ( num < 0 ? this[ num + this.length ] : this[ num ] ) :

      // Return all the elements in a clean array
        slice.call( this );
    },

    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function ( elems ) {

      // Build a new jQuery matched element set
      var ret = jQuery.merge( this.constructor(), elems );

      // Add the old object onto the stack (as a reference)
      ret.prevObject = this;
      ret.context = this.context;

      // Return the newly-formed element set
      return ret;
    },

    // Execute a callback for every element in the matched set.
    // (You can seed the arguments with an array of args, but this is
    // only used internally.)
    each: function ( callback, args ) {
      return jQuery.each( this, callback, args );
    },

    map: function ( callback ) {
      return this.pushStack( jQuery.map(this, function ( elem, i ) {
        return callback.call( elem, i, elem );
      }));
    },

    slice: function () {
      return this.pushStack( slice.apply( this, arguments ) );
    },

    first: function () {
      return this.eq( 0 );
    },

    last: function () {
      return this.eq( -1 );
    },

    eq: function ( i ) {
      var len = this.length,
        j = +i + ( i < 0 ? len : 0 );
      return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
    },

    end: function () {
      return this.prevObject || this.constructor(null);
    },

    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: push,
    sort: deletedIds.sort,
    splice: deletedIds.splice
  };

  jQuery.extend = jQuery.fn.extend = function () {
    var src, copyIsArray, copy, name, options, clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false;

    // Handle a deep copy situation
    if ( typeof target === "boolean" ) {
      deep = target;

      // skip the boolean and the target
      target = arguments[ i ] || {};
      i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
      target = {};
    }

    // extend jQuery itself if only one argument is passed
    if ( i === length ) {
      target = this;
      i--;
    }

    for ( ; i < length; i++ ) {
      // Only deal with non-null/undefined values
      if ( (options = arguments[ i ]) != null ) {
        // Extend the base object
        for ( name in options ) {
          src = target[ name ];
          copy = options[ name ];

          // Prevent never-ending loop
          if ( target === copy ) {
            continue;
          }

          // Recurse if we're merging plain objects or arrays
          if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
            if ( copyIsArray ) {
              copyIsArray = false;
              clone = src && jQuery.isArray(src) ? src : [];

            } else {
              clone = src && jQuery.isPlainObject(src) ? src : {};
            }

            // Never move original objects, clone them
            target[ name ] = jQuery.extend( deep, clone, copy );

            // Don't bring in undefined values
          } else if ( copy !== undefined ) {
            target[ name ] = copy;
          }
        }
      }
    }

    // Return the modified object
    return target;
  };

  jQuery.extend({
    // Unique for each copy of jQuery on the page
    expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

    // Assume jQuery is ready without the ready module
    isReady: true,

    error: function ( msg ) {
      throw new Error( msg );
    },

    noop: function () {},

    // See test/unit/core.js for details concerning isFunction.
    // Since version 1.3, DOM methods and functions like alert
    // aren't supported. They return false on IE (#2968).
    isFunction: function ( obj ) {
      return jQuery.type(obj) === "function";
    },

    isArray: Array.isArray || function ( obj ) {
      return jQuery.type(obj) === "array";
    },

    isWindow: function ( obj ) {
      /* jshint eqeqeq: false */
      return obj != null && obj == obj.window;
    },

    isNumeric: function ( obj ) {
      // parseFloat NaNs numeric-cast false positives (null|true|false|"")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      // adding 1 corrects loss of precision from parseFloat (#15100)
      return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
    },

    isEmptyObject: function ( obj ) {
      var name;
      for ( name in obj ) {
        return false;
      }
      return true;
    },

    isPlainObject: function ( obj ) {
      var key;

      // Must be an Object.
      // Because of IE, we also have to check the presence of the constructor property.
      // Make sure that DOM nodes and window objects don't pass through, as well
      if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
        return false;
      }

      try {
        // Not own constructor property must be Object
        if ( obj.constructor &&
				!hasOwn.call(obj, "constructor") &&
				!hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
          return false;
        }
      } catch ( e ) {
        // IE8,9 Will throw exceptions on certain host objects #9897
        return false;
      }

      // Support: IE<9
      // Handle iteration over inherited properties before own properties.
      if ( support.ownLast ) {
        for ( key in obj ) {
          return hasOwn.call( obj, key );
        }
      }

      // Own properties are enumerated firstly, so to speed up,
      // if last one is own, then all properties are own.
      for ( key in obj ) {}

      return key === undefined || hasOwn.call( obj, key );
    },

    type: function ( obj ) {
      if ( obj == null ) {
        return obj + "";
      }
      return typeof obj === "object" || typeof obj === "function" ?
        class2type[ toString.call(obj) ] || "object" :
        typeof obj;
    },

    // Evaluates a script in a global context
    // Workarounds based on findings by Jim Driscoll
    // http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
    globalEval: function ( data ) {
      if ( data && jQuery.trim( data ) ) {
        // We use execScript on Internet Explorer
        // We use an anonymous function so that context is window
        // rather than jQuery in Firefox
        ( window.execScript || function ( data ) {
          window[ "eval" ].call( window, data );
        } )( data );
      }
    },

    // Convert dashed to camelCase; used by the css and data modules
    // Microsoft forgot to hump their vendor prefix (#9572)
    camelCase: function ( string ) {
      return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
    },

    nodeName: function ( elem, name ) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    },

    // args is for internal usage only
    each: function ( obj, callback, args ) {
      var value,
        i = 0,
        length = obj.length,
        isArray = isArraylike( obj );

      if ( args ) {
        if ( isArray ) {
          for ( ; i < length; i++ ) {
            value = callback.apply( obj[ i ], args );

            if ( value === false ) {
              break;
            }
          }
        } else {
          for ( i in obj ) {
            value = callback.apply( obj[ i ], args );

            if ( value === false ) {
              break;
            }
          }
        }

        // A special, fast, case for the most common use of each
      } else {
        if ( isArray ) {
          for ( ; i < length; i++ ) {
            value = callback.call( obj[ i ], i, obj[ i ] );

            if ( value === false ) {
              break;
            }
          }
        } else {
          for ( i in obj ) {
            value = callback.call( obj[ i ], i, obj[ i ] );

            if ( value === false ) {
              break;
            }
          }
        }
      }

      return obj;
    },

    // Support: Android<4.1, IE<9
    trim: function ( text ) {
      return text == null ?
        "" :
        ( text + "" ).replace( rtrim, "" );
    },

    // results is for internal usage only
    makeArray: function ( arr, results ) {
      var ret = results || [];

      if ( arr != null ) {
        if ( isArraylike( Object(arr) ) ) {
          jQuery.merge( ret,
            typeof arr === "string" ?
              [ arr ] : arr
          );
        } else {
          push.call( ret, arr );
        }
      }

      return ret;
    },

    inArray: function ( elem, arr, i ) {
      var len;

      if ( arr ) {
        if ( indexOf ) {
          return indexOf.call( arr, elem, i );
        }

        len = arr.length;
        i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

        for ( ; i < len; i++ ) {
          // Skip accessing in sparse arrays
          if ( i in arr && arr[ i ] === elem ) {
            return i;
          }
        }
      }

      return -1;
    },

    merge: function ( first, second ) {
      var len = +second.length,
        j = 0,
        i = first.length;

      while ( j < len ) {
        first[ i++ ] = second[ j++ ];
      }

      // Support: IE<9
      // Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
      if ( len !== len ) {
        while ( second[j] !== undefined ) {
          first[ i++ ] = second[ j++ ];
        }
      }

      first.length = i;

      return first;
    },

    grep: function ( elems, callback, invert ) {
      var callbackInverse,
        matches = [],
        i = 0,
        length = elems.length,
        callbackExpect = !invert;

      // Go through the array, only saving the items
      // that pass the validator function
      for ( ; i < length; i++ ) {
        callbackInverse = !callback( elems[ i ], i );
        if ( callbackInverse !== callbackExpect ) {
          matches.push( elems[ i ] );
        }
      }

      return matches;
    },

    // arg is for internal usage only
    map: function ( elems, callback, arg ) {
      var value,
        i = 0,
        length = elems.length,
        isArray = isArraylike( elems ),
        ret = [];

      // Go through the array, translating each of the items to their new values
      if ( isArray ) {
        for ( ; i < length; i++ ) {
          value = callback( elems[ i ], i, arg );

          if ( value != null ) {
            ret.push( value );
          }
        }

        // Go through every key on the object,
      } else {
        for ( i in elems ) {
          value = callback( elems[ i ], i, arg );

          if ( value != null ) {
            ret.push( value );
          }
        }
      }

      // Flatten any nested arrays
      return concat.apply( [], ret );
    },

    // A global GUID counter for objects
    guid: 1,

    // Bind a function to a context, optionally partially applying any
    // arguments.
    proxy: function ( fn, context ) {
      var args, proxy, tmp;

      if ( typeof context === "string" ) {
        tmp = fn[ context ];
        context = fn;
        fn = tmp;
      }

      // Quick check to determine if target is callable, in the spec
      // this throws a TypeError, but we will just return undefined.
      if ( !jQuery.isFunction( fn ) ) {
        return undefined;
      }

      // Simulated bind
      args = slice.call( arguments, 2 );
      proxy = function () {
        return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
      };

      // Set the guid of unique handler to the same of original handler, so it can be removed
      proxy.guid = fn.guid = fn.guid || jQuery.guid++;

      return proxy;
    },

    now: function () {
      return +( new Date() );
    },

    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: support
  });

  // Populate the class2type map
  jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
    class2type[ "[object " + name + "]" ] = name.toLowerCase();
  });

  function isArraylike( obj ) {

    // Support: iOS 8.2 (not reproducible in simulator)
    // `in` check used to prevent JIT error (gh-2145)
    // hasOwn isn't used here due to false negatives
    // regarding Nodelist length in IE
    var length = "length" in obj && obj.length,
      type = jQuery.type( obj );

    if ( type === "function" || jQuery.isWindow( obj ) ) {
      return false;
    }

    if ( obj.nodeType === 1 && length ) {
      return true;
    }

    return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
  }
  var Sizzle =
/* !
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function ( window ) {

  var i,
    support,
    Expr,
    getText,
    isXML,
    tokenize,
    compile,
    select,
    outermostContext,
    sortInput,
    hasDuplicate,

    // Local document vars
    setDocument,
    document,
    docElem,
    documentIsHTML,
    rbuggyQSA,
    rbuggyMatches,
    matches,
    contains,

    // Instance-specific data
    expando = "sizzle" + 1 * new Date(),
    preferredDoc = window.document,
    dirruns = 0,
    done = 0,
    classCache = createCache(),
    tokenCache = createCache(),
    compilerCache = createCache(),
    sortOrder = function ( a, b ) {
      if ( a === b ) {
        hasDuplicate = true;
      }
      return 0;
    },

    // General-purpose constants
    MAX_NEGATIVE = 1 << 31,

    // Instance methods
    hasOwn = ({}).hasOwnProperty,
    arr = [],
    pop = arr.pop,
    push_native = arr.push,
    push = arr.push,
    slice = arr.slice,
    // Use a stripped-down indexOf as it's faster than native
    // http://jsperf.com/thor-indexof-vs-for/5
    indexOf = function ( list, elem ) {
      var i = 0,
        len = list.length;
      for ( ; i < len; i++ ) {
        if ( list[i] === elem ) {
          return i;
        }
      }
      return -1;
    },

    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

    // Regular expressions

    // Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
    whitespace = "[\\x20\\t\\r\\n\\f]",
    // http://www.w3.org/TR/css3-syntax/#characters
    characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

    // Loosely modeled on CSS identifier characters
    // An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
    // Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
    identifier = characterEncoding.replace( "w", "w#" ),

    // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
    attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

    pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

    // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp( whitespace + "+", "g" ),
    rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

    rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
    rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

    rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

    rpseudo = new RegExp( pseudos ),
    ridentifier = new RegExp( "^" + identifier + "$" ),

    matchExpr = {
      "ID": new RegExp( "^#(" + characterEncoding + ")" ),
      "CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
      "TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
      "ATTR": new RegExp( "^" + attributes ),
      "PSEUDO": new RegExp( "^" + pseudos ),
      "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
      "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
      // For use in libraries implementing .is()
      // We use this for POS matching in `select`
      "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
    },

    rinputs = /^(?:input|select|textarea|button)$/i,
    rheader = /^h\d$/i,

    rnative = /^[^{]+\{\s*\[native \w/,

    // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

    rsibling = /[+~]/,
    rescape = /'|\\/g,

    // CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
    funescape = function ( _, escaped, escapedWhitespace ) {
      var high = "0x" + escaped - 0x10000;
      // NaN means non-codepoint
      // Support: Firefox<24
      // Workaround erroneous numeric interpretation of +"0x"
      return high !== high || escapedWhitespace ?
        escaped :
        high < 0 ?
        // BMP codepoint
          String.fromCharCode( high + 0x10000 ) :
        // Supplemental Plane codepoint (surrogate pair)
          String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
    },

    // Used for iframes
    // See setDocument()
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE
    unloadHandler = function () {
      setDocument();
    };

  // Optimize for push.apply( _, NodeList )
  try {
    push.apply(
      (arr = slice.call( preferredDoc.childNodes )),
      preferredDoc.childNodes
    );
    // Support: Android<4.0
    // Detect silently failing push.apply
    arr[ preferredDoc.childNodes.length ].nodeType;
  } catch ( e ) {
    push = { apply: arr.length ?

    // Leverage slice if possible
      function ( target, els ) {
        push_native.apply( target, slice.call(els) );
      } :

    // Support: IE<9
    // Otherwise append directly
      function ( target, els ) {
        var j = target.length,
          i = 0;
        // Can't trust NodeList.length
        while ( (target[j++] = els[i++]) ) {}
        target.length = j - 1;
      }
    };
  }

  function Sizzle( selector, context, results, seed ) {
    var match, elem, m, nodeType,
      // QSA vars
      i, groups, old, nid, newContext, newSelector;

    if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
      setDocument( context );
    }

    context = context || document;
    results = results || [];
    nodeType = context.nodeType;

    if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

      return results;
    }

    if ( !seed && documentIsHTML ) {

      // Try to shortcut find operations when possible (e.g., not under DocumentFragment)
      if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
        // Speed-up: Sizzle("#ID")
        if ( (m = match[1]) ) {
          if ( nodeType === 9 ) {
            elem = context.getElementById( m );
            // Check parentNode to catch when Blackberry 4.6 returns
            // nodes that are no longer in the document (jQuery #6963)
            if ( elem && elem.parentNode ) {
              // Handle the case where IE, Opera, and Webkit return items
              // by name instead of ID
              if ( elem.id === m ) {
                results.push( elem );
                return results;
              }
            } else {
              return results;
            }
          } else {
            // Context is not a document
            if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
              results.push( elem );
              return results;
            }
          }

          // Speed-up: Sizzle("TAG")
        } else if ( match[2] ) {
          push.apply( results, context.getElementsByTagName( selector ) );
          return results;

          // Speed-up: Sizzle(".CLASS")
        } else if ( (m = match[3]) && support.getElementsByClassName ) {
          push.apply( results, context.getElementsByClassName( m ) );
          return results;
        }
      }

      // QSA path
      if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
        nid = old = expando;
        newContext = context;
        newSelector = nodeType !== 1 && selector;

        // qSA works strangely on Element-rooted queries
        // We can work around this by specifying an extra ID on the root
        // and working up from there (Thanks to Andrew Dupont for the technique)
        // IE 8 doesn't work on object elements
        if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
          groups = tokenize( selector );

          if ( (old = context.getAttribute("id")) ) {
            nid = old.replace( rescape, "\\$&" );
          } else {
            context.setAttribute( "id", nid );
          }
          nid = "[id='" + nid + "'] ";

          i = groups.length;
          while ( i-- ) {
            groups[i] = nid + toSelector( groups[i] );
          }
          newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
          newSelector = groups.join(",");
        }

        if ( newSelector ) {
          try {
            push.apply( results,
              newContext.querySelectorAll( newSelector )
            );
            return results;
          } catch (qsaError) {
          } finally {
            if ( !old ) {
              context.removeAttribute("id");
            }
          }
        }
      }
    }

    // All others
    return select( selector.replace( rtrim, "$1" ), context, results, seed );
  }

  /**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
  function createCache() {
    var keys = [];

    function cache( key, value ) {
      // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
      if ( keys.push( key + " " ) > Expr.cacheLength ) {
        // Only keep the most recent entries
        delete cache[ keys.shift() ];
      }
      return (cache[ key + " " ] = value);
    }
    return cache;
  }

  /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
  function markFunction( fn ) {
    fn[ expando ] = true;
    return fn;
  }

  /**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
  function assert( fn ) {
    var div = document.createElement("div");

    try {
      return !!fn( div );
    } catch (e) {
      return false;
    } finally {
      // Remove from its parent by default
      if ( div.parentNode ) {
        div.parentNode.removeChild( div );
      }
      // release memory in IE
      div = null;
    }
  }

  /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
  function addHandle( attrs, handler ) {
    var arr = attrs.split("|"),
      i = attrs.length;

    while ( i-- ) {
      Expr.attrHandle[ arr[i] ] = handler;
    }
  }

  /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
  function siblingCheck( a, b ) {
    var cur = b && a,
      diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

    // Use IE sourceIndex if available on both nodes
    if ( diff ) {
      return diff;
    }

    // Check if b follows a
    if ( cur ) {
      while ( (cur = cur.nextSibling) ) {
        if ( cur === b ) {
          return -1;
        }
      }
    }

    return a ? 1 : -1;
  }

  /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
  function createInputPseudo( type ) {
    return function ( elem ) {
      var name = elem.nodeName.toLowerCase();
      return name === "input" && elem.type === type;
    };
  }

  /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
  function createButtonPseudo( type ) {
    return function ( elem ) {
      var name = elem.nodeName.toLowerCase();
      return (name === "input" || name === "button") && elem.type === type;
    };
  }

  /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
  function createPositionalPseudo( fn ) {
    return markFunction(function ( argument ) {
      argument = +argument;
      return markFunction(function ( seed, matches ) {
        var j,
          matchIndexes = fn( [], seed.length, argument ),
          i = matchIndexes.length;

        // Match elements found at the specified indexes
        while ( i-- ) {
          if ( seed[ (j = matchIndexes[i]) ] ) {
            seed[j] = !(matches[j] = seed[j]);
          }
        }
      });
    });
  }

  /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
  function testContext( context ) {
    return context && typeof context.getElementsByTagName !== "undefined" && context;
  }

  // Expose support vars for convenience
  support = Sizzle.support = {};

  /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
  isXML = Sizzle.isXML = function ( elem ) {
    // documentElement is verified for cases where it doesn't yet exist
    // (such as loading iframes in IE - #4833)
    var documentElement = elem && (elem.ownerDocument || elem).documentElement;
    return documentElement ? documentElement.nodeName !== "HTML" : false;
  };

  /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
  setDocument = Sizzle.setDocument = function ( node ) {
    var hasCompare, parent,
      doc = node ? node.ownerDocument || node : preferredDoc;

    // If no document and documentElement is available, return
    if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
      return document;
    }

    // Set our document
    document = doc;
    docElem = doc.documentElement;
    parent = doc.defaultView;

    // Support: IE>8
    // If iframe document is assigned to "document" variable and if iframe has been reloaded,
    // IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
    // IE6-8 do not support the defaultView property so parent will be undefined
    if ( parent && parent !== parent.top ) {
      // IE11 does not have attachEvent, so all must suffer
      if ( parent.addEventListener ) {
        parent.addEventListener( "unload", unloadHandler, false );
      } else if ( parent.attachEvent ) {
        parent.attachEvent( "onunload", unloadHandler );
      }
    }

    /* Support tests
	---------------------------------------------------------------------- */
    documentIsHTML = !isXML( doc );

    /* Attributes
	---------------------------------------------------------------------- */

    // Support: IE<8
    // Verify that getAttribute really returns attributes and not properties
    // (excepting IE8 booleans)
    support.attributes = assert(function ( div ) {
      div.className = "i";
      return !div.getAttribute("className");
    });

    /* getElement(s)By*
	---------------------------------------------------------------------- */

    // Check if getElementsByTagName("*") returns only elements
    support.getElementsByTagName = assert(function ( div ) {
      div.appendChild( doc.createComment("") );
      return !div.getElementsByTagName("*").length;
    });

    // Support: IE<9
    support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

    // Support: IE<10
    // Check if getElementById returns elements by name
    // The broken getElementById methods don't pick up programatically-set names,
    // so use a roundabout getElementsByName test
    support.getById = assert(function ( div ) {
      docElem.appendChild( div ).id = expando;
      return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
    });

    // ID find and filter
    if ( support.getById ) {
      Expr.find["ID"] = function ( id, context ) {
        if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
          var m = context.getElementById( id );
          // Check parentNode to catch when Blackberry 4.6 returns
          // nodes that are no longer in the document #6963
          return m && m.parentNode ? [ m ] : [];
        }
      };
      Expr.filter["ID"] = function ( id ) {
        var attrId = id.replace( runescape, funescape );
        return function ( elem ) {
          return elem.getAttribute("id") === attrId;
        };
      };
    } else {
      // Support: IE6/7
      // getElementById is not reliable as a find shortcut
      delete Expr.find["ID"];

      Expr.filter["ID"] = function ( id ) {
        var attrId = id.replace( runescape, funescape );
        return function ( elem ) {
          var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
          return node && node.value === attrId;
        };
      };
    }

    // Tag
    Expr.find["TAG"] = support.getElementsByTagName ?
      function ( tag, context ) {
        if ( typeof context.getElementsByTagName !== "undefined" ) {
          return context.getElementsByTagName( tag );

          // DocumentFragment nodes don't have gEBTN
        } else if ( support.qsa ) {
          return context.querySelectorAll( tag );
        }
      } :

      function ( tag, context ) {
        var elem,
          tmp = [],
          i = 0,
          // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
          results = context.getElementsByTagName( tag );

        // Filter out possible comments
        if ( tag === "*" ) {
          while ( (elem = results[i++]) ) {
            if ( elem.nodeType === 1 ) {
              tmp.push( elem );
            }
          }

          return tmp;
        }
        return results;
      };

    // Class
    Expr.find["CLASS"] = support.getElementsByClassName && function ( className, context ) {
      if ( documentIsHTML ) {
        return context.getElementsByClassName( className );
      }
    };

    /* QSA/matchesSelector
	---------------------------------------------------------------------- */

    // QSA and matchesSelector support

    // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
    rbuggyMatches = [];

    // qSa(:focus) reports false when true (Chrome 21)
    // We allow this because of a bug in IE8/9 that throws an error
    // whenever `document.activeElement` is accessed on an iframe
    // So, we allow :focus to pass through QSA all the time to avoid the IE error
    // See http://bugs.jquery.com/ticket/13378
    rbuggyQSA = [];

    if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
      // Build QSA regex
      // Regex strategy adopted from Diego Perini
      assert(function ( div ) {
        // Select is set to empty string on purpose
        // This is to test IE's treatment of not explicitly
        // setting a boolean content attribute,
        // since its presence should be enough
        // http://bugs.jquery.com/ticket/12359
        docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

        // Support: IE8, Opera 11-12.16
        // Nothing should be selected when empty strings follow ^= or $= or *=
        // The test attribute must be unknown in Opera but "safe" for WinRT
        // http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
        if ( div.querySelectorAll("[msallowcapture^='']").length ) {
          rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
        }

        // Support: IE8
        // Boolean attributes and "value" are not treated correctly
        if ( !div.querySelectorAll("[selected]").length ) {
          rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
        }

        // Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
        if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
          rbuggyQSA.push("~=");
        }

        // Webkit/Opera - :checked should return selected option elements
        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
        // IE8 throws error here and will not see later tests
        if ( !div.querySelectorAll(":checked").length ) {
          rbuggyQSA.push(":checked");
        }

        // Support: Safari 8+, iOS 8+
        // https://bugs.webkit.org/show_bug.cgi?id=136851
        // In-page `selector#id sibing-combinator selector` fails
        if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
          rbuggyQSA.push(".#.+[+~]");
        }
      });

      assert(function ( div ) {
        // Support: Windows 8 Native Apps
        // The type and name attributes are restricted during .innerHTML assignment
        var input = doc.createElement("input");
        input.setAttribute( "type", "hidden" );
        div.appendChild( input ).setAttribute( "name", "D" );

        // Support: IE8
        // Enforce case-sensitivity of name attribute
        if ( div.querySelectorAll("[name=d]").length ) {
          rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
        }

        // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
        // IE8 throws error here and will not see later tests
        if ( !div.querySelectorAll(":enabled").length ) {
          rbuggyQSA.push( ":enabled", ":disabled" );
        }

        // Opera 10-11 does not throw on post-comma invalid pseudos
        div.querySelectorAll("*,:x");
        rbuggyQSA.push(",.*:");
      });
    }

    if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

      assert(function ( div ) {
        // Check to see if it's possible to do matchesSelector
        // on a disconnected node (IE 9)
        support.disconnectedMatch = matches.call( div, "div" );

        // This should fail with an exception
        // Gecko does not error, returns false instead
        matches.call( div, "[s!='']:x" );
        rbuggyMatches.push( "!=", pseudos );
      });
    }

    rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
    rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

    /* Contains
	---------------------------------------------------------------------- */
    hasCompare = rnative.test( docElem.compareDocumentPosition );

    // Element contains another
    // Purposefully does not implement inclusive descendent
    // As in, an element does not contain itself
    contains = hasCompare || rnative.test( docElem.contains ) ?
      function ( a, b ) {
        var adown = a.nodeType === 9 ? a.documentElement : a,
          bup = b && b.parentNode;
        return a === bup || !!( bup && bup.nodeType === 1 && (
          adown.contains ?
            adown.contains( bup ) :
            a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
        ));
      } :
      function ( a, b ) {
        if ( b ) {
          while ( (b = b.parentNode) ) {
            if ( b === a ) {
              return true;
            }
          }
        }
        return false;
      };

    /* Sorting
	---------------------------------------------------------------------- */

    // Document order sorting
    sortOrder = hasCompare ?
      function ( a, b ) {

        // Flag for duplicate removal
        if ( a === b ) {
          hasDuplicate = true;
          return 0;
        }

        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if ( compare ) {
          return compare;
        }

        // Calculate position if both inputs belong to the same document
        compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
          a.compareDocumentPosition( b ) :

        // Otherwise we know they are disconnected
          1;

        // Disconnected nodes
        if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

          // Choose the first element that is related to our preferred document
          if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
            return -1;
          }
          if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
            return 1;
          }

          // Maintain original order
          return sortInput ?
            ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
            0;
        }

        return compare & 4 ? -1 : 1;
      } :
      function ( a, b ) {
        // Exit early if the nodes are identical
        if ( a === b ) {
          hasDuplicate = true;
          return 0;
        }

        var cur,
          i = 0,
          aup = a.parentNode,
          bup = b.parentNode,
          ap = [ a ],
          bp = [ b ];

        // Parentless nodes are either documents or disconnected
        if ( !aup || !bup ) {
          return a === doc ? -1 :
            b === doc ? 1 :
              aup ? -1 :
                bup ? 1 :
                  sortInput ?
                    ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                    0;

          // If the nodes are siblings, we can do a quick check
        } else if ( aup === bup ) {
          return siblingCheck( a, b );
        }

        // Otherwise we need full lists of their ancestors for comparison
        cur = a;
        while ( (cur = cur.parentNode) ) {
          ap.unshift( cur );
        }
        cur = b;
        while ( (cur = cur.parentNode) ) {
          bp.unshift( cur );
        }

        // Walk down the tree looking for a discrepancy
        while ( ap[i] === bp[i] ) {
          i++;
        }

        return i ?
        // Do a sibling check if the nodes have a common ancestor
          siblingCheck( ap[i], bp[i] ) :

        // Otherwise nodes in our document sort first
          ap[i] === preferredDoc ? -1 :
            bp[i] === preferredDoc ? 1 :
              0;
      };

    return doc;
  };

  Sizzle.matches = function ( expr, elements ) {
    return Sizzle( expr, null, null, elements );
  };

  Sizzle.matchesSelector = function ( elem, expr ) {
    // Set document vars if needed
    if ( ( elem.ownerDocument || elem ) !== document ) {
      setDocument( elem );
    }

    // Make sure that attribute selectors are quoted
    expr = expr.replace( rattributeQuotes, "='$1']" );

    if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

      try {
        var ret = matches.call( elem, expr );

        // IE 9's matchesSelector returns false on disconnected nodes
        if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
          return ret;
        }
      } catch (e) {}
    }

    return Sizzle( expr, document, null, [ elem ] ).length > 0;
  };

  Sizzle.contains = function ( context, elem ) {
    // Set document vars if needed
    if ( ( context.ownerDocument || context ) !== document ) {
      setDocument( context );
    }
    return contains( context, elem );
  };

  Sizzle.attr = function ( elem, name ) {
    // Set document vars if needed
    if ( ( elem.ownerDocument || elem ) !== document ) {
      setDocument( elem );
    }

    var fn = Expr.attrHandle[ name.toLowerCase() ],
      // Don't get fooled by Object.prototype properties (jQuery #13807)
      val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
        fn( elem, name, !documentIsHTML ) :
        undefined;

    return val !== undefined ?
      val :
      support.attributes || !documentIsHTML ?
        elem.getAttribute( name ) :
        (val = elem.getAttributeNode(name)) && val.specified ?
          val.value :
          null;
  };

  Sizzle.error = function ( msg ) {
    throw new Error( "Syntax error, unrecognized expression: " + msg );
  };

  /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
  Sizzle.uniqueSort = function ( results ) {
    var elem,
      duplicates = [],
      j = 0,
      i = 0;

    // Unless we *know* we can detect duplicates, assume their presence
    hasDuplicate = !support.detectDuplicates;
    sortInput = !support.sortStable && results.slice( 0 );
    results.sort( sortOrder );

    if ( hasDuplicate ) {
      while ( (elem = results[i++]) ) {
        if ( elem === results[ i ] ) {
          j = duplicates.push( i );
        }
      }
      while ( j-- ) {
        results.splice( duplicates[ j ], 1 );
      }
    }

    // Clear input after sorting to release objects
    // See https://github.com/jquery/sizzle/pull/225
    sortInput = null;

    return results;
  };

  /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
  getText = Sizzle.getText = function ( elem ) {
    var node,
      ret = "",
      i = 0,
      nodeType = elem.nodeType;

    if ( !nodeType ) {
      // If no nodeType, this is expected to be an array
      while ( (node = elem[i++]) ) {
        // Do not traverse comment nodes
        ret += getText( node );
      }
    } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
      // Use textContent for elements
      // innerText usage removed for consistency of new lines (jQuery #11153)
      if ( typeof elem.textContent === "string" ) {
        return elem.textContent;
      } else {
        // Traverse its children
        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
          ret += getText( elem );
        }
      }
    } else if ( nodeType === 3 || nodeType === 4 ) {
      return elem.nodeValue;
    }
    // Do not include comment or processing instruction nodes

    return ret;
  };

  Expr = Sizzle.selectors = {

    // Can be adjusted by the user
    cacheLength: 50,

    createPseudo: markFunction,

    match: matchExpr,

    attrHandle: {},

    find: {},

    relative: {
      ">": { dir: "parentNode", first: true },
      " ": { dir: "parentNode" },
      "+": { dir: "previousSibling", first: true },
      "~": { dir: "previousSibling" }
    },

    preFilter: {
      "ATTR": function ( match ) {
        match[1] = match[1].replace( runescape, funescape );

        // Move the given value to match[3] whether quoted or unquoted
        match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

        if ( match[2] === "~=" ) {
          match[3] = " " + match[3] + " ";
        }

        return match.slice( 0, 4 );
      },

      "CHILD": function ( match ) {
        /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
        match[1] = match[1].toLowerCase();

        if ( match[1].slice( 0, 3 ) === "nth" ) {
          // nth-* requires argument
          if ( !match[3] ) {
            Sizzle.error( match[0] );
          }

          // numeric x and y parameters for Expr.filter.CHILD
          // remember that false/true cast respectively to 0/1
          match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
          match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

          // other types prohibit arguments
        } else if ( match[3] ) {
          Sizzle.error( match[0] );
        }

        return match;
      },

      "PSEUDO": function ( match ) {
        var excess,
          unquoted = !match[6] && match[2];

        if ( matchExpr["CHILD"].test( match[0] ) ) {
          return null;
        }

        // Accept quoted arguments as-is
        if ( match[3] ) {
          match[2] = match[4] || match[5] || "";

          // Strip excess characters from unquoted arguments
        } else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

          // excess is a negative index
          match[0] = match[0].slice( 0, excess );
          match[2] = unquoted.slice( 0, excess );
        }

        // Return only captures needed by the pseudo filter method (type and argument)
        return match.slice( 0, 3 );
      }
    },

    filter: {

      "TAG": function ( nodeNameSelector ) {
        var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
        return nodeNameSelector === "*" ?
          function () { return true; } :
          function ( elem ) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
      },

      "CLASS": function ( className ) {
        var pattern = classCache[ className + " " ];

        return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function ( elem ) {
				  return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
      },

      "ATTR": function ( name, operator, check ) {
        return function ( elem ) {
          var result = Sizzle.attr( elem, name );

          if ( result == null ) {
            return operator === "!=";
          }
          if ( !operator ) {
            return true;
          }

          result += "";

          return operator === "=" ? result === check :
            operator === "!=" ? result !== check :
              operator === "^=" ? check && result.indexOf( check ) === 0 :
                operator === "*=" ? check && result.indexOf( check ) > -1 :
                  operator === "$=" ? check && result.slice( -check.length ) === check :
                    operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                      operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                        false;
        };
      },

      "CHILD": function ( type, what, argument, first, last ) {
        var simple = type.slice( 0, 3 ) !== "nth",
          forward = type.slice( -4 ) !== "last",
          ofType = what === "of-type";

        return first === 1 && last === 0 ?

        // Shortcut for :nth-*(n)
          function ( elem ) {
            return !!elem.parentNode;
          } :

          function ( elem, context, xml ) {
            var cache, outerCache, node, diff, nodeIndex, start,
              dir = simple !== forward ? "nextSibling" : "previousSibling",
              parent = elem.parentNode,
              name = ofType && elem.nodeName.toLowerCase(),
              useCache = !xml && !ofType;

            if ( parent ) {

              // :(first|last|only)-(child|of-type)
              if ( simple ) {
                while ( dir ) {
                  node = elem;
                  while ( (node = node[ dir ]) ) {
                    if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
                      return false;
                    }
                  }
                  // Reverse direction for :only-* (if we haven't yet done so)
                  start = dir = type === "only" && !start && "nextSibling";
                }
                return true;
              }

              start = [ forward ? parent.firstChild : parent.lastChild ];

              // non-xml :nth-child(...) stores cache data on `parent`
              if ( forward && useCache ) {
                // Seek `elem` from a previously-cached index
                outerCache = parent[ expando ] || (parent[ expando ] = {});
                cache = outerCache[ type ] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = cache[0] === dirruns && cache[2];
                node = nodeIndex && parent.childNodes[ nodeIndex ];

                while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

                  // When found, cache indexes on `parent` and break
                  if ( node.nodeType === 1 && ++diff && node === elem ) {
                    outerCache[ type ] = [ dirruns, nodeIndex, diff ];
                    break;
                  }
                }

                // Use previously-cached element index if available
              } else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
                diff = cache[1];

                // xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
              } else {
                // Use the same loop as above to seek `elem` from the start
                while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

                  if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
                    // Cache the index of each encountered element
                    if ( useCache ) {
                      (node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
                    }

                    if ( node === elem ) {
                      break;
                    }
                  }
                }
              }

              // Incorporate the offset, then check against cycle size
              diff -= last;
              return diff === first || ( diff % first === 0 && diff / first >= 0 );
            }
          };
      },

      "PSEUDO": function ( pseudo, argument ) {
        // pseudo-class names are case-insensitive
        // http://www.w3.org/TR/selectors/#pseudo-classes
        // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
        // Remember that setFilters inherits from pseudos
        var args,
          fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

        // The user may use createPseudo to indicate that
        // arguments are needed to create the filter function
        // just as Sizzle does
        if ( fn[ expando ] ) {
          return fn( argument );
        }

        // But maintain support for old signatures
        if ( fn.length > 1 ) {
          args = [ pseudo, pseudo, "", argument ];
          return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
            markFunction(function ( seed, matches ) {
              var idx,
                matched = fn( seed, argument ),
                i = matched.length;
              while ( i-- ) {
                idx = indexOf( seed, matched[i] );
                seed[ idx ] = !( matches[ idx ] = matched[i] );
              }
            }) :
            function ( elem ) {
              return fn( elem, 0, args );
            };
        }

        return fn;
      }
    },

    pseudos: {
      // Potentially complex pseudos
      "not": markFunction(function ( selector ) {
        // Trim the selector passed to compile
        // to avoid treating leading and trailing
        // spaces as combinators
        var input = [],
          results = [],
          matcher = compile( selector.replace( rtrim, "$1" ) );

        return matcher[ expando ] ?
          markFunction(function ( seed, matches, context, xml ) {
            var elem,
              unmatched = matcher( seed, null, xml, [] ),
              i = seed.length;

            // Match elements unmatched by `matcher`
            while ( i-- ) {
              if ( (elem = unmatched[i]) ) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) :
          function ( elem, context, xml ) {
            input[0] = elem;
            matcher( input, null, xml, results );
            // Don't keep the element (issue #299)
            input[0] = null;
            return !results.pop();
          };
      }),

      "has": markFunction(function ( selector ) {
        return function ( elem ) {
          return Sizzle( selector, elem ).length > 0;
        };
      }),

      "contains": markFunction(function ( text ) {
        text = text.replace( runescape, funescape );
        return function ( elem ) {
          return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
        };
      }),

      // "Whether an element is represented by a :lang() selector
      // is based solely on the element's language value
      // being equal to the identifier C,
      // or beginning with the identifier C immediately followed by "-".
      // The matching of C against the element's language value is performed case-insensitively.
      // The identifier C does not have to be a valid language name."
      // http://www.w3.org/TR/selectors/#lang-pseudo
      "lang": markFunction( function ( lang ) {
        // lang value must be a valid identifier
        if ( !ridentifier.test(lang || "") ) {
          Sizzle.error( "unsupported lang: " + lang );
        }
        lang = lang.replace( runescape, funescape ).toLowerCase();
        return function ( elem ) {
          var elemLang;
          do {
            if ( (elemLang = documentIsHTML ?
              elem.lang :
              elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

              elemLang = elemLang.toLowerCase();
              return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
            }
          } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
          return false;
        };
      }),

      // Miscellaneous
      "target": function ( elem ) {
        var hash = window.location && window.location.hash;
        return hash && hash.slice( 1 ) === elem.id;
      },

      "root": function ( elem ) {
        return elem === docElem;
      },

      "focus": function ( elem ) {
        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
      },

      // Boolean properties
      "enabled": function ( elem ) {
        return elem.disabled === false;
      },

      "disabled": function ( elem ) {
        return elem.disabled === true;
      },

      "checked": function ( elem ) {
        // In CSS3, :checked should return both checked and selected elements
        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
        var nodeName = elem.nodeName.toLowerCase();
        return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
      },

      "selected": function ( elem ) {
        // Accessing this property makes selected-by-default
        // options in Safari work properly
        if ( elem.parentNode ) {
          elem.parentNode.selectedIndex;
        }

        return elem.selected === true;
      },

      // Contents
      "empty": function ( elem ) {
        // http://www.w3.org/TR/selectors/#empty-pseudo
        // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
        //   but not by others (comment: 8; processing instruction: 7; etc.)
        // nodeType < 6 works because attributes (2) do not appear as children
        for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
          if ( elem.nodeType < 6 ) {
            return false;
          }
        }
        return true;
      },

      "parent": function ( elem ) {
        return !Expr.pseudos["empty"]( elem );
      },

      // Element/input types
      "header": function ( elem ) {
        return rheader.test( elem.nodeName );
      },

      "input": function ( elem ) {
        return rinputs.test( elem.nodeName );
      },

      "button": function ( elem ) {
        var name = elem.nodeName.toLowerCase();
        return name === "input" && elem.type === "button" || name === "button";
      },

      "text": function ( elem ) {
        var attr;
        return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
      },

      // Position-in-collection
      "first": createPositionalPseudo(function () {
        return [ 0 ];
      }),

      "last": createPositionalPseudo(function ( matchIndexes, length ) {
        return [ length - 1 ];
      }),

      "eq": createPositionalPseudo(function ( matchIndexes, length, argument ) {
        return [ argument < 0 ? argument + length : argument ];
      }),

      "even": createPositionalPseudo(function ( matchIndexes, length ) {
        var i = 0;
        for ( ; i < length; i += 2 ) {
          matchIndexes.push( i );
        }
        return matchIndexes;
      }),

      "odd": createPositionalPseudo(function ( matchIndexes, length ) {
        var i = 1;
        for ( ; i < length; i += 2 ) {
          matchIndexes.push( i );
        }
        return matchIndexes;
      }),

      "lt": createPositionalPseudo(function ( matchIndexes, length, argument ) {
        var i = argument < 0 ? argument + length : argument;
        for ( ; --i >= 0; ) {
          matchIndexes.push( i );
        }
        return matchIndexes;
      }),

      "gt": createPositionalPseudo(function ( matchIndexes, length, argument ) {
        var i = argument < 0 ? argument + length : argument;
        for ( ; ++i < length; ) {
          matchIndexes.push( i );
        }
        return matchIndexes;
      })
    }
  };

  Expr.pseudos["nth"] = Expr.pseudos["eq"];

  // Add button/input type pseudos
  for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
    Expr.pseudos[ i ] = createInputPseudo( i );
  }
  for ( i in { submit: true, reset: true } ) {
    Expr.pseudos[ i ] = createButtonPseudo( i );
  }

  // Easy API for creating new setFilters
  function setFilters() {}
  setFilters.prototype = Expr.filters = Expr.pseudos;
  Expr.setFilters = new setFilters();

  tokenize = Sizzle.tokenize = function ( selector, parseOnly ) {
    var matched, match, tokens, type,
      soFar, groups, preFilters,
      cached = tokenCache[ selector + " " ];

    if ( cached ) {
      return parseOnly ? 0 : cached.slice( 0 );
    }

    soFar = selector;
    groups = [];
    preFilters = Expr.preFilter;

    while ( soFar ) {

      // Comma and first run
      if ( !matched || (match = rcomma.exec( soFar )) ) {
        if ( match ) {
          // Don't consume trailing commas as valid
          soFar = soFar.slice( match[0].length ) || soFar;
        }
        groups.push( (tokens = []) );
      }

      matched = false;

      // Combinators
      if ( (match = rcombinators.exec( soFar )) ) {
        matched = match.shift();
        tokens.push({
          value: matched,
          // Cast descendant combinators to space
          type: match[0].replace( rtrim, " " )
        });
        soFar = soFar.slice( matched.length );
      }

      // Filters
      for ( type in Expr.filter ) {
        if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
          matched = match.shift();
          tokens.push({
            value: matched,
            type: type,
            matches: match
          });
          soFar = soFar.slice( matched.length );
        }
      }

      if ( !matched ) {
        break;
      }
    }

    // Return the length of the invalid excess
    // if we're just parsing
    // Otherwise, throw an error or return tokens
    return parseOnly ?
      soFar.length :
      soFar ?
        Sizzle.error( selector ) :
      // Cache the tokens
        tokenCache( selector, groups ).slice( 0 );
  };

  function toSelector( tokens ) {
    var i = 0,
      len = tokens.length,
      selector = "";
    for ( ; i < len; i++ ) {
      selector += tokens[i].value;
    }
    return selector;
  }

  function addCombinator( matcher, combinator, base ) {
    var dir = combinator.dir,
      checkNonElements = base && dir === "parentNode",
      doneName = done++;

    return combinator.first ?
    // Check against closest ancestor/preceding element
      function ( elem, context, xml ) {
        while ( (elem = elem[ dir ]) ) {
          if ( elem.nodeType === 1 || checkNonElements ) {
            return matcher( elem, context, xml );
          }
        }
      } :

    // Check against all ancestor/preceding elements
      function ( elem, context, xml ) {
        var oldCache, outerCache,
          newCache = [ dirruns, doneName ];

        // We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
        if ( xml ) {
          while ( (elem = elem[ dir ]) ) {
            if ( elem.nodeType === 1 || checkNonElements ) {
              if ( matcher( elem, context, xml ) ) {
                return true;
              }
            }
          }
        } else {
          while ( (elem = elem[ dir ]) ) {
            if ( elem.nodeType === 1 || checkNonElements ) {
              outerCache = elem[ expando ] || (elem[ expando ] = {});
              if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

                // Assign to newCache so results back-propagate to previous elements
                return (newCache[ 2 ] = oldCache[ 2 ]);
              } else {
                // Reuse newcache so results back-propagate to previous elements
                outerCache[ dir ] = newCache;

                // A match means we're done; a fail means we have to keep checking
                if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
                  return true;
                }
              }
            }
          }
        }
      };
  }

  function elementMatcher( matchers ) {
    return matchers.length > 1 ?
      function ( elem, context, xml ) {
        var i = matchers.length;
        while ( i-- ) {
          if ( !matchers[i]( elem, context, xml ) ) {
            return false;
          }
        }
        return true;
      } :
      matchers[0];
  }

  function multipleContexts( selector, contexts, results ) {
    var i = 0,
      len = contexts.length;
    for ( ; i < len; i++ ) {
      Sizzle( selector, contexts[i], results );
    }
    return results;
  }

  function condense( unmatched, map, filter, context, xml ) {
    var elem,
      newUnmatched = [],
      i = 0,
      len = unmatched.length,
      mapped = map != null;

    for ( ; i < len; i++ ) {
      if ( (elem = unmatched[i]) ) {
        if ( !filter || filter( elem, context, xml ) ) {
          newUnmatched.push( elem );
          if ( mapped ) {
            map.push( i );
          }
        }
      }
    }

    return newUnmatched;
  }

  function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
    if ( postFilter && !postFilter[ expando ] ) {
      postFilter = setMatcher( postFilter );
    }
    if ( postFinder && !postFinder[ expando ] ) {
      postFinder = setMatcher( postFinder, postSelector );
    }
    return markFunction(function ( seed, results, context, xml ) {
      var temp, i, elem,
        preMap = [],
        postMap = [],
        preexisting = results.length,

        // Get initial elements from seed or context
        elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

        // Prefilter to get matcher input, preserving a map for seed-results synchronization
        matcherIn = preFilter && ( seed || !selector ) ?
          condense( elems, preMap, preFilter, context, xml ) :
          elems,

        matcherOut = matcher ?
        // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
          postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

          // ...intermediate processing is necessary
            [] :

          // ...otherwise use results directly
            results :
          matcherIn;

      // Find primary matches
      if ( matcher ) {
        matcher( matcherIn, matcherOut, context, xml );
      }

      // Apply postFilter
      if ( postFilter ) {
        temp = condense( matcherOut, postMap );
        postFilter( temp, [], context, xml );

        // Un-match failing elements by moving them back to matcherIn
        i = temp.length;
        while ( i-- ) {
          if ( (elem = temp[i]) ) {
            matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
          }
        }
      }

      if ( seed ) {
        if ( postFinder || preFilter ) {
          if ( postFinder ) {
            // Get the final matcherOut by condensing this intermediate into postFinder contexts
            temp = [];
            i = matcherOut.length;
            while ( i-- ) {
              if ( (elem = matcherOut[i]) ) {
                // Restore matcherIn since elem is not yet a final match
                temp.push( (matcherIn[i] = elem) );
              }
            }
            postFinder( null, (matcherOut = []), temp, xml );
          }

          // Move matched elements from seed to results to keep them synchronized
          i = matcherOut.length;
          while ( i-- ) {
            if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

              seed[temp] = !(results[temp] = elem);
            }
          }
        }

        // Add elements to results, through postFinder if defined
      } else {
        matcherOut = condense(
          matcherOut === results ?
            matcherOut.splice( preexisting, matcherOut.length ) :
            matcherOut
        );
        if ( postFinder ) {
          postFinder( null, results, matcherOut, xml );
        } else {
          push.apply( results, matcherOut );
        }
      }
    });
  }

  function matcherFromTokens( tokens ) {
    var checkContext, matcher, j,
      len = tokens.length,
      leadingRelative = Expr.relative[ tokens[0].type ],
      implicitRelative = leadingRelative || Expr.relative[" "],
      i = leadingRelative ? 1 : 0,

      // The foundational matcher ensures that elements are reachable from top-level context(s)
      matchContext = addCombinator( function ( elem ) {
        return elem === checkContext;
      }, implicitRelative, true ),
      matchAnyContext = addCombinator( function ( elem ) {
        return indexOf( checkContext, elem ) > -1;
      }, implicitRelative, true ),
      matchers = [ function ( elem, context, xml ) {
        var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
          (checkContext = context).nodeType ?
            matchContext( elem, context, xml ) :
            matchAnyContext( elem, context, xml ) );
        // Avoid hanging onto element (issue #299)
        checkContext = null;
        return ret;
      } ];

    for ( ; i < len; i++ ) {
      if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
        matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
      } else {
        matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

        // Return special upon seeing a positional matcher
        if ( matcher[ expando ] ) {
          // Find the next relative operator (if any) for proper handling
          j = ++i;
          for ( ; j < len; j++ ) {
            if ( Expr.relative[ tokens[j].type ] ) {
              break;
            }
          }
          return setMatcher(
            i > 1 && elementMatcher( matchers ),
            i > 1 && toSelector(
              // If the preceding token was a descendant combinator, insert an implicit any-element `*`
              tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
            ).replace( rtrim, "$1" ),
            matcher,
            i < j && matcherFromTokens( tokens.slice( i, j ) ),
            j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
            j < len && toSelector( tokens )
          );
        }
        matchers.push( matcher );
      }
    }

    return elementMatcher( matchers );
  }

  function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
    var bySet = setMatchers.length > 0,
      byElement = elementMatchers.length > 0,
      superMatcher = function ( seed, context, xml, results, outermost ) {
        var elem, j, matcher,
          matchedCount = 0,
          i = "0",
          unmatched = seed && [],
          setMatched = [],
          contextBackup = outermostContext,
          // We must always have either seed elements or outermost context
          elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
          // Use integer dirruns iff this is the outermost matcher
          dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
          len = elems.length;

        if ( outermost ) {
          outermostContext = context !== document && context;
        }

        // Add elements passing elementMatchers directly to results
        // Keep `i` a string if there are no elements so `matchedCount` will be "00" below
        // Support: IE<9, Safari
        // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
        for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
          if ( byElement && elem ) {
            j = 0;
            while ( (matcher = elementMatchers[j++]) ) {
              if ( matcher( elem, context, xml ) ) {
                results.push( elem );
                break;
              }
            }
            if ( outermost ) {
              dirruns = dirrunsUnique;
            }
          }

          // Track unmatched elements for set filters
          if ( bySet ) {
            // They will have gone through all possible matchers
            if ( (elem = !matcher && elem) ) {
              matchedCount--;
            }

            // Lengthen the array for every element, matched or not
            if ( seed ) {
              unmatched.push( elem );
            }
          }
        }

        // Apply set filters to unmatched elements
        matchedCount += i;
        if ( bySet && i !== matchedCount ) {
          j = 0;
          while ( (matcher = setMatchers[j++]) ) {
            matcher( unmatched, setMatched, context, xml );
          }

          if ( seed ) {
            // Reintegrate element matches to eliminate the need for sorting
            if ( matchedCount > 0 ) {
              while ( i-- ) {
                if ( !(unmatched[i] || setMatched[i]) ) {
                  setMatched[i] = pop.call( results );
                }
              }
            }

            // Discard index placeholder values to get only actual matches
            setMatched = condense( setMatched );
          }

          // Add matches to results
          push.apply( results, setMatched );

          // Seedless set matches succeeding multiple successful matchers stipulate sorting
          if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

            Sizzle.uniqueSort( results );
          }
        }

        // Override manipulation of globals by nested matchers
        if ( outermost ) {
          dirruns = dirrunsUnique;
          outermostContext = contextBackup;
        }

        return unmatched;
      };

    return bySet ?
      markFunction( superMatcher ) :
      superMatcher;
  }

  compile = Sizzle.compile = function ( selector, match /* Internal Use Only */ ) {
    var i,
      setMatchers = [],
      elementMatchers = [],
      cached = compilerCache[ selector + " " ];

    if ( !cached ) {
      // Generate a function of recursive functions that can be used to check each element
      if ( !match ) {
        match = tokenize( selector );
      }
      i = match.length;
      while ( i-- ) {
        cached = matcherFromTokens( match[i] );
        if ( cached[ expando ] ) {
          setMatchers.push( cached );
        } else {
          elementMatchers.push( cached );
        }
      }

      // Cache the compiled function
      cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

      // Save selector and tokenization
      cached.selector = selector;
    }
    return cached;
  };

  /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
  select = Sizzle.select = function ( selector, context, results, seed ) {
    var i, tokens, token, type, find,
      compiled = typeof selector === "function" && selector,
      match = !seed && tokenize( (selector = compiled.selector || selector) );

    results = results || [];

    // Try to minimize operations if there is no seed and only one group
    if ( match.length === 1 ) {

      // Take a shortcut and set the context if the root selector is an ID
      tokens = match[0] = match[0].slice( 0 );
      if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

        context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
        if ( !context ) {
          return results;

          // Precompiled matchers will still verify ancestry, so step up a level
        } else if ( compiled ) {
          context = context.parentNode;
        }

        selector = selector.slice( tokens.shift().value.length );
      }

      // Fetch a seed set for right-to-left matching
      i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
      while ( i-- ) {
        token = tokens[i];

        // Abort if we hit a combinator
        if ( Expr.relative[ (type = token.type) ] ) {
          break;
        }
        if ( (find = Expr.find[ type ]) ) {
          // Search, expanding context for leading sibling combinators
          if ( (seed = find(
            token.matches[0].replace( runescape, funescape ),
            rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
          )) ) {

            // If seed is empty or no tokens remain, we can return early
            tokens.splice( i, 1 );
            selector = seed.length && toSelector( tokens );
            if ( !selector ) {
              push.apply( results, seed );
              return results;
            }

            break;
          }
        }
      }
    }

    // Compile and execute a filtering function if one is not provided
    // Provide `match` to avoid retokenization if we modified the selector above
    ( compiled || compile( selector, match ) )(
      seed,
      context,
      !documentIsHTML,
      results,
      rsibling.test( selector ) && testContext( context.parentNode ) || context
    );
    return results;
  };

  // One-time assignments

  // Sort stability
  support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

  // Support: Chrome 14-35+
  // Always assume duplicates if they aren't passed to the comparison function
  support.detectDuplicates = !!hasDuplicate;

  // Initialize against the default document
  setDocument();

  // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
  // Detached nodes confoundingly follow *each other*
  support.sortDetached = assert(function ( div1 ) {
    // Should return 1, but returns 4 (following)
    return div1.compareDocumentPosition( document.createElement("div") ) & 1;
  });

  // Support: IE<8
  // Prevent attribute/property "interpolation"
  // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
  if ( !assert(function ( div ) {
    div.innerHTML = "<a href='#'></a>";
    return div.firstChild.getAttribute("href") === "#" ;
  }) ) {
    addHandle( "type|href|height|width", function ( elem, name, isXML ) {
      if ( !isXML ) {
        return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
      }
    });
  }

  // Support: IE<9
  // Use defaultValue in place of getAttribute("value")
  if ( !support.attributes || !assert(function ( div ) {
    div.innerHTML = "<input/>";
    div.firstChild.setAttribute( "value", "" );
    return div.firstChild.getAttribute( "value" ) === "";
  }) ) {
    addHandle( "value", function ( elem, name, isXML ) {
      if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
        return elem.defaultValue;
      }
    });
  }

  // Support: IE<9
  // Use getAttributeNode to fetch booleans when getAttribute lies
  if ( !assert(function ( div ) {
    return div.getAttribute("disabled") == null;
  }) ) {
    addHandle( booleans, function ( elem, name, isXML ) {
      var val;
      if ( !isXML ) {
        return elem[ name ] === true ? name.toLowerCase() :
          (val = elem.getAttributeNode( name )) && val.specified ?
            val.value :
            null;
      }
    });
  }

  return Sizzle;

})( window );

  jQuery.find = Sizzle;
  jQuery.expr = Sizzle.selectors;
  jQuery.expr[":"] = jQuery.expr.pseudos;
  jQuery.unique = Sizzle.uniqueSort;
  jQuery.text = Sizzle.getText;
  jQuery.isXMLDoc = Sizzle.isXML;
  jQuery.contains = Sizzle.contains;

  var rneedsContext = jQuery.expr.match.needsContext;

  var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);

  var risSimple = /^.[^:#\[\.,]*$/;

  // Implement the identical functionality for filter and not
  function winnow( elements, qualifier, not ) {
    if ( jQuery.isFunction( qualifier ) ) {
      return jQuery.grep( elements, function ( elem, i ) {
        /* jshint -W018 */
        return !!qualifier.call( elem, i, elem ) !== not;
      });

    }

    if ( qualifier.nodeType ) {
      return jQuery.grep( elements, function ( elem ) {
        return ( elem === qualifier ) !== not;
      });

    }

    if ( typeof qualifier === "string" ) {
      if ( risSimple.test( qualifier ) ) {
        return jQuery.filter( qualifier, elements, not );
      }

      qualifier = jQuery.filter( qualifier, elements );
    }

    return jQuery.grep( elements, function ( elem ) {
      return ( jQuery.inArray( elem, qualifier ) >= 0 ) !== not;
    });
  }

  jQuery.filter = function ( expr, elems, not ) {
    var elem = elems[ 0 ];

    if ( not ) {
      expr = ":not(" + expr + ")";
    }

    return elems.length === 1 && elem.nodeType === 1 ?
      jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
      jQuery.find.matches( expr, jQuery.grep( elems, function ( elem ) {
        return elem.nodeType === 1;
      }));
  };

  jQuery.fn.extend({
    find: function ( selector ) {
      var i,
        ret = [],
        self = this,
        len = self.length;

      if ( typeof selector !== "string" ) {
        return this.pushStack( jQuery( selector ).filter(function () {
          for ( i = 0; i < len; i++ ) {
            if ( jQuery.contains( self[ i ], this ) ) {
              return true;
            }
          }
        }) );
      }

      for ( i = 0; i < len; i++ ) {
        jQuery.find( selector, self[ i ], ret );
      }

      // Needed because $( selector, context ) becomes $( context ).find( selector )
      ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
      ret.selector = this.selector ? this.selector + " " + selector : selector;
      return ret;
    },
    filter: function ( selector ) {
      return this.pushStack( winnow(this, selector || [], false) );
    },
    not: function ( selector ) {
      return this.pushStack( winnow(this, selector || [], true) );
    },
    is: function ( selector ) {
      return !!winnow(
        this,

        // If this is a positional/relative selector, check membership in the returned set
        // so $("p:first").is("p:last") won't return true for a doc with two "p".
        typeof selector === "string" && rneedsContext.test( selector ) ?
          jQuery( selector ) :
          selector || [],
        false
      ).length;
    }
  });

  // Initialize a jQuery object

  // A central reference to the root jQuery(document)
  var rootjQuery,

    // Use the correct document accordingly with window argument (sandbox)
    document = window.document,

    // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
    // Strict HTML recognition (#11290: must start with <)
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

    init = jQuery.fn.init = function ( selector, context ) {
      var match, elem;

      // HANDLE: $(""), $(null), $(undefined), $(false)
      if ( !selector ) {
        return this;
      }

      // Handle HTML strings
      if ( typeof selector === "string" ) {
        if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
          // Assume that strings that start and end with <> are HTML and skip the regex check
          match = [ null, selector, null ];

        } else {
          match = rquickExpr.exec( selector );
        }

        // Match html or make sure no context is specified for #id
        if ( match && (match[1] || !context) ) {

          // HANDLE: $(html) -> $(array)
          if ( match[1] ) {
            context = context instanceof jQuery ? context[0] : context;

            // scripts is true for back-compat
            // Intentionally let the error be thrown if parseHTML is not present
            jQuery.merge( this, jQuery.parseHTML(
              match[1],
              context && context.nodeType ? context.ownerDocument || context : document,
              true
            ) );

            // HANDLE: $(html, props)
            if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
              for ( match in context ) {
                // Properties of context are called as methods if possible
                if ( jQuery.isFunction( this[ match ] ) ) {
                  this[ match ]( context[ match ] );

                  // ...and otherwise set as attributes
                } else {
                  this.attr( match, context[ match ] );
                }
              }
            }

            return this;

            // HANDLE: $(#id)
          } else {
            elem = document.getElementById( match[2] );

            // Check parentNode to catch when Blackberry 4.6 returns
            // nodes that are no longer in the document #6963
            if ( elem && elem.parentNode ) {
              // Handle the case where IE and Opera return items
              // by name instead of ID
              if ( elem.id !== match[2] ) {
                return rootjQuery.find( selector );
              }

              // Otherwise, we inject the element directly into the jQuery object
              this.length = 1;
              this[0] = elem;
            }

            this.context = document;
            this.selector = selector;
            return this;
          }

          // HANDLE: $(expr, $(...))
        } else if ( !context || context.jquery ) {
          return ( context || rootjQuery ).find( selector );

          // HANDLE: $(expr, context)
          // (which is just equivalent to: $(context).find(expr)
        } else {
          return this.constructor( context ).find( selector );
        }

        // HANDLE: $(DOMElement)
      } else if ( selector.nodeType ) {
        this.context = this[0] = selector;
        this.length = 1;
        return this;

        // HANDLE: $(function)
        // Shortcut for document ready
      } else if ( jQuery.isFunction( selector ) ) {
        return typeof rootjQuery.ready !== "undefined" ?
          rootjQuery.ready( selector ) :
        // Execute immediately if ready is not present
          selector( jQuery );
      }

      if ( selector.selector !== undefined ) {
        this.selector = selector.selector;
        this.context = selector.context;
      }

      return jQuery.makeArray( selector, this );
    };

  // Give the init function the jQuery prototype for later instantiation
  init.prototype = jQuery.fn;

  // Initialize central reference
  rootjQuery = jQuery( document );

  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
    // methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
      children: true,
      contents: true,
      next: true,
      prev: true
    };

  jQuery.extend({
    dir: function ( elem, dir, until ) {
      var matched = [],
        cur = elem[ dir ];

      while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
        if ( cur.nodeType === 1 ) {
          matched.push( cur );
        }
        cur = cur[dir];
      }
      return matched;
    },

    sibling: function ( n, elem ) {
      var r = [];

      for ( ; n; n = n.nextSibling ) {
        if ( n.nodeType === 1 && n !== elem ) {
          r.push( n );
        }
      }

      return r;
    }
  });

  jQuery.fn.extend({
    has: function ( target ) {
      var i,
        targets = jQuery( target, this ),
        len = targets.length;

      return this.filter(function () {
        for ( i = 0; i < len; i++ ) {
          if ( jQuery.contains( this, targets[i] ) ) {
            return true;
          }
        }
      });
    },

    closest: function ( selectors, context ) {
      var cur,
        i = 0,
        l = this.length,
        matched = [],
        pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
          jQuery( selectors, context || this.context ) :
          0;

      for ( ; i < l; i++ ) {
        for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
          // Always skip document fragments
          if ( cur.nodeType < 11 && (pos ?
            pos.index(cur) > -1 :

          // Don't pass non-elements to Sizzle
            cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

            matched.push( cur );
            break;
          }
        }
      }

      return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
    },

    // Determine the position of an element within
    // the matched set of elements
    index: function ( elem ) {

      // No argument, return index in parent
      if ( !elem ) {
        return ( this[0] && this[0].parentNode ) ? this.first().prevAll().length : -1;
      }

      // index in selector
      if ( typeof elem === "string" ) {
        return jQuery.inArray( this[0], jQuery( elem ) );
      }

      // Locate the position of the desired element
      return jQuery.inArray(
        // If it receives a jQuery object, the first element is used
        elem.jquery ? elem[0] : elem, this );
    },

    add: function ( selector, context ) {
      return this.pushStack(
        jQuery.unique(
          jQuery.merge( this.get(), jQuery( selector, context ) )
        )
      );
    },

    addBack: function ( selector ) {
      return this.add( selector == null ?
        this.prevObject : this.prevObject.filter(selector)
      );
    }
  });

  function sibling( cur, dir ) {
    do {
      cur = cur[ dir ];
    } while ( cur && cur.nodeType !== 1 );

    return cur;
  }

  jQuery.each({
    parent: function ( elem ) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function ( elem ) {
      return jQuery.dir( elem, "parentNode" );
    },
    parentsUntil: function ( elem, i, until ) {
      return jQuery.dir( elem, "parentNode", until );
    },
    next: function ( elem ) {
      return sibling( elem, "nextSibling" );
    },
    prev: function ( elem ) {
      return sibling( elem, "previousSibling" );
    },
    nextAll: function ( elem ) {
      return jQuery.dir( elem, "nextSibling" );
    },
    prevAll: function ( elem ) {
      return jQuery.dir( elem, "previousSibling" );
    },
    nextUntil: function ( elem, i, until ) {
      return jQuery.dir( elem, "nextSibling", until );
    },
    prevUntil: function ( elem, i, until ) {
      return jQuery.dir( elem, "previousSibling", until );
    },
    siblings: function ( elem ) {
      return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
    },
    children: function ( elem ) {
      return jQuery.sibling( elem.firstChild );
    },
    contents: function ( elem ) {
      return jQuery.nodeName( elem, "iframe" ) ?
        elem.contentDocument || elem.contentWindow.document :
        jQuery.merge( [], elem.childNodes );
    }
  }, function ( name, fn ) {
    jQuery.fn[ name ] = function ( until, selector ) {
      var ret = jQuery.map( this, fn, until );

      if ( name.slice( -5 ) !== "Until" ) {
        selector = until;
      }

      if ( selector && typeof selector === "string" ) {
        ret = jQuery.filter( selector, ret );
      }

      if ( this.length > 1 ) {
        // Remove duplicates
        if ( !guaranteedUnique[ name ] ) {
          ret = jQuery.unique( ret );
        }

        // Reverse order for parents* and prev-derivatives
        if ( rparentsprev.test( name ) ) {
          ret = ret.reverse();
        }
      }

      return this.pushStack( ret );
    };
  });
  var rnotwhite = (/\S+/g);

  // String to Object options format cache
  var optionsCache = {};

  // Convert String-formatted options into Object-formatted ones and store in cache
  function createOptions( options ) {
    var object = optionsCache[ options ] = {};
    jQuery.each( options.match( rnotwhite ) || [], function ( _, flag ) {
      object[ flag ] = true;
    });
    return object;
  }

  /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
  jQuery.Callbacks = function ( options ) {

    // Convert options from String-formatted to Object-formatted if needed
    // (we check in cache first)
    options = typeof options === "string" ?
      ( optionsCache[ options ] || createOptions( options ) ) :
      jQuery.extend( {}, options );

    var // Flag to know if list is currently firing
      firing,
      // Last fire value (for non-forgettable lists)
      memory,
      // Flag to know if list was already fired
      fired,
      // End of the loop when firing
      firingLength,
      // Index of currently firing callback (modified by remove if needed)
      firingIndex,
      // First callback to fire (used internally by add and fireWith)
      firingStart,
      // Actual callback list
      list = [],
      // Stack of fire calls for repeatable lists
      stack = !options.once && [],
      // Fire callbacks
      fire = function ( data ) {
        memory = options.memory && data;
        fired = true;
        firingIndex = firingStart || 0;
        firingStart = 0;
        firingLength = list.length;
        firing = true;
        for ( ; list && firingIndex < firingLength; firingIndex++ ) {
          if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
            memory = false; // To prevent further calls using add
            break;
          }
        }
        firing = false;
        if ( list ) {
          if ( stack ) {
            if ( stack.length ) {
              fire( stack.shift() );
            }
          } else if ( memory ) {
            list = [];
          } else {
            self.disable();
          }
        }
      },
      // Actual Callbacks object
      self = {
        // Add a callback or a collection of callbacks to the list
        add: function () {
          if ( list ) {
            // First, we save the current length
            var start = list.length;
            (function add( args ) {
              jQuery.each( args, function ( _, arg ) {
                var type = jQuery.type( arg );
                if ( type === "function" ) {
                  if ( !options.unique || !self.has( arg ) ) {
                    list.push( arg );
                  }
                } else if ( arg && arg.length && type !== "string" ) {
                  // Inspect recursively
                  add( arg );
                }
              });
            })( arguments );
            // Do we need to add the callbacks to the
            // current firing batch?
            if ( firing ) {
              firingLength = list.length;
              // With memory, if we're not firing then
              // we should call right away
            } else if ( memory ) {
              firingStart = start;
              fire( memory );
            }
          }
          return this;
        },
        // Remove a callback from the list
        remove: function () {
          if ( list ) {
            jQuery.each( arguments, function ( _, arg ) {
              var index;
              while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                list.splice( index, 1 );
                // Handle firing indexes
                if ( firing ) {
                  if ( index <= firingLength ) {
                    firingLength--;
                  }
                  if ( index <= firingIndex ) {
                    firingIndex--;
                  }
                }
              }
            });
          }
          return this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function ( fn ) {
          return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
        },
        // Remove all callbacks from the list
        empty: function () {
          list = [];
          firingLength = 0;
          return this;
        },
        // Have the list do nothing anymore
        disable: function () {
          list = stack = memory = undefined;
          return this;
        },
        // Is it disabled?
        disabled: function () {
          return !list;
        },
        // Lock the list in its current state
        lock: function () {
          stack = undefined;
          if ( !memory ) {
            self.disable();
          }
          return this;
        },
        // Is it locked?
        locked: function () {
          return !stack;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function ( context, args ) {
          if ( list && ( !fired || stack ) ) {
            args = args || [];
            args = [ context, args.slice ? args.slice() : args ];
            if ( firing ) {
              stack.push( args );
            } else {
              fire( args );
            }
          }
          return this;
        },
        // Call all the callbacks with the given arguments
        fire: function () {
          self.fireWith( this, arguments );
          return this;
        },
        // To know if the callbacks have already been called at least once
        fired: function () {
          return !!fired;
        }
      };

    return self;
  };

  jQuery.extend({

    Deferred: function ( func ) {
      var tuples = [
          // action, add listener, listener list, final state
          [ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
          [ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
          [ "notify", "progress", jQuery.Callbacks("memory") ]
        ],
        state = "pending",
        promise = {
          state: function () {
            return state;
          },
          always: function () {
            deferred.done( arguments ).fail( arguments );
            return this;
          },
          then: function ( /* fnDone, fnFail, fnProgress */ ) {
            var fns = arguments;
            return jQuery.Deferred(function ( newDefer ) {
              jQuery.each( tuples, function ( i, tuple ) {
                var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
                // deferred[ done | fail | progress ] for forwarding actions to newDefer
                deferred[ tuple[1] ](function () {
                  var returned = fn && fn.apply( this, arguments );
                  if ( returned && jQuery.isFunction( returned.promise ) ) {
                    returned.promise()
                      .done( newDefer.resolve )
                      .fail( newDefer.reject )
                      .progress( newDefer.notify );
                  } else {
                    newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
                  }
                });
              });
              fns = null;
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function ( obj ) {
            return obj != null ? jQuery.extend( obj, promise ) : promise;
          }
        },
        deferred = {};

      // Keep pipe for back-compat
      promise.pipe = promise.then;

      // Add list-specific methods
      jQuery.each( tuples, function ( i, tuple ) {
        var list = tuple[ 2 ],
          stateString = tuple[ 3 ];

        // promise[ done | fail | progress ] = list.add
        promise[ tuple[1] ] = list.add;

        // Handle state
        if ( stateString ) {
          list.add(function () {
            // state = [ resolved | rejected ]
            state = stateString;

            // [ reject_list | resolve_list ].disable; progress_list.lock
          }, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
        }

        // deferred[ resolve | reject | notify ]
        deferred[ tuple[0] ] = function () {
          deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
          return this;
        };
        deferred[ tuple[0] + "With" ] = list.fireWith;
      });

      // Make the deferred a promise
      promise.promise( deferred );

      // Call given func if any
      if ( func ) {
        func.call( deferred, deferred );
      }

      // All done!
      return deferred;
    },

    // Deferred helper
    when: function ( subordinate /* , ..., subordinateN */ ) {
      var i = 0,
        resolveValues = slice.call( arguments ),
        length = resolveValues.length,

        // the count of uncompleted subordinates
        remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

        // the master Deferred. If resolveValues consist of only a single Deferred, just use that.
        deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

        // Update function for both resolve and progress values
        updateFunc = function ( i, contexts, values ) {
          return function ( value ) {
            contexts[ i ] = this;
            values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
            if ( values === progressValues ) {
              deferred.notifyWith( contexts, values );

            } else if ( !(--remaining) ) {
              deferred.resolveWith( contexts, values );
            }
          };
        },

        progressValues, progressContexts, resolveContexts;

      // add listeners to Deferred subordinates; treat others as resolved
      if ( length > 1 ) {
        progressValues = new Array( length );
        progressContexts = new Array( length );
        resolveContexts = new Array( length );
        for ( ; i < length; i++ ) {
          if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
            resolveValues[ i ].promise()
              .done( updateFunc( i, resolveContexts, resolveValues ) )
              .fail( deferred.reject )
              .progress( updateFunc( i, progressContexts, progressValues ) );
          } else {
            --remaining;
          }
        }
      }

      // if we're not waiting on anything, resolve the master
      if ( !remaining ) {
        deferred.resolveWith( resolveContexts, resolveValues );
      }

      return deferred.promise();
    }
  });

  // The deferred used on DOM ready
  var readyList;

  jQuery.fn.ready = function ( fn ) {
    // Add the callback
    jQuery.ready.promise().done( fn );

    return this;
  };

  jQuery.extend({
    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: false,

    // A counter to track how many items to wait for before
    // the ready event fires. See #6781
    readyWait: 1,

    // Hold (or release) the ready event
    holdReady: function ( hold ) {
      if ( hold ) {
        jQuery.readyWait++;
      } else {
        jQuery.ready( true );
      }
    },

    // Handle when the DOM is ready
    ready: function ( wait ) {

      // Abort if there are pending holds or we're already ready
      if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
        return;
      }

      // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
      if ( !document.body ) {
        return setTimeout( jQuery.ready );
      }

      // Remember that the DOM is ready
      jQuery.isReady = true;

      // If a normal DOM Ready event fired, decrement, and wait if need be
      if ( wait !== true && --jQuery.readyWait > 0 ) {
        return;
      }

      // If there are functions bound, to execute
      readyList.resolveWith( document, [ jQuery ] );

      // Trigger any bound ready events
      if ( jQuery.fn.triggerHandler ) {
        jQuery( document ).triggerHandler( "ready" );
        jQuery( document ).off( "ready" );
      }
    }
  });

  /**
 * Clean-up method for dom ready events
 */
  function detach() {
    if ( document.addEventListener ) {
      document.removeEventListener( "DOMContentLoaded", completed, false );
      window.removeEventListener( "load", completed, false );

    } else {
      document.detachEvent( "onreadystatechange", completed );
      window.detachEvent( "onload", completed );
    }
  }

  /**
 * The ready event handler and self cleanup method
 */
  function completed() {
    // readyState === "complete" is good enough for us to call the dom ready in oldIE
    if ( document.addEventListener || event.type === "load" || document.readyState === "complete" ) {
      detach();
      jQuery.ready();
    }
  }

  jQuery.ready.promise = function ( obj ) {
    if ( !readyList ) {

      readyList = jQuery.Deferred();

      // Catch cases where $(document).ready() is called after the browser event has already occurred.
      // we once tried to use readyState "interactive" here, but it caused issues like the one
      // discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
      if ( document.readyState === "complete" ) {
        // Handle it asynchronously to allow scripts the opportunity to delay ready
        setTimeout( jQuery.ready );

        // Standards-based browsers support DOMContentLoaded
      } else if ( document.addEventListener ) {
        // Use the handy event callback
        document.addEventListener( "DOMContentLoaded", completed, false );

        // A fallback to window.onload, that will always work
        window.addEventListener( "load", completed, false );

        // If IE event model is used
      } else {
        // Ensure firing before onload, maybe late but safe also for iframes
        document.attachEvent( "onreadystatechange", completed );

        // A fallback to window.onload, that will always work
        window.attachEvent( "onload", completed );

        // If IE and not a frame
        // continually check to see if the document is ready
        var top = false;

        try {
          top = window.frameElement == null && document.documentElement;
        } catch (e) {}

        if ( top && top.doScroll ) {
          (function doScrollCheck() {
            if ( !jQuery.isReady ) {

              try {
                // Use the trick by Diego Perini
                // http://javascript.nwbox.com/IEContentLoaded/
                top.doScroll("left");
              } catch (e) {
                return setTimeout( doScrollCheck, 50 );
              }

              // detach all dom ready events
              detach();

              // and execute any waiting functions
              jQuery.ready();
            }
          })();
        }
      }
    }
    return readyList.promise( obj );
  };

  var strundefined = typeof undefined;

  // Support: IE<9
  // Iteration over object's inherited properties before its own
  var i;
  for ( i in jQuery( support ) ) {
    break;
  }
  support.ownLast = i !== "0";

  // Note: most support tests are defined in their respective modules.
  // false until the test is run
  support.inlineBlockNeedsLayout = false;

  // Execute ASAP in case we need to set body.style.zoom
  jQuery(function () {
    // Minified: var a,b,c,d
    var val, div, body, container;

    body = document.getElementsByTagName( "body" )[ 0 ];
    if ( !body || !body.style ) {
      // Return for frameset docs that don't have a body
      return;
    }

    // Setup
    div = document.createElement( "div" );
    container = document.createElement( "div" );
    container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
    body.appendChild( container ).appendChild( div );

    if ( typeof div.style.zoom !== strundefined ) {
      // Support: IE<8
      // Check if natively block-level elements act like inline-block
      // elements when setting their display to 'inline' and giving
      // them layout
      div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";

      support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
      if ( val ) {
        // Prevent IE 6 from affecting layout for positioned elements #11048
        // Prevent IE from shrinking the body in IE 7 mode #12869
        // Support: IE<8
        body.style.zoom = 1;
      }
    }

    body.removeChild( container );
  });

  (function () {
    var div = document.createElement( "div" );

    // Execute the test only if not already executed in another module.
    if (support.deleteExpando == null) {
      // Support: IE<9
      support.deleteExpando = true;
      try {
        delete div.test;
      } catch ( e ) {
        support.deleteExpando = false;
      }
    }

    // Null elements to avoid leaks in IE.
    div = null;
  })();

  /**
 * Determines whether an object can have data
 */
  jQuery.acceptData = function ( elem ) {
    var noData = jQuery.noData[ (elem.nodeName + " ").toLowerCase() ],
      nodeType = +elem.nodeType || 1;

    // Do not set data on non-element DOM nodes because it will not be cleared (#8335).
    return nodeType !== 1 && nodeType !== 9 ?
      false :

    // Nodes accept data unless otherwise specified; rejection can be conditional
      !noData || noData !== true && elem.getAttribute("classid") === noData;
  };

  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    rmultiDash = /([A-Z])/g;

  function dataAttr( elem, key, data ) {
    // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute
    if ( data === undefined && elem.nodeType === 1 ) {

      var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

      data = elem.getAttribute( name );

      if ( typeof data === "string" ) {
        try {
          data = data === "true" ? true :
            data === "false" ? false :
              data === "null" ? null :
              // Only convert to a number if it doesn't change the string
                +data + "" === data ? +data :
                  rbrace.test( data ) ? jQuery.parseJSON( data ) :
                    data;
        } catch ( e ) {}

        // Make sure we set the data so it isn't changed later
        jQuery.data( elem, key, data );

      } else {
        data = undefined;
      }
    }

    return data;
  }

  // checks a cache object for emptiness
  function isEmptyDataObject( obj ) {
    var name;
    for ( name in obj ) {

      // if the public data object is empty, the private is still empty
      if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
        continue;
      }
      if ( name !== "toJSON" ) {
        return false;
      }
    }

    return true;
  }

  function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
    if ( !jQuery.acceptData( elem ) ) {
      return;
    }

    var ret, thisCache,
      internalKey = jQuery.expando,

      // We have to handle DOM nodes and JS objects differently because IE6-7
      // can't GC object references properly across the DOM-JS boundary
      isNode = elem.nodeType,

      // Only DOM nodes need the global jQuery cache; JS object data is
      // attached directly to the object so GC can occur automatically
      cache = isNode ? jQuery.cache : elem,

      // Only defining an ID for JS objects if its cache already exists allows
      // the code to shortcut on the same path as a DOM node with no cache
      id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

    // Avoid doing any more work than we need to when trying to get data on an
    // object that has no data at all
    if ( (!id || !cache[id] || (!pvt && !cache[id].data)) && data === undefined && typeof name === "string" ) {
      return;
    }

    if ( !id ) {
      // Only DOM nodes need a new unique ID for each element since their data
      // ends up in the global cache
      if ( isNode ) {
        id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
      } else {
        id = internalKey;
      }
    }

    if ( !cache[ id ] ) {
      // Avoid exposing jQuery metadata on plain JS objects when the object
      // is serialized using JSON.stringify
      cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
    }

    // An object can be passed to jQuery.data instead of a key/value pair; this gets
    // shallow copied over onto the existing cache
    if ( typeof name === "object" || typeof name === "function" ) {
      if ( pvt ) {
        cache[ id ] = jQuery.extend( cache[ id ], name );
      } else {
        cache[ id ].data = jQuery.extend( cache[ id ].data, name );
      }
    }

    thisCache = cache[ id ];

    // jQuery data() is stored in a separate object inside the object's internal data
    // cache in order to avoid key collisions between internal data and user-defined
    // data.
    if ( !pvt ) {
      if ( !thisCache.data ) {
        thisCache.data = {};
      }

      thisCache = thisCache.data;
    }

    if ( data !== undefined ) {
      thisCache[ jQuery.camelCase( name ) ] = data;
    }

    // Check for both converted-to-camel and non-converted data property names
    // If a data property was specified
    if ( typeof name === "string" ) {

      // First Try to find as-is property data
      ret = thisCache[ name ];

      // Test for null|undefined property data
      if ( ret == null ) {

        // Try to find the camelCased property
        ret = thisCache[ jQuery.camelCase( name ) ];
      }
    } else {
      ret = thisCache;
    }

    return ret;
  }

  function internalRemoveData( elem, name, pvt ) {
    if ( !jQuery.acceptData( elem ) ) {
      return;
    }

    var thisCache, i,
      isNode = elem.nodeType,

      // See jQuery.data for more information
      cache = isNode ? jQuery.cache : elem,
      id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

    // If there is already no cache entry for this object, there is no
    // purpose in continuing
    if ( !cache[ id ] ) {
      return;
    }

    if ( name ) {

      thisCache = pvt ? cache[ id ] : cache[ id ].data;

      if ( thisCache ) {

        // Support array or space separated string names for data keys
        if ( !jQuery.isArray( name ) ) {

          // try the string as a key before any manipulation
          if ( name in thisCache ) {
            name = [ name ];
          } else {

            // split the camel cased version by spaces unless a key with the spaces exists
            name = jQuery.camelCase( name );
            if ( name in thisCache ) {
              name = [ name ];
            } else {
              name = name.split(" ");
            }
          }
        } else {
          // If "name" is an array of keys...
          // When data is initially created, via ("key", "val") signature,
          // keys will be converted to camelCase.
          // Since there is no way to tell _how_ a key was added, remove
          // both plain key and camelCase key. #12786
          // This will only penalize the array argument path.
          name = name.concat( jQuery.map( name, jQuery.camelCase ) );
        }

        i = name.length;
        while ( i-- ) {
          delete thisCache[ name[i] ];
        }

        // If there is no data left in the cache, we want to continue
        // and let the cache object itself get destroyed
        if ( pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache) ) {
          return;
        }
      }
    }

    // See jQuery.data for more information
    if ( !pvt ) {
      delete cache[ id ].data;

      // Don't destroy the parent cache unless the internal data object
      // had been the only thing left in it
      if ( !isEmptyDataObject( cache[ id ] ) ) {
        return;
      }
    }

    // Destroy the cache
    if ( isNode ) {
      jQuery.cleanData( [ elem ], true );

      // Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
      /* jshint eqeqeq: false */
    } else if ( support.deleteExpando || cache != cache.window ) {
      /* jshint eqeqeq: true */
      delete cache[ id ];

      // When all else fails, null
    } else {
      cache[ id ] = null;
    }
  }

  jQuery.extend({
    cache: {},

    // The following elements (space-suffixed to avoid Object.prototype collisions)
    // throw uncatchable exceptions if you attempt to set expando properties
    noData: {
      "applet ": true,
      "embed ": true,
      // ...but Flash objects (which have this classid) *can* handle expandos
      "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
    },

    hasData: function ( elem ) {
      elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
      return !!elem && !isEmptyDataObject( elem );
    },

    data: function ( elem, name, data ) {
      return internalData( elem, name, data );
    },

    removeData: function ( elem, name ) {
      return internalRemoveData( elem, name );
    },

    // For internal use only.
    _data: function ( elem, name, data ) {
      return internalData( elem, name, data, true );
    },

    _removeData: function ( elem, name ) {
      return internalRemoveData( elem, name, true );
    }
  });

  jQuery.fn.extend({
    data: function ( key, value ) {
      var i, name, data,
        elem = this[0],
        attrs = elem && elem.attributes;

      // Special expections of .data basically thwart jQuery.access,
      // so implement the relevant behavior ourselves

      // Gets all values
      if ( key === undefined ) {
        if ( this.length ) {
          data = jQuery.data( elem );

          if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
            i = attrs.length;
            while ( i-- ) {

              // Support: IE11+
              // The attrs elements can be null (#14894)
              if ( attrs[ i ] ) {
                name = attrs[ i ].name;
                if ( name.indexOf( "data-" ) === 0 ) {
                  name = jQuery.camelCase( name.slice(5) );
                  dataAttr( elem, name, data[ name ] );
                }
              }
            }
            jQuery._data( elem, "parsedAttrs", true );
          }
        }

        return data;
      }

      // Sets multiple values
      if ( typeof key === "object" ) {
        return this.each(function () {
          jQuery.data( this, key );
        });
      }

      return arguments.length > 1 ?

      // Sets one value
        this.each(function () {
          jQuery.data( this, key, value );
        }) :

      // Gets one value
      // Try to fetch any internally stored data first
        elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
    },

    removeData: function ( key ) {
      return this.each(function () {
        jQuery.removeData( this, key );
      });
    }
  });

  jQuery.extend({
    queue: function ( elem, type, data ) {
      var queue;

      if ( elem ) {
        type = ( type || "fx" ) + "queue";
        queue = jQuery._data( elem, type );

        // Speed up dequeue by getting out quickly if this is just a lookup
        if ( data ) {
          if ( !queue || jQuery.isArray(data) ) {
            queue = jQuery._data( elem, type, jQuery.makeArray(data) );
          } else {
            queue.push( data );
          }
        }
        return queue || [];
      }
    },

    dequeue: function ( elem, type ) {
      type = type || "fx";

      var queue = jQuery.queue( elem, type ),
        startLength = queue.length,
        fn = queue.shift(),
        hooks = jQuery._queueHooks( elem, type ),
        next = function () {
          jQuery.dequeue( elem, type );
        };

      // If the fx queue is dequeued, always remove the progress sentinel
      if ( fn === "inprogress" ) {
        fn = queue.shift();
        startLength--;
      }

      if ( fn ) {

        // Add a progress sentinel to prevent the fx queue from being
        // automatically dequeued
        if ( type === "fx" ) {
          queue.unshift( "inprogress" );
        }

        // clear up the last queue stop function
        delete hooks.stop;
        fn.call( elem, next, hooks );
      }

      if ( !startLength && hooks ) {
        hooks.empty.fire();
      }
    },

    // not intended for public consumption - generates a queueHooks object, or returns the current one
    _queueHooks: function ( elem, type ) {
      var key = type + "queueHooks";
      return jQuery._data( elem, key ) || jQuery._data( elem, key, {
        empty: jQuery.Callbacks("once memory").add(function () {
          jQuery._removeData( elem, type + "queue" );
          jQuery._removeData( elem, key );
        })
      });
    }
  });

  jQuery.fn.extend({
    queue: function ( type, data ) {
      var setter = 2;

      if ( typeof type !== "string" ) {
        data = type;
        type = "fx";
        setter--;
      }

      if ( arguments.length < setter ) {
        return jQuery.queue( this[0], type );
      }

      return data === undefined ?
        this :
        this.each(function () {
          var queue = jQuery.queue( this, type, data );

          // ensure a hooks for this queue
          jQuery._queueHooks( this, type );

          if ( type === "fx" && queue[0] !== "inprogress" ) {
            jQuery.dequeue( this, type );
          }
        });
    },
    dequeue: function ( type ) {
      return this.each(function () {
        jQuery.dequeue( this, type );
      });
    },
    clearQueue: function ( type ) {
      return this.queue( type || "fx", [] );
    },
    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function ( type, obj ) {
      var tmp,
        count = 1,
        defer = jQuery.Deferred(),
        elements = this,
        i = this.length,
        resolve = function () {
          if ( !( --count ) ) {
            defer.resolveWith( elements, [ elements ] );
          }
        };

      if ( typeof type !== "string" ) {
        obj = type;
        type = undefined;
      }
      type = type || "fx";

      while ( i-- ) {
        tmp = jQuery._data( elements[ i ], type + "queueHooks" );
        if ( tmp && tmp.empty ) {
          count++;
          tmp.empty.add( resolve );
        }
      }
      resolve();
      return defer.promise( obj );
    }
  });
  var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

  var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

  var isHidden = function ( elem, el ) {
    // isHidden might be called from jQuery#filter function;
    // in that case, element will be second argument
    elem = el || elem;
    return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
  };

  // Multifunctional method to get and set values of a collection
  // The value/s can optionally be executed if it's a function
  var access = jQuery.access = function ( elems, fn, key, value, chainable, emptyGet, raw ) {
    var i = 0,
      length = elems.length,
      bulk = key == null;

    // Sets many values
    if ( jQuery.type( key ) === "object" ) {
      chainable = true;
      for ( i in key ) {
        jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
      }

      // Sets one value
    } else if ( value !== undefined ) {
      chainable = true;

      if ( !jQuery.isFunction( value ) ) {
        raw = true;
      }

      if ( bulk ) {
        // Bulk operations run against the entire set
        if ( raw ) {
          fn.call( elems, value );
          fn = null;

          // ...except when executing function values
        } else {
          bulk = fn;
          fn = function ( elem, key, value ) {
            return bulk.call( jQuery( elem ), value );
          };
        }
      }

      if ( fn ) {
        for ( ; i < length; i++ ) {
          fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
        }
      }
    }

    return chainable ?
      elems :

    // Gets
      bulk ?
        fn.call( elems ) :
        length ? fn( elems[0], key ) : emptyGet;
  };
  var rcheckableType = (/^(?:checkbox|radio)$/i);

  (function () {
    // Minified: var a,b,c
    var input = document.createElement( "input" ),
      div = document.createElement( "div" ),
      fragment = document.createDocumentFragment();

    // Setup
    div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

    // IE strips leading whitespace when .innerHTML is used
    support.leadingWhitespace = div.firstChild.nodeType === 3;

    // Make sure that tbody elements aren't automatically inserted
    // IE will insert them into empty tables
    support.tbody = !div.getElementsByTagName( "tbody" ).length;

    // Make sure that link elements get serialized correctly by innerHTML
    // This requires a wrapper element in IE
    support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

    // Makes sure cloning an html5 element does not cause problems
    // Where outerHTML is undefined, this still works
    support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

    // Check if a disconnected checkbox will retain its checked
    // value of true after appended to the DOM (IE6/7)
    input.type = "checkbox";
    input.checked = true;
    fragment.appendChild( input );
    support.appendChecked = input.checked;

    // Make sure textarea (and checkbox) defaultValue is properly cloned
    // Support: IE6-IE11+
    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

    // #11217 - WebKit loses check when the name is after the checked attribute
    fragment.appendChild( div );
    div.innerHTML = "<input type='radio' checked='checked' name='t'/>";

    // Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
    // old WebKit doesn't clone checked state correctly in fragments
    support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

    // Support: IE<9
    // Opera does not clone events (and typeof div.attachEvent === undefined).
    // IE9-10 clones events bound via attachEvent, but they don't trigger with .click()
    support.noCloneEvent = true;
    if ( div.attachEvent ) {
      div.attachEvent( "onclick", function () {
        support.noCloneEvent = false;
      });

      div.cloneNode( true ).click();
    }

    // Execute the test only if not already executed in another module.
    if (support.deleteExpando == null) {
      // Support: IE<9
      support.deleteExpando = true;
      try {
        delete div.test;
      } catch ( e ) {
        support.deleteExpando = false;
      }
    }
  })();

  (function () {
    var i, eventName,
      div = document.createElement( "div" );

    // Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)
    for ( i in { submit: true, change: true, focusin: true }) {
      eventName = "on" + i;

      if ( !(support[ i + "Bubbles" ] = eventName in window) ) {
        // Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
        div.setAttribute( eventName, "t" );
        support[ i + "Bubbles" ] = div.attributes[ eventName ].expando === false;
      }
    }

    // Null elements to avoid leaks in IE.
    div = null;
  })();

  var rformElems = /^(?:input|select|textarea)$/i,
    rkeyEvent = /^key/,
    rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
    rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
    rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

  function returnTrue() {
    return true;
  }

  function returnFalse() {
    return false;
  }

  function safeActiveElement() {
    try {
      return document.activeElement;
    } catch ( err ) { }
  }

  /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
  jQuery.event = {

    global: {},

    add: function ( elem, types, handler, data, selector ) {
      var tmp, events, t, handleObjIn,
        special, eventHandle, handleObj,
        handlers, type, namespaces, origType,
        elemData = jQuery._data( elem );

      // Don't attach events to noData or text/comment nodes (but allow plain objects)
      if ( !elemData ) {
        return;
      }

      // Caller can pass in an object of custom data in lieu of the handler
      if ( handler.handler ) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      }

      // Make sure that the handler has a unique ID, used to find/remove it later
      if ( !handler.guid ) {
        handler.guid = jQuery.guid++;
      }

      // Init the element's event structure and main handler, if this is the first
      if ( !(events = elemData.events) ) {
        events = elemData.events = {};
      }
      if ( !(eventHandle = elemData.handle) ) {
        eventHandle = elemData.handle = function ( e ) {
          // Discard the second event of a jQuery.event.trigger() and
          // when an event is called after a page has unloaded
          return typeof jQuery !== strundefined && (!e || jQuery.event.triggered !== e.type) ?
            jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
            undefined;
        };
        // Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
        eventHandle.elem = elem;
      }

      // Handle multiple events separated by a space
      types = ( types || "" ).match( rnotwhite ) || [ "" ];
      t = types.length;
      while ( t-- ) {
        tmp = rtypenamespace.exec( types[t] ) || [];
        type = origType = tmp[1];
        namespaces = ( tmp[2] || "" ).split( "." ).sort();

        // There *must* be a type, no attaching namespace-only handlers
        if ( !type ) {
          continue;
        }

        // If event changes its type, use the special event handlers for the changed type
        special = jQuery.event.special[ type ] || {};

        // If selector defined, determine special event api type, otherwise given type
        type = ( selector ? special.delegateType : special.bindType ) || type;

        // Update special based on newly reset type
        special = jQuery.event.special[ type ] || {};

        // handleObj is passed to all event handlers
        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
          namespace: namespaces.join(".")
        }, handleObjIn );

        // Init the event handler queue if we're the first
        if ( !(handlers = events[ type ]) ) {
          handlers = events[ type ] = [];
          handlers.delegateCount = 0;

          // Only use addEventListener/attachEvent if the special events handler returns false
          if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
            // Bind the global event handler to the element
            if ( elem.addEventListener ) {
              elem.addEventListener( type, eventHandle, false );

            } else if ( elem.attachEvent ) {
              elem.attachEvent( "on" + type, eventHandle );
            }
          }
        }

        if ( special.add ) {
          special.add.call( elem, handleObj );

          if ( !handleObj.handler.guid ) {
            handleObj.handler.guid = handler.guid;
          }
        }

        // Add to the element's handler list, delegates in front
        if ( selector ) {
          handlers.splice( handlers.delegateCount++, 0, handleObj );
        } else {
          handlers.push( handleObj );
        }

        // Keep track of which events have ever been used, for event optimization
        jQuery.event.global[ type ] = true;
      }

      // Nullify elem to prevent memory leaks in IE
      elem = null;
    },

    // Detach an event or set of events from an element
    remove: function ( elem, types, handler, selector, mappedTypes ) {
      var j, handleObj, tmp,
        origCount, t, events,
        special, handlers, type,
        namespaces, origType,
        elemData = jQuery.hasData( elem ) && jQuery._data( elem );

      if ( !elemData || !(events = elemData.events) ) {
        return;
      }

      // Once for each type.namespace in types; type may be omitted
      types = ( types || "" ).match( rnotwhite ) || [ "" ];
      t = types.length;
      while ( t-- ) {
        tmp = rtypenamespace.exec( types[t] ) || [];
        type = origType = tmp[1];
        namespaces = ( tmp[2] || "" ).split( "." ).sort();

        // Unbind all events (on this namespace, if provided) for the element
        if ( !type ) {
          for ( type in events ) {
            jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
          }
          continue;
        }

        special = jQuery.event.special[ type ] || {};
        type = ( selector ? special.delegateType : special.bindType ) || type;
        handlers = events[ type ] || [];
        tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

        // Remove matching events
        origCount = j = handlers.length;
        while ( j-- ) {
          handleObj = handlers[ j ];

          if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
            handlers.splice( j, 1 );

            if ( handleObj.selector ) {
              handlers.delegateCount--;
            }
            if ( special.remove ) {
              special.remove.call( elem, handleObj );
            }
          }
        }

        // Remove generic event handler if we removed something and no more handlers exist
        // (avoids potential for endless recursion during removal of special event handlers)
        if ( origCount && !handlers.length ) {
          if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
            jQuery.removeEvent( elem, type, elemData.handle );
          }

          delete events[ type ];
        }
      }

      // Remove the expando if it's no longer used
      if ( jQuery.isEmptyObject( events ) ) {
        delete elemData.handle;

        // removeData also checks for emptiness and clears the expando if empty
        // so use it instead of delete
        jQuery._removeData( elem, "events" );
      }
    },

    trigger: function ( event, data, elem, onlyHandlers ) {
      var handle, ontype, cur,
        bubbleType, special, tmp, i,
        eventPath = [ elem || document ],
        type = hasOwn.call( event, "type" ) ? event.type : event,
        namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

      cur = tmp = elem = elem || document;

      // Don't do events on text and comment nodes
      if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
        return;
      }

      // focus/blur morphs to focusin/out; ensure we're not firing them right now
      if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
        return;
      }

      if ( type.indexOf(".") >= 0 ) {
        // Namespaced trigger; create a regexp to match event type in handle()
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }
      ontype = type.indexOf(":") < 0 && "on" + type;

      // Caller can pass in a jQuery.Event object, Object, or just an event type string
      event = event[ jQuery.expando ] ?
        event :
        new jQuery.Event( type, typeof event === "object" && event );

      // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.namespace_re = event.namespace ?
        new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
        null;

      // Clean up the event in case it is being reused
      event.result = undefined;
      if ( !event.target ) {
        event.target = elem;
      }

      // Clone any incoming data and prepend the event, creating the handler arg list
      data = data == null ?
        [ event ] :
        jQuery.makeArray( data, [ event ] );

      // Allow special events to draw outside the lines
      special = jQuery.event.special[ type ] || {};
      if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
        return;
      }

      // Determine event propagation path in advance, per W3C events spec (#9951)
      // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
      if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

        bubbleType = special.delegateType || type;
        if ( !rfocusMorph.test( bubbleType + type ) ) {
          cur = cur.parentNode;
        }
        for ( ; cur; cur = cur.parentNode ) {
          eventPath.push( cur );
          tmp = cur;
        }

        // Only add window if we got to document (e.g., not plain obj or detached DOM)
        if ( tmp === (elem.ownerDocument || document) ) {
          eventPath.push( tmp.defaultView || tmp.parentWindow || window );
        }
      }

      // Fire handlers on the event path
      i = 0;
      while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

        event.type = i > 1 ?
          bubbleType :
          special.bindType || type;

        // jQuery handler
        handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
        if ( handle ) {
          handle.apply( cur, data );
        }

        // Native handler
        handle = ontype && cur[ ontype ];
        if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
          event.result = handle.apply( cur, data );
          if ( event.result === false ) {
            event.preventDefault();
          }
        }
      }
      event.type = type;

      // If nobody prevented the default action, do it now
      if ( !onlyHandlers && !event.isDefaultPrevented() ) {

        if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

          // Call a native DOM method on the target with the same name name as the event.
          // Can't use an .isFunction() check here because IE6/7 fails that test.
          // Don't do default actions on window, that's where global variables be (#6170)
          if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

            // Don't re-trigger an onFOO event when we call its FOO() method
            tmp = elem[ ontype ];

            if ( tmp ) {
              elem[ ontype ] = null;
            }

            // Prevent re-triggering of the same event, since we already bubbled it above
            jQuery.event.triggered = type;
            try {
              elem[ type ]();
            } catch ( e ) {
              // IE<9 dies on focus/blur to hidden element (#1486,#12518)
              // only reproducible on winXP IE8 native, not IE9 in IE8 mode
            }
            jQuery.event.triggered = undefined;

            if ( tmp ) {
              elem[ ontype ] = tmp;
            }
          }
        }
      }

      return event.result;
    },

    dispatch: function ( event ) {

      // Make a writable jQuery.Event from the native event object
      event = jQuery.event.fix( event );

      var i, ret, handleObj, matched, j,
        handlerQueue = [],
        args = slice.call( arguments ),
        handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
        special = jQuery.event.special[ event.type ] || {};

      // Use the fix-ed jQuery.Event rather than the (read-only) native event
      args[0] = event;
      event.delegateTarget = this;

      // Call the preDispatch hook for the mapped type, and let it bail if desired
      if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
        return;
      }

      // Determine handlers
      handlerQueue = jQuery.event.handlers.call( this, event, handlers );

      // Run delegates first; they may want to stop propagation beneath us
      i = 0;
      while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
        event.currentTarget = matched.elem;

        j = 0;
        while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

          // Triggered event must either 1) have no namespace, or
          // 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
          if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

            event.handleObj = handleObj;
            event.data = handleObj.data;

            ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
              .apply( matched.elem, args );

            if ( ret !== undefined ) {
              if ( (event.result = ret) === false ) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      }

      // Call the postDispatch hook for the mapped type
      if ( special.postDispatch ) {
        special.postDispatch.call( this, event );
      }

      return event.result;
    },

    handlers: function ( event, handlers ) {
      var sel, handleObj, matches, i,
        handlerQueue = [],
        delegateCount = handlers.delegateCount,
        cur = event.target;

      // Find delegate handlers
      // Black-hole SVG <use> instance trees (#13180)
      // Avoid non-left-click bubbling in Firefox (#3861)
      if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

        /* jshint eqeqeq: false */
        for ( ; cur != this; cur = cur.parentNode || this ) {
          /* jshint eqeqeq: true */

          // Don't check non-elements (#13208)
          // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
          if ( cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click") ) {
            matches = [];
            for ( i = 0; i < delegateCount; i++ ) {
              handleObj = handlers[ i ];

              // Don't conflict with Object.prototype properties (#13203)
              sel = handleObj.selector + " ";

              if ( matches[ sel ] === undefined ) {
                matches[ sel ] = handleObj.needsContext ?
                  jQuery( sel, this ).index( cur ) >= 0 :
                  jQuery.find( sel, this, null, [ cur ] ).length;
              }
              if ( matches[ sel ] ) {
                matches.push( handleObj );
              }
            }
            if ( matches.length ) {
              handlerQueue.push({ elem: cur, handlers: matches });
            }
          }
        }
      }

      // Add the remaining (directly-bound) handlers
      if ( delegateCount < handlers.length ) {
        handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
      }

      return handlerQueue;
    },

    fix: function ( event ) {
      if ( event[ jQuery.expando ] ) {
        return event;
      }

      // Create a writable copy of the event object and normalize some properties
      var i, prop, copy,
        type = event.type,
        originalEvent = event,
        fixHook = this.fixHooks[ type ];

      if ( !fixHook ) {
        this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				  rkeyEvent.test( type ) ? this.keyHooks :
				    {};
      }
      copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

      event = new jQuery.Event( originalEvent );

      i = copy.length;
      while ( i-- ) {
        prop = copy[ i ];
        event[ prop ] = originalEvent[ prop ];
      }

      // Support: IE<9
      // Fix target property (#1925)
      if ( !event.target ) {
        event.target = originalEvent.srcElement || document;
      }

      // Support: Chrome 23+, Safari?
      // Target should not be a text node (#504, #13143)
      if ( event.target.nodeType === 3 ) {
        event.target = event.target.parentNode;
      }

      // Support: IE<9
      // For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
      event.metaKey = !!event.metaKey;

      return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
    },

    // Includes some event props shared by KeyEvent and MouseEvent
    props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

    fixHooks: {},

    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function ( event, original ) {

        // Add which for key events
        if ( event.which == null ) {
          event.which = original.charCode != null ? original.charCode : original.keyCode;
        }

        return event;
      }
    },

    mouseHooks: {
      props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
      filter: function ( event, original ) {
        var body, eventDoc, doc,
          button = original.button,
          fromElement = original.fromElement;

        // Calculate pageX/Y if missing and clientX/Y available
        if ( event.pageX == null && original.clientX != null ) {
          eventDoc = event.target.ownerDocument || document;
          doc = eventDoc.documentElement;
          body = eventDoc.body;

          event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
          event.pageY = original.clientY + ( doc && doc.scrollTop || body && body.scrollTop || 0 ) - ( doc && doc.clientTop || body && body.clientTop || 0 );
        }

        // Add relatedTarget, if necessary
        if ( !event.relatedTarget && fromElement ) {
          event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
        }

        // Add which for click: 1 === left; 2 === middle; 3 === right
        // Note: button is not normalized, so don't use it
        if ( !event.which && button !== undefined ) {
          event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
        }

        return event;
      }
    },

    special: {
      load: {
        // Prevent triggered image.load events from bubbling to window.load
        noBubble: true
      },
      focus: {
        // Fire native event if possible so blur/focus sequence is correct
        trigger: function () {
          if ( this !== safeActiveElement() && this.focus ) {
            try {
              this.focus();
              return false;
            } catch ( e ) {
              // Support: IE<9
              // If we error on focus to hidden element (#1486, #12518),
              // let .trigger() run the handlers
            }
          }
        },
        delegateType: "focusin"
      },
      blur: {
        trigger: function () {
          if ( this === safeActiveElement() && this.blur ) {
            this.blur();
            return false;
          }
        },
        delegateType: "focusout"
      },
      click: {
        // For checkbox, fire native event so checked state will be right
        trigger: function () {
          if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
            this.click();
            return false;
          }
        },

        // For cross-browser consistency, don't fire native .click() on links
        _default: function ( event ) {
          return jQuery.nodeName( event.target, "a" );
        }
      },

      beforeunload: {
        postDispatch: function ( event ) {

          // Support: Firefox 20+
          // Firefox doesn't alert if the returnValue field is not set.
          if ( event.result !== undefined && event.originalEvent ) {
            event.originalEvent.returnValue = event.result;
          }
        }
      }
    },

    simulate: function ( type, elem, event, bubble ) {
      // Piggyback on a donor event to simulate a different one.
      // Fake originalEvent to avoid donor's stopPropagation, but if the
      // simulated event prevents default then we do the same on the donor.
      var e = jQuery.extend(
        new jQuery.Event(),
        event,
        {
          type: type,
          isSimulated: true,
          originalEvent: {}
        }
      );
      if ( bubble ) {
        jQuery.event.trigger( e, null, elem );
      } else {
        jQuery.event.dispatch.call( elem, e );
      }
      if ( e.isDefaultPrevented() ) {
        event.preventDefault();
      }
    }
  };

  jQuery.removeEvent = document.removeEventListener ?
    function ( elem, type, handle ) {
      if ( elem.removeEventListener ) {
        elem.removeEventListener( type, handle, false );
      }
    } :
    function ( elem, type, handle ) {
      var name = "on" + type;

      if ( elem.detachEvent ) {

        // #8545, #7054, preventing memory leaks for custom events in IE6-8
        // detachEvent needed property on element, by name of that event, to properly expose it to GC
        if ( typeof elem[ name ] === strundefined ) {
          elem[ name ] = null;
        }

        elem.detachEvent( name, handle );
      }
    };

  jQuery.Event = function ( src, props ) {
    // Allow instantiation without the 'new' keyword
    if ( !(this instanceof jQuery.Event) ) {
      return new jQuery.Event( src, props );
    }

    // Event object
    if ( src && src.type ) {
      this.originalEvent = src;
      this.type = src.type;

      // Events bubbling up the document may have been marked as prevented
      // by a handler lower down the tree; reflect the correct value.
      this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: IE < 9, Android < 4.0
				src.returnValue === false ?
        returnTrue :
        returnFalse;

      // Event type
    } else {
      this.type = src;
    }

    // Put explicitly provided properties onto the event object
    if ( props ) {
      jQuery.extend( this, props );
    }

    // Create a timestamp if incoming event doesn't have one
    this.timeStamp = src && src.timeStamp || jQuery.now();

    // Mark it as fixed
    this[ jQuery.expando ] = true;
  };

  // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
  // http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
  jQuery.Event.prototype = {
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,

    preventDefault: function () {
      var e = this.originalEvent;

      this.isDefaultPrevented = returnTrue;
      if ( !e ) {
        return;
      }

      // If preventDefault exists, run it on the original event
      if ( e.preventDefault ) {
        e.preventDefault();

        // Support: IE
        // Otherwise set the returnValue property of the original event to false
      } else {
        e.returnValue = false;
      }
    },
    stopPropagation: function () {
      var e = this.originalEvent;

      this.isPropagationStopped = returnTrue;
      if ( !e ) {
        return;
      }
      // If stopPropagation exists, run it on the original event
      if ( e.stopPropagation ) {
        e.stopPropagation();
      }

      // Support: IE
      // Set the cancelBubble property of the original event to true
      e.cancelBubble = true;
    },
    stopImmediatePropagation: function () {
      var e = this.originalEvent;

      this.isImmediatePropagationStopped = returnTrue;

      if ( e && e.stopImmediatePropagation ) {
        e.stopImmediatePropagation();
      }

      this.stopPropagation();
    }
  };

  // Create mouseenter/leave events using mouseover/out and event-time checks
  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function ( orig, fix ) {
    jQuery.event.special[ orig ] = {
      delegateType: fix,
      bindType: fix,

      handle: function ( event ) {
        var ret,
          target = this,
          related = event.relatedTarget,
          handleObj = event.handleObj;

        // For mousenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply( this, arguments );
          event.type = fix;
        }
        return ret;
      }
    };
  });

  // IE submit delegation
  if ( !support.submitBubbles ) {

    jQuery.event.special.submit = {
      setup: function () {
        // Only need this for delegated form submit events
        if ( jQuery.nodeName( this, "form" ) ) {
          return false;
        }

        // Lazy-add a submit handler when a descendant form may potentially be submitted
        jQuery.event.add( this, "click._submit keypress._submit", function ( e ) {
          // Node name check avoids a VML-related crash in IE (#9807)
          var elem = e.target,
            form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
          if ( form && !jQuery._data( form, "submitBubbles" ) ) {
            jQuery.event.add( form, "submit._submit", function ( event ) {
              event._submit_bubble = true;
            });
            jQuery._data( form, "submitBubbles", true );
          }
        });
        // return undefined since we don't need an event listener
      },

      postDispatch: function ( event ) {
        // If form was submitted by the user, bubble the event up the tree
        if ( event._submit_bubble ) {
          delete event._submit_bubble;
          if ( this.parentNode && !event.isTrigger ) {
            jQuery.event.simulate( "submit", this.parentNode, event, true );
          }
        }
      },

      teardown: function () {
        // Only need this for delegated form submit events
        if ( jQuery.nodeName( this, "form" ) ) {
          return false;
        }

        // Remove delegated handlers; cleanData eventually reaps submit handlers attached above
        jQuery.event.remove( this, "._submit" );
      }
    };
  }

  // IE change delegation and checkbox/radio fix
  if ( !support.changeBubbles ) {

    jQuery.event.special.change = {

      setup: function () {

        if ( rformElems.test( this.nodeName ) ) {
          // IE doesn't fire change on a check/radio until blur; trigger it on click
          // after a propertychange. Eat the blur-change in special.change.handle.
          // This still fires onchange a second time for check/radio after blur.
          if ( this.type === "checkbox" || this.type === "radio" ) {
            jQuery.event.add( this, "propertychange._change", function ( event ) {
              if ( event.originalEvent.propertyName === "checked" ) {
                this._just_changed = true;
              }
            });
            jQuery.event.add( this, "click._change", function ( event ) {
              if ( this._just_changed && !event.isTrigger ) {
                this._just_changed = false;
              }
              // Allow triggered, simulated change events (#11500)
              jQuery.event.simulate( "change", this, event, true );
            });
          }
          return false;
        }
        // Delegated event; lazy-add a change handler on descendant inputs
        jQuery.event.add( this, "beforeactivate._change", function ( e ) {
          var elem = e.target;

          if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "changeBubbles" ) ) {
            jQuery.event.add( elem, "change._change", function ( event ) {
              if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
                jQuery.event.simulate( "change", this.parentNode, event, true );
              }
            });
            jQuery._data( elem, "changeBubbles", true );
          }
        });
      },

      handle: function ( event ) {
        var elem = event.target;

        // Swallow native change events from checkbox/radio, we already triggered them above
        if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
          return event.handleObj.handler.apply( this, arguments );
        }
      },

      teardown: function () {
        jQuery.event.remove( this, "._change" );

        return !rformElems.test( this.nodeName );
      }
    };
  }

  // Create "bubbling" focus and blur events
  if ( !support.focusinBubbles ) {
    jQuery.each({ focus: "focusin", blur: "focusout" }, function ( orig, fix ) {

      // Attach a single capturing handler on the document while someone wants focusin/focusout
      var handler = function ( event ) {
        jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
      };

      jQuery.event.special[ fix ] = {
        setup: function () {
          var doc = this.ownerDocument || this,
            attaches = jQuery._data( doc, fix );

          if ( !attaches ) {
            doc.addEventListener( orig, handler, true );
          }
          jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
        },
        teardown: function () {
          var doc = this.ownerDocument || this,
            attaches = jQuery._data( doc, fix ) - 1;

          if ( !attaches ) {
            doc.removeEventListener( orig, handler, true );
            jQuery._removeData( doc, fix );
          } else {
            jQuery._data( doc, fix, attaches );
          }
        }
      };
    });
  }

  jQuery.fn.extend({

    on: function ( types, selector, data, fn, /* INTERNAL*/ one ) {
      var type, origFn;

      // Types can be a map of types/handlers
      if ( typeof types === "object" ) {
        // ( types-Object, selector, data )
        if ( typeof selector !== "string" ) {
          // ( types-Object, data )
          data = data || selector;
          selector = undefined;
        }
        for ( type in types ) {
          this.on( type, selector, data, types[ type ], one );
        }
        return this;
      }

      if ( data == null && fn == null ) {
        // ( types, fn )
        fn = selector;
        data = selector = undefined;
      } else if ( fn == null ) {
        if ( typeof selector === "string" ) {
          // ( types, selector, fn )
          fn = data;
          data = undefined;
        } else {
          // ( types, data, fn )
          fn = data;
          data = selector;
          selector = undefined;
        }
      }
      if ( fn === false ) {
        fn = returnFalse;
      } else if ( !fn ) {
        return this;
      }

      if ( one === 1 ) {
        origFn = fn;
        fn = function ( event ) {
          // Can use an empty set, since event contains the info
          jQuery().off( event );
          return origFn.apply( this, arguments );
        };
        // Use same guid so caller can remove using origFn
        fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
      }
      return this.each( function () {
        jQuery.event.add( this, types, fn, data, selector );
      });
    },
    one: function ( types, selector, data, fn ) {
      return this.on( types, selector, data, fn, 1 );
    },
    off: function ( types, selector, fn ) {
      var handleObj, type;
      if ( types && types.preventDefault && types.handleObj ) {
        // ( event )  dispatched jQuery.Event
        handleObj = types.handleObj;
        jQuery( types.delegateTarget ).off(
          handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
          handleObj.selector,
          handleObj.handler
        );
        return this;
      }
      if ( typeof types === "object" ) {
        // ( types-object [, selector] )
        for ( type in types ) {
          this.off( type, selector, types[ type ] );
        }
        return this;
      }
      if ( selector === false || typeof selector === "function" ) {
        // ( types [, fn] )
        fn = selector;
        selector = undefined;
      }
      if ( fn === false ) {
        fn = returnFalse;
      }
      return this.each(function () {
        jQuery.event.remove( this, types, fn, selector );
      });
    },

    trigger: function ( type, data ) {
      return this.each(function () {
        jQuery.event.trigger( type, data, this );
      });
    },
    triggerHandler: function ( type, data ) {
      var elem = this[0];
      if ( elem ) {
        return jQuery.event.trigger( type, data, elem, true );
      }
    }
  });

  function createSafeFragment( document ) {
    var list = nodeNames.split( "|" ),
      safeFrag = document.createDocumentFragment();

    if ( safeFrag.createElement ) {
      while ( list.length ) {
        safeFrag.createElement(
          list.pop()
        );
      }
    }
    return safeFrag;
  }

  var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
		"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
    rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
    rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
    rleadingWhitespace = /^\s+/,
    rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
    rtagName = /<([\w:]+)/,
    rtbody = /<tbody/i,
    rhtml = /<|&#?\w+;/,
    rnoInnerhtml = /<(?:script|style|link)/i,
    // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
    rscriptType = /^$|\/(?:java|ecma)script/i,
    rscriptTypeMasked = /^true\/(.*)/,
    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

    // We have to close these tags to support XHTML (#13200)
    wrapMap = {
      option: [ 1, "<select multiple='multiple'>", "</select>" ],
      legend: [ 1, "<fieldset>", "</fieldset>" ],
      area: [ 1, "<map>", "</map>" ],
      param: [ 1, "<object>", "</object>" ],
      thead: [ 1, "<table>", "</table>" ],
      tr: [ 2, "<table><tbody>", "</tbody></table>" ],
      col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
      td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

      // IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
      // unless wrapped in a div with non-breaking characters in front of it.
      _default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
    },
    safeFragment = createSafeFragment( document ),
    fragmentDiv = safeFragment.appendChild( document.createElement("div") );

  wrapMap.optgroup = wrapMap.option;
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  function getAll( context, tag ) {
    var elems, elem,
      i = 0,
      found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName( tag || "*" ) :
        typeof context.querySelectorAll !== strundefined ? context.querySelectorAll( tag || "*" ) :
          undefined;

    if ( !found ) {
      for ( found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++ ) {
        if ( !tag || jQuery.nodeName( elem, tag ) ) {
          found.push( elem );
        } else {
          jQuery.merge( found, getAll( elem, tag ) );
        }
      }
    }

    return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
      jQuery.merge( [ context ], found ) :
      found;
  }

  // Used in buildFragment, fixes the defaultChecked property
  function fixDefaultChecked( elem ) {
    if ( rcheckableType.test( elem.type ) ) {
      elem.defaultChecked = elem.checked;
    }
  }

  // Support: IE<8
  // Manipulating tables requires a tbody
  function manipulationTarget( elem, content ) {
    return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

      elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
      elem;
  }

  // Replace/restore the type attribute of script elements for safe DOM manipulation
  function disableScript( elem ) {
    elem.type = (jQuery.find.attr( elem, "type" ) !== null) + "/" + elem.type;
    return elem;
  }
  function restoreScript( elem ) {
    var match = rscriptTypeMasked.exec( elem.type );
    if ( match ) {
      elem.type = match[1];
    } else {
      elem.removeAttribute("type");
    }
    return elem;
  }

  // Mark scripts as having already been evaluated
  function setGlobalEval( elems, refElements ) {
    var elem,
      i = 0;
    for ( ; (elem = elems[i]) != null; i++ ) {
      jQuery._data( elem, "globalEval", !refElements || jQuery._data( refElements[i], "globalEval" ) );
    }
  }

  function cloneCopyEvent( src, dest ) {

    if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
      return;
    }

    var type, i, l,
      oldData = jQuery._data( src ),
      curData = jQuery._data( dest, oldData ),
      events = oldData.events;

    if ( events ) {
      delete curData.handle;
      curData.events = {};

      for ( type in events ) {
        for ( i = 0, l = events[ type ].length; i < l; i++ ) {
          jQuery.event.add( dest, type, events[ type ][ i ] );
        }
      }
    }

    // make the cloned public data object a copy from the original
    if ( curData.data ) {
      curData.data = jQuery.extend( {}, curData.data );
    }
  }

  function fixCloneNodeIssues( src, dest ) {
    var nodeName, e, data;

    // We do not need to do anything for non-Elements
    if ( dest.nodeType !== 1 ) {
      return;
    }

    nodeName = dest.nodeName.toLowerCase();

    // IE6-8 copies events bound via attachEvent when using cloneNode.
    if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
      data = jQuery._data( dest );

      for ( e in data.events ) {
        jQuery.removeEvent( dest, e, data.handle );
      }

      // Event data gets referenced instead of copied if the expando gets copied too
      dest.removeAttribute( jQuery.expando );
    }

    // IE blanks contents when cloning scripts, and tries to evaluate newly-set text
    if ( nodeName === "script" && dest.text !== src.text ) {
      disableScript( dest ).text = src.text;
      restoreScript( dest );

      // IE6-10 improperly clones children of object elements using classid.
      // IE10 throws NoModificationAllowedError if parent is null, #12132.
    } else if ( nodeName === "object" ) {
      if ( dest.parentNode ) {
        dest.outerHTML = src.outerHTML;
      }

      // This path appears unavoidable for IE9. When cloning an object
      // element in IE9, the outerHTML strategy above is not sufficient.
      // If the src has innerHTML and the destination does not,
      // copy the src.innerHTML into the dest.innerHTML. #10324
      if ( support.html5Clone && ( src.innerHTML && !jQuery.trim(dest.innerHTML) ) ) {
        dest.innerHTML = src.innerHTML;
      }

    } else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
      // IE6-8 fails to persist the checked state of a cloned checkbox
      // or radio button. Worse, IE6-7 fail to give the cloned element
      // a checked appearance if the defaultChecked value isn't also set

      dest.defaultChecked = dest.checked = src.checked;

      // IE6-7 get confused and end up setting the value of a cloned
      // checkbox/radio button to an empty string instead of "on"
      if ( dest.value !== src.value ) {
        dest.value = src.value;
      }

      // IE6-8 fails to return the selected option to the default selected
      // state when cloning options
    } else if ( nodeName === "option" ) {
      dest.defaultSelected = dest.selected = src.defaultSelected;

      // IE6-8 fails to set the defaultValue to the correct value when
      // cloning other types of input fields
    } else if ( nodeName === "input" || nodeName === "textarea" ) {
      dest.defaultValue = src.defaultValue;
    }
  }

  jQuery.extend({
    clone: function ( elem, dataAndEvents, deepDataAndEvents ) {
      var destElements, node, clone, i, srcElements,
        inPage = jQuery.contains( elem.ownerDocument, elem );

      if ( support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
        clone = elem.cloneNode( true );

        // IE<=8 does not properly clone detached, unknown element nodes
      } else {
        fragmentDiv.innerHTML = elem.outerHTML;
        fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
      }

      if ( (!support.noCloneEvent || !support.noCloneChecked) &&
				(elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {

        // We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
        destElements = getAll( clone );
        srcElements = getAll( elem );

        // Fix all IE cloning issues
        for ( i = 0; (node = srcElements[i]) != null; ++i ) {
          // Ensure that the destination node is not null; Fixes #9587
          if ( destElements[i] ) {
            fixCloneNodeIssues( node, destElements[i] );
          }
        }
      }

      // Copy the events from the original to the clone
      if ( dataAndEvents ) {
        if ( deepDataAndEvents ) {
          srcElements = srcElements || getAll( elem );
          destElements = destElements || getAll( clone );

          for ( i = 0; (node = srcElements[i]) != null; i++ ) {
            cloneCopyEvent( node, destElements[i] );
          }
        } else {
          cloneCopyEvent( elem, clone );
        }
      }

      // Preserve script evaluation history
      destElements = getAll( clone, "script" );
      if ( destElements.length > 0 ) {
        setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
      }

      destElements = srcElements = node = null;

      // Return the cloned set
      return clone;
    },

    buildFragment: function ( elems, context, scripts, selection ) {
      var j, elem, contains,
        tmp, tag, tbody, wrap,
        l = elems.length,

        // Ensure a safe fragment
        safe = createSafeFragment( context ),

        nodes = [],
        i = 0;

      for ( ; i < l; i++ ) {
        elem = elems[ i ];

        if ( elem || elem === 0 ) {

          // Add nodes directly
          if ( jQuery.type( elem ) === "object" ) {
            jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

            // Convert non-html into a text node
          } else if ( !rhtml.test( elem ) ) {
            nodes.push( context.createTextNode( elem ) );

            // Convert html into DOM nodes
          } else {
            tmp = tmp || safe.appendChild( context.createElement("div") );

            // Deserialize a standard representation
            tag = (rtagName.exec( elem ) || [ "", "" ])[ 1 ].toLowerCase();
            wrap = wrapMap[ tag ] || wrapMap._default;

            tmp.innerHTML = wrap[1] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[2];

            // Descend through wrappers to the right content
            j = wrap[0];
            while ( j-- ) {
              tmp = tmp.lastChild;
            }

            // Manually add leading whitespace removed by IE
            if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
              nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[0] ) );
            }

            // Remove IE's autoinserted <tbody> from table fragments
            if ( !support.tbody ) {

              // String was a <table>, *may* have spurious <tbody>
              elem = tag === "table" && !rtbody.test( elem ) ?
                tmp.firstChild :

              // String was a bare <thead> or <tfoot>
                wrap[1] === "<table>" && !rtbody.test( elem ) ?
                  tmp :
                  0;

              j = elem && elem.childNodes.length;
              while ( j-- ) {
                if ( jQuery.nodeName( (tbody = elem.childNodes[j]), "tbody" ) && !tbody.childNodes.length ) {
                  elem.removeChild( tbody );
                }
              }
            }

            jQuery.merge( nodes, tmp.childNodes );

            // Fix #12392 for WebKit and IE > 9
            tmp.textContent = "";

            // Fix #12392 for oldIE
            while ( tmp.firstChild ) {
              tmp.removeChild( tmp.firstChild );
            }

            // Remember the top-level container for proper cleanup
            tmp = safe.lastChild;
          }
        }
      }

      // Fix #11356: Clear elements from fragment
      if ( tmp ) {
        safe.removeChild( tmp );
      }

      // Reset defaultChecked for any radios and checkboxes
      // about to be appended to the DOM in IE 6/7 (#8060)
      if ( !support.appendChecked ) {
        jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
      }

      i = 0;
      while ( (elem = nodes[ i++ ]) ) {

        // #4087 - If origin and destination elements are the same, and this is
        // that element, do not do anything
        if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
          continue;
        }

        contains = jQuery.contains( elem.ownerDocument, elem );

        // Append to fragment
        tmp = getAll( safe.appendChild( elem ), "script" );

        // Preserve script evaluation history
        if ( contains ) {
          setGlobalEval( tmp );
        }

        // Capture executables
        if ( scripts ) {
          j = 0;
          while ( (elem = tmp[ j++ ]) ) {
            if ( rscriptType.test( elem.type || "" ) ) {
              scripts.push( elem );
            }
          }
        }
      }

      tmp = null;

      return safe;
    },

    cleanData: function ( elems, /* internal */ acceptData ) {
      var elem, type, id, data,
        i = 0,
        internalKey = jQuery.expando,
        cache = jQuery.cache,
        deleteExpando = support.deleteExpando,
        special = jQuery.event.special;

      for ( ; (elem = elems[i]) != null; i++ ) {
        if ( acceptData || jQuery.acceptData( elem ) ) {

          id = elem[ internalKey ];
          data = id && cache[ id ];

          if ( data ) {
            if ( data.events ) {
              for ( type in data.events ) {
                if ( special[ type ] ) {
                  jQuery.event.remove( elem, type );

                  // This is a shortcut to avoid jQuery.event.remove's overhead
                } else {
                  jQuery.removeEvent( elem, type, data.handle );
                }
              }
            }

            // Remove cache only if it was not already removed by jQuery.event.remove
            if ( cache[ id ] ) {

              delete cache[ id ];

              // IE does not allow us to delete expando properties from nodes,
              // nor does it have a removeAttribute function on Document nodes;
              // we must handle all of these cases
              if ( deleteExpando ) {
                delete elem[ internalKey ];

              } else if ( typeof elem.removeAttribute !== strundefined ) {
                elem.removeAttribute( internalKey );

              } else {
                elem[ internalKey ] = null;
              }

              deletedIds.push( id );
            }
          }
        }
      }
    }
  });

  jQuery.fn.extend({
    text: function ( value ) {
      return access( this, function ( value ) {
        return value === undefined ?
          jQuery.text( this ) :
          this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
      }, null, value, arguments.length );
    },

    append: function () {
      return this.domManip( arguments, function ( elem ) {
        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
          var target = manipulationTarget( this, elem );
          target.appendChild( elem );
        }
      });
    },

    prepend: function () {
      return this.domManip( arguments, function ( elem ) {
        if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
          var target = manipulationTarget( this, elem );
          target.insertBefore( elem, target.firstChild );
        }
      });
    },

    before: function () {
      return this.domManip( arguments, function ( elem ) {
        if ( this.parentNode ) {
          this.parentNode.insertBefore( elem, this );
        }
      });
    },

    after: function () {
      return this.domManip( arguments, function ( elem ) {
        if ( this.parentNode ) {
          this.parentNode.insertBefore( elem, this.nextSibling );
        }
      });
    },

    remove: function ( selector, keepData /* Internal Use Only */ ) {
      var elem,
        elems = selector ? jQuery.filter( selector, this ) : this,
        i = 0;

      for ( ; (elem = elems[i]) != null; i++ ) {

        if ( !keepData && elem.nodeType === 1 ) {
          jQuery.cleanData( getAll( elem ) );
        }

        if ( elem.parentNode ) {
          if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
            setGlobalEval( getAll( elem, "script" ) );
          }
          elem.parentNode.removeChild( elem );
        }
      }

      return this;
    },

    empty: function () {
      var elem,
        i = 0;

      for ( ; (elem = this[i]) != null; i++ ) {
        // Remove element nodes and prevent memory leaks
        if ( elem.nodeType === 1 ) {
          jQuery.cleanData( getAll( elem, false ) );
        }

        // Remove any remaining nodes
        while ( elem.firstChild ) {
          elem.removeChild( elem.firstChild );
        }

        // If this is a select, ensure that it displays empty (#12336)
        // Support: IE<9
        if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
          elem.options.length = 0;
        }
      }

      return this;
    },

    clone: function ( dataAndEvents, deepDataAndEvents ) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

      return this.map(function () {
        return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
      });
    },

    html: function ( value ) {
      return access( this, function ( value ) {
        var elem = this[ 0 ] || {},
          i = 0,
          l = this.length;

        if ( value === undefined ) {
          return elem.nodeType === 1 ?
            elem.innerHTML.replace( rinlinejQuery, "" ) :
            undefined;
        }

        // See if we can take a shortcut and just use innerHTML
        if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value ) ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ (rtagName.exec( value ) || [ "", "" ])[ 1 ].toLowerCase() ] ) {

          value = value.replace( rxhtmlTag, "<$1></$2>" );

          try {
            for (; i < l; i++ ) {
              // Remove element nodes and prevent memory leaks
              elem = this[i] || {};
              if ( elem.nodeType === 1 ) {
                jQuery.cleanData( getAll( elem, false ) );
                elem.innerHTML = value;
              }
            }

            elem = 0;

            // If using innerHTML throws an exception, use the fallback method
          } catch (e) {}
        }

        if ( elem ) {
          this.empty().append( value );
        }
      }, null, value, arguments.length );
    },

    replaceWith: function () {
      var arg = arguments[ 0 ];

      // Make the changes, replacing each context element with the new content
      this.domManip( arguments, function ( elem ) {
        arg = this.parentNode;

        jQuery.cleanData( getAll( this ) );

        if ( arg ) {
          arg.replaceChild( elem, this );
        }
      });

      // Force removal if there was no new content (e.g., from empty arguments)
      return arg && (arg.length || arg.nodeType) ? this : this.remove();
    },

    detach: function ( selector ) {
      return this.remove( selector, true );
    },

    domManip: function ( args, callback ) {

      // Flatten any nested arrays
      args = concat.apply( [], args );

      var first, node, hasScripts,
        scripts, doc, fragment,
        i = 0,
        l = this.length,
        set = this,
        iNoClone = l - 1,
        value = args[0],
        isFunction = jQuery.isFunction( value );

      // We can't cloneNode fragments that contain checked, in WebKit
      if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
        return this.each(function ( index ) {
          var self = set.eq( index );
          if ( isFunction ) {
            args[0] = value.call( this, index, self.html() );
          }
          self.domManip( args, callback );
        });
      }

      if ( l ) {
        fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
        first = fragment.firstChild;

        if ( fragment.childNodes.length === 1 ) {
          fragment = first;
        }

        if ( first ) {
          scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
          hasScripts = scripts.length;

          // Use the original fragment for the last item instead of the first because it can end up
          // being emptied incorrectly in certain situations (#8070).
          for ( ; i < l; i++ ) {
            node = fragment;

            if ( i !== iNoClone ) {
              node = jQuery.clone( node, true, true );

              // Keep references to cloned scripts for later restoration
              if ( hasScripts ) {
                jQuery.merge( scripts, getAll( node, "script" ) );
              }
            }

            callback.call( this[i], node, i );
          }

          if ( hasScripts ) {
            doc = scripts[ scripts.length - 1 ].ownerDocument;

            // Reenable scripts
            jQuery.map( scripts, restoreScript );

            // Evaluate executable scripts on first document insertion
            for ( i = 0; i < hasScripts; i++ ) {
              node = scripts[ i ];
              if ( rscriptType.test( node.type || "" ) &&
							!jQuery._data( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

                if ( node.src ) {
                  // Optional AJAX dependency, but won't run scripts if not present
                  if ( jQuery._evalUrl ) {
                    jQuery._evalUrl( node.src );
                  }
                } else {
                  jQuery.globalEval( ( node.text || node.textContent || node.innerHTML || "" ).replace( rcleanScript, "" ) );
                }
              }
            }
          }

          // Fix #11809: Avoid leaking memory
          fragment = first = null;
        }
      }

      return this;
    }
  });

  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function ( name, original ) {
    jQuery.fn[ name ] = function ( selector ) {
      var elems,
        i = 0,
        ret = [],
        insert = jQuery( selector ),
        last = insert.length - 1;

      for ( ; i <= last; i++ ) {
        elems = i === last ? this : this.clone(true);
        jQuery( insert[i] )[ original ]( elems );

        // Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
        push.apply( ret, elems.get() );
      }

      return this.pushStack( ret );
    };
  });

  var iframe,
    elemdisplay = {};

  /**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
  // Called only from within defaultDisplay
  function actualDisplay( name, doc ) {
    var style,
      elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

      // getDefaultComputedStyle might be reliably used only on attached element
      display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

      // Use of this method is a temporary fix (more like optmization) until something better comes along,
      // since it was removed from specification and supported only in FF
        style.display : jQuery.css( elem[ 0 ], "display" );

    // We don't have any data stored on the element,
    // so use "detach" method as fast way to get rid of the element
    elem.detach();

    return display;
  }

  /**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
  function defaultDisplay( nodeName ) {
    var doc = document,
      display = elemdisplay[ nodeName ];

    if ( !display ) {
      display = actualDisplay( nodeName, doc );

      // If the simple way fails, read from inside an iframe
      if ( display === "none" || !display ) {

        // Use the already-created iframe if possible
        iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

        // Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
        doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

        // Support: IE
        doc.write();
        doc.close();

        display = actualDisplay( nodeName, doc );
        iframe.detach();
      }

      // Store the correct default display
      elemdisplay[ nodeName ] = display;
    }

    return display;
  }

  (function () {
    var shrinkWrapBlocksVal;

    support.shrinkWrapBlocks = function () {
      if ( shrinkWrapBlocksVal != null ) {
        return shrinkWrapBlocksVal;
      }

      // Will be changed later if needed.
      shrinkWrapBlocksVal = false;

      // Minified: var b,c,d
      var div, body, container;

      body = document.getElementsByTagName( "body" )[ 0 ];
      if ( !body || !body.style ) {
        // Test fired too early or in an unsupported environment, exit.
        return;
      }

      // Setup
      div = document.createElement( "div" );
      container = document.createElement( "div" );
      container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
      body.appendChild( container ).appendChild( div );

      // Support: IE6
      // Check if elements with layout shrink-wrap their children
      if ( typeof div.style.zoom !== strundefined ) {
        // Reset CSS: box-sizing; display; margin; border
        div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;" +
				"padding:1px;width:1px;zoom:1";
        div.appendChild( document.createElement( "div" ) ).style.width = "5px";
        shrinkWrapBlocksVal = div.offsetWidth !== 3;
      }

      body.removeChild( container );

      return shrinkWrapBlocksVal;
    };

  })();
  var rmargin = (/^margin/);

  var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

  var getStyles, curCSS,
    rposition = /^(top|right|bottom|left)$/;

  if ( window.getComputedStyle ) {
    getStyles = function ( elem ) {
      // Support: IE<=11+, Firefox<=30+ (#15098, #14150)
      // IE throws on elements created in popups
      // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
      if ( elem.ownerDocument.defaultView.opener ) {
        return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
      }

      return window.getComputedStyle( elem, null );
    };

    curCSS = function ( elem, name, computed ) {
      var width, minWidth, maxWidth, ret,
        style = elem.style;

      computed = computed || getStyles( elem );

      // getPropertyValue is only needed for .css('filter') in IE9, see #12537
      ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

      if ( computed ) {

        if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
          ret = jQuery.style( elem, name );
        }

        // A tribute to the "awesome hack by Dean Edwards"
        // Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
        // Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
        // this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
        if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

          // Remember the original values
          width = style.width;
          minWidth = style.minWidth;
          maxWidth = style.maxWidth;

          // Put in the new values to get a computed value out
          style.minWidth = style.maxWidth = style.width = ret;
          ret = computed.width;

          // Revert the changed values
          style.width = width;
          style.minWidth = minWidth;
          style.maxWidth = maxWidth;
        }
      }

      // Support: IE
      // IE returns zIndex value as an integer.
      return ret === undefined ?
        ret :
        ret + "";
    };
  } else if ( document.documentElement.currentStyle ) {
    getStyles = function ( elem ) {
      return elem.currentStyle;
    };

    curCSS = function ( elem, name, computed ) {
      var left, rs, rsLeft, ret,
        style = elem.style;

      computed = computed || getStyles( elem );
      ret = computed ? computed[ name ] : undefined;

      // Avoid setting ret to empty string here
      // so we don't default to auto
      if ( ret == null && style && style[ name ] ) {
        ret = style[ name ];
      }

      // From the awesome hack by Dean Edwards
      // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

      // If we're not dealing with a regular pixel number
      // but a number that has a weird ending, we need to convert it to pixels
      // but not position css attributes, as those are proportional to the parent element instead
      // and we can't measure the parent instead because it might trigger a "stacking dolls" problem
      if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

        // Remember the original values
        left = style.left;
        rs = elem.runtimeStyle;
        rsLeft = rs && rs.left;

        // Put in the new values to get a computed value out
        if ( rsLeft ) {
          rs.left = elem.currentStyle.left;
        }
        style.left = name === "fontSize" ? "1em" : ret;
        ret = style.pixelLeft + "px";

        // Revert the changed values
        style.left = left;
        if ( rsLeft ) {
          rs.left = rsLeft;
        }
      }

      // Support: IE
      // IE returns zIndex value as an integer.
      return ret === undefined ?
        ret :
        ret + "" || "auto";
    };
  }

  function addGetHookIf( conditionFn, hookFn ) {
    // Define the hook, we'll check on the first run if it's really needed.
    return {
      get: function () {
        var condition = conditionFn();

        if ( condition == null ) {
          // The test was not ready at this point; screw the hook this time
          // but check again when needed next time.
          return;
        }

        if ( condition ) {
          // Hook not needed (or it's not possible to use it due to missing dependency),
          // remove it.
          // Since there are no other hooks for marginRight, remove the whole object.
          delete this.get;
          return;
        }

        // Hook needed; redefine it so that the support test is not executed again.

        return (this.get = hookFn).apply( this, arguments );
      }
    };
  }

  (function () {
    // Minified: var b,c,d,e,f,g, h,i
    var div, style, a, pixelPositionVal, boxSizingReliableVal,
      reliableHiddenOffsetsVal, reliableMarginRightVal;

    // Setup
    div = document.createElement( "div" );
    div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
    a = div.getElementsByTagName( "a" )[ 0 ];
    style = a && a.style;

    // Finish early in limited (non-browser) environments
    if ( !style ) {
      return;
    }

    style.cssText = "float:left;opacity:.5";

    // Support: IE<9
    // Make sure that element opacity exists (as opposed to filter)
    support.opacity = style.opacity === "0.5";

    // Verify style float existence
    // (IE uses styleFloat instead of cssFloat)
    support.cssFloat = !!style.cssFloat;

    div.style.backgroundClip = "content-box";
    div.cloneNode( true ).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";

    // Support: Firefox<29, Android 2.3
    // Vendor-prefix box-sizing
    support.boxSizing = style.boxSizing === "" || style.MozBoxSizing === "" ||
		style.WebkitBoxSizing === "";

    jQuery.extend(support, {
      reliableHiddenOffsets: function () {
        if ( reliableHiddenOffsetsVal == null ) {
          computeStyleTests();
        }
        return reliableHiddenOffsetsVal;
      },

      boxSizingReliable: function () {
        if ( boxSizingReliableVal == null ) {
          computeStyleTests();
        }
        return boxSizingReliableVal;
      },

      pixelPosition: function () {
        if ( pixelPositionVal == null ) {
          computeStyleTests();
        }
        return pixelPositionVal;
      },

      // Support: Android 2.3
      reliableMarginRight: function () {
        if ( reliableMarginRightVal == null ) {
          computeStyleTests();
        }
        return reliableMarginRightVal;
      }
    });

    function computeStyleTests() {
      // Minified: var b,c,d,j
      var div, body, container, contents;

      body = document.getElementsByTagName( "body" )[ 0 ];
      if ( !body || !body.style ) {
        // Test fired too early or in an unsupported environment, exit.
        return;
      }

      // Setup
      div = document.createElement( "div" );
      container = document.createElement( "div" );
      container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
      body.appendChild( container ).appendChild( div );

      div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";

      // Support: IE<9
      // Assume reasonable values in the absence of getComputedStyle
      pixelPositionVal = boxSizingReliableVal = false;
      reliableMarginRightVal = true;

      // Check for getComputedStyle so that this code is not run in IE<9.
      if ( window.getComputedStyle ) {
        pixelPositionVal = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
        boxSizingReliableVal =
				( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";

        // Support: Android 2.3
        // Div with explicit width and no margin-right incorrectly
        // gets computed margin-right based on width of container (#3333)
        // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
        contents = div.appendChild( document.createElement( "div" ) );

        // Reset CSS: box-sizing; display; margin; border; padding
        contents.style.cssText = div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
        contents.style.marginRight = contents.style.width = "0";
        div.style.width = "1px";

        reliableMarginRightVal =
				!parseFloat( ( window.getComputedStyle( contents, null ) || {} ).marginRight );

        div.removeChild( contents );
      }

      // Support: IE8
      // Check if table cells still have offsetWidth/Height when they are set
      // to display:none and there are still other visible table cells in a
      // table row; if so, offsetWidth/Height are not reliable for use when
      // determining if an element has been hidden directly using
      // display:none (it is still safe to use offsets if a parent element is
      // hidden; don safety goggles and see bug #4512 for more information).
      div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
      contents = div.getElementsByTagName( "td" );
      contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
      reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
      if ( reliableHiddenOffsetsVal ) {
        contents[ 0 ].style.display = "";
        contents[ 1 ].style.display = "none";
        reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
      }

      body.removeChild( container );
    }

  })();

  // A method for quickly swapping in/out CSS properties to get correct calculations.
  jQuery.swap = function ( elem, options, callback, args ) {
    var ret, name,
      old = {};

    // Remember the old values, and insert the new ones
    for ( name in options ) {
      old[ name ] = elem.style[ name ];
      elem.style[ name ] = options[ name ];
    }

    ret = callback.apply( elem, args || [] );

    // Revert the old values
    for ( name in options ) {
      elem.style[ name ] = old[ name ];
    }

    return ret;
  };

  var
    ralpha = /alpha\([^)]*\)/i,
    ropacity = /opacity\s*=\s*([^)]*)/,

    // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
    // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/,
    rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
    rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
    cssNormalTransform = {
      letterSpacing: "0",
      fontWeight: "400"
    },

    cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

  // return a css property mapped to a potentially vendor prefixed property
  function vendorPropName( style, name ) {

    // shortcut for names that are not vendor prefixed
    if ( name in style ) {
      return name;
    }

    // check for vendor prefixed names
    var capName = name.charAt(0).toUpperCase() + name.slice(1),
      origName = name,
      i = cssPrefixes.length;

    while ( i-- ) {
      name = cssPrefixes[ i ] + capName;
      if ( name in style ) {
        return name;
      }
    }

    return origName;
  }

  function showHide( elements, show ) {
    var display, elem, hidden,
      values = [],
      index = 0,
      length = elements.length;

    for ( ; index < length; index++ ) {
      elem = elements[ index ];
      if ( !elem.style ) {
        continue;
      }

      values[ index ] = jQuery._data( elem, "olddisplay" );
      display = elem.style.display;
      if ( show ) {
        // Reset the inline display of this element to learn if it is
        // being hidden by cascaded rules or not
        if ( !values[ index ] && display === "none" ) {
          elem.style.display = "";
        }

        // Set elements which have been overridden with display: none
        // in a stylesheet to whatever the default browser style is
        // for such an element
        if ( elem.style.display === "" && isHidden( elem ) ) {
          values[ index ] = jQuery._data( elem, "olddisplay", defaultDisplay(elem.nodeName) );
        }
      } else {
        hidden = isHidden( elem );

        if ( display && display !== "none" || !hidden ) {
          jQuery._data( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
        }
      }
    }

    // Set the display of most of the elements in a second loop
    // to avoid the constant reflow
    for ( index = 0; index < length; index++ ) {
      elem = elements[ index ];
      if ( !elem.style ) {
        continue;
      }
      if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
        elem.style.display = show ? values[ index ] || "" : "none";
      }
    }

    return elements;
  }

  function setPositiveNumber( elem, value, subtract ) {
    var matches = rnumsplit.exec( value );
    return matches ?
    // Guard against undefined "subtract", e.g., when used as in cssHooks
      Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
      value;
  }

  function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
    var i = extra === ( isBorderBox ? "border" : "content" ) ?
      // If we already have the right measurement, avoid augmentation
        4 :
      // Otherwise initialize for horizontal or vertical properties
        name === "width" ? 1 : 0,

      val = 0;

    for ( ; i < 4; i += 2 ) {
      // both box models exclude margin, so add it if we want it
      if ( extra === "margin" ) {
        val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
      }

      if ( isBorderBox ) {
        // border-box includes padding, so remove it if we want content
        if ( extra === "content" ) {
          val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
        }

        // at this point, extra isn't border nor margin, so remove border
        if ( extra !== "margin" ) {
          val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
        }
      } else {
        // at this point, extra isn't content, so add padding
        val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

        // at this point, extra isn't content nor padding, so add border
        if ( extra !== "padding" ) {
          val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
        }
      }
    }

    return val;
  }

  function getWidthOrHeight( elem, name, extra ) {

    // Start with offset property, which is equivalent to the border-box value
    var valueIsBorderBox = true,
      val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
      styles = getStyles( elem ),
      isBorderBox = support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

    // some non-html elements return undefined for offsetWidth, so check for null/undefined
    // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
    // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
    if ( val <= 0 || val == null ) {
      // Fall back to computed then uncomputed css if necessary
      val = curCSS( elem, name, styles );
      if ( val < 0 || val == null ) {
        val = elem.style[ name ];
      }

      // Computed unit is not pixels. Stop here and return.
      if ( rnumnonpx.test(val) ) {
        return val;
      }

      // we need the check for style in case a browser which returns unreliable values
      // for getComputedStyle silently falls back to the reliable elem.style
      valueIsBorderBox = isBorderBox && ( support.boxSizingReliable() || val === elem.style[ name ] );

      // Normalize "", auto, and prepare for extra
      val = parseFloat( val ) || 0;
    }

    // use the active box-sizing model to add/subtract irrelevant styles
    return ( val +
		augmentWidthOrHeight(
		  elem,
		  name,
		  extra || ( isBorderBox ? "border" : "content" ),
		  valueIsBorderBox,
		  styles
		)
    ) + "px";
  }

  jQuery.extend({
    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {
      opacity: {
        get: function ( elem, computed ) {
          if ( computed ) {
            // We should always get a number back from opacity
            var ret = curCSS( elem, "opacity" );
            return ret === "" ? "1" : ret;
          }
        }
      }
    },

    // Don't automatically add "px" to these possibly-unitless properties
    cssNumber: {
      "columnCount": true,
      "fillOpacity": true,
      "flexGrow": true,
      "flexShrink": true,
      "fontWeight": true,
      "lineHeight": true,
      "opacity": true,
      "order": true,
      "orphans": true,
      "widows": true,
      "zIndex": true,
      "zoom": true
    },

    // Add in properties whose names you wish to fix before
    // setting or getting the value
    cssProps: {
      // normalize float css property
      "float": support.cssFloat ? "cssFloat" : "styleFloat"
    },

    // Get and set the style property on a DOM Node
    style: function ( elem, name, value, extra ) {
      // Don't set styles on text and comment nodes
      if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
        return;
      }

      // Make sure that we're working with the right name
      var ret, type, hooks,
        origName = jQuery.camelCase( name ),
        style = elem.style;

      name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

      // gets hook for the prefixed version
      // followed by the unprefixed version
      hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

      // Check if we're setting a value
      if ( value !== undefined ) {
        type = typeof value;

        // convert relative number strings (+= or -=) to relative numbers. #7345
        if ( type === "string" && (ret = rrelNum.exec( value )) ) {
          value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
          // Fixes bug #9237
          type = "number";
        }

        // Make sure that null and NaN values aren't set. See: #7116
        if ( value == null || value !== value ) {
          return;
        }

        // If a number was passed in, add 'px' to the (except for certain CSS properties)
        if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
          value += "px";
        }

        // Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
        // but it would mean to define eight (for every problematic property) identical functions
        if ( !support.clearCloneStyle && value === "" && name.indexOf("background") === 0 ) {
          style[ name ] = "inherit";
        }

        // If a hook was provided, use that value, otherwise just set the specified value
        if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {

          // Support: IE
          // Swallow errors from 'invalid' CSS values (#5509)
          try {
            style[ name ] = value;
          } catch (e) {}
        }

      } else {
        // If a hook was provided get the non-computed value from there
        if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
          return ret;
        }

        // Otherwise just get the value from the style object
        return style[ name ];
      }
    },

    css: function ( elem, name, extra, styles ) {
      var num, val, hooks,
        origName = jQuery.camelCase( name );

      // Make sure that we're working with the right name
      name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

      // gets hook for the prefixed version
      // followed by the unprefixed version
      hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

      // If a hook was provided get the computed value from there
      if ( hooks && "get" in hooks ) {
        val = hooks.get( elem, true, extra );
      }

      // Otherwise, if a way to get the computed value exists, use that
      if ( val === undefined ) {
        val = curCSS( elem, name, styles );
      }

      // convert "normal" to computed value
      if ( val === "normal" && name in cssNormalTransform ) {
        val = cssNormalTransform[ name ];
      }

      // Return, converting to number if forced or a qualifier was provided and val looks numeric
      if ( extra === "" || extra ) {
        num = parseFloat( val );
        return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
      }
      return val;
    }
  });

  jQuery.each([ "height", "width" ], function ( i, name ) {
    jQuery.cssHooks[ name ] = {
      get: function ( elem, computed, extra ) {
        if ( computed ) {
          // certain elements can have dimension info if we invisibly show them
          // however, it must have a current display style that would benefit from this
          return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
            jQuery.swap( elem, cssShow, function () {
              return getWidthOrHeight( elem, name, extra );
            }) :
            getWidthOrHeight( elem, name, extra );
        }
      },

      set: function ( elem, value, extra ) {
        var styles = extra && getStyles( elem );
        return setPositiveNumber( elem, value, extra ?
          augmentWidthOrHeight(
            elem,
            name,
            extra,
            support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
            styles
          ) : 0
        );
      }
    };
  });

  if ( !support.opacity ) {
    jQuery.cssHooks.opacity = {
      get: function ( elem, computed ) {
        // IE uses filters for opacity
        return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
          ( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
          computed ? "1" : "";
      },

      set: function ( elem, value ) {
        var style = elem.style,
          currentStyle = elem.currentStyle,
          opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
          filter = currentStyle && currentStyle.filter || style.filter || "";

        // IE has trouble with opacity if it does not have layout
        // Force it by setting the zoom level
        style.zoom = 1;

        // if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
        // if value === "", then remove inline opacity #12685
        if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

          // Setting style.filter to null, "" & " " still leave "filter:" in the cssText
          // if "filter:" is present at all, clearType is disabled, we want to avoid this
          // style.removeAttribute is IE Only, but so apparently is this code path...
          style.removeAttribute( "filter" );

          // if there is no filter style applied in a css rule or unset inline opacity, we are done
          if ( value === "" || currentStyle && !currentStyle.filter ) {
            return;
          }
        }

        // otherwise, set new filter values
        style.filter = ralpha.test( filter ) ?
          filter.replace( ralpha, opacity ) :
          filter + " " + opacity;
      }
    };
  }

  jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
    function ( elem, computed ) {
      if ( computed ) {
        // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
        // Work around by temporarily setting element display to inline-block
        return jQuery.swap( elem, { "display": "inline-block" },
          curCSS, [ elem, "marginRight" ] );
      }
    }
  );

  // These hooks are used by animate to expand properties
  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function ( prefix, suffix ) {
    jQuery.cssHooks[ prefix + suffix ] = {
      expand: function ( value ) {
        var i = 0,
          expanded = {},

          // assumes a single number if not a string
          parts = typeof value === "string" ? value.split(" ") : [ value ];

        for ( ; i < 4; i++ ) {
          expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
        }

        return expanded;
      }
    };

    if ( !rmargin.test( prefix ) ) {
      jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
    }
  });

  jQuery.fn.extend({
    css: function ( name, value ) {
      return access( this, function ( elem, name, value ) {
        var styles, len,
          map = {},
          i = 0;

        if ( jQuery.isArray( name ) ) {
          styles = getStyles( elem );
          len = name.length;

          for ( ; i < len; i++ ) {
            map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
          }

          return map;
        }

        return value !== undefined ?
          jQuery.style( elem, name, value ) :
          jQuery.css( elem, name );
      }, name, value, arguments.length > 1 );
    },
    show: function () {
      return showHide( this, true );
    },
    hide: function () {
      return showHide( this );
    },
    toggle: function ( state ) {
      if ( typeof state === "boolean" ) {
        return state ? this.show() : this.hide();
      }

      return this.each(function () {
        if ( isHidden( this ) ) {
          jQuery( this ).show();
        } else {
          jQuery( this ).hide();
        }
      });
    }
  });

  function Tween( elem, options, prop, end, easing ) {
    return new Tween.prototype.init( elem, options, prop, end, easing );
  }
  jQuery.Tween = Tween;

  Tween.prototype = {
    constructor: Tween,
    init: function ( elem, options, prop, end, easing, unit ) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || "swing";
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
    },
    cur: function () {
      var hooks = Tween.propHooks[ this.prop ];

      return hooks && hooks.get ?
        hooks.get( this ) :
        Tween.propHooks._default.get( this );
    },
    run: function ( percent ) {
      var eased,
        hooks = Tween.propHooks[ this.prop ];

      if ( this.options.duration ) {
        this.pos = eased = jQuery.easing[ this.easing ](
          percent, this.options.duration * percent, 0, 1, this.options.duration
        );
      } else {
        this.pos = eased = percent;
      }
      this.now = ( this.end - this.start ) * eased + this.start;

      if ( this.options.step ) {
        this.options.step.call( this.elem, this.now, this );
      }

      if ( hooks && hooks.set ) {
        hooks.set( this );
      } else {
        Tween.propHooks._default.set( this );
      }
      return this;
    }
  };

  Tween.prototype.init.prototype = Tween.prototype;

  Tween.propHooks = {
    _default: {
      get: function ( tween ) {
        var result;

        if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
          return tween.elem[ tween.prop ];
        }

        // passing an empty string as a 3rd parameter to .css will automatically
        // attempt a parseFloat and fallback to a string if the parse fails
        // so, simple values such as "10px" are parsed to Float.
        // complex values such as "rotate(1rad)" are returned as is.
        result = jQuery.css( tween.elem, tween.prop, "" );
        // Empty strings, null, undefined and "auto" are converted to 0.
        return !result || result === "auto" ? 0 : result;
      },
      set: function ( tween ) {
        // use step hook for back compat - use cssHook if its there - use .style if its
        // available and use plain properties where available
        if ( jQuery.fx.step[ tween.prop ] ) {
          jQuery.fx.step[ tween.prop ]( tween );
        } else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
          jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
        } else {
          tween.elem[ tween.prop ] = tween.now;
        }
      }
    }
  };

  // Support: IE <=9
  // Panic based approach to setting things on disconnected nodes

  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
    set: function ( tween ) {
      if ( tween.elem.nodeType && tween.elem.parentNode ) {
        tween.elem[ tween.prop ] = tween.now;
      }
    }
  };

  jQuery.easing = {
    linear: function ( p ) {
      return p;
    },
    swing: function ( p ) {
      return 0.5 - Math.cos( p * Math.PI ) / 2;
    }
  };

  jQuery.fx = Tween.prototype.init;

  // Back Compat <1.8 extension point
  jQuery.fx.step = {};

  var
    fxNow, timerId,
    rfxtypes = /^(?:toggle|show|hide)$/,
    rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
    rrun = /queueHooks$/,
    animationPrefilters = [ defaultPrefilter ],
    tweeners = {
      "*": [ function ( prop, value ) {
        var tween = this.createTween( prop, value ),
          target = tween.cur(),
          parts = rfxnum.exec( value ),
          unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

          // Starting value computation is required for potential unit mismatches
          start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
          scale = 1,
          maxIterations = 20;

        if ( start && start[ 3 ] !== unit ) {
          // Trust units reported by jQuery.css
          unit = unit || start[ 3 ];

          // Make sure we update the tween properties later on
          parts = parts || [];

          // Iteratively approximate from a nonzero starting point
          start = +target || 1;

          do {
            // If previous iteration zeroed out, double until we get *something*
            // Use a string for doubling factor so we don't accidentally see scale as unchanged below
            scale = scale || ".5";

            // Adjust and apply
            start = start / scale;
            jQuery.style( tween.elem, prop, start + unit );

            // Update scale, tolerating zero or NaN from tween.cur()
            // And breaking the loop if scale is unchanged or perfect, or if we've just had enough
          } while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
        }

        // Update tween properties
        if ( parts ) {
          start = tween.start = +start || +target || 0;
          tween.unit = unit;
          // If a +=/-= token was provided, we're doing a relative animation
          tween.end = parts[ 1 ] ?
            start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
            +parts[ 2 ];
        }

        return tween;
      } ]
    };

  // Animations created synchronously will run synchronously
  function createFxNow() {
    setTimeout(function () {
      fxNow = undefined;
    });
    return ( fxNow = jQuery.now() );
  }

  // Generate parameters to create a standard animation
  function genFx( type, includeWidth ) {
    var which,
      attrs = { height: type },
      i = 0;

    // if we include width, step value is 1 to do all cssExpand values,
    // if we don't include width, step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for ( ; i < 4 ; i += 2 - includeWidth ) {
      which = cssExpand[ i ];
      attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
    }

    if ( includeWidth ) {
      attrs.opacity = attrs.width = type;
    }

    return attrs;
  }

  function createTween( value, prop, animation ) {
    var tween,
      collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
      index = 0,
      length = collection.length;
    for ( ; index < length; index++ ) {
      if ( (tween = collection[ index ].call( animation, prop, value )) ) {

        // we're done with this property
        return tween;
      }
    }
  }

  function defaultPrefilter( elem, props, opts ) {
    /* jshint validthis: true */
    var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
      anim = this,
      orig = {},
      style = elem.style,
      hidden = elem.nodeType && isHidden( elem ),
      dataShow = jQuery._data( elem, "fxshow" );

    // handle queue: false promises
    if ( !opts.queue ) {
      hooks = jQuery._queueHooks( elem, "fx" );
      if ( hooks.unqueued == null ) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;
        hooks.empty.fire = function () {
          if ( !hooks.unqueued ) {
            oldfire();
          }
        };
      }
      hooks.unqueued++;

      anim.always(function () {
        // doing this makes sure that the complete handler will be called
        // before this completes
        anim.always(function () {
          hooks.unqueued--;
          if ( !jQuery.queue( elem, "fx" ).length ) {
            hooks.empty.fire();
          }
        });
      });
    }

    // height/width overflow pass
    if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
      // Make sure that nothing sneaks out
      // Record all 3 overflow attributes because IE does not
      // change the overflow attribute when overflowX and
      // overflowY are set to the same value
      opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

      // Set display property to inline-block for height/width
      // animations on inline elements that are having width/height animated
      display = jQuery.css( elem, "display" );

      // Test default display if display is currently "none"
      checkDisplay = display === "none" ?
        jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

      if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {

        // inline-level elements accept inline-block;
        // block-level elements need to be inline with layout
        if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
          style.display = "inline-block";
        } else {
          style.zoom = 1;
        }
      }
    }

    if ( opts.overflow ) {
      style.overflow = "hidden";
      if ( !support.shrinkWrapBlocks() ) {
        anim.always(function () {
          style.overflow = opts.overflow[ 0 ];
          style.overflowX = opts.overflow[ 1 ];
          style.overflowY = opts.overflow[ 2 ];
        });
      }
    }

    // show/hide pass
    for ( prop in props ) {
      value = props[ prop ];
      if ( rfxtypes.exec( value ) ) {
        delete props[ prop ];
        toggle = toggle || value === "toggle";
        if ( value === ( hidden ? "hide" : "show" ) ) {

          // If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
          if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
            hidden = true;
          } else {
            continue;
          }
        }
        orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

        // Any non-fx value stops us from restoring the original display value
      } else {
        display = undefined;
      }
    }

    if ( !jQuery.isEmptyObject( orig ) ) {
      if ( dataShow ) {
        if ( "hidden" in dataShow ) {
          hidden = dataShow.hidden;
        }
      } else {
        dataShow = jQuery._data( elem, "fxshow", {} );
      }

      // store state if its toggle - enables .stop().toggle() to "reverse"
      if ( toggle ) {
        dataShow.hidden = !hidden;
      }
      if ( hidden ) {
        jQuery( elem ).show();
      } else {
        anim.done(function () {
          jQuery( elem ).hide();
        });
      }
      anim.done(function () {
        var prop;
        jQuery._removeData( elem, "fxshow" );
        for ( prop in orig ) {
          jQuery.style( elem, prop, orig[ prop ] );
        }
      });
      for ( prop in orig ) {
        tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

        if ( !( prop in dataShow ) ) {
          dataShow[ prop ] = tween.start;
          if ( hidden ) {
            tween.end = tween.start;
            tween.start = prop === "width" || prop === "height" ? 1 : 0;
          }
        }
      }

      // If this is a noop like .hide().hide(), restore an overwritten display value
    } else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
      style.display = display;
    }
  }

  function propFilter( props, specialEasing ) {
    var index, name, easing, value, hooks;

    // camelCase, specialEasing and expand cssHook pass
    for ( index in props ) {
      name = jQuery.camelCase( index );
      easing = specialEasing[ name ];
      value = props[ index ];
      if ( jQuery.isArray( value ) ) {
        easing = value[ 1 ];
        value = props[ index ] = value[ 0 ];
      }

      if ( index !== name ) {
        props[ name ] = value;
        delete props[ index ];
      }

      hooks = jQuery.cssHooks[ name ];
      if ( hooks && "expand" in hooks ) {
        value = hooks.expand( value );
        delete props[ name ];

        // not quite $.extend, this wont overwrite keys already present.
        // also - reusing 'index' from above because we have the correct "name"
        for ( index in value ) {
          if ( !( index in props ) ) {
            props[ index ] = value[ index ];
            specialEasing[ index ] = easing;
          }
        }
      } else {
        specialEasing[ name ] = easing;
      }
    }
  }

  function Animation( elem, properties, options ) {
    var result,
      stopped,
      index = 0,
      length = animationPrefilters.length,
      deferred = jQuery.Deferred().always( function () {
        // don't match elem in the :animated selector
        delete tick.elem;
      }),
      tick = function () {
        if ( stopped ) {
          return false;
        }
        var currentTime = fxNow || createFxNow(),
          remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
          // archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
          temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;

        for ( ; index < length ; index++ ) {
          animation.tweens[ index ].run( percent );
        }

        deferred.notifyWith( elem, [ animation, percent, remaining ]);

        if ( percent < 1 && length ) {
          return remaining;
        } else {
          deferred.resolveWith( elem, [ animation ] );
          return false;
        }
      },
      animation = deferred.promise({
        elem: elem,
        props: jQuery.extend( {}, properties ),
        opts: jQuery.extend( true, { specialEasing: {} }, options ),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function ( prop, end ) {
          var tween = jQuery.Tween( elem, animation.opts, prop, end,
            animation.opts.specialEasing[ prop ] || animation.opts.easing );
          animation.tweens.push( tween );
          return tween;
        },
        stop: function ( gotoEnd ) {
          var index = 0,
            // if we are going to the end, we want to run all the tweens
            // otherwise we skip this part
            length = gotoEnd ? animation.tweens.length : 0;
          if ( stopped ) {
            return this;
          }
          stopped = true;
          for ( ; index < length ; index++ ) {
            animation.tweens[ index ].run( 1 );
          }

          // resolve when we played the last frame
          // otherwise, reject
          if ( gotoEnd ) {
            deferred.resolveWith( elem, [ animation, gotoEnd ] );
          } else {
            deferred.rejectWith( elem, [ animation, gotoEnd ] );
          }
          return this;
        }
      }),
      props = animation.props;

    propFilter( props, animation.opts.specialEasing );

    for ( ; index < length ; index++ ) {
      result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
      if ( result ) {
        return result;
      }
    }

    jQuery.map( props, createTween, animation );

    if ( jQuery.isFunction( animation.opts.start ) ) {
      animation.opts.start.call( elem, animation );
    }

    jQuery.fx.timer(
      jQuery.extend( tick, {
        elem: elem,
        anim: animation,
        queue: animation.opts.queue
      })
    );

    // attach callbacks from options
    return animation.progress( animation.opts.progress )
      .done( animation.opts.done, animation.opts.complete )
      .fail( animation.opts.fail )
      .always( animation.opts.always );
  }

  jQuery.Animation = jQuery.extend( Animation, {
    tweener: function ( props, callback ) {
      if ( jQuery.isFunction( props ) ) {
        callback = props;
        props = [ "*" ];
      } else {
        props = props.split(" ");
      }

      var prop,
        index = 0,
        length = props.length;

      for ( ; index < length ; index++ ) {
        prop = props[ index ];
        tweeners[ prop ] = tweeners[ prop ] || [];
        tweeners[ prop ].unshift( callback );
      }
    },

    prefilter: function ( callback, prepend ) {
      if ( prepend ) {
        animationPrefilters.unshift( callback );
      } else {
        animationPrefilters.push( callback );
      }
    }
  });

  jQuery.speed = function ( speed, easing, fn ) {
    var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
      complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
      duration: speed,
      easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
    };

    opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
      opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

    // normalize opt.queue - true/undefined/null -> "fx"
    if ( opt.queue == null || opt.queue === true ) {
      opt.queue = "fx";
    }

    // Queueing
    opt.old = opt.complete;

    opt.complete = function () {
      if ( jQuery.isFunction( opt.old ) ) {
        opt.old.call( this );
      }

      if ( opt.queue ) {
        jQuery.dequeue( this, opt.queue );
      }
    };

    return opt;
  };

  jQuery.fn.extend({
    fadeTo: function ( speed, to, easing, callback ) {

      // show any hidden elements after setting opacity to 0
      return this.filter( isHidden ).css( "opacity", 0 ).show()

      // animate to the value specified
        .end().animate({ opacity: to }, speed, easing, callback );
    },
    animate: function ( prop, speed, easing, callback ) {
      var empty = jQuery.isEmptyObject( prop ),
        optall = jQuery.speed( speed, easing, callback ),
        doAnimation = function () {
          // Operate on a copy of prop so per-property easing won't be lost
          var anim = Animation( this, jQuery.extend( {}, prop ), optall );

          // Empty animations, or finishing resolves immediately
          if ( empty || jQuery._data( this, "finish" ) ) {
            anim.stop( true );
          }
        };
      doAnimation.finish = doAnimation;

      return empty || optall.queue === false ?
        this.each( doAnimation ) :
        this.queue( optall.queue, doAnimation );
    },
    stop: function ( type, clearQueue, gotoEnd ) {
      var stopQueue = function ( hooks ) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop( gotoEnd );
      };

      if ( typeof type !== "string" ) {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }
      if ( clearQueue && type !== false ) {
        this.queue( type || "fx", [] );
      }

      return this.each(function () {
        var dequeue = true,
          index = type != null && type + "queueHooks",
          timers = jQuery.timers,
          data = jQuery._data( this );

        if ( index ) {
          if ( data[ index ] && data[ index ].stop ) {
            stopQueue( data[ index ] );
          }
        } else {
          for ( index in data ) {
            if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
              stopQueue( data[ index ] );
            }
          }
        }

        for ( index = timers.length; index--; ) {
          if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
            timers[ index ].anim.stop( gotoEnd );
            dequeue = false;
            timers.splice( index, 1 );
          }
        }

        // start the next in the queue if the last step wasn't forced
        // timers currently will call their complete callbacks, which will dequeue
        // but only if they were gotoEnd
        if ( dequeue || !gotoEnd ) {
          jQuery.dequeue( this, type );
        }
      });
    },
    finish: function ( type ) {
      if ( type !== false ) {
        type = type || "fx";
      }
      return this.each(function () {
        var index,
          data = jQuery._data( this ),
          queue = data[ type + "queue" ],
          hooks = data[ type + "queueHooks" ],
          timers = jQuery.timers,
          length = queue ? queue.length : 0;

        // enable finishing flag on private data
        data.finish = true;

        // empty the queue first
        jQuery.queue( this, type, [] );

        if ( hooks && hooks.stop ) {
          hooks.stop.call( this, true );
        }

        // look for any active animations, and finish them
        for ( index = timers.length; index--; ) {
          if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
            timers[ index ].anim.stop( true );
            timers.splice( index, 1 );
          }
        }

        // look for any animations in the old queue and finish them
        for ( index = 0; index < length; index++ ) {
          if ( queue[ index ] && queue[ index ].finish ) {
            queue[ index ].finish.call( this );
          }
        }

        // turn off finishing flag
        delete data.finish;
      });
    }
  });

  jQuery.each([ "toggle", "show", "hide" ], function ( i, name ) {
    var cssFn = jQuery.fn[ name ];
    jQuery.fn[ name ] = function ( speed, easing, callback ) {
      return speed == null || typeof speed === "boolean" ?
        cssFn.apply( this, arguments ) :
        this.animate( genFx( name, true ), speed, easing, callback );
    };
  });

  // Generate shortcuts for custom animations
  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: { opacity: "show" },
    fadeOut: { opacity: "hide" },
    fadeToggle: { opacity: "toggle" }
  }, function ( name, props ) {
    jQuery.fn[ name ] = function ( speed, easing, callback ) {
      return this.animate( props, speed, easing, callback );
    };
  });

  jQuery.timers = [];
  jQuery.fx.tick = function () {
    var timer,
      timers = jQuery.timers,
      i = 0;

    fxNow = jQuery.now();

    for ( ; i < timers.length; i++ ) {
      timer = timers[ i ];
      // Checks the timer has not already been removed
      if ( !timer() && timers[ i ] === timer ) {
        timers.splice( i--, 1 );
      }
    }

    if ( !timers.length ) {
      jQuery.fx.stop();
    }
    fxNow = undefined;
  };

  jQuery.fx.timer = function ( timer ) {
    jQuery.timers.push( timer );
    if ( timer() ) {
      jQuery.fx.start();
    } else {
      jQuery.timers.pop();
    }
  };

  jQuery.fx.interval = 13;

  jQuery.fx.start = function () {
    if ( !timerId ) {
      timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
    }
  };

  jQuery.fx.stop = function () {
    clearInterval( timerId );
    timerId = null;
  };

  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    // Default speed
    _default: 400
  };

  // Based off of the plugin by Clint Helfers, with permission.
  // http://blindsignals.com/index.php/2009/07/jquery-delay/
  jQuery.fn.delay = function ( time, type ) {
    time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
    type = type || "fx";

    return this.queue( type, function ( next, hooks ) {
      var timeout = setTimeout( next, time );
      hooks.stop = function () {
        clearTimeout( timeout );
      };
    });
  };

  (function () {
    // Minified: var a,b,c,d,e
    var input, div, select, a, opt;

    // Setup
    div = document.createElement( "div" );
    div.setAttribute( "className", "t" );
    div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
    a = div.getElementsByTagName("a")[ 0 ];

    // First batch of tests.
    select = document.createElement("select");
    opt = select.appendChild( document.createElement("option") );
    input = div.getElementsByTagName("input")[ 0 ];

    a.style.cssText = "top:1px";

    // Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
    support.getSetAttribute = div.className !== "t";

    // Get the style information from getAttribute
    // (IE uses .cssText instead)
    support.style = /top/.test( a.getAttribute("style") );

    // Make sure that URLs aren't manipulated
    // (IE normalizes it by default)
    support.hrefNormalized = a.getAttribute("href") === "/a";

    // Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
    support.checkOn = !!input.value;

    // Make sure that a selected-by-default option has a working selected property.
    // (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
    support.optSelected = opt.selected;

    // Tests for enctype support on a form (#6743)
    support.enctype = !!document.createElement("form").enctype;

    // Make sure that the options inside disabled selects aren't marked as disabled
    // (WebKit marks them as disabled)
    select.disabled = true;
    support.optDisabled = !opt.disabled;

    // Support: IE8 only
    // Check if we can trust getAttribute("value")
    input = document.createElement( "input" );
    input.setAttribute( "value", "" );
    support.input = input.getAttribute( "value" ) === "";

    // Check if an input maintains its value after becoming a radio
    input.value = "t";
    input.setAttribute( "type", "radio" );
    support.radioValue = input.value === "t";
  })();

  var rreturn = /\r/g;

  jQuery.fn.extend({
    val: function ( value ) {
      var hooks, ret, isFunction,
        elem = this[0];

      if ( !arguments.length ) {
        if ( elem ) {
          hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

          if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
            return ret;
          }

          ret = elem.value;

          return typeof ret === "string" ?
          // handle most common string cases
            ret.replace(rreturn, "") :
          // handle cases where value is null/undef or number
            ret == null ? "" : ret;
        }

        return;
      }

      isFunction = jQuery.isFunction( value );

      return this.each(function ( i ) {
        var val;

        if ( this.nodeType !== 1 ) {
          return;
        }

        if ( isFunction ) {
          val = value.call( this, i, jQuery( this ).val() );
        } else {
          val = value;
        }

        // Treat null/undefined as ""; convert numbers to string
        if ( val == null ) {
          val = "";
        } else if ( typeof val === "number" ) {
          val += "";
        } else if ( jQuery.isArray( val ) ) {
          val = jQuery.map( val, function ( value ) {
            return value == null ? "" : value + "";
          });
        }

        hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

        // If set returns undefined, fall back to normal setting
        if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
          this.value = val;
        }
      });
    }
  });

  jQuery.extend({
    valHooks: {
      option: {
        get: function ( elem ) {
          var val = jQuery.find.attr( elem, "value" );
          return val != null ?
            val :
          // Support: IE10-11+
          // option.text throws exceptions (#14686, #14858)
            jQuery.trim( jQuery.text( elem ) );
        }
      },
      select: {
        get: function ( elem ) {
          var value, option,
            options = elem.options,
            index = elem.selectedIndex,
            one = elem.type === "select-one" || index < 0,
            values = one ? null : [],
            max = one ? index + 1 : options.length,
            i = index < 0 ?
              max :
              one ? index : 0;

          // Loop through all the selected options
          for ( ; i < max; i++ ) {
            option = options[ i ];

            // oldIE doesn't update selected after form reset (#2551)
            if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

              // Get the specific value for the option
              value = jQuery( option ).val();

              // We don't need an array for one selects
              if ( one ) {
                return value;
              }

              // Multi-Selects return an array
              values.push( value );
            }
          }

          return values;
        },

        set: function ( elem, value ) {
          var optionSet, option,
            options = elem.options,
            values = jQuery.makeArray( value ),
            i = options.length;

          while ( i-- ) {
            option = options[ i ];

            if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) >= 0 ) {

              // Support: IE6
              // When new option element is added to select box we need to
              // force reflow of newly added node in order to workaround delay
              // of initialization properties
              try {
                option.selected = optionSet = true;

              } catch ( _ ) {

                // Will be executed only in IE6
                option.scrollHeight;
              }

            } else {
              option.selected = false;
            }
          }

          // Force browsers to behave consistently when non-matching value is set
          if ( !optionSet ) {
            elem.selectedIndex = -1;
          }

          return options;
        }
      }
    }
  });

  // Radios and checkboxes getter/setter
  jQuery.each([ "radio", "checkbox" ], function () {
    jQuery.valHooks[ this ] = {
      set: function ( elem, value ) {
        if ( jQuery.isArray( value ) ) {
          return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
        }
      }
    };
    if ( !support.checkOn ) {
      jQuery.valHooks[ this ].get = function ( elem ) {
        // Support: Webkit
        // "" is returned instead of "on" if a value isn't specified
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  });

  var nodeHook, boolHook,
    attrHandle = jQuery.expr.attrHandle,
    ruseDefault = /^(?:checked|selected)$/i,
    getSetAttribute = support.getSetAttribute,
    getSetInput = support.input;

  jQuery.fn.extend({
    attr: function ( name, value ) {
      return access( this, jQuery.attr, name, value, arguments.length > 1 );
    },

    removeAttr: function ( name ) {
      return this.each(function () {
        jQuery.removeAttr( this, name );
      });
    }
  });

  jQuery.extend({
    attr: function ( elem, name, value ) {
      var hooks, ret,
        nType = elem.nodeType;

      // don't get/set attributes on text, comment and attribute nodes
      if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
        return;
      }

      // Fallback to prop when attributes are not supported
      if ( typeof elem.getAttribute === strundefined ) {
        return jQuery.prop( elem, name, value );
      }

      // All attributes are lowercase
      // Grab necessary hook if one is defined
      if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
        name = name.toLowerCase();
        hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
      }

      if ( value !== undefined ) {

        if ( value === null ) {
          jQuery.removeAttr( elem, name );

        } else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
          return ret;

        } else {
          elem.setAttribute( name, value + "" );
          return value;
        }

      } else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
        return ret;

      } else {
        ret = jQuery.find.attr( elem, name );

        // Non-existent attributes return null, we normalize to undefined
        return ret == null ?
          undefined :
          ret;
      }
    },

    removeAttr: function ( elem, value ) {
      var name, propName,
        i = 0,
        attrNames = value && value.match( rnotwhite );

      if ( attrNames && elem.nodeType === 1 ) {
        while ( (name = attrNames[i++]) ) {
          propName = jQuery.propFix[ name ] || name;

          // Boolean attributes get special treatment (#10870)
          if ( jQuery.expr.match.bool.test( name ) ) {
            // Set corresponding property to false
            if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
              elem[ propName ] = false;
              // Support: IE<9
              // Also clear defaultChecked/defaultSelected (if appropriate)
            } else {
              elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
            }

            // See #9699 for explanation of this approach (setting first, then removal)
          } else {
            jQuery.attr( elem, name, "" );
          }

          elem.removeAttribute( getSetAttribute ? name : propName );
        }
      }
    },

    attrHooks: {
      type: {
        set: function ( elem, value ) {
          if ( !support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
            // Setting the type on a radio button after the value resets the value in IE6-9
            // Reset value to default in case type is set after value during creation
            var val = elem.value;
            elem.setAttribute( "type", value );
            if ( val ) {
              elem.value = val;
            }
            return value;
          }
        }
      }
    }
  });

  // Hook for boolean attributes
  boolHook = {
    set: function ( elem, value, name ) {
      if ( value === false ) {
        // Remove boolean attributes when set to false
        jQuery.removeAttr( elem, name );
      } else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
        // IE<8 needs the *property* name
        elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

        // Use defaultChecked and defaultSelected for oldIE
      } else {
        elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
      }

      return name;
    }
  };

  // Retrieve booleans specially
  jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function ( i, name ) {

    var getter = attrHandle[ name ] || jQuery.find.attr;

    attrHandle[ name ] = getSetInput && getSetAttribute || !ruseDefault.test( name ) ?
      function ( elem, name, isXML ) {
        var ret, handle;
        if ( !isXML ) {
          // Avoid an infinite loop by temporarily removing this function from the getter
          handle = attrHandle[ name ];
          attrHandle[ name ] = ret;
          ret = getter( elem, name, isXML ) != null ?
            name.toLowerCase() :
            null;
          attrHandle[ name ] = handle;
        }
        return ret;
      } :
      function ( elem, name, isXML ) {
        if ( !isXML ) {
          return elem[ jQuery.camelCase( "default-" + name ) ] ?
            name.toLowerCase() :
            null;
        }
      };
  });

  // fix oldIE attroperties
  if ( !getSetInput || !getSetAttribute ) {
    jQuery.attrHooks.value = {
      set: function ( elem, value, name ) {
        if ( jQuery.nodeName( elem, "input" ) ) {
          // Does not return so that setAttribute is also used
          elem.defaultValue = value;
        } else {
          // Use nodeHook if defined (#1954); otherwise setAttribute is fine
          return nodeHook && nodeHook.set( elem, value, name );
        }
      }
    };
  }

  // IE6/7 do not support getting/setting some attributes with get/setAttribute
  if ( !getSetAttribute ) {

    // Use this for any attribute in IE6/7
    // This fixes almost every IE6/7 issue
    nodeHook = {
      set: function ( elem, value, name ) {
        // Set the existing or create a new attribute node
        var ret = elem.getAttributeNode( name );
        if ( !ret ) {
          elem.setAttributeNode(
            (ret = elem.ownerDocument.createAttribute( name ))
          );
        }

        ret.value = value += "";

        // Break association with cloned elements by also using setAttribute (#9646)
        if ( name === "value" || value === elem.getAttribute( name ) ) {
          return value;
        }
      }
    };

    // Some attributes are constructed with empty-string values when not defined
    attrHandle.id = attrHandle.name = attrHandle.coords =
		function ( elem, name, isXML ) {
		  var ret;
		  if ( !isXML ) {
		    return (ret = elem.getAttributeNode( name )) && ret.value !== "" ?
		      ret.value :
		      null;
		  }
		};

    // Fixing value retrieval on a button requires this module
    jQuery.valHooks.button = {
      get: function ( elem, name ) {
        var ret = elem.getAttributeNode( name );
        if ( ret && ret.specified ) {
          return ret.value;
        }
      },
      set: nodeHook.set
    };

    // Set contenteditable to false on removals(#10429)
    // Setting to empty string throws an error as an invalid value
    jQuery.attrHooks.contenteditable = {
      set: function ( elem, value, name ) {
        nodeHook.set( elem, value === "" ? false : value, name );
      }
    };

    // Set width and height to auto instead of 0 on empty string( Bug #8150 )
    // This is for removals
    jQuery.each([ "width", "height" ], function ( i, name ) {
      jQuery.attrHooks[ name ] = {
        set: function ( elem, value ) {
          if ( value === "" ) {
            elem.setAttribute( name, "auto" );
            return value;
          }
        }
      };
    });
  }

  if ( !support.style ) {
    jQuery.attrHooks.style = {
      get: function ( elem ) {
        // Return undefined in the case of empty string
        // Note: IE uppercases css property names, but if we were to .toLowerCase()
        // .cssText, that would destroy case senstitivity in URL's, like in "background"
        return elem.style.cssText || undefined;
      },
      set: function ( elem, value ) {
        return ( elem.style.cssText = value + "" );
      }
    };
  }

  var rfocusable = /^(?:input|select|textarea|button|object)$/i,
    rclickable = /^(?:a|area)$/i;

  jQuery.fn.extend({
    prop: function ( name, value ) {
      return access( this, jQuery.prop, name, value, arguments.length > 1 );
    },

    removeProp: function ( name ) {
      name = jQuery.propFix[ name ] || name;
      return this.each(function () {
        // try/catch handles cases where IE balks (such as removing a property on window)
        try {
          this[ name ] = undefined;
          delete this[ name ];
        } catch ( e ) {}
      });
    }
  });

  jQuery.extend({
    propFix: {
      "for": "htmlFor",
      "class": "className"
    },

    prop: function ( elem, name, value ) {
      var ret, hooks, notxml,
        nType = elem.nodeType;

      // don't get/set properties on text, comment and attribute nodes
      if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
        return;
      }

      notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

      if ( notxml ) {
        // Fix name and attach hooks
        name = jQuery.propFix[ name ] || name;
        hooks = jQuery.propHooks[ name ];
      }

      if ( value !== undefined ) {
        return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
          ret :
          ( elem[ name ] = value );

      } else {
        return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
          ret :
          elem[ name ];
      }
    },

    propHooks: {
      tabIndex: {
        get: function ( elem ) {
          // elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
          // http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
          // Use proper attribute retrieval(#12072)
          var tabindex = jQuery.find.attr( elem, "tabindex" );

          return tabindex ?
            parseInt( tabindex, 10 ) :
            rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
              0 :
              -1;
        }
      }
    }
  });

  // Some attributes require a special call on IE
  // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
  if ( !support.hrefNormalized ) {
    // href/src property should get the full normalized URL (#10299/#12915)
    jQuery.each([ "href", "src" ], function ( i, name ) {
      jQuery.propHooks[ name ] = {
        get: function ( elem ) {
          return elem.getAttribute( name, 4 );
        }
      };
    });
  }

  // Support: Safari, IE9+
  // mis-reports the default selected property of an option
  // Accessing the parent's selectedIndex property fixes it
  if ( !support.optSelected ) {
    jQuery.propHooks.selected = {
      get: function ( elem ) {
        var parent = elem.parentNode;

        if ( parent ) {
          parent.selectedIndex;

          // Make sure that it also works with optgroups, see #5701
          if ( parent.parentNode ) {
            parent.parentNode.selectedIndex;
          }
        }
        return null;
      }
    };
  }

  jQuery.each([
    "tabIndex",
    "readOnly",
    "maxLength",
    "cellSpacing",
    "cellPadding",
    "rowSpan",
    "colSpan",
    "useMap",
    "frameBorder",
    "contentEditable"
  ], function () {
    jQuery.propFix[ this.toLowerCase() ] = this;
  });

  // IE6/7 call enctype encoding
  if ( !support.enctype ) {
    jQuery.propFix.enctype = "encoding";
  }

  var rclass = /[\t\r\n\f]/g;

  jQuery.fn.extend({
    addClass: function ( value ) {
      var classes, elem, cur, clazz, j, finalValue,
        i = 0,
        len = this.length,
        proceed = typeof value === "string" && value;

      if ( jQuery.isFunction( value ) ) {
        return this.each(function ( j ) {
          jQuery( this ).addClass( value.call( this, j, this.className ) );
        });
      }

      if ( proceed ) {
        // The disjunction here is for better compressibility (see removeClass)
        classes = ( value || "" ).match( rnotwhite ) || [];

        for ( ; i < len; i++ ) {
          elem = this[ i ];
          cur = elem.nodeType === 1 && ( elem.className ?
            ( " " + elem.className + " " ).replace( rclass, " " ) :
            " "
          );

          if ( cur ) {
            j = 0;
            while ( (clazz = classes[j++]) ) {
              if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
                cur += clazz + " ";
              }
            }

            // only assign if different to avoid unneeded rendering.
            finalValue = jQuery.trim( cur );
            if ( elem.className !== finalValue ) {
              elem.className = finalValue;
            }
          }
        }
      }

      return this;
    },

    removeClass: function ( value ) {
      var classes, elem, cur, clazz, j, finalValue,
        i = 0,
        len = this.length,
        proceed = arguments.length === 0 || typeof value === "string" && value;

      if ( jQuery.isFunction( value ) ) {
        return this.each(function ( j ) {
          jQuery( this ).removeClass( value.call( this, j, this.className ) );
        });
      }
      if ( proceed ) {
        classes = ( value || "" ).match( rnotwhite ) || [];

        for ( ; i < len; i++ ) {
          elem = this[ i ];
          // This expression is here for better compressibility (see addClass)
          cur = elem.nodeType === 1 && ( elem.className ?
            ( " " + elem.className + " " ).replace( rclass, " " ) :
            ""
          );

          if ( cur ) {
            j = 0;
            while ( (clazz = classes[j++]) ) {
              // Remove *all* instances
              while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
                cur = cur.replace( " " + clazz + " ", " " );
              }
            }

            // only assign if different to avoid unneeded rendering.
            finalValue = value ? jQuery.trim( cur ) : "";
            if ( elem.className !== finalValue ) {
              elem.className = finalValue;
            }
          }
        }
      }

      return this;
    },

    toggleClass: function ( value, stateVal ) {
      var type = typeof value;

      if ( typeof stateVal === "boolean" && type === "string" ) {
        return stateVal ? this.addClass( value ) : this.removeClass( value );
      }

      if ( jQuery.isFunction( value ) ) {
        return this.each(function ( i ) {
          jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
        });
      }

      return this.each(function () {
        if ( type === "string" ) {
          // toggle individual class names
          var className,
            i = 0,
            self = jQuery( this ),
            classNames = value.match( rnotwhite ) || [];

          while ( (className = classNames[ i++ ]) ) {
            // check each className given, space separated list
            if ( self.hasClass( className ) ) {
              self.removeClass( className );
            } else {
              self.addClass( className );
            }
          }

          // Toggle whole class name
        } else if ( type === strundefined || type === "boolean" ) {
          if ( this.className ) {
            // store className if set
            jQuery._data( this, "__className__", this.className );
          }

          // If the element has a class name or if we're passed "false",
          // then remove the whole classname (if there was one, the above saved it).
          // Otherwise bring back whatever was previously saved (if anything),
          // falling back to the empty string if nothing was stored.
          this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
        }
      });
    },

    hasClass: function ( selector ) {
      var className = " " + selector + " ",
        i = 0,
        l = this.length;
      for ( ; i < l; i++ ) {
        if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
          return true;
        }
      }

      return false;
    }
  });

  // Return jQuery for attributes-only inclusion

  jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function ( i, name ) {

    // Handle event binding
    jQuery.fn[ name ] = function ( data, fn ) {
      return arguments.length > 0 ?
        this.on( name, null, data, fn ) :
        this.trigger( name );
    };
  });

  jQuery.fn.extend({
    hover: function ( fnOver, fnOut ) {
      return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
    },

    bind: function ( types, data, fn ) {
      return this.on( types, null, data, fn );
    },
    unbind: function ( types, fn ) {
      return this.off( types, null, fn );
    },

    delegate: function ( selector, types, data, fn ) {
      return this.on( types, selector, data, fn );
    },
    undelegate: function ( selector, types, fn ) {
      // ( namespace ) or ( selector, types [, fn] )
      return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
    }
  });

  var nonce = jQuery.now();

  var rquery = (/\?/);

  var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

  jQuery.parseJSON = function ( data ) {
    // Attempt to parse using the native JSON parser first
    if ( window.JSON && window.JSON.parse ) {
      // Support: Android 2.3
      // Workaround failure to string-cast null input
      return window.JSON.parse( data + "" );
    }

    var requireNonComma,
      depth = null,
      str = jQuery.trim( data + "" );

    // Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
    // after removing valid tokens
    return str && !jQuery.trim( str.replace( rvalidtokens, function ( token, comma, open, close ) {

      // Force termination if we see a misplaced comma
      if ( requireNonComma && comma ) {
        depth = 0;
      }

      // Perform no more replacements after returning to outermost depth
      if ( depth === 0 ) {
        return token;
      }

      // Commas must not follow "[", "{", or ","
      requireNonComma = open || comma;

      // Determine new depth
      // array/object open ("[" or "{"): depth += true - false (increment)
      // array/object close ("]" or "}"): depth += false - true (decrement)
      // other cases ("," or primitive): depth += true - true (numeric cast)
      depth += !close - !open;

      // Remove this token
      return "";
    }) ) ?
      ( Function( "return " + str ) )() :
      jQuery.error( "Invalid JSON: " + data );
  };

  // Cross-browser xml parsing
  jQuery.parseXML = function ( data ) {
    var xml, tmp;
    if ( !data || typeof data !== "string" ) {
      return null;
    }
    try {
      if ( window.DOMParser ) { // Standard
        tmp = new DOMParser();
        xml = tmp.parseFromString( data, "text/xml" );
      } else { // IE
        xml = new ActiveXObject( "Microsoft.XMLDOM" );
        xml.async = "false";
        xml.loadXML( data );
      }
    } catch ( e ) {
      xml = undefined;
    }
    if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
      jQuery.error( "Invalid XML: " + data );
    }
    return xml;
  };

  var
    // Document location
    ajaxLocParts,
    ajaxLocation,

    rhash = /#.*$/,
    rts = /([?&])_=[^&]*/,
    rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
    // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    rnoContent = /^(?:GET|HEAD)$/,
    rprotocol = /^\/\//,
    rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

    /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
    prefilters = {},

    /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
    transports = {},

    // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = "*/".concat("*");

  // #8138, IE may throw an exception when accessing
  // a field from window.location if document.domain has been set
  try {
    ajaxLocation = location.href;
  } catch ( e ) {
    // Use the href attribute of an A element
    // since IE will modify it given document.location
    ajaxLocation = document.createElement( "a" );
    ajaxLocation.href = "";
    ajaxLocation = ajaxLocation.href;
  }

  // Segment location into parts
  ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

  // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
  function addToPrefiltersOrTransports( structure ) {

    // dataTypeExpression is optional and defaults to "*"
    return function ( dataTypeExpression, func ) {

      if ( typeof dataTypeExpression !== "string" ) {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }

      var dataType,
        i = 0,
        dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

      if ( jQuery.isFunction( func ) ) {
        // For each dataType in the dataTypeExpression
        while ( (dataType = dataTypes[i++]) ) {
          // Prepend if requested
          if ( dataType.charAt( 0 ) === "+" ) {
            dataType = dataType.slice( 1 ) || "*";
            (structure[ dataType ] = structure[ dataType ] || []).unshift( func );

            // Otherwise append
          } else {
            (structure[ dataType ] = structure[ dataType ] || []).push( func );
          }
        }
      }
    };
  }

  // Base inspection function for prefilters and transports
  function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

    var inspected = {},
      seekingTransport = ( structure === transports );

    function inspect( dataType ) {
      var selected;
      inspected[ dataType ] = true;
      jQuery.each( structure[ dataType ] || [], function ( _, prefilterOrFactory ) {
        var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
        if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
          options.dataTypes.unshift( dataTypeOrTransport );
          inspect( dataTypeOrTransport );
          return false;
        } else if ( seekingTransport ) {
          return !( selected = dataTypeOrTransport );
        }
      });
      return selected;
    }

    return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
  }

  // A special extend for ajax options
  // that takes "flat" options (not to be deep extended)
  // Fixes #9887
  function ajaxExtend( target, src ) {
    var deep, key,
      flatOptions = jQuery.ajaxSettings.flatOptions || {};

    for ( key in src ) {
      if ( src[ key ] !== undefined ) {
        ( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
      }
    }
    if ( deep ) {
      jQuery.extend( true, target, deep );
    }

    return target;
  }

  /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
  function ajaxHandleResponses( s, jqXHR, responses ) {
    var firstDataType, ct, finalDataType, type,
      contents = s.contents,
      dataTypes = s.dataTypes;

    // Remove auto dataType and get content-type in the process
    while ( dataTypes[ 0 ] === "*" ) {
      dataTypes.shift();
      if ( ct === undefined ) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    }

    // Check if we're dealing with a known content-type
    if ( ct ) {
      for ( type in contents ) {
        if ( contents[ type ] && contents[ type ].test( ct ) ) {
          dataTypes.unshift( type );
          break;
        }
      }
    }

    // Check to see if we have a response for the expected dataType
    if ( dataTypes[ 0 ] in responses ) {
      finalDataType = dataTypes[ 0 ];
    } else {
      // Try convertible dataTypes
      for ( type in responses ) {
        if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
          finalDataType = type;
          break;
        }
        if ( !firstDataType ) {
          firstDataType = type;
        }
      }
      // Or just use first one
      finalDataType = finalDataType || firstDataType;
    }

    // If we found a dataType
    // We add the dataType to the list if needed
    // and return the corresponding response
    if ( finalDataType ) {
      if ( finalDataType !== dataTypes[ 0 ] ) {
        dataTypes.unshift( finalDataType );
      }
      return responses[ finalDataType ];
    }
  }

  /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
  function ajaxConvert( s, response, jqXHR, isSuccess ) {
    var conv2, current, conv, tmp, prev,
      converters = {},
      // Work with a copy of dataTypes in case we need to modify it for conversion
      dataTypes = s.dataTypes.slice();

    // Create converters map with lowercased keys
    if ( dataTypes[ 1 ] ) {
      for ( conv in s.converters ) {
        converters[ conv.toLowerCase() ] = s.converters[ conv ];
      }
    }

    current = dataTypes.shift();

    // Convert to each sequential dataType
    while ( current ) {

      if ( s.responseFields[ current ] ) {
        jqXHR[ s.responseFields[ current ] ] = response;
      }

      // Apply the dataFilter if provided
      if ( !prev && isSuccess && s.dataFilter ) {
        response = s.dataFilter( response, s.dataType );
      }

      prev = current;
      current = dataTypes.shift();

      if ( current ) {

        // There's only work to do if current dataType is non-auto
        if ( current === "*" ) {

          current = prev;

          // Convert response if prev dataType is non-auto and differs from current
        } else if ( prev !== "*" && prev !== current ) {

          // Seek a direct converter
          conv = converters[ prev + " " + current ] || converters[ "* " + current ];

          // If none found, seek a pair
          if ( !conv ) {
            for ( conv2 in converters ) {

              // If conv2 outputs current
              tmp = conv2.split( " " );
              if ( tmp[ 1 ] === current ) {

                // If prev can be converted to accepted input
                conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
                if ( conv ) {
                  // Condense equivalence converters
                  if ( conv === true ) {
                    conv = converters[ conv2 ];

                    // Otherwise, insert the intermediate dataType
                  } else if ( converters[ conv2 ] !== true ) {
                    current = tmp[ 0 ];
                    dataTypes.unshift( tmp[ 1 ] );
                  }
                  break;
                }
              }
            }
          }

          // Apply converter (if not an equivalence)
          if ( conv !== true ) {

            // Unless errors are allowed to bubble, catch and return them
            if ( conv && s[ "throws" ] ) {
              response = conv( response );
            } else {
              try {
                response = conv( response );
              } catch ( e ) {
                return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
              }
            }
          }
        }
      }
    }

    return { state: "success", data: response };
  }

  jQuery.extend({

    // Counter for holding the number of active queries
    active: 0,

    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},

    ajaxSettings: {
      url: ajaxLocation,
      type: "GET",
      isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },

      contents: {
        xml: /xml/,
        html: /html/,
        json: /json/
      },

      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },

      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {

        // Convert anything to text
        "* text": String,

        // Text to html (true = no transformation)
        "text html": true,

        // Evaluate text as a json expression
        "text json": jQuery.parseJSON,

        // Parse text as xml
        "text xml": jQuery.parseXML
      },

      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: true,
        context: true
      }
    },

    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function ( target, settings ) {
      return settings ?

      // Building a settings object
        ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

      // Extending ajaxSettings
        ajaxExtend( jQuery.ajaxSettings, target );
    },

    ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
    ajaxTransport: addToPrefiltersOrTransports( transports ),

    // Main method
    ajax: function ( url, options ) {

      // If url is an object, simulate pre-1.5 signature
      if ( typeof url === "object" ) {
        options = url;
        url = undefined;
      }

      // Force options to be an object
      options = options || {};

      var // Cross-domain detection vars
        parts,
        // Loop variable
        i,
        // URL without anti-cache param
        cacheURL,
        // Response headers as string
        responseHeadersString,
        // timeout handle
        timeoutTimer,

        // To know if global events are to be dispatched
        fireGlobals,

        transport,
        // Response headers
        responseHeaders,
        // Create the final options object
        s = jQuery.ajaxSetup( {}, options ),
        // Callbacks context
        callbackContext = s.context || s,
        // Context for global events is callbackContext if it is a DOM node or jQuery collection
        globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
          jQuery( callbackContext ) :
          jQuery.event,
        // Deferreds
        deferred = jQuery.Deferred(),
        completeDeferred = jQuery.Callbacks("once memory"),
        // Status-dependent callbacks
        statusCode = s.statusCode || {},
        // Headers (they are sent all at once)
        requestHeaders = {},
        requestHeadersNames = {},
        // The jqXHR state
        state = 0,
        // Default abort message
        strAbort = "canceled",
        // Fake xhr
        jqXHR = {
          readyState: 0,

          // Builds headers hashtable if needed
          getResponseHeader: function ( key ) {
            var match;
            if ( state === 2 ) {
              if ( !responseHeaders ) {
                responseHeaders = {};
                while ( (match = rheaders.exec( responseHeadersString )) ) {
                  responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
                }
              }
              match = responseHeaders[ key.toLowerCase() ];
            }
            return match == null ? null : match;
          },

          // Raw string
          getAllResponseHeaders: function () {
            return state === 2 ? responseHeadersString : null;
          },

          // Caches the header
          setRequestHeader: function ( name, value ) {
            var lname = name.toLowerCase();
            if ( !state ) {
              name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
              requestHeaders[ name ] = value;
            }
            return this;
          },

          // Overrides response content-type header
          overrideMimeType: function ( type ) {
            if ( !state ) {
              s.mimeType = type;
            }
            return this;
          },

          // Status-dependent callbacks
          statusCode: function ( map ) {
            var code;
            if ( map ) {
              if ( state < 2 ) {
                for ( code in map ) {
                  // Lazy-add the new callback in a way that preserves old ones
                  statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                }
              } else {
                // Execute the appropriate callbacks
                jqXHR.always( map[ jqXHR.status ] );
              }
            }
            return this;
          },

          // Cancel the request
          abort: function ( statusText ) {
            var finalText = statusText || strAbort;
            if ( transport ) {
              transport.abort( finalText );
            }
            done( 0, finalText );
            return this;
          }
        };

      // Attach deferreds
      deferred.promise( jqXHR ).complete = completeDeferred.add;
      jqXHR.success = jqXHR.done;
      jqXHR.error = jqXHR.fail;

      // Remove hash character (#7531: and string promotion)
      // Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
      // Handle falsy url in the settings object (#10093: consistency with old signature)
      // We also use the url parameter if available
      s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

      // Alias method option to type as per ticket #12004
      s.type = options.method || options.type || s.method || s.type;

      // Extract dataTypes list
      s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

      // A cross-domain request is in order when we have a protocol:host:port mismatch
      if ( s.crossDomain == null ) {
        parts = rurl.exec( s.url.toLowerCase() );
        s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
        );
      }

      // Convert data if not already a string
      if ( s.data && s.processData && typeof s.data !== "string" ) {
        s.data = jQuery.param( s.data, s.traditional );
      }

      // Apply prefilters
      inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

      // If request was aborted inside a prefilter, stop there
      if ( state === 2 ) {
        return jqXHR;
      }

      // We can fire global events as of now if asked to
      // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
      fireGlobals = jQuery.event && s.global;

      // Watch for a new set of requests
      if ( fireGlobals && jQuery.active++ === 0 ) {
        jQuery.event.trigger("ajaxStart");
      }

      // Uppercase the type
      s.type = s.type.toUpperCase();

      // Determine if request has content
      s.hasContent = !rnoContent.test( s.type );

      // Save the URL in case we're toying with the If-Modified-Since
      // and/or If-None-Match header later on
      cacheURL = s.url;

      // More options handling for requests with no content
      if ( !s.hasContent ) {

        // If data is available, append data to url
        if ( s.data ) {
          cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
          // #9682: remove data so that it's not used in an eventual retry
          delete s.data;
        }

        // Add anti-cache in url if needed
        if ( s.cache === false ) {
          s.url = rts.test( cacheURL ) ?

          // If there is already a '_' parameter, set its value
            cacheURL.replace( rts, "$1_=" + nonce++ ) :

          // Otherwise add one to the end
            cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
        }
      }

      // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
      if ( s.ifModified ) {
        if ( jQuery.lastModified[ cacheURL ] ) {
          jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
        }
        if ( jQuery.etag[ cacheURL ] ) {
          jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
        }
      }

      // Set the correct header, if data is being sent
      if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
        jqXHR.setRequestHeader( "Content-Type", s.contentType );
      }

      // Set the Accepts header for the server, depending on the dataType
      jqXHR.setRequestHeader(
        "Accept",
        s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
          s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
          s.accepts[ "*" ]
      );

      // Check for headers option
      for ( i in s.headers ) {
        jqXHR.setRequestHeader( i, s.headers[ i ] );
      }

      // Allow custom headers/mimetypes and early abort
      if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
        // Abort if not done already and return
        return jqXHR.abort();
      }

      // aborting is no longer a cancellation
      strAbort = "abort";

      // Install callbacks on deferreds
      for ( i in { success: 1, error: 1, complete: 1 } ) {
        jqXHR[ i ]( s[ i ] );
      }

      // Get transport
      transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

      // If no transport, we auto-abort
      if ( !transport ) {
        done( -1, "No Transport" );
      } else {
        jqXHR.readyState = 1;

        // Send global event
        if ( fireGlobals ) {
          globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
        }
        // Timeout
        if ( s.async && s.timeout > 0 ) {
          timeoutTimer = setTimeout(function () {
            jqXHR.abort("timeout");
          }, s.timeout );
        }

        try {
          state = 1;
          transport.send( requestHeaders, done );
        } catch ( e ) {
          // Propagate exception as error if not done
          if ( state < 2 ) {
            done( -1, e );
            // Simply rethrow otherwise
          } else {
            throw e;
          }
        }
      }

      // Callback for when everything is done
      function done( status, nativeStatusText, responses, headers ) {
        var isSuccess, success, error, response, modified,
          statusText = nativeStatusText;

        // Called once
        if ( state === 2 ) {
          return;
        }

        // State is "done" now
        state = 2;

        // Clear timeout if it exists
        if ( timeoutTimer ) {
          clearTimeout( timeoutTimer );
        }

        // Dereference transport for early garbage collection
        // (no matter how long the jqXHR object will be used)
        transport = undefined;

        // Cache response headers
        responseHeadersString = headers || "";

        // Set readyState
        jqXHR.readyState = status > 0 ? 4 : 0;

        // Determine if successful
        isSuccess = status >= 200 && status < 300 || status === 304;

        // Get response data
        if ( responses ) {
          response = ajaxHandleResponses( s, jqXHR, responses );
        }

        // Convert no matter what (that way responseXXX fields are always set)
        response = ajaxConvert( s, response, jqXHR, isSuccess );

        // If successful, handle type chaining
        if ( isSuccess ) {

          // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
          if ( s.ifModified ) {
            modified = jqXHR.getResponseHeader("Last-Modified");
            if ( modified ) {
              jQuery.lastModified[ cacheURL ] = modified;
            }
            modified = jqXHR.getResponseHeader("etag");
            if ( modified ) {
              jQuery.etag[ cacheURL ] = modified;
            }
          }

          // if no content
          if ( status === 204 || s.type === "HEAD" ) {
            statusText = "nocontent";

            // if not modified
          } else if ( status === 304 ) {
            statusText = "notmodified";

            // If we have data, let's convert it
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          // We extract error from statusText
          // then normalize statusText and status for non-aborts
          error = statusText;
          if ( status || !statusText ) {
            statusText = "error";
            if ( status < 0 ) {
              status = 0;
            }
          }
        }

        // Set data for the fake xhr object
        jqXHR.status = status;
        jqXHR.statusText = ( nativeStatusText || statusText ) + "";

        // Success/Error
        if ( isSuccess ) {
          deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
        } else {
          deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
        }

        // Status-dependent callbacks
        jqXHR.statusCode( statusCode );
        statusCode = undefined;

        if ( fireGlobals ) {
          globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
            [ jqXHR, s, isSuccess ? success : error ] );
        }

        // Complete
        completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

        if ( fireGlobals ) {
          globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
          // Handle the global AJAX counter
          if ( !( --jQuery.active ) ) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }

      return jqXHR;
    },

    getJSON: function ( url, data, callback ) {
      return jQuery.get( url, data, callback, "json" );
    },

    getScript: function ( url, callback ) {
      return jQuery.get( url, undefined, callback, "script" );
    }
  });

  jQuery.each( [ "get", "post" ], function ( i, method ) {
    jQuery[ method ] = function ( url, data, callback, type ) {
      // shift arguments if data argument was omitted
      if ( jQuery.isFunction( data ) ) {
        type = type || callback;
        callback = data;
        data = undefined;
      }

      return jQuery.ajax({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      });
    };
  });

  jQuery._evalUrl = function ( url ) {
    return jQuery.ajax({
      url: url,
      type: "GET",
      dataType: "script",
      async: false,
      global: false,
      "throws": true
    });
  };

  jQuery.fn.extend({
    wrapAll: function ( html ) {
      if ( jQuery.isFunction( html ) ) {
        return this.each(function (i) {
          jQuery(this).wrapAll( html.call(this, i) );
        });
      }

      if ( this[0] ) {
        // The elements to wrap the target around
        var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);

        if ( this[0].parentNode ) {
          wrap.insertBefore( this[0] );
        }

        wrap.map(function () {
          var elem = this;

          while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
            elem = elem.firstChild;
          }

          return elem;
        }).append( this );
      }

      return this;
    },

    wrapInner: function ( html ) {
      if ( jQuery.isFunction( html ) ) {
        return this.each(function (i) {
          jQuery(this).wrapInner( html.call(this, i) );
        });
      }

      return this.each(function () {
        var self = jQuery( this ),
          contents = self.contents();

        if ( contents.length ) {
          contents.wrapAll( html );

        } else {
          self.append( html );
        }
      });
    },

    wrap: function ( html ) {
      var isFunction = jQuery.isFunction( html );

      return this.each(function (i) {
        jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
      });
    },

    unwrap: function () {
      return this.parent().each(function () {
        if ( !jQuery.nodeName( this, "body" ) ) {
          jQuery( this ).replaceWith( this.childNodes );
        }
      }).end();
    }
  });

  jQuery.expr.filters.hidden = function ( elem ) {
    // Support: Opera <= 12.12
    // Opera reports offsetWidths and offsetHeights less than zero on some elements
    return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 ||
		(!support.reliableHiddenOffsets() &&
			((elem.style && elem.style.display) || jQuery.css( elem, "display" )) === "none");
  };

  jQuery.expr.filters.visible = function ( elem ) {
    return !jQuery.expr.filters.hidden( elem );
  };

  var r20 = /%20/g,
    rbracket = /\[\]$/,
    rCRLF = /\r?\n/g,
    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
    rsubmittable = /^(?:input|select|textarea|keygen)/i;

  function buildParams( prefix, obj, traditional, add ) {
    var name;

    if ( jQuery.isArray( obj ) ) {
      // Serialize array item.
      jQuery.each( obj, function ( i, v ) {
        if ( traditional || rbracket.test( prefix ) ) {
          // Treat each array item as a scalar.
          add( prefix, v );

        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
        }
      });

    } else if ( !traditional && jQuery.type( obj ) === "object" ) {
      // Serialize object item.
      for ( name in obj ) {
        buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
      }

    } else {
      // Serialize scalar item.
      add( prefix, obj );
    }
  }

  // Serialize an array of form elements or a set of
  // key/values into a query string
  jQuery.param = function ( a, traditional ) {
    var prefix,
      s = [],
      add = function ( key, value ) {
        // If value is a function, invoke it and return its value
        value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
        s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
      };

    // Set traditional to true for jQuery <= 1.3.2 behavior.
    if ( traditional === undefined ) {
      traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
    }

    // If an array was passed in, assume that it is an array of form elements.
    if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
      // Serialize the form elements
      jQuery.each( a, function () {
        add( this.name, this.value );
      });

    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for ( prefix in a ) {
        buildParams( prefix, a[ prefix ], traditional, add );
      }
    }

    // Return the resulting serialization
    return s.join( "&" ).replace( r20, "+" );
  };

  jQuery.fn.extend({
    serialize: function () {
      return jQuery.param( this.serializeArray() );
    },
    serializeArray: function () {
      return this.map(function () {
        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop( this, "elements" );
        return elements ? jQuery.makeArray( elements ) : this;
      })
        .filter(function () {
          var type = this.type;
          // Use .is(":disabled") so that fieldset[disabled] works
          return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
        })
        .map(function ( i, elem ) {
          var val = jQuery( this ).val();

          return val == null ?
            null :
            jQuery.isArray( val ) ?
              jQuery.map( val, function ( val ) {
                return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
              }) :
              { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
        }).get();
    }
  });

  // Create the request object
  // (This is still attached to ajaxSettings for backward compatibility)
  jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
  // Support: IE6+
    function () {

      // XHR cannot access local files, always use ActiveX for that case
      return !this.isLocal &&

			// Support: IE7-8
			// oldIE XHR does not support non-RFC2616 methods (#13240)
			// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
			// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
			// Although this check for six methods instead of eight
			// since IE also does not support "trace" and "connect"
			/^(get|post|head|put|delete|options)$/i.test( this.type ) &&

			createStandardXHR() || createActiveXHR();
    } :
  // For all other browsers, use the standard XMLHttpRequest object
    createStandardXHR;

  var xhrId = 0,
    xhrCallbacks = {},
    xhrSupported = jQuery.ajaxSettings.xhr();

  // Support: IE<10
  // Open requests must be manually aborted on unload (#5280)
  // See https://support.microsoft.com/kb/2856746 for more info
  if ( window.attachEvent ) {
    window.attachEvent( "onunload", function () {
      for ( var key in xhrCallbacks ) {
        xhrCallbacks[ key ]( undefined, true );
      }
    });
  }

  // Determine support properties
  support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
  xhrSupported = support.ajax = !!xhrSupported;

  // Create transport if the browser can provide an xhr
  if ( xhrSupported ) {

    jQuery.ajaxTransport(function ( options ) {
      // Cross domain only allowed if supported through XMLHttpRequest
      if ( !options.crossDomain || support.cors ) {

        var callback;

        return {
          send: function ( headers, complete ) {
            var i,
              xhr = options.xhr(),
              id = ++xhrId;

            // Open the socket
            xhr.open( options.type, options.url, options.async, options.username, options.password );

            // Apply custom fields if provided
            if ( options.xhrFields ) {
              for ( i in options.xhrFields ) {
                xhr[ i ] = options.xhrFields[ i ];
              }
            }

            // Override mime type if needed
            if ( options.mimeType && xhr.overrideMimeType ) {
              xhr.overrideMimeType( options.mimeType );
            }

            // X-Requested-With header
            // For cross-domain requests, seeing as conditions for a preflight are
            // akin to a jigsaw puzzle, we simply never set it to be sure.
            // (it can always be set on a per-request basis or even using ajaxSetup)
            // For same-domain requests, won't change header if already provided.
            if ( !options.crossDomain && !headers["X-Requested-With"] ) {
              headers["X-Requested-With"] = "XMLHttpRequest";
            }

            // Set headers
            for ( i in headers ) {
              // Support: IE<9
              // IE's ActiveXObject throws a 'Type Mismatch' exception when setting
              // request header to a null-value.
              //
              // To keep consistent with other XHR implementations, cast the value
              // to string and ignore `undefined`.
              if ( headers[ i ] !== undefined ) {
                xhr.setRequestHeader( i, headers[ i ] + "" );
              }
            }

            // Do send the request
            // This may raise an exception which is actually
            // handled in jQuery.ajax (so no try/catch here)
            xhr.send( ( options.hasContent && options.data ) || null );

            // Listener
            callback = function ( _, isAbort ) {
              var status, statusText, responses;

              // Was never called and is aborted or complete
              if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
                // Clean up
                delete xhrCallbacks[ id ];
                callback = undefined;
                xhr.onreadystatechange = jQuery.noop;

                // Abort manually if needed
                if ( isAbort ) {
                  if ( xhr.readyState !== 4 ) {
                    xhr.abort();
                  }
                } else {
                  responses = {};
                  status = xhr.status;

                  // Support: IE<10
                  // Accessing binary-data responseText throws an exception
                  // (#11426)
                  if ( typeof xhr.responseText === "string" ) {
                    responses.text = xhr.responseText;
                  }

                  // Firefox throws an exception when accessing
                  // statusText for faulty cross-domain requests
                  try {
                    statusText = xhr.statusText;
                  } catch ( e ) {
                    // We normalize with Webkit giving an empty statusText
                    statusText = "";
                  }

                  // Filter status for non standard behaviors

                  // If the request is local and we have data: assume a success
                  // (success with no data won't get notified, that's the best we
                  // can do given current implementations)
                  if ( !status && options.isLocal && !options.crossDomain ) {
                    status = responses.text ? 200 : 404;
                    // IE - #1450: sometimes returns 1223 when it should be 204
                  } else if ( status === 1223 ) {
                    status = 204;
                  }
                }
              }

              // Call complete if needed
              if ( responses ) {
                complete( status, statusText, responses, xhr.getAllResponseHeaders() );
              }
            };

            if ( !options.async ) {
              // if we're in sync mode we fire the callback
              callback();
            } else if ( xhr.readyState === 4 ) {
              // (IE6 & IE7) if it's in cache and has been
              // retrieved directly we need to fire the callback
              setTimeout( callback );
            } else {
              // Add to the list of active xhr callbacks
              xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
            }
          },

          abort: function () {
            if ( callback ) {
              callback( undefined, true );
            }
          }
        };
      }
    });
  }

  // Functions to create xhrs
  function createStandardXHR() {
    try {
      return new window.XMLHttpRequest();
    } catch ( e ) {}
  }

  function createActiveXHR() {
    try {
      return new window.ActiveXObject( "Microsoft.XMLHTTP" );
    } catch ( e ) {}
  }

  // Install script dataType
  jQuery.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /(?:java|ecma)script/
    },
    converters: {
      "text script": function ( text ) {
        jQuery.globalEval( text );
        return text;
      }
    }
  });

  // Handle cache's special case and global
  jQuery.ajaxPrefilter( "script", function ( s ) {
    if ( s.cache === undefined ) {
      s.cache = false;
    }
    if ( s.crossDomain ) {
      s.type = "GET";
      s.global = false;
    }
  });

  // Bind script tag hack transport
  jQuery.ajaxTransport( "script", function (s) {

    // This transport only deals with cross domain requests
    if ( s.crossDomain ) {

      var script,
        head = document.head || jQuery("head")[0] || document.documentElement;

      return {

        send: function ( _, callback ) {

          script = document.createElement("script");

          script.async = true;

          if ( s.scriptCharset ) {
            script.charset = s.scriptCharset;
          }

          script.src = s.url;

          // Attach handlers for all browsers
          script.onload = script.onreadystatechange = function ( _, isAbort ) {

            if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

              // Handle memory leak in IE
              script.onload = script.onreadystatechange = null;

              // Remove the script
              if ( script.parentNode ) {
                script.parentNode.removeChild( script );
              }

              // Dereference the script
              script = null;

              // Callback if not abort
              if ( !isAbort ) {
                callback( 200, "success" );
              }
            }
          };

          // Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
          // Use native DOM manipulation to avoid our domManip AJAX trickery
          head.insertBefore( script, head.firstChild );
        },

        abort: function () {
          if ( script ) {
            script.onload( undefined, true );
          }
        }
      };
    }
  });

  var oldCallbacks = [],
    rjsonp = /(=)\?(?=&|$)|\?\?/;

  // Default jsonp settings
  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
      this[ callback ] = true;
      return callback;
    }
  });

  // Detect, normalize options and install callbacks for jsonp requests
  jQuery.ajaxPrefilter( "json jsonp", function ( s, originalSettings, jqXHR ) {

    var callbackName, overwritten, responseContainer,
      jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
        "url" :
        typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
      );

    // Handle iff the expected data type is "jsonp" or we have a parameter to set
    if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

      // Get callback name, remembering preexisting value associated with it
      callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
        s.jsonpCallback() :
        s.jsonpCallback;

      // Insert callback into url or form data
      if ( jsonProp ) {
        s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
      } else if ( s.jsonp !== false ) {
        s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
      }

      // Use data converter to retrieve json after script execution
      s.converters["script json"] = function () {
        if ( !responseContainer ) {
          jQuery.error( callbackName + " was not called" );
        }
        return responseContainer[ 0 ];
      };

      // force json dataType
      s.dataTypes[ 0 ] = "json";

      // Install callback
      overwritten = window[ callbackName ];
      window[ callbackName ] = function () {
        responseContainer = arguments;
      };

      // Clean-up function (fires after converters)
      jqXHR.always(function () {
        // Restore preexisting value
        window[ callbackName ] = overwritten;

        // Save back as free
        if ( s[ callbackName ] ) {
          // make sure that re-using the options doesn't screw things around
          s.jsonpCallback = originalSettings.jsonpCallback;

          // save the callback name for future use
          oldCallbacks.push( callbackName );
        }

        // Call if it was a function and we have a response
        if ( responseContainer && jQuery.isFunction( overwritten ) ) {
          overwritten( responseContainer[ 0 ] );
        }

        responseContainer = overwritten = undefined;
      });

      // Delegate to script
      return "script";
    }
  });

  // data: string of html
  // context (optional): If specified, the fragment will be created in this context, defaults to document
  // keepScripts (optional): If true, will include scripts passed in the html string
  jQuery.parseHTML = function ( data, context, keepScripts ) {
    if ( !data || typeof data !== "string" ) {
      return null;
    }
    if ( typeof context === "boolean" ) {
      keepScripts = context;
      context = false;
    }
    context = context || document;

    var parsed = rsingleTag.exec( data ),
      scripts = !keepScripts && [];

    // Single tag
    if ( parsed ) {
      return [ context.createElement( parsed[1] ) ];
    }

    parsed = jQuery.buildFragment( [ data ], context, scripts );

    if ( scripts && scripts.length ) {
      jQuery( scripts ).remove();
    }

    return jQuery.merge( [], parsed.childNodes );
  };

  // Keep a copy of the old load method
  var _load = jQuery.fn.load;

  /**
 * Load a url into a page
 */
  jQuery.fn.load = function ( url, params, callback ) {
    if ( typeof url !== "string" && _load ) {
      return _load.apply( this, arguments );
    }

    var selector, response, type,
      self = this,
      off = url.indexOf(" ");

    if ( off >= 0 ) {
      selector = jQuery.trim( url.slice( off, url.length ) );
      url = url.slice( 0, off );
    }

    // If it's a function
    if ( jQuery.isFunction( params ) ) {

      // We assume that it's the callback
      callback = params;
      params = undefined;

      // Otherwise, build a param string
    } else if ( params && typeof params === "object" ) {
      type = "POST";
    }

    // If we have elements to modify, make the request
    if ( self.length > 0 ) {
      jQuery.ajax({
        url: url,

        // if "type" variable is undefined, then "GET" method will be used
        type: type,
        dataType: "html",
        data: params
      }).done(function ( responseText ) {

        // Save response for use in complete callback
        response = arguments;

        self.html( selector ?

        // If a selector was specified, locate the right elements in a dummy div
        // Exclude scripts to avoid IE 'Permission Denied' errors
          jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

        // Otherwise use the full result
          responseText );

      }).complete( callback && function ( jqXHR, status ) {
        self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
      });
    }

    return this;
  };

  // Attach a bunch of functions for handling common AJAX events
  jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function ( i, type ) {
    jQuery.fn[ type ] = function ( fn ) {
      return this.on( type, fn );
    };
  });

  jQuery.expr.filters.animated = function ( elem ) {
    return jQuery.grep(jQuery.timers, function ( fn ) {
      return elem === fn.elem;
    }).length;
  };

  var docElem = window.document.documentElement;

  /**
 * Gets a window from an element
 */
  function getWindow( elem ) {
    return jQuery.isWindow( elem ) ?
      elem :
      elem.nodeType === 9 ?
        elem.defaultView || elem.parentWindow :
        false;
  }

  jQuery.offset = {
    setOffset: function ( elem, options, i ) {
      var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
        position = jQuery.css( elem, "position" ),
        curElem = jQuery( elem ),
        props = {};

      // set position first, in-case top/left are set even on static elem
      if ( position === "static" ) {
        elem.style.position = "relative";
      }

      curOffset = curElem.offset();
      curCSSTop = jQuery.css( elem, "top" );
      curCSSLeft = jQuery.css( elem, "left" );
      calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray("auto", [ curCSSTop, curCSSLeft ] ) > -1;

      // need to be able to calculate position if either top or left is auto and position is either absolute or fixed
      if ( calculatePosition ) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat( curCSSTop ) || 0;
        curLeft = parseFloat( curCSSLeft ) || 0;
      }

      if ( jQuery.isFunction( options ) ) {
        options = options.call( elem, i, curOffset );
      }

      if ( options.top != null ) {
        props.top = ( options.top - curOffset.top ) + curTop;
      }
      if ( options.left != null ) {
        props.left = ( options.left - curOffset.left ) + curLeft;
      }

      if ( "using" in options ) {
        options.using.call( elem, props );
      } else {
        curElem.css( props );
      }
    }
  };

  jQuery.fn.extend({
    offset: function ( options ) {
      if ( arguments.length ) {
        return options === undefined ?
          this :
          this.each(function ( i ) {
            jQuery.offset.setOffset( this, options, i );
          });
      }

      var docElem, win,
        box = { top: 0, left: 0 },
        elem = this[ 0 ],
        doc = elem && elem.ownerDocument;

      if ( !doc ) {
        return;
      }

      docElem = doc.documentElement;

      // Make sure it's not a disconnected DOM node
      if ( !jQuery.contains( docElem, elem ) ) {
        return box;
      }

      // If we don't have gBCR, just use 0,0 rather than error
      // BlackBerry 5, iOS 3 (original iPhone)
      if ( typeof elem.getBoundingClientRect !== strundefined ) {
        box = elem.getBoundingClientRect();
      }
      win = getWindow( doc );
      return {
        top: box.top + ( win.pageYOffset || docElem.scrollTop ) - ( docElem.clientTop || 0 ),
        left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
      };
    },

    position: function () {
      if ( !this[ 0 ] ) {
        return;
      }

      var offsetParent, offset,
        parentOffset = { top: 0, left: 0 },
        elem = this[ 0 ];

      // fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
      if ( jQuery.css( elem, "position" ) === "fixed" ) {
        // we assume that getBoundingClientRect is available when computed position is fixed
        offset = elem.getBoundingClientRect();
      } else {
        // Get *real* offsetParent
        offsetParent = this.offsetParent();

        // Get correct offsets
        offset = this.offset();
        if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
          parentOffset = offsetParent.offset();
        }

        // Add offsetParent borders
        parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
        parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
      }

      // Subtract parent offsets and element margins
      // note: when an element has margin: auto the offsetLeft and marginLeft
      // are the same in Safari causing offset.left to incorrectly be 0
      return {
        top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
        left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true)
      };
    },

    offsetParent: function () {
      return this.map(function () {
        var offsetParent = this.offsetParent || docElem;

        while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
          offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || docElem;
      });
    }
  });

  // Create scrollLeft and scrollTop methods
  jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function ( method, prop ) {
    var top = /Y/.test( prop );

    jQuery.fn[ method ] = function ( val ) {
      return access( this, function ( elem, method, val ) {
        var win = getWindow( elem );

        if ( val === undefined ) {
          return win ? (prop in win) ? win[ prop ] :
            win.document.documentElement[ method ] :
            elem[ method ];
        }

        if ( win ) {
          win.scrollTo(
            !top ? val : jQuery( win ).scrollLeft(),
            top ? val : jQuery( win ).scrollTop()
          );

        } else {
          elem[ method ] = val;
        }
      }, method, val, arguments.length, null );
    };
  });

  // Add the top/left cssHooks using jQuery.fn.position
  // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
  // getComputedStyle returns percent when specified for top/left/bottom/right
  // rather than make the css module depend on the offset module, we just check for it here
  jQuery.each( [ "top", "left" ], function ( i, prop ) {
    jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
      function ( elem, computed ) {
        if ( computed ) {
          computed = curCSS( elem, prop );
          // if curCSS returns percentage, fallback to offset
          return rnumnonpx.test( computed ) ?
            jQuery( elem ).position()[ prop ] + "px" :
            computed;
        }
      }
    );
  });

  // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
  jQuery.each( { Height: "height", Width: "width" }, function ( name, type ) {
    jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function ( defaultExtra, funcName ) {
      // margin is only for outerHeight, outerWidth
      jQuery.fn[ funcName ] = function ( margin, value ) {
        var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
          extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

        return access( this, function ( elem, type, value ) {
          var doc;

          if ( jQuery.isWindow( elem ) ) {
            // As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
            // isn't a whole lot we can do. See pull request at this URL for discussion:
            // https://github.com/jquery/jquery/pull/764
            return elem.document.documentElement[ "client" + name ];
          }

          // Get document width or height
          if ( elem.nodeType === 9 ) {
            doc = elem.documentElement;

            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
            // unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.
            return Math.max(
              elem.body[ "scroll" + name ], doc[ "scroll" + name ],
              elem.body[ "offset" + name ], doc[ "offset" + name ],
              doc[ "client" + name ]
            );
          }

          return value === undefined ?
          // Get width or height on the element, requesting but not forcing parseFloat
            jQuery.css( elem, type, extra ) :

          // Set width or height on the element
            jQuery.style( elem, type, value, extra );
        }, type, chainable ? margin : undefined, chainable, null );
      };
    });
  });

  // The number of elements contained in the matched element set
  jQuery.fn.size = function () {
    return this.length;
  };

  jQuery.fn.andSelf = jQuery.fn.addBack;

  // Register as a named AMD module, since jQuery can be concatenated with other
  // files that may use define, but not via a proper concatenation script that
  // understands anonymous AMD modules. A named AMD is safest and most robust
  // way to register. Lowercase jquery is used because AMD module names are
  // derived from file names, and jQuery is normally delivered in a lowercase
  // file name. Do this after creating the global so that if an AMD module wants
  // to call noConflict to hide this version of jQuery, it will work.

  // Note that for maximum portability, libraries that are not jQuery should
  // declare themselves as anonymous modules, and avoid setting a global if an
  // AMD loader is present. jQuery is a special case. For more information, see
  // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

  if ( typeof define === "function" && define.amd ) {
    define( "jquery", [], function () {
      return jQuery;
    });
  }

  var
    // Map over jQuery in case of overwrite
    _jQuery = window.jQuery,

    // Map over the $ in case of overwrite
    _$ = window.$;

  jQuery.noConflict = function ( deep ) {
    if ( window.$ === jQuery ) {
      window.$ = _$;
    }

    if ( deep && window.jQuery === jQuery ) {
      window.jQuery = _jQuery;
    }

    return jQuery;
  };

  // Expose jQuery and $ identifiers, even in
  // AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
  // and CommonJS for browser emulators (#13566)
  if ( typeof noGlobal === strundefined ) {
    window.jQuery = window.$ = jQuery;
  }

  return jQuery;

}));

/* ! jQuery UI - v1.12.1 - 2016-09-14
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function (t) {"function" === typeof define && define.amd ? define(["jquery"], t) : t(jQuery);})(function (t) {function e(t) {for (var e = t.css("visibility");"inherit" === e;)t = t.parent(), e = t.css("visibility");return "hidden" !== e;} function i(t) {for (var e, i;t.length && t[0] !== document;) {if (e = t.css("position"), ("absolute" === e || "relative" === e || "fixed" === e) && (i = parseInt(t.css("zIndex"), 10), !isNaN(i) && 0 !== i)) return i;t = t.parent();} return 0;} function s() {this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = "ui-datepicker-div", this._inlineClass = "ui-datepicker-inline", this._appendClass = "ui-datepicker-append", this._triggerClass = "ui-datepicker-trigger", this._dialogClass = "ui-datepicker-dialog", this._disableClass = "ui-datepicker-disabled", this._unselectableClass = "ui-datepicker-unselectable", this._currentClass = "ui-datepicker-current-day", this._dayOverClass = "ui-datepicker-days-cell-over", this.regional = [], this.regional[""] = { closeText: "Done", prevText: "Prev", nextText: "Next", currentText: "Today", monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], weekHeader: "Wk", dateFormat: "mm/dd/yy", firstDay: 0, isRTL: !1, showMonthAfterYear: !1, yearSuffix: "" }, this._defaults = { showOn: "focus", showAnim: "fadeIn", showOptions: {}, defaultDate: null, appendText: "", buttonText: "...", buttonImage: "", buttonImageOnly: !1, hideIfNoPrevNext: !1, navigationAsDateFormat: !1, gotoCurrent: !1, changeMonth: !1, changeYear: !1, yearRange: "c-10:c+10", showOtherMonths: !1, selectOtherMonths: !1, showWeek: !1, calculateWeek: this.iso8601Week, shortYearCutoff: "+10", minDate: null, maxDate: null, duration: "fast", beforeShowDay: null, beforeShow: null, onSelect: null, onChangeMonthYear: null, onClose: null, numberOfMonths: 1, showCurrentAtPos: 0, stepMonths: 1, stepBigMonths: 12, altField: "", altFormat: "", constrainInput: !0, showButtonPanel: !1, autoSize: !1, disabled: !1 }, t.extend(this._defaults, this.regional[""]), this.regional.en = t.extend(!0, {}, this.regional[""]), this.regional["en-US"] = t.extend(!0, {}, this.regional.en), this.dpDiv = n(t("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));} function n(e) {var i = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.on("mouseout", i, function () {t(this).removeClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && t(this).removeClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && t(this).removeClass("ui-datepicker-next-hover");}).on("mouseover", i, o);} function o() {t.datepicker._isDisabledDatepicker(m.inline ? m.dpDiv.parent()[0] : m.input[0]) || (t(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"), t(this).addClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && t(this).addClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && t(this).addClass("ui-datepicker-next-hover"));} function a(e, i) {t.extend(e, i);for (var s in i)null == i[s] && (e[s] = i[s]);return e;} function r(t) {return function () {var e = this.element.val();t.apply(this, arguments), this._refresh(), e !== this.element.val() && this._trigger("change");};}t.ui = t.ui || {}, t.ui.version = "1.12.1";var h = 0, l = Array.prototype.slice;t.cleanData = function (e) {return function (i) {var s, n, o;for (o = 0;null != (n = i[o]);o++) try {s = t._data(n, "events"), s && s.remove && t(n).triggerHandler("remove");} catch (a) {}e(i);};}(t.cleanData), t.widget = function (e, i, s) {var n, o, a, r = {}, h = e.split(".")[0];e = e.split(".")[1];var l = h + "-" + e;return s || (s = i, i = t.Widget), t.isArray(s) && (s = t.extend.apply(null, [{}].concat(s))), t.expr[":"][l.toLowerCase()] = function (e) {return !!t.data(e, l);}, t[h] = t[h] || {}, n = t[h][e], o = t[h][e] = function (t, e) {return this._createWidget ? (arguments.length && this._createWidget(t, e), void 0) : new o(t, e);}, t.extend(o, n, { version: s.version, _proto: t.extend({}, s), _childConstructors: [] }), a = new i, a.options = t.widget.extend({}, a.options), t.each(s, function (e, s) {return t.isFunction(s) ? (r[e] = function () {function t() {return i.prototype[e].apply(this, arguments);} function n(t) {return i.prototype[e].apply(this, t);} return function () {var e, i = this._super, o = this._superApply;return this._super = t, this._superApply = n, e = s.apply(this, arguments), this._super = i, this._superApply = o, e;};}(), void 0) : (r[e] = s, void 0);}), o.prototype = t.widget.extend(a, { widgetEventPrefix: n ? a.widgetEventPrefix || e : e }, r, { constructor: o, namespace: h, widgetName: e, widgetFullName: l }), n ? (t.each(n._childConstructors, function (e, i) {var s = i.prototype;t.widget(s.namespace + "." + s.widgetName, o, i._proto);}), delete n._childConstructors) : i._childConstructors.push(o), t.widget.bridge(e, o), o;}, t.widget.extend = function (e) {for (var i, s, n = l.call(arguments, 1), o = 0, a = n.length;a > o;o++) for (i in n[o])s = n[o][i], n[o].hasOwnProperty(i) && void 0 !== s && (e[i] = t.isPlainObject(s) ? t.isPlainObject(e[i]) ? t.widget.extend({}, e[i], s) : t.widget.extend({}, s) : s);return e;}, t.widget.bridge = function (e, i) {var s = i.prototype.widgetFullName || e;t.fn[e] = function (n) {var o = "string" === typeof n, a = l.call(arguments, 1), r = this;return o ? this.length || "instance" !== n ? this.each(function () {var i, o = t.data(this, s);return "instance" === n ? (r = o, !1) : o ? t.isFunction(o[n]) && "_" !== n.charAt(0) ? (i = o[n].apply(o, a), i !== o && void 0 !== i ? (r = i && i.jquery ? r.pushStack(i.get()) : i, !1) : void 0) : t.error("no such method '" + n + "' for " + e + " widget instance") : t.error("cannot call methods on " + e + " prior to initialization; " + "attempted to call method '" + n + "'");}) : r = void 0 : (a.length && (n = t.widget.extend.apply(null, [n].concat(a))), this.each(function () {var e = t.data(this, s);e ? (e.option(n || {}), e._init && e._init()) : t.data(this, s, new i(n, this));})), r;};}, t.Widget = function () {}, t.Widget._childConstructors = [], t.Widget.prototype = { widgetName: "widget", widgetEventPrefix: "", defaultElement: "<div>", options: { classes: {}, disabled: !1, create: null }, _createWidget: function (e, i) {i = t(i || this.defaultElement || this)[0], this.element = t(i), this.uuid = h++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = t(), this.hoverable = t(), this.focusable = t(), this.classesElementLookup = {}, i !== this && (t.data(i, this.widgetFullName, this), this._on(!0, this.element, { remove: function (t) {t.target === i && this.destroy();} }), this.document = t(i.style ? i.ownerDocument : i.document || i), this.window = t(this.document[0].defaultView || this.document[0].parentWindow)), this.options = t.widget.extend({}, this.options, this._getCreateOptions(), e), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init();}, _getCreateOptions: function () {return {};}, _getCreateEventData: t.noop, _create: t.noop, _init: t.noop, destroy: function () {var e = this;this._destroy(), t.each(this.classesElementLookup, function (t, i) {e._removeClass(i, t);}), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace);}, _destroy: t.noop, widget: function () {return this.element;}, option: function (e, i) {var s, n, o, a = e;if (0 === arguments.length) return t.widget.extend({}, this.options);if ("string" === typeof e) if (a = {}, s = e.split("."), e = s.shift(), s.length) {for (n = a[e] = t.widget.extend({}, this.options[e]), o = 0;s.length - 1 > o;o++)n[s[o]] = n[s[o]] || {}, n = n[s[o]];if (e = s.pop(), 1 === arguments.length) return void 0 === n[e] ? null : n[e];n[e] = i;} else {if (1 === arguments.length) return void 0 === this.options[e] ? null : this.options[e];a[e] = i;} return this._setOptions(a), this;}, _setOptions: function (t) {var e;for (e in t) this._setOption(e, t[e]);return this;}, _setOption: function (t, e) {return "classes" === t && this._setOptionClasses(e), this.options[t] = e, "disabled" === t && this._setOptionDisabled(e), this;}, _setOptionClasses: function (e) {var i, s, n;for (i in e)n = this.classesElementLookup[i], e[i] !== this.options.classes[i] && n && n.length && (s = t(n.get()), this._removeClass(n, i), s.addClass(this._classes({ element: s, keys: i, classes: e, add: !0 })));}, _setOptionDisabled: function (t) {this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!t), t && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"));}, enable: function () {return this._setOptions({ disabled: !1 });}, disable: function () {return this._setOptions({ disabled: !0 });}, _classes: function (e) {function i(i, o) {var a, r;for (r = 0;i.length > r;r++)a = n.classesElementLookup[i[r]] || t(), a = e.add ? t(t.unique(a.get().concat(e.element.get()))) : t(a.not(e.element).get()), n.classesElementLookup[i[r]] = a, s.push(i[r]), o && e.classes[i[r]] && s.push(e.classes[i[r]]);} var s = [], n = this;return e = t.extend({ element: this.element, classes: this.options.classes || {} }, e), this._on(e.element, { remove: "_untrackClassesElement" }), e.keys && i(e.keys.match(/\S+/g) || [], !0), e.extra && i(e.extra.match(/\S+/g) || []), s.join(" ");}, _untrackClassesElement: function (e) {var i = this;t.each(i.classesElementLookup, function (s, n) {-1 !== t.inArray(e.target, n) && (i.classesElementLookup[s] = t(n.not(e.target).get()));});}, _removeClass: function (t, e, i) {return this._toggleClass(t, e, i, !1);}, _addClass: function (t, e, i) {return this._toggleClass(t, e, i, !0);}, _toggleClass: function (t, e, i, s) {s = "boolean" === typeof s ? s : i;var n = "string" === typeof t || null === t, o = { extra: n ? e : i, keys: n ? t : e, element: n ? this.element : t, add: s };return o.element.toggleClass(this._classes(o), s), this;}, _on: function (e, i, s) {var n, o = this;"boolean" !== typeof e && (s = i, i = e, e = !1), s ? (i = n = t(i), this.bindings = this.bindings.add(i)) : (s = i, i = this.element, n = this.widget()), t.each(s, function (s, a) {function r() {return e || o.options.disabled !== !0 && !t(this).hasClass("ui-state-disabled") ? ("string" === typeof a ? o[a] : a).apply(o, arguments) : void 0;}"string" !== typeof a && (r.guid = a.guid = a.guid || r.guid || t.guid++);var h = s.match(/^([\w:-]*)\s*(.*)$/), l = h[1] + o.eventNamespace, c = h[2];c ? n.on(l, c, r) : i.on(l, r);});}, _off: function (e, i) {i = (i || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, e.off(i).off(i), this.bindings = t(this.bindings.not(e).get()), this.focusable = t(this.focusable.not(e).get()), this.hoverable = t(this.hoverable.not(e).get());}, _delay: function (t, e) {function i() {return ("string" === typeof t ? s[t] : t).apply(s, arguments);} var s = this;return setTimeout(i, e || 0);}, _hoverable: function (e) {this.hoverable = this.hoverable.add(e), this._on(e, { mouseenter: function (e) {this._addClass(t(e.currentTarget), null, "ui-state-hover");}, mouseleave: function (e) {this._removeClass(t(e.currentTarget), null, "ui-state-hover");} });}, _focusable: function (e) {this.focusable = this.focusable.add(e), this._on(e, { focusin: function (e) {this._addClass(t(e.currentTarget), null, "ui-state-focus");}, focusout: function (e) {this._removeClass(t(e.currentTarget), null, "ui-state-focus");} });}, _trigger: function (e, i, s) {var n, o, a = this.options[e];if (s = s || {}, i = t.Event(i), i.type = (e === this.widgetEventPrefix ? e : this.widgetEventPrefix + e).toLowerCase(), i.target = this.element[0], o = i.originalEvent) for (n in o)n in i || (i[n] = o[n]);return this.element.trigger(i, s), !(t.isFunction(a) && a.apply(this.element[0], [i].concat(s)) === !1 || i.isDefaultPrevented());} }, t.each({ show: "fadeIn", hide: "fadeOut" }, function (e, i) {t.Widget.prototype["_" + e] = function (s, n, o) {"string" === typeof n && (n = { effect: n });var a, r = n ? n === !0 || "number" === typeof n ? i : n.effect || i : e;n = n || {}, "number" === typeof n && (n = { duration: n }), a = !t.isEmptyObject(n), n.complete = o, n.delay && s.delay(n.delay), a && t.effects && t.effects.effect[r] ? s[e](n) : r !== e && s[r] ? s[r](n.duration, n.easing, o) : s.queue(function (i) {t(this)[e](), o && o.call(s[0]), i();});};}), t.widget, function () {function e(t, e, i) {return [parseFloat(t[0]) * (u.test(t[0]) ? e / 100 : 1), parseFloat(t[1]) * (u.test(t[1]) ? i / 100 : 1)];} function i(e, i) {return parseInt(t.css(e, i), 10) || 0;} function s(e) {var i = e[0];return 9 === i.nodeType ? { width: e.width(), height: e.height(), offset: { top: 0, left: 0 } } : t.isWindow(i) ? { width: e.width(), height: e.height(), offset: { top: e.scrollTop(), left: e.scrollLeft() } } : i.preventDefault ? { width: 0, height: 0, offset: { top: i.pageY, left: i.pageX } } : { width: e.outerWidth(), height: e.outerHeight(), offset: e.offset() };} var n, o = Math.max, a = Math.abs, r = /left|center|right/, h = /top|center|bottom/, l = /[\+\-]\d+(\.[\d]+)?%?/, c = /^\w+/, u = /%$/, d = t.fn.position;t.position = { scrollbarWidth: function () {if (void 0 !== n) return n;var e, i, s = t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"), o = s.children()[0];return t("body").append(s), e = o.offsetWidth, s.css("overflow", "scroll"), i = o.offsetWidth, e === i && (i = s[0].clientWidth), s.remove(), n = e - i;}, getScrollInfo: function (e) {var i = e.isWindow || e.isDocument ? "" : e.element.css("overflow-x"), s = e.isWindow || e.isDocument ? "" : e.element.css("overflow-y"), n = "scroll" === i || "auto" === i && e.width < e.element[0].scrollWidth, o = "scroll" === s || "auto" === s && e.height < e.element[0].scrollHeight;return { width: o ? t.position.scrollbarWidth() : 0, height: n ? t.position.scrollbarWidth() : 0 };}, getWithinInfo: function (e) {var i = t(e || window), s = t.isWindow(i[0]), n = !!i[0] && 9 === i[0].nodeType, o = !s && !n;return { element: i, isWindow: s, isDocument: n, offset: o ? t(e).offset() : { left: 0, top: 0 }, scrollLeft: i.scrollLeft(), scrollTop: i.scrollTop(), width: i.outerWidth(), height: i.outerHeight() };} }, t.fn.position = function (n) {if (!n || !n.of) return d.apply(this, arguments);n = t.extend({}, n);var u, p, f, g, m, _, v = t(n.of), b = t.position.getWithinInfo(n.within), y = t.position.getScrollInfo(b), w = (n.collision || "flip").split(" "), k = {};return _ = s(v), v[0].preventDefault && (n.at = "left top"), p = _.width, f = _.height, g = _.offset, m = t.extend({}, g), t.each(["my", "at"], function () {var t, e, i = (n[this] || "").split(" ");1 === i.length && (i = r.test(i[0]) ? i.concat(["center"]) : h.test(i[0]) ? ["center"].concat(i) : ["center", "center"]), i[0] = r.test(i[0]) ? i[0] : "center", i[1] = h.test(i[1]) ? i[1] : "center", t = l.exec(i[0]), e = l.exec(i[1]), k[this] = [t ? t[0] : 0, e ? e[0] : 0], n[this] = [c.exec(i[0])[0], c.exec(i[1])[0]];}), 1 === w.length && (w[1] = w[0]), "right" === n.at[0] ? m.left += p : "center" === n.at[0] && (m.left += p / 2), "bottom" === n.at[1] ? m.top += f : "center" === n.at[1] && (m.top += f / 2), u = e(k.at, p, f), m.left += u[0], m.top += u[1], this.each(function () {var s, r, h = t(this), l = h.outerWidth(), c = h.outerHeight(), d = i(this, "marginLeft"), _ = i(this, "marginTop"), x = l + d + i(this, "marginRight") + y.width, C = c + _ + i(this, "marginBottom") + y.height, D = t.extend({}, m), I = e(k.my, h.outerWidth(), h.outerHeight());"right" === n.my[0] ? D.left -= l : "center" === n.my[0] && (D.left -= l / 2), "bottom" === n.my[1] ? D.top -= c : "center" === n.my[1] && (D.top -= c / 2), D.left += I[0], D.top += I[1], s = { marginLeft: d, marginTop: _ }, t.each(["left", "top"], function (e, i) {t.ui.position[w[e]] && t.ui.position[w[e]][i](D, { targetWidth: p, targetHeight: f, elemWidth: l, elemHeight: c, collisionPosition: s, collisionWidth: x, collisionHeight: C, offset: [u[0] + I[0], u[1] + I[1]], my: n.my, at: n.at, within: b, elem: h });}), n.using && (r = function (t) {var e = g.left - D.left, i = e + p - l, s = g.top - D.top, r = s + f - c, u = { target: { element: v, left: g.left, top: g.top, width: p, height: f }, element: { element: h, left: D.left, top: D.top, width: l, height: c }, horizontal: 0 > i ? "left" : e > 0 ? "right" : "center", vertical: 0 > r ? "top" : s > 0 ? "bottom" : "middle" };l > p && p > a(e + i) && (u.horizontal = "center"), c > f && f > a(s + r) && (u.vertical = "middle"), u.important = o(a(e), a(i)) > o(a(s), a(r)) ? "horizontal" : "vertical", n.using.call(this, t, u);}), h.offset(t.extend(D, { using: r }));});}, t.ui.position = { fit: { left: function (t, e) {var i, s = e.within, n = s.isWindow ? s.scrollLeft : s.offset.left, a = s.width, r = t.left - e.collisionPosition.marginLeft, h = n - r, l = r + e.collisionWidth - a - n;e.collisionWidth > a ? h > 0 && 0 >= l ? (i = t.left + h + e.collisionWidth - a - n, t.left += h - i) : t.left = l > 0 && 0 >= h ? n : h > l ? n + a - e.collisionWidth : n : h > 0 ? t.left += h : l > 0 ? t.left -= l : t.left = o(t.left - r, t.left);}, top: function (t, e) {var i, s = e.within, n = s.isWindow ? s.scrollTop : s.offset.top, a = e.within.height, r = t.top - e.collisionPosition.marginTop, h = n - r, l = r + e.collisionHeight - a - n;e.collisionHeight > a ? h > 0 && 0 >= l ? (i = t.top + h + e.collisionHeight - a - n, t.top += h - i) : t.top = l > 0 && 0 >= h ? n : h > l ? n + a - e.collisionHeight : n : h > 0 ? t.top += h : l > 0 ? t.top -= l : t.top = o(t.top - r, t.top);} }, flip: { left: function (t, e) {var i, s, n = e.within, o = n.offset.left + n.scrollLeft, r = n.width, h = n.isWindow ? n.scrollLeft : n.offset.left, l = t.left - e.collisionPosition.marginLeft, c = l - h, u = l + e.collisionWidth - r - h, d = "left" === e.my[0] ? -e.elemWidth : "right" === e.my[0] ? e.elemWidth : 0, p = "left" === e.at[0] ? e.targetWidth : "right" === e.at[0] ? -e.targetWidth : 0, f = -2 * e.offset[0];0 > c ? (i = t.left + d + p + f + e.collisionWidth - r - o, (0 > i || a(c) > i) && (t.left += d + p + f)) : u > 0 && (s = t.left - e.collisionPosition.marginLeft + d + p + f - h, (s > 0 || u > a(s)) && (t.left += d + p + f));}, top: function (t, e) {var i, s, n = e.within, o = n.offset.top + n.scrollTop, r = n.height, h = n.isWindow ? n.scrollTop : n.offset.top, l = t.top - e.collisionPosition.marginTop, c = l - h, u = l + e.collisionHeight - r - h, d = "top" === e.my[1], p = d ? -e.elemHeight : "bottom" === e.my[1] ? e.elemHeight : 0, f = "top" === e.at[1] ? e.targetHeight : "bottom" === e.at[1] ? -e.targetHeight : 0, g = -2 * e.offset[1];0 > c ? (s = t.top + p + f + g + e.collisionHeight - r - o, (0 > s || a(c) > s) && (t.top += p + f + g)) : u > 0 && (i = t.top - e.collisionPosition.marginTop + p + f + g - h, (i > 0 || u > a(i)) && (t.top += p + f + g));} }, flipfit: { left: function () {t.ui.position.flip.left.apply(this, arguments), t.ui.position.fit.left.apply(this, arguments);}, top: function () {t.ui.position.flip.top.apply(this, arguments), t.ui.position.fit.top.apply(this, arguments);} } };}(), t.ui.position, t.extend(t.expr[":"], { data: t.expr.createPseudo ? t.expr.createPseudo(function (e) {return function (i) {return !!t.data(i, e);};}) : function (e, i, s) {return !!t.data(e, s[3]);} }), t.fn.extend({ disableSelection: function () {var t = "onselectstart" in document.createElement("div") ? "selectstart" : "mousedown";return function () {return this.on(t + ".ui-disableSelection", function (t) {t.preventDefault();});};}(), enableSelection: function () {return this.off(".ui-disableSelection");} });var c = "ui-effects-", u = "ui-effects-style", d = "ui-effects-animated", p = t;t.effects = { effect: {} }, function (t, e) {function i(t, e, i) {var s = u[e.type] || {};return null == t ? i || !e.def ? null : e.def : (t = s.floor ? ~~t : parseFloat(t), isNaN(t) ? e.def : s.mod ? (t + s.mod) % s.mod : 0 > t ? 0 : t > s.max ? s.max : t);} function s(i) {var s = l(), n = s._rgba = [];return i = i.toLowerCase(), f(h, function (t, o) {var a, r = o.re.exec(i), h = r && o.parse(r), l = o.space || "rgba";return h ? (a = s[l](h), s[c[l].cache] = a[c[l].cache], n = s._rgba = a._rgba, !1) : e;}), n.length ? ("0,0,0,0" === n.join() && t.extend(n, o.transparent), s) : o[i];} function n(t, e, i) {return i = (i + 1) % 1, 1 > 6 * i ? t + 6 * (e - t) * i : 1 > 2 * i ? e : 2 > 3 * i ? t + 6 * (e - t) * (2 / 3 - i) : t;} var o, a = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor", r = /^([\-+])=\s*(\d+\.?\d*)/, h = [{ re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, parse: function (t) {return [t[1], t[2], t[3], t[4]];} }, { re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, parse: function (t) {return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]];} }, { re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/, parse: function (t) {return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];} }, { re: /#([a-f0-9])([a-f0-9])([a-f0-9])/, parse: function (t) {return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)];} }, { re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, space: "hsla", parse: function (t) {return [t[1], t[2] / 100, t[3] / 100, t[4]];} }], l = t.Color = function (e, i, s, n) {return new t.Color.fn.parse(e, i, s, n);}, c = { rgba: { props: { red: { idx: 0, type: "byte" }, green: { idx: 1, type: "byte" }, blue: { idx: 2, type: "byte" } } }, hsla: { props: { hue: { idx: 0, type: "degrees" }, saturation: { idx: 1, type: "percent" }, lightness: { idx: 2, type: "percent" } } } }, u = { "byte": { floor: !0, max: 255 }, percent: { max: 1 }, degrees: { mod: 360, floor: !0 } }, d = l.support = {}, p = t("<p>")[0], f = t.each;p.style.cssText = "background-color:rgba(1,1,1,.5)", d.rgba = p.style.backgroundColor.indexOf("rgba") > -1, f(c, function (t, e) {e.cache = "_" + t, e.props.alpha = { idx: 3, type: "percent", def: 1 };}), l.fn = t.extend(l.prototype, { parse: function (n, a, r, h) {if (n === e) return this._rgba = [null, null, null, null], this;(n.jquery || n.nodeType) && (n = t(n).css(a), a = e);var u = this, d = t.type(n), p = this._rgba = [];return a !== e && (n = [n, a, r, h], d = "array"), "string" === d ? this.parse(s(n) || o._default) : "array" === d ? (f(c.rgba.props, function (t, e) {p[e.idx] = i(n[e.idx], e);}), this) : "object" === d ? (n instanceof l ? f(c, function (t, e) {n[e.cache] && (u[e.cache] = n[e.cache].slice());}) : f(c, function (e, s) {var o = s.cache;f(s.props, function (t, e) {if (!u[o] && s.to) {if ("alpha" === t || null == n[t]) return;u[o] = s.to(u._rgba);}u[o][e.idx] = i(n[t], e, !0);}), u[o] && 0 > t.inArray(null, u[o].slice(0, 3)) && (u[o][3] = 1, s.from && (u._rgba = s.from(u[o])));}), this) : e;}, is: function (t) {var i = l(t), s = !0, n = this;return f(c, function (t, o) {var a, r = i[o.cache];return r && (a = n[o.cache] || o.to && o.to(n._rgba) || [], f(o.props, function (t, i) {return null != r[i.idx] ? s = r[i.idx] === a[i.idx] : e;})), s;}), s;}, _space: function () {var t = [], e = this;return f(c, function (i, s) {e[s.cache] && t.push(i);}), t.pop();}, transition: function (t, e) {var s = l(t), n = s._space(), o = c[n], a = 0 === this.alpha() ? l("transparent") : this, r = a[o.cache] || o.to(a._rgba), h = r.slice();return s = s[o.cache], f(o.props, function (t, n) {var o = n.idx, a = r[o], l = s[o], c = u[n.type] || {};null !== l && (null === a ? h[o] = l : (c.mod && (l - a > c.mod / 2 ? a += c.mod : a - l > c.mod / 2 && (a -= c.mod)), h[o] = i((l - a) * e + a, n)));}), this[n](h);}, blend: function (e) {if (1 === this._rgba[3]) return this;var i = this._rgba.slice(), s = i.pop(), n = l(e)._rgba;return l(t.map(i, function (t, e) {return (1 - s) * n[e] + s * t;}));}, toRgbaString: function () {var e = "rgba(", i = t.map(this._rgba, function (t, e) {return null == t ? e > 2 ? 1 : 0 : t;});return 1 === i[3] && (i.pop(), e = "rgb("), e + i.join() + ")";}, toHslaString: function () {var e = "hsla(", i = t.map(this.hsla(), function (t, e) {return null == t && (t = e > 2 ? 1 : 0), e && 3 > e && (t = Math.round(100 * t) + "%"), t;});return 1 === i[3] && (i.pop(), e = "hsl("), e + i.join() + ")";}, toHexString: function (e) {var i = this._rgba.slice(), s = i.pop();return e && i.push(~~(255 * s)), "#" + t.map(i, function (t) {return t = (t || 0).toString(16), 1 === t.length ? "0" + t : t;}).join("");}, toString: function () {return 0 === this._rgba[3] ? "transparent" : this.toRgbaString();} }), l.fn.parse.prototype = l.fn, c.hsla.to = function (t) {if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];var e, i, s = t[0] / 255, n = t[1] / 255, o = t[2] / 255, a = t[3], r = Math.max(s, n, o), h = Math.min(s, n, o), l = r - h, c = r + h, u = .5 * c;return e = h === r ? 0 : s === r ? 60 * (n - o) / l + 360 : n === r ? 60 * (o - s) / l + 120 : 60 * (s - n) / l + 240, i = 0 === l ? 0 : .5 >= u ? l / c : l / (2 - c), [Math.round(e) % 360, i, u, null == a ? 1 : a];}, c.hsla.from = function (t) {if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];var e = t[0] / 360, i = t[1], s = t[2], o = t[3], a = .5 >= s ? s * (1 + i) : s + i - s * i, r = 2 * s - a;return [Math.round(255 * n(r, a, e + 1 / 3)), Math.round(255 * n(r, a, e)), Math.round(255 * n(r, a, e - 1 / 3)), o];}, f(c, function (s, n) {var o = n.props, a = n.cache, h = n.to, c = n.from;l.fn[s] = function (s) {if (h && !this[a] && (this[a] = h(this._rgba)), s === e) return this[a].slice();var n, r = t.type(s), u = "array" === r || "object" === r ? s : arguments, d = this[a].slice();return f(o, function (t, e) {var s = u["object" === r ? t : e.idx];null == s && (s = d[e.idx]), d[e.idx] = i(s, e);}), c ? (n = l(c(d)), n[a] = d, n) : l(d);}, f(o, function (e, i) {l.fn[e] || (l.fn[e] = function (n) {var o, a = t.type(n), h = "alpha" === e ? this._hsla ? "hsla" : "rgba" : s, l = this[h](), c = l[i.idx];return "undefined" === a ? c : ("function" === a && (n = n.call(this, c), a = t.type(n)), null == n && i.empty ? this : ("string" === a && (o = r.exec(n), o && (n = c + parseFloat(o[2]) * ("+" === o[1] ? 1 : -1))), l[i.idx] = n, this[h](l)));});});}), l.hook = function (e) {var i = e.split(" ");f(i, function (e, i) {t.cssHooks[i] = { set: function (e, n) {var o, a, r = "";if ("transparent" !== n && ("string" !== t.type(n) || (o = s(n)))) {if (n = l(o || n), !d.rgba && 1 !== n._rgba[3]) {for (a = "backgroundColor" === i ? e.parentNode : e;("" === r || "transparent" === r) && a && a.style;) try {r = t.css(a, "backgroundColor"), a = a.parentNode;} catch (h) {}n = n.blend(r && "transparent" !== r ? r : "_default");}n = n.toRgbaString();} try {e.style[i] = n;} catch (h) {}} }, t.fx.step[i] = function (e) {e.colorInit || (e.start = l(e.elem, i), e.end = l(e.end), e.colorInit = !0), t.cssHooks[i].set(e.elem, e.start.transition(e.end, e.pos));};});}, l.hook(a), t.cssHooks.borderColor = { expand: function (t) {var e = {};return f(["Top", "Right", "Bottom", "Left"], function (i, s) {e["border" + s + "Color"] = t;}), e;} }, o = t.Color.names = { aqua: "#00ffff", black: "#000000", blue: "#0000ff", fuchsia: "#ff00ff", gray: "#808080", green: "#008000", lime: "#00ff00", maroon: "#800000", navy: "#000080", olive: "#808000", purple: "#800080", red: "#ff0000", silver: "#c0c0c0", teal: "#008080", white: "#ffffff", yellow: "#ffff00", transparent: [null, null, null, 0], _default: "#ffffff" };}(p), function () {function e(e) {var i, s, n = e.ownerDocument.defaultView ? e.ownerDocument.defaultView.getComputedStyle(e, null) : e.currentStyle, o = {};if (n && n.length && n[0] && n[n[0]]) for (s = n.length;s--;)i = n[s], "string" === typeof n[i] && (o[t.camelCase(i)] = n[i]);else for (i in n)"string" === typeof n[i] && (o[i] = n[i]);return o;} function i(e, i) {var s, o, a = {};for (s in i)o = i[s], e[s] !== o && (n[s] || (t.fx.step[s] || !isNaN(parseFloat(o))) && (a[s] = o));return a;} var s = ["add", "remove", "toggle"], n = { border: 1, borderBottom: 1, borderColor: 1, borderLeft: 1, borderRight: 1, borderTop: 1, borderWidth: 1, margin: 1, padding: 1 };t.each(["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"], function (e, i) {t.fx.step[i] = function (t) {("none" !== t.end && !t.setAttr || 1 === t.pos && !t.setAttr) && (p.style(t.elem, i, t.end), t.setAttr = !0);};}), t.fn.addBack || (t.fn.addBack = function (t) {return this.add(null == t ? this.prevObject : this.prevObject.filter(t));}), t.effects.animateClass = function (n, o, a, r) {var h = t.speed(o, a, r);return this.queue(function () {var o, a = t(this), r = a.attr("class") || "", l = h.children ? a.find("*").addBack() : a;l = l.map(function () {var i = t(this);return { el: i, start: e(this) };}), o = function () {t.each(s, function (t, e) {n[e] && a[e + "Class"](n[e]);});}, o(), l = l.map(function () {return this.end = e(this.el[0]), this.diff = i(this.start, this.end), this;}), a.attr("class", r), l = l.map(function () {var e = this, i = t.Deferred(), s = t.extend({}, h, { queue: !1, complete: function () {i.resolve(e);} });return this.el.animate(this.diff, s), i.promise();}), t.when.apply(t, l.get()).done(function () {o(), t.each(arguments, function () {var e = this.el;t.each(this.diff, function (t) {e.css(t, "");});}), h.complete.call(a[0]);});});}, t.fn.extend({ addClass: function (e) {return function (i, s, n, o) {return s ? t.effects.animateClass.call(this, { add: i }, s, n, o) : e.apply(this, arguments);};}(t.fn.addClass), removeClass: function (e) {return function (i, s, n, o) {return arguments.length > 1 ? t.effects.animateClass.call(this, { remove: i }, s, n, o) : e.apply(this, arguments);};}(t.fn.removeClass), toggleClass: function (e) {return function (i, s, n, o, a) {return "boolean" === typeof s || void 0 === s ? n ? t.effects.animateClass.call(this, s ? { add: i } : { remove: i }, n, o, a) : e.apply(this, arguments) : t.effects.animateClass.call(this, { toggle: i }, s, n, o);};}(t.fn.toggleClass), switchClass: function (e, i, s, n, o) {return t.effects.animateClass.call(this, { add: i, remove: e }, s, n, o);} });}(), function () {function e(e, i, s, n) {return t.isPlainObject(e) && (i = e, e = e.effect), e = { effect: e }, null == i && (i = {}), t.isFunction(i) && (n = i, s = null, i = {}), ("number" === typeof i || t.fx.speeds[i]) && (n = s, s = i, i = {}), t.isFunction(s) && (n = s, s = null), i && t.extend(e, i), s = s || i.duration, e.duration = t.fx.off ? 0 : "number" === typeof s ? s : s in t.fx.speeds ? t.fx.speeds[s] : t.fx.speeds._default, e.complete = n || i.complete, e;} function i(e) {return !e || "number" === typeof e || t.fx.speeds[e] ? !0 : "string" !== typeof e || t.effects.effect[e] ? t.isFunction(e) ? !0 : "object" !== typeof e || e.effect ? !1 : !0 : !0;} function s(t, e) {var i = e.outerWidth(), s = e.outerHeight(), n = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/, o = n.exec(t) || ["", 0, i, s, 0];return { top: parseFloat(o[1]) || 0, right: "auto" === o[2] ? i : parseFloat(o[2]), bottom: "auto" === o[3] ? s : parseFloat(o[3]), left: parseFloat(o[4]) || 0 };}t.expr && t.expr.filters && t.expr.filters.animated && (t.expr.filters.animated = function (e) {return function (i) {return !!t(i).data(d) || e(i);};}(t.expr.filters.animated)), t.uiBackCompat !== !1 && t.extend(t.effects, { save: function (t, e) {for (var i = 0, s = e.length;s > i;i++)null !== e[i] && t.data(c + e[i], t[0].style[e[i]]);}, restore: function (t, e) {for (var i, s = 0, n = e.length;n > s;s++)null !== e[s] && (i = t.data(c + e[s]), t.css(e[s], i));}, setMode: function (t, e) {return "toggle" === e && (e = t.is(":hidden") ? "show" : "hide"), e;}, createWrapper: function (e) {if (e.parent().is(".ui-effects-wrapper")) return e.parent();var i = { width: e.outerWidth(!0), height: e.outerHeight(!0), "float": e.css("float") }, s = t("<div></div>").addClass("ui-effects-wrapper").css({ fontSize: "100%", background: "transparent", border: "none", margin: 0, padding: 0 }), n = { width: e.width(), height: e.height() }, o = document.activeElement;try {o.id;} catch (a) {o = document.body;} return e.wrap(s), (e[0] === o || t.contains(e[0], o)) && t(o).trigger("focus"), s = e.parent(), "static" === e.css("position") ? (s.css({ position: "relative" }), e.css({ position: "relative" })) : (t.extend(i, { position: e.css("position"), zIndex: e.css("z-index") }), t.each(["top", "left", "bottom", "right"], function (t, s) {i[s] = e.css(s), isNaN(parseInt(i[s], 10)) && (i[s] = "auto");}), e.css({ position: "relative", top: 0, left: 0, right: "auto", bottom: "auto" })), e.css(n), s.css(i).show();}, removeWrapper: function (e) {var i = document.activeElement;return e.parent().is(".ui-effects-wrapper") && (e.parent().replaceWith(e), (e[0] === i || t.contains(e[0], i)) && t(i).trigger("focus")), e;} }), t.extend(t.effects, { version: "1.12.1", define: function (e, i, s) {return s || (s = i, i = "effect"), t.effects.effect[e] = s, t.effects.effect[e].mode = i, s;}, scaledDimensions: function (t, e, i) {if (0 === e) return { height: 0, width: 0, outerHeight: 0, outerWidth: 0 };var s = "horizontal" !== i ? (e || 100) / 100 : 1, n = "vertical" !== i ? (e || 100) / 100 : 1;return { height: t.height() * n, width: t.width() * s, outerHeight: t.outerHeight() * n, outerWidth: t.outerWidth() * s };}, clipToBox: function (t) {return { width: t.clip.right - t.clip.left, height: t.clip.bottom - t.clip.top, left: t.clip.left, top: t.clip.top };}, unshift: function (t, e, i) {var s = t.queue();e > 1 && s.splice.apply(s, [1, 0].concat(s.splice(e, i))), t.dequeue();}, saveStyle: function (t) {t.data(u, t[0].style.cssText);}, restoreStyle: function (t) {t[0].style.cssText = t.data(u) || "", t.removeData(u);}, mode: function (t, e) {var i = t.is(":hidden");return "toggle" === e && (e = i ? "show" : "hide"), (i ? "hide" === e : "show" === e) && (e = "none"), e;}, getBaseline: function (t, e) {var i, s;switch (t[0]) {case "top":i = 0;break;case "middle":i = .5;break;case "bottom":i = 1;break;default:i = t[0] / e.height;} switch (t[1]) {case "left":s = 0;break;case "center":s = .5;break;case "right":s = 1;break;default:s = t[1] / e.width;} return { x: s, y: i };}, createPlaceholder: function (e) {var i, s = e.css("position"), n = e.position();return e.css({ marginTop: e.css("marginTop"), marginBottom: e.css("marginBottom"), marginLeft: e.css("marginLeft"), marginRight: e.css("marginRight") }).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()), /^(static|relative)/.test(s) && (s = "absolute", i = t("<" + e[0].nodeName + ">").insertAfter(e).css({ display: /^(inline|ruby)/.test(e.css("display")) ? "inline-block" : "block", visibility: "hidden", marginTop: e.css("marginTop"), marginBottom: e.css("marginBottom"), marginLeft: e.css("marginLeft"), marginRight: e.css("marginRight"), "float": e.css("float") }).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).addClass("ui-effects-placeholder"), e.data(c + "placeholder", i)), e.css({ position: s, left: n.left, top: n.top }), i;}, removePlaceholder: function (t) {var e = c + "placeholder", i = t.data(e);i && (i.remove(), t.removeData(e));}, cleanUp: function (e) {t.effects.restoreStyle(e), t.effects.removePlaceholder(e);}, setTransition: function (e, i, s, n) {return n = n || {}, t.each(i, function (t, i) {var o = e.cssUnit(i);o[0] > 0 && (n[i] = o[0] * s + o[1]);}), n;} }), t.fn.extend({ effect: function () {function i(e) {function i() {r.removeData(d), t.effects.cleanUp(r), "hide" === s.mode && r.hide(), a();} function a() {t.isFunction(h) && h.call(r[0]), t.isFunction(e) && e();} var r = t(this);s.mode = c.shift(), t.uiBackCompat === !1 || o ? "none" === s.mode ? (r[l](), a()) : n.call(r[0], s, i) : (r.is(":hidden") ? "hide" === l : "show" === l) ? (r[l](), a()) : n.call(r[0], s, a);} var s = e.apply(this, arguments), n = t.effects.effect[s.effect], o = n.mode, a = s.queue, r = a || "fx", h = s.complete, l = s.mode, c = [], u = function (e) {var i = t(this), s = t.effects.mode(i, l) || o;i.data(d, !0), c.push(s), o && ("show" === s || s === o && "hide" === s) && i.show(), o && "none" === s || t.effects.saveStyle(i), t.isFunction(e) && e();};return t.fx.off || !n ? l ? this[l](s.duration, h) : this.each(function () {h && h.call(this);}) : a === !1 ? this.each(u).each(i) : this.queue(r, u).queue(r, i);}, show: function (t) {return function (s) {if (i(s)) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = "show", this.effect.call(this, n);
};}(t.fn.show), hide: function (t) {return function (s) {if (i(s)) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = "hide", this.effect.call(this, n);};}(t.fn.hide), toggle: function (t) {return function (s) {if (i(s) || "boolean" === typeof s) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = "toggle", this.effect.call(this, n);};}(t.fn.toggle), cssUnit: function (e) {var i = this.css(e), s = [];return t.each(["em", "px", "%", "pt"], function (t, e) {i.indexOf(e) > 0 && (s = [parseFloat(i), e]);}), s;}, cssClip: function (t) {return t ? this.css("clip", "rect(" + t.top + "px " + t.right + "px " + t.bottom + "px " + t.left + "px)") : s(this.css("clip"), this);}, transfer: function (e, i) {var s = t(this), n = t(e.to), o = "fixed" === n.css("position"), a = t("body"), r = o ? a.scrollTop() : 0, h = o ? a.scrollLeft() : 0, l = n.offset(), c = { top: l.top - r, left: l.left - h, height: n.innerHeight(), width: n.innerWidth() }, u = s.offset(), d = t("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(e.className).css({ top: u.top - r, left: u.left - h, height: s.innerHeight(), width: s.innerWidth(), position: o ? "fixed" : "absolute" }).animate(c, e.duration, e.easing, function () {d.remove(), t.isFunction(i) && i();});} }), t.fx.step.clip = function (e) {e.clipInit || (e.start = t(e.elem).cssClip(), "string" === typeof e.end && (e.end = s(e.end, e.elem)), e.clipInit = !0), t(e.elem).cssClip({ top: e.pos * (e.end.top - e.start.top) + e.start.top, right: e.pos * (e.end.right - e.start.right) + e.start.right, bottom: e.pos * (e.end.bottom - e.start.bottom) + e.start.bottom, left: e.pos * (e.end.left - e.start.left) + e.start.left });};}(), function () {var e = {};t.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (t, i) {e[i] = function (e) {return Math.pow(e, t + 2);};}), t.extend(e, { Sine: function (t) {return 1 - Math.cos(t * Math.PI / 2);}, Circ: function (t) {return 1 - Math.sqrt(1 - t * t);}, Elastic: function (t) {return 0 === t || 1 === t ? t : -Math.pow(2, 8 * (t - 1)) * Math.sin((80 * (t - 1) - 7.5) * Math.PI / 15);}, Back: function (t) {return t * t * (3 * t - 2);}, Bounce: function (t) {for (var e, i = 4;((e = Math.pow(2, --i)) - 1) / 11 > t;);return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2);} }), t.each(e, function (e, i) {t.easing["easeIn" + e] = i, t.easing["easeOut" + e] = function (t) {return 1 - i(1 - t);}, t.easing["easeInOut" + e] = function (t) {return.5 > t ? i(2 * t) / 2 : 1 - i(-2 * t + 2) / 2;};});}();var f = t.effects;t.effects.define("blind", "hide", function (e, i) {var s = { up: ["bottom", "top"], vertical: ["bottom", "top"], down: ["top", "bottom"], left: ["right", "left"], horizontal: ["right", "left"], right: ["left", "right"] }, n = t(this), o = e.direction || "up", a = n.cssClip(), r = { clip: t.extend({}, a) }, h = t.effects.createPlaceholder(n);r.clip[s[o][0]] = r.clip[s[o][1]], "show" === e.mode && (n.cssClip(r.clip), h && h.css(t.effects.clipToBox(r)), r.clip = a), h && h.animate(t.effects.clipToBox(r), e.duration, e.easing), n.animate(r, { queue: !1, duration: e.duration, easing: e.easing, complete: i });}), t.effects.define("bounce", function (e, i) {var s, n, o, a = t(this), r = e.mode, h = "hide" === r, l = "show" === r, c = e.direction || "up", u = e.distance, d = e.times || 5, p = 2 * d + (l || h ? 1 : 0), f = e.duration / p, g = e.easing, m = "up" === c || "down" === c ? "top" : "left", _ = "up" === c || "left" === c, v = 0, b = a.queue().length;for (t.effects.createPlaceholder(a), o = a.css(m), u || (u = a["top" === m ? "outerHeight" : "outerWidth"]() / 3), l && (n = { opacity: 1 }, n[m] = o, a.css("opacity", 0).css(m, _ ? 2 * -u : 2 * u).animate(n, f, g)), h && (u /= Math.pow(2, d - 1)), n = {}, n[m] = o;d > v;v++)s = {}, s[m] = (_ ? "-=" : "+=") + u, a.animate(s, f, g).animate(n, f, g), u = h ? 2 * u : u / 2;h && (s = { opacity: 0 }, s[m] = (_ ? "-=" : "+=") + u, a.animate(s, f, g)), a.queue(i), t.effects.unshift(a, b, p + 1);}), t.effects.define("clip", "hide", function (e, i) {var s, n = {}, o = t(this), a = e.direction || "vertical", r = "both" === a, h = r || "horizontal" === a, l = r || "vertical" === a;s = o.cssClip(), n.clip = { top: l ? (s.bottom - s.top) / 2 : s.top, right: h ? (s.right - s.left) / 2 : s.right, bottom: l ? (s.bottom - s.top) / 2 : s.bottom, left: h ? (s.right - s.left) / 2 : s.left }, t.effects.createPlaceholder(o), "show" === e.mode && (o.cssClip(n.clip), n.clip = s), o.animate(n, { queue: !1, duration: e.duration, easing: e.easing, complete: i });}), t.effects.define("drop", "hide", function (e, i) {var s, n = t(this), o = e.mode, a = "show" === o, r = e.direction || "left", h = "up" === r || "down" === r ? "top" : "left", l = "up" === r || "left" === r ? "-=" : "+=", c = "+=" === l ? "-=" : "+=", u = { opacity: 0 };t.effects.createPlaceholder(n), s = e.distance || n["top" === h ? "outerHeight" : "outerWidth"](!0) / 2, u[h] = l + s, a && (n.css(u), u[h] = c + s, u.opacity = 1), n.animate(u, { queue: !1, duration: e.duration, easing: e.easing, complete: i });}), t.effects.define("explode", "hide", function (e, i) {function s() {b.push(this), b.length === u * d && n();} function n() {p.css({ visibility: "visible" }), t(b).remove(), i();} var o, a, r, h, l, c, u = e.pieces ? Math.round(Math.sqrt(e.pieces)) : 3, d = u, p = t(this), f = e.mode, g = "show" === f, m = p.show().css("visibility", "hidden").offset(), _ = Math.ceil(p.outerWidth() / d), v = Math.ceil(p.outerHeight() / u), b = [];for (o = 0;u > o;o++) for (h = m.top + o * v, c = o - (u - 1) / 2, a = 0;d > a;a++)r = m.left + a * _, l = a - (d - 1) / 2, p.clone().appendTo("body").wrap("<div></div>").css({ position: "absolute", visibility: "visible", left: -a * _, top: -o * v }).parent().addClass("ui-effects-explode").css({ position: "absolute", overflow: "hidden", width: _, height: v, left: r + (g ? l * _ : 0), top: h + (g ? c * v : 0), opacity: g ? 0 : 1 }).animate({ left: r + (g ? 0 : l * _), top: h + (g ? 0 : c * v), opacity: g ? 1 : 0 }, e.duration || 500, e.easing, s);}), t.effects.define("fade", "toggle", function (e, i) {var s = "show" === e.mode;t(this).css("opacity", s ? 0 : 1).animate({ opacity: s ? 1 : 0 }, { queue: !1, duration: e.duration, easing: e.easing, complete: i });}), t.effects.define("fold", "hide", function (e, i) {var s = t(this), n = e.mode, o = "show" === n, a = "hide" === n, r = e.size || 15, h = /([0-9]+)%/.exec(r), l = !!e.horizFirst, c = l ? ["right", "bottom"] : ["bottom", "right"], u = e.duration / 2, d = t.effects.createPlaceholder(s), p = s.cssClip(), f = { clip: t.extend({}, p) }, g = { clip: t.extend({}, p) }, m = [p[c[0]], p[c[1]]], _ = s.queue().length;h && (r = parseInt(h[1], 10) / 100 * m[a ? 0 : 1]), f.clip[c[0]] = r, g.clip[c[0]] = r, g.clip[c[1]] = 0, o && (s.cssClip(g.clip), d && d.css(t.effects.clipToBox(g)), g.clip = p), s.queue(function (i) {d && d.animate(t.effects.clipToBox(f), u, e.easing).animate(t.effects.clipToBox(g), u, e.easing), i();}).animate(f, u, e.easing).animate(g, u, e.easing).queue(i), t.effects.unshift(s, _, 4);}), t.effects.define("highlight", "show", function (e, i) {var s = t(this), n = { backgroundColor: s.css("backgroundColor") };"hide" === e.mode && (n.opacity = 0), t.effects.saveStyle(s), s.css({ backgroundImage: "none", backgroundColor: e.color || "#ffff99" }).animate(n, { queue: !1, duration: e.duration, easing: e.easing, complete: i });}), t.effects.define("size", function (e, i) {var s, n, o, a = t(this), r = ["fontSize"], h = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"], l = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"], c = e.mode, u = "effect" !== c, d = e.scale || "both", p = e.origin || ["middle", "center"], f = a.css("position"), g = a.position(), m = t.effects.scaledDimensions(a), _ = e.from || m, v = e.to || t.effects.scaledDimensions(a, 0);t.effects.createPlaceholder(a), "show" === c && (o = _, _ = v, v = o), n = { from: { y: _.height / m.height, x: _.width / m.width }, to: { y: v.height / m.height, x: v.width / m.width } }, ("box" === d || "both" === d) && (n.from.y !== n.to.y && (_ = t.effects.setTransition(a, h, n.from.y, _), v = t.effects.setTransition(a, h, n.to.y, v)), n.from.x !== n.to.x && (_ = t.effects.setTransition(a, l, n.from.x, _), v = t.effects.setTransition(a, l, n.to.x, v))), ("content" === d || "both" === d) && n.from.y !== n.to.y && (_ = t.effects.setTransition(a, r, n.from.y, _), v = t.effects.setTransition(a, r, n.to.y, v)), p && (s = t.effects.getBaseline(p, m), _.top = (m.outerHeight - _.outerHeight) * s.y + g.top, _.left = (m.outerWidth - _.outerWidth) * s.x + g.left, v.top = (m.outerHeight - v.outerHeight) * s.y + g.top, v.left = (m.outerWidth - v.outerWidth) * s.x + g.left), a.css(_), ("content" === d || "both" === d) && (h = h.concat(["marginTop", "marginBottom"]).concat(r), l = l.concat(["marginLeft", "marginRight"]), a.find("*[width]").each(function () {var i = t(this), s = t.effects.scaledDimensions(i), o = { height: s.height * n.from.y, width: s.width * n.from.x, outerHeight: s.outerHeight * n.from.y, outerWidth: s.outerWidth * n.from.x }, a = { height: s.height * n.to.y, width: s.width * n.to.x, outerHeight: s.height * n.to.y, outerWidth: s.width * n.to.x };n.from.y !== n.to.y && (o = t.effects.setTransition(i, h, n.from.y, o), a = t.effects.setTransition(i, h, n.to.y, a)), n.from.x !== n.to.x && (o = t.effects.setTransition(i, l, n.from.x, o), a = t.effects.setTransition(i, l, n.to.x, a)), u && t.effects.saveStyle(i), i.css(o), i.animate(a, e.duration, e.easing, function () {u && t.effects.restoreStyle(i);});})), a.animate(v, { queue: !1, duration: e.duration, easing: e.easing, complete: function () {var e = a.offset();0 === v.opacity && a.css("opacity", _.opacity), u || (a.css("position", "static" === f ? "relative" : f).offset(e), t.effects.saveStyle(a)), i();} });}), t.effects.define("scale", function (e, i) {var s = t(this), n = e.mode, o = parseInt(e.percent, 10) || (0 === parseInt(e.percent, 10) ? 0 : "effect" !== n ? 0 : 100), a = t.extend(!0, { from: t.effects.scaledDimensions(s), to: t.effects.scaledDimensions(s, o, e.direction || "both"), origin: e.origin || ["middle", "center"] }, e);e.fade && (a.from.opacity = 1, a.to.opacity = 0), t.effects.effect.size.call(this, a, i);}), t.effects.define("puff", "hide", function (e, i) {var s = t.extend(!0, {}, e, { fade: !0, percent: parseInt(e.percent, 10) || 150 });t.effects.effect.scale.call(this, s, i);}), t.effects.define("pulsate", "show", function (e, i) {var s = t(this), n = e.mode, o = "show" === n, a = "hide" === n, r = o || a, h = 2 * (e.times || 5) + (r ? 1 : 0), l = e.duration / h, c = 0, u = 1, d = s.queue().length;for ((o || !s.is(":visible")) && (s.css("opacity", 0).show(), c = 1);h > u;u++)s.animate({ opacity: c }, l, e.easing), c = 1 - c;s.animate({ opacity: c }, l, e.easing), s.queue(i), t.effects.unshift(s, d, h + 1);}), t.effects.define("shake", function (e, i) {var s = 1, n = t(this), o = e.direction || "left", a = e.distance || 20, r = e.times || 3, h = 2 * r + 1, l = Math.round(e.duration / h), c = "up" === o || "down" === o ? "top" : "left", u = "up" === o || "left" === o, d = {}, p = {}, f = {}, g = n.queue().length;for (t.effects.createPlaceholder(n), d[c] = (u ? "-=" : "+=") + a, p[c] = (u ? "+=" : "-=") + 2 * a, f[c] = (u ? "-=" : "+=") + 2 * a, n.animate(d, l, e.easing);r > s;s++)n.animate(p, l, e.easing).animate(f, l, e.easing);n.animate(p, l, e.easing).animate(d, l / 2, e.easing).queue(i), t.effects.unshift(n, g, h + 1);}), t.effects.define("slide", "show", function (e, i) {var s, n, o = t(this), a = { up: ["bottom", "top"], down: ["top", "bottom"], left: ["right", "left"], right: ["left", "right"] }, r = e.mode, h = e.direction || "left", l = "up" === h || "down" === h ? "top" : "left", c = "up" === h || "left" === h, u = e.distance || o["top" === l ? "outerHeight" : "outerWidth"](!0), d = {};t.effects.createPlaceholder(o), s = o.cssClip(), n = o.position()[l], d[l] = (c ? -1 : 1) * u + n, d.clip = o.cssClip(), d.clip[a[h][1]] = d.clip[a[h][0]], "show" === r && (o.cssClip(d.clip), o.css(l, d[l]), d.clip = s, d[l] = n), o.animate(d, { queue: !1, duration: e.duration, easing: e.easing, complete: i });});var f;t.uiBackCompat !== !1 && (f = t.effects.define("transfer", function (e, i) {t(this).transfer(e, i);})), t.ui.focusable = function (i, s) {var n, o, a, r, h, l = i.nodeName.toLowerCase();return "area" === l ? (n = i.parentNode, o = n.name, i.href && o && "map" === n.nodeName.toLowerCase() ? (a = t("img[usemap='#" + o + "']"), a.length > 0 && a.is(":visible")) : !1) : (/^(input|select|textarea|button|object)$/.test(l) ? (r = !i.disabled, r && (h = t(i).closest("fieldset")[0], h && (r = !h.disabled))) : r = "a" === l ? i.href || s : s, r && t(i).is(":visible") && e(t(i)));}, t.extend(t.expr[":"], { focusable: function (e) {return t.ui.focusable(e, null != t.attr(e, "tabindex"));} }), t.ui.focusable, t.fn.form = function () {return "string" === typeof this[0].form ? this.closest("form") : t(this[0].form);}, t.ui.formResetMixin = { _formResetHandler: function () {var e = t(this);setTimeout(function () {var i = e.data("ui-form-reset-instances");t.each(i, function () {this.refresh();});});}, _bindFormResetHandler: function () {if (this.form = this.element.form(), this.form.length) {var t = this.form.data("ui-form-reset-instances") || [];t.length || this.form.on("reset.ui-form-reset", this._formResetHandler), t.push(this), this.form.data("ui-form-reset-instances", t);}}, _unbindFormResetHandler: function () {if (this.form.length) {var e = this.form.data("ui-form-reset-instances");e.splice(t.inArray(this, e), 1), e.length ? this.form.data("ui-form-reset-instances", e) : this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset");}} }, "1.7" === t.fn.jquery.substring(0, 3) && (t.each(["Width", "Height"], function (e, i) {function s(e, i, s, o) {return t.each(n, function () {i -= parseFloat(t.css(e, "padding" + this)) || 0, s && (i -= parseFloat(t.css(e, "border" + this + "Width")) || 0), o && (i -= parseFloat(t.css(e, "margin" + this)) || 0);}), i;} var n = "Width" === i ? ["Left", "Right"] : ["Top", "Bottom"], o = i.toLowerCase(), a = { innerWidth: t.fn.innerWidth, innerHeight: t.fn.innerHeight, outerWidth: t.fn.outerWidth, outerHeight: t.fn.outerHeight };t.fn["inner" + i] = function (e) {return void 0 === e ? a["inner" + i].call(this) : this.each(function () {t(this).css(o, s(this, e) + "px");});}, t.fn["outer" + i] = function (e, n) {return "number" !== typeof e ? a["outer" + i].call(this, e) : this.each(function () {t(this).css(o, s(this, e, !0, n) + "px");});};}), t.fn.addBack = function (t) {return this.add(null == t ? this.prevObject : this.prevObject.filter(t));}), t.ui.keyCode = { BACKSPACE: 8, COMMA: 188, DELETE: 46, DOWN: 40, END: 35, ENTER: 13, ESCAPE: 27, HOME: 36, LEFT: 37, PAGE_DOWN: 34, PAGE_UP: 33, PERIOD: 190, RIGHT: 39, SPACE: 32, TAB: 9, UP: 38 }, t.ui.escapeSelector = function () {var t = /([!"#$%&'()*+,.\/:;<=>?@[\]^`{|}~])/g;return function (e) {return e.replace(t, "\\$1");};}(), t.fn.labels = function () {var e, i, s, n, o;return this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (n = this.eq(0).parents("label"), s = this.attr("id"), s && (e = this.eq(0).parents().last(), o = e.add(e.length ? e.siblings() : this.siblings()), i = "label[for='" + t.ui.escapeSelector(s) + "']", n = n.add(o.find(i).addBack(i))), this.pushStack(n));}, t.fn.scrollParent = function (e) {var i = this.css("position"), s = "absolute" === i, n = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/, o = this.parents().filter(function () {var e = t(this);return s && "static" === e.css("position") ? !1 : n.test(e.css("overflow") + e.css("overflow-y") + e.css("overflow-x"));}).eq(0);return "fixed" !== i && o.length ? o : t(this[0].ownerDocument || document);}, t.extend(t.expr[":"], { tabbable: function (e) {var i = t.attr(e, "tabindex"), s = null != i;return (!s || i >= 0) && t.ui.focusable(e, s);} }), t.fn.extend({ uniqueId: function () {var t = 0;return function () {return this.each(function () {this.id || (this.id = "ui-id-" + ++t);});};}(), removeUniqueId: function () {return this.each(function () {/^ui-id-\d+$/.test(this.id) && t(this).removeAttr("id");});} }), t.widget("ui.accordion", { version: "1.12.1", options: { active: 0, animate: {}, classes: { "ui-accordion-header": "ui-corner-top", "ui-accordion-header-collapsed": "ui-corner-all", "ui-accordion-content": "ui-corner-bottom" }, collapsible: !1, event: "click", header: "> li > :first-child, > :not(li):even", heightStyle: "auto", icons: { activeHeader: "ui-icon-triangle-1-s", header: "ui-icon-triangle-1-e" }, activate: null, beforeActivate: null }, hideProps: { borderTopWidth: "hide", borderBottomWidth: "hide", paddingTop: "hide", paddingBottom: "hide", height: "hide" }, showProps: { borderTopWidth: "show", borderBottomWidth: "show", paddingTop: "show", paddingBottom: "show", height: "show" }, _create: function () {var e = this.options;this.prevShow = this.prevHide = t(), this._addClass("ui-accordion", "ui-widget ui-helper-reset"), this.element.attr("role", "tablist"), e.collapsible || e.active !== !1 && null != e.active || (e.active = 0), this._processPanels(), 0 > e.active && (e.active += this.headers.length), this._refresh();}, _getCreateEventData: function () {return { header: this.active, panel: this.active.length ? this.active.next() : t() };}, _createIcons: function () {var e, i, s = this.options.icons;s && (e = t("<span>"), this._addClass(e, "ui-accordion-header-icon", "ui-icon " + s.header), e.prependTo(this.headers), i = this.active.children(".ui-accordion-header-icon"), this._removeClass(i, s.header)._addClass(i, null, s.activeHeader)._addClass(this.headers, "ui-accordion-icons"));}, _destroyIcons: function () {this._removeClass(this.headers, "ui-accordion-icons"), this.headers.children(".ui-accordion-header-icon").remove();}, _destroy: function () {var t;this.element.removeAttr("role"), this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(), this._destroyIcons(), t = this.headers.next().css("display", "").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(), "content" !== this.options.heightStyle && t.css("height", "");}, _setOption: function (t, e) {return "active" === t ? (this._activate(e), void 0) : ("event" === t && (this.options.event && this._off(this.headers, this.options.event), this._setupEvents(e)), this._super(t, e), "collapsible" !== t || e || this.options.active !== !1 || this._activate(0), "icons" === t && (this._destroyIcons(), e && this._createIcons()), void 0);}, _setOptionDisabled: function (t) {this._super(t), this.element.attr("aria-disabled", t), this._toggleClass(null, "ui-state-disabled", !!t), this._toggleClass(this.headers.add(this.headers.next()), null, "ui-state-disabled", !!t);}, _keydown: function (e) {if (!e.altKey && !e.ctrlKey) {var i = t.ui.keyCode, s = this.headers.length, n = this.headers.index(e.target), o = !1;switch (e.keyCode) {case i.RIGHT:case i.DOWN:o = this.headers[(n + 1) % s];break;case i.LEFT:case i.UP:o = this.headers[(n - 1 + s) % s];break;case i.SPACE:case i.ENTER:this._eventHandler(e);break;case i.HOME:o = this.headers[0];break;case i.END:o = this.headers[s - 1];}o && (t(e.target).attr("tabIndex", -1), t(o).attr("tabIndex", 0), t(o).trigger("focus"), e.preventDefault());}}, _panelKeyDown: function (e) {e.keyCode === t.ui.keyCode.UP && e.ctrlKey && t(e.currentTarget).prev().trigger("focus");}, refresh: function () {var e = this.options;this._processPanels(), e.active === !1 && e.collapsible === !0 || !this.headers.length ? (e.active = !1, this.active = t()) : e.active === !1 ? this._activate(0) : this.active.length && !t.contains(this.element[0], this.active[0]) ? this.headers.length === this.headers.find(".ui-state-disabled").length ? (e.active = !1, this.active = t()) : this._activate(Math.max(0, e.active - 1)) : e.active = this.headers.index(this.active), this._destroyIcons(), this._refresh();}, _processPanels: function () {var t = this.headers, e = this.panels;this.headers = this.element.find(this.options.header), this._addClass(this.headers, "ui-accordion-header ui-accordion-header-collapsed", "ui-state-default"), this.panels = this.headers.next().filter(":not(.ui-accordion-content-active)").hide(), this._addClass(this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content"), e && (this._off(t.not(this.headers)), this._off(e.not(this.panels)));}, _refresh: function () {var e, i = this.options, s = i.heightStyle, n = this.element.parent();this.active = this._findActive(i.active), this._addClass(this.active, "ui-accordion-header-active", "ui-state-active")._removeClass(this.active, "ui-accordion-header-collapsed"), this._addClass(this.active.next(), "ui-accordion-content-active"), this.active.next().show(), this.headers.attr("role", "tab").each(function () {var e = t(this), i = e.uniqueId().attr("id"), s = e.next(), n = s.uniqueId().attr("id");e.attr("aria-controls", n), s.attr("aria-labelledby", i);}).next().attr("role", "tabpanel"), this.headers.not(this.active).attr({ "aria-selected": "false", "aria-expanded": "false", tabIndex: -1 }).next().attr({ "aria-hidden": "true" }).hide(), this.active.length ? this.active.attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 }).next().attr({ "aria-hidden": "false" }) : this.headers.eq(0).attr("tabIndex", 0), this._createIcons(), this._setupEvents(i.event), "fill" === s ? (e = n.height(), this.element.siblings(":visible").each(function () {var i = t(this), s = i.css("position");"absolute" !== s && "fixed" !== s && (e -= i.outerHeight(!0));}), this.headers.each(function () {e -= t(this).outerHeight(!0);}), this.headers.next().each(function () {t(this).height(Math.max(0, e - t(this).innerHeight() + t(this).height()));}).css("overflow", "auto")) : "auto" === s && (e = 0, this.headers.next().each(function () {var i = t(this).is(":visible");i || t(this).show(), e = Math.max(e, t(this).css("height", "").height()), i || t(this).hide();}).height(e));}, _activate: function (e) {var i = this._findActive(e)[0];i !== this.active[0] && (i = i || this.active[0], this._eventHandler({ target: i, currentTarget: i, preventDefault: t.noop }));}, _findActive: function (e) {return "number" === typeof e ? this.headers.eq(e) : t();}, _setupEvents: function (e) {var i = { keydown: "_keydown" };e && t.each(e.split(" "), function (t, e) {i[e] = "_eventHandler";}), this._off(this.headers.add(this.headers.next())), this._on(this.headers, i), this._on(this.headers.next(), { keydown: "_panelKeyDown" }), this._hoverable(this.headers), this._focusable(this.headers);}, _eventHandler: function (e) {var i, s, n = this.options, o = this.active, a = t(e.currentTarget), r = a[0] === o[0], h = r && n.collapsible, l = h ? t() : a.next(), c = o.next(), u = { oldHeader: o, oldPanel: c, newHeader: h ? t() : a, newPanel: l };e.preventDefault(), r && !n.collapsible || this._trigger("beforeActivate", e, u) === !1 || (n.active = h ? !1 : this.headers.index(a), this.active = r ? t() : a, this._toggle(u), this._removeClass(o, "ui-accordion-header-active", "ui-state-active"), n.icons && (i = o.children(".ui-accordion-header-icon"), this._removeClass(i, null, n.icons.activeHeader)._addClass(i, null, n.icons.header)), r || (this._removeClass(a, "ui-accordion-header-collapsed")._addClass(a, "ui-accordion-header-active", "ui-state-active"), n.icons && (s = a.children(".ui-accordion-header-icon"), this._removeClass(s, null, n.icons.header)._addClass(s, null, n.icons.activeHeader)), this._addClass(a.next(), "ui-accordion-content-active")));}, _toggle: function (e) {var i = e.newPanel, s = this.prevShow.length ? this.prevShow : e.oldPanel;this.prevShow.add(this.prevHide).stop(!0, !0), this.prevShow = i, this.prevHide = s, this.options.animate ? this._animate(i, s, e) : (s.hide(), i.show(), this._toggleComplete(e)), s.attr({ "aria-hidden": "true" }), s.prev().attr({ "aria-selected": "false", "aria-expanded": "false" }), i.length && s.length ? s.prev().attr({ tabIndex: -1, "aria-expanded": "false" }) : i.length && this.headers.filter(function () {return 0 === parseInt(t(this).attr("tabIndex"), 10);}).attr("tabIndex", -1), i.attr("aria-hidden", "false").prev().attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 });}, _animate: function (t, e, i) {var s, n, o, a = this, r = 0, h = t.css("box-sizing"), l = t.length && (!e.length || t.index() < e.index()), c = this.options.animate || {}, u = l && c.down || c, d = function () {a._toggleComplete(i);};return "number" === typeof u && (o = u), "string" === typeof u && (n = u), n = n || u.easing || c.easing, o = o || u.duration || c.duration, e.length ? t.length ? (s = t.show().outerHeight(), e.animate(this.hideProps, { duration: o, easing: n, step: function (t, e) {e.now = Math.round(t);} }), t.hide().animate(this.showProps, { duration: o, easing: n, complete: d, step: function (t, i) {i.now = Math.round(t), "height" !== i.prop ? "content-box" === h && (r += i.now) : "content" !== a.options.heightStyle && (i.now = Math.round(s - e.outerHeight() - r), r = 0);} }), void 0) : e.animate(this.hideProps, o, n, d) : t.animate(this.showProps, o, n, d);}, _toggleComplete: function (t) {var e = t.oldPanel, i = e.prev();this._removeClass(e, "ui-accordion-content-active"), this._removeClass(i, "ui-accordion-header-active")._addClass(i, "ui-accordion-header-collapsed"), e.length && (e.parent()[0].className = e.parent()[0].className), this._trigger("activate", null, t);} }), t.ui.safeActiveElement = function (t) {var e;try {e = t.activeElement;} catch (i) {e = t.body;} return e || (e = t.body), e.nodeName || (e = t.body), e;}, t.widget("ui.menu", { version: "1.12.1", defaultElement: "<ul>", delay: 300, options: { icons: { submenu: "ui-icon-caret-1-e" }, items: "> *", menus: "ul", position: { my: "left top", at: "right top" }, role: "menu", blur: null, focus: null, select: null }, _create: function () {this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().attr({ role: this.options.role, tabIndex: 0 }), this._addClass("ui-menu", "ui-widget ui-widget-content"), this._on({ "mousedown .ui-menu-item": function (t) {t.preventDefault();}, "click .ui-menu-item": function (e) {var i = t(e.target), s = t(t.ui.safeActiveElement(this.document[0]));!this.mouseHandled && i.not(".ui-state-disabled").length && (this.select(e), e.isPropagationStopped() || (this.mouseHandled = !0), i.has(".ui-menu").length ? this.expand(e) : !this.element.is(":focus") && s.closest(".ui-menu").length && (this.element.trigger("focus", [!0]), this.active && 1 === this.active.parents(".ui-menu").length && clearTimeout(this.timer)));}, "mouseenter .ui-menu-item": function (e) {if (!this.previousFilter) {var i = t(e.target).closest(".ui-menu-item"), s = t(e.currentTarget);i[0] === s[0] && (this._removeClass(s.siblings().children(".ui-state-active"), null, "ui-state-active"), this.focus(e, s));}}, mouseleave: "collapseAll", "mouseleave .ui-menu": "collapseAll", focus: function (t, e) {var i = this.active || this.element.find(this.options.items).eq(0);e || this.focus(t, i);}, blur: function (e) {this._delay(function () {var i = !t.contains(this.element[0], t.ui.safeActiveElement(this.document[0]));i && this.collapseAll(e);});}, keydown: "_keydown" }), this.refresh(), this._on(this.document, { click: function (t) {this._closeOnDocumentClick(t) && this.collapseAll(t), this.mouseHandled = !1;} });}, _destroy: function () {var e = this.element.find(".ui-menu-item").removeAttr("role aria-disabled"), i = e.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(), i.children().each(function () {var e = t(this);e.data("ui-menu-submenu-caret") && e.remove();});}, _keydown: function (e) {var i, s, n, o, a = !0;switch (e.keyCode) {case t.ui.keyCode.PAGE_UP:this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:this.nextPage(e);break;case t.ui.keyCode.HOME:this._move("first", "first", e);break;case t.ui.keyCode.END:this._move("last", "last", e);break;case t.ui.keyCode.UP:this.previous(e);break;case t.ui.keyCode.DOWN:this.next(e);break;case t.ui.keyCode.LEFT:this.collapse(e);break;case t.ui.keyCode.RIGHT:this.active && !this.active.is(".ui-state-disabled") && this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:this._activate(e);break;case t.ui.keyCode.ESCAPE:this.collapse(e);break;default:a = !1, s = this.previousFilter || "", o = !1, n = e.keyCode >= 96 && 105 >= e.keyCode ? "" + (e.keyCode - 96) : String.fromCharCode(e.keyCode), clearTimeout(this.filterTimer), n === s ? o = !0 : n = s + n, i = this._filterMenuItems(n), i = o && -1 !== i.index(this.active.next()) ? this.active.nextAll(".ui-menu-item") : i, i.length || (n = String.fromCharCode(e.keyCode), i = this._filterMenuItems(n)), i.length ? (this.focus(e, i), this.previousFilter = n, this.filterTimer = this._delay(function () {delete this.previousFilter;}, 1e3)) : delete this.previousFilter;}a && e.preventDefault();}, _activate: function (t) {this.active && !this.active.is(".ui-state-disabled") && (this.active.children("[aria-haspopup='true']").length ? this.expand(t) : this.select(t));}, refresh: function () {var e, i, s, n, o, a = this, r = this.options.icons.submenu, h = this.element.find(this.options.menus);this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length), s = h.filter(":not(.ui-menu)").hide().attr({ role: this.options.role, "aria-hidden": "true", "aria-expanded": "false" }).each(function () {var e = t(this), i = e.prev(), s = t("<span>").data("ui-menu-submenu-caret", !0);a._addClass(s, "ui-menu-icon", "ui-icon " + r), i.attr("aria-haspopup", "true").prepend(s), e.attr("aria-labelledby", i.attr("id"));}), this._addClass(s, "ui-menu", "ui-widget ui-widget-content ui-front"), e = h.add(this.element), i = e.find(this.options.items), i.not(".ui-menu-item").each(function () {var e = t(this);a._isDivider(e) && a._addClass(e, "ui-menu-divider", "ui-widget-content");}), n = i.not(".ui-menu-item, .ui-menu-divider"), o = n.children().not(".ui-menu").uniqueId().attr({ tabIndex: -1, role: this._itemRole() }), this._addClass(n, "ui-menu-item")._addClass(o, "ui-menu-item-wrapper"), i.filter(".ui-state-disabled").attr("aria-disabled", "true"), this.active && !t.contains(this.element[0], this.active[0]) && this.blur();}, _itemRole: function () {return { menu: "menuitem", listbox: "option" }[this.options.role];}, _setOption: function (t, e) {if ("icons" === t) {var i = this.element.find(".ui-menu-icon");this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, e.submenu);} this._super(t, e);}, _setOptionDisabled: function (t) {this._super(t), this.element.attr("aria-disabled", t + ""), this._toggleClass(null, "ui-state-disabled", !!t);}, focus: function (t, e) {var i, s, n;this.blur(t, t && "focus" === t.type), this._scrollIntoView(e), this.active = e.first(), s = this.active.children(".ui-menu-item-wrapper"), this._addClass(s, null, "ui-state-active"), this.options.role && this.element.attr("aria-activedescendant", s.attr("id")), n = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"), this._addClass(n, null, "ui-state-active"), t && "keydown" === t.type ? this._close() : this.timer = this._delay(function () {this._close();}, this.delay), i = e.children(".ui-menu"), i.length && t && /^mouse/.test(t.type) && this._startOpening(i), this.activeMenu = e.parent(), this._trigger("focus", t, { item: e });}, _scrollIntoView: function (e) {var i, s, n, o, a, r;this._hasScroll() && (i = parseFloat(t.css(this.activeMenu[0], "borderTopWidth")) || 0, s = parseFloat(t.css(this.activeMenu[0], "paddingTop")) || 0, n = e.offset().top - this.activeMenu.offset().top - i - s, o = this.activeMenu.scrollTop(), a = this.activeMenu.height(), r = e.outerHeight(), 0 > n ? this.activeMenu.scrollTop(o + n) : n + r > a && this.activeMenu.scrollTop(o + n - a + r));}, blur: function (t, e) {e || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active"), this._trigger("blur", t, { item: this.active }), this.active = null);}, _startOpening: function (t) {clearTimeout(this.timer), "true" === t.attr("aria-hidden") && (this.timer = this._delay(function () {this._close(), this._open(t);}, this.delay));}, _open: function (e) {var i = t.extend({ of: this.active }, this.options.position);clearTimeout(this.timer), this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden", "true"), e.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(i);}, collapseAll: function (e, i) {clearTimeout(this.timer), this.timer = this._delay(function () {var s = i ? this.element : t(e && e.target).closest(this.element.find(".ui-menu"));s.length || (s = this.element), this._close(s), this.blur(e), this._removeClass(s.find(".ui-state-active"), null, "ui-state-active"), this.activeMenu = s;}, this.delay);}, _close: function (t) {t || (t = this.active ? this.active.parent() : this.element), t.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false");}, _closeOnDocumentClick: function (e) {return !t(e.target).closest(".ui-menu").length;}, _isDivider: function (t) {return !/[^\-\u2014\u2013\s]/.test(t.text());}, collapse: function (t) {var e = this.active && this.active.parent().closest(".ui-menu-item", this.element);e && e.length && (this._close(), this.focus(t, e));}, expand: function (t) {var e = this.active && this.active.children(".ui-menu ").find(this.options.items).first();e && e.length && (this._open(e.parent()), this._delay(function () {this.focus(t, e);}));}, next: function (t) {this._move("next", "first", t);}, previous: function (t) {this._move("prev", "last", t);}, isFirstItem: function () {return this.active && !this.active.prevAll(".ui-menu-item").length;}, isLastItem: function () {return this.active && !this.active.nextAll(".ui-menu-item").length;}, _move: function (t, e, i) {var s;this.active && (s = "first" === t || "last" === t ? this.active["first" === t ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : this.active[t + "All"](".ui-menu-item").eq(0)), s && s.length && this.active || (s = this.activeMenu.find(this.options.items)[e]()), this.focus(i, s);}, nextPage: function (e) {var i, s, n;return this.active ? (this.isLastItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.nextAll(".ui-menu-item").each(function () {return i = t(this), 0 > i.offset().top - s - n;}), this.focus(e, i)) : this.focus(e, this.activeMenu.find(this.options.items)[this.active ? "last" : "first"]())), void 0) : (this.next(e), void 0);}, previousPage: function (e) {var i, s, n;return this.active ? (this.isFirstItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.prevAll(".ui-menu-item").each(function () {return i = t(this), i.offset().top - s + n > 0;}), this.focus(e, i)) : this.focus(e, this.activeMenu.find(this.options.items).first())), void 0) : (this.next(e), void 0);}, _hasScroll: function () {return this.element.outerHeight() < this.element.prop("scrollHeight");}, select: function (e) {this.active = this.active || t(e.target).closest(".ui-menu-item");var i = { item: this.active };this.active.has(".ui-menu").length || this.collapseAll(e, !0), this._trigger("select", e, i);}, _filterMenuItems: function (e) {var i = e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"), s = RegExp("^" + i, "i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function () {return s.test(t.trim(t(this).children(".ui-menu-item-wrapper").text()));});} }), t.widget("ui.autocomplete", { version: "1.12.1", defaultElement: "<input>", options: { appendTo: null, autoFocus: !1, delay: 300, minLength: 1, position: { my: "left top", at: "left bottom", collision: "none" }, source: null, change: null, close: null, focus: null, open: null, response: null, search: null, select: null }, requestIndex: 0, pending: 0, _create: function () {var e, i, s, n = this.element[0].nodeName.toLowerCase(), o = "textarea" === n, a = "input" === n;
  this.isMultiLine = o || !a && this._isContentEditable(this.element), this.valueMethod = this.element[o || a ? "val" : "text"], this.isNewMenu = !0, this._addClass("ui-autocomplete-input"), this.element.attr("autocomplete", "off"), this._on(this.element, { keydown: function (n) {if (this.element.prop("readOnly")) return e = !0, s = !0, i = !0, void 0;e = !1, s = !1, i = !1;var o = t.ui.keyCode;switch (n.keyCode) {case o.PAGE_UP:e = !0, this._move("previousPage", n);break;case o.PAGE_DOWN:e = !0, this._move("nextPage", n);break;case o.UP:e = !0, this._keyEvent("previous", n);break;case o.DOWN:e = !0, this._keyEvent("next", n);break;case o.ENTER:this.menu.active && (e = !0, n.preventDefault(), this.menu.select(n));break;case o.TAB:this.menu.active && this.menu.select(n);break;case o.ESCAPE:this.menu.element.is(":visible") && (this.isMultiLine || this._value(this.term), this.close(n), n.preventDefault());break;default:i = !0, this._searchTimeout(n);}}, keypress: function (s) {if (e) return e = !1, (!this.isMultiLine || this.menu.element.is(":visible")) && s.preventDefault(), void 0;if (!i) {var n = t.ui.keyCode;switch (s.keyCode) {case n.PAGE_UP:this._move("previousPage", s);break;case n.PAGE_DOWN:this._move("nextPage", s);break;case n.UP:this._keyEvent("previous", s);break;case n.DOWN:this._keyEvent("next", s);}}}, input: function (t) {return s ? (s = !1, t.preventDefault(), void 0) : (this._searchTimeout(t), void 0);}, focus: function () {this.selectedItem = null, this.previous = this._value();}, blur: function (t) {return this.cancelBlur ? (delete this.cancelBlur, void 0) : (clearTimeout(this.searching), this.close(t), this._change(t), void 0);} }), this._initSource(), this.menu = t("<ul>").appendTo(this._appendTo()).menu({ role: null }).hide().menu("instance"), this._addClass(this.menu.element, "ui-autocomplete", "ui-front"), this._on(this.menu.element, { mousedown: function (e) {e.preventDefault(), this.cancelBlur = !0, this._delay(function () {delete this.cancelBlur, this.element[0] !== t.ui.safeActiveElement(this.document[0]) && this.element.trigger("focus");});}, menufocus: function (e, i) {var s, n;return this.isNewMenu && (this.isNewMenu = !1, e.originalEvent && /^mouse/.test(e.originalEvent.type)) ? (this.menu.blur(), this.document.one("mousemove", function () {t(e.target).trigger(e.originalEvent);}), void 0) : (n = i.item.data("ui-autocomplete-item"), !1 !== this._trigger("focus", e, { item: n }) && e.originalEvent && /^key/.test(e.originalEvent.type) && this._value(n.value), s = i.item.attr("aria-label") || n.value, s && t.trim(s).length && (this.liveRegion.children().hide(), t("<div>").text(s).appendTo(this.liveRegion)), void 0);}, menuselect: function (e, i) {var s = i.item.data("ui-autocomplete-item"), n = this.previous;this.element[0] !== t.ui.safeActiveElement(this.document[0]) && (this.element.trigger("focus"), this.previous = n, this._delay(function () {this.previous = n, this.selectedItem = s;})), !1 !== this._trigger("select", e, { item: s }) && this._value(s.value), this.term = this._value(), this.close(e), this.selectedItem = s;} }), this.liveRegion = t("<div>", { role: "status", "aria-live": "assertive", "aria-relevant": "additions" }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this._on(this.window, { beforeunload: function () {this.element.removeAttr("autocomplete");} });}, _destroy: function () {clearTimeout(this.searching), this.element.removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove();}, _setOption: function (t, e) {this._super(t, e), "source" === t && this._initSource(), "appendTo" === t && this.menu.element.appendTo(this._appendTo()), "disabled" === t && e && this.xhr && this.xhr.abort();}, _isEventTargetInWidget: function (e) {var i = this.menu.element[0];return e.target === this.element[0] || e.target === i || t.contains(i, e.target);}, _closeOnClickOutside: function (t) {this._isEventTargetInWidget(t) || this.close();}, _appendTo: function () {var e = this.options.appendTo;return e && (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)), e && e[0] || (e = this.element.closest(".ui-front, dialog")), e.length || (e = this.document[0].body), e;}, _initSource: function () {var e, i, s = this;t.isArray(this.options.source) ? (e = this.options.source, this.source = function (i, s) {s(t.ui.autocomplete.filter(e, i.term));}) : "string" === typeof this.options.source ? (i = this.options.source, this.source = function (e, n) {s.xhr && s.xhr.abort(), s.xhr = t.ajax({ url: i, data: e, dataType: "json", success: function (t) {n(t);}, error: function () {n([]);} });}) : this.source = this.options.source;}, _searchTimeout: function (t) {clearTimeout(this.searching), this.searching = this._delay(function () {var e = this.term === this._value(), i = this.menu.element.is(":visible"), s = t.altKey || t.ctrlKey || t.metaKey || t.shiftKey;(!e || e && !i && !s) && (this.selectedItem = null, this.search(null, t));}, this.options.delay);}, search: function (t, e) {return t = null != t ? t : this._value(), this.term = this._value(), t.length < this.options.minLength ? this.close(e) : this._trigger("search", e) !== !1 ? this._search(t) : void 0;}, _search: function (t) {this.pending++, this._addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({ term: t }, this._response());}, _response: function () {var e = ++this.requestIndex;return t.proxy(function (t) {e === this.requestIndex && this.__response(t), this.pending--, this.pending || this._removeClass("ui-autocomplete-loading");}, this);}, __response: function (t) {t && (t = this._normalize(t)), this._trigger("response", null, { content: t }), !this.options.disabled && t && t.length && !this.cancelSearch ? (this._suggest(t), this._trigger("open")) : this._close();}, close: function (t) {this.cancelSearch = !0, this._close(t);}, _close: function (t) {this._off(this.document, "mousedown"), this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", t));}, _change: function (t) {this.previous !== this._value() && this._trigger("change", t, { item: this.selectedItem });}, _normalize: function (e) {return e.length && e[0].label && e[0].value ? e : t.map(e, function (e) {return "string" === typeof e ? { label: e, value: e } : t.extend({}, e, { label: e.label || e.value, value: e.value || e.label });});}, _suggest: function (e) {var i = this.menu.element.empty();this._renderMenu(i, e), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(t.extend({ of: this.element }, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, { mousedown: "_closeOnClickOutside" });}, _resizeMenu: function () {var t = this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth() + 1, this.element.outerWidth()));}, _renderMenu: function (e, i) {var s = this;t.each(i, function (t, i) {s._renderItemData(e, i);});}, _renderItemData: function (t, e) {return this._renderItem(t, e).data("ui-autocomplete-item", e);}, _renderItem: function (e, i) {return t("<li>").append(t("<div>").text(i.label)).appendTo(e);}, _move: function (t, e) {return this.menu.element.is(":visible") ? this.menu.isFirstItem() && /^previous/.test(t) || this.menu.isLastItem() && /^next/.test(t) ? (this.isMultiLine || this._value(this.term), this.menu.blur(), void 0) : (this.menu[t](e), void 0) : (this.search(null, e), void 0);}, widget: function () {return this.menu.element;}, _value: function () {return this.valueMethod.apply(this.element, arguments);}, _keyEvent: function (t, e) {(!this.isMultiLine || this.menu.element.is(":visible")) && (this._move(t, e), e.preventDefault());}, _isContentEditable: function (t) {if (!t.length) return !1;var e = t.prop("contentEditable");return "inherit" === e ? this._isContentEditable(t.parent()) : "true" === e;} }), t.extend(t.ui.autocomplete, { escapeRegex: function (t) {return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");}, filter: function (e, i) {var s = RegExp(t.ui.autocomplete.escapeRegex(i), "i");return t.grep(e, function (t) {return s.test(t.label || t.value || t);});} }), t.widget("ui.autocomplete", t.ui.autocomplete, { options: { messages: { noResults: "No search results.", results: function (t) {return t + (t > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";} } }, __response: function (e) {var i;this._superApply(arguments), this.options.disabled || this.cancelSearch || (i = e && e.length ? this.options.messages.results(e.length) : this.options.messages.noResults, this.liveRegion.children().hide(), t("<div>").text(i).appendTo(this.liveRegion));} }), t.ui.autocomplete;var g = /ui-corner-([a-z]){2,6}/g;t.widget("ui.controlgroup", { version: "1.12.1", defaultElement: "<div>", options: { direction: "horizontal", disabled: null, onlyVisible: !0, items: { button: "input[type=button], input[type=submit], input[type=reset], button, a", controlgroupLabel: ".ui-controlgroup-label", checkboxradio: "input[type='checkbox'], input[type='radio']", selectmenu: "select", spinner: ".ui-spinner-input" } }, _create: function () {this._enhance();}, _enhance: function () {this.element.attr("role", "toolbar"), this.refresh();}, _destroy: function () {this._callChildMethod("destroy"), this.childWidgets.removeData("ui-controlgroup-data"), this.element.removeAttr("role"), this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap();}, _initWidgets: function () {var e = this, i = [];t.each(this.options.items, function (s, n) {var o, a = {};return n ? "controlgroupLabel" === s ? (o = e.element.find(n), o.each(function () {var e = t(this);e.children(".ui-controlgroup-label-contents").length || e.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>");}), e._addClass(o, null, "ui-widget ui-widget-content ui-state-default"), i = i.concat(o.get()), void 0) : (t.fn[s] && (a = e["_" + s + "Options"] ? e["_" + s + "Options"]("middle") : { classes: {} }, e.element.find(n).each(function () {var n = t(this), o = n[s]("instance"), r = t.widget.extend({}, a);if ("button" !== s || !n.parent(".ui-spinner").length) {o || (o = n[s]()[s]("instance")), o && (r.classes = e._resolveClassesValues(r.classes, o)), n[s](r);var h = n[s]("widget");t.data(h[0], "ui-controlgroup-data", o ? o : n[s]("instance")), i.push(h[0]);}})), void 0) : void 0;}), this.childWidgets = t(t.unique(i)), this._addClass(this.childWidgets, "ui-controlgroup-item");}, _callChildMethod: function (e) {this.childWidgets.each(function () {var i = t(this), s = i.data("ui-controlgroup-data");s && s[e] && s[e]();});}, _updateCornerClass: function (t, e) {var i = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all", s = this._buildSimpleOptions(e, "label").classes.label;this._removeClass(t, null, i), this._addClass(t, null, s);}, _buildSimpleOptions: function (t, e) {var i = "vertical" === this.options.direction, s = { classes: {} };return s.classes[e] = { middle: "", first: "ui-corner-" + (i ? "top" : "left"), last: "ui-corner-" + (i ? "bottom" : "right"), only: "ui-corner-all" }[t], s;}, _spinnerOptions: function (t) {var e = this._buildSimpleOptions(t, "ui-spinner");return e.classes["ui-spinner-up"] = "", e.classes["ui-spinner-down"] = "", e;}, _buttonOptions: function (t) {return this._buildSimpleOptions(t, "ui-button");}, _checkboxradioOptions: function (t) {return this._buildSimpleOptions(t, "ui-checkboxradio-label");}, _selectmenuOptions: function (t) {var e = "vertical" === this.options.direction;return { width: e ? "auto" : !1, classes: { middle: { "ui-selectmenu-button-open": "", "ui-selectmenu-button-closed": "" }, first: { "ui-selectmenu-button-open": "ui-corner-" + (e ? "top" : "tl"), "ui-selectmenu-button-closed": "ui-corner-" + (e ? "top" : "left") }, last: { "ui-selectmenu-button-open": e ? "" : "ui-corner-tr", "ui-selectmenu-button-closed": "ui-corner-" + (e ? "bottom" : "right") }, only: { "ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all" } }[t] };}, _resolveClassesValues: function (e, i) {var s = {};return t.each(e, function (n) {var o = i.options.classes[n] || "";o = t.trim(o.replace(g, "")), s[n] = (o + " " + e[n]).replace(/\s+/g, " ");}), s;}, _setOption: function (t, e) {return "direction" === t && this._removeClass("ui-controlgroup-" + this.options.direction), this._super(t, e), "disabled" === t ? (this._callChildMethod(e ? "disable" : "enable"), void 0) : (this.refresh(), void 0);}, refresh: function () {var e, i = this;this._addClass("ui-controlgroup ui-controlgroup-" + this.options.direction), "horizontal" === this.options.direction && this._addClass(null, "ui-helper-clearfix"), this._initWidgets(), e = this.childWidgets, this.options.onlyVisible && (e = e.filter(":visible")), e.length && (t.each(["first", "last"], function (t, s) {var n = e[s]().data("ui-controlgroup-data");if (n && i["_" + n.widgetName + "Options"]) {var o = i["_" + n.widgetName + "Options"](1 === e.length ? "only" : s);o.classes = i._resolveClassesValues(o.classes, n), n.element[n.widgetName](o);} else i._updateCornerClass(e[s](), s);}), this._callChildMethod("refresh"));} }), t.widget("ui.checkboxradio", [t.ui.formResetMixin, { version: "1.12.1", options: { disabled: null, label: null, icon: !0, classes: { "ui-checkboxradio-label": "ui-corner-all", "ui-checkboxradio-icon": "ui-corner-all" } }, _getCreateOptions: function () {var e, i, s = this, n = this._super() || {};return this._readType(), i = this.element.labels(), this.label = t(i[i.length - 1]), this.label.length || t.error("No label found for checkboxradio widget"), this.originalLabel = "", this.label.contents().not(this.element[0]).each(function () {s.originalLabel += 3 === this.nodeType ? t(this).text() : this.outerHTML;}), this.originalLabel && (n.label = this.originalLabel), e = this.element[0].disabled, null != e && (n.disabled = e), n;}, _create: function () {var t = this.element[0].checked;this._bindFormResetHandler(), null == this.options.disabled && (this.options.disabled = this.element[0].disabled), this._setOption("disabled", this.options.disabled), this._addClass("ui-checkboxradio", "ui-helper-hidden-accessible"), this._addClass(this.label, "ui-checkboxradio-label", "ui-button ui-widget"), "radio" === this.type && this._addClass(this.label, "ui-checkboxradio-radio-label"), this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel), this._enhance(), t && (this._addClass(this.label, "ui-checkboxradio-checked", "ui-state-active"), this.icon && this._addClass(this.icon, null, "ui-state-hover")), this._on({ change: "_toggleClasses", focus: function () {this._addClass(this.label, null, "ui-state-focus ui-visual-focus");}, blur: function () {this._removeClass(this.label, null, "ui-state-focus ui-visual-focus");} });}, _readType: function () {var e = this.element[0].nodeName.toLowerCase();this.type = this.element[0].type, "input" === e && /radio|checkbox/.test(this.type) || t.error("Can't create checkboxradio on element.nodeName=" + e + " and element.type=" + this.type);}, _enhance: function () {this._updateIcon(this.element[0].checked);}, widget: function () {return this.label;}, _getRadioGroup: function () {var e, i = this.element[0].name, s = "input[name='" + t.ui.escapeSelector(i) + "']";return i ? (e = this.form.length ? t(this.form[0].elements).filter(s) : t(s).filter(function () {return 0 === t(this).form().length;}), e.not(this.element)) : t([]);}, _toggleClasses: function () {var e = this.element[0].checked;this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", e), this.options.icon && "checkbox" === this.type && this._toggleClass(this.icon, null, "ui-icon-check ui-state-checked", e)._toggleClass(this.icon, null, "ui-icon-blank", !e), "radio" === this.type && this._getRadioGroup().each(function () {var e = t(this).checkboxradio("instance");e && e._removeClass(e.label, "ui-checkboxradio-checked", "ui-state-active");});}, _destroy: function () {this._unbindFormResetHandler(), this.icon && (this.icon.remove(), this.iconSpace.remove());}, _setOption: function (t, e) {return "label" !== t || e ? (this._super(t, e), "disabled" === t ? (this._toggleClass(this.label, null, "ui-state-disabled", e), this.element[0].disabled = e, void 0) : (this.refresh(), void 0)) : void 0;}, _updateIcon: function (e) {var i = "ui-icon ui-icon-background ";this.options.icon ? (this.icon || (this.icon = t("<span>"), this.iconSpace = t("<span> </span>"), this._addClass(this.iconSpace, "ui-checkboxradio-icon-space")), "checkbox" === this.type ? (i += e ? "ui-icon-check ui-state-checked" : "ui-icon-blank", this._removeClass(this.icon, null, e ? "ui-icon-blank" : "ui-icon-check")) : i += "ui-icon-blank", this._addClass(this.icon, "ui-checkboxradio-icon", i), e || this._removeClass(this.icon, null, "ui-icon-check ui-state-checked"), this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(), this.iconSpace.remove(), delete this.icon);}, _updateLabel: function () {var t = this.label.contents().not(this.element[0]);this.icon && (t = t.not(this.icon[0])), this.iconSpace && (t = t.not(this.iconSpace[0])), t.remove(), this.label.append(this.options.label);}, refresh: function () {var t = this.element[0].checked, e = this.element[0].disabled;this._updateIcon(t), this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", t), null !== this.options.label && this._updateLabel(), e !== this.options.disabled && this._setOptions({ disabled: e });} }]), t.ui.checkboxradio, t.widget("ui.button", { version: "1.12.1", defaultElement: "<button>", options: { classes: { "ui-button": "ui-corner-all" }, disabled: null, icon: null, iconPosition: "beginning", label: null, showLabel: !0 }, _getCreateOptions: function () {var t, e = this._super() || {};return this.isInput = this.element.is("input"), t = this.element[0].disabled, null != t && (e.disabled = t), this.originalLabel = this.isInput ? this.element.val() : this.element.html(), this.originalLabel && (e.label = this.originalLabel), e;}, _create: function () {!this.option.showLabel & !this.options.icon && (this.options.showLabel = !0), null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1), this.hasTitle = !!this.element.attr("title"), this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)), this._addClass("ui-button", "ui-widget"), this._setOption("disabled", this.options.disabled), this._enhance(), this.element.is("a") && this._on({ keyup: function (e) {e.keyCode === t.ui.keyCode.SPACE && (e.preventDefault(), this.element[0].click ? this.element[0].click() : this.element.trigger("click"));} });}, _enhance: function () {this.element.is("button") || this.element.attr("role", "button"), this.options.icon && (this._updateIcon("icon", this.options.icon), this._updateTooltip());}, _updateTooltip: function () {this.title = this.element.attr("title"), this.options.showLabel || this.title || this.element.attr("title", this.options.label);}, _updateIcon: function (e, i) {var s = "iconPosition" !== e, n = s ? this.options.iconPosition : i, o = "top" === n || "bottom" === n;this.icon ? s && this._removeClass(this.icon, null, this.options.icon) : (this.icon = t("<span>"), this._addClass(this.icon, "ui-button-icon", "ui-icon"), this.options.showLabel || this._addClass("ui-button-icon-only")), s && this._addClass(this.icon, null, i), this._attachIcon(n), o ? (this._addClass(this.icon, null, "ui-widget-icon-block"), this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = t("<span> </span>"), this._addClass(this.iconSpace, "ui-button-icon-space")), this._removeClass(this.icon, null, "ui-wiget-icon-block"), this._attachIconSpace(n));}, _destroy: function () {this.element.removeAttr("role"), this.icon && this.icon.remove(), this.iconSpace && this.iconSpace.remove(), this.hasTitle || this.element.removeAttr("title");}, _attachIconSpace: function (t) {this.icon[/^(?:end|bottom)/.test(t) ? "before" : "after"](this.iconSpace);}, _attachIcon: function (t) {this.element[/^(?:end|bottom)/.test(t) ? "append" : "prepend"](this.icon);}, _setOptions: function (t) {var e = void 0 === t.showLabel ? this.options.showLabel : t.showLabel, i = void 0 === t.icon ? this.options.icon : t.icon;e || i || (t.showLabel = !0), this._super(t);}, _setOption: function (t, e) {"icon" === t && (e ? this._updateIcon(t, e) : this.icon && (this.icon.remove(), this.iconSpace && this.iconSpace.remove())), "iconPosition" === t && this._updateIcon(t, e), "showLabel" === t && (this._toggleClass("ui-button-icon-only", null, !e), this._updateTooltip()), "label" === t && (this.isInput ? this.element.val(e) : (this.element.html(e), this.icon && (this._attachIcon(this.options.iconPosition), this._attachIconSpace(this.options.iconPosition)))), this._super(t, e), "disabled" === t && (this._toggleClass(null, "ui-state-disabled", e), this.element[0].disabled = e, e && this.element.blur());}, refresh: function () {var t = this.element.is("input, button") ? this.element[0].disabled : this.element.hasClass("ui-button-disabled");t !== this.options.disabled && this._setOptions({ disabled: t }), this._updateTooltip();} }), t.uiBackCompat !== !1 && (t.widget("ui.button", t.ui.button, { options: { text: !0, icons: { primary: null, secondary: null } }, _create: function () {this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text), !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel), this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary, this.options.iconPosition = "end"), this._super();}, _setOption: function (t, e) {return "text" === t ? (this._super("showLabel", e), void 0) : ("showLabel" === t && (this.options.text = e), "icon" === t && (this.options.icons.primary = e), "icons" === t && (e.primary ? (this._super("icon", e.primary), this._super("iconPosition", "beginning")) : e.secondary && (this._super("icon", e.secondary), this._super("iconPosition", "end"))), this._superApply(arguments), void 0);} }), t.fn.button = function (e) {return function () {return !this.length || this.length && "INPUT" !== this[0].tagName || this.length && "INPUT" === this[0].tagName && "checkbox" !== this.attr("type") && "radio" !== this.attr("type") ? e.apply(this, arguments) : (t.ui.checkboxradio || t.error("Checkboxradio widget missing"), 0 === arguments.length ? this.checkboxradio({ icon: !1 }) : this.checkboxradio.apply(this, arguments));};}(t.fn.button), t.fn.buttonset = function () {return t.ui.controlgroup || t.error("Controlgroup widget missing"), "option" === arguments[0] && "items" === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], "items.button", arguments[2]]) : "option" === arguments[0] && "items" === arguments[1] ? this.controlgroup.apply(this, [arguments[0], "items.button"]) : ("object" === typeof arguments[0] && arguments[0].items && (arguments[0].items = { button: arguments[0].items }), this.controlgroup.apply(this, arguments));}), t.ui.button, t.extend(t.ui, { datepicker: { version: "1.12.1" } });var m;t.extend(s.prototype, { markerClassName: "hasDatepicker", maxRows: 4, _widgetDatepicker: function () {return this.dpDiv;}, setDefaults: function (t) {return a(this._defaults, t || {}), this;}, _attachDatepicker: function (e, i) {var s, n, o;s = e.nodeName.toLowerCase(), n = "div" === s || "span" === s, e.id || (this.uuid += 1, e.id = "dp" + this.uuid), o = this._newInst(t(e), n), o.settings = t.extend({}, i || {}), "input" === s ? this._connectDatepicker(e, o) : n && this._inlineDatepicker(e, o);}, _newInst: function (e, i) {var s = e[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1");return { id: s, input: e, selectedDay: 0, selectedMonth: 0, selectedYear: 0, drawMonth: 0, drawYear: 0, inline: i, dpDiv: i ? n(t("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) : this.dpDiv };}, _connectDatepicker: function (e, i) {var s = t(e);i.append = t([]), i.trigger = t([]), s.hasClass(this.markerClassName) || (this._attachments(s, i), s.addClass(this.markerClassName).on("keydown", this._doKeyDown).on("keypress", this._doKeyPress).on("keyup", this._doKeyUp), this._autoSize(i), t.data(e, "datepicker", i), i.settings.disabled && this._disableDatepicker(e));}, _attachments: function (e, i) {var s, n, o, a = this._get(i, "appendText"), r = this._get(i, "isRTL");i.append && i.append.remove(), a && (i.append = t("<span class='" + this._appendClass + "'>" + a + "</span>"), e[r ? "before" : "after"](i.append)), e.off("focus", this._showDatepicker), i.trigger && i.trigger.remove(), s = this._get(i, "showOn"), ("focus" === s || "both" === s) && e.on("focus", this._showDatepicker), ("button" === s || "both" === s) && (n = this._get(i, "buttonText"), o = this._get(i, "buttonImage"), i.trigger = t(this._get(i, "buttonImageOnly") ? t("<img/>").addClass(this._triggerClass).attr({ src: o, alt: n, title: n }) : t("<button type='button'></button>").addClass(this._triggerClass).html(o ? t("<img/>").attr({ src: o, alt: n, title: n }) : n)), e[r ? "before" : "after"](i.trigger), i.trigger.on("click", function () {return t.datepicker._datepickerShowing && t.datepicker._lastInput === e[0] ? t.datepicker._hideDatepicker() : t.datepicker._datepickerShowing && t.datepicker._lastInput !== e[0] ? (t.datepicker._hideDatepicker(), t.datepicker._showDatepicker(e[0])) : t.datepicker._showDatepicker(e[0]), !1;}));}, _autoSize: function (t) {if (this._get(t, "autoSize") && !t.inline) {var e, i, s, n, o = new Date(2009, 11, 20), a = this._get(t, "dateFormat");a.match(/[DM]/) && (e = function (t) {for (i = 0, s = 0, n = 0;t.length > n;n++)t[n].length > i && (i = t[n].length, s = n);return s;}, o.setMonth(e(this._get(t, a.match(/MM/) ? "monthNames" : "monthNamesShort"))), o.setDate(e(this._get(t, a.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - o.getDay())), t.input.attr("size", this._formatDate(t, o).length);}}, _inlineDatepicker: function (e, i) {var s = t(e);s.hasClass(this.markerClassName) || (s.addClass(this.markerClassName).append(i.dpDiv), t.data(e, "datepicker", i), this._setDate(i, this._getDefaultDate(i), !0), this._updateDatepicker(i), this._updateAlternate(i), i.settings.disabled && this._disableDatepicker(e), i.dpDiv.css("display", "block"));}, _dialogDatepicker: function (e, i, s, n, o) {var r, h, l, c, u, d = this._dialogInst;return d || (this.uuid += 1, r = "dp" + this.uuid, this._dialogInput = t("<input type='text' id='" + r + "' style='position: absolute; top: -100px; width: 0px;'/>"), this._dialogInput.on("keydown", this._doKeyDown), t("body").append(this._dialogInput), d = this._dialogInst = this._newInst(this._dialogInput, !1), d.settings = {}, t.data(this._dialogInput[0], "datepicker", d)), a(d.settings, n || {}), i = i && i.constructor === Date ? this._formatDate(d, i) : i, this._dialogInput.val(i), this._pos = o ? o.length ? o : [o.pageX, o.pageY] : null, this._pos || (h = document.documentElement.clientWidth, l = document.documentElement.clientHeight, c = document.documentElement.scrollLeft || document.body.scrollLeft, u = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [h / 2 - 100 + c, l / 2 - 150 + u]), this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px"), d.settings.onSelect = s, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), t.blockUI && t.blockUI(this.dpDiv), t.data(this._dialogInput[0], "datepicker", d), this;}, _destroyDatepicker: function (e) {var i, s = t(e), n = t.data(e, "datepicker");s.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), t.removeData(e, "datepicker"), "input" === i ? (n.append.remove(), n.trigger.remove(), s.removeClass(this.markerClassName).off("focus", this._showDatepicker).off("keydown", this._doKeyDown).off("keypress", this._doKeyPress).off("keyup", this._doKeyUp)) : ("div" === i || "span" === i) && s.removeClass(this.markerClassName).empty(), m === n && (m = null));}, _enableDatepicker: function (e) {var i, s, n = t(e), o = t.data(e, "datepicker");n.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), "input" === i ? (e.disabled = !1, o.trigger.filter("button").each(function () {this.disabled = !1;}).end().filter("img").css({ opacity: "1.0", cursor: "" })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().removeClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !1)), this._disabledInputs = t.map(this._disabledInputs, function (t) {return t === e ? null : t;}));}, _disableDatepicker: function (e) {var i, s, n = t(e), o = t.data(e, "datepicker");n.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), "input" === i ? (e.disabled = !0, o.trigger.filter("button").each(function () {this.disabled = !0;}).end().filter("img").css({ opacity: "0.5", cursor: "default" })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().addClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !0)), this._disabledInputs = t.map(this._disabledInputs, function (t) {return t === e ? null : t;}), this._disabledInputs[this._disabledInputs.length] = e);}, _isDisabledDatepicker: function (t) {if (!t) return !1;for (var e = 0;this._disabledInputs.length > e;e++) if (this._disabledInputs[e] === t) return !0;return !1;}, _getInst: function (e) {try {return t.data(e, "datepicker");} catch (i) {throw "Missing instance data for this datepicker";}}, _optionDatepicker: function (e, i, s) {var n, o, r, h, l = this._getInst(e);return 2 === arguments.length && "string" === typeof i ? "defaults" === i ? t.extend({}, t.datepicker._defaults) : l ? "all" === i ? t.extend({}, l.settings) : this._get(l, i) : null : (n = i || {}, "string" === typeof i && (n = {}, n[i] = s), l && (this._curInst === l && this._hideDatepicker(), o = this._getDateDatepicker(e, !0), r = this._getMinMaxDate(l, "min"), h = this._getMinMaxDate(l, "max"), a(l.settings, n), null !== r && void 0 !== n.dateFormat && void 0 === n.minDate && (l.settings.minDate = this._formatDate(l, r)), null !== h && void 0 !== n.dateFormat && void 0 === n.maxDate && (l.settings.maxDate = this._formatDate(l, h)), "disabled" in n && (n.disabled ? this._disableDatepicker(e) : this._enableDatepicker(e)), this._attachments(t(e), l), this._autoSize(l), this._setDate(l, o), this._updateAlternate(l), this._updateDatepicker(l)), void 0);}, _changeDatepicker: function (t, e, i) {this._optionDatepicker(t, e, i);}, _refreshDatepicker: function (t) {var e = this._getInst(t);e && this._updateDatepicker(e);}, _setDateDatepicker: function (t, e) {var i = this._getInst(t);i && (this._setDate(i, e), this._updateDatepicker(i), this._updateAlternate(i));}, _getDateDatepicker: function (t, e) {var i = this._getInst(t);return i && !i.inline && this._setDateFromField(i, e), i ? this._getDate(i) : null;}, _doKeyDown: function (e) {var i, s, n, o = t.datepicker._getInst(e.target), a = !0, r = o.dpDiv.is(".ui-datepicker-rtl");if (o._keyEvent = !0, t.datepicker._datepickerShowing) switch (e.keyCode) {case 9:t.datepicker._hideDatepicker(), a = !1;break;case 13:return n = t("td." + t.datepicker._dayOverClass + ":not(." + t.datepicker._currentClass + ")", o.dpDiv), n[0] && t.datepicker._selectDay(e.target, o.selectedMonth, o.selectedYear, n[0]), i = t.datepicker._get(o, "onSelect"), i ? (s = t.datepicker._formatDate(o), i.apply(o.input ? o.input[0] : null, [s, o])) : t.datepicker._hideDatepicker(), !1;case 27:t.datepicker._hideDatepicker();break;case 33:t.datepicker._adjustDate(e.target, e.ctrlKey ? -t.datepicker._get(o, "stepBigMonths") : -t.datepicker._get(o, "stepMonths"), "M");break;case 34:t.datepicker._adjustDate(e.target, e.ctrlKey ? +t.datepicker._get(o, "stepBigMonths") : +t.datepicker._get(o, "stepMonths"), "M");break;case 35:(e.ctrlKey || e.metaKey) && t.datepicker._clearDate(e.target), a = e.ctrlKey || e.metaKey;break;case 36:(e.ctrlKey || e.metaKey) && t.datepicker._gotoToday(e.target), a = e.ctrlKey || e.metaKey;break;case 37:(e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, r ? 1 : -1, "D"), a = e.ctrlKey || e.metaKey, e.originalEvent.altKey && t.datepicker._adjustDate(e.target, e.ctrlKey ? -t.datepicker._get(o, "stepBigMonths") : -t.datepicker._get(o, "stepMonths"), "M");break;case 38:(e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, -7, "D"), a = e.ctrlKey || e.metaKey;break;case 39:(e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, r ? -1 : 1, "D"), a = e.ctrlKey || e.metaKey, e.originalEvent.altKey && t.datepicker._adjustDate(e.target, e.ctrlKey ? +t.datepicker._get(o, "stepBigMonths") : +t.datepicker._get(o, "stepMonths"), "M");break;case 40:(e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, 7, "D"), a = e.ctrlKey || e.metaKey;break;default:a = !1;} else 36 === e.keyCode && e.ctrlKey ? t.datepicker._showDatepicker(this) : a = !1;a && (e.preventDefault(), e.stopPropagation());}, _doKeyPress: function (e) {var i, s, n = t.datepicker._getInst(e.target);return t.datepicker._get(n, "constrainInput") ? (i = t.datepicker._possibleChars(t.datepicker._get(n, "dateFormat")), s = String.fromCharCode(null == e.charCode ? e.keyCode : e.charCode), e.ctrlKey || e.metaKey || " " > s || !i || i.indexOf(s) > -1) : void 0;}, _doKeyUp: function (e) {var i, s = t.datepicker._getInst(e.target);if (s.input.val() !== s.lastVal) try {i = t.datepicker.parseDate(t.datepicker._get(s, "dateFormat"), s.input ? s.input.val() : null, t.datepicker._getFormatConfig(s)), i && (t.datepicker._setDateFromField(s), t.datepicker._updateAlternate(s), t.datepicker._updateDatepicker(s));} catch (n) {} return !0;}, _showDatepicker: function (e) {if (e = e.target || e, "input" !== e.nodeName.toLowerCase() && (e = t("input", e.parentNode)[0]), !t.datepicker._isDisabledDatepicker(e) && t.datepicker._lastInput !== e) {var s, n, o, r, h, l, c;s = t.datepicker._getInst(e), t.datepicker._curInst && t.datepicker._curInst !== s && (t.datepicker._curInst.dpDiv.stop(!0, !0), s && t.datepicker._datepickerShowing && t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])), n = t.datepicker._get(s, "beforeShow"), o = n ? n.apply(e, [e, s]) : {}, o !== !1 && (a(s.settings, o), s.lastVal = null, t.datepicker._lastInput = e, t.datepicker._setDateFromField(s), t.datepicker._inDialog && (e.value = ""), t.datepicker._pos || (t.datepicker._pos = t.datepicker._findPos(e), t.datepicker._pos[1] += e.offsetHeight), r = !1, t(e).parents().each(function () {return r |= "fixed" === t(this).css("position"), !r;}), h = { left: t.datepicker._pos[0], top: t.datepicker._pos[1] }, t.datepicker._pos = null, s.dpDiv.empty(), s.dpDiv.css({ position: "absolute", display: "block", top: "-1000px" }), t.datepicker._updateDatepicker(s), h = t.datepicker._checkOffset(s, h, r), s.dpDiv.css({ position: t.datepicker._inDialog && t.blockUI ? "static" : r ? "fixed" : "absolute", display: "none", left: h.left + "px", top: h.top + "px" }), s.inline || (l = t.datepicker._get(s, "showAnim"), c = t.datepicker._get(s, "duration"), s.dpDiv.css("z-index", i(t(e)) + 1), t.datepicker._datepickerShowing = !0, t.effects && t.effects.effect[l] ? s.dpDiv.show(l, t.datepicker._get(s, "showOptions"), c) : s.dpDiv[l || "show"](l ? c : null), t.datepicker._shouldFocusInput(s) && s.input.trigger("focus"), t.datepicker._curInst = s));
}}, _updateDatepicker: function (e) {this.maxRows = 4, m = e, e.dpDiv.empty().append(this._generateHTML(e)), this._attachHandlers(e);var i, s = this._getNumberOfMonths(e), n = s[1], a = 17, r = e.dpDiv.find("." + this._dayOverClass + " a");r.length > 0 && o.apply(r.get(0)), e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""), n > 1 && e.dpDiv.addClass("ui-datepicker-multi-" + n).css("width", a * n + "em"), e.dpDiv[(1 !== s[0] || 1 !== s[1] ? "add" : "remove") + "Class"]("ui-datepicker-multi"), e.dpDiv[(this._get(e, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl"), e === t.datepicker._curInst && t.datepicker._datepickerShowing && t.datepicker._shouldFocusInput(e) && e.input.trigger("focus"), e.yearshtml && (i = e.yearshtml, setTimeout(function () {i === e.yearshtml && e.yearshtml && e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml), i = e.yearshtml = null;}, 0));}, _shouldFocusInput: function (t) {return t.input && t.input.is(":visible") && !t.input.is(":disabled") && !t.input.is(":focus");}, _checkOffset: function (e, i, s) {var n = e.dpDiv.outerWidth(), o = e.dpDiv.outerHeight(), a = e.input ? e.input.outerWidth() : 0, r = e.input ? e.input.outerHeight() : 0, h = document.documentElement.clientWidth + (s ? 0 : t(document).scrollLeft()), l = document.documentElement.clientHeight + (s ? 0 : t(document).scrollTop());return i.left -= this._get(e, "isRTL") ? n - a : 0, i.left -= s && i.left === e.input.offset().left ? t(document).scrollLeft() : 0, i.top -= s && i.top === e.input.offset().top + r ? t(document).scrollTop() : 0, i.left -= Math.min(i.left, i.left + n > h && h > n ? Math.abs(i.left + n - h) : 0), i.top -= Math.min(i.top, i.top + o > l && l > o ? Math.abs(o + r) : 0), i;}, _findPos: function (e) {for (var i, s = this._getInst(e), n = this._get(s, "isRTL");e && ("hidden" === e.type || 1 !== e.nodeType || t.expr.filters.hidden(e));)e = e[n ? "previousSibling" : "nextSibling"];return i = t(e).offset(), [i.left, i.top];}, _hideDatepicker: function (e) {var i, s, n, o, a = this._curInst;!a || e && a !== t.data(e, "datepicker") || this._datepickerShowing && (i = this._get(a, "showAnim"), s = this._get(a, "duration"), n = function () {t.datepicker._tidyDialog(a);}, t.effects && (t.effects.effect[i] || t.effects[i]) ? a.dpDiv.hide(i, t.datepicker._get(a, "showOptions"), s, n) : a.dpDiv["slideDown" === i ? "slideUp" : "fadeIn" === i ? "fadeOut" : "hide"](i ? s : null, n), i || n(), this._datepickerShowing = !1, o = this._get(a, "onClose"), o && o.apply(a.input ? a.input[0] : null, [a.input ? a.input.val() : "", a]), this._lastInput = null, this._inDialog && (this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" }), t.blockUI && (t.unblockUI(), t("body").append(this.dpDiv))), this._inDialog = !1);}, _tidyDialog: function (t) {t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar");}, _checkExternalClick: function (e) {if (t.datepicker._curInst) {var i = t(e.target), s = t.datepicker._getInst(i[0]);(i[0].id !== t.datepicker._mainDivId && 0 === i.parents("#" + t.datepicker._mainDivId).length && !i.hasClass(t.datepicker.markerClassName) && !i.closest("." + t.datepicker._triggerClass).length && t.datepicker._datepickerShowing && (!t.datepicker._inDialog || !t.blockUI) || i.hasClass(t.datepicker.markerClassName) && t.datepicker._curInst !== s) && t.datepicker._hideDatepicker();}}, _adjustDate: function (e, i, s) {var n = t(e), o = this._getInst(n[0]);this._isDisabledDatepicker(n[0]) || (this._adjustInstDate(o, i + ("M" === s ? this._get(o, "showCurrentAtPos") : 0), s), this._updateDatepicker(o));}, _gotoToday: function (e) {var i, s = t(e), n = this._getInst(s[0]);this._get(n, "gotoCurrent") && n.currentDay ? (n.selectedDay = n.currentDay, n.drawMonth = n.selectedMonth = n.currentMonth, n.drawYear = n.selectedYear = n.currentYear) : (i = new Date, n.selectedDay = i.getDate(), n.drawMonth = n.selectedMonth = i.getMonth(), n.drawYear = n.selectedYear = i.getFullYear()), this._notifyChange(n), this._adjustDate(s);}, _selectMonthYear: function (e, i, s) {var n = t(e), o = this._getInst(n[0]);o["selected" + ("M" === s ? "Month" : "Year")] = o["draw" + ("M" === s ? "Month" : "Year")] = parseInt(i.options[i.selectedIndex].value, 10), this._notifyChange(o), this._adjustDate(n);}, _selectDay: function (e, i, s, n) {var o, a = t(e);t(n).hasClass(this._unselectableClass) || this._isDisabledDatepicker(a[0]) || (o = this._getInst(a[0]), o.selectedDay = o.currentDay = t("a", n).html(), o.selectedMonth = o.currentMonth = i, o.selectedYear = o.currentYear = s, this._selectDate(e, this._formatDate(o, o.currentDay, o.currentMonth, o.currentYear)));}, _clearDate: function (e) {var i = t(e);this._selectDate(i, "");}, _selectDate: function (e, i) {var s, n = t(e), o = this._getInst(n[0]);i = null != i ? i : this._formatDate(o), o.input && o.input.val(i), this._updateAlternate(o), s = this._get(o, "onSelect"), s ? s.apply(o.input ? o.input[0] : null, [i, o]) : o.input && o.input.trigger("change"), o.inline ? this._updateDatepicker(o) : (this._hideDatepicker(), this._lastInput = o.input[0], "object" !== typeof o.input[0] && o.input.trigger("focus"), this._lastInput = null);}, _updateAlternate: function (e) {var i, s, n, o = this._get(e, "altField");o && (i = this._get(e, "altFormat") || this._get(e, "dateFormat"), s = this._getDate(e), n = this.formatDate(i, s, this._getFormatConfig(e)), t(o).val(n));}, noWeekends: function (t) {var e = t.getDay();return [e > 0 && 6 > e, ""];}, iso8601Week: function (t) {var e, i = new Date(t.getTime());return i.setDate(i.getDate() + 4 - (i.getDay() || 7)), e = i.getTime(), i.setMonth(0), i.setDate(1), Math.floor(Math.round((e - i) / 864e5) / 7) + 1;}, parseDate: function (e, i, s) {if (null == e || null == i) throw "Invalid arguments";if (i = "object" === typeof i ? "" + i : i + "", "" === i) return null;var n, o, a, r, h = 0, l = (s ? s.shortYearCutoff : null) || this._defaults.shortYearCutoff, c = "string" !== typeof l ? l : (new Date).getFullYear() % 100 + parseInt(l, 10), u = (s ? s.dayNamesShort : null) || this._defaults.dayNamesShort, d = (s ? s.dayNames : null) || this._defaults.dayNames, p = (s ? s.monthNamesShort : null) || this._defaults.monthNamesShort, f = (s ? s.monthNames : null) || this._defaults.monthNames, g = -1, m = -1, _ = -1, v = -1, b = !1, y = function (t) {var i = e.length > n + 1 && e.charAt(n + 1) === t;return i && n++, i;}, w = function (t) {var e = y(t), s = "@" === t ? 14 : "!" === t ? 20 : "y" === t && e ? 4 : "o" === t ? 3 : 2, n = "y" === t ? s : 1, o = RegExp("^\\d{" + n + "," + s + "}"), a = i.substring(h).match(o);if (!a) throw "Missing number at position " + h;return h += a[0].length, parseInt(a[0], 10);}, k = function (e, s, n) {var o = -1, a = t.map(y(e) ? n : s, function (t, e) {return [[e, t]];}).sort(function (t, e) {return -(t[1].length - e[1].length);});if (t.each(a, function (t, e) {var s = e[1];return i.substr(h, s.length).toLowerCase() === s.toLowerCase() ? (o = e[0], h += s.length, !1) : void 0;}), -1 !== o) return o + 1;throw "Unknown name at position " + h;}, x = function () {if (i.charAt(h) !== e.charAt(n)) throw "Unexpected literal at position " + h;h++;};for (n = 0;e.length > n;n++) if (b)"'" !== e.charAt(n) || y("'") ? x() : b = !1;else switch (e.charAt(n)) {case "d":_ = w("d");break;case "D":k("D", u, d);break;case "o":v = w("o");break;case "m":m = w("m");break;case "M":m = k("M", p, f);break;case "y":g = w("y");break;case "@":r = new Date(w("@")), g = r.getFullYear(), m = r.getMonth() + 1, _ = r.getDate();break;case "!":r = new Date((w("!") - this._ticksTo1970) / 1e4), g = r.getFullYear(), m = r.getMonth() + 1, _ = r.getDate();break;case "'":y("'") ? x() : b = !0;break;default:x();} if (i.length > h && (a = i.substr(h), !/^\s+/.test(a))) throw "Extra/unparsed characters found in date: " + a;if (-1 === g ? g = (new Date).getFullYear() : 100 > g && (g += (new Date).getFullYear() - (new Date).getFullYear() % 100 + (c >= g ? 0 : -100)), v > -1) for (m = 1, _ = v;;) {if (o = this._getDaysInMonth(g, m - 1), o >= _) break;m++, _ -= o;} if (r = this._daylightSavingAdjust(new Date(g, m - 1, _)), r.getFullYear() !== g || r.getMonth() + 1 !== m || r.getDate() !== _) throw "Invalid date";return r;}, ATOM: "yy-mm-dd", COOKIE: "D, dd M yy", ISO_8601: "yy-mm-dd", RFC_822: "D, d M y", RFC_850: "DD, dd-M-y", RFC_1036: "D, d M y", RFC_1123: "D, d M yy", RFC_2822: "D, d M yy", RSS: "D, d M y", TICKS: "!", TIMESTAMP: "@", W3C: "yy-mm-dd", _ticksTo1970: 1e7 * 60 * 60 * 24 * (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)), formatDate: function (t, e, i) {if (!e) return "";var s, n = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort, o = (i ? i.dayNames : null) || this._defaults.dayNames, a = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort, r = (i ? i.monthNames : null) || this._defaults.monthNames, h = function (e) {var i = t.length > s + 1 && t.charAt(s + 1) === e;return i && s++, i;}, l = function (t, e, i) {var s = "" + e;if (h(t)) for (;i > s.length;)s = "0" + s;return s;}, c = function (t, e, i, s) {return h(t) ? s[e] : i[e];}, u = "", d = !1;if (e) for (s = 0;t.length > s;s++) if (d)"'" !== t.charAt(s) || h("'") ? u += t.charAt(s) : d = !1;else switch (t.charAt(s)) {case "d":u += l("d", e.getDate(), 2);break;case "D":u += c("D", e.getDay(), n, o);break;case "o":u += l("o", Math.round((new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / 864e5), 3);break;case "m":u += l("m", e.getMonth() + 1, 2);break;case "M":u += c("M", e.getMonth(), a, r);break;case "y":u += h("y") ? e.getFullYear() : (10 > e.getFullYear() % 100 ? "0" : "") + e.getFullYear() % 100;break;case "@":u += e.getTime();break;case "!":u += 1e4 * e.getTime() + this._ticksTo1970;break;case "'":h("'") ? u += "'" : d = !0;break;default:u += t.charAt(s);} return u;}, _possibleChars: function (t) {var e, i = "", s = !1, n = function (i) {var s = t.length > e + 1 && t.charAt(e + 1) === i;return s && e++, s;};for (e = 0;t.length > e;e++) if (s)"'" !== t.charAt(e) || n("'") ? i += t.charAt(e) : s = !1;else switch (t.charAt(e)) {case "d":case "m":case "y":case "@":i += "0123456789";break;case "D":case "M":return null;case "'":n("'") ? i += "'" : s = !0;break;default:i += t.charAt(e);} return i;}, _get: function (t, e) {return void 0 !== t.settings[e] ? t.settings[e] : this._defaults[e];}, _setDateFromField: function (t, e) {if (t.input.val() !== t.lastVal) {var i = this._get(t, "dateFormat"), s = t.lastVal = t.input ? t.input.val() : null, n = this._getDefaultDate(t), o = n, a = this._getFormatConfig(t);try {o = this.parseDate(i, s, a) || n;} catch (r) {s = e ? "" : s;}t.selectedDay = o.getDate(), t.drawMonth = t.selectedMonth = o.getMonth(), t.drawYear = t.selectedYear = o.getFullYear(), t.currentDay = s ? o.getDate() : 0, t.currentMonth = s ? o.getMonth() : 0, t.currentYear = s ? o.getFullYear() : 0, this._adjustInstDate(t);}}, _getDefaultDate: function (t) {return this._restrictMinMax(t, this._determineDate(t, this._get(t, "defaultDate"), new Date));}, _determineDate: function (e, i, s) {var n = function (t) {var e = new Date;return e.setDate(e.getDate() + t), e;}, o = function (i) {try {return t.datepicker.parseDate(t.datepicker._get(e, "dateFormat"), i, t.datepicker._getFormatConfig(e));} catch (s) {} for (var n = (i.toLowerCase().match(/^c/) ? t.datepicker._getDate(e) : null) || new Date, o = n.getFullYear(), a = n.getMonth(), r = n.getDate(), h = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, l = h.exec(i);l;) {switch (l[2] || "d") {case "d":case "D":r += parseInt(l[1], 10);break;case "w":case "W":r += 7 * parseInt(l[1], 10);break;case "m":case "M":a += parseInt(l[1], 10), r = Math.min(r, t.datepicker._getDaysInMonth(o, a));break;case "y":case "Y":o += parseInt(l[1], 10), r = Math.min(r, t.datepicker._getDaysInMonth(o, a));}l = h.exec(i);} return new Date(o, a, r);}, a = null == i || "" === i ? s : "string" === typeof i ? o(i) : "number" === typeof i ? isNaN(i) ? s : n(i) : new Date(i.getTime());return a = a && "Invalid Date" == "" + a ? s : a, a && (a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)), this._daylightSavingAdjust(a);}, _daylightSavingAdjust: function (t) {return t ? (t.setHours(t.getHours() > 12 ? t.getHours() + 2 : 0), t) : null;}, _setDate: function (t, e, i) {var s = !e, n = t.selectedMonth, o = t.selectedYear, a = this._restrictMinMax(t, this._determineDate(t, e, new Date));t.selectedDay = t.currentDay = a.getDate(), t.drawMonth = t.selectedMonth = t.currentMonth = a.getMonth(), t.drawYear = t.selectedYear = t.currentYear = a.getFullYear(), n === t.selectedMonth && o === t.selectedYear || i || this._notifyChange(t), this._adjustInstDate(t), t.input && t.input.val(s ? "" : this._formatDate(t));}, _getDate: function (t) {var e = !t.currentYear || t.input && "" === t.input.val() ? null : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));return e;}, _attachHandlers: function (e) {var i = this._get(e, "stepMonths"), s = "#" + e.id.replace(/\\\\/g, "\\");e.dpDiv.find("[data-handler]").map(function () {var e = { prev: function () {t.datepicker._adjustDate(s, -i, "M");}, next: function () {t.datepicker._adjustDate(s, +i, "M");}, hide: function () {t.datepicker._hideDatepicker();}, today: function () {t.datepicker._gotoToday(s);}, selectDay: function () {return t.datepicker._selectDay(s, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this), !1;}, selectMonth: function () {return t.datepicker._selectMonthYear(s, this, "M"), !1;}, selectYear: function () {return t.datepicker._selectMonthYear(s, this, "Y"), !1;} };t(this).on(this.getAttribute("data-event"), e[this.getAttribute("data-handler")]);});}, _generateHTML: function (t) {var e, i, s, n, o, a, r, h, l, c, u, d, p, f, g, m, _, v, b, y, w, k, x, C, D, I, T, P, M, S, H, z, O, A, N, W, E, F, L, R = new Date, B = this._daylightSavingAdjust(new Date(R.getFullYear(), R.getMonth(), R.getDate())), Y = this._get(t, "isRTL"), j = this._get(t, "showButtonPanel"), q = this._get(t, "hideIfNoPrevNext"), K = this._get(t, "navigationAsDateFormat"), U = this._getNumberOfMonths(t), V = this._get(t, "showCurrentAtPos"), $ = this._get(t, "stepMonths"), X = 1 !== U[0] || 1 !== U[1], G = this._daylightSavingAdjust(t.currentDay ? new Date(t.currentYear, t.currentMonth, t.currentDay) : new Date(9999, 9, 9)), Q = this._getMinMaxDate(t, "min"), J = this._getMinMaxDate(t, "max"), Z = t.drawMonth - V, te = t.drawYear;if (0 > Z && (Z += 12, te--), J) for (e = this._daylightSavingAdjust(new Date(J.getFullYear(), J.getMonth() - U[0] * U[1] + 1, J.getDate())), e = Q && Q > e ? Q : e;this._daylightSavingAdjust(new Date(te, Z, 1)) > e;)Z--, 0 > Z && (Z = 11, te--);for (t.drawMonth = Z, t.drawYear = te, i = this._get(t, "prevText"), i = K ? this.formatDate(i, this._daylightSavingAdjust(new Date(te, Z - $, 1)), this._getFormatConfig(t)) : i, s = this._canAdjustMonth(t, -1, te, Z) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>" : q ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>", n = this._get(t, "nextText"), n = K ? this.formatDate(n, this._daylightSavingAdjust(new Date(te, Z + $, 1)), this._getFormatConfig(t)) : n, o = this._canAdjustMonth(t, 1, te, Z) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>" : q ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>", a = this._get(t, "currentText"), r = this._get(t, "gotoCurrent") && t.currentDay ? G : B, a = K ? this.formatDate(a, r, this._getFormatConfig(t)) : a, h = t.inline ? "" : "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(t, "closeText") + "</button>", l = j ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (Y ? h : "") + (this._isInRange(t, r) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" + a + "</button>" : "") + (Y ? "" : h) + "</div>" : "", c = parseInt(this._get(t, "firstDay"), 10), c = isNaN(c) ? 0 : c, u = this._get(t, "showWeek"), d = this._get(t, "dayNames"), p = this._get(t, "dayNamesMin"), f = this._get(t, "monthNames"), g = this._get(t, "monthNamesShort"), m = this._get(t, "beforeShowDay"), _ = this._get(t, "showOtherMonths"), v = this._get(t, "selectOtherMonths"), b = this._getDefaultDate(t), y = "", k = 0;U[0] > k;k++) {for (x = "", this.maxRows = 4, C = 0;U[1] > C;C++) {if (D = this._daylightSavingAdjust(new Date(te, Z, t.selectedDay)), I = " ui-corner-all", T = "", X) {if (T += "<div class='ui-datepicker-group", U[1] > 1) switch (C) {case 0:T += " ui-datepicker-group-first", I = " ui-corner-" + (Y ? "right" : "left");break;case U[1] - 1:T += " ui-datepicker-group-last", I = " ui-corner-" + (Y ? "left" : "right");break;default:T += " ui-datepicker-group-middle", I = "";}T += "'>";} for (T += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + I + "'>" + (/all|left/.test(I) && 0 === k ? Y ? o : s : "") + (/all|right/.test(I) && 0 === k ? Y ? s : o : "") + this._generateMonthYearHeader(t, Z, te, Q, J, k > 0 || C > 0, f, g) + "</div><table class='ui-datepicker-calendar'><thead>" + "<tr>", P = u ? "<th class='ui-datepicker-week-col'>" + this._get(t, "weekHeader") + "</th>" : "", w = 0;7 > w;w++)M = (w + c) % 7, P += "<th scope='col'" + ((w + c + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + d[M] + "'>" + p[M] + "</span></th>";for (T += P + "</tr></thead><tbody>", S = this._getDaysInMonth(te, Z), te === t.selectedYear && Z === t.selectedMonth && (t.selectedDay = Math.min(t.selectedDay, S)), H = (this._getFirstDayOfMonth(te, Z) - c + 7) % 7, z = Math.ceil((H + S) / 7), O = X ? this.maxRows > z ? this.maxRows : z : z, this.maxRows = O, A = this._daylightSavingAdjust(new Date(te, Z, 1 - H)), N = 0;O > N;N++) {for (T += "<tr>", W = u ? "<td class='ui-datepicker-week-col'>" + this._get(t, "calculateWeek")(A) + "</td>" : "", w = 0;7 > w;w++)E = m ? m.apply(t.input ? t.input[0] : null, [A]) : [!0, ""], F = A.getMonth() !== Z, L = F && !v || !E[0] || Q && Q > A || J && A > J, W += "<td class='" + ((w + c + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + (F ? " ui-datepicker-other-month" : "") + (A.getTime() === D.getTime() && Z === t.selectedMonth && t._keyEvent || b.getTime() === A.getTime() && b.getTime() === D.getTime() ? " " + this._dayOverClass : "") + (L ? " " + this._unselectableClass + " ui-state-disabled" : "") + (F && !_ ? "" : " " + E[1] + (A.getTime() === G.getTime() ? " " + this._currentClass : "") + (A.getTime() === B.getTime() ? " ui-datepicker-today" : "")) + "'" + (F && !_ || !E[2] ? "" : " title='" + E[2].replace(/'/g, "&#39;") + "'") + (L ? "" : " data-handler='selectDay' data-event='click' data-month='" + A.getMonth() + "' data-year='" + A.getFullYear() + "'") + ">" + (F && !_ ? "&#xa0;" : L ? "<span class='ui-state-default'>" + A.getDate() + "</span>" : "<a class='ui-state-default" + (A.getTime() === B.getTime() ? " ui-state-highlight" : "") + (A.getTime() === G.getTime() ? " ui-state-active" : "") + (F ? " ui-priority-secondary" : "") + "' href='#'>" + A.getDate() + "</a>") + "</td>", A.setDate(A.getDate() + 1), A = this._daylightSavingAdjust(A);T += W + "</tr>";}Z++, Z > 11 && (Z = 0, te++), T += "</tbody></table>" + (X ? "</div>" + (U[0] > 0 && C === U[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : ""), x += T;}y += x;} return y += l, t._keyEvent = !1, y;}, _generateMonthYearHeader: function (t, e, i, s, n, o, a, r) {var h, l, c, u, d, p, f, g, m = this._get(t, "changeMonth"), _ = this._get(t, "changeYear"), v = this._get(t, "showMonthAfterYear"), b = "<div class='ui-datepicker-title'>", y = "";if (o || !m)y += "<span class='ui-datepicker-month'>" + a[e] + "</span>";else {for (h = s && s.getFullYear() === i, l = n && n.getFullYear() === i, y += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>", c = 0;12 > c;c++)(!h || c >= s.getMonth()) && (!l || n.getMonth() >= c) && (y += "<option value='" + c + "'" + (c === e ? " selected='selected'" : "") + ">" + r[c] + "</option>");y += "</select>";} if (v || (b += y + (!o && m && _ ? "" : "&#xa0;")), !t.yearshtml) if (t.yearshtml = "", o || !_)b += "<span class='ui-datepicker-year'>" + i + "</span>";else {for (u = this._get(t, "yearRange").split(":"), d = (new Date).getFullYear(), p = function (t) {var e = t.match(/c[+\-].*/) ? i + parseInt(t.substring(1), 10) : t.match(/[+\-].*/) ? d + parseInt(t, 10) : parseInt(t, 10);return isNaN(e) ? d : e;}, f = p(u[0]), g = Math.max(f, p(u[1] || "")), f = s ? Math.max(f, s.getFullYear()) : f, g = n ? Math.min(g, n.getFullYear()) : g, t.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";g >= f;f++)t.yearshtml += "<option value='" + f + "'" + (f === i ? " selected='selected'" : "") + ">" + f + "</option>";t.yearshtml += "</select>", b += t.yearshtml, t.yearshtml = null;} return b += this._get(t, "yearSuffix"), v && (b += (!o && m && _ ? "" : "&#xa0;") + y), b += "</div>";}, _adjustInstDate: function (t, e, i) {var s = t.selectedYear + ("Y" === i ? e : 0), n = t.selectedMonth + ("M" === i ? e : 0), o = Math.min(t.selectedDay, this._getDaysInMonth(s, n)) + ("D" === i ? e : 0), a = this._restrictMinMax(t, this._daylightSavingAdjust(new Date(s, n, o)));t.selectedDay = a.getDate(), t.drawMonth = t.selectedMonth = a.getMonth(), t.drawYear = t.selectedYear = a.getFullYear(), ("M" === i || "Y" === i) && this._notifyChange(t);}, _restrictMinMax: function (t, e) {var i = this._getMinMaxDate(t, "min"), s = this._getMinMaxDate(t, "max"), n = i && i > e ? i : e;return s && n > s ? s : n;}, _notifyChange: function (t) {var e = this._get(t, "onChangeMonthYear");e && e.apply(t.input ? t.input[0] : null, [t.selectedYear, t.selectedMonth + 1, t]);}, _getNumberOfMonths: function (t) {var e = this._get(t, "numberOfMonths");return null == e ? [1, 1] : "number" === typeof e ? [1, e] : e;}, _getMinMaxDate: function (t, e) {return this._determineDate(t, this._get(t, e + "Date"), null);}, _getDaysInMonth: function (t, e) {return 32 - this._daylightSavingAdjust(new Date(t, e, 32)).getDate();}, _getFirstDayOfMonth: function (t, e) {return new Date(t, e, 1).getDay();}, _canAdjustMonth: function (t, e, i, s) {var n = this._getNumberOfMonths(t), o = this._daylightSavingAdjust(new Date(i, s + (0 > e ? e : n[0] * n[1]), 1));return 0 > e && o.setDate(this._getDaysInMonth(o.getFullYear(), o.getMonth())), this._isInRange(t, o);}, _isInRange: function (t, e) {var i, s, n = this._getMinMaxDate(t, "min"), o = this._getMinMaxDate(t, "max"), a = null, r = null, h = this._get(t, "yearRange");return h && (i = h.split(":"), s = (new Date).getFullYear(), a = parseInt(i[0], 10), r = parseInt(i[1], 10), i[0].match(/[+\-].*/) && (a += s), i[1].match(/[+\-].*/) && (r += s)), (!n || e.getTime() >= n.getTime()) && (!o || e.getTime() <= o.getTime()) && (!a || e.getFullYear() >= a) && (!r || r >= e.getFullYear());}, _getFormatConfig: function (t) {var e = this._get(t, "shortYearCutoff");return e = "string" !== typeof e ? e : (new Date).getFullYear() % 100 + parseInt(e, 10), { shortYearCutoff: e, dayNamesShort: this._get(t, "dayNamesShort"), dayNames: this._get(t, "dayNames"), monthNamesShort: this._get(t, "monthNamesShort"), monthNames: this._get(t, "monthNames") };}, _formatDate: function (t, e, i, s) {e || (t.currentDay = t.selectedDay, t.currentMonth = t.selectedMonth, t.currentYear = t.selectedYear);var n = e ? "object" === typeof e ? e : this._daylightSavingAdjust(new Date(s, i, e)) : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));return this.formatDate(this._get(t, "dateFormat"), n, this._getFormatConfig(t));} }), t.fn.datepicker = function (e) {if (!this.length) return this;t.datepicker.initialized || (t(document).on("mousedown", t.datepicker._checkExternalClick), t.datepicker.initialized = !0), 0 === t("#" + t.datepicker._mainDivId).length && t("body").append(t.datepicker.dpDiv);var i = Array.prototype.slice.call(arguments, 1);return "string" !== typeof e || "isDisabled" !== e && "getDate" !== e && "widget" !== e ? "option" === e && 2 === arguments.length && "string" === typeof arguments[1] ? t.datepicker["_" + e + "Datepicker"].apply(t.datepicker, [this[0]].concat(i)) : this.each(function () {"string" === typeof e ? t.datepicker["_" + e + "Datepicker"].apply(t.datepicker, [this].concat(i)) : t.datepicker._attachDatepicker(this, e);}) : t.datepicker["_" + e + "Datepicker"].apply(t.datepicker, [this[0]].concat(i));}, t.datepicker = new s, t.datepicker.initialized = !1, t.datepicker.uuid = (new Date).getTime(), t.datepicker.version = "1.12.1", t.datepicker, t.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var _ = !1;t(document).on("mouseup", function () {_ = !1;}), t.widget("ui.mouse", { version: "1.12.1", options: { cancel: "input, textarea, button, select, option", distance: 1, delay: 0 }, _mouseInit: function () {var e = this;this.element.on("mousedown." + this.widgetName, function (t) {return e._mouseDown(t);}).on("click." + this.widgetName, function (i) {return !0 === t.data(i.target, e.widgetName + ".preventClickEvent") ? (t.removeData(i.target, e.widgetName + ".preventClickEvent"), i.stopImmediatePropagation(), !1) : void 0;}), this.started = !1;}, _mouseDestroy: function () {this.element.off("." + this.widgetName), this._mouseMoveDelegate && this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate);}, _mouseDown: function (e) {if (!_) {this._mouseMoved = !1, this._mouseStarted && this._mouseUp(e), this._mouseDownEvent = e;var i = this, s = 1 === e.which, n = "string" === typeof this.options.cancel && e.target.nodeName ? t(e.target).closest(this.options.cancel).length : !1;return s && !n && this._mouseCapture(e) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {i.mouseDelayMet = !0;}, this.options.delay)), this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = this._mouseStart(e) !== !1, !this._mouseStarted) ? (e.preventDefault(), !0) : (!0 === t.data(e.target, this.widgetName + ".preventClickEvent") && t.removeData(e.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function (t) {return i._mouseMove(t);}, this._mouseUpDelegate = function (t) {return i._mouseUp(t);}, this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate), e.preventDefault(), _ = !0, !0)) : !0;}}, _mouseMove: function (e) {if (this._mouseMoved) {if (t.ui.ie && (!document.documentMode || 9 > document.documentMode) && !e.button) return this._mouseUp(e);if (!e.which) if (e.originalEvent.altKey || e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.shiftKey) this.ignoreMissingWhich = !0;else if (!this.ignoreMissingWhich) return this._mouseUp(e);} return (e.which || e.button) && (this._mouseMoved = !0), this._mouseStarted ? (this._mouseDrag(e), e.preventDefault()) : (this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, e) !== !1, this._mouseStarted ? this._mouseDrag(e) : this._mouseUp(e)), !this._mouseStarted);}, _mouseUp: function (e) {this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, e.target === this._mouseDownEvent.target && t.data(e.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(e)), this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer), this.ignoreMissingWhich = !1, _ = !1, e.preventDefault();}, _mouseDistanceMet: function (t) {return Math.max(Math.abs(this._mouseDownEvent.pageX - t.pageX), Math.abs(this._mouseDownEvent.pageY - t.pageY)) >= this.options.distance;}, _mouseDelayMet: function () {return this.mouseDelayMet;}, _mouseStart: function () {}, _mouseDrag: function () {}, _mouseStop: function () {}, _mouseCapture: function () {return !0;} }), t.ui.plugin = { add: function (e, i, s) {var n, o = t.ui[e].prototype;for (n in s)o.plugins[n] = o.plugins[n] || [], o.plugins[n].push([i, s[n]]);}, call: function (t, e, i, s) {var n, o = t.plugins[e];if (o && (s || t.element[0].parentNode && 11 !== t.element[0].parentNode.nodeType)) for (n = 0;o.length > n;n++)t.options[o[n][0]] && o[n][1].apply(t.element, i);} }, t.ui.safeBlur = function (e) {e && "body" !== e.nodeName.toLowerCase() && t(e).trigger("blur");}, t.widget("ui.draggable", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "drag", options: { addClasses: !0, appendTo: "parent", axis: !1, connectToSortable: !1, containment: !1, cursor: "auto", cursorAt: !1, grid: !1, handle: !1, helper: "original", iframeFix: !1, opacity: !1, refreshPositions: !1, revert: !1, revertDuration: 500, scope: "default", scroll: !0, scrollSensitivity: 20, scrollSpeed: 20, snap: !1, snapMode: "both", snapTolerance: 20, stack: !1, zIndex: !1, drag: null, start: null, stop: null }, _create: function () {"original" === this.options.helper && this._setPositionRelative(), this.options.addClasses && this._addClass("ui-draggable"), this._setHandleClassName(), this._mouseInit();}, _setOption: function (t, e) {this._super(t, e), "handle" === t && (this._removeHandleClassName(), this._setHandleClassName());}, _destroy: function () {return (this.helper || this.element).is(".ui-draggable-dragging") ? (this.destroyOnClear = !0, void 0) : (this._removeHandleClassName(), this._mouseDestroy(), void 0);}, _mouseCapture: function (e) {var i = this.options;return this.helper || i.disabled || t(e.target).closest(".ui-resizable-handle").length > 0 ? !1 : (this.handle = this._getHandle(e), this.handle ? (this._blurActiveElement(e), this._blockFrames(i.iframeFix === !0 ? "iframe" : i.iframeFix), !0) : !1);}, _blockFrames: function (e) {this.iframeBlocks = this.document.find(e).map(function () {var e = t(this);return t("<div>").css("position", "absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0];});}, _unblockFrames: function () {this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);}, _blurActiveElement: function (e) {var i = t.ui.safeActiveElement(this.document[0]), s = t(e.target);s.closest(i).length || t.ui.safeBlur(i);}, _mouseStart: function (e) {var i = this.options;return this.helper = this._createHelper(e), this._addClass(this.helper, "ui-draggable-dragging"), this._cacheHelperProportions(), t.ui.ddmanager && (t.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css("position"), this.scrollParent = this.helper.scrollParent(!0), this.offsetParent = this.helper.offsetParent(), this.hasFixedAncestor = this.helper.parents().filter(function () {return "fixed" === t(this).css("position");}).length > 0, this.positionAbs = this.element.offset(), this._refreshOffsets(e), this.originalPosition = this.position = this._generatePosition(e, !1), this.originalPageX = e.pageX, this.originalPageY = e.pageY, i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt), this._setContainment(), this._trigger("start", e) === !1 ? (this._clear(), !1) : (this._cacheHelperProportions(), t.ui.ddmanager && !i.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e), this._mouseDrag(e, !0), t.ui.ddmanager && t.ui.ddmanager.dragStart(this, e), !0);}, _refreshOffsets: function (t) {this.offset = { top: this.positionAbs.top - this.margins.top, left: this.positionAbs.left - this.margins.left, scroll: !1, parent: this._getParentOffset(), relative: this._getRelativeOffset() }, this.offset.click = { left: t.pageX - this.offset.left, top: t.pageY - this.offset.top };}, _mouseDrag: function (e, i) {if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()), this.position = this._generatePosition(e, !0), this.positionAbs = this._convertPositionTo("absolute"), !i) {var s = this._uiHash();if (this._trigger("drag", e, s) === !1) return this._mouseUp(new t.Event("mouseup", e)), !1;this.position = s.position;} return this.helper[0].style.left = this.position.left + "px", this.helper[0].style.top = this.position.top + "px", t.ui.ddmanager && t.ui.ddmanager.drag(this, e), !1;}, _mouseStop: function (e) {var i = this, s = !1;return t.ui.ddmanager && !this.options.dropBehaviour && (s = t.ui.ddmanager.drop(this, e)), this.dropped && (s = this.dropped, this.dropped = !1), "invalid" === this.options.revert && !s || "valid" === this.options.revert && s || this.options.revert === !0 || t.isFunction(this.options.revert) && this.options.revert.call(this.element, s) ? t(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {i._trigger("stop", e) !== !1 && i._clear();}) : this._trigger("stop", e) !== !1 && this._clear(), !1;}, _mouseUp: function (e) {return this._unblockFrames(), t.ui.ddmanager && t.ui.ddmanager.dragStop(this, e), this.handleElement.is(e.target) && this.element.trigger("focus"), t.ui.mouse.prototype._mouseUp.call(this, e);}, cancel: function () {return this.helper.is(".ui-draggable-dragging") ? this._mouseUp(new t.Event("mouseup", { target: this.element[0] })) : this._clear(), this;}, _getHandle: function (e) {return this.options.handle ? !!t(e.target).closest(this.element.find(this.options.handle)).length : !0;}, _setHandleClassName: function () {this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element, this._addClass(this.handleElement, "ui-draggable-handle");}, _removeHandleClassName: function () {this._removeClass(this.handleElement, "ui-draggable-handle");}, _createHelper: function (e) {var i = this.options, s = t.isFunction(i.helper), n = s ? t(i.helper.apply(this.element[0], [e])) : "clone" === i.helper ? this.element.clone().removeAttr("id") : this.element;return n.parents("body").length || n.appendTo("parent" === i.appendTo ? this.element[0].parentNode : i.appendTo), s && n[0] === this.element[0] && this._setPositionRelative(), n[0] === this.element[0] || /(fixed|absolute)/.test(n.css("position")) || n.css("position", "absolute"), n;}, _setPositionRelative: function () {/^(?:r|a|f)/.test(this.element.css("position")) || (this.element[0].style.position = "relative");}, _adjustOffsetFromHelper: function (e) {"string" === typeof e && (e = e.split(" ")), t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }), "left" in e && (this.offset.click.left = e.left + this.margins.left), "right" in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left), "top" in e && (this.offset.click.top = e.top + this.margins.top), "bottom" in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top);}, _isRootNode: function (t) {return /(html|body)/i.test(t.tagName) || t === this.document[0];}, _getParentOffset: function () {var e = this.offsetParent.offset(), i = this.document[0];return "absolute" === this.cssPosition && this.scrollParent[0] !== i && t.contains(this.scrollParent[0], this.offsetParent[0]) && (e.left += this.scrollParent.scrollLeft(), e.top += this.scrollParent.scrollTop()), this._isRootNode(this.offsetParent[0]) && (e = { top: 0, left: 0 }), { top: e.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0), left: e.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0) };}, _getRelativeOffset: function () {if ("relative" !== this.cssPosition) return { top: 0, left: 0 };var t = this.element.position(), e = this._isRootNode(this.scrollParent[0]);return { top: t.top - (parseInt(this.helper.css("top"), 10) || 0) + (e ? 0 : this.scrollParent.scrollTop()), left: t.left - (parseInt(this.helper.css("left"), 10) || 0) + (e ? 0 : this.scrollParent.scrollLeft()) };
}, _cacheMargins: function () {this.margins = { left: parseInt(this.element.css("marginLeft"), 10) || 0, top: parseInt(this.element.css("marginTop"), 10) || 0, right: parseInt(this.element.css("marginRight"), 10) || 0, bottom: parseInt(this.element.css("marginBottom"), 10) || 0 };}, _cacheHelperProportions: function () {this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };}, _setContainment: function () {var e, i, s, n = this.options, o = this.document[0];return this.relativeContainer = null, n.containment ? "window" === n.containment ? (this.containment = [t(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, t(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, t(window).scrollLeft() + t(window).width() - this.helperProportions.width - this.margins.left, t(window).scrollTop() + (t(window).height() || o.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : "document" === n.containment ? (this.containment = [0, 0, t(o).width() - this.helperProportions.width - this.margins.left, (t(o).height() || o.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : n.containment.constructor === Array ? (this.containment = n.containment, void 0) : ("parent" === n.containment && (n.containment = this.helper[0].parentNode), i = t(n.containment), s = i[0], s && (e = /(scroll|auto)/.test(i.css("overflow")), this.containment = [(parseInt(i.css("borderLeftWidth"), 10) || 0) + (parseInt(i.css("paddingLeft"), 10) || 0), (parseInt(i.css("borderTopWidth"), 10) || 0) + (parseInt(i.css("paddingTop"), 10) || 0), (e ? Math.max(s.scrollWidth, s.offsetWidth) : s.offsetWidth) - (parseInt(i.css("borderRightWidth"), 10) || 0) - (parseInt(i.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (e ? Math.max(s.scrollHeight, s.offsetHeight) : s.offsetHeight) - (parseInt(i.css("borderBottomWidth"), 10) || 0) - (parseInt(i.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relativeContainer = i), void 0) : (this.containment = null, void 0);}, _convertPositionTo: function (t, e) {e || (e = this.position);var i = "absolute" === t ? 1 : -1, s = this._isRootNode(this.scrollParent[0]);return { top: e.top + this.offset.relative.top * i + this.offset.parent.top * i - ("fixed" === this.cssPosition ? -this.offset.scroll.top : s ? 0 : this.offset.scroll.top) * i, left: e.left + this.offset.relative.left * i + this.offset.parent.left * i - ("fixed" === this.cssPosition ? -this.offset.scroll.left : s ? 0 : this.offset.scroll.left) * i };}, _generatePosition: function (t, e) {var i, s, n, o, a = this.options, r = this._isRootNode(this.scrollParent[0]), h = t.pageX, l = t.pageY;return r && this.offset.scroll || (this.offset.scroll = { top: this.scrollParent.scrollTop(), left: this.scrollParent.scrollLeft() }), e && (this.containment && (this.relativeContainer ? (s = this.relativeContainer.offset(), i = [this.containment[0] + s.left, this.containment[1] + s.top, this.containment[2] + s.left, this.containment[3] + s.top]) : i = this.containment, t.pageX - this.offset.click.left < i[0] && (h = i[0] + this.offset.click.left), t.pageY - this.offset.click.top < i[1] && (l = i[1] + this.offset.click.top), t.pageX - this.offset.click.left > i[2] && (h = i[2] + this.offset.click.left), t.pageY - this.offset.click.top > i[3] && (l = i[3] + this.offset.click.top)), a.grid && (n = a.grid[1] ? this.originalPageY + Math.round((l - this.originalPageY) / a.grid[1]) * a.grid[1] : this.originalPageY, l = i ? n - this.offset.click.top >= i[1] || n - this.offset.click.top > i[3] ? n : n - this.offset.click.top >= i[1] ? n - a.grid[1] : n + a.grid[1] : n, o = a.grid[0] ? this.originalPageX + Math.round((h - this.originalPageX) / a.grid[0]) * a.grid[0] : this.originalPageX, h = i ? o - this.offset.click.left >= i[0] || o - this.offset.click.left > i[2] ? o : o - this.offset.click.left >= i[0] ? o - a.grid[0] : o + a.grid[0] : o), "y" === a.axis && (h = this.originalPageX), "x" === a.axis && (l = this.originalPageY)), { top: l - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.offset.scroll.top : r ? 0 : this.offset.scroll.top), left: h - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.offset.scroll.left : r ? 0 : this.offset.scroll.left) };}, _clear: function () {this._removeClass(this.helper, "ui-draggable-dragging"), this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1, this.destroyOnClear && this.destroy();}, _trigger: function (e, i, s) {return s = s || this._uiHash(), t.ui.plugin.call(this, e, [i, s, this], !0), /^(drag|start|stop)/.test(e) && (this.positionAbs = this._convertPositionTo("absolute"), s.offset = this.positionAbs), t.Widget.prototype._trigger.call(this, e, i, s);}, plugins: {}, _uiHash: function () {return { helper: this.helper, position: this.position, originalPosition: this.originalPosition, offset: this.positionAbs };} }), t.ui.plugin.add("draggable", "connectToSortable", { start: function (e, i, s) {var n = t.extend({}, i, { item: s.element });s.sortables = [], t(s.options.connectToSortable).each(function () {var i = t(this).sortable("instance");i && !i.options.disabled && (s.sortables.push(i), i.refreshPositions(), i._trigger("activate", e, n));});}, stop: function (e, i, s) {var n = t.extend({}, i, { item: s.element });s.cancelHelperRemoval = !1, t.each(s.sortables, function () {var t = this;t.isOver ? (t.isOver = 0, s.cancelHelperRemoval = !0, t.cancelHelperRemoval = !1, t._storedCSS = { position: t.placeholder.css("position"), top: t.placeholder.css("top"), left: t.placeholder.css("left") }, t._mouseStop(e), t.options.helper = t.options._helper) : (t.cancelHelperRemoval = !0, t._trigger("deactivate", e, n));});}, drag: function (e, i, s) {t.each(s.sortables, function () {var n = !1, o = this;o.positionAbs = s.positionAbs, o.helperProportions = s.helperProportions, o.offset.click = s.offset.click, o._intersectsWith(o.containerCache) && (n = !0, t.each(s.sortables, function () {return this.positionAbs = s.positionAbs, this.helperProportions = s.helperProportions, this.offset.click = s.offset.click, this !== o && this._intersectsWith(this.containerCache) && t.contains(o.element[0], this.element[0]) && (n = !1), n;})), n ? (o.isOver || (o.isOver = 1, s._parent = i.helper.parent(), o.currentItem = i.helper.appendTo(o.element).data("ui-sortable-item", !0), o.options._helper = o.options.helper, o.options.helper = function () {return i.helper[0];}, e.target = o.currentItem[0], o._mouseCapture(e, !0), o._mouseStart(e, !0, !0), o.offset.click.top = s.offset.click.top, o.offset.click.left = s.offset.click.left, o.offset.parent.left -= s.offset.parent.left - o.offset.parent.left, o.offset.parent.top -= s.offset.parent.top - o.offset.parent.top, s._trigger("toSortable", e), s.dropped = o.element, t.each(s.sortables, function () {this.refreshPositions();}), s.currentItem = s.element, o.fromOutside = s), o.currentItem && (o._mouseDrag(e), i.position = o.position)) : o.isOver && (o.isOver = 0, o.cancelHelperRemoval = !0, o.options._revert = o.options.revert, o.options.revert = !1, o._trigger("out", e, o._uiHash(o)), o._mouseStop(e, !0), o.options.revert = o.options._revert, o.options.helper = o.options._helper, o.placeholder && o.placeholder.remove(), i.helper.appendTo(s._parent), s._refreshOffsets(e), i.position = s._generatePosition(e, !0), s._trigger("fromSortable", e), s.dropped = !1, t.each(s.sortables, function () {this.refreshPositions();}));});} }), t.ui.plugin.add("draggable", "cursor", { start: function (e, i, s) {var n = t("body"), o = s.options;n.css("cursor") && (o._cursor = n.css("cursor")), n.css("cursor", o.cursor);}, stop: function (e, i, s) {var n = s.options;n._cursor && t("body").css("cursor", n._cursor);} }), t.ui.plugin.add("draggable", "opacity", { start: function (e, i, s) {var n = t(i.helper), o = s.options;n.css("opacity") && (o._opacity = n.css("opacity")), n.css("opacity", o.opacity);}, stop: function (e, i, s) {var n = s.options;n._opacity && t(i.helper).css("opacity", n._opacity);} }), t.ui.plugin.add("draggable", "scroll", { start: function (t, e, i) {i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)), i.scrollParentNotHidden[0] !== i.document[0] && "HTML" !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset());}, drag: function (e, i, s) {var n = s.options, o = !1, a = s.scrollParentNotHidden[0], r = s.document[0];a !== r && "HTML" !== a.tagName ? (n.axis && "x" === n.axis || (s.overflowOffset.top + a.offsetHeight - e.pageY < n.scrollSensitivity ? a.scrollTop = o = a.scrollTop + n.scrollSpeed : e.pageY - s.overflowOffset.top < n.scrollSensitivity && (a.scrollTop = o = a.scrollTop - n.scrollSpeed)), n.axis && "y" === n.axis || (s.overflowOffset.left + a.offsetWidth - e.pageX < n.scrollSensitivity ? a.scrollLeft = o = a.scrollLeft + n.scrollSpeed : e.pageX - s.overflowOffset.left < n.scrollSensitivity && (a.scrollLeft = o = a.scrollLeft - n.scrollSpeed))) : (n.axis && "x" === n.axis || (e.pageY - t(r).scrollTop() < n.scrollSensitivity ? o = t(r).scrollTop(t(r).scrollTop() - n.scrollSpeed) : t(window).height() - (e.pageY - t(r).scrollTop()) < n.scrollSensitivity && (o = t(r).scrollTop(t(r).scrollTop() + n.scrollSpeed))), n.axis && "y" === n.axis || (e.pageX - t(r).scrollLeft() < n.scrollSensitivity ? o = t(r).scrollLeft(t(r).scrollLeft() - n.scrollSpeed) : t(window).width() - (e.pageX - t(r).scrollLeft()) < n.scrollSensitivity && (o = t(r).scrollLeft(t(r).scrollLeft() + n.scrollSpeed)))), o !== !1 && t.ui.ddmanager && !n.dropBehaviour && t.ui.ddmanager.prepareOffsets(s, e);} }), t.ui.plugin.add("draggable", "snap", { start: function (e, i, s) {var n = s.options;s.snapElements = [], t(n.snap.constructor !== String ? n.snap.items || ":data(ui-draggable)" : n.snap).each(function () {var e = t(this), i = e.offset();this !== s.element[0] && s.snapElements.push({ item: this, width: e.outerWidth(), height: e.outerHeight(), top: i.top, left: i.left });});}, drag: function (e, i, s) {var n, o, a, r, h, l, c, u, d, p, f = s.options, g = f.snapTolerance, m = i.offset.left, _ = m + s.helperProportions.width, v = i.offset.top, b = v + s.helperProportions.height;for (d = s.snapElements.length - 1;d >= 0;d--)h = s.snapElements[d].left - s.margins.left, l = h + s.snapElements[d].width, c = s.snapElements[d].top - s.margins.top, u = c + s.snapElements[d].height, h - g > _ || m > l + g || c - g > b || v > u + g || !t.contains(s.snapElements[d].item.ownerDocument, s.snapElements[d].item) ? (s.snapElements[d].snapping && s.options.snap.release && s.options.snap.release.call(s.element, e, t.extend(s._uiHash(), { snapItem: s.snapElements[d].item })), s.snapElements[d].snapping = !1) : ("inner" !== f.snapMode && (n = g >= Math.abs(c - b), o = g >= Math.abs(u - v), a = g >= Math.abs(h - _), r = g >= Math.abs(l - m), n && (i.position.top = s._convertPositionTo("relative", { top: c - s.helperProportions.height, left: 0 }).top), o && (i.position.top = s._convertPositionTo("relative", { top: u, left: 0 }).top), a && (i.position.left = s._convertPositionTo("relative", { top: 0, left: h - s.helperProportions.width }).left), r && (i.position.left = s._convertPositionTo("relative", { top: 0, left: l }).left)), p = n || o || a || r, "outer" !== f.snapMode && (n = g >= Math.abs(c - v), o = g >= Math.abs(u - b), a = g >= Math.abs(h - m), r = g >= Math.abs(l - _), n && (i.position.top = s._convertPositionTo("relative", { top: c, left: 0 }).top), o && (i.position.top = s._convertPositionTo("relative", { top: u - s.helperProportions.height, left: 0 }).top), a && (i.position.left = s._convertPositionTo("relative", { top: 0, left: h }).left), r && (i.position.left = s._convertPositionTo("relative", { top: 0, left: l - s.helperProportions.width }).left)), !s.snapElements[d].snapping && (n || o || a || r || p) && s.options.snap.snap && s.options.snap.snap.call(s.element, e, t.extend(s._uiHash(), { snapItem: s.snapElements[d].item })), s.snapElements[d].snapping = n || o || a || r || p);} }), t.ui.plugin.add("draggable", "stack", { start: function (e, i, s) {var n, o = s.options, a = t.makeArray(t(o.stack)).sort(function (e, i) {return (parseInt(t(e).css("zIndex"), 10) || 0) - (parseInt(t(i).css("zIndex"), 10) || 0);});a.length && (n = parseInt(t(a[0]).css("zIndex"), 10) || 0, t(a).each(function (e) {t(this).css("zIndex", n + e);}), this.css("zIndex", n + a.length));} }), t.ui.plugin.add("draggable", "zIndex", { start: function (e, i, s) {var n = t(i.helper), o = s.options;n.css("zIndex") && (o._zIndex = n.css("zIndex")), n.css("zIndex", o.zIndex);}, stop: function (e, i, s) {var n = s.options;n._zIndex && t(i.helper).css("zIndex", n._zIndex);} }), t.ui.draggable, t.widget("ui.resizable", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "resize", options: { alsoResize: !1, animate: !1, animateDuration: "slow", animateEasing: "swing", aspectRatio: !1, autoHide: !1, classes: { "ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se" }, containment: !1, ghost: !1, grid: !1, handles: "e,s,se", helper: !1, maxHeight: null, maxWidth: null, minHeight: 10, minWidth: 10, zIndex: 90, resize: null, start: null, stop: null }, _num: function (t) {return parseFloat(t) || 0;}, _isNumber: function (t) {return !isNaN(parseFloat(t));}, _hasScroll: function (e, i) {if ("hidden" === t(e).css("overflow")) return !1;var s = i && "left" === i ? "scrollLeft" : "scrollTop", n = !1;return e[s] > 0 ? !0 : (e[s] = 1, n = e[s] > 0, e[s] = 0, n);}, _create: function () {var e, i = this.options, s = this;this._addClass("ui-resizable"), t.extend(this, { _aspectRatio: !!i.aspectRatio, aspectRatio: i.aspectRatio, originalElement: this.element, _proportionallyResizeElements: [], _helper: i.helper || i.ghost || i.animate ? i.helper || "ui-resizable-helper" : null }), this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({ position: this.element.css("position"), width: this.element.outerWidth(), height: this.element.outerHeight(), top: this.element.css("top"), left: this.element.css("left") })), this.element = this.element.parent().data("ui-resizable", this.element.resizable("instance")), this.elementIsWrapper = !0, e = { marginTop: this.originalElement.css("marginTop"), marginRight: this.originalElement.css("marginRight"), marginBottom: this.originalElement.css("marginBottom"), marginLeft: this.originalElement.css("marginLeft") }, this.element.css(e), this.originalElement.css("margin", 0), this.originalResizeStyle = this.originalElement.css("resize"), this.originalElement.css("resize", "none"), this._proportionallyResizeElements.push(this.originalElement.css({ position: "static", zoom: 1, display: "block" })), this.originalElement.css(e), this._proportionallyResize()), this._setupHandles(), i.autoHide && t(this.element).on("mouseenter", function () {i.disabled || (s._removeClass("ui-resizable-autohide"), s._handles.show());}).on("mouseleave", function () {i.disabled || s.resizing || (s._addClass("ui-resizable-autohide"), s._handles.hide());}), this._mouseInit();}, _destroy: function () {this._mouseDestroy();var e, i = function (e) {t(e).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove();};return this.elementIsWrapper && (i(this.element), e = this.element, this.originalElement.css({ position: e.css("position"), width: e.outerWidth(), height: e.outerHeight(), top: e.css("top"), left: e.css("left") }).insertAfter(e), e.remove()), this.originalElement.css("resize", this.originalResizeStyle), i(this.originalElement), this;}, _setOption: function (t, e) {switch (this._super(t, e), t) {case "handles":this._removeHandles(), this._setupHandles();break;default:}}, _setupHandles: function () {var e, i, s, n, o, a = this.options, r = this;if (this.handles = a.handles || (t(".ui-resizable-handle", this.element).length ? { n: ".ui-resizable-n", e: ".ui-resizable-e", s: ".ui-resizable-s", w: ".ui-resizable-w", se: ".ui-resizable-se", sw: ".ui-resizable-sw", ne: ".ui-resizable-ne", nw: ".ui-resizable-nw" } : "e,s,se"), this._handles = t(), this.handles.constructor === String) for ("all" === this.handles && (this.handles = "n,e,s,w,se,sw,ne,nw"), s = this.handles.split(","), this.handles = {}, i = 0;s.length > i;i++)e = t.trim(s[i]), n = "ui-resizable-" + e, o = t("<div>"), this._addClass(o, "ui-resizable-handle " + n), o.css({ zIndex: a.zIndex }), this.handles[e] = ".ui-resizable-" + e, this.element.append(o);this._renderAxis = function (e) {var i, s, n, o;e = e || this.element;for (i in this.handles) this.handles[i].constructor === String ? this.handles[i] = this.element.children(this.handles[i]).first().show() : (this.handles[i].jquery || this.handles[i].nodeType) && (this.handles[i] = t(this.handles[i]), this._on(this.handles[i], { mousedown: r._mouseDown })), this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (s = t(this.handles[i], this.element), o = /sw|ne|nw|se|n|s/.test(i) ? s.outerHeight() : s.outerWidth(), n = ["padding", /ne|nw|n/.test(i) ? "Top" : /se|sw|s/.test(i) ? "Bottom" : /^e$/.test(i) ? "Right" : "Left"].join(""), e.css(n, o), this._proportionallyResize()), this._handles = this._handles.add(this.handles[i]);}, this._renderAxis(this.element), this._handles = this._handles.add(this.element.find(".ui-resizable-handle")), this._handles.disableSelection(), this._handles.on("mouseover", function () {r.resizing || (this.className && (o = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)), r.axis = o && o[1] ? o[1] : "se");}), a.autoHide && (this._handles.hide(), this._addClass("ui-resizable-autohide"));}, _removeHandles: function () {this._handles.remove();}, _mouseCapture: function (e) {var i, s, n = !1;for (i in this.handles)s = t(this.handles[i])[0], (s === e.target || t.contains(s, e.target)) && (n = !0);return !this.options.disabled && n;}, _mouseStart: function (e) {var i, s, n, o = this.options, a = this.element;return this.resizing = !0, this._renderProxy(), i = this._num(this.helper.css("left")), s = this._num(this.helper.css("top")), o.containment && (i += t(o.containment).scrollLeft() || 0, s += t(o.containment).scrollTop() || 0), this.offset = this.helper.offset(), this.position = { left: i, top: s }, this.size = this._helper ? { width: this.helper.width(), height: this.helper.height() } : { width: a.width(), height: a.height() }, this.originalSize = this._helper ? { width: a.outerWidth(), height: a.outerHeight() } : { width: a.width(), height: a.height() }, this.sizeDiff = { width: a.outerWidth() - a.width(), height: a.outerHeight() - a.height() }, this.originalPosition = { left: i, top: s }, this.originalMousePosition = { left: e.pageX, top: e.pageY }, this.aspectRatio = "number" === typeof o.aspectRatio ? o.aspectRatio : this.originalSize.width / this.originalSize.height || 1, n = t(".ui-resizable-" + this.axis).css("cursor"), t("body").css("cursor", "auto" === n ? this.axis + "-resize" : n), this._addClass("ui-resizable-resizing"), this._propagate("start", e), !0;}, _mouseDrag: function (e) {var i, s, n = this.originalMousePosition, o = this.axis, a = e.pageX - n.left || 0, r = e.pageY - n.top || 0, h = this._change[o];return this._updatePrevProperties(), h ? (i = h.apply(this, [e, a, r]), this._updateVirtualBoundaries(e.shiftKey), (this._aspectRatio || e.shiftKey) && (i = this._updateRatio(i, e)), i = this._respectSize(i, e), this._updateCache(i), this._propagate("resize", e), s = this._applyChanges(), !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(), t.isEmptyObject(s) || (this._updatePrevProperties(), this._trigger("resize", e, this.ui()), this._applyChanges()), !1) : !1;}, _mouseStop: function (e) {this.resizing = !1;var i, s, n, o, a, r, h, l = this.options, c = this;return this._helper && (i = this._proportionallyResizeElements, s = i.length && /textarea/i.test(i[0].nodeName), n = s && this._hasScroll(i[0], "left") ? 0 : c.sizeDiff.height, o = s ? 0 : c.sizeDiff.width, a = { width: c.helper.width() - o, height: c.helper.height() - n }, r = parseFloat(c.element.css("left")) + (c.position.left - c.originalPosition.left) || null, h = parseFloat(c.element.css("top")) + (c.position.top - c.originalPosition.top) || null, l.animate || this.element.css(t.extend(a, { top: h, left: r })), c.helper.height(c.size.height), c.helper.width(c.size.width), this._helper && !l.animate && this._proportionallyResize()), t("body").css("cursor", "auto"), this._removeClass("ui-resizable-resizing"), this._propagate("stop", e), this._helper && this.helper.remove(), !1;}, _updatePrevProperties: function () {this.prevPosition = { top: this.position.top, left: this.position.left }, this.prevSize = { width: this.size.width, height: this.size.height };}, _applyChanges: function () {var t = {};return this.position.top !== this.prevPosition.top && (t.top = this.position.top + "px"), this.position.left !== this.prevPosition.left && (t.left = this.position.left + "px"), this.size.width !== this.prevSize.width && (t.width = this.size.width + "px"), this.size.height !== this.prevSize.height && (t.height = this.size.height + "px"), this.helper.css(t), t;}, _updateVirtualBoundaries: function (t) {var e, i, s, n, o, a = this.options;o = { minWidth: this._isNumber(a.minWidth) ? a.minWidth : 0, maxWidth: this._isNumber(a.maxWidth) ? a.maxWidth : 1 / 0, minHeight: this._isNumber(a.minHeight) ? a.minHeight : 0, maxHeight: this._isNumber(a.maxHeight) ? a.maxHeight : 1 / 0 }, (this._aspectRatio || t) && (e = o.minHeight * this.aspectRatio, s = o.minWidth / this.aspectRatio, i = o.maxHeight * this.aspectRatio, n = o.maxWidth / this.aspectRatio, e > o.minWidth && (o.minWidth = e), s > o.minHeight && (o.minHeight = s), o.maxWidth > i && (o.maxWidth = i), o.maxHeight > n && (o.maxHeight = n)), this._vBoundaries = o;}, _updateCache: function (t) {this.offset = this.helper.offset(), this._isNumber(t.left) && (this.position.left = t.left), this._isNumber(t.top) && (this.position.top = t.top), this._isNumber(t.height) && (this.size.height = t.height), this._isNumber(t.width) && (this.size.width = t.width);}, _updateRatio: function (t) {var e = this.position, i = this.size, s = this.axis;return this._isNumber(t.height) ? t.width = t.height * this.aspectRatio : this._isNumber(t.width) && (t.height = t.width / this.aspectRatio), "sw" === s && (t.left = e.left + (i.width - t.width), t.top = null), "nw" === s && (t.top = e.top + (i.height - t.height), t.left = e.left + (i.width - t.width)), t;}, _respectSize: function (t) {var e = this._vBoundaries, i = this.axis, s = this._isNumber(t.width) && e.maxWidth && e.maxWidth < t.width, n = this._isNumber(t.height) && e.maxHeight && e.maxHeight < t.height, o = this._isNumber(t.width) && e.minWidth && e.minWidth > t.width, a = this._isNumber(t.height) && e.minHeight && e.minHeight > t.height, r = this.originalPosition.left + this.originalSize.width, h = this.originalPosition.top + this.originalSize.height, l = /sw|nw|w/.test(i), c = /nw|ne|n/.test(i);return o && (t.width = e.minWidth), a && (t.height = e.minHeight), s && (t.width = e.maxWidth), n && (t.height = e.maxHeight), o && l && (t.left = r - e.minWidth), s && l && (t.left = r - e.maxWidth), a && c && (t.top = h - e.minHeight), n && c && (t.top = h - e.maxHeight), t.width || t.height || t.left || !t.top ? t.width || t.height || t.top || !t.left || (t.left = null) : t.top = null, t;}, _getPaddingPlusBorderDimensions: function (t) {for (var e = 0, i = [], s = [t.css("borderTopWidth"), t.css("borderRightWidth"), t.css("borderBottomWidth"), t.css("borderLeftWidth")], n = [t.css("paddingTop"), t.css("paddingRight"), t.css("paddingBottom"), t.css("paddingLeft")];4 > e;e++)i[e] = parseFloat(s[e]) || 0, i[e] += parseFloat(n[e]) || 0;return { height: i[0] + i[2], width: i[1] + i[3] };}, _proportionallyResize: function () {if (this._proportionallyResizeElements.length) for (var t, e = 0, i = this.helper || this.element;this._proportionallyResizeElements.length > e;e++)t = this._proportionallyResizeElements[e], this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(t)), t.css({ height: i.height() - this.outerDimensions.height || 0, width: i.width() - this.outerDimensions.width || 0 });}, _renderProxy: function () {var e = this.element, i = this.options;this.elementOffset = e.offset(), this._helper ? (this.helper = this.helper || t("<div style='overflow:hidden;'></div>"), this._addClass(this.helper, this._helper), this.helper.css({ width: this.element.outerWidth(), height: this.element.outerHeight(), position: "absolute", left: this.elementOffset.left + "px", top: this.elementOffset.top + "px", zIndex: ++i.zIndex }), this.helper.appendTo("body").disableSelection()) : this.helper = this.element;}, _change: { e: function (t, e) {return { width: this.originalSize.width + e };}, w: function (t, e) {var i = this.originalSize, s = this.originalPosition;return { left: s.left + e, width: i.width - e };}, n: function (t, e, i) {var s = this.originalSize, n = this.originalPosition;return { top: n.top + i, height: s.height - i };}, s: function (t, e, i) {return { height: this.originalSize.height + i };}, se: function (e, i, s) {return t.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [e, i, s]));}, sw: function (e, i, s) {return t.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [e, i, s]));}, ne: function (e, i, s) {return t.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [e, i, s]));}, nw: function (e, i, s) {return t.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [e, i, s]));} }, _propagate: function (e, i) {t.ui.plugin.call(this, e, [i, this.ui()]), "resize" !== e && this._trigger(e, i, this.ui());}, plugins: {}, ui: function () {return { originalElement: this.originalElement, element: this.element, helper: this.helper, position: this.position, size: this.size, originalSize: this.originalSize, originalPosition: this.originalPosition };} }), t.ui.plugin.add("resizable", "animate", { stop: function (e) {var i = t(this).resizable("instance"), s = i.options, n = i._proportionallyResizeElements, o = n.length && /textarea/i.test(n[0].nodeName), a = o && i._hasScroll(n[0], "left") ? 0 : i.sizeDiff.height, r = o ? 0 : i.sizeDiff.width, h = { width: i.size.width - r, height: i.size.height - a }, l = parseFloat(i.element.css("left")) + (i.position.left - i.originalPosition.left) || null, c = parseFloat(i.element.css("top")) + (i.position.top - i.originalPosition.top) || null;i.element.animate(t.extend(h, c && l ? { top: c, left: l } : {}), { duration: s.animateDuration, easing: s.animateEasing, step: function () {var s = { width: parseFloat(i.element.css("width")), height: parseFloat(i.element.css("height")), top: parseFloat(i.element.css("top")), left: parseFloat(i.element.css("left")) };n && n.length && t(n[0]).css({ width: s.width, height: s.height }), i._updateCache(s), i._propagate("resize", e);} });} }), t.ui.plugin.add("resizable", "containment", { start: function () {var e, i, s, n, o, a, r, h = t(this).resizable("instance"), l = h.options, c = h.element, u = l.containment, d = u instanceof t ? u.get(0) : /parent/.test(u) ? c.parent().get(0) : u;d && (h.containerElement = t(d), /document/.test(u) || u === document ? (h.containerOffset = { left: 0, top: 0 }, h.containerPosition = { left: 0, top: 0 }, h.parentData = { element: t(document), left: 0, top: 0, width: t(document).width(), height: t(document).height() || document.body.parentNode.scrollHeight }) : (e = t(d), i = [], t(["Top", "Right", "Left", "Bottom"]).each(function (t, s) {i[t] = h._num(e.css("padding" + s));}), h.containerOffset = e.offset(), h.containerPosition = e.position(), h.containerSize = { height: e.innerHeight() - i[3], width: e.innerWidth() - i[1] }, s = h.containerOffset, n = h.containerSize.height, o = h.containerSize.width, a = h._hasScroll(d, "left") ? d.scrollWidth : o, r = h._hasScroll(d) ? d.scrollHeight : n, h.parentData = { element: d, left: s.left, top: s.top, width: a, height: r }));}, resize: function (e) {var i, s, n, o, a = t(this).resizable("instance"), r = a.options, h = a.containerOffset, l = a.position, c = a._aspectRatio || e.shiftKey, u = { top: 0, left: 0 }, d = a.containerElement, p = !0;d[0] !== document && /static/.test(d.css("position")) && (u = h), l.left < (a._helper ? h.left : 0) && (a.size.width = a.size.width + (a._helper ? a.position.left - h.left : a.position.left - u.left), c && (a.size.height = a.size.width / a.aspectRatio, p = !1), a.position.left = r.helper ? h.left : 0), l.top < (a._helper ? h.top : 0) && (a.size.height = a.size.height + (a._helper ? a.position.top - h.top : a.position.top), c && (a.size.width = a.size.height * a.aspectRatio, p = !1), a.position.top = a._helper ? h.top : 0), n = a.containerElement.get(0) === a.element.parent().get(0), o = /relative|absolute/.test(a.containerElement.css("position")), n && o ? (a.offset.left = a.parentData.left + a.position.left, a.offset.top = a.parentData.top + a.position.top) : (a.offset.left = a.element.offset().left, a.offset.top = a.element.offset().top), i = Math.abs(a.sizeDiff.width + (a._helper ? a.offset.left - u.left : a.offset.left - h.left)), s = Math.abs(a.sizeDiff.height + (a._helper ? a.offset.top - u.top : a.offset.top - h.top)), i + a.size.width >= a.parentData.width && (a.size.width = a.parentData.width - i, c && (a.size.height = a.size.width / a.aspectRatio, p = !1)), s + a.size.height >= a.parentData.height && (a.size.height = a.parentData.height - s, c && (a.size.width = a.size.height * a.aspectRatio, p = !1)), p || (a.position.left = a.prevPosition.left, a.position.top = a.prevPosition.top, a.size.width = a.prevSize.width, a.size.height = a.prevSize.height);}, stop: function () {var e = t(this).resizable("instance"), i = e.options, s = e.containerOffset, n = e.containerPosition, o = e.containerElement, a = t(e.helper), r = a.offset(), h = a.outerWidth() - e.sizeDiff.width, l = a.outerHeight() - e.sizeDiff.height;e._helper && !i.animate && /relative/.test(o.css("position")) && t(this).css({ left: r.left - n.left - s.left, width: h, height: l }), e._helper && !i.animate && /static/.test(o.css("position")) && t(this).css({ left: r.left - n.left - s.left, width: h, height: l });} }), t.ui.plugin.add("resizable", "alsoResize", { start: function () {var e = t(this).resizable("instance"), i = e.options;t(i.alsoResize).each(function () {var e = t(this);e.data("ui-resizable-alsoresize", { width: parseFloat(e.width()), height: parseFloat(e.height()), left: parseFloat(e.css("left")), top: parseFloat(e.css("top")) });});}, resize: function (e, i) {var s = t(this).resizable("instance"), n = s.options, o = s.originalSize, a = s.originalPosition, r = { height: s.size.height - o.height || 0, width: s.size.width - o.width || 0, top: s.position.top - a.top || 0, left: s.position.left - a.left || 0 };t(n.alsoResize).each(function () {var e = t(this), s = t(this).data("ui-resizable-alsoresize"), n = {}, o = e.parents(i.originalElement[0]).length ? ["width", "height"] : ["width", "height", "top", "left"];t.each(o, function (t, e) {var i = (s[e] || 0) + (r[e] || 0);i && i >= 0 && (n[e] = i || null);}), e.css(n);});}, stop: function () {t(this).removeData("ui-resizable-alsoresize");} }), t.ui.plugin.add("resizable", "ghost", { start: function () {var e = t(this).resizable("instance"), i = e.size;e.ghost = e.originalElement.clone(), e.ghost.css({ opacity: .25, display: "block", position: "relative", height: i.height, width: i.width, margin: 0, left: 0, top: 0 }), e._addClass(e.ghost, "ui-resizable-ghost"), t.uiBackCompat !== !1 && "string" === typeof e.options.ghost && e.ghost.addClass(this.options.ghost), e.ghost.appendTo(e.helper);}, resize: function () {var e = t(this).resizable("instance");e.ghost && e.ghost.css({ position: "relative", height: e.size.height, width: e.size.width });}, stop: function () {var e = t(this).resizable("instance");e.ghost && e.helper && e.helper.get(0).removeChild(e.ghost.get(0));} }), t.ui.plugin.add("resizable", "grid", { resize: function () {var e, i = t(this).resizable("instance"), s = i.options, n = i.size, o = i.originalSize, a = i.originalPosition, r = i.axis, h = "number" === typeof s.grid ? [s.grid, s.grid] : s.grid, l = h[0] || 1, c = h[1] || 1, u = Math.round((n.width - o.width) / l) * l, d = Math.round((n.height - o.height) / c) * c, p = o.width + u, f = o.height + d, g = s.maxWidth && p > s.maxWidth, m = s.maxHeight && f > s.maxHeight, _ = s.minWidth && s.minWidth > p, v = s.minHeight && s.minHeight > f;s.grid = h, _ && (p += l), v && (f += c), g && (p -= l), m && (f -= c), /^(se|s|e)$/.test(r) ? (i.size.width = p, i.size.height = f) : /^(ne)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.top = a.top - d) : /^(sw)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.left = a.left - u) : ((0 >= f - c || 0 >= p - l) && (e = i._getPaddingPlusBorderDimensions(this)), f - c > 0 ? (i.size.height = f, i.position.top = a.top - d) : (f = c - e.height, i.size.height = f, i.position.top = a.top + o.height - f), p - l > 0 ? (i.size.width = p, i.position.left = a.left - u) : (p = l - e.width, i.size.width = p, i.position.left = a.left + o.width - p));} }), t.ui.resizable, t.widget("ui.dialog", { version: "1.12.1", options: { appendTo: "body", autoOpen: !0, buttons: [], classes: { "ui-dialog": "ui-corner-all", "ui-dialog-titlebar": "ui-corner-all" }, closeOnEscape: !0, closeText: "Close", draggable: !0, hide: null, height: "auto", maxHeight: null, maxWidth: null, minHeight: 150, minWidth: 150, modal: !1, position: { my: "center", at: "center", of: window, collision: "fit", using: function (e) {var i = t(this).css(e).offset().top;0 > i && t(this).css("top", e.top - i);} }, resizable: !0, show: null, title: null, width: 300, beforeClose: null, close: null, drag: null, dragStart: null, dragStop: null, focus: null, open: null, resize: null, resizeStart: null, resizeStop: null }, sizeRelatedOptions: { buttons: !0, height: !0, maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0, width: !0 }, resizableRelatedOptions: { maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0 }, _create: function () {this.originalCss = { display: this.element[0].style.display, width: this.element[0].style.width, minHeight: this.element[0].style.minHeight, maxHeight: this.element[0].style.maxHeight, height: this.element[0].style.height }, this.originalPosition = { parent: this.element.parent(), index: this.element.parent().children().index(this.element) }, this.originalTitle = this.element.attr("title"), null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle), this.options.disabled && (this.options.disabled = !1), this._createWrapper(), this.element.show().removeAttr("title").appendTo(this.uiDialog), this._addClass("ui-dialog-content", "ui-widget-content"), this._createTitlebar(), this._createButtonPane(), this.options.draggable && t.fn.draggable && this._makeDraggable(), this.options.resizable && t.fn.resizable && this._makeResizable(), this._isOpen = !1, this._trackFocus();}, _init: function () {this.options.autoOpen && this.open();}, _appendTo: function () {var e = this.options.appendTo;return e && (e.jquery || e.nodeType) ? t(e) : this.document.find(e || "body").eq(0);}, _destroy: function () {var t, e = this.originalPosition;this._untrackInstance(), this._destroyOverlay(), this.element.removeUniqueId().css(this.originalCss).detach(), this.uiDialog.remove(), this.originalTitle && this.element.attr("title", this.originalTitle), t = e.parent.children().eq(e.index), t.length && t[0] !== this.element[0] ? t.before(this.element) : e.parent.append(this.element);}, widget: function () {return this.uiDialog;
}, disable: t.noop, enable: t.noop, close: function (e) {var i = this;this._isOpen && this._trigger("beforeClose", e) !== !1 && (this._isOpen = !1, this._focusedElement = null, this._destroyOverlay(), this._untrackInstance(), this.opener.filter(":focusable").trigger("focus").length || t.ui.safeBlur(t.ui.safeActiveElement(this.document[0])), this._hide(this.uiDialog, this.options.hide, function () {i._trigger("close", e);}));}, isOpen: function () {return this._isOpen;}, moveToTop: function () {this._moveToTop();}, _moveToTop: function (e, i) {var s = !1, n = this.uiDialog.siblings(".ui-front:visible").map(function () {return +t(this).css("z-index");}).get(), o = Math.max.apply(null, n);return o >= +this.uiDialog.css("z-index") && (this.uiDialog.css("z-index", o + 1), s = !0), s && !i && this._trigger("focus", e), s;}, open: function () {var e = this;return this._isOpen ? (this._moveToTop() && this._focusTabbable(), void 0) : (this._isOpen = !0, this.opener = t(t.ui.safeActiveElement(this.document[0])), this._size(), this._position(), this._createOverlay(), this._moveToTop(null, !0), this.overlay && this.overlay.css("z-index", this.uiDialog.css("z-index") - 1), this._show(this.uiDialog, this.options.show, function () {e._focusTabbable(), e._trigger("focus");}), this._makeFocusTarget(), this._trigger("open"), void 0);}, _focusTabbable: function () {var t = this._focusedElement;t || (t = this.element.find("[autofocus]")), t.length || (t = this.element.find(":tabbable")), t.length || (t = this.uiDialogButtonPane.find(":tabbable")), t.length || (t = this.uiDialogTitlebarClose.filter(":tabbable")), t.length || (t = this.uiDialog), t.eq(0).trigger("focus");}, _keepFocus: function (e) {function i() {var e = t.ui.safeActiveElement(this.document[0]), i = this.uiDialog[0] === e || t.contains(this.uiDialog[0], e);i || this._focusTabbable();}e.preventDefault(), i.call(this), this._delay(i);}, _createWrapper: function () {this.uiDialog = t("<div>").hide().attr({ tabIndex: -1, role: "dialog" }).appendTo(this._appendTo()), this._addClass(this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front"), this._on(this.uiDialog, { keydown: function (e) {if (this.options.closeOnEscape && !e.isDefaultPrevented() && e.keyCode && e.keyCode === t.ui.keyCode.ESCAPE) return e.preventDefault(), this.close(e), void 0;if (e.keyCode === t.ui.keyCode.TAB && !e.isDefaultPrevented()) {var i = this.uiDialog.find(":tabbable"), s = i.filter(":first"), n = i.filter(":last");e.target !== n[0] && e.target !== this.uiDialog[0] || e.shiftKey ? e.target !== s[0] && e.target !== this.uiDialog[0] || !e.shiftKey || (this._delay(function () {n.trigger("focus");}), e.preventDefault()) : (this._delay(function () {s.trigger("focus");}), e.preventDefault());}}, mousedown: function (t) {this._moveToTop(t) && this._focusTabbable();} }), this.element.find("[aria-describedby]").length || this.uiDialog.attr({ "aria-describedby": this.element.uniqueId().attr("id") });}, _createTitlebar: function () {var e;this.uiDialogTitlebar = t("<div>"), this._addClass(this.uiDialogTitlebar, "ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix"), this._on(this.uiDialogTitlebar, { mousedown: function (e) {t(e.target).closest(".ui-dialog-titlebar-close") || this.uiDialog.trigger("focus");} }), this.uiDialogTitlebarClose = t("<button type='button'></button>").button({ label: t("<a>").text(this.options.closeText).html(), icon: "ui-icon-closethick", showLabel: !1 }).appendTo(this.uiDialogTitlebar), this._addClass(this.uiDialogTitlebarClose, "ui-dialog-titlebar-close"), this._on(this.uiDialogTitlebarClose, { click: function (t) {t.preventDefault(), this.close(t);} }), e = t("<span>").uniqueId().prependTo(this.uiDialogTitlebar), this._addClass(e, "ui-dialog-title"), this._title(e), this.uiDialogTitlebar.prependTo(this.uiDialog), this.uiDialog.attr({ "aria-labelledby": e.attr("id") });}, _title: function (t) {this.options.title ? t.text(this.options.title) : t.html("&#160;");}, _createButtonPane: function () {this.uiDialogButtonPane = t("<div>"), this._addClass(this.uiDialogButtonPane, "ui-dialog-buttonpane", "ui-widget-content ui-helper-clearfix"), this.uiButtonSet = t("<div>").appendTo(this.uiDialogButtonPane), this._addClass(this.uiButtonSet, "ui-dialog-buttonset"), this._createButtons();}, _createButtons: function () {var e = this, i = this.options.buttons;return this.uiDialogButtonPane.remove(), this.uiButtonSet.empty(), t.isEmptyObject(i) || t.isArray(i) && !i.length ? (this._removeClass(this.uiDialog, "ui-dialog-buttons"), void 0) : (t.each(i, function (i, s) {var n, o;s = t.isFunction(s) ? { click: s, text: i } : s, s = t.extend({ type: "button" }, s), n = s.click, o = { icon: s.icon, iconPosition: s.iconPosition, showLabel: s.showLabel, icons: s.icons, text: s.text }, delete s.click, delete s.icon, delete s.iconPosition, delete s.showLabel, delete s.icons, "boolean" === typeof s.text && delete s.text, t("<button></button>", s).button(o).appendTo(e.uiButtonSet).on("click", function () {n.apply(e.element[0], arguments);});}), this._addClass(this.uiDialog, "ui-dialog-buttons"), this.uiDialogButtonPane.appendTo(this.uiDialog), void 0);}, _makeDraggable: function () {function e(t) {return { position: t.position, offset: t.offset };} var i = this, s = this.options;this.uiDialog.draggable({ cancel: ".ui-dialog-content, .ui-dialog-titlebar-close", handle: ".ui-dialog-titlebar", containment: "document", start: function (s, n) {i._addClass(t(this), "ui-dialog-dragging"), i._blockFrames(), i._trigger("dragStart", s, e(n));}, drag: function (t, s) {i._trigger("drag", t, e(s));}, stop: function (n, o) {var a = o.offset.left - i.document.scrollLeft(), r = o.offset.top - i.document.scrollTop();s.position = { my: "left top", at: "left" + (a >= 0 ? "+" : "") + a + " " + "top" + (r >= 0 ? "+" : "") + r, of: i.window }, i._removeClass(t(this), "ui-dialog-dragging"), i._unblockFrames(), i._trigger("dragStop", n, e(o));} });}, _makeResizable: function () {function e(t) {return { originalPosition: t.originalPosition, originalSize: t.originalSize, position: t.position, size: t.size };} var i = this, s = this.options, n = s.resizable, o = this.uiDialog.css("position"), a = "string" === typeof n ? n : "n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({ cancel: ".ui-dialog-content", containment: "document", alsoResize: this.element, maxWidth: s.maxWidth, maxHeight: s.maxHeight, minWidth: s.minWidth, minHeight: this._minHeight(), handles: a, start: function (s, n) {i._addClass(t(this), "ui-dialog-resizing"), i._blockFrames(), i._trigger("resizeStart", s, e(n));}, resize: function (t, s) {i._trigger("resize", t, e(s));}, stop: function (n, o) {var a = i.uiDialog.offset(), r = a.left - i.document.scrollLeft(), h = a.top - i.document.scrollTop();s.height = i.uiDialog.height(), s.width = i.uiDialog.width(), s.position = { my: "left top", at: "left" + (r >= 0 ? "+" : "") + r + " " + "top" + (h >= 0 ? "+" : "") + h, of: i.window }, i._removeClass(t(this), "ui-dialog-resizing"), i._unblockFrames(), i._trigger("resizeStop", n, e(o));} }).css("position", o);}, _trackFocus: function () {this._on(this.widget(), { focusin: function (e) {this._makeFocusTarget(), this._focusedElement = t(e.target);} });}, _makeFocusTarget: function () {this._untrackInstance(), this._trackingInstances().unshift(this);}, _untrackInstance: function () {var e = this._trackingInstances(), i = t.inArray(this, e);-1 !== i && e.splice(i, 1);}, _trackingInstances: function () {var t = this.document.data("ui-dialog-instances");return t || (t = [], this.document.data("ui-dialog-instances", t)), t;}, _minHeight: function () {var t = this.options;return "auto" === t.height ? t.minHeight : Math.min(t.minHeight, t.height);}, _position: function () {var t = this.uiDialog.is(":visible");t || this.uiDialog.show(), this.uiDialog.position(this.options.position), t || this.uiDialog.hide();}, _setOptions: function (e) {var i = this, s = !1, n = {};t.each(e, function (t, e) {i._setOption(t, e), t in i.sizeRelatedOptions && (s = !0), t in i.resizableRelatedOptions && (n[t] = e);}), s && (this._size(), this._position()), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", n);}, _setOption: function (e, i) {var s, n, o = this.uiDialog;"disabled" !== e && (this._super(e, i), "appendTo" === e && this.uiDialog.appendTo(this._appendTo()), "buttons" === e && this._createButtons(), "closeText" === e && this.uiDialogTitlebarClose.button({ label: t("<a>").text("" + this.options.closeText).html() }), "draggable" === e && (s = o.is(":data(ui-draggable)"), s && !i && o.draggable("destroy"), !s && i && this._makeDraggable()), "position" === e && this._position(), "resizable" === e && (n = o.is(":data(ui-resizable)"), n && !i && o.resizable("destroy"), n && "string" === typeof i && o.resizable("option", "handles", i), n || i === !1 || this._makeResizable()), "title" === e && this._title(this.uiDialogTitlebar.find(".ui-dialog-title")));}, _size: function () {var t, e, i, s = this.options;this.element.show().css({ width: "auto", minHeight: 0, maxHeight: "none", height: 0 }), s.minWidth > s.width && (s.width = s.minWidth), t = this.uiDialog.css({ height: "auto", width: s.width }).outerHeight(), e = Math.max(0, s.minHeight - t), i = "number" === typeof s.maxHeight ? Math.max(0, s.maxHeight - t) : "none", "auto" === s.height ? this.element.css({ minHeight: e, maxHeight: i, height: "auto" }) : this.element.height(Math.max(0, s.height - t)), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", "minHeight", this._minHeight());}, _blockFrames: function () {this.iframeBlocks = this.document.find("iframe").map(function () {var e = t(this);return t("<div>").css({ position: "absolute", width: e.outerWidth(), height: e.outerHeight() }).appendTo(e.parent()).offset(e.offset())[0];});}, _unblockFrames: function () {this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);}, _allowInteraction: function (e) {return t(e.target).closest(".ui-dialog").length ? !0 : !!t(e.target).closest(".ui-datepicker").length;}, _createOverlay: function () {if (this.options.modal) {var e = !0;this._delay(function () {e = !1;}), this.document.data("ui-dialog-overlays") || this._on(this.document, { focusin: function (t) {e || this._allowInteraction(t) || (t.preventDefault(), this._trackingInstances()[0]._focusTabbable());} }), this.overlay = t("<div>").appendTo(this._appendTo()), this._addClass(this.overlay, null, "ui-widget-overlay ui-front"), this._on(this.overlay, { mousedown: "_keepFocus" }), this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1);}}, _destroyOverlay: function () {if (this.options.modal && this.overlay) {var t = this.document.data("ui-dialog-overlays") - 1;t ? this.document.data("ui-dialog-overlays", t) : (this._off(this.document, "focusin"), this.document.removeData("ui-dialog-overlays")), this.overlay.remove(), this.overlay = null;}} }), t.uiBackCompat !== !1 && t.widget("ui.dialog", t.ui.dialog, { options: { dialogClass: "" }, _createWrapper: function () {this._super(), this.uiDialog.addClass(this.options.dialogClass);}, _setOption: function (t, e) {"dialogClass" === t && this.uiDialog.removeClass(this.options.dialogClass).addClass(e), this._superApply(arguments);} }), t.ui.dialog, t.widget("ui.droppable", { version: "1.12.1", widgetEventPrefix: "drop", options: { accept: "*", addClasses: !0, greedy: !1, scope: "default", tolerance: "intersect", activate: null, deactivate: null, drop: null, out: null, over: null }, _create: function () {var e, i = this.options, s = i.accept;this.isover = !1, this.isout = !0, this.accept = t.isFunction(s) ? s : function (t) {return t.is(s);}, this.proportions = function () {return arguments.length ? (e = arguments[0], void 0) : e ? e : e = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight };}, this._addToManager(i.scope), i.addClasses && this._addClass("ui-droppable");}, _addToManager: function (e) {t.ui.ddmanager.droppables[e] = t.ui.ddmanager.droppables[e] || [], t.ui.ddmanager.droppables[e].push(this);}, _splice: function (t) {for (var e = 0;t.length > e;e++)t[e] === this && t.splice(e, 1);}, _destroy: function () {var e = t.ui.ddmanager.droppables[this.options.scope];this._splice(e);}, _setOption: function (e, i) {if ("accept" === e) this.accept = t.isFunction(i) ? i : function (t) {return t.is(i);};else if ("scope" === e) {var s = t.ui.ddmanager.droppables[this.options.scope];this._splice(s), this._addToManager(i);} this._super(e, i);}, _activate: function (e) {var i = t.ui.ddmanager.current;this._addActiveClass(), i && this._trigger("activate", e, this.ui(i));}, _deactivate: function (e) {var i = t.ui.ddmanager.current;this._removeActiveClass(), i && this._trigger("deactivate", e, this.ui(i));}, _over: function (e) {var i = t.ui.ddmanager.current;i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._addHoverClass(), this._trigger("over", e, this.ui(i)));}, _out: function (e) {var i = t.ui.ddmanager.current;i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._removeHoverClass(), this._trigger("out", e, this.ui(i)));}, _drop: function (e, i) {var s = i || t.ui.ddmanager.current, n = !1;return s && (s.currentItem || s.element)[0] !== this.element[0] ? (this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function () {var i = t(this).droppable("instance");return i.options.greedy && !i.options.disabled && i.options.scope === s.options.scope && i.accept.call(i.element[0], s.currentItem || s.element) && v(s, t.extend(i, { offset: i.element.offset() }), i.options.tolerance, e) ? (n = !0, !1) : void 0;}), n ? !1 : this.accept.call(this.element[0], s.currentItem || s.element) ? (this._removeActiveClass(), this._removeHoverClass(), this._trigger("drop", e, this.ui(s)), this.element) : !1) : !1;}, ui: function (t) {return { draggable: t.currentItem || t.element, helper: t.helper, position: t.position, offset: t.positionAbs };}, _addHoverClass: function () {this._addClass("ui-droppable-hover");}, _removeHoverClass: function () {this._removeClass("ui-droppable-hover");}, _addActiveClass: function () {this._addClass("ui-droppable-active");}, _removeActiveClass: function () {this._removeClass("ui-droppable-active");} });var v = t.ui.intersect = function () {function t(t, e, i) {return t >= e && e + i > t;} return function (e, i, s, n) {if (!i.offset) return !1;var o = (e.positionAbs || e.position.absolute).left + e.margins.left, a = (e.positionAbs || e.position.absolute).top + e.margins.top, r = o + e.helperProportions.width, h = a + e.helperProportions.height, l = i.offset.left, c = i.offset.top, u = l + i.proportions().width, d = c + i.proportions().height;switch (s) {case "fit":return o >= l && u >= r && a >= c && d >= h;case "intersect":return o + e.helperProportions.width / 2 > l && u > r - e.helperProportions.width / 2 && a + e.helperProportions.height / 2 > c && d > h - e.helperProportions.height / 2;case "pointer":return t(n.pageY, c, i.proportions().height) && t(n.pageX, l, i.proportions().width);case "touch":return (a >= c && d >= a || h >= c && d >= h || c > a && h > d) && (o >= l && u >= o || r >= l && u >= r || l > o && r > u);default:return !1;}};}();t.ui.ddmanager = { current: null, droppables: { "default": [] }, prepareOffsets: function (e, i) {var s, n, o = t.ui.ddmanager.droppables[e.options.scope] || [], a = i ? i.type : null, r = (e.currentItem || e.element).find(":data(ui-droppable)").addBack();t:for (s = 0;o.length > s;s++) if (!(o[s].options.disabled || e && !o[s].accept.call(o[s].element[0], e.currentItem || e.element))) {for (n = 0;r.length > n;n++) if (r[n] === o[s].element[0]) {o[s].proportions().height = 0;continue t;}o[s].visible = "none" !== o[s].element.css("display"), o[s].visible && ("mousedown" === a && o[s]._activate.call(o[s], i), o[s].offset = o[s].element.offset(), o[s].proportions({ width: o[s].element[0].offsetWidth, height: o[s].element[0].offsetHeight }));}}, drop: function (e, i) {var s = !1;return t.each((t.ui.ddmanager.droppables[e.options.scope] || []).slice(), function () {this.options && (!this.options.disabled && this.visible && v(e, this, this.options.tolerance, i) && (s = this._drop.call(this, i) || s), !this.options.disabled && this.visible && this.accept.call(this.element[0], e.currentItem || e.element) && (this.isout = !0, this.isover = !1, this._deactivate.call(this, i)));}), s;}, dragStart: function (e, i) {e.element.parentsUntil("body").on("scroll.droppable", function () {e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);});}, drag: function (e, i) {e.options.refreshPositions && t.ui.ddmanager.prepareOffsets(e, i), t.each(t.ui.ddmanager.droppables[e.options.scope] || [], function () {if (!this.options.disabled && !this.greedyChild && this.visible) {var s, n, o, a = v(e, this, this.options.tolerance, i), r = !a && this.isover ? "isout" : a && !this.isover ? "isover" : null;r && (this.options.greedy && (n = this.options.scope, o = this.element.parents(":data(ui-droppable)").filter(function () {return t(this).droppable("instance").options.scope === n;}), o.length && (s = t(o[0]).droppable("instance"), s.greedyChild = "isover" === r)), s && "isover" === r && (s.isover = !1, s.isout = !0, s._out.call(s, i)), this[r] = !0, this["isout" === r ? "isover" : "isout"] = !1, this["isover" === r ? "_over" : "_out"].call(this, i), s && "isout" === r && (s.isout = !1, s.isover = !0, s._over.call(s, i)));}});}, dragStop: function (e, i) {e.element.parentsUntil("body").off("scroll.droppable"), e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);} }, t.uiBackCompat !== !1 && t.widget("ui.droppable", t.ui.droppable, { options: { hoverClass: !1, activeClass: !1 }, _addActiveClass: function () {this._super(), this.options.activeClass && this.element.addClass(this.options.activeClass);}, _removeActiveClass: function () {this._super(), this.options.activeClass && this.element.removeClass(this.options.activeClass);}, _addHoverClass: function () {this._super(), this.options.hoverClass && this.element.addClass(this.options.hoverClass);}, _removeHoverClass: function () {this._super(), this.options.hoverClass && this.element.removeClass(this.options.hoverClass);} }), t.ui.droppable, t.widget("ui.progressbar", { version: "1.12.1", options: { classes: { "ui-progressbar": "ui-corner-all", "ui-progressbar-value": "ui-corner-left", "ui-progressbar-complete": "ui-corner-right" }, max: 100, value: 0, change: null, complete: null }, min: 0, _create: function () {this.oldValue = this.options.value = this._constrainedValue(), this.element.attr({ role: "progressbar", "aria-valuemin": this.min }), this._addClass("ui-progressbar", "ui-widget ui-widget-content"), this.valueDiv = t("<div>").appendTo(this.element), this._addClass(this.valueDiv, "ui-progressbar-value", "ui-widget-header"), this._refreshValue();}, _destroy: function () {this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"), this.valueDiv.remove();}, value: function (t) {return void 0 === t ? this.options.value : (this.options.value = this._constrainedValue(t), this._refreshValue(), void 0);}, _constrainedValue: function (t) {return void 0 === t && (t = this.options.value), this.indeterminate = t === !1, "number" !== typeof t && (t = 0), this.indeterminate ? !1 : Math.min(this.options.max, Math.max(this.min, t));}, _setOptions: function (t) {var e = t.value;delete t.value, this._super(t), this.options.value = this._constrainedValue(e), this._refreshValue();}, _setOption: function (t, e) {"max" === t && (e = Math.max(this.min, e)), this._super(t, e);}, _setOptionDisabled: function (t) {this._super(t), this.element.attr("aria-disabled", t), this._toggleClass(null, "ui-state-disabled", !!t);}, _percentage: function () {return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min);}, _refreshValue: function () {var e = this.options.value, i = this._percentage();this.valueDiv.toggle(this.indeterminate || e > this.min).width(i.toFixed(0) + "%"), this._toggleClass(this.valueDiv, "ui-progressbar-complete", null, e === this.options.max)._toggleClass("ui-progressbar-indeterminate", null, this.indeterminate), this.indeterminate ? (this.element.removeAttr("aria-valuenow"), this.overlayDiv || (this.overlayDiv = t("<div>").appendTo(this.valueDiv), this._addClass(this.overlayDiv, "ui-progressbar-overlay"))) : (this.element.attr({ "aria-valuemax": this.options.max, "aria-valuenow": e }), this.overlayDiv && (this.overlayDiv.remove(), this.overlayDiv = null)), this.oldValue !== e && (this.oldValue = e, this._trigger("change")), e === this.options.max && this._trigger("complete");} }), t.widget("ui.selectable", t.ui.mouse, { version: "1.12.1", options: { appendTo: "body", autoRefresh: !0, distance: 0, filter: "*", tolerance: "touch", selected: null, selecting: null, start: null, stop: null, unselected: null, unselecting: null }, _create: function () {var e = this;this._addClass("ui-selectable"), this.dragged = !1, this.refresh = function () {e.elementPos = t(e.element[0]).offset(), e.selectees = t(e.options.filter, e.element[0]), e._addClass(e.selectees, "ui-selectee"), e.selectees.each(function () {var i = t(this), s = i.offset(), n = { left: s.left - e.elementPos.left, top: s.top - e.elementPos.top };t.data(this, "selectable-item", { element: this, $element: i, left: n.left, top: n.top, right: n.left + i.outerWidth(), bottom: n.top + i.outerHeight(), startselected: !1, selected: i.hasClass("ui-selected"), selecting: i.hasClass("ui-selecting"), unselecting: i.hasClass("ui-unselecting") });});}, this.refresh(), this._mouseInit(), this.helper = t("<div>"), this._addClass(this.helper, "ui-selectable-helper");}, _destroy: function () {this.selectees.removeData("selectable-item"), this._mouseDestroy();}, _mouseStart: function (e) {var i = this, s = this.options;this.opos = [e.pageX, e.pageY], this.elementPos = t(this.element[0]).offset(), this.options.disabled || (this.selectees = t(s.filter, this.element[0]), this._trigger("start", e), t(s.appendTo).append(this.helper), this.helper.css({ left: e.pageX, top: e.pageY, width: 0, height: 0 }), s.autoRefresh && this.refresh(), this.selectees.filter(".ui-selected").each(function () {var s = t.data(this, "selectable-item");s.startselected = !0, e.metaKey || e.ctrlKey || (i._removeClass(s.$element, "ui-selected"), s.selected = !1, i._addClass(s.$element, "ui-unselecting"), s.unselecting = !0, i._trigger("unselecting", e, { unselecting: s.element }));}), t(e.target).parents().addBack().each(function () {var s, n = t.data(this, "selectable-item");return n ? (s = !e.metaKey && !e.ctrlKey || !n.$element.hasClass("ui-selected"), i._removeClass(n.$element, s ? "ui-unselecting" : "ui-selected")._addClass(n.$element, s ? "ui-selecting" : "ui-unselecting"), n.unselecting = !s, n.selecting = s, n.selected = s, s ? i._trigger("selecting", e, { selecting: n.element }) : i._trigger("unselecting", e, { unselecting: n.element }), !1) : void 0;}));}, _mouseDrag: function (e) {if (this.dragged = !0, !this.options.disabled) {var i, s = this, n = this.options, o = this.opos[0], a = this.opos[1], r = e.pageX, h = e.pageY;return o > r && (i = r, r = o, o = i), a > h && (i = h, h = a, a = i), this.helper.css({ left: o, top: a, width: r - o, height: h - a }), this.selectees.each(function () {var i = t.data(this, "selectable-item"), l = !1, c = {};i && i.element !== s.element[0] && (c.left = i.left + s.elementPos.left, c.right = i.right + s.elementPos.left, c.top = i.top + s.elementPos.top, c.bottom = i.bottom + s.elementPos.top, "touch" === n.tolerance ? l = !(c.left > r || o > c.right || c.top > h || a > c.bottom) : "fit" === n.tolerance && (l = c.left > o && r > c.right && c.top > a && h > c.bottom), l ? (i.selected && (s._removeClass(i.$element, "ui-selected"), i.selected = !1), i.unselecting && (s._removeClass(i.$element, "ui-unselecting"), i.unselecting = !1), i.selecting || (s._addClass(i.$element, "ui-selecting"), i.selecting = !0, s._trigger("selecting", e, { selecting: i.element }))) : (i.selecting && ((e.metaKey || e.ctrlKey) && i.startselected ? (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, s._addClass(i.$element, "ui-selected"), i.selected = !0) : (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, i.startselected && (s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0), s._trigger("unselecting", e, { unselecting: i.element }))), i.selected && (e.metaKey || e.ctrlKey || i.startselected || (s._removeClass(i.$element, "ui-selected"), i.selected = !1, s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0, s._trigger("unselecting", e, { unselecting: i.element })))));}), !1;}}, _mouseStop: function (e) {var i = this;return this.dragged = !1, t(".ui-unselecting", this.element[0]).each(function () {var s = t.data(this, "selectable-item");i._removeClass(s.$element, "ui-unselecting"), s.unselecting = !1, s.startselected = !1, i._trigger("unselected", e, { unselected: s.element });}), t(".ui-selecting", this.element[0]).each(function () {var s = t.data(this, "selectable-item");i._removeClass(s.$element, "ui-selecting")._addClass(s.$element, "ui-selected"), s.selecting = !1, s.selected = !0, s.startselected = !0, i._trigger("selected", e, { selected: s.element });}), this._trigger("stop", e), this.helper.remove(), !1;} }), t.widget("ui.selectmenu", [t.ui.formResetMixin, { version: "1.12.1", defaultElement: "<select>", options: { appendTo: null, classes: { "ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all" }, disabled: null, icons: { button: "ui-icon-triangle-1-s" }, position: { my: "left top", at: "left bottom", collision: "none" }, width: !1, change: null, close: null, focus: null, open: null, select: null }, _create: function () {var e = this.element.uniqueId().attr("id");this.ids = { element: e, button: e + "-button", menu: e + "-menu" }, this._drawButton(), this._drawMenu(), this._bindFormResetHandler(), this._rendered = !1, this.menuItems = t();}, _drawButton: function () {var e, i = this, s = this._parseOption(this.element.find("option:selected"), this.element[0].selectedIndex);this.labels = this.element.labels().attr("for", this.ids.button), this._on(this.labels, { click: function (t) {this.button.focus(), t.preventDefault();} }), this.element.hide(), this.button = t("<span>", { tabindex: this.options.disabled ? -1 : 0, id: this.ids.button, role: "combobox", "aria-expanded": "false", "aria-autocomplete": "list", "aria-owns": this.ids.menu, "aria-haspopup": "true", title: this.element.attr("title") }).insertAfter(this.element), this._addClass(this.button, "ui-selectmenu-button ui-selectmenu-button-closed", "ui-button ui-widget"), e = t("<span>").appendTo(this.button), this._addClass(e, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button), this.buttonItem = this._renderButtonItem(s).appendTo(this.button), this.options.width !== !1 && this._resizeButton(), this._on(this.button, this._buttonEvents), this.button.one("focusin", function () {i._rendered || i._refreshMenu();});}, _drawMenu: function () {var e = this;this.menu = t("<ul>", { "aria-hidden": "true", "aria-labelledby": this.ids.button, id: this.ids.menu }), this.menuWrap = t("<div>").append(this.menu), this._addClass(this.menuWrap, "ui-selectmenu-menu", "ui-front"), this.menuWrap.appendTo(this._appendTo()), this.menuInstance = this.menu.menu({ classes: { "ui-menu": "ui-corner-bottom" }, role: "listbox", select: function (t, i) {t.preventDefault(), e._setSelection(), e._select(i.item.data("ui-selectmenu-item"), t);}, focus: function (t, i) {var s = i.item.data("ui-selectmenu-item");null != e.focusIndex && s.index !== e.focusIndex && (e._trigger("focus", t, { item: s }), e.isOpen || e._select(s, t)), e.focusIndex = s.index, e.button.attr("aria-activedescendant", e.menuItems.eq(s.index).attr("id"));} }).menu("instance"), this.menuInstance._off(this.menu, "mouseleave"), this.menuInstance._closeOnDocumentClick = function () {return !1;}, this.menuInstance._isDivider = function () {return !1;};}, refresh: function () {this._refreshMenu(), this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item") || {})), null === this.options.width && this._resizeButton();}, _refreshMenu: function () {var t, e = this.element.find("option");this.menu.empty(), this._parseOptions(e), this._renderMenu(this.menu, this.items), this.menuInstance.refresh(), this.menuItems = this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"), this._rendered = !0, e.length && (t = this._getSelectedItem(), this.menuInstance.focus(null, t), this._setAria(t.data("ui-selectmenu-item")), this._setOption("disabled", this.element.prop("disabled")));}, open: function (t) {this.options.disabled || (this._rendered ? (this._removeClass(this.menu.find(".ui-state-active"), null, "ui-state-active"), this.menuInstance.focus(null, this._getSelectedItem())) : this._refreshMenu(), this.menuItems.length && (this.isOpen = !0, this._toggleAttr(), this._resizeMenu(), this._position(), this._on(this.document, this._documentClick), this._trigger("open", t)));}, _position: function () {this.menuWrap.position(t.extend({ of: this.button }, this.options.position));}, close: function (t) {this.isOpen && (this.isOpen = !1, this._toggleAttr(), this.range = null, this._off(this.document), this._trigger("close", t));}, widget: function () {return this.button;}, menuWidget: function () {return this.menu;}, _renderButtonItem: function (e) {var i = t("<span>");return this._setText(i, e.label), this._addClass(i, "ui-selectmenu-text"), i;}, _renderMenu: function (e, i) {var s = this, n = "";t.each(i, function (i, o) {var a;o.optgroup !== n && (a = t("<li>", { text: o.optgroup }), s._addClass(a, "ui-selectmenu-optgroup", "ui-menu-divider" + (o.element.parent("optgroup").prop("disabled") ? " ui-state-disabled" : "")), a.appendTo(e), n = o.optgroup), s._renderItemData(e, o);});}, _renderItemData: function (t, e) {return this._renderItem(t, e).data("ui-selectmenu-item", e);}, _renderItem: function (e, i) {var s = t("<li>"), n = t("<div>", { title: i.element.attr("title") });return i.disabled && this._addClass(s, null, "ui-state-disabled"), this._setText(n, i.label), s.append(n).appendTo(e);}, _setText: function (t, e) {e ? t.text(e) : t.html("&#160;");}, _move: function (t, e) {var i, s, n = ".ui-menu-item";this.isOpen ? i = this.menuItems.eq(this.focusIndex).parent("li") : (i = this.menuItems.eq(this.element[0].selectedIndex).parent("li"), n += ":not(.ui-state-disabled)"), s = "first" === t || "last" === t ? i["first" === t ? "prevAll" : "nextAll"](n).eq(-1) : i[t + "All"](n).eq(0), s.length && this.menuInstance.focus(e, s);}, _getSelectedItem: function () {return this.menuItems.eq(this.element[0].selectedIndex).parent("li");}, _toggle: function (t) {this[this.isOpen ? "close" : "open"](t);}, _setSelection: function () {var t;this.range && (window.getSelection ? (t = window.getSelection(), t.removeAllRanges(), t.addRange(this.range)) : this.range.select(), this.button.focus());}, _documentClick: { mousedown: function (e) {this.isOpen && (t(e.target).closest(".ui-selectmenu-menu, #" + t.ui.escapeSelector(this.ids.button)).length || this.close(e));} }, _buttonEvents: { mousedown: function () {var t;window.getSelection ? (t = window.getSelection(), t.rangeCount && (this.range = t.getRangeAt(0))) : this.range = document.selection.createRange();}, click: function (t) {this._setSelection(), this._toggle(t);}, keydown: function (e) {var i = !0;switch (e.keyCode) {case t.ui.keyCode.TAB:case t.ui.keyCode.ESCAPE:this.close(e), i = !1;break;case t.ui.keyCode.ENTER:this.isOpen && this._selectFocusedItem(e);break;case t.ui.keyCode.UP:e.altKey ? this._toggle(e) : this._move("prev", e);break;case t.ui.keyCode.DOWN:e.altKey ? this._toggle(e) : this._move("next", e);break;case t.ui.keyCode.SPACE:this.isOpen ? this._selectFocusedItem(e) : this._toggle(e);break;case t.ui.keyCode.LEFT:this._move("prev", e);break;case t.ui.keyCode.RIGHT:this._move("next", e);break;case t.ui.keyCode.HOME:case t.ui.keyCode.PAGE_UP:this._move("first", e);break;case t.ui.keyCode.END:case t.ui.keyCode.PAGE_DOWN:this._move("last", e);break;default:this.menu.trigger(e), i = !1;}i && e.preventDefault();} }, _selectFocusedItem: function (t) {var e = this.menuItems.eq(this.focusIndex).parent("li");e.hasClass("ui-state-disabled") || this._select(e.data("ui-selectmenu-item"), t);}, _select: function (t, e) {var i = this.element[0].selectedIndex;this.element[0].selectedIndex = t.index, this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(t)), this._setAria(t), this._trigger("select", e, { item: t }), t.index !== i && this._trigger("change", e, { item: t }), this.close(e);}, _setAria: function (t) {var e = this.menuItems.eq(t.index).attr("id");this.button.attr({ "aria-labelledby": e, "aria-activedescendant": e }), this.menu.attr("aria-activedescendant", e);}, _setOption: function (t, e) {if ("icons" === t) {var i = this.button.find("span.ui-icon");this._removeClass(i, null, this.options.icons.button)._addClass(i, null, e.button);} this._super(t, e), "appendTo" === t && this.menuWrap.appendTo(this._appendTo()), "width" === t && this._resizeButton();}, _setOptionDisabled: function (t) {this._super(t), this.menuInstance.option("disabled", t), this.button.attr("aria-disabled", t), this._toggleClass(this.button, null, "ui-state-disabled", t), this.element.prop("disabled", t), t ? (this.button.attr("tabindex", -1), this.close()) : this.button.attr("tabindex", 0);}, _appendTo: function () {var e = this.options.appendTo;return e && (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)), e && e[0] || (e = this.element.closest(".ui-front, dialog")), e.length || (e = this.document[0].body), e;}, _toggleAttr: function () {this.button.attr("aria-expanded", this.isOpen), this._removeClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "closed" : "open"))._addClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "open" : "closed"))._toggleClass(this.menuWrap, "ui-selectmenu-open", null, this.isOpen), this.menu.attr("aria-hidden", !this.isOpen);}, _resizeButton: function () {var t = this.options.width;return t === !1 ? (this.button.css("width", ""), void 0) : (null === t && (t = this.element.show().outerWidth(), this.element.hide()), this.button.outerWidth(t), void 0);}, _resizeMenu: function () {this.menu.outerWidth(Math.max(this.button.outerWidth(), this.menu.width("").outerWidth() + 1));}, _getCreateOptions: function () {var t = this._super();return t.disabled = this.element.prop("disabled"), t;}, _parseOptions: function (e) {var i = this, s = [];e.each(function (e, n) {s.push(i._parseOption(t(n), e));}), this.items = s;}, _parseOption: function (t, e) {var i = t.parent("optgroup");return { element: t, index: e, value: t.val(), label: t.text(), optgroup: i.attr("label") || "", disabled: i.prop("disabled") || t.prop("disabled") };}, _destroy: function () {this._unbindFormResetHandler(), this.menuWrap.remove(), this.button.remove(), this.element.show(), this.element.removeUniqueId(), this.labels.attr("for", this.ids.element);} }]), t.widget("ui.slider", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "slide", options: { animate: !1, classes: { "ui-slider": "ui-corner-all", "ui-slider-handle": "ui-corner-all", "ui-slider-range": "ui-corner-all ui-widget-header" }, distance: 0, max: 100, min: 0, orientation: "horizontal", range: !1, step: 1, value: 0, values: null, change: null, slide: null, start: null, stop: null }, numPages: 5, _create: function () {this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this._calculateNewMax(), this._addClass("ui-slider ui-slider-" + this.orientation, "ui-widget ui-widget-content"), this._refresh(), this._animateOff = !1;
}, _refresh: function () {this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue();}, _createHandles: function () {var e, i, s = this.options, n = this.element.find(".ui-slider-handle"), o = "<span tabindex='0'></span>", a = [];for (i = s.values && s.values.length || 1, n.length > i && (n.slice(i).remove(), n = n.slice(0, i)), e = n.length;i > e;e++)a.push(o);this.handles = n.add(t(a.join("")).appendTo(this.element)), this._addClass(this.handles, "ui-slider-handle", "ui-state-default"), this.handle = this.handles.eq(0), this.handles.each(function (e) {t(this).data("ui-slider-handle-index", e).attr("tabIndex", 0);});}, _createRange: function () {var e = this.options;e.range ? (e.range === !0 && (e.values ? e.values.length && 2 !== e.values.length ? e.values = [e.values[0], e.values[0]] : t.isArray(e.values) && (e.values = e.values.slice(0)) : e.values = [this._valueMin(), this._valueMin()]), this.range && this.range.length ? (this._removeClass(this.range, "ui-slider-range-min ui-slider-range-max"), this.range.css({ left: "", bottom: "" })) : (this.range = t("<div>").appendTo(this.element), this._addClass(this.range, "ui-slider-range")), ("min" === e.range || "max" === e.range) && this._addClass(this.range, "ui-slider-range-" + e.range)) : (this.range && this.range.remove(), this.range = null);}, _setupEvents: function () {this._off(this.handles), this._on(this.handles, this._handleEvents), this._hoverable(this.handles), this._focusable(this.handles);}, _destroy: function () {this.handles.remove(), this.range && this.range.remove(), this._mouseDestroy();}, _mouseCapture: function (e) {var i, s, n, o, a, r, h, l, c = this, u = this.options;return u.disabled ? !1 : (this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() }, this.elementOffset = this.element.offset(), i = { x: e.pageX, y: e.pageY }, s = this._normValueFromMouse(i), n = this._valueMax() - this._valueMin() + 1, this.handles.each(function (e) {var i = Math.abs(s - c.values(e));(n > i || n === i && (e === c._lastChangedValue || c.values(e) === u.min)) && (n = i, o = t(this), a = e);}), r = this._start(e, a), r === !1 ? !1 : (this._mouseSliding = !0, this._handleIndex = a, this._addClass(o, null, "ui-state-active"), o.trigger("focus"), h = o.offset(), l = !t(e.target).parents().addBack().is(".ui-slider-handle"), this._clickOffset = l ? { left: 0, top: 0 } : { left: e.pageX - h.left - o.width() / 2, top: e.pageY - h.top - o.height() / 2 - (parseInt(o.css("borderTopWidth"), 10) || 0) - (parseInt(o.css("borderBottomWidth"), 10) || 0) + (parseInt(o.css("marginTop"), 10) || 0) }, this.handles.hasClass("ui-state-hover") || this._slide(e, a, s), this._animateOff = !0, !0));}, _mouseStart: function () {return !0;}, _mouseDrag: function (t) {var e = { x: t.pageX, y: t.pageY }, i = this._normValueFromMouse(e);return this._slide(t, this._handleIndex, i), !1;}, _mouseStop: function (t) {return this._removeClass(this.handles, null, "ui-state-active"), this._mouseSliding = !1, this._stop(t, this._handleIndex), this._change(t, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1, !1;}, _detectOrientation: function () {this.orientation = "vertical" === this.options.orientation ? "vertical" : "horizontal";}, _normValueFromMouse: function (t) {var e, i, s, n, o;return "horizontal" === this.orientation ? (e = this.elementSize.width, i = t.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (e = this.elementSize.height, i = t.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)), s = i / e, s > 1 && (s = 1), 0 > s && (s = 0), "vertical" === this.orientation && (s = 1 - s), n = this._valueMax() - this._valueMin(), o = this._valueMin() + s * n, this._trimAlignValue(o);}, _uiHash: function (t, e, i) {var s = { handle: this.handles[t], handleIndex: t, value: void 0 !== e ? e : this.value() };return this._hasMultipleValues() && (s.value = void 0 !== e ? e : this.values(t), s.values = i || this.values()), s;}, _hasMultipleValues: function () {return this.options.values && this.options.values.length;}, _start: function (t, e) {return this._trigger("start", t, this._uiHash(e));}, _slide: function (t, e, i) {var s, n, o = this.value(), a = this.values();this._hasMultipleValues() && (n = this.values(e ? 0 : 1), o = this.values(e), 2 === this.options.values.length && this.options.range === !0 && (i = 0 === e ? Math.min(n, i) : Math.max(n, i)), a[e] = i), i !== o && (s = this._trigger("slide", t, this._uiHash(e, i, a)), s !== !1 && (this._hasMultipleValues() ? this.values(e, i) : this.value(i)));}, _stop: function (t, e) {this._trigger("stop", t, this._uiHash(e));}, _change: function (t, e) {this._keySliding || this._mouseSliding || (this._lastChangedValue = e, this._trigger("change", t, this._uiHash(e)));}, value: function (t) {return arguments.length ? (this.options.value = this._trimAlignValue(t), this._refreshValue(), this._change(null, 0), void 0) : this._value();}, values: function (e, i) {var s, n, o;if (arguments.length > 1) return this.options.values[e] = this._trimAlignValue(i), this._refreshValue(), this._change(null, e), void 0;if (!arguments.length) return this._values();if (!t.isArray(arguments[0])) return this._hasMultipleValues() ? this._values(e) : this.value();for (s = this.options.values, n = arguments[0], o = 0;s.length > o;o += 1)s[o] = this._trimAlignValue(n[o]), this._change(null, o);this._refreshValue();}, _setOption: function (e, i) {var s, n = 0;switch ("range" === e && this.options.range === !0 && ("min" === i ? (this.options.value = this._values(0), this.options.values = null) : "max" === i && (this.options.value = this._values(this.options.values.length - 1), this.options.values = null)), t.isArray(this.options.values) && (n = this.options.values.length), this._super(e, i), e) {case "orientation":this._detectOrientation(), this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-" + this.orientation), this._refreshValue(), this.options.range && this._refreshRange(i), this.handles.css("horizontal" === i ? "bottom" : "left", "");break;case "value":this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;break;case "values":for (this._animateOff = !0, this._refreshValue(), s = n - 1;s >= 0;s--) this._change(null, s);this._animateOff = !1;break;case "step":case "min":case "max":this._animateOff = !0, this._calculateNewMax(), this._refreshValue(), this._animateOff = !1;break;case "range":this._animateOff = !0, this._refresh(), this._animateOff = !1;}}, _setOptionDisabled: function (t) {this._super(t), this._toggleClass(null, "ui-state-disabled", !!t);}, _value: function () {var t = this.options.value;return t = this._trimAlignValue(t);}, _values: function (t) {var e, i, s;if (arguments.length) return e = this.options.values[t], e = this._trimAlignValue(e);if (this._hasMultipleValues()) {for (i = this.options.values.slice(), s = 0;i.length > s;s += 1)i[s] = this._trimAlignValue(i[s]);return i;} return [];}, _trimAlignValue: function (t) {if (this._valueMin() >= t) return this._valueMin();if (t >= this._valueMax()) return this._valueMax();var e = this.options.step > 0 ? this.options.step : 1, i = (t - this._valueMin()) % e, s = t - i;return 2 * Math.abs(i) >= e && (s += i > 0 ? e : -e), parseFloat(s.toFixed(5));}, _calculateNewMax: function () {var t = this.options.max, e = this._valueMin(), i = this.options.step, s = Math.round((t - e) / i) * i;t = s + e, t > this.options.max && (t -= i), this.max = parseFloat(t.toFixed(this._precision()));}, _precision: function () {var t = this._precisionOf(this.options.step);return null !== this.options.min && (t = Math.max(t, this._precisionOf(this.options.min))), t;}, _precisionOf: function (t) {var e = "" + t, i = e.indexOf(".");return -1 === i ? 0 : e.length - i - 1;}, _valueMin: function () {return this.options.min;}, _valueMax: function () {return this.max;}, _refreshRange: function (t) {"vertical" === t && this.range.css({ width: "", left: "" }), "horizontal" === t && this.range.css({ height: "", bottom: "" });}, _refreshValue: function () {var e, i, s, n, o, a = this.options.range, r = this.options, h = this, l = this._animateOff ? !1 : r.animate, c = {};this._hasMultipleValues() ? this.handles.each(function (s) {i = 100 * ((h.values(s) - h._valueMin()) / (h._valueMax() - h._valueMin())), c["horizontal" === h.orientation ? "left" : "bottom"] = i + "%", t(this).stop(1, 1)[l ? "animate" : "css"](c, r.animate), h.options.range === !0 && ("horizontal" === h.orientation ? (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({ left: i + "%" }, r.animate), 1 === s && h.range[l ? "animate" : "css"]({ width: i - e + "%" }, { queue: !1, duration: r.animate })) : (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({ bottom: i + "%" }, r.animate), 1 === s && h.range[l ? "animate" : "css"]({ height: i - e + "%" }, { queue: !1, duration: r.animate }))), e = i;}) : (s = this.value(), n = this._valueMin(), o = this._valueMax(), i = o !== n ? 100 * ((s - n) / (o - n)) : 0, c["horizontal" === this.orientation ? "left" : "bottom"] = i + "%", this.handle.stop(1, 1)[l ? "animate" : "css"](c, r.animate), "min" === a && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ width: i + "%" }, r.animate), "max" === a && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ width: 100 - i + "%" }, r.animate), "min" === a && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ height: i + "%" }, r.animate), "max" === a && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ height: 100 - i + "%" }, r.animate));}, _handleEvents: { keydown: function (e) {var i, s, n, o, a = t(e.target).data("ui-slider-handle-index");switch (e.keyCode) {case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if (e.preventDefault(), !this._keySliding && (this._keySliding = !0, this._addClass(t(e.target), null, "ui-state-active"), i = this._start(e, a), i === !1)) return;} switch (o = this.options.step, s = n = this._hasMultipleValues() ? this.values(a) : this.value(), e.keyCode) {case t.ui.keyCode.HOME:n = this._valueMin();break;case t.ui.keyCode.END:n = this._valueMax();break;case t.ui.keyCode.PAGE_UP:n = this._trimAlignValue(s + (this._valueMax() - this._valueMin()) / this.numPages);break;case t.ui.keyCode.PAGE_DOWN:n = this._trimAlignValue(s - (this._valueMax() - this._valueMin()) / this.numPages);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:if (s === this._valueMax()) return;n = this._trimAlignValue(s + o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if (s === this._valueMin()) return;n = this._trimAlignValue(s - o);} this._slide(e, a, n);}, keyup: function (e) {var i = t(e.target).data("ui-slider-handle-index");this._keySliding && (this._keySliding = !1, this._stop(e, i), this._change(e, i), this._removeClass(t(e.target), null, "ui-state-active"));} } }), t.widget("ui.sortable", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "sort", ready: !1, options: { appendTo: "parent", axis: !1, connectWith: !1, containment: !1, cursor: "auto", cursorAt: !1, dropOnEmpty: !0, forcePlaceholderSize: !1, forceHelperSize: !1, grid: !1, handle: !1, helper: "original", items: "> *", opacity: !1, placeholder: !1, revert: !1, scroll: !0, scrollSensitivity: 20, scrollSpeed: 20, scope: "default", tolerance: "intersect", zIndex: 1e3, activate: null, beforeStop: null, change: null, deactivate: null, out: null, over: null, receive: null, remove: null, sort: null, start: null, stop: null, update: null }, _isOverAxis: function (t, e, i) {return t >= e && e + i > t;}, _isFloating: function (t) {return /left|right/.test(t.css("float")) || /inline|table-cell/.test(t.css("display"));}, _create: function () {this.containerCache = {}, this._addClass("ui-sortable"), this.refresh(), this.offset = this.element.offset(), this._mouseInit(), this._setHandleClassName(), this.ready = !0;}, _setOption: function (t, e) {this._super(t, e), "handle" === t && this._setHandleClassName();}, _setHandleClassName: function () {var e = this;this._removeClass(this.element.find(".ui-sortable-handle"), "ui-sortable-handle"), t.each(this.items, function () {e._addClass(this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item, "ui-sortable-handle");});}, _destroy: function () {this._mouseDestroy();for (var t = this.items.length - 1;t >= 0;t--) this.items[t].item.removeData(this.widgetName + "-item");return this;}, _mouseCapture: function (e, i) {var s = null, n = !1, o = this;return this.reverting ? !1 : this.options.disabled || "static" === this.options.type ? !1 : (this._refreshItems(e), t(e.target).parents().each(function () {return t.data(this, o.widgetName + "-item") === o ? (s = t(this), !1) : void 0;}), t.data(e.target, o.widgetName + "-item") === o && (s = t(e.target)), s ? !this.options.handle || i || (t(this.options.handle, s).find("*").addBack().each(function () {this === e.target && (n = !0);}), n) ? (this.currentItem = s, this._removeCurrentsFromItems(), !0) : !1 : !1);}, _mouseStart: function (e, i, s) {var n, o, a = this.options;if (this.currentContainer = this, this.refreshPositions(), this.helper = this._createHelper(e), this._cacheHelperProportions(), this._cacheMargins(), this.scrollParent = this.helper.scrollParent(), this.offset = this.currentItem.offset(), this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left }, t.extend(this.offset, { click: { left: e.pageX - this.offset.left, top: e.pageY - this.offset.top }, parent: this._getParentOffset(), relative: this._getRelativeOffset() }), this.helper.css("position", "absolute"), this.cssPosition = this.helper.css("position"), this.originalPosition = this._generatePosition(e), this.originalPageX = e.pageX, this.originalPageY = e.pageY, a.cursorAt && this._adjustOffsetFromHelper(a.cursorAt), this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] }, this.helper[0] !== this.currentItem[0] && this.currentItem.hide(), this._createPlaceholder(), a.containment && this._setContainment(), a.cursor && "auto" !== a.cursor && (o = this.document.find("body"), this.storedCursor = o.css("cursor"), o.css("cursor", a.cursor), this.storedStylesheet = t("<style>*{ cursor: " + a.cursor + " !important; }</style>").appendTo(o)), a.opacity && (this.helper.css("opacity") && (this._storedOpacity = this.helper.css("opacity")), this.helper.css("opacity", a.opacity)), a.zIndex && (this.helper.css("zIndex") && (this._storedZIndex = this.helper.css("zIndex")), this.helper.css("zIndex", a.zIndex)), this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this._trigger("start", e, this._uiHash()), this._preserveHelperProportions || this._cacheHelperProportions(), !s) for (n = this.containers.length - 1;n >= 0;n--) this.containers[n]._trigger("activate", e, this._uiHash(this));return t.ui.ddmanager && (t.ui.ddmanager.current = this), t.ui.ddmanager && !a.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e), this.dragging = !0, this._addClass(this.helper, "ui-sortable-helper"), this._mouseDrag(e), !0;}, _mouseDrag: function (e) {var i, s, n, o, a = this.options, r = !1;for (this.position = this._generatePosition(e), this.positionAbs = this._convertPositionTo("absolute"), this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs), this.options.scroll && (this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - e.pageY < a.scrollSensitivity ? this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop + a.scrollSpeed : e.pageY - this.overflowOffset.top < a.scrollSensitivity && (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop - a.scrollSpeed), this.overflowOffset.left + this.scrollParent[0].offsetWidth - e.pageX < a.scrollSensitivity ? this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft + a.scrollSpeed : e.pageX - this.overflowOffset.left < a.scrollSensitivity && (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft - a.scrollSpeed)) : (e.pageY - this.document.scrollTop() < a.scrollSensitivity ? r = this.document.scrollTop(this.document.scrollTop() - a.scrollSpeed) : this.window.height() - (e.pageY - this.document.scrollTop()) < a.scrollSensitivity && (r = this.document.scrollTop(this.document.scrollTop() + a.scrollSpeed)), e.pageX - this.document.scrollLeft() < a.scrollSensitivity ? r = this.document.scrollLeft(this.document.scrollLeft() - a.scrollSpeed) : this.window.width() - (e.pageX - this.document.scrollLeft()) < a.scrollSensitivity && (r = this.document.scrollLeft(this.document.scrollLeft() + a.scrollSpeed))), r !== !1 && t.ui.ddmanager && !a.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e)), this.positionAbs = this._convertPositionTo("absolute"), this.options.axis && "y" === this.options.axis || (this.helper[0].style.left = this.position.left + "px"), this.options.axis && "x" === this.options.axis || (this.helper[0].style.top = this.position.top + "px"), i = this.items.length - 1;i >= 0;i--) if (s = this.items[i], n = s.item[0], o = this._intersectsWithPointer(s), o && s.instance === this.currentContainer && n !== this.currentItem[0] && this.placeholder[1 === o ? "next" : "prev"]()[0] !== n && !t.contains(this.placeholder[0], n) && ("semi-dynamic" === this.options.type ? !t.contains(this.element[0], n) : !0)) {if (this.direction = 1 === o ? "down" : "up", "pointer" !== this.options.tolerance && !this._intersectsWithSides(s)) break;this._rearrange(e, s), this._trigger("change", e, this._uiHash());break;} return this._contactContainers(e), t.ui.ddmanager && t.ui.ddmanager.drag(this, e), this._trigger("sort", e, this._uiHash()), this.lastPositionAbs = this.positionAbs, !1;}, _mouseStop: function (e, i) {if (e) {if (t.ui.ddmanager && !this.options.dropBehaviour && t.ui.ddmanager.drop(this, e), this.options.revert) {var s = this, n = this.placeholder.offset(), o = this.options.axis, a = {};o && "x" !== o || (a.left = n.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft)), o && "y" !== o || (a.top = n.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop)), this.reverting = !0, t(this.helper).animate(a, parseInt(this.options.revert, 10) || 500, function () {s._clear(e);});} else this._clear(e, i);return !1;}}, cancel: function () {if (this.dragging) {this._mouseUp(new t.Event("mouseup", { target: null })), "original" === this.options.helper ? (this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper")) : this.currentItem.show();for (var e = this.containers.length - 1;e >= 0;e--) this.containers[e]._trigger("deactivate", null, this._uiHash(this)), this.containers[e].containerCache.over && (this.containers[e]._trigger("out", null, this._uiHash(this)), this.containers[e].containerCache.over = 0);} return this.placeholder && (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]), "original" !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(), t.extend(this, { helper: null, dragging: !1, reverting: !1, _noFinalSort: null }), this.domPosition.prev ? t(this.domPosition.prev).after(this.currentItem) : t(this.domPosition.parent).prepend(this.currentItem)), this;}, serialize: function (e) {var i = this._getItemsAsjQuery(e && e.connected), s = [];return e = e || {}, t(i).each(function () {var i = (t(e.item || this).attr(e.attribute || "id") || "").match(e.expression || /(.+)[\-=_](.+)/);i && s.push((e.key || i[1] + "[]") + "=" + (e.key && e.expression ? i[1] : i[2]));}), !s.length && e.key && s.push(e.key + "="), s.join("&");}, toArray: function (e) {var i = this._getItemsAsjQuery(e && e.connected), s = [];return e = e || {}, i.each(function () {s.push(t(e.item || this).attr(e.attribute || "id") || "");}), s;}, _intersectsWith: function (t) {var e = this.positionAbs.left, i = e + this.helperProportions.width, s = this.positionAbs.top, n = s + this.helperProportions.height, o = t.left, a = o + t.width, r = t.top, h = r + t.height, l = this.offset.click.top, c = this.offset.click.left, u = "x" === this.options.axis || s + l > r && h > s + l, d = "y" === this.options.axis || e + c > o && a > e + c, p = u && d;return "pointer" === this.options.tolerance || this.options.forcePointerForContainers || "pointer" !== this.options.tolerance && this.helperProportions[this.floating ? "width" : "height"] > t[this.floating ? "width" : "height"] ? p : e + this.helperProportions.width / 2 > o && a > i - this.helperProportions.width / 2 && s + this.helperProportions.height / 2 > r && h > n - this.helperProportions.height / 2;}, _intersectsWithPointer: function (t) {var e, i, s = "x" === this.options.axis || this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top, t.height), n = "y" === this.options.axis || this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left, t.width), o = s && n;return o ? (e = this._getDragVerticalDirection(), i = this._getDragHorizontalDirection(), this.floating ? "right" === i || "down" === e ? 2 : 1 : e && ("down" === e ? 2 : 1)) : !1;}, _intersectsWithSides: function (t) {var e = this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top + t.height / 2, t.height), i = this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left + t.width / 2, t.width), s = this._getDragVerticalDirection(), n = this._getDragHorizontalDirection();return this.floating && n ? "right" === n && i || "left" === n && !i : s && ("down" === s && e || "up" === s && !e);}, _getDragVerticalDirection: function () {var t = this.positionAbs.top - this.lastPositionAbs.top;return 0 !== t && (t > 0 ? "down" : "up");}, _getDragHorizontalDirection: function () {var t = this.positionAbs.left - this.lastPositionAbs.left;return 0 !== t && (t > 0 ? "right" : "left");}, refresh: function (t) {return this._refreshItems(t), this._setHandleClassName(), this.refreshPositions(), this;}, _connectWith: function () {var t = this.options;return t.connectWith.constructor === String ? [t.connectWith] : t.connectWith;}, _getItemsAsjQuery: function (e) {function i() {r.push(this);} var s, n, o, a, r = [], h = [], l = this._connectWith();if (l && e) for (s = l.length - 1;s >= 0;s--) for (o = t(l[s], this.document[0]), n = o.length - 1;n >= 0;n--)a = t.data(o[n], this.widgetFullName), a && a !== this && !a.options.disabled && h.push([t.isFunction(a.options.items) ? a.options.items.call(a.element) : t(a.options.items, a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), a]);for (h.push([t.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : t(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]), s = h.length - 1;s >= 0;s--)h[s][0].each(i);return t(r);}, _removeCurrentsFromItems: function () {var e = this.currentItem.find(":data(" + this.widgetName + "-item)");this.items = t.grep(this.items, function (t) {for (var i = 0;e.length > i;i++) if (e[i] === t.item[0]) return !1;return !0;});}, _refreshItems: function (e) {this.items = [], this.containers = [this];var i, s, n, o, a, r, h, l, c = this.items, u = [[t.isFunction(this.options.items) ? this.options.items.call(this.element[0], e, { item: this.currentItem }) : t(this.options.items, this.element), this]], d = this._connectWith();if (d && this.ready) for (i = d.length - 1;i >= 0;i--) for (n = t(d[i], this.document[0]), s = n.length - 1;s >= 0;s--)o = t.data(n[s], this.widgetFullName), o && o !== this && !o.options.disabled && (u.push([t.isFunction(o.options.items) ? o.options.items.call(o.element[0], e, { item: this.currentItem }) : t(o.options.items, o.element), o]), this.containers.push(o));for (i = u.length - 1;i >= 0;i--) for (a = u[i][1], r = u[i][0], s = 0, l = r.length;l > s;s++)h = t(r[s]), h.data(this.widgetName + "-item", a), c.push({ item: h, instance: a, width: 0, height: 0, left: 0, top: 0 });}, refreshPositions: function (e) {this.floating = this.items.length ? "x" === this.options.axis || this._isFloating(this.items[0].item) : !1, this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset());var i, s, n, o;for (i = this.items.length - 1;i >= 0;i--)s = this.items[i], s.instance !== this.currentContainer && this.currentContainer && s.item[0] !== this.currentItem[0] || (n = this.options.toleranceElement ? t(this.options.toleranceElement, s.item) : s.item, e || (s.width = n.outerWidth(), s.height = n.outerHeight()), o = n.offset(), s.left = o.left, s.top = o.top);if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this);else for (i = this.containers.length - 1;i >= 0;i--)o = this.containers[i].element.offset(), this.containers[i].containerCache.left = o.left, this.containers[i].containerCache.top = o.top, this.containers[i].containerCache.width = this.containers[i].element.outerWidth(), this.containers[i].containerCache.height = this.containers[i].element.outerHeight();return this;}, _createPlaceholder: function (e) {e = e || this;var i, s = e.options;s.placeholder && s.placeholder.constructor !== String || (i = s.placeholder, s.placeholder = { element: function () {var s = e.currentItem[0].nodeName.toLowerCase(), n = t("<" + s + ">", e.document[0]);return e._addClass(n, "ui-sortable-placeholder", i || e.currentItem[0].className)._removeClass(n, "ui-sortable-helper"), "tbody" === s ? e._createTrPlaceholder(e.currentItem.find("tr").eq(0), t("<tr>", e.document[0]).appendTo(n)) : "tr" === s ? e._createTrPlaceholder(e.currentItem, n) : "img" === s && n.attr("src", e.currentItem.attr("src")), i || n.css("visibility", "hidden"), n;}, update: function (t, n) {(!i || s.forcePlaceholderSize) && (n.height() || n.height(e.currentItem.innerHeight() - parseInt(e.currentItem.css("paddingTop") || 0, 10) - parseInt(e.currentItem.css("paddingBottom") || 0, 10)), n.width() || n.width(e.currentItem.innerWidth() - parseInt(e.currentItem.css("paddingLeft") || 0, 10) - parseInt(e.currentItem.css("paddingRight") || 0, 10)));} }), e.placeholder = t(s.placeholder.element.call(e.element, e.currentItem)), e.currentItem.after(e.placeholder), s.placeholder.update(e, e.placeholder);}, _createTrPlaceholder: function (e, i) {var s = this;e.children().each(function () {t("<td>&#160;</td>", s.document[0]).attr("colspan", t(this).attr("colspan") || 1).appendTo(i);});}, _contactContainers: function (e) {var i, s, n, o, a, r, h, l, c, u, d = null, p = null;for (i = this.containers.length - 1;i >= 0;i--) if (!t.contains(this.currentItem[0], this.containers[i].element[0])) if (this._intersectsWith(this.containers[i].containerCache)) {if (d && t.contains(this.containers[i].element[0], d.element[0])) continue;d = this.containers[i], p = i;} else this.containers[i].containerCache.over && (this.containers[i]._trigger("out", e, this._uiHash(this)), this.containers[i].containerCache.over = 0);if (d) if (1 === this.containers.length) this.containers[p].containerCache.over || (this.containers[p]._trigger("over", e, this._uiHash(this)), this.containers[p].containerCache.over = 1);else {for (n = 1e4, o = null, c = d.floating || this._isFloating(this.currentItem), a = c ? "left" : "top", r = c ? "width" : "height", u = c ? "pageX" : "pageY", s = this.items.length - 1;s >= 0;s--)t.contains(this.containers[p].element[0], this.items[s].item[0]) && this.items[s].item[0] !== this.currentItem[0] && (h = this.items[s].item.offset()[a], l = !1, e[u] - h > this.items[s][r] / 2 && (l = !0), n > Math.abs(e[u] - h) && (n = Math.abs(e[u] - h), o = this.items[s], this.direction = l ? "up" : "down"));if (!o && !this.options.dropOnEmpty) return;if (this.currentContainer === this.containers[p]) return this.currentContainer.containerCache.over || (this.containers[p]._trigger("over", e, this._uiHash()), this.currentContainer.containerCache.over = 1), void 0;o ? this._rearrange(e, o, null, !0) : this._rearrange(e, null, this.containers[p].element, !0), this._trigger("change", e, this._uiHash()), this.containers[p]._trigger("change", e, this._uiHash(this)), this.currentContainer = this.containers[p], this.options.placeholder.update(this.currentContainer, this.placeholder), this.containers[p]._trigger("over", e, this._uiHash(this)), this.containers[p].containerCache.over = 1;}}, _createHelper: function (e) {var i = this.options, s = t.isFunction(i.helper) ? t(i.helper.apply(this.element[0], [e, this.currentItem])) : "clone" === i.helper ? this.currentItem.clone() : this.currentItem;return s.parents("body").length || t("parent" !== i.appendTo ? i.appendTo : this.currentItem[0].parentNode)[0].appendChild(s[0]), s[0] === this.currentItem[0] && (this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") }), (!s[0].style.width || i.forceHelperSize) && s.width(this.currentItem.width()), (!s[0].style.height || i.forceHelperSize) && s.height(this.currentItem.height()), s;}, _adjustOffsetFromHelper: function (e) {"string" === typeof e && (e = e.split(" ")), t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }), "left" in e && (this.offset.click.left = e.left + this.margins.left), "right" in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left), "top" in e && (this.offset.click.top = e.top + this.margins.top), "bottom" in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top);}, _getParentOffset: function () {this.offsetParent = this.helper.offsetParent();var e = this.offsetParent.offset();return "absolute" === this.cssPosition && this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) && (e.left += this.scrollParent.scrollLeft(), e.top += this.scrollParent.scrollTop()), (this.offsetParent[0] === this.document[0].body || this.offsetParent[0].tagName && "html" === this.offsetParent[0].tagName.toLowerCase() && t.ui.ie) && (e = { top: 0, left: 0 }), { top: e.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0), left: e.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0) };}, _getRelativeOffset: function () {if ("relative" === this.cssPosition) {var t = this.currentItem.position();return { top: t.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(), left: t.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft() };} return { top: 0, left: 0 };}, _cacheMargins: function () {this.margins = { left: parseInt(this.currentItem.css("marginLeft"), 10) || 0, top: parseInt(this.currentItem.css("marginTop"), 10) || 0 };}, _cacheHelperProportions: function () {this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };}, _setContainment: function () {var e, i, s, n = this.options;"parent" === n.containment && (n.containment = this.helper[0].parentNode), ("document" === n.containment || "window" === n.containment) && (this.containment = [0 - this.offset.relative.left - this.offset.parent.left, 0 - this.offset.relative.top - this.offset.parent.top, "document" === n.containment ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left, ("document" === n.containment ? this.document.height() || document.body.parentNode.scrollHeight : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]), /^(document|window|parent)$/.test(n.containment) || (e = t(n.containment)[0], i = t(n.containment).offset(), s = "hidden" !== t(e).css("overflow"), this.containment = [i.left + (parseInt(t(e).css("borderLeftWidth"), 10) || 0) + (parseInt(t(e).css("paddingLeft"), 10) || 0) - this.margins.left, i.top + (parseInt(t(e).css("borderTopWidth"), 10) || 0) + (parseInt(t(e).css("paddingTop"), 10) || 0) - this.margins.top, i.left + (s ? Math.max(e.scrollWidth, e.offsetWidth) : e.offsetWidth) - (parseInt(t(e).css("borderLeftWidth"), 10) || 0) - (parseInt(t(e).css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left, i.top + (s ? Math.max(e.scrollHeight, e.offsetHeight) : e.offsetHeight) - (parseInt(t(e).css("borderTopWidth"), 10) || 0) - (parseInt(t(e).css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top]);}, _convertPositionTo: function (e, i) {i || (i = this.position);var s = "absolute" === e ? 1 : -1, n = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent, o = /(html|body)/i.test(n[0].tagName);return { top: i.top + this.offset.relative.top * s + this.offset.parent.top * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : o ? 0 : n.scrollTop()) * s, left: i.left + this.offset.relative.left * s + this.offset.parent.left * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : o ? 0 : n.scrollLeft()) * s };}, _generatePosition: function (e) {var i, s, n = this.options, o = e.pageX, a = e.pageY, r = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent, h = /(html|body)/i.test(r[0].tagName);return "relative" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0] || (this.offset.relative = this._getRelativeOffset()), this.originalPosition && (this.containment && (e.pageX - this.offset.click.left < this.containment[0] && (o = this.containment[0] + this.offset.click.left), e.pageY - this.offset.click.top < this.containment[1] && (a = this.containment[1] + this.offset.click.top), e.pageX - this.offset.click.left > this.containment[2] && (o = this.containment[2] + this.offset.click.left), e.pageY - this.offset.click.top > this.containment[3] && (a = this.containment[3] + this.offset.click.top)), n.grid && (i = this.originalPageY + Math.round((a - this.originalPageY) / n.grid[1]) * n.grid[1], a = this.containment ? i - this.offset.click.top >= this.containment[1] && i - this.offset.click.top <= this.containment[3] ? i : i - this.offset.click.top >= this.containment[1] ? i - n.grid[1] : i + n.grid[1] : i, s = this.originalPageX + Math.round((o - this.originalPageX) / n.grid[0]) * n.grid[0], o = this.containment ? s - this.offset.click.left >= this.containment[0] && s - this.offset.click.left <= this.containment[2] ? s : s - this.offset.click.left >= this.containment[0] ? s - n.grid[0] : s + n.grid[0] : s)), { top: a - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : h ? 0 : r.scrollTop()), left: o - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : h ? 0 : r.scrollLeft()) };}, _rearrange: function (t, e, i, s) {i ? i[0].appendChild(this.placeholder[0]) : e.item[0].parentNode.insertBefore(this.placeholder[0], "down" === this.direction ? e.item[0] : e.item[0].nextSibling), this.counter = this.counter ? ++this.counter : 1;var n = this.counter;
  this._delay(function () {n === this.counter && this.refreshPositions(!s);});}, _clear: function (t, e) {function i(t, e, i) {return function (s) {i._trigger(t, s, e._uiHash(e));};} this.reverting = !1;var s, n = [];if (!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), this._noFinalSort = null, this.helper[0] === this.currentItem[0]) {for (s in this._storedCSS)("auto" === this._storedCSS[s] || "static" === this._storedCSS[s]) && (this._storedCSS[s] = "");this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper");} else this.currentItem.show();for (this.fromOutside && !e && n.push(function (t) {this._trigger("receive", t, this._uiHash(this.fromOutside));}), !this.fromOutside && this.domPosition.prev === this.currentItem.prev().not(".ui-sortable-helper")[0] && this.domPosition.parent === this.currentItem.parent()[0] || e || n.push(function (t) {this._trigger("update", t, this._uiHash());}), this !== this.currentContainer && (e || (n.push(function (t) {this._trigger("remove", t, this._uiHash());}), n.push(function (t) {return function (e) {t._trigger("receive", e, this._uiHash(this));};}.call(this, this.currentContainer)), n.push(function (t) {return function (e) {t._trigger("update", e, this._uiHash(this));};}.call(this, this.currentContainer)))), s = this.containers.length - 1;s >= 0;s--)e || n.push(i("deactivate", this, this.containers[s])), this.containers[s].containerCache.over && (n.push(i("out", this, this.containers[s])), this.containers[s].containerCache.over = 0);if (this.storedCursor && (this.document.find("body").css("cursor", this.storedCursor), this.storedStylesheet.remove()), this._storedOpacity && this.helper.css("opacity", this._storedOpacity), this._storedZIndex && this.helper.css("zIndex", "auto" === this._storedZIndex ? "" : this._storedZIndex), this.dragging = !1, e || this._trigger("beforeStop", t, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.cancelHelperRemoval || (this.helper[0] !== this.currentItem[0] && this.helper.remove(), this.helper = null), !e) {for (s = 0;n.length > s;s++)n[s].call(this, t);this._trigger("stop", t, this._uiHash());} return this.fromOutside = !1, !this.cancelHelperRemoval;}, _trigger: function () {t.Widget.prototype._trigger.apply(this, arguments) === !1 && this.cancel();}, _uiHash: function (e) {var i = e || this;return { helper: i.helper, placeholder: i.placeholder || t([]), position: i.position, originalPosition: i.originalPosition, offset: i.positionAbs, item: i.currentItem, sender: e ? e.element : null };} }), t.widget("ui.spinner", { version: "1.12.1", defaultElement: "<input>", widgetEventPrefix: "spin", options: { classes: { "ui-spinner": "ui-corner-all", "ui-spinner-down": "ui-corner-br", "ui-spinner-up": "ui-corner-tr" }, culture: null, icons: { down: "ui-icon-triangle-1-s", up: "ui-icon-triangle-1-n" }, incremental: !0, max: null, min: null, numberFormat: null, page: 10, step: 1, change: null, spin: null, start: null, stop: null }, _create: function () {this._setOption("max", this.options.max), this._setOption("min", this.options.min), this._setOption("step", this.options.step), "" !== this.value() && this._value(this.element.val(), !0), this._draw(), this._on(this._events), this._refresh(), this._on(this.window, { beforeunload: function () {this.element.removeAttr("autocomplete");} });}, _getCreateOptions: function () {var e = this._super(), i = this.element;return t.each(["min", "max", "step"], function (t, s) {var n = i.attr(s);null != n && n.length && (e[s] = n);}), e;}, _events: { keydown: function (t) {this._start(t) && this._keydown(t) && t.preventDefault();}, keyup: "_stop", focus: function () {this.previous = this.element.val();}, blur: function (t) {return this.cancelBlur ? (delete this.cancelBlur, void 0) : (this._stop(), this._refresh(), this.previous !== this.element.val() && this._trigger("change", t), void 0);}, mousewheel: function (t, e) {if (e) {if (!this.spinning && !this._start(t)) return !1;this._spin((e > 0 ? 1 : -1) * this.options.step, t), clearTimeout(this.mousewheelTimer), this.mousewheelTimer = this._delay(function () {this.spinning && this._stop(t);}, 100), t.preventDefault();}}, "mousedown .ui-spinner-button": function (e) {function i() {var e = this.element[0] === t.ui.safeActiveElement(this.document[0]);e || (this.element.trigger("focus"), this.previous = s, this._delay(function () {this.previous = s;}));} var s;s = this.element[0] === t.ui.safeActiveElement(this.document[0]) ? this.previous : this.element.val(), e.preventDefault(), i.call(this), this.cancelBlur = !0, this._delay(function () {delete this.cancelBlur, i.call(this);}), this._start(e) !== !1 && this._repeat(null, t(e.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, e);}, "mouseup .ui-spinner-button": "_stop", "mouseenter .ui-spinner-button": function (e) {return t(e.currentTarget).hasClass("ui-state-active") ? this._start(e) === !1 ? !1 : (this._repeat(null, t(e.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, e), void 0) : void 0;}, "mouseleave .ui-spinner-button": "_stop" }, _enhance: function () {this.uiSpinner = this.element.attr("autocomplete", "off").wrap("<span>").parent().append("<a></a><a></a>");}, _draw: function () {this._enhance(), this._addClass(this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content"), this._addClass("ui-spinner-input"), this.element.attr("role", "spinbutton"), this.buttons = this.uiSpinner.children("a").attr("tabIndex", -1).attr("aria-hidden", !0).button({ classes: { "ui-button": "" } }), this._removeClass(this.buttons, "ui-corner-all"), this._addClass(this.buttons.first(), "ui-spinner-button ui-spinner-up"), this._addClass(this.buttons.last(), "ui-spinner-button ui-spinner-down"), this.buttons.first().button({ icon: this.options.icons.up, showLabel: !1 }), this.buttons.last().button({ icon: this.options.icons.down, showLabel: !1 }), this.buttons.height() > Math.ceil(.5 * this.uiSpinner.height()) && this.uiSpinner.height() > 0 && this.uiSpinner.height(this.uiSpinner.height());}, _keydown: function (e) {var i = this.options, s = t.ui.keyCode;switch (e.keyCode) {case s.UP:return this._repeat(null, 1, e), !0;case s.DOWN:return this._repeat(null, -1, e), !0;case s.PAGE_UP:return this._repeat(null, i.page, e), !0;case s.PAGE_DOWN:return this._repeat(null, -i.page, e), !0;} return !1;}, _start: function (t) {return this.spinning || this._trigger("start", t) !== !1 ? (this.counter || (this.counter = 1), this.spinning = !0, !0) : !1;}, _repeat: function (t, e, i) {t = t || 500, clearTimeout(this.timer), this.timer = this._delay(function () {this._repeat(40, e, i);}, t), this._spin(e * this.options.step, i);}, _spin: function (t, e) {var i = this.value() || 0;this.counter || (this.counter = 1), i = this._adjustValue(i + t * this._increment(this.counter)), this.spinning && this._trigger("spin", e, { value: i }) === !1 || (this._value(i), this.counter++);}, _increment: function (e) {var i = this.options.incremental;return i ? t.isFunction(i) ? i(e) : Math.floor(e * e * e / 5e4 - e * e / 500 + 17 * e / 200 + 1) : 1;}, _precision: function () {var t = this._precisionOf(this.options.step);return null !== this.options.min && (t = Math.max(t, this._precisionOf(this.options.min))), t;}, _precisionOf: function (t) {var e = "" + t, i = e.indexOf(".");return -1 === i ? 0 : e.length - i - 1;}, _adjustValue: function (t) {var e, i, s = this.options;return e = null !== s.min ? s.min : 0, i = t - e, i = Math.round(i / s.step) * s.step, t = e + i, t = parseFloat(t.toFixed(this._precision())), null !== s.max && t > s.max ? s.max : null !== s.min && s.min > t ? s.min : t;}, _stop: function (t) {this.spinning && (clearTimeout(this.timer), clearTimeout(this.mousewheelTimer), this.counter = 0, this.spinning = !1, this._trigger("stop", t));}, _setOption: function (t, e) {var i, s, n;return "culture" === t || "numberFormat" === t ? (i = this._parse(this.element.val()), this.options[t] = e, this.element.val(this._format(i)), void 0) : (("max" === t || "min" === t || "step" === t) && "string" === typeof e && (e = this._parse(e)), "icons" === t && (s = this.buttons.first().find(".ui-icon"), this._removeClass(s, null, this.options.icons.up), this._addClass(s, null, e.up), n = this.buttons.last().find(".ui-icon"), this._removeClass(n, null, this.options.icons.down), this._addClass(n, null, e.down)), this._super(t, e), void 0);}, _setOptionDisabled: function (t) {this._super(t), this._toggleClass(this.uiSpinner, null, "ui-state-disabled", !!t), this.element.prop("disabled", !!t), this.buttons.button(t ? "disable" : "enable");}, _setOptions: r(function (t) {this._super(t);}), _parse: function (t) {return "string" === typeof t && "" !== t && (t = window.Globalize && this.options.numberFormat ? Globalize.parseFloat(t, 10, this.options.culture) : +t), "" === t || isNaN(t) ? null : t;}, _format: function (t) {return "" === t ? "" : window.Globalize && this.options.numberFormat ? Globalize.format(t, this.options.numberFormat, this.options.culture) : t;}, _refresh: function () {this.element.attr({ "aria-valuemin": this.options.min, "aria-valuemax": this.options.max, "aria-valuenow": this._parse(this.element.val()) });}, isValid: function () {var t = this.value();return null === t ? !1 : t === this._adjustValue(t);}, _value: function (t, e) {var i;"" !== t && (i = this._parse(t), null !== i && (e || (i = this._adjustValue(i)), t = this._format(i))), this.element.val(t), this._refresh();}, _destroy: function () {this.element.prop("disabled", !1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"), this.uiSpinner.replaceWith(this.element);}, stepUp: r(function (t) {this._stepUp(t);}), _stepUp: function (t) {this._start() && (this._spin((t || 1) * this.options.step), this._stop());}, stepDown: r(function (t) {this._stepDown(t);}), _stepDown: function (t) {this._start() && (this._spin((t || 1) * -this.options.step), this._stop());}, pageUp: r(function (t) {this._stepUp((t || 1) * this.options.page);}), pageDown: r(function (t) {this._stepDown((t || 1) * this.options.page);}), value: function (t) {return arguments.length ? (r(this._value).call(this, t), void 0) : this._parse(this.element.val());}, widget: function () {return this.uiSpinner;} }), t.uiBackCompat !== !1 && t.widget("ui.spinner", t.ui.spinner, { _enhance: function () {this.uiSpinner = this.element.attr("autocomplete", "off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());}, _uiSpinnerHtml: function () {return "<span>";}, _buttonHtml: function () {return "<a></a><a></a>";} }), t.ui.spinner, t.widget("ui.tabs", { version: "1.12.1", delay: 300, options: { active: null, classes: { "ui-tabs": "ui-corner-all", "ui-tabs-nav": "ui-corner-all", "ui-tabs-panel": "ui-corner-bottom", "ui-tabs-tab": "ui-corner-top" }, collapsible: !1, event: "click", heightStyle: "content", hide: null, show: null, activate: null, beforeActivate: null, beforeLoad: null, load: null }, _isLocal: function () {var t = /#.*$/;return function (e) {var i, s;i = e.href.replace(t, ""), s = location.href.replace(t, "");try {i = decodeURIComponent(i);} catch (n) {} try {s = decodeURIComponent(s);} catch (n) {} return e.hash.length > 1 && i === s;};}(), _create: function () {var e = this, i = this.options;this.running = !1, this._addClass("ui-tabs", "ui-widget ui-widget-content"), this._toggleClass("ui-tabs-collapsible", null, i.collapsible), this._processTabs(), i.active = this._initialActive(), t.isArray(i.disabled) && (i.disabled = t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"), function (t) {return e.tabs.index(t);}))).sort()), this.active = this.options.active !== !1 && this.anchors.length ? this._findActive(i.active) : t(), this._refresh(), this.active.length && this.load(i.active);}, _initialActive: function () {var e = this.options.active, i = this.options.collapsible, s = location.hash.substring(1);return null === e && (s && this.tabs.each(function (i, n) {return t(n).attr("aria-controls") === s ? (e = i, !1) : void 0;}), null === e && (e = this.tabs.index(this.tabs.filter(".ui-tabs-active"))), (null === e || -1 === e) && (e = this.tabs.length ? 0 : !1)), e !== !1 && (e = this.tabs.index(this.tabs.eq(e)), -1 === e && (e = i ? !1 : 0)), !i && e === !1 && this.anchors.length && (e = 0), e;}, _getCreateEventData: function () {return { tab: this.active, panel: this.active.length ? this._getPanelForTab(this.active) : t() };}, _tabKeydown: function (e) {var i = t(t.ui.safeActiveElement(this.document[0])).closest("li"), s = this.tabs.index(i), n = !0;if (!this._handlePageNav(e)) {switch (e.keyCode) {case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:s++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:n = !1, s--;break;case t.ui.keyCode.END:s = this.anchors.length - 1;break;case t.ui.keyCode.HOME:s = 0;break;case t.ui.keyCode.SPACE:return e.preventDefault(), clearTimeout(this.activating), this._activate(s), void 0;case t.ui.keyCode.ENTER:return e.preventDefault(), clearTimeout(this.activating), this._activate(s === this.options.active ? !1 : s), void 0;default:return;}e.preventDefault(), clearTimeout(this.activating), s = this._focusNextTab(s, n), e.ctrlKey || e.metaKey || (i.attr("aria-selected", "false"), this.tabs.eq(s).attr("aria-selected", "true"), this.activating = this._delay(function () {this.option("active", s);}, this.delay));}}, _panelKeydown: function (e) {this._handlePageNav(e) || e.ctrlKey && e.keyCode === t.ui.keyCode.UP && (e.preventDefault(), this.active.trigger("focus"));}, _handlePageNav: function (e) {return e.altKey && e.keyCode === t.ui.keyCode.PAGE_UP ? (this._activate(this._focusNextTab(this.options.active - 1, !1)), !0) : e.altKey && e.keyCode === t.ui.keyCode.PAGE_DOWN ? (this._activate(this._focusNextTab(this.options.active + 1, !0)), !0) : void 0;}, _findNextTab: function (e, i) {function s() {return e > n && (e = 0), 0 > e && (e = n), e;} for (var n = this.tabs.length - 1;-1 !== t.inArray(s(), this.options.disabled);)e = i ? e + 1 : e - 1;return e;}, _focusNextTab: function (t, e) {return t = this._findNextTab(t, e), this.tabs.eq(t).trigger("focus"), t;}, _setOption: function (t, e) {return "active" === t ? (this._activate(e), void 0) : (this._super(t, e), "collapsible" === t && (this._toggleClass("ui-tabs-collapsible", null, e), e || this.options.active !== !1 || this._activate(0)), "event" === t && this._setupEvents(e), "heightStyle" === t && this._setupHeightStyle(e), void 0);}, _sanitizeSelector: function (t) {return t ? t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&") : "";}, refresh: function () {var e = this.options, i = this.tablist.children(":has(a[href])");e.disabled = t.map(i.filter(".ui-state-disabled"), function (t) {return i.index(t);}), this._processTabs(), e.active !== !1 && this.anchors.length ? this.active.length && !t.contains(this.tablist[0], this.active[0]) ? this.tabs.length === e.disabled.length ? (e.active = !1, this.active = t()) : this._activate(this._findNextTab(Math.max(0, e.active - 1), !1)) : e.active = this.tabs.index(this.active) : (e.active = !1, this.active = t()), this._refresh();}, _refresh: function () {this._setOptionDisabled(this.options.disabled), this._setupEvents(this.options.event), this._setupHeightStyle(this.options.heightStyle), this.tabs.not(this.active).attr({ "aria-selected": "false", "aria-expanded": "false", tabIndex: -1 }), this.panels.not(this._getPanelForTab(this.active)).hide().attr({ "aria-hidden": "true" }), this.active.length ? (this.active.attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 }), this._addClass(this.active, "ui-tabs-active", "ui-state-active"), this._getPanelForTab(this.active).show().attr({ "aria-hidden": "false" })) : this.tabs.eq(0).attr("tabIndex", 0);}, _processTabs: function () {var e = this, i = this.tabs, s = this.anchors, n = this.panels;this.tablist = this._getList().attr("role", "tablist"), this._addClass(this.tablist, "ui-tabs-nav", "ui-helper-reset ui-helper-clearfix ui-widget-header"), this.tablist.on("mousedown" + this.eventNamespace, "> li", function (e) {t(this).is(".ui-state-disabled") && e.preventDefault();}).on("focus" + this.eventNamespace, ".ui-tabs-anchor", function () {t(this).closest("li").is(".ui-state-disabled") && this.blur();}), this.tabs = this.tablist.find("> li:has(a[href])").attr({ role: "tab", tabIndex: -1 }), this._addClass(this.tabs, "ui-tabs-tab", "ui-state-default"), this.anchors = this.tabs.map(function () {return t("a", this)[0];}).attr({ role: "presentation", tabIndex: -1 }), this._addClass(this.anchors, "ui-tabs-anchor"), this.panels = t(), this.anchors.each(function (i, s) {var n, o, a, r = t(s).uniqueId().attr("id"), h = t(s).closest("li"), l = h.attr("aria-controls");e._isLocal(s) ? (n = s.hash, a = n.substring(1), o = e.element.find(e._sanitizeSelector(n))) : (a = h.attr("aria-controls") || t({}).uniqueId()[0].id, n = "#" + a, o = e.element.find(n), o.length || (o = e._createPanel(a), o.insertAfter(e.panels[i - 1] || e.tablist)), o.attr("aria-live", "polite")), o.length && (e.panels = e.panels.add(o)), l && h.data("ui-tabs-aria-controls", l), h.attr({ "aria-controls": a, "aria-labelledby": r }), o.attr("aria-labelledby", r);}), this.panels.attr("role", "tabpanel"), this._addClass(this.panels, "ui-tabs-panel", "ui-widget-content"), i && (this._off(i.not(this.tabs)), this._off(s.not(this.anchors)), this._off(n.not(this.panels)));}, _getList: function () {return this.tablist || this.element.find("ol, ul").eq(0);}, _createPanel: function (e) {return t("<div>").attr("id", e).data("ui-tabs-destroy", !0);}, _setOptionDisabled: function (e) {var i, s, n;for (t.isArray(e) && (e.length ? e.length === this.anchors.length && (e = !0) : e = !1), n = 0;s = this.tabs[n];n++)i = t(s), e === !0 || -1 !== t.inArray(n, e) ? (i.attr("aria-disabled", "true"), this._addClass(i, null, "ui-state-disabled")) : (i.removeAttr("aria-disabled"), this._removeClass(i, null, "ui-state-disabled"));this.options.disabled = e, this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, e === !0);}, _setupEvents: function (e) {var i = {};e && t.each(e.split(" "), function (t, e) {i[e] = "_eventHandler";}), this._off(this.anchors.add(this.tabs).add(this.panels)), this._on(!0, this.anchors, { click: function (t) {t.preventDefault();} }), this._on(this.anchors, i), this._on(this.tabs, { keydown: "_tabKeydown" }), this._on(this.panels, { keydown: "_panelKeydown" }), this._focusable(this.tabs), this._hoverable(this.tabs);}, _setupHeightStyle: function (e) {var i, s = this.element.parent();"fill" === e ? (i = s.height(), i -= this.element.outerHeight() - this.element.height(), this.element.siblings(":visible").each(function () {var e = t(this), s = e.css("position");"absolute" !== s && "fixed" !== s && (i -= e.outerHeight(!0));}), this.element.children().not(this.panels).each(function () {i -= t(this).outerHeight(!0);}), this.panels.each(function () {t(this).height(Math.max(0, i - t(this).innerHeight() + t(this).height()));}).css("overflow", "auto")) : "auto" === e && (i = 0, this.panels.each(function () {i = Math.max(i, t(this).height("").height());}).height(i));}, _eventHandler: function (e) {var i = this.options, s = this.active, n = t(e.currentTarget), o = n.closest("li"), a = o[0] === s[0], r = a && i.collapsible, h = r ? t() : this._getPanelForTab(o), l = s.length ? this._getPanelForTab(s) : t(), c = { oldTab: s, oldPanel: l, newTab: r ? t() : o, newPanel: h };e.preventDefault(), o.hasClass("ui-state-disabled") || o.hasClass("ui-tabs-loading") || this.running || a && !i.collapsible || this._trigger("beforeActivate", e, c) === !1 || (i.active = r ? !1 : this.tabs.index(o), this.active = a ? t() : o, this.xhr && this.xhr.abort(), l.length || h.length || t.error("jQuery UI Tabs: Mismatching fragment identifier."), h.length && this.load(this.tabs.index(o), e), this._toggle(e, c));}, _toggle: function (e, i) {function s() {o.running = !1, o._trigger("activate", e, i);} function n() {o._addClass(i.newTab.closest("li"), "ui-tabs-active", "ui-state-active"), a.length && o.options.show ? o._show(a, o.options.show, s) : (a.show(), s());} var o = this, a = i.newPanel, r = i.oldPanel;this.running = !0, r.length && this.options.hide ? this._hide(r, this.options.hide, function () {o._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), n();}) : (this._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), r.hide(), n()), r.attr("aria-hidden", "true"), i.oldTab.attr({ "aria-selected": "false", "aria-expanded": "false" }), a.length && r.length ? i.oldTab.attr("tabIndex", -1) : a.length && this.tabs.filter(function () {return 0 === t(this).attr("tabIndex");}).attr("tabIndex", -1), a.attr("aria-hidden", "false"), i.newTab.attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 });}, _activate: function (e) {var i, s = this._findActive(e);s[0] !== this.active[0] && (s.length || (s = this.active), i = s.find(".ui-tabs-anchor")[0], this._eventHandler({ target: i, currentTarget: i, preventDefault: t.noop }));}, _findActive: function (e) {return e === !1 ? t() : this.tabs.eq(e);}, _getIndex: function (e) {return "string" === typeof e && (e = this.anchors.index(this.anchors.filter("[href$='" + t.ui.escapeSelector(e) + "']"))), e;}, _destroy: function () {this.xhr && this.xhr.abort(), this.tablist.removeAttr("role").off(this.eventNamespace), this.anchors.removeAttr("role tabIndex").removeUniqueId(), this.tabs.add(this.panels).each(function () {t.data(this, "ui-tabs-destroy") ? t(this).remove() : t(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded");}), this.tabs.each(function () {var e = t(this), i = e.data("ui-tabs-aria-controls");i ? e.attr("aria-controls", i).removeData("ui-tabs-aria-controls") : e.removeAttr("aria-controls");}), this.panels.show(), "content" !== this.options.heightStyle && this.panels.css("height", "");}, enable: function (e) {var i = this.options.disabled;i !== !1 && (void 0 === e ? i = !1 : (e = this._getIndex(e), i = t.isArray(i) ? t.map(i, function (t) {return t !== e ? t : null;}) : t.map(this.tabs, function (t, i) {return i !== e ? i : null;})), this._setOptionDisabled(i));}, disable: function (e) {var i = this.options.disabled;if (i !== !0) {if (void 0 === e)i = !0;else {if (e = this._getIndex(e), -1 !== t.inArray(e, i)) return;i = t.isArray(i) ? t.merge([e], i).sort() : [e];} this._setOptionDisabled(i);}}, load: function (e, i) {e = this._getIndex(e);var s = this, n = this.tabs.eq(e), o = n.find(".ui-tabs-anchor"), a = this._getPanelForTab(n), r = { tab: n, panel: a }, h = function (t, e) {"abort" === e && s.panels.stop(!1, !0), s._removeClass(n, "ui-tabs-loading"), a.removeAttr("aria-busy"), t === s.xhr && delete s.xhr;};this._isLocal(o[0]) || (this.xhr = t.ajax(this._ajaxSettings(o, i, r)), this.xhr && "canceled" !== this.xhr.statusText && (this._addClass(n, "ui-tabs-loading"), a.attr("aria-busy", "true"), this.xhr.done(function (t, e, n) {setTimeout(function () {a.html(t), s._trigger("load", i, r), h(n, e);}, 1);}).fail(function (t, e) {setTimeout(function () {h(t, e);}, 1);})));}, _ajaxSettings: function (e, i, s) {var n = this;return { url: e.attr("href").replace(/#.*$/, ""), beforeSend: function (e, o) {return n._trigger("beforeLoad", i, t.extend({ jqXHR: e, ajaxSettings: o }, s));} };}, _getPanelForTab: function (e) {var i = t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#" + i));} }), t.uiBackCompat !== !1 && t.widget("ui.tabs", t.ui.tabs, { _processTabs: function () {this._superApply(arguments), this._addClass(this.tabs, "ui-tab");} }), t.ui.tabs, t.widget("ui.tooltip", { version: "1.12.1", options: { classes: { "ui-tooltip": "ui-corner-all ui-widget-shadow" }, content: function () {var e = t(this).attr("title") || "";return t("<a>").text(e).html();}, hide: !0, items: "[title]:not([disabled])", position: { my: "left top+15", at: "left bottom", collision: "flipfit flip" }, show: !0, track: !1, close: null, open: null }, _addDescribedBy: function (e, i) {var s = (e.attr("aria-describedby") || "").split(/\s+/);s.push(i), e.data("ui-tooltip-id", i).attr("aria-describedby", t.trim(s.join(" ")));}, _removeDescribedBy: function (e) {var i = e.data("ui-tooltip-id"), s = (e.attr("aria-describedby") || "").split(/\s+/), n = t.inArray(i, s);-1 !== n && s.splice(n, 1), e.removeData("ui-tooltip-id"), s = t.trim(s.join(" ")), s ? e.attr("aria-describedby", s) : e.removeAttr("aria-describedby");}, _create: function () {this._on({ mouseover: "open", focusin: "open" }), this.tooltips = {}, this.parents = {}, this.liveRegion = t("<div>").attr({ role: "log", "aria-live": "assertive", "aria-relevant": "additions" }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this.disabledTitles = t([]);}, _setOption: function (e, i) {var s = this;this._super(e, i), "content" === e && t.each(this.tooltips, function (t, e) {s._updateContent(e.element);});}, _setOptionDisabled: function (t) {this[t ? "_disable" : "_enable"]();}, _disable: function () {var e = this;t.each(this.tooltips, function (i, s) {var n = t.Event("blur");n.target = n.currentTarget = s.element[0], e.close(n, !0);}), this.disabledTitles = this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function () {var e = t(this);return e.is("[title]") ? e.data("ui-tooltip-title", e.attr("title")).removeAttr("title") : void 0;}));}, _enable: function () {this.disabledTitles.each(function () {var e = t(this);e.data("ui-tooltip-title") && e.attr("title", e.data("ui-tooltip-title"));}), this.disabledTitles = t([]);}, open: function (e) {var i = this, s = t(e ? e.target : this.element).closest(this.options.items);s.length && !s.data("ui-tooltip-id") && (s.attr("title") && s.data("ui-tooltip-title", s.attr("title")), s.data("ui-tooltip-open", !0), e && "mouseover" === e.type && s.parents().each(function () {var e, s = t(this);s.data("ui-tooltip-open") && (e = t.Event("blur"), e.target = e.currentTarget = this, i.close(e, !0)), s.attr("title") && (s.uniqueId(), i.parents[this.id] = { element: this, title: s.attr("title") }, s.attr("title", ""));}), this._registerCloseHandlers(e, s), this._updateContent(s, e));}, _updateContent: function (t, e) {var i, s = this.options.content, n = this, o = e ? e.type : null;return "string" === typeof s || s.nodeType || s.jquery ? this._open(e, t, s) : (i = s.call(t[0], function (i) {n._delay(function () {t.data("ui-tooltip-open") && (e && (e.type = o), this._open(e, t, i));});}), i && this._open(e, t, i), void 0);}, _open: function (e, i, s) {function n(t) {l.of = t, a.is(":hidden") || a.position(l);} var o, a, r, h, l = t.extend({}, this.options.position);if (s) {if (o = this._find(i)) return o.tooltip.find(".ui-tooltip-content").html(s), void 0;i.is("[title]") && (e && "mouseover" === e.type ? i.attr("title", "") : i.removeAttr("title")), o = this._tooltip(i), a = o.tooltip, this._addDescribedBy(i, a.attr("id")), a.find(".ui-tooltip-content").html(s), this.liveRegion.children().hide(), h = t("<div>").html(a.find(".ui-tooltip-content").html()), h.removeAttr("name").find("[name]").removeAttr("name"), h.removeAttr("id").find("[id]").removeAttr("id"), h.appendTo(this.liveRegion), this.options.track && e && /^mouse/.test(e.type) ? (this._on(this.document, { mousemove: n }), n(e)) : a.position(t.extend({ of: i }, this.options.position)), a.hide(), this._show(a, this.options.show), this.options.track && this.options.show && this.options.show.delay && (r = this.delayedShow = setInterval(function () {a.is(":visible") && (n(l.of), clearInterval(r));}, t.fx.interval)), this._trigger("open", e, { tooltip: a });}}, _registerCloseHandlers: function (e, i) {var s = { keyup: function (e) {if (e.keyCode === t.ui.keyCode.ESCAPE) {var s = t.Event(e);s.currentTarget = i[0], this.close(s, !0);}} };i[0] !== this.element[0] && (s.remove = function () {this._removeTooltip(this._find(i).tooltip);}), e && "mouseover" !== e.type || (s.mouseleave = "close"), e && "focusin" !== e.type || (s.focusout = "close"), this._on(!0, i, s);}, close: function (e) {var i, s = this, n = t(e ? e.currentTarget : this.element), o = this._find(n);return o ? (i = o.tooltip, o.closing || (clearInterval(this.delayedShow), n.data("ui-tooltip-title") && !n.attr("title") && n.attr("title", n.data("ui-tooltip-title")), this._removeDescribedBy(n), o.hiding = !0, i.stop(!0), this._hide(i, this.options.hide, function () {s._removeTooltip(t(this));}), n.removeData("ui-tooltip-open"), this._off(n, "mouseleave focusout keyup"), n[0] !== this.element[0] && this._off(n, "remove"), this._off(this.document, "mousemove"), e && "mouseleave" === e.type && t.each(this.parents, function (e, i) {t(i.element).attr("title", i.title), delete s.parents[e];}), o.closing = !0, this._trigger("close", e, { tooltip: i }), o.hiding || (o.closing = !1)), void 0) : (n.removeData("ui-tooltip-open"), void 0);}, _tooltip: function (e) {var i = t("<div>").attr("role", "tooltip"), s = t("<div>").appendTo(i), n = i.uniqueId().attr("id");return this._addClass(s, "ui-tooltip-content"), this._addClass(i, "ui-tooltip", "ui-widget ui-widget-content"), i.appendTo(this._appendTo(e)), this.tooltips[n] = { element: e, tooltip: i };}, _find: function (t) {var e = t.data("ui-tooltip-id");return e ? this.tooltips[e] : null;}, _removeTooltip: function (t) {t.remove(), delete this.tooltips[t.attr("id")];}, _appendTo: function (t) {var e = t.closest(".ui-front, dialog");return e.length || (e = this.document[0].body), e;}, _destroy: function () {var e = this;t.each(this.tooltips, function (i, s) {var n = t.Event("blur"), o = s.element;n.target = n.currentTarget = o[0], e.close(n, !0), t("#" + i).remove(), o.data("ui-tooltip-title") && (o.attr("title") || o.attr("title", o.data("ui-tooltip-title")), o.removeData("ui-tooltip-title"));}), this.liveRegion.remove();} }), t.uiBackCompat !== !1 && t.widget("ui.tooltip", t.ui.tooltip, { options: { tooltipClass: null }, _tooltip: function () {var t = this._superApply(arguments);return this.options.tooltipClass && t.tooltip.addClass(this.options.tooltipClass), t;} }), t.ui.tooltip;});

/* !
 * Bootstrap v3.2.0 (http://getbootstrap.com)
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

if (typeof jQuery === "undefined") { throw new Error("Bootstrap's JavaScript requires jQuery"); }

/* ========================================================================
 * Bootstrap: transition.js v3.2.0
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement("bootstrap");

    var transEndEventNames = {
      WebkitTransition: "webkitTransitionEnd",
      MozTransition: "transitionend",
      OTransition: "oTransitionEnd otransitionend",
      transition: "transitionend"
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] };
      }
    }

    return false; // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false;
    var $el = this;
    $(this).one("bsTransitionEnd", function () { called = true; });
    var callback = function () { if (!called) $($el).trigger($.support.transition.end); };
    setTimeout(callback, duration);
    return this;
  };

  $(function () {
    $.support.transition = transitionEnd();

    if (!$.support.transition) return;

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
      }
    };
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.2.0
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = "[data-dismiss=\"alert\"]";
  var Alert = function (el) {
    $(el).on("click", dismiss, this.close);
  };

  Alert.VERSION = "3.2.0";

  Alert.prototype.close = function (e) {
    var $this = $(this);
    var selector = $this.attr("data-target");

    if (!selector) {
      selector = $this.attr("href");
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
    }

    var $parent = $(selector);

    if (e) e.preventDefault();

    if (!$parent.length) {
      $parent = $this.hasClass("alert") ? $this : $this.parent();
    }

    $parent.trigger(e = $.Event("close.bs.alert"));

    if (e.isDefaultPrevented()) return;

    $parent.removeClass("in");

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger("closed.bs.alert").remove();
    }

    $.support.transition && $parent.hasClass("fade") ?
      $parent
        .one("bsTransitionEnd", removeElement)
        .emulateTransitionEnd(150) :
      removeElement();
  };

  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.alert");

      if (!data) $this.data("bs.alert", (data = new Alert(this)));
      if (typeof option === "string") data[option].call($this);
    });
  }

  var old = $.fn.alert;

  $.fn.alert = Plugin;
  $.fn.alert.Constructor = Alert;

  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old;
    return this;
  };

  // ALERT DATA-API
  // ==============

  $(document).on("click.bs.alert.data-api", dismiss, Alert.prototype.close);

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.2.0
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Button.DEFAULTS, options);
    this.isLoading = false;
  };

  Button.VERSION = "3.2.0";

  Button.DEFAULTS = {
    loadingText: "loading..."
  };

  Button.prototype.setState = function (state) {
    var d = "disabled";
    var $el = this.$element;
    var val = $el.is("input") ? "val" : "html";
    var data = $el.data();

    state = state + "Text";

    if (data.resetText == null) $el.data("resetText", $el[val]());

    $el[val](data[state] == null ? this.options[state] : data[state]);

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      if (state == "loadingText") {
        this.isLoading = true;
        $el.addClass(d).attr(d, d);
      } else if (this.isLoading) {
        this.isLoading = false;
        $el.removeClass(d).removeAttr(d);
      }
    }, this), 0);
  };

  Button.prototype.toggle = function () {
    var changed = true;
    var $parent = this.$element.closest("[data-toggle=\"buttons\"]");

    if ($parent.length) {
      var $input = this.$element.find("input");
      if ($input.prop("type") == "radio") {
        if ($input.prop("checked") && this.$element.hasClass("active")) changed = false;
        else $parent.find(".active").removeClass("active");
      }
      if (changed) $input.prop("checked", !this.$element.hasClass("active")).trigger("change");
    }

    if (changed) this.$element.toggleClass("active");
  };

  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.button");
      var options = typeof option === "object" && option;

      if (!data) $this.data("bs.button", (data = new Button(this, options)));

      if (option == "toggle") data.toggle();
      else if (option) data.setState(option);
    });
  }

  var old = $.fn.button;

  $.fn.button = Plugin;
  $.fn.button.Constructor = Button;

  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old;
    return this;
  };

  // BUTTON DATA-API
  // ===============

  $(document).on("click.bs.button.data-api", "[data-toggle^=\"button\"]", function (e) {
    var $btn = $(e.target);
    if (!$btn.hasClass("btn")) $btn = $btn.closest(".btn");
    Plugin.call($btn, "toggle");
    e.preventDefault();
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.2.0
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element = $(element).on("keydown.bs.carousel", $.proxy(this.keydown, this));
    this.$indicators = this.$element.find(".carousel-indicators");
    this.options = options;
    this.paused =
    this.sliding =
    this.interval =
    this.$active =
    this.$items = null;

    this.options.pause == "hover" && this.$element
      .on("mouseenter.bs.carousel", $.proxy(this.pause, this))
      .on("mouseleave.bs.carousel", $.proxy(this.cycle, this));
  };

  Carousel.VERSION = "3.2.0";

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: "hover",
    wrap: true
  };

  Carousel.prototype.keydown = function (e) {
    switch (e.which) {
      case 37: this.prev(); break;
      case 39: this.next(); break;
      default: return;
    }

    e.preventDefault();
  };

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false);

    this.interval && clearInterval(this.interval);

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));

    return this;
  };

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children(".item");
    return this.$items.index(item || this.$active);
  };

  Carousel.prototype.to = function (pos) {
    var that = this;
    var activeIndex = this.getItemIndex(this.$active = this.$element.find(".item.active"));

    if (pos > (this.$items.length - 1) || pos < 0) return;

    if (this.sliding) return this.$element.one("slid.bs.carousel", function () { that.to(pos); }); // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle();

    return this.slide(pos > activeIndex ? "next" : "prev", $(this.$items[pos]));
  };

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true);

    if (this.$element.find(".next, .prev").length && $.support.transition) {
      this.$element.trigger($.support.transition.end);
      this.cycle(true);
    }

    this.interval = clearInterval(this.interval);

    return this;
  };

  Carousel.prototype.next = function () {
    if (this.sliding) return;
    return this.slide("next");
  };

  Carousel.prototype.prev = function () {
    if (this.sliding) return;
    return this.slide("prev");
  };

  Carousel.prototype.slide = function (type, next) {
    var $active = this.$element.find(".item.active");
    var $next = next || $active[type]();
    var isCycling = this.interval;
    var direction = type == "next" ? "left" : "right";
    var fallback = type == "next" ? "first" : "last";
    var that = this;

    if (!$next.length) {
      if (!this.options.wrap) return;
      $next = this.$element.find(".item")[fallback]();
    }

    if ($next.hasClass("active")) return (this.sliding = false);

    var relatedTarget = $next[0];
    var slideEvent = $.Event("slide.bs.carousel", {
      relatedTarget: relatedTarget,
      direction: direction
    });
    this.$element.trigger(slideEvent);
    if (slideEvent.isDefaultPrevented()) return;

    this.sliding = true;

    isCycling && this.pause();

    if (this.$indicators.length) {
      this.$indicators.find(".active").removeClass("active");
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
      $nextIndicator && $nextIndicator.addClass("active");
    }

    var slidEvent = $.Event("slid.bs.carousel", { relatedTarget: relatedTarget, direction: direction }); // yes, "slid"
    if ($.support.transition && this.$element.hasClass("slide")) {
      $next.addClass(type);
      $next[0].offsetWidth; // force reflow
      $active.addClass(direction);
      $next.addClass(direction);
      $active
        .one("bsTransitionEnd", function () {
          $next.removeClass([type, direction].join(" ")).addClass("active");
          $active.removeClass(["active", direction].join(" "));
          that.sliding = false;
          setTimeout(function () {
            that.$element.trigger(slidEvent);
          }, 0);
        })
        .emulateTransitionEnd($active.css("transition-duration").slice(0, -1) * 1000);
    } else {
      $active.removeClass("active");
      $next.addClass("active");
      this.sliding = false;
      this.$element.trigger(slidEvent);
    }

    isCycling && this.cycle();

    return this;
  };

  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.carousel");
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option === "object" && option);
      var action = typeof option === "string" ? option : options.slide;

      if (!data) $this.data("bs.carousel", (data = new Carousel(this, options)));
      if (typeof option === "number") data.to(option);
      else if (action) data[action]();
      else if (options.interval) data.pause().cycle();
    });
  }

  var old = $.fn.carousel;

  $.fn.carousel = Plugin;
  $.fn.carousel.Constructor = Carousel;

  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old;
    return this;
  };

  // CAROUSEL DATA-API
  // =================

  $(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", function (e) {
    var href;
    var $this = $(this);
    var $target = $($this.attr("data-target") || (href = $this.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, "")); // strip for ie7
    if (!$target.hasClass("carousel")) return;
    var options = $.extend({}, $target.data(), $this.data());
    var slideIndex = $this.attr("data-slide-to");
    if (slideIndex) options.interval = false;

    Plugin.call($target, options);

    if (slideIndex) {
      $target.data("bs.carousel").to(slideIndex);
    }

    e.preventDefault();
  });

  $(window).on("load", function () {
    $("[data-ride=\"carousel\"]").each(function () {
      var $carousel = $(this);
      Plugin.call($carousel, $carousel.data());
    });
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.2.0
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Collapse.DEFAULTS, options);
    this.transitioning = null;

    if (this.options.parent) this.$parent = $(this.options.parent);
    if (this.options.toggle) this.toggle();
  };

  Collapse.VERSION = "3.2.0";

  Collapse.DEFAULTS = {
    toggle: true
  };

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass("width");
    return hasWidth ? "width" : "height";
  };

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass("in")) return;

    var startEvent = $.Event("show.bs.collapse");
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    var actives = this.$parent && this.$parent.find("> .panel > .in");

    if (actives && actives.length) {
      var hasData = actives.data("bs.collapse");
      if (hasData && hasData.transitioning) return;
      Plugin.call(actives, "hide");
      hasData || actives.data("bs.collapse", null);
    }

    var dimension = this.dimension();

    this.$element
      .removeClass("collapse")
      .addClass("collapsing")[dimension](0);

    this.transitioning = 1;

    var complete = function () {
      this.$element
        .removeClass("collapsing")
        .addClass("collapse in")[dimension]("");
      this.transitioning = 0;
      this.$element
        .trigger("shown.bs.collapse");
    };

    if (!$.support.transition) return complete.call(this);

    var scrollSize = $.camelCase(["scroll", dimension].join("-"));

    this.$element
      .one("bsTransitionEnd", $.proxy(complete, this))
      .emulateTransitionEnd(350)[dimension](this.$element[0][scrollSize]);
  };

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass("in")) return;

    var startEvent = $.Event("hide.bs.collapse");
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    var dimension = this.dimension();

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;

    this.$element
      .addClass("collapsing")
      .removeClass("collapse")
      .removeClass("in");

    this.transitioning = 1;

    var complete = function () {
      this.transitioning = 0;
      this.$element
        .trigger("hidden.bs.collapse")
        .removeClass("collapsing")
        .addClass("collapse");
    };

    if (!$.support.transition) return complete.call(this);

    this.$element
      [dimension](0)
      .one("bsTransitionEnd", $.proxy(complete, this))
      .emulateTransitionEnd(350);
  };

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  };

  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.collapse");
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option === "object" && option);

      if (!data && options.toggle && option == "show") option = !option;
      if (!data) $this.data("bs.collapse", (data = new Collapse(this, options)));
      if (typeof option === "string") data[option]();
    });
  }

  var old = $.fn.collapse;

  $.fn.collapse = Plugin;
  $.fn.collapse.Constructor = Collapse;

  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  };

  // COLLAPSE DATA-API
  // =================

  $(document).on("click.bs.collapse.data-api", "[data-toggle=\"collapse\"]", function (e) {
    var href;
    var $this = $(this);
    var target = $this.attr("data-target")
        || e.preventDefault()
        || (href = $this.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, ""); // strip for ie7
    var $target = $(target);
    var data = $target.data("bs.collapse");
    var option = data ? "toggle" : $this.data();
    var parent = $this.attr("data-parent");
    var $parent = parent && $(parent);

    if (!data || !data.transitioning) {
      if ($parent) $parent.find("[data-toggle=\"collapse\"][data-parent=\"" + parent + "\"]").not($this).addClass("collapsed");
      $this[$target.hasClass("in") ? "addClass" : "removeClass"]("collapsed");
    }

    Plugin.call($target, option);
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.2.0
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = ".dropdown-backdrop";
  var toggle = "[data-toggle=\"dropdown\"]";
  var Dropdown = function (element) {
    $(element).on("click.bs.dropdown", this.toggle);
  };

  Dropdown.VERSION = "3.2.0";

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this);

    if ($this.is(".disabled, :disabled")) return;

    var $parent = getParent($this);
    var isActive = $parent.hasClass("open");

    clearMenus();

    if (!isActive) {
      if ("ontouchstart" in document.documentElement && !$parent.closest(".navbar-nav").length) {
        // if mobile we use a backdrop because click events don't delegate
        $("<div class=\"dropdown-backdrop\"/>").insertAfter($(this)).on("click", clearMenus);
      }

      var relatedTarget = { relatedTarget: this };
      $parent.trigger(e = $.Event("show.bs.dropdown", relatedTarget));

      if (e.isDefaultPrevented()) return;

      $this.trigger("focus");

      $parent
        .toggleClass("open")
        .trigger("shown.bs.dropdown", relatedTarget);
    }

    return false;
  };

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27)/.test(e.keyCode)) return;

    var $this = $(this);

    e.preventDefault();
    e.stopPropagation();

    if ($this.is(".disabled, :disabled")) return;

    var $parent = getParent($this);
    var isActive = $parent.hasClass("open");

    if (!isActive || (isActive && e.keyCode == 27)) {
      if (e.which == 27) $parent.find(toggle).trigger("focus");
      return $this.trigger("click");
    }

    var desc = " li:not(.divider):visible a";
    var $items = $parent.find("[role=\"menu\"]" + desc + ", [role=\"listbox\"]" + desc);

    if (!$items.length) return;

    var index = $items.index($items.filter(":focus"));

    if (e.keyCode == 38 && index > 0) index--; // up
    if (e.keyCode == 40 && index < $items.length - 1) index++; // down
    if (!~index) index = 0;

    $items.eq(index).trigger("focus");
  };

  function clearMenus(e) {
    if (e && e.which === 3) return;
    $(backdrop).remove();
    $(toggle).each(function () {
      var $parent = getParent($(this));
      var relatedTarget = { relatedTarget: this };
      if (!$parent.hasClass("open")) return;
      $parent.trigger(e = $.Event("hide.bs.dropdown", relatedTarget));
      if (e.isDefaultPrevented()) return;
      $parent.removeClass("open").trigger("hidden.bs.dropdown", relatedTarget);
    });
  }

  function getParent($this) {
    var selector = $this.attr("data-target");

    if (!selector) {
      selector = $this.attr("href");
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
    }

    var $parent = selector && $(selector);

    return $parent && $parent.length ? $parent : $this.parent();
  }

  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.dropdown");

      if (!data) $this.data("bs.dropdown", (data = new Dropdown(this)));
      if (typeof option === "string") data[option].call($this);
    });
  }

  var old = $.fn.dropdown;

  $.fn.dropdown = Plugin;
  $.fn.dropdown.Constructor = Dropdown;

  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old;
    return this;
  };

  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on("click.bs.dropdown.data-api", clearMenus)
    .on("click.bs.dropdown.data-api", ".dropdown form", function (e) { e.stopPropagation(); })
    .on("click.bs.dropdown.data-api", toggle, Dropdown.prototype.toggle)
    .on("keydown.bs.dropdown.data-api", toggle + ", [role=\"menu\"], [role=\"listbox\"]", Dropdown.prototype.keydown);

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.2.0
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options;
    this.$body = $(document.body);
    this.$element = $(element);
    this.$backdrop =
    this.isShown = null;
    this.scrollbarWidth = 0;

    if (this.options.remote) {
      this.$element
        .find(".modal-content")
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger("loaded.bs.modal");
        }, this));
    }
  };

  Modal.VERSION = "3.2.0";

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  };

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget);
  };

  Modal.prototype.show = function (_relatedTarget) {
    var that = this;
    var e = $.Event("show.bs.modal", { relatedTarget: _relatedTarget });

    this.$element.trigger(e);

    if (this.isShown || e.isDefaultPrevented()) return;

    this.isShown = true;

    this.checkScrollbar();
    this.$body.addClass("modal-open");

    this.setScrollbar();
    this.escape();

    this.$element.on("click.dismiss.bs.modal", "[data-dismiss=\"modal\"]", $.proxy(this.hide, this));

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass("fade");

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body); // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0);

      if (transition) {
        that.$element[0].offsetWidth; // force reflow
      }

      that.$element
        .addClass("in")
        .attr("aria-hidden", false);

      that.enforceFocus();

      var e = $.Event("shown.bs.modal", { relatedTarget: _relatedTarget });

      transition ?
        that.$element.find(".modal-dialog") // wait for modal to slide in
          .one("bsTransitionEnd", function () {
            that.$element.trigger("focus").trigger(e);
          })
          .emulateTransitionEnd(300) :
        that.$element.trigger("focus").trigger(e);
    });
  };

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault();

    e = $.Event("hide.bs.modal");

    this.$element.trigger(e);

    if (!this.isShown || e.isDefaultPrevented()) return;

    this.isShown = false;

    this.$body.removeClass("modal-open");

    this.resetScrollbar();
    this.escape();

    $(document).off("focusin.bs.modal");

    this.$element
      .removeClass("in")
      .attr("aria-hidden", true)
      .off("click.dismiss.bs.modal");

    $.support.transition && this.$element.hasClass("fade") ?
      this.$element
        .one("bsTransitionEnd", $.proxy(this.hideModal, this))
        .emulateTransitionEnd(300) :
      this.hideModal();
  };

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off("focusin.bs.modal") // guard against infinite focus loop
      .on("focusin.bs.modal", $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger("focus");
        }
      }, this));
  };

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on("keyup.dismiss.bs.modal", $.proxy(function (e) {
        e.which == 27 && this.hide();
      }, this));
    } else if (!this.isShown) {
      this.$element.off("keyup.dismiss.bs.modal");
    }
  };

  Modal.prototype.hideModal = function () {
    var that = this;
    this.$element.hide();
    this.backdrop(function () {
      that.$element.trigger("hidden.bs.modal");
    });
  };

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove();
    this.$backdrop = null;
  };

  Modal.prototype.backdrop = function (callback) {
    var that = this;
    var animate = this.$element.hasClass("fade") ? "fade" : "";

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate;

      this.$backdrop = $("<div class=\"modal-backdrop " + animate + "\" />")
        .appendTo(this.$body);

      this.$element.on("click.dismiss.bs.modal", $.proxy(function (e) {
        if (e.target !== e.currentTarget) return;
        this.options.backdrop == "static"
          ? this.$element[0].focus.call(this.$element[0])
          : this.hide.call(this);
      }, this));

      if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

      this.$backdrop.addClass("in");

      if (!callback) return;

      doAnimate ?
        this.$backdrop
          .one("bsTransitionEnd", callback)
          .emulateTransitionEnd(150) :
        callback();

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass("in");

      var callbackRemove = function () {
        that.removeBackdrop();
        callback && callback();
      };
      $.support.transition && this.$element.hasClass("fade") ?
        this.$backdrop
          .one("bsTransitionEnd", callbackRemove)
          .emulateTransitionEnd(150) :
        callbackRemove();

    } else if (callback) {
      callback();
    }
  };

  Modal.prototype.checkScrollbar = function () {
    if (document.body.clientWidth >= window.innerWidth) return;
    this.scrollbarWidth = this.scrollbarWidth || this.measureScrollbar();
  };

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css("padding-right") || 0), 10);
    if (this.scrollbarWidth) this.$body.css("padding-right", bodyPad + this.scrollbarWidth);
  };

  Modal.prototype.resetScrollbar = function () {
    this.$body.css("padding-right", "");
  };

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    this.$body.append(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    this.$body[0].removeChild(scrollDiv);
    return scrollbarWidth;
  };

  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.modal");
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option === "object" && option);

      if (!data) $this.data("bs.modal", (data = new Modal(this, options)));
      if (typeof option === "string") data[option](_relatedTarget);
      else if (options.show) data.show(_relatedTarget);
    });
  }

  var old = $.fn.modal;

  $.fn.modal = Plugin;
  $.fn.modal.Constructor = Modal;

  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old;
    return this;
  };

  // MODAL DATA-API
  // ==============

  $(document).on("click.bs.modal.data-api", "[data-toggle=\"modal\"]", function (e) {
    var $this = $(this);
    var href = $this.attr("href");
    var $target = $($this.attr("data-target") || (href && href.replace(/.*(?=#[^\s]+$)/, ""))); // strip for ie7
    var option = $target.data("bs.modal") ? "toggle" : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

    if ($this.is("a")) e.preventDefault();

    $target.one("show.bs.modal", function (showEvent) {
      if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
      $target.one("hidden.bs.modal", function () {
        $this.is(":visible") && $this.trigger("focus");
      });
    });
    Plugin.call($target, option, this);
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.2.0
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type =
    this.options =
    this.enabled =
    this.timeout =
    this.hoverState =
    this.$element = null;

    this.init("tooltip", element, options);
  };

  Tooltip.VERSION = "3.2.0";

  Tooltip.DEFAULTS = {
    animation: true,
    placement: "top",
    selector: false,
    template: "<div class=\"tooltip\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>",
    trigger: "hover focus",
    title: "",
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: "body",
      padding: 0
    }
  };

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled = true;
    this.type = type;
    this.$element = $(element);
    this.options = this.getOptions(options);
    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport);

    var triggers = this.options.trigger.split(" ");

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i];

      if (trigger == "click") {
        this.$element.on("click." + this.type, this.options.selector, $.proxy(this.toggle, this));
      } else if (trigger != "manual") {
        var eventIn = trigger == "hover" ? "mouseenter" : "focusin";
        var eventOut = trigger == "hover" ? "mouseleave" : "focusout";

        this.$element.on(eventIn + "." + this.type, this.options.selector, $.proxy(this.enter, this));
        this.$element.on(eventOut + "." + this.type, this.options.selector, $.proxy(this.leave, this));
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: "manual", selector: "" })) :
      this.fixTitle();
  };

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS;
  };

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options);

    if (options.delay && typeof options.delay === "number") {
      options.delay = {
        show: options.delay,
        hide: options.delay
      };
    }

    return options;
  };

  Tooltip.prototype.getDelegateOptions = function () {
    var options = {};
    var defaults = this.getDefaults();

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value;
    });

    return options;
  };

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data("bs." + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data("bs." + this.type, self);
    }

    clearTimeout(self.timeout);

    self.hoverState = "in";

    if (!self.options.delay || !self.options.delay.show) return self.show();

    self.timeout = setTimeout(function () {
      if (self.hoverState == "in") self.show();
    }, self.options.delay.show);
  };

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data("bs." + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data("bs." + this.type, self);
    }

    clearTimeout(self.timeout);

    self.hoverState = "out";

    if (!self.options.delay || !self.options.delay.hide) return self.hide();

    self.timeout = setTimeout(function () {
      if (self.hoverState == "out") self.hide();
    }, self.options.delay.hide);
  };

  Tooltip.prototype.show = function () {
    var e = $.Event("show.bs." + this.type);

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e);

      var inDom = $.contains(document.documentElement, this.$element[0]);
      if (e.isDefaultPrevented() || !inDom) return;
      var that = this;

      var $tip = this.tip();

      var tipId = this.getUID(this.type);

      this.setContent();
      $tip.attr("id", tipId);
      this.$element.attr("aria-describedby", tipId);

      if (this.options.animation) $tip.addClass("fade");

      var placement = typeof this.options.placement === "function" ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement;

      var autoToken = /\s?auto?\s?/i;
      var autoPlace = autoToken.test(placement);
      if (autoPlace) placement = placement.replace(autoToken, "") || "top";

      $tip
        .detach()
        .css({ top: 0, left: 0, display: "block" })
        .addClass(placement)
        .data("bs." + this.type, this);

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);

      var pos = this.getPosition();
      var actualWidth = $tip[0].offsetWidth;
      var actualHeight = $tip[0].offsetHeight;

      if (autoPlace) {
        var orgPlacement = placement;
        var $parent = this.$element.parent();
        var parentDim = this.getPosition($parent);

        placement = placement == "bottom" && pos.top + pos.height + actualHeight - parentDim.scroll > parentDim.height ? "top" :
          placement == "top" && pos.top - parentDim.scroll - actualHeight < 0 ? "bottom" :
            placement == "right" && pos.right + actualWidth > parentDim.width ? "left" :
              placement == "left" && pos.left - actualWidth < parentDim.left ? "right" :
                placement;

        $tip
          .removeClass(orgPlacement)
          .addClass(placement);
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

      this.applyPlacement(calculatedOffset, placement);

      var complete = function () {
        that.$element.trigger("shown.bs." + that.type);
        that.hoverState = null;
      };

      $.support.transition && this.$tip.hasClass("fade") ?
        $tip
          .one("bsTransitionEnd", complete)
          .emulateTransitionEnd(150) :
        complete();
    }
  };

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip = this.tip();
    var width = $tip[0].offsetWidth;
    var height = $tip[0].offsetHeight;

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css("margin-top"), 10);
    var marginLeft = parseInt($tip.css("margin-left"), 10);

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop)) marginTop = 0;
    if (isNaN(marginLeft)) marginLeft = 0;

    offset.top = offset.top + marginTop;
    offset.left = offset.left + marginLeft;

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        });
      }
    }, offset), 0);

    $tip.addClass("in");

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth = $tip[0].offsetWidth;
    var actualHeight = $tip[0].offsetHeight;

    if (placement == "top" && actualHeight != height) {
      offset.top = offset.top + height - actualHeight;
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

    if (delta.left) offset.left += delta.left;
    else offset.top += delta.top;

    var arrowDelta = delta.left ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
    var arrowPosition = delta.left ? "left" : "top";
    var arrowOffsetPosition = delta.left ? "offsetWidth" : "offsetHeight";

    $tip.offset(offset);
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], arrowPosition);
  };

  Tooltip.prototype.replaceArrow = function (delta, dimension, position) {
    this.arrow().css(position, delta ? (50 * (1 - delta / dimension) + "%") : "");
  };

  Tooltip.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();

    $tip.find(".tooltip-inner")[this.options.html ? "html" : "text"](title);
    $tip.removeClass("fade in top bottom left right");
  };

  Tooltip.prototype.hide = function () {
    var that = this;
    var $tip = this.tip();
    var e = $.Event("hide.bs." + this.type);

    this.$element.removeAttr("aria-describedby");

    function complete() {
      if (that.hoverState != "in") $tip.detach();
      that.$element.trigger("hidden.bs." + that.type);
    }

    this.$element.trigger(e);

    if (e.isDefaultPrevented()) return;

    $tip.removeClass("in");

    $.support.transition && this.$tip.hasClass("fade") ?
      $tip
        .one("bsTransitionEnd", complete)
        .emulateTransitionEnd(150) :
      complete();

    this.hoverState = null;

    return this;
  };

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element;
    if ($e.attr("title") || typeof ($e.attr("data-original-title")) !== "string") {
      $e.attr("data-original-title", $e.attr("title") || "").attr("title", "");
    }
  };

  Tooltip.prototype.hasContent = function () {
    return this.getTitle();
  };

  Tooltip.prototype.getPosition = function ($element) {
    $element = $element || this.$element;
    var el = $element[0];
    var isBody = el.tagName == "BODY";
    return $.extend({}, (typeof el.getBoundingClientRect === "function") ? el.getBoundingClientRect() : null, {
      scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop(),
      width: isBody ? $(window).width() : $element.outerWidth(),
      height: isBody ? $(window).height() : $element.outerHeight()
    }, isBody ? { top: 0, left: 0 } : $element.offset());
  };

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == "bottom" ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } :
      placement == "top" ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
        placement == "left" ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };

  };

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 };
    if (!this.$viewport) return delta;

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
    var viewportDimensions = this.getPosition(this.$viewport);

    if (/right|left/.test(placement)) {
      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset;
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
      }
    } else {
      var leftEdgeOffset = pos.left - viewportPadding;
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset;
      } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
      }
    }

    return delta;
  };

  Tooltip.prototype.getTitle = function () {
    var title;
    var $e = this.$element;
    var o = this.options;

    title = $e.attr("data-original-title")
      || (typeof o.title === "function" ? o.title.call($e[0]) : o.title);

    return title;
  };

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000);
    while (document.getElementById(prefix));
    return prefix;
  };

  Tooltip.prototype.tip = function () {
    return (this.$tip = this.$tip || $(this.options.template));
  };

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
  };

  Tooltip.prototype.validate = function () {
    if (!this.$element[0].parentNode) {
      this.hide();
      this.$element = null;
      this.options = null;
    }
  };

  Tooltip.prototype.enable = function () {
    this.enabled = true;
  };

  Tooltip.prototype.disable = function () {
    this.enabled = false;
  };

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  };

  Tooltip.prototype.toggle = function (e) {
    var self = this;
    if (e) {
      self = $(e.currentTarget).data("bs." + this.type);
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
        $(e.currentTarget).data("bs." + this.type, self);
      }
    }

    self.tip().hasClass("in") ? self.leave(self) : self.enter(self);
  };

  Tooltip.prototype.destroy = function () {
    clearTimeout(this.timeout);
    this.hide().$element.off("." + this.type).removeData("bs." + this.type);
  };

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.tooltip");
      var options = typeof option === "object" && option;

      if (!data && option == "destroy") return;
      if (!data) $this.data("bs.tooltip", (data = new Tooltip(this, options)));
      if (typeof option === "string") data[option]();
    });
  }

  var old = $.fn.tooltip;

  $.fn.tooltip = Plugin;
  $.fn.tooltip.Constructor = Tooltip;

  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.2.0
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init("popover", element, options);
  };

  if (!$.fn.tooltip) throw new Error("Popover requires tooltip.js");

  Popover.VERSION = "3.2.0";

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: "right",
    trigger: "click",
    content: "",
    template: "<div class=\"popover\" role=\"tooltip\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>"
  });

  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);

  Popover.prototype.constructor = Popover;

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS;
  };

  Popover.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();
    var content = this.getContent();

    $tip.find(".popover-title")[this.options.html ? "html" : "text"](title);
    $tip.find(".popover-content").empty()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content === "string" ? "html" : "append") : "text"
    ](content);

    $tip.removeClass("fade top bottom left right in");

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find(".popover-title").html()) $tip.find(".popover-title").hide();
  };

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  };

  Popover.prototype.getContent = function () {
    var $e = this.$element;
    var o = this.options;

    return $e.attr("data-content")
      || (typeof o.content === "function" ?
        o.content.call($e[0]) :
        o.content);
  };

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
  };

  Popover.prototype.tip = function () {
    if (!this.$tip) this.$tip = $(this.options.template);
    return this.$tip;
  };

  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.popover");
      var options = typeof option === "object" && option;

      if (!data && option == "destroy") return;
      if (!data) $this.data("bs.popover", (data = new Popover(this, options)));
      if (typeof option === "string") data[option]();
    });
  }

  var old = $.fn.popover;

  $.fn.popover = Plugin;
  $.fn.popover.Constructor = Popover;

  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old;
    return this;
  };

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.2.0
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    var process = $.proxy(this.process, this);

    this.$body = $("body");
    this.$scrollElement = $(element).is("body") ? $(window) : $(element);
    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
    this.selector = (this.options.target || "") + " .nav li > a";
    this.offsets = [];
    this.targets = [];
    this.activeTarget = null;
    this.scrollHeight = 0;

    this.$scrollElement.on("scroll.bs.scrollspy", process);
    this.refresh();
    this.process();
  }

  ScrollSpy.VERSION = "3.2.0";

  ScrollSpy.DEFAULTS = {
    offset: 10
  };

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
  };

  ScrollSpy.prototype.refresh = function () {
    var offsetMethod = "offset";
    var offsetBase = 0;

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = "position";
      offsetBase = this.$scrollElement.scrollTop();
    }

    this.offsets = [];
    this.targets = [];
    this.scrollHeight = this.getScrollHeight();

    var self = this;

    this.$body
      .find(this.selector)
      .map(function () {
        var $el = $(this);
        var href = $el.data("target") || $el.attr("href");
        var $href = /^#./.test(href) && $(href);

        return ($href
          && $href.length
          && $href.is(":visible")
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null;
      })
      .sort(function (a, b) { return a[0] - b[0]; })
      .each(function () {
        self.offsets.push(this[0]);
        self.targets.push(this[1]);
      });
  };

  ScrollSpy.prototype.process = function () {
    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
    var scrollHeight = this.getScrollHeight();
    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
    var offsets = this.offsets;
    var targets = this.targets;
    var activeTarget = this.activeTarget;
    var i;

    if (this.scrollHeight != scrollHeight) {
      this.refresh();
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
    }

    if (activeTarget && scrollTop <= offsets[0]) {
      return activeTarget != (i = targets[0]) && this.activate(i);
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (!offsets[i + 1] || scrollTop <= offsets[i + 1])
        && this.activate(targets[i]);
    }
  };

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target;

    $(this.selector)
      .parentsUntil(this.options.target, ".active")
      .removeClass("active");

    var selector = this.selector +
        "[data-target=\"" + target + "\"]," +
        this.selector + "[href=\"" + target + "\"]";

    var active = $(selector)
      .parents("li")
      .addClass("active");

    if (active.parent(".dropdown-menu").length) {
      active = active
        .closest("li.dropdown")
        .addClass("active");
    }

    active.trigger("activate.bs.scrollspy");
  };

  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.scrollspy");
      var options = typeof option === "object" && option;

      if (!data) $this.data("bs.scrollspy", (data = new ScrollSpy(this, options)));
      if (typeof option === "string") data[option]();
    });
  }

  var old = $.fn.scrollspy;

  $.fn.scrollspy = Plugin;
  $.fn.scrollspy.Constructor = ScrollSpy;

  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old;
    return this;
  };

  // SCROLLSPY DATA-API
  // ==================

  $(window).on("load.bs.scrollspy.data-api", function () {
    $("[data-spy=\"scroll\"]").each(function () {
      var $spy = $(this);
      Plugin.call($spy, $spy.data());
    });
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.2.0
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    this.element = $(element);
  };

  Tab.VERSION = "3.2.0";

  Tab.prototype.show = function () {
    var $this = this.element;
    var $ul = $this.closest("ul:not(.dropdown-menu)");
    var selector = $this.data("target");

    if (!selector) {
      selector = $this.attr("href");
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
    }

    if ($this.parent("li").hasClass("active")) return;

    var previous = $ul.find(".active:last a")[0];
    var e = $.Event("show.bs.tab", {
      relatedTarget: previous
    });

    $this.trigger(e);

    if (e.isDefaultPrevented()) return;

    var $target = $(selector);

    this.activate($this.closest("li"), $ul);
    this.activate($target, $target.parent(), function () {
      $this.trigger({
        type: "shown.bs.tab",
        relatedTarget: previous
      });
    });
  };

  Tab.prototype.activate = function (element, container, callback) {
    var $active = container.find("> .active");
    var transition = callback
      && $.support.transition
      && $active.hasClass("fade");

    function next() {
      $active
        .removeClass("active")
        .find("> .dropdown-menu > .active")
        .removeClass("active");

      element.addClass("active");

      if (transition) {
        element[0].offsetWidth; // reflow for transition
        element.addClass("in");
      } else {
        element.removeClass("fade");
      }

      if (element.parent(".dropdown-menu")) {
        element.closest("li.dropdown").addClass("active");
      }

      callback && callback();
    }

    transition ?
      $active
        .one("bsTransitionEnd", next)
        .emulateTransitionEnd(150) :
      next();

    $active.removeClass("in");
  };

  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.tab");

      if (!data) $this.data("bs.tab", (data = new Tab(this)));
      if (typeof option === "string") data[option]();
    });
  }

  var old = $.fn.tab;

  $.fn.tab = Plugin;
  $.fn.tab.Constructor = Tab;

  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old;
    return this;
  };

  // TAB DATA-API
  // ============

  $(document).on("click.bs.tab.data-api", "[data-toggle=\"tab\"], [data-toggle=\"pill\"]", function (e) {
    e.preventDefault();
    Plugin.call($(this), "show");
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.2.0
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options);

    this.$target = $(this.options.target)
      .on("scroll.bs.affix.data-api", $.proxy(this.checkPosition, this))
      .on("click.bs.affix.data-api", $.proxy(this.checkPositionWithEventLoop, this));

    this.$element = $(element);
    this.affixed =
    this.unpin =
    this.pinnedOffset = null;

    this.checkPosition();
  };

  Affix.VERSION = "3.2.0";

  Affix.RESET = "affix affix-top affix-bottom";

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  };

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;
    this.$element.removeClass(Affix.RESET).addClass("affix");
    var scrollTop = this.$target.scrollTop();
    var position = this.$element.offset();
    return (this.pinnedOffset = position.top - scrollTop);
  };

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1);
  };

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(":visible")) return;

    var scrollHeight = $(document).height();
    var scrollTop = this.$target.scrollTop();
    var position = this.$element.offset();
    var offset = this.options.offset;
    var offsetTop = offset.top;
    var offsetBottom = offset.bottom;

    if (typeof offset !== "object") offsetBottom = offsetTop = offset;
    if (typeof offsetTop === "function") offsetTop = offset.top(this.$element);
    if (typeof offsetBottom === "function") offsetBottom = offset.bottom(this.$element);

    var affix = this.unpin != null && (scrollTop + this.unpin <= position.top) ? false :
      offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ? "bottom" :
        offsetTop != null && (scrollTop <= offsetTop) ? "top" : false;

    if (this.affixed === affix) return;
    if (this.unpin != null) this.$element.css("top", "");

    var affixType = "affix" + (affix ? "-" + affix : "");
    var e = $.Event(affixType + ".bs.affix");

    this.$element.trigger(e);

    if (e.isDefaultPrevented()) return;

    this.affixed = affix;
    this.unpin = affix == "bottom" ? this.getPinnedOffset() : null;

    this.$element
      .removeClass(Affix.RESET)
      .addClass(affixType)
      .trigger($.Event(affixType.replace("affix", "affixed")));

    if (affix == "bottom") {
      this.$element.offset({
        top: scrollHeight - this.$element.height() - offsetBottom
      });
    }
  };

  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.affix");
      var options = typeof option === "object" && option;

      if (!data) $this.data("bs.affix", (data = new Affix(this, options)));
      if (typeof option === "string") data[option]();
    });
  }

  var old = $.fn.affix;

  $.fn.affix = Plugin;
  $.fn.affix.Constructor = Affix;

  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old;
    return this;
  };

  // AFFIX DATA-API
  // ==============

  $(window).on("load", function () {
    $("[data-spy=\"affix\"]").each(function () {
      var $spy = $(this);
      var data = $spy.data();

      data.offset = data.offset || {};

      if (data.offsetBottom) data.offset.bottom = data.offsetBottom;
      if (data.offsetTop) data.offset.top = data.offsetTop;

      Plugin.call($spy, data);
    });
  });

}(jQuery);

/**
 * @license AngularJS v1.6.10
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window) {"use strict";

  /* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/

  var minErrConfig = {
    objectMaxDepth: 5
  };

  /**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 */
  function errorHandlingConfig(config) {
    if (isObject(config)) {
      if (isDefined(config.objectMaxDepth)) {
        minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
      }
    } else {
      return minErrConfig;
    }
  }

  /**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */
  function isValidObjectMaxDepth(maxDepth) {
    return isNumber(maxDepth) && maxDepth > 0;
  }

  /**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

  function minErr(module, ErrorConstructor) {
    ErrorConstructor = ErrorConstructor || Error;

    var url = "https://errors.angularjs.org/1.6.10/";
    var regex = url.replace(".", "\\.") + "[\\s\\S]*";
    var errRegExp = new RegExp(regex, "g");

    return function () {
      var code = arguments[0],
        template = arguments[1],
        message = "[" + (module ? module + ":" : "") + code + "] ",
        templateArgs = sliceArgs(arguments, 2).map(function (arg) {
          return toDebugString(arg, minErrConfig.objectMaxDepth);
        }),
        paramPrefix, i;

      // A minErr message has two parts: the message itself and the url that contains the
      // encoded message.
      // The message's parameters can contain other error messages which also include error urls.
      // To prevent the messages from getting too long, we strip the error urls from the parameters.

      message += template.replace(/\{\d+\}/g, function (match) {
        var index = +match.slice(1, -1);

        if (index < templateArgs.length) {
          return templateArgs[index].replace(errRegExp, "");
        }

        return match;
      });

      message += "\n" + url + (module ? module + "/" : "") + code;

      for (i = 0, paramPrefix = "?"; i < templateArgs.length; i++, paramPrefix = "&") {
        message += paramPrefix + "p" + i + "=" + encodeURIComponent(templateArgs[i]);
      }

      return new ErrorConstructor(message);
    };
  }

  /* We need to tell ESLint what variables are being exported */
  /* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  manualLowercase,
  manualUppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

  // //////////////////////////////////

  /**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */

  var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

  // The name of a form control's ValidityState property.
  // This is used so that it's possible for internal tests to create mock ValidityStates.
  var VALIDITY_STATE_PROPERTY = "validity";

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  /**
 * @ngdoc function
 * @name angular.lowercase
 * @module ng
 * @kind function
 *
 * @deprecated
 * sinceVersion="1.5.0"
 * removeVersion="1.7.0"
 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
  var lowercase = function (string) {return isString(string) ? string.toLowerCase() : string;};

  /**
 * @ngdoc function
 * @name angular.uppercase
 * @module ng
 * @kind function
 *
 * @deprecated
 * sinceVersion="1.5.0"
 * removeVersion="1.7.0"
 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
  var uppercase = function (string) {return isString(string) ? string.toUpperCase() : string;};

  var manualLowercase = function (s) {
  /* eslint-disable no-bitwise */
    return isString(s)
      ? s.replace(/[A-Z]/g, function (ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
  /* eslint-enable */
  };
  var manualUppercase = function (s) {
  /* eslint-disable no-bitwise */
    return isString(s)
      ? s.replace(/[a-z]/g, function (ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
  /* eslint-enable */
  };

  // String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
  // locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
  // with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
  if ("i" !== "I".toLowerCase()) {
    lowercase = manualLowercase;
    uppercase = manualUppercase;
  }

  var
    msie, // holds major version number for IE, or NaN if UA is not IE.
    jqLite, // delay binding since jQuery could be loaded after us.
    jQuery, // delay binding
    slice = [].slice,
    splice = [].splice,
    push = [].push,
    toString = Object.prototype.toString,
    getPrototypeOf = Object.getPrototypeOf,
    ngMinErr = minErr("ng"),

    /** @name angular */
    angular = window.angular || (window.angular = {}),
    angularModule,
    uid = 0;

  // Support: IE 9-11 only
  /**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
  msie = window.document.documentMode;

  /**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
  function isArrayLike(obj) {

    // `null`, `undefined` and `window` are not array-like
    if (obj == null || isWindow(obj)) return false;

    // arrays, strings and jQuery/jqLite objects are array like
    // * jqLite is either the jQuery or jqLite constructor function
    // * we have to check the existence of jqLite first as this method is called
    //   via the forEach method when constructing the jqLite object in the first place
    if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

    // Support: iOS 8.2 (not reproducible in simulator)
    // "length" in obj used to prevent JIT error (gh-11508)
    var length = "length" in Object(obj) && obj.length;

    // NodeList objects (with `item` method) and
    // other objects with suitable length characteristics are array-like
    return isNumber(length) &&
    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === "function");

  }

  /**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

  function forEach(obj, iterator, context) {
    var key, length;
    if (obj) {
      if (isFunction(obj)) {
        for (key in obj) {
          if (key !== "prototype" && key !== "length" && key !== "name" && obj.hasOwnProperty(key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else if (isArray(obj) || isArrayLike(obj)) {
        var isPrimitive = typeof obj !== "object";
        for (key = 0, length = obj.length; key < length; key++) {
          if (isPrimitive || key in obj) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
      } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      } else if (typeof obj.hasOwnProperty === "function") {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
        for (key in obj) {
          if (hasOwnProperty.call(obj, key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      }
    }
    return obj;
  }

  function forEachSorted(obj, iterator, context) {
    var keys = Object.keys(obj).sort();
    for (var i = 0; i < keys.length; i++) {
      iterator.call(context, obj[keys[i]], keys[i]);
    }
    return keys;
  }

  /**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
  function reverseParams(iteratorFn) {
    return function (value, key) {iteratorFn(key, value);};
  }

  /**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
  function nextUid() {
    return ++uid;
  }

  /**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
  function setHashKey(obj, h) {
    if (h) {
      obj.$$hashKey = h;
    } else {
      delete obj.$$hashKey;
    }
  }

  function baseExtend(dst, objs, deep) {
    var h = dst.$$hashKey;

    for (var i = 0, ii = objs.length; i < ii; ++i) {
      var obj = objs[i];
      if (!isObject(obj) && !isFunction(obj)) continue;
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        var src = obj[key];

        if (deep && isObject(src)) {
          if (isDate(src)) {
            dst[key] = new Date(src.valueOf());
          } else if (isRegExp(src)) {
            dst[key] = new RegExp(src);
          } else if (src.nodeName) {
            dst[key] = src.cloneNode(true);
          } else if (isElement(src)) {
            dst[key] = src.clone();
          } else {
            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
            baseExtend(dst[key], [src], true);
          }
        } else {
          dst[key] = src;
        }
      }
    }

    setHashKey(dst, h);
    return dst;
  }

  /**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
  function extend(dst) {
    return baseExtend(dst, slice.call(arguments, 1), false);
  }

  /**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest
* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
  function merge(dst) {
    return baseExtend(dst, slice.call(arguments, 1), true);
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
    return num !== num;
  };

  function inherit(parent, extra) {
    return extend(Object.create(parent), extra);
  }

  /**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
  function noop() {}
  noop.$inject = [];

  /**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
  function identity($) {return $;}
  identity.$inject = [];

  function valueFn(value) {return function valueRef() {return value;};}

  function hasCustomToString(obj) {
    return isFunction(obj.toString) && obj.toString !== toString;
  }

  /**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
  function isUndefined(value) {return typeof value === "undefined";}

  /**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
  function isDefined(value) {return typeof value !== "undefined";}

  /**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
  function isObject(value) {
  // http://jsperf.com/isobject4
    return value !== null && typeof value === "object";
  }

  /**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
  function isBlankObject(value) {
    return value !== null && typeof value === "object" && !getPrototypeOf(value);
  }

  /**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
  function isString(value) {return typeof value === "string";}

  /**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
  function isNumber(value) {return typeof value === "number";}

  /**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
  function isDate(value) {
    return toString.call(value) === "[object Date]";
  }

  /**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`. Alias of Array.isArray.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
  var isArray = Array.isArray;

  /**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */
  function isError(value) {
    var tag = toString.call(value);
    switch (tag) {
      case "[object Error]": return true;
      case "[object Exception]": return true;
      case "[object DOMException]": return true;
      default: return value instanceof Error;
    }
  }

  /**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
  function isFunction(value) {return typeof value === "function";}

  /**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
  function isRegExp(value) {
    return toString.call(value) === "[object RegExp]";
  }

  /**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
  function isWindow(obj) {
    return obj && obj.window === obj;
  }

  function isScope(obj) {
    return obj && obj.$evalAsync && obj.$watch;
  }

  function isFile(obj) {
    return toString.call(obj) === "[object File]";
  }

  function isFormData(obj) {
    return toString.call(obj) === "[object FormData]";
  }

  function isBlob(obj) {
    return toString.call(obj) === "[object Blob]";
  }

  function isBoolean(value) {
    return typeof value === "boolean";
  }

  function isPromiseLike(obj) {
    return obj && isFunction(obj.then);
  }

  var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
  function isTypedArray(value) {
    return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
  }

  function isArrayBuffer(obj) {
    return toString.call(obj) === "[object ArrayBuffer]";
  }

  var trim = function (value) {
    return isString(value) ? value.trim() : value;
  };

  // Copied from:
  // http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
  // Prereq: s is a string.
  var escapeForRegexp = function (s) {
    return s
      .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, "\\$1")
    // eslint-disable-next-line no-control-regex
      .replace(/\x08/g, "\\x08");
  };

  /**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
  function isElement(node) {
    return !!(node &&
    (node.nodeName // We are a direct element.
    || (node.prop && node.attr && node.find))); // We have an on and find method part of jQuery API.
  }

  /**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
  function makeMap(str) {
    var obj = {}, items = str.split(","), i;
    for (i = 0; i < items.length; i++) {
      obj[items[i]] = true;
    }
    return obj;
  }

  function nodeName_(element) {
    return lowercase(element.nodeName || (element[0] && element[0].nodeName));
  }

  function includes(array, obj) {
    return Array.prototype.indexOf.call(array, obj) !== -1;
  }

  function arrayRemove(array, value) {
    var index = array.indexOf(value);
    if (index >= 0) {
      array.splice(index, 1);
    }
    return index;
  }

  /**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
  function copy(source, destination, maxDepth) {
    var stackSource = [];
    var stackDest = [];
    maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

    if (destination) {
      if (isTypedArray(destination) || isArrayBuffer(destination)) {
        throw ngMinErr("cpta", "Can't copy! TypedArray destination cannot be mutated.");
      }
      if (source === destination) {
        throw ngMinErr("cpi", "Can't copy! Source and destination are identical.");
      }

      // Empty the destination object
      if (isArray(destination)) {
        destination.length = 0;
      } else {
        forEach(destination, function (value, key) {
          if (key !== "$$hashKey") {
            delete destination[key];
          }
        });
      }

      stackSource.push(source);
      stackDest.push(destination);
      return copyRecurse(source, destination, maxDepth);
    }

    return copyElement(source, maxDepth);

    function copyRecurse(source, destination, maxDepth) {
      maxDepth--;
      if (maxDepth < 0) {
        return "...";
      }
      var h = destination.$$hashKey;
      var key;
      if (isArray(source)) {
        for (var i = 0, ii = source.length; i < ii; i++) {
          destination.push(copyElement(source[i], maxDepth));
        }
      } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in source) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      } else if (source && typeof source.hasOwnProperty === "function") {
      // Slow path, which must rely on hasOwnProperty
        for (key in source) {
          if (source.hasOwnProperty(key)) {
            destination[key] = copyElement(source[key], maxDepth);
          }
        }
      } else {
      // Slowest path --- hasOwnProperty can't be called as a method
        for (key in source) {
          if (hasOwnProperty.call(source, key)) {
            destination[key] = copyElement(source[key], maxDepth);
          }
        }
      }
      setHashKey(destination, h);
      return destination;
    }

    function copyElement(source, maxDepth) {
    // Simple values
      if (!isObject(source)) {
        return source;
      }

      // Already copied values
      var index = stackSource.indexOf(source);
      if (index !== -1) {
        return stackDest[index];
      }

      if (isWindow(source) || isScope(source)) {
        throw ngMinErr("cpws",
          "Can't copy! Making copies of Window or Scope instances is not supported.");
      }

      var needsRecurse = false;
      var destination = copyType(source);

      if (destination === undefined) {
        destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
        needsRecurse = true;
      }

      stackSource.push(source);
      stackDest.push(destination);

      return needsRecurse
        ? copyRecurse(source, destination, maxDepth)
        : destination;
    }

    function copyType(source) {
      switch (toString.call(source)) {
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

        case "[object ArrayBuffer]":
        // Support: IE10
          if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
            var copied = new ArrayBuffer(source.byteLength);
            new Uint8Array(copied).set(new Uint8Array(source));
            /* eslint-enable */
            return copied;
          }
          return source.slice(0);

        case "[object Boolean]":
        case "[object Number]":
        case "[object String]":
        case "[object Date]":
          return new source.constructor(source.valueOf());

        case "[object RegExp]":
          var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
          re.lastIndex = source.lastIndex;
          return re;

        case "[object Blob]":
          return new source.constructor([source], { type: source.type });
      }

      if (isFunction(source.cloneNode)) {
        return source.cloneNode(true);
      }
    }
  }

  // eslint-disable-next-line no-self-compare
  function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }

  /**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
  function equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    // eslint-disable-next-line no-self-compare
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
    if (t1 === t2 && t1 === "object") {
      if (isArray(o1)) {
        if (!isArray(o2)) return false;
        if ((length = o1.length) === o2.length) {
          for (key = 0; key < length; key++) {
            if (!equals(o1[key], o2[key])) return false;
          }
          return true;
        }
      } else if (isDate(o1)) {
        if (!isDate(o2)) return false;
        return simpleCompare(o1.getTime(), o2.getTime());
      } else if (isRegExp(o1)) {
        if (!isRegExp(o2)) return false;
        return o1.toString() === o2.toString();
      } else {
        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
        keySet = createMap();
        for (key in o1) {
          if (key.charAt(0) === "$" || isFunction(o1[key])) continue;
          if (!equals(o1[key], o2[key])) return false;
          keySet[key] = true;
        }
        for (key in o2) {
          if (!(key in keySet) &&
            key.charAt(0) !== "$" &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
        }
        return true;
      }
    }
    return false;
  }

  var csp = function () {
    if (!isDefined(csp.rules)) {

      var ngCspElement = (window.document.querySelector("[ng-csp]") ||
                    window.document.querySelector("[data-ng-csp]"));

      if (ngCspElement) {
        var ngCspAttribute = ngCspElement.getAttribute("ng-csp") ||
                    ngCspElement.getAttribute("data-ng-csp");
        csp.rules = {
          noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf("no-unsafe-eval") !== -1),
          noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf("no-inline-style") !== -1)
        };
      } else {
        csp.rules = {
          noUnsafeEval: noUnsafeEval(),
          noInlineStyle: false
        };
      }
    }

    return csp.rules;

    function noUnsafeEval() {
      try {
      // eslint-disable-next-line no-new, no-new-func
        new Function("");
        return false;
      } catch (e) {
        return true;
      }
    }
  };

  /**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
  var jq = function () {
    if (isDefined(jq.name_)) return jq.name_;
    var el;
    var i, ii = ngAttrPrefixes.length, prefix, name;
    for (i = 0; i < ii; ++i) {
      prefix = ngAttrPrefixes[i];
      el = window.document.querySelector("[" + prefix.replace(":", "\\:") + "jq]");
      if (el) {
        name = el.getAttribute(prefix + "jq");
        break;
      }
    }

    return (jq.name_ = name);
  };

  function concat(array1, array2, index) {
    return array1.concat(slice.call(array2, index));
  }

  function sliceArgs(args, startIndex) {
    return slice.call(args, startIndex || 0);
  }

  /**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
  function bind(self, fn) {
    var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
    if (isFunction(fn) && !(fn instanceof RegExp)) {
      return curryArgs.length
        ? function () {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
        : function () {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
    } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
      return fn;
    }
  }

  function toJsonReplacer(key, value) {
    var val = value;

    if (typeof key === "string" && key.charAt(0) === "$" && key.charAt(1) === "$") {
      val = undefined;
    } else if (isWindow(value)) {
      val = "$WINDOW";
    } else if (value && window.document === value) {
      val = "$DOCUMENT";
    } else if (isScope(value)) {
      val = "$SCOPE";
    }

    return val;
  }

  /**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
  function toJson(obj, pretty) {
    if (isUndefined(obj)) return undefined;
    if (!isNumber(pretty)) {
      pretty = pretty ? 2 : null;
    }
    return JSON.stringify(obj, toJsonReplacer, pretty);
  }

  /**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
  function fromJson(json) {
    return isString(json)
      ? JSON.parse(json)
      : json;
  }

  var ALL_COLONS = /:/g;
  function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-15+
  // IE/Edge do not "understand" colon (`:`) in timezone
    timezone = timezone.replace(ALL_COLONS, "");
    var requestedTimezoneOffset = Date.parse("Jan 01, 1970 00:00:00 " + timezone) / 60000;
    return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }

  /**
 * @returns {string} Returns the string representation of the element.
 */
  function startingTag(element) {
    element = jqLite(element).clone().empty();
    var elemHtml = jqLite("<div></div>").append(element).html();
    try {
      return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function (match, nodeName) {return "<" + lowercase(nodeName);});
    } catch (e) {
      return lowercase(elemHtml);
    }

  }

  // ///////////////////////////////////////////////

  /**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
  function tryDecodeURIComponent(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
    // Ignore any invalid uri component.
    }
  }

  /**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
  function parseKeyValue(/** string*/keyValue) {
    var obj = {};
    forEach((keyValue || "").split("&"), function (keyValue) {
      var splitPoint, key, val;
      if (keyValue) {
        key = keyValue = keyValue.replace(/\+/g, "%20");
        splitPoint = keyValue.indexOf("=");
        if (splitPoint !== -1) {
          key = keyValue.substring(0, splitPoint);
          val = keyValue.substring(splitPoint + 1);
        }
        key = tryDecodeURIComponent(key);
        if (isDefined(key)) {
          val = isDefined(val) ? tryDecodeURIComponent(val) : true;
          if (!hasOwnProperty.call(obj, key)) {
            obj[key] = val;
          } else if (isArray(obj[key])) {
            obj[key].push(val);
          } else {
            obj[key] = [obj[key], val];
          }
        }
      }
    });
    return obj;
  }

  function toKeyValue(obj) {
    var parts = [];
    forEach(obj, function (value, key) {
      if (isArray(value)) {
        forEach(value, function (arrayValue) {
          parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? "" : "=" + encodeUriQuery(arrayValue, true)));
        });
      } else {
        parts.push(encodeUriQuery(key, true) +
               (value === true ? "" : "=" + encodeUriQuery(value, true)));
      }
    });
    return parts.length ? parts.join("&") : "";
  }

  /**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
  function encodeUriSegment(val) {
    return encodeUriQuery(val, true).
      replace(/%26/gi, "&").
      replace(/%3D/gi, "=").
      replace(/%2B/gi, "+");
  }

  /**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
  function encodeUriQuery(val, pctEncodeSpaces) {
    return encodeURIComponent(val).
      replace(/%40/gi, "@").
      replace(/%3A/gi, ":").
      replace(/%24/g, "$").
      replace(/%2C/gi, ",").
      replace(/%3B/gi, ";").
      replace(/%20/g, (pctEncodeSpaces ? "%20" : "+"));
  }

  var ngAttrPrefixes = ["ng-", "data-ng-", "ng:", "x-ng-"];

  function getNgAttribute(element, ngAttr) {
    var attr, i, ii = ngAttrPrefixes.length;
    for (i = 0; i < ii; ++i) {
      attr = ngAttrPrefixes[i] + ngAttr;
      if (isString(attr = element.getAttribute(attr))) {
        return attr;
      }
    }
    return null;
  }

  function allowAutoBootstrap(document) {
    var script = document.currentScript;

    if (!script) {
    // Support: IE 9-11 only
    // IE does not have `document.currentScript`
      return true;
    }

    // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
    if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
      return false;
    }

    var attributes = script.attributes;
    var srcs = [attributes.getNamedItem("src"), attributes.getNamedItem("href"), attributes.getNamedItem("xlink:href")];

    return srcs.every(function (src) {
      if (!src) {
        return true;
      }
      if (!src.value) {
        return false;
      }

      var link = document.createElement("a");
      link.href = src.value;

      if (document.location.origin === link.origin) {
      // Same-origin resources are always allowed, even for non-whitelisted schemes.
        return true;
      }
      // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
      // This is to prevent angular.js bundled with browser extensions from being used to bypass the
      // content security policy in web pages and other browser extensions.
      switch (link.protocol) {
        case "http:":
        case "https:":
        case "ftp:":
        case "blob:":
        case "file:":
        case "data:":
          return true;
        default:
          return false;
      }
    });
  }

  // Cached as it has to run during loading so that document.currentScript is available.
  var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

  /**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
  function angularInit(element, bootstrap) {
    var appElement,
      module,
      config = {};

    // The element `element` has priority over any other element.
    forEach(ngAttrPrefixes, function (prefix) {
      var name = prefix + "app";

      if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
        appElement = element;
        module = element.getAttribute(name);
      }
    });
    forEach(ngAttrPrefixes, function (prefix) {
      var name = prefix + "app";
      var candidate;

      if (!appElement && (candidate = element.querySelector("[" + name.replace(":", "\\:") + "]"))) {
        appElement = candidate;
        module = candidate.getAttribute(name);
      }
    });
    if (appElement) {
      if (!isAutoBootstrapAllowed) {
        window.console.error("AngularJS: disabling automatic bootstrap. <script> protocol indicates " +
          "an extension, document.location.href does not match.");
        return;
      }
      config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
      bootstrap(appElement, module ? [module] : [], config);
    }
  }

  /**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
  function bootstrap(element, modules, config) {
    if (!isObject(config)) config = {};
    var defaultConfig = {
      strictDi: false
    };
    config = extend(defaultConfig, config);
    var doBootstrap = function () {
      element = jqLite(element);

      if (element.injector()) {
        var tag = (element[0] === window.document) ? "document" : startingTag(element);
        // Encode angle brackets to prevent input from being sanitized to empty string #8683.
        throw ngMinErr(
          "btstrpd",
          "App already bootstrapped with this element '{0}'",
          tag.replace(/</, "&lt;").replace(/>/, "&gt;"));
      }

      modules = modules || [];
      modules.unshift(["$provide", function ($provide) {
        $provide.value("$rootElement", element);
      }]);

      if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
        modules.push(["$compileProvider", function ($compileProvider) {
          $compileProvider.debugInfoEnabled(true);
        }]);
      }

      modules.unshift("ng");
      var injector = createInjector(modules, config.strictDi);
      injector.invoke(["$rootScope", "$rootElement", "$compile", "$injector",
        function bootstrapApply(scope, element, compile, injector) {
          scope.$apply(function () {
            element.data("$injector", injector);
            compile(element)(scope);
          });
        }]
      );
      return injector;
    };

    var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
    var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

    if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
      config.debugInfoEnabled = true;
      window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, "");
    }

    if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
      return doBootstrap();
    }

    window.name = window.name.replace(NG_DEFER_BOOTSTRAP, "");
    angular.resumeBootstrap = function (extraModules) {
      forEach(extraModules, function (module) {
        modules.push(module);
      });
      return doBootstrap();
    };

    if (isFunction(angular.resumeDeferredBootstrap)) {
      angular.resumeDeferredBootstrap();
    }
  }

  /**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
  function reloadWithDebugInfo() {
    window.name = "NG_ENABLE_DEBUG_INFO!" + window.name;
    window.location.reload();
  }

  /**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */
  function getTestability(rootElement) {
    var injector = angular.element(rootElement).injector();
    if (!injector) {
      throw ngMinErr("test",
        "no injector found for element argument to getTestability");
    }
    return injector.get("$$testability");
  }

  var SNAKE_CASE_REGEXP = /[A-Z]/g;
  function snake_case(name, separator) {
    separator = separator || "_";
    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
      return (pos ? separator : "") + letter.toLowerCase();
    });
  }

  var bindJQueryFired = false;
  function bindJQuery() {
    var originalCleanData;

    if (bindJQueryFired) {
      return;
    }

    // bind to jQuery if present;
    var jqName = jq();
    jQuery = isUndefined(jqName) ? window.jQuery : // use jQuery (if present)
      !jqName ? undefined : // use jqLite
        window[jqName]; // use jQuery specified by `ngJq`

    // Use jQuery if it exists with proper functionality, otherwise default to us.
    // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
    // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
    // versions. It will not work for sure with jQuery <1.7, though.
    if (jQuery && jQuery.fn.on) {
      jqLite = jQuery;
      extend(jQuery.fn, {
        scope: JQLitePrototype.scope,
        isolateScope: JQLitePrototype.isolateScope,
        controller: /** @type {?} */ (JQLitePrototype).controller,
        injector: JQLitePrototype.injector,
        inheritedData: JQLitePrototype.inheritedData
      });

      // All nodes removed from the DOM via various jQuery APIs like .remove()
      // are passed through jQuery.cleanData. Monkey-patch this method to fire
      // the $destroy event on all removed nodes.
      originalCleanData = jQuery.cleanData;
      jQuery.cleanData = function (elems) {
        var events;
        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
          events = jQuery._data(elem, "events");
          if (events && events.$destroy) {
            jQuery(elem).triggerHandler("$destroy");
          }
        }
        originalCleanData(elems);
      };
    } else {
      jqLite = JQLite;
    }

    angular.element = jqLite;

    // Prevent double-proxying.
    bindJQueryFired = true;
  }

  /**
 * throw error if the argument is falsy.
 */
  function assertArg(arg, name, reason) {
    if (!arg) {
      throw ngMinErr("areq", "Argument '{0}' is {1}", (name || "?"), (reason || "required"));
    }
    return arg;
  }

  function assertArgFn(arg, name, acceptArrayAnnotation) {
    if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
    }

    assertArg(isFunction(arg), name, "not a function, got " +
      (arg && typeof arg === "object" ? arg.constructor.name || "Object" : typeof arg));
    return arg;
  }

  /**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
  function assertNotHasOwnProperty(name, context) {
    if (name === "hasOwnProperty") {
      throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);
    }
  }

  /**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
  // TODO(misko): this function needs to be removed
  function getter(obj, path, bindFnToScope) {
    if (!path) return obj;
    var keys = path.split(".");
    var key;
    var lastInstance = obj;
    var len = keys.length;

    for (var i = 0; i < len; i++) {
      key = keys[i];
      if (obj) {
        obj = (lastInstance = obj)[key];
      }
    }
    if (!bindFnToScope && isFunction(obj)) {
      return bind(lastInstance, obj);
    }
    return obj;
  }

  /**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
  function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
    var node = nodes[0];
    var endNode = nodes[nodes.length - 1];
    var blockNodes;

    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
      if (blockNodes || nodes[i] !== node) {
        if (!blockNodes) {
          blockNodes = jqLite(slice.call(nodes, 0, i));
        }
        blockNodes.push(node);
      }
    }

    return blockNodes || nodes;
  }

  /**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
  function createMap() {
    return Object.create(null);
  }

  function stringify(value) {
    if (value == null) { // null || undefined
      return "";
    }
    switch (typeof value) {
      case "string":
        break;
      case "number":
        value = "" + value;
        break;
      default:
        if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
          value = value.toString();
        } else {
          value = toJson(value);
        }
    }

    return value;
  }

  var NODE_TYPE_ELEMENT = 1;
  var NODE_TYPE_ATTRIBUTE = 2;
  var NODE_TYPE_TEXT = 3;
  var NODE_TYPE_COMMENT = 8;
  var NODE_TYPE_DOCUMENT = 9;
  var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

  /**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */

  function setupModuleLoader(window) {

    var $injectorMinErr = minErr("$injector");
    var ngMinErr = minErr("ng");

    function ensure(obj, name, factory) {
      return obj[name] || (obj[name] = factory());
    }

    var angular = ensure(window, "angular", Object);

    // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
    angular.$$minErr = angular.$$minErr || minErr;

    return ensure(angular, "module", function () {
    /** @type {Object.<string, angular.Module>} */
      var modules = {};

      /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
      return function module(name, requires, configFn) {

        var info = {};

        var assertNotHasOwnProperty = function (name, context) {
          if (name === "hasOwnProperty") {
            throw ngMinErr("badname", "hasOwnProperty is not a valid {0} name", context);
          }
        };

        assertNotHasOwnProperty(name, "module");
        if (requires && modules.hasOwnProperty(name)) {
          modules[name] = null;
        }
        return ensure(modules, name, function () {
          if (!requires) {
            throw $injectorMinErr("nomod", "Module '{0}' is not available! You either misspelled " +
             "the module name or forgot to load it. If registering a module ensure that you " +
             "specify the dependencies as the second argument.", name);
          }

          /** @type {!Array.<Array.<*>>} */
          var invokeQueue = [];

          /** @type {!Array.<Function>} */
          var configBlocks = [];

          /** @type {!Array.<Function>} */
          var runBlocks = [];

          var config = invokeLater("$injector", "invoke", "push", configBlocks);

          /** @type {angular.Module} */
          var moduleInstance = {
          // Private state
            _invokeQueue: invokeQueue,
            _configBlocks: configBlocks,
            _runBlocks: runBlocks,

            /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */
            info: function (value) {
              if (isDefined(value)) {
                if (!isObject(value)) throw ngMinErr("aobj", "Argument '{0}' must be an object", "value");
                info = value;
                return this;
              }
              return info;
            },

            /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
            requires: requires,

            /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
            name: name,

            /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
            provider: invokeLaterAndSetModuleName("$provide", "provider"),

            /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
            factory: invokeLaterAndSetModuleName("$provide", "factory"),

            /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
            service: invokeLaterAndSetModuleName("$provide", "service"),

            /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
            value: invokeLater("$provide", "value"),

            /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
            constant: invokeLater("$provide", "constant", "unshift"),

            /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
            decorator: invokeLaterAndSetModuleName("$provide", "decorator", configBlocks),

            /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
            animation: invokeLaterAndSetModuleName("$animateProvider", "register"),

            /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
            filter: invokeLaterAndSetModuleName("$filterProvider", "register"),

            /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
            controller: invokeLaterAndSetModuleName("$controllerProvider", "register"),

            /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
            directive: invokeLaterAndSetModuleName("$compileProvider", "directive"),

            /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
            component: invokeLaterAndSetModuleName("$compileProvider", "component"),

            /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
            config: config,

            /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
            run: function (block) {
              runBlocks.push(block);
              return this;
            }
          };

          if (configFn) {
            config(configFn);
          }

          return moduleInstance;

          /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
          function invokeLater(provider, method, insertMethod, queue) {
            if (!queue) queue = invokeQueue;
            return function () {
              queue[insertMethod || "push"]([provider, method, arguments]);
              return moduleInstance;
            };
          }

          /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
          function invokeLaterAndSetModuleName(provider, method, queue) {
            if (!queue) queue = invokeQueue;
            return function (recipeName, factoryFunction) {
              if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
              queue.push([provider, method, arguments]);
              return moduleInstance;
            };
          }
        });
      };
    });

  }

  /* global shallowCopy: true */

  /**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
  function shallowCopy(src, dst) {
    if (isArray(src)) {
      dst = dst || [];

      for (var i = 0, ii = src.length; i < ii; i++) {
        dst[i] = src[i];
      }
    } else if (isObject(src)) {
      dst = dst || {};

      for (var key in src) {
        if (!(key.charAt(0) === "$" && key.charAt(1) === "$")) {
          dst[key] = src[key];
        }
      }
    }

    return dst || src;
  }

  /* exported toDebugString */

  function serializeObject(obj, maxDepth) {
    var seen = [];

    // There is no direct way to stringify object until reaching a specific depth
    // and a very deep object can cause a performance issue, so we copy the object
    // based on this specific depth and then stringify it.
    if (isValidObjectMaxDepth(maxDepth)) {
    // This file is also included in `angular-loader`, so `copy()` might not always be available in
    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
      obj = angular.copy(obj, null, maxDepth);
    }
    return JSON.stringify(obj, function (key, val) {
      val = toJsonReplacer(key, val);
      if (isObject(val)) {

        if (seen.indexOf(val) >= 0) return "...";

        seen.push(val);
      }
      return val;
    });
  }

  function toDebugString(obj, maxDepth) {
    if (typeof obj === "function") {
      return obj.toString().replace(/ \{[\s\S]*$/, "");
    } else if (isUndefined(obj)) {
      return "undefined";
    } else if (typeof obj !== "string") {
      return serializeObject(obj, maxDepth);
    }
    return obj;
  }

  /* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/

  /**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
  var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
    full: "1.6.10",
    major: 1,
    minor: 6,
    dot: 10,
    codeName: "crystalline-persuasion"
  };

  function publishExternalAPI(angular) {
    extend(angular, {
      "errorHandlingConfig": errorHandlingConfig,
      "bootstrap": bootstrap,
      "copy": copy,
      "extend": extend,
      "merge": merge,
      "equals": equals,
      "element": jqLite,
      "forEach": forEach,
      "injector": createInjector,
      "noop": noop,
      "bind": bind,
      "toJson": toJson,
      "fromJson": fromJson,
      "identity": identity,
      "isUndefined": isUndefined,
      "isDefined": isDefined,
      "isString": isString,
      "isFunction": isFunction,
      "isObject": isObject,
      "isNumber": isNumber,
      "isElement": isElement,
      "isArray": isArray,
      "version": version,
      "isDate": isDate,
      "lowercase": lowercase,
      "uppercase": uppercase,
      "callbacks": { $$counter: 0 },
      "getTestability": getTestability,
      "reloadWithDebugInfo": reloadWithDebugInfo,
      "$$minErr": minErr,
      "$$csp": csp,
      "$$encodeUriSegment": encodeUriSegment,
      "$$encodeUriQuery": encodeUriQuery,
      "$$stringify": stringify
    });

    angularModule = setupModuleLoader(window);

    angularModule("ng", ["ngLocale"], ["$provide",
      function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
        $provide.provider({
          $$sanitizeUri: $$SanitizeUriProvider
        });
        $provide.provider("$compile", $CompileProvider).
          directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
          }).
          directive({
            ngInclude: ngIncludeFillContentDirective
          }).
          directive(ngAttributeAliasDirectives).
          directive(ngEventDirectives);
        $provide.provider({
          $anchorScroll: $AnchorScrollProvider,
          $animate: $AnimateProvider,
          $animateCss: $CoreAnimateCssProvider,
          $$animateJs: $$CoreAnimateJsProvider,
          $$animateQueue: $$CoreAnimateQueueProvider,
          $$AnimateRunner: $$AnimateRunnerFactoryProvider,
          $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
          $browser: $BrowserProvider,
          $cacheFactory: $CacheFactoryProvider,
          $controller: $ControllerProvider,
          $document: $DocumentProvider,
          $$isDocumentHidden: $$IsDocumentHiddenProvider,
          $exceptionHandler: $ExceptionHandlerProvider,
          $filter: $FilterProvider,
          $$forceReflow: $$ForceReflowProvider,
          $interpolate: $InterpolateProvider,
          $interval: $IntervalProvider,
          $http: $HttpProvider,
          $httpParamSerializer: $HttpParamSerializerProvider,
          $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
          $httpBackend: $HttpBackendProvider,
          $xhrFactory: $xhrFactoryProvider,
          $jsonpCallbacks: $jsonpCallbacksProvider,
          $location: $LocationProvider,
          $log: $LogProvider,
          $parse: $ParseProvider,
          $rootScope: $RootScopeProvider,
          $q: $QProvider,
          $$q: $$QProvider,
          $sce: $SceProvider,
          $sceDelegate: $SceDelegateProvider,
          $sniffer: $SnifferProvider,
          $templateCache: $TemplateCacheProvider,
          $templateRequest: $TemplateRequestProvider,
          $$testability: $$TestabilityProvider,
          $timeout: $TimeoutProvider,
          $window: $WindowProvider,
          $$rAF: $$RAFProvider,
          $$jqLite: $$jqLiteProvider,
          $$Map: $$MapProvider,
          $$cookieReader: $$CookieReaderProvider
        });
      }
    ])
      .info({ angularVersion: "1.6.10" });
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

  // ////////////////////////////////
  // JQLite
  // ////////////////////////////////

  /**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

  JQLite.expando = "ng339";

  var jqCache = JQLite.cache = {},
    jqId = 1;

  /*
 * !!! This is an undocumented "private" function !!!
 */
  JQLite._data = function (node) {
  // jQuery always returns an object on cache miss
    return this.cache[node[this.expando]] || {};
  };

  function jqNextId() { return ++jqId; }

  var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
  var MS_HACK_REGEXP = /^-ms-/;
  var MOUSE_EVENT_MAP = { mouseleave: "mouseout", mouseenter: "mouseover" };
  var jqLiteMinErr = minErr("jqLite");

  /**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
  function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, "ms-"));
  }

  function fnCamelCaseReplace(all, letter) {
    return letter.toUpperCase();
  }

  /**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
  function kebabToCamel(name) {
    return name
      .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
  }

  var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
  var HTML_REGEXP = /<|&#?\w+;/;
  var TAG_NAME_REGEXP = /<([\w:-]+)/;
  var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

  var wrapMap = {
    "option": [1, "<select multiple=\"multiple\">", "</select>"],

    "thead": [1, "<table>", "</table>"],
    "col": [2, "<table><colgroup>", "</colgroup></table>"],
    "tr": [2, "<table><tbody>", "</tbody></table>"],
    "td": [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    "_default": [0, "", ""]
  };

  wrapMap.optgroup = wrapMap.option;
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  function jqLiteIsTextNode(html) {
    return !HTML_REGEXP.test(html);
  }

  function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
    var nodeType = node.nodeType;
    return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
  }

  function jqLiteHasData(node) {
    for (var key in jqCache[node.ng339]) {
      return true;
    }
    return false;
  }

  function jqLiteBuildFragment(html, context) {
    var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

    if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
      nodes.push(context.createTextNode(html));
    } else {
    // Convert html into DOM nodes
      tmp = fragment.appendChild(context.createElement("div"));
      tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
      wrap = wrapMap[tag] || wrapMap._default;
      tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];

      // Descend through wrappers to the right content
      i = wrap[0];
      while (i--) {
        tmp = tmp.lastChild;
      }

      nodes = concat(nodes, tmp.childNodes);

      tmp = fragment.firstChild;
      tmp.textContent = "";
    }

    // Remove wrapper from fragment
    fragment.textContent = "";
    fragment.innerHTML = ""; // Clear inner HTML
    forEach(nodes, function (node) {
      fragment.appendChild(node);
    });

    return fragment;
  }

  function jqLiteParseHTML(html, context) {
    context = context || window.document;
    var parsed;

    if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
      return [context.createElement(parsed[1])];
    }

    if ((parsed = jqLiteBuildFragment(html, context))) {
      return parsed.childNodes;
    }

    return [];
  }

  function jqLiteWrapNode(node, wrapper) {
    var parent = node.parentNode;

    if (parent) {
      parent.replaceChild(wrapper, node);
    }

    wrapper.appendChild(node);
  }

  // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
  var jqLiteContains = window.Node.prototype.contains || /** @this */ function (arg) {
  // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // ///////////////////////////////////////////
  function JQLite(element) {
    if (element instanceof JQLite) {
      return element;
    }

    var argIsString;

    if (isString(element)) {
      element = trim(element);
      argIsString = true;
    }
    if (!(this instanceof JQLite)) {
      if (argIsString && element.charAt(0) !== "<") {
        throw jqLiteMinErr("nosel", "Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element");
      }
      return new JQLite(element);
    }

    if (argIsString) {
      jqLiteAddNodes(this, jqLiteParseHTML(element));
    } else if (isFunction(element)) {
      jqLiteReady(element);
    } else {
      jqLiteAddNodes(this, element);
    }
  }

  function jqLiteClone(element) {
    return element.cloneNode(true);
  }

  function jqLiteDealoc(element, onlyDescendants) {
    if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

    if (element.querySelectorAll) {
      jqLite.cleanData(element.querySelectorAll("*"));
    }
  }

  function jqLiteOff(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr("offargs", "jqLite#off() does not support the `selector` argument");

    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var handle = expandoStore && expandoStore.handle;

    if (!handle) return; // no listeners registered

    if (!type) {
      for (type in events) {
        if (type !== "$destroy") {
          element.removeEventListener(type, handle);
        }
        delete events[type];
      }
    } else {

      var removeHandler = function (type) {
        var listenerFns = events[type];
        if (isDefined(fn)) {
          arrayRemove(listenerFns || [], fn);
        }
        if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
          element.removeEventListener(type, handle);
          delete events[type];
        }
      };

      forEach(type.split(" "), function (type) {
        removeHandler(type);
        if (MOUSE_EVENT_MAP[type]) {
          removeHandler(MOUSE_EVENT_MAP[type]);
        }
      });
    }
  }

  function jqLiteRemoveData(element, name) {
    var expandoId = element.ng339;
    var expandoStore = expandoId && jqCache[expandoId];

    if (expandoStore) {
      if (name) {
        delete expandoStore.data[name];
        return;
      }

      if (expandoStore.handle) {
        if (expandoStore.events.$destroy) {
          expandoStore.handle({}, "$destroy");
        }
        jqLiteOff(element);
      }
      delete jqCache[expandoId];
      element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
    }
  }

  function jqLiteExpandoStore(element, createIfNecessary) {
    var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

    if (createIfNecessary && !expandoStore) {
      element.ng339 = expandoId = jqNextId();
      expandoStore = jqCache[expandoId] = { events: {}, data: {}, handle: undefined };
    }

    return expandoStore;
  }

  function jqLiteData(element, key, value) {
    if (jqLiteAcceptsData(element)) {
      var prop;

      var isSimpleSetter = isDefined(value);
      var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
      var massGetter = !key;
      var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
      var data = expandoStore && expandoStore.data;

      if (isSimpleSetter) { // data('key', value)
        data[kebabToCamel(key)] = value;
      } else {
        if (massGetter) { // data()
          return data;
        } else {
          if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
            return data && data[kebabToCamel(key)];
          } else { // mass-setter: data({key1: val1, key2: val2})
            for (prop in key) {
              data[kebabToCamel(prop)] = key[prop];
            }
          }
        }
      }
    }
  }

  function jqLiteHasClass(element, selector) {
    if (!element.getAttribute) return false;
    return ((" " + (element.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").
      indexOf(" " + selector + " ") > -1);
  }

  function jqLiteRemoveClass(element, cssClasses) {
    if (cssClasses && element.setAttribute) {
      var existingClasses = (" " + (element.getAttribute("class") || "") + " ")
        .replace(/[\n\t]/g, " ");
      var newClasses = existingClasses;

      forEach(cssClasses.split(" "), function (cssClass) {
        cssClass = trim(cssClass);
        newClasses = newClasses.replace(" " + cssClass + " ", " ");
      });

      if (newClasses !== existingClasses) {
        element.setAttribute("class", trim(newClasses));
      }
    }
  }

  function jqLiteAddClass(element, cssClasses) {
    if (cssClasses && element.setAttribute) {
      var existingClasses = (" " + (element.getAttribute("class") || "") + " ")
        .replace(/[\n\t]/g, " ");
      var newClasses = existingClasses;

      forEach(cssClasses.split(" "), function (cssClass) {
        cssClass = trim(cssClass);
        if (newClasses.indexOf(" " + cssClass + " ") === -1) {
          newClasses += cssClass + " ";
        }
      });

      if (newClasses !== existingClasses) {
        element.setAttribute("class", trim(newClasses));
      }
    }
  }

  function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

    if (elements) {

      // if a Node (the most common case)
      if (elements.nodeType) {
        root[root.length++] = elements;
      } else {
        var length = elements.length;

        // if an Array or NodeList and not a Window
        if (typeof length === "number" && elements.window !== elements) {
          if (length) {
            for (var i = 0; i < length; i++) {
              root[root.length++] = elements[i];
            }
          }
        } else {
          root[root.length++] = elements;
        }
      }
    }
  }

  function jqLiteController(element, name) {
    return jqLiteInheritedData(element, "$" + (name || "ngController") + "Controller");
  }

  function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
    if (element.nodeType === NODE_TYPE_DOCUMENT) {
      element = element.documentElement;
    }
    var names = isArray(name) ? name : [name];

    while (element) {
      for (var i = 0, ii = names.length; i < ii; i++) {
        if (isDefined(value = jqLite.data(element, names[i]))) return value;
      }

      // If dealing with a document fragment node with a host element, and no parent, use the host
      // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
      // to lookup parent controllers.
      element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
    }
  }

  function jqLiteEmpty(element) {
    jqLiteDealoc(element, true);
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function jqLiteRemove(element, keepData) {
    if (!keepData) jqLiteDealoc(element);
    var parent = element.parentNode;
    if (parent) parent.removeChild(element);
  }

  function jqLiteDocumentLoaded(action, win) {
    win = win || window;
    if (win.document.readyState === "complete") {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
      win.setTimeout(action);
    } else {
    // No need to unbind this handler as load is only ever called once
      jqLite(win).on("load", action);
    }
  }

  function jqLiteReady(fn) {
    function trigger() {
      window.document.removeEventListener("DOMContentLoaded", trigger);
      window.removeEventListener("load", trigger);
      fn();
    }

    // check if document is already loaded
    if (window.document.readyState === "complete") {
      window.setTimeout(fn);
    } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

      // Works for modern browsers and IE9
      window.document.addEventListener("DOMContentLoaded", trigger);

      // Fallback to window.onload for others
      window.addEventListener("load", trigger);
    }
  }

  // ////////////////////////////////////////
  // Functions which are declared directly.
  // ////////////////////////////////////////
  var JQLitePrototype = JQLite.prototype = {
    ready: jqLiteReady,
    toString: function () {
      var value = [];
      forEach(this, function (e) { value.push("" + e);});
      return "[" + value.join(", ") + "]";
    },

    eq: function (index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
    },

    length: 0,
    push: push,
    sort: [].sort,
    splice: [].splice
  };

  // ////////////////////////////////////////
  // Functions iterating getter/setters.
  // these functions return self on setter and
  // value on get.
  // ////////////////////////////////////////
  var BOOLEAN_ATTR = {};
  forEach("multiple,selected,checked,disabled,readOnly,required,open".split(","), function (value) {
    BOOLEAN_ATTR[lowercase(value)] = value;
  });
  var BOOLEAN_ELEMENTS = {};
  forEach("input,select,option,textarea,button,form,details".split(","), function (value) {
    BOOLEAN_ELEMENTS[value] = true;
  });
  var ALIASED_ATTR = {
    "ngMinlength": "minlength",
    "ngMaxlength": "maxlength",
    "ngMin": "min",
    "ngMax": "max",
    "ngPattern": "pattern",
    "ngStep": "step"
  };

  function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
    var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

    // booleanAttr is here twice to minimize DOM access
    return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
  }

  function getAliasedAttrName(name) {
    return ALIASED_ATTR[name];
  }

  forEach({
    data: jqLiteData,
    removeData: jqLiteRemoveData,
    hasData: jqLiteHasData,
    cleanData: function jqLiteCleanData(nodes) {
      for (var i = 0, ii = nodes.length; i < ii; i++) {
        jqLiteRemoveData(nodes[i]);
      }
    }
  }, function (fn, name) {
    JQLite[name] = fn;
  });

  forEach({
    data: jqLiteData,
    inheritedData: jqLiteInheritedData,

    scope: function (element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
      return jqLite.data(element, "$scope") || jqLiteInheritedData(element.parentNode || element, ["$isolateScope", "$scope"]);
    },

    isolateScope: function (element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
      return jqLite.data(element, "$isolateScope") || jqLite.data(element, "$isolateScopeNoTemplate");
    },

    controller: jqLiteController,

    injector: function (element) {
      return jqLiteInheritedData(element, "$injector");
    },

    removeAttr: function (element, name) {
      element.removeAttribute(name);
    },

    hasClass: jqLiteHasClass,

    css: function (element, name, value) {
      name = cssKebabToCamel(name);

      if (isDefined(value)) {
        element.style[name] = value;
      } else {
        return element.style[name];
      }
    },

    attr: function (element, name, value) {
      var ret;
      var nodeType = element.nodeType;
      if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
        return;
      }

      var lowercasedName = lowercase(name);
      var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

      if (isDefined(value)) {
      // setter

        if (value === null || (value === false && isBooleanAttr)) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
        }
      } else {
      // getter

        ret = element.getAttribute(name);

        if (isBooleanAttr && ret !== null) {
          ret = lowercasedName;
        }
        // Normalize non-existing attributes to undefined (as jQuery).
        return ret === null ? undefined : ret;
      }
    },

    prop: function (element, name, value) {
      if (isDefined(value)) {
        element[name] = value;
      } else {
        return element[name];
      }
    },

    text: (function () {
      getText.$dv = "";
      return getText;

      function getText(element, value) {
        if (isUndefined(value)) {
          var nodeType = element.nodeType;
          return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : "";
        }
        element.textContent = value;
      }
    })(),

    val: function (element, value) {
      if (isUndefined(value)) {
        if (element.multiple && nodeName_(element) === "select") {
          var result = [];
          forEach(element.options, function (option) {
            if (option.selected) {
              result.push(option.value || option.text);
            }
          });
          return result;
        }
        return element.value;
      }
      element.value = value;
    },

    html: function (element, value) {
      if (isUndefined(value)) {
        return element.innerHTML;
      }
      jqLiteDealoc(element, true);
      element.innerHTML = value;
    },

    empty: jqLiteEmpty
  }, function (fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
    JQLite.prototype[name] = function (arg1, arg2) {
      var i, key;
      var nodeCount = this.length;

      // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
      // in a way that survives minification.
      // jqLiteEmpty takes no arguments but is a setter.
      if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
        if (isObject(arg1)) {

          // we are a write, but the object properties are the key/values
          for (i = 0; i < nodeCount; i++) {
            if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
              fn(this[i], arg1);
            } else {
              for (key in arg1) {
                fn(this[i], key, arg1[key]);
              }
            }
          }
          // return self for chaining
          return this;
        } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
          var value = fn.$dv;
          // Only if we have $dv do we iterate over all, otherwise it is just the first element.
          var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
          for (var j = 0; j < jj; j++) {
            var nodeValue = fn(this[j], arg1, arg2);
            value = value ? value + nodeValue : nodeValue;
          }
          return value;
        }
      } else {
      // we are a write, so apply to all children
        for (i = 0; i < nodeCount; i++) {
          fn(this[i], arg1, arg2);
        }
        // return self for chaining
        return this;
      }
    };
  });

  function createEventHandler(element, events) {
    var eventHandler = function (event, type) {
    // jQuery specific api
      event.isDefaultPrevented = function () {
        return event.defaultPrevented;
      };

      var eventFns = events[type || event.type];
      var eventFnsLength = eventFns ? eventFns.length : 0;

      if (!eventFnsLength) return;

      if (isUndefined(event.immediatePropagationStopped)) {
        var originalStopImmediatePropagation = event.stopImmediatePropagation;
        event.stopImmediatePropagation = function () {
          event.immediatePropagationStopped = true;

          if (event.stopPropagation) {
            event.stopPropagation();
          }

          if (originalStopImmediatePropagation) {
            originalStopImmediatePropagation.call(event);
          }
        };
      }

      event.isImmediatePropagationStopped = function () {
        return event.immediatePropagationStopped === true;
      };

      // Some events have special handlers that wrap the real handler
      var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

      // Copy event handlers in case event handlers array is modified during execution.
      if ((eventFnsLength > 1)) {
        eventFns = shallowCopy(eventFns);
      }

      for (var i = 0; i < eventFnsLength; i++) {
        if (!event.isImmediatePropagationStopped()) {
          handlerWrapper(element, event, eventFns[i]);
        }
      }
    };

    // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
    //       events on `element`
    eventHandler.elem = element;
    return eventHandler;
  }

  function defaultHandlerWrapper(element, event, handler) {
    handler.call(element, event);
  }

  function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
    var related = event.relatedTarget;
    // For mousenter/leave call the handler if related is outside the target.
    // NB: No relatedTarget if the mouse left/entered the browser window
    if (!related || (related !== target && !jqLiteContains.call(target, related))) {
      handler.call(target, event);
    }
  }

  // ////////////////////////////////////////
  // Functions iterating traversal.
  // These functions chain results into a single
  // selector.
  // ////////////////////////////////////////
  forEach({
    removeData: jqLiteRemoveData,

    on: function jqLiteOn(element, type, fn, unsupported) {
      if (isDefined(unsupported)) throw jqLiteMinErr("onargs", "jqLite#on() does not support the `selector` or `eventData` parameters");

      // Do not add event handlers to non-elements because they will not be cleaned up.
      if (!jqLiteAcceptsData(element)) {
        return;
      }

      var expandoStore = jqLiteExpandoStore(element, true);
      var events = expandoStore.events;
      var handle = expandoStore.handle;

      if (!handle) {
        handle = expandoStore.handle = createEventHandler(element, events);
      }

      // http://jsperf.com/string-indexof-vs-split
      var types = type.indexOf(" ") >= 0 ? type.split(" ") : [type];
      var i = types.length;

      var addHandler = function (type, specialHandlerWrapper, noEventListener) {
        var eventFns = events[type];

        if (!eventFns) {
          eventFns = events[type] = [];
          eventFns.specialHandlerWrapper = specialHandlerWrapper;
          if (type !== "$destroy" && !noEventListener) {
            element.addEventListener(type, handle);
          }
        }

        eventFns.push(fn);
      };

      while (i--) {
        type = types[i];
        if (MOUSE_EVENT_MAP[type]) {
          addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
          addHandler(type, undefined, true);
        } else {
          addHandler(type);
        }
      }
    },

    off: jqLiteOff,

    one: function (element, type, fn) {
      element = jqLite(element);

      // add the listener twice so that when it is called
      // you can remove the original function and still be
      // able to call element.off(ev, fn) normally
      element.on(type, function onFn() {
        element.off(type, fn);
        element.off(type, onFn);
      });
      element.on(type, fn);
    },

    replaceWith: function (element, replaceNode) {
      var index, parent = element.parentNode;
      jqLiteDealoc(element);
      forEach(new JQLite(replaceNode), function (node) {
        if (index) {
          parent.insertBefore(node, index.nextSibling);
        } else {
          parent.replaceChild(node, element);
        }
        index = node;
      });
    },

    children: function (element) {
      var children = [];
      forEach(element.childNodes, function (element) {
        if (element.nodeType === NODE_TYPE_ELEMENT) {
          children.push(element);
        }
      });
      return children;
    },

    contents: function (element) {
      return element.contentDocument || element.childNodes || [];
    },

    append: function (element, node) {
      var nodeType = element.nodeType;
      if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

      node = new JQLite(node);

      for (var i = 0, ii = node.length; i < ii; i++) {
        var child = node[i];
        element.appendChild(child);
      }
    },

    prepend: function (element, node) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        var index = element.firstChild;
        forEach(new JQLite(node), function (child) {
          element.insertBefore(child, index);
        });
      }
    },

    wrap: function (element, wrapNode) {
      jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
    },

    remove: jqLiteRemove,

    detach: function (element) {
      jqLiteRemove(element, true);
    },

    after: function (element, newElement) {
      var index = element, parent = element.parentNode;

      if (parent) {
        newElement = new JQLite(newElement);

        for (var i = 0, ii = newElement.length; i < ii; i++) {
          var node = newElement[i];
          parent.insertBefore(node, index.nextSibling);
          index = node;
        }
      }
    },

    addClass: jqLiteAddClass,
    removeClass: jqLiteRemoveClass,

    toggleClass: function (element, selector, condition) {
      if (selector) {
        forEach(selector.split(" "), function (className) {
          var classCondition = condition;
          if (isUndefined(classCondition)) {
            classCondition = !jqLiteHasClass(element, className);
          }
          (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
        });
      }
    },

    parent: function (element) {
      var parent = element.parentNode;
      return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
    },

    next: function (element) {
      return element.nextElementSibling;
    },

    find: function (element, selector) {
      if (element.getElementsByTagName) {
        return element.getElementsByTagName(selector);
      } else {
        return [];
      }
    },

    clone: jqLiteClone,

    triggerHandler: function (element, event, extraParameters) {

      var dummyEvent, eventFnsCopy, handlerArgs;
      var eventName = event.type || event;
      var expandoStore = jqLiteExpandoStore(element);
      var events = expandoStore && expandoStore.events;
      var eventFns = events && events[eventName];

      if (eventFns) {
      // Create a dummy event to pass to the handlers
        dummyEvent = {
          preventDefault: function () { this.defaultPrevented = true; },
          isDefaultPrevented: function () { return this.defaultPrevented === true; },
          stopImmediatePropagation: function () { this.immediatePropagationStopped = true; },
          isImmediatePropagationStopped: function () { return this.immediatePropagationStopped === true; },
          stopPropagation: noop,
          type: eventName,
          target: element
        };

        // If a custom event was provided then extend our dummy event with it
        if (event.type) {
          dummyEvent = extend(dummyEvent, event);
        }

        // Copy event handlers in case event handlers array is modified during execution.
        eventFnsCopy = shallowCopy(eventFns);
        handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

        forEach(eventFnsCopy, function (fn) {
          if (!dummyEvent.isImmediatePropagationStopped()) {
            fn.apply(element, handlerArgs);
          }
        });
      }
    }
  }, function (fn, name) {
  /**
   * chaining functions
   */
    JQLite.prototype[name] = function (arg1, arg2, arg3) {
      var value;

      for (var i = 0, ii = this.length; i < ii; i++) {
        if (isUndefined(value)) {
          value = fn(this[i], arg1, arg2, arg3);
          if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
            value = jqLite(value);
          }
        } else {
          jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
        }
      }
      return isDefined(value) ? value : this;
    };
  });

  // bind legacy bind/unbind to on/off
  JQLite.prototype.bind = JQLite.prototype.on;
  JQLite.prototype.unbind = JQLite.prototype.off;

  // Provider for private $$jqLite service
  /** @this */
  function $$jqLiteProvider() {
    this.$get = function $$jqLite() {
      return extend(JQLite, {
        hasClass: function (node, classes) {
          if (node.attr) node = node[0];
          return jqLiteHasClass(node, classes);
        },
        addClass: function (node, classes) {
          if (node.attr) node = node[0];
          return jqLiteAddClass(node, classes);
        },
        removeClass: function (node, classes) {
          if (node.attr) node = node[0];
          return jqLiteRemoveClass(node, classes);
        }
      });
    };
  }

  /**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
  function hashKey(obj, nextUidFn) {
    var key = obj && obj.$$hashKey;

    if (key) {
      if (typeof key === "function") {
        key = obj.$$hashKey();
      }
      return key;
    }

    var objType = typeof obj;
    if (objType === "function" || (objType === "object" && obj !== null)) {
      key = obj.$$hashKey = objType + ":" + (nextUidFn || nextUid)();
    } else {
      key = objType + ":" + obj;
    }

    return key;
  }

  // A minimal ES2015 Map implementation.
  // Should be bug/feature equivalent to the native implementations of supported browsers
  // (for the features required in Angular).
  // See https://kangax.github.io/compat-table/es6/#test-Map
  var nanKey = Object.create(null);
  function NgMapShim() {
    this._keys = [];
    this._values = [];
    this._lastKey = NaN;
    this._lastIndex = -1;
  }
  NgMapShim.prototype = {
    _idx: function (key) {
      if (key === this._lastKey) {
        return this._lastIndex;
      }
      this._lastKey = key;
      this._lastIndex = this._keys.indexOf(key);
      return this._lastIndex;
    },
    _transformKey: function (key) {
      return isNumberNaN(key) ? nanKey : key;
    },
    get: function (key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx !== -1) {
        return this._values[idx];
      }
    },
    set: function (key, value) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx === -1) {
        idx = this._lastIndex = this._keys.length;
      }
      this._keys[idx] = key;
      this._values[idx] = value;

    // Support: IE11
    // Do not `return this` to simulate the partial IE11 implementation
    },
    delete: function (key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx === -1) {
        return false;
      }
      this._keys.splice(idx, 1);
      this._values.splice(idx, 1);
      this._lastKey = NaN;
      this._lastIndex = -1;
      return true;
    }
  };

  // For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
  // are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
  // implementations get more stable, we can reconsider switching to `window.Map` (when available).
  var NgMap = NgMapShim;

  var $$MapProvider = [/** @this */function () {
    this.$get = [function () {
      return NgMap;
    }];
  }];

  /**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */

  /**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

  var ARROW_ARG = /^([^(]+?)=>/;
  var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
  var FN_ARG_SPLIT = /,/;
  var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
  var $injectorMinErr = minErr("$injector");

  function stringifyFn(fn) {
    return Function.prototype.toString.call(fn);
  }

  function extractArgs(fn) {
    var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ""),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
    return args;
  }

  function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
    var args = extractArgs(fn);
    if (args) {
      return "function(" + (args[1] || "").replace(/[\s\r\n]+/, " ") + ")";
    }
    return "fn";
  }

  function annotate(fn, strictDi, name) {
    var $inject,
      argDecl,
      last;

    if (typeof fn === "function") {
      if (!($inject = fn.$inject)) {
        $inject = [];
        if (fn.length) {
          if (strictDi) {
            if (!isString(name) || !name) {
              name = fn.name || anonFn(fn);
            }
            throw $injectorMinErr("strictdi",
              "{0} is not using explicit annotation and cannot be invoked in strict mode", name);
          }
          argDecl = extractArgs(fn);
          forEach(argDecl[1].split(FN_ARG_SPLIT), function (arg) {
            arg.replace(FN_ARG, function (all, underscore, name) {
              $inject.push(name);
            });
          });
        }
        fn.$inject = $inject;
      }
    } else if (isArray(fn)) {
      last = fn.length - 1;
      assertArgFn(fn[last], "fn");
      $inject = fn.slice(0, last);
    } else {
      assertArgFn(fn, "fn", true);
    }
    return $inject;
  }

  // /////////////////////////////////////

  /**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

  /**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */

  /**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

  /**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

  /**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

  /**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

  /**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */
  /**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */

  /**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

  /**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

  /**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */

  /**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */

  /**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */

  /**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */

  /**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */

  function createInjector(modulesToLoad, strictDi) {
    strictDi = (strictDi === true);
    var INSTANTIATING = {},
      providerSuffix = "Provider",
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
          provider: supportObject(provider),
          factory: supportObject(factory),
          service: supportObject(service),
          value: supportObject(value),
          constant: supportObject(constant),
          decorator: decorator
        }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function (serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr("unpr", "Unknown provider: {0}", path.join(" <- "));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function (serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
              provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

    providerCache["$injector" + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
    instanceInjector.modules = providerInjector.modules = createMap();
    var runBlocks = loadModules(modulesToLoad);
    instanceInjector = protoInstanceInjector.get("$injector");
    instanceInjector.strictDi = strictDi;
    forEach(runBlocks, function (fn) { if (fn) instanceInjector.invoke(fn); });

    instanceInjector.loadNewModules = function (mods) {
      forEach(loadModules(mods), function (fn) { if (fn) instanceInjector.invoke(fn); });
    };

    return instanceInjector;

    // //////////////////////////////////
    // $provider
    // //////////////////////////////////

    function supportObject(delegate) {
      return function (key, value) {
        if (isObject(key)) {
          forEach(key, reverseParams(delegate));
        } else {
          return delegate(key, value);
        }
      };
    }

    function provider(name, provider_) {
      assertNotHasOwnProperty(name, "service");
      if (isFunction(provider_) || isArray(provider_)) {
        provider_ = providerInjector.instantiate(provider_);
      }
      if (!provider_.$get) {
        throw $injectorMinErr("pget", "Provider '{0}' must define $get factory method.", name);
      }
      return (providerCache[name + providerSuffix] = provider_);
    }

    function enforceReturnValue(name, factory) {
      return /** @this */ function enforcedReturnValue() {
        var result = instanceInjector.invoke(factory, this);
        if (isUndefined(result)) {
          throw $injectorMinErr("undef", "Provider '{0}' must return a value from $get factory method.", name);
        }
        return result;
      };
    }

    function factory(name, factoryFn, enforce) {
      return provider(name, {
        $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
      });
    }

    function service(name, constructor) {
      return factory(name, ["$injector", function ($injector) {
        return $injector.instantiate(constructor);
      }]);
    }

    function value(name, val) { return factory(name, valueFn(val), false); }

    function constant(name, value) {
      assertNotHasOwnProperty(name, "constant");
      providerCache[name] = value;
      instanceCache[name] = value;
    }

    function decorator(serviceName, decorFn) {
      var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

      origProvider.$get = function () {
        var origInstance = instanceInjector.invoke(orig$get, origProvider);
        return instanceInjector.invoke(decorFn, null, { $delegate: origInstance });
      };
    }

    // //////////////////////////////////
    // Module Loading
    // //////////////////////////////////
    function loadModules(modulesToLoad) {
      assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), "modulesToLoad", "not an array");
      var runBlocks = [], moduleFn;
      forEach(modulesToLoad, function (module) {
        if (loadedModules.get(module)) return;
        loadedModules.set(module, true);

        function runInvokeQueue(queue) {
          var i, ii;
          for (i = 0, ii = queue.length; i < ii; i++) {
            var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

            provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
          }
        }

        try {
          if (isString(module)) {
            moduleFn = angularModule(module);
            instanceInjector.modules[module] = moduleFn;
            runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
            runInvokeQueue(moduleFn._invokeQueue);
            runInvokeQueue(moduleFn._configBlocks);
          } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
          } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
          } else {
            assertArgFn(module, "module");
          }
        } catch (e) {
          if (isArray(module)) {
            module = module[module.length - 1];
          }
          if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
            e = e.message + "\n" + e.stack;
          }
          throw $injectorMinErr("modulerr", "Failed to instantiate module {0} due to:\n{1}",
            module, e.stack || e.message || e);
        }
      });
      return runBlocks;
    }

    // //////////////////////////////////
    // internal Injector
    // //////////////////////////////////

    function createInternalInjector(cache, factory) {

      function getService(serviceName, caller) {
        if (cache.hasOwnProperty(serviceName)) {
          if (cache[serviceName] === INSTANTIATING) {
            throw $injectorMinErr("cdep", "Circular dependency found: {0}",
              serviceName + " <- " + path.join(" <- "));
          }
          return cache[serviceName];
        } else {
          try {
            path.unshift(serviceName);
            cache[serviceName] = INSTANTIATING;
            cache[serviceName] = factory(serviceName, caller);
            return cache[serviceName];
          } catch (err) {
            if (cache[serviceName] === INSTANTIATING) {
              delete cache[serviceName];
            }
            throw err;
          } finally {
            path.shift();
          }
        }
      }

      function injectionArgs(fn, locals, serviceName) {
        var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

        for (var i = 0, length = $inject.length; i < length; i++) {
          var key = $inject[i];
          if (typeof key !== "string") {
            throw $injectorMinErr("itkn",
              "Incorrect injection token! Expected service name as string, got {0}", key);
          }
          args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
            getService(key, serviceName));
        }
        return args;
      }

      function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
        if (msie || typeof func !== "function") {
          return false;
        }
        var result = func.$$ngIsClass;
        if (!isBoolean(result)) {
        // Support: Edge 12-13 only
        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
          result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
        }
        return result;
      }

      function invoke(fn, self, locals, serviceName) {
        if (typeof locals === "string") {
          serviceName = locals;
          locals = null;
        }

        var args = injectionArgs(fn, locals, serviceName);
        if (isArray(fn)) {
          fn = fn[fn.length - 1];
        }

        if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
          return fn.apply(self, args);
        } else {
          args.unshift(null);
          return new (Function.prototype.bind.apply(fn, args))();
        }
      }

      function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
        var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
        var args = injectionArgs(Type, locals, serviceName);
        // Empty object at position 0 is ignored for invocation with `new`, but required.
        args.unshift(null);
        return new (Function.prototype.bind.apply(ctor, args))();
      }

      return {
        invoke: invoke,
        instantiate: instantiate,
        get: getService,
        annotate: createInjector.$$annotate,
        has: function (name) {
          return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
        }
      };
    }
  }

  createInjector.$$annotate = annotate;

  /**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
  function $AnchorScrollProvider() {

    var autoScrollingEnabled = true;

    /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
    this.disableAutoScrolling = function () {
      autoScrollingEnabled = false;
    };

    /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
    this.$get = ["$window", "$location", "$rootScope", function ($window, $location, $rootScope) {
      var document = $window.document;

      // Helper function to get first anchor from a NodeList
      // (using `Array#some()` instead of `angular#forEach()` since it's more performant
      //  and working in all supported browsers.)
      function getFirstAnchor(list) {
        var result = null;
        Array.prototype.some.call(list, function (element) {
          if (nodeName_(element) === "a") {
            result = element;
            return true;
          }
        });
        return result;
      }

      function getYOffset() {

        var offset = scroll.yOffset;

        if (isFunction(offset)) {
          offset = offset();
        } else if (isElement(offset)) {
          var elem = offset[0];
          var style = $window.getComputedStyle(elem);
          if (style.position !== "fixed") {
            offset = 0;
          } else {
            offset = elem.getBoundingClientRect().bottom;
          }
        } else if (!isNumber(offset)) {
          offset = 0;
        }

        return offset;
      }

      function scrollTo(elem) {
        if (elem) {
          elem.scrollIntoView();

          var offset = getYOffset();

          if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
            var elemTop = elem.getBoundingClientRect().top;
            $window.scrollBy(0, elemTop - offset);
          }
        } else {
          $window.scrollTo(0, 0);
        }
      }

      function scroll(hash) {
      // Allow numeric hashes
        hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
        var elm;

        // empty hash, scroll to the top of the page
        if (!hash) scrollTo(null);

        // element with given id
        else if ((elm = document.getElementById(hash))) scrollTo(elm);

        // first anchor with given name :-D
        else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

        // no element and hash === 'top', scroll to the top of the page
        else if (hash === "top") scrollTo(null);
      }

      // does not scroll when user clicks on anchor link that is currently on
      // (no url change, no $location.hash() change), browser native does scroll
      if (autoScrollingEnabled) {
        $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
          function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
            if (newVal === oldVal && newVal === "") return;

            jqLiteDocumentLoaded(function () {
              $rootScope.$evalAsync(scroll);
            });
          });
      }

      return scroll;
    }];
  }

  var $animateMinErr = minErr("$animate");
  var ELEMENT_NODE = 1;
  var NG_ANIMATE_CLASSNAME = "ng-animate";

  function mergeClasses(a, b) {
    if (!a && !b) return "";
    if (!a) return b;
    if (!b) return a;
    if (isArray(a)) a = a.join(" ");
    if (isArray(b)) b = b.join(" ");
    return a + " " + b;
  }

  function extractElementNode(element) {
    for (var i = 0; i < element.length; i++) {
      var elm = element[i];
      if (elm.nodeType === ELEMENT_NODE) {
        return elm;
      }
    }
  }

  function splitClasses(classes) {
    if (isString(classes)) {
      classes = classes.split(" ");
    }

    // Use createMap() to prevent class assumptions involving property names in
    // Object.prototype
    var obj = createMap();
    forEach(classes, function (klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  // if any other type of options value besides an Object value is
  // passed into the $animate.method() animation then this helper code
  // will be run which will ignore it. While this patch is not the
  // greatest solution to this, a lot of existing plugins depend on
  // $animate to either call the callback (< 1.2) or return a promise
  // that can be changed. This helper function ensures that the options
  // are wiped clean incase a callback function is provided.
  function prepareAnimateOptions(options) {
    return isObject(options)
      ? options
      : {};
  }

  var $$CoreAnimateJsProvider = /** @this */ function () {
    this.$get = noop;
  };

  // this is prefixed with Core since it conflicts with
  // the animateQueueProvider defined in ngAnimate/animateQueue.js
  var $$CoreAnimateQueueProvider = /** @this */ function () {
    var postDigestQueue = new NgMap();
    var postDigestElements = [];

    this.$get = ["$$AnimateRunner", "$rootScope",
      function ($$AnimateRunner, $rootScope) {
        return {
          enabled: noop,
          on: noop,
          off: noop,
          pin: noop,

          push: function (element, event, options, domOperation) {
            if (domOperation) {
              domOperation();
            }

            options = options || {};
            if (options.from) {
              element.css(options.from);
            }
            if (options.to) {
              element.css(options.to);
            }

            if (options.addClass || options.removeClass) {
              addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
            }

            var runner = new $$AnimateRunner();

            // since there are no animations to run the runner needs to be
            // notified that the animation call is complete.
            runner.complete();
            return runner;
          }
        };

        function updateData(data, classes, value) {
          var changed = false;
          if (classes) {
            classes = isString(classes) ? classes.split(" ") :
              isArray(classes) ? classes : [];
            forEach(classes, function (className) {
              if (className) {
                changed = true;
                data[className] = value;
              }
            });
          }
          return changed;
        }

        function handleCSSClassChanges() {
          forEach(postDigestElements, function (element) {
            var data = postDigestQueue.get(element);
            if (data) {
              var existing = splitClasses(element.attr("class"));
              var toAdd = "";
              var toRemove = "";
              forEach(data, function (status, className) {
                var hasClass = !!existing[className];
                if (status !== hasClass) {
                  if (status) {
                    toAdd += (toAdd.length ? " " : "") + className;
                  } else {
                    toRemove += (toRemove.length ? " " : "") + className;
                  }
                }
              });

              forEach(element, function (elm) {
                if (toAdd) {
                  jqLiteAddClass(elm, toAdd);
                }
                if (toRemove) {
                  jqLiteRemoveClass(elm, toRemove);
                }
              });
              postDigestQueue.delete(element);
            }
          });
          postDigestElements.length = 0;
        }

        function addRemoveClassesPostDigest(element, add, remove) {
          var data = postDigestQueue.get(element) || {};

          var classesAdded = updateData(data, add, true);
          var classesRemoved = updateData(data, remove, false);

          if (classesAdded || classesRemoved) {

            postDigestQueue.set(element, data);
            postDigestElements.push(element);

            if (postDigestElements.length === 1) {
              $rootScope.$$postDigest(handleCSSClassChanges);
            }
          }
        }
      }];
  };

  /**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
  var $AnimateProvider = ["$provide", /** @this */ function ($provide) {
    var provider = this;
    var classNameFilter = null;
    var customFilter = null;

    this.$$registeredAnimations = Object.create(null);

    /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
    this.register = function (name, factory) {
      if (name && name.charAt(0) !== ".") {
        throw $animateMinErr("notcsel", "Expecting class selector starting with '.' got '{0}'.", name);
      }

      var key = name + "-animation";
      provider.$$registeredAnimations[name.substr(1)] = key;
      $provide.factory(key, factory);
    };

    /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */
    this.customFilter = function (filterFn) {
      if (arguments.length === 1) {
        customFilter = isFunction(filterFn) ? filterFn : null;
      }

      return customFilter;
    };

    /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
    this.classNameFilter = function (expression) {
      if (arguments.length === 1) {
        classNameFilter = (expression instanceof RegExp) ? expression : null;
        if (classNameFilter) {
          var reservedRegex = new RegExp("[(\\s|\\/)]" + NG_ANIMATE_CLASSNAME + "[(\\s|\\/)]");
          if (reservedRegex.test(classNameFilter.toString())) {
            classNameFilter = null;
            throw $animateMinErr("nongcls", "$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the \"{0}\" CSS class.", NG_ANIMATE_CLASSNAME);
          }
        }
      }
      return classNameFilter;
    };

    this.$get = ["$$animateQueue", function ($$animateQueue) {
      function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
        if (afterElement) {
          var afterNode = extractElementNode(afterElement);
          if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
            afterElement = null;
          }
        }
        if (afterElement) {
          afterElement.after(element);
        } else {
          parentElement.prepend(element);
        }
      }

      /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
      return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

        /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       */
        on: $$animateQueue.on,

        /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
        off: $$animateQueue.off,

        /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
        pin: $$animateQueue.pin,

        /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
        enabled: $$animateQueue.enabled,

        /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation.
       *
       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
       */
        cancel: function (runner) {
          if (runner.end) {
            runner.end();
          }
        },

        /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        enter: function (element, parent, after, options) {
          parent = parent && jqLite(parent);
          after = after && jqLite(after);
          parent = parent || after.parent();
          domInsert(element, parent, after);
          return $$animateQueue.push(element, "enter", prepareAnimateOptions(options));
        },

        /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        move: function (element, parent, after, options) {
          parent = parent && jqLite(parent);
          after = after && jqLite(after);
          parent = parent || after.parent();
          domInsert(element, parent, after);
          return $$animateQueue.push(element, "move", prepareAnimateOptions(options));
        },

        /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        leave: function (element, options) {
          return $$animateQueue.push(element, "leave", prepareAnimateOptions(options), function () {
            element.remove();
          });
        },

        /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        addClass: function (element, className, options) {
          options = prepareAnimateOptions(options);
          options.addClass = mergeClasses(options.addclass, className);
          return $$animateQueue.push(element, "addClass", options);
        },

        /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        removeClass: function (element, className, options) {
          options = prepareAnimateOptions(options);
          options.removeClass = mergeClasses(options.removeClass, className);
          return $$animateQueue.push(element, "removeClass", options);
        },

        /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        setClass: function (element, add, remove, options) {
          options = prepareAnimateOptions(options);
          options.addClass = mergeClasses(options.addClass, add);
          options.removeClass = mergeClasses(options.removeClass, remove);
          return $$animateQueue.push(element, "setClass", options);
        },

        /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
        animate: function (element, from, to, className, options) {
          options = prepareAnimateOptions(options);
          options.from = options.from ? extend(options.from, from) : from;
          options.to = options.to ? extend(options.to, to) : to;

          className = className || "ng-inline-animate";
          options.tempClasses = mergeClasses(options.tempClasses, className);
          return $$animateQueue.push(element, "animate", options);
        }
      };
    }];
  }];

  var $$AnimateAsyncRunFactoryProvider = /** @this */ function () {
    this.$get = ["$$rAF", function ($$rAF) {
      var waitQueue = [];

      function waitForTick(fn) {
        waitQueue.push(fn);
        if (waitQueue.length > 1) return;
        $$rAF(function () {
          for (var i = 0; i < waitQueue.length; i++) {
            waitQueue[i]();
          }
          waitQueue = [];
        });
      }

      return function () {
        var passed = false;
        waitForTick(function () {
          passed = true;
        });
        return function (callback) {
          if (passed) {
            callback();
          } else {
            waitForTick(callback);
          }
        };
      };
    }];
  };

  var $$AnimateRunnerFactoryProvider = /** @this */ function () {
    this.$get = ["$q", "$sniffer", "$$animateAsyncRun", "$$isDocumentHidden", "$timeout",
      function ($q, $sniffer, $$animateAsyncRun, $$isDocumentHidden, $timeout) {

        var INITIAL_STATE = 0;
        var DONE_PENDING_STATE = 1;
        var DONE_COMPLETE_STATE = 2;

        AnimateRunner.chain = function (chain, callback) {
          var index = 0;

          next();
          function next() {
            if (index === chain.length) {
              callback(true);
              return;
            }

            chain[index](function (response) {
              if (response === false) {
                callback(false);
                return;
              }
              index++;
              next();
            });
          }
        };

        AnimateRunner.all = function (runners, callback) {
          var count = 0;
          var status = true;
          forEach(runners, function (runner) {
            runner.done(onProgress);
          });

          function onProgress(response) {
            status = status && response;
            if (++count === runners.length) {
              callback(status);
            }
          }
        };

        function AnimateRunner(host) {
          this.setHost(host);

          var rafTick = $$animateAsyncRun();
          var timeoutTick = function (fn) {
            $timeout(fn, 0, false);
          };

          this._doneCallbacks = [];
          this._tick = function (fn) {
            if ($$isDocumentHidden()) {
              timeoutTick(fn);
            } else {
              rafTick(fn);
            }
          };
          this._state = 0;
        }

        AnimateRunner.prototype = {
          setHost: function (host) {
            this.host = host || {};
          },

          done: function (fn) {
            if (this._state === DONE_COMPLETE_STATE) {
              fn();
            } else {
              this._doneCallbacks.push(fn);
            }
          },

          progress: noop,

          getPromise: function () {
            if (!this.promise) {
              var self = this;
              this.promise = $q(function (resolve, reject) {
                self.done(function (status) {
                  if (status === false) {
                    reject();
                  } else {
                    resolve();
                  }
                });
              });
            }
            return this.promise;
          },

          then: function (resolveHandler, rejectHandler) {
            return this.getPromise().then(resolveHandler, rejectHandler);
          },

          "catch": function (handler) {
            return this.getPromise()["catch"](handler);
          },

          "finally": function (handler) {
            return this.getPromise()["finally"](handler);
          },

          pause: function () {
            if (this.host.pause) {
              this.host.pause();
            }
          },

          resume: function () {
            if (this.host.resume) {
              this.host.resume();
            }
          },

          end: function () {
            if (this.host.end) {
              this.host.end();
            }
            this._resolve(true);
          },

          cancel: function () {
            if (this.host.cancel) {
              this.host.cancel();
            }
            this._resolve(false);
          },

          complete: function (response) {
            var self = this;
            if (self._state === INITIAL_STATE) {
              self._state = DONE_PENDING_STATE;
              self._tick(function () {
                self._resolve(response);
              });
            }
          },

          _resolve: function (response) {
            if (this._state !== DONE_COMPLETE_STATE) {
              forEach(this._doneCallbacks, function (fn) {
                fn(response);
              });
              this._doneCallbacks.length = 0;
              this._state = DONE_COMPLETE_STATE;
            }
          }
        };

        return AnimateRunner;
      }];
  };

  /* exported $CoreAnimateCssProvider */

  /**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
  var $CoreAnimateCssProvider = function () {
    this.$get = ["$$rAF", "$q", "$$AnimateRunner", function ($$rAF, $q, $$AnimateRunner) {

      return function (element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
        var options = initialOptions || {};
        if (!options.$$prepared) {
          options = copy(options);
        }

        // there is no point in applying the styles since
        // there is no animation that goes on at all in
        // this version of $animateCss.
        if (options.cleanupStyles) {
          options.from = options.to = null;
        }

        if (options.from) {
          element.css(options.from);
          options.from = null;
        }

        var closed, runner = new $$AnimateRunner();
        return {
          start: run,
          end: run
        };

        function run() {
          $$rAF(function () {
            applyAnimationContents();
            if (!closed) {
              runner.complete();
            }
            closed = true;
          });
          return runner;
        }

        function applyAnimationContents() {
          if (options.addClass) {
            element.addClass(options.addClass);
            options.addClass = null;
          }
          if (options.removeClass) {
            element.removeClass(options.removeClass);
            options.removeClass = null;
          }
          if (options.to) {
            element.css(options.to);
            options.to = null;
          }
        }
      };
    }];
  };

  /* global stripHash: true */

  /**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
  /**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
  function Browser(window, document, $log, $sniffer) {
    var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

    self.isMock = false;

    var outstandingRequestCount = 0;
    var outstandingRequestCallbacks = [];

    // TODO(vojta): remove this temporary api
    self.$$completeOutstandingRequest = completeOutstandingRequest;
    self.$$incOutstandingRequestCount = function () { outstandingRequestCount++; };

    /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
    function completeOutstandingRequest(fn) {
      try {
        fn.apply(null, sliceArgs(arguments, 1));
      } finally {
        outstandingRequestCount--;
        if (outstandingRequestCount === 0) {
          while (outstandingRequestCallbacks.length) {
            try {
              outstandingRequestCallbacks.pop()();
            } catch (e) {
              $log.error(e);
            }
          }
        }
      }
    }

    function getHash(url) {
      var index = url.indexOf("#");
      return index === -1 ? "" : url.substr(index);
    }

    /**
   * @private
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
    self.notifyWhenNoOutstandingRequests = function (callback) {
      if (outstandingRequestCount === 0) {
        callback();
      } else {
        outstandingRequestCallbacks.push(callback);
      }
    };

    // ////////////////////////////////////////////////////////////
    // URL API
    // ////////////////////////////////////////////////////////////

    var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find("base"),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

    cacheState();

    /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
    self.url = function (url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
      if (isUndefined(state)) {
        state = null;
      }

      // Android Browser BFCache causes location, history reference to become stale.
      if (location !== window.location) location = window.location;
      if (history !== window.history) history = window.history;

      // setter
      if (url) {
        var sameState = lastHistoryState === state;

        // Don't change anything if previous and current URLs and states match. This also prevents
        // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
        // See https://github.com/angular/angular.js/commit/ffb2701
        if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
          return self;
        }
        var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
        lastBrowserUrl = url;
        lastHistoryState = state;
        // Don't use history API if only the hash changed
        // due to a bug in IE10/IE11 which leads
        // to not firing a `hashchange` nor `popstate` event
        // in some cases (see #9143).
        if ($sniffer.history && (!sameBase || !sameState)) {
          history[replace ? "replaceState" : "pushState"](state, "", url);
          cacheState();
        } else {
          if (!sameBase) {
            pendingLocation = url;
          }
          if (replace) {
            location.replace(url);
          } else if (!sameBase) {
            location.href = url;
          } else {
            location.hash = getHash(url);
          }
          if (location.href !== url) {
            pendingLocation = url;
          }
        }
        if (pendingLocation) {
          pendingLocation = url;
        }
        return self;
        // getter
      } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
        return pendingLocation || location.href.replace(/%27/g, "'");
      }
    };

    /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
    self.state = function () {
      return cachedState;
    };

    var urlChangeListeners = [],
      urlChangeInit = false;

    function cacheStateAndFireUrlChange() {
      pendingLocation = null;
      fireStateOrUrlChange();
    }

    // This variable should be used *only* inside the cacheState function.
    var lastCachedState = null;
    function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
      cachedState = getCurrentState();
      cachedState = isUndefined(cachedState) ? null : cachedState;

      // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
      if (equals(cachedState, lastCachedState)) {
        cachedState = lastCachedState;
      }

      lastCachedState = cachedState;
      lastHistoryState = cachedState;
    }

    function fireStateOrUrlChange() {
      var prevLastHistoryState = lastHistoryState;
      cacheState();

      if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
        return;
      }

      lastBrowserUrl = self.url();
      lastHistoryState = cachedState;
      forEach(urlChangeListeners, function (listener) {
        listener(self.url(), cachedState);
      });
    }

    /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
    self.onUrlChange = function (callback) {
    // TODO(vojta): refactor to use node's syntax for events
      if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers don't
      // fire popstate when user changes the address bar and don't fire hashchange when url
      // changed by push/replaceState

        // html5 history api - popstate event
        if ($sniffer.history) jqLite(window).on("popstate", cacheStateAndFireUrlChange);
        // hashchange event
        jqLite(window).on("hashchange", cacheStateAndFireUrlChange);

        urlChangeInit = true;
      }

      urlChangeListeners.push(callback);
      return callback;
    };

    /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
    self.$$applicationDestroyed = function () {
      jqLite(window).off("hashchange popstate", cacheStateAndFireUrlChange);
    };

    /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
    self.$$checkUrlChange = fireStateOrUrlChange;

    // ////////////////////////////////////////////////////////////
    // Misc API
    // ////////////////////////////////////////////////////////////

    /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
    self.baseHref = function () {
      var href = baseElement.attr("href");
      return href ? href.replace(/^(https?:)?\/\/[^/]*/, "") : "";
    };

    /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
    self.defer = function (fn, delay) {
      var timeoutId;
      outstandingRequestCount++;
      timeoutId = setTimeout(function () {
        delete pendingDeferIds[timeoutId];
        completeOutstandingRequest(fn);
      }, delay || 0);
      pendingDeferIds[timeoutId] = true;
      return timeoutId;
    };

    /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
    self.defer.cancel = function (deferId) {
      if (pendingDeferIds[deferId]) {
        delete pendingDeferIds[deferId];
        clearTimeout(deferId);
        completeOutstandingRequest(noop);
        return true;
      }
      return false;
    };

  }

  /** @this */
  function $BrowserProvider() {
    this.$get = ["$window", "$log", "$sniffer", "$document",
      function ($window, $log, $sniffer, $document) {
        return new Browser($window, $document, $log, $sniffer);
      }];
  }

  /**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
  function $CacheFactoryProvider() {

    this.$get = function () {
      var caches = {};

      function cacheFactory(cacheId, options) {
        if (cacheId in caches) {
          throw minErr("$cacheFactory")("iid", "CacheId '{0}' is already taken!", cacheId);
        }

        var size = 0,
          stats = extend({}, options, { id: cacheId }),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

        /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
        return (caches[cacheId] = {

          /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
          put: function (key, value) {
            if (isUndefined(value)) return;
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key] || (lruHash[key] = { key: key });

              refresh(lruEntry);
            }

            if (!(key in data)) size++;
            data[key] = value;

            if (size > capacity) {
              this.remove(staleEnd.key);
            }

            return value;
          },

          /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
          get: function (key) {
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key];

              if (!lruEntry) return;

              refresh(lruEntry);
            }

            return data[key];
          },

          /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
          remove: function (key) {
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key];

              if (!lruEntry) return;

              if (lruEntry === freshEnd) freshEnd = lruEntry.p;
              if (lruEntry === staleEnd) staleEnd = lruEntry.n;
              link(lruEntry.n, lruEntry.p);

              delete lruHash[key];
            }

            if (!(key in data)) return;

            delete data[key];
            size--;
          },

          /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
          removeAll: function () {
            data = createMap();
            size = 0;
            lruHash = createMap();
            freshEnd = staleEnd = null;
          },

          /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
          destroy: function () {
            data = null;
            stats = null;
            lruHash = null;
            delete caches[cacheId];
          },

          /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
          info: function () {
            return extend({}, stats, { size: size });
          }
        });

        /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
        function refresh(entry) {
          if (entry !== freshEnd) {
            if (!staleEnd) {
              staleEnd = entry;
            } else if (staleEnd === entry) {
              staleEnd = entry.n;
            }

            link(entry.n, entry.p);
            link(entry, freshEnd);
            freshEnd = entry;
            freshEnd.n = null;
          }
        }

        /**
       * bidirectionally links two entries of the LRU linked list
       */
        function link(nextEntry, prevEntry) {
          if (nextEntry !== prevEntry) {
            if (nextEntry) nextEntry.p = prevEntry; // p stands for previous, 'prev' didn't minify
            if (prevEntry) prevEntry.n = nextEntry; // n stands for next, 'next' didn't minify
          }
        }
      }

      /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
      cacheFactory.info = function () {
        var info = {};
        forEach(caches, function (cache, cacheId) {
          info[cacheId] = cache.info();
        });
        return info;
      };

      /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
      cacheFactory.get = function (cacheId) {
        return caches[cacheId];
      };

      return cacheFactory;
    };
  }

  /**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */
  function $TemplateCacheProvider() {
    this.$get = ["$cacheFactory", function ($cacheFactory) {
      return $cacheFactory("templates");
    }];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */

  /**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * <div class="alert alert-warning">
 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
 * </div>
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have
 * unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */

  var $compileMinErr = minErr("$compile");

  function UNINITIALIZED_VALUE() {}
  var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

  /**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
  $CompileProvider.$inject = ["$provide", "$$sanitizeUriProvider"];
  /** @this */
  function $CompileProvider($provide, $$sanitizeUriProvider) {
    var hasDirectives = {},
      Suffix = "Directive",
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap("ngSrc,ngSrcset,src,srcset"),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

    // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
    // The assumption is that future DOM event attribute names will begin with
    // 'on' and be composed of only English letters.
    var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
    var bindingCache = createMap();

    function parseIsolateBindings(scope, directiveName, isController) {
      var LOCAL_REGEXP = /^([@&<]|=(\*?))(\??)\s*([\w$]*)$/;

      var bindings = createMap();

      forEach(scope, function (definition, scopeName) {
        definition = definition.trim();

        if (definition in bindingCache) {
          bindings[scopeName] = bindingCache[definition];
          return;
        }
        var match = definition.match(LOCAL_REGEXP);

        if (!match) {
          throw $compileMinErr("iscp",
            "Invalid {3} for directive '{0}'." +
            " Definition: {... {1}: '{2}' ...}",
            directiveName, scopeName, definition,
            (isController ? "controller bindings definition" :
              "isolate scope definition"));
        }

        bindings[scopeName] = {
          mode: match[1][0],
          collection: match[2] === "*",
          optional: match[3] === "?",
          attrName: match[4] || scopeName
        };
        if (match[4]) {
          bindingCache[definition] = bindings[scopeName];
        }
      });

      return bindings;
    }

    function parseDirectiveBindings(directive, directiveName) {
      var bindings = {
        isolateScope: null,
        bindToController: null
      };
      if (isObject(directive.scope)) {
        if (directive.bindToController === true) {
          bindings.bindToController = parseIsolateBindings(directive.scope,
            directiveName, true);
          bindings.isolateScope = {};
        } else {
          bindings.isolateScope = parseIsolateBindings(directive.scope,
            directiveName, false);
        }
      }
      if (isObject(directive.bindToController)) {
        bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
      }
      if (bindings.bindToController && !directive.controller) {
      // There is no controller
        throw $compileMinErr("noctrl",
          "Cannot bind to controller without directive '{0}'s controller.",
          directiveName);
      }
      return bindings;
    }

    function assertValidDirectiveName(name) {
      var letter = name.charAt(0);
      if (!letter || letter !== lowercase(letter)) {
        throw $compileMinErr("baddir", "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
      }
      if (name !== name.trim()) {
        throw $compileMinErr("baddir",
          "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
          name);
      }
    }

    function getDirectiveRequire(directive) {
      var require = directive.require || (directive.controller && directive.name);

      if (!isArray(require) && isObject(require)) {
        forEach(require, function (value, key) {
          var match = value.match(REQUIRE_PREFIX_REGEXP);
          var name = value.substring(match[0].length);
          if (!name) require[key] = match[0] + key;
        });
      }

      return require;
    }

    function getDirectiveRestrict(restrict, name) {
      if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
        throw $compileMinErr("badrestrict",
          "Restrict property '{0}' of directive '{1}' is invalid",
          restrict,
          name);
      }

      return restrict || "EA";
    }

    /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
    this.directive = function registerDirective(name, directiveFactory) {
      assertArg(name, "name");
      assertNotHasOwnProperty(name, "directive");
      if (isString(name)) {
        assertValidDirectiveName(name);
        assertArg(directiveFactory, "directiveFactory");
        if (!hasDirectives.hasOwnProperty(name)) {
          hasDirectives[name] = [];
          $provide.factory(name + Suffix, ["$injector", "$exceptionHandler",
            function ($injector, $exceptionHandler) {
              var directives = [];
              forEach(hasDirectives[name], function (directiveFactory, index) {
                try {
                  var directive = $injector.invoke(directiveFactory);
                  if (isFunction(directive)) {
                    directive = { compile: valueFn(directive) };
                  } else if (!directive.compile && directive.link) {
                    directive.compile = valueFn(directive.link);
                  }
                  directive.priority = directive.priority || 0;
                  directive.index = index;
                  directive.name = directive.name || name;
                  directive.require = getDirectiveRequire(directive);
                  directive.restrict = getDirectiveRestrict(directive.restrict, name);
                  directive.$$moduleName = directiveFactory.$$moduleName;
                  directives.push(directive);
                } catch (e) {
                  $exceptionHandler(e);
                }
              });
              return directives;
            }]);
        }
        hasDirectives[name].push(directiveFactory);
      } else {
        forEach(name, reverseParams(registerDirective));
      }
      return this;
    };

    /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
    this.component = function registerComponent(name, options) {
      if (!isString(name)) {
        forEach(name, reverseParams(bind(this, registerComponent)));
        return this;
      }

      var controller = options.controller || function () {};

      function factory($injector) {
        function makeInjectable(fn) {
          if (isFunction(fn) || isArray(fn)) {
            return /** @this */ function (tElement, tAttrs) {
              return $injector.invoke(fn, this, { $element: tElement, $attrs: tAttrs });
            };
          } else {
            return fn;
          }
        }

        var template = (!options.template && !options.templateUrl ? "" : options.template);
        var ddo = {
          controller: controller,
          controllerAs: identifierForController(options.controller) || options.controllerAs || "$ctrl",
          template: makeInjectable(template),
          templateUrl: makeInjectable(options.templateUrl),
          transclude: options.transclude,
          scope: {},
          bindToController: options.bindings || {},
          restrict: "E",
          require: options.require
        };

        // Copy annotations (starting with $) over to the DDO
        forEach(options, function (val, key) {
          if (key.charAt(0) === "$") ddo[key] = val;
        });

        return ddo;
      }

      // TODO(pete) remove the following `forEach` before we release 1.6.0
      // The component-router@0.2.0 looks for the annotations on the controller constructor
      // Nothing in AngularJS looks for annotations on the factory function but we can't remove
      // it from 1.5.x yet.

      // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
      // These could be used by libraries such as the new component router
      forEach(options, function (val, key) {
        if (key.charAt(0) === "$") {
          factory[key] = val;
          // Don't try to copy over annotations to named controller
          if (isFunction(controller)) controller[key] = val;
        }
      });

      factory.$inject = ["$injector"];

      return this.directive(name, factory);
    };

    /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
    this.aHrefSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
        return this;
      } else {
        return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
      }
    };

    /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
    this.imgSrcSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
        return this;
      } else {
        return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
      }
    };

    /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
    var debugInfoEnabled = true;
    this.debugInfoEnabled = function (enabled) {
      if (isDefined(enabled)) {
        debugInfoEnabled = enabled;
        return this;
      }
      return debugInfoEnabled;
    };

    /**
   * @ngdoc method
   * @name  $compileProvider#preAssignBindingsEnabled
   *
   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
   * current preAssignBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable whether directive controllers are assigned bindings before
   * calling the controller's constructor.
   * If enabled (true), the compiler assigns the value of each of the bindings to the
   * properties of the controller object before the constructor of this object is called.
   *
   * If disabled (false), the compiler calls the constructor first before assigning bindings.
   *
   * The default value is false.
   *
   * @deprecated
   * sinceVersion="1.6.0"
   * removeVersion="1.7.0"
   *
   * This method and the option to assign the bindings before calling the controller's constructor
   * will be removed in v1.7.0.
   */
    var preAssignBindingsEnabled = false;
    this.preAssignBindingsEnabled = function (enabled) {
      if (isDefined(enabled)) {
        preAssignBindingsEnabled = enabled;
        return this;
      }
      return preAssignBindingsEnabled;
    };

    /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
   * current strictComponentBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
   * on the component's HTML tag.
   *
   * The default value is false.
   */
    var strictComponentBindingsEnabled = false;
    this.strictComponentBindingsEnabled = function (enabled) {
      if (isDefined(enabled)) {
        strictComponentBindingsEnabled = enabled;
        return this;
      }
      return strictComponentBindingsEnabled;
    };

    var TTL = 10;
    /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
    this.onChangesTtl = function (value) {
      if (arguments.length) {
        TTL = value;
        return this;
      }
      return TTL;
    };

    var commentDirectivesEnabledConfig = true;
    /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
    this.commentDirectivesEnabled = function (value) {
      if (arguments.length) {
        commentDirectivesEnabledConfig = value;
        return this;
      }
      return commentDirectivesEnabledConfig;
    };

    var cssClassDirectivesEnabledConfig = true;
    /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
    this.cssClassDirectivesEnabled = function (value) {
      if (arguments.length) {
        cssClassDirectivesEnabledConfig = value;
        return this;
      }
      return cssClassDirectivesEnabledConfig;
    };

    this.$get = [
      "$injector", "$interpolate", "$exceptionHandler", "$templateRequest", "$parse",
      "$controller", "$rootScope", "$sce", "$animate", "$$sanitizeUri",
      function ($injector, $interpolate, $exceptionHandler, $templateRequest, $parse,
        $controller, $rootScope, $sce, $animate, $$sanitizeUri) {

        var SIMPLE_ATTR_NAME = /^\w/;
        var specialAttrHolder = window.document.createElement("div");

        var commentDirectivesEnabled = commentDirectivesEnabledConfig;
        var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;

        var onChangesTtl = TTL;
        // The onChanges hooks should all be run together in a single digest
        // When changes occur, the call to trigger their hooks will be added to this queue
        var onChangesQueue;

        // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
        function flushOnChangesQueue() {
          try {
            if (!(--onChangesTtl)) {
              // We have hit the TTL limit so reset everything
              onChangesQueue = undefined;
              throw $compileMinErr("infchng", "{0} $onChanges() iterations reached. Aborting!\n", TTL);
            }
            // We must run this hook in an apply since the $$postDigest runs outside apply
            $rootScope.$apply(function () {
              for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
                try {
                  onChangesQueue[i]();
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
              // Reset the queue to trigger a new schedule next time there is a change
              onChangesQueue = undefined;
            });
          } finally {
            onChangesTtl++;
          }
        }

        function Attributes(element, attributesToCopy) {
          if (attributesToCopy) {
            var keys = Object.keys(attributesToCopy);
            var i, l, key;

            for (i = 0, l = keys.length; i < l; i++) {
              key = keys[i];
              this[key] = attributesToCopy[key];
            }
          } else {
            this.$attr = {};
          }

          this.$$element = element;
        }

        Attributes.prototype = {
          /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
          $normalize: directiveNormalize,

          /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
          $addClass: function (classVal) {
            if (classVal && classVal.length > 0) {
              $animate.addClass(this.$$element, classVal);
            }
          },

          /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
          $removeClass: function (classVal) {
            if (classVal && classVal.length > 0) {
              $animate.removeClass(this.$$element, classVal);
            }
          },

          /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
          $updateClass: function (newClasses, oldClasses) {
            var toAdd = tokenDifference(newClasses, oldClasses);
            if (toAdd && toAdd.length) {
              $animate.addClass(this.$$element, toAdd);
            }

            var toRemove = tokenDifference(oldClasses, newClasses);
            if (toRemove && toRemove.length) {
              $animate.removeClass(this.$$element, toRemove);
            }
          },

          /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
          $set: function (key, value, writeAttr, attrName) {
            // TODO: decide whether or not to throw an error if "class"
            // is set through this function since it may cause $updateClass to
            // become unstable.

            var node = this.$$element[0],
              booleanKey = getBooleanAttrName(node, key),
              aliasedKey = getAliasedAttrName(key),
              observer = key,
              nodeName;

            if (booleanKey) {
              this.$$element.prop(key, value);
              attrName = booleanKey;
            } else if (aliasedKey) {
              this[aliasedKey] = value;
              observer = aliasedKey;
            }

            this[key] = value;

            // translate normalized key to actual key
            if (attrName) {
              this.$attr[key] = attrName;
            } else {
              attrName = this.$attr[key];
              if (!attrName) {
                this.$attr[key] = attrName = snake_case(key, "-");
              }
            }

            nodeName = nodeName_(this.$$element);

            if ((nodeName === "a" && (key === "href" || key === "xlinkHref")) ||
            (nodeName === "img" && key === "src")) {
              // sanitize a[href] and img[src] values
              this[key] = value = (value == null) ? value : $$sanitizeUri(value, key === "src");
            } else if (nodeName === "img" && key === "srcset" && isDefined(value)) {
              // sanitize img[srcset] values
              var result = "";

              // first check if there are spaces because it's not the same pattern
              var trimmedSrcset = trim(value);
              //                (   999x   ,|   999w   ,|   ,|,   )
              var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
              var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

              // split srcset into tuple of uri and descriptor except for the last item
              var rawUris = trimmedSrcset.split(pattern);

              // for each tuples
              var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
              for (var i = 0; i < nbrUrisWith2parts; i++) {
                var innerIdx = i * 2;
                // sanitize the uri
                result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
                // add the descriptor
                result += (" " + trim(rawUris[innerIdx + 1]));
              }

              // split the last item into uri and descriptor
              var lastTuple = trim(rawUris[i * 2]).split(/\s/);

              // sanitize the last uri
              result += $$sanitizeUri(trim(lastTuple[0]), true);

              // and add the last descriptor if any
              if (lastTuple.length === 2) {
                result += (" " + trim(lastTuple[1]));
              }
              this[key] = value = result;
            }

            if (writeAttr !== false) {
              if (value == null) {
                this.$$element.removeAttr(attrName);
              } else {
                if (SIMPLE_ATTR_NAME.test(attrName)) {
                  this.$$element.attr(attrName, value);
                } else {
                  setSpecialAttr(this.$$element[0], attrName, value);
                }
              }
            }

            // fire observers
            var $$observers = this.$$observers;
            if ($$observers) {
              forEach($$observers[observer], function (fn) {
                try {
                  fn(value);
                } catch (e) {
                  $exceptionHandler(e);
                }
              });
            }
          },

          /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
          $observe: function (key, fn) {
            var attrs = this,
              $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
              listeners = ($$observers[key] || ($$observers[key] = []));

            listeners.push(fn);
            $rootScope.$evalAsync(function () {
              if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
                // no one registered attribute interpolation function, so lets call it manually
                fn(attrs[key]);
              }
            });

            return function () {
              arrayRemove(listeners, fn);
            };
          }
        };

        function setSpecialAttr(element, attrName, value) {
          // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
          // so we have to jump through some hoops to get such an attribute
          // https://github.com/angular/angular.js/pull/13318
          specialAttrHolder.innerHTML = "<span " + attrName + ">";
          var attributes = specialAttrHolder.firstChild.attributes;
          var attribute = attributes[0];
          // We have to remove the attribute from its container element before we can add it to the destination element
          attributes.removeNamedItem(attribute.name);
          attribute.value = value;
          element.attributes.setNamedItem(attribute);
        }

        function safeAddClass($element, className) {
          try {
            $element.addClass(className);
          } catch (e) {
            // ignore, since it means that we are trying to set class on
            // SVG element, where class name is read-only.
          }
        }

        var startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          denormalizeTemplate = (startSymbol === "{{" && endSymbol === "}}")
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
            },
          NG_ATTR_BINDING = /^ngAttr[A-Z]/;
        var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

        compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
          var bindings = $element.data("$binding") || [];

          if (isArray(binding)) {
            bindings = bindings.concat(binding);
          } else {
            bindings.push(binding);
          }

          $element.data("$binding", bindings);
        } : noop;

        compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
          safeAddClass($element, "ng-binding");
        } : noop;

        compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
          var dataName = isolated ? (noTemplate ? "$isolateScopeNoTemplate" : "$isolateScope") : "$scope";
          $element.data(dataName, scope);
        } : noop;

        compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
          safeAddClass($element, isolated ? "ng-isolate-scope" : "ng-scope");
        } : noop;

        compile.$$createComment = function (directiveName, comment) {
          var content = "";
          if (debugInfoEnabled) {
            content = " " + (directiveName || "") + ": ";
            if (comment) content += comment + " ";
          }
          return window.document.createComment(content);
        };

        return compile;

        // ================================

        function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
          previousCompileContext) {
          if (!($compileNodes instanceof jqLite)) {
            // jquery always rewraps, whereas we need to preserve the original selector so that we can
            // modify it.
            $compileNodes = jqLite($compileNodes);
          }
          var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                maxPriority, ignoreDirective, previousCompileContext);
          compile.$$addScopeClass($compileNodes);
          var namespace = null;
          return function publicLinkFn(scope, cloneConnectFn, options) {
            if (!$compileNodes) {
              throw $compileMinErr("multilink", "This element has already been linked.");
            }
            assertArg(scope, "scope");

            if (previousCompileContext && previousCompileContext.needsNewScope) {
              // A parent directive did a replace and a directive on this element asked
              // for transclusion, which caused us to lose a layer of element on which
              // we could hold the new transclusion scope, so we will create it manually
              // here.
              scope = scope.$parent.$new();
            }

            options = options || {};
            var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
              transcludeControllers = options.transcludeControllers,
              futureParentElement = options.futureParentElement;

            // When `parentBoundTranscludeFn` is passed, it is a
            // `controllersBoundTransclude` function (it was previously passed
            // as `transclude` to directive.link) so we must unwrap it to get
            // its `boundTranscludeFn`
            if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
              parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
            }

            if (!namespace) {
              namespace = detectNamespaceForChildElements(futureParentElement);
            }
            var $linkNode;
            if (namespace !== "html") {
              // When using a directive with replace:true and templateUrl the $compileNodes
              // (or a child element inside of them)
              // might change, so we need to recreate the namespace adapted compileNodes
              // for call to the link function.
              // Note: This will already clone the nodes...
              $linkNode = jqLite(
                wrapTemplate(namespace, jqLite("<div></div>").append($compileNodes).html())
              );
            } else if (cloneConnectFn) {
              // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
              // and sometimes changes the structure of the DOM.
              $linkNode = JQLitePrototype.clone.call($compileNodes);
            } else {
              $linkNode = $compileNodes;
            }

            if (transcludeControllers) {
              for (var controllerName in transcludeControllers) {
                $linkNode.data("$" + controllerName + "Controller", transcludeControllers[controllerName].instance);
              }
            }

            compile.$$addScopeInfo($linkNode, scope);

            if (cloneConnectFn) cloneConnectFn($linkNode, scope);
            if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

            if (!cloneConnectFn) {
              $compileNodes = compositeLinkFn = null;
            }
            return $linkNode;
          };
        }

        function detectNamespaceForChildElements(parentElement) {
          // TODO: Make this detect MathML as well...
          var node = parentElement && parentElement[0];
          if (!node) {
            return "html";
          } else {
            return nodeName_(node) !== "foreignobject" && toString.call(node).match(/SVG/) ? "svg" : "html";
          }
        }

        /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
        function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
          previousCompileContext) {
          var linkFns = [],
            // `nodeList` can be either an element's `.childNodes` (live NodeList)
            // or a jqLite/jQuery collection or an array
            notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
            attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;

          for (var i = 0; i < nodeList.length; i++) {
            attrs = new Attributes();

            // Support: IE 11 only
            // Workaround for #11781 and #14924
            if (msie === 11) {
              mergeConsecutiveTextNodes(nodeList, i, notLiveList);
            }

            // We must always refer to `nodeList[i]` hereafter,
            // since the nodes can be replaced underneath us.
            directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
              ignoreDirective);

            nodeLinkFn = (directives.length)
              ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                null, [], [], previousCompileContext)
              : null;

            if (nodeLinkFn && nodeLinkFn.scope) {
              compile.$$addScopeClass(attrs.$$element);
            }

            childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
              ? null
              : compileNodes(childNodes,
                nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

            if (nodeLinkFn || childLinkFn) {
              linkFns.push(i, nodeLinkFn, childLinkFn);
              linkFnFound = true;
              nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
            }

            // use the previous context only for the first element in the virtual group
            previousCompileContext = null;
          }

          // return a linking function if we have found anything, null otherwise
          return linkFnFound ? compositeLinkFn : null;

          function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
            var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
            var stableNodeList;

            if (nodeLinkFnFound) {
              // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
              // offsets don't get screwed up
              var nodeListLength = nodeList.length;
              stableNodeList = new Array(nodeListLength);

              // create a sparse array by only copying the elements which have a linkFn
              for (i = 0; i < linkFns.length; i += 3) {
                idx = linkFns[i];
                stableNodeList[idx] = nodeList[idx];
              }
            } else {
              stableNodeList = nodeList;
            }

            for (i = 0, ii = linkFns.length; i < ii;) {
              node = stableNodeList[linkFns[i++]];
              nodeLinkFn = linkFns[i++];
              childLinkFn = linkFns[i++];

              if (nodeLinkFn) {
                if (nodeLinkFn.scope) {
                  childScope = scope.$new();
                  compile.$$addScopeInfo(jqLite(node), childScope);
                } else {
                  childScope = scope;
                }

                if (nodeLinkFn.transcludeOnThisElement) {
                  childBoundTranscludeFn = createBoundTranscludeFn(
                    scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

                } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
                  childBoundTranscludeFn = parentBoundTranscludeFn;

                } else if (!parentBoundTranscludeFn && transcludeFn) {
                  childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

                } else {
                  childBoundTranscludeFn = null;
                }

                nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

              } else if (childLinkFn) {
                childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
              }
            }
          }
        }

        function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
          var node = nodeList[idx];
          var parent = node.parentNode;
          var sibling;

          if (node.nodeType !== NODE_TYPE_TEXT) {
            return;
          }

          while (true) {
            sibling = parent ? node.nextSibling : nodeList[idx + 1];
            if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
              break;
            }

            node.nodeValue = node.nodeValue + sibling.nodeValue;

            if (sibling.parentNode) {
              sibling.parentNode.removeChild(sibling);
            }
            if (notLiveList && sibling === nodeList[idx + 1]) {
              nodeList.splice(idx + 1, 1);
            }
          }
        }

        function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
          function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

            if (!transcludedScope) {
              transcludedScope = scope.$new(false, containingScope);
              transcludedScope.$$transcluded = true;
            }

            return transcludeFn(transcludedScope, cloneFn, {
              parentBoundTranscludeFn: previousBoundTranscludeFn,
              transcludeControllers: controllers,
              futureParentElement: futureParentElement
            });
          }

          // We need  to attach the transclusion slots onto the `boundTranscludeFn`
          // so that they are available inside the `controllersBoundTransclude` function
          var boundSlots = boundTranscludeFn.$$slots = createMap();
          for (var slotName in transcludeFn.$$slots) {
            if (transcludeFn.$$slots[slotName]) {
              boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
            } else {
              boundSlots[slotName] = null;
            }
          }

          return boundTranscludeFn;
        }

        /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
        function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
          var nodeType = node.nodeType,
            attrsMap = attrs.$attr,
            match,
            nodeName,
            className;

          switch (nodeType) {
            case NODE_TYPE_ELEMENT: /* Element */

              nodeName = nodeName_(node);

              // use the node name: <directive>
              addDirective(directives,
                directiveNormalize(nodeName), "E", maxPriority, ignoreDirective);

              // iterate over the attributes
              for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
                var attrStartName = false;
                var attrEndName = false;

                attr = nAttrs[j];
                name = attr.name;
                value = attr.value;

                // support ngAttr attribute binding
                ngAttrName = directiveNormalize(name);
                isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
                if (isNgAttr) {
                  name = name.replace(PREFIX_REGEXP, "")
                    .substr(8).replace(/_(.)/g, function (match, letter) {
                      return letter.toUpperCase();
                    });
                }

                var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
                if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
                  attrStartName = name;
                  attrEndName = name.substr(0, name.length - 5) + "end";
                  name = name.substr(0, name.length - 6);
                }

                nName = directiveNormalize(name.toLowerCase());
                attrsMap[nName] = name;
                if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                  attrs[nName] = value;
                  if (getBooleanAttrName(node, nName)) {
                    attrs[nName] = true; // presence means true
                  }
                }
                addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
                addDirective(directives, nName, "A", maxPriority, ignoreDirective, attrStartName,
                  attrEndName);
              }

              if (nodeName === "input" && node.getAttribute("type") === "hidden") {
                // Hidden input elements can have strange behaviour when navigating back to the page
                // This tells the browser not to try to cache and reinstate previous values
                node.setAttribute("autocomplete", "off");
              }

              // use class as directive
              if (!cssClassDirectivesEnabled) break;
              className = node.className;
              if (isObject(className)) {
              // Maybe SVGAnimatedString
                className = className.animVal;
              }
              if (isString(className) && className !== "") {
                while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
                  nName = directiveNormalize(match[2]);
                  if (addDirective(directives, nName, "C", maxPriority, ignoreDirective)) {
                    attrs[nName] = trim(match[3]);
                  }
                  className = className.substr(match.index + match[0].length);
                }
              }
              break;
            case NODE_TYPE_TEXT: /* Text Node */
              addTextInterpolateDirective(directives, node.nodeValue);
              break;
            case NODE_TYPE_COMMENT: /* Comment */
              if (!commentDirectivesEnabled) break;
              collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
              break;
          }

          directives.sort(byPriority);
          return directives;
        }

        function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
          // function created because of performance, try/catch disables
          // the optimization of the whole function #14848
          try {
            var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
            if (match) {
              var nName = directiveNormalize(match[1]);
              if (addDirective(directives, nName, "M", maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[2]);
              }
            }
          } catch (e) {
            // turns out that under some circumstances IE9 throws errors when one attempts to read
            // comment's node value.
            // Just ignore it and continue. (Can't seem to reproduce in test case.)
          }
        }

        /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
        function groupScan(node, attrStart, attrEnd) {
          var nodes = [];
          var depth = 0;
          if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
            do {
              if (!node) {
                throw $compileMinErr("uterdir",
                  "Unterminated attribute, found '{0}' but no matching '{1}' found.",
                  attrStart, attrEnd);
              }
              if (node.nodeType === NODE_TYPE_ELEMENT) {
                if (node.hasAttribute(attrStart)) depth++;
                if (node.hasAttribute(attrEnd)) depth--;
              }
              nodes.push(node);
              node = node.nextSibling;
            } while (depth > 0);
          } else {
            nodes.push(node);
          }

          return jqLite(nodes);
        }

        /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
        function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
          return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
            element = groupScan(element[0], attrStart, attrEnd);
            return linkFn(scope, element, attrs, controllers, transcludeFn);
          };
        }

        /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
        function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
          var compiled;

          if (eager) {
            return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
          }
          return /** @this */ function lazyCompilation() {
            if (!compiled) {
              compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

              // Null out all of these references in order to make them eligible for garbage collection
              // since this is a potentially long lived closure
              $compileNodes = transcludeFn = previousCompileContext = null;
            }
            return compiled.apply(this, arguments);
          };
        }

        /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
        function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
          jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
          previousCompileContext) {
          previousCompileContext = previousCompileContext || {};

          var terminalPriority = -Number.MAX_VALUE,
            newScopeDirective = previousCompileContext.newScopeDirective,
            controllerDirectives = previousCompileContext.controllerDirectives,
            newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
            templateDirective = previousCompileContext.templateDirective,
            nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
            hasTranscludeDirective = false,
            hasTemplate = false,
            hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
            $compileNode = templateAttrs.$$element = jqLite(compileNode),
            directive,
            directiveName,
            $template,
            replaceDirective = originalReplaceDirective,
            childTranscludeFn = transcludeFn,
            linkFn,
            didScanForMultipleTransclusion = false,
            mightHaveMultipleTransclusionError = false,
            directiveValue;

          // executes all directives on the current element
          for (var i = 0, ii = directives.length; i < ii; i++) {
            directive = directives[i];
            var attrStart = directive.$$start;
            var attrEnd = directive.$$end;

            // collect multiblock sections
            if (attrStart) {
              $compileNode = groupScan(compileNode, attrStart, attrEnd);
            }
            $template = undefined;

            if (terminalPriority > directive.priority) {
              break; // prevent further processing of directives
            }

            directiveValue = directive.scope;

            if (directiveValue) {

              // skip the check for directives with async templates, we'll check the derived sync
              // directive when the template arrives
              if (!directive.templateUrl) {
                if (isObject(directiveValue)) {
                  // This directive is trying to add an isolated scope.
                  // Check that there is no scope of any kind already
                  assertNoDuplicate("new/isolated scope", newIsolateScopeDirective || newScopeDirective,
                    directive, $compileNode);
                  newIsolateScopeDirective = directive;
                } else {
                  // This directive is trying to add a child scope.
                  // Check that there is no isolated scope already
                  assertNoDuplicate("new/isolated scope", newIsolateScopeDirective, directive,
                    $compileNode);
                }
              }

              newScopeDirective = newScopeDirective || directive;
            }

            directiveName = directive.name;

            // If we encounter a condition that can result in transclusion on the directive,
            // then scan ahead in the remaining directives for others that may cause a multiple
            // transclusion error to be thrown during the compilation process.  If a matching directive
            // is found, then we know that when we encounter a transcluded directive, we need to eagerly
            // compile the `transclude` function rather than doing it lazily in order to throw
            // exceptions at the correct time
            if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
              var candidateDirective;

              for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                  mightHaveMultipleTransclusionError = true;
                  break;
                }
              }

              didScanForMultipleTransclusion = true;
            }

            if (!directive.templateUrl && directive.controller) {
              controllerDirectives = controllerDirectives || createMap();
              assertNoDuplicate("'" + directiveName + "' controller",
                controllerDirectives[directiveName], directive, $compileNode);
              controllerDirectives[directiveName] = directive;
            }

            directiveValue = directive.transclude;

            if (directiveValue) {
              hasTranscludeDirective = true;

              // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
              // This option should only be used by directives that know how to safely handle element transclusion,
              // where the transcluded nodes are added or replaced after linking.
              if (!directive.$$tlb) {
                assertNoDuplicate("transclusion", nonTlbTranscludeDirective, directive, $compileNode);
                nonTlbTranscludeDirective = directive;
              }

              if (directiveValue === "element") {
                hasElementTranscludeDirective = true;
                terminalPriority = directive.priority;
                $template = $compileNode;
                $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
                compileNode = $compileNode[0];
                replaceWith(jqCollection, sliceArgs($template), compileNode);

                // Support: Chrome < 50
                // https://github.com/angular/angular.js/issues/14041

                // In the versions of V8 prior to Chrome 50, the document fragment that is created
                // in the `replaceWith` function is improperly garbage collected despite still
                // being referenced by the `parentNode` property of all of the child nodes.  By adding
                // a reference to the fragment via a different property, we can avoid that incorrect
                // behavior.
                // TODO: remove this line after Chrome 50 has been released
                $template[0].$$parentNode = $template[0].parentNode;

                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                  replaceDirective && replaceDirective.name, {
                    // Don't pass in:
                    // - controllerDirectives - otherwise we'll create duplicates controllers
                    // - newIsolateScopeDirective or templateDirective - combining templates with
                    //   element transclusion doesn't make sense.
                    //
                    // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                    // on the same element more than once.
                    nonTlbTranscludeDirective: nonTlbTranscludeDirective
                  });
              } else {

                var slots = createMap();

                if (!isObject(directiveValue)) {
                  $template = jqLite(jqLiteClone(compileNode)).contents();
                } else {

                  // We have transclusion slots,
                  // collect them up, compile them and store their transclusion functions
                  $template = [];

                  var slotMap = createMap();
                  var filledSlots = createMap();

                  // Parse the element selectors
                  forEach(directiveValue, function (elementSelector, slotName) {
                    // If an element selector starts with a ? then it is optional
                    var optional = (elementSelector.charAt(0) === "?");
                    elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                    slotMap[elementSelector] = slotName;

                    // We explicitly assign `null` since this implies that a slot was defined but not filled.
                    // Later when calling boundTransclusion functions with a slot name we only error if the
                    // slot is `undefined`
                    slots[slotName] = null;

                    // filledSlots contains `true` for all slots that are either optional or have been
                    // filled. This is used to check that we have not missed any required slots
                    filledSlots[slotName] = optional;
                  });

                  // Add the matching elements into their slot
                  forEach($compileNode.contents(), function (node) {
                    var slotName = slotMap[directiveNormalize(nodeName_(node))];
                    if (slotName) {
                      filledSlots[slotName] = true;
                      slots[slotName] = slots[slotName] || [];
                      slots[slotName].push(node);
                    } else {
                      $template.push(node);
                    }
                  });

                  // Check for required slots that were not filled
                  forEach(filledSlots, function (filled, slotName) {
                    if (!filled) {
                      throw $compileMinErr("reqslot", "Required transclusion slot `{0}` was not filled.", slotName);
                    }
                  });

                  for (var slotName in slots) {
                    if (slots[slotName]) {
                      // Only define a transclusion function if the slot was filled
                      slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                    }
                  }
                }

                $compileNode.empty(); // clear contents
                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                  undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope });
                childTranscludeFn.$$slots = slots;
              }
            }

            if (directive.template) {
              hasTemplate = true;
              assertNoDuplicate("template", templateDirective, directive, $compileNode);
              templateDirective = directive;

              directiveValue = (isFunction(directive.template))
                ? directive.template($compileNode, templateAttrs)
                : directive.template;

              directiveValue = denormalizeTemplate(directiveValue);

              if (directive.replace) {
                replaceDirective = directive;
                if (jqLiteIsTextNode(directiveValue)) {
                  $template = [];
                } else {
                  $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
                }
                compileNode = $template[0];

                if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                  throw $compileMinErr("tplrt",
                    "Template for directive '{0}' must have exactly one root element. {1}",
                    directiveName, "");
                }

                replaceWith(jqCollection, $compileNode, compileNode);

                var newTemplateAttrs = { $attr: {} };

                // combine directives from the original node and from the template:
                // - take the array of directives for this element
                // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
                // - collect directives from the template and sort them by priority
                // - combine directives as: processed + template + unprocessed
                var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
                var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

                if (newIsolateScopeDirective || newScopeDirective) {
                  // The original directive caused the current element to be replaced but this element
                  // also needs to have a new scope, so we need to tell the template directives
                  // that they would need to get their scope from further up, if they require transclusion
                  markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
                }
                directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
                mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

                ii = directives.length;
              } else {
                $compileNode.html(directiveValue);
              }
            }

            if (directive.templateUrl) {
              hasTemplate = true;
              assertNoDuplicate("template", templateDirective, directive, $compileNode);
              templateDirective = directive;

              if (directive.replace) {
                replaceDirective = directive;
              }

              // eslint-disable-next-line no-func-assign
              nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
                templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                  controllerDirectives: controllerDirectives,
                  newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                  newIsolateScopeDirective: newIsolateScopeDirective,
                  templateDirective: templateDirective,
                  nonTlbTranscludeDirective: nonTlbTranscludeDirective
                });
              ii = directives.length;
            } else if (directive.compile) {
              try {
                linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
                var context = directive.$$originalDirective || directive;
                if (isFunction(linkFn)) {
                  addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
                } else if (linkFn) {
                  addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
                }
              } catch (e) {
                $exceptionHandler(e, startingTag($compileNode));
              }
            }

            if (directive.terminal) {
              nodeLinkFn.terminal = true;
              terminalPriority = Math.max(terminalPriority, directive.priority);
            }

          }

          nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
          nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
          nodeLinkFn.templateOnThisElement = hasTemplate;
          nodeLinkFn.transclude = childTranscludeFn;

          previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

          // might be normal or delayed nodeLinkFn depending on if templateUrl is present
          return nodeLinkFn;

          // //////////////////

          function addLinkFns(pre, post, attrStart, attrEnd) {
            if (pre) {
              if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
              pre.require = directive.require;
              pre.directiveName = directiveName;
              if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
                pre = cloneAndAnnotateFn(pre, { isolateScope: true });
              }
              preLinkFns.push(pre);
            }
            if (post) {
              if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
              post.require = directive.require;
              post.directiveName = directiveName;
              if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
                post = cloneAndAnnotateFn(post, { isolateScope: true });
              }
              postLinkFns.push(post);
            }
          }

          function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
            var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
              attrs, scopeBindingInfo;

            if (compileNode === linkNode) {
              attrs = templateAttrs;
              $element = templateAttrs.$$element;
            } else {
              $element = jqLite(linkNode);
              attrs = new Attributes($element, templateAttrs);
            }

            controllerScope = scope;
            if (newIsolateScopeDirective) {
              isolateScope = scope.$new(true);
            } else if (newScopeDirective) {
              controllerScope = scope.$parent;
            }

            if (boundTranscludeFn) {
              // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
              // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
              transcludeFn = controllersBoundTransclude;
              transcludeFn.$$boundTransclude = boundTranscludeFn;
              // expose the slots on the `$transclude` function
              transcludeFn.isSlotFilled = function (slotName) {
                return !!boundTranscludeFn.$$slots[slotName];
              };
            }

            if (controllerDirectives) {
              elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
            }

            if (newIsolateScopeDirective) {
              // Initialize isolate scope bindings for new isolate scope directive.
              compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
              compile.$$addScopeClass($element, true);
              isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
              scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                isolateScope.$$isolateBindings,
                newIsolateScopeDirective);
              if (scopeBindingInfo.removeWatches) {
                isolateScope.$on("$destroy", scopeBindingInfo.removeWatches);
              }
            }

            // Initialize bindToController bindings
            for (var name in elementControllers) {
              var controllerDirective = controllerDirectives[name];
              var controller = elementControllers[name];
              var bindings = controllerDirective.$$bindings.bindToController;

              if (preAssignBindingsEnabled) {
                if (bindings) {
                  controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                } else {
                  controller.bindingInfo = {};
                }

                var controllerResult = controller();
                if (controllerResult !== controller.instance) {
                  // If the controller constructor has a return value, overwrite the instance
                  // from setupControllers
                  controller.instance = controllerResult;
                  $element.data("$" + controllerDirective.name + "Controller", controllerResult);
                  if (controller.bindingInfo.removeWatches) {
                    controller.bindingInfo.removeWatches();
                  }
                  controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
                }
              } else {
                controller.instance = controller();
                $element.data("$" + controllerDirective.name + "Controller", controller.instance);
                controller.bindingInfo =
              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
              }
            }

            // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
            forEach(controllerDirectives, function (controllerDirective, name) {
              var require = controllerDirective.require;
              if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
                extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
              }
            });

            // Handle the init and destroy lifecycle hooks on all controllers that have them
            forEach(elementControllers, function (controller) {
              var controllerInstance = controller.instance;
              if (isFunction(controllerInstance.$onChanges)) {
                try {
                  controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
              if (isFunction(controllerInstance.$onInit)) {
                try {
                  controllerInstance.$onInit();
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
              if (isFunction(controllerInstance.$doCheck)) {
                controllerScope.$watch(function () { controllerInstance.$doCheck(); });
                controllerInstance.$doCheck();
              }
              if (isFunction(controllerInstance.$onDestroy)) {
                controllerScope.$on("$destroy", function callOnDestroyHook() {
                  controllerInstance.$onDestroy();
                });
              }
            });

            // PRELINKING
            for (i = 0, ii = preLinkFns.length; i < ii; i++) {
              linkFn = preLinkFns[i];
              invokeLinkFn(linkFn,
                linkFn.isolateScope ? isolateScope : scope,
                $element,
                attrs,
                linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
                transcludeFn
              );
            }

            // RECURSION
            // We only pass the isolate scope, if the isolate directive has a template,
            // otherwise the child elements do not belong to the isolate directive.
            var scopeToChild = scope;
            if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
              scopeToChild = isolateScope;
            }
            if (childLinkFn) {
              childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
            }

            // POSTLINKING
            for (i = postLinkFns.length - 1; i >= 0; i--) {
              linkFn = postLinkFns[i];
              invokeLinkFn(linkFn,
                linkFn.isolateScope ? isolateScope : scope,
                $element,
                attrs,
                linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
                transcludeFn
              );
            }

            // Trigger $postLink lifecycle hooks
            forEach(elementControllers, function (controller) {
              var controllerInstance = controller.instance;
              if (isFunction(controllerInstance.$postLink)) {
                controllerInstance.$postLink();
              }
            });

            // This is the function that is injected as `$transclude`.
            // Note: all arguments are optional!
            function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
              var transcludeControllers;
              // No scope passed in:
              if (!isScope(scope)) {
                slotName = futureParentElement;
                futureParentElement = cloneAttachFn;
                cloneAttachFn = scope;
                scope = undefined;
              }

              if (hasElementTranscludeDirective) {
                transcludeControllers = elementControllers;
              }
              if (!futureParentElement) {
                futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
              }
              if (slotName) {
                // slotTranscludeFn can be one of three things:
                //  * a transclude function - a filled slot
                //  * `null` - an optional slot that was not filled
                //  * `undefined` - a slot that was not declared (i.e. invalid)
                var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
                if (slotTranscludeFn) {
                  return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
                } else if (isUndefined(slotTranscludeFn)) {
                  throw $compileMinErr("noslot",
                    "No parent directive that requires a transclusion with slot name \"{0}\". " +
               "Element: {1}",
                    slotName, startingTag($element));
                }
              } else {
                return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
              }
            }
          }
        }

        function getControllers(directiveName, require, $element, elementControllers) {
          var value;

          if (isString(require)) {
            var match = require.match(REQUIRE_PREFIX_REGEXP);
            var name = require.substring(match[0].length);
            var inheritType = match[1] || match[3];
            var optional = match[2] === "?";

            // If only parents then start at the parent element
            if (inheritType === "^^") {
              $element = $element.parent();
              // Otherwise attempt getting the controller from elementControllers in case
              // the element is transcluded (and has no data) and to avoid .data if possible
            } else {
              value = elementControllers && elementControllers[name];
              value = value && value.instance;
            }

            if (!value) {
              var dataName = "$" + name + "Controller";
              value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
            }

            if (!value && !optional) {
              throw $compileMinErr("ctreq",
                "Controller '{0}', required by directive '{1}', can't be found!",
                name, directiveName);
            }
          } else if (isArray(require)) {
            value = [];
            for (var i = 0, ii = require.length; i < ii; i++) {
              value[i] = getControllers(directiveName, require[i], $element, elementControllers);
            }
          } else if (isObject(require)) {
            value = {};
            forEach(require, function (controller, property) {
              value[property] = getControllers(directiveName, controller, $element, elementControllers);
            });
          }

          return value || null;
        }

        function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
          var elementControllers = createMap();
          for (var controllerKey in controllerDirectives) {
            var directive = controllerDirectives[controllerKey];
            var locals = {
              $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
              $element: $element,
              $attrs: attrs,
              $transclude: transcludeFn
            };

            var controller = directive.controller;
            if (controller === "@") {
              controller = attrs[directive.name];
            }

            var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

            // For directives with element transclusion the element is a comment.
            // In this case .data will not attach any data.
            // Instead, we save the controllers for the element in a local hash and attach to .data
            // later, once we have the actual element.
            elementControllers[directive.name] = controllerInstance;
            $element.data("$" + directive.name + "Controller", controllerInstance.instance);
          }
          return elementControllers;
        }

        // Depending upon the context in which a directive finds itself it might need to have a new isolated
        // or child scope created. For instance:
        // * if the directive has been pulled into a template because another directive with a higher priority
        // asked for element transclusion
        // * if the directive itself asks for transclusion but it is at the root of a template and the original
        // element was replaced. See https://github.com/angular/angular.js/issues/12936
        function markDirectiveScope(directives, isolateScope, newScope) {
          for (var j = 0, jj = directives.length; j < jj; j++) {
            directives[j] = inherit(directives[j], { $$isolateScope: isolateScope, $$newScope: newScope });
          }
        }

        /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
        function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
          endAttrName) {
          if (name === ignoreDirective) return null;
          var match = null;
          if (hasDirectives.hasOwnProperty(name)) {
            for (var directive, directives = $injector.get(name + Suffix),
              i = 0, ii = directives.length; i < ii; i++) {
              directive = directives[i];
              if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
                if (startAttrName) {
                  directive = inherit(directive, { $$start: startAttrName, $$end: endAttrName });
                }
                if (!directive.$$bindings) {
                  var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
                  if (isObject(bindings.isolateScope)) {
                    directive.$$isolateBindings = bindings.isolateScope;
                  }
                }
                tDirectives.push(directive);
                match = directive;
              }
            }
          }
          return match;
        }

        /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
        function directiveIsMultiElement(name) {
          if (hasDirectives.hasOwnProperty(name)) {
            for (var directive, directives = $injector.get(name + Suffix),
              i = 0, ii = directives.length; i < ii; i++) {
              directive = directives[i];
              if (directive.multiElement) {
                return true;
              }
            }
          }
          return false;
        }

        /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
        function mergeTemplateAttributes(dst, src) {
          var srcAttr = src.$attr,
            dstAttr = dst.$attr;

          // reapply the old attributes to the new element
          forEach(dst, function (value, key) {
            if (key.charAt(0) !== "$") {
              if (src[key] && src[key] !== value) {
                if (value.length) {
                  value += (key === "style" ? ";" : " ") + src[key];
                } else {
                  value = src[key];
                }
              }
              dst.$set(key, value, true, srcAttr[key]);
            }
          });

          // copy the new attributes on the old attrs object
          forEach(src, function (value, key) {
            // Check if we already set this attribute in the loop above.
            // `dst` will never contain hasOwnProperty as DOM parser won't let it.
            // You will get an "InvalidCharacterError: DOM Exception 5" error if you
            // have an attribute like "has-own-property" or "data-has-own-property", etc.
            if (!dst.hasOwnProperty(key) && key.charAt(0) !== "$") {
              dst[key] = value;

              if (key !== "class" && key !== "style") {
                dstAttr[key] = srcAttr[key];
              }
            }
          });
        }

        function compileTemplateUrl(directives, $compileNode, tAttrs,
          $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
          var linkQueue = [],
            afterTemplateNodeLinkFn,
            afterTemplateChildLinkFn,
            beforeTemplateCompileNode = $compileNode[0],
            origAsyncDirective = directives.shift(),
            derivedSyncDirective = inherit(origAsyncDirective, {
              templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
            }),
            templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
            templateNamespace = origAsyncDirective.templateNamespace;

          $compileNode.empty();

          $templateRequest(templateUrl)
            .then(function (content) {
              var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

              content = denormalizeTemplate(content);

              if (origAsyncDirective.replace) {
                if (jqLiteIsTextNode(content)) {
                  $template = [];
                } else {
                  $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
                }
                compileNode = $template[0];

                if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                  throw $compileMinErr("tplrt",
                    "Template for directive '{0}' must have exactly one root element. {1}",
                    origAsyncDirective.name, templateUrl);
                }

                tempTemplateAttrs = { $attr: {} };
                replaceWith($rootElement, $compileNode, compileNode);
                var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

                if (isObject(origAsyncDirective.scope)) {
                  // the original directive that caused the template to be loaded async required
                  // an isolate scope
                  markDirectiveScope(templateDirectives, true);
                }
                directives = templateDirectives.concat(directives);
                mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
              } else {
                compileNode = beforeTemplateCompileNode;
                $compileNode.html(content);
              }

              directives.unshift(derivedSyncDirective);

              afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
                childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
                previousCompileContext);
              forEach($rootElement, function (node, i) {
                if (node === compileNode) {
                  $rootElement[i] = $compileNode[0];
                }
              });
              afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

              while (linkQueue.length) {
                var scope = linkQueue.shift(),
                  beforeTemplateLinkNode = linkQueue.shift(),
                  linkRootElement = linkQueue.shift(),
                  boundTranscludeFn = linkQueue.shift(),
                  linkNode = $compileNode[0];

                if (scope.$$destroyed) continue;

                if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
                  var oldClasses = beforeTemplateLinkNode.className;

                  if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                    // it was cloned therefore we have to clone as well.
                    linkNode = jqLiteClone(compileNode);
                  }
                  replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

                  // Copy in CSS classes from original node
                  safeAddClass(jqLite(linkNode), oldClasses);
                }
                if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
                  childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
                } else {
                  childBoundTranscludeFn = boundTranscludeFn;
                }
                afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
                  childBoundTranscludeFn);
              }
              linkQueue = null;
            }).catch(function (error) {
              if (isError(error)) {
                $exceptionHandler(error);
              }
            });

          return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
            var childBoundTranscludeFn = boundTranscludeFn;
            if (scope.$$destroyed) return;
            if (linkQueue) {
              linkQueue.push(scope,
                node,
                rootElement,
                childBoundTranscludeFn);
            } else {
              if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
                childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
              }
              afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
            }
          };
        }

        /**
     * Sorting function for bound directives.
     */
        function byPriority(a, b) {
          var diff = b.priority - a.priority;
          if (diff !== 0) return diff;
          if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
          return a.index - b.index;
        }

        function assertNoDuplicate(what, previousDirective, directive, element) {

          function wrapModuleNameIfDefined(moduleName) {
            return moduleName ?
              (" (module: " + moduleName + ")") :
              "";
          }

          if (previousDirective) {
            throw $compileMinErr("multidir", "Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}",
              previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
              directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
          }
        }

        function addTextInterpolateDirective(directives, text) {
          var interpolateFn = $interpolate(text, true);
          if (interpolateFn) {
            directives.push({
              priority: 0,
              compile: function textInterpolateCompileFn(templateNode) {
                var templateNodeParent = templateNode.parent(),
                  hasCompileParent = !!templateNodeParent.length;

                // When transcluding a template that has bindings in the root
                // we don't have a parent and thus need to add the class during linking fn.
                if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

                return function textInterpolateLinkFn(scope, node) {
                  var parent = node.parent();
                  if (!hasCompileParent) compile.$$addBindingClass(parent);
                  compile.$$addBindingInfo(parent, interpolateFn.expressions);
                  scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                    node[0].nodeValue = value;
                  });
                };
              }
            });
          }
        }

        function wrapTemplate(type, template) {
          type = lowercase(type || "html");
          switch (type) {
            case "svg":
            case "math":
              var wrapper = window.document.createElement("div");
              wrapper.innerHTML = "<" + type + ">" + template + "</" + type + ">";
              return wrapper.childNodes[0].childNodes;
            default:
              return template;
          }
        }

        function getTrustedContext(node, attrNormalizedName) {
          if (attrNormalizedName === "srcdoc") {
            return $sce.HTML;
          }
          var tag = nodeName_(node);
          // All tags with src attributes require a RESOURCE_URL value, except for
          // img and various html5 media tags.
          if (attrNormalizedName === "src" || attrNormalizedName === "ngSrc") {
            if (["img", "video", "audio", "source", "track"].indexOf(tag) === -1) {
              return $sce.RESOURCE_URL;
            }
            // maction[xlink:href] can source SVG.  It's not limited to <maction>.
          } else if (attrNormalizedName === "xlinkHref" ||
          (tag === "form" && attrNormalizedName === "action") ||
          // links can be stylesheets or imports, which can run script in the current origin
          (tag === "link" && attrNormalizedName === "href")
          ) {
            return $sce.RESOURCE_URL;
          }
        }

        function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
          var trustedContext = getTrustedContext(node, name);
          var mustHaveExpression = !isNgAttr;
          var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

          var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

          // no interpolation found -> ignore
          if (!interpolateFn) return;

          if (name === "multiple" && nodeName_(node) === "select") {
            throw $compileMinErr("selmulti",
              "Binding to the 'multiple' attribute is not supported. Element: {0}",
              startingTag(node));
          }

          if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
            throw $compileMinErr("nodomevents",
              "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
                "ng- versions (such as ng-click instead of onclick) instead.");
          }

          directives.push({
            priority: 100,
            compile: function () {
              return {
                pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                  var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                  // If the attribute has changed since last $interpolate()ed
                  var newValue = attr[name];
                  if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                    interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                    value = newValue;
                  }

                  // if attribute was updated so that there is no interpolation going on we don't want to
                  // register any observers
                  if (!interpolateFn) return;

                  // initialize attr object so that it's ready in case we need the value for isolate
                  // scope initialization, otherwise the value would not be available from isolate
                  // directive's linking fn during linking phase
                  attr[name] = interpolateFn(scope);

                  ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                  (attr.$$observers && attr.$$observers[name].$$scope || scope).
                    $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    // special case for class attribute addition + removal
                    // so that class changes can tap into the animation
                    // hooks provided by the $animate service. Be sure to
                    // skip animations when the first digest occurs (when
                    // both the new and the old values are the same) since
                    // the CSS classes are the non-interpolated values
                      if (name === "class" && newValue !== oldValue) {
                        attr.$updateClass(newValue, oldValue);
                      } else {
                        attr.$set(name, newValue);
                      }
                    });
                }
              };
            }
          });
        }

        /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
        function replaceWith($rootElement, elementsToRemove, newNode) {
          var firstElementToRemove = elementsToRemove[0],
            removeCount = elementsToRemove.length,
            parent = firstElementToRemove.parentNode,
            i, ii;

          if ($rootElement) {
            for (i = 0, ii = $rootElement.length; i < ii; i++) {
              if ($rootElement[i] === firstElementToRemove) {
                $rootElement[i++] = newNode;
                for (var j = i, j2 = j + removeCount - 1,
                  jj = $rootElement.length;
                  j < jj; j++, j2++) {
                  if (j2 < jj) {
                    $rootElement[j] = $rootElement[j2];
                  } else {
                    delete $rootElement[j];
                  }
                }
                $rootElement.length -= removeCount - 1;

                // If the replaced element is also the jQuery .context then replace it
                // .context is a deprecated jQuery api, so we should set it only when jQuery set it
                // http://api.jquery.com/context/
                if ($rootElement.context === firstElementToRemove) {
                  $rootElement.context = newNode;
                }
                break;
              }
            }
          }

          if (parent) {
            parent.replaceChild(newNode, firstElementToRemove);
          }

          // Append all the `elementsToRemove` to a fragment. This will...
          // - remove them from the DOM
          // - allow them to still be traversed with .nextSibling
          // - allow a single fragment.qSA to fetch all elements being removed
          var fragment = window.document.createDocumentFragment();
          for (i = 0; i < removeCount; i++) {
            fragment.appendChild(elementsToRemove[i]);
          }

          if (jqLite.hasData(firstElementToRemove)) {
            // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
            // data here because there's no public interface in jQuery to do that and copying over
            // event listeners (which is the main use of private data) wouldn't work anyway.
            jqLite.data(newNode, jqLite.data(firstElementToRemove));

            // Remove $destroy event listeners from `firstElementToRemove`
            jqLite(firstElementToRemove).off("$destroy");
          }

          // Cleanup any data/listeners on the elements and children.
          // This includes invoking the $destroy event on any elements with listeners.
          jqLite.cleanData(fragment.querySelectorAll("*"));

          // Update the jqLite collection to only contain the `newNode`
          for (i = 1; i < removeCount; i++) {
            delete elementsToRemove[i];
          }
          elementsToRemove[0] = newNode;
          elementsToRemove.length = 1;
        }

        function cloneAndAnnotateFn(fn, annotation) {
          return extend(function () { return fn.apply(null, arguments); }, fn, annotation);
        }

        function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
          try {
            linkFn(scope, $element, attrs, controllers, transcludeFn);
          } catch (e) {
            $exceptionHandler(e, startingTag($element));
          }
        }

        function strictBindingsCheck(attrName, directiveName) {
          if (strictComponentBindingsEnabled) {
            throw $compileMinErr("missingattr",
              "Attribute '{0}' of '{1}' is non-optional and must be set!",
              attrName, directiveName);
          }
        }

        // Set up $watches for isolate scope and controller bindings.
        function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
          var removeWatchCollection = [];
          var initialChanges = {};
          var changes;

          forEach(bindings, function initializeBinding(definition, scopeName) {
            var attrName = definition.attrName,
              optional = definition.optional,
              mode = definition.mode, // @, =, <, or &
              lastValue,
              parentGet, parentSet, compare, removeWatch;

            switch (mode) {

              case "@":
                if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                  strictBindingsCheck(attrName, directive.name);
                  destination[scopeName] = attrs[attrName] = undefined;

                }
                removeWatch = attrs.$observe(attrName, function (value) {
                  if (isString(value) || isBoolean(value)) {
                    var oldValue = destination[scopeName];
                    recordChanges(scopeName, value, oldValue);
                    destination[scopeName] = value;
                  }
                });
                attrs.$$observers[attrName].$$scope = scope;
                lastValue = attrs[attrName];
                if (isString(lastValue)) {
                  // If the attribute has been provided then we trigger an interpolation to ensure
                  // the value is there for use in the link fn
                  destination[scopeName] = $interpolate(lastValue)(scope);
                } else if (isBoolean(lastValue)) {
                  // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
                  // the value to boolean rather than a string, so we special case this situation
                  destination[scopeName] = lastValue;
                }
                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
                removeWatchCollection.push(removeWatch);
                break;

              case "=":
                if (!hasOwnProperty.call(attrs, attrName)) {
                  if (optional) break;
                  strictBindingsCheck(attrName, directive.name);
                  attrs[attrName] = undefined;
                }
                if (optional && !attrs[attrName]) break;

                parentGet = $parse(attrs[attrName]);
                if (parentGet.literal) {
                  compare = equals;
                } else {
                  compare = simpleCompare;
                }
                parentSet = parentGet.assign || function () {
                  // reset the change, or we will throw this exception on every $digest
                  lastValue = destination[scopeName] = parentGet(scope);
                  throw $compileMinErr("nonassign",
                    "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
                    attrs[attrName], attrName, directive.name);
                };
                lastValue = destination[scopeName] = parentGet(scope);
                var parentValueWatch = function parentValueWatch(parentValue) {
                  if (!compare(parentValue, destination[scopeName])) {
                    // we are out of sync and need to copy
                    if (!compare(parentValue, lastValue)) {
                      // parent changed and it has precedence
                      destination[scopeName] = parentValue;
                    } else {
                      // if the parent can be assigned then do so
                      parentSet(scope, parentValue = destination[scopeName]);
                    }
                  }
                  lastValue = parentValue;
                  return lastValue;
                };
                parentValueWatch.$stateful = true;
                if (definition.collection) {
                  removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
                } else {
                  removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
                }
                removeWatchCollection.push(removeWatch);
                break;

              case "<":
                if (!hasOwnProperty.call(attrs, attrName)) {
                  if (optional) break;
                  strictBindingsCheck(attrName, directive.name);
                  attrs[attrName] = undefined;
                }
                if (optional && !attrs[attrName]) break;

                parentGet = $parse(attrs[attrName]);
                var deepWatch = parentGet.literal;

                var initialValue = destination[scopeName] = parentGet(scope);
                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

                removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
                  if (oldValue === newValue) {
                    if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
                      return;
                    }
                    oldValue = initialValue;
                  }
                  recordChanges(scopeName, newValue, oldValue);
                  destination[scopeName] = newValue;
                }, deepWatch);

                removeWatchCollection.push(removeWatch);
                break;

              case "&":
                if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                  strictBindingsCheck(attrName, directive.name);
                }
                // Don't assign Object.prototype method to scope
                parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

                // Don't assign noop to destination if expression is not valid
                if (parentGet === noop && optional) break;

                destination[scopeName] = function (locals) {
                  return parentGet(scope, locals);
                };
                break;
            }
          });

          function recordChanges(key, currentValue, previousValue) {
            if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
              // If we have not already scheduled the top level onChangesQueue handler then do so now
              if (!onChangesQueue) {
                scope.$$postDigest(flushOnChangesQueue);
                onChangesQueue = [];
              }
              // If we have not already queued a trigger of onChanges for this controller then do so now
              if (!changes) {
                changes = {};
                onChangesQueue.push(triggerOnChangesHook);
              }
              // If the has been a change on this property already then we need to reuse the previous value
              if (changes[key]) {
                previousValue = changes[key].previousValue;
              }
              // Store this change
              changes[key] = new SimpleChange(previousValue, currentValue);
            }
          }

          function triggerOnChangesHook() {
            destination.$onChanges(changes);
            // Now clear the changes so that we schedule onChanges when more changes arrive
            changes = undefined;
          }

          return {
            initialChanges: initialChanges,
            removeWatches: removeWatchCollection.length && function removeWatches() {
              for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
                removeWatchCollection[i]();
              }
            }
          };
        }
      }];
  }

  function SimpleChange(previous, current) {
    this.previousValue = previous;
    this.currentValue = current;
  }
  SimpleChange.prototype.isFirstChange = function () { return this.previousValue === _UNINITIALIZED_VALUE; };

  var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
  var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

  /**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
  function directiveNormalize(name) {
    return name
      .replace(PREFIX_REGEXP, "")
      .replace(SPECIAL_CHARS_REGEXP, function (_, letter, offset) {
        return offset ? letter.toUpperCase() : letter;
      });
  }

  /**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

  /**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */

  /**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */

  /**
 * Closure compiler type information
 */

  function nodesetLinkingFn(
  /* angular.Scope */ scope,
    /* NodeList */ nodeList,
    /* Element */ rootElement,
    /* function(Function) */ boundTranscludeFn
  ) {}

  function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
    /* angular.Scope */ scope,
    /* Node */ node,
    /* Element */ rootElement,
    /* function(Function) */ boundTranscludeFn
  ) {}

  function tokenDifference(str1, str2) {
    var values = "",
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values += (values.length > 0 ? " " : "") + token;
    }
    return values;
  }

  function removeComments(jqNodes) {
    jqNodes = jqLite(jqNodes);
    var i = jqNodes.length;

    if (i <= 1) {
      return jqNodes;
    }

    while (i--) {
      var node = jqNodes[i];
      if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === "")) {
        splice.call(jqNodes, i, 1);
      }
    }
    return jqNodes;
  }

  var $controllerMinErr = minErr("$controller");

  var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
  function identifierForController(controller, ident) {
    if (ident && isString(ident)) return ident;
    if (isString(controller)) {
      var match = CNTRL_REG.exec(controller);
      if (match) return match[3];
    }
  }

  /**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
  function $ControllerProvider() {
    var controllers = {},
      globals = false;

    /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
    this.has = function (name) {
      return controllers.hasOwnProperty(name);
    };

    /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
    this.register = function (name, constructor) {
      assertNotHasOwnProperty(name, "controller");
      if (isObject(name)) {
        extend(controllers, name);
      } else {
        controllers[name] = constructor;
      }
    };

    /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   * @description If called, allows `$controller` to find controller constructors on `window`
   *
   * @deprecated
   * sinceVersion="v1.3.0"
   * removeVersion="v1.7.0"
   * This method of finding controllers has been deprecated.
   */
    this.allowGlobals = function () {
      globals = true;
    };

    this.$get = ["$injector", "$window", function ($injector, $window) {

      /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (deprecated, not recommended)
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
      return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
        var instance, match, constructor, identifier;
        later = later === true;
        if (ident && isString(ident)) {
          identifier = ident;
        }

        if (isString(expression)) {
          match = expression.match(CNTRL_REG);
          if (!match) {
            throw $controllerMinErr("ctrlfmt",
              "Badly formed controller string '{0}'. " +
            "Must match `__name__ as __id__` or `__name__`.", expression);
          }
          constructor = match[1];
          identifier = identifier || match[3];
          expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

          if (!expression) {
            throw $controllerMinErr("ctrlreg",
              "The controller with the name '{0}' is not registered.", constructor);
          }

          assertArgFn(expression, constructor, true);
        }

        if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
          var controllerPrototype = (isArray(expression) ?
            expression[expression.length - 1] : expression).prototype;
          instance = Object.create(controllerPrototype || null);

          if (identifier) {
            addIdentifier(locals, identifier, instance, constructor || expression.name);
          }

          return extend(function $controllerInit() {
            var result = $injector.invoke(expression, instance, locals, constructor);
            if (result !== instance && (isObject(result) || isFunction(result))) {
              instance = result;
              if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
                addIdentifier(locals, identifier, instance, constructor || expression.name);
              }
            }
            return instance;
          }, {
            instance: instance,
            identifier: identifier
          });
        }

        instance = $injector.instantiate(expression, locals, constructor);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return instance;
      };

      function addIdentifier(locals, identifier, instance, name) {
        if (!(locals && isObject(locals.$scope))) {
          throw minErr("$controller")("noscp",
            "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
            name, identifier);
        }

        locals.$scope[identifier] = instance;
      }
    }];
  }

  /**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
  function $DocumentProvider() {
    this.$get = ["$window", function (window) {
      return jqLite(window.document);
    }];
  }

  /**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
  function $$IsDocumentHiddenProvider() {
    this.$get = ["$document", "$rootScope", function ($document, $rootScope) {
      var doc = $document[0];
      var hidden = doc && doc.hidden;

      $document.on("visibilitychange", changeListener);

      $rootScope.$on("$destroy", function () {
        $document.off("visibilitychange", changeListener);
      });

      function changeListener() {
        hidden = doc.hidden;
      }

      return function () {
        return hidden;
      };
    }];
  }

  /**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
  function $ExceptionHandlerProvider() {
    this.$get = ["$log", function ($log) {
      return function (exception, cause) {
        $log.error.apply($log, arguments);
      };
    }];
  }

  var $$ForceReflowProvider = /** @this */ function () {
    this.$get = ["$document", function ($document) {
      return function (domNode) {
      // the line below will force the browser to perform a repaint so
      // that all the animated elements within the animation frame will
      // be properly updated and drawn on screen. This is required to
      // ensure that the preparation animation is properly flushed so that
      // the active state picks up from there. DO NOT REMOVE THIS LINE.
      // DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      // WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      // WILL TAKE YEARS AWAY FROM YOUR LIFE.
        if (domNode) {
          if (!domNode.nodeType && domNode instanceof jqLite) {
            domNode = domNode[0];
          }
        } else {
          domNode = $document[0].body;
        }
        return domNode.offsetWidth + 1;
      };
    }];
  };

  var APPLICATION_JSON = "application/json";
  var CONTENT_TYPE_APPLICATION_JSON = { "Content-Type": APPLICATION_JSON + ";charset=utf-8" };
  var JSON_START = /^\[|^\{(?!\{)/;
  var JSON_ENDS = {
    "[": /]$/,
    "{": /}$/
  };
  var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
  var $httpMinErr = minErr("$http");

  function serializeValue(v) {
    if (isObject(v)) {
      return isDate(v) ? v.toISOString() : toJson(v);
    }
    return v;
  }

  /** @this */
  function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */

    this.$get = function () {
      return function ngParamSerializer(params) {
        if (!params) return "";
        var parts = [];
        forEachSorted(params, function (value, key) {
          if (value === null || isUndefined(value) || isFunction(value)) return;
          if (isArray(value)) {
            forEach(value, function (v) {
              parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(serializeValue(v)));
            });
          } else {
            parts.push(encodeUriQuery(key) + "=" + encodeUriQuery(serializeValue(value)));
          }
        });

        return parts.join("&");
      };
    };
  }

  /** @this */
  function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */
    this.$get = function () {
      return function jQueryLikeParamSerializer(params) {
        if (!params) return "";
        var parts = [];
        serialize(params, "", true);
        return parts.join("&");

        function serialize(toSerialize, prefix, topLevel) {
          if (toSerialize === null || isUndefined(toSerialize)) return;
          if (isArray(toSerialize)) {
            forEach(toSerialize, function (value, index) {
              serialize(value, prefix + "[" + (isObject(value) ? index : "") + "]");
            });
          } else if (isObject(toSerialize) && !isDate(toSerialize)) {
            forEachSorted(toSerialize, function (value, key) {
              serialize(value, prefix +
                (topLevel ? "" : "[") +
                key +
                (topLevel ? "" : "]"));
            });
          } else {
            parts.push(encodeUriQuery(prefix) + "=" + encodeUriQuery(serializeValue(toSerialize)));
          }
        }
      };
    };
  }

  function defaultHttpResponseTransform(data, headers) {
    if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
      var tempData = data.replace(JSON_PROTECTION_PREFIX, "").trim();

      if (tempData) {
        var contentType = headers("Content-Type");
        var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);

        if (hasJsonContentType || isJsonLike(tempData)) {
          try {
            data = fromJson(tempData);
          } catch (e) {
            if (!hasJsonContentType) {
              return data;
            }
            throw $httpMinErr("baddata", "Data must be a valid JSON object. Received: \"{0}\". " +
          "Parse error: \"{1}\"", data, e);
          }
        }
      }
    }

    return data;
  }

  function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
  }

  /**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
  function parseHeaders(headers) {
    var parsed = createMap(), i;

    function fillInParsed(key, val) {
      if (key) {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }

    if (isString(headers)) {
      forEach(headers.split("\n"), function (line) {
        i = line.indexOf(":");
        fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
      });
    } else if (isObject(headers)) {
      forEach(headers, function (headerVal, headerKey) {
        fillInParsed(lowercase(headerKey), trim(headerVal));
      });
    }

    return parsed;
  }

  /**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
  function headersGetter(headers) {
    var headersObj;

    return function (name) {
      if (!headersObj) headersObj = parseHeaders(headers);

      if (name) {
        var value = headersObj[lowercase(name)];
        if (value === undefined) {
          value = null;
        }
        return value;
      }

      return headersObj;
    };
  }

  /**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
  function transformData(data, headers, status, fns) {
    if (isFunction(fns)) {
      return fns(data, headers, status);
    }

    forEach(fns, function (fn) {
      data = fn(data, headers, status);
    });

    return data;
  }

  function isSuccess(status) {
    return 200 <= status && status < 300;
  }

  /**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */
  function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */
    var defaults = this.defaults = {
    // transform incoming response data
      transformResponse: [defaultHttpResponseTransform],

      // transform outgoing request data
      transformRequest: [function (d) {
        return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
      }],

      // default headers
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        },
        post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
        put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
        patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
      },

      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",

      paramSerializer: "$httpParamSerializer",

      jsonpCallbackParam: "callback"
    };

    var useApplyAsync = false;
    /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */
    this.useApplyAsync = function (value) {
      if (isDefined(value)) {
        useApplyAsync = !!value;
        return this;
      }
      return useApplyAsync;
    };

    /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */
    var interceptorFactories = this.interceptors = [];

    /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to whitelist specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfWhitelistedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfWhitelistedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */
    var xsrfWhitelistedOrigins = this.xsrfWhitelistedOrigins = [];

    this.$get = ["$browser", "$httpBackend", "$$cookieReader", "$cacheFactory", "$rootScope", "$q", "$injector", "$sce",
      function ($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

        var defaultCache = $cacheFactory("$http");

        /**
     * Make sure that default param serializer is exposed as a function
     */
        defaults.paramSerializer = isString(defaults.paramSerializer) ?
          $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

        /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
        var reversedInterceptors = [];

        forEach(interceptorFactories, function (interceptorFactory) {
          reversedInterceptors.unshift(isString(interceptorFactory)
            ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
        });

        /**
     * A function to check request URLs against a list of allowed origins.
     */
        var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfWhitelistedOrigins);

        /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can whitelist additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfWhitelistedOrigins xsrfWhitelistedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfWhitelistedOrigins $httpProvider.xsrfWhitelistedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only whitelist origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must whitelist the JSONP endpoint that we are using to show that we trust it
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
        function $http(requestConfig) {

          if (!isObject(requestConfig)) {
            throw minErr("$http")("badreq", "Http request configuration must be an object.  Received: {0}", requestConfig);
          }

          if (!isString($sce.valueOf(requestConfig.url))) {
            throw minErr("$http")("badreq", "Http request configuration url must be a string or a $sce trusted object.  Received: {0}", requestConfig.url);
          }

          var config = extend({
            method: "get",
            transformRequest: defaults.transformRequest,
            transformResponse: defaults.transformResponse,
            paramSerializer: defaults.paramSerializer,
            jsonpCallbackParam: defaults.jsonpCallbackParam
          }, requestConfig);

          config.headers = mergeHeaders(requestConfig);
          config.method = uppercase(config.method);
          config.paramSerializer = isString(config.paramSerializer) ?
            $injector.get(config.paramSerializer) : config.paramSerializer;

          $browser.$$incOutstandingRequestCount();

          var requestInterceptors = [];
          var responseInterceptors = [];
          var promise = $q.resolve(config);

          // apply interceptors
          forEach(reversedInterceptors, function (interceptor) {
            if (interceptor.request || interceptor.requestError) {
              requestInterceptors.unshift(interceptor.request, interceptor.requestError);
            }
            if (interceptor.response || interceptor.responseError) {
              responseInterceptors.push(interceptor.response, interceptor.responseError);
            }
          });

          promise = chainInterceptors(promise, requestInterceptors);
          promise = promise.then(serverRequest);
          promise = chainInterceptors(promise, responseInterceptors);
          promise = promise.finally(completeOutstandingRequest);

          return promise;

          function chainInterceptors(promise, interceptors) {
            for (var i = 0, ii = interceptors.length; i < ii;) {
              var thenFn = interceptors[i++];
              var rejectFn = interceptors[i++];

              promise = promise.then(thenFn, rejectFn);
            }

            interceptors.length = 0;

            return promise;
          }

          function completeOutstandingRequest() {
            $browser.$$completeOutstandingRequest(noop);
          }

          function executeHeaderFns(headers, config) {
            var headerContent, processedHeaders = {};

            forEach(headers, function (headerFn, header) {
              if (isFunction(headerFn)) {
                headerContent = headerFn(config);
                if (headerContent != null) {
                  processedHeaders[header] = headerContent;
                }
              } else {
                processedHeaders[header] = headerFn;
              }
            });

            return processedHeaders;
          }

          function mergeHeaders(config) {
            var defHeaders = defaults.headers,
              reqHeaders = extend({}, config.headers),
              defHeaderName, lowercaseDefHeaderName, reqHeaderName;

            defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

            // using for-in instead of forEach to avoid unnecessary iteration after header has been found
            defaultHeadersIteration:
            for (defHeaderName in defHeaders) {
              lowercaseDefHeaderName = lowercase(defHeaderName);

              for (reqHeaderName in reqHeaders) {
                if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
                  continue defaultHeadersIteration;
                }
              }

              reqHeaders[defHeaderName] = defHeaders[defHeaderName];
            }

            // execute if header value is a function for merged headers
            return executeHeaderFns(reqHeaders, shallowCopy(config));
          }

          function serverRequest(config) {
            var headers = config.headers;
            var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

            // strip content-type if data is undefined
            if (isUndefined(reqData)) {
              forEach(headers, function (value, header) {
                if (lowercase(header) === "content-type") {
                  delete headers[header];
                }
              });
            }

            if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
              config.withCredentials = defaults.withCredentials;
            }

            // send request
            return sendReq(config, reqData).then(transformResponse, transformResponse);
          }

          function transformResponse(response) {
            // make a copy since the response must be cacheable
            var resp = extend({}, response);
            resp.data = transformData(response.data, response.headers, response.status,
              config.transformResponse);
            return (isSuccess(response.status))
              ? resp
              : $q.reject(resp);
          }
        }

        $http.pendingRequests = [];

        /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

        /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

        /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

        /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the whitelist via
     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */
        createShortMethods("get", "delete", "head", "jsonp");

        /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

        /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

        /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */
        createShortMethodsWithData("post", "put", "patch");

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
        $http.defaults = defaults;

        return $http;

        function createShortMethods(names) {
          forEach(arguments, function (name) {
            $http[name] = function (url, config) {
              return $http(extend({}, config || {}, {
                method: name,
                url: url
              }));
            };
          });
        }

        function createShortMethodsWithData(name) {
          forEach(arguments, function (name) {
            $http[name] = function (url, data, config) {
              return $http(extend({}, config || {}, {
                method: name,
                url: url,
                data: data
              }));
            };
          });
        }

        /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
        function sendReq(config, reqData) {
          var deferred = $q.defer(),
            promise = deferred.promise,
            cache,
            cachedResp,
            reqHeaders = config.headers,
            isJsonp = lowercase(config.method) === "jsonp",
            url = config.url;

          if (isJsonp) {
            // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
            // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
            url = $sce.getTrustedResourceUrl(url);
          } else if (!isString(url)) {
            // If it is not a string then the URL must be a $sce trusted object
            url = $sce.valueOf(url);
          }

          url = buildUrl(url, config.paramSerializer(config.params));

          if (isJsonp) {
            // Check the url and add the JSONP callback placeholder
            url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
          }

          $http.pendingRequests.push(config);
          promise.then(removePendingReq, removePendingReq);

          if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === "GET" || config.method === "JSONP")) {
            cache = isObject(config.cache) ? config.cache
              : isObject(/** @type {?} */ (defaults).cache)
                ? /** @type {?} */ (defaults).cache
                : defaultCache;
          }

          if (cache) {
            cachedResp = cache.get(url);
            if (isDefined(cachedResp)) {
              if (isPromiseLike(cachedResp)) {
                // cached request has already been sent, but there is no response yet
                cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
              } else {
                // serving from cache
                if (isArray(cachedResp)) {
                  resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
                } else {
                  resolvePromise(cachedResp, 200, {}, "OK", "complete");
                }
              }
            } else {
              // put the promise for the non-transformed response into cache as a placeholder
              cache.put(url, promise);
            }
          }

          // if we won't have the response in cache, set the xsrf headers and
          // send the request to the backend
          if (isUndefined(cachedResp)) {
            var xsrfValue = urlIsAllowedOrigin(config.url)
              ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
              : undefined;
            if (xsrfValue) {
              reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
            }

            $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
              config.withCredentials, config.responseType,
              createApplyHandlers(config.eventHandlers),
              createApplyHandlers(config.uploadEventHandlers));
          }

          return promise;

          function createApplyHandlers(eventHandlers) {
            if (eventHandlers) {
              var applyHandlers = {};
              forEach(eventHandlers, function (eventHandler, key) {
                applyHandlers[key] = function (event) {
                  if (useApplyAsync) {
                    $rootScope.$applyAsync(callEventHandler);
                  } else if ($rootScope.$$phase) {
                    callEventHandler();
                  } else {
                    $rootScope.$apply(callEventHandler);
                  }

                  function callEventHandler() {
                    eventHandler(event);
                  }
                };
              });
              return applyHandlers;
            }
          }

          /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
          function done(status, response, headersString, statusText, xhrStatus) {
            if (cache) {
              if (isSuccess(status)) {
                cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
              } else {
                // remove promise from the cache
                cache.remove(url);
              }
            }

            function resolveHttpPromise() {
              resolvePromise(response, status, headersString, statusText, xhrStatus);
            }

            if (useApplyAsync) {
              $rootScope.$applyAsync(resolveHttpPromise);
            } else {
              resolveHttpPromise();
              if (!$rootScope.$$phase) $rootScope.$apply();
            }
          }

          /**
       * Resolves the raw $http promise.
       */
          function resolvePromise(response, status, headers, statusText, xhrStatus) {
            // status: HTTP response status code, 0, -1 (aborted by timeout / promise)
            status = status >= -1 ? status : 0;

            (isSuccess(status) ? deferred.resolve : deferred.reject)({
              data: response,
              status: status,
              headers: headersGetter(headers),
              config: config,
              statusText: statusText,
              xhrStatus: xhrStatus
            });
          }

          function resolvePromiseWithResult(result) {
            resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
          }

          function removePendingReq() {
            var idx = $http.pendingRequests.indexOf(config);
            if (idx !== -1) $http.pendingRequests.splice(idx, 1);
          }
        }

        function buildUrl(url, serializedParams) {
          if (serializedParams.length > 0) {
            url += ((url.indexOf("?") === -1) ? "?" : "&") + serializedParams;
          }
          return url;
        }

        function sanitizeJsonpCallbackParam(url, cbKey) {
          var parts = url.split("?");
          if (parts.length > 2) {
            // Throw if the url contains more than one `?` query indicator
            throw $httpMinErr("badjsonp", "Illegal use more than one \"?\", in url, \"{1}\"", url);
          }
          var params = parseKeyValue(parts[1]);
          forEach(params, function (value, key) {
            if (value === "JSON_CALLBACK") {
              // Throw if the url already contains a reference to JSON_CALLBACK
              throw $httpMinErr("badjsonp", "Illegal use of JSON_CALLBACK in url, \"{0}\"", url);
            }
            if (key === cbKey) {
              // Throw if the callback param was already provided
              throw $httpMinErr("badjsonp", "Illegal use of callback param, \"{0}\", in url, \"{1}\"", cbKey, url);
            }
          });

          // Add in the JSON_CALLBACK callback param value
          url += ((url.indexOf("?") === -1) ? "?" : "&") + cbKey + "=JSON_CALLBACK";

          return url;
        }
      }];
  }

  /**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
  function $xhrFactoryProvider() {
    this.$get = function () {
      return function createXhr() {
        return new window.XMLHttpRequest();
      };
    };
  }

  /**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
  function $HttpBackendProvider() {
    this.$get = ["$browser", "$jsonpCallbacks", "$document", "$xhrFactory", function ($browser, $jsonpCallbacks, $document, $xhrFactory) {
      return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
    }];
  }

  function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
    return function (method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
      url = url || $browser.url();

      if (lowercase(method) === "jsonp") {
        var callbackPath = callbacks.createCallback(url);
        var jsonpDone = jsonpReq(url, callbackPath, function (status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
          var response = (status === 200) && callbacks.getResponse(callbackPath);
          completeRequest(callback, status, response, "", text, "complete");
          callbacks.removeCallback(callbackPath);
        });
      } else {

        var xhr = createXhr(method, url);
        var abortedByTimeout = false;

        xhr.open(method, url, true);
        forEach(headers, function (value, key) {
          if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
          }
        });

        xhr.onload = function requestLoaded() {
          var statusText = xhr.statusText || "";

          // responseText is the old-school way of retrieving response (supported by IE9)
          // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
          var response = ("response" in xhr) ? xhr.response : xhr.responseText;

          // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
          var status = xhr.status === 1223 ? 204 : xhr.status;

          // fix status code when it is 0 (0 status is undocumented).
          // Occurs when accessing file resources or on Android 4.1 stock browser
          // while retrieving files from application cache.
          if (status === 0) {
            status = response ? 200 : urlResolve(url).protocol === "file" ? 404 : 0;
          }

          completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText,
            "complete");
        };

        var requestError = function () {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
          completeRequest(callback, -1, null, null, "", "error");
        };

        var requestAborted = function () {
          completeRequest(callback, -1, null, null, "", abortedByTimeout ? "timeout" : "abort");
        };

        var requestTimeout = function () {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
          completeRequest(callback, -1, null, null, "", "timeout");
        };

        xhr.onerror = requestError;
        xhr.ontimeout = requestTimeout;
        xhr.onabort = requestAborted;

        forEach(eventHandlers, function (value, key) {
          xhr.addEventListener(key, value);
        });

        forEach(uploadEventHandlers, function (value, key) {
          xhr.upload.addEventListener(key, value);
        });

        if (withCredentials) {
          xhr.withCredentials = true;
        }

        if (responseType) {
          try {
            xhr.responseType = responseType;
          } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
            if (responseType !== "json") {
              throw e;
            }
          }
        }

        xhr.send(isUndefined(post) ? null : post);
      }

      // Since we are using xhr.abort() when a request times out, we have to set a flag that
      // indicates to requestAborted if the request timed out or was aborted.
      //
      // http.timeout = numerical timeout   timeout
      // http.timeout = $timeout            timeout
      // http.timeout = promise             abort
      // xhr.abort()                        abort (The xhr object is normally inaccessible, but
      //                                    can be exposed with the xhrFactory)
      if (timeout > 0) {
        var timeoutId = $browserDefer(function () {
          timeoutRequest("timeout");
        }, timeout);
      } else if (isPromiseLike(timeout)) {
        timeout.then(function () {
          timeoutRequest(isDefined(timeout.$$timeoutId) ? "timeout" : "abort");
        });
      }

      function timeoutRequest(reason) {
        abortedByTimeout = reason === "timeout";
        if (jsonpDone) {
          jsonpDone();
        }
        if (xhr) {
          xhr.abort();
        }
      }

      function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
      // cancel timeout and subsequent timeout promise resolution
        if (isDefined(timeoutId)) {
          $browserDefer.cancel(timeoutId);
        }
        jsonpDone = xhr = null;

        callback(status, response, headersString, statusText, xhrStatus);
      }
    };

    function jsonpReq(url, callbackPath, done) {
      url = url.replace("JSON_CALLBACK", callbackPath);
      // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
      // - fetches local scripts via XHR and evals them
      // - adds and immediately removes script elements from the document
      var script = rawDocument.createElement("script"), callback = null;
      script.type = "text/javascript";
      script.src = url;
      script.async = true;

      callback = function (event) {
        script.removeEventListener("load", callback);
        script.removeEventListener("error", callback);
        rawDocument.body.removeChild(script);
        script = null;
        var status = -1;
        var text = "unknown";

        if (event) {
          if (event.type === "load" && !callbacks.wasCalled(callbackPath)) {
            event = { type: "error" };
          }
          text = event.type;
          status = event.type === "error" ? 404 : 200;
        }

        if (done) {
          done(status, text);
        }
      };

      script.addEventListener("load", callback);
      script.addEventListener("error", callback);
      rawDocument.body.appendChild(script);
      return callback;
    }
  }

  var $interpolateMinErr = angular.$interpolateMinErr = minErr("$interpolate");
  $interpolateMinErr.throwNoconcat = function (text) {
    throw $interpolateMinErr("noconcat",
      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
      "interpolations that concatenate multiple expressions when a trusted value is " +
      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
  };

  $interpolateMinErr.interr = function (text, err) {
    return $interpolateMinErr("interr", "Can't interpolate: {0}\n{1}", text, err.toString());
  };

  /**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });

  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
  function $InterpolateProvider() {
    var startSymbol = "{{";
    var endSymbol = "}}";

    /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
    this.startSymbol = function (value) {
      if (value) {
        startSymbol = value;
        return this;
      } else {
        return startSymbol;
      }
    };

    /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
    this.endSymbol = function (value) {
      if (value) {
        endSymbol = value;
        return this;
      } else {
        return endSymbol;
      }
    };

    this.$get = ["$parse", "$exceptionHandler", "$sce", function ($parse, $exceptionHandler, $sce) {
      var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), "g"),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), "g");

      function escape(ch) {
        return "\\\\\\" + ch;
      }

      function unescapeText(text) {
        return text.replace(escapedStartRegexp, startSymbol).
          replace(escapedEndRegexp, endSymbol);
      }

      // TODO: this is the same as the constantWatchDelegate in parse.js
      function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
        var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
          unwatch();
          return constantInterp(scope);
        }, listener, objectEquality);
        return unwatch;
      }

      /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
      function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      // Provide a quick exit and simplified result function for text with no interpolation
        if (!text.length || text.indexOf(startSymbol) === -1) {
          var constantInterp;
          if (!mustHaveExpression) {
            var unescapedText = unescapeText(text);
            constantInterp = valueFn(unescapedText);
            constantInterp.exp = text;
            constantInterp.expressions = [];
            constantInterp.$$watchDelegate = constantWatchDelegate;
          }
          return constantInterp;
        }

        allOrNothing = !!allOrNothing;
        var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

        while (index < textLength) {
          if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
            if (index !== startIndex) {
              concat.push(unescapeText(text.substring(index, startIndex)));
            }
            exp = text.substring(startIndex + startSymbolLength, endIndex);
            expressions.push(exp);
            parseFns.push($parse(exp, parseStringifyInterceptor));
            index = endIndex + endSymbolLength;
            expressionPositions.push(concat.length);
            concat.push("");
          } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
            if (index !== textLength) {
              concat.push(unescapeText(text.substring(index)));
            }
            break;
          }
        }

        // Concatenating expressions makes it hard to reason about whether some combination of
        // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
        // single expression be used for iframe[src], object[src], etc., we ensure that the value
        // that's used is assigned or constructed by some JS code somewhere that is more testable or
        // make it obvious that you bound the value to some user controlled value.  This helps reduce
        // the load when auditing for XSS issues.
        if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
        }

        if (!mustHaveExpression || expressions.length) {
          var compute = function (values) {
            for (var i = 0, ii = expressions.length; i < ii; i++) {
              if (allOrNothing && isUndefined(values[i])) return;
              concat[expressionPositions[i]] = values[i];
            }
            return concat.join("");
          };

          var getValue = function (value) {
            return trustedContext ?
              $sce.getTrusted(trustedContext, value) :
              $sce.valueOf(value);
          };

          return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
            exp: text, // just for compatibility with regular watchers created via $watch
            expressions: expressions,
            $$watchDelegate: function (scope, listener) {
              var lastValue;
              return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
                var currValue = compute(values);
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                lastValue = currValue;
              });
            }
          });
        }

        function parseStringifyInterceptor(value) {
          try {
            value = getValue(value);
            return allOrNothing && !isDefined(value) ? value : stringify(value);
          } catch (err) {
            $exceptionHandler($interpolateMinErr.interr(text, err));
          }
        }
      }

      /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
      $interpolate.startSymbol = function () {
        return startSymbol;
      };

      /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
      $interpolate.endSymbol = function () {
        return endSymbol;
      };

      return $interpolate;
    }];
  }

  /** @this */
  function $IntervalProvider() {
    this.$get = ["$rootScope", "$window", "$q", "$$q", "$browser",
      function ($rootScope, $window, $q, $$q, $browser) {
        var intervals = {};

        /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */
        function interval(fn, delay, count, invokeApply) {
          var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            setInterval = $window.setInterval,
            clearInterval = $window.clearInterval,
            iteration = 0,
            skipApply = (isDefined(invokeApply) && !invokeApply),
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;

          count = isDefined(count) ? count : 0;

          promise.$$intervalId = setInterval(function tick() {
            if (skipApply) {
              $browser.defer(callback);
            } else {
              $rootScope.$evalAsync(callback);
            }
            deferred.notify(iteration++);

            if (count > 0 && iteration >= count) {
              deferred.resolve(iteration);
              clearInterval(promise.$$intervalId);
              delete intervals[promise.$$intervalId];
            }

            if (!skipApply) $rootScope.$apply();

          }, delay);

          intervals[promise.$$intervalId] = deferred;

          return promise;

          function callback() {
            if (!hasParams) {
              fn(iteration);
            } else {
              fn.apply(null, args);
            }
          }
        }

        /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */
        interval.cancel = function (promise) {
          if (promise && promise.$$intervalId in intervals) {
            // Interval cancels should not report as unhandled promise.
            markQExceptionHandled(intervals[promise.$$intervalId].promise);
            intervals[promise.$$intervalId].reject("canceled");
            $window.clearInterval(promise.$$intervalId);
            delete intervals[promise.$$intervalId];
            return true;
          }
          return false;
        };

        return interval;
      }];
  }

  /**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
  var $jsonpCallbacksProvider = /** @this */ function () {
    this.$get = function () {
      var callbacks = angular.callbacks;
      var callbackMap = {};

      function createCallback(callbackId) {
        var callback = function (data) {
          callback.data = data;
          callback.called = true;
        };
        callback.id = callbackId;
        return callback;
      }

      return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
        createCallback: function (url) {
          var callbackId = "_" + (callbacks.$$counter++).toString(36);
          var callbackPath = "angular.callbacks." + callbackId;
          var callback = createCallback(callbackId);
          callbackMap[callbackPath] = callbacks[callbackId] = callback;
          return callbackPath;
        },
        /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
        wasCalled: function (callbackPath) {
          return callbackMap[callbackPath].called;
        },
        /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
        getResponse: function (callbackPath) {
          return callbackMap[callbackPath].data;
        },
        /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
        removeCallback: function (callbackPath) {
          var callback = callbackMap[callbackPath];
          delete callbacks[callback.id];
          delete callbackMap[callbackPath];
        }
      };
    };
  };

  /**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

  var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = { "http": 80, "https": 443, "ftp": 21 };
  var $locationMinErr = minErr("$location");

  /**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
  function encodePath(path) {
    var segments = path.split("/"),
      i = segments.length;

    while (i--) {
    // decode forward slashes to prevent them from being double encoded
      segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, "/"));
    }

    return segments.join("/");
  }

  function decodePath(path, html5Mode) {
    var segments = path.split("/"),
      i = segments.length;

    while (i--) {
      segments[i] = decodeURIComponent(segments[i]);
      if (html5Mode) {
      // encode forward slashes to prevent them from being mistaken for path separators
        segments[i] = segments[i].replace(/\//g, "%2F");
      }
    }

    return segments.join("/");
  }

  function parseAbsoluteUrl(absoluteUrl, locationObj) {
    var parsedUrl = urlResolve(absoluteUrl);

    locationObj.$$protocol = parsedUrl.protocol;
    locationObj.$$host = parsedUrl.hostname;
    locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
  }

  var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
  function parseAppUrl(url, locationObj, html5Mode) {

    if (DOUBLE_SLASH_REGEX.test(url)) {
      throw $locationMinErr("badpath", "Invalid url \"{0}\".", url);
    }

    var prefixed = (url.charAt(0) !== "/");
    if (prefixed) {
      url = "/" + url;
    }
    var match = urlResolve(url);
    var path = prefixed && match.pathname.charAt(0) === "/" ? match.pathname.substring(1) : match.pathname;
    locationObj.$$path = decodePath(path, html5Mode);
    locationObj.$$search = parseKeyValue(match.search);
    locationObj.$$hash = decodeURIComponent(match.hash);

    // make sure path starts with '/';
    if (locationObj.$$path && locationObj.$$path.charAt(0) !== "/") {
      locationObj.$$path = "/" + locationObj.$$path;
    }
  }

  function startsWith(str, search) {
    return str.slice(0, search.length) === search;
  }

  /**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
  function stripBaseUrl(base, url) {
    if (startsWith(url, base)) {
      return url.substr(base.length);
    }
  }

  function stripHash(url) {
    var index = url.indexOf("#");
    return index === -1 ? url : url.substr(0, index);
  }

  function trimEmptyHash(url) {
    return url.replace(/(#.+)|#$/, "$1");
  }

  function stripFile(url) {
    return url.substr(0, stripHash(url).lastIndexOf("/") + 1);
  }

  /* return the server only (scheme://host:port) */
  function serverBase(url) {
    return url.substring(0, url.indexOf("/", url.indexOf("//") + 2));
  }

  /**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
  function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
    this.$$html5 = true;
    basePrefix = basePrefix || "";
    parseAbsoluteUrl(appBase, this);

    /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
    this.$$parse = function (url) {
      var pathUrl = stripBaseUrl(appBaseNoFile, url);
      if (!isString(pathUrl)) {
        throw $locationMinErr("ipthprfx", "Invalid url \"{0}\", missing path prefix \"{1}\".", url,
          appBaseNoFile);
      }

      parseAppUrl(pathUrl, this, true);

      if (!this.$$path) {
        this.$$path = "/";
      }

      this.$$compose();
    };

    /**
   * Compose url and update `absUrl` property
   * @private
   */
    this.$$compose = function () {
      var search = toKeyValue(this.$$search),
        hash = this.$$hash ? "#" + encodeUriSegment(this.$$hash) : "";

      this.$$url = encodePath(this.$$path) + (search ? "?" + search : "") + hash;
      this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'

      this.$$urlUpdatedByLocation = true;
    };

    this.$$parseLinkUrl = function (url, relHref) {
      if (relHref && relHref[0] === "#") {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
        this.hash(relHref.slice(1));
        return true;
      }
      var appUrl, prevAppUrl;
      var rewrittenUrl;

      if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
        prevAppUrl = appUrl;
        if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
          rewrittenUrl = appBaseNoFile + (stripBaseUrl("/", appUrl) || appUrl);
        } else {
          rewrittenUrl = appBase + prevAppUrl;
        }
      } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
        rewrittenUrl = appBaseNoFile + appUrl;
      } else if (appBaseNoFile === url + "/") {
        rewrittenUrl = appBaseNoFile;
      }
      if (rewrittenUrl) {
        this.$$parse(rewrittenUrl);
      }
      return !!rewrittenUrl;
    };
  }

  /**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
  function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

    parseAbsoluteUrl(appBase, this);

    /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
    this.$$parse = function (url) {
      var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
      var withoutHashUrl;

      if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === "#") {

        // The rest of the URL starts with a hash so we have
        // got either a hashbang path or a plain hash fragment
        withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
        if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
          withoutHashUrl = withoutBaseUrl;
        }

      } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
        if (this.$$html5) {
          withoutHashUrl = withoutBaseUrl;
        } else {
          withoutHashUrl = "";
          if (isUndefined(withoutBaseUrl)) {
            appBase = url;
            /** @type {?} */ (this).replace();
          }
        }
      }

      parseAppUrl(withoutHashUrl, this, false);

      this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

      this.$$compose();

      /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */
      function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
        var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

        var firstPathSegmentMatch;

        // Get the relative path from the input URL.
        if (startsWith(url, base)) {
          url = url.replace(base, "");
        }

        // The input URL intentionally contains a first path segment that ends with a colon.
        if (windowsFilePathExp.exec(url)) {
          return path;
        }

        firstPathSegmentMatch = windowsFilePathExp.exec(path);
        return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
      }
    };

    /**
   * Compose hashbang URL and update `absUrl` property
   * @private
   */
    this.$$compose = function () {
      var search = toKeyValue(this.$$search),
        hash = this.$$hash ? "#" + encodeUriSegment(this.$$hash) : "";

      this.$$url = encodePath(this.$$path) + (search ? "?" + search : "") + hash;
      this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : "");

      this.$$urlUpdatedByLocation = true;
    };

    this.$$parseLinkUrl = function (url, relHref) {
      if (stripHash(appBase) === stripHash(url)) {
        this.$$parse(url);
        return true;
      }
      return false;
    };
  }

  /**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
  function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
    this.$$html5 = true;
    LocationHashbangUrl.apply(this, arguments);

    this.$$parseLinkUrl = function (url, relHref) {
      if (relHref && relHref[0] === "#") {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
        this.hash(relHref.slice(1));
        return true;
      }

      var rewrittenUrl;
      var appUrl;

      if (appBase === stripHash(url)) {
        rewrittenUrl = url;
      } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
        rewrittenUrl = appBase + hashPrefix + appUrl;
      } else if (appBaseNoFile === url + "/") {
        rewrittenUrl = appBaseNoFile;
      }
      if (rewrittenUrl) {
        this.$$parse(rewrittenUrl);
      }
      return !!rewrittenUrl;
    };

    this.$$compose = function () {
      var search = toKeyValue(this.$$search),
        hash = this.$$hash ? "#" + encodeUriSegment(this.$$hash) : "";

      this.$$url = encodePath(this.$$path) + (search ? "?" + search : "") + hash;
      // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
      this.$$absUrl = appBase + hashPrefix + this.$$url;

      this.$$urlUpdatedByLocation = true;
    };

  }

  var locationPrototype = {

    /**
   * Ensure absolute URL is initialized.
   * @private
   */
    $$absUrl: "",

    /**
   * Are we in html5 mode?
   * @private
   */
    $$html5: false,

    /**
   * Has any change been replacing?
   * @private
   */
    $$replace: false,

    /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
    absUrl: locationGetter("$$absUrl"),

    /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
    url: function (url) {
      if (isUndefined(url)) {
        return this.$$url;
      }

      var match = PATH_MATCH.exec(url);
      if (match[1] || url === "") this.path(decodeURIComponent(match[1]));
      if (match[2] || match[1] || url === "") this.search(match[3] || "");
      this.hash(match[5] || "");

      return this;
    },

    /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
    protocol: locationGetter("$$protocol"),

    /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
    host: locationGetter("$$host"),

    /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
    port: locationGetter("$$port"),

    /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
    path: locationGetterSetter("$$path", function (path) {
      path = path !== null ? path.toString() : "";
      return path.charAt(0) === "/" ? path : "/" + path;
    }),

    /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
    search: function (search, paramValue) {
      switch (arguments.length) {
        case 0:
          return this.$$search;
        case 1:
          if (isString(search) || isNumber(search)) {
            search = search.toString();
            this.$$search = parseKeyValue(search);
          } else if (isObject(search)) {
            search = copy(search, {});
            // remove object undefined or null properties
            forEach(search, function (value, key) {
              if (value == null) delete search[key];
            });

            this.$$search = search;
          } else {
            throw $locationMinErr("isrcharg",
              "The first argument of the `$location#search()` call must be a string or an object.");
          }
          break;
        default:
          if (isUndefined(paramValue) || paramValue === null) {
            delete this.$$search[search];
          } else {
            this.$$search[search] = paramValue;
          }
      }

      this.$$compose();
      return this;
    },

    /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
    hash: locationGetterSetter("$$hash", function (hash) {
      return hash !== null ? hash.toString() : "";
    }),

    /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
    replace: function () {
      this.$$replace = true;
      return this;
    }
  };

  forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function (Location) {
    Location.prototype = Object.create(locationPrototype);

    /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
    Location.prototype.state = function (state) {
      if (!arguments.length) {
        return this.$$state;
      }

      if (Location !== LocationHtml5Url || !this.$$html5) {
        throw $locationMinErr("nostate", "History API state support is available only " +
        "in HTML5 mode and only in browsers supporting HTML5 History API");
      }
      // The user might modify `stateObject` after invoking `$location.state(stateObject)`
      // but we're changing the $$state reference to $browser.state() during the $digest
      // so the modification window is narrow.
      this.$$state = isUndefined(state) ? null : state;
      this.$$urlUpdatedByLocation = true;

      return this;
    };
  });

  function locationGetter(property) {
    return /** @this */ function () {
      return this[property];
    };
  }

  function locationGetterSetter(property, preprocess) {
    return /** @this */ function (value) {
      if (isUndefined(value)) {
        return this[property];
      }

      this[property] = preprocess(value);
      this.$$compose();

      return this;
    };
  }

  /**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

  /**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
  function $LocationProvider() {
    var hashPrefix = "!",
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

    /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
    this.hashPrefix = function (prefix) {
      if (isDefined(prefix)) {
        hashPrefix = prefix;
        return this;
      } else {
        return hashPrefix;
      }
    };

    /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
    this.html5Mode = function (mode) {
      if (isBoolean(mode)) {
        html5Mode.enabled = mode;
        return this;
      } else if (isObject(mode)) {

        if (isBoolean(mode.enabled)) {
          html5Mode.enabled = mode.enabled;
        }

        if (isBoolean(mode.requireBase)) {
          html5Mode.requireBase = mode.requireBase;
        }

        if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
          html5Mode.rewriteLinks = mode.rewriteLinks;
        }

        return this;
      } else {
        return html5Mode;
      }
    };

    /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

    /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

    this.$get = ["$rootScope", "$browser", "$sniffer", "$rootElement", "$window",
      function ($rootScope, $browser, $sniffer, $rootElement, $window) {
        var $location,
          LocationMode,
          baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
          initialUrl = $browser.url(),
          appBase;

        if (html5Mode.enabled) {
          if (!baseHref && html5Mode.requireBase) {
            throw $locationMinErr("nobase",
              "$location in HTML5 mode requires a <base> tag to be present!");
          }
          appBase = serverBase(initialUrl) + (baseHref || "/");
          LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
        } else {
          appBase = stripHash(initialUrl);
          LocationMode = LocationHashbangUrl;
        }
        var appBaseNoFile = stripFile(appBase);

        $location = new LocationMode(appBase, appBaseNoFile, "#" + hashPrefix);
        $location.$$parseLinkUrl(initialUrl, initialUrl);

        $location.$$state = $browser.state();

        var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

        function setBrowserUrlWithFallback(url, replace, state) {
          var oldUrl = $location.url();
          var oldState = $location.$$state;
          try {
            $browser.url(url, replace, state);

            // Make sure $location.state() returns referentially identical (not just deeply equal)
            // state object; this makes possible quick checking if the state changed in the digest
            // loop. Checking deep equality would be too expensive.
            $location.$$state = $browser.state();
          } catch (e) {
            // Restore old values if pushState fails
            $location.url(oldUrl);
            $location.$$state = oldState;

            throw e;
          }
        }

        $rootElement.on("click", function (event) {
          var rewriteLinks = html5Mode.rewriteLinks;
          // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
          // currently we open nice url link and redirect then

          if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

          var elm = jqLite(event.target);

          // traverse the DOM up to find first A tag
          while (nodeName_(elm[0]) !== "a") {
            // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
            if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
          }

          if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

          var absHref = elm.prop("href");
          // get the actual href attribute - see
          // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
          var relHref = elm.attr("href") || elm.attr("xlink:href");

          if (isObject(absHref) && absHref.toString() === "[object SVGAnimatedString]") {
            // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
            // an animation.
            absHref = urlResolve(absHref.animVal).href;
          }

          // Ignore when url is started with javascript: or mailto:
          if (IGNORE_URI_REGEXP.test(absHref)) return;

          if (absHref && !elm.attr("target") && !event.isDefaultPrevented()) {
            if ($location.$$parseLinkUrl(absHref, relHref)) {
              // We do a preventDefault for all urls that are part of the AngularJS application,
              // in html5mode and also without, so that we are able to abort navigation without
              // getting double entries in the location history.
              event.preventDefault();
              // update location manually
              if ($location.absUrl() !== $browser.url()) {
                $rootScope.$apply();
                // hack to work around FF6 bug 684208 when scenario runner clicks on links
                $window.angular["ff-684208-preventDefault"] = true;
              }
            }
          }
        });

        // rewrite hashbang url <> html5 url
        if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
          $browser.url($location.absUrl(), true);
        }

        var initializing = true;

        // update $location when $browser url changes
        $browser.onUrlChange(function (newUrl, newState) {

          if (!startsWith(newUrl, appBaseNoFile)) {
            // If we are navigating outside of the app then force a reload
            $window.location.href = newUrl;
            return;
          }

          $rootScope.$evalAsync(function () {
            var oldUrl = $location.absUrl();
            var oldState = $location.$$state;
            var defaultPrevented;
            newUrl = trimEmptyHash(newUrl);
            $location.$$parse(newUrl);
            $location.$$state = newState;

            defaultPrevented = $rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl,
              newState, oldState).defaultPrevented;

            // if the location was changed by a `$locationChangeStart` handler then stop
            // processing this location change
            if ($location.absUrl() !== newUrl) return;

            if (defaultPrevented) {
              $location.$$parse(oldUrl);
              $location.$$state = oldState;
              setBrowserUrlWithFallback(oldUrl, false, oldState);
            } else {
              initializing = false;
              afterLocationChange(oldUrl, oldState);
            }
          });
          if (!$rootScope.$$phase) $rootScope.$digest();
        });

        // update browser
        $rootScope.$watch(function $locationWatch() {
          if (initializing || $location.$$urlUpdatedByLocation) {
            $location.$$urlUpdatedByLocation = false;

            var oldUrl = trimEmptyHash($browser.url());
            var newUrl = trimEmptyHash($location.absUrl());
            var oldState = $browser.state();
            var currentReplace = $location.$$replace;
            var urlOrStateChanged = oldUrl !== newUrl ||
          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

            if (initializing || urlOrStateChanged) {
              initializing = false;

              $rootScope.$evalAsync(function () {
                var newUrl = $location.absUrl();
                var defaultPrevented = $rootScope.$broadcast("$locationChangeStart", newUrl, oldUrl,
                  $location.$$state, oldState).defaultPrevented;

                // if the location was changed by a `$locationChangeStart` handler then stop
                // processing this location change
                if ($location.absUrl() !== newUrl) return;

                if (defaultPrevented) {
                  $location.$$parse(oldUrl);
                  $location.$$state = oldState;
                } else {
                  if (urlOrStateChanged) {
                    setBrowserUrlWithFallback(newUrl, currentReplace,
                      oldState === $location.$$state ? null : $location.$$state);
                  }
                  afterLocationChange(oldUrl, oldState);
                }
              });
            }
          }

          $location.$$replace = false;

          // we don't need to return anything because $evalAsync will make the digest loop dirty when
          // there is a change
        });

        return $location;

        function afterLocationChange(oldUrl, oldState) {
          $rootScope.$broadcast("$locationChangeSuccess", $location.absUrl(), oldUrl,
            $location.$$state, oldState);
        }
      }];
  }

  /**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

  /**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
  function $LogProvider() {
    var debug = true,
      self = this;

    /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
    this.debugEnabled = function (flag) {
      if (isDefined(flag)) {
        debug = flag;
        return this;
      } else {
        return debug;
      }
    };

    this.$get = ["$window", function ($window) {
    // Support: IE 9-11, Edge 12-14+
    // IE/Edge display errors in such a way that it requires the user to click in 4 places
    // to see the stack trace. There is no way to feature-detect it so there's a chance
    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
    // break apps. Other browsers display errors in a sensible way and some of them map stack
    // traces along source maps if available so it makes sense to let browsers display it
    // as they want.
      var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

      return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
        log: consoleLog("log"),

        /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
        info: consoleLog("info"),

        /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
        warn: consoleLog("warn"),

        /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
        error: consoleLog("error"),

        /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
        debug: (function () {
          var fn = consoleLog("debug");

          return function () {
            if (debug) {
              fn.apply(self, arguments);
            }
          };
        })()
      };

      function formatError(arg) {
        if (isError(arg)) {
          if (arg.stack && formatStackTrace) {
            arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? "Error: " + arg.message + "\n" + arg.stack
              : arg.stack;
          } else if (arg.sourceURL) {
            arg = arg.message + "\n" + arg.sourceURL + ":" + arg.line;
          }
        }
        return arg;
      }

      function consoleLog(type) {
        var console = $window.console || {},
          logFn = console[type] || console.log || noop;

        return function () {
          var args = [];
          forEach(arguments, function (arg) {
            args.push(formatError(arg));
          });
          // Support: IE 9 only
          // console methods don't inherit from Function.prototype in IE 9 so we can't
          // call `logFn.apply(console, args)` directly.
          return Function.prototype.apply.call(logFn, console, args);
        };
      }
    }];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var $parseMinErr = minErr("$parse");

  var objectValueOf = {}.constructor.prototype.valueOf;

  // Sandboxing AngularJS Expressions
  // ------------------------------
  // AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
  // various means such as obtaining a reference to native JS functions like the Function constructor.
  //
  // As an example, consider the following AngularJS expression:
  //
  //   {}.toString.constructor('alert("evil JS code")')
  //
  // It is important to realize that if you create an expression from a string that contains user provided
  // content then it is possible that your application contains a security vulnerability to an XSS style attack.
  //
  // See https://docs.angularjs.org/guide/security

  function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
    return name + "";
  }

  var OPERATORS = createMap();
  forEach("+ - * / % === !== == != < > <= >= && || ! = |".split(" "), function (operator) { OPERATORS[operator] = true; });
  var ESCAPE = { "n": "\n", "f": "\f", "r": "\r", "t": "\t", "v": "\v", "'": "'", "\"": "\"" };

  // ///////////////////////////////////////

  /**
 * @constructor
 */
  var Lexer = function Lexer(options) {
    this.options = options;
  };

  Lexer.prototype = {
    constructor: Lexer,

    lex: function (text) {
      this.text = text;
      this.index = 0;
      this.tokens = [];

      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        if (ch === "\"" || ch === "'") {
          this.readString(ch);
        } else if (this.isNumber(ch) || ch === "." && this.isNumber(this.peek())) {
          this.readNumber();
        } else if (this.isIdentifierStart(this.peekMultichar())) {
          this.readIdent();
        } else if (this.is(ch, "(){}[].,;:?")) {
          this.tokens.push({ index: this.index, text: ch });
          this.index++;
        } else if (this.isWhitespace(ch)) {
          this.index++;
        } else {
          var ch2 = ch + this.peek();
          var ch3 = ch2 + this.peek(2);
          var op1 = OPERATORS[ch];
          var op2 = OPERATORS[ch2];
          var op3 = OPERATORS[ch3];
          if (op1 || op2 || op3) {
            var token = op3 ? ch3 : (op2 ? ch2 : ch);
            this.tokens.push({ index: this.index, text: token, operator: true });
            this.index += token.length;
          } else {
            this.throwError("Unexpected next character ", this.index, this.index + 1);
          }
        }
      }
      return this.tokens;
    },

    is: function (ch, chars) {
      return chars.indexOf(ch) !== -1;
    },

    peek: function (i) {
      var num = i || 1;
      return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
    },

    isNumber: function (ch) {
      return ("0" <= ch && ch <= "9") && typeof ch === "string";
    },

    isWhitespace: function (ch) {
    // IE treats non-breaking space as \u00A0
      return (ch === " " || ch === "\r" || ch === "\t" ||
            ch === "\n" || ch === "\v" || ch === "\u00A0");
    },

    isIdentifierStart: function (ch) {
      return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
    },

    isValidIdentifierStart: function (ch) {
      return ("a" <= ch && ch <= "z" ||
            "A" <= ch && ch <= "Z" ||
            "_" === ch || ch === "$");
    },

    isIdentifierContinue: function (ch) {
      return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
    },

    isValidIdentifierContinue: function (ch, cp) {
      return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
    },

    codePointAt: function (ch) {
      if (ch.length === 1) return ch.charCodeAt(0);
      // eslint-disable-next-line no-bitwise
      return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
    },

    peekMultichar: function () {
      var ch = this.text.charAt(this.index);
      var peek = this.peek();
      if (!peek) {
        return ch;
      }
      var cp1 = ch.charCodeAt(0);
      var cp2 = peek.charCodeAt(0);
      if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
        return ch + peek;
      }
      return ch;
    },

    isExpOperator: function (ch) {
      return (ch === "-" || ch === "+" || this.isNumber(ch));
    },

    throwError: function (error, start, end) {
      end = end || this.index;
      var colStr = (isDefined(start)
        ? "s " + start + "-" + this.index + " [" + this.text.substring(start, end) + "]"
        : " " + end);
      throw $parseMinErr("lexerr", "Lexer Error: {0} at column{1} in expression [{2}].",
        error, colStr, this.text);
    },

    readNumber: function () {
      var number = "";
      var start = this.index;
      while (this.index < this.text.length) {
        var ch = lowercase(this.text.charAt(this.index));
        if (ch === "." || this.isNumber(ch)) {
          number += ch;
        } else {
          var peekCh = this.peek();
          if (ch === "e" && this.isExpOperator(peekCh)) {
            number += ch;
          } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === "e") {
            number += ch;
          } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === "e") {
            this.throwError("Invalid exponent");
          } else {
            break;
          }
        }
        this.index++;
      }
      this.tokens.push({
        index: start,
        text: number,
        constant: true,
        value: Number(number)
      });
    },

    readIdent: function () {
      var start = this.index;
      this.index += this.peekMultichar().length;
      while (this.index < this.text.length) {
        var ch = this.peekMultichar();
        if (!this.isIdentifierContinue(ch)) {
          break;
        }
        this.index += ch.length;
      }
      this.tokens.push({
        index: start,
        text: this.text.slice(start, this.index),
        identifier: true
      });
    },

    readString: function (quote) {
      var start = this.index;
      this.index++;
      var string = "";
      var rawString = quote;
      var escape = false;
      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        rawString += ch;
        if (escape) {
          if (ch === "u") {
            var hex = this.text.substring(this.index + 1, this.index + 5);
            if (!hex.match(/[\da-f]{4}/i)) {
              this.throwError("Invalid unicode escape [\\u" + hex + "]");
            }
            this.index += 4;
            string += String.fromCharCode(parseInt(hex, 16));
          } else {
            var rep = ESCAPE[ch];
            string = string + (rep || ch);
          }
          escape = false;
        } else if (ch === "\\") {
          escape = true;
        } else if (ch === quote) {
          this.index++;
          this.tokens.push({
            index: start,
            text: rawString,
            constant: true,
            value: string
          });
          return;
        } else {
          string += ch;
        }
        this.index++;
      }
      this.throwError("Unterminated quote", start);
    }
  };

  var AST = function AST(lexer, options) {
    this.lexer = lexer;
    this.options = options;
  };

  AST.Program = "Program";
  AST.ExpressionStatement = "ExpressionStatement";
  AST.AssignmentExpression = "AssignmentExpression";
  AST.ConditionalExpression = "ConditionalExpression";
  AST.LogicalExpression = "LogicalExpression";
  AST.BinaryExpression = "BinaryExpression";
  AST.UnaryExpression = "UnaryExpression";
  AST.CallExpression = "CallExpression";
  AST.MemberExpression = "MemberExpression";
  AST.Identifier = "Identifier";
  AST.Literal = "Literal";
  AST.ArrayExpression = "ArrayExpression";
  AST.Property = "Property";
  AST.ObjectExpression = "ObjectExpression";
  AST.ThisExpression = "ThisExpression";
  AST.LocalsExpression = "LocalsExpression";

  // Internal use only
  AST.NGValueParameter = "NGValueParameter";

  AST.prototype = {
    ast: function (text) {
      this.text = text;
      this.tokens = this.lexer.lex(text);

      var value = this.program();

      if (this.tokens.length !== 0) {
        this.throwError("is an unexpected token", this.tokens[0]);
      }

      return value;
    },

    program: function () {
      var body = [];
      while (true) {
        if (this.tokens.length > 0 && !this.peek("}", ")", ";", "]"))
          body.push(this.expressionStatement());
        if (!this.expect(";")) {
          return { type: AST.Program, body: body };
        }
      }
    },

    expressionStatement: function () {
      return { type: AST.ExpressionStatement, expression: this.filterChain() };
    },

    filterChain: function () {
      var left = this.expression();
      while (this.expect("|")) {
        left = this.filter(left);
      }
      return left;
    },

    expression: function () {
      return this.assignment();
    },

    assignment: function () {
      var result = this.ternary();
      if (this.expect("=")) {
        if (!isAssignable(result)) {
          throw $parseMinErr("lval", "Trying to assign a value to a non l-value");
        }

        result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: "=" };
      }
      return result;
    },

    ternary: function () {
      var test = this.logicalOR();
      var alternate;
      var consequent;
      if (this.expect("?")) {
        alternate = this.expression();
        if (this.consume(":")) {
          consequent = this.expression();
          return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent };
        }
      }
      return test;
    },

    logicalOR: function () {
      var left = this.logicalAND();
      while (this.expect("||")) {
        left = { type: AST.LogicalExpression, operator: "||", left: left, right: this.logicalAND() };
      }
      return left;
    },

    logicalAND: function () {
      var left = this.equality();
      while (this.expect("&&")) {
        left = { type: AST.LogicalExpression, operator: "&&", left: left, right: this.equality() };
      }
      return left;
    },

    equality: function () {
      var left = this.relational();
      var token;
      while ((token = this.expect("==", "!=", "===", "!=="))) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
      }
      return left;
    },

    relational: function () {
      var left = this.additive();
      var token;
      while ((token = this.expect("<", ">", "<=", ">="))) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
      }
      return left;
    },

    additive: function () {
      var left = this.multiplicative();
      var token;
      while ((token = this.expect("+", "-"))) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
      }
      return left;
    },

    multiplicative: function () {
      var left = this.unary();
      var token;
      while ((token = this.expect("*", "/", "%"))) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
      }
      return left;
    },

    unary: function () {
      var token;
      if ((token = this.expect("+", "-", "!"))) {
        return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
      } else {
        return this.primary();
      }
    },

    primary: function () {
      var primary;
      if (this.expect("(")) {
        primary = this.filterChain();
        this.consume(")");
      } else if (this.expect("[")) {
        primary = this.arrayDeclaration();
      } else if (this.expect("{")) {
        primary = this.object();
      } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
        primary = copy(this.selfReferential[this.consume().text]);
      } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
        primary = { type: AST.Literal, value: this.options.literals[this.consume().text] };
      } else if (this.peek().identifier) {
        primary = this.identifier();
      } else if (this.peek().constant) {
        primary = this.constant();
      } else {
        this.throwError("not a primary expression", this.peek());
      }

      var next;
      while ((next = this.expect("(", "[", "."))) {
        if (next.text === "(") {
          primary = { type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
          this.consume(")");
        } else if (next.text === "[") {
          primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
          this.consume("]");
        } else if (next.text === ".") {
          primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
        } else {
          this.throwError("IMPOSSIBLE");
        }
      }
      return primary;
    },

    filter: function (baseExpression) {
      var args = [baseExpression];
      var result = { type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true };

      while (this.expect(":")) {
        args.push(this.expression());
      }

      return result;
    },

    parseArguments: function () {
      var args = [];
      if (this.peekToken().text !== ")") {
        do {
          args.push(this.filterChain());
        } while (this.expect(","));
      }
      return args;
    },

    identifier: function () {
      var token = this.consume();
      if (!token.identifier) {
        this.throwError("is not a valid identifier", token);
      }
      return { type: AST.Identifier, name: token.text };
    },

    constant: function () {
    // TODO check that it is a constant
      return { type: AST.Literal, value: this.consume().value };
    },

    arrayDeclaration: function () {
      var elements = [];
      if (this.peekToken().text !== "]") {
        do {
          if (this.peek("]")) {
          // Support trailing commas per ES5.1.
            break;
          }
          elements.push(this.expression());
        } while (this.expect(","));
      }
      this.consume("]");

      return { type: AST.ArrayExpression, elements: elements };
    },

    object: function () {
      var properties = [], property;
      if (this.peekToken().text !== "}") {
        do {
          if (this.peek("}")) {
          // Support trailing commas per ES5.1.
            break;
          }
          property = { type: AST.Property, kind: "init" };
          if (this.peek().constant) {
            property.key = this.constant();
            property.computed = false;
            this.consume(":");
            property.value = this.expression();
          } else if (this.peek().identifier) {
            property.key = this.identifier();
            property.computed = false;
            if (this.peek(":")) {
              this.consume(":");
              property.value = this.expression();
            } else {
              property.value = property.key;
            }
          } else if (this.peek("[")) {
            this.consume("[");
            property.key = this.expression();
            this.consume("]");
            property.computed = true;
            this.consume(":");
            property.value = this.expression();
          } else {
            this.throwError("invalid key", this.peek());
          }
          properties.push(property);
        } while (this.expect(","));
      }
      this.consume("}");

      return { type: AST.ObjectExpression, properties: properties };
    },

    throwError: function (msg, token) {
      throw $parseMinErr("syntax",
        "Syntax Error: Token '{0}' {1} at column {2} of the expression [{3}] starting at [{4}].",
        token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
    },

    consume: function (e1) {
      if (this.tokens.length === 0) {
        throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);
      }

      var token = this.expect(e1);
      if (!token) {
        this.throwError("is unexpected, expecting [" + e1 + "]", this.peek());
      }
      return token;
    },

    peekToken: function () {
      if (this.tokens.length === 0) {
        throw $parseMinErr("ueoe", "Unexpected end of expression: {0}", this.text);
      }
      return this.tokens[0];
    },

    peek: function (e1, e2, e3, e4) {
      return this.peekAhead(0, e1, e2, e3, e4);
    },

    peekAhead: function (i, e1, e2, e3, e4) {
      if (this.tokens.length > i) {
        var token = this.tokens[i];
        var t = token.text;
        if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
          return token;
        }
      }
      return false;
    },

    expect: function (e1, e2, e3, e4) {
      var token = this.peek(e1, e2, e3, e4);
      if (token) {
        this.tokens.shift();
        return token;
      }
      return false;
    },

    selfReferential: {
      "this": { type: AST.ThisExpression },
      "$locals": { type: AST.LocalsExpression }
    }
  };

  function ifDefined(v, d) {
    return typeof v !== "undefined" ? v : d;
  }

  function plusFn(l, r) {
    if (typeof l === "undefined") return r;
    if (typeof r === "undefined") return l;
    return l + r;
  }

  function isStateless($filter, filterName) {
    var fn = $filter(filterName);
    return !fn.$stateful;
  }

  var PURITY_ABSOLUTE = 1;
  var PURITY_RELATIVE = 2;

  // Detect nodes which could depend on non-shallow state of objects
  function isPure(node, parentIsPure) {
    switch (node.type) {
    // Computed members might invoke a stateful toString()
      case AST.MemberExpression:
        if (node.computed) {
          return false;
        }
        break;

        // Unary always convert to primative
      case AST.UnaryExpression:
        return PURITY_ABSOLUTE;

        // The binary + operator can invoke a stateful toString().
      case AST.BinaryExpression:
        return node.operator !== "+" ? PURITY_ABSOLUTE : false;

        // Functions / filters probably read state from within objects
      case AST.CallExpression:
        return false;
    }

    return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
  }

  function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
    var allConstants;
    var argsToWatch;
    var isStatelessFilter;

    var astIsPure = ast.isPure = isPure(ast, parentIsPure);

    switch (ast.type) {
      case AST.Program:
        allConstants = true;
        forEach(ast.body, function (expr) {
          findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
          allConstants = allConstants && expr.expression.constant;
        });
        ast.constant = allConstants;
        break;
      case AST.Literal:
        ast.constant = true;
        ast.toWatch = [];
        break;
      case AST.UnaryExpression:
        findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
        ast.constant = ast.argument.constant;
        ast.toWatch = ast.argument.toWatch;
        break;
      case AST.BinaryExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
        break;
      case AST.LogicalExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.ConditionalExpression:
        findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
        ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.Identifier:
        ast.constant = false;
        ast.toWatch = [ast];
        break;
      case AST.MemberExpression:
        findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
        if (ast.computed) {
          findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
        }
        ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.CallExpression:
        isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
        allConstants = isStatelessFilter;
        argsToWatch = [];
        forEach(ast.arguments, function (expr) {
          findConstantAndWatchExpressions(expr, $filter, astIsPure);
          allConstants = allConstants && expr.constant;
          argsToWatch.push.apply(argsToWatch, expr.toWatch);
        });
        ast.constant = allConstants;
        ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
        break;
      case AST.AssignmentExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = [ast];
        break;
      case AST.ArrayExpression:
        allConstants = true;
        argsToWatch = [];
        forEach(ast.elements, function (expr) {
          findConstantAndWatchExpressions(expr, $filter, astIsPure);
          allConstants = allConstants && expr.constant;
          argsToWatch.push.apply(argsToWatch, expr.toWatch);
        });
        ast.constant = allConstants;
        ast.toWatch = argsToWatch;
        break;
      case AST.ObjectExpression:
        allConstants = true;
        argsToWatch = [];
        forEach(ast.properties, function (property) {
          findConstantAndWatchExpressions(property.value, $filter, astIsPure);
          allConstants = allConstants && property.value.constant;
          argsToWatch.push.apply(argsToWatch, property.value.toWatch);
          if (property.computed) {
            // `{[key]: value}` implicitly does `key.toString()` which may be non-pure
            findConstantAndWatchExpressions(property.key, $filter, /* parentIsPure=*/false);
            allConstants = allConstants && property.key.constant;
            argsToWatch.push.apply(argsToWatch, property.key.toWatch);
          }
        });
        ast.constant = allConstants;
        ast.toWatch = argsToWatch;
        break;
      case AST.ThisExpression:
        ast.constant = false;
        ast.toWatch = [];
        break;
      case AST.LocalsExpression:
        ast.constant = false;
        ast.toWatch = [];
        break;
    }
  }

  function getInputs(body) {
    if (body.length !== 1) return;
    var lastExpression = body[0].expression;
    var candidate = lastExpression.toWatch;
    if (candidate.length !== 1) return candidate;
    return candidate[0] !== lastExpression ? candidate : undefined;
  }

  function isAssignable(ast) {
    return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
  }

  function assignableAST(ast) {
    if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
      return { type: AST.AssignmentExpression, left: ast.body[0].expression, right: { type: AST.NGValueParameter }, operator: "=" };
    }
  }

  function isLiteral(ast) {
    return ast.body.length === 0 ||
      ast.body.length === 1 && (
        ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
  }

  function isConstant(ast) {
    return ast.constant;
  }

  function ASTCompiler($filter) {
    this.$filter = $filter;
  }

  ASTCompiler.prototype = {
    compile: function (ast) {
      var self = this;
      this.state = {
        nextId: 0,
        filters: {},
        fn: { vars: [], body: [], own: {} },
        assign: { vars: [], body: [], own: {} },
        inputs: []
      };
      findConstantAndWatchExpressions(ast, self.$filter);
      var extra = "";
      var assignable;
      this.stage = "assign";
      if ((assignable = assignableAST(ast))) {
        this.state.computing = "assign";
        var result = this.nextId();
        this.recurse(assignable, result);
        this.return_(result);
        extra = "fn.assign=" + this.generateFunction("assign", "s,v,l");
      }
      var toWatch = getInputs(ast.body);
      self.stage = "inputs";
      forEach(toWatch, function (watch, key) {
        var fnKey = "fn" + key;
        self.state[fnKey] = { vars: [], body: [], own: {} };
        self.state.computing = fnKey;
        var intoId = self.nextId();
        self.recurse(watch, intoId);
        self.return_(intoId);
        self.state.inputs.push({ name: fnKey, isPure: watch.isPure });
        watch.watchId = key;
      });
      this.state.computing = "fn";
      this.stage = "main";
      this.recurse(ast);
      var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      "\"" + this.USE + " " + this.STRICT + "\";\n" +
      this.filterPrefix() +
      "var fn=" + this.generateFunction("fn", "s,l,a,i") +
      extra +
      this.watchFns() +
      "return fn;";

      // eslint-disable-next-line no-new-func
      var fn = (new Function("$filter",
        "getStringValue",
        "ifDefined",
        "plus",
        fnString))(
        this.$filter,
        getStringValue,
        ifDefined,
        plusFn);
      this.state = this.stage = undefined;
      return fn;
    },

    USE: "use",

    STRICT: "strict",

    watchFns: function () {
      var result = [];
      var inputs = this.state.inputs;
      var self = this;
      forEach(inputs, function (input) {
        result.push("var " + input.name + "=" + self.generateFunction(input.name, "s"));
        if (input.isPure) {
          result.push(input.name, ".isPure=" + JSON.stringify(input.isPure) + ";");
        }
      });
      if (inputs.length) {
        result.push("fn.inputs=[" + inputs.map(function (i) { return i.name; }).join(",") + "];");
      }
      return result.join("");
    },

    generateFunction: function (name, params) {
      return "function(" + params + "){" +
        this.varsPrefix(name) +
        this.body(name) +
        "};";
    },

    filterPrefix: function () {
      var parts = [];
      var self = this;
      forEach(this.state.filters, function (id, filter) {
        parts.push(id + "=$filter(" + self.escape(filter) + ")");
      });
      if (parts.length) return "var " + parts.join(",") + ";";
      return "";
    },

    varsPrefix: function (section) {
      return this.state[section].vars.length ? "var " + this.state[section].vars.join(",") + ";" : "";
    },

    body: function (section) {
      return this.state[section].body.join("");
    },

    recurse: function (ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
      var left, right, self = this, args, expression, computed;
      recursionFn = recursionFn || noop;
      if (!skipWatchIdCheck && isDefined(ast.watchId)) {
        intoId = intoId || this.nextId();
        this.if_("i",
          this.lazyAssign(intoId, this.computedMember("i", ast.watchId)),
          this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
        );
        return;
      }
      switch (ast.type) {
        case AST.Program:
          forEach(ast.body, function (expression, pos) {
            self.recurse(expression.expression, undefined, undefined, function (expr) { right = expr; });
            if (pos !== ast.body.length - 1) {
              self.current().body.push(right, ";");
            } else {
              self.return_(right);
            }
          });
          break;
        case AST.Literal:
          expression = this.escape(ast.value);
          this.assign(intoId, expression);
          recursionFn(intoId || expression);
          break;
        case AST.UnaryExpression:
          this.recurse(ast.argument, undefined, undefined, function (expr) { right = expr; });
          expression = ast.operator + "(" + this.ifDefined(right, 0) + ")";
          this.assign(intoId, expression);
          recursionFn(expression);
          break;
        case AST.BinaryExpression:
          this.recurse(ast.left, undefined, undefined, function (expr) { left = expr; });
          this.recurse(ast.right, undefined, undefined, function (expr) { right = expr; });
          if (ast.operator === "+") {
            expression = this.plus(left, right);
          } else if (ast.operator === "-") {
            expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
          } else {
            expression = "(" + left + ")" + ast.operator + "(" + right + ")";
          }
          this.assign(intoId, expression);
          recursionFn(expression);
          break;
        case AST.LogicalExpression:
          intoId = intoId || this.nextId();
          self.recurse(ast.left, intoId);
          self.if_(ast.operator === "&&" ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
          recursionFn(intoId);
          break;
        case AST.ConditionalExpression:
          intoId = intoId || this.nextId();
          self.recurse(ast.test, intoId);
          self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
          recursionFn(intoId);
          break;
        case AST.Identifier:
          intoId = intoId || this.nextId();
          if (nameId) {
            nameId.context = self.stage === "inputs" ? "s" : this.assign(this.nextId(), this.getHasOwnProperty("l", ast.name) + "?l:s");
            nameId.computed = false;
            nameId.name = ast.name;
          }
          self.if_(self.stage === "inputs" || self.not(self.getHasOwnProperty("l", ast.name)),
            function () {
              self.if_(self.stage === "inputs" || "s", function () {
                if (create && create !== 1) {
                  self.if_(
                    self.isNull(self.nonComputedMember("s", ast.name)),
                    self.lazyAssign(self.nonComputedMember("s", ast.name), "{}"));
                }
                self.assign(intoId, self.nonComputedMember("s", ast.name));
              });
            }, intoId && self.lazyAssign(intoId, self.nonComputedMember("l", ast.name))
          );
          recursionFn(intoId);
          break;
        case AST.MemberExpression:
          left = nameId && (nameId.context = this.nextId()) || this.nextId();
          intoId = intoId || this.nextId();
          self.recurse(ast.object, left, undefined, function () {
            self.if_(self.notNull(left), function () {
              if (ast.computed) {
                right = self.nextId();
                self.recurse(ast.property, right);
                self.getStringValue(right);
                if (create && create !== 1) {
                  self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), "{}"));
                }
                expression = self.computedMember(left, right);
                self.assign(intoId, expression);
                if (nameId) {
                  nameId.computed = true;
                  nameId.name = right;
                }
              } else {
                if (create && create !== 1) {
                  self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), "{}"));
                }
                expression = self.nonComputedMember(left, ast.property.name);
                self.assign(intoId, expression);
                if (nameId) {
                  nameId.computed = false;
                  nameId.name = ast.property.name;
                }
              }
            }, function () {
              self.assign(intoId, "undefined");
            });
            recursionFn(intoId);
          }, !!create);
          break;
        case AST.CallExpression:
          intoId = intoId || this.nextId();
          if (ast.filter) {
            right = self.filter(ast.callee.name);
            args = [];
            forEach(ast.arguments, function (expr) {
              var argument = self.nextId();
              self.recurse(expr, argument);
              args.push(argument);
            });
            expression = right + "(" + args.join(",") + ")";
            self.assign(intoId, expression);
            recursionFn(intoId);
          } else {
            right = self.nextId();
            left = {};
            args = [];
            self.recurse(ast.callee, right, left, function () {
              self.if_(self.notNull(right), function () {
                forEach(ast.arguments, function (expr) {
                  self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function (argument) {
                    args.push(argument);
                  });
                });
                if (left.name) {
                  expression = self.member(left.context, left.name, left.computed) + "(" + args.join(",") + ")";
                } else {
                  expression = right + "(" + args.join(",") + ")";
                }
                self.assign(intoId, expression);
              }, function () {
                self.assign(intoId, "undefined");
              });
              recursionFn(intoId);
            });
          }
          break;
        case AST.AssignmentExpression:
          right = this.nextId();
          left = {};
          this.recurse(ast.left, undefined, left, function () {
            self.if_(self.notNull(left.context), function () {
              self.recurse(ast.right, right);
              expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
              self.assign(intoId, expression);
              recursionFn(intoId || expression);
            });
          }, 1);
          break;
        case AST.ArrayExpression:
          args = [];
          forEach(ast.elements, function (expr) {
            self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function (argument) {
              args.push(argument);
            });
          });
          expression = "[" + args.join(",") + "]";
          this.assign(intoId, expression);
          recursionFn(intoId || expression);
          break;
        case AST.ObjectExpression:
          args = [];
          computed = false;
          forEach(ast.properties, function (property) {
            if (property.computed) {
              computed = true;
            }
          });
          if (computed) {
            intoId = intoId || this.nextId();
            this.assign(intoId, "{}");
            forEach(ast.properties, function (property) {
              if (property.computed) {
                left = self.nextId();
                self.recurse(property.key, left);
              } else {
                left = property.key.type === AST.Identifier ?
                  property.key.name :
                  ("" + property.key.value);
              }
              right = self.nextId();
              self.recurse(property.value, right);
              self.assign(self.member(intoId, left, property.computed), right);
            });
          } else {
            forEach(ast.properties, function (property) {
              self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function (expr) {
                args.push(self.escape(
                  property.key.type === AST.Identifier ? property.key.name :
                    ("" + property.key.value)) +
                ":" + expr);
              });
            });
            expression = "{" + args.join(",") + "}";
            this.assign(intoId, expression);
          }
          recursionFn(intoId || expression);
          break;
        case AST.ThisExpression:
          this.assign(intoId, "s");
          recursionFn(intoId || "s");
          break;
        case AST.LocalsExpression:
          this.assign(intoId, "l");
          recursionFn(intoId || "l");
          break;
        case AST.NGValueParameter:
          this.assign(intoId, "v");
          recursionFn(intoId || "v");
          break;
      }
    },

    getHasOwnProperty: function (element, property) {
      var key = element + "." + property;
      var own = this.current().own;
      if (!own.hasOwnProperty(key)) {
        own[key] = this.nextId(false, element + "&&(" + this.escape(property) + " in " + element + ")");
      }
      return own[key];
    },

    assign: function (id, value) {
      if (!id) return;
      this.current().body.push(id, "=", value, ";");
      return id;
    },

    filter: function (filterName) {
      if (!this.state.filters.hasOwnProperty(filterName)) {
        this.state.filters[filterName] = this.nextId(true);
      }
      return this.state.filters[filterName];
    },

    ifDefined: function (id, defaultValue) {
      return "ifDefined(" + id + "," + this.escape(defaultValue) + ")";
    },

    plus: function (left, right) {
      return "plus(" + left + "," + right + ")";
    },

    return_: function (id) {
      this.current().body.push("return ", id, ";");
    },

    if_: function (test, alternate, consequent) {
      if (test === true) {
        alternate();
      } else {
        var body = this.current().body;
        body.push("if(", test, "){");
        alternate();
        body.push("}");
        if (consequent) {
          body.push("else{");
          consequent();
          body.push("}");
        }
      }
    },

    not: function (expression) {
      return "!(" + expression + ")";
    },

    isNull: function (expression) {
      return expression + "==null";
    },

    notNull: function (expression) {
      return expression + "!=null";
    },

    nonComputedMember: function (left, right) {
      var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
      var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
      if (SAFE_IDENTIFIER.test(right)) {
        return left + "." + right;
      } else {
        return left + "[\"" + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + "\"]";
      }
    },

    computedMember: function (left, right) {
      return left + "[" + right + "]";
    },

    member: function (left, right, computed) {
      if (computed) return this.computedMember(left, right);
      return this.nonComputedMember(left, right);
    },

    getStringValue: function (item) {
      this.assign(item, "getStringValue(" + item + ")");
    },

    lazyRecurse: function (ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
      var self = this;
      return function () {
        self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
      };
    },

    lazyAssign: function (id, value) {
      var self = this;
      return function () {
        self.assign(id, value);
      };
    },

    stringEscapeRegex: /[^ a-zA-Z0-9]/g,

    stringEscapeFn: function (c) {
      return "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
    },

    escape: function (value) {
      if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
      if (isNumber(value)) return value.toString();
      if (value === true) return "true";
      if (value === false) return "false";
      if (value === null) return "null";
      if (typeof value === "undefined") return "undefined";

      throw $parseMinErr("esc", "IMPOSSIBLE");
    },

    nextId: function (skip, init) {
      var id = "v" + (this.state.nextId++);
      if (!skip) {
        this.current().vars.push(id + (init ? "=" + init : ""));
      }
      return id;
    },

    current: function () {
      return this.state[this.state.computing];
    }
  };

  function ASTInterpreter($filter) {
    this.$filter = $filter;
  }

  ASTInterpreter.prototype = {
    compile: function (ast) {
      var self = this;
      findConstantAndWatchExpressions(ast, self.$filter);
      var assignable;
      var assign;
      if ((assignable = assignableAST(ast))) {
        assign = this.recurse(assignable);
      }
      var toWatch = getInputs(ast.body);
      var inputs;
      if (toWatch) {
        inputs = [];
        forEach(toWatch, function (watch, key) {
          var input = self.recurse(watch);
          input.isPure = watch.isPure;
          watch.input = input;
          inputs.push(input);
          watch.watchId = key;
        });
      }
      var expressions = [];
      forEach(ast.body, function (expression) {
        expressions.push(self.recurse(expression.expression));
      });
      var fn = ast.body.length === 0 ? noop :
        ast.body.length === 1 ? expressions[0] :
          function (scope, locals) {
            var lastValue;
            forEach(expressions, function (exp) {
              lastValue = exp(scope, locals);
            });
            return lastValue;
          };
      if (assign) {
        fn.assign = function (scope, value, locals) {
          return assign(scope, locals, value);
        };
      }
      if (inputs) {
        fn.inputs = inputs;
      }
      return fn;
    },

    recurse: function (ast, context, create) {
      var left, right, self = this, args;
      if (ast.input) {
        return this.inputs(ast.input, ast.watchId);
      }
      switch (ast.type) {
        case AST.Literal:
          return this.value(ast.value, context);
        case AST.UnaryExpression:
          right = this.recurse(ast.argument);
          return this["unary" + ast.operator](right, context);
        case AST.BinaryExpression:
          left = this.recurse(ast.left);
          right = this.recurse(ast.right);
          return this["binary" + ast.operator](left, right, context);
        case AST.LogicalExpression:
          left = this.recurse(ast.left);
          right = this.recurse(ast.right);
          return this["binary" + ast.operator](left, right, context);
        case AST.ConditionalExpression:
          return this["ternary?:"](
            this.recurse(ast.test),
            this.recurse(ast.alternate),
            this.recurse(ast.consequent),
            context
          );
        case AST.Identifier:
          return self.identifier(ast.name, context, create);
        case AST.MemberExpression:
          left = this.recurse(ast.object, false, !!create);
          if (!ast.computed) {
            right = ast.property.name;
          }
          if (ast.computed) right = this.recurse(ast.property);
          return ast.computed ?
            this.computedMember(left, right, context, create) :
            this.nonComputedMember(left, right, context, create);
        case AST.CallExpression:
          args = [];
          forEach(ast.arguments, function (expr) {
            args.push(self.recurse(expr));
          });
          if (ast.filter) right = this.$filter(ast.callee.name);
          if (!ast.filter) right = this.recurse(ast.callee, true);
          return ast.filter ?
            function (scope, locals, assign, inputs) {
              var values = [];
              for (var i = 0; i < args.length; ++i) {
                values.push(args[i](scope, locals, assign, inputs));
              }
              var value = right.apply(undefined, values, inputs);
              return context ? { context: undefined, name: undefined, value: value } : value;
            } :
            function (scope, locals, assign, inputs) {
              var rhs = right(scope, locals, assign, inputs);
              var value;
              if (rhs.value != null) {
                var values = [];
                for (var i = 0; i < args.length; ++i) {
                  values.push(args[i](scope, locals, assign, inputs));
                }
                value = rhs.value.apply(rhs.context, values);
              }
              return context ? { value: value } : value;
            };
        case AST.AssignmentExpression:
          left = this.recurse(ast.left, true, 1);
          right = this.recurse(ast.right);
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            lhs.context[lhs.name] = rhs;
            return context ? { value: rhs } : rhs;
          };
        case AST.ArrayExpression:
          args = [];
          forEach(ast.elements, function (expr) {
            args.push(self.recurse(expr));
          });
          return function (scope, locals, assign, inputs) {
            var value = [];
            for (var i = 0; i < args.length; ++i) {
              value.push(args[i](scope, locals, assign, inputs));
            }
            return context ? { value: value } : value;
          };
        case AST.ObjectExpression:
          args = [];
          forEach(ast.properties, function (property) {
            if (property.computed) {
              args.push({ key: self.recurse(property.key),
                computed: true,
                value: self.recurse(property.value)
              });
            } else {
              args.push({ key: property.key.type === AST.Identifier ?
                property.key.name :
                ("" + property.key.value),
              computed: false,
              value: self.recurse(property.value)
              });
            }
          });
          return function (scope, locals, assign, inputs) {
            var value = {};
            for (var i = 0; i < args.length; ++i) {
              if (args[i].computed) {
                value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
              } else {
                value[args[i].key] = args[i].value(scope, locals, assign, inputs);
              }
            }
            return context ? { value: value } : value;
          };
        case AST.ThisExpression:
          return function (scope) {
            return context ? { value: scope } : scope;
          };
        case AST.LocalsExpression:
          return function (scope, locals) {
            return context ? { value: locals } : locals;
          };
        case AST.NGValueParameter:
          return function (scope, locals, assign) {
            return context ? { value: assign } : assign;
          };
      }
    },

    "unary+": function (argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = argument(scope, locals, assign, inputs);
        if (isDefined(arg)) {
          arg = +arg;
        } else {
          arg = 0;
        }
        return context ? { value: arg } : arg;
      };
    },
    "unary-": function (argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = argument(scope, locals, assign, inputs);
        if (isDefined(arg)) {
          arg = -arg;
        } else {
          arg = -0;
        }
        return context ? { value: arg } : arg;
      };
    },
    "unary!": function (argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = !argument(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary+": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        var arg = plusFn(lhs, rhs);
        return context ? { value: arg } : arg;
      };
    },
    "binary-": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
        return context ? { value: arg } : arg;
      };
    },
    "binary*": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary/": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary%": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary===": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary!==": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary==": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
        var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary!=": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
        var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary<": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary>": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary<=": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary>=": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary&&": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "binary||": function (left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    "ternary?:": function (test, alternate, consequent, context) {
      return function (scope, locals, assign, inputs) {
        var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    value: function (value, context) {
      return function () { return context ? { context: undefined, name: undefined, value: value } : value; };
    },
    identifier: function (name, context, create) {
      return function (scope, locals, assign, inputs) {
        var base = locals && (name in locals) ? locals : scope;
        if (create && create !== 1 && base && base[name] == null) {
          base[name] = {};
        }
        var value = base ? base[name] : undefined;
        if (context) {
          return { context: base, name: name, value: value };
        } else {
          return value;
        }
      };
    },
    computedMember: function (left, right, context, create) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs;
        var value;
        if (lhs != null) {
          rhs = right(scope, locals, assign, inputs);
          rhs = getStringValue(rhs);
          if (create && create !== 1) {
            if (lhs && !(lhs[rhs])) {
              lhs[rhs] = {};
            }
          }
          value = lhs[rhs];
        }
        if (context) {
          return { context: lhs, name: rhs, value: value };
        } else {
          return value;
        }
      };
    },
    nonComputedMember: function (left, right, context, create) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        if (create && create !== 1) {
          if (lhs && lhs[right] == null) {
            lhs[right] = {};
          }
        }
        var value = lhs != null ? lhs[right] : undefined;
        if (context) {
          return { context: lhs, name: right, value: value };
        } else {
          return value;
        }
      };
    },
    inputs: function (input, watchId) {
      return function (scope, value, locals, inputs) {
        if (inputs) return inputs[watchId];
        return input(scope, value, locals);
      };
    }
  };

  /**
 * @constructor
 */
  function Parser(lexer, $filter, options) {
    this.ast = new AST(lexer, options);
    this.astCompiler = options.csp ? new ASTInterpreter($filter) :
      new ASTCompiler($filter);
  }

  Parser.prototype = {
    constructor: Parser,

    parse: function (text) {
      var ast = this.getAst(text);
      var fn = this.astCompiler.compile(ast.ast);
      fn.literal = isLiteral(ast.ast);
      fn.constant = isConstant(ast.ast);
      fn.oneTime = ast.oneTime;
      return fn;
    },

    getAst: function (exp) {
      var oneTime = false;
      exp = exp.trim();

      if (exp.charAt(0) === ":" && exp.charAt(1) === ":") {
        oneTime = true;
        exp = exp.substring(2);
      }
      return {
        ast: this.ast.ast(exp),
        oneTime: oneTime
      };
    }
  };

  function getValueOf(value) {
    return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
  }

  // /////////////////////////////////

  /**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */

  /**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
  function $ParseProvider() {
    var cache = createMap();
    var literals = {
      "true": true,
      "false": false,
      "null": null,
      "undefined": undefined
    };
    var identStart, identContinue;

    /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
    this.addLiteral = function (literalName, literalValue) {
      literals[literalName] = literalValue;
    };

    /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
    this.setIdentifierFns = function (identifierStart, identifierContinue) {
      identStart = identifierStart;
      identContinue = identifierContinue;
      return this;
    };

    this.$get = ["$filter", function ($filter) {
      var noUnsafeEval = csp().noUnsafeEval;
      var $parseOptions = {
        csp: noUnsafeEval,
        literals: copy(literals),
        isIdentifierStart: isFunction(identStart) && identStart,
        isIdentifierContinue: isFunction(identContinue) && identContinue
      };
      $parse.$$getAst = $$getAst;
      return $parse;

      function $parse(exp, interceptorFn) {
        var parsedExpression, cacheKey;

        switch (typeof exp) {
          case "string":
            exp = exp.trim();
            cacheKey = exp;

            parsedExpression = cache[cacheKey];

            if (!parsedExpression) {
              var lexer = new Lexer($parseOptions);
              var parser = new Parser(lexer, $filter, $parseOptions);
              parsedExpression = parser.parse(exp);
              if (parsedExpression.constant) {
                parsedExpression.$$watchDelegate = constantWatchDelegate;
              } else if (parsedExpression.oneTime) {
                parsedExpression.$$watchDelegate = parsedExpression.literal ?
                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
              } else if (parsedExpression.inputs) {
                parsedExpression.$$watchDelegate = inputsWatchDelegate;
              }
              cache[cacheKey] = parsedExpression;
            }
            return addInterceptor(parsedExpression, interceptorFn);

          case "function":
            return addInterceptor(exp, interceptorFn);

          default:
            return addInterceptor(noop, interceptorFn);
        }
      }

      function $$getAst(exp) {
        var lexer = new Lexer($parseOptions);
        var parser = new Parser(lexer, $filter, $parseOptions);
        return parser.getAst(exp).ast;
      }

      function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

        if (newValue == null || oldValueOfValue == null) { // null/undefined
          return newValue === oldValueOfValue;
        }

        if (typeof newValue === "object") {

          // attempt to convert the value to a primitive type
          // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
          //             be cheaply dirty-checked
          newValue = getValueOf(newValue);

          if (typeof newValue === "object" && !compareObjectIdentity) {
          // objects/arrays are not supported - deep-watching them would be too expensive
            return false;
          }

        // fall-through to the primitive equality check
        }

        // Primitive or NaN
        // eslint-disable-next-line no-self-compare
        return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
      }

      function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
        var inputExpressions = parsedExpression.inputs;
        var lastResult;

        if (inputExpressions.length === 1) {
          var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
          inputExpressions = inputExpressions[0];
          return scope.$watch(function expressionInputWatch(scope) {
            var newInputValue = inputExpressions(scope);
            if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
              lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
              oldInputValueOf = newInputValue && getValueOf(newInputValue);
            }
            return lastResult;
          }, listener, objectEquality, prettyPrintExpression);
        }

        var oldInputValueOfValues = [];
        var oldInputValues = [];
        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
          oldInputValues[i] = null;
        }

        return scope.$watch(function expressionInputsWatch(scope) {
          var changed = false;

          for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
            var newInputValue = inputExpressions[i](scope);
            if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
              oldInputValues[i] = newInputValue;
              oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
            }
          }

          if (changed) {
            lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
          }

          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
        var unwatch, lastValue;
        if (parsedExpression.inputs) {
          unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
        } else {
          unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
        }
        return unwatch;

        function oneTimeWatch(scope) {
          return parsedExpression(scope);
        }
        function oneTimeListener(value, old, scope) {
          lastValue = value;
          if (isFunction(listener)) {
            listener(value, old, scope);
          }
          if (isDefined(value)) {
            scope.$$postDigest(function () {
              if (isDefined(lastValue)) {
                unwatch();
              }
            });
          }
        }
      }

      function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
        var unwatch, lastValue;
        unwatch = scope.$watch(function oneTimeWatch(scope) {
          return parsedExpression(scope);
        }, function oneTimeListener(value, old, scope) {
          lastValue = value;
          if (isFunction(listener)) {
            listener(value, old, scope);
          }
          if (isAllDefined(value)) {
            scope.$$postDigest(function () {
              if (isAllDefined(lastValue)) unwatch();
            });
          }
        }, objectEquality);

        return unwatch;

        function isAllDefined(value) {
          var allDefined = true;
          forEach(value, function (val) {
            if (!isDefined(val)) allDefined = false;
          });
          return allDefined;
        }
      }

      function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
        var unwatch = scope.$watch(function constantWatch(scope) {
          unwatch();
          return parsedExpression(scope);
        }, listener, objectEquality);
        return unwatch;
      }

      function addInterceptor(parsedExpression, interceptorFn) {
        if (!interceptorFn) return parsedExpression;
        var watchDelegate = parsedExpression.$$watchDelegate;
        var useInputs = false;

        var regularWatch =
          watchDelegate !== oneTimeLiteralWatchDelegate &&
          watchDelegate !== oneTimeWatchDelegate;

        var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
          var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
          return interceptorFn(value, scope, locals);
        } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
          var value = parsedExpression(scope, locals, assign, inputs);
          var result = interceptorFn(value, scope, locals);
          // we only return the interceptor's result if the
          // initial value is defined (for bind-once)
          return isDefined(value) ? result : value;
        };

        // Propagate $$watchDelegates other then inputsWatchDelegate
        useInputs = !parsedExpression.inputs;
        if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
          fn.$$watchDelegate = watchDelegate;
          fn.inputs = parsedExpression.inputs;
        } else if (!interceptorFn.$stateful) {
        // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
          fn.$$watchDelegate = inputsWatchDelegate;
          fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
        }

        if (fn.inputs) {
          fn.inputs = fn.inputs.map(function (e) {
            // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
            // potentially non-pure interceptor function.
            if (e.isPure === PURITY_RELATIVE) {
              return function depurifier(s) { return e(s); };
            }
            return e;
          });
        }

        return fn;
      }
    }];
  }

  /**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
  /**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
  function $QProvider() {
    var errorOnUnhandledRejections = true;
    this.$get = ["$rootScope", "$exceptionHandler", function ($rootScope, $exceptionHandler) {
      return qFactory(function (callback) {
        $rootScope.$evalAsync(callback);
      }, $exceptionHandler, errorOnUnhandledRejections);
    }];

    /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
    this.errorOnUnhandledRejections = function (value) {
      if (isDefined(value)) {
        errorOnUnhandledRejections = value;
        return this;
      } else {
        return errorOnUnhandledRejections;
      }
    };
  }

  /** @this */
  function $$QProvider() {
    var errorOnUnhandledRejections = true;
    this.$get = ["$browser", "$exceptionHandler", function ($browser, $exceptionHandler) {
      return qFactory(function (callback) {
        $browser.defer(callback);
      }, $exceptionHandler, errorOnUnhandledRejections);
    }];

    this.errorOnUnhandledRejections = function (value) {
      if (isDefined(value)) {
        errorOnUnhandledRejections = value;
        return this;
      } else {
        return errorOnUnhandledRejections;
      }
    };
  }

  /**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
  function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
    var $qMinErr = minErr("$q", TypeError);
    var queueSize = 0;
    var checkQueue = [];

    /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
    function defer() {
      return new Deferred();
    }

    function Deferred() {
      var promise = this.promise = new Promise();
      // Non prototype methods necessary to support unbound execution :/
      this.resolve = function (val) { resolvePromise(promise, val); };
      this.reject = function (reason) { rejectPromise(promise, reason); };
      this.notify = function (progress) { notifyPromise(promise, progress); };
    }

    function Promise() {
      this.$$state = { status: 0 };
    }

    extend(Promise.prototype, {
      then: function (onFulfilled, onRejected, progressBack) {
        if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
          return this;
        }
        var result = new Promise();

        this.$$state.pending = this.$$state.pending || [];
        this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
        if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

        return result;
      },

      "catch": function (callback) {
        return this.then(null, callback);
      },

      "finally": function (callback, progressBack) {
        return this.then(function (value) {
          return handleCallback(value, resolve, callback);
        }, function (error) {
          return handleCallback(error, reject, callback);
        }, progressBack);
      }
    });

    function processQueue(state) {
      var fn, promise, pending;

      pending = state.pending;
      state.processScheduled = false;
      state.pending = undefined;
      try {
        for (var i = 0, ii = pending.length; i < ii; ++i) {
          markQStateExceptionHandled(state);
          promise = pending[i][0];
          fn = pending[i][state.status];
          try {
            if (isFunction(fn)) {
              resolvePromise(promise, fn(state.value));
            } else if (state.status === 1) {
              resolvePromise(promise, state.value);
            } else {
              rejectPromise(promise, state.value);
            }
          } catch (e) {
            rejectPromise(promise, e);
            // This error is explicitly marked for being passed to the $exceptionHandler
            if (e && e.$$passToExceptionHandler === true) {
              exceptionHandler(e);
            }
          }
        }
      } finally {
        --queueSize;
        if (errorOnUnhandledRejections && queueSize === 0) {
          nextTick(processChecks);
        }
      }
    }

    function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
      while (!queueSize && checkQueue.length) {
        var toCheck = checkQueue.shift();
        if (!isStateExceptionHandled(toCheck)) {
          markQStateExceptionHandled(toCheck);
          var errorMessage = "Possibly unhandled rejection: " + toDebugString(toCheck.value);
          if (isError(toCheck.value)) {
            exceptionHandler(toCheck.value, errorMessage);
          } else {
            exceptionHandler(errorMessage);
          }
        }
      }
    }

    function scheduleProcessQueue(state) {
      if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
        if (queueSize === 0 && checkQueue.length === 0) {
          nextTick(processChecks);
        }
        checkQueue.push(state);
      }
      if (state.processScheduled || !state.pending) return;
      state.processScheduled = true;
      ++queueSize;
      nextTick(function () { processQueue(state); });
    }

    function resolvePromise(promise, val) {
      if (promise.$$state.status) return;
      if (val === promise) {
        $$reject(promise, $qMinErr(
          "qcycle",
          "Expected promise to be resolved with value other than itself '{0}'",
          val));
      } else {
        $$resolve(promise, val);
      }

    }

    function $$resolve(promise, val) {
      var then;
      var done = false;
      try {
        if (isObject(val) || isFunction(val)) then = val.then;
        if (isFunction(then)) {
          promise.$$state.status = -1;
          then.call(val, doResolve, doReject, doNotify);
        } else {
          promise.$$state.value = val;
          promise.$$state.status = 1;
          scheduleProcessQueue(promise.$$state);
        }
      } catch (e) {
        doReject(e);
      }

      function doResolve(val) {
        if (done) return;
        done = true;
        $$resolve(promise, val);
      }
      function doReject(val) {
        if (done) return;
        done = true;
        $$reject(promise, val);
      }
      function doNotify(progress) {
        notifyPromise(promise, progress);
      }
    }

    function rejectPromise(promise, reason) {
      if (promise.$$state.status) return;
      $$reject(promise, reason);
    }

    function $$reject(promise, reason) {
      promise.$$state.value = reason;
      promise.$$state.status = 2;
      scheduleProcessQueue(promise.$$state);
    }

    function notifyPromise(promise, progress) {
      var callbacks = promise.$$state.pending;

      if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
        nextTick(function () {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
            } catch (e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }

    /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
    function reject(reason) {
      var result = new Promise();
      rejectPromise(result, reason);
      return result;
    }

    function handleCallback(value, resolver, callback) {
      var callbackOutput = null;
      try {
        if (isFunction(callback)) callbackOutput = callback();
      } catch (e) {
        return reject(e);
      }
      if (isPromiseLike(callbackOutput)) {
        return callbackOutput.then(function () {
          return resolver(value);
        }, reject);
      } else {
        return resolver(value);
      }
    }

    /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */

    function when(value, callback, errback, progressBack) {
      var result = new Promise();
      resolvePromise(result, value);
      return result.then(callback, errback, progressBack);
    }

    /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
    var resolve = when;

    /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

    function all(promises) {
      var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

      forEach(promises, function (promise, key) {
        counter++;
        when(promise).then(function (value) {
          results[key] = value;
          if (!(--counter)) resolvePromise(result, results);
        }, function (reason) {
          rejectPromise(result, reason);
        });
      });

      if (counter === 0) {
        resolvePromise(result, results);
      }

      return result;
    }

    /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

    function race(promises) {
      var deferred = defer();

      forEach(promises, function (promise) {
        when(promise).then(deferred.resolve, deferred.reject);
      });

      return deferred.promise;
    }

    function $Q(resolver) {
      if (!isFunction(resolver)) {
        throw $qMinErr("norslvr", "Expected resolverFn, got '{0}'", resolver);
      }

      var promise = new Promise();

      function resolveFn(value) {
        resolvePromise(promise, value);
      }

      function rejectFn(reason) {
        rejectPromise(promise, reason);
      }

      resolver(resolveFn, rejectFn);

      return promise;
    }

    // Let's make the instanceof operator work for promises, so that
    // `new $q(fn) instanceof $q` would evaluate to true.
    $Q.prototype = Promise.prototype;

    $Q.defer = defer;
    $Q.reject = reject;
    $Q.when = when;
    $Q.resolve = resolve;
    $Q.all = all;
    $Q.race = race;

    return $Q;
  }

  function isStateExceptionHandled(state) {
    return !!state.pur;
  }
  function markQStateExceptionHandled(state) {
    state.pur = true;
  }
  function markQExceptionHandled(q) {
    markQStateExceptionHandled(q.$$state);
  }

  /** @this */
  function $$RAFProvider() { // rAF
    this.$get = ["$window", "$timeout", function ($window, $timeout) {
      var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

      var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

      var rafSupported = !!requestAnimationFrame;
      var raf = rafSupported
        ? function (fn) {
          var id = requestAnimationFrame(fn);
          return function () {
            cancelAnimationFrame(id);
          };
        }
        : function (fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function () {
            $timeout.cancel(timer);
          };
        };

      raf.supported = rafSupported;

      return raf;
    }];
  }

  /**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */

  /**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

  /**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */

  /**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
  function $RootScopeProvider() {
    var TTL = 10;
    var $rootScopeMinErr = minErr("$rootScope");
    var lastDirtyWatch = null;
    var applyAsyncId = null;

    this.digestTtl = function (value) {
      if (arguments.length) {
        TTL = value;
      }
      return TTL;
    };

    function createChildScopeClass(parent) {
      function ChildScope() {
        this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
        this.$$listeners = {};
        this.$$listenerCount = {};
        this.$$watchersCount = 0;
        this.$id = nextUid();
        this.$$ChildScope = null;
        this.$$suspended = false;
      }
      ChildScope.prototype = parent;
      return ChildScope;
    }

    this.$get = ["$exceptionHandler", "$parse", "$browser",
      function ($exceptionHandler, $parse, $browser) {

        function destroyChildScope($event) {
          $event.currentScope.$$destroyed = true;
        }

        function cleanUpScope($scope) {

          // Support: IE 9 only
          if (msie === 9) {
            // There is a memory leak in IE9 if all child scopes are not disconnected
            // completely when a scope is destroyed. So this code will recurse up through
            // all this scopes children
            //
            // See issue https://github.com/angular/angular.js/issues/10706
            if ($scope.$$childHead) {
              cleanUpScope($scope.$$childHead);
            }
            if ($scope.$$nextSibling) {
              cleanUpScope($scope.$$nextSibling);
            }
          }

          // The code below works around IE9 and V8's memory leaks
          //
          // See:
          // - https://code.google.com/p/v8/issues/detail?id=2073#c26
          // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
          // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

          $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
        }

        /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
        function Scope() {
          this.$id = nextUid();
          this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
          this.$root = this;
          this.$$destroyed = false;
          this.$$suspended = false;
          this.$$listeners = {};
          this.$$listenerCount = {};
          this.$$watchersCount = 0;
          this.$$isolateBindings = null;
        }

        /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

        /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

        /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

        Scope.prototype = {
          constructor: Scope,
          /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
          $new: function (isolate, parent) {
            var child;

            parent = parent || this;

            if (isolate) {
              child = new Scope();
              child.$root = this.$root;
            } else {
              // Only create a child scope class if somebody asks for one,
              // but cache it to allow the VM to optimize lookups.
              if (!this.$$ChildScope) {
                this.$$ChildScope = createChildScopeClass(this);
              }
              child = new this.$$ChildScope();
            }
            child.$parent = parent;
            child.$$prevSibling = parent.$$childTail;
            if (parent.$$childHead) {
              parent.$$childTail.$$nextSibling = child;
              parent.$$childTail = child;
            } else {
              parent.$$childHead = parent.$$childTail = child;
            }

            // When the new scope is not isolated or we inherit from `this`, and
            // the parent scope is destroyed, the property `$$destroyed` is inherited
            // prototypically. In all other cases, this property needs to be set
            // when the parent scope is destroyed.
            // The listener needs to be added after the parent is set
            if (isolate || parent !== this) child.$on("$destroy", destroyChildScope);

            return child;
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are
       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);

           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
          $watch: function (watchExp, listener, objectEquality, prettyPrintExpression) {
            var get = $parse(watchExp);
            var fn = isFunction(listener) ? listener : noop;

            if (get.$$watchDelegate) {
              return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
            }
            var scope = this,
              array = scope.$$watchers,
              watcher = {
                fn: fn,
                last: initWatchVal,
                get: get,
                exp: prettyPrintExpression || watchExp,
                eq: !!objectEquality
              };

            lastDirtyWatch = null;

            if (!array) {
              array = scope.$$watchers = [];
              array.$$digestWatchIndex = -1;
            }
            // we use unshift since we use a while loop in $digest for speed.
            // the while loop reads in reverse order.
            array.unshift(watcher);
            array.$$digestWatchIndex++;
            incrementWatchersCount(this, 1);

            return function deregisterWatch() {
              var index = arrayRemove(array, watcher);
              if (index >= 0) {
                incrementWatchersCount(scope, -1);
                if (index < array.$$digestWatchIndex) {
                  array.$$digestWatchIndex--;
                }
              }
              lastDirtyWatch = null;
            };
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * `$watchGroup` is more performant than watching each expression individually, and should be
       * used when the listener does not need to know which expression has changed.
       * If the listener needs to know which expression has changed,
       * {@link ng.$rootScope.Scope#$watch $watch()} or
       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`.
       *
       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
       *    expression, and not the difference of the values between each call of the listener.
       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
       *    which expression has changed / remained stable:
       *
       *    ```js
       *
       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
       *      console.log(newValues, oldValues);
       *    });
       *
       *    // newValues, oldValues initially
       *    // [undefined, undefined], [undefined, undefined]
       *
       *    $scope.v1 = 'a';
       *    $scope.v2 = 'a';
       *
       *    // ['a', 'a'], [undefined, undefined]
       *
       *    $scope.v2 = 'b'
       *
       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
       *    // ['a', 'b'], [undefined, 'a']
       *
       *    ```
       *
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
          $watchGroup: function (watchExpressions, listener) {
            var oldValues = new Array(watchExpressions.length);
            var newValues = new Array(watchExpressions.length);
            var deregisterFns = [];
            var self = this;
            var changeReactionScheduled = false;
            var firstRun = true;

            if (!watchExpressions.length) {
              // No expressions means we call the listener ASAP
              var shouldCall = true;
              self.$evalAsync(function () {
                if (shouldCall) listener(newValues, newValues, self);
              });
              return function deregisterWatchGroup() {
                shouldCall = false;
              };
            }

            if (watchExpressions.length === 1) {
              // Special case size of one
              return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
                newValues[0] = value;
                oldValues[0] = oldValue;
                listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
              });
            }

            forEach(watchExpressions, function (expr, i) {
              var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
                newValues[i] = value;
                oldValues[i] = oldValue;
                if (!changeReactionScheduled) {
                  changeReactionScheduled = true;
                  self.$evalAsync(watchGroupAction);
                }
              });
              deregisterFns.push(unwatchFn);
            });

            function watchGroupAction() {
              changeReactionScheduled = false;

              if (firstRun) {
                firstRun = false;
                listener(newValues, newValues, self);
              } else {
                listener(newValues, oldValues, self);
              }
            }

            return function deregisterWatchGroup() {
              while (deregisterFns.length) {
                deregisterFns.shift()();
              }
            };
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
          $watchCollection: function (obj, listener) {
            $watchCollectionInterceptor.$stateful = true;

            var self = this;
            // the current value, updated on each dirty-check run
            var newValue;
            // a shallow copy of the newValue from the last dirty-check run,
            // updated to match newValue during dirty-check run
            var oldValue;
            // a shallow copy of the newValue from when the last change happened
            var veryOldValue;
            // only track veryOldValue if the listener is asking for it
            var trackVeryOldValue = (listener.length > 1);
            var changeDetected = 0;
            var changeDetector = $parse(obj, $watchCollectionInterceptor);
            var internalArray = [];
            var internalObject = {};
            var initRun = true;
            var oldLength = 0;

            function $watchCollectionInterceptor(_value) {
              newValue = _value;
              var newLength, key, bothNaN, newItem, oldItem;

              // If the new value is undefined, then return undefined as the watch may be a one-time watch
              if (isUndefined(newValue)) return;

              if (!isObject(newValue)) { // if primitive
                if (oldValue !== newValue) {
                  oldValue = newValue;
                  changeDetected++;
                }
              } else if (isArrayLike(newValue)) {
                if (oldValue !== internalArray) {
                  // we are transitioning from something which was not an array into array.
                  oldValue = internalArray;
                  oldLength = oldValue.length = 0;
                  changeDetected++;
                }

                newLength = newValue.length;

                if (oldLength !== newLength) {
                  // if lengths do not match we need to trigger change notification
                  changeDetected++;
                  oldValue.length = oldLength = newLength;
                }
                // copy the items to oldValue and look for changes.
                for (var i = 0; i < newLength; i++) {
                  oldItem = oldValue[i];
                  newItem = newValue[i];

                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[i] = newItem;
                  }
                }
              } else {
                if (oldValue !== internalObject) {
                  // we are transitioning from something which was not an object into object.
                  oldValue = internalObject = {};
                  oldLength = 0;
                  changeDetected++;
                }
                // copy the items to oldValue and look for changes.
                newLength = 0;
                for (key in newValue) {
                  if (hasOwnProperty.call(newValue, key)) {
                    newLength++;
                    newItem = newValue[key];
                    oldItem = oldValue[key];

                    if (key in oldValue) {
                      // eslint-disable-next-line no-self-compare
                      bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                      if (!bothNaN && (oldItem !== newItem)) {
                        changeDetected++;
                        oldValue[key] = newItem;
                      }
                    } else {
                      oldLength++;
                      oldValue[key] = newItem;
                      changeDetected++;
                    }
                  }
                }
                if (oldLength > newLength) {
                  // we used to have more keys, need to find them and destroy them.
                  changeDetected++;
                  for (key in oldValue) {
                    if (!hasOwnProperty.call(newValue, key)) {
                      oldLength--;
                      delete oldValue[key];
                    }
                  }
                }
              }
              return changeDetected;
            }

            function $watchCollectionAction() {
              if (initRun) {
                initRun = false;
                listener(newValue, newValue, self);
              } else {
                listener(newValue, veryOldValue, self);
              }

              // make a copy for the next time a collection is changed
              if (trackVeryOldValue) {
                if (!isObject(newValue)) {
                  // primitive
                  veryOldValue = newValue;
                } else if (isArrayLike(newValue)) {
                  veryOldValue = new Array(newValue.length);
                  for (var i = 0; i < newValue.length; i++) {
                    veryOldValue[i] = newValue[i];
                  }
                } else { // if object
                  veryOldValue = {};
                  for (var key in newValue) {
                    if (hasOwnProperty.call(newValue, key)) {
                      veryOldValue[key] = newValue[key];
                    }
                  }
                }
              }
            }

            return this.$watch(changeDetector, $watchCollectionAction);
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
          $digest: function () {
            var watch, value, last, fn, get,
              watchers,
              dirty, ttl = TTL,
              next, current, target = this,
              watchLog = [],
              logIdx, asyncTask;

            beginPhase("$digest");
            // Check for changes to browser url that happened in sync before the call to $digest
            $browser.$$checkUrlChange();

            if (this === $rootScope && applyAsyncId !== null) {
              // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
              // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
              $browser.defer.cancel(applyAsyncId);
              flushApplyAsync();
            }

            lastDirtyWatch = null;

            do { // "while dirty" loop
              dirty = false;
              current = target;

              // It's safe for asyncQueuePosition to be a local variable here because this loop can't
              // be reentered recursively. Calling $digest from a function passed to $evalAsync would
              // lead to a '$digest already in progress' error.
              for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
                try {
                  asyncTask = asyncQueue[asyncQueuePosition];
                  fn = asyncTask.fn;
                  fn(asyncTask.scope, asyncTask.locals);
                } catch (e) {
                  $exceptionHandler(e);
                }
                lastDirtyWatch = null;
              }
              asyncQueue.length = 0;

              traverseScopesLoop:
              do { // "traverse the scopes" loop
                if ((watchers = !current.$$suspended && current.$$watchers)) {
                  // process our watches
                  watchers.$$digestWatchIndex = watchers.length;
                  while (watchers.$$digestWatchIndex--) {
                    try {
                      watch = watchers[watchers.$$digestWatchIndex];
                      // Most common watches are on primitives, in which case we can short
                      // circuit it with === operator, only when === fails do we use .equals
                      if (watch) {
                        get = watch.get;
                        if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                          ? equals(value, last)
                          : (isNumberNaN(value) && isNumberNaN(last)))) {
                          dirty = true;
                          lastDirtyWatch = watch;
                          watch.last = watch.eq ? copy(value, null) : value;
                          fn = watch.fn;
                          fn(value, ((last === initWatchVal) ? value : last), current);
                          if (ttl < 5) {
                            logIdx = 4 - ttl;
                            if (!watchLog[logIdx]) watchLog[logIdx] = [];
                            watchLog[logIdx].push({
                              msg: isFunction(watch.exp) ? "fn: " + (watch.exp.name || watch.exp.toString()) : watch.exp,
                              newVal: value,
                              oldVal: last
                            });
                          }
                        } else if (watch === lastDirtyWatch) {
                          // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                          // have already been tested.
                          dirty = false;
                          break traverseScopesLoop;
                        }
                      }
                    } catch (e) {
                      $exceptionHandler(e);
                    }
                  }
                }

                // Insanity Warning: scope depth-first traversal
                // yes, this code is a bit crazy, but it works and we have tests to prove it!
                // this piece should be kept in sync with the traversal in $broadcast
                // (though it differs due to having the extra check for $$suspended and does not
                // check $$listenerCount)
                if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
                  while (current !== target && !(next = current.$$nextSibling)) {
                    current = current.$parent;
                  }
                }
              } while ((current = next));

              // `break traverseScopesLoop;` takes us to here

              if ((dirty || asyncQueue.length) && !(ttl--)) {
                clearPhase();
                throw $rootScopeMinErr("infdig",
                  "{0} $digest() iterations reached. Aborting!\n" +
                "Watchers fired in the last 5 iterations: {1}",
                  TTL, watchLog);
              }

            } while (dirty || asyncQueue.length);

            clearPhase();

            // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
            while (postDigestQueuePosition < postDigestQueue.length) {
              try {
                postDigestQueue[postDigestQueuePosition++]();
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            postDigestQueue.length = postDigestQueuePosition = 0;

            // Check for changes to browser url that happened during the $digest
            // (for which no event is fired; e.g. via `history.pushState()`)
            $browser.$$checkUrlChange();
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */
          $suspend: function () {
            this.$$suspended = true;
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */
          $isSuspended: function () {
            return this.$$suspended;
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */
          $resume: function () {
            this.$$suspended = false;
          },

          /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
          $destroy: function () {
            // We can't destroy a scope that has been already destroyed.
            if (this.$$destroyed) return;
            var parent = this.$parent;

            this.$broadcast("$destroy");
            this.$$destroyed = true;

            if (this === $rootScope) {
              // Remove handlers attached to window when $rootScope is removed
              $browser.$$applicationDestroyed();
            }

            incrementWatchersCount(this, -this.$$watchersCount);
            for (var eventName in this.$$listenerCount) {
              decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
            }

            // sever all the references to parent scopes (after this cleanup, the current scope should
            // not be retained by any of our references and should be eligible for garbage collection)
            if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
            if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
            if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
            if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

            // Disable listeners, watchers and apply/digest methods
            this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
            this.$on = this.$watch = this.$watchGroup = function () { return noop; };
            this.$$listeners = {};

            // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
            this.$$nextSibling = null;
            cleanUpScope(this);
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
          $eval: function (expr, locals) {
            return $parse(expr)(this, locals);
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
          $evalAsync: function (expr, locals) {
            // if we are outside of an $digest loop and this is the first time we are scheduling async
            // task also schedule async auto-flush
            if (!$rootScope.$$phase && !asyncQueue.length) {
              $browser.defer(function () {
                if (asyncQueue.length) {
                  $rootScope.$digest();
                }
              });
            }

            asyncQueue.push({ scope: this, fn: $parse(expr), locals: locals });
          },

          $$postDigest: function (fn) {
            postDigestQueue.push(fn);
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
          $apply: function (expr) {
            try {
              beginPhase("$apply");
              try {
                return this.$eval(expr);
              } finally {
                clearPhase();
              }
            } catch (e) {
              $exceptionHandler(e);
            } finally {
              try {
                $rootScope.$digest();
              } catch (e) {
                $exceptionHandler(e);
                // eslint-disable-next-line no-unsafe-finally
                throw e;
              }
            }
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
          $applyAsync: function (expr) {
            var scope = this;
            if (expr) {
              applyAsyncQueue.push($applyAsyncExpression);
            }
            expr = $parse(expr);
            scheduleApplyAsync();

            function $applyAsyncExpression() {
              scope.$eval(expr);
            }
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
          $on: function (name, listener) {
            var namedListeners = this.$$listeners[name];
            if (!namedListeners) {
              this.$$listeners[name] = namedListeners = [];
            }
            namedListeners.push(listener);

            var current = this;
            do {
              if (!current.$$listenerCount[name]) {
                current.$$listenerCount[name] = 0;
              }
              current.$$listenerCount[name]++;
            } while ((current = current.$parent));

            var self = this;
            return function () {
              var indexOfListener = namedListeners.indexOf(listener);
              if (indexOfListener !== -1) {
                // Use delete in the hope of the browser deallocating the memory for the array entry,
                // while not shifting the array indexes of other listeners.
                // See issue https://github.com/angular/angular.js/issues/16135
                delete namedListeners[indexOfListener];
                decrementListenerCount(self, 1, name);
              }
            };
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
          $emit: function (name, args) {
            var empty = [],
              namedListeners,
              scope = this,
              stopPropagation = false,
              event = {
                name: name,
                targetScope: scope,
                stopPropagation: function () {stopPropagation = true;},
                preventDefault: function () {
                  event.defaultPrevented = true;
                },
                defaultPrevented: false
              },
              listenerArgs = concat([event], arguments, 1),
              i, length;

            do {
              namedListeners = scope.$$listeners[name] || empty;
              event.currentScope = scope;
              for (i = 0, length = namedListeners.length; i < length; i++) {

                // if listeners were deregistered, defragment the array
                if (!namedListeners[i]) {
                  namedListeners.splice(i, 1);
                  i--;
                  length--;
                  continue;
                }
                try {
                  // allow all listeners attached to the current scope to run
                  namedListeners[i].apply(null, listenerArgs);
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
              // if any listener on the current scope stops propagation, prevent bubbling
              if (stopPropagation) {
                break;
              }
              // traverse upwards
              scope = scope.$parent;
            } while (scope);

            event.currentScope = null;

            return event;
          },

          /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
          $broadcast: function (name, args) {
            var target = this,
              current = target,
              next = target,
              event = {
                name: name,
                targetScope: target,
                preventDefault: function () {
                  event.defaultPrevented = true;
                },
                defaultPrevented: false
              };

            if (!target.$$listenerCount[name]) return event;

            var listenerArgs = concat([event], arguments, 1),
              listeners, i, length;

            // down while you can, then up and next sibling or up and next sibling until back at root
            while ((current = next)) {
              event.currentScope = current;
              listeners = current.$$listeners[name] || [];
              for (i = 0, length = listeners.length; i < length; i++) {
                // if listeners were deregistered, defragment the array
                if (!listeners[i]) {
                  listeners.splice(i, 1);
                  i--;
                  length--;
                  continue;
                }

                try {
                  listeners[i].apply(null, listenerArgs);
                } catch (e) {
                  $exceptionHandler(e);
                }
              }

              // Insanity Warning: scope depth-first traversal
              // yes, this code is a bit crazy, but it works and we have tests to prove it!
              // this piece should be kept in sync with the traversal in $digest
              // (though it differs due to having the extra check for $$listenerCount and
              // does not check $$suspended)
              if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
                while (current !== target && !(next = current.$$nextSibling)) {
                  current = current.$parent;
                }
              }
            }

            event.currentScope = null;
            return event;
          }
        };

        var $rootScope = new Scope();

        // The internal queues. Expose them on the $rootScope for debugging/testing purposes.
        var asyncQueue = $rootScope.$$asyncQueue = [];
        var postDigestQueue = $rootScope.$$postDigestQueue = [];
        var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

        var postDigestQueuePosition = 0;

        return $rootScope;

        function beginPhase(phase) {
          if ($rootScope.$$phase) {
            throw $rootScopeMinErr("inprog", "{0} already in progress", $rootScope.$$phase);
          }

          $rootScope.$$phase = phase;
        }

        function clearPhase() {
          $rootScope.$$phase = null;
        }

        function incrementWatchersCount(current, count) {
          do {
            current.$$watchersCount += count;
          } while ((current = current.$parent));
        }

        function decrementListenerCount(current, count, name) {
          do {
            current.$$listenerCount[name] -= count;

            if (current.$$listenerCount[name] === 0) {
              delete current.$$listenerCount[name];
            }
          } while ((current = current.$parent));
        }

        /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
        function initWatchVal() {}

        function flushApplyAsync() {
          while (applyAsyncQueue.length) {
            try {
              applyAsyncQueue.shift()();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          applyAsyncId = null;
        }

        function scheduleApplyAsync() {
          if (applyAsyncId === null) {
            applyAsyncId = $browser.defer(function () {
              $rootScope.$apply(flushApplyAsync);
            });
          }
        }
      }];
  }

  /**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */

  // the implementation is in angular.bootstrap

  /**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
  function $$SanitizeUriProvider() {
    var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
      imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

    /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
    this.aHrefSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        aHrefSanitizationWhitelist = regexp;
        return this;
      }
      return aHrefSanitizationWhitelist;
    };

    /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
    this.imgSrcSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        imgSrcSanitizationWhitelist = regexp;
        return this;
      }
      return imgSrcSanitizationWhitelist;
    };

    this.$get = function () {
      return function sanitizeUri(uri, isImage) {
        var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
        var normalizedVal;
        normalizedVal = urlResolve(uri && uri.trim()).href;
        if (normalizedVal !== "" && !normalizedVal.match(regex)) {
          return "unsafe:" + normalizedVal;
        }
        return uri;
      };
    };
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* exported $SceProvider, $SceDelegateProvider */

  var $sceMinErr = minErr("$sce");

  var SCE_CONTEXTS = {
  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
    HTML: "html",

    // Style statements or stylesheets. Currently unused in AngularJS.
    CSS: "css",

    // An URL used in a context where it does not refer to a resource that loads code. Currently
    // unused in AngularJS.
    URL: "url",

    // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
    // code. (e.g. ng-include, script src binding, templateUrl)
    RESOURCE_URL: "resourceUrl",

    // Script. Currently unused in AngularJS.
    JS: "js"
  };

  // Helper functions follow.

  var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

  function snakeToCamel(name) {
    return name
      .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
  }

  function adjustMatcher(matcher) {
    if (matcher === "self") {
      return matcher;
    } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
      if (matcher.indexOf("***") > -1) {
        throw $sceMinErr("iwcard",
          "Illegal sequence *** in string matcher.  String: {0}", matcher);
      }
      matcher = escapeForRegexp(matcher).
        replace(/\\\*\\\*/g, ".*").
        replace(/\\\*/g, "[^:/.?&;]*");
      return new RegExp("^" + matcher + "$");
    } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
      return new RegExp("^" + matcher.source + "$");
    } else {
      throw $sceMinErr("imatcher",
        "Matchers may only be \"self\", string patterns or RegExp objects");
    }
  }

  function adjustMatchers(matchers) {
    var adjustedMatchers = [];
    if (isDefined(matchers)) {
      forEach(matchers, function (matcher) {
        adjustedMatchers.push(adjustMatcher(matcher));
      });
    }
    return adjustedMatchers;
  }

  /**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

  /**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
 * places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
 * and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty whitelist will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
 * for instance attacker-controlled `ng-includes`.
 */

  function $SceDelegateProvider() {
    this.SCE_CONTEXTS = SCE_CONTEXTS;

    // Resource URLs can also be trusted by policy.
    var resourceUrlWhitelist = ["self"],
      resourceUrlBlacklist = [];

    /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set whitelist array.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
   * with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */
    this.resourceUrlWhitelist = function (value) {
      if (arguments.length) {
        resourceUrlWhitelist = adjustMatchers(value);
      }
      return resourceUrlWhitelist;
    };

    /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the blacklist is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} The currently set blacklist array.
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   */

    this.resourceUrlBlacklist = function (value) {
      if (arguments.length) {
        resourceUrlBlacklist = adjustMatchers(value);
      }
      return resourceUrlBlacklist;
    };

    this.$get = ["$injector", function ($injector) {

      var htmlSanitizer = function htmlSanitizer(html) {
        throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");
      };

      if ($injector.has("$sanitize")) {
        htmlSanitizer = $injector.get("$sanitize");
      }

      function matchUrl(matcher, parsedUrl) {
        if (matcher === "self") {
          return urlIsSameOrigin(parsedUrl);
        } else {
        // definitely a regex.  See adjustMatchers()
          return !!matcher.exec(parsedUrl.href);
        }
      }

      function isResourceUrlAllowedByPolicy(url) {
        var parsedUrl = urlResolve(url.toString());
        var i, n, allowed = false;
        // Ensure that at least one item from the whitelist allows this url.
        for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
          if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
            allowed = true;
            break;
          }
        }
        if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
          for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
            if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
              allowed = false;
              break;
            }
          }
        }
        return allowed;
      }

      function generateHolderType(Base) {
        var holderType = function TrustedValueHolderType(trustedValue) {
          this.$$unwrapTrustedValue = function () {
            return trustedValue;
          };
        };
        if (Base) {
          holderType.prototype = new Base();
        }
        holderType.prototype.valueOf = function sceValueOf() {
          return this.$$unwrapTrustedValue();
        };
        holderType.prototype.toString = function sceToString() {
          return this.$$unwrapTrustedValue().toString();
        };
        return holderType;
      }

      var trustedValueHolderBase = generateHolderType(),
        byType = {};

      byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

      /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */
      function trustAs(type, trustedValue) {
        var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
        if (!Constructor) {
          throw $sceMinErr("icontext",
            "Attempted to trust a value in invalid context. Context: {0}; Value: {1}",
            type, trustedValue);
        }
        if (trustedValue === null || isUndefined(trustedValue) || trustedValue === "") {
          return trustedValue;
        }
        // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
        // mutable objects, we ensure here that the value passed in is actually a string.
        if (typeof trustedValue !== "string") {
          throw $sceMinErr("itype",
            "Attempted to trust a non-string value in a content requiring a string: Context: {0}",
            type);
        }
        return new Constructor(trustedValue);
      }

      /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
      function valueOf(maybeTrusted) {
        if (maybeTrusted instanceof trustedValueHolderBase) {
          return maybeTrusted.$$unwrapTrustedValue();
        } else {
          return maybeTrusted;
        }
      }

      /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes any input, and either returns a value that's safe to use in the specified context, or
     * throws an exception.
     *
     * In practice, there are several cases. When given a string, this function runs checks
     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
     * value if that value's context is valid for this call's context. Finally, this function can
     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
     * is available or possible.)
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */
      function getTrusted(type, maybeTrusted) {
        if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === "") {
          return maybeTrusted;
        }
        var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
        // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
        // as-is.
        if (constructor && maybeTrusted instanceof constructor) {
          return maybeTrusted.$$unwrapTrustedValue();
        }
        // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
        // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
        // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
        // has no corresponding sinks.
        if (type === SCE_CONTEXTS.RESOURCE_URL) {
        // RESOURCE_URL uses a whitelist.
          if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
            return maybeTrusted;
          } else {
            throw $sceMinErr("insecurl",
              "Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}",
              maybeTrusted.toString());
          }
        } else if (type === SCE_CONTEXTS.HTML) {
        // htmlSanitizer throws its own error when no sanitizer is available.
          return htmlSanitizer(maybeTrusted);
        }
        // Default error when the $sce service has no way to make the input safe.
        throw $sceMinErr("unsafe", "Attempting to use an unsafe value in a safe context.");
      }

      return { trustAs: trustAs,
        getTrusted: getTrusted,
        valueOf: valueOf };
    }];
  }

  /**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

  /**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
 * can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
 * also use the `$sanitize` service if it is available when binding untrusted values to
 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
 *
 *
 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
 * might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

  function $SceProvider() {
    var enabled = true;

    /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
    this.enabled = function (value) {
      if (arguments.length) {
        enabled = !!value;
      }
      return enabled;
    };

    /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */

    this.$get = ["$parse", "$sceDelegate", function (
      $parse, $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
      if (enabled && msie < 8) {
        throw $sceMinErr("iequirks",
          "Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks " +
        "mode.  You can fix this by adding the text <!doctype html> to the top of your HTML " +
        "document.  See http://docs.angularjs.org/api/ng.$sce for more information.");
      }

      var sce = shallowCopy(SCE_CONTEXTS);

      /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
      sce.isEnabled = function () {
        return enabled;
      };
      sce.trustAs = $sceDelegate.trustAs;
      sce.getTrusted = $sceDelegate.getTrusted;
      sce.valueOf = $sceDelegate.valueOf;

      if (!enabled) {
        sce.trustAs = sce.getTrusted = function (type, value) { return value; };
        sce.valueOf = identity;
      }

      /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */
      sce.parseAs = function sceParseAs(type, expr) {
        var parsed = $parse(expr);
        if (parsed.literal && parsed.constant) {
          return parsed;
        } else {
          return $parse(expr, function (value) {
            return sce.getTrusted(type, value);
          });
        }
      };

      /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */

      /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */

      /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */

      /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */

      /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */

      /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */

      /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */

      /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

      /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

      /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

      /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

      /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

      /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

      /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

      /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

      /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

      /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

      // Shorthand delegations.
      var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

      forEach(SCE_CONTEXTS, function (enumValue, name) {
        var lName = lowercase(name);
        sce[snakeToCamel("parse_as_" + lName)] = function (expr) {
          return parse(enumValue, expr);
        };
        sce[snakeToCamel("get_trusted_" + lName)] = function (value) {
          return getTrusted(enumValue, value);
        };
        sce[snakeToCamel("trust_as_" + lName)] = function (value) {
          return trustAs(enumValue, value);
        };
      });

      return sce;
    }];
  }

  /* exported $SnifferProvider */

  /**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
  function $SnifferProvider() {
    this.$get = ["$window", "$document", function ($window, $document) {
      var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp =
            !isNw &&
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

      if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
        transitions = !!("transition" in bodyStyle || "webkitTransition" in bodyStyle);
        animations = !!("animation" in bodyStyle || "webkitAnimation" in bodyStyle);
      }

      return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

        // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
        // so let's not use the history API also
        // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
        history: !!(hasHistoryPushState && !(android < 4) && !boxee),
        hasEvent: function (event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
          if (event === "input" && msie) return false;

          if (isUndefined(eventSupport[event])) {
            var divElm = document.createElement("div");
            eventSupport[event] = "on" + event in divElm;
          }

          return eventSupport[event];
        },
        csp: csp(),
        transitions: transitions,
        animations: animations,
        android: android
      };
    }];
  }

  var $templateRequestMinErr = minErr("$compile");

  /**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
  function $TemplateRequestProvider() {

    var httpOptions;

    /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
    this.httpOptions = function (val) {
      if (val) {
        httpOptions = val;
        return this;
      }
      return httpOptions;
    };

    /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
    this.$get = ["$exceptionHandler", "$templateCache", "$http", "$q", "$sce",
      function ($exceptionHandler, $templateCache, $http, $q, $sce) {

        function handleRequestFn(tpl, ignoreRequestError) {
          handleRequestFn.totalPendingRequests++;

          // We consider the template cache holds only trusted templates, so
          // there's no need to go through whitelisting again for keys that already
          // are included in there. This also makes AngularJS accept any script
          // directive, no matter its name. However, we still need to unwrap trusted
          // types.
          if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
            tpl = $sce.getTrustedResourceUrl(tpl);
          }

          var transformResponse = $http.defaults && $http.defaults.transformResponse;

          if (isArray(transformResponse)) {
            transformResponse = transformResponse.filter(function (transformer) {
              return transformer !== defaultHttpResponseTransform;
            });
          } else if (transformResponse === defaultHttpResponseTransform) {
            transformResponse = null;
          }

          return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
            .finally(function () {
              handleRequestFn.totalPendingRequests--;
            })
            .then(function (response) {
              $templateCache.put(tpl, response.data);
              return response.data;
            }, handleError);

          function handleError(resp) {
            if (!ignoreRequestError) {
              resp = $templateRequestMinErr("tpload",
                "Failed to load template: {0} (HTTP status: {1} {2})",
                tpl, resp.status, resp.statusText);

              $exceptionHandler(resp);
            }

            return $q.reject(resp);
          }
        }

        handleRequestFn.totalPendingRequests = 0;

        return handleRequestFn;
      }
    ];
  }

  /** @this */
  function $$TestabilityProvider() {
    this.$get = ["$rootScope", "$browser", "$location",
      function ($rootScope, $browser, $location) {

        /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
        var testability = {};

        /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
        testability.findBindings = function (element, expression, opt_exactMatch) {
          var bindings = element.getElementsByClassName("ng-binding");
          var matches = [];
          forEach(bindings, function (binding) {
            var dataBinding = angular.element(binding).data("$binding");
            if (dataBinding) {
              forEach(dataBinding, function (bindingName) {
                if (opt_exactMatch) {
                  var matcher = new RegExp("(^|\\s)" + escapeForRegexp(expression) + "(\\s|\\||$)");
                  if (matcher.test(bindingName)) {
                    matches.push(binding);
                  }
                } else {
                  if (bindingName.indexOf(expression) !== -1) {
                    matches.push(binding);
                  }
                }
              });
            }
          });
          return matches;
        };

        /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
        testability.findModels = function (element, expression, opt_exactMatch) {
          var prefixes = ["ng-", "data-ng-", "ng\\:"];
          for (var p = 0; p < prefixes.length; ++p) {
            var attributeEquals = opt_exactMatch ? "=" : "*=";
            var selector = "[" + prefixes[p] + "model" + attributeEquals + "\"" + expression + "\"]";
            var elements = element.querySelectorAll(selector);
            if (elements.length) {
              return elements;
            }
          }
        };

        /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
        testability.getLocation = function () {
          return $location.url();
        };

        /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
        testability.setLocation = function (url) {
          if (url !== $location.url()) {
            $location.url(url);
            $rootScope.$digest();
          }
        };

        /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
        testability.whenStable = function (callback) {
          $browser.notifyWhenNoOutstandingRequests(callback);
        };

        return testability;
      }];
  }

  /** @this */
  function $TimeoutProvider() {
    this.$get = ["$rootScope", "$browser", "$q", "$$q", "$exceptionHandler",
      function ($rootScope, $browser, $q, $$q, $exceptionHandler) {

        var deferreds = {};

        /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */
        function timeout(fn, delay, invokeApply) {
          if (!isFunction(fn)) {
            invokeApply = delay;
            delay = fn;
            fn = noop;
          }

          var args = sliceArgs(arguments, 3),
            skipApply = (isDefined(invokeApply) && !invokeApply),
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise,
            timeoutId;

          timeoutId = $browser.defer(function () {
            try {
              deferred.resolve(fn.apply(null, args));
            } catch (e) {
              deferred.reject(e);
              $exceptionHandler(e);
            } finally {
              delete deferreds[promise.$$timeoutId];
            }

            if (!skipApply) $rootScope.$apply();
          }, delay);

          promise.$$timeoutId = timeoutId;
          deferreds[timeoutId] = deferred;

          return promise;
        }

        /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */
        timeout.cancel = function (promise) {
          if (promise && promise.$$timeoutId in deferreds) {
            // Timeout cancels should not report an unhandled promise.
            markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
            deferreds[promise.$$timeoutId].reject("canceled");
            delete deferreds[promise.$$timeoutId];
            return $browser.defer.cancel(promise.$$timeoutId);
          }
          return false;
        };

        return timeout;
      }];
  }

  // NOTE:  The usage of window and document instead of $window and $document here is
  // deliberate.  This service depends on the specific behavior of anchor nodes created by the
  // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
  // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
  // doesn't know about mocked locations and resolves URLs to the real document - which is
  // exactly the behavior needed here.  There is little value is mocking these out for this
  // service.
  var urlParsingNode = window.document.createElement("a");
  var originUrl = urlResolve(window.location.href);

  /**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
  function urlResolve(url) {
    if (!isString(url)) return url;

    var href = url;

    // Support: IE 9-11 only
    if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute("href", href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: (urlParsingNode.pathname.charAt(0) === "/")
        ? urlParsingNode.pathname
        : "/" + urlParsingNode.pathname
    };
  }

  /**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
  function urlIsSameOrigin(requestUrl) {
    return urlsAreSameOrigin(requestUrl, originUrl);
  }

  /**
 * Create a function that can check a URL's origin against a list of allowed/whitelisted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} whitelistedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */
  function urlIsAllowedOriginFactory(whitelistedOriginUrls) {
    var parsedAllowedOriginUrls = [originUrl].concat(whitelistedOriginUrls.map(urlResolve));

    /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of whitelisted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */
    return function urlIsAllowedOrigin(requestUrl) {
      var parsedUrl = urlResolve(requestUrl);
      return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
    };
  }

  /**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */
  function urlsAreSameOrigin(url1, url2) {
    url1 = urlResolve(url1);
    url2 = urlResolve(url2);

    return (url1.protocol === url2.protocol &&
          url1.host === url2.host);
  }

  /**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
  function $WindowProvider() {
    this.$get = valueFn(window);
  }

  /**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
  function $$CookieReader($document) {
    var rawDocument = $document[0] || {};
    var lastCookies = {};
    var lastCookieString = "";

    function safeGetCookie(rawDocument) {
      try {
        return rawDocument.cookie || "";
      } catch (e) {
        return "";
      }
    }

    function safeDecodeURIComponent(str) {
      try {
        return decodeURIComponent(str);
      } catch (e) {
        return str;
      }
    }

    return function () {
      var cookieArray, cookie, i, index, name;
      var currentCookieString = safeGetCookie(rawDocument);

      if (currentCookieString !== lastCookieString) {
        lastCookieString = currentCookieString;
        cookieArray = lastCookieString.split("; ");
        lastCookies = {};

        for (i = 0; i < cookieArray.length; i++) {
          cookie = cookieArray[i];
          index = cookie.indexOf("=");
          if (index > 0) { // ignore nameless cookies
            name = safeDecodeURIComponent(cookie.substring(0, index));
            // the first value that is seen for a cookie is the most
            // specific one.  values for the same cookie name that
            // follow are for less specific paths.
            if (isUndefined(lastCookies[name])) {
              lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
            }
          }
        }
      }
      return lastCookies;
    };
  }

  $$CookieReader.$inject = ["$document"];

  /** @this */
  function $$CookieReaderProvider() {
    this.$get = $$CookieReader;
  }

  /* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

  /**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */

  /**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
  $FilterProvider.$inject = ["$provide"];
  /** @this */
  function $FilterProvider($provide) {
    var suffix = "Filter";

    /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
    function register(name, factory) {
      if (isObject(name)) {
        var filters = {};
        forEach(name, function (filter, key) {
          filters[key] = register(key, filter);
        });
        return filters;
      } else {
        return $provide.factory(name + suffix, factory);
      }
    }
    this.register = register;

    this.$get = ["$injector", function ($injector) {
      return function (name) {
        return $injector.get(name + suffix);
      };
    }];

    // //////////////////////////////////////

    /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

    register("currency", currencyFilter);
    register("date", dateFilter);
    register("filter", filterFilter);
    register("json", jsonFilter);
    register("limitTo", limitToFilter);
    register("lowercase", lowercaseFilter);
    register("number", numberFilter);
    register("orderBy", orderByFilter);
    register("uppercase", uppercaseFilter);
  }

  /**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

  function filterFilter() {
    return function (array, expression, comparator, anyPropertyKey) {
      if (!isArrayLike(array)) {
        if (array == null) {
          return array;
        } else {
          throw minErr("filter")("notarray", "Expected array but received: {0}", array);
        }
      }

      anyPropertyKey = anyPropertyKey || "$";
      var expressionType = getTypeForFilter(expression);
      var predicateFn;
      var matchAgainstAnyProp;

      switch (expressionType) {
        case "function":
          predicateFn = expression;
          break;
        case "boolean":
        case "null":
        case "number":
        case "string":
          matchAgainstAnyProp = true;
        // falls through
        case "object":
          predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
          break;
        default:
          return array;
      }

      return Array.prototype.filter.call(array, predicateFn);
    };
  }

  // Helper functions for `filterFilter`
  function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
    var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
    var predicateFn;

    if (comparator === true) {
      comparator = equals;
    } else if (!isFunction(comparator)) {
      comparator = function (actual, expected) {
        if (isUndefined(actual)) {
        // No substring matching against `undefined`
          return false;
        }
        if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
          return actual === expected;
        }
        if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
          return false;
        }

        actual = lowercase("" + actual);
        expected = lowercase("" + expected);
        return actual.indexOf(expected) !== -1;
      };
    }

    predicateFn = function (item) {
      if (shouldMatchPrimitives && !isObject(item)) {
        return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
      }
      return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
    };

    return predicateFn;
  }

  function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
    var actualType = getTypeForFilter(actual);
    var expectedType = getTypeForFilter(expected);

    if ((expectedType === "string") && (expected.charAt(0) === "!")) {
      return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
    } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
      return actual.some(function (item) {
        return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
      });
    }

    switch (actualType) {
      case "object":
        var key;
        if (matchAgainstAnyProp) {
          for (key in actual) {
          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
          // See: https://github.com/angular/angular.js/issues/15644
            if (key.charAt && (key.charAt(0) !== "$") &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
              return true;
            }
          }
          return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
        } else if (expectedType === "object") {
          for (key in expected) {
            var expectedVal = expected[key];
            if (isFunction(expectedVal) || isUndefined(expectedVal)) {
              continue;
            }

            var matchAnyProperty = key === anyPropertyKey;
            var actualVal = matchAnyProperty ? actual : actual[key];
            if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
              return false;
            }
          }
          return true;
        } else {
          return comparator(actual, expected);
        }
      case "function":
        return false;
      default:
        return comparator(actual, expected);
    }
  }

  // Used for easily differentiating between `null` and actual `object`
  function getTypeForFilter(val) {
    return (val === null) ? "null" : typeof val;
  }

  var MAX_DIGITS = 22;
  var DECIMAL_SEP = ".";
  var ZERO_CHAR = "0";

  /**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
  currencyFilter.$inject = ["$locale"];
  function currencyFilter($locale) {
    var formats = $locale.NUMBER_FORMATS;
    return function (amount, currencySymbol, fractionSize) {
      if (isUndefined(currencySymbol)) {
        currencySymbol = formats.CURRENCY_SYM;
      }

      if (isUndefined(fractionSize)) {
        fractionSize = formats.PATTERNS[1].maxFrac;
      }

      // If the currency symbol is empty, trim whitespace around the symbol
      var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

      // if null or undefined pass it through
      return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
          replace(currencySymbolRe, currencySymbol);
    };
  }

  /**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
  numberFilter.$inject = ["$locale"];
  function numberFilter($locale) {
    var formats = $locale.NUMBER_FORMATS;
    return function (number, fractionSize) {

      // if null or undefined pass it through
      return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
          fractionSize);
    };
  }

  /**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
  function parse(numStr) {
    var exponent = 0, digits, numberOfIntegerDigits;
    var i, j, zeros;

    // Decimal point?
    if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
      numStr = numStr.replace(DECIMAL_SEP, "");
    }

    // Exponential form?
    if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
      if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
      numberOfIntegerDigits += +numStr.slice(i + 1);
      numStr = numStr.substring(0, i);
    } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
      numberOfIntegerDigits = numStr.length;
    }

    // Count the number of leading zeros.
    for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

    if (i === (zeros = numStr.length)) {
    // The digits are all zero.
      digits = [0];
      numberOfIntegerDigits = 1;
    } else {
    // Count the number of trailing zeros
      zeros--;
      while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

      // Trailing zeros are insignificant so ignore them
      numberOfIntegerDigits -= i;
      digits = [];
      // Convert string to array of digits without leading/trailing zeros.
      for (j = 0; i <= zeros; i++, j++) {
        digits[j] = +numStr.charAt(i);
      }
    }

    // If the number overflows the maximum allowed digits then use an exponent.
    if (numberOfIntegerDigits > MAX_DIGITS) {
      digits = digits.splice(0, MAX_DIGITS - 1);
      exponent = numberOfIntegerDigits - 1;
      numberOfIntegerDigits = 1;
    }

    return { d: digits, e: exponent, i: numberOfIntegerDigits };
  }

  /**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
  function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);

    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function (carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
  }

  /**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
  function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

    if (!(isString(number) || isNumber(number)) || isNaN(number)) return "";

    var isInfinity = !isFinite(number);
    var isZero = false;
    var numStr = Math.abs(number) + "",
      formattedText = "",
      parsedNumber;

    if (isInfinity) {
      formattedText = "\u221e";
    } else {
      parsedNumber = parse(numStr);

      roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

      var digits = parsedNumber.d;
      var integerLen = parsedNumber.i;
      var exponent = parsedNumber.e;
      var decimals = [];
      isZero = digits.reduce(function (isZero, d) { return isZero && !d; }, true);

      // pad zeros for small numbers
      while (integerLen < 0) {
        digits.unshift(0);
        integerLen++;
      }

      // extract decimals digits
      if (integerLen > 0) {
        decimals = digits.splice(integerLen, digits.length);
      } else {
        decimals = digits;
        digits = [0];
      }

      // format the integer digits with grouping separators
      var groups = [];
      if (digits.length >= pattern.lgSize) {
        groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(""));
      }
      while (digits.length > pattern.gSize) {
        groups.unshift(digits.splice(-pattern.gSize, digits.length).join(""));
      }
      if (digits.length) {
        groups.unshift(digits.join(""));
      }
      formattedText = groups.join(groupSep);

      // append the decimal digits
      if (decimals.length) {
        formattedText += decimalSep + decimals.join("");
      }

      if (exponent) {
        formattedText += "e+" + exponent;
      }
    }
    if (number < 0 && !isZero) {
      return pattern.negPre + formattedText + pattern.negSuf;
    } else {
      return pattern.posPre + formattedText + pattern.posSuf;
    }
  }

  function padNumber(num, digits, trim, negWrap) {
    var neg = "";
    if (num < 0 || (negWrap && num <= 0)) {
      if (negWrap) {
        num = -num + 1;
      } else {
        num = -num;
        neg = "-";
      }
    }
    num = "" + num;
    while (num.length < digits) num = ZERO_CHAR + num;
    if (trim) {
      num = num.substr(num.length - digits);
    }
    return neg + num;
  }

  function dateGetter(name, size, offset, trim, negWrap) {
    offset = offset || 0;
    return function (date) {
      var value = date["get" + name]();
      if (offset > 0 || value > -offset) {
        value += offset;
      }
      if (value === 0 && offset === -12) value = 12;
      return padNumber(value, size, trim, negWrap);
    };
  }

  function dateStrGetter(name, shortForm, standAlone) {
    return function (date, formats) {
      var value = date["get" + name]();
      var propPrefix = (standAlone ? "STANDALONE" : "") + (shortForm ? "SHORT" : "");
      var get = uppercase(propPrefix + name);

      return formats[get][value];
    };
  }

  function timeZoneGetter(date, formats, offset) {
    var zone = -1 * offset;
    var paddedZone = (zone >= 0) ? "+" : "";

    paddedZone += padNumber(Math[zone > 0 ? "floor" : "ceil"](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

    return paddedZone;
  }

  function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
  }

  function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
  }

  function weekGetter(size) {
    return function (date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
        thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
        result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
    };
  }

  function ampmGetter(date, formats) {
    return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
  }

  function eraGetter(date, formats) {
    return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
  }

  function longEraGetter(date, formats) {
    return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
  }

  var DATE_FORMATS = {
    yyyy: dateGetter("FullYear", 4, 0, false, true),
    yy: dateGetter("FullYear", 2, 0, true, true),
    y: dateGetter("FullYear", 1, 0, false, true),
    MMMM: dateStrGetter("Month"),
    MMM: dateStrGetter("Month", true),
    MM: dateGetter("Month", 2, 1),
    M: dateGetter("Month", 1, 1),
    LLLL: dateStrGetter("Month", false, true),
    dd: dateGetter("Date", 2),
    d: dateGetter("Date", 1),
    HH: dateGetter("Hours", 2),
    H: dateGetter("Hours", 1),
    hh: dateGetter("Hours", 2, -12),
    h: dateGetter("Hours", 1, -12),
    mm: dateGetter("Minutes", 2),
    m: dateGetter("Minutes", 1),
    ss: dateGetter("Seconds", 2),
    s: dateGetter("Seconds", 1),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
    sss: dateGetter("Milliseconds", 3),
    EEEE: dateStrGetter("Day"),
    EEE: dateStrGetter("Day", true),
    a: ampmGetter,
    Z: timeZoneGetter,
    ww: weekGetter(2),
    w: weekGetter(1),
    G: eraGetter,
    GG: eraGetter,
    GGG: eraGetter,
    GGGG: longEraGetter
  };

  var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

  /**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
  dateFilter.$inject = ["$locale"];
  function dateFilter($locale) {

    var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
    // 1        2       3         4          5          6          7          8  9     10      11
    function jsonStringToDate(string) {
      var match;
      if ((match = string.match(R_ISO8601_STR))) {
        var date = new Date(0),
          tzHour = 0,
          tzMin = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

        if (match[9]) {
          tzHour = toInt(match[9] + match[10]);
          tzMin = toInt(match[9] + match[11]);
        }
        dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
        var h = toInt(match[4] || 0) - tzHour;
        var m = toInt(match[5] || 0) - tzMin;
        var s = toInt(match[6] || 0);
        var ms = Math.round(parseFloat("0." + (match[7] || 0)) * 1000);
        timeSetter.call(date, h, m, s, ms);
        return date;
      }
      return string;
    }

    return function (date, format, timezone) {
      var text = "",
        parts = [],
        fn, match;

      format = format || "mediumDate";
      format = $locale.DATETIME_FORMATS[format] || format;
      if (isString(date)) {
        date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
      }

      if (isNumber(date)) {
        date = new Date(date);
      }

      if (!isDate(date) || !isFinite(date.getTime())) {
        return date;
      }

      while (format) {
        match = DATE_FORMATS_SPLIT.exec(format);
        if (match) {
          parts = concat(parts, match, 1);
          format = parts.pop();
        } else {
          parts.push(format);
          format = null;
        }
      }

      var dateTimezoneOffset = date.getTimezoneOffset();
      if (timezone) {
        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        date = convertTimezoneToLocal(date, timezone, true);
      }
      forEach(parts, function (value) {
        fn = DATE_FORMATS[value];
        text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
          : value === "''" ? "'" : value.replace(/(^'|'$)/g, "").replace(/''/g, "'");
      });

      return text;
    };
  }

  /**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
  function jsonFilter() {
    return function (object, spacing) {
      if (isUndefined(spacing)) {
        spacing = 2;
      }
      return toJson(object, spacing);
    };
  }

  /**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */
  var lowercaseFilter = valueFn(lowercase);

  /**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */
  var uppercaseFilter = valueFn(uppercase);

  /**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
  function limitToFilter() {
    return function (input, limit, begin) {
      if (Math.abs(Number(limit)) === Infinity) {
        limit = Number(limit);
      } else {
        limit = toInt(limit);
      }
      if (isNumberNaN(limit)) return input;

      if (isNumber(input)) input = input.toString();
      if (!isArrayLike(input)) return input;

      begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
      begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

      if (limit >= 0) {
        return sliceFn(input, begin, begin + limit);
      } else {
        if (begin === 0) {
          return sliceFn(input, limit, input.length);
        } else {
          return sliceFn(input, Math.max(0, begin + limit), begin);
        }
      }
    };
  }

  function sliceFn(input, begin, end) {
    if (isString(input)) return input.slice(begin, end);

    return slice.call(input, begin, end);
  }

  /**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, and sorts values of different types by type.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types, compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
 *           other values.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
  orderByFilter.$inject = ["$parse"];
  function orderByFilter($parse) {
    return function (array, sortPredicate, reverseOrder, compareFn) {

      if (array == null) return array;
      if (!isArrayLike(array)) {
        throw minErr("orderBy")("notarray", "Expected array but received: {0}", array);
      }

      if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
      if (sortPredicate.length === 0) { sortPredicate = ["+"]; }

      var predicates = processPredicates(sortPredicate);

      var descending = reverseOrder ? -1 : 1;

      // Define the `compare()` function. Use a default comparator if none is specified.
      var compare = isFunction(compareFn) ? compareFn : defaultCompare;

      // The next three lines are a version of a Swartzian Transform idiom from Perl
      // (sometimes called the Decorate-Sort-Undecorate idiom)
      // See https://en.wikipedia.org/wiki/Schwartzian_transform
      var compareValues = Array.prototype.map.call(array, getComparisonObject);
      compareValues.sort(doComparison);
      array = compareValues.map(function (item) { return item.value; });

      return array;

      function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
        return {
          value: value,
          tieBreaker: { value: index, type: "number", index: index },
          predicateValues: predicates.map(function (predicate) {
            return getPredicateValue(predicate.get(value), index);
          })
        };
      }

      function doComparison(v1, v2) {
        for (var i = 0, ii = predicates.length; i < ii; i++) {
          var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
          if (result) {
            return result * predicates[i].descending * descending;
          }
        }

        return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
      }
    };

    function processPredicates(sortPredicates) {
      return sortPredicates.map(function (predicate) {
        var descending = 1, get = identity;

        if (isFunction(predicate)) {
          get = predicate;
        } else if (isString(predicate)) {
          if ((predicate.charAt(0) === "+" || predicate.charAt(0) === "-")) {
            descending = predicate.charAt(0) === "-" ? -1 : 1;
            predicate = predicate.substring(1);
          }
          if (predicate !== "") {
            get = $parse(predicate);
            if (get.constant) {
              var key = get();
              get = function (value) { return value[key]; };
            }
          }
        }
        return { get: get, descending: descending };
      });
    }

    function isPrimitive(value) {
      switch (typeof value) {
        case "number": /* falls through */
        case "boolean": /* falls through */
        case "string":
          return true;
        default:
          return false;
      }
    }

    function objectValue(value) {
    // If `valueOf` is a valid function use that
      if (isFunction(value.valueOf)) {
        value = value.valueOf();
        if (isPrimitive(value)) return value;
      }
      // If `toString` is a valid function and not the one from `Object.prototype` use that
      if (hasCustomToString(value)) {
        value = value.toString();
        if (isPrimitive(value)) return value;
      }

      return value;
    }

    function getPredicateValue(value, index) {
      var type = typeof value;
      if (value === null) {
        type = "string";
        value = "null";
      } else if (type === "object") {
        value = objectValue(value);
      }
      return { value: value, type: type, index: index };
    }

    function defaultCompare(v1, v2) {
      var result = 0;
      var type1 = v1.type;
      var type2 = v2.type;

      if (type1 === type2) {
        var value1 = v1.value;
        var value2 = v2.value;

        if (type1 === "string") {
        // Compare strings case-insensitively
          value1 = value1.toLowerCase();
          value2 = value2.toLowerCase();
        } else if (type1 === "object") {
        // For basic objects, use the position of the object
        // in the collection instead of the value
          if (isObject(value1)) value1 = v1.index;
          if (isObject(value2)) value2 = v2.index;
        }

        if (value1 !== value2) {
          result = value1 < value2 ? -1 : 1;
        }
      } else {
        result = type1 < type2 ? -1 : 1;
      }

      return result;
    }
  }

  function ngDirective(directive) {
    if (isFunction(directive)) {
      directive = {
        link: directive
      };
    }
    directive.restrict = directive.restrict || "AC";
    return valueFn(directive);
  }

  /**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
  var htmlAnchorDirective = valueFn({
    restrict: "E",
    compile: function (element, attr) {
      if (!attr.href && !attr.xlinkHref) {
        return function (scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
          if (element[0].nodeName.toLowerCase() !== "a") return;

          // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
          var href = toString.call(element.prop("href")) === "[object SVGAnimatedString]" ?
            "xlink:href" : "href";
          element.on("click", function (event) {
          // if we have no href url, then don't navigate anywhere.
            if (!element.attr(href)) {
              event.preventDefault();
            }
          });
        };
      }
    }
  });

  /**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

  /**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

  /**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

  /**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */

  /**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */

  /**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */

  /**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

  /**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

  var ngAttributeAliasDirectives = {};

  // boolean attrs are evaluated
  forEach(BOOLEAN_ATTR, function (propName, attrName) {
  // binding to multiple is not supported
    if (propName === "multiple") return;

    function defaultLinkFn(scope, element, attr) {
      scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
        attr.$set(attrName, !!value);
      });
    }

    var normalized = directiveNormalize("ng-" + attrName);
    var linkFn = defaultLinkFn;

    if (propName === "checked") {
      linkFn = function (scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
        if (attr.ngModel !== attr[normalized]) {
          defaultLinkFn(scope, element, attr);
        }
      };
    }

    ngAttributeAliasDirectives[normalized] = function () {
      return {
        restrict: "A",
        priority: 100,
        link: linkFn
      };
    };
  });

  // aliased input attrs are evaluated
  forEach(ALIASED_ATTR, function (htmlAttr, ngAttr) {
    ngAttributeAliasDirectives[ngAttr] = function () {
      return {
        priority: 100,
        link: function (scope, element, attr) {
        // special case ngPattern when a literal regular expression value
        // is used as the expression (this way we don't have to watch anything).
          if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) === "/") {
            var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
            if (match) {
              attr.$set("ngPattern", new RegExp(match[1], match[2]));
              return;
            }
          }

          scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
            attr.$set(ngAttr, value);
          });
        }
      };
    };
  });

  // ng-src, ng-srcset, ng-href are interpolated
  forEach(["src", "srcset", "href"], function (attrName) {
    var normalized = directiveNormalize("ng-" + attrName);
    ngAttributeAliasDirectives[normalized] = function () {
      return {
        priority: 99, // it needs to run after the attributes are interpolated
        link: function (scope, element, attr) {
          var propName = attrName,
            name = attrName;

          if (attrName === "href" &&
            toString.call(element.prop("href")) === "[object SVGAnimatedString]") {
            name = "xlinkHref";
            attr.$attr[name] = "xlink:href";
            propName = null;
          }

          attr.$observe(normalized, function (value) {
            if (!value) {
              if (attrName === "href") {
                attr.$set(name, null);
              }
              return;
            }

            attr.$set(name, value);

            // Support: IE 9-11 only
            // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
            // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
            // to set the property as well to achieve the desired effect.
            // We use attr[attrName] value since $set can sanitize the url.
            if (msie && propName) element.prop(propName, attr[name]);
          });
        }
      };
    };
  });

  /* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
  var nullFormCtrl = {
      $addControl: noop,
      $$renameControl: nullFormRenameControl,
      $removeControl: noop,
      $setValidity: noop,
      $setDirty: noop,
      $setPristine: noop,
      $setSubmitted: noop
    },
    PENDING_CLASS = "ng-pending",
    SUBMITTED_CLASS = "ng-submitted";

  function nullFormRenameControl(control, name) {
    control.$name = name;
  }

  /**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
  // asks for $scope to fool the BC controller module
  FormController.$inject = ["$element", "$attrs", "$scope", "$animate", "$interpolate"];
  function FormController($element, $attrs, $scope, $animate, $interpolate) {
    this.$$controls = [];

    // init state
    this.$error = {};
    this.$$success = {};
    this.$pending = undefined;
    this.$name = $interpolate($attrs.name || $attrs.ngForm || "")($scope);
    this.$dirty = false;
    this.$pristine = true;
    this.$valid = true;
    this.$invalid = false;
    this.$submitted = false;
    this.$$parentForm = nullFormCtrl;

    this.$$element = $element;
    this.$$animate = $animate;

    setupValidity(this);
  }

  FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
    $rollbackViewValue: function () {
      forEach(this.$$controls, function (control) {
        control.$rollbackViewValue();
      });
    },

    /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
    $commitViewValue: function () {
      forEach(this.$$controls, function (control) {
        control.$commitViewValue();
      });
    },

    /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
    $addControl: function (control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
      assertNotHasOwnProperty(control.$name, "input");
      this.$$controls.push(control);

      if (control.$name) {
        this[control.$name] = control;
      }

      control.$$parentForm = this;
    },

    // Private API: rename a form control
    $$renameControl: function (control, newName) {
      var oldName = control.$name;

      if (this[oldName] === control) {
        delete this[oldName];
      }
      this[newName] = control;
      control.$name = newName;
    },

    /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
    $removeControl: function (control) {
      if (control.$name && this[control.$name] === control) {
        delete this[control.$name];
      }
      forEach(this.$pending, function (value, name) {
      // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      forEach(this.$error, function (value, name) {
      // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      forEach(this.$$success, function (value, name) {
      // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);

      arrayRemove(this.$$controls, control);
      control.$$parentForm = nullFormCtrl;
    },

    /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
    $setDirty: function () {
      this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
      this.$$animate.addClass(this.$$element, DIRTY_CLASS);
      this.$dirty = true;
      this.$pristine = false;
      this.$$parentForm.$setDirty();
    },

    /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
    $setPristine: function () {
      this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + " " + SUBMITTED_CLASS);
      this.$dirty = false;
      this.$pristine = true;
      this.$submitted = false;
      forEach(this.$$controls, function (control) {
        control.$setPristine();
      });
    },

    /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
    $setUntouched: function () {
      forEach(this.$$controls, function (control) {
        control.$setUntouched();
      });
    },

    /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
    $setSubmitted: function () {
      this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
      this.$submitted = true;
      this.$$parentForm.$setSubmitted();
    }
  };

  /**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */
  addSetValidityMethod({
    clazz: FormController,
    set: function (object, property, controller) {
      var list = object[property];
      if (!list) {
        object[property] = [controller];
      } else {
        var index = list.indexOf(controller);
        if (index === -1) {
          list.push(controller);
        }
      }
    },
    unset: function (object, property, controller) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, controller);
      if (list.length === 0) {
        delete object[property];
      }
    }
  });

  /**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

  /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
  var formDirectiveFactory = function (isNgForm) {
    return ["$timeout", "$parse", function ($timeout, $parse) {
      var formDirective = {
        name: "form",
        restrict: isNgForm ? "EAC" : "E",
        require: ["form", "^^?form"], // first is the form's own ctrl, second is an optional parent form
        controller: FormController,
        compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
          formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

          var nameAttr = attr.name ? "name" : (isNgForm && attr.ngForm ? "ngForm" : false);

          return {
            pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
              var controller = ctrls[0];

              // if `action` attr is not present on the form, prevent the default action (submission)
              if (!("action" in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
                var handleFormSubmission = function (event) {
                  scope.$apply(function () {
                    controller.$commitViewValue();
                    controller.$setSubmitted();
                  });

                  event.preventDefault();
                };

                formElement[0].addEventListener("submit", handleFormSubmission);

                // unregister the preventDefault listener so that we don't not leak memory but in a
                // way that will achieve the prevention of the default action.
                formElement.on("$destroy", function () {
                  $timeout(function () {
                    formElement[0].removeEventListener("submit", handleFormSubmission);
                  }, 0, false);
                });
              }

              var parentFormCtrl = ctrls[1] || controller.$$parentForm;
              parentFormCtrl.$addControl(controller);

              var setter = nameAttr ? getSetter(controller.$name) : noop;

              if (nameAttr) {
                setter(scope, controller);
                attr.$observe(nameAttr, function (newValue) {
                  if (controller.$name === newValue) return;
                  setter(scope, undefined);
                  controller.$$parentForm.$$renameControl(controller, newValue);
                  setter = getSetter(controller.$name);
                  setter(scope, controller);
                });
              }
              formElement.on("$destroy", function () {
                controller.$$parentForm.$removeControl(controller);
                setter(scope, undefined);
                extend(controller, nullFormCtrl); // stop propagating child destruction handlers upwards
              });
            }
          };
        }
      };

      return formDirective;

      function getSetter(expression) {
        if (expression === "") {
        // create an assignable expression, so forms with an empty name can be renamed later
          return $parse("this[\"\"]").assign;
        }
        return $parse(expression).assign || noop;
      }
    }];
  };

  var formDirective = formDirectiveFactory();
  var ngFormDirective = formDirectiveFactory(true);

  // helper methods
  function setupValidity(instance) {
    instance.$$classCache = {};
    instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
  }
  function addSetValidityMethod(context) {
    var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

    clazz.prototype.$setValidity = function (validationErrorKey, state, controller) {
      if (isUndefined(state)) {
        createAndSet(this, "$pending", validationErrorKey, controller);
      } else {
        unsetAndCleanup(this, "$pending", validationErrorKey, controller);
      }
      if (!isBoolean(state)) {
        unset(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      } else {
        if (state) {
          unset(this.$error, validationErrorKey, controller);
          set(this.$$success, validationErrorKey, controller);
        } else {
          set(this.$error, validationErrorKey, controller);
          unset(this.$$success, validationErrorKey, controller);
        }
      }
      if (this.$pending) {
        cachedToggleClass(this, PENDING_CLASS, true);
        this.$valid = this.$invalid = undefined;
        toggleValidationCss(this, "", null);
      } else {
        cachedToggleClass(this, PENDING_CLASS, false);
        this.$valid = isObjectEmpty(this.$error);
        this.$invalid = !this.$valid;
        toggleValidationCss(this, "", this.$valid);
      }

      // re-read the state as the set/unset methods could have
      // combined state in this.$error[validationError] (used for forms),
      // where setting/unsetting only increments/decrements the value,
      // and does not replace it.
      var combinedState;
      if (this.$pending && this.$pending[validationErrorKey]) {
        combinedState = undefined;
      } else if (this.$error[validationErrorKey]) {
        combinedState = false;
      } else if (this.$$success[validationErrorKey]) {
        combinedState = true;
      } else {
        combinedState = null;
      }

      toggleValidationCss(this, validationErrorKey, combinedState);
      this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
    };

    function createAndSet(ctrl, name, value, controller) {
      if (!ctrl[name]) {
        ctrl[name] = {};
      }
      set(ctrl[name], value, controller);
    }

    function unsetAndCleanup(ctrl, name, value, controller) {
      if (ctrl[name]) {
        unset(ctrl[name], value, controller);
      }
      if (isObjectEmpty(ctrl[name])) {
        ctrl[name] = undefined;
      }
    }

    function cachedToggleClass(ctrl, className, switchValue) {
      if (switchValue && !ctrl.$$classCache[className]) {
        ctrl.$$animate.addClass(ctrl.$$element, className);
        ctrl.$$classCache[className] = true;
      } else if (!switchValue && ctrl.$$classCache[className]) {
        ctrl.$$animate.removeClass(ctrl.$$element, className);
        ctrl.$$classCache[className] = false;
      }
    }

    function toggleValidationCss(ctrl, validationErrorKey, isValid) {
      validationErrorKey = validationErrorKey ? "-" + snake_case(validationErrorKey, "-") : "";

      cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
      cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
    }
  }

  function isObjectEmpty(obj) {
    if (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }
    }
    return true;
  }

  /* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

  // Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
  var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
  // See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
  // Note: We are being more lenient, because browsers are too.
  //   1. Scheme
  //   2. Slashes
  //   3. Username
  //   4. Password
  //   5. Hostname
  //   6. Port
  //   7. Path
  //   8. Query
  //   9. Fragment
  //                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
  var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
  // eslint-disable-next-line max-len
  var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
  var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
  var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
  var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
  var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
  var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
  var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

  var PARTIAL_VALIDATION_EVENTS = "keydown wheel mousedown";
  var PARTIAL_VALIDATION_TYPES = createMap();
  forEach("date,datetime-local,month,time,week".split(","), function (type) {
    PARTIAL_VALIDATION_TYPES[type] = true;
  });

  var inputType = {

    /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
    "text": textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    "date": createDateInputType("date", DATE_REGEXP,
      createDateParser(DATE_REGEXP, ["yyyy", "MM", "dd"]),
      "yyyy-MM-dd"),

    /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
    "datetime-local": createDateInputType("datetimelocal", DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ["yyyy", "MM", "dd", "HH", "mm", "ss", "sss"]),
      "yyyy-MM-ddTHH:mm:ss.sss"),

    /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
    "time": createDateInputType("time", TIME_REGEXP,
      createDateParser(TIME_REGEXP, ["HH", "mm", "ss", "sss"]),
      "HH:mm:ss.sss"),

    /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
    "week": createDateInputType("week", WEEK_REGEXP, weekParser, "yyyy-Www"),

    /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
    "month": createDateInputType("month", MONTH_REGEXP,
      createDateParser(MONTH_REGEXP, ["yyyy", "MM"]),
      "yyyy-MM"),

    /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   * ## Issues with HTML5 constraint validation
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
    "number": numberInputType,

    /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
    "url": urlInputType,

    /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
    "email": emailInputType,

    /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
    "radio": radioInputType,

    /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {string=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                  to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
    "range": rangeInputType,

    /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
    "checkbox": checkboxInputType,

    "hidden": noop,
    "button": noop,
    "submit": noop,
    "reset": noop,
    "file": noop
  };

  function stringBasedInputType(ctrl) {
    ctrl.$formatters.push(function (value) {
      return ctrl.$isEmpty(value) ? value : value.toString();
    });
  }

  function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);
  }

  function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    var type = lowercase(element[0].type);

    // In composition mode, users are still inputting intermediate text buffer,
    // hold the listener until composition is done.
    // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
    if (!$sniffer.android) {
      var composing = false;

      element.on("compositionstart", function () {
        composing = true;
      });

      // Support: IE9+
      element.on("compositionupdate", function (ev) {
      // End composition when ev.data is empty string on 'compositionupdate' event.
      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
      // instead of 'compositionend'.
        if (isUndefined(ev.data) || ev.data === "") {
          composing = false;
        }
      });

      element.on("compositionend", function () {
        composing = false;
        listener();
      });
    }

    var timeout;

    var listener = function (ev) {
      if (timeout) {
        $browser.defer.cancel(timeout);
        timeout = null;
      }
      if (composing) return;
      var value = element.val(),
        event = ev && ev.type;

      // By default we will trim the value
      // If the attribute ng-trim exists we will avoid trimming
      // If input type is 'password', the value is never trimmed
      if (type !== "password" && (!attr.ngTrim || attr.ngTrim !== "false")) {
        value = trim(value);
      }

      // If a control is suffering from bad input (due to native validators), browsers discard its
      // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
      // control's value is the same empty value twice in a row.
      if (ctrl.$viewValue !== value || (value === "" && ctrl.$$hasNativeValidators)) {
        ctrl.$setViewValue(value, event);
      }
    };

    // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
    // input event on backspace, delete or cut
    if ($sniffer.hasEvent("input")) {
      element.on("input", listener);
    } else {
      var deferListener = function (ev, input, origValue) {
        if (!timeout) {
          timeout = $browser.defer(function () {
            timeout = null;
            if (!input || input.value !== origValue) {
              listener(ev);
            }
          });
        }
      };

      element.on("keydown", /** @this */ function (event) {
        var key = event.keyCode;

        // ignore
        //    command            modifiers                   arrows
        if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

        deferListener(event, this, this.value);
      });

      // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
      if ($sniffer.hasEvent("paste")) {
        element.on("paste cut drop", deferListener);
      }
    }

    // if user paste into input using mouse on older browser
    // or form autocomplete on newer browser, we need "change" event to catch it
    element.on("change", listener);

    // Some native input types (date-family) have the ability to change validity without
    // firing any input/change events.
    // For these event types, when native validators are present and the browser supports the type,
    // check for validity changes on various DOM events.
    if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
      element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function (ev) {
        if (!timeout) {
          var validity = this[VALIDITY_STATE_PROPERTY];
          var origBadInput = validity.badInput;
          var origTypeMismatch = validity.typeMismatch;
          timeout = $browser.defer(function () {
            timeout = null;
            if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
              listener(ev);
            }
          });
        }
      });
    }

    ctrl.$render = function () {
    // Workaround for Firefox validation #12102.
      var value = ctrl.$isEmpty(ctrl.$viewValue) ? "" : ctrl.$viewValue;
      if (element.val() !== value) {
        element.val(value);
      }
    };
  }

  function weekParser(isoWeek, existingDate) {
    if (isDate(isoWeek)) {
      return isoWeek;
    }

    if (isString(isoWeek)) {
      WEEK_REGEXP.lastIndex = 0;
      var parts = WEEK_REGEXP.exec(isoWeek);
      if (parts) {
        var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

        if (existingDate) {
          hours = existingDate.getHours();
          minutes = existingDate.getMinutes();
          seconds = existingDate.getSeconds();
          milliseconds = existingDate.getMilliseconds();
        }

        return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
      }
    }

    return NaN;
  }

  function createDateParser(regexp, mapping) {
    return function (iso, date) {
      var parts, map;

      if (isDate(iso)) {
        return iso;
      }

      if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
        if (iso.charAt(0) === "\"" && iso.charAt(iso.length - 1) === "\"") {
          iso = iso.substring(1, iso.length - 1);
        }
        if (ISO_DATE_REGEXP.test(iso)) {
          return new Date(iso);
        }
        regexp.lastIndex = 0;
        parts = regexp.exec(iso);

        if (parts) {
          parts.shift();
          if (date) {
            map = {
              yyyy: date.getFullYear(),
              MM: date.getMonth() + 1,
              dd: date.getDate(),
              HH: date.getHours(),
              mm: date.getMinutes(),
              ss: date.getSeconds(),
              sss: date.getMilliseconds() / 1000
            };
          } else {
            map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
          }

          forEach(parts, function (part, index) {
            if (index < mapping.length) {
              map[mapping[index]] = +part;
            }
          });
          return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
        }
      }

      return NaN;
    };
  }

  function createDateInputType(type, regexp, parseDate, format) {
    return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
      badInputChecker(scope, element, attr, ctrl);
      baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
      var previousDate;
      var previousTimezone;

      ctrl.$$parserName = type;
      ctrl.$parsers.push(function (value) {
        if (ctrl.$isEmpty(value)) return null;

        if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
          return parseDateAndConvertTimeZoneToLocal(value, previousDate);
        }
        return undefined;
      });

      ctrl.$formatters.push(function (value) {
        if (value && !isDate(value)) {
          throw ngModelMinErr("datefmt", "Expected `{0}` to be a date", value);
        }
        if (isValidDate(value)) {
          previousDate = value;
          var timezone = ctrl.$options.getOption("timezone");
          if (timezone) {
            previousTimezone = timezone;
            previousDate = convertTimezoneToLocal(previousDate, timezone, true);
          }
          return $filter("date")(value, format, timezone);
        } else {
          previousDate = null;
          previousTimezone = null;
          return "";
        }
      });

      if (isDefined(attr.min) || attr.ngMin) {
        var minVal;
        ctrl.$validators.min = function (value) {
          return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
        };
        attr.$observe("min", function (val) {
          minVal = parseObservedDateValue(val);
          ctrl.$validate();
        });
      }

      if (isDefined(attr.max) || attr.ngMax) {
        var maxVal;
        ctrl.$validators.max = function (value) {
          return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
        };
        attr.$observe("max", function (val) {
          maxVal = parseObservedDateValue(val);
          ctrl.$validate();
        });
      }

      function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
        return value && !(value.getTime && value.getTime() !== value.getTime());
      }

      function parseObservedDateValue(val) {
        return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
      }

      function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
        var timezone = ctrl.$options.getOption("timezone");

        if (previousTimezone && previousTimezone !== timezone) {
        // If the timezone has changed, adjust the previousDate to the default timezone
        // so that the new date is converted with the correct timezone offset
          previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
        }

        var parsedDate = parseDate(value, previousDate);

        if (!isNaN(parsedDate) && timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
    };
  }

  function badInputChecker(scope, element, attr, ctrl) {
    var node = element[0];
    var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
    if (nativeValidation) {
      ctrl.$parsers.push(function (value) {
        var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
        return validity.badInput || validity.typeMismatch ? undefined : value;
      });
    }
  }

  function numberFormatterParser(ctrl) {
    ctrl.$$parserName = "number";
    ctrl.$parsers.push(function (value) {
      if (ctrl.$isEmpty(value)) return null;
      if (NUMBER_REGEXP.test(value)) return parseFloat(value);
      return undefined;
    });

    ctrl.$formatters.push(function (value) {
      if (!ctrl.$isEmpty(value)) {
        if (!isNumber(value)) {
          throw ngModelMinErr("numfmt", "Expected `{0}` to be a number", value);
        }
        value = value.toString();
      }
      return value;
    });
  }

  function parseNumberAttrVal(val) {
    if (isDefined(val) && !isNumber(val)) {
      val = parseFloat(val);
    }
    return !isNumberNaN(val) ? val : undefined;
  }

  function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

    // eslint-disable-next-line no-bitwise
    return (num | 0) === num;
  }

  function countDecimals(num) {
    var numString = num.toString();
    var decimalSymbolIndex = numString.indexOf(".");

    if (decimalSymbolIndex === -1) {
      if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
        var match = /e-(\d+)$/.exec(numString);

        if (match) {
          return Number(match[1]);
        }
      }

      return 0;
    }

    return numString.length - decimalSymbolIndex - 1;
  }

  function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
    var value = Number(viewValue);

    var isNonIntegerValue = !isNumberInteger(value);
    var isNonIntegerStepBase = !isNumberInteger(stepBase);
    var isNonIntegerStep = !isNumberInteger(step);

    // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
    // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
    if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
      var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
      var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
      var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

      var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
      var multiplier = Math.pow(10, decimalCount);

      value = value * multiplier;
      stepBase = stepBase * multiplier;
      step = step * multiplier;

      if (isNonIntegerValue) value = Math.round(value);
      if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
      if (isNonIntegerStep) step = Math.round(step);
    }

    return (value - stepBase) % step === 0;
  }

  function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    badInputChecker(scope, element, attr, ctrl);
    numberFormatterParser(ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var minVal;
    var maxVal;

    if (isDefined(attr.min) || attr.ngMin) {
      ctrl.$validators.min = function (value) {
        return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
      };

      attr.$observe("min", function (val) {
        minVal = parseNumberAttrVal(val);
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      ctrl.$validators.max = function (value) {
        return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
      };

      attr.$observe("max", function (val) {
        maxVal = parseNumberAttrVal(val);
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      });
    }

    if (isDefined(attr.step) || attr.ngStep) {
      var stepVal;
      ctrl.$validators.step = function (modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
             isValidForStep(viewValue, minVal || 0, stepVal);
      };

      attr.$observe("step", function (val) {
        stepVal = parseNumberAttrVal(val);
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      });
    }
  }

  function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    badInputChecker(scope, element, attr, ctrl);
    numberFormatterParser(ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var supportsRange = ctrl.$$hasNativeValidators && element[0].type === "range",
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

    var originalRender = ctrl.$render;

    ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    // Browsers that implement range will set these values automatically, but reading the adjusted values after
    // $render would cause the min / max validators to be applied with the wrong value
      function rangeRender() {
        originalRender();
        ctrl.$setViewValue(element.val());
      } :
      originalRender;

    if (hasMinAttr) {
      ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
        function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
        function minValidator(modelValue, viewValue) {
          return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
        };

      setInitialValueAndObserver("min", minChange);
    }

    if (hasMaxAttr) {
      ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
        function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
        function maxValidator(modelValue, viewValue) {
          return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
        };

      setInitialValueAndObserver("max", maxChange);
    }

    if (hasStepAttr) {
      ctrl.$validators.step = supportsRange ?
        function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
          return !validity.stepMismatch;
        } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
        function stepValidator(modelValue, viewValue) {
          return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
        };

      setInitialValueAndObserver("step", stepChange);
    }

    function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
      element.attr(htmlAttrName, attr[htmlAttrName]);
      attr.$observe(htmlAttrName, changeFn);
    }

    function minChange(val) {
      minVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      if (supportsRange) {
        var elVal = element.val();
        // IE11 doesn't set the el val correctly if the minVal is greater than the element value
        if (minVal > elVal) {
          elVal = minVal;
          element.val(elVal);
        }
        ctrl.$setViewValue(elVal);
      } else {
      // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }

    function maxChange(val) {
      maxVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      if (supportsRange) {
        var elVal = element.val();
        // IE11 doesn't set the el val correctly if the maxVal is less than the element value
        if (maxVal < elVal) {
          element.val(maxVal);
          // IE11 and Chrome don't set the value to the minVal when max < min
          elVal = maxVal < minVal ? minVal : maxVal;
        }
        ctrl.$setViewValue(elVal);
      } else {
      // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }

    function stepChange(val) {
      stepVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      // Some browsers don't adjust the input value correctly, but set the stepMismatch error
      if (supportsRange && ctrl.$viewValue !== element.val()) {
        ctrl.$setViewValue(element.val());
      } else {
      // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }
  }

  function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);

    ctrl.$$parserName = "url";
    ctrl.$validators.url = function (modelValue, viewValue) {
      var value = modelValue || viewValue;
      return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
    };
  }

  function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);

    ctrl.$$parserName = "email";
    ctrl.$validators.email = function (modelValue, viewValue) {
      var value = modelValue || viewValue;
      return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
    };
  }

  function radioInputType(scope, element, attr, ctrl) {
    var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== "false";
    // make the name unique, if not defined
    if (isUndefined(attr.name)) {
      element.attr("name", nextUid());
    }

    var listener = function (ev) {
      var value;
      if (element[0].checked) {
        value = attr.value;
        if (doTrim) {
          value = trim(value);
        }
        ctrl.$setViewValue(value, ev && ev.type);
      }
    };

    element.on("click", listener);

    ctrl.$render = function () {
      var value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      element[0].checked = (value === ctrl.$viewValue);
    };

    attr.$observe("value", ctrl.$render);
  }

  function parseConstantExpr($parse, context, name, expression, fallback) {
    var parseFn;
    if (isDefined(expression)) {
      parseFn = $parse(expression);
      if (!parseFn.constant) {
        throw ngModelMinErr("constexpr", "Expected constant expression for `{0}`, but saw " +
                                   "`{1}`.", name, expression);
      }
      return parseFn(context);
    }
    return fallback;
  }

  function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    var trueValue = parseConstantExpr($parse, scope, "ngTrueValue", attr.ngTrueValue, true);
    var falseValue = parseConstantExpr($parse, scope, "ngFalseValue", attr.ngFalseValue, false);

    var listener = function (ev) {
      ctrl.$setViewValue(element[0].checked, ev && ev.type);
    };

    element.on("click", listener);

    ctrl.$render = function () {
      element[0].checked = ctrl.$viewValue;
    };

    // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
    // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
    // it to a boolean.
    ctrl.$isEmpty = function (value) {
      return value === false;
    };

    ctrl.$formatters.push(function (value) {
      return equals(value, trueValue);
    });

    ctrl.$parsers.push(function (value) {
      return value ? trueValue : falseValue;
    });
  }

  /**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */

  /**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
  var inputDirective = ["$browser", "$sniffer", "$filter", "$parse",
    function ($browser, $sniffer, $filter, $parse) {
      return {
        restrict: "E",
        require: ["?ngModel"],
        link: {
          pre: function (scope, element, attr, ctrls) {
            if (ctrls[0]) {
              (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                $browser, $filter, $parse);
            }
          }
        }
      };
    }];

  var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
  /**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
  var ngValueDirective = function () {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
    function updateElementValue(element, attr, value) {
    // Support: IE9 only
    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
      var propValue = isDefined(value) ? value : (msie === 9) ? "" : null;
      element.prop("value", propValue);
      attr.$set("value", value);
    }

    return {
      restrict: "A",
      priority: 100,
      compile: function (tpl, tplAttr) {
        if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
          return function ngValueConstantLink(scope, elm, attr) {
            var value = scope.$eval(attr.ngValue);
            updateElementValue(elm, attr, value);
          };
        } else {
          return function ngValueLink(scope, elm, attr) {
            scope.$watch(attr.ngValue, function valueWatchAction(value) {
              updateElementValue(elm, attr, value);
            });
          };
        }
      }
    };
  };

  /**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
  var ngBindDirective = ["$compile", function ($compile) {
    return {
      restrict: "AC",
      compile: function ngBindCompile(templateElement) {
        $compile.$$addBindingClass(templateElement);
        return function ngBindLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBind);
          element = element[0];
          scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
            element.textContent = stringify(value);
          });
        };
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
  var ngBindTemplateDirective = ["$interpolate", "$compile", function ($interpolate, $compile) {
    return {
      compile: function ngBindTemplateCompile(templateElement) {
        $compile.$$addBindingClass(templateElement);
        return function ngBindTemplateLink(scope, element, attr) {
          var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
          $compile.$$addBindingInfo(element, interpolateFn.expressions);
          element = element[0];
          attr.$observe("ngBindTemplate", function (value) {
            element.textContent = isUndefined(value) ? "" : value;
          });
        };
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
  var ngBindHtmlDirective = ["$sce", "$parse", "$compile", function ($sce, $parse, $compile) {
    return {
      restrict: "A",
      compile: function ngBindHtmlCompile(tElement, tAttrs) {
        var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
        var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
          return $sce.valueOf(val);
        });
        $compile.$$addBindingClass(tElement);

        return function ngBindHtmlLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBindHtml);

          scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
            var value = ngBindHtmlGetter(scope);
            element.html($sce.getTrustedHtml(value) || "");
          });
        };
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
  var ngChangeDirective = valueFn({
    restrict: "A",
    require: "ngModel",
    link: function (scope, element, attr, ctrl) {
      ctrl.$viewChangeListeners.push(function () {
        scope.$eval(attr.ngChange);
      });
    }
  });

  /* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

  function classDirective(name, selector) {
    name = "ngClass" + name;
    var indexWatchExpression;

    return ["$parse", function ($parse) {
      return {
        restrict: "AC",
        link: function (scope, element, attr) {
          var expression = attr[name].trim();
          var isOneTime = (expression.charAt(0) === ":") && (expression.charAt(1) === ":");

          var watchInterceptor = isOneTime ? toFlatValue : toClassString;
          var watchExpression = $parse(expression, watchInterceptor);
          var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;

          var classCounts = element.data("$classCounts");
          var oldModulo = true;
          var oldClassString;

          if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
            classCounts = createMap();
            element.data("$classCounts", classCounts);
          }

          if (name !== "ngClass") {
            if (!indexWatchExpression) {
              indexWatchExpression = $parse("$index", function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
                return $index & 1;
              });
            }

            scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
          }

          scope.$watch(watchExpression, watchAction, isOneTime);

          function addClasses(classString) {
            classString = digestClassCounts(split(classString), 1);
            attr.$addClass(classString);
          }

          function removeClasses(classString) {
            classString = digestClassCounts(split(classString), -1);
            attr.$removeClass(classString);
          }

          function updateClasses(oldClassString, newClassString) {
            var oldClassArray = split(oldClassString);
            var newClassArray = split(newClassString);

            var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
            var toAddArray = arrayDifference(newClassArray, oldClassArray);

            var toRemoveString = digestClassCounts(toRemoveArray, -1);
            var toAddString = digestClassCounts(toAddArray, 1);

            attr.$addClass(toAddString);
            attr.$removeClass(toRemoveString);
          }

          function digestClassCounts(classArray, count) {
            var classesToUpdate = [];

            forEach(classArray, function (className) {
              if (count > 0 || classCounts[className]) {
                classCounts[className] = (classCounts[className] || 0) + count;
                if (classCounts[className] === +(count > 0)) {
                  classesToUpdate.push(className);
                }
              }
            });

            return classesToUpdate.join(" ");
          }

          function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClass[OneTime]WatchAction()` will update the classes.
            if (newModulo === selector) {
              addClasses(oldClassString);
            } else {
              removeClasses(oldClassString);
            }

            oldModulo = newModulo;
          }

          function ngClassOneTimeWatchAction(newClassValue) {
            var newClassString = toClassString(newClassValue);

            if (newClassString !== oldClassString) {
              ngClassWatchAction(newClassString);
            }
          }

          function ngClassWatchAction(newClassString) {
            if (oldModulo === selector) {
              updateClasses(oldClassString, newClassString);
            }

            oldClassString = newClassString;
          }
        }
      };
    }];

    // Helpers
    function arrayDifference(tokens1, tokens2) {
      if (!tokens1 || !tokens1.length) return [];
      if (!tokens2 || !tokens2.length) return tokens1;

      var values = [];

      outer:
      for (var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for (var j = 0; j < tokens2.length; j++) {
          if (token === tokens2[j]) continue outer;
        }
        values.push(token);
      }

      return values;
    }

    function split(classString) {
      return classString && classString.split(" ");
    }

    function toClassString(classValue) {
      var classString = classValue;

      if (isArray(classValue)) {
        classString = classValue.map(toClassString).join(" ");
      } else if (isObject(classValue)) {
        classString = Object.keys(classValue).
          filter(function (key) { return classValue[key]; }).
          join(" ");
      }

      return classString;
    }

    function toFlatValue(classValue) {
      var flatValue = classValue;

      if (isArray(classValue)) {
        flatValue = classValue.map(toFlatValue);
      } else if (isObject(classValue)) {
        var hasUndefined = false;

        flatValue = Object.keys(classValue).filter(function (key) {
          var value = classValue[key];

          if (!hasUndefined && isUndefined(value)) {
            hasUndefined = true;
          }

          return value;
        });

        if (hasUndefined) {
        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
        // the watcher, by including at least one `undefined` value.
          flatValue.push(undefined);
        }
      }

      return flatValue;
    }
  }

  /**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */
  var ngClassDirective = classDirective("", true);

  /**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */
  var ngClassOddDirective = classDirective("Odd", 0);

  /**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */
  var ngClassEvenDirective = classDirective("Even", 1);

  /**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
  var ngCloakDirective = ngDirective({
    compile: function (element, attr) {
      attr.$set("ngCloak", undefined);
      element.removeClass("ng-cloak");
    }
  });

  /**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (deprecated, not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
  var ngControllerDirective = [function () {
    return {
      restrict: "A",
      scope: true,
      controller: "@",
      priority: 500
    };
  }];

  /**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */

  // `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
  // we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
  // fn that looks for the `ng-csp` attribute anywhere in the current doc.

  /**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
  /*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */
  var ngEventDirectives = {};

  // For events that might fire synchronously during DOM manipulation
  // we need to execute their event handlers asynchronously using $evalAsync,
  // so that they are not executed in an inconsistent state.
  var forceAsyncEvents = {
    "blur": true,
    "focus": true
  };
  forEach(
    "click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "),
    function (eventName) {
      var directiveName = directiveNormalize("ng-" + eventName);
      ngEventDirectives[directiveName] = ["$parse", "$rootScope", function ($parse, $rootScope) {
        return {
          restrict: "A",
          compile: function ($element, attr) {
          // NOTE:
          // We expose the powerful `$event` object on the scope that provides access to the Window,
          // etc. This is OK, because expressions are not sandboxed any more (and the expression
          // sandbox was never meant to be a security feature anyway).
            var fn = $parse(attr[directiveName]);
            return function ngEventHandler(scope, element) {
              element.on(eventName, function (event) {
                var callback = function () {
                  fn(scope, { $event: event });
                };
                if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                  scope.$evalAsync(callback);
                } else {
                  scope.$apply(callback);
                }
              });
            };
          }
        };
      }];
    }
  );

  /**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

  /**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

  /**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

  /**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
  var ngIfDirective = ["$animate", "$compile", function ($animate, $compile) {
    return {
      multiElement: true,
      transclude: "element",
      priority: 600,
      terminal: true,
      restrict: "A",
      $$tlb: true,
      link: function ($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function (clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment("end ngIf", $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function (response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */

  /**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */

  /**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */

  /**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
  var ngIncludeDirective = ["$templateRequest", "$anchorScroll", "$animate",
    function ($templateRequest, $anchorScroll, $animate) {
      return {
        restrict: "ECA",
        priority: 400,
        terminal: true,
        transclude: "element",
        controller: angular.noop,
        compile: function (element, attr) {
          var srcExp = attr.ngInclude || attr.src,
            onloadExp = attr.onload || "",
            autoScrollExp = attr.autoscroll;

          return function (scope, $element, $attr, ctrl, $transclude) {
            var changeCounter = 0,
              currentScope,
              previousElement,
              currentElement;

            var cleanupLastIncludeContent = function () {
              if (previousElement) {
                previousElement.remove();
                previousElement = null;
              }
              if (currentScope) {
                currentScope.$destroy();
                currentScope = null;
              }
              if (currentElement) {
                $animate.leave(currentElement).done(function (response) {
                  if (response !== false) previousElement = null;
                });
                previousElement = currentElement;
                currentElement = null;
              }
            };

            scope.$watch(srcExp, function ngIncludeWatchAction(src) {
              var afterAnimation = function (response) {
                if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                  $anchorScroll();
                }
              };
              var thisChangeId = ++changeCounter;

              if (src) {
                // set the 2nd param to true to ignore the template request error so that the inner
                // contents and scope can be cleaned up.
                $templateRequest(src, true).then(function (response) {
                  if (scope.$$destroyed) return;

                  if (thisChangeId !== changeCounter) return;
                  var newScope = scope.$new();
                  ctrl.template = response;

                  // Note: This will also link all children of ng-include that were contained in the original
                  // html. If that content contains controllers, ... they could pollute/change the scope.
                  // However, using ng-include on an element with additional content does not make sense...
                  // Note: We can't remove them in the cloneAttchFn of $transclude as that
                  // function is called before linking the content, which would apply child
                  // directives to non existing elements.
                  var clone = $transclude(newScope, function (clone) {
                    cleanupLastIncludeContent();
                    $animate.enter(clone, null, $element).done(afterAnimation);
                  });

                  currentScope = newScope;
                  currentElement = clone;

                  currentScope.$emit("$includeContentLoaded", src);
                  scope.$eval(onloadExp);
                }, function () {
                  if (scope.$$destroyed) return;

                  if (thisChangeId === changeCounter) {
                    cleanupLastIncludeContent();
                    scope.$emit("$includeContentError", src);
                  }
                });
                scope.$emit("$includeContentRequested", src);
              } else {
                cleanupLastIncludeContent();
                ctrl.template = null;
              }
            });
          };
        }
      };
    }];

  // This directive is called during the $transclude call of the first `ngInclude` directive.
  // It will replace and compile the content of the element with the loaded template.
  // We need this directive so that the element content is already filled when
  // the link function of another directive on the same element as ngInclude
  // is called.
  var ngIncludeFillContentDirective = ["$compile",
    function ($compile) {
      return {
        restrict: "ECA",
        priority: -400,
        require: "ngInclude",
        link: function (scope, $element, $attr, ctrl) {
          if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
            $element.empty();
            $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
                $element.append(clone);
              }, { futureParentElement: $element });
            return;
          }

          $element.html(ctrl.template);
          $compile($element.contents())(scope);
        }
      };
    }];

  /**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
  var ngInitDirective = ngDirective({
    priority: 450,
    compile: function () {
      return {
        pre: function (scope, element, attrs) {
          scope.$eval(attrs.ngInit);
        }
      };
    }
  });

  /**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */
  var ngListDirective = function () {
    return {
      restrict: "A",
      priority: 100,
      require: "ngModel",
      link: function (scope, element, attr, ctrl) {
        var ngList = attr.ngList || ", ";
        var trimValues = attr.ngTrim !== "false";
        var separator = trimValues ? trim(ngList) : ngList;

        var parse = function (viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
          if (isUndefined(viewValue)) return;

          var list = [];

          if (viewValue) {
            forEach(viewValue.split(separator), function (value) {
              if (value) list.push(trimValues ? trim(value) : value);
            });
          }

          return list;
        };

        ctrl.$parsers.push(parse);
        ctrl.$formatters.push(function (value) {
          if (isArray(value)) {
            return value.join(ngList);
          }

          return undefined;
        });

        // Override the standard $isEmpty because an empty array means the input is empty.
        ctrl.$isEmpty = function (value) {
          return !value || !value.length;
        };
      }
    };
  };

  /* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/

  var VALID_CLASS = "ng-valid",
    INVALID_CLASS = "ng-invalid",
    PRISTINE_CLASS = "ng-pristine",
    DIRTY_CLASS = "ng-dirty",
    UNTOUCHED_CLASS = "ng-untouched",
    TOUCHED_CLASS = "ng-touched",
    EMPTY_CLASS = "ng-empty",
    NOT_EMPTY_CLASS = "ng-not-empty";

  var ngModelMinErr = minErr("ngModel");

  /**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
  NgModelController.$inject = ["$scope", "$exceptionHandler", "$attrs", "$element", "$parse", "$animate", "$timeout", "$q", "$interpolate"];
  function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
    this.$viewValue = Number.NaN;
    this.$modelValue = Number.NaN;
    this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
    this.$validators = {};
    this.$asyncValidators = {};
    this.$parsers = [];
    this.$formatters = [];
    this.$viewChangeListeners = [];
    this.$untouched = true;
    this.$touched = false;
    this.$pristine = true;
    this.$dirty = false;
    this.$valid = true;
    this.$invalid = false;
    this.$error = {}; // keep invalid keys here
    this.$$success = {}; // keep valid keys here
    this.$pending = undefined; // keep pending keys here
    this.$name = $interpolate($attr.name || "", false)($scope);
    this.$$parentForm = nullFormCtrl;
    this.$options = defaultModelOptions;
    this.$$updateEvents = "";
    // Attach the correct context to the event handler function for updateOn
    this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

    this.$$parsedNgModel = $parse($attr.ngModel);
    this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
    this.$$ngModelGet = this.$$parsedNgModel;
    this.$$ngModelSet = this.$$parsedNgModelAssign;
    this.$$pendingDebounce = null;
    this.$$parserValid = undefined;

    this.$$currentValidationRunId = 0;

    // https://github.com/angular/angular.js/issues/15833
    // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
    Object.defineProperty(this, "$$scope", { value: $scope });
    this.$$attr = $attr;
    this.$$element = $element;
    this.$$animate = $animate;
    this.$$timeout = $timeout;
    this.$$parse = $parse;
    this.$$q = $q;
    this.$$exceptionHandler = $exceptionHandler;

    setupValidity(this);
    setupModelWatcher(this);
  }

  NgModelController.prototype = {
    $$initGetterSetters: function () {
      if (this.$options.getOption("getterSetter")) {
        var invokeModelGetter = this.$$parse(this.$$attr.ngModel + "()"),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + "($$$p)");

        this.$$ngModelGet = function ($scope) {
          var modelValue = this.$$parsedNgModel($scope);
          if (isFunction(modelValue)) {
            modelValue = invokeModelGetter($scope);
          }
          return modelValue;
        };
        this.$$ngModelSet = function ($scope, newValue) {
          if (isFunction(this.$$parsedNgModel($scope))) {
            invokeModelSetter($scope, { $$$p: newValue });
          } else {
            this.$$parsedNgModelAssign($scope, newValue);
          }
        };
      } else if (!this.$$parsedNgModel.assign) {
        throw ngModelMinErr("nonassign", "Expression '{0}' is non-assignable. Element: {1}",
          this.$$attr.ngModel, startingTag(this.$$element));
      }
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
    $render: noop,

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
    $isEmpty: function (value) {
    // eslint-disable-next-line no-self-compare
      return isUndefined(value) || value === "" || value === null || value !== value;
    },

    $$updateEmptyClasses: function (value) {
      if (this.$isEmpty(value)) {
        this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
        this.$$animate.addClass(this.$$element, EMPTY_CLASS);
      } else {
        this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
        this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
      }
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
    $setPristine: function () {
      this.$dirty = false;
      this.$pristine = true;
      this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
      this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
    $setDirty: function () {
      this.$dirty = true;
      this.$pristine = false;
      this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
      this.$$animate.addClass(this.$$element, DIRTY_CLASS);
      this.$$parentForm.$setDirty();
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
    $setUntouched: function () {
      this.$touched = false;
      this.$untouched = true;
      this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
    $setTouched: function () {
      this.$touched = true;
      this.$untouched = false;
      this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
    $rollbackViewValue: function () {
      this.$$timeout.cancel(this.$$pendingDebounce);
      this.$viewValue = this.$$lastCommittedViewValue;
      this.$render();
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
    $validate: function () {
    // ignore $validate before model is initialized
      if (isNumberNaN(this.$modelValue)) {
        return;
      }

      var viewValue = this.$$lastCommittedViewValue;
      // Note: we use the $$rawModelValue as $modelValue might have been
      // set to undefined during a view -> model update that found validation
      // errors. We can't parse the view here, since that could change
      // the model although neither viewValue nor the model on the scope changed
      var modelValue = this.$$rawModelValue;

      var prevValid = this.$valid;
      var prevModelValue = this.$modelValue;

      var allowInvalid = this.$options.getOption("allowInvalid");

      var that = this;
      this.$$runValidators(modelValue, viewValue, function (allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
        if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
          that.$modelValue = allValid ? modelValue : undefined;

          if (that.$modelValue !== prevModelValue) {
            that.$$writeModelToScope();
          }
        }
      });
    },

    $$runValidators: function (modelValue, viewValue, doneCallback) {
      this.$$currentValidationRunId++;
      var localValidationRunId = this.$$currentValidationRunId;
      var that = this;

      // check parser error
      if (!processParseErrors()) {
        validationDone(false);
        return;
      }
      if (!processSyncValidators()) {
        validationDone(false);
        return;
      }
      processAsyncValidators();

      function processParseErrors() {
        var errorKey = that.$$parserName || "parse";
        if (isUndefined(that.$$parserValid)) {
          setValidity(errorKey, null);
        } else {
          if (!that.$$parserValid) {
            forEach(that.$validators, function (v, name) {
              setValidity(name, null);
            });
            forEach(that.$asyncValidators, function (v, name) {
              setValidity(name, null);
            });
          }
          // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
          setValidity(errorKey, that.$$parserValid);
          return that.$$parserValid;
        }
        return true;
      }

      function processSyncValidators() {
        var syncValidatorsValid = true;
        forEach(that.$validators, function (validator, name) {
          var result = Boolean(validator(modelValue, viewValue));
          syncValidatorsValid = syncValidatorsValid && result;
          setValidity(name, result);
        });
        if (!syncValidatorsValid) {
          forEach(that.$asyncValidators, function (v, name) {
            setValidity(name, null);
          });
          return false;
        }
        return true;
      }

      function processAsyncValidators() {
        var validatorPromises = [];
        var allValid = true;
        forEach(that.$asyncValidators, function (validator, name) {
          var promise = validator(modelValue, viewValue);
          if (!isPromiseLike(promise)) {
            throw ngModelMinErr("nopromise",
              "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
          }
          setValidity(name, undefined);
          validatorPromises.push(promise.then(function () {
            setValidity(name, true);
          }, function () {
            allValid = false;
            setValidity(name, false);
          }));
        });
        if (!validatorPromises.length) {
          validationDone(true);
        } else {
          that.$$q.all(validatorPromises).then(function () {
            validationDone(allValid);
          }, noop);
        }
      }

      function setValidity(name, isValid) {
        if (localValidationRunId === that.$$currentValidationRunId) {
          that.$setValidity(name, isValid);
        }
      }

      function validationDone(allValid) {
        if (localValidationRunId === that.$$currentValidationRunId) {

          doneCallback(allValid);
        }
      }
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
    $commitViewValue: function () {
      var viewValue = this.$viewValue;

      this.$$timeout.cancel(this.$$pendingDebounce);

      // If the view value has not changed then we should just exit, except in the case where there is
      // a native validator on the element. In this case the validation state may have changed even though
      // the viewValue has stayed empty.
      if (this.$$lastCommittedViewValue === viewValue && (viewValue !== "" || !this.$$hasNativeValidators)) {
        return;
      }
      this.$$updateEmptyClasses(viewValue);
      this.$$lastCommittedViewValue = viewValue;

      // change to dirty
      if (this.$pristine) {
        this.$setDirty();
      }
      this.$$parseAndValidate();
    },

    $$parseAndValidate: function () {
      var viewValue = this.$$lastCommittedViewValue;
      var modelValue = viewValue;
      var that = this;

      this.$$parserValid = isUndefined(modelValue) ? undefined : true;

      if (this.$$parserValid) {
        for (var i = 0; i < this.$parsers.length; i++) {
          modelValue = this.$parsers[i](modelValue);
          if (isUndefined(modelValue)) {
            this.$$parserValid = false;
            break;
          }
        }
      }
      if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
        this.$modelValue = this.$$ngModelGet(this.$$scope);
      }
      var prevModelValue = this.$modelValue;
      var allowInvalid = this.$options.getOption("allowInvalid");
      this.$$rawModelValue = modelValue;

      if (allowInvalid) {
        this.$modelValue = modelValue;
        writeToModelIfNeeded();
      }

      // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
      // This can happen if e.g. $setViewValue is called from inside a parser
      this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function (allValid) {
        if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
          that.$modelValue = allValid ? modelValue : undefined;
          writeToModelIfNeeded();
        }
      });

      function writeToModelIfNeeded() {
        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    },

    $$writeModelToScope: function () {
      this.$$ngModelSet(this.$$scope, this.$modelValue);
      forEach(this.$viewChangeListeners, function (listener) {
        try {
          listener();
        } catch (e) {
        // eslint-disable-next-line no-invalid-this
          this.$$exceptionHandler(e);
        }
      }, this);
    },

    /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
    $setViewValue: function (value, trigger) {
      this.$viewValue = value;
      if (this.$options.getOption("updateOnDefault")) {
        this.$$debounceViewValueCommit(trigger);
      }
    },

    $$debounceViewValueCommit: function (trigger) {
      var debounceDelay = this.$options.getOption("debounce");

      if (isNumber(debounceDelay[trigger])) {
        debounceDelay = debounceDelay[trigger];
      } else if (isNumber(debounceDelay["default"])) {
        debounceDelay = debounceDelay["default"];
      }

      this.$$timeout.cancel(this.$$pendingDebounce);
      var that = this;
      if (debounceDelay > 0) { // this fails if debounceDelay is an object
        this.$$pendingDebounce = this.$$timeout(function () {
          that.$commitViewValue();
        }, debounceDelay);
      } else if (this.$$scope.$root.$$phase) {
        this.$commitViewValue();
      } else {
        this.$$scope.$apply(function () {
          that.$commitViewValue();
        });
      }
    },

    /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */
    $overrideModelOptions: function (options) {
      this.$options = this.$options.createChild(options);
      this.$$setUpdateOnEvents();
    },

    /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */
    $processModelValue: function () {
      var viewValue = this.$$format();

      if (this.$viewValue !== viewValue) {
        this.$$updateEmptyClasses(viewValue);
        this.$viewValue = this.$$lastCommittedViewValue = viewValue;
        this.$render();
        // It is possible that model and view value have been updated during render
        this.$$runValidators(this.$modelValue, this.$viewValue, noop);
      }
    },

    /**
   * This method is called internally to run the $formatters on the $modelValue
   */
    $$format: function () {
      var formatters = this.$formatters,
        idx = formatters.length;

      var viewValue = this.$modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }

      return viewValue;
    },

    /**
   * This method is called internally when the bound scope value changes.
   */
    $$setModelValue: function (modelValue) {
      this.$modelValue = this.$$rawModelValue = modelValue;
      this.$$parserValid = undefined;
      this.$processModelValue();
    },

    $$setUpdateOnEvents: function () {
      if (this.$$updateEvents) {
        this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
      }

      this.$$updateEvents = this.$options.getOption("updateOn");
      if (this.$$updateEvents) {
        this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
      }
    },

    $$updateEventHandler: function (ev) {
      this.$$debounceViewValueCommit(ev && ev.type);
    }
  };

  function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
    ctrl.$$scope.$watch(function ngModelWatch(scope) {
      var modelValue = ctrl.$$ngModelGet(scope);

      // if scope model value and ngModel value are out of sync
      // This cannot be moved to the action function, because it would not catch the
      // case where the model is changed in the ngChange function or the model setter
      if (modelValue !== ctrl.$modelValue &&
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
      ) {
        ctrl.$$setModelValue(modelValue);
      }

      return modelValue;
    });
  }

  /**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
  addSetValidityMethod({
    clazz: NgModelController,
    set: function (object, property) {
      object[property] = true;
    },
    unset: function (object, property) {
      delete object[property];
    }
  });

  /**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
  var ngModelDirective = ["$rootScope", function ($rootScope) {
    return {
      restrict: "A",
      require: ["ngModel", "^?form", "^?ngModelOptions"],
      controller: NgModelController,
      // Prelink needs to run before any input directive
      // so that we can set the NgModelOptions in NgModelController
      // before anyone else uses it.
      priority: 1,
      compile: function ngModelCompile(element) {
      // Setup initial state of the control
        element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

        return {
          pre: function ngModelPreLink(scope, element, attr, ctrls) {
            var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

            if (optionsCtrl) {
              modelCtrl.$options = optionsCtrl.$options;
            }

            modelCtrl.$$initGetterSetters();

            // notify others, especially parent forms
            formCtrl.$addControl(modelCtrl);

            attr.$observe("name", function (newValue) {
              if (modelCtrl.$name !== newValue) {
                modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
              }
            });

            scope.$on("$destroy", function () {
              modelCtrl.$$parentForm.$removeControl(modelCtrl);
            });
          },
          post: function ngModelPostLink(scope, element, attr, ctrls) {
            var modelCtrl = ctrls[0];
            modelCtrl.$$setUpdateOnEvents();

            function setTouched() {
              modelCtrl.$setTouched();
            }

            element.on("blur", function () {
              if (modelCtrl.$touched) return;

              if ($rootScope.$$phase) {
                scope.$evalAsync(setTouched);
              } else {
                scope.$apply(setTouched);
              }
            });
          }
        };
      }
    };
  }];

  /* exported defaultModelOptions */
  var defaultModelOptions;
  var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

  /**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
  function ModelOptions(options) {
    this.$$options = options;
  }

  ModelOptions.prototype = {

    /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
    getOption: function (name) {
      return this.$$options[name];
    },

    /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
    createChild: function (options) {
      var inheritAll = false;

      // make a shallow copy
      options = extend({}, options);

      // Inherit options from the parent if specified by the value `"$inherit"`
      forEach(options, /* @this */ function (option, key) {
        if (option === "$inherit") {
          if (key === "*") {
            inheritAll = true;
          } else {
            options[key] = this.$$options[key];
            // `updateOn` is special so we must also inherit the `updateOnDefault` option
            if (key === "updateOn") {
              options.updateOnDefault = this.$$options.updateOnDefault;
            }
          }
        } else {
          if (key === "updateOn") {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
            options.updateOnDefault = false;
            options[key] = trim(option.replace(DEFAULT_REGEXP, function () {
              options.updateOnDefault = true;
              return " ";
            }));
          }
        }
      }, this);

      if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
        delete options["*"];
        defaults(options, this.$$options);
      }

      // Finally add in any missing defaults
      defaults(options, defaultModelOptions.$$options);

      return new ModelOptions(options);
    }
  };

  defaultModelOptions = new ModelOptions({
    updateOn: "",
    updateOnDefault: true,
    debounce: 0,
    getterSetter: false,
    allowInvalid: false,
    timezone: null
  });

  /**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 *
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents. Valid keys are:
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur click',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *
 *     "default" also applies to all events that are listed in `updateOn` but are not
 *     listed in `debounce`, i.e. "click" would also be debounced by 500 milliseconds.
 *
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 */
  var ngModelOptionsDirective = function () {
    NgModelOptionsController.$inject = ["$attrs", "$scope"];
    function NgModelOptionsController($attrs, $scope) {
      this.$$attrs = $attrs;
      this.$$scope = $scope;
    }
    NgModelOptionsController.prototype = {
      $onInit: function () {
        var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
        var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

        this.$options = parentOptions.createChild(modelOptionsDefinition);
      }
    };

    return {
      restrict: "A",
      // ngModelOptions needs to run before ngModel and input directives
      priority: 10,
      require: { parentCtrl: "?^^ngModelOptions" },
      bindToController: true,
      controller: NgModelOptionsController
    };
  };

  // shallow copy over values from `src` that are not already specified on `dst`
  function defaults(dst, src) {
    forEach(src, function (value, key) {
      if (!isDefined(dst[key])) {
        dst[key] = value;
      }
    });
  }

  /**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */
  var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

  /* exported ngOptionsDirective */

  /* global jqLiteRemove */

  var ngOptionsMinErr = minErr("ngOptions");

  /**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>

          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

  /* eslint-disable max-len */
  //                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
  // 1: value expression (valueFn)
  // 2: label expression (displayFn)
  // 3: group by expression (groupByFn)
  // 4: disable when expression (disableWhenFn)
  // 5: array item variable name
  // 6: object item key variable name
  // 7: object item value variable name
  // 8: collection expression
  // 9: track by expression
  /* eslint-enable */

  var ngOptionsDirective = ["$compile", "$document", "$parse", function ($compile, $document, $parse) {

    function parseOptionsExpression(optionsExp, selectElement, scope) {

      var match = optionsExp.match(NG_OPTIONS_REGEXP);
      if (!(match)) {
        throw ngOptionsMinErr("iexp",
          "Expected expression in form of " +
        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
        " but got '{0}'. Element: {1}",
          optionsExp, startingTag(selectElement));
      }

      // Extract the parts from the ngOptions expression

      // The variable name for the value of the item in the collection
      var valueName = match[5] || match[7];
      // The variable name for the key of the item in the collection
      var keyName = match[6];

      // An expression that generates the viewValue for an option if there is a label expression
      var selectAs = / as /.test(match[0]) && match[1];
      // An expression that is used to track the id of each object in the options collection
      var trackBy = match[9];
      // An expression that generates the viewValue for an option if there is no label expression
      var valueFn = $parse(match[2] ? match[1] : valueName);
      var selectAsFn = selectAs && $parse(selectAs);
      var viewValueFn = selectAsFn || valueFn;
      var trackByFn = trackBy && $parse(trackBy);

      // Get the value by which we are going to track the option
      // if we have a trackFn then use that (passing scope and locals)
      // otherwise just hash the given viewValue
      var getTrackByValueFn = trackBy ?
        function (value, locals) { return trackByFn(scope, locals); } :
        function getHashOfValue(value) { return hashKey(value); };
      var getTrackByValue = function (value, key) {
        return getTrackByValueFn(value, getLocals(value, key));
      };

      var displayFn = $parse(match[2] || match[1]);
      var groupByFn = $parse(match[3] || "");
      var disableWhenFn = $parse(match[4] || "");
      var valuesFn = $parse(match[8]);

      var locals = {};
      var getLocals = keyName ? function (value, key) {
        locals[keyName] = key;
        locals[valueName] = value;
        return locals;
      } : function (value) {
        locals[valueName] = value;
        return locals;
      };

      function Option(selectValue, viewValue, label, group, disabled) {
        this.selectValue = selectValue;
        this.viewValue = viewValue;
        this.label = label;
        this.group = group;
        this.disabled = disabled;
      }

      function getOptionValuesKeys(optionValues) {
        var optionValuesKeys;

        if (!keyName && isArrayLike(optionValues)) {
          optionValuesKeys = optionValues;
        } else {
        // if object, extract keys, in enumeration order, unsorted
          optionValuesKeys = [];
          for (var itemKey in optionValues) {
            if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== "$") {
              optionValuesKeys.push(itemKey);
            }
          }
        }
        return optionValuesKeys;
      }

      return {
        trackBy: trackBy,
        getTrackByValue: getTrackByValue,
        getWatchables: $parse(valuesFn, function (optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
          var watchedArray = [];
          optionValues = optionValues || [];

          var optionValuesKeys = getOptionValuesKeys(optionValues);
          var optionValuesLength = optionValuesKeys.length;
          for (var index = 0; index < optionValuesLength; index++) {
            var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
            var value = optionValues[key];

            var locals = getLocals(value, key);
            var selectValue = getTrackByValueFn(value, locals);
            watchedArray.push(selectValue);

            // Only need to watch the displayFn if there is a specific label expression
            if (match[2] || match[1]) {
              var label = displayFn(scope, locals);
              watchedArray.push(label);
            }

            // Only need to watch the disableWhenFn if there is a specific disable expression
            if (match[4]) {
              var disableWhen = disableWhenFn(scope, locals);
              watchedArray.push(disableWhen);
            }
          }
          return watchedArray;
        }),

        getOptions: function () {

          var optionItems = [];
          var selectValueMap = {};

          // The option values were already computed in the `getWatchables` fn,
          // which must have been called to trigger `getOptions`
          var optionValues = valuesFn(scope) || [];
          var optionValuesKeys = getOptionValuesKeys(optionValues);
          var optionValuesLength = optionValuesKeys.length;

          for (var index = 0; index < optionValuesLength; index++) {
            var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
            var value = optionValues[key];
            var locals = getLocals(value, key);
            var viewValue = viewValueFn(scope, locals);
            var selectValue = getTrackByValueFn(viewValue, locals);
            var label = displayFn(scope, locals);
            var group = groupByFn(scope, locals);
            var disabled = disableWhenFn(scope, locals);
            var optionItem = new Option(selectValue, viewValue, label, group, disabled);

            optionItems.push(optionItem);
            selectValueMap[selectValue] = optionItem;
          }

          return {
            items: optionItems,
            selectValueMap: selectValueMap,
            getOptionFromViewValue: function (value) {
              return selectValueMap[getTrackByValue(value)];
            },
            getViewValueFromOption: function (option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
              return trackBy ? copy(option.viewValue) : option.viewValue;
            }
          };
        }
      };
    }

    // Support: IE 9 only
    // We can't just jqLite('<option>') since jqLite is not smart enough
    // to create it in <select> and IE barfs otherwise.
    var optionTemplate = window.document.createElement("option"),
      optGroupTemplate = window.document.createElement("optgroup");

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === "") {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val("?");

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function (val) {
        return "?";
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute("selected");

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute("selected", "selected");
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function () { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function () { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function (option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };

        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
            selections = [];

          forEach(selectedValues, function (value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function () {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function (value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function () {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function (optionScope, optionEl) {
            if (optionEl.val() === "") {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass("ng-scope");
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on("$destroy", function () {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass("ng-scope");
        }

      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? "null" : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
    }

    return {
      restrict: "A",
      terminal: true,
      require: ["select", "ngModel"],
      link: {
        pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
          ctrls[0].registerOption = noop;
        },
        post: ngOptionsPostLink
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
  var ngPluralizeDirective = ["$locale", "$interpolate", "$log", function ($locale, $interpolate, $log) {
    var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

    return {
      link: function (scope, element, attr) {
        var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + "-" + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

        forEach(attr, function (expression, attributeName) {
          var tmpMatch = IS_WHEN.exec(attributeName);
          if (tmpMatch) {
            var whenKey = (tmpMatch[1] ? "-" : "") + lowercase(tmpMatch[2]);
            whens[whenKey] = element.attr(attr.$attr[attributeName]);
          }
        });
        forEach(whens, function (expression, key) {
          whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

        });

        scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
          var count = parseFloat(newVal);
          var countIsNaN = isNumberNaN(count);

          if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
            count = $locale.pluralCat(count - offset);
          }

          // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
          // In JS `NaN !== NaN`, so we have to explicitly check.
          if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
            watchRemover();
            var whenExpFn = whensExpFns[count];
            if (isUndefined(whenExpFn)) {
              if (newVal != null) {
                $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
              }
              watchRemover = noop;
              updateElementText();
            } else {
              watchRemover = scope.$watch(whenExpFn, updateElementText);
            }
            lastCount = count;
          }
        });

        function updateElementText(newText) {
          element.text(newText || "");
        }
      }
    };
  }];

  /* exported ngRepeatDirective */

  /**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
  var ngRepeatDirective = ["$parse", "$animate", "$compile", function ($parse, $animate, $compile) {
    var NG_REMOVED = "$$NG_REMOVED";
    var ngRepeatMinErr = minErr("ngRepeat");

    var updateScope = function (scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
      scope[valueIdentifier] = value;
      if (keyIdentifier) scope[keyIdentifier] = key;
      scope.$index = index;
      scope.$first = (index === 0);
      scope.$last = (index === (arrayLength - 1));
      scope.$middle = !(scope.$first || scope.$last);
      // eslint-disable-next-line no-bitwise
      scope.$odd = !(scope.$even = (index & 1) === 0);
    };

    var getBlockStart = function (block) {
      return block.clone[0];
    };

    var getBlockEnd = function (block) {
      return block.clone[block.clone.length - 1];
    };

    return {
      restrict: "A",
      multiElement: true,
      transclude: "element",
      priority: 1000,
      terminal: true,
      $$tlb: true,
      compile: function ngRepeatCompile($element, $attr) {
        var expression = $attr.ngRepeat;
        var ngRepeatEndComment = $compile.$$createComment("end ngRepeat", expression);

        var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

        if (!match) {
          throw ngRepeatMinErr("iexp", "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            expression);
        }

        var lhs = match[1];
        var rhs = match[2];
        var aliasAs = match[3];
        var trackByExp = match[4];

        match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

        if (!match) {
          throw ngRepeatMinErr("iidexp", "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            lhs);
        }
        var valueIdentifier = match[3] || match[1];
        var keyIdentifier = match[2];

        if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
          throw ngRepeatMinErr("badident", "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
            aliasAs);
        }

        var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
        var hashFnLocals = { $id: hashKey };

        if (trackByExp) {
          trackByExpGetter = $parse(trackByExp);
        } else {
          trackByIdArrayFn = function (key, value) {
            return hashKey(value);
          };
          trackByIdObjFn = function (key) {
            return key;
          };
        }

        return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

          if (trackByExpGetter) {
            trackByIdExpFn = function (key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
              if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
              hashFnLocals[valueIdentifier] = value;
              hashFnLocals.$index = index;
              return trackByExpGetter($scope, hashFnLocals);
            };
          }

          // Store a list of elements from previous run. This is a hash where key is the item from the
          // iterator, and the value is objects with following properties.
          //   - scope: bound scope
          //   - clone: previous element.
          //   - index: position
          //
          // We are using no-proto object so that we don't need to guard against inherited props via
          // hasOwnProperty.
          var lastBlockMap = createMap();

          // watch props
          $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
            var index, length,
              previousNode = $element[0], // node that cloned nodes should be inserted after
              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block, // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

            if (aliasAs) {
              $scope[aliasAs] = collection;
            }

            if (isArrayLike(collection)) {
              collectionKeys = collection;
              trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
            } else {
              trackByIdFn = trackByIdExpFn || trackByIdObjFn;
              // if object, extract keys, in enumeration order, unsorted
              collectionKeys = [];
              for (var itemKey in collection) {
                if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== "$") {
                  collectionKeys.push(itemKey);
                }
              }
            }

            collectionLength = collectionKeys.length;
            nextBlockOrder = new Array(collectionLength);

            // locate existing items
            for (index = 0; index < collectionLength; index++) {
              key = (collection === collectionKeys) ? index : collectionKeys[index];
              value = collection[key];
              trackById = trackByIdFn(key, value, index);
              if (lastBlockMap[trackById]) {
              // found previously seen block
                block = lastBlockMap[trackById];
                delete lastBlockMap[trackById];
                nextBlockMap[trackById] = block;
                nextBlockOrder[index] = block;
              } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
                forEach(nextBlockOrder, function (block) {
                  if (block && block.scope) lastBlockMap[block.id] = block;
                });
                throw ngRepeatMinErr("dupes",
                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
                  expression, trackById, value);
              } else {
              // new never before seen block
                nextBlockOrder[index] = { id: trackById, scope: undefined, clone: undefined };
                nextBlockMap[trackById] = true;
              }
            }

            // remove leftover items
            for (var blockKey in lastBlockMap) {
              block = lastBlockMap[blockKey];
              elementsToRemove = getBlockNodes(block.clone);
              $animate.leave(elementsToRemove);
              if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
                for (index = 0, length = elementsToRemove.length; index < length; index++) {
                  elementsToRemove[index][NG_REMOVED] = true;
                }
              }
              block.scope.$destroy();
            }

            // we are not using forEach for perf reasons (trying to avoid #call)
            for (index = 0; index < collectionLength; index++) {
              key = (collection === collectionKeys) ? index : collectionKeys[index];
              value = collection[key];
              block = nextBlockOrder[index];

              if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

                nextNode = previousNode;

                // skip nodes that are already pending removal via leave animation
                do {
                  nextNode = nextNode.nextSibling;
                } while (nextNode && nextNode[NG_REMOVED]);

                if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                  $animate.move(getBlockNodes(block.clone), null, previousNode);
                }
                previousNode = getBlockEnd(block);
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              } else {
              // new item which we don't know about
                $transclude(function ngRepeatTransclude(clone, scope) {
                  block.scope = scope;
                  // http://jsperf.com/clone-vs-createcomment
                  var endNode = ngRepeatEndComment.cloneNode(false);
                  clone[clone.length++] = endNode;

                  $animate.enter(clone, null, previousNode);
                  previousNode = endNode;
                  // Note: We only need the first/last node of the cloned nodes.
                  // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                  // by a directive with templateUrl when its template arrives.
                  block.clone = clone;
                  nextBlockMap[block.id] = block;
                  updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                });
              }
            }
            lastBlockMap = nextBlockMap;
          });
        };
      }
    };
  }];

  var NG_HIDE_CLASS = "ng-hide";
  var NG_HIDE_IN_PROGRESS_CLASS = "ng-hide-animate";
  /**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
  var ngShowDirective = ["$animate", function ($animate) {
    return {
      restrict: "A",
      multiElement: true,
      link: function (scope, element, attr) {
        scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
          $animate[value ? "removeClass" : "addClass"](element, NG_HIDE_CLASS, {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
          });
        });
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
  var ngHideDirective = ["$animate", function ($animate) {
    return {
      restrict: "A",
      multiElement: true,
      link: function (scope, element, attr) {
        scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
          $animate[value ? "addClass" : "removeClass"](element, NG_HIDE_CLASS, {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
          });
        });
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
  var ngStyleDirective = ngDirective(function (scope, element, attr) {
    scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
      if (oldStyles && (newStyles !== oldStyles)) {
        forEach(oldStyles, function (val, style) { element.css(style, "");});
      }
      if (newStyles) element.css(newStyles);
    }, true);
  });

  /**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
  var ngSwitchDirective = ["$animate", "$compile", function ($animate, $compile) {
    return {
      require: "ngSwitch",

      // asks for $scope to fool the BC controller module
      controller: ["$scope", function NgSwitchController() {
        this.cases = {};
      }],
      link: function (scope, element, attr, ngSwitchController) {
        var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

        var spliceFactory = function (array, index) {
          return function (response) {
            if (response !== false) array.splice(index, 1);
          };
        };

        scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
          var i, ii;

          // Start with the last, in case the array is modified during the loop
          while (previousLeaveAnimations.length) {
            $animate.cancel(previousLeaveAnimations.pop());
          }

          for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
            var selected = getBlockNodes(selectedElements[i].clone);
            selectedScopes[i].$destroy();
            var runner = previousLeaveAnimations[i] = $animate.leave(selected);
            runner.done(spliceFactory(previousLeaveAnimations, i));
          }

          selectedElements.length = 0;
          selectedScopes.length = 0;

          if ((selectedTranscludes = ngSwitchController.cases["!" + value] || ngSwitchController.cases["?"])) {
            forEach(selectedTranscludes, function (selectedTransclude) {
              selectedTransclude.transclude(function (caseElement, selectedScope) {
                selectedScopes.push(selectedScope);
                var anchor = selectedTransclude.element;
                caseElement[caseElement.length++] = $compile.$$createComment("end ngSwitchWhen");
                var block = { clone: caseElement };

                selectedElements.push(block);
                $animate.enter(caseElement, anchor.parent(), anchor);
              });
            });
          }
        });
      }
    };
  }];

  var ngSwitchWhenDirective = ngDirective({
    transclude: "element",
    priority: 1200,
    require: "^ngSwitch",
    multiElement: true,
    link: function (scope, element, attrs, ctrl, $transclude) {

      var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
        function (element, index, array) { return array[index - 1] !== element; }
      );

      forEach(cases, function (whenCase) {
        ctrl.cases["!" + whenCase] = (ctrl.cases["!" + whenCase] || []);
        ctrl.cases["!" + whenCase].push({ transclude: $transclude, element: element });
      });
    }
  });

  var ngSwitchDefaultDirective = ngDirective({
    transclude: "element",
    priority: 1200,
    require: "^ngSwitch",
    multiElement: true,
    link: function (scope, element, attr, ctrl, $transclude) {
      ctrl.cases["?"] = (ctrl.cases["?"] || []);
      ctrl.cases["?"].push({ transclude: $transclude, element: element });
    }
  });

  /**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
  var ngTranscludeMinErr = minErr("ngTransclude");
  var ngTranscludeDirective = ["$compile", function ($compile) {
    return {
      restrict: "EAC",
      compile: function ngTranscludeCompile(tElement) {

        // Remove and cache any original content to act as a fallback
        var fallbackLinkFn = $compile(tElement.contents());
        tElement.empty();

        return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

          if (!$transclude) {
            throw ngTranscludeMinErr("orphan",
              "Illegal use of ngTransclude directive in the template! " +
          "No parent directive that requires a transclusion found. " +
          "Element: {0}",
              startingTag($element));
          }

          // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
          if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
            $attrs.ngTransclude = "";
          }
          var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

          // If the slot is required and no transclusion content is provided then this call will throw an error
          $transclude(ngTranscludeCloneAttachFn, null, slotName);

          // If the slot is optional and no transclusion content is provided then use the fallback content
          if (slotName && !$transclude.isSlotFilled(slotName)) {
            useFallbackContent();
          }

          function ngTranscludeCloneAttachFn(clone, transcludedScope) {
            if (clone.length && notWhitespace(clone)) {
              $element.append(clone);
            } else {
              useFallbackContent();
              // There is nothing linked against the transcluded scope since no content was available,
              // so it should be safe to clean up the generated scope.
              transcludedScope.$destroy();
            }
          }

          function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
            fallbackLinkFn($scope, function (clone) {
              $element.append(clone);
            });
          }

          function notWhitespace(nodes) {
            for (var i = 0, ii = nodes.length; i < ii; i++) {
              var node = nodes[i];
              if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
                return true;
              }
            }
          }
        };
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
  var scriptDirective = ["$templateCache", function ($templateCache) {
    return {
      restrict: "E",
      terminal: true,
      compile: function (element, attr) {
        if (attr.type === "text/ng-template") {
          var templateUrl = attr.id,
            text = element[0].text;

          $templateCache.put(templateUrl, text);
        }
      }
    };
  }];

  /* exported selectDirective, optionDirective */

  var noopNgModelController = { $setViewValue: noop, $render: noop };

  function setOptionSelectedStatus(optionEl, value) {
    optionEl.prop("selected", value);
    /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */
    optionEl.attr("selected", value);
  }

  /**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */
  var SelectController =
        ["$element", "$scope", /** @this */ function ($element, $scope) {

          var self = this,
            optionsMap = new NgMap();

          self.selectValueMap = {}; // Keys are the hashed values, values the original values

          // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
          self.ngModelCtrl = noopNgModelController;
          self.multiple = false;

          // The "unknown" option is one that is prepended to the list if the viewValue
          // does not match any of the options. When it is rendered the value of the unknown
          // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
          //
          // Support: IE 9 only
          // We can't just jqLite('<option>') since jqLite is not smart enough
          // to create it in <select> and IE barfs otherwise.
          self.unknownOption = jqLite(window.document.createElement("option"));

          // The empty option is an option with the value '' that the application developer can
          // provide inside the select. It is always selectable and indicates that a "null" selection has
          // been made by the user.
          // If the select has an empty option, and the model of the select is set to "undefined" or "null",
          // the empty option is selected.
          // If the model is set to a different unmatched value, the unknown option is rendered and
          // selected, i.e both are present, because a "null" selection and an unknown value are different.
          self.hasEmptyOption = false;
          self.emptyOption = undefined;

          self.renderUnknownOption = function (val) {
            var unknownVal = self.generateUnknownOptionValue(val);
            self.unknownOption.val(unknownVal);
            $element.prepend(self.unknownOption);
            setOptionSelectedStatus(self.unknownOption, true);
            $element.val(unknownVal);
          };

          self.updateUnknownOption = function (val) {
            var unknownVal = self.generateUnknownOptionValue(val);
            self.unknownOption.val(unknownVal);
            setOptionSelectedStatus(self.unknownOption, true);
            $element.val(unknownVal);
          };

          self.generateUnknownOptionValue = function (val) {
            return "? " + hashKey(val) + " ?";
          };

          self.removeUnknownOption = function () {
            if (self.unknownOption.parent()) self.unknownOption.remove();
          };

          self.selectEmptyOption = function () {
            if (self.emptyOption) {
              $element.val("");
              setOptionSelectedStatus(self.emptyOption, true);
            }
          };

          self.unselectEmptyOption = function () {
            if (self.hasEmptyOption) {
              setOptionSelectedStatus(self.emptyOption, false);
            }
          };

          $scope.$on("$destroy", function () {
            // disable unknown option so that we don't do work when the whole select is being destroyed
            self.renderUnknownOption = noop;
          });

          // Read the value of the select control, the implementation of this changes depending
          // upon whether the select can have multiple values and whether ngOptions is at work.
          self.readValue = function readSingleValue() {
            var val = $element.val();
            // ngValue added option values are stored in the selectValueMap, normal interpolations are not
            var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

            if (self.hasOption(realVal)) {
              return realVal;
            }

            return null;
          };

          // Write the value to the select control, the implementation of this changes depending
          // upon whether the select can have multiple values and whether ngOptions is at work.
          self.writeValue = function writeSingleValue(value) {
            // Make sure to remove the selected attribute from the previously selected option
            // Otherwise, screen readers might get confused
            var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
            if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

            if (self.hasOption(value)) {
              self.removeUnknownOption();

              var hashedVal = hashKey(value);
              $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

              // Set selected attribute and property on selected option for screen readers
              var selectedOption = $element[0].options[$element[0].selectedIndex];
              setOptionSelectedStatus(jqLite(selectedOption), true);
            } else {
              self.selectUnknownOrEmptyOption(value);
            }
          };

          // Tell the select control that an option, with the given value, has been added
          self.addOption = function (value, element) {
            // Skip comment nodes, as they only pollute the `optionsMap`
            if (element[0].nodeType === NODE_TYPE_COMMENT) return;

            assertNotHasOwnProperty(value, "\"option value\"");
            if (value === "") {
              self.hasEmptyOption = true;
              self.emptyOption = element;
            }
            var count = optionsMap.get(value) || 0;
            optionsMap.set(value, count + 1);
            // Only render at the end of a digest. This improves render performance when many options
            // are added during a digest and ensures all relevant options are correctly marked as selected
            scheduleRender();
          };

          // Tell the select control that an option, with the given value, has been removed
          self.removeOption = function (value) {
            var count = optionsMap.get(value);
            if (count) {
              if (count === 1) {
                optionsMap.delete(value);
                if (value === "") {
                  self.hasEmptyOption = false;
                  self.emptyOption = undefined;
                }
              } else {
                optionsMap.set(value, count - 1);
              }
            }
          };

          // Check whether the select control has an option matching the given value
          self.hasOption = function (value) {
            return !!optionsMap.get(value);
          };

          /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */
          self.$hasEmptyOption = function () {
            return self.hasEmptyOption;
          };

          /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */
          self.$isUnknownOptionSelected = function () {
            // Presence of the unknown option means it is selected
            return $element[0].options[0] === self.unknownOption[0];
          };

          /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */
          self.$isEmptyOptionSelected = function () {
            return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
          };

          self.selectUnknownOrEmptyOption = function (value) {
            if (value == null && self.emptyOption) {
              self.removeUnknownOption();
              self.selectEmptyOption();
            } else if (self.unknownOption.parent().length) {
              self.updateUnknownOption(value);
            } else {
              self.renderUnknownOption(value);
            }
          };

          var renderScheduled = false;
          function scheduleRender() {
            if (renderScheduled) return;
            renderScheduled = true;
            $scope.$$postDigest(function () {
              renderScheduled = false;
              self.ngModelCtrl.$render();
            });
          }

          var updateScheduled = false;
          function scheduleViewValueUpdate(renderAfter) {
            if (updateScheduled) return;

            updateScheduled = true;

            $scope.$$postDigest(function () {
              if ($scope.$$destroyed) return;

              updateScheduled = false;
              self.ngModelCtrl.$setViewValue(self.readValue());
              if (renderAfter) self.ngModelCtrl.$render();
            });
          }

          self.registerOption = function (optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

            if (optionAttrs.$attr.ngValue) {
              // The value attribute is set by ngValue
              var oldVal, hashedVal = NaN;
              optionAttrs.$observe("value", function valueAttributeObserveAction(newVal) {

                var removal;
                var previouslySelected = optionElement.prop("selected");

                if (isDefined(hashedVal)) {
                  self.removeOption(oldVal);
                  delete self.selectValueMap[hashedVal];
                  removal = true;
                }

                hashedVal = hashKey(newVal);
                oldVal = newVal;
                self.selectValueMap[hashedVal] = newVal;
                self.addOption(newVal, optionElement);
                // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
                // from firing a second time. Other $observers on value will also get the result of the
                // ngValue expression, not the hashed value
                optionElement.attr("value", hashedVal);

                if (removal && previouslySelected) {
                  scheduleViewValueUpdate();
                }

              });
            } else if (interpolateValueFn) {
              // The value attribute is interpolated
              optionAttrs.$observe("value", function valueAttributeObserveAction(newVal) {
                // This method is overwritten in ngOptions and has side-effects!
                self.readValue();

                var removal;
                var previouslySelected = optionElement.prop("selected");

                if (isDefined(oldVal)) {
                  self.removeOption(oldVal);
                  removal = true;
                }
                oldVal = newVal;
                self.addOption(newVal, optionElement);

                if (removal && previouslySelected) {
                  scheduleViewValueUpdate();
                }
              });
            } else if (interpolateTextFn) {
              // The text content is interpolated
              optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
                optionAttrs.$set("value", newVal);
                var previouslySelected = optionElement.prop("selected");
                if (oldVal !== newVal) {
                  self.removeOption(oldVal);
                }
                self.addOption(newVal, optionElement);

                if (oldVal && previouslySelected) {
                  scheduleViewValueUpdate();
                }
              });
            } else {
              // The value attribute is static
              self.addOption(optionAttrs.value, optionElement);
            }

            optionAttrs.$observe("disabled", function (newVal) {

              // Since model updates will also select disabled options (like ngOptions),
              // we only have to handle options becoming disabled, not enabled

              if (newVal === "true" || newVal && optionElement.prop("selected")) {
                if (self.multiple) {
                  scheduleViewValueUpdate(true);
                } else {
                  self.ngModelCtrl.$setViewValue(null);
                  self.ngModelCtrl.$render();
                }
              }
            });

            optionElement.on("$destroy", function () {
              var currentValue = self.readValue();
              var removeValue = optionAttrs.value;

              self.removeOption(removeValue);
              scheduleRender();

              if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
              ) {
                // When multiple (selected) options are destroyed at the same time, we don't want
                // to run a model update for each of them. Instead, run a single update in the $$postDigest
                scheduleViewValueUpdate(true);
              }
            });
          };
        }];

  /**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @knownIssue
 *
 * In Firefox, the select model is only updated when the select element is blurred. For example,
 * when switching between options with the keyboard, the select model is only set to the
 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
 * outside the select.
 *
 * This is due to an ambiguity in the select element specification. See the
 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
 * for more information, and this
 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
  var selectDirective = function () {

    return {
      restrict: "E",
      require: ["select", "?ngModel"],
      controller: SelectController,
      priority: 1,
      link: {
        pre: selectPreLink,
        post: selectPostLink
      }
    };

    function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }

      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on("change", function () {
        selectCtrl.removeUnknownOption();
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find("option"), function (option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find("option"), function (option) {
            var shouldBeSelected = !!value && (includes(value, option.value) ||
                                               includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }

          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function (value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function () {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
  };

  // The option directive is purely designed to communicate the existence (or lack of)
  // of dynamically created (and destroyed) option elements to their containing select
  // directive via its controller.
  var optionDirective = ["$interpolate", function ($interpolate) {
    return {
      restrict: "E",
      priority: 100,
      compile: function (element, attr) {
        var interpolateValueFn, interpolateTextFn;

        if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
        } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
          interpolateValueFn = $interpolate(attr.value, true);
        } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
          interpolateTextFn = $interpolate(element.text(), true);
          if (!interpolateTextFn) {
            attr.$set("value", element.text());
          }
        }

        return function (scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
          var selectCtrlName = "$selectController",
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

          if (selectCtrl) {
            selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
          }
        };
      }
    };
  }];

  /**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
  var requiredDirective = function () {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function (scope, elm, attr, ctrl) {
        if (!ctrl) return;
        attr.required = true; // force truthy in case we are on non input element

        ctrl.$validators.required = function (modelValue, viewValue) {
          return !attr.required || !ctrl.$isEmpty(viewValue);
        };

        attr.$observe("required", function () {
          ctrl.$validate();
        });
      }
    };
  };

  /**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
  var patternDirective = function () {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function (scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var regexp, patternExp = attr.ngPattern || attr.pattern;
        attr.$observe("pattern", function (regex) {
          if (isString(regex) && regex.length > 0) {
            regex = new RegExp("^" + regex + "$");
          }

          if (regex && !regex.test) {
            throw minErr("ngPattern")("noregexp",
              "Expected {0} to be a RegExp but was {1}. Element: {2}", patternExp,
              regex, startingTag(elm));
          }

          regexp = regex || undefined;
          ctrl.$validate();
        });

        ctrl.$validators.pattern = function (modelValue, viewValue) {
        // HTML5 pattern constraint validates the input value, so we validate the viewValue
          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
        };
      }
    };
  };

  /**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
  var maxlengthDirective = function () {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function (scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var maxlength = -1;
        attr.$observe("maxlength", function (value) {
          var intVal = toInt(value);
          maxlength = isNumberNaN(intVal) ? -1 : intVal;
          ctrl.$validate();
        });
        ctrl.$validators.maxlength = function (modelValue, viewValue) {
          return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
        };
      }
    };
  };

  /**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
  var minlengthDirective = function () {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function (scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var minlength = 0;
        attr.$observe("minlength", function (value) {
          minlength = toInt(value) || 0;
          ctrl.$validate();
        });
        ctrl.$validators.minlength = function (modelValue, viewValue) {
          return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
        };
      }
    };
  };

  if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
    if (window.console) {
      console.log("WARNING: Tried to load AngularJS more than once.");
    }
    return;
  }

  // try to bind to jquery now so that one can write jqLite(fn)
  // but we will rebind on bootstrap again.
  bindJQuery();

  publishExternalAPI(angular);

  angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function getDecimals(n) {
      n = n + "";
      var i = n.indexOf(".");
      return (i == -1) ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
      var v = opt_precision;

      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }

      var base = Math.pow(10, v);
      var f = ((n * base) | 0) % base;
      return { v: v, f: f };
    }

    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": [
          "AM",
          "PM"
        ],
        "DAY": [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "ERANAMES": [
          "Before Christ",
          "Anno Domini"
        ],
        "ERAS": [
          "BC",
          "AD"
        ],
        "FIRSTDAYOFWEEK": 6,
        "MONTH": [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        "SHORTDAY": [
          "Sun",
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat"
        ],
        "SHORTMONTH": [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        "STANDALONEMONTH": [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        "WEEKENDRANGE": [
          5,
          6
        ],
        "fullDate": "EEEE, MMMM d, y",
        "longDate": "MMMM d, y",
        "medium": "MMM d, y h:mm:ss a",
        "mediumDate": "MMM d, y",
        "mediumTime": "h:mm:ss a",
        "short": "M/d/yy h:mm a",
        "shortDate": "M/d/yy",
        "shortTime": "h:mm a"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "$",
        "DECIMAL_SEP": ".",
        "GROUP_SEP": ",",
        "PATTERNS": [
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
          },
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "-\u00a4",
            "negSuf": "",
            "posPre": "\u00a4",
            "posSuf": ""
          }
        ]
      },
      "id": "en-us",
      "localeID": "en_US",
      "pluralCat": function (n, opt_precision) { var i = n | 0; var vf = getVF(n, opt_precision); if (i == 1 && vf.v == 0) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER;}
    });
  }]);

  jqLite(function () {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend("<style type=\"text/css\">@charset \"UTF-8\";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>");

/* ! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = typeof define === "function" && define.amd;

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
    freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global === "object" && global;

  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root["Object"]());
    exports || (exports = root["Object"]());

    // Native constructor aliases.
    var Number = context["Number"] || root["Number"],
      String = context["String"] || root["String"],
      Object = context["Object"] || root["Object"],
      Date = context["Date"] || root["Date"],
      SyntaxError = context["SyntaxError"] || root["SyntaxError"],
      TypeError = context["TypeError"] || root["TypeError"],
      Math = context["Math"] || root["Math"],
      nativeJSON = context["JSON"] || root["JSON"];

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON === "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
      getClass = objectProto.toString,
      isProperty, forEach, undef;

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    try {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    } catch (exception) {}

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] !== undef) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("json-parse");
      } else {
        var value, serialized = "{\"a\":[1,true,false,null,\"\\u0000\\b\\n\\f\\r\\t\"]}";
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify === "function" && isExtended;
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            try {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == "\"\"" &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undef &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undef) === undef &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undef &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undef]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undef, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify(new Date(-8.64e15)) == "\"-271821-04-20T00:00:00.000Z\"" &&
                // The milliseconds are optional in ES 5, but required in 5.1.
                stringify(new Date(8.64e15)) == "\"+275760-09-13T00:00:00.000Z\"" &&
                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify(new Date(-621987552e5)) == "\"-000001-01-01T00:00:00.000Z\"" &&
                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify(new Date(-1)) == "\"1969-12-31T23:59:59.999Z\"";
            } catch (exception) {
              stringifySupported = false;
            }
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse;
          if (typeof parse === "function") {
            try {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  try {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse("\"\t\"");
                  } catch (exception) {}
                  if (parseSupported) {
                    try {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    } catch (exception) {}
                  }
                  if (parseSupported) {
                    try {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    } catch (exception) {}
                  }
                }
              }
            } catch (exception) {
              parseSupported = false;
            }
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
        dateClass = "[object Date]",
        numberClass = "[object Number]",
        stringClass = "[object String]",
        arrayClass = "[object Array]",
        booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Define additional utility methods if the `Date` methods are buggy.
      if (!isExtended) {
        var floor = Math.floor;
        // A mapping between the months of the year and the number of days between
        // January 1st and the first of the respective month.
        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        // Internal: Calculates the number of days between the Unix epoch and the
        // first day of the given month.
        var getDay = function (year, month) {
          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
        };
      }

      // Internal: Determines if a property is a direct property of the given
      // object. Delegates to the native `Object#hasOwnProperty` method.
      if (!(isProperty = objectProto.hasOwnProperty)) {
        isProperty = function (property) {
          var members = {}, constructor;
          if ((members.__proto__ = null, members.__proto__ = {
            // The *proto* property cannot be set multiple times in recent
            // versions of Firefox and SeaMonkey.
            "toString": 1
          }, members).toString != getClass) {
            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
            // supports the mutable *proto* property.
            isProperty = function (property) {
              // Capture and break the object's prototype chain (see section 8.6.2
              // of the ES 5.1 spec). The parenthesized expression prevents an
              // unsafe transformation by the Closure Compiler.
              var original = this.__proto__, result = property in (this.__proto__ = null, this);
              // Restore the original prototype chain.
              this.__proto__ = original;
              return result;
            };
          } else {
            // Capture a reference to the top-level `Object` constructor.
            constructor = members.constructor;
            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
            // other environments.
            isProperty = function (property) {
              var parent = (this.constructor || constructor).prototype;
              return property in this && !(property in parent && this[property] === parent[property]);
            };
          }
          members = null;
          return isProperty.call(this, property);
        };
      }

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      forEach = function (object, callback) {
        var size = 0, Properties, members, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        members = new Properties();
        for (property in members) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(members, property)) {
            size++;
          }
        }
        Properties = members = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor !== "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
          };
        } else if (size == 2) {
          // Safari <= 2.0.4 enumerates shadowed properties twice.
          forEach = function (object, callback) {
            // Create a set of iterated properties.
            var members = {}, isFunction = getClass.call(object) == functionClass, property;
            for (property in object) {
              // Store each property name to prevent double enumeration. The
              // `prototype` property of functions is not enumerated due to cross-
              // environment inconsistencies.
              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forEach(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: "\\\"",
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Double-quotes a string `value`, replacing all ASCII control
        // characters (characters with code unit values between 0 and 31) with
        // their escaped equivalents. This is an implementation of the
        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
        var unicodePrefix = "\\u00";
        var quote = function (value) {
          var result = "\"", index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
          for (; index < length; index++) {
            var charCode = value.charCodeAt(index);
            // If the character is a control character, append its Unicode or
            // shorthand escape sequence; otherwise, append the character as-is.
            switch (charCode) {
              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
                result += Escapes[charCode];
                break;
              default:
                if (charCode < 32) {
                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
                  break;
                }
                result += useCharIndex ? symbols[index] : value.charAt(index);
            }
          }
          return result + "\"";
        };

        // Internal: Recursively serializes an object. Implements the
        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
          try {
            // Necessary for host object support.
            value = object[property];
          } catch (exception) {}
          if (typeof value === "object" && value) {
            className = getClass.call(value);
            if (className == dateClass && !isProperty.call(value, "toJSON")) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                if (getDay) {
                  // Manually compute the year, month, date, hours, minutes,
                  // seconds, and milliseconds if the `getUTC*` methods are
                  // buggy. Adapted from @Yaffle's `date-shim` project.
                  date = floor(value / 864e5);
                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
                  date = 1 + date - getDay(year, month);
                  // The `time` value specifies the time within the day (see ES
                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                  // to compute `A modulo B`, as the `%` operator does not
                  // correspond to the `modulo` operation for negative numbers.
                  time = (value % 864e5 + 864e5) % 864e5;
                  // The hours, minutes, seconds, and milliseconds are obtained by
                  // decomposing the time within the day. See section 15.9.1.10.
                  hours = floor(time / 36e5) % 24;
                  minutes = floor(time / 6e4) % 60;
                  seconds = floor(time / 1e3) % 60;
                  milliseconds = time % 1e3;
                } else {
                  year = value.getUTCFullYear();
                  month = value.getUTCMonth();
                  date = value.getUTCDate();
                  hours = value.getUTCHours();
                  minutes = value.getUTCMinutes();
                  seconds = value.getUTCSeconds();
                  milliseconds = value.getUTCMilliseconds();
                }
                // Serialize extended years correctly.
                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
                  // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
                  // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
              } else {
                value = null;
              }
            } else if (typeof value.toJSON === "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
              // ignores all `toJSON` methods on these objects unless they are
              // defined directly on an instance.
              value = value.toJSON(property);
            }
          }
          if (callback) {
            // If a replacement function was provided, call it to obtain the value
            // for serialization.
            value = callback.call(object, property, value);
          }
          if (value === null) {
            return "null";
          }
          className = getClass.call(value);
          if (className == booleanClass) {
            // Booleans are represented literally.
            return "" + value;
          } else if (className == numberClass) {
            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
            // `"null"`.
            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
          } else if (className == stringClass) {
            // Strings are double-quoted and escaped.
            return quote("" + value);
          }
          // Recursively serialize objects and arrays.
          if (typeof value === "object") {
            // Check for cyclic structures. This is a linear search; performance
            // is inversely proportional to the number of unique nested objects.
            for (length = stack.length; length--;) {
              if (stack[length] === value) {
                // Cyclic structures cannot be serialized by `JSON.stringify`.
                throw TypeError();
              }
            }
            // Add the object to the stack of traversed objects.
            stack.push(value);
            results = [];
            // Save the current indentation level and indent one additional level.
            prefix = indentation;
            indentation += whitespace;
            if (className == arrayClass) {
              // Recursively serialize array elements.
              for (index = 0, length = value.length; index < length; index++) {
                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                results.push(element === undef ? "null" : element);
              }
              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
            } else {
              // Recursively serialize object members. Members are selected from
              // either a user-specified list of property names, or the object
              // itself.
              forEach(properties || value, function (property) {
                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                if (element !== undef) {
                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                  // is not the empty string, let `member` {quote(property) + ":"}
                  // be the concatenation of `member` and the `space` character."
                  // The "`space` character" refers to the literal space
                  // character, not the `space` {width} argument provided to
                  // `JSON.stringify`.
                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                }
              });
              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
            }
            // Remove the object from the traversed object stack.
            stack.pop();
            return result;
          }
        };

        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
        exports.stringify = function (source, filter, width) {
          var whitespace, callback, properties, className;
          if (objectTypes[typeof filter] && filter) {
            if ((className = getClass.call(filter)) == functionClass) {
              callback = filter;
            } else if (className == arrayClass) {
              // Convert the property names array into a makeshift set.
              properties = {};
              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
            }
          }
          if (width) {
            if ((className = getClass.call(width)) == numberClass) {
              // Convert the `width` to an integer and create a string containing
              // `width` number of space characters.
              if ((width -= width % 1) > 0) {
                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
              }
            } else if (className == stringClass) {
              whitespace = width.length <= 10 ? width : width.slice(0, 10);
            }
          }
          // Opera <= 7.54u2 discards the values associated with empty string keys
          // (`""`) only if they are used directly within an object member list
          // (e.g., `!("" in { "": 1})`).
          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
        };
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: "\"",
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                if (source.slice(Index, Index + 4) == "true") {
                  Index += 4;
                  return true;
                } else if (source.slice(Index, Index + 5) == "false") {
                  Index += 5;
                  return false;
                } else if (source.slice(Index, Index + 4) == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value === "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value !== "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undef) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value === "object" && value) {
            // `forEach` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(value, length, callback);
              }
            } else {
              forEach(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports["runInContext"] = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
      previousJSON = root["JSON3"],
      isRestored = false;

    var JSON3 = runInContext(root, (root["JSON3"] = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root["JSON3"] = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    define(function () {
      return JSON3;
    });
  }
}).call(this);

/* !
 * https://github.com/es-shims/es5-shim
 * @license es5-shim Copyright 2009-2014 by contributors, MIT License
 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
 */

// vim: ts=4 sts=4 sw=4 expandtab

// Add semicolon to prevent IIFE from being passed as argument to concated code.

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/returnExports.js
(function (root, factory) {
  if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(factory);
  } else if (typeof exports === "object") {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(this, function () {

  /**
 * Brings an environment as close to ECMAScript 5 compliance
 * as is possible with the facilities of erstwhile engines.
 *
 * Annotated ES5: http://es5.github.com/ (specific links below)
 * ES5 Spec: http://www.ecma-international.org/publications/files/ECMA-ST/Ecma-262.pdf
 * Required reading: http://javascriptweblog.wordpress.com/2011/12/05/extending-javascript-natives/
 */

  // Shortcut to an often accessed properties, in order to avoid multiple
  // dereference that costs universally.
  var call = Function.prototype.call;
  var prototypeOfArray = Array.prototype;
  var prototypeOfObject = Object.prototype;
  var _Array_slice_ = prototypeOfArray.slice;
  var array_splice = Array.prototype.splice;
  var array_push = Array.prototype.push;
  var array_unshift = Array.prototype.unshift;

  //
  // Function
  // ========
  //

  // ES-5 15.3.4.5
  // http://es5.github.com/#x15.3.4.5

  function Empty() {}

  if (!Function.prototype.bind) {
    Function.prototype.bind = function bind(that) { // .length is 1
      // 1. Let Target be the this value.
      var target = this;
      // 2. If IsCallable(Target) is false, throw a TypeError exception.
      if (typeof target !== "function") {
        throw new TypeError("Function.prototype.bind called on incompatible " + target);
      }
      // 3. Let A be a new (possibly empty) internal list of all of the
      //   argument values provided after thisArg (arg1, arg2 etc), in order.
      // XXX slicedArgs will stand in for "A" if used
      var args = _Array_slice_.call(arguments, 1); // for normal call
      // 4. Let F be a new native ECMAScript object.
      // 11. Set the [[Prototype]] internal property of F to the standard
      //   built-in Function prototype object as specified in 15.3.3.1.
      // 12. Set the [[Call]] internal property of F as described in
      //   15.3.4.5.1.
      // 13. Set the [[Construct]] internal property of F as described in
      //   15.3.4.5.2.
      // 14. Set the [[HasInstance]] internal property of F as described in
      //   15.3.4.5.3.
      var binder = function () {

        if (this instanceof bound) {
          // 15.3.4.5.2 [[Construct]]
          // When the [[Construct]] internal method of a function object,
          // F that was created using the bind function is called with a
          // list of arguments ExtraArgs, the following steps are taken:
          // 1. Let target be the value of F's [[TargetFunction]]
          //   internal property.
          // 2. If target has no [[Construct]] internal method, a
          //   TypeError exception is thrown.
          // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
          //   property.
          // 4. Let args be a new list containing the same values as the
          //   list boundArgs in the same order followed by the same
          //   values as the list ExtraArgs in the same order.
          // 5. Return the result of calling the [[Construct]] internal
          //   method of target providing args as the arguments.

          var result = target.apply(
            this,
            args.concat(_Array_slice_.call(arguments))
          );
          if (Object(result) === result) {
            return result;
          }
          return this;

        } else {
          // 15.3.4.5.1 [[Call]]
          // When the [[Call]] internal method of a function object, F,
          // which was created using the bind function is called with a
          // this value and a list of arguments ExtraArgs, the following
          // steps are taken:
          // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
          //   property.
          // 2. Let boundThis be the value of F's [[BoundThis]] internal
          //   property.
          // 3. Let target be the value of F's [[TargetFunction]] internal
          //   property.
          // 4. Let args be a new list containing the same values as the
          //   list boundArgs in the same order followed by the same
          //   values as the list ExtraArgs in the same order.
          // 5. Return the result of calling the [[Call]] internal method
          //   of target providing boundThis as the this value and
          //   providing args as the arguments.

          // equiv: target.call(this, ...boundArgs, ...args)
          return target.apply(
            that,
            args.concat(_Array_slice_.call(arguments))
          );

        }

      };

      // 15. If the [[Class]] internal property of Target is "Function", then
      //     a. Let L be the length property of Target minus the length of A.
      //     b. Set the length own property of F to either 0 or L, whichever is
      //       larger.
      // 16. Else set the length own property of F to 0.

      var boundLength = Math.max(0, target.length - args.length);

      // 17. Set the attributes of the length own property of F to the values
      //   specified in 15.3.5.1.
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs.push("$" + i);
      }

      // XXX Build a dynamic function with desired amount of arguments is the only
      // way to set the length property of a function.
      // In environments where Content Security Policies enabled (Chrome extensions,
      // for ex.) all use of eval or Function costructor throws an exception.
      // However in all of these environments Function.prototype.bind exists
      // and so this code will never be executed.
      var bound = Function("binder", "return function(" + boundArgs.join(",") + "){return binder.apply(this,arguments)}")(binder);

      if (target.prototype) {
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        // Clean up dangling references.
        Empty.prototype = null;
      }

      // TODO
      // 18. Set the [[Extensible]] internal property of F to true.

      // TODO
      // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
      // 20. Call the [[DefineOwnProperty]] internal method of F with
      //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
      //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
      //   false.
      // 21. Call the [[DefineOwnProperty]] internal method of F with
      //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
      //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
      //   and false.

      // TODO
      // NOTE Function objects created using Function.prototype.bind do not
      // have a prototype property or the [[Code]], [[FormalParameters]], and
      // [[Scope]] internal properties.
      // XXX can't delete prototype in pure-js.

      // 22. Return F.
      return bound;
    };
  }

  // _Please note: Shortcuts are defined after `Function.prototype.bind` as we
  // us it in defining shortcuts.
  var owns = call.bind(prototypeOfObject.hasOwnProperty);
  // Having a toString local variable name breaks in Opera so use _toString.
  var _toString = call.bind(prototypeOfObject.toString);

  // If JS engine supports accessors creating shortcuts.
  var defineGetter;
  var defineSetter;
  var lookupGetter;
  var lookupSetter;
  var supportsAccessors;
  if ((supportsAccessors = owns(prototypeOfObject, "__defineGetter__"))) {
    defineGetter = call.bind(prototypeOfObject.__defineGetter__);
    defineSetter = call.bind(prototypeOfObject.__defineSetter__);
    lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
    lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
  }

  //
  // Array
  // =====
  //

  // ES5 15.4.4.12
  // http://es5.github.com/#x15.4.4.12
  // Default value for second param
  // [bugfix, ielt9, old browsers]
  // IE < 9 bug: [1,2].splice(0).join("") === "" but should be "12"
  if ([1, 2].splice(0).length != 2) {
    if (function () { // test IE < 9 to splice bug - see issue #138
      function makeArray(l) {
        var a = [];
        while (l--) {
          a.unshift(l);
        }
        return a;
      }

      var array = [];
      var lengthBefore;

      array.splice.bind(array, 0, 0).apply(null, makeArray(20));
      array.splice.bind(array, 0, 0).apply(null, makeArray(26));

      lengthBefore = array.length; // 20
      array.splice(5, 0, "XXX"); // add one element

      if (lengthBefore + 1 === array.length) {
        return true;// has right splice implementation without bugs
      }
      // else {
      //    IE8 bug
      // }
    }()) {// IE 6/7
      Array.prototype.splice = function (start, deleteCount) {
        if (!arguments.length) {
          return [];
        } else {
          return array_splice.apply(this, [
            start === void 0 ? 0 : start,
            deleteCount === void 0 ? (this.length - start) : deleteCount
          ].concat(_Array_slice_.call(arguments, 2)));
        }
      };
    }
    else {// IE8
      Array.prototype.splice = function (start, deleteCount) {
        var result;
        var args = _Array_slice_.call(arguments, 2);
        var addElementsCount = args.length;

        if (!arguments.length) {
          return [];
        }

        if (start === void 0) { // default
          start = 0;
        }
        if (deleteCount === void 0) { // default
          deleteCount = this.length - start;
        }

        if (addElementsCount > 0) {
          if (deleteCount <= 0) {
            if (start === this.length) { // tiny optimisation #1
              array_push.apply(this, args);
              return [];
            }

            if (start === 0) { // tiny optimisation #2
              array_unshift.apply(this, args);
              return [];
            }
          }

          // Array.prototype.splice implementation
          result = _Array_slice_.call(this, start, start + deleteCount);// delete part
          args.push.apply(args, _Array_slice_.call(this, start + deleteCount, this.length));// right part
          args.unshift.apply(args, _Array_slice_.call(this, 0, start));// left part

          // delete all items from this array and replace it to 'left part' + _Array_slice_.call(arguments, 2) + 'right part'
          args.unshift(0, this.length);

          array_splice.apply(this, args);

          return result;
        }

        return array_splice.call(this, start, deleteCount);
      };

    }
  }

  // ES5 15.4.4.12
  // http://es5.github.com/#x15.4.4.13
  // Return len+argCount.
  // [bugfix, ielt8]
  // IE < 8 bug: [].unshift(0) === undefined but should be "1"
  if ([].unshift(0) != 1) {
    Array.prototype.unshift = function () {
      array_unshift.apply(this, arguments);
      return this.length;
    };
  }

  // ES5 15.4.3.2
  // http://es5.github.com/#x15.4.3.2
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
  if (!Array.isArray) {
    Array.isArray = function isArray(obj) {
      return _toString(obj) === "[object Array]";
    };
  }

  // The IsCallable() check in the Array functions
  // has been replaced with a strict check on the
  // internal class of the object to trap cases where
  // the provided function was actually a regular
  // expression literal, which in V8 and
  // JavaScriptCore is a typeof "function".  Only in
  // V8 are regular expression literals permitted as
  // reduce parameters, so it is desirable in the
  // general case for the shim to match the more
  // strict and common behavior of rejecting regular
  // expressions.

  // ES5 15.4.4.18
  // http://es5.github.com/#x15.4.4.18
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/array/forEach

  // Check failure of by-index access of string characters (IE < 9)
  // and failure of `0 in boxedString` (Rhino)
  var boxedString = Object("a");
  var splitString = boxedString[0] != "a" || !(0 in boxedString);

  var properlyBoxesContext = function properlyBoxed(method) {
    // Check node 0.6.21 bug where third parameter is not boxed
    var properlyBoxes = true;
    if (method) {
      method.call("foo", function (_, __, context) {
        if (typeof context !== "object") { properlyBoxes = false; }
      });
    }
    return !!method && properlyBoxes;
  };

  if (!Array.prototype.forEach || !properlyBoxesContext(Array.prototype.forEach)) {
    Array.prototype.forEach = function forEach(fun /* , thisp*/) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        thisp = arguments[1],
        i = -1,
        length = self.length >>> 0;

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(); // TODO message
      }

      while (++i < length) {
        if (i in self) {
          // Invoke the callback function with call, passing arguments:
          // context, property value, property key, thisArg object
          // context
          fun.call(thisp, self[i], i, object);
        }
      }
    };
  }

  // ES5 15.4.4.19
  // http://es5.github.com/#x15.4.4.19
  // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
  if (!Array.prototype.map || !properlyBoxesContext(Array.prototype.map)) {
    Array.prototype.map = function map(fun /* , thisp*/) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        length = self.length >>> 0,
        result = Array(length),
        thisp = arguments[1];

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(fun + " is not a function");
      }

      for (var i = 0; i < length; i++) {
        if (i in self)
          result[i] = fun.call(thisp, self[i], i, object);
      }
      return result;
    };
  }

  // ES5 15.4.4.20
  // http://es5.github.com/#x15.4.4.20
  // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
  if (!Array.prototype.filter || !properlyBoxesContext(Array.prototype.filter)) {
    Array.prototype.filter = function filter(fun /* , thisp */) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        length = self.length >>> 0,
        result = [],
        value,
        thisp = arguments[1];

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(fun + " is not a function");
      }

      for (var i = 0; i < length; i++) {
        if (i in self) {
          value = self[i];
          if (fun.call(thisp, value, i, object)) {
            result.push(value);
          }
        }
      }
      return result;
    };
  }

  // ES5 15.4.4.16
  // http://es5.github.com/#x15.4.4.16
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
  if (!Array.prototype.every || !properlyBoxesContext(Array.prototype.every)) {
    Array.prototype.every = function every(fun /* , thisp */) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        length = self.length >>> 0,
        thisp = arguments[1];

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(fun + " is not a function");
      }

      for (var i = 0; i < length; i++) {
        if (i in self && !fun.call(thisp, self[i], i, object)) {
          return false;
        }
      }
      return true;
    };
  }

  // ES5 15.4.4.17
  // http://es5.github.com/#x15.4.4.17
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
  if (!Array.prototype.some || !properlyBoxesContext(Array.prototype.some)) {
    Array.prototype.some = function some(fun /* , thisp */) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        length = self.length >>> 0,
        thisp = arguments[1];

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(fun + " is not a function");
      }

      for (var i = 0; i < length; i++) {
        if (i in self && fun.call(thisp, self[i], i, object)) {
          return true;
        }
      }
      return false;
    };
  }

  // ES5 15.4.4.21
  // http://es5.github.com/#x15.4.4.21
  // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduce
  var reduceCoercesToObject = false;
  if (Array.prototype.reduce) {
    reduceCoercesToObject = typeof Array.prototype.reduce.call("a", function (_, __, ___, list) { return list; }) === "object";
  }
  if (!Array.prototype.reduce || !reduceCoercesToObject) {
    Array.prototype.reduce = function reduce(fun /* , initial*/) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        length = self.length >>> 0;

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(fun + " is not a function");
      }

      // no value to return if no initial value and an empty array
      if (!length && arguments.length === 1) {
        throw new TypeError("reduce of empty array with no initial value");
      }

      var i = 0;
      var result;
      if (arguments.length >= 2) {
        result = arguments[1];
      } else {
        do {
          if (i in self) {
            result = self[i++];
            break;
          }

          // if array contains no values, no initial value to return
          if (++i >= length) {
            throw new TypeError("reduce of empty array with no initial value");
          }
        } while (true);
      }

      for (; i < length; i++) {
        if (i in self) {
          result = fun.call(void 0, result, self[i], i, object);
        }
      }

      return result;
    };
  }

  // ES5 15.4.4.22
  // http://es5.github.com/#x15.4.4.22
  // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduceRight
  if (!Array.prototype.reduceRight) {
    Array.prototype.reduceRight = function reduceRight(fun /* , initial*/) {
      var object = toObject(this),
        self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          object,
        length = self.length >>> 0;

      // If no callback function or if callback is not a callable function
      if (_toString(fun) != "[object Function]") {
        throw new TypeError(fun + " is not a function");
      }

      // no value to return if no initial value, empty array
      if (!length && arguments.length === 1) {
        throw new TypeError("reduceRight of empty array with no initial value");
      }

      var result, i = length - 1;
      if (arguments.length >= 2) {
        result = arguments[1];
      } else {
        do {
          if (i in self) {
            result = self[i--];
            break;
          }

          // if array contains no values, no initial value to return
          if (--i < 0) {
            throw new TypeError("reduceRight of empty array with no initial value");
          }
        } while (true);
      }

      if (i < 0) {
        return result;
      }

      do {
        if (i in this) {
          result = fun.call(void 0, result, self[i], i, object);
        }
      } while (i--);

      return result;
    };
  }

  // ES5 15.4.4.14
  // http://es5.github.com/#x15.4.4.14
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
  if (!Array.prototype.indexOf || ([0, 1].indexOf(1, 2) != -1)) {
    Array.prototype.indexOf = function indexOf(sought /* , fromIndex */ ) {
      var self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          toObject(this),
        length = self.length >>> 0;

      if (!length) {
        return -1;
      }

      var i = 0;
      if (arguments.length > 1) {
        i = toInteger(arguments[1]);
      }

      // handle negative indices
      i = i >= 0 ? i : Math.max(0, length + i);
      for (; i < length; i++) {
        if (i in self && self[i] === sought) {
          return i;
        }
      }
      return -1;
    };
  }

  // ES5 15.4.4.15
  // http://es5.github.com/#x15.4.4.15
  // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
  if (!Array.prototype.lastIndexOf || ([0, 1].lastIndexOf(0, -3) != -1)) {
    Array.prototype.lastIndexOf = function lastIndexOf(sought /* , fromIndex */) {
      var self = splitString && _toString(this) === "[object String]" ?
          this.split("") :
          toObject(this),
        length = self.length >>> 0;

      if (!length) {
        return -1;
      }
      var i = length - 1;
      if (arguments.length > 1) {
        i = Math.min(i, toInteger(arguments[1]));
      }
      // handle negative indices
      i = i >= 0 ? i : length - Math.abs(i);
      for (; i >= 0; i--) {
        if (i in self && sought === self[i]) {
          return i;
        }
      }
      return -1;
    };
  }

  //
  // Object
  // ======
  //

  // ES5 15.2.3.14
  // http://es5.github.com/#x15.2.3.14
  if (!Object.keys) {
    // http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
    var hasDontEnumBug = !({ "toString": null }).propertyIsEnumerable("toString"),
      hasProtoEnumBug = (function () {}).propertyIsEnumerable("prototype"),
      dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
      ],
      dontEnumsLength = dontEnums.length,
      isFunction = function isFunction(value) {
        return _toString(value) === "[object Function]";
      },
      isArguments = function isArguments(value) {
        var str = _toString(value);
        var isArgs = str === "[object Arguments]";
        if (!isArgs) {
          isArgs = !Array.isArray(str)
                    && value !== null
                    && typeof value === "object"
                    && typeof value.length === "number"
                    && value.length >= 0
                    && isFunction(value.callee);
        }
        return isArgs;
      };

    Object.keys = function keys(object) {
      var isFn = isFunction(object),
        isArgs = isArguments(object),
        isObject = object !== null && typeof object === "object",
        isString = isObject && _toString(object) === "[object String]";

      if (!isObject && !isFn && !isArgs) {
        throw new TypeError("Object.keys called on a non-object");
      }

      var theKeys = [];
      var skipProto = hasProtoEnumBug && isFn;
      if (isString || isArgs) {
        for (var i = 0; i < object.length; ++i) {
          theKeys.push(String(i));
        }
      } else {
        for (var name in object) {
          if (!(skipProto && name === "prototype") && owns(object, name)) {
            theKeys.push(String(name));
          }
        }
      }

      if (hasDontEnumBug) {
        var ctor = object.constructor,
          skipConstructor = ctor && ctor.prototype === object;
        for (var j = 0; j < dontEnumsLength; j++) {
          var dontEnum = dontEnums[j];
          if (!(skipConstructor && dontEnum === "constructor") && owns(object, dontEnum)) {
            theKeys.push(dontEnum);
          }
        }
      }
      return theKeys;
    };

  }

  //
  // Date
  // ====
  //

  // ES5 15.9.5.43
  // http://es5.github.com/#x15.9.5.43
  // This function returns a String value represent the instance in time
  // represented by this Date object. The format of the String is the Date Time
  // string format defined in 15.9.1.15. All fields are present in the String.
  // The time zone is always UTC, denoted by the suffix Z. If the time value of
  // this object is not a finite Number a RangeError exception is thrown.
  var negativeDate = -62198755200000,
    negativeYearString = "-000001";
  if (
    !Date.prototype.toISOString ||
    (new Date(negativeDate).toISOString().indexOf(negativeYearString) === -1)
  ) {
    Date.prototype.toISOString = function toISOString() {
      var result, length, value, year, month;
      if (!isFinite(this)) {
        throw new RangeError("Date.prototype.toISOString called on non-finite value.");
      }

      year = this.getUTCFullYear();

      month = this.getUTCMonth();
      // see https://github.com/es-shims/es5-shim/issues/111
      year += Math.floor(month / 12);
      month = (month % 12 + 12) % 12;

      // the date time string format is specified in 15.9.1.15.
      result = [month + 1, this.getUTCDate(),
        this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds()];
      year = (
        (year < 0 ? "-" : (year > 9999 ? "+" : "")) +
            ("00000" + Math.abs(year))
              .slice(0 <= year && year <= 9999 ? -4 : -6)
      );

      length = result.length;
      while (length--) {
        value = result[length];
        // pad months, days, hours, minutes, and seconds to have two
        // digits.
        if (value < 10) {
          result[length] = "0" + value;
        }
      }
      // pad milliseconds to have three digits.
      return (
        year + "-" + result.slice(0, 2).join("-") +
            "T" + result.slice(2).join(":") + "." +
            ("000" + this.getUTCMilliseconds()).slice(-3) + "Z"
      );
    };
  }

  // ES5 15.9.5.44
  // http://es5.github.com/#x15.9.5.44
  // This function provides a String representation of a Date object for use by
  // JSON.stringify (15.12.3).
  var dateToJSONIsSupported = false;
  try {
    dateToJSONIsSupported = (
      Date.prototype.toJSON &&
        new Date(NaN).toJSON() === null &&
        new Date(negativeDate).toJSON().indexOf(negativeYearString) !== -1 &&
        Date.prototype.toJSON.call({ // generic
          toISOString: function () {
            return true;
          }
        })
    );
  } catch (e) {
  }
  if (!dateToJSONIsSupported) {
    Date.prototype.toJSON = function toJSON(key) {
      // When the toJSON method is called with argument key, the following
      // steps are taken:

      // 1.  Let O be the result of calling ToObject, giving it the this
      // value as its argument.
      // 2. Let tv be toPrimitive(O, hint Number).
      var o = Object(this),
        tv = toPrimitive(o),
        toISO;
        // 3. If tv is a Number and is not finite, return null.
      if (typeof tv === "number" && !isFinite(tv)) {
        return null;
      }
      // 4. Let toISO be the result of calling the [[Get]] internal method of
      // O with argument "toISOString".
      toISO = o.toISOString;
      // 5. If IsCallable(toISO) is false, throw a TypeError exception.
      if (typeof toISO !== "function") {
        throw new TypeError("toISOString property is not callable");
      }
      // 6. Return the result of calling the [[Call]] internal method of
      //  toISO with O as the this value and an empty argument list.
      return toISO.call(o);

      // NOTE 1 The argument is ignored.

      // NOTE 2 The toJSON function is intentionally generic; it does not
      // require that its this value be a Date object. Therefore, it can be
      // transferred to other kinds of objects for use as a method. However,
      // it does require that any such object have a toISOString method. An
      // object is free to use the argument key to filter its
      // stringification.
    };
  }

  // ES5 15.9.4.2
  // http://es5.github.com/#x15.9.4.2
  // based on work shared by Daniel Friesen (dantman)
  // http://gist.github.com/303249
  var supportsExtendedYears = Date.parse("+033658-09-27T01:46:40.000Z") === 1e15;
  var acceptsInvalidDates = !isNaN(Date.parse("2012-04-04T24:00:00.500Z")) || !isNaN(Date.parse("2012-11-31T23:59:59.000Z"));
  var doesNotParseY2KNewYear = isNaN(Date.parse("2000-01-01T00:00:00.000Z"));
  if (!Date.parse || doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
    // XXX global assignment won't work in embeddings that use
    // an alternate object for the context.
    Date = (function (NativeDate) {

      // Date.length === 7
      function Date(Y, M, D, h, m, s, ms) {
        var length = arguments.length;
        if (this instanceof NativeDate) {
          var date = length === 1 && String(Y) === Y ? // isString(Y)
          // We explicitly pass it through parse:
            new NativeDate(Date.parse(Y)) :
          // We have to manually make calls depending on argument
          // length here
            length >= 7 ? new NativeDate(Y, M, D, h, m, s, ms) :
              length >= 6 ? new NativeDate(Y, M, D, h, m, s) :
                length >= 5 ? new NativeDate(Y, M, D, h, m) :
                  length >= 4 ? new NativeDate(Y, M, D, h) :
                    length >= 3 ? new NativeDate(Y, M, D) :
                      length >= 2 ? new NativeDate(Y, M) :
                        length >= 1 ? new NativeDate(Y) :
                          new NativeDate();
          // Prevent mixups with unfixed Date object
          date.constructor = Date;
          return date;
        }
        return NativeDate.apply(this, arguments);
      }

      // 15.9.1.15 Date Time String Format.
      var isoDateExpression = new RegExp("^" +
            "(\\d{4}|[\+\-]\\d{6})" + // four-digit year capture or sign +
      // 6-digit extended year
            "(?:-(\\d{2})" + // optional month capture
            "(?:-(\\d{2})" + // optional day capture
            "(?:" + // capture hours:minutes:seconds.milliseconds
                "T(\\d{2})" + // hours capture
                ":(\\d{2})" + // minutes capture
                "(?:" + // optional :seconds.milliseconds
                    ":(\\d{2})" + // seconds capture
                    "(?:(\\.\\d{1,}))?" + // milliseconds capture
                ")?" +
            "(" + // capture UTC offset component
                "Z|" + // UTC capture
                "(?:" + // offset specifier +/-hours:minutes
                    "([-+])" + // sign capture
                    "(\\d{2})" + // hours offset capture
                    ":(\\d{2})" + // minutes offset capture
                ")" +
            ")?)?)?)?" +
        "$");

      var months = [
        0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365
      ];

      function dayFromMonth(year, month) {
        var t = month > 1 ? 1 : 0;
        return (
          months[month] +
                Math.floor((year - 1969 + t) / 4) -
                Math.floor((year - 1901 + t) / 100) +
                Math.floor((year - 1601 + t) / 400) +
                365 * (year - 1970)
        );
      }

      function toUTC(t) {
        return Number(new NativeDate(1970, 0, 1, 0, 0, 0, t));
      }

      // Copy any custom methods a 3rd party library may have added
      for (var key in NativeDate) {
        Date[key] = NativeDate[key];
      }

      // Copy "native" methods explicitly; they may be non-enumerable
      Date.now = NativeDate.now;
      Date.UTC = NativeDate.UTC;
      Date.prototype = NativeDate.prototype;
      Date.prototype.constructor = Date;

      // Upgrade Date.parse to handle simplified ISO 8601 strings
      Date.parse = function parse(string) {
        var match = isoDateExpression.exec(string);
        if (match) {
          // parse months, days, hours, minutes, seconds, and milliseconds
          // provide default values if necessary
          // parse the UTC offset component
          var year = Number(match[1]),
            month = Number(match[2] || 1) - 1,
            day = Number(match[3] || 1) - 1,
            hour = Number(match[4] || 0),
            minute = Number(match[5] || 0),
            second = Number(match[6] || 0),
            millisecond = Math.floor(Number(match[7] || 0) * 1000),
            // When time zone is missed, local offset should be used
            // (ES 5.1 bug)
            // see https://bugs.ecmascript.org/show_bug.cgi?id=112
            isLocalTime = Boolean(match[4] && !match[8]),
            signOffset = match[9] === "-" ? 1 : -1,
            hourOffset = Number(match[10] || 0),
            minuteOffset = Number(match[11] || 0),
            result;
          if (
            hour < (
              minute > 0 || second > 0 || millisecond > 0 ?
                24 : 25
            ) &&
                    minute < 60 && second < 60 && millisecond < 1000 &&
                    month > -1 && month < 12 && hourOffset < 24 &&
                    minuteOffset < 60 && // detect invalid offsets
                    day > -1 &&
                    day < (
                      dayFromMonth(year, month + 1) -
                        dayFromMonth(year, month)
                    )
          ) {
            result = (
              (dayFromMonth(year, month) + day) * 24 +
                        hour +
                        hourOffset * signOffset
            ) * 60;
            result = (
              (result + minute + minuteOffset * signOffset) * 60 +
                        second
            ) * 1000 + millisecond;
            if (isLocalTime) {
              result = toUTC(result);
            }
            if (-8.64e15 <= result && result <= 8.64e15) {
              return result;
            }
          }
          return NaN;
        }
        return NativeDate.parse.apply(this, arguments);
      };

      return Date;
    })(Date);
  }

  // ES5 15.9.4.4
  // http://es5.github.com/#x15.9.4.4
  if (!Date.now) {
    Date.now = function now() {
      return new Date().getTime();
    };
  }

  //
  // Number
  // ======
  //

  // ES5.1 15.7.4.5
  // http://es5.github.com/#x15.7.4.5
  if (!Number.prototype.toFixed || (0.00008).toFixed(3) !== "0.000" || (0.9).toFixed(0) === "0" || (1.255).toFixed(2) !== "1.25" || (1000000000000000128).toFixed(0) !== "1000000000000000128") {
    // Hide these variables and functions
    (function () {
      var base, size, data, i;

      base = 1e7;
      size = 6;
      data = [0, 0, 0, 0, 0, 0];

      function multiply(n, c) {
        var i = -1;
        while (++i < size) {
          c += n * data[i];
          data[i] = c % base;
          c = Math.floor(c / base);
        }
      }

      function divide(n) {
        var i = size, c = 0;
        while (--i >= 0) {
          c += data[i];
          data[i] = Math.floor(c / n);
          c = (c % n) * base;
        }
      }

      function toString() {
        var i = size;
        var s = "";
        while (--i >= 0) {
          if (s !== "" || i === 0 || data[i] !== 0) {
            var t = String(data[i]);
            if (s === "") {
              s = t;
            } else {
              s += "0000000".slice(0, 7 - t.length) + t;
            }
          }
        }
        return s;
      }

      function pow(x, n, acc) {
        return (n === 0 ? acc : (n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc)));
      }

      function log(x) {
        var n = 0;
        while (x >= 4096) {
          n += 12;
          x /= 4096;
        }
        while (x >= 2) {
          n += 1;
          x /= 2;
        }
        return n;
      }

      Number.prototype.toFixed = function toFixed(fractionDigits) {
        var f, x, s, m, e, z, j, k;

        // Test for NaN and round fractionDigits down
        f = Number(fractionDigits);
        f = f !== f ? 0 : Math.floor(f);

        if (f < 0 || f > 20) {
          throw new RangeError("Number.toFixed called with invalid number of decimals");
        }

        x = Number(this);

        // Test for NaN
        if (x !== x) {
          return "NaN";
        }

        // If it is too big or small, return the string value of the number
        if (x <= -1e21 || x >= 1e21) {
          return String(x);
        }

        s = "";

        if (x < 0) {
          s = "-";
          x = -x;
        }

        m = "0";

        if (x > 1e-21) {
          // 1e-21 < x < 1e21
          // -70 < log2(x) < 70
          e = log(x * pow(2, 69, 1)) - 69;
          z = (e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1));
          z *= 0x10000000000000; // Math.pow(2, 52);
          e = 52 - e;

          // -18 < e < 122
          // x = z / 2 ^ e
          if (e > 0) {
            multiply(0, z);
            j = f;

            while (j >= 7) {
              multiply(1e7, 0);
              j -= 7;
            }

            multiply(pow(10, j, 1), 0);
            j = e - 1;

            while (j >= 23) {
              divide(1 << 23);
              j -= 23;
            }

            divide(1 << j);
            multiply(1, 1);
            divide(2);
            m = toString();
          } else {
            multiply(0, z);
            multiply(1 << (-e), 0);
            m = toString() + "0.00000000000000000000".slice(2, 2 + f);
          }
        }

        if (f > 0) {
          k = m.length;

          if (k <= f) {
            m = s + "0.0000000000000000000".slice(0, f - k + 2) + m;
          } else {
            m = s + m.slice(0, k - f) + "." + m.slice(k - f);
          }
        } else {
          m = s + m;
        }

        return m;
      };
    }());
  }

  //
  // String
  // ======
  //

  // ES5 15.5.4.14
  // http://es5.github.com/#x15.5.4.14

  // [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
  // Many browsers do not split properly with regular expressions or they
  // do not perform the split correctly under obscure conditions.
  // See http://blog.stevenlevithan.com/archives/cross-browser-split
  // I've tested in many browsers and this seems to cover the deviant ones:
  //    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
  //    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
  //    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
  //       [undefined, "t", undefined, "e", ...]
  //    ''.split(/.?/) should be [], not [""]
  //    '.'.split(/()()/) should be ["."], not ["", "", "."]

  var string_split = String.prototype.split;
  if (
    "ab".split(/(?:ab)*/).length !== 2 ||
    ".".split(/(.?)(.?)/).length !== 4 ||
    "tesst".split(/(s)*/)[1] === "t" ||
    "".split(/.?/).length ||
    ".".split(/()()/).length > 1
  ) {
    (function () {
      var compliantExecNpcg = /()??/.exec("")[1] === void 0; // NPCG: nonparticipating capturing group

      String.prototype.split = function (separator, limit) {
        var string = this;
        if (separator === void 0 && limit === 0)
          return [];

        // If `separator` is not a regex, use native split
        if (Object.prototype.toString.call(separator) !== "[object RegExp]") {
          return string_split.apply(this, arguments);
        }

        var output = [],
          flags = (separator.ignoreCase ? "i" : "") +
                        (separator.multiline ? "m" : "") +
                        (separator.extended ? "x" : "") + // Proposed for ES6
                        (separator.sticky ? "y" : ""), // Firefox 3+
          lastLastIndex = 0,
          // Make `global` and avoid `lastIndex` issues by working with a copy
          separator2, match, lastIndex, lastLength;
        separator = new RegExp(separator.source, flags + "g");
        string += ""; // Type-convert
        if (!compliantExecNpcg) {
          // Doesn't need flags gy, but they don't hurt
          separator2 = new RegExp("^" + separator.source + "$(?!\\s)", flags);
        }
        /* Values for `limit`, per the spec:
             * If undefined: 4294967295 // Math.pow(2, 32) - 1
             * If 0, Infinity, or NaN: 0
             * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
             * If negative number: 4294967296 - Math.floor(Math.abs(limit))
             * If other: Type-convert, then use the above rules
             */
        limit = limit === void 0 ?
          -1 >>> 0 : // Math.pow(2, 32) - 1
          limit >>> 0; // ToUint32(limit)
        while (match = separator.exec(string)) {
          // `separator.lastIndex` is not reliable cross-browser
          lastIndex = match.index + match[0].length;
          if (lastIndex > lastLastIndex) {
            output.push(string.slice(lastLastIndex, match.index));
            // Fix browsers whose `exec` methods don't consistently return `undefined` for
            // nonparticipating capturing groups
            if (!compliantExecNpcg && match.length > 1) {
              match[0].replace(separator2, function () {
                for (var i = 1; i < arguments.length - 2; i++) {
                  if (arguments[i] === void 0) {
                    match[i] = void 0;
                  }
                }
              });
            }
            if (match.length > 1 && match.index < string.length) {
              Array.prototype.push.apply(output, match.slice(1));
            }
            lastLength = match[0].length;
            lastLastIndex = lastIndex;
            if (output.length >= limit) {
              break;
            }
          }
          if (separator.lastIndex === match.index) {
            separator.lastIndex++; // Avoid an infinite loop
          }
        }
        if (lastLastIndex === string.length) {
          if (lastLength || !separator.test("")) {
            output.push("");
          }
        } else {
          output.push(string.slice(lastLastIndex));
        }
        return output.length > limit ? output.slice(0, limit) : output;
      };
    }());

    // [bugfix, chrome]
    // If separator is undefined, then the result array contains just one String,
    // which is the this value (converted to a String). If limit is not undefined,
    // then the output array is truncated so that it contains no more than limit
    // elements.
    // "0".split(undefined, 0) -> []
  } else if ("0".split(void 0, 0).length) {
    String.prototype.split = function split(separator, limit) {
      if (separator === void 0 && limit === 0) return [];
      return string_split.apply(this, arguments);
    };
  }

  // ECMA-262, 3rd B.2.3
  // Note an ECMAScript standart, although ECMAScript 3rd Edition has a
  // non-normative section suggesting uniform semantics and it should be
  // normalized across all browsers
  // [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
  if ("".substr && "0b".substr(-1) !== "b") {
    var string_substr = String.prototype.substr;
    /**
     *  Get the substring of a string
     *  @param  {integer}  start   where to start the substring
     *  @param  {integer}  length  how many characters to return
     *  @return {string}
     */
    String.prototype.substr = function substr(start, length) {
      return string_substr.call(
        this,
        start < 0 ? ((start = this.length + start) < 0 ? 0 : start) : start,
        length
      );
    };
  }

  // ES5 15.5.4.20
  // whitespace from: http://es5.github.io/#x15.5.4.20
  var ws = "\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003" +
    "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028" +
    "\u2029\uFEFF";
  var zeroWidth = "\u200b";
  if (!String.prototype.trim || ws.trim() || !zeroWidth.trim()) {
    // http://blog.stevenlevithan.com/archives/faster-trim-javascript
    // http://perfectionkills.com/whitespace-deviations/
    ws = "[" + ws + "]";
    var trimBeginRegexp = new RegExp("^" + ws + ws + "*"),
      trimEndRegexp = new RegExp(ws + ws + "*$");
    String.prototype.trim = function trim() {
      if (this === void 0 || this === null) {
        throw new TypeError("can't convert " + this + " to object");
      }
      return String(this)
        .replace(trimBeginRegexp, "")
        .replace(trimEndRegexp, "");
    };
  }

  // ES-5 15.1.2.2
  if (parseInt(ws + "08") !== 8 || parseInt(ws + "0x16") !== 22) {
    parseInt = (function (origParseInt) {
      var hexRegex = /^0[xX]/;
      return function parseIntES5(str, radix) {
        str = String(str).trim();
        if (!Number(radix)) {
          radix = hexRegex.test(str) ? 16 : 10;
        }
        return origParseInt(str, radix);
      };
    }(parseInt));
  }

  //
  // Util
  // ======
  //

  // ES5 9.4
  // http://es5.github.com/#x9.4
  // http://jsperf.com/to-integer

  function toInteger(n) {
    n = +n;
    if (n !== n) { // isNaN
      n = 0;
    } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
      n = (n > 0 || -1) * Math.floor(Math.abs(n));
    }
    return n;
  }

  function isPrimitive(input) {
    var type = typeof input;
    return (
      input === null ||
        type === "undefined" ||
        type === "boolean" ||
        type === "number" ||
        type === "string"
    );
  }

  function toPrimitive(input) {
    var val, valueOf, toString;
    if (isPrimitive(input)) {
      return input;
    }
    valueOf = input.valueOf;
    if (typeof valueOf === "function") {
      val = valueOf.call(input);
      if (isPrimitive(val)) {
        return val;
      }
    }
    toString = input.toString;
    if (typeof toString === "function") {
      val = toString.call(input);
      if (isPrimitive(val)) {
        return val;
      }
    }
    throw new TypeError();
  }

  // ES5 9.9
  // http://es5.github.com/#x9.9
  var toObject = function (o) {
    if (o == null) { // this matches both null and undefined
      throw new TypeError("can't convert " + o + " to object");
    }
    return Object(o);
  };

}));

/* ========================================================================
 * Bootstrap: affix.js v3.1.1
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options);
    this.$window = $(window)
      .on("scroll.bs.affix.data-api", $.proxy(this.checkPosition, this))
      .on("click.bs.affix.data-api", $.proxy(this.checkPositionWithEventLoop, this));

    this.$element = $(element);
    this.affixed =
    this.unpin =
    this.pinnedOffset = null;

    this.checkPosition();
  };

  Affix.RESET = "affix affix-top affix-bottom";

  Affix.DEFAULTS = {
    offset: 0
  };

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;
    this.$element.removeClass(Affix.RESET).addClass("affix");
    var scrollTop = this.$window.scrollTop();
    var position = this.$element.offset();
    return (this.pinnedOffset = position.top - scrollTop);
  };

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1);
  };

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(":visible")) return;

    var scrollHeight = $(document).height();
    var scrollTop = this.$window.scrollTop();
    var position = this.$element.offset();
    var offset = this.options.offset;
    var offsetTop = offset.top;
    var offsetBottom = offset.bottom;

    if (typeof offset !== "object") offsetBottom = offsetTop = offset;
    if (typeof offsetTop === "function") offsetTop = offset.top(this.$element);
    if (typeof offsetBottom === "function") offsetBottom = offset.bottom(this.$element);

    var affix = this.unpin != null && (scrollTop + this.unpin <= position.top) ? false :
      offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ? "bottom" :
        offsetTop != null && (scrollTop <= offsetTop) ? "top" : false;

    if (this.affixed === affix) return;
    if (this.unpin != null) this.$element.css("top", "");

    var affixType = "affix" + (affix ? "-" + affix : "");
    var e = $.Event(affixType + ".bs.affix");

    this.$element.trigger(e);

    if (e.isDefaultPrevented()) return;

    this.affixed = affix;
    this.unpin = affix == "bottom" ? this.getPinnedOffset() : null;

    this.$element
      .removeClass(Affix.RESET)
      .addClass(affixType)
      .trigger($.Event(affixType.replace("affix", "affixed")));

    if (affix == "bottom") {
      this.$element.offset({ top: position.top });
    }
  };

  // AFFIX PLUGIN DEFINITION
  // =======================

  var old = $.fn.affix;

  $.fn.affix = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.affix");
      var options = typeof option === "object" && option;

      if (!data) $this.data("bs.affix", (data = new Affix(this, options)));
      if (typeof option === "string") data[option]();
    });
  };

  $.fn.affix.Constructor = Affix;

  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old;
    return this;
  };

  // AFFIX DATA-API
  // ==============

  $(window).on("load", function () {
    $("[data-spy=\"affix\"]").each(function () {
      var $spy = $(this);
      var data = $spy.data();

      data.offset = data.offset || {};

      if (data.offsetBottom) data.offset.bottom = data.offsetBottom;
      if (data.offsetTop) data.offset.top = data.offsetTop;

      $spy.affix(data);
    });
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.1.1
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = "[data-dismiss=\"alert\"]";
  var Alert = function (el) {
    $(el).on("click", dismiss, this.close);
  };

  Alert.prototype.close = function (e) {
    var $this = $(this);
    var selector = $this.attr("data-target");

    if (!selector) {
      selector = $this.attr("href");
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
    }

    var $parent = $(selector);

    if (e) e.preventDefault();

    if (!$parent.length) {
      $parent = $this.hasClass("alert") ? $this : $this.parent();
    }

    $parent.trigger(e = $.Event("close.bs.alert"));

    if (e.isDefaultPrevented()) return;

    $parent.removeClass("in");

    function removeElement() {
      $parent.trigger("closed.bs.alert").remove();
    }

    $.support.transition && $parent.hasClass("fade") ?
      $parent
        .one($.support.transition.end, removeElement)
        .emulateTransitionEnd(150) :
      removeElement();
  };

  // ALERT PLUGIN DEFINITION
  // =======================

  var old = $.fn.alert;

  $.fn.alert = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.alert");

      if (!data) $this.data("bs.alert", (data = new Alert(this)));
      if (typeof option === "string") data[option].call($this);
    });
  };

  $.fn.alert.Constructor = Alert;

  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old;
    return this;
  };

  // ALERT DATA-API
  // ==============

  $(document).on("click.bs.alert.data-api", dismiss, Alert.prototype.close);

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.1.1
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Button.DEFAULTS, options);
    this.isLoading = false;
  };

  Button.DEFAULTS = {
    loadingText: "loading..."
  };

  Button.prototype.setState = function (state) {
    var d = "disabled";
    var $el = this.$element;
    var val = $el.is("input") ? "val" : "html";
    var data = $el.data();

    state = state + "Text";

    if (!data.resetText) $el.data("resetText", $el[val]());

    $el[val](data[state] || this.options[state]);

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      if (state == "loadingText") {
        this.isLoading = true;
        $el.addClass(d).attr(d, d);
      } else if (this.isLoading) {
        this.isLoading = false;
        $el.removeClass(d).removeAttr(d);
      }
    }, this), 0);
  };

  Button.prototype.toggle = function () {
    var changed = true;
    var $parent = this.$element.closest("[data-toggle=\"buttons\"]");

    if ($parent.length) {
      var $input = this.$element.find("input");
      if ($input.prop("type") == "radio") {
        if ($input.prop("checked") && this.$element.hasClass("active")) changed = false;
        else $parent.find(".active").removeClass("active");
      }
      if (changed) $input.prop("checked", !this.$element.hasClass("active")).trigger("change");
    }

    if (changed) this.$element.toggleClass("active");
  };

  // BUTTON PLUGIN DEFINITION
  // ========================

  var old = $.fn.button;

  $.fn.button = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.button");
      var options = typeof option === "object" && option;

      if (!data) $this.data("bs.button", (data = new Button(this, options)));

      if (option == "toggle") data.toggle();
      else if (option) data.setState(option);
    });
  };

  $.fn.button.Constructor = Button;

  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old;
    return this;
  };

  // BUTTON DATA-API
  // ===============

  $(document).on("click.bs.button.data-api", "[data-toggle^=\"button\"]", function (e) {
    var $btn = $(e.target);
    if (!$btn.hasClass("btn")) $btn = $btn.closest(".btn");
    $btn.button("toggle");
    e.preventDefault();
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.1.1
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element = $(element);
    this.$indicators = this.$element.find(".carousel-indicators");
    this.options = options;
    this.paused =
    this.sliding =
    this.interval =
    this.$active =
    this.$items = null;

    this.options.pause == "hover" && this.$element
      .on("mouseenter", $.proxy(this.pause, this))
      .on("mouseleave", $.proxy(this.cycle, this));
  };

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: "hover",
    wrap: true
  };

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false);

    this.interval && clearInterval(this.interval);

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));

    return this;
  };

  Carousel.prototype.getActiveIndex = function () {
    this.$active = this.$element.find(".item.active");
    this.$items = this.$active.parent().children(".item");

    return this.$items.index(this.$active);
  };

  Carousel.prototype.to = function (pos) {
    var that = this;
    var activeIndex = this.getActiveIndex();

    if (pos > (this.$items.length - 1) || pos < 0) return;

    if (this.sliding) return this.$element.one("slid.bs.carousel", function () { that.to(pos); }); // yes, "slid". not a typo. past tense of "to slide".
    if (activeIndex == pos) return this.pause().cycle();

    return this.slide(pos > activeIndex ? "next" : "prev", $(this.$items[pos]));
  };

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true);

    if (this.$element.find(".next, .prev").length && $.support.transition) {
      this.$element.trigger($.support.transition.end);
      this.cycle(true);
    }

    this.interval = clearInterval(this.interval);

    return this;
  };

  Carousel.prototype.next = function () {
    if (this.sliding) return;
    return this.slide("next");
  };

  Carousel.prototype.prev = function () {
    if (this.sliding) return;
    return this.slide("prev");
  };

  Carousel.prototype.slide = function (type, next) {
    var $active = this.$element.find(".item.active");
    var $next = next || $active[type]();
    var isCycling = this.interval;
    var direction = type == "next" ? "left" : "right";
    var fallback = type == "next" ? "first" : "last";
    var that = this;

    if (!$next.length) {
      if (!this.options.wrap) return;
      $next = this.$element.find(".item")[fallback]();
    }

    if ($next.hasClass("active")) return this.sliding = false;

    var e = $.Event("slide.bs.carousel", { relatedTarget: $next[0], direction: direction });
    this.$element.trigger(e);
    if (e.isDefaultPrevented()) return;

    this.sliding = true;

    isCycling && this.pause();

    if (this.$indicators.length) {
      this.$indicators.find(".active").removeClass("active");
      this.$element.one("slid.bs.carousel", function () { // yes, "slid". not a typo. past tense of "to slide".
        var $nextIndicator = $(that.$indicators.children()[that.getActiveIndex()]);
        $nextIndicator && $nextIndicator.addClass("active");
      });
    }

    if ($.support.transition && this.$element.hasClass("slide")) {
      $next.addClass(type);
      $next[0].offsetWidth; // force reflow
      $active.addClass(direction);
      $next.addClass(direction);
      $active
        .one($.support.transition.end, function () {
          $next.removeClass([type, direction].join(" ")).addClass("active");
          $active.removeClass(["active", direction].join(" "));
          that.sliding = false;
          setTimeout(function () { that.$element.trigger("slid.bs.carousel"); }, 0); // yes, "slid". not a typo. past tense of "to slide".
        })
        .emulateTransitionEnd($active.css("transition-duration").slice(0, -1) * 1000);
    } else {
      $active.removeClass("active");
      $next.addClass("active");
      this.sliding = false;
      this.$element.trigger("slid.bs.carousel"); // yes, "slid". not a typo. past tense of "to slide".
    }

    isCycling && this.cycle();

    return this;
  };

  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  var old = $.fn.carousel;

  $.fn.carousel = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.carousel");
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option === "object" && option);
      var action = typeof option === "string" ? option : options.slide;

      if (!data) $this.data("bs.carousel", (data = new Carousel(this, options)));
      if (typeof option === "number") data.to(option);
      else if (action) data[action]();
      else if (options.interval) data.pause().cycle();
    });
  };

  $.fn.carousel.Constructor = Carousel;

  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old;
    return this;
  };

  // CAROUSEL DATA-API
  // =================

  $(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", function (e) {
    var $this = $(this), href;
    var $target = $($this.attr("data-target") || (href = $this.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, "")); // strip for ie7
    var options = $.extend({}, $target.data(), $this.data());
    var slideIndex = $this.attr("data-slide-to");
    if (slideIndex) options.interval = false;

    $target.carousel(options);

    if (slideIndex = $this.attr("data-slide-to")) {
      $target.data("bs.carousel").to(slideIndex);
    }

    e.preventDefault();
  });

  $(window).on("load", function () {
    $("[data-ride=\"carousel\"]").each(function () {
      var $carousel = $(this);
      $carousel.carousel($carousel.data());
    });
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.1.1
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Collapse.DEFAULTS, options);
    this.transitioning = null;

    if (this.options.parent) this.$parent = $(this.options.parent);
    if (this.options.toggle) this.toggle();
  };

  Collapse.DEFAULTS = {
    toggle: true
  };

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass("width");
    return hasWidth ? "width" : "height";
  };

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass("in")) return;

    var startEvent = $.Event("show.bs.collapse");
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    var actives = this.$parent && this.$parent.find("> .panel > .in");

    if (actives && actives.length) {
      var hasData = actives.data("bs.collapse");
      if (hasData && hasData.transitioning) return;
      actives.collapse("hide");
      hasData || actives.data("bs.collapse", null);
    }

    var dimension = this.dimension();

    this.$element
      .removeClass("collapse")
      .addClass("collapsing")[dimension](0);

    this.transitioning = 1;

    var complete = function (e) {
      if (e && e.target != this.$element[0]) {
        this.$element
          .one($.support.transition.end, $.proxy(complete, this));
        return;
      }
      this.$element
        .removeClass("collapsing")
        .addClass("collapse in")[dimension]("");
      this.transitioning = 0;
      this.$element.trigger("shown.bs.collapse");
    };

    if (!$.support.transition) return complete.call(this);

    var scrollSize = $.camelCase(["scroll", dimension].join("-"));

    this.$element
      .one($.support.transition.end, $.proxy(complete, this))
      .emulateTransitionEnd(350)[dimension](this.$element[0][scrollSize]);
  };

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass("in")) return;

    var startEvent = $.Event("hide.bs.collapse");
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    var dimension = this.dimension();

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;

    this.$element
      .addClass("collapsing")
      .removeClass("collapse")
      .removeClass("in");

    this.transitioning = 1;

    var complete = function (e) {
      if (e && e.target != this.$element[0]) {
        this.$element
          .one($.support.transition.end, $.proxy(complete, this));
        return;
      }
      this.transitioning = 0;
      this.$element
        .trigger("hidden.bs.collapse")
        .removeClass("collapsing")
        .addClass("collapse");
    };

    if (!$.support.transition) return complete.call(this);

    this.$element
      [dimension](0)
      .one($.support.transition.end, $.proxy(complete, this))
      .emulateTransitionEnd(350);
  };

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  };

  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  var old = $.fn.collapse;

  $.fn.collapse = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.collapse");
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option === "object" && option);

      if (!data && options.toggle && option == "show") option = !option;
      if (!data) $this.data("bs.collapse", (data = new Collapse(this, options)));
      if (typeof option === "string") data[option]();
    });
  };

  $.fn.collapse.Constructor = Collapse;

  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  };

  // COLLAPSE DATA-API
  // =================

  $(document).on("click.bs.collapse.data-api", "[data-toggle=\"collapse\"]", function (e) {
    var $this = $(this), href;
    var target = $this.attr("data-target")
        || e.preventDefault()
        || (href = $this.attr("href")) && href.replace(/.*(?=#[^\s]+$)/, ""); // strip for ie7
    var $target = $(target);
    var data = $target.data("bs.collapse");
    var option = data ? "toggle" : $this.data();
    var parent = $this.attr("data-parent");
    var $parent = parent && $(parent);

    if (!data || !data.transitioning) {
      if ($parent) $parent.find("[data-toggle=\"collapse\"][data-parent=\"" + parent + "\"]").not($this).addClass("collapsed");
      $this[$target.hasClass("in") ? "addClass" : "removeClass"]("collapsed");
    }

    $target.collapse(option);
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.1.1
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = ".dropdown-backdrop";
  var toggle = "[data-toggle=\"dropdown\"]";
  var Dropdown = function (element) {
    $(element).on("click.bs.dropdown", this.toggle);
  };

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this);

    if ($this.is(".disabled, :disabled")) return;

    var $parent = getParent($this);
    var isActive = $parent.hasClass("open");

    clearMenus();

    if (!isActive) {
      if ("ontouchstart" in document.documentElement && !$parent.closest(".navbar-nav").length) {
        // if mobile we use a backdrop because click events don't delegate
        $("<div class=\"dropdown-backdrop\"/>").insertAfter($(this)).on("click", clearMenus);
      }

      var relatedTarget = { relatedTarget: this };
      $parent.trigger(e = $.Event("show.bs.dropdown", relatedTarget));

      if (e.isDefaultPrevented()) return;

      $this.trigger("focus");

      $parent
        .toggleClass("open")
        .trigger("shown.bs.dropdown", relatedTarget);
    }

    return false;
  };

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27)/.test(e.keyCode)) return;

    var $this = $(this);

    e.preventDefault();
    e.stopPropagation();

    if ($this.is(".disabled, :disabled")) return;

    var $parent = getParent($this);
    var isActive = $parent.hasClass("open");

    if (!isActive || (isActive && e.keyCode == 27)) {
      if (e.which == 27) $parent.find(toggle).trigger("focus");
      return $this.trigger("click");
    }

    var desc = " li:not(.divider):visible a";
    var $items = $parent.find("[role=\"menu\"]" + desc + ", [role=\"listbox\"]" + desc);

    if (!$items.length) return;

    var index = $items.index($items.filter(":focus"));

    if (e.keyCode == 38 && index > 0) index--; // up
    if (e.keyCode == 40 && index < $items.length - 1) index++; // down
    if (!~index) index = 0;

    $items.eq(index).trigger("focus");
  };

  function clearMenus(e) {
    if (e && e.which === 3) return;
    $(backdrop).remove();
    $(toggle).each(function () {
      var $parent = getParent($(this));
      var relatedTarget = { relatedTarget: this };
      if (!$parent.hasClass("open")) return;
      $parent.trigger(e = $.Event("hide.bs.dropdown", relatedTarget));
      if (e.isDefaultPrevented()) return;
      $parent.removeClass("open").trigger("hidden.bs.dropdown", relatedTarget);
    });
  }

  function getParent($this) {
    var selector = $this.attr("data-target");

    if (!selector) {
      selector = $this.attr("href");
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
    }

    var $parent = selector && $(selector);

    return $parent && $parent.length ? $parent : $this.parent();
  }

  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  var old = $.fn.dropdown;

  $.fn.dropdown = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.dropdown");

      if (!data) $this.data("bs.dropdown", (data = new Dropdown(this)));
      if (typeof option === "string") data[option].call($this);
    });
  };

  $.fn.dropdown.Constructor = Dropdown;

  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old;
    return this;
  };

  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on("click.bs.dropdown.data-api", clearMenus)
    .on("click.bs.dropdown.data-api", ".dropdown form", function (e) { e.stopPropagation(); })
    .on("click.bs.dropdown.data-api", toggle, Dropdown.prototype.toggle)
    .on("keydown.bs.dropdown.data-api", toggle + ", [role=\"menu\"], [role=\"listbox\"]", Dropdown.prototype.keydown);

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.1.1
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    this.element = $(element);
  };

  Tab.prototype.show = function () {
    var $this = this.element;
    var $ul = $this.closest("ul:not(.dropdown-menu)");
    var selector = $this.data("target");

    if (!selector) {
      selector = $this.attr("href");
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ""); // strip for ie7
    }

    if ($this.parent("li").hasClass("active")) return;

    var previous = $ul.find(".active:last a")[0];
    var e = $.Event("show.bs.tab", {
      relatedTarget: previous
    });

    $this.trigger(e);

    if (e.isDefaultPrevented()) return;

    var $target = $(selector);

    this.activate($this.parent("li"), $ul);
    this.activate($target, $target.parent(), function () {
      $this.trigger({
        type: "shown.bs.tab",
        relatedTarget: previous
      });
    });
  };

  Tab.prototype.activate = function (element, container, callback) {
    var $active = container.find("> .active");
    var transition = callback
      && $.support.transition
      && $active.hasClass("fade");

    function next() {
      $active
        .removeClass("active")
        .find("> .dropdown-menu > .active")
        .removeClass("active");

      element.addClass("active");

      if (transition) {
        element[0].offsetWidth; // reflow for transition
        element.addClass("in");
      } else {
        element.removeClass("fade");
      }

      if (element.parent(".dropdown-menu")) {
        element.closest("li.dropdown").addClass("active");
      }

      callback && callback();
    }

    transition ?
      $active
        .one($.support.transition.end, next)
        .emulateTransitionEnd(150) :
      next();

    $active.removeClass("in");
  };

  // TAB PLUGIN DEFINITION
  // =====================

  var old = $.fn.tab;

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.tab");

      if (!data) $this.data("bs.tab", (data = new Tab(this)));
      if (typeof option === "string") data[option]();
    });
  };

  $.fn.tab.Constructor = Tab;

  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old;
    return this;
  };

  // TAB DATA-API
  // ============

  $(document).on("click.bs.tab.data-api", "[data-toggle=\"tab\"], [data-toggle=\"pill\"]", function (e) {
    e.preventDefault();
    $(this).tab("show");
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.1.1
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement("bootstrap");

    var transEndEventNames = {
      WebkitTransition: "webkitTransitionEnd",
      MozTransition: "transitionend",
      OTransition: "oTransitionEnd otransitionend",
      transition: "transitionend"
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] };
      }
    }

    return false; // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false, $el = this;
    $(this).one($.support.transition.end, function () { called = true; });
    var callback = function () { if (!called) $($el).trigger($.support.transition.end); };
    setTimeout(callback, duration);
    return this;
  };

  $(function () {
    $.support.transition = transitionEnd();
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.1.1
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    var href;
    var process = $.proxy(this.process, this);

    this.$element = $(element).is("body") ? $(window) : $(element);
    this.$body = $("body");
    this.$scrollElement = this.$element.on("scroll.bs.scrollspy", process);
    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
    this.selector = (this.options.target
      || ((href = $(element).attr("href")) && href.replace(/.*(?=#[^\s]+$)/, "")) // strip for ie7
      || "") + " .nav li > a";
    this.offsets = $([]);
    this.targets = $([]);
    this.activeTarget = null;

    this.refresh();
    this.process();
  }

  ScrollSpy.DEFAULTS = {
    offset: 10
  };

  ScrollSpy.prototype.refresh = function () {
    var offsetMethod = this.$element[0] == window ? "offset" : "position";

    this.offsets = $([]);
    this.targets = $([]);

    var self = this;

    this.$body
      .find(this.selector)
      .map(function () {
        var $el = $(this);
        var href = $el.data("target") || $el.attr("href");
        var $href = /^#./.test(href) && $(href);

        return ($href
          && $href.length
          && $href.is(":visible")
          && [[ $href[offsetMethod]().top + (!$.isWindow(self.$scrollElement.get(0)) && self.$scrollElement.scrollTop()), href ]]) || null;
      })
      .sort(function (a, b) { return a[0] - b[0]; })
      .each(function () {
        self.offsets.push(this[0]);
        self.targets.push(this[1]);
      });
  };

  ScrollSpy.prototype.process = function () {
    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
    var scrollHeight = this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
    var maxScroll = scrollHeight - this.$scrollElement.height();
    var offsets = this.offsets;
    var targets = this.targets;
    var activeTarget = this.activeTarget;
    var i;

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets.last()[0]) && this.activate(i);
    }

    if (activeTarget && scrollTop <= offsets[0]) {
      return activeTarget != (i = targets[0]) && this.activate(i);
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (!offsets[i + 1] || scrollTop <= offsets[i + 1])
        && this.activate( targets[i] );
    }
  };

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target;

    $(this.selector)
      .parentsUntil(this.options.target, ".active")
      .removeClass("active");

    var selector = this.selector +
        "[data-target=\"" + target + "\"]," +
        this.selector + "[href=\"" + target + "\"]";

    var active = $(selector)
      .parents("li")
      .addClass("active");

    if (active.parent(".dropdown-menu").length) {
      active = active
        .closest("li.dropdown")
        .addClass("active");
    }

    active.trigger("activate.bs.scrollspy");
  };

  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  var old = $.fn.scrollspy;

  $.fn.scrollspy = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.scrollspy");
      var options = typeof option === "object" && option;

      if (!data) $this.data("bs.scrollspy", (data = new ScrollSpy(this, options)));
      if (typeof option === "string") data[option]();
    });
  };

  $.fn.scrollspy.Constructor = ScrollSpy;

  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old;
    return this;
  };

  // SCROLLSPY DATA-API
  // ==================

  $(window).on("load.bs.scrollspy.data-api", function () {
    $("[data-spy=\"scroll\"]").each(function () {
      var $spy = $(this);
      $spy.scrollspy($spy.data());
    });
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.1.1
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options;
    this.$body = $(document.body);
    this.$element = $(element);
    this.$backdrop =
    this.isShown = null;
    this.scrollbarWidth = 0;

    if (this.options.remote) {
      this.$element
        .find(".modal-content")
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger("loaded.bs.modal");
        }, this));
    }
  };

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  };

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget);
  };

  Modal.prototype.show = function (_relatedTarget) {
    var that = this;
    var e = $.Event("show.bs.modal", { relatedTarget: _relatedTarget });

    this.$element.trigger(e);

    if (this.isShown || e.isDefaultPrevented()) return;

    this.isShown = true;

    this.checkScrollbar();
    this.$body.addClass("modal-open");

    this.setScrollbar();
    this.escape();

    this.$element.on("click.dismiss.bs.modal", "[data-dismiss=\"modal\"]", $.proxy(this.hide, this));

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass("fade");

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body); // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0);

      if (transition) {
        that.$element[0].offsetWidth; // force reflow
      }

      that.$element
        .addClass("in")
        .attr("aria-hidden", false);

      that.enforceFocus();

      var e = $.Event("shown.bs.modal", { relatedTarget: _relatedTarget });

      transition ?
        that.$element.find(".modal-dialog") // wait for modal to slide in
          .one($.support.transition.end, function () {
            that.$element.trigger("focus").trigger(e);
          })
          .emulateTransitionEnd(300) :
        that.$element.trigger("focus").trigger(e);
    });
  };

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault();

    e = $.Event("hide.bs.modal");

    this.$element.trigger(e);

    if (!this.isShown || e.isDefaultPrevented()) return;

    this.isShown = false;

    this.$body.removeClass("modal-open");

    this.resetScrollbar();
    this.escape();

    $(document).off("focusin.bs.modal");

    this.$element
      .removeClass("in")
      .attr("aria-hidden", true)
      .off("click.dismiss.bs.modal");

    $.support.transition && this.$element.hasClass("fade") ?
      this.$element
        .one($.support.transition.end, $.proxy(this.hideModal, this))
        .emulateTransitionEnd(300) :
      this.hideModal();
  };

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off("focusin.bs.modal") // guard against infinite focus loop
      .on("focusin.bs.modal", $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger("focus");
        }
      }, this));
  };

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on("keyup.dismiss.bs.modal", $.proxy(function (e) {
        e.which == 27 && this.hide();
      }, this));
    } else if (!this.isShown) {
      this.$element.off("keyup.dismiss.bs.modal");
    }
  };

  Modal.prototype.hideModal = function () {
    var that = this;
    this.$element.hide();
    this.backdrop(function () {
      that.$element.trigger("hidden.bs.modal");
    });
  };

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove();
    this.$backdrop = null;
  };

  Modal.prototype.backdrop = function (callback) {
    var that = this;
    var animate = this.$element.hasClass("fade") ? "fade" : "";

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate;

      this.$backdrop = $("<div class=\"modal-backdrop " + animate + "\" />")
        .appendTo(this.$body);

      this.$element.on("click.dismiss.bs.modal", $.proxy(function (e) {
        if (e.target !== e.currentTarget) return;
        this.options.backdrop == "static"
          ? this.$element[0].focus.call(this.$element[0])
          : this.hide.call(this);
      }, this));

      if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

      this.$backdrop.addClass("in");

      if (!callback) return;

      doAnimate ?
        this.$backdrop
          .one($.support.transition.end, callback)
          .emulateTransitionEnd(150) :
        callback();

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass("in");

      var callbackRemove = function () {
        that.removeBackdrop();
        callback && callback();
      };
      $.support.transition && this.$element.hasClass("fade") ?
        this.$backdrop
          .one($.support.transition.end, callbackRemove)
          .emulateTransitionEnd(150) :
        callbackRemove();

    } else if (callback) {
      callback();
    }
  };

  Modal.prototype.checkScrollbar = function () {
    if (document.body.clientWidth >= window.innerWidth) return;
    this.scrollbarWidth = this.scrollbarWidth || this.measureScrollbar();
  };

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt(this.$body.css("padding-right") || 0);
    if (this.scrollbarWidth) this.$body.css("padding-right", bodyPad + this.scrollbarWidth);
  };

  Modal.prototype.resetScrollbar = function () {
    this.$body.css("padding-right", "");
  };

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    this.$body.append(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    this.$body[0].removeChild(scrollDiv);
    return scrollbarWidth;
  };

  // MODAL PLUGIN DEFINITION
  // =======================

  var old = $.fn.modal;

  $.fn.modal = function (option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.modal");
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option === "object" && option);

      if (!data) $this.data("bs.modal", (data = new Modal(this, options)));
      if (typeof option === "string") data[option](_relatedTarget);
      else if (options.show) data.show(_relatedTarget);
    });
  };

  $.fn.modal.Constructor = Modal;

  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old;
    return this;
  };

  // MODAL DATA-API
  // ==============

  $(document).on("click.bs.modal.data-api", "[data-toggle=\"modal\"]", function (e) {
    var $this = $(this);
    var href = $this.attr("href");
    var $target = $($this.attr("data-target") || (href && href.replace(/.*(?=#[^\s]+$)/, ""))); // strip for ie7
    var option = $target.data("bs.modal") ? "toggle" : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

    if ($this.is("a")) e.preventDefault();

    $target
      .modal(option, this)
      .one("hide", function () {
        $this.is(":visible") && $this.trigger("focus");
      });
  });

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.1.1
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type =
    this.options =
    this.enabled =
    this.timeout =
    this.hoverState =
    this.$element = null;

    this.init("tooltip", element, options);
  };

  Tooltip.DEFAULTS = {
    animation: true,
    placement: "top",
    selector: false,
    template: "<div class=\"tooltip\" role=\"tooltip\"><div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\"></div></div>",
    trigger: "hover focus",
    title: "",
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: "body",
      padding: 0
    }
  };

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled = true;
    this.type = type;
    this.$element = $(element);
    this.options = this.getOptions(options);
    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport);

    var triggers = this.options.trigger.split(" ");

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i];

      if (trigger == "click") {
        this.$element.on("click." + this.type, this.options.selector, $.proxy(this.toggle, this));
      } else if (trigger != "manual") {
        var eventIn = trigger == "hover" ? "mouseenter" : "focusin";
        var eventOut = trigger == "hover" ? "mouseleave" : "focusout";

        this.$element.on(eventIn + "." + this.type, this.options.selector, $.proxy(this.enter, this));
        this.$element.on(eventOut + "." + this.type, this.options.selector, $.proxy(this.leave, this));
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: "manual", selector: "" })) :
      this.fixTitle();
  };

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS;
  };

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options);

    if (options.delay && typeof options.delay === "number") {
      options.delay = {
        show: options.delay,
        hide: options.delay
      };
    }

    return options;
  };

  Tooltip.prototype.getDelegateOptions = function () {
    var options = {};
    var defaults = this.getDefaults();

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value;
    });

    return options;
  };

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type);

    clearTimeout(self.timeout);

    self.hoverState = "in";

    if (!self.options.delay || !self.options.delay.show) return self.show();

    self.timeout = setTimeout(function () {
      if (self.hoverState == "in") self.show();
    }, self.options.delay.show);
  };

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type);

    clearTimeout(self.timeout);

    self.hoverState = "out";

    if (!self.options.delay || !self.options.delay.hide) return self.hide();

    self.timeout = setTimeout(function () {
      if (self.hoverState == "out") self.hide();
    }, self.options.delay.hide);
  };

  Tooltip.prototype.show = function () {
    var e = $.Event("show.bs." + this.type);

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e);

      if (e.isDefaultPrevented()) return;
      var that = this;

      var $tip = this.tip();

      this.setContent();

      if (this.options.animation) $tip.addClass("fade");

      var placement = typeof this.options.placement === "function" ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement;

      var autoToken = /\s?auto?\s?/i;
      var autoPlace = autoToken.test(placement);
      if (autoPlace) placement = placement.replace(autoToken, "") || "top";

      $tip
        .detach()
        .css({ top: 0, left: 0, display: "block" })
        .addClass(placement);

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);

      var pos = this.getPosition();
      var actualWidth = $tip[0].offsetWidth;
      var actualHeight = $tip[0].offsetHeight;

      if (autoPlace) {
        var orgPlacement = placement;
        var $parent = this.$element.parent();
        var parentDim = this.getPosition($parent);

        placement = placement == "bottom" && pos.top + pos.height + actualHeight - parentDim.scroll > parentDim.height ? "top" :
          placement == "top" && pos.top - parentDim.scroll - actualHeight < 0 ? "bottom" :
            placement == "right" && pos.right + actualWidth > parentDim.width ? "left" :
              placement == "left" && pos.left - actualWidth < parentDim.left ? "right" :
                placement;

        $tip
          .removeClass(orgPlacement)
          .addClass(placement);
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

      this.applyPlacement(calculatedOffset, placement);
      this.hoverState = null;

      var complete = function () {
        that.$element.trigger("shown.bs." + that.type);
      };

      $.support.transition && this.$tip.hasClass("fade") ?
        $tip
          .one($.support.transition.end, complete)
          .emulateTransitionEnd(150) :
        complete();
    }
  };

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip = this.tip();
    var width = $tip[0].offsetWidth;
    var height = $tip[0].offsetHeight;

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css("margin-top"), 10);
    var marginLeft = parseInt($tip.css("margin-left"), 10);

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop)) marginTop = 0;
    if (isNaN(marginLeft)) marginLeft = 0;

    offset.top = offset.top + marginTop;
    offset.left = offset.left + marginLeft;

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        });
      }
    }, offset), 0);

    $tip.addClass("in");

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth = $tip[0].offsetWidth;
    var actualHeight = $tip[0].offsetHeight;

    if (placement == "top" && actualHeight != height) {
      offset.top = offset.top + height - actualHeight;
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

    if (delta.left) offset.left += delta.left;
    else offset.top += delta.top;

    var arrowDelta = delta.left ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
    var arrowPosition = delta.left ? "left" : "top";
    var arrowOffsetPosition = delta.left ? "offsetWidth" : "offsetHeight";

    $tip.offset(offset);
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], arrowPosition);
  };

  Tooltip.prototype.replaceArrow = function (delta, dimension, position) {
    this.arrow().css(position, delta ? (50 * (1 - delta / dimension) + "%") : "");
  };

  Tooltip.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();

    $tip.find(".tooltip-inner")[this.options.html ? "html" : "text"](title);
    $tip.removeClass("fade in top bottom left right");
  };

  Tooltip.prototype.hide = function () {
    var that = this;
    var $tip = this.tip();
    var e = $.Event("hide.bs." + this.type);

    function complete() {
      if (that.hoverState != "in") $tip.detach();
      that.$element.trigger("hidden.bs." + that.type);
    }

    this.$element.trigger(e);

    if (e.isDefaultPrevented()) return;

    $tip.removeClass("in");

    $.support.transition && this.$tip.hasClass("fade") ?
      $tip
        .one($.support.transition.end, complete)
        .emulateTransitionEnd(150) :
      complete();

    this.hoverState = null;

    return this;
  };

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element;
    if ($e.attr("title") || typeof($e.attr("data-original-title")) !== "string") {
      $e.attr("data-original-title", $e.attr("title") || "").attr("title", "");
    }
  };

  Tooltip.prototype.hasContent = function () {
    return this.getTitle();
  };

  Tooltip.prototype.getPosition = function ($element) {
    $element = $element || this.$element;
    var el = $element[0];
    var isBody = el.tagName == "BODY";
    return $.extend({}, (typeof el.getBoundingClientRect === "function") ? el.getBoundingClientRect() : null, {
      scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop(),
      width: isBody ? $(window).width() : $element.outerWidth(),
      height: isBody ? $(window).height() : $element.outerHeight()
    }, isBody ? { top: 0, left: 0 } : $element.offset());
  };

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == "bottom" ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } :
      placement == "top" ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
        placement == "left" ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };

  };

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 };
    if (!this.$viewport) return delta;

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
    var viewportDimensions = this.getPosition(this.$viewport);

    if (/right|left/.test(placement)) {
      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset;
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
      }
    } else {
      var leftEdgeOffset = pos.left - viewportPadding;
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset;
      } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
      }
    }

    return delta;
  };

  Tooltip.prototype.getTitle = function () {
    var title;
    var $e = this.$element;
    var o = this.options;

    title = $e.attr("data-original-title")
      || (typeof o.title === "function" ? o.title.call($e[0]) : o.title);

    return title;
  };

  Tooltip.prototype.tip = function () {
    return this.$tip = this.$tip || $(this.options.template);
  };

  Tooltip.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
  };

  Tooltip.prototype.validate = function () {
    if (!this.$element[0].parentNode) {
      this.hide();
      this.$element = null;
      this.options = null;
    }
  };

  Tooltip.prototype.enable = function () {
    this.enabled = true;
  };

  Tooltip.prototype.disable = function () {
    this.enabled = false;
  };

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  };

  Tooltip.prototype.toggle = function (e) {
    var self = e ? $(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type) : this;
    self.tip().hasClass("in") ? self.leave(self) : self.enter(self);
  };

  Tooltip.prototype.destroy = function () {
    clearTimeout(this.timeout);
    this.hide().$element.off("." + this.type).removeData("bs." + this.type);
  };

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  var old = $.fn.tooltip;

  $.fn.tooltip = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.tooltip");
      var options = typeof option === "object" && option;

      if (!data && option == "destroy") return;
      if (!data) $this.data("bs.tooltip", (data = new Tooltip(this, options)));
      if (typeof option === "string") data[option]();
    });
  };

  $.fn.tooltip.Constructor = Tooltip;

  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.1.1
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  "use strict";

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init("popover", element, options);
  };

  if (!$.fn.tooltip) throw new Error("Popover requires tooltip.js");

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: "right",
    trigger: "click",
    content: "",
    template: "<div class=\"popover\"><div class=\"arrow\"></div><h3 class=\"popover-title\"></h3><div class=\"popover-content\"></div></div>"
  });

  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);

  Popover.prototype.constructor = Popover;

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS;
  };

  Popover.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();
    var content = this.getContent();

    $tip.find(".popover-title")[this.options.html ? "html" : "text"](title);
    $tip.find(".popover-content").empty()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content === "string" ? "html" : "append") : "text"
    ](content);

    $tip.removeClass("fade top bottom left right in");

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find(".popover-title").html()) $tip.find(".popover-title").hide();
  };

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  };

  Popover.prototype.getContent = function () {
    var $e = this.$element;
    var o = this.options;

    return $e.attr("data-content")
      || (typeof o.content === "function" ?
        o.content.call($e[0]) :
        o.content);
  };

  Popover.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".arrow");
  };

  Popover.prototype.tip = function () {
    if (!this.$tip) this.$tip = $(this.options.template);
    return this.$tip;
  };

  // POPOVER PLUGIN DEFINITION
  // =========================

  var old = $.fn.popover;

  $.fn.popover = function (option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data("bs.popover");
      var options = typeof option === "object" && option;

      if (!data && option == "destroy") return;
      if (!data) $this.data("bs.popover", (data = new Popover(this, options)));
      if (typeof option === "string") data[option]();
    });
  };

  $.fn.popover.Constructor = Popover;

  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old;
    return this;
  };

}(jQuery);

/**
 * @license AngularJS v1.6.10
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {"use strict";

  var $resourceMinErr = angular.$$minErr("$resource");

  // Helper functions and regex to lookup a dotted path on an object
  // stopping at undefined/null.  The path must be composed of ASCII
  // identifiers (just like $parse)
  var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;

  function isValidDottedPath(path) {
    return (path != null && path !== "" && path !== "hasOwnProperty" &&
      MEMBER_NAME_REGEX.test("." + path));
  }

  function lookupDottedPath(obj, path) {
    if (!isValidDottedPath(path)) {
      throw $resourceMinErr("badmember", "Dotted member path \"@{0}\" is invalid.", path);
    }
    var keys = path.split(".");
    for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
      var key = keys[i];
      obj = (obj !== null) ? obj[key] : undefined;
    }
    return obj;
  }

  /**
 * Create a shallow copy of an object and clear other fields from the destination
 */
  function shallowClearAndCopy(src, dst) {
    dst = dst || {};

    angular.forEach(dst, function (value, key) {
      delete dst[key];
    });

    for (var key in src) {
      if (src.hasOwnProperty(key) && !(key.charAt(0) === "$" && key.charAt(1) === "$")) {
        dst[key] = src[key];
      }
    }

    return dst;
  }

  /**
 * @ngdoc module
 * @name ngResource
 * @description
 *
 * The `ngResource` module provides interaction support with RESTful services
 * via the $resource service.
 *
 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
 */

  /**
 * @ngdoc provider
 * @name $resourceProvider
 *
 * @description
 *
 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
 * service.
 *
 * ## Dependencies
 * Requires the {@link ngResource } module to be installed.
 *
 */

  /**
 * @ngdoc service
 * @name $resource
 * @requires $http
 * @requires ng.$log
 * @requires $q
 * @requires ng.$timeout
 *
 * @description
 * A factory which creates a resource object that lets you interact with
 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
 *
 * The returned resource object has action methods which provide high-level behaviors without
 * the need to interact with the low level {@link ng.$http $http} service.
 *
 * Requires the {@link ngResource `ngResource`} module to be installed.
 *
 * By default, trailing slashes will be stripped from the calculated URLs,
 * which can pose problems with server backends that do not expect that
 * behavior.  This can be disabled by configuring the `$resourceProvider` like
 * this:
 *
 * ```js
     app.config(['$resourceProvider', function($resourceProvider) {
       // Don't strip trailing slashes from calculated URLs
       $resourceProvider.defaults.stripTrailingSlashes = false;
     }]);
 * ```
 *
 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
 *   `/user/:username`. If you are using a URL with a port number (e.g.
 *   `http://example.com:8080/api`), it will be respected.
 *
 *   If you are using a url with a suffix, just add the suffix, like this:
 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
 *   can escape it with `/\.`.
 *
 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
 *   `actions` methods. If a parameter value is a function, it will be called every time
 *   a param value needs to be obtained for a request (unless the param was overridden). The function
 *   will be passed the current data value as an argument.
 *
 *   Each key value in the parameter object is first bound to url template if present and then any
 *   excess keys are appended to the url search query after the `?`.
 *
 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
 *   URL `/path/greet?salutation=Hello`.
 *
 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
 *   extracted from the corresponding property on the `data` object (provided when calling actions
 *   with a request body).
 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
 *   `someParam` will be `data.someProp`.
 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
 *   method that does not accept a request body)
 *
 * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
 *   in addition to the default set of resource actions (see below). If a custom action has the same
 *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
 *   extended.
 *
 *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
 *
 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
 *        ...}
 *
 *   Where:
 *
 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
 *     your resource object.
 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
 *     `DELETE`, `JSONP`, etc).
 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
 *     the parameter value is a function, it will be called every time when a param value needs to
 *     be obtained for a request (unless the param was overridden). The function will be passed the
 *     current data value as an argument.
 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
 *     like for the resource-level urls.
 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
 *     see `returns` section.
 *   - **`transformRequest`** –
 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
 *     transform function or an array of such functions. The transform function takes the http
 *     request body and headers and returns its transformed (typically serialized) version.
 *     By default, transformRequest will contain one function that checks if the request data is
 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
 *     `transformRequest` to an empty array: `transformRequest: []`
 *   - **`transformResponse`** –
 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
 *     transform function or an array of such functions. The transform function takes the http
 *     response body, headers and status and returns its transformed (typically deserialized)
 *     version.
 *     By default, transformResponse will contain one function that checks if the response looks
 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
 *     set `transformResponse` to an empty array: `transformResponse: []`
 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
 *     GET request, otherwise if a cache instance built with
 *     {@link ng.$cacheFactory $cacheFactory} is supplied, this cache will be used for
 *     caching.
 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
 *     **not** supported in $resource, because the same value would be used for multiple requests.
 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
 *     completed/cancelled request will have no effect.<br />
 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
 *     XHR object. See
 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
 *     for more information.
 *   - **`responseType`** - `{string}` - see
 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
 *     with `http response` object. See {@link ng.$http $http interceptors}. In addition, the
 *     resource instance or array object is accessible by the `resource` property of the
 *     `http response` object.
 *     Keep in mind that the associated promise will be resolved with the value returned by the
 *     response interceptor, if one is specified. The default response interceptor returns
 *     `response.resource` (i.e. the resource instance or array).
 *   - **`hasBody`** - `{boolean}` - allows to specify if a request body should be included or not.
 *     If not specified only POST, PUT and PATCH requests will have a body.
 *
 * @param {Object} options Hash with custom settings that should extend the
 *   default `$resourceProvider` behavior.  The supported options are:
 *
 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
 *   slashes from any calculated URL will be stripped. (Defaults to true.)
 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
 *   This can be overwritten per action. (Defaults to false.)
 *
 * @returns {Object} A resource "class" object with methods for the default set of resource actions
 *   optionally extended with custom `actions`. The default set contains these actions:
 *   ```js
 *   { 'get':    {method:'GET'},
 *     'save':   {method:'POST'},
 *     'query':  {method:'GET', isArray:true},
 *     'remove': {method:'DELETE'},
 *     'delete': {method:'DELETE'} };
 *   ```
 *
 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
 *   destination and parameters. When the data is returned from the server then the object is an
 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
 *   read, update, delete) on server-side data like this:
 *   ```js
 *   var User = $resource('/user/:userId', {userId:'@id'});
 *   var user = User.get({userId:123}, function() {
 *     user.abc = true;
 *     user.$save();
 *   });
 *   ```
 *
 *   It is important to realize that invoking a $resource object method immediately returns an
 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
 *   server the existing reference is populated with the actual data. This is a useful trick since
 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
 *   object results in no rendering, once the data arrives from the server then the object is
 *   populated with the data and the view automatically re-renders itself showing the new data. This
 *   means that in most cases one never has to write a callback function for the action methods.
 *
 *   The action methods on the class object or instance object can be invoked with the following
 *   parameters:
 *
 *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
 *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
 *   - instance actions: `instance.$action([parameters], [success], [error])`
 *
 *
 *   When calling instance methods, the instance itself is used as the request body (if the action
 *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
 *   bodies, but you can use the `hasBody` configuration option to specify whether an action
 *   should have a body or not (regardless of its HTTP method).
 *
 *
 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
 *   status (number), statusText (string)) arguments, where the value is the populated resource
 *   instance or collection object. The error callback is called with (httpResponse) argument.
 *
 *   Class actions return empty instance (with additional properties below).
 *   Instance actions return promise of the action.
 *
 *   The Resource instances and collections have these additional properties:
 *
 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
 *     instance or collection.
 *
 *     On success, the promise is resolved with the same resource instance or collection object,
 *     updated with data from server. This makes it easy to use in
 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
 *     rendering until the resource(s) are loaded.
 *
 *     On failure, the promise is rejected with the {@link ng.$http http response} object.
 *
 *     If an interceptor object was provided, the promise will instead be resolved with the value
 *     returned by the interceptor.
 *
 *   - `$resolved`: `true` after first server interaction is completed (either with success or
 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
 *      data-binding.
 *
 *   The Resource instances and collections have these additional methods:
 *
 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
 *      collection, calling this method will abort the request.
 *
 *   The Resource instances have these additional methods:
 *
 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
 *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
 *     `angular.toJson`) automatically use this method when serializing a Resource instance
 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
 *
 * @example
 *
 * ### Credit card resource
 *
 * ```js
     // Define CreditCard class
     var CreditCard = $resource('/user/:userId/card/:cardId',
      {userId:123, cardId:'@id'}, {
       charge: {method:'POST', params:{charge:true}}
      });

     // We can retrieve a collection from the server
     var cards = CreditCard.query(function() {
       // GET: /user/123/card
       // server returns: [ {id:456, number:'1234', name:'Smith'} ];

       var card = cards[0];
       // each item is an instance of CreditCard
       expect(card instanceof CreditCard).toEqual(true);
       card.name = "J. Smith";
       // non GET methods are mapped onto the instances
       card.$save();
       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
       // server returns: {id:456, number:'1234', name: 'J. Smith'};

       // our custom method is mapped as well.
       card.$charge({amount:9.99});
       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
     });

     // we can create an instance as well
     var newCard = new CreditCard({number:'0123'});
     newCard.name = "Mike Smith";
     newCard.$save();
     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
     expect(newCard.id).toEqual(789);
 * ```
 *
 * The object returned from this function execution is a resource "class" which has "static" method
 * for each action in the definition.
 *
 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
 * `headers`.
 *
 * @example
 *
 * ### User resource
 *
 * When the data is returned from the server then the object is an instance of the resource type and
 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
 * operations (create, read, update, delete) on server-side data.

   ```js
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123}, function(user) {
       user.abc = true;
       user.$save();
     });
   ```
 *
 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
 * in the response that came from the server as well as $http header getter function, so one
 * could rewrite the above example and get access to http headers as:
 *
   ```js
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123}, function(user, getResponseHeaders){
       user.abc = true;
       user.$save(function(user, putResponseHeaders) {
         //user => saved user object
         //putResponseHeaders => $http header getter
       });
     });
   ```
 *
 * You can also access the raw `$http` promise via the `$promise` property on the object returned
 *
   ```
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123})
         .$promise.then(function(user) {
           $scope.user = user;
         });
   ```
 *
 * @example
 *
 * ### Creating a custom 'PUT' request
 *
 * In this example we create a custom method on our resource to make a PUT request
 * ```js
 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
 *
 *    // Some APIs expect a PUT request in the format URL/object/ID
 *    // Here we are creating an 'update' method
 *    app.factory('Notes', ['$resource', function($resource) {
 *    return $resource('/notes/:id', null,
 *        {
 *            'update': { method:'PUT' }
 *        });
 *    }]);
 *
 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
 *    // We pass in $routeParams and our Notes factory along with $scope
 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
                                      function($scope, $routeParams, Notes) {
 *    // First get a note object from the factory
 *    var note = Notes.get({ id:$routeParams.id });
 *    $id = note.id;
 *
 *    // Now call update passing in the ID first then the object you are updating
 *    Notes.update({ id:$id }, note);
 *
 *    // This will PUT /notes/ID with the note object in the request payload
 *    }]);
 * ```
 *
 * @example
 *
 * ### Cancelling requests
 *
 * If an action's configuration specifies that it is cancellable, you can cancel the request related
 * to an instance or collection (as long as it is a result of a "non-instance" call):
 *
   ```js
     // ...defining the `Hotel` resource...
     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
       // Let's make the `query()` method cancellable
       query: {method: 'get', isArray: true, cancellable: true}
     });

     // ...somewhere in the PlanVacationController...
     ...
     this.onDestinationChanged = function onDestinationChanged(destination) {
       // We don't care about any pending request for hotels
       // in a different destination any more
       this.availableHotels.$cancelRequest();

       // Let's query for hotels in '<destination>'
       // (calls: /api/hotel?location=<destination>)
       this.availableHotels = Hotel.query({location: destination});
     };
   ```
 *
 */
  angular.module("ngResource", ["ng"]).
    info({ angularVersion: "1.6.10" }).
    provider("$resource", function ResourceProvider() {
      var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;

      var provider = this;

      /**
     * @ngdoc property
     * @name $resourceProvider#defaults
     * @description
     * Object containing default options used when creating `$resource` instances.
     *
     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
     * them to further customize your instances. The available properties are:
     *
     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
     *   calculated URL will be stripped.<br />
     *   (Defaults to true.)
     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
     *   resource class or action.<br />
     *   (Defaults to false.)
     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
     *   object or a collection (array) of objects etc. For more details, see
     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
     *   class.<br />
     *   The default actions are:
     *   ```js
     *   {
     *     get: {method: 'GET'},
     *     save: {method: 'POST'},
     *     query: {method: 'GET', isArray: true},
     *     remove: {method: 'DELETE'},
     *     delete: {method: 'DELETE'}
     *   }
     *   ```
     *
     * #### Example
     *
     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions.update = {
     *         method: 'PUT'
     *       };
     *     }]);
     * ```
     *
     * Or you can even overwrite the whole `actions` list and specify your own:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions = {
     *         create: {method: 'POST'},
     *         get:    {method: 'GET'},
     *         getAll: {method: 'GET', isArray:true},
     *         update: {method: 'PUT'},
     *         delete: {method: 'DELETE'}
     *       };
     *     });
     * ```
     *
     */
      this.defaults = {
      // Strip slashes by default
        stripTrailingSlashes: true,

        // Make non-instance requests cancellable (via `$cancelRequest()`)
        cancellable: false,

        // Default actions configuration
        actions: {
          "get": { method: "GET" },
          "save": { method: "POST" },
          "query": { method: "GET", isArray: true },
          "remove": { method: "DELETE" },
          "delete": { method: "DELETE" }
        }
      };

      this.$get = ["$http", "$log", "$q", "$timeout", function ($http, $log, $q, $timeout) {

        var noop = angular.noop,
          forEach = angular.forEach,
          extend = angular.extend,
          copy = angular.copy,
          isArray = angular.isArray,
          isDefined = angular.isDefined,
          isFunction = angular.isFunction,
          isNumber = angular.isNumber,
          encodeUriQuery = angular.$$encodeUriQuery,
          encodeUriSegment = angular.$$encodeUriSegment;

        function Route(template, defaults) {
          this.template = template;
          this.defaults = extend({}, provider.defaults, defaults);
          this.urlParams = {};
        }

        Route.prototype = {
          setUrlParams: function (config, params, actionUrl) {
            var self = this,
              url = actionUrl || self.template,
              val,
              encodedVal,
              protocolAndIpv6 = "";

            var urlParams = self.urlParams = Object.create(null);
            forEach(url.split(/\W/), function (param) {
              if (param === "hasOwnProperty") {
                throw $resourceMinErr("badname", "hasOwnProperty is not a valid parameter name.");
              }
              if (!(new RegExp("^\\d+$").test(param)) && param &&
              (new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url))) {
                urlParams[param] = {
                  isQueryParamValue: (new RegExp("\\?.*=:" + param + "(?:\\W|$)")).test(url)
                };
              }
            });
            url = url.replace(/\\:/g, ":");
            url = url.replace(PROTOCOL_AND_IPV6_REGEX, function (match) {
              protocolAndIpv6 = match;
              return "";
            });

            params = params || {};
            forEach(self.urlParams, function (paramInfo, urlParam) {
              val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
              if (isDefined(val) && val !== null) {
                if (paramInfo.isQueryParamValue) {
                  encodedVal = encodeUriQuery(val, true);
                } else {
                  encodedVal = encodeUriSegment(val);
                }
                url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function (match, p1) {
                  return encodedVal + p1;
                });
              } else {
                url = url.replace(new RegExp("(/?):" + urlParam + "(\\W|$)", "g"), function (match,
                  leadingSlashes, tail) {
                  if (tail.charAt(0) === "/") {
                    return tail;
                  } else {
                    return leadingSlashes + tail;
                  }
                });
              }
            });

            // strip trailing slashes and set the url (unless this behavior is specifically disabled)
            if (self.defaults.stripTrailingSlashes) {
              url = url.replace(/\/+$/, "") || "/";
            }

            // Collapse `/.` if found in the last URL path segment before the query.
            // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
            url = url.replace(/\/\.(?=\w+($|\?))/, ".");
            // Replace escaped `/\.` with `/.`.
            // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
            config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, "/.");

            // set params - delegate param encoding to $http
            forEach(params, function (value, key) {
              if (!self.urlParams[key]) {
                config.params = config.params || {};
                config.params[key] = value;
              }
            });
          }
        };

        function resourceFactory(url, paramDefaults, actions, options) {
          var route = new Route(url, options);

          actions = extend({}, provider.defaults.actions, actions);

          function extractParams(data, actionParams) {
            var ids = {};
            actionParams = extend({}, paramDefaults, actionParams);
            forEach(actionParams, function (value, key) {
              if (isFunction(value)) { value = value(data); }
              ids[key] = value && value.charAt && value.charAt(0) === "@" ?
                lookupDottedPath(data, value.substr(1)) : value;
            });
            return ids;
          }

          function defaultResponseInterceptor(response) {
            return response.resource;
          }

          function Resource(value) {
            shallowClearAndCopy(value || {}, this);
          }

          Resource.prototype.toJSON = function () {
            var data = extend({}, this);
            delete data.$promise;
            delete data.$resolved;
            delete data.$cancelRequest;
            return data;
          };

          forEach(actions, function (action, name) {
            var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
            var numericTimeout = action.timeout;
            var cancellable = isDefined(action.cancellable) ?
              action.cancellable : route.defaults.cancellable;

            if (numericTimeout && !isNumber(numericTimeout)) {
              $log.debug("ngResource:\n" +
                       "  Only numeric values are allowed as `timeout`.\n" +
                       "  Promises are not supported in $resource, because the same value would " +
                       "be used for multiple requests. If you are looking for a way to cancel " +
                       "requests, you should use the `cancellable` option.");
              delete action.timeout;
              numericTimeout = null;
            }

            Resource[name] = function (a1, a2, a3, a4) {
              var params = {}, data, success, error;

              switch (arguments.length) {
                case 4:
                  error = a4;
                  success = a3;
                // falls through
                case 3:
                case 2:
                  if (isFunction(a2)) {
                    if (isFunction(a1)) {
                      success = a1;
                      error = a2;
                      break;
                    }

                    success = a2;
                    error = a3;
                  // falls through
                  } else {
                    params = a1;
                    data = a2;
                    success = a3;
                    break;
                  }
                // falls through
                case 1:
                  if (isFunction(a1)) success = a1;
                  else if (hasBody) data = a1;
                  else params = a1;
                  break;
                case 0: break;
                default:
                  throw $resourceMinErr("badargs",
                    "Expected up to 4 arguments [params, data, success, error], got {0} arguments",
                    arguments.length);
              }

              var isInstanceCall = this instanceof Resource;
              var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
              var httpConfig = {};
              var responseInterceptor = action.interceptor && action.interceptor.response ||
              defaultResponseInterceptor;
              var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
              undefined;
              var hasError = !!error;
              var hasResponseErrorInterceptor = !!responseErrorInterceptor;
              var timeoutDeferred;
              var numericTimeoutPromise;

              forEach(action, function (value, key) {
                switch (key) {
                  default:
                    httpConfig[key] = copy(value);
                    break;
                  case "params":
                  case "isArray":
                  case "interceptor":
                  case "cancellable":
                    break;
                }
              });

              if (!isInstanceCall && cancellable) {
                timeoutDeferred = $q.defer();
                httpConfig.timeout = timeoutDeferred.promise;

                if (numericTimeout) {
                  numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
                }
              }

              if (hasBody) httpConfig.data = data;
              route.setUrlParams(httpConfig,
                extend({}, extractParams(data, action.params || {}), params),
                action.url);

              var promise = $http(httpConfig).then(function (response) {
                var data = response.data;

                if (data) {
                // Need to convert action.isArray to boolean in case it is undefined
                  if (isArray(data) !== (!!action.isArray)) {
                    throw $resourceMinErr("badcfg",
                      "Error in resource configuration for action `{0}`. Expected response to " +
                      "contain an {1} but got an {2} (Request: {3} {4})", name, action.isArray ? "array" : "object",
                      isArray(data) ? "array" : "object", httpConfig.method, httpConfig.url);
                  }
                  if (action.isArray) {
                    value.length = 0;
                    forEach(data, function (item) {
                      if (typeof item === "object") {
                        value.push(new Resource(item));
                      } else {
                      // Valid JSON values may be string literals, and these should not be converted
                      // into objects. These items will not have access to the Resource prototype
                      // methods, but unfortunately there
                        value.push(item);
                      }
                    });
                  } else {
                    var promise = value.$promise; // Save the promise
                    shallowClearAndCopy(data, value);
                    value.$promise = promise; // Restore the promise
                  }
                }
                response.resource = value;

                return response;
              }, function (response) {
                response.resource = value;
                return $q.reject(response);
              });

              promise = promise["finally"](function () {
                value.$resolved = true;
                if (!isInstanceCall && cancellable) {
                  value.$cancelRequest = noop;
                  $timeout.cancel(numericTimeoutPromise);
                  timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
                }
              });

              promise = promise.then(
                function (response) {
                  var value = responseInterceptor(response);
                  (success || noop)(value, response.headers, response.status, response.statusText);
                  return value;
                },
                (hasError || hasResponseErrorInterceptor) ?
                  function (response) {
                    if (hasError && !hasResponseErrorInterceptor) {
                    // Avoid `Possibly Unhandled Rejection` error,
                    // but still fulfill the returned promise with a rejection
                      promise.catch(noop);
                    }
                    if (hasError) error(response);
                    return hasResponseErrorInterceptor ?
                      responseErrorInterceptor(response) :
                      $q.reject(response);
                  } :
                  undefined);

              if (!isInstanceCall) {
              // we are creating instance / collection
              // - set the initial promise
              // - return the instance / collection
                value.$promise = promise;
                value.$resolved = false;
                if (cancellable) value.$cancelRequest = cancelRequest;

                return value;
              }

              // instance call
              return promise;

              function cancelRequest(value) {
                promise.catch(noop);
                if (timeoutDeferred !== null) {
                  timeoutDeferred.resolve(value);
                }
              }
            };

            Resource.prototype["$" + name] = function (params, success, error) {
              if (isFunction(params)) {
                error = success; success = params; params = {};
              }
              var result = Resource[name].call(this, params, this, success, error);
              return result.$promise || result;
            };
          });

          return Resource;
        }

        return resourceFactory;
      }];
    });

})(window, window.angular);

/**
 * @license AngularJS v1.6.10
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {"use strict";

  /**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 * See {@link ngCookies.$cookies `$cookies`} for usage.
 */

  angular.module("ngCookies", ["ng"]).
    info({ angularVersion: "1.6.10" }).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
    provider("$cookies", [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
      var defaults = this.defaults = {};

      function calcOptions(options) {
        return options ? angular.extend({}, defaults, options) : defaults;
      }

      /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
      this.$get = ["$$cookieReader", "$$cookieWriter", function ($$cookieReader, $$cookieWriter) {
        return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
          get: function (key) {
            return $$cookieReader()[key];
          },

          /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
          getObject: function (key) {
            var value = this.get(key);
            return value ? angular.fromJson(value) : value;
          },

          /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
          getAll: function () {
            return $$cookieReader();
          },

          /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
          put: function (key, value, options) {
            $$cookieWriter(key, value, calcOptions(options));
          },

          /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
          putObject: function (key, value, options) {
            this.put(key, angular.toJson(value), options);
          },

          /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
          remove: function (key, options) {
            $$cookieWriter(key, undefined, calcOptions(options));
          }
        };
      }];
    }]);

  angular.module("ngCookies").
  /**
 * @ngdoc service
 * @name $cookieStore
 * @deprecated
 * sinceVersion="v1.4.0"
 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
 *
 * @requires $cookies
 *
 * @description
 * Provides a key-value (string-object) storage, that is backed by session cookies.
 * Objects put or retrieved from this storage are automatically serialized or
 * deserialized by AngularJS's `toJson`/`fromJson`.
 *
 * Requires the {@link ngCookies `ngCookies`} module to be installed.
 *
 * @example
 *
 * ```js
 * angular.module('cookieStoreExample', ['ngCookies'])
 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
 *     // Put cookie
 *     $cookieStore.put('myFavorite','oatmeal');
 *     // Get cookie
 *     var favoriteCookie = $cookieStore.get('myFavorite');
 *     // Removing a cookie
 *     $cookieStore.remove('myFavorite');
 *   }]);
 * ```
 */
    factory("$cookieStore", ["$cookies", function ($cookies) {

      return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
        get: function (key) {
          return $cookies.getObject(key);
        },

        /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
        put: function (key, value) {
          $cookies.putObject(key, value);
        },

        /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
        remove: function (key) {
          $cookies.remove(key);
        }
      };

    }]);

  /**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
  function $$CookieWriter($document, $log, $browser) {
    var cookiePath = $browser.baseHref();
    var rawDocument = $document[0];

    function buildCookieString(name, value, options) {
      var path, expires;
      options = options || {};
      expires = options.expires;
      path = angular.isDefined(options.path) ? options.path : cookiePath;
      if (angular.isUndefined(value)) {
        expires = "Thu, 01 Jan 1970 00:00:00 GMT";
        value = "";
      }
      if (angular.isString(expires)) {
        expires = new Date(expires);
      }

      var str = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      str += path ? ";path=" + path : "";
      str += options.domain ? ";domain=" + options.domain : "";
      str += expires ? ";expires=" + expires.toUTCString() : "";
      str += options.secure ? ";secure" : "";

      // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
      // - 300 cookies
      // - 20 cookies per unique domain
      // - 4096 bytes per cookie
      var cookieLength = str.length + 1;
      if (cookieLength > 4096) {
        $log.warn("Cookie '" + name +
        "' possibly not set or overflowed because it was too large (" +
        cookieLength + " > 4096 bytes)!");
      }

      return str;
    }

    return function (name, value, options) {
      rawDocument.cookie = buildCookieString(name, value, options);
    };
  }

  $$CookieWriter.$inject = ["$document", "$log", "$browser"];

  angular.module("ngCookies").provider("$$cookieWriter", /** @this */ function $$CookieWriterProvider() {
    this.$get = $$CookieWriter;
  });

})(window, window.angular);

/**
 * @license AngularJS v1.6.10
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {"use strict";

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var $sanitizeMinErr = angular.$$minErr("$sanitize");
  var bind;
  var extend;
  var forEach;
  var isArray;
  var isDefined;
  var lowercase;
  var noop;
  var nodeContains;
  var htmlParser;
  var htmlSanitizeWriter;

  /**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

  /**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
 *   `$compileProvider`}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */

  /**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
  function $SanitizeProvider() {
    var hasBeenInstantiated = false;
    var svgEnabled = false;

    this.$get = ["$$sanitizeUri", function ($$sanitizeUri) {
      hasBeenInstantiated = true;
      if (svgEnabled) {
        extend(validElements, svgElements);
      }
      return function (html) {
        var buf = [];
        htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
          return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
        }));
        return buf.join("");
      };
    }];

    /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
    this.enableSvg = function (enableSvg) {
      if (isDefined(enableSvg)) {
        svgEnabled = enableSvg;
        return this;
      } else {
        return svgEnabled;
      }
    };

    /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
    this.addValidElements = function (elements) {
      if (!hasBeenInstantiated) {
        if (isArray(elements)) {
          elements = { htmlElements: elements };
        }

        addElementsTo(svgElements, elements.svgElements);
        addElementsTo(voidElements, elements.htmlVoidElements);
        addElementsTo(validElements, elements.htmlVoidElements);
        addElementsTo(validElements, elements.htmlElements);
      }

      return this;
    };

    /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationWhitelist aHrefSanitizationWhitelist} and
   * {@link ng.$compileProvider#imgSrcSanitizationWhitelist imgSrcSanitizationWhitelist}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
    this.addValidAttrs = function (attrs) {
      if (!hasBeenInstantiated) {
        extend(validAttrs, arrayToMap(attrs, true));
      }
      return this;
    };

    // ////////////////////////////////////////////////////////////////////////////////////////////////
    // Private stuff
    // ////////////////////////////////////////////////////////////////////////////////////////////////

    bind = angular.bind;
    extend = angular.extend;
    forEach = angular.forEach;
    isArray = angular.isArray;
    isDefined = angular.isDefined;
    lowercase = angular.lowercase;
    noop = angular.noop;

    htmlParser = htmlParserImpl;
    htmlSanitizeWriter = htmlSanitizeWriterImpl;

    nodeContains = window.Node.prototype.contains || /** @this */ function (arg) {
    // eslint-disable-next-line no-bitwise
      return !!(this.compareDocumentPosition(arg) & 16);
    };

    // Regular Expressions for parsing tags and attributes
    var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
      // Match everything outside of normal chars and " (quote character)
      NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;

    // Good source of info about elements and attributes
    // http://dev.w3.org/html5/spec/Overview.html#semantics
    // http://simon.html5.org/html-elements

    // Safe Void Elements - HTML5
    // http://dev.w3.org/html5/spec/Overview.html#void-elements
    var voidElements = stringToMap("area,br,col,hr,img,wbr");

    // Elements that you can, intentionally, leave open (and which close themselves)
    // http://dev.w3.org/html5/spec/Overview.html#optional-tags
    var optionalEndTagBlockElements = stringToMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
      optionalEndTagInlineElements = stringToMap("rp,rt"),
      optionalEndTagElements = extend({},
        optionalEndTagInlineElements,
        optionalEndTagBlockElements);

    // Safe Block Elements - HTML5
    var blockElements = extend({}, optionalEndTagBlockElements, stringToMap("address,article," +
          "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
          "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));

    // Inline Elements - HTML5
    var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap("a,abbr,acronym,b," +
          "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
          "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));

    // SVG Elements
    // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
    // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
    // They can potentially allow for arbitrary javascript to be executed. See #11290
    var svgElements = stringToMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
          "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
          "radialGradient,rect,stop,svg,switch,text,title,tspan");

    // Blocked Elements (will be stripped)
    var blockedElements = stringToMap("script,style");

    var validElements = extend({},
      voidElements,
      blockElements,
      inlineElements,
      optionalEndTagElements);

    // Attributes that have href and hence need to be sanitized
    var uriAttrs = stringToMap("background,cite,href,longdesc,src,xlink:href,xml:base");

    var htmlAttrs = stringToMap("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear," +
      "color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace," +
      "ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules," +
      "scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type," +
      "valign,value,vspace,width");

    // SVG attributes (without "id" and "name" attributes)
    // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
    var svgAttrs = stringToMap("accent-height,accumulate,additive,alphabetic,arabic-form,ascent," +
      "baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content," +
      "cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch," +
      "font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging," +
      "height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang," +
      "marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical," +
      "max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1," +
      "path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur," +
      "requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color," +
      "stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray," +
      "stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity," +
      "stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position," +
      "underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility," +
      "width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title," +
      "xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan", true);

    var validAttrs = extend({},
      uriAttrs,
      svgAttrs,
      htmlAttrs);

    function stringToMap(str, lowercaseKeys) {
      return arrayToMap(str.split(","), lowercaseKeys);
    }

    function arrayToMap(items, lowercaseKeys) {
      var obj = {}, i;
      for (i = 0; i < items.length; i++) {
        obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
      }
      return obj;
    }

    function addElementsTo(elementsMap, newElements) {
      if (newElements && newElements.length) {
        extend(elementsMap, arrayToMap(newElements));
      }
    }

    /**
   * Create an inert document that contains the dirty HTML that needs sanitizing
   * Depending upon browser support we use one of three strategies for doing this.
   * Support: Safari 10.x -> XHR strategy
   * Support: Firefox -> DomParser strategy
   */
    var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function (window, document) {
      var inertDocument;
      if (document && document.implementation) {
        inertDocument = document.implementation.createHTMLDocument("inert");
      } else {
        throw $sanitizeMinErr("noinert", "Can't create an inert html document");
      }
      var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector("body");

      // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
      inertBodyElement.innerHTML = "<svg><g onload=\"this.parentNode.remove()\"></g></svg>";
      if (!inertBodyElement.querySelector("svg")) {
        return getInertBodyElement_XHR;
      } else {
      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
        inertBodyElement.innerHTML = "<svg><p><style><img src=\"</style><img src=x onerror=alert(1)//\">";
        if (inertBodyElement.querySelector("svg img")) {
          return getInertBodyElement_DOMParser;
        } else {
          return getInertBodyElement_InertDocument;
        }
      }

      function getInertBodyElement_XHR(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
        html = "<remove></remove>" + html;
        try {
          html = encodeURI(html);
        } catch (e) {
          return undefined;
        }
        var xhr = new window.XMLHttpRequest();
        xhr.responseType = "document";
        xhr.open("GET", "data:text/html;charset=utf-8," + html, false);
        xhr.send(null);
        var body = xhr.response.body;
        body.firstChild.remove();
        return body;
      }

      function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
        html = "<remove></remove>" + html;
        try {
          var body = new window.DOMParser().parseFromString(html, "text/html").body;
          body.firstChild.remove();
          return body;
        } catch (e) {
          return undefined;
        }
      }

      function getInertBodyElement_InertDocument(html) {
        inertBodyElement.innerHTML = html;

        // Support: IE 9-11 only
        // strip custom-namespaced attributes on IE<=11
        if (document.documentMode) {
          stripCustomNsAttrs(inertBodyElement);
        }

        return inertBodyElement;
      }
    })(window, window.document);

    /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
    function htmlParserImpl(html, handler) {
      if (html === null || html === undefined) {
        html = "";
      } else if (typeof html !== "string") {
        html = "" + html;
      }

      var inertBodyElement = getInertBodyElement(html);
      if (!inertBodyElement) return "";

      // mXSS protection
      var mXSSAttempts = 5;
      do {
        if (mXSSAttempts === 0) {
          throw $sanitizeMinErr("uinput", "Failed to sanitize html because the input is unstable");
        }
        mXSSAttempts--;

        // trigger mXSS if it is going to happen by reading and writing the innerHTML
        html = inertBodyElement.innerHTML;
        inertBodyElement = getInertBodyElement(html);
      } while (html !== inertBodyElement.innerHTML);

      var node = inertBodyElement.firstChild;
      while (node) {
        switch (node.nodeType) {
          case 1: // ELEMENT_NODE
            handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
            break;
          case 3: // TEXT NODE
            handler.chars(node.textContent);
            break;
        }

        var nextNode;
        if (!(nextNode = node.firstChild)) {
          if (node.nodeType === 1) {
            handler.end(node.nodeName.toLowerCase());
          }
          nextNode = getNonDescendant("nextSibling", node);
          if (!nextNode) {
            while (nextNode == null) {
              node = getNonDescendant("parentNode", node);
              if (node === inertBodyElement) break;
              nextNode = getNonDescendant("nextSibling", node);
              if (node.nodeType === 1) {
                handler.end(node.nodeName.toLowerCase());
              }
            }
          }
        }
        node = nextNode;
      }

      while ((node = inertBodyElement.firstChild)) {
        inertBodyElement.removeChild(node);
      }
    }

    function attrToMap(attrs) {
      var map = {};
      for (var i = 0, ii = attrs.length; i < ii; i++) {
        var attr = attrs[i];
        map[attr.name] = attr.value;
      }
      return map;
    }

    /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
    function encodeEntities(value) {
      return value.
        replace(/&/g, "&amp;").
        replace(SURROGATE_PAIR_REGEXP, function (value) {
          var hi = value.charCodeAt(0);
          var low = value.charCodeAt(1);
          return "&#" + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ";";
        }).
        replace(NON_ALPHANUMERIC_REGEXP, function (value) {
          return "&#" + value.charCodeAt(0) + ";";
        }).
        replace(/</g, "&lt;").
        replace(/>/g, "&gt;");
    }

    /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
    function htmlSanitizeWriterImpl(buf, uriValidator) {
      var ignoreCurrentElement = false;
      var out = bind(buf, buf.push);
      return {
        start: function (tag, attrs) {
          tag = lowercase(tag);
          if (!ignoreCurrentElement && blockedElements[tag]) {
            ignoreCurrentElement = tag;
          }
          if (!ignoreCurrentElement && validElements[tag] === true) {
            out("<");
            out(tag);
            forEach(attrs, function (value, key) {
              var lkey = lowercase(key);
              var isImage = (tag === "img" && lkey === "src") || (lkey === "background");
              if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
                out(" ");
                out(key);
                out("=\"");
                out(encodeEntities(value));
                out("\"");
              }
            });
            out(">");
          }
        },
        end: function (tag) {
          tag = lowercase(tag);
          if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
            out("</");
            out(tag);
            out(">");
          }
          // eslint-disable-next-line eqeqeq
          if (tag == ignoreCurrentElement) {
            ignoreCurrentElement = false;
          }
        },
        chars: function (chars) {
          if (!ignoreCurrentElement) {
            out(encodeEntities(chars));
          }
        }
      };
    }

    /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
    function stripCustomNsAttrs(node) {
      while (node) {
        if (node.nodeType === window.Node.ELEMENT_NODE) {
          var attrs = node.attributes;
          for (var i = 0, l = attrs.length; i < l; i++) {
            var attrNode = attrs[i];
            var attrName = attrNode.name.toLowerCase();
            if (attrName === "xmlns:ns1" || attrName.lastIndexOf("ns1:", 0) === 0) {
              node.removeAttributeNode(attrNode);
              i--;
              l--;
            }
          }
        }

        var nextNode = node.firstChild;
        if (nextNode) {
          stripCustomNsAttrs(nextNode);
        }

        node = getNonDescendant("nextSibling", node);
      }
    }

    function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
      var nextNode = node[propName];
      if (nextNode && nodeContains.call(node, nextNode)) {
        throw $sanitizeMinErr("elclob", "Failed to sanitize html because the element is clobbered: {0}", node.outerHTML || node.outerText);
      }
      return nextNode;
    }
  }

  function sanitizeText(chars) {
    var buf = [];
    var writer = htmlSanitizeWriter(buf, noop);
    writer.chars(chars);
    return buf.join("");
  }

  // define ngSanitize module and register $sanitize service
  angular.module("ngSanitize", [])
    .provider("$sanitize", $SanitizeProvider)
    .info({ angularVersion: "1.6.10" });

  /**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
  angular.module("ngSanitize").filter("linky", ["$sanitize", function ($sanitize) {
    var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

    var linkyMinErr = angular.$$minErr("linky");
    var isDefined = angular.isDefined;
    var isFunction = angular.isFunction;
    var isObject = angular.isObject;
    var isString = angular.isString;

    return function (text, target, attributes) {
      if (text == null || text === "") return text;
      if (!isString(text)) throw linkyMinErr("notstring", "Expected string but received: {0}", text);

      var attributesFn =
      isFunction(attributes) ? attributes :
        isObject(attributes) ? function getAttributesObject() {return attributes;} :
          function getEmptyAttributesObject() {return {};};

      var match;
      var raw = text;
      var html = [];
      var url;
      var i;
      while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
        url = match[0];
        // if we did not match ftp/http/www/mailto then assume mailto
        if (!match[2] && !match[4]) {
          url = (match[3] ? "http://" : "mailto:") + url;
        }
        i = match.index;
        addText(raw.substr(0, i));
        addLink(url, match[0].replace(MAILTO_REGEXP, ""));
        raw = raw.substring(i + match[0].length);
      }
      addText(raw);
      return $sanitize(html.join(""));

      function addText(text) {
        if (!text) {
          return;
        }
        html.push(sanitizeText(text));
      }

      function addLink(url, text) {
        var key, linkAttributes = attributesFn(url);
        html.push("<a ");

        for (key in linkAttributes) {
          html.push(key + "=\"" + linkAttributes[key] + "\" ");
        }

        if (isDefined(target) && !("target" in linkAttributes)) {
          html.push("target=\"",
            target,
            "\" ");
        }
        html.push("href=\"",
          url.replace(/"/g, "&quot;"),
          "\">");
        addText(text);
        html.push("</a>");
      }
    };
  }]);

})(window, window.angular);

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.11.2 - 2014-09-26
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.bindHtml", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.dropdown", "ui.bootstrap.modal", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html", "template/accordion/accordion.html", "template/alert/alert.html", "template/carousel/carousel.html", "template/carousel/slide.html", "template/datepicker/datepicker.html", "template/datepicker/day.html", "template/datepicker/month.html", "template/datepicker/popup.html", "template/datepicker/year.html", "template/modal/backdrop.html", "template/modal/window.html", "template/pagination/pager.html", "template/pagination/pagination.html", "template/tooltip/tooltip-html-unsafe-popup.html", "template/tooltip/tooltip-popup.html", "template/popover/popover.html", "template/progressbar/bar.html", "template/progressbar/progress.html", "template/progressbar/progressbar.html", "template/rating/rating.html", "template/tabs/tab.html", "template/tabs/tabset.html", "template/timepicker/timepicker.html", "template/typeahead/typeahead-match.html", "template/typeahead/typeahead-popup.html"]);
angular.module("ui.bootstrap.transition", [])

/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */
  .factory("$transition", ["$q", "$timeout", "$rootScope", function ($q, $timeout, $rootScope) {

    var $transition = function (element, trigger, options) {
      options = options || {};
      var deferred = $q.defer();
      var endEventName = $transition[options.animation ? "animationEndEventName" : "transitionEndEventName"];

      var transitionEndHandler = function (event) {
        $rootScope.$apply(function () {
          element.unbind(endEventName, transitionEndHandler);
          deferred.resolve(element);
        });
      };

      if (endEventName) {
        element.bind(endEventName, transitionEndHandler);
      }

      // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
      $timeout(function () {
        if ( angular.isString(trigger) ) {
          element.addClass(trigger);
        } else if ( angular.isFunction(trigger) ) {
          trigger(element);
        } else if ( angular.isObject(trigger) ) {
          element.css(trigger);
        }
        // If browser does not support transitions, instantly resolve
        if ( !endEventName ) {
          deferred.resolve(element);
        }
      });

      // Add our custom cancel function to the promise that is returned
      // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
      // i.e. it will therefore never raise a transitionEnd event for that transition
      deferred.promise.cancel = function () {
        if ( endEventName ) {
          element.unbind(endEventName, transitionEndHandler);
        }
        deferred.reject("Transition cancelled");
      };

      return deferred.promise;
    };

    // Work out the name of the transitionEnd event
    var transElement = document.createElement("trans");
    var transitionEndEventNames = {
      "WebkitTransition": "webkitTransitionEnd",
      "MozTransition": "transitionend",
      "OTransition": "oTransitionEnd",
      "transition": "transitionend"
    };
    var animationEndEventNames = {
      "WebkitTransition": "webkitAnimationEnd",
      "MozTransition": "animationend",
      "OTransition": "oAnimationEnd",
      "transition": "animationend"
    };
    function findEndEventName(endEventNames) {
      for (var name in endEventNames) {
        if (transElement.style[name] !== undefined) {
          return endEventNames[name];
        }
      }
    }
    $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
    $transition.animationEndEventName = findEndEventName(animationEndEventNames);
    return $transition;
  }]);

angular.module("ui.bootstrap.collapse", ["ui.bootstrap.transition"])

  .directive("collapse", ["$transition", function ($transition) {

    return {
      link: function (scope, element, attrs) {

        var initialAnimSkip = true;
        var currentTransition;

        function doTransition(change) {
          var newTransition = $transition(element, change);
          if (currentTransition) {
            currentTransition.cancel();
          }
          currentTransition = newTransition;
          newTransition.then(newTransitionDone, newTransitionDone);
          return newTransition;

          function newTransitionDone() {
            // Make sure it's this transition, otherwise, leave it alone.
            if (currentTransition === newTransition) {
              currentTransition = undefined;
            }
          }
        }

        function expand() {
          if (initialAnimSkip) {
            initialAnimSkip = false;
            expandDone();
          } else {
            element.removeClass("collapse").addClass("collapsing");
            doTransition({ height: element[0].scrollHeight + "px" }).then(expandDone);
          }
        }

        function expandDone() {
          element.removeClass("collapsing");
          element.addClass("collapse in");
          element.css({ height: "auto" });
        }

        function collapse() {
          if (initialAnimSkip) {
            initialAnimSkip = false;
            collapseDone();
            element.css({ height: 0 });
          } else {
            // CSS transitions don't work with height: auto, so we have to manually change the height to a specific value
            element.css({ height: element[0].scrollHeight + "px" });
            // trigger reflow so a browser realizes that height was updated from auto to a specific value
            var x = element[0].offsetWidth;

            element.removeClass("collapse in").addClass("collapsing");

            doTransition({ height: 0 }).then(collapseDone);
          }
        }

        function collapseDone() {
          element.removeClass("collapsing");
          element.addClass("collapse");
        }

        scope.$watch(attrs.collapse, function (shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module("ui.bootstrap.accordion", ["ui.bootstrap.collapse"])

  .constant("accordionConfig", {
    closeOthers: true
  })

  .controller("AccordionController", ["$scope", "$attrs", "accordionConfig", function ($scope, $attrs, accordionConfig) {

    // This array keeps track of the accordion groups
    this.groups = [];

    // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
    this.closeOthers = function (openGroup) {
      var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
      if ( closeOthers ) {
        angular.forEach(this.groups, function (group) {
          if ( group !== openGroup ) {
            group.isOpen = false;
          }
        });
      }
    };

    // This is called from the accordion-group directive to add itself to the accordion
    this.addGroup = function (groupScope) {
      var that = this;
      this.groups.push(groupScope);

      groupScope.$on("$destroy", function (event) {
        that.removeGroup(groupScope);
      });
    };

    // This is called from the accordion-group directive when to remove itself
    this.removeGroup = function (group) {
      var index = this.groups.indexOf(group);
      if ( index !== -1 ) {
        this.groups.splice(index, 1);
      }
    };

  }])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
  .directive("accordion", function () {
    return {
      restrict: "EA",
      controller: "AccordionController",
      transclude: true,
      replace: false,
      templateUrl: "template/accordion/accordion.html"
    };
  })

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
  .directive("accordionGroup", function () {
    return {
      require: "^accordion", // We need this directive to be inside an accordion
      restrict: "EA",
      transclude: true, // It transcludes the contents of the directive into the template
      replace: true, // The element containing the directive will be replaced with the template
      templateUrl: "template/accordion/accordion-group.html",
      scope: {
        heading: "@", // Interpolate the heading attribute onto this scope
        isOpen: "=?",
        isDisabled: "=?"
      },
      controller: function () {
        this.setHeading = function (element) {
          this.heading = element;
        };
      },
      link: function (scope, element, attrs, accordionCtrl) {
        accordionCtrl.addGroup(scope);

        scope.$watch("isOpen", function (value) {
          if ( value ) {
            accordionCtrl.closeOthers(scope);
          }
        });

        scope.toggleOpen = function () {
          if ( !scope.isDisabled ) {
            scope.isOpen = !scope.isOpen;
          }
        };
      }
    };
  })

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
  .directive("accordionHeading", function () {
    return {
      restrict: "EA",
      transclude: true, // Grab the contents to be used as the heading
      template: "", // In effect remove this element!
      replace: true,
      require: "^accordionGroup",
      link: function (scope, element, attr, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
        accordionGroupCtrl.setHeading(transclude(scope, function () {}));
      }
    };
  })

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
  .directive("accordionTransclude", function () {
    return {
      require: "^accordionGroup",
      link: function (scope, element, attr, controller) {
        scope.$watch(function () { return controller[attr.accordionTransclude]; }, function (heading) {
          if ( heading ) {
            element.html("");
            element.append(heading);
          }
        });
      }
    };
  });

angular.module("ui.bootstrap.alert", [])

  .controller("AlertController", ["$scope", "$attrs", function ($scope, $attrs) {
    $scope.closeable = "close" in $attrs;
  }])

  .directive("alert", function () {
    return {
      restrict: "EA",
      controller: "AlertController",
      templateUrl: "template/alert/alert.html",
      transclude: true,
      replace: true,
      scope: {
        type: "@",
        close: "&"
      }
    };
  });

angular.module("ui.bootstrap.bindHtml", [])

  .directive("bindHtmlUnsafe", function () {
    return function (scope, element, attr) {
      element.addClass("ng-binding").data("$binding", attr.bindHtmlUnsafe);
      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
        element.html(value || "");
      });
    };
  });
angular.module("ui.bootstrap.buttons", [])

  .constant("buttonConfig", {
    activeClass: "active",
    toggleEvent: "click"
  })

  .controller("ButtonsController", ["buttonConfig", function (buttonConfig) {
    this.activeClass = buttonConfig.activeClass || "active";
    this.toggleEvent = buttonConfig.toggleEvent || "click";
  }])

  .directive("btnRadio", function () {
    return {
      require: ["btnRadio", "ngModel"],
      controller: "ButtonsController",
      link: function (scope, element, attrs, ctrls) {
        var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        // model -> UI
        ngModelCtrl.$render = function () {
          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
        };

        // ui->model
        element.bind(buttonsCtrl.toggleEvent, function () {
          var isActive = element.hasClass(buttonsCtrl.activeClass);

          if (!isActive || angular.isDefined(attrs.uncheckable)) {
            scope.$apply(function () {
              ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
              ngModelCtrl.$render();
            });
          }
        });
      }
    };
  })

  .directive("btnCheckbox", function () {
    return {
      require: ["btnCheckbox", "ngModel"],
      controller: "ButtonsController",
      link: function (scope, element, attrs, ctrls) {
        var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        function getTrueValue() {
          return getCheckboxValue(attrs.btnCheckboxTrue, true);
        }

        function getFalseValue() {
          return getCheckboxValue(attrs.btnCheckboxFalse, false);
        }

        function getCheckboxValue(attributeValue, defaultValue) {
          var val = scope.$eval(attributeValue);
          return angular.isDefined(val) ? val : defaultValue;
        }

        // model -> UI
        ngModelCtrl.$render = function () {
          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
        };

        // ui->model
        element.bind(buttonsCtrl.toggleEvent, function () {
          scope.$apply(function () {
            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
            ngModelCtrl.$render();
          });
        });
      }
    };
  });

/**
* @ngdoc overview
* @name ui.bootstrap.carousel
*
* @description
* AngularJS version of an image carousel.
*
*/
angular.module("ui.bootstrap.carousel", ["ui.bootstrap.transition"])
  .controller("CarouselController", ["$scope", "$timeout", "$transition", function ($scope, $timeout, $transition) {
    var self = this,
      slides = self.slides = $scope.slides = [],
      currentIndex = -1,
      currentTimeout, isPlaying;
    self.currentSlide = null;

    var destroyed = false;
    /* direction: "prev" or "next" */
    self.select = $scope.select = function (nextSlide, direction) {
      var nextIndex = slides.indexOf(nextSlide);
      // Decide direction if it's not given
      if (direction === undefined) {
        direction = nextIndex > currentIndex ? "next" : "prev";
      }
      if (nextSlide && nextSlide !== self.currentSlide) {
        if ($scope.$currentTransition) {
          $scope.$currentTransition.cancel();
          // Timeout so ng-class in template has time to fix classes for finished slide
          $timeout(goNext);
        } else {
          goNext();
        }
      }
      function goNext() {
      // Scope has been destroyed, stop here.
        if (destroyed) { return; }
        // If we have a slide to transition from and we have a transition type and we're allowed, go
        if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
        // We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
          nextSlide.$element.addClass(direction);
          var reflow = nextSlide.$element[0].offsetWidth; // force reflow

          // Set all other slides to stop doing their stuff for the new transition
          angular.forEach(slides, function (slide) {
            angular.extend(slide, { direction: "", entering: false, leaving: false, active: false });
          });
          angular.extend(nextSlide, { direction: direction, active: true, entering: true });
          angular.extend(self.currentSlide || {}, { direction: direction, leaving: true });

          $scope.$currentTransition = $transition(nextSlide.$element, {});
          // We have to create new pointers inside a closure since next & current will change
          (function (next, current) {
            $scope.$currentTransition.then(
              function () { transitionDone(next, current); },
              function () { transitionDone(next, current); }
            );
          }(nextSlide, self.currentSlide));
        } else {
          transitionDone(nextSlide, self.currentSlide);
        }
        self.currentSlide = nextSlide;
        currentIndex = nextIndex;
        // every time you change slides, reset the timer
        restartTimer();
      }
      function transitionDone(next, current) {
        angular.extend(next, { direction: "", active: true, leaving: false, entering: false });
        angular.extend(current || {}, { direction: "", active: false, leaving: false, entering: false });
        $scope.$currentTransition = null;
      }
    };
    $scope.$on("$destroy", function () {
      destroyed = true;
    });

    /* Allow outside people to call indexOf on slides array */
    self.indexOfSlide = function (slide) {
      return slides.indexOf(slide);
    };

    $scope.next = function () {
      var newIndex = (currentIndex + 1) % slides.length;

      // Prevent this user-triggered transition from occurring if there is already one in progress
      if (!$scope.$currentTransition) {
        return self.select(slides[newIndex], "next");
      }
    };

    $scope.prev = function () {
      var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;

      // Prevent this user-triggered transition from occurring if there is already one in progress
      if (!$scope.$currentTransition) {
        return self.select(slides[newIndex], "prev");
      }
    };

    $scope.isActive = function (slide) {
      return self.currentSlide === slide;
    };

    $scope.$watch("interval", restartTimer);
    $scope.$on("$destroy", resetTimer);

    function restartTimer() {
      resetTimer();
      var interval = +$scope.interval;
      if (!isNaN(interval) && interval >= 0) {
        currentTimeout = $timeout(timerFn, interval);
      }
    }

    function resetTimer() {
      if (currentTimeout) {
        $timeout.cancel(currentTimeout);
        currentTimeout = null;
      }
    }

    function timerFn() {
      if (isPlaying) {
        $scope.next();
        restartTimer();
      } else {
        $scope.pause();
      }
    }

    $scope.play = function () {
      if (!isPlaying) {
        isPlaying = true;
        restartTimer();
      }
    };
    $scope.pause = function () {
      if (!$scope.noPause) {
        isPlaying = false;
        resetTimer();
      }
    };

    self.addSlide = function (slide, element) {
      slide.$element = element;
      slides.push(slide);
      // if this is the first slide or the slide is set to active, select it
      if (slides.length === 1 || slide.active) {
        self.select(slides[slides.length - 1]);
        if (slides.length == 1) {
          $scope.play();
        }
      } else {
        slide.active = false;
      }
    };

    self.removeSlide = function (slide) {
    // get the index of the slide inside the carousel
      var index = slides.indexOf(slide);
      slides.splice(index, 1);
      if (slides.length > 0 && slide.active) {
        if (index >= slides.length) {
          self.select(slides[index - 1]);
        } else {
          self.select(slides[index]);
        }
      } else if (currentIndex > index) {
        currentIndex--;
      }
    };

  }])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <carousel>
      <slide>
        <img src="http://placekitten.com/150/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>Beautiful!</p>
        </div>
      </slide>
      <slide>
        <img src="http://placekitten.com/100/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>D'aww!</p>
        </div>
      </slide>
    </carousel>
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
 */
  .directive("carousel", [function () {
    return {
      restrict: "EA",
      transclude: true,
      replace: true,
      controller: "CarouselController",
      require: "carousel",
      templateUrl: "template/carousel/carousel.html",
      scope: {
        interval: "=",
        noTransition: "=",
        noPause: "="
      }
    };
  }])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
<div ng-controller="CarouselDemoCtrl">
  <carousel>
    <slide ng-repeat="slide in slides" active="slide.active">
      <img ng-src="{{slide.image}}" style="margin:auto;">
      <div class="carousel-caption">
        <h4>Slide {{$index}}</h4>
        <p>{{slide.text}}</p>
      </div>
    </slide>
  </carousel>
  Interval, in milliseconds: <input type="number" ng-model="myInterval">
  <br />Enter a negative number to stop the interval.
</div>
  </file>
  <file name="script.js">
function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
}
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
*/

  .directive("slide", function () {
    return {
      require: "^carousel",
      restrict: "EA",
      transclude: true,
      replace: true,
      templateUrl: "template/carousel/slide.html",
      scope: {
        active: "=?"
      },
      link: function (scope, element, attrs, carouselCtrl) {
        carouselCtrl.addSlide(scope, element);
        // when the scope is destroyed then remove the slide from the current slides array
        scope.$on("$destroy", function () {
          carouselCtrl.removeSlide(scope);
        });

        scope.$watch("active", function (active) {
          if (active) {
            carouselCtrl.select(scope);
          }
        });
      }
    };
  });

angular.module("ui.bootstrap.dateparser", [])

  .service("dateParser", ["$locale", "orderByFilter", function ($locale, orderByFilter) {

    this.parsers = {};

    var formatCodeToRegex = {
      "yyyy": {
        regex: "\\d{4}",
        apply: function (value) { this.year = +value; }
      },
      "yy": {
        regex: "\\d{2}",
        apply: function (value) { this.year = +value + 2000; }
      },
      "y": {
        regex: "\\d{1,4}",
        apply: function (value) { this.year = +value; }
      },
      "MMMM": {
        regex: $locale.DATETIME_FORMATS.MONTH.join("|"),
        apply: function (value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
      },
      "MMM": {
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join("|"),
        apply: function (value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
      },
      "MM": {
        regex: "0[1-9]|1[0-2]",
        apply: function (value) { this.month = value - 1; }
      },
      "M": {
        regex: "[1-9]|1[0-2]",
        apply: function (value) { this.month = value - 1; }
      },
      "dd": {
        regex: "[0-2][0-9]{1}|3[0-1]{1}",
        apply: function (value) { this.date = +value; }
      },
      "d": {
        regex: "[1-2]?[0-9]{1}|3[0-1]{1}",
        apply: function (value) { this.date = +value; }
      },
      "EEEE": {
        regex: $locale.DATETIME_FORMATS.DAY.join("|")
      },
      "EEE": {
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join("|")
      }
    };

    function createParser(format) {
      var map = [], regex = format.split("");

      angular.forEach(formatCodeToRegex, function (data, code) {
        var index = format.indexOf(code);

        if (index > -1) {
          format = format.split("");

          regex[index] = "(" + data.regex + ")";
          format[index] = "$"; // Custom symbol to define consumed part of format
          for (var i = index + 1, n = index + code.length; i < n; i++) {
            regex[i] = "";
            format[i] = "$";
          }
          format = format.join("");

          map.push({ index: index, apply: data.apply });
        }
      });

      return {
        regex: new RegExp("^" + regex.join("") + "$"),
        map: orderByFilter(map, "index")
      };
    }

    this.parse = function (input, format) {
      if ( !angular.isString(input) || !format ) {
        return input;
      }

      format = $locale.DATETIME_FORMATS[format] || format;

      if ( !this.parsers[format] ) {
        this.parsers[format] = createParser(format);
      }

      var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex);

      if ( results && results.length ) {
        var fields = { year: 1900, month: 0, date: 1, hours: 0 }, dt;

        for ( var i = 1, n = results.length; i < n; i++ ) {
          var mapper = map[i - 1];
          if ( mapper.apply ) {
            mapper.apply.call(fields, results[i]);
          }
        }

        if ( isValid(fields.year, fields.month, fields.date) ) {
          dt = new Date( fields.year, fields.month, fields.date, fields.hours);
        }

        return dt;
      }
    };

    // Check if date is valid for specific month (and year for February).
    // Month: 0 = Jan, 1 = Feb, etc
    function isValid(year, month, date) {
      if ( month === 1 && date > 28) {
        return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
      }

      if ( month === 3 || month === 5 || month === 8 || month === 10) {
        return date < 31;
      }

      return true;
    }
  }]);

angular.module("ui.bootstrap.position", [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory("$position", ["$document", "$window", function ($document, $window) {

    function getStyle(el, cssprop) {
      if (el.currentStyle) { // IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, "position") || "static" ) === "static";
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function (element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function (element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop("offsetWidth"),
          height: boundingClientRect.height || element.prop("offsetHeight"),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function (element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop("offsetWidth"),
          height: boundingClientRect.height || element.prop("offsetHeight"),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function (hostEl, targetEl, positionStr, appendToBody) {

        var positionStrParts = positionStr.split("-");
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || "center";

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop("offsetWidth");
        targetElHeight = targetEl.prop("offsetHeight");

        var shiftWidth = {
          center: function () {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function () {
            return hostElPos.left;
          },
          right: function () {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function () {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function () {
            return hostElPos.top;
          },
          bottom: function () {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case "right":
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case "left":
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case "bottom":
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);

angular.module("ui.bootstrap.datepicker", ["ui.bootstrap.dateparser", "ui.bootstrap.position"])

  .constant("datepickerConfig", {
    formatDay: "dd",
    formatMonth: "MMMM",
    formatYear: "yyyy",
    formatDayHeader: "EEE",
    formatDayTitle: "MMMM yyyy",
    formatMonthTitle: "yyyy",
    datepickerMode: "day",
    minMode: "day",
    maxMode: "year",
    showWeeks: true,
    startingDay: 0,
    yearRange: 20,
    minDate: null,
    maxDate: null
  })

  .controller("DatepickerController", ["$scope", "$attrs", "$parse", "$interpolate", "$timeout", "$log", "dateFilter", "datepickerConfig", function ($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
    var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

    // Modes chain
    this.modes = ["day", "month", "year"];

    // Configuration attributes
    angular.forEach(["formatDay", "formatMonth", "formatYear", "formatDayHeader", "formatDayTitle", "formatMonthTitle",
      "minMode", "maxMode", "showWeeks", "startingDay", "yearRange"], function ( key, index ) {
      self[key] = angular.isDefined($attrs[key]) ? (index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
    });

    // Watchable date attributes
    angular.forEach(["minDate", "maxDate"], function ( key ) {
      if ( $attrs[key] ) {
        $scope.$parent.$watch($parse($attrs[key]), function (value) {
          self[key] = value ? new Date(value) : null;
          self.refreshView();
        });
      } else {
        self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
      }
    });

    $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
    $scope.uniqueId = "datepicker-" + $scope.$id + "-" + Math.floor(Math.random() * 10000);
    this.activeDate = angular.isDefined($attrs.initDate) ? $scope.$parent.$eval($attrs.initDate) : new Date();

    $scope.isActive = function (dateObject) {
      if (self.compare(dateObject.date, self.activeDate) === 0) {
        $scope.activeDateId = dateObject.uid;
        return true;
      }
      return false;
    };

    this.init = function ( ngModelCtrl_ ) {
      ngModelCtrl = ngModelCtrl_;

      ngModelCtrl.$render = function () {
        self.render();
      };
    };

    this.render = function () {
      if ( ngModelCtrl.$modelValue ) {
        var date = new Date( ngModelCtrl.$modelValue ),
          isValid = !isNaN(date);

        if ( isValid ) {
          this.activeDate = date;
        } else {
          $log.error("Datepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.");
        }
        ngModelCtrl.$setValidity("date", isValid);
      }
      this.refreshView();
    };

    this.refreshView = function () {
      if ( this.element ) {
        this._refreshView();

        var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
        ngModelCtrl.$setValidity("date-disabled", !date || (this.element && !this.isDisabled(date)));
      }
    };

    this.createDateObject = function (date, format) {
      var model = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : null;
      return {
        date: date,
        label: dateFilter(date, format),
        selected: model && this.compare(date, model) === 0,
        disabled: this.isDisabled(date),
        current: this.compare(date, new Date()) === 0
      };
    };

    this.isDisabled = function ( date ) {
      return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode })));
    };

    // Split array into smaller arrays
    this.split = function (arr, size) {
      var arrays = [];
      while (arr.length > 0) {
        arrays.push(arr.splice(0, size));
      }
      return arrays;
    };

    $scope.select = function ( date ) {
      if ( $scope.datepickerMode === self.minMode ) {
        var dt = ngModelCtrl.$modelValue ? new Date( ngModelCtrl.$modelValue ) : new Date(0, 0, 0, 0, 0, 0, 0);
        dt.setFullYear( date.getFullYear(), date.getMonth(), date.getDate() );
        ngModelCtrl.$setViewValue( dt );
        ngModelCtrl.$render();
      } else {
        self.activeDate = date;
        $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) - 1 ];
      }
    };

    $scope.move = function ( direction ) {
      var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
      self.activeDate.setFullYear(year, month, 1);
      self.refreshView();
    };

    $scope.toggleMode = function ( direction ) {
      direction = direction || 1;

      if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
        return;
      }

      $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) + direction ];
    };

    // Key event mapper
    $scope.keys = { 13: "enter", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home", 37: "left", 38: "up", 39: "right", 40: "down" };

    var focusElement = function () {
      $timeout(function () {
        self.element[0].focus();
      }, 0, false);
    };

    // Listen for focus requests from popup directive
    $scope.$on("datepicker.focus", focusElement);

    $scope.keydown = function ( evt ) {
      var key = $scope.keys[evt.which];

      if ( !key || evt.shiftKey || evt.altKey ) {
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();

      if (key === "enter" || key === "space") {
        if ( self.isDisabled(self.activeDate)) {
          return; // do nothing
        }
        $scope.select(self.activeDate);
        focusElement();
      } else if (evt.ctrlKey && (key === "up" || key === "down")) {
        $scope.toggleMode(key === "up" ? 1 : -1);
        focusElement();
      } else {
        self.handleKeyDown(key, evt);
        self.refreshView();
      }
    };
  }])

  .directive( "datepicker", function () {
    return {
      restrict: "EA",
      replace: true,
      templateUrl: "template/datepicker/datepicker.html",
      scope: {
        datepickerMode: "=?",
        dateDisabled: "&"
      },
      require: ["datepicker", "?^ngModel"],
      controller: "DatepickerController",
      link: function (scope, element, attrs, ctrls) {
        var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if ( ngModelCtrl ) {
          datepickerCtrl.init( ngModelCtrl );
        }
      }
    };
  })

  .directive("daypicker", ["dateFilter", function (dateFilter) {
    return {
      restrict: "EA",
      replace: true,
      templateUrl: "template/datepicker/day.html",
      require: "^datepicker",
      link: function (scope, element, attrs, ctrl) {
        scope.showWeeks = ctrl.showWeeks;

        ctrl.step = { months: 1 };
        ctrl.element = element;

        var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function getDaysInMonth( year, month ) {
          return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
        }

        function getDates(startDate, n) {
          var dates = new Array(n), current = new Date(startDate), i = 0;
          current.setHours(12); // Prevent repeated dates because of timezone bug
          while ( i < n ) {
            dates[i++] = new Date(current);
            current.setDate( current.getDate() + 1 );
          }
          return dates;
        }

        ctrl._refreshView = function () {
          var year = ctrl.activeDate.getFullYear(),
            month = ctrl.activeDate.getMonth(),
            firstDayOfMonth = new Date(year, month, 1),
            difference = ctrl.startingDay - firstDayOfMonth.getDay(),
            numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
            firstDate = new Date(firstDayOfMonth);

          if ( numDisplayedFromPreviousMonth > 0 ) {
            firstDate.setDate( - numDisplayedFromPreviousMonth + 1 );
          }

          // 42 is the number of days on a six-month calendar
          var days = getDates(firstDate, 42);
          for (var i = 0; i < 42; i ++) {
            days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
              secondary: days[i].getMonth() !== month,
              uid: scope.uniqueId + "-" + i
            });
          }

          scope.labels = new Array(7);
          for (var j = 0; j < 7; j++) {
            scope.labels[j] = {
              abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
              full: dateFilter(days[j].date, "EEEE")
            };
          }

          scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
          scope.rows = ctrl.split(days, 7);

          if ( scope.showWeeks ) {
            scope.weekNumbers = [];
            var weekNumber = getISO8601WeekNumber( scope.rows[0][0].date ),
              numWeeks = scope.rows.length;
            while ( scope.weekNumbers.push(weekNumber++) < numWeeks ) {}
          }
        };

        ctrl.compare = function (date1, date2) {
          return (new Date( date1.getFullYear(), date1.getMonth(), date1.getDate() ) - new Date( date2.getFullYear(), date2.getMonth(), date2.getDate() ) );
        };

        function getISO8601WeekNumber(date) {
          var checkDate = new Date(date);
          checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
          var time = checkDate.getTime();
          checkDate.setMonth(0); // Compare with Jan 1
          checkDate.setDate(1);
          return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
        }

        ctrl.handleKeyDown = function ( key, evt ) {
          var date = ctrl.activeDate.getDate();

          if (key === "left") {
            date = date - 1; // up
          } else if (key === "up") {
            date = date - 7; // down
          } else if (key === "right") {
            date = date + 1; // down
          } else if (key === "down") {
            date = date + 7;
          } else if (key === "pageup" || key === "pagedown") {
            var month = ctrl.activeDate.getMonth() + (key === "pageup" ? - 1 : 1);
            ctrl.activeDate.setMonth(month, 1);
            date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
          } else if (key === "home") {
            date = 1;
          } else if (key === "end") {
            date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
          }
          ctrl.activeDate.setDate(date);
        };

        ctrl.refreshView();
      }
    };
  }])

  .directive("monthpicker", ["dateFilter", function (dateFilter) {
    return {
      restrict: "EA",
      replace: true,
      templateUrl: "template/datepicker/month.html",
      require: "^datepicker",
      link: function (scope, element, attrs, ctrl) {
        ctrl.step = { years: 1 };
        ctrl.element = element;

        ctrl._refreshView = function () {
          var months = new Array(12),
            year = ctrl.activeDate.getFullYear();

          for ( var i = 0; i < 12; i++ ) {
            months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {
              uid: scope.uniqueId + "-" + i
            });
          }

          scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
          scope.rows = ctrl.split(months, 3);
        };

        ctrl.compare = function (date1, date2) {
          return new Date( date1.getFullYear(), date1.getMonth() ) - new Date( date2.getFullYear(), date2.getMonth() );
        };

        ctrl.handleKeyDown = function ( key, evt ) {
          var date = ctrl.activeDate.getMonth();

          if (key === "left") {
            date = date - 1; // up
          } else if (key === "up") {
            date = date - 3; // down
          } else if (key === "right") {
            date = date + 1; // down
          } else if (key === "down") {
            date = date + 3;
          } else if (key === "pageup" || key === "pagedown") {
            var year = ctrl.activeDate.getFullYear() + (key === "pageup" ? - 1 : 1);
            ctrl.activeDate.setFullYear(year);
          } else if (key === "home") {
            date = 0;
          } else if (key === "end") {
            date = 11;
          }
          ctrl.activeDate.setMonth(date);
        };

        ctrl.refreshView();
      }
    };
  }])

  .directive("yearpicker", ["dateFilter", function (dateFilter) {
    return {
      restrict: "EA",
      replace: true,
      templateUrl: "template/datepicker/year.html",
      require: "^datepicker",
      link: function (scope, element, attrs, ctrl) {
        var range = ctrl.yearRange;

        ctrl.step = { years: range };
        ctrl.element = element;

        function getStartingYear( year ) {
          return parseInt((year - 1) / range, 10) * range + 1;
        }

        ctrl._refreshView = function () {
          var years = new Array(range);

          for ( var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++ ) {
            years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {
              uid: scope.uniqueId + "-" + i
            });
          }

          scope.title = [years[0].label, years[range - 1].label].join(" - ");
          scope.rows = ctrl.split(years, 5);
        };

        ctrl.compare = function (date1, date2) {
          return date1.getFullYear() - date2.getFullYear();
        };

        ctrl.handleKeyDown = function ( key, evt ) {
          var date = ctrl.activeDate.getFullYear();

          if (key === "left") {
            date = date - 1; // up
          } else if (key === "up") {
            date = date - 5; // down
          } else if (key === "right") {
            date = date + 1; // down
          } else if (key === "down") {
            date = date + 5;
          } else if (key === "pageup" || key === "pagedown") {
            date += (key === "pageup" ? - 1 : 1) * ctrl.step.years;
          } else if (key === "home") {
            date = getStartingYear( ctrl.activeDate.getFullYear() );
          } else if (key === "end") {
            date = getStartingYear( ctrl.activeDate.getFullYear() ) + range - 1;
          }
          ctrl.activeDate.setFullYear(date);
        };

        ctrl.refreshView();
      }
    };
  }])

  .constant("datepickerPopupConfig", {
    datepickerPopup: "yyyy-MM-dd",
    currentText: "Today",
    clearText: "Clear",
    closeText: "Done",
    closeOnDateSelection: true,
    appendToBody: false,
    showButtonBar: true
  })

  .directive("datepickerPopup", ["$compile", "$parse", "$document", "$position", "dateFilter", "dateParser", "datepickerPopupConfig",
    function ($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig) {
      return {
        restrict: "EA",
        require: "ngModel",
        scope: {
          isOpen: "=?",
          currentText: "@",
          clearText: "@",
          closeText: "@",
          dateDisabled: "&"
        },
        link: function (scope, element, attrs, ngModel) {
          var dateFormat,
            closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
            appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;

          scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

          scope.getText = function ( key ) {
            return scope[key + "Text"] || datepickerPopupConfig[key + "Text"];
          };

          attrs.$observe("datepickerPopup", function (value) {
            dateFormat = value || datepickerPopupConfig.datepickerPopup;
            ngModel.$render();
          });

          // popup element used to display calendar
          var popupEl = angular.element("<div datepicker-popup-wrap><div datepicker></div></div>");
          popupEl.attr({
            "ng-model": "date",
            "ng-change": "dateSelection()"
          });

          function cameltoDash( string ) {
            return string.replace(/([A-Z])/g, function ($1) { return "-" + $1.toLowerCase(); });
          }

          // datepicker element
          var datepickerEl = angular.element(popupEl.children()[0]);
          if ( attrs.datepickerOptions ) {
            angular.forEach(scope.$parent.$eval(attrs.datepickerOptions), function ( value, option ) {
              datepickerEl.attr( cameltoDash(option), value );
            });
          }

          scope.watchData = {};
          angular.forEach(["minDate", "maxDate", "datepickerMode"], function ( key ) {
            if ( attrs[key] ) {
              var getAttribute = $parse(attrs[key]);
              scope.$parent.$watch(getAttribute, function (value) {
                scope.watchData[key] = value;
              });
              datepickerEl.attr(cameltoDash(key), "watchData." + key);

              // Propagate changes from datepicker to outside
              if ( key === "datepickerMode" ) {
                var setAttribute = getAttribute.assign;
                scope.$watch("watchData." + key, function (value, oldvalue) {
                  if ( value !== oldvalue ) {
                    setAttribute(scope.$parent, value);
                  }
                });
              }
            }
          });
          if (attrs.dateDisabled) {
            datepickerEl.attr("date-disabled", "dateDisabled({ date: date, mode: mode })");
          }

          function parseDate(viewValue) {
            if (!viewValue) {
              ngModel.$setValidity("date", true);
              return null;
            } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
              ngModel.$setValidity("date", true);
              return viewValue;
            } else if (angular.isString(viewValue)) {
              var date = dateParser.parse(viewValue, dateFormat) || new Date(viewValue);
              if (isNaN(date)) {
                ngModel.$setValidity("date", false);
                return undefined;
              } else {
                ngModel.$setValidity("date", true);
                return date;
              }
            } else {
              ngModel.$setValidity("date", false);
              return undefined;
            }
          }
          ngModel.$parsers.unshift(parseDate);

          // Inner change
          scope.dateSelection = function (dt) {
            if (angular.isDefined(dt)) {
              scope.date = dt;
            }
            ngModel.$setViewValue(scope.date);
            ngModel.$render();

            if ( closeOnDateSelection ) {
              scope.isOpen = false;
              element[0].focus();
            }
          };

          element.bind("input change keyup", function () {
            scope.$apply(function () {
              scope.date = ngModel.$modelValue;
            });
          });

          // Outter change
          ngModel.$render = function () {
            var date = ngModel.$viewValue ? dateFilter(ngModel.$viewValue, dateFormat) : "";
            element.val(date);
            scope.date = parseDate( ngModel.$modelValue );
          };

          var documentClickBind = function (event) {
            if (scope.isOpen && event.target !== element[0]) {
              scope.$apply(function () {
                scope.isOpen = false;
              });
            }
          };

          var keydown = function (evt, noApply) {
            scope.keydown(evt);
          };
          element.bind("keydown", keydown);

          scope.keydown = function (evt) {
            if (evt.which === 27) {
              evt.preventDefault();
              evt.stopPropagation();
              scope.close();
            } else if (evt.which === 40 && !scope.isOpen) {
              scope.isOpen = true;
            }
          };

          scope.$watch("isOpen", function (value) {
            if (value) {
              scope.$broadcast("datepicker.focus");
              scope.position = appendToBody ? $position.offset(element) : $position.position(element);
              scope.position.top = scope.position.top + element.prop("offsetHeight");

              $document.bind("click", documentClickBind);
            } else {
              $document.unbind("click", documentClickBind);
            }
          });

          scope.select = function ( date ) {
            if (date === "today") {
              var today = new Date();
              if (angular.isDate(ngModel.$modelValue)) {
                date = new Date(ngModel.$modelValue);
                date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
              } else {
                date = new Date(today.setHours(0, 0, 0, 0));
              }
            }
            scope.dateSelection( date );
          };

          scope.close = function () {
            scope.isOpen = false;
            element[0].focus();
          };

          var $popup = $compile(popupEl)(scope);
          // Prevent jQuery cache memory leak (template is now redundant after linking)
          popupEl.remove();

          if ( appendToBody ) {
            $document.find("body").append($popup);
          } else {
            element.after($popup);
          }

          scope.$on("$destroy", function () {
            $popup.remove();
            element.unbind("keydown", keydown);
            $document.unbind("click", documentClickBind);
          });
        }
      };
    }])

  .directive("datepickerPopupWrap", function () {
    return {
      restrict: "EA",
      replace: true,
      transclude: true,
      templateUrl: "template/datepicker/popup.html",
      link: function (scope, element, attrs) {
        element.bind("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
        });
      }
    };
  });

angular.module("ui.bootstrap.dropdown", [])

  .constant("dropdownConfig", {
    openClass: "open"
  })

  .service("dropdownService", ["$document", function ($document) {
    var openScope = null;

    this.open = function ( dropdownScope ) {
      if ( !openScope ) {
        $document.bind("click", closeDropdown);
        $document.bind("keydown", escapeKeyBind);
      }

      if ( openScope && openScope !== dropdownScope ) {
        openScope.isOpen = false;
      }

      openScope = dropdownScope;
    };

    this.close = function ( dropdownScope ) {
      if ( openScope === dropdownScope ) {
        openScope = null;
        $document.unbind("click", closeDropdown);
        $document.unbind("keydown", escapeKeyBind);
      }
    };

    var closeDropdown = function ( evt ) {
      var toggleElement = openScope.getToggleElement();
      if ( evt && toggleElement && toggleElement[0].contains(evt.target) ) {
        return;
      }

      openScope.$apply(function () {
        openScope.isOpen = false;
      });
    };

    var escapeKeyBind = function ( evt ) {
      if ( evt.which === 27 ) {
        openScope.focusToggleElement();
        closeDropdown();
      }
    };
  }])

  .controller("DropdownController", ["$scope", "$attrs", "$parse", "dropdownConfig", "dropdownService", "$animate", function ($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate) {
    var self = this,
      scope = $scope.$new(), // create a child scope so we are not polluting original one
      openClass = dropdownConfig.openClass,
      getIsOpen,
      setIsOpen = angular.noop,
      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop;

    this.init = function ( element ) {
      self.$element = element;

      if ( $attrs.isOpen ) {
        getIsOpen = $parse($attrs.isOpen);
        setIsOpen = getIsOpen.assign;

        $scope.$watch(getIsOpen, function (value) {
          scope.isOpen = !!value;
        });
      }
    };

    this.toggle = function ( open ) {
      return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    };

    // Allow other directives to watch status
    this.isOpen = function () {
      return scope.isOpen;
    };

    scope.getToggleElement = function () {
      return self.toggleElement;
    };

    scope.focusToggleElement = function () {
      if ( self.toggleElement ) {
        self.toggleElement[0].focus();
      }
    };

    scope.$watch("isOpen", function ( isOpen, wasOpen ) {
      $animate[isOpen ? "addClass" : "removeClass"](self.$element, openClass);

      if ( isOpen ) {
        scope.focusToggleElement();
        dropdownService.open( scope );
      } else {
        dropdownService.close( scope );
      }

      setIsOpen($scope, isOpen);
      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
        toggleInvoker($scope, { open: !!isOpen });
      }
    });

    $scope.$on("$locationChangeSuccess", function () {
      scope.isOpen = false;
    });

    $scope.$on("$destroy", function () {
      scope.$destroy();
    });
  }])

  .directive("dropdown", function () {
    return {
      restrict: "CA",
      controller: "DropdownController",
      link: function (scope, element, attrs, dropdownCtrl) {
        dropdownCtrl.init( element );
      }
    };
  })

  .directive("dropdownToggle", function () {
    return {
      restrict: "CA",
      require: "?^dropdown",
      link: function (scope, element, attrs, dropdownCtrl) {
        if ( !dropdownCtrl ) {
          return;
        }

        dropdownCtrl.toggleElement = element;

        var toggleDropdown = function (event) {
          event.preventDefault();

          if ( !element.hasClass("disabled") && !attrs.disabled ) {
            scope.$apply(function () {
              dropdownCtrl.toggle();
            });
          }
        };

        element.bind("click", toggleDropdown);

        // WAI-ARIA
        element.attr({ "aria-haspopup": true, "aria-expanded": false });
        scope.$watch(dropdownCtrl.isOpen, function ( isOpen ) {
          element.attr("aria-expanded", !!isOpen);
        });

        scope.$on("$destroy", function () {
          element.unbind("click", toggleDropdown);
        });
      }
    };
  });

angular.module("ui.bootstrap.modal", ["ui.bootstrap.transition"])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory("$$stackedMap", function () {
    return {
      createNew: function () {
        var stack = [];

        return {
          add: function (key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function (key) {
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function () {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function () {
            return stack[stack.length - 1];
          },
          remove: function (key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function () {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function () {
            return stack.length;
          }
        };
      }
    };
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive("modalBackdrop", ["$timeout", function ($timeout) {
    return {
      restrict: "EA",
      replace: true,
      templateUrl: "template/modal/backdrop.html",
      link: function (scope, element, attrs) {
        scope.backdropClass = attrs.backdropClass || "";

        scope.animate = false;

        // trigger CSS transitions
        $timeout(function () {
          scope.animate = true;
        });
      }
    };
  }])

  .directive("modalWindow", ["$modalStack", "$timeout", function ($modalStack, $timeout) {
    return {
      restrict: "EA",
      scope: {
        index: "@",
        animate: "="
      },
      replace: true,
      transclude: true,
      templateUrl: function (tElement, tAttrs) {
        return tAttrs.templateUrl || "template/modal/window.html";
      },
      link: function (scope, element, attrs) {
        element.addClass(attrs.windowClass || "");
        scope.size = attrs.size;

        $timeout(function () {
          // trigger CSS transitions
          scope.animate = true;

          /**
           * Auto-focusing of a freshly-opened modal element causes any child elements
           * with the autofocus attribute to loose focus. This is an issue on touch
           * based devices which will show and then hide the onscreen keyboard.
           * Attempts to refocus the autofocus element via JavaScript will not reopen
           * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
           * the modal element if the modal does not contain an autofocus element.
           */
          if (!element[0].querySelectorAll("[autofocus]").length) {
            element[0].focus();
          }
        });

        scope.close = function (evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop && modal.value.backdrop != "static" && (evt.target === evt.currentTarget)) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, "backdrop click");
          }
        };
      }
    };
  }])

  .directive("modalTransclude", function () {
    return {
      link: function ($scope, $element, $attrs, controller, $transclude) {
        $transclude($scope.$parent, function (clone) {
          $element.empty();
          $element.append(clone);
        });
      }
    };
  })

  .factory("$modalStack", ["$transition", "$timeout", "$document", "$compile", "$rootScope", "$$stackedMap",
    function ($transition, $timeout, $document, $compile, $rootScope, $$stackedMap) {

      var OPENED_MODAL_CLASS = "modal-open";

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var $modalStack = {};

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance) {

        var body = $document.find("body").eq(0);
        var modalWindow = openedWindows.get(modalInstance).value;

        // clean up the stack
        openedWindows.remove(modalInstance);

        // remove window DOM element
        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, 300, function () {
          modalWindow.modalScope.$destroy();
          body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
          checkRemoveBackdrop();
        });
      }

      function checkRemoveBackdrop() {
        // remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() == -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, 150, function () {
            backdropScopeRef.$destroy();
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, emulateTime, done) {
        // Closing animation
        scope.animate = false;

        var transitionEndEventName = $transition.transitionEndEventName;
        if (transitionEndEventName) {
          // transition out
          var timeout = $timeout(afterAnimating, emulateTime);

          domEl.bind(transitionEndEventName, function () {
            $timeout.cancel(timeout);
            afterAnimating();
            scope.$apply();
          });
        } else {
          // Ensure this call is async
          $timeout(afterAnimating);
        }

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          domEl.remove();
          if (done) {
            done();
          }
        }
      }

      $document.bind("keydown", function (evt) {
        var modal;

        if (evt.which === 27) {
          modal = openedWindows.top();
          if (modal && modal.value.keyboard) {
            evt.preventDefault();
            $rootScope.$apply(function () {
              $modalStack.dismiss(modal.key, "escape key press");
            });
          }
        }
      });

      $modalStack.open = function (modalInstance, modal) {

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard
        });

        var body = $document.find("body").eq(0),
          currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.index = currBackdropIndex;
          var angularBackgroundDomEl = angular.element("<div modal-backdrop></div>");
          angularBackgroundDomEl.attr("backdrop-class", modal.backdropClass);
          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
          body.append(backdropDomEl);
        }

        var angularDomEl = angular.element("<div modal-window></div>");
        angularDomEl.attr({
          "template-url": modal.windowTemplateUrl,
          "window-class": modal.windowClass,
          "size": modal.size,
          "index": openedWindows.length() - 1,
          "animate": "animate"
        }).html(modal.content);

        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        body.append(modalDomEl);
        body.addClass(OPENED_MODAL_CLASS);
      };

      $modalStack.close = function (modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance);
        }
      };

      $modalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance);
        }
      };

      $modalStack.dismissAll = function (reason) {
        var topModal = this.getTop();
        while (topModal) {
          this.dismiss(topModal.key, reason);
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function () {
        return openedWindows.top();
      };

      return $modalStack;
    }])

  .provider("$modal", function () {

    var $modalProvider = {
      options: {
        backdrop: true, // can be also false or 'static'
        keyboard: true
      },
      $get: ["$injector", "$rootScope", "$q", "$http", "$templateCache", "$controller", "$modalStack",
        function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {

          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $http.get(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl,
                { cache: $templateCache }).then(function (result) {
                return result.data;
              });
          }

          function getResolvePromises(resolves) {
            var promisesArr = [];
            angular.forEach(resolves, function (value) {
              if (angular.isFunction(value) || angular.isArray(value)) {
                promisesArr.push($q.when($injector.invoke(value)));
              }
            });
            return promisesArr;
          }

          $modal.open = function (modalOptions) {

            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();

            // prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              close: function (result) {
                $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                $modalStack.dismiss(modalInstance, reason);
              }
            };

            // merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};

            // verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error("One of template or templateUrl options is required.");
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));

            templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {

              var modalScope = (modalOptions.scope || $rootScope).$new();
              modalScope.$close = modalInstance.close;
              modalScope.$dismiss = modalInstance.dismiss;

              var ctrlInstance, ctrlLocals = {};
              var resolveIter = 1;

              // controllers
              if (modalOptions.controller) {
                ctrlLocals.$scope = modalScope;
                ctrlLocals.$modalInstance = modalInstance;
                angular.forEach(modalOptions.resolve, function (value, key) {
                  ctrlLocals[key] = tplAndVars[resolveIter++];
                });

                ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                if (modalOptions.controllerAs) {
                  modalScope[modalOptions.controllerAs] = ctrlInstance;
                }
              }

              $modalStack.open(modalInstance, {
                scope: modalScope,
                deferred: modalResultDeferred,
                content: tplAndVars[0],
                backdrop: modalOptions.backdrop,
                keyboard: modalOptions.keyboard,
                backdropClass: modalOptions.backdropClass,
                windowClass: modalOptions.windowClass,
                windowTemplateUrl: modalOptions.windowTemplateUrl,
                size: modalOptions.size
              });

            }, function resolveError(reason) {
              modalResultDeferred.reject(reason);
            });

            templateAndResolvePromise.then(function () {
              modalOpenedDeferred.resolve(true);
            }, function () {
              modalOpenedDeferred.reject(false);
            });

            return modalInstance;
          };

          return $modal;
        }]
    };

    return $modalProvider;
  });

angular.module("ui.bootstrap.pagination", [])

  .controller("PaginationController", ["$scope", "$attrs", "$parse", function ($scope, $attrs, $parse) {
    var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;

    this.init = function (ngModelCtrl_, config) {
      ngModelCtrl = ngModelCtrl_;
      this.config = config;

      ngModelCtrl.$render = function () {
        self.render();
      };

      if ($attrs.itemsPerPage) {
        $scope.$parent.$watch($parse($attrs.itemsPerPage), function (value) {
          self.itemsPerPage = parseInt(value, 10);
          $scope.totalPages = self.calculateTotalPages();
        });
      } else {
        this.itemsPerPage = config.itemsPerPage;
      }
    };

    this.calculateTotalPages = function () {
      var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
      return Math.max(totalPages || 0, 1);
    };

    this.render = function () {
      $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
    };

    $scope.selectPage = function (page) {
      if ( $scope.page !== page && page > 0 && page <= $scope.totalPages) {
        ngModelCtrl.$setViewValue(page);
        ngModelCtrl.$render();
      }
    };

    $scope.getText = function ( key ) {
      return $scope[key + "Text"] || self.config[key + "Text"];
    };
    $scope.noPrevious = function () {
      return $scope.page === 1;
    };
    $scope.noNext = function () {
      return $scope.page === $scope.totalPages;
    };

    $scope.$watch("totalItems", function () {
      $scope.totalPages = self.calculateTotalPages();
    });

    $scope.$watch("totalPages", function (value) {
      setNumPages($scope.$parent, value); // Readonly variable

      if ( $scope.page > value ) {
        $scope.selectPage(value);
      } else {
        ngModelCtrl.$render();
      }
    });
  }])

  .constant("paginationConfig", {
    itemsPerPage: 10,
    boundaryLinks: false,
    directionLinks: true,
    firstText: "First",
    previousText: "Previous",
    nextText: "Next",
    lastText: "Last",
    rotate: true
  })

  .directive("pagination", ["$parse", "paginationConfig", function ($parse, paginationConfig) {
    return {
      restrict: "EA",
      scope: {
        totalItems: "=",
        firstText: "@",
        previousText: "@",
        nextText: "@",
        lastText: "@"
      },
      require: ["pagination", "?ngModel"],
      controller: "PaginationController",
      templateUrl: "template/pagination/pagination.html",
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if (!ngModelCtrl) {
          return; // do nothing if no ng-model
        }

        // Setup configuration parameters
        var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
        scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
        scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;

        paginationCtrl.init(ngModelCtrl, paginationConfig);

        if (attrs.maxSize) {
          scope.$parent.$watch($parse(attrs.maxSize), function (value) {
            maxSize = parseInt(value, 10);
            paginationCtrl.render();
          });
        }

        // Create page object used in template
        function makePage(number, text, isActive) {
          return {
            number: number,
            text: text,
            active: isActive
          };
        }

        function getPages(currentPage, totalPages) {
          var pages = [];

          // Default page limits
          var startPage = 1, endPage = totalPages;
          var isMaxSized = ( angular.isDefined(maxSize) && maxSize < totalPages );

          // recompute if maxSize
          if ( isMaxSized ) {
            if ( rotate ) {
            // Current page is displayed in the middle of the visible ones
              startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
              endPage = startPage + maxSize - 1;

              // Adjust if limit is exceeded
              if (endPage > totalPages) {
                endPage = totalPages;
                startPage = endPage - maxSize + 1;
              }
            } else {
            // Visible pages are paginated with maxSize
              startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;

              // Adjust last page if limit is exceeded
              endPage = Math.min(startPage + maxSize - 1, totalPages);
            }
          }

          // Add page number links
          for (var number = startPage; number <= endPage; number++) {
            var page = makePage(number, number, number === currentPage);
            pages.push(page);
          }

          // Add links to move between page sets
          if ( isMaxSized && ! rotate ) {
            if ( startPage > 1 ) {
              var previousPageSet = makePage(startPage - 1, "...", false);
              pages.unshift(previousPageSet);
            }

            if ( endPage < totalPages ) {
              var nextPageSet = makePage(endPage + 1, "...", false);
              pages.push(nextPageSet);
            }
          }

          return pages;
        }

        var originalRender = paginationCtrl.render;
        paginationCtrl.render = function () {
          originalRender();
          if (scope.page > 0 && scope.page <= scope.totalPages) {
            scope.pages = getPages(scope.page, scope.totalPages);
          }
        };
      }
    };
  }])

  .constant("pagerConfig", {
    itemsPerPage: 10,
    previousText: "« Previous",
    nextText: "Next »",
    align: true
  })

  .directive("pager", ["pagerConfig", function (pagerConfig) {
    return {
      restrict: "EA",
      scope: {
        totalItems: "=",
        previousText: "@",
        nextText: "@"
      },
      require: ["pager", "?ngModel"],
      controller: "PaginationController",
      templateUrl: "template/pagination/pager.html",
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if (!ngModelCtrl) {
          return; // do nothing if no ng-model
        }

        scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
        paginationCtrl.init(ngModelCtrl, pagerConfig);
      }
    };
  }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module( "ui.bootstrap.tooltip", [ "ui.bootstrap.position", "ui.bootstrap.bindHtml" ] )

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
  .provider( "$tooltip", function () {
  // The default options tooltip and popover.
    var defaultOptions = {
      placement: "top",
      animation: true,
      popupDelay: 0
    };

    // Default hide triggers for each show trigger
    var triggerMap = {
      "mouseenter": "mouseleave",
      "click": "click",
      "focus": "blur"
    };

    // The options specified to the provider globally.
    var globalOptions = {};

    /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
    this.options = function ( value ) {
      angular.extend( globalOptions, value );
    };

    /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
   */
    this.setTriggers = function setTriggers( triggers ) {
      angular.extend( triggerMap, triggers );
    };

    /**
   * This is a helper function for translating camel-case to snake-case.
   */
    function snake_case(name) {
      var regexp = /[A-Z]/g;
      var separator = "-";
      return name.replace(regexp, function (letter, pos) {
        return (pos ? separator : "") + letter.toLowerCase();
      });
    }

    /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
    this.$get = [ "$window", "$compile", "$timeout", "$parse", "$document", "$position", "$interpolate", function ( $window, $compile, $timeout, $parse, $document, $position, $interpolate ) {
      return function $tooltip( type, prefix, defaultTriggerShow ) {
        var options = angular.extend( {}, defaultOptions, globalOptions );

        /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
        function getTriggers( trigger ) {
          var show = trigger || options.trigger || defaultTriggerShow;
          var hide = triggerMap[show] || show;
          return {
            show: show,
            hide: hide
          };
        }

        var directiveName = snake_case( type );

        var startSym = $interpolate.startSymbol();
        var endSym = $interpolate.endSymbol();
        var template =
        "<div " + directiveName + "-popup " +
          "title=\"" + startSym + "tt_title" + endSym + "\" " +
          "content=\"" + startSym + "tt_content" + endSym + "\" " +
          "placement=\"" + startSym + "tt_placement" + endSym + "\" " +
          "animation=\"tt_animation\" " +
          "is-open=\"tt_isOpen\"" +
          ">" +
        "</div>";

        return {
          restrict: "EA",
          scope: true,
          compile: function (tElem, tAttrs) {
            var tooltipLinker = $compile( template );

            return function link( scope, element, attrs ) {
              var tooltip;
              var transitionTimeout;
              var popupTimeout;
              var appendToBody = angular.isDefined( options.appendToBody ) ? options.appendToBody : false;
              var triggers = getTriggers( undefined );
              var hasEnableExp = angular.isDefined(attrs[prefix + "Enable"]);

              var positionTooltip = function () {

                var ttPosition = $position.positionElements(element, tooltip, scope.tt_placement, appendToBody);
                ttPosition.top += "px";
                ttPosition.left += "px";

                // Now set the calculated positioning.
                tooltip.css( ttPosition );
              };

              // By default, the tooltip is not open.
              // TODO add ability to start tooltip opened
              scope.tt_isOpen = false;

              function toggleTooltipBind() {
                if ( ! scope.tt_isOpen ) {
                  showTooltipBind();
                } else {
                  hideTooltipBind();
                }
              }

              // Show the tooltip with delay if specified, otherwise show it immediately
              function showTooltipBind() {
                if (hasEnableExp && !scope.$eval(attrs[prefix + "Enable"])) {
                  return;
                }
                if ( scope.tt_popupDelay ) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                  if (!popupTimeout) {
                    popupTimeout = $timeout( show, scope.tt_popupDelay, false );
                    popupTimeout.then(function (reposition) {reposition();});
                  }
                } else {
                  show()();
                }
              }

              function hideTooltipBind() {
                scope.$apply(function () {
                  hide();
                });
              }

              // Show the tooltip popup element.
              function show() {

                popupTimeout = null;

                // If there is a pending remove transition, we must cancel it, lest the
                // tooltip be mysteriously removed.
                if ( transitionTimeout ) {
                  $timeout.cancel( transitionTimeout );
                  transitionTimeout = null;
                }

                // Don't show empty tooltips.
                if ( ! scope.tt_content ) {
                  return angular.noop;
                }

                createTooltip();

                // Set the initial positioning.
                tooltip.css({ top: 0, left: 0, display: "block" });

                // Now we add it to the DOM because need some info about it. But it's not
                // visible yet anyway.
                if ( appendToBody ) {
                  $document.find( "body" ).append( tooltip );
                } else {
                  element.after( tooltip );
                }

                positionTooltip();

                // And show the tooltip.
                scope.tt_isOpen = true;
                scope.$digest(); // digest required as $apply is not called

                // Return positioning function as promise callback for correct
                // positioning after draw.
                return positionTooltip;
              }

              // Hide the tooltip popup element.
              function hide() {
              // First things first: we don't show it anymore.
                scope.tt_isOpen = false;

                // if tooltip is going to be shown after delay, we must cancel this
                $timeout.cancel( popupTimeout );
                popupTimeout = null;

                // And now we remove it from the DOM. However, if we have animation, we
                // need to wait for it to expire beforehand.
                // FIXME: this is a placeholder for a port of the transitions library.
                if ( scope.tt_animation ) {
                  if (!transitionTimeout) {
                    transitionTimeout = $timeout(removeTooltip, 500);
                  }
                } else {
                  removeTooltip();
                }
              }

              function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
                if (tooltip) {
                  removeTooltip();
                }
                tooltip = tooltipLinker(scope, function () {});

                // Get contents rendered into the tooltip
                scope.$digest();
              }

              function removeTooltip() {
                transitionTimeout = null;
                if (tooltip) {
                  tooltip.remove();
                  tooltip = null;
                }
              }

              /**
             * Observe the relevant attributes.
             */
              attrs.$observe( type, function ( val ) {
                scope.tt_content = val;

                if (!val && scope.tt_isOpen ) {
                  hide();
                }
              });

              attrs.$observe( prefix + "Title", function ( val ) {
                scope.tt_title = val;
              });

              attrs.$observe( prefix + "Placement", function ( val ) {
                scope.tt_placement = angular.isDefined( val ) ? val : options.placement;
              });

              attrs.$observe( prefix + "PopupDelay", function ( val ) {
                var delay = parseInt( val, 10 );
                scope.tt_popupDelay = ! isNaN(delay) ? delay : options.popupDelay;
              });

              var unregisterTriggers = function () {
                element.unbind(triggers.show, showTooltipBind);
                element.unbind(triggers.hide, hideTooltipBind);
              };

              attrs.$observe( prefix + "Trigger", function ( val ) {
                unregisterTriggers();

                triggers = getTriggers( val );

                if ( triggers.show === triggers.hide ) {
                  element.bind( triggers.show, toggleTooltipBind );
                } else {
                  element.bind( triggers.show, showTooltipBind );
                  element.bind( triggers.hide, hideTooltipBind );
                }
              });

              var animation = scope.$eval(attrs[prefix + "Animation"]);
              scope.tt_animation = angular.isDefined(animation) ? !!animation : options.animation;

              attrs.$observe( prefix + "AppendToBody", function ( val ) {
                appendToBody = angular.isDefined( val ) ? $parse( val )( scope ) : appendToBody;
              });

              // if a tooltip is attached to <body> we need to remove it on
              // location change as its parent scope will probably not be destroyed
              // by the change.
              if ( appendToBody ) {
                scope.$on("$locationChangeSuccess", function closeTooltipOnLocationChangeSuccess() {
                  if ( scope.tt_isOpen ) {
                    hide();
                  }
                });
              }

              // Make sure tooltip is destroyed and removed.
              scope.$on("$destroy", function onDestroyTooltip() {
                $timeout.cancel( transitionTimeout );
                $timeout.cancel( popupTimeout );
                unregisterTriggers();
                removeTooltip();
              });
            };
          }
        };
      };
    }];
  })

  .directive( "tooltipPopup", function () {
    return {
      restrict: "EA",
      replace: true,
      scope: { content: "@", placement: "@", animation: "&", isOpen: "&" },
      templateUrl: "template/tooltip/tooltip-popup.html"
    };
  })

  .directive( "tooltip", [ "$tooltip", function ( $tooltip ) {
    return $tooltip( "tooltip", "tooltip", "mouseenter" );
  }])

  .directive( "tooltipHtmlUnsafePopup", function () {
    return {
      restrict: "EA",
      replace: true,
      scope: { content: "@", placement: "@", animation: "&", isOpen: "&" },
      templateUrl: "template/tooltip/tooltip-html-unsafe-popup.html"
    };
  })

  .directive( "tooltipHtmlUnsafe", [ "$tooltip", function ( $tooltip ) {
    return $tooltip( "tooltipHtmlUnsafe", "tooltip", "mouseenter" );
  }]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html popovers, and selector delegatation.
 */
angular.module( "ui.bootstrap.popover", [ "ui.bootstrap.tooltip" ] )

  .directive( "popoverPopup", function () {
    return {
      restrict: "EA",
      replace: true,
      scope: { title: "@", content: "@", placement: "@", animation: "&", isOpen: "&" },
      templateUrl: "template/popover/popover.html"
    };
  })

  .directive( "popover", [ "$tooltip", function ( $tooltip ) {
    return $tooltip( "popover", "popover", "click" );
  }]);

angular.module("ui.bootstrap.progressbar", [])

  .constant("progressConfig", {
    animate: true,
    max: 100
  })

  .controller("ProgressController", ["$scope", "$attrs", "progressConfig", function ($scope, $attrs, progressConfig) {
    var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

    this.bars = [];
    $scope.max = angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : progressConfig.max;

    this.addBar = function (bar, element) {
      if ( !animate ) {
        element.css({ "transition": "none" });
      }

      this.bars.push(bar);

      bar.$watch("value", function ( value ) {
        bar.percent = +(100 * value / $scope.max).toFixed(2);
      });

      bar.$on("$destroy", function () {
        element = null;
        self.removeBar(bar);
      });
    };

    this.removeBar = function (bar) {
      this.bars.splice(this.bars.indexOf(bar), 1);
    };
  }])

  .directive("progress", function () {
    return {
      restrict: "EA",
      replace: true,
      transclude: true,
      controller: "ProgressController",
      require: "progress",
      scope: {},
      templateUrl: "template/progressbar/progress.html"
    };
  })

  .directive("bar", function () {
    return {
      restrict: "EA",
      replace: true,
      transclude: true,
      require: "^progress",
      scope: {
        value: "=",
        type: "@"
      },
      templateUrl: "template/progressbar/bar.html",
      link: function (scope, element, attrs, progressCtrl) {
        progressCtrl.addBar(scope, element);
      }
    };
  })

  .directive("progressbar", function () {
    return {
      restrict: "EA",
      replace: true,
      transclude: true,
      controller: "ProgressController",
      scope: {
        value: "=",
        type: "@"
      },
      templateUrl: "template/progressbar/progressbar.html",
      link: function (scope, element, attrs, progressCtrl) {
        progressCtrl.addBar(scope, angular.element(element.children()[0]));
      }
    };
  });
angular.module("ui.bootstrap.rating", [])

  .constant("ratingConfig", {
    max: 5,
    stateOn: null,
    stateOff: null
  })

  .controller("RatingController", ["$scope", "$attrs", "ratingConfig", function ($scope, $attrs, ratingConfig) {
    var ngModelCtrl = { $setViewValue: angular.noop };

    this.init = function (ngModelCtrl_) {
      ngModelCtrl = ngModelCtrl_;
      ngModelCtrl.$render = this.render;

      this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
      this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;

      var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) :
        new Array( angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max );
      $scope.range = this.buildTemplateObjects(ratingStates);
    };

    this.buildTemplateObjects = function (states) {
      for (var i = 0, n = states.length; i < n; i++) {
        states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff }, states[i]);
      }
      return states;
    };

    $scope.rate = function (value) {
      if ( !$scope.readonly && value >= 0 && value <= $scope.range.length ) {
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$render();
      }
    };

    $scope.enter = function (value) {
      if ( !$scope.readonly ) {
        $scope.value = value;
      }
      $scope.onHover({ value: value });
    };

    $scope.reset = function () {
      $scope.value = ngModelCtrl.$viewValue;
      $scope.onLeave();
    };

    $scope.onKeydown = function (evt) {
      if (/(37|38|39|40)/.test(evt.which)) {
        evt.preventDefault();
        evt.stopPropagation();
        $scope.rate( $scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1) );
      }
    };

    this.render = function () {
      $scope.value = ngModelCtrl.$viewValue;
    };
  }])

  .directive("rating", function () {
    return {
      restrict: "EA",
      require: ["rating", "ngModel"],
      scope: {
        readonly: "=?",
        onHover: "&",
        onLeave: "&"
      },
      controller: "RatingController",
      templateUrl: "template/rating/rating.html",
      replace: true,
      link: function (scope, element, attrs, ctrls) {
        var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if ( ngModelCtrl ) {
          ratingCtrl.init( ngModelCtrl );
        }
      }
    };
  });

/**
 * @ngdoc overview
 * @name ui.bootstrap.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */

angular.module("ui.bootstrap.tabs", [])

  .controller("TabsetController", ["$scope", function TabsetCtrl($scope) {
    var ctrl = this,
      tabs = ctrl.tabs = $scope.tabs = [];

    ctrl.select = function (selectedTab) {
      angular.forEach(tabs, function (tab) {
        if (tab.active && tab !== selectedTab) {
          tab.active = false;
          tab.onDeselect();
        }
      });
      selectedTab.active = true;
      selectedTab.onSelect();
    };

    ctrl.addTab = function addTab(tab) {
      tabs.push(tab);
      // we can't run the select function on the first tab
      // since that would select it twice
      if (tabs.length === 1) {
        tab.active = true;
      } else if (tab.active) {
        ctrl.select(tab);
      }
    };

    ctrl.removeTab = function removeTab(tab) {
      var index = tabs.indexOf(tab);
      // Select a new tab if the tab to be removed is selected
      if (tab.active && tabs.length > 1) {
      // If this is the last tab, select the previous tab. else, the next tab.
        var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
        ctrl.select(tabs[newActiveIndex]);
      }
      tabs.splice(index, 1);
    };
  }])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab heading="Tab 1"><b>First</b> Content!</tab>
      <tab heading="Tab 2"><i>Second</i> Content!</tab>
    </tabset>
    <hr />
    <tabset vertical="true">
      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
    </tabset>
    <tabset justified="true">
      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
    </tabset>
  </file>
</example>
 */
  .directive("tabset", function () {
    return {
      restrict: "EA",
      transclude: true,
      replace: true,
      scope: {
        type: "@"
      },
      controller: "TabsetController",
      templateUrl: "template/tabs/tabset.html",
      link: function (scope, element, attrs) {
        scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
        scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
      }
    };
  })

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {string=} select An expression to evaluate when the tab is selected.
 * @param {boolean=} active A binding, telling whether or not this tab is selected.
 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <div ng-controller="TabsDemoCtrl">
      <button class="btn btn-small" ng-click="items[0].active = true">
        Select item 1, using active binding
      </button>
      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
        Enable/disable item 2, using disabled binding
      </button>
      <br />
      <tabset>
        <tab heading="Tab 1">First Tab</tab>
        <tab select="alertMe()">
          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
          Second Tab, with alert callback and html heading!
        </tab>
        <tab ng-repeat="item in items"
          heading="{{item.title}}"
          disabled="item.disabled"
          active="item.active">
          {{item.content}}
        </tab>
      </tabset>
    </div>
  </file>
  <file name="script.js">
    function TabsDemoCtrl($scope) {
      $scope.items = [
        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
      ];

      $scope.alertMe = function() {
        setTimeout(function() {
          alert("You've selected the alert tab!");
        });
      };
    };
  </file>
</example>
 */

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab>
        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
        And some content, too!
      </tab>
      <tab>
        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
        That's right.
      </tab>
    </tabset>
  </file>
</example>
 */
  .directive("tab", ["$parse", function ($parse) {
    return {
      require: "^tabset",
      restrict: "EA",
      replace: true,
      templateUrl: "template/tabs/tab.html",
      transclude: true,
      scope: {
        active: "=?",
        heading: "@",
        onSelect: "&select", // This callback is called in contentHeadingTransclude
        // once it inserts the tab's content into the dom
        onDeselect: "&deselect"
      },
      controller: function () {
      // Empty controller so other directives can require being 'under' a tab
      },
      compile: function (elm, attrs, transclude) {
        return function postLink(scope, elm, attrs, tabsetCtrl) {
          scope.$watch("active", function (active) {
            if (active) {
              tabsetCtrl.select(scope);
            }
          });

          scope.disabled = false;
          if ( attrs.disabled ) {
            scope.$parent.$watch($parse(attrs.disabled), function (value) {
              scope.disabled = !! value;
            });
          }

          scope.select = function () {
            if ( !scope.disabled ) {
              scope.active = true;
            }
          };

          tabsetCtrl.addTab(scope);
          scope.$on("$destroy", function () {
            tabsetCtrl.removeTab(scope);
          });

          // We need to transclude later, once the content container is ready.
          // when this link happens, we're inside a tab heading.
          scope.$transcludeFn = transclude;
        };
      }
    };
  }])

  .directive("tabHeadingTransclude", [function () {
    return {
      restrict: "A",
      require: "^tab",
      link: function (scope, elm, attrs, tabCtrl) {
        scope.$watch("headingElement", function updateHeadingElement(heading) {
          if (heading) {
            elm.html("");
            elm.append(heading);
          }
        });
      }
    };
  }])

  .directive("tabContentTransclude", function () {
    return {
      restrict: "A",
      require: "^tabset",
      link: function (scope, elm, attrs) {
        var tab = scope.$eval(attrs.tabContentTransclude);

        // Now our tab is ready to be transcluded: both the tab heading area
        // and the tab content area are loaded.  Transclude 'em both.
        tab.$transcludeFn(tab.$parent, function (contents) {
          angular.forEach(contents, function (node) {
            if (isTabHeading(node)) {
            // Let tabHeadingTransclude know.
              tab.headingElement = node;
            } else {
              elm.append(node);
            }
          });
        });
      }
    };
    function isTabHeading(node) {
      return node.tagName && (
        node.hasAttribute("tab-heading") ||
      node.hasAttribute("data-tab-heading") ||
      node.tagName.toLowerCase() === "tab-heading" ||
      node.tagName.toLowerCase() === "data-tab-heading"
      );
    }
  })

;

angular.module("ui.bootstrap.timepicker", [])

  .constant("timepickerConfig", {
    hourStep: 1,
    minuteStep: 1,
    showMeridian: true,
    meridians: null,
    readonlyInput: false,
    mousewheel: true
  })

  .controller("TimepickerController", ["$scope", "$attrs", "$parse", "$log", "$locale", "timepickerConfig", function ($scope, $attrs, $parse, $log, $locale, timepickerConfig) {
    var selected = new Date(),
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;

    this.init = function ( ngModelCtrl_, inputs ) {
      ngModelCtrl = ngModelCtrl_;
      ngModelCtrl.$render = this.render;

      var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1);

      var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
      if ( mousewheel ) {
        this.setupMousewheelEvents( hoursInputEl, minutesInputEl );
      }

      $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
      this.setupInputEvents( hoursInputEl, minutesInputEl );
    };

    var hourStep = timepickerConfig.hourStep;
    if ($attrs.hourStep) {
      $scope.$parent.$watch($parse($attrs.hourStep), function (value) {
        hourStep = parseInt(value, 10);
      });
    }

    var minuteStep = timepickerConfig.minuteStep;
    if ($attrs.minuteStep) {
      $scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
        minuteStep = parseInt(value, 10);
      });
    }

    // 12H / 24H mode
    $scope.showMeridian = timepickerConfig.showMeridian;
    if ($attrs.showMeridian) {
      $scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
        $scope.showMeridian = !!value;

        if ( ngModelCtrl.$error.time ) {
        // Evaluate from template
          var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
          if (angular.isDefined( hours ) && angular.isDefined( minutes )) {
            selected.setHours( hours );
            refresh();
          }
        } else {
          updateTemplate();
        }
      });
    }

    // Get $scope.hours in 24H mode if valid
    function getHoursFromTemplate( ) {
      var hours = parseInt( $scope.hours, 10 );
      var valid = ( $scope.showMeridian ) ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
      if ( !valid ) {
        return undefined;
      }

      if ( $scope.showMeridian ) {
        if ( hours === 12 ) {
          hours = 0;
        }
        if ( $scope.meridian === meridians[1] ) {
          hours = hours + 12;
        }
      }
      return hours;
    }

    function getMinutesFromTemplate() {
      var minutes = parseInt($scope.minutes, 10);
      return ( minutes >= 0 && minutes < 60 ) ? minutes : undefined;
    }

    function pad( value ) {
      return ( angular.isDefined(value) && value.toString().length < 2 ) ? "0" + value : value;
    }

    // Respond on mousewheel spin
    this.setupMousewheelEvents = function ( hoursInputEl, minutesInputEl ) {
      var isScrollingUp = function (e) {
        if (e.originalEvent) {
          e = e.originalEvent;
        }
        // pick correct delta variable depending on event
        var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
        return (e.detail || delta > 0);
      };

      hoursInputEl.bind("mousewheel wheel", function (e) {
        $scope.$apply( (isScrollingUp(e)) ? $scope.incrementHours() : $scope.decrementHours() );
        e.preventDefault();
      });

      minutesInputEl.bind("mousewheel wheel", function (e) {
        $scope.$apply( (isScrollingUp(e)) ? $scope.incrementMinutes() : $scope.decrementMinutes() );
        e.preventDefault();
      });

    };

    this.setupInputEvents = function ( hoursInputEl, minutesInputEl ) {
      if ( $scope.readonlyInput ) {
        $scope.updateHours = angular.noop;
        $scope.updateMinutes = angular.noop;
        return;
      }

      var invalidate = function (invalidHours, invalidMinutes) {
        ngModelCtrl.$setViewValue( null );
        ngModelCtrl.$setValidity("time", false);
        if (angular.isDefined(invalidHours)) {
          $scope.invalidHours = invalidHours;
        }
        if (angular.isDefined(invalidMinutes)) {
          $scope.invalidMinutes = invalidMinutes;
        }
      };

      $scope.updateHours = function () {
        var hours = getHoursFromTemplate();

        if ( angular.isDefined(hours) ) {
          selected.setHours( hours );
          refresh( "h" );
        } else {
          invalidate(true);
        }
      };

      hoursInputEl.bind("blur", function (e) {
        if ( !$scope.invalidHours && $scope.hours < 10) {
          $scope.$apply( function () {
            $scope.hours = pad( $scope.hours );
          });
        }
      });

      $scope.updateMinutes = function () {
        var minutes = getMinutesFromTemplate();

        if ( angular.isDefined(minutes) ) {
          selected.setMinutes( minutes );
          refresh( "m" );
        } else {
          invalidate(undefined, true);
        }
      };

      minutesInputEl.bind("blur", function (e) {
        if ( !$scope.invalidMinutes && $scope.minutes < 10 ) {
          $scope.$apply( function () {
            $scope.minutes = pad( $scope.minutes );
          });
        }
      });

    };

    this.render = function () {
      var date = ngModelCtrl.$modelValue ? new Date( ngModelCtrl.$modelValue ) : null;

      if ( isNaN(date) ) {
        ngModelCtrl.$setValidity("time", false);
        $log.error("Timepicker directive: \"ng-model\" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.");
      } else {
        if ( date ) {
          selected = date;
        }
        makeValid();
        updateTemplate();
      }
    };

    // Call internally when we know that model is valid.
    function refresh( keyboardChange ) {
      makeValid();
      ngModelCtrl.$setViewValue( new Date(selected) );
      updateTemplate( keyboardChange );
    }

    function makeValid() {
      ngModelCtrl.$setValidity("time", true);
      $scope.invalidHours = false;
      $scope.invalidMinutes = false;
    }

    function updateTemplate( keyboardChange ) {
      var hours = selected.getHours(), minutes = selected.getMinutes();

      if ( $scope.showMeridian ) {
        hours = ( hours === 0 || hours === 12 ) ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === "h" ? hours : pad(hours);
      $scope.minutes = keyboardChange === "m" ? minutes : pad(minutes);
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }

    function addMinutes( minutes ) {
      var dt = new Date( selected.getTime() + minutes * 60000 );
      selected.setHours( dt.getHours(), dt.getMinutes() );
      refresh();
    }

    $scope.incrementHours = function () {
      addMinutes( hourStep * 60 );
    };
    $scope.decrementHours = function () {
      addMinutes( - hourStep * 60 );
    };
    $scope.incrementMinutes = function () {
      addMinutes( minuteStep );
    };
    $scope.decrementMinutes = function () {
      addMinutes( - minuteStep );
    };
    $scope.toggleMeridian = function () {
      addMinutes( 12 * 60 * (( selected.getHours() < 12 ) ? 1 : -1) );
    };
  }])

  .directive("timepicker", function () {
    return {
      restrict: "EA",
      require: ["timepicker", "?^ngModel"],
      controller: "TimepickerController",
      replace: true,
      scope: {},
      templateUrl: "template/timepicker/timepicker.html",
      link: function (scope, element, attrs, ctrls) {
        var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

        if ( ngModelCtrl ) {
          timepickerCtrl.init( ngModelCtrl, element.find("input") );
        }
      }
    };
  });

angular.module("ui.bootstrap.typeahead", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory("typeaheadParser", ["$parse", function ($parse) {

    //                      00000111000000000000022200000000000000003333333333333330000000000044000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;

    return {
      parse: function (input) {

        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            "Expected typeahead specification in form of \"_modelValue_ (as _label_)? for _item_ in _collection_\"" +
            " but got \"" + input + "\".");
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .directive("typeahead", ["$compile", "$parse", "$q", "$timeout", "$document", "$position", "typeaheadParser",
    function ($compile, $parse, $q, $timeout, $document, $position, typeaheadParser) {

      var HOT_KEYS = [9, 13, 27, 38, 40];

      return {
        require: "ngModel",
        link: function (originalScope, element, attrs, modelCtrl) {

          // SUPPORTED ATTRIBUTES (OPTIONS)

          // minimal no of characters that needs to be entered before typeahead kicks-in
          var minSearch = originalScope.$eval(attrs.typeaheadMinLength) || 1;

          // minimal wait time after last character typed before typehead kicks-in
          var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

          // should it restrict model values to the ones selected from the popup only?
          var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;

          // binding to a variable that indicates if matches are being retrieved asynchronously
          var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

          // a callback executed when a match is selected
          var onSelectCallback = $parse(attrs.typeaheadOnSelect);

          var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

          var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

          // INTERNAL VARIABLES

          // model setter executed upon match selection
          var $setModelValue = $parse(attrs.ngModel).assign;

          // expressions used by typeahead
          var parserResult = typeaheadParser.parse(attrs.typeahead);

          var hasFocus;

          // create a child scope for the typeahead directive so we are not polluting original scope
          // with typeahead-specific data (matches, query etc.)
          var scope = originalScope.$new();
          originalScope.$on("$destroy", function () {
            scope.$destroy();
          });

          // WAI-ARIA
          var popupId = "typeahead-" + scope.$id + "-" + Math.floor(Math.random() * 10000);
          element.attr({
            "aria-autocomplete": "list",
            "aria-expanded": false,
            "aria-owns": popupId
          });

          // pop-up element used to display matches
          var popUpEl = angular.element("<div typeahead-popup></div>");
          popUpEl.attr({
            id: popupId,
            matches: "matches",
            active: "activeIdx",
            select: "select(activeIdx)",
            query: "query",
            position: "position"
          });
          // custom item template
          if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
            popUpEl.attr("template-url", attrs.typeaheadTemplateUrl);
          }

          var resetMatches = function () {
            scope.matches = [];
            scope.activeIdx = -1;
            element.attr("aria-expanded", false);
          };

          var getMatchId = function (index) {
            return popupId + "-option-" + index;
          };

          // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
          // This attribute is added or removed automatically when the `activeIdx` changes.
          scope.$watch("activeIdx", function (index) {
            if (index < 0) {
              element.removeAttr("aria-activedescendant");
            } else {
              element.attr("aria-activedescendant", getMatchId(index));
            }
          });

          var getMatchesAsync = function (inputValue) {

            var locals = { $viewValue: inputValue };
            isLoadingSetter(originalScope, true);
            $q.when(parserResult.source(originalScope, locals)).then(function (matches) {

              // it might happen that several async queries were in progress if a user were typing fast
              // but we are interested only in responses that correspond to the current view value
              var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
              if (onCurrentRequest && hasFocus) {
                if (matches.length > 0) {

                  scope.activeIdx = 0;
                  scope.matches.length = 0;

                  // transform labels
                  for (var i = 0; i < matches.length; i++) {
                    locals[parserResult.itemName] = matches[i];
                    scope.matches.push({
                      id: getMatchId(i),
                      label: parserResult.viewMapper(scope, locals),
                      model: matches[i]
                    });
                  }

                  scope.query = inputValue;
                  // position pop-up with matches - we need to re-calculate its position each time we are opening a window
                  // with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                  // due to other elements being rendered
                  scope.position = appendToBody ? $position.offset(element) : $position.position(element);
                  scope.position.top = scope.position.top + element.prop("offsetHeight");

                  element.attr("aria-expanded", true);
                } else {
                  resetMatches();
                }
              }
              if (onCurrentRequest) {
                isLoadingSetter(originalScope, false);
              }
            }, function () {
              resetMatches();
              isLoadingSetter(originalScope, false);
            });
          };

          resetMatches();

          // we need to propagate user's query so we can higlight matches
          scope.query = undefined;

          // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
          var timeoutPromise;

          var scheduleSearchWithTimeout = function (inputValue) {
            timeoutPromise = $timeout(function () {
              getMatchesAsync(inputValue);
            }, waitTime);
          };

          var cancelPreviousTimeout = function () {
            if (timeoutPromise) {
              $timeout.cancel(timeoutPromise);
            }
          };

          // plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
          // $parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
          modelCtrl.$parsers.unshift(function (inputValue) {

            hasFocus = true;

            if (inputValue && inputValue.length >= minSearch) {
              if (waitTime > 0) {
                cancelPreviousTimeout();
                scheduleSearchWithTimeout(inputValue);
              } else {
                getMatchesAsync(inputValue);
              }
            } else {
              isLoadingSetter(originalScope, false);
              cancelPreviousTimeout();
              resetMatches();
            }

            if (isEditable) {
              return inputValue;
            } else {
              if (!inputValue) {
                // Reset in case user had typed something previously.
                modelCtrl.$setValidity("editable", true);
                return inputValue;
              } else {
                modelCtrl.$setValidity("editable", false);
                return undefined;
              }
            }
          });

          modelCtrl.$formatters.push(function (modelValue) {

            var candidateViewValue, emptyViewValue;
            var locals = {};

            if (inputFormatter) {

              locals["$model"] = modelValue;
              return inputFormatter(originalScope, locals);

            } else {

              // it might happen that we don't have enough info to properly render input value
              // we need to check for this situation and simply return model value if we can't apply custom formatting
              locals[parserResult.itemName] = modelValue;
              candidateViewValue = parserResult.viewMapper(originalScope, locals);
              locals[parserResult.itemName] = undefined;
              emptyViewValue = parserResult.viewMapper(originalScope, locals);

              return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
            }
          });

          scope.select = function (activeIdx) {
            // called from within the $digest() cycle
            var locals = {};
            var model, item;

            locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
            model = parserResult.modelMapper(originalScope, locals);
            $setModelValue(originalScope, model);
            modelCtrl.$setValidity("editable", true);

            onSelectCallback(originalScope, {
              $item: item,
              $model: model,
              $label: parserResult.viewMapper(originalScope, locals)
            });

            resetMatches();

            // return focus to the input element if a match was selected via a mouse click event
            // use timeout to avoid $rootScope:inprog error
            $timeout(function () { element[0].focus(); }, 0, false);
          };

          // bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
          element.bind("keydown", function (evt) {

            // typeahead is open and an "interesting" key was pressed
            if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
              return;
            }

            evt.preventDefault();

            if (evt.which === 40) {
              scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
              scope.$digest();

            } else if (evt.which === 38) {
              scope.activeIdx = (scope.activeIdx ? scope.activeIdx : scope.matches.length) - 1;
              scope.$digest();

            } else if (evt.which === 13 || evt.which === 9) {
              scope.$apply(function () {
                scope.select(scope.activeIdx);
              });

            } else if (evt.which === 27) {
              evt.stopPropagation();

              resetMatches();
              scope.$digest();
            }
          });

          element.bind("blur", function (evt) {
            hasFocus = false;
          });

          // Keep reference to click handler to unbind it.
          var dismissClickHandler = function (evt) {
            if (element[0] !== evt.target) {
              resetMatches();
              scope.$digest();
            }
          };

          $document.bind("click", dismissClickHandler);

          originalScope.$on("$destroy", function () {
            $document.unbind("click", dismissClickHandler);
          });

          var $popup = $compile(popUpEl)(scope);
          if ( appendToBody ) {
            $document.find("body").append($popup);
          } else {
            element.after($popup);
          }
        }
      };

    }])

  .directive("typeaheadPopup", function () {
    return {
      restrict: "EA",
      scope: {
        matches: "=",
        query: "=",
        active: "=",
        position: "=",
        select: "&"
      },
      replace: true,
      templateUrl: "template/typeahead/typeahead-popup.html",
      link: function (scope, element, attrs) {

        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function () {
          return scope.matches.length > 0;
        };

        scope.isActive = function (matchIdx) {
          return scope.active == matchIdx;
        };

        scope.selectActive = function (matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function (activeIdx) {
          scope.select({ activeIdx: activeIdx });
        };
      }
    };
  })

  .directive("typeaheadMatch", ["$http", "$templateCache", "$compile", "$parse", function ($http, $templateCache, $compile, $parse) {
    return {
      restrict: "EA",
      scope: {
        index: "=",
        match: "=",
        query: "="
      },
      link: function (scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || "template/typeahead/typeahead-match.html";
        $http.get(tplUrl, { cache: $templateCache }).then(function (tplContent) {
          element.replaceWith($compile(tplContent.data.trim())(scope));
        });
      }
    };
  }])

  .filter("typeaheadHighlight", function () {

    function escapeRegexp(queryToEscape) {
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    }

    return function (matchItem, query) {
      return query ? ("" + matchItem).replace(new RegExp(escapeRegexp(query), "gi"), "<strong>$&</strong>") : matchItem;
    };
  });

angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/accordion/accordion-group.html",
    "<div class=\"panel panel-default\">\n" +
    "  <div class=\"panel-heading\">\n" +
    "    <h4 class=\"panel-title\">\n" +
    "      <a class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "    </h4>\n" +
    "  </div>\n" +
    "  <div class=\"panel-collapse\" collapse=\"!isOpen\">\n" +
    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/accordion/accordion.html",
    "<div class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/alert/alert.html",
    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissable' : null]\" role=\"alert\">\n" +
    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close()\">\n" +
    "        <span aria-hidden=\"true\">&times;</span>\n" +
    "        <span class=\"sr-only\">Close</span>\n" +
    "    </button>\n" +
    "    <div ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/carousel/carousel.html",
    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
    "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "        <li ng-repeat=\"slide in slides track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
    "    </ol>\n" +
    "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
    "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" +
    "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/carousel/slide.html",
    "<div ng-class=\"{\n" +
    "    'active': leaving || (active && !entering),\n" +
    "    'prev': (next || active) && direction=='prev',\n" +
    "    'next': (next || active) && direction=='next',\n" +
    "    'right': direction=='prev',\n" +
    "    'left': direction=='next'\n" +
    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
    "</div>");
}]);

angular.module("template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{5 + showWeeks}}\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-show=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in labels track by $index\" class=\"text-center\"><small aria-label=\"{{label.full}}\">{{label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-show=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-muted': dt.secondary, 'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/popup.html",
    "<ul class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" +
    "	<li ng-transclude></li>\n" +
    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
    "		<span class=\"btn-group\">\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
    "		</span>\n" +
    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"3\"><button id=\"{{uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{dt.uid}}\" aria-disabled=\"{{!!dt.disabled}}\">\n" +
    "        <button type=\"button\" style=\"width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"{'text-info': dt.current}\">{{dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/backdrop.html",
    "<div class=\"modal-backdrop fade {{ backdropClass }}\"\n" +
    "     ng-class=\"{in: animate}\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/window.html",
    "<div tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
    "    <div class=\"modal-dialog\" ng-class=\"{'modal-sm': size == 'sm', 'modal-lg': size == 'lg'}\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
    "</div>");
}]);

angular.module("template/pagination/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/pagination/pager.html",
    "<ul class=\"pager\">\n" +
    "  <li ng-class=\"{disabled: noPrevious(), previous: align}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" +
    "  <li ng-class=\"{disabled: noNext(), next: align}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" +
    "</ul>");
}]);

angular.module("template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/pagination/pagination.html",
    "<ul class=\"pagination\">\n" +
    "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(1)\">{{getText('first')}}</a></li>\n" +
    "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noPrevious()}\"><a href ng-click=\"selectPage(page - 1)\">{{getText('previous')}}</a></li>\n" +
    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active}\"><a href ng-click=\"selectPage(page.number)\">{{page.text}}</a></li>\n" +
    "  <li ng-if=\"directionLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(page + 1)\">{{getText('next')}}</a></li>\n" +
    "  <li ng-if=\"boundaryLinks\" ng-class=\"{disabled: noNext()}\"><a href ng-click=\"selectPage(totalPages)\">{{getText('last')}}</a></li>\n" +
    "</ul>");
}]);

angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/popover/popover.html",
    "<div class=\"popover {{placement}}\" ng-class=\"{ in: isOpen(), fade: animation() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>");
}]);

angular.module("template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude></div>");
}]);

angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: percent + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" ng-transclude></div>\n" +
    "</div>");
}]);

angular.module("template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
    "    <i ng-repeat=\"r in range track by $index\" ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\">\n" +
    "        <span class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    </i>\n" +
    "</span>");
}]);

angular.module("template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tabs/tab.html",
    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
    "  <a ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\" \n" +
    "         ng-repeat=\"tab in tabs\" \n" +
    "         ng-class=\"{active: tab.active}\"\n" +
    "         tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/timepicker/timepicker.html",
    "<table>\n" +
    "	<tbody>\n" +
    "		<tr class=\"text-center\">\n" +
    "			<td><a ng-click=\"incrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "			<td>&nbsp;</td>\n" +
    "			<td><a ng-click=\"incrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "			<td ng-show=\"showMeridian\"></td>\n" +
    "		</tr>\n" +
    "		<tr>\n" +
    "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "				<input type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-mousewheel=\"incrementHours()\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" +
    "			</td>\n" +
    "			<td>:</td>\n" +
    "			<td style=\"width:50px;\" class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "				<input type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\">\n" +
    "			</td>\n" +
    "			<td ng-show=\"showMeridian\"><button type=\"button\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\">{{meridian}}</button></td>\n" +
    "		</tr>\n" +
    "		<tr class=\"text-center\">\n" +
    "			<td><a ng-click=\"decrementHours()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "			<td>&nbsp;</td>\n" +
    "			<td><a ng-click=\"decrementMinutes()\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "			<td ng-show=\"showMeridian\"></td>\n" +
    "		</tr>\n" +
    "	</tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/typeahead/typeahead-match.html",
    "<a tabindex=\"-1\" bind-html-unsafe=\"match.label | typeaheadHighlight:query\"></a>");
}]);

angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen()\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{match.id}}\">\n" +
    "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);

/**
 * @license
 * lodash 4.3.0 <https://lodash.com/>
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
(function () {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = "4.3.0";

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;

  /** Used to compose bitmasks for comparison styles. */
  var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = "...";

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 150,
    HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
    LAZY_MAP_FLAG = 2,
    LAZY_WHILE_FLAG = 3;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = "Expected a function";

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = "__lodash_hash_undefined__";

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = "__lodash_placeholder__";

  /** `Object#toString` result references. */
  var argsTag = "[object Arguments]",
    arrayTag = "[object Array]",
    boolTag = "[object Boolean]",
    dateTag = "[object Date]",
    errorTag = "[object Error]",
    funcTag = "[object Function]",
    genTag = "[object GeneratorFunction]",
    mapTag = "[object Map]",
    numberTag = "[object Number]",
    objectTag = "[object Object]",
    regexpTag = "[object RegExp]",
    setTag = "[object Set]",
    stringTag = "[object String]",
    symbolTag = "[object Symbol]",
    weakMapTag = "[object WeakMap]",
    weakSetTag = "[object WeakSet]";

  var arrayBufferTag = "[object ArrayBuffer]",
    float32Tag = "[object Float32Array]",
    float64Tag = "[object Float64Array]",
    int8Tag = "[object Int8Array]",
    int16Tag = "[object Int16Array]",
    int32Tag = "[object Int32Array]",
    uint8Tag = "[object Uint8Array]",
    uint8ClampedTag = "[object Uint8ClampedArray]",
    uint16Tag = "[object Uint16Array]",
    uint32Tag = "[object Uint32Array]";

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
    reUnescapedHtml = /[&<>"'`]/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source),
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
    reEvaluate = /<%([\s\S]+?)%>/g,
    reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;

  /** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
    reTrimStart = /^\s+/,
    reTrimEnd = /\s+$/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0x/i;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23",
    rsComboSymbolsRange = "\\u20d0-\\u20f0",
    rsDingbatRange = "\\u2700-\\u27bf",
    rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff",
    rsMathOpRange = "\\xac\\xb1\\xd7\\xf7",
    rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
    rsQuoteRange = "\\u2018\\u2019\\u201c\\u201d",
    rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde",
    rsVarRange = "\\ufe0e\\ufe0f",
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsQuoteRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsAstral = "[" + rsAstralRange + "]",
    rsBreak = "[" + rsBreakRange + "]",
    rsCombo = "[" + rsComboMarksRange + rsComboSymbolsRange + "]",
    rsDigits = "\\d+",
    rsDingbat = "[" + rsDingbatRange + "]",
    rsLower = "[" + rsLowerRange + "]",
    rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]",
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")",
    rsNonAstral = "[^" + rsAstralRange + "]",
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper = "[" + rsUpperRange + "]",
    rsZWJ = "\\u200d";

  /** Used to compose unicode regexes. */
  var rsLowerMisc = "(?:" + rsLower + "|" + rsMisc + ")",
    rsUpperMisc = "(?:" + rsUpper + "|" + rsMisc + ")",
    reOptMod = rsModifier + "?",
    rsOptVar = "[" + rsVarRange + "]?",
    rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*",
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq,
    rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, "g");

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reComplexSymbol = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasComplexSymbol = RegExp("[" + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + "]");

  /** Used to match non-compound words composed of alphanumeric characters. */
  var reBasicWord = /[a-zA-Z0-9]+/g;

  /** Used to match complex or compound words. */
  var reComplexWord = RegExp([
    rsUpper + "?" + rsLower + "+(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
    rsUpperMisc + "+(?=" + [rsBreak, rsUpper + rsLowerMisc, "$"].join("|") + ")",
    rsUpper + "?" + rsLowerMisc + "+",
    rsUpper + "+",
    rsDigits,
    rsEmoji
  ].join("|"), "g");

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasComplexWord = /[a-z][A-Z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    "Array", "Buffer", "Date", "Error", "Float32Array", "Float64Array",
    "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object",
    "Reflect", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array",
    "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_",
    "clearTimeout", "isFinite", "parseInt", "setTimeout"
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[mapTag] = cloneableTags[numberTag] =
  cloneableTags[objectTag] = cloneableTags[regexpTag] =
  cloneableTags[setTag] = cloneableTags[stringTag] =
  cloneableTags[symbolTag] = cloneableTags[uint8Tag] =
  cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] =
  cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    "\xc0": "A", "\xc1": "A", "\xc2": "A", "\xc3": "A", "\xc4": "A", "\xc5": "A",
    "\xe0": "a", "\xe1": "a", "\xe2": "a", "\xe3": "a", "\xe4": "a", "\xe5": "a",
    "\xc7": "C", "\xe7": "c",
    "\xd0": "D", "\xf0": "d",
    "\xc8": "E", "\xc9": "E", "\xca": "E", "\xcb": "E",
    "\xe8": "e", "\xe9": "e", "\xea": "e", "\xeb": "e",
    "\xcC": "I", "\xcd": "I", "\xce": "I", "\xcf": "I",
    "\xeC": "i", "\xed": "i", "\xee": "i", "\xef": "i",
    "\xd1": "N", "\xf1": "n",
    "\xd2": "O", "\xd3": "O", "\xd4": "O", "\xd5": "O", "\xd6": "O", "\xd8": "O",
    "\xf2": "o", "\xf3": "o", "\xf4": "o", "\xf5": "o", "\xf6": "o", "\xf8": "o",
    "\xd9": "U", "\xda": "U", "\xdb": "U", "\xdc": "U",
    "\xf9": "u", "\xfa": "u", "\xfb": "u", "\xfc": "u",
    "\xdd": "Y", "\xfd": "y", "\xff": "y",
    "\xc6": "Ae", "\xe6": "ae",
    "\xde": "Th", "\xfe": "th",
    "\xdf": "ss"
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;",
    "`": "&#96;"
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": "\"",
    "&#39;": "'",
    "&#96;": "`"
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    "function": true,
    "object": true
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    "\\": "\\",
    "'": "'",
    "\n": "n",
    "\r": "r",
    "\u2028": "u2028",
    "\u2029": "u2029"
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
    freeParseInt = parseInt;

  /** Detect free variable `exports`. */
  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType) ? exports : null;

  /** Detect free variable `module`. */
  var freeModule = (objectTypes[typeof module] && module && !module.nodeType) ? module : null;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global === "object" && global);

  /** Detect free variable `self`. */
  var freeSelf = checkGlobal(objectTypes[typeof self] && self);

  /** Detect free variable `window`. */
  var freeWindow = checkGlobal(objectTypes[typeof window] && window);

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = (freeModule && freeModule.exports === freeExports) ? freeExports : null;

  /** Detect `this` as the global object. */
  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) || freeSelf || thisGlobal || Function("return this")();

  /* --------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {...*} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    var length = args.length;
    switch (length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
      length = array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * Creates a new array concatenating `array` with `other`.
   *
   * @private
   * @param {Array} array The first array to concatenate.
   * @param {Array} other The second array to concatenate.
   * @returns {Array} Returns the new concatenated array.
   */
  function arrayConcat(array, other) {
    var index = -1,
      length = array.length,
      othIndex = -1,
      othLength = other.length,
      result = Array(length + othLength);

    while (++index < length) {
      result[index] = array[index];
    }
    while (++othIndex < othLength) {
      result[index++] = other[othIndex];
    }
    return result;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
      length = array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
      length = array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
      length = array.length,
      resIndex = -1,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    return !!array.length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * A specialized version of `_.includesWith` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
      length = array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array.length,
      result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
      length = values.length,
      offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
      length = array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
      length = array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * The base implementation of methods like `_.max` and `_.min` which accepts a
   * `comparator` to determine the extremum value.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The iteratee invoked per iteration.
   * @param {Function} comparator The comparator used to compare values.
   * @returns {*} Returns the extremum value.
   */
  function baseExtremum(array, iteratee, comparator) {
    var index = -1,
      length = array.length;

    while (++index < length) {
      var value = array[index],
        current = iteratee(value);

      if (current != null && (computed === undefined
        ? current === current
        : comparator(current, computed)
      )) {
        var computed = current,
          result = value;
      }
    }
    return result;
  }

  /**
   * The base implementation of methods like `_.find` and `_.findKey`, without
   * support for iteratee shorthands, which iterates over `collection` using
   * `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @param {boolean} [retKey] Specify returning the key of the found element instead of the element itself.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFind(collection, predicate, eachFunc, retKey) {
    var result;
    eachFunc(collection, function (value, key, collection) {
      if (predicate(value, key, collection)) {
        result = retKey ? key : value;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
      index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
      length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function (value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define
   * the sort order of `array` and replaces criteria objects with their
   * corresponding values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` without support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
      index = -1,
      length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the new array of key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function (key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing wrapper metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function (key) {
      return object[key];
    });
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
      length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Checks if `value` is a global object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
   */
  function checkGlobal(value) {
    return (value && value.Object === Object) ? value : null;
  }

  /**
   * Compares values to sort them in ascending order.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function compareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
        valIsUndef = value === undefined,
        valIsReflexive = value === value;

      var othIsNull = other === null,
        othIsUndef = other === undefined,
        othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * Used by `_.orderBy` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
   * specify an order of "desc" for descending or "asc" for ascending sort order
   * of corresponding values.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]|string[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

    while (++index < length) {
      var result = compareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * (order == "desc" ? -1 : 1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return "\\" + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
      index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString !== "function") {
      try {
        result = !!(value + "");
      } catch (e) {}
    }
    return result;
  }

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    value = (typeof value === "number" || reIsUint.test(value)) ? +value : -1;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
      result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to an array.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the converted array.
   */
  function mapToArray(map) {
    var index = -1,
      result = Array(map.size);

    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
      length = array.length,
      resIndex = -1,
      result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the converted array.
   */
  function setToArray(set) {
    var index = -1,
      result = Array(set.size);

    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    if (!(string && reHasComplexSymbol.test(string))) {
      return string.length;
    }
    var result = reComplexSymbol.lastIndex = 0;
    while (reComplexSymbol.test(string)) {
      result++;
    }
    return result;
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return string.match(reComplexSymbol);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /* --------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Use `context` to mock `Date#getTime` use in `_.now`.
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;

    /** Built-in constructor references. */
    var Date = context.Date,
      Error = context.Error,
      Math = context.Math,
      RegExp = context.RegExp,
      TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = context.Array.prototype,
      objectProto = context.Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = context.Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objectToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp("^" +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&")
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
      Reflect = context.Reflect,
      Symbol = context.Symbol,
      Uint8Array = context.Uint8Array,
      clearTimeout = context.clearTimeout,
      enumerate = Reflect ? Reflect.enumerate : undefined,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertySymbols = Object.getOwnPropertySymbols,
      iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) === "symbol" ? iteratorSymbol : undefined,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      setTimeout = context.setTimeout,
      splice = arrayProto.splice;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
      nativeFloor = Math.floor,
      nativeIsFinite = context.isFinite,
      nativeJoin = arrayProto.join,
      nativeKeys = Object.keys,
      nativeMax = Math.max,
      nativeMin = Math.min,
      nativeParseInt = context.parseInt,
      nativeRandom = Math.random,
      nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var Map = getNative(context, "Map"),
      Set = getNative(context, "Set"),
      WeakMap = getNative(context, "WeakMap"),
      nativeCreate = getNative(Object, "create");

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to detect maps, sets, and weakmaps. */
    var mapCtorString = Map ? funcToString.call(Map) : "",
      setCtorString = Set ? funcToString.call(Set) : "",
      weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : "";

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = Symbol ? symbolProto.valueOf : undefined,
      symbolToString = Symbol ? symbolProto.toString : undefined;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /* ------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chaining. Methods that operate on and return arrays, collections, and
     * functions can be chained together. Methods that retrieve a single value or
     * may return a primitive value will automatically end the chain sequence and
     * return the unwrapped value. Otherwise, the value must be unwrapped with
     * `_#value`.
     *
     * Explicit chaining, which must be unwrapped with `_#value` in all cases,
     * may be enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization to merge iteratee calls; this avoids the creation
     * of intermediate arrays and can greatly reduce the number of iteratee executions.
     * Sections of a chain sequence qualify for shortcut fusion if the section is
     * applied to an array of at least two hundred elements and any iteratees
     * accept only one argument. The heuristic for whether a section qualifies
     * for shortcut fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`,
     * `at`, `before`, `bind`, `bindAll`, `bindKey`, `chain`, `chunk`, `commit`,
     * `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`, `curry`,
     * `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`, `difference`,
     * `differenceBy`, `differenceWith`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flip`, `flow`,
     * `flowRight`, `fromPairs`, `functions`, `functionsIn`, `groupBy`, `initial`,
     * `intersection`, `intersectionBy`, `intersectionWith`, `invert`, `invertBy`,
     * `invokeMap`, `iteratee`, `keyBy`, `keys`, `keysIn`, `map`, `mapKeys`,
     * `mapValues`, `matches`, `matchesProperty`, `memoize`, `merge`, `mergeWith`,
     * `method`, `methodOf`, `mixin`, `negate`, `nthArg`, `omit`, `omitBy`, `once`,
     * `orderBy`, `over`, `overArgs`, `overEvery`, `overSome`, `partial`,
     * `partialRight`, `partition`, `pick`, `pickBy`, `plant`, `property`,
     * `propertyOf`, `pull`, `pullAll`, `pullAllBy`, `pullAt`, `push`, `range`,
     * `rangeRight`, `rearg`, `reject`, `remove`, `rest`, `reverse`, `sampleSize`,
     * `set`, `setWith`, `shuffle`, `slice`, `sort`, `sortBy`, `splice`, `spread`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`, `throttle`,
     * `thru`, `toArray`, `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`,
     * `transform`, `unary`, `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`,
     * `uniqWith`, `unset`, `unshift`, `unzip`, `unzipWith`, `values`, `valuesIn`,
     * `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`, `zipObject`,
     * `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `endsWith`, `eq`,
     * `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`,
     * `findLast`, `findLastIndex`, `findLastKey`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
     * `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`, `isError`,
     * `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMatch`, `isMatchWith`,
     * `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`, `isObject`, `isObjectLike`,
     * `isPlainObject`, `isRegExp`, `isSafeInteger`, `isString`, `isUndefined`,
     * `isTypedArray`, `join`, `kebabCase`, `last`, `lastIndexOf`, `lowerCase`,
     * `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `min`, `minBy`,
     * `noConflict`, `noop`, `now`, `pad`, `padEnd`, `padStart`, `parseInt`,
     * `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`, `round`,
     * `runInContext`, `sample`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
     * `sortedIndexBy`, `sortedLastIndex`, `sortedLastIndexBy`, `startCase`,
     * `startsWith`, `subtract`, `sum`, `sumBy`, `template`, `times`, `toLower`,
     * `toInteger`, `toLength`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`,
     * `trim`, `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`,
     * `upperCase`, `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, "__wrapped__")) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      "escape": reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      "evaluate": reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      "interpolate": reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      "variable": "",

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      "imports": {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        "_": lodash
      }
    };

    /* ------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
        dir = this.__dir__,
        isArr = isArray(array),
        isRight = dir < 0,
        arrLength = isArr ? array.length : 0,
        view = getView(0, arrLength, this.__views__),
        start = view.start,
        end = view.end,
        length = end - start,
        index = isRight ? end : (start - 1),
        iteratees = this.__iteratees__,
        iterLength = iteratees.length,
        resIndex = 0,
        takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
          value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
            iteratee = data.iteratee,
            type = data.type,
            computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Creates an hash object.
     *
     * @private
     * @returns {Object} Returns the new hash object.
     */
    function Hash() {}

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(hash, key) {
      return hashHas(hash, key) && delete hash[key];
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @param {Object} hash The hash to query.
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(hash, key) {
      if (nativeCreate) {
        var result = hash[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @param {Object} hash The hash to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(hash, key) {
      return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     */
    function hashSet(hash, key, value) {
      hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function MapCache(values) {
      var index = -1,
        length = values ? values.length : 0;

      this.clear();
      while (++index < length) {
        var entry = values[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapClear() {
      this.__data__ = { "hash": new Hash, "map": Map ? new Map : [], "string": new Hash };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapDelete(key) {
      var data = this.__data__;
      if (isKeyable(key)) {
        return hashDelete(typeof key === "string" ? data.string : data.hash, key);
      }
      return Map ? data.map["delete"](key) : assocDelete(data.map, key);
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapGet(key) {
      var data = this.__data__;
      if (isKeyable(key)) {
        return hashGet(typeof key === "string" ? data.string : data.hash, key);
      }
      return Map ? data.map.get(key) : assocGet(data.map, key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      var data = this.__data__;
      if (isKeyable(key)) {
        return hashHas(typeof key === "string" ? data.string : data.hash, key);
      }
      return Map ? data.map.has(key) : assocHas(data.map, key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache object.
     */
    function mapSet(key, value) {
      var data = this.__data__;
      if (isKeyable(key)) {
        hashSet(typeof key === "string" ? data.string : data.hash, key, value);
      } else if (Map) {
        data.map.set(key, value);
      } else {
        assocSet(data.map, key, value);
      }
      return this;
    }

    /* ------------------------------------------------------------------------*/

    /**
     *
     * Creates a set cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
        length = values ? values.length : 0;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.push(values[index]);
      }
    }

    /**
     * Checks if `value` is in `cache`.
     *
     * @private
     * @param {Object} cache The set cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function cacheHas(cache, value) {
      var map = cache.__data__;
      if (isKeyable(value)) {
        var data = map.__data__,
          hash = typeof value === "string" ? data.string : data.hash;

        return hash[value] === HASH_UNDEFINED;
      }
      return map.has(value);
    }

    /**
     * Adds `value` to the set cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var map = this.__data__;
      if (isKeyable(value)) {
        var data = map.__data__,
          hash = typeof value === "string" ? data.string : data.hash;

        hash[value] = HASH_UNDEFINED;
      }
      else {
        map.set(value, HASH_UNDEFINED);
      }
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function Stack(values) {
      var index = -1,
        length = values ? values.length : 0;

      this.clear();
      while (++index < length) {
        var entry = values[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = { "array": [], "map": null };
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
        array = data.array;

      return array ? assocDelete(array, key) : data.map["delete"](key);
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      var data = this.__data__,
        array = data.array;

      return array ? assocGet(array, key) : data.map.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      var data = this.__data__,
        array = data.array;

      return array ? assocHas(array, key) : data.map.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache object.
     */
    function stackSet(key, value) {
      var data = this.__data__,
        array = data.array;

      if (array) {
        if (array.length < (LARGE_ARRAY_SIZE - 1)) {
          assocSet(array, key, value);
        } else {
          data.array = null;
          data.map = new MapCache(array);
        }
      }
      var map = data.map;
      if (map) {
        map.set(key, value);
      }
      return this;
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Removes `key` and its value from the associative array.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function assocDelete(array, key) {
      var index = assocIndexOf(array, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = array.length - 1;
      if (index == lastIndex) {
        array.pop();
      } else {
        splice.call(array, index, 1);
      }
      return true;
    }

    /**
     * Gets the associative array value for `key`.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function assocGet(array, key) {
      var index = assocIndexOf(array, key);
      return index < 0 ? undefined : array[index][1];
    }

    /**
     * Checks if an associative array value for `key` exists.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function assocHas(array, key) {
      return assocIndexOf(array, key) > -1;
    }

    /**
     * Gets the index at which the first occurrence of `key` is found in `array`
     * of key-value pairs.
     *
     * @private
     * @param {Array} array The array to search.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Sets the associative array `key` to `value`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     */
    function assocSet(array, key, value) {
      var index = assocIndexOf(array, key);
      if (index < 0) {
        array.push([key, value]);
      } else {
        array[index][1] = value;
      }
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function assignInDefaults(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * This function is like `assignValue` except that it doesn't assign `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (typeof key === "number" && value === undefined && !(key in object))) {
        object[key] = value;
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if ((!eq(objValue, value) ||
            (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) ||
          (value === undefined && !(key in object))) {
        object[key] = value;
      }
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function (value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
        isNil = object == null,
        length = paths.length,
        result = Array(length);

      while (++index < length) {
        result[index] = isNil ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stack) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          if (isHostObject(value)) {
            return object ? value : {};
          }
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return copySymbols(value, baseAssign(result, value));
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function (subValue, key) {
        assignValue(result, key, baseClone(subValue, isDeep, customizer, key, value, stack));
      });
      return isArr ? result : copySymbols(value, result);
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new function.
     */
    function baseConforms(source) {
      var props = keys(source),
        length = props.length;

      return function (object) {
        if (object == null) {
          return !length;
        }
        var index = length;
        while (index--) {
          var key = props[index],
            predicate = source[key],
            value = object[key];

          if ((value === undefined && !(key in Object(object))) || !predicate(value)) {
            return false;
          }
        }
        return true;
      };
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function () {
      function object() {}
      return function (prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an array
     * of `func` arguments.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments to provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function () { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support for
     * excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
        includes = arrayIncludes,
        isCommon = true,
        length = array.length,
        result = [],
        valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
          computed = iteratee ? iteratee(value) : value;

        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function (value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function (value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
        length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isArrayLikeObject(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return object == null ? object : baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function (key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = isKey(path, object) ? [path + ""] : baseToPath(path);

      var index = 0,
        length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
      // that are composed entirely of index properties, return `false` for
      // `hasOwnProperty` checks of them.
      return hasOwnProperty.call(object, key) ||
        (typeof object === "object" && key in object && getPrototypeOf(object) === null);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
        othLength = arrays.length,
        othIndex = othLength,
        caches = Array(othLength),
        result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        caches[othIndex] = !comparator && (iteratee || array.length >= 120)
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
        length = array.length,
        seen = caches[0];

      outer:
      while (++index < length) {
        var value = array[index],
          computed = iteratee ? iteratee(value) : value;

        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function (value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      if (!isKey(path, object)) {
        path = baseToPath(path);
        object = parent(object, path);
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {boolean} [bitmask] The bitmask of comparison flags.
     *  The bitmask may be composed of the following flags:
     *     1 - Unordered comparison
     *     2 - Partial comparison
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, bitmask, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
      var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = arrayTag,
        othTag = arrayTag;

      if (!objIsArr) {
        objTag = getTag(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = getTag(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag && !isHostObject(object),
        othIsObj = othTag == objectTag && !isHostObject(other),
        isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag, equalFunc, customizer, bitmask);
      }
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      if (!isPartial) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, bitmask, stack);
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
          objValue = object[key],
          srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack,
            result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;

          if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      var type = typeof value;
      if (type == "function") {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (type == "object") {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't skip the constructor
     * property of prototypes or treat sparse arrays as dense.
     *
     * @private
     * @type Function
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      return nativeKeys(Object(object));
    }

    /**
     * The base implementation of `_.keysIn` which doesn't skip the constructor
     * property of prototypes or treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      object = object == null ? object : Object(object);

      var result = [];
      for (var key in object) {
        result.push(key);
      }
      return result;
    }

    // Fallback for IE < 9 with es6-shim.
    if (enumerate && !propertyIsEnumerable.call({ "valueOf": 1 }, "valueOf")) {
      baseKeysIn = function (object) {
        return iteratorToArray(enumerate(object));
      };
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
        result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function (value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
          value = matchData[0][1];

        return function (object) {
          if (object == null) {
            return false;
          }
          return object[key] === value &&
            (value !== undefined || (key in Object(object)));
        };
      }
      return function (object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      return function (object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      var props = (isArray(source) || isTypedArray(source)) ? undefined : keysIn(source);
      arrayEach(props || source, function (srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer ? customizer(object[key], srcValue, (key + ""), object, source, stack) : undefined;
          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      });
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
        srcValue = source[key],
        stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, (key + ""), object, source, stack) : undefined,
        isCommon = newValue === undefined;

      if (isCommon) {
        newValue = srcValue;
        if (isArray(srcValue) || isTypedArray(srcValue)) {
          if (isArray(objValue)) {
            newValue = srcIndex ? copyArray(objValue) : objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else {
            isCommon = false;
            newValue = baseClone(srcValue);
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            isCommon = false;
            newValue = baseClone(srcValue);
          }
          else {
            newValue = srcIndex ? baseClone(objValue) : objValue;
          }
        }
        else {
          isCommon = false;
        }
      }
      stack.set(srcValue, newValue);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1,
        toIteratee = getIteratee();

      iteratees = arrayMap(iteratees.length ? iteratees : Array(1), function (iteratee) {
        return toIteratee(iteratee);
      });

      var result = baseMap(collection, function (value, key, collection) {
        var criteria = arrayMap(iteratees, function (iteratee) {
          return iteratee(value);
        });
        return { "criteria": criteria, "index": ++index, "value": value };
      });

      return baseSortBy(result, function (object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property names.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, props) {
      object = Object(object);
      return arrayReduce(props, function (result, key) {
        if (key in object) {
          result[key] = object[key];
        }
        return result;
      }, {});
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, predicate) {
      var result = {};
      baseForIn(object, function (value, key) {
        if (predicate(value, key)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      return function (object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAll`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values) {
      return basePullAllBy(array, values);
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAllBy(array, values, iteratee) {
      var index = -1,
        length = values.length,
        seen = array;

      if (iteratee) {
        seen = arrayMap(array, function (value) { return iteratee(value); });
      }
      while (++index < length) {
        var fromIndex = 0,
          value = values[index],
          computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = baseIndexOf(seen, computed, fromIndex)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
        lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (lastIndex == length || index != previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          }
          else if (!isKey(index, array)) {
            var path = baseToPath(index),
              object = parent(array, path);

            if (object != null) {
              delete object[last(path)];
            }
          }
          else {
            delete array[index];
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments to numbers.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the new array of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
        length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
        result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      path = isKey(path, object) ? [path + ""] : baseToPath(path);

      var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          var newValue = value;
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) {
              newValue = objValue == null ? (isIndex(path[index + 1]) ? [] : {}) : objValue;
            }
          }
          assignValue(nested, key, newValue);
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function (func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
        length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function (value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
        high = array ? array.length : low;

      if (typeof value === "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
            computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
        high = array ? array.length : 0,
        valIsNaN = value !== value,
        valIsNull = value === null,
        valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
          computed = iteratee(array[mid]),
          isDef = computed !== undefined,
          isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array) {
      return baseSortedUniqBy(array);
    }

    /**
     * The base implementation of `_.sortedUniqBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniqBy(array, iteratee) {
      var index = 0,
        length = array.length,
        value = array[0],
        computed = iteratee ? iteratee(value) : value,
        seen = computed,
        resIndex = 0,
        result = [value];

      while (++index < length) {
        value = array[index],
        computed = iteratee ? iteratee(value) : value;

        if (!eq(computed, seen)) {
          seen = computed;
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toPath` which only converts `value` to a
     * path if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function baseToPath(value) {
      return isArray(value) ? value : stringToPath(value);
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
        includes = arrayIncludes,
        length = array.length,
        isCommon = true,
        result = [],
        seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
          computed = iteratee ? iteratee(value) : value;

        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = isKey(path, object) ? [path + ""] : baseToPath(path);
      object = parent(object, path);
      var key = last(path);
      return (object != null && has(object, key)) ? delete object[key] : true;
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
        index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function (result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var index = -1,
        length = arrays.length;

      while (++index < length) {
        var result = result
          ? arrayPush(
            baseDifference(result, arrays[index], iteratee, comparator),
            baseDifference(arrays[index], result, iteratee, comparator)
          )
          : arrays[index];
      }
      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property names.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
        length = props.length,
        valsLength = values.length,
        result = {};

      while (++index < length) {
        assignFunc(result, props[index], index < valsLength ? values[index] : undefined);
      }
      return result;
    }

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var Ctor = buffer.constructor,
        result = new Ctor(buffer.length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var Ctor = arrayBuffer.constructor,
        result = new Ctor(arrayBuffer.byteLength),
        view = new Uint8Array(result);

      view.set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map) {
      var Ctor = map.constructor;
      return arrayReduce(mapToArray(map), addMapEntry, new Ctor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var Ctor = regexp.constructor,
        result = new Ctor(regexp.source, reFlags.exec(regexp));

      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set) {
      var Ctor = set.constructor;
      return arrayReduce(setToArray(set), addSetEntry, new Ctor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return Symbol ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = typedArray.buffer,
        Ctor = typedArray.constructor;

      return new Ctor(isDeep ? cloneArrayBuffer(buffer) : buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
        argsIndex = -1,
        argsLength = nativeMax(args.length - holdersLength, 0),
        leftIndex = -1,
        leftLength = partials.length,
        result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
        holdersLength = holders.length,
        argsIndex = -1,
        argsLength = nativeMax(args.length - holdersLength, 0),
        rightIndex = -1,
        rightLength = partials.length,
        result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
        length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object) {
      return copyObjectWith(source, props, object);
    }

    /**
     * This function is like `copyObject` except that it accepts a function to
     * customize copied values.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObjectWith(source, props, object, customizer) {
      object || (object = {});

      var index = -1,
        length = props.length;

      while (++index < length) {
        var key = props[index],
          newValue = customizer ? customizer(object[key], source[key], key, object, source) : source[key];

        assignValue(object, key, newValue);
      }
      return object;
    }

    /**
     * Copies own symbol properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function (collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
          accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return rest(function (object, sources) {
        var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;

        customizer = typeof customizer === "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function (collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
          index = fromRight ? length : -1,
          iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function (object, iteratee, keysFunc) {
        var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBaseWrapper(func, bitmask, thisArg) {
      var isBind = bitmask & BIND_FLAG,
        Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new function.
     */
    function createCaseFirst(methodName) {
      return function (string) {
        string = toString(string);

        var strSymbols = reHasComplexSymbol.test(string) ? stringToArray(string) : undefined,
          chr = strSymbols ? strSymbols[0] : string.charAt(0),
          trailing = strSymbols ? strSymbols.slice(1).join("") : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function (string) {
        return arrayReduce(words(deburr(string)), callback, "");
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function () {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
          result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurryWrapper(func, bitmask, arity) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var length = arguments.length,
          index = length,
          args = Array(length),
          fn = (this && this !== root && this instanceof wrapper) ? Ctor : func,
          placeholder = lodash.placeholder || wrapper.placeholder;

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        return length < arity
          ? createRecurryWrapper(func, bitmask, createHybridWrapper, placeholder, undefined, args, holders, undefined, undefined, arity - length)
          : apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return rest(function (funcs) {
        funcs = baseFlatten(funcs);

        var length = funcs.length,
          index = length,
          prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func !== "function") {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == "wrapper") {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
            data = funcName == "wrapper" ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function () {
          var args = arguments,
            value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
            result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
        isBind = bitmask & BIND_FLAG,
        isBindKey = bitmask & BIND_KEY_FLAG,
        isCurry = bitmask & CURRY_FLAG,
        isCurryRight = bitmask & CURRY_RIGHT_FLAG,
        isFlip = bitmask & FLIP_FLAG,
        Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        var length = arguments.length,
          index = length,
          args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = lodash.placeholder || wrapper.placeholder,
            argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            return createRecurryWrapper(func, bitmask, createHybridWrapper, placeholder, thisArg, args, argsHolders, argPos, ary, arity - length);
          }
        }
        var thisBinding = isBind ? thisArg : this,
          fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && args.length > 1) {
          args.reverse();
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function (object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new invoker function.
     */
    function createOver(arrayFunc) {
      return rest(function (iteratees) {
        iteratees = arrayMap(baseFlatten(iteratees), getIteratee());
        return rest(function (args) {
          var thisArg = this;
          return arrayFunc(iteratees, function (iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(string, length, chars) {
      length = toInteger(length);

      var strLength = stringSize(string);
      if (!length || strLength >= length) {
        return "";
      }
      var padLength = length - strLength;
      chars = chars === undefined ? " " : (chars + "");

      var result = repeat(chars, nativeCeil(padLength / stringSize(chars)));
      return reHasComplexSymbol.test(chars)
        ? stringToArray(result).slice(0, padLength).join("")
        : result.slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
        Ctor = createCtorWrapper(func);

      function wrapper() {
        var argsIndex = -1,
          argsLength = arguments.length,
          leftIndex = -1,
          leftLength = partials.length,
          args = Array(leftLength + argsLength),
          fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function (start, end, step) {
        if (step && typeof step !== "number" && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toNumber(start);
        start = start === start ? start : 0;
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toNumber(end) || 0;
        }
        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder to replace.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & CURRY_FLAG,
        newArgPos = argPos ? copyArray(argPos) : undefined,
        newsHolders = isCurry ? holders : undefined,
        newHoldersRight = isCurry ? undefined : holders,
        newPartials = isCurry ? partials : undefined,
        newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

      if (!(bitmask & CURRY_BOUND_FLAG)) {
        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
      }
      var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, arity],
        result = wrapFunc.apply(undefined, newData);

      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return result;
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function (number, precision) {
        number = toNumber(number);
        precision = toInteger(precision);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + "e").split("e"),
            value = func(pair[0] + "e" + (+pair[1] + precision));

          pair = (toString(value) + "e").split("e");
          return +(pair[0] + "e" + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function (values) {
      return new Set(values);
    };

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask of wrapper flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
          holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
        newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] == null
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == BIND_FLAG) {
        var result = createBaseWrapper(func, bitmask, thisArg);
      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
        result = createCurryWrapper(func, bitmask, arity);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
        result = createPartialWrapper(func, bitmask, thisArg, partials);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
     * @param {Object} [stack] Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
      var index = -1,
        isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
        arrLength = array.length,
        othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked) {
        return stacked == other;
      }
      var result = true;
      stack.set(array, other);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isUnordered) {
          if (!arraySome(other, function (othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
          result = false;
          break;
        }
      }
      stack["delete"](array);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, equalFunc, customizer, bitmask) {
      switch (tag) {
        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object) ? other != +other : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + "");

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
          convert || (convert = setToArray);

          // Recursively compare objects (susceptible to call stack limits).
          return (isPartial || object.size == other.size) &&
            equalFunc(convert(object), convert(other), customizer, bitmask | UNORDERED_COMPARE_FLAG);

        case symbolTag:
          return !!Symbol && (symbolValueOf.call(object) == symbolValueOf.call(other));
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        objProps = keys(object),
        objLength = objProps.length,
        othProps = keys(other),
        othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : baseHas(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == "constructor");
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ("constructor" in object && "constructor" in other) &&
            !(typeof objCtor === "function" && objCtor instanceof objCtor &&
              typeof othCtor === "function" && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack["delete"](object);
      return result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function (func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ""),
        array = realNames[result],
        length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
          otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "iteratee" function. If the `_.iteratee` method is
     * customized this function returns the custom method, otherwise it returns
     * `baseIteratee`. If arguments are provided the chosen function is invoked
     * with them and its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty("length");

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = toPairs(object),
        length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Creates an array of the own symbol properties of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = getOwnPropertySymbols || function () {
      return [];
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function getTag(value) {
      return objectToString.call(value);
    }

    // Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
    if ((Map && getTag(new Map) != mapTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function (value) {
        var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : null,
          ctorString = typeof Ctor === "function" ? funcToString.call(Ctor) : "";

        if (ctorString) {
          switch (ctorString) {
            case mapCtorString: return mapTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
        length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
          size = data.size;

        switch (data.type) {
          case "drop": start += size; break;
          case "dropRight": end -= size; break;
          case "take": end = nativeMin(end, start + size); break;
          case "takeRight": start = nativeMax(start, end - size); break;
        }
      }
      return { "start": start, "end": end };
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      if (object == null) {
        return false;
      }
      var result = hasFunc(object, path);
      if (!result && !isKey(path)) {
        path = baseToPath(path);
        object = parent(object, path);
        if (object != null) {
          path = last(path);
          result = hasFunc(object, path);
        }
      }
      var length = object ? object.length : undefined;
      return result || (
        !!length && isLength(length) && isIndex(path, length) &&
        (isArray(object) || isString(object) || isArguments(object))
      );
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
        result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] === "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      if (isPrototype(object)) {
        return {};
      }
      var Ctor = object.constructor;
      return baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Creates an array of index keys for `object` values of arrays,
     * `arguments` objects, and strings, otherwise `null` is returned.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array|null} Returns index keys, else `null`.
     */
    function indexKeys(object) {
      var length = object ? object.length : undefined;
      if (isLength(length) &&
          (isArray(object) || isString(object) || isArguments(object))) {
        return baseTimes(length, String);
      }
      return null;
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number"
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == "string" && index in object)) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (typeof value === "number") {
        return true;
      }
      return !isArray(value) &&
        (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
          (object != null && value in Object(object)));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return type == "number" || type == "boolean" ||
        (type == "string" && value !== "__proto__") || value == null;
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
        other = lodash[funcName];

      if (typeof other !== "function" || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = (typeof Ctor === "function" && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * modify function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * combined case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
        srcBitmask = source[1],
        newBitmask = bitmask | srcBitmask,
        isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);

      var isCombo =
        (srcBitmask == ARY_FLAG && (bitmask == CURRY_FLAG)) ||
        (srcBitmask == ARY_FLAG && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : copyArray(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : copyArray(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : copyArray(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : copyArray(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = copyArray(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
     * @returns {*} Returns the value to assign.
     */
    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
      }
      return objValue;
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
        length = nativeMin(indexes.length, arrLength),
        oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function () {
      var count = 0,
        lastCalled = 0;

      return function (key, value) {
        var stamp = now(),
          remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    function stringToPath(string) {
      var result = [];
      toString(string).replace(rePropName, function (match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : (number || match));
      });
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the array-like object.
     */
    function toArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Converts `value` to a function if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Function} Returns the function.
     */
    function toFunction(value) {
      return typeof value === "function" ? value : identity;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__ = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=0] The length of each chunk.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size) {
      size = nativeMax(toInteger(size), 0);

      var length = array ? array.length : 0;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
        resIndex = -1,
        result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
        length = array ? array.length : 0,
        resIndex = -1,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var concat = rest(function (array, values) {
      if (!isArray(array)) {
        array = array == null ? [] : [Object(array)];
      }
      values = baseFlatten(values);
      return arrayConcat(array, values);
    });

    /**
     * Creates an array of unique `array` values not included in the other
     * given arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([3, 2, 1], [4, 2]);
     * // => [3, 1]
     */
    var difference = rest(function (array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
     * // => [3.1, 1.3]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = rest(function (array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, false, true), getIteratee(iteratee))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = rest(function (array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, false, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start !== "number" && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate) {
      return (array && array.length)
        ? baseFindIndex(array, getIteratee(predicate, 3))
        : -1;
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate) {
      return (array && array.length)
        ? baseFindIndex(array, getIteratee(predicate, 3), true)
        : -1;
    }

    /**
     * Flattens `array` a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     */
    function flatten(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array) : [];
    }

    /**
     * This method is like `_.flatten` except that it recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function fromPairs(pairs) {
      var index = -1,
        length = pairs ? pairs.length : 0,
        result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
     * from the end of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      fromIndex = toInteger(fromIndex);
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return baseIndexOf(array, value, fromIndex);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     *
     * _.intersection([2, 1], [4, 2], [1, 2]);
     * // => [2]
     */
    var intersection = rest(function (arrays) {
      var mapped = arrayMap(arrays, toArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of shared values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = rest(function (arrays) {
      var iteratee = last(arrays),
        mapped = arrayMap(arrays, toArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = rest(function (arrays) {
      var comparator = last(arrays),
        mapped = arrayMap(arrays, toArrayLikeObject);

      if (comparator === last(mapped)) {
        comparator = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array ? nativeJoin.call(array, separator) : "";
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = (index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1)) + 1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    var pull = rest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pullAll(array, [2, 3]);
     * console.log(array);
     * // => [1, 1]
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAllBy(array, values, getIteratee(iteratee))
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified individually or in arrays.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = rest(function (array, indexes) {
      indexes = arrayMap(baseFlatten(indexes), String);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(compareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
        indexes = [],
        length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @category Array
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array ? nativeReverse.call(array) : array;
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of [`Array#slice`](https://mdn.io/Array/slice)
     * to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end !== "number" && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 5], 4);
     * // => 0
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted into `array`.
     * @example
     *
     * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
     *
     * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([1, 1, 2, 2], 2);
     * // => 2
     */
    function sortedIndexOf(array, value) {
      var length = array ? array.length : 0;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5], 4);
     * // => 1
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted into `array`.
     * @example
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([1, 1, 2, 2], 2);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array ? array.length : 0;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniqBy(array, getIteratee(iteratee))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with three
     * arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2, 1], [4, 2], [1, 2]);
     * // => [2, 1, 4]
     */
    var union = rest(function (arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by which
     * uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
     * // => [2.1, 1.2, 4.3]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = rest(function (arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, false, true), getIteratee(iteratee));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = rest(function (arrays) {
      var comparator = last(arrays);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return baseUniq(baseFlatten(arrays, false, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length)
        ? baseUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length)
        ? baseUniq(array, getIteratee(iteratee))
        : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The comparator is invoked with
     * two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      return (array && array.length)
        ? baseUniq(array, undefined, comparator)
        : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function (group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function (index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function (group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = rest(function (array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([2, 1], [4, 2]);
     * // => [1, 4]
     */
    var xor = rest(function (arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by which
     * uniqueness is computed. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
     * // => [1.2, 4.3]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = rest(function (arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The comparator is invoked with
     * two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = rest(function (arrays) {
      var comparator = last(arrays);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = rest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property names and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} [props=[]] The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} [props=[]] The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = rest(function (arrays) {
      var length = arrays.length,
        iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee === "function" ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /* ------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method chaining enabled.
     * The result of such method chaining must be unwrapped with `_#value`.
     *
     * @static
     * @memberOf _
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain.
     *
     * @static
     * @memberOf _
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths of elements to pick,
     *  specified individually or in arrays.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     *
     * _(['a', 'b', 'c']).at(0, 2).value();
     * // => ['a', 'c']
     */
    var wrapperAt = rest(function (paths) {
      paths = baseFlatten(paths);
      var length = paths.length,
        start = length ? paths[0] : 0,
        value = this.__wrapped__,
        interceptor = function (object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined });
      return new LodashWrapper(value, this.__chain__).thru(function (array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * This method is the wrapper version of `_.flatMap`.
     *
     * @name flatMap
     * @memberOf _
     * @category Seq
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _([1, 2]).flatMap(duplicate).value();
     * // => [1, 1, 2, 2]
     */
    function wrapperFlatMap(iteratee) {
      return this.map(iteratee).flatten();
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
        value = done ? undefined : this.__values__[this.__index__++];

      return { "done": done, "value": value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
        parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ "func": thru, "args": [reverse], "thisArg": undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function (result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three arguments:
     * (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three arguments:
     * (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    function find(collection, predicate) {
      predicate = getIteratee(predicate, 3);
      if (isArray(collection)) {
        var index = baseFindIndex(collection, predicate);
        return index > -1 ? collection[index] : undefined;
      }
      return baseFind(collection, predicate, baseEach);
    }

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    function findLast(collection, predicate) {
      predicate = getIteratee(predicate, 3);
      if (isArray(collection)) {
        var index = baseFindIndex(collection, predicate, true);
        return index > -1 ? collection[index] : undefined;
      }
      return baseFind(collection, predicate, baseEachRight);
    }

    /**
     * Creates an array of flattened values by running each element in `collection`
     * through `iteratee` and concating its result to the other mapped values.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior use `_.forIn` or `_.forOwn`
     * for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(value) {
     *   console.log(value);
     * });
     * // => logs `1` then `2`
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' then 'b' (iteration order is not guaranteed)
     */
    function forEach(collection, iteratee) {
      return (typeof iteratee === "function" && isArray(collection))
        ? arrayEach(collection, iteratee)
        : baseEach(collection, toFunction(iteratee));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => logs `2` then `1`
     */
    function forEachRight(collection, iteratee) {
      return (typeof iteratee === "function" && isArray(collection))
        ? arrayEachRight(collection, iteratee)
        : baseEachRight(collection, toFunction(iteratee));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of elements responsible for generating the key.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function (result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string it's checked
     * for a substring of `value`, otherwise [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it's
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = rest(function (collection, path, args) {
      var index = -1,
        isFunc = typeof path === "function",
        isProp = isKey(path),
        result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function (value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function (result, value, key) {
      result[key] = value;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
     * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
     * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
     * and `words`
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} [iteratees=[_.identity]] The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function (result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function () { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
        initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
        initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getIteratee(predicate, 3);
      return func(collection, function (value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var array = isArrayLike(collection) ? collection : values(collection),
        length = array.length;

      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=0] The number of elements to sample.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n) {
      var index = -1,
        result = toArray(collection),
        length = result.length,
        lastIndex = length - 1;

      n = baseClamp(toInteger(n), 0, length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
          value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sampleSize(collection, MAX_ARRAY_LENGTH);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        var result = collection.length;
        return (result && isString(collection)) ? stringSize(collection) : result;
      }
      return keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} [iteratees=[_.identity]]
     *  The iteratees to sort by, specified individually or in arrays.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, function(o) { return o.user; });
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.sortBy(users, 'user', function(o) {
     *   return Math.floor(o.age / 10);
     * });
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortBy = rest(function (collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees.length = 1;
      }
      return baseOrderBy(collection, baseFlatten(iteratees), []);
    });

    /* ------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = Date.now;

    /* ------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function () {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function () {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = rest(function (func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var placeholder = lodash.placeholder || bind.placeholder,
          holders = replaceHolders(partials, placeholder);

        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = rest(function (object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var placeholder = lodash.placeholder || bindKey.placeholder,
          holders = replaceHolders(partials, placeholder);

        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = lodash.placeholder || curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = lodash.placeholder || curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide an options object to indicate whether `func` should be invoked on
     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent calls
     * to the debounced function return the result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it's invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var args,
        maxTimeoutId,
        result,
        stamp,
        thisArg,
        timeoutId,
        trailingCall,
        lastCalled = 0,
        leading = false,
        maxWait = false,
        trailing = true;

      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxWait = "maxWait" in options && nativeMax(toNumber(options.maxWait) || 0, wait);
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        args = maxTimeoutId = thisArg = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function flush() {
        if ((timeoutId && trailingCall) || (maxTimeoutId && trailing)) {
          result = func.apply(thisArg, args);
        }
        cancel();
        return result;
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!lastCalled && !maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
            isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => logs 'deferred' after one or more milliseconds
     */
    var defer = rest(function (func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = rest(function (func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrapper(func, FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func !== "function" || (resolver && typeof resolver !== "function")) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function () {
        var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function () {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with arguments transformed by
     * corresponding `transforms`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified individually or in arrays.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = rest(function (func, transforms) {
      transforms = arrayMap(baseFlatten(transforms), getIteratee());

      var funcsLength = transforms.length;
      return rest(function (args) {
        var index = -1,
          length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = rest(function (func, partials) {
      var placeholder = lodash.placeholder || partial.placeholder,
        holders = replaceHolders(partials, placeholder);

      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = rest(function (func, partials) {
      var placeholder = lodash.placeholder || partialRight.placeholder,
        holders = replaceHolders(partials, placeholder);

      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified individually or in arrays.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = rest(function (func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
      return function () {
        var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, array);
          case 1: return func.call(this, args[0], array);
          case 2: return func.call(this, args[0], args[1], array);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = array;
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
      return rest(function (args) {
        var array = args[start],
          otherArgs = args.slice(0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide an options object to indicate whether
     * `func` should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
        trailing = true;

      if (typeof func !== "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { "leading": leading, "maxWait": wait, "trailing": trailing });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return partial(wrapper, value);
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      return baseClone(value, false, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, true);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      return baseClone(value, true, customizer);
    }

    /**
     * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
      return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") &&
        (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    function isArrayBuffer(value) {
      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
    }

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null &&
        !(typeof value === "function" && isFunction(value)) && isLength(getLength(value));
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @type Function
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && objectToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = !Buffer ? constant(false) : function (value) {
      return value instanceof Buffer;
    };

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objectToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it's an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (isArrayLike(value) &&
          (isArray(value) || isString(value) || isFunction(value.splice) || isArguments(value))) {
        return !value.length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are **not** supported.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which is
     * invoked to compare values. If `customizer` returns `undefined` comparisons are
     * handled by the method instead. The `customizer` is invoked with up to six arguments:
     * (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer === "function" ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) &&
        typeof value.message === "string" && objectToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MAX_VALUE);
     * // => true
     *
     * _.isFinite(3.14);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value === "number" && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 8 which returns 'object' for typed array constructors, and
      // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
      var tag = isObject(value) ? objectToString.call(value) : "";
      return tag == funcTag || tag == genTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value === "number" && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value === "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return !!value && typeof value === "object";
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    function isMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values.
     *
     * **Note:** This method supports comparing the same values as `_.isEqual`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined` comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer === "function" ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(funcToString.call(value));
      }
      return isObjectLike(value) &&
        (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value === "number" ||
        (isObjectLike(value) && objectToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
        return false;
      }
      var proto = objectProto;
      if (typeof value.constructor === "function") {
        proto = getPrototypeOf(value);
      }
      if (proto === null) {
        return true;
      }
      var Ctor = proto.constructor;
      return (typeof Ctor === "function" &&
        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objectToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    function isSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value === "string" ||
        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value === "symbol" ||
        (isObjectLike(value) && objectToString.call(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (iteratorSymbol && value[iteratorSymbol]) {
        return iteratorToArray(value[iteratorSymbol]());
      }
      var tag = getTag(value),
        func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3');
     * // => 3
     */
    function toInteger(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      var remainder = value % 1;
      return value === value ? (remainder ? value - remainder : value) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3);
     * // => 3
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3');
     * // => 3
     */
    function toNumber(value) {
      if (isObject(value)) {
        var other = isFunction(value.valueOf) ? value.valueOf() : value;
        value = isObject(other) ? (other + "") : other;
      }
      if (typeof value !== "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3');
     * // => 3
     */
    function toSafeInteger(value) {
      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
    }

    /**
     * Converts `value` to a string if it's not one. An empty string is returned
     * for `null` and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value === "string") {
        return value;
      }
      if (value == null) {
        return "";
      }
      if (isSymbol(value)) {
        return Symbol ? symbolToString.call(value) : "";
      }
      var result = (value + "");
      return (result == "0" && (1 / value) == -INFINITY) ? "-0" : result;
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable properties of source objects to the destination
     * object. Source objects are applied from left to right. Subsequent sources
     * overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.c = 3;
     * }
     *
     * function Bar() {
     *   this.e = 5;
     * }
     *
     * Foo.prototype.d = 4;
     * Bar.prototype.f = 6;
     *
     * _.assign({ 'a': 1 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3, 'e': 5 }
     */
    var assign = createAssigner(function (object, source) {
      copyObject(source, keys(source), object);
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * function Bar() {
     *   this.d = 4;
     * }
     *
     * Foo.prototype.c = 3;
     * Bar.prototype.e = 5;
     *
     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
     */
    var assignIn = createAssigner(function (object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer` which
     * is invoked to produce the assigned values. If `customizer` returns `undefined`
     * assignment is handled by the method instead. The `customizer` is invoked
     * with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
      copyObjectWith(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer` which
     * is invoked to produce the assigned values. If `customizer` returns `undefined`
     * assignment is handled by the method instead. The `customizer` is invoked
     * with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
      copyObjectWith(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths of elements to pick,
     *  specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     *
     * _.at(['a', 'b', 'c'], 0, 2);
     * // => ['a', 'c']
     */
    var at = rest(function (object, paths) {
      return baseAt(object, baseFlatten(paths));
    });

    /**
     * Creates an object that inherits from the `prototype` object. If a `properties`
     * object is given its own enumerable properties are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own and inherited enumerable properties of source objects to the
     * destination object for all destination properties that resolve to `undefined`.
     * Source objects are applied from left to right. Once a property is set,
     * additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = rest(function (args) {
      args.push(undefined, assignInDefaults);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = rest(function (args) {
      args.push(undefined, mergeDefaults);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
    }

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The iteratee is invoked with three arguments:
     * (value, key, object). Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', then 'c' (iteration order is not guaranteed)
     */
    function forIn(object, iteratee) {
      return object == null ? object : baseFor(object, toFunction(iteratee), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'
     */
    function forInRight(object, iteratee) {
      return object == null ? object : baseForRight(object, toFunction(iteratee), keysIn);
    }

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The iteratee is invoked with three arguments:
     * (value, key, object). Iteratee functions may exit iteration early by
     * explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' then 'b' (iteration order is not guaranteed)
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, toFunction(iteratee));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, toFunction(iteratee));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     * var other = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b.c');
     * // => true
     *
     * _.hasIn(object, ['a', 'b', 'c']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function (result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` through `iteratee`.
     * The corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function (result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = rest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      var isProto = isPrototype(object);
      if (!(isProto || isArrayLike(object))) {
        return baseKeys(object);
      }
      var indexes = indexKeys(object),
        skipIndexes = !!indexes,
        result = indexes || [],
        length = result.length;

      for (var key in object) {
        if (baseHas(object, key) &&
            !(skipIndexes && (key == "length" || isIndex(key, length))) &&
            !(isProto && key == "constructor")) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      var index = -1,
        isProto = isPrototype(object),
        props = baseKeysIn(object),
        propsLength = props.length,
        indexes = indexKeys(object),
        skipIndexes = !!indexes,
        result = indexes || [],
        length = result.length;

      while (++index < propsLength) {
        var key = props[index];
        if (!(skipIndexes && (key == "length" || isIndex(key, length))) &&
            !(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function (value, key, object) {
        result[iteratee(value, key, object)] = value;
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function (value, key, object) {
        result[key] = iteratee(value, key, object);
      });
      return result;
    }

    /**
     * Recursively merges own and inherited enumerable properties of source
     * objects into the destination object, skipping source properties that resolve
     * to `undefined`. Array and plain object properties are merged recursively.
     * Other objects and value types are overridden by assignment. Source objects
     * are applied from left to right. Subsequent sources overwrite property
     * assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     */
    var merge = createAssigner(function (object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined` merging is handled by the
     * method instead. The `customizer` is invoked with seven arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property names to omit, specified
     *  individually or in arrays..
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = rest(function (object, props) {
      if (object == null) {
        return {};
      }
      props = arrayMap(baseFlatten(props), String);
      return basePick(object, baseDifference(keysIn(object), props));
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that `predicate`
     * doesn't return truthy for.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      predicate = getIteratee(predicate, 2);
      return basePickBy(object, function (value, key) {
        return !predicate(value, key);
      });
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [props] The property names to pick, specified
     *  individually or in arrays.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = rest(function (object, props) {
      return object == null ? {} : basePick(object, baseFlatten(props));
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      return object == null ? {} : basePickBy(object, getIteratee(predicate, 2));
    }

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it's invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      if (!isKey(path, object)) {
        path = baseToPath(path);
        var result = get(object, path);
        object = parent(object, path);
      } else {
        result = object == null ? undefined : object[path];
      }
      if (result === undefined) {
        result = defaultValue;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.setWith({ '0': { 'length': 2 } }, '[0][1][2]', 3, Object);
     * // => { '0': { '1': { '2': 3 }, 'length': 2 } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer === "function" ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable key-value pairs for `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    function toPairs(object) {
      return baseToPairs(object, keys(object));
    }

    /**
     * Creates an array of own and inherited enumerable key-value pairs for `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
     */
    function toPairsIn(object) {
      return baseToPairs(object, keysIn(object));
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The iteratee is invoked with four arguments:
     * (accumulator, value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getIteratee(iteratee, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function (value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object ? baseValues(object, keys(object)) : [];
    }

    /**
     * Creates an array of the own and inherited enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? baseValues(object, keysIn(object)) : [];
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toNumber(start) || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toNumber(end) || 0;
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are floats,
     * a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating !== "boolean" && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper === "boolean") {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower === "boolean") {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toNumber(lower) || 0;
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toNumber(upper) || 0;
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function (result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, "");
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = typeof target === "string" ? target : (target + "");

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in IE < 9, they can break out of
     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, "\\$&")
        : string;
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function (result, word, index) {
      return result + (index ? "-" : "") + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function (result, word, index) {
      return result + (index ? " " : "") + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst("toLowerCase");

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst("toUpperCase");

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = stringSize(string);
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2,
        leftLength = nativeFloor(mid),
        rightLength = nativeCeil(mid);

      return createPadding("", leftLength, chars) + string + createPadding("", rightLength, chars);
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      return string + createPadding(string, length, chars);
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      return createPadding(string, length, chars) + string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#x15.1.2.2)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = toString(string).replace(reTrim, "");
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      string = toString(string);
      n = toInteger(n);

      var result = "";
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
        string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function (result, word, index) {
      return result + (index ? "_" : "") + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the new array of string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      return toString(string).split(separator, limit);
    }

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function (result, word, index) {
      return result + (index ? " " : "") + capitalize(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = baseClamp(toInteger(position), 0, string.length);
      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, assignInDefaults);

      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
        importsKeys = keys(imports),
        importsValues = baseValues(imports, importsKeys);

      var isEscaping,
        isEvaluating,
        index = 0,
        interpolate = options.interpolate || reNoMatch,
        source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + "|" +
        interpolate.source + "|" +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" +
        (options.evaluate || reNoMatch).source + "|$"
        , "g");

      // Use a sourceURL for easier debugging.
      var sourceURL = "//# sourceURL=" +
        ("sourceURL" in options
          ? options.sourceURL
          : ("lodash.templateSources[" + (++templateCounter) + "]")
        ) + "\n";

      string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = "with (obj) {\n" + source + "\n}\n";
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source)
        .replace(reEmptyStringMiddle, "$1")
        .replace(reEmptyStringTrailing, "$1;");

      // Frame code as the function body.
      source = "function(" + (variable || "obj") + ") {\n" +
        (variable
          ? ""
          : "obj || (obj = {});\n"
        ) +
        "var __t, __p = ''" +
        (isEscaping
          ? ", __e = _.escape"
          : ""
        ) +
        (isEvaluating
          ? ", __j = Array.prototype.join;\n" +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ";\n"
        ) +
        source +
        "return __p\n}";

      var result = attempt(function () {
        return Function(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar');
     * // => '--foo-bar'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar');
     * // => '--FOO-BAR'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (!string) {
        return string;
      }
      if (guard || chars === undefined) {
        return string.replace(reTrim, "");
      }
      chars = (chars + "");
      if (!chars) {
        return string;
      }
      var strSymbols = stringToArray(string),
        chrSymbols = stringToArray(chars);

      return strSymbols.slice(charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1).join("");
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (!string) {
        return string;
      }
      if (guard || chars === undefined) {
        return string.replace(reTrimEnd, "");
      }
      chars = (chars + "");
      if (!chars) {
        return string;
      }
      var strSymbols = stringToArray(string);
      return strSymbols.slice(0, charsEndIndex(strSymbols, stringToArray(chars)) + 1).join("");
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (!string) {
        return string;
      }
      if (guard || chars === undefined) {
        return string.replace(reTrimStart, "");
      }
      chars = (chars + "");
      if (!chars) {
        return string;
      }
      var strSymbols = stringToArray(string);
      return strSymbols.slice(charsStartIndex(strSymbols, stringToArray(chars))).join("");
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
        omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = "separator" in options ? options.separator : separator;
        length = "length" in options ? toInteger(options.length) : length;
        omission = "omission" in options ? toString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (reHasComplexSymbol.test(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? strSymbols.slice(0, end).join("")
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
            substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function (result, word, index) {
      return result + (index ? " " : "") + word.toUpperCase();
    });

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
      }
      return string.match(pattern) || [];
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = rest(function (func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isObject(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind,
     *  specified individually or in arrays.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, 'onClick');
     * jQuery(element).on('click', view.onClick);
     * // => logs 'clicked docs' when clicked
     */
    var bindAll = rest(function (object, methodNames) {
      arrayEach(baseFlatten(methodNames), function (key) {
        object[key] = bind(object[key], object);
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` invoking the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.constant(true),                _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs ? pairs.length : 0,
        toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function (pair) {
        if (typeof pair[1] !== "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return rest(function (args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, true));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function () {
        return value;
      };
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument given to it.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name the created callback returns the
     * property value for a given element. If `func` is an object the created
     * callback returns `true` for elements that contain the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(callback, func) {
     *   var p = /^(\S+)\s*([<>])\s*(\S+)$/.exec(func);
     *   return !p ? callback(func) : function(object) {
     *     return (p[2] == '>' ? object[p[1]] > p[3] : object[p[1]] < p[3]);
     *   };
     * });
     *
     * _.filter(users, 'age > 36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function iteratee(func) {
      return baseIteratee(typeof func === "function" ? func : baseClone(func, true));
    }

    /**
     * Creates a function that performs a deep partial comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** This method supports comparing the same values as `_.isEqual`.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that performs a deep partial comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** This method supports comparing the same values as `_.isEqual`.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invokeMap(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = rest(function (path, args) {
      return function (object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = rest(function (object, args) {
      return function (path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
        methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = (isObject(options) && "chain" in options) ? options.chain : true,
        isFunc = isFunction(object);

      arrayEach(methodNames, function (methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function () {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ "func": func, "args": arguments, "thisArg": object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Util
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns its nth argument.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.nthArg(1);
     *
     * func('a', 'b', 'c');
     * // => 'b'
     */
    function nthArg(n) {
      n = toInteger(n);
      return function () {
        return arguments[n];
      };
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments provided
     * to the created function and returns their results.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} iteratees The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over(Math.max, Math.min);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments provided to the created function.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} predicates The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery(Boolean, isFinite);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments provided to the created function.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} predicates The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome(Boolean, isFinite);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function (path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(true));
     * // => [true, true, true, true]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
        length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = toFunction(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     *
     * var path = ['a', 'b', 'c'],
     *     newPath = _.toPath(path);
     *
     * console.log(newPath);
     * // => ['a', 'b', 'c']
     *
     * console.log(path === newPath);
     * // => false
     */
    function toPath(value) {
      return isArray(value) ? arrayMap(value, String) : stringToPath(value);
    }

    /**
     * Generates a unique ID. If `prefix` is given the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Util
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /* ------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      var result;
      if (augend === undefined && addend === undefined) {
        return 0;
      }
      if (augend !== undefined) {
        result = augend;
      }
      if (addend !== undefined) {
        result = result === undefined ? addend : (result + addend);
      }
      return result;
    }

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound("ceil");

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound("floor");

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey
     * `undefined` is returned.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, gt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee), gt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return sum(array) / (array ? array.length : 0);
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey
     * `undefined` is returned.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, lt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee), lt)
        : undefined;
    }

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound("round");

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    function subtract(minuend, subtrahend) {
      var result;
      if (minuend === undefined && subtrahend === undefined) {
        return 0;
      }
      if (minuend !== undefined) {
        result = minuend;
      }
      if (subtrahend !== undefined) {
        result = result === undefined ? subtrahend : (result - subtrahend);
      }
      return result;
    }

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee))
        : 0;
    }

    /* ------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Avoid inheriting from `Object.prototype` when possible.
    Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;

    // Add functions to the `MapCache`.
    MapCache.prototype.clear = mapClear;
    MapCache.prototype["delete"] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `SetCache`.
    SetCache.prototype.push = cachePush;

    // Add functions to the `Stack` cache.
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /* ------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function () {
      var source = {};
      baseForOwn(lodash, function (func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { "chain": false });

    /* ------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(["drop", "take"], function (methodName, index) {
      LazyWrapper.prototype[methodName] = function (n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({ "size": nativeMin(n, MAX_ARRAY_LENGTH), "type": methodName + (result.__dir__ < 0 ? "Right" : "") });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + "Right"] = function (n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(["filter", "map", "takeWhile"], function (methodName, index) {
      var type = index + 1,
        isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function (iteratee) {
        var result = this.clone();
        result.__iteratees__.push({ "iteratee": getIteratee(iteratee, 3), "type": type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(["head", "last"], function (methodName, index) {
      var takeName = "take" + (index ? "Right" : "");

      LazyWrapper.prototype[methodName] = function () {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(["initial", "tail"], function (methodName, index) {
      var dropName = "drop" + (index ? "" : "Right");

      LazyWrapper.prototype[methodName] = function () {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function () {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function (predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function (predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = rest(function (path, args) {
      if (typeof path === "function") {
        return new LazyWrapper(this);
      }
      return this.map(function (value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function (predicate) {
      predicate = getIteratee(predicate, 3);
      return this.filter(function (value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function (start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function (predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function () {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function (func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
        isTaker = /^(?:head|last)$/.test(methodName),
        lodashFunc = lodash[isTaker ? ("take" + (methodName == "last" ? "Right" : "")) : methodName],
        retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function () {
        var value = this.__wrapped__,
          args = isTaker ? [1] : arguments,
          isLazy = value instanceof LazyWrapper,
          iteratee = args[0],
          useLazy = isLazy || isArray(value);

        var interceptor = function (value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee === "function" && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
          isHybrid = !!this.__actions__.length,
          isUnwrapped = retUnwrapped && !chainAll,
          onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function (methodName) {
      var func = arrayProto[methodName],
        chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru",
        retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function () {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function (value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function (func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ""),
          names = realNames[key] || (realNames[key] = []);

        names.push({ "name": methodName, "func": lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ "name": "wrapper", "func": undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.flatMap = wrapperFlatMap;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    if (iteratorSymbol) {
      lodash.prototype[iteratorSymbol] = wrapperToIterator;
    }
    return lodash;
  }

  /* --------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Expose lodash on the free variable `window` or `self` when available. This
  // prevents errors in cases where lodash is loaded by a script tag in the presence
  // of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch for more details.
  (freeWindow || freeSelf || {})._ = _;

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function () {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/*
 * @license
 * angular-socket-io v0.6.1
 * (c) 2014 Brian Ford http://briantford.com
 * License: MIT
 */

angular.module("btford.socket-io", []).
  provider("socketFactory", function () {

    "use strict";

    // when forwarding events, prefix the event name
    var defaultPrefix = "socket:",
      ioSocket;

    // expose to provider
    this.$get = ["$rootScope", "$timeout", function ($rootScope, $timeout) {

      var asyncAngularify = function (socket, callback) {
        return callback ? function () {
          var args = arguments;
          $timeout(function () {
            callback.apply(socket, args);
          }, 0);
        } : angular.noop;
      };

      return function socketFactory(options) {
        options = options || {};
        var socket = options.ioSocket || io.connect();
        var prefix = options.prefix === undefined ? defaultPrefix : options.prefix ;
        var defaultScope = options.scope || $rootScope;

        var addListener = function (eventName, callback) {
          socket.on(eventName, callback.__ng = asyncAngularify(socket, callback));
        };

        var addOnceListener = function (eventName, callback) {
          socket.once(eventName, callback.__ng = asyncAngularify(socket, callback));
        };

        var wrappedSocket = {
          on: addListener,
          addListener: addListener,
          once: addOnceListener,

          emit: function (eventName, data, callback) {
            var lastIndex = arguments.length - 1;
            var callback = arguments[lastIndex];
            if (typeof callback === "function") {
              callback = asyncAngularify(socket, callback);
              arguments[lastIndex] = callback;
            }
            return socket.emit.apply(socket, arguments);
          },

          removeListener: function (ev, fn) {
            if (fn && fn.__ng) {
              arguments[1] = fn.__ng;
            }
            return socket.removeListener.apply(socket, arguments);
          },

          removeAllListeners: function () {
            return socket.removeAllListeners.apply(socket, arguments);
          },

          disconnect: function (close) {
            return socket.disconnect(close);
          },

          // when socket.on('someEvent', fn (data) { ... }),
          // call scope.$broadcast('someEvent', data)
          forward: function (events, scope) {
            if (events instanceof Array === false) {
              events = [events];
            }
            if (!scope) {
              scope = defaultScope;
            }
            events.forEach(function (eventName) {
              var prefixedEvent = prefix + eventName;
              var forwardBroadcast = asyncAngularify(socket, function () {
                Array.prototype.unshift.call(arguments, prefixedEvent);
                scope.$broadcast.apply(scope, arguments);
              });
              scope.$on("$destroy", function () {
                socket.removeListener(eventName, forwardBroadcast);
              });
              socket.on(eventName, forwardBroadcast);
            });
          }
        };

        return wrappedSocket;
      };
    }];
  });

/**
 * State-based routing for AngularJS 1.x
 * NOTICE: This monolithic bundle also bundles the @uirouter/core code.
 *         This causes it to be incompatible with plugins that depend on @uirouter/core.
 *         We recommend switching to the ui-router-core.js and ui-router-angularjs.js bundles instead.
 *         For more information, see https://ui-router.github.io/blog/uirouter-for-angularjs-umd-bundles
 * @version v1.0.30
 * @link https://ui-router.github.io
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('angular')) :
    typeof define === 'function' && define.amd ? define(['exports', 'angular'], factory) :
    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular));
}(this, (function (exports, ng_from_import) { 'use strict';

    /** @publicapi @module ng1 */ /** */
    /** @hidden */ var ng_from_global = angular;
    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;

    /**
     * Higher order functions
     *
     * These utility functions are exported, but are subject to change without notice.
     *
     * @packageDocumentation
     */
    var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };
    /**
     * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
     *
     * Given a function with N parameters, returns a new function that supports partial application.
     * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
     * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
     * accept more parameters until all N parameters have been supplied.
     *
     *
     * This contrived example uses a partially applied function as an predicate, which returns true
     * if an object is found in both arrays.
     * @example
     * ```
     * // returns true if an object is in both of the two arrays
     * function inBoth(array1, array2, object) {
     *   return array1.indexOf(object) !== -1 &&
     *          array2.indexOf(object) !== 1;
     * }
     * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
     * let foos = [obj1, obj3]
     * let bars = [obj3, obj4, obj5]
     *
     * // A curried "copy" of inBoth
     * let curriedInBoth = curry(inBoth);
     * // Partially apply both the array1 and array2
     * let inFoosAndBars = curriedInBoth(foos, bars);
     *
     * // Supply the final argument; since all arguments are
     * // supplied, the original inBoth function is then called.
     * let obj1InBoth = inFoosAndBars(obj1); // false
     *
     * // Use the inFoosAndBars as a predicate.
     * // Filter, on each iteration, supplies the final argument
     * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
     * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
     *
     * ```
     *
     * @param fn
     * @returns {*|function(): (*|any)}
     */
    function curry(fn) {
        return function curried() {
            if (arguments.length >= fn.length) {
                return fn.apply(this, arguments);
            }
            var args = Array.prototype.slice.call(arguments);
            return curried.bind.apply(curried, __spreadArrays([this], args));
        };
    }
    /**
     * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
     * given: f(x), g(x), h(x)
     * let composed = compose(f,g,h)
     * then, composed is: f(g(h(x)))
     */
    function compose() {
        var args = arguments;
        var start = args.length - 1;
        return function () {
            var i = start, result = args[start].apply(this, arguments);
            while (i--)
                result = args[i].call(this, result);
            return result;
        };
    }
    /**
     * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
     * given: f(x), g(x), h(x)
     * let piped = pipe(f,g,h);
     * then, piped is: h(g(f(x)))
     */
    function pipe() {
        var funcs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            funcs[_i] = arguments[_i];
        }
        return compose.apply(null, [].slice.call(arguments).reverse());
    }
    /**
     * Given a property name, returns a function that returns that property from an object
     * let obj = { foo: 1, name: "blarg" };
     * let getName = prop("name");
     * getName(obj) === "blarg"
     */
    var prop = function (name) { return function (obj) { return obj && obj[name]; }; };
    /**
     * Given a property name and a value, returns a function that returns a boolean based on whether
     * the passed object has a property that matches the value
     * let obj = { foo: 1, name: "blarg" };
     * let getName = propEq("name", "blarg");
     * getName(obj) === true
     */
    var propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
    /**
     * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
     * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
     * let getName = prop("nestedObj.name");
     * getName(obj) === "blarg"
     * let propNotFound = prop("this.property.doesnt.exist");
     * propNotFound(obj) === undefined
     */
    var parse = function (name) { return pipe.apply(null, name.split('.').map(prop)); };
    /**
     * Given a function that returns a truthy or falsey value, returns a
     * function that returns the opposite (falsey or truthy) value given the same inputs
     */
    var not = function (fn) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return !fn.apply(null, args);
    }; };
    /**
     * Given two functions that return truthy or falsey values, returns a function that returns truthy
     * if both functions return truthy for the given arguments
     */
    function and(fn1, fn2) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return fn1.apply(null, args) && fn2.apply(null, args);
        };
    }
    /**
     * Given two functions that return truthy or falsey values, returns a function that returns truthy
     * if at least one of the functions returns truthy for the given arguments
     */
    function or(fn1, fn2) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return fn1.apply(null, args) || fn2.apply(null, args);
        };
    }
    /**
     * Check if all the elements of an array match a predicate function
     *
     * @param fn1 a predicate function `fn1`
     * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
     */
    var all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
    // tslint:disable-next-line:variable-name
    var any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
    /** Given a class, returns a Predicate function that returns true if the object is of that class */
    var is = function (ctor) { return function (obj) {
        return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
    }; };
    /** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
    var eq = function (value) { return function (other) { return value === other; }; };
    /** Given a value, returns a function which returns the value */
    var val = function (v) { return function () { return v; }; };
    function invoke(fnName, args) {
        return function (obj) { return obj[fnName].apply(obj, args); };
    }
    /**
     * Sorta like Pattern Matching (a functional programming conditional construct)
     *
     * See http://c2.com/cgi/wiki?PatternMatching
     *
     * This is a conditional construct which allows a series of predicates and output functions
     * to be checked and then applied.  Each predicate receives the input.  If the predicate
     * returns truthy, then its matching output function (mapping function) is provided with
     * the input and, then the result is returned.
     *
     * Each combination (2-tuple) of predicate + output function should be placed in an array
     * of size 2: [ predicate, mapFn ]
     *
     * These 2-tuples should be put in an outer array.
     *
     * @example
     * ```
     *
     * // Here's a 2-tuple where the first element is the isString predicate
     * // and the second element is a function that returns a description of the input
     * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
     *
     * // Second tuple: predicate "isNumber", mapfn returns a description
     * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
     *
     * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
     *
     * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
     *
     * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
     *
     * console.log(descriptionOf(undefined)); // 'notdefined'
     * console.log(descriptionOf(55)); // '(55) That's a number!'
     * console.log(descriptionOf("foo")); // 'Here's your string foo'
     * ```
     *
     * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
     * with a Predicate and a mapping/output function
     * @returns {function(any): *}
     */
    function pattern(struct) {
        return function (x) {
            for (var i = 0; i < struct.length; i++) {
                if (struct[i][0](x))
                    return struct[i][1](x);
            }
        };
    }

    /**
     * Predicates
     *
     * These predicates return true/false based on the input.
     * Although these functions are exported, they are subject to change without notice.
     *
     * @packageDocumentation
     */
    var toStr = Object.prototype.toString;
    var tis = function (t) { return function (x) { return typeof x === t; }; };
    var isUndefined = tis('undefined');
    var isDefined = not(isUndefined);
    var isNull = function (o) { return o === null; };
    var isNullOrUndefined = or(isNull, isUndefined);
    var isFunction = tis('function');
    var isNumber = tis('number');
    var isString = tis('string');
    var isObject = function (x) { return x !== null && typeof x === 'object'; };
    var isArray = Array.isArray;
    var isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
    var isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
    /**
     * Predicate which checks if a value is injectable
     *
     * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
     * where all the elements in the array are Strings, except the last one, which is a Function
     */
    function isInjectable(val) {
        if (isArray(val) && val.length) {
            var head = val.slice(0, -1), tail = val.slice(-1);
            return !(head.filter(not(isString)).length || tail.filter(not(isFunction)).length);
        }
        return isFunction(val);
    }
    /**
     * Predicate which checks if a value looks like a Promise
     *
     * It is probably a Promise if it's an object, and it has a `then` property which is a Function
     */
    var isPromise = and(isObject, pipe(prop('then'), isFunction));

    var noImpl = function (fnname) { return function () {
        throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
    }; };
    var makeStub = function (service, methods) {
        return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
    };
    var services = {
        $q: undefined,
        $injector: undefined,
    };

    var __spreadArrays$1 = (undefined && undefined.__spreadArrays) || function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };
    var root = (typeof self === 'object' && self.self === self && self) ||
        (typeof global === 'object' && global.global === global && global) ||
        undefined;
    var angular$1 = root.angular || {};
    var fromJson = angular$1.fromJson || JSON.parse.bind(JSON);
    var toJson = angular$1.toJson || JSON.stringify.bind(JSON);
    var forEach = angular$1.forEach || _forEach;
    var extend = Object.assign || _extend;
    var equals = angular$1.equals || _equals;
    function identity(x) {
        return x;
    }
    function noop() { }
    /**
     * Builds proxy functions on the `to` object which pass through to the `from` object.
     *
     * For each key in `fnNames`, creates a proxy function on the `to` object.
     * The proxy function calls the real function on the `from` object.
     *
     *
     * #### Example:
     * This example creates an new class instance whose functions are prebound to the new'd object.
     * ```js
     * class Foo {
     *   constructor(data) {
     *     // Binds all functions from Foo.prototype to 'this',
     *     // then copies them to 'this'
     *     bindFunctions(Foo.prototype, this, this);
     *     this.data = data;
     *   }
     *
     *   log() {
     *     console.log(this.data);
     *   }
     * }
     *
     * let myFoo = new Foo([1,2,3]);
     * var logit = myFoo.log;
     * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
     * ```
     *
     * #### Example:
     * This example creates a bound version of a service function, and copies it to another object
     * ```
     *
     * var SomeService = {
     *   this.data = [3, 4, 5];
     *   this.log = function() {
     *     console.log(this.data);
     *   }
     * }
     *
     * // Constructor fn
     * function OtherThing() {
     *   // Binds all functions from SomeService to SomeService,
     *   // then copies them to 'this'
     *   bindFunctions(SomeService, this, SomeService);
     * }
     *
     * let myOtherThing = new OtherThing();
     * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
     * ```
     *
     * @param source A function that returns the source object which contains the original functions to be bound
     * @param target A function that returns the target object which will receive the bound functions
     * @param bind A function that returns the object which the functions will be bound to
     * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
     * @param latebind If true, the binding of the function is delayed until the first time it's invoked
     */
    function createProxyFunctions(source, target, bind, fnNames, latebind) {
        if (latebind === void 0) { latebind = false; }
        var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
        var makeLateRebindFn = function (fnName) {
            return function lateRebindFunction() {
                target[fnName] = bindFunction(fnName);
                return target[fnName].apply(null, arguments);
            };
        };
        fnNames = fnNames || Object.keys(source());
        return fnNames.reduce(function (acc, name) {
            acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
            return acc;
        }, target);
    }
    /**
     * prototypal inheritance helper.
     * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
     */
    var inherit = function (parent, extra) { return extend(Object.create(parent), extra); };
    /** Given an array, returns true if the object is found in the array, (using indexOf) */
    var inArray = curry(_inArray);
    function _inArray(array, obj) {
        return array.indexOf(obj) !== -1;
    }
    /**
     * Given an array, and an item, if the item is found in the array, it removes it (in-place).
     * The same array is returned
     */
    var removeFrom = curry(_removeFrom);
    function _removeFrom(array, obj) {
        var idx = array.indexOf(obj);
        if (idx >= 0)
            array.splice(idx, 1);
        return array;
    }
    /** pushes a values to an array and returns the value */
    var pushTo = curry(_pushTo);
    function _pushTo(arr, val) {
        return arr.push(val), val;
    }
    /** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
    var deregAll = function (functions) {
        return functions.slice().forEach(function (fn) {
            typeof fn === 'function' && fn();
            removeFrom(functions, fn);
        });
    };
    /**
     * Applies a set of defaults to an options object.  The options object is filtered
     * to only those properties of the objects in the defaultsList.
     * Earlier objects in the defaultsList take precedence when applying defaults.
     */
    function defaults(opts) {
        var defaultsList = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            defaultsList[_i - 1] = arguments[_i];
        }
        var defaultVals = extend.apply(void 0, __spreadArrays$1([{}], defaultsList.reverse()));
        return extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
    }
    /** Reduce function that merges each element of the list into a single object, using extend */
    var mergeR = function (memo, item) { return extend(memo, item); };
    /**
     * Finds the common ancestor path between two states.
     *
     * @param {Object} first The first state.
     * @param {Object} second The second state.
     * @return {Array} Returns an array of state names in descending order, not including the root.
     */
    function ancestors(first, second) {
        var path = [];
        // tslint:disable-next-line:forin
        for (var n in first.path) {
            if (first.path[n] !== second.path[n])
                break;
            path.push(first.path[n]);
        }
        return path;
    }
    /**
     * Return a copy of the object only containing the whitelisted properties.
     *
     * #### Example:
     * ```
     * var foo = { a: 1, b: 2, c: 3 };
     * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
     * ```
     * @param obj the source object
     * @param propNames an Array of strings, which are the whitelisted property names
     */
    function pick(obj, propNames) {
        var objCopy = {};
        for (var _prop in obj) {
            if (propNames.indexOf(_prop) !== -1) {
                objCopy[_prop] = obj[_prop];
            }
        }
        return objCopy;
    }
    /**
     * Return a copy of the object omitting the blacklisted properties.
     *
     * @example
     * ```
     *
     * var foo = { a: 1, b: 2, c: 3 };
     * var ab = omit(foo, ['a', 'b']); // { c: 3 }
     * ```
     * @param obj the source object
     * @param propNames an Array of strings, which are the blacklisted property names
     */
    function omit(obj, propNames) {
        return Object.keys(obj)
            .filter(not(inArray(propNames)))
            .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
    }
    /**
     * Maps an array, or object to a property (by name)
     */
    function pluck(collection, propName) {
        return map(collection, prop(propName));
    }
    /** Filters an Array or an Object's properties based on a predicate */
    function filter(collection, callback) {
        var arr = isArray(collection), result = arr ? [] : {};
        var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
        forEach(collection, function (item, i) {
            if (callback(item, i))
                accept(item, i);
        });
        return result;
    }
    /** Finds an object from an array, or a property of an object, that matches a predicate */
    function find(collection, callback) {
        var result;
        forEach(collection, function (item, i) {
            if (result)
                return;
            if (callback(item, i))
                result = item;
        });
        return result;
    }
    /** Given an object, returns a new object, where each property is transformed by the callback function */
    var mapObj = map;
    /** Maps an array or object properties using a callback function */
    function map(collection, callback, target) {
        target = target || (isArray(collection) ? [] : {});
        forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
        return target;
    }
    /**
     * Given an object, return its enumerable property values
     *
     * @example
     * ```
     *
     * let foo = { a: 1, b: 2, c: 3 }
     * let vals = values(foo); // [ 1, 2, 3 ]
     * ```
     */
    var values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
    /**
     * Reduce function that returns true if all of the values are truthy.
     *
     * @example
     * ```
     *
     * let vals = [ 1, true, {}, "hello world"];
     * vals.reduce(allTrueR, true); // true
     *
     * vals.push(0);
     * vals.reduce(allTrueR, true); // false
     * ```
     */
    var allTrueR = function (memo, elem) { return memo && elem; };
    /**
     * Reduce function that returns true if any of the values are truthy.
     *
     *  * @example
     * ```
     *
     * let vals = [ 0, null, undefined ];
     * vals.reduce(anyTrueR, true); // false
     *
     * vals.push("hello world");
     * vals.reduce(anyTrueR, true); // true
     * ```
     */
    var anyTrueR = function (memo, elem) { return memo || elem; };
    /**
     * Reduce function which un-nests a single level of arrays
     * @example
     * ```
     *
     * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
     * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
     * ```
     */
    var unnestR = function (memo, elem) { return memo.concat(elem); };
    /**
     * Reduce function which recursively un-nests all arrays
     *
     * @example
     * ```
     *
     * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
     * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
     * ```
     */
    var flattenR = function (memo, elem) {
        return isArray(elem) ? memo.concat(elem.reduce(flattenR, [])) : pushR(memo, elem);
    };
    /**
     * Reduce function that pushes an object to an array, then returns the array.
     * Mostly just for [[flattenR]] and [[uniqR]]
     */
    function pushR(arr, obj) {
        arr.push(obj);
        return arr;
    }
    /** Reduce function that filters out duplicates */
    var uniqR = function (acc, token) { return (inArray(acc, token) ? acc : pushR(acc, token)); };
    /**
     * Return a new array with a single level of arrays unnested.
     *
     * @example
     * ```
     *
     * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
     * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
     * ```
     */
    var unnest = function (arr) { return arr.reduce(unnestR, []); };
    /**
     * Return a completely flattened version of an array.
     *
     * @example
     * ```
     *
     * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
     * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
     * ```
     */
    var flatten = function (arr) { return arr.reduce(flattenR, []); };
    /**
     * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
     * @example
     * ```
     *
     * let isNumber = (obj) => typeof(obj) === 'number';
     * let allNumbers = [ 1, 2, 3, 4, 5 ];
     * allNumbers.filter(assertPredicate(isNumber)); //OK
     *
     * let oneString = [ 1, 2, 3, 4, "5" ];
     * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
     * ```
     */
    var assertPredicate = assertFn;
    /**
     * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
     * @example
     * ```
     *
     * var data = { foo: 1, bar: 2 };
     *
     * let keys = [ 'foo', 'bar' ]
     * let values = keys.map(assertMap(key => data[key], "Key not found"));
     * // values is [1, 2]
     *
     * let keys = [ 'foo', 'bar', 'baz' ]
     * let values = keys.map(assertMap(key => data[key], "Key not found"));
     * // throws Error("Key not found")
     * ```
     */
    var assertMap = assertFn;
    function assertFn(predicateOrMap, errMsg) {
        if (errMsg === void 0) { errMsg = 'assert failure'; }
        return function (obj) {
            var result = predicateOrMap(obj);
            if (!result) {
                throw new Error(isFunction(errMsg) ? errMsg(obj) : errMsg);
            }
            return result;
        };
    }
    /**
     * Like _.pairs: Given an object, returns an array of key/value pairs
     *
     * @example
     * ```
     *
     * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
     * ```
     */
    var pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
    /**
     * Given two or more parallel arrays, returns an array of tuples where
     * each tuple is composed of [ a[i], b[i], ... z[i] ]
     *
     * @example
     * ```
     *
     * let foo = [ 0, 2, 4, 6 ];
     * let bar = [ 1, 3, 5, 7 ];
     * let baz = [ 10, 30, 50, 70 ];
     * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
     * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
     * ```
     */
    function arrayTuples() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length === 0)
            return [];
        var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
        var result = [];
        var _loop_1 = function (i) {
            // This is a hot function
            // Unroll when there are 1-4 arguments
            switch (args.length) {
                case 1:
                    result.push([args[0][i]]);
                    break;
                case 2:
                    result.push([args[0][i], args[1][i]]);
                    break;
                case 3:
                    result.push([args[0][i], args[1][i], args[2][i]]);
                    break;
                case 4:
                    result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
                    break;
                default:
                    result.push(args.map(function (array) { return array[i]; }));
                    break;
            }
        };
        for (var i = 0; i < maxArrayLen; i++) {
            _loop_1(i);
        }
        return result;
    }
    /**
     * Reduce function which builds an object from an array of [key, value] pairs.
     *
     * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
     *
     * Each keyValueTuple should be an array with values [ key: string, value: any ]
     *
     * @example
     * ```
     *
     * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
     *
     * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
     * // pairsToObj == { fookey: "fooval", barkey: "barval" }
     *
     * // Or, more simply:
     * var pairsToObj = pairs.reduce(applyPairs, {})
     * // pairsToObj == { fookey: "fooval", barkey: "barval" }
     * ```
     */
    function applyPairs(memo, keyValTuple) {
        var key, value;
        if (isArray(keyValTuple))
            key = keyValTuple[0], value = keyValTuple[1];
        if (!isString(key))
            throw new Error('invalid parameters to applyPairs');
        memo[key] = value;
        return memo;
    }
    /** Get the last element of an array */
    function tail(arr) {
        return (arr.length && arr[arr.length - 1]) || undefined;
    }
    /**
     * shallow copy from src to dest
     */
    function copy(src, dest) {
        if (dest)
            Object.keys(dest).forEach(function (key) { return delete dest[key]; });
        if (!dest)
            dest = {};
        return extend(dest, src);
    }
    /** Naive forEach implementation works with Objects or Arrays */
    function _forEach(obj, cb, _this) {
        if (isArray(obj))
            return obj.forEach(cb, _this);
        Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
    }
    function _extend(toObj) {
        for (var i = 1; i < arguments.length; i++) {
            var obj = arguments[i];
            if (!obj)
                continue;
            var keys = Object.keys(obj);
            for (var j = 0; j < keys.length; j++) {
                toObj[keys[j]] = obj[keys[j]];
            }
        }
        return toObj;
    }
    function _equals(o1, o2) {
        if (o1 === o2)
            return true;
        if (o1 === null || o2 === null)
            return false;
        if (o1 !== o1 && o2 !== o2)
            return true; // NaN === NaN
        var t1 = typeof o1, t2 = typeof o2;
        if (t1 !== t2 || t1 !== 'object')
            return false;
        var tup = [o1, o2];
        if (all(isArray)(tup))
            return _arraysEq(o1, o2);
        if (all(isDate)(tup))
            return o1.getTime() === o2.getTime();
        if (all(isRegExp)(tup))
            return o1.toString() === o2.toString();
        if (all(isFunction)(tup))
            return true; // meh
        var predicates = [isFunction, isArray, isDate, isRegExp];
        if (predicates.map(any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
            return false;
        var keys = {};
        // tslint:disable-next-line:forin
        for (var key in o1) {
            if (!_equals(o1[key], o2[key]))
                return false;
            keys[key] = true;
        }
        for (var key in o2) {
            if (!keys[key])
                return false;
        }
        return true;
    }
    function _arraysEq(a1, a2) {
        if (a1.length !== a2.length)
            return false;
        return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
    }
    // issue #2676
    var silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
    var silentRejection = function (error) { return silenceUncaughtInPromise(services.$q.reject(error)); };

    /**
     * Matches state names using glob-like pattern strings.
     *
     * Globs can be used in specific APIs including:
     *
     * - [[StateService.is]]
     * - [[StateService.includes]]
     * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
     *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
     *
     * A `Glob` string is a pattern which matches state names.
     * Nested state names are split into segments (separated by a dot) when processing.
     * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
     *
     * Globs work according to the following rules:
     *
     * ### Exact match:
     *
     * The glob `'A.B'` matches the state named exactly `'A.B'`.
     *
     * | Glob        |Matches states named|Does not match state named|
     * |:------------|:--------------------|:---------------------|
     * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
     * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
     * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
     *
     * ### Single star (`*`)
     *
     * A single star (`*`) is a wildcard that matches exactly one segment.
     *
     * | Glob        |Matches states named  |Does not match state named |
     * |:------------|:---------------------|:--------------------------|
     * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
     * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
     * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
     *
     * ### Double star (`**`)
     *
     * A double star (`'**'`) is a wildcard that matches *zero or more segments*
     *
     * | Glob        |Matches states named                           |Does not match state named         |
     * |:------------|:----------------------------------------------|:----------------------------------|
     * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
     * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
     * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
     * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
     *
     * @packageDocumentation
     */
    var Glob = /** @class */ (function () {
        function Glob(text) {
            this.text = text;
            this.glob = text.split('.');
            var regexpString = this.text
                .split('.')
                .map(function (seg) {
                if (seg === '**')
                    return '(?:|(?:\\.[^.]*)*)';
                if (seg === '*')
                    return '\\.[^.]*';
                return '\\.' + seg;
            })
                .join('');
            this.regexp = new RegExp('^' + regexpString + '$');
        }
        /** Returns true if the string has glob-like characters in it */
        Glob.is = function (text) {
            return !!/[!,*]+/.exec(text);
        };
        /** Returns a glob from the string, or null if the string isn't Glob-like */
        Glob.fromString = function (text) {
            return Glob.is(text) ? new Glob(text) : null;
        };
        Glob.prototype.matches = function (name) {
            return this.regexp.test('.' + name);
        };
        return Glob;
    }());

    var Queue = /** @class */ (function () {
        function Queue(_items, _limit) {
            if (_items === void 0) { _items = []; }
            if (_limit === void 0) { _limit = null; }
            this._items = _items;
            this._limit = _limit;
            this._evictListeners = [];
            this.onEvict = pushTo(this._evictListeners);
        }
        Queue.prototype.enqueue = function (item) {
            var items = this._items;
            items.push(item);
            if (this._limit && items.length > this._limit)
                this.evict();
            return item;
        };
        Queue.prototype.evict = function () {
            var item = this._items.shift();
            this._evictListeners.forEach(function (fn) { return fn(item); });
            return item;
        };
        Queue.prototype.dequeue = function () {
            if (this.size())
                return this._items.splice(0, 1)[0];
        };
        Queue.prototype.clear = function () {
            var current = this._items;
            this._items = [];
            return current;
        };
        Queue.prototype.size = function () {
            return this._items.length;
        };
        Queue.prototype.remove = function (item) {
            var idx = this._items.indexOf(item);
            return idx > -1 && this._items.splice(idx, 1)[0];
        };
        Queue.prototype.peekTail = function () {
            return this._items[this._items.length - 1];
        };
        Queue.prototype.peekHead = function () {
            if (this.size())
                return this._items[0];
        };
        return Queue;
    }());

    /** An enum for Transition Rejection reasons */

    (function (RejectType) {
        /**
         * A new transition superseded this one.
         *
         * While this transition was running, a new transition started.
         * This transition is cancelled because it was superseded by new transition.
         */
        RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
        /**
         * The transition was aborted
         *
         * The transition was aborted by a hook which returned `false`
         */
        RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
        /**
         * The transition was invalid
         *
         * The transition was never started because it was invalid
         */
        RejectType[RejectType["INVALID"] = 4] = "INVALID";
        /**
         * The transition was ignored
         *
         * The transition was ignored because it would have no effect.
         *
         * Either:
         *
         * - The transition is targeting the current state and parameter values
         * - The transition is targeting the same state and parameter values as the currently running transition.
         */
        RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
        /**
         * The transition errored.
         *
         * This generally means a hook threw an error or returned a rejected promise
         */
        RejectType[RejectType["ERROR"] = 6] = "ERROR";
    })(exports.RejectType || (exports.RejectType = {}));
    /** @internal */
    var id = 0;
    var Rejection = /** @class */ (function () {
        function Rejection(type, message, detail) {
            /** @internal */
            this.$id = id++;
            this.type = type;
            this.message = message;
            this.detail = detail;
        }
        /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
        Rejection.isRejectionPromise = function (obj) {
            return obj && typeof obj.then === 'function' && is(Rejection)(obj._transitionRejection);
        };
        /** Returns a Rejection due to transition superseded */
        Rejection.superseded = function (detail, options) {
            var message = 'The transition has been superseded by a different transition';
            var rejection = new Rejection(exports.RejectType.SUPERSEDED, message, detail);
            if (options && options.redirected) {
                rejection.redirected = true;
            }
            return rejection;
        };
        /** Returns a Rejection due to redirected transition */
        Rejection.redirected = function (detail) {
            return Rejection.superseded(detail, { redirected: true });
        };
        /** Returns a Rejection due to invalid transition */
        Rejection.invalid = function (detail) {
            var message = 'This transition is invalid';
            return new Rejection(exports.RejectType.INVALID, message, detail);
        };
        /** Returns a Rejection due to ignored transition */
        Rejection.ignored = function (detail) {
            var message = 'The transition was ignored';
            return new Rejection(exports.RejectType.IGNORED, message, detail);
        };
        /** Returns a Rejection due to aborted transition */
        Rejection.aborted = function (detail) {
            var message = 'The transition has been aborted';
            return new Rejection(exports.RejectType.ABORTED, message, detail);
        };
        /** Returns a Rejection due to aborted transition */
        Rejection.errored = function (detail) {
            var message = 'The transition errored';
            return new Rejection(exports.RejectType.ERROR, message, detail);
        };
        /**
         * Returns a Rejection
         *
         * Normalizes a value as a Rejection.
         * If the value is already a Rejection, returns it.
         * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
         *
         * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
         */
        Rejection.normalize = function (detail) {
            return is(Rejection)(detail) ? detail : Rejection.errored(detail);
        };
        Rejection.prototype.toString = function () {
            var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : stringify(d)); };
            var detail = detailString(this.detail);
            var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
            return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
        };
        Rejection.prototype.toPromise = function () {
            return extend(silentRejection(this), { _transitionRejection: this });
        };
        return Rejection;
    }());

    /**
     * Functions that manipulate strings
     *
     * Although these functions are exported, they are subject to change without notice.
     *
     * @packageDocumentation
     */
    /**
     * Returns a string shortened to a maximum length
     *
     * If the string is already less than the `max` length, return the string.
     * Else return the string, shortened to `max - 3` and append three dots ("...").
     *
     * @param max the maximum length of the string to return
     * @param str the input string
     */
    function maxLength(max, str) {
        if (str.length <= max)
            return str;
        return str.substr(0, max - 3) + '...';
    }
    /**
     * Returns a string, with spaces added to the end, up to a desired str length
     *
     * If the string is already longer than the desired length, return the string.
     * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
     *
     * @param length the desired length of the string to return
     * @param str the input string
     */
    function padString(length, str) {
        while (str.length < length)
            str += ' ';
        return str;
    }
    function kebobString(camelCase) {
        return camelCase
            .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
            .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
    }
    function functionToString(fn) {
        var fnStr = fnToString(fn);
        var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
        var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
        var fnName = fn['name'] || '';
        if (fnName && toStr.match(/function \(/)) {
            return 'function ' + fnName + toStr.substr(9);
        }
        return toStr;
    }
    function fnToString(fn) {
        var _fn = isArray(fn) ? fn.slice(-1)[0] : fn;
        return (_fn && _fn.toString()) || 'undefined';
    }
    function stringify(o) {
        var seen = [];
        var isRejection = Rejection.isRejectionPromise;
        var hasToString = function (obj) {
            return isObject(obj) && !isArray(obj) && obj.constructor !== Object && isFunction(obj.toString);
        };
        var stringifyPattern = pattern([
            [isUndefined, val('undefined')],
            [isNull, val('null')],
            [isPromise, val('[Promise]')],
            [isRejection, function (x) { return x._transitionRejection.toString(); }],
            [hasToString, function (x) { return x.toString(); }],
            [isInjectable, functionToString],
            [val(true), identity],
        ]);
        function format(value) {
            if (isObject(value)) {
                if (seen.indexOf(value) !== -1)
                    return '[circular ref]';
                seen.push(value);
            }
            return stringifyPattern(value);
        }
        if (isUndefined(o)) {
            // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
            // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
            // manually stringifying it.
            return format(o);
        }
        return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
    }
    /** Returns a function that splits a string on a character or substring */
    var beforeAfterSubstr = function (char) {
        return function (str) {
            if (!str)
                return ['', ''];
            var idx = str.indexOf(char);
            if (idx === -1)
                return [str, ''];
            return [str.substr(0, idx), str.substr(idx + 1)];
        };
    };
    var hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
    var stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
    var splitHash = beforeAfterSubstr('#');
    var splitQuery = beforeAfterSubstr('?');
    var splitEqual = beforeAfterSubstr('=');
    var trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
    /**
     * Splits on a delimiter, but returns the delimiters in the array
     *
     * #### Example:
     * ```js
     * var splitOnSlashes = splitOnDelim('/');
     * splitOnSlashes("/foo"); // ["/", "foo"]
     * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
     * ```
     */
    function splitOnDelim(delim) {
        var re = new RegExp('(' + delim + ')', 'g');
        return function (str) { return str.split(re).filter(identity); };
    }
    /**
     * Reduce fn that joins neighboring strings
     *
     * Given an array of strings, returns a new array
     * where all neighboring strings have been joined.
     *
     * #### Example:
     * ```js
     * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
     * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
     * ```
     */
    function joinNeighborsR(acc, x) {
        if (isString(tail(acc)) && isString(x))
            return acc.slice(0, -1).concat(tail(acc) + x);
        return pushR(acc, x);
    }

    /**
     * workaround for missing console object in IE9 when dev tools haven't been opened o_O
     * @packageDocumentation
     */
    var noopConsoleStub = { log: noop, error: noop, table: noop };
    function ie9Console(console) {
        var bound = function (fn) { return Function.prototype.bind.call(fn, console); };
        return {
            log: bound(console.log),
            error: bound(console.log),
            table: bound(console.log),
        };
    }
    function fallbackConsole(console) {
        var log = console.log.bind(console);
        var error = console.error ? console.error.bind(console) : log;
        var table = console.table ? console.table.bind(console) : log;
        return { log: log, error: error, table: table };
    }
    function getSafeConsole() {
        // @ts-ignore
        var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
        if (isIE9) {
            return window && window.console ? ie9Console(window.console) : noopConsoleStub;
        }
        else if (!console.table || !console.error) {
            return fallbackConsole(console);
        }
        else {
            return console;
        }
    }
    var safeConsole = getSafeConsole();

    /**
     * # Transition tracing (debug)
     *
     * Enable transition tracing to print transition information to the console,
     * in order to help debug your application.
     * Tracing logs detailed information about each Transition to your console.
     *
     * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
     *
     * ### ES6
     * ```js
     * import {trace} from "@uirouter/core";
     * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
     * ```
     *
     * ### CJS
     * ```js
     * let trace = require("@uirouter/core").trace;
     * trace.enable("TRANSITION", "VIEWCONFIG");
     * ```
     *
     * ### Globals
     * ```js
     * let trace = window["@uirouter/core"].trace;
     * trace.enable(); // Trace everything (very verbose)
     * ```
     *
     * ### Angular 1:
     * ```js
     * app.run($trace => $trace.enable());
     * ```
     *
     * @packageDocumentation
     */
    function uiViewString(uiview) {
        if (!uiview)
            return 'ui-view (defunct)';
        var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
        return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
    }
    var viewConfigString = function (viewConfig) {
        var view = viewConfig.viewDecl;
        var state = view.$context.name || '(root)';
        return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
    };
    function normalizedCat(input) {
        return isNumber(input) ? exports.Category[input] : exports.Category[exports.Category[input]];
    }
    /**
     * Trace categories Enum
     *
     * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
     *
     * `trace.enable(Category.TRANSITION)`
     *
     * These can also be provided using a matching string, or position ordinal
     *
     * `trace.enable("TRANSITION")`
     *
     * `trace.enable(1)`
     */

    (function (Category) {
        Category[Category["RESOLVE"] = 0] = "RESOLVE";
        Category[Category["TRANSITION"] = 1] = "TRANSITION";
        Category[Category["HOOK"] = 2] = "HOOK";
        Category[Category["UIVIEW"] = 3] = "UIVIEW";
        Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
    })(exports.Category || (exports.Category = {}));
    var _tid = parse('$id');
    var _rid = parse('router.$id');
    var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
    /**
     * Prints UI-Router Transition trace information to the console.
     */
    var Trace = /** @class */ (function () {
        /** @internal */
        function Trace() {
            /** @internal */
            this._enabled = {};
            this.approximateDigests = 0;
        }
        /** @internal */
        Trace.prototype._set = function (enabled, categories) {
            var _this = this;
            if (!categories.length) {
                categories = Object.keys(exports.Category)
                    .map(function (k) { return parseInt(k, 10); })
                    .filter(function (k) { return !isNaN(k); })
                    .map(function (key) { return exports.Category[key]; });
            }
            categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
        };
        Trace.prototype.enable = function () {
            var categories = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                categories[_i] = arguments[_i];
            }
            this._set(true, categories);
        };
        Trace.prototype.disable = function () {
            var categories = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                categories[_i] = arguments[_i];
            }
            this._set(false, categories);
        };
        /**
         * Retrieves the enabled stateus of a [[Category]]
         *
         * ```js
         * trace.enabled("VIEWCONFIG"); // true or false
         * ```
         *
         * @returns boolean true if the category is enabled
         */
        Trace.prototype.enabled = function (category) {
            return !!this._enabled[normalizedCat(category)];
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceTransitionStart = function (trans) {
            if (!this.enabled(exports.Category.TRANSITION))
                return;
            safeConsole.log(transLbl(trans) + ": Started  -> " + stringify(trans));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceTransitionIgnored = function (trans) {
            if (!this.enabled(exports.Category.TRANSITION))
                return;
            safeConsole.log(transLbl(trans) + ": Ignored  <> " + stringify(trans));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceHookInvocation = function (step, trans, options) {
            if (!this.enabled(exports.Category.HOOK))
                return;
            var event = parse('traceData.hookType')(options) || 'internal', context = parse('traceData.context.state.name')(options) || parse('traceData.context')(options) || 'unknown', name = functionToString(step.registeredHook.callback);
            safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + maxLength(200, name));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
            if (!this.enabled(exports.Category.HOOK))
                return;
            safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + maxLength(200, stringify(hookResult)));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceResolvePath = function (path, when, trans) {
            if (!this.enabled(exports.Category.RESOLVE))
                return;
            safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
            if (!this.enabled(exports.Category.RESOLVE))
                return;
            safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + maxLength(200, stringify(resolvable.data)));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceError = function (reason, trans) {
            if (!this.enabled(exports.Category.TRANSITION))
                return;
            safeConsole.log(transLbl(trans) + ": <- Rejected " + stringify(trans) + ", reason: " + reason);
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceSuccess = function (finalState, trans) {
            if (!this.enabled(exports.Category.TRANSITION))
                return;
            safeConsole.log(transLbl(trans) + ": <- Success  " + stringify(trans) + ", final state: " + finalState.name);
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
            if (extra === void 0) { extra = ''; }
            if (!this.enabled(exports.Category.UIVIEW))
                return;
            safeConsole.log("ui-view: " + padString(30, event) + " " + uiViewString(viewData) + extra);
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
            if (!this.enabled(exports.Category.UIVIEW))
                return;
            this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceUIViewFill = function (viewData, html) {
            if (!this.enabled(exports.Category.UIVIEW))
                return;
            this.traceUIViewEvent('Fill', viewData, " with: " + maxLength(200, html));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceViewSync = function (pairs) {
            if (!this.enabled(exports.Category.VIEWCONFIG))
                return;
            var uivheader = 'uiview component fqn';
            var cfgheader = 'view config state (view name)';
            var mapping = pairs
                .map(function (_a) {
                var _b;
                var uiView = _a.uiView, viewConfig = _a.viewConfig;
                var uiv = uiView && uiView.fqn;
                var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
                return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
            })
                .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
            safeConsole.table(mapping);
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
            if (!this.enabled(exports.Category.VIEWCONFIG))
                return;
            safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
        };
        /** @internal called by ui-router code */
        Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
            if (!this.enabled(exports.Category.VIEWCONFIG))
                return;
            safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
        };
        return Trace;
    }());
    /**
     * The [[Trace]] singleton
     *
     * #### Example:
     * ```js
     * import {trace} from "@uirouter/core";
     * trace.enable(1, 5);
     * ```
     */
    var trace = new Trace();

    /**
     * An internal class which implements [[ParamTypeDefinition]].
     *
     * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
     * When a param type definition is registered, an instance of this class is created internally.
     *
     * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
     *
     * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
     *
     * #### Example:
     * ```js
     * var paramTypeDef = {
     *   decode: function(val) { return parseInt(val, 10); },
     *   encode: function(val) { return val && val.toString(); },
     *   equals: function(a, b) { return this.is(a) && a === b; },
     *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
     *   pattern: /\d+/
     * }
     *
     * var paramType = new ParamType(paramTypeDef);
     * ```
     */
    var ParamType = /** @class */ (function () {
        /**
         * @param def  A configuration object which contains the custom type definition.  The object's
         *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
         * @returns a new ParamType object
         */
        function ParamType(def) {
            /** @inheritdoc */
            this.pattern = /.*/;
            /** @inheritdoc */
            this.inherit = true;
            extend(this, def);
        }
        // consider these four methods to be "abstract methods" that should be overridden
        /** @inheritdoc */
        ParamType.prototype.is = function (val, key) {
            return true;
        };
        /** @inheritdoc */
        ParamType.prototype.encode = function (val, key) {
            return val;
        };
        /** @inheritdoc */
        ParamType.prototype.decode = function (val, key) {
            return val;
        };
        /** @inheritdoc */
        ParamType.prototype.equals = function (a, b) {
            // tslint:disable-next-line:triple-equals
            return a == b;
        };
        ParamType.prototype.$subPattern = function () {
            var sub = this.pattern.toString();
            return sub.substr(1, sub.length - 2);
        };
        ParamType.prototype.toString = function () {
            return "{ParamType:" + this.name + "}";
        };
        /** Given an encoded string, or a decoded object, returns a decoded object */
        ParamType.prototype.$normalize = function (val) {
            return this.is(val) ? val : this.decode(val);
        };
        /**
         * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
         * e.g.:
         * - urlmatcher pattern "/path?{queryParam[]:int}"
         * - url: "/path?queryParam=1&queryParam=2
         * - $stateParams.queryParam will be [1, 2]
         * if `mode` is "auto", then
         * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
         * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
         */
        ParamType.prototype.$asArray = function (mode, isSearch) {
            if (!mode)
                return this;
            if (mode === 'auto' && !isSearch)
                throw new Error("'auto' array mode is for query parameters only");
            return new ArrayType(this, mode);
        };
        return ParamType;
    }());
    /** Wraps up a `ParamType` object to handle array values. */
    function ArrayType(type, mode) {
        var _this = this;
        // Wrap non-array value as array
        function arrayWrap(val) {
            return isArray(val) ? val : isDefined(val) ? [val] : [];
        }
        // Unwrap array value for "auto" mode. Return undefined for empty array.
        function arrayUnwrap(val) {
            switch (val.length) {
                case 0:
                    return undefined;
                case 1:
                    return mode === 'auto' ? val[0] : val;
                default:
                    return val;
            }
        }
        // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
        function arrayHandler(callback, allTruthyMode) {
            return function handleArray(val) {
                if (isArray(val) && val.length === 0)
                    return val;
                var arr = arrayWrap(val);
                var result = map(arr, callback);
                return allTruthyMode === true ? filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
            };
        }
        // Wraps type (.equals) functions to operate on each value of an array
        function arrayEqualsHandler(callback) {
            return function handleArray(val1, val2) {
                var left = arrayWrap(val1), right = arrayWrap(val2);
                if (left.length !== right.length)
                    return false;
                for (var i = 0; i < left.length; i++) {
                    if (!callback(left[i], right[i]))
                        return false;
                }
                return true;
            };
        }
        ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
            var paramTypeFn = type[name].bind(type);
            var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
            _this[name] = wrapperFn(paramTypeFn);
        });
        extend(this, {
            dynamic: type.dynamic,
            name: type.name,
            pattern: type.pattern,
            inherit: type.inherit,
            raw: type.raw,
            is: arrayHandler(type.is.bind(type), true),
            $arrayMode: mode,
        });
    }

    var hasOwn = Object.prototype.hasOwnProperty;
    var isShorthand = function (cfg) {
        return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
    };

    (function (DefType) {
        DefType[DefType["PATH"] = 0] = "PATH";
        DefType[DefType["SEARCH"] = 1] = "SEARCH";
        DefType[DefType["CONFIG"] = 2] = "CONFIG";
    })(exports.DefType || (exports.DefType = {}));
    function getParamDeclaration(paramName, location, state) {
        var noReloadOnSearch = (state.reloadOnSearch === false && location === exports.DefType.SEARCH) || undefined;
        var dynamic = find([state.dynamic, noReloadOnSearch], isDefined);
        var defaultConfig = isDefined(dynamic) ? { dynamic: dynamic } : {};
        var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
        return extend(defaultConfig, paramConfig);
    }
    function unwrapShorthand(cfg) {
        cfg = isShorthand(cfg) ? { value: cfg } : cfg;
        getStaticDefaultValue['__cacheable'] = true;
        function getStaticDefaultValue() {
            return cfg.value;
        }
        var $$fn = isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
        return extend(cfg, { $$fn: $$fn });
    }
    function getType(cfg, urlType, location, id, paramTypes) {
        if (cfg.type && urlType && urlType.name !== 'string')
            throw new Error("Param '" + id + "' has two type configurations.");
        if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
            return paramTypes.type(cfg.type);
        if (urlType)
            return urlType;
        if (!cfg.type) {
            var type = location === exports.DefType.CONFIG
                ? 'any'
                : location === exports.DefType.PATH
                    ? 'path'
                    : location === exports.DefType.SEARCH
                        ? 'query'
                        : 'string';
            return paramTypes.type(type);
        }
        return cfg.type instanceof ParamType ? cfg.type : paramTypes.type(cfg.type);
    }
    /** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
    function getSquashPolicy(config, isOptional, defaultPolicy) {
        var squash = config.squash;
        if (!isOptional || squash === false)
            return false;
        if (!isDefined(squash) || squash == null)
            return defaultPolicy;
        if (squash === true || isString(squash))
            return squash;
        throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }
    function getReplace(config, arrayMode, isOptional, squash) {
        var defaultPolicy = [
            { from: '', to: isOptional || arrayMode ? undefined : '' },
            { from: null, to: isOptional || arrayMode ? undefined : '' },
        ];
        var replace = isArray(config.replace) ? config.replace : [];
        if (isString(squash))
            replace.push({ from: squash, to: undefined });
        var configuredKeys = map(replace, prop('from'));
        return filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
    }
    var Param = /** @class */ (function () {
        function Param(id, type, location, urlConfig, state) {
            var config = getParamDeclaration(id, location, state);
            type = getType(config, type, location, id, urlConfig.paramTypes);
            var arrayMode = getArrayMode();
            type = arrayMode ? type.$asArray(arrayMode, location === exports.DefType.SEARCH) : type;
            var isOptional = config.value !== undefined || location === exports.DefType.SEARCH;
            var dynamic = isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
            var raw = isDefined(config.raw) ? !!config.raw : !!type.raw;
            var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
            var replace = getReplace(config, arrayMode, isOptional, squash);
            var inherit = isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
            // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
            function getArrayMode() {
                var arrayDefaults = { array: location === exports.DefType.SEARCH ? 'auto' : false };
                var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
                return extend(arrayDefaults, arrayParamNomenclature, config).array;
            }
            extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
        }
        Param.values = function (params, values) {
            if (values === void 0) { values = {}; }
            var paramValues = {};
            for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
                var param = params_1[_i];
                paramValues[param.id] = param.value(values[param.id]);
            }
            return paramValues;
        };
        /**
         * Finds [[Param]] objects which have different param values
         *
         * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
         *
         * @param params: The list of Param objects to filter
         * @param values1: The first set of parameter values
         * @param values2: the second set of parameter values
         *
         * @returns any Param objects whose values were different between values1 and values2
         */
        Param.changed = function (params, values1, values2) {
            if (values1 === void 0) { values1 = {}; }
            if (values2 === void 0) { values2 = {}; }
            return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
        };
        /**
         * Checks if two param value objects are equal (for a set of [[Param]] objects)
         *
         * @param params The list of [[Param]] objects to check
         * @param values1 The first set of param values
         * @param values2 The second set of param values
         *
         * @returns true if the param values in values1 and values2 are equal
         */
        Param.equals = function (params, values1, values2) {
            if (values1 === void 0) { values1 = {}; }
            if (values2 === void 0) { values2 = {}; }
            return Param.changed(params, values1, values2).length === 0;
        };
        /** Returns true if a the parameter values are valid, according to the Param definitions */
        Param.validates = function (params, values) {
            if (values === void 0) { values = {}; }
            return params.map(function (param) { return param.validates(values[param.id]); }).reduce(allTrueR, true);
        };
        Param.prototype.isDefaultValue = function (value) {
            return this.isOptional && this.type.equals(this.value(), value);
        };
        /**
         * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
         * default value, which may be the result of an injectable function.
         */
        Param.prototype.value = function (value) {
            var _this = this;
            /**
             * [Internal] Get the default value of a parameter, which may be an injectable function.
             */
            var getDefaultValue = function () {
                if (_this._defaultValueCache)
                    return _this._defaultValueCache.defaultValue;
                if (!services.$injector)
                    throw new Error('Injectable functions cannot be called at configuration time');
                var defaultValue = services.$injector.invoke(_this.config.$$fn);
                if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
                    throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
                if (_this.config.$$fn['__cacheable']) {
                    _this._defaultValueCache = { defaultValue: defaultValue };
                }
                return defaultValue;
            };
            var replaceSpecialValues = function (val) {
                for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
                    var tuple = _a[_i];
                    if (tuple.from === val)
                        return tuple.to;
                }
                return val;
            };
            value = replaceSpecialValues(value);
            return isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
        };
        Param.prototype.isSearch = function () {
            return this.location === exports.DefType.SEARCH;
        };
        Param.prototype.validates = function (value) {
            // There was no parameter value, but the param is optional
            if ((isUndefined(value) || value === null) && this.isOptional)
                return true;
            // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
            var normalized = this.type.$normalize(value);
            if (!this.type.is(normalized))
                return false;
            // The value was of the correct type, but when encoded, did not match the ParamType's regexp
            var encoded = this.type.encode(normalized);
            return !(isString(encoded) && !this.type.pattern.exec(encoded));
        };
        Param.prototype.toString = function () {
            return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
        };
        return Param;
    }());

    /**
     * A registry for parameter types.
     *
     * This registry manages the built-in (and custom) parameter types.
     *
     * The built-in parameter types are:
     *
     * - [[string]]
     * - [[path]]
     * - [[query]]
     * - [[hash]]
     * - [[int]]
     * - [[bool]]
     * - [[date]]
     * - [[json]]
     * - [[any]]
     *
     * To register custom parameter types, use [[UrlConfig.type]], i.e.,
     *
     * ```js
     * router.urlService.config.type(customType)
     * ```
     */
    var ParamTypes = /** @class */ (function () {
        function ParamTypes() {
            this.enqueue = true;
            this.typeQueue = [];
            this.defaultTypes = pick(ParamTypes.prototype, [
                'hash',
                'string',
                'query',
                'path',
                'int',
                'bool',
                'date',
                'json',
                'any',
            ]);
            // Register default types. Store them in the prototype of this.types.
            var makeType = function (definition, name) { return new ParamType(extend({ name: name }, definition)); };
            this.types = inherit(map(this.defaultTypes, makeType), {});
        }
        ParamTypes.prototype.dispose = function () {
            this.types = {};
        };
        /**
         * Registers a parameter type
         *
         * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
         */
        ParamTypes.prototype.type = function (name, definition, definitionFn) {
            if (!isDefined(definition))
                return this.types[name];
            if (this.types.hasOwnProperty(name))
                throw new Error("A type named '" + name + "' has already been defined.");
            this.types[name] = new ParamType(extend({ name: name }, definition));
            if (definitionFn) {
                this.typeQueue.push({ name: name, def: definitionFn });
                if (!this.enqueue)
                    this._flushTypeQueue();
            }
            return this;
        };
        ParamTypes.prototype._flushTypeQueue = function () {
            while (this.typeQueue.length) {
                var type = this.typeQueue.shift();
                if (type.pattern)
                    throw new Error("You cannot override a type's .pattern at runtime.");
                extend(this.types[type.name], services.$injector.invoke(type.def));
            }
        };
        return ParamTypes;
    }());
    function initDefaultTypes() {
        var makeDefaultType = function (def) {
            var valToString = function (val) { return (val != null ? val.toString() : val); };
            var defaultTypeBase = {
                encode: valToString,
                decode: valToString,
                is: is(String),
                pattern: /.*/,
                // tslint:disable-next-line:triple-equals
                equals: function (a, b) { return a == b; },
            };
            return extend({}, defaultTypeBase, def);
        };
        // Default Parameter Type Definitions
        extend(ParamTypes.prototype, {
            string: makeDefaultType({}),
            path: makeDefaultType({
                pattern: /[^/]*/,
            }),
            query: makeDefaultType({}),
            hash: makeDefaultType({
                inherit: false,
            }),
            int: makeDefaultType({
                decode: function (val) { return parseInt(val, 10); },
                is: function (val) {
                    return !isNullOrUndefined(val) && this.decode(val.toString()) === val;
                },
                pattern: /-?\d+/,
            }),
            bool: makeDefaultType({
                encode: function (val) { return (val && 1) || 0; },
                decode: function (val) { return parseInt(val, 10) !== 0; },
                is: is(Boolean),
                pattern: /0|1/,
            }),
            date: makeDefaultType({
                encode: function (val) {
                    return !this.is(val)
                        ? undefined
                        : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
                },
                decode: function (val) {
                    if (this.is(val))
                        return val;
                    var match = this.capture.exec(val);
                    return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
                },
                is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
                equals: function (l, r) {
                    return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
                },
                pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
                capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
            }),
            json: makeDefaultType({
                encode: toJson,
                decode: fromJson,
                is: is(Object),
                equals: equals,
                pattern: /[^/]*/,
            }),
            // does not encode/decode
            any: makeDefaultType({
                encode: identity,
                decode: identity,
                is: function () { return true; },
                equals: equals,
            }),
        });
    }
    initDefaultTypes();

    var StateParams = /** @class */ (function () {
        function StateParams(params) {
            if (params === void 0) { params = {}; }
            extend(this, params);
        }
        /**
         * Merges a set of parameters with all parameters inherited between the common parents of the
         * current state and a given destination state.
         *
         * @param {Object} newParams The set of parameters which will be composited with inherited params.
         * @param {Object} $current Internal definition of object representing the current state.
         * @param {Object} $to Internal definition of object representing state to transition to.
         */
        StateParams.prototype.$inherit = function (newParams, $current, $to) {
            var parentParams;
            var parents = ancestors($current, $to), inherited = {}, inheritList = [];
            for (var i in parents) {
                if (!parents[i] || !parents[i].params)
                    continue;
                parentParams = Object.keys(parents[i].params);
                if (!parentParams.length)
                    continue;
                for (var j in parentParams) {
                    if (inheritList.indexOf(parentParams[j]) >= 0)
                        continue;
                    inheritList.push(parentParams[j]);
                    inherited[parentParams[j]] = this[parentParams[j]];
                }
            }
            return extend({}, inherited, newParams);
        };
        return StateParams;
    }());

    /**
     * A node in a [[TreeChanges]] path
     *
     * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
     * Each PathNode corresponds to a state being entered, exited, or retained.
     * The stateful information includes parameter values and resolve data.
     */
    var PathNode = /** @class */ (function () {
        function PathNode(stateOrNode) {
            if (stateOrNode instanceof PathNode) {
                var node = stateOrNode;
                this.state = node.state;
                this.paramSchema = node.paramSchema.slice();
                this.paramValues = extend({}, node.paramValues);
                this.resolvables = node.resolvables.slice();
                this.views = node.views && node.views.slice();
            }
            else {
                var state = stateOrNode;
                this.state = state;
                this.paramSchema = state.parameters({ inherit: false });
                this.paramValues = {};
                this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
            }
        }
        PathNode.prototype.clone = function () {
            return new PathNode(this);
        };
        /** Sets [[paramValues]] for the node, from the values of an object hash */
        PathNode.prototype.applyRawParams = function (params) {
            var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
            this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return applyPairs(memo, getParamVal(pDef)); }, {});
            return this;
        };
        /** Gets a specific [[Param]] metadata that belongs to the node */
        PathNode.prototype.parameter = function (name) {
            return find(this.paramSchema, propEq('id', name));
        };
        /**
         * @returns true if the state and parameter values for another PathNode are
         * equal to the state and param values for this PathNode
         */
        PathNode.prototype.equals = function (node, paramsFn) {
            var diff = this.diff(node, paramsFn);
            return diff && diff.length === 0;
        };
        /**
         * Finds Params with different parameter values on another PathNode.
         *
         * Given another node (of the same state), finds the parameter values which differ.
         * Returns the [[Param]] (schema objects) whose parameter values differ.
         *
         * Given another node for a different state, returns `false`
         *
         * @param node The node to compare to
         * @param paramsFn A function that returns which parameters should be compared.
         * @returns The [[Param]]s which differ, or null if the two nodes are for different states
         */
        PathNode.prototype.diff = function (node, paramsFn) {
            if (this.state !== node.state)
                return false;
            var params = paramsFn ? paramsFn(this) : this.paramSchema;
            return Param.changed(params, this.paramValues, node.paramValues);
        };
        /**
         * Returns a clone of the PathNode
         * @deprecated use instance method `node.clone()`
         */
        PathNode.clone = function (node) { return node.clone(); };
        return PathNode;
    }());

    /**
     * Encapsulate the target (destination) state/params/options of a [[Transition]].
     *
     * This class is frequently used to redirect a transition to a new destination.
     *
     * See:
     *
     * - [[HookResult]]
     * - [[TransitionHookFn]]
     * - [[TransitionService.onStart]]
     *
     * To create a `TargetState`, use [[StateService.target]].
     *
     * ---
     *
     * This class wraps:
     *
     * 1) an identifier for a state
     * 2) a set of parameters
     * 3) and transition options
     * 4) the registered state object (the [[StateDeclaration]])
     *
     * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
     * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
     * The `TargetState` class normalizes those options.
     *
     * A `TargetState` may be valid (the state being targeted exists in the registry)
     * or invalid (the state being targeted is not registered).
     */
    var TargetState = /** @class */ (function () {
        /**
         * The TargetState constructor
         *
         * Note: Do not construct a `TargetState` manually.
         * To create a `TargetState`, use the [[StateService.target]] factory method.
         *
         * @param _stateRegistry The StateRegistry to use to look up the _definition
         * @param _identifier An identifier for a state.
         *    Either a fully-qualified state name, or the object used to define the state.
         * @param _params Parameters for the target state
         * @param _options Transition options.
         *
         * @internal
         */
        function TargetState(_stateRegistry, _identifier, _params, _options) {
            this._stateRegistry = _stateRegistry;
            this._identifier = _identifier;
            this._identifier = _identifier;
            this._params = extend({}, _params || {});
            this._options = extend({}, _options || {});
            this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
        }
        /** The name of the state this object targets */
        TargetState.prototype.name = function () {
            return (this._definition && this._definition.name) || this._identifier;
        };
        /** The identifier used when creating this TargetState */
        TargetState.prototype.identifier = function () {
            return this._identifier;
        };
        /** The target parameter values */
        TargetState.prototype.params = function () {
            return this._params;
        };
        /** The internal state object (if it was found) */
        TargetState.prototype.$state = function () {
            return this._definition;
        };
        /** The internal state declaration (if it was found) */
        TargetState.prototype.state = function () {
            return this._definition && this._definition.self;
        };
        /** The target options */
        TargetState.prototype.options = function () {
            return this._options;
        };
        /** True if the target state was found */
        TargetState.prototype.exists = function () {
            return !!(this._definition && this._definition.self);
        };
        /** True if the object is valid */
        TargetState.prototype.valid = function () {
            return !this.error();
        };
        /** If the object is invalid, returns the reason why */
        TargetState.prototype.error = function () {
            var base = this.options().relative;
            if (!this._definition && !!base) {
                var stateName = base.name ? base.name : base;
                return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
            }
            if (!this._definition)
                return "No such state '" + this.name() + "'";
            if (!this._definition.self)
                return "State '" + this.name() + "' has an invalid definition";
        };
        TargetState.prototype.toString = function () {
            return "'" + this.name() + "'" + stringify(this.params());
        };
        /**
         * Returns a copy of this TargetState which targets a different state.
         * The new TargetState has the same parameter values and transition options.
         *
         * @param state The new state that should be targeted
         */
        TargetState.prototype.withState = function (state) {
            return new TargetState(this._stateRegistry, state, this._params, this._options);
        };
        /**
         * Returns a copy of this TargetState, using the specified parameter values.
         *
         * @param params the new parameter values to use
         * @param replace When false (default) the new parameter values will be merged with the current values.
         *                When true the parameter values will be used instead of the current values.
         */
        TargetState.prototype.withParams = function (params, replace) {
            if (replace === void 0) { replace = false; }
            var newParams = replace ? params : extend({}, this._params, params);
            return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
        };
        /**
         * Returns a copy of this TargetState, using the specified Transition Options.
         *
         * @param options the new options to use
         * @param replace When false (default) the new options will be merged with the current options.
         *                When true the options will be used instead of the current options.
         */
        TargetState.prototype.withOptions = function (options, replace) {
            if (replace === void 0) { replace = false; }
            var newOpts = replace ? options : extend({}, this._options, options);
            return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
        };
        /** Returns true if the object has a state property that might be a state or state name */
        TargetState.isDef = function (obj) {
            return obj && obj.state && (isString(obj.state) || (isObject(obj.state) && isString(obj.state.name)));
        };
        return TargetState;
    }());

    /**
     * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
     */
    var PathUtils = /** @class */ (function () {
        function PathUtils() {
        }
        /** Given a PathNode[], create an TargetState */
        PathUtils.makeTargetState = function (registry, path) {
            var state = tail(path).state;
            return new TargetState(registry, state, path.map(prop('paramValues')).reduce(mergeR, {}), {});
        };
        PathUtils.buildPath = function (targetState) {
            var toParams = targetState.params();
            return targetState.$state().path.map(function (state) { return new PathNode(state).applyRawParams(toParams); });
        };
        /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
        PathUtils.buildToPath = function (fromPath, targetState) {
            var toPath = PathUtils.buildPath(targetState);
            if (targetState.options().inherit) {
                return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
            }
            return toPath;
        };
        /**
         * Creates ViewConfig objects and adds to nodes.
         *
         * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
         */
        PathUtils.applyViewConfigs = function ($view, path, states) {
            // Only apply the viewConfigs to the nodes for the given states
            path
                .filter(function (node) { return inArray(states, node.state); })
                .forEach(function (node) {
                var viewDecls = values(node.state.views || {});
                var subPath = PathUtils.subPath(path, function (n) { return n === node; });
                var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
                node.views = viewConfigs.reduce(unnestR, []);
            });
        };
        /**
         * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
         *
         * For a parameter in a node to be inherited from the from path:
         * - The toPath's node must have a matching node in the fromPath (by state).
         * - The parameter name must not be found in the toKeys parameter array.
         *
         * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
         * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
         * it is not inherited from the fromPath.
         */
        PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
            if (toKeys === void 0) { toKeys = []; }
            function nodeParamVals(path, state) {
                var node = find(path, propEq('state', state));
                return extend({}, node && node.paramValues);
            }
            var noInherit = fromPath
                .map(function (node) { return node.paramSchema; })
                .reduce(unnestR, [])
                .filter(function (param) { return !param.inherit; })
                .map(prop('id'));
            /**
             * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
             * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
             */
            function makeInheritedParamsNode(toNode) {
                // All param values for the node (may include default key/vals, when key was not found in toParams)
                var toParamVals = extend({}, toNode && toNode.paramValues);
                // limited to only those keys found in toParams
                var incomingParamVals = pick(toParamVals, toKeys);
                toParamVals = omit(toParamVals, toKeys);
                var fromParamVals = omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
                // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
                var ownParamVals = extend(toParamVals, fromParamVals, incomingParamVals);
                return new PathNode(toNode.state).applyRawParams(ownParamVals);
            }
            // The param keys specified by the incoming toParams
            return toPath.map(makeInheritedParamsNode);
        };
        /**
         * Computes the tree changes (entering, exiting) between a fromPath and toPath.
         */
        PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
            var max = Math.min(fromPath.length, toPath.length);
            var keep = 0;
            var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
            while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
                keep++;
            }
            /** Given a retained node, return a new node which uses the to node's param values */
            function applyToParams(retainedNode, idx) {
                var cloned = retainedNode.clone();
                cloned.paramValues = toPath[idx].paramValues;
                return cloned;
            }
            var from, retained, exiting, entering, to;
            from = fromPath;
            retained = from.slice(0, keep);
            exiting = from.slice(keep);
            // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
            var retainedWithToParams = retained.map(applyToParams);
            entering = toPath.slice(keep);
            to = retainedWithToParams.concat(entering);
            return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
        };
        /**
         * Returns a new path which is: the subpath of the first path which matches the second path.
         *
         * The new path starts from root and contains any nodes that match the nodes in the second path.
         * It stops before the first non-matching node.
         *
         * Nodes are compared using their state property and their parameter values.
         * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
         *
         * @param pathA the first path
         * @param pathB the second path
         * @param paramsFn a function which returns the parameters to consider when comparing
         *
         * @returns an array of PathNodes from the first path which match the nodes in the second path
         */
        PathUtils.matching = function (pathA, pathB, paramsFn) {
            var done = false;
            var tuples = arrayTuples(pathA, pathB);
            return tuples.reduce(function (matching, _a) {
                var nodeA = _a[0], nodeB = _a[1];
                done = done || !nodeA.equals(nodeB, paramsFn);
                return done ? matching : matching.concat(nodeA);
            }, []);
        };
        /**
         * Returns true if two paths are identical.
         *
         * @param pathA
         * @param pathB
         * @param paramsFn a function which returns the parameters to consider when comparing
         * @returns true if the the states and parameter values for both paths are identical
         */
        PathUtils.equals = function (pathA, pathB, paramsFn) {
            return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
        };
        /**
         * Return a subpath of a path, which stops at the first matching node
         *
         * Given an array of nodes, returns a subset of the array starting from the first node,
         * stopping when the first node matches the predicate.
         *
         * @param path a path of [[PathNode]]s
         * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
         * @returns a subpath up to the matching node, or undefined if no match is found
         */
        PathUtils.subPath = function (path, predicate) {
            var node = find(path, predicate);
            var elementIdx = path.indexOf(node);
            return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
        };
        PathUtils.nonDynamicParams = function (node) {
            return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
        };
        /** Gets the raw parameter values from a path */
        PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return extend(acc, node.paramValues); }, {}); };
        return PathUtils;
    }());

    var resolvePolicies = {
        when: {
            LAZY: 'LAZY',
            EAGER: 'EAGER',
        },
        async: {
            WAIT: 'WAIT',
            NOWAIT: 'NOWAIT',
        },
    };

    // TODO: explicitly make this user configurable
    var defaultResolvePolicy = {
        when: 'LAZY',
        async: 'WAIT',
    };
    /**
     * The basic building block for the resolve system.
     *
     * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
     * and the unwrapped-when-complete (.data) result of the resolveFn.
     *
     * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
     * resolveFn) and returns the resulting promise.
     *
     * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
     * parameter to those fns.
     */
    var Resolvable = /** @class */ (function () {
        function Resolvable(arg1, resolveFn, deps, policy, data) {
            this.resolved = false;
            this.promise = undefined;
            if (arg1 instanceof Resolvable) {
                extend(this, arg1);
            }
            else if (isFunction(resolveFn)) {
                if (isNullOrUndefined(arg1))
                    throw new Error('new Resolvable(): token argument is required');
                if (!isFunction(resolveFn))
                    throw new Error('new Resolvable(): resolveFn argument must be a function');
                this.token = arg1;
                this.policy = policy;
                this.resolveFn = resolveFn;
                this.deps = deps || [];
                this.data = data;
                this.resolved = data !== undefined;
                this.promise = this.resolved ? services.$q.when(this.data) : undefined;
            }
            else if (isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
                var literal = arg1;
                return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
            }
        }
        Resolvable.prototype.getPolicy = function (state) {
            var thisPolicy = this.policy || {};
            var statePolicy = (state && state.resolvePolicy) || {};
            return {
                when: thisPolicy.when || statePolicy.when || defaultResolvePolicy.when,
                async: thisPolicy.async || statePolicy.async || defaultResolvePolicy.async,
            };
        };
        /**
         * Asynchronously resolve this Resolvable's data
         *
         * Given a ResolveContext that this Resolvable is found in:
         * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
         * and update the Resolvable's state
         */
        Resolvable.prototype.resolve = function (resolveContext, trans) {
            var _this = this;
            var $q = services.$q;
            // Gets all dependencies from ResolveContext and wait for them to be resolved
            var getResolvableDependencies = function () {
                return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
            };
            // Invokes the resolve function passing the resolved dependencies as arguments
            var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
            var node = resolveContext.findNode(this);
            var state = node && node.state;
            var asyncPolicy = this.getPolicy(state).async;
            var customAsyncPolicy = isFunction(asyncPolicy) ? asyncPolicy : identity;
            // After the final value has been resolved, update the state of the Resolvable
            var applyResolvedValue = function (resolvedValue) {
                _this.data = resolvedValue;
                _this.resolved = true;
                _this.resolveFn = null;
                trace.traceResolvableResolved(_this, trans);
                return _this.data;
            };
            // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
            return (this.promise = $q
                .when()
                .then(getResolvableDependencies)
                .then(invokeResolveFn)
                .then(customAsyncPolicy)
                .then(applyResolvedValue));
        };
        /**
         * Gets a promise for this Resolvable's data.
         *
         * Fetches the data and returns a promise.
         * Returns the existing promise if it has already been fetched once.
         */
        Resolvable.prototype.get = function (resolveContext, trans) {
            return this.promise || this.resolve(resolveContext, trans);
        };
        Resolvable.prototype.toString = function () {
            return "Resolvable(token: " + stringify(this.token) + ", requires: [" + this.deps.map(stringify) + "])";
        };
        Resolvable.prototype.clone = function () {
            return new Resolvable(this);
        };
        Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
        return Resolvable;
    }());

    var whens = resolvePolicies.when;
    var ALL_WHENS = [whens.EAGER, whens.LAZY];
    var EAGER_WHENS = [whens.EAGER];
    // tslint:disable-next-line:no-inferrable-types
    var NATIVE_INJECTOR_TOKEN = 'Native Injector';
    /**
     * Encapsulates Dependency Injection for a path of nodes
     *
     * UI-Router states are organized as a tree.
     * A nested state has a path of ancestors to the root of the tree.
     * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
     * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
     *
     * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
     */
    var ResolveContext = /** @class */ (function () {
        function ResolveContext(_path) {
            this._path = _path;
        }
        /** Gets all the tokens found in the resolve context, de-duplicated */
        ResolveContext.prototype.getTokens = function () {
            return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(uniqR, []);
        };
        /**
         * Gets the Resolvable that matches the token
         *
         * Gets the last Resolvable that matches the token in this context, or undefined.
         * Throws an error if it doesn't exist in the ResolveContext
         */
        ResolveContext.prototype.getResolvable = function (token) {
            var matching = this._path
                .map(function (node) { return node.resolvables; })
                .reduce(unnestR, [])
                .filter(function (r) { return r.token === token; });
            return tail(matching);
        };
        /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
        ResolveContext.prototype.getPolicy = function (resolvable) {
            var node = this.findNode(resolvable);
            return resolvable.getPolicy(node.state);
        };
        /**
         * Returns a ResolveContext that includes a portion of this one
         *
         * Given a state, this method creates a new ResolveContext from this one.
         * The new context starts at the first node (root) and stops at the node for the `state` parameter.
         *
         * #### Why
         *
         * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
         * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
         * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
         * This method is used to create a narrower context when injecting ancestor nodes.
         *
         * @example
         * `let ABCD = new ResolveContext([A, B, C, D]);`
         *
         * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
         * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
         * However, `B` should only be able to access resolvables from `A`, `B`.
         *
         * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
         * `let AB = ABCD.subcontext(a)`
         */
        ResolveContext.prototype.subContext = function (state) {
            return new ResolveContext(PathUtils.subPath(this._path, function (node) { return node.state === state; }));
        };
        /**
         * Adds Resolvables to the node that matches the state
         *
         * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
         * The resolvable is added to the node matching the `state` parameter.
         *
         * These new resolvables are not automatically fetched.
         * The calling code should either fetch them, fetch something that depends on them,
         * or rely on [[resolvePath]] being called when some state is being entered.
         *
         * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
         *
         * @param newResolvables the new Resolvables
         * @param state Used to find the node to put the resolvable on
         */
        ResolveContext.prototype.addResolvables = function (newResolvables, state) {
            var node = find(this._path, propEq('state', state));
            var keys = newResolvables.map(function (r) { return r.token; });
            node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
        };
        /**
         * Returns a promise for an array of resolved path Element promises
         *
         * @param when
         * @param trans
         * @returns {Promise<any>|any}
         */
        ResolveContext.prototype.resolvePath = function (when, trans) {
            var _this = this;
            if (when === void 0) { when = 'LAZY'; }
            // This option determines which 'when' policy Resolvables we are about to fetch.
            var whenOption = inArray(ALL_WHENS, when) ? when : 'LAZY';
            // If the caller specified EAGER, only the EAGER Resolvables are fetched.
            // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
            var matchedWhens = whenOption === resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
            // get the subpath to the state argument, if provided
            trace.traceResolvePath(this._path, when, trans);
            var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
                return inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
            }; };
            // Trigger all the (matching) Resolvables in the path
            // Reduce all the "WAIT" Resolvables into an array
            var promises = this._path.reduce(function (acc, node) {
                var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
                var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
                var wait = nodeResolvables.filter(not(matchesPolicy(['NOWAIT'], 'async')));
                // For the matching Resolvables, start their async fetch process.
                var subContext = _this.subContext(node.state);
                var getResult = function (r) {
                    return r
                        .get(subContext, trans)
                        // Return a tuple that includes the Resolvable's token
                        .then(function (value) { return ({ token: r.token, value: value }); });
                };
                nowait.forEach(getResult);
                return acc.concat(wait.map(getResult));
            }, []);
            // Wait for all the "WAIT" resolvables
            return services.$q.all(promises);
        };
        ResolveContext.prototype.injector = function () {
            return this._injector || (this._injector = new UIInjectorImpl(this));
        };
        ResolveContext.prototype.findNode = function (resolvable) {
            return find(this._path, function (node) { return inArray(node.resolvables, resolvable); });
        };
        /**
         * Gets the async dependencies of a Resolvable
         *
         * Given a Resolvable, returns its dependencies as a Resolvable[]
         */
        ResolveContext.prototype.getDependencies = function (resolvable) {
            var _this = this;
            var node = this.findNode(resolvable);
            // Find which other resolvables are "visible" to the `resolvable` argument
            // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
            var subPath = PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
            var availableResolvables = subPath
                .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
                .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
            var getDependency = function (token) {
                var matching = availableResolvables.filter(function (r) { return r.token === token; });
                if (matching.length)
                    return tail(matching);
                var fromInjector = _this.injector().getNative(token);
                if (isUndefined(fromInjector)) {
                    throw new Error('Could not find Dependency Injection token: ' + stringify(token));
                }
                return new Resolvable(token, function () { return fromInjector; }, [], fromInjector);
            };
            return resolvable.deps.map(getDependency);
        };
        return ResolveContext;
    }());
    /** @internal */
    var UIInjectorImpl = /** @class */ (function () {
        function UIInjectorImpl(context) {
            this.context = context;
            this.native = this.get(NATIVE_INJECTOR_TOKEN) || services.$injector;
        }
        UIInjectorImpl.prototype.get = function (token) {
            var resolvable = this.context.getResolvable(token);
            if (resolvable) {
                if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
                    return resolvable.get(this.context);
                }
                if (!resolvable.resolved) {
                    throw new Error('Resolvable async .get() not complete:' + stringify(resolvable.token));
                }
                return resolvable.data;
            }
            return this.getNative(token);
        };
        UIInjectorImpl.prototype.getAsync = function (token) {
            var resolvable = this.context.getResolvable(token);
            if (resolvable)
                return resolvable.get(this.context);
            return services.$q.when(this.native.get(token));
        };
        UIInjectorImpl.prototype.getNative = function (token) {
            return this.native && this.native.get(token);
        };
        return UIInjectorImpl;
    }());

    var parseUrl = function (url) {
        if (!isString(url))
            return false;
        var root = url.charAt(0) === '^';
        return { val: root ? url.substring(1) : url, root: root };
    };
    function nameBuilder(state) {
        return state.name;
    }
    function selfBuilder(state) {
        state.self.$$state = function () { return state; };
        return state.self;
    }
    function dataBuilder(state) {
        if (state.parent && state.parent.data) {
            state.data = state.self.data = inherit(state.parent.data, state.data);
        }
        return state.data;
    }
    var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
        return function urlBuilder(stateObject) {
            var stateDec = stateObject.self;
            // For future states, i.e., states whose name ends with `.**`,
            // match anything that starts with the url prefix
            if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
                var newStateDec = {};
                copy(stateDec, newStateDec);
                newStateDec.url += '{remainder:any}'; // match any path (.*)
                stateDec = newStateDec;
            }
            var parent = stateObject.parent;
            var parsed = parseUrl(stateDec.url);
            var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
            if (!url)
                return null;
            if (!$urlMatcherFactoryProvider.isMatcher(url))
                throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
            return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
        };
    };
    var getNavigableBuilder = function (isRoot) {
        return function navigableBuilder(state) {
            return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
        };
    };
    var getParamsBuilder = function (paramFactory) {
        return function paramsBuilder(state) {
            var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
            var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
            var nonUrlParams = values(mapObj(omit(state.params || {}, urlParams.map(prop('id'))), makeConfigParam));
            return urlParams
                .concat(nonUrlParams)
                .map(function (p) { return [p.id, p]; })
                .reduce(applyPairs, {});
        };
    };
    function pathBuilder(state) {
        return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
    }
    function includesBuilder(state) {
        var includes = state.parent ? extend({}, state.parent.includes) : {};
        includes[state.name] = true;
        return includes;
    }
    /**
     * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
     *
     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
     * validates the `resolve` property and converts it to a [[Resolvable]] array.
     *
     * resolve: input value can be:
     *
     * {
     *   // analyzed but not injected
     *   myFooResolve: function() { return "myFooData"; },
     *
     *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
     *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
     *
     *   // Array split; "DependencyName" dep as string
     *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
     *
     *   // Array split; DependencyType dep as token (compared using ===)
     *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
     *
     *   // val.$inject used as deps
     *   // where:
     *   //     corgeResolve.$inject = ["DependencyName"];
     *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
     *   // then "DependencyName" dep as string
     *   myCorgeResolve: corgeResolve,
     *
     *  // inject service by name
     *  // When a string is found, desugar creating a resolve that injects the named service
     *   myGraultResolve: "SomeService"
     * }
     *
     * or:
     *
     * [
     *   new Resolvable("myFooResolve", function() { return "myFooData" }),
     *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
     *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
     * ]
     */
    function resolvablesBuilder(state) {
        /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
        var objects2Tuples = function (resolveObj, resolvePolicies) {
            return Object.keys(resolveObj || {}).map(function (token) { return ({
                token: token,
                val: resolveObj[token],
                deps: undefined,
                policy: resolvePolicies[token],
            }); });
        };
        /** fetch DI annotations from a function or ng1-style array */
        var annotate = function (fn) {
            var $injector = services.$injector;
            // ng1 doesn't have an $injector until runtime.
            // If the $injector doesn't exist, use "deferred" literal as a
            // marker indicating they should be annotated when runtime starts
            return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
        };
        /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
        var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
        /** true if the object looks like a provide literal, or a ng2 Provider */
        var isLikeNg2Provider = function (obj) {
            return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
        };
        /** true if the object looks like a tuple from obj2Tuples */
        var isTupleFromObj = function (obj) {
            return !!(obj && obj.val && (isString(obj.val) || isArray(obj.val) || isFunction(obj.val)));
        };
        /** extracts the token from a Provider or provide literal */
        var getToken = function (p) { return p.provide || p.token; };
        // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
        var literal2Resolvable = pattern([
            [prop('resolveFn'), function (p) { return new Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
            [prop('useFactory'), function (p) { return new Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
            [prop('useClass'), function (p) { return new Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
            [prop('useValue'), function (p) { return new Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
            [prop('useExisting'), function (p) { return new Resolvable(getToken(p), identity, [p.useExisting], p.policy); }],
        ]);
        // prettier-ignore
        var tuple2Resolvable = pattern([
            [pipe(prop('val'), isString), function (tuple) { return new Resolvable(tuple.token, identity, [tuple.val], tuple.policy); }],
            [pipe(prop('val'), isArray), function (tuple) { return new Resolvable(tuple.token, tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
            [pipe(prop('val'), isFunction), function (tuple) { return new Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
        ]);
        // prettier-ignore
        var item2Resolvable = pattern([
            [is(Resolvable), function (r) { return r; }],
            [isResolveLiteral, literal2Resolvable],
            [isLikeNg2Provider, literal2Resolvable],
            [isTupleFromObj, tuple2Resolvable],
            [val(true), function (obj) { throw new Error('Invalid resolve value: ' + stringify(obj)); },],
        ]);
        // If resolveBlock is already an array, use it as-is.
        // Otherwise, assume it's an object and convert to an Array of tuples
        var decl = state.resolve;
        var items = isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
        return items.map(item2Resolvable);
    }
    /**
     * A internal global service
     *
     * StateBuilder is a factory for the internal [[StateObject]] objects.
     *
     * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
     * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
     * [[StateObject]] object, which has an API and is used internally.
     *
     * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
     * using the [[builder]] method.
     */
    var StateBuilder = /** @class */ (function () {
        function StateBuilder(matcher, urlMatcherFactory) {
            this.matcher = matcher;
            var self = this;
            var root = function () { return matcher.find(''); };
            var isRoot = function (state) { return state.name === ''; };
            function parentBuilder(state) {
                if (isRoot(state))
                    return null;
                return matcher.find(self.parentName(state)) || root();
            }
            this.builders = {
                name: [nameBuilder],
                self: [selfBuilder],
                parent: [parentBuilder],
                data: [dataBuilder],
                // Build a URLMatcher if necessary, either via a relative or absolute URL
                url: [getUrlBuilder(urlMatcherFactory, root)],
                // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
                navigable: [getNavigableBuilder(isRoot)],
                params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
                // Each framework-specific ui-router implementation should define its own `views` builder
                // e.g., src/ng1/statebuilders/views.ts
                views: [],
                // Keep a full path from the root down to this state as this is needed for state activation.
                path: [pathBuilder],
                // Speed up $state.includes() as it's used a lot
                includes: [includesBuilder],
                resolvables: [resolvablesBuilder],
            };
        }
        StateBuilder.prototype.builder = function (name, fn) {
            var builders = this.builders;
            var array = builders[name] || [];
            // Backwards compat: if only one builder exists, return it, else return whole arary.
            if (isString(name) && !isDefined(fn))
                return array.length > 1 ? array : array[0];
            if (!isString(name) || !isFunction(fn))
                return;
            builders[name] = array;
            builders[name].push(fn);
            return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
        };
        /**
         * Builds all of the properties on an essentially blank State object, returning a State object which has all its
         * properties and API built.
         *
         * @param state an uninitialized State object
         * @returns the built State object
         */
        StateBuilder.prototype.build = function (state) {
            var _a = this, matcher = _a.matcher, builders = _a.builders;
            var parent = this.parentName(state);
            if (parent && !matcher.find(parent, undefined, false)) {
                return null;
            }
            for (var key in builders) {
                if (!builders.hasOwnProperty(key))
                    continue;
                var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, noop);
                state[key] = chain(state);
            }
            return state;
        };
        StateBuilder.prototype.parentName = function (state) {
            // name = 'foo.bar.baz.**'
            var name = state.name || '';
            // segments = ['foo', 'bar', 'baz', '.**']
            var segments = name.split('.');
            // segments = ['foo', 'bar', 'baz']
            var lastSegment = segments.pop();
            // segments = ['foo', 'bar'] (ignore .** segment for future states)
            if (lastSegment === '**')
                segments.pop();
            if (segments.length) {
                if (state.parent) {
                    throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
                }
                // 'foo.bar'
                return segments.join('.');
            }
            if (!state.parent)
                return '';
            return isString(state.parent) ? state.parent : state.parent.name;
        };
        StateBuilder.prototype.name = function (state) {
            var name = state.name;
            if (name.indexOf('.') !== -1 || !state.parent)
                return name;
            var parentName = isString(state.parent) ? state.parent : state.parent.name;
            return parentName ? parentName + '.' + name : name;
        };
        return StateBuilder;
    }());

    /**
     * Internal representation of a UI-Router state.
     *
     * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
     *
     * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
     *
     * This class prototypally inherits from the corresponding [[StateDeclaration]].
     * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
     */
    var StateObject = /** @class */ (function () {
        /** @deprecated use State.create() */
        function StateObject(config) {
            return StateObject.create(config || {});
        }
        /**
         * Create a state object to put the private/internal implementation details onto.
         * The object's prototype chain looks like:
         * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
         *
         * @param stateDecl the user-supplied State Declaration
         * @returns {StateObject} an internal State object
         */
        StateObject.create = function (stateDecl) {
            stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
            var state = inherit(inherit(stateDecl, StateObject.prototype));
            stateDecl.$$state = function () { return state; };
            state.self = stateDecl;
            state.__stateObjectCache = {
                nameGlob: Glob.fromString(state.name),
            };
            return state;
        };
        /**
         * Returns true if the provided parameter is the same state.
         *
         * Compares the identity of the state against the passed value, which is either an object
         * reference to the actual `State` instance, the original definition object passed to
         * `$stateProvider.state()`, or the fully-qualified name.
         *
         * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
         *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
         * @returns Returns `true` if `ref` matches the current `State` instance.
         */
        StateObject.prototype.is = function (ref) {
            return this === ref || this.self === ref || this.fqn() === ref;
        };
        /**
         * @deprecated this does not properly handle dot notation
         * @returns Returns a dot-separated name of the state.
         */
        StateObject.prototype.fqn = function () {
            if (!this.parent || !(this.parent instanceof this.constructor))
                return this.name;
            var name = this.parent.fqn();
            return name ? name + '.' + this.name : this.name;
        };
        /**
         * Returns the root node of this state's tree.
         *
         * @returns The root of this state's tree.
         */
        StateObject.prototype.root = function () {
            return (this.parent && this.parent.root()) || this;
        };
        /**
         * Gets the state's `Param` objects
         *
         * Gets the list of [[Param]] objects owned by the state.
         * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
         * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
         *
         * @param opts options
         */
        StateObject.prototype.parameters = function (opts) {
            opts = defaults(opts, { inherit: true, matchingKeys: null });
            var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
            return inherited
                .concat(values(this.params))
                .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
        };
        /**
         * Returns a single [[Param]] that is owned by the state
         *
         * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
         * @param id the name of the [[Param]] to return
         * @param opts options
         */
        StateObject.prototype.parameter = function (id, opts) {
            if (opts === void 0) { opts = {}; }
            return ((this.url && this.url.parameter(id, opts)) ||
                find(values(this.params), propEq('id', id)) ||
                (opts.inherit && this.parent && this.parent.parameter(id)));
        };
        StateObject.prototype.toString = function () {
            return this.fqn();
        };
        /** Predicate which returns true if the object is an class with @State() decorator */
        StateObject.isStateClass = function (stateDecl) {
            return isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
        };
        /** Predicate which returns true if the object is a [[StateDeclaration]] object */
        StateObject.isStateDeclaration = function (obj) { return isFunction(obj['$$state']); };
        /** Predicate which returns true if the object is an internal [[StateObject]] object */
        StateObject.isState = function (obj) { return isObject(obj['__stateObjectCache']); };
        return StateObject;
    }());

    var StateMatcher = /** @class */ (function () {
        function StateMatcher(_states) {
            this._states = _states;
        }
        StateMatcher.prototype.isRelative = function (stateName) {
            stateName = stateName || '';
            return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
        };
        StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
            if (matchGlob === void 0) { matchGlob = true; }
            if (!stateOrName && stateOrName !== '')
                return undefined;
            var isStr = isString(stateOrName);
            var name = isStr ? stateOrName : stateOrName.name;
            if (this.isRelative(name))
                name = this.resolvePath(name, base);
            var state = this._states[name];
            if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
                return state;
            }
            else if (isStr && matchGlob) {
                var _states = values(this._states);
                var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
                if (matches.length > 1) {
                    safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
                }
                return matches[0];
            }
            return undefined;
        };
        StateMatcher.prototype.resolvePath = function (name, base) {
            if (!base)
                throw new Error("No reference point given for path '" + name + "'");
            var baseState = this.find(base);
            var splitName = name.split('.');
            var pathLength = splitName.length;
            var i = 0, current = baseState;
            for (; i < pathLength; i++) {
                if (splitName[i] === '' && i === 0) {
                    current = baseState;
                    continue;
                }
                if (splitName[i] === '^') {
                    if (!current.parent)
                        throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
                    current = current.parent;
                    continue;
                }
                break;
            }
            var relName = splitName.slice(i).join('.');
            return current.name + (current.name && relName ? '.' : '') + relName;
        };
        return StateMatcher;
    }());

    var StateQueueManager = /** @class */ (function () {
        function StateQueueManager(router, states, builder, listeners) {
            this.router = router;
            this.states = states;
            this.builder = builder;
            this.listeners = listeners;
            this.queue = [];
        }
        StateQueueManager.prototype.dispose = function () {
            this.queue = [];
        };
        StateQueueManager.prototype.register = function (stateDecl) {
            var queue = this.queue;
            var state = StateObject.create(stateDecl);
            var name = state.name;
            if (!isString(name))
                throw new Error('State must have a valid name');
            if (this.states.hasOwnProperty(name) || inArray(queue.map(prop('name')), name))
                throw new Error("State '" + name + "' is already defined");
            queue.push(state);
            this.flush();
            return state;
        };
        StateQueueManager.prototype.flush = function () {
            var _this = this;
            var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
            var registered = [], // states that got registered
            orphans = [], // states that don't yet have a parent registered
            previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
            var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
            var notifyListeners = function () {
                if (registered.length) {
                    _this.listeners.forEach(function (listener) {
                        return listener('registered', registered.map(function (s) { return s.self; }));
                    });
                }
            };
            while (queue.length > 0) {
                var state = queue.shift();
                var name_1 = state.name;
                var result = builder.build(state);
                var orphanIdx = orphans.indexOf(state);
                if (result) {
                    var existingState = getState(name_1);
                    if (existingState && existingState.name === name_1) {
                        throw new Error("State '" + name_1 + "' is already defined");
                    }
                    var existingFutureState = getState(name_1 + '.**');
                    if (existingFutureState) {
                        // Remove future state of the same name
                        this.router.stateRegistry.deregister(existingFutureState);
                    }
                    states[name_1] = state;
                    this.attachRoute(state);
                    if (orphanIdx >= 0)
                        orphans.splice(orphanIdx, 1);
                    registered.push(state);
                    continue;
                }
                var prev = previousQueueLength[name_1];
                previousQueueLength[name_1] = queue.length;
                if (orphanIdx >= 0 && prev === queue.length) {
                    // Wait until two consecutive iterations where no additional states were dequeued successfully.
                    // throw new Error(`Cannot register orphaned state '${name}'`);
                    queue.push(state);
                    notifyListeners();
                    return states;
                }
                else if (orphanIdx < 0) {
                    orphans.push(state);
                }
                queue.push(state);
            }
            notifyListeners();
            return states;
        };
        StateQueueManager.prototype.attachRoute = function (state) {
            if (state.abstract || !state.url)
                return;
            var rulesApi = this.router.urlService.rules;
            rulesApi.rule(rulesApi.urlRuleFactory.create(state));
        };
        return StateQueueManager;
    }());

    /**
     * A registry for all of the application's [[StateDeclaration]]s
     *
     * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
     */
    var StateRegistry = /** @class */ (function () {
        /** @internal */
        function StateRegistry(router) {
            this.router = router;
            this.states = {};
            /** @internal */
            this.listeners = [];
            this.matcher = new StateMatcher(this.states);
            this.builder = new StateBuilder(this.matcher, router.urlMatcherFactory);
            this.stateQueue = new StateQueueManager(router, this.states, this.builder, this.listeners);
            this._registerRoot();
        }
        /** @internal */
        StateRegistry.prototype._registerRoot = function () {
            var rootStateDef = {
                name: '',
                url: '^',
                views: null,
                params: {
                    '#': { value: null, type: 'hash', dynamic: true },
                },
                abstract: true,
            };
            var _root = (this._root = this.stateQueue.register(rootStateDef));
            _root.navigable = null;
        };
        /** @internal */
        StateRegistry.prototype.dispose = function () {
            var _this = this;
            this.stateQueue.dispose();
            this.listeners = [];
            this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
        };
        /**
         * Listen for a State Registry events
         *
         * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
         *
         * #### Example:
         * ```js
         * let allStates = registry.get();
         *
         * // Later, invoke deregisterFn() to remove the listener
         * let deregisterFn = registry.onStatesChanged((event, states) => {
         *   switch(event) {
         *     case: 'registered':
         *       states.forEach(state => allStates.push(state));
         *       break;
         *     case: 'deregistered':
         *       states.forEach(state => {
         *         let idx = allStates.indexOf(state);
         *         if (idx !== -1) allStates.splice(idx, 1);
         *       });
         *       break;
         *   }
         * });
         * ```
         *
         * @param listener a callback function invoked when the registered states changes.
         *        The function receives two parameters, `event` and `state`.
         *        See [[StateRegistryListener]]
         * @return a function that deregisters the listener
         */
        StateRegistry.prototype.onStatesChanged = function (listener) {
            this.listeners.push(listener);
            return function deregisterListener() {
                removeFrom(this.listeners)(listener);
            }.bind(this);
        };
        /**
         * Gets the implicit root state
         *
         * Gets the root of the state tree.
         * The root state is implicitly created by UI-Router.
         * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
         *
         * @return the root [[StateObject]]
         */
        StateRegistry.prototype.root = function () {
            return this._root;
        };
        /**
         * Adds a state to the registry
         *
         * Registers a [[StateDeclaration]] or queues it for registration.
         *
         * Note: a state will be queued if the state's parent isn't yet registered.
         *
         * @param stateDefinition the definition of the state to register.
         * @returns the internal [[StateObject]] object.
         *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
         *          If the state was only queued, then the object is not fully built.
         */
        StateRegistry.prototype.register = function (stateDefinition) {
            return this.stateQueue.register(stateDefinition);
        };
        /** @internal */
        StateRegistry.prototype._deregisterTree = function (state) {
            var _this = this;
            var all = this.get().map(function (s) { return s.$$state(); });
            var getChildren = function (states) {
                var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
                return _children.length === 0 ? _children : _children.concat(getChildren(_children));
            };
            var children = getChildren([state]);
            var deregistered = [state].concat(children).reverse();
            deregistered.forEach(function (_state) {
                var rulesApi = _this.router.urlService.rules;
                // Remove URL rule
                rulesApi
                    .rules()
                    .filter(propEq('state', _state))
                    .forEach(function (rule) { return rulesApi.removeRule(rule); });
                // Remove state from registry
                delete _this.states[_state.name];
            });
            return deregistered;
        };
        /**
         * Removes a state from the registry
         *
         * This removes a state from the registry.
         * If the state has children, they are are also removed from the registry.
         *
         * @param stateOrName the state's name or object representation
         * @returns {StateObject[]} a list of removed states
         */
        StateRegistry.prototype.deregister = function (stateOrName) {
            var _state = this.get(stateOrName);
            if (!_state)
                throw new Error("Can't deregister state; not found: " + stateOrName);
            var deregisteredStates = this._deregisterTree(_state.$$state());
            this.listeners.forEach(function (listener) {
                return listener('deregistered', deregisteredStates.map(function (s) { return s.self; }));
            });
            return deregisteredStates;
        };
        StateRegistry.prototype.get = function (stateOrName, base) {
            var _this = this;
            if (arguments.length === 0)
                return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
            var found = this.matcher.find(stateOrName, base);
            return (found && found.self) || null;
        };
        /**
         * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
         * More than one BuilderFunction can be registered for a given property.
         *
         * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
         *
         * @param property The name of the State property being registered for.
         * @param builderFunction The BuilderFunction which will be used to build the State property
         * @returns a function which deregisters the BuilderFunction
         */
        StateRegistry.prototype.decorator = function (property, builderFunction) {
            return this.builder.builder(property, builderFunction);
        };
        return StateRegistry;
    }());

    (function (TransitionHookPhase) {
        TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
        TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
        TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
        TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
        TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
    })(exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));

    (function (TransitionHookScope) {
        TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
        TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
    })(exports.TransitionHookScope || (exports.TransitionHookScope = {}));

    var defaultOptions = {
        current: noop,
        transition: null,
        traceData: {},
        bind: null,
    };
    var TransitionHook = /** @class */ (function () {
        function TransitionHook(transition, stateContext, registeredHook, options) {
            var _this = this;
            this.transition = transition;
            this.stateContext = stateContext;
            this.registeredHook = registeredHook;
            this.options = options;
            this.isSuperseded = function () { return _this.type.hookPhase === exports.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
            this.options = defaults(options, defaultOptions);
            this.type = registeredHook.eventType;
        }
        /**
         * Chains together an array of TransitionHooks.
         *
         * Given a list of [[TransitionHook]] objects, chains them together.
         * Each hook is invoked after the previous one completes.
         *
         * #### Example:
         * ```js
         * var hooks: TransitionHook[] = getHooks();
         * let promise: Promise<any> = TransitionHook.chain(hooks);
         *
         * promise.then(handleSuccess, handleError);
         * ```
         *
         * @param hooks the list of hooks to chain together
         * @param waitFor if provided, the chain is `.then()`'ed off this promise
         * @returns a `Promise` for sequentially invoking the hooks (in order)
         */
        TransitionHook.chain = function (hooks, waitFor) {
            // Chain the next hook off the previous
            var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
            return hooks.reduce(createHookChainR, waitFor || services.$q.when());
        };
        /**
         * Invokes all the provided TransitionHooks, in order.
         * Each hook's return value is checked.
         * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
         * If no hook returns a promise, then all hooks are processed synchronously.
         *
         * @param hooks the list of TransitionHooks to invoke
         * @param doneCallback a callback that is invoked after all the hooks have successfully completed
         *
         * @returns a promise for the async result, or the result of the callback
         */
        TransitionHook.invokeHooks = function (hooks, doneCallback) {
            for (var idx = 0; idx < hooks.length; idx++) {
                var hookResult = hooks[idx].invokeHook();
                if (isPromise(hookResult)) {
                    var remainingHooks = hooks.slice(idx + 1);
                    return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
                }
            }
            return doneCallback();
        };
        /**
         * Run all TransitionHooks, ignoring their return value.
         */
        TransitionHook.runAllHooks = function (hooks) {
            hooks.forEach(function (hook) { return hook.invokeHook(); });
        };
        TransitionHook.prototype.logError = function (err) {
            this.transition.router.stateService.defaultErrorHandler()(err);
        };
        TransitionHook.prototype.invokeHook = function () {
            var _this = this;
            var hook = this.registeredHook;
            if (hook._deregistered)
                return;
            var notCurrent = this.getNotCurrentRejection();
            if (notCurrent)
                return notCurrent;
            var options = this.options;
            trace.traceHookInvocation(this, this.transition, options);
            var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
            var normalizeErr = function (err) { return Rejection.normalize(err).toPromise(); };
            var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
            var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
            try {
                var result = invokeCallback();
                if (!this.type.synchronous && isPromise(result)) {
                    return result.catch(normalizeErr).then(handleResult, handleError);
                }
                else {
                    return handleResult(result);
                }
            }
            catch (err) {
                // If callback throws (synchronously)
                return handleError(Rejection.normalize(err));
            }
            finally {
                if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
                    hook.deregister();
                }
            }
        };
        /**
         * This method handles the return value of a Transition Hook.
         *
         * A hook can return false (cancel), a TargetState (redirect),
         * or a promise (which may later resolve to false or a redirect)
         *
         * This also handles "transition superseded" -- when a new transition
         * was started while the hook was still running
         */
        TransitionHook.prototype.handleHookResult = function (result) {
            var _this = this;
            var notCurrent = this.getNotCurrentRejection();
            if (notCurrent)
                return notCurrent;
            // Hook returned a promise
            if (isPromise(result)) {
                // Wait for the promise, then reprocess with the resulting value
                return result.then(function (val) { return _this.handleHookResult(val); });
            }
            trace.traceHookResult(result, this.transition, this.options);
            // Hook returned false
            if (result === false) {
                // Abort this Transition
                return Rejection.aborted('Hook aborted transition').toPromise();
            }
            var isTargetState = is(TargetState);
            // hook returned a TargetState
            if (isTargetState(result)) {
                // Halt the current Transition and redirect (a new Transition) to the TargetState.
                return Rejection.redirected(result).toPromise();
            }
        };
        /**
         * Return a Rejection promise if the transition is no longer current due
         * to a stopped router (disposed), or a new transition has started and superseded this one.
         */
        TransitionHook.prototype.getNotCurrentRejection = function () {
            var router = this.transition.router;
            // The router is stopped
            if (router._disposed) {
                return Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
            }
            if (this.transition._aborted) {
                return Rejection.aborted().toPromise();
            }
            // This transition is no longer current.
            // Another transition started while this hook was still running.
            if (this.isSuperseded()) {
                // Abort this transition
                return Rejection.superseded(this.options.current()).toPromise();
            }
        };
        TransitionHook.prototype.toString = function () {
            var _a = this, options = _a.options, registeredHook = _a.registeredHook;
            var event = parse('traceData.hookType')(options) || 'internal', context = parse('traceData.context.state.name')(options) || parse('traceData.context')(options) || 'unknown', name = fnToString(registeredHook.callback);
            return event + " context: " + context + ", " + maxLength(200, name);
        };
        /**
         * These GetResultHandler(s) are used by [[invokeHook]] below
         * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
         */
        TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
            return hook.handleHookResult(result);
        }; };
        /**
         * If the result is a promise rejection, log it.
         * Otherwise, ignore the result.
         */
        TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
            isPromise(result) && result.catch(function (err) { return hook.logError(Rejection.normalize(err)); });
            return undefined;
        }; };
        /**
         * These GetErrorHandler(s) are used by [[invokeHook]] below
         * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
         */
        TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
        TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return silentRejection(error); }; };
        TransitionHook.THROW_ERROR = function (hook) { return function (error) {
            throw error;
        }; };
        return TransitionHook;
    }());

    /**
     * Determines if the given state matches the matchCriteria
     *
     * @internal
     *
     * @param state a State Object to test against
     * @param criterion
     * - If a string, matchState uses the string as a glob-matcher against the state name
     * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
     *   and returns a positive match if any of the globs match.
     * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
     * @returns {boolean}
     */
    function matchState(state, criterion, transition) {
        var toMatch = isString(criterion) ? [criterion] : criterion;
        function matchGlobs(_state) {
            var globStrings = toMatch;
            for (var i = 0; i < globStrings.length; i++) {
                var glob = new Glob(globStrings[i]);
                if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
                    return true;
                }
            }
            return false;
        }
        var matchFn = (isFunction(toMatch) ? toMatch : matchGlobs);
        return !!matchFn(state, transition);
    }
    /**
     * The registration data for a registered transition hook
     */
    var RegisteredHook = /** @class */ (function () {
        function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
            if (options === void 0) { options = {}; }
            this.tranSvc = tranSvc;
            this.eventType = eventType;
            this.callback = callback;
            this.matchCriteria = matchCriteria;
            this.removeHookFromRegistry = removeHookFromRegistry;
            this.invokeCount = 0;
            this._deregistered = false;
            this.priority = options.priority || 0;
            this.bind = options.bind || null;
            this.invokeLimit = options.invokeLimit;
        }
        /**
         * Gets the matching [[PathNode]]s
         *
         * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
         * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
         *
         * Returning `null` is significant to distinguish between the default
         * "match-all criterion value" of `true` compared to a `() => true` function,
         * when the nodes is an empty array.
         *
         * This is useful to allow a transition match criteria of `entering: true`
         * to still match a transition, even when `entering === []`.  Contrast that
         * with `entering: (state) => true` which only matches when a state is actually
         * being entered.
         */
        RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
            if (criterion === true)
                return nodes;
            var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
            return matching.length ? matching : null;
        };
        /**
         * Gets the default match criteria (all `true`)
         *
         * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
         *
         * ```js
         * {
         *   to: true,
         *   from: true,
         *   entering: true,
         *   exiting: true,
         *   retained: true,
         * }
         */
        RegisteredHook.prototype._getDefaultMatchCriteria = function () {
            return mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
        };
        /**
         * Gets matching nodes as [[IMatchingNodes]]
         *
         * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
         *
         * ```js
         * let matches: IMatchingNodes = {
         *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
         *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
         *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
         *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
         *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
         * };
         * ```
         */
        RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
            var _this = this;
            var criteria = extend(this._getDefaultMatchCriteria(), this.matchCriteria);
            var paths = values(this.tranSvc._pluginapi._getPathTypes());
            return paths.reduce(function (mn, pathtype) {
                // STATE scope criteria matches against every node in the path.
                // TRANSITION scope criteria matches against only the last node in the path
                var isStateHook = pathtype.scope === exports.TransitionHookScope.STATE;
                var path = treeChanges[pathtype.name] || [];
                var nodes = isStateHook ? path : [tail(path)];
                mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
                return mn;
            }, {});
        };
        /**
         * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
         *
         * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
         * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
         */
        RegisteredHook.prototype.matches = function (treeChanges, transition) {
            var matches = this._getMatchingNodes(treeChanges, transition);
            // Check if all the criteria matched the TreeChanges object
            var allMatched = values(matches).every(identity);
            return allMatched ? matches : null;
        };
        RegisteredHook.prototype.deregister = function () {
            this.removeHookFromRegistry(this);
            this._deregistered = true;
        };
        return RegisteredHook;
    }());
    /** Return a registration function of the requested type. */
    function makeEvent(registry, transitionService, eventType) {
        // Create the object which holds the registered transition hooks.
        var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
        var hooks = (_registeredHooks[eventType.name] = []);
        var removeHookFn = removeFrom(hooks);
        // Create hook registration function on the IHookRegistry for the event
        registry[eventType.name] = hookRegistrationFn;
        function hookRegistrationFn(matchObject, callback, options) {
            if (options === void 0) { options = {}; }
            var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
            hooks.push(registeredHook);
            return registeredHook.deregister.bind(registeredHook);
        }
        return hookRegistrationFn;
    }

    /**
     * This class returns applicable TransitionHooks for a specific Transition instance.
     *
     * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
     * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
     * determined by the type of hook)
     *
     * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
     *
     * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
     * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
     * in the Transition class, so we must also provide the Transition's _treeChanges)
     */
    var HookBuilder = /** @class */ (function () {
        function HookBuilder(transition) {
            this.transition = transition;
        }
        HookBuilder.prototype.buildHooksForPhase = function (phase) {
            var _this = this;
            var $transitions = this.transition.router.transitionService;
            return $transitions._pluginapi
                ._getEvents(phase)
                .map(function (type) { return _this.buildHooks(type); })
                .reduce(unnestR, [])
                .filter(identity);
        };
        /**
         * Returns an array of newly built TransitionHook objects.
         *
         * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
         * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
         * - For each of the [[PathNode]]s, creates a TransitionHook
         *
         * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
         */
        HookBuilder.prototype.buildHooks = function (hookType) {
            var transition = this.transition;
            var treeChanges = transition.treeChanges();
            // Find all the matching registered hooks for a given hook type
            var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
            if (!matchingHooks)
                return [];
            var baseHookOptions = {
                transition: transition,
                current: transition.options().current,
            };
            var makeTransitionHooks = function (hook) {
                // Fetch the Nodes that caused this hook to match.
                var matches = hook.matches(treeChanges, transition);
                // Select the PathNode[] that will be used as TransitionHook context objects
                var matchingNodes = matches[hookType.criteriaMatchPath.name];
                // Return an array of HookTuples
                return matchingNodes.map(function (node) {
                    var _options = extend({
                        bind: hook.bind,
                        traceData: { hookType: hookType.name, context: node },
                    }, baseHookOptions);
                    var state = hookType.criteriaMatchPath.scope === exports.TransitionHookScope.STATE ? node.state.self : null;
                    var transitionHook = new TransitionHook(transition, state, hook, _options);
                    return { hook: hook, node: node, transitionHook: transitionHook };
                });
            };
            return matchingHooks
                .map(makeTransitionHooks)
                .reduce(unnestR, [])
                .sort(tupleSort(hookType.reverseSort))
                .map(function (tuple) { return tuple.transitionHook; });
        };
        /**
         * Finds all RegisteredHooks from:
         * - The Transition object instance hook registry
         * - The TransitionService ($transitions) global hook registry
         *
         * which matched:
         * - the eventType
         * - the matchCriteria (to, from, exiting, retained, entering)
         *
         * @returns an array of matched [[RegisteredHook]]s
         */
        HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
            var isCreate = hookType.hookPhase === exports.TransitionHookPhase.CREATE;
            // Instance and Global hook registries
            var $transitions = this.transition.router.transitionService;
            var registries = isCreate ? [$transitions] : [this.transition, $transitions];
            return registries
                .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
                .filter(assertPredicate(isArray, "broken event named: " + hookType.name)) // Sanity check
                .reduce(unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
                .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
        };
        return HookBuilder;
    }());
    /**
     * A factory for a sort function for HookTuples.
     *
     * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
     * the EventHook priority.
     *
     * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
     * @returns a tuple sort function
     */
    function tupleSort(reverseDepthSort) {
        if (reverseDepthSort === void 0) { reverseDepthSort = false; }
        return function nodeDepthThenPriority(l, r) {
            var factor = reverseDepthSort ? -1 : 1;
            var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
            return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
        };
    }

    /** @internal */
    var stateSelf = prop('self');
    /**
     * Represents a transition between two states.
     *
     * When navigating to a state, we are transitioning **from** the current state **to** the new state.
     *
     * This object contains all contextual information about the to/from states, parameters, resolves.
     * It has information about all states being entered and exited as a result of the transition.
     */
    var Transition = /** @class */ (function () {
        /**
         * Creates a new Transition object.
         *
         * If the target state is not valid, an error is thrown.
         *
         * @internal
         *
         * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
         *        encapsulates the "from state".
         * @param targetState The target state and parameters being transitioned to (also, the transition options)
         * @param router The [[UIRouter]] instance
         * @internal
         */
        function Transition(fromPath, targetState, router) {
            var _this = this;
            /** @internal */
            this._deferred = services.$q.defer();
            /**
             * This promise is resolved or rejected based on the outcome of the Transition.
             *
             * When the transition is successful, the promise is resolved
             * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
             */
            this.promise = this._deferred.promise;
            /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
            this._registeredHooks = {};
            /** @internal */
            this._hookBuilder = new HookBuilder(this);
            /** Checks if this transition is currently active/running. */
            this.isActive = function () { return _this.router.globals.transition === _this; };
            this.router = router;
            this._targetState = targetState;
            if (!targetState.valid()) {
                throw new Error(targetState.error());
            }
            // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
            this._options = extend({ current: val(this) }, targetState.options());
            this.$id = router.transitionService._transitionCount++;
            var toPath = PathUtils.buildToPath(fromPath, targetState);
            this._treeChanges = PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
            this.createTransitionHookRegFns();
            var onCreateHooks = this._hookBuilder.buildHooksForPhase(exports.TransitionHookPhase.CREATE);
            TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
            this.applyViewConfigs(router);
        }
        /** @internal */
        Transition.prototype.onBefore = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onStart = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onExit = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onRetain = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onEnter = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onFinish = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onSuccess = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        Transition.prototype.onError = function (criteria, callback, options) {
            return;
        };
        /** @internal
         * Creates the transition-level hook registration functions
         * (which can then be used to register hooks)
         */
        Transition.prototype.createTransitionHookRegFns = function () {
            var _this = this;
            this.router.transitionService._pluginapi
                ._getEvents()
                .filter(function (type) { return type.hookPhase !== exports.TransitionHookPhase.CREATE; })
                .forEach(function (type) { return makeEvent(_this, _this.router.transitionService, type); });
        };
        /** @internal */
        Transition.prototype.getHooks = function (hookName) {
            return this._registeredHooks[hookName];
        };
        Transition.prototype.applyViewConfigs = function (router) {
            var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
            PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
        };
        /**
         * @internal
         * @returns the internal from [State] object
         */
        Transition.prototype.$from = function () {
            return tail(this._treeChanges.from).state;
        };
        /**
         * @internal
         * @returns the internal to [State] object
         */
        Transition.prototype.$to = function () {
            return tail(this._treeChanges.to).state;
        };
        /**
         * Returns the "from state"
         *
         * Returns the state that the transition is coming *from*.
         *
         * @returns The state declaration object for the Transition's ("from state").
         */
        Transition.prototype.from = function () {
            return this.$from().self;
        };
        /**
         * Returns the "to state"
         *
         * Returns the state that the transition is going *to*.
         *
         * @returns The state declaration object for the Transition's target state ("to state").
         */
        Transition.prototype.to = function () {
            return this.$to().self;
        };
        /**
         * Gets the Target State
         *
         * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
         *
         * @returns the [[TargetState]] of this Transition
         */
        Transition.prototype.targetState = function () {
            return this._targetState;
        };
        /**
         * Determines whether two transitions are equivalent.
         * @deprecated
         */
        Transition.prototype.is = function (compare) {
            if (compare instanceof Transition) {
                // TODO: Also compare parameters
                return this.is({ to: compare.$to().name, from: compare.$from().name });
            }
            return !((compare.to && !matchState(this.$to(), compare.to, this)) ||
                (compare.from && !matchState(this.$from(), compare.from, this)));
        };
        Transition.prototype.params = function (pathname) {
            if (pathname === void 0) { pathname = 'to'; }
            return Object.freeze(this._treeChanges[pathname].map(prop('paramValues')).reduce(mergeR, {}));
        };
        Transition.prototype.paramsChanged = function () {
            var fromParams = this.params('from');
            var toParams = this.params('to');
            // All the parameters declared on both the "to" and "from" paths
            var allParamDescriptors = []
                .concat(this._treeChanges.to)
                .concat(this._treeChanges.from)
                .map(function (pathNode) { return pathNode.paramSchema; })
                .reduce(flattenR, [])
                .reduce(uniqR, []);
            var changedParamDescriptors = Param.changed(allParamDescriptors, fromParams, toParams);
            return changedParamDescriptors.reduce(function (changedValues, descriptor) {
                changedValues[descriptor.id] = toParams[descriptor.id];
                return changedValues;
            }, {});
        };
        /**
         * Creates a [[UIInjector]] Dependency Injector
         *
         * Returns a Dependency Injector for the Transition's target state (to state).
         * The injector provides resolve values which the target state has access to.
         *
         * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
         *
         * #### Example:
         * ```js
         * .onEnter({ entering: 'myState' }, trans => {
         *   var myResolveValue = trans.injector().get('myResolve');
         *   // Inject a global service from the global/native injector (if it exists)
         *   var MyService = trans.injector().get('MyService');
         * })
         * ```
         *
         * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
         * You can use [[UIInjector.getAsync]] to get a promise for the data.
         * #### Example:
         * ```js
         * .onBefore({}, trans => {
         *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
         *     return myResolveValue !== 'ABORT';
         *   });
         * });
         * ```
         *
         * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
         * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
         * #### Example:
         * ```js
         * .onEnter({ to: 'foo.bar' }, trans => {
         *   // returns result of `foo` state's `myResolve` resolve
         *   // even though `foo.bar` also has a `myResolve` resolve
         *   var fooData = trans.injector('foo').get('myResolve');
         * });
         * ```
         *
         * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
         * The resolve data from the `from` path will be returned.
         * #### Example:
         * ```js
         * .onExit({ exiting: 'foo.bar' }, trans => {
         *   // Gets the resolve value of `myResolve` from the state being exited
         *   var fooData = trans.injector(null, 'from').get('myResolve');
         * });
         * ```
         *
         *
         * @param state Limits the resolves provided to only the resolves the provided state has access to.
         * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
         *
         * @returns a [[UIInjector]]
         */
        Transition.prototype.injector = function (state, pathName) {
            if (pathName === void 0) { pathName = 'to'; }
            var path = this._treeChanges[pathName];
            if (state)
                path = PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
            return new ResolveContext(path).injector();
        };
        /**
         * Gets all available resolve tokens (keys)
         *
         * This method can be used in conjunction with [[injector]] to inspect the resolve values
         * available to the Transition.
         *
         * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
         * in the Transition's [[TreeChanges.to]] path.
         *
         * #### Example:
         * This example logs all resolve values
         * ```js
         * let tokens = trans.getResolveTokens();
         * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
         * ```
         *
         * #### Example:
         * This example creates promises for each resolve value.
         * This triggers fetches of resolves (if any have not yet been fetched).
         * When all promises have all settled, it logs the resolve values.
         * ```js
         * let tokens = trans.getResolveTokens();
         * let promise = tokens.map(token => trans.injector().getAsync(token));
         * Promise.all(promises).then(values => console.log("Resolved values: " + values));
         * ```
         *
         * Note: Angular 1 users whould use `$q.all()`
         *
         * @param pathname resolve context's path name (e.g., `to` or `from`)
         *
         * @returns an array of resolve tokens (keys)
         */
        Transition.prototype.getResolveTokens = function (pathname) {
            if (pathname === void 0) { pathname = 'to'; }
            return new ResolveContext(this._treeChanges[pathname]).getTokens();
        };
        /**
         * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
         *
         * Allows a transition hook to dynamically add a Resolvable to this Transition.
         *
         * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
         *
         * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
         * If no `state` is provided then the root state is used.
         * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
         * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
         *
         * The `state` argument also scopes the resolved data.
         * The resolved data is available from the injector for that `state` and any children states.
         *
         * #### Example:
         * ```js
         * transitionService.onBefore({}, transition => {
         *   transition.addResolvable({
         *     token: 'myResolve',
         *     deps: ['MyService'],
         *     resolveFn: myService => myService.getData()
         *   });
         * });
         * ```
         *
         * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
         * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
         */
        Transition.prototype.addResolvable = function (resolvable, state) {
            if (state === void 0) { state = ''; }
            resolvable = is(Resolvable)(resolvable) ? resolvable : new Resolvable(resolvable);
            var stateName = typeof state === 'string' ? state : state.name;
            var topath = this._treeChanges.to;
            var targetNode = find(topath, function (node) { return node.state.name === stateName; });
            var resolveContext = new ResolveContext(topath);
            resolveContext.addResolvables([resolvable], targetNode.state);
        };
        /**
         * Gets the transition from which this transition was redirected.
         *
         * If the current transition is a redirect, this method returns the transition that was redirected.
         *
         * #### Example:
         * ```js
         * let transitionA = $state.go('A').transition
         * transitionA.onStart({}, () => $state.target('B'));
         * $transitions.onSuccess({ to: 'B' }, (trans) => {
         *   trans.to().name === 'B'; // true
         *   trans.redirectedFrom() === transitionA; // true
         * });
         * ```
         *
         * @returns The previous Transition, or null if this Transition is not the result of a redirection
         */
        Transition.prototype.redirectedFrom = function () {
            return this._options.redirectedFrom || null;
        };
        /**
         * Gets the original transition in a redirect chain
         *
         * A transition might belong to a long chain of multiple redirects.
         * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
         *
         * #### Example:
         * ```js
         * // states
         * registry.register({ name: 'A', redirectTo: 'B' });
         * registry.register({ name: 'B', redirectTo: 'C' });
         * registry.register({ name: 'C', redirectTo: 'D' });
         * registry.register({ name: 'D' });
         *
         * let transitionA = $state.go('A').transition
         *
         * $transitions.onSuccess({ to: 'D' }, (trans) => {
         *   trans.to().name === 'D'; // true
         *   trans.redirectedFrom().to().name === 'C'; // true
         *   trans.originalTransition() === transitionA; // true
         *   trans.originalTransition().to().name === 'A'; // true
         * });
         * ```
         *
         * @returns The original Transition that started a redirect chain
         */
        Transition.prototype.originalTransition = function () {
            var rf = this.redirectedFrom();
            return (rf && rf.originalTransition()) || this;
        };
        /**
         * Get the transition options
         *
         * @returns the options for this Transition.
         */
        Transition.prototype.options = function () {
            return this._options;
        };
        /**
         * Gets the states being entered.
         *
         * @returns an array of states that will be entered during this transition.
         */
        Transition.prototype.entering = function () {
            return map(this._treeChanges.entering, prop('state')).map(stateSelf);
        };
        /**
         * Gets the states being exited.
         *
         * @returns an array of states that will be exited during this transition.
         */
        Transition.prototype.exiting = function () {
            return map(this._treeChanges.exiting, prop('state')).map(stateSelf).reverse();
        };
        /**
         * Gets the states being retained.
         *
         * @returns an array of states that are already entered from a previous Transition, that will not be
         *    exited during this Transition
         */
        Transition.prototype.retained = function () {
            return map(this._treeChanges.retained, prop('state')).map(stateSelf);
        };
        /**
         * Get the [[ViewConfig]]s associated with this Transition
         *
         * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
         * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
         *
         * @param pathname the name of the path to fetch views for:
         *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
         * @param state If provided, only returns the `ViewConfig`s for a single state in the path
         *
         * @returns a list of ViewConfig objects for the given path.
         */
        Transition.prototype.views = function (pathname, state) {
            if (pathname === void 0) { pathname = 'entering'; }
            var path = this._treeChanges[pathname];
            path = !state ? path : path.filter(propEq('state', state));
            return path.map(prop('views')).filter(identity).reduce(unnestR, []);
        };
        Transition.prototype.treeChanges = function (pathname) {
            return pathname ? this._treeChanges[pathname] : this._treeChanges;
        };
        /**
         * Creates a new transition that is a redirection of the current one.
         *
         * This transition can be returned from a [[TransitionService]] hook to
         * redirect a transition to a new state and/or set of parameters.
         *
         * @internal
         *
         * @returns Returns a new [[Transition]] instance.
         */
        Transition.prototype.redirect = function (targetState) {
            var redirects = 1, trans = this;
            // tslint:disable-next-line:no-conditional-assignment
            while ((trans = trans.redirectedFrom()) != null) {
                if (++redirects > 20)
                    throw new Error("Too many consecutive Transition redirects (20+)");
            }
            var redirectOpts = { redirectedFrom: this, source: 'redirect' };
            // If the original transition was caused by URL sync, then use { location: 'replace' }
            // on the new transition (unless the target state explicitly specifies location: false).
            // This causes the original url to be replaced with the url for the redirect target
            // so the original url disappears from the browser history.
            if (this.options().source === 'url' && targetState.options().location !== false) {
                redirectOpts.location = 'replace';
            }
            var newOptions = extend({}, this.options(), targetState.options(), redirectOpts);
            targetState = targetState.withOptions(newOptions, true);
            var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
            var originalEnteringNodes = this._treeChanges.entering;
            var redirectEnteringNodes = newTransition._treeChanges.entering;
            // --- Re-use resolve data from original transition ---
            // When redirecting from a parent state to a child state where the parent parameter values haven't changed
            // (because of the redirect), the resolves fetched by the original transition are still valid in the
            // redirected transition.
            //
            // This allows you to define a redirect on a parent state which depends on an async resolve value.
            // You can wait for the resolve, then redirect to a child state based on the result.
            // The redirected transition does not have to re-fetch the resolve.
            // ---------------------------------------------------------
            var nodeIsReloading = function (reloadState) { return function (node) {
                return reloadState && node.state.includes[reloadState.name];
            }; };
            // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
            var matchingEnteringNodes = PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, PathUtils.nonDynamicParams).filter(not(nodeIsReloading(targetState.options().reloadState)));
            // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
            matchingEnteringNodes.forEach(function (node, idx) {
                node.resolvables = originalEnteringNodes[idx].resolvables;
            });
            return newTransition;
        };
        /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
        Transition.prototype._changedParams = function () {
            var tc = this._treeChanges;
            /** Return undefined if it's not a "dynamic" transition, for the following reasons */
            // If user explicitly wants a reload
            if (this._options.reload)
                return undefined;
            // If any states are exiting or entering
            if (tc.exiting.length || tc.entering.length)
                return undefined;
            // If to/from path lengths differ
            if (tc.to.length !== tc.from.length)
                return undefined;
            // If the to/from paths are different
            var pathsDiffer = arrayTuples(tc.to, tc.from)
                .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
                .reduce(anyTrueR, false);
            if (pathsDiffer)
                return undefined;
            // Find any parameter values that differ
            var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
            var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
            var tuples = arrayTuples(nodeSchemas, toValues, fromValues);
            return tuples.map(function (_a) {
                var schema = _a[0], toVals = _a[1], fromVals = _a[2];
                return Param.changed(schema, toVals, fromVals);
            }).reduce(unnestR, []);
        };
        /**
         * Returns true if the transition is dynamic.
         *
         * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
         *
         * @returns true if the Transition is dynamic
         */
        Transition.prototype.dynamic = function () {
            var changes = this._changedParams();
            return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(anyTrueR, false);
        };
        /**
         * Returns true if the transition is ignored.
         *
         * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
         *
         * @returns true if the Transition is ignored.
         */
        Transition.prototype.ignored = function () {
            return !!this._ignoredReason();
        };
        /** @internal */
        Transition.prototype._ignoredReason = function () {
            var pending = this.router.globals.transition;
            var reloadState = this._options.reloadState;
            var same = function (pathA, pathB) {
                if (pathA.length !== pathB.length)
                    return false;
                var matching = PathUtils.matching(pathA, pathB);
                return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
            };
            var newTC = this.treeChanges();
            var pendTC = pending && pending.treeChanges();
            if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
                return 'SameAsPending';
            if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
                return 'SameAsCurrent';
        };
        /**
         * Runs the transition
         *
         * This method is generally called from the [[StateService.transitionTo]]
         *
         * @internal
         *
         * @returns a promise for a successful transition.
         */
        Transition.prototype.run = function () {
            var _this = this;
            var runAllHooks = TransitionHook.runAllHooks;
            // Gets transition hooks array for the given phase
            var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
            // When the chain is complete, then resolve or reject the deferred
            var transitionSuccess = function () {
                trace.traceSuccess(_this.$to(), _this);
                _this.success = true;
                _this._deferred.resolve(_this.to());
                runAllHooks(getHooksFor(exports.TransitionHookPhase.SUCCESS));
            };
            var transitionError = function (reason) {
                trace.traceError(reason, _this);
                _this.success = false;
                _this._deferred.reject(reason);
                _this._error = reason;
                runAllHooks(getHooksFor(exports.TransitionHookPhase.ERROR));
            };
            var runTransition = function () {
                // Wait to build the RUN hook chain until the BEFORE hooks are done
                // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
                var allRunHooks = getHooksFor(exports.TransitionHookPhase.RUN);
                var done = function () { return services.$q.when(undefined); };
                return TransitionHook.invokeHooks(allRunHooks, done);
            };
            var startTransition = function () {
                var globals = _this.router.globals;
                globals.lastStartedTransitionId = _this.$id;
                globals.transition = _this;
                globals.transitionHistory.enqueue(_this);
                trace.traceTransitionStart(_this);
                return services.$q.when(undefined);
            };
            var allBeforeHooks = getHooksFor(exports.TransitionHookPhase.BEFORE);
            TransitionHook.invokeHooks(allBeforeHooks, startTransition)
                .then(runTransition)
                .then(transitionSuccess, transitionError);
            return this.promise;
        };
        /**
         * Checks if the Transition is valid
         *
         * @returns true if the Transition is valid
         */
        Transition.prototype.valid = function () {
            return !this.error() || this.success !== undefined;
        };
        /**
         * Aborts this transition
         *
         * Imperative API to abort a Transition.
         * This only applies to Transitions that are not yet complete.
         */
        Transition.prototype.abort = function () {
            // Do not set flag if the transition is already complete
            if (isUndefined(this.success)) {
                this._aborted = true;
            }
        };
        /**
         * The Transition error reason.
         *
         * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
         * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
         *
         * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
         */
        Transition.prototype.error = function () {
            var state = this.$to();
            if (state.self.abstract) {
                return Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
            }
            var paramDefs = state.parameters();
            var values = this.params();
            var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
            if (invalidParams.length) {
                var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + stringify(values[param.id]) + "]"; }).join(', ');
                var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
                return Rejection.invalid(detail);
            }
            if (this.success === false)
                return this._error;
        };
        /**
         * A string representation of the Transition
         *
         * @returns A string representation of the Transition
         */
        Transition.prototype.toString = function () {
            var fromStateOrName = this.from();
            var toStateOrName = this.to();
            var avoidEmptyHash = function (params) {
                return params['#'] !== null && params['#'] !== undefined ? params : omit(params, ['#']);
            };
            // (X) means the to state is invalid.
            var id = this.$id, from = isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = stringify(avoidEmptyHash(this._treeChanges.from.map(prop('paramValues')).reduce(mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = stringify(avoidEmptyHash(this.params()));
            return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
        };
        /** @internal */
        Transition.diToken = Transition;
        return Transition;
    }());

    function quoteRegExp(str, param) {
        var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
        if (!param)
            return result;
        switch (param.squash) {
            case false:
                surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
                break;
            case true:
                result = result.replace(/\/$/, '');
                surroundPattern = ['(?:/(', ')|/)?'];
                break;
            default:
                surroundPattern = ["(" + param.squash + "|", ')?'];
                break;
        }
        return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
    }
    var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
    var splitOnSlash = splitOnDelim('/');
    var defaultConfig = {
        state: { params: {} },
        strict: true,
        caseInsensitive: true,
        decodeParams: true,
    };
    /**
     * Matches URLs against patterns.
     *
     * Matches URLs against patterns and extracts named parameters from the path or the search
     * part of the URL.
     *
     * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
     * parameters. Multiple search parameter names are separated by '&'. Search parameters
     * do not influence whether or not a URL is matched, but their values are passed through into
     * the matched parameters returned by [[UrlMatcher.exec]].
     *
     * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
     * or colon placeholders (`/somePath/:param`).
     *
     * - *A parameter RegExp* may be defined for a param after a colon
     * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
     * The regexp must match for the url to be matched.
     * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
     *
     * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
     *
     * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
     *   See [[UrlMatcherFactory.type]] for more information.
     *
     * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
     *   A catch-all * parameter value will contain the remainder of the URL.
     *
     * ---
     *
     * Parameter names may contain only word characters (latin letters, digits, and underscore) and
     * must be unique within the pattern (across both path and search parameters).
     * A path parameter matches any number of characters other than '/'. For catch-all
     * placeholders the path parameter matches any number of characters.
     *
     * Examples:
     *
     * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
     *   trailing slashes, and patterns have to match the entire path, not just a prefix.
     * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
     *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
     * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
     * * `'/user/{id:[^/]*}'` - Same as the previous example.
     * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
     *   parameter consists of 1 to 8 hex digits.
     * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
     *   path into the parameter 'path'.
     * * `'/files/*path'` - ditto.
     * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
     *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
     *
     */
    var UrlMatcher = /** @class */ (function () {
        /**
         * @param pattern The pattern to compile into a matcher.
         * @param paramTypes The [[ParamTypes]] registry
         * @param paramFactory A [[ParamFactory]] object
         * @param config  A [[UrlMatcherCompileConfig]] configuration object
         */
        function UrlMatcher(pattern, paramTypes, paramFactory, config) {
            var _this = this;
            /** @internal */
            this._cache = { path: [this] };
            /** @internal */
            this._children = [];
            /** @internal */
            this._params = [];
            /** @internal */
            this._segments = [];
            /** @internal */
            this._compiled = [];
            this.config = config = defaults(config, defaultConfig);
            this.pattern = pattern;
            // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
            //   '*' name
            //   ':' name
            //   '{' name '}'
            //   '{' name ':' regexp '}'
            // The regular expression is somewhat complicated due to the need to allow curly braces
            // inside the regular expression. The placeholder regexp breaks down as follows:
            //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
            //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
            //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
            //    [^{}\\]+                       - anything other than curly braces or backslash
            //    \\.                            - a backslash escape
            //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
            var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
            var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
            var patterns = [];
            var last = 0;
            var matchArray;
            var checkParamErrors = function (id) {
                if (!UrlMatcher.nameValidator.test(id))
                    throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
                if (find(_this._params, propEq('id', id)))
                    throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
            };
            // Split into static segments separated by path parameter placeholders.
            // The number of segments is always 1 more than the number of parameters.
            var matchDetails = function (m, isSearch) {
                // IE[78] returns '' for unmatched groups instead of null
                var id = m[2] || m[3];
                var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
                var makeRegexpType = function (str) {
                    return inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
                        pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
                    });
                };
                return {
                    id: id,
                    regexp: regexp,
                    segment: pattern.substring(last, m.index),
                    type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
                };
            };
            var details;
            var segment;
            // tslint:disable-next-line:no-conditional-assignment
            while ((matchArray = placeholder.exec(pattern))) {
                details = matchDetails(matchArray, false);
                if (details.segment.indexOf('?') >= 0)
                    break; // we're into the search part
                checkParamErrors(details.id);
                this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
                this._segments.push(details.segment);
                patterns.push([details.segment, tail(this._params)]);
                last = placeholder.lastIndex;
            }
            segment = pattern.substring(last);
            // Find any search parameter names and remove them from the last segment
            var i = segment.indexOf('?');
            if (i >= 0) {
                var search = segment.substring(i);
                segment = segment.substring(0, i);
                if (search.length > 0) {
                    last = 0;
                    // tslint:disable-next-line:no-conditional-assignment
                    while ((matchArray = searchPlaceholder.exec(search))) {
                        details = matchDetails(matchArray, true);
                        checkParamErrors(details.id);
                        this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
                        last = placeholder.lastIndex;
                        // check if ?&
                    }
                }
            }
            this._segments.push(segment);
            this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
        }
        /** @internal */
        UrlMatcher.encodeDashes = function (str) {
            // Replace dashes with encoded "\-"
            return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
        };
        /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
        UrlMatcher.pathSegmentsAndParams = function (matcher) {
            var staticSegments = matcher._segments;
            var pathParams = matcher._params.filter(function (p) { return p.location === exports.DefType.PATH; });
            return arrayTuples(staticSegments, pathParams.concat(undefined))
                .reduce(unnestR, [])
                .filter(function (x) { return x !== '' && isDefined(x); });
        };
        /** @internal Given a matcher, return an array with the matcher's query params */
        UrlMatcher.queryParams = function (matcher) {
            return matcher._params.filter(function (p) { return p.location === exports.DefType.SEARCH; });
        };
        /**
         * Compare two UrlMatchers
         *
         * This comparison function converts a UrlMatcher into static and dynamic path segments.
         * Each static path segment is a static string between a path separator (slash character).
         * Each dynamic segment is a path parameter.
         *
         * The comparison function sorts static segments before dynamic ones.
         */
        UrlMatcher.compare = function (a, b) {
            /**
             * Turn a UrlMatcher and all its parent matchers into an array
             * of slash literals '/', string literals, and Param objects
             *
             * This example matcher matches strings like "/foo/:param/tail":
             * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
             * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
             *
             * Caches the result as `matcher._cache.segments`
             */
            var segments = function (matcher) {
                return (matcher._cache.segments =
                    matcher._cache.segments ||
                        matcher._cache.path
                            .map(UrlMatcher.pathSegmentsAndParams)
                            .reduce(unnestR, [])
                            .reduce(joinNeighborsR, [])
                            .map(function (x) { return (isString(x) ? splitOnSlash(x) : x); })
                            .reduce(unnestR, []));
            };
            /**
             * Gets the sort weight for each segment of a UrlMatcher
             *
             * Caches the result as `matcher._cache.weights`
             */
            var weights = function (matcher) {
                return (matcher._cache.weights =
                    matcher._cache.weights ||
                        segments(matcher).map(function (segment) {
                            // Sort slashes first, then static strings, the Params
                            if (segment === '/')
                                return 1;
                            if (isString(segment))
                                return 2;
                            if (segment instanceof Param)
                                return 3;
                        }));
            };
            /**
             * Pads shorter array in-place (mutates)
             */
            var padArrays = function (l, r, padVal) {
                var len = Math.max(l.length, r.length);
                while (l.length < len)
                    l.push(padVal);
                while (r.length < len)
                    r.push(padVal);
            };
            var weightsA = weights(a), weightsB = weights(b);
            padArrays(weightsA, weightsB, 0);
            var _pairs = arrayTuples(weightsA, weightsB);
            var cmp, i;
            for (i = 0; i < _pairs.length; i++) {
                cmp = _pairs[i][0] - _pairs[i][1];
                if (cmp !== 0)
                    return cmp;
            }
            return 0;
        };
        /**
         * Creates a new concatenated UrlMatcher
         *
         * Builds a new UrlMatcher by appending another UrlMatcher to this one.
         *
         * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
         */
        UrlMatcher.prototype.append = function (url) {
            this._children.push(url);
            url._cache = {
                path: this._cache.path.concat(url),
                parent: this,
                pattern: null,
            };
            return url;
        };
        /** @internal */
        UrlMatcher.prototype.isRoot = function () {
            return this._cache.path[0] === this;
        };
        /** Returns the input pattern string */
        UrlMatcher.prototype.toString = function () {
            return this.pattern;
        };
        UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
            if (isDefined(value)) {
                if (this.config.decodeParams && !param.type.raw) {
                    if (isArray(value)) {
                        value = value.map(function (paramValue) { return decodeURIComponent(paramValue); });
                    }
                    else {
                        value = decodeURIComponent(value);
                    }
                }
                value = param.type.decode(value);
            }
            return param.value(value);
        };
        /**
         * Tests the specified url/path against this matcher.
         *
         * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
         * parameter values.  Returns null if the path does not match.
         *
         * The returned object contains the values
         * of any search parameters that are mentioned in the pattern, but their value may be null if
         * they are not present in `search`. This means that search parameters are always treated
         * as optional.
         *
         * #### Example:
         * ```js
         * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
         *   x: '1', q: 'hello'
         * });
         * // returns { id: 'bob', q: 'hello', r: null }
         * ```
         *
         * @param path    The URL path to match, e.g. `$location.path()`.
         * @param search  URL search parameters, e.g. `$location.search()`.
         * @param hash    URL hash e.g. `$location.hash()`.
         * @param options
         *
         * @returns The captured parameter values.
         */
        UrlMatcher.prototype.exec = function (path, search, hash, options) {
            var _this = this;
            if (search === void 0) { search = {}; }
            var match = memoizeTo(this._cache, 'pattern', function () {
                return new RegExp([
                    '^',
                    unnest(_this._cache.path.map(prop('_compiled'))).join(''),
                    _this.config.strict === false ? '/?' : '',
                    '$',
                ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
            }).exec(path);
            if (!match)
                return null;
            // options = defaults(options, { isolate: false });
            var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
            if (nPathSegments !== match.length - 1)
                throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
            function decodePathArray(paramVal) {
                var reverseString = function (str) { return str.split('').reverse().join(''); };
                var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
                var split = reverseString(paramVal).split(/-(?!\\)/);
                var allReversed = map(split, reverseString);
                return map(allReversed, unquoteDashes).reverse();
            }
            for (var i = 0; i < nPathSegments; i++) {
                var param = pathParams[i];
                var value = match[i + 1];
                // if the param value matches a pre-replace pair, replace the value before decoding.
                for (var j = 0; j < param.replace.length; j++) {
                    if (param.replace[j].from === value)
                        value = param.replace[j].to;
                }
                if (value && param.array === true)
                    value = decodePathArray(value);
                values[param.id] = this._getDecodedParamValue(value, param);
            }
            searchParams.forEach(function (param) {
                var value = search[param.id];
                for (var j = 0; j < param.replace.length; j++) {
                    if (param.replace[j].from === value)
                        value = param.replace[j].to;
                }
                values[param.id] = _this._getDecodedParamValue(value, param);
            });
            if (hash)
                values['#'] = hash;
            return values;
        };
        /**
         * @internal
         * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
         *
         * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
         *    pattern has no parameters, an empty array is returned.
         */
        UrlMatcher.prototype.parameters = function (opts) {
            if (opts === void 0) { opts = {}; }
            if (opts.inherit === false)
                return this._params;
            return unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
        };
        /**
         * @internal
         * Returns a single parameter from this UrlMatcher by id
         *
         * @param id
         * @param opts
         * @returns {T|Param|any|boolean|UrlMatcher|null}
         */
        UrlMatcher.prototype.parameter = function (id, opts) {
            var _this = this;
            if (opts === void 0) { opts = {}; }
            var findParam = function () {
                for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
                    var param = _a[_i];
                    if (param.id === id)
                        return param;
                }
            };
            var parent = this._cache.parent;
            return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
        };
        /**
         * Validates the input parameter values against this UrlMatcher
         *
         * Checks an object hash of parameters to validate their correctness according to the parameter
         * types of this `UrlMatcher`.
         *
         * @param params The object hash of parameters to validate.
         * @returns Returns `true` if `params` validates, otherwise `false`.
         */
        UrlMatcher.prototype.validates = function (params) {
            var validParamVal = function (param, val) { return !param || param.validates(val); };
            params = params || {};
            // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
            var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
            return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(allTrueR, true);
        };
        /**
         * Given a set of parameter values, creates a URL from this UrlMatcher.
         *
         * Creates a URL that matches this pattern by substituting the specified values
         * for the path and search parameters.
         *
         * #### Example:
         * ```js
         * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
         * // returns '/user/bob?q=yes'
         * ```
         *
         * @param values  the values to substitute for the parameters in this pattern.
         * @returns the formatted URL (path and optionally search part).
         */
        UrlMatcher.prototype.format = function (values) {
            if (values === void 0) { values = {}; }
            // Build the full path of UrlMatchers (including all parent UrlMatchers)
            var urlMatchers = this._cache.path;
            // Extract all the static segments and Params (processed as ParamDetails)
            // into an ordered array
            var pathSegmentsAndParams = urlMatchers
                .map(UrlMatcher.pathSegmentsAndParams)
                .reduce(unnestR, [])
                .map(function (x) { return (isString(x) ? x : getDetails(x)); });
            // Extract the query params into a separate array
            var queryParams = urlMatchers
                .map(UrlMatcher.queryParams)
                .reduce(unnestR, [])
                .map(getDetails);
            var isInvalid = function (param) { return param.isValid === false; };
            if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
                return null;
            }
            /**
             * Given a Param, applies the parameter value, then returns detailed information about it
             */
            function getDetails(param) {
                // Normalize to typed value
                var value = param.value(values[param.id]);
                var isValid = param.validates(value);
                var isDefaultValue = param.isDefaultValue(value);
                // Check if we're in squash mode for the parameter
                var squash = isDefaultValue ? param.squash : false;
                // Allow the Parameter's Type to encode the value
                var encoded = param.type.encode(value);
                return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
            }
            // Build up the path-portion from the list of static segments and parameters
            var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
                // The element is a static segment (a raw string); just append it
                if (isString(x))
                    return acc + x;
                // Otherwise, it's a ParamDetails.
                var squash = x.squash, encoded = x.encoded, param = x.param;
                // If squash is === true, try to remove a slash from the path
                if (squash === true)
                    return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
                // If squash is a string, use the string for the param value
                if (isString(squash))
                    return acc + squash;
                if (squash !== false)
                    return acc; // ?
                if (encoded == null)
                    return acc;
                // If this parameter value is an array, encode the value using encodeDashes
                if (isArray(encoded))
                    return acc + map(encoded, UrlMatcher.encodeDashes).join('-');
                // If the parameter type is "raw", then do not encodeURIComponent
                if (param.raw)
                    return acc + encoded;
                // Encode the value
                return acc + encodeURIComponent(encoded);
            }, '');
            // Build the query string by applying parameter values (array or regular)
            // then mapping to key=value, then flattening and joining using "&"
            var queryString = queryParams
                .map(function (paramDetails) {
                var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
                if (encoded == null || (isDefaultValue && squash !== false))
                    return;
                if (!isArray(encoded))
                    encoded = [encoded];
                if (encoded.length === 0)
                    return;
                if (!param.raw)
                    encoded = map(encoded, encodeURIComponent);
                return encoded.map(function (val) { return param.id + "=" + val; });
            })
                .filter(identity)
                .reduce(unnestR, [])
                .join('&');
            // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
            return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
        };
        /** @internal */
        UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
        return UrlMatcher;
    }());

    var __assign = (undefined && undefined.__assign) || function () {
        __assign = Object.assign || function(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var ParamFactory = /** @class */ (function () {
        function ParamFactory(router) {
            this.router = router;
        }
        ParamFactory.prototype.fromConfig = function (id, type, state) {
            return new Param(id, type, exports.DefType.CONFIG, this.router.urlService.config, state);
        };
        ParamFactory.prototype.fromPath = function (id, type, state) {
            return new Param(id, type, exports.DefType.PATH, this.router.urlService.config, state);
        };
        ParamFactory.prototype.fromSearch = function (id, type, state) {
            return new Param(id, type, exports.DefType.SEARCH, this.router.urlService.config, state);
        };
        return ParamFactory;
    }());
    /**
     * Factory for [[UrlMatcher]] instances.
     *
     * The factory is available to ng1 services as
     * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
     */
    var UrlMatcherFactory = /** @class */ (function () {
        // TODO: move implementations to UrlConfig (urlService.config)
        function UrlMatcherFactory(/** @internal */ router) {
            var _this = this;
            this.router = router;
            /** Creates a new [[Param]] for a given location (DefType) */
            this.paramFactory = new ParamFactory(this.router);
            // TODO: Check if removal of this will break anything, then remove these
            this.UrlMatcher = UrlMatcher;
            this.Param = Param;
            /** @deprecated use [[UrlConfig.caseInsensitive]] */
            this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
            /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
            this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
            /** @deprecated use [[UrlConfig.strictMode]] */
            this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
            /** @deprecated use [[UrlConfig.type]] */
            this.type = function (name, definition, definitionFn) {
                return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
            };
        }
        /**
         * Creates a [[UrlMatcher]] for the specified pattern.
         *
         * @param pattern  The URL pattern.
         * @param config  The config object hash.
         * @returns The UrlMatcher.
         */
        UrlMatcherFactory.prototype.compile = function (pattern, config) {
            var urlConfig = this.router.urlService.config;
            // backward-compatible support for config.params -> config.state.params
            var params = config && !config.state && config.params;
            config = params ? __assign({ state: { params: params } }, config) : config;
            var globalConfig = {
                strict: urlConfig._isStrictMode,
                caseInsensitive: urlConfig._isCaseInsensitive,
                decodeParams: urlConfig._decodeParams,
            };
            return new UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, extend(globalConfig, config));
        };
        /**
         * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
         *
         * @param object  The object to perform the type check against.
         * @returns `true` if the object matches the `UrlMatcher` interface, by
         *          implementing all the same methods.
         */
        UrlMatcherFactory.prototype.isMatcher = function (object) {
            // TODO: typeof?
            if (!isObject(object))
                return false;
            var result = true;
            forEach(UrlMatcher.prototype, function (val, name) {
                if (isFunction(val))
                    result = result && isDefined(object[name]) && isFunction(object[name]);
            });
            return result;
        };
        /** @internal */
        UrlMatcherFactory.prototype.$get = function () {
            var urlConfig = this.router.urlService.config;
            urlConfig.paramTypes.enqueue = false;
            urlConfig.paramTypes._flushTypeQueue();
            return this;
        };
        return UrlMatcherFactory;
    }());

    /**
     * Creates a [[UrlRule]]
     *
     * Creates a [[UrlRule]] from a:
     *
     * - `string`
     * - [[UrlMatcher]]
     * - `RegExp`
     * - [[StateObject]]
     */
    var UrlRuleFactory = /** @class */ (function () {
        function UrlRuleFactory(router) {
            this.router = router;
        }
        UrlRuleFactory.prototype.compile = function (str) {
            return this.router.urlMatcherFactory.compile(str);
        };
        UrlRuleFactory.prototype.create = function (what, handler) {
            var _this = this;
            var isState = StateObject.isState, isStateDeclaration = StateObject.isStateDeclaration;
            var makeRule = pattern([
                [isString, function (_what) { return makeRule(_this.compile(_what)); }],
                [is(UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
                [or(isState, isStateDeclaration), function (_what) { return _this.fromState(_what, _this.router); }],
                [is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
                [isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
            ]);
            var rule = makeRule(what);
            if (!rule)
                throw new Error("invalid 'what' in when()");
            return rule;
        };
        /**
         * A UrlRule which matches based on a UrlMatcher
         *
         * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
         *
         * ## Handler as a function
         *
         * If `handler` is a function, the function is invoked with:
         *
         * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
         * - url: the current Url ([[UrlParts]])
         * - router: the router object ([[UIRouter]])
         *
         * #### Example:
         * ```js
         * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
         * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
         * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
         * var result = rule.handler(match); // '/home/123/456'
         * ```
         *
         * ## Handler as UrlMatcher
         *
         * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
         * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
         * The url is replaced with the result.
         *
         * #### Example:
         * ```js
         * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
         * var handler = $umf.compile("/home/:fooId/:barId");
         * var rule = factory.fromUrlMatcher(urlMatcher, handler);
         * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
         * var result = rule.handler(match); // '/home/123/456'
         * ```
         */
        UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
            var _handler = handler;
            if (isString(handler))
                handler = this.router.urlMatcherFactory.compile(handler);
            if (is(UrlMatcher)(handler))
                _handler = function (match) { return handler.format(match); };
            function matchUrlParamters(url) {
                var params = urlMatcher.exec(url.path, url.search, url.hash);
                return urlMatcher.validates(params) && params;
            }
            // Prioritize URLs, lowest to highest:
            // - Some optional URL parameters, but none matched
            // - No optional parameters in URL
            // - Some optional parameters, some matched
            // - Some optional parameters, all matched
            function matchPriority(params) {
                var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
                if (!optional.length)
                    return 0.000001;
                var matched = optional.filter(function (param) { return params[param.id]; });
                return matched.length / optional.length;
            }
            var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
            return extend(new BaseUrlRule(matchUrlParamters, _handler), details);
        };
        /**
         * A UrlRule which matches a state by its url
         *
         * #### Example:
         * ```js
         * var rule = factory.fromState($state.get('foo'), router);
         * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
         * var result = rule.handler(match);
         * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
         * ```
         */
        UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
            var state = StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
            /**
             * Handles match by transitioning to matched state
             *
             * First checks if the router should start a new transition.
             * A new transition is not required if the current state's URL
             * and the new URL are already identical
             */
            var handler = function (match) {
                var $state = router.stateService;
                var globals = router.globals;
                if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
                    $state.transitionTo(state, match, { inherit: true, source: 'url' });
                }
            };
            var details = { state: state, type: 'STATE' };
            return extend(this.fromUrlMatcher(state.url, handler), details);
        };
        /**
         * A UrlRule which matches based on a regular expression
         *
         * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
         *
         * ## Handler as a function
         *
         * If `handler` is a function, the function is invoked with:
         *
         * - regexp match array (from `regexp`)
         * - url: the current Url ([[UrlParts]])
         * - router: the router object ([[UIRouter]])
         *
         * #### Example:
         * ```js
         * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
         * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
         * var result = rule.handler(match); // '/home/bar'
         * ```
         *
         * ## Handler as string
         *
         * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
         * The string is first interpolated using `string.replace()` style pattern.
         *
         * #### Example:
         * ```js
         * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
         * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
         * var result = rule.handler(match); // '/home/bar'
         * ```
         */
        UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
            if (regexp.global || regexp.sticky)
                throw new Error('Rule RegExp must not be global or sticky');
            /**
             * If handler is a string, the url will be replaced by the string.
             * If the string has any String.replace() style variables in it (like `$2`),
             * they will be replaced by the captures from [[match]]
             */
            var redirectUrlTo = function (match) {
                // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
                return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
            };
            var _handler = isString(handler) ? redirectUrlTo : handler;
            var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
            var details = { regexp: regexp, type: 'REGEXP' };
            return extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
        };
        UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return isDefined(obj[key]); }); };
        return UrlRuleFactory;
    }());
    /**
     * A base rule which calls `match`
     *
     * The value from the `match` function is passed through to the `handler`.
     * @internal
     */
    var BaseUrlRule = /** @class */ (function () {
        function BaseUrlRule(match, handler) {
            var _this = this;
            this.match = match;
            this.type = 'RAW';
            this.matchPriority = function (match) { return 0 - _this.$id; };
            this.handler = handler || identity;
        }
        return BaseUrlRule;
    }());

    function appendBasePath(url, isHtml5, absolute, baseHref) {
        if (baseHref === '/')
            return url;
        if (isHtml5)
            return stripLastPathElement(baseHref) + url;
        if (absolute)
            return baseHref.slice(1) + url;
        return url;
    }
    /**
     * Updates URL and responds to URL changes
     *
     * ### Deprecation warning:
     * This class is now considered to be an internal API
     * Use the [[UrlService]] instead.
     * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
     */
    var UrlRouter = /** @class */ (function () {
        /** @internal */
        function UrlRouter(/** @internal */ router) {
            var _this = this;
            this.router = router;
            // Delegate these calls to [[UrlService]]
            /** @deprecated use [[UrlService.sync]]*/
            this.sync = function (evt) { return _this.router.urlService.sync(evt); };
            /** @deprecated use [[UrlService.listen]]*/
            this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
            /** @deprecated use [[UrlService.deferIntercept]]*/
            this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
            /** @deprecated use [[UrlService.match]]*/
            this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
            // Delegate these calls to [[UrlRules]]
            /** @deprecated use [[UrlRules.initial]]*/
            this.initial = function (handler) {
                return _this.router.urlService.rules.initial(handler);
            };
            /** @deprecated use [[UrlRules.otherwise]]*/
            this.otherwise = function (handler) {
                return _this.router.urlService.rules.otherwise(handler);
            };
            /** @deprecated use [[UrlRules.removeRule]]*/
            this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
            /** @deprecated use [[UrlRules.rule]]*/
            this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
            /** @deprecated use [[UrlRules.rules]]*/
            this.rules = function () { return _this.router.urlService.rules.rules(); };
            /** @deprecated use [[UrlRules.sort]]*/
            this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
            /** @deprecated use [[UrlRules.when]]*/
            this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
            this.urlRuleFactory = new UrlRuleFactory(router);
        }
        /** Internal API. */
        UrlRouter.prototype.update = function (read) {
            var $url = this.router.locationService;
            if (read) {
                this.location = $url.url();
                return;
            }
            if ($url.url() === this.location)
                return;
            $url.url(this.location, true);
        };
        /**
         * Internal API.
         *
         * Pushes a new location to the browser history.
         *
         * @internal
         * @param urlMatcher
         * @param params
         * @param options
         */
        UrlRouter.prototype.push = function (urlMatcher, params, options) {
            var replace = options && !!options.replace;
            this.router.urlService.url(urlMatcher.format(params || {}), replace);
        };
        /**
         * Builds and returns a URL with interpolated parameters
         *
         * #### Example:
         * ```js
         * matcher = $umf.compile("/about/:person");
         * params = { person: "bob" };
         * $bob = $urlRouter.href(matcher, params);
         * // $bob == "/about/bob";
         * ```
         *
         * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
         * @param params An object of parameter values to fill the matcher's required parameters.
         * @param options Options object. The options are:
         *
         * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
         *
         * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
         */
        UrlRouter.prototype.href = function (urlMatcher, params, options) {
            var url = urlMatcher.format(params);
            if (url == null)
                return null;
            options = options || { absolute: false };
            var cfg = this.router.urlService.config;
            var isHtml5 = cfg.html5Mode();
            if (!isHtml5 && url !== null) {
                url = '#' + cfg.hashPrefix() + url;
            }
            url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
            if (!options.absolute || !url) {
                return url;
            }
            var slash = !isHtml5 && url ? '/' : '';
            var cfgPort = cfg.port();
            var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
            return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
        };
        Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
            /** @deprecated use [[UrlService.interceptDeferred]]*/
            get: function () {
                return this.router.urlService.interceptDeferred;
            },
            enumerable: false,
            configurable: true
        });
        return UrlRouter;
    }());

    /**
     * The View service
     *
     * This service pairs existing `ui-view` components (which live in the DOM)
     * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
     *
     * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
     *   The views from exited states are deactivated via [[deactivateViewConfig]].
     *   (See: the [[registerActivateViews]] Transition Hook)
     *
     * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
     *
     * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
     * are configured with the matching [[ViewConfig]](s)
     *
     */
    var ViewService = /** @class */ (function () {
        /** @internal */
        function ViewService(/** @internal */ router) {
            var _this = this;
            this.router = router;
            /** @internal */ this._uiViews = [];
            /** @internal */ this._viewConfigs = [];
            /** @internal */ this._viewConfigFactories = {};
            /** @internal */ this._listeners = [];
            /** @internal */
            this._pluginapi = {
                _rootViewContext: this._rootViewContext.bind(this),
                _viewConfigFactory: this._viewConfigFactory.bind(this),
                _registeredUIView: function (id) { return find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
                _registeredUIViews: function () { return _this._uiViews; },
                _activeViewConfigs: function () { return _this._viewConfigs; },
                _onSync: function (listener) {
                    _this._listeners.push(listener);
                    return function () { return removeFrom(_this._listeners, listener); };
                },
            };
        }
        /**
         * Normalizes a view's name from a state.views configuration block.
         *
         * This should be used by a framework implementation to calculate the values for
         * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
         *
         * @param context the context object (state declaration) that the view belongs to
         * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
         *
         * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
         */
        ViewService.normalizeUIViewTarget = function (context, rawViewName) {
            if (rawViewName === void 0) { rawViewName = ''; }
            // TODO: Validate incoming view name with a regexp to allow:
            // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
            // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
            var viewAtContext = rawViewName.split('@');
            var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
            var uiViewContextAnchor = isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
            // Handle relative view-name sugar syntax.
            // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
            var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
            if (relativeViewNameSugar) {
                // Clobbers existing contextAnchor (rawViewName validation will fix this)
                uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
                uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
            }
            if (uiViewName.charAt(0) === '!') {
                uiViewName = uiViewName.substr(1);
                uiViewContextAnchor = ''; // target absolutely from root
            }
            // handle parent relative targeting "^.^.^"
            var relativeMatch = /^(\^(?:\.\^)*)$/;
            if (relativeMatch.exec(uiViewContextAnchor)) {
                var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
                uiViewContextAnchor = anchorState.name;
            }
            else if (uiViewContextAnchor === '.') {
                uiViewContextAnchor = context.name;
            }
            return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
        };
        /** @internal */
        ViewService.prototype._rootViewContext = function (context) {
            return (this._rootContext = context || this._rootContext);
        };
        /** @internal */
        ViewService.prototype._viewConfigFactory = function (viewType, factory) {
            this._viewConfigFactories[viewType] = factory;
        };
        ViewService.prototype.createViewConfig = function (path, decl) {
            var cfgFactory = this._viewConfigFactories[decl.$type];
            if (!cfgFactory)
                throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
            var cfgs = cfgFactory(path, decl);
            return isArray(cfgs) ? cfgs : [cfgs];
        };
        /**
         * Deactivates a ViewConfig.
         *
         * This function deactivates a `ViewConfig`.
         * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
         *
         * @param viewConfig The ViewConfig view to deregister.
         */
        ViewService.prototype.deactivateViewConfig = function (viewConfig) {
            trace.traceViewServiceEvent('<- Removing', viewConfig);
            removeFrom(this._viewConfigs, viewConfig);
        };
        ViewService.prototype.activateViewConfig = function (viewConfig) {
            trace.traceViewServiceEvent('-> Registering', viewConfig);
            this._viewConfigs.push(viewConfig);
        };
        ViewService.prototype.sync = function () {
            var _this = this;
            var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(applyPairs, {});
            // Return a weighted depth value for a uiView.
            // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
            // plus the depth of the state that is populating the uiView
            function uiViewDepth(uiView) {
                var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
                return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
            }
            // Return the ViewConfig's context's depth in the context tree.
            function viewConfigDepth(config) {
                var context = config.viewDecl.$context, count = 0;
                while (++count && context.parent)
                    context = context.parent;
                return count;
            }
            // Given a depth function, returns a compare function which can return either ascending or descending order
            var depthCompare = curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
            var matchingConfigPair = function (uiView) {
                var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
                if (matchingConfigs.length > 1) {
                    // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
                    // Sort by depth and return the match from the deepest child
                    // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
                    matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
                }
                return { uiView: uiView, viewConfig: matchingConfigs[0] };
            };
            var configureUIView = function (tuple) {
                // If a parent ui-view is reconfigured, it could destroy child ui-views.
                // Before configuring a child ui-view, make sure it's still in the active uiViews array.
                if (_this._uiViews.indexOf(tuple.uiView) !== -1)
                    tuple.uiView.configUpdated(tuple.viewConfig);
            };
            // Sort views by FQN and state depth. Process uiviews nearest the root first.
            var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
            var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
            var unmatchedConfigTuples = this._viewConfigs
                .filter(function (config) { return !inArray(matchedViewConfigs, config); })
                .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
            uiViewTuples.forEach(configureUIView);
            var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
            this._listeners.forEach(function (cb) { return cb(allTuples); });
            trace.traceViewSync(allTuples);
        };
        /**
         * Registers a `ui-view` component
         *
         * When a `ui-view` component is created, it uses this method to register itself.
         * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
         *
         * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
         * and what the view's state context is.
         *
         * Note: There is no corresponding `deregisterUIView`.
         *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
         *
         * @param uiView The metadata for a UIView
         * @return a de-registration function used when the view is destroyed.
         */
        ViewService.prototype.registerUIView = function (uiView) {
            trace.traceViewServiceUIViewEvent('-> Registering', uiView);
            var uiViews = this._uiViews;
            var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
            if (uiViews.filter(fqnAndTypeMatches).length)
                trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
            uiViews.push(uiView);
            this.sync();
            return function () {
                var idx = uiViews.indexOf(uiView);
                if (idx === -1) {
                    trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
                    return;
                }
                trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
                removeFrom(uiViews)(uiView);
            };
        };
        /**
         * Returns the list of views currently available on the page, by fully-qualified name.
         *
         * @return {Array} Returns an array of fully-qualified view names.
         */
        ViewService.prototype.available = function () {
            return this._uiViews.map(prop('fqn'));
        };
        /**
         * Returns the list of views on the page containing loaded content.
         *
         * @return {Array} Returns an array of fully-qualified view names.
         */
        ViewService.prototype.active = function () {
            return this._uiViews.filter(prop('$config')).map(prop('name'));
        };
        /**
         * Given a ui-view and a ViewConfig, determines if they "match".
         *
         * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
         * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
         *
         * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
         * can be a segmented ui-view path, describing a portion of a ui-view fqn.
         *
         * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
         *
         * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
         * - the ui-view's name matches the ViewConfig's target name
         * - the ui-view's context matches the ViewConfig's anchor
         *
         * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
         * - There exists a parent ui-view where:
         *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
         *    - the parent ui-view's context matches the ViewConfig's anchor
         * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
         *
         * Example:
         *
         * DOM:
         * <ui-view>                        <!-- created in the root context (name: "") -->
         *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
         *     <ui-view>                    <!-- created in the context named: "A.B"    -->
         *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
         *       </ui-view>
         *     </ui-view>
         *   </ui-view>
         * </ui-view>
         *
         * uiViews: [
         *  { fqn: "$default",                  creationContext: { name: "" } },
         *  { fqn: "$default.foo",              creationContext: { name: "A" } },
         *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
         *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
         * ]
         *
         * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
         *
         * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
         * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
         * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
         * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
         *
         * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
         * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
         * - There exists a parent ui-view (which has fqn: "$default.foo") where:
         *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
         *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
         * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
         *   the tail of the ui-view's fqn "default.bar"
         *
         * @internal
         */
        ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
            // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
            if (uiView.$type !== viewConfig.viewDecl.$type)
                return false;
            // Split names apart from both viewConfig and uiView into segments
            var vc = viewConfig.viewDecl;
            var vcSegments = vc.$uiViewName.split('.');
            var uivSegments = uiView.fqn.split('.');
            // Check if the tails of the segment arrays match. ex, these arrays' tails match:
            // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
            if (!equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
                return false;
            // Now check if the fqn ending at the first segment of the viewConfig matches the context:
            // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
            var negOffset = 1 - vcSegments.length || undefined;
            var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
            var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
            return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
        }; };
        return ViewService;
    }());

    /**
     * Global router state
     *
     * This is where we hold the global mutable state such as current state, current
     * params, current transition, etc.
     */
    var UIRouterGlobals = /** @class */ (function () {
        function UIRouterGlobals() {
            /**
             * Current parameter values
             *
             * The parameter values from the latest successful transition
             */
            this.params = new StateParams();
            /** @internal */
            this.lastStartedTransitionId = -1;
            /** @internal */
            this.transitionHistory = new Queue([], 1);
            /** @internal */
            this.successfulTransitions = new Queue([], 1);
        }
        UIRouterGlobals.prototype.dispose = function () {
            this.transitionHistory.clear();
            this.successfulTransitions.clear();
            this.transition = null;
        };
        return UIRouterGlobals;
    }());

    var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
    var typeSort = function (a, b) {
        var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
        return (weights[a.type] || 0) - (weights[b.type] || 0);
    };
    var urlMatcherSort = function (a, b) {
        return !a.urlMatcher || !b.urlMatcher ? 0 : UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
    };
    var idSort = function (a, b) {
        // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
        var useMatchPriority = { STATE: true, URLMATCHER: true };
        var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
        return equal ? 0 : (a.$id || 0) - (b.$id || 0);
    };
    /**
     * Default rule priority sorting function.
     *
     * Sorts rules by:
     *
     * - Explicit priority (set rule priority using [[UrlRules.when]])
     * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
     * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
     * - Rule registration order (for rule types other than STATE and URLMATCHER)
     *   - Equally sorted State and UrlMatcher rules will each match the URL.
     *     Then, the *best* match is chosen based on how many parameter values were matched.
     */
    var defaultRuleSortFn;
    defaultRuleSortFn = function (a, b) {
        var cmp = prioritySort(a, b);
        if (cmp !== 0)
            return cmp;
        cmp = typeSort(a, b);
        if (cmp !== 0)
            return cmp;
        cmp = urlMatcherSort(a, b);
        if (cmp !== 0)
            return cmp;
        return idSort(a, b);
    };
    function getHandlerFn(handler) {
        if (!isFunction(handler) && !isString(handler) && !is(TargetState)(handler) && !TargetState.isDef(handler)) {
            throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
        }
        return isFunction(handler) ? handler : val(handler);
    }
    /**
     * API for managing URL rules
     *
     * This API is used to create and manage URL rules.
     * URL rules are a mechanism to respond to specific URL patterns.
     *
     * The most commonly used methods are [[otherwise]] and [[when]].
     *
     * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
     */
    var UrlRules = /** @class */ (function () {
        /** @internal */
        function UrlRules(/** @internal */ router) {
            this.router = router;
            /** @internal */ this._sortFn = defaultRuleSortFn;
            /** @internal */ this._rules = [];
            /** @internal */ this._id = 0;
            this.urlRuleFactory = new UrlRuleFactory(router);
        }
        /** @internal */
        UrlRules.prototype.dispose = function (router) {
            this._rules = [];
            delete this._otherwiseFn;
        };
        /**
         * Defines the initial state, path, or behavior to use when the app starts.
         *
         * This rule defines the initial/starting state for the application.
         *
         * This rule is triggered the first time the URL is checked (when the app initially loads).
         * The rule is triggered only when the url matches either `""` or `"/"`.
         *
         * Note: The rule is intended to be used when the root of the application is directly linked to.
         * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
         * This allows 404-like behavior when an unknown URL is deep-linked.
         *
         * #### Example:
         * Start app at `home` state.
         * ```js
         * .initial({ state: 'home' });
         * ```
         *
         * #### Example:
         * Start app at `/home` (by url)
         * ```js
         * .initial('/home');
         * ```
         *
         * #### Example:
         * When no other url rule matches, go to `home` state
         * ```js
         * .initial((matchValue, url, router) => {
         *   console.log('initial state');
         *   return { state: 'home' };
         * })
         * ```
         *
         * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
         */
        UrlRules.prototype.initial = function (handler) {
            var handlerFn = getHandlerFn(handler);
            var matchFn = function (urlParts, router) {
                return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
            };
            this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
        };
        /**
         * Defines the state, url, or behavior to use when no other rule matches the URL.
         *
         * This rule is matched when *no other rule* matches.
         * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
         *
         * - If `handler` a string, it is treated as a url redirect
         *
         * #### Example:
         * When no other url rule matches, redirect to `/index`
         * ```js
         * .otherwise('/index');
         * ```
         *
         * - If `handler` is an object with a `state` property, the state is activated.
         *
         * #### Example:
         * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
         * ```js
         * .otherwise({ state: 'home', params: { dashboard: 'default' } });
         * ```
         *
         * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
         *   The function can perform actions, and/or return a value.
         *
         * #### Example:
         * When no other url rule matches, manually trigger a transition to the `home` state
         * ```js
         * .otherwise((matchValue, urlParts, router) => {
         *   router.stateService.go('home');
         * });
         * ```
         *
         * #### Example:
         * When no other url rule matches, go to `home` state
         * ```js
         * .otherwise((matchValue, urlParts, router) => {
         *   return { state: 'home' };
         * });
         * ```
         *
         * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
         */
        UrlRules.prototype.otherwise = function (handler) {
            var handlerFn = getHandlerFn(handler);
            this._otherwiseFn = this.urlRuleFactory.create(val(true), handlerFn);
            this._sorted = false;
        };
        /**
         * Remove a rule previously registered
         *
         * @param rule the matcher rule that was previously registered using [[rule]]
         */
        UrlRules.prototype.removeRule = function (rule) {
            removeFrom(this._rules, rule);
        };
        /**
         * Manually adds a URL Rule.
         *
         * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
         * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
         * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
         *
         * A rule should have a `match` function which returns truthy if the rule matched.
         * It should also have a `handler` function which is invoked if the rule is the best match.
         *
         * @return a function that deregisters the rule
         */
        UrlRules.prototype.rule = function (rule) {
            var _this = this;
            if (!UrlRuleFactory.isUrlRule(rule))
                throw new Error('invalid rule');
            rule.$id = this._id++;
            rule.priority = rule.priority || 0;
            this._rules.push(rule);
            this._sorted = false;
            return function () { return _this.removeRule(rule); };
        };
        /**
         * Gets all registered rules
         *
         * @returns an array of all the registered rules
         */
        UrlRules.prototype.rules = function () {
            this.ensureSorted();
            return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
        };
        /**
         * Defines URL Rule priorities
         *
         * More than one rule ([[UrlRule]]) might match a given URL.
         * This `compareFn` is used to sort the rules by priority.
         * Higher priority rules should sort earlier.
         *
         * The [[defaultRuleSortFn]] is used by default.
         *
         * You only need to call this function once.
         * The `compareFn` will be used to sort the rules as each is registered.
         *
         * If called without any parameter, it will re-sort the rules.
         *
         * ---
         *
         * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
         * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
         * The `$id` is is the order in which the rule was registered.
         *
         * The sort function should use these data, or data found on a specific type
         * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
         *
         * #### Example:
         * This compare function prioritizes rules by the order in which the rules were registered.
         * A rule registered earlier has higher priority.
         *
         * ```js
         * function compareFn(a, b) {
         *   return a.$id - b.$id;
         * }
         * ```
         *
         * @param compareFn a function that compares to [[UrlRule]] objects.
         *    The `compareFn` should abide by the `Array.sort` compare function rules.
         *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
         *    Return a positive number if `b` should be higher priority.
         *    Return `0` if the rules are identical.
         *
         *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
         *    for details.
         */
        UrlRules.prototype.sort = function (compareFn) {
            var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
            // precompute _sortGroup values and apply to each rule
            var group = 0;
            for (var i = 0; i < sorted.length; i++) {
                sorted[i]._group = group;
                if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
                    group++;
                }
            }
            this._rules = sorted;
            this._sorted = true;
        };
        /** @internal */
        UrlRules.prototype.ensureSorted = function () {
            this._sorted || this.sort();
        };
        /** @internal */
        UrlRules.prototype.stableSort = function (arr, compareFn) {
            var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
            arrOfWrapper.sort(function (wrapperA, wrapperB) {
                var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
                return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
            });
            return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
        };
        /**
         * Registers a `matcher` and `handler` for custom URLs handling.
         *
         * The `matcher` can be:
         *
         * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
         * - a `string`: The string is compiled to a [[UrlMatcher]]
         * - a `RegExp`: The regexp is used to match the url.
         *
         * The `handler` can be:
         *
         * - a string: The url is redirected to the value of the string.
         * - a function: The url is redirected to the return value of the function.
         *
         * ---
         *
         * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
         * string is interpolated with parameter values.
         *
         * #### Example:
         * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
         * ```js
         * .when("/foo/:param1", "/bar/:param1")
         * ```
         *
         * ---
         *
         * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
         * interpolated with capture groups from the RegExp.
         *
         * #### Example:
         * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
         * ```js
         * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
         * ```
         *
         * ---
         *
         * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
         * The "matched value" differs based on the `matcher`.
         * For [[UrlMatcher]]s, it will be the matched state params.
         * For `RegExp`, it will be the match array from `regexp.exec()`.
         *
         * If the handler returns a string, the URL is redirected to the string.
         *
         * #### Example:
         * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
         * ```js
         * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
         * ```
         *
         * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
         *
         * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
         * @param handler The path to redirect to, or a function that returns the path.
         * @param options `{ priority: number }`
         *
         * @return the registered [[UrlRule]]
         */
        UrlRules.prototype.when = function (matcher, handler, options) {
            var rule = this.urlRuleFactory.create(matcher, handler);
            if (isDefined(options && options.priority))
                rule.priority = options.priority;
            this.rule(rule);
            return rule;
        };
        return UrlRules;
    }());

    /**
     * An API to customize the URL behavior and retrieve URL configuration
     *
     * This API is used to customize the behavior of the URL.
     * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
     * and custom parameter encoding (custom [[type]]).
     *
     * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
     * This information can be used to build absolute URLs, such as
     * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
     *
     * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
     */
    var UrlConfig = /** @class */ (function () {
        /** @internal */ function UrlConfig(/** @internal */ router) {
            var _this = this;
            this.router = router;
            /** @internal */ this.paramTypes = new ParamTypes();
            /** @internal */ this._decodeParams = true;
            /** @internal */ this._isCaseInsensitive = false;
            /** @internal */ this._isStrictMode = true;
            /** @internal */ this._defaultSquashPolicy = false;
            /** @internal */ this.dispose = function () { return _this.paramTypes.dispose(); };
            // Delegate these calls to the current LocationConfig implementation
            /**
             * Gets the base Href, e.g., `http://localhost/approot/`
             *
             * @return the application's base href
             */
            this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
            /**
             * Gets or sets the hashPrefix
             *
             * This only applies when not running in [[html5Mode]] (pushstate mode)
             *
             * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
             *
             * @return the hash prefix
             */
            this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
            /**
             * Gets the host, e.g., `localhost`
             *
             * @return the protocol
             */
            this.host = function () { return _this.router.locationConfig.host(); };
            /**
             * Returns true when running in pushstate mode
             *
             * @return true when running in html5 mode (pushstate mode).
             */
            this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
            /**
             * Gets the port, e.g., `80`
             *
             * @return the port number
             */
            this.port = function () { return _this.router.locationConfig.port(); };
            /**
             * Gets the protocol, e.g., `http`
             *
             * @return the protocol
             */
            this.protocol = function () { return _this.router.locationConfig.protocol(); };
        }
        /**
         * Defines whether URL matching should be case sensitive (the default behavior), or not.
         *
         * #### Example:
         * ```js
         * // Allow case insensitive url matches
         * urlService.config.caseInsensitive(true);
         * ```
         *
         * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
         * @returns the current value of caseInsensitive
         */
        UrlConfig.prototype.caseInsensitive = function (value) {
            return (this._isCaseInsensitive = isDefined(value) ? value : this._isCaseInsensitive);
        };
        /**
         * Sets the default behavior when generating or matching URLs with default parameter values.
         *
         * #### Example:
         * ```js
         * // Remove default parameter values from the url
         * urlService.config.defaultSquashPolicy(true);
         * ```
         *
         * @param value A string that defines the default parameter URL squashing behavior.
         *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
         *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
         *      parameter is surrounded by slashes, squash (remove) one slash from the URL
         *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
         *      the parameter value from the URL and replace it with this string.
         * @returns the current value of defaultSquashPolicy
         */
        UrlConfig.prototype.defaultSquashPolicy = function (value) {
            if (isDefined(value) && value !== true && value !== false && !isString(value))
                throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
            return (this._defaultSquashPolicy = isDefined(value) ? value : this._defaultSquashPolicy);
        };
        /**
         * Defines whether URLs should match trailing slashes, or not (the default behavior).
         *
         * #### Example:
         * ```js
         * // Allow optional trailing slashes
         * urlService.config.strictMode(false);
         * ```
         *
         * @param value `false` to match trailing slashes in URLs, otherwise `true`.
         * @returns the current value of strictMode
         */
        UrlConfig.prototype.strictMode = function (value) {
            return (this._isStrictMode = isDefined(value) ? value : this._isStrictMode);
        };
        /**
         * Creates and registers a custom [[ParamType]] object
         *
         * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
         *
         * #### Note: Register custom types *before using them* in a state definition.
         *
         * #### Example:
         * ```js
         * // Encode object parameter as JSON string
         * urlService.config.type('myjson', {
         *   encode: (obj) => JSON.stringify(obj),
         *   decode: (str) => JSON.parse(str),
         *   is: (val) => typeof(val) === 'object',
         *   pattern: /[^/]+/,
         *   equals: (a, b) => _.isEqual(a, b),
         * });
         * ```
         *
         * See [[ParamTypeDefinition]] for more examples
         *
         * @param name The type name.
         * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
         * @param definitionFn A function that is injected before the app runtime starts.
         *        The result of this function should be a [[ParamTypeDefinition]].
         *        The result is merged into the existing `definition`.
         *        See [[ParamType]] for information on the values accepted.
         *
         * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
         */
        UrlConfig.prototype.type = function (name, definition, definitionFn) {
            var type = this.paramTypes.type(name, definition, definitionFn);
            return !isDefined(definition) ? type : this;
        };
        return UrlConfig;
    }());

    /**
     * API for URL management
     */
    var UrlService = /** @class */ (function () {
        /** @internal */
        function UrlService(/** @internal */ router) {
            var _this = this;
            this.router = router;
            /** @internal */ this.interceptDeferred = false;
            /**
             * The nested [[UrlRules]] API for managing URL rules and rewrites
             *
             * See: [[UrlRules]] for details
             */
            this.rules = new UrlRules(this.router);
            /**
             * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
             *
             * See: [[UrlConfig]] for details
             */
            this.config = new UrlConfig(this.router);
            // Delegate these calls to the current LocationServices implementation
            /**
             * Gets the current url, or updates the url
             *
             * ### Getting the current URL
             *
             * When no arguments are passed, returns the current URL.
             * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
             *
             * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
             * have a base HREF prepended ([[PushStateLocationServices]]).
             *
             * The raw URL in the browser might be:
             *
             * ```
             * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
             * ```
             *
             * or
             *
             * ```
             * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
             * ```
             *
             * then this method returns:
             *
             * ```
             * /internal/path/123?param1=foo#anchor
             * ```
             *
             *
             * #### Example:
             * ```js
             * locationServices.url(); // "/some/path?query=value#anchor"
             * ```
             *
             * ### Updating the URL
             *
             * When `newurl` arguments is provided, changes the URL to reflect `newurl`
             *
             * #### Example:
             * ```js
             * locationServices.url("/some/path?query=value#anchor", true);
             * ```
             *
             * @param newurl The new value for the URL.
             *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
             *               It should not include the protocol, site, port, or base path of an absolute HREF.
             * @param replace When true, replaces the current history entry (instead of appending it) with this new url
             * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
             *
             * @return the url (after potentially being processed)
             */
            this.url = function (newurl, replace, state) {
                return _this.router.locationService.url(newurl, replace, state);
            };
            /**
             * Gets the path part of the current url
             *
             * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
             *
             * @return the path portion of the url
             */
            this.path = function () { return _this.router.locationService.path(); };
            /**
             * Gets the search part of the current url as an object
             *
             * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
             *
             * @return the search (query) portion of the url, as an object
             */
            this.search = function () { return _this.router.locationService.search(); };
            /**
             * Gets the hash part of the current url
             *
             * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
             *
             * @return the hash (anchor) portion of the url
             */
            this.hash = function () { return _this.router.locationService.hash(); };
            /**
             * @internal
             *
             * Registers a low level url change handler
             *
             * Note: Because this is a low level handler, it's not recommended for general use.
             *
             * #### Example:
             * ```js
             * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
             * ```
             *
             * @param callback a function that will be called when the url is changing
             * @return a function that de-registers the callback
             */
            this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
        }
        /** @internal */
        UrlService.prototype.dispose = function () {
            this.listen(false);
            this.rules.dispose();
        };
        /**
         * Gets the current URL parts
         *
         * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
         */
        UrlService.prototype.parts = function () {
            return { path: this.path(), search: this.search(), hash: this.hash() };
        };
        /**
         * Activates the best rule for the current URL
         *
         * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
         * This method is called internally any time the URL has changed.
         *
         * This effectively activates the state (or redirect, etc) which matches the current URL.
         *
         * #### Example:
         * ```js
         * urlService.deferIntercept();
         *
         * fetch('/states.json').then(resp => resp.json()).then(data => {
         *   data.forEach(state => $stateRegistry.register(state));
         *   urlService.listen();
         *   // Find the matching URL and invoke the handler.
         *   urlService.sync();
         * });
         * ```
         */
        UrlService.prototype.sync = function (evt) {
            if (evt && evt.defaultPrevented)
                return;
            var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
            var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
            var best = this.match(url);
            var applyResult = pattern([
                [isString, function (newurl) { return urlService.url(newurl, true); }],
                [TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
                [is(TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
            ]);
            applyResult(best && best.rule.handler(best.match, url, this.router));
        };
        /**
         * Starts or stops listening for URL changes
         *
         * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
         * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
         *
         * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
         *
         * #### Example:
         * ```js
         * urlService.deferIntercept();
         *
         * fetch('/states.json').then(resp => resp.json()).then(data => {
         *   data.forEach(state => $stateRegistry.register(state));
         *   // Start responding to URL changes
         *   urlService.listen();
         *   urlService.sync();
         * });
         * ```
         *
         * @param enabled `true` or `false` to start or stop listening to URL changes
         */
        UrlService.prototype.listen = function (enabled) {
            var _this = this;
            if (enabled === false) {
                this._stopListeningFn && this._stopListeningFn();
                delete this._stopListeningFn;
            }
            else {
                return (this._stopListeningFn =
                    this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
            }
        };
        /**
         * Disables monitoring of the URL.
         *
         * Call this method before UI-Router has bootstrapped.
         * It will stop UI-Router from performing the initial url sync.
         *
         * This can be useful to perform some asynchronous initialization before the router starts.
         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
         *
         * #### Example:
         * ```js
         * // Prevent UI-Router from automatically intercepting URL changes when it starts;
         * urlService.deferIntercept();
         *
         * fetch('/states.json').then(resp => resp.json()).then(data => {
         *   data.forEach(state => $stateRegistry.register(state));
         *   urlService.listen();
         *   urlService.sync();
         * });
         * ```
         *
         * @param defer Indicates whether to defer location change interception.
         *        Passing no parameter is equivalent to `true`.
         */
        UrlService.prototype.deferIntercept = function (defer) {
            if (defer === undefined)
                defer = true;
            this.interceptDeferred = defer;
        };
        /**
         * Matches a URL
         *
         * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
         * Return the result as a [[MatchResult]].
         */
        UrlService.prototype.match = function (url) {
            var _this = this;
            url = extend({ path: '', search: {}, hash: '' }, url);
            var rules = this.rules.rules();
            // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
            var checkRule = function (rule) {
                var match = rule.match(url, _this.router);
                return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
            };
            // The rules are pre-sorted.
            // - Find the first matching rule.
            // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
            // - Choose the rule with the highest match weight.
            var best;
            for (var i = 0; i < rules.length; i++) {
                // Stop when there is a 'best' rule and the next rule sorts differently than it.
                if (best && best.rule._group !== rules[i]._group)
                    break;
                var current = checkRule(rules[i]);
                // Pick the best MatchResult
                best = !best || (current && current.weight > best.weight) ? current : best;
            }
            return best;
        };
        return UrlService;
    }());

    /** @internal */
    var _routerInstance = 0;
    /** @internal */
    var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
    /** @internal */
    var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
    /** @internal */
    var locationServiceStub = makeStub('LocationServices', locSvcFns);
    /** @internal */
    var locationConfigStub = makeStub('LocationConfig', locCfgFns);
    /**
     * An instance of UI-Router.
     *
     * This object contains references to service APIs which define your application's routing behavior.
     */
    var UIRouter = /** @class */ (function () {
        /**
         * Creates a new `UIRouter` object
         *
         * @param locationService a [[LocationServices]] implementation
         * @param locationConfig a [[LocationConfig]] implementation
         * @internal
         */
        function UIRouter(locationService, locationConfig) {
            if (locationService === void 0) { locationService = locationServiceStub; }
            if (locationConfig === void 0) { locationConfig = locationConfigStub; }
            this.locationService = locationService;
            this.locationConfig = locationConfig;
            /** @internal */ this.$id = _routerInstance++;
            /** @internal */ this._disposed = false;
            /** @internal */ this._disposables = [];
            /** Enable/disable tracing to the javascript console */
            this.trace = trace;
            /** Provides services related to ui-view synchronization */
            this.viewService = new ViewService(this);
            /** An object that contains global router state, such as the current state and params */
            this.globals = new UIRouterGlobals();
            /** A service that exposes global Transition Hooks */
            this.transitionService = new TransitionService(this);
            /**
             * Deprecated for public use. Use [[urlService]] instead.
             * @deprecated Use [[urlService]] instead
             */
            this.urlMatcherFactory = new UrlMatcherFactory(this);
            /**
             * Deprecated for public use. Use [[urlService]] instead.
             * @deprecated Use [[urlService]] instead
             */
            this.urlRouter = new UrlRouter(this);
            /** Provides services related to the URL */
            this.urlService = new UrlService(this);
            /** Provides a registry for states, and related registration services */
            this.stateRegistry = new StateRegistry(this);
            /** Provides services related to states */
            this.stateService = new StateService(this);
            /** @internal plugin instances are registered here */
            this._plugins = {};
            this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
            this.globals.$current = this.stateRegistry.root();
            this.globals.current = this.globals.$current.self;
            this.disposable(this.globals);
            this.disposable(this.stateService);
            this.disposable(this.stateRegistry);
            this.disposable(this.transitionService);
            this.disposable(this.urlService);
            this.disposable(locationService);
            this.disposable(locationConfig);
        }
        /** Registers an object to be notified when the router is disposed */
        UIRouter.prototype.disposable = function (disposable) {
            this._disposables.push(disposable);
        };
        /**
         * Disposes this router instance
         *
         * When called, clears resources retained by the router by calling `dispose(this)` on all
         * registered [[disposable]] objects.
         *
         * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
         *
         * @internal
         * @param disposable (optional) the disposable to dispose
         */
        UIRouter.prototype.dispose = function (disposable) {
            var _this = this;
            if (disposable && isFunction(disposable.dispose)) {
                disposable.dispose(this);
                return undefined;
            }
            this._disposed = true;
            this._disposables.slice().forEach(function (d) {
                try {
                    typeof d.dispose === 'function' && d.dispose(_this);
                    removeFrom(_this._disposables, d);
                }
                catch (ignored) { }
            });
        };
        /**
         * Adds a plugin to UI-Router
         *
         * This method adds a UI-Router Plugin.
         * A plugin can enhance or change UI-Router behavior using any public API.
         *
         * #### Example:
         * ```js
         * import { MyCoolPlugin } from "ui-router-cool-plugin";
         *
         * var plugin = router.addPlugin(MyCoolPlugin);
         * ```
         *
         * ### Plugin authoring
         *
         * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
         *
         * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
         * For example, it may configure router options or add a Transition Hook.
         *
         * The plugin can then be published as a separate module.
         *
         * #### Example:
         * ```js
         * export class MyAuthPlugin implements UIRouterPlugin {
         *   constructor(router: UIRouter, options: any) {
         *     this.name = "MyAuthPlugin";
         *     let $transitions = router.transitionService;
         *     let $state = router.stateService;
         *
         *     let authCriteria = {
         *       to: (state) => state.data && state.data.requiresAuth
         *     };
         *
         *     function authHook(transition: Transition) {
         *       let authService = transition.injector().get('AuthService');
         *       if (!authService.isAuthenticated()) {
         *         return $state.target('login');
         *       }
         *     }
         *
         *     $transitions.onStart(authCriteria, authHook);
         *   }
         * }
         * ```
         *
         * @param plugin one of:
         *        - a plugin class which implements [[UIRouterPlugin]]
         *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
         *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
         * @param options options to pass to the plugin class/factory
         * @returns the registered plugin instance
         */
        UIRouter.prototype.plugin = function (plugin, options) {
            if (options === void 0) { options = {}; }
            var pluginInstance = new plugin(this, options);
            if (!pluginInstance.name)
                throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
            this._disposables.push(pluginInstance);
            return (this._plugins[pluginInstance.name] = pluginInstance);
        };
        UIRouter.prototype.getPlugin = function (pluginName) {
            return pluginName ? this._plugins[pluginName] : values(this._plugins);
        };
        return UIRouter;
    }());

    function addCoreResolvables(trans) {
        trans.addResolvable(Resolvable.fromData(UIRouter, trans.router), '');
        trans.addResolvable(Resolvable.fromData(Transition, trans), '');
        trans.addResolvable(Resolvable.fromData('$transition$', trans), '');
        trans.addResolvable(Resolvable.fromData('$stateParams', trans.params()), '');
        trans.entering().forEach(function (state) {
            trans.addResolvable(Resolvable.fromData('$state$', state), state);
        });
    }
    var registerAddCoreResolvables = function (transitionService) {
        return transitionService.onCreate({}, addCoreResolvables);
    };
    var TRANSITION_TOKENS = ['$transition$', Transition];
    var isTransition = inArray(TRANSITION_TOKENS);
    // References to Transition in the treeChanges pathnodes makes all
    // previous Transitions reachable in memory, causing a memory leak
    // This function removes resolves for '$transition$' and `Transition` from the treeChanges.
    // Do not use this on current transitions, only on old ones.
    var treeChangesCleanup = function (trans) {
        var nodes = values(trans.treeChanges()).reduce(unnestR, []).reduce(uniqR, []);
        // If the resolvable is a Transition, return a new resolvable with null data
        var replaceTransitionWithNull = function (r) {
            return isTransition(r.token) ? Resolvable.fromData(r.token, null) : r;
        };
        nodes.forEach(function (node) {
            node.resolvables = node.resolvables.map(replaceTransitionWithNull);
        });
    };

    /**
     * A [[TransitionHookFn]] that redirects to a different state or params
     *
     * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
     *
     * See [[StateDeclaration.redirectTo]]
     */
    var redirectToHook = function (trans) {
        var redirect = trans.to().redirectTo;
        if (!redirect)
            return;
        var $state = trans.router.stateService;
        function handleResult(result) {
            if (!result)
                return;
            if (result instanceof TargetState)
                return result;
            if (isString(result))
                return $state.target(result, trans.params(), trans.options());
            if (result['state'] || result['params'])
                return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
        }
        if (isFunction(redirect)) {
            return services.$q.when(redirect(trans)).then(handleResult);
        }
        return handleResult(redirect);
    };
    var registerRedirectToHook = function (transitionService) {
        return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
    };

    /**
     * A factory which creates an onEnter, onExit or onRetain transition hook function
     *
     * The returned function invokes the (for instance) state.onEnter hook when the
     * state is being entered.
     */
    function makeEnterExitRetainHook(hookName) {
        return function (transition, state) {
            var _state = state.$$state();
            var hookFn = _state[hookName];
            return hookFn(transition, state);
        };
    }
    /**
     * The [[TransitionStateHookFn]] for onExit
     *
     * When the state is being exited, the state's .onExit function is invoked.
     *
     * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
     *
     * See: [[IHookRegistry.onExit]]
     */
    var onExitHook = makeEnterExitRetainHook('onExit');
    var registerOnExitHook = function (transitionService) {
        return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
    };
    /**
     * The [[TransitionStateHookFn]] for onRetain
     *
     * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
     *
     * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
     *
     * See: [[IHookRegistry.onRetain]]
     */
    var onRetainHook = makeEnterExitRetainHook('onRetain');
    var registerOnRetainHook = function (transitionService) {
        return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
    };
    /**
     * The [[TransitionStateHookFn]] for onEnter
     *
     * When the state is being entered, the state's .onEnter function is invoked.
     *
     * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
     *
     * See: [[IHookRegistry.onEnter]]
     */
    var onEnterHook = makeEnterExitRetainHook('onEnter');
    var registerOnEnterHook = function (transitionService) {
        return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
    };

    var RESOLVE_HOOK_PRIORITY = 1000;
    /**
     * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
     *
     * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
     *
     * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
     *
     * See [[StateDeclaration.resolve]]
     */
    var eagerResolvePath = function (trans) {
        return new ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(noop);
    };
    var registerEagerResolvePath = function (transitionService) {
        return transitionService.onStart({}, eagerResolvePath, { priority: RESOLVE_HOOK_PRIORITY });
    };
    /**
     * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
     *
     * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
     *
     * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
     *
     * See [[StateDeclaration.resolve]]
     */
    var lazyResolveState = function (trans, state) {
        return new ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(noop);
    };
    var registerLazyResolveState = function (transitionService) {
        return transitionService.onEnter({ entering: val(true) }, lazyResolveState, { priority: RESOLVE_HOOK_PRIORITY });
    };
    /**
     * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
     *
     * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
     *
     * After all entering states have been entered, this hook resolves any remaining Resolvables.
     * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
     *
     * See [[StateDeclaration.resolve]]
     */
    var resolveRemaining = function (trans) {
        return new ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(noop);
    };
    var registerResolveRemaining = function (transitionService) {
        return transitionService.onFinish({}, resolveRemaining, { priority: RESOLVE_HOOK_PRIORITY });
    };

    /**
     * A [[TransitionHookFn]] which waits for the views to load
     *
     * Registered using `transitionService.onStart({}, loadEnteringViews);`
     *
     * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
     * In angular 1, this includes loading the templates.
     */
    var loadEnteringViews = function (transition) {
        var $q = services.$q;
        var enteringViews = transition.views('entering');
        if (!enteringViews.length)
            return;
        return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(noop);
    };
    var registerLoadEnteringViews = function (transitionService) {
        return transitionService.onFinish({}, loadEnteringViews);
    };
    /**
     * A [[TransitionHookFn]] which activates the new views when a transition is successful.
     *
     * Registered using `transitionService.onSuccess({}, activateViews);`
     *
     * After a transition is complete, this hook deactivates the old views from the previous state,
     * and activates the new views from the destination state.
     *
     * See [[ViewService]]
     */
    var activateViews = function (transition) {
        var enteringViews = transition.views('entering');
        var exitingViews = transition.views('exiting');
        if (!enteringViews.length && !exitingViews.length)
            return;
        var $view = transition.router.viewService;
        exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
        enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
        $view.sync();
    };
    var registerActivateViews = function (transitionService) {
        return transitionService.onSuccess({}, activateViews);
    };

    /**
     * A [[TransitionHookFn]] which updates global UI-Router state
     *
     * Registered using `transitionService.onBefore({}, updateGlobalState);`
     *
     * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
     * After a successful [[Transition]], updates the global values of "the current state"
     * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
     *
     * See also the deprecated properties:
     * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
     */
    var updateGlobalState = function (trans) {
        var globals = trans.router.globals;
        var transitionSuccessful = function () {
            globals.successfulTransitions.enqueue(trans);
            globals.$current = trans.$to();
            globals.current = globals.$current.self;
            copy(trans.params(), globals.params);
        };
        var clearCurrentTransition = function () {
            // Do not clear globals.transition if a different transition has started in the meantime
            if (globals.transition === trans)
                globals.transition = null;
        };
        trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
        trans.promise.then(clearCurrentTransition, clearCurrentTransition);
    };
    var registerUpdateGlobalState = function (transitionService) {
        return transitionService.onCreate({}, updateGlobalState);
    };

    /**
     * A [[TransitionHookFn]] which updates the URL after a successful transition
     *
     * Registered using `transitionService.onSuccess({}, updateUrl);`
     */
    var updateUrl = function (transition) {
        var options = transition.options();
        var $state = transition.router.stateService;
        var $urlRouter = transition.router.urlRouter;
        // Dont update the url in these situations:
        // The transition was triggered by a URL sync (options.source === 'url')
        // The user doesn't want the url to update (options.location === false)
        // The destination state, and all parents have no navigable url
        if (options.source !== 'url' && options.location && $state.$current.navigable) {
            var urlOptions = { replace: options.location === 'replace' };
            $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
        }
        $urlRouter.update(true);
    };
    var registerUpdateUrl = function (transitionService) {
        return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
    };

    /**
     * A [[TransitionHookFn]] that performs lazy loading
     *
     * When entering a state "abc" which has a `lazyLoad` function defined:
     * - Invoke the `lazyLoad` function (unless it is already in process)
     *   - Flag the hook function as "in process"
     *   - The function should return a promise (that resolves when lazy loading is complete)
     * - Wait for the promise to settle
     *   - If the promise resolves to a [[LazyLoadResult]], then register those states
     *   - Flag the hook function as "not in process"
     * - If the hook was successful
     *   - Remove the `lazyLoad` function from the state declaration
     * - If all the hooks were successful
     *   - Retry the transition (by returning a TargetState)
     *
     * ```
     * .state('abc', {
     *   component: 'fooComponent',
     *   lazyLoad: () => import('./fooComponent')
     *   });
     * ```
     *
     * See [[StateDeclaration.lazyLoad]]
     */
    var lazyLoadHook = function (transition) {
        var router = transition.router;
        function retryTransition() {
            if (transition.originalTransition().options().source !== 'url') {
                // The original transition was not triggered via url sync
                // The lazy state should be loaded now, so re-try the original transition
                var orig = transition.targetState();
                return router.stateService.target(orig.identifier(), orig.params(), orig.options());
            }
            // The original transition was triggered via url sync
            // Run the URL rules and find the best match
            var $url = router.urlService;
            var result = $url.match($url.parts());
            var rule = result && result.rule;
            // If the best match is a state, redirect the transition (instead
            // of calling sync() which supersedes the current transition)
            if (rule && rule.type === 'STATE') {
                var state = rule.state;
                var params = result.match;
                return router.stateService.target(state, params, transition.options());
            }
            // No matching state found, so let .sync() choose the best non-state match/otherwise
            router.urlService.sync();
        }
        var promises = transition
            .entering()
            .filter(function (state) { return !!state.$$state().lazyLoad; })
            .map(function (state) { return lazyLoadState(transition, state); });
        return services.$q.all(promises).then(retryTransition);
    };
    var registerLazyLoadHook = function (transitionService) {
        return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
    };
    /**
     * Invokes a state's lazy load function
     *
     * @param transition a Transition context
     * @param state the state to lazy load
     * @returns A promise for the lazy load result
     */
    function lazyLoadState(transition, state) {
        var lazyLoadFn = state.$$state().lazyLoad;
        // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
        var promise = lazyLoadFn['_promise'];
        if (!promise) {
            var success = function (result) {
                delete state.lazyLoad;
                delete state.$$state().lazyLoad;
                delete lazyLoadFn['_promise'];
                return result;
            };
            var error = function (err) {
                delete lazyLoadFn['_promise'];
                return services.$q.reject(err);
            };
            promise = lazyLoadFn['_promise'] = services.$q
                .when(lazyLoadFn(transition, state))
                .then(updateStateRegistry)
                .then(success, error);
        }
        /** Register any lazy loaded state definitions */
        function updateStateRegistry(result) {
            if (result && Array.isArray(result.states)) {
                result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
            }
            return result;
        }
        return promise;
    }

    /**
     * This class defines a type of hook, such as `onBefore` or `onEnter`.
     * Plugins can define custom hook types, such as sticky states does for `onInactive`.
     */
    var TransitionEventType = /** @class */ (function () {
        /* tslint:disable:no-inferrable-types */
        function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
            if (reverseSort === void 0) { reverseSort = false; }
            if (getResultHandler === void 0) { getResultHandler = TransitionHook.HANDLE_RESULT; }
            if (getErrorHandler === void 0) { getErrorHandler = TransitionHook.REJECT_ERROR; }
            if (synchronous === void 0) { synchronous = false; }
            this.name = name;
            this.hookPhase = hookPhase;
            this.hookOrder = hookOrder;
            this.criteriaMatchPath = criteriaMatchPath;
            this.reverseSort = reverseSort;
            this.getResultHandler = getResultHandler;
            this.getErrorHandler = getErrorHandler;
            this.synchronous = synchronous;
        }
        return TransitionEventType;
    }());

    /**
     * A [[TransitionHookFn]] that skips a transition if it should be ignored
     *
     * This hook is invoked at the end of the onBefore phase.
     *
     * If the transition should be ignored (because no parameter or states changed)
     * then the transition is ignored and not processed.
     */
    function ignoredHook(trans) {
        var ignoredReason = trans._ignoredReason();
        if (!ignoredReason)
            return;
        trace.traceTransitionIgnored(trans);
        var pending = trans.router.globals.transition;
        // The user clicked a link going back to the *current state* ('A')
        // However, there is also a pending transition in flight (to 'B')
        // Abort the transition to 'B' because the user now wants to be back at 'A'.
        if (ignoredReason === 'SameAsCurrent' && pending) {
            pending.abort();
        }
        return Rejection.ignored().toPromise();
    }
    var registerIgnoredTransitionHook = function (transitionService) {
        return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
    };

    /**
     * A [[TransitionHookFn]] that rejects the Transition if it is invalid
     *
     * This hook is invoked at the end of the onBefore phase.
     * If the transition is invalid (for example, param values do not validate)
     * then the transition is rejected.
     */
    function invalidTransitionHook(trans) {
        if (!trans.valid()) {
            throw new Error(trans.error().toString());
        }
    }
    var registerInvalidTransitionHook = function (transitionService) {
        return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
    };

    /**
     * The default [[Transition]] options.
     *
     * Include this object when applying custom defaults:
     * let reloadOpts = { reload: true, notify: true }
     * let options = defaults(theirOpts, customDefaults, defaultOptions);
     */
    var defaultTransOpts = {
        location: true,
        relative: null,
        inherit: false,
        notify: true,
        reload: false,
        supercede: true,
        custom: {},
        current: function () { return null; },
        source: 'unknown',
    };
    /**
     * This class provides services related to Transitions.
     *
     * - Most importantly, it allows global Transition Hooks to be registered.
     * - It allows the default transition error handler to be set.
     * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
     *
     * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
     *
     * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
     */
    var TransitionService = /** @class */ (function () {
        /** @internal */
        function TransitionService(_router) {
            /** @internal */
            this._transitionCount = 0;
            /** The transition hook types, such as `onEnter`, `onStart`, etc */
            this._eventTypes = [];
            /** @internal The registered transition hooks */
            this._registeredHooks = {};
            /** The  paths on a criteria object */
            this._criteriaPaths = {};
            this._router = _router;
            this.$view = _router.viewService;
            this._deregisterHookFns = {};
            this._pluginapi = (createProxyFunctions(val(this), {}, val(this), [
                '_definePathType',
                '_defineEvent',
                '_getPathTypes',
                '_getEvents',
                'getHooks',
            ]));
            this._defineCorePaths();
            this._defineCoreEvents();
            this._registerCoreTransitionHooks();
            _router.globals.successfulTransitions.onEvict(treeChangesCleanup);
        }
        /**
         * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
         *
         * Registers a transition lifecycle hook, which is invoked during transition construction.
         *
         * This low level hook should only be used by plugins.
         * This can be a useful time for plugins to add resolves or mutate the transition as needed.
         * The Sticky States plugin uses this hook to modify the treechanges.
         *
         * ### Lifecycle
         *
         * `onCreate` hooks are invoked *while a transition is being constructed*.
         *
         * ### Return value
         *
         * The hook's return value is ignored
         *
         * @internal
         * @param criteria defines which Transitions the Hook should be invoked for.
         * @param callback the hook function which will be invoked.
         * @param options the registration options
         * @returns a function which deregisters the hook.
         */
        TransitionService.prototype.onCreate = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onBefore = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onStart = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onExit = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onRetain = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onEnter = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onFinish = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onSuccess = function (criteria, callback, options) {
            return;
        };
        /** @inheritdoc */
        TransitionService.prototype.onError = function (criteria, callback, options) {
            return;
        };
        /**
         * dispose
         * @internal
         */
        TransitionService.prototype.dispose = function (router) {
            values(this._registeredHooks).forEach(function (hooksArray) {
                return hooksArray.forEach(function (hook) {
                    hook._deregistered = true;
                    removeFrom(hooksArray, hook);
                });
            });
        };
        /**
         * Creates a new [[Transition]] object
         *
         * This is a factory function for creating new Transition objects.
         * It is used internally by the [[StateService]] and should generally not be called by application code.
         *
         * @internal
         * @param fromPath the path to the current state (the from state)
         * @param targetState the target state (destination)
         * @returns a Transition
         */
        TransitionService.prototype.create = function (fromPath, targetState) {
            return new Transition(fromPath, targetState, this._router);
        };
        /** @internal */
        TransitionService.prototype._defineCoreEvents = function () {
            var Phase = exports.TransitionHookPhase;
            var TH = TransitionHook;
            var paths = this._criteriaPaths;
            var NORMAL_SORT = false, REVERSE_SORT = true;
            var SYNCHRONOUS = true;
            this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
            this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
            this._defineEvent('onStart', Phase.RUN, 0, paths.to);
            this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
            this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
            this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
            this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
            this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
            this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
        };
        /** @internal */
        TransitionService.prototype._defineCorePaths = function () {
            var STATE = exports.TransitionHookScope.STATE, TRANSITION = exports.TransitionHookScope.TRANSITION;
            this._definePathType('to', TRANSITION);
            this._definePathType('from', TRANSITION);
            this._definePathType('exiting', STATE);
            this._definePathType('retained', STATE);
            this._definePathType('entering', STATE);
        };
        /** @internal */
        TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
            if (reverseSort === void 0) { reverseSort = false; }
            if (getResultHandler === void 0) { getResultHandler = TransitionHook.HANDLE_RESULT; }
            if (getErrorHandler === void 0) { getErrorHandler = TransitionHook.REJECT_ERROR; }
            if (synchronous === void 0) { synchronous = false; }
            var eventType = new TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
            this._eventTypes.push(eventType);
            makeEvent(this, this, eventType);
        };
        /** @internal */
        TransitionService.prototype._getEvents = function (phase) {
            var transitionHookTypes = isDefined(phase)
                ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
                : this._eventTypes.slice();
            return transitionHookTypes.sort(function (l, r) {
                var cmpByPhase = l.hookPhase - r.hookPhase;
                return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
            });
        };
        /**
         * Adds a Path to be used as a criterion against a TreeChanges path
         *
         * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
         * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
         * Each state in the exiting path is checked against the criteria and returned as part of the match.
         *
         * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
         * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
         * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
         *
         * @internal
         */
        TransitionService.prototype._definePathType = function (name, hookScope) {
            this._criteriaPaths[name] = { name: name, scope: hookScope };
        };
        /** @internal */
        // tslint:disable-next-line
        TransitionService.prototype._getPathTypes = function () {
            return this._criteriaPaths;
        };
        /** @internal */
        TransitionService.prototype.getHooks = function (hookName) {
            return this._registeredHooks[hookName];
        };
        /** @internal */
        TransitionService.prototype._registerCoreTransitionHooks = function () {
            var fns = this._deregisterHookFns;
            fns.addCoreResolves = registerAddCoreResolvables(this);
            fns.ignored = registerIgnoredTransitionHook(this);
            fns.invalid = registerInvalidTransitionHook(this);
            // Wire up redirectTo hook
            fns.redirectTo = registerRedirectToHook(this);
            // Wire up onExit/Retain/Enter state hooks
            fns.onExit = registerOnExitHook(this);
            fns.onRetain = registerOnRetainHook(this);
            fns.onEnter = registerOnEnterHook(this);
            // Wire up Resolve hooks
            fns.eagerResolve = registerEagerResolvePath(this);
            fns.lazyResolve = registerLazyResolveState(this);
            fns.resolveAll = registerResolveRemaining(this);
            // Wire up the View management hooks
            fns.loadViews = registerLoadEnteringViews(this);
            fns.activateViews = registerActivateViews(this);
            // Updates global state after a transition
            fns.updateGlobals = registerUpdateGlobalState(this);
            // After globals.current is updated at priority: 10000
            fns.updateUrl = registerUpdateUrl(this);
            // Lazy load state trees
            fns.lazyLoad = registerLazyLoadHook(this);
        };
        return TransitionService;
    }());

    /**
     * Provides services related to ui-router states.
     *
     * This API is located at `router.stateService` ([[UIRouter.stateService]])
     */
    var StateService = /** @class */ (function () {
        /** @internal */
        function StateService(/** @internal */ router) {
            this.router = router;
            /** @internal */
            this.invalidCallbacks = [];
            /** @internal */
            this._defaultErrorHandler = function $defaultErrorHandler($error$) {
                if ($error$ instanceof Error && $error$.stack) {
                    console.error($error$);
                    console.error($error$.stack);
                }
                else if ($error$ instanceof Rejection) {
                    console.error($error$.toString());
                    if ($error$.detail && $error$.detail.stack)
                        console.error($error$.detail.stack);
                }
                else {
                    console.error($error$);
                }
            };
            var getters = ['current', '$current', 'params', 'transition'];
            var boundFns = Object.keys(StateService.prototype).filter(not(inArray(getters)));
            createProxyFunctions(val(StateService.prototype), this, val(this), boundFns);
        }
        Object.defineProperty(StateService.prototype, "transition", {
            /**
             * The [[Transition]] currently in progress (or null)
             *
             * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
             */
            get: function () {
                return this.router.globals.transition;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateService.prototype, "params", {
            /**
             * The latest successful state parameters
             *
             * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
             */
            get: function () {
                return this.router.globals.params;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateService.prototype, "current", {
            /**
             * The current [[StateDeclaration]]
             *
             * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
             */
            get: function () {
                return this.router.globals.current;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateService.prototype, "$current", {
            /**
             * The current [[StateObject]] (an internal API)
             *
             * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
             */
            get: function () {
                return this.router.globals.$current;
            },
            enumerable: false,
            configurable: true
        });
        /** @internal */
        StateService.prototype.dispose = function () {
            this.defaultErrorHandler(noop);
            this.invalidCallbacks = [];
        };
        /**
         * Handler for when [[transitionTo]] is called with an invalid state.
         *
         * Invokes the [[onInvalid]] callbacks, in natural order.
         * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
         * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
         *
         * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
         *
         * @internal
         */
        StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
            var _this = this;
            var fromState = PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
            var globals = this.router.globals;
            var latestThing = function () { return globals.transitionHistory.peekTail(); };
            var latest = latestThing();
            var callbackQueue = new Queue(this.invalidCallbacks.slice());
            var injector = new ResolveContext(fromPath).injector();
            var checkForRedirect = function (result) {
                if (!(result instanceof TargetState)) {
                    return;
                }
                var target = result;
                // Recreate the TargetState, in case the state is now defined.
                target = _this.target(target.identifier(), target.params(), target.options());
                if (!target.valid()) {
                    return Rejection.invalid(target.error()).toPromise();
                }
                if (latestThing() !== latest) {
                    return Rejection.superseded().toPromise();
                }
                return _this.transitionTo(target.identifier(), target.params(), target.options());
            };
            function invokeNextCallback() {
                var nextCallback = callbackQueue.dequeue();
                if (nextCallback === undefined)
                    return Rejection.invalid(toState.error()).toPromise();
                var callbackResult = services.$q.when(nextCallback(toState, fromState, injector));
                return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
            }
            return invokeNextCallback();
        };
        /**
         * Registers an Invalid State handler
         *
         * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
         * has been called with an invalid state reference parameter
         *
         * Example:
         * ```js
         * stateService.onInvalid(function(to, from, injector) {
         *   if (to.name() === 'foo') {
         *     let lazyLoader = injector.get('LazyLoadService');
         *     return lazyLoader.load('foo')
         *         .then(() => stateService.target('foo'));
         *   }
         * });
         * ```
         *
         * @param {function} callback invoked when the toState is invalid
         *   This function receives the (invalid) toState, the fromState, and an injector.
         *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
         *   If one is returned, it is treated as a redirect.
         *
         * @returns a function which deregisters the callback
         */
        StateService.prototype.onInvalid = function (callback) {
            this.invalidCallbacks.push(callback);
            return function deregisterListener() {
                removeFrom(this.invalidCallbacks)(callback);
            }.bind(this);
        };
        /**
         * Reloads the current state
         *
         * A method that force reloads the current state, or a partial state hierarchy.
         * All resolves are re-resolved, and components reinstantiated.
         *
         * #### Example:
         * ```js
         * let app angular.module('app', ['ui.router']);
         *
         * app.controller('ctrl', function ($scope, $state) {
         *   $scope.reload = function(){
         *     $state.reload();
         *   }
         * });
         * ```
         *
         * Note: `reload()` is just an alias for:
         *
         * ```js
         * $state.transitionTo($state.current, $state.params, {
         *   reload: true, inherit: false
         * });
         * ```
         *
         * @param reloadState A state name or a state object.
         *    If present, this state and all its children will be reloaded, but ancestors will not reload.
         *
         * #### Example:
         * ```js
         * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
         * //and current state is 'contacts.detail.item'
         * let app angular.module('app', ['ui.router']);
         *
         * app.controller('ctrl', function ($scope, $state) {
         *   $scope.reload = function(){
         *     //will reload 'contact.detail' and nested 'contact.detail.item' states
         *     $state.reload('contact.detail');
         *   }
         * });
         * ```
         *
         * @returns A promise representing the state of the new transition. See [[StateService.go]]
         */
        StateService.prototype.reload = function (reloadState) {
            return this.transitionTo(this.current, this.params, {
                reload: isDefined(reloadState) ? reloadState : true,
                inherit: false,
                notify: false,
            });
        };
        /**
         * Transition to a different state and/or parameters
         *
         * Convenience method for transitioning to a new state.
         *
         * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
         * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
         * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
         * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
         * inherit from the current parameter values (because of `inherit: true`).
         *
         * #### Example:
         * ```js
         * let app = angular.module('app', ['ui.router']);
         *
         * app.controller('ctrl', function ($scope, $state) {
         *   $scope.changeState = function () {
         *     $state.go('contact.detail');
         *   };
         * });
         * ```
         *
         * @param to Absolute state name, state object, or relative state path (relative to current state).
         *
         * Some examples:
         *
         * - `$state.go('contact.detail')` - will go to the `contact.detail` state
         * - `$state.go('^')` - will go to the parent state
         * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
         * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
         *
         * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
         *
         *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
         *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
         *
         * @param options Transition options
         *
         * @returns {promise} A promise representing the state of the new transition.
         */
        StateService.prototype.go = function (to, params, options) {
            var defautGoOpts = { relative: this.$current, inherit: true };
            var transOpts = defaults(options, defautGoOpts, defaultTransOpts);
            return this.transitionTo(to, params, transOpts);
        };
        /**
         * Creates a [[TargetState]]
         *
         * This is a factory method for creating a TargetState
         *
         * This may be returned from a Transition Hook to redirect a transition, for example.
         */
        StateService.prototype.target = function (identifier, params, options) {
            if (options === void 0) { options = {}; }
            // If we're reloading, find the state object to reload from
            if (isObject(options.reload) && !options.reload.name)
                throw new Error('Invalid reload state object');
            var reg = this.router.stateRegistry;
            options.reloadState =
                options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
            if (options.reload && !options.reloadState)
                throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
            return new TargetState(this.router.stateRegistry, identifier, params, options);
        };
        /** @internal */
        StateService.prototype.getCurrentPath = function () {
            var _this = this;
            var globals = this.router.globals;
            var latestSuccess = globals.successfulTransitions.peekTail();
            var rootPath = function () { return [new PathNode(_this.router.stateRegistry.root())]; };
            return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
        };
        /**
         * Low-level method for transitioning to a new state.
         *
         * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
         *
         * #### Example:
         * ```js
         * let app = angular.module('app', ['ui.router']);
         *
         * app.controller('ctrl', function ($scope, $state) {
         *   $scope.changeState = function () {
         *     $state.transitionTo('contact.detail');
         *   };
         * });
         * ```
         *
         * @param to State name or state object.
         * @param toParams A map of the parameters that will be sent to the state,
         *      will populate $stateParams.
         * @param options Transition options
         *
         * @returns A promise representing the state of the new transition. See [[go]]
         */
        StateService.prototype.transitionTo = function (to, toParams, options) {
            var _this = this;
            if (toParams === void 0) { toParams = {}; }
            if (options === void 0) { options = {}; }
            var router = this.router;
            var globals = router.globals;
            options = defaults(options, defaultTransOpts);
            var getCurrent = function () { return globals.transition; };
            options = extend(options, { current: getCurrent });
            var ref = this.target(to, toParams, options);
            var currentPath = this.getCurrentPath();
            if (!ref.exists())
                return this._handleInvalidTargetState(currentPath, ref);
            if (!ref.valid())
                return silentRejection(ref.error());
            if (options.supercede === false && getCurrent()) {
                return (Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise());
            }
            /**
             * Special handling for Ignored, Aborted, and Redirected transitions
             *
             * The semantics for the transition.run() promise and the StateService.transitionTo()
             * promise differ. For instance, the run() promise may be rejected because it was
             * IGNORED, but the transitionTo() promise is resolved because from the user perspective
             * no error occurred.  Likewise, the transition.run() promise may be rejected because of
             * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
             */
            var rejectedTransitionHandler = function (trans) { return function (error) {
                if (error instanceof Rejection) {
                    var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
                    if (error.type === exports.RejectType.IGNORED) {
                        isLatest && router.urlRouter.update();
                        // Consider ignored `Transition.run()` as a successful `transitionTo`
                        return services.$q.when(globals.current);
                    }
                    var detail = error.detail;
                    if (error.type === exports.RejectType.SUPERSEDED && error.redirected && detail instanceof TargetState) {
                        // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
                        // by returning the promise for the new (redirect) `Transition.run()`.
                        var redirect = trans.redirect(detail);
                        return redirect.run().catch(rejectedTransitionHandler(redirect));
                    }
                    if (error.type === exports.RejectType.ABORTED) {
                        isLatest && router.urlRouter.update();
                        return services.$q.reject(error);
                    }
                }
                var errorHandler = _this.defaultErrorHandler();
                errorHandler(error);
                return services.$q.reject(error);
            }; };
            var transition = this.router.transitionService.create(currentPath, ref);
            var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
            silenceUncaughtInPromise(transitionToPromise); // issue #2676
            // Return a promise for the transition, which also has the transition object on it.
            return extend(transitionToPromise, { transition: transition });
        };
        /**
         * Checks if the current state *is* the provided state
         *
         * Similar to [[includes]] but only checks for the full state name.
         * If params is supplied then it will be tested for strict equality against the current
         * active params object, so all params must match with none missing and no extras.
         *
         * #### Example:
         * ```js
         * $state.$current.name = 'contacts.details.item';
         *
         * // absolute name
         * $state.is('contact.details.item'); // returns true
         * $state.is(contactDetailItemStateObject); // returns true
         * ```
         *
         * // relative name (. and ^), typically from a template
         * // E.g. from the 'contacts.details' template
         * ```html
         * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
         * ```
         *
         * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
         * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
         * to test against the current active state.
         * @param options An options object. The options are:
         *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
         *     test relative to `options.relative` state (or name).
         *
         * @returns Returns true if it is the state.
         */
        StateService.prototype.is = function (stateOrName, params, options) {
            options = defaults(options, { relative: this.$current });
            var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
            if (!isDefined(state))
                return undefined;
            if (this.$current !== state)
                return false;
            if (!params)
                return true;
            var schema = state.parameters({ inherit: true, matchingKeys: params });
            return Param.equals(schema, Param.values(schema, params), this.params);
        };
        /**
         * Checks if the current state *includes* the provided state
         *
         * A method to determine if the current active state is equal to or is the child of the
         * state stateName. If any params are passed then they will be tested for a match as well.
         * Not all the parameters need to be passed, just the ones you'd like to test for equality.
         *
         * #### Example when `$state.$current.name === 'contacts.details.item'`
         * ```js
         * // Using partial names
         * $state.includes("contacts"); // returns true
         * $state.includes("contacts.details"); // returns true
         * $state.includes("contacts.details.item"); // returns true
         * $state.includes("contacts.list"); // returns false
         * $state.includes("about"); // returns false
         * ```
         *
         * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
         * ```js
         * $state.includes("*.details.*.*"); // returns true
         * $state.includes("*.details.**"); // returns true
         * $state.includes("**.item.**"); // returns true
         * $state.includes("*.details.item.url"); // returns true
         * $state.includes("*.details.*.url"); // returns true
         * $state.includes("*.details.*"); // returns false
         * $state.includes("item.**"); // returns false
         * ```
         *
         * @param stateOrName A partial name, relative name, glob pattern,
         *   or state object to be searched for within the current state name.
         * @param params A param object, e.g. `{sectionId: section.id}`,
         *   that you'd like to test against the current active state.
         * @param options An options object. The options are:
         *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
         *     test relative to `options.relative` state (or name).
         *
         * @returns {boolean} Returns true if it does include the state
         */
        StateService.prototype.includes = function (stateOrName, params, options) {
            options = defaults(options, { relative: this.$current });
            var glob = isString(stateOrName) && Glob.fromString(stateOrName);
            if (glob) {
                if (!glob.matches(this.$current.name))
                    return false;
                stateOrName = this.$current.name;
            }
            var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
            if (!isDefined(state))
                return undefined;
            if (!isDefined(include[state.name]))
                return false;
            if (!params)
                return true;
            var schema = state.parameters({ inherit: true, matchingKeys: params });
            return Param.equals(schema, Param.values(schema, params), this.params);
        };
        /**
         * Generates a URL for a state and parameters
         *
         * Returns the url for the given state populated with the given params.
         *
         * #### Example:
         * ```js
         * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
         * ```
         *
         * @param stateOrName The state name or state object you'd like to generate a url from.
         * @param params An object of parameter values to fill the state's required parameters.
         * @param options Options object. The options are:
         *
         * @returns {string} compiled state url
         */
        StateService.prototype.href = function (stateOrName, params, options) {
            var defaultHrefOpts = {
                lossy: true,
                inherit: true,
                absolute: false,
                relative: this.$current,
            };
            options = defaults(options, defaultHrefOpts);
            params = params || {};
            var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
            if (!isDefined(state))
                return null;
            if (options.inherit)
                params = this.params.$inherit(params, this.$current, state);
            var nav = state && options.lossy ? state.navigable : state;
            if (!nav || nav.url === undefined || nav.url === null) {
                return null;
            }
            return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
        };
        /**
         * Sets or gets the default [[transitionTo]] error handler.
         *
         * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
         * This includes errors caused by resolves and transition hooks.
         *
         * Note:
         * This handler does not receive certain Transition rejections.
         * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
         *
         * The built-in default error handler logs the error to the console.
         *
         * You can provide your own custom handler.
         *
         * #### Example:
         * ```js
         * stateService.defaultErrorHandler(function() {
         *   // Do not log transitionTo errors
         * });
         * ```
         *
         * @param handler a global error handler function
         * @returns the current global error handler
         */
        StateService.prototype.defaultErrorHandler = function (handler) {
            return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
        };
        StateService.prototype.get = function (stateOrName, base) {
            var reg = this.router.stateRegistry;
            if (arguments.length === 0)
                return reg.get();
            return reg.get(stateOrName, base || this.$current);
        };
        /**
         * Lazy loads a state
         *
         * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
         *
         * @param stateOrName the state that should be lazy loaded
         * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
         * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
         * This noop transition is not actually run.
         *
         * @returns a promise to lazy load
         */
        StateService.prototype.lazyLoad = function (stateOrName, transition) {
            var state = this.get(stateOrName);
            if (!state || !state.lazyLoad)
                throw new Error('Can not lazy load ' + stateOrName);
            var currentPath = this.getCurrentPath();
            var target = PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
            transition = transition || this.router.transitionService.create(currentPath, target);
            return lazyLoadState(transition, state);
        };
        return StateService;
    }());

    /**
     * An angular1-like promise api
     *
     * This object implements four methods similar to the
     * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
     *
     * UI-Router evolved from an angular 1 library to a framework agnostic library.
     * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
     *
     * This API provides native ES6 promise support wrapped as a $q-like API.
     * Internally, UI-Router uses this $q object to perform promise operations.
     * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
     *
     * $q-like promise api
     */
    var $q = {
        /** Normalizes a value as a promise */
        when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
        /** Normalizes a value as a promise rejection */
        reject: function (val) {
            return new Promise(function (resolve, reject) {
                reject(val);
            });
        },
        /** @returns a deferred object, which has `resolve` and `reject` functions */
        defer: function () {
            var deferred = {};
            deferred.promise = new Promise(function (resolve, reject) {
                deferred.resolve = resolve;
                deferred.reject = reject;
            });
            return deferred;
        },
        /** Like Promise.all(), but also supports object key/promise notation like $q */
        all: function (promises) {
            if (isArray(promises)) {
                return Promise.all(promises);
            }
            if (isObject(promises)) {
                // Convert promises map to promises array.
                // When each promise resolves, map it to a tuple { key: key, val: val }
                var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
                // Then wait for all promises to resolve, and convert them back to an object
                return $q.all(chain).then(function (values) {
                    return values.reduce(function (acc, tuple) {
                        acc[tuple.key] = tuple.val;
                        return acc;
                    }, {});
                });
            }
        },
    };

    // globally available injectables
    var globals = {};
    var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
    var ARGUMENT_NAMES = /([^\s,]+)/g;
    /**
     * A basic angular1-like injector api
     *
     * This object implements four methods similar to the
     * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
     *
     * UI-Router evolved from an angular 1 library to a framework agnostic library.
     * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
     *
     * This object provides a naive implementation of a globally scoped dependency injection system.
     * It supports the following DI approaches:
     *
     * ### Function parameter names
     *
     * A function's `.toString()` is called, and the parameter names are parsed.
     * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
     *
     * ```js
     * function injectedFunction(FooService, BarService) {
     *   // FooService and BarService are injected
     * }
     * ```
     *
     * ### Function annotation
     *
     * A function may be annotated with an array of dependency names as the `$inject` property.
     *
     * ```js
     * injectedFunction.$inject = [ 'FooService', 'BarService' ];
     * function injectedFunction(fs, bs) {
     *   // FooService and BarService are injected as fs and bs parameters
     * }
     * ```
     *
     * ### Array notation
     *
     * An array provides the names of the dependencies to inject (as strings).
     * The function is the last element of the array.
     *
     * ```js
     * [ 'FooService', 'BarService', function (fs, bs) {
     *   // FooService and BarService are injected as fs and bs parameters
     * }]
     * ```
     *
     * @type {$InjectorLike}
     */
    var $injector = {
        /** Gets an object from DI based on a string token */
        get: function (name) { return globals[name]; },
        /** Returns true if an object named `name` exists in global DI */
        has: function (name) { return $injector.get(name) != null; },
        /**
         * Injects a function
         *
         * @param fn the function to inject
         * @param context the function's `this` binding
         * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
         */
        invoke: function (fn, context, locals) {
            var all = extend({}, globals, locals || {});
            var params = $injector.annotate(fn);
            var ensureExist = assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
            var args = params.filter(ensureExist).map(function (x) { return all[x]; });
            if (isFunction(fn))
                return fn.apply(context, args);
            else
                return fn.slice(-1)[0].apply(context, args);
        },
        /**
         * Returns a function's dependencies
         *
         * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
         * @return an array of `string`s
         */
        annotate: function (fn) {
            if (!isInjectable(fn))
                throw new Error("Not an injectable function: " + fn);
            if (fn && fn.$inject)
                return fn.$inject;
            if (isArray(fn))
                return fn.slice(0, -1);
            var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
            var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
            return result || [];
        },
    };

    var keyValsToObjectR = function (accum, _a) {
        var key = _a[0], val = _a[1];
        if (!accum.hasOwnProperty(key)) {
            accum[key] = val;
        }
        else if (isArray(accum[key])) {
            accum[key].push(val);
        }
        else {
            accum[key] = [accum[key], val];
        }
        return accum;
    };
    var getParams = function (queryString) {
        return queryString.split('&').filter(identity).map(splitEqual).reduce(keyValsToObjectR, {});
    };
    function parseUrl$1(url) {
        var orEmptyString = function (x) { return x || ''; };
        var _a = splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
        var _b = splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
        return { path: path, search: search, hash: hash, url: url };
    }
    var buildUrl = function (loc) {
        var path = loc.path();
        var searchObject = loc.search();
        var hash = loc.hash();
        var search = Object.keys(searchObject)
            .map(function (key) {
            var param = searchObject[key];
            var vals = isArray(param) ? param : [param];
            return vals.map(function (val) { return key + '=' + val; });
        })
            .reduce(unnestR, [])
            .join('&');
        return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
    };
    function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
        return function (uiRouter) {
            var service = (uiRouter.locationService = new serviceClass(uiRouter));
            var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
            function dispose(router) {
                router.dispose(service);
                router.dispose(configuration);
            }
            return { name: name, service: service, configuration: configuration, dispose: dispose };
        };
    }

    /** A base `LocationServices` */
    var BaseLocationServices = /** @class */ (function () {
        function BaseLocationServices(router, fireAfterUpdate) {
            var _this = this;
            this.fireAfterUpdate = fireAfterUpdate;
            this._listeners = [];
            this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
            this.hash = function () { return parseUrl$1(_this._get()).hash; };
            this.path = function () { return parseUrl$1(_this._get()).path; };
            this.search = function () { return getParams(parseUrl$1(_this._get()).search); };
            this._location = root.location;
            this._history = root.history;
        }
        BaseLocationServices.prototype.url = function (url, replace) {
            if (replace === void 0) { replace = true; }
            if (isDefined(url) && url !== this._get()) {
                this._set(null, null, url, replace);
                if (this.fireAfterUpdate) {
                    this._listeners.forEach(function (cb) { return cb({ url: url }); });
                }
            }
            return buildUrl(this);
        };
        BaseLocationServices.prototype.onChange = function (cb) {
            var _this = this;
            this._listeners.push(cb);
            return function () { return removeFrom(_this._listeners, cb); };
        };
        BaseLocationServices.prototype.dispose = function (router) {
            deregAll(this._listeners);
        };
        return BaseLocationServices;
    }());

    var __extends = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    /** A `LocationServices` that uses the browser hash "#" to get/set the current location */
    var HashLocationService = /** @class */ (function (_super) {
        __extends(HashLocationService, _super);
        function HashLocationService(router) {
            var _this = _super.call(this, router, false) || this;
            root.addEventListener('hashchange', _this._listener, false);
            return _this;
        }
        HashLocationService.prototype._get = function () {
            return trimHashVal(this._location.hash);
        };
        HashLocationService.prototype._set = function (state, title, url, replace) {
            this._location.hash = url;
        };
        HashLocationService.prototype.dispose = function (router) {
            _super.prototype.dispose.call(this, router);
            root.removeEventListener('hashchange', this._listener);
        };
        return HashLocationService;
    }(BaseLocationServices));

    var __extends$1 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    /** A `LocationServices` that gets/sets the current location from an in-memory object */
    var MemoryLocationService = /** @class */ (function (_super) {
        __extends$1(MemoryLocationService, _super);
        function MemoryLocationService(router) {
            return _super.call(this, router, true) || this;
        }
        MemoryLocationService.prototype._get = function () {
            return this._url;
        };
        MemoryLocationService.prototype._set = function (state, title, url, replace) {
            this._url = url;
        };
        return MemoryLocationService;
    }(BaseLocationServices));

    var __extends$2 = (undefined && undefined.__extends) || (function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
            return extendStatics(d, b);
        };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    /**
     * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
     *
     * Uses `history.pushState` and `history.replaceState`
     */
    var PushStateLocationService = /** @class */ (function (_super) {
        __extends$2(PushStateLocationService, _super);
        function PushStateLocationService(router) {
            var _this = _super.call(this, router, true) || this;
            _this._config = router.urlService.config;
            root.addEventListener('popstate', _this._listener, false);
            return _this;
        }
        /**
         * Gets the base prefix without:
         * - trailing slash
         * - trailing filename
         * - protocol and hostname
         *
         * If <base href='/base/'>, this returns '/base'.
         * If <base href='/foo/base/'>, this returns '/foo/base'.
         * If <base href='/base/index.html'>, this returns '/base'.
         * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
         * If <base href='/base'>, this returns ''.
         * If <base href='http://localhost:8080'>, this returns ''.
         * If <base href='http://localhost:8080/'>, this returns ''.
         *
         * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
         */
        PushStateLocationService.prototype._getBasePrefix = function () {
            return stripLastPathElement(this._config.baseHref());
        };
        PushStateLocationService.prototype._get = function () {
            var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
            search = splitQuery(search)[1]; // strip ? if found
            hash = splitHash(hash)[1]; // strip # if found
            var basePrefix = this._getBasePrefix();
            var exactBaseHrefMatch = pathname === this._config.baseHref();
            var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
            pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
            return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
        };
        PushStateLocationService.prototype._set = function (state, title, url, replace) {
            var basePrefix = this._getBasePrefix();
            var slash = url && url[0] !== '/' ? '/' : '';
            var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
            if (replace) {
                this._history.replaceState(state, title, fullUrl);
            }
            else {
                this._history.pushState(state, title, fullUrl);
            }
        };
        PushStateLocationService.prototype.dispose = function (router) {
            _super.prototype.dispose.call(this, router);
            root.removeEventListener('popstate', this._listener);
        };
        return PushStateLocationService;
    }(BaseLocationServices));

    /** A `LocationConfig` mock that gets/sets all config from an in-memory object */
    var MemoryLocationConfig = /** @class */ (function () {
        function MemoryLocationConfig() {
            var _this = this;
            this.dispose = noop;
            this._baseHref = '';
            this._port = 80;
            this._protocol = 'http';
            this._host = 'localhost';
            this._hashPrefix = '';
            this.port = function () { return _this._port; };
            this.protocol = function () { return _this._protocol; };
            this.host = function () { return _this._host; };
            this.baseHref = function () { return _this._baseHref; };
            this.html5Mode = function () { return false; };
            this.hashPrefix = function (newval) { return (isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
        }
        return MemoryLocationConfig;
    }());

    /** A `LocationConfig` that delegates to the browser's `location` object */
    var BrowserLocationConfig = /** @class */ (function () {
        function BrowserLocationConfig(router, _isHtml5) {
            if (_isHtml5 === void 0) { _isHtml5 = false; }
            this._isHtml5 = _isHtml5;
            this._baseHref = undefined;
            this._hashPrefix = '';
        }
        BrowserLocationConfig.prototype.port = function () {
            if (location.port) {
                return Number(location.port);
            }
            return this.protocol() === 'https' ? 443 : 80;
        };
        BrowserLocationConfig.prototype.protocol = function () {
            return location.protocol.replace(/:/g, '');
        };
        BrowserLocationConfig.prototype.host = function () {
            return location.hostname;
        };
        BrowserLocationConfig.prototype.html5Mode = function () {
            return this._isHtml5;
        };
        BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
            return isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
        };
        BrowserLocationConfig.prototype.baseHref = function (href) {
            if (isDefined(href))
                this._baseHref = href;
            if (isUndefined(this._baseHref))
                this._baseHref = this.getBaseHref();
            return this._baseHref;
        };
        BrowserLocationConfig.prototype.getBaseHref = function () {
            var baseTag = document.getElementsByTagName('base')[0];
            if (baseTag && baseTag.href) {
                return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
            }
            return this._isHtml5 ? '/' : location.pathname || '/';
        };
        BrowserLocationConfig.prototype.dispose = function () { };
        return BrowserLocationConfig;
    }());

    function servicesPlugin(router) {
        services.$injector = $injector;
        services.$q = $q;
        return { name: 'vanilla.services', $q: $q, $injector: $injector, dispose: function () { return null; } };
    }
    /** A `UIRouterPlugin` uses the browser hash to get/set the current location */
    var hashLocationPlugin = locationPluginFactory('vanilla.hashBangLocation', false, HashLocationService, BrowserLocationConfig);
    /** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
    var pushStateLocationPlugin = locationPluginFactory('vanilla.pushStateLocation', true, PushStateLocationService, BrowserLocationConfig);
    /** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
    var memoryLocationPlugin = locationPluginFactory('vanilla.memoryLocation', false, MemoryLocationService, MemoryLocationConfig);

    var UIRouterPluginBase = /** @class */ (function () {
        function UIRouterPluginBase() {
        }
        UIRouterPluginBase.prototype.dispose = function (router) { };
        return UIRouterPluginBase;
    }());

    var index = /*#__PURE__*/Object.freeze({
        __proto__: null,
        root: root,
        fromJson: fromJson,
        toJson: toJson,
        forEach: forEach,
        extend: extend,
        equals: equals,
        identity: identity,
        noop: noop,
        createProxyFunctions: createProxyFunctions,
        inherit: inherit,
        inArray: inArray,
        _inArray: _inArray,
        removeFrom: removeFrom,
        _removeFrom: _removeFrom,
        pushTo: pushTo,
        _pushTo: _pushTo,
        deregAll: deregAll,
        defaults: defaults,
        mergeR: mergeR,
        ancestors: ancestors,
        pick: pick,
        omit: omit,
        pluck: pluck,
        filter: filter,
        find: find,
        mapObj: mapObj,
        map: map,
        values: values,
        allTrueR: allTrueR,
        anyTrueR: anyTrueR,
        unnestR: unnestR,
        flattenR: flattenR,
        pushR: pushR,
        uniqR: uniqR,
        unnest: unnest,
        flatten: flatten,
        assertPredicate: assertPredicate,
        assertMap: assertMap,
        assertFn: assertFn,
        pairs: pairs,
        arrayTuples: arrayTuples,
        applyPairs: applyPairs,
        tail: tail,
        copy: copy,
        _extend: _extend,
        silenceUncaughtInPromise: silenceUncaughtInPromise,
        silentRejection: silentRejection,
        makeStub: makeStub,
        services: services,
        Glob: Glob,
        curry: curry,
        compose: compose,
        pipe: pipe,
        prop: prop,
        propEq: propEq,
        parse: parse,
        not: not,
        and: and,
        or: or,
        all: all,
        any: any,
        is: is,
        eq: eq,
        val: val,
        invoke: invoke,
        pattern: pattern,
        isUndefined: isUndefined,
        isDefined: isDefined,
        isNull: isNull,
        isNullOrUndefined: isNullOrUndefined,
        isFunction: isFunction,
        isNumber: isNumber,
        isString: isString,
        isObject: isObject,
        isArray: isArray,
        isDate: isDate,
        isRegExp: isRegExp,
        isInjectable: isInjectable,
        isPromise: isPromise,
        Queue: Queue,
        maxLength: maxLength,
        padString: padString,
        kebobString: kebobString,
        functionToString: functionToString,
        fnToString: fnToString,
        stringify: stringify,
        beforeAfterSubstr: beforeAfterSubstr,
        hostRegex: hostRegex,
        stripLastPathElement: stripLastPathElement,
        splitHash: splitHash,
        splitQuery: splitQuery,
        splitEqual: splitEqual,
        trimHashVal: trimHashVal,
        splitOnDelim: splitOnDelim,
        joinNeighborsR: joinNeighborsR,
        get Category () { return exports.Category; },
        Trace: Trace,
        trace: trace,
        get DefType () { return exports.DefType; },
        Param: Param,
        ParamTypes: ParamTypes,
        StateParams: StateParams,
        ParamType: ParamType,
        PathNode: PathNode,
        PathUtils: PathUtils,
        resolvePolicies: resolvePolicies,
        defaultResolvePolicy: defaultResolvePolicy,
        Resolvable: Resolvable,
        NATIVE_INJECTOR_TOKEN: NATIVE_INJECTOR_TOKEN,
        ResolveContext: ResolveContext,
        resolvablesBuilder: resolvablesBuilder,
        StateBuilder: StateBuilder,
        StateObject: StateObject,
        StateMatcher: StateMatcher,
        StateQueueManager: StateQueueManager,
        StateRegistry: StateRegistry,
        StateService: StateService,
        TargetState: TargetState,
        get TransitionHookPhase () { return exports.TransitionHookPhase; },
        get TransitionHookScope () { return exports.TransitionHookScope; },
        HookBuilder: HookBuilder,
        matchState: matchState,
        RegisteredHook: RegisteredHook,
        makeEvent: makeEvent,
        get RejectType () { return exports.RejectType; },
        Rejection: Rejection,
        Transition: Transition,
        TransitionHook: TransitionHook,
        TransitionEventType: TransitionEventType,
        defaultTransOpts: defaultTransOpts,
        TransitionService: TransitionService,
        UrlRules: UrlRules,
        UrlConfig: UrlConfig,
        UrlMatcher: UrlMatcher,
        ParamFactory: ParamFactory,
        UrlMatcherFactory: UrlMatcherFactory,
        UrlRouter: UrlRouter,
        UrlRuleFactory: UrlRuleFactory,
        BaseUrlRule: BaseUrlRule,
        UrlService: UrlService,
        ViewService: ViewService,
        UIRouterGlobals: UIRouterGlobals,
        UIRouter: UIRouter,
        $q: $q,
        $injector: $injector,
        BaseLocationServices: BaseLocationServices,
        HashLocationService: HashLocationService,
        MemoryLocationService: MemoryLocationService,
        PushStateLocationService: PushStateLocationService,
        MemoryLocationConfig: MemoryLocationConfig,
        BrowserLocationConfig: BrowserLocationConfig,
        keyValsToObjectR: keyValsToObjectR,
        getParams: getParams,
        parseUrl: parseUrl$1,
        buildUrl: buildUrl,
        locationPluginFactory: locationPluginFactory,
        servicesPlugin: servicesPlugin,
        hashLocationPlugin: hashLocationPlugin,
        pushStateLocationPlugin: pushStateLocationPlugin,
        memoryLocationPlugin: memoryLocationPlugin,
        UIRouterPluginBase: UIRouterPluginBase
    });

    /** @publicapi @module ng1 */ /** */
    /** @internalapi */
    function getNg1ViewConfigFactory() {
        var templateFactory = null;
        return function (path, view) {
            templateFactory = templateFactory || services.$injector.get('$templateFactory');
            return [new Ng1ViewConfig(path, view, templateFactory)];
        };
    }
    /** @internalapi */
    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || isDefined(obj[key]); }, false); };
    /**
     * This is a [[StateBuilder.builder]] function for angular1 `views`.
     *
     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
     *
     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
     * and applies the state-level configuration to a view named `$default`.
     *
     * @internalapi
     */
    function ng1ViewsBuilder(state) {
        // Do not process root state
        if (!state.parent)
            return {};
        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
        // Do not allow a state to have both state-level props and also a `views: {}` property.
        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
        // However, the `$default` approach should not be mixed with a separate `views: ` block.
        if (isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
            throw new Error("State '" + state.name + "' has a 'views' object. " +
                "It cannot also have \"view properties\" at the state level.  " +
                "Move the following properties into a view (in the 'views' object): " +
                (" " + allViewKeys.filter(function (key) { return isDefined(state[key]); }).join(', ')));
        }
        var views = {}, viewsObject = state.views || { $default: pick(state, allViewKeys) };
        forEach(viewsObject, function (config, name) {
            // Account for views: { "": { template... } }
            name = name || '$default';
            // Account for views: { header: "headerComponent" }
            if (isString(config))
                config = { component: config };
            // Make a shallow copy of the config object
            config = extend({}, config);
            // Do not allow a view to mix props for component-style view with props for template/controller-style view
            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
            }
            config.resolveAs = config.resolveAs || '$resolve';
            config.$type = 'ng1';
            config.$context = state;
            config.$name = name;
            var normalized = ViewService.normalizeUIViewTarget(config.$context, config.$name);
            config.$uiViewName = normalized.uiViewName;
            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
            views[name] = config;
        });
        return views;
    }
    /** @hidden */
    var id$1 = 0;
    /** @internalapi */
    var Ng1ViewConfig = /** @class */ (function () {
        function Ng1ViewConfig(path, viewDecl, factory) {
            var _this = this;
            this.path = path;
            this.viewDecl = viewDecl;
            this.factory = factory;
            this.$id = id$1++;
            this.loaded = false;
            this.getTemplate = function (uiView, context) {
                return _this.component
                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
                    : _this.template;
            };
        }
        Ng1ViewConfig.prototype.load = function () {
            var _this = this;
            var $q = services.$q;
            var context = new ResolveContext(this.path);
            var params = this.path.reduce(function (acc, node) { return extend(acc, node.paramValues); }, {});
            var promises = {
                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
                controller: $q.when(this.getController(context)),
            };
            return $q.all(promises).then(function (results) {
                trace.traceViewServiceEvent('Loaded', _this);
                _this.controller = results.controller;
                extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
                return _this;
            });
        };
        /**
         * Gets the controller for a view configuration.
         *
         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
         */
        Ng1ViewConfig.prototype.getController = function (context) {
            var provider = this.viewDecl.controllerProvider;
            if (!isInjectable(provider))
                return this.viewDecl.controller;
            var deps = services.$injector.annotate(provider);
            var providerFn = isArray(provider) ? tail(provider) : provider;
            var resolvable = new Resolvable('', providerFn, deps);
            return resolvable.get(context);
        };
        return Ng1ViewConfig;
    }());

    /** @publicapi @module view */ /** */
    /**
     * Service which manages loading of templates from a ViewConfig.
     */
    var TemplateFactory = /** @class */ (function () {
        function TemplateFactory() {
            var _this = this;
            /** @hidden */ this._useHttp = ng.version.minor < 3;
            /** @hidden */ this.$get = [
                '$http',
                '$templateCache',
                '$injector',
                function ($http, $templateCache, $injector) {
                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
                    _this.$http = $http;
                    _this.$templateCache = $templateCache;
                    return _this;
                },
            ];
        }
        /** @hidden */
        TemplateFactory.prototype.useHttpService = function (value) {
            this._useHttp = value;
        };
        /**
         * Creates a template from a configuration object.
         *
         * @param config Configuration object for which to load a template.
         * The following properties are search in the specified order, and the first one
         * that is defined is used to create the template:
         *
         * @param params  Parameters to pass to the template function.
         * @param context The resolve context associated with the template's view
         *
         * @return {string|object}  The template html as a string, or a promise for
         * that string,or `null` if no template is configured.
         */
        TemplateFactory.prototype.fromConfig = function (config, params, context) {
            var defaultTemplate = '<ui-view></ui-view>';
            var asTemplate = function (result) { return services.$q.when(result).then(function (str) { return ({ template: str }); }); };
            var asComponent = function (result) { return services.$q.when(result).then(function (str) { return ({ component: str }); }); };
            return isDefined(config.template)
                ? asTemplate(this.fromString(config.template, params))
                : isDefined(config.templateUrl)
                    ? asTemplate(this.fromUrl(config.templateUrl, params))
                    : isDefined(config.templateProvider)
                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
                        : isDefined(config.component)
                            ? asComponent(config.component)
                            : isDefined(config.componentProvider)
                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
                                : asTemplate(defaultTemplate);
        };
        /**
         * Creates a template from a string or a function returning a string.
         *
         * @param template html template as a string or function that returns an html template as a string.
         * @param params Parameters to pass to the template function.
         *
         * @return {string|object} The template html as a string, or a promise for that
         * string.
         */
        TemplateFactory.prototype.fromString = function (template, params) {
            return isFunction(template) ? template(params) : template;
        };
        /**
         * Loads a template from the a URL via `$http` and `$templateCache`.
         *
         * @param {string|Function} url url of the template to load, or a function
         * that returns a url.
         * @param {Object} params Parameters to pass to the url function.
         * @return {string|Promise.<string>} The template html as a string, or a promise
         * for that string.
         */
        TemplateFactory.prototype.fromUrl = function (url, params) {
            if (isFunction(url))
                url = url(params);
            if (url == null)
                return null;
            if (this._useHttp) {
                return this.$http
                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
                    .then(function (response) {
                    return response.data;
                });
            }
            return this.$templateRequest(url);
        };
        /**
         * Creates a template by invoking an injectable provider function.
         *
         * @param provider Function to invoke via `locals`
         * @param {Function} injectFn a function used to invoke the template provider
         * @return {string|Promise.<string>} The template html as a string, or a promise
         * for that string.
         */
        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
            var deps = services.$injector.annotate(provider);
            var providerFn = isArray(provider) ? tail(provider) : provider;
            var resolvable = new Resolvable('', providerFn, deps);
            return resolvable.get(context);
        };
        /**
         * Creates a component's template by invoking an injectable provider function.
         *
         * @param provider Function to invoke via `locals`
         * @param {Function} injectFn a function used to invoke the template provider
         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
         */
        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
            var deps = services.$injector.annotate(provider);
            var providerFn = isArray(provider) ? tail(provider) : provider;
            var resolvable = new Resolvable('', providerFn, deps);
            return resolvable.get(context);
        };
        /**
         * Creates a template from a component's name
         *
         * This implements route-to-component.
         * It works by retrieving the component (directive) metadata from the injector.
         * It analyses the component's bindings, then constructs a template that instantiates the component.
         * The template wires input and output bindings to resolves or from the parent component.
         *
         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
         * @param component {string} Component's name in camel case.
         * @param bindings An object defining the component's bindings: {foo: '<'}
         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
         */
        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
            bindings = bindings || {};
            // Bind once prefix
            var prefix = ng.version.minor >= 3 ? '::' : '';
            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
            var kebob = function (camelCase) {
                var kebobed = kebobString(camelCase);
                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
            };
            var attributeTpl = function (input) {
                var name = input.name, type = input.type;
                var attrName = kebob(name);
                // If the ui-view has an attribute which matches a binding on the routed component
                // then pass that attribute through to the routed component template.
                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
                if (uiView.attr(attrName) && !bindings[name])
                    return attrName + "='" + uiView.attr(attrName) + "'";
                var resolveName = bindings[name] || name;
                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
                // some-attr="{{ ::$resolve.someResolveName }}"
                if (type === '@')
                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
                // Wire "&" callbacks to resolves that return a callback function
                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
                // some-attr="$resolve.someResolveResultName(foo, bar)"
                if (type === '&') {
                    var res = context.getResolvable(resolveName);
                    var fn = res && res.data;
                    var args = (fn && services.$injector.annotate(fn)) || [];
                    // account for array style injection, i.e., ['foo', function(foo) {}]
                    var arrayIdxStr = isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
                }
                // some-attr="::$resolve.someResolveName"
                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
            };
            var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
            var kebobName = kebob(component);
            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
        };
        return TemplateFactory;
    }());
    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
    function getComponentBindings(name) {
        var cmpDefs = services.$injector.get(name + 'Directive'); // could be multiple
        if (!cmpDefs || !cmpDefs.length)
            throw new Error("Unable to find component named '" + name + "'");
        return cmpDefs.map(getBindings).reduce(unnestR, []);
    }
    // Given a directive definition, find its object input attributes
    // Use different properties, depending on the type of directive (component, bindToController, normal)
    var getBindings = function (def) {
        if (isObject(def.bindToController))
            return scopeBindings(def.bindToController);
        return scopeBindings(def.scope);
    };
    // for ng 1.2 style, process the scope: { input: "=foo" }
    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
    var scopeBindings = function (bindingsObj) {
        return Object.keys(bindingsObj || {})
            // [ 'input', [ '=foo', '=', 'foo' ] ]
            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
            // skip malformed values
            .filter(function (tuple) { return isDefined(tuple) && isArray(tuple[1]); })
            // { name: ('foo' || 'input'), type: '=' }
            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
    };

    /** @publicapi @module ng1 */ /** */
    /**
     * The Angular 1 `StateProvider`
     *
     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
     * on state.
     *
     * A state corresponds to a "place" in the application in terms of the overall UI and
     * navigation. A state describes (via the controller / template / view properties) what
     * the UI looks like and does at that place.
     *
     * States often have things in common, and the primary way of factoring out these
     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
     * nested states.
     *
     * The `$stateProvider` provides interfaces to declare these states for your app.
     */
    var StateProvider = /** @class */ (function () {
        function StateProvider(stateRegistry, stateService) {
            this.stateRegistry = stateRegistry;
            this.stateService = stateService;
            createProxyFunctions(val(StateProvider.prototype), this, val(this));
        }
        /**
         * Decorates states when they are registered
         *
         * Allows you to extend (carefully) or override (at your own peril) the
         * `stateBuilder` object used internally by [[StateRegistry]].
         * This can be used to add custom functionality to ui-router,
         * for example inferring templateUrl based on the state name.
         *
         * When passing only a name, it returns the current (original or decorated) builder
         * function that matches `name`.
         *
         * The builder functions that can be decorated are listed below. Though not all
         * necessarily have a good use case for decoration, that is up to you to decide.
         *
         * In addition, users can attach custom decorators, which will generate new
         * properties within the state's internal definition. There is currently no clear
         * use-case for this beyond accessing internal states (i.e. $state.$current),
         * however, expect this to become increasingly relevant as we introduce additional
         * meta-programming features.
         *
         * **Warning**: Decorators should not be interdependent because the order of
         * execution of the builder functions in non-deterministic. Builder functions
         * should only be dependent on the state definition object and super function.
         *
         *
         * Existing builder functions and current return values:
         *
         * - **parent** `{object}` - returns the parent state object.
         * - **data** `{object}` - returns state data, including any inherited data that is not
         *   overridden by own values (if any).
         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
         *   or `null`.
         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
         *   navigable).
         * - **params** `{object}` - returns an array of state params that are ensured to
         *   be a super-set of parent's params.
         * - **views** `{object}` - returns a views object where each key is an absolute view
         *   name (i.e. "viewName@stateName") and each value is the config object
         *   (template, controller) for the view. Even when you don't use the views object
         *   explicitly on a state config, one is still created for you internally.
         *   So by decorating this builder function you have access to decorating template
         *   and controller properties.
         * - **ownParams** `{object}` - returns an array of params that belong to the state,
         *   not including any params defined by ancestor states.
         * - **path** `{string}` - returns the full path from the root down to this state.
         *   Needed for state activation.
         * - **includes** `{object}` - returns an object that includes every state that
         *   would pass a `$state.includes()` test.
         *
         * #### Example:
         * Override the internal 'views' builder with a function that takes the state
         * definition, and a reference to the internal function being overridden:
         * ```js
         * $stateProvider.decorator('views', function (state, parent) {
         *   let result = {},
         *       views = parent(state);
         *
         *   angular.forEach(views, function (config, name) {
         *     let autoName = (state.name + '.' + name).replace('.', '/');
         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
         *     result[name] = config;
         *   });
         *   return result;
         * });
         *
         * $stateProvider.state('home', {
         *   views: {
         *     'contact.list': { controller: 'ListController' },
         *     'contact.item': { controller: 'ItemController' }
         *   }
         * });
         * ```
         *
         *
         * ```js
         * // Auto-populates list and item views with /partials/home/contact/list.html,
         * // and /partials/home/contact/item.html, respectively.
         * $state.go('home');
         * ```
         *
         * @param {string} name The name of the builder function to decorate.
         * @param {object} func A function that is responsible for decorating the original
         * builder function. The function receives two parameters:
         *
         *   - `{object}` - state - The state config object.
         *   - `{object}` - super - The original builder function.
         *
         * @return {object} $stateProvider - $stateProvider instance
         */
        StateProvider.prototype.decorator = function (name, func) {
            return this.stateRegistry.decorator(name, func) || this;
        };
        StateProvider.prototype.state = function (name, definition) {
            if (isObject(name)) {
                definition = name;
            }
            else {
                definition.name = name;
            }
            this.stateRegistry.register(definition);
            return this;
        };
        /**
         * Registers an invalid state handler
         *
         * This is a passthrough to [[StateService.onInvalid]] for ng1.
         */
        StateProvider.prototype.onInvalid = function (callback) {
            return this.stateService.onInvalid(callback);
        };
        return StateProvider;
    }());

    /** @publicapi @module ng1 */ /** */
    /**
     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
     *
     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
     *
     * @internalapi
     */
    var getStateHookBuilder = function (hookName) {
        return function stateHookBuilder(stateObject) {
            var hook = stateObject[hookName];
            var pathname = hookName === 'onExit' ? 'from' : 'to';
            function decoratedNg1Hook(trans, state) {
                var resolveContext = new ResolveContext(trans.treeChanges(pathname));
                var subContext = resolveContext.subContext(state.$$state());
                var locals = extend(getLocals(subContext), { $state$: state, $transition$: trans });
                return services.$injector.invoke(hook, this, locals);
            }
            return hook ? decoratedNg1Hook : undefined;
        };
    };

    /** @publicapi @module ng1 */ /** */
    /**
     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
     * @internalapi
     */
    var Ng1LocationServices = /** @class */ (function () {
        function Ng1LocationServices($locationProvider) {
            // .onChange() registry
            this._urlListeners = [];
            this.$locationProvider = $locationProvider;
            var _lp = val($locationProvider);
            createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
        }
        /**
         * Applys ng1-specific path parameter encoding
         *
         * The Angular 1 `$location` service is a bit weird.
         * It doesn't allow slashes to be encoded/decoded bi-directionally.
         *
         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
         *
         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
         *
         * @param router
         */
        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
            var pathType = router.urlMatcherFactory.type('path');
            pathType.encode = function (x) {
                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
            };
            pathType.decode = function (x) {
                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
            };
        };
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        Ng1LocationServices.prototype.dispose = function () { };
        Ng1LocationServices.prototype.onChange = function (callback) {
            var _this = this;
            this._urlListeners.push(callback);
            return function () { return removeFrom(_this._urlListeners)(callback); };
        };
        Ng1LocationServices.prototype.html5Mode = function () {
            var html5Mode = this.$locationProvider.html5Mode();
            html5Mode = isObject(html5Mode) ? html5Mode.enabled : html5Mode;
            return html5Mode && this.$sniffer.history;
        };
        Ng1LocationServices.prototype.baseHref = function () {
            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
        };
        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
            if (replace === void 0) { replace = false; }
            if (isDefined(newUrl))
                this.$location.url(newUrl);
            if (replace)
                this.$location.replace();
            if (state)
                this.$location.state(state);
            return this.$location.url();
        };
        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
            var _this = this;
            this.$location = $location;
            this.$sniffer = $sniffer;
            this.$browser = $browser;
            this.$window = $window;
            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
            var _loc = val($location);
            // Bind these LocationService functions to $location
            createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
            // Bind these LocationConfig functions to $location
            createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
        };
        return Ng1LocationServices;
    }());

    /** @publicapi @module url */ /** */
    /**
     * Manages rules for client-side URL
     *
     * ### Deprecation warning:
     * This class is now considered to be an internal API
     * Use the [[UrlService]] instead.
     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
     *
     * This class manages the router rules for what to do when the URL changes.
     *
     * This provider remains for backwards compatibility.
     *
     * @internalapi
     * @deprecated
     */
    var UrlRouterProvider = /** @class */ (function () {
        /** @hidden */
        function UrlRouterProvider(/** @hidden */ router) {
            this.router = router;
        }
        UrlRouterProvider.injectableHandler = function (router, handler) {
            return function (match) { return services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
        };
        /** @hidden */
        UrlRouterProvider.prototype.$get = function () {
            var urlService = this.router.urlService;
            this.router.urlRouter.update(true);
            if (!urlService.interceptDeferred)
                urlService.listen();
            return this.router.urlRouter;
        };
        /**
         * Registers a url handler function.
         *
         * Registers a low level url handler (a `rule`).
         * A rule detects specific URL patterns and returns a redirect, or performs some action.
         *
         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
         *
         * #### Example:
         * ```js
         * var app = angular.module('app', ['ui.router.router']);
         *
         * app.config(function ($urlRouterProvider) {
         *   // Here's an example of how you might allow case insensitive urls
         *   $urlRouterProvider.rule(function ($injector, $location) {
         *     var path = $location.path(),
         *         normalized = path.toLowerCase();
         *
         *     if (path !== normalized) {
         *       return normalized;
         *     }
         *   });
         * });
         * ```
         *
         * @param ruleFn
         * Handler function that takes `$injector` and `$location` services as arguments.
         * You can use them to detect a url and return a different url as a string.
         *
         * @return [[UrlRouterProvider]] (`this`)
         */
        UrlRouterProvider.prototype.rule = function (ruleFn) {
            var _this = this;
            if (!isFunction(ruleFn))
                throw new Error("'rule' must be a function");
            var match = function () { return ruleFn(services.$injector, _this.router.locationService); };
            var rule = new BaseUrlRule(match, identity);
            this.router.urlService.rules.rule(rule);
            return this;
        };
        /**
         * Defines the path or behavior to use when no url can be matched.
         *
         * #### Example:
         * ```js
         * var app = angular.module('app', ['ui.router.router']);
         *
         * app.config(function ($urlRouterProvider) {
         *   // if the path doesn't match any of the urls you configured
         *   // otherwise will take care of routing the user to the
         *   // specified url
         *   $urlRouterProvider.otherwise('/index');
         *
         *   // Example of using function rule as param
         *   $urlRouterProvider.otherwise(function ($injector, $location) {
         *     return '/a/valid/url';
         *   });
         * });
         * ```
         *
         * @param rule
         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
         *
         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
         */
        UrlRouterProvider.prototype.otherwise = function (rule) {
            var _this = this;
            var urlRules = this.router.urlService.rules;
            if (isString(rule)) {
                urlRules.otherwise(rule);
            }
            else if (isFunction(rule)) {
                urlRules.otherwise(function () { return rule(services.$injector, _this.router.locationService); });
            }
            else {
                throw new Error("'rule' must be a string or function");
            }
            return this;
        };
        /**
         * Registers a handler for a given url matching.
         *
         * If the handler is a string, it is
         * treated as a redirect, and is interpolated according to the syntax of match
         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
         *
         * If the handler is a function, it is injectable.
         * It gets invoked if `$location` matches.
         * You have the option of inject the match object as `$match`.
         *
         * The handler can return
         *
         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
         *   will continue trying to find another one that matches.
         * - **string** which is treated as a redirect and passed to `$location.url()`
         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
         *
         * #### Example:
         * ```js
         * var app = angular.module('app', ['ui.router.router']);
         *
         * app.config(function ($urlRouterProvider) {
         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
         *     if ($state.$current.navigable !== state ||
         *         !equalForKeys($match, $stateParams) {
         *      $state.transitionTo(state, $match, false);
         *     }
         *   });
         * });
         * ```
         *
         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
         * @param handler The path (or function that returns a path) that you want to redirect your user to.
         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
         *
         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
         */
        UrlRouterProvider.prototype.when = function (what, handler) {
            if (isArray(handler) || isFunction(handler)) {
                handler = UrlRouterProvider.injectableHandler(this.router, handler);
            }
            this.router.urlService.rules.when(what, handler);
            return this;
        };
        /**
         * Disables monitoring of the URL.
         *
         * Call this method before UI-Router has bootstrapped.
         * It will stop UI-Router from performing the initial url sync.
         *
         * This can be useful to perform some asynchronous initialization before the router starts.
         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
         *
         * #### Example:
         * ```js
         * var app = angular.module('app', ['ui.router']);
         *
         * app.config(function ($urlRouterProvider) {
         *   // Prevent $urlRouter from automatically intercepting URL changes;
         *   $urlRouterProvider.deferIntercept();
         * })
         *
         * app.run(function (MyService, $urlRouter, $http) {
         *   $http.get("/stuff").then(function(resp) {
         *     MyService.doStuff(resp.data);
         *     $urlRouter.listen();
         *     $urlRouter.sync();
         *   });
         * });
         * ```
         *
         * @param defer Indicates whether to defer location change interception.
         *        Passing no parameter is equivalent to `true`.
         */
        UrlRouterProvider.prototype.deferIntercept = function (defer) {
            this.router.urlService.deferIntercept(defer);
        };
        return UrlRouterProvider;
    }());

    /* eslint-disable @typescript-eslint/no-empty-function */
    ng.module('ui.router.angular1', []);
    var mod_init = ng.module('ui.router.init', ['ng']);
    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
    var router = null;
    $uiRouterProvider.$inject = ['$locationProvider'];
    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
    function $uiRouterProvider($locationProvider) {
        // Create a new instance of the Router when the $uiRouterProvider is initialized
        router = this.router = new UIRouter();
        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
        router.stateRegistry.decorator('views', ng1ViewsBuilder);
        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
        // Disable decoding of params by UrlMatcherFactory because $location already handles this
        router.urlService.config._decodeParams = false;
        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
        Ng1LocationServices.monkeyPatchPathParameterType(router);
        // backwards compat: also expose router instance as $uiRouterProvider.router
        router['router'] = router;
        router['$get'] = $get;
        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
            delete router['router'];
            delete router['$get'];
            return router;
        }
        return router;
    }
    var getProviderFor = function (serviceName) { return [
        '$uiRouterProvider',
        function ($urp) {
            var service = $urp.router[serviceName];
            service['$get'] = function () { return service; };
            return service;
        },
    ]; };
    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
    function runBlock($injector, $q, $uiRouter) {
        services.$injector = $injector;
        services.$q = $q;
        // https://github.com/angular-ui/ui-router/issues/3678
        if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
            try {
                $injector.invoke(function (checkStrictDi) { });
            }
            catch (error) {
                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
            }
        }
        // The $injector is now available.
        // Find any resolvables that had dependency annotation deferred
        $uiRouter.stateRegistry
            .get()
            .map(function (x) { return x.$$state().resolvables; })
            .reduce(unnestR, [])
            .filter(function (x) { return x.deps === 'deferred'; })
            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
    }
    // $urlRouter service and $urlRouterProvider
    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
    // $state service and $stateProvider
    // $urlRouter service and $urlRouterProvider
    var getStateProvider = function () { return extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
    watchDigests.$inject = ['$rootScope'];
    function watchDigests($rootScope) {
        $rootScope.$watch(function () {
            trace.approximateDigests++;
        });
    }
    mod_init.provider('$uiRouter', $uiRouterProvider);
    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
    mod_util.provider('$urlService', getProviderFor('urlService'));
    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
    mod_state.provider('$transitions', getProviderFor('transitionService'));
    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
    mod_main.factory('$view', function () { return router.viewService; });
    mod_main.service('$trace', function () { return trace; });
    mod_main.run(watchDigests);
    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
    mod_state.run(['$state', function ($state) { }]);
    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
    mod_init.run(runBlock);
    /** @hidden TODO: find a place to move this */
    var getLocals = function (ctx) {
        var tokens = ctx.getTokens().filter(isString);
        var tuples = tokens.map(function (key) {
            var resolvable = ctx.getResolvable(key);
            var waitPolicy = ctx.getPolicy(resolvable).async;
            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
        });
        return tuples.reduce(applyPairs, {});
    };

    /* eslint-disable @typescript-eslint/no-empty-interface */
    /** @hidden */
    function parseStateRef(ref) {
        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
        if (paramsOnly)
            ref = '(' + paramsOnly[1] + ')';
        var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
        if (!parsed || parsed.length !== 4)
            throw new Error("Invalid state ref '" + ref + "'");
        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
    }
    /** @hidden */
    function stateContext(el) {
        var $uiView = el.parent().inheritedData('$uiView');
        var path = parse('$cfg.path')($uiView);
        return path ? tail(path).state.name : undefined;
    }
    /** @hidden */
    function processedDef($state, $element, def) {
        var uiState = def.uiState || $state.current.name;
        var uiStateOpts = extend(defaultOpts($element, $state), def.uiStateOpts || {});
        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
    }
    /** @hidden */
    function getTypeInfo(el) {
        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
        var isForm = el[0].nodeName === 'FORM';
        return {
            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
            isAnchor: el.prop('tagName').toUpperCase() === 'A',
            clickable: !isForm,
        };
    }
    /** @hidden */
    function clickHook(el, $state, $timeout, type, getDef) {
        return function (e) {
            var button = e.which || e.button, target = getDef();
            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
                var transition_1 = $timeout(function () {
                    if (!el.attr('disabled')) {
                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
                    }
                });
                e.preventDefault();
                // if the state has no URL, ignore one preventDefault from the <a> directive.
                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
                e.preventDefault = function () {
                    if (ignorePreventDefaultCount_1-- <= 0)
                        $timeout.cancel(transition_1);
                };
            }
        };
    }
    /** @hidden */
    function defaultOpts(el, $state) {
        return {
            relative: stateContext(el) || $state.$current,
            inherit: true,
            source: 'sref',
        };
    }
    /** @hidden */
    function bindEvents(element, scope, hookFn, uiStateOpts) {
        var events;
        if (uiStateOpts) {
            events = uiStateOpts.events;
        }
        if (!isArray(events)) {
            events = ['click'];
        }
        var on = element.on ? 'on' : 'bind';
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            element[on](event_1, hookFn);
        }
        scope.$on('$destroy', function () {
            var off = element.off ? 'off' : 'unbind';
            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
                var event_2 = events_2[_i];
                element[off](event_2, hookFn);
            }
        });
    }
    /**
     * `ui-sref`: A directive for linking to a state
     *
     * A directive which links to a state (and optionally, parameters).
     * When clicked, this directive activates the linked state with the supplied parameter values.
     *
     * ### Linked State
     * The attribute value of the `ui-sref` is the name of the state to link to.
     *
     * #### Example:
     * This will activate the `home` state when the link is clicked.
     * ```html
     * <a ui-sref="home">Home</a>
     * ```
     *
     * ### Relative Links
     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
     * You just need to be aware that the path is relative to the state that *created* the link.
     * This allows a state to create a relative `ui-sref` which always targets the same destination.
     *
     * #### Example:
     * Both these links are relative to the parent state, even when a child state is currently active.
     * ```html
     * <a ui-sref=".child1">child 1 state</a>
     * <a ui-sref=".child2">child 2 state</a>
     * ```
     *
     * This link activates the parent state.
     * ```html
     * <a ui-sref="^">Return</a>
     * ```
     *
     * ### hrefs
     * If the linked state has a URL, the directive will automatically generate and
     * update the `href` attribute (using the [[StateService.href]]  method).
     *
     * #### Example:
     * Assuming the `users` state has a url of `/users/`
     * ```html
     * <a ui-sref="users" href="/users/">Users</a>
     * ```
     *
     * ### Parameter Values
     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
     * The content inside the parentheses is an expression, evaluated to the parameter values.
     *
     * #### Example:
     * This example renders a list of links to users.
     * The state's `userId` parameter value comes from each user's `user.id` property.
     * ```html
     * <li ng-repeat="user in users">
     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
     * </li>
     * ```
     *
     * Note:
     * The parameter values expression is `$watch`ed for updates.
     *
     * ### Transition Options
     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
     * Options are restricted to `location`, `inherit`, and `reload`.
     *
     * #### Example:
     * ```html
     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
     * ```
     *
     * ### Other DOM Events
     *
     * You can also customize which DOM events to respond to (instead of `click`) by
     * providing an `events` array in the `ui-sref-opts` attribute.
     *
     * #### Example:
     * ```html
     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
     * ```
     *
     * ### Highlighting the active link
     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
     *
     * ### Examples
     * If you have the following template:
     *
     * ```html
     * <a ui-sref="home">Home</a>
     * <a ui-sref="about">About</a>
     * <a ui-sref="{page: 2}">Next page</a>
     *
     * <ul>
     *     <li ng-repeat="contact in contacts">
     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
     *     </li>
     * </ul>
     * ```
     *
     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
     *
     * ```html
     * <a href="#/home" ui-sref="home">Home</a>
     * <a href="#/about" ui-sref="about">About</a>
     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
     *
     * <ul>
     *     <li ng-repeat="contact in contacts">
     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
     *     </li>
     *     <li ng-repeat="contact in contacts">
     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
     *     </li>
     *     <li ng-repeat="contact in contacts">
     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
     *     </li>
     * </ul>
     *
     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
     * ```
     *
     * ### Notes
     *
     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
     * #### Example:
     * Sets the `lang` parameter to `en` and remains on the same state.
     *
     * ```html
     * <a ui-sref="{ lang: 'en' }">English</a>
     * ```
     *
     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
     *
     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
     */
    var uiSrefDirective;
    uiSrefDirective = [
        '$uiRouter',
        '$timeout',
        function $StateRefDirective($uiRouter, $timeout) {
            var $state = $uiRouter.stateService;
            return {
                restrict: 'A',
                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
                link: function (scope, element, attrs, uiSrefActive) {
                    var type = getTypeInfo(element);
                    var active = uiSrefActive[1] || uiSrefActive[0];
                    var unlinkInfoFn = null;
                    var rawDef = {};
                    var getDef = function () { return processedDef($state, element, rawDef); };
                    var ref = parseStateRef(attrs.uiSref);
                    rawDef.uiState = ref.state;
                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
                    function update() {
                        var def = getDef();
                        if (unlinkInfoFn)
                            unlinkInfoFn();
                        if (active)
                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                        if (def.href != null)
                            attrs.$set(type.attr, def.href);
                    }
                    if (ref.paramExpr) {
                        scope.$watch(ref.paramExpr, function (val) {
                            rawDef.uiStateParams = extend({}, val);
                            update();
                        }, true);
                        rawDef.uiStateParams = extend({}, scope.$eval(ref.paramExpr));
                    }
                    update();
                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                    if (!type.clickable)
                        return;
                    var hookFn = clickHook(element, $state, $timeout, type, getDef);
                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
                },
            };
        },
    ];
    /**
     * `ui-state`: A fully dynamic directive for linking to a state
     *
     * A directive which links to a state (and optionally, parameters).
     * When clicked, this directive activates the linked state with the supplied parameter values.
     *
     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
     *
     * A directive which links to a state (and optionally, parameters).
     * When clicked, this directive activates the linked state with the supplied parameter values.
     *
     * ### Linked State
     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
     *
     * #### Example:
     * Create a list of links.
     * ```html
     * <li ng-repeat="link in navlinks">
     *   <a ui-state="link.state">{{ link.displayName }}</a>
     * </li>
     * ```
     *
     * ### Relative Links
     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
     * You just need to be aware that the path is relative to the state that *created* the link.
     * This allows a state to create relative `ui-state` which always targets the same destination.
     *
     * ### hrefs
     * If the linked state has a URL, the directive will automatically generate and
     * update the `href` attribute (using the [[StateService.href]]  method).
     *
     * ### Parameter Values
     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
     * Param values should be provided using the `ui-state-params` attribute.
     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
     *
     * #### Example:
     * This example renders a list of links with param values.
     * The state's `userId` parameter value comes from each user's `user.id` property.
     * ```html
     * <li ng-repeat="link in navlinks">
     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
     * </li>
     * ```
     *
     * ### Transition Options
     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
     * Options are restricted to `location`, `inherit`, and `reload`.
     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
     *
     * #### Example:
     * ```html
     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
     * ```
     *
     * ### Other DOM Events
     *
     * You can also customize which DOM events to respond to (instead of `click`) by
     * providing an `events` array in the `ui-state-opts` attribute.
     *
     * #### Example:
     * ```html
     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
     * ```
     *
     * ### Highlighting the active link
     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
     *
     * ### Notes
     *
     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
     *   However, it might be simpler to use [[uiSref]] parameter-only links.
     *
     * #### Example:
     * Sets the `lang` parameter to `en` and remains on the same state.
     *
     * ```html
     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
     * ```
     *
     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
     * ```
     */
    var uiStateDirective;
    uiStateDirective = [
        '$uiRouter',
        '$timeout',
        function $StateRefDynamicDirective($uiRouter, $timeout) {
            var $state = $uiRouter.stateService;
            return {
                restrict: 'A',
                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
                link: function (scope, element, attrs, uiSrefActive) {
                    var type = getTypeInfo(element);
                    var active = uiSrefActive[1] || uiSrefActive[0];
                    var unlinkInfoFn = null;
                    var hookFn;
                    var rawDef = {};
                    var getDef = function () { return processedDef($state, element, rawDef); };
                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = noop), acc); }, {});
                    function update() {
                        var def = getDef();
                        if (unlinkInfoFn)
                            unlinkInfoFn();
                        if (active)
                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                        if (def.href != null)
                            attrs.$set(type.attr, def.href);
                    }
                    inputAttrs.forEach(function (field) {
                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
                        attrs.$observe(field, function (expr) {
                            watchDeregFns[field]();
                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
                                rawDef[field] = newval;
                                update();
                            }, true);
                        });
                    });
                    update();
                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                    if (!type.clickable)
                        return;
                    hookFn = clickHook(element, $state, $timeout, type, getDef);
                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
                },
            };
        },
    ];
    /**
     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
     *
     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
     * related directive's state is active (and remove them when it is inactive).
     *
     * The primary use-case is to highlight the active link in navigation menus,
     * distinguishing it from the inactive menu items.
     *
     * ### Linking to a `ui-sref` or `ui-state`
     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
     *
     * ### Matching
     *
     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
     * This is a "fuzzy match" which uses [[StateService.includes]].
     *
     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
     * This is an "exact match" which uses [[StateService.is]].
     *
     * ### Parameter values
     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
     *
     * #### Example:
     * ```html
     * <li ng-repeat="user in users" ui-sref-active="active">
     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
     * </li>
     * ```
     *
     * ### Examples
     *
     * Given the following template:
     * #### Example:
     * ```html
     * <ul>
     *   <li ui-sref-active="active" class="item">
     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
     *   </li>
     * </ul>
     * ```
     *
     * When the app state is `app.user` (or any child state),
     * and contains the state parameter "user" with value "bilbobaggins",
     * the resulting HTML will appear as (note the 'active' class):
     *
     * ```html
     * <ul>
     *   <li ui-sref-active="active" class="item active">
     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
     *   </li>
     * </ul>
     * ```
     *
     * ### Glob mode
     *
     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
     * The objects keys represent active class names and values represent the respective state names/globs.
     * `ui-sref-active` will match if the current active state **includes** any of
     * the specified state names/globs, even the abstract ones.
     *
     * #### Example:
     * Given the following template, with "admin" being an abstract state:
     * ```html
     * <div ui-sref-active="{'active': 'admin.**'}">
     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
     * </div>
     * ```
     *
     * Arrays are also supported as values in the `ngClass`-like interface.
     * This allows multiple states to add `active` class.
     *
     * #### Example:
     * Given the following template, with "admin.roles" being the current state, the class will be added too:
     * ```html
     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
     * </div>
     * ```
     *
     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
     *
     * ### Notes:
     *
     * - The class name is interpolated **once** during the directives link time (any further changes to the
     * interpolated value are ignored).
     *
     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
     */
    var uiSrefActiveDirective;
    uiSrefActiveDirective = [
        '$state',
        '$stateParams',
        '$interpolate',
        '$uiRouter',
        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
            return {
                restrict: 'A',
                controller: [
                    '$scope',
                    '$element',
                    '$attrs',
                    function ($scope, $element, $attrs) {
                        var states = [];
                        var activeEqClass;
                        var uiSrefActive;
                        // There probably isn't much point in $observing this
                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
                        // slight difference in logic routing
                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
                        try {
                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
                        }
                        catch (e) {
                            // Do nothing. uiSrefActive is not a valid expression.
                            // Fall back to using $interpolate below
                        }
                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
                        setStatesFromDefinitionObject(uiSrefActive);
                        // Allow uiSref to communicate with uiSrefActive[Equals]
                        this.$$addStateInfo = function (newState, newParams) {
                            // we already got an explicit state provided by ui-sref-active, so we
                            // shadow the one that comes from ui-sref
                            if (isObject(uiSrefActive) && states.length > 0) {
                                return;
                            }
                            var deregister = addState(newState, newParams, uiSrefActive);
                            update();
                            return deregister;
                        };
                        function updateAfterTransition(trans) {
                            trans.promise.then(update, noop);
                        }
                        $scope.$on('$destroy', setupEventListeners());
                        if ($uiRouter.globals.transition) {
                            updateAfterTransition($uiRouter.globals.transition);
                        }
                        function setupEventListeners() {
                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
                            return function cleanUp() {
                                deregisterStatesChangedListener();
                                deregisterOnStartListener();
                                deregisterStateChangeSuccessListener();
                            };
                        }
                        function handleStatesChanged() {
                            setStatesFromDefinitionObject(uiSrefActive);
                        }
                        function setStatesFromDefinitionObject(statesDefinition) {
                            if (isObject(statesDefinition)) {
                                states = [];
                                forEach(statesDefinition, function (stateOrName, activeClass) {
                                    // Helper function to abstract adding state.
                                    var addStateForClass = function (stateOrName, activeClass) {
                                        var ref = parseStateRef(stateOrName);
                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                                    };
                                    if (isString(stateOrName)) {
                                        // If state is string, just add it.
                                        addStateForClass(stateOrName, activeClass);
                                    }
                                    else if (isArray(stateOrName)) {
                                        // If state is an array, iterate over it and add each array item individually.
                                        forEach(stateOrName, function (stateOrName) {
                                            addStateForClass(stateOrName, activeClass);
                                        });
                                    }
                                });
                            }
                        }
                        function addState(stateName, stateParams, activeClass) {
                            var state = $state.get(stateName, stateContext($element));
                            var stateInfo = {
                                state: state || { name: stateName },
                                params: stateParams,
                                activeClass: activeClass,
                            };
                            states.push(stateInfo);
                            return function removeState() {
                                removeFrom(states)(stateInfo);
                            };
                        }
                        // Update route state
                        function update() {
                            var splitClasses = function (str) { return str.split(/\s/).filter(identity); };
                            var getClasses = function (stateList) {
                                return stateList
                                    .map(function (x) { return x.activeClass; })
                                    .map(splitClasses)
                                    .reduce(unnestR, []);
                            };
                            var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(uniqR, []);
                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(uniqR, []);
                            var removeClasses = allClasses.filter(function (cls) { return !inArray(addClasses, cls); });
                            $scope.$evalAsync(function () {
                                addClasses.forEach(function (className) { return $element.addClass(className); });
                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
                            });
                        }
                        update();
                    },
                ],
            };
        },
    ];
    ng
        .module('ui.router.state')
        .directive('uiSref', uiSrefDirective)
        .directive('uiSrefActive', uiSrefActiveDirective)
        .directive('uiSrefActiveEq', uiSrefActiveDirective)
        .directive('uiState', uiStateDirective);

    /** @publicapi @module ng1 */ /** */
    /**
     * `isState` Filter: truthy if the current state is the parameter
     *
     * Translates to [[StateService.is]] `$state.is("stateName")`.
     *
     * #### Example:
     * ```html
     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
     * ```
     */
    $IsStateFilter.$inject = ['$state'];
    function $IsStateFilter($state) {
        var isFilter = function (state, params, options) {
            return $state.is(state, params, options);
        };
        isFilter.$stateful = true;
        return isFilter;
    }
    /**
     * `includedByState` Filter: truthy if the current state includes the parameter
     *
     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
     *
     * #### Example:
     * ```html
     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
     * ```
     */
    $IncludedByStateFilter.$inject = ['$state'];
    function $IncludedByStateFilter($state) {
        var includesFilter = function (state, params, options) {
            return $state.includes(state, params, options);
        };
        includesFilter.$stateful = true;
        return includesFilter;
    }
    ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);

    /** @publicapi @module directives */ /** */
    /**
     * `ui-view`: A viewport directive which is filled in by a view from the active state.
     *
     * ### Attributes
     *
     * - `name`: (Optional) A view name.
     *   The name should be unique amongst the other views in the same state.
     *   You can have views of the same name that live in different states.
     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
     *
     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
     *   Uses [[$uiViewScroll]] to do the scrolling.
     *
     * - `onload`: Expression to evaluate whenever the view updates.
     *
     * #### Example:
     * A view can be unnamed or named.
     * ```html
     * <!-- Unnamed -->
     * <div ui-view></div>
     *
     * <!-- Named -->
     * <div ui-view="viewName"></div>
     *
     * <!-- Named (different style) -->
     * <ui-view name="viewName"></ui-view>
     * ```
     *
     * You can only have one unnamed view within any template (or root html). If you are only using a
     * single view and it is unnamed then you can populate it like so:
     *
     * ```html
     * <div ui-view></div>
     * $stateProvider.state("home", {
     *   template: "<h1>HELLO!</h1>"
     * })
     * ```
     *
     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
     *
     * ```js
     * $stateProvider.state("home", {
     *   views: {
     *     "": {
     *       template: "<h1>HELLO!</h1>"
     *     }
     *   }
     * })
     * ```
     *
     * But typically you'll only use the views property if you name your view or have more than one view
     * in the same template. There's not really a compelling reason to name a view if its the only one,
     * but you could if you wanted, like so:
     *
     * ```html
     * <div ui-view="main"></div>
     * ```
     *
     * ```js
     * $stateProvider.state("home", {
     *   views: {
     *     "main": {
     *       template: "<h1>HELLO!</h1>"
     *     }
     *   }
     * })
     * ```
     *
     * Really though, you'll use views to set up multiple views:
     *
     * ```html
     * <div ui-view></div>
     * <div ui-view="chart"></div>
     * <div ui-view="data"></div>
     * ```
     *
     * ```js
     * $stateProvider.state("home", {
     *   views: {
     *     "": {
     *       template: "<h1>HELLO!</h1>"
     *     },
     *     "chart": {
     *       template: "<chart_thing/>"
     *     },
     *     "data": {
     *       template: "<data_thing/>"
     *     }
     *   }
     * })
     * ```
     *
     * #### Examples for `autoscroll`:
     * ```html
     * <!-- If autoscroll present with no expression,
     *      then scroll ui-view into view -->
     * <ui-view autoscroll/>
     *
     * <!-- If autoscroll present with valid expression,
     *      then scroll ui-view into view if expression evaluates to true -->
     * <ui-view autoscroll='true'/>
     * <ui-view autoscroll='false'/>
     * <ui-view autoscroll='scopeVariable'/>
     * ```
     *
     * Resolve data:
     *
     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
     *
     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
     * depends on `$resolve` data.
     *
     * #### Example:
     * ```js
     * $stateProvider.state('home', {
     *   template: '<my-component user="$resolve.user"></my-component>',
     *   resolve: {
     *     user: function(UserService) { return UserService.fetchUser(); }
     *   }
     * });
     * ```
     */
    var uiView;
    // eslint-disable-next-line prefer-const
    uiView = [
        '$view',
        '$animate',
        '$uiViewScroll',
        '$interpolate',
        '$q',
        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
            function getRenderer() {
                return {
                    enter: function (element, target, cb) {
                        if (ng.version.minor > 2) {
                            $animate.enter(element, null, target).then(cb);
                        }
                        else {
                            $animate.enter(element, null, target, cb);
                        }
                    },
                    leave: function (element, cb) {
                        if (ng.version.minor > 2) {
                            $animate.leave(element).then(cb);
                        }
                        else {
                            $animate.leave(element, cb);
                        }
                    },
                };
            }
            function configsEqual(config1, config2) {
                return config1 === config2;
            }
            var rootData = {
                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
                $uiView: {},
            };
            var directive = {
                count: 0,
                restrict: 'ECA',
                terminal: true,
                priority: 400,
                transclude: 'element',
                compile: function (tElement, tAttrs, $transclude) {
                    return function (scope, $element, attrs) {
                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
                        var previousEl, currentEl, currentScope, viewConfig;
                        var activeUIView = {
                            $type: 'ng1',
                            id: directive.count++,
                            name: name,
                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
                            config: null,
                            configUpdated: configUpdatedCallback,
                            get creationContext() {
                                // The context in which this ui-view "tag" was created
                                var fromParentTagConfig = parse('$cfg.viewDecl.$context')(inherited);
                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
                                // See https://github.com/angular-ui/ui-router/issues/3355
                                var fromParentTag = parse('$uiView.creationContext')(inherited);
                                return fromParentTagConfig || fromParentTag;
                            },
                        };
                        trace.traceUIViewEvent('Linking', activeUIView);
                        function configUpdatedCallback(config) {
                            if (config && !(config instanceof Ng1ViewConfig))
                                return;
                            if (configsEqual(viewConfig, config))
                                return;
                            trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                            viewConfig = config;
                            updateView(config);
                        }
                        $element.data('$uiView', { $uiView: activeUIView });
                        updateView();
                        var unregister = $view.registerUIView(activeUIView);
                        scope.$on('$destroy', function () {
                            trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
                            unregister();
                        });
                        function cleanupLastView() {
                            if (previousEl) {
                                trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
                                previousEl.remove();
                                previousEl = null;
                            }
                            if (currentScope) {
                                trace.traceUIViewEvent('Destroying scope', activeUIView);
                                currentScope.$destroy();
                                currentScope = null;
                            }
                            if (currentEl) {
                                var _viewData_1 = currentEl.data('$uiViewAnim');
                                trace.traceUIViewEvent('Animate out', _viewData_1);
                                renderer.leave(currentEl, function () {
                                    _viewData_1.$$animLeave.resolve();
                                    previousEl = null;
                                });
                                previousEl = currentEl;
                                currentEl = null;
                            }
                        }
                        function updateView(config) {
                            var newScope = scope.$new();
                            var animEnter = $q.defer(), animLeave = $q.defer();
                            var $uiViewData = {
                                $cfg: config,
                                $uiView: activeUIView,
                            };
                            var $uiViewAnim = {
                                $animEnter: animEnter.promise,
                                $animLeave: animLeave.promise,
                                $$animLeave: animLeave,
                            };
                            /**
                             * @ngdoc event
                             * @name ui.router.state.directive:ui-view#$viewContentLoading
                             * @eventOf ui.router.state.directive:ui-view
                             * @eventType emits on ui-view directive scope
                             * @description
                             *
                             * Fired once the view **begins loading**, *before* the DOM is rendered.
                             *
                             * @param {Object} event Event object.
                             * @param {string} viewName Name of the view.
                             */
                            newScope.$emit('$viewContentLoading', name);
                            var cloned = $transclude(newScope, function (clone) {
                                clone.data('$uiViewAnim', $uiViewAnim);
                                clone.data('$uiView', $uiViewData);
                                renderer.enter(clone, $element, function onUIViewEnter() {
                                    animEnter.resolve();
                                    if (currentScope)
                                        currentScope.$emit('$viewContentAnimationEnded');
                                    if ((isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
                                        $uiViewScroll(clone);
                                    }
                                });
                                cleanupLastView();
                            });
                            currentEl = cloned;
                            currentScope = newScope;
                            /**
                             * @ngdoc event
                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
                             * @eventOf ui.router.state.directive:ui-view
                             * @eventType emits on ui-view directive scope
                             * @description           *
                             * Fired once the view is **loaded**, *after* the DOM is rendered.
                             *
                             * @param {Object} event Event object.
                             */
                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
                            currentScope.$eval(onloadExp);
                        }
                    };
                },
            };
            return directive;
        },
    ];
    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
    /** @hidden */
    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
        var getControllerAs = parse('viewDecl.controllerAs');
        var getResolveAs = parse('viewDecl.resolveAs');
        return {
            restrict: 'ECA',
            priority: -400,
            compile: function (tElement) {
                var initial = tElement.html();
                tElement.empty();
                return function (scope, $element) {
                    var data = $element.data('$uiView');
                    if (!data) {
                        $element.html(initial);
                        $compile($element.contents())(scope);
                        return;
                    }
                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: noop };
                    var resolveCtx = cfg.path && new ResolveContext(cfg.path);
                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
                    trace.traceUIViewFill(data.$uiView, $element.html());
                    var link = $compile($element.contents());
                    var controller = cfg.controller;
                    var controllerAs = getControllerAs(cfg);
                    var resolveAs = getResolveAs(cfg);
                    var locals = resolveCtx && getLocals(resolveCtx);
                    scope[resolveAs] = locals;
                    if (controller) {
                        var controllerInstance = ($controller(controller, extend({}, locals, { $scope: scope, $element: $element })));
                        if (controllerAs) {
                            scope[controllerAs] = controllerInstance;
                            scope[controllerAs][resolveAs] = locals;
                        }
                        // TODO: Use $view service as a central point for registering component-level hooks
                        // Then, when a component is created, tell the $view service, so it can invoke hooks
                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
                        $element.data('$ngControllerController', controllerInstance);
                        $element.children().data('$ngControllerController', controllerInstance);
                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
                    }
                    // Wait for the component to appear in the DOM
                    if (isString(cfg.component)) {
                        var kebobName = kebobString(cfg.component);
                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
                        var getComponentController = function () {
                            var directiveEl = [].slice
                                .call($element[0].children)
                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
                        };
                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
                            if (!ctrlInstance)
                                return;
                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
                            deregisterWatch_1();
                        });
                    }
                    link(scope);
                };
            },
        };
    }
    /** @hidden */
    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
    /** @hidden incrementing id */
    var _uiCanExitId = 0;
    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
        // Call $onInit() ASAP
        if (isFunction(controllerInstance.$onInit) &&
            !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
            controllerInstance.$onInit();
        }
        var viewState = tail(cfg.path).state.self;
        var hookOptions = { bind: controllerInstance };
        // Add component-level hook for onUiParamsChanged
        if (isFunction(controllerInstance.uiOnParamsChanged)) {
            var resolveContext = new ResolveContext(cfg.path);
            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
            // Fire callback on any successful transition
            var paramsUpdated = function ($transition$) {
                // Exit early if the $transition$ is the same as the view was created within.
                // Exit early if the $transition$ will exit the state the view is for.
                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
                    return;
                var toParams = $transition$.params('to');
                var fromParams = $transition$.params('from');
                var getNodeSchema = function (node) { return node.paramSchema; };
                var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(unnestR, []);
                var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(unnestR, []);
                // Find the to params that have different values than the from params
                var changedToParams = toSchema.filter(function (param) {
                    var idx = fromSchema.indexOf(param);
                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
                });
                // Only trigger callback if a to param has changed or is new
                if (changedToParams.length) {
                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
                    var newValues = filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
                }
            };
            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
        }
        // Add component-level hook for uiCanExit
        if (isFunction(controllerInstance.uiCanExit)) {
            var id_1 = _uiCanExitId++;
            var cacheProp_1 = '_uiCanExitIds';
            // Returns true if a redirect transition already answered truthy
            var prevTruthyAnswer_1 = function (trans) {
                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
            };
            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
            var wrappedHook = function (trans) {
                var promise;
                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
                if (!prevTruthyAnswer_1(trans)) {
                    promise = $q.when(controllerInstance.uiCanExit(trans));
                    promise.then(function (val) { return (ids[id_1] = val !== false); });
                }
                return promise;
            };
            var criteria = { exiting: viewState.name };
            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
        }
    }
    ng.module('ui.router.state').directive('uiView', uiView);
    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

    /** @publicapi @module ng1 */ /** */
    /** @hidden */
    function $ViewScrollProvider() {
        var useAnchorScroll = false;
        this.useAnchorScroll = function () {
            useAnchorScroll = true;
        };
        this.$get = [
            '$anchorScroll',
            '$timeout',
            function ($anchorScroll, $timeout) {
                if (useAnchorScroll) {
                    return $anchorScroll;
                }
                return function ($element) {
                    return $timeout(function () {
                        $element[0].scrollIntoView();
                    }, 0, false);
                };
            },
        ];
    }
    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

    /**
     * Main entry point for angular 1.x build
     * @publicapi @module ng1
     */ /** */
    var index$1 = 'ui.router';

    exports.$injector = $injector;
    exports.$q = $q;
    exports.BaseLocationServices = BaseLocationServices;
    exports.BaseUrlRule = BaseUrlRule;
    exports.BrowserLocationConfig = BrowserLocationConfig;
    exports.Glob = Glob;
    exports.HashLocationService = HashLocationService;
    exports.HookBuilder = HookBuilder;
    exports.MemoryLocationConfig = MemoryLocationConfig;
    exports.MemoryLocationService = MemoryLocationService;
    exports.NATIVE_INJECTOR_TOKEN = NATIVE_INJECTOR_TOKEN;
    exports.Ng1ViewConfig = Ng1ViewConfig;
    exports.Param = Param;
    exports.ParamFactory = ParamFactory;
    exports.ParamType = ParamType;
    exports.ParamTypes = ParamTypes;
    exports.PathNode = PathNode;
    exports.PathUtils = PathUtils;
    exports.PushStateLocationService = PushStateLocationService;
    exports.Queue = Queue;
    exports.RegisteredHook = RegisteredHook;
    exports.Rejection = Rejection;
    exports.Resolvable = Resolvable;
    exports.ResolveContext = ResolveContext;
    exports.StateBuilder = StateBuilder;
    exports.StateMatcher = StateMatcher;
    exports.StateObject = StateObject;
    exports.StateParams = StateParams;
    exports.StateProvider = StateProvider;
    exports.StateQueueManager = StateQueueManager;
    exports.StateRegistry = StateRegistry;
    exports.StateService = StateService;
    exports.TargetState = TargetState;
    exports.Trace = Trace;
    exports.Transition = Transition;
    exports.TransitionEventType = TransitionEventType;
    exports.TransitionHook = TransitionHook;
    exports.TransitionService = TransitionService;
    exports.UIRouter = UIRouter;
    exports.UIRouterGlobals = UIRouterGlobals;
    exports.UIRouterPluginBase = UIRouterPluginBase;
    exports.UrlConfig = UrlConfig;
    exports.UrlMatcher = UrlMatcher;
    exports.UrlMatcherFactory = UrlMatcherFactory;
    exports.UrlRouter = UrlRouter;
    exports.UrlRouterProvider = UrlRouterProvider;
    exports.UrlRuleFactory = UrlRuleFactory;
    exports.UrlRules = UrlRules;
    exports.UrlService = UrlService;
    exports.ViewService = ViewService;
    exports._extend = _extend;
    exports._inArray = _inArray;
    exports._pushTo = _pushTo;
    exports._removeFrom = _removeFrom;
    exports.all = all;
    exports.allTrueR = allTrueR;
    exports.ancestors = ancestors;
    exports.and = and;
    exports.any = any;
    exports.anyTrueR = anyTrueR;
    exports.applyPairs = applyPairs;
    exports.arrayTuples = arrayTuples;
    exports.assertFn = assertFn;
    exports.assertMap = assertMap;
    exports.assertPredicate = assertPredicate;
    exports.beforeAfterSubstr = beforeAfterSubstr;
    exports.buildUrl = buildUrl;
    exports.compose = compose;
    exports.copy = copy;
    exports.core = index;
    exports.createProxyFunctions = createProxyFunctions;
    exports.curry = curry;
    exports.default = index$1;
    exports.defaultResolvePolicy = defaultResolvePolicy;
    exports.defaultTransOpts = defaultTransOpts;
    exports.defaults = defaults;
    exports.deregAll = deregAll;
    exports.eq = eq;
    exports.equals = equals;
    exports.extend = extend;
    exports.filter = filter;
    exports.find = find;
    exports.flatten = flatten;
    exports.flattenR = flattenR;
    exports.fnToString = fnToString;
    exports.forEach = forEach;
    exports.fromJson = fromJson;
    exports.functionToString = functionToString;
    exports.getLocals = getLocals;
    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
    exports.getParams = getParams;
    exports.hashLocationPlugin = hashLocationPlugin;
    exports.hostRegex = hostRegex;
    exports.identity = identity;
    exports.inArray = inArray;
    exports.inherit = inherit;
    exports.invoke = invoke;
    exports.is = is;
    exports.isArray = isArray;
    exports.isDate = isDate;
    exports.isDefined = isDefined;
    exports.isFunction = isFunction;
    exports.isInjectable = isInjectable;
    exports.isNull = isNull;
    exports.isNullOrUndefined = isNullOrUndefined;
    exports.isNumber = isNumber;
    exports.isObject = isObject;
    exports.isPromise = isPromise;
    exports.isRegExp = isRegExp;
    exports.isString = isString;
    exports.isUndefined = isUndefined;
    exports.joinNeighborsR = joinNeighborsR;
    exports.kebobString = kebobString;
    exports.keyValsToObjectR = keyValsToObjectR;
    exports.locationPluginFactory = locationPluginFactory;
    exports.makeEvent = makeEvent;
    exports.makeStub = makeStub;
    exports.map = map;
    exports.mapObj = mapObj;
    exports.matchState = matchState;
    exports.maxLength = maxLength;
    exports.memoryLocationPlugin = memoryLocationPlugin;
    exports.mergeR = mergeR;
    exports.ng1ViewsBuilder = ng1ViewsBuilder;
    exports.noop = noop;
    exports.not = not;
    exports.omit = omit;
    exports.or = or;
    exports.padString = padString;
    exports.pairs = pairs;
    exports.parse = parse;
    exports.parseUrl = parseUrl$1;
    exports.pattern = pattern;
    exports.pick = pick;
    exports.pipe = pipe;
    exports.pluck = pluck;
    exports.prop = prop;
    exports.propEq = propEq;
    exports.pushR = pushR;
    exports.pushStateLocationPlugin = pushStateLocationPlugin;
    exports.pushTo = pushTo;
    exports.removeFrom = removeFrom;
    exports.resolvablesBuilder = resolvablesBuilder;
    exports.resolvePolicies = resolvePolicies;
    exports.root = root;
    exports.services = services;
    exports.servicesPlugin = servicesPlugin;
    exports.silenceUncaughtInPromise = silenceUncaughtInPromise;
    exports.silentRejection = silentRejection;
    exports.splitEqual = splitEqual;
    exports.splitHash = splitHash;
    exports.splitOnDelim = splitOnDelim;
    exports.splitQuery = splitQuery;
    exports.stringify = stringify;
    exports.stripLastPathElement = stripLastPathElement;
    exports.tail = tail;
    exports.toJson = toJson;
    exports.trace = trace;
    exports.trimHashVal = trimHashVal;
    exports.uniqR = uniqR;
    exports.unnest = unnest;
    exports.unnestR = unnestR;
    exports.val = val;
    exports.values = values;
    exports.watchDigests = watchDigests;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=angular-ui-router.js.map

/**
 * angular-ui-utils - Swiss-Army-Knife of AngularJS tools (with no external dependencies!)
 * @version v0.2.3 - 2015-03-30
 * @link http://angular-ui.github.com
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
angular.module("ui.alias", []).config(["$compileProvider", "uiAliasConfig", function ($compileProvider, uiAliasConfig) {
  "use strict";

  uiAliasConfig = uiAliasConfig || {};
  angular.forEach(uiAliasConfig, function (config, alias) {
    if (angular.isString(config)) {
      config = {
        replace: true,
        template: config
      };
    }
    $compileProvider.directive(alias, function () {
      return config;
    });
  });
}]);

/**
 * General-purpose Event binding. Bind any event not natively supported by Angular
 * Pass an object with keynames for events to ui-event
 * Allows $event object and $params object to be passed
 *
 * @example <input ui-event="{ focus : 'counter++', blur : 'someCallback()' }">
 * @example <input ui-event="{ myCustomEvent : 'myEventHandler($event, $params)'}">
 *
 * @param ui-event {string|object literal} The event to bind to as a string or a hash of events with their callbacks
 */
angular.module("ui.event", []).directive("uiEvent", ["$parse",
  function ($parse) {
    "use strict";

    return function ($scope, elm, attrs) {
      var events = $scope.$eval(attrs.uiEvent);
      angular.forEach(events, function (uiEvent, eventName) {
        var fn = $parse(uiEvent);
        elm.bind(eventName, function (evt) {
          var params = Array.prototype.slice.call(arguments);
          // Take out first paramater (event object);
          params = params.splice(1);
          fn($scope, { $event: evt, $params: params });
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        });
      });
    };
  }]);

/**
 * A replacement utility for internationalization very similar to sprintf.
 *
 * @param replace {mixed} The tokens to replace depends on type
 *  string: all instances of $0 will be replaced
 *  array: each instance of $0, $1, $2 etc. will be placed with each array item in corresponding order
 *  object: all attributes will be iterated through, with :key being replaced with its corresponding value
 * @return string
 *
 * @example: 'Hello :name, how are you :day'.format({ name:'John', day:'Today' })
 * @example: 'Records $0 to $1 out of $2 total'.format(['10', '20', '3000'])
 * @example: '$0 agrees to all mentions $0 makes in the event that $0 hits a tree while $0 is driving drunk'.format('Bob')
 */
angular.module("ui.format", []).filter("format", function () {
  "use strict";

  return function (value, replace) {
    var target = value;
    if (angular.isString(target) && replace !== undefined) {
      if (!angular.isArray(replace) && !angular.isObject(replace)) {
        replace = [replace];
      }
      if (angular.isArray(replace)) {
        var rlen = replace.length;
        var rfx = function (str, i) {
          i = parseInt(i, 10);
          return (i >= 0 && i < rlen) ? replace[i] : str;
        };
        target = target.replace(/\$([0-9]+)/g, rfx);
      }
      else {
        angular.forEach(replace, function (value, key) {
          target = target.split(":" + key).join(value);
        });
      }
    }
    return target;
  };
});

/**
 * Wraps the
 * @param text {string} haystack to search through
 * @param search {string} needle to search for
 * @param [caseSensitive] {boolean} optional boolean to use case-sensitive searching
 */
angular.module("ui.highlight", []).filter("highlight", function () {
  "use strict";

  return function (text, search, caseSensitive) {
    if (text && (search || angular.isNumber(search))) {
      text = text.toString();
      search = search.toString();
      if (caseSensitive) {
        return text.split(search).join("<span class=\"ui-match\">" + search + "</span>");
      } else {
        return text.replace(new RegExp(search, "gi"), "<span class=\"ui-match\">$&</span>");
      }
    } else {
      return text;
    }
  };
});

// modeled after: angular-1.0.7/src/ng/directive/ngInclude.js
angular.module("ui.include", [])
  .directive("uiInclude", ["$http", "$templateCache", "$anchorScroll", "$compile",
    function ($http, $templateCache, $anchorScroll, $compile) {
      "use strict";

      return {
        restrict: "ECA",
        terminal: true,
        compile: function (element, attr) {
          var srcExp = attr.uiInclude || attr.src,
            fragExp = attr.fragment || "",
            onloadExp = attr.onload || "",
            autoScrollExp = attr.autoscroll;

          return function (scope, element) {
            var changeCounter = 0,
              childScope;

            var clearContent = function () {
              if (childScope) {
                childScope.$destroy();
                childScope = null;
              }

              element.html("");
            };

            function ngIncludeWatchAction() {
              var thisChangeId = ++changeCounter;
              var src = scope.$eval(srcExp);
              var fragment = scope.$eval(fragExp);

              if (src) {
                $http.get(src, { cache: $templateCache }).success(function (response) {
                  if (thisChangeId !== changeCounter) { return; }

                  if (childScope) { childScope.$destroy(); }
                  childScope = scope.$new();

                  var contents;
                  if (fragment) {
                    contents = angular.element("<div/>").html(response).find(fragment);
                  }
                  else {
                    contents = angular.element("<div/>").html(response).contents();
                  }
                  element.html(contents);
                  $compile(contents)(childScope);

                  if (angular.isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                    $anchorScroll();
                  }

                  childScope.$emit("$includeContentLoaded");
                  scope.$eval(onloadExp);
                }).error(function () {
                  if (thisChangeId === changeCounter) { clearContent(); }
                });
              } else { clearContent(); }
            }

            scope.$watch(fragExp, ngIncludeWatchAction);
            scope.$watch(srcExp, ngIncludeWatchAction);
          };
        }
      };
    }]);

/**
 * Provides an easy way to toggle a checkboxes indeterminate property
 *
 * @example <input type="checkbox" ui-indeterminate="isUnkown">
 */
angular.module("ui.indeterminate", []).directive("uiIndeterminate", [
  function () {
    "use strict";

    return {
      compile: function (tElm, tAttrs) {
        if (!tAttrs.type || tAttrs.type.toLowerCase() !== "checkbox") {
          return angular.noop;
        }

        return function ($scope, elm, attrs) {
          $scope.$watch(attrs.uiIndeterminate, function (newVal) {
            elm[0].indeterminate = !!newVal;
          });
        };
      }
    };
  }]);

/**
 * Converts variable-esque naming conventions to something presentational, capitalized words separated by space.
 * @param {String} value The value to be parsed and prettified.
 * @param {String} [inflector] The inflector to use. Default: humanize.
 * @return {String}
 * @example {{ 'Here Is my_phoneNumber' | inflector:'humanize' }} => Here Is My Phone Number
 *          {{ 'Here Is my_phoneNumber' | inflector:'underscore' }} => here_is_my_phone_number
 *          {{ 'Here Is my_phoneNumber' | inflector:'variable' }} => hereIsMyPhoneNumber
 */
angular.module("ui.inflector", []).filter("inflector", function () {
  "use strict";

  function tokenize(text) {
    text = text.replace(/([A-Z])|([\-|\_])/g, function (_, $1) { return " " + ($1 || ""); });
    return text.replace(/\s\s+/g, " ").trim().toLowerCase().split(" ");
  }

  function capitalizeTokens(tokens) {
    var result = [];
    angular.forEach(tokens, function (token) {
      result.push(token.charAt(0).toUpperCase() + token.substr(1));
    });
    return result;
  }

  var inflectors = {
    humanize: function (value) {
      return capitalizeTokens(tokenize(value)).join(" ");
    },
    underscore: function (value) {
      return tokenize(value).join("_");
    },
    variable: function (value) {
      value = tokenize(value);
      value = value[0] + capitalizeTokens(value.slice(1)).join("");
      return value;
    }
  };

  return function (text, inflector) {
    if (inflector !== false && angular.isString(text)) {
      inflector = inflector || "humanize";
      return inflectors[inflector](text);
    } else {
      return text;
    }
  };
});

/**
 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
 *
 * It is possible to specify a default set of parameters for each jQuery plugin.
 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
 * Unfortunately, at this time you can only pre-define the first parameter.
 * @example { jq : { datepicker : { showOn:'click' } } }
 *
 * @param ui-jq {string} The $elm.[pluginName]() to call.
 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
 *     Multiple parameters can be separated by commas
 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
 *
 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
 */
angular.module("ui.jq", []).
  value("uiJqConfig", {}).
  directive("uiJq", ["uiJqConfig", "$timeout", function uiJqInjectingFunction(uiJqConfig, $timeout) {
    "use strict";

    return {
      restrict: "A",
      compile: function uiJqCompilingFunction(tElm, tAttrs) {

        if (!angular.isFunction(tElm[tAttrs.uiJq])) {
          throw new Error("ui-jq: The \"" + tAttrs.uiJq + "\" function does not exist");
        }
        var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];

        return function uiJqLinkingFunction(scope, elm, attrs) {

          // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
          if (attrs.ngModel && elm.is("select,input,textarea")) {
            elm.bind("change", function () {
              elm.trigger("input");
            });
          }

          function createLinkOptions() {
            var linkOptions = [];

            // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
            if (attrs.uiOptions) {
              linkOptions = scope.$eval("[" + attrs.uiOptions + "]");
              if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
                linkOptions[0] = angular.extend({}, options, linkOptions[0]);
              }
            } else if (options) {
              linkOptions = [options];
            }
            return linkOptions;
          }

          // Call jQuery method and pass relevant options
          function callPlugin() {
            $timeout(function () {
              elm[attrs.uiJq].apply(elm, createLinkOptions());
            }, 0, false);
          }

          // If ui-refresh is used, re-fire the the method upon every change
          if (attrs.uiRefresh) {
            scope.$watch(attrs.uiRefresh, function () {
              callPlugin();
            });
          }
          callPlugin();
        };
      }
    };
  }]);

angular.module("ui.keypress", []).
  factory("keypressHelper", ["$parse", function keypress($parse) {
    "use strict";

    var keysByCode = {
      8: "backspace",
      9: "tab",
      13: "enter",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "insert",
      46: "delete"
    };

    var capitaliseFirstLetter = function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    return function (mode, scope, elm, attrs) {
      var params, combinations = [];
      params = scope.$eval(attrs["ui" + capitaliseFirstLetter(mode)]);

      // Prepare combinations for simple checking
      angular.forEach(params, function (v, k) {
        var combination, expression;
        expression = $parse(v);

        angular.forEach(k.split(" "), function (variation) {
          combination = {
            expression: expression,
            keys: {}
          };
          angular.forEach(variation.split("-"), function (value) {
            combination.keys[value] = true;
          });
          combinations.push(combination);
        });
      });

      // Check only matching of pressed keys one of the conditions
      elm.bind(mode, function (event) {
      // No need to do that inside the cycle
        var metaPressed = !!(event.metaKey && !event.ctrlKey);
        var altPressed = !!event.altKey;
        var ctrlPressed = !!event.ctrlKey;
        var shiftPressed = !!event.shiftKey;
        var keyCode = event.keyCode;

        // normalize keycodes
        if (mode === "keypress" && !shiftPressed && keyCode >= 97 && keyCode <= 122) {
          keyCode = keyCode - 32;
        }

        // Iterate over prepared combinations
        angular.forEach(combinations, function (combination) {

          var mainKeyPressed = combination.keys[keysByCode[keyCode]] || combination.keys[keyCode.toString()];

          var metaRequired = !!combination.keys.meta;
          var altRequired = !!combination.keys.alt;
          var ctrlRequired = !!combination.keys.ctrl;
          var shiftRequired = !!combination.keys.shift;

          if (
            mainKeyPressed &&
          ( metaRequired === metaPressed ) &&
          ( altRequired === altPressed ) &&
          ( ctrlRequired === ctrlPressed ) &&
          ( shiftRequired === shiftPressed )
          ) {
          // Run the function
            scope.$apply(function () {
              combination.expression(scope, { "$event": event });
            });
          }
        });
      });
    };
  }]);

/**
 * Bind one or more handlers to particular keys or their combination
 * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: "{ keys1: expression1 [, keys2: expression2 [ , ... ]]}". String syntax: ""expression1 on keys1 [ and expression2 on keys2 [ and ... ]]"". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.
 * @example <input ui-keypress="{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}" /> <input ui-keypress="foo = 2 on ctrl-13 and bar('hello') on shift-esc" />
 **/
angular.module("ui.keypress").directive("uiKeydown", ["keypressHelper", function (keypressHelper) {
  "use strict";

  return {
    link: function (scope, elm, attrs) {
      keypressHelper("keydown", scope, elm, attrs);
    }
  };
}]);

angular.module("ui.keypress").directive("uiKeypress", ["keypressHelper", function (keypressHelper) {
  "use strict";

  return {
    link: function (scope, elm, attrs) {
      keypressHelper("keypress", scope, elm, attrs);
    }
  };
}]);

angular.module("ui.keypress").directive("uiKeyup", ["keypressHelper", function (keypressHelper) {
  "use strict";

  return {
    link: function (scope, elm, attrs) {
      keypressHelper("keyup", scope, elm, attrs);
    }
  };
}]);

/*
 Attaches input mask onto input element
 */
angular.module("ui.mask", [])
  .value("uiMaskConfig", {
    "maskDefinitions": {
      "9": /\d/,
      "A": /[a-zA-Z]/,
      "*": /[a-zA-Z0-9]/
    },
    "clearOnBlur": true
  })
  .directive("uiMask", ["uiMaskConfig", "$parse", function (maskConfig, $parse) {
    "use strict";

    return {
      priority: 100,
      require: "ngModel",
      restrict: "A",
      compile: function uiMaskCompilingFunction() {
        var options = maskConfig;

        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
          var maskProcessed = false, eventsBound = false,
            maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
            // Minimum required length of the value to be considered valid
            minRequiredLength,
            value, valueMasked, isValid,
            // Vars for initializing/uninitializing
            originalPlaceholder = iAttrs.placeholder,
            originalMaxlength = iAttrs.maxlength,
            // Vars used exclusively in eventHandler()
            oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength;

          function initialize(maskAttr) {
            if (!angular.isDefined(maskAttr)) {
              return uninitialize();
            }
            processRawMask(maskAttr);
            if (!maskProcessed) {
              return uninitialize();
            }
            initializeElement();
            bindEventListeners();
            return true;
          }

          function initPlaceholder(placeholderAttr) {
            if (! angular.isDefined(placeholderAttr)) {
              return;
            }

            maskPlaceholder = placeholderAttr;

            // If the mask is processed, then we need to update the value
            if (maskProcessed) {
              eventHandler();
            }
          }

          function formatter(fromModelValue) {
            if (!maskProcessed) {
              return fromModelValue;
            }
            value = unmaskValue(fromModelValue || "");
            isValid = validateValue(value);
            controller.$setValidity("mask", isValid);
            return isValid && value.length ? maskValue(value) : undefined;
          }

          function parser(fromViewValue) {
            if (!maskProcessed) {
              return fromViewValue;
            }
            value = unmaskValue(fromViewValue || "");
            isValid = validateValue(value);
            // We have to set viewValue manually as the reformatting of the input
            // value performed by eventHandler() doesn't happen until after
            // this parser is called, which causes what the user sees in the input
            // to be out-of-sync with what the controller's $viewValue is set to.
            controller.$viewValue = value.length ? maskValue(value) : "";
            controller.$setValidity("mask", isValid);
            if (value === "" && iAttrs.required) {
              controller.$setValidity("required", !controller.$error.required);
            }
            return isValid ? value : undefined;
          }

          var linkOptions = {};

          if (iAttrs.uiOptions) {
            linkOptions = scope.$eval("[" + iAttrs.uiOptions + "]");
            if (angular.isObject(linkOptions[0])) {
              // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
              linkOptions = (function (original, current) {
                for (var i in original) {
                  if (Object.prototype.hasOwnProperty.call(original, i)) {
                    if (current[i] === undefined) {
                      current[i] = angular.copy(original[i]);
                    } else {
                      angular.extend(current[i], original[i]);
                    }
                  }
                }
                return current;
              })(options, linkOptions[0]);
            }
          } else {
            linkOptions = options;
          }

          iAttrs.$observe("uiMask", initialize);
          iAttrs.$observe("placeholder", initPlaceholder);
          var modelViewValue = false;
          iAttrs.$observe("modelViewValue", function (val) {
            if (val === "true") {
              modelViewValue = true;
            }
          });
          scope.$watch(iAttrs.ngModel, function (val) {
            if (modelViewValue && val) {
              var model = $parse(iAttrs.ngModel);
              model.assign(scope, controller.$viewValue);
            }
          });
          controller.$formatters.push(formatter);
          controller.$parsers.push(parser);

          function uninitialize() {
            maskProcessed = false;
            unbindEventListeners();

            if (angular.isDefined(originalPlaceholder)) {
              iElement.attr("placeholder", originalPlaceholder);
            } else {
              iElement.removeAttr("placeholder");
            }

            if (angular.isDefined(originalMaxlength)) {
              iElement.attr("maxlength", originalMaxlength);
            } else {
              iElement.removeAttr("maxlength");
            }

            iElement.val(controller.$modelValue);
            controller.$viewValue = controller.$modelValue;
            return false;
          }

          function initializeElement() {
            value = oldValueUnmasked = unmaskValue(controller.$viewValue || "");
            valueMasked = oldValue = maskValue(value);
            isValid = validateValue(value);
            var viewValue = isValid && value.length ? valueMasked : "";
            if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
              iElement.attr("maxlength", maskCaretMap[maskCaretMap.length - 1] * 2);
            }
            iElement.attr("placeholder", maskPlaceholder);
            iElement.val(viewValue);
            controller.$viewValue = viewValue;
            // Not using $setViewValue so we don't clobber the model value and dirty the form
            // without any kind of user interaction.
          }

          function bindEventListeners() {
            if (eventsBound) {
              return;
            }
            iElement.bind("blur", blurHandler);
            iElement.bind("mousedown mouseup", mouseDownUpHandler);
            iElement.bind("input keyup click focus", eventHandler);
            eventsBound = true;
          }

          function unbindEventListeners() {
            if (!eventsBound) {
              return;
            }
            iElement.unbind("blur", blurHandler);
            iElement.unbind("mousedown", mouseDownUpHandler);
            iElement.unbind("mouseup", mouseDownUpHandler);
            iElement.unbind("input", eventHandler);
            iElement.unbind("keyup", eventHandler);
            iElement.unbind("click", eventHandler);
            iElement.unbind("focus", eventHandler);
            eventsBound = false;
          }

          function validateValue(value) {
            // Zero-length value validity is ngRequired's determination
            return value.length ? value.length >= minRequiredLength : true;
          }

          function unmaskValue(value) {
            var valueUnmasked = "",
              maskPatternsCopy = maskPatterns.slice();
            // Preprocess by stripping mask components from value
            value = value.toString();
            angular.forEach(maskComponents, function (component) {
              value = value.replace(component, "");
            });
            angular.forEach(value.split(""), function (chr) {
              if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
                valueUnmasked += chr;
                maskPatternsCopy.shift();
              }
            });
            return valueUnmasked;
          }

          function maskValue(unmaskedValue) {
            var valueMasked = "",
              maskCaretMapCopy = maskCaretMap.slice();

            angular.forEach(maskPlaceholder.split(""), function (chr, i) {
              if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
                valueMasked += unmaskedValue.charAt(0) || "_";
                unmaskedValue = unmaskedValue.substr(1);
                maskCaretMapCopy.shift();
              }
              else {
                valueMasked += chr;
              }
            });
            return valueMasked;
          }

          function getPlaceholderChar(i) {
            var placeholder = iAttrs.placeholder;

            if (typeof placeholder !== "undefined" && placeholder[i]) {
              return placeholder[i];
            } else {
              return "_";
            }
          }

          // Generate array of mask components that will be stripped from a masked value
          // before processing to prevent mask components from being added to the unmasked value.
          // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
          // If a maskable char is followed by a mask char and has a mask
          // char behind it, we'll split it into it's own component so if
          // a user is aggressively deleting in the input and a char ahead
          // of the maskable char gets deleted, we'll still be able to strip
          // it in the unmaskValue() preprocessing.
          function getMaskComponents() {
            return maskPlaceholder.replace(/[_]+/g, "_").replace(/([^_]+)([a-zA-Z0-9])([^_])/g, "$1$2_$3").split("_");
          }

          function processRawMask(mask) {
            var characterCount = 0;

            maskCaretMap = [];
            maskPatterns = [];
            maskPlaceholder = "";

            if (typeof mask === "string") {
              minRequiredLength = 0;

              var isOptional = false,
                numberOfOptionalCharacters = 0,
                splitMask = mask.split("");

              angular.forEach(splitMask, function (chr, i) {
                if (linkOptions.maskDefinitions[chr]) {

                  maskCaretMap.push(characterCount);

                  maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
                  maskPatterns.push(linkOptions.maskDefinitions[chr]);

                  characterCount++;
                  if (!isOptional) {
                    minRequiredLength++;
                  }
                }
                else if (chr === "?") {
                  isOptional = true;
                  numberOfOptionalCharacters++;
                }
                else {
                  maskPlaceholder += chr;
                  characterCount++;
                }
              });
            }
            // Caret position immediately following last position is valid.
            maskCaretMap.push(maskCaretMap.slice().pop() + 1);

            maskComponents = getMaskComponents();
            maskProcessed = maskCaretMap.length > 1 ? true : false;
          }

          function blurHandler() {
            if (linkOptions.clearOnBlur) {
              oldCaretPosition = 0;
              oldSelectionLength = 0;
              if (!isValid || value.length === 0) {
                valueMasked = "";
                iElement.val("");
                scope.$apply(function () {
                  controller.$setViewValue("");
                });
              }
            }
          }

          function mouseDownUpHandler(e) {
            if (e.type === "mousedown") {
              iElement.bind("mouseout", mouseoutHandler);
            } else {
              iElement.unbind("mouseout", mouseoutHandler);
            }
          }

          iElement.bind("mousedown mouseup", mouseDownUpHandler);

          function mouseoutHandler() {
            /* jshint validthis: true */
            oldSelectionLength = getSelectionLength(this);
            iElement.unbind("mouseout", mouseoutHandler);
          }

          function eventHandler(e) {
            /* jshint validthis: true */
            e = e || {};
            // Allows more efficient minification
            var eventWhich = e.which,
              eventType = e.type;

            // Prevent shift and ctrl from mucking with old values
            if (eventWhich === 16 || eventWhich === 91) { return;}

            var val = iElement.val(),
              valOld = oldValue,
              valMasked,
              valUnmasked = unmaskValue(val),
              valUnmaskedOld = oldValueUnmasked,
              valAltered = false,

              caretPos = getCaretPosition(this) || 0,
              caretPosOld = oldCaretPosition || 0,
              caretPosDelta = caretPos - caretPosOld,
              caretPosMin = maskCaretMap[0],
              caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),

              selectionLenOld = oldSelectionLength || 0,
              isSelected = getSelectionLength(this) > 0,
              wasSelected = selectionLenOld > 0,

              // Case: Typing a character to overwrite a selection
              isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
              // Case: Delete and backspace behave identically on a selection
              isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
              isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes

              isKeyLeftArrow = eventWhich === 37,
              // Necessary due to "input" event not providing a key code
              isKeyBackspace = eventWhich === 8 || (eventType !== "keyup" && isDeletion && (caretPosDelta === -1)),
              isKeyDelete = eventWhich === 46 || (eventType !== "keyup" && isDeletion && (caretPosDelta === 0 ) && !wasSelected),

              // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
              // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
              // non-mask character. Also applied to click since users are (arguably) more likely to backspace
              // a character when clicking within a filled input.
              caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === "click") && caretPos > caretPosMin;

            oldSelectionLength = getSelectionLength(this);

            // These events don't require any action
            if (isSelection || (isSelected && (eventType === "click" || eventType === "keyup"))) {
              return;
            }

            // Value Handling
            // ==============

            // User attempted to delete but raw value was unaffected--correct this grievous offense
            if ((eventType === "input") && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
              while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
                caretPos--;
              }
              while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
                caretPos++;
              }
              var charIndex = maskCaretMap.indexOf(caretPos);
              // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
              valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
              valAltered = true;
            }

            // Update values
            valMasked = maskValue(valUnmasked);

            oldValue = valMasked;
            oldValueUnmasked = valUnmasked;
            iElement.val(valMasked);
            if (valAltered) {
              // We've altered the raw value after it's been $digest'ed, we need to $apply the new value.
              scope.$apply(function () {
                controller.$setViewValue(valUnmasked);
              });
            }

            // Caret Repositioning
            // ===================

            // Ensure that typing always places caret ahead of typed character in cases where the first char of
            // the input is a mask char and the caret is placed at the 0 position.
            if (isAddition && (caretPos <= caretPosMin)) {
              caretPos = caretPosMin + 1;
            }

            if (caretBumpBack) {
              caretPos--;
            }

            // Make sure caret is within min and max position limits
            caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;

            // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
            while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
              caretPos += caretBumpBack ? -1 : 1;
            }

            if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
              caretPos++;
            }
            oldCaretPosition = caretPos;
            setCaretPosition(this, caretPos);
          }

          function isValidCaretPosition(pos) { return maskCaretMap.indexOf(pos) > -1; }

          function getCaretPosition(input) {
            if (!input) return 0;
            if (input.selectionStart !== undefined) {
              return input.selectionStart;
            } else if (document.selection) {
              // Curse you IE
              input.focus();
              var selection = document.selection.createRange();
              selection.moveStart("character", input.value ? -input.value.length : 0);
              return selection.text.length;
            }
            return 0;
          }

          function setCaretPosition(input, pos) {
            if (!input) return 0;
            if (input.offsetWidth === 0 || input.offsetHeight === 0) {
              return; // Input's hidden
            }
            if (input.setSelectionRange) {
              input.focus();
              input.setSelectionRange(pos, pos);
            }
            else if (input.createTextRange) {
              // Curse you IE
              var range = input.createTextRange();
              range.collapse(true);
              range.moveEnd("character", pos);
              range.moveStart("character", pos);
              range.select();
            }
          }

          function getSelectionLength(input) {
            if (!input) return 0;
            if (input.selectionStart !== undefined) {
              return (input.selectionEnd - input.selectionStart);
            }
            if (document.selection) {
              return (document.selection.createRange().text.length);
            }
            return 0;
          }

          // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
          if (!Array.prototype.indexOf) {
            Array.prototype.indexOf = function (searchElement /* , fromIndex */) {
              if (this === null) {
                throw new TypeError();
              }
              var t = Object(this);
              var len = t.length >>> 0;
              if (len === 0) {
                return -1;
              }
              var n = 0;
              if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) { // shortcut for verifying if it's NaN
                  n = 0;
                } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
                  n = (n > 0 || -1) * Math.floor(Math.abs(n));
                }
              }
              if (n >= len) {
                return -1;
              }
              var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
              for (; k < len; k++) {
                if (k in t && t[k] === searchElement) {
                  return k;
                }
              }
              return -1;
            };
          }

        };
      }
    };
  }
  ]);

/**
 * Add a clear button to form inputs to reset their value
 */
angular.module("ui.reset", []).value("uiResetConfig", null).directive("uiReset", ["uiResetConfig", function (uiResetConfig) {
  "use strict";

  var resetValue = null;
  if (uiResetConfig !== undefined) {
    resetValue = uiResetConfig;
  }
  return {
    require: "ngModel",
    link: function (scope, elm, attrs, ctrl) {
      var aElement;
      aElement = angular.element("<a class=\"ui-reset\" />");
      elm.wrap("<span class=\"ui-resetwrap\" />").after(aElement);
      aElement.bind("click", function (e) {
        e.preventDefault();
        scope.$apply(function () {
          if (attrs.uiReset) {
            ctrl.$setViewValue(scope.$eval(attrs.uiReset));
          } else {
            ctrl.$setViewValue(resetValue);
          }
          ctrl.$render();
        });
      });
    }
  };
}]);

/**
 * Set a $uiRoute boolean to see if the current route matches
 */
angular.module("ui.route", []).directive("uiRoute", ["$location", "$parse", function ($location, $parse) {
  "use strict";

  return {
    restrict: "AC",
    scope: true,
    compile: function (tElement, tAttrs) {
      var useProperty;
      if (tAttrs.uiRoute) {
        useProperty = "uiRoute";
      } else if (tAttrs.ngHref) {
        useProperty = "ngHref";
      } else if (tAttrs.href) {
        useProperty = "href";
      } else {
        throw new Error("uiRoute missing a route or href property on " + tElement[0]);
      }
      return function ($scope, elm, attrs) {
        var modelSetter = $parse(attrs.ngModel || attrs.routeModel || "$uiRoute").assign;
        var watcher = angular.noop;

        // Used by href and ngHref
        function staticWatcher(newVal) {
          var hash = newVal.indexOf("#");
          if (hash > -1) {
            newVal = newVal.substr(hash + 1);
          }
          watcher = function watchHref() {
            modelSetter($scope, ($location.path().indexOf(newVal) > -1));
          };
          watcher();
        }
        // Used by uiRoute
        function regexWatcher(newVal) {
          var hash = newVal.indexOf("#");
          if (hash > -1) {
            newVal = newVal.substr(hash + 1);
          }
          watcher = function watchRegex() {
            var regexp = new RegExp("^" + newVal + "$", ["i"]);
            modelSetter($scope, regexp.test($location.path()));
          };
          watcher();
        }

        switch (useProperty) {
          case "uiRoute":
            // if uiRoute={{}} this will be undefined, otherwise it will have a value and $observe() never gets triggered
            if (attrs.uiRoute) {
              regexWatcher(attrs.uiRoute);
            } else {
              attrs.$observe("uiRoute", regexWatcher);
            }
            break;
          case "ngHref":
            // Setup watcher() every time ngHref changes
            if (attrs.ngHref) {
              staticWatcher(attrs.ngHref);
            } else {
              attrs.$observe("ngHref", staticWatcher);
            }
            break;
          case "href":
            // Setup watcher()
            staticWatcher(attrs.href);
        }

        $scope.$on("$routeChangeSuccess", function () {
          watcher();
        });

        // Added for compatibility with ui-router
        $scope.$on("$stateChangeSuccess", function () {
          watcher();
        });
      };
    }
  };
}]);

angular.module("ui.scroll.jqlite", ["ui.scroll"]).service("jqLiteExtras", [
  "$log", "$window", function (console, window) {
    "use strict";

    return {
      registerFor: function (element) {
        var convertToPx, css, getMeasurements, getStyle, getWidthHeight, isWindow, scrollTo;
        css = angular.element.prototype.css;
        element.prototype.css = function (name, value) {
          var elem, self;
          self = this;
          elem = self[0];
          if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
            return css.call(self, name, value);
          }
        };
        isWindow = function (obj) {
          return obj && obj.document && obj.location && obj.alert && obj.setInterval;
        };
        scrollTo = function (self, direction, value) {
          var elem, method, preserve, prop, _ref;
          elem = self[0];
          _ref = {
            top: ["scrollTop", "pageYOffset", "scrollLeft"],
            left: ["scrollLeft", "pageXOffset", "scrollTop"]
          }[direction], method = _ref[0], prop = _ref[1], preserve = _ref[2];
          if (isWindow(elem)) {
            if (angular.isDefined(value)) {
              return elem.scrollTo(self[preserve].call(self), value);
            } else {
              if (prop in elem) {
                return elem[prop];
              } else {
                return elem.document.documentElement[method];
              }
            }
          } else {
            if (angular.isDefined(value)) {
              return elem[method] = value;
            } else {
              return elem[method];
            }
          }
        };
        if (window.getComputedStyle) {
          getStyle = function (elem) {
            return window.getComputedStyle(elem, null);
          };
          convertToPx = function (elem, value) {
            return parseFloat(value);
          };
        } else {
          getStyle = function (elem) {
            return elem.currentStyle;
          };
          convertToPx = function (elem, value) {
            var core_pnum, left, result, rnumnonpx, rs, rsLeft, style;
            core_pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
            rnumnonpx = new RegExp("^(" + core_pnum + ")(?!px)[a-z%]+$", "i");
            if (!rnumnonpx.test(value)) {
              return parseFloat(value);
            } else {
              style = elem.style;
              left = style.left;
              rs = elem.runtimeStyle;
              rsLeft = rs && rs.left;
              if (rs) {
                rs.left = style.left;
              }
              style.left = value;
              result = style.pixelLeft;
              style.left = left;
              if (rsLeft) {
                rs.left = rsLeft;
              }
              return result;
            }
          };
        }
        getMeasurements = function (elem, measure) {
          var base, borderA, borderB, computedMarginA, computedMarginB, computedStyle, dirA, dirB, marginA, marginB, paddingA, paddingB, _ref;
          if (isWindow(elem)) {
            base = document.documentElement[{
              height: "clientHeight",
              width: "clientWidth"
            }[measure]];
            return {
              base: base,
              padding: 0,
              border: 0,
              margin: 0
            };
          }
          _ref = {
            width: [elem.offsetWidth, "Left", "Right"],
            height: [elem.offsetHeight, "Top", "Bottom"]
          }[measure], base = _ref[0], dirA = _ref[1], dirB = _ref[2];
          computedStyle = getStyle(elem);
          paddingA = convertToPx(elem, computedStyle["padding" + dirA]) || 0;
          paddingB = convertToPx(elem, computedStyle["padding" + dirB]) || 0;
          borderA = convertToPx(elem, computedStyle["border" + dirA + "Width"]) || 0;
          borderB = convertToPx(elem, computedStyle["border" + dirB + "Width"]) || 0;
          computedMarginA = computedStyle["margin" + dirA];
          computedMarginB = computedStyle["margin" + dirB];
          marginA = convertToPx(elem, computedMarginA) || 0;
          marginB = convertToPx(elem, computedMarginB) || 0;
          return {
            base: base,
            padding: paddingA + paddingB,
            border: borderA + borderB,
            margin: marginA + marginB
          };
        };
        getWidthHeight = function (elem, direction, measure) {
          var computedStyle, measurements, result;
          measurements = getMeasurements(elem, direction);
          if (measurements.base > 0) {
            return {
              base: measurements.base - measurements.padding - measurements.border,
              outer: measurements.base,
              outerfull: measurements.base + measurements.margin
            }[measure];
          } else {
            computedStyle = getStyle(elem);
            result = computedStyle[direction];
            if (result < 0 || result === null) {
              result = elem.style[direction] || 0;
            }
            result = parseFloat(result) || 0;
            return {
              base: result - measurements.padding - measurements.border,
              outer: result,
              outerfull: result + measurements.padding + measurements.border + measurements.margin
            }[measure];
          }
        };
        return angular.forEach({
          before: function (newElem) {
            var children, elem, i, parent, self, _i, _ref;
            self = this;
            elem = self[0];
            parent = self.parent();
            children = parent.contents();
            if (children[0] === elem) {
              return parent.prepend(newElem);
            } else {
              for (i = _i = 1, _ref = children.length - 1; 1 <= _ref ? _i <= _ref : _i >= _ref; i = 1 <= _ref ? ++_i : --_i) {
                if (children[i] === elem) {
                  angular.element(children[i - 1]).after(newElem);
                  return;
                }
              }
              throw new Error("invalid DOM structure " + elem.outerHTML);
            }
          },
          height: function (value) {
            var self;
            self = this;
            if (angular.isDefined(value)) {
              if (angular.isNumber(value)) {
                value = value + "px";
              }
              return css.call(self, "height", value);
            } else {
              return getWidthHeight(this[0], "height", "base");
            }
          },
          outerHeight: function (option) {
            return getWidthHeight(this[0], "height", option ? "outerfull" : "outer");
          },
          /*
          UIScroller no longer relies on jQuery method offset. The jQLite implementation of the method
          is kept here just for the reference. Also the offset setter method was never implemented
          */

          offset: function (value) {
            var box, doc, docElem, elem, self, win;
            self = this;
            if (arguments.length) {
              if (value === void 0) {
                return self;
              } else {
                throw new Error("offset setter method is not implemented");
              }
            }
            box = {
              top: 0,
              left: 0
            };
            elem = self[0];
            doc = elem && elem.ownerDocument;
            if (!doc) {
              return;
            }
            docElem = doc.documentElement;
            if (elem.getBoundingClientRect != null) {
              box = elem.getBoundingClientRect();
            }
            win = doc.defaultView || doc.parentWindow;
            return {
              top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
              left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0)
            };
          },
          scrollTop: function (value) {
            return scrollTo(this, "top", value);
          },
          scrollLeft: function (value) {
            return scrollTo(this, "left", value);
          }
        }, function (value, key) {
          if (!element.prototype[key]) {
            return element.prototype[key] = value;
          }
        });
      }
    };
  }
]).run([
  "$log", "$window", "jqLiteExtras", function (console, window, jqLiteExtras) {
    "use strict";

    if (!window.jQuery) {
      return jqLiteExtras.registerFor(angular.element);
    }
  }
]);

/*
//# sourceURL=src/scripts/ui-scroll-jqlite.js
*/

/*
 globals: angular, window

 List of used element methods available in JQuery but not in JQuery Lite

 element.before(elem)
 element.height()
 element.outerHeight(true)
 element.height(value) = only for Top/Bottom padding elements
 element.scrollTop()
 element.scrollTop(value)
 */

angular.module("ui.scroll", []).directive("uiScrollViewport", [
  "$log", function () {
    "use strict";

    return {
      controller: [
        "$scope", "$element", function (scope, element) {
          this.viewport = element;
          return this;
        }
      ]
    };
  }
]).directive("uiScroll", [
  "$log", "$injector", "$rootScope", "$timeout", function (console, $injector, $rootScope, $timeout) {
    "use strict";

    return {
      require: ["?^uiScrollViewport"],
      transclude: "element",
      priority: 1000,
      terminal: true,
      compile: function (elementTemplate, attr, linker) {
        return function ($scope, element, $attr, controllers) {
          var adapter, adapterOnScope, adjustBuffer, adjustRowHeight, applyUpdate, bof, bottomVisiblePos, buffer, bufferPadding, bufferSize, builder, clipBottom, clipTop, datasource, datasourceName, doAdjustment, doDelete, doInsert, doUpdate, enqueueFetch, eof, eventListener, fetch, finalize, first, getValueChain, hideElementBeforeAppend, insert, isDatasourceValid, itemName, loading, log, match, next, pending, reload, removeFromBuffer, resizeAndScrollHandler, ridActual, scrollHeight, setValueChain, shouldLoadBottom, shouldLoadTop, showElementAfterRender, topVisible, topVisiblePos, viewport, viewportScope, wheelHandler;
          log = console.debug || console.log;
          match = $attr.uiScroll.match(/^\s*(\w+)\s+in\s+([\w\.]+)\s*$/);
          if (!match) {
            throw new Error("Expected uiScroll in form of '_item_ in _datasource_' but got '" + $attr.uiScroll + "'");
          }
          itemName = match[1];
          datasourceName = match[2];
          getValueChain = function (targetScope, target) {
            var chain;
            if (!targetScope) {
              return;
            }
            chain = target.match(/^([\w]+)\.(.+)$/);
            if (!chain || chain.length !== 3) {
              return targetScope[target];
            }
            return getValueChain(targetScope[chain[1]], chain[2]);
          };
          setValueChain = function (targetScope, target, value, doNotSet) {
            var chain;
            if (!targetScope || !target) {
              return;
            }
            if (!(chain = target.match(/^([\w]+)\.(.+)$/))) {
              if (target.indexOf(".") !== -1) {
                return;
              }
            }
            if (!chain || chain.length !== 3) {
              if (!angular.isObject(targetScope[target]) && !doNotSet) {
                return targetScope[target] = value;
              }
              return targetScope[target] = value;
            }
            if (!angular.isObject(targetScope[chain[1]]) && !doNotSet) {
              targetScope[chain[1]] = {};
            }
            return setValueChain(targetScope[chain[1]], chain[2], value, doNotSet);
          };
          datasource = getValueChain($scope, datasourceName);
          isDatasourceValid = function () {
            return angular.isObject(datasource) && typeof datasource.get === "function";
          };
          if (!isDatasourceValid()) {
            datasource = $injector.get(datasourceName);
            if (!isDatasourceValid()) {
              throw new Error("" + datasourceName + " is not a valid datasource");
            }
          }
          bufferSize = Math.max(3, +$attr.bufferSize || 10);
          bufferPadding = function () {
            return viewport.outerHeight() * Math.max(0.1, +$attr.padding || 0.1);
          };
          scrollHeight = function (elem) {
            var _ref;
            return (_ref = elem[0].scrollHeight) != null ? _ref : elem[0].document.documentElement.scrollHeight;
          };
          builder = null;
          linker($scope.$new(), function (template) {
            var bottomPadding, createPadding, padding, repeaterType, topPadding, viewport;
            repeaterType = template[0].localName;
            if (repeaterType === "dl") {
              throw new Error("ui-scroll directive does not support <" + template[0].localName + "> as a repeating tag: " + template[0].outerHTML);
            }
            if (repeaterType !== "li" && repeaterType !== "tr") {
              repeaterType = "div";
            }
            viewport = controllers[0] && controllers[0].viewport ? controllers[0].viewport : angular.element(window);
            viewport.css({
              "overflow-y": "auto",
              "display": "block"
            });
            padding = function (repeaterType) {
              var div, result, table;
              switch (repeaterType) {
                case "tr":
                  table = angular.element("<table><tr><td><div></div></td></tr></table>");
                  div = table.find("div");
                  result = table.find("tr");
                  result.paddingHeight = function () {
                    return div.height.apply(div, arguments);
                  };
                  return result;
                default:
                  result = angular.element("<" + repeaterType + "></" + repeaterType + ">");
                  result.paddingHeight = result.height;
                  return result;
              }
            };
            createPadding = function (padding, element, direction) {
              element[{
                top: "before",
                bottom: "after"
              }[direction]](padding);
              return {
                paddingHeight: function () {
                  return padding.paddingHeight.apply(padding, arguments);
                },
                insert: function (element) {
                  return padding[{
                    top: "after",
                    bottom: "before"
                  }[direction]](element);
                }
              };
            };
            topPadding = createPadding(padding(repeaterType), element, "top");
            bottomPadding = createPadding(padding(repeaterType), element, "bottom");
            $scope.$on("$destroy", template.remove);
            return builder = {
              viewport: viewport,
              topPadding: topPadding.paddingHeight,
              bottomPadding: bottomPadding.paddingHeight,
              append: bottomPadding.insert,
              prepend: topPadding.insert,
              bottomDataPos: function () {
                return scrollHeight(viewport) - bottomPadding.paddingHeight();
              },
              topDataPos: function () {
                return topPadding.paddingHeight();
              }
            };
          });
          viewport = builder.viewport;
          viewportScope = viewport.scope() || $rootScope;
          topVisible = function (item) {
            adapter.topVisible = item.scope[itemName];
            adapter.topVisibleElement = item.element;
            adapter.topVisibleScope = item.scope;
            if ($attr.topVisible) {
              setValueChain(viewportScope, $attr.topVisible, adapter.topVisible);
            }
            if ($attr.topVisibleElement) {
              setValueChain(viewportScope, $attr.topVisibleElement, adapter.topVisibleElement);
            }
            if ($attr.topVisibleScope) {
              setValueChain(viewportScope, $attr.topVisibleScope, adapter.topVisibleScope);
            }
            if (typeof datasource.topVisible === "function") {
              return datasource.topVisible(item);
            }
          };
          loading = function (value) {
            adapter.isLoading = value;
            if ($attr.isLoading) {
              setValueChain($scope, $attr.isLoading, value);
            }
            if (typeof datasource.loading === "function") {
              return datasource.loading(value);
            }
          };
          ridActual = 0;
          first = 1;
          next = 1;
          buffer = [];
          pending = [];
          eof = false;
          bof = false;
          removeFromBuffer = function (start, stop) {
            var i, _i;
            for (i = _i = start; start <= stop ? _i < stop : _i > stop; i = start <= stop ? ++_i : --_i) {
              buffer[i].scope.$destroy();
              buffer[i].element.remove();
            }
            return buffer.splice(start, stop - start);
          };
          reload = function () {
            ridActual++;
            first = 1;
            next = 1;
            removeFromBuffer(0, buffer.length);
            builder.topPadding(0);
            builder.bottomPadding(0);
            pending = [];
            eof = false;
            bof = false;
            return adjustBuffer(ridActual);
          };
          bottomVisiblePos = function () {
            return viewport.scrollTop() + viewport.outerHeight();
          };
          topVisiblePos = function () {
            return viewport.scrollTop();
          };
          shouldLoadBottom = function () {
            return !eof && builder.bottomDataPos() < bottomVisiblePos() + bufferPadding();
          };
          clipBottom = function () {
            var bottomHeight, i, item, itemHeight, itemTop, newRow, overage, rowTop, _i, _ref;
            bottomHeight = 0;
            overage = 0;
            for (i = _i = _ref = buffer.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {
              item = buffer[i];
              itemTop = item.element.offset().top;
              newRow = rowTop !== itemTop;
              rowTop = itemTop;
              if (newRow) {
                itemHeight = item.element.outerHeight(true);
              }
              if (builder.bottomDataPos() - bottomHeight - itemHeight > bottomVisiblePos() + bufferPadding()) {
                if (newRow) {
                  bottomHeight += itemHeight;
                }
                overage++;
                eof = false;
              } else {
                if (newRow) {
                  break;
                }
                overage++;
              }
            }
            if (overage > 0) {
              builder.bottomPadding(builder.bottomPadding() + bottomHeight);
              removeFromBuffer(buffer.length - overage, buffer.length);
              return next -= overage;
            }
          };
          shouldLoadTop = function () {
            return !bof && (builder.topDataPos() > topVisiblePos() - bufferPadding());
          };
          clipTop = function () {
            var item, itemHeight, itemTop, newRow, overage, rowTop, topHeight, _i, _len;
            topHeight = 0;
            overage = 0;
            for (_i = 0, _len = buffer.length; _i < _len; _i++) {
              item = buffer[_i];
              itemTop = item.element.offset().top;
              newRow = rowTop !== itemTop;
              rowTop = itemTop;
              if (newRow) {
                itemHeight = item.element.outerHeight(true);
              }
              if (builder.topDataPos() + topHeight + itemHeight < topVisiblePos() - bufferPadding()) {
                if (newRow) {
                  topHeight += itemHeight;
                }
                overage++;
                bof = false;
              } else {
                if (newRow) {
                  break;
                }
                overage++;
              }
            }
            if (overage > 0) {
              builder.topPadding(builder.topPadding() + topHeight);
              removeFromBuffer(0, overage);
              return first += overage;
            }
          };
          enqueueFetch = function (rid, direction) {
            if (!adapter.isLoading) {
              loading(true);
            }
            if (pending.push(direction) === 1) {
              return fetch(rid);
            }
          };
          hideElementBeforeAppend = function (element) {
            element.displayTemp = element.css("display");
            return element.css("display", "none");
          };
          showElementAfterRender = function (element) {
            if (element.hasOwnProperty("displayTemp")) {
              return element.css("display", element.displayTemp);
            }
          };
          insert = function (index, item) {
            var itemScope, toBeAppended, wrapper;
            itemScope = $scope.$new();
            itemScope[itemName] = item;
            toBeAppended = index > first;
            itemScope.$index = index;
            if (toBeAppended) {
              itemScope.$index--;
            }
            wrapper = {
              scope: itemScope
            };
            linker(itemScope, function (clone) {
              wrapper.element = clone;
              if (toBeAppended) {
                if (index === next) {
                  hideElementBeforeAppend(clone);
                  builder.append(clone);
                  return buffer.push(wrapper);
                } else {
                  buffer[index - first].element.after(clone);
                  return buffer.splice(index - first + 1, 0, wrapper);
                }
              } else {
                hideElementBeforeAppend(clone);
                builder.prepend(clone);
                return buffer.unshift(wrapper);
              }
            });
            return {
              appended: toBeAppended,
              wrapper: wrapper
            };
          };
          adjustRowHeight = function (appended, wrapper) {
            var newHeight;
            if (appended) {
              return builder.bottomPadding(Math.max(0, builder.bottomPadding() - wrapper.element.outerHeight(true)));
            } else {
              newHeight = builder.topPadding() - wrapper.element.outerHeight(true);
              if (newHeight >= 0) {
                return builder.topPadding(newHeight);
              } else {
                return viewport.scrollTop(viewport.scrollTop() + wrapper.element.outerHeight(true));
              }
            }
          };
          doAdjustment = function (rid, finalize) {
            var item, itemHeight, itemTop, newRow, rowTop, topHeight, _i, _len, _results;
            if (shouldLoadBottom()) {
              enqueueFetch(rid, true);
            } else {
              if (shouldLoadTop()) {
                enqueueFetch(rid, false);
              }
            }
            if (finalize) {
              finalize(rid);
            }
            if (pending.length === 0) {
              topHeight = 0;
              _results = [];
              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
                item = buffer[_i];
                itemTop = item.element.offset().top;
                newRow = rowTop !== itemTop;
                rowTop = itemTop;
                if (newRow) {
                  itemHeight = item.element.outerHeight(true);
                }
                if (newRow && (builder.topDataPos() + topHeight + itemHeight < topVisiblePos())) {
                  _results.push(topHeight += itemHeight);
                } else {
                  if (newRow) {
                    topVisible(item);
                  }
                  break;
                }
              }
              return _results;
            }
          };
          adjustBuffer = function (rid, newItems, finalize) {
            if (newItems && newItems.length) {
              return $timeout(function () {
                var elt, itemTop, row, rowTop, rows, _i, _j, _len, _len1;
                rows = [];
                for (_i = 0, _len = newItems.length; _i < _len; _i++) {
                  row = newItems[_i];
                  elt = row.wrapper.element;
                  showElementAfterRender(elt);
                  itemTop = elt.offset().top;
                  if (rowTop !== itemTop) {
                    rows.push(row);
                    rowTop = itemTop;
                  }
                }
                for (_j = 0, _len1 = rows.length; _j < _len1; _j++) {
                  row = rows[_j];
                  adjustRowHeight(row.appended, row.wrapper);
                }
                return doAdjustment(rid, finalize);
              });
            } else {
              return doAdjustment(rid, finalize);
            }
          };
          finalize = function (rid, newItems) {
            return adjustBuffer(rid, newItems, function () {
              pending.shift();
              if (pending.length === 0) {
                return loading(false);
              } else {
                return fetch(rid);
              }
            });
          };
          fetch = function (rid) {
            var direction;
            direction = pending[0];
            if (direction) {
              if (buffer.length && !shouldLoadBottom()) {
                return finalize(rid);
              } else {
                return datasource.get(next, bufferSize, function (result) {
                  var item, newItems, _i, _len;
                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {
                    return;
                  }
                  newItems = [];
                  if (result.length < bufferSize) {
                    eof = true;
                    builder.bottomPadding(0);
                  }
                  if (result.length > 0) {
                    clipTop();
                    for (_i = 0, _len = result.length; _i < _len; _i++) {
                      item = result[_i];
                      newItems.push(insert(++next, item));
                    }
                  }
                  return finalize(rid, newItems);
                });
              }
            } else {
              if (buffer.length && !shouldLoadTop()) {
                return finalize(rid);
              } else {
                return datasource.get(first - bufferSize, bufferSize, function (result) {
                  var i, newItems, _i, _ref;
                  if ((rid && rid !== ridActual) || $scope.$$destroyed) {
                    return;
                  }
                  newItems = [];
                  if (result.length < bufferSize) {
                    bof = true;
                    builder.topPadding(0);
                  }
                  if (result.length > 0) {
                    if (buffer.length) {
                      clipBottom();
                    }
                    for (i = _i = _ref = result.length - 1; _ref <= 0 ? _i <= 0 : _i >= 0; i = _ref <= 0 ? ++_i : --_i) {
                      newItems.unshift(insert(--first, result[i]));
                    }
                  }
                  return finalize(rid, newItems);
                });
              }
            }
          };
          resizeAndScrollHandler = function () {
            if (!$rootScope.$$phase && !adapter.isLoading) {
              adjustBuffer();
              return $scope.$apply();
            }
          };
          wheelHandler = function (event) {
            var scrollTop, yMax;
            scrollTop = viewport[0].scrollTop;
            yMax = viewport[0].scrollHeight - viewport[0].clientHeight;
            if ((scrollTop === 0 && !bof) || (scrollTop === yMax && !eof)) {
              return event.preventDefault();
            }
          };
          viewport.bind("resize", resizeAndScrollHandler);
          viewport.bind("scroll", resizeAndScrollHandler);
          viewport.bind("mousewheel", wheelHandler);
          $scope.$watch(datasource.revision, reload);
          if (datasource.scope) {
            eventListener = datasource.scope.$new();
          } else {
            eventListener = $scope.$new();
          }
          $scope.$on("$destroy", function () {
            var item, _i, _len;
            for (_i = 0, _len = buffer.length; _i < _len; _i++) {
              item = buffer[_i];
              item.scope.$destroy();
              item.element.remove();
            }
            viewport.unbind("resize", resizeAndScrollHandler);
            viewport.unbind("scroll", resizeAndScrollHandler);
            return viewport.unbind("mousewheel", wheelHandler);
          });
          adapter = {};
          adapter.isLoading = false;
          applyUpdate = function (wrapper, newItems) {
            var i, inserted, item, ndx, newItem, oldItemNdx, _i, _j, _k, _len, _len1, _len2;
            inserted = [];
            if (angular.isArray(newItems)) {
              if (newItems.length) {
                if (newItems.length === 1 && newItems[0] === wrapper.scope[itemName]) {
                  return inserted;
                } else {
                  ndx = wrapper.scope.$index;
                  if (ndx > first) {
                    oldItemNdx = ndx - first;
                  } else {
                    oldItemNdx = 1;
                  }
                  for (i = _i = 0, _len = newItems.length; _i < _len; i = ++_i) {
                    newItem = newItems[i];
                    inserted.push(insert(ndx + i, newItem));
                  }
                  removeFromBuffer(oldItemNdx, oldItemNdx + 1);
                  for (i = _j = 0, _len1 = buffer.length; _j < _len1; i = ++_j) {
                    item = buffer[i];
                    item.scope.$index = first + i;
                  }
                }
              } else {
                removeFromBuffer(wrapper.scope.$index - first, wrapper.scope.$index - first + 1);
                next--;
                for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {
                  item = buffer[i];
                  item.scope.$index = first + i;
                }
              }
            }
            return inserted;
          };
          adapter.applyUpdates = function (arg1, arg2) {
            var inserted, wrapper, _i, _len, _ref, _ref1;
            inserted = [];
            ridActual++;
            if (angular.isFunction(arg1)) {
              _ref = buffer.slice(0);
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                wrapper = _ref[_i];
                inserted.concat(inserted, applyUpdate(wrapper, arg1(wrapper.scope[itemName], wrapper.scope, wrapper.element)));
              }
            } else {
              if (arg1 % 1 === 0) {
                if ((0 <= (_ref1 = arg1 - first - 1) && _ref1 < buffer.length)) {
                  inserted = applyUpdate(buffer[arg1 - first], arg2);
                }
              } else {
                throw new Error("applyUpdates - " + arg1 + " is not a valid index or outside of range");
              }
            }
            return adjustBuffer(ridActual, inserted);
          };
          if ($attr.adapter) {
            adapterOnScope = getValueChain($scope, $attr.adapter);
            if (!adapterOnScope) {
              setValueChain($scope, $attr.adapter, {});
              adapterOnScope = getValueChain($scope, $attr.adapter);
            }
            angular.extend(adapterOnScope, adapter);
            adapter = adapterOnScope;
          }
          doUpdate = function (locator, newItem) {
            var wrapper, _fn, _i, _len, _ref;
            if (angular.isFunction(locator)) {
              _fn = function (wrapper) {
                return locator(wrapper.scope);
              };
              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
                wrapper = buffer[_i];
                _fn(wrapper);
              }
            } else {
              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
                buffer[locator - first - 1].scope[itemName] = newItem;
              }
            }
            return null;
          };
          doDelete = function (locator) {
            var i, item, temp, wrapper, _fn, _i, _j, _k, _len, _len1, _len2, _ref;
            if (angular.isFunction(locator)) {
              temp = [];
              for (_i = 0, _len = buffer.length; _i < _len; _i++) {
                item = buffer[_i];
                temp.unshift(item);
              }
              _fn = function (wrapper) {
                if (locator(wrapper.scope)) {
                  removeFromBuffer(temp.length - 1 - i, temp.length - i);
                  return next--;
                }
              };
              for (i = _j = 0, _len1 = temp.length; _j < _len1; i = ++_j) {
                wrapper = temp[i];
                _fn(wrapper);
              }
            } else {
              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
                removeFromBuffer(locator - first - 1, locator - first);
                next--;
              }
            }
            for (i = _k = 0, _len2 = buffer.length; _k < _len2; i = ++_k) {
              item = buffer[i];
              item.scope.$index = first + i;
            }
            return adjustBuffer();
          };
          doInsert = function (locator, item) {
            var i, inserted, _i, _len, _ref;
            inserted = [];
            if (angular.isFunction(locator)) {
              throw new Error("not implemented - Insert with locator function");
            } else {
              if ((0 <= (_ref = locator - first - 1) && _ref < buffer.length)) {
                inserted.push(insert(locator, item));
                next++;
              }
            }
            for (i = _i = 0, _len = buffer.length; _i < _len; i = ++_i) {
              item = buffer[i];
              item.scope.$index = first + i;
            }
            return adjustBuffer(null, inserted);
          };
          eventListener.$on("insert.item", function (event, locator, item) {
            return doInsert(locator, item);
          });
          eventListener.$on("update.items", function (event, locator, newItem) {
            return doUpdate(locator, newItem);
          });
          return eventListener.$on("delete.items", function (event, locator) {
            return doDelete(locator);
          });
        };
      }
    };
  }
]);

/*
//# sourceURL=src/scripts/ui-scroll.js
*/

/**
 * Adds a 'ui-scrollfix' class to the element when the page scrolls past it's position.
 * @param [offset] {int} optional Y-offset to override the detected offset.
 *   Takes 300 (absolute) or -300 or +300 (relative to detected)
 */
angular.module("ui.scrollfix", []).directive("uiScrollfix", ["$window", function ($window) {
  "use strict";

  function getWindowScrollTop() {
    if (angular.isDefined($window.pageYOffset)) {
      return $window.pageYOffset;
    } else {
      var iebody = (document.compatMode && document.compatMode !== "BackCompat") ? document.documentElement : document.body;
      return iebody.scrollTop;
    }
  }
  return {
    require: "^?uiScrollfixTarget",
    link: function (scope, elm, attrs, uiScrollfixTarget) {
      var absolute = true,
        shift = 0,
        fixLimit,
        $target = uiScrollfixTarget && uiScrollfixTarget.$element || angular.element($window);

      if (!attrs.uiScrollfix) {
        absolute = false;
      } else if (typeof(attrs.uiScrollfix) === "string") {
        // charAt is generally faster than indexOf: http://jsperf.com/indexof-vs-charat
        if (attrs.uiScrollfix.charAt(0) === "-") {
          absolute = false;
          shift = - parseFloat(attrs.uiScrollfix.substr(1));
        } else if (attrs.uiScrollfix.charAt(0) === "+") {
          absolute = false;
          shift = parseFloat(attrs.uiScrollfix.substr(1));
        }
      }

      fixLimit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;

      function onScroll() {

        var limit = absolute ? attrs.uiScrollfix : elm[0].offsetTop + shift;

        // if pageYOffset is defined use it, otherwise use other crap for IE
        var offset = uiScrollfixTarget ? $target[0].scrollTop : getWindowScrollTop();
        if (!elm.hasClass("ui-scrollfix") && offset > limit) {
          elm.addClass("ui-scrollfix");
          fixLimit = limit;
        } else if (elm.hasClass("ui-scrollfix") && offset < fixLimit) {
          elm.removeClass("ui-scrollfix");
        }
      }

      $target.on("scroll", onScroll);

      // Unbind scroll event handler when directive is removed
      scope.$on("$destroy", function () {
        $target.off("scroll", onScroll);
      });
    }
  };
}]).directive("uiScrollfixTarget", [function () {
  "use strict";
  return {
    controller: ["$element", function ($element) {
      this.$element = $element;
    }]
  };
}]);

/**
 * uiShow Directive
 *
 * Adds a 'ui-show' class to the element instead of display:block
 * Created to allow tighter control  of CSS without bulkier directives
 *
 * @param expression {boolean} evaluated expression to determine if the class should be added
 */
angular.module("ui.showhide", [])
  .directive("uiShow", [function () {
    "use strict";

    return function (scope, elm, attrs) {
      scope.$watch(attrs.uiShow, function (newVal) {
        if (newVal) {
          elm.addClass("ui-show");
        } else {
          elm.removeClass("ui-show");
        }
      });
    };
  }])

/**
 * uiHide Directive
 *
 * Adds a 'ui-hide' class to the element instead of display:block
 * Created to allow tighter control  of CSS without bulkier directives
 *
 * @param expression {boolean} evaluated expression to determine if the class should be added
 */
  .directive("uiHide", [function () {
    "use strict";

    return function (scope, elm, attrs) {
      scope.$watch(attrs.uiHide, function (newVal) {
        if (newVal) {
          elm.addClass("ui-hide");
        } else {
          elm.removeClass("ui-hide");
        }
      });
    };
  }])

/**
 * uiToggle Directive
 *
 * Adds a class 'ui-show' if true, and a 'ui-hide' if false to the element instead of display:block/display:none
 * Created to allow tighter control  of CSS without bulkier directives. This also allows you to override the
 * default visibility of the element using either class.
 *
 * @param expression {boolean} evaluated expression to determine if the class should be added
 */
  .directive("uiToggle", [function () {
    "use strict";

    return function (scope, elm, attrs) {
      scope.$watch(attrs.uiToggle, function (newVal) {
        if (newVal) {
          elm.removeClass("ui-hide").addClass("ui-show");
        } else {
          elm.removeClass("ui-show").addClass("ui-hide");
        }
      });
    };
  }]);

/**
 * Filters out all duplicate items from an array by checking the specified key
 * @param [key] {string} the name of the attribute of each object to compare for uniqueness
 if the key is empty, the entire object will be compared
 if the key === false then no filtering will be performed
 * @return {array}
 */
angular.module("ui.unique", []).filter("unique", ["$parse", function ($parse) {
  "use strict";

  return function (items, filterOn) {

    if (filterOn === false) {
      return items;
    }

    if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
      var newItems = [],
        get = angular.isString(filterOn) ? $parse(filterOn) : function (item) { return item; };

      var extractValueToCompare = function (item) {
        return angular.isObject(item) ? get(item) : item;
      };

      angular.forEach(items, function (item) {
        var isDuplicate = false;

        for (var i = 0; i < newItems.length; i++) {
          if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
            isDuplicate = true;
            break;
          }
        }
        if (!isDuplicate) {
          newItems.push(item);
        }

      });
      items = newItems;
    }
    return items;
  };
}]);

/*
 * Author: Remy Alain Ticona Carbajal http://realtica.org
 * Description: The main objective of ng-uploader is to have a user control,
 * clean, simple, customizable, and above all very easy to implement.
 * Licence: MIT
 */

angular.module("ui.uploader", []).service("uiUploader", uiUploader);

uiUploader.$inject = ["$log"];

function uiUploader($log) {
  "use strict";

  /* jshint validthis: true */
  var self = this;
  self.files = [];
  self.options = {};
  self.activeUploads = 0;
  $log.info("uiUploader loaded");

  function addFiles(files) {
    for (var i = 0; i < files.length; i++) {
      self.files.push(files[i]);
    }
  }

  function getFiles() {
    return self.files;
  }

  function startUpload(options) {
    self.options = options;
    for (var i = 0; i < self.files.length; i++) {
      if (self.activeUploads == self.options.concurrency) {
        break;
      }
      if (self.files[i].active)
        continue;
      ajaxUpload(self.files[i], self.options.url);
    }
  }

  function removeFile(file) {
    self.files.splice(self.files.indexOf(file), 1);
  }

  function removeAll() {
    self.files.splice(0, self.files.length);
  }

  return {
    addFiles: addFiles,
    getFiles: getFiles,
    files: self.files,
    startUpload: startUpload,
    removeFile: removeFile,
    removeAll: removeAll
  };

  function getHumanSize(bytes) {
    var sizes = ["n/a", "bytes", "KiB", "MiB", "GiB", "TB", "PB", "EiB", "ZiB", "YiB"];
    var i = +Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(i ? 1 : 0) + " " + sizes[isNaN(bytes) ? 0 : i + 1];
  }

  function ajaxUpload(file, url) {
    var xhr, formData, prop, data = "",
      key = "" || "file";
    self.activeUploads += 1;
    file.active = true;
    xhr = new window.XMLHttpRequest();
    formData = new window.FormData();
    xhr.open("POST", url);

    // Triggered when upload starts:
    xhr.upload.onloadstart = function () {};

    // Triggered many times during upload:
    xhr.upload.onprogress = function (event) {
      if (!event.lengthComputable) {
        return;
      }
      // Update file size because it might be bigger than reported by
      // the fileSize:
      // $log.info("progres..");
      // console.info(event.loaded);
      file.loaded = event.loaded;
      file.humanSize = getHumanSize(event.loaded);
      self.options.onProgress(file);
    };

    // Triggered when upload is completed:
    xhr.onload = function () {
      self.activeUploads -= 1;
      startUpload(self.options);
      self.options.onCompleted(file, xhr.responseText);
    };

    // Triggered when upload fails:
    xhr.onerror = function () {};

    // Append additional data if provided:
    if (data) {
      for (prop in data) {
        if (data.hasOwnProperty(prop)) {
          formData.append(prop, data[prop]);
        }
      }
    }

    // Append file data:
    formData.append(key, file, file.name);

    // Initiate upload:
    xhr.send(formData);

    return xhr;
  }

}

/**
 * General-purpose validator for ngModel.
 * angular.js comes with several built-in validation mechanism for input fields (ngRequired, ngPattern etc.) but using
 * an arbitrary validation function requires creation of a custom formatters and / or parsers.
 * The ui-validate directive makes it easy to use any function(s) defined in scope as a validator function(s).
 * A validator function will trigger validation on both model and input changes.
 *
 * @example <input ui-validate=" 'myValidatorFunction($value)' ">
 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }">
 * @example <input ui-validate="{ foo : '$value > anotherModel' }" ui-validate-watch=" 'anotherModel' ">
 * @example <input ui-validate="{ foo : '$value > anotherModel', bar : 'validateFoo($value)' }" ui-validate-watch=" { foo : 'anotherModel' } ">
 *
 * @param ui-validate {string|object literal} If strings is passed it should be a scope's function to be used as a validator.
 * If an object literal is passed a key denotes a validation error key while a value should be a validator function.
 * In both cases validator function should take a value to validate as its argument and should return true/false indicating a validation result.
 */
angular.module("ui.validate", []).directive("uiValidate", function () {
  "use strict";

  return {
    restrict: "A",
    require: "ngModel",
    link: function (scope, elm, attrs, ctrl) {
      var validateFn, validators = {},
        validateExpr = scope.$eval(attrs.uiValidate);

      if (!validateExpr) { return;}

      if (angular.isString(validateExpr)) {
        validateExpr = { validator: validateExpr };
      }

      angular.forEach(validateExpr, function (exprssn, key) {
        validateFn = function (valueToValidate) {
          var expression = scope.$eval(exprssn, { "$value": valueToValidate });
          if (angular.isObject(expression) && angular.isFunction(expression.then)) {
            // expression is a promise
            expression.then(function () {
              ctrl.$setValidity(key, true);
            }, function () {
              ctrl.$setValidity(key, false);
            });
            return valueToValidate;
          } else if (expression) {
            // expression is true
            ctrl.$setValidity(key, true);
            return valueToValidate;
          } else {
            // expression is false
            ctrl.$setValidity(key, false);
            return valueToValidate;
          }
        };
        validators[key] = validateFn;
        ctrl.$formatters.push(validateFn);
        ctrl.$parsers.push(validateFn);
      });

      function apply_watch(watch)
      {
        // string - update all validators on expression change
        if (angular.isString(watch))
        {
          scope.$watch(watch, function () {
            angular.forEach(validators, function (validatorFn) {
              validatorFn(ctrl.$modelValue);
            });
          });
          return;
        }

        // array - update all validators on change of any expression
        if (angular.isArray(watch))
        {
          angular.forEach(watch, function (expression) {
            scope.$watch(expression, function ()
            {
              angular.forEach(validators, function (validatorFn) {
                validatorFn(ctrl.$modelValue);
              });
            });
          });
          return;
        }

        // object - update appropriate validator
        if (angular.isObject(watch))
        {
          angular.forEach(watch, function (expression, validatorKey)
          {
            // value is string - look after one expression
            if (angular.isString(expression))
            {
              scope.$watch(expression, function () {
                validators[validatorKey](ctrl.$modelValue);
              });
            }

            // value is array - look after all expressions in array
            if (angular.isArray(expression))
            {
              angular.forEach(expression, function (intExpression)
              {
                scope.$watch(intExpression, function () {
                  validators[validatorKey](ctrl.$modelValue);
                });
              });
            }
          });
        }
      }
      // Support for ui-validate-watch
      if (attrs.uiValidateWatch) {
        apply_watch( scope.$eval(attrs.uiValidateWatch) );
      }
    }
  };
});

angular.module("ui.utils", [
  "ui.event",
  "ui.format",
  "ui.highlight",
  "ui.include",
  "ui.indeterminate",
  "ui.inflector",
  "ui.jq",
  "ui.keypress",
  "ui.mask",
  "ui.reset",
  "ui.route",
  "ui.scrollfix",
  "ui.scroll",
  "ui.scroll.jqlite",
  "ui.showhide",
  "ui.unique",
  "ui.validate"
]);

/*
 *  Angular RangeSlider Directive
 *
 *  Version: 0.0.13
 *
 *  Author: Daniel Crisp, danielcrisp.com
 *
 *  The rangeSlider has been styled to match the default styling
 *  of form elements styled using Twitter's Bootstrap
 *
 *  Originally forked from https://github.com/leongersen/noUiSlider
 *

    This code is released under the MIT Licence - http://opensource.org/licenses/MIT

    Copyright (c) 2013 Daniel Crisp

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.

*/

(function () {
  "use strict";

  // check if we need to support legacy angular
  var legacySupport = (angular.version.major === 1 && angular.version.minor === 0);

  /**
     * RangeSlider, allows user to define a range of values using a slider
     * Touch friendly.
     * @directive
     */
  angular.module("ui-rangeSlider", [])
    .directive("rangeSlider", ["$document", "$filter", "$log", function ($document, $filter, $log) {

      // test for mouse, pointer or touch
      var eventNamespace = ".rangeSlider",

        defaults = {
          disabled: false,
          orientation: "horizontal",
          step: 0,
          decimalPlaces: 0,
          showValues: true,
          preventEqualMinMax: false,
          attachHandleValues: false
        },

        // Determine the events to bind. IE11 implements pointerEvents without
        // a prefix, which breaks compatibility with the IE10 implementation.
        /** @const */
        actions = window.navigator.pointerEnabled ? {
          start: "pointerdown",
          move: "pointermove",
          end: "pointerup",
          over: "pointerdown",
          out: "mouseout"
        } : window.navigator.msPointerEnabled ? {
          start: "MSPointerDown",
          move: "MSPointerMove",
          end: "MSPointerUp",
          over: "MSPointerDown",
          out: "mouseout"
        } : {
          start: "mousedown touchstart",
          move: "mousemove touchmove",
          end: "mouseup touchend",
          over: "mouseover touchstart",
          out: "mouseout"
        },

        onEvent = actions.start + eventNamespace,
        moveEvent = actions.move + eventNamespace,
        offEvent = actions.end + eventNamespace,
        overEvent = actions.over + eventNamespace,
        outEvent = actions.out + eventNamespace,

        // get standarised clientX and clientY
        client = function (f) {
          try {
            return [(f.clientX || f.originalEvent.clientX || f.originalEvent.touches[0].clientX), (f.clientY || f.originalEvent.clientY || f.originalEvent.touches[0].clientY)];
          } catch (e) {
            return ["x", "y"];
          }
        },

        restrict = function (value) {

          // normalize so it can't move out of bounds
          return (value < 0 ? 0 : (value > 100 ? 100 : value));

        },

        isNumber = function (n) {
          // console.log(n);
          return !isNaN(parseFloat(n)) && isFinite(n);
        },

        scopeOptions = {
          disabled: "=?",
          min: "=",
          max: "=",
          modelMin: "=?",
          modelMax: "=?",
          onHandleDown: "&", // calls optional function when handle is grabbed
          onHandleUp: "&", // calls optional function when handle is released
          orientation: "@", // options: horizontal | vertical | vertical left | vertical right
          step: "@",
          decimalPlaces: "@",
          filter: "@",
          filterOptions: "@",
          showValues: "@",
          pinHandle: "@",
          preventEqualMinMax: "@",
          attachHandleValues: "@",
          getterSetter: "@" // Allow the use of getterSetters for model values
        };

      if (legacySupport) {
        // make optional properties required
        scopeOptions.disabled = "=";
        scopeOptions.modelMin = "=";
        scopeOptions.modelMax = "=";
      }

      // if (EVENT < 4) {
      //     // some sort of touch has been detected
      //     angular.element('html').addClass('ngrs-touch');
      // } else {
      //     angular.element('html').addClass('ngrs-no-touch');
      // }

      return {
        restrict: "A",
        replace: true,
        template: ["<div class=\"ngrs-range-slider\">",
          "<div class=\"ngrs-runner\">",
          "<div class=\"ngrs-handle ngrs-handle-min\"><i></i></div>",
          "<div class=\"ngrs-handle ngrs-handle-max\"><i></i></div>",
          "<div class=\"ngrs-join\"></div>",
          "</div>",
          "<div class=\"ngrs-value-runner\">",
          "<div class=\"ngrs-value ngrs-value-min\" ng-show=\"showValues\"><div>{{filteredModelMin}}</div></div>",
          "<div class=\"ngrs-value ngrs-value-max\" ng-show=\"showValues\"><div>{{filteredModelMax}}</div></div>",
          "</div>",
          "</div>"
        ].join(""),
        scope: scopeOptions,
        link: function (scope, element, attrs, controller) {

          /**
                     *  FIND ELEMENTS
                     */

          var $slider = angular.element(element),
            handles = [element.find(".ngrs-handle-min"), element.find(".ngrs-handle-max")],
            values = [element.find(".ngrs-value-min"), element.find(".ngrs-value-max")],
            join = element.find(".ngrs-join"),
            pos = "left",
            posOpp = "right",
            orientation = 0,
            allowedRange = [0, 0],
            range = 0,
            down = false;

          // filtered
          scope.filteredModelMin = modelMin();
          scope.filteredModelMax = modelMax();

          /**
                     *  FALL BACK TO DEFAULTS FOR SOME ATTRIBUTES
                     */

          attrs.$observe("disabled", function (val) {
            if (!angular.isDefined(val)) {
              scope.disabled = defaults.disabled;
            }

            scope.$watch("disabled", setDisabledStatus);
          });

          attrs.$observe("orientation", function (val) {
            if (!angular.isDefined(val)) {
              scope.orientation = defaults.orientation;
            }

            var classNames = scope.orientation.split(" "),
              useClass;

            for (var i = 0, l = classNames.length; i < l; i++) {
              classNames[i] = "ngrs-" + classNames[i];
            }

            useClass = classNames.join(" ");

            // add class to element
            $slider.addClass(useClass);

            // update pos
            if (scope.orientation === "vertical" || scope.orientation === "vertical left" || scope.orientation === "vertical right") {
              pos = "top";
              posOpp = "bottom";
              orientation = 1;
            }
          });

          attrs.$observe("step", function (val) {
            if (!angular.isDefined(val)) {
              scope.step = defaults.step;
            }
          });

          attrs.$observe("decimalPlaces", function (val) {
            if (!angular.isDefined(val)) {
              scope.decimalPlaces = defaults.decimalPlaces;
            }
          });

          attrs.$observe("showValues", function (val) {
            if (!angular.isDefined(val)) {
              scope.showValues = defaults.showValues;
            } else {
              if (val === "false") {
                scope.showValues = false;
              } else {
                scope.showValues = true;
              }
            }
          });

          attrs.$observe("pinHandle", function (val) {
            if (!angular.isDefined(val)) {
              scope.pinHandle = null;
            } else {
              if (val === "min" || val === "max") {
                scope.pinHandle = val;
              } else {
                scope.pinHandle = null;
              }
            }

            scope.$watch("pinHandle", setPinHandle);
          });

          attrs.$observe("preventEqualMinMax", function (val) {
            if (!angular.isDefined(val)) {
              scope.preventEqualMinMax = defaults.preventEqualMinMax;
            } else {
              if (val === "false") {
                scope.preventEqualMinMax = false;
              } else {
                scope.preventEqualMinMax = true;
              }
            }
          });

          attrs.$observe("attachHandleValues", function (val) {
            if (!angular.isDefined(val)) {
              scope.attachHandleValues = defaults.attachHandleValues;
            } else {
              if (val === "true" || val === "") {
                // flag as true
                scope.attachHandleValues = true;
                // add class to runner
                element.find(".ngrs-value-runner").addClass("ngrs-attached-handles");
              } else {
                scope.attachHandleValues = false;
              }
            }
          });

          // GetterSetters for model values

          function modelMin(newValue) {
            if (scope.getterSetter) {
              return arguments.length ? scope.modelMin(newValue) : scope.modelMin();
            } else {
              return arguments.length ? (scope.modelMin = newValue) : scope.modelMin;
            }
          }

          function modelMax(newValue) {
            if (scope.getterSetter) {
              return arguments.length ? scope.modelMax(newValue) : scope.modelMax();
            } else {
              return arguments.length ? (scope.modelMax = newValue) : scope.modelMax;
            }
          }

          // listen for changes to values
          scope.$watch("min", setMinMax);
          scope.$watch("max", setMinMax);

          scope.$watch(function () {
            return modelMin();
          }, setModelMinMax);
          scope.$watch(function () {
            return modelMax();
          }, setModelMinMax);

          /**
                     * HANDLE CHANGES
                     */

          function setPinHandle(status) {
            if (status === "min") {
              angular.element(handles[0]).css("display", "none");
              angular.element(handles[1]).css("display", "block");
            } else if (status === "max") {
              angular.element(handles[0]).css("display", "block");
              angular.element(handles[1]).css("display", "none");
            } else {
              angular.element(handles[0]).css("display", "block");
              angular.element(handles[1]).css("display", "block");
            }
          }

          function setDisabledStatus(status) {
            if (status) {
              $slider.addClass("ngrs-disabled");
            } else {
              $slider.removeClass("ngrs-disabled");
            }
          }

          function setMinMax() {

            if (scope.min > scope.max) {
              throwError("min must be less than or equal to max");
            }

            // only do stuff when both values are ready
            if (angular.isDefined(scope.min) && angular.isDefined(scope.max)) {

              // make sure they are numbers
              if (!isNumber(scope.min)) {
                throwError("min must be a number");
              }

              if (!isNumber(scope.max)) {
                throwError("max must be a number");
              }

              range = scope.max - scope.min;
              allowedRange = [scope.min, scope.max];

              // update models too
              setModelMinMax();

            }
          }

          function setModelMinMax() {

            if (modelMin() > modelMax()) {
              throwWarning("modelMin must be less than or equal to modelMax");
              // reset values to correct
              modelMin(modelMax());
            }

            // only do stuff when both values are ready
            if (
              (angular.isDefined(modelMin()) || scope.pinHandle === "min") &&
                            (angular.isDefined(modelMax()) || scope.pinHandle === "max")
            ) {

              // make sure they are numbers
              if (!isNumber(modelMin())) {
                if (scope.pinHandle !== "min") {
                  throwWarning("modelMin must be a number");
                }
                modelMin(scope.min);
              }

              if (!isNumber(modelMax())) {
                if (scope.pinHandle !== "max") {
                  throwWarning("modelMax must be a number");
                }
                modelMax(scope.max);
              }

              var handle1pos = restrict(((modelMin() - scope.min) / range) * 100),
                handle2pos = restrict(((modelMax() - scope.min) / range) * 100),
                value1pos,
                value2pos;

              if (scope.attachHandleValues) {
                value1pos = handle1pos;
                value2pos = handle2pos;
              }

              // make sure the model values are within the allowed range
              modelMin(Math.max(scope.min, modelMin()));
              modelMax(Math.min(scope.max, modelMax()));

              if (scope.filter && scope.filterOptions) {
                scope.filteredModelMin = $filter(scope.filter)(modelMin(), scope.filterOptions);
                scope.filteredModelMax = $filter(scope.filter)(modelMax(), scope.filterOptions);
              } else if (scope.filter) {

                var filterTokens = scope.filter.split(":"),
                  filterName = scope.filter.split(":")[0],
                  filterOptions = filterTokens.slice().slice(1),
                  modelMinOptions,
                  modelMaxOptions;

                // properly parse string and number args
                filterOptions = filterOptions.map(function (arg) {
                  if (isNumber(arg)) {
                    return +arg;
                  } else if ((arg[0] == "\"" && arg[arg.length - 1] == "\"") || (arg[0] == "\'" && arg[arg.length - 1] == "\'")) {
                    return arg.slice(1, -1);
                  }
                });

                modelMinOptions = filterOptions.slice();
                modelMaxOptions = filterOptions.slice();
                modelMinOptions.unshift(modelMin());
                modelMaxOptions.unshift(modelMax());

                scope.filteredModelMin = $filter(filterName).apply(null, modelMinOptions);
                scope.filteredModelMax = $filter(filterName).apply(null, modelMaxOptions);
              } else {
                scope.filteredModelMin = modelMin();
                scope.filteredModelMax = modelMax();
              }

              // check for no range
              if (scope.min === scope.max && modelMin() == modelMax()) {

                // reposition handles
                angular.element(handles[0]).css(pos, "0%");
                angular.element(handles[1]).css(pos, "100%");

                if (scope.attachHandleValues) {
                  // reposition values
                  angular.element(values[0]).css(pos, "0%");
                  angular.element(values[1]).css(pos, "100%");
                }

                // reposition join
                angular.element(join).css(pos, "0%").css(posOpp, "0%");

              } else {

                // reposition handles
                angular.element(handles[0]).css(pos, handle1pos + "%");
                angular.element(handles[1]).css(pos, handle2pos + "%");

                if (scope.attachHandleValues) {
                  // reposition values
                  angular.element(values[0]).css(pos, value1pos + "%");
                  angular.element(values[1]).css(pos, value2pos + "%");
                  angular.element(values[1]).css(posOpp, "auto");
                }

                // reposition join
                angular.element(join).css(pos, handle1pos + "%").css(posOpp, (100 - handle2pos) + "%");

                // ensure min handle can't be hidden behind max handle
                if (handle1pos > 95) {
                  angular.element(handles[0]).css("z-index", 3);
                }
              }

            }

          }

          function handleMove(index) {

            var $handle = handles[index];

            // on mousedown / touchstart
            $handle.bind(onEvent + "X", function (event) {

              var handleDownClass = (index === 0 ? "ngrs-handle-min" : "ngrs-handle-max") + "-down",
                // unbind = $handle.add($document).add('body'),
                modelValue = (index === 0 ? modelMin() : modelMax()) - scope.min,
                originalPosition = (modelValue / range) * 100,
                originalClick = client(event),
                previousClick = originalClick,
                previousProposal = false;

              if (angular.isFunction(scope.onHandleDown)) {
                scope.onHandleDown();
              }

              // stop user accidentally selecting stuff
              angular.element("body").bind("selectstart" + eventNamespace, function () {
                return false;
              });

              // only do stuff if we are disabled
              if (!scope.disabled) {

                // flag as down
                down = true;

                // add down class
                $handle.addClass("ngrs-down");

                $slider.addClass("ngrs-focus " + handleDownClass);

                // add touch class for MS styling
                angular.element("body").addClass("ngrs-touching");

                // listen for mousemove / touchmove document events
                $document.bind(moveEvent, function (e) {
                  // prevent default
                  e.preventDefault();

                  var currentClick = client(e),
                    movement,
                    proposal,
                    other,
                    per = (scope.step / range) * 100,
                    otherModelPosition = (((index === 0 ? modelMax() : modelMin()) - scope.min) / range) * 100;

                  if (currentClick[0] === "x") {
                    return;
                  }

                  // calculate deltas
                  currentClick[0] -= originalClick[0];
                  currentClick[1] -= originalClick[1];

                  // has movement occurred on either axis?
                  movement = [
                    (previousClick[0] !== currentClick[0]), (previousClick[1] !== currentClick[1])
                  ];

                  // propose a movement
                  proposal = originalPosition + ((currentClick[orientation] * 100) / (orientation ? $slider.height() : $slider.width()));

                  // normalize so it can't move out of bounds
                  proposal = restrict(proposal);

                  if (scope.preventEqualMinMax) {

                    if (per === 0) {
                      per = (1 / range) * 100; // restrict to 1
                    }

                    if (index === 0) {
                      otherModelPosition = otherModelPosition - per;
                    } else if (index === 1) {
                      otherModelPosition = otherModelPosition + per;
                    }
                  }

                  // check which handle is being moved and add / remove margin
                  if (index === 0) {
                    proposal = proposal > otherModelPosition ? otherModelPosition : proposal;
                  } else if (index === 1) {
                    proposal = proposal < otherModelPosition ? otherModelPosition : proposal;
                  }

                  if (scope.step > 0) {
                    // only change if we are within the extremes, otherwise we get strange rounding
                    if (proposal < 100 && proposal > 0) {
                      proposal = Math.round(proposal / per) * per;
                    }
                  }

                  if (proposal > 95 && index === 0) {
                    $handle.css("z-index", 3);
                  } else {
                    $handle.css("z-index", "");
                  }

                  if (movement[orientation] && proposal != previousProposal) {

                    if (index === 0) {

                      // update model as we slide
                      modelMin(parseFloat(parseFloat((((proposal * range) / 100) + scope.min)).toFixed(scope.decimalPlaces)));

                    } else if (index === 1) {

                      modelMax(parseFloat(parseFloat((((proposal * range) / 100) + scope.min)).toFixed(scope.decimalPlaces)));
                    }

                    // update angular
                    scope.$apply();

                    previousProposal = proposal;

                  }

                  previousClick = currentClick;

                }).bind(offEvent, function () {

                  if (angular.isFunction(scope.onHandleUp)) {
                    scope.onHandleUp();
                  }

                  // unbind listeners
                  $document.off(moveEvent);
                  $document.off(offEvent);

                  angular.element("body").removeClass("ngrs-touching");

                  // cancel down flag
                  down = false;

                  // remove down and over class
                  $handle.removeClass("ngrs-down");
                  $handle.removeClass("ngrs-over");

                  // remove active class
                  $slider.removeClass("ngrs-focus " + handleDownClass);

                });
              }

            }).on(overEvent, function () {
              $handle.addClass("ngrs-over");
            }).on(outEvent, function () {
              if (!down) {
                $handle.removeClass("ngrs-over");
              }
            });
          }

          function throwError(message) {
            scope.disabled = true;
            throw new Error("RangeSlider: " + message);
          }

          function throwWarning(message) {
            $log.warn(message);
          }

          /**
                     * DESTROY
                     */

          scope.$on("$destroy", function () {

            // unbind event from slider
            $slider.off(eventNamespace);

            // unbind from body
            angular.element("body").off(eventNamespace);

            // unbind from document
            $document.off(eventNamespace);

            // unbind from handles
            for (var i = 0, l = handles.length; i < l; i++) {
              handles[i].off(eventNamespace);
              handles[i].off(eventNamespace + "X");
            }

          });

          /**
                     * INIT
                     */

          $slider
          // disable selection
            .bind("selectstart" + eventNamespace, function (event) {
              return false;
            })
          // stop propagation
            .bind("click", function (event) {
              event.stopPropagation();
            });

          // bind events to each handle
          handleMove(0);
          handleMove(1);

        }
      };
    }]);

  // requestAnimationFramePolyFill
  // http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
  // shim layer with setTimeout fallback
  window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function (callback) {
              window.setTimeout(callback, 1000 / 60);
            };
  })();
}());

/** !
 * AngularJS file upload/drop directive with progress and abort
 * @author  Danial  <danial.farid@gmail.com>
 * @version 2.1.2
 */
(function () {

  function patchXHR(fnName, newFn) {
    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
  }

  if (window.XMLHttpRequest && !window.XMLHttpRequest.__isFileAPIShim) {
    patchXHR("setRequestHeader", function (orig) {
      return function (header, value) {
        if (header === "__setXHR_") {
          var val = value(this);
          // fix for angular < 1.2.0
          if (val instanceof Function) {
            val(this);
          }
        } else {
          orig.apply(this, arguments);
        }
      };
    });
  }

  var angularFileUpload = angular.module("angularFileUpload", []);
  angularFileUpload.version = "2.1.2";
  angularFileUpload.service("$upload", ["$http", "$q", "$timeout", function ($http, $q, $timeout) {
    function sendHttp(config) {
      config.method = config.method || "POST";
      config.headers = config.headers || {};
      config.transformRequest = config.transformRequest || function (data, headersGetter) {
        if (window.ArrayBuffer && data instanceof window.ArrayBuffer) {
          return data;
        }
        return $http.defaults.transformRequest[0](data, headersGetter);
      };
      var deferred = $q.defer();
      var promise = deferred.promise;

      config.headers["__setXHR_"] = function () {
        return function (xhr) {
          if (!xhr) return;
          config.__XHR = xhr;
          config.xhrFn && config.xhrFn(xhr);
          xhr.upload.addEventListener("progress", function (e) {
            e.config = config;
            deferred.notify ? deferred.notify(e) : promise.progress_fn && $timeout(function () {promise.progress_fn(e);});
          }, false);
          // fix for firefox not firing upload progress end, also IE8-9
          xhr.upload.addEventListener("load", function (e) {
            if (e.lengthComputable) {
              e.config = config;
              deferred.notify ? deferred.notify(e) : promise.progress_fn && $timeout(function () {promise.progress_fn(e);});
            }
          }, false);
        };
      };

      $http(config).then(function (r) {deferred.resolve(r);}, function (e) {deferred.reject(e);}, function (n) {deferred.notify(n);});

      promise.success = function (fn) {
        promise.then(function (response) {
          fn(response.data, response.status, response.headers, config);
        });
        return promise;
      };

      promise.error = function (fn) {
        promise.then(null, function (response) {
          fn(response.data, response.status, response.headers, config);
        });
        return promise;
      };

      promise.progress = function (fn) {
        promise.progress_fn = fn;
        promise.then(null, null, function (update) {
          fn(update);
        });
        return promise;
      };
      promise.abort = function () {
        if (config.__XHR) {
          $timeout(function () {
            config.__XHR.abort();
          });
        }
        return promise;
      };
      promise.xhr = function (fn) {
        config.xhrFn = (function (origXhrFn) {
          return function () {
            origXhrFn && origXhrFn.apply(promise, arguments);
            fn.apply(promise, arguments);
          };
        })(config.xhrFn);
        return promise;
      };

      return promise;
    }

    this.upload = function (config) {
      config.headers = config.headers || {};
      config.headers["Content-Type"] = undefined;
      config.transformRequest = config.transformRequest || $http.defaults.transformRequest;
      var formData = new FormData();
      var origTransformRequest = config.transformRequest;
      var origData = config.data;
      config.transformRequest = function (formData, headerGetter) {
        if (origData) {
          if (config.formDataAppender) {
            for (var key in origData) {
              var val = origData[key];
              config.formDataAppender(formData, key, val);
            }
          } else {
            for (var key in origData) {
              var val = origData[key];
              if (typeof origTransformRequest === "function") {
                val = origTransformRequest(val, headerGetter);
              } else {
                for (var i = 0; i < origTransformRequest.length; i++) {
                  var transformFn = origTransformRequest[i];
                  if (typeof transformFn === "function") {
                    val = transformFn(val, headerGetter);
                  }
                }
              }
              if (val != undefined) formData.append(key, val);
            }
          }
        }

        if (config.file != null) {
          var fileFormName = config.fileFormDataName || "file";

          if (Object.prototype.toString.call(config.file) === "[object Array]") {
            var isFileFormNameString = Object.prototype.toString.call(fileFormName) === "[object String]";
            for (var i = 0; i < config.file.length; i++) {
              formData.append(isFileFormNameString ? fileFormName : fileFormName[i], config.file[i],
                (config.fileName && config.fileName[i]) || config.file[i].name);
            }
          } else {
            formData.append(fileFormName, config.file, config.fileName || config.file.name);
          }
        }
        return formData;
      };

      config.data = formData;

      return sendHttp(config);
    };

    this.http = function (config) {
      return sendHttp(config);
    };
  }]);

  angularFileUpload.directive("ngFileSelect", [ "$parse", "$timeout", "$compile", function ($parse, $timeout, $compile) { return {
    restrict: "AEC",
    require: "?ngModel",
    link: function (scope, elem, attr, ngModel) {
      handleFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile);
    }
  };}]);

  function handleFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile) {
    if (attr.ngMultiple && $parse(attr.ngMultiple)(scope)) {
      elem.attr("multiple", "true");
      attr["multiple"] = "true";
    }
    var accept = attr.ngAccept && $parse(attr.ngAccept)(scope);
    if (accept) {
      elem.attr("accept", accept);
      attr["accept"] = accept;
    }
    if (elem[0].tagName.toLowerCase() !== "input" || (elem.attr("type") && elem.attr("type").toLowerCase()) !== "file") {
      var fileElem = angular.element("<input type=\"file\">");
      if (attr["multiple"]) fileElem.attr("multiple", attr["multiple"]);
      if (attr["accept"]) fileElem.attr("accept", attr["accept"]);
      fileElem.css("width", "1px").css("height", "1px").css("opacity", 0).css("position", "absolute").css("filter", "alpha(opacity=0)")
        .css("padding", 0).css("margin", 0).css("overflow", "hidden").attr("tabindex", "-1").attr("ng-file-generated-elem", true);
      elem.append(fileElem);
      elem.__afu_fileClickDelegate__ = function () {
        fileElem[0].click();
      };
      elem.bind("click", elem.__afu_fileClickDelegate__);
      elem.css("overflow", "hidden");
      var origElem = elem;
      elem = fileElem;
    }
    if (attr["ngFileSelect"] != "") {
      attr.ngFileChange = attr.ngFileSelect;
    }
    if ($parse(attr.resetOnClick)(scope) != false) {
      if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
        // fix for IE10 cannot set the value of the input to null programmatically by replacing input
        var replaceElem = function (evt) {
          var inputFile = elem.clone();
          inputFile.val("");
          elem.replaceWith(inputFile);
          $compile(inputFile)(scope);
          fileElem = inputFile;
          elem = inputFile;
          elem.bind("change", onChangeFn);
          elem.unbind("click");
          elem[0].click();
          elem.bind("click", replaceElem);
          evt.preventDefault();
          evt.stopPropagation();
        };
        elem.bind("click", replaceElem);
      } else {
        elem.bind("click", function (evt) {
          elem[0].value = null;
        });
      }
    }
    var onChangeFn = function (evt) {
      var files = [], fileList, i;
      fileList = evt.__files_ || evt.target.files;
      updateModel(fileList, attr, ngModel, scope, evt);
    };
    elem.bind("change", onChangeFn);

    function updateModel(fileList, attr, ngModel, change, scope, evt) {
      var files = [];
      for (var i = 0; i < fileList.length; i++) {
        files.push(fileList.item(i));
      }
      if (ngModel) {
        scope[attr.ngModel] ? scope[attr.ngModel].value = files : scope[attr.ngModel] = files;
        ngModel && ngModel.$setViewValue(files != null && files.length == 0 ? "" : files);
      }
      if (attr.ngFileChange && attr.ngFileChange != "") {
        $timeout(function () {
          $parse(attr.ngFileChange)(scope, {
            $files: files,
            $event: evt
          });
        });
      }
    }
  }

  angularFileUpload.directive("ngFileDrop", [ "$parse", "$timeout", "$location", function ($parse, $timeout, $location) { return {
    restrict: "AEC",
    require: "?ngModel",
    link: function (scope, elem, attr, ngModel) {
      handleDrop(scope, elem, attr, ngModel, $parse, $timeout, $location);
    }
  };}]);

  angularFileUpload.directive("ngNoFileDrop", function () {
    return function (scope, elem, attr) {
      if (dropAvailable()) elem.css("display", "none");
    };
  });

  // for backward compatibility
  angularFileUpload.directive("ngFileDropAvailable", [ "$parse", "$timeout", function ($parse, $timeout) {
    return function (scope, elem, attr) {
      if (dropAvailable()) {
        var fn = $parse(attr["ngFileDropAvailable"]);
        $timeout(function () {
          fn(scope);
        });
      }
    };
  }]);

  function handleDrop(scope, elem, attr, ngModel, $parse, $timeout, $location) {
    var available = dropAvailable();
    if (attr["dropAvailable"]) {
      $timeout(function () {
        scope.dropAvailable ? scope.dropAvailable.value = available : scope.dropAvailable = available;
      });
    }
    if (!available) {
      if ($parse(attr.hideOnDropNotAvailable)(scope) != false) {
        elem.css("display", "none");
      }
      return;
    }
    var leaveTimeout = null;
    var stopPropagation = $parse(attr.stopPropagation)(scope);
    var dragOverDelay = 1;
    var accept = $parse(attr.ngAccept)(scope) || attr.accept;
    var regexp = accept ? new RegExp(globStringToRegex(accept)) : null;
    var actualDragOverClass;
    elem[0].addEventListener("dragover", function (evt) {
      evt.preventDefault();
      if (stopPropagation) evt.stopPropagation();
      $timeout.cancel(leaveTimeout);
      if (!scope.actualDragOverClass) {
        actualDragOverClass = calculateDragOverClass(scope, attr, evt);
      }
      elem.addClass(actualDragOverClass);
    }, false);
    elem[0].addEventListener("dragenter", function (evt) {
      evt.preventDefault();
      if (stopPropagation) evt.stopPropagation();
    }, false);
    elem[0].addEventListener("dragleave", function (evt) {
      leaveTimeout = $timeout(function () {
        elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
      }, dragOverDelay || 1);
    }, false);
    if (attr["ngFileDrop"] != "") {
      attr.ngFileChange = scope.ngFileDrop;
    }
    elem[0].addEventListener("drop", function (evt) {
      evt.preventDefault();
      if (stopPropagation) evt.stopPropagation();
      elem.removeClass(actualDragOverClass);
      actualDragOverClass = null;
      extractFiles(evt, function (files, rejFiles) {
        if (ngModel) {
          scope[attr.ngModel] ? scope[attr.ngModel].value = files : scope[attr.ngModel] = files;
          ngModel && ngModel.$setViewValue(files != null && files.length == 0 ? "" : files);
        }
        if (attr["ngFileRejectedModel"]) {
          scope[attr.ngFileRejectedModel] ? scope[attr.ngFileRejectedModel].value = rejFiles :
            scope[attr.ngFileRejectedModel] = rejFiles;
        }

        $timeout(function () {
          $parse(attr.ngFileChange)(scope, {
            $files: files,
            $rejectedFiles: rejFiles,
            $event: evt
          });
        });
      }, $parse(attr.allowDir)(scope) != false, attr.multiple || $parse(attr.ngMultiple)(scope));
    }, false);

    function calculateDragOverClass(scope, attr, evt) {
      var valid = true;
      if (regexp) {
        var items = evt.dataTransfer.items;
        if (items != null) {
          for (var i = 0 ; i < items.length && valid; i++) {
            valid = valid && (items[i].kind == "file" || items[i].kind == "") &&
						(items[i].type.match(regexp) != null || (items[i].name != null && items[i].name.match(regexp) != null));
          }
        }
      }
      var clazz = $parse(attr.dragOverClass)(scope, { $event: evt });
      if (clazz) {
        if (clazz.delay) dragOverDelay = clazz.delay;
        if (clazz.accept) clazz = valid ? clazz.accept : clazz.reject;
      }
      return clazz || attr["dragOverClass"] || "dragover";
    }

    function extractFiles(evt, callback, allowDir, multiple) {
      var files = [], rejFiles = [], items = evt.dataTransfer.items, processing = 0;

      function addFile(file) {
        if (!regexp || file.type.match(regexp) || (file.name != null && file.name.match(regexp))) {
          files.push(file);
        } else {
          rejFiles.push(file);
        }
      }

      if (items && items.length > 0 && $location.protocol() != "file") {
        for (var i = 0; i < items.length; i++) {
          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
            var entry = items[i].webkitGetAsEntry();
            if (entry.isDirectory && !allowDir) {
              continue;
            }
            if (entry != null) {
              // fix for chrome bug https://code.google.com/p/chromium/issues/detail?id=149735
              if (isASCII(entry.name)) {
                traverseFileTree(files, entry);
              } else if (!items[i].webkitGetAsEntry().isDirectory) {
                addFile(items[i].getAsFile());
              }
            }
          } else {
            var f = items[i].getAsFile();
            if (f != null) addFile(f);
          }
          if (!multiple && files.length > 0) break;
        }
      } else {
        var fileList = evt.dataTransfer.files;
        if (fileList != null) {
          for (var i = 0; i < fileList.length; i++) {
            addFile(fileList.item(i));
            if (!multiple && files.length > 0) break;
          }
        }
      }
      var delays = 0;
      (function waitForProcess(delay) {
        $timeout(function () {
          if (!processing) {
            if (!multiple && files.length > 1) {
              var i = 0;
              while (files[i].type == "directory") i++;
              files = [files[i]];
            }
            callback(files, rejFiles);
          } else {
            if (delays++ * 10 < 20 * 1000) {
              waitForProcess(10);
            }
          }
        }, delay || 0);
      })();

      function traverseFileTree(files, entry, path) {
        if (entry != null) {
          if (entry.isDirectory) {
            var filePath = (path || "") + entry.name;
            addFile({ name: entry.name, type: "directory", path: filePath });
            var dirReader = entry.createReader();
            var entries = [];
            processing++;
            var readEntries = function () {
              dirReader.readEntries(function (results) {
                try {
                  if (!results.length) {
                    for (var i = 0; i < entries.length; i++) {
                      traverseFileTree(files, entries[i], (path ? path : "") + entry.name + "/");
                    }
                    processing--;
                  } else {
                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                    readEntries();
                  }
                } catch (e) {
                  processing--;
                  console.error(e);
                }
              }, function () {
                processing--;
              });
            };
            readEntries();
          } else {
            processing++;
            entry.file(function (file) {
              try {
                processing--;
                file.path = (path ? path : "") + file.name;
                addFile(file);
              } catch (e) {
                processing--;
                console.error(e);
              }
            }, function (e) {
              processing--;
            });
          }
        }
      }
    }
  }

  function dropAvailable() {
    var div = document.createElement("div");
    return ("draggable" in div) && ("ondrop" in div);
  }

  function isASCII(str) {
    return /^[\000-\177]*$/.test(str);
  }

  function globStringToRegex(str) {
    if (str.length > 2 && str[0] === "/" && str[str.length - 1] === "/") {
      return str.substring(1, str.length - 1);
    }
    var split = str.split(","), result = "";
    if (split.length > 1) {
      for (var i = 0; i < split.length; i++) {
        result += "(" + globStringToRegex(split[i]) + ")";
        if (i < split.length - 1) {
          result += "|";
        }
      }
    } else {
      result = "^" + str.replace(new RegExp("[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\" + "-]", "g"), "\\$&") + "$";
      result = result.replace(/\\\*/g, ".*").replace(/\\\?/g, ".");
    }
    return result;
  }

})();

/* ! jQuery UI - v1.12.1 - 2016-09-14
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function ( factory ) {
  if ( typeof define === "function" && define.amd ) {

    // AMD. Register as an anonymous module.
    define([ "jquery" ], factory );
  } else {

    // Browser globals
    factory( jQuery );
  }
}(function ( $ ) {

  $.ui = $.ui || {};

  var version = $.ui.version = "1.12.1";

  /* !
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Widget
  // >>group: Core
  // >>description: Provides a factory for creating stateful widgets with a common API.
  // >>docs: http://api.jqueryui.com/jQuery.widget/
  // >>demos: http://jqueryui.com/widget/

  var widgetUuid = 0;
  var widgetSlice = Array.prototype.slice;

  $.cleanData = ( function ( orig ) {
    return function ( elems ) {
      var events, elem, i;
      for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
        try {

          // Only trigger remove when necessary to save time
          events = $._data( elem, "events" );
          if ( events && events.remove ) {
            $( elem ).triggerHandler( "remove" );
          }

          // Http://bugs.jquery.com/ticket/8235
        } catch ( e ) {}
      }
      orig( elems );
    };
  } )( $.cleanData );

  $.widget = function ( name, base, prototype ) {
    var existingConstructor, constructor, basePrototype;

    // ProxiedPrototype allows the provided prototype to remain unmodified
    // so that it can be used as a mixin for multiple widgets (#8876)
    var proxiedPrototype = {};

    var namespace = name.split( "." )[ 0 ];
    name = name.split( "." )[ 1 ];
    var fullName = namespace + "-" + name;

    if ( !prototype ) {
      prototype = base;
      base = $.Widget;
    }

    if ( $.isArray( prototype ) ) {
      prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
    }

    // Create selector for plugin
    $.expr[ ":" ][ fullName.toLowerCase() ] = function ( elem ) {
      return !!$.data( elem, fullName );
    };

    $[ namespace ] = $[ namespace ] || {};
    existingConstructor = $[ namespace ][ name ];
    constructor = $[ namespace ][ name ] = function ( options, element ) {

      // Allow instantiation without "new" keyword
      if ( !this._createWidget ) {
        return new constructor( options, element );
      }

      // Allow instantiation without initializing for simple inheritance
      // must use "new" keyword (the code above always passes args)
      if ( arguments.length ) {
        this._createWidget( options, element );
      }
    };

    // Extend with the existing constructor to carry over any static properties
    $.extend( constructor, existingConstructor, {
      version: prototype.version,

      // Copy the object used to create the prototype in case we need to
      // redefine the widget later
      _proto: $.extend( {}, prototype ),

      // Track widgets that inherit from this widget in case this widget is
      // redefined after a widget inherits from it
      _childConstructors: []
    } );

    basePrototype = new base();

    // We need to make the options hash a property directly on the new instance
    // otherwise we'll modify the options hash on the prototype that we're
    // inheriting from
    basePrototype.options = $.widget.extend( {}, basePrototype.options );
    $.each( prototype, function ( prop, value ) {
      if ( !$.isFunction( value ) ) {
        proxiedPrototype[ prop ] = value;
        return;
      }
      proxiedPrototype[ prop ] = ( function () {
        function _super() {
          return base.prototype[ prop ].apply( this, arguments );
        }

        function _superApply( args ) {
          return base.prototype[ prop ].apply( this, args );
        }

        return function () {
          var __super = this._super;
          var __superApply = this._superApply;
          var returnValue;

          this._super = _super;
          this._superApply = _superApply;

          returnValue = value.apply( this, arguments );

          this._super = __super;
          this._superApply = __superApply;

          return returnValue;
        };
      } )();
    } );
    constructor.prototype = $.widget.extend( basePrototype, {

      // TODO: remove support for widgetEventPrefix
      // always use the name + a colon as the prefix, e.g., draggable:start
      // don't prefix for widgets that aren't DOM-based
      widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
    }, proxiedPrototype, {
      constructor: constructor,
      namespace: namespace,
      widgetName: name,
      widgetFullName: fullName
    } );

    // If this widget is being redefined then we need to find all widgets that
    // are inheriting from it and redefine all of them so that they inherit from
    // the new version of this widget. We're essentially trying to replace one
    // level in the prototype chain.
    if ( existingConstructor ) {
      $.each( existingConstructor._childConstructors, function ( i, child ) {
        var childPrototype = child.prototype;

        // Redefine the child widget using the same prototype that was
        // originally used, but inherit from the new version of the base
        $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
          child._proto );
      } );

      // Remove the list of existing child constructors from the old constructor
      // so the old child constructors can be garbage collected
      delete existingConstructor._childConstructors;
    } else {
      base._childConstructors.push( constructor );
    }

    $.widget.bridge( name, constructor );

    return constructor;
  };

  $.widget.extend = function ( target ) {
    var input = widgetSlice.call( arguments, 1 );
    var inputIndex = 0;
    var inputLength = input.length;
    var key;
    var value;

    for ( ; inputIndex < inputLength; inputIndex++ ) {
      for ( key in input[ inputIndex ] ) {
        value = input[ inputIndex ][ key ];
        if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

          // Clone objects
          if ( $.isPlainObject( value ) ) {
            target[ key ] = $.isPlainObject( target[ key ] ) ?
              $.widget.extend( {}, target[ key ], value ) :

            // Don't extend strings, arrays, etc. with objects
              $.widget.extend( {}, value );

            // Copy everything else by reference
          } else {
            target[ key ] = value;
          }
        }
      }
    }
    return target;
  };

  $.widget.bridge = function ( name, object ) {
    var fullName = object.prototype.widgetFullName || name;
    $.fn[ name ] = function ( options ) {
      var isMethodCall = typeof options === "string";
      var args = widgetSlice.call( arguments, 1 );
      var returnValue = this;

      if ( isMethodCall ) {

        // If this is an empty collection, we need to have the instance method
        // return undefined instead of the jQuery instance
        if ( !this.length && options === "instance" ) {
          returnValue = undefined;
        } else {
          this.each( function () {
            var methodValue;
            var instance = $.data( this, fullName );

            if ( options === "instance" ) {
              returnValue = instance;
              return false;
            }

            if ( !instance ) {
              return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
            }

            if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
              return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
            }

            methodValue = instance[ options ].apply( instance, args );

            if ( methodValue !== instance && methodValue !== undefined ) {
              returnValue = methodValue && methodValue.jquery ?
                returnValue.pushStack( methodValue.get() ) :
                methodValue;
              return false;
            }
          } );
        }
      } else {

        // Allow multiple hashes to be passed on init
        if ( args.length ) {
          options = $.widget.extend.apply( null, [ options ].concat( args ) );
        }

        this.each( function () {
          var instance = $.data( this, fullName );
          if ( instance ) {
            instance.option( options || {} );
            if ( instance._init ) {
              instance._init();
            }
          } else {
            $.data( this, fullName, new object( options, this ) );
          }
        } );
      }

      return returnValue;
    };
  };

  $.Widget = function ( /* options, element */ ) {};
  $.Widget._childConstructors = [];

  $.Widget.prototype = {
    widgetName: "widget",
    widgetEventPrefix: "",
    defaultElement: "<div>",

    options: {
      classes: {},
      disabled: false,

      // Callbacks
      create: null
    },

    _createWidget: function ( options, element ) {
      element = $( element || this.defaultElement || this )[ 0 ];
      this.element = $( element );
      this.uuid = widgetUuid++;
      this.eventNamespace = "." + this.widgetName + this.uuid;

      this.bindings = $();
      this.hoverable = $();
      this.focusable = $();
      this.classesElementLookup = {};

      if ( element !== this ) {
        $.data( element, this.widgetFullName, this );
        this._on( true, this.element, {
          remove: function ( event ) {
            if ( event.target === element ) {
              this.destroy();
            }
          }
        } );
        this.document = $( element.style ?

        // Element within the document
          element.ownerDocument :

        // Element is window or document
          element.document || element );
        this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
      }

      this.options = $.widget.extend( {},
        this.options,
        this._getCreateOptions(),
        options );

      this._create();

      if ( this.options.disabled ) {
        this._setOptionDisabled( this.options.disabled );
      }

      this._trigger( "create", null, this._getCreateEventData() );
      this._init();
    },

    _getCreateOptions: function () {
      return {};
    },

    _getCreateEventData: $.noop,

    _create: $.noop,

    _init: $.noop,

    destroy: function () {
      var that = this;

      this._destroy();
      $.each( this.classesElementLookup, function ( key, value ) {
        that._removeClass( value, key );
      } );

      // We can probably remove the unbind calls in 2.0
      // all event bindings should go through this._on()
      this.element
        .off( this.eventNamespace )
        .removeData( this.widgetFullName );
      this.widget()
        .off( this.eventNamespace )
        .removeAttr( "aria-disabled" );

      // Clean up events and states
      this.bindings.off( this.eventNamespace );
    },

    _destroy: $.noop,

    widget: function () {
      return this.element;
    },

    option: function ( key, value ) {
      var options = key;
      var parts;
      var curOption;
      var i;

      if ( arguments.length === 0 ) {

        // Don't return a reference to the internal hash
        return $.widget.extend( {}, this.options );
      }

      if ( typeof key === "string" ) {

        // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
        options = {};
        parts = key.split( "." );
        key = parts.shift();
        if ( parts.length ) {
          curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
          for ( i = 0; i < parts.length - 1; i++ ) {
            curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
            curOption = curOption[ parts[ i ] ];
          }
          key = parts.pop();
          if ( arguments.length === 1 ) {
            return curOption[ key ] === undefined ? null : curOption[ key ];
          }
          curOption[ key ] = value;
        } else {
          if ( arguments.length === 1 ) {
            return this.options[ key ] === undefined ? null : this.options[ key ];
          }
          options[ key ] = value;
        }
      }

      this._setOptions( options );

      return this;
    },

    _setOptions: function ( options ) {
      var key;

      for ( key in options ) {
        this._setOption( key, options[ key ] );
      }

      return this;
    },

    _setOption: function ( key, value ) {
      if ( key === "classes" ) {
        this._setOptionClasses( value );
      }

      this.options[ key ] = value;

      if ( key === "disabled" ) {
        this._setOptionDisabled( value );
      }

      return this;
    },

    _setOptionClasses: function ( value ) {
      var classKey, elements, currentElements;

      for ( classKey in value ) {
        currentElements = this.classesElementLookup[ classKey ];
        if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
          continue;
        }

        // We are doing this to create a new jQuery object because the _removeClass() call
        // on the next line is going to destroy the reference to the current elements being
        // tracked. We need to save a copy of this collection so that we can add the new classes
        // below.
        elements = $( currentElements.get() );
        this._removeClass( currentElements, classKey );

        // We don't use _addClass() here, because that uses this.options.classes
        // for generating the string of classes. We want to use the value passed in from
        // _setOption(), this is the new value of the classes option which was passed to
        // _setOption(). We pass this value directly to _classes().
        elements.addClass( this._classes( {
          element: elements,
          keys: classKey,
          classes: value,
          add: true
        } ) );
      }
    },

    _setOptionDisabled: function ( value ) {
      this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

      // If the widget is becoming disabled, then nothing is interactive
      if ( value ) {
        this._removeClass( this.hoverable, null, "ui-state-hover" );
        this._removeClass( this.focusable, null, "ui-state-focus" );
      }
    },

    enable: function () {
      return this._setOptions( { disabled: false } );
    },

    disable: function () {
      return this._setOptions( { disabled: true } );
    },

    _classes: function ( options ) {
      var full = [];
      var that = this;

      options = $.extend( {
        element: this.element,
        classes: this.options.classes || {}
      }, options );

      function processClassString( classes, checkOption ) {
        var current, i;
        for ( i = 0; i < classes.length; i++ ) {
          current = that.classesElementLookup[ classes[ i ] ] || $();
          if ( options.add ) {
            current = $( $.unique( current.get().concat( options.element.get() ) ) );
          } else {
            current = $( current.not( options.element ).get() );
          }
          that.classesElementLookup[ classes[ i ] ] = current;
          full.push( classes[ i ] );
          if ( checkOption && options.classes[ classes[ i ] ] ) {
            full.push( options.classes[ classes[ i ] ] );
          }
        }
      }

      this._on( options.element, {
        "remove": "_untrackClassesElement"
      } );

      if ( options.keys ) {
        processClassString( options.keys.match( /\S+/g ) || [], true );
      }
      if ( options.extra ) {
        processClassString( options.extra.match( /\S+/g ) || [] );
      }

      return full.join( " " );
    },

    _untrackClassesElement: function ( event ) {
      var that = this;
      $.each( that.classesElementLookup, function ( key, value ) {
        if ( $.inArray( event.target, value ) !== -1 ) {
          that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
        }
      } );
    },

    _removeClass: function ( element, keys, extra ) {
      return this._toggleClass( element, keys, extra, false );
    },

    _addClass: function ( element, keys, extra ) {
      return this._toggleClass( element, keys, extra, true );
    },

    _toggleClass: function ( element, keys, extra, add ) {
      add = ( typeof add === "boolean" ) ? add : extra;
      var shift = ( typeof element === "string" || element === null ),
        options = {
          extra: shift ? keys : extra,
          keys: shift ? element : keys,
          element: shift ? this.element : element,
          add: add
        };
      options.element.toggleClass( this._classes( options ), add );
      return this;
    },

    _on: function ( suppressDisabledCheck, element, handlers ) {
      var delegateElement;
      var instance = this;

      // No suppressDisabledCheck flag, shuffle arguments
      if ( typeof suppressDisabledCheck !== "boolean" ) {
        handlers = element;
        element = suppressDisabledCheck;
        suppressDisabledCheck = false;
      }

      // No element argument, shuffle and use this.element
      if ( !handlers ) {
        handlers = element;
        element = this.element;
        delegateElement = this.widget();
      } else {
        element = delegateElement = $( element );
        this.bindings = this.bindings.add( element );
      }

      $.each( handlers, function ( event, handler ) {
        function handlerProxy() {

          // Allow widgets to customize the disabled handling
          // - disabled as an array instead of boolean
          // - disabled class as method for disabling individual parts
          if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
            return;
          }
          return ( typeof handler === "string" ? instance[ handler ] : handler )
            .apply( instance, arguments );
        }

        // Copy the guid so direct unbinding works
        if ( typeof handler !== "string" ) {
          handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
        }

        var match = event.match( /^([\w:-]*)\s*(.*)$/ );
        var eventName = match[ 1 ] + instance.eventNamespace;
        var selector = match[ 2 ];

        if ( selector ) {
          delegateElement.on( eventName, selector, handlerProxy );
        } else {
          element.on( eventName, handlerProxy );
        }
      } );
    },

    _off: function ( element, eventName ) {
      eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
      element.off( eventName ).off( eventName );

      // Clear the stack to avoid memory leaks (#10056)
      this.bindings = $( this.bindings.not( element ).get() );
      this.focusable = $( this.focusable.not( element ).get() );
      this.hoverable = $( this.hoverable.not( element ).get() );
    },

    _delay: function ( handler, delay ) {
      function handlerProxy() {
        return ( typeof handler === "string" ? instance[ handler ] : handler )
          .apply( instance, arguments );
      }
      var instance = this;
      return setTimeout( handlerProxy, delay || 0 );
    },

    _hoverable: function ( element ) {
      this.hoverable = this.hoverable.add( element );
      this._on( element, {
        mouseenter: function ( event ) {
          this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
        },
        mouseleave: function ( event ) {
          this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
        }
      } );
    },

    _focusable: function ( element ) {
      this.focusable = this.focusable.add( element );
      this._on( element, {
        focusin: function ( event ) {
          this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
        },
        focusout: function ( event ) {
          this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
        }
      } );
    },

    _trigger: function ( type, event, data ) {
      var prop, orig;
      var callback = this.options[ type ];

      data = data || {};
      event = $.Event( event );
      event.type = ( type === this.widgetEventPrefix ?
        type :
        this.widgetEventPrefix + type ).toLowerCase();

      // The original event may come from any element
      // so we need to reset the target on the new event
      event.target = this.element[ 0 ];

      // Copy original event properties over to the new event
      orig = event.originalEvent;
      if ( orig ) {
        for ( prop in orig ) {
          if ( !( prop in event ) ) {
            event[ prop ] = orig[ prop ];
          }
        }
      }

      this.element.trigger( event, data );
      return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
    }
  };

  $.each( { show: "fadeIn", hide: "fadeOut" }, function ( method, defaultEffect ) {
    $.Widget.prototype[ "_" + method ] = function ( element, options, callback ) {
      if ( typeof options === "string" ) {
        options = { effect: options };
      }

      var hasOptions;
      var effectName = !options ?
        method :
        options === true || typeof options === "number" ?
          defaultEffect :
          options.effect || defaultEffect;

      options = options || {};
      if ( typeof options === "number" ) {
        options = { duration: options };
      }

      hasOptions = !$.isEmptyObject( options );
      options.complete = callback;

      if ( options.delay ) {
        element.delay( options.delay );
      }

      if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
        element[ method ]( options );
      } else if ( effectName !== method && element[ effectName ] ) {
        element[ effectName ]( options.duration, options.easing, callback );
      } else {
        element.queue( function ( next ) {
          $( this )[ method ]();
          if ( callback ) {
            callback.call( element[ 0 ] );
          }
          next();
        } );
      }
    };
  } );

  var widget = $.widget;

  /* !
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

  // >>label: Position
  // >>group: Core
  // >>description: Positions elements relative to other elements.
  // >>docs: http://api.jqueryui.com/position/
  // >>demos: http://jqueryui.com/position/

  ( function () {
    var cachedScrollbarWidth,
      max = Math.max,
      abs = Math.abs,
      rhorizontal = /left|center|right/,
      rvertical = /top|center|bottom/,
      roffset = /[\+\-]\d+(\.[\d]+)?%?/,
      rposition = /^\w+/,
      rpercent = /%$/,
      _position = $.fn.position;

    function getOffsets( offsets, width, height ) {
      return [
        parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
        parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
      ];
    }

    function parseCss( element, property ) {
      return parseInt( $.css( element, property ), 10 ) || 0;
    }

    function getDimensions( elem ) {
      var raw = elem[ 0 ];
      if ( raw.nodeType === 9 ) {
        return {
          width: elem.width(),
          height: elem.height(),
          offset: { top: 0, left: 0 }
        };
      }
      if ( $.isWindow( raw ) ) {
        return {
          width: elem.width(),
          height: elem.height(),
          offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
        };
      }
      if ( raw.preventDefault ) {
        return {
          width: 0,
          height: 0,
          offset: { top: raw.pageY, left: raw.pageX }
        };
      }
      return {
        width: elem.outerWidth(),
        height: elem.outerHeight(),
        offset: elem.offset()
      };
    }

    $.position = {
      scrollbarWidth: function () {
        if ( cachedScrollbarWidth !== undefined ) {
          return cachedScrollbarWidth;
        }
        var w1, w2,
          div = $( "<div " +
				"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
				"<div style='height:100px;width:auto;'></div></div>" ),
          innerDiv = div.children()[ 0 ];

        $( "body" ).append( div );
        w1 = innerDiv.offsetWidth;
        div.css( "overflow", "scroll" );

        w2 = innerDiv.offsetWidth;

        if ( w1 === w2 ) {
          w2 = div[ 0 ].clientWidth;
        }

        div.remove();

        return ( cachedScrollbarWidth = w1 - w2 );
      },
      getScrollInfo: function ( within ) {
        var overflowX = within.isWindow || within.isDocument ? "" :
            within.element.css( "overflow-x" ),
          overflowY = within.isWindow || within.isDocument ? "" :
            within.element.css( "overflow-y" ),
          hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
          hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
        return {
          width: hasOverflowY ? $.position.scrollbarWidth() : 0,
          height: hasOverflowX ? $.position.scrollbarWidth() : 0
        };
      },
      getWithinInfo: function ( element ) {
        var withinElement = $( element || window ),
          isWindow = $.isWindow( withinElement[ 0 ] ),
          isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
          hasOffset = !isWindow && !isDocument;
        return {
          element: withinElement,
          isWindow: isWindow,
          isDocument: isDocument,
          offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
          scrollLeft: withinElement.scrollLeft(),
          scrollTop: withinElement.scrollTop(),
          width: withinElement.outerWidth(),
          height: withinElement.outerHeight()
        };
      }
    };

    $.fn.position = function ( options ) {
      if ( !options || !options.of ) {
        return _position.apply( this, arguments );
      }

      // Make a copy, we don't want to modify arguments
      options = $.extend( {}, options );

      var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
        target = $( options.of ),
        within = $.position.getWithinInfo( options.within ),
        scrollInfo = $.position.getScrollInfo( within ),
        collision = ( options.collision || "flip" ).split( " " ),
        offsets = {};

      dimensions = getDimensions( target );
      if ( target[ 0 ].preventDefault ) {

        // Force left top to allow flipping
        options.at = "left top";
      }
      targetWidth = dimensions.width;
      targetHeight = dimensions.height;
      targetOffset = dimensions.offset;

      // Clone to reuse original targetOffset later
      basePosition = $.extend( {}, targetOffset );

      // Force my and at to have valid horizontal and vertical positions
      // if a value is missing or invalid, it will be converted to center
      $.each( [ "my", "at" ], function () {
        var pos = ( options[ this ] || "" ).split( " " ),
          horizontalOffset,
          verticalOffset;

        if ( pos.length === 1 ) {
          pos = rhorizontal.test( pos[ 0 ] ) ?
            pos.concat( [ "center" ] ) :
            rvertical.test( pos[ 0 ] ) ?
              [ "center" ].concat( pos ) :
              [ "center", "center" ];
        }
        pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
        pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

        // Calculate offsets
        horizontalOffset = roffset.exec( pos[ 0 ] );
        verticalOffset = roffset.exec( pos[ 1 ] );
        offsets[ this ] = [
          horizontalOffset ? horizontalOffset[ 0 ] : 0,
          verticalOffset ? verticalOffset[ 0 ] : 0
        ];

        // Reduce to just the positions without the offsets
        options[ this ] = [
          rposition.exec( pos[ 0 ] )[ 0 ],
          rposition.exec( pos[ 1 ] )[ 0 ]
        ];
      } );

      // Normalize collision option
      if ( collision.length === 1 ) {
        collision[ 1 ] = collision[ 0 ];
      }

      if ( options.at[ 0 ] === "right" ) {
        basePosition.left += targetWidth;
      } else if ( options.at[ 0 ] === "center" ) {
        basePosition.left += targetWidth / 2;
      }

      if ( options.at[ 1 ] === "bottom" ) {
        basePosition.top += targetHeight;
      } else if ( options.at[ 1 ] === "center" ) {
        basePosition.top += targetHeight / 2;
      }

      atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
      basePosition.left += atOffset[ 0 ];
      basePosition.top += atOffset[ 1 ];

      return this.each( function () {
        var collisionPosition, using,
          elem = $( this ),
          elemWidth = elem.outerWidth(),
          elemHeight = elem.outerHeight(),
          marginLeft = parseCss( this, "marginLeft" ),
          marginTop = parseCss( this, "marginTop" ),
          collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
          collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
          position = $.extend( {}, basePosition ),
          myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

        if ( options.my[ 0 ] === "right" ) {
          position.left -= elemWidth;
        } else if ( options.my[ 0 ] === "center" ) {
          position.left -= elemWidth / 2;
        }

        if ( options.my[ 1 ] === "bottom" ) {
          position.top -= elemHeight;
        } else if ( options.my[ 1 ] === "center" ) {
          position.top -= elemHeight / 2;
        }

        position.left += myOffset[ 0 ];
        position.top += myOffset[ 1 ];

        collisionPosition = {
          marginLeft: marginLeft,
          marginTop: marginTop
        };

        $.each( [ "left", "top" ], function ( i, dir ) {
          if ( $.ui.position[ collision[ i ] ] ) {
            $.ui.position[ collision[ i ] ][ dir ]( position, {
              targetWidth: targetWidth,
              targetHeight: targetHeight,
              elemWidth: elemWidth,
              elemHeight: elemHeight,
              collisionPosition: collisionPosition,
              collisionWidth: collisionWidth,
              collisionHeight: collisionHeight,
              offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
              my: options.my,
              at: options.at,
              within: within,
              elem: elem
            } );
          }
        } );

        if ( options.using ) {

          // Adds feedback as second argument to using callback, if present
          using = function ( props ) {
            var left = targetOffset.left - position.left,
              right = left + targetWidth - elemWidth,
              top = targetOffset.top - position.top,
              bottom = top + targetHeight - elemHeight,
              feedback = {
                target: {
                  element: target,
                  left: targetOffset.left,
                  top: targetOffset.top,
                  width: targetWidth,
                  height: targetHeight
                },
                element: {
                  element: elem,
                  left: position.left,
                  top: position.top,
                  width: elemWidth,
                  height: elemHeight
                },
                horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
              };
            if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
              feedback.horizontal = "center";
            }
            if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
              feedback.vertical = "middle";
            }
            if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
              feedback.important = "horizontal";
            } else {
              feedback.important = "vertical";
            }
            options.using.call( this, props, feedback );
          };
        }

        elem.offset( $.extend( position, { using: using } ) );
      } );
    };

    $.ui.position = {
      fit: {
        left: function ( position, data ) {
          var within = data.within,
            withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
            outerWidth = within.width,
            collisionPosLeft = position.left - data.collisionPosition.marginLeft,
            overLeft = withinOffset - collisionPosLeft,
            overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
            newOverRight;

          // Element is wider than within
          if ( data.collisionWidth > outerWidth ) {

            // Element is initially over the left side of within
            if ( overLeft > 0 && overRight <= 0 ) {
              newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
              position.left += overLeft - newOverRight;

              // Element is initially over right side of within
            } else if ( overRight > 0 && overLeft <= 0 ) {
              position.left = withinOffset;

              // Element is initially over both left and right sides of within
            } else {
              if ( overLeft > overRight ) {
                position.left = withinOffset + outerWidth - data.collisionWidth;
              } else {
                position.left = withinOffset;
              }
            }

            // Too far left -> align with left edge
          } else if ( overLeft > 0 ) {
            position.left += overLeft;

            // Too far right -> align with right edge
          } else if ( overRight > 0 ) {
            position.left -= overRight;

            // Adjust based on position and margin
          } else {
            position.left = max( position.left - collisionPosLeft, position.left );
          }
        },
        top: function ( position, data ) {
          var within = data.within,
            withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
            outerHeight = data.within.height,
            collisionPosTop = position.top - data.collisionPosition.marginTop,
            overTop = withinOffset - collisionPosTop,
            overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
            newOverBottom;

          // Element is taller than within
          if ( data.collisionHeight > outerHeight ) {

            // Element is initially over the top of within
            if ( overTop > 0 && overBottom <= 0 ) {
              newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
              position.top += overTop - newOverBottom;

              // Element is initially over bottom of within
            } else if ( overBottom > 0 && overTop <= 0 ) {
              position.top = withinOffset;

              // Element is initially over both top and bottom of within
            } else {
              if ( overTop > overBottom ) {
                position.top = withinOffset + outerHeight - data.collisionHeight;
              } else {
                position.top = withinOffset;
              }
            }

            // Too far up -> align with top
          } else if ( overTop > 0 ) {
            position.top += overTop;

            // Too far down -> align with bottom edge
          } else if ( overBottom > 0 ) {
            position.top -= overBottom;

            // Adjust based on position and margin
          } else {
            position.top = max( position.top - collisionPosTop, position.top );
          }
        }
      },
      flip: {
        left: function ( position, data ) {
          var within = data.within,
            withinOffset = within.offset.left + within.scrollLeft,
            outerWidth = within.width,
            offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
            collisionPosLeft = position.left - data.collisionPosition.marginLeft,
            overLeft = collisionPosLeft - offsetLeft,
            overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
            myOffset = data.my[ 0 ] === "left" ?
              -data.elemWidth :
              data.my[ 0 ] === "right" ?
                data.elemWidth :
                0,
            atOffset = data.at[ 0 ] === "left" ?
              data.targetWidth :
              data.at[ 0 ] === "right" ?
                -data.targetWidth :
                0,
            offset = -2 * data.offset[ 0 ],
            newOverRight,
            newOverLeft;

          if ( overLeft < 0 ) {
            newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
            if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
              position.left += myOffset + atOffset + offset;
            }
          } else if ( overRight > 0 ) {
            newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
            if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
              position.left += myOffset + atOffset + offset;
            }
          }
        },
        top: function ( position, data ) {
          var within = data.within,
            withinOffset = within.offset.top + within.scrollTop,
            outerHeight = within.height,
            offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
            collisionPosTop = position.top - data.collisionPosition.marginTop,
            overTop = collisionPosTop - offsetTop,
            overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
            top = data.my[ 1 ] === "top",
            myOffset = top ?
              -data.elemHeight :
              data.my[ 1 ] === "bottom" ?
                data.elemHeight :
                0,
            atOffset = data.at[ 1 ] === "top" ?
              data.targetHeight :
              data.at[ 1 ] === "bottom" ?
                -data.targetHeight :
                0,
            offset = -2 * data.offset[ 1 ],
            newOverTop,
            newOverBottom;
          if ( overTop < 0 ) {
            newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
            if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
              position.top += myOffset + atOffset + offset;
            }
          } else if ( overBottom > 0 ) {
            newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
            if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
              position.top += myOffset + atOffset + offset;
            }
          }
        }
      },
      flipfit: {
        left: function () {
          $.ui.position.flip.left.apply( this, arguments );
          $.ui.position.fit.left.apply( this, arguments );
        },
        top: function () {
          $.ui.position.flip.top.apply( this, arguments );
          $.ui.position.fit.top.apply( this, arguments );
        }
      }
    };

  } )();

  var position = $.ui.position;

  /* !
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: :data Selector
  // >>group: Core
  // >>description: Selects elements which have data stored under the specified key.
  // >>docs: http://api.jqueryui.com/data-selector/

  var data = $.extend( $.expr[ ":" ], {
    data: $.expr.createPseudo ?
      $.expr.createPseudo( function ( dataName ) {
        return function ( elem ) {
          return !!$.data( elem, dataName );
        };
      } ) :

    // Support: jQuery <1.8
      function ( elem, i, match ) {
        return !!$.data( elem, match[ 3 ] );
      }
  } );

  /* !
 * jQuery UI Disable Selection 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: disableSelection
  // >>group: Core
  // >>description: Disable selection of text content within the set of matched elements.
  // >>docs: http://api.jqueryui.com/disableSelection/

  // This file is deprecated

  var disableSelection = $.fn.extend( {
    disableSelection: ( function () {
      var eventType = "onselectstart" in document.createElement( "div" ) ?
        "selectstart" :
        "mousedown";

      return function () {
        return this.on( eventType + ".ui-disableSelection", function ( event ) {
          event.preventDefault();
        } );
      };
    } )(),

    enableSelection: function () {
      return this.off( ".ui-disableSelection" );
    }
  } );

  /* !
 * jQuery UI Effects 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Effects Core
  // >>group: Effects
  // jscs:disable maximumLineLength
  // >>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
  // jscs:enable maximumLineLength
  // >>docs: http://api.jqueryui.com/category/effects-core/
  // >>demos: http://jqueryui.com/effect/

  var dataSpace = "ui-effects-",
    dataSpaceStyle = "ui-effects-style",
    dataSpaceAnimated = "ui-effects-animated",

    // Create a local jQuery because jQuery Color relies on it and the
    // global may not exist with AMD and a custom build (#10199)
    jQuery = $;

  $.effects = {
    effect: {}
  };

  /* !
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
  ( function ( jQuery, undefined ) {

    var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

      // Plusequals test for += 100 -= 100
      rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

      // A set of RE's that can match strings and generate color tuples.
      stringParsers = [ {
        re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
        parse: function ( execResult ) {
          return [
            execResult[ 1 ],
            execResult[ 2 ],
            execResult[ 3 ],
            execResult[ 4 ]
          ];
        }
      }, {
        re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
        parse: function ( execResult ) {
          return [
            execResult[ 1 ] * 2.55,
            execResult[ 2 ] * 2.55,
            execResult[ 3 ] * 2.55,
            execResult[ 4 ]
          ];
        }
      }, {

        // This regex ignores A-F because it's compared against an already lowercased string
        re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
        parse: function ( execResult ) {
          return [
            parseInt( execResult[ 1 ], 16 ),
            parseInt( execResult[ 2 ], 16 ),
            parseInt( execResult[ 3 ], 16 )
          ];
        }
      }, {

        // This regex ignores A-F because it's compared against an already lowercased string
        re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
        parse: function ( execResult ) {
          return [
            parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
            parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
            parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
          ];
        }
      }, {
        re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
        space: "hsla",
        parse: function ( execResult ) {
          return [
            execResult[ 1 ],
            execResult[ 2 ] / 100,
            execResult[ 3 ] / 100,
            execResult[ 4 ]
          ];
        }
      } ],

      // JQuery.Color( )
      color = jQuery.Color = function ( color, green, blue, alpha ) {
        return new jQuery.Color.fn.parse( color, green, blue, alpha );
      },
      spaces = {
        rgba: {
          props: {
            red: {
              idx: 0,
              type: "byte"
            },
            green: {
              idx: 1,
              type: "byte"
            },
            blue: {
              idx: 2,
              type: "byte"
            }
          }
        },

        hsla: {
          props: {
            hue: {
              idx: 0,
              type: "degrees"
            },
            saturation: {
              idx: 1,
              type: "percent"
            },
            lightness: {
              idx: 2,
              type: "percent"
            }
          }
        }
      },
      propTypes = {
        "byte": {
          floor: true,
          max: 255
        },
        "percent": {
          max: 1
        },
        "degrees": {
          mod: 360,
          floor: true
        }
      },
      support = color.support = {},

      // Element for support tests
      supportElem = jQuery( "<p>" )[ 0 ],

      // Colors = jQuery.Color.names
      colors,

      // Local aliases of functions called often
      each = jQuery.each;

    // Determine rgba support immediately
    supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
    support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

    // Define cache name and alpha properties
    // for rgba and hsla spaces
    each( spaces, function ( spaceName, space ) {
      space.cache = "_" + spaceName;
      space.props.alpha = {
        idx: 3,
        type: "percent",
        def: 1
      };
    } );

    function clamp( value, prop, allowEmpty ) {
      var type = propTypes[ prop.type ] || {};

      if ( value == null ) {
        return ( allowEmpty || !prop.def ) ? null : prop.def;
      }

      // ~~ is an short way of doing floor for positive numbers
      value = type.floor ? ~~value : parseFloat( value );

      // IE will pass in empty strings as value for alpha,
      // which will hit this case
      if ( isNaN( value ) ) {
        return prop.def;
      }

      if ( type.mod ) {

        // We add mod before modding to make sure that negatives values
        // get converted properly: -10 -> 350
        return ( value + type.mod ) % type.mod;
      }

      // For now all property types without mod have min and max
      return 0 > value ? 0 : type.max < value ? type.max : value;
    }

    function stringParse( string ) {
      var inst = color(),
        rgba = inst._rgba = [];

      string = string.toLowerCase();

      each( stringParsers, function ( i, parser ) {
        var parsed,
          match = parser.re.exec( string ),
          values = match && parser.parse( match ),
          spaceName = parser.space || "rgba";

        if ( values ) {
          parsed = inst[ spaceName ]( values );

          // If this was an rgba parse the assignment might happen twice
          // oh well....
          inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
          rgba = inst._rgba = parsed._rgba;

          // Exit each( stringParsers ) here because we matched
          return false;
        }
      } );

      // Found a stringParser that handled it
      if ( rgba.length ) {

        // If this came from a parsed string, force "transparent" when alpha is 0
        // chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
        if ( rgba.join() === "0,0,0,0" ) {
          jQuery.extend( rgba, colors.transparent );
        }
        return inst;
      }

      // Named colors
      return colors[ string ];
    }

    color.fn = jQuery.extend( color.prototype, {
      parse: function ( red, green, blue, alpha ) {
        if ( red === undefined ) {
          this._rgba = [ null, null, null, null ];
          return this;
        }
        if ( red.jquery || red.nodeType ) {
          red = jQuery( red ).css( green );
          green = undefined;
        }

        var inst = this,
          type = jQuery.type( red ),
          rgba = this._rgba = [];

        // More than 1 argument specified - assume ( red, green, blue, alpha )
        if ( green !== undefined ) {
          red = [ red, green, blue, alpha ];
          type = "array";
        }

        if ( type === "string" ) {
          return this.parse( stringParse( red ) || colors._default );
        }

        if ( type === "array" ) {
          each( spaces.rgba.props, function ( key, prop ) {
            rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
          } );
          return this;
        }

        if ( type === "object" ) {
          if ( red instanceof color ) {
            each( spaces, function ( spaceName, space ) {
              if ( red[ space.cache ] ) {
                inst[ space.cache ] = red[ space.cache ].slice();
              }
            } );
          } else {
            each( spaces, function ( spaceName, space ) {
              var cache = space.cache;
              each( space.props, function ( key, prop ) {

                // If the cache doesn't exist, and we know how to convert
                if ( !inst[ cache ] && space.to ) {

                  // If the value was null, we don't need to copy it
                  // if the key was alpha, we don't need to copy it either
                  if ( key === "alpha" || red[ key ] == null ) {
                    return;
                  }
                  inst[ cache ] = space.to( inst._rgba );
                }

                // This is the only case where we allow nulls for ALL properties.
                // call clamp with alwaysAllowEmpty
                inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
              } );

              // Everything defined but alpha?
              if ( inst[ cache ] &&
							jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {

                // Use the default of 1
                inst[ cache ][ 3 ] = 1;
                if ( space.from ) {
                  inst._rgba = space.from( inst[ cache ] );
                }
              }
            } );
          }
          return this;
        }
      },
      is: function ( compare ) {
        var is = color( compare ),
          same = true,
          inst = this;

        each( spaces, function ( _, space ) {
          var localCache,
            isCache = is[ space.cache ];
          if ( isCache ) {
            localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
            each( space.props, function ( _, prop ) {
              if ( isCache[ prop.idx ] != null ) {
                same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
                return same;
              }
            } );
          }
          return same;
        } );
        return same;
      },
      _space: function () {
        var used = [],
          inst = this;
        each( spaces, function ( spaceName, space ) {
          if ( inst[ space.cache ] ) {
            used.push( spaceName );
          }
        } );
        return used.pop();
      },
      transition: function ( other, distance ) {
        var end = color( other ),
          spaceName = end._space(),
          space = spaces[ spaceName ],
          startColor = this.alpha() === 0 ? color( "transparent" ) : this,
          start = startColor[ space.cache ] || space.to( startColor._rgba ),
          result = start.slice();

        end = end[ space.cache ];
        each( space.props, function ( key, prop ) {
          var index = prop.idx,
            startValue = start[ index ],
            endValue = end[ index ],
            type = propTypes[ prop.type ] || {};

          // If null, don't override start value
          if ( endValue === null ) {
            return;
          }

          // If null - use end
          if ( startValue === null ) {
            result[ index ] = endValue;
          } else {
            if ( type.mod ) {
              if ( endValue - startValue > type.mod / 2 ) {
                startValue += type.mod;
              } else if ( startValue - endValue > type.mod / 2 ) {
                startValue -= type.mod;
              }
            }
            result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
          }
        } );
        return this[ spaceName ]( result );
      },
      blend: function ( opaque ) {

        // If we are already opaque - return ourself
        if ( this._rgba[ 3 ] === 1 ) {
          return this;
        }

        var rgb = this._rgba.slice(),
          a = rgb.pop(),
          blend = color( opaque )._rgba;

        return color( jQuery.map( rgb, function ( v, i ) {
          return ( 1 - a ) * blend[ i ] + a * v;
        } ) );
      },
      toRgbaString: function () {
        var prefix = "rgba(",
          rgba = jQuery.map( this._rgba, function ( v, i ) {
            return v == null ? ( i > 2 ? 1 : 0 ) : v;
          } );

        if ( rgba[ 3 ] === 1 ) {
          rgba.pop();
          prefix = "rgb(";
        }

        return prefix + rgba.join() + ")";
      },
      toHslaString: function () {
        var prefix = "hsla(",
          hsla = jQuery.map( this.hsla(), function ( v, i ) {
            if ( v == null ) {
              v = i > 2 ? 1 : 0;
            }

            // Catch 1 and 2
            if ( i && i < 3 ) {
              v = Math.round( v * 100 ) + "%";
            }
            return v;
          } );

        if ( hsla[ 3 ] === 1 ) {
          hsla.pop();
          prefix = "hsl(";
        }
        return prefix + hsla.join() + ")";
      },
      toHexString: function ( includeAlpha ) {
        var rgba = this._rgba.slice(),
          alpha = rgba.pop();

        if ( includeAlpha ) {
          rgba.push( ~~( alpha * 255 ) );
        }

        return "#" + jQuery.map( rgba, function ( v ) {

          // Default to 0 when nulls exist
          v = ( v || 0 ).toString( 16 );
          return v.length === 1 ? "0" + v : v;
        } ).join( "" );
      },
      toString: function () {
        return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
      }
    } );
    color.fn.parse.prototype = color.fn;

    // Hsla conversions adapted from:
    // https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

    function hue2rgb( p, q, h ) {
      h = ( h + 1 ) % 1;
      if ( h * 6 < 1 ) {
        return p + ( q - p ) * h * 6;
      }
      if ( h * 2 < 1 ) {
        return q;
      }
      if ( h * 3 < 2 ) {
        return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
      }
      return p;
    }

    spaces.hsla.to = function ( rgba ) {
      if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
        return [ null, null, null, rgba[ 3 ] ];
      }
      var r = rgba[ 0 ] / 255,
        g = rgba[ 1 ] / 255,
        b = rgba[ 2 ] / 255,
        a = rgba[ 3 ],
        max = Math.max( r, g, b ),
        min = Math.min( r, g, b ),
        diff = max - min,
        add = max + min,
        l = add * 0.5,
        h, s;

      if ( min === max ) {
        h = 0;
      } else if ( r === max ) {
        h = ( 60 * ( g - b ) / diff ) + 360;
      } else if ( g === max ) {
        h = ( 60 * ( b - r ) / diff ) + 120;
      } else {
        h = ( 60 * ( r - g ) / diff ) + 240;
      }

      // Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
      // otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
      if ( diff === 0 ) {
        s = 0;
      } else if ( l <= 0.5 ) {
        s = diff / add;
      } else {
        s = diff / ( 2 - add );
      }
      return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
    };

    spaces.hsla.from = function ( hsla ) {
      if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
        return [ null, null, null, hsla[ 3 ] ];
      }
      var h = hsla[ 0 ] / 360,
        s = hsla[ 1 ],
        l = hsla[ 2 ],
        a = hsla[ 3 ],
        q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
        p = 2 * l - q;

      return [
        Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
        Math.round( hue2rgb( p, q, h ) * 255 ),
        Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
        a
      ];
    };

    each( spaces, function ( spaceName, space ) {
      var props = space.props,
        cache = space.cache,
        to = space.to,
        from = space.from;

      // Makes rgba() and hsla()
      color.fn[ spaceName ] = function ( value ) {

        // Generate a cache for this space if it doesn't exist
        if ( to && !this[ cache ] ) {
          this[ cache ] = to( this._rgba );
        }
        if ( value === undefined ) {
          return this[ cache ].slice();
        }

        var ret,
          type = jQuery.type( value ),
          arr = ( type === "array" || type === "object" ) ? value : arguments,
          local = this[ cache ].slice();

        each( props, function ( key, prop ) {
          var val = arr[ type === "object" ? key : prop.idx ];
          if ( val == null ) {
            val = local[ prop.idx ];
          }
          local[ prop.idx ] = clamp( val, prop );
        } );

        if ( from ) {
          ret = color( from( local ) );
          ret[ cache ] = local;
          return ret;
        } else {
          return color( local );
        }
      };

      // Makes red() green() blue() alpha() hue() saturation() lightness()
      each( props, function ( key, prop ) {

        // Alpha is included in more than one space
        if ( color.fn[ key ] ) {
          return;
        }
        color.fn[ key ] = function ( value ) {
          var vtype = jQuery.type( value ),
            fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
            local = this[ fn ](),
            cur = local[ prop.idx ],
            match;

          if ( vtype === "undefined" ) {
            return cur;
          }

          if ( vtype === "function" ) {
            value = value.call( this, cur );
            vtype = jQuery.type( value );
          }
          if ( value == null && prop.empty ) {
            return this;
          }
          if ( vtype === "string" ) {
            match = rplusequals.exec( value );
            if ( match ) {
              value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
            }
          }
          local[ prop.idx ] = value;
          return this[ fn ]( local );
        };
      } );
    } );

    // Add cssHook and .fx.step function for each named hook.
    // accept a space separated string of properties
    color.hook = function ( hook ) {
      var hooks = hook.split( " " );
      each( hooks, function ( i, hook ) {
        jQuery.cssHooks[ hook ] = {
          set: function ( elem, value ) {
            var parsed, curElem,
              backgroundColor = "";

            if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
						( parsed = stringParse( value ) ) ) ) {
              value = color( parsed || value );
              if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
                curElem = hook === "backgroundColor" ? elem.parentNode : elem;
                while (
                  ( backgroundColor === "" || backgroundColor === "transparent" ) &&
							curElem && curElem.style
                ) {
                  try {
                    backgroundColor = jQuery.css( curElem, "backgroundColor" );
                    curElem = curElem.parentNode;
                  } catch ( e ) {
                  }
                }

                value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
                  backgroundColor :
                  "_default" );
              }

              value = value.toRgbaString();
            }
            try {
              elem.style[ hook ] = value;
            } catch ( e ) {

              // Wrapped to prevent IE from throwing errors on "invalid" values like
              // 'auto' or 'inherit'
            }
          }
        };
        jQuery.fx.step[ hook ] = function ( fx ) {
          if ( !fx.colorInit ) {
            fx.start = color( fx.elem, hook );
            fx.end = color( fx.end );
            fx.colorInit = true;
          }
          jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
        };
      } );

    };

    color.hook( stepHooks );

    jQuery.cssHooks.borderColor = {
      expand: function ( value ) {
        var expanded = {};

        each( [ "Top", "Right", "Bottom", "Left" ], function ( i, part ) {
          expanded[ "border" + part + "Color" ] = value;
        } );
        return expanded;
      }
    };

    // Basic color names only.
    // Usage of any of the other color names requires adding yourself or including
    // jquery.color.svg-names.js.
    colors = jQuery.Color.names = {

      // 4.1. Basic color keywords
      aqua: "#00ffff",
      black: "#000000",
      blue: "#0000ff",
      fuchsia: "#ff00ff",
      gray: "#808080",
      green: "#008000",
      lime: "#00ff00",
      maroon: "#800000",
      navy: "#000080",
      olive: "#808000",
      purple: "#800080",
      red: "#ff0000",
      silver: "#c0c0c0",
      teal: "#008080",
      white: "#ffffff",
      yellow: "#ffff00",

      // 4.2.3. "transparent" color keyword
      transparent: [ null, null, null, 0 ],

      _default: "#ffffff"
    };

  } )( jQuery );

  /** ****************************************************************************/
  /** **************************** CLASS ANIMATIONS ******************************/
  /** ****************************************************************************/
  ( function () {

    var classAnimationActions = [ "add", "remove", "toggle" ],
      shorthandStyles = {
        border: 1,
        borderBottom: 1,
        borderColor: 1,
        borderLeft: 1,
        borderRight: 1,
        borderTop: 1,
        borderWidth: 1,
        margin: 1,
        padding: 1
      };

    $.each(
      [ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
      function ( _, prop ) {
        $.fx.step[ prop ] = function ( fx ) {
          if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
            jQuery.style( fx.elem, prop, fx.end );
            fx.setAttr = true;
          }
        };
      }
    );

    function getElementStyles( elem ) {
      var key, len,
        style = elem.ownerDocument.defaultView ?
          elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
          elem.currentStyle,
        styles = {};

      if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
        len = style.length;
        while ( len-- ) {
          key = style[ len ];
          if ( typeof style[ key ] === "string" ) {
            styles[ $.camelCase( key ) ] = style[ key ];
          }
        }

        // Support: Opera, IE <9
      } else {
        for ( key in style ) {
          if ( typeof style[ key ] === "string" ) {
            styles[ key ] = style[ key ];
          }
        }
      }

      return styles;
    }

    function styleDifference( oldStyle, newStyle ) {
      var diff = {},
        name, value;

      for ( name in newStyle ) {
        value = newStyle[ name ];
        if ( oldStyle[ name ] !== value ) {
          if ( !shorthandStyles[ name ] ) {
            if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
              diff[ name ] = value;
            }
          }
        }
      }

      return diff;
    }

    // Support: jQuery <1.8
    if ( !$.fn.addBack ) {
      $.fn.addBack = function ( selector ) {
        return this.add( selector == null ?
          this.prevObject : this.prevObject.filter( selector )
        );
      };
    }

    $.effects.animateClass = function ( value, duration, easing, callback ) {
      var o = $.speed( duration, easing, callback );

      return this.queue( function () {
        var animated = $( this ),
          baseClass = animated.attr( "class" ) || "",
          applyClassChange,
          allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

        // Map the animated objects to store the original styles.
        allAnimations = allAnimations.map( function () {
          var el = $( this );
          return {
            el: el,
            start: getElementStyles( this )
          };
        } );

        // Apply class change
        applyClassChange = function () {
          $.each( classAnimationActions, function ( i, action ) {
            if ( value[ action ] ) {
              animated[ action + "Class" ]( value[ action ] );
            }
          } );
        };
        applyClassChange();

        // Map all animated objects again - calculate new styles and diff
        allAnimations = allAnimations.map( function () {
          this.end = getElementStyles( this.el[ 0 ] );
          this.diff = styleDifference( this.start, this.end );
          return this;
        } );

        // Apply original class
        animated.attr( "class", baseClass );

        // Map all animated objects again - this time collecting a promise
        allAnimations = allAnimations.map( function () {
          var styleInfo = this,
            dfd = $.Deferred(),
            opts = $.extend( {}, o, {
              queue: false,
              complete: function () {
                dfd.resolve( styleInfo );
              }
            } );

          this.el.animate( this.diff, opts );
          return dfd.promise();
        } );

        // Once all animations have completed:
        $.when.apply( $, allAnimations.get() ).done( function () {

          // Set the final class
          applyClassChange();

          // For each animated element,
          // clear all css properties that were animated
          $.each( arguments, function () {
            var el = this.el;
            $.each( this.diff, function ( key ) {
              el.css( key, "" );
            } );
          } );

          // This is guarnteed to be there if you use jQuery.speed()
          // it also handles dequeuing the next anim...
          o.complete.call( animated[ 0 ] );
        } );
      } );
    };

    $.fn.extend( {
      addClass: ( function ( orig ) {
        return function ( classNames, speed, easing, callback ) {
          return speed ?
            $.effects.animateClass.call( this,
              { add: classNames }, speed, easing, callback ) :
            orig.apply( this, arguments );
        };
      } )( $.fn.addClass ),

      removeClass: ( function ( orig ) {
        return function ( classNames, speed, easing, callback ) {
          return arguments.length > 1 ?
            $.effects.animateClass.call( this,
              { remove: classNames }, speed, easing, callback ) :
            orig.apply( this, arguments );
        };
      } )( $.fn.removeClass ),

      toggleClass: ( function ( orig ) {
        return function ( classNames, force, speed, easing, callback ) {
          if ( typeof force === "boolean" || force === undefined ) {
            if ( !speed ) {

              // Without speed parameter
              return orig.apply( this, arguments );
            } else {
              return $.effects.animateClass.call( this,
                ( force ? { add: classNames } : { remove: classNames } ),
                speed, easing, callback );
            }
          } else {

            // Without force parameter
            return $.effects.animateClass.call( this,
              { toggle: classNames }, force, speed, easing );
          }
        };
      } )( $.fn.toggleClass ),

      switchClass: function ( remove, add, speed, easing, callback ) {
        return $.effects.animateClass.call( this, {
          add: add,
          remove: remove
        }, speed, easing, callback );
      }
    } );

  } )();

  /** ****************************************************************************/
  /** ********************************* EFFECTS **********************************/
  /** ****************************************************************************/

  ( function () {

    if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
      $.expr.filters.animated = ( function ( orig ) {
        return function ( elem ) {
          return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
        };
      } )( $.expr.filters.animated );
    }

    if ( $.uiBackCompat !== false ) {
      $.extend( $.effects, {

        // Saves a set of properties in a data storage
        save: function ( element, set ) {
          var i = 0, length = set.length;
          for ( ; i < length; i++ ) {
            if ( set[ i ] !== null ) {
              element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
            }
          }
        },

        // Restores a set of previously saved properties from a data storage
        restore: function ( element, set ) {
          var val, i = 0, length = set.length;
          for ( ; i < length; i++ ) {
            if ( set[ i ] !== null ) {
              val = element.data( dataSpace + set[ i ] );
              element.css( set[ i ], val );
            }
          }
        },

        setMode: function ( el, mode ) {
          if ( mode === "toggle" ) {
            mode = el.is( ":hidden" ) ? "show" : "hide";
          }
          return mode;
        },

        // Wraps the element around a wrapper that copies position properties
        createWrapper: function ( element ) {

          // If the element is already wrapped, return it
          if ( element.parent().is( ".ui-effects-wrapper" ) ) {
            return element.parent();
          }

          // Wrap the element
          var props = {
              width: element.outerWidth( true ),
              height: element.outerHeight( true ),
              "float": element.css( "float" )
            },
            wrapper = $( "<div></div>" )
              .addClass( "ui-effects-wrapper" )
              .css( {
                fontSize: "100%",
                background: "transparent",
                border: "none",
                margin: 0,
                padding: 0
              } ),

            // Store the size in case width/height are defined in % - Fixes #5245
            size = {
              width: element.width(),
              height: element.height()
            },
            active = document.activeElement;

          // Support: Firefox
          // Firefox incorrectly exposes anonymous content
          // https://bugzilla.mozilla.org/show_bug.cgi?id=561664
          try {
            active.id;
          } catch ( e ) {
            active = document.body;
          }

          element.wrap( wrapper );

          // Fixes #7595 - Elements lose focus when wrapped.
          if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
            $( active ).trigger( "focus" );
          }

          // Hotfix for jQuery 1.4 since some change in wrap() seems to actually
          // lose the reference to the wrapped element
          wrapper = element.parent();

          // Transfer positioning properties to the wrapper
          if ( element.css( "position" ) === "static" ) {
            wrapper.css( { position: "relative" } );
            element.css( { position: "relative" } );
          } else {
            $.extend( props, {
              position: element.css( "position" ),
              zIndex: element.css( "z-index" )
            } );
            $.each( [ "top", "left", "bottom", "right" ], function ( i, pos ) {
              props[ pos ] = element.css( pos );
              if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
                props[ pos ] = "auto";
              }
            } );
            element.css( {
              position: "relative",
              top: 0,
              left: 0,
              right: "auto",
              bottom: "auto"
            } );
          }
          element.css( size );

          return wrapper.css( props ).show();
        },

        removeWrapper: function ( element ) {
          var active = document.activeElement;

          if ( element.parent().is( ".ui-effects-wrapper" ) ) {
            element.parent().replaceWith( element );

            // Fixes #7595 - Elements lose focus when wrapped.
            if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
              $( active ).trigger( "focus" );
            }
          }

          return element;
        }
      } );
    }

    $.extend( $.effects, {
      version: "1.12.1",

      define: function ( name, mode, effect ) {
        if ( !effect ) {
          effect = mode;
          mode = "effect";
        }

        $.effects.effect[ name ] = effect;
        $.effects.effect[ name ].mode = mode;

        return effect;
      },

      scaledDimensions: function ( element, percent, direction ) {
        if ( percent === 0 ) {
          return {
            height: 0,
            width: 0,
            outerHeight: 0,
            outerWidth: 0
          };
        }

        var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
          y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

        return {
          height: element.height() * y,
          width: element.width() * x,
          outerHeight: element.outerHeight() * y,
          outerWidth: element.outerWidth() * x
        };

      },

      clipToBox: function ( animation ) {
        return {
          width: animation.clip.right - animation.clip.left,
          height: animation.clip.bottom - animation.clip.top,
          left: animation.clip.left,
          top: animation.clip.top
        };
      },

      // Injects recently queued functions to be first in line (after "inprogress")
      unshift: function ( element, queueLength, count ) {
        var queue = element.queue();

        if ( queueLength > 1 ) {
          queue.splice.apply( queue,
            [ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
        }
        element.dequeue();
      },

      saveStyle: function ( element ) {
        element.data( dataSpaceStyle, element[ 0 ].style.cssText );
      },

      restoreStyle: function ( element ) {
        element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
        element.removeData( dataSpaceStyle );
      },

      mode: function ( element, mode ) {
        var hidden = element.is( ":hidden" );

        if ( mode === "toggle" ) {
          mode = hidden ? "show" : "hide";
        }
        if ( hidden ? mode === "hide" : mode === "show" ) {
          mode = "none";
        }
        return mode;
      },

      // Translates a [top,left] array into a baseline value
      getBaseline: function ( origin, original ) {
        var y, x;

        switch ( origin[ 0 ] ) {
          case "top":
            y = 0;
            break;
          case "middle":
            y = 0.5;
            break;
          case "bottom":
            y = 1;
            break;
          default:
            y = origin[ 0 ] / original.height;
        }

        switch ( origin[ 1 ] ) {
          case "left":
            x = 0;
            break;
          case "center":
            x = 0.5;
            break;
          case "right":
            x = 1;
            break;
          default:
            x = origin[ 1 ] / original.width;
        }

        return {
          x: x,
          y: y
        };
      },

      // Creates a placeholder element so that the original element can be made absolute
      createPlaceholder: function ( element ) {
        var placeholder,
          cssPosition = element.css( "position" ),
          position = element.position();

        // Lock in margins first to account for form elements, which
        // will change margin if you explicitly set height
        // see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
        // Support: Safari
        element.css( {
          marginTop: element.css( "marginTop" ),
          marginBottom: element.css( "marginBottom" ),
          marginLeft: element.css( "marginLeft" ),
          marginRight: element.css( "marginRight" )
        } )
          .outerWidth( element.outerWidth() )
          .outerHeight( element.outerHeight() );

        if ( /^(static|relative)/.test( cssPosition ) ) {
          cssPosition = "absolute";

          placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

            // Convert inline to inline block to account for inline elements
            // that turn to inline block based on content (like img)
            display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
              "inline-block" :
              "block",
            visibility: "hidden",

            // Margins need to be set to account for margin collapse
            marginTop: element.css( "marginTop" ),
            marginBottom: element.css( "marginBottom" ),
            marginLeft: element.css( "marginLeft" ),
            marginRight: element.css( "marginRight" ),
            "float": element.css( "float" )
          } )
            .outerWidth( element.outerWidth() )
            .outerHeight( element.outerHeight() )
            .addClass( "ui-effects-placeholder" );

          element.data( dataSpace + "placeholder", placeholder );
        }

        element.css( {
          position: cssPosition,
          left: position.left,
          top: position.top
        } );

        return placeholder;
      },

      removePlaceholder: function ( element ) {
        var dataKey = dataSpace + "placeholder",
          placeholder = element.data( dataKey );

        if ( placeholder ) {
          placeholder.remove();
          element.removeData( dataKey );
        }
      },

      // Removes a placeholder if it exists and restores
      // properties that were modified during placeholder creation
      cleanUp: function ( element ) {
        $.effects.restoreStyle( element );
        $.effects.removePlaceholder( element );
      },

      setTransition: function ( element, list, factor, value ) {
        value = value || {};
        $.each( list, function ( i, x ) {
          var unit = element.cssUnit( x );
          if ( unit[ 0 ] > 0 ) {
            value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
          }
        } );
        return value;
      }
    } );

    // Return an effect options object for the given parameters:
    function _normalizeArguments( effect, options, speed, callback ) {

      // Allow passing all options as the first parameter
      if ( $.isPlainObject( effect ) ) {
        options = effect;
        effect = effect.effect;
      }

      // Convert to an object
      effect = { effect: effect };

      // Catch (effect, null, ...)
      if ( options == null ) {
        options = {};
      }

      // Catch (effect, callback)
      if ( $.isFunction( options ) ) {
        callback = options;
        speed = null;
        options = {};
      }

      // Catch (effect, speed, ?)
      if ( typeof options === "number" || $.fx.speeds[ options ] ) {
        callback = speed;
        speed = options;
        options = {};
      }

      // Catch (effect, options, callback)
      if ( $.isFunction( speed ) ) {
        callback = speed;
        speed = null;
      }

      // Add options to effect
      if ( options ) {
        $.extend( effect, options );
      }

      speed = speed || options.duration;
      effect.duration = $.fx.off ? 0 :
        typeof speed === "number" ? speed :
          speed in $.fx.speeds ? $.fx.speeds[ speed ] :
            $.fx.speeds._default;

      effect.complete = callback || options.complete;

      return effect;
    }

    function standardAnimationOption( option ) {

      // Valid standard speeds (nothing, number, named speed)
      if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
        return true;
      }

      // Invalid strings - treat as "normal" speed
      if ( typeof option === "string" && !$.effects.effect[ option ] ) {
        return true;
      }

      // Complete callback
      if ( $.isFunction( option ) ) {
        return true;
      }

      // Options hash (but not naming an effect)
      if ( typeof option === "object" && !option.effect ) {
        return true;
      }

      // Didn't match any standard API
      return false;
    }

    $.fn.extend( {
      effect: function ( /* effect, options, speed, callback */ ) {
        var args = _normalizeArguments.apply( this, arguments ),
          effectMethod = $.effects.effect[ args.effect ],
          defaultMode = effectMethod.mode,
          queue = args.queue,
          queueName = queue || "fx",
          complete = args.complete,
          mode = args.mode,
          modes = [],
          prefilter = function ( next ) {
            var el = $( this ),
              normalizedMode = $.effects.mode( el, mode ) || defaultMode;

            // Sentinel for duck-punching the :animated psuedo-selector
            el.data( dataSpaceAnimated, true );

            // Save effect mode for later use,
            // we can't just call $.effects.mode again later,
            // as the .show() below destroys the initial state
            modes.push( normalizedMode );

            // See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
            if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
              el.show();
            }

            if ( !defaultMode || normalizedMode !== "none" ) {
              $.effects.saveStyle( el );
            }

            if ( $.isFunction( next ) ) {
              next();
            }
          };

        if ( $.fx.off || !effectMethod ) {

          // Delegate to the original method (e.g., .show()) if possible
          if ( mode ) {
            return this[ mode ]( args.duration, complete );
          } else {
            return this.each( function () {
              if ( complete ) {
                complete.call( this );
              }
            } );
          }
        }

        function run( next ) {
          var elem = $( this );

          function cleanup() {
            elem.removeData( dataSpaceAnimated );

            $.effects.cleanUp( elem );

            if ( args.mode === "hide" ) {
              elem.hide();
            }

            done();
          }

          function done() {
            if ( $.isFunction( complete ) ) {
              complete.call( elem[ 0 ] );
            }

            if ( $.isFunction( next ) ) {
              next();
            }
          }

          // Override mode option on a per element basis,
          // as toggle can be either show or hide depending on element state
          args.mode = modes.shift();

          if ( $.uiBackCompat !== false && !defaultMode ) {
            if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

              // Call the core method to track "olddisplay" properly
              elem[ mode ]();
              done();
            } else {
              effectMethod.call( elem[ 0 ], args, done );
            }
          } else {
            if ( args.mode === "none" ) {

              // Call the core method to track "olddisplay" properly
              elem[ mode ]();
              done();
            } else {
              effectMethod.call( elem[ 0 ], args, cleanup );
            }
          }
        }

        // Run prefilter on all elements first to ensure that
        // any showing or hiding happens before placeholder creation,
        // which ensures that any layout changes are correctly captured.
        return queue === false ?
          this.each( prefilter ).each( run ) :
          this.queue( queueName, prefilter ).queue( queueName, run );
      },

      show: ( function ( orig ) {
        return function ( option ) {
          if ( standardAnimationOption( option ) ) {
            return orig.apply( this, arguments );
          } else {
            var args = _normalizeArguments.apply( this, arguments );
            args.mode = "show";
            return this.effect.call( this, args );
          }
        };
      } )( $.fn.show ),

      hide: ( function ( orig ) {
        return function ( option ) {
          if ( standardAnimationOption( option ) ) {
            return orig.apply( this, arguments );
          } else {
            var args = _normalizeArguments.apply( this, arguments );
            args.mode = "hide";
            return this.effect.call( this, args );
          }
        };
      } )( $.fn.hide ),

      toggle: ( function ( orig ) {
        return function ( option ) {
          if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
            return orig.apply( this, arguments );
          } else {
            var args = _normalizeArguments.apply( this, arguments );
            args.mode = "toggle";
            return this.effect.call( this, args );
          }
        };
      } )( $.fn.toggle ),

      cssUnit: function ( key ) {
        var style = this.css( key ),
          val = [];

        $.each( [ "em", "px", "%", "pt" ], function ( i, unit ) {
          if ( style.indexOf( unit ) > 0 ) {
            val = [ parseFloat( style ), unit ];
          }
        } );
        return val;
      },

      cssClip: function ( clipObj ) {
        if ( clipObj ) {
          return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
        }
        return parseClip( this.css( "clip" ), this );
      },

      transfer: function ( options, done ) {
        var element = $( this ),
          target = $( options.to ),
          targetFixed = target.css( "position" ) === "fixed",
          body = $( "body" ),
          fixTop = targetFixed ? body.scrollTop() : 0,
          fixLeft = targetFixed ? body.scrollLeft() : 0,
          endPosition = target.offset(),
          animation = {
            top: endPosition.top - fixTop,
            left: endPosition.left - fixLeft,
            height: target.innerHeight(),
            width: target.innerWidth()
          },
          startPosition = element.offset(),
          transfer = $( "<div class='ui-effects-transfer'></div>" )
            .appendTo( "body" )
            .addClass( options.className )
            .css( {
              top: startPosition.top - fixTop,
              left: startPosition.left - fixLeft,
              height: element.innerHeight(),
              width: element.innerWidth(),
              position: targetFixed ? "fixed" : "absolute"
            } )
            .animate( animation, options.duration, options.easing, function () {
              transfer.remove();
              if ( $.isFunction( done ) ) {
                done();
              }
            } );
      }
    } );

    function parseClip( str, element ) {
      var outerWidth = element.outerWidth(),
        outerHeight = element.outerHeight(),
        clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
        values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

      return {
        top: parseFloat( values[ 1 ] ) || 0,
        right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
        bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
        left: parseFloat( values[ 4 ] ) || 0
      };
    }

    $.fx.step.clip = function ( fx ) {
      if ( !fx.clipInit ) {
        fx.start = $( fx.elem ).cssClip();
        if ( typeof fx.end === "string" ) {
          fx.end = parseClip( fx.end, fx.elem );
        }
        fx.clipInit = true;
      }

      $( fx.elem ).cssClip( {
        top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
        right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
        bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
        left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
      } );
    };

  } )();

  /** ****************************************************************************/
  /** ********************************* EASING ***********************************/
  /** ****************************************************************************/

  ( function () {

    // Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

    var baseEasings = {};

    $.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function ( i, name ) {
      baseEasings[ name ] = function ( p ) {
        return Math.pow( p, i + 2 );
      };
    } );

    $.extend( baseEasings, {
      Sine: function ( p ) {
        return 1 - Math.cos( p * Math.PI / 2 );
      },
      Circ: function ( p ) {
        return 1 - Math.sqrt( 1 - p * p );
      },
      Elastic: function ( p ) {
        return p === 0 || p === 1 ? p :
          -Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
      },
      Back: function ( p ) {
        return p * p * ( 3 * p - 2 );
      },
      Bounce: function ( p ) {
        var pow2,
          bounce = 4;

        while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
        return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
      }
    } );

    $.each( baseEasings, function ( name, easeIn ) {
      $.easing[ "easeIn" + name ] = easeIn;
      $.easing[ "easeOut" + name ] = function ( p ) {
        return 1 - easeIn( 1 - p );
      };
      $.easing[ "easeInOut" + name ] = function ( p ) {
        return p < 0.5 ?
          easeIn( p * 2 ) / 2 :
          1 - easeIn( p * -2 + 2 ) / 2;
      };
    } );

  } )();

  var effect = $.effects;

  /* !
 * jQuery UI Effects Blind 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Blind Effect
  // >>group: Effects
  // >>description: Blinds the element.
  // >>docs: http://api.jqueryui.com/blind-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectBlind = $.effects.define( "blind", "hide", function ( options, done ) {
    var map = {
        up: [ "bottom", "top" ],
        vertical: [ "bottom", "top" ],
        down: [ "top", "bottom" ],
        left: [ "right", "left" ],
        horizontal: [ "right", "left" ],
        right: [ "left", "right" ]
      },
      element = $( this ),
      direction = options.direction || "up",
      start = element.cssClip(),
      animate = { clip: $.extend( {}, start ) },
      placeholder = $.effects.createPlaceholder( element );

    animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

    if ( options.mode === "show" ) {
      element.cssClip( animate.clip );
      if ( placeholder ) {
        placeholder.css( $.effects.clipToBox( animate ) );
      }

      animate.clip = start;
    }

    if ( placeholder ) {
      placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
    }

    element.animate( animate, {
      queue: false,
      duration: options.duration,
      easing: options.easing,
      complete: done
    } );
  } );

  /* !
 * jQuery UI Effects Bounce 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Bounce Effect
  // >>group: Effects
  // >>description: Bounces an element horizontally or vertically n times.
  // >>docs: http://api.jqueryui.com/bounce-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectBounce = $.effects.define( "bounce", function ( options, done ) {
    var upAnim, downAnim, refValue,
      element = $( this ),

      // Defaults:
      mode = options.mode,
      hide = mode === "hide",
      show = mode === "show",
      direction = options.direction || "up",
      distance = options.distance,
      times = options.times || 5,

      // Number of internal animations
      anims = times * 2 + ( show || hide ? 1 : 0 ),
      speed = options.duration / anims,
      easing = options.easing,

      // Utility:
      ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
      motion = ( direction === "up" || direction === "left" ),
      i = 0,

      queuelen = element.queue().length;

    $.effects.createPlaceholder( element );

    refValue = element.css( ref );

    // Default distance for the BIGGEST bounce is the outer Distance / 3
    if ( !distance ) {
      distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
    }

    if ( show ) {
      downAnim = { opacity: 1 };
      downAnim[ ref ] = refValue;

      // If we are showing, force opacity 0 and set the initial position
      // then do the "first" animation
      element
        .css( "opacity", 0 )
        .css( ref, motion ? -distance * 2 : distance * 2 )
        .animate( downAnim, speed, easing );
    }

    // Start at the smallest distance if we are hiding
    if ( hide ) {
      distance = distance / Math.pow( 2, times - 1 );
    }

    downAnim = {};
    downAnim[ ref ] = refValue;

    // Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
    for ( ; i < times; i++ ) {
      upAnim = {};
      upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

      element
        .animate( upAnim, speed, easing )
        .animate( downAnim, speed, easing );

      distance = hide ? distance * 2 : distance / 2;
    }

    // Last Bounce when Hiding
    if ( hide ) {
      upAnim = { opacity: 0 };
      upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

      element.animate( upAnim, speed, easing );
    }

    element.queue( done );

    $.effects.unshift( element, queuelen, anims + 1 );
  } );

  /* !
 * jQuery UI Effects Clip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Clip Effect
  // >>group: Effects
  // >>description: Clips the element on and off like an old TV.
  // >>docs: http://api.jqueryui.com/clip-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectClip = $.effects.define( "clip", "hide", function ( options, done ) {
    var start,
      animate = {},
      element = $( this ),
      direction = options.direction || "vertical",
      both = direction === "both",
      horizontal = both || direction === "horizontal",
      vertical = both || direction === "vertical";

    start = element.cssClip();
    animate.clip = {
      top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
      right: horizontal ? ( start.right - start.left ) / 2 : start.right,
      bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
      left: horizontal ? ( start.right - start.left ) / 2 : start.left
    };

    $.effects.createPlaceholder( element );

    if ( options.mode === "show" ) {
      element.cssClip( animate.clip );
      animate.clip = start;
    }

    element.animate( animate, {
      queue: false,
      duration: options.duration,
      easing: options.easing,
      complete: done
    } );

  } );

  /* !
 * jQuery UI Effects Drop 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Drop Effect
  // >>group: Effects
  // >>description: Moves an element in one direction and hides it at the same time.
  // >>docs: http://api.jqueryui.com/drop-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectDrop = $.effects.define( "drop", "hide", function ( options, done ) {

    var distance,
      element = $( this ),
      mode = options.mode,
      show = mode === "show",
      direction = options.direction || "left",
      ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
      motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
      oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
      animation = {
        opacity: 0
      };

    $.effects.createPlaceholder( element );

    distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

    animation[ ref ] = motion + distance;

    if ( show ) {
      element.css( animation );

      animation[ ref ] = oppositeMotion + distance;
      animation.opacity = 1;
    }

    // Animate
    element.animate( animation, {
      queue: false,
      duration: options.duration,
      easing: options.easing,
      complete: done
    } );
  } );

  /* !
 * jQuery UI Effects Explode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Explode Effect
  // >>group: Effects
  // jscs:disable maximumLineLength
  // >>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
  // jscs:enable maximumLineLength
  // >>docs: http://api.jqueryui.com/explode-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectExplode = $.effects.define( "explode", "hide", function ( options, done ) {

    var i, j, left, top, mx, my,
      rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
      cells = rows,
      element = $( this ),
      mode = options.mode,
      show = mode === "show",

      // Show and then visibility:hidden the element before calculating offset
      offset = element.show().css( "visibility", "hidden" ).offset(),

      // Width and height of a piece
      width = Math.ceil( element.outerWidth() / cells ),
      height = Math.ceil( element.outerHeight() / rows ),
      pieces = [];

    // Children animate complete:
    function childComplete() {
      pieces.push( this );
      if ( pieces.length === rows * cells ) {
        animComplete();
      }
    }

    // Clone the element for each row and cell.
    for ( i = 0; i < rows; i++ ) { // ===>
      top = offset.top + i * height;
      my = i - ( rows - 1 ) / 2;

      for ( j = 0; j < cells; j++ ) { // |||
        left = offset.left + j * width;
        mx = j - ( cells - 1 ) / 2;

        // Create a clone of the now hidden main element that will be absolute positioned
        // within a wrapper div off the -left and -top equal to size of our pieces
        element
          .clone()
          .appendTo( "body" )
          .wrap( "<div></div>" )
          .css( {
            position: "absolute",
            visibility: "visible",
            left: -j * width,
            top: -i * height
          } )

        // Select the wrapper - make it overflow: hidden and absolute positioned based on
        // where the original was located +left and +top equal to the size of pieces
          .parent()
          .addClass( "ui-effects-explode" )
          .css( {
            position: "absolute",
            overflow: "hidden",
            width: width,
            height: height,
            left: left + ( show ? mx * width : 0 ),
            top: top + ( show ? my * height : 0 ),
            opacity: show ? 0 : 1
          } )
          .animate( {
            left: left + ( show ? 0 : mx * width ),
            top: top + ( show ? 0 : my * height ),
            opacity: show ? 1 : 0
          }, options.duration || 500, options.easing, childComplete );
      }
    }

    function animComplete() {
      element.css( {
        visibility: "visible"
      } );
      $( pieces ).remove();
      done();
    }
  } );

  /* !
 * jQuery UI Effects Fade 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Fade Effect
  // >>group: Effects
  // >>description: Fades the element.
  // >>docs: http://api.jqueryui.com/fade-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectFade = $.effects.define( "fade", "toggle", function ( options, done ) {
    var show = options.mode === "show";

    $( this )
      .css( "opacity", show ? 0 : 1 )
      .animate( {
        opacity: show ? 1 : 0
      }, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: done
      } );
  } );

  /* !
 * jQuery UI Effects Fold 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Fold Effect
  // >>group: Effects
  // >>description: Folds an element first horizontally and then vertically.
  // >>docs: http://api.jqueryui.com/fold-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectFold = $.effects.define( "fold", "hide", function ( options, done ) {

    // Create element
    var element = $( this ),
      mode = options.mode,
      show = mode === "show",
      hide = mode === "hide",
      size = options.size || 15,
      percent = /([0-9]+)%/.exec( size ),
      horizFirst = !!options.horizFirst,
      ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
      duration = options.duration / 2,

      placeholder = $.effects.createPlaceholder( element ),

      start = element.cssClip(),
      animation1 = { clip: $.extend( {}, start ) },
      animation2 = { clip: $.extend( {}, start ) },

      distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

      queuelen = element.queue().length;

    if ( percent ) {
      size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
    }
    animation1.clip[ ref[ 0 ] ] = size;
    animation2.clip[ ref[ 0 ] ] = size;
    animation2.clip[ ref[ 1 ] ] = 0;

    if ( show ) {
      element.cssClip( animation2.clip );
      if ( placeholder ) {
        placeholder.css( $.effects.clipToBox( animation2 ) );
      }

      animation2.clip = start;
    }

    // Animate
    element
      .queue( function ( next ) {
        if ( placeholder ) {
          placeholder
            .animate( $.effects.clipToBox( animation1 ), duration, options.easing )
            .animate( $.effects.clipToBox( animation2 ), duration, options.easing );
        }

        next();
      } )
      .animate( animation1, duration, options.easing )
      .animate( animation2, duration, options.easing )
      .queue( done );

    $.effects.unshift( element, queuelen, 4 );
  } );

  /* !
 * jQuery UI Effects Highlight 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Highlight Effect
  // >>group: Effects
  // >>description: Highlights the background of an element in a defined color for a custom duration.
  // >>docs: http://api.jqueryui.com/highlight-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectHighlight = $.effects.define( "highlight", "show", function ( options, done ) {
    var element = $( this ),
      animation = {
        backgroundColor: element.css( "backgroundColor" )
      };

    if ( options.mode === "hide" ) {
      animation.opacity = 0;
    }

    $.effects.saveStyle( element );

    element
      .css( {
        backgroundImage: "none",
        backgroundColor: options.color || "#ffff99"
      } )
      .animate( animation, {
        queue: false,
        duration: options.duration,
        easing: options.easing,
        complete: done
      } );
  } );

  /* !
 * jQuery UI Effects Size 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Size Effect
  // >>group: Effects
  // >>description: Resize an element to a specified width and height.
  // >>docs: http://api.jqueryui.com/size-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectSize = $.effects.define( "size", function ( options, done ) {

    // Create element
    var baseline, factor, temp,
      element = $( this ),

      // Copy for children
      cProps = [ "fontSize" ],
      vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
      hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

      // Set options
      mode = options.mode,
      restore = mode !== "effect",
      scale = options.scale || "both",
      origin = options.origin || [ "middle", "center" ],
      position = element.css( "position" ),
      pos = element.position(),
      original = $.effects.scaledDimensions( element ),
      from = options.from || original,
      to = options.to || $.effects.scaledDimensions( element, 0 );

    $.effects.createPlaceholder( element );

    if ( mode === "show" ) {
      temp = from;
      from = to;
      to = temp;
    }

    // Set scaling factor
    factor = {
      from: {
        y: from.height / original.height,
        x: from.width / original.width
      },
      to: {
        y: to.height / original.height,
        x: to.width / original.width
      }
    };

    // Scale the css box
    if ( scale === "box" || scale === "both" ) {

      // Vertical props scaling
      if ( factor.from.y !== factor.to.y ) {
        from = $.effects.setTransition( element, vProps, factor.from.y, from );
        to = $.effects.setTransition( element, vProps, factor.to.y, to );
      }

      // Horizontal props scaling
      if ( factor.from.x !== factor.to.x ) {
        from = $.effects.setTransition( element, hProps, factor.from.x, from );
        to = $.effects.setTransition( element, hProps, factor.to.x, to );
      }
    }

    // Scale the content
    if ( scale === "content" || scale === "both" ) {

      // Vertical props scaling
      if ( factor.from.y !== factor.to.y ) {
        from = $.effects.setTransition( element, cProps, factor.from.y, from );
        to = $.effects.setTransition( element, cProps, factor.to.y, to );
      }
    }

    // Adjust the position properties based on the provided origin points
    if ( origin ) {
      baseline = $.effects.getBaseline( origin, original );
      from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
      from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
      to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
      to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
    }
    element.css( from );

    // Animate the children if desired
    if ( scale === "content" || scale === "both" ) {

      vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
      hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

      // Only animate children with width attributes specified
      // TODO: is this right? should we include anything with css width specified as well
      element.find( "*[width]" ).each( function () {
        var child = $( this ),
          childOriginal = $.effects.scaledDimensions( child ),
          childFrom = {
            height: childOriginal.height * factor.from.y,
            width: childOriginal.width * factor.from.x,
            outerHeight: childOriginal.outerHeight * factor.from.y,
            outerWidth: childOriginal.outerWidth * factor.from.x
          },
          childTo = {
            height: childOriginal.height * factor.to.y,
            width: childOriginal.width * factor.to.x,
            outerHeight: childOriginal.height * factor.to.y,
            outerWidth: childOriginal.width * factor.to.x
          };

        // Vertical props scaling
        if ( factor.from.y !== factor.to.y ) {
          childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
          childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
        }

        // Horizontal props scaling
        if ( factor.from.x !== factor.to.x ) {
          childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
          childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
        }

        if ( restore ) {
          $.effects.saveStyle( child );
        }

        // Animate children
        child.css( childFrom );
        child.animate( childTo, options.duration, options.easing, function () {

          // Restore children
          if ( restore ) {
            $.effects.restoreStyle( child );
          }
        } );
      } );
    }

    // Animate
    element.animate( to, {
      queue: false,
      duration: options.duration,
      easing: options.easing,
      complete: function () {

        var offset = element.offset();

        if ( to.opacity === 0 ) {
          element.css( "opacity", from.opacity );
        }

        if ( !restore ) {
          element
            .css( "position", position === "static" ? "relative" : position )
            .offset( offset );

          // Need to save style here so that automatic style restoration
          // doesn't restore to the original styles from before the animation.
          $.effects.saveStyle( element );
        }

        done();
      }
    } );

  } );

  /* !
 * jQuery UI Effects Scale 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Scale Effect
  // >>group: Effects
  // >>description: Grows or shrinks an element and its content.
  // >>docs: http://api.jqueryui.com/scale-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectScale = $.effects.define( "scale", function ( options, done ) {

    // Create element
    var el = $( this ),
      mode = options.mode,
      percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

      newOptions = $.extend( true, {
        from: $.effects.scaledDimensions( el ),
        to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
        origin: options.origin || [ "middle", "center" ]
      }, options );

    // Fade option to support puff
    if ( options.fade ) {
      newOptions.from.opacity = 1;
      newOptions.to.opacity = 0;
    }

    $.effects.effect.size.call( this, newOptions, done );
  } );

  /* !
 * jQuery UI Effects Puff 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Puff Effect
  // >>group: Effects
  // >>description: Creates a puff effect by scaling the element up and hiding it at the same time.
  // >>docs: http://api.jqueryui.com/puff-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectPuff = $.effects.define( "puff", "hide", function ( options, done ) {
    var newOptions = $.extend( true, {}, options, {
      fade: true,
      percent: parseInt( options.percent, 10 ) || 150
    } );

    $.effects.effect.scale.call( this, newOptions, done );
  } );

  /* !
 * jQuery UI Effects Pulsate 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Pulsate Effect
  // >>group: Effects
  // >>description: Pulsates an element n times by changing the opacity to zero and back.
  // >>docs: http://api.jqueryui.com/pulsate-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectPulsate = $.effects.define( "pulsate", "show", function ( options, done ) {
    var element = $( this ),
      mode = options.mode,
      show = mode === "show",
      hide = mode === "hide",
      showhide = show || hide,

      // Showing or hiding leaves off the "last" animation
      anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
      duration = options.duration / anims,
      animateTo = 0,
      i = 1,
      queuelen = element.queue().length;

    if ( show || !element.is( ":visible" ) ) {
      element.css( "opacity", 0 ).show();
      animateTo = 1;
    }

    // Anims - 1 opacity "toggles"
    for ( ; i < anims; i++ ) {
      element.animate( { opacity: animateTo }, duration, options.easing );
      animateTo = 1 - animateTo;
    }

    element.animate( { opacity: animateTo }, duration, options.easing );

    element.queue( done );

    $.effects.unshift( element, queuelen, anims + 1 );
  } );

  /* !
 * jQuery UI Effects Shake 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Shake Effect
  // >>group: Effects
  // >>description: Shakes an element horizontally or vertically n times.
  // >>docs: http://api.jqueryui.com/shake-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectShake = $.effects.define( "shake", function ( options, done ) {

    var i = 1,
      element = $( this ),
      direction = options.direction || "left",
      distance = options.distance || 20,
      times = options.times || 3,
      anims = times * 2 + 1,
      speed = Math.round( options.duration / anims ),
      ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
      positiveMotion = ( direction === "up" || direction === "left" ),
      animation = {},
      animation1 = {},
      animation2 = {},

      queuelen = element.queue().length;

    $.effects.createPlaceholder( element );

    // Animation
    animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
    animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
    animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

    // Animate
    element.animate( animation, speed, options.easing );

    // Shakes
    for ( ; i < times; i++ ) {
      element
        .animate( animation1, speed, options.easing )
        .animate( animation2, speed, options.easing );
    }

    element
      .animate( animation1, speed, options.easing )
      .animate( animation, speed / 2, options.easing )
      .queue( done );

    $.effects.unshift( element, queuelen, anims + 1 );
  } );

  /* !
 * jQuery UI Effects Slide 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Slide Effect
  // >>group: Effects
  // >>description: Slides an element in and out of the viewport.
  // >>docs: http://api.jqueryui.com/slide-effect/
  // >>demos: http://jqueryui.com/effect/

  var effectsEffectSlide = $.effects.define( "slide", "show", function ( options, done ) {
    var startClip, startRef,
      element = $( this ),
      map = {
        up: [ "bottom", "top" ],
        down: [ "top", "bottom" ],
        left: [ "right", "left" ],
        right: [ "left", "right" ]
      },
      mode = options.mode,
      direction = options.direction || "left",
      ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
      positiveMotion = ( direction === "up" || direction === "left" ),
      distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
      animation = {};

    $.effects.createPlaceholder( element );

    startClip = element.cssClip();
    startRef = element.position()[ ref ];

    // Define hide animation
    animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
    animation.clip = element.cssClip();
    animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

    // Reverse the animation if we're showing
    if ( mode === "show" ) {
      element.cssClip( animation.clip );
      element.css( ref, animation[ ref ] );
      animation.clip = startClip;
      animation[ ref ] = startRef;
    }

    // Actually animate
    element.animate( animation, {
      queue: false,
      duration: options.duration,
      easing: options.easing,
      complete: done
    } );
  } );

  /* !
 * jQuery UI Effects Transfer 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Transfer Effect
  // >>group: Effects
  // >>description: Displays a transfer effect from one element to another.
  // >>docs: http://api.jqueryui.com/transfer-effect/
  // >>demos: http://jqueryui.com/effect/

  var effect;
  if ( $.uiBackCompat !== false ) {
    effect = $.effects.define( "transfer", function ( options, done ) {
      $( this ).transfer( options, done );
    } );
  }
  var effectsEffectTransfer = effect;

  /* !
 * jQuery UI Focusable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: :focusable Selector
  // >>group: Core
  // >>description: Selects elements which can be focused.
  // >>docs: http://api.jqueryui.com/focusable-selector/

  // Selectors
  $.ui.focusable = function ( element, hasTabindex ) {
    var map, mapName, img, focusableIfVisible, fieldset,
      nodeName = element.nodeName.toLowerCase();

    if ( "area" === nodeName ) {
      map = element.parentNode;
      mapName = map.name;
      if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
        return false;
      }
      img = $( "img[usemap='#" + mapName + "']" );
      return img.length > 0 && img.is( ":visible" );
    }

    if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
      focusableIfVisible = !element.disabled;

      if ( focusableIfVisible ) {

        // Form controls within a disabled fieldset are disabled.
        // However, controls within the fieldset's legend do not get disabled.
        // Since controls generally aren't placed inside legends, we skip
        // this portion of the check.
        fieldset = $( element ).closest( "fieldset" )[ 0 ];
        if ( fieldset ) {
          focusableIfVisible = !fieldset.disabled;
        }
      }
    } else if ( "a" === nodeName ) {
      focusableIfVisible = element.href || hasTabindex;
    } else {
      focusableIfVisible = hasTabindex;
    }

    return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
  };

  // Support: IE 8 only
  // IE 8 doesn't resolve inherit to visible/hidden for computed values
  function visible( element ) {
    var visibility = element.css( "visibility" );
    while ( visibility === "inherit" ) {
      element = element.parent();
      visibility = element.css( "visibility" );
    }
    return visibility !== "hidden";
  }

  $.extend( $.expr[ ":" ], {
    focusable: function ( element ) {
      return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
    }
  } );

  var focusable = $.ui.focusable;

  // Support: IE8 Only
  // IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
  // with a string, so we need to find the proper form.
  var form = $.fn.form = function () {
    return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
  };

  /* !
 * jQuery UI Form Reset Mixin 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Form Reset Mixin
  // >>group: Core
  // >>description: Refresh input widgets when their form is reset
  // >>docs: http://api.jqueryui.com/form-reset-mixin/

  var formResetMixin = $.ui.formResetMixin = {
    _formResetHandler: function () {
      var form = $( this );

      // Wait for the form reset to actually happen before refreshing
      setTimeout( function () {
        var instances = form.data( "ui-form-reset-instances" );
        $.each( instances, function () {
          this.refresh();
        } );
      } );
    },

    _bindFormResetHandler: function () {
      this.form = this.element.form();
      if ( !this.form.length ) {
        return;
      }

      var instances = this.form.data( "ui-form-reset-instances" ) || [];
      if ( !instances.length ) {

        // We don't use _on() here because we use a single event handler per form
        this.form.on( "reset.ui-form-reset", this._formResetHandler );
      }
      instances.push( this );
      this.form.data( "ui-form-reset-instances", instances );
    },

    _unbindFormResetHandler: function () {
      if ( !this.form.length ) {
        return;
      }

      var instances = this.form.data( "ui-form-reset-instances" );
      instances.splice( $.inArray( this, instances ), 1 );
      if ( instances.length ) {
        this.form.data( "ui-form-reset-instances", instances );
      } else {
        this.form
          .removeData( "ui-form-reset-instances" )
          .off( "reset.ui-form-reset" );
      }
    }
  };

  /* !
 * jQuery UI Support for jQuery core 1.7.x 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 */

  // >>label: jQuery 1.7 Support
  // >>group: Core
  // >>description: Support version 1.7.x of jQuery core

  // Support: jQuery 1.7 only
  // Not a great way to check versions, but since we only support 1.7+ and only
  // need to detect <1.8, this is a simple check that should suffice. Checking
  // for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
  // and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
  // 1.7 anymore). See #11197 for why we're not using feature detection.
  if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {

    // Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
    // Unlike jQuery Core 1.8+, these only support numeric values to set the
    // dimensions in pixels
    $.each( [ "Width", "Height" ], function ( i, name ) {
      var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
        type = name.toLowerCase(),
        orig = {
          innerWidth: $.fn.innerWidth,
          innerHeight: $.fn.innerHeight,
          outerWidth: $.fn.outerWidth,
          outerHeight: $.fn.outerHeight
        };

      function reduce( elem, size, border, margin ) {
        $.each( side, function () {
          size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
          if ( border ) {
            size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
          }
          if ( margin ) {
            size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
          }
        } );
        return size;
      }

      $.fn[ "inner" + name ] = function ( size ) {
        if ( size === undefined ) {
          return orig[ "inner" + name ].call( this );
        }

        return this.each( function () {
          $( this ).css( type, reduce( this, size ) + "px" );
        } );
      };

      $.fn[ "outer" + name ] = function ( size, margin ) {
        if ( typeof size !== "number" ) {
          return orig[ "outer" + name ].call( this, size );
        }

        return this.each( function () {
          $( this ).css( type, reduce( this, size, true, margin ) + "px" );
        } );
      };
    } );

    $.fn.addBack = function ( selector ) {
      return this.add( selector == null ?
        this.prevObject : this.prevObject.filter( selector )
      );
    };
  }

  /* !
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Keycode
  // >>group: Core
  // >>description: Provide keycodes as keynames
  // >>docs: http://api.jqueryui.com/jQuery.ui.keyCode/

  var keycode = $.ui.keyCode = {
    BACKSPACE: 8,
    COMMA: 188,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    LEFT: 37,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SPACE: 32,
    TAB: 9,
    UP: 38
  };

  // Internal use only
  var escapeSelector = $.ui.escapeSelector = ( function () {
    var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
    return function ( selector ) {
      return selector.replace( selectorEscape, "\\$1" );
    };
  } )();

  /* !
 * jQuery UI Labels 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: labels
  // >>group: Core
  // >>description: Find all the labels associated with a given input
  // >>docs: http://api.jqueryui.com/labels/

  var labels = $.fn.labels = function () {
    var ancestor, selector, id, labels, ancestors;

    // Check control.labels first
    if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
      return this.pushStack( this[ 0 ].labels );
    }

    // Support: IE <= 11, FF <= 37, Android <= 2.3 only
    // Above browsers do not support control.labels. Everything below is to support them
    // as well as document fragments. control.labels does not work on document fragments
    labels = this.eq( 0 ).parents( "label" );

    // Look for the label based on the id
    id = this.attr( "id" );
    if ( id ) {

      // We don't search against the document in case the element
      // is disconnected from the DOM
      ancestor = this.eq( 0 ).parents().last();

      // Get a full set of top level ancestors
      ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

      // Create a selector for the label based on the id
      selector = "label[for='" + $.ui.escapeSelector( id ) + "']";

      labels = labels.add( ancestors.find( selector ).addBack( selector ) );

    }

    // Return whatever we have found for labels
    return this.pushStack( labels );
  };

  /* !
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: scrollParent
  // >>group: Core
  // >>description: Get the closest ancestor element that is scrollable.
  // >>docs: http://api.jqueryui.com/scrollParent/

  var scrollParent = $.fn.scrollParent = function ( includeHidden ) {
    var position = this.css( "position" ),
      excludeStaticParent = position === "absolute",
      overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
      scrollParent = this.parents().filter( function () {
        var parent = $( this );
        if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
          return false;
        }
        return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
      } ).eq( 0 );

    return position === "fixed" || !scrollParent.length ?
      $( this[ 0 ].ownerDocument || document ) :
      scrollParent;
  };

  /* !
 * jQuery UI Tabbable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: :tabbable Selector
  // >>group: Core
  // >>description: Selects elements which can be tabbed to.
  // >>docs: http://api.jqueryui.com/tabbable-selector/

  var tabbable = $.extend( $.expr[ ":" ], {
    tabbable: function ( element ) {
      var tabIndex = $.attr( element, "tabindex" ),
        hasTabindex = tabIndex != null;
      return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
    }
  } );

  /* !
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: uniqueId
  // >>group: Core
  // >>description: Functions to generate and remove uniqueId's
  // >>docs: http://api.jqueryui.com/uniqueId/

  var uniqueId = $.fn.extend( {
    uniqueId: ( function () {
      var uuid = 0;

      return function () {
        return this.each( function () {
          if ( !this.id ) {
            this.id = "ui-id-" + ( ++uuid );
          }
        } );
      };
    } )(),

    removeUniqueId: function () {
      return this.each( function () {
        if ( /^ui-id-\d+$/.test( this.id ) ) {
          $( this ).removeAttr( "id" );
        }
      } );
    }
  } );

  /* !
 * jQuery UI Accordion 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Accordion
  // >>group: Widgets
  // jscs:disable maximumLineLength
  // >>description: Displays collapsible content panels for presenting information in a limited amount of space.
  // jscs:enable maximumLineLength
  // >>docs: http://api.jqueryui.com/accordion/
  // >>demos: http://jqueryui.com/accordion/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/accordion.css
  // >>css.theme: ../../themes/base/theme.css

  var widgetsAccordion = $.widget( "ui.accordion", {
    version: "1.12.1",
    options: {
      active: 0,
      animate: {},
      classes: {
        "ui-accordion-header": "ui-corner-top",
        "ui-accordion-header-collapsed": "ui-corner-all",
        "ui-accordion-content": "ui-corner-bottom"
      },
      collapsible: false,
      event: "click",
      header: "> li > :first-child, > :not(li):even",
      heightStyle: "auto",
      icons: {
        activeHeader: "ui-icon-triangle-1-s",
        header: "ui-icon-triangle-1-e"
      },

      // Callbacks
      activate: null,
      beforeActivate: null
    },

    hideProps: {
      borderTopWidth: "hide",
      borderBottomWidth: "hide",
      paddingTop: "hide",
      paddingBottom: "hide",
      height: "hide"
    },

    showProps: {
      borderTopWidth: "show",
      borderBottomWidth: "show",
      paddingTop: "show",
      paddingBottom: "show",
      height: "show"
    },

    _create: function () {
      var options = this.options;

      this.prevShow = this.prevHide = $();
      this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
      this.element.attr( "role", "tablist" );

      // Don't allow collapsible: false and active: false / null
      if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
        options.active = 0;
      }

      this._processPanels();

      // handle negative values
      if ( options.active < 0 ) {
        options.active += this.headers.length;
      }
      this._refresh();
    },

    _getCreateEventData: function () {
      return {
        header: this.active,
        panel: !this.active.length ? $() : this.active.next()
      };
    },

    _createIcons: function () {
      var icon, children,
        icons = this.options.icons;

      if ( icons ) {
        icon = $( "<span>" );
        this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
        icon.prependTo( this.headers );
        children = this.active.children( ".ui-accordion-header-icon" );
        this._removeClass( children, icons.header )
          ._addClass( children, null, icons.activeHeader )
          ._addClass( this.headers, "ui-accordion-icons" );
      }
    },

    _destroyIcons: function () {
      this._removeClass( this.headers, "ui-accordion-icons" );
      this.headers.children( ".ui-accordion-header-icon" ).remove();
    },

    _destroy: function () {
      var contents;

      // Clean up main element
      this.element.removeAttr( "role" );

      // Clean up headers
      this.headers
        .removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
        .removeUniqueId();

      this._destroyIcons();

      // Clean up content panels
      contents = this.headers.next()
        .css( "display", "" )
        .removeAttr( "role aria-hidden aria-labelledby" )
        .removeUniqueId();

      if ( this.options.heightStyle !== "content" ) {
        contents.css( "height", "" );
      }
    },

    _setOption: function ( key, value ) {
      if ( key === "active" ) {

        // _activate() will handle invalid values and update this.options
        this._activate( value );
        return;
      }

      if ( key === "event" ) {
        if ( this.options.event ) {
          this._off( this.headers, this.options.event );
        }
        this._setupEvents( value );
      }

      this._super( key, value );

      // Setting collapsible: false while collapsed; open first panel
      if ( key === "collapsible" && !value && this.options.active === false ) {
        this._activate( 0 );
      }

      if ( key === "icons" ) {
        this._destroyIcons();
        if ( value ) {
          this._createIcons();
        }
      }
    },

    _setOptionDisabled: function ( value ) {
      this._super( value );

      this.element.attr( "aria-disabled", value );

      // Support: IE8 Only
      // #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
      // so we need to add the disabled class to the headers and panels
      this._toggleClass( null, "ui-state-disabled", !!value );
      this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
        !!value );
    },

    _keydown: function ( event ) {
      if ( event.altKey || event.ctrlKey ) {
        return;
      }

      var keyCode = $.ui.keyCode,
        length = this.headers.length,
        currentIndex = this.headers.index( event.target ),
        toFocus = false;

      switch ( event.keyCode ) {
        case keyCode.RIGHT:
        case keyCode.DOWN:
          toFocus = this.headers[ ( currentIndex + 1 ) % length ];
          break;
        case keyCode.LEFT:
        case keyCode.UP:
          toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
          break;
        case keyCode.SPACE:
        case keyCode.ENTER:
          this._eventHandler( event );
          break;
        case keyCode.HOME:
          toFocus = this.headers[ 0 ];
          break;
        case keyCode.END:
          toFocus = this.headers[ length - 1 ];
          break;
      }

      if ( toFocus ) {
        $( event.target ).attr( "tabIndex", -1 );
        $( toFocus ).attr( "tabIndex", 0 );
        $( toFocus ).trigger( "focus" );
        event.preventDefault();
      }
    },

    _panelKeyDown: function ( event ) {
      if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
        $( event.currentTarget ).prev().trigger( "focus" );
      }
    },

    refresh: function () {
      var options = this.options;
      this._processPanels();

      // Was collapsed or no panel
      if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
        options.active = false;
        this.active = $();

        // active false only when collapsible is true
      } else if ( options.active === false ) {
        this._activate( 0 );

        // was active, but active panel is gone
      } else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

        // all remaining panel are disabled
        if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
          options.active = false;
          this.active = $();

          // activate previous panel
        } else {
          this._activate( Math.max( 0, options.active - 1 ) );
        }

        // was active, active panel still exists
      } else {

        // make sure active index is correct
        options.active = this.headers.index( this.active );
      }

      this._destroyIcons();

      this._refresh();
    },

    _processPanels: function () {
      var prevHeaders = this.headers,
        prevPanels = this.panels;

      this.headers = this.element.find( this.options.header );
      this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
        "ui-state-default" );

      this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
      this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

      // Avoid memory leaks (#10056)
      if ( prevPanels ) {
        this._off( prevHeaders.not( this.headers ) );
        this._off( prevPanels.not( this.panels ) );
      }
    },

    _refresh: function () {
      var maxHeight,
        options = this.options,
        heightStyle = options.heightStyle,
        parent = this.element.parent();

      this.active = this._findActive( options.active );
      this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
        ._removeClass( this.active, "ui-accordion-header-collapsed" );
      this._addClass( this.active.next(), "ui-accordion-content-active" );
      this.active.next().show();

      this.headers
        .attr( "role", "tab" )
        .each( function () {
          var header = $( this ),
            headerId = header.uniqueId().attr( "id" ),
            panel = header.next(),
            panelId = panel.uniqueId().attr( "id" );
          header.attr( "aria-controls", panelId );
          panel.attr( "aria-labelledby", headerId );
        } )
        .next()
        .attr( "role", "tabpanel" );

      this.headers
        .not( this.active )
        .attr( {
          "aria-selected": "false",
          "aria-expanded": "false",
          tabIndex: -1
        } )
        .next()
        .attr( {
          "aria-hidden": "true"
        } )
        .hide();

      // Make sure at least one header is in the tab order
      if ( !this.active.length ) {
        this.headers.eq( 0 ).attr( "tabIndex", 0 );
      } else {
        this.active.attr( {
          "aria-selected": "true",
          "aria-expanded": "true",
          tabIndex: 0
        } )
          .next()
          .attr( {
            "aria-hidden": "false"
          } );
      }

      this._createIcons();

      this._setupEvents( options.event );

      if ( heightStyle === "fill" ) {
        maxHeight = parent.height();
        this.element.siblings( ":visible" ).each( function () {
          var elem = $( this ),
            position = elem.css( "position" );

          if ( position === "absolute" || position === "fixed" ) {
            return;
          }
          maxHeight -= elem.outerHeight( true );
        } );

        this.headers.each( function () {
          maxHeight -= $( this ).outerHeight( true );
        } );

        this.headers.next()
          .each( function () {
            $( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
          } )
          .css( "overflow", "auto" );
      } else if ( heightStyle === "auto" ) {
        maxHeight = 0;
        this.headers.next()
          .each( function () {
            var isVisible = $( this ).is( ":visible" );
            if ( !isVisible ) {
              $( this ).show();
            }
            maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
            if ( !isVisible ) {
              $( this ).hide();
            }
          } )
          .height( maxHeight );
      }
    },

    _activate: function ( index ) {
      var active = this._findActive( index )[ 0 ];

      // Trying to activate the already active panel
      if ( active === this.active[ 0 ] ) {
        return;
      }

      // Trying to collapse, simulate a click on the currently active header
      active = active || this.active[ 0 ];

      this._eventHandler( {
        target: active,
        currentTarget: active,
        preventDefault: $.noop
      } );
    },

    _findActive: function ( selector ) {
      return typeof selector === "number" ? this.headers.eq( selector ) : $();
    },

    _setupEvents: function ( event ) {
      var events = {
        keydown: "_keydown"
      };
      if ( event ) {
        $.each( event.split( " " ), function ( index, eventName ) {
          events[ eventName ] = "_eventHandler";
        } );
      }

      this._off( this.headers.add( this.headers.next() ) );
      this._on( this.headers, events );
      this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
      this._hoverable( this.headers );
      this._focusable( this.headers );
    },

    _eventHandler: function ( event ) {
      var activeChildren, clickedChildren,
        options = this.options,
        active = this.active,
        clicked = $( event.currentTarget ),
        clickedIsActive = clicked[ 0 ] === active[ 0 ],
        collapsing = clickedIsActive && options.collapsible,
        toShow = collapsing ? $() : clicked.next(),
        toHide = active.next(),
        eventData = {
          oldHeader: active,
          oldPanel: toHide,
          newHeader: collapsing ? $() : clicked,
          newPanel: toShow
        };

      event.preventDefault();

      if (

      // click on active header, but not collapsible
        ( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
        return;
      }

      options.active = collapsing ? false : this.headers.index( clicked );

      // When the call to ._toggle() comes after the class changes
      // it causes a very odd bug in IE 8 (see #6720)
      this.active = clickedIsActive ? $() : clicked;
      this._toggle( eventData );

      // Switch classes
      // corner classes on the previously active header stay after the animation
      this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
      if ( options.icons ) {
        activeChildren = active.children( ".ui-accordion-header-icon" );
        this._removeClass( activeChildren, null, options.icons.activeHeader )
          ._addClass( activeChildren, null, options.icons.header );
      }

      if ( !clickedIsActive ) {
        this._removeClass( clicked, "ui-accordion-header-collapsed" )
          ._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
        if ( options.icons ) {
          clickedChildren = clicked.children( ".ui-accordion-header-icon" );
          this._removeClass( clickedChildren, null, options.icons.header )
            ._addClass( clickedChildren, null, options.icons.activeHeader );
        }

        this._addClass( clicked.next(), "ui-accordion-content-active" );
      }
    },

    _toggle: function ( data ) {
      var toShow = data.newPanel,
        toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

      // Handle activating a panel during the animation for another activation
      this.prevShow.add( this.prevHide ).stop( true, true );
      this.prevShow = toShow;
      this.prevHide = toHide;

      if ( this.options.animate ) {
        this._animate( toShow, toHide, data );
      } else {
        toHide.hide();
        toShow.show();
        this._toggleComplete( data );
      }

      toHide.attr( {
        "aria-hidden": "true"
      } );
      toHide.prev().attr( {
        "aria-selected": "false",
        "aria-expanded": "false"
      } );

      // if we're switching panels, remove the old header from the tab order
      // if we're opening from collapsed state, remove the previous header from the tab order
      // if we're collapsing, then keep the collapsing header in the tab order
      if ( toShow.length && toHide.length ) {
        toHide.prev().attr( {
          "tabIndex": -1,
          "aria-expanded": "false"
        } );
      } else if ( toShow.length ) {
        this.headers.filter( function () {
          return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
        } )
          .attr( "tabIndex", -1 );
      }

      toShow
        .attr( "aria-hidden", "false" )
        .prev()
        .attr( {
          "aria-selected": "true",
          "aria-expanded": "true",
          tabIndex: 0
        } );
    },

    _animate: function ( toShow, toHide, data ) {
      var total, easing, duration,
        that = this,
        adjust = 0,
        boxSizing = toShow.css( "box-sizing" ),
        down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
        animate = this.options.animate || {},
        options = down && animate.down || animate,
        complete = function () {
          that._toggleComplete( data );
        };

      if ( typeof options === "number" ) {
        duration = options;
      }
      if ( typeof options === "string" ) {
        easing = options;
      }

      // fall back from options to animation in case of partial down settings
      easing = easing || options.easing || animate.easing;
      duration = duration || options.duration || animate.duration;

      if ( !toHide.length ) {
        return toShow.animate( this.showProps, duration, easing, complete );
      }
      if ( !toShow.length ) {
        return toHide.animate( this.hideProps, duration, easing, complete );
      }

      total = toShow.show().outerHeight();
      toHide.animate( this.hideProps, {
        duration: duration,
        easing: easing,
        step: function ( now, fx ) {
          fx.now = Math.round( now );
        }
      } );
      toShow
        .hide()
        .animate( this.showProps, {
          duration: duration,
          easing: easing,
          complete: complete,
          step: function ( now, fx ) {
            fx.now = Math.round( now );
            if ( fx.prop !== "height" ) {
              if ( boxSizing === "content-box" ) {
                adjust += fx.now;
              }
            } else if ( that.options.heightStyle !== "content" ) {
              fx.now = Math.round( total - toHide.outerHeight() - adjust );
              adjust = 0;
            }
          }
        } );
    },

    _toggleComplete: function ( data ) {
      var toHide = data.oldPanel,
        prev = toHide.prev();

      this._removeClass( toHide, "ui-accordion-content-active" );
      this._removeClass( prev, "ui-accordion-header-active" )
        ._addClass( prev, "ui-accordion-header-collapsed" );

      // Work around for rendering bug in IE (#5421)
      if ( toHide.length ) {
        toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
      }
      this._trigger( "activate", null, data );
    }
  } );

  var safeActiveElement = $.ui.safeActiveElement = function ( document ) {
    var activeElement;

    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
      activeElement = document.activeElement;
    } catch ( error ) {
      activeElement = document.body;
    }

    // Support: IE 9 - 11 only
    // IE may return null instead of an element
    // Interestingly, this only seems to occur when NOT in an iframe
    if ( !activeElement ) {
      activeElement = document.body;
    }

    // Support: IE 11 only
    // IE11 returns a seemingly empty object in some cases when accessing
    // document.activeElement from an <iframe>
    if ( !activeElement.nodeName ) {
      activeElement = document.body;
    }

    return activeElement;
  };

  /* !
 * jQuery UI Menu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Menu
  // >>group: Widgets
  // >>description: Creates nestable menus.
  // >>docs: http://api.jqueryui.com/menu/
  // >>demos: http://jqueryui.com/menu/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/menu.css
  // >>css.theme: ../../themes/base/theme.css

  var widgetsMenu = $.widget( "ui.menu", {
    version: "1.12.1",
    defaultElement: "<ul>",
    delay: 300,
    options: {
      icons: {
        submenu: "ui-icon-caret-1-e"
      },
      items: "> *",
      menus: "ul",
      position: {
        my: "left top",
        at: "right top"
      },
      role: "menu",

      // Callbacks
      blur: null,
      focus: null,
      select: null
    },

    _create: function () {
      this.activeMenu = this.element;

      // Flag used to prevent firing of the click handler
      // as the event bubbles up through nested menus
      this.mouseHandled = false;
      this.element
        .uniqueId()
        .attr( {
          role: this.options.role,
          tabIndex: 0
        } );

      this._addClass( "ui-menu", "ui-widget ui-widget-content" );
      this._on( {

        // Prevent focus from sticking to links inside menu after clicking
        // them (focus should always stay on UL during navigation).
        "mousedown .ui-menu-item": function ( event ) {
          event.preventDefault();
        },
        "click .ui-menu-item": function ( event ) {
          var target = $( event.target );
          var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
          if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
            this.select( event );

            // Only set the mouseHandled flag if the event will bubble, see #9469.
            if ( !event.isPropagationStopped() ) {
              this.mouseHandled = true;
            }

            // Open submenu on click
            if ( target.has( ".ui-menu" ).length ) {
              this.expand( event );
            } else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

              // Redirect focus to the menu
              this.element.trigger( "focus", [ true ] );

              // If the active item is on the top level, let it stay active.
              // Otherwise, blur the active item since it is no longer visible.
              if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
                clearTimeout( this.timer );
              }
            }
          }
        },
        "mouseenter .ui-menu-item": function ( event ) {

          // Ignore mouse events while typeahead is active, see #10458.
          // Prevents focusing the wrong item when typeahead causes a scroll while the mouse
          // is over an item in the menu
          if ( this.previousFilter ) {
            return;
          }

          var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
            target = $( event.currentTarget );

          // Ignore bubbled events on parent items, see #11641
          if ( actualTarget[ 0 ] !== target[ 0 ] ) {
            return;
          }

          // Remove ui-state-active class from siblings of the newly focused menu item
          // to avoid a jump caused by adjacent elements both having a class with a border
          this._removeClass( target.siblings().children( ".ui-state-active" ),
            null, "ui-state-active" );
          this.focus( event, target );
        },
        mouseleave: "collapseAll",
        "mouseleave .ui-menu": "collapseAll",
        focus: function ( event, keepActiveItem ) {

          // If there's already an active item, keep it active
          // If not, activate the first item
          var item = this.active || this.element.find( this.options.items ).eq( 0 );

          if ( !keepActiveItem ) {
            this.focus( event, item );
          }
        },
        blur: function ( event ) {
          this._delay( function () {
            var notContained = !$.contains(
              this.element[ 0 ],
              $.ui.safeActiveElement( this.document[ 0 ] )
            );
            if ( notContained ) {
              this.collapseAll( event );
            }
          } );
        },
        keydown: "_keydown"
      } );

      this.refresh();

      // Clicks outside of a menu collapse any open menus
      this._on( this.document, {
        click: function ( event ) {
          if ( this._closeOnDocumentClick( event ) ) {
            this.collapseAll( event );
          }

          // Reset the mouseHandled flag
          this.mouseHandled = false;
        }
      } );
    },

    _destroy: function () {
      var items = this.element.find( ".ui-menu-item" )
          .removeAttr( "role aria-disabled" ),
        submenus = items.children( ".ui-menu-item-wrapper" )
          .removeUniqueId()
          .removeAttr( "tabIndex role aria-haspopup" );

      // Destroy (sub)menus
      this.element
        .removeAttr( "aria-activedescendant" )
        .find( ".ui-menu" ).addBack()
        .removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
        .removeUniqueId()
        .show();

      submenus.children().each( function () {
        var elem = $( this );
        if ( elem.data( "ui-menu-submenu-caret" ) ) {
          elem.remove();
        }
      } );
    },

    _keydown: function ( event ) {
      var match, prev, character, skip,
        preventDefault = true;

      switch ( event.keyCode ) {
        case $.ui.keyCode.PAGE_UP:
          this.previousPage( event );
          break;
        case $.ui.keyCode.PAGE_DOWN:
          this.nextPage( event );
          break;
        case $.ui.keyCode.HOME:
          this._move( "first", "first", event );
          break;
        case $.ui.keyCode.END:
          this._move( "last", "last", event );
          break;
        case $.ui.keyCode.UP:
          this.previous( event );
          break;
        case $.ui.keyCode.DOWN:
          this.next( event );
          break;
        case $.ui.keyCode.LEFT:
          this.collapse( event );
          break;
        case $.ui.keyCode.RIGHT:
          if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
            this.expand( event );
          }
          break;
        case $.ui.keyCode.ENTER:
        case $.ui.keyCode.SPACE:
          this._activate( event );
          break;
        case $.ui.keyCode.ESCAPE:
          this.collapse( event );
          break;
        default:
          preventDefault = false;
          prev = this.previousFilter || "";
          skip = false;

          // Support number pad values
          character = event.keyCode >= 96 && event.keyCode <= 105 ?
            ( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

          clearTimeout( this.filterTimer );

          if ( character === prev ) {
            skip = true;
          } else {
            character = prev + character;
          }

          match = this._filterMenuItems( character );
          match = skip && match.index( this.active.next() ) !== -1 ?
            this.active.nextAll( ".ui-menu-item" ) :
            match;

          // If no matches on the current filter, reset to the last character pressed
          // to move down the menu to the first item that starts with that character
          if ( !match.length ) {
            character = String.fromCharCode( event.keyCode );
            match = this._filterMenuItems( character );
          }

          if ( match.length ) {
            this.focus( event, match );
            this.previousFilter = character;
            this.filterTimer = this._delay( function () {
              delete this.previousFilter;
            }, 1000 );
          } else {
            delete this.previousFilter;
          }
      }

      if ( preventDefault ) {
        event.preventDefault();
      }
    },

    _activate: function ( event ) {
      if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
        if ( this.active.children( "[aria-haspopup='true']" ).length ) {
          this.expand( event );
        } else {
          this.select( event );
        }
      }
    },

    refresh: function () {
      var menus, items, newSubmenus, newItems, newWrappers,
        that = this,
        icon = this.options.icons.submenu,
        submenus = this.element.find( this.options.menus );

      this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

      // Initialize nested menus
      newSubmenus = submenus.filter( ":not(.ui-menu)" )
        .hide()
        .attr( {
          role: this.options.role,
          "aria-hidden": "true",
          "aria-expanded": "false"
        } )
        .each( function () {
          var menu = $( this ),
            item = menu.prev(),
            submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

          that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
          item
            .attr( "aria-haspopup", "true" )
            .prepend( submenuCaret );
          menu.attr( "aria-labelledby", item.attr( "id" ) );
        } );

      this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

      menus = submenus.add( this.element );
      items = menus.find( this.options.items );

      // Initialize menu-items containing spaces and/or dashes only as dividers
      items.not( ".ui-menu-item" ).each( function () {
        var item = $( this );
        if ( that._isDivider( item ) ) {
          that._addClass( item, "ui-menu-divider", "ui-widget-content" );
        }
      } );

      // Don't refresh list items that are already adapted
      newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
      newWrappers = newItems.children()
        .not( ".ui-menu" )
        .uniqueId()
        .attr( {
          tabIndex: -1,
          role: this._itemRole()
        } );
      this._addClass( newItems, "ui-menu-item" )
        ._addClass( newWrappers, "ui-menu-item-wrapper" );

      // Add aria-disabled attribute to any disabled menu item
      items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

      // If the active item has been removed, blur the menu
      if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
        this.blur();
      }
    },

    _itemRole: function () {
      return {
        menu: "menuitem",
        listbox: "option"
      }[ this.options.role ];
    },

    _setOption: function ( key, value ) {
      if ( key === "icons" ) {
        var icons = this.element.find( ".ui-menu-icon" );
        this._removeClass( icons, null, this.options.icons.submenu )
          ._addClass( icons, null, value.submenu );
      }
      this._super( key, value );
    },

    _setOptionDisabled: function ( value ) {
      this._super( value );

      this.element.attr( "aria-disabled", String( value ) );
      this._toggleClass( null, "ui-state-disabled", !!value );
    },

    focus: function ( event, item ) {
      var nested, focused, activeParent;
      this.blur( event, event && event.type === "focus" );

      this._scrollIntoView( item );

      this.active = item.first();

      focused = this.active.children( ".ui-menu-item-wrapper" );
      this._addClass( focused, null, "ui-state-active" );

      // Only update aria-activedescendant if there's a role
      // otherwise we assume focus is managed elsewhere
      if ( this.options.role ) {
        this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
      }

      // Highlight active parent menu item, if any
      activeParent = this.active
        .parent()
        .closest( ".ui-menu-item" )
        .children( ".ui-menu-item-wrapper" );
      this._addClass( activeParent, null, "ui-state-active" );

      if ( event && event.type === "keydown" ) {
        this._close();
      } else {
        this.timer = this._delay( function () {
          this._close();
        }, this.delay );
      }

      nested = item.children( ".ui-menu" );
      if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
        this._startOpening( nested );
      }
      this.activeMenu = item.parent();

      this._trigger( "focus", event, { item: item } );
    },

    _scrollIntoView: function ( item ) {
      var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
      if ( this._hasScroll() ) {
        borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
        paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
        offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
        scroll = this.activeMenu.scrollTop();
        elementHeight = this.activeMenu.height();
        itemHeight = item.outerHeight();

        if ( offset < 0 ) {
          this.activeMenu.scrollTop( scroll + offset );
        } else if ( offset + itemHeight > elementHeight ) {
          this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
        }
      }
    },

    blur: function ( event, fromFocus ) {
      if ( !fromFocus ) {
        clearTimeout( this.timer );
      }

      if ( !this.active ) {
        return;
      }

      this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
        null, "ui-state-active" );

      this._trigger( "blur", event, { item: this.active } );
      this.active = null;
    },

    _startOpening: function ( submenu ) {
      clearTimeout( this.timer );

      // Don't open if already open fixes a Firefox bug that caused a .5 pixel
      // shift in the submenu position when mousing over the caret icon
      if ( submenu.attr( "aria-hidden" ) !== "true" ) {
        return;
      }

      this.timer = this._delay( function () {
        this._close();
        this._open( submenu );
      }, this.delay );
    },

    _open: function ( submenu ) {
      var position = $.extend( {
        of: this.active
      }, this.options.position );

      clearTimeout( this.timer );
      this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
        .hide()
        .attr( "aria-hidden", "true" );

      submenu
        .show()
        .removeAttr( "aria-hidden" )
        .attr( "aria-expanded", "true" )
        .position( position );
    },

    collapseAll: function ( event, all ) {
      clearTimeout( this.timer );
      this.timer = this._delay( function () {

        // If we were passed an event, look for the submenu that contains the event
        var currentMenu = all ? this.element :
          $( event && event.target ).closest( this.element.find( ".ui-menu" ) );

        // If we found no valid submenu ancestor, use the main menu to close all
        // sub menus anyway
        if ( !currentMenu.length ) {
          currentMenu = this.element;
        }

        this._close( currentMenu );

        this.blur( event );

        // Work around active item staying active after menu is blurred
        this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

        this.activeMenu = currentMenu;
      }, this.delay );
    },

    // With no arguments, closes the currently active menu - if nothing is active
    // it closes all menus.  If passed an argument, it will search for menus BELOW
    _close: function ( startMenu ) {
      if ( !startMenu ) {
        startMenu = this.active ? this.active.parent() : this.element;
      }

      startMenu.find( ".ui-menu" )
        .hide()
        .attr( "aria-hidden", "true" )
        .attr( "aria-expanded", "false" );
    },

    _closeOnDocumentClick: function ( event ) {
      return !$( event.target ).closest( ".ui-menu" ).length;
    },

    _isDivider: function ( item ) {

      // Match hyphen, em dash, en dash
      return !/[^\-\u2014\u2013\s]/.test( item.text() );
    },

    collapse: function ( event ) {
      var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
      if ( newItem && newItem.length ) {
        this._close();
        this.focus( event, newItem );
      }
    },

    expand: function ( event ) {
      var newItem = this.active &&
			this.active
			  .children( ".ui-menu " )
			  .find( this.options.items )
			  .first();

      if ( newItem && newItem.length ) {
        this._open( newItem.parent() );

        // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
        this._delay( function () {
          this.focus( event, newItem );
        } );
      }
    },

    next: function ( event ) {
      this._move( "next", "first", event );
    },

    previous: function ( event ) {
      this._move( "prev", "last", event );
    },

    isFirstItem: function () {
      return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
    },

    isLastItem: function () {
      return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
    },

    _move: function ( direction, filter, event ) {
      var next;
      if ( this.active ) {
        if ( direction === "first" || direction === "last" ) {
          next = this.active
            [ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
            .eq( -1 );
        } else {
          next = this.active
            [ direction + "All" ]( ".ui-menu-item" )
            .eq( 0 );
        }
      }
      if ( !next || !next.length || !this.active ) {
        next = this.activeMenu.find( this.options.items )[ filter ]();
      }

      this.focus( event, next );
    },

    nextPage: function ( event ) {
      var item, base, height;

      if ( !this.active ) {
        this.next( event );
        return;
      }
      if ( this.isLastItem() ) {
        return;
      }
      if ( this._hasScroll() ) {
        base = this.active.offset().top;
        height = this.element.height();
        this.active.nextAll( ".ui-menu-item" ).each( function () {
          item = $( this );
          return item.offset().top - base - height < 0;
        } );

        this.focus( event, item );
      } else {
        this.focus( event, this.activeMenu.find( this.options.items )
          [ !this.active ? "first" : "last" ]() );
      }
    },

    previousPage: function ( event ) {
      var item, base, height;
      if ( !this.active ) {
        this.next( event );
        return;
      }
      if ( this.isFirstItem() ) {
        return;
      }
      if ( this._hasScroll() ) {
        base = this.active.offset().top;
        height = this.element.height();
        this.active.prevAll( ".ui-menu-item" ).each( function () {
          item = $( this );
          return item.offset().top - base + height > 0;
        } );

        this.focus( event, item );
      } else {
        this.focus( event, this.activeMenu.find( this.options.items ).first() );
      }
    },

    _hasScroll: function () {
      return this.element.outerHeight() < this.element.prop( "scrollHeight" );
    },

    select: function ( event ) {

      // TODO: It should never be possible to not have an active item at this
      // point, but the tests don't trigger mouseenter before click.
      this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
      var ui = { item: this.active };
      if ( !this.active.has( ".ui-menu" ).length ) {
        this.collapseAll( event, true );
      }
      this._trigger( "select", event, ui );
    },

    _filterMenuItems: function ( character ) {
      var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
        regex = new RegExp( "^" + escapedCharacter, "i" );

      return this.activeMenu
        .find( this.options.items )

      // Only match on items, not dividers or other content (#10571)
        .filter( ".ui-menu-item" )
        .filter( function () {
          return regex.test(
            $.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
        } );
    }
  } );

  /* !
 * jQuery UI Autocomplete 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Autocomplete
  // >>group: Widgets
  // >>description: Lists suggested words as the user is typing.
  // >>docs: http://api.jqueryui.com/autocomplete/
  // >>demos: http://jqueryui.com/autocomplete/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/autocomplete.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.autocomplete", {
    version: "1.12.1",
    defaultElement: "<input>",
    options: {
      appendTo: null,
      autoFocus: false,
      delay: 300,
      minLength: 1,
      position: {
        my: "left top",
        at: "left bottom",
        collision: "none"
      },
      source: null,

      // Callbacks
      change: null,
      close: null,
      focus: null,
      open: null,
      response: null,
      search: null,
      select: null
    },

    requestIndex: 0,
    pending: 0,

    _create: function () {

      // Some browsers only repeat keydown events, not keypress events,
      // so we use the suppressKeyPress flag to determine if we've already
      // handled the keydown event. #7269
      // Unfortunately the code for & in keypress is the same as the up arrow,
      // so we use the suppressKeyPressRepeat flag to avoid handling keypress
      // events when we know the keydown event was used to modify the
      // search term. #7799
      var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
        nodeName = this.element[ 0 ].nodeName.toLowerCase(),
        isTextarea = nodeName === "textarea",
        isInput = nodeName === "input";

      // Textareas are always multi-line
      // Inputs are always single-line, even if inside a contentEditable element
      // IE also treats inputs as contentEditable
      // All other element types are determined by whether or not they're contentEditable
      this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );

      this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
      this.isNewMenu = true;

      this._addClass( "ui-autocomplete-input" );
      this.element.attr( "autocomplete", "off" );

      this._on( this.element, {
        keydown: function ( event ) {
          if ( this.element.prop( "readOnly" ) ) {
            suppressKeyPress = true;
            suppressInput = true;
            suppressKeyPressRepeat = true;
            return;
          }

          suppressKeyPress = false;
          suppressInput = false;
          suppressKeyPressRepeat = false;
          var keyCode = $.ui.keyCode;
          switch ( event.keyCode ) {
            case keyCode.PAGE_UP:
              suppressKeyPress = true;
              this._move( "previousPage", event );
              break;
            case keyCode.PAGE_DOWN:
              suppressKeyPress = true;
              this._move( "nextPage", event );
              break;
            case keyCode.UP:
              suppressKeyPress = true;
              this._keyEvent( "previous", event );
              break;
            case keyCode.DOWN:
              suppressKeyPress = true;
              this._keyEvent( "next", event );
              break;
            case keyCode.ENTER:

              // when menu is open and has focus
              if ( this.menu.active ) {

                // #6055 - Opera still allows the keypress to occur
                // which causes forms to submit
                suppressKeyPress = true;
                event.preventDefault();
                this.menu.select( event );
              }
              break;
            case keyCode.TAB:
              if ( this.menu.active ) {
                this.menu.select( event );
              }
              break;
            case keyCode.ESCAPE:
              if ( this.menu.element.is( ":visible" ) ) {
                if ( !this.isMultiLine ) {
                  this._value( this.term );
                }
                this.close( event );

                // Different browsers have different default behavior for escape
                // Single press can mean undo or clear
                // Double press in IE means clear the whole form
                event.preventDefault();
              }
              break;
            default:
              suppressKeyPressRepeat = true;

              // search timeout should be triggered before the input value is changed
              this._searchTimeout( event );
              break;
          }
        },
        keypress: function ( event ) {
          if ( suppressKeyPress ) {
            suppressKeyPress = false;
            if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
              event.preventDefault();
            }
            return;
          }
          if ( suppressKeyPressRepeat ) {
            return;
          }

          // Replicate some key handlers to allow them to repeat in Firefox and Opera
          var keyCode = $.ui.keyCode;
          switch ( event.keyCode ) {
            case keyCode.PAGE_UP:
              this._move( "previousPage", event );
              break;
            case keyCode.PAGE_DOWN:
              this._move( "nextPage", event );
              break;
            case keyCode.UP:
              this._keyEvent( "previous", event );
              break;
            case keyCode.DOWN:
              this._keyEvent( "next", event );
              break;
          }
        },
        input: function ( event ) {
          if ( suppressInput ) {
            suppressInput = false;
            event.preventDefault();
            return;
          }
          this._searchTimeout( event );
        },
        focus: function () {
          this.selectedItem = null;
          this.previous = this._value();
        },
        blur: function ( event ) {
          if ( this.cancelBlur ) {
            delete this.cancelBlur;
            return;
          }

          clearTimeout( this.searching );
          this.close( event );
          this._change( event );
        }
      } );

      this._initSource();
      this.menu = $( "<ul>" )
        .appendTo( this._appendTo() )
        .menu( {

          // disable ARIA support, the live region takes care of that
          role: null
        } )
        .hide()
        .menu( "instance" );

      this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
      this._on( this.menu.element, {
        mousedown: function ( event ) {

          // prevent moving focus out of the text field
          event.preventDefault();

          // IE doesn't prevent moving focus even with event.preventDefault()
          // so we set a flag to know when we should ignore the blur event
          this.cancelBlur = true;
          this._delay( function () {
            delete this.cancelBlur;

            // Support: IE 8 only
            // Right clicking a menu item or selecting text from the menu items will
            // result in focus moving out of the input. However, we've already received
            // and ignored the blur event because of the cancelBlur flag set above. So
            // we restore focus to ensure that the menu closes properly based on the user's
            // next actions.
            if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
              this.element.trigger( "focus" );
            }
          } );
        },
        menufocus: function ( event, ui ) {
          var label, item;

          // support: Firefox
          // Prevent accidental activation of menu items in Firefox (#7024 #9118)
          if ( this.isNewMenu ) {
            this.isNewMenu = false;
            if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
              this.menu.blur();

              this.document.one( "mousemove", function () {
                $( event.target ).trigger( event.originalEvent );
              } );

              return;
            }
          }

          item = ui.item.data( "ui-autocomplete-item" );
          if ( false !== this._trigger( "focus", event, { item: item } ) ) {

            // use value to match what will end up in the input, if it was a key event
            if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
              this._value( item.value );
            }
          }

          // Announce the value in the liveRegion
          label = ui.item.attr( "aria-label" ) || item.value;
          if ( label && $.trim( label ).length ) {
            this.liveRegion.children().hide();
            $( "<div>" ).text( label ).appendTo( this.liveRegion );
          }
        },
        menuselect: function ( event, ui ) {
          var item = ui.item.data( "ui-autocomplete-item" ),
            previous = this.previous;

          // Only trigger when focus was lost (click on menu)
          if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
            this.element.trigger( "focus" );
            this.previous = previous;

            // #6109 - IE triggers two focus events and the second
            // is asynchronous, so we need to reset the previous
            // term synchronously and asynchronously :-(
            this._delay( function () {
              this.previous = previous;
              this.selectedItem = item;
            } );
          }

          if ( false !== this._trigger( "select", event, { item: item } ) ) {
            this._value( item.value );
          }

          // reset the term after the select event
          // this allows custom select handling to work properly
          this.term = this._value();

          this.close( event );
          this.selectedItem = item;
        }
      } );

      this.liveRegion = $( "<div>", {
        role: "status",
        "aria-live": "assertive",
        "aria-relevant": "additions"
      } )
        .appendTo( this.document[ 0 ].body );

      this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

      // Turning off autocomplete prevents the browser from remembering the
      // value when navigating through history, so we re-enable autocomplete
      // if the page is unloaded before the widget is destroyed. #7790
      this._on( this.window, {
        beforeunload: function () {
          this.element.removeAttr( "autocomplete" );
        }
      } );
    },

    _destroy: function () {
      clearTimeout( this.searching );
      this.element.removeAttr( "autocomplete" );
      this.menu.element.remove();
      this.liveRegion.remove();
    },

    _setOption: function ( key, value ) {
      this._super( key, value );
      if ( key === "source" ) {
        this._initSource();
      }
      if ( key === "appendTo" ) {
        this.menu.element.appendTo( this._appendTo() );
      }
      if ( key === "disabled" && value && this.xhr ) {
        this.xhr.abort();
      }
    },

    _isEventTargetInWidget: function ( event ) {
      var menuElement = this.menu.element[ 0 ];

      return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
    },

    _closeOnClickOutside: function ( event ) {
      if ( !this._isEventTargetInWidget( event ) ) {
        this.close();
      }
    },

    _appendTo: function () {
      var element = this.options.appendTo;

      if ( element ) {
        element = element.jquery || element.nodeType ?
          $( element ) :
          this.document.find( element ).eq( 0 );
      }

      if ( !element || !element[ 0 ] ) {
        element = this.element.closest( ".ui-front, dialog" );
      }

      if ( !element.length ) {
        element = this.document[ 0 ].body;
      }

      return element;
    },

    _initSource: function () {
      var array, url,
        that = this;
      if ( $.isArray( this.options.source ) ) {
        array = this.options.source;
        this.source = function ( request, response ) {
          response( $.ui.autocomplete.filter( array, request.term ) );
        };
      } else if ( typeof this.options.source === "string" ) {
        url = this.options.source;
        this.source = function ( request, response ) {
          if ( that.xhr ) {
            that.xhr.abort();
          }
          that.xhr = $.ajax( {
            url: url,
            data: request,
            dataType: "json",
            success: function ( data ) {
              response( data );
            },
            error: function () {
              response( [] );
            }
          } );
        };
      } else {
        this.source = this.options.source;
      }
    },

    _searchTimeout: function ( event ) {
      clearTimeout( this.searching );
      this.searching = this._delay( function () {

        // Search if the value has changed, or if the user retypes the same value (see #7434)
        var equalValues = this.term === this._value(),
          menuVisible = this.menu.element.is( ":visible" ),
          modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

        if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
          this.selectedItem = null;
          this.search( null, event );
        }
      }, this.options.delay );
    },

    search: function ( value, event ) {
      value = value != null ? value : this._value();

      // Always save the actual value, not the one passed as an argument
      this.term = this._value();

      if ( value.length < this.options.minLength ) {
        return this.close( event );
      }

      if ( this._trigger( "search", event ) === false ) {
        return;
      }

      return this._search( value );
    },

    _search: function ( value ) {
      this.pending++;
      this._addClass( "ui-autocomplete-loading" );
      this.cancelSearch = false;

      this.source( { term: value }, this._response() );
    },

    _response: function () {
      var index = ++this.requestIndex;

      return $.proxy( function ( content ) {
        if ( index === this.requestIndex ) {
          this.__response( content );
        }

        this.pending--;
        if ( !this.pending ) {
          this._removeClass( "ui-autocomplete-loading" );
        }
      }, this );
    },

    __response: function ( content ) {
      if ( content ) {
        content = this._normalize( content );
      }
      this._trigger( "response", null, { content: content } );
      if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
        this._suggest( content );
        this._trigger( "open" );
      } else {

        // use ._close() instead of .close() so we don't cancel future searches
        this._close();
      }
    },

    close: function ( event ) {
      this.cancelSearch = true;
      this._close( event );
    },

    _close: function ( event ) {

      // Remove the handler that closes the menu on outside clicks
      this._off( this.document, "mousedown" );

      if ( this.menu.element.is( ":visible" ) ) {
        this.menu.element.hide();
        this.menu.blur();
        this.isNewMenu = true;
        this._trigger( "close", event );
      }
    },

    _change: function ( event ) {
      if ( this.previous !== this._value() ) {
        this._trigger( "change", event, { item: this.selectedItem } );
      }
    },

    _normalize: function ( items ) {

      // assume all items have the right format when the first item is complete
      if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
        return items;
      }
      return $.map( items, function ( item ) {
        if ( typeof item === "string" ) {
          return {
            label: item,
            value: item
          };
        }
        return $.extend( {}, item, {
          label: item.label || item.value,
          value: item.value || item.label
        } );
      } );
    },

    _suggest: function ( items ) {
      var ul = this.menu.element.empty();
      this._renderMenu( ul, items );
      this.isNewMenu = true;
      this.menu.refresh();

      // Size and position menu
      ul.show();
      this._resizeMenu();
      ul.position( $.extend( {
        of: this.element
      }, this.options.position ) );

      if ( this.options.autoFocus ) {
        this.menu.next();
      }

      // Listen for interactions outside of the widget (#6642)
      this._on( this.document, {
        mousedown: "_closeOnClickOutside"
      } );
    },

    _resizeMenu: function () {
      var ul = this.menu.element;
      ul.outerWidth( Math.max(

        // Firefox wraps long text (possibly a rounding bug)
        // so we add 1px to avoid the wrapping (#7513)
        ul.width( "" ).outerWidth() + 1,
        this.element.outerWidth()
      ) );
    },

    _renderMenu: function ( ul, items ) {
      var that = this;
      $.each( items, function ( index, item ) {
        that._renderItemData( ul, item );
      } );
    },

    _renderItemData: function ( ul, item ) {
      return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
    },

    _renderItem: function ( ul, item ) {
      return $( "<li>" )
        .append( $( "<div>" ).text( item.label ) )
        .appendTo( ul );
    },

    _move: function ( direction, event ) {
      if ( !this.menu.element.is( ":visible" ) ) {
        this.search( null, event );
        return;
      }
      if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

        if ( !this.isMultiLine ) {
          this._value( this.term );
        }

        this.menu.blur();
        return;
      }
      this.menu[ direction ]( event );
    },

    widget: function () {
      return this.menu.element;
    },

    _value: function () {
      return this.valueMethod.apply( this.element, arguments );
    },

    _keyEvent: function ( keyEvent, event ) {
      if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
        this._move( keyEvent, event );

        // Prevents moving cursor to beginning/end of the text field in some browsers
        event.preventDefault();
      }
    },

    // Support: Chrome <=50
    // We should be able to just use this.element.prop( "isContentEditable" )
    // but hidden elements always report false in Chrome.
    // https://code.google.com/p/chromium/issues/detail?id=313082
    _isContentEditable: function ( element ) {
      if ( !element.length ) {
        return false;
      }

      var editable = element.prop( "contentEditable" );

      if ( editable === "inherit" ) {
		  return this._isContentEditable( element.parent() );
      }

      return editable === "true";
    }
  } );

  $.extend( $.ui.autocomplete, {
    escapeRegex: function ( value ) {
      return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
    },
    filter: function ( array, term ) {
      var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
      return $.grep( array, function ( value ) {
        return matcher.test( value.label || value.value || value );
      } );
    }
  } );

  // Live region extension, adding a `messages` option
  // NOTE: This is an experimental API. We are still investigating
  // a full solution for string manipulation and internationalization.
  $.widget( "ui.autocomplete", $.ui.autocomplete, {
    options: {
      messages: {
        noResults: "No search results.",
        results: function ( amount ) {
          return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
        }
      }
    },

    __response: function ( content ) {
      var message;
      this._superApply( arguments );
      if ( this.options.disabled || this.cancelSearch ) {
        return;
      }
      if ( content && content.length ) {
        message = this.options.messages.results( content.length );
      } else {
        message = this.options.messages.noResults;
      }
      this.liveRegion.children().hide();
      $( "<div>" ).text( message ).appendTo( this.liveRegion );
    }
  } );

  var widgetsAutocomplete = $.ui.autocomplete;

  /* !
 * jQuery UI Controlgroup 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Controlgroup
  // >>group: Widgets
  // >>description: Visually groups form control widgets
  // >>docs: http://api.jqueryui.com/controlgroup/
  // >>demos: http://jqueryui.com/controlgroup/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/controlgroup.css
  // >>css.theme: ../../themes/base/theme.css

  var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;

  var widgetsControlgroup = $.widget( "ui.controlgroup", {
    version: "1.12.1",
    defaultElement: "<div>",
    options: {
      direction: "horizontal",
      disabled: null,
      onlyVisible: true,
      items: {
        "button": "input[type=button], input[type=submit], input[type=reset], button, a",
        "controlgroupLabel": ".ui-controlgroup-label",
        "checkboxradio": "input[type='checkbox'], input[type='radio']",
        "selectmenu": "select",
        "spinner": ".ui-spinner-input"
      }
    },

    _create: function () {
      this._enhance();
    },

    // To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
    _enhance: function () {
      this.element.attr( "role", "toolbar" );
      this.refresh();
    },

    _destroy: function () {
      this._callChildMethod( "destroy" );
      this.childWidgets.removeData( "ui-controlgroup-data" );
      this.element.removeAttr( "role" );
      if ( this.options.items.controlgroupLabel ) {
        this.element
          .find( this.options.items.controlgroupLabel )
          .find( ".ui-controlgroup-label-contents" )
          .contents().unwrap();
      }
    },

    _initWidgets: function () {
      var that = this,
        childWidgets = [];

      // First we iterate over each of the items options
      $.each( this.options.items, function ( widget, selector ) {
        var labels;
        var options = {};

        // Make sure the widget has a selector set
        if ( !selector ) {
          return;
        }

        if ( widget === "controlgroupLabel" ) {
          labels = that.element.find( selector );
          labels.each( function () {
            var element = $( this );

            if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
              return;
            }
            element.contents()
              .wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
          } );
          that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
          childWidgets = childWidgets.concat( labels.get() );
          return;
        }

        // Make sure the widget actually exists
        if ( !$.fn[ widget ] ) {
          return;
        }

        // We assume everything is in the middle to start because we can't determine
        // first / last elements until all enhancments are done.
        if ( that[ "_" + widget + "Options" ] ) {
          options = that[ "_" + widget + "Options" ]( "middle" );
        } else {
          options = { classes: {} };
        }

        // Find instances of this widget inside controlgroup and init them
        that.element
          .find( selector )
          .each( function () {
            var element = $( this );
            var instance = element[ widget ]( "instance" );

            // We need to clone the default options for this type of widget to avoid
            // polluting the variable options which has a wider scope than a single widget.
            var instanceOptions = $.widget.extend( {}, options );

            // If the button is the child of a spinner ignore it
            // TODO: Find a more generic solution
            if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
              return;
            }

            // Create the widget if it doesn't exist
            if ( !instance ) {
              instance = element[ widget ]()[ widget ]( "instance" );
            }
            if ( instance ) {
              instanceOptions.classes =
							that._resolveClassesValues( instanceOptions.classes, instance );
            }
            element[ widget ]( instanceOptions );

            // Store an instance of the controlgroup to be able to reference
            // from the outermost element for changing options and refresh
            var widgetElement = element[ widget ]( "widget" );
            $.data( widgetElement[ 0 ], "ui-controlgroup-data",
              instance ? instance : element[ widget ]( "instance" ) );

            childWidgets.push( widgetElement[ 0 ] );
          } );
      } );

      this.childWidgets = $( $.unique( childWidgets ) );
      this._addClass( this.childWidgets, "ui-controlgroup-item" );
    },

    _callChildMethod: function ( method ) {
      this.childWidgets.each( function () {
        var element = $( this ),
          data = element.data( "ui-controlgroup-data" );
        if ( data && data[ method ] ) {
          data[ method ]();
        }
      } );
    },

    _updateCornerClass: function ( element, position ) {
      var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
      var add = this._buildSimpleOptions( position, "label" ).classes.label;

      this._removeClass( element, null, remove );
      this._addClass( element, null, add );
    },

    _buildSimpleOptions: function ( position, key ) {
      var direction = this.options.direction === "vertical";
      var result = {
        classes: {}
      };
      result.classes[ key ] = {
        "middle": "",
        "first": "ui-corner-" + ( direction ? "top" : "left" ),
        "last": "ui-corner-" + ( direction ? "bottom" : "right" ),
        "only": "ui-corner-all"
      }[ position ];

      return result;
    },

    _spinnerOptions: function ( position ) {
      var options = this._buildSimpleOptions( position, "ui-spinner" );

      options.classes[ "ui-spinner-up" ] = "";
      options.classes[ "ui-spinner-down" ] = "";

      return options;
    },

    _buttonOptions: function ( position ) {
      return this._buildSimpleOptions( position, "ui-button" );
    },

    _checkboxradioOptions: function ( position ) {
      return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
    },

    _selectmenuOptions: function ( position ) {
      var direction = this.options.direction === "vertical";
      return {
        width: direction ? "auto" : false,
        classes: {
          middle: {
            "ui-selectmenu-button-open": "",
            "ui-selectmenu-button-closed": ""
          },
          first: {
            "ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
            "ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
          },
          last: {
            "ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
            "ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
          },
          only: {
            "ui-selectmenu-button-open": "ui-corner-top",
            "ui-selectmenu-button-closed": "ui-corner-all"
          }

        }[ position ]
      };
    },

    _resolveClassesValues: function ( classes, instance ) {
      var result = {};
      $.each( classes, function ( key ) {
        var current = instance.options.classes[ key ] || "";
        current = $.trim( current.replace( controlgroupCornerRegex, "" ) );
        result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
      } );
      return result;
    },

    _setOption: function ( key, value ) {
      if ( key === "direction" ) {
        this._removeClass( "ui-controlgroup-" + this.options.direction );
      }

      this._super( key, value );
      if ( key === "disabled" ) {
        this._callChildMethod( value ? "disable" : "enable" );
        return;
      }

      this.refresh();
    },

    refresh: function () {
      var children,
        that = this;

      this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );

      if ( this.options.direction === "horizontal" ) {
        this._addClass( null, "ui-helper-clearfix" );
      }
      this._initWidgets();

      children = this.childWidgets;

      // We filter here because we need to track all childWidgets not just the visible ones
      if ( this.options.onlyVisible ) {
        children = children.filter( ":visible" );
      }

      if ( children.length ) {

        // We do this last because we need to make sure all enhancment is done
        // before determining first and last
        $.each( [ "first", "last" ], function ( index, value ) {
          var instance = children[ value ]().data( "ui-controlgroup-data" );

          if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
            var options = that[ "_" + instance.widgetName + "Options" ](
              children.length === 1 ? "only" : value
            );
            options.classes = that._resolveClassesValues( options.classes, instance );
            instance.element[ instance.widgetName ]( options );
          } else {
            that._updateCornerClass( children[ value ](), value );
          }
        } );

        // Finally call the refresh method on each of the child widgets.
        this._callChildMethod( "refresh" );
      }
    }
  } );

  /* !
 * jQuery UI Checkboxradio 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Checkboxradio
  // >>group: Widgets
  // >>description: Enhances a form with multiple themeable checkboxes or radio buttons.
  // >>docs: http://api.jqueryui.com/checkboxradio/
  // >>demos: http://jqueryui.com/checkboxradio/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/button.css
  // >>css.structure: ../../themes/base/checkboxradio.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
    version: "1.12.1",
    options: {
      disabled: null,
      label: null,
      icon: true,
      classes: {
        "ui-checkboxradio-label": "ui-corner-all",
        "ui-checkboxradio-icon": "ui-corner-all"
      }
    },

    _getCreateOptions: function () {
      var disabled, labels;
      var that = this;
      var options = this._super() || {};

      // We read the type here, because it makes more sense to throw a element type error first,
      // rather then the error for lack of a label. Often if its the wrong type, it
      // won't have a label (e.g. calling on a div, btn, etc)
      this._readType();

      labels = this.element.labels();

      // If there are multiple labels, use the last one
      this.label = $( labels[ labels.length - 1 ] );
      if ( !this.label.length ) {
        $.error( "No label found for checkboxradio widget" );
      }

      this.originalLabel = "";

      // We need to get the label text but this may also need to make sure it does not contain the
      // input itself.
      this.label.contents().not( this.element[ 0 ] ).each( function () {

        // The label contents could be text, html, or a mix. We concat each element to get a
        // string representation of the label, without the input as part of it.
        that.originalLabel += this.nodeType === 3 ? $( this ).text() : this.outerHTML;
      } );

      // Set the label option if we found label text
      if ( this.originalLabel ) {
        options.label = this.originalLabel;
      }

      disabled = this.element[ 0 ].disabled;
      if ( disabled != null ) {
        options.disabled = disabled;
      }
      return options;
    },

    _create: function () {
      var checked = this.element[ 0 ].checked;

      this._bindFormResetHandler();

      if ( this.options.disabled == null ) {
        this.options.disabled = this.element[ 0 ].disabled;
      }

      this._setOption( "disabled", this.options.disabled );
      this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
      this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );

      if ( this.type === "radio" ) {
        this._addClass( this.label, "ui-checkboxradio-radio-label" );
      }

      if ( this.options.label && this.options.label !== this.originalLabel ) {
        this._updateLabel();
      } else if ( this.originalLabel ) {
        this.options.label = this.originalLabel;
      }

      this._enhance();

      if ( checked ) {
        this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
        if ( this.icon ) {
          this._addClass( this.icon, null, "ui-state-hover" );
        }
      }

      this._on( {
        change: "_toggleClasses",
        focus: function () {
          this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
        },
        blur: function () {
          this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
        }
      } );
    },

    _readType: function () {
      var nodeName = this.element[ 0 ].nodeName.toLowerCase();
      this.type = this.element[ 0 ].type;
      if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
        $.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
				" and element.type=" + this.type );
      }
    },

    // Support jQuery Mobile enhanced option
    _enhance: function () {
      this._updateIcon( this.element[ 0 ].checked );
    },

    widget: function () {
      return this.label;
    },

    _getRadioGroup: function () {
      var group;
      var name = this.element[ 0 ].name;
      var nameSelector = "input[name='" + $.ui.escapeSelector( name ) + "']";

      if ( !name ) {
        return $( [] );
      }

      if ( this.form.length ) {
        group = $( this.form[ 0 ].elements ).filter( nameSelector );
      } else {

        // Not inside a form, check all inputs that also are not inside a form
        group = $( nameSelector ).filter( function () {
          return $( this ).form().length === 0;
        } );
      }

      return group.not( this.element );
    },

    _toggleClasses: function () {
      var checked = this.element[ 0 ].checked;
      this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );

      if ( this.options.icon && this.type === "checkbox" ) {
        this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
          ._toggleClass( this.icon, null, "ui-icon-blank", !checked );
      }

      if ( this.type === "radio" ) {
        this._getRadioGroup()
          .each( function () {
            var instance = $( this ).checkboxradio( "instance" );

            if ( instance ) {
              instance._removeClass( instance.label,
                "ui-checkboxradio-checked", "ui-state-active" );
            }
          } );
      }
    },

    _destroy: function () {
      this._unbindFormResetHandler();

      if ( this.icon ) {
        this.icon.remove();
        this.iconSpace.remove();
      }
    },

    _setOption: function ( key, value ) {

      // We don't allow the value to be set to nothing
      if ( key === "label" && !value ) {
        return;
      }

      this._super( key, value );

      if ( key === "disabled" ) {
        this._toggleClass( this.label, null, "ui-state-disabled", value );
        this.element[ 0 ].disabled = value;

        // Don't refresh when setting disabled
        return;
      }
      this.refresh();
    },

    _updateIcon: function ( checked ) {
      var toAdd = "ui-icon ui-icon-background ";

      if ( this.options.icon ) {
        if ( !this.icon ) {
          this.icon = $( "<span>" );
          this.iconSpace = $( "<span> </span>" );
          this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
        }

        if ( this.type === "checkbox" ) {
          toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
          this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
        } else {
          toAdd += "ui-icon-blank";
        }
        this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
        if ( !checked ) {
          this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
        }
        this.icon.prependTo( this.label ).after( this.iconSpace );
      } else if ( this.icon !== undefined ) {
        this.icon.remove();
        this.iconSpace.remove();
        delete this.icon;
      }
    },

    _updateLabel: function () {

      // Remove the contents of the label ( minus the icon, icon space, and input )
      var contents = this.label.contents().not( this.element[ 0 ] );
      if ( this.icon ) {
        contents = contents.not( this.icon[ 0 ] );
      }
      if ( this.iconSpace ) {
        contents = contents.not( this.iconSpace[ 0 ] );
      }
      contents.remove();

      this.label.append( this.options.label );
    },

    refresh: function () {
      var checked = this.element[ 0 ].checked,
        isDisabled = this.element[ 0 ].disabled;

      this._updateIcon( checked );
      this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
      if ( this.options.label !== null ) {
        this._updateLabel();
      }

      if ( isDisabled !== this.options.disabled ) {
        this._setOptions( { "disabled": isDisabled } );
      }
    }

  } ] );

  var widgetsCheckboxradio = $.ui.checkboxradio;

  /* !
 * jQuery UI Button 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Button
  // >>group: Widgets
  // >>description: Enhances a form with themeable buttons.
  // >>docs: http://api.jqueryui.com/button/
  // >>demos: http://jqueryui.com/button/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/button.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.button", {
    version: "1.12.1",
    defaultElement: "<button>",
    options: {
      classes: {
        "ui-button": "ui-corner-all"
      },
      disabled: null,
      icon: null,
      iconPosition: "beginning",
      label: null,
      showLabel: true
    },

    _getCreateOptions: function () {
      var disabled,

        // This is to support cases like in jQuery Mobile where the base widget does have
        // an implementation of _getCreateOptions
        options = this._super() || {};

      this.isInput = this.element.is( "input" );

      disabled = this.element[ 0 ].disabled;
      if ( disabled != null ) {
        options.disabled = disabled;
      }

      this.originalLabel = this.isInput ? this.element.val() : this.element.html();
      if ( this.originalLabel ) {
        options.label = this.originalLabel;
      }

      return options;
    },

    _create: function () {
      if ( !this.option.showLabel & !this.options.icon ) {
        this.options.showLabel = true;
      }

      // We have to check the option again here even though we did in _getCreateOptions,
      // because null may have been passed on init which would override what was set in
      // _getCreateOptions
      if ( this.options.disabled == null ) {
        this.options.disabled = this.element[ 0 ].disabled || false;
      }

      this.hasTitle = !!this.element.attr( "title" );

      // Check to see if the label needs to be set or if its already correct
      if ( this.options.label && this.options.label !== this.originalLabel ) {
        if ( this.isInput ) {
          this.element.val( this.options.label );
        } else {
          this.element.html( this.options.label );
        }
      }
      this._addClass( "ui-button", "ui-widget" );
      this._setOption( "disabled", this.options.disabled );
      this._enhance();

      if ( this.element.is( "a" ) ) {
        this._on( {
          "keyup": function ( event ) {
            if ( event.keyCode === $.ui.keyCode.SPACE ) {
              event.preventDefault();

              // Support: PhantomJS <= 1.9, IE 8 Only
              // If a native click is available use it so we actually cause navigation
              // otherwise just trigger a click event
              if ( this.element[ 0 ].click ) {
                this.element[ 0 ].click();
              } else {
                this.element.trigger( "click" );
              }
            }
          }
        } );
      }
    },

    _enhance: function () {
      if ( !this.element.is( "button" ) ) {
        this.element.attr( "role", "button" );
      }

      if ( this.options.icon ) {
        this._updateIcon( "icon", this.options.icon );
        this._updateTooltip();
      }
    },

    _updateTooltip: function () {
      this.title = this.element.attr( "title" );

      if ( !this.options.showLabel && !this.title ) {
        this.element.attr( "title", this.options.label );
      }
    },

    _updateIcon: function ( option, value ) {
      var icon = option !== "iconPosition",
        position = icon ? this.options.iconPosition : value,
        displayBlock = position === "top" || position === "bottom";

      // Create icon
      if ( !this.icon ) {
        this.icon = $( "<span>" );

        this._addClass( this.icon, "ui-button-icon", "ui-icon" );

        if ( !this.options.showLabel ) {
          this._addClass( "ui-button-icon-only" );
        }
      } else if ( icon ) {

        // If we are updating the icon remove the old icon class
        this._removeClass( this.icon, null, this.options.icon );
      }

      // If we are updating the icon add the new icon class
      if ( icon ) {
        this._addClass( this.icon, null, value );
      }

      this._attachIcon( position );

      // If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
      // the iconSpace if there is one.
      if ( displayBlock ) {
        this._addClass( this.icon, null, "ui-widget-icon-block" );
        if ( this.iconSpace ) {
          this.iconSpace.remove();
        }
      } else {

        // Position is beginning or end so remove the ui-widget-icon-block class and add the
        // space if it does not exist
        if ( !this.iconSpace ) {
          this.iconSpace = $( "<span> </span>" );
          this._addClass( this.iconSpace, "ui-button-icon-space" );
        }
        this._removeClass( this.icon, null, "ui-wiget-icon-block" );
        this._attachIconSpace( position );
      }
    },

    _destroy: function () {
      this.element.removeAttr( "role" );

      if ( this.icon ) {
        this.icon.remove();
      }
      if ( this.iconSpace ) {
        this.iconSpace.remove();
      }
      if ( !this.hasTitle ) {
        this.element.removeAttr( "title" );
      }
    },

    _attachIconSpace: function ( iconPosition ) {
      this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
    },

    _attachIcon: function ( iconPosition ) {
      this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
    },

    _setOptions: function ( options ) {
      var newShowLabel = options.showLabel === undefined ?
          this.options.showLabel :
          options.showLabel,
        newIcon = options.icon === undefined ? this.options.icon : options.icon;

      if ( !newShowLabel && !newIcon ) {
        options.showLabel = true;
      }
      this._super( options );
    },

    _setOption: function ( key, value ) {
      if ( key === "icon" ) {
        if ( value ) {
          this._updateIcon( key, value );
        } else if ( this.icon ) {
          this.icon.remove();
          if ( this.iconSpace ) {
            this.iconSpace.remove();
          }
        }
      }

      if ( key === "iconPosition" ) {
        this._updateIcon( key, value );
      }

      // Make sure we can't end up with a button that has neither text nor icon
      if ( key === "showLabel" ) {
        this._toggleClass( "ui-button-icon-only", null, !value );
        this._updateTooltip();
      }

      if ( key === "label" ) {
        if ( this.isInput ) {
          this.element.val( value );
        } else {

          // If there is an icon, append it, else nothing then append the value
          // this avoids removal of the icon when setting label text
          this.element.html( value );
          if ( this.icon ) {
            this._attachIcon( this.options.iconPosition );
            this._attachIconSpace( this.options.iconPosition );
          }
        }
      }

      this._super( key, value );

      if ( key === "disabled" ) {
        this._toggleClass( null, "ui-state-disabled", value );
        this.element[ 0 ].disabled = value;
        if ( value ) {
          this.element.blur();
        }
      }
    },

    refresh: function () {

      // Make sure to only check disabled if its an element that supports this otherwise
      // check for the disabled class to determine state
      var isDisabled = this.element.is( "input, button" ) ?
        this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );

      if ( isDisabled !== this.options.disabled ) {
        this._setOptions( { disabled: isDisabled } );
      }

      this._updateTooltip();
    }
  } );

  // DEPRECATED
  if ( $.uiBackCompat !== false ) {

    // Text and Icons options
    $.widget( "ui.button", $.ui.button, {
      options: {
        text: true,
        icons: {
          primary: null,
          secondary: null
        }
      },

      _create: function () {
        if ( this.options.showLabel && !this.options.text ) {
          this.options.showLabel = this.options.text;
        }
        if ( !this.options.showLabel && this.options.text ) {
          this.options.text = this.options.showLabel;
        }
        if ( !this.options.icon && ( this.options.icons.primary ||
					this.options.icons.secondary ) ) {
          if ( this.options.icons.primary ) {
            this.options.icon = this.options.icons.primary;
          } else {
            this.options.icon = this.options.icons.secondary;
            this.options.iconPosition = "end";
          }
        } else if ( this.options.icon ) {
          this.options.icons.primary = this.options.icon;
        }
        this._super();
      },

      _setOption: function ( key, value ) {
        if ( key === "text" ) {
          this._super( "showLabel", value );
          return;
        }
        if ( key === "showLabel" ) {
          this.options.text = value;
        }
        if ( key === "icon" ) {
          this.options.icons.primary = value;
        }
        if ( key === "icons" ) {
          if ( value.primary ) {
            this._super( "icon", value.primary );
            this._super( "iconPosition", "beginning" );
          } else if ( value.secondary ) {
            this._super( "icon", value.secondary );
            this._super( "iconPosition", "end" );
          }
        }
        this._superApply( arguments );
      }
    } );

    $.fn.button = ( function ( orig ) {
      return function () {
        if ( !this.length || ( this.length && this[ 0 ].tagName !== "INPUT" ) ||
					( this.length && this[ 0 ].tagName === "INPUT" && (
					  this.attr( "type" ) !== "checkbox" && this.attr( "type" ) !== "radio"
					) ) ) {
          return orig.apply( this, arguments );
        }
        if ( !$.ui.checkboxradio ) {
          $.error( "Checkboxradio widget missing" );
        }
        if ( arguments.length === 0 ) {
          return this.checkboxradio( {
            "icon": false
          } );
        }
        return this.checkboxradio.apply( this, arguments );
      };
    } )( $.fn.button );

    $.fn.buttonset = function () {
      if ( !$.ui.controlgroup ) {
        $.error( "Controlgroup widget missing" );
      }
      if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
        return this.controlgroup.apply( this,
          [ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
      }
      if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
        return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
      }
      if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
        arguments[ 0 ].items = {
          button: arguments[ 0 ].items
        };
      }
      return this.controlgroup.apply( this, arguments );
    };
  }

  var widgetsButton = $.ui.button;

  // jscs:disable maximumLineLength
  /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
  /* !
 * jQuery UI Datepicker 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Datepicker
  // >>group: Widgets
  // >>description: Displays a calendar from an input or inline for selecting dates.
  // >>docs: http://api.jqueryui.com/datepicker/
  // >>demos: http://jqueryui.com/datepicker/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/datepicker.css
  // >>css.theme: ../../themes/base/theme.css

  $.extend( $.ui, { datepicker: { version: "1.12.1" } } );

  var datepicker_instActive;

  function datepicker_getZindex( elem ) {
    var position, value;
    while ( elem.length && elem[ 0 ] !== document ) {

      // Ignore z-index if position is set to a value where z-index is ignored by the browser
      // This makes behavior of this function consistent across browsers
      // WebKit always returns auto if the element is positioned
      position = elem.css( "position" );
      if ( position === "absolute" || position === "relative" || position === "fixed" ) {

        // IE returns 0 when zIndex is not specified
        // other browsers return a string
        // we ignore the case of nested elements with an explicit value of 0
        // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
        value = parseInt( elem.css( "zIndex" ), 10 );
        if ( !isNaN( value ) && value !== 0 ) {
          return value;
        }
      }
      elem = elem.parent();
    }

    return 0;
  }
  /* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

  function Datepicker() {
    this._curInst = null; // The current instance in use
    this._keyEvent = false; // If the last event was a key event
    this._disabledInputs = []; // List of date picker inputs that have been disabled
    this._datepickerShowing = false; // True if the popup picker is showing , false if not
    this._inDialog = false; // True if showing within a "dialog", false if not
    this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
    this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
    this._appendClass = "ui-datepicker-append"; // The name of the append marker class
    this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
    this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
    this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
    this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
    this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
    this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
    this.regional = []; // Available regional settings, indexed by language code
    this.regional[ "" ] = { // Default regional settings
      closeText: "Done", // Display text for close link
      prevText: "Prev", // Display text for previous month link
      nextText: "Next", // Display text for next month link
      currentText: "Today", // Display text for current month link
      monthNames: [ "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December" ], // Names of months for drop-down and formatting
      monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
      dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
      dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
      dayNamesMin: [ "Su", "Mo", "Tu", "We", "Th", "Fr", "Sa" ], // Column headings for days starting at Sunday
      weekHeader: "Wk", // Column header for week of the year
      dateFormat: "mm/dd/yy", // See format options on parseDate
      firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
      isRTL: false, // True if right-to-left language, false if left-to-right
      showMonthAfterYear: false, // True if the year select precedes month, false for month then year
      yearSuffix: "" // Additional text to append to the year in the month headers
    };
    this._defaults = { // Global defaults for all the date picker instances
      showOn: "focus", // "focus" for popup on focus,
      // "button" for trigger button, or "both" for either
      showAnim: "fadeIn", // Name of jQuery animation for popup
      showOptions: {}, // Options for enhanced animations
      defaultDate: null, // Used when field is blank: actual date,
      // +/-number for offset from today, null for today
      appendText: "", // Display text following the input box, e.g. showing the format
      buttonText: "...", // Text for trigger button
      buttonImage: "", // URL for trigger button image
      buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
      hideIfNoPrevNext: false, // True to hide next/previous month links
      // if not applicable, false to just disable them
      navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
      gotoCurrent: false, // True if today link goes back to current selection instead
      changeMonth: false, // True if month can be selected directly, false if only prev/next
      changeYear: false, // True if year can be selected directly, false if only prev/next
      yearRange: "c-10:c+10", // Range of years to display in drop-down,
      // either relative to today's year (-nn:+nn), relative to currently displayed year
      // (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
      showOtherMonths: false, // True to show dates in other months, false to leave blank
      selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
      showWeek: false, // True to show week of the year, false to not show it
      calculateWeek: this.iso8601Week, // How to calculate the week of the year,
      // takes a Date and returns the number of the week for it
      shortYearCutoff: "+10", // Short year values < this are in the current century,
      // > this are in the previous century,
      // string value starting with "+" for current year + value
      minDate: null, // The earliest selectable date, or null for no limit
      maxDate: null, // The latest selectable date, or null for no limit
      duration: "fast", // Duration of display/closure
      beforeShowDay: null, // Function that takes a date and returns an array with
      // [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
      // [2] = cell title (optional), e.g. $.datepicker.noWeekends
      beforeShow: null, // Function that takes an input field and
      // returns a set of custom settings for the date picker
      onSelect: null, // Define a callback function when a date is selected
      onChangeMonthYear: null, // Define a callback function when the month or year is changed
      onClose: null, // Define a callback function when the datepicker is closed
      numberOfMonths: 1, // Number of months to show at a time
      showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
      stepMonths: 1, // Number of months to step back/forward
      stepBigMonths: 12, // Number of months to step back/forward for the big links
      altField: "", // Selector for an alternate field to store selected dates into
      altFormat: "", // The date format to use for the alternate field
      constrainInput: true, // The input is constrained by the current date format
      showButtonPanel: false, // True to show button panel, false to not show it
      autoSize: false, // True to size the input for the date format, false to leave as is
      disabled: false // The initial disabled state
    };
    $.extend( this._defaults, this.regional[ "" ] );
    this.regional.en = $.extend( true, {}, this.regional[ "" ] );
    this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
    this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
  }

  $.extend( Datepicker.prototype, {
    /* Class name added to elements to indicate already configured with a date picker. */
    markerClassName: "hasDatepicker",

    // Keep track of the maximum number of rows displayed (see #7043)
    maxRows: 4,

    // TODO rename to "widget" when switching to widget factory
    _widgetDatepicker: function () {
      return this.dpDiv;
    },

    /* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
    setDefaults: function ( settings ) {
      datepicker_extendRemove( this._defaults, settings || {} );
      return this;
    },

    /* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
    _attachDatepicker: function ( target, settings ) {
      var nodeName, inline, inst;
      nodeName = target.nodeName.toLowerCase();
      inline = ( nodeName === "div" || nodeName === "span" );
      if ( !target.id ) {
        this.uuid += 1;
        target.id = "dp" + this.uuid;
      }
      inst = this._newInst( $( target ), inline );
      inst.settings = $.extend( {}, settings || {} );
      if ( nodeName === "input" ) {
        this._connectDatepicker( target, inst );
      } else if ( inline ) {
        this._inlineDatepicker( target, inst );
      }
    },

    /* Create a new instance object. */
    _newInst: function ( target, inline ) {
      var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
      return { id: id, input: target, // associated target
        selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
        drawMonth: 0, drawYear: 0, // month being drawn
        inline: inline, // is datepicker inline or not
        dpDiv: ( !inline ? this.dpDiv : // presentation div
          datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
    },

    /* Attach the date picker to an input field. */
    _connectDatepicker: function ( target, inst ) {
      var input = $( target );
      inst.append = $( [] );
      inst.trigger = $( [] );
      if ( input.hasClass( this.markerClassName ) ) {
        return;
      }
      this._attachments( input, inst );
      input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
        on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
      this._autoSize( inst );
      $.data( target, "datepicker", inst );

      // If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
      if ( inst.settings.disabled ) {
        this._disableDatepicker( target );
      }
    },

    /* Make attachments based on settings. */
    _attachments: function ( input, inst ) {
      var showOn, buttonText, buttonImage,
        appendText = this._get( inst, "appendText" ),
        isRTL = this._get( inst, "isRTL" );

      if ( inst.append ) {
        inst.append.remove();
      }
      if ( appendText ) {
        inst.append = $( "<span class='" + this._appendClass + "'>" + appendText + "</span>" );
        input[ isRTL ? "before" : "after" ]( inst.append );
      }

      input.off( "focus", this._showDatepicker );

      if ( inst.trigger ) {
        inst.trigger.remove();
      }

      showOn = this._get( inst, "showOn" );
      if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
        input.on( "focus", this._showDatepicker );
      }
      if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
        buttonText = this._get( inst, "buttonText" );
        buttonImage = this._get( inst, "buttonImage" );
        inst.trigger = $( this._get( inst, "buttonImageOnly" ) ?
          $( "<img/>" ).addClass( this._triggerClass ).
            attr( { src: buttonImage, alt: buttonText, title: buttonText } ) :
          $( "<button type='button'></button>" ).addClass( this._triggerClass ).
            html( !buttonImage ? buttonText : $( "<img/>" ).attr(
              { src: buttonImage, alt: buttonText, title: buttonText } ) ) );
        input[ isRTL ? "before" : "after" ]( inst.trigger );
        inst.trigger.on( "click", function () {
          if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
            $.datepicker._hideDatepicker();
          } else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
            $.datepicker._hideDatepicker();
            $.datepicker._showDatepicker( input[ 0 ] );
          } else {
            $.datepicker._showDatepicker( input[ 0 ] );
          }
          return false;
        } );
      }
    },

    /* Apply the maximum length for the date format. */
    _autoSize: function ( inst ) {
      if ( this._get( inst, "autoSize" ) && !inst.inline ) {
        var findMax, max, maxI, i,
          date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
          dateFormat = this._get( inst, "dateFormat" );

        if ( dateFormat.match( /[DM]/ ) ) {
          findMax = function ( names ) {
            max = 0;
            maxI = 0;
            for ( i = 0; i < names.length; i++ ) {
              if ( names[ i ].length > max ) {
                max = names[ i ].length;
                maxI = i;
              }
            }
            return maxI;
          };
          date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
            "monthNames" : "monthNamesShort" ) ) ) );
          date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
            "dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
        }
        inst.input.attr( "size", this._formatDate( inst, date ).length );
      }
    },

    /* Attach an inline date picker to a div. */
    _inlineDatepicker: function ( target, inst ) {
      var divSpan = $( target );
      if ( divSpan.hasClass( this.markerClassName ) ) {
        return;
      }
      divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
      $.data( target, "datepicker", inst );
      this._setDate( inst, this._getDefaultDate( inst ), true );
      this._updateDatepicker( inst );
      this._updateAlternate( inst );

      // If disabled option is true, disable the datepicker before showing it (see ticket #5665)
      if ( inst.settings.disabled ) {
        this._disableDatepicker( target );
      }

      // Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
      // http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
      inst.dpDiv.css( "display", "block" );
    },

    /* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
    _dialogDatepicker: function ( input, date, onSelect, settings, pos ) {
      var id, browserWidth, browserHeight, scrollX, scrollY,
        inst = this._dialogInst; // internal instance

      if ( !inst ) {
        this.uuid += 1;
        id = "dp" + this.uuid;
        this._dialogInput = $( "<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>" );
        this._dialogInput.on( "keydown", this._doKeyDown );
        $( "body" ).append( this._dialogInput );
        inst = this._dialogInst = this._newInst( this._dialogInput, false );
        inst.settings = {};
        $.data( this._dialogInput[ 0 ], "datepicker", inst );
      }
      datepicker_extendRemove( inst.settings, settings || {} );
      date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
      this._dialogInput.val( date );

      this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
      if ( !this._pos ) {
        browserWidth = document.documentElement.clientWidth;
        browserHeight = document.documentElement.clientHeight;
        scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
        scrollY = document.documentElement.scrollTop || document.body.scrollTop;
        this._pos = // should use actual width/height below
				[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
      }

      // Move input on screen for focus, but hidden behind dialog
      this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
      inst.settings.onSelect = onSelect;
      this._inDialog = true;
      this.dpDiv.addClass( this._dialogClass );
      this._showDatepicker( this._dialogInput[ 0 ] );
      if ( $.blockUI ) {
        $.blockUI( this.dpDiv );
      }
      $.data( this._dialogInput[ 0 ], "datepicker", inst );
      return this;
    },

    /* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
    _destroyDatepicker: function ( target ) {
      var nodeName,
        $target = $( target ),
        inst = $.data( target, "datepicker" );

      if ( !$target.hasClass( this.markerClassName ) ) {
        return;
      }

      nodeName = target.nodeName.toLowerCase();
      $.removeData( target, "datepicker" );
      if ( nodeName === "input" ) {
        inst.append.remove();
        inst.trigger.remove();
        $target.removeClass( this.markerClassName ).
          off( "focus", this._showDatepicker ).
          off( "keydown", this._doKeyDown ).
          off( "keypress", this._doKeyPress ).
          off( "keyup", this._doKeyUp );
      } else if ( nodeName === "div" || nodeName === "span" ) {
        $target.removeClass( this.markerClassName ).empty();
      }

      if ( datepicker_instActive === inst ) {
        datepicker_instActive = null;
      }
    },

    /* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
    _enableDatepicker: function ( target ) {
      var nodeName, inline,
        $target = $( target ),
        inst = $.data( target, "datepicker" );

      if ( !$target.hasClass( this.markerClassName ) ) {
        return;
      }

      nodeName = target.nodeName.toLowerCase();
      if ( nodeName === "input" ) {
        target.disabled = false;
        inst.trigger.filter( "button" ).
          each( function () { this.disabled = false; } ).end().
          filter( "img" ).css( { opacity: "1.0", cursor: "" } );
      } else if ( nodeName === "div" || nodeName === "span" ) {
        inline = $target.children( "." + this._inlineClass );
        inline.children().removeClass( "ui-state-disabled" );
        inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
          prop( "disabled", false );
      }
      this._disabledInputs = $.map( this._disabledInputs,
        function ( value ) { return ( value === target ? null : value ); } ); // delete entry
    },

    /* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
    _disableDatepicker: function ( target ) {
      var nodeName, inline,
        $target = $( target ),
        inst = $.data( target, "datepicker" );

      if ( !$target.hasClass( this.markerClassName ) ) {
        return;
      }

      nodeName = target.nodeName.toLowerCase();
      if ( nodeName === "input" ) {
        target.disabled = true;
        inst.trigger.filter( "button" ).
          each( function () { this.disabled = true; } ).end().
          filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
      } else if ( nodeName === "div" || nodeName === "span" ) {
        inline = $target.children( "." + this._inlineClass );
        inline.children().addClass( "ui-state-disabled" );
        inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
          prop( "disabled", true );
      }
      this._disabledInputs = $.map( this._disabledInputs,
        function ( value ) { return ( value === target ? null : value ); } ); // delete entry
      this._disabledInputs[ this._disabledInputs.length ] = target;
    },

    /* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
    _isDisabledDatepicker: function ( target ) {
      if ( !target ) {
        return false;
      }
      for ( var i = 0; i < this._disabledInputs.length; i++ ) {
        if ( this._disabledInputs[ i ] === target ) {
          return true;
        }
      }
      return false;
    },

    /* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
    _getInst: function ( target ) {
      try {
        return $.data( target, "datepicker" );
      }
      catch ( err ) {
        throw "Missing instance data for this datepicker";
      }
    },

    /* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
    _optionDatepicker: function ( target, name, value ) {
      var settings, date, minDate, maxDate,
        inst = this._getInst( target );

      if ( arguments.length === 2 && typeof name === "string" ) {
        return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
          ( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
            this._get( inst, name ) ) : null ) );
      }

      settings = name || {};
      if ( typeof name === "string" ) {
        settings = {};
        settings[ name ] = value;
      }

      if ( inst ) {
        if ( this._curInst === inst ) {
          this._hideDatepicker();
        }

        date = this._getDateDatepicker( target, true );
        minDate = this._getMinMaxDate( inst, "min" );
        maxDate = this._getMinMaxDate( inst, "max" );
        datepicker_extendRemove( inst.settings, settings );

        // reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
        if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
          inst.settings.minDate = this._formatDate( inst, minDate );
        }
        if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
          inst.settings.maxDate = this._formatDate( inst, maxDate );
        }
        if ( "disabled" in settings ) {
          if ( settings.disabled ) {
            this._disableDatepicker( target );
          } else {
            this._enableDatepicker( target );
          }
        }
        this._attachments( $( target ), inst );
        this._autoSize( inst );
        this._setDate( inst, date );
        this._updateAlternate( inst );
        this._updateDatepicker( inst );
      }
    },

    // Change method deprecated
    _changeDatepicker: function ( target, name, value ) {
      this._optionDatepicker( target, name, value );
    },

    /* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
    _refreshDatepicker: function ( target ) {
      var inst = this._getInst( target );
      if ( inst ) {
        this._updateDatepicker( inst );
      }
    },

    /* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
    _setDateDatepicker: function ( target, date ) {
      var inst = this._getInst( target );
      if ( inst ) {
        this._setDate( inst, date );
        this._updateDatepicker( inst );
        this._updateAlternate( inst );
      }
    },

    /* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
    _getDateDatepicker: function ( target, noDefault ) {
      var inst = this._getInst( target );
      if ( inst && !inst.inline ) {
        this._setDateFromField( inst, noDefault );
      }
      return ( inst ? this._getDate( inst ) : null );
    },

    /* Handle keystrokes. */
    _doKeyDown: function ( event ) {
      var onSelect, dateStr, sel,
        inst = $.datepicker._getInst( event.target ),
        handled = true,
        isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );

      inst._keyEvent = true;
      if ( $.datepicker._datepickerShowing ) {
        switch ( event.keyCode ) {
          case 9: $.datepicker._hideDatepicker();
            handled = false;
            break; // hide on tab out
          case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv );
            if ( sel[ 0 ] ) {
              $.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
            }

            onSelect = $.datepicker._get( inst, "onSelect" );
            if ( onSelect ) {
              dateStr = $.datepicker._formatDate( inst );

              // Trigger custom callback
              onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
            } else {
              $.datepicker._hideDatepicker();
            }

            return false; // don't submit the form
          case 27: $.datepicker._hideDatepicker();
            break; // hide on escape
          case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
            -$.datepicker._get( inst, "stepBigMonths" ) :
            -$.datepicker._get( inst, "stepMonths" ) ), "M" );
            break; // previous month/year on page up/+ ctrl
          case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
            +$.datepicker._get( inst, "stepBigMonths" ) :
            +$.datepicker._get( inst, "stepMonths" ) ), "M" );
            break; // next month/year on page down/+ ctrl
          case 35: if ( event.ctrlKey || event.metaKey ) {
            $.datepicker._clearDate( event.target );
          }
            handled = event.ctrlKey || event.metaKey;
            break; // clear on ctrl or command +end
          case 36: if ( event.ctrlKey || event.metaKey ) {
            $.datepicker._gotoToday( event.target );
          }
            handled = event.ctrlKey || event.metaKey;
            break; // current on ctrl or command +home
          case 37: if ( event.ctrlKey || event.metaKey ) {
            $.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
          }
            handled = event.ctrlKey || event.metaKey;

            // -1 day on ctrl or command +left
            if ( event.originalEvent.altKey ) {
              $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
                -$.datepicker._get( inst, "stepBigMonths" ) :
                -$.datepicker._get( inst, "stepMonths" ) ), "M" );
            }

            // next month/year on alt +left on Mac
            break;
          case 38: if ( event.ctrlKey || event.metaKey ) {
            $.datepicker._adjustDate( event.target, -7, "D" );
          }
            handled = event.ctrlKey || event.metaKey;
            break; // -1 week on ctrl or command +up
          case 39: if ( event.ctrlKey || event.metaKey ) {
            $.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
          }
            handled = event.ctrlKey || event.metaKey;

            // +1 day on ctrl or command +right
            if ( event.originalEvent.altKey ) {
              $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
                +$.datepicker._get( inst, "stepBigMonths" ) :
                +$.datepicker._get( inst, "stepMonths" ) ), "M" );
            }

            // next month/year on alt +right
            break;
          case 40: if ( event.ctrlKey || event.metaKey ) {
            $.datepicker._adjustDate( event.target, +7, "D" );
          }
            handled = event.ctrlKey || event.metaKey;
            break; // +1 week on ctrl or command +down
          default: handled = false;
        }
      } else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
        $.datepicker._showDatepicker( this );
      } else {
        handled = false;
      }

      if ( handled ) {
        event.preventDefault();
        event.stopPropagation();
      }
    },

    /* Filter entered characters - based on date format. */
    _doKeyPress: function ( event ) {
      var chars, chr,
        inst = $.datepicker._getInst( event.target );

      if ( $.datepicker._get( inst, "constrainInput" ) ) {
        chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
        chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
        return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
      }
    },

    /* Synchronise manual entry and field/alternate field. */
    _doKeyUp: function ( event ) {
      var date,
        inst = $.datepicker._getInst( event.target );

      if ( inst.input.val() !== inst.lastVal ) {
        try {
          date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
            ( inst.input ? inst.input.val() : null ),
            $.datepicker._getFormatConfig( inst ) );

          if ( date ) { // only if valid
            $.datepicker._setDateFromField( inst );
            $.datepicker._updateAlternate( inst );
            $.datepicker._updateDatepicker( inst );
          }
        }
        catch ( err ) {
        }
      }
      return true;
    },

    /* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
    _showDatepicker: function ( input ) {
      input = input.target || input;
      if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
        input = $( "input", input.parentNode )[ 0 ];
      }

      if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
        return;
      }

      var inst, beforeShow, beforeShowSettings, isFixed,
        offset, showAnim, duration;

      inst = $.datepicker._getInst( input );
      if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
        $.datepicker._curInst.dpDiv.stop( true, true );
        if ( inst && $.datepicker._datepickerShowing ) {
          $.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
        }
      }

      beforeShow = $.datepicker._get( inst, "beforeShow" );
      beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
      if ( beforeShowSettings === false ) {
        return;
      }
      datepicker_extendRemove( inst.settings, beforeShowSettings );

      inst.lastVal = null;
      $.datepicker._lastInput = input;
      $.datepicker._setDateFromField( inst );

      if ( $.datepicker._inDialog ) { // hide cursor
        input.value = "";
      }
      if ( !$.datepicker._pos ) { // position below input
        $.datepicker._pos = $.datepicker._findPos( input );
        $.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
      }

      isFixed = false;
      $( input ).parents().each( function () {
        isFixed |= $( this ).css( "position" ) === "fixed";
        return !isFixed;
      } );

      offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
      $.datepicker._pos = null;

      // to avoid flashes on Firefox
      inst.dpDiv.empty();

      // determine sizing offscreen
      inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
      $.datepicker._updateDatepicker( inst );

      // fix width for dynamic number of date pickers
      // and adjust position before showing
      offset = $.datepicker._checkOffset( inst, offset, isFixed );
      inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
        "static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
      left: offset.left + "px", top: offset.top + "px" } );

      if ( !inst.inline ) {
        showAnim = $.datepicker._get( inst, "showAnim" );
        duration = $.datepicker._get( inst, "duration" );
        inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
        $.datepicker._datepickerShowing = true;

        if ( $.effects && $.effects.effect[ showAnim ] ) {
          inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
        } else {
          inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
        }

        if ( $.datepicker._shouldFocusInput( inst ) ) {
          inst.input.trigger( "focus" );
        }

        $.datepicker._curInst = inst;
      }
    },

    /* Generate the date picker content. */
    _updateDatepicker: function ( inst ) {
      this.maxRows = 4; // Reset the max number of rows being displayed (see #7043)
      datepicker_instActive = inst; // for delegate hover events
      inst.dpDiv.empty().append( this._generateHTML( inst ) );
      this._attachHandlers( inst );

      var origyearshtml,
        numMonths = this._getNumberOfMonths( inst ),
        cols = numMonths[ 1 ],
        width = 17,
        activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

      if ( activeCell.length > 0 ) {
        datepicker_handleMouseover.apply( activeCell.get( 0 ) );
      }

      inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
      if ( cols > 1 ) {
        inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
      }
      inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-multi" );
      inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-rtl" );

      if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
        inst.input.trigger( "focus" );
      }

      // Deffered render of the years select (to avoid flashes on Firefox)
      if ( inst.yearshtml ) {
        origyearshtml = inst.yearshtml;
        setTimeout( function () {

          // assure that inst.yearshtml didn't change.
          if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
            inst.dpDiv.find( "select.ui-datepicker-year:first" ).replaceWith( inst.yearshtml );
          }
          origyearshtml = inst.yearshtml = null;
        }, 0 );
      }
    },

    // #6694 - don't focus the input if it's already focused
    // this breaks the change event in IE
    // Support: IE and jQuery <1.9
    _shouldFocusInput: function ( inst ) {
      return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
    },

    /* Check positioning to remain on screen. */
    _checkOffset: function ( inst, offset, isFixed ) {
      var dpWidth = inst.dpDiv.outerWidth(),
        dpHeight = inst.dpDiv.outerHeight(),
        inputWidth = inst.input ? inst.input.outerWidth() : 0,
        inputHeight = inst.input ? inst.input.outerHeight() : 0,
        viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
        viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );

      offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
      offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
      offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;

      // Now check if datepicker is showing outside window viewport - move to a better place if so.
      offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
        Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
      offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
        Math.abs( dpHeight + inputHeight ) : 0 );

      return offset;
    },

    /* Find an object's position on the screen. */
    _findPos: function ( obj ) {
      var position,
        inst = this._getInst( obj ),
        isRTL = this._get( inst, "isRTL" );

      while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden( obj ) ) ) {
        obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
      }

      position = $( obj ).offset();
      return [ position.left, position.top ];
    },

    /* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
    _hideDatepicker: function ( input ) {
      var showAnim, duration, postProcess, onClose,
        inst = this._curInst;

      if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
        return;
      }

      if ( this._datepickerShowing ) {
        showAnim = this._get( inst, "showAnim" );
        duration = this._get( inst, "duration" );
        postProcess = function () {
          $.datepicker._tidyDialog( inst );
        };

        // DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
        if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
          inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
        } else {
          inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
            ( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
        }

        if ( !showAnim ) {
          postProcess();
        }
        this._datepickerShowing = false;

        onClose = this._get( inst, "onClose" );
        if ( onClose ) {
          onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
        }

        this._lastInput = null;
        if ( this._inDialog ) {
          this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
          if ( $.blockUI ) {
            $.unblockUI();
            $( "body" ).append( this.dpDiv );
          }
        }
        this._inDialog = false;
      }
    },

    /* Tidy up after a dialog display. */
    _tidyDialog: function ( inst ) {
      inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
    },

    /* Close date picker if clicked elsewhere. */
    _checkExternalClick: function ( event ) {
      if ( !$.datepicker._curInst ) {
        return;
      }

      var $target = $( event.target ),
        inst = $.datepicker._getInst( $target[ 0 ] );

      if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
				$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
				!$target.hasClass( $.datepicker.markerClassName ) &&
				!$target.closest( "." + $.datepicker._triggerClass ).length &&
				$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
			( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
        $.datepicker._hideDatepicker();
      }
    },

    /* Adjust one of the date sub-fields. */
    _adjustDate: function ( id, offset, period ) {
      var target = $( id ),
        inst = this._getInst( target[ 0 ] );

      if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
        return;
      }
      this._adjustInstDate( inst, offset +
			( period === "M" ? this._get( inst, "showCurrentAtPos" ) : 0 ), // undo positioning
      period );
      this._updateDatepicker( inst );
    },

    /* Action for current link. */
    _gotoToday: function ( id ) {
      var date,
        target = $( id ),
        inst = this._getInst( target[ 0 ] );

      if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
        inst.selectedDay = inst.currentDay;
        inst.drawMonth = inst.selectedMonth = inst.currentMonth;
        inst.drawYear = inst.selectedYear = inst.currentYear;
      } else {
        date = new Date();
        inst.selectedDay = date.getDate();
        inst.drawMonth = inst.selectedMonth = date.getMonth();
        inst.drawYear = inst.selectedYear = date.getFullYear();
      }
      this._notifyChange( inst );
      this._adjustDate( target );
    },

    /* Action for selecting a new month/year. */
    _selectMonthYear: function ( id, select, period ) {
      var target = $( id ),
        inst = this._getInst( target[ 0 ] );

      inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
		inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
			parseInt( select.options[ select.selectedIndex ].value, 10 );

      this._notifyChange( inst );
      this._adjustDate( target );
    },

    /* Action for selecting a day. */
    _selectDay: function ( id, month, year, td ) {
      var inst,
        target = $( id );

      if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
        return;
      }

      inst = this._getInst( target[ 0 ] );
      inst.selectedDay = inst.currentDay = $( "a", td ).html();
      inst.selectedMonth = inst.currentMonth = month;
      inst.selectedYear = inst.currentYear = year;
      this._selectDate( id, this._formatDate( inst,
        inst.currentDay, inst.currentMonth, inst.currentYear ) );
    },

    /* Erase the input field and hide the date picker. */
    _clearDate: function ( id ) {
      var target = $( id );
      this._selectDate( target, "" );
    },

    /* Update the input field with the selected date. */
    _selectDate: function ( id, dateStr ) {
      var onSelect,
        target = $( id ),
        inst = this._getInst( target[ 0 ] );

      dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
      if ( inst.input ) {
        inst.input.val( dateStr );
      }
      this._updateAlternate( inst );

      onSelect = this._get( inst, "onSelect" );
      if ( onSelect ) {
        onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] ); // trigger custom callback
      } else if ( inst.input ) {
        inst.input.trigger( "change" ); // fire the change event
      }

      if ( inst.inline ) {
        this._updateDatepicker( inst );
      } else {
        this._hideDatepicker();
        this._lastInput = inst.input[ 0 ];
        if ( typeof( inst.input[ 0 ] ) !== "object" ) {
          inst.input.trigger( "focus" ); // restore focus
        }
        this._lastInput = null;
      }
    },

    /* Update any alternate field to synchronise with the main field. */
    _updateAlternate: function ( inst ) {
      var altFormat, date, dateStr,
        altField = this._get( inst, "altField" );

      if ( altField ) { // update alternate field too
        altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
        date = this._getDate( inst );
        dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
        $( altField ).val( dateStr );
      }
    },

    /* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
    noWeekends: function ( date ) {
      var day = date.getDay();
      return [ ( day > 0 && day < 6 ), "" ];
    },

    /* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
    iso8601Week: function ( date ) {
      var time,
        checkDate = new Date( date.getTime() );

      // Find Thursday of this week starting on Monday
      checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );

      time = checkDate.getTime();
      checkDate.setMonth( 0 ); // Compare with Jan 1
      checkDate.setDate( 1 );
      return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
    },

    /* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
    parseDate: function ( format, value, settings ) {
      if ( format == null || value == null ) {
        throw "Invalid arguments";
      }

      value = ( typeof value === "object" ? value.toString() : value + "" );
      if ( value === "" ) {
        return null;
      }

      var iFormat, dim, extra,
        iValue = 0,
        shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
        shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
          new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
        dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
        dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
        monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
        monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
        year = -1,
        month = -1,
        day = -1,
        doy = -1,
        literal = false,
        date,

        // Check whether a format character is doubled
        lookAhead = function ( match ) {
          var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
          if ( matches ) {
            iFormat++;
          }
          return matches;
        },

        // Extract a number from the string value
        getNumber = function ( match ) {
          var isDoubled = lookAhead( match ),
            size = ( match === "@" ? 14 : ( match === "!" ? 20 :
              ( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
            minSize = ( match === "y" ? size : 1 ),
            digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
            num = value.substring( iValue ).match( digits );
          if ( !num ) {
            throw "Missing number at position " + iValue;
          }
          iValue += num[ 0 ].length;
          return parseInt( num[ 0 ], 10 );
        },

        // Extract a name from the string value and convert to an index
        getName = function ( match, shortNames, longNames ) {
          var index = -1,
            names = $.map( lookAhead( match ) ? longNames : shortNames, function ( v, k ) {
              return [ [ k, v ] ];
            } ).sort( function ( a, b ) {
              return -( a[ 1 ].length - b[ 1 ].length );
            } );

          $.each( names, function ( i, pair ) {
            var name = pair[ 1 ];
            if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
              index = pair[ 0 ];
              iValue += name.length;
              return false;
            }
          } );
          if ( index !== -1 ) {
            return index + 1;
          } else {
            throw "Unknown name at position " + iValue;
          }
        },

        // Confirm that a literal character matches the string value
        checkLiteral = function () {
          if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
            throw "Unexpected literal at position " + iValue;
          }
          iValue++;
        };

      for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
        if ( literal ) {
          if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
            literal = false;
          } else {
            checkLiteral();
          }
        } else {
          switch ( format.charAt( iFormat ) ) {
            case "d":
              day = getNumber( "d" );
              break;
            case "D":
              getName( "D", dayNamesShort, dayNames );
              break;
            case "o":
              doy = getNumber( "o" );
              break;
            case "m":
              month = getNumber( "m" );
              break;
            case "M":
              month = getName( "M", monthNamesShort, monthNames );
              break;
            case "y":
              year = getNumber( "y" );
              break;
            case "@":
              date = new Date( getNumber( "@" ) );
              year = date.getFullYear();
              month = date.getMonth() + 1;
              day = date.getDate();
              break;
            case "!":
              date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
              year = date.getFullYear();
              month = date.getMonth() + 1;
              day = date.getDate();
              break;
            case "'":
              if ( lookAhead( "'" ) ) {
                checkLiteral();
              } else {
                literal = true;
              }
              break;
            default:
              checkLiteral();
          }
        }
      }

      if ( iValue < value.length ) {
        extra = value.substr( iValue );
        if ( !/^\s+/.test( extra ) ) {
          throw "Extra/unparsed characters found in date: " + extra;
        }
      }

      if ( year === -1 ) {
        year = new Date().getFullYear();
      } else if ( year < 100 ) {
        year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
      }

      if ( doy > -1 ) {
        month = 1;
        day = doy;
        do {
          dim = this._getDaysInMonth( year, month - 1 );
          if ( day <= dim ) {
            break;
          }
          month++;
          day -= dim;
        } while ( true );
      }

      date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
      if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
        throw "Invalid date"; // E.g. 31/02/00
      }
      return date;
    },

    /* Standard date formats. */
    ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
    COOKIE: "D, dd M yy",
    ISO_8601: "yy-mm-dd",
    RFC_822: "D, d M y",
    RFC_850: "DD, dd-M-y",
    RFC_1036: "D, d M y",
    RFC_1123: "D, d M yy",
    RFC_2822: "D, d M yy",
    RSS: "D, d M y", // RFC 822
    TICKS: "!",
    TIMESTAMP: "@",
    W3C: "yy-mm-dd", // ISO 8601

    _ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
		Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),

    /* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
    formatDate: function ( format, date, settings ) {
      if ( !date ) {
        return "";
      }

      var iFormat,
        dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
        dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
        monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
        monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,

        // Check whether a format character is doubled
        lookAhead = function ( match ) {
          var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
          if ( matches ) {
            iFormat++;
          }
          return matches;
        },

        // Format a number, with leading zero if necessary
        formatNumber = function ( match, value, len ) {
          var num = "" + value;
          if ( lookAhead( match ) ) {
            while ( num.length < len ) {
              num = "0" + num;
            }
          }
          return num;
        },

        // Format a name, short or long as requested
        formatName = function ( match, value, shortNames, longNames ) {
          return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
        },
        output = "",
        literal = false;

      if ( date ) {
        for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
          if ( literal ) {
            if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
              literal = false;
            } else {
              output += format.charAt( iFormat );
            }
          } else {
            switch ( format.charAt( iFormat ) ) {
              case "d":
                output += formatNumber( "d", date.getDate(), 2 );
                break;
              case "D":
                output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
                break;
              case "o":
                output += formatNumber( "o",
                  Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
                break;
              case "m":
                output += formatNumber( "m", date.getMonth() + 1, 2 );
                break;
              case "M":
                output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
                break;
              case "y":
                output += ( lookAhead( "y" ) ? date.getFullYear() :
                  ( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
                break;
              case "@":
                output += date.getTime();
                break;
              case "!":
                output += date.getTime() * 10000 + this._ticksTo1970;
                break;
              case "'":
                if ( lookAhead( "'" ) ) {
                  output += "'";
                } else {
                  literal = true;
                }
                break;
              default:
                output += format.charAt( iFormat );
            }
          }
        }
      }
      return output;
    },

    /* Extract all possible characters from the date format. */
    _possibleChars: function ( format ) {
      var iFormat,
        chars = "",
        literal = false,

        // Check whether a format character is doubled
        lookAhead = function ( match ) {
          var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
          if ( matches ) {
            iFormat++;
          }
          return matches;
        };

      for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
        if ( literal ) {
          if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
            literal = false;
          } else {
            chars += format.charAt( iFormat );
          }
        } else {
          switch ( format.charAt( iFormat ) ) {
            case "d": case "m": case "y": case "@":
              chars += "0123456789";
              break;
            case "D": case "M":
              return null; // Accept anything
            case "'":
              if ( lookAhead( "'" ) ) {
                chars += "'";
              } else {
                literal = true;
              }
              break;
            default:
              chars += format.charAt( iFormat );
          }
        }
      }
      return chars;
    },

    /* Get a setting value, defaulting if necessary. */
    _get: function ( inst, name ) {
      return inst.settings[ name ] !== undefined ?
        inst.settings[ name ] : this._defaults[ name ];
    },

    /* Parse existing date and initialise date picker. */
    _setDateFromField: function ( inst, noDefault ) {
      if ( inst.input.val() === inst.lastVal ) {
        return;
      }

      var dateFormat = this._get( inst, "dateFormat" ),
        dates = inst.lastVal = inst.input ? inst.input.val() : null,
        defaultDate = this._getDefaultDate( inst ),
        date = defaultDate,
        settings = this._getFormatConfig( inst );

      try {
        date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
      } catch ( event ) {
        dates = ( noDefault ? "" : dates );
      }
      inst.selectedDay = date.getDate();
      inst.drawMonth = inst.selectedMonth = date.getMonth();
      inst.drawYear = inst.selectedYear = date.getFullYear();
      inst.currentDay = ( dates ? date.getDate() : 0 );
      inst.currentMonth = ( dates ? date.getMonth() : 0 );
      inst.currentYear = ( dates ? date.getFullYear() : 0 );
      this._adjustInstDate( inst );
    },

    /* Retrieve the default date shown on opening. */
    _getDefaultDate: function ( inst ) {
      return this._restrictMinMax( inst,
        this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
    },

    /* A date may be specified as an exact value or a relative one. */
    _determineDate: function ( inst, date, defaultDate ) {
      var offsetNumeric = function ( offset ) {
          var date = new Date();
          date.setDate( date.getDate() + offset );
          return date;
        },
        offsetString = function ( offset ) {
          try {
            return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
              offset, $.datepicker._getFormatConfig( inst ) );
          }
          catch ( e ) {

            // Ignore
          }

          var date = ( offset.toLowerCase().match( /^c/ ) ?
              $.datepicker._getDate( inst ) : null ) || new Date(),
            year = date.getFullYear(),
            month = date.getMonth(),
            day = date.getDate(),
            pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
            matches = pattern.exec( offset );

          while ( matches ) {
            switch ( matches[ 2 ] || "d" ) {
              case "d" : case "D" :
                day += parseInt( matches[ 1 ], 10 ); break;
              case "w" : case "W" :
                day += parseInt( matches[ 1 ], 10 ) * 7; break;
              case "m" : case "M" :
                month += parseInt( matches[ 1 ], 10 );
                day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
                break;
              case "y": case "Y" :
                year += parseInt( matches[ 1 ], 10 );
                day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
                break;
            }
            matches = pattern.exec( offset );
          }
          return new Date( year, month, day );
        },
        newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
          ( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );

      newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
      if ( newDate ) {
        newDate.setHours( 0 );
        newDate.setMinutes( 0 );
        newDate.setSeconds( 0 );
        newDate.setMilliseconds( 0 );
      }
      return this._daylightSavingAdjust( newDate );
    },

    /* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
    _daylightSavingAdjust: function ( date ) {
      if ( !date ) {
        return null;
      }
      date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
      return date;
    },

    /* Set the date(s) directly. */
    _setDate: function ( inst, date, noChange ) {
      var clear = !date,
        origMonth = inst.selectedMonth,
        origYear = inst.selectedYear,
        newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );

      inst.selectedDay = inst.currentDay = newDate.getDate();
      inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
      inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
      if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
        this._notifyChange( inst );
      }
      this._adjustInstDate( inst );
      if ( inst.input ) {
        inst.input.val( clear ? "" : this._formatDate( inst ) );
      }
    },

    /* Retrieve the date(s) directly. */
    _getDate: function ( inst ) {
      var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
        this._daylightSavingAdjust( new Date(
          inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
      return startDate;
    },

    /* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
    _attachHandlers: function ( inst ) {
      var stepMonths = this._get( inst, "stepMonths" ),
        id = "#" + inst.id.replace( /\\\\/g, "\\" );
      inst.dpDiv.find( "[data-handler]" ).map( function () {
        var handler = {
          prev: function () {
            $.datepicker._adjustDate( id, -stepMonths, "M" );
          },
          next: function () {
            $.datepicker._adjustDate( id, +stepMonths, "M" );
          },
          hide: function () {
            $.datepicker._hideDatepicker();
          },
          today: function () {
            $.datepicker._gotoToday( id );
          },
          selectDay: function () {
            $.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
            return false;
          },
          selectMonth: function () {
            $.datepicker._selectMonthYear( id, this, "M" );
            return false;
          },
          selectYear: function () {
            $.datepicker._selectMonthYear( id, this, "Y" );
            return false;
          }
        };
        $( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
      } );
    },

    /* Generate the HTML for the current state of the date picker. */
    _generateHTML: function ( inst ) {
      var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
        controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
        monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
        selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
        cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
        printDate, dRow, tbody, daySettings, otherMonth, unselectable,
        tempDate = new Date(),
        today = this._daylightSavingAdjust(
          new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
        isRTL = this._get( inst, "isRTL" ),
        showButtonPanel = this._get( inst, "showButtonPanel" ),
        hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
        navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
        numMonths = this._getNumberOfMonths( inst ),
        showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
        stepMonths = this._get( inst, "stepMonths" ),
        isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
        currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
          new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
        minDate = this._getMinMaxDate( inst, "min" ),
        maxDate = this._getMinMaxDate( inst, "max" ),
        drawMonth = inst.drawMonth - showCurrentAtPos,
        drawYear = inst.drawYear;

      if ( drawMonth < 0 ) {
        drawMonth += 12;
        drawYear--;
      }
      if ( maxDate ) {
        maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
          maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
        maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
        while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
          drawMonth--;
          if ( drawMonth < 0 ) {
            drawMonth = 11;
            drawYear--;
          }
        }
      }
      inst.drawMonth = drawMonth;
      inst.drawYear = drawYear;

      prevText = this._get( inst, "prevText" );
      prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
        this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
        this._getFormatConfig( inst ) ) );

      prev = ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ?
        "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" :
        ( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" ) );

      nextText = this._get( inst, "nextText" );
      nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
        this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
        this._getFormatConfig( inst ) ) );

      next = ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ?
        "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" :
        ( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" ) );

      currentText = this._get( inst, "currentText" );
      gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
      currentText = ( !navigationAsDateFormat ? currentText :
        this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );

      controls = ( !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get( inst, "closeText" ) + "</button>" : "" );

      buttonPanel = ( showButtonPanel ) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + ( isRTL ? controls : "" ) +
			( this._isInRange( inst, gotoDate ) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "" ) + ( isRTL ? "" : controls ) + "</div>" : "";

      firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
      firstDay = ( isNaN( firstDay ) ? 0 : firstDay );

      showWeek = this._get( inst, "showWeek" );
      dayNames = this._get( inst, "dayNames" );
      dayNamesMin = this._get( inst, "dayNamesMin" );
      monthNames = this._get( inst, "monthNames" );
      monthNamesShort = this._get( inst, "monthNamesShort" );
      beforeShowDay = this._get( inst, "beforeShowDay" );
      showOtherMonths = this._get( inst, "showOtherMonths" );
      selectOtherMonths = this._get( inst, "selectOtherMonths" );
      defaultDate = this._getDefaultDate( inst );
      html = "";

      for ( row = 0; row < numMonths[ 0 ]; row++ ) {
        group = "";
        this.maxRows = 4;
        for ( col = 0; col < numMonths[ 1 ]; col++ ) {
          selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
          cornerClass = " ui-corner-all";
          calender = "";
          if ( isMultiMonth ) {
            calender += "<div class='ui-datepicker-group";
            if ( numMonths[ 1 ] > 1 ) {
              switch ( col ) {
                case 0: calender += " ui-datepicker-group-first";
                  cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
                case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
                  cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
                default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
              }
            }
            calender += "'>";
          }
          calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
					( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
					this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
					  row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
          thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
          for ( dow = 0; dow < 7; dow++ ) { // days of the week
            day = ( dow + firstDay ) % 7;
            thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
						"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
          }
          calender += thead + "</tr></thead><tbody>";
          daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
          if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
            inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
          }
          leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
          curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
          numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); // If multiple months, use the higher number of rows (see #7043)
          this.maxRows = numRows;
          printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
          for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
            calender += "<tr>";
            tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
            for ( dow = 0; dow < 7; dow++ ) { // create date picker days
              daySettings = ( beforeShowDay ?
                beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
              otherMonth = ( printDate.getMonth() !== drawMonth );
              unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
							( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
              tbody += "<td class='" +
							( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
							( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
							( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
							( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?

							// or defaultDate is current printedDate and defaultDate is selectedDate
							  " " + this._dayOverClass : "" ) + // highlight selected day
							( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) + // highlight unselectable days
							( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
							( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
							( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
							( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
							( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
							( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							  ( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
							( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
							( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
              printDate.setDate( printDate.getDate() + 1 );
              printDate = this._daylightSavingAdjust( printDate );
            }
            calender += tbody + "</tr>";
          }
          drawMonth++;
          if ( drawMonth > 11 ) {
            drawMonth = 0;
            drawYear++;
          }
          calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
							( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
          group += calender;
        }
        html += group;
      }
      html += buttonPanel;
      inst._keyEvent = false;
      return html;
    },

    /* Generate the month and year header. */
    _generateMonthYearHeader: function ( inst, drawMonth, drawYear, minDate, maxDate,
      secondary, monthNames, monthNamesShort ) {

      var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
        changeMonth = this._get( inst, "changeMonth" ),
        changeYear = this._get( inst, "changeYear" ),
        showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
        html = "<div class='ui-datepicker-title'>",
        monthHtml = "";

      // Month selection
      if ( secondary || !changeMonth ) {
        monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
      } else {
        inMinYear = ( minDate && minDate.getFullYear() === drawYear );
        inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
        monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
        for ( month = 0; month < 12; month++ ) {
          if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
            monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
          }
        }
        monthHtml += "</select>";
      }

      if ( !showMonthAfterYear ) {
        html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
      }

      // Year selection
      if ( !inst.yearshtml ) {
        inst.yearshtml = "";
        if ( secondary || !changeYear ) {
          html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
        } else {

          // determine range of years to display
          years = this._get( inst, "yearRange" ).split( ":" );
          thisYear = new Date().getFullYear();
          determineYear = function ( value ) {
            var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
              ( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
                parseInt( value, 10 ) ) );
            return ( isNaN( year ) ? thisYear : year );
          };
          year = determineYear( years[ 0 ] );
          endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
          year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
          endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
          inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
          for ( ; year <= endYear; year++ ) {
            inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + year + "</option>";
          }
          inst.yearshtml += "</select>";

          html += inst.yearshtml;
          inst.yearshtml = null;
        }
      }

      html += this._get( inst, "yearSuffix" );
      if ( showMonthAfterYear ) {
        html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
      }
      html += "</div>"; // Close datepicker_header
      return html;
    },

    /* Adjust one of the date sub-fields. */
    _adjustInstDate: function ( inst, offset, period ) {
      var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
        month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
        day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
        date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );

      inst.selectedDay = date.getDate();
      inst.drawMonth = inst.selectedMonth = date.getMonth();
      inst.drawYear = inst.selectedYear = date.getFullYear();
      if ( period === "M" || period === "Y" ) {
        this._notifyChange( inst );
      }
    },

    /* Ensure a date is within any min/max bounds. */
    _restrictMinMax: function ( inst, date ) {
      var minDate = this._getMinMaxDate( inst, "min" ),
        maxDate = this._getMinMaxDate( inst, "max" ),
        newDate = ( minDate && date < minDate ? minDate : date );
      return ( maxDate && newDate > maxDate ? maxDate : newDate );
    },

    /* Notify change of month/year. */
    _notifyChange: function ( inst ) {
      var onChange = this._get( inst, "onChangeMonthYear" );
      if ( onChange ) {
        onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
          [ inst.selectedYear, inst.selectedMonth + 1, inst ] );
      }
    },

    /* Determine the number of months to show. */
    _getNumberOfMonths: function ( inst ) {
      var numMonths = this._get( inst, "numberOfMonths" );
      return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
    },

    /* Determine the current maximum date - ensure no time components are set. */
    _getMinMaxDate: function ( inst, minMax ) {
      return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
    },

    /* Find the number of days in a given month. */
    _getDaysInMonth: function ( year, month ) {
      return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
    },

    /* Find the day of the week of the first of a month. */
    _getFirstDayOfMonth: function ( year, month ) {
      return new Date( year, month, 1 ).getDay();
    },

    /* Determines if we should allow a "next/prev" month display change. */
    _canAdjustMonth: function ( inst, offset, curYear, curMonth ) {
      var numMonths = this._getNumberOfMonths( inst ),
        date = this._daylightSavingAdjust( new Date( curYear,
          curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );

      if ( offset < 0 ) {
        date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
      }
      return this._isInRange( inst, date );
    },

    /* Is the given date in the accepted range? */
    _isInRange: function ( inst, date ) {
      var yearSplit, currentYear,
        minDate = this._getMinMaxDate( inst, "min" ),
        maxDate = this._getMinMaxDate( inst, "max" ),
        minYear = null,
        maxYear = null,
        years = this._get( inst, "yearRange" );
      if ( years ) {
        yearSplit = years.split( ":" );
        currentYear = new Date().getFullYear();
        minYear = parseInt( yearSplit[ 0 ], 10 );
        maxYear = parseInt( yearSplit[ 1 ], 10 );
        if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
          minYear += currentYear;
        }
        if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
          maxYear += currentYear;
        }
      }

      return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
			( !maxDate || date.getTime() <= maxDate.getTime() ) &&
			( !minYear || date.getFullYear() >= minYear ) &&
			( !maxYear || date.getFullYear() <= maxYear ) );
    },

    /* Provide the configuration settings for formatting/parsing. */
    _getFormatConfig: function ( inst ) {
      var shortYearCutoff = this._get( inst, "shortYearCutoff" );
      shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
        new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
      return { shortYearCutoff: shortYearCutoff,
        dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
        monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
    },

    /* Format the given date for display. */
    _formatDate: function ( inst, day, month, year ) {
      if ( !day ) {
        inst.currentDay = inst.selectedDay;
        inst.currentMonth = inst.selectedMonth;
        inst.currentYear = inst.selectedYear;
      }
      var date = ( day ? ( typeof day === "object" ? day :
        this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
        this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
      return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
    }
  } );

  /*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
  function datepicker_bindHover( dpDiv ) {
    var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
    return dpDiv.on( "mouseout", selector, function () {
      $( this ).removeClass( "ui-state-hover" );
      if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
        $( this ).removeClass( "ui-datepicker-prev-hover" );
      }
      if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
        $( this ).removeClass( "ui-datepicker-next-hover" );
      }
    } )
      .on( "mouseover", selector, datepicker_handleMouseover );
  }

  function datepicker_handleMouseover() {
    if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
      $( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
      $( this ).addClass( "ui-state-hover" );
      if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
        $( this ).addClass( "ui-datepicker-prev-hover" );
      }
      if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
        $( this ).addClass( "ui-datepicker-next-hover" );
      }
    }
  }

  /* jQuery extend now ignores nulls! */
  function datepicker_extendRemove( target, props ) {
    $.extend( target, props );
    for ( var name in props ) {
      if ( props[ name ] == null ) {
        target[ name ] = props[ name ];
      }
    }
    return target;
  }

  /* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
  $.fn.datepicker = function ( options ) {

    /* Verify an empty collection wasn't passed - Fixes #6976 */
    if ( !this.length ) {
      return this;
    }

    /* Initialise the date picker. */
    if ( !$.datepicker.initialized ) {
      $( document ).on( "mousedown", $.datepicker._checkExternalClick );
      $.datepicker.initialized = true;
    }

    /* Append datepicker main container to body if not exist. */
    if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
      $( "body" ).append( $.datepicker.dpDiv );
    }

    var otherArgs = Array.prototype.slice.call( arguments, 1 );
    if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
      return $.datepicker[ "_" + options + "Datepicker" ].
        apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
    }
    if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
      return $.datepicker[ "_" + options + "Datepicker" ].
        apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
    }
    return this.each( function () {
      typeof options === "string" ?
        $.datepicker[ "_" + options + "Datepicker" ].
          apply( $.datepicker, [ this ].concat( otherArgs ) ) :
        $.datepicker._attachDatepicker( this, options );
    } );
  };

  $.datepicker = new Datepicker(); // singleton instance
  $.datepicker.initialized = false;
  $.datepicker.uuid = new Date().getTime();
  $.datepicker.version = "1.12.1";

  var widgetsDatepicker = $.datepicker;

  // This file is deprecated
  var ie = $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

  /* !
 * jQuery UI Mouse 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Mouse
  // >>group: Widgets
  // >>description: Abstracts mouse-based interactions to assist in creating certain widgets.
  // >>docs: http://api.jqueryui.com/mouse/

  var mouseHandled = false;
  $( document ).on( "mouseup", function () {
    mouseHandled = false;
  } );

  var widgetsMouse = $.widget( "ui.mouse", {
    version: "1.12.1",
    options: {
      cancel: "input, textarea, button, select, option",
      distance: 1,
      delay: 0
    },
    _mouseInit: function () {
      var that = this;

      this.element
        .on( "mousedown." + this.widgetName, function ( event ) {
          return that._mouseDown( event );
        } )
        .on( "click." + this.widgetName, function ( event ) {
          if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
            $.removeData( event.target, that.widgetName + ".preventClickEvent" );
            event.stopImmediatePropagation();
            return false;
          }
        } );

      this.started = false;
    },

    // TODO: make sure destroying one instance of mouse doesn't mess with
    // other instances of mouse
    _mouseDestroy: function () {
      this.element.off( "." + this.widgetName );
      if ( this._mouseMoveDelegate ) {
        this.document
          .off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
          .off( "mouseup." + this.widgetName, this._mouseUpDelegate );
      }
    },

    _mouseDown: function ( event ) {

      // don't let more than one widget handle mouseStart
      if ( mouseHandled ) {
        return;
      }

      this._mouseMoved = false;

      // We may have missed mouseup (out of window)
      ( this._mouseStarted && this._mouseUp( event ) );

      this._mouseDownEvent = event;

      var that = this,
        btnIsLeft = ( event.which === 1 ),

        // event.target.nodeName works around a bug in IE 8 with
        // disabled inputs (#7620)
        elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
          $( event.target ).closest( this.options.cancel ).length : false );
      if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
        return true;
      }

      this.mouseDelayMet = !this.options.delay;
      if ( !this.mouseDelayMet ) {
        this._mouseDelayTimer = setTimeout( function () {
          that.mouseDelayMet = true;
        }, this.options.delay );
      }

      if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
        this._mouseStarted = ( this._mouseStart( event ) !== false );
        if ( !this._mouseStarted ) {
          event.preventDefault();
          return true;
        }
      }

      // Click event may never have fired (Gecko & Opera)
      if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
        $.removeData( event.target, this.widgetName + ".preventClickEvent" );
      }

      // These delegates are required to keep context
      this._mouseMoveDelegate = function ( event ) {
        return that._mouseMove( event );
      };
      this._mouseUpDelegate = function ( event ) {
        return that._mouseUp( event );
      };

      this.document
        .on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
        .on( "mouseup." + this.widgetName, this._mouseUpDelegate );

      event.preventDefault();

      mouseHandled = true;
      return true;
    },

    _mouseMove: function ( event ) {

      // Only check for mouseups outside the document if you've moved inside the document
      // at least once. This prevents the firing of mouseup in the case of IE<9, which will
      // fire a mousemove event if content is placed under the cursor. See #7778
      // Support: IE <9
      if ( this._mouseMoved ) {

        // IE mouseup check - mouseup happened when mouse was out of window
        if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
          return this._mouseUp( event );

          // Iframe mouseup check - mouseup occurred in another document
        } else if ( !event.which ) {

          // Support: Safari <=8 - 9
          // Safari sets which to 0 if you press any of the following keys
          // during a drag (#14461)
          if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
            this.ignoreMissingWhich = true;
          } else if ( !this.ignoreMissingWhich ) {
            return this._mouseUp( event );
          }
        }
      }

      if ( event.which || event.button ) {
        this._mouseMoved = true;
      }

      if ( this._mouseStarted ) {
        this._mouseDrag( event );
        return event.preventDefault();
      }

      if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
        this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
        ( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
      }

      return !this._mouseStarted;
    },

    _mouseUp: function ( event ) {
      this.document
        .off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
        .off( "mouseup." + this.widgetName, this._mouseUpDelegate );

      if ( this._mouseStarted ) {
        this._mouseStarted = false;

        if ( event.target === this._mouseDownEvent.target ) {
          $.data( event.target, this.widgetName + ".preventClickEvent", true );
        }

        this._mouseStop( event );
      }

      if ( this._mouseDelayTimer ) {
        clearTimeout( this._mouseDelayTimer );
        delete this._mouseDelayTimer;
      }

      this.ignoreMissingWhich = false;
      mouseHandled = false;
      event.preventDefault();
    },

    _mouseDistanceMet: function ( event ) {
      return ( Math.max(
        Math.abs( this._mouseDownEvent.pageX - event.pageX ),
        Math.abs( this._mouseDownEvent.pageY - event.pageY )
      ) >= this.options.distance
      );
    },

    _mouseDelayMet: function ( /* event */ ) {
      return this.mouseDelayMet;
    },

    // These are placeholder methods, to be overriden by extending plugin
    _mouseStart: function ( /* event */ ) {},
    _mouseDrag: function ( /* event */ ) {},
    _mouseStop: function ( /* event */ ) {},
    _mouseCapture: function ( /* event */ ) { return true; }
  } );

  // $.ui.plugin is deprecated. Use $.widget() extensions instead.
  var plugin = $.ui.plugin = {
    add: function ( module, option, set ) {
      var i,
        proto = $.ui[ module ].prototype;
      for ( i in set ) {
        proto.plugins[ i ] = proto.plugins[ i ] || [];
        proto.plugins[ i ].push( [ option, set[ i ] ] );
      }
    },
    call: function ( instance, name, args, allowDisconnected ) {
      var i,
        set = instance.plugins[ name ];

      if ( !set ) {
        return;
      }

      if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
        return;
      }

      for ( i = 0; i < set.length; i++ ) {
        if ( instance.options[ set[ i ][ 0 ] ] ) {
          set[ i ][ 1 ].apply( instance.element, args );
        }
      }
    }
  };

  var safeBlur = $.ui.safeBlur = function ( element ) {

    // Support: IE9 - 10 only
    // If the <body> is blurred, IE will switch windows, see #9420
    if ( element && element.nodeName.toLowerCase() !== "body" ) {
      $( element ).trigger( "blur" );
    }
  };

  /* !
 * jQuery UI Draggable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Draggable
  // >>group: Interactions
  // >>description: Enables dragging functionality for any element.
  // >>docs: http://api.jqueryui.com/draggable/
  // >>demos: http://jqueryui.com/draggable/
  // >>css.structure: ../../themes/base/draggable.css

  $.widget( "ui.draggable", $.ui.mouse, {
    version: "1.12.1",
    widgetEventPrefix: "drag",
    options: {
      addClasses: true,
      appendTo: "parent",
      axis: false,
      connectToSortable: false,
      containment: false,
      cursor: "auto",
      cursorAt: false,
      grid: false,
      handle: false,
      helper: "original",
      iframeFix: false,
      opacity: false,
      refreshPositions: false,
      revert: false,
      revertDuration: 500,
      scope: "default",
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      snap: false,
      snapMode: "both",
      snapTolerance: 20,
      stack: false,
      zIndex: false,

      // Callbacks
      drag: null,
      start: null,
      stop: null
    },
    _create: function () {

      if ( this.options.helper === "original" ) {
        this._setPositionRelative();
      }
      if ( this.options.addClasses ) {
        this._addClass( "ui-draggable" );
      }
      this._setHandleClassName();

      this._mouseInit();
    },

    _setOption: function ( key, value ) {
      this._super( key, value );
      if ( key === "handle" ) {
        this._removeHandleClassName();
        this._setHandleClassName();
      }
    },

    _destroy: function () {
      if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
        this.destroyOnClear = true;
        return;
      }
      this._removeHandleClassName();
      this._mouseDestroy();
    },

    _mouseCapture: function ( event ) {
      var o = this.options;

      // Among others, prevent a drag on a resizable-handle
      if ( this.helper || o.disabled ||
				$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
        return false;
      }

      // Quit if we're not on a valid handle
      this.handle = this._getHandle( event );
      if ( !this.handle ) {
        return false;
      }

      this._blurActiveElement( event );

      this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

      return true;

    },

    _blockFrames: function ( selector ) {
      this.iframeBlocks = this.document.find( selector ).map( function () {
        var iframe = $( this );

        return $( "<div>" )
          .css( "position", "absolute" )
          .appendTo( iframe.parent() )
          .outerWidth( iframe.outerWidth() )
          .outerHeight( iframe.outerHeight() )
          .offset( iframe.offset() )[ 0 ];
      } );
    },

    _unblockFrames: function () {
      if ( this.iframeBlocks ) {
        this.iframeBlocks.remove();
        delete this.iframeBlocks;
      }
    },

    _blurActiveElement: function ( event ) {
      var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
        target = $( event.target );

      // Don't blur if the event occurred on an element that is within
      // the currently focused element
      // See #10527, #12472
      if ( target.closest( activeElement ).length ) {
        return;
      }

      // Blur any element that currently has focus, see #4261
      $.ui.safeBlur( activeElement );
    },

    _mouseStart: function ( event ) {

      var o = this.options;

      // Create and append the visible helper
      this.helper = this._createHelper( event );

      this._addClass( this.helper, "ui-draggable-dragging" );

      // Cache the helper size
      this._cacheHelperProportions();

      // If ddmanager is used for droppables, set the global draggable
      if ( $.ui.ddmanager ) {
        $.ui.ddmanager.current = this;
      }

      /*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

      // Cache the margins of the original element
      this._cacheMargins();

      // Store the helper's css position
      this.cssPosition = this.helper.css( "position" );
      this.scrollParent = this.helper.scrollParent( true );
      this.offsetParent = this.helper.offsetParent();
      this.hasFixedAncestor = this.helper.parents().filter( function () {
        return $( this ).css( "position" ) === "fixed";
      } ).length > 0;

      // The element's absolute position on the page minus margins
      this.positionAbs = this.element.offset();
      this._refreshOffsets( event );

      // Generate the original position
      this.originalPosition = this.position = this._generatePosition( event, false );
      this.originalPageX = event.pageX;
      this.originalPageY = event.pageY;

      // Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      ( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

      // Set a containment if given in the options
      this._setContainment();

      // Trigger event + callbacks
      if ( this._trigger( "start", event ) === false ) {
        this._clear();
        return false;
      }

      // Recache the helper size
      this._cacheHelperProportions();

      // Prepare the droppable offsets
      if ( $.ui.ddmanager && !o.dropBehaviour ) {
        $.ui.ddmanager.prepareOffsets( this, event );
      }

      // Execute the drag once - this causes the helper not to be visible before getting its
      // correct position
      this._mouseDrag( event, true );

      // If the ddmanager is used for droppables, inform the manager that dragging has started
      // (see #5003)
      if ( $.ui.ddmanager ) {
        $.ui.ddmanager.dragStart( this, event );
      }

      return true;
    },

    _refreshOffsets: function ( event ) {
      this.offset = {
        top: this.positionAbs.top - this.margins.top,
        left: this.positionAbs.left - this.margins.left,
        scroll: false,
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset()
      };

      this.offset.click = {
        left: event.pageX - this.offset.left,
        top: event.pageY - this.offset.top
      };
    },

    _mouseDrag: function ( event, noPropagation ) {

      // reset any necessary cached properties (see #5009)
      if ( this.hasFixedAncestor ) {
        this.offset.parent = this._getParentOffset();
      }

      // Compute the helpers position
      this.position = this._generatePosition( event, true );
      this.positionAbs = this._convertPositionTo( "absolute" );

      // Call plugins and callbacks and use the resulting position if something is returned
      if ( !noPropagation ) {
        var ui = this._uiHash();
        if ( this._trigger( "drag", event, ui ) === false ) {
          this._mouseUp( new $.Event( "mouseup", event ) );
          return false;
        }
        this.position = ui.position;
      }

      this.helper[ 0 ].style.left = this.position.left + "px";
      this.helper[ 0 ].style.top = this.position.top + "px";

      if ( $.ui.ddmanager ) {
        $.ui.ddmanager.drag( this, event );
      }

      return false;
    },

    _mouseStop: function ( event ) {

      // If we are using droppables, inform the manager about the drop
      var that = this,
        dropped = false;
      if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
        dropped = $.ui.ddmanager.drop( this, event );
      }

      // if a drop comes from outside (a sortable)
      if ( this.dropped ) {
        dropped = this.dropped;
        this.dropped = false;
      }

      if ( ( this.options.revert === "invalid" && !dropped ) ||
				( this.options.revert === "valid" && dropped ) ||
				this.options.revert === true || ( $.isFunction( this.options.revert ) &&
				this.options.revert.call( this.element, dropped ) )
      ) {
        $( this.helper ).animate(
          this.originalPosition,
          parseInt( this.options.revertDuration, 10 ),
          function () {
            if ( that._trigger( "stop", event ) !== false ) {
              that._clear();
            }
          }
        );
      } else {
        if ( this._trigger( "stop", event ) !== false ) {
          this._clear();
        }
      }

      return false;
    },

    _mouseUp: function ( event ) {
      this._unblockFrames();

      // If the ddmanager is used for droppables, inform the manager that dragging has stopped
      // (see #5003)
      if ( $.ui.ddmanager ) {
        $.ui.ddmanager.dragStop( this, event );
      }

      // Only need to focus if the event occurred on the draggable itself, see #10527
      if ( this.handleElement.is( event.target ) ) {

        // The interaction is over; whether or not the click resulted in a drag,
        // focus the element
        this.element.trigger( "focus" );
      }

      return $.ui.mouse.prototype._mouseUp.call( this, event );
    },

    cancel: function () {

      if ( this.helper.is( ".ui-draggable-dragging" ) ) {
        this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
      } else {
        this._clear();
      }

      return this;

    },

    _getHandle: function ( event ) {
      return this.options.handle ?
        !!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
        true;
    },

    _setHandleClassName: function () {
      this.handleElement = this.options.handle ?
        this.element.find( this.options.handle ) : this.element;
      this._addClass( this.handleElement, "ui-draggable-handle" );
    },

    _removeHandleClassName: function () {
      this._removeClass( this.handleElement, "ui-draggable-handle" );
    },

    _createHelper: function ( event ) {

      var o = this.options,
        helperIsFunction = $.isFunction( o.helper ),
        helper = helperIsFunction ?
          $( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
          ( o.helper === "clone" ?
            this.element.clone().removeAttr( "id" ) :
            this.element );

      if ( !helper.parents( "body" ).length ) {
        helper.appendTo( ( o.appendTo === "parent" ?
          this.element[ 0 ].parentNode :
          o.appendTo ) );
      }

      // Http://bugs.jqueryui.com/ticket/9446
      // a helper function can return the original element
      // which wouldn't have been set to relative in _create
      if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
        this._setPositionRelative();
      }

      if ( helper[ 0 ] !== this.element[ 0 ] &&
				!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
        helper.css( "position", "absolute" );
      }

      return helper;

    },

    _setPositionRelative: function () {
      if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
        this.element[ 0 ].style.position = "relative";
      }
    },

    _adjustOffsetFromHelper: function ( obj ) {
      if ( typeof obj === "string" ) {
        obj = obj.split( " " );
      }
      if ( $.isArray( obj ) ) {
        obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
      }
      if ( "left" in obj ) {
        this.offset.click.left = obj.left + this.margins.left;
      }
      if ( "right" in obj ) {
        this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
      }
      if ( "top" in obj ) {
        this.offset.click.top = obj.top + this.margins.top;
      }
      if ( "bottom" in obj ) {
        this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
      }
    },

    _isRootNode: function ( element ) {
      return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
    },

    _getParentOffset: function () {

      // Get the offsetParent and cache its position
      var po = this.offsetParent.offset(),
        document = this.document[ 0 ];

      // This is a special case where we need to modify a offset calculated on start, since the
      // following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the
      // next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
      // the document, which means that the scroll is included in the initial calculation of the
      // offset of the parent, and never recalculated upon drag
      if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
        po.left += this.scrollParent.scrollLeft();
        po.top += this.scrollParent.scrollTop();
      }

      if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
        po = { top: 0, left: 0 };
      }

      return {
        top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
        left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
      };

    },

    _getRelativeOffset: function () {
      if ( this.cssPosition !== "relative" ) {
        return { top: 0, left: 0 };
      }

      var p = this.element.position(),
        scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

      return {
        top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
        left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
      };

    },

    _cacheMargins: function () {
      this.margins = {
        left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
        top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
        right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
        bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
      };
    },

    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight()
      };
    },

    _setContainment: function () {

      var isUserScrollable, c, ce,
        o = this.options,
        document = this.document[ 0 ];

      this.relativeContainer = null;

      if ( !o.containment ) {
        this.containment = null;
        return;
      }

      if ( o.containment === "window" ) {
        this.containment = [
          $( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
          $( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
          $( window ).scrollLeft() + $( window ).width() -
					this.helperProportions.width - this.margins.left,
          $( window ).scrollTop() +
					( $( window ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
        ];
        return;
      }

      if ( o.containment === "document" ) {
        this.containment = [
          0,
          0,
          $( document ).width() - this.helperProportions.width - this.margins.left,
          ( $( document ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
        ];
        return;
      }

      if ( o.containment.constructor === Array ) {
        this.containment = o.containment;
        return;
      }

      if ( o.containment === "parent" ) {
        o.containment = this.helper[ 0 ].parentNode;
      }

      c = $( o.containment );
      ce = c[ 0 ];

      if ( !ce ) {
        return;
      }

      isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

      this.containment = [
        ( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
        ( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
        ( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
        ( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
      ];
      this.relativeContainer = c;
    },

    _convertPositionTo: function ( d, pos ) {

      if ( !pos ) {
        pos = this.position;
      }

      var mod = d === "absolute" ? 1 : -1,
        scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

      return {
        top: (

        // The absolute mouse position
          pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
				  -this.offset.scroll.top :
				  ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
        ),
        left: (

        // The absolute mouse position
          pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
				  -this.offset.scroll.left :
				  ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
        )
      };

    },

    _generatePosition: function ( event, constrainPosition ) {

      var containment, co, top, left,
        o = this.options,
        scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
        pageX = event.pageX,
        pageY = event.pageY;

      // Cache the scroll
      if ( !scrollIsRootNode || !this.offset.scroll ) {
        this.offset.scroll = {
          top: this.scrollParent.scrollTop(),
          left: this.scrollParent.scrollLeft()
        };
      }

      /*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

      // If we are not dragging yet, we won't check for options
      if ( constrainPosition ) {
        if ( this.containment ) {
          if ( this.relativeContainer ) {
            co = this.relativeContainer.offset();
            containment = [
              this.containment[ 0 ] + co.left,
              this.containment[ 1 ] + co.top,
              this.containment[ 2 ] + co.left,
              this.containment[ 3 ] + co.top
            ];
          } else {
            containment = this.containment;
          }

          if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
            pageX = containment[ 0 ] + this.offset.click.left;
          }
          if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
            pageY = containment[ 1 ] + this.offset.click.top;
          }
          if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
            pageX = containment[ 2 ] + this.offset.click.left;
          }
          if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
            pageY = containment[ 3 ] + this.offset.click.top;
          }
        }

        if ( o.grid ) {

          // Check for grid elements set to 0 to prevent divide by 0 error causing invalid
          // argument errors in IE (see ticket #6950)
          top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
					this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
          pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
					top - this.offset.click.top > containment[ 3 ] ) ?
            top :
            ( ( top - this.offset.click.top >= containment[ 1 ] ) ?
              top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;

          left = o.grid[ 0 ] ? this.originalPageX +
					Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
            this.originalPageX;
          pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
					left - this.offset.click.left > containment[ 2 ] ) ?
            left :
            ( ( left - this.offset.click.left >= containment[ 0 ] ) ?
              left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
        }

        if ( o.axis === "y" ) {
          pageX = this.originalPageX;
        }

        if ( o.axis === "x" ) {
          pageY = this.originalPageY;
        }
      }

      return {
        top: (

        // The absolute mouse position
          pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( this.cssPosition === "fixed" ?
				  -this.offset.scroll.top :
				  ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
        ),
        left: (

        // The absolute mouse position
          pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( this.cssPosition === "fixed" ?
				  -this.offset.scroll.left :
				  ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
        )
      };

    },

    _clear: function () {
      this._removeClass( this.helper, "ui-draggable-dragging" );
      if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
        this.helper.remove();
      }
      this.helper = null;
      this.cancelHelperRemoval = false;
      if ( this.destroyOnClear ) {
        this.destroy();
      }
    },

    // From now on bulk stuff - mainly helpers

    _trigger: function ( type, event, ui ) {
      ui = ui || this._uiHash();
      $.ui.plugin.call( this, type, [ event, ui, this ], true );

      // Absolute position and offset (see #6884 ) have to be recalculated after plugins
      if ( /^(drag|start|stop)/.test( type ) ) {
        this.positionAbs = this._convertPositionTo( "absolute" );
        ui.offset = this.positionAbs;
      }
      return $.Widget.prototype._trigger.call( this, type, event, ui );
    },

    plugins: {},

    _uiHash: function () {
      return {
        helper: this.helper,
        position: this.position,
        originalPosition: this.originalPosition,
        offset: this.positionAbs
      };
    }

  } );

  $.ui.plugin.add( "draggable", "connectToSortable", {
    start: function ( event, ui, draggable ) {
      var uiSortable = $.extend( {}, ui, {
        item: draggable.element
      } );

      draggable.sortables = [];
      $( draggable.options.connectToSortable ).each( function () {
        var sortable = $( this ).sortable( "instance" );

        if ( sortable && !sortable.options.disabled ) {
          draggable.sortables.push( sortable );

          // RefreshPositions is called at drag start to refresh the containerCache
          // which is used in drag. This ensures it's initialized and synchronized
          // with any changes that might have happened on the page since initialization.
          sortable.refreshPositions();
          sortable._trigger( "activate", event, uiSortable );
        }
      } );
    },
    stop: function ( event, ui, draggable ) {
      var uiSortable = $.extend( {}, ui, {
        item: draggable.element
      } );

      draggable.cancelHelperRemoval = false;

      $.each( draggable.sortables, function () {
        var sortable = this;

        if ( sortable.isOver ) {
          sortable.isOver = 0;

          // Allow this sortable to handle removing the helper
          draggable.cancelHelperRemoval = true;
          sortable.cancelHelperRemoval = false;

          // Use _storedCSS To restore properties in the sortable,
          // as this also handles revert (#9675) since the draggable
          // may have modified them in unexpected ways (#8809)
          sortable._storedCSS = {
            position: sortable.placeholder.css( "position" ),
            top: sortable.placeholder.css( "top" ),
            left: sortable.placeholder.css( "left" )
          };

          sortable._mouseStop( event );

          // Once drag has ended, the sortable should return to using
          // its original helper, not the shared helper from draggable
          sortable.options.helper = sortable.options._helper;
        } else {

          // Prevent this Sortable from removing the helper.
          // However, don't set the draggable to remove the helper
          // either as another connected Sortable may yet handle the removal.
          sortable.cancelHelperRemoval = true;

          sortable._trigger( "deactivate", event, uiSortable );
        }
      } );
    },
    drag: function ( event, ui, draggable ) {
      $.each( draggable.sortables, function () {
        var innermostIntersecting = false,
          sortable = this;

        // Copy over variables that sortable's _intersectsWith uses
        sortable.positionAbs = draggable.positionAbs;
        sortable.helperProportions = draggable.helperProportions;
        sortable.offset.click = draggable.offset.click;

        if ( sortable._intersectsWith( sortable.containerCache ) ) {
          innermostIntersecting = true;

          $.each( draggable.sortables, function () {

            // Copy over variables that sortable's _intersectsWith uses
            this.positionAbs = draggable.positionAbs;
            this.helperProportions = draggable.helperProportions;
            this.offset.click = draggable.offset.click;

            if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
              innermostIntersecting = false;
            }

            return innermostIntersecting;
          } );
        }

        if ( innermostIntersecting ) {

          // If it intersects, we use a little isOver variable and set it once,
          // so that the move-in stuff gets fired only once.
          if ( !sortable.isOver ) {
            sortable.isOver = 1;

            // Store draggable's parent in case we need to reappend to it later.
            draggable._parent = ui.helper.parent();

            sortable.currentItem = ui.helper
              .appendTo( sortable.element )
              .data( "ui-sortable-item", true );

            // Store helper option to later restore it
            sortable.options._helper = sortable.options.helper;

            sortable.options.helper = function () {
              return ui.helper[ 0 ];
            };

            // Fire the start events of the sortable with our passed browser event,
            // and our own helper (so it doesn't create a new one)
            event.target = sortable.currentItem[ 0 ];
            sortable._mouseCapture( event, true );
            sortable._mouseStart( event, true, true );

            // Because the browser event is way off the new appended portlet,
            // modify necessary variables to reflect the changes
            sortable.offset.click.top = draggable.offset.click.top;
            sortable.offset.click.left = draggable.offset.click.left;
            sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
            sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

            draggable._trigger( "toSortable", event );

            // Inform draggable that the helper is in a valid drop zone,
            // used solely in the revert option to handle "valid/invalid".
            draggable.dropped = sortable.element;

            // Need to refreshPositions of all sortables in the case that
            // adding to one sortable changes the location of the other sortables (#9675)
            $.each( draggable.sortables, function () {
              this.refreshPositions();
            } );

            // Hack so receive/update callbacks work (mostly)
            draggable.currentItem = draggable.element;
            sortable.fromOutside = draggable;
          }

          if ( sortable.currentItem ) {
            sortable._mouseDrag( event );

            // Copy the sortable's position because the draggable's can potentially reflect
            // a relative position, while sortable is always absolute, which the dragged
            // element has now become. (#8809)
            ui.position = sortable.position;
          }
        } else {

          // If it doesn't intersect with the sortable, and it intersected before,
          // we fake the drag stop of the sortable, but make sure it doesn't remove
          // the helper by using cancelHelperRemoval.
          if ( sortable.isOver ) {

            sortable.isOver = 0;
            sortable.cancelHelperRemoval = true;

            // Calling sortable's mouseStop would trigger a revert,
            // so revert must be temporarily false until after mouseStop is called.
            sortable.options._revert = sortable.options.revert;
            sortable.options.revert = false;

            sortable._trigger( "out", event, sortable._uiHash( sortable ) );
            sortable._mouseStop( event, true );

            // Restore sortable behaviors that were modfied
            // when the draggable entered the sortable area (#9481)
            sortable.options.revert = sortable.options._revert;
            sortable.options.helper = sortable.options._helper;

            if ( sortable.placeholder ) {
              sortable.placeholder.remove();
            }

            // Restore and recalculate the draggable's offset considering the sortable
            // may have modified them in unexpected ways. (#8809, #10669)
            ui.helper.appendTo( draggable._parent );
            draggable._refreshOffsets( event );
            ui.position = draggable._generatePosition( event, true );

            draggable._trigger( "fromSortable", event );

            // Inform draggable that the helper is no longer in a valid drop zone
            draggable.dropped = false;

            // Need to refreshPositions of all sortables just in case removing
            // from one sortable changes the location of other sortables (#9675)
            $.each( draggable.sortables, function () {
              this.refreshPositions();
            } );
          }
        }
      } );
    }
  } );

  $.ui.plugin.add( "draggable", "cursor", {
    start: function ( event, ui, instance ) {
      var t = $( "body" ),
        o = instance.options;

      if ( t.css( "cursor" ) ) {
        o._cursor = t.css( "cursor" );
      }
      t.css( "cursor", o.cursor );
    },
    stop: function ( event, ui, instance ) {
      var o = instance.options;
      if ( o._cursor ) {
        $( "body" ).css( "cursor", o._cursor );
      }
    }
  } );

  $.ui.plugin.add( "draggable", "opacity", {
    start: function ( event, ui, instance ) {
      var t = $( ui.helper ),
        o = instance.options;
      if ( t.css( "opacity" ) ) {
        o._opacity = t.css( "opacity" );
      }
      t.css( "opacity", o.opacity );
    },
    stop: function ( event, ui, instance ) {
      var o = instance.options;
      if ( o._opacity ) {
        $( ui.helper ).css( "opacity", o._opacity );
      }
    }
  } );

  $.ui.plugin.add( "draggable", "scroll", {
    start: function ( event, ui, i ) {
      if ( !i.scrollParentNotHidden ) {
        i.scrollParentNotHidden = i.helper.scrollParent( false );
      }

      if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
				i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
        i.overflowOffset = i.scrollParentNotHidden.offset();
      }
    },
    drag: function ( event, ui, i ) {

      var o = i.options,
        scrolled = false,
        scrollParent = i.scrollParentNotHidden[ 0 ],
        document = i.document[ 0 ];

      if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
        if ( !o.axis || o.axis !== "x" ) {
          if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
						o.scrollSensitivity ) {
            scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
          } else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
            scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
          }
        }

        if ( !o.axis || o.axis !== "y" ) {
          if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
						o.scrollSensitivity ) {
            scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
          } else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
            scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
          }
        }

      } else {

        if ( !o.axis || o.axis !== "x" ) {
          if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
            scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
          } else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
						o.scrollSensitivity ) {
            scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
          }
        }

        if ( !o.axis || o.axis !== "y" ) {
          if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
            scrolled = $( document ).scrollLeft(
              $( document ).scrollLeft() - o.scrollSpeed
            );
          } else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
						o.scrollSensitivity ) {
            scrolled = $( document ).scrollLeft(
              $( document ).scrollLeft() + o.scrollSpeed
            );
          }
        }

      }

      if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
        $.ui.ddmanager.prepareOffsets( i, event );
      }

    }
  } );

  $.ui.plugin.add( "draggable", "snap", {
    start: function ( event, ui, i ) {

      var o = i.options;

      i.snapElements = [];

      $( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
        .each( function () {
          var $t = $( this ),
            $o = $t.offset();
          if ( this !== i.element[ 0 ] ) {
            i.snapElements.push( {
              item: this,
              width: $t.outerWidth(), height: $t.outerHeight(),
              top: $o.top, left: $o.left
            } );
          }
        } );

    },
    drag: function ( event, ui, inst ) {

      var ts, bs, ls, rs, l, r, t, b, i, first,
        o = inst.options,
        d = o.snapTolerance,
        x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
        y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

      for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {

        l = inst.snapElements[ i ].left - inst.margins.left;
        r = l + inst.snapElements[ i ].width;
        t = inst.snapElements[ i ].top - inst.margins.top;
        b = t + inst.snapElements[ i ].height;

        if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
					!$.contains( inst.snapElements[ i ].item.ownerDocument,
					  inst.snapElements[ i ].item ) ) {
          if ( inst.snapElements[ i ].snapping ) {
            ( inst.options.snap.release &&
						inst.options.snap.release.call(
						  inst.element,
						  event,
						  $.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
						) );
          }
          inst.snapElements[ i ].snapping = false;
          continue;
        }

        if ( o.snapMode !== "inner" ) {
          ts = Math.abs( t - y2 ) <= d;
          bs = Math.abs( b - y1 ) <= d;
          ls = Math.abs( l - x2 ) <= d;
          rs = Math.abs( r - x1 ) <= d;
          if ( ts ) {
            ui.position.top = inst._convertPositionTo( "relative", {
              top: t - inst.helperProportions.height,
              left: 0
            } ).top;
          }
          if ( bs ) {
            ui.position.top = inst._convertPositionTo( "relative", {
              top: b,
              left: 0
            } ).top;
          }
          if ( ls ) {
            ui.position.left = inst._convertPositionTo( "relative", {
              top: 0,
              left: l - inst.helperProportions.width
            } ).left;
          }
          if ( rs ) {
            ui.position.left = inst._convertPositionTo( "relative", {
              top: 0,
              left: r
            } ).left;
          }
        }

        first = ( ts || bs || ls || rs );

        if ( o.snapMode !== "outer" ) {
          ts = Math.abs( t - y1 ) <= d;
          bs = Math.abs( b - y2 ) <= d;
          ls = Math.abs( l - x1 ) <= d;
          rs = Math.abs( r - x2 ) <= d;
          if ( ts ) {
            ui.position.top = inst._convertPositionTo( "relative", {
              top: t,
              left: 0
            } ).top;
          }
          if ( bs ) {
            ui.position.top = inst._convertPositionTo( "relative", {
              top: b - inst.helperProportions.height,
              left: 0
            } ).top;
          }
          if ( ls ) {
            ui.position.left = inst._convertPositionTo( "relative", {
              top: 0,
              left: l
            } ).left;
          }
          if ( rs ) {
            ui.position.left = inst._convertPositionTo( "relative", {
              top: 0,
              left: r - inst.helperProportions.width
            } ).left;
          }
        }

        if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
          ( inst.options.snap.snap &&
					inst.options.snap.snap.call(
					  inst.element,
					  event,
					  $.extend( inst._uiHash(), {
					    snapItem: inst.snapElements[ i ].item
					  } ) ) );
        }
        inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );

      }

    }
  } );

  $.ui.plugin.add( "draggable", "stack", {
    start: function ( event, ui, instance ) {
      var min,
        o = instance.options,
        group = $.makeArray( $( o.stack ) ).sort( function ( a, b ) {
          return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
					( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
        } );

      if ( !group.length ) { return; }

      min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
      $( group ).each( function ( i ) {
        $( this ).css( "zIndex", min + i );
      } );
      this.css( "zIndex", ( min + group.length ) );
    }
  } );

  $.ui.plugin.add( "draggable", "zIndex", {
    start: function ( event, ui, instance ) {
      var t = $( ui.helper ),
        o = instance.options;

      if ( t.css( "zIndex" ) ) {
        o._zIndex = t.css( "zIndex" );
      }
      t.css( "zIndex", o.zIndex );
    },
    stop: function ( event, ui, instance ) {
      var o = instance.options;

      if ( o._zIndex ) {
        $( ui.helper ).css( "zIndex", o._zIndex );
      }
    }
  } );

  var widgetsDraggable = $.ui.draggable;

  /* !
 * jQuery UI Resizable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Resizable
  // >>group: Interactions
  // >>description: Enables resize functionality for any element.
  // >>docs: http://api.jqueryui.com/resizable/
  // >>demos: http://jqueryui.com/resizable/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/resizable.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.resizable", $.ui.mouse, {
    version: "1.12.1",
    widgetEventPrefix: "resize",
    options: {
      alsoResize: false,
      animate: false,
      animateDuration: "slow",
      animateEasing: "swing",
      aspectRatio: false,
      autoHide: false,
      classes: {
        "ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
      },
      containment: false,
      ghost: false,
      grid: false,
      handles: "e,s,se",
      helper: false,
      maxHeight: null,
      maxWidth: null,
      minHeight: 10,
      minWidth: 10,

      // See #7960
      zIndex: 90,

      // Callbacks
      resize: null,
      start: null,
      stop: null
    },

    _num: function ( value ) {
      return parseFloat( value ) || 0;
    },

    _isNumber: function ( value ) {
      return !isNaN( parseFloat( value ) );
    },

    _hasScroll: function ( el, a ) {

      if ( $( el ).css( "overflow" ) === "hidden" ) {
        return false;
      }

      var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
        has = false;

      if ( el[ scroll ] > 0 ) {
        return true;
      }

      // TODO: determine which cases actually cause this to happen
      // if the element doesn't have the scroll set, see if it's possible to
      // set the scroll
      el[ scroll ] = 1;
      has = ( el[ scroll ] > 0 );
      el[ scroll ] = 0;
      return has;
    },

    _create: function () {

      var margins,
        o = this.options,
        that = this;
      this._addClass( "ui-resizable" );

      $.extend( this, {
        _aspectRatio: !!( o.aspectRatio ),
        aspectRatio: o.aspectRatio,
        originalElement: this.element,
        _proportionallyResizeElements: [],
        _helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
      } );

      // Wrap the element if it cannot hold child nodes
      if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {

        this.element.wrap(
          $( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
            position: this.element.css( "position" ),
            width: this.element.outerWidth(),
            height: this.element.outerHeight(),
            top: this.element.css( "top" ),
            left: this.element.css( "left" )
          } )
        );

        this.element = this.element.parent().data(
          "ui-resizable", this.element.resizable( "instance" )
        );

        this.elementIsWrapper = true;

        margins = {
          marginTop: this.originalElement.css( "marginTop" ),
          marginRight: this.originalElement.css( "marginRight" ),
          marginBottom: this.originalElement.css( "marginBottom" ),
          marginLeft: this.originalElement.css( "marginLeft" )
        };

        this.element.css( margins );
        this.originalElement.css( "margin", 0 );

        // support: Safari
        // Prevent Safari textarea resize
        this.originalResizeStyle = this.originalElement.css( "resize" );
        this.originalElement.css( "resize", "none" );

        this._proportionallyResizeElements.push( this.originalElement.css( {
          position: "static",
          zoom: 1,
          display: "block"
        } ) );

        // Support: IE9
        // avoid IE jump (hard set the margin)
        this.originalElement.css( margins );

        this._proportionallyResize();
      }

      this._setupHandles();

      if ( o.autoHide ) {
        $( this.element )
          .on( "mouseenter", function () {
            if ( o.disabled ) {
              return;
            }
            that._removeClass( "ui-resizable-autohide" );
            that._handles.show();
          } )
          .on( "mouseleave", function () {
            if ( o.disabled ) {
              return;
            }
            if ( !that.resizing ) {
              that._addClass( "ui-resizable-autohide" );
              that._handles.hide();
            }
          } );
      }

      this._mouseInit();
    },

    _destroy: function () {

      this._mouseDestroy();

      var wrapper,
        _destroy = function ( exp ) {
          $( exp )
            .removeData( "resizable" )
            .removeData( "ui-resizable" )
            .off( ".resizable" )
            .find( ".ui-resizable-handle" )
            .remove();
        };

      // TODO: Unwrap at same DOM position
      if ( this.elementIsWrapper ) {
        _destroy( this.element );
        wrapper = this.element;
        this.originalElement.css( {
          position: wrapper.css( "position" ),
          width: wrapper.outerWidth(),
          height: wrapper.outerHeight(),
          top: wrapper.css( "top" ),
          left: wrapper.css( "left" )
        } ).insertAfter( wrapper );
        wrapper.remove();
      }

      this.originalElement.css( "resize", this.originalResizeStyle );
      _destroy( this.originalElement );

      return this;
    },

    _setOption: function ( key, value ) {
      this._super( key, value );

      switch ( key ) {
        case "handles":
          this._removeHandles();
          this._setupHandles();
          break;
        default:
          break;
      }
    },

    _setupHandles: function () {
      var o = this.options, handle, i, n, hname, axis, that = this;
      this.handles = o.handles ||
			( !$( ".ui-resizable-handle", this.element ).length ?
			  "e,s,se" : {
			    n: ".ui-resizable-n",
			    e: ".ui-resizable-e",
			    s: ".ui-resizable-s",
			    w: ".ui-resizable-w",
			    se: ".ui-resizable-se",
			    sw: ".ui-resizable-sw",
			    ne: ".ui-resizable-ne",
			    nw: ".ui-resizable-nw"
			  } );

      this._handles = $();
      if ( this.handles.constructor === String ) {

        if ( this.handles === "all" ) {
          this.handles = "n,e,s,w,se,sw,ne,nw";
        }

        n = this.handles.split( "," );
        this.handles = {};

        for ( i = 0; i < n.length; i++ ) {

          handle = $.trim( n[ i ] );
          hname = "ui-resizable-" + handle;
          axis = $( "<div>" );
          this._addClass( axis, "ui-resizable-handle " + hname );

          axis.css( { zIndex: o.zIndex } );

          this.handles[ handle ] = ".ui-resizable-" + handle;
          this.element.append( axis );
        }

      }

      this._renderAxis = function ( target ) {

        var i, axis, padPos, padWrapper;

        target = target || this.element;

        for ( i in this.handles ) {

          if ( this.handles[ i ].constructor === String ) {
            this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
          } else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
            this.handles[ i ] = $( this.handles[ i ] );
            this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
          }

          if ( this.elementIsWrapper &&
						this.originalElement[ 0 ]
						  .nodeName
						  .match( /^(textarea|input|select|button)$/i ) ) {
            axis = $( this.handles[ i ], this.element );

            padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
              axis.outerHeight() :
              axis.outerWidth();

            padPos = [ "padding",
              /ne|nw|n/.test( i ) ? "Top" :
                /se|sw|s/.test( i ) ? "Bottom" :
                  /^e$/.test( i ) ? "Right" : "Left" ].join( "" );

            target.css( padPos, padWrapper );

            this._proportionallyResize();
          }

          this._handles = this._handles.add( this.handles[ i ] );
        }
      };

      // TODO: make renderAxis a prototype function
      this._renderAxis( this.element );

      this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
      this._handles.disableSelection();

      this._handles.on( "mouseover", function () {
        if ( !that.resizing ) {
          if ( this.className ) {
            axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
          }
          that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
        }
      } );

      if ( o.autoHide ) {
        this._handles.hide();
        this._addClass( "ui-resizable-autohide" );
      }
    },

    _removeHandles: function () {
      this._handles.remove();
    },

    _mouseCapture: function ( event ) {
      var i, handle,
        capture = false;

      for ( i in this.handles ) {
        handle = $( this.handles[ i ] )[ 0 ];
        if ( handle === event.target || $.contains( handle, event.target ) ) {
          capture = true;
        }
      }

      return !this.options.disabled && capture;
    },

    _mouseStart: function ( event ) {

      var curleft, curtop, cursor,
        o = this.options,
        el = this.element;

      this.resizing = true;

      this._renderProxy();

      curleft = this._num( this.helper.css( "left" ) );
      curtop = this._num( this.helper.css( "top" ) );

      if ( o.containment ) {
        curleft += $( o.containment ).scrollLeft() || 0;
        curtop += $( o.containment ).scrollTop() || 0;
      }

      this.offset = this.helper.offset();
      this.position = { left: curleft, top: curtop };

      this.size = this._helper ? {
        width: this.helper.width(),
        height: this.helper.height()
      } : {
        width: el.width(),
        height: el.height()
      };

      this.originalSize = this._helper ? {
        width: el.outerWidth(),
        height: el.outerHeight()
      } : {
        width: el.width(),
        height: el.height()
      };

      this.sizeDiff = {
        width: el.outerWidth() - el.width(),
        height: el.outerHeight() - el.height()
      };

      this.originalPosition = { left: curleft, top: curtop };
      this.originalMousePosition = { left: event.pageX, top: event.pageY };

      this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
        o.aspectRatio :
        ( ( this.originalSize.width / this.originalSize.height ) || 1 );

      cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
      $( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );

      this._addClass( "ui-resizable-resizing" );
      this._propagate( "start", event );
      return true;
    },

    _mouseDrag: function ( event ) {

      var data, props,
        smp = this.originalMousePosition,
        a = this.axis,
        dx = ( event.pageX - smp.left ) || 0,
        dy = ( event.pageY - smp.top ) || 0,
        trigger = this._change[ a ];

      this._updatePrevProperties();

      if ( !trigger ) {
        return false;
      }

      data = trigger.apply( this, [ event, dx, dy ] );

      this._updateVirtualBoundaries( event.shiftKey );
      if ( this._aspectRatio || event.shiftKey ) {
        data = this._updateRatio( data, event );
      }

      data = this._respectSize( data, event );

      this._updateCache( data );

      this._propagate( "resize", event );

      props = this._applyChanges();

      if ( !this._helper && this._proportionallyResizeElements.length ) {
        this._proportionallyResize();
      }

      if ( !$.isEmptyObject( props ) ) {
        this._updatePrevProperties();
        this._trigger( "resize", event, this.ui() );
        this._applyChanges();
      }

      return false;
    },

    _mouseStop: function ( event ) {

      this.resizing = false;
      var pr, ista, soffseth, soffsetw, s, left, top,
        o = this.options, that = this;

      if ( this._helper ) {

        pr = this._proportionallyResizeElements;
        ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
        soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
        soffsetw = ista ? 0 : that.sizeDiff.width;

        s = {
          width: ( that.helper.width() - soffsetw ),
          height: ( that.helper.height() - soffseth )
        };
        left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null;
        top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

        if ( !o.animate ) {
          this.element.css( $.extend( s, { top: top, left: left } ) );
        }

        that.helper.height( that.size.height );
        that.helper.width( that.size.width );

        if ( this._helper && !o.animate ) {
          this._proportionallyResize();
        }
      }

      $( "body" ).css( "cursor", "auto" );

      this._removeClass( "ui-resizable-resizing" );

      this._propagate( "stop", event );

      if ( this._helper ) {
        this.helper.remove();
      }

      return false;

    },

    _updatePrevProperties: function () {
      this.prevPosition = {
        top: this.position.top,
        left: this.position.left
      };
      this.prevSize = {
        width: this.size.width,
        height: this.size.height
      };
    },

    _applyChanges: function () {
      var props = {};

      if ( this.position.top !== this.prevPosition.top ) {
        props.top = this.position.top + "px";
      }
      if ( this.position.left !== this.prevPosition.left ) {
        props.left = this.position.left + "px";
      }
      if ( this.size.width !== this.prevSize.width ) {
        props.width = this.size.width + "px";
      }
      if ( this.size.height !== this.prevSize.height ) {
        props.height = this.size.height + "px";
      }

      this.helper.css( props );

      return props;
    },

    _updateVirtualBoundaries: function ( forceAspectRatio ) {
      var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
        o = this.options;

      b = {
        minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
        maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
        minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
        maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
      };

      if ( this._aspectRatio || forceAspectRatio ) {
        pMinWidth = b.minHeight * this.aspectRatio;
        pMinHeight = b.minWidth / this.aspectRatio;
        pMaxWidth = b.maxHeight * this.aspectRatio;
        pMaxHeight = b.maxWidth / this.aspectRatio;

        if ( pMinWidth > b.minWidth ) {
          b.minWidth = pMinWidth;
        }
        if ( pMinHeight > b.minHeight ) {
          b.minHeight = pMinHeight;
        }
        if ( pMaxWidth < b.maxWidth ) {
          b.maxWidth = pMaxWidth;
        }
        if ( pMaxHeight < b.maxHeight ) {
          b.maxHeight = pMaxHeight;
        }
      }
      this._vBoundaries = b;
    },

    _updateCache: function ( data ) {
      this.offset = this.helper.offset();
      if ( this._isNumber( data.left ) ) {
        this.position.left = data.left;
      }
      if ( this._isNumber( data.top ) ) {
        this.position.top = data.top;
      }
      if ( this._isNumber( data.height ) ) {
        this.size.height = data.height;
      }
      if ( this._isNumber( data.width ) ) {
        this.size.width = data.width;
      }
    },

    _updateRatio: function ( data ) {

      var cpos = this.position,
        csize = this.size,
        a = this.axis;

      if ( this._isNumber( data.height ) ) {
        data.width = ( data.height * this.aspectRatio );
      } else if ( this._isNumber( data.width ) ) {
        data.height = ( data.width / this.aspectRatio );
      }

      if ( a === "sw" ) {
        data.left = cpos.left + ( csize.width - data.width );
        data.top = null;
      }
      if ( a === "nw" ) {
        data.top = cpos.top + ( csize.height - data.height );
        data.left = cpos.left + ( csize.width - data.width );
      }

      return data;
    },

    _respectSize: function ( data ) {

      var o = this._vBoundaries,
        a = this.axis,
        ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
        ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
        isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
        isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
        dw = this.originalPosition.left + this.originalSize.width,
        dh = this.originalPosition.top + this.originalSize.height,
        cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
      if ( isminw ) {
        data.width = o.minWidth;
      }
      if ( isminh ) {
        data.height = o.minHeight;
      }
      if ( ismaxw ) {
        data.width = o.maxWidth;
      }
      if ( ismaxh ) {
        data.height = o.maxHeight;
      }

      if ( isminw && cw ) {
        data.left = dw - o.minWidth;
      }
      if ( ismaxw && cw ) {
        data.left = dw - o.maxWidth;
      }
      if ( isminh && ch ) {
        data.top = dh - o.minHeight;
      }
      if ( ismaxh && ch ) {
        data.top = dh - o.maxHeight;
      }

      // Fixing jump error on top/left - bug #2330
      if ( !data.width && !data.height && !data.left && data.top ) {
        data.top = null;
      } else if ( !data.width && !data.height && !data.top && data.left ) {
        data.left = null;
      }

      return data;
    },

    _getPaddingPlusBorderDimensions: function ( element ) {
      var i = 0,
        widths = [],
        borders = [
          element.css( "borderTopWidth" ),
          element.css( "borderRightWidth" ),
          element.css( "borderBottomWidth" ),
          element.css( "borderLeftWidth" )
        ],
        paddings = [
          element.css( "paddingTop" ),
          element.css( "paddingRight" ),
          element.css( "paddingBottom" ),
          element.css( "paddingLeft" )
        ];

      for ( ; i < 4; i++ ) {
        widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
        widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
      }

      return {
        height: widths[ 0 ] + widths[ 2 ],
        width: widths[ 1 ] + widths[ 3 ]
      };
    },

    _proportionallyResize: function () {

      if ( !this._proportionallyResizeElements.length ) {
        return;
      }

      var prel,
        i = 0,
        element = this.helper || this.element;

      for ( ; i < this._proportionallyResizeElements.length; i++ ) {

        prel = this._proportionallyResizeElements[ i ];

        // TODO: Seems like a bug to cache this.outerDimensions
        // considering that we are in a loop.
        if ( !this.outerDimensions ) {
          this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
        }

        prel.css( {
          height: ( element.height() - this.outerDimensions.height ) || 0,
          width: ( element.width() - this.outerDimensions.width ) || 0
        } );

      }

    },

    _renderProxy: function () {

      var el = this.element, o = this.options;
      this.elementOffset = el.offset();

      if ( this._helper ) {

        this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );

        this._addClass( this.helper, this._helper );
        this.helper.css( {
          width: this.element.outerWidth(),
          height: this.element.outerHeight(),
          position: "absolute",
          left: this.elementOffset.left + "px",
          top: this.elementOffset.top + "px",
          zIndex: ++o.zIndex // TODO: Don't modify option
        } );

        this.helper
          .appendTo( "body" )
          .disableSelection();

      } else {
        this.helper = this.element;
      }

    },

    _change: {
      e: function ( event, dx ) {
        return { width: this.originalSize.width + dx };
      },
      w: function ( event, dx ) {
        var cs = this.originalSize, sp = this.originalPosition;
        return { left: sp.left + dx, width: cs.width - dx };
      },
      n: function ( event, dx, dy ) {
        var cs = this.originalSize, sp = this.originalPosition;
        return { top: sp.top + dy, height: cs.height - dy };
      },
      s: function ( event, dx, dy ) {
        return { height: this.originalSize.height + dy };
      },
      se: function ( event, dx, dy ) {
        return $.extend( this._change.s.apply( this, arguments ),
          this._change.e.apply( this, [ event, dx, dy ] ) );
      },
      sw: function ( event, dx, dy ) {
        return $.extend( this._change.s.apply( this, arguments ),
          this._change.w.apply( this, [ event, dx, dy ] ) );
      },
      ne: function ( event, dx, dy ) {
        return $.extend( this._change.n.apply( this, arguments ),
          this._change.e.apply( this, [ event, dx, dy ] ) );
      },
      nw: function ( event, dx, dy ) {
        return $.extend( this._change.n.apply( this, arguments ),
          this._change.w.apply( this, [ event, dx, dy ] ) );
      }
    },

    _propagate: function ( n, event ) {
      $.ui.plugin.call( this, n, [ event, this.ui() ] );
      ( n !== "resize" && this._trigger( n, event, this.ui() ) );
    },

    plugins: {},

    ui: function () {
      return {
        originalElement: this.originalElement,
        element: this.element,
        helper: this.helper,
        position: this.position,
        size: this.size,
        originalSize: this.originalSize,
        originalPosition: this.originalPosition
      };
    }

  } );

  /*
 * Resizable Extensions
 */

  $.ui.plugin.add( "resizable", "animate", {

    stop: function ( event ) {
      var that = $( this ).resizable( "instance" ),
        o = that.options,
        pr = that._proportionallyResizeElements,
        ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
        soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
        soffsetw = ista ? 0 : that.sizeDiff.width,
        style = {
          width: ( that.size.width - soffsetw ),
          height: ( that.size.height - soffseth )
        },
        left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null,
        top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

      that.element.animate(
        $.extend( style, top && left ? { top: top, left: left } : {} ), {
          duration: o.animateDuration,
          easing: o.animateEasing,
          step: function () {

            var data = {
              width: parseFloat( that.element.css( "width" ) ),
              height: parseFloat( that.element.css( "height" ) ),
              top: parseFloat( that.element.css( "top" ) ),
              left: parseFloat( that.element.css( "left" ) )
            };

            if ( pr && pr.length ) {
              $( pr[ 0 ] ).css( { width: data.width, height: data.height } );
            }

            // Propagating resize, and updating values for each animation step
            that._updateCache( data );
            that._propagate( "resize", event );

          }
        }
      );
    }

  } );

  $.ui.plugin.add( "resizable", "containment", {

    start: function () {
      var element, p, co, ch, cw, width, height,
        that = $( this ).resizable( "instance" ),
        o = that.options,
        el = that.element,
        oc = o.containment,
        ce = ( oc instanceof $ ) ?
          oc.get( 0 ) :
          ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

      if ( !ce ) {
        return;
      }

      that.containerElement = $( ce );

      if ( /document/.test( oc ) || oc === document ) {
        that.containerOffset = {
          left: 0,
          top: 0
        };
        that.containerPosition = {
          left: 0,
          top: 0
        };

        that.parentData = {
          element: $( document ),
          left: 0,
          top: 0,
          width: $( document ).width(),
          height: $( document ).height() || document.body.parentNode.scrollHeight
        };
      } else {
        element = $( ce );
        p = [];
        $( [ "Top", "Right", "Left", "Bottom" ] ).each( function ( i, name ) {
          p[ i ] = that._num( element.css( "padding" + name ) );
        } );

        that.containerOffset = element.offset();
        that.containerPosition = element.position();
        that.containerSize = {
          height: ( element.innerHeight() - p[ 3 ] ),
          width: ( element.innerWidth() - p[ 1 ] )
        };

        co = that.containerOffset;
        ch = that.containerSize.height;
        cw = that.containerSize.width;
        width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
        height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

        that.parentData = {
          element: ce,
          left: co.left,
          top: co.top,
          width: width,
          height: height
        };
      }
    },

    resize: function ( event ) {
      var woset, hoset, isParent, isOffsetRelative,
        that = $( this ).resizable( "instance" ),
        o = that.options,
        co = that.containerOffset,
        cp = that.position,
        pRatio = that._aspectRatio || event.shiftKey,
        cop = {
          top: 0,
          left: 0
        },
        ce = that.containerElement,
        continueResize = true;

      if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
        cop = co;
      }

      if ( cp.left < ( that._helper ? co.left : 0 ) ) {
        that.size.width = that.size.width +
				( that._helper ?
				  ( that.position.left - co.left ) :
				  ( that.position.left - cop.left ) );

        if ( pRatio ) {
          that.size.height = that.size.width / that.aspectRatio;
          continueResize = false;
        }
        that.position.left = o.helper ? co.left : 0;
      }

      if ( cp.top < ( that._helper ? co.top : 0 ) ) {
        that.size.height = that.size.height +
				( that._helper ?
				  ( that.position.top - co.top ) :
				  that.position.top );

        if ( pRatio ) {
          that.size.width = that.size.height * that.aspectRatio;
          continueResize = false;
        }
        that.position.top = that._helper ? co.top : 0;
      }

      isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
      isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

      if ( isParent && isOffsetRelative ) {
        that.offset.left = that.parentData.left + that.position.left;
        that.offset.top = that.parentData.top + that.position.top;
      } else {
        that.offset.left = that.element.offset().left;
        that.offset.top = that.element.offset().top;
      }

      woset = Math.abs( that.sizeDiff.width +
			( that._helper ?
			  that.offset.left - cop.left :
			  ( that.offset.left - co.left ) ) );

      hoset = Math.abs( that.sizeDiff.height +
			( that._helper ?
			  that.offset.top - cop.top :
			  ( that.offset.top - co.top ) ) );

      if ( woset + that.size.width >= that.parentData.width ) {
        that.size.width = that.parentData.width - woset;
        if ( pRatio ) {
          that.size.height = that.size.width / that.aspectRatio;
          continueResize = false;
        }
      }

      if ( hoset + that.size.height >= that.parentData.height ) {
        that.size.height = that.parentData.height - hoset;
        if ( pRatio ) {
          that.size.width = that.size.height * that.aspectRatio;
          continueResize = false;
        }
      }

      if ( !continueResize ) {
        that.position.left = that.prevPosition.left;
        that.position.top = that.prevPosition.top;
        that.size.width = that.prevSize.width;
        that.size.height = that.prevSize.height;
      }
    },

    stop: function () {
      var that = $( this ).resizable( "instance" ),
        o = that.options,
        co = that.containerOffset,
        cop = that.containerPosition,
        ce = that.containerElement,
        helper = $( that.helper ),
        ho = helper.offset(),
        w = helper.outerWidth() - that.sizeDiff.width,
        h = helper.outerHeight() - that.sizeDiff.height;

      if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
        $( this ).css( {
          left: ho.left - cop.left - co.left,
          width: w,
          height: h
        } );
      }

      if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
        $( this ).css( {
          left: ho.left - cop.left - co.left,
          width: w,
          height: h
        } );
      }
    }
  } );

  $.ui.plugin.add( "resizable", "alsoResize", {

    start: function () {
      var that = $( this ).resizable( "instance" ),
        o = that.options;

      $( o.alsoResize ).each( function () {
        var el = $( this );
        el.data( "ui-resizable-alsoresize", {
          width: parseFloat( el.width() ), height: parseFloat( el.height() ),
          left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
        } );
      } );
    },

    resize: function ( event, ui ) {
      var that = $( this ).resizable( "instance" ),
        o = that.options,
        os = that.originalSize,
        op = that.originalPosition,
        delta = {
          height: ( that.size.height - os.height ) || 0,
          width: ( that.size.width - os.width ) || 0,
          top: ( that.position.top - op.top ) || 0,
          left: ( that.position.left - op.left ) || 0
        };

      $( o.alsoResize ).each( function () {
        var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
          css = el.parents( ui.originalElement[ 0 ] ).length ?
            [ "width", "height" ] :
            [ "width", "height", "top", "left" ];

        $.each( css, function ( i, prop ) {
          var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
          if ( sum && sum >= 0 ) {
            style[ prop ] = sum || null;
          }
        } );

        el.css( style );
      } );
    },

    stop: function () {
      $( this ).removeData( "ui-resizable-alsoresize" );
    }
  } );

  $.ui.plugin.add( "resizable", "ghost", {

    start: function () {

      var that = $( this ).resizable( "instance" ), cs = that.size;

      that.ghost = that.originalElement.clone();
      that.ghost.css( {
        opacity: 0.25,
        display: "block",
        position: "relative",
        height: cs.height,
        width: cs.width,
        margin: 0,
        left: 0,
        top: 0
      } );

      that._addClass( that.ghost, "ui-resizable-ghost" );

      // DEPRECATED
      // TODO: remove after 1.12
      if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {

        // Ghost option
        that.ghost.addClass( this.options.ghost );
      }

      that.ghost.appendTo( that.helper );

    },

    resize: function () {
      var that = $( this ).resizable( "instance" );
      if ( that.ghost ) {
        that.ghost.css( {
          position: "relative",
          height: that.size.height,
          width: that.size.width
        } );
      }
    },

    stop: function () {
      var that = $( this ).resizable( "instance" );
      if ( that.ghost && that.helper ) {
        that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
      }
    }

  } );

  $.ui.plugin.add( "resizable", "grid", {

    resize: function () {
      var outerDimensions,
        that = $( this ).resizable( "instance" ),
        o = that.options,
        cs = that.size,
        os = that.originalSize,
        op = that.originalPosition,
        a = that.axis,
        grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
        gridX = ( grid[ 0 ] || 1 ),
        gridY = ( grid[ 1 ] || 1 ),
        ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
        oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
        newWidth = os.width + ox,
        newHeight = os.height + oy,
        isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
        isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
        isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
        isMinHeight = o.minHeight && ( o.minHeight > newHeight );

      o.grid = grid;

      if ( isMinWidth ) {
        newWidth += gridX;
      }
      if ( isMinHeight ) {
        newHeight += gridY;
      }
      if ( isMaxWidth ) {
        newWidth -= gridX;
      }
      if ( isMaxHeight ) {
        newHeight -= gridY;
      }

      if ( /^(se|s|e)$/.test( a ) ) {
        that.size.width = newWidth;
        that.size.height = newHeight;
      } else if ( /^(ne)$/.test( a ) ) {
        that.size.width = newWidth;
        that.size.height = newHeight;
        that.position.top = op.top - oy;
      } else if ( /^(sw)$/.test( a ) ) {
        that.size.width = newWidth;
        that.size.height = newHeight;
        that.position.left = op.left - ox;
      } else {
        if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
          outerDimensions = that._getPaddingPlusBorderDimensions( this );
        }

        if ( newHeight - gridY > 0 ) {
          that.size.height = newHeight;
          that.position.top = op.top - oy;
        } else {
          newHeight = gridY - outerDimensions.height;
          that.size.height = newHeight;
          that.position.top = op.top + os.height - newHeight;
        }
        if ( newWidth - gridX > 0 ) {
          that.size.width = newWidth;
          that.position.left = op.left - ox;
        } else {
          newWidth = gridX - outerDimensions.width;
          that.size.width = newWidth;
          that.position.left = op.left + os.width - newWidth;
        }
      }
    }

  } );

  var widgetsResizable = $.ui.resizable;

  /* !
 * jQuery UI Dialog 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Dialog
  // >>group: Widgets
  // >>description: Displays customizable dialog windows.
  // >>docs: http://api.jqueryui.com/dialog/
  // >>demos: http://jqueryui.com/dialog/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/dialog.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.dialog", {
    version: "1.12.1",
    options: {
      appendTo: "body",
      autoOpen: true,
      buttons: [],
      classes: {
        "ui-dialog": "ui-corner-all",
        "ui-dialog-titlebar": "ui-corner-all"
      },
      closeOnEscape: true,
      closeText: "Close",
      draggable: true,
      hide: null,
      height: "auto",
      maxHeight: null,
      maxWidth: null,
      minHeight: 150,
      minWidth: 150,
      modal: false,
      position: {
        my: "center",
        at: "center",
        of: window,
        collision: "fit",

        // Ensure the titlebar is always visible
        using: function ( pos ) {
          var topOffset = $( this ).css( pos ).offset().top;
          if ( topOffset < 0 ) {
            $( this ).css( "top", pos.top - topOffset );
          }
        }
      },
      resizable: true,
      show: null,
      title: null,
      width: 300,

      // Callbacks
      beforeClose: null,
      close: null,
      drag: null,
      dragStart: null,
      dragStop: null,
      focus: null,
      open: null,
      resize: null,
      resizeStart: null,
      resizeStop: null
    },

    sizeRelatedOptions: {
      buttons: true,
      height: true,
      maxHeight: true,
      maxWidth: true,
      minHeight: true,
      minWidth: true,
      width: true
    },

    resizableRelatedOptions: {
      maxHeight: true,
      maxWidth: true,
      minHeight: true,
      minWidth: true
    },

    _create: function () {
      this.originalCss = {
        display: this.element[ 0 ].style.display,
        width: this.element[ 0 ].style.width,
        minHeight: this.element[ 0 ].style.minHeight,
        maxHeight: this.element[ 0 ].style.maxHeight,
        height: this.element[ 0 ].style.height
      };
      this.originalPosition = {
        parent: this.element.parent(),
        index: this.element.parent().children().index( this.element )
      };
      this.originalTitle = this.element.attr( "title" );
      if ( this.options.title == null && this.originalTitle != null ) {
        this.options.title = this.originalTitle;
      }

      // Dialogs can't be disabled
      if ( this.options.disabled ) {
        this.options.disabled = false;
      }

      this._createWrapper();

      this.element
        .show()
        .removeAttr( "title" )
        .appendTo( this.uiDialog );

      this._addClass( "ui-dialog-content", "ui-widget-content" );

      this._createTitlebar();
      this._createButtonPane();

      if ( this.options.draggable && $.fn.draggable ) {
        this._makeDraggable();
      }
      if ( this.options.resizable && $.fn.resizable ) {
        this._makeResizable();
      }

      this._isOpen = false;

      this._trackFocus();
    },

    _init: function () {
      if ( this.options.autoOpen ) {
        this.open();
      }
    },

    _appendTo: function () {
      var element = this.options.appendTo;
      if ( element && ( element.jquery || element.nodeType ) ) {
        return $( element );
      }
      return this.document.find( element || "body" ).eq( 0 );
    },

    _destroy: function () {
      var next,
        originalPosition = this.originalPosition;

      this._untrackInstance();
      this._destroyOverlay();

      this.element
        .removeUniqueId()
        .css( this.originalCss )

      // Without detaching first, the following becomes really slow
        .detach();

      this.uiDialog.remove();

      if ( this.originalTitle ) {
        this.element.attr( "title", this.originalTitle );
      }

      next = originalPosition.parent.children().eq( originalPosition.index );

      // Don't try to place the dialog next to itself (#8613)
      if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
        next.before( this.element );
      } else {
        originalPosition.parent.append( this.element );
      }
    },

    widget: function () {
      return this.uiDialog;
    },

    disable: $.noop,
    enable: $.noop,

    close: function ( event ) {
      var that = this;

      if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
        return;
      }

      this._isOpen = false;
      this._focusedElement = null;
      this._destroyOverlay();
      this._untrackInstance();

      if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {

        // Hiding a focused element doesn't trigger blur in WebKit
        // so in case we have nothing to focus on, explicitly blur the active element
        // https://bugs.webkit.org/show_bug.cgi?id=47182
        $.ui.safeBlur( $.ui.safeActiveElement( this.document[ 0 ] ) );
      }

      this._hide( this.uiDialog, this.options.hide, function () {
        that._trigger( "close", event );
      } );
    },

    isOpen: function () {
      return this._isOpen;
    },

    moveToTop: function () {
      this._moveToTop();
    },

    _moveToTop: function ( event, silent ) {
      var moved = false,
        zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function () {
          return +$( this ).css( "z-index" );
        } ).get(),
        zIndexMax = Math.max.apply( null, zIndices );

      if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
        this.uiDialog.css( "z-index", zIndexMax + 1 );
        moved = true;
      }

      if ( moved && !silent ) {
        this._trigger( "focus", event );
      }
      return moved;
    },

    open: function () {
      var that = this;
      if ( this._isOpen ) {
        if ( this._moveToTop() ) {
          this._focusTabbable();
        }
        return;
      }

      this._isOpen = true;
      this.opener = $( $.ui.safeActiveElement( this.document[ 0 ] ) );

      this._size();
      this._position();
      this._createOverlay();
      this._moveToTop( null, true );

      // Ensure the overlay is moved to the top with the dialog, but only when
      // opening. The overlay shouldn't move after the dialog is open so that
      // modeless dialogs opened after the modal dialog stack properly.
      if ( this.overlay ) {
        this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
      }

      this._show( this.uiDialog, this.options.show, function () {
        that._focusTabbable();
        that._trigger( "focus" );
      } );

      // Track the dialog immediately upon openening in case a focus event
      // somehow occurs outside of the dialog before an element inside the
      // dialog is focused (#10152)
      this._makeFocusTarget();

      this._trigger( "open" );
    },

    _focusTabbable: function () {

      // Set focus to the first match:
      // 1. An element that was focused previously
      // 2. First element inside the dialog matching [autofocus]
      // 3. Tabbable element inside the content element
      // 4. Tabbable element inside the buttonpane
      // 5. The close button
      // 6. The dialog itself
      var hasFocus = this._focusedElement;
      if ( !hasFocus ) {
        hasFocus = this.element.find( "[autofocus]" );
      }
      if ( !hasFocus.length ) {
        hasFocus = this.element.find( ":tabbable" );
      }
      if ( !hasFocus.length ) {
        hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
      }
      if ( !hasFocus.length ) {
        hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
      }
      if ( !hasFocus.length ) {
        hasFocus = this.uiDialog;
      }
      hasFocus.eq( 0 ).trigger( "focus" );
    },

    _keepFocus: function ( event ) {
      function checkFocus() {
        var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
          isActive = this.uiDialog[ 0 ] === activeElement ||
					$.contains( this.uiDialog[ 0 ], activeElement );
        if ( !isActive ) {
          this._focusTabbable();
        }
      }
      event.preventDefault();
      checkFocus.call( this );

      // support: IE
      // IE <= 8 doesn't prevent moving focus even with event.preventDefault()
      // so we check again later
      this._delay( checkFocus );
    },

    _createWrapper: function () {
      this.uiDialog = $( "<div>" )
        .hide()
        .attr( {

          // Setting tabIndex makes the div focusable
          tabIndex: -1,
          role: "dialog"
        } )
        .appendTo( this._appendTo() );

      this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
      this._on( this.uiDialog, {
        keydown: function ( event ) {
          if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
            event.preventDefault();
            this.close( event );
            return;
          }

          // Prevent tabbing out of dialogs
          if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
            return;
          }
          var tabbables = this.uiDialog.find( ":tabbable" ),
            first = tabbables.filter( ":first" ),
            last = tabbables.filter( ":last" );

          if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
						!event.shiftKey ) {
            this._delay( function () {
              first.trigger( "focus" );
            } );
            event.preventDefault();
          } else if ( ( event.target === first[ 0 ] ||
						event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
            this._delay( function () {
              last.trigger( "focus" );
            } );
            event.preventDefault();
          }
        },
        mousedown: function ( event ) {
          if ( this._moveToTop( event ) ) {
            this._focusTabbable();
          }
        }
      } );

      // We assume that any existing aria-describedby attribute means
      // that the dialog content is marked up properly
      // otherwise we brute force the content as the description
      if ( !this.element.find( "[aria-describedby]" ).length ) {
        this.uiDialog.attr( {
          "aria-describedby": this.element.uniqueId().attr( "id" )
        } );
      }
    },

    _createTitlebar: function () {
      var uiDialogTitle;

      this.uiDialogTitlebar = $( "<div>" );
      this._addClass( this.uiDialogTitlebar,
        "ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
      this._on( this.uiDialogTitlebar, {
        mousedown: function ( event ) {

          // Don't prevent click on close button (#8838)
          // Focusing a dialog that is partially scrolled out of view
          // causes the browser to scroll it into view, preventing the click event
          if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {

            // Dialog isn't getting focus when dragging (#8063)
            this.uiDialog.trigger( "focus" );
          }
        }
      } );

      // Support: IE
      // Use type="button" to prevent enter keypresses in textboxes from closing the
      // dialog in IE (#9312)
      this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
        .button( {
          label: $( "<a>" ).text( this.options.closeText ).html(),
          icon: "ui-icon-closethick",
          showLabel: false
        } )
        .appendTo( this.uiDialogTitlebar );

      this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
      this._on( this.uiDialogTitlebarClose, {
        click: function ( event ) {
          event.preventDefault();
          this.close( event );
        }
      } );

      uiDialogTitle = $( "<span>" ).uniqueId().prependTo( this.uiDialogTitlebar );
      this._addClass( uiDialogTitle, "ui-dialog-title" );
      this._title( uiDialogTitle );

      this.uiDialogTitlebar.prependTo( this.uiDialog );

      this.uiDialog.attr( {
        "aria-labelledby": uiDialogTitle.attr( "id" )
      } );
    },

    _title: function ( title ) {
      if ( this.options.title ) {
        title.text( this.options.title );
      } else {
        title.html( "&#160;" );
      }
    },

    _createButtonPane: function () {
      this.uiDialogButtonPane = $( "<div>" );
      this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
        "ui-widget-content ui-helper-clearfix" );

      this.uiButtonSet = $( "<div>" )
        .appendTo( this.uiDialogButtonPane );
      this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );

      this._createButtons();
    },

    _createButtons: function () {
      var that = this,
        buttons = this.options.buttons;

      // If we already have a button pane, remove it
      this.uiDialogButtonPane.remove();
      this.uiButtonSet.empty();

      if ( $.isEmptyObject( buttons ) || ( $.isArray( buttons ) && !buttons.length ) ) {
        this._removeClass( this.uiDialog, "ui-dialog-buttons" );
        return;
      }

      $.each( buttons, function ( name, props ) {
        var click, buttonOptions;
        props = $.isFunction( props ) ?
          { click: props, text: name } :
          props;

        // Default to a non-submitting button
        props = $.extend( { type: "button" }, props );

        // Change the context for the click callback to be the main element
        click = props.click;
        buttonOptions = {
          icon: props.icon,
          iconPosition: props.iconPosition,
          showLabel: props.showLabel,

          // Deprecated options
          icons: props.icons,
          text: props.text
        };

        delete props.click;
        delete props.icon;
        delete props.iconPosition;
        delete props.showLabel;

        // Deprecated options
        delete props.icons;
        if ( typeof props.text === "boolean" ) {
          delete props.text;
        }

        $( "<button></button>", props )
          .button( buttonOptions )
          .appendTo( that.uiButtonSet )
          .on( "click", function () {
            click.apply( that.element[ 0 ], arguments );
          } );
      } );
      this._addClass( this.uiDialog, "ui-dialog-buttons" );
      this.uiDialogButtonPane.appendTo( this.uiDialog );
    },

    _makeDraggable: function () {
      var that = this,
        options = this.options;

      function filteredUi( ui ) {
        return {
          position: ui.position,
          offset: ui.offset
        };
      }

      this.uiDialog.draggable( {
        cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
        handle: ".ui-dialog-titlebar",
        containment: "document",
        start: function ( event, ui ) {
          that._addClass( $( this ), "ui-dialog-dragging" );
          that._blockFrames();
          that._trigger( "dragStart", event, filteredUi( ui ) );
        },
        drag: function ( event, ui ) {
          that._trigger( "drag", event, filteredUi( ui ) );
        },
        stop: function ( event, ui ) {
          var left = ui.offset.left - that.document.scrollLeft(),
            top = ui.offset.top - that.document.scrollTop();

          options.position = {
            my: "left top",
            at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
            of: that.window
          };
          that._removeClass( $( this ), "ui-dialog-dragging" );
          that._unblockFrames();
          that._trigger( "dragStop", event, filteredUi( ui ) );
        }
      } );
    },

    _makeResizable: function () {
      var that = this,
        options = this.options,
        handles = options.resizable,

        // .ui-resizable has position: relative defined in the stylesheet
        // but dialogs have to use absolute or fixed positioning
        position = this.uiDialog.css( "position" ),
        resizeHandles = typeof handles === "string" ?
          handles :
          "n,e,s,w,se,sw,ne,nw";

      function filteredUi( ui ) {
        return {
          originalPosition: ui.originalPosition,
          originalSize: ui.originalSize,
          position: ui.position,
          size: ui.size
        };
      }

      this.uiDialog.resizable( {
        cancel: ".ui-dialog-content",
        containment: "document",
        alsoResize: this.element,
        maxWidth: options.maxWidth,
        maxHeight: options.maxHeight,
        minWidth: options.minWidth,
        minHeight: this._minHeight(),
        handles: resizeHandles,
        start: function ( event, ui ) {
          that._addClass( $( this ), "ui-dialog-resizing" );
          that._blockFrames();
          that._trigger( "resizeStart", event, filteredUi( ui ) );
        },
        resize: function ( event, ui ) {
          that._trigger( "resize", event, filteredUi( ui ) );
        },
        stop: function ( event, ui ) {
          var offset = that.uiDialog.offset(),
            left = offset.left - that.document.scrollLeft(),
            top = offset.top - that.document.scrollTop();

          options.height = that.uiDialog.height();
          options.width = that.uiDialog.width();
          options.position = {
            my: "left top",
            at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
            of: that.window
          };
          that._removeClass( $( this ), "ui-dialog-resizing" );
          that._unblockFrames();
          that._trigger( "resizeStop", event, filteredUi( ui ) );
        }
      } )
        .css( "position", position );
    },

    _trackFocus: function () {
      this._on( this.widget(), {
        focusin: function ( event ) {
          this._makeFocusTarget();
          this._focusedElement = $( event.target );
        }
      } );
    },

    _makeFocusTarget: function () {
      this._untrackInstance();
      this._trackingInstances().unshift( this );
    },

    _untrackInstance: function () {
      var instances = this._trackingInstances(),
        exists = $.inArray( this, instances );
      if ( exists !== -1 ) {
        instances.splice( exists, 1 );
      }
    },

    _trackingInstances: function () {
      var instances = this.document.data( "ui-dialog-instances" );
      if ( !instances ) {
        instances = [];
        this.document.data( "ui-dialog-instances", instances );
      }
      return instances;
    },

    _minHeight: function () {
      var options = this.options;

      return options.height === "auto" ?
        options.minHeight :
        Math.min( options.minHeight, options.height );
    },

    _position: function () {

      // Need to show the dialog to get the actual offset in the position plugin
      var isVisible = this.uiDialog.is( ":visible" );
      if ( !isVisible ) {
        this.uiDialog.show();
      }
      this.uiDialog.position( this.options.position );
      if ( !isVisible ) {
        this.uiDialog.hide();
      }
    },

    _setOptions: function ( options ) {
      var that = this,
        resize = false,
        resizableOptions = {};

      $.each( options, function ( key, value ) {
        that._setOption( key, value );

        if ( key in that.sizeRelatedOptions ) {
          resize = true;
        }
        if ( key in that.resizableRelatedOptions ) {
          resizableOptions[ key ] = value;
        }
      } );

      if ( resize ) {
        this._size();
        this._position();
      }
      if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
        this.uiDialog.resizable( "option", resizableOptions );
      }
    },

    _setOption: function ( key, value ) {
      var isDraggable, isResizable,
        uiDialog = this.uiDialog;

      if ( key === "disabled" ) {
        return;
      }

      this._super( key, value );

      if ( key === "appendTo" ) {
        this.uiDialog.appendTo( this._appendTo() );
      }

      if ( key === "buttons" ) {
        this._createButtons();
      }

      if ( key === "closeText" ) {
        this.uiDialogTitlebarClose.button( {

          // Ensure that we always pass a string
          label: $( "<a>" ).text( "" + this.options.closeText ).html()
        } );
      }

      if ( key === "draggable" ) {
        isDraggable = uiDialog.is( ":data(ui-draggable)" );
        if ( isDraggable && !value ) {
          uiDialog.draggable( "destroy" );
        }

        if ( !isDraggable && value ) {
          this._makeDraggable();
        }
      }

      if ( key === "position" ) {
        this._position();
      }

      if ( key === "resizable" ) {

        // currently resizable, becoming non-resizable
        isResizable = uiDialog.is( ":data(ui-resizable)" );
        if ( isResizable && !value ) {
          uiDialog.resizable( "destroy" );
        }

        // Currently resizable, changing handles
        if ( isResizable && typeof value === "string" ) {
          uiDialog.resizable( "option", "handles", value );
        }

        // Currently non-resizable, becoming resizable
        if ( !isResizable && value !== false ) {
          this._makeResizable();
        }
      }

      if ( key === "title" ) {
        this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
      }
    },

    _size: function () {

      // If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
      // divs will both have width and height set, so we need to reset them
      var nonContentHeight, minContentHeight, maxContentHeight,
        options = this.options;

      // Reset content sizing
      this.element.show().css( {
        width: "auto",
        minHeight: 0,
        maxHeight: "none",
        height: 0
      } );

      if ( options.minWidth > options.width ) {
        options.width = options.minWidth;
      }

      // Reset wrapper sizing
      // determine the height of all the non-content elements
      nonContentHeight = this.uiDialog.css( {
        height: "auto",
        width: options.width
      } )
        .outerHeight();
      minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
      maxContentHeight = typeof options.maxHeight === "number" ?
        Math.max( 0, options.maxHeight - nonContentHeight ) :
        "none";

      if ( options.height === "auto" ) {
        this.element.css( {
          minHeight: minContentHeight,
          maxHeight: maxContentHeight,
          height: "auto"
        } );
      } else {
        this.element.height( Math.max( 0, options.height - nonContentHeight ) );
      }

      if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
        this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
      }
    },

    _blockFrames: function () {
      this.iframeBlocks = this.document.find( "iframe" ).map( function () {
        var iframe = $( this );

        return $( "<div>" )
          .css( {
            position: "absolute",
            width: iframe.outerWidth(),
            height: iframe.outerHeight()
          } )
          .appendTo( iframe.parent() )
          .offset( iframe.offset() )[ 0 ];
      } );
    },

    _unblockFrames: function () {
      if ( this.iframeBlocks ) {
        this.iframeBlocks.remove();
        delete this.iframeBlocks;
      }
    },

    _allowInteraction: function ( event ) {
      if ( $( event.target ).closest( ".ui-dialog" ).length ) {
        return true;
      }

      // TODO: Remove hack when datepicker implements
      // the .ui-front logic (#8989)
      return !!$( event.target ).closest( ".ui-datepicker" ).length;
    },

    _createOverlay: function () {
      if ( !this.options.modal ) {
        return;
      }

      // We use a delay in case the overlay is created from an
      // event that we're going to be cancelling (#2804)
      var isOpening = true;
      this._delay( function () {
        isOpening = false;
      } );

      if ( !this.document.data( "ui-dialog-overlays" ) ) {

        // Prevent use of anchors and inputs
        // Using _on() for an event handler shared across many instances is
        // safe because the dialogs stack and must be closed in reverse order
        this._on( this.document, {
          focusin: function ( event ) {
            if ( isOpening ) {
              return;
            }

            if ( !this._allowInteraction( event ) ) {
              event.preventDefault();
              this._trackingInstances()[ 0 ]._focusTabbable();
            }
          }
        } );
      }

      this.overlay = $( "<div>" )
        .appendTo( this._appendTo() );

      this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
      this._on( this.overlay, {
        mousedown: "_keepFocus"
      } );
      this.document.data( "ui-dialog-overlays",
        ( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
    },

    _destroyOverlay: function () {
      if ( !this.options.modal ) {
        return;
      }

      if ( this.overlay ) {
        var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

        if ( !overlays ) {
          this._off( this.document, "focusin" );
          this.document.removeData( "ui-dialog-overlays" );
        } else {
          this.document.data( "ui-dialog-overlays", overlays );
        }

        this.overlay.remove();
        this.overlay = null;
      }
    }
  } );

  // DEPRECATED
  // TODO: switch return back to widget declaration at top of file when this is removed
  if ( $.uiBackCompat !== false ) {

    // Backcompat for dialogClass option
    $.widget( "ui.dialog", $.ui.dialog, {
      options: {
        dialogClass: ""
      },
      _createWrapper: function () {
        this._super();
        this.uiDialog.addClass( this.options.dialogClass );
      },
      _setOption: function ( key, value ) {
        if ( key === "dialogClass" ) {
          this.uiDialog
            .removeClass( this.options.dialogClass )
            .addClass( value );
        }
        this._superApply( arguments );
      }
    } );
  }

  var widgetsDialog = $.ui.dialog;

  /* !
 * jQuery UI Droppable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Droppable
  // >>group: Interactions
  // >>description: Enables drop targets for draggable elements.
  // >>docs: http://api.jqueryui.com/droppable/
  // >>demos: http://jqueryui.com/droppable/

  $.widget( "ui.droppable", {
    version: "1.12.1",
    widgetEventPrefix: "drop",
    options: {
      accept: "*",
      addClasses: true,
      greedy: false,
      scope: "default",
      tolerance: "intersect",

      // Callbacks
      activate: null,
      deactivate: null,
      drop: null,
      out: null,
      over: null
    },
    _create: function () {

      var proportions,
        o = this.options,
        accept = o.accept;

      this.isover = false;
      this.isout = true;

      this.accept = $.isFunction( accept ) ? accept : function ( d ) {
        return d.is( accept );
      };

      this.proportions = function ( /* valueToWrite */ ) {
        if ( arguments.length ) {

          // Store the droppable's proportions
          proportions = arguments[ 0 ];
        } else {

          // Retrieve or derive the droppable's proportions
          return proportions ?
            proportions :
            proportions = {
              width: this.element[ 0 ].offsetWidth,
              height: this.element[ 0 ].offsetHeight
            };
        }
      };

      this._addToManager( o.scope );

      o.addClasses && this._addClass( "ui-droppable" );

    },

    _addToManager: function ( scope ) {

      // Add the reference and positions to the manager
      $.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
      $.ui.ddmanager.droppables[ scope ].push( this );
    },

    _splice: function ( drop ) {
      var i = 0;
      for ( ; i < drop.length; i++ ) {
        if ( drop[ i ] === this ) {
          drop.splice( i, 1 );
        }
      }
    },

    _destroy: function () {
      var drop = $.ui.ddmanager.droppables[ this.options.scope ];

      this._splice( drop );
    },

    _setOption: function ( key, value ) {

      if ( key === "accept" ) {
        this.accept = $.isFunction( value ) ? value : function ( d ) {
          return d.is( value );
        };
      } else if ( key === "scope" ) {
        var drop = $.ui.ddmanager.droppables[ this.options.scope ];

        this._splice( drop );
        this._addToManager( value );
      }

      this._super( key, value );
    },

    _activate: function ( event ) {
      var draggable = $.ui.ddmanager.current;

      this._addActiveClass();
      if ( draggable ) {
        this._trigger( "activate", event, this.ui( draggable ) );
      }
    },

    _deactivate: function ( event ) {
      var draggable = $.ui.ddmanager.current;

      this._removeActiveClass();
      if ( draggable ) {
        this._trigger( "deactivate", event, this.ui( draggable ) );
      }
    },

    _over: function ( event ) {

      var draggable = $.ui.ddmanager.current;

      // Bail if draggable and droppable are same element
      if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
        return;
      }

      if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
        this._addHoverClass();
        this._trigger( "over", event, this.ui( draggable ) );
      }

    },

    _out: function ( event ) {

      var draggable = $.ui.ddmanager.current;

      // Bail if draggable and droppable are same element
      if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
        return;
      }

      if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
        this._removeHoverClass();
        this._trigger( "out", event, this.ui( draggable ) );
      }

    },

    _drop: function ( event, custom ) {

      var draggable = custom || $.ui.ddmanager.current,
        childrenIntersection = false;

      // Bail if draggable and droppable are same element
      if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
        return false;
      }

      this.element
        .find( ":data(ui-droppable)" )
        .not( ".ui-draggable-dragging" )
        .each( function () {
          var inst = $( this ).droppable( "instance" );
          if (
            inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call(
					  inst.element[ 0 ], ( draggable.currentItem || draggable.element )
					) &&
					intersect(
					  draggable,
					  $.extend( inst, { offset: inst.element.offset() } ),
					  inst.options.tolerance, event
					)
          ) {
            childrenIntersection = true;
            return false; }
        } );
      if ( childrenIntersection ) {
        return false;
      }

      if ( this.accept.call( this.element[ 0 ],
        ( draggable.currentItem || draggable.element ) ) ) {
        this._removeActiveClass();
        this._removeHoverClass();

        this._trigger( "drop", event, this.ui( draggable ) );
        return this.element;
      }

      return false;

    },

    ui: function ( c ) {
      return {
        draggable: ( c.currentItem || c.element ),
        helper: c.helper,
        position: c.position,
        offset: c.positionAbs
      };
    },

    // Extension points just to make backcompat sane and avoid duplicating logic
    // TODO: Remove in 1.13 along with call to it below
    _addHoverClass: function () {
      this._addClass( "ui-droppable-hover" );
    },

    _removeHoverClass: function () {
      this._removeClass( "ui-droppable-hover" );
    },

    _addActiveClass: function () {
      this._addClass( "ui-droppable-active" );
    },

    _removeActiveClass: function () {
      this._removeClass( "ui-droppable-active" );
    }
  } );

  var intersect = $.ui.intersect = ( function () {
    function isOverAxis( x, reference, size ) {
      return ( x >= reference ) && ( x < ( reference + size ) );
    }

    return function ( draggable, droppable, toleranceMode, event ) {

      if ( !droppable.offset ) {
        return false;
      }

      var x1 = ( draggable.positionAbs ||
				draggable.position.absolute ).left + draggable.margins.left,
        y1 = ( draggable.positionAbs ||
				draggable.position.absolute ).top + draggable.margins.top,
        x2 = x1 + draggable.helperProportions.width,
        y2 = y1 + draggable.helperProportions.height,
        l = droppable.offset.left,
        t = droppable.offset.top,
        r = l + droppable.proportions().width,
        b = t + droppable.proportions().height;

      switch ( toleranceMode ) {
        case "fit":
          return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
        case "intersect":
          return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
        case "pointer":
          return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
				isOverAxis( event.pageX, l, droppable.proportions().width );
        case "touch":
          return (
            ( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
          ) && (
            ( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
          );
        default:
          return false;
      }
    };
  } )();

  /*
	This manager tracks offsets of draggables and droppables
*/
  $.ui.ddmanager = {
    current: null,
    droppables: { "default": [] },
    prepareOffsets: function ( t, event ) {

      var i, j,
        m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
        type = event ? event.type : null, // workaround for #2317
        list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

      droppablesLoop: for ( i = 0; i < m.length; i++ ) {

        // No disabled and non-accepted
        if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
          ( t.currentItem || t.element ) ) ) ) {
          continue;
        }

        // Filter out elements in the current dragged item
        for ( j = 0; j < list.length; j++ ) {
          if ( list[ j ] === m[ i ].element[ 0 ] ) {
            m[ i ].proportions().height = 0;
            continue droppablesLoop;
          }
        }

        m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
        if ( !m[ i ].visible ) {
          continue;
        }

        // Activate the droppable if used directly from draggables
        if ( type === "mousedown" ) {
          m[ i ]._activate.call( m[ i ], event );
        }

        m[ i ].offset = m[ i ].element.offset();
        m[ i ].proportions( {
          width: m[ i ].element[ 0 ].offsetWidth,
          height: m[ i ].element[ 0 ].offsetHeight
        } );

      }

    },
    drop: function ( draggable, event ) {

      var dropped = false;

      // Create a copy of the droppables in case the list changes during the drop (#9116)
      $.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function () {

        if ( !this.options ) {
          return;
        }
        if ( !this.options.disabled && this.visible &&
					intersect( draggable, this, this.options.tolerance, event ) ) {
          dropped = this._drop.call( this, event ) || dropped;
        }

        if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
          ( draggable.currentItem || draggable.element ) ) ) {
          this.isout = true;
          this.isover = false;
          this._deactivate.call( this, event );
        }

      } );
      return dropped;

    },
    dragStart: function ( draggable, event ) {

      // Listen for scrolling so that if the dragging causes scrolling the position of the
      // droppables can be recalculated (see #5003)
      draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function () {
        if ( !draggable.options.refreshPositions ) {
          $.ui.ddmanager.prepareOffsets( draggable, event );
        }
      } );
    },
    drag: function ( draggable, event ) {

      // If you have a highly dynamic page, you might try this option. It renders positions
      // every time you move the mouse.
      if ( draggable.options.refreshPositions ) {
        $.ui.ddmanager.prepareOffsets( draggable, event );
      }

      // Run through all droppables and check their positions based on specific tolerance options
      $.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function () {

        if ( this.options.disabled || this.greedyChild || !this.visible ) {
          return;
        }

        var parentInstance, scope, parent,
          intersects = intersect( draggable, this, this.options.tolerance, event ),
          c = !intersects && this.isover ?
            "isout" :
            ( intersects && !this.isover ? "isover" : null );
        if ( !c ) {
          return;
        }

        if ( this.options.greedy ) {

          // find droppable parents with same scope
          scope = this.options.scope;
          parent = this.element.parents( ":data(ui-droppable)" ).filter( function () {
            return $( this ).droppable( "instance" ).options.scope === scope;
          } );

          if ( parent.length ) {
            parentInstance = $( parent[ 0 ] ).droppable( "instance" );
            parentInstance.greedyChild = ( c === "isover" );
          }
        }

        // We just moved into a greedy child
        if ( parentInstance && c === "isover" ) {
          parentInstance.isover = false;
          parentInstance.isout = true;
          parentInstance._out.call( parentInstance, event );
        }

        this[ c ] = true;
        this[ c === "isout" ? "isover" : "isout" ] = false;
        this[ c === "isover" ? "_over" : "_out" ].call( this, event );

        // We just moved out of a greedy child
        if ( parentInstance && c === "isout" ) {
          parentInstance.isout = false;
          parentInstance.isover = true;
          parentInstance._over.call( parentInstance, event );
        }
      } );

    },
    dragStop: function ( draggable, event ) {
      draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );

      // Call prepareOffsets one final time since IE does not fire return scroll events when
      // overflow was caused by drag (see #5003)
      if ( !draggable.options.refreshPositions ) {
        $.ui.ddmanager.prepareOffsets( draggable, event );
      }
    }
  };

  // DEPRECATED
  // TODO: switch return back to widget declaration at top of file when this is removed
  if ( $.uiBackCompat !== false ) {

    // Backcompat for activeClass and hoverClass options
    $.widget( "ui.droppable", $.ui.droppable, {
      options: {
        hoverClass: false,
        activeClass: false
      },
      _addActiveClass: function () {
        this._super();
        if ( this.options.activeClass ) {
          this.element.addClass( this.options.activeClass );
        }
      },
      _removeActiveClass: function () {
        this._super();
        if ( this.options.activeClass ) {
          this.element.removeClass( this.options.activeClass );
        }
      },
      _addHoverClass: function () {
        this._super();
        if ( this.options.hoverClass ) {
          this.element.addClass( this.options.hoverClass );
        }
      },
      _removeHoverClass: function () {
        this._super();
        if ( this.options.hoverClass ) {
          this.element.removeClass( this.options.hoverClass );
        }
      }
    } );
  }

  var widgetsDroppable = $.ui.droppable;

  /* !
 * jQuery UI Progressbar 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Progressbar
  // >>group: Widgets
  // jscs:disable maximumLineLength
  // >>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
  // jscs:enable maximumLineLength
  // >>docs: http://api.jqueryui.com/progressbar/
  // >>demos: http://jqueryui.com/progressbar/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/progressbar.css
  // >>css.theme: ../../themes/base/theme.css

  var widgetsProgressbar = $.widget( "ui.progressbar", {
    version: "1.12.1",
    options: {
      classes: {
        "ui-progressbar": "ui-corner-all",
        "ui-progressbar-value": "ui-corner-left",
        "ui-progressbar-complete": "ui-corner-right"
      },
      max: 100,
      value: 0,

      change: null,
      complete: null
    },

    min: 0,

    _create: function () {

      // Constrain initial value
      this.oldValue = this.options.value = this._constrainedValue();

      this.element.attr( {

        // Only set static values; aria-valuenow and aria-valuemax are
        // set inside _refreshValue()
        role: "progressbar",
        "aria-valuemin": this.min
      } );
      this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );

      this.valueDiv = $( "<div>" ).appendTo( this.element );
      this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
      this._refreshValue();
    },

    _destroy: function () {
      this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );

      this.valueDiv.remove();
    },

    value: function ( newValue ) {
      if ( newValue === undefined ) {
        return this.options.value;
      }

      this.options.value = this._constrainedValue( newValue );
      this._refreshValue();
    },

    _constrainedValue: function ( newValue ) {
      if ( newValue === undefined ) {
        newValue = this.options.value;
      }

      this.indeterminate = newValue === false;

      // Sanitize value
      if ( typeof newValue !== "number" ) {
        newValue = 0;
      }

      return this.indeterminate ? false :
        Math.min( this.options.max, Math.max( this.min, newValue ) );
    },

    _setOptions: function ( options ) {

      // Ensure "value" option is set after other values (like max)
      var value = options.value;
      delete options.value;

      this._super( options );

      this.options.value = this._constrainedValue( value );
      this._refreshValue();
    },

    _setOption: function ( key, value ) {
      if ( key === "max" ) {

        // Don't allow a max less than min
        value = Math.max( this.min, value );
      }
      this._super( key, value );
    },

    _setOptionDisabled: function ( value ) {
      this._super( value );

      this.element.attr( "aria-disabled", value );
      this._toggleClass( null, "ui-state-disabled", !!value );
    },

    _percentage: function () {
      return this.indeterminate ?
        100 :
        100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
    },

    _refreshValue: function () {
      var value = this.options.value,
        percentage = this._percentage();

      this.valueDiv
        .toggle( this.indeterminate || value > this.min )
        .width( percentage.toFixed( 0 ) + "%" );

      this
        ._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
          value === this.options.max )
        ._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );

      if ( this.indeterminate ) {
        this.element.removeAttr( "aria-valuenow" );
        if ( !this.overlayDiv ) {
          this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
          this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
        }
      } else {
        this.element.attr( {
          "aria-valuemax": this.options.max,
          "aria-valuenow": value
        } );
        if ( this.overlayDiv ) {
          this.overlayDiv.remove();
          this.overlayDiv = null;
        }
      }

      if ( this.oldValue !== value ) {
        this.oldValue = value;
        this._trigger( "change" );
      }
      if ( value === this.options.max ) {
        this._trigger( "complete" );
      }
    }
  } );

  /* !
 * jQuery UI Selectable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Selectable
  // >>group: Interactions
  // >>description: Allows groups of elements to be selected with the mouse.
  // >>docs: http://api.jqueryui.com/selectable/
  // >>demos: http://jqueryui.com/selectable/
  // >>css.structure: ../../themes/base/selectable.css

  var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
    version: "1.12.1",
    options: {
      appendTo: "body",
      autoRefresh: true,
      distance: 0,
      filter: "*",
      tolerance: "touch",

      // Callbacks
      selected: null,
      selecting: null,
      start: null,
      stop: null,
      unselected: null,
      unselecting: null
    },
    _create: function () {
      var that = this;

      this._addClass( "ui-selectable" );

      this.dragged = false;

      // Cache selectee children based on filter
      this.refresh = function () {
        that.elementPos = $( that.element[ 0 ] ).offset();
        that.selectees = $( that.options.filter, that.element[ 0 ] );
        that._addClass( that.selectees, "ui-selectee" );
        that.selectees.each( function () {
          var $this = $( this ),
            selecteeOffset = $this.offset(),
            pos = {
              left: selecteeOffset.left - that.elementPos.left,
              top: selecteeOffset.top - that.elementPos.top
            };
          $.data( this, "selectable-item", {
            element: this,
            $element: $this,
            left: pos.left,
            top: pos.top,
            right: pos.left + $this.outerWidth(),
            bottom: pos.top + $this.outerHeight(),
            startselected: false,
            selected: $this.hasClass( "ui-selected" ),
            selecting: $this.hasClass( "ui-selecting" ),
            unselecting: $this.hasClass( "ui-unselecting" )
          } );
        } );
      };
      this.refresh();

      this._mouseInit();

      this.helper = $( "<div>" );
      this._addClass( this.helper, "ui-selectable-helper" );
    },

    _destroy: function () {
      this.selectees.removeData( "selectable-item" );
      this._mouseDestroy();
    },

    _mouseStart: function ( event ) {
      var that = this,
        options = this.options;

      this.opos = [ event.pageX, event.pageY ];
      this.elementPos = $( this.element[ 0 ] ).offset();

      if ( this.options.disabled ) {
        return;
      }

      this.selectees = $( options.filter, this.element[ 0 ] );

      this._trigger( "start", event );

      $( options.appendTo ).append( this.helper );

      // position helper (lasso)
      this.helper.css( {
        "left": event.pageX,
        "top": event.pageY,
        "width": 0,
        "height": 0
      } );

      if ( options.autoRefresh ) {
        this.refresh();
      }

      this.selectees.filter( ".ui-selected" ).each( function () {
        var selectee = $.data( this, "selectable-item" );
        selectee.startselected = true;
        if ( !event.metaKey && !event.ctrlKey ) {
          that._removeClass( selectee.$element, "ui-selected" );
          selectee.selected = false;
          that._addClass( selectee.$element, "ui-unselecting" );
          selectee.unselecting = true;

          // selectable UNSELECTING callback
          that._trigger( "unselecting", event, {
            unselecting: selectee.element
          } );
        }
      } );

      $( event.target ).parents().addBack().each( function () {
        var doSelect,
          selectee = $.data( this, "selectable-item" );
        if ( selectee ) {
          doSelect = ( !event.metaKey && !event.ctrlKey ) ||
					!selectee.$element.hasClass( "ui-selected" );
          that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
            ._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
          selectee.unselecting = !doSelect;
          selectee.selecting = doSelect;
          selectee.selected = doSelect;

          // selectable (UN)SELECTING callback
          if ( doSelect ) {
            that._trigger( "selecting", event, {
              selecting: selectee.element
            } );
          } else {
            that._trigger( "unselecting", event, {
              unselecting: selectee.element
            } );
          }
          return false;
        }
      } );

    },

    _mouseDrag: function ( event ) {

      this.dragged = true;

      if ( this.options.disabled ) {
        return;
      }

      var tmp,
        that = this,
        options = this.options,
        x1 = this.opos[ 0 ],
        y1 = this.opos[ 1 ],
        x2 = event.pageX,
        y2 = event.pageY;

      if ( x1 > x2 ) { tmp = x2; x2 = x1; x1 = tmp; }
      if ( y1 > y2 ) { tmp = y2; y2 = y1; y1 = tmp; }
      this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );

      this.selectees.each( function () {
        var selectee = $.data( this, "selectable-item" ),
          hit = false,
          offset = {};

        // prevent helper from being selected if appendTo: selectable
        if ( !selectee || selectee.element === that.element[ 0 ] ) {
          return;
        }

        offset.left = selectee.left + that.elementPos.left;
        offset.right = selectee.right + that.elementPos.left;
        offset.top = selectee.top + that.elementPos.top;
        offset.bottom = selectee.bottom + that.elementPos.top;

        if ( options.tolerance === "touch" ) {
          hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
                    offset.bottom < y1 ) );
        } else if ( options.tolerance === "fit" ) {
          hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
                    offset.bottom < y2 );
        }

        if ( hit ) {

          // SELECT
          if ( selectee.selected ) {
            that._removeClass( selectee.$element, "ui-selected" );
            selectee.selected = false;
          }
          if ( selectee.unselecting ) {
            that._removeClass( selectee.$element, "ui-unselecting" );
            selectee.unselecting = false;
          }
          if ( !selectee.selecting ) {
            that._addClass( selectee.$element, "ui-selecting" );
            selectee.selecting = true;

            // selectable SELECTING callback
            that._trigger( "selecting", event, {
              selecting: selectee.element
            } );
          }
        } else {

          // UNSELECT
          if ( selectee.selecting ) {
            if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
              that._removeClass( selectee.$element, "ui-selecting" );
              selectee.selecting = false;
              that._addClass( selectee.$element, "ui-selected" );
              selectee.selected = true;
            } else {
              that._removeClass( selectee.$element, "ui-selecting" );
              selectee.selecting = false;
              if ( selectee.startselected ) {
                that._addClass( selectee.$element, "ui-unselecting" );
                selectee.unselecting = true;
              }

              // selectable UNSELECTING callback
              that._trigger( "unselecting", event, {
                unselecting: selectee.element
              } );
            }
          }
          if ( selectee.selected ) {
            if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
              that._removeClass( selectee.$element, "ui-selected" );
              selectee.selected = false;

              that._addClass( selectee.$element, "ui-unselecting" );
              selectee.unselecting = true;

              // selectable UNSELECTING callback
              that._trigger( "unselecting", event, {
                unselecting: selectee.element
              } );
            }
          }
        }
      } );

      return false;
    },

    _mouseStop: function ( event ) {
      var that = this;

      this.dragged = false;

      $( ".ui-unselecting", this.element[ 0 ] ).each( function () {
        var selectee = $.data( this, "selectable-item" );
        that._removeClass( selectee.$element, "ui-unselecting" );
        selectee.unselecting = false;
        selectee.startselected = false;
        that._trigger( "unselected", event, {
          unselected: selectee.element
        } );
      } );
      $( ".ui-selecting", this.element[ 0 ] ).each( function () {
        var selectee = $.data( this, "selectable-item" );
        that._removeClass( selectee.$element, "ui-selecting" )
          ._addClass( selectee.$element, "ui-selected" );
        selectee.selecting = false;
        selectee.selected = true;
        selectee.startselected = true;
        that._trigger( "selected", event, {
          selected: selectee.element
        } );
      } );
      this._trigger( "stop", event );

      this.helper.remove();

      return false;
    }

  } );

  /* !
 * jQuery UI Selectmenu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Selectmenu
  // >>group: Widgets
  // jscs:disable maximumLineLength
  // >>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
  // jscs:enable maximumLineLength
  // >>docs: http://api.jqueryui.com/selectmenu/
  // >>demos: http://jqueryui.com/selectmenu/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
  // >>css.theme: ../../themes/base/theme.css

  var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
    version: "1.12.1",
    defaultElement: "<select>",
    options: {
      appendTo: null,
      classes: {
        "ui-selectmenu-button-open": "ui-corner-top",
        "ui-selectmenu-button-closed": "ui-corner-all"
      },
      disabled: null,
      icons: {
        button: "ui-icon-triangle-1-s"
      },
      position: {
        my: "left top",
        at: "left bottom",
        collision: "none"
      },
      width: false,

      // Callbacks
      change: null,
      close: null,
      focus: null,
      open: null,
      select: null
    },

    _create: function () {
      var selectmenuId = this.element.uniqueId().attr( "id" );
      this.ids = {
        element: selectmenuId,
        button: selectmenuId + "-button",
        menu: selectmenuId + "-menu"
      };

      this._drawButton();
      this._drawMenu();
      this._bindFormResetHandler();

      this._rendered = false;
      this.menuItems = $();
    },

    _drawButton: function () {
      var icon,
        that = this,
        item = this._parseOption(
          this.element.find( "option:selected" ),
          this.element[ 0 ].selectedIndex
        );

      // Associate existing label with the new button
      this.labels = this.element.labels().attr( "for", this.ids.button );
      this._on( this.labels, {
        click: function ( event ) {
          this.button.focus();
          event.preventDefault();
        }
      } );

      // Hide original select element
      this.element.hide();

      // Create button
      this.button = $( "<span>", {
        tabindex: this.options.disabled ? -1 : 0,
        id: this.ids.button,
        role: "combobox",
        "aria-expanded": "false",
        "aria-autocomplete": "list",
        "aria-owns": this.ids.menu,
        "aria-haspopup": "true",
        title: this.element.attr( "title" )
      } )
        .insertAfter( this.element );

      this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
        "ui-button ui-widget" );

      icon = $( "<span>" ).appendTo( this.button );
      this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
      this.buttonItem = this._renderButtonItem( item )
        .appendTo( this.button );

      if ( this.options.width !== false ) {
        this._resizeButton();
      }

      this._on( this.button, this._buttonEvents );
      this.button.one( "focusin", function () {

        // Delay rendering the menu items until the button receives focus.
        // The menu may have already been rendered via a programmatic open.
        if ( !that._rendered ) {
          that._refreshMenu();
        }
      } );
    },

    _drawMenu: function () {
      var that = this;

      // Create menu
      this.menu = $( "<ul>", {
        "aria-hidden": "true",
        "aria-labelledby": this.ids.button,
        id: this.ids.menu
      } );

      // Wrap menu
      this.menuWrap = $( "<div>" ).append( this.menu );
      this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
      this.menuWrap.appendTo( this._appendTo() );

      // Initialize menu widget
      this.menuInstance = this.menu
        .menu( {
          classes: {
            "ui-menu": "ui-corner-bottom"
          },
          role: "listbox",
          select: function ( event, ui ) {
            event.preventDefault();

            // Support: IE8
            // If the item was selected via a click, the text selection
            // will be destroyed in IE
            that._setSelection();

            that._select( ui.item.data( "ui-selectmenu-item" ), event );
          },
          focus: function ( event, ui ) {
            var item = ui.item.data( "ui-selectmenu-item" );

            // Prevent inital focus from firing and check if its a newly focused item
            if ( that.focusIndex != null && item.index !== that.focusIndex ) {
              that._trigger( "focus", event, { item: item } );
              if ( !that.isOpen ) {
                that._select( item, event );
              }
            }
            that.focusIndex = item.index;

            that.button.attr( "aria-activedescendant",
              that.menuItems.eq( item.index ).attr( "id" ) );
          }
        } )
        .menu( "instance" );

      // Don't close the menu on mouseleave
      this.menuInstance._off( this.menu, "mouseleave" );

      // Cancel the menu's collapseAll on document click
      this.menuInstance._closeOnDocumentClick = function () {
        return false;
      };

      // Selects often contain empty items, but never contain dividers
      this.menuInstance._isDivider = function () {
        return false;
      };
    },

    refresh: function () {
      this._refreshMenu();
      this.buttonItem.replaceWith(
        this.buttonItem = this._renderButtonItem(

          // Fall back to an empty object in case there are no options
          this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
        )
      );
      if ( this.options.width === null ) {
        this._resizeButton();
      }
    },

    _refreshMenu: function () {
      var item,
        options = this.element.find( "option" );

      this.menu.empty();

      this._parseOptions( options );
      this._renderMenu( this.menu, this.items );

      this.menuInstance.refresh();
      this.menuItems = this.menu.find( "li" )
        .not( ".ui-selectmenu-optgroup" )
        .find( ".ui-menu-item-wrapper" );

      this._rendered = true;

      if ( !options.length ) {
        return;
      }

      item = this._getSelectedItem();

      // Update the menu to have the correct item focused
      this.menuInstance.focus( null, item );
      this._setAria( item.data( "ui-selectmenu-item" ) );

      // Set disabled state
      this._setOption( "disabled", this.element.prop( "disabled" ) );
    },

    open: function ( event ) {
      if ( this.options.disabled ) {
        return;
      }

      // If this is the first time the menu is being opened, render the items
      if ( !this._rendered ) {
        this._refreshMenu();
      } else {

        // Menu clears focus on close, reset focus to selected item
        this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
        this.menuInstance.focus( null, this._getSelectedItem() );
      }

      // If there are no options, don't open the menu
      if ( !this.menuItems.length ) {
        return;
      }

      this.isOpen = true;
      this._toggleAttr();
      this._resizeMenu();
      this._position();

      this._on( this.document, this._documentClick );

      this._trigger( "open", event );
    },

    _position: function () {
      this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
    },

    close: function ( event ) {
      if ( !this.isOpen ) {
        return;
      }

      this.isOpen = false;
      this._toggleAttr();

      this.range = null;
      this._off( this.document );

      this._trigger( "close", event );
    },

    widget: function () {
      return this.button;
    },

    menuWidget: function () {
      return this.menu;
    },

    _renderButtonItem: function ( item ) {
      var buttonItem = $( "<span>" );

      this._setText( buttonItem, item.label );
      this._addClass( buttonItem, "ui-selectmenu-text" );

      return buttonItem;
    },

    _renderMenu: function ( ul, items ) {
      var that = this,
        currentOptgroup = "";

      $.each( items, function ( index, item ) {
        var li;

        if ( item.optgroup !== currentOptgroup ) {
          li = $( "<li>", {
            text: item.optgroup
          } );
          that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
					( item.element.parent( "optgroup" ).prop( "disabled" ) ?
					  " ui-state-disabled" :
					  "" ) );

          li.appendTo( ul );

          currentOptgroup = item.optgroup;
        }

        that._renderItemData( ul, item );
      } );
    },

    _renderItemData: function ( ul, item ) {
      return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
    },

    _renderItem: function ( ul, item ) {
      var li = $( "<li>" ),
        wrapper = $( "<div>", {
          title: item.element.attr( "title" )
        } );

      if ( item.disabled ) {
        this._addClass( li, null, "ui-state-disabled" );
      }
      this._setText( wrapper, item.label );

      return li.append( wrapper ).appendTo( ul );
    },

    _setText: function ( element, value ) {
      if ( value ) {
        element.text( value );
      } else {
        element.html( "&#160;" );
      }
    },

    _move: function ( direction, event ) {
      var item, next,
        filter = ".ui-menu-item";

      if ( this.isOpen ) {
        item = this.menuItems.eq( this.focusIndex ).parent( "li" );
      } else {
        item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
        filter += ":not(.ui-state-disabled)";
      }

      if ( direction === "first" || direction === "last" ) {
        next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
      } else {
        next = item[ direction + "All" ]( filter ).eq( 0 );
      }

      if ( next.length ) {
        this.menuInstance.focus( event, next );
      }
    },

    _getSelectedItem: function () {
      return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
    },

    _toggle: function ( event ) {
      this[ this.isOpen ? "close" : "open" ]( event );
    },

    _setSelection: function () {
      var selection;

      if ( !this.range ) {
        return;
      }

      if ( window.getSelection ) {
        selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange( this.range );

        // Support: IE8
      } else {
        this.range.select();
      }

      // Support: IE
      // Setting the text selection kills the button focus in IE, but
      // restoring the focus doesn't kill the selection.
      this.button.focus();
    },

    _documentClick: {
      mousedown: function ( event ) {
        if ( !this.isOpen ) {
          return;
        }

        if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
					$.ui.escapeSelector( this.ids.button ) ).length ) {
          this.close( event );
        }
      }
    },

    _buttonEvents: {

      // Prevent text selection from being reset when interacting with the selectmenu (#10144)
      mousedown: function () {
        var selection;

        if ( window.getSelection ) {
          selection = window.getSelection();
          if ( selection.rangeCount ) {
            this.range = selection.getRangeAt( 0 );
          }

          // Support: IE8
        } else {
          this.range = document.selection.createRange();
        }
      },

      click: function ( event ) {
        this._setSelection();
        this._toggle( event );
      },

      keydown: function ( event ) {
        var preventDefault = true;
        switch ( event.keyCode ) {
          case $.ui.keyCode.TAB:
          case $.ui.keyCode.ESCAPE:
            this.close( event );
            preventDefault = false;
            break;
          case $.ui.keyCode.ENTER:
            if ( this.isOpen ) {
              this._selectFocusedItem( event );
            }
            break;
          case $.ui.keyCode.UP:
            if ( event.altKey ) {
              this._toggle( event );
            } else {
              this._move( "prev", event );
            }
            break;
          case $.ui.keyCode.DOWN:
            if ( event.altKey ) {
              this._toggle( event );
            } else {
              this._move( "next", event );
            }
            break;
          case $.ui.keyCode.SPACE:
            if ( this.isOpen ) {
              this._selectFocusedItem( event );
            } else {
              this._toggle( event );
            }
            break;
          case $.ui.keyCode.LEFT:
            this._move( "prev", event );
            break;
          case $.ui.keyCode.RIGHT:
            this._move( "next", event );
            break;
          case $.ui.keyCode.HOME:
          case $.ui.keyCode.PAGE_UP:
            this._move( "first", event );
            break;
          case $.ui.keyCode.END:
          case $.ui.keyCode.PAGE_DOWN:
            this._move( "last", event );
            break;
          default:
            this.menu.trigger( event );
            preventDefault = false;
        }

        if ( preventDefault ) {
          event.preventDefault();
        }
      }
    },

    _selectFocusedItem: function ( event ) {
      var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
      if ( !item.hasClass( "ui-state-disabled" ) ) {
        this._select( item.data( "ui-selectmenu-item" ), event );
      }
    },

    _select: function ( item, event ) {
      var oldIndex = this.element[ 0 ].selectedIndex;

      // Change native select element
      this.element[ 0 ].selectedIndex = item.index;
      this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
      this._setAria( item );
      this._trigger( "select", event, { item: item } );

      if ( item.index !== oldIndex ) {
        this._trigger( "change", event, { item: item } );
      }

      this.close( event );
    },

    _setAria: function ( item ) {
      var id = this.menuItems.eq( item.index ).attr( "id" );

      this.button.attr( {
        "aria-labelledby": id,
        "aria-activedescendant": id
      } );
      this.menu.attr( "aria-activedescendant", id );
    },

    _setOption: function ( key, value ) {
      if ( key === "icons" ) {
        var icon = this.button.find( "span.ui-icon" );
        this._removeClass( icon, null, this.options.icons.button )
          ._addClass( icon, null, value.button );
      }

      this._super( key, value );

      if ( key === "appendTo" ) {
        this.menuWrap.appendTo( this._appendTo() );
      }

      if ( key === "width" ) {
        this._resizeButton();
      }
    },

    _setOptionDisabled: function ( value ) {
      this._super( value );

      this.menuInstance.option( "disabled", value );
      this.button.attr( "aria-disabled", value );
      this._toggleClass( this.button, null, "ui-state-disabled", value );

      this.element.prop( "disabled", value );
      if ( value ) {
        this.button.attr( "tabindex", -1 );
        this.close();
      } else {
        this.button.attr( "tabindex", 0 );
      }
    },

    _appendTo: function () {
      var element = this.options.appendTo;

      if ( element ) {
        element = element.jquery || element.nodeType ?
          $( element ) :
          this.document.find( element ).eq( 0 );
      }

      if ( !element || !element[ 0 ] ) {
        element = this.element.closest( ".ui-front, dialog" );
      }

      if ( !element.length ) {
        element = this.document[ 0 ].body;
      }

      return element;
    },

    _toggleAttr: function () {
      this.button.attr( "aria-expanded", this.isOpen );

      // We can't use two _toggleClass() calls here, because we need to make sure
      // we always remove classes first and add them second, otherwise if both classes have the
      // same theme class, it will be removed after we add it.
      this._removeClass( this.button, "ui-selectmenu-button-" +
			( this.isOpen ? "closed" : "open" ) )
        ._addClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "open" : "closed" ) )
        ._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );

      this.menu.attr( "aria-hidden", !this.isOpen );
    },

    _resizeButton: function () {
      var width = this.options.width;

      // For `width: false`, just remove inline style and stop
      if ( width === false ) {
        this.button.css( "width", "" );
        return;
      }

      // For `width: null`, match the width of the original element
      if ( width === null ) {
        width = this.element.show().outerWidth();
        this.element.hide();
      }

      this.button.outerWidth( width );
    },

    _resizeMenu: function () {
      this.menu.outerWidth( Math.max(
        this.button.outerWidth(),

        // Support: IE10
        // IE10 wraps long text (possibly a rounding bug)
        // so we add 1px to avoid the wrapping
        this.menu.width( "" ).outerWidth() + 1
      ) );
    },

    _getCreateOptions: function () {
      var options = this._super();

      options.disabled = this.element.prop( "disabled" );

      return options;
    },

    _parseOptions: function ( options ) {
      var that = this,
        data = [];
      options.each( function ( index, item ) {
        data.push( that._parseOption( $( item ), index ) );
      } );
      this.items = data;
    },

    _parseOption: function ( option, index ) {
      var optgroup = option.parent( "optgroup" );

      return {
        element: option,
        index: index,
        value: option.val(),
        label: option.text(),
        optgroup: optgroup.attr( "label" ) || "",
        disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
      };
    },

    _destroy: function () {
      this._unbindFormResetHandler();
      this.menuWrap.remove();
      this.button.remove();
      this.element.show();
      this.element.removeUniqueId();
      this.labels.attr( "for", this.ids.element );
    }
  } ] );

  /* !
 * jQuery UI Slider 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Slider
  // >>group: Widgets
  // >>description: Displays a flexible slider with ranges and accessibility via keyboard.
  // >>docs: http://api.jqueryui.com/slider/
  // >>demos: http://jqueryui.com/slider/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/slider.css
  // >>css.theme: ../../themes/base/theme.css

  var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
    version: "1.12.1",
    widgetEventPrefix: "slide",

    options: {
      animate: false,
      classes: {
        "ui-slider": "ui-corner-all",
        "ui-slider-handle": "ui-corner-all",

        // Note: ui-widget-header isn't the most fittingly semantic framework class for this
        // element, but worked best visually with a variety of themes
        "ui-slider-range": "ui-corner-all ui-widget-header"
      },
      distance: 0,
      max: 100,
      min: 0,
      orientation: "horizontal",
      range: false,
      step: 1,
      value: 0,
      values: null,

      // Callbacks
      change: null,
      slide: null,
      start: null,
      stop: null
    },

    // Number of pages in a slider
    // (how many times can you page up/down to go through the whole range)
    numPages: 5,

    _create: function () {
      this._keySliding = false;
      this._mouseSliding = false;
      this._animateOff = true;
      this._handleIndex = null;
      this._detectOrientation();
      this._mouseInit();
      this._calculateNewMax();

      this._addClass( "ui-slider ui-slider-" + this.orientation,
        "ui-widget ui-widget-content" );

      this._refresh();

      this._animateOff = false;
    },

    _refresh: function () {
      this._createRange();
      this._createHandles();
      this._setupEvents();
      this._refreshValue();
    },

    _createHandles: function () {
      var i, handleCount,
        options = this.options,
        existingHandles = this.element.find( ".ui-slider-handle" ),
        handle = "<span tabindex='0'></span>",
        handles = [];

      handleCount = ( options.values && options.values.length ) || 1;

      if ( existingHandles.length > handleCount ) {
        existingHandles.slice( handleCount ).remove();
        existingHandles = existingHandles.slice( 0, handleCount );
      }

      for ( i = existingHandles.length; i < handleCount; i++ ) {
        handles.push( handle );
      }

      this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

      this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

      this.handle = this.handles.eq( 0 );

      this.handles.each( function ( i ) {
        $( this )
          .data( "ui-slider-handle-index", i )
          .attr( "tabIndex", 0 );
      } );
    },

    _createRange: function () {
      var options = this.options;

      if ( options.range ) {
        if ( options.range === true ) {
          if ( !options.values ) {
            options.values = [ this._valueMin(), this._valueMin() ];
          } else if ( options.values.length && options.values.length !== 2 ) {
            options.values = [ options.values[ 0 ], options.values[ 0 ] ];
          } else if ( $.isArray( options.values ) ) {
            options.values = options.values.slice( 0 );
          }
        }

        if ( !this.range || !this.range.length ) {
          this.range = $( "<div>" )
            .appendTo( this.element );

          this._addClass( this.range, "ui-slider-range" );
        } else {
          this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

          // Handle range switching from true to min/max
          this.range.css( {
            "left": "",
            "bottom": ""
          } );
        }
        if ( options.range === "min" || options.range === "max" ) {
          this._addClass( this.range, "ui-slider-range-" + options.range );
        }
      } else {
        if ( this.range ) {
          this.range.remove();
        }
        this.range = null;
      }
    },

    _setupEvents: function () {
      this._off( this.handles );
      this._on( this.handles, this._handleEvents );
      this._hoverable( this.handles );
      this._focusable( this.handles );
    },

    _destroy: function () {
      this.handles.remove();
      if ( this.range ) {
        this.range.remove();
      }

      this._mouseDestroy();
    },

    _mouseCapture: function ( event ) {
      var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
        that = this,
        o = this.options;

      if ( o.disabled ) {
        return false;
      }

      this.elementSize = {
        width: this.element.outerWidth(),
        height: this.element.outerHeight()
      };
      this.elementOffset = this.element.offset();

      position = { x: event.pageX, y: event.pageY };
      normValue = this._normValueFromMouse( position );
      distance = this._valueMax() - this._valueMin() + 1;
      this.handles.each( function ( i ) {
        var thisDistance = Math.abs( normValue - that.values( i ) );
        if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
          distance = thisDistance;
          closestHandle = $( this );
          index = i;
        }
      } );

      allowed = this._start( event, index );
      if ( allowed === false ) {
        return false;
      }
      this._mouseSliding = true;

      this._handleIndex = index;

      this._addClass( closestHandle, null, "ui-state-active" );
      closestHandle.trigger( "focus" );

      offset = closestHandle.offset();
      mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
      this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
        left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
        top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
      };

      if ( !this.handles.hasClass( "ui-state-hover" ) ) {
        this._slide( event, index, normValue );
      }
      this._animateOff = true;
      return true;
    },

    _mouseStart: function () {
      return true;
    },

    _mouseDrag: function ( event ) {
      var position = { x: event.pageX, y: event.pageY },
        normValue = this._normValueFromMouse( position );

      this._slide( event, this._handleIndex, normValue );

      return false;
    },

    _mouseStop: function ( event ) {
      this._removeClass( this.handles, null, "ui-state-active" );
      this._mouseSliding = false;

      this._stop( event, this._handleIndex );
      this._change( event, this._handleIndex );

      this._handleIndex = null;
      this._clickOffset = null;
      this._animateOff = false;

      return false;
    },

    _detectOrientation: function () {
      this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
    },

    _normValueFromMouse: function ( position ) {
      var pixelTotal,
        pixelMouse,
        percentMouse,
        valueTotal,
        valueMouse;

      if ( this.orientation === "horizontal" ) {
        pixelTotal = this.elementSize.width;
        pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
      } else {
        pixelTotal = this.elementSize.height;
        pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
      }

      percentMouse = ( pixelMouse / pixelTotal );
      if ( percentMouse > 1 ) {
        percentMouse = 1;
      }
      if ( percentMouse < 0 ) {
        percentMouse = 0;
      }
      if ( this.orientation === "vertical" ) {
        percentMouse = 1 - percentMouse;
      }

      valueTotal = this._valueMax() - this._valueMin();
      valueMouse = this._valueMin() + percentMouse * valueTotal;

      return this._trimAlignValue( valueMouse );
    },

    _uiHash: function ( index, value, values ) {
      var uiHash = {
        handle: this.handles[ index ],
        handleIndex: index,
        value: value !== undefined ? value : this.value()
      };

      if ( this._hasMultipleValues() ) {
        uiHash.value = value !== undefined ? value : this.values( index );
        uiHash.values = values || this.values();
      }

      return uiHash;
    },

    _hasMultipleValues: function () {
      return this.options.values && this.options.values.length;
    },

    _start: function ( event, index ) {
      return this._trigger( "start", event, this._uiHash( index ) );
    },

    _slide: function ( event, index, newVal ) {
      var allowed, otherVal,
        currentValue = this.value(),
        newValues = this.values();

      if ( this._hasMultipleValues() ) {
        otherVal = this.values( index ? 0 : 1 );
        currentValue = this.values( index );

        if ( this.options.values.length === 2 && this.options.range === true ) {
          newVal = index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
        }

        newValues[ index ] = newVal;
      }

      if ( newVal === currentValue ) {
        return;
      }

      allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

      // A slide can be canceled by returning false from the slide callback
      if ( allowed === false ) {
        return;
      }

      if ( this._hasMultipleValues() ) {
        this.values( index, newVal );
      } else {
        this.value( newVal );
      }
    },

    _stop: function ( event, index ) {
      this._trigger( "stop", event, this._uiHash( index ) );
    },

    _change: function ( event, index ) {
      if ( !this._keySliding && !this._mouseSliding ) {

        // store the last changed value index for reference when handles overlap
        this._lastChangedValue = index;
        this._trigger( "change", event, this._uiHash( index ) );
      }
    },

    value: function ( newValue ) {
      if ( arguments.length ) {
        this.options.value = this._trimAlignValue( newValue );
        this._refreshValue();
        this._change( null, 0 );
        return;
      }

      return this._value();
    },

    values: function ( index, newValue ) {
      var vals,
        newValues,
        i;

      if ( arguments.length > 1 ) {
        this.options.values[ index ] = this._trimAlignValue( newValue );
        this._refreshValue();
        this._change( null, index );
        return;
      }

      if ( arguments.length ) {
        if ( $.isArray( arguments[ 0 ] ) ) {
          vals = this.options.values;
          newValues = arguments[ 0 ];
          for ( i = 0; i < vals.length; i += 1 ) {
            vals[ i ] = this._trimAlignValue( newValues[ i ] );
            this._change( null, i );
          }
          this._refreshValue();
        } else {
          if ( this._hasMultipleValues() ) {
            return this._values( index );
          } else {
            return this.value();
          }
        }
      } else {
        return this._values();
      }
    },

    _setOption: function ( key, value ) {
      var i,
        valsLength = 0;

      if ( key === "range" && this.options.range === true ) {
        if ( value === "min" ) {
          this.options.value = this._values( 0 );
          this.options.values = null;
        } else if ( value === "max" ) {
          this.options.value = this._values( this.options.values.length - 1 );
          this.options.values = null;
        }
      }

      if ( $.isArray( this.options.values ) ) {
        valsLength = this.options.values.length;
      }

      this._super( key, value );

      switch ( key ) {
        case "orientation":
          this._detectOrientation();
          this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
            ._addClass( "ui-slider-" + this.orientation );
          this._refreshValue();
          if ( this.options.range ) {
            this._refreshRange( value );
          }

          // Reset positioning from previous orientation
          this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
          break;
        case "value":
          this._animateOff = true;
          this._refreshValue();
          this._change( null, 0 );
          this._animateOff = false;
          break;
        case "values":
          this._animateOff = true;
          this._refreshValue();

          // Start from the last handle to prevent unreachable handles (#9046)
          for ( i = valsLength - 1; i >= 0; i-- ) {
            this._change( null, i );
          }
          this._animateOff = false;
          break;
        case "step":
        case "min":
        case "max":
          this._animateOff = true;
          this._calculateNewMax();
          this._refreshValue();
          this._animateOff = false;
          break;
        case "range":
          this._animateOff = true;
          this._refresh();
          this._animateOff = false;
          break;
      }
    },

    _setOptionDisabled: function ( value ) {
      this._super( value );

      this._toggleClass( null, "ui-state-disabled", !!value );
    },

    // internal value getter
    // _value() returns value trimmed by min and max, aligned by step
    _value: function () {
      var val = this.options.value;
      val = this._trimAlignValue( val );

      return val;
    },

    // internal values getter
    // _values() returns array of values trimmed by min and max, aligned by step
    // _values( index ) returns single value trimmed by min and max, aligned by step
    _values: function ( index ) {
      var val,
        vals,
        i;

      if ( arguments.length ) {
        val = this.options.values[ index ];
        val = this._trimAlignValue( val );

        return val;
      } else if ( this._hasMultipleValues() ) {

        // .slice() creates a copy of the array
        // this copy gets trimmed by min and max and then returned
        vals = this.options.values.slice();
        for ( i = 0; i < vals.length; i += 1 ) {
          vals[ i ] = this._trimAlignValue( vals[ i ] );
        }

        return vals;
      } else {
        return [];
      }
    },

    // Returns the step-aligned value that val is closest to, between (inclusive) min and max
    _trimAlignValue: function ( val ) {
      if ( val <= this._valueMin() ) {
        return this._valueMin();
      }
      if ( val >= this._valueMax() ) {
        return this._valueMax();
      }
      var step = ( this.options.step > 0 ) ? this.options.step : 1,
        valModStep = ( val - this._valueMin() ) % step,
        alignValue = val - valModStep;

      if ( Math.abs( valModStep ) * 2 >= step ) {
        alignValue += ( valModStep > 0 ) ? step : ( -step );
      }

      // Since JavaScript has problems with large floats, round
      // the final value to 5 digits after the decimal point (see #4124)
      return parseFloat( alignValue.toFixed( 5 ) );
    },

    _calculateNewMax: function () {
      var max = this.options.max,
        min = this._valueMin(),
        step = this.options.step,
        aboveMin = Math.round( ( max - min ) / step ) * step;
      max = aboveMin + min;
      if ( max > this.options.max ) {

        // If max is not divisible by step, rounding off may increase its value
        max -= step;
      }
      this.max = parseFloat( max.toFixed( this._precision() ) );
    },

    _precision: function () {
      var precision = this._precisionOf( this.options.step );
      if ( this.options.min !== null ) {
        precision = Math.max( precision, this._precisionOf( this.options.min ) );
      }
      return precision;
    },

    _precisionOf: function ( num ) {
      var str = num.toString(),
        decimal = str.indexOf( "." );
      return decimal === -1 ? 0 : str.length - decimal - 1;
    },

    _valueMin: function () {
      return this.options.min;
    },

    _valueMax: function () {
      return this.max;
    },

    _refreshRange: function ( orientation ) {
      if ( orientation === "vertical" ) {
        this.range.css( { "width": "", "left": "" } );
      }
      if ( orientation === "horizontal" ) {
        this.range.css( { "height": "", "bottom": "" } );
      }
    },

    _refreshValue: function () {
      var lastValPercent, valPercent, value, valueMin, valueMax,
        oRange = this.options.range,
        o = this.options,
        that = this,
        animate = ( !this._animateOff ) ? o.animate : false,
        _set = {};

      if ( this._hasMultipleValues() ) {
        this.handles.each( function ( i ) {
          valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
          _set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
          $( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
          if ( that.options.range === true ) {
            if ( that.orientation === "horizontal" ) {
              if ( i === 0 ) {
                that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
                  left: valPercent + "%"
                }, o.animate );
              }
              if ( i === 1 ) {
                that.range[ animate ? "animate" : "css" ]( {
                  width: ( valPercent - lastValPercent ) + "%"
                }, {
                  queue: false,
                  duration: o.animate
                } );
              }
            } else {
              if ( i === 0 ) {
                that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
                  bottom: ( valPercent ) + "%"
                }, o.animate );
              }
              if ( i === 1 ) {
                that.range[ animate ? "animate" : "css" ]( {
                  height: ( valPercent - lastValPercent ) + "%"
                }, {
                  queue: false,
                  duration: o.animate
                } );
              }
            }
          }
          lastValPercent = valPercent;
        } );
      } else {
        value = this.value();
        valueMin = this._valueMin();
        valueMax = this._valueMax();
        valPercent = ( valueMax !== valueMin ) ?
          ( value - valueMin ) / ( valueMax - valueMin ) * 100 :
          0;
        _set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
        this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

        if ( oRange === "min" && this.orientation === "horizontal" ) {
          this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
            width: valPercent + "%"
          }, o.animate );
        }
        if ( oRange === "max" && this.orientation === "horizontal" ) {
          this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
            width: ( 100 - valPercent ) + "%"
          }, o.animate );
        }
        if ( oRange === "min" && this.orientation === "vertical" ) {
          this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
            height: valPercent + "%"
          }, o.animate );
        }
        if ( oRange === "max" && this.orientation === "vertical" ) {
          this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
            height: ( 100 - valPercent ) + "%"
          }, o.animate );
        }
      }
    },

    _handleEvents: {
      keydown: function ( event ) {
        var allowed, curVal, newVal, step,
          index = $( event.target ).data( "ui-slider-handle-index" );

        switch ( event.keyCode ) {
          case $.ui.keyCode.HOME:
          case $.ui.keyCode.END:
          case $.ui.keyCode.PAGE_UP:
          case $.ui.keyCode.PAGE_DOWN:
          case $.ui.keyCode.UP:
          case $.ui.keyCode.RIGHT:
          case $.ui.keyCode.DOWN:
          case $.ui.keyCode.LEFT:
            event.preventDefault();
            if ( !this._keySliding ) {
              this._keySliding = true;
              this._addClass( $( event.target ), null, "ui-state-active" );
              allowed = this._start( event, index );
              if ( allowed === false ) {
                return;
              }
            }
            break;
        }

        step = this.options.step;
        if ( this._hasMultipleValues() ) {
          curVal = newVal = this.values( index );
        } else {
          curVal = newVal = this.value();
        }

        switch ( event.keyCode ) {
          case $.ui.keyCode.HOME:
            newVal = this._valueMin();
            break;
          case $.ui.keyCode.END:
            newVal = this._valueMax();
            break;
          case $.ui.keyCode.PAGE_UP:
            newVal = this._trimAlignValue(
              curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
            );
            break;
          case $.ui.keyCode.PAGE_DOWN:
            newVal = this._trimAlignValue(
              curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
            break;
          case $.ui.keyCode.UP:
          case $.ui.keyCode.RIGHT:
            if ( curVal === this._valueMax() ) {
              return;
            }
            newVal = this._trimAlignValue( curVal + step );
            break;
          case $.ui.keyCode.DOWN:
          case $.ui.keyCode.LEFT:
            if ( curVal === this._valueMin() ) {
              return;
            }
            newVal = this._trimAlignValue( curVal - step );
            break;
        }

        this._slide( event, index, newVal );
      },
      keyup: function ( event ) {
        var index = $( event.target ).data( "ui-slider-handle-index" );

        if ( this._keySliding ) {
          this._keySliding = false;
          this._stop( event, index );
          this._change( event, index );
          this._removeClass( $( event.target ), null, "ui-state-active" );
        }
      }
    }
  } );

  /* !
 * jQuery UI Sortable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Sortable
  // >>group: Interactions
  // >>description: Enables items in a list to be sorted using the mouse.
  // >>docs: http://api.jqueryui.com/sortable/
  // >>demos: http://jqueryui.com/sortable/
  // >>css.structure: ../../themes/base/sortable.css

  var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
    version: "1.12.1",
    widgetEventPrefix: "sort",
    ready: false,
    options: {
      appendTo: "parent",
      axis: false,
      connectWith: false,
      containment: false,
      cursor: "auto",
      cursorAt: false,
      dropOnEmpty: true,
      forcePlaceholderSize: false,
      forceHelperSize: false,
      grid: false,
      handle: false,
      helper: "original",
      items: "> *",
      opacity: false,
      placeholder: false,
      revert: false,
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      scope: "default",
      tolerance: "intersect",
      zIndex: 1000,

      // Callbacks
      activate: null,
      beforeStop: null,
      change: null,
      deactivate: null,
      out: null,
      over: null,
      receive: null,
      remove: null,
      sort: null,
      start: null,
      stop: null,
      update: null
    },

    _isOverAxis: function ( x, reference, size ) {
      return ( x >= reference ) && ( x < ( reference + size ) );
    },

    _isFloating: function ( item ) {
      return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
    },

    _create: function () {
      this.containerCache = {};
      this._addClass( "ui-sortable" );

      // Get the items
      this.refresh();

      // Let's determine the parent's offset
      this.offset = this.element.offset();

      // Initialize mouse events for interaction
      this._mouseInit();

      this._setHandleClassName();

      // We're ready to go
      this.ready = true;

    },

    _setOption: function ( key, value ) {
      this._super( key, value );

      if ( key === "handle" ) {
        this._setHandleClassName();
      }
    },

    _setHandleClassName: function () {
      var that = this;
      this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
      $.each( this.items, function () {
        that._addClass(
          this.instance.options.handle ?
            this.item.find( this.instance.options.handle ) :
            this.item,
          "ui-sortable-handle"
        );
      } );
    },

    _destroy: function () {
      this._mouseDestroy();

      for ( var i = this.items.length - 1; i >= 0; i-- ) {
        this.items[ i ].item.removeData( this.widgetName + "-item" );
      }

      return this;
    },

    _mouseCapture: function ( event, overrideHandle ) {
      var currentItem = null,
        validHandle = false,
        that = this;

      if ( this.reverting ) {
        return false;
      }

      if ( this.options.disabled || this.options.type === "static" ) {
        return false;
      }

      // We have to refresh the items data once first
      this._refreshItems( event );

      // Find out if the clicked node (or one of its parents) is a actual item in this.items
      $( event.target ).parents().each( function () {
        if ( $.data( this, that.widgetName + "-item" ) === that ) {
          currentItem = $( this );
          return false;
        }
      } );
      if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
        currentItem = $( event.target );
      }

      if ( !currentItem ) {
        return false;
      }
      if ( this.options.handle && !overrideHandle ) {
        $( this.options.handle, currentItem ).find( "*" ).addBack().each( function () {
          if ( this === event.target ) {
            validHandle = true;
          }
        } );
        if ( !validHandle ) {
          return false;
        }
      }

      this.currentItem = currentItem;
      this._removeCurrentsFromItems();
      return true;

    },

    _mouseStart: function ( event, overrideHandle, noActivation ) {

      var i, body,
        o = this.options;

      this.currentContainer = this;

      // We only need to call refreshPositions, because the refreshItems call has been moved to
      // mouseCapture
      this.refreshPositions();

      // Create and append the visible helper
      this.helper = this._createHelper( event );

      // Cache the helper size
      this._cacheHelperProportions();

      /*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

      // Cache the margins of the original element
      this._cacheMargins();

      // Get the next scrolling parent
      this.scrollParent = this.helper.scrollParent();

      // The element's absolute position on the page minus margins
      this.offset = this.currentItem.offset();
      this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left
      };

      $.extend( this.offset, {
        click: { // Where the click happened, relative to the element
          left: event.pageX - this.offset.left,
          top: event.pageY - this.offset.top
        },
        parent: this._getParentOffset(),

        // This is a relative to absolute position minus the actual position calculation -
        // only used for relative positioned helper
        relative: this._getRelativeOffset()
      } );

      // Only after we got the offset, we can change the helper's position to absolute
      // TODO: Still need to figure out a way to make relative sorting possible
      this.helper.css( "position", "absolute" );
      this.cssPosition = this.helper.css( "position" );

      // Generate the original position
      this.originalPosition = this._generatePosition( event );
      this.originalPageX = event.pageX;
      this.originalPageY = event.pageY;

      // Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      ( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

      // Cache the former DOM position
      this.domPosition = {
        prev: this.currentItem.prev()[ 0 ],
        parent: this.currentItem.parent()[ 0 ]
      };

      // If the helper is not the original, hide the original so it's not playing any role during
      // the drag, won't cause anything bad this way
      if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
        this.currentItem.hide();
      }

      // Create the placeholder
      this._createPlaceholder();

      // Set a containment if given in the options
      if ( o.containment ) {
        this._setContainment();
      }

      if ( o.cursor && o.cursor !== "auto" ) { // cursor option
        body = this.document.find( "body" );

        // Support: IE
        this.storedCursor = body.css( "cursor" );
        body.css( "cursor", o.cursor );

        this.storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
      }

      if ( o.opacity ) { // opacity option
        if ( this.helper.css( "opacity" ) ) {
          this._storedOpacity = this.helper.css( "opacity" );
        }
        this.helper.css( "opacity", o.opacity );
      }

      if ( o.zIndex ) { // zIndex option
        if ( this.helper.css( "zIndex" ) ) {
          this._storedZIndex = this.helper.css( "zIndex" );
        }
        this.helper.css( "zIndex", o.zIndex );
      }

      // Prepare scrolling
      if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
        this.overflowOffset = this.scrollParent.offset();
      }

      // Call callbacks
      this._trigger( "start", event, this._uiHash() );

      // Recache the helper size
      if ( !this._preserveHelperProportions ) {
        this._cacheHelperProportions();
      }

      // Post "activate" events to possible containers
      if ( !noActivation ) {
        for ( i = this.containers.length - 1; i >= 0; i-- ) {
          this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
        }
      }

      // Prepare possible droppables
      if ( $.ui.ddmanager ) {
        $.ui.ddmanager.current = this;
      }

      if ( $.ui.ddmanager && !o.dropBehaviour ) {
        $.ui.ddmanager.prepareOffsets( this, event );
      }

      this.dragging = true;

      this._addClass( this.helper, "ui-sortable-helper" );

      // Execute the drag once - this causes the helper not to be visiblebefore getting its
      // correct position
      this._mouseDrag( event );
      return true;

    },

    _mouseDrag: function ( event ) {
      var i, item, itemElement, intersection,
        o = this.options,
        scrolled = false;

      // Compute the helpers position
      this.position = this._generatePosition( event );
      this.positionAbs = this._convertPositionTo( "absolute" );

      if ( !this.lastPositionAbs ) {
        this.lastPositionAbs = this.positionAbs;
      }

      // Do scrolling
      if ( this.options.scroll ) {
        if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {

          if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
						event.pageY < o.scrollSensitivity ) {
            this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
          } else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
            this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
          }

          if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
						event.pageX < o.scrollSensitivity ) {
            this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
          } else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
            this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
          }

        } else {

          if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
            scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
          } else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
						o.scrollSensitivity ) {
            scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
          }

          if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
            scrolled = this.document.scrollLeft(
              this.document.scrollLeft() - o.scrollSpeed
            );
          } else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
						o.scrollSensitivity ) {
            scrolled = this.document.scrollLeft(
              this.document.scrollLeft() + o.scrollSpeed
            );
          }

        }

        if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
          $.ui.ddmanager.prepareOffsets( this, event );
        }
      }

      // Regenerate the absolute position used for position checks
      this.positionAbs = this._convertPositionTo( "absolute" );

      // Set the helper position
      if ( !this.options.axis || this.options.axis !== "y" ) {
        this.helper[ 0 ].style.left = this.position.left + "px";
      }
      if ( !this.options.axis || this.options.axis !== "x" ) {
        this.helper[ 0 ].style.top = this.position.top + "px";
      }

      // Rearrange
      for ( i = this.items.length - 1; i >= 0; i-- ) {

        // Cache variables and intersection, continue if no intersection
        item = this.items[ i ];
        itemElement = item.item[ 0 ];
        intersection = this._intersectsWithPointer( item );
        if ( !intersection ) {
          continue;
        }

        // Only put the placeholder inside the current Container, skip all
        // items from other containers. This works because when moving
        // an item from one container to another the
        // currentContainer is switched before the placeholder is moved.
        //
        // Without this, moving items in "sub-sortables" can cause
        // the placeholder to jitter between the outer and inner container.
        if ( item.instance !== this.currentContainer ) {
          continue;
        }

        // Cannot intersect with itself
        // no useless actions that have been done before
        // no action if the item moved is the parent of the item checked
        if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
				  !$.contains( this.element[ 0 ], itemElement ) :
				  true
				)
        ) {

          this.direction = intersection === 1 ? "down" : "up";

          if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
            this._rearrange( event, item );
          } else {
            break;
          }

          this._trigger( "change", event, this._uiHash() );
          break;
        }
      }

      // Post events to containers
      this._contactContainers( event );

      // Interconnect with droppables
      if ( $.ui.ddmanager ) {
        $.ui.ddmanager.drag( this, event );
      }

      // Call callbacks
      this._trigger( "sort", event, this._uiHash() );

      this.lastPositionAbs = this.positionAbs;
      return false;

    },

    _mouseStop: function ( event, noPropagation ) {

      if ( !event ) {
        return;
      }

      // If we are using droppables, inform the manager about the drop
      if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
        $.ui.ddmanager.drop( this, event );
      }

      if ( this.options.revert ) {
        var that = this,
          cur = this.placeholder.offset(),
          axis = this.options.axis,
          animation = {};

        if ( !axis || axis === "x" ) {
          animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
					  0 :
					  this.offsetParent[ 0 ].scrollLeft
					);
        }
        if ( !axis || axis === "y" ) {
          animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
					  0 :
					  this.offsetParent[ 0 ].scrollTop
					);
        }
        this.reverting = true;
        $( this.helper ).animate(
          animation,
          parseInt( this.options.revert, 10 ) || 500,
          function () {
            that._clear( event );
          }
        );
      } else {
        this._clear( event, noPropagation );
      }

      return false;

    },

    cancel: function () {

      if ( this.dragging ) {

        this._mouseUp( new $.Event( "mouseup", { target: null } ) );

        if ( this.options.helper === "original" ) {
          this.currentItem.css( this._storedCSS );
          this._removeClass( this.currentItem, "ui-sortable-helper" );
        } else {
          this.currentItem.show();
        }

        // Post deactivating events to containers
        for ( var i = this.containers.length - 1; i >= 0; i-- ) {
          this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
          if ( this.containers[ i ].containerCache.over ) {
            this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
            this.containers[ i ].containerCache.over = 0;
          }
        }

      }

      if ( this.placeholder ) {

        // $(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
        // it unbinds ALL events from the original node!
        if ( this.placeholder[ 0 ].parentNode ) {
          this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
        }
        if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
          this.helper.remove();
        }

        $.extend( this, {
          helper: null,
          dragging: false,
          reverting: false,
          _noFinalSort: null
        } );

        if ( this.domPosition.prev ) {
          $( this.domPosition.prev ).after( this.currentItem );
        } else {
          $( this.domPosition.parent ).prepend( this.currentItem );
        }
      }

      return this;

    },

    serialize: function ( o ) {

      var items = this._getItemsAsjQuery( o && o.connected ),
        str = [];
      o = o || {};

      $( items ).each( function () {
        var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
          .match( o.expression || ( /(.+)[\-=_](.+)/ ) );
        if ( res ) {
          str.push(
            ( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
        }
      } );

      if ( !str.length && o.key ) {
        str.push( o.key + "=" );
      }

      return str.join( "&" );

    },

    toArray: function ( o ) {

      var items = this._getItemsAsjQuery( o && o.connected ),
        ret = [];

      o = o || {};

      items.each( function () {
        ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
      } );
      return ret;

    },

    /* Be careful with the following core functions */
    _intersectsWith: function ( item ) {

      var x1 = this.positionAbs.left,
        x2 = x1 + this.helperProportions.width,
        y1 = this.positionAbs.top,
        y2 = y1 + this.helperProportions.height,
        l = item.left,
        r = l + item.width,
        t = item.top,
        b = t + item.height,
        dyClick = this.offset.click.top,
        dxClick = this.offset.click.left,
        isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
        isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
        isOverElement = isOverElementHeight && isOverElementWidth;

      if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
      ) {
        return isOverElement;
      } else {

        return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

      }
    },

    _intersectsWithPointer: function ( item ) {
      var verticalDirection, horizontalDirection,
        isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
				  this.positionAbs.top + this.offset.click.top, item.top, item.height ),
        isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
				  this.positionAbs.left + this.offset.click.left, item.left, item.width ),
        isOverElement = isOverElementHeight && isOverElementWidth;

      if ( !isOverElement ) {
        return false;
      }

      verticalDirection = this._getDragVerticalDirection();
      horizontalDirection = this._getDragHorizontalDirection();

      return this.floating ?
        ( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
        : ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

    },

    _intersectsWithSides: function ( item ) {

      var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
        isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
        verticalDirection = this._getDragVerticalDirection(),
        horizontalDirection = this._getDragHorizontalDirection();

      if ( this.floating && horizontalDirection ) {
        return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
      } else {
        return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
      }

    },

    _getDragVerticalDirection: function () {
      var delta = this.positionAbs.top - this.lastPositionAbs.top;
      return delta !== 0 && ( delta > 0 ? "down" : "up" );
    },

    _getDragHorizontalDirection: function () {
      var delta = this.positionAbs.left - this.lastPositionAbs.left;
      return delta !== 0 && ( delta > 0 ? "right" : "left" );
    },

    refresh: function ( event ) {
      this._refreshItems( event );
      this._setHandleClassName();
      this.refreshPositions();
      return this;
    },

    _connectWith: function () {
      var options = this.options;
      return options.connectWith.constructor === String ?
        [ options.connectWith ] :
        options.connectWith;
    },

    _getItemsAsjQuery: function ( connected ) {

      var i, j, cur, inst,
        items = [],
        queries = [],
        connectWith = this._connectWith();

      if ( connectWith && connected ) {
        for ( i = connectWith.length - 1; i >= 0; i-- ) {
          cur = $( connectWith[ i ], this.document[ 0 ] );
          for ( j = cur.length - 1; j >= 0; j-- ) {
            inst = $.data( cur[ j ], this.widgetFullName );
            if ( inst && inst !== this && !inst.options.disabled ) {
              queries.push( [ $.isFunction( inst.options.items ) ?
                inst.options.items.call( inst.element ) :
                $( inst.options.items, inst.element )
                  .not( ".ui-sortable-helper" )
                  .not( ".ui-sortable-placeholder" ), inst ] );
            }
          }
        }
      }

      queries.push( [ $.isFunction( this.options.items ) ?
        this.options.items
          .call( this.element, null, { options: this.options, item: this.currentItem } ) :
        $( this.options.items, this.element )
          .not( ".ui-sortable-helper" )
          .not( ".ui-sortable-placeholder" ), this ] );

      function addItems() {
        items.push( this );
      }
      for ( i = queries.length - 1; i >= 0; i-- ) {
        queries[ i ][ 0 ].each( addItems );
      }

      return $( items );

    },

    _removeCurrentsFromItems: function () {

      var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

      this.items = $.grep( this.items, function ( item ) {
        for ( var j = 0; j < list.length; j++ ) {
          if ( list[ j ] === item.item[ 0 ] ) {
            return false;
          }
        }
        return true;
      } );

    },

    _refreshItems: function ( event ) {

      this.items = [];
      this.containers = [ this ];

      var i, j, cur, inst, targetData, _queries, item, queriesLength,
        items = this.items,
        queries = [ [ $.isFunction( this.options.items ) ?
          this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
          $( this.options.items, this.element ), this ] ],
        connectWith = this._connectWith();

      // Shouldn't be run the first time through due to massive slow-down
      if ( connectWith && this.ready ) {
        for ( i = connectWith.length - 1; i >= 0; i-- ) {
          cur = $( connectWith[ i ], this.document[ 0 ] );
          for ( j = cur.length - 1; j >= 0; j-- ) {
            inst = $.data( cur[ j ], this.widgetFullName );
            if ( inst && inst !== this && !inst.options.disabled ) {
              queries.push( [ $.isFunction( inst.options.items ) ?
                inst.options.items
                  .call( inst.element[ 0 ], event, { item: this.currentItem } ) :
                $( inst.options.items, inst.element ), inst ] );
              this.containers.push( inst );
            }
          }
        }
      }

      for ( i = queries.length - 1; i >= 0; i-- ) {
        targetData = queries[ i ][ 1 ];
        _queries = queries[ i ][ 0 ];

        for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
          item = $( _queries[ j ] );

          // Data for target checking (mouse manager)
          item.data( this.widgetName + "-item", targetData );

          items.push( {
            item: item,
            instance: targetData,
            width: 0, height: 0,
            left: 0, top: 0
          } );
        }
      }

    },

    refreshPositions: function ( fast ) {

      // Determine whether items are being displayed horizontally
      this.floating = this.items.length ?
        this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
        false;

      // This has to be redone because due to the item being moved out/into the offsetParent,
      // the offsetParent's position will change
      if ( this.offsetParent && this.helper ) {
        this.offset.parent = this._getParentOffset();
      }

      var i, item, t, p;

      for ( i = this.items.length - 1; i >= 0; i-- ) {
        item = this.items[ i ];

        // We ignore calculating positions of all connected containers when we're not over them
        if ( item.instance !== this.currentContainer && this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
          continue;
        }

        t = this.options.toleranceElement ?
          $( this.options.toleranceElement, item.item ) :
          item.item;

        if ( !fast ) {
          item.width = t.outerWidth();
          item.height = t.outerHeight();
        }

        p = t.offset();
        item.left = p.left;
        item.top = p.top;
      }

      if ( this.options.custom && this.options.custom.refreshContainers ) {
        this.options.custom.refreshContainers.call( this );
      } else {
        for ( i = this.containers.length - 1; i >= 0; i-- ) {
          p = this.containers[ i ].element.offset();
          this.containers[ i ].containerCache.left = p.left;
          this.containers[ i ].containerCache.top = p.top;
          this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
          this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
        }
      }

      return this;
    },

    _createPlaceholder: function ( that ) {
      that = that || this;
      var className,
        o = that.options;

      if ( !o.placeholder || o.placeholder.constructor === String ) {
        className = o.placeholder;
        o.placeholder = {
          element: function () {

            var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
              element = $( "<" + nodeName + ">", that.document[ 0 ] );

            that._addClass( element, "ui-sortable-placeholder",
              className || that.currentItem[ 0 ].className )
              ._removeClass( element, "ui-sortable-helper" );

            if ( nodeName === "tbody" ) {
              that._createTrPlaceholder(
                that.currentItem.find( "tr" ).eq( 0 ),
                $( "<tr>", that.document[ 0 ] ).appendTo( element )
              );
            } else if ( nodeName === "tr" ) {
              that._createTrPlaceholder( that.currentItem, element );
            } else if ( nodeName === "img" ) {
              element.attr( "src", that.currentItem.attr( "src" ) );
            }

            if ( !className ) {
              element.css( "visibility", "hidden" );
            }

            return element;
          },
          update: function ( container, p ) {

            // 1. If a className is set as 'placeholder option, we don't force sizes -
            // the class is responsible for that
            // 2. The option 'forcePlaceholderSize can be enabled to force it even if a
            // class name is specified
            if ( className && !o.forcePlaceholderSize ) {
              return;
            }

            // If the element doesn't have a actual height by itself (without styles coming
            // from a stylesheet), it receives the inline height from the dragged item
            if ( !p.height() ) {
              p.height(
                that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
            }
            if ( !p.width() ) {
              p.width(
                that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
            }
          }
        };
      }

      // Create the placeholder
      that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

      // Append it after the actual current item
      that.currentItem.after( that.placeholder );

      // Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
      o.placeholder.update( that, that.placeholder );

    },

    _createTrPlaceholder: function ( sourceTr, targetTr ) {
      var that = this;

      sourceTr.children().each( function () {
        $( "<td>&#160;</td>", that.document[ 0 ] )
          .attr( "colspan", $( this ).attr( "colspan" ) || 1 )
          .appendTo( targetTr );
      } );
    },

    _contactContainers: function ( event ) {
      var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
        floating, axis,
        innermostContainer = null,
        innermostIndex = null;

      // Get innermost container that intersects with item
      for ( i = this.containers.length - 1; i >= 0; i-- ) {

        // Never consider a container that's located within the item itself
        if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
          continue;
        }

        if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

          // If we've already found a container and it's more "inner" than this, then continue
          if ( innermostContainer &&
						$.contains(
						  this.containers[ i ].element[ 0 ],
						  innermostContainer.element[ 0 ] ) ) {
            continue;
          }

          innermostContainer = this.containers[ i ];
          innermostIndex = i;

        } else {

          // container doesn't intersect. trigger "out" event if necessary
          if ( this.containers[ i ].containerCache.over ) {
            this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
            this.containers[ i ].containerCache.over = 0;
          }
        }

      }

      // If no intersecting containers found, return
      if ( !innermostContainer ) {
        return;
      }

      // Move the item into the container if it's not there already
      if ( this.containers.length === 1 ) {
        if ( !this.containers[ innermostIndex ].containerCache.over ) {
          this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
          this.containers[ innermostIndex ].containerCache.over = 1;
        }
      } else {

        // When entering a new container, we will find the item with the least distance and
        // append our item near it
        dist = 10000;
        itemWithLeastDistance = null;
        floating = innermostContainer.floating || this._isFloating( this.currentItem );
        posProperty = floating ? "left" : "top";
        sizeProperty = floating ? "width" : "height";
        axis = floating ? "pageX" : "pageY";

        for ( j = this.items.length - 1; j >= 0; j-- ) {
          if ( !$.contains(
            this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
          ) {
            continue;
          }
          if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
            continue;
          }

          cur = this.items[ j ].item.offset()[ posProperty ];
          nearBottom = false;
          if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
            nearBottom = true;
          }

          if ( Math.abs( event[ axis ] - cur ) < dist ) {
            dist = Math.abs( event[ axis ] - cur );
            itemWithLeastDistance = this.items[ j ];
            this.direction = nearBottom ? "up" : "down";
          }
        }

        // Check if dropOnEmpty is enabled
        if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
          return;
        }

        if ( this.currentContainer === this.containers[ innermostIndex ] ) {
          if ( !this.currentContainer.containerCache.over ) {
            this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
            this.currentContainer.containerCache.over = 1;
          }
          return;
        }

        itemWithLeastDistance ?
          this._rearrange( event, itemWithLeastDistance, null, true ) :
          this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
        this._trigger( "change", event, this._uiHash() );
        this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
        this.currentContainer = this.containers[ innermostIndex ];

        // Update the placeholder
        this.options.placeholder.update( this.currentContainer, this.placeholder );

        this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
        this.containers[ innermostIndex ].containerCache.over = 1;
      }

    },

    _createHelper: function ( event ) {

      var o = this.options,
        helper = $.isFunction( o.helper ) ?
          $( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
          ( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

      // Add the helper to the DOM if that didn't happen already
      if ( !helper.parents( "body" ).length ) {
        $( o.appendTo !== "parent" ?
          o.appendTo :
          this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
      }

      if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
        this._storedCSS = {
          width: this.currentItem[ 0 ].style.width,
          height: this.currentItem[ 0 ].style.height,
          position: this.currentItem.css( "position" ),
          top: this.currentItem.css( "top" ),
          left: this.currentItem.css( "left" )
        };
      }

      if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
        helper.width( this.currentItem.width() );
      }
      if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
        helper.height( this.currentItem.height() );
      }

      return helper;

    },

    _adjustOffsetFromHelper: function ( obj ) {
      if ( typeof obj === "string" ) {
        obj = obj.split( " " );
      }
      if ( $.isArray( obj ) ) {
        obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
      }
      if ( "left" in obj ) {
        this.offset.click.left = obj.left + this.margins.left;
      }
      if ( "right" in obj ) {
        this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
      }
      if ( "top" in obj ) {
        this.offset.click.top = obj.top + this.margins.top;
      }
      if ( "bottom" in obj ) {
        this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
      }
    },

    _getParentOffset: function () {

      // Get the offsetParent and cache its position
      this.offsetParent = this.helper.offsetParent();
      var po = this.offsetParent.offset();

      // This is a special case where we need to modify a offset calculated on start, since the
      // following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the
      // next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
      // the document, which means that the scroll is included in the initial calculation of the
      // offset of the parent, and never recalculated upon drag
      if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
        po.left += this.scrollParent.scrollLeft();
        po.top += this.scrollParent.scrollTop();
      }

      // This needs to be actually done for all browsers, since pageX/pageY includes this
      // information with an ugly IE fix
      if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
				( this.offsetParent[ 0 ].tagName &&
				this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
        po = { top: 0, left: 0 };
      }

      return {
        top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
        left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
      };

    },

    _getRelativeOffset: function () {

      if ( this.cssPosition === "relative" ) {
        var p = this.currentItem.position();
        return {
          top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
          left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
        };
      } else {
        return { top: 0, left: 0 };
      }

    },

    _cacheMargins: function () {
      this.margins = {
        left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
        top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
      };
    },

    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight()
      };
    },

    _setContainment: function () {

      var ce, co, over,
        o = this.options;
      if ( o.containment === "parent" ) {
        o.containment = this.helper[ 0 ].parentNode;
      }
      if ( o.containment === "document" || o.containment === "window" ) {
        this.containment = [
          0 - this.offset.relative.left - this.offset.parent.left,
          0 - this.offset.relative.top - this.offset.parent.top,
          o.containment === "document" ?
            this.document.width() :
            this.window.width() - this.helperProportions.width - this.margins.left,
          ( o.containment === "document" ?
            ( this.document.height() || document.body.parentNode.scrollHeight ) :
            this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
          ) - this.helperProportions.height - this.margins.top
        ];
      }

      if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
        ce = $( o.containment )[ 0 ];
        co = $( o.containment ).offset();
        over = ( $( ce ).css( "overflow" ) !== "hidden" );

        this.containment = [
          co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
          co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
          co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
          co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
        ];
      }

    },

    _convertPositionTo: function ( d, pos ) {

      if ( !pos ) {
        pos = this.position;
      }
      var mod = d === "absolute" ? 1 : -1,
        scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
          this.offsetParent :
          this.scrollParent,
        scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

      return {
        top: (

        // The absolute mouse position
          pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
				  -this.scrollParent.scrollTop() :
				  ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
        ),
        left: (

        // The absolute mouse position
          pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
				  -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
				    scroll.scrollLeft() ) * mod )
        )
      };

    },

    _generatePosition: function ( event ) {

      var top, left,
        o = this.options,
        pageX = event.pageX,
        pageY = event.pageY,
        scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
          this.offsetParent :
          this.scrollParent,
        scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

      // This is another very weird special case that only happens for relative elements:
      // 1. If the css position is relative
      // 2. and the scroll parent is the document or similar to the offset parent
      // we have to refresh the relative offset during the scroll so there are no jumps
      if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
        this.offset.relative = this._getRelativeOffset();
      }

      /*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

      if ( this.originalPosition ) { // If we are not dragging yet, we won't check for options

        if ( this.containment ) {
          if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
            pageX = this.containment[ 0 ] + this.offset.click.left;
          }
          if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
            pageY = this.containment[ 1 ] + this.offset.click.top;
          }
          if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
            pageX = this.containment[ 2 ] + this.offset.click.left;
          }
          if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
            pageY = this.containment[ 3 ] + this.offset.click.top;
          }
        }

        if ( o.grid ) {
          top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
          pageY = this.containment ?
            ( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
              top :
              ( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
                top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
            top;

          left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
          pageX = this.containment ?
            ( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
              left :
              ( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
                left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
            left;
        }

      }

      return {
        top: (

        // The absolute mouse position
          pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
				  -this.scrollParent.scrollTop() :
				  ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
        ),
        left: (

        // The absolute mouse position
          pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
				  -this.scrollParent.scrollLeft() :
				  scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
        )
      };

    },

    _rearrange: function ( event, i, a, hardRefresh ) {

      a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
        i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
          ( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );

      // Various things done here to improve the performance:
      // 1. we create a setTimeout, that calls refreshPositions
      // 2. on the instance, we have a counter variable, that get's higher after every append
      // 3. on the local scope, we copy the counter variable, and check in the timeout,
      // if it's still the same
      // 4. this lets only the last addition to the timeout stack through
      this.counter = this.counter ? ++this.counter : 1;
      var counter = this.counter;

      this._delay( function () {
        if ( counter === this.counter ) {

          // Precompute after each DOM insertion, NOT on mousemove
          this.refreshPositions( !hardRefresh );
        }
      } );

    },

    _clear: function ( event, noPropagation ) {

      this.reverting = false;

      // We delay all events that have to be triggered to after the point where the placeholder
      // has been removed and everything else normalized again
      var i,
        delayedTriggers = [];

      // We first have to update the dom position of the actual currentItem
      // Note: don't do it if the current item is already removed (by a user), or it gets
      // reappended (see #4088)
      if ( !this._noFinalSort && this.currentItem.parent().length ) {
        this.placeholder.before( this.currentItem );
      }
      this._noFinalSort = null;

      if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
        for ( i in this._storedCSS ) {
          if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
            this._storedCSS[ i ] = "";
          }
        }
        this.currentItem.css( this._storedCSS );
        this._removeClass( this.currentItem, "ui-sortable-helper" );
      } else {
        this.currentItem.show();
      }

      if ( this.fromOutside && !noPropagation ) {
        delayedTriggers.push( function ( event ) {
          this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
        } );
      }
      if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

        // Trigger update callback if the DOM position has changed
        delayedTriggers.push( function ( event ) {
          this._trigger( "update", event, this._uiHash() );
        } );
      }

      // Check if the items Container has Changed and trigger appropriate
      // events.
      if ( this !== this.currentContainer ) {
        if ( !noPropagation ) {
          delayedTriggers.push( function ( event ) {
            this._trigger( "remove", event, this._uiHash() );
          } );
          delayedTriggers.push( ( function ( c ) {
            return function ( event ) {
              c._trigger( "receive", event, this._uiHash( this ) );
            };
          } ).call( this, this.currentContainer ) );
          delayedTriggers.push( ( function ( c ) {
            return function ( event ) {
              c._trigger( "update", event, this._uiHash( this ) );
            };
          } ).call( this, this.currentContainer ) );
        }
      }

      // Post events to containers
      function delayEvent( type, instance, container ) {
        return function ( event ) {
          container._trigger( type, event, instance._uiHash( instance ) );
        };
      }
      for ( i = this.containers.length - 1; i >= 0; i-- ) {
        if ( !noPropagation ) {
          delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
        }
        if ( this.containers[ i ].containerCache.over ) {
          delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
          this.containers[ i ].containerCache.over = 0;
        }
      }

      // Do what was originally in plugins
      if ( this.storedCursor ) {
        this.document.find( "body" ).css( "cursor", this.storedCursor );
        this.storedStylesheet.remove();
      }
      if ( this._storedOpacity ) {
        this.helper.css( "opacity", this._storedOpacity );
      }
      if ( this._storedZIndex ) {
        this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
      }

      this.dragging = false;

      if ( !noPropagation ) {
        this._trigger( "beforeStop", event, this._uiHash() );
      }

      // $(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
      // it unbinds ALL events from the original node!
      this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

      if ( !this.cancelHelperRemoval ) {
        if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
          this.helper.remove();
        }
        this.helper = null;
      }

      if ( !noPropagation ) {
        for ( i = 0; i < delayedTriggers.length; i++ ) {

          // Trigger all delayed events
          delayedTriggers[ i ].call( this, event );
        }
        this._trigger( "stop", event, this._uiHash() );
      }

      this.fromOutside = false;
      return !this.cancelHelperRemoval;

    },

    _trigger: function () {
      if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
        this.cancel();
      }
    },

    _uiHash: function ( _inst ) {
      var inst = _inst || this;
      return {
        helper: inst.helper,
        placeholder: inst.placeholder || $( [] ),
        position: inst.position,
        originalPosition: inst.originalPosition,
        offset: inst.positionAbs,
        item: inst.currentItem,
        sender: _inst ? _inst.element : null
      };
    }

  } );

  /* !
 * jQuery UI Spinner 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Spinner
  // >>group: Widgets
  // >>description: Displays buttons to easily input numbers via the keyboard or mouse.
  // >>docs: http://api.jqueryui.com/spinner/
  // >>demos: http://jqueryui.com/spinner/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/spinner.css
  // >>css.theme: ../../themes/base/theme.css

  function spinnerModifer( fn ) {
    return function () {
      var previous = this.element.val();
      fn.apply( this, arguments );
      this._refresh();
      if ( previous !== this.element.val() ) {
        this._trigger( "change" );
      }
    };
  }

  $.widget( "ui.spinner", {
    version: "1.12.1",
    defaultElement: "<input>",
    widgetEventPrefix: "spin",
    options: {
      classes: {
        "ui-spinner": "ui-corner-all",
        "ui-spinner-down": "ui-corner-br",
        "ui-spinner-up": "ui-corner-tr"
      },
      culture: null,
      icons: {
        down: "ui-icon-triangle-1-s",
        up: "ui-icon-triangle-1-n"
      },
      incremental: true,
      max: null,
      min: null,
      numberFormat: null,
      page: 10,
      step: 1,

      change: null,
      spin: null,
      start: null,
      stop: null
    },

    _create: function () {

      // handle string values that need to be parsed
      this._setOption( "max", this.options.max );
      this._setOption( "min", this.options.min );
      this._setOption( "step", this.options.step );

      // Only format if there is a value, prevents the field from being marked
      // as invalid in Firefox, see #9573.
      if ( this.value() !== "" ) {

        // Format the value, but don't constrain.
        this._value( this.element.val(), true );
      }

      this._draw();
      this._on( this._events );
      this._refresh();

      // Turning off autocomplete prevents the browser from remembering the
      // value when navigating through history, so we re-enable autocomplete
      // if the page is unloaded before the widget is destroyed. #7790
      this._on( this.window, {
        beforeunload: function () {
          this.element.removeAttr( "autocomplete" );
        }
      } );
    },

    _getCreateOptions: function () {
      var options = this._super();
      var element = this.element;

      $.each( [ "min", "max", "step" ], function ( i, option ) {
        var value = element.attr( option );
        if ( value != null && value.length ) {
          options[ option ] = value;
        }
      } );

      return options;
    },

    _events: {
      keydown: function ( event ) {
        if ( this._start( event ) && this._keydown( event ) ) {
          event.preventDefault();
        }
      },
      keyup: "_stop",
      focus: function () {
        this.previous = this.element.val();
      },
      blur: function ( event ) {
        if ( this.cancelBlur ) {
          delete this.cancelBlur;
          return;
        }

        this._stop();
        this._refresh();
        if ( this.previous !== this.element.val() ) {
          this._trigger( "change", event );
        }
      },
      mousewheel: function ( event, delta ) {
        if ( !delta ) {
          return;
        }
        if ( !this.spinning && !this._start( event ) ) {
          return false;
        }

        this._spin( ( delta > 0 ? 1 : -1 ) * this.options.step, event );
        clearTimeout( this.mousewheelTimer );
        this.mousewheelTimer = this._delay( function () {
          if ( this.spinning ) {
            this._stop( event );
          }
        }, 100 );
        event.preventDefault();
      },
      "mousedown .ui-spinner-button": function ( event ) {
        var previous;

        // We never want the buttons to have focus; whenever the user is
        // interacting with the spinner, the focus should be on the input.
        // If the input is focused then this.previous is properly set from
        // when the input first received focus. If the input is not focused
        // then we need to set this.previous based on the value before spinning.
        previous = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] ) ?
          this.previous : this.element.val();
        function checkFocus() {
          var isActive = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] );
          if ( !isActive ) {
            this.element.trigger( "focus" );
            this.previous = previous;

            // support: IE
            // IE sets focus asynchronously, so we need to check if focus
            // moved off of the input because the user clicked on the button.
            this._delay( function () {
              this.previous = previous;
            } );
          }
        }

        // Ensure focus is on (or stays on) the text field
        event.preventDefault();
        checkFocus.call( this );

        // Support: IE
        // IE doesn't prevent moving focus even with event.preventDefault()
        // so we set a flag to know when we should ignore the blur event
        // and check (again) if focus moved off of the input.
        this.cancelBlur = true;
        this._delay( function () {
          delete this.cancelBlur;
          checkFocus.call( this );
        } );

        if ( this._start( event ) === false ) {
          return;
        }

        this._repeat( null, $( event.currentTarget )
          .hasClass( "ui-spinner-up" ) ? 1 : -1, event );
      },
      "mouseup .ui-spinner-button": "_stop",
      "mouseenter .ui-spinner-button": function ( event ) {

        // button will add ui-state-active if mouse was down while mouseleave and kept down
        if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
          return;
        }

        if ( this._start( event ) === false ) {
          return false;
        }
        this._repeat( null, $( event.currentTarget )
          .hasClass( "ui-spinner-up" ) ? 1 : -1, event );
      },

      // TODO: do we really want to consider this a stop?
      // shouldn't we just stop the repeater and wait until mouseup before
      // we trigger the stop event?
      "mouseleave .ui-spinner-button": "_stop"
    },

    // Support mobile enhanced option and make backcompat more sane
    _enhance: function () {
      this.uiSpinner = this.element
        .attr( "autocomplete", "off" )
        .wrap( "<span>" )
        .parent()

      // Add buttons
        .append(
          "<a></a><a></a>"
        );
    },

    _draw: function () {
      this._enhance();

      this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
      this._addClass( "ui-spinner-input" );

      this.element.attr( "role", "spinbutton" );

      // Button bindings
      this.buttons = this.uiSpinner.children( "a" )
        .attr( "tabIndex", -1 )
        .attr( "aria-hidden", true )
        .button( {
          classes: {
            "ui-button": ""
          }
        } );

      // TODO: Right now button does not support classes this is already updated in button PR
      this._removeClass( this.buttons, "ui-corner-all" );

      this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
      this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
      this.buttons.first().button( {
        "icon": this.options.icons.up,
        "showLabel": false
      } );
      this.buttons.last().button( {
        "icon": this.options.icons.down,
        "showLabel": false
      } );

      // IE 6 doesn't understand height: 50% for the buttons
      // unless the wrapper has an explicit height
      if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
				this.uiSpinner.height() > 0 ) {
        this.uiSpinner.height( this.uiSpinner.height() );
      }
    },

    _keydown: function ( event ) {
      var options = this.options,
        keyCode = $.ui.keyCode;

      switch ( event.keyCode ) {
        case keyCode.UP:
          this._repeat( null, 1, event );
          return true;
        case keyCode.DOWN:
          this._repeat( null, -1, event );
          return true;
        case keyCode.PAGE_UP:
          this._repeat( null, options.page, event );
          return true;
        case keyCode.PAGE_DOWN:
          this._repeat( null, -options.page, event );
          return true;
      }

      return false;
    },

    _start: function ( event ) {
      if ( !this.spinning && this._trigger( "start", event ) === false ) {
        return false;
      }

      if ( !this.counter ) {
        this.counter = 1;
      }
      this.spinning = true;
      return true;
    },

    _repeat: function ( i, steps, event ) {
      i = i || 500;

      clearTimeout( this.timer );
      this.timer = this._delay( function () {
        this._repeat( 40, steps, event );
      }, i );

      this._spin( steps * this.options.step, event );
    },

    _spin: function ( step, event ) {
      var value = this.value() || 0;

      if ( !this.counter ) {
        this.counter = 1;
      }

      value = this._adjustValue( value + step * this._increment( this.counter ) );

      if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
        this._value( value );
        this.counter++;
      }
    },

    _increment: function ( i ) {
      var incremental = this.options.incremental;

      if ( incremental ) {
        return $.isFunction( incremental ) ?
          incremental( i ) :
          Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
      }

      return 1;
    },

    _precision: function () {
      var precision = this._precisionOf( this.options.step );
      if ( this.options.min !== null ) {
        precision = Math.max( precision, this._precisionOf( this.options.min ) );
      }
      return precision;
    },

    _precisionOf: function ( num ) {
      var str = num.toString(),
        decimal = str.indexOf( "." );
      return decimal === -1 ? 0 : str.length - decimal - 1;
    },

    _adjustValue: function ( value ) {
      var base, aboveMin,
        options = this.options;

      // Make sure we're at a valid step
      // - find out where we are relative to the base (min or 0)
      base = options.min !== null ? options.min : 0;
      aboveMin = value - base;

      // - round to the nearest step
      aboveMin = Math.round( aboveMin / options.step ) * options.step;

      // - rounding is based on 0, so adjust back to our base
      value = base + aboveMin;

      // Fix precision from bad JS floating point math
      value = parseFloat( value.toFixed( this._precision() ) );

      // Clamp the value
      if ( options.max !== null && value > options.max ) {
        return options.max;
      }
      if ( options.min !== null && value < options.min ) {
        return options.min;
      }

      return value;
    },

    _stop: function ( event ) {
      if ( !this.spinning ) {
        return;
      }

      clearTimeout( this.timer );
      clearTimeout( this.mousewheelTimer );
      this.counter = 0;
      this.spinning = false;
      this._trigger( "stop", event );
    },

    _setOption: function ( key, value ) {
      var prevValue, first, last;

      if ( key === "culture" || key === "numberFormat" ) {
        prevValue = this._parse( this.element.val() );
        this.options[ key ] = value;
        this.element.val( this._format( prevValue ) );
        return;
      }

      if ( key === "max" || key === "min" || key === "step" ) {
        if ( typeof value === "string" ) {
          value = this._parse( value );
        }
      }
      if ( key === "icons" ) {
        first = this.buttons.first().find( ".ui-icon" );
        this._removeClass( first, null, this.options.icons.up );
        this._addClass( first, null, value.up );
        last = this.buttons.last().find( ".ui-icon" );
        this._removeClass( last, null, this.options.icons.down );
        this._addClass( last, null, value.down );
      }

      this._super( key, value );
    },

    _setOptionDisabled: function ( value ) {
      this._super( value );

      this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
      this.element.prop( "disabled", !!value );
      this.buttons.button( value ? "disable" : "enable" );
    },

    _setOptions: spinnerModifer( function ( options ) {
      this._super( options );
    } ),

    _parse: function ( val ) {
      if ( typeof val === "string" && val !== "" ) {
        val = window.Globalize && this.options.numberFormat ?
          Globalize.parseFloat( val, 10, this.options.culture ) : +val;
      }
      return val === "" || isNaN( val ) ? null : val;
    },

    _format: function ( value ) {
      if ( value === "" ) {
        return "";
      }
      return window.Globalize && this.options.numberFormat ?
        Globalize.format( value, this.options.numberFormat, this.options.culture ) :
        value;
    },

    _refresh: function () {
      this.element.attr( {
        "aria-valuemin": this.options.min,
        "aria-valuemax": this.options.max,

        // TODO: what should we do with values that can't be parsed?
        "aria-valuenow": this._parse( this.element.val() )
      } );
    },

    isValid: function () {
      var value = this.value();

      // Null is invalid
      if ( value === null ) {
        return false;
      }

      // If value gets adjusted, it's invalid
      return value === this._adjustValue( value );
    },

    // Update the value without triggering change
    _value: function ( value, allowAny ) {
      var parsed;
      if ( value !== "" ) {
        parsed = this._parse( value );
        if ( parsed !== null ) {
          if ( !allowAny ) {
            parsed = this._adjustValue( parsed );
          }
          value = this._format( parsed );
        }
      }
      this.element.val( value );
      this._refresh();
    },

    _destroy: function () {
      this.element
        .prop( "disabled", false )
        .removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );

      this.uiSpinner.replaceWith( this.element );
    },

    stepUp: spinnerModifer( function ( steps ) {
      this._stepUp( steps );
    } ),
    _stepUp: function ( steps ) {
      if ( this._start() ) {
        this._spin( ( steps || 1 ) * this.options.step );
        this._stop();
      }
    },

    stepDown: spinnerModifer( function ( steps ) {
      this._stepDown( steps );
    } ),
    _stepDown: function ( steps ) {
      if ( this._start() ) {
        this._spin( ( steps || 1 ) * -this.options.step );
        this._stop();
      }
    },

    pageUp: spinnerModifer( function ( pages ) {
      this._stepUp( ( pages || 1 ) * this.options.page );
    } ),

    pageDown: spinnerModifer( function ( pages ) {
      this._stepDown( ( pages || 1 ) * this.options.page );
    } ),

    value: function ( newVal ) {
      if ( !arguments.length ) {
        return this._parse( this.element.val() );
      }
      spinnerModifer( this._value ).call( this, newVal );
    },

    widget: function () {
      return this.uiSpinner;
    }
  } );

  // DEPRECATED
  // TODO: switch return back to widget declaration at top of file when this is removed
  if ( $.uiBackCompat !== false ) {

    // Backcompat for spinner html extension points
    $.widget( "ui.spinner", $.ui.spinner, {
      _enhance: function () {
        this.uiSpinner = this.element
          .attr( "autocomplete", "off" )
          .wrap( this._uiSpinnerHtml() )
          .parent()

        // Add buttons
          .append( this._buttonHtml() );
      },
      _uiSpinnerHtml: function () {
        return "<span>";
      },

      _buttonHtml: function () {
        return "<a></a><a></a>";
      }
    } );
  }

  var widgetsSpinner = $.ui.spinner;

  /* !
 * jQuery UI Tabs 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Tabs
  // >>group: Widgets
  // >>description: Transforms a set of container elements into a tab structure.
  // >>docs: http://api.jqueryui.com/tabs/
  // >>demos: http://jqueryui.com/tabs/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/tabs.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.tabs", {
    version: "1.12.1",
    delay: 300,
    options: {
      active: null,
      classes: {
        "ui-tabs": "ui-corner-all",
        "ui-tabs-nav": "ui-corner-all",
        "ui-tabs-panel": "ui-corner-bottom",
        "ui-tabs-tab": "ui-corner-top"
      },
      collapsible: false,
      event: "click",
      heightStyle: "content",
      hide: null,
      show: null,

      // Callbacks
      activate: null,
      beforeActivate: null,
      beforeLoad: null,
      load: null
    },

    _isLocal: ( function () {
      var rhash = /#.*$/;

      return function ( anchor ) {
        var anchorUrl, locationUrl;

        anchorUrl = anchor.href.replace( rhash, "" );
        locationUrl = location.href.replace( rhash, "" );

        // Decoding may throw an error if the URL isn't UTF-8 (#9518)
        try {
          anchorUrl = decodeURIComponent( anchorUrl );
        } catch ( error ) {}
        try {
          locationUrl = decodeURIComponent( locationUrl );
        } catch ( error ) {}

        return anchor.hash.length > 1 && anchorUrl === locationUrl;
      };
    } )(),

    _create: function () {
      var that = this,
        options = this.options;

      this.running = false;

      this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
      this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

      this._processTabs();
      options.active = this._initialActive();

      // Take disabling tabs via class attribute from HTML
      // into account and update option properly.
      if ( $.isArray( options.disabled ) ) {
        options.disabled = $.unique( options.disabled.concat(
          $.map( this.tabs.filter( ".ui-state-disabled" ), function ( li ) {
            return that.tabs.index( li );
          } )
        ) ).sort();
      }

      // Check for length avoids error when initializing empty list
      if ( this.options.active !== false && this.anchors.length ) {
        this.active = this._findActive( options.active );
      } else {
        this.active = $();
      }

      this._refresh();

      if ( this.active.length ) {
        this.load( options.active );
      }
    },

    _initialActive: function () {
      var active = this.options.active,
        collapsible = this.options.collapsible,
        locationHash = location.hash.substring( 1 );

      if ( active === null ) {

        // check the fragment identifier in the URL
        if ( locationHash ) {
          this.tabs.each( function ( i, tab ) {
            if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
              active = i;
              return false;
            }
          } );
        }

        // Check for a tab marked active via a class
        if ( active === null ) {
          active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
        }

        // No active tab, set to false
        if ( active === null || active === -1 ) {
          active = this.tabs.length ? 0 : false;
        }
      }

      // Handle numbers: negative, out of range
      if ( active !== false ) {
        active = this.tabs.index( this.tabs.eq( active ) );
        if ( active === -1 ) {
          active = collapsible ? false : 0;
        }
      }

      // Don't allow collapsible: false and active: false
      if ( !collapsible && active === false && this.anchors.length ) {
        active = 0;
      }

      return active;
    },

    _getCreateEventData: function () {
      return {
        tab: this.active,
        panel: !this.active.length ? $() : this._getPanelForTab( this.active )
      };
    },

    _tabKeydown: function ( event ) {
      var focusedTab = $( $.ui.safeActiveElement( this.document[ 0 ] ) ).closest( "li" ),
        selectedIndex = this.tabs.index( focusedTab ),
        goingForward = true;

      if ( this._handlePageNav( event ) ) {
        return;
      }

      switch ( event.keyCode ) {
        case $.ui.keyCode.RIGHT:
        case $.ui.keyCode.DOWN:
          selectedIndex++;
          break;
        case $.ui.keyCode.UP:
        case $.ui.keyCode.LEFT:
          goingForward = false;
          selectedIndex--;
          break;
        case $.ui.keyCode.END:
          selectedIndex = this.anchors.length - 1;
          break;
        case $.ui.keyCode.HOME:
          selectedIndex = 0;
          break;
        case $.ui.keyCode.SPACE:

          // Activate only, no collapsing
          event.preventDefault();
          clearTimeout( this.activating );
          this._activate( selectedIndex );
          return;
        case $.ui.keyCode.ENTER:

          // Toggle (cancel delayed activation, allow collapsing)
          event.preventDefault();
          clearTimeout( this.activating );

          // Determine if we should collapse or activate
          this._activate( selectedIndex === this.options.active ? false : selectedIndex );
          return;
        default:
          return;
      }

      // Focus the appropriate tab, based on which key was pressed
      event.preventDefault();
      clearTimeout( this.activating );
      selectedIndex = this._focusNextTab( selectedIndex, goingForward );

      // Navigating with control/command key will prevent automatic activation
      if ( !event.ctrlKey && !event.metaKey ) {

        // Update aria-selected immediately so that AT think the tab is already selected.
        // Otherwise AT may confuse the user by stating that they need to activate the tab,
        // but the tab will already be activated by the time the announcement finishes.
        focusedTab.attr( "aria-selected", "false" );
        this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

        this.activating = this._delay( function () {
          this.option( "active", selectedIndex );
        }, this.delay );
      }
    },

    _panelKeydown: function ( event ) {
      if ( this._handlePageNav( event ) ) {
        return;
      }

      // Ctrl+up moves focus to the current tab
      if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
        event.preventDefault();
        this.active.trigger( "focus" );
      }
    },

    // Alt+page up/down moves focus to the previous/next tab (and activates)
    _handlePageNav: function ( event ) {
      if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
        this._activate( this._focusNextTab( this.options.active - 1, false ) );
        return true;
      }
      if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
        this._activate( this._focusNextTab( this.options.active + 1, true ) );
        return true;
      }
    },

    _findNextTab: function ( index, goingForward ) {
      var lastTabIndex = this.tabs.length - 1;

      function constrain() {
        if ( index > lastTabIndex ) {
          index = 0;
        }
        if ( index < 0 ) {
          index = lastTabIndex;
        }
        return index;
      }

      while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
        index = goingForward ? index + 1 : index - 1;
      }

      return index;
    },

    _focusNextTab: function ( index, goingForward ) {
      index = this._findNextTab( index, goingForward );
      this.tabs.eq( index ).trigger( "focus" );
      return index;
    },

    _setOption: function ( key, value ) {
      if ( key === "active" ) {

        // _activate() will handle invalid values and update this.options
        this._activate( value );
        return;
      }

      this._super( key, value );

      if ( key === "collapsible" ) {
        this._toggleClass( "ui-tabs-collapsible", null, value );

        // Setting collapsible: false while collapsed; open first panel
        if ( !value && this.options.active === false ) {
          this._activate( 0 );
        }
      }

      if ( key === "event" ) {
        this._setupEvents( value );
      }

      if ( key === "heightStyle" ) {
        this._setupHeightStyle( value );
      }
    },

    _sanitizeSelector: function ( hash ) {
      return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
    },

    refresh: function () {
      var options = this.options,
        lis = this.tablist.children( ":has(a[href])" );

      // Get disabled tabs from class attribute from HTML
      // this will get converted to a boolean if needed in _refresh()
      options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function ( tab ) {
        return lis.index( tab );
      } );

      this._processTabs();

      // Was collapsed or no tabs
      if ( options.active === false || !this.anchors.length ) {
        options.active = false;
        this.active = $();

        // was active, but active tab is gone
      } else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

        // all remaining tabs are disabled
        if ( this.tabs.length === options.disabled.length ) {
          options.active = false;
          this.active = $();

          // activate previous tab
        } else {
          this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
        }

        // was active, active tab still exists
      } else {

        // make sure active index is correct
        options.active = this.tabs.index( this.active );
      }

      this._refresh();
    },

    _refresh: function () {
      this._setOptionDisabled( this.options.disabled );
      this._setupEvents( this.options.event );
      this._setupHeightStyle( this.options.heightStyle );

      this.tabs.not( this.active ).attr( {
        "aria-selected": "false",
        "aria-expanded": "false",
        tabIndex: -1
      } );
      this.panels.not( this._getPanelForTab( this.active ) )
        .hide()
        .attr( {
          "aria-hidden": "true"
        } );

      // Make sure one tab is in the tab order
      if ( !this.active.length ) {
        this.tabs.eq( 0 ).attr( "tabIndex", 0 );
      } else {
        this.active
          .attr( {
            "aria-selected": "true",
            "aria-expanded": "true",
            tabIndex: 0
          } );
        this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
        this._getPanelForTab( this.active )
          .show()
          .attr( {
            "aria-hidden": "false"
          } );
      }
    },

    _processTabs: function () {
      var that = this,
        prevTabs = this.tabs,
        prevAnchors = this.anchors,
        prevPanels = this.panels;

      this.tablist = this._getList().attr( "role", "tablist" );
      this._addClass( this.tablist, "ui-tabs-nav",
        "ui-helper-reset ui-helper-clearfix ui-widget-header" );

      // Prevent users from focusing disabled tabs via click
      this.tablist
        .on( "mousedown" + this.eventNamespace, "> li", function ( event ) {
          if ( $( this ).is( ".ui-state-disabled" ) ) {
            event.preventDefault();
          }
        } )

      // Support: IE <9
      // Preventing the default action in mousedown doesn't prevent IE
      // from focusing the element, so if the anchor gets focused, blur.
      // We don't have to worry about focusing the previously focused
      // element since clicking on a non-focusable element should focus
      // the body anyway.
        .on( "focus" + this.eventNamespace, ".ui-tabs-anchor", function () {
          if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
            this.blur();
          }
        } );

      this.tabs = this.tablist.find( "> li:has(a[href])" )
        .attr( {
          role: "tab",
          tabIndex: -1
        } );
      this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

      this.anchors = this.tabs.map( function () {
        return $( "a", this )[ 0 ];
      } )
        .attr( {
          role: "presentation",
          tabIndex: -1
        } );
      this._addClass( this.anchors, "ui-tabs-anchor" );

      this.panels = $();

      this.anchors.each( function ( i, anchor ) {
        var selector, panel, panelId,
          anchorId = $( anchor ).uniqueId().attr( "id" ),
          tab = $( anchor ).closest( "li" ),
          originalAriaControls = tab.attr( "aria-controls" );

        // Inline tab
        if ( that._isLocal( anchor ) ) {
          selector = anchor.hash;
          panelId = selector.substring( 1 );
          panel = that.element.find( that._sanitizeSelector( selector ) );

          // remote tab
        } else {

          // If the tab doesn't already have aria-controls,
          // generate an id by using a throw-away element
          panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
          selector = "#" + panelId;
          panel = that.element.find( selector );
          if ( !panel.length ) {
            panel = that._createPanel( panelId );
            panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
          }
          panel.attr( "aria-live", "polite" );
        }

        if ( panel.length ) {
          that.panels = that.panels.add( panel );
        }
        if ( originalAriaControls ) {
          tab.data( "ui-tabs-aria-controls", originalAriaControls );
        }
        tab.attr( {
          "aria-controls": panelId,
          "aria-labelledby": anchorId
        } );
        panel.attr( "aria-labelledby", anchorId );
      } );

      this.panels.attr( "role", "tabpanel" );
      this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

      // Avoid memory leaks (#10056)
      if ( prevTabs ) {
        this._off( prevTabs.not( this.tabs ) );
        this._off( prevAnchors.not( this.anchors ) );
        this._off( prevPanels.not( this.panels ) );
      }
    },

    // Allow overriding how to find the list for rare usage scenarios (#7715)
    _getList: function () {
      return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
    },

    _createPanel: function ( id ) {
      return $( "<div>" )
        .attr( "id", id )
        .data( "ui-tabs-destroy", true );
    },

    _setOptionDisabled: function ( disabled ) {
      var currentItem, li, i;

      if ( $.isArray( disabled ) ) {
        if ( !disabled.length ) {
          disabled = false;
        } else if ( disabled.length === this.anchors.length ) {
          disabled = true;
        }
      }

      // Disable tabs
      for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
        currentItem = $( li );
        if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
          currentItem.attr( "aria-disabled", "true" );
          this._addClass( currentItem, null, "ui-state-disabled" );
        } else {
          currentItem.removeAttr( "aria-disabled" );
          this._removeClass( currentItem, null, "ui-state-disabled" );
        }
      }

      this.options.disabled = disabled;

      this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
        disabled === true );
    },

    _setupEvents: function ( event ) {
      var events = {};
      if ( event ) {
        $.each( event.split( " " ), function ( index, eventName ) {
          events[ eventName ] = "_eventHandler";
        } );
      }

      this._off( this.anchors.add( this.tabs ).add( this.panels ) );

      // Always prevent the default action, even when disabled
      this._on( true, this.anchors, {
        click: function ( event ) {
          event.preventDefault();
        }
      } );
      this._on( this.anchors, events );
      this._on( this.tabs, { keydown: "_tabKeydown" } );
      this._on( this.panels, { keydown: "_panelKeydown" } );

      this._focusable( this.tabs );
      this._hoverable( this.tabs );
    },

    _setupHeightStyle: function ( heightStyle ) {
      var maxHeight,
        parent = this.element.parent();

      if ( heightStyle === "fill" ) {
        maxHeight = parent.height();
        maxHeight -= this.element.outerHeight() - this.element.height();

        this.element.siblings( ":visible" ).each( function () {
          var elem = $( this ),
            position = elem.css( "position" );

          if ( position === "absolute" || position === "fixed" ) {
            return;
          }
          maxHeight -= elem.outerHeight( true );
        } );

        this.element.children().not( this.panels ).each( function () {
          maxHeight -= $( this ).outerHeight( true );
        } );

        this.panels.each( function () {
          $( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
        } )
          .css( "overflow", "auto" );
      } else if ( heightStyle === "auto" ) {
        maxHeight = 0;
        this.panels.each( function () {
          maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
        } ).height( maxHeight );
      }
    },

    _eventHandler: function ( event ) {
      var options = this.options,
        active = this.active,
        anchor = $( event.currentTarget ),
        tab = anchor.closest( "li" ),
        clickedIsActive = tab[ 0 ] === active[ 0 ],
        collapsing = clickedIsActive && options.collapsible,
        toShow = collapsing ? $() : this._getPanelForTab( tab ),
        toHide = !active.length ? $() : this._getPanelForTab( active ),
        eventData = {
          oldTab: active,
          oldPanel: toHide,
          newTab: collapsing ? $() : tab,
          newPanel: toShow
        };

      event.preventDefault();

      if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
        return;
      }

      options.active = collapsing ? false : this.tabs.index( tab );

      this.active = clickedIsActive ? $() : tab;
      if ( this.xhr ) {
        this.xhr.abort();
      }

      if ( !toHide.length && !toShow.length ) {
        $.error( "jQuery UI Tabs: Mismatching fragment identifier." );
      }

      if ( toShow.length ) {
        this.load( this.tabs.index( tab ), event );
      }
      this._toggle( event, eventData );
    },

    // Handles show/hide for selecting tabs
    _toggle: function ( event, eventData ) {
      var that = this,
        toShow = eventData.newPanel,
        toHide = eventData.oldPanel;

      this.running = true;

      function complete() {
        that.running = false;
        that._trigger( "activate", event, eventData );
      }

      function show() {
        that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

        if ( toShow.length && that.options.show ) {
          that._show( toShow, that.options.show, complete );
        } else {
          toShow.show();
          complete();
        }
      }

      // Start out by hiding, then showing, then completing
      if ( toHide.length && this.options.hide ) {
        this._hide( toHide, this.options.hide, function () {
          that._removeClass( eventData.oldTab.closest( "li" ),
            "ui-tabs-active", "ui-state-active" );
          show();
        } );
      } else {
        this._removeClass( eventData.oldTab.closest( "li" ),
          "ui-tabs-active", "ui-state-active" );
        toHide.hide();
        show();
      }

      toHide.attr( "aria-hidden", "true" );
      eventData.oldTab.attr( {
        "aria-selected": "false",
        "aria-expanded": "false"
      } );

      // If we're switching tabs, remove the old tab from the tab order.
      // If we're opening from collapsed state, remove the previous tab from the tab order.
      // If we're collapsing, then keep the collapsing tab in the tab order.
      if ( toShow.length && toHide.length ) {
        eventData.oldTab.attr( "tabIndex", -1 );
      } else if ( toShow.length ) {
        this.tabs.filter( function () {
          return $( this ).attr( "tabIndex" ) === 0;
        } )
          .attr( "tabIndex", -1 );
      }

      toShow.attr( "aria-hidden", "false" );
      eventData.newTab.attr( {
        "aria-selected": "true",
        "aria-expanded": "true",
        tabIndex: 0
      } );
    },

    _activate: function ( index ) {
      var anchor,
        active = this._findActive( index );

      // Trying to activate the already active panel
      if ( active[ 0 ] === this.active[ 0 ] ) {
        return;
      }

      // Trying to collapse, simulate a click on the current active header
      if ( !active.length ) {
        active = this.active;
      }

      anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
      this._eventHandler( {
        target: anchor,
        currentTarget: anchor,
        preventDefault: $.noop
      } );
    },

    _findActive: function ( index ) {
      return index === false ? $() : this.tabs.eq( index );
    },

    _getIndex: function ( index ) {

      // meta-function to give users option to provide a href string instead of a numerical index.
      if ( typeof index === "string" ) {
        index = this.anchors.index( this.anchors.filter( "[href$='" +
				$.ui.escapeSelector( index ) + "']" ) );
      }

      return index;
    },

    _destroy: function () {
      if ( this.xhr ) {
        this.xhr.abort();
      }

      this.tablist
        .removeAttr( "role" )
        .off( this.eventNamespace );

      this.anchors
        .removeAttr( "role tabIndex" )
        .removeUniqueId();

      this.tabs.add( this.panels ).each( function () {
        if ( $.data( this, "ui-tabs-destroy" ) ) {
          $( this ).remove();
        } else {
          $( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
        }
      } );

      this.tabs.each( function () {
        var li = $( this ),
          prev = li.data( "ui-tabs-aria-controls" );
        if ( prev ) {
          li
            .attr( "aria-controls", prev )
            .removeData( "ui-tabs-aria-controls" );
        } else {
          li.removeAttr( "aria-controls" );
        }
      } );

      this.panels.show();

      if ( this.options.heightStyle !== "content" ) {
        this.panels.css( "height", "" );
      }
    },

    enable: function ( index ) {
      var disabled = this.options.disabled;
      if ( disabled === false ) {
        return;
      }

      if ( index === undefined ) {
        disabled = false;
      } else {
        index = this._getIndex( index );
        if ( $.isArray( disabled ) ) {
          disabled = $.map( disabled, function ( num ) {
            return num !== index ? num : null;
          } );
        } else {
          disabled = $.map( this.tabs, function ( li, num ) {
            return num !== index ? num : null;
          } );
        }
      }
      this._setOptionDisabled( disabled );
    },

    disable: function ( index ) {
      var disabled = this.options.disabled;
      if ( disabled === true ) {
        return;
      }

      if ( index === undefined ) {
        disabled = true;
      } else {
        index = this._getIndex( index );
        if ( $.inArray( index, disabled ) !== -1 ) {
          return;
        }
        if ( $.isArray( disabled ) ) {
          disabled = $.merge( [ index ], disabled ).sort();
        } else {
          disabled = [ index ];
        }
      }
      this._setOptionDisabled( disabled );
    },

    load: function ( index, event ) {
      index = this._getIndex( index );
      var that = this,
        tab = this.tabs.eq( index ),
        anchor = tab.find( ".ui-tabs-anchor" ),
        panel = this._getPanelForTab( tab ),
        eventData = {
          tab: tab,
          panel: panel
        },
        complete = function ( jqXHR, status ) {
          if ( status === "abort" ) {
            that.panels.stop( false, true );
          }

          that._removeClass( tab, "ui-tabs-loading" );
          panel.removeAttr( "aria-busy" );

          if ( jqXHR === that.xhr ) {
            delete that.xhr;
          }
        };

      // Not remote
      if ( this._isLocal( anchor[ 0 ] ) ) {
        return;
      }

      this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

      // Support: jQuery <1.8
      // jQuery <1.8 returns false if the request is canceled in beforeSend,
      // but as of 1.8, $.ajax() always returns a jqXHR object.
      if ( this.xhr && this.xhr.statusText !== "canceled" ) {
        this._addClass( tab, "ui-tabs-loading" );
        panel.attr( "aria-busy", "true" );

        this.xhr
          .done( function ( response, status, jqXHR ) {

            // support: jQuery <1.8
            // http://bugs.jquery.com/ticket/11778
            setTimeout( function () {
              panel.html( response );
              that._trigger( "load", event, eventData );

              complete( jqXHR, status );
            }, 1 );
          } )
          .fail( function ( jqXHR, status ) {

            // support: jQuery <1.8
            // http://bugs.jquery.com/ticket/11778
            setTimeout( function () {
              complete( jqXHR, status );
            }, 1 );
          } );
      }
    },

    _ajaxSettings: function ( anchor, event, eventData ) {
      var that = this;
      return {

        // Support: IE <11 only
        // Strip any hash that exists to prevent errors with the Ajax request
        url: anchor.attr( "href" ).replace( /#.*$/, "" ),
        beforeSend: function ( jqXHR, settings ) {
          return that._trigger( "beforeLoad", event,
            $.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
        }
      };
    },

    _getPanelForTab: function ( tab ) {
      var id = $( tab ).attr( "aria-controls" );
      return this.element.find( this._sanitizeSelector( "#" + id ) );
    }
  } );

  // DEPRECATED
  // TODO: Switch return back to widget declaration at top of file when this is removed
  if ( $.uiBackCompat !== false ) {

    // Backcompat for ui-tab class (now ui-tabs-tab)
    $.widget( "ui.tabs", $.ui.tabs, {
      _processTabs: function () {
        this._superApply( arguments );
        this._addClass( this.tabs, "ui-tab" );
      }
    } );
  }

  var widgetsTabs = $.ui.tabs;

  /* !
 * jQuery UI Tooltip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

  // >>label: Tooltip
  // >>group: Widgets
  // >>description: Shows additional information for any element on hover or focus.
  // >>docs: http://api.jqueryui.com/tooltip/
  // >>demos: http://jqueryui.com/tooltip/
  // >>css.structure: ../../themes/base/core.css
  // >>css.structure: ../../themes/base/tooltip.css
  // >>css.theme: ../../themes/base/theme.css

  $.widget( "ui.tooltip", {
    version: "1.12.1",
    options: {
      classes: {
        "ui-tooltip": "ui-corner-all ui-widget-shadow"
      },
      content: function () {

        // support: IE<9, Opera in jQuery <1.7
        // .text() can't accept undefined, so coerce to a string
        var title = $( this ).attr( "title" ) || "";

        // Escape title, since we're going from an attribute to raw HTML
        return $( "<a>" ).text( title ).html();
      },
      hide: true,

      // Disabled elements have inconsistent behavior across browsers (#8661)
      items: "[title]:not([disabled])",
      position: {
        my: "left top+15",
        at: "left bottom",
        collision: "flipfit flip"
      },
      show: true,
      track: false,

      // Callbacks
      close: null,
      open: null
    },

    _addDescribedBy: function ( elem, id ) {
      var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
      describedby.push( id );
      elem
        .data( "ui-tooltip-id", id )
        .attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
    },

    _removeDescribedBy: function ( elem ) {
      var id = elem.data( "ui-tooltip-id" ),
        describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
        index = $.inArray( id, describedby );

      if ( index !== -1 ) {
        describedby.splice( index, 1 );
      }

      elem.removeData( "ui-tooltip-id" );
      describedby = $.trim( describedby.join( " " ) );
      if ( describedby ) {
        elem.attr( "aria-describedby", describedby );
      } else {
        elem.removeAttr( "aria-describedby" );
      }
    },

    _create: function () {
      this._on( {
        mouseover: "open",
        focusin: "open"
      } );

      // IDs of generated tooltips, needed for destroy
      this.tooltips = {};

      // IDs of parent tooltips where we removed the title attribute
      this.parents = {};

      // Append the aria-live region so tooltips announce correctly
      this.liveRegion = $( "<div>" )
        .attr( {
          role: "log",
          "aria-live": "assertive",
          "aria-relevant": "additions"
        } )
        .appendTo( this.document[ 0 ].body );
      this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

      this.disabledTitles = $( [] );
    },

    _setOption: function ( key, value ) {
      var that = this;

      this._super( key, value );

      if ( key === "content" ) {
        $.each( this.tooltips, function ( id, tooltipData ) {
          that._updateContent( tooltipData.element );
        } );
      }
    },

    _setOptionDisabled: function ( value ) {
      this[ value ? "_disable" : "_enable" ]();
    },

    _disable: function () {
      var that = this;

      // Close open tooltips
      $.each( this.tooltips, function ( id, tooltipData ) {
        var event = $.Event( "blur" );
        event.target = event.currentTarget = tooltipData.element[ 0 ];
        that.close( event, true );
      } );

      // Remove title attributes to prevent native tooltips
      this.disabledTitles = this.disabledTitles.add(
        this.element.find( this.options.items ).addBack()
          .filter( function () {
            var element = $( this );
            if ( element.is( "[title]" ) ) {
              return element
                .data( "ui-tooltip-title", element.attr( "title" ) )
                .removeAttr( "title" );
            }
          } )
      );
    },

    _enable: function () {

      // restore title attributes
      this.disabledTitles.each( function () {
        var element = $( this );
        if ( element.data( "ui-tooltip-title" ) ) {
          element.attr( "title", element.data( "ui-tooltip-title" ) );
        }
      } );
      this.disabledTitles = $( [] );
    },

    open: function ( event ) {
      var that = this,
        target = $( event ? event.target : this.element )

        // we need closest here due to mouseover bubbling,
        // but always pointing at the same event target
          .closest( this.options.items );

      // No element to show a tooltip for or the tooltip is already open
      if ( !target.length || target.data( "ui-tooltip-id" ) ) {
        return;
      }

      if ( target.attr( "title" ) ) {
        target.data( "ui-tooltip-title", target.attr( "title" ) );
      }

      target.data( "ui-tooltip-open", true );

      // Kill parent tooltips, custom or native, for hover
      if ( event && event.type === "mouseover" ) {
        target.parents().each( function () {
          var parent = $( this ),
            blurEvent;
          if ( parent.data( "ui-tooltip-open" ) ) {
            blurEvent = $.Event( "blur" );
            blurEvent.target = blurEvent.currentTarget = this;
            that.close( blurEvent, true );
          }
          if ( parent.attr( "title" ) ) {
            parent.uniqueId();
            that.parents[ this.id ] = {
              element: this,
              title: parent.attr( "title" )
            };
            parent.attr( "title", "" );
          }
        } );
      }

      this._registerCloseHandlers( event, target );
      this._updateContent( target, event );
    },

    _updateContent: function ( target, event ) {
      var content,
        contentOption = this.options.content,
        that = this,
        eventType = event ? event.type : null;

      if ( typeof contentOption === "string" || contentOption.nodeType ||
				contentOption.jquery ) {
        return this._open( event, target, contentOption );
      }

      content = contentOption.call( target[ 0 ], function ( response ) {

        // IE may instantly serve a cached response for ajax requests
        // delay this call to _open so the other call to _open runs first
        that._delay( function () {

          // Ignore async response if tooltip was closed already
          if ( !target.data( "ui-tooltip-open" ) ) {
            return;
          }

          // JQuery creates a special event for focusin when it doesn't
          // exist natively. To improve performance, the native event
          // object is reused and the type is changed. Therefore, we can't
          // rely on the type being correct after the event finished
          // bubbling, so we set it back to the previous value. (#8740)
          if ( event ) {
            event.type = eventType;
          }
          this._open( event, target, response );
        } );
      } );
      if ( content ) {
        this._open( event, target, content );
      }
    },

    _open: function ( event, target, content ) {
      var tooltipData, tooltip, delayedShow, a11yContent,
        positionOption = $.extend( {}, this.options.position );

      if ( !content ) {
        return;
      }

      // Content can be updated multiple times. If the tooltip already
      // exists, then just update the content and bail.
      tooltipData = this._find( target );
      if ( tooltipData ) {
        tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
        return;
      }

      // If we have a title, clear it to prevent the native tooltip
      // we have to check first to avoid defining a title if none exists
      // (we don't want to cause an element to start matching [title])
      //
      // We use removeAttr only for key events, to allow IE to export the correct
      // accessible attributes. For mouse events, set to empty string to avoid
      // native tooltip showing up (happens only when removing inside mouseover).
      if ( target.is( "[title]" ) ) {
        if ( event && event.type === "mouseover" ) {
          target.attr( "title", "" );
        } else {
          target.removeAttr( "title" );
        }
      }

      tooltipData = this._tooltip( target );
      tooltip = tooltipData.tooltip;
      this._addDescribedBy( target, tooltip.attr( "id" ) );
      tooltip.find( ".ui-tooltip-content" ).html( content );

      // Support: Voiceover on OS X, JAWS on IE <= 9
      // JAWS announces deletions even when aria-relevant="additions"
      // Voiceover will sometimes re-read the entire log region's contents from the beginning
      this.liveRegion.children().hide();
      a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
      a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
      a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
      a11yContent.appendTo( this.liveRegion );

      function position( event ) {
        positionOption.of = event;
        if ( tooltip.is( ":hidden" ) ) {
          return;
        }
        tooltip.position( positionOption );
      }
      if ( this.options.track && event && /^mouse/.test( event.type ) ) {
        this._on( this.document, {
          mousemove: position
        } );

        // trigger once to override element-relative positioning
        position( event );
      } else {
        tooltip.position( $.extend( {
          of: target
        }, this.options.position ) );
      }

      tooltip.hide();

      this._show( tooltip, this.options.show );

      // Handle tracking tooltips that are shown with a delay (#8644). As soon
      // as the tooltip is visible, position the tooltip using the most recent
      // event.
      // Adds the check to add the timers only when both delay and track options are set (#14682)
      if ( this.options.track && this.options.show && this.options.show.delay ) {
        delayedShow = this.delayedShow = setInterval( function () {
          if ( tooltip.is( ":visible" ) ) {
            position( positionOption.of );
            clearInterval( delayedShow );
          }
        }, $.fx.interval );
      }

      this._trigger( "open", event, { tooltip: tooltip } );
    },

    _registerCloseHandlers: function ( event, target ) {
      var events = {
        keyup: function ( event ) {
          if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
            var fakeEvent = $.Event( event );
            fakeEvent.currentTarget = target[ 0 ];
            this.close( fakeEvent, true );
          }
        }
      };

      // Only bind remove handler for delegated targets. Non-delegated
      // tooltips will handle this in destroy.
      if ( target[ 0 ] !== this.element[ 0 ] ) {
        events.remove = function () {
          this._removeTooltip( this._find( target ).tooltip );
        };
      }

      if ( !event || event.type === "mouseover" ) {
        events.mouseleave = "close";
      }
      if ( !event || event.type === "focusin" ) {
        events.focusout = "close";
      }
      this._on( true, target, events );
    },

    close: function ( event ) {
      var tooltip,
        that = this,
        target = $( event ? event.currentTarget : this.element ),
        tooltipData = this._find( target );

      // The tooltip may already be closed
      if ( !tooltipData ) {

        // We set ui-tooltip-open immediately upon open (in open()), but only set the
        // additional data once there's actually content to show (in _open()). So even if the
        // tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
        // the period between open() and _open().
        target.removeData( "ui-tooltip-open" );
        return;
      }

      tooltip = tooltipData.tooltip;

      // Disabling closes the tooltip, so we need to track when we're closing
      // to avoid an infinite loop in case the tooltip becomes disabled on close
      if ( tooltipData.closing ) {
        return;
      }

      // Clear the interval for delayed tracking tooltips
      clearInterval( this.delayedShow );

      // Only set title if we had one before (see comment in _open())
      // If the title attribute has changed since open(), don't restore
      if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
        target.attr( "title", target.data( "ui-tooltip-title" ) );
      }

      this._removeDescribedBy( target );

      tooltipData.hiding = true;
      tooltip.stop( true );
      this._hide( tooltip, this.options.hide, function () {
        that._removeTooltip( $( this ) );
      } );

      target.removeData( "ui-tooltip-open" );
      this._off( target, "mouseleave focusout keyup" );

      // Remove 'remove' binding only on delegated targets
      if ( target[ 0 ] !== this.element[ 0 ] ) {
        this._off( target, "remove" );
      }
      this._off( this.document, "mousemove" );

      if ( event && event.type === "mouseleave" ) {
        $.each( this.parents, function ( id, parent ) {
          $( parent.element ).attr( "title", parent.title );
          delete that.parents[ id ];
        } );
      }

      tooltipData.closing = true;
      this._trigger( "close", event, { tooltip: tooltip } );
      if ( !tooltipData.hiding ) {
        tooltipData.closing = false;
      }
    },

    _tooltip: function ( element ) {
      var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
        content = $( "<div>" ).appendTo( tooltip ),
        id = tooltip.uniqueId().attr( "id" );

      this._addClass( content, "ui-tooltip-content" );
      this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );

      tooltip.appendTo( this._appendTo( element ) );

      return this.tooltips[ id ] = {
        element: element,
        tooltip: tooltip
      };
    },

    _find: function ( target ) {
      var id = target.data( "ui-tooltip-id" );
      return id ? this.tooltips[ id ] : null;
    },

    _removeTooltip: function ( tooltip ) {
      tooltip.remove();
      delete this.tooltips[ tooltip.attr( "id" ) ];
    },

    _appendTo: function ( target ) {
      var element = target.closest( ".ui-front, dialog" );

      if ( !element.length ) {
        element = this.document[ 0 ].body;
      }

      return element;
    },

    _destroy: function () {
      var that = this;

      // Close open tooltips
      $.each( this.tooltips, function ( id, tooltipData ) {

        // Delegate to close method to handle common cleanup
        var event = $.Event( "blur" ),
          element = tooltipData.element;
        event.target = event.currentTarget = element[ 0 ];
        that.close( event, true );

        // Remove immediately; destroying an open tooltip doesn't use the
        // hide animation
        $( "#" + id ).remove();

        // Restore the title
        if ( element.data( "ui-tooltip-title" ) ) {

          // If the title attribute has changed since open(), don't restore
          if ( !element.attr( "title" ) ) {
            element.attr( "title", element.data( "ui-tooltip-title" ) );
          }
          element.removeData( "ui-tooltip-title" );
        }
      } );
      this.liveRegion.remove();
    }
  } );

  // DEPRECATED
  // TODO: Switch return back to widget declaration at top of file when this is removed
  if ( $.uiBackCompat !== false ) {

    // Backcompat for tooltipClass option
    $.widget( "ui.tooltip", $.ui.tooltip, {
      options: {
        tooltipClass: null
      },
      _tooltip: function () {
        var tooltipData = this._superApply( arguments );
        if ( this.options.tooltipClass ) {
          tooltipData.tooltip.addClass( this.options.tooltipClass );
        }
        return tooltipData;
      }
    } );
  }

  var widgetsTooltip = $.ui.tooltip;

}));

/* ! jQuery Fancytree Plugin - 2.7.0 - 2014-12-21T15:57
  * https://github.com/mar10/fancytree
  * Copyright (c) 2014 Martin Wendt; Licensed MIT */
(function ( factory ) {
  if ( typeof define === "function" && define.amd ) {
    define( [ "jquery" ], factory );
  } else {
    factory( jQuery );
  }
}(function ( $ ) {

  !function (a, b, c, d) {"use strict";function e(b, c) {b || (c = c ? ": " + c : "", a.error("Fancytree assertion failed" + c));} function f(a, c) {var d, e, f = b.console ? b.console[a] : null;if (f) try {f.apply(b.console, c);} catch (g) {for (e = "", d = 0;d < c.length;d++)e += c[d];f(e);}} function g(a) {return !(!a.tree || a.statusNodeType === d);} function h(b) {var c, d, e, f = a.map(a.trim(b).split("."), function (a) {return parseInt(a, 10);}), g = a.map(Array.prototype.slice.call(arguments, 1), function (a) {return parseInt(a, 10);});for (c = 0;c < g.length;c++) if (d = f[c] || 0, e = g[c] || 0, d !== e) return d > e;return !0;} function i(a, b, c, d, e) {var f = function () {var c = b[a], f = d[a], g = b.ext[e], h = function () {return c.apply(b, arguments);};return function () {var a = b._local, c = b._super;try {return b._local = g, b._super = h, f.apply(b, arguments);} finally {b._local = a, b._super = c;}};}();return f;} function j(b, c, d, e) {for (var f in d)"function" === typeof d[f] ? "function" === typeof b[f] ? b[f] = i(f, b, c, d, e) : "_" === f.charAt(0) ? b.ext[e][f] = i(f, b, c, d, e) : a.error("Could not override tree." + f + ". Use prefix '_' to create tree." + e + "._" + f) : "options" !== f && (b.ext[e][f] = d[f]);} function k(b, c) {return b === d ? a.Deferred(function () {this.resolve();}).promise() : a.Deferred(function () {this.resolveWith(b, c);}).promise();} function l(b, c) {return b === d ? a.Deferred(function () {this.reject();}).promise() : a.Deferred(function () {this.rejectWith(b, c);}).promise();} function m(a, b) {return function () {a.resolveWith(b);};} function n(b) {var c = a.extend({}, b.data()), d = c.json;return delete c.fancytree, d && (delete c.json, c = a.extend(c, d)), c;} function o(a) {return a = a.toLowerCase(), function (b) {return b.title.toLowerCase().indexOf(a) >= 0;};} function p(a) {var b = new RegExp("^" + a, "i");return function (a) {return b.test(a.title);};} function q(b, c) {var d, f, g, h;for (this.parent = b, this.tree = b.tree, this.ul = null, this.li = null, this.statusNodeType = null, this._isLoading = !1, this._error = null, this.data = {}, d = 0, f = z.length;f > d;d++)g = z[d], this[g] = c[g];c.data && a.extend(this.data, c.data);for (g in c)A[g] || a.isFunction(c[g]) || B[g] || (this.data[g] = c[g]);null == this.key ? this.tree.options.defaultKey ? (this.key = this.tree.options.defaultKey(this), e(this.key, "defaultKey() must return a unique key")) : this.key = "_" + t._nextNodeKey++ : this.key = "" + this.key, c.active && (e(null === this.tree.activeNode, "only one active node allowed"), this.tree.activeNode = this), c.selected && (this.tree.lastSelectedNode = this), this.children = null, h = c.children, h && h.length && this._setChildren(h), this.tree._callHook("treeRegisterNode", this.tree, !0, this);} function r(b) {this.widget = b, this.$div = b.element, this.options = b.options, this.options && (a.isFunction(this.options.lazyload) && !a.isFunction(this.options.lazyLoad) && (this.options.lazyLoad = function () {return t.warn("The 'lazyload' event is deprecated since 2014-02-25. Use 'lazyLoad' (with uppercase L) instead."), b.options.lazyload.apply(this, arguments);}), a.isFunction(this.options.loaderror) && a.error("The 'loaderror' event was renamed since 2014-07-03. Use 'loadError' (with uppercase E) instead."), this.options.fx !== d && t.warn("The 'fx' options was replaced by 'toggleEffect' since 2014-11-30.")), this.ext = {}, this.data = n(this.$div), this._id = a.ui.fancytree._nextId++, this._ns = ".fancytree-" + this._id, this.activeNode = null, this.focusNode = null, this._hasFocus = null, this.lastSelectedNode = null, this.systemFocusElement = null, this.lastQuicksearchTerm = "", this.lastQuicksearchTime = 0, this.statusClassPropName = "span", this.ariaPropName = "li", this.nodeContainerAttrName = "li", this.$div.find(">ul.fancytree-container").remove();var c, e = { tree: this };this.rootNode = new q(e, { title: "root", key: "root_" + this._id, children: null, expanded: !0 }), this.rootNode.parent = null, c = a("<ul>", { "class": "ui-fancytree fancytree-container" }).appendTo(this.$div), this.$container = c, this.rootNode.ul = c[0], null == this.options.debugLevel && (this.options.debugLevel = t.debugLevel), this.$container.attr("tabindex", this.options.tabbable ? "0" : "-1"), this.options.aria && this.$container.attr("role", "tree").attr("aria-multiselectable", !0);} if (a.ui && a.ui.fancytree) return void a.ui.fancytree.warn("Fancytree: ignored duplicate include");e(a.ui, "Fancytree requires jQuery UI (http://jqueryui.com)");var s, t = null, u = { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;", "/": "&#x2F;" }, v = { 16: !0, 17: !0, 18: !0 }, w = { 8: "backspace", 9: "tab", 10: "return", 13: "return", 19: "pause", 20: "capslock", 27: "esc", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home", 37: "left", 38: "up", 39: "right", 40: "down", 45: "insert", 46: "del", 59: ";", 61: "=", 96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111: "/", 112: "f1", 113: "f2", 114: "f3", 115: "f4", 116: "f5", 117: "f6", 118: "f7", 119: "f8", 120: "f9", 121: "f10", 122: "f11", 123: "f12", 144: "numlock", 145: "scroll", 173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'" }, x = "active expanded focus folder hideCheckbox lazy selected unselectable".split(" "), y = {}, z = "expanded extraClasses folder hideCheckbox key lazy refKey selected title tooltip unselectable".split(" "), A = {}, B = { active: !0, children: !0, data: !0, focus: !0 };for (s = 0;s < x.length;s++)y[x[s]] = !0;for (s = 0;s < z.length;s++)A[z[s]] = !0;q.prototype = { _findDirectChild: function (a) {var b, c, d = this.children;if (d) if ("string" === typeof a) {for (b = 0, c = d.length;c > b;b++) if (d[b].key === a) return d[b];} else {if ("number" === typeof a) return this.children[a];if (a.parent === this) return a;} return null;}, _setChildren: function (a) {e(a && (!this.children || 0 === this.children.length), "only init supported"), this.children = [];for (var b = 0, c = a.length;c > b;b++) this.children.push(new q(this, a[b]));}, addChildren: function (b, c) {var d, f, g, h = null, i = [];for (a.isPlainObject(b) && (b = [b]), this.children || (this.children = []), d = 0, f = b.length;f > d;d++)i.push(new q(this, b[d]));return h = i[0], null == c ? this.children = this.children.concat(i) : (c = this._findDirectChild(c), g = a.inArray(c, this.children), e(g >= 0, "insertBefore must be an existing child"), this.children.splice.apply(this.children, [g, 0].concat(i))), (!this.parent || this.parent.ul || this.tr) && this.render(), 3 === this.tree.options.selectMode && this.fixSelection3FromEndNodes(), h;}, addNode: function (a, b) {switch ((b === d || "over" === b) && (b = "child"), b) {case "after":return this.getParent().addChildren(a, this.getNextSibling());case "before":return this.getParent().addChildren(a, this);case "firstChild":var c = this.children ? this.children[0] : null;return this.addChildren(a, c);case "child":case "over":return this.addChildren(a);}e(!1, "Invalid mode: " + b);}, appendSibling: function (a) {return this.addNode(a, "after");}, applyPatch: function (b) {if (null === b) return this.remove(), k(this);var c, d, e, f = { children: !0, expanded: !0, parent: !0 };for (c in b)e = b[c], f[c] || a.isFunction(e) || (A[c] ? this[c] = e : this.data[c] = e);return b.hasOwnProperty("children") && (this.removeChildren(), b.children && this._setChildren(b.children)), this.isVisible() && (this.renderTitle(), this.renderStatus()), d = b.hasOwnProperty("expanded") ? this.setExpanded(b.expanded) : k(this);}, collapseSiblings: function () {return this.tree._callHook("nodeCollapseSiblings", this);}, copyTo: function (a, b, c) {return a.addNode(this.toDict(!0, c), b);}, countChildren: function (a) {var b, c, d, e = this.children;if (!e) return 0;if (d = e.length, a !== !1) for (b = 0, c = d;c > b;b++)d += e[b].countChildren();return d;}, debug: function () {this.tree.options.debugLevel >= 2 && (Array.prototype.unshift.call(arguments, this.toString()), f("log", arguments));}, discard: function () {return this.warn("FancytreeNode.discard() is deprecated since 2014-02-16. Use .resetLazy() instead."), this.resetLazy();}, findAll: function (b) {b = a.isFunction(b) ? b : o(b);var c = [];return this.visit(function (a) {b(a) && c.push(a);}), c;}, findFirst: function (b) {b = a.isFunction(b) ? b : o(b);var c = null;return this.visit(function (a) {return b(a) ? (c = a, !1) : void 0;}), c;}, _changeSelectStatusAttrs: function (a) {var b = !1;switch (a) {case !1:b = this.selected || this.partsel, this.selected = !1, this.partsel = !1;break;case !0:b = !this.selected || !this.partsel, this.selected = !0, this.partsel = !0;break;case d:b = this.selected || !this.partsel, this.selected = !1, this.partsel = !0;break;default:e(!1, "invalid state: " + a);} return b && this.renderStatus(), b;}, fixSelection3AfterClick: function () {var a = this.isSelected();this.visit(function (b) {b._changeSelectStatusAttrs(a);}), this.fixSelection3FromEndNodes();}, fixSelection3FromEndNodes: function () {function a(b) {var c, e, f, g, h, i, j, k = b.children;if (k && k.length) {for (i = !0, j = !1, c = 0, e = k.length;e > c;c++)f = k[c], g = a(f), g !== !1 && (j = !0), g !== !0 && (i = !1);h = i ? !0 : j ? d : !1;} else h = !!b.selected;return b._changeSelectStatusAttrs(h), h;}e(3 === this.tree.options.selectMode, "expected selectMode 3"), a(this), this.visitParents(function (a) {var b, c, e, f, g = a.children, h = !0, i = !1;for (b = 0, c = g.length;c > b;b++)e = g[b], (e.selected || e.partsel) && (i = !0), e.unselectable || e.selected || (h = !1);f = h ? !0 : i ? d : !1, a._changeSelectStatusAttrs(f);});}, fromDict: function (b) {for (var c in b)A[c] ? this[c] = b[c] : "data" === c ? a.extend(this.data, b.data) : a.isFunction(b[c]) || B[c] || (this.data[c] = b[c]);b.children && (this.removeChildren(), this.addChildren(b.children)), this.renderTitle();}, getChildren: function () {return this.hasChildren() === d ? d : this.children;}, getFirstChild: function () {return this.children ? this.children[0] : null;}, getIndex: function () {return a.inArray(this, this.parent.children);}, getIndexHier: function (b) {b = b || ".";var c = [];return a.each(this.getParentList(!1, !0), function (a, b) {c.push(b.getIndex() + 1);}), c.join(b);}, getKeyPath: function (a) {var b = [], c = this.tree.options.keyPathSeparator;return this.visitParents(function (a) {a.parent && b.unshift(a.key);}, !a), c + b.join(c);}, getLastChild: function () {return this.children ? this.children[this.children.length - 1] : null;}, getLevel: function () {for (var a = 0, b = this.parent;b;)a++, b = b.parent;return a;}, getNextSibling: function () {if (this.parent) {var a, b, c = this.parent.children;for (a = 0, b = c.length - 1;b > a;a++) if (c[a] === this) return c[a + 1];} return null;}, getParent: function () {return this.parent;}, getParentList: function (a, b) {for (var c = [], d = b ? this : this.parent;d;)(a || d.parent) && c.unshift(d), d = d.parent;return c;}, getPrevSibling: function () {if (this.parent) {var a, b, c = this.parent.children;for (a = 1, b = c.length;b > a;a++) if (c[a] === this) return c[a - 1];} return null;}, hasChildren: function () {return this.lazy ? null == this.children ? d : 0 === this.children.length ? !1 : 1 === this.children.length && this.children[0].isStatusNode() ? d : !0 : !(!this.children || !this.children.length);}, hasFocus: function () {return this.tree.hasFocus() && this.tree.focusNode === this;}, info: function () {this.tree.options.debugLevel >= 1 && (Array.prototype.unshift.call(arguments, this.toString()), f("info", arguments));}, isActive: function () {return this.tree.activeNode === this;}, isChildOf: function (a) {return this.parent && this.parent === a;}, isDescendantOf: function (a) {if (!a || a.tree !== this.tree) return !1;for (var b = this.parent;b;) {if (b === a) return !0;b = b.parent;} return !1;}, isExpanded: function () {return !!this.expanded;}, isFirstSibling: function () {var a = this.parent;return !a || a.children[0] === this;}, isFolder: function () {return !!this.folder;}, isLastSibling: function () {var a = this.parent;return !a || a.children[a.children.length - 1] === this;}, isLazy: function () {return !!this.lazy;}, isLoaded: function () {return !this.lazy || this.hasChildren() !== d;}, isLoading: function () {return !!this._isLoading;}, isRoot: function () {return this.isRootNode();}, isRootNode: function () {return this.tree.rootNode === this;}, isSelected: function () {return !!this.selected;}, isStatusNode: function () {return !!this.statusNodeType;}, isTopLevel: function () {return this.tree.rootNode === this.parent;}, isUndefined: function () {return this.hasChildren() === d;}, isVisible: function () {var a, b, c = this.getParentList(!1, !1);for (a = 0, b = c.length;b > a;a++) if (!c[a].expanded) return !1;return !0;}, lazyLoad: function (a) {return this.warn("FancytreeNode.lazyLoad() is deprecated since 2014-02-16. Use .load() instead."), this.load(a);}, load: function (a) {var b, c, d = this;return e(this.isLazy(), "load() requires a lazy node"), a || this.isUndefined() ? (this.isLoaded() && this.resetLazy(), c = this.tree._triggerNodeEvent("lazyLoad", this), c === !1 ? k(this) : (e("boolean" !== typeof c, "lazyLoad event must return source in data.result"), b = this.tree._callHook("nodeLoadChildren", this, c), this.expanded && b.always(function () {d.render();}), b)) : k(this);}, makeVisible: function (b) {var c, d = this, e = [], f = new a.Deferred, g = this.getParentList(!1, !1), h = g.length, i = !(b && b.noAnimation === !0), j = !(b && b.scrollIntoView === !1);for (c = h - 1;c >= 0;c--)e.push(g[c].setExpanded(!0, b));return a.when.apply(a, e).done(function () {j ? d.scrollIntoView(i).done(function () {f.resolve();}) : f.resolve();}), f.promise();}, moveTo: function (b, c, f) {(c === d || "over" === c) && (c = "child");var g, h = this.parent, i = "child" === c ? b : b.parent;if (this !== b) {if (!this.parent) throw "Cannot move system root";if (i.isDescendantOf(this)) throw "Cannot move a node to its own descendant";if (1 === this.parent.children.length) {if (this.parent === i) return;this.parent.children = this.parent.lazy ? [] : null, this.parent.expanded = !1;} else g = a.inArray(this, this.parent.children), e(g >= 0), this.parent.children.splice(g, 1);if (this.parent = i, i.hasChildren()) switch (c) {case "child":i.children.push(this);break;case "before":g = a.inArray(b, i.children), e(g >= 0), i.children.splice(g, 0, this);break;case "after":g = a.inArray(b, i.children), e(g >= 0), i.children.splice(g + 1, 0, this);break;default:throw "Invalid mode " + c;} else i.children = [this];f && b.visit(f, !0), this.tree !== b.tree && (this.warn("Cross-tree moveTo is experimantal!"), this.visit(function (a) {a.tree = b.tree;}, !0)), h.isDescendantOf(i) || h.render(), i.isDescendantOf(h) || i === h || i.render();}}, navigate: function (b, c) {function d(d) {if (d) {try {d.makeVisible();} catch (e) {} return a(d.span).is(":visible") ? c === !1 ? d.setFocus() : d.setActive() : (d.debug("Navigate: skipping hidden node"), void d.navigate(b, c));}} var e, f, g = !0, h = a.ui.keyCode, i = null;switch (b) {case h.BACKSPACE:this.parent && this.parent.parent && d(this.parent);break;case h.LEFT:this.expanded ? (this.setExpanded(!1), d(this)) : this.parent && this.parent.parent && d(this.parent);break;case h.RIGHT:this.expanded || !this.children && !this.lazy ? this.children && this.children.length && d(this.children[0]) : (this.setExpanded(), d(this));break;case h.UP:for (i = this.getPrevSibling();i && !a(i.span).is(":visible");)i = i.getPrevSibling();for (;i && i.expanded && i.children && i.children.length;)i = i.children[i.children.length - 1];!i && this.parent && this.parent.parent && (i = this.parent), d(i);break;case h.DOWN:if (this.expanded && this.children && this.children.length)i = this.children[0];else for (f = this.getParentList(!1, !0), e = f.length - 1;e >= 0;e--) {for (i = f[e].getNextSibling();i && !a(i.span).is(":visible");)i = i.getNextSibling();if (i) break;}d(i);break;default:g = !1;}}, remove: function () {return this.parent.removeChild(this);}, removeChild: function (a) {return this.tree._callHook("nodeRemoveChild", this, a);}, removeChildren: function () {return this.tree._callHook("nodeRemoveChildren", this);}, render: function (a, b) {return this.tree._callHook("nodeRender", this, a, b);}, renderTitle: function () {return this.tree._callHook("nodeRenderTitle", this);}, renderStatus: function () {return this.tree._callHook("nodeRenderStatus", this);}, resetLazy: function () {this.removeChildren(), this.expanded = !1, this.lazy = !0, this.children = d, this.renderStatus();}, scheduleAction: function (a, b) {this.tree.timer && clearTimeout(this.tree.timer), this.tree.timer = null;var c = this;switch (a) {case "cancel":break;case "expand":this.tree.timer = setTimeout(function () {c.tree.debug("setTimeout: trigger expand"), c.setExpanded(!0);}, b);break;case "activate":this.tree.timer = setTimeout(function () {c.tree.debug("setTimeout: trigger activate"), c.setActive(!0);}, b);break;default:throw "Invalid mode " + a;}}, scrollIntoView: function (f, h) {h !== d && g(h) && (this.warn("scrollIntoView() with 'topNode' option is deprecated since 2014-05-08. Use 'options.topNode' instead."), h = { topNode: h });var i, j, k, l, m = a.extend({ effects: f === !0 ? { duration: 200, queue: !1 } : f, scrollOfs: this.tree.options.scrollOfs, scrollParent: this.tree.options.scrollParent || this.tree.$container, topNode: null }, h), n = new a.Deferred, o = this, p = a(this.span).height(), q = a(m.scrollParent), r = m.scrollOfs.top || 0, s = m.scrollOfs.bottom || 0, t = q.height(), u = q.scrollTop(), v = q, w = q[0] === b, x = m.topNode || null, y = null;return e(a(this.span).is(":visible"), "scrollIntoView node is invisible"), w ? (j = a(this.span).offset().top, i = x && x.span ? a(x.span).offset().top : 0, v = a("html,body")) : (e(q[0] !== c && q[0] !== c.body, "scrollParent should be an simple element or `window`, not document or body."), l = q.offset().top, j = a(this.span).offset().top - l + u, i = x ? a(x.span).offset().top - l + u : 0, k = Math.max(0, q.innerHeight() - q[0].clientHeight), t -= k), u + r > j ? y = j - r : j + p > u + t - s && (y = j + p - t + s, x && (e(x.isRoot() || a(x.span).is(":visible"), "topNode must be visible"), y > i && (y = i - r))), null !== y ? m.effects ? (m.effects.complete = function () {n.resolveWith(o);}, v.stop(!0).animate({ scrollTop: y }, m.effects)) : (v[0].scrollTop = y, n.resolveWith(this)) : n.resolveWith(this), n.promise();}, setActive: function (a, b) {return this.tree._callHook("nodeSetActive", this, a, b);}, setExpanded: function (a, b) {return this.tree._callHook("nodeSetExpanded", this, a, b);}, setFocus: function (a) {return this.tree._callHook("nodeSetFocus", this, a);}, setSelected: function (a) {return this.tree._callHook("nodeSetSelected", this, a);}, setStatus: function (a, b, c) {return this.tree._callHook("nodeSetStatus", this, a, b, c);}, setTitle: function (a) {this.title = a, this.renderTitle();}, sortChildren: function (a, b) {var c, d, e = this.children;if (e) {if (a = a || function (a, b) {var c = a.title.toLowerCase(), d = b.title.toLowerCase();return c === d ? 0 : c > d ? 1 : -1;}, e.sort(a), b) for (c = 0, d = e.length;d > c;c++)e[c].children && e[c].sortChildren(a, "$norender$");"$norender$" !== b && this.render();}}, toDict: function (b, c) {var d, e, f, g = {}, h = this;if (a.each(z, function (a, b) {(h[b] || h[b] === !1) && (g[b] = h[b]);}), a.isEmptyObject(this.data) || (g.data = a.extend({}, this.data), a.isEmptyObject(g.data) && delete g.data), c && c(g), b && this.hasChildren()) for (g.children = [], d = 0, e = this.children.length;e > d;d++)f = this.children[d], f.isStatusNode() || g.children.push(f.toDict(!0, c));return g;}, toggleExpanded: function () {return this.tree._callHook("nodeToggleExpanded", this);}, toggleSelected: function () {return this.tree._callHook("nodeToggleSelected", this);}, toString: function () {return "<FancytreeNode(#" + this.key + ", '" + this.title + "')>";}, visit: function (a, b) {var c, d, e = !0, f = this.children;if (b === !0 && (e = a(this), e === !1 || "skip" === e)) return e;if (f) for (c = 0, d = f.length;d > c && (e = f[c].visit(a, !0), e !== !1);c++);return e;}, visitAndLoad: function (b, c, d) {var e, f, g, h = this;return b && c === !0 && (f = b(h), f === !1 || "skip" === f) ? d ? f : k() : h.children || h.lazy ? (e = new a.Deferred, g = [], h.load().done(function () {for (var c = 0, d = h.children.length;d > c;c++) {if (f = h.children[c].visitAndLoad(b, !0, !0), f === !1) {e.reject();break;}"skip" !== f && g.push(f);}a.when.apply(this, g).then(function () {e.resolve();});}), e.promise()) : k();}, visitParents: function (a, b) {if (b && a(this) === !1) return !1;for (var c = this.parent;c;) {if (a(c) === !1) return !1;c = c.parent;} return !0;}, warn: function () {Array.prototype.unshift.call(arguments, this.toString()), f("warn", arguments);} }, r.prototype = { _makeHookContext: function (b, c, e) {var f, g;return b.node !== d ? (c && b.originalEvent !== c && a.error("invalid args"), f = b) : b.tree ? (g = b.tree, f = { node: b, tree: g, widget: g.widget, options: g.widget.options, originalEvent: c }) : b.widget ? f = { node: null, tree: b, widget: b.widget, options: b.widget.options, originalEvent: c } : a.error("invalid args"), e && a.extend(f, e), f;}, _callHook: function (b, c) {var d = this._makeHookContext(c), e = this[b], f = Array.prototype.slice.call(arguments, 2);return a.isFunction(e) || a.error("_callHook('" + b + "') is not a function"), f.unshift(d), e.apply(this, f);}, _requireExtension: function (b, c, d, f) {d = !!d;var g = this._local.name, h = this.options.extensions, i = a.inArray(b, h) < a.inArray(g, h), j = c && null == this.ext[b], k = !j && null != d && d !== i;return e(g && g !== b), j || k ? (f || (j || c ? (f = "'" + g + "' extension requires '" + b + "'", k && (f += " to be registered " + (d ? "before" : "after") + " itself")) : f = "If used together, `" + b + "` must be registered " + (d ? "before" : "after") + " `" + g + "`"), a.error(f), !1) : !0;}, activateKey: function (a) {var b = this.getNodeByKey(a);return b ? b.setActive() : this.activeNode && this.activeNode.setActive(!1), b;}, applyPatch: function (b) {var c, d, f, g, h, i, j = b.length, k = [];for (d = 0;j > d;d++)f = b[d], e(2 === f.length, "patchList must be an array of length-2-arrays"), g = f[0], h = f[1], i = null === g ? this.rootNode : this.getNodeByKey(g), i ? (c = new a.Deferred, k.push(c), i.applyPatch(h).always(m(c, i))) : this.warn("could not find node with key '" + g + "'");return a.when.apply(a, k).promise();}, count: function () {return this.rootNode.countChildren();}, debug: function () {this.options.debugLevel >= 2 && (Array.prototype.unshift.call(arguments, this.toString()), f("log", arguments));}, findNextNode: function (b, c) {var d = null, e = c.parent.children, f = null, g = function (a, b, c) {var d, e, f = a.children, h = f.length, i = f[b];if (i && c(i) === !1) return !1;if (i && i.children && i.expanded && g(i, 0, c) === !1) return !1;for (d = b + 1;h > d;d++) if (g(a, d, c) === !1) return !1;return e = a.parent, e ? g(e, e.children.indexOf(a) + 1, c) : g(a, 0, c);};return b = "string" === typeof b ? p(b) : b, c = c || this.getFirstChild(), g(c.parent, e.indexOf(c), function (e) {return e === d ? !1 : (d = d || e, a(e.span).is(":visible") ? b(e) && (f = e, f !== c) ? !1 : void 0 : void e.debug("quicksearch: skipping hidden node"));}), f;}, generateFormElements: function (b, c) {var d, e = b !== !1 ? "ft_" + this._id + "[]" : b, f = c !== !1 ? "ft_" + this._id + "_active" : c, g = "fancytree_result_" + this._id, h = a("#" + g);h.length ? h.empty() : h = a("<div>", { id: g }).hide().insertAfter(this.$container), e && (d = this.getSelectedNodes(3 === this.options.selectMode), a.each(d, function (b, c) {h.append(a("<input>", { type: "checkbox", name: e, value: c.key, checked: !0 }));})), f && this.activeNode && h.append(a("<input>", { type: "radio", name: f, value: this.activeNode.key, checked: !0 }));}, getActiveNode: function () {return this.activeNode;}, getFirstChild: function () {return this.rootNode.getFirstChild();}, getFocusNode: function () {return this.focusNode;}, getNodeByKey: function (a, b) {var d, e;return !b && (d = c.getElementById(this.options.idPrefix + a)) ? d.ftnode ? d.ftnode : null : (b = b || this.rootNode, e = null, b.visit(function (b) {return b.key === a ? (e = b, !1) : void 0;}, !0), e);}, getRootNode: function () {return this.rootNode;}, getSelectedNodes: function (a) {var b = [];return this.rootNode.visit(function (c) {return c.selected && (b.push(c), a === !0) ? "skip" : void 0;}), b;}, hasFocus: function () {return !!this._hasFocus;}, info: function () {this.options.debugLevel >= 1 && (Array.prototype.unshift.call(arguments, this.toString()), f("info", arguments));}, loadKeyPath: function (b, c, e) {function f(a, b, d) {c.call(r, b, "loading"), b.load().done(function () {r.loadKeyPath.call(r, l[a], c, b).always(m(d, r));}).fail(function () {r.warn("loadKeyPath: error loading: " + a + " (parent: " + o + ")"), c.call(r, b, "error"), d.reject();});} var g, h, i, j, k, l, n, o, p, q = this.options.keyPathSeparator, r = this;for (a.isArray(b) || (b = [b]), l = {}, i = 0;i < b.length;i++) for (o = e || this.rootNode, j = b[i], j.charAt(0) === q && (j = j.substr(1)), p = j.split(q);p.length;) {if (k = p.shift(), n = o._findDirectChild(k), !n) {this.warn("loadKeyPath: key not found: " + k + " (parent: " + o + ")"), c.call(this, k, "error");break;} if (0 === p.length) {c.call(this, n, "ok");break;} if (n.lazy && n.hasChildren() === d) {c.call(this, n, "loaded"), l[k] ? l[k].push(p.join(q)) : l[k] = [p.join(q)];break;}c.call(this, n, "loaded"), o = n;}g = [];for (k in l)n = o._findDirectChild(k), h = new a.Deferred, g.push(h), f(k, n, h);return a.when.apply(a, g).promise();}, reactivate: function (a) {var b, c = this.activeNode;return c ? (this.activeNode = null, b = c.setActive(), a && c.setFocus(), b) : k();}, reload: function (a) {return this._callHook("treeClear", this), this._callHook("treeLoad", this, a);}, render: function (a, b) {return this.rootNode.render(a, b);}, setFocus: function (a) {return this._callHook("treeSetFocus", this, a);}, toDict: function (a, b) {var c = this.rootNode.toDict(!0, b);return a ? c : c.children;}, toString: function () {return "<Fancytree(#" + this._id + ")>";}, _triggerNodeEvent: function (a, b, c, e) {var f = this._makeHookContext(b, c, e), g = this.widget._trigger(a, c, f);return g !== !1 && f.result !== d ? f.result : g;}, _triggerTreeEvent: function (a, b, c) {var e = this._makeHookContext(this, b, c), f = this.widget._trigger(a, b, e);return f !== !1 && e.result !== d ? e.result : f;}, visit: function (a) {return this.rootNode.visit(a, !1);}, warn: function () {Array.prototype.unshift.call(arguments, this.toString()), f("warn", arguments);} }, a.extend(r.prototype, { nodeClick: function (a) {var b, c, d = a.targetType, e = a.node;if ("expander" === d) this._callHook("nodeToggleExpanded", a);else if ("checkbox" === d) this._callHook("nodeToggleSelected", a), a.options.focusOnSelect && this._callHook("nodeSetFocus", a, !0);else {if (c = !1, b = !0, e.folder) switch (a.options.clickFolderMode) {case 2:c = !0, b = !1;break;case 3:b = !0, c = !0;}b && (this.nodeSetFocus(a), this._callHook("nodeSetActive", a, !0)), c && this._callHook("nodeToggleExpanded", a);}}, nodeCollapseSiblings: function (a, b) {var c, d, e, f = a.node;if (f.parent) for (c = f.parent.children, d = 0, e = c.length;e > d;d++)c[d] !== f && c[d].expanded && this._callHook("nodeSetExpanded", c[d], !1, b);}, nodeDblclick: function (a) {"title" === a.targetType && 4 === a.options.clickFolderMode && this._callHook("nodeToggleExpanded", a), "title" === a.targetType && a.originalEvent.preventDefault();}, nodeKeydown: function (b) {var c, d, e, f = b.originalEvent, g = b.node, h = b.tree, i = b.options, j = f.which, k = String.fromCharCode(j), l = !(f.altKey || f.ctrlKey || f.metaKey || f.shiftKey), m = a(f.target), n = !0, o = !(f.ctrlKey || !i.autoActivate);if (g || (this.getFirstChild().setFocus(), g = b.node = this.focusNode, g.debug("Keydown force focus on first node")), i.quicksearch && l && /\w/.test(k) && !m.is(":input:enabled")) return d = (new Date).getTime(), d - h.lastQuicksearchTime > 500 && (h.lastQuicksearchTerm = ""), h.lastQuicksearchTime = d, h.lastQuicksearchTerm += k, c = h.findNextNode(h.lastQuicksearchTerm, h.getActiveNode()), c && c.setActive(), void f.preventDefault();switch (t.keyEventToString(f)) {case "+":case "=":h.nodeSetExpanded(b, !0);break;case "-":h.nodeSetExpanded(b, !1);break;case "space":i.checkbox ? h.nodeToggleSelected(b) : h.nodeSetActive(b, !0);break;case "enter":h.nodeSetActive(b, !0);break;case "backspace":case "left":case "right":case "up":case "down":e = g.navigate(f.which, o);break;default:n = !1;}n && f.preventDefault();}, nodeLoadChildren: function (b, c) {var d, f, g, h = b.tree, i = b.node;return a.isFunction(c) && (c = c()), c.url && (d = a.extend({}, b.options.ajax, c), d.debugDelay ? (f = d.debugDelay, a.isArray(f) && (f = f[0] + Math.random() * (f[1] - f[0])), i.debug("nodeLoadChildren waiting debug delay " + Math.round(f) + "ms"), d.debugDelay = !1, g = a.Deferred(function (b) {setTimeout(function () {a.ajax(d).done(function () {b.resolveWith(this, arguments);}).fail(function () {b.rejectWith(this, arguments);});}, f);})) : g = a.ajax(d), c = new a.Deferred, g.done(function (d) {var e, f;if ("string" === typeof d && a.error("Ajax request returned a string (did you get the JSON dataType wrong?)."), b.options.postProcess) {if (f = h._triggerNodeEvent("postProcess", b, b.originalEvent, { response: d, error: null, dataType: this.dataType }), f.error) return e = a.isPlainObject(f.error) ? f.error : { message: f.error }, e = h._makeHookContext(i, null, e), void c.rejectWith(this, [e]);d = a.isArray(f) ? f : d;} else d && d.hasOwnProperty("d") && b.options.enableAspx && (d = "string" === typeof d.d ? a.parseJSON(d.d) : d.d);c.resolveWith(this, [d]);}).fail(function (a, b, d) {var e = h._makeHookContext(i, null, { error: a, args: Array.prototype.slice.call(arguments), message: d, details: a.status + ": " + d });c.rejectWith(this, [e]);})), a.isFunction(c.promise) && (e(!i.isLoading()), h.nodeSetStatus(b, "loading"), c.done(function () {h.nodeSetStatus(b, "ok");}).fail(function (a) {var c;c = a.node && a.error && a.message ? a : h._makeHookContext(i, null, { error: a, args: Array.prototype.slice.call(arguments), message: a ? a.message || a.toString() : "" }), h._triggerNodeEvent("loadError", c, null) !== !1 && h.nodeSetStatus(b, "error", c.message, c.details);})), a.when(c).done(function (b) {var c;a.isPlainObject(b) && (e(a.isArray(b.children), "source must contain (or be) an array of children"), e(i.isRoot(), "source may only be an object for root nodes"), c = b, b = b.children, delete c.children, a.extend(h.data, c)), e(a.isArray(b), "expected array of children"), i._setChildren(b), h._triggerNodeEvent("loadChildren", i);});}, nodeLoadKeyPath: function () {}, nodeRemoveChild: function (b, c) {var d, f = b.node, g = b.options, h = a.extend({}, b, { node: c }), i = f.children;return 1 === i.length ? (e(c === i[0]), this.nodeRemoveChildren(b)) : (this.activeNode && (c === this.activeNode || this.activeNode.isDescendantOf(c)) && this.activeNode.setActive(!1), this.focusNode && (c === this.focusNode || this.focusNode.isDescendantOf(c)) && (this.focusNode = null), this.nodeRemoveMarkup(h), this.nodeRemoveChildren(h), d = a.inArray(c, i), e(d >= 0), c.visit(function (a) {a.parent = null;}, !0), this._callHook("treeRegisterNode", this, !1, c), g.removeNode && g.removeNode.call(b.tree, { type: "removeNode" }, h), void i.splice(d, 1));}, nodeRemoveChildMarkup: function (b) {var c = b.node;c.ul && (c.isRoot() ? a(c.ul).empty() : (a(c.ul).remove(), c.ul = null), c.visit(function (a) {a.li = a.ul = null;}));}, nodeRemoveChildren: function (b) {var c, d = b.tree, e = b.node, f = e.children, g = b.options;f && (this.activeNode && this.activeNode.isDescendantOf(e) && this.activeNode.setActive(!1), this.focusNode && this.focusNode.isDescendantOf(e) && (this.focusNode = null), this.nodeRemoveChildMarkup(b), c = a.extend({}, b), e.visit(function (a) {a.parent = null, d._callHook("treeRegisterNode", d, !1, a), g.removeNode && (c.node = a, g.removeNode.call(b.tree, { type: "removeNode" }, c));}), e.children = e.lazy ? [] : null, this.nodeRenderStatus(b));}, nodeRemoveMarkup: function (b) {var c = b.node;c.li && (a(c.li).remove(), c.li = null), this.nodeRemoveChildMarkup(b);}, nodeRender: function (b, d, f, g, h) {var i, j, k, l, m, n, o, p = b.node, q = b.tree, r = b.options, s = r.aria, t = !1, u = p.parent, v = !u, w = p.children;if (v || u.ul) {if (e(v || u.ul, "parent UL must exist"), v || (p.li && (d || p.li.parentNode !== p.parent.ul) && (p.li.parentNode !== p.parent.ul && this.debug("Unlinking " + p + " (must be child of " + p.parent + ")"), this.nodeRemoveMarkup(b)), p.li ? this.nodeRenderStatus(b) : (t = !0, p.li = c.createElement("li"), p.li.ftnode = p, p.key && r.generateIds && (p.li.id = r.idPrefix + p.key), p.span = c.createElement("span"), p.span.className = "fancytree-node", s && a(p.span).attr("aria-labelledby", "ftal_" + p.key), p.li.appendChild(p.span), this.nodeRenderTitle(b), r.createNode && r.createNode.call(q, { type: "createNode" }, b)), r.renderNode && r.renderNode.call(q, { type: "renderNode" }, b)), w) {if (v || p.expanded || f === !0) {for (p.ul || (p.ul = c.createElement("ul"), (g === !0 && !h || !p.expanded) && (p.ul.style.display = "none"), s && a(p.ul).attr("role", "group"), p.li ? p.li.appendChild(p.ul) : p.tree.$div.append(p.ul)), l = 0, m = w.length;m > l;l++)o = a.extend({}, b, { node: w[l] }), this.nodeRender(o, d, f, !1, !0);for (i = p.ul.firstChild;i;)k = i.ftnode, k && k.parent !== p ? (p.debug("_fixParent: remove missing " + k, i), n = i.nextSibling, i.parentNode.removeChild(i), i = n) : i = i.nextSibling;for (i = p.ul.firstChild, l = 0, m = w.length - 1;m > l;l++)j = w[l], k = i.ftnode, j !== k ? p.ul.insertBefore(j.li, k.li) : i = i.nextSibling;}} else p.ul && (this.warn("remove child markup for " + p), this.nodeRemoveChildMarkup(b));v || t && u.ul.appendChild(p.li);}}, nodeRenderTitle: function (a, b) {var c, e, f, g, h, i, j = a.node, k = a.tree, l = a.options, m = l.aria, n = j.getLevel(), o = [], p = j.data.icon;b !== d && (j.title = b), j.span && (n < l.minExpandLevel ? (j.lazy || (j.expanded = !0), n > 1 && o.push(m ? "<span role='button' class='fancytree-expander fancytree-expander-fixed'></span>" : "<span class='fancytree-expander fancytree-expander-fixed''></span>")) : o.push(m ? "<span role='button' class='fancytree-expander'></span>" : "<span class='fancytree-expander'></span>"), l.checkbox && j.hideCheckbox !== !0 && !j.isStatusNode() && o.push(m ? "<span role='checkbox' class='fancytree-checkbox'></span>" : "<span class='fancytree-checkbox'></span>"), g = m ? " role='img'" : "", (p === !0 || p !== !1 && l.icons !== !1) && (p && "string" === typeof p ? (p = "/" === p.charAt(0) ? p : (l.imagePath || "") + p, o.push("<img src='" + p + "' class='fancytree-icon' alt='' />")) : (e = l.iconClass && l.iconClass.call(k, j, a) || j.data.iconclass || null, o.push(e ? "<span " + g + " class='fancytree-custom-icon " + e + "'></span>" : "<span " + g + " class='fancytree-icon'></span>"))), f = "", l.renderTitle && (f = l.renderTitle.call(k, { type: "renderTitle" }, a) || ""), f || (i = j.tooltip ? " title='" + t.escapeHtml(j.tooltip) + "'" : "", c = m ? " id='ftal_" + j.key + "'" : "", g = m ? " role='treeitem'" : "", h = l.titlesTabbable ? " tabindex='0'" : "", f = "<span " + g + " class='fancytree-title'" + c + i + h + ">" + j.title + "</span>"), o.push(f), j.span.innerHTML = o.join(""), this.nodeRenderStatus(a));}, nodeRenderStatus: function (b) {var c = b.node, d = b.tree, e = b.options, f = c.hasChildren(), g = c.isLastSibling(), h = e.aria, i = a(c.span).find(".fancytree-title"), j = e._classNames, k = [], l = c[d.statusClassPropName];l && (k.push(j.node), d.activeNode === c && k.push(j.active), d.focusNode === c ? (k.push(j.focused), h && i.attr("aria-activedescendant", !0)) : h && i.removeAttr("aria-activedescendant"), c.expanded ? (k.push(j.expanded), h && i.attr("aria-expanded", !0)) : h && i.removeAttr("aria-expanded"), c.folder && k.push(j.folder), f !== !1 && k.push(j.hasChildren), g && k.push(j.lastsib), c.lazy && null == c.children && k.push(j.lazy), c.partsel && k.push(j.partsel), c.unselectable && k.push(j.unselectable), c._isLoading && k.push(j.loading), c._error && k.push(j.error), c.selected ? (k.push(j.selected), h && i.attr("aria-selected", !0)) : h && i.attr("aria-selected", !1), c.extraClasses && k.push(c.extraClasses), k.push(f === !1 ? j.combinedExpanderPrefix + "n" + (g ? "l" : "") : j.combinedExpanderPrefix + (c.expanded ? "e" : "c") + (c.lazy && null == c.children ? "d" : "") + (g ? "l" : "")), k.push(j.combinedIconPrefix + (c.expanded ? "e" : "c") + (c.folder ? "f" : "")), l.className = k.join(" "), c.li && (c.li.className = g ? j.lastsib : ""));
  }, nodeSetActive: function (b, c, d) {d = d || {};var f, g = b.node, h = b.tree, i = b.options, j = d.noEvents === !0, m = g === h.activeNode;return c = c !== !1, m === c ? k(g) : c && !j && this._triggerNodeEvent("beforeActivate", g, b.originalEvent) === !1 ? l(g, ["rejected"]) : void(c ? (h.activeNode && (e(h.activeNode !== g, "node was active (inconsistency)"), f = a.extend({}, b, { node: h.activeNode }), h.nodeSetActive(f, !1), e(null === h.activeNode, "deactivate was out of sync?")), i.activeVisible && g.makeVisible({ scrollIntoView: !1 }), h.activeNode = g, h.nodeRenderStatus(b), h.nodeSetFocus(b), j || h._triggerNodeEvent("activate", g, b.originalEvent)) : (e(h.activeNode === g, "node was not active (inconsistency)"), h.activeNode = null, this.nodeRenderStatus(b), j || b.tree._triggerNodeEvent("deactivate", g, b.originalEvent)));}, nodeSetExpanded: function (b, c, e) {e = e || {};var f, g, h, i, j, m, n = b.node, o = b.tree, p = b.options, q = e.noAnimation === !0, r = e.noEvents === !0;if (c = c !== !1, n.expanded && c || !n.expanded && !c) return k(n);if (c && !n.lazy && !n.hasChildren()) return k(n);if (!c && n.getLevel() < p.minExpandLevel) return l(n, ["locked"]);if (!r && this._triggerNodeEvent("beforeExpand", n, b.originalEvent) === !1) return l(n, ["rejected"]);if (q || n.isVisible() || (q = e.noAnimation = !0), g = new a.Deferred, c && !n.expanded && p.autoCollapse) {j = n.getParentList(!1, !0), m = p.autoCollapse;try {for (p.autoCollapse = !1, h = 0, i = j.length;i > h;h++) this._callHook("nodeCollapseSiblings", j[h], e);} finally {p.autoCollapse = m;}} return g.done(function () {c && p.autoScroll && !q ? n.getLastChild().scrollIntoView(!0, { topNode: n }).always(function () {r || b.tree._triggerNodeEvent(c ? "expand" : "collapse", b);}) : r || b.tree._triggerNodeEvent(c ? "expand" : "collapse", b);}), f = function (d) {var e, f, g = p.toggleEffect;if (n.expanded = c, o._callHook("nodeRender", b, !1, !1, !0), n.ul) if (e = "none" !== n.ul.style.display, f = !!n.expanded, e === f)n.warn("nodeSetExpanded: UL.style.display already set");else {if (g && !q) return void a(n.ul).toggle(g.effect, g.options, g.duration, function () {d();});n.ul.style.display = n.expanded || !parent ? "" : "none";}d();}, c && n.lazy && n.hasChildren() === d ? n.load().done(function () {g.notifyWith && g.notifyWith(n, ["loaded"]), f(function () {g.resolveWith(n);});}).fail(function (a) {f(function () {g.rejectWith(n, ["load failed (" + a + ")"]);});}) : f(function () {g.resolveWith(n);}), g.promise();}, nodeSetFocus: function (b, c) {var d, e = b.tree, f = b.node;if (c = c !== !1, e.focusNode) {if (e.focusNode === f && c) return;d = a.extend({}, b, { node: e.focusNode }), e.focusNode = null, this._triggerNodeEvent("blur", d), this._callHook("nodeRenderStatus", d);}c && (this.hasFocus() || (f.debug("nodeSetFocus: forcing container focus"), this._callHook("treeSetFocus", b, !0, !0)), f.makeVisible({ scrollIntoView: !1 }), e.focusNode = f, this._triggerNodeEvent("focus", b), b.options.autoScroll && f.scrollIntoView(), this._callHook("nodeRenderStatus", b));}, nodeSetSelected: function (a, b) {var c = a.node, d = a.tree, e = a.options;if (b = b !== !1, c.debug("nodeSetSelected(" + b + ")", a), !c.unselectable) {if (c.selected && b || !c.selected && !b) return !!c.selected;if (this._triggerNodeEvent("beforeSelect", c, a.originalEvent) === !1) return !!c.selected;b && 1 === e.selectMode ? d.lastSelectedNode && d.lastSelectedNode.setSelected(!1) : 3 === e.selectMode && (c.selected = b, c.fixSelection3AfterClick()), c.selected = b, this.nodeRenderStatus(a), d.lastSelectedNode = b ? c : null, d._triggerNodeEvent("select", a);}}, nodeSetStatus: function (b, c, d, e) {function f() {var a = h.children ? h.children[0] : null;if (a && a.isStatusNode()) {try {h.ul && (h.ul.removeChild(a.li), a.li = null);} catch (b) {}1 === h.children.length ? h.children = [] : h.children.shift();}} function g(b, c) {var d = h.children ? h.children[0] : null;return d && d.isStatusNode() ? (a.extend(d, b), i._callHook("nodeRenderTitle", d)) : (b.key = "_statusNode", h._setChildren([b]), h.children[0].statusNodeType = c, i.render()), h.children[0];} var h = b.node, i = b.tree;switch (c) {case "ok":f(), h._isLoading = !1, h._error = null, h.renderStatus();break;case "loading":h.parent || g({ title: i.options.strings.loading + (d ? " (" + d + ") " : ""), tooltip: e, extraClasses: "fancytree-statusnode-wait" }, c), h._isLoading = !0, h._error = null, h.renderStatus();break;case "error":g({ title: i.options.strings.loadError + (d ? " (" + d + ") " : ""), tooltip: e, extraClasses: "fancytree-statusnode-error" }, c), h._isLoading = !1, h._error = { message: d, details: e }, h.renderStatus();break;default:a.error("invalid node status " + c);}}, nodeToggleExpanded: function (a) {return this.nodeSetExpanded(a, !a.node.expanded);}, nodeToggleSelected: function (a) {return this.nodeSetSelected(a, !a.node.selected);}, treeClear: function (a) {var b = a.tree;b.activeNode = null, b.focusNode = null, b.$div.find(">ul.fancytree-container").empty(), b.rootNode.children = null;}, treeCreate: function () {}, treeDestroy: function () {}, treeInit: function (a) {this.treeLoad(a);}, treeLoad: function (b, c) {var d, e, f, g = b.tree, h = b.widget.element, i = a.extend({}, b, { node: this.rootNode });if (g.rootNode.children && this.treeClear(b), c = c || this.options.source)"string" === typeof c && a.error("Not implemented");else switch (d = h.data("type") || "html") {case "html":e = h.find(">ul:first"), e.addClass("ui-fancytree-source ui-helper-hidden"), c = a.ui.fancytree.parseHtml(e), this.data = a.extend(this.data, n(e));break;case "json":c = a.parseJSON(h.text()), c.children && (c.title && (g.title = c.title), c = c.children);break;default:a.error("Invalid data-type: " + d);} return f = this.nodeLoadChildren(i, c).done(function () {g.render(), 3 === b.options.selectMode && g.rootNode.fixSelection3FromEndNodes(), g._triggerTreeEvent("init", null, { status: !0 });}).fail(function () {g.render(), g._triggerTreeEvent("init", null, { status: !1 });});}, treeRegisterNode: function () {}, treeSetFocus: function (a, b) {b = b !== !1, b !== this.hasFocus() && (this._hasFocus = b, this.$container.toggleClass("fancytree-treefocus", b), this._triggerTreeEvent(b ? "focusTree" : "blurTree"));} }), a.widget("ui.fancytree", { options: { activeVisible: !0, ajax: { type: "GET", cache: !1, dataType: "json" }, aria: !1, autoActivate: !0, autoCollapse: !1, autoScroll: !1, checkbox: !1, clickFolderMode: 4, debugLevel: null, disabled: !1, enableAspx: !0, extensions: [], toggleEffect: { effect: "blind", options: { direction: "vertical", scale: "box" }, duration: 200 }, generateIds: !1, icons: !0, idPrefix: "ft_", focusOnSelect: !1, keyboard: !0, keyPathSeparator: "/", minExpandLevel: 1, quicksearch: !1, scrollOfs: { top: 0, bottom: 0 }, scrollParent: null, selectMode: 2, strings: { loading: "Loading&#8230;", loadError: "Load error!" }, tabbable: !0, titlesTabbable: !1, _classNames: { node: "fancytree-node", folder: "fancytree-folder", combinedExpanderPrefix: "fancytree-exp-", combinedIconPrefix: "fancytree-ico-", hasChildren: "fancytree-has-children", active: "fancytree-active", selected: "fancytree-selected", expanded: "fancytree-expanded", lazy: "fancytree-lazy", focused: "fancytree-focused", partsel: "fancytree-partsel", unselectable: "fancytree-unselectable", lastsib: "fancytree-lastsib", loading: "fancytree-loading", error: "fancytree-error" }, lazyLoad: null, postProcess: null }, _create: function () {this.tree = new r(this), this.$source = this.source || "json" === this.element.data("type") ? this.element : this.element.find(">ul:first");var b, c, f, g = this.options.extensions, h = this.tree;for (f = 0;f < g.length;f++)c = g[f], b = a.ui.fancytree._extensions[c], b || a.error("Could not apply extension '" + c + "' (it is not registered, did you forget to include it?)"), this.tree.options[c] = a.extend(!0, {}, b.options, this.tree.options[c]), e(this.tree.ext[c] === d, "Extension name must not exist as Fancytree.ext attribute: '" + c + "'"), this.tree.ext[c] = {}, j(this.tree, h, b, c), h = b;this.tree._callHook("treeCreate", this.tree);}, _init: function () {this.tree._callHook("treeInit", this.tree), this._bind();}, _setOption: function (b, c) {var d = !0, e = !1;switch (b) {case "aria":case "checkbox":case "icons":case "minExpandLevel":case "tabbable":this.tree._callHook("treeCreate", this.tree), e = !0;break;case "source":d = !1, this.tree._callHook("treeLoad", this.tree, c);} this.tree.debug("set option " + b + "=" + c + " <" + typeof c + ">"), d && a.Widget.prototype._setOption.apply(this, arguments), e && this.tree.render(!0, !1);}, destroy: function () {this._unbind(), this.tree._callHook("treeDestroy", this.tree), this.tree.$div.find(">ul.fancytree-container").remove(), this.$source && this.$source.removeClass("ui-helper-hidden"), a.Widget.prototype.destroy.call(this);}, _unbind: function () {var b = this.tree._ns;this.element.unbind(b), this.tree.$container.unbind(b), a(c).unbind(b);}, _bind: function () {var a = this, b = this.options, c = this.tree, d = c._ns;this._unbind(), c.$container.on("focusin" + d + " focusout" + d, function (a) {var b = t.getNode(a), d = "focusin" === a.type;b ? c._callHook("nodeSetFocus", b, d) : c._callHook("treeSetFocus", c, d);}).on("selectstart" + d, "span.fancytree-title", function (a) {a.preventDefault();}).on("keydown" + d, function (a) {if (b.disabled || b.keyboard === !1) return !0;var d, e = c.focusNode, f = c._makeHookContext(e || c, a), g = c.phase;try {return c.phase = "userEvent", d = e ? c._triggerNodeEvent("keydown", e, a) : c._triggerTreeEvent("keydown", a), "preventNav" === d ? d = !0 : d !== !1 && (d = c._callHook("nodeKeydown", f)), d;} finally {c.phase = g;}}).on("click" + d + " dblclick" + d, function (c) {if (b.disabled) return !0;var d, e = t.getEventTarget(c), f = e.node, g = a.tree, h = g.phase;if (!f) return !0;d = g._makeHookContext(f, c);try {switch (g.phase = "userEvent", c.type) {case "click":return d.targetType = e.type, g._triggerNodeEvent("click", d, c) === !1 ? !1 : g._callHook("nodeClick", d);case "dblclick":return d.targetType = e.type, g._triggerNodeEvent("dblclick", d, c) === !1 ? !1 : g._callHook("nodeDblclick", d);}} finally {g.phase = h;}});}, getActiveNode: function () {return this.tree.activeNode;}, getNodeByKey: function (a) {return this.tree.getNodeByKey(a);}, getRootNode: function () {return this.tree.rootNode;}, getTree: function () {return this.tree;} }), t = a.ui.fancytree, a.extend(a.ui.fancytree, { version: "2.7.0", buildType: "production", debugLevel: 1, _nextId: 1, _nextNodeKey: 1, _extensions: {}, _FancytreeClass: r, _FancytreeNodeClass: q, jquerySupports: { positionMyOfs: h(a.ui.version, 1, 9) }, assert: function (a, b) {return e(a, b);}, debounce: function (a, b, c, d) {var e;return 3 === arguments.length && "boolean" !== typeof c && (d = c, c = !1), function () {var f = arguments;d = d || this, c && !e && b.apply(d, f), clearTimeout(e), e = setTimeout(function () {c || b.apply(d, f), e = null;}, a);};}, debug: function () {a.ui.fancytree.debugLevel >= 2 && f("log", arguments);}, error: function () {f("error", arguments);}, escapeHtml: function (a) {return ("" + a).replace(/[&<>"'\/]/g, function (a) {return u[a];});}, getEventTargetType: function (a) {return this.getEventTarget(a).type;}, getEventTarget: function (b) {var c = b && b.target ? b.target.className : "", e = { node: this.getNode(b.target), type: d };return /\bfancytree-title\b/.test(c) ? e.type = "title" : /\bfancytree-expander\b/.test(c) ? e.type = e.node.hasChildren() === !1 ? "prefix" : "expander" : /\bfancytree-checkbox\b/.test(c) || /\bfancytree-radio\b/.test(c) ? e.type = "checkbox" : /\bfancytree-icon\b/.test(c) ? e.type = "icon" : /\bfancytree-node\b/.test(c) ? e.type = "title" : b && b.target && a(b.target).closest(".fancytree-title").length && (e.type = "title"), e;}, getNode: function (a) {if (a instanceof q) return a;for (a.selector !== d ? a = a[0] : a.originalEvent !== d && (a = a.target);a;) {if (a.ftnode) return a.ftnode;a = a.parentNode;} return null;}, info: function () {a.ui.fancytree.debugLevel >= 1 && f("info", arguments);}, keyEventToString: function (a) {var b = a.which, c = [];return a.altKey && c.push("alt"), a.ctrlKey && c.push("ctrl"), a.metaKey && c.push("meta"), a.shiftKey && c.push("shift"), v[b] || c.push(w[b] || String.fromCharCode(b).toLowerCase()), c.join("+");}, parseHtml: function (b) {var c, e, f, g, h, i, j, k, l = b.find(">li"), m = [];return l.each(function () {var l, o = a(this), p = o.find(">span:first", this), q = p.length ? null : o.find(">a:first"), r = { tooltip: null, data: {} };for (p.length ? r.title = p.html() : q && q.length ? (r.title = q.html(), r.data.href = q.attr("href"), r.data.target = q.attr("target"), r.tooltip = q.attr("title")) : (r.title = o.html(), g = r.title.search(/<ul/i), g >= 0 && (r.title = r.title.substring(0, g))), r.title = a.trim(r.title), e = 0, f = x.length;f > e;e++)r[x[e]] = d;for (j = this.className.split(" "), c = [], e = 0, f = j.length;f > e;e++)k = j[e], y[k] ? r[k] = !0 : c.push(k);if (r.extraClasses = c.join(" "), h = o.attr("title"), h && (r.tooltip = h), h = o.attr("id"), h && (r.key = h), l = n(o), l && !a.isEmptyObject(l)) {for (e = 0, f = z.length;f > e;e++)h = z[e], i = l[h], null != i && (delete l[h], r[h] = i);a.extend(r.data, l);}b = o.find(">ul:first"), r.children = b.length ? a.ui.fancytree.parseHtml(b) : r.lazy ? d : null, m.push(r);}), m;}, registerExtension: function (b) {e(null != b.name, "extensions must have a `name` property."), e(null != b.version, "extensions must have a `version` property."), a.ui.fancytree._extensions[b.name] = b;}, unescapeHtml: function (a) {var b = c.createElement("div");return b.innerHTML = a, 0 === b.childNodes.length ? "" : b.childNodes[0].nodeValue;}, warn: function () {f("warn", arguments);} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.childcounter.min.js' */
  !function (a) {"use strict";a.ui.fancytree._FancytreeClass.prototype.countSelected = function (a) { {var b = this;b.options;} return b.getSelectedNodes(a).length;}, a.ui.fancytree._FancytreeNodeClass.prototype.toUpper = function () {var a = this;return a.setTitle(a.title.toUpperCase());}, a.ui.fancytree.prototype.widgetMethod1 = function (a) {this.tree;return a;}, a.ui.fancytree.registerExtension({ name: "childcounter", version: "1.0.0", options: { deep: !0, hideZeros: !0, hideExpanded: !1 }, foo: 42, _appendCounter: function () {}, treeInit: function (a) {a.options, a.options.childcounter;this._super(a), this.$container.addClass("fancytree-ext-childcounter");}, treeDestroy: function (a) {this._super(a);}, nodeRenderTitle: function (b, c) {var d = b.node, e = b.options.childcounter, f = null == d.data.childCounter ? d.countChildren(e.deep) : +d.data.childCounter;this._super(b, c), !f && e.hideZeros || d.isExpanded() && e.hideExpanded || a("span.fancytree-icon", d.span).append(a("<span class='fancytree-childcounter'/>").text(f));}, nodeSetExpanded: function (a, b, c) { {var d = a.tree;a.node;} return this._super(a, b, c).always(function () {d.nodeRenderTitle(a);});} });}(jQuery);

  /* ! Extension 'jquery.fancytree.clones.min.js' */
  !function (a) {"use strict";function b(b, c) {b || (c = c ? ": " + c : "", a.error("Assertion failed" + c));} function c(a, b) {var c;for (c = a.length - 1;c >= 0;c--) if (a[c] === b) return a.splice(c, 1), !0;return !1;} function d(a, b, c) {for (var d, e, f = 3 & a.length, g = a.length - f, h = c, i = 3432918353, j = 461845907, k = 0;g > k;)e = 255 & a.charCodeAt(k) | (255 & a.charCodeAt(++k)) << 8 | (255 & a.charCodeAt(++k)) << 16 | (255 & a.charCodeAt(++k)) << 24, ++k, e = (65535 & e) * i + (((e >>> 16) * i & 65535) << 16) & 4294967295, e = e << 15 | e >>> 17, e = (65535 & e) * j + (((e >>> 16) * j & 65535) << 16) & 4294967295, h ^= e, h = h << 13 | h >>> 19, d = 5 * (65535 & h) + ((5 * (h >>> 16) & 65535) << 16) & 4294967295, h = (65535 & d) + 27492 + (((d >>> 16) + 58964 & 65535) << 16);switch (e = 0, f) {case 3:e ^= (255 & a.charCodeAt(k + 2)) << 16;case 2:e ^= (255 & a.charCodeAt(k + 1)) << 8;case 1:e ^= 255 & a.charCodeAt(k), e = (65535 & e) * i + (((e >>> 16) * i & 65535) << 16) & 4294967295, e = e << 15 | e >>> 17, e = (65535 & e) * j + (((e >>> 16) * j & 65535) << 16) & 4294967295, h ^= e;} return h ^= a.length, h ^= h >>> 16, h = 2246822507 * (65535 & h) + ((2246822507 * (h >>> 16) & 65535) << 16) & 4294967295, h ^= h >>> 13, h = 3266489909 * (65535 & h) + ((3266489909 * (h >>> 16) & 65535) << 16) & 4294967295, h ^= h >>> 16, b ? ("0000000" + (h >>> 0).toString(16)).substr(-8) : h >>> 0;} function e(b) {var c, e = a.map(b.getParentList(!1, !0), function (a) {return a.refKey || a.key;});return e = e.join("/"), c = "id_" + d(e, !0);}a.ui.fancytree._FancytreeNodeClass.prototype.getCloneList = function (b) {var c, d = this.tree, e = d.refMap[this.refKey] || null, f = d.keyMap;return e && (c = this.key, b ? e = a.map(e, function (a) {return f[a];}) : (e = a.map(e, function (a) {return a === c ? null : f[a];}), e.length < 1 && (e = null))), e;}, a.ui.fancytree._FancytreeNodeClass.prototype.isClone = function () {var a = this.refKey || null, b = a && this.tree.refMap[a] || null;return !!(b && b.length > 1);}, a.ui.fancytree._FancytreeNodeClass.prototype.reRegister = function (b, c) {b = null == b ? null : "" + b, c = null == c ? null : "" + c;var d = this.tree, e = this.key, f = this.refKey, g = d.keyMap, h = d.refMap, i = h[f] || null, j = !1;return null != b && b !== this.key && (g[b] && a.error("[ext-clones] reRegister(" + b + "): already exists: " + this), delete g[e], g[b] = this, i && (h[f] = a.map(i, function (a) {return a === e ? b : a;})), this.key = b, j = !0), null != c && c !== this.refKey && (i && (1 === i.length ? delete h[f] : h[f] = a.map(i, function (a) {return a === e ? null : a;})), h[c] ? h[c].append(b) : h[c] = [this.key], this.refKey = c, j = !0), j;}, a.ui.fancytree._FancytreeClass.prototype.getNodesByRef = function (b, c) {var d = this.keyMap, e = this.refMap[b] || null;return e && (e = c ? a.map(e, function (a) {var b = d[a];return b.isDescendantOf(c) ? b : null;}) : a.map(e, function (a) {return d[a];}), e.length < 1 && (e = null)), e;}, a.ui.fancytree._FancytreeClass.prototype.changeRefKey = function (a, b) {var c, d, e = this.keyMap, f = this.refMap[a] || null;if (f) {for (c = 0;c < f.length;c++)d = e[f[c]], d.refKey = b;delete this.refMap[a], this.refMap[b] = f;}}, a.ui.fancytree.registerExtension({ name: "clones", version: "0.0.3", options: { highlightActiveClones: !0, highlightClones: !1 }, treeCreate: function (a) {this._super(a), a.tree.refMap = {}, a.tree.keyMap = {};}, treeInit: function (a) {this.$container.addClass("fancytree-ext-clones"), b(null == a.options.defaultKey), a.options.defaultKey = function (a) {return e(a);}, this._super(a);}, treeClear: function (a) {return a.tree.refMap = {}, a.tree.keyMap = {}, this._super(a);}, treeRegisterNode: function (d, e, f) {var g, h, i = d.tree, j = i.keyMap, k = i.refMap, l = f.key, m = f && null != f.refKey ? "" + f.refKey : null;return "_statusNode" === l ? this._super(d, e, f) : (e ? (null != j[f.key] && a.error("clones.treeRegisterNode: node.key already exists: " + f), j[l] = f, m && (g = k[m], g ? (g.push(l), 2 === g.length && d.options.clones.highlightClones && j[g[0]].renderStatus()) : k[m] = [l])) : (null == j[l] && a.error("clones.treeRegisterNode: node.key not registered: " + f.key), delete j[l], m && (g = k[m], g && (h = g.length, 1 >= h ? (b(1 === h), b(g[0] === l), delete k[m]) : (c(g, l), 2 === h && d.options.clones.highlightClones && j[g[0]].renderStatus())))), this._super(d, e, f));}, nodeRenderStatus: function (b) {var c, d, e = b.node;return d = this._super(b), b.options.clones.highlightClones && (c = a(e[b.tree.statusClassPropName]), c.length && e.isClone() && c.addClass("fancytree-clone")), d;}, nodeSetActive: function (b, c) {var d, e = b.tree.statusClassPropName, f = b.node;return d = this._super(b, c), b.options.clones.highlightActiveClones && f.isClone() && a.each(f.getCloneList(!0), function (b, d) {a(d[e]).toggleClass("fancytree-active-clone", c !== !1);}), d;} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.dnd.min.js' */
  !function (a, b, c, d) {"use strict";function e(a) {return 0 === a ? "" : a > 0 ? "+" + a : "" + a;} function f(b) {var c = b.options.dnd || null;c && g(), c && c.dragStart && b.widget.element.draggable(a.extend({ addClasses: !1, appendTo: b.$container, containment: !1, delay: 0, distance: 4, revert: !1, scroll: !0, scrollSpeed: 7, scrollSensitivity: 10, connectToFancytree: !0, helper: function (b) {var c, d = a.ui.fancytree.getNode(b.target), e = a(d.span);return d ? (c = a("<div class='fancytree-drag-helper'><span class='fancytree-drag-helper-img' /></div>").css({ zIndex: 3, position: "relative" }).append(e.find("span.fancytree-title").clone()), c.data("ftSourceNode", d), c) : "<div>ERROR?: helper requested but sourceNode not found</div>";}, start: function (a, b) {var c = b.helper.data("ftSourceNode");return !!c;} }, b.options.dnd.draggable)), c && c.dragDrop && b.widget.element.droppable(a.extend({ addClasses: !1, tolerance: "intersect", greedy: !1 }, b.options.dnd.droppable));} function g() {h || (a.ui.plugin.add("draggable", "connectToFancytree", { start: function (b, c) {var d = a(this).data("ui-draggable") || a(this).data("draggable"), e = c.helper.data("ftSourceNode") || null;return e ? (d.offset.click.top = -2, d.offset.click.left = 16, e.tree.ext.dnd._onDragEvent("start", e, null, b, c, d)) : void 0;}, drag: function (b, c) {var d, e, f = a(this).data("ui-draggable") || a(this).data("draggable"), g = c.helper.data("ftSourceNode") || null, h = c.helper.data("ftTargetNode") || null, i = a.ui.fancytree.getNode(b.target);return b.target && !i && (d = a(b.target).closest("div.fancytree-drag-helper,#fancytree-drop-marker").length > 0) ? (e = g || h || a.ui.fancytree, void e.debug("Drag event over helper: ignored.")) : (c.helper.data("ftTargetNode", i), h && h !== i && h.tree.ext.dnd._onDragEvent("leave", h, g, b, c, f), void(i && i.tree.options.dnd.dragDrop && (i === h ? i.tree.ext.dnd._onDragEvent("over", i, g, b, c, f) : i.tree.ext.dnd._onDragEvent("enter", i, g, b, c, f))));}, stop: function (b, c) {var d, e = a(this).data("ui-draggable") || a(this).data("draggable"), f = c.helper.data("ftSourceNode") || null, g = c.helper.data("ftTargetNode") || null, h = b.type, i = "mouseup" === h && 1 === b.which;i || (d = f || g || a.ui.fancytree, d.debug("Drag was cancelled")), g && (i && g.tree.ext.dnd._onDragEvent("drop", g, f, b, c, e), g.tree.ext.dnd._onDragEvent("leave", g, f, b, c, e)), f && f.tree.ext.dnd._onDragEvent("stop", f, null, b, c, e);} }), h = !0);} var h = !1;a.ui.fancytree.registerExtension({ name: "dnd", version: "0.1.0", options: { autoExpandMS: 1e3, draggable: null, droppable: null, focusOnClick: !1, preventVoidMoves: !0, preventRecursiveMoves: !0, dragStart: null, dragStop: null, dragEnter: null, dragOver: null, dragDrop: null, dragLeave: null }, treeInit: function (b) {var c = b.tree;this._super(b), c.options.dnd.dragStart && c.$container.on("mousedown", function (d) {if (!c.hasFocus() && b.options.dnd.focusOnClick) {var e = a.ui.fancytree.getNode(d);e.debug("Re-enable focus that was prevented by jQuery UI draggable."), setTimeout(function () {a(d.target).closest(":tabbable").focus();}, 10);}}), f(c);}, nodeKeydown: function (b) {var c = b.originalEvent;return c.which === a.ui.keyCode.ESCAPE && this._local._cancelDrag(), this._super(b);}, nodeClick: function (a) {return this._super(a);}, _setDndStatus: function (b, c, d, f, g) {var h, i = 0, j = "center", k = this._local, l = b ? a(b.span) : null, m = a(c.span);if (k.$dropMarker || (k.$dropMarker = a("<div id='fancytree-drop-marker'></div>").hide().css({ "z-index": 1e3 }).prependTo(a(this.$div).parent())), "after" === f || "before" === f || "over" === f) {switch (f) {case "before":k.$dropMarker.removeClass("fancytree-drop-after fancytree-drop-over").addClass("fancytree-drop-before"), j = "top";break;case "after":k.$dropMarker.removeClass("fancytree-drop-before fancytree-drop-over").addClass("fancytree-drop-after"), j = "bottom";break;default:k.$dropMarker.removeClass("fancytree-drop-after fancytree-drop-before").addClass("fancytree-drop-over"), m.addClass("fancytree-drop-target"), i = 8;}h = a.ui.fancytree.jquerySupports.positionMyOfs ? { my: "left" + e(i) + " center", at: "left " + j, of: m } : { my: "left center", at: "left " + j, of: m, offset: "" + i + " 0" }, k.$dropMarker.show().position(h);} else m.removeClass("fancytree-drop-target"), k.$dropMarker.hide();"after" === f ? m.addClass("fancytree-drop-after") : m.removeClass("fancytree-drop-after"), "before" === f ? m.addClass("fancytree-drop-before") : m.removeClass("fancytree-drop-before"), g === !0 ? (l && l.addClass("fancytree-drop-accept"), m.addClass("fancytree-drop-accept"), d.addClass("fancytree-drop-accept")) : (l && l.removeClass("fancytree-drop-accept"), m.removeClass("fancytree-drop-accept"), d.removeClass("fancytree-drop-accept")), g === !1 ? (l && l.addClass("fancytree-drop-reject"), m.addClass("fancytree-drop-reject"), d.addClass("fancytree-drop-reject")) : (l && l.removeClass("fancytree-drop-reject"), m.removeClass("fancytree-drop-reject"), d.removeClass("fancytree-drop-reject"));}, _onDragEvent: function (b, c, e, f, g, h) {"over" !== b && this.debug("tree.ext.dnd._onDragEvent(%s, %o, %o) - %o", b, c, e, this);var i, j, k, l, m, n, o = this.options, p = o.dnd, q = this._makeHookContext(c, f, { otherNode: e, ui: g, draggable: h }), r = null, s = a(c.span);switch (b) {case "start":c.isStatusNode() ? r = !1 : p.dragStart && (r = p.dragStart(c, q)), r === !1 ? (this.debug("tree.dragStart() cancelled"), g.helper.trigger("mouseup").hide()) : s.addClass("fancytree-drag-source");break;case "enter":n = p.preventRecursiveMoves && c.isDescendantOf(e) ? !1 : p.dragEnter ? p.dragEnter(c, q) : null, r = n ? a.isArray(n) ? { over: a.inArray("over", n) >= 0, before: a.inArray("before", n) >= 0, after: a.inArray("after", n) >= 0 } : { over: n === !0 || "over" === n, before: n === !0 || "before" === n, after: n === !0 || "after" === n } : !1, g.helper.data("enterResponse", r), this.debug("helper.enterResponse: %o", r);break;case "over":l = g.helper.data("enterResponse"), m = null, l === !1 || ("string" === typeof l ? m = l : (i = s.offset(), j = { x: f.pageX - i.left, y: f.pageY - i.top }, k = { x: j.x / s.width(), y: j.y / s.height() }, l.after && k.y > .75 ? m = "after" : !l.over && l.after && k.y > .5 ? m = "after" : l.before && k.y <= .25 ? m = "before" : !l.over && l.before && k.y <= .5 ? m = "before" : l.over && (m = "over"), p.preventVoidMoves && (c === e ? (this.debug("    drop over source node prevented"), m = null) : "before" === m && e && c === e.getNextSibling() ? (this.debug("    drop after source node prevented"), m = null) : "after" === m && e && c === e.getPrevSibling() ? (this.debug("    drop before source node prevented"), m = null) : "over" === m && e && e.parent === c && e.isLastSibling() && (this.debug("    drop last child over own parent prevented"), m = null)), g.helper.data("hitMode", m))), "over" === m && p.autoExpandMS && c.hasChildren() !== !1 && !c.expanded && c.scheduleAction("expand", p.autoExpandMS), m && p.dragOver && (q.hitMode = m, r = p.dragOver(c, q)), this._local._setDndStatus(e, c, g.helper, m, r !== !1 && null !== m);break;case "drop":m = g.helper.data("hitMode"), m && p.dragDrop && (q.hitMode = m, p.dragDrop(c, q));break;case "leave":c.scheduleAction("cancel"), g.helper.data("enterResponse", null), g.helper.data("hitMode", null), this._local._setDndStatus(e, c, g.helper, "out", d), p.dragLeave && p.dragLeave(c, q);break;case "stop":s.removeClass("fancytree-drag-source"), p.dragStop && p.dragStop(c, q);break;default:a.error("Unsupported drag event: " + b);} return r;}, _cancelDrag: function () {var b = a.ui.ddmanager.current;b && b.cancel();} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.edit.min.js' */
  !function (a, b, c) {"use strict";var d = /Mac/.test(navigator.platform), e = a.ui.fancytree.escapeHtml, f = a.ui.fancytree.unescapeHtml;a.ui.fancytree._FancytreeNodeClass.prototype.editStart = function () {var b, d = this, e = this.tree, g = e.ext.edit, h = e.options.edit, i = a(".fancytree-title", d.span), j = { node: d, tree: e, options: e.options, isNew: a(d.span).hasClass("fancytree-edit-new"), orgTitle: d.title, input: null, dirty: !1 };return h.beforeEdit.call(d, { type: "beforeEdit" }, j) === !1 ? !1 : (a.ui.fancytree.assert(!g.currentNode, "recursive edit"), g.currentNode = this, g.eventData = j, e.widget._unbind(), a(c).on("mousedown.fancytree-edit", function (b) {a(b.target).hasClass("fancytree-edit-input") || d.editEnd(!0, b);}), b = a("<input />", { "class": "fancytree-edit-input", type: "text", value: f(j.orgTitle) }), g.eventData.input = b, null != h.adjustWidthOfs && b.width(i.width() + h.adjustWidthOfs), null != h.inputCss && b.css(h.inputCss), i.html(b), b.focus().change(function () {b.addClass("fancytree-edit-dirty");}).keydown(function (b) {switch (b.which) {case a.ui.keyCode.ESCAPE:d.editEnd(!1, b);break;case a.ui.keyCode.ENTER:return d.editEnd(!0, b), !1;}b.stopPropagation();}).blur(function (a) {return d.editEnd(!0, a);}), void h.edit.call(d, { type: "edit" }, j));}, a.ui.fancytree._FancytreeNodeClass.prototype.editEnd = function (b) {var d, f = this, g = this.tree, h = g.ext.edit, i = h.eventData, j = g.options.edit, k = a(".fancytree-title", f.span), l = k.find("input.fancytree-edit-input");return j.trim && l.val(a.trim(l.val())), d = l.val(), i.dirty = d !== f.title, i.save = b === !1 ? !1 : i.isNew ? "" !== d : i.dirty && "" !== d, j.beforeClose.call(f, { type: "beforeClose" }, i) === !1 ? !1 : i.save && j.save.call(f, { type: "save" }, i) === !1 ? !1 : (l.removeClass("fancytree-edit-dirty").unbind(), a(c).off(".fancytree-edit"), i.save ? (f.setTitle(e(d)), f.setFocus()) : i.isNew ? (f.remove(), f = i.node = null, h.relatedNode.setFocus()) : (f.renderTitle(), f.setFocus()), h.eventData = null, h.currentNode = null, h.relatedNode = null, g.widget._bind(), a(g.$container).focus(), i.input = null, j.close.call(f, { type: "close" }, i), !0);}, a.ui.fancytree._FancytreeNodeClass.prototype.editCreateNode = function (b, c) {var d, e = this;return b = b || "child", null == c ? c = { title: "" } : "string" === typeof c ? c = { title: c } : a.ui.fancytree.assert(a.isPlainObject(c)), "child" !== b || this.isExpanded() || this.hasChildren() === !1 ? (d = this.addNode(c, b), d.makeVisible(), a(d.span).addClass("fancytree-edit-new"), this.tree.ext.edit.relatedNode = this, void d.editStart()) : void this.setExpanded().done(function () {e.editCreateNode(b, c);});}, a.ui.fancytree._FancytreeClass.prototype.isEditing = function () {return this.ext.edit.currentNode;}, a.ui.fancytree._FancytreeNodeClass.prototype.isEditing = function () {return this.tree.ext.edit.currentNode === this;}, a.ui.fancytree.registerExtension({ name: "edit", version: "0.2.0", options: { adjustWidthOfs: 4, allowEmpty: !1, inputCss: { minWidth: "3em" }, triggerCancel: ["esc", "tab", "click"], triggerStart: ["f2", "shift+click", "mac+enter"], trim: !0, beforeClose: a.noop, beforeEdit: a.noop, close: a.noop, edit: a.noop, save: a.noop }, currentNode: null, treeInit: function (a) {this._super(a), this.$container.addClass("fancytree-ext-edit");}, nodeClick: function (b) {return a.inArray("shift+click", b.options.edit.triggerStart) >= 0 && b.originalEvent.shiftKey ? (b.node.editStart(), !1) : this._super(b);}, nodeDblclick: function (b) {return a.inArray("dblclick", b.options.edit.triggerStart) >= 0 ? (b.node.editStart(), !1) : this._super(b);}, nodeKeydown: function (b) {switch (b.originalEvent.which) {case 113:if (a.inArray("f2", b.options.edit.triggerStart) >= 0) return b.node.editStart(), !1;break;case a.ui.keyCode.ENTER:if (a.inArray("mac+enter", b.options.edit.triggerStart) >= 0 && d) return b.node.editStart(), !1;} return this._super(b);} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.filter.min.js' */
  !function (a) {"use strict";function b(a) {return (a + "").replace(/([.?*+\^\$\[\]\\(){}|-])/g, "\\$1");}a.ui.fancytree._FancytreeClass.prototype._applyFilterImpl = function (a, c, d) {var e, f, g = 0, h = "hide" === this.options.filter.mode;return d = !!d && !c, "string" === typeof a && (e = b(a), f = new RegExp(".*" + e + ".*", "i"), a = function (a) {return !!f.exec(a.title);}), this.enableFilter = !0, this.lastFilterArgs = arguments, this.$div.addClass("fancytree-ext-filter"), this.$div.addClass(h ? "fancytree-ext-filter-hide" : "fancytree-ext-filter-dimm"), this.visit(function (a) {delete a.match, delete a.subMatch;}), this.visit(function (b) {return d && null != b.children || !a(b) || (g++, b.match = !0, b.visitParents(function (a) {a.subMatch = !0;}), !c) ? void 0 : (b.visit(function (a) {a.match = !0;}), "skip");}), this.render(), g;}, a.ui.fancytree._FancytreeClass.prototype.filterNodes = function (a, b) {return this._applyFilterImpl(a, !1, b);}, a.ui.fancytree._FancytreeClass.prototype.applyFilter = function () {return this.warn("Fancytree.applyFilter() is deprecated since 2014-05-10. Use .filterNodes() instead."), this.filterNodes.apply(this, arguments);}, a.ui.fancytree._FancytreeClass.prototype.filterBranches = function (a) {return this._applyFilterImpl(a, !0, null);}, a.ui.fancytree._FancytreeClass.prototype.clearFilter = function () {this.visit(function (a) {delete a.match, delete a.subMatch;}), this.enableFilter = !1, this.lastFilterArgs = null, this.$div.removeClass("fancytree-ext-filter fancytree-ext-filter-dimm fancytree-ext-filter-hide"), this.render();}, a.ui.fancytree.registerExtension({ name: "filter", version: "0.3.0", options: { autoApply: !0, mode: "dimm" }, treeInit: function (a) {this._super(a);}, nodeLoadChildren: function (a, b) {return this._super(a, b).done(function () {a.tree.enableFilter && a.tree.lastFilterArgs && a.options.filter.autoApply && a.tree._applyFilterImpl.apply(a.tree, a.tree.lastFilterArgs);});}, nodeRenderStatus: function (b) {var c, d = b.node, e = b.tree, f = a(d[e.statusClassPropName]);return c = this._super(b), f.length && e.enableFilter ? (f.toggleClass("fancytree-match", !!d.match).toggleClass("fancytree-submatch", !!d.subMatch).toggleClass("fancytree-hide", !(d.match || d.subMatch)), c) : c;} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.glyph.min.js' */
  !function (a) {"use strict";function b(a, b) {return a.map[b];}a.ui.fancytree.registerExtension({ name: "glyph", version: "0.2.0", options: { map: { checkbox: "icon-check-empty", checkboxSelected: "icon-check", checkboxUnknown: "icon-check icon-muted", error: "icon-exclamation-sign", expanderClosed: "icon-caret-right", expanderLazy: "icon-angle-right", expanderOpen: "icon-caret-down", doc: "icon-file-alt", noExpander: "", docOpen: "icon-file-alt", loading: "icon-refresh icon-spin", folder: "icon-folder-close-alt", folderOpen: "icon-folder-open-alt" } }, treeInit: function (a) {var b = a.tree;this._super(a), b.$container.addClass("fancytree-ext-glyph");}, nodeRenderStatus: function (c) {var d, e, f = c.node, g = a(f.span), h = c.options.glyph, i = h.map;this._super(c), f.isRoot() || (e = g.children("span.fancytree-expander").get(0), e && (d = f.isLoading() ? "loading" : f.expanded ? "expanderOpen" : f.isUndefined() ? "expanderLazy" : f.hasChildren() ? "expanderClosed" : "noExpander", e.className = "fancytree-expander " + i[d]), e = f.tr ? a("td", f.tr).children("span.fancytree-checkbox").get(0) : g.children("span.fancytree-checkbox").get(0), e && (d = f.selected ? "checkboxSelected" : f.partsel ? "checkboxUnknown" : "checkbox", e.className = "fancytree-checkbox " + i[d]), e = g.children("span.fancytree-icon").get(0), e && (d = f.folder ? f.expanded ? b(h, "folderOpen") : b(h, "folder") : f.expanded ? b(h, "docOpen") : b(h, "doc"), e.className = "fancytree-icon " + d));}, nodeSetStatus: function (c, d, e, f) {var g, h = c.options.glyph, i = c.node;this._super(c, d, e, f), g = i.parent ? a("span.fancytree-expander", i.span).get(0) : a(".fancytree-statusnode-wait, .fancytree-statusnode-error", i[this.nodeContainerAttrName]).find("span.fancytree-expander").get(0), "loading" === d ? g.className = "fancytree-expander " + b(h, "loading") : "error" === d && (g.className = "fancytree-expander " + b(h, "error"));} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.gridnav.min.js' */
  !function (a) {"use strict";function b(b, c) {var d, e = c.get(0), f = 0;return b.children().each(function () {return this === e ? !1 : (d = a(this).prop("colspan"), void(f += d ? d : 1));}), f;} function c(b, c) {var d, e = null, f = 0;return b.children().each(function () {return f >= c ? (e = a(this), !1) : (d = a(this).prop("colspan"), void(f += d ? d : 1));}), e;} function d(a, d) {var f, g, h = a.closest("td"), i = null;switch (d) {case e.LEFT:i = h.prev();break;case e.RIGHT:i = h.next();break;case e.UP:case e.DOWN:for (f = h.parent(), g = b(f, h);;) {if (f = d === e.UP ? f.prev() : f.next(), !f.length) break;if (!f.is(":hidden") && (i = c(f, g), i && i.find(":input").length)) break;}} return i;} var e = a.ui.keyCode, f = { text: [e.UP, e.DOWN], checkbox: [e.UP, e.DOWN, e.LEFT, e.RIGHT], radiobutton: [e.UP, e.DOWN, e.LEFT, e.RIGHT], "select-one": [e.LEFT, e.RIGHT], "select-multiple": [e.LEFT, e.RIGHT] };a.ui.fancytree.registerExtension({ name: "gridnav", version: "0.0.1", options: { autofocusInput: !1, handleCursorKeys: !0 }, treeInit: function (b) {this._requireExtension("table", !0, !0), this._super(b), this.$container.addClass("fancytree-ext-gridnav"), this.$container.on("focusin", function (c) {var d, e = a.ui.fancytree.getNode(c.target);e && !e.isActive() && (d = b.tree._makeHookContext(e, c), b.tree._callHook("nodeSetActive", d, !0));});}, nodeSetActive: function (b, c) {var d, e = b.options.gridnav, f = b.node, g = b.originalEvent || {}, h = a(g.target).is(":input");c = c !== !1, this._super(b, c), c && (b.options.titlesTabbable ? (h || (a(f.span).find("span.fancytree-title").focus(), f.setFocus()), b.tree.$container.attr("tabindex", "-1")) : e.autofocusInput && !h && (d = a(f.tr || f.span), d.find(":input:enabled:first").focus()));}, nodeKeydown: function (b) {var c, e, g, h = b.options.gridnav, i = b.originalEvent, j = a(i.target);return c = j.is(":input:enabled") ? j.prop("type") : null, c && h.handleCursorKeys ? (e = f[c], e && a.inArray(i.which, e) >= 0 && (g = d(j, i.which), g && g.length) ? (g.find(":input:enabled").focus(), !1) : !0) : (b.tree.debug("ext-gridnav NOT HANDLED", i, c), this._super(b));} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.persist.min.js' */
  !function (a, b, c, d) {"use strict";function e(b, c, d, f, g) {var i, j, k, l, m = !1, n = [], o = [];for (d = d || [], g = g || a.Deferred(), i = 0, k = d.length;k > i;i++)j = d[i], l = b.getNodeByKey(j), l ? f && l.isUndefined() ? (m = !0, b.debug("_loadLazyNodes: " + l + " is lazy: loading..."), n.push("expand" === f ? l.setExpanded() : l.load())) : (b.debug("_loadLazyNodes: " + l + " already loaded."), l.setExpanded()) : (o.push(j), b.debug("_loadLazyNodes: " + l + " was not yet found."));return a.when.apply(a, n).always(function () {if (m && o.length > 0)e(b, c, o, f, g);else {if (o.length) for (b.warn("_loadLazyNodes: could not load those keys: ", o), i = 0, k = o.length;k > i;i++)j = d[i], c._appendKey(h, d[i], !1);g.resolve();}}), g;} var f = a.ui.fancytree.assert, g = "active", h = "expanded", i = "focus", j = "selected";a.ui.fancytree._FancytreeClass.prototype.clearCookies = function (a) {var b = this.ext.persist, c = b.cookiePrefix;a = a || "active expanded focus selected", a.indexOf(g) >= 0 && b._data(c + g, null), a.indexOf(h) >= 0 && b._data(c + h, null), a.indexOf(i) >= 0 && b._data(c + i, null), a.indexOf(j) >= 0 && b._data(c + j, null);}, a.ui.fancytree._FancytreeClass.prototype.getPersistData = function () {var a = this.ext.persist, b = a.cookiePrefix, c = a.cookieDelimiter, d = {};return d[g] = a._data(b + g), d[h] = (a._data(b + h) || "").split(c), d[j] = (a._data(b + j) || "").split(c), d[i] = a._data(b + i), d;}, a.ui.fancytree.registerExtension({ name: "persist", version: "0.3.0", options: { cookieDelimiter: "~", cookiePrefix: d, cookie: { raw: !1, expires: "", path: "", domain: "", secure: !1 }, expandLazy: !1, overrideSource: !0, store: "auto", types: "active expanded focus selected" }, _data: function (b, c) {var e = this._local.localStorage;return c === d ? e ? e.getItem(b) : a.cookie(b) : void(null === c ? e ? e.removeItem(b) : a.removeCookie(b) : e ? e.setItem(b, c) : a.cookie(b, c, this.options.persist.cookie));}, _appendKey: function (b, c, d) {c = "" + c;var e = this._local, f = this.options.persist, g = f.cookieDelimiter, h = e.cookiePrefix + b, i = e._data(h), j = i ? i.split(g) : [], k = a.inArray(c, j);k >= 0 && j.splice(k, 1), d && j.push(c), e._data(h, j.join(g));}, treeInit: function (c) {var k = c.tree, l = c.options, m = this._local, n = this.options.persist;return f("localStore" === n.store || a.cookie, "Missing required plugin for 'persist' extension: jquery.cookie.js"), m.cookiePrefix = n.cookiePrefix || "fancytree-" + k._id + "-", m.storeActive = n.types.indexOf(g) >= 0, m.storeExpanded = n.types.indexOf(h) >= 0, m.storeSelected = n.types.indexOf(j) >= 0, m.storeFocus = n.types.indexOf(i) >= 0, m.localStorage = "cookie" !== n.store && b.localStorage ? "local" === n.store ? b.localStorage : b.sessionStorage : null, k.$div.bind("fancytreeinit", function () {var b, c, f, o, p, q = a.cookie(m.cookiePrefix + i);b = m._data(m.cookiePrefix + h), o = b && b.split(n.cookieDelimiter), c = m.storeExpanded ? e(k, m, o, n.expandLazy ? "expand" : !1, null) : (new a.Deferred).resolve(), c.done(function () {if (m.storeSelected) {if (b = m._data(m.cookiePrefix + j)) for (o = b.split(n.cookieDelimiter), f = 0;f < o.length;f++)p = k.getNodeByKey(o[f]), p ? (p.selected === d || n.overrideSource && p.selected === !1) && (p.selected = !0, p.renderStatus()) : m._appendKey(j, o[f], !1);3 === k.options.selectMode && k.visit(function (a) {return a.selected ? (a.fixSelection3AfterClick(), "skip") : void 0;});}m.storeActive && (b = m._data(m.cookiePrefix + g), !b || !l.persist.overrideSource && k.activeNode || (p = k.getNodeByKey(b), p && p.setActive())), m.storeFocus && q && (p = k.getNodeByKey(q), p && p.setFocus()), k._triggerTreeEvent("restore", null, {});});}), this._super(c);}, nodeSetActive: function (a, b, c) {var d, e = this._local;return b = b !== !1, d = this._super(a, b, c), e.storeActive && e._data(e.cookiePrefix + g, this.activeNode ? this.activeNode.key : null), d;}, nodeSetExpanded: function (a, b, c) {var d, e = a.node, f = this._local;return b = b !== !1, d = this._super(a, b, c), f.storeExpanded && f._appendKey(h, e.key, b), d;}, nodeSetFocus: function (a, b) {var c, d = this._local;return b = b !== !1, c = this._super(a, b), b && d.storeFocus && d._data(d.cookiePrefix + i, this.focusNode ? this.focusNode.key : null), c;}, nodeSetSelected: function (b, c) {var d, e, f = b.tree, g = b.node, h = this._local;return c = c !== !1, d = this._super(b, c), h.storeSelected && (3 === f.options.selectMode ? (e = a.map(f.getSelectedNodes(!0), function (a) {return a.key;}), e = e.join(b.options.persist.cookieDelimiter), h._data(h.cookiePrefix + j, e)) : h._appendKey(j, g.key, c)), d;} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.table.min.js' */
  !function (a, b, c) {"use strict";function d(b, c) {c = c || "", b || a.error("Assertion failed " + c);} function e(a, b) {a.parentNode.insertBefore(b, a.nextSibling);} function f(a, b) {a.visit(function (a) {var c = a.tr;return c && (c.style.display = a.hide || !b ? "none" : ""), a.expanded ? void 0 : "skip";});} function g(b) {var c, e, f, g = b.parent, h = g ? g.children : null;if (h && h.length > 1 && h[0] !== b) for (c = a.inArray(b, h), f = h[c - 1], d(f.tr);f.children && (e = f.children[f.children.length - 1], e.tr);)f = e;else f = g;return f;}a.ui.fancytree.registerExtension({ name: "table", version: "0.2.0", options: { checkboxColumnIdx: null, customStatus: !1, indentation: 16, nodeColumnIdx: 0 }, treeInit: function (b) {var d, e, f, g = b.tree, h = g.widget.element;for (h.addClass("fancytree-container fancytree-ext-table"), g.tbody = h.find("> tbody")[0], g.columnCount = a("thead >tr >th", h).length, a(g.tbody).empty(), g.rowFragment = c.createDocumentFragment(), e = a("<tr />"), f = "", b.options.aria && (e.attr("role", "row"), f = " role='gridcell'"), d = 0;d < g.columnCount;d++)e.append(b.options.table.nodeColumnIdx === d ? "<td" + f + "><span class='fancytree-node' /></td>" : "<td" + f + " />");g.rowFragment.appendChild(e.get(0)), g.statusClassPropName = "tr", g.ariaPropName = "tr", this.nodeContainerAttrName = "tr", this._super(b), a(g.rootNode.ul).remove(), g.rootNode.ul = null, g.$container = h, this.$container.attr("tabindex", this.options.tabbable ? "0" : "-1"), this.options.aria && g.$container.attr("role", "treegrid").attr("aria-readonly", !0);}, nodeRemoveChildMarkup: function (b) {var c = b.node;c.visit(function (b) {b.tr && (a(b.tr).remove(), b.tr = null);});}, nodeRemoveMarkup: function (b) {var c = b.node;c.tr && (a(c.tr).remove(), c.tr = null), this.nodeRemoveChildMarkup(b);}, nodeRender: function (b, c, h, i, j) {var k, l, m, n, o, p, q, r, s = b.tree, t = b.node, u = b.options, v = !t.parent;if (j || (b.hasCollapsedParents = t.parent && !t.parent.expanded), !v) if (t.tr)c ? this.nodeRenderTitle(b) : this.nodeRenderStatus(b);else {if (b.hasCollapsedParents) return void t.debug("nodeRender ignored due to unrendered parent");o = s.rowFragment.firstChild.cloneNode(!0), p = g(t), d(p), i === !0 && j ? o.style.display = "none" : h && b.hasCollapsedParents && (o.style.display = "none"), p.tr ? e(p.tr, o) : (d(!p.parent, "prev. row must have a tr, or is system root"), s.tbody.appendChild(o)), t.tr = o, t.key && u.generateIds && (t.tr.id = u.idPrefix + t.key), t.tr.ftnode = t, u.aria && a(t.tr).attr("aria-labelledby", "ftal_" + t.key), t.span = a("span.fancytree-node", t.tr).get(0), this.nodeRenderTitle(b), u.createNode && u.createNode.call(s, { type: "createNode" }, b);} if (u.renderNode && u.renderNode.call(s, { type: "renderNode" }, b), k = t.children, k && (v || h || t.expanded)) for (m = 0, n = k.length;n > m;m++)r = a.extend({}, b, { node: k[m] }), r.hasCollapsedParents = r.hasCollapsedParents || !t.expanded, this.nodeRender(r, c, h, i, !0);k && !j && (q = t.tr || null, l = s.tbody.firstChild, t.visit(function (a) {if (a.tr) {if (a.parent.expanded || "none" === a.tr.style.display || (a.tr.style.display = "none", f(a, !1)), a.tr.previousSibling !== q) {t.debug("_fixOrder: mismatch at node: " + a);var b = q ? q.nextSibling : l;s.tbody.insertBefore(a.tr, b);}q = a.tr;}}));}, nodeRenderTitle: function (b) {var c, d = b.node, e = b.options;this._super(b), e.checkbox && null != e.table.checkboxColumnIdx && (c = a("span.fancytree-checkbox", d.span).detach(), a(d.tr).find("td:first").html(c)), d.isRoot() || this.nodeRenderStatus(b), !e.table.customStatus && d.isStatusNode() || e.renderColumns && e.renderColumns.call(b.tree, { type: "renderColumns" }, b);}, nodeRenderStatus: function (b) {var c, d = b.node, e = b.options;this._super(b), a(d.tr).removeClass("fancytree-node"), c = (d.getLevel() - 1) * e.table.indentation, a(d.span).css({ marginLeft: c + "px" });}, nodeSetExpanded: function (b, c, d) {function e(a) {c = c !== !1, f(b.node, c), a ? c && b.options.autoScroll && !d.noAnimation && b.node.hasChildren() ? b.node.getLastChild().scrollIntoView(!0, { topNode: b.node }).always(function () {d.noEvents || b.tree._triggerNodeEvent(c ? "expand" : "collapse", b), g.resolveWith(b.node);}) : (d.noEvents || b.tree._triggerNodeEvent(c ? "expand" : "collapse", b), g.resolveWith(b.node)) : (d.noEvents || b.tree._triggerNodeEvent(c ? "expand" : "collapse", b), g.rejectWith(b.node));} var g = new a.Deferred, h = a.extend({}, d, { noEvents: !0, noAnimation: !0 });return d = d || {}, this._super(b, c, h).done(function () {e(!0);}).fail(function () {e(!1);}), g.promise();}, nodeSetStatus: function (b, c, d, e) {if ("ok" === c) {var f = b.node, g = f.children ? f.children[0] : null;g && g.isStatusNode() && a(g.tr).remove();} this._super(b, c, d, e);}, treeClear: function (a) {return this.nodeRemoveChildMarkup(this._makeHookContext(this.rootNode)), this._super(a);} });}(jQuery, window, document);

  /* ! Extension 'jquery.fancytree.themeroller.min.js' */
  !function (a) {"use strict";a.ui.fancytree.registerExtension({ name: "themeroller", version: "0.0.1", options: { activeClass: "ui-state-active", foccusClass: "ui-state-focus", hoverClass: "ui-state-hover", selectedClass: "ui-state-highlight" }, treeInit: function (b) {this._super(b);var c = b.widget.element;"TABLE" === c[0].nodeName ? (c.addClass("ui-widget ui-corner-all"), c.find(">thead tr").addClass("ui-widget-header"), c.find(">tbody").addClass("ui-widget-conent")) : c.addClass("ui-widget ui-widget-content ui-corner-all"), c.delegate(".fancytree-node", "mouseenter mouseleave", function (b) {var c = a.ui.fancytree.getNode(b.target), d = "mouseenter" === b.type;c.debug("hover: " + d), a(c.span).toggleClass("ui-state-hover ui-corner-all", d);});}, treeDestroy: function (a) {this._super(a), a.widget.element.removeClass("ui-widget ui-widget-content ui-corner-all");}, nodeRenderStatus: function (b) {var c = b.node, d = a(c.span);this._super(b), d.toggleClass("ui-state-active", c.isActive()), d.toggleClass("ui-state-focus", c.hasFocus()), d.toggleClass("ui-state-highlight", c.isSelected());} });}(jQuery, window, document);
}));

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports) {
  module.exports = "treeControl";
}
(function (angular) {
  "use strict";

  function createPath(startScope) {
    return function path() {
      var _path = [];
      var scope = startScope;
      var prevNode;
      while (scope && scope.node !== startScope.synteticRoot) {
        if (prevNode !== scope.node)
          _path.push(scope.node);
        prevNode = scope.node;
        scope = scope.$parent;
      }
      return _path;
    };
  }

  function ensureDefault(obj, prop, value) {
    if (!obj.hasOwnProperty(prop))
      obj[prop] = value;
  }

  function defaultIsLeaf(node, $scope) {
    return !node[$scope.options.nodeChildren] || node[$scope.options.nodeChildren].length === 0;
  }

  function shallowCopy(src, dst) {
    if (angular.isArray(src)) {
      dst = dst || [];

      for (var i = 0; i < src.length; i++) {
        dst[i] = src[i];
      }
    } else if (angular.isObject(src)) {
      dst = dst || {};

      for (var key in src) {
        if (hasOwnProperty.call(src, key) && !(key.charAt(0) === "$" && key.charAt(1) === "$")) {
          dst[key] = src[key];
        }
      }
    }

    return dst || src;
  }

  function defaultEquality(a, b, $scope) {
    if (!a || !b)
      return false;
    a = shallowCopy(a);
    a[$scope.options.nodeChildren] = [];
    b = shallowCopy(b);
    b[$scope.options.nodeChildren] = [];
    return angular.equals(a, b);
  }

  function defaultIsSelectable() {
    return true;
  }

  function ensureAllDefaultOptions($scope) {
    ensureDefault($scope.options, "multiSelection", false);
    ensureDefault($scope.options, "nodeChildren", "children");
    ensureDefault($scope.options, "dirSelectable", "true");
    ensureDefault($scope.options, "injectClasses", {});
    ensureDefault($scope.options.injectClasses, "ul", "");
    ensureDefault($scope.options.injectClasses, "li", "");
    ensureDefault($scope.options.injectClasses, "liSelected", "");
    ensureDefault($scope.options.injectClasses, "iExpanded", "");
    ensureDefault($scope.options.injectClasses, "iCollapsed", "");
    ensureDefault($scope.options.injectClasses, "iLeaf", "");
    ensureDefault($scope.options.injectClasses, "label", "");
    ensureDefault($scope.options.injectClasses, "labelSelected", "");
    ensureDefault($scope.options, "equality", defaultEquality);
    ensureDefault($scope.options, "isLeaf", defaultIsLeaf);
    ensureDefault($scope.options, "allowDeselect", true);
    ensureDefault($scope.options, "isSelectable", defaultIsSelectable);
  }

  angular.module("treeControl", [])
    .constant("treeConfig", {
      templateUrl: null
    })
    .directive("treecontrol", ["$compile", function ($compile) {
      /**
       * @param cssClass - the css class
       * @param addClassProperty - should we wrap the class name with class=""
       */
      function classIfDefined(cssClass, addClassProperty) {
        if (cssClass) {
          if (addClassProperty)
            return "class=\"" + cssClass + "\"";
          else
            return cssClass;
        }
        else
          return "";
      }

      return {
        restrict: "EA",
        require: "treecontrol",
        transclude: true,
        scope: {
          treeModel: "=",
          selectedNode: "=?",
          selectedNodes: "=?",
          expandedNodes: "=?",
          onSelection: "&",
          onNodeToggle: "&",
          options: "=?",
          orderBy: "=?",
          reverseOrder: "@",
          filterExpression: "=?",
          filterComparator: "=?"
        },
        controller: ["$scope", "$templateCache", "$interpolate", "treeConfig", function ($scope, $templateCache, $interpolate, treeConfig) {

          $scope.options = $scope.options || {};

          ensureAllDefaultOptions($scope);

          $scope.selectedNodes = $scope.selectedNodes || [];
          $scope.expandedNodes = $scope.expandedNodes || [];
          $scope.expandedNodesMap = {};
          for (var i = 0; i < $scope.expandedNodes.length; i++) {
            $scope.expandedNodesMap["a" + i] = $scope.expandedNodes[i];
          }
          $scope.parentScopeOfTree = $scope.$parent;

          function isSelectedNode(node) {
            if (!$scope.options.multiSelection && ($scope.options.equality(node, $scope.selectedNode, $scope)))
              return true;
            else if ($scope.options.multiSelection && $scope.selectedNodes) {
              for (var i = 0; (i < $scope.selectedNodes.length); i++) {
                if ($scope.options.equality(node, $scope.selectedNodes[i], $scope)) {
                  return true;
                }
              }
              return false;
            }
          }

          $scope.headClass = function (node) {
            var liSelectionClass = classIfDefined($scope.options.injectClasses.liSelected, false);
            var injectSelectionClass = "";
            if (liSelectionClass && isSelectedNode(node))
              injectSelectionClass = " " + liSelectionClass;
            if ($scope.options.isLeaf(node, $scope))
              return "tree-leaf" + injectSelectionClass;
            if ($scope.expandedNodesMap[this.$id])
              return "tree-expanded" + injectSelectionClass;
            else
              return "tree-collapsed" + injectSelectionClass;
          };

          $scope.iBranchClass = function () {
            if ($scope.expandedNodesMap[this.$id])
              return classIfDefined($scope.options.injectClasses.iExpanded);
            else
              return classIfDefined($scope.options.injectClasses.iCollapsed);
          };

          $scope.nodeExpanded = function () {
            return !!$scope.expandedNodesMap[this.$id];
          };

          $scope.selectNodeHead = function () {
            var transcludedScope = this;
            var expanding = $scope.expandedNodesMap[transcludedScope.$id] === undefined;
            $scope.expandedNodesMap[transcludedScope.$id] = (expanding ? transcludedScope.node : undefined);
            if (expanding) {
              $scope.expandedNodes.push(transcludedScope.node);
            }
            else {
              var index;
              for (var i = 0; (i < $scope.expandedNodes.length) && !index; i++) {
                if ($scope.options.equality($scope.expandedNodes[i], transcludedScope.node, $scope)) {
                  index = i;
                }
              }
              if (index !== undefined)
                $scope.expandedNodes.splice(index, 1);
            }
            if ($scope.onNodeToggle) {
              var parentNode = (transcludedScope.$parent.node === transcludedScope.synteticRoot) ? null : transcludedScope.$parent.node;
              var path = createPath(transcludedScope);
              $scope.onNodeToggle({
                node: transcludedScope.node,
                $parentNode: parentNode,
                $path: path,
                $index: transcludedScope.$index,
                $first: transcludedScope.$first,
                $middle: transcludedScope.$middle,
                $last: transcludedScope.$last,
                $odd: transcludedScope.$odd,
                $even: transcludedScope.$even,
                expanded: expanding
              });

            }
          };

          $scope.options.treeScope = $scope;

          $scope.selectNodeLabel = function (selectedNode) {
            var transcludedScope = this;
            if (!$scope.options.isLeaf(selectedNode, $scope) && (!$scope.options.dirSelectable || !$scope.options.isSelectable(selectedNode))) {
              // Branch node is not selectable, expand
              this.selectNodeHead();
            }
            else if ($scope.options.isLeaf(selectedNode, $scope) && (!$scope.options.isSelectable(selectedNode))) {
              // Leaf node is not selectable
              return;
            }
            else {
              var selected = false;
              if ($scope.options.multiSelection) {
                var pos = -1;
                for (var i = 0; i < $scope.selectedNodes.length; i++) {
                  if ($scope.options.equality(selectedNode, $scope.selectedNodes[i], $scope)) {
                    pos = i;
                    break;
                  }
                }
                if (pos === -1) {
                  $scope.selectedNodes.push(selectedNode);
                  selected = true;
                } else {
                  $scope.selectedNodes.splice(pos, 1);
                }
              } else {
                if (!$scope.options.equality(selectedNode, $scope.selectedNode, $scope)) {
                  $scope.selectedNode = selectedNode;
                  selected = true;
                }
                else {
                  if ($scope.options.allowDeselect) {
                    $scope.selectedNode = undefined;
                  } else {
                    $scope.selectedNode = selectedNode;
                    selected = true;
                  }
                }
              }
              if ($scope.onSelection) {
                var parentNode = (transcludedScope.$parent.node === transcludedScope.synteticRoot) ? null : transcludedScope.$parent.node;
                var path = createPath(transcludedScope);
                $scope.onSelection({
                  node: selectedNode, selected: selected, $parentNode: parentNode, $path: path,
                  $index: transcludedScope.$index, $first: transcludedScope.$first, $middle: transcludedScope.$middle,
                  $last: transcludedScope.$last, $odd: transcludedScope.$odd, $even: transcludedScope.$even
                });
              }
            }
          };

          $scope.selectedClass = function () {
            var isThisNodeSelected = isSelectedNode(this.node);
            var labelSelectionClass = classIfDefined($scope.options.injectClasses.labelSelected, false);
            var injectSelectionClass = "";
            if (labelSelectionClass && isThisNodeSelected)
              injectSelectionClass = " " + labelSelectionClass;

            return isThisNodeSelected ? "tree-selected" + injectSelectionClass : "";
          };

          $scope.unselectableClass = function () {
            var isThisNodeUnselectable = !$scope.options.isSelectable(this.node);
            var labelUnselectableClass = classIfDefined($scope.options.injectClasses.labelUnselectable, false);
            return isThisNodeUnselectable ? "tree-unselectable " + labelUnselectableClass : "";
          };

          // tree template
          $scope.isReverse = function () {
            return !($scope.reverseOrder === "false" || $scope.reverseOrder === "False" || $scope.reverseOrder === "" || $scope.reverseOrder === false);
          };

          $scope.orderByFunc = function () {
            return $scope.orderBy;
          };
          //                    return "" + $scope.orderBy;

          var templateOptions = {
            orderBy: $scope.orderBy ? " | orderBy:orderByFunc():isReverse()" : "",
            ulClass: classIfDefined($scope.options.injectClasses.ul, true),
            nodeChildren: $scope.options.nodeChildren,
            liClass: classIfDefined($scope.options.injectClasses.li, true),
            iLeafClass: classIfDefined($scope.options.injectClasses.iLeaf, false),
            labelClass: classIfDefined($scope.options.injectClasses.label, false)
          };

          var template;
          var templateUrl = $scope.options.templateUrl || treeConfig.templateUrl;

          if (templateUrl) {
            template = $templateCache.get(templateUrl);
          }

          if (!template) { // {{options.nodeChildren}}

            template =
              "<ul {{options.ulClass}} >" +
              "<li ng-repeat=\"node in node.{{options.nodeChildren}} | filter:filterExpression:filterComparator {{options.orderBy}}\" ng-class=\"headClass(node)\" {{options.liClass}}" +
              "set-node-to-data>" +
              "<i class=\"tree-branch-head\" ng-class=\"iBranchClass()\" ng-click=\"selectNodeHead(node)\"></i>" +
              "<i class=\"tree-leaf-head {{options.iLeafClass}}\"></i>" +
              "<div class=\"tree-label {{options.labelClass}}\" ng-class=\"[selectedClass(), unselectableClass()]\" ng-click=\"selectNodeLabel(node)\" tree-transclude></div>" +
              "<treeitem ng-if=\"nodeExpanded()\"></treeitem>" +
              "</li>" +
              "</ul>";
          }

          this.template = $compile($interpolate(template)({ options: templateOptions }));

        }],
        compile: function (element, attrs, childTranscludeFn) {
          return function (scope, element, attrs, treemodelCntr) {

            scope.$watch("treeModel", function updateNodeOnRootScope(newValue) {
              if (angular.isArray(newValue)) {
                if (angular.isDefined(scope.node) && angular.equals(scope.node[scope.options.nodeChildren], newValue))
                  return;
                scope.node = {};
                scope.synteticRoot = scope.node;
                scope.node[scope.options.nodeChildren] = newValue;
              }
              else {
                if (angular.equals(scope.node, newValue))
                  return;
                scope.node = newValue;
              }
            });

            scope.$watchCollection("expandedNodes", function (newValue, oldValue) {
              var notFoundIds = 0;
              var newExpandedNodesMap = {};
              var $liElements = element.find("li");
              var existingScopes = [];
              // find all nodes visible on the tree and the scope $id of the scopes including them
              angular.forEach($liElements, function (liElement) {
                var $liElement = angular.element(liElement);
                var liScope = {
                  $id: $liElement.data("scope-id"),
                  node: $liElement.data("node")
                };
                existingScopes.push(liScope);
              });
              // iterate over the newValue, the new expanded nodes, and for each find it in the existingNodesAndScopes
              // if found, add the mapping $id -> node into newExpandedNodesMap
              // if not found, add the mapping num -> node into newExpandedNodesMap
              angular.forEach(newValue, function (newExNode) {
                var found = false;
                for (var i = 0; (i < existingScopes.length) && !found; i++) {
                  var existingScope = existingScopes[i];
                  if (scope.options.equality(newExNode, existingScope.node, scope)) {
                    newExpandedNodesMap[existingScope.$id] = existingScope.node;
                    found = true;
                  }
                }
                if (!found)
                  newExpandedNodesMap["a" + notFoundIds++] = newExNode;
              });
              scope.expandedNodesMap = newExpandedNodesMap;
            });

            //                        scope.$watch('expandedNodesMap', function(newValue) {
            //
            //                        });

            // Rendering template for a root node
            treemodelCntr.template(scope, function (clone) {
              element.html("").append(clone);
            });
            // save the transclude function from compile (which is not bound to a scope as apposed to the one from link)
            // we can fix this to work with the link transclude function with angular 1.2.6. as for angular 1.2.0 we need
            // to keep using the compile function
            scope.$treeTransclude = childTranscludeFn;
          };
        }
      };
    }])
    .directive("setNodeToData", ["$parse", function ($parse) {
      return {
        restrict: "A",
        link: function ($scope, $element, $attrs) {
          $element.data("node", $scope.node);
          $element.data("scope-id", $scope.$id);
        }
      };
    }])
    .directive("treeitem", function () {
      return {
        restrict: "E",
        require: "^treecontrol",
        link: function (scope, element, attrs, treemodelCntr) {
          // Rendering template for the current node
          treemodelCntr.template(scope, function (clone) {
            element.html("").append(clone);
          });
        }
      };
    })
    .directive("treeTransclude", function () {
      return {
        controller: ["$scope", function ($scope) {
          ensureAllDefaultOptions($scope);
        }],

        link: function (scope, element, attrs, controller) {
          if (!scope.options.isLeaf(scope.node, scope)) {
            angular.forEach(scope.expandedNodesMap, function (node, id) {
              if (scope.options.equality(node, scope.node, scope)) {
                scope.expandedNodesMap[scope.$id] = scope.node;
                scope.expandedNodesMap[id] = undefined;
              }
            });
          }
          if (!scope.options.multiSelection && scope.options.equality(scope.node, scope.selectedNode, scope)) {
            scope.selectedNode = scope.node;
          } else if (scope.options.multiSelection) {
            var newSelectedNodes = [];
            for (var i = 0; (i < scope.selectedNodes.length); i++) {
              if (scope.options.equality(scope.node, scope.selectedNodes[i], scope)) {
                newSelectedNodes.push(scope.node);
              }
            }
            scope.selectedNodes = newSelectedNodes;
          }

          // create a scope for the transclusion, whos parent is the parent of the tree control
          scope.transcludeScope = scope.parentScopeOfTree.$new();
          scope.transcludeScope.node = scope.node;
          scope.transcludeScope.$path = createPath(scope);
          scope.transcludeScope.$parentNode = (scope.$parent.node === scope.synteticRoot) ? null : scope.$parent.node;
          scope.transcludeScope.$index = scope.$index;
          scope.transcludeScope.$first = scope.$first;
          scope.transcludeScope.$middle = scope.$middle;
          scope.transcludeScope.$last = scope.$last;
          scope.transcludeScope.$odd = scope.$odd;
          scope.transcludeScope.$even = scope.$even;
          scope.$on("$destroy", function () {
            scope.transcludeScope.$destroy();
          });

          scope.$treeTransclude(scope.transcludeScope, function (clone) {
            element.empty();
            element.append(clone);
          });
        }
      };
    });
})(angular);

angular.module("gettext", []);

angular.module("gettext").constant("gettext", function (str) {
  /*
     * Does nothing, simply returns the input string.
     *
     * This function serves as a marker for `grunt-angular-gettext` to know that
     * this string should be extracted for translations.
     */
  return str;
});

angular.module("gettext").factory("gettextCatalog", ["gettextPlurals", "$http", "$cacheFactory", "$interpolate", "$rootScope", function (gettextPlurals, $http, $cacheFactory, $interpolate, $rootScope) {
  var catalog;
  var noContext = "$$noContext";

  // IE8 returns UPPER CASE tags, even though the source is lower case.
  // This can causes the (key) string in the DOM to have a different case to
  // the string in the `po` files.
  // IE9, IE10 and IE11 reorders the attributes of tags.
  var test = "<span id=\"test\" title=\"test\" class=\"tested\">test</span>";
  var isHTMLModified = (angular.element("<span>" + test + "</span>").html() !== test);

  var prefixDebug = function (string) {
    if (catalog.debug && catalog.currentLanguage !== catalog.baseLanguage) {
      return catalog.debugPrefix + string;
    } else {
      return string;
    }
  };

  var addTranslatedMarkers = function (string) {
    if (catalog.showTranslatedMarkers) {
      return catalog.translatedMarkerPrefix + string + catalog.translatedMarkerSuffix;
    } else {
      return string;
    }
  };

  function broadcastUpdated() {
    $rootScope.$broadcast("gettextLanguageChanged");
  }

  catalog = {
    debug: false,
    debugPrefix: "[MISSING]: ",
    showTranslatedMarkers: false,
    translatedMarkerPrefix: "[",
    translatedMarkerSuffix: "]",
    strings: {},
    baseLanguage: "en",
    currentLanguage: "en",
    cache: $cacheFactory("strings"),

    setCurrentLanguage: function (lang) {
      this.currentLanguage = lang;
      broadcastUpdated();
    },

    getCurrentLanguage: function () {
      return this.currentLanguage;
    },

    setStrings: function (language, strings) {
      if (!this.strings[language]) {
        this.strings[language] = {};
      }

      for (var key in strings) {
        var val = strings[key];

        if (isHTMLModified) {
          // Use the DOM engine to render any HTML in the key (#131).
          key = angular.element("<span>" + key + "</span>").html();
        }

        if (angular.isString(val) || angular.isArray(val)) {
          // No context, wrap it in $$noContext.
          var obj = {};
          obj[noContext] = val;
          val = obj;
        }

        // Expand single strings for each context.
        for (var context in val) {
          var str = val[context];
          val[context] = angular.isArray(str) ? str : [str];
        }
        this.strings[language][key] = val;
      }

      broadcastUpdated();
    },

    getStringForm: function (string, n, context) {
      var stringTable = this.strings[this.currentLanguage] || {};
      var contexts = stringTable[string] || {};
      var plurals = contexts[context || noContext] || [];
      return plurals[n];
    },

    getString: function (string, scope, context) {
      string = this.getStringForm(string, 0, context) || prefixDebug(string);
      string = scope ? $interpolate(string)(scope) : string;
      return addTranslatedMarkers(string);
    },

    getPlural: function (n, string, stringPlural, scope, context) {
      var form = gettextPlurals(this.currentLanguage, n);
      string = this.getStringForm(string, form, context) || prefixDebug(n === 1 ? string : stringPlural);
      if (scope) {
        scope.$count = n;
        string = $interpolate(string)(scope);
      }
      return addTranslatedMarkers(string);
    },

    loadRemote: function (url) {
      return $http({
        method: "GET",
        url: url,
        cache: catalog.cache
      }).success(function (data) {
        for (var lang in data) {
          catalog.setStrings(lang, data[lang]);
        }
      });
    }
  };

  return catalog;
}]);

angular.module("gettext").directive("translate", ["gettextCatalog", "$parse", "$animate", "$compile", "$window", function (gettextCatalog, $parse, $animate, $compile, $window) {
  // Trim polyfill for old browsers (instead of jQuery)
  // Based on AngularJS-v1.2.2 (angular.js#620)
  var trim = (function () {
    if (!String.prototype.trim) {
      return function (value) {
        return (typeof value === "string") ? value.replace(/^\s*/, "").replace(/\s*$/, "") : value;
      };
    }
    return function (value) {
      return (typeof value === "string") ? value.trim() : value;
    };
  })();

  function assert(condition, missing, found) {
    if (!condition) {
      throw new Error("You should add a " + missing + " attribute whenever you add a " + found + " attribute.");
    }
  }

  var msie = parseInt((/msie (\d+)/.exec(angular.lowercase($window.navigator.userAgent)) || [])[1], 10);

  return {
    restrict: "AE",
    terminal: true,
    compile: function compile(element, attrs) {
      // Validate attributes
      assert(!attrs.translatePlural || attrs.translateN, "translate-n", "translate-plural");
      assert(!attrs.translateN || attrs.translatePlural, "translate-plural", "translate-n");

      var msgid = trim(element.html());
      var translatePlural = attrs.translatePlural;
      var translateContext = attrs.translateContext;

      if (msie <= 8) {
        // Workaround fix relating to angular adding a comment node to
        // anchors. angular/angular.js/#1949 / angular/angular.js/#2013
        if (msgid.slice(-13) === "<!--IE fix-->") {
          msgid = msgid.slice(0, -13);
        }
      }

      return {
        post: function (scope, element, attrs) {
          var countFn = $parse(attrs.translateN);
          var pluralScope = null;

          function update() {
            // Fetch correct translated string.
            var translated;
            if (translatePlural) {
              scope = pluralScope || (pluralScope = scope.$new());
              scope.$count = countFn(scope);
              translated = gettextCatalog.getPlural(scope.$count, msgid, translatePlural, null, translateContext);
            } else {
              translated = gettextCatalog.getString(msgid, null, translateContext);
            }

            // Swap in the translation
            var newWrapper = angular.element("<span>" + translated + "</span>");
            $compile(newWrapper.contents())(scope);
            var oldContents = element.contents();
            var newContents = newWrapper.contents();
            $animate.enter(newContents, element);
            $animate.leave(oldContents);
          }

          if (attrs.translateN) {
            scope.$watch(attrs.translateN, update);
          }

          scope.$on("gettextLanguageChanged", update);

          update();
        }
      };
    }
  };
}]);

angular.module("gettext").filter("translate", ["gettextCatalog", function (gettextCatalog) {
  function filter(input, context) {
    return gettextCatalog.getString(input, null, context);
  }
  filter.$stateful = true;
  return filter;
}]);

// Do not edit this file, it is autogenerated using genplurals.py!
angular.module("gettext").factory("gettextPlurals", function () {
  return function (langCode, n) {
    switch (langCode) {
      case "ay": // Aymará
      case "bo": // Tibetan
      case "cgg": // Chiga
      case "dz": // Dzongkha
      case "fa": // Persian
      case "id": // Indonesian
      case "ja": // Japanese
      case "jbo": // Lojban
      case "ka": // Georgian
      case "kk": // Kazakh
      case "km": // Khmer
      case "ko": // Korean
      case "ky": // Kyrgyz
      case "lo": // Lao
      case "ms": // Malay
      case "my": // Burmese
      case "sah": // Yakut
      case "su": // Sundanese
      case "th": // Thai
      case "tt": // Tatar
      case "ug": // Uyghur
      case "vi": // Vietnamese
      case "wo": // Wolof
      case "zh": // Chinese
        // 1 form
        return 0;
      case "is": // Icelandic
        // 2 forms
        return (n % 10 != 1 || n % 100 == 11) ? 1 : 0;
      case "jv": // Javanese
        // 2 forms
        return n != 0 ? 1 : 0;
      case "mk": // Macedonian
        // 2 forms
        return n == 1 || n % 10 == 1 ? 0 : 1;
      case "ach": // Acholi
      case "ak": // Akan
      case "am": // Amharic
      case "arn": // Mapudungun
      case "br": // Breton
      case "fil": // Filipino
      case "fr": // French
      case "gun": // Gun
      case "ln": // Lingala
      case "mfe": // Mauritian Creole
      case "mg": // Malagasy
      case "mi": // Maori
      case "oc": // Occitan
      case "pt_BR": // Brazilian Portuguese
      case "tg": // Tajik
      case "ti": // Tigrinya
      case "tr": // Turkish
      case "uz": // Uzbek
      case "wa": // Walloon
      case "zh": // Chinese
        // 2 forms
        return n > 1 ? 1 : 0;
      case "lv": // Latvian
        // 3 forms
        return (n % 10 == 1 && n % 100 != 11 ? 0 : n != 0 ? 1 : 2);
      case "lt": // Lithuanian
        // 3 forms
        return (n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
      case "be": // Belarusian
      case "bs": // Bosnian
      case "hr": // Croatian
      case "ru": // Russian
      case "sr": // Serbian
      case "uk": // Ukrainian
        // 3 forms
        return (n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
      case "mnk": // Mandinka
        // 3 forms
        return (n == 0 ? 0 : n == 1 ? 1 : 2);
      case "ro": // Romanian
        // 3 forms
        return (n == 1 ? 0 : (n == 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2);
      case "pl": // Polish
        // 3 forms
        return (n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
      case "cs": // Czech
      case "sk": // Slovak
        // 3 forms
        return (n == 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2;
      case "sl": // Slovenian
        // 4 forms
        return (n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
      case "mt": // Maltese
        // 4 forms
        return (n == 1 ? 0 : n == 0 || ( n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20 ) ? 2 : 3);
      case "gd": // Scottish Gaelic
        // 4 forms
        return (n == 1 || n == 11) ? 0 : (n == 2 || n == 12) ? 1 : (n > 2 && n < 20) ? 2 : 3;
      case "cy": // Welsh
        // 4 forms
        return (n == 1) ? 0 : (n == 2) ? 1 : (n != 8 && n != 11) ? 2 : 3;
      case "kw": // Cornish
        // 4 forms
        return (n == 1) ? 0 : (n == 2) ? 1 : (n == 3) ? 2 : 3;
      case "ga": // Irish
        // 5 forms
        return n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4;
      case "ar": // Arabic
        // 6 forms
        return (n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
      default: // Everything else
        return n != 1 ? 1 : 0;
    }
  };
});

/*
 * ngKookies - relpacer for built-in $cookieStore
 * Porque?? - https://github.com/angular/angular.js/issues/950
 * http://github.com/voronianski/ngKookies
 * (c) 2014 MIT License, https://pixelhunter.me
 */

(function (root, factory) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory(require("angular"));
  } else if (typeof define === "function" && define.amd) {
    define(["angular"], factory);
  } else {
    factory(root.angular);
  }
}(this, function (angular, undefined) {
  "use strict";

  angular.module("ngKookies", [])

    .provider("$kookies", function () {
      var config = this.config = {};
      var defaults = this.defaults = {};

      this.setConfig = function (newConfig) {
        angular.extend(config, newConfig);
      };

      this.setDefaults = function (newDefaults) {
        angular.extend(defaults, newDefaults);
      };

      this.$get = function () {

        var privateMethods = {};
        var publicMethods = {};

        privateMethods.decode = function (s) {
          return config.raw ? s : encodeURIComponent(s);
        };

        privateMethods.encode = function (s) {
          return config.raw ? s : decodeURIComponent(s);
        };

        privateMethods.parseCookie = function (s) {
          if (s.indexOf("\"") === 0) {
            // unescape quoted cookie as according to RFC2068
            s = s.slice(1, -1).replace(/\\"/g, "\"").replace(/\\\\/g, "\\");
          }

          try {
            // replace server-side written pluses with spaces.
            s = decodeURIComponent(s.replace(/\+/g, " "));
            return config.json ? angular.fromJson(s) : s;
          } catch (e) {}
        };

        privateMethods.stringifyCookie = function (value) {
          return privateMethods.encode(config.json ? angular.toJson(value) : String(value));
        };

        privateMethods.read = function (s, converter) {
          var value = config.raw ? s : privateMethods.parseCookie(s);
          return angular.isFunction(converter) ? converter(value) : value;
        };

        publicMethods.get = function (key, converter) {
          var result = key ? undefined : {};
          var cookies = document.cookie ? document.cookie.split("; ") : [];

          for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split("=");
            var name = privateMethods.decode(parts.shift());
            var cookie = parts.join("=");

            if (key && key === name) {
              result = privateMethods.read(cookie, converter);
              break;
            }

            if (!key && (cookie = privateMethods.read(cookie)) !== undefined) {
              result[name] = cookie;
            }
          }

          return result;
        };

        publicMethods.set = function (key, value, options) {
          options = options || {};
          options = angular.extend(options, defaults);

          if (typeof options.expires === "number") {
            var days = options.expires;
            var time = options.expires = new Date();
            time.setTime(+time + days * 864e+5);
          }

          var cookies = document.cookie = [
            privateMethods.encode(key), "=", privateMethods.stringifyCookie(value),
            options.expires ? "; expires=" + options.expires.toUTCString() : "", // use expires attribute, max-age is not supported by IE
            options.path ? "; path=" + options.path : "",
            options.domain ? "; domain=" + options.domain : "",
            options.secure ? "; secure" : ""
          ].join("");

          return cookies;
        };

        publicMethods.remove = function (key, options) {

          if (publicMethods.get(key) === undefined) {
            return false;
          }

          publicMethods.set(key, "", angular.extend({ expires: -1 }, options));

          return !publicMethods.get(key);
        };

        return publicMethods;
      };
    });
}));

/* ! DataTables 1.10.16
 * ©2008-2017 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     DataTables
 * @description Paginate, search and order HTML tables
 * @version     1.10.16
 * @file        jquery.dataTables.js
 * @author      SpryMedia Ltd
 * @contact     www.datatables.net
 * @copyright   Copyright 2008-2017 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

/* jslint evil: true, undef: true, browser: true */
/* globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/

(function ( factory ) {
  "use strict";

  if ( typeof define === "function" && define.amd ) {
    // AMD
    define( ["jquery"], function ( $ ) {
      return factory( $, window, document );
    } );
  }
  else if ( typeof exports === "object" ) {
    // CommonJS
    module.exports = function (root, $) {
      if ( ! root ) {
        // CommonJS environments without a window global must pass a
        // root. This will give an error otherwise
        root = window;
      }

      if ( ! $ ) {
        $ = typeof window !== "undefined" ? // jQuery's factory checks for a global window
          require("jquery") :
          require("jquery")( root );
      }

      return factory( $, root, root.document );
    };
  }
  else {
    // Browser
    factory( jQuery, window, document );
  }
}
(function ( $, window, document, undefined ) {
  "use strict";

  /**
	 * DataTables is a plug-in for the jQuery Javascript library. It is a highly
	 * flexible tool, based upon the foundations of progressive enhancement,
	 * which will add advanced interaction controls to any HTML table. For a
	 * full list of features please refer to
	 * [DataTables.net](href="http://datatables.net).
	 *
	 * Note that the `DataTable` object is not a global variable but is aliased
	 * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
	 * be  accessed.
	 *
	 *  @class
	 *  @param {object} [init={}] Configuration object for DataTables. Options
	 *    are defined by {@link DataTable.defaults}
	 *  @requires jQuery 1.7+
	 *
	 *  @example
	 *    // Basic initialisation
	 *    $(document).ready( function {
	 *      $('#example').dataTable();
	 *    } );
	 *
	 *  @example
	 *    // Initialisation with configuration options - in this case, disable
	 *    // pagination and sorting.
	 *    $(document).ready( function {
	 *      $('#example').dataTable( {
	 *        "paginate": false,
	 *        "sort": false
	 *      } );
	 *    } );
	 */
  var DataTable = function ( options )
  {
    /**
		 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
		 * return the resulting jQuery object.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
		 *    criterion ("applied") or all TR elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {object} jQuery object, filtered by the given selector.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Highlight every second row
		 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to rows with 'Webkit' in them, add a background colour and then
		 *      // remove the filter, thus highlighting the 'Webkit' rows only.
		 *      oTable.fnFilter('Webkit');
		 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
		 *      oTable.fnFilter('');
		 *    } );
		 */
    this.$ = function ( sSelector, oOpts )
    {
      return this.api(true).$( sSelector, oOpts );
    };

    /**
		 * Almost identical to $ in operation, but in this case returns the data for the matched
		 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
		 * rather than any descendants, so the data can be obtained for the row/cell. If matching
		 * rows are found, the data returned is the original data array/object that was used to
		 * create the row (or a generated array if from a DOM source).
		 *
		 * This method is often useful in-combination with $ where both functions are given the
		 * same parameters and the array indexes will match identically.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
		 *    criterion ("applied") or all elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {array} Data for the matched elements. If any elements, as a result of the
		 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
		 *    entry in the array.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the data from the first row in the table
		 *      var data = oTable._('tr:first');
		 *
		 *      // Do something useful with the data
		 *      alert( "First cell is: "+data[0] );
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to 'Webkit' and get all data for
		 *      oTable.fnFilter('Webkit');
		 *      var data = oTable._('tr', {"search": "applied"});
		 *
		 *      // Do something with the data
		 *      alert( data.length+" rows matched the search" );
		 *    } );
		 */
    this._ = function ( sSelector, oOpts )
    {
      return this.api(true).rows( sSelector, oOpts ).data();
    };

    /**
		 * Create a DataTables Api instance, with the currently selected tables for
		 * the Api's context.
		 * @param {boolean} [traditional=false] Set the API instance's context to be
		 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
		 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
		 *   or if all tables captured in the jQuery object should be used.
		 * @return {DataTables.Api}
		 */
    this.api = function ( traditional )
    {
      return traditional ?
        new _Api(
          _fnSettingsFromNode( this[ _ext.iApiIndex ] )
        ) :
        new _Api( this );
    };

    /**
		 * Add a single new row or multiple rows of data to the table. Please note
		 * that this is suitable for client-side processing only - if you are using
		 * server-side processing (i.e. "bServerSide": true), then to add data, you
		 * must add it to the data source, i.e. the server-side, through an Ajax call.
		 *  @param {array|object} data The data to be added to the table. This can be:
		 *    <ul>
		 *      <li>1D array of data - add a single row with the data provided</li>
		 *      <li>2D array of arrays - add multiple rows in a single call</li>
		 *      <li>object - data object when using <i>mData</i></li>
		 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
		 *    </ul>
		 *  @param {bool} [redraw=true] redraw the table or not
		 *  @returns {array} An array of integers, representing the list of indexes in
		 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
		 *    the table.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Global var for counter
		 *    var giCount = 2;
		 *
		 *    $(document).ready(function() {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *    function fnClickAddRow() {
		 *      $('#example').dataTable().fnAddData( [
		 *        giCount+".1",
		 *        giCount+".2",
		 *        giCount+".3",
		 *        giCount+".4" ]
		 *      );
		 *
		 *      giCount++;
		 *    }
		 */
    this.fnAddData = function ( data, redraw )
    {
      var api = this.api( true );

      /* Check if we want to add multiple rows or not */
      var rows = $.isArray(data) && ( $.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
        api.rows.add( data ) :
        api.row.add( data );

      if ( redraw === undefined || redraw ) {
        api.draw();
      }

      return rows.flatten().toArray();
    };

    /**
		 * This function will make DataTables recalculate the column sizes, based on the data
		 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
		 * through the sWidth parameter). This can be useful when the width of the table's
		 * parent element changes (for example a window resize).
		 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable( {
		 *        "sScrollY": "200px",
		 *        "bPaginate": false
		 *      } );
		 *
		 *      $(window).on('resize', function () {
		 *        oTable.fnAdjustColumnSizing();
		 *      } );
		 *    } );
		 */
    this.fnAdjustColumnSizing = function ( bRedraw )
    {
      var api = this.api( true ).columns.adjust();
      var settings = api.settings()[0];
      var scroll = settings.oScroll;

      if ( bRedraw === undefined || bRedraw ) {
        api.draw( false );
      }
      else if ( scroll.sX !== "" || scroll.sY !== "" ) {
        /* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
        _fnScrollDraw( settings );
      }
    };

    /**
		 * Quickly and simply clear a table
		 *  @param {bool} [bRedraw=true] redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
		 *      oTable.fnClearTable();
		 *    } );
		 */
    this.fnClearTable = function ( bRedraw )
    {
      var api = this.api( true ).clear();

      if ( bRedraw === undefined || bRedraw ) {
        api.draw();
      }
    };

    /**
		 * The exact opposite of 'opening' a row, this function will close any rows which
		 * are currently 'open'.
		 *  @param {node} nTr the table row to 'close'
		 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
    this.fnClose = function ( nTr )
    {
      this.api( true ).row( nTr ).child.hide();
    };

    /**
		 * Remove a row for the table
		 *  @param {mixed} target The index of the row from aoData to be deleted, or
		 *    the TR element you want to delete
		 *  @param {function|null} [callBack] Callback function
		 *  @param {bool} [redraw=true] Redraw the table or not
		 *  @returns {array} The row that was deleted
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately remove the first row
		 *      oTable.fnDeleteRow( 0 );
		 *    } );
		 */
    this.fnDeleteRow = function ( target, callback, redraw )
    {
      var api = this.api( true );
      var rows = api.rows( target );
      var settings = rows.settings()[0];
      var data = settings.aoData[ rows[0][0] ];

      rows.remove();

      if ( callback ) {
        callback.call( this, settings, data );
      }

      if ( redraw === undefined || redraw ) {
        api.draw();
      }

      return data;
    };

    /**
		 * Restore the table to it's original state in the DOM by removing all of DataTables
		 * enhancements, alterations to the DOM structure of the table and event listeners.
		 *  @param {boolean} [remove=false] Completely remove the table from the DOM
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnDestroy();
		 *    } );
		 */
    this.fnDestroy = function ( remove )
    {
      this.api( true ).destroy( remove );
    };

    /**
		 * Redraw the table
		 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
		 *      oTable.fnDraw();
		 *    } );
		 */
    this.fnDraw = function ( complete )
    {
      // Note that this isn't an exact match to the old call to _fnDraw - it takes
      // into account the new data, but can hold position.
      this.api( true ).draw( complete );
    };

    /**
		 * Filter the input based on data
		 *  @param {string} sInput String to filter the table on
		 *  @param {int|null} [iColumn] Column to limit filtering to
		 *  @param {bool} [bRegex=false] Treat as regular expression or not
		 *  @param {bool} [bSmart=true] Perform smart filtering or not
		 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
		 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sometime later - filter...
		 *      oTable.fnFilter( 'test string' );
		 *    } );
		 */
    this.fnFilter = function ( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
    {
      var api = this.api( true );

      if ( iColumn === null || iColumn === undefined ) {
        api.search( sInput, bRegex, bSmart, bCaseInsensitive );
      }
      else {
        api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
      }

      api.draw();
    };

    /**
		 * Get the data for the whole table, an individual row or an individual cell based on the
		 * provided parameters.
		 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
		 *    a TR node then the data source for the whole row will be returned. If given as a
		 *    TD/TH cell node then iCol will be automatically calculated and the data for the
		 *    cell returned. If given as an integer, then this is treated as the aoData internal
		 *    data index for the row (see fnGetPosition) and the data for that row used.
		 *  @param {int} [col] Optional column index that you want the data of.
		 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
		 *    returned. If mRow is defined, just data for that row, and is iCol is
		 *    defined, only data for the designated cell is returned.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Row data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('tr').click( function () {
		 *        var data = oTable.fnGetData( this );
		 *        // ... do something with the array / object of data for the row
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Individual cell data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('td').click( function () {
		 *        var sData = oTable.fnGetData( this );
		 *        alert( 'The cell clicked on had the value of '+sData );
		 *      } );
		 *    } );
		 */
    this.fnGetData = function ( src, col )
    {
      var api = this.api( true );

      if ( src !== undefined ) {
        var type = src.nodeName ? src.nodeName.toLowerCase() : "";

        return col !== undefined || type == "td" || type == "th" ?
          api.cell( src, col ).data() :
          api.row( src ).data() || null;
      }

      return api.data().toArray();
    };

    /**
		 * Get an array of the TR nodes that are used in the table's body. Note that you will
		 * typically want to use the '$' API method in preference to this as it is more
		 * flexible.
		 *  @param {int} [iRow] Optional row index for the TR element you want
		 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
		 *    in the table's body, or iRow is defined, just the TR element requested.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the nodes from the table
		 *      var nNodes = oTable.fnGetNodes( );
		 *    } );
		 */
    this.fnGetNodes = function ( iRow )
    {
      var api = this.api( true );

      return iRow !== undefined ?
        api.row( iRow ).node() :
        api.rows().nodes().flatten().toArray();
    };

    /**
		 * Get the array indexes of a particular cell from it's DOM element
		 * and column index including hidden columns
		 *  @param {node} node this can either be a TR, TD or TH in the table's body
		 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
		 *    if given as a cell, an array of [row index, column index (visible),
		 *    column index (all)] is given.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      $('#example tbody td').click( function () {
		 *        // Get the position of the current data from the node
		 *        var aPos = oTable.fnGetPosition( this );
		 *
		 *        // Get the data array for this row
		 *        var aData = oTable.fnGetData( aPos[0] );
		 *
		 *        // Update the data array and return the value
		 *        aData[ aPos[1] ] = 'clicked';
		 *        this.innerHTML = 'clicked';
		 *      } );
		 *
		 *      // Init DataTables
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
    this.fnGetPosition = function ( node )
    {
      var api = this.api( true );
      var nodeName = node.nodeName.toUpperCase();

      if ( nodeName == "TR" ) {
        return api.row( node ).index();
      }
      else if ( nodeName == "TD" || nodeName == "TH" ) {
        var cell = api.cell( node ).index();

        return [
          cell.row,
          cell.columnVisible,
          cell.column
        ];
      }
      return null;
    };

    /**
		 * Check to see if a row is 'open' or not.
		 *  @param {node} nTr the table row to check
		 *  @returns {boolean} true if the row is currently open, false otherwise
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
    this.fnIsOpen = function ( nTr )
    {
      return this.api( true ).row( nTr ).child.isShown();
    };

    /**
		 * This function will place a new row directly after a row which is currently
		 * on display on the page, with the HTML contents that is passed into the
		 * function. This can be used, for example, to ask for confirmation that a
		 * particular record should be deleted.
		 *  @param {node} nTr The table row to 'open'
		 *  @param {string|node|jQuery} mHtml The HTML to put into the row
		 *  @param {string} sClass Class to give the new TD cell
		 *  @returns {node} The row opened. Note that if the table row passed in as the
		 *    first parameter, is not found in the table, this method will silently
		 *    return.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
    this.fnOpen = function ( nTr, mHtml, sClass )
    {
      return this.api( true )
        .row( nTr )
        .child( mHtml, sClass )
        .show()
        .child()[0];
    };

    /**
		 * Change the pagination - provides the internal logic for pagination in a simple API
		 * function. With this function you can have a DataTables table go to the next,
		 * previous, first or last pages.
		 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
		 *    or page number to jump to (integer), note that page 0 is the first page.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnPageChange( 'next' );
		 *    } );
		 */
    this.fnPageChange = function ( mAction, bRedraw )
    {
      var api = this.api( true ).page( mAction );

      if ( bRedraw === undefined || bRedraw ) {
        api.draw(false);
      }
    };

    /**
		 * Show a particular column
		 *  @param {int} iCol The column whose display should be changed
		 *  @param {bool} bShow Show (true) or hide (false) the column
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Hide the second column after initialisation
		 *      oTable.fnSetColumnVis( 1, false );
		 *    } );
		 */
    this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
    {
      var api = this.api( true ).column( iCol ).visible( bShow );

      if ( bRedraw === undefined || bRedraw ) {
        api.columns.adjust().draw();
      }
    };

    /**
		 * Get the settings for a particular table for external manipulation
		 *  @returns {object} DataTables settings object. See
		 *    {@link DataTable.models.oSettings}
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      var oSettings = oTable.fnSettings();
		 *
		 *      // Show an example parameter from the settings
		 *      alert( oSettings._iDisplayStart );
		 *    } );
		 */
    this.fnSettings = function ()
    {
      return _fnSettingsFromNode( this[_ext.iApiIndex] );
    };

    /**
		 * Sort the table by a particular column
		 *  @param {int} iCol the data index to sort on. Note that this will not match the
		 *    'display index' if you have hidden data entries
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort immediately with columns 0 and 1
		 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
		 *    } );
		 */
    this.fnSort = function ( aaSort )
    {
      this.api( true ).order( aaSort ).draw();
    };

    /**
		 * Attach a sort listener to an element for a given column
		 *  @param {node} nNode the element to attach the sort listener to
		 *  @param {int} iColumn the column that a click on this node will sort on
		 *  @param {function} [fnCallback] callback function when sort is run
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort on column 1, when 'sorter' is clicked on
		 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
		 *    } );
		 */
    this.fnSortListener = function ( nNode, iColumn, fnCallback )
    {
      this.api( true ).order.listener( nNode, iColumn, fnCallback );
    };

    /**
		 * Update a table cell or row - this method will accept either a single value to
		 * update the cell with, an array of values with one element for each column or
		 * an object in the same format as the original data source. The function is
		 * self-referencing in order to make the multi column updates easier.
		 *  @param {object|array|string} mData Data to update the cell/row with
		 *  @param {node|int} mRow TR element you want to update or the aoData index
		 *  @param {int} [iColumn] The column to update, give as null or undefined to
		 *    update a whole row.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @param {bool} [bAction=true] Perform pre-draw actions or not
		 *  @returns {int} 0 on success, 1 on error
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
		 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
		 *    } );
		 */
    this.fnUpdate = function ( mData, mRow, iColumn, bRedraw, bAction )
    {
      var api = this.api( true );

      if ( iColumn === undefined || iColumn === null ) {
        api.row( mRow ).data( mData );
      }
      else {
        api.cell( mRow, iColumn ).data( mData );
      }

      if ( bAction === undefined || bAction ) {
        api.columns.adjust();
      }

      if ( bRedraw === undefined || bRedraw ) {
        api.draw();
      }
      return 0;
    };

    /**
		 * Provide a common method for plug-ins to check the version of DataTables being used, in order
		 * to ensure compatibility.
		 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
		 *    formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
		 *    version, or false if this version of DataTales is not suitable
		 *  @method
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
		 *    } );
		 */
    this.fnVersionCheck = _ext.fnVersionCheck;

    var _that = this;
    var emptyInit = options === undefined;
    var len = this.length;

    if ( emptyInit ) {
      options = {};
    }

    this.oApi = this.internal = _ext.internal;

    // Extend with old style plug-in API methods
    for ( var fn in DataTable.ext.internal ) {
      if ( fn ) {
        this[fn] = _fnExternApiFunc(fn);
      }
    }

    this.each(function () {
      // For each initialisation we want to give it a clean initialisation
      // object that can be bashed around
      var o = {};
      var oInit = len > 1 ? // optimisation for single table case
        _fnExtend( o, options, true ) :
        options;

      /* global oInit,_that,emptyInit*/
      var i = 0, iLen, j, jLen, k, kLen;
      var sId = this.getAttribute( "id" );
      var bInitHandedOff = false;
      var defaults = DataTable.defaults;
      var $this = $(this);

      /* Sanity check */
      if ( this.nodeName.toLowerCase() != "table" )
      {
        _fnLog( null, 0, "Non-table node initialisation (" + this.nodeName + ")", 2 );
        return;
      }

      /* Backwards compatibility for the defaults */
      _fnCompatOpts( defaults );
      _fnCompatCols( defaults.column );

      /* Convert the camel-case defaults to Hungarian */
      _fnCamelToHungarian( defaults, defaults, true );
      _fnCamelToHungarian( defaults.column, defaults.column, true );

      /* Setting up the initialisation object */
      _fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ) );

      /* Check to see if we are re-initialising a table */
      var allSettings = DataTable.settings;
      for ( i = 0, iLen = allSettings.length ; i < iLen ; i++ )
      {
        var s = allSettings[i];

        /* Base check on table node */
        if ( s.nTable == this || s.nTHead.parentNode == this || (s.nTFoot && s.nTFoot.parentNode == this) )
        {
          var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
          var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;

          if ( emptyInit || bRetrieve )
          {
            return s.oInstance;
          }
          else if ( bDestroy )
          {
            s.oInstance.fnDestroy();
            break;
          }
          else
          {
            _fnLog( s, 0, "Cannot reinitialise DataTable", 3 );
            return;
          }
        }

        /* If the element we are initialising has the same ID as a table which was previously
				 * initialised, but the table nodes don't match (from before) then we destroy the old
				 * instance by simply deleting it. This is under the assumption that the table has been
				 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
				 */
        if ( s.sTableId == this.id )
        {
          allSettings.splice( i, 1 );
          break;
        }
      }

      /* Ensure the table has an ID - required for accessibility */
      if ( sId === null || sId === "" )
      {
        sId = "DataTables_Table_" + (DataTable.ext._unique++);
        this.id = sId;
      }

      /* Create the settings object for this table and set some of the default parameters */
      var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
        "sDestroyWidth": $this[0].style.width,
        "sInstance": sId,
        "sTableId": sId
      } );
      oSettings.nTable = this;
      oSettings.oApi = _that.internal;
      oSettings.oInit = oInit;

      allSettings.push( oSettings );

      // Need to add the instance after the instance after the settings object has been added
      // to the settings array, so we can self reference the table instance if more than one
      oSettings.oInstance = (_that.length === 1) ? _that : $this.dataTable();

      // Backwards compatibility, before we apply all the defaults
      _fnCompatOpts( oInit );

      if ( oInit.oLanguage )
      {
        _fnLanguageCompat( oInit.oLanguage );
      }

      // If the length menu is given, but the init display length is not, use the length menu
      if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
      {
        oInit.iDisplayLength = $.isArray( oInit.aLengthMenu[0] ) ?
          oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
      }

      // Apply the defaults and init options to make a single init object will all
      // options defined from defaults and instance options.
      oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );

      // Map the initialisation options onto the settings object
      _fnMap( oSettings.oFeatures, oInit, [
        "bPaginate",
        "bLengthChange",
        "bFilter",
        "bSort",
        "bSortMulti",
        "bInfo",
        "bProcessing",
        "bAutoWidth",
        "bSortClasses",
        "bServerSide",
        "bDeferRender"
      ] );
      _fnMap( oSettings, oInit, [
        "asStripeClasses",
        "ajax",
        "fnServerData",
        "fnFormatNumber",
        "sServerMethod",
        "aaSorting",
        "aaSortingFixed",
        "aLengthMenu",
        "sPaginationType",
        "sAjaxSource",
        "sAjaxDataProp",
        "iStateDuration",
        "sDom",
        "bSortCellsTop",
        "iTabIndex",
        "fnStateLoadCallback",
        "fnStateSaveCallback",
        "renderer",
        "searchDelay",
        "rowId",
        [ "iCookieDuration", "iStateDuration" ], // backwards compat
        [ "oSearch", "oPreviousSearch" ],
        [ "aoSearchCols", "aoPreSearchCols" ],
        [ "iDisplayLength", "_iDisplayLength" ]
      ] );
      _fnMap( oSettings.oScroll, oInit, [
        [ "sScrollX", "sX" ],
        [ "sScrollXInner", "sXInner" ],
        [ "sScrollY", "sY" ],
        [ "bScrollCollapse", "bCollapse" ]
      ] );
      _fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );

      /* Callback functions which are array driven */
      _fnCallbackReg( oSettings, "aoDrawCallback", oInit.fnDrawCallback, "user" );
      _fnCallbackReg( oSettings, "aoServerParams", oInit.fnServerParams, "user" );
      _fnCallbackReg( oSettings, "aoStateSaveParams", oInit.fnStateSaveParams, "user" );
      _fnCallbackReg( oSettings, "aoStateLoadParams", oInit.fnStateLoadParams, "user" );
      _fnCallbackReg( oSettings, "aoStateLoaded", oInit.fnStateLoaded, "user" );
      _fnCallbackReg( oSettings, "aoRowCallback", oInit.fnRowCallback, "user" );
      _fnCallbackReg( oSettings, "aoRowCreatedCallback", oInit.fnCreatedRow, "user" );
      _fnCallbackReg( oSettings, "aoHeaderCallback", oInit.fnHeaderCallback, "user" );
      _fnCallbackReg( oSettings, "aoFooterCallback", oInit.fnFooterCallback, "user" );
      _fnCallbackReg( oSettings, "aoInitComplete", oInit.fnInitComplete, "user" );
      _fnCallbackReg( oSettings, "aoPreDrawCallback", oInit.fnPreDrawCallback, "user" );

      oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );

      /* Browser support detection */
      _fnBrowserDetect( oSettings );

      var oClasses = oSettings.oClasses;

      $.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
      $this.addClass( oClasses.sTable );

      if ( oSettings.iInitDisplayStart === undefined )
      {
        /* Display start point, taking into account the save saving */
        oSettings.iInitDisplayStart = oInit.iDisplayStart;
        oSettings._iDisplayStart = oInit.iDisplayStart;
      }

      if ( oInit.iDeferLoading !== null )
      {
        oSettings.bDeferLoading = true;
        var tmp = $.isArray( oInit.iDeferLoading );
        oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
        oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
      }

      /* Language definitions */
      var oLanguage = oSettings.oLanguage;
      $.extend( true, oLanguage, oInit.oLanguage );

      if ( oLanguage.sUrl )
      {
        /* Get the language definitions from a file - because this Ajax call makes the language
				 * get async to the remainder of this function we use bInitHandedOff to indicate that
				 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
				 */
        $.ajax( {
          dataType: "json",
          url: oLanguage.sUrl,
          success: function ( json ) {
            _fnLanguageCompat( json );
            _fnCamelToHungarian( defaults.oLanguage, json );
            $.extend( true, oLanguage, json );
            _fnInitialise( oSettings );
          },
          error: function () {
            // Error occurred loading language file, continue on as best we can
            _fnInitialise( oSettings );
          }
        } );
        bInitHandedOff = true;
      }

      /*
			 * Stripes
			 */
      if ( oInit.asStripeClasses === null )
      {
        oSettings.asStripeClasses = [
          oClasses.sStripeOdd,
          oClasses.sStripeEven
        ];
      }

      /* Remove row stripe classes if they are already on the table row */
      var stripeClasses = oSettings.asStripeClasses;
      var rowOne = $this.children("tbody").find("tr").eq(0);
      if ( $.inArray( true, $.map( stripeClasses, function (el, i) {
        return rowOne.hasClass(el);
      } ) ) !== -1 ) {
        $("tbody tr", this).removeClass( stripeClasses.join(" ") );
        oSettings.asDestroyStripes = stripeClasses.slice();
      }

      /*
			 * Columns
			 * See if we should load columns automatically or use defined ones
			 */
      var anThs = [];
      var aoColumnsInit;
      var nThead = this.getElementsByTagName("thead");
      if ( nThead.length !== 0 )
      {
        _fnDetectHeader( oSettings.aoHeader, nThead[0] );
        anThs = _fnGetUniqueThs( oSettings );
      }

      /* If not given a column array, generate one with nulls */
      if ( oInit.aoColumns === null )
      {
        aoColumnsInit = [];
        for ( i = 0, iLen = anThs.length ; i < iLen ; i++ )
        {
          aoColumnsInit.push( null );
        }
      }
      else
      {
        aoColumnsInit = oInit.aoColumns;
      }

      /* Add the columns */
      for ( i = 0, iLen = aoColumnsInit.length ; i < iLen ; i++ )
      {
        _fnAddColumn( oSettings, anThs ? anThs[i] : null );
      }

      /* Apply the column definitions */
      _fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
        _fnColumnOptions( oSettings, iCol, oDef );
      } );

      /* HTML5 attribute detection - build an mData object automatically if the
			 * attributes are found
			 */
      if ( rowOne.length ) {
        var a = function ( cell, name ) {
          return cell.getAttribute( "data-" + name ) !== null ? name : null;
        };

        $( rowOne[0] ).children("th, td").each( function (i, cell) {
          var col = oSettings.aoColumns[i];

          if ( col.mData === i ) {
            var sort = a( cell, "sort" ) || a( cell, "order" );
            var filter = a( cell, "filter" ) || a( cell, "search" );

            if ( sort !== null || filter !== null ) {
              col.mData = {
                _: i + ".display",
                sort: sort !== null ? i + ".@data-" + sort : undefined,
                type: sort !== null ? i + ".@data-" + sort : undefined,
                filter: filter !== null ? i + ".@data-" + filter : undefined
              };

              _fnColumnOptions( oSettings, i );
            }
          }
        } );
      }

      var features = oSettings.oFeatures;
      var loadedInit = function () {
        /*
				 * Sorting
				 * @todo For modularisation (1.11) this needs to do into a sort start up handler
				 */

        // If aaSorting is not defined, then we use the first indicator in asSorting
        // in case that has been altered, so the default sort reflects that option
        if ( oInit.aaSorting === undefined ) {
          var sorting = oSettings.aaSorting;
          for ( i = 0, iLen = sorting.length ; i < iLen ; i++ ) {
            sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
          }
        }

        /* Do a first pass on the sorting classes (allows any size changes to be taken into
				 * account, and also will apply sorting disabled classes if disabled
				 */
        _fnSortingClasses( oSettings );

        if ( features.bSort ) {
          _fnCallbackReg( oSettings, "aoDrawCallback", function () {
            if ( oSettings.bSorted ) {
              var aSort = _fnSortFlatten( oSettings );
              var sortedColumns = {};

              $.each( aSort, function (i, val) {
                sortedColumns[ val.src ] = val.dir;
              } );

              _fnCallbackFire( oSettings, null, "order", [oSettings, aSort, sortedColumns] );
              _fnSortAria( oSettings );
            }
          } );
        }

        _fnCallbackReg( oSettings, "aoDrawCallback", function () {
          if ( oSettings.bSorted || _fnDataSource( oSettings ) === "ssp" || features.bDeferRender ) {
            _fnSortingClasses( oSettings );
          }
        }, "sc" );

        /*
				 * Final init
				 * Cache the header, body and footer as required, creating them if needed
				 */

        // Work around for Webkit bug 83867 - store the caption-side before removing from doc
        var captions = $this.children("caption").each( function () {
          this._captionSide = $(this).css("caption-side");
        } );

        var thead = $this.children("thead");
        if ( thead.length === 0 ) {
          thead = $("<thead/>").appendTo($this);
        }
        oSettings.nTHead = thead[0];

        var tbody = $this.children("tbody");
        if ( tbody.length === 0 ) {
          tbody = $("<tbody/>").appendTo($this);
        }
        oSettings.nTBody = tbody[0];

        var tfoot = $this.children("tfoot");
        if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
          // If we are a scrolling table, and no footer has been given, then we need to create
          // a tfoot element for the caption element to be appended to
          tfoot = $("<tfoot/>").appendTo($this);
        }

        if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
          $this.addClass( oClasses.sNoFooter );
        }
        else if ( tfoot.length > 0 ) {
          oSettings.nTFoot = tfoot[0];
          _fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
        }

        /* Check if there is data passing into the constructor */
        if ( oInit.aaData ) {
          for ( i = 0 ; i < oInit.aaData.length ; i++ ) {
            _fnAddData( oSettings, oInit.aaData[ i ] );
          }
        }
        else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == "dom" ) {
          /* Grab the data from the page - only do this when deferred loading or no Ajax
					 * source since there is no point in reading the DOM data if we are then going
					 * to replace it with Ajax data
					 */
          _fnAddTr( oSettings, $(oSettings.nTBody).children("tr") );
        }

        /* Copy the data index array */
        oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();

        /* Initialisation complete - table can be drawn */
        oSettings.bInitialised = true;

        /* Check if we need to initialise the table (it might not have been handed off to the
				 * language processor)
				 */
        if ( bInitHandedOff === false ) {
          _fnInitialise( oSettings );
        }
      };

      /* Must be done after everything which can be overridden by the state saving! */
      if ( oInit.bStateSave )
      {
        features.bStateSave = true;
        _fnCallbackReg( oSettings, "aoDrawCallback", _fnSaveState, "state_save" );
        _fnLoadState( oSettings, oInit, loadedInit );
      }
      else {
        loadedInit();
      }

    } );
    _that = null;
    return this;
  };

  /*
	 * It is useful to have variables which are scoped locally so only the
	 * DataTables functions can access them and they don't leak into global space.
	 * At the same time these functions are often useful over multiple files in the
	 * core and API, so we list, or at least document, all variables which are used
	 * by DataTables as private variables here. This also ensures that there is no
	 * clashing of variable names and that they can easily referenced for reuse.
	 */

  // Defined else where
  //  _selector_run
  //  _selector_opts
  //  _selector_first
  //  _selector_row_indexes

  var _ext; // DataTable.ext
  var _Api; // DataTable.Api
  var _api_register; // DataTable.Api.register
  var _api_registerPlural; // DataTable.Api.registerPlural

  var _re_dic = {};
  var _re_new_lines = /[\r\n]/g;
  var _re_html = /<.*?>/g;

  // This is not strict ISO8601 - Date.parse() is quite lax, although
  // implementations differ between browsers.
  var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;

  // Escape regular expression special characters
  var _re_escape_regex = new RegExp( "(\\" + [ "/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^", "-" ].join("|\\") + ")", "g" );

  // http://en.wikipedia.org/wiki/Foreign_exchange_market
  // - \u20BD - Russian ruble.
  // - \u20a9 - South Korean Won
  // - \u20BA - Turkish Lira
  // - \u20B9 - Indian Rupee
  // - R - Brazil (R$) and South Africa
  // - fr - Swiss Franc
  // - kr - Swedish krona, Norwegian krone and Danish krone
  // - \u2009 is thin space and \u202F is narrow no-break space, both used in many
  //   standards as thousands separators.
  var _re_formatted_numeric = /[',$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfk]/gi;

  var _empty = function ( d ) {
    return !d || d === true || d === "-" ? true : false;
  };

  var _intVal = function ( s ) {
    var integer = parseInt( s, 10 );
    return !isNaN(integer) && isFinite(s) ? integer : null;
  };

  // Convert from a formatted number with characters other than `.` as the
  // decimal place, to a Javascript number
  var _numToDecimal = function ( num, decimalPoint ) {
    // Cache created regular expressions for speed as this function is called often
    if ( ! _re_dic[ decimalPoint ] ) {
      _re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), "g" );
    }
    return typeof num === "string" && decimalPoint !== "." ?
      num.replace( /\./g, "" ).replace( _re_dic[ decimalPoint ], "." ) :
      num;
  };

  var _isNumber = function ( d, decimalPoint, formatted ) {
    var strType = typeof d === "string";

    // If empty return immediately so there must be a number if it is a
    // formatted string (this stops the string "k", or "kr", etc being detected
    // as a formatted number for currency
    if ( _empty( d ) ) {
      return true;
    }

    if ( decimalPoint && strType ) {
      d = _numToDecimal( d, decimalPoint );
    }

    if ( formatted && strType ) {
      d = d.replace( _re_formatted_numeric, "" );
    }

    return !isNaN( parseFloat(d) ) && isFinite( d );
  };

  // A string without HTML in it can be considered to be HTML still
  var _isHtml = function ( d ) {
    return _empty( d ) || typeof d === "string";
  };

  var _htmlNumeric = function ( d, decimalPoint, formatted ) {
    if ( _empty( d ) ) {
      return true;
    }

    var html = _isHtml( d );
    return ! html ?
      null :
      _isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
        true :
        null;
  };

  var _pluck = function ( a, prop, prop2 ) {
    var out = [];
    var i = 0, ien = a.length;

    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if ( prop2 !== undefined ) {
      for ( ; i < ien ; i++ ) {
        if ( a[i] && a[i][ prop ] ) {
          out.push( a[i][ prop ][ prop2 ] );
        }
      }
    }
    else {
      for ( ; i < ien ; i++ ) {
        if ( a[i] ) {
          out.push( a[i][ prop ] );
        }
      }
    }

    return out;
  };

  // Basically the same as _pluck, but rather than looping over `a` we use `order`
  // as the indexes to pick from `a`
  var _pluck_order = function ( a, order, prop, prop2 )
  {
    var out = [];
    var i = 0, ien = order.length;

    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if ( prop2 !== undefined ) {
      for ( ; i < ien ; i++ ) {
        if ( a[ order[i] ][ prop ] ) {
          out.push( a[ order[i] ][ prop ][ prop2 ] );
        }
      }
    }
    else {
      for ( ; i < ien ; i++ ) {
        out.push( a[ order[i] ][ prop ] );
      }
    }

    return out;
  };

  var _range = function ( len, start )
  {
    var out = [];
    var end;

    if ( start === undefined ) {
      start = 0;
      end = len;
    }
    else {
      end = start;
      start = len;
    }

    for ( var i = start ; i < end ; i++ ) {
      out.push( i );
    }

    return out;
  };

  var _removeEmpty = function ( a )
  {
    var out = [];

    for ( var i = 0, ien = a.length ; i < ien ; i++ ) {
      if ( a[i] ) { // careful - will remove all falsy values!
        out.push( a[i] );
      }
    }

    return out;
  };

  var _stripHtml = function ( d ) {
    return d.replace( _re_html, "" );
  };

  /**
	 * Determine if all values in the array are unique. This means we can short
	 * cut the _unique method at the cost of a single loop. A sorted array is used
	 * to easily check the values.
	 *
	 * @param  {array} src Source array
	 * @return {boolean} true if all unique, false otherwise
	 * @ignore
	 */
  var _areAllUnique = function ( src ) {
    if ( src.length < 2 ) {
      return true;
    }

    var sorted = src.slice().sort();
    var last = sorted[0];

    for ( var i = 1, ien = sorted.length ; i < ien ; i++ ) {
      if ( sorted[i] === last ) {
        return false;
      }

      last = sorted[i];
    }

    return true;
  };

  /**
	 * Find the unique elements in a source array.
	 *
	 * @param  {array} src Source array
	 * @return {array} Array of unique items
	 * @ignore
	 */
  var _unique = function ( src )
  {
    if ( _areAllUnique( src ) ) {
      return src.slice();
    }

    // A faster unique method is to use object keys to identify used values,
    // but this doesn't work with arrays or objects, which we must also
    // consider. See jsperf.com/compare-array-unique-versions/4 for more
    // information.
    var
      out = [],
      val,
      i, ien = src.length,
      j, k = 0;

    again: for ( i = 0 ; i < ien ; i++ ) {
      val = src[i];

      for ( j = 0 ; j < k ; j++ ) {
        if ( out[j] === val ) {
          continue again;
        }
      }

      out.push( val );
      k++;
    }

    return out;
  };

  /**
	 * DataTables utility methods
	 *
	 * This namespace provides helper methods that DataTables uses internally to
	 * create a DataTable, but which are not exclusively used only for DataTables.
	 * These methods can be used by extension authors to save the duplication of
	 * code.
	 *
	 *  @namespace
	 */
  DataTable.util = {
    /**
		 * Throttle the calls to a function. Arguments and context are maintained
		 * for the throttled function.
		 *
		 * @param {function} fn Function to be called
		 * @param {integer} freq Call frequency in mS
		 * @return {function} Wrapped function
		 */
    throttle: function ( fn, freq ) {
      var
        frequency = freq !== undefined ? freq : 200,
        last,
        timer;

      return function () {
        var
          that = this,
          now = +new Date(),
          args = arguments;

        if ( last && now < last + frequency ) {
          clearTimeout( timer );

          timer = setTimeout( function () {
            last = undefined;
            fn.apply( that, args );
          }, frequency );
        }
        else {
          last = now;
          fn.apply( that, args );
        }
      };
    },

    /**
		 * Escape a string such that it can be used in a regular expression
		 *
		 *  @param {string} val string to escape
		 *  @returns {string} escaped string
		 */
    escapeRegex: function ( val ) {
      return val.replace( _re_escape_regex, "\\$1" );
    }
  };

  /**
	 * Create a mapping object that allows camel case parameters to be looked up
	 * for their Hungarian counterparts. The mapping is stored in a private
	 * parameter called `_hungarianMap` which can be accessed on the source object.
	 *  @param {object} o
	 *  @memberof DataTable#oApi
	 */
  function _fnHungarianMap( o )
  {
    var
      hungarian = "a aa ai ao as b fn i m o s ",
      match,
      newKey,
      map = {};

    $.each( o, function (key, val) {
      match = key.match(/^([^A-Z]+?)([A-Z])/);

      if ( match && hungarian.indexOf(match[1] + " ") !== -1 )
      {
        newKey = key.replace( match[0], match[2].toLowerCase() );
        map[ newKey ] = key;

        if ( match[1] === "o" )
        {
          _fnHungarianMap( o[key] );
        }
      }
    } );

    o._hungarianMap = map;
  }

  /**
	 * Convert from camel case parameters to Hungarian, based on a Hungarian map
	 * created by _fnHungarianMap.
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 *  @memberof DataTable#oApi
	 */
  function _fnCamelToHungarian( src, user, force )
  {
    if ( ! src._hungarianMap ) {
      _fnHungarianMap( src );
    }

    var hungarianKey;

    $.each( user, function (key, val) {
      hungarianKey = src._hungarianMap[ key ];

      if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
      {
        // For objects, we need to buzz down into the object to copy parameters
        if ( hungarianKey.charAt(0) === "o" )
        {
          // Copy the camelCase options over to the hungarian
          if ( ! user[ hungarianKey ] ) {
            user[ hungarianKey ] = {};
          }
          $.extend( true, user[hungarianKey], user[key] );

          _fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
        }
        else {
          user[hungarianKey] = user[ key ];
        }
      }
    } );
  }

  /**
	 * Language compatibility - when certain options are given, and others aren't, we
	 * need to duplicate the values over, in order to provide backwards compatibility
	 * with older language files.
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnLanguageCompat( lang )
  {
    var defaults = DataTable.defaults.oLanguage;
    var zeroRecords = lang.sZeroRecords;

    /* Backwards compatibility - if there is no sEmptyTable given, then use the same as
		 * sZeroRecords - assuming that is given.
		 */
    if ( ! lang.sEmptyTable && zeroRecords &&
			defaults.sEmptyTable === "No data available in table" )
    {
      _fnMap( lang, lang, "sZeroRecords", "sEmptyTable" );
    }

    /* Likewise with loading records */
    if ( ! lang.sLoadingRecords && zeroRecords &&
			defaults.sLoadingRecords === "Loading..." )
    {
      _fnMap( lang, lang, "sZeroRecords", "sLoadingRecords" );
    }

    // Old parameter name of the thousands separator mapped onto the new
    if ( lang.sInfoThousands ) {
      lang.sThousands = lang.sInfoThousands;
    }

    var decimal = lang.sDecimal;
    if ( decimal ) {
      _addNumericSort( decimal );
    }
  }

  /**
	 * Map one parameter onto another
	 *  @param {object} o Object to map
	 *  @param {*} knew The new parameter name
	 *  @param {*} old The old parameter name
	 */
  var _fnCompatMap = function ( o, knew, old ) {
    if ( o[ knew ] !== undefined ) {
      o[ old ] = o[ knew ];
    }
  };

  /**
	 * Provide backwards compatibility for the main DT options. Note that the new
	 * options are mapped onto the old parameters, so this is an external interface
	 * change only.
	 *  @param {object} init Object to map
	 */
  function _fnCompatOpts( init )
  {
    _fnCompatMap( init, "ordering", "bSort" );
    _fnCompatMap( init, "orderMulti", "bSortMulti" );
    _fnCompatMap( init, "orderClasses", "bSortClasses" );
    _fnCompatMap( init, "orderCellsTop", "bSortCellsTop" );
    _fnCompatMap( init, "order", "aaSorting" );
    _fnCompatMap( init, "orderFixed", "aaSortingFixed" );
    _fnCompatMap( init, "paging", "bPaginate" );
    _fnCompatMap( init, "pagingType", "sPaginationType" );
    _fnCompatMap( init, "pageLength", "iDisplayLength" );
    _fnCompatMap( init, "searching", "bFilter" );

    // Boolean initialisation of x-scrolling
    if ( typeof init.sScrollX === "boolean" ) {
      init.sScrollX = init.sScrollX ? "100%" : "";
    }
    if ( typeof init.scrollX === "boolean" ) {
      init.scrollX = init.scrollX ? "100%" : "";
    }

    // Column search objects are in an array, so it needs to be converted
    // element by element
    var searchCols = init.aoSearchCols;

    if ( searchCols ) {
      for ( var i = 0, ien = searchCols.length ; i < ien ; i++ ) {
        if ( searchCols[i] ) {
          _fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
        }
      }
    }
  }

  /**
	 * Provide backwards compatibility for column options. Note that the new options
	 * are mapped onto the old parameters, so this is an external interface change
	 * only.
	 *  @param {object} init Object to map
	 */
  function _fnCompatCols( init )
  {
    _fnCompatMap( init, "orderable", "bSortable" );
    _fnCompatMap( init, "orderData", "aDataSort" );
    _fnCompatMap( init, "orderSequence", "asSorting" );
    _fnCompatMap( init, "orderDataType", "sortDataType" );

    // orderData can be given as an integer
    var dataSort = init.aDataSort;
    if ( typeof dataSort === "number" && ! $.isArray( dataSort ) ) {
      init.aDataSort = [ dataSort ];
    }
  }

  /**
	 * Browser feature detection for capabilities, quirks
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnBrowserDetect( settings )
  {
    // We don't need to do this every time DataTables is constructed, the values
    // calculated are specific to the browser and OS configuration which we
    // don't expect to change between initialisations
    if ( ! DataTable.__browser ) {
      var browser = {};
      DataTable.__browser = browser;

      // Scrolling feature / quirks detection
      var n = $("<div/>")
        .css( {
          position: "fixed",
          top: 0,
          left: $(window).scrollLeft() * -1, // allow for scrolling
          height: 1,
          width: 1,
          overflow: "hidden"
        } )
        .append(
          $("<div/>")
            .css( {
              position: "absolute",
              top: 1,
              left: 1,
              width: 100,
              overflow: "scroll"
            } )
            .append(
              $("<div/>")
                .css( {
                  width: "100%",
                  height: 10
                } )
            )
        )
        .appendTo( "body" );

      var outer = n.children();
      var inner = outer.children();

      // Numbers below, in order, are:
      // inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
      //
      // IE6 XP:                           100 100 100  83
      // IE7 Vista:                        100 100 100  83
      // IE 8+ Windows:                     83  83 100  83
      // Evergreen Windows:                 83  83 100  83
      // Evergreen Mac with scrollbars:     85  85 100  85
      // Evergreen Mac without scrollbars: 100 100 100 100

      // Get scrollbar width
      browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;

      // IE6/7 will oversize a width 100% element inside a scrolling element, to
      // include the width of the scrollbar, while other browsers ensure the inner
      // element is contained without forcing scrolling
      browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;

      // In rtl text layout, some browsers (most, but not all) will place the
      // scrollbar on the left, rather than the right.
      browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;

      // IE8- don't provide height and width for getBoundingClientRect
      browser.bBounding = n[0].getBoundingClientRect().width ? true : false;

      n.remove();
    }

    $.extend( settings.oBrowser, DataTable.__browser );
    settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
  }

  /**
	 * Array.prototype reduce[Right] method, used for browsers which don't support
	 * JS 1.6. Done this way to reduce code size, since we iterate either way
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnReduce( that, fn, init, start, end, inc )
  {
    var
      i = start,
      value,
      isSet = false;

    if ( init !== undefined ) {
      value = init;
      isSet = true;
    }

    while ( i !== end ) {
      if ( ! that.hasOwnProperty(i) ) {
        continue;
      }

      value = isSet ?
        fn( value, that[i], i, that ) :
        that[i];

      isSet = true;
      i += inc;
    }

    return value;
  }

  /**
	 * Add a column to the list used for the table with default values
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nTh The th element for this column
	 *  @memberof DataTable#oApi
	 */
  function _fnAddColumn( oSettings, nTh )
  {
    // Add column to aoColumns array
    var oDefaults = DataTable.defaults.column;
    var iCol = oSettings.aoColumns.length;
    var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
      "nTh": nTh ? nTh : document.createElement("th"),
      "sTitle": oDefaults.sTitle ? oDefaults.sTitle : nTh ? nTh.innerHTML : "",
      "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
      "mData": oDefaults.mData ? oDefaults.mData : iCol,
      idx: iCol
    } );
    oSettings.aoColumns.push( oCol );

    // Add search object for column specific search. Note that the `searchCols[ iCol ]`
    // passed into extend can be undefined. This allows the user to give a default
    // with only some of the parameters defined, and also not give a default
    var searchCols = oSettings.aoPreSearchCols;
    searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );

    // Use the default column options function to initialise classes etc
    _fnColumnOptions( oSettings, iCol, $(nTh).data() );
  }

  /**
	 * Apply options for a column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iCol column index to consider
	 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
	 *  @memberof DataTable#oApi
	 */
  function _fnColumnOptions( oSettings, iCol, oOptions )
  {
    var oCol = oSettings.aoColumns[ iCol ];
    var oClasses = oSettings.oClasses;
    var th = $(oCol.nTh);

    // Try to get width information from the DOM. We can't get it from CSS
    // as we'd need to parse the CSS stylesheet. `width` option can override
    if ( ! oCol.sWidthOrig ) {
      // Width attribute
      oCol.sWidthOrig = th.attr("width") || null;

      // Style attribute
      var t = (th.attr("style") || "").match(/width:\s*(\d+[pxem%]+)/);
      if ( t ) {
        oCol.sWidthOrig = t[1];
      }
    }

    /* User specified column options */
    if ( oOptions !== undefined && oOptions !== null )
    {
      // Backwards compatibility
      _fnCompatCols( oOptions );

      // Map camel case parameters to their Hungarian counterparts
      _fnCamelToHungarian( DataTable.defaults.column, oOptions );

      /* Backwards compatibility for mDataProp */
      if ( oOptions.mDataProp !== undefined && !oOptions.mData )
      {
        oOptions.mData = oOptions.mDataProp;
      }

      if ( oOptions.sType )
      {
        oCol._sManualType = oOptions.sType;
      }

      // `class` is a reserved word in Javascript, so we need to provide
      // the ability to use a valid name for the camel case input
      if ( oOptions.className && ! oOptions.sClass )
      {
        oOptions.sClass = oOptions.className;
      }
      if ( oOptions.sClass ) {
        th.addClass( oOptions.sClass );
      }

      $.extend( oCol, oOptions );
      _fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );

      /* iDataSort to be applied (backwards compatibility), but aDataSort will take
			 * priority if defined
			 */
      if ( oOptions.iDataSort !== undefined )
      {
        oCol.aDataSort = [ oOptions.iDataSort ];
      }
      _fnMap( oCol, oOptions, "aDataSort" );
    }

    /* Cache the data get and set functions for speed */
    var mDataSrc = oCol.mData;
    var mData = _fnGetObjectDataFn( mDataSrc );
    var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;

    var attrTest = function ( src ) {
      return typeof src === "string" && src.indexOf("@") !== -1;
    };
    oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
      attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
    );
    oCol._setter = null;

    oCol.fnGetData = function (rowData, type, meta) {
      var innerData = mData( rowData, type, undefined, meta );

      return mRender && type ?
        mRender( innerData, type, rowData, meta ) :
        innerData;
    };
    oCol.fnSetData = function ( rowData, val, meta ) {
      return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
    };

    // Indicate if DataTables should read DOM data as an object or array
    // Used in _fnGetRowElements
    if ( typeof mDataSrc !== "number" ) {
      oSettings._rowReadObject = true;
    }

    /* Feature sorting overrides column specific when off */
    if ( !oSettings.oFeatures.bSort )
    {
      oCol.bSortable = false;
      th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
    }

    /* Check that the class assignment is correct for sorting */
    var bAsc = $.inArray("asc", oCol.asSorting) !== -1;
    var bDesc = $.inArray("desc", oCol.asSorting) !== -1;
    if ( !oCol.bSortable || (!bAsc && !bDesc) )
    {
      oCol.sSortingClass = oClasses.sSortableNone;
      oCol.sSortingClassJUI = "";
    }
    else if ( bAsc && !bDesc )
    {
      oCol.sSortingClass = oClasses.sSortableAsc;
      oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
    }
    else if ( !bAsc && bDesc )
    {
      oCol.sSortingClass = oClasses.sSortableDesc;
      oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
    }
    else
    {
      oCol.sSortingClass = oClasses.sSortable;
      oCol.sSortingClassJUI = oClasses.sSortJUI;
    }
  }

  /**
	 * Adjust the table column widths for new data. Note: you would probably want to
	 * do a redraw after calling this function!
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnAdjustColumnSizing( settings )
  {
    /* Not interested in doing column width calculation if auto-width is disabled */
    if ( settings.oFeatures.bAutoWidth !== false )
    {
      var columns = settings.aoColumns;

      _fnCalculateColumnWidths( settings );
      for ( var i = 0, iLen = columns.length ; i < iLen ; i++ )
      {
        columns[i].nTh.style.width = columns[i].sWidth;
      }
    }

    var scroll = settings.oScroll;
    if ( scroll.sY !== "" || scroll.sX !== "")
    {
      _fnScrollDraw( settings );
    }

    _fnCallbackFire( settings, null, "column-sizing", [settings] );
  }

  /**
	 * Covert the index of a visible column to the index in the data array (take account
	 * of hidden columns)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iMatch Visible column index to lookup
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
  function _fnVisibleToColumnIndex( oSettings, iMatch )
  {
    var aiVis = _fnGetColumns( oSettings, "bVisible" );

    return typeof aiVis[iMatch] === "number" ?
      aiVis[iMatch] :
      null;
  }

  /**
	 * Covert the index of an index in the data array and convert it to the visible
	 *   column index (take account of hidden columns)
	 *  @param {int} iMatch Column index to lookup
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
  function _fnColumnIndexToVisible( oSettings, iMatch )
  {
    var aiVis = _fnGetColumns( oSettings, "bVisible" );
    var iPos = $.inArray( iMatch, aiVis );

    return iPos !== -1 ? iPos : null;
  }

  /**
	 * Get the number of visible columns
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the number of visible columns
	 *  @memberof DataTable#oApi
	 */
  function _fnVisbleColumns( oSettings )
  {
    var vis = 0;

    // No reduce in IE8, use a loop for now
    $.each( oSettings.aoColumns, function ( i, col ) {
      if ( col.bVisible && $(col.nTh).css("display") !== "none" ) {
        vis++;
      }
    } );

    return vis;
  }

  /**
	 * Get an array of column indexes that match a given property
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sParam Parameter in aoColumns to look for - typically
	 *    bVisible or bSearchable
	 *  @returns {array} Array of indexes with matched properties
	 *  @memberof DataTable#oApi
	 */
  function _fnGetColumns( oSettings, sParam )
  {
    var a = [];

    $.map( oSettings.aoColumns, function (val, i) {
      if ( val[sParam] ) {
        a.push( i );
      }
    } );

    return a;
  }

  /**
	 * Calculate the 'type' of a column
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnColumnTypes( settings )
  {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var types = DataTable.ext.type.detect;
    var i, ien, j, jen, k, ken;
    var col, cell, detectedType, cache;

    // For each column, spin over the
    for ( i = 0, ien = columns.length ; i < ien ; i++ ) {
      col = columns[i];
      cache = [];

      if ( ! col.sType && col._sManualType ) {
        col.sType = col._sManualType;
      }
      else if ( ! col.sType ) {
        for ( j = 0, jen = types.length ; j < jen ; j++ ) {
          for ( k = 0, ken = data.length ; k < ken ; k++ ) {
            // Use a cache array so we only need to get the type data
            // from the formatter once (when using multiple detectors)
            if ( cache[k] === undefined ) {
              cache[k] = _fnGetCellData( settings, k, i, "type" );
            }

            detectedType = types[j]( cache[k], settings );

            // If null, then this type can't apply to this column, so
            // rather than testing all cells, break out. There is an
            // exception for the last type which is `html`. We need to
            // scan all rows since it is possible to mix string and HTML
            // types
            if ( ! detectedType && j !== types.length - 1 ) {
              break;
            }

            // Only a single match is needed for html type since it is
            // bottom of the pile and very similar to string
            if ( detectedType === "html" ) {
              break;
            }
          }

          // Type is valid for all data points in the column - use this
          // type
          if ( detectedType ) {
            col.sType = detectedType;
            break;
          }
        }

        // Fall back - if no type was detected, always use string
        if ( ! col.sType ) {
          col.sType = "string";
        }
      }
    }
  }

  /**
	 * Take the column definitions and static columns arrays and calculate how
	 * they relate to column indexes. The callback function will then apply the
	 * definition found for a column to a suitable configuration object.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
	 *  @param {array} aoCols The aoColumns array that defines columns individually
	 *  @param {function} fn Callback function - takes two parameters, the calculated
	 *    column index and the definition for that column.
	 *  @memberof DataTable#oApi
	 */
  function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
  {
    var i, iLen, j, jLen, k, kLen, def;
    var columns = oSettings.aoColumns;

    // Column definitions with aTargets
    if ( aoColDefs )
    {
      /* Loop over the definitions array - loop in reverse so first instance has priority */
      for ( i = aoColDefs.length - 1 ; i >= 0 ; i-- )
      {
        def = aoColDefs[i];

        /* Each definition can target multiple columns, as it is an array */
        var aTargets = def.targets !== undefined ?
          def.targets :
          def.aTargets;

        if ( ! $.isArray( aTargets ) )
        {
          aTargets = [ aTargets ];
        }

        for ( j = 0, jLen = aTargets.length ; j < jLen ; j++ )
        {
          if ( typeof aTargets[j] === "number" && aTargets[j] >= 0 )
          {
            /* Add columns that we don't yet know about */
            while ( columns.length <= aTargets[j] )
            {
              _fnAddColumn( oSettings );
            }

            /* Integer, basic index */
            fn( aTargets[j], def );
          }
          else if ( typeof aTargets[j] === "number" && aTargets[j] < 0 )
          {
            /* Negative integer, right to left column counting */
            fn( columns.length + aTargets[j], def );
          }
          else if ( typeof aTargets[j] === "string" )
          {
            /* Class name matching on TH element */
            for ( k = 0, kLen = columns.length ; k < kLen ; k++ )
            {
              if ( aTargets[j] == "_all" ||
							     $(columns[k].nTh).hasClass( aTargets[j] ) )
              {
                fn( k, def );
              }
            }
          }
        }
      }
    }

    // Statically defined columns array
    if ( aoCols )
    {
      for ( i = 0, iLen = aoCols.length ; i < iLen ; i++ )
      {
        fn( i, aoCols[i] );
      }
    }
  }

  /**
	 * Add a data array to the table, creating DOM node etc. This is the parallel to
	 * _fnGatherData, but for adding rows from a Javascript source, rather than a
	 * DOM source.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aData data array to be added
	 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
	 *  @memberof DataTable#oApi
	 */
  function _fnAddData( oSettings, aDataIn, nTr, anTds )
  {
    /* Create the object for storing information about this new row */
    var iRow = oSettings.aoData.length;
    var oData = $.extend( true, {}, DataTable.models.oRow, {
      src: nTr ? "dom" : "data",
      idx: iRow
    } );

    oData._aData = aDataIn;
    oSettings.aoData.push( oData );

    /* Create the cells */
    var nTd, sThisType;
    var columns = oSettings.aoColumns;

    // Invalidate the column types as the new data needs to be revalidated
    for ( var i = 0, iLen = columns.length ; i < iLen ; i++ )
    {
      columns[i].sType = null;
    }

    /* Add to the display array */
    oSettings.aiDisplayMaster.push( iRow );

    var id = oSettings.rowIdFn( aDataIn );
    if ( id !== undefined ) {
      oSettings.aIds[ id ] = oData;
    }

    /* Create the DOM information, or register it if already present */
    if ( nTr || ! oSettings.oFeatures.bDeferRender )
    {
      _fnCreateTr( oSettings, iRow, nTr, anTds );
    }

    return iRow;
  }

  /**
	 * Add one or more TR elements to the table. Generally we'd expect to
	 * use this for reading data from a DOM sourced table, but it could be
	 * used for an TR element. Note that if a TR is given, it is used (i.e.
	 * it is not cloned).
	 *  @param {object} settings dataTables settings object
	 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
	 *  @returns {array} Array of indexes for the added rows
	 *  @memberof DataTable#oApi
	 */
  function _fnAddTr( settings, trs )
  {
    var row;

    // Allow an individual node to be passed in
    if ( ! (trs instanceof $) ) {
      trs = $(trs);
    }

    return trs.map( function (i, el) {
      row = _fnGetRowElements( settings, el );
      return _fnAddData( settings, row.data, el, row.cells );
    } );
  }

  /**
	 * Take a TR element and convert it to an index in aoData
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} n the TR element to find
	 *  @returns {int} index if the node is found, null if not
	 *  @memberof DataTable#oApi
	 */
  function _fnNodeToDataIndex( oSettings, n )
  {
    return (n._DT_RowIndex !== undefined) ? n._DT_RowIndex : null;
  }

  /**
	 * Take a TD element and convert it into a column data index (not the visible index)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow The row number the TD/TH can be found in
	 *  @param {node} n The TD/TH element to find
	 *  @returns {int} index if the node is found, -1 if not
	 *  @memberof DataTable#oApi
	 */
  function _fnNodeToColumnIndex( oSettings, iRow, n )
  {
    return $.inArray( n, oSettings.aoData[ iRow ].anCells );
  }

  /**
	 * Get the data for a given cell from the internal cache, taking into account data mapping
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
	 *  @returns {*} Cell data
	 *  @memberof DataTable#oApi
	 */
  function _fnGetCellData( settings, rowIdx, colIdx, type )
  {
    var draw = settings.iDraw;
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;
    var defaultContent = col.sDefaultContent;
    var cellData = col.fnGetData( rowData, type, {
      settings: settings,
      row: rowIdx,
      col: colIdx
    } );

    if ( cellData === undefined ) {
      if ( settings.iDrawError != draw && defaultContent === null ) {
        _fnLog( settings, 0, "Requested unknown parameter " +
					(typeof col.mData === "function" ? "{function}" : "'" + col.mData + "'") +
					" for row " + rowIdx + ", column " + colIdx, 4 );
        settings.iDrawError = draw;
      }
      return defaultContent;
    }

    // When the data source is null and a specific data type is requested (i.e.
    // not the original data), we can use default column data
    if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
      cellData = defaultContent;
    }
    else if ( typeof cellData === "function" ) {
      // If the data source is a function, then we run it and use the return,
      // executing in the scope of the data object (for instances)
      return cellData.call( rowData );
    }

    if ( cellData === null && type == "display" ) {
      return "";
    }
    return cellData;
  }

  /**
	 * Set the value for a specific cell, into the internal data cache
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {*} val Value to set
	 *  @memberof DataTable#oApi
	 */
  function _fnSetCellData( settings, rowIdx, colIdx, val )
  {
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;

    col.fnSetData( rowData, val, {
      settings: settings,
      row: rowIdx,
      col: colIdx
    } );
  }

  // Private variable that is used to match action syntax in the data property object
  var __reArray = /\[.*?\]$/;
  var __reFn = /\(\)$/;

  /**
	 * Split string on periods, taking into account escaped periods
	 * @param  {string} str String to split
	 * @return {array} Split string
	 */
  function _fnSplitObjNotation( str )
  {
    return $.map( str.match(/(\\.|[^\.])+/g) || [""], function ( s ) {
      return s.replace(/\\\./g, ".");
    } );
  }

  /**
	 * Return a function that can be used to get data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data get function
	 *  @memberof DataTable#oApi
	 */
  function _fnGetObjectDataFn( mSource )
  {
    if ( $.isPlainObject( mSource ) )
    {
      /* Build an object of get functions, and wrap them in a single call */
      var o = {};
      $.each( mSource, function (key, val) {
        if ( val ) {
          o[key] = _fnGetObjectDataFn( val );
        }
      } );

      return function (data, type, row, meta) {
        var t = o[type] || o._;
        return t !== undefined ?
          t(data, type, row, meta) :
          data;
      };
    }
    else if ( mSource === null )
    {
      /* Give an empty string for rendering / sorting etc */
      return function (data) { // type, row and meta also passed, but not used
        return data;
      };
    }
    else if ( typeof mSource === "function" )
    {
      return function (data, type, row, meta) {
        return mSource( data, type, row, meta );
      };
    }
    else if ( typeof mSource === "string" && (mSource.indexOf(".") !== -1 ||
			      mSource.indexOf("[") !== -1 || mSource.indexOf("(") !== -1) )
    {
      /* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */
      var fetchData = function (data, type, src) {
        var arrayNotation, funcNotation, out, innerSrc;

        if ( src !== "" )
        {
          var a = _fnSplitObjNotation( src );

          for ( var i = 0, iLen = a.length ; i < iLen ; i++ )
          {
            // Check if we are dealing with special notation
            arrayNotation = a[i].match(__reArray);
            funcNotation = a[i].match(__reFn);

            if ( arrayNotation )
            {
              // Array notation
              a[i] = a[i].replace(__reArray, "");

              // Condition allows simply [] to be passed in
              if ( a[i] !== "" ) {
                data = data[ a[i] ];
              }
              out = [];

              // Get the remainder of the nested object to get
              a.splice( 0, i + 1 );
              innerSrc = a.join(".");

              // Traverse each entry in the array getting the properties requested
              if ( $.isArray( data ) ) {
                for ( var j = 0, jLen = data.length ; j < jLen ; j++ ) {
                  out.push( fetchData( data[j], type, innerSrc ) );
                }
              }

              // If a string is given in between the array notation indicators, that
              // is used to join the strings together, otherwise an array is returned
              var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
              data = (join === "") ? out : out.join(join);

              // The inner call to fetchData has already traversed through the remainder
              // of the source requested, so we exit from the loop
              break;
            }
            else if ( funcNotation )
            {
              // Function call
              a[i] = a[i].replace(__reFn, "");
              data = data[ a[i] ]();
              continue;
            }

            if ( data === null || data[ a[i] ] === undefined )
            {
              return undefined;
            }
            data = data[ a[i] ];
          }
        }

        return data;
      };

      return function (data, type) { // row and meta also passed, but not used
        return fetchData( data, type, mSource );
      };
    }
    else
    {
      /* Array or flat object mapping */
      return function (data, type) { // row and meta also passed, but not used
        return data[mSource];
      };
    }
  }

  /**
	 * Return a function that can be used to set data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data set function
	 *  @memberof DataTable#oApi
	 */
  function _fnSetObjectDataFn( mSource )
  {
    if ( $.isPlainObject( mSource ) )
    {
      /* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */
      return _fnSetObjectDataFn( mSource._ );
    }
    else if ( mSource === null )
    {
      /* Nothing to do when the data source is null */
      return function () {};
    }
    else if ( typeof mSource === "function" )
    {
      return function (data, val, meta) {
        mSource( data, "set", val, meta );
      };
    }
    else if ( typeof mSource === "string" && (mSource.indexOf(".") !== -1 ||
			      mSource.indexOf("[") !== -1 || mSource.indexOf("(") !== -1) )
    {
      /* Like the get, we need to get data from a nested object */
      var setData = function (data, val, src) {
        var a = _fnSplitObjNotation( src ), b;
        var aLast = a[a.length - 1];
        var arrayNotation, funcNotation, o, innerSrc;

        for ( var i = 0, iLen = a.length - 1 ; i < iLen ; i++ )
        {
          // Check if we are dealing with an array notation request
          arrayNotation = a[i].match(__reArray);
          funcNotation = a[i].match(__reFn);

          if ( arrayNotation )
          {
            a[i] = a[i].replace(__reArray, "");
            data[ a[i] ] = [];

            // Get the remainder of the nested object to set so we can recurse
            b = a.slice();
            b.splice( 0, i + 1 );
            innerSrc = b.join(".");

            // Traverse each entry in the array setting the properties requested
            if ( $.isArray( val ) )
            {
              for ( var j = 0, jLen = val.length ; j < jLen ; j++ )
              {
                o = {};
                setData( o, val[j], innerSrc );
                data[ a[i] ].push( o );
              }
            }
            else
            {
              // We've been asked to save data to an array, but it
              // isn't array data to be saved. Best that can be done
              // is to just save the value.
              data[ a[i] ] = val;
            }

            // The inner call to setData has already traversed through the remainder
            // of the source and has set the data, thus we can exit here
            return;
          }
          else if ( funcNotation )
          {
            // Function call
            a[i] = a[i].replace(__reFn, "");
            data = data[ a[i] ]( val );
          }

          // If the nested object doesn't currently exist - since we are
          // trying to set the value - create it
          if ( data[ a[i] ] === null || data[ a[i] ] === undefined )
          {
            data[ a[i] ] = {};
          }
          data = data[ a[i] ];
        }

        // Last item in the input - i.e, the actual set
        if ( aLast.match(__reFn ) )
        {
          // Function call
          data = data[ aLast.replace(__reFn, "") ]( val );
        }
        else
        {
          // If array notation is used, we just want to strip it and use the property name
          // and assign the value. If it isn't used, then we get the result we want anyway
          data[ aLast.replace(__reArray, "") ] = val;
        }
      };

      return function (data, val) { // meta is also passed in, but not used
        return setData( data, val, mSource );
      };
    }
    else
    {
      /* Array or flat object mapping */
      return function (data, val) { // meta is also passed in, but not used
        data[mSource] = val;
      };
    }
  }

  /**
	 * Return an array with the full table data
	 *  @param {object} oSettings dataTables settings object
	 *  @returns array {array} aData Master data array
	 *  @memberof DataTable#oApi
	 */
  function _fnGetDataMaster( settings )
  {
    return _pluck( settings.aoData, "_aData" );
  }

  /**
	 * Nuke the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnClearTable( settings )
  {
    settings.aoData.length = 0;
    settings.aiDisplayMaster.length = 0;
    settings.aiDisplay.length = 0;
    settings.aIds = {};
  }

	 /**
	 * Take an array of integers (index array) and remove a target integer (value - not
	 * the key!)
	 *  @param {array} a Index array to target
	 *  @param {int} iTarget value to find
	 *  @memberof DataTable#oApi
	 */
  function _fnDeleteIndex( a, iTarget, splice )
  {
    var iTargetIndex = -1;

    for ( var i = 0, iLen = a.length ; i < iLen ; i++ )
    {
      if ( a[i] == iTarget )
      {
        iTargetIndex = i;
      }
      else if ( a[i] > iTarget )
      {
        a[i]--;
      }
    }

    if ( iTargetIndex != -1 && splice === undefined )
    {
      a.splice( iTargetIndex, 1 );
    }
  }

  /**
	 * Mark cached data as invalid such that a re-read of the data will occur when
	 * the cached data is next requested. Also update from the data source object.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {int}    rowIdx   Row index to invalidate
	 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
	 *     or 'data'
	 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
	 *     row will be invalidated
	 * @memberof DataTable#oApi
	 *
	 * @todo For the modularisation of v1.11 this will need to become a callback, so
	 *   the sort and filter methods can subscribe to it. That will required
	 *   initialisation options for sorting, which is why it is not already baked in
	 */
  function _fnInvalidate( settings, rowIdx, src, colIdx )
  {
    var row = settings.aoData[ rowIdx ];
    var i, ien;
    var cellWrite = function ( cell, col ) {
      // This is very frustrating, but in IE if you just write directly
      // to innerHTML, and elements that are overwritten are GC'ed,
      // even if there is a reference to them elsewhere
      while ( cell.childNodes.length ) {
        cell.removeChild( cell.firstChild );
      }

      cell.innerHTML = _fnGetCellData( settings, rowIdx, col, "display" );
    };

    // Are we reading last data from DOM or the data object?
    if ( src === "dom" || ((! src || src === "auto") && row.src === "dom") ) {
      // Read the data from the DOM
      row._aData = _fnGetRowElements(
        settings, row, colIdx, colIdx === undefined ? undefined : row._aData
      )
        .data;
    }
    else {
      // Reading from data object, update the DOM
      var cells = row.anCells;

      if ( cells ) {
        if ( colIdx !== undefined ) {
          cellWrite( cells[colIdx], colIdx );
        }
        else {
          for ( i = 0, ien = cells.length ; i < ien ; i++ ) {
            cellWrite( cells[i], i );
          }
        }
      }
    }

    // For both row and cell invalidation, the cached data for sorting and
    // filtering is nulled out
    row._aSortData = null;
    row._aFilterData = null;

    // Invalidate the type for a specific column (if given) or all columns since
    // the data might have changed
    var cols = settings.aoColumns;
    if ( colIdx !== undefined ) {
      cols[ colIdx ].sType = null;
    }
    else {
      for ( i = 0, ien = cols.length ; i < ien ; i++ ) {
        cols[i].sType = null;
      }

      // Update DataTables special `DT_*` attributes for the row
      _fnRowAttributes( settings, row );
    }
  }

  /**
	 * Build a data source object from an HTML row, reading the contents of the
	 * cells that are in the row.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {node|object} TR element from which to read data or existing row
	 *   object from which to re-read the data from the cells
	 * @param {int} [colIdx] Optional column index
	 * @param {array|object} [d] Data source object. If `colIdx` is given then this
	 *   parameter should also be given and will be used to write the data into.
	 *   Only the column in question will be written
	 * @returns {object} Object with two parameters: `data` the data read, in
	 *   document order, and `cells` and array of nodes (they can be useful to the
	 *   caller, so rather than needing a second traversal to get them, just return
	 *   them from here).
	 * @memberof DataTable#oApi
	 */
  function _fnGetRowElements( settings, row, colIdx, d )
  {
    var
      tds = [],
      td = row.firstChild,
      name, col, o, i = 0, contents,
      columns = settings.aoColumns,
      objectRead = settings._rowReadObject;

    // Allow the data object to be passed in, or construct
    d = d !== undefined ?
      d :
      objectRead ?
        {} :
        [];

    var attr = function ( str, td ) {
      if ( typeof str === "string" ) {
        var idx = str.indexOf("@");

        if ( idx !== -1 ) {
          var attr = str.substring( idx + 1 );
          var setter = _fnSetObjectDataFn( str );
          setter( d, td.getAttribute( attr ) );
        }
      }
    };

    // Read data from a cell and store into the data object
    var cellProcess = function ( cell ) {
      if ( colIdx === undefined || colIdx === i ) {
        col = columns[i];
        contents = $.trim(cell.innerHTML);

        if ( col && col._bAttrSrc ) {
          var setter = _fnSetObjectDataFn( col.mData._ );
          setter( d, contents );

          attr( col.mData.sort, cell );
          attr( col.mData.type, cell );
          attr( col.mData.filter, cell );
        }
        else {
          // Depending on the `data` option for the columns the data can
          // be read to either an object or an array.
          if ( objectRead ) {
            if ( ! col._setter ) {
              // Cache the setter function
              col._setter = _fnSetObjectDataFn( col.mData );
            }
            col._setter( d, contents );
          }
          else {
            d[i] = contents;
          }
        }
      }

      i++;
    };

    if ( td ) {
      // `tr` element was passed in
      while ( td ) {
        name = td.nodeName.toUpperCase();

        if ( name == "TD" || name == "TH" ) {
          cellProcess( td );
          tds.push( td );
        }

        td = td.nextSibling;
      }
    }
    else {
      // Existing row object passed in
      tds = row.anCells;

      for ( var j = 0, jen = tds.length ; j < jen ; j++ ) {
        cellProcess( tds[j] );
      }
    }

    // Read the ID from the DOM if present
    var rowNode = row.firstChild ? row : row.nTr;

    if ( rowNode ) {
      var id = rowNode.getAttribute( "id" );

      if ( id ) {
        _fnSetObjectDataFn( settings.rowId )( d, id );
      }
    }

    return {
      data: d,
      cells: tds
    };
  }
  /**
	 * Create a new TR element (and it's TD children) for a row
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow Row to consider
	 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @memberof DataTable#oApi
	 */
  function _fnCreateTr( oSettings, iRow, nTrIn, anTds )
  {
    var
      row = oSettings.aoData[iRow],
      rowData = row._aData,
      cells = [],
      nTr, nTd, oCol,
      i, iLen;

    if ( row.nTr === null )
    {
      nTr = nTrIn || document.createElement("tr");

      row.nTr = nTr;
      row.anCells = cells;

      /* Use a private property on the node to allow reserve mapping from the node
			 * to the aoData array for fast look up
			 */
      nTr._DT_RowIndex = iRow;

      /* Special parameters can be given by the data source to be used on the row */
      _fnRowAttributes( oSettings, row );

      /* Process each column */
      for ( i = 0, iLen = oSettings.aoColumns.length ; i < iLen ; i++ )
      {
        oCol = oSettings.aoColumns[i];

        nTd = nTrIn ? anTds[i] : document.createElement( oCol.sCellType );
        nTd._DT_CellIndex = {
          row: iRow,
          column: i
        };

        cells.push( nTd );

        // Need to create the HTML if new, or if a rendering function is defined
        if ( (!nTrIn || oCol.mRender || oCol.mData !== i) &&
					 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i + ".display")
        ) {
          nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, "display" );
        }

        /* Add user defined class */
        if ( oCol.sClass )
        {
          nTd.className += " " + oCol.sClass;
        }

        // Visibility - add or remove as required
        if ( oCol.bVisible && ! nTrIn )
        {
          nTr.appendChild( nTd );
        }
        else if ( ! oCol.bVisible && nTrIn )
        {
          nTd.parentNode.removeChild( nTd );
        }

        if ( oCol.fnCreatedCell )
        {
          oCol.fnCreatedCell.call( oSettings.oInstance,
            nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
          );
        }
      }

      _fnCallbackFire( oSettings, "aoRowCreatedCallback", null, [nTr, rowData, iRow] );
    }

    // Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
    // and deployed
    row.nTr.setAttribute( "role", "row" );
  }

  /**
	 * Add attributes to a row based on the special `DT_*` parameters in a data
	 * source object.
	 *  @param {object} settings DataTables settings object
	 *  @param {object} DataTables row object for the row to be modified
	 *  @memberof DataTable#oApi
	 */
  function _fnRowAttributes( settings, row )
  {
    var tr = row.nTr;
    var data = row._aData;

    if ( tr ) {
      var id = settings.rowIdFn( data );

      if ( id ) {
        tr.id = id;
      }

      if ( data.DT_RowClass ) {
        // Remove any classes added by DT_RowClass before
        var a = data.DT_RowClass.split(" ");
        row.__rowc = row.__rowc ?
          _unique( row.__rowc.concat( a ) ) :
          a;

        $(tr)
          .removeClass( row.__rowc.join(" ") )
          .addClass( data.DT_RowClass );
      }

      if ( data.DT_RowAttr ) {
        $(tr).attr( data.DT_RowAttr );
      }

      if ( data.DT_RowData ) {
        $(tr).data( data.DT_RowData );
      }
    }
  }

  /**
	 * Create the HTML header for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnBuildHead( oSettings )
  {
    var i, ien, cell, row, column;
    var thead = oSettings.nTHead;
    var tfoot = oSettings.nTFoot;
    var createHeader = $("th, td", thead).length === 0;
    var classes = oSettings.oClasses;
    var columns = oSettings.aoColumns;

    if ( createHeader ) {
      row = $("<tr/>").appendTo( thead );
    }

    for ( i = 0, ien = columns.length ; i < ien ; i++ ) {
      column = columns[i];
      cell = $( column.nTh ).addClass( column.sClass );

      if ( createHeader ) {
        cell.appendTo( row );
      }

      // 1.11 move into sorting
      if ( oSettings.oFeatures.bSort ) {
        cell.addClass( column.sSortingClass );

        if ( column.bSortable !== false ) {
          cell
            .attr( "tabindex", oSettings.iTabIndex )
            .attr( "aria-controls", oSettings.sTableId );

          _fnSortAttachListener( oSettings, column.nTh, i );
        }
      }

      if ( column.sTitle != cell[0].innerHTML ) {
        cell.html( column.sTitle );
      }

      _fnRenderer( oSettings, "header" )(
        oSettings, cell, column, classes
      );
    }

    if ( createHeader ) {
      _fnDetectHeader( oSettings.aoHeader, thead );
    }

    /* ARIA role for the rows */
	 	$(thead).find(">tr").attr("role", "row");

    /* Deal with the footer - add classes if required */
    $(thead).find(">tr>th, >tr>td").addClass( classes.sHeaderTH );
    $(tfoot).find(">tr>th, >tr>td").addClass( classes.sFooterTH );

    // Cache the footer cells. Note that we only take the cells from the first
    // row in the footer. If there is more than one row the user wants to
    // interact with, they need to use the table().foot() method. Note also this
    // allows cells to be used for multiple columns using colspan
    if ( tfoot !== null ) {
      var cells = oSettings.aoFooter[0];

      for ( i = 0, ien = cells.length ; i < ien ; i++ ) {
        column = columns[i];
        column.nTf = cells[i].cell;

        if ( column.sClass ) {
          $(column.nTf).addClass( column.sClass );
        }
      }
    }
  }

  /**
	 * Draw the header (or footer) element based on the column visibility states. The
	 * methodology here is to use the layout array from _fnDetectHeader, modified for
	 * the instantaneous column visibility, to construct the new layout. The grid is
	 * traversed over cell at a time in a rows x columns grid fashion, although each
	 * cell insert can cover multiple elements in the grid - which is tracks using the
	 * aApplied array. Cell inserts in the grid will only occur where there isn't
	 * already a cell in that position.
	 *  @param {object} oSettings dataTables settings object
	 *  @param array {objects} aoSource Layout array from _fnDetectHeader
	 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
	 *  @memberof DataTable#oApi
	 */
  function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
  {
    var i, iLen, j, jLen, k, kLen, n, nLocalTr;
    var aoLocal = [];
    var aApplied = [];
    var iColumns = oSettings.aoColumns.length;
    var iRowspan, iColspan;

    if ( ! aoSource )
    {
      return;
    }

    if ( bIncludeHidden === undefined )
    {
      bIncludeHidden = false;
    }

    /* Make a copy of the master layout array, but without the visible columns in it */
    for ( i = 0, iLen = aoSource.length ; i < iLen ; i++ )
    {
      aoLocal[i] = aoSource[i].slice();
      aoLocal[i].nTr = aoSource[i].nTr;

      /* Remove any columns which are currently hidden */
      for ( j = iColumns - 1 ; j >= 0 ; j-- )
      {
        if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
        {
          aoLocal[i].splice( j, 1 );
        }
      }

      /* Prep the applied array - it needs an element for each row */
      aApplied.push( [] );
    }

    for ( i = 0, iLen = aoLocal.length ; i < iLen ; i++ )
    {
      nLocalTr = aoLocal[i].nTr;

      /* All cells are going to be replaced, so empty out the row */
      if ( nLocalTr )
      {
        while ( (n = nLocalTr.firstChild) )
        {
          nLocalTr.removeChild( n );
        }
      }

      for ( j = 0, jLen = aoLocal[i].length ; j < jLen ; j++ )
      {
        iRowspan = 1;
        iColspan = 1;

        /* Check to see if there is already a cell (row/colspan) covering our target
				 * insert point. If there is, then there is nothing to do.
				 */
        if ( aApplied[i][j] === undefined )
        {
          nLocalTr.appendChild( aoLocal[i][j].cell );
          aApplied[i][j] = 1;

          /* Expand the cell to cover as many rows as needed */
          while ( aoLocal[i + iRowspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i + iRowspan][j].cell )
          {
            aApplied[i + iRowspan][j] = 1;
            iRowspan++;
          }

          /* Expand the cell to cover as many columns as needed */
          while ( aoLocal[i][j + iColspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i][j + iColspan].cell )
          {
            /* Must update the applied array over the rows for the columns */
            for ( k = 0 ; k < iRowspan ; k++ )
            {
              aApplied[i + k][j + iColspan] = 1;
            }
            iColspan++;
          }

          /* Do the actual expansion in the DOM */
          $(aoLocal[i][j].cell)
            .attr("rowspan", iRowspan)
            .attr("colspan", iColspan);
        }
      }
    }
  }

  /**
	 * Insert the required TR nodes into the table for display
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnDraw( oSettings )
  {
    /* Provide a pre-callback function which can be used to cancel the draw is false is returned */
    var aPreDraw = _fnCallbackFire( oSettings, "aoPreDrawCallback", "preDraw", [oSettings] );
    if ( $.inArray( false, aPreDraw ) !== -1 )
    {
      _fnProcessingDisplay( oSettings, false );
      return;
    }

    var i, iLen, n;
    var anRows = [];
    var iRowCount = 0;
    var asStripeClasses = oSettings.asStripeClasses;
    var iStripes = asStripeClasses.length;
    var iOpenRows = oSettings.aoOpenRows.length;
    var oLang = oSettings.oLanguage;
    var iInitDisplayStart = oSettings.iInitDisplayStart;
    var bServerSide = _fnDataSource( oSettings ) == "ssp";
    var aiDisplay = oSettings.aiDisplay;

    oSettings.bDrawing = true;

    /* Check and see if we have an initial draw position from state saving */
    if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
    {
      oSettings._iDisplayStart = bServerSide ?
        iInitDisplayStart :
        iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
          0 :
          iInitDisplayStart;

      oSettings.iInitDisplayStart = -1;
    }

    var iDisplayStart = oSettings._iDisplayStart;
    var iDisplayEnd = oSettings.fnDisplayEnd();

    /* Server-side processing draw intercept */
    if ( oSettings.bDeferLoading )
    {
      oSettings.bDeferLoading = false;
      oSettings.iDraw++;
      _fnProcessingDisplay( oSettings, false );
    }
    else if ( !bServerSide )
    {
      oSettings.iDraw++;
    }
    else if ( !oSettings.bDestroying && !_fnAjaxUpdate( oSettings ) )
    {
      return;
    }

    if ( aiDisplay.length !== 0 )
    {
      var iStart = bServerSide ? 0 : iDisplayStart;
      var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;

      for ( var j = iStart ; j < iEnd ; j++ )
      {
        var iDataIndex = aiDisplay[j];
        var aoData = oSettings.aoData[ iDataIndex ];
        if ( aoData.nTr === null )
        {
          _fnCreateTr( oSettings, iDataIndex );
        }

        var nRow = aoData.nTr;

        /* Remove the old striping classes and then add the new one */
        if ( iStripes !== 0 )
        {
          var sStripe = asStripeClasses[ iRowCount % iStripes ];
          if ( aoData._sRowStripe != sStripe )
          {
            $(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
            aoData._sRowStripe = sStripe;
          }
        }

        // Row callback functions - might want to manipulate the row
        // iRowCount and j are not currently documented. Are they at all
        // useful?
        _fnCallbackFire( oSettings, "aoRowCallback", null,
          [nRow, aoData._aData, iRowCount, j] );

        anRows.push( nRow );
        iRowCount++;
      }
    }
    else
    {
      /* Table is empty - create a row with an empty message in it */
      var sZero = oLang.sZeroRecords;
      if ( oSettings.iDraw == 1 && _fnDataSource( oSettings ) == "ajax" )
      {
        sZero = oLang.sLoadingRecords;
      }
      else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
      {
        sZero = oLang.sEmptyTable;
      }

      anRows[ 0 ] = $( "<tr/>", { "class": iStripes ? asStripeClasses[0] : "" } )
        .append( $("<td />", {
          "valign": "top",
          "colSpan": _fnVisbleColumns( oSettings ),
          "class": oSettings.oClasses.sRowEmpty
        } ).html( sZero ) )[0];
    }

    /* Header and footer callbacks */
    _fnCallbackFire( oSettings, "aoHeaderCallback", "header", [ $(oSettings.nTHead).children("tr")[0],
      _fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );

    _fnCallbackFire( oSettings, "aoFooterCallback", "footer", [ $(oSettings.nTFoot).children("tr")[0],
      _fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );

    var body = $(oSettings.nTBody);

    body.children().detach();
    body.append( $(anRows) );

    /* Call all required callback functions for the end of a draw */
    _fnCallbackFire( oSettings, "aoDrawCallback", "draw", [oSettings] );

    /* Draw is complete, sorting and filtering must be as well */
    oSettings.bSorted = false;
    oSettings.bFiltered = false;
    oSettings.bDrawing = false;
  }

  /**
	 * Redraw the table - taking account of the various features which are enabled
	 *  @param {object} oSettings dataTables settings object
	 *  @param {boolean} [holdPosition] Keep the current paging position. By default
	 *    the paging is reset to the first page
	 *  @memberof DataTable#oApi
	 */
  function _fnReDraw( settings, holdPosition )
  {
    var
      features = settings.oFeatures,
      sort = features.bSort,
      filter = features.bFilter;

    if ( sort ) {
      _fnSort( settings );
    }

    if ( filter ) {
      _fnFilterComplete( settings, settings.oPreviousSearch );
    }
    else {
      // No filtering, so we want to just use the display master
      settings.aiDisplay = settings.aiDisplayMaster.slice();
    }

    if ( holdPosition !== true ) {
      settings._iDisplayStart = 0;
    }

    // Let any modules know about the draw hold position state (used by
    // scrolling internally)
    settings._drawHold = holdPosition;

    _fnDraw( settings );

    settings._drawHold = false;
  }

  /**
	 * Add the options to the page HTML for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnAddOptionsHtml( oSettings )
  {
    var classes = oSettings.oClasses;
    var table = $(oSettings.nTable);
    var holding = $("<div/>").insertBefore( table ); // Holding element for speed
    var features = oSettings.oFeatures;

    // All DataTables are wrapped in a div
    var insert = $("<div/>", {
      id: oSettings.sTableId + "_wrapper",
      "class": classes.sWrapper + (oSettings.nTFoot ? "" : " " + classes.sNoFooter)
    } );

    oSettings.nHolding = holding[0];
    oSettings.nTableWrapper = insert[0];
    oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;

    /* Loop over the user set positioning and place the elements as needed */
    var aDom = oSettings.sDom.split("");
    var featureNode, cOption, nNewNode, cNext, sAttr, j;
    for ( var i = 0 ; i < aDom.length ; i++ )
    {
      featureNode = null;
      cOption = aDom[i];

      if ( cOption == "<" )
      {
        /* New container div */
        nNewNode = $("<div/>")[0];

        /* Check to see if we should append an id and/or a class name to the container */
        cNext = aDom[i + 1];
        if ( cNext == "'" || cNext == "\"" )
        {
          sAttr = "";
          j = 2;
          while ( aDom[i + j] != cNext )
          {
            sAttr += aDom[i + j];
            j++;
          }

          /* Replace jQuery UI constants @todo depreciated */
          if ( sAttr == "H" )
          {
            sAttr = classes.sJUIHeader;
          }
          else if ( sAttr == "F" )
          {
            sAttr = classes.sJUIFooter;
          }

          /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
					 * breaks the string into parts and applies them as needed
					 */
          if ( sAttr.indexOf(".") != -1 )
          {
            var aSplit = sAttr.split(".");
            nNewNode.id = aSplit[0].substr(1, aSplit[0].length - 1);
            nNewNode.className = aSplit[1];
          }
          else if ( sAttr.charAt(0) == "#" )
          {
            nNewNode.id = sAttr.substr(1, sAttr.length - 1);
          }
          else
          {
            nNewNode.className = sAttr;
          }

          i += j; /* Move along the position array */
        }

        insert.append( nNewNode );
        insert = $(nNewNode);
      }
      else if ( cOption == ">" )
      {
        /* End container div */
        insert = insert.parent();
      }
      // @todo Move options into their own plugins?
      else if ( cOption == "l" && features.bPaginate && features.bLengthChange )
      {
        /* Length */
        featureNode = _fnFeatureHtmlLength( oSettings );
      }
      else if ( cOption == "f" && features.bFilter )
      {
        /* Filter */
        featureNode = _fnFeatureHtmlFilter( oSettings );
      }
      else if ( cOption == "r" && features.bProcessing )
      {
        /* pRocessing */
        featureNode = _fnFeatureHtmlProcessing( oSettings );
      }
      else if ( cOption == "t" )
      {
        /* Table */
        featureNode = _fnFeatureHtmlTable( oSettings );
      }
      else if ( cOption == "i" && features.bInfo )
      {
        /* Info */
        featureNode = _fnFeatureHtmlInfo( oSettings );
      }
      else if ( cOption == "p" && features.bPaginate )
      {
        /* Pagination */
        featureNode = _fnFeatureHtmlPaginate( oSettings );
      }
      else if ( DataTable.ext.feature.length !== 0 )
      {
        /* Plug-in features */
        var aoFeatures = DataTable.ext.feature;
        for ( var k = 0, kLen = aoFeatures.length ; k < kLen ; k++ )
        {
          if ( cOption == aoFeatures[k].cFeature )
          {
            featureNode = aoFeatures[k].fnInit( oSettings );
            break;
          }
        }
      }

      /* Add to the 2D features array */
      if ( featureNode )
      {
        var aanFeatures = oSettings.aanFeatures;

        if ( ! aanFeatures[cOption] )
        {
          aanFeatures[cOption] = [];
        }

        aanFeatures[cOption].push( featureNode );
        insert.append( featureNode );
      }
    }

    /* Built our DOM structure - replace the holding div with what we want */
    holding.replaceWith( insert );
    oSettings.nHolding = null;
  }

  /**
	 * Use the DOM source to create up an array of header cells. The idea here is to
	 * create a layout grid (array) of rows x columns, which contains a reference
	 * to the cell that that point in the grid (regardless of col/rowspan), such that
	 * any column / row could be removed and the new grid constructed
	 *  @param array {object} aLayout Array to store the calculated layout in
	 *  @param {node} nThead The header/footer element for the table
	 *  @memberof DataTable#oApi
	 */
  function _fnDetectHeader( aLayout, nThead )
  {
    var nTrs = $(nThead).children("tr");
    var nTr, nCell;
    var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
    var bUnique;
    var fnShiftCol = function ( a, i, j ) {
      var k = a[i];
	                while ( k[j] ) {
        j++;
      }
      return j;
    };

    aLayout.splice( 0, aLayout.length );

    /* We know how many rows there are in the layout - so prep it */
    for ( i = 0, iLen = nTrs.length ; i < iLen ; i++ )
    {
      aLayout.push( [] );
    }

    /* Calculate a layout array */
    for ( i = 0, iLen = nTrs.length ; i < iLen ; i++ )
    {
      nTr = nTrs[i];
      iColumn = 0;

      /* For every cell in the row... */
      nCell = nTr.firstChild;
      while ( nCell ) {
        if ( nCell.nodeName.toUpperCase() == "TD" ||
				     nCell.nodeName.toUpperCase() == "TH" )
        {
          /* Get the col and rowspan attributes from the DOM and sanitise them */
          iColspan = nCell.getAttribute("colspan") * 1;
          iRowspan = nCell.getAttribute("rowspan") * 1;
          iColspan = (!iColspan || iColspan === 0 || iColspan === 1) ? 1 : iColspan;
          iRowspan = (!iRowspan || iRowspan === 0 || iRowspan === 1) ? 1 : iRowspan;

          /* There might be colspan cells already in this row, so shift our target
					 * accordingly
					 */
          iColShifted = fnShiftCol( aLayout, i, iColumn );

          /* Cache calculation for unique columns */
          bUnique = iColspan === 1 ? true : false;

          /* If there is col / rowspan, copy the information into the layout grid */
          for ( l = 0 ; l < iColspan ; l++ )
          {
            for ( k = 0 ; k < iRowspan ; k++ )
            {
              aLayout[i + k][iColShifted + l] = {
                "cell": nCell,
                "unique": bUnique
              };
              aLayout[i + k].nTr = nTr;
            }
          }
        }
        nCell = nCell.nextSibling;
      }
    }
  }

  /**
	 * Get an array of unique th elements, one for each column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nHeader automatically detect the layout from this node - optional
	 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
	 *  @returns array {node} aReturn list of unique th's
	 *  @memberof DataTable#oApi
	 */
  function _fnGetUniqueThs( oSettings, nHeader, aLayout )
  {
    var aReturn = [];
    if ( !aLayout )
    {
      aLayout = oSettings.aoHeader;
      if ( nHeader )
      {
        aLayout = [];
        _fnDetectHeader( aLayout, nHeader );
      }
    }

    for ( var i = 0, iLen = aLayout.length ; i < iLen ; i++ )
    {
      for ( var j = 0, jLen = aLayout[i].length ; j < jLen ; j++ )
      {
        if ( aLayout[i][j].unique &&
					 (!aReturn[j] || !oSettings.bSortCellsTop) )
        {
          aReturn[j] = aLayout[i][j].cell;
        }
      }
    }

    return aReturn;
  }

  /**
	 * Create an Ajax call based on the table's settings, taking into account that
	 * parameters can have multiple forms, and backwards compatibility.
	 *
	 * @param {object} oSettings dataTables settings object
	 * @param {array} data Data to send to the server, required by
	 *     DataTables - may be augmented by developer callbacks
	 * @param {function} fn Callback function to run when data is obtained
	 */
  function _fnBuildAjax( oSettings, data, fn )
  {
    // Compatibility with 1.9-, allow fnServerData and event to manipulate
    _fnCallbackFire( oSettings, "aoServerParams", "serverParams", [data] );

    // Convert to object based for 1.10+ if using the old array scheme which can
    // come from server-side processing or serverParams
    if ( data && $.isArray(data) ) {
      var tmp = {};
      var rbracket = /(.*?)\[\]$/;

      $.each( data, function (key, val) {
        var match = val.name.match(rbracket);

        if ( match ) {
          // Support for arrays
          var name = match[0];

          if ( ! tmp[ name ] ) {
            tmp[ name ] = [];
          }
          tmp[ name ].push( val.value );
        }
        else {
          tmp[val.name] = val.value;
        }
      } );
      data = tmp;
    }

    var ajaxData;
    var ajax = oSettings.ajax;
    var instance = oSettings.oInstance;
    var callback = function ( json ) {
      _fnCallbackFire( oSettings, null, "xhr", [oSettings, json, oSettings.jqXHR] );
      fn( json );
    };

    if ( $.isPlainObject( ajax ) && ajax.data )
    {
      ajaxData = ajax.data;

      var newData = $.isFunction( ajaxData ) ?
        ajaxData( data, oSettings ) : // fn can manipulate data or return
        ajaxData; // an object object or array to merge

      // If the function returned something, use that alone
      data = $.isFunction( ajaxData ) && newData ?
        newData :
        $.extend( true, data, newData );

      // Remove the data property as we've resolved it already and don't want
      // jQuery to do it again (it is restored at the end of the function)
      delete ajax.data;
    }

    var baseAjax = {
      "data": data,
      "success": function (json) {
        var error = json.error || json.sError;
        if ( error ) {
          _fnLog( oSettings, 0, error );
        }

        oSettings.json = json;
        callback( json );
      },
      "dataType": "json",
      "cache": false,
      "type": oSettings.sServerMethod,
      "error": function (xhr, error, thrown) {
        var ret = _fnCallbackFire( oSettings, null, "xhr", [oSettings, null, oSettings.jqXHR] );

        if ( $.inArray( true, ret ) === -1 ) {
          if ( error == "parsererror" ) {
            _fnLog( oSettings, 0, "Invalid JSON response", 1 );
          }
          else if ( xhr.readyState === 4 ) {
            _fnLog( oSettings, 0, "Ajax error", 7 );
          }
        }

        _fnProcessingDisplay( oSettings, false );
      }
    };

    // Store the data submitted for the API
    oSettings.oAjaxData = data;

    // Allow plug-ins and external processes to modify the data
    _fnCallbackFire( oSettings, null, "preXhr", [oSettings, data] );

    if ( oSettings.fnServerData )
    {
      // DataTables 1.9- compatibility
      oSettings.fnServerData.call( instance,
        oSettings.sAjaxSource,
        $.map( data, function (val, key) { // Need to convert back to 1.9 trad format
          return { name: key, value: val };
        } ),
        callback,
        oSettings
      );
    }
    else if ( oSettings.sAjaxSource || typeof ajax === "string" )
    {
      // DataTables 1.9- compatibility
      oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
        url: ajax || oSettings.sAjaxSource
      } ) );
    }
    else if ( $.isFunction( ajax ) )
    {
      // Is a function - let the caller define what needs to be done
      oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
    }
    else
    {
      // Object to extend the base settings
      oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );

      // Restore for next time around
      ajax.data = ajaxData;
    }
  }

  /**
	 * Update the table using an Ajax call
	 *  @param {object} settings dataTables settings object
	 *  @returns {boolean} Block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
  function _fnAjaxUpdate( settings )
  {
    if ( settings.bAjaxDataGet ) {
      settings.iDraw++;
      _fnProcessingDisplay( settings, true );

      _fnBuildAjax(
        settings,
        _fnAjaxParameters( settings ),
        function (json) {
          _fnAjaxUpdateDraw( settings, json );
        }
      );

      return false;
    }
    return true;
  }

  /**
	 * Build up the parameters in an object needed for a server-side processing
	 * request. Note that this is basically done twice, is different ways - a modern
	 * method which is used by default in DataTables 1.10 which uses objects and
	 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
	 * the sAjaxSource option is used in the initialisation, or the legacyAjax
	 * option is set.
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {bool} block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
  function _fnAjaxParameters( settings )
  {
    var
      columns = settings.aoColumns,
      columnCount = columns.length,
      features = settings.oFeatures,
      preSearch = settings.oPreviousSearch,
      preColSearch = settings.aoPreSearchCols,
      i, data = [], dataProp, column, columnSearch,
      sort = _fnSortFlatten( settings ),
      displayStart = settings._iDisplayStart,
      displayLength = features.bPaginate !== false ?
        settings._iDisplayLength :
        -1;

    var param = function ( name, value ) {
      data.push( { "name": name, "value": value } );
    };

    // DataTables 1.9- compatible method
    param( "sEcho", settings.iDraw );
    param( "iColumns", columnCount );
    param( "sColumns", _pluck( columns, "sName" ).join(",") );
    param( "iDisplayStart", displayStart );
    param( "iDisplayLength", displayLength );

    // DataTables 1.10+ method
    var d = {
      draw: settings.iDraw,
      columns: [],
      order: [],
      start: displayStart,
      length: displayLength,
      search: {
        value: preSearch.sSearch,
        regex: preSearch.bRegex
      }
    };

    for ( i = 0 ; i < columnCount ; i++ ) {
      column = columns[i];
      columnSearch = preColSearch[i];
      dataProp = typeof column.mData === "function" ? "function" : column.mData ;

      d.columns.push( {
        data: dataProp,
        name: column.sName,
        searchable: column.bSearchable,
        orderable: column.bSortable,
        search: {
          value: columnSearch.sSearch,
          regex: columnSearch.bRegex
        }
      } );

      param( "mDataProp_" + i, dataProp );

      if ( features.bFilter ) {
        param( "sSearch_" + i, columnSearch.sSearch );
        param( "bRegex_" + i, columnSearch.bRegex );
        param( "bSearchable_" + i, column.bSearchable );
      }

      if ( features.bSort ) {
        param( "bSortable_" + i, column.bSortable );
      }
    }

    if ( features.bFilter ) {
      param( "sSearch", preSearch.sSearch );
      param( "bRegex", preSearch.bRegex );
    }

    if ( features.bSort ) {
      $.each( sort, function ( i, val ) {
        d.order.push( { column: val.col, dir: val.dir } );

        param( "iSortCol_" + i, val.col );
        param( "sSortDir_" + i, val.dir );
      } );

      param( "iSortingCols", sort.length );
    }

    // If the legacy.ajax parameter is null, then we automatically decide which
    // form to use, based on sAjaxSource
    var legacy = DataTable.ext.legacy.ajax;
    if ( legacy === null ) {
      return settings.sAjaxSource ? data : d;
    }

    // Otherwise, if legacy has been specified then we use that to decide on the
    // form
    return legacy ? data : d;
  }

  /**
	 * Data the data from the server (nuking the old) and redraw the table
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} json json data return from the server.
	 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
	 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
	 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
	 *  @param {array} json.aaData The data to display on this page
	 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
	 *  @memberof DataTable#oApi
	 */
  function _fnAjaxUpdateDraw( settings, json )
  {
    // v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
    // Support both
    var compat = function ( old, modern ) {
      return json[old] !== undefined ? json[old] : json[modern];
    };

    var data = _fnAjaxDataSrc( settings, json );
    var draw = compat( "sEcho", "draw" );
    var recordsTotal = compat( "iTotalRecords", "recordsTotal" );
    var recordsFiltered = compat( "iTotalDisplayRecords", "recordsFiltered" );

    if ( draw ) {
      // Protect against out of sequence returns
      if ( draw * 1 < settings.iDraw ) {
        return;
      }
      settings.iDraw = draw * 1;
    }

    _fnClearTable( settings );
    settings._iRecordsTotal = parseInt(recordsTotal, 10);
    settings._iRecordsDisplay = parseInt(recordsFiltered, 10);

    for ( var i = 0, ien = data.length ; i < ien ; i++ ) {
      _fnAddData( settings, data[i] );
    }
    settings.aiDisplay = settings.aiDisplayMaster.slice();

    settings.bAjaxDataGet = false;
    _fnDraw( settings );

    if ( ! settings._bInitComplete ) {
      _fnInitComplete( settings, json );
    }

    settings.bAjaxDataGet = true;
    _fnProcessingDisplay( settings, false );
  }

  /**
	 * Get the data from the JSON data source to use for drawing a table. Using
	 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
	 * source object, or from a processing function.
	 *  @param {object} oSettings dataTables settings object
	 *  @param  {object} json Data source object / array from the server
	 *  @return {array} Array of data to use
	 */
  function _fnAjaxDataSrc( oSettings, json )
  {
    var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
      oSettings.ajax.dataSrc :
      oSettings.sAjaxDataProp; // Compatibility with 1.9-.

    // Compatibility with 1.9-. In order to read from aaData, check if the
    // default has been changed, if not, check for aaData
    if ( dataSrc === "data" ) {
      return json.aaData || json[dataSrc];
    }

    return dataSrc !== "" ?
      _fnGetObjectDataFn( dataSrc )( json ) :
      json;
  }

  /**
	 * Generate the node required for filtering text
	 *  @returns {node} Filter control element
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnFeatureHtmlFilter( settings )
  {
    var classes = settings.oClasses;
    var tableId = settings.sTableId;
    var language = settings.oLanguage;
    var previousSearch = settings.oPreviousSearch;
    var features = settings.aanFeatures;
    var input = "<input type=\"search\" class=\"" + classes.sFilterInput + "\"/>";

    var str = language.sSearch;
    str = str.match(/_INPUT_/) ?
      str.replace("_INPUT_", input) :
      str + input;

    var filter = $("<div/>", {
      "id": ! features.f ? tableId + "_filter" : null,
      "class": classes.sFilter
    } )
      .append( $("<label/>" ).append( str ) );

    var searchFn = function () {
      /* Update all other filter input elements for the new display */
      var n = features.f;
      var val = !this.value ? "" : this.value; // mental IE8 fix :-(

      /* Now do the filter */
      if ( val != previousSearch.sSearch ) {
        _fnFilterComplete( settings, {
          "sSearch": val,
          "bRegex": previousSearch.bRegex,
          "bSmart": previousSearch.bSmart,
          "bCaseInsensitive": previousSearch.bCaseInsensitive
        } );

        // Need to redraw, without resorting
        settings._iDisplayStart = 0;
        _fnDraw( settings );
      }
    };

    var searchDelay = settings.searchDelay !== null ?
      settings.searchDelay :
      _fnDataSource( settings ) === "ssp" ?
        400 :
        0;

    var jqFilter = $("input", filter)
      .val( previousSearch.sSearch )
      .attr( "placeholder", language.sSearchPlaceholder )
      .on(
        "keyup.DT search.DT input.DT paste.DT cut.DT",
        searchDelay ?
          _fnThrottle( searchFn, searchDelay ) :
          searchFn
      )
      .on( "keypress.DT", function (e) {
        /* Prevent form submission */
        if ( e.keyCode == 13 ) {
          return false;
        }
      } )
      .attr("aria-controls", tableId);

    // Update the input elements whenever the table is filtered
    $(settings.nTable).on( "search.dt.DT", function ( ev, s ) {
      if ( settings === s ) {
        // IE9 throws an 'unknown error' if document.activeElement is used
        // inside an iframe or frame...
        try {
          if ( jqFilter[0] !== document.activeElement ) {
            jqFilter.val( previousSearch.sSearch );
          }
        }
        catch ( e ) {}
      }
    } );

    return filter[0];
  }

  /**
	 * Filter the table using both the global filter and column based filtering
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oSearch search information
	 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
	 *  @memberof DataTable#oApi
	 */
  function _fnFilterComplete( oSettings, oInput, iForce )
  {
    var oPrevSearch = oSettings.oPreviousSearch;
    var aoPrevSearch = oSettings.aoPreSearchCols;
    var fnSaveFilter = function ( oFilter ) {
      /* Save the filtering values */
      oPrevSearch.sSearch = oFilter.sSearch;
      oPrevSearch.bRegex = oFilter.bRegex;
      oPrevSearch.bSmart = oFilter.bSmart;
      oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
    };
    var fnRegex = function ( o ) {
      // Backwards compatibility with the bEscapeRegex option
      return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
    };

    // Resolve any column types that are unknown due to addition or invalidation
    // @todo As per sort - can this be moved into an event handler?
    _fnColumnTypes( oSettings );

    /* In server-side processing all filtering is done by the server, so no point hanging around here */
    if ( _fnDataSource( oSettings ) != "ssp" )
    {
      /* Global filter */
      _fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
      fnSaveFilter( oInput );

      /* Now do the individual column filter */
      for ( var i = 0 ; i < aoPrevSearch.length ; i++ )
      {
        _fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
          aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
      }

      /* Custom filtering */
      _fnFilterCustom( oSettings );
    }
    else
    {
      fnSaveFilter( oInput );
    }

    /* Tell the draw function we have been filtering */
    oSettings.bFiltered = true;
    _fnCallbackFire( oSettings, null, "search", [oSettings] );
  }

  /**
	 * Apply custom filtering functions
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnFilterCustom( settings )
  {
    var filters = DataTable.ext.search;
    var displayRows = settings.aiDisplay;
    var row, rowIdx;

    for ( var i = 0, ien = filters.length ; i < ien ; i++ ) {
      var rows = [];

      // Loop over each row and see if it should be included
      for ( var j = 0, jen = displayRows.length ; j < jen ; j++ ) {
        rowIdx = displayRows[ j ];
        row = settings.aoData[ rowIdx ];

        if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
          rows.push( rowIdx );
        }
      }

      // So the array reference doesn't break set the results into the
      // existing array
      displayRows.length = 0;
      $.merge( displayRows, rows );
    }
  }

  /**
	 * Filter the table on a per-column basis
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sInput string to filter on
	 *  @param {int} iColumn column to filter
	 *  @param {bool} bRegex treat search string as a regular expression or not
	 *  @param {bool} bSmart use smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insenstive matching or not
	 *  @memberof DataTable#oApi
	 */
  function _fnFilterColumn( settings, searchStr, colIdx, regex, smart, caseInsensitive )
  {
    if ( searchStr === "" ) {
      return;
    }

    var data;
    var out = [];
    var display = settings.aiDisplay;
    var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );

    for ( var i = 0 ; i < display.length ; i++ ) {
      data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];

      if ( rpSearch.test( data ) ) {
        out.push( display[i] );
      }
    }

    settings.aiDisplay = out;
  }

  /**
	 * Filter the data table based on user input and draw the table
	 *  @param {object} settings dataTables settings object
	 *  @param {string} input string to filter on
	 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
	 *  @param {bool} regex treat as a regular expression or not
	 *  @param {bool} smart perform smart filtering or not
	 *  @param {bool} caseInsensitive Do case insenstive matching or not
	 *  @memberof DataTable#oApi
	 */
  function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
  {
    var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
    var prevSearch = settings.oPreviousSearch.sSearch;
    var displayMaster = settings.aiDisplayMaster;
    var display, invalidated, i;
    var filtered = [];

    // Need to take account of custom filtering functions - always filter
    if ( DataTable.ext.search.length !== 0 ) {
      force = true;
    }

    // Check if any of the rows were invalidated
    invalidated = _fnFilterData( settings );

    // If the input is blank - we just want the full data set
    if ( input.length <= 0 ) {
      settings.aiDisplay = displayMaster.slice();
    }
    else {
      // New search - start from the master array
      if ( invalidated ||
				 force ||
				 prevSearch.length > input.length ||
				 input.indexOf(prevSearch) !== 0 ||
				 settings.bSorted // On resort, the display master needs to be
				                  // re-filtered since indexes will have changed
      ) {
        settings.aiDisplay = displayMaster.slice();
      }

      // Search the display array
      display = settings.aiDisplay;

      for ( i = 0 ; i < display.length ; i++ ) {
        if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
          filtered.push( display[i] );
        }
      }

      settings.aiDisplay = filtered;
    }
  }

  /**
	 * Build a regular expression object suitable for searching a table
	 *  @param {string} sSearch string to search for
	 *  @param {bool} bRegex treat as a regular expression or not
	 *  @param {bool} bSmart perform smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @returns {RegExp} constructed object
	 *  @memberof DataTable#oApi
	 */
  function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
  {
    search = regex ?
      search :
      _fnEscapeRegex( search );

    if ( smart ) {
      /* For smart filtering we want to allow the search to work regardless of
			 * word order. We also want double quoted text to be preserved, so word
			 * order is important - a la google. So this is what we want to
			 * generate:
			 *
			 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
			 */
      var a = $.map( search.match( /"[^"]+"|[^ ]+/g ) || [""], function ( word ) {
        if ( word.charAt(0) === "\"" ) {
          var m = word.match( /^"(.*)"$/ );
          word = m ? m[1] : word;
        }

        return word.replace("\"", "");
      } );

      search = "^(?=.*?" + a.join( ")(?=.*?" ) + ").*$";
    }

    return new RegExp( search, caseInsensitive ? "i" : "" );
  }

  /**
	 * Escape a string such that it can be used in a regular expression
	 *  @param {string} sVal string to escape
	 *  @returns {string} escaped string
	 *  @memberof DataTable#oApi
	 */
  var _fnEscapeRegex = DataTable.util.escapeRegex;

  var __filter_div = $("<div>")[0];
  var __filter_div_textContent = __filter_div.textContent !== undefined;

  // Update the filtering data for each row if needed (by invalidation or first run)
  function _fnFilterData( settings )
  {
    var columns = settings.aoColumns;
    var column;
    var i, j, ien, jen, filterData, cellData, row;
    var fomatters = DataTable.ext.type.search;
    var wasInvalidated = false;

    for ( i = 0, ien = settings.aoData.length ; i < ien ; i++ ) {
      row = settings.aoData[i];

      if ( ! row._aFilterData ) {
        filterData = [];

        for ( j = 0, jen = columns.length ; j < jen ; j++ ) {
          column = columns[j];

          if ( column.bSearchable ) {
            cellData = _fnGetCellData( settings, i, j, "filter" );

            if ( fomatters[ column.sType ] ) {
              cellData = fomatters[ column.sType ]( cellData );
            }

            // Search in DataTables 1.10 is string based. In 1.11 this
            // should be altered to also allow strict type checking.
            if ( cellData === null ) {
              cellData = "";
            }

            if ( typeof cellData !== "string" && cellData.toString ) {
              cellData = cellData.toString();
            }
          }
          else {
            cellData = "";
          }

          // If it looks like there is an HTML entity in the string,
          // attempt to decode it so sorting works as expected. Note that
          // we could use a single line of jQuery to do this, but the DOM
          // method used here is much faster http://jsperf.com/html-decode
          if ( cellData.indexOf && cellData.indexOf("&") !== -1 ) {
            __filter_div.innerHTML = cellData;
            cellData = __filter_div_textContent ?
              __filter_div.textContent :
              __filter_div.innerText;
          }

          if ( cellData.replace ) {
            cellData = cellData.replace(/[\r\n]/g, "");
          }

          filterData.push( cellData );
        }

        row._aFilterData = filterData;
        row._sFilterRow = filterData.join("  ");
        wasInvalidated = true;
      }
    }

    return wasInvalidated;
  }

  /**
	 * Convert from the internal Hungarian notation to camelCase for external
	 * interaction
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
  function _fnSearchToCamel( obj )
  {
    return {
      search: obj.sSearch,
      smart: obj.bSmart,
      regex: obj.bRegex,
      caseInsensitive: obj.bCaseInsensitive
    };
  }

  /**
	 * Convert from camelCase notation to the internal Hungarian. We could use the
	 * Hungarian convert function here, but this is cleaner
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
  function _fnSearchToHung( obj )
  {
    return {
      sSearch: obj.search,
      bSmart: obj.smart,
      bRegex: obj.regex,
      bCaseInsensitive: obj.caseInsensitive
    };
  }

  /**
	 * Generate the node required for the info display
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Information element
	 *  @memberof DataTable#oApi
	 */
  function _fnFeatureHtmlInfo( settings )
  {
    var
      tid = settings.sTableId,
      nodes = settings.aanFeatures.i,
      n = $("<div/>", {
        "class": settings.oClasses.sInfo,
        "id": ! nodes ? tid + "_info" : null
      } );

    if ( ! nodes ) {
      // Update display on each draw
      settings.aoDrawCallback.push( {
        "fn": _fnUpdateInfo,
        "sName": "information"
      } );

      n
        .attr( "role", "status" )
        .attr( "aria-live", "polite" );

      // Table is described by our info div
      $(settings.nTable).attr( "aria-describedby", tid + "_info" );
    }

    return n[0];
  }

  /**
	 * Update the information elements in the display
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnUpdateInfo( settings )
  {
    /* Show information about the table */
    var nodes = settings.aanFeatures.i;
    if ( nodes.length === 0 ) {
      return;
    }

    var
      lang = settings.oLanguage,
      start = settings._iDisplayStart + 1,
      end = settings.fnDisplayEnd(),
      max = settings.fnRecordsTotal(),
      total = settings.fnRecordsDisplay(),
      out = total ?
        lang.sInfo :
        lang.sInfoEmpty;

    if ( total !== max ) {
      /* Record set after filtering */
      out += " " + lang.sInfoFiltered;
    }

    // Convert the macros
    out += lang.sInfoPostFix;
    out = _fnInfoMacros( settings, out );

    var callback = lang.fnInfoCallback;
    if ( callback !== null ) {
      out = callback.call( settings.oInstance,
        settings, start, end, max, total, out
      );
    }

    $(nodes).html( out );
  }

  function _fnInfoMacros( settings, str )
  {
    // When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
    // internally
    var
      formatter = settings.fnFormatNumber,
      start = settings._iDisplayStart + 1,
      len = settings._iDisplayLength,
      vis = settings.fnRecordsDisplay(),
      all = len === -1;

    return str.
      replace(/_START_/g, formatter.call( settings, start ) ).
      replace(/_END_/g, formatter.call( settings, settings.fnDisplayEnd() ) ).
      replace(/_MAX_/g, formatter.call( settings, settings.fnRecordsTotal() ) ).
      replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
      replace(/_PAGE_/g, formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
      replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
  }

  /**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnInitialise( settings )
  {
    var i, iLen, iAjaxStart = settings.iInitDisplayStart;
    var columns = settings.aoColumns, column;
    var features = settings.oFeatures;
    var deferLoading = settings.bDeferLoading; // value modified by the draw

    /* Ensure that the table data is fully initialised */
    if ( ! settings.bInitialised ) {
      setTimeout( function () { _fnInitialise( settings ); }, 200 );
      return;
    }

    /* Show the display HTML options */
    _fnAddOptionsHtml( settings );

    /* Build and draw the header / footer for the table */
    _fnBuildHead( settings );
    _fnDrawHead( settings, settings.aoHeader );
    _fnDrawHead( settings, settings.aoFooter );

    /* Okay to show that something is going on now */
    _fnProcessingDisplay( settings, true );

    /* Calculate sizes for columns */
    if ( features.bAutoWidth ) {
      _fnCalculateColumnWidths( settings );
    }

    for ( i = 0, iLen = columns.length ; i < iLen ; i++ ) {
      column = columns[i];

      if ( column.sWidth ) {
        column.nTh.style.width = _fnStringToCss( column.sWidth );
      }
    }

    _fnCallbackFire( settings, null, "preInit", [settings] );

    // If there is default sorting required - let's do it. The sort function
    // will do the drawing for us. Otherwise we draw the table regardless of the
    // Ajax source - this allows the table to look initialised for Ajax sourcing
    // data (show 'loading' message possibly)
    _fnReDraw( settings );

    // Server-side processing init complete is done by _fnAjaxUpdateDraw
    var dataSrc = _fnDataSource( settings );
    if ( dataSrc != "ssp" || deferLoading ) {
      // if there is an ajax source load the data
      if ( dataSrc == "ajax" ) {
        _fnBuildAjax( settings, [], function (json) {
          var aData = _fnAjaxDataSrc( settings, json );

          // Got the data - add it to the table
          for ( i = 0 ; i < aData.length ; i++ ) {
            _fnAddData( settings, aData[i] );
          }

          // Reset the init display for cookie saving. We've already done
          // a filter, and therefore cleared it before. So we need to make
          // it appear 'fresh'
          settings.iInitDisplayStart = iAjaxStart;

          _fnReDraw( settings );

          _fnProcessingDisplay( settings, false );
          _fnInitComplete( settings, json );
        }, settings );
      }
      else {
        _fnProcessingDisplay( settings, false );
        _fnInitComplete( settings );
      }
    }
  }

  /**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
	 *    with client-side processing (optional)
	 *  @memberof DataTable#oApi
	 */
  function _fnInitComplete( settings, json )
  {
    settings._bInitComplete = true;

    // When data was added after the initialisation (data or Ajax) we need to
    // calculate the column sizing
    if ( json || settings.oInit.aaData ) {
      _fnAdjustColumnSizing( settings );
    }

    _fnCallbackFire( settings, null, "plugin-init", [settings, json] );
    _fnCallbackFire( settings, "aoInitComplete", "init", [settings, json] );
  }

  function _fnLengthChange( settings, val )
  {
    var len = parseInt( val, 10 );
    settings._iDisplayLength = len;

    _fnLengthOverflow( settings );

    // Fire length change event
    _fnCallbackFire( settings, null, "length", [settings, len] );
  }

  /**
	 * Generate the node required for user display length changing
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Display length feature node
	 *  @memberof DataTable#oApi
	 */
  function _fnFeatureHtmlLength( settings )
  {
    var
      classes = settings.oClasses,
      tableId = settings.sTableId,
      menu = settings.aLengthMenu,
      d2 = $.isArray( menu[0] ),
      lengths = d2 ? menu[0] : menu,
      language = d2 ? menu[1] : menu;

    var select = $("<select/>", {
      "name": tableId + "_length",
      "aria-controls": tableId,
      "class": classes.sLengthSelect
    } );

    for ( var i = 0, ien = lengths.length ; i < ien ; i++ ) {
      select[0][ i ] = new Option(
        typeof language[i] === "number" ?
          settings.fnFormatNumber( language[i] ) :
          language[i],
        lengths[i]
      );
    }

    var div = $("<div><label/></div>").addClass( classes.sLength );
    if ( ! settings.aanFeatures.l ) {
      div[0].id = tableId + "_length";
    }

    div.children().append(
      settings.oLanguage.sLengthMenu.replace( "_MENU_", select[0].outerHTML )
    );

    // Can't use `select` variable as user might provide their own and the
    // reference is broken by the use of outerHTML
    $("select", div)
      .val( settings._iDisplayLength )
      .on( "change.DT", function (e) {
        _fnLengthChange( settings, $(this).val() );
        _fnDraw( settings );
      } );

    // Update node value whenever anything changes the table's length
    $(settings.nTable).on( "length.dt.DT", function (e, s, len) {
      if ( settings === s ) {
        $("select", div).val( len );
      }
    } );

    return div[0];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Note that most of the paging logic is done in
	 * DataTable.ext.pager
	 */

  /**
	 * Generate the node required for default pagination
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Pagination feature node
	 *  @memberof DataTable#oApi
	 */
  function _fnFeatureHtmlPaginate( settings )
  {
    var
      type = settings.sPaginationType,
      plugin = DataTable.ext.pager[ type ],
      modern = typeof plugin === "function",
      redraw = function ( settings ) {
        _fnDraw( settings );
      },
      node = $("<div/>").addClass( settings.oClasses.sPaging + type )[0],
      features = settings.aanFeatures;

    if ( ! modern ) {
      plugin.fnInit( settings, node, redraw );
    }

    /* Add a draw callback for the pagination on first instance, to update the paging display */
    if ( ! features.p )
    {
      node.id = settings.sTableId + "_paginate";

      settings.aoDrawCallback.push( {
        "fn": function ( settings ) {
          if ( modern ) {
            var
              start = settings._iDisplayStart,
              len = settings._iDisplayLength,
              visRecords = settings.fnRecordsDisplay(),
              all = len === -1,
              page = all ? 0 : Math.ceil( start / len ),
              pages = all ? 1 : Math.ceil( visRecords / len ),
              buttons = plugin(page, pages),
              i, ien;

            for ( i = 0, ien = features.p.length ; i < ien ; i++ ) {
              _fnRenderer( settings, "pageButton" )(
                settings, features.p[i], i, buttons, page, pages
              );
            }
          }
          else {
            plugin.fnUpdate( settings, redraw );
          }
        },
        "sName": "pagination"
      } );
    }

    return node;
  }

  /**
	 * Alter the display settings to change the page
	 *  @param {object} settings DataTables settings object
	 *  @param {string|int} action Paging action to take: "first", "previous",
	 *    "next" or "last" or page number to jump to (integer)
	 *  @param [bool] redraw Automatically draw the update or not
	 *  @returns {bool} true page has changed, false - no change
	 *  @memberof DataTable#oApi
	 */
  function _fnPageChange( settings, action, redraw )
  {
    var
      start = settings._iDisplayStart,
      len = settings._iDisplayLength,
      records = settings.fnRecordsDisplay();

    if ( records === 0 || len === -1 )
    {
      start = 0;
    }
    else if ( typeof action === "number" )
    {
      start = action * len;

      if ( start > records )
      {
        start = 0;
      }
    }
    else if ( action == "first" )
    {
      start = 0;
    }
    else if ( action == "previous" )
    {
      start = len >= 0 ?
        start - len :
        0;

      if ( start < 0 )
      {
			  start = 0;
      }
    }
    else if ( action == "next" )
    {
      if ( start + len < records )
      {
        start += len;
      }
    }
    else if ( action == "last" )
    {
      start = Math.floor( (records - 1) / len) * len;
    }
    else
    {
      _fnLog( settings, 0, "Unknown paging action: " + action, 5 );
    }

    var changed = settings._iDisplayStart !== start;
    settings._iDisplayStart = start;

    if ( changed ) {
      _fnCallbackFire( settings, null, "page", [settings] );

      if ( redraw ) {
        _fnDraw( settings );
      }
    }

    return changed;
  }

  /**
	 * Generate the node required for the processing node
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Processing element
	 *  @memberof DataTable#oApi
	 */
  function _fnFeatureHtmlProcessing( settings )
  {
    return $("<div/>", {
      "id": ! settings.aanFeatures.r ? settings.sTableId + "_processing" : null,
      "class": settings.oClasses.sProcessing
    } )
      .html( settings.oLanguage.sProcessing )
      .insertBefore( settings.nTable )[0];
  }

  /**
	 * Display or hide the processing indicator
	 *  @param {object} settings dataTables settings object
	 *  @param {bool} show Show the processing indicator (true) or not (false)
	 *  @memberof DataTable#oApi
	 */
  function _fnProcessingDisplay( settings, show )
  {
    if ( settings.oFeatures.bProcessing ) {
      $(settings.aanFeatures.r).css( "display", show ? "block" : "none" );
    }

    _fnCallbackFire( settings, null, "processing", [settings, show] );
  }

  /**
	 * Add any control elements for the table - specifically scrolling
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Node to add to the DOM
	 *  @memberof DataTable#oApi
	 */
  function _fnFeatureHtmlTable( settings )
  {
    var table = $(settings.nTable);

    // Add the ARIA grid role to the table
    table.attr( "role", "grid" );

    // Scrolling from here on in
    var scroll = settings.oScroll;

    if ( scroll.sX === "" && scroll.sY === "" ) {
      return settings.nTable;
    }

    var scrollX = scroll.sX;
    var scrollY = scroll.sY;
    var classes = settings.oClasses;
    var caption = table.children("caption");
    var captionSide = caption.length ? caption[0]._captionSide : null;
    var headerClone = $( table[0].cloneNode(false) );
    var footerClone = $( table[0].cloneNode(false) );
    var footer = table.children("tfoot");
    var _div = "<div/>";
    var size = function ( s ) {
      return !s ? null : _fnStringToCss( s );
    };

    if ( ! footer.length ) {
      footer = null;
    }

    /*
		 * The HTML structure that we want to generate in this function is:
		 *  div - scroller
		 *    div - scroll head
		 *      div - scroll head inner
		 *        table - scroll head table
		 *          thead - thead
		 *    div - scroll body
		 *      table - table (master table)
		 *        thead - thead clone for sizing
		 *        tbody - tbody
		 *    div - scroll foot
		 *      div - scroll foot inner
		 *        table - scroll foot table
		 *          tfoot - tfoot
		 */
    var scroller = $( _div, { "class": classes.sScrollWrapper } )
      .append(
        $(_div, { "class": classes.sScrollHead } )
          .css( {
            overflow: "hidden",
            position: "relative",
            border: 0,
            width: scrollX ? size(scrollX) : "100%"
          } )
          .append(
            $(_div, { "class": classes.sScrollHeadInner } )
              .css( {
                "box-sizing": "content-box",
                width: scroll.sXInner || "100%"
              } )
              .append(
                headerClone
                  .removeAttr("id")
                  .css( "margin-left", 0 )
                  .append( captionSide === "top" ? caption : null )
                  .append(
                    table.children("thead")
                  )
              )
          )
      )
      .append(
        $(_div, { "class": classes.sScrollBody } )
          .css( {
            position: "relative",
            overflow: "auto",
            width: size( scrollX )
          } )
          .append( table )
      );

    if ( footer ) {
      scroller.append(
        $(_div, { "class": classes.sScrollFoot } )
          .css( {
            overflow: "hidden",
            border: 0,
            width: scrollX ? size(scrollX) : "100%"
          } )
          .append(
            $(_div, { "class": classes.sScrollFootInner } )
              .append(
                footerClone
                  .removeAttr("id")
                  .css( "margin-left", 0 )
                  .append( captionSide === "bottom" ? caption : null )
                  .append(
                    table.children("tfoot")
                  )
              )
          )
      );
    }

    var children = scroller.children();
    var scrollHead = children[0];
    var scrollBody = children[1];
    var scrollFoot = footer ? children[2] : null;

    // When the body is scrolled, then we also want to scroll the headers
    if ( scrollX ) {
      $(scrollBody).on( "scroll.DT", function (e) {
        var scrollLeft = this.scrollLeft;

        scrollHead.scrollLeft = scrollLeft;

        if ( footer ) {
          scrollFoot.scrollLeft = scrollLeft;
        }
      } );
    }

    $(scrollBody).css(
      scrollY && scroll.bCollapse ? "max-height" : "height",
      scrollY
    );

    settings.nScrollHead = scrollHead;
    settings.nScrollBody = scrollBody;
    settings.nScrollFoot = scrollFoot;

    // On redraw - align columns
    settings.aoDrawCallback.push( {
      "fn": _fnScrollDraw,
      "sName": "scrolling"
    } );

    return scroller[0];
  }

  /**
	 * Update the header, footer and body tables for resizing - i.e. column
	 * alignment.
	 *
	 * Welcome to the most horrible function DataTables. The process that this
	 * function follows is basically:
	 *   1. Re-create the table inside the scrolling div
	 *   2. Take live measurements from the DOM
	 *   3. Apply the measurements to align the columns
	 *   4. Clean up
	 *
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnScrollDraw( settings )
  {
    // Given that this is such a monster function, a lot of variables are use
    // to try and keep the minimised size as small as possible
    var
      scroll = settings.oScroll,
      scrollX = scroll.sX,
      scrollXInner = scroll.sXInner,
      scrollY = scroll.sY,
      barWidth = scroll.iBarWidth,
      divHeader = $(settings.nScrollHead),
      divHeaderStyle = divHeader[0].style,
      divHeaderInner = divHeader.children("div"),
      divHeaderInnerStyle = divHeaderInner[0].style,
      divHeaderTable = divHeaderInner.children("table"),
      divBodyEl = settings.nScrollBody,
      divBody = $(divBodyEl),
      divBodyStyle = divBodyEl.style,
      divFooter = $(settings.nScrollFoot),
      divFooterInner = divFooter.children("div"),
      divFooterTable = divFooterInner.children("table"),
      header = $(settings.nTHead),
      table = $(settings.nTable),
      tableEl = table[0],
      tableStyle = tableEl.style,
      footer = settings.nTFoot ? $(settings.nTFoot) : null,
      browser = settings.oBrowser,
      ie67 = browser.bScrollOversize,
      dtHeaderCells = _pluck( settings.aoColumns, "nTh" ),
      headerTrgEls, footerTrgEls,
      headerSrcEls, footerSrcEls,
      headerCopy, footerCopy,
      headerWidths = [], footerWidths = [],
      headerContent = [], footerContent = [],
      idx, correction, sanityWidth,
      zeroOut = function (nSizer) {
        var style = nSizer.style;
        style.paddingTop = "0";
        style.paddingBottom = "0";
        style.borderTopWidth = "0";
        style.borderBottomWidth = "0";
        style.height = 0;
      };

    // If the scrollbar visibility has changed from the last draw, we need to
    // adjust the column sizes as the table width will have changed to account
    // for the scrollbar
    var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;

    if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
      settings.scrollBarVis = scrollBarVis;
      _fnAdjustColumnSizing( settings );
      return; // adjust column sizing will call this function again
    }
    else {
      settings.scrollBarVis = scrollBarVis;
    }

    /*
		 * 1. Re-create the table inside the scrolling div
		 */

    // Remove the old minimised thead and tfoot elements in the inner table
    table.children("thead, tfoot").remove();

    if ( footer ) {
      footerCopy = footer.clone().prependTo( table );
      footerTrgEls = footer.find("tr"); // the original tfoot is in its own table and must be sized
      footerSrcEls = footerCopy.find("tr");
    }

    // Clone the current header and footer elements and then place it into the inner table
    headerCopy = header.clone().prependTo( table );
    headerTrgEls = header.find("tr"); // original header is in its own table
    headerSrcEls = headerCopy.find("tr");
    headerCopy.find("th, td").removeAttr("tabindex");

    /*
		 * 2. Take live measurements from the DOM - do not alter the DOM itself!
		 */

    // Remove old sizing and apply the calculated column widths
    // Get the unique column headers in the newly created (cloned) header. We want to apply the
    // calculated sizes to this header
    if ( ! scrollX )
    {
      divBodyStyle.width = "100%";
      divHeader[0].style.width = "100%";
    }

    $.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
      idx = _fnVisibleToColumnIndex( settings, i );
      el.style.width = settings.aoColumns[idx].sWidth;
    } );

    if ( footer ) {
      _fnApplyToChildren( function (n) {
        n.style.width = "";
      }, footerSrcEls );
    }

    // Size the table as a whole
    sanityWidth = table.outerWidth();
    if ( scrollX === "" ) {
      // No x scrolling
      tableStyle.width = "100%";

      // IE7 will make the width of the table when 100% include the scrollbar
      // - which is shouldn't. When there is a scrollbar we need to take this
      // into account.
      if ( ie67 && (table.find("tbody").height() > divBodyEl.offsetHeight ||
				divBody.css("overflow-y") == "scroll")
      ) {
        tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
      }

      // Recalculate the sanity width
      sanityWidth = table.outerWidth();
    }
    else if ( scrollXInner !== "" ) {
      // legacy x scroll inner has been given - use it
      tableStyle.width = _fnStringToCss(scrollXInner);

      // Recalculate the sanity width
      sanityWidth = table.outerWidth();
    }

    // Hidden header should have zero height, so remove padding and borders. Then
    // set the width based on the real headers

    // Apply all styles in one pass
    _fnApplyToChildren( zeroOut, headerSrcEls );

    // Read all widths in next pass
    _fnApplyToChildren( function (nSizer) {
      headerContent.push( nSizer.innerHTML );
      headerWidths.push( _fnStringToCss( $(nSizer).css("width") ) );
    }, headerSrcEls );

    // Apply all widths in final pass
    _fnApplyToChildren( function (nToSize, i) {
      // Only apply widths to the DataTables detected header cells - this
      // prevents complex headers from having contradictory sizes applied
      if ( $.inArray( nToSize, dtHeaderCells ) !== -1 ) {
        nToSize.style.width = headerWidths[i];
      }
    }, headerTrgEls );

    $(headerSrcEls).height(0);

    /* Same again with the footer if we have one */
    if ( footer )
    {
      _fnApplyToChildren( zeroOut, footerSrcEls );

      _fnApplyToChildren( function (nSizer) {
        footerContent.push( nSizer.innerHTML );
        footerWidths.push( _fnStringToCss( $(nSizer).css("width") ) );
      }, footerSrcEls );

      _fnApplyToChildren( function (nToSize, i) {
        nToSize.style.width = footerWidths[i];
      }, footerTrgEls );

      $(footerSrcEls).height(0);
    }

    /*
		 * 3. Apply the measurements
		 */

    // "Hide" the header and footer that we used for the sizing. We need to keep
    // the content of the cell so that the width applied to the header and body
    // both match, but we want to hide it completely. We want to also fix their
    // width to what they currently are
    _fnApplyToChildren( function (nSizer, i) {
      nSizer.innerHTML = "<div class=\"dataTables_sizing\" style=\"height:0;overflow:hidden;\">" + headerContent[i] + "</div>";
      nSizer.style.width = headerWidths[i];
    }, headerSrcEls );

    if ( footer )
    {
      _fnApplyToChildren( function (nSizer, i) {
        nSizer.innerHTML = "<div class=\"dataTables_sizing\" style=\"height:0;overflow:hidden;\">" + footerContent[i] + "</div>";
        nSizer.style.width = footerWidths[i];
      }, footerSrcEls );
    }

    // Sanity check that the table is of a sensible width. If not then we are going to get
    // misalignment - try to prevent this by not allowing the table to shrink below its min width
    if ( table.outerWidth() < sanityWidth )
    {
      // The min width depends upon if we have a vertical scrollbar visible or not */
      correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
				divBody.css("overflow-y") == "scroll")) ?
        sanityWidth + barWidth :
        sanityWidth;

      // IE6/7 are a law unto themselves...
      if ( ie67 && (divBodyEl.scrollHeight >
				divBodyEl.offsetHeight || divBody.css("overflow-y") == "scroll")
      ) {
        tableStyle.width = _fnStringToCss( correction - barWidth );
      }

      // And give the user a warning that we've stopped the table getting too small
      if ( scrollX === "" || scrollXInner !== "" ) {
        _fnLog( settings, 1, "Possible column misalignment", 6 );
      }
    }
    else
    {
      correction = "100%";
    }

    // Apply to the container elements
    divBodyStyle.width = _fnStringToCss( correction );
    divHeaderStyle.width = _fnStringToCss( correction );

    if ( footer ) {
      settings.nScrollFoot.style.width = _fnStringToCss( correction );
    }

    /*
		 * 4. Clean up
		 */
    if ( ! scrollY ) {
      /* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
			 * the scrollbar height from the visible display, rather than adding it on. We need to
			 * set the height in order to sort this. Don't want to do it in any other browsers.
			 */
      if ( ie67 ) {
        divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight + barWidth );
      }
    }

    /* Finally set the width's of the header and footer tables */
    var iOuterWidth = table.outerWidth();
    divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
    divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );

    // Figure out if there are scrollbar present - if so then we need a the header and footer to
    // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
    var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css("overflow-y") == "scroll";
    var padding = "padding" + (browser.bScrollbarLeft ? "Left" : "Right" );
    divHeaderInnerStyle[ padding ] = bScrolling ? barWidth + "px" : "0px";

    if ( footer ) {
      divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
      divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
      divFooterInner[0].style[padding] = bScrolling ? barWidth + "px" : "0px";
    }

    // Correct DOM ordering for colgroup - comes before the thead
    table.children("colgroup").insertBefore( table.children("thead") );

    /* Adjust the position of the header in case we loose the y-scrollbar */
    divBody.scroll();

    // If sorting or filtering has occurred, jump the scrolling back to the top
    // only if we aren't holding the position
    if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
      divBodyEl.scrollTop = 0;
    }
  }

  /**
	 * Apply a given function to the display child nodes of an element array (typically
	 * TD children of TR rows
	 *  @param {function} fn Method to apply to the objects
	 *  @param array {nodes} an1 List of elements to look through for display children
	 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
	 *  @memberof DataTable#oApi
	 */
  function _fnApplyToChildren( fn, an1, an2 )
  {
    var index = 0, i = 0, iLen = an1.length;
    var nNode1, nNode2;

    while ( i < iLen ) {
      nNode1 = an1[i].firstChild;
      nNode2 = an2 ? an2[i].firstChild : null;

      while ( nNode1 ) {
        if ( nNode1.nodeType === 1 ) {
          if ( an2 ) {
            fn( nNode1, nNode2, index );
          }
          else {
            fn( nNode1, index );
          }

          index++;
        }

        nNode1 = nNode1.nextSibling;
        nNode2 = an2 ? nNode2.nextSibling : null;
      }

      i++;
    }
  }

  var __re_html_remove = /<.*?>/g;

  /**
	 * Calculate the width of columns for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnCalculateColumnWidths( oSettings )
  {
    var
      table = oSettings.nTable,
      columns = oSettings.aoColumns,
      scroll = oSettings.oScroll,
      scrollY = scroll.sY,
      scrollX = scroll.sX,
      scrollXInner = scroll.sXInner,
      columnCount = columns.length,
      visibleColumns = _fnGetColumns( oSettings, "bVisible" ),
      headerCells = $("th", oSettings.nTHead),
      tableWidthAttr = table.getAttribute("width"), // from DOM element
      tableContainer = table.parentNode,
      userInputs = false,
      i, column, columnIdx, width, outerWidth,
      browser = oSettings.oBrowser,
      ie67 = browser.bScrollOversize;

    var styleWidth = table.style.width;
    if ( styleWidth && styleWidth.indexOf("%") !== -1 ) {
      tableWidthAttr = styleWidth;
    }

    /* Convert any user input sizes into pixel sizes */
    for ( i = 0 ; i < visibleColumns.length ; i++ ) {
      column = columns[ visibleColumns[i] ];

      if ( column.sWidth !== null ) {
        column.sWidth = _fnConvertToWidth( column.sWidthOrig, tableContainer );

        userInputs = true;
      }
    }

    /* If the number of columns in the DOM equals the number that we have to
		 * process in DataTables, then we can use the offsets that are created by
		 * the web- browser. No custom sizes can be set in order for this to happen,
		 * nor scrolling used
		 */
    if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
		     columnCount == _fnVisbleColumns( oSettings ) &&
		     columnCount == headerCells.length
    ) {
      for ( i = 0 ; i < columnCount ; i++ ) {
        var colIdx = _fnVisibleToColumnIndex( oSettings, i );

        if ( colIdx !== null ) {
          columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
        }
      }
    }
    else
    {
      // Otherwise construct a single row, worst case, table with the widest
      // node in the data, assign any user defined widths, then insert it into
      // the DOM and allow the browser to do all the hard work of calculating
      // table widths
      var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
        .css( "visibility", "hidden" )
        .removeAttr( "id" );

      // Clean up the table body
      tmpTable.find("tbody tr").remove();
      var tr = $("<tr/>").appendTo( tmpTable.find("tbody") );

      // Clone the table header and footer - we can't use the header / footer
      // from the cloned table, since if scrolling is active, the table's
      // real header and footer are contained in different table tags
      tmpTable.find("thead, tfoot").remove();
      tmpTable
        .append( $(oSettings.nTHead).clone() )
        .append( $(oSettings.nTFoot).clone() );

      // Remove any assigned widths from the footer (from scrolling)
      tmpTable.find("tfoot th, tfoot td").css("width", "");

      // Apply custom sizing to the cloned header
      headerCells = _fnGetUniqueThs( oSettings, tmpTable.find("thead")[0] );

      for ( i = 0 ; i < visibleColumns.length ; i++ ) {
        column = columns[ visibleColumns[i] ];

        headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== "" ?
          _fnStringToCss( column.sWidthOrig ) :
          "";

        // For scrollX we need to force the column width otherwise the
        // browser will collapse it. If this width is smaller than the
        // width the column requires, then it will have no effect
        if ( column.sWidthOrig && scrollX ) {
          $( headerCells[i] ).append( $("<div/>").css( {
            width: column.sWidthOrig,
            margin: 0,
            padding: 0,
            border: 0,
            height: 1
          } ) );
        }
      }

      // Find the widest cell for each column and put it into the table
      if ( oSettings.aoData.length ) {
        for ( i = 0 ; i < visibleColumns.length ; i++ ) {
          columnIdx = visibleColumns[i];
          column = columns[ columnIdx ];

          $( _fnGetWidestNode( oSettings, columnIdx ) )
            .clone( false )
            .append( column.sContentPadding )
            .appendTo( tr );
        }
      }

      // Tidy the temporary table - remove name attributes so there aren't
      // duplicated in the dom (radio elements for example)
      $("[name]", tmpTable).removeAttr("name");

      // Table has been built, attach to the document so we can work with it.
      // A holding element is used, positioned at the top of the container
      // with minimal height, so it has no effect on if the container scrolls
      // or not. Otherwise it might trigger scrolling when it actually isn't
      // needed
      var holder = $("<div/>").css( scrollX || scrollY ?
        {
          position: "absolute",
          top: 0,
          left: 0,
          height: 1,
          right: 0,
          overflow: "hidden"
        } :
        {}
      )
        .append( tmpTable )
        .appendTo( tableContainer );

      // When scrolling (X or Y) we want to set the width of the table as
      // appropriate. However, when not scrolling leave the table width as it
      // is. This results in slightly different, but I think correct behaviour
      if ( scrollX && scrollXInner ) {
        tmpTable.width( scrollXInner );
      }
      else if ( scrollX ) {
        tmpTable.css( "width", "auto" );
        tmpTable.removeAttr("width");

        // If there is no width attribute or style, then allow the table to
        // collapse
        if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
          tmpTable.width( tableContainer.clientWidth );
        }
      }
      else if ( scrollY ) {
        tmpTable.width( tableContainer.clientWidth );
      }
      else if ( tableWidthAttr ) {
        tmpTable.width( tableWidthAttr );
      }

      // Get the width of each column in the constructed table - we need to
      // know the inner width (so it can be assigned to the other table's
      // cells) and the outer width so we can calculate the full width of the
      // table. This is safe since DataTables requires a unique cell for each
      // column, but if ever a header can span multiple columns, this will
      // need to be modified.
      var total = 0;
      for ( i = 0 ; i < visibleColumns.length ; i++ ) {
        var cell = $(headerCells[i]);
        var border = cell.outerWidth() - cell.width();

        // Use getBounding... where possible (not IE8-) because it can give
        // sub-pixel accuracy, which we then want to round up!
        var bounding = browser.bBounding ?
          Math.ceil( headerCells[i].getBoundingClientRect().width ) :
          cell.outerWidth();

        // Total is tracked to remove any sub-pixel errors as the outerWidth
        // of the table might not equal the total given here (IE!).
        total += bounding;

        // Width for each column to use
        columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
      }

      table.style.width = _fnStringToCss( total );

      // Finished with the table - ditch it
      holder.remove();
    }

    // If there is a width attr, we want to attach an event listener which
    // allows the table sizing to automatically adjust when the window is
    // resized. Use the width attr rather than CSS, since we can't know if the
    // CSS is a relative value or absolute - DOM read is always px.
    if ( tableWidthAttr ) {
      table.style.width = _fnStringToCss( tableWidthAttr );
    }

    if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
      var bindResize = function () {
        $(window).on("resize.DT-" + oSettings.sInstance, _fnThrottle( function () {
          _fnAdjustColumnSizing( oSettings );
        } ) );
      };

      // IE6/7 will crash if we bind a resize event handler on page load.
      // To be removed in 1.11 which drops IE6/7 support
      if ( ie67 ) {
        setTimeout( bindResize, 1000 );
      }
      else {
        bindResize();
      }

      oSettings._reszEvt = true;
    }
  }

  /**
	 * Throttle the calls to a function. Arguments and context are maintained for
	 * the throttled function
	 *  @param {function} fn Function to be called
	 *  @param {int} [freq=200] call frequency in mS
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#oApi
	 */
  var _fnThrottle = DataTable.util.throttle;

  /**
	 * Convert a CSS unit width to pixels (e.g. 2em)
	 *  @param {string} width width to be converted
	 *  @param {node} parent parent to get the with for (required for relative widths) - optional
	 *  @returns {int} width in pixels
	 *  @memberof DataTable#oApi
	 */
  function _fnConvertToWidth( width, parent )
  {
    if ( ! width ) {
      return 0;
    }

    var n = $("<div/>")
      .css( "width", _fnStringToCss( width ) )
      .appendTo( parent || document.body );

    var val = n[0].offsetWidth;
    n.remove();

    return val;
  }

  /**
	 * Get the widest node
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {node} widest table node
	 *  @memberof DataTable#oApi
	 */
  function _fnGetWidestNode( settings, colIdx )
  {
    var idx = _fnGetMaxLenString( settings, colIdx );
    if ( idx < 0 ) {
      return null;
    }

    var data = settings.aoData[ idx ];
    return ! data.nTr ? // Might not have been created when deferred rendering
      $("<td/>").html( _fnGetCellData( settings, idx, colIdx, "display" ) )[0] :
      data.anCells[ colIdx ];
  }

  /**
	 * Get the maximum strlen for each data column
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {string} max string length for each column
	 *  @memberof DataTable#oApi
	 */
  function _fnGetMaxLenString( settings, colIdx )
  {
    var s, max = -1, maxIdx = -1;

    for ( var i = 0, ien = settings.aoData.length ; i < ien ; i++ ) {
      s = _fnGetCellData( settings, i, colIdx, "display" ) + "";
      s = s.replace( __re_html_remove, "" );
      s = s.replace( /&nbsp;/g, " " );

      if ( s.length > max ) {
        max = s.length;
        maxIdx = i;
      }
    }

    return maxIdx;
  }

  /**
	 * Append a CSS unit (only if required) to a string
	 *  @param {string} value to css-ify
	 *  @returns {string} value with css unit
	 *  @memberof DataTable#oApi
	 */
  function _fnStringToCss( s )
  {
    if ( s === null ) {
      return "0px";
    }

    if ( typeof s === "number" ) {
      return s < 0 ?
        "0px" :
        s + "px";
    }

    // Check it has a unit character already
    return s.match(/\d$/) ?
      s + "px" :
      s;
  }

  function _fnSortFlatten( settings )
  {
    var
      i, iLen, k, kLen,
      aSort = [],
      aiOrig = [],
      aoColumns = settings.aoColumns,
      aDataSort, iCol, sType, srcCol,
      fixed = settings.aaSortingFixed,
      fixedObj = $.isPlainObject( fixed ),
      nestedSort = [],
      add = function ( a ) {
        if ( a.length && ! $.isArray( a[0] ) ) {
          // 1D array
          nestedSort.push( a );
        }
        else {
          // 2D array
          $.merge( nestedSort, a );
        }
      };

    // Build the sort array, with pre-fix and post-fix options if they have been
    // specified
    if ( $.isArray( fixed ) ) {
      add( fixed );
    }

    if ( fixedObj && fixed.pre ) {
      add( fixed.pre );
    }

    add( settings.aaSorting );

    if (fixedObj && fixed.post ) {
      add( fixed.post );
    }

    for ( i = 0 ; i < nestedSort.length ; i++ )
    {
      srcCol = nestedSort[i][0];
      aDataSort = aoColumns[ srcCol ].aDataSort;

      for ( k = 0, kLen = aDataSort.length ; k < kLen ; k++ )
      {
        iCol = aDataSort[k];
        sType = aoColumns[ iCol ].sType || "string";

        if ( nestedSort[i]._idx === undefined ) {
          nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
        }

        aSort.push( {
          src: srcCol,
          col: iCol,
          dir: nestedSort[i][1],
          index: nestedSort[i]._idx,
          type: sType,
          formatter: DataTable.ext.type.order[ sType + "-pre" ]
        } );
      }
    }

    return aSort;
  }

  /**
	 * Change the order of the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 *  @todo This really needs split up!
	 */
  function _fnSort( oSettings )
  {
    var
      i, ien, iLen, j, jLen, k, kLen,
      sDataType, nTh,
      aiOrig = [],
      oExtSort = DataTable.ext.type.order,
      aoData = oSettings.aoData,
      aoColumns = oSettings.aoColumns,
      aDataSort, data, iCol, sType, oSort,
      formatters = 0,
      sortCol,
      displayMaster = oSettings.aiDisplayMaster,
      aSort;

    // Resolve any column types that are unknown due to addition or invalidation
    // @todo Can this be moved into a 'data-ready' handler which is called when
    //   data is going to be used in the table?
    _fnColumnTypes( oSettings );

    aSort = _fnSortFlatten( oSettings );

    for ( i = 0, ien = aSort.length ; i < ien ; i++ ) {
      sortCol = aSort[i];

      // Track if we can use the fast sort algorithm
      if ( sortCol.formatter ) {
        formatters++;
      }

      // Load the data needed for the sort, for each cell
      _fnSortData( oSettings, sortCol.col );
    }

    /* No sorting required if server-side or no sorting array */
    if ( _fnDataSource( oSettings ) != "ssp" && aSort.length !== 0 )
    {
      // Create a value - key array of the current row positions such that we can use their
      // current position during the sort, if values match, in order to perform stable sorting
      for ( i = 0, iLen = displayMaster.length ; i < iLen ; i++ ) {
        aiOrig[ displayMaster[i] ] = i;
      }

      /* Do the sort - here we want multi-column sorting based on a given data source (column)
			 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
			 * follow on it's own, but this is what we want (example two column sorting):
			 *  fnLocalSorting = function(a,b){
			 *    var iTest;
			 *    iTest = oSort['string-asc']('data11', 'data12');
			 *      if (iTest !== 0)
			 *        return iTest;
			 *    iTest = oSort['numeric-desc']('data21', 'data22');
			 *    if (iTest !== 0)
			 *      return iTest;
			 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
			 *  }
			 * Basically we have a test for each sorting column, if the data in that column is equal,
			 * test the next column. If all columns match, then we use a numeric sort on the row
			 * positions in the original data array to provide a stable sort.
			 *
			 * Note - I know it seems excessive to have two sorting methods, but the first is around
			 * 15% faster, so the second is only maintained for backwards compatibility with sorting
			 * methods which do not have a pre-sort formatting function.
			 */
      if ( formatters === aSort.length ) {
        // All sort types have formatting functions
        displayMaster.sort( function ( a, b ) {
          var
            x, y, k, test, sort,
            len = aSort.length,
            dataA = aoData[a]._aSortData,
            dataB = aoData[b]._aSortData;

          for ( k = 0 ; k < len ; k++ ) {
            sort = aSort[k];

            x = dataA[ sort.col ];
            y = dataB[ sort.col ];

            test = x < y ? -1 : x > y ? 1 : 0;
            if ( test !== 0 ) {
              return sort.dir === "asc" ? test : -test;
            }
          }

          x = aiOrig[a];
          y = aiOrig[b];
          return x < y ? -1 : x > y ? 1 : 0;
        } );
      }
      else {
        // Depreciated - remove in 1.11 (providing a plug-in option)
        // Not all sort types have formatting methods, so we have to call their sorting
        // methods.
        displayMaster.sort( function ( a, b ) {
          var
            x, y, k, l, test, sort, fn,
            len = aSort.length,
            dataA = aoData[a]._aSortData,
            dataB = aoData[b]._aSortData;

          for ( k = 0 ; k < len ; k++ ) {
            sort = aSort[k];

            x = dataA[ sort.col ];
            y = dataB[ sort.col ];

            fn = oExtSort[ sort.type + "-" + sort.dir ] || oExtSort[ "string-" + sort.dir ];
            test = fn( x, y );
            if ( test !== 0 ) {
              return test;
            }
          }

          x = aiOrig[a];
          y = aiOrig[b];
          return x < y ? -1 : x > y ? 1 : 0;
        } );
      }
    }

    /* Tell the draw function that we have sorted the data */
    oSettings.bSorted = true;
  }

  function _fnSortAria( settings )
  {
    var label;
    var nextSort;
    var columns = settings.aoColumns;
    var aSort = _fnSortFlatten( settings );
    var oAria = settings.oLanguage.oAria;

    // ARIA attributes - need to loop all columns, to update all (removing old
    // attributes as needed)
    for ( var i = 0, iLen = columns.length ; i < iLen ; i++ )
    {
      var col = columns[i];
      var asSorting = col.asSorting;
      var sTitle = col.sTitle.replace( /<.*?>/g, "" );
      var th = col.nTh;

      // IE7 is throwing an error when setting these properties with jQuery's
      // attr() and removeAttr() methods...
      th.removeAttribute("aria-sort");

      /* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
      if ( col.bSortable ) {
        if ( aSort.length > 0 && aSort[0].col == i ) {
          th.setAttribute("aria-sort", aSort[0].dir == "asc" ? "ascending" : "descending" );
          nextSort = asSorting[ aSort[0].index + 1 ] || asSorting[0];
        }
        else {
          nextSort = asSorting[0];
        }

        label = sTitle + ( nextSort === "asc" ?
          oAria.sSortAscending :
          oAria.sSortDescending
        );
      }
      else {
        label = sTitle;
      }

      th.setAttribute("aria-label", label);
    }
  }

  /**
	 * Function to run on user sort request
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {boolean} [append=false] Append the requested sort to the existing
	 *    sort if true (i.e. multi-column sort)
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
  function _fnSortListener( settings, colIdx, append, callback )
  {
    var col = settings.aoColumns[ colIdx ];
    var sorting = settings.aaSorting;
    var asSorting = col.asSorting;
    var nextSortIdx;
    var next = function ( a, overflow ) {
      var idx = a._idx;
      if ( idx === undefined ) {
        idx = $.inArray( a[1], asSorting );
      }

      return idx + 1 < asSorting.length ?
        idx + 1 :
        overflow ?
          null :
          0;
    };

    // Convert to 2D array if needed
    if ( typeof sorting[0] === "number" ) {
      sorting = settings.aaSorting = [ sorting ];
    }

    // If appending the sort then we are multi-column sorting
    if ( append && settings.oFeatures.bSortMulti ) {
      // Are we already doing some kind of sort on this column?
      var sortIdx = $.inArray( colIdx, _pluck(sorting, "0") );

      if ( sortIdx !== -1 ) {
        // Yes, modify the sort
        nextSortIdx = next( sorting[sortIdx], true );

        if ( nextSortIdx === null && sorting.length === 1 ) {
          nextSortIdx = 0; // can't remove sorting completely
        }

        if ( nextSortIdx === null ) {
          sorting.splice( sortIdx, 1 );
        }
        else {
          sorting[sortIdx][1] = asSorting[ nextSortIdx ];
          sorting[sortIdx]._idx = nextSortIdx;
        }
      }
      else {
        // No sort on this column yet
        sorting.push( [ colIdx, asSorting[0], 0 ] );
        sorting[sorting.length - 1]._idx = 0;
      }
    }
    else if ( sorting.length && sorting[0][0] == colIdx ) {
      // Single column - already sorting on this column, modify the sort
      nextSortIdx = next( sorting[0] );

      sorting.length = 1;
      sorting[0][1] = asSorting[ nextSortIdx ];
      sorting[0]._idx = nextSortIdx;
    }
    else {
      // Single column - sort only on this column
      sorting.length = 0;
      sorting.push( [ colIdx, asSorting[0] ] );
      sorting[0]._idx = 0;
    }

    // Run the sort by calling a full redraw
    _fnReDraw( settings );

    // callback used for async user interaction
    if ( typeof callback === "function" ) {
      callback( settings );
    }
  }

  /**
	 * Attach a sort handler (click) to a node
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
  function _fnSortAttachListener( settings, attachTo, colIdx, callback )
  {
    var col = settings.aoColumns[ colIdx ];

    _fnBindAction( attachTo, {}, function (e) {
      /* If the column is not sortable - don't to anything */
      if ( col.bSortable === false ) {
        return;
      }

      // If processing is enabled use a timeout to allow the processing
      // display to be shown - otherwise to it synchronously
      if ( settings.oFeatures.bProcessing ) {
        _fnProcessingDisplay( settings, true );

        setTimeout( function () {
          _fnSortListener( settings, colIdx, e.shiftKey, callback );

          // In server-side processing, the draw callback will remove the
          // processing display
          if ( _fnDataSource( settings ) !== "ssp" ) {
            _fnProcessingDisplay( settings, false );
          }
        }, 0 );
      }
      else {
        _fnSortListener( settings, colIdx, e.shiftKey, callback );
      }
    } );
  }

  /**
	 * Set the sorting classes on table's body, Note: it is safe to call this function
	 * when bSort and bSortClasses are false
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnSortingClasses( settings )
  {
    var oldSort = settings.aLastSort;
    var sortClass = settings.oClasses.sSortColumn;
    var sort = _fnSortFlatten( settings );
    var features = settings.oFeatures;
    var i, ien, colIdx;

    if ( features.bSort && features.bSortClasses ) {
      // Remove old sorting classes
      for ( i = 0, ien = oldSort.length ; i < ien ; i++ ) {
        colIdx = oldSort[i].src;

        // Remove column sorting
        $( _pluck( settings.aoData, "anCells", colIdx ) )
          .removeClass( sortClass + (i < 2 ? i + 1 : 3) );
      }

      // Add new column sorting
      for ( i = 0, ien = sort.length ; i < ien ; i++ ) {
        colIdx = sort[i].src;

        $( _pluck( settings.aoData, "anCells", colIdx ) )
          .addClass( sortClass + (i < 2 ? i + 1 : 3) );
      }
    }

    settings.aLastSort = sort;
  }

  // Get the data to sort a column, be it from cache, fresh (populating the
  // cache), or from a sort formatter
  function _fnSortData( settings, idx )
  {
    // Custom sorting function - provided by the sort data type
    var column = settings.aoColumns[ idx ];
    var customSort = DataTable.ext.order[ column.sSortDataType ];
    var customData;

    if ( customSort ) {
      customData = customSort.call( settings.oInstance, settings, idx,
        _fnColumnIndexToVisible( settings, idx )
      );
    }

    // Use / populate cache
    var row, cellData;
    var formatter = DataTable.ext.type.order[ column.sType + "-pre" ];

    for ( var i = 0, ien = settings.aoData.length ; i < ien ; i++ ) {
      row = settings.aoData[i];

      if ( ! row._aSortData ) {
        row._aSortData = [];
      }

      if ( ! row._aSortData[idx] || customSort ) {
        cellData = customSort ?
          customData[i] : // If there was a custom sort function, use data from there
          _fnGetCellData( settings, i, idx, "sort" );

        row._aSortData[ idx ] = formatter ?
          formatter( cellData ) :
          cellData;
      }
    }
  }

  /**
	 * Save the state of a table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
  function _fnSaveState( settings )
  {
    if ( !settings.oFeatures.bStateSave || settings.bDestroying )
    {
      return;
    }

    /* Store the interesting variables */
    var state = {
      time: +new Date(),
      start: settings._iDisplayStart,
      length: settings._iDisplayLength,
      order: $.extend( true, [], settings.aaSorting ),
      search: _fnSearchToCamel( settings.oPreviousSearch ),
      columns: $.map( settings.aoColumns, function ( col, i ) {
        return {
          visible: col.bVisible,
          search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
        };
      } )
    };

    _fnCallbackFire( settings, "aoStateSaveParams", "stateSaveParams", [settings, state] );

    settings.oSavedState = state;
    settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
  }

  /**
	 * Attempt to load a saved table state
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oInit DataTables init object so we can override settings
	 *  @param {function} callback Callback to execute when the state has been loaded
	 *  @memberof DataTable#oApi
	 */
  function _fnLoadState( settings, oInit, callback )
  {
    var i, ien;
    var columns = settings.aoColumns;
    var loaded = function ( s ) {
      if ( ! s || ! s.time ) {
        callback();
        return;
      }

      // Allow custom and plug-in manipulation functions to alter the saved data set and
      // cancelling of loading by returning false
      var abStateLoad = _fnCallbackFire( settings, "aoStateLoadParams", "stateLoadParams", [settings, s] );
      if ( $.inArray( false, abStateLoad ) !== -1 ) {
        callback();
        return;
      }

      // Reject old data
      var duration = settings.iStateDuration;
      if ( duration > 0 && s.time < +new Date() - (duration * 1000) ) {
        callback();
        return;
      }

      // Number of columns have changed - all bets are off, no restore of settings
      if ( s.columns && columns.length !== s.columns.length ) {
        callback();
        return;
      }

      // Store the saved state so it might be accessed at any time
      settings.oLoadedState = $.extend( true, {}, s );

      // Restore key features - todo - for 1.11 this needs to be done by
      // subscribed events
      if ( s.start !== undefined ) {
        settings._iDisplayStart = s.start;
        settings.iInitDisplayStart = s.start;
      }
      if ( s.length !== undefined ) {
        settings._iDisplayLength = s.length;
      }

      // Order
      if ( s.order !== undefined ) {
        settings.aaSorting = [];
        $.each( s.order, function ( i, col ) {
          settings.aaSorting.push( col[0] >= columns.length ?
            [ 0, col[1] ] :
            col
          );
        } );
      }

      // Search
      if ( s.search !== undefined ) {
        $.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
      }

      // Columns
      //
      if ( s.columns ) {
        for ( i = 0, ien = s.columns.length ; i < ien ; i++ ) {
          var col = s.columns[i];

          // Visibility
          if ( col.visible !== undefined ) {
            columns[i].bVisible = col.visible;
          }

          // Search
          if ( col.search !== undefined ) {
            $.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
          }
        }
      }

      _fnCallbackFire( settings, "aoStateLoaded", "stateLoaded", [settings, s] );
      callback();
    };

    if ( ! settings.oFeatures.bStateSave ) {
      callback();
      return;
    }

    var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );

    if ( state !== undefined ) {
      loaded( state );
    }
    // otherwise, wait for the loaded callback to be executed
  }

  /**
	 * Return the settings object for a particular table
	 *  @param {node} table table we are using as a dataTable
	 *  @returns {object} Settings object - or null if not found
	 *  @memberof DataTable#oApi
	 */
  function _fnSettingsFromNode( table )
  {
    var settings = DataTable.settings;
    var idx = $.inArray( table, _pluck( settings, "nTable" ) );

    return idx !== -1 ?
      settings[ idx ] :
      null;
  }

  /**
	 * Log an error message
	 *  @param {object} settings dataTables settings object
	 *  @param {int} level log error messages, or display them to the user
	 *  @param {string} msg error message
	 *  @param {int} tn Technical note id to get more information about the error.
	 *  @memberof DataTable#oApi
	 */
  function _fnLog( settings, level, msg, tn )
  {
    msg = "DataTables warning: " +
			(settings ? "table id=" + settings.sTableId + " - " : "") + msg;

    if ( tn ) {
      msg += ". For more information about this error, please see " +
			"http://datatables.net/tn/" + tn;
    }

    if ( ! level ) {
      // Backwards compatibility pre 1.10
      var ext = DataTable.ext;
      var type = ext.sErrMode || ext.errMode;

      if ( settings ) {
        _fnCallbackFire( settings, null, "error", [ settings, tn, msg ] );
      }

      if ( type == "alert" ) {
        alert( msg );
      }
      else if ( type == "throw" ) {
        throw new Error(msg);
      }
      else if ( typeof type === "function" ) {
        type( settings, tn, msg );
      }
    }
    else if ( window.console && console.log ) {
      console.log( msg );
    }
  }

  /**
	 * See if a property is defined on one object, if so assign it to the other object
	 *  @param {object} ret target object
	 *  @param {object} src source object
	 *  @param {string} name property
	 *  @param {string} [mappedName] name to map too - optional, name used if not given
	 *  @memberof DataTable#oApi
	 */
  function _fnMap( ret, src, name, mappedName )
  {
    if ( $.isArray( name ) ) {
      $.each( name, function (i, val) {
        if ( $.isArray( val ) ) {
          _fnMap( ret, src, val[0], val[1] );
        }
        else {
          _fnMap( ret, src, val );
        }
      } );

      return;
    }

    if ( mappedName === undefined ) {
      mappedName = name;
    }

    if ( src[name] !== undefined ) {
      ret[mappedName] = src[name];
    }
  }

  /**
	 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
	 * shallow copy arrays. The reason we need to do this, is that we don't want to
	 * deep copy array init values (such as aaSorting) since the dev wouldn't be
	 * able to override them, but we do want to deep copy arrays.
	 *  @param {object} out Object to extend
	 *  @param {object} extender Object from which the properties will be applied to
	 *      out
	 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
	 *      independent copy with the exception of the `data` or `aaData` parameters
	 *      if they are present. This is so you can pass in a collection to
	 *      DataTables and have that used as your data source without breaking the
	 *      references
	 *  @returns {object} out Reference, just for convenience - out === the return.
	 *  @memberof DataTable#oApi
	 *  @todo This doesn't take account of arrays inside the deep copied objects.
	 */
  function _fnExtend( out, extender, breakRefs )
  {
    var val;

    for ( var prop in extender ) {
      if ( extender.hasOwnProperty(prop) ) {
        val = extender[prop];

        if ( $.isPlainObject( val ) ) {
          if ( ! $.isPlainObject( out[prop] ) ) {
            out[prop] = {};
          }
          $.extend( true, out[prop], val );
        }
        else if ( breakRefs && prop !== "data" && prop !== "aaData" && $.isArray(val) ) {
          out[prop] = val.slice();
        }
        else {
          out[prop] = val;
        }
      }
    }

    return out;
  }

  /**
	 * Bind an event handers to allow a click or return key to activate the callback.
	 * This is good for accessibility since a return on the keyboard will have the
	 * same effect as a click, if the element has focus.
	 *  @param {element} n Element to bind the action to
	 *  @param {object} oData Data object to pass to the triggered function
	 *  @param {function} fn Callback function for when the event is triggered
	 *  @memberof DataTable#oApi
	 */
  function _fnBindAction( n, oData, fn )
  {
    $(n)
      .on( "click.DT", oData, function (e) {
        n.blur(); // Remove focus outline for mouse users
        fn(e);
      } )
      .on( "keypress.DT", oData, function (e) {
        if ( e.which === 13 ) {
          e.preventDefault();
          fn(e);
        }
      } )
      .on( "selectstart.DT", function () {
        /* Take the brutal approach to cancelling text selection */
        return false;
      } );
  }

  /**
	 * Register a callback function. Easily allows a callback function to be added to
	 * an array store of callback functions that can then all be called together.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
	 *  @param {function} fn Function to be called back
	 *  @param {string} sName Identifying name for the callback (i.e. a label)
	 *  @memberof DataTable#oApi
	 */
  function _fnCallbackReg( oSettings, sStore, fn, sName )
  {
    if ( fn )
    {
      oSettings[sStore].push( {
        "fn": fn,
        "sName": sName
      } );
    }
  }

  /**
	 * Fire callback functions and trigger events. Note that the loop over the
	 * callback array store is done backwards! Further note that you do not want to
	 * fire off triggers in time sensitive applications (for example cell creation)
	 * as its slow.
	 *  @param {object} settings dataTables settings object
	 *  @param {string} callbackArr Name of the array storage for the callbacks in
	 *      oSettings
	 *  @param {string} eventName Name of the jQuery custom event to trigger. If
	 *      null no trigger is fired
	 *  @param {array} args Array of arguments to pass to the callback function /
	 *      trigger
	 *  @memberof DataTable#oApi
	 */
  function _fnCallbackFire( settings, callbackArr, eventName, args )
  {
    var ret = [];

    if ( callbackArr ) {
      ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
        return val.fn.apply( settings.oInstance, args );
      } );
    }

    if ( eventName !== null ) {
      var e = $.Event( eventName + ".dt" );

      $(settings.nTable).trigger( e, args );

      ret.push( e.result );
    }

    return ret;
  }

  function _fnLengthOverflow( settings )
  {
    var
      start = settings._iDisplayStart,
      end = settings.fnDisplayEnd(),
      len = settings._iDisplayLength;

    /* If we have space to show extra rows (backing up from the end point - then do so */
    if ( start >= end )
    {
      start = end - len;
    }

    // Keep the start record on the current page
    start -= (start % len);

    if ( len === -1 || start < 0 )
    {
      start = 0;
    }

    settings._iDisplayStart = start;
  }

  function _fnRenderer( settings, type )
  {
    var renderer = settings.renderer;
    var host = DataTable.ext.renderer[type];

    if ( $.isPlainObject( renderer ) && renderer[type] ) {
      // Specific renderer for this type. If available use it, otherwise use
      // the default.
      return host[renderer[type]] || host._;
    }
    else if ( typeof renderer === "string" ) {
      // Common renderer - if there is one available for this type use it,
      // otherwise use the default
      return host[renderer] || host._;
    }

    // Use the default
    return host._;
  }

  /**
	 * Detect the data source being used for the table. Used to simplify the code
	 * a little (ajax) and to make it compress a little smaller.
	 *
	 *  @param {object} settings dataTables settings object
	 *  @returns {string} Data source
	 *  @memberof DataTable#oApi
	 */
  function _fnDataSource( settings )
  {
    if ( settings.oFeatures.bServerSide ) {
      return "ssp";
    }
    else if ( settings.ajax || settings.sAjaxSource ) {
      return "ajax";
    }
    return "dom";
  }

  /**
	 * Computed structure of the DataTables API, defined by the options passed to
	 * `DataTable.Api.register()` when building the API.
	 *
	 * The structure is built in order to speed creation and extension of the Api
	 * objects since the extensions are effectively pre-parsed.
	 *
	 * The array is an array of objects with the following structure, where this
	 * base array represents the Api prototype base:
	 *
	 *     [
	 *       {
	 *         name:      'data'                -- string   - Property name
	 *         val:       function () {},       -- function - Api method (or undefined if just an object
	 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	 *       },
	 *       {
	 *         name:     'row'
	 *         val:       {},
	 *         methodExt: [ ... ],
	 *         propExt:   [
	 *           {
	 *             name:      'data'
	 *             val:       function () {},
	 *             methodExt: [ ... ],
	 *             propExt:   [ ... ]
	 *           },
	 *           ...
	 *         ]
	 *       }
	 *     ]
	 *
	 * @type {Array}
	 * @ignore
	 */
  var __apiStruct = [];

  /**
	 * `Array.prototype` reference.
	 *
	 * @type object
	 * @ignore
	 */
  var __arrayProto = Array.prototype;

  /**
	 * Abstraction for `context` parameter of the `Api` constructor to allow it to
	 * take several different forms for ease of use.
	 *
	 * Each of the input parameter types will be converted to a DataTables settings
	 * object where possible.
	 *
	 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
	 *   of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 *   * `DataTables.Api` - API instance
	 * @return {array|null} Matching DataTables settings objects. `null` or
	 *   `undefined` is returned if no matching DataTable is found.
	 * @ignore
	 */
  var _toSettings = function ( mixed )
  {
    var idx, jq;
    var settings = DataTable.settings;
    var tables = $.map( settings, function (el, i) {
      return el.nTable;
    } );

    if ( ! mixed ) {
      return [];
    }
    else if ( mixed.nTable && mixed.oApi ) {
      // DataTables settings object
      return [ mixed ];
    }
    else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === "table" ) {
      // Table node
      idx = $.inArray( mixed, tables );
      return idx !== -1 ? [ settings[idx] ] : null;
    }
    else if ( mixed && typeof mixed.settings === "function" ) {
      return mixed.settings().toArray();
    }
    else if ( typeof mixed === "string" ) {
      // jQuery selector
      jq = $(mixed);
    }
    else if ( mixed instanceof $ ) {
      // jQuery object (also DataTables instance)
      jq = mixed;
    }

    if ( jq ) {
      return jq.map( function (i) {
        idx = $.inArray( this, tables );
        return idx !== -1 ? settings[idx] : null;
      } ).toArray();
    }
  };

  /**
	 * DataTables API class - used to control and interface with  one or more
	 * DataTables enhanced tables.
	 *
	 * The API class is heavily based on jQuery, presenting a chainable interface
	 * that you can use to interact with tables. Each instance of the API class has
	 * a "context" - i.e. the tables that it will operate on. This could be a single
	 * table, all tables on a page or a sub-set thereof.
	 *
	 * Additionally the API is designed to allow you to easily work with the data in
	 * the tables, retrieving and manipulating it as required. This is done by
	 * presenting the API class as an array like interface. The contents of the
	 * array depend upon the actions requested by each method (for example
	 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
	 * return an array of objects or arrays depending upon your table's
	 * configuration). The API object has a number of array like methods (`push`,
	 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
	 * `unique` etc) to assist your working with the data held in a table.
	 *
	 * Most methods (those which return an Api instance) are chainable, which means
	 * the return from a method call also has all of the methods available that the
	 * top level object had. For example, these two calls are equivalent:
	 *
	 *     // Not chained
	 *     api.row.add( {...} );
	 *     api.draw();
	 *
	 *     // Chained
	 *     api.row.add( {...} ).draw();
	 *
	 * @class DataTable.Api
	 * @param {array|object|string|jQuery} context DataTable identifier. This is
	 *   used to define which DataTables enhanced tables this API will operate on.
	 *   Can be one of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 * @param {array} [data] Data to initialise the Api instance with.
	 *
	 * @example
	 *   // Direct initialisation during DataTables construction
	 *   var api = $('#example').DataTable();
	 *
	 * @example
	 *   // Initialisation using a DataTables jQuery object
	 *   var api = $('#example').dataTable().api();
	 *
	 * @example
	 *   // Initialisation as a constructor
	 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
	 */
  _Api = function ( context, data )
  {
    if ( ! (this instanceof _Api) ) {
      return new _Api( context, data );
    }

    var settings = [];
    var ctxSettings = function ( o ) {
      var a = _toSettings( o );
      if ( a ) {
        settings = settings.concat( a );
      }
    };

    if ( $.isArray( context ) ) {
      for ( var i = 0, ien = context.length ; i < ien ; i++ ) {
        ctxSettings( context[i] );
      }
    }
    else {
      ctxSettings( context );
    }

    // Remove duplicates
    this.context = _unique( settings );

    // Initial data
    if ( data ) {
      $.merge( this, data );
    }

    // selector
    this.selector = {
      rows: null,
      cols: null,
      opts: null
    };

    _Api.extend( this, this, __apiStruct );
  };

  DataTable.Api = _Api;

  // Don't destroy the existing prototype, just extend it. Required for jQuery 2's
  // isPlainObject.
  $.extend( _Api.prototype, {
    any: function ()
    {
      return this.count() !== 0;
    },

    concat: __arrayProto.concat,

    context: [], // array of table settings objects

    count: function ()
    {
      return this.flatten().length;
    },

    each: function ( fn )
    {
      for ( var i = 0, ien = this.length ; i < ien; i++ ) {
        fn.call( this, this[i], i, this );
      }

      return this;
    },

    eq: function ( idx )
    {
      var ctx = this.context;

      return ctx.length > idx ?
        new _Api( ctx[idx], this[idx] ) :
        null;
    },

    filter: function ( fn )
    {
      var a = [];

      if ( __arrayProto.filter ) {
        a = __arrayProto.filter.call( this, fn, this );
      }
      else {
        // Compatibility for browsers without EMCA-252-5 (JS 1.6)
        for ( var i = 0, ien = this.length ; i < ien ; i++ ) {
          if ( fn.call( this, this[i], i, this ) ) {
            a.push( this[i] );
          }
        }
      }

      return new _Api( this.context, a );
    },

    flatten: function ()
    {
      var a = [];
      return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
    },

    join: __arrayProto.join,

    indexOf: __arrayProto.indexOf || function (obj, start)
    {
      for ( var i = (start || 0), ien = this.length ; i < ien ; i++ ) {
        if ( this[i] === obj ) {
          return i;
        }
      }
      return -1;
    },

    iterator: function ( flatten, type, fn, alwaysNew ) {
      var
        a = [], ret,
        i, ien, j, jen,
        context = this.context,
        rows, items, item,
        selector = this.selector;

      // Argument shifting
      if ( typeof flatten === "string" ) {
        alwaysNew = fn;
        fn = type;
        type = flatten;
        flatten = false;
      }

      for ( i = 0, ien = context.length ; i < ien ; i++ ) {
        var apiInst = new _Api( context[i] );

        if ( type === "table" ) {
          ret = fn.call( apiInst, context[i], i );

          if ( ret !== undefined ) {
            a.push( ret );
          }
        }
        else if ( type === "columns" || type === "rows" ) {
          // this has same length as context - one entry for each table
          ret = fn.call( apiInst, context[i], this[i], i );

          if ( ret !== undefined ) {
            a.push( ret );
          }
        }
        else if ( type === "column" || type === "column-rows" || type === "row" || type === "cell" ) {
          // columns and rows share the same structure.
          // 'this' is an array of column indexes for each context
          items = this[i];

          if ( type === "column-rows" ) {
            rows = _selector_row_indexes( context[i], selector.opts );
          }

          for ( j = 0, jen = items.length ; j < jen ; j++ ) {
            item = items[j];

            if ( type === "cell" ) {
              ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
            }
            else {
              ret = fn.call( apiInst, context[i], item, i, j, rows );
            }

            if ( ret !== undefined ) {
              a.push( ret );
            }
          }
        }
      }

      if ( a.length || alwaysNew ) {
        var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
        var apiSelector = api.selector;
        apiSelector.rows = selector.rows;
        apiSelector.cols = selector.cols;
        apiSelector.opts = selector.opts;
        return api;
      }
      return this;
    },

    lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
    {
      // Bit cheeky...
      return this.indexOf.apply( this.toArray.reverse(), arguments );
    },

    length: 0,

    map: function ( fn )
    {
      var a = [];

      if ( __arrayProto.map ) {
        a = __arrayProto.map.call( this, fn, this );
      }
      else {
        // Compatibility for browsers without EMCA-252-5 (JS 1.6)
        for ( var i = 0, ien = this.length ; i < ien ; i++ ) {
          a.push( fn.call( this, this[i], i ) );
        }
      }

      return new _Api( this.context, a );
    },

    pluck: function ( prop )
    {
      return this.map( function ( el ) {
        return el[ prop ];
      } );
    },

    pop: __arrayProto.pop,

    push: __arrayProto.push,

    // Does not return an API instance
    reduce: __arrayProto.reduce || function ( fn, init )
    {
      return _fnReduce( this, fn, init, 0, this.length, 1 );
    },

    reduceRight: __arrayProto.reduceRight || function ( fn, init )
    {
      return _fnReduce( this, fn, init, this.length - 1, -1, -1 );
    },

    reverse: __arrayProto.reverse,

    // Object with rows, columns and opts
    selector: null,

    shift: __arrayProto.shift,

    slice: function () {
      return new _Api( this.context, this );
    },

    sort: __arrayProto.sort, // ? name - order?

    splice: __arrayProto.splice,

    toArray: function ()
    {
      return __arrayProto.slice.call( this );
    },

    to$: function ()
    {
      return $( this );
    },

    toJQuery: function ()
    {
      return $( this );
    },

    unique: function ()
    {
      return new _Api( this.context, _unique(this) );
    },

    unshift: __arrayProto.unshift
  } );

  _Api.extend = function ( scope, obj, ext )
  {
    // Only extend API instances and static properties of the API
    if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
      return;
    }

    var
      i, ien,
      j, jen,
      struct, inner,
      methodScoping = function ( scope, fn, struc ) {
        return function () {
          var ret = fn.apply( scope, arguments );

          // Method extension
          _Api.extend( ret, ret, struc.methodExt );
          return ret;
        };
      };

    for ( i = 0, ien = ext.length ; i < ien ; i++ ) {
      struct = ext[i];

      // Value
      obj[ struct.name ] = typeof struct.val === "function" ?
        methodScoping( scope, struct.val, struct ) :
        $.isPlainObject( struct.val ) ?
          {} :
          struct.val;

      obj[ struct.name ].__dt_wrapper = true;

      // Property extension
      _Api.extend( scope, obj[ struct.name ], struct.propExt );
    }
  };

  // @todo - Is there need for an augment function?
  // _Api.augment = function ( inst, name )
  // {
  // 	// Find src object in the structure from the name
  // 	var parts = name.split('.');

  // 	_Api.extend( inst, obj );
  // };

  //     [
  //       {
  //         name:      'data'                -- string   - Property name
  //         val:       function () {},       -- function - Api method (or undefined if just an object
  //         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
  //         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
  //       },
  //       {
  //         name:     'row'
  //         val:       {},
  //         methodExt: [ ... ],
  //         propExt:   [
  //           {
  //             name:      'data'
  //             val:       function () {},
  //             methodExt: [ ... ],
  //             propExt:   [ ... ]
  //           },
  //           ...
  //         ]
  //       }
  //     ]

  _Api.register = _api_register = function ( name, val )
  {
    if ( $.isArray( name ) ) {
      for ( var j = 0, jen = name.length ; j < jen ; j++ ) {
        _Api.register( name[j], val );
      }
      return;
    }

    var
      i, ien,
      heir = name.split("."),
      struct = __apiStruct,
      key, method;

    var find = function ( src, name ) {
      for ( var i = 0, ien = src.length ; i < ien ; i++ ) {
        if ( src[i].name === name ) {
          return src[i];
        }
      }
      return null;
    };

    for ( i = 0, ien = heir.length ; i < ien ; i++ ) {
      method = heir[i].indexOf("()") !== -1;
      key = method ?
        heir[i].replace("()", "") :
        heir[i];

      var src = find( struct, key );
      if ( ! src ) {
        src = {
          name: key,
          val: {},
          methodExt: [],
          propExt: []
        };
        struct.push( src );
      }

      if ( i === ien - 1 ) {
        src.val = val;
      }
      else {
        struct = method ?
          src.methodExt :
          src.propExt;
      }
    }
  };

  _Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
    _Api.register( pluralName, val );

    _Api.register( singularName, function () {
      var ret = val.apply( this, arguments );

      if ( ret === this ) {
        // Returned item is the API instance that was passed in, return it
        return this;
      }
      else if ( ret instanceof _Api ) {
        // New API instance returned, want the value from the first item
        // in the returned array for the singular result.
        return ret.length ?
          $.isArray( ret[0] ) ?
            new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
            ret[0] :
          undefined;
      }

      // Non-API return - just fire it back
      return ret;
    } );
  };

  /**
	 * Selector for HTML tables. Apply the given selector to the give array of
	 * DataTables settings objects.
	 *
	 * @param {string|integer} [selector] jQuery selector string or integer
	 * @param  {array} Array of DataTables settings objects to be filtered
	 * @return {array}
	 * @ignore
	 */
  var __table_selector = function ( selector, a )
  {
    // Integer is used to pick out a table by index
    if ( typeof selector === "number" ) {
      return [ a[ selector ] ];
    }

    // Perform a jQuery selector on the table nodes
    var nodes = $.map( a, function (el, i) {
      return el.nTable;
    } );

    return $(nodes)
      .filter( selector )
      .map( function (i) {
        // Need to translate back from the table node to the settings
        var idx = $.inArray( this, nodes );
        return a[ idx ];
      } )
      .toArray();
  };

  /**
	 * Context selector for the API's context (i.e. the tables the API instance
	 * refers to.
	 *
	 * @name    DataTable.Api#tables
	 * @param {string|integer} [selector] Selector to pick which tables the iterator
	 *   should operate on. If not given, all tables in the current context are
	 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
	 *   select multiple tables or as an integer to select a single table.
	 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
	 */
  _api_register( "tables()", function ( selector ) {
    // A new instance is created if there was a selector specified
    return selector ?
      new _Api( __table_selector( selector, this.context ) ) :
      this;
  } );

  _api_register( "table()", function ( selector ) {
    var tables = this.tables( selector );
    var ctx = tables.context;

    // Truncate to the first matched table
    return ctx.length ?
      new _Api( ctx[0] ) :
      tables;
  } );

  _api_registerPlural( "tables().nodes()", "table().node()", function () {
    return this.iterator( "table", function ( ctx ) {
      return ctx.nTable;
    }, 1 );
  } );

  _api_registerPlural( "tables().body()", "table().body()", function () {
    return this.iterator( "table", function ( ctx ) {
      return ctx.nTBody;
    }, 1 );
  } );

  _api_registerPlural( "tables().header()", "table().header()", function () {
    return this.iterator( "table", function ( ctx ) {
      return ctx.nTHead;
    }, 1 );
  } );

  _api_registerPlural( "tables().footer()", "table().footer()", function () {
    return this.iterator( "table", function ( ctx ) {
      return ctx.nTFoot;
    }, 1 );
  } );

  _api_registerPlural( "tables().containers()", "table().container()", function () {
    return this.iterator( "table", function ( ctx ) {
      return ctx.nTableWrapper;
    }, 1 );
  } );

  /**
	 * Redraw the tables in the current context.
	 */
  _api_register( "draw()", function ( paging ) {
    return this.iterator( "table", function ( settings ) {
      if ( paging === "page" ) {
        _fnDraw( settings );
      }
      else {
        if ( typeof paging === "string" ) {
          paging = paging === "full-hold" ?
            false :
            true;
        }

        _fnReDraw( settings, paging === false );
      }
    } );
  } );

  /**
	 * Get the current page index.
	 *
	 * @return {integer} Current page index (zero based)
	 *//**
	 * Set the current page.
	 *
	 * Note that if you attempt to show a page which does not exist, DataTables will
	 * not throw an error, but rather reset the paging.
	 *
	 * @param {integer|string} action The paging action to take. This can be one of:
	 *  * `integer` - The page index to jump to
	 *  * `string` - An action to take:
	 *    * `first` - Jump to first page.
	 *    * `next` - Jump to the next page
	 *    * `previous` - Jump to previous page
	 *    * `last` - Jump to the last page.
	 * @returns {DataTables.Api} this
	 */
  _api_register( "page()", function ( action ) {
    if ( action === undefined ) {
      return this.page.info().page; // not an expensive call
    }

    // else, have an action to take on all tables
    return this.iterator( "table", function ( settings ) {
      _fnPageChange( settings, action );
    } );
  } );

  /**
	 * Paging information for the first table in the current context.
	 *
	 * If you require paging information for another table, use the `table()` method
	 * with a suitable selector.
	 *
	 * @return {object} Object with the following properties set:
	 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
	 *  * `pages` - Total number of pages
	 *  * `start` - Display index for the first record shown on the current page
	 *  * `end` - Display index for the last record shown on the current page
	 *  * `length` - Display length (number of records). Note that generally `start
	 *    + length = end`, but this is not always true, for example if there are
	 *    only 2 records to show on the final page, with a length of 10.
	 *  * `recordsTotal` - Full data set length
	 *  * `recordsDisplay` - Data set length once the current filtering criterion
	 *    are applied.
	 */
  _api_register( "page.info()", function ( action ) {
    if ( this.context.length === 0 ) {
      return undefined;
    }

    var
      settings = this.context[0],
      start = settings._iDisplayStart,
      len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
      visRecords = settings.fnRecordsDisplay(),
      all = len === -1;

    return {
      "page": all ? 0 : Math.floor( start / len ),
      "pages": all ? 1 : Math.ceil( visRecords / len ),
      "start": start,
      "end": settings.fnDisplayEnd(),
      "length": len,
      "recordsTotal": settings.fnRecordsTotal(),
      "recordsDisplay": visRecords,
      "serverSide": _fnDataSource( settings ) === "ssp"
    };
  } );

  /**
	 * Get the current page length.
	 *
	 * @return {integer} Current page length. Note `-1` indicates that all records
	 *   are to be shown.
	 *//**
	 * Set the current page length.
	 *
	 * @param {integer} Page length to set. Use `-1` to show all records.
	 * @returns {DataTables.Api} this
	 */
  _api_register( "page.len()", function ( len ) {
    // Note that we can't call this function 'length()' because `length`
    // is a Javascript property of functions which defines how many arguments
    // the function expects.
    if ( len === undefined ) {
      return this.context.length !== 0 ?
        this.context[0]._iDisplayLength :
        undefined;
    }

    // else, set the page length
    return this.iterator( "table", function ( settings ) {
      _fnLengthChange( settings, len );
    } );
  } );

  var __reload = function ( settings, holdPosition, callback ) {
    // Use the draw event to trigger a callback
    if ( callback ) {
      var api = new _Api( settings );

      api.one( "draw", function () {
        callback( api.ajax.json() );
      } );
    }

    if ( _fnDataSource( settings ) == "ssp" ) {
      _fnReDraw( settings, holdPosition );
    }
    else {
      _fnProcessingDisplay( settings, true );

      // Cancel an existing request
      var xhr = settings.jqXHR;
      if ( xhr && xhr.readyState !== 4 ) {
        xhr.abort();
      }

      // Trigger xhr
      _fnBuildAjax( settings, [], function ( json ) {
        _fnClearTable( settings );

        var data = _fnAjaxDataSrc( settings, json );
        for ( var i = 0, ien = data.length ; i < ien ; i++ ) {
          _fnAddData( settings, data[i] );
        }

        _fnReDraw( settings, holdPosition );
        _fnProcessingDisplay( settings, false );
      } );
    }
  };

  /**
	 * Get the JSON response from the last Ajax request that DataTables made to the
	 * server. Note that this returns the JSON from the first table in the current
	 * context.
	 *
	 * @return {object} JSON received from the server.
	 */
  _api_register( "ajax.json()", function () {
    var ctx = this.context;

    if ( ctx.length > 0 ) {
      return ctx[0].json;
    }

    // else return undefined;
  } );

  /**
	 * Get the data submitted in the last Ajax request
	 */
  _api_register( "ajax.params()", function () {
    var ctx = this.context;

    if ( ctx.length > 0 ) {
      return ctx[0].oAjaxData;
    }

    // else return undefined;
  } );

  /**
	 * Reload tables from the Ajax data source. Note that this function will
	 * automatically re-draw the table when the remote data has been loaded.
	 *
	 * @param {boolean} [reset=true] Reset (default) or hold the current paging
	 *   position. A full re-sort and re-filter is performed when this method is
	 *   called, which is why the pagination reset is the default action.
	 * @returns {DataTables.Api} this
	 */
  _api_register( "ajax.reload()", function ( callback, resetPaging ) {
    return this.iterator( "table", function (settings) {
      __reload( settings, resetPaging === false, callback );
    } );
  } );

  /**
	 * Get the current Ajax URL. Note that this returns the URL from the first
	 * table in the current context.
	 *
	 * @return {string} Current Ajax source URL
	 *//**
	 * Set the Ajax URL. Note that this will set the URL for all tables in the
	 * current context.
	 *
	 * @param {string} url URL to set.
	 * @returns {DataTables.Api} this
	 */
  _api_register( "ajax.url()", function ( url ) {
    var ctx = this.context;

    if ( url === undefined ) {
      // get
      if ( ctx.length === 0 ) {
        return undefined;
      }
      ctx = ctx[0];

      return ctx.ajax ?
        $.isPlainObject( ctx.ajax ) ?
          ctx.ajax.url :
          ctx.ajax :
        ctx.sAjaxSource;
    }

    // set
    return this.iterator( "table", function ( settings ) {
      if ( $.isPlainObject( settings.ajax ) ) {
        settings.ajax.url = url;
      }
      else {
        settings.ajax = url;
      }
      // No need to consider sAjaxSource here since DataTables gives priority
      // to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
      // value of `sAjaxSource` redundant.
    } );
  } );

  /**
	 * Load data from the newly set Ajax URL. Note that this method is only
	 * available when `ajax.url()` is used to set a URL. Additionally, this method
	 * has the same effect as calling `ajax.reload()` but is provided for
	 * convenience when setting a new URL. Like `ajax.reload()` it will
	 * automatically redraw the table once the remote data has been loaded.
	 *
	 * @returns {DataTables.Api} this
	 */
  _api_register( "ajax.url().load()", function ( callback, resetPaging ) {
    // Same as a reload, but makes sense to present it for easy access after a
    // url change
    return this.iterator( "table", function ( ctx ) {
      __reload( ctx, resetPaging === false, callback );
    } );
  } );

  var _selector_run = function ( type, selector, selectFn, settings, opts )
  {
    var
      out = [], res,
      a, i, ien, j, jen,
      selectorType = typeof selector;

    // Can't just check for isArray here, as an API or jQuery instance might be
    // given with their array like look
    if ( ! selector || selectorType === "string" || selectorType === "function" || selector.length === undefined ) {
      selector = [ selector ];
    }

    for ( i = 0, ien = selector.length ; i < ien ; i++ ) {
      // Only split on simple strings - complex expressions will be jQuery selectors
      a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
        selector[i].split(",") :
        [ selector[i] ];

      for ( j = 0, jen = a.length ; j < jen ; j++ ) {
        res = selectFn( typeof a[j] === "string" ? $.trim(a[j]) : a[j] );

        if ( res && res.length ) {
          out = out.concat( res );
        }
      }
    }

    // selector extensions
    var ext = _ext.selector[ type ];
    if ( ext.length ) {
      for ( i = 0, ien = ext.length ; i < ien ; i++ ) {
        out = ext[i]( settings, opts, out );
      }
    }

    return _unique( out );
  };

  var _selector_opts = function ( opts )
  {
    if ( ! opts ) {
      opts = {};
    }

    // Backwards compatibility for 1.9- which used the terminology filter rather
    // than search
    if ( opts.filter && opts.search === undefined ) {
      opts.search = opts.filter;
    }

    return $.extend( {
      search: "none",
      order: "current",
      page: "all"
    }, opts );
  };

  var _selector_first = function ( inst )
  {
    // Reduce the API instance to the first item found
    for ( var i = 0, ien = inst.length ; i < ien ; i++ ) {
      if ( inst[i].length > 0 ) {
        // Assign the first element to the first item in the instance
        // and truncate the instance and context
        inst[0] = inst[i];
        inst[0].length = 1;
        inst.length = 1;
        inst.context = [ inst.context[i] ];

        return inst;
      }
    }

    // Not found - return an empty instance
    inst.length = 0;
    return inst;
  };

  var _selector_row_indexes = function ( settings, opts )
  {
    var
      i, ien, tmp, a = [],
      displayFiltered = settings.aiDisplay,
      displayMaster = settings.aiDisplayMaster;

    var
      search = opts.search, // none, applied, removed
      order = opts.order, // applied, current, index (original - compatibility with 1.9)
      page = opts.page; // all, current

    if ( _fnDataSource( settings ) == "ssp" ) {
      // In server-side processing mode, most options are irrelevant since
      // rows not shown don't exist and the index order is the applied order
      // Removed is a special case - for consistency just return an empty
      // array
      return search === "removed" ?
        [] :
        _range( 0, displayMaster.length );
    }
    else if ( page == "current" ) {
      // Current page implies that order=current and fitler=applied, since it is
      // fairly senseless otherwise, regardless of what order and search actually
      // are
      for ( i = settings._iDisplayStart, ien = settings.fnDisplayEnd() ; i < ien ; i++ ) {
        a.push( displayFiltered[i] );
      }
    }
    else if ( order == "current" || order == "applied" ) {
      a = search == "none" ?
        displayMaster.slice() : // no search
        search == "applied" ?
          displayFiltered.slice() : // applied search
          $.map( displayMaster, function (el, i) { // removed search
            return $.inArray( el, displayFiltered ) === -1 ? el : null;
          } );
    }
    else if ( order == "index" || order == "original" ) {
      for ( i = 0, ien = settings.aoData.length ; i < ien ; i++ ) {
        if ( search == "none" ) {
          a.push( i );
        }
        else { // applied | removed
          tmp = $.inArray( i, displayFiltered );

          if ((tmp === -1 && search == "removed") ||
						(tmp >= 0 && search == "applied") )
          {
            a.push( i );
          }
        }
      }
    }

    return a;
  };

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Rows
	 *
	 * {}          - no selector - use all available rows
	 * {integer}   - row aoData index
	 * {node}      - TR node
	 * {string}    - jQuery selector to apply to the TR elements
	 * {array}     - jQuery array of nodes, or simply an array of TR nodes
	 *
	 */

  var __row_selector = function ( settings, selector, opts )
  {
    var rows;
    var run = function ( sel ) {
      var selInt = _intVal( sel );
      var i, ien;

      // Short cut - selector is a number and no options provided (default is
      // all records, so no need to check if the index is in there, since it
      // must be - dev error if the index doesn't exist).
      if ( selInt !== null && ! opts ) {
        return [ selInt ];
      }

      if ( ! rows ) {
        rows = _selector_row_indexes( settings, opts );
      }

      if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
        // Selector - integer
        return [ selInt ];
      }
      else if ( sel === null || sel === undefined || sel === "" ) {
        // Selector - none
        return rows;
      }

      // Selector - function
      if ( typeof sel === "function" ) {
        return $.map( rows, function (idx) {
          var row = settings.aoData[ idx ];
          return sel( idx, row._aData, row.nTr ) ? idx : null;
        } );
      }

      // Get nodes in the order from the `rows` array with null values removed
      var nodes = _removeEmpty(
        _pluck_order( settings.aoData, rows, "nTr" )
      );

      // Selector - node
      if ( sel.nodeName ) {
        if ( sel._DT_RowIndex !== undefined ) {
          return [ sel._DT_RowIndex ]; // Property added by DT for fast lookup
        }
        else if ( sel._DT_CellIndex ) {
          return [ sel._DT_CellIndex.row ];
        }
        else {
          var host = $(sel).closest("*[data-dt-row]");
          return host.length ?
            [ host.data("dt-row") ] :
            [];
        }
      }

      // ID selector. Want to always be able to select rows by id, regardless
      // of if the tr element has been created or not, so can't rely upon
      // jQuery here - hence a custom implementation. This does not match
      // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
      // but to select it using a CSS selector engine (like Sizzle or
      // querySelect) it would need to need to be escaped for some characters.
      // DataTables simplifies this for row selectors since you can select
      // only a row. A # indicates an id any anything that follows is the id -
      // unescaped.
      if ( typeof sel === "string" && sel.charAt(0) === "#" ) {
        // get row index from id
        var rowObj = settings.aIds[ sel.replace( /^#/, "" ) ];
        if ( rowObj !== undefined ) {
          return [ rowObj.idx ];
        }

        // need to fall through to jQuery in case there is DOM id that
        // matches
      }

      // Selector - jQuery selector string, array of nodes or jQuery object/
      // As jQuery's .filter() allows jQuery objects to be passed in filter,
      // it also allows arrays, so this will cope with all three options
      return $(nodes)
        .filter( sel )
        .map( function () {
          return this._DT_RowIndex;
        } )
        .toArray();
    };

    return _selector_run( "row", selector, run, settings, opts );
  };

  _api_register( "rows()", function ( selector, opts ) {
    // argument shifting
    if ( selector === undefined ) {
      selector = "";
    }
    else if ( $.isPlainObject( selector ) ) {
      opts = selector;
      selector = "";
    }

    opts = _selector_opts( opts );

    var inst = this.iterator( "table", function ( settings ) {
      return __row_selector( settings, selector, opts );
    }, 1 );

    // Want argument shifting here and in __row_selector?
    inst.selector.rows = selector;
    inst.selector.opts = opts;

    return inst;
  } );

  _api_register( "rows().nodes()", function () {
    return this.iterator( "row", function ( settings, row ) {
      return settings.aoData[ row ].nTr || undefined;
    }, 1 );
  } );

  _api_register( "rows().data()", function () {
    return this.iterator( true, "rows", function ( settings, rows ) {
      return _pluck_order( settings.aoData, rows, "_aData" );
    }, 1 );
  } );

  _api_registerPlural( "rows().cache()", "row().cache()", function ( type ) {
    return this.iterator( "row", function ( settings, row ) {
      var r = settings.aoData[ row ];
      return type === "search" ? r._aFilterData : r._aSortData;
    }, 1 );
  } );

  _api_registerPlural( "rows().invalidate()", "row().invalidate()", function ( src ) {
    return this.iterator( "row", function ( settings, row ) {
      _fnInvalidate( settings, row, src );
    } );
  } );

  _api_registerPlural( "rows().indexes()", "row().index()", function () {
    return this.iterator( "row", function ( settings, row ) {
      return row;
    }, 1 );
  } );

  _api_registerPlural( "rows().ids()", "row().id()", function ( hash ) {
    var a = [];
    var context = this.context;

    // `iterator` will drop undefined values, but in this case we want them
    for ( var i = 0, ien = context.length ; i < ien ; i++ ) {
      for ( var j = 0, jen = this[i].length ; j < jen ; j++ ) {
        var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
        a.push( (hash === true ? "#" : "" ) + id );
      }
    }

    return new _Api( context, a );
  } );

  _api_registerPlural( "rows().remove()", "row().remove()", function () {
    var that = this;

    this.iterator( "row", function ( settings, row, thatIdx ) {
      var data = settings.aoData;
      var rowData = data[ row ];
      var i, ien, j, jen;
      var loopRow, loopCells;

      data.splice( row, 1 );

      // Update the cached indexes
      for ( i = 0, ien = data.length ; i < ien ; i++ ) {
        loopRow = data[i];
        loopCells = loopRow.anCells;

        // Rows
        if ( loopRow.nTr !== null ) {
          loopRow.nTr._DT_RowIndex = i;
        }

        // Cells
        if ( loopCells !== null ) {
          for ( j = 0, jen = loopCells.length ; j < jen ; j++ ) {
            loopCells[j]._DT_CellIndex.row = i;
          }
        }
      }

      // Delete from the display arrays
      _fnDeleteIndex( settings.aiDisplayMaster, row );
      _fnDeleteIndex( settings.aiDisplay, row );
      _fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes

      // For server-side processing tables - subtract the deleted row from the count
      if ( settings._iRecordsDisplay > 0 ) {
        settings._iRecordsDisplay--;
      }

      // Check for an 'overflow' they case for displaying the table
      _fnLengthOverflow( settings );

      // Remove the row's ID reference if there is one
      var id = settings.rowIdFn( rowData._aData );
      if ( id !== undefined ) {
        delete settings.aIds[ id ];
      }
    } );

    this.iterator( "table", function ( settings ) {
      for ( var i = 0, ien = settings.aoData.length ; i < ien ; i++ ) {
        settings.aoData[i].idx = i;
      }
    } );

    return this;
  } );

  _api_register( "rows.add()", function ( rows ) {
    var newRows = this.iterator( "table", function ( settings ) {
      var row, i, ien;
      var out = [];

      for ( i = 0, ien = rows.length ; i < ien ; i++ ) {
        row = rows[i];

        if ( row.nodeName && row.nodeName.toUpperCase() === "TR" ) {
          out.push( _fnAddTr( settings, row )[0] );
        }
        else {
          out.push( _fnAddData( settings, row ) );
        }
      }

      return out;
    }, 1 );

    // Return an Api.rows() extended instance, so rows().nodes() etc can be used
    var modRows = this.rows( -1 );
    modRows.pop();
    $.merge( modRows, newRows );

    return modRows;
  } );

  /**
	 *
	 */
  _api_register( "row()", function ( selector, opts ) {
    return _selector_first( this.rows( selector, opts ) );
  } );

  _api_register( "row().data()", function ( data ) {
    var ctx = this.context;

    if ( data === undefined ) {
      // Get
      return ctx.length && this.length ?
        ctx[0].aoData[ this[0] ]._aData :
        undefined;
    }

    // Set
    ctx[0].aoData[ this[0] ]._aData = data;

    // Automatically invalidate
    _fnInvalidate( ctx[0], this[0], "data" );

    return this;
  } );

  _api_register( "row().node()", function () {
    var ctx = this.context;

    return ctx.length && this.length ?
      ctx[0].aoData[ this[0] ].nTr || null :
      null;
  } );

  _api_register( "row.add()", function ( row ) {
    // Allow a jQuery object to be passed in - only a single row is added from
    // it though - the first element in the set
    if ( row instanceof $ && row.length ) {
      row = row[0];
    }

    var rows = this.iterator( "table", function ( settings ) {
      if ( row.nodeName && row.nodeName.toUpperCase() === "TR" ) {
        return _fnAddTr( settings, row )[0];
      }
      return _fnAddData( settings, row );
    } );

    // Return an Api.rows() extended instance, with the newly added row selected
    return this.row( rows[0] );
  } );

  var __details_add = function ( ctx, row, data, klass )
  {
    // Convert to array of TR elements
    var rows = [];
    var addRow = function ( r, k ) {
      // Recursion to allow for arrays of jQuery objects
      if ( $.isArray( r ) || r instanceof $ ) {
        for ( var i = 0, ien = r.length ; i < ien ; i++ ) {
          addRow( r[i], k );
        }
        return;
      }

      // If we get a TR element, then just add it directly - up to the dev
      // to add the correct number of columns etc
      if ( r.nodeName && r.nodeName.toLowerCase() === "tr" ) {
        rows.push( r );
      }
      else {
        // Otherwise create a row with a wrapper
        var created = $("<tr><td/></tr>").addClass( k );
        $("td", created)
          .addClass( k )
          .html( r )
          [0].colSpan = _fnVisbleColumns( ctx );

        rows.push( created[0] );
      }
    };

    addRow( data, klass );

    if ( row._details ) {
      row._details.detach();
    }

    row._details = $(rows);

    // If the children were already shown, that state should be retained
    if ( row._detailsShow ) {
      row._details.insertAfter( row.nTr );
    }
  };

  var __details_remove = function ( api, idx )
  {
    var ctx = api.context;

    if ( ctx.length ) {
      var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];

      if ( row && row._details ) {
        row._details.remove();

        row._detailsShow = undefined;
        row._details = undefined;
      }
    }
  };

  var __details_display = function ( api, show ) {
    var ctx = api.context;

    if ( ctx.length && api.length ) {
      var row = ctx[0].aoData[ api[0] ];

      if ( row._details ) {
        row._detailsShow = show;

        if ( show ) {
          row._details.insertAfter( row.nTr );
        }
        else {
          row._details.detach();
        }

        __details_events( ctx[0] );
      }
    }
  };

  var __details_events = function ( settings )
  {
    var api = new _Api( settings );
    var namespace = ".dt.DT_details";
    var drawEvent = "draw" + namespace;
    var colvisEvent = "column-visibility" + namespace;
    var destroyEvent = "destroy" + namespace;
    var data = settings.aoData;

    api.off( drawEvent + " " + colvisEvent + " " + destroyEvent );

    if ( _pluck( data, "_details" ).length > 0 ) {
      // On each draw, insert the required elements into the document
      api.on( drawEvent, function ( e, ctx ) {
        if ( settings !== ctx ) {
          return;
        }

        api.rows( { page: "current" } ).eq(0).each( function (idx) {
          // Internal data grab
          var row = data[ idx ];

          if ( row._detailsShow ) {
            row._details.insertAfter( row.nTr );
          }
        } );
      } );

      // Column visibility change - update the colspan
      api.on( colvisEvent, function ( e, ctx, idx, vis ) {
        if ( settings !== ctx ) {
          return;
        }

        // Update the colspan for the details rows (note, only if it already has
        // a colspan)
        var row, visible = _fnVisbleColumns( ctx );

        for ( var i = 0, ien = data.length ; i < ien ; i++ ) {
          row = data[i];

          if ( row._details ) {
            row._details.children("td[colspan]").attr("colspan", visible );
          }
        }
      } );

      // Table destroyed - nuke any child rows
      api.on( destroyEvent, function ( e, ctx ) {
        if ( settings !== ctx ) {
          return;
        }

        for ( var i = 0, ien = data.length ; i < ien ; i++ ) {
          if ( data[i]._details ) {
            __details_remove( api, i );
          }
        }
      } );
    }
  };

  // Strings for the method names to help minification
  var _emp = "";
  var _child_obj = _emp + "row().child";
  var _child_mth = _child_obj + "()";

  // data can be:
  //  tr
  //  string
  //  jQuery or array of any of the above
  _api_register( _child_mth, function ( data, klass ) {
    var ctx = this.context;

    if ( data === undefined ) {
      // get
      return ctx.length && this.length ?
        ctx[0].aoData[ this[0] ]._details :
        undefined;
    }
    else if ( data === true ) {
      // show
      this.child.show();
    }
    else if ( data === false ) {
      // remove
      __details_remove( this );
    }
    else if ( ctx.length && this.length ) {
      // set
      __details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
    }

    return this;
  } );

  _api_register( [
    _child_obj + ".show()",
    _child_mth + ".show()" // only when `child()` was called with parameters (without
  ], function ( show ) { // it returns an object and this method is not executed)
    __details_display( this, true );
    return this;
  } );

  _api_register( [
    _child_obj + ".hide()",
    _child_mth + ".hide()" // only when `child()` was called with parameters (without
  ], function () { // it returns an object and this method is not executed)
    __details_display( this, false );
    return this;
  } );

  _api_register( [
    _child_obj + ".remove()",
    _child_mth + ".remove()" // only when `child()` was called with parameters (without
  ], function () { // it returns an object and this method is not executed)
    __details_remove( this );
    return this;
  } );

  _api_register( _child_obj + ".isShown()", function () {
    var ctx = this.context;

    if ( ctx.length && this.length ) {
      // _detailsShown as false or undefined will fall through to return false
      return ctx[0].aoData[ this[0] ]._detailsShow || false;
    }
    return false;
  } );

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Columns
	 *
	 * {integer}           - column index (>=0 count from left, <0 count from right)
	 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
	 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
	 * "{string}:name"     - column name
	 * "{string}"          - jQuery selector on column header nodes
	 *
	 */

  // can be an array of these items, comma separated list, or an array of comma
  // separated lists

  var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;

  // r1 and r2 are redundant - but it means that the parameters match for the
  // iterator callback in columns().data()
  var __columnData = function ( settings, column, r1, r2, rows ) {
    var a = [];
    for ( var row = 0, ien = rows.length ; row < ien ; row++ ) {
      a.push( _fnGetCellData( settings, rows[row], column ) );
    }
    return a;
  };

  var __column_selector = function ( settings, selector, opts )
  {
    var
      columns = settings.aoColumns,
      names = _pluck( columns, "sName" ),
      nodes = _pluck( columns, "nTh" );

    var run = function ( s ) {
      var selInt = _intVal( s );

      // Selector - all
      if ( s === "" ) {
        return _range( columns.length );
      }

      // Selector - index
      if ( selInt !== null ) {
        return [ selInt >= 0 ?
          selInt : // Count from left
          columns.length + selInt // Count from right (+ because its a negative value)
        ];
      }

      // Selector = function
      if ( typeof s === "function" ) {
        var rows = _selector_row_indexes( settings, opts );

        return $.map( columns, function (col, idx) {
          return s(
            idx,
            __columnData( settings, idx, 0, 0, rows ),
            nodes[ idx ]
          ) ? idx : null;
        } );
      }

      // jQuery or string selector
      var match = typeof s === "string" ?
        s.match( __re_column_selector ) :
        "";

      if ( match ) {
        switch ( match[2] ) {
          case "visIdx":
          case "visible":
            var idx = parseInt( match[1], 10 );
            // Visible index given, convert to column index
            if ( idx < 0 ) {
              // Counting from the right
              var visColumns = $.map( columns, function (col, i) {
                return col.bVisible ? i : null;
              } );
              return [ visColumns[ visColumns.length + idx ] ];
            }
            // Counting from the left
            return [ _fnVisibleToColumnIndex( settings, idx ) ];

          case "name":
            // match by name. `names` is column index complete and in order
            return $.map( names, function (name, i) {
              return name === match[1] ? i : null;
            } );

          default:
            return [];
        }
      }

      // Cell in the table body
      if ( s.nodeName && s._DT_CellIndex ) {
        return [ s._DT_CellIndex.column ];
      }

      // jQuery selector on the TH elements for the columns
      var jqResult = $( nodes )
        .filter( s )
        .map( function () {
          return $.inArray( this, nodes ); // `nodes` is column index complete and in order
        } )
        .toArray();

      if ( jqResult.length || ! s.nodeName ) {
        return jqResult;
      }

      // Otherwise a node which might have a `dt-column` data attribute, or be
      // a child or such an element
      var host = $(s).closest("*[data-dt-column]");
      return host.length ?
        [ host.data("dt-column") ] :
        [];
    };

    return _selector_run( "column", selector, run, settings, opts );
  };

  var __setColumnVis = function ( settings, column, vis ) {
    var
      cols = settings.aoColumns,
      col = cols[ column ],
      data = settings.aoData,
      row, cells, i, ien, tr;

    // Get
    if ( vis === undefined ) {
      return col.bVisible;
    }

    // Set
    // No change
    if ( col.bVisible === vis ) {
      return;
    }

    if ( vis ) {
      // Insert column
      // Need to decide if we should use appendChild or insertBefore
      var insertBefore = $.inArray( true, _pluck(cols, "bVisible"), column + 1 );

      for ( i = 0, ien = data.length ; i < ien ; i++ ) {
        tr = data[i].nTr;
        cells = data[i].anCells;

        if ( tr ) {
          // insertBefore can act like appendChild if 2nd arg is null
          tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
        }
      }
    }
    else {
      // Remove column
      $( _pluck( settings.aoData, "anCells", column ) ).detach();
    }

    // Common actions
    col.bVisible = vis;
    _fnDrawHead( settings, settings.aoHeader );
    _fnDrawHead( settings, settings.aoFooter );

    _fnSaveState( settings );
  };

  _api_register( "columns()", function ( selector, opts ) {
    // argument shifting
    if ( selector === undefined ) {
      selector = "";
    }
    else if ( $.isPlainObject( selector ) ) {
      opts = selector;
      selector = "";
    }

    opts = _selector_opts( opts );

    var inst = this.iterator( "table", function ( settings ) {
      return __column_selector( settings, selector, opts );
    }, 1 );

    // Want argument shifting here and in _row_selector?
    inst.selector.cols = selector;
    inst.selector.opts = opts;

    return inst;
  } );

  _api_registerPlural( "columns().header()", "column().header()", function ( selector, opts ) {
    return this.iterator( "column", function ( settings, column ) {
      return settings.aoColumns[column].nTh;
    }, 1 );
  } );

  _api_registerPlural( "columns().footer()", "column().footer()", function ( selector, opts ) {
    return this.iterator( "column", function ( settings, column ) {
      return settings.aoColumns[column].nTf;
    }, 1 );
  } );

  _api_registerPlural( "columns().data()", "column().data()", function () {
    return this.iterator( "column-rows", __columnData, 1 );
  } );

  _api_registerPlural( "columns().dataSrc()", "column().dataSrc()", function () {
    return this.iterator( "column", function ( settings, column ) {
      return settings.aoColumns[column].mData;
    }, 1 );
  } );

  _api_registerPlural( "columns().cache()", "column().cache()", function ( type ) {
    return this.iterator( "column-rows", function ( settings, column, i, j, rows ) {
      return _pluck_order( settings.aoData, rows,
        type === "search" ? "_aFilterData" : "_aSortData", column
      );
    }, 1 );
  } );

  _api_registerPlural( "columns().nodes()", "column().nodes()", function () {
    return this.iterator( "column-rows", function ( settings, column, i, j, rows ) {
      return _pluck_order( settings.aoData, rows, "anCells", column ) ;
    }, 1 );
  } );

  _api_registerPlural( "columns().visible()", "column().visible()", function ( vis, calc ) {
    var ret = this.iterator( "column", function ( settings, column ) {
      if ( vis === undefined ) {
        return settings.aoColumns[ column ].bVisible;
      } // else
      __setColumnVis( settings, column, vis );
    } );

    // Group the column visibility changes
    if ( vis !== undefined ) {
      // Second loop once the first is done for events
      this.iterator( "column", function ( settings, column ) {
        _fnCallbackFire( settings, null, "column-visibility", [settings, column, vis, calc] );
      } );

      if ( calc === undefined || calc ) {
        this.columns.adjust();
      }
    }

    return ret;
  } );

  _api_registerPlural( "columns().indexes()", "column().index()", function ( type ) {
    return this.iterator( "column", function ( settings, column ) {
      return type === "visible" ?
        _fnColumnIndexToVisible( settings, column ) :
        column;
    }, 1 );
  } );

  _api_register( "columns.adjust()", function () {
    return this.iterator( "table", function ( settings ) {
      _fnAdjustColumnSizing( settings );
    }, 1 );
  } );

  _api_register( "column.index()", function ( type, idx ) {
    if ( this.context.length !== 0 ) {
      var ctx = this.context[0];

      if ( type === "fromVisible" || type === "toData" ) {
        return _fnVisibleToColumnIndex( ctx, idx );
      }
      else if ( type === "fromData" || type === "toVisible" ) {
        return _fnColumnIndexToVisible( ctx, idx );
      }
    }
  } );

  _api_register( "column()", function ( selector, opts ) {
    return _selector_first( this.columns( selector, opts ) );
  } );

  var __cell_selector = function ( settings, selector, opts )
  {
    var data = settings.aoData;
    var rows = _selector_row_indexes( settings, opts );
    var cells = _removeEmpty( _pluck_order( data, rows, "anCells" ) );
    var allCells = $( [].concat.apply([], cells) );
    var row;
    var columns = settings.aoColumns.length;
    var a, i, ien, j, o, host;

    var run = function ( s ) {
      var fnSelector = typeof s === "function";

      if ( s === null || s === undefined || fnSelector ) {
        // All cells and function selectors
        a = [];

        for ( i = 0, ien = rows.length ; i < ien ; i++ ) {
          row = rows[i];

          for ( j = 0 ; j < columns ; j++ ) {
            o = {
              row: row,
              column: j
            };

            if ( fnSelector ) {
              // Selector - function
              host = data[ row ];

              if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
                a.push( o );
              }
            }
            else {
              // Selector - all
              a.push( o );
            }
          }
        }

        return a;
      }

      // Selector - index
      if ( $.isPlainObject( s ) ) {
        return [s];
      }

      // Selector - jQuery filtered cells
      var jqResult = allCells
        .filter( s )
        .map( function (i, el) {
          return { // use a new object, in case someone changes the values
            row: el._DT_CellIndex.row,
            column: el._DT_CellIndex.column
	 				};
        } )
        .toArray();

      if ( jqResult.length || ! s.nodeName ) {
        return jqResult;
      }

      // Otherwise the selector is a node, and there is one last option - the
      // element might be a child of an element which has dt-row and dt-column
      // data attributes
      host = $(s).closest("*[data-dt-row]");
      return host.length ?
        [ {
          row: host.data("dt-row"),
          column: host.data("dt-column")
        } ] :
        [];
    };

    return _selector_run( "cell", selector, run, settings, opts );
  };

  _api_register( "cells()", function ( rowSelector, columnSelector, opts ) {
    // Argument shifting
    if ( $.isPlainObject( rowSelector ) ) {
      // Indexes
      if ( rowSelector.row === undefined ) {
        // Selector options in first parameter
        opts = rowSelector;
        rowSelector = null;
      }
      else {
        // Cell index objects in first parameter
        opts = columnSelector;
        columnSelector = null;
      }
    }
    if ( $.isPlainObject( columnSelector ) ) {
      opts = columnSelector;
      columnSelector = null;
    }

    // Cell selector
    if ( columnSelector === null || columnSelector === undefined ) {
      return this.iterator( "table", function ( settings ) {
        return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
      } );
    }

    // Row + column selector
    var columns = this.columns( columnSelector, opts );
    var rows = this.rows( rowSelector, opts );
    var a, i, ien, j, jen;

    var cells = this.iterator( "table", function ( settings, idx ) {
      a = [];

      for ( i = 0, ien = rows[idx].length ; i < ien ; i++ ) {
        for ( j = 0, jen = columns[idx].length ; j < jen ; j++ ) {
          a.push( {
            row: rows[idx][i],
            column: columns[idx][j]
          } );
        }
      }

      return a;
    }, 1 );

    $.extend( cells.selector, {
      cols: columnSelector,
      rows: rowSelector,
      opts: opts
    } );

    return cells;
  } );

  _api_registerPlural( "cells().nodes()", "cell().node()", function () {
    return this.iterator( "cell", function ( settings, row, column ) {
      var data = settings.aoData[ row ];

      return data && data.anCells ?
        data.anCells[ column ] :
        undefined;
    }, 1 );
  } );

  _api_register( "cells().data()", function () {
    return this.iterator( "cell", function ( settings, row, column ) {
      return _fnGetCellData( settings, row, column );
    }, 1 );
  } );

  _api_registerPlural( "cells().cache()", "cell().cache()", function ( type ) {
    type = type === "search" ? "_aFilterData" : "_aSortData";

    return this.iterator( "cell", function ( settings, row, column ) {
      return settings.aoData[ row ][ type ][ column ];
    }, 1 );
  } );

  _api_registerPlural( "cells().render()", "cell().render()", function ( type ) {
    return this.iterator( "cell", function ( settings, row, column ) {
      return _fnGetCellData( settings, row, column, type );
    }, 1 );
  } );

  _api_registerPlural( "cells().indexes()", "cell().index()", function () {
    return this.iterator( "cell", function ( settings, row, column ) {
      return {
        row: row,
        column: column,
        columnVisible: _fnColumnIndexToVisible( settings, column )
      };
    }, 1 );
  } );

  _api_registerPlural( "cells().invalidate()", "cell().invalidate()", function ( src ) {
    return this.iterator( "cell", function ( settings, row, column ) {
      _fnInvalidate( settings, row, src, column );
    } );
  } );

  _api_register( "cell()", function ( rowSelector, columnSelector, opts ) {
    return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
  } );

  _api_register( "cell().data()", function ( data ) {
    var ctx = this.context;
    var cell = this[0];

    if ( data === undefined ) {
      // Get
      return ctx.length && cell.length ?
        _fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
        undefined;
    }

    // Set
    _fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
    _fnInvalidate( ctx[0], cell[0].row, "data", cell[0].column );

    return this;
  } );

  /**
	 * Get current ordering (sorting) that has been applied to the table.
	 *
	 * @returns {array} 2D array containing the sorting information for the first
	 *   table in the current context. Each element in the parent array represents
	 *   a column being sorted upon (i.e. multi-sorting with two columns would have
	 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
	 *   the column index that the sorting condition applies to, the second is the
	 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
	 *   index of the sorting order from the `column.sorting` initialisation array.
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {integer} order Column index to sort upon.
	 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 1D array of sorting information to be applied.
	 * @param {array} [...] Optional additional sorting conditions
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 2D array of sorting information to be applied.
	 * @returns {DataTables.Api} this
	 */
  _api_register( "order()", function ( order, dir ) {
    var ctx = this.context;

    if ( order === undefined ) {
      // get
      return ctx.length !== 0 ?
        ctx[0].aaSorting :
        undefined;
    }

    // set
    if ( typeof order === "number" ) {
      // Simple column / direction passed in
      order = [ [ order, dir ] ];
    }
    else if ( order.length && ! $.isArray( order[0] ) ) {
      // Arguments passed in (list of 1D arrays)
      order = Array.prototype.slice.call( arguments );
    }
    // otherwise a 2D array was passed in

    return this.iterator( "table", function ( settings ) {
      settings.aaSorting = order.slice();
    } );
  } );

  /**
	 * Attach a sort listener to an element for a given column
	 *
	 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
	 *   listener to. This can take the form of a single DOM node, a jQuery
	 *   collection of nodes or a jQuery selector which will identify the node(s).
	 * @param {integer} column the column that a click on this node will sort on
	 * @param {function} [callback] callback function when sort is run
	 * @returns {DataTables.Api} this
	 */
  _api_register( "order.listener()", function ( node, column, callback ) {
    return this.iterator( "table", function ( settings ) {
      _fnSortAttachListener( settings, node, column, callback );
    } );
  } );

  _api_register( "order.fixed()", function ( set ) {
    if ( ! set ) {
      var ctx = this.context;
      var fixed = ctx.length ?
        ctx[0].aaSortingFixed :
        undefined;

      return $.isArray( fixed ) ?
        { pre: fixed } :
        fixed;
    }

    return this.iterator( "table", function ( settings ) {
      settings.aaSortingFixed = $.extend( true, {}, set );
    } );
  } );

  // Order by the selected column(s)
  _api_register( [
    "columns().order()",
    "column().order()"
  ], function ( dir ) {
    var that = this;

    return this.iterator( "table", function ( settings, i ) {
      var sort = [];

      $.each( that[i], function (j, col) {
        sort.push( [ col, dir ] );
      } );

      settings.aaSorting = sort;
    } );
  } );

  _api_register( "search()", function ( input, regex, smart, caseInsen ) {
    var ctx = this.context;

    if ( input === undefined ) {
      // get
      return ctx.length !== 0 ?
        ctx[0].oPreviousSearch.sSearch :
        undefined;
    }

    // set
    return this.iterator( "table", function ( settings ) {
      if ( ! settings.oFeatures.bFilter ) {
        return;
      }

      _fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
        "sSearch": input + "",
        "bRegex": regex === null ? false : regex,
        "bSmart": smart === null ? true : smart,
        "bCaseInsensitive": caseInsen === null ? true : caseInsen
      } ), 1 );
    } );
  } );

  _api_registerPlural(
    "columns().search()",
    "column().search()",
    function ( input, regex, smart, caseInsen ) {
      return this.iterator( "column", function ( settings, column ) {
        var preSearch = settings.aoPreSearchCols;

        if ( input === undefined ) {
          // get
          return preSearch[ column ].sSearch;
        }

        // set
        if ( ! settings.oFeatures.bFilter ) {
          return;
        }

        $.extend( preSearch[ column ], {
          "sSearch": input + "",
          "bRegex": regex === null ? false : regex,
          "bSmart": smart === null ? true : smart,
          "bCaseInsensitive": caseInsen === null ? true : caseInsen
        } );

        _fnFilterComplete( settings, settings.oPreviousSearch, 1 );
      } );
    }
  );

  /*
	 * State API methods
	 */

  _api_register( "state()", function () {
    return this.context.length ?
      this.context[0].oSavedState :
      null;
  } );

  _api_register( "state.clear()", function () {
    return this.iterator( "table", function ( settings ) {
      // Save an empty object
      settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
    } );
  } );

  _api_register( "state.loaded()", function () {
    return this.context.length ?
      this.context[0].oLoadedState :
      null;
  } );

  _api_register( "state.save()", function () {
    return this.iterator( "table", function ( settings ) {
      _fnSaveState( settings );
    } );
  } );

  /**
	 * Provide a common method for plug-ins to check the version of DataTables being
	 * used, in order to ensure compatibility.
	 *
	 *  @param {string} version Version string to check for, in the format "X.Y.Z".
	 *    Note that the formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to
	 *    the required version, or false if this version of DataTales is not
	 *    suitable
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
	 */
  DataTable.versionCheck = DataTable.fnVersionCheck = function ( version )
  {
    var aThis = DataTable.version.split(".");
    var aThat = version.split(".");
    var iThis, iThat;

    for ( var i = 0, iLen = aThat.length ; i < iLen ; i++ ) {
      iThis = parseInt( aThis[i], 10 ) || 0;
      iThat = parseInt( aThat[i], 10 ) || 0;

      // Parts are the same, keep comparing
      if (iThis === iThat) {
        continue;
      }

      // Parts are different, return immediately
      return iThis > iThat;
    }

    return true;
  };

  /**
	 * Check if a `<table>` node is a DataTable table already or not.
	 *
	 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
	 *      selector for the table to test. Note that if more than more than one
	 *      table is passed on, only the first will be checked
	 *  @returns {boolean} true the table given is a DataTable, or false otherwise
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
	 *      $('#example').dataTable();
	 *    }
	 */
  DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
  {
    var t = $(table).get(0);
    var is = false;

    if ( table instanceof DataTable.Api ) {
      return true;
    }

    $.each( DataTable.settings, function (i, o) {
      var head = o.nScrollHead ? $("table", o.nScrollHead)[0] : null;
      var foot = o.nScrollFoot ? $("table", o.nScrollFoot)[0] : null;

      if ( o.nTable === t || head === t || foot === t ) {
        is = true;
      }
    } );

    return is;
  };

  /**
	 * Get all DataTable tables that have been initialised - optionally you can
	 * select to get only currently visible tables.
	 *
	 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
	 *    or visible tables only.
	 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
	 *    DataTables
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    $.each( $.fn.dataTable.tables(true), function () {
	 *      $(table).DataTable().columns.adjust();
	 *    } );
	 */
  DataTable.tables = DataTable.fnTables = function ( visible )
  {
    var api = false;

    if ( $.isPlainObject( visible ) ) {
      api = visible.api;
      visible = visible.visible;
    }

    var a = $.map( DataTable.settings, function (o) {
      if ( !visible || (visible && $(o.nTable).is(":visible")) ) {
        return o.nTable;
      }
    } );

    return api ?
      new _Api( a ) :
      a;
  };

  /**
	 * Convert from camel case parameters to Hungarian notation. This is made public
	 * for the extensions to provide the same ability as DataTables core to accept
	 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
	 * parameters.
	 *
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 */
  DataTable.camelToHungarian = _fnCamelToHungarian;

  /**
	 *
	 */
  _api_register( "$()", function ( selector, opts ) {
    var
      rows = this.rows( opts ).nodes(), // Get all rows
      jqRows = $(rows);

    return $( [].concat(
      jqRows.filter( selector ).toArray(),
      jqRows.find( selector ).toArray()
    ) );
  } );

  // jQuery functions to operate on the tables
  $.each( [ "on", "one", "off" ], function (i, key) {
    _api_register( key + "()", function ( /* event, handler */ ) {
      var args = Array.prototype.slice.call(arguments);

      // Add the `dt` namespace automatically if it isn't already present
      args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
        return ! e.match(/\.dt\b/) ?
          e + ".dt" :
          e;
      } ).join( " " );

      var inst = $( this.tables().nodes() );
      inst[key].apply( inst, args );
      return this;
    } );
  } );

  _api_register( "clear()", function () {
    return this.iterator( "table", function ( settings ) {
      _fnClearTable( settings );
    } );
  } );

  _api_register( "settings()", function () {
    return new _Api( this.context, this.context );
  } );

  _api_register( "init()", function () {
    var ctx = this.context;
    return ctx.length ? ctx[0].oInit : null;
  } );

  _api_register( "data()", function () {
    return this.iterator( "table", function ( settings ) {
      return _pluck( settings.aoData, "_aData" );
    } ).flatten();
  } );

  _api_register( "destroy()", function ( remove ) {
    remove = remove || false;

    return this.iterator( "table", function ( settings ) {
      var orig = settings.nTableWrapper.parentNode;
      var classes = settings.oClasses;
      var table = settings.nTable;
      var tbody = settings.nTBody;
      var thead = settings.nTHead;
      var tfoot = settings.nTFoot;
      var jqTable = $(table);
      var jqTbody = $(tbody);
      var jqWrapper = $(settings.nTableWrapper);
      var rows = $.map( settings.aoData, function (r) { return r.nTr; } );
      var i, ien;

      // Flag to note that the table is currently being destroyed - no action
      // should be taken
      settings.bDestroying = true;

      // Fire off the destroy callbacks for plug-ins etc
      _fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );

      // If not being removed from the document, make all columns visible
      if ( ! remove ) {
        new _Api( settings ).columns().visible( true );
      }

      // Blitz all `DT` namespaced events (these are internal events, the
      // lowercase, `dt` events are user subscribed and they are responsible
      // for removing them
      jqWrapper.off(".DT").find(":not(tbody *)").off(".DT");
      $(window).off(".DT-" + settings.sInstance);

      // When scrolling we had to break the table up - restore it
      if ( table != thead.parentNode ) {
        jqTable.children("thead").detach();
        jqTable.append( thead );
      }

      if ( tfoot && table != tfoot.parentNode ) {
        jqTable.children("tfoot").detach();
        jqTable.append( tfoot );
      }

      settings.aaSorting = [];
      settings.aaSortingFixed = [];
      _fnSortingClasses( settings );

      $( rows ).removeClass( settings.asStripeClasses.join(" ") );

      $("th, td", thead).removeClass( classes.sSortable + " " +
				classes.sSortableAsc + " " + classes.sSortableDesc + " " + classes.sSortableNone
      );

      // Add the TR elements back into the table in their original order
      jqTbody.children().detach();
      jqTbody.append( rows );

      // Remove the DataTables generated nodes, events and classes
      var removedMethod = remove ? "remove" : "detach";
      jqTable[ removedMethod ]();
      jqWrapper[ removedMethod ]();

      // If we need to reattach the table to the document
      if ( ! remove && orig ) {
        // insertBefore acts like appendChild if !arg[1]
        orig.insertBefore( table, settings.nTableReinsertBefore );

        // Restore the width of the original table - was read from the style property,
        // so we can restore directly to that
        jqTable
          .css( "width", settings.sDestroyWidth )
          .removeClass( classes.sTable );

        // If the were originally stripe classes - then we add them back here.
        // Note this is not fool proof (for example if not all rows had stripe
        // classes - but it's a good effort without getting carried away
        ien = settings.asDestroyStripes.length;

        if ( ien ) {
          jqTbody.children().each( function (i) {
            $(this).addClass( settings.asDestroyStripes[i % ien] );
          } );
        }
      }

      /* Remove the settings object from the settings array */
      var idx = $.inArray( settings, DataTable.settings );
      if ( idx !== -1 ) {
        DataTable.settings.splice( idx, 1 );
      }
    } );
  } );

  // Add the `every()` method for rows, columns and cells in a compact form
  $.each( [ "column", "row", "cell" ], function ( i, type ) {
    _api_register( type + "s().every()", function ( fn ) {
      var opts = this.selector.opts;
      var api = this;

      return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
        // Rows and columns:
        //  arg1 - index
        //  arg2 - table counter
        //  arg3 - loop counter
        //  arg4 - undefined
        // Cells:
        //  arg1 - row index
        //  arg2 - column index
        //  arg3 - table counter
        //  arg4 - loop counter
        fn.call(
          api[ type ](
            arg1,
            type === "cell" ? arg2 : opts,
            type === "cell" ? opts : undefined
          ),
          arg1, arg2, arg3, arg4
        );
      } );
    } );
  } );

  // i18n method for extensions to be able to use the language object from the
  // DataTable
  _api_register( "i18n()", function ( token, def, plural ) {
    var ctx = this.context[0];
    var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );

    if ( resolved === undefined ) {
      resolved = def;
    }

    if ( plural !== undefined && $.isPlainObject( resolved ) ) {
      resolved = resolved[ plural ] !== undefined ?
        resolved[ plural ] :
        resolved._;
    }

    return resolved.replace( "%d", plural ); // nb: plural might be undefined,
  } );

  /**
	 * Version string for plug-ins to check compatibility. Allowed format is
	 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
	 * only for non-release builds. See http://semver.org/ for more information.
	 *  @member
	 *  @type string
	 *  @default Version number
	 */
  DataTable.version = "1.10.16";

  /**
	 * Private data store, containing all of the settings objects that are
	 * created for the tables on a given page.
	 *
	 * Note that the `DataTable.settings` object is aliased to
	 * `jQuery.fn.dataTableExt` through which it may be accessed and
	 * manipulated, or `jQuery.fn.dataTable.settings`.
	 *  @member
	 *  @type array
	 *  @default []
	 *  @private
	 */
  DataTable.settings = [];

  /**
	 * Object models container, for the various models that DataTables has
	 * available to it. These models define the objects that are used to hold
	 * the active state and configuration of the table.
	 *  @namespace
	 */
  DataTable.models = {};

  /**
	 * Template object for the way in which DataTables holds information about
	 * search information for the global filter and individual column filters.
	 *  @namespace
	 */
  DataTable.models.oSearch = {
    /**
		 * Flag to indicate if the filtering should be case insensitive or not
		 *  @type boolean
		 *  @default true
		 */
    "bCaseInsensitive": true,

    /**
		 * Applied search term
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
    "sSearch": "",

    /**
		 * Flag to indicate if the search term should be interpreted as a
		 * regular expression (true) or not (false) and therefore and special
		 * regex characters escaped.
		 *  @type boolean
		 *  @default false
		 */
    "bRegex": false,

    /**
		 * Flag to indicate if DataTables is to use its smart filtering or not.
		 *  @type boolean
		 *  @default true
		 */
    "bSmart": true
  };

  /**
	 * Template object for the way in which DataTables holds information about
	 * each individual row. This is the object format used for the settings
	 * aoData array.
	 *  @namespace
	 */
  DataTable.models.oRow = {
    /**
		 * TR element for the row
		 *  @type node
		 *  @default null
		 */
    "nTr": null,

    /**
		 * Array of TD elements for each row. This is null until the row has been
		 * created.
		 *  @type array nodes
		 *  @default []
		 */
    "anCells": null,

    /**
		 * Data object from the original data source for the row. This is either
		 * an array if using the traditional form of DataTables, or an object if
		 * using mData options. The exact type will depend on the passed in
		 * data from the data source, or will be an array if using DOM a data
		 * source.
		 *  @type array|object
		 *  @default []
		 */
    "_aData": [],

    /**
		 * Sorting data cache - this array is ostensibly the same length as the
		 * number of columns (although each index is generated only as it is
		 * needed), and holds the data that is used for sorting each column in the
		 * row. We do this cache generation at the start of the sort in order that
		 * the formatting of the sort data need be done only once for each cell
		 * per sort. This array should not be read from or written to by anything
		 * other than the master sorting methods.
		 *  @type array
		 *  @default null
		 *  @private
		 */
    "_aSortData": null,

    /**
		 * Per cell filtering data cache. As per the sort data cache, used to
		 * increase the performance of the filtering in DataTables
		 *  @type array
		 *  @default null
		 *  @private
		 */
    "_aFilterData": null,

    /**
		 * Filtering data cache. This is the same as the cell filtering cache, but
		 * in this case a string rather than an array. This is easily computed with
		 * a join on `_aFilterData`, but is provided as a cache so the join isn't
		 * needed on every search (memory traded for performance)
		 *  @type array
		 *  @default null
		 *  @private
		 */
    "_sFilterRow": null,

    /**
		 * Cache of the class name that DataTables has applied to the row, so we
		 * can quickly look at this variable rather than needing to do a DOM check
		 * on className for the nTr property.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *  @private
		 */
    "_sRowStripe": "",

    /**
		 * Denote if the original data source was from the DOM, or the data source
		 * object. This is used for invalidating data, so DataTables can
		 * automatically read data from the original source, unless uninstructed
		 * otherwise.
		 *  @type string
		 *  @default null
		 *  @private
		 */
    "src": null,

    /**
		 * Index in the aoData array. This saves an indexOf lookup when we have the
		 * object, but want to know the index
		 *  @type integer
		 *  @default -1
		 *  @private
		 */
    "idx": -1
  };

  /**
	 * Template object for the column information object in DataTables. This object
	 * is held in the settings aoColumns array and contains all the information that
	 * DataTables needs about each individual column.
	 *
	 * Note that this object is related to {@link DataTable.defaults.column}
	 * but this one is the internal data store for DataTables's cache of columns.
	 * It should NOT be manipulated outside of DataTables. Any configuration should
	 * be done through the initialisation options.
	 *  @namespace
	 */
  DataTable.models.oColumn = {
    /**
		 * Column index. This could be worked out on-the-fly with $.inArray, but it
		 * is faster to just hold it as a variable
		 *  @type integer
		 *  @default null
		 */
    "idx": null,

    /**
		 * A list of the columns that sorting should occur on when this column
		 * is sorted. That this property is an array allows multi-column sorting
		 * to be defined for a column (for example first name / last name columns
		 * would benefit from this). The values are integers pointing to the
		 * columns to be sorted on (typically it will be a single integer pointing
		 * at itself, but that doesn't need to be the case).
		 *  @type array
		 */
    "aDataSort": null,

    /**
		 * Define the sorting directions that are applied to the column, in sequence
		 * as the column is repeatedly sorted upon - i.e. the first value is used
		 * as the sorting direction when the column if first sorted (clicked on).
		 * Sort it again (click again) and it will move on to the next index.
		 * Repeat until loop.
		 *  @type array
		 */
    "asSorting": null,

    /**
		 * Flag to indicate if the column is searchable, and thus should be included
		 * in the filtering or not.
		 *  @type boolean
		 */
    "bSearchable": null,

    /**
		 * Flag to indicate if the column is sortable or not.
		 *  @type boolean
		 */
    "bSortable": null,

    /**
		 * Flag to indicate if the column is currently visible in the table or not
		 *  @type boolean
		 */
    "bVisible": null,

    /**
		 * Store for manual type assignment using the `column.type` option. This
		 * is held in store so we can manipulate the column's `sType` property.
		 *  @type string
		 *  @default null
		 *  @private
		 */
    "_sManualType": null,

    /**
		 * Flag to indicate if HTML5 data attributes should be used as the data
		 * source for filtering or sorting. True is either are.
		 *  @type boolean
		 *  @default false
		 *  @private
		 */
    "_bAttrSrc": false,

    /**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} nTd The TD node that has been created
		 *  @param {*} sData The Data for the cell
		 *  @param {array|object} oData The data for the whole row
		 *  @param {int} iRow The row index for the aoData data store
		 *  @default null
		 */
    "fnCreatedCell": null,

    /**
		 * Function to get data from a cell in a column. You should <b>never</b>
		 * access data directly through _aData internally in DataTables - always use
		 * the method attached to this property. It allows mData to function as
		 * required. This function is automatically assigned by the column
		 * initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {string} sSpecific The specific data type you want to get -
		 *    'display', 'type' 'filter' 'sort'
		 *  @returns {*} The data for the cell from the given row's data
		 *  @default null
		 */
    "fnGetData": null,

    /**
		 * Function to set data for a cell in the column. You should <b>never</b>
		 * set the data directly to _aData internally in DataTables - always use
		 * this method. It allows mData to function as required. This function
		 * is automatically assigned by the column initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {*} sValue Value to set
		 *  @default null
		 */
    "fnSetData": null,

    /**
		 * Property to read the value for the cells in the column from the data
		 * source array / object. If null, then the default content is used, if a
		 * function is given then the return from the function is used.
		 *  @type function|int|string|null
		 *  @default null
		 */
    "mData": null,

    /**
		 * Partner property to mData which is used (only when defined) to get
		 * the data - i.e. it is basically the same as mData, but without the
		 * 'set' option, and also the data fed to it is the result from mData.
		 * This is the rendering method to match the data method of mData.
		 *  @type function|int|string|null
		 *  @default null
		 */
    "mRender": null,

    /**
		 * Unique header TH/TD element for this column - this is what the sorting
		 * listener is attached to (if sorting is enabled.)
		 *  @type node
		 *  @default null
		 */
    "nTh": null,

    /**
		 * Unique footer TH/TD element for this column (if there is one). Not used
		 * in DataTables as such, but can be used for plug-ins to reference the
		 * footer for each column.
		 *  @type node
		 *  @default null
		 */
    "nTf": null,

    /**
		 * The class to apply to all TD elements in the table's TBODY for the column
		 *  @type string
		 *  @default null
		 */
    "sClass": null,

    /**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 *  @type string
		 */
    "sContentPadding": null,

    /**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because mData
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 */
    "sDefaultContent": null,

    /**
		 * Name for the column, allowing reference to the column by name as well as
		 * by index (needs a lookup to work by name).
		 *  @type string
		 */
    "sName": null,

    /**
		 * Custom sorting data type - defines which of the available plug-ins in
		 * afnSortData the custom sorting will use - if any is defined.
		 *  @type string
		 *  @default std
		 */
    "sSortDataType": "std",

    /**
		 * Class to be applied to the header element when sorting on this column
		 *  @type string
		 *  @default null
		 */
    "sSortingClass": null,

    /**
		 * Class to be applied to the header element when sorting on this column -
		 * when jQuery UI theming is used.
		 *  @type string
		 *  @default null
		 */
    "sSortingClassJUI": null,

    /**
		 * Title of the column - what is seen in the TH element (nTh).
		 *  @type string
		 */
    "sTitle": null,

    /**
		 * Column sorting and filtering type
		 *  @type string
		 *  @default null
		 */
    "sType": null,

    /**
		 * Width of the column
		 *  @type string
		 *  @default null
		 */
    "sWidth": null,

    /**
		 * Width of the column when it was first "encountered"
		 *  @type string
		 *  @default null
		 */
    "sWidthOrig": null
  };

  /*
	 * Developer note: The properties of the object below are given in Hungarian
	 * notation, that was used as the interface for DataTables prior to v1.10, however
	 * from v1.10 onwards the primary interface is camel case. In order to avoid
	 * breaking backwards compatibility utterly with this change, the Hungarian
	 * version is still, internally the primary interface, but is is not documented
	 * - hence the @name tags in each doc comment. This allows a Javascript function
	 * to create a map from Hungarian notation to camel case (going the other direction
	 * would require each property to be listed, which would at around 3K to the size
	 * of DataTables, while this method is about a 0.5K hit.
	 *
	 * Ultimately this does pave the way for Hungarian notation to be dropped
	 * completely, but that is a massive amount of work and will break current
	 * installs (therefore is on-hold until v2).
	 */

  /**
	 * Initialisation options that can be given to DataTables at initialisation
	 * time.
	 *  @namespace
	 */
  DataTable.defaults = {
    /**
		 * An array of data to use for the table, passed in at initialisation which
		 * will be used in preference to any data which is already in the DOM. This is
		 * particularly useful for constructing tables purely in Javascript, for
		 * example with a custom Ajax call.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.data
		 *
		 *  @example
		 *    // Using a 2D array data source
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
		 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine" },
		 *          { "title": "Browser" },
		 *          { "title": "Platform" },
		 *          { "title": "Version" },
		 *          { "title": "Grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using an array of objects as a data source (`data`)
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 4.0",
		 *            "platform": "Win 95+",
		 *            "version":  4,
		 *            "grade":    "X"
		 *          },
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 5.0",
		 *            "platform": "Win 95+",
		 *            "version":  5,
		 *            "grade":    "C"
		 *          }
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine",   "data": "engine" },
		 *          { "title": "Browser",  "data": "browser" },
		 *          { "title": "Platform", "data": "platform" },
		 *          { "title": "Version",  "data": "version" },
		 *          { "title": "Grade",    "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
    "aaData": null,

    /**
		 * If ordering is enabled, then DataTables will perform a first pass sort on
		 * initialisation. You can define which column(s) the sort is performed
		 * upon, and the sorting direction, with this variable. The `sorting` array
		 * should contain an array for each column to be sorted initially containing
		 * the column's index and a direction string ('asc' or 'desc').
		 *  @type array
		 *  @default [[0,'asc']]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.order
		 *
		 *  @example
		 *    // Sort by 3rd column first, and then 4th column
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": [[2,'asc'], [3,'desc']]
		 *      } );
		 *    } );
		 *
		 *    // No initial sorting
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": []
		 *      } );
		 *    } );
		 */
    "aaSorting": [[0, "asc"]],

    /**
		 * This parameter is basically identical to the `sorting` parameter, but
		 * cannot be overridden by user interaction with the table. What this means
		 * is that you could have a column (visible or hidden) which the sorting
		 * will always be forced on first - any sorting after that (from the user)
		 * will then be performed as required. This can be useful for grouping rows
		 * together.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.orderFixed
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderFixed": [[0,'asc']]
		 *      } );
		 *    } )
		 */
    "aaSortingFixed": [],

    /**
		 * DataTables can be instructed to load data to display in the table from a
		 * Ajax source. This option defines how that Ajax call is made and where to.
		 *
		 * The `ajax` property has three different modes of operation, depending on
		 * how it is defined. These are:
		 *
		 * * `string` - Set the URL from where the data should be loaded from.
		 * * `object` - Define properties for `jQuery.ajax`.
		 * * `function` - Custom data get function
		 *
		 * `string`
		 * --------
		 *
		 * As a string, the `ajax` property simply defines the URL from which
		 * DataTables will load data.
		 *
		 * `object`
		 * --------
		 *
		 * As an object, the parameters in the object are passed to
		 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
		 * of the Ajax request. DataTables has a number of default parameters which
		 * you can override using this option. Please refer to the jQuery
		 * documentation for a full description of the options available, although
		 * the following parameters provide additional options in DataTables or
		 * require special consideration:
		 *
		 * * `data` - As with jQuery, `data` can be provided as an object, but it
		 *   can also be used as a function to manipulate the data DataTables sends
		 *   to the server. The function takes a single parameter, an object of
		 *   parameters with the values that DataTables has readied for sending. An
		 *   object may be returned which will be merged into the DataTables
		 *   defaults, or you can add the items to the object that was passed in and
		 *   not return anything from the function. This supersedes `fnServerParams`
		 *   from DataTables 1.9-.
		 *
		 * * `dataSrc` - By default DataTables will look for the property `data` (or
		 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
		 *   from an Ajax source or for server-side processing - this parameter
		 *   allows that property to be changed. You can use Javascript dotted
		 *   object notation to get a data source for multiple levels of nesting, or
		 *   it my be used as a function. As a function it takes a single parameter,
		 *   the JSON returned from the server, which can be manipulated as
		 *   required, with the returned value being that used by DataTables as the
		 *   data source for the table. This supersedes `sAjaxDataProp` from
		 *   DataTables 1.9-.
		 *
		 * * `success` - Should not be overridden it is used internally in
		 *   DataTables. To manipulate / transform the data returned by the server
		 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
		 *
		 * `function`
		 * ----------
		 *
		 * As a function, making the Ajax call is left up to yourself allowing
		 * complete control of the Ajax request. Indeed, if desired, a method other
		 * than Ajax could be used to obtain the required data, such as Web storage
		 * or an AIR database.
		 *
		 * The function is given four parameters and no return is required. The
		 * parameters are:
		 *
		 * 1. _object_ - Data to send to the server
		 * 2. _function_ - Callback function that must be executed when the required
		 *    data has been obtained. That data should be passed into the callback
		 *    as the only parameter
		 * 3. _object_ - DataTables settings object for the table
		 *
		 * Note that this supersedes `fnServerData` from DataTables 1.9-.
		 *
		 *  @type string|object|function
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.ajax
		 *  @since 1.10.0
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax.
		 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
		 *   $('#example').dataTable( {
		 *     "ajax": "data.json"
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
		 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": "tableData"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
		 *   // from a plain array rather than an array in an object
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": ""
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Manipulate the data returned from the server - add a link to data
		 *   // (note this can, should, be done using `render` for the column - this
		 *   // is just a simple example of how the data can be manipulated).
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": function ( json ) {
		 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
		 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
		 *         }
		 *         return json;
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Add data to the request
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "data": function ( d ) {
		 *         return {
		 *           "extra_search": $('#extra').val()
		 *         };
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Send request as POST
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "type": "POST"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get the data from localStorage (could interface with a form for
		 *   // adding, editing and removing rows).
		 *   $('#example').dataTable( {
		 *     "ajax": function (data, callback, settings) {
		 *       callback(
		 *         JSON.parse( localStorage.getItem('dataTablesData') )
		 *       );
		 *     }
		 *   } );
		 */
    "ajax": null,

    /**
		 * This parameter allows you to readily specify the entries in the length drop
		 * down menu that DataTables shows when pagination is enabled. It can be
		 * either a 1D array of options which will be used for both the displayed
		 * option and the value, or a 2D array which will use the array in the first
		 * position as the value, and the array in the second position as the
		 * displayed options (useful for language strings such as 'All').
		 *
		 * Note that the `pageLength` property will be automatically set to the
		 * first value given in this array, unless `pageLength` is also provided.
		 *  @type array
		 *  @default [ 10, 25, 50, 100 ]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.lengthMenu
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
		 *      } );
		 *    } );
		 */
    "aLengthMenu": [ 10, 25, 50, 100 ],

    /**
		 * The `columns` option in the initialisation parameter allows you to define
		 * details about the way individual columns behave. For a full list of
		 * column options that can be set, please see
		 * {@link DataTable.defaults.column}. Note that if you use `columns` to
		 * define your columns, you must have an entry in the array for every single
		 * column that you have in your table (these can be null if you don't which
		 * to specify any options).
		 *  @member
		 *
		 *  @name DataTable.defaults.column
		 */
    "aoColumns": null,

    /**
		 * Very similar to `columns`, `columnDefs` allows you to target a specific
		 * column, multiple columns, or all columns, using the `targets` property of
		 * each object in the array. This allows great flexibility when creating
		 * tables, as the `columnDefs` arrays can be of any length, targeting the
		 * columns you specifically want. `columnDefs` may use any of the column
		 * options available: {@link DataTable.defaults.column}, but it _must_
		 * have `targets` defined in each object in the array. Values in the `targets`
		 * array may be:
		 *   <ul>
		 *     <li>a string - class name will be matched on the TH for the column</li>
		 *     <li>0 or a positive integer - column index counting from the left</li>
		 *     <li>a negative integer - column index counting from the right</li>
		 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
		 *   </ul>
		 *  @member
		 *
		 *  @name DataTable.defaults.columnDefs
		 */
    "aoColumnDefs": null,

    /**
		 * Basically the same as `search`, this parameter defines the individual column
		 * filtering state at initialisation time. The array must be of the same size
		 * as the number of columns, and each element be an object with the parameters
		 * `search` and `escapeRegex` (the latter is optional). 'null' is also
		 * accepted and the default will be used.
		 *  @type array
		 *  @default []
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.searchCols
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchCols": [
		 *          null,
		 *          { "search": "My filter" },
		 *          null,
		 *          { "search": "^[0-9]", "escapeRegex": false }
		 *        ]
		 *      } );
		 *    } )
		 */
    "aoSearchCols": [],

    /**
		 * An array of CSS classes that should be applied to displayed rows. This
		 * array may be of any length, and DataTables will apply each class
		 * sequentially, looping when required.
		 *  @type array
		 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
		 *    options</i>
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.stripeClasses
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
		 *      } );
		 *    } )
		 */
    "asStripeClasses": null,

    /**
		 * Enable or disable automatic column width calculation. This can be disabled
		 * as an optimisation (it takes some time to calculate the widths) if the
		 * tables widths are passed in using `columns`.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.autoWidth
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "autoWidth": false
		 *      } );
		 *    } );
		 */
    "bAutoWidth": true,

    /**
		 * Deferred rendering can provide DataTables with a huge speed boost when you
		 * are using an Ajax or JS data source for the table. This option, when set to
		 * true, will cause DataTables to defer the creation of the table elements for
		 * each row until they are needed for a draw - saving a significant amount of
		 * time.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.deferRender
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajax": "sources/arrays.txt",
		 *        "deferRender": true
		 *      } );
		 *    } );
		 */
    "bDeferRender": false,

    /**
		 * Replace a DataTable which matches the given selector and replace it with
		 * one which has the properties of the new initialisation object passed. If no
		 * table matches the selector, then the new DataTable will be constructed as
		 * per normal.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.destroy
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "srollY": "200px",
		 *        "paginate": false
		 *      } );
		 *
		 *      // Some time later....
		 *      $('#example').dataTable( {
		 *        "filter": false,
		 *        "destroy": true
		 *      } );
		 *    } );
		 */
    "bDestroy": false,

    /**
		 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
		 * that it allows the end user to input multiple words (space separated) and
		 * will match a row containing those words, even if not in the order that was
		 * specified (this allow matching across multiple columns). Note that if you
		 * wish to use filtering in DataTables this must remain 'true' - to remove the
		 * default filtering input box and retain filtering abilities, please use
		 * {@link DataTable.defaults.dom}.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.searching
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "searching": false
		 *      } );
		 *    } );
		 */
    "bFilter": true,

    /**
		 * Enable or disable the table information display. This shows information
		 * about the data that is currently visible on the page, including information
		 * about filtered data if that action is being performed.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.info
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "info": false
		 *      } );
		 *    } );
		 */
    "bInfo": true,

    /**
		 * Allows the end user to select the size of a formatted page from a select
		 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.lengthChange
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "lengthChange": false
		 *      } );
		 *    } );
		 */
    "bLengthChange": true,

    /**
		 * Enable or disable pagination.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.paging
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "paging": false
		 *      } );
		 *    } );
		 */
    "bPaginate": true,

    /**
		 * Enable or disable the display of a 'processing' indicator when the table is
		 * being processed (e.g. a sort). This is particularly useful for tables with
		 * large amounts of data where it can take a noticeable amount of time to sort
		 * the entries.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.processing
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "processing": true
		 *      } );
		 *    } );
		 */
    "bProcessing": false,

    /**
		 * Retrieve the DataTables object for the given selector. Note that if the
		 * table has already been initialised, this parameter will cause DataTables
		 * to simply return the object that has already been set up - it will not take
		 * account of any changes you might have made to the initialisation object
		 * passed to DataTables (setting this parameter to true is an acknowledgement
		 * that you understand this). `destroy` can be used to reinitialise a table if
		 * you need.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.retrieve
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      initTable();
		 *      tableActions();
		 *    } );
		 *
		 *    function initTable ()
		 *    {
		 *      return $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false,
		 *        "retrieve": true
		 *      } );
		 *    }
		 *
		 *    function tableActions ()
		 *    {
		 *      var table = initTable();
		 *      // perform API operations with oTable
		 *    }
		 */
    "bRetrieve": false,

    /**
		 * When vertical (y) scrolling is enabled, DataTables will force the height of
		 * the table's viewport to the given height at all times (useful for layout).
		 * However, this can look odd when filtering data down to a small data set,
		 * and the footer is left "floating" further down. This parameter (when
		 * enabled) will cause DataTables to collapse the table's viewport down when
		 * the result set will fit within the given Y height.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollCollapse
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200",
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
    "bScrollCollapse": false,

    /**
		 * Configure DataTables to use server-side processing. Note that the
		 * `ajax` parameter must also be given in order to give DataTables a
		 * source to obtain the required data for each draw.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverSide
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "xhr.php"
		 *      } );
		 *    } );
		 */
    "bServerSide": false,

    /**
		 * Enable or disable sorting of columns. Sorting of individual columns can be
		 * disabled by the `sortable` option for each column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.ordering
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "ordering": false
		 *      } );
		 *    } );
		 */
    "bSort": true,

    /**
		 * Enable or display DataTables' ability to sort multiple columns at the
		 * same time (activated by shift-click by the user).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderMulti
		 *
		 *  @example
		 *    // Disable multiple column sorting ability
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderMulti": false
		 *      } );
		 *    } );
		 */
    "bSortMulti": true,

    /**
		 * Allows control over whether DataTables should use the top (true) unique
		 * cell that is found for a single column, or the bottom (false - default).
		 * This is useful when using complex headers.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderCellsTop
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderCellsTop": true
		 *      } );
		 *    } );
		 */
    "bSortCellsTop": false,

    /**
		 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
		 * `sorting\_3` to the columns which are currently being sorted on. This is
		 * presented as a feature switch as it can increase processing time (while
		 * classes are removed and added) so for large data sets you might want to
		 * turn this off.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.orderClasses
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderClasses": false
		 *      } );
		 *    } );
		 */
    "bSortClasses": true,

    /**
		 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
		 * used to save table display information such as pagination information,
		 * display length, filtering and sorting. As such when the end user reloads
		 * the page the display display will match what thy had previously set up.
		 *
		 * Due to the use of `localStorage` the default state saving is not supported
		 * in IE6 or 7. If state saving is required in those browsers, use
		 * `stateSaveCallback` to provide a storage solution such as cookies.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.stateSave
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "stateSave": true
		 *      } );
		 *    } );
		 */
    "bStateSave": false,

    /**
		 * This function is called when a TR element is created (and all TD child
		 * elements have been inserted), or registered if using a DOM source, allowing
		 * manipulation of the TR element (adding classes etc).
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} dataIndex The index of this row in the internal aoData array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.createdRow
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "createdRow": function( row, data, dataIndex ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" )
		 *          {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
    "fnCreatedRow": null,

    /**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify any aspect you want about the created DOM.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.drawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "drawCallback": function( settings ) {
		 *          alert( 'DataTables has redrawn the table' );
		 *        }
		 *      } );
		 *    } );
		 */
    "fnDrawCallback": null,

    /**
		 * Identical to fnHeaderCallback() but for the table footer this function
		 * allows you to modify the table footer on every 'draw' event.
		 *  @type function
		 *  @param {node} foot "TR" element for the footer
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.footerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "footerCallback": function( tfoot, data, start, end, display ) {
		 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
		 *        }
		 *      } );
		 *    } )
		 */
    "fnFooterCallback": null,

    /**
		 * When rendering large numbers in the information element for the table
		 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
		 * to have a comma separator for the 'thousands' units (e.g. 1 million is
		 * rendered as "1,000,000") to help readability for the end user. This
		 * function will override the default method DataTables uses.
		 *  @type function
		 *  @member
		 *  @param {int} toFormat number to be formatted
		 *  @returns {string} formatted string for DataTables to show the number
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.formatNumber
		 *
		 *  @example
		 *    // Format a number using a single quote for the separator (note that
		 *    // this can also be done with the language.thousands option)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "formatNumber": function ( toFormat ) {
		 *          return toFormat.toString().replace(
		 *            /\B(?=(\d{3})+(?!\d))/g, "'"
		 *          );
		 *        };
		 *      } );
		 *    } );
		 */
    "fnFormatNumber": function ( toFormat ) {
      return toFormat.toString().replace(
        /\B(?=(\d{3})+(?!\d))/g,
        this.oLanguage.sThousands
      );
    },

    /**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify the header row. This can be used to calculate and
		 * display useful information about the table.
		 *  @type function
		 *  @param {node} head "TR" element for the header
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.headerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "fheaderCallback": function( head, data, start, end, display ) {
		 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
		 *        }
		 *      } );
		 *    } )
		 */
    "fnHeaderCallback": null,

    /**
		 * The information element can be used to convey information about the current
		 * state of the table. Although the internationalisation options presented by
		 * DataTables are quite capable of dealing with most customisations, there may
		 * be times where you wish to customise the string further. This callback
		 * allows you to do exactly that.
		 *  @type function
		 *  @param {object} oSettings DataTables settings object
		 *  @param {int} start Starting position in data for the draw
		 *  @param {int} end End position in data for the draw
		 *  @param {int} max Total number of rows in the table (regardless of
		 *    filtering)
		 *  @param {int} total Total number of rows in the data set, after filtering
		 *  @param {string} pre The string that DataTables has formatted using it's
		 *    own rules
		 *  @returns {string} The string to be displayed in the information element.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.infoCallback
		 *
		 *  @example
		 *    $('#example').dataTable( {
		 *      "infoCallback": function( settings, start, end, max, total, pre ) {
		 *        return start +" to "+ end;
		 *      }
		 *    } );
		 */
    "fnInfoCallback": null,

    /**
		 * Called when the table has been initialised. Normally DataTables will
		 * initialise sequentially and there will be no need for this function,
		 * however, this does not hold true when using external language information
		 * since that is obtained using an async XHR call.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.initComplete
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "initComplete": function(settings, json) {
		 *          alert( 'DataTables has finished its initialisation.' );
		 *        }
		 *      } );
		 *    } )
		 */
    "fnInitComplete": null,

    /**
		 * Called at the very start of each table draw and can be used to cancel the
		 * draw by returning false, any other return (including undefined) results in
		 * the full draw occurring).
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @returns {boolean} False will cancel the draw, anything else (including no
		 *    return) will allow it to complete.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.preDrawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "preDrawCallback": function( settings ) {
		 *          if ( $('#test').val() == 1 ) {
		 *            return false;
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
    "fnPreDrawCallback": null,

    /**
		 * This function allows you to 'post process' each row after it have been
		 * generated for each table draw, but before it is rendered on screen. This
		 * function might be used for setting the row class name etc.
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} displayIndex The display index for the current table draw
		 *  @param {int} displayIndexFull The index of the data in the full list of
		 *    rows (after filtering)
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.rowCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" ) {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
    "fnRowCallback": null,

    /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * This parameter allows you to override the default function which obtains
		 * the data from the server so something more suitable for your application.
		 * For example you could use POST data, or pull information from a Gears or
		 * AIR database.
		 *  @type function
		 *  @member
		 *  @param {string} source HTTP source to obtain the data from (`ajax`)
		 *  @param {array} data A key/value pair object containing the data to send
		 *    to the server
		 *  @param {function} callback to be called on completion of the data get
		 *    process that will draw the data on the page.
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverData
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
    "fnServerData": null,

    /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 *  It is often useful to send extra data to the server when making an Ajax
		 * request - for example custom filtering information, and this callback
		 * function makes it trivial to send extra information to the server. The
		 * passed in parameter is the data set that has been constructed by
		 * DataTables, and you can add to this or modify it as you require.
		 *  @type function
		 *  @param {array} data Data array (array of objects which are name/value
		 *    pairs) that has been constructed by DataTables and will be sent to the
		 *    server. In the case of Ajax sourced data with server-side processing
		 *    this will be an empty array, for server-side processing there will be a
		 *    significant number of parameters!
		 *  @returns {undefined} Ensure that you modify the data array passed in,
		 *    as this is passed by reference.
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverParams
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
    "fnServerParams": null,

    /**
		 * Load the table state. With this function you can define from where, and how, the
		 * state of a table is loaded. By default DataTables will load from `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} callback Callback that can be executed when done. It
		 *    should be passed the loaded state object.
		 *  @return {object} The DataTables state object to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadCallback": function (settings, callback) {
		 *          $.ajax( {
		 *            "url": "/state_load",
		 *            "dataType": "json",
		 *            "success": function (json) {
		 *              callback( json );
		 *            }
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
    "fnStateLoadCallback": function ( settings ) {
      try {
        return JSON.parse(
          (settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
            "DataTables_" + settings.sInstance + "_" + location.pathname
          )
        );
      } catch (e) {}
    },

    /**
		 * Callback which allows modification of the saved state prior to loading that state.
		 * This callback is called when the table is loading state from the stored data, but
		 * prior to the settings object being modified by the saved state. Note that for
		 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
		 * a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that is to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never loaded
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Disallow state loading by returning false
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          return false;
		 *        }
		 *      } );
		 *    } );
		 */
    "fnStateLoadParams": null,

    /**
		 * Callback that is called when the state has been loaded from the state saving method
		 * and the DataTables settings object has been modified as a result of the loaded state.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that was loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoaded
		 *
		 *  @example
		 *    // Show an alert with the filtering value that was saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoaded": function (settings, data) {
		 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
		 *        }
		 *      } );
		 *    } );
		 */
    "fnStateLoaded": null,

    /**
		 * Save the table state. This function allows you to define where and how the state
		 * information for the table is stored By default DataTables will use `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveCallback": function (settings, data) {
		 *          // Send an Ajax request to the server with the state object
		 *          $.ajax( {
		 *            "url": "/state_save",
		 *            "data": data,
		 *            "dataType": "json",
		 *            "method": "POST"
		 *            "success": function () {}
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
    "fnStateSaveCallback": function ( settings, data ) {
      try {
        (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
          "DataTables_" + settings.sInstance + "_" + location.pathname,
          JSON.stringify( data )
        );
      } catch (e) {}
    },

    /**
		 * Callback which allows modification of the state to be saved. Called when the table
		 * has changed state a new state save is required. This method allows modification of
		 * the state saving object prior to actually doing the save, including addition or
		 * other state properties or modification. Note that for plug-in authors, you should
		 * use the `stateSaveParams` event to save parameters for a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 */
    "fnStateSaveParams": null,

    /**
		 * Duration for which the saved state information is considered valid. After this period
		 * has elapsed the state will be returned to the default.
		 * Value is given in seconds.
		 *  @type int
		 *  @default 7200 <i>(2 hours)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.stateDuration
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateDuration": 60*60*24; // 1 day
		 *      } );
		 *    } )
		 */
    "iStateDuration": 7200,

    /**
		 * When enabled DataTables will not make a request to the server for the first
		 * page draw - rather it will use the data already on the page (no sorting etc
		 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
		 * is used to indicate that deferred loading is required, but it is also used
		 * to tell DataTables how many records there are in the full table (allowing
		 * the information element and pagination to be displayed correctly). In the case
		 * where a filtering is applied to the table on initial load, this can be
		 * indicated by giving the parameter as an array, where the first element is
		 * the number of records available after filtering and the second element is the
		 * number of records without filtering (allowing the table information element
		 * to be shown correctly).
		 *  @type int | array
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.deferLoading
		 *
		 *  @example
		 *    // 57 records available in the table, no filtering applied
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": 57
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": [ 57, 100 ],
		 *        "search": {
		 *          "search": "my_filter"
		 *        }
		 *      } );
		 *    } );
		 */
    "iDeferLoading": null,

    /**
		 * Number of rows to display on a single page when using pagination. If
		 * feature enabled (`lengthChange`) then the end user will be able to override
		 * this to a custom setting using a pop-up menu.
		 *  @type int
		 *  @default 10
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pageLength
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pageLength": 50
		 *      } );
		 *    } )
		 */
    "iDisplayLength": 10,

    /**
		 * Define the starting point for data display when using DataTables with
		 * pagination. Note that this parameter is the number of records, rather than
		 * the page number, so if you have 10 records per page and want to start on
		 * the third page, it should be "20".
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.displayStart
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "displayStart": 20
		 *      } );
		 *    } )
		 */
    "iDisplayStart": 0,

    /**
		 * By default DataTables allows keyboard navigation of the table (sorting, paging,
		 * and filtering) by adding a `tabindex` attribute to the required elements. This
		 * allows you to tab through the controls and press the enter key to activate them.
		 * The tabindex is default 0, meaning that the tab follows the flow of the document.
		 * You can overrule this using this parameter if you wish. Use a value of -1 to
		 * disable built-in keyboard navigation.
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.tabIndex
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "tabIndex": 1
		 *      } );
		 *    } );
		 */
    "iTabIndex": 0,

    /**
		 * Classes that DataTables assigns to the various components and features
		 * that it adds to the HTML table. This allows classes to be configured
		 * during initialisation in addition to through the static
		 * {@link DataTable.ext.oStdClasses} object).
		 *  @namespace
		 *  @name DataTable.defaults.classes
		 */
    "oClasses": {},

    /**
		 * All strings that DataTables uses in the user interface that it creates
		 * are defined in this object, allowing you to modified them individually or
		 * completely replace them all as required.
		 *  @namespace
		 *  @name DataTable.defaults.language
		 */
    "oLanguage": {
      /**
			 * Strings that are used for WAI-ARIA labels and controls only (these are not
			 * actually visible on the page, but will be read by screenreaders, and thus
			 * must be internationalised as well).
			 *  @namespace
			 *  @name DataTable.defaults.language.aria
			 */
      "oAria": {
        /**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted ascending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortAscending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortAscending": " - click/return to sort ascending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
        "sSortAscending": ": activate to sort column ascending",

        /**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted descending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortDescending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortDescending": " - click/return to sort descending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
        "sSortDescending": ": activate to sort column descending"
      },

      /**
			 * Pagination string used by DataTables for the built-in pagination
			 * control types.
			 *  @namespace
			 *  @name DataTable.defaults.language.paginate
			 */
      "oPaginate": {
        /**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the first page.
				 *  @type string
				 *  @default First
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.first
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "first": "First page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
        "sFirst": "First",

        /**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the last page.
				 *  @type string
				 *  @default Last
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.last
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "last": "Last page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
        "sLast": "Last",

        /**
				 * Text to use for the 'next' pagination button (to take the user to the
				 * next page).
				 *  @type string
				 *  @default Next
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.next
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "next": "Next page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
        "sNext": "Next",

        /**
				 * Text to use for the 'previous' pagination button (to take the user to
				 * the previous page).
				 *  @type string
				 *  @default Previous
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.previous
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "previous": "Previous page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
        "sPrevious": "Previous"
      },

      /**
			 * This string is shown in preference to `zeroRecords` when the table is
			 * empty of data (regardless of filtering). Note that this is an optional
			 * parameter - if it is not given, the value of `zeroRecords` will be used
			 * instead (either the default or given value).
			 *  @type string
			 *  @default No data available in table
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.emptyTable
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "emptyTable": "No data available in table"
			 *        }
			 *      } );
			 *    } );
			 */
      "sEmptyTable": "No data available in table",

      /**
			 * This string gives information to the end user about the information
			 * that is current on display on the page. The following tokens can be
			 * used in the string and will be dynamically replaced as the table
			 * display updates. This tokens can be placed anywhere in the string, or
			 * removed as needed by the language requires:
			 *
			 * * `\_START\_` - Display index of the first record on the current page
			 * * `\_END\_` - Display index of the last record on the current page
			 * * `\_TOTAL\_` - Number of records in the table after filtering
			 * * `\_MAX\_` - Number of records in the table without filtering
			 * * `\_PAGE\_` - Current page number
			 * * `\_PAGES\_` - Total number of pages of data in the table
			 *
			 *  @type string
			 *  @default Showing _START_ to _END_ of _TOTAL_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.info
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "info": "Showing page _PAGE_ of _PAGES_"
			 *        }
			 *      } );
			 *    } );
			 */
      "sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",

      /**
			 * Display information string for when the table is empty. Typically the
			 * format of this string should match `info`.
			 *  @type string
			 *  @default Showing 0 to 0 of 0 entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoEmpty
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoEmpty": "No entries to show"
			 *        }
			 *      } );
			 *    } );
			 */
      "sInfoEmpty": "Showing 0 to 0 of 0 entries",

      /**
			 * When a user filters the information in a table, this string is appended
			 * to the information (`info`) to give an idea of how strong the filtering
			 * is. The variable _MAX_ is dynamically updated.
			 *  @type string
			 *  @default (filtered from _MAX_ total entries)
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoFiltered
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoFiltered": " - filtering from _MAX_ records"
			 *        }
			 *      } );
			 *    } );
			 */
      "sInfoFiltered": "(filtered from _MAX_ total entries)",

      /**
			 * If can be useful to append extra information to the info string at times,
			 * and this variable does exactly that. This information will be appended to
			 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
			 * being used) at all times.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoPostFix
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoPostFix": "All records shown are derived from real information."
			 *        }
			 *      } );
			 *    } );
			 */
      "sInfoPostFix": "",

      /**
			 * This decimal place operator is a little different from the other
			 * language options since DataTables doesn't output floating point
			 * numbers, so it won't ever use this for display of a number. Rather,
			 * what this parameter does is modify the sort methods of the table so
			 * that numbers which are in a format which has a character other than
			 * a period (`.`) as a decimal place will be sorted numerically.
			 *
			 * Note that numbers with different decimal places cannot be shown in
			 * the same table and still be sortable, the table must be consistent.
			 * However, multiple different tables on the page can use different
			 * decimal place characters.
			 *  @type string
			 *  @default
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.decimal
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "decimal": ","
			 *          "thousands": "."
			 *        }
			 *      } );
			 *    } );
			 */
      "sDecimal": "",

      /**
			 * DataTables has a build in number formatter (`formatNumber`) which is
			 * used to format large numbers that are used in the table information.
			 * By default a comma is used, but this can be trivially changed to any
			 * character you wish with this parameter.
			 *  @type string
			 *  @default ,
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.thousands
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "thousands": "'"
			 *        }
			 *      } );
			 *    } );
			 */
      "sThousands": ",",

      /**
			 * Detail the action that will be taken when the drop down menu for the
			 * pagination length option is changed. The '_MENU_' variable is replaced
			 * with a default select list of 10, 25, 50 and 100, and can be replaced
			 * with a custom select box if required.
			 *  @type string
			 *  @default Show _MENU_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.lengthMenu
			 *
			 *  @example
			 *    // Language change only
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": "Display _MENU_ records"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Language and options change
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": 'Display <select>'+
			 *            '<option value="10">10</option>'+
			 *            '<option value="20">20</option>'+
			 *            '<option value="30">30</option>'+
			 *            '<option value="40">40</option>'+
			 *            '<option value="50">50</option>'+
			 *            '<option value="-1">All</option>'+
			 *            '</select> records'
			 *        }
			 *      } );
			 *    } );
			 */
      "sLengthMenu": "Show _MENU_ entries",

      /**
			 * When using Ajax sourced data and during the first draw when DataTables is
			 * gathering the data, this message is shown in an empty row in the table to
			 * indicate to the end user the the data is being loaded. Note that this
			 * parameter is not used when loading data by server-side processing, just
			 * Ajax sourced data with client-side processing.
			 *  @type string
			 *  @default Loading...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.loadingRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "loadingRecords": "Please wait - loading..."
			 *        }
			 *      } );
			 *    } );
			 */
      "sLoadingRecords": "Loading...",

      /**
			 * Text which is displayed when the table is processing a user action
			 * (usually a sort command or similar).
			 *  @type string
			 *  @default Processing...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.processing
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "processing": "DataTables is currently busy"
			 *        }
			 *      } );
			 *    } );
			 */
      "sProcessing": "Processing...",

      /**
			 * Details the actions that will be taken when the user types into the
			 * filtering input text box. The variable "_INPUT_", if used in the string,
			 * is replaced with the HTML text box for the filtering input allowing
			 * control over where it appears in the string. If "_INPUT_" is not given
			 * then the input box is appended to the string automatically.
			 *  @type string
			 *  @default Search:
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.search
			 *
			 *  @example
			 *    // Input text box will be appended at the end automatically
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Filter records:"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Specify where the filter should appear
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Apply filter _INPUT_ to table"
			 *        }
			 *      } );
			 *    } );
			 */
      "sSearch": "Search:",

      /**
			 * Assign a `placeholder` attribute to the search `input` element
			 *  @type string
			 *  @default
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.searchPlaceholder
			 */
      "sSearchPlaceholder": "",

      /**
			 * All of the language information can be stored in a file on the
			 * server-side, which DataTables will look up if this parameter is passed.
			 * It must store the URL of the language file, which is in a JSON format,
			 * and the object has the same properties as the oLanguage object in the
			 * initialiser object (i.e. the above parameters). Please refer to one of
			 * the example language files to see how this works in action.
			 *  @type string
			 *  @default <i>Empty string - i.e. disabled</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.url
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
			 *        }
			 *      } );
			 *    } );
			 */
      "sUrl": "",

      /**
			 * Text shown inside the table records when the is no information to be
			 * displayed after filtering. `emptyTable` is shown when there is simply no
			 * information in the table at all (regardless of filtering).
			 *  @type string
			 *  @default No matching records found
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.zeroRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "zeroRecords": "No records to display"
			 *        }
			 *      } );
			 *    } );
			 */
      "sZeroRecords": "No matching records found"
    },

    /**
		 * This parameter allows you to have define the global filtering state at
		 * initialisation time. As an object the `search` parameter must be
		 * defined, but all other parameters are optional. When `regex` is true,
		 * the search string will be treated as a regular expression, when false
		 * (default) it will be treated as a straight string. When `smart`
		 * DataTables will use it's smart filtering methods (to word match at
		 * any point in the data), when false this will not be done.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.search
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "search": {"search": "Initial search"}
		 *      } );
		 *    } )
		 */
    "oSearch": $.extend( {}, DataTable.models.oSearch ),

    /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * By default DataTables will look for the property `data` (or `aaData` for
		 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
		 * source or for server-side processing - this parameter allows that
		 * property to be changed. You can use Javascript dotted object notation to
		 * get a data source for multiple levels of nesting.
		 *  @type string
		 *  @default data
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxDataProp
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
    "sAjaxDataProp": "data",

    /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * You can instruct DataTables to load data from an external
		 * source using this parameter (use aData if you want to pass data in you
		 * already have). Simply provide a url a JSON object can be obtained from.
		 *  @type string
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxSource
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
    "sAjaxSource": null,

    /**
		 * This initialisation variable allows you to specify exactly where in the
		 * DOM you want DataTables to inject the various controls it adds to the page
		 * (for example you might want the pagination controls at the top of the
		 * table). DIV elements (with or without a custom class) can also be added to
		 * aid styling. The follow syntax is used:
		 *   <ul>
		 *     <li>The following options are allowed:
		 *       <ul>
		 *         <li>'l' - Length changing</li>
		 *         <li>'f' - Filtering input</li>
		 *         <li>'t' - The table!</li>
		 *         <li>'i' - Information</li>
		 *         <li>'p' - Pagination</li>
		 *         <li>'r' - pRocessing</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following constants are allowed:
		 *       <ul>
		 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
		 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following syntax is expected:
		 *       <ul>
		 *         <li>'&lt;' and '&gt;' - div elements</li>
		 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
		 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
		 *       </ul>
		 *     </li>
		 *     <li>Examples:
		 *       <ul>
		 *         <li>'&lt;"wrapper"flipt&gt;'</li>
		 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
		 *       </ul>
		 *     </li>
		 *   </ul>
		 *  @type string
		 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
		 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.dom
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
		 *      } );
		 *    } );
		 */
    "sDom": "lfrtip",

    /**
		 * Search delay option. This will throttle full table searches that use the
		 * DataTables provided search input element (it does not effect calls to
		 * `dt-api search()`, providing a delay before the search is made.
		 *  @type integer
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.searchDelay
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchDelay": 200
		 *      } );
		 *    } )
		 */
    "searchDelay": null,

    /**
		 * DataTables features six different built-in options for the buttons to
		 * display for pagination control:
		 *
		 * * `numbers` - Page number buttons only
		 * * `simple` - 'Previous' and 'Next' buttons only
		 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
		 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
		 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
		 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
		 *
		 * Further methods can be added using {@link DataTable.ext.oPagination}.
		 *  @type string
		 *  @default simple_numbers
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pagingType
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pagingType": "full_numbers"
		 *      } );
		 *    } )
		 */
    "sPaginationType": "simple_numbers",

    /**
		 * Enable horizontal scrolling. When a table is too wide to fit into a
		 * certain layout, or you have a large number of columns in the table, you
		 * can enable x-scrolling to show the table in a viewport, which can be
		 * scrolled. This property can be `true` which will allow the table to
		 * scroll horizontally when needed, or any CSS unit, or a number (in which
		 * case it will be treated as a pixel measurement). Setting as simply `true`
		 * is recommended.
		 *  @type boolean|string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollX
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": true,
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
    "sScrollX": "",

    /**
		 * This property can be used to force a DataTable to use more width than it
		 * might otherwise do when x-scrolling is enabled. For example if you have a
		 * table which requires to be well spaced, this parameter is useful for
		 * "over-sizing" the table, and thus forcing scrolling. This property can by
		 * any CSS unit, or a number (in which case it will be treated as a pixel
		 * measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollXInner
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": "100%",
		 *        "scrollXInner": "110%"
		 *      } );
		 *    } );
		 */
    "sScrollXInner": "",

    /**
		 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
		 * to the given height, and enable scrolling for any data which overflows the
		 * current viewport. This can be used as an alternative to paging to display
		 * a lot of data in a small area (although paging and scrolling can both be
		 * enabled at the same time). This property can be any CSS unit, or a number
		 * (in which case it will be treated as a pixel measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollY
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false
		 *      } );
		 *    } );
		 */
    "sScrollY": "",

    /**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * Set the HTTP method that is used to make the Ajax call for server-side
		 * processing or Ajax sourced data.
		 *  @type string
		 *  @default GET
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverMethod
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
    "sServerMethod": "GET",

    /**
		 * DataTables makes use of renderers when displaying HTML elements for
		 * a table. These renderers can be added or modified by plug-ins to
		 * generate suitable mark-up for a site. For example the Bootstrap
		 * integration plug-in for DataTables uses a paging button renderer to
		 * display pagination buttons in the mark-up required by Bootstrap.
		 *
		 * For further information about the renderers available see
		 * DataTable.ext.renderer
		 *  @type string|object
		 *  @default null
		 *
		 *  @name DataTable.defaults.renderer
		 *
		 */
    "renderer": null,

    /**
		 * Set the data property name that DataTables should use to get a row's id
		 * to set as the `id` property in the node.
		 *  @type string
		 *  @default DT_RowId
		 *
		 *  @name DataTable.defaults.rowId
		 */
    "rowId": "DT_RowId"
  };

  _fnHungarianMap( DataTable.defaults );

  /*
	 * Developer note - See note in model.defaults.js about the use of Hungarian
	 * notation and camel case.
	 */

  /**
	 * Column options that can be given to DataTables at initialisation time.
	 *  @namespace
	 */
  DataTable.defaults.column = {
    /**
		 * Define which column(s) an order will occur on for this column. This
		 * allows a column's ordering to take multiple columns into account when
		 * doing a sort or use the data from a different column. For example first
		 * name / last name columns make sense to do a multi-column sort over the
		 * two columns.
		 *  @type array|int
		 *  @default null <i>Takes the value of the column index automatically</i>
		 *
		 *  @name DataTable.defaults.column.orderData
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
		 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
		 *          { "orderData": 2, "targets": [ 2 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderData": [ 0, 1 ] },
		 *          { "orderData": [ 1, 0 ] },
		 *          { "orderData": 2 },
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
    "aDataSort": null,
    "iDataSort": -1,

    /**
		 * You can control the default ordering direction, and even alter the
		 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
		 * using this parameter.
		 *  @type array
		 *  @default [ 'asc', 'desc' ]
		 *
		 *  @name DataTable.defaults.column.orderSequence
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
		 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          { "orderSequence": [ "asc" ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ] },
		 *          { "orderSequence": [ "desc" ] },
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
    "asSorting": [ "asc", "desc" ],

    /**
		 * Enable or disable filtering on the data in this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.searchable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "searchable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "searchable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
    "bSearchable": true,

    /**
		 * Enable or disable ordering on this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.orderable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
    "bSortable": true,

    /**
		 * Enable or disable the display of this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.visible
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "visible": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "visible": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
    "bVisible": true,

    /**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} td The TD node that has been created
		 *  @param {*} cellData The Data for the cell
		 *  @param {array|object} rowData The data for the whole row
		 *  @param {int} row The row index for the aoData data store
		 *  @param {int} col The column index for aoColumns
		 *
		 *  @name DataTable.defaults.column.createdCell
		 *  @dtopt Columns
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [3],
		 *          "createdCell": function (td, cellData, rowData, row, col) {
		 *            if ( cellData == "1.7" ) {
		 *              $(td).css('color', 'blue')
		 *            }
		 *          }
		 *        } ]
		 *      });
		 *    } );
		 */
    "fnCreatedCell": null,

    /**
		 * This parameter has been replaced by `data` in DataTables to ensure naming
		 * consistency. `dataProp` can still be used, as there is backwards
		 * compatibility in DataTables for this option, but it is strongly
		 * recommended that you use `data` in preference to `dataProp`.
		 *  @name DataTable.defaults.column.dataProp
		 */

    /**
		 * This property can be used to read data from any data source property,
		 * including deeply nested objects / properties. `data` can be given in a
		 * number of different ways which effect its behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object. Note that
		 *      function notation is recommended for use in `render` rather than
		 *      `data` as it is much simpler to use as a renderer.
		 * * `null` - use the original data source for the row rather than plucking
		 *   data directly from it. This action has effects on two other
		 *   initialisation options:
		 *    * `defaultContent` - When null is given as the `data` option and
		 *      `defaultContent` is specified for the column, the value defined by
		 *      `defaultContent` will be used for the cell.
		 *    * `render` - When null is used for the `data` option and the `render`
		 *      option is specified for the column, the whole data source for the
		 *      row is used for the renderer.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * `{array|object}` The data source for the row
		 *      * `{string}` The type call data requested - this will be 'set' when
		 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
		 *        when gathering data. Note that when `undefined` is given for the
		 *        type DataTables expects to get the raw data for the object back<
		 *      * `{*}` Data to set when the second parameter is 'set'.
		 *    * Return:
		 *      * The return value from the function is not required when 'set' is
		 *        the type of call, but otherwise the return is what will be used
		 *        for the data requested.
		 *
		 * Note that `data` is a getter and setter option. If you just require
		 * formatting of data for output, you will likely want to use `render` which
		 * is simply a getter and thus simpler to use.
		 *
		 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
		 * name change reflects the flexibility of this property and is consistent
		 * with the naming of mRender. If 'mDataProp' is given, then it will still
		 * be used by DataTables, as it automatically maps the old name to the new
		 * if required.
		 *
		 *  @type string|int|function|null
		 *  @default null <i>Use automatically calculated column index</i>
		 *
		 *  @name DataTable.defaults.column.data
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Read table data from objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {value},
		 *    //      "version": {value},
		 *    //      "grade": {value}
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/objects.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform" },
		 *          { "data": "version" },
		 *          { "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Read information from deeply nested objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {
		 *    //         "inner": {value}
		 *    //      },
		 *    //      "details": [
		 *    //         {value}, {value}
		 *    //      ]
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform.inner" },
		 *          { "data": "platform.details.0" },
		 *          { "data": "platform.details.1" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `data` as a function to provide different information for
		 *    // sorting, filtering and display. In this case, currency (price)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": function ( source, type, val ) {
		 *            if (type === 'set') {
		 *              source.price = val;
		 *              // Store the computed dislay and filter values for efficiency
		 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
		 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
		 *              return;
		 *            }
		 *            else if (type === 'display') {
		 *              return source.price_display;
		 *            }
		 *            else if (type === 'filter') {
		 *              return source.price_filter;
		 *            }
		 *            // 'sort', 'type' and undefined all just use the integer
		 *            return source.price;
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using default content
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null,
		 *          "defaultContent": "Click to edit"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using array notation - outputting a list from an array
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "name[, ]"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 */
    "mData": null,

    /**
		 * This property is the rendering partner to `data` and it is suggested that
		 * when you want to manipulate data for display (including filtering,
		 * sorting etc) without altering the underlying data for the table, use this
		 * property. `render` can be considered to be the the read only companion to
		 * `data` which is read / write (then as such more complex). Like `data`
		 * this option can be given in a number of different ways to effect its
		 * behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object.
		 * * `object` - use different data for the different data types requested by
		 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
		 *   of the object is the data type the property refers to and the value can
		 *   defined using an integer, string or function using the same rules as
		 *   `render` normally does. Note that an `_` option _must_ be specified.
		 *   This is the default value to use if you haven't specified a value for
		 *   the data type requested by DataTables.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * {array|object} The data source for the row (based on `data`)
		 *      * {string} The type call data requested - this will be 'filter',
		 *        'display', 'type' or 'sort'.
		 *      * {array|object} The full data source for the row (not based on
		 *        `data`)
		 *    * Return:
		 *      * The return value from the function is what will be used for the
		 *        data requested.
		 *
		 *  @type string|int|function|object|null
		 *  @default null Use the data source value.
		 *
		 *  @name DataTable.defaults.column.render
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Create a comma separated list from an array of objects
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          {
		 *            "data": "platform",
		 *            "render": "[, ].name"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Execute a function to obtain data
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": "browserName()"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // As an object, extracting different data for the different types
		 *    // This would be used with a data source such as:
		 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
		 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
		 *    // (which has both forms) is used for filtering for if a user inputs either format, while
		 *    // the formatted phone number is the one that is shown in the table.
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": {
		 *            "_": "phone",
		 *            "filter": "phone_filter",
		 *            "display": "phone_display"
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Use as a function to create a link from the data source
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "download_link",
		 *          "render": function ( data, type, full ) {
		 *            return '<a href="'+data+'">Download</a>';
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 */
    "mRender": null,

    /**
		 * Change the cell type created for the column - either TD cells or TH cells. This
		 * can be useful as TH cells have semantic meaning in the table body, allowing them
		 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
		 *  @type string
		 *  @default td
		 *
		 *  @name DataTable.defaults.column.cellType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Make the first column use TH cells
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "cellType": "th"
		 *        } ]
		 *      } );
		 *    } );
		 */
    "sCellType": "td",

    /**
		 * Class to give to each cell in this column.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.class
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "class": "my_class", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "class": "my_class" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
    "sClass": "",

    /**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 * Generally you shouldn't need this!
		 *  @type string
		 *  @default <i>Empty string<i>
		 *
		 *  @name DataTable.defaults.column.contentPadding
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "contentPadding": "mmm"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
    "sContentPadding": "",

    /**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because `data`
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 *
		 *  @name DataTable.defaults.column.defaultContent
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit",
		 *            "targets": [ -1 ]
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
    "sDefaultContent": null,

    /**
		 * This parameter is only used in DataTables' server-side processing. It can
		 * be exceptionally useful to know what columns are being displayed on the
		 * client side, and to map these to database fields. When defined, the names
		 * also allow DataTables to reorder information from the server if it comes
		 * back in an unexpected order (i.e. if you switch your columns around on the
		 * client-side, your server-side code does not also need updating).
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.name
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "name": "engine", "targets": [ 0 ] },
		 *          { "name": "browser", "targets": [ 1 ] },
		 *          { "name": "platform", "targets": [ 2 ] },
		 *          { "name": "version", "targets": [ 3 ] },
		 *          { "name": "grade", "targets": [ 4 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "name": "engine" },
		 *          { "name": "browser" },
		 *          { "name": "platform" },
		 *          { "name": "version" },
		 *          { "name": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
    "sName": "",

    /**
		 * Defines a data source type for the ordering which can be used to read
		 * real-time information from the table (updating the internally cached
		 * version) prior to ordering. This allows ordering to occur on user
		 * editable elements such as form inputs.
		 *  @type string
		 *  @default std
		 *
		 *  @name DataTable.defaults.column.orderDataType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
		 *          { "type": "numeric", "targets": [ 3 ] },
		 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
		 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          { "orderDataType": "dom-text" },
		 *          { "orderDataType": "dom-text", "type": "numeric" },
		 *          { "orderDataType": "dom-select" },
		 *          { "orderDataType": "dom-checkbox" }
		 *        ]
		 *      } );
		 *    } );
		 */
    "sSortDataType": "std",

    /**
		 * The title of this column.
		 *  @type string
		 *  @default null <i>Derived from the 'TH' value for this column in the
		 *    original HTML table.</i>
		 *
		 *  @name DataTable.defaults.column.title
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "title": "My column title", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "title": "My column title" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
    "sTitle": null,

    /**
		 * The type allows you to specify how the data for this column will be
		 * ordered. Four types (string, numeric, date and html (which will strip
		 * HTML tags before ordering)) are currently available. Note that only date
		 * formats understood by Javascript's Date() object will be accepted as type
		 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
		 * 'numeric', 'date' or 'html' (by default). Further types can be adding
		 * through plug-ins.
		 *  @type string
		 *  @default null <i>Auto-detected from raw data</i>
		 *
		 *  @name DataTable.defaults.column.type
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "type": "html", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "type": "html" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
    "sType": null,

    /**
		 * Defining the width of the column, this parameter may take any CSS value
		 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
		 * been given a specific width through this interface ensuring that the table
		 * remains readable.
		 *  @type string
		 *  @default null <i>Automatic</i>
		 *
		 *  @name DataTable.defaults.column.width
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "width": "20%", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "width": "20%" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
    "sWidth": null
  };

  _fnHungarianMap( DataTable.defaults.column );

  /**
	 * DataTables settings object - this holds all the information needed for a
	 * given table, including configuration, data and current application of the
	 * table options. DataTables does not have a single instance for each DataTable
	 * with the settings attached to that instance, but rather instances of the
	 * DataTable "class" are created on-the-fly as needed (typically by a
	 * $().dataTable() call) and the settings object is then applied to that
	 * instance.
	 *
	 * Note that this object is related to {@link DataTable.defaults} but this
	 * one is the internal data store for DataTables's cache of columns. It should
	 * NOT be manipulated outside of DataTables. Any configuration should be done
	 * through the initialisation options.
	 *  @namespace
	 *  @todo Really should attach the settings object to individual instances so we
	 *    don't need to create new instances on each $().dataTable() call (if the
	 *    table already exists). It would also save passing oSettings around and
	 *    into every single function. However, this is a very significant
	 *    architecture change for DataTables and will almost certainly break
	 *    backwards compatibility with older installations. This is something that
	 *    will be done in 2.0.
	 */
  DataTable.models.oSettings = {
    /**
		 * Primary features of DataTables and their enablement state.
		 *  @namespace
		 */
    "oFeatures": {

      /**
			 * Flag to say if DataTables should automatically try to calculate the
			 * optimum table and columns widths (true) or not (false).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bAutoWidth": null,

      /**
			 * Delay the creation of TR and TD elements until they are actually
			 * needed by a driven page draw. This can give a significant speed
			 * increase for Ajax source and Javascript source data, but makes no
			 * difference at all fro DOM and server-side processing tables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bDeferRender": null,

      /**
			 * Enable filtering on the table or not. Note that if this is disabled
			 * then there is no filtering at all on the table, including fnFilter.
			 * To just remove the filtering input use sDom and remove the 'f' option.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bFilter": null,

      /**
			 * Table information element (the 'Showing x of y records' div) enable
			 * flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bInfo": null,

      /**
			 * Present a user control allowing the end user to change the page size
			 * when pagination is enabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bLengthChange": null,

      /**
			 * Pagination enabled or not. Note that if this is disabled then length
			 * changing must also be disabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bPaginate": null,

      /**
			 * Processing indicator enable flag whenever DataTables is enacting a
			 * user request - typically an Ajax request for server-side processing.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bProcessing": null,

      /**
			 * Server-side processing enabled flag - when enabled DataTables will
			 * get all data from the server for every draw - there is no filtering,
			 * sorting or paging done on the client-side.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bServerSide": null,

      /**
			 * Sorting enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bSort": null,

      /**
			 * Multi-column sorting
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bSortMulti": null,

      /**
			 * Apply a class to the columns which are being sorted to provide a
			 * visual highlight or not. This can slow things down when enabled since
			 * there is a lot of DOM interaction.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bSortClasses": null,

      /**
			 * State saving enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bStateSave": null
    },

    /**
		 * Scrolling settings for a table.
		 *  @namespace
		 */
    "oScroll": {
      /**
			 * When the table is shorter in height than sScrollY, collapse the
			 * table container down to the height of the table (when true).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
      "bCollapse": null,

      /**
			 * Width of the scrollbar for the web-browser's platform. Calculated
			 * during table initialisation.
			 *  @type int
			 *  @default 0
			 */
      "iBarWidth": 0,

      /**
			 * Viewport width for horizontal scrolling. Horizontal scrolling is
			 * disabled if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
      "sX": null,

      /**
			 * Width to expand the table to when using x-scrolling. Typically you
			 * should not need to use this.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @deprecated
			 */
      "sXInner": null,

      /**
			 * Viewport height for vertical scrolling. Vertical scrolling is disabled
			 * if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
      "sY": null
    },

    /**
		 * Language information for the table.
		 *  @namespace
		 *  @extends DataTable.defaults.oLanguage
		 */
    "oLanguage": {
      /**
			 * Information callback function. See
			 * {@link DataTable.defaults.fnInfoCallback}
			 *  @type function
			 *  @default null
			 */
      "fnInfoCallback": null
    },

    /**
		 * Browser support parameters
		 *  @namespace
		 */
    "oBrowser": {
      /**
			 * Indicate if the browser incorrectly calculates width:100% inside a
			 * scrolling element (IE6/7)
			 *  @type boolean
			 *  @default false
			 */
      "bScrollOversize": false,

      /**
			 * Determine if the vertical scrollbar is on the right or left of the
			 * scrolling container - needed for rtl language layout, although not
			 * all browsers move the scrollbar (Safari).
			 *  @type boolean
			 *  @default false
			 */
      "bScrollbarLeft": false,

      /**
			 * Flag for if `getBoundingClientRect` is fully supported or not
			 *  @type boolean
			 *  @default false
			 */
      "bBounding": false,

      /**
			 * Browser scrollbar width
			 *  @type integer
			 *  @default 0
			 */
      "barWidth": 0
    },

    "ajax": null,

    /**
		 * Array referencing the nodes which are used for the features. The
		 * parameters of this object match what is allowed by sDom - i.e.
		 *   <ul>
		 *     <li>'l' - Length changing</li>
		 *     <li>'f' - Filtering input</li>
		 *     <li>'t' - The table!</li>
		 *     <li>'i' - Information</li>
		 *     <li>'p' - Pagination</li>
		 *     <li>'r' - pRocessing</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
    "aanFeatures": [],

    /**
		 * Store data information - see {@link DataTable.models.oRow} for detailed
		 * information.
		 *  @type array
		 *  @default []
		 */
    "aoData": [],

    /**
		 * Array of indexes which are in the current display (after filtering etc)
		 *  @type array
		 *  @default []
		 */
    "aiDisplay": [],

    /**
		 * Array of indexes for display - no filtering
		 *  @type array
		 *  @default []
		 */
    "aiDisplayMaster": [],

    /**
		 * Map of row ids to data indexes
		 *  @type object
		 *  @default {}
		 */
    "aIds": {},

    /**
		 * Store information about each column that is in use
		 *  @type array
		 *  @default []
		 */
    "aoColumns": [],

    /**
		 * Store information about the table's header
		 *  @type array
		 *  @default []
		 */
    "aoHeader": [],

    /**
		 * Store information about the table's footer
		 *  @type array
		 *  @default []
		 */
    "aoFooter": [],

    /**
		 * Store the applied global search information in case we want to force a
		 * research or compare the old search to a new one.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 */
    "oPreviousSearch": {},

    /**
		 * Store the applied search for each column - see
		 * {@link DataTable.models.oSearch} for the format that is used for the
		 * filtering information for each column.
		 *  @type array
		 *  @default []
		 */
    "aoPreSearchCols": [],

    /**
		 * Sorting that is applied to the table. Note that the inner arrays are
		 * used in the following manner:
		 * <ul>
		 *   <li>Index 0 - column number</li>
		 *   <li>Index 1 - current sorting direction</li>
		 * </ul>
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @todo These inner arrays should really be objects
		 */
    "aaSorting": null,

    /**
		 * Sorting that is always applied to the table (i.e. prefixed in front of
		 * aaSorting).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
    "aaSortingFixed": [],

    /**
		 * Classes to use for the striping of a table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
    "asStripeClasses": null,

    /**
		 * If restoring a table - we should restore its striping classes as well
		 *  @type array
		 *  @default []
		 */
    "asDestroyStripes": [],

    /**
		 * If restoring a table - we should restore its width
		 *  @type int
		 *  @default 0
		 */
    "sDestroyWidth": 0,

    /**
		 * Callback functions array for every time a row is inserted (i.e. on a draw).
		 *  @type array
		 *  @default []
		 */
    "aoRowCallback": [],

    /**
		 * Callback functions for the header on each draw.
		 *  @type array
		 *  @default []
		 */
    "aoHeaderCallback": [],

    /**
		 * Callback function for the footer on each draw.
		 *  @type array
		 *  @default []
		 */
    "aoFooterCallback": [],

    /**
		 * Array of callback functions for draw callback functions
		 *  @type array
		 *  @default []
		 */
    "aoDrawCallback": [],

    /**
		 * Array of callback functions for row created function
		 *  @type array
		 *  @default []
		 */
    "aoRowCreatedCallback": [],

    /**
		 * Callback functions for just before the table is redrawn. A return of
		 * false will be used to cancel the draw.
		 *  @type array
		 *  @default []
		 */
    "aoPreDrawCallback": [],

    /**
		 * Callback functions for when the table has been initialised.
		 *  @type array
		 *  @default []
		 */
    "aoInitComplete": [],

    /**
		 * Callbacks for modifying the settings to be stored for state saving, prior to
		 * saving state.
		 *  @type array
		 *  @default []
		 */
    "aoStateSaveParams": [],

    /**
		 * Callbacks for modifying the settings that have been stored for state saving
		 * prior to using the stored values to restore the state.
		 *  @type array
		 *  @default []
		 */
    "aoStateLoadParams": [],

    /**
		 * Callbacks for operating on the settings object once the saved state has been
		 * loaded
		 *  @type array
		 *  @default []
		 */
    "aoStateLoaded": [],

    /**
		 * Cache the table ID for quick access
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
    "sTableId": "",

    /**
		 * The TABLE node for the main table
		 *  @type node
		 *  @default null
		 */
    "nTable": null,

    /**
		 * Permanent ref to the thead element
		 *  @type node
		 *  @default null
		 */
    "nTHead": null,

    /**
		 * Permanent ref to the tfoot element - if it exists
		 *  @type node
		 *  @default null
		 */
    "nTFoot": null,

    /**
		 * Permanent ref to the tbody element
		 *  @type node
		 *  @default null
		 */
    "nTBody": null,

    /**
		 * Cache the wrapper node (contains all DataTables controlled elements)
		 *  @type node
		 *  @default null
		 */
    "nTableWrapper": null,

    /**
		 * Indicate if when using server-side processing the loading of data
		 * should be deferred until the second draw.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 *  @default false
		 */
    "bDeferLoading": false,

    /**
		 * Indicate if all required information has been read in
		 *  @type boolean
		 *  @default false
		 */
    "bInitialised": false,

    /**
		 * Information about open rows. Each object in the array has the parameters
		 * 'nTr' and 'nParent'
		 *  @type array
		 *  @default []
		 */
    "aoOpenRows": [],

    /**
		 * Dictate the positioning of DataTables' control elements - see
		 * {@link DataTable.model.oInit.sDom}.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
    "sDom": null,

    /**
		 * Search delay (in mS)
		 *  @type integer
		 *  @default null
		 */
    "searchDelay": null,

    /**
		 * Which type of pagination should be used.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default two_button
		 */
    "sPaginationType": "two_button",

    /**
		 * The state duration (for `stateSave`) in seconds.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type int
		 *  @default 0
		 */
    "iStateDuration": 0,

    /**
		 * Array of callback functions for state saving. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the JSON string to save that has been thus far created. Returns
		 *       a JSON string to be inserted into a json object
		 *       (i.e. '"param": [ 0, 1, 2]')</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
    "aoStateSave": [],

    /**
		 * Array of callback functions for state loading. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the object stored. May return false to cancel state loading</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
    "aoStateLoad": [],

    /**
		 * State that was saved. Useful for back reference
		 *  @type object
		 *  @default null
		 */
    "oSavedState": null,

    /**
		 * State that was loaded. Useful for back reference
		 *  @type object
		 *  @default null
		 */
    "oLoadedState": null,

    /**
		 * Source url for AJAX data for the table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
    "sAjaxSource": null,

    /**
		 * Property from a given object from which to read the table data from. This
		 * can be an empty string (when not server-side processing), in which case
		 * it is  assumed an an array is given directly.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
    "sAjaxDataProp": null,

    /**
		 * Note if draw should be blocked while getting data
		 *  @type boolean
		 *  @default true
		 */
    "bAjaxDataGet": true,

    /**
		 * The last jQuery XHR object that was used for server-side data gathering.
		 * This can be used for working with the XHR information in one of the
		 * callbacks
		 *  @type object
		 *  @default null
		 */
    "jqXHR": null,

    /**
		 * JSON returned from the server in the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
    "json": undefined,

    /**
		 * Data submitted as part of the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
    "oAjaxData": undefined,

    /**
		 * Function to get the server-side data.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
    "fnServerData": null,

    /**
		 * Functions which are called prior to sending an Ajax request so extra
		 * parameters can easily be sent to the server
		 *  @type array
		 *  @default []
		 */
    "aoServerParams": [],

    /**
		 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
		 * required).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
    "sServerMethod": null,

    /**
		 * Format numbers for display.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
    "fnFormatNumber": null,

    /**
		 * List of options that can be used for the user selectable length menu.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
    "aLengthMenu": null,

    /**
		 * Counter for the draws that the table does. Also used as a tracker for
		 * server-side processing
		 *  @type int
		 *  @default 0
		 */
    "iDraw": 0,

    /**
		 * Indicate if a redraw is being done - useful for Ajax
		 *  @type boolean
		 *  @default false
		 */
    "bDrawing": false,

    /**
		 * Draw index (iDraw) of the last error when parsing the returned data
		 *  @type int
		 *  @default -1
		 */
    "iDrawError": -1,

    /**
		 * Paging display length
		 *  @type int
		 *  @default 10
		 */
    "_iDisplayLength": 10,

    /**
		 * Paging start point - aiDisplay index
		 *  @type int
		 *  @default 0
		 */
    "_iDisplayStart": 0,

    /**
		 * Server-side processing - number of records in the result set
		 * (i.e. before filtering), Use fnRecordsTotal rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type int
		 *  @default 0
		 *  @private
		 */
    "_iRecordsTotal": 0,

    /**
		 * Server-side processing - number of records in the current display set
		 * (i.e. after filtering). Use fnRecordsDisplay rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type boolean
		 *  @default 0
		 *  @private
		 */
    "_iRecordsDisplay": 0,

    /**
		 * The classes to use for the table
		 *  @type object
		 *  @default {}
		 */
    "oClasses": {},

    /**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if filtering has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
    "bFiltered": false,

    /**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if sorting has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
    "bSorted": false,

    /**
		 * Indicate that if multiple rows are in the header and there is more than
		 * one unique cell per column, if the top one (true) or bottom one (false)
		 * should be used for sorting / title by DataTables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
    "bSortCellsTop": null,

    /**
		 * Initialisation object that is used for the table
		 *  @type object
		 *  @default null
		 */
    "oInit": null,

    /**
		 * Destroy callback functions - for plug-ins to attach themselves to the
		 * destroy so they can clean up markup and events.
		 *  @type array
		 *  @default []
		 */
    "aoDestroyCallback": [],

    /**
		 * Get the number of records in the current record set, before filtering
		 *  @type function
		 */
    "fnRecordsTotal": function ()
    {
      return _fnDataSource( this ) == "ssp" ?
        this._iRecordsTotal * 1 :
        this.aiDisplayMaster.length;
    },

    /**
		 * Get the number of records in the current record set, after filtering
		 *  @type function
		 */
    "fnRecordsDisplay": function ()
    {
      return _fnDataSource( this ) == "ssp" ?
        this._iRecordsDisplay * 1 :
        this.aiDisplay.length;
    },

    /**
		 * Get the display end point - aiDisplay index
		 *  @type function
		 */
    "fnDisplayEnd": function ()
    {
      var
        len = this._iDisplayLength,
        start = this._iDisplayStart,
        calc = start + len,
        records = this.aiDisplay.length,
        features = this.oFeatures,
        paginate = features.bPaginate;

      if ( features.bServerSide ) {
        return paginate === false || len === -1 ?
          start + records :
          Math.min( start + len, this._iRecordsDisplay );
      }
      else {
        return ! paginate || calc > records || len === -1 ?
          records :
          calc;
      }
    },

    /**
		 * The DataTables object for this table
		 *  @type object
		 *  @default null
		 */
    "oInstance": null,

    /**
		 * Unique identifier for each instance of the DataTables object. If there
		 * is an ID on the table node, then it takes that value, otherwise an
		 * incrementing internal counter is used.
		 *  @type string
		 *  @default null
		 */
    "sInstance": null,

    /**
		 * tabindex attribute value that is added to DataTables control elements, allowing
		 * keyboard navigation of the table and its controls.
		 */
    "iTabIndex": 0,

    /**
		 * DIV container for the footer scrolling table if scrolling
		 */
    "nScrollHead": null,

    /**
		 * DIV container for the footer scrolling table if scrolling
		 */
    "nScrollFoot": null,

    /**
		 * Last applied sort
		 *  @type array
		 *  @default []
		 */
    "aLastSort": [],

    /**
		 * Stored plug-in instances
		 *  @type object
		 *  @default {}
		 */
    "oPlugins": {},

    /**
		 * Function used to get a row's id from the row's data
		 *  @type function
		 *  @default null
		 */
    "rowIdFn": null,

    /**
		 * Data location where to store a row's id
		 *  @type string
		 *  @default null
		 */
    "rowId": null
  };

  /**
	 * Extension object for DataTables that is used to provide all extension
	 * options.
	 *
	 * Note that the `DataTable.ext` object is available through
	 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
	 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
	 *  @namespace
	 *  @extends DataTable.models.ext
	 */

  /**
	 * DataTables extensions
	 *
	 * This namespace acts as a collection area for plug-ins that can be used to
	 * extend DataTables capabilities. Indeed many of the build in methods
	 * use this method to provide their own capabilities (sorting methods for
	 * example).
	 *
	 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
	 * reasons
	 *
	 *  @namespace
	 */
  DataTable.ext = _ext = {
    /**
		 * Buttons. For use with the Buttons extension for DataTables. This is
		 * defined here so other extensions can define buttons regardless of load
		 * order. It is _not_ used by DataTables core.
		 *
		 *  @type object
		 *  @default {}
		 */
    buttons: {},

    /**
		 * Element class names
		 *
		 *  @type object
		 *  @default {}
		 */
    classes: {},

    /**
		 * DataTables build type (expanded by the download builder)
		 *
		 *  @type string
		 */
    builder: "-source-",

    /**
		 * Error reporting.
		 *
		 * How should DataTables report an error. Can take the value 'alert',
		 * 'throw', 'none' or a function.
		 *
		 *  @type string|function
		 *  @default alert
		 */
    errMode: "alert",

    /**
		 * Feature plug-ins.
		 *
		 * This is an array of objects which describe the feature plug-ins that are
		 * available to DataTables. These feature plug-ins are then available for
		 * use through the `dom` initialisation option.
		 *
		 * Each feature plug-in is described by an object which must have the
		 * following properties:
		 *
		 * * `fnInit` - function that is used to initialise the plug-in,
		 * * `cFeature` - a character so the feature can be enabled by the `dom`
		 *   instillation option. This is case sensitive.
		 *
		 * The `fnInit` function has the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 *
		 * And the following return is expected:
		 *
		 * * {node|null} The element which contains your feature. Note that the
		 *   return may also be void if your plug-in does not require to inject any
		 *   DOM elements into DataTables control (`dom`) - for example this might
		 *   be useful when developing a plug-in which allows table control via
		 *   keyboard entry
		 *
		 *  @type array
		 *
		 *  @example
		 *    $.fn.dataTable.ext.features.push( {
		 *      "fnInit": function( oSettings ) {
		 *        return new TableTools( { "oDTSettings": oSettings } );
		 *      },
		 *      "cFeature": "T"
		 *    } );
		 */
    feature: [],

    /**
		 * Row searching.
		 *
		 * This method of searching is complimentary to the default type based
		 * searching, and a lot more comprehensive as it allows you complete control
		 * over the searching logic. Each element in this array is a function
		 * (parameters described below) that is called for every row in the table,
		 * and your logic decides if it should be included in the searching data set
		 * or not.
		 *
		 * Searching functions have the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{array|object}` Data for the row to be processed (same as the
		 *    original format that was passed in as the data source, or an array
		 *    from a DOM data source
		 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
		 *    can be useful to retrieve the `TR` element if you need DOM interaction.
		 *
		 * And the following return is expected:
		 *
		 * * {boolean} Include the row in the searched result set (true) or not
		 *   (false)
		 *
		 * Note that as with the main search ability in DataTables, technically this
		 * is "filtering", since it is subtractive. However, for consistency in
		 * naming we call it searching here.
		 *
		 *  @type array
		 *  @default []
		 *
		 *  @example
		 *    // The following example shows custom search being applied to the
		 *    // fourth column (i.e. the data[3] index) based on two input values
		 *    // from the end-user, matching the data in a certain range.
		 *    $.fn.dataTable.ext.search.push(
		 *      function( settings, data, dataIndex ) {
		 *        var min = document.getElementById('min').value * 1;
		 *        var max = document.getElementById('max').value * 1;
		 *        var version = data[3] == "-" ? 0 : data[3]*1;
		 *
		 *        if ( min == "" && max == "" ) {
		 *          return true;
		 *        }
		 *        else if ( min == "" && version < max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && "" == max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && version < max ) {
		 *          return true;
		 *        }
		 *        return false;
		 *      }
		 *    );
		 */
    search: [],

    /**
		 * Selector extensions
		 *
		 * The `selector` option can be used to extend the options available for the
		 * selector modifier options (`selector-modifier` object data type) that
		 * each of the three built in selector types offer (row, column and cell +
		 * their plural counterparts). For example the Select extension uses this
		 * mechanism to provide an option to select only rows, columns and cells
		 * that have been marked as selected by the end user (`{selected: true}`),
		 * which can be used in conjunction with the existing built in selector
		 * options.
		 *
		 * Each property is an array to which functions can be pushed. The functions
		 * take three attributes:
		 *
		 * * Settings object for the host table
		 * * Options object (`selector-modifier` object type)
		 * * Array of selected item indexes
		 *
		 * The return is an array of the resulting item indexes after the custom
		 * selector has been applied.
		 *
		 *  @type object
		 */
    selector: {
      cell: [],
      column: [],
      row: []
    },

    /**
		 * Internal functions, exposed for used in plug-ins.
		 *
		 * Please note that you should not need to use the internal methods for
		 * anything other than a plug-in (and even then, try to avoid if possible).
		 * The internal function may change between releases.
		 *
		 *  @type object
		 *  @default {}
		 */
    internal: {},

    /**
		 * Legacy configuration options. Enable and disable legacy options that
		 * are available in DataTables.
		 *
		 *  @type object
		 */
    legacy: {
      /**
			 * Enable / disable DataTables 1.9 compatible server-side processing
			 * requests
			 *
			 *  @type boolean
			 *  @default null
			 */
      ajax: null
    },

    /**
		 * Pagination plug-in methods.
		 *
		 * Each entry in this object is a function and defines which buttons should
		 * be shown by the pagination rendering method that is used for the table:
		 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
		 * buttons are displayed in the document, while the functions here tell it
		 * what buttons to display. This is done by returning an array of button
		 * descriptions (what each button will do).
		 *
		 * Pagination types (the four built in options and any additional plug-in
		 * options defined here) can be used through the `paginationType`
		 * initialisation parameter.
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{int} page` The current page index
		 * 2. `{int} pages` The number of pages in the table
		 *
		 * Each function is expected to return an array where each element of the
		 * array can be one of:
		 *
		 * * `first` - Jump to first page when activated
		 * * `last` - Jump to last page when activated
		 * * `previous` - Show previous page when activated
		 * * `next` - Show next page when activated
		 * * `{int}` - Show page of the index given
		 * * `{array}` - A nested array containing the above elements to add a
		 *   containing 'DIV' element (might be useful for styling).
		 *
		 * Note that DataTables v1.9- used this object slightly differently whereby
		 * an object with two functions would be defined for each plug-in. That
		 * ability is still supported by DataTables 1.10+ to provide backwards
		 * compatibility, but this option of use is now decremented and no longer
		 * documented in DataTables 1.10+.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Show previous, next and current page buttons only
		 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
		 *      return [ 'previous', page, 'next' ];
		 *    };
		 */
    pager: {},

    renderer: {
      pageButton: {},
      header: {}
    },

    /**
		 * Ordering plug-ins - custom data source
		 *
		 * The extension options for ordering of data available here is complimentary
		 * to the default type based ordering that DataTables typically uses. It
		 * allows much greater control over the the data that is being used to
		 * order a column, but is necessarily therefore more complex.
		 *
		 * This type of ordering is useful if you want to do ordering based on data
		 * live from the DOM (for example the contents of an 'input' element) rather
		 * than just the static string that DataTables knows of.
		 *
		 * The way these plug-ins work is that you create an array of the values you
		 * wish to be ordering for the column in question and then return that
		 * array. The data in the array much be in the index order of the rows in
		 * the table (not the currently ordering order!). Which order data gathering
		 * function is run here depends on the `dt-init columns.orderDataType`
		 * parameter that is used for the column (if any).
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{int}` Target column index
		 *
		 * Each function is expected to return an array:
		 *
		 * * `{array}` Data for the column to be ordering upon
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Ordering using `input` node values
		 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
		 *    {
		 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
		 *        return $('input', td).val();
		 *      } );
		 *    }
		 */
    order: {},

    /**
		 * Type based plug-ins.
		 *
		 * Each column in DataTables has a type assigned to it, either by automatic
		 * detection or by direct assignment using the `type` option for the column.
		 * The type of a column will effect how it is ordering and search (plug-ins
		 * can also make use of the column type if required).
		 *
		 * @namespace
		 */
    type: {
      /**
			 * Type detection functions.
			 *
			 * The functions defined in this object are used to automatically detect
			 * a column's type, making initialisation of DataTables super easy, even
			 * when complex data is in the table.
			 *
			 * The functions defined take two parameters:
			 *
		     *  1. `{*}` Data from the column cell to be analysed
		     *  2. `{settings}` DataTables settings object. This can be used to
		     *     perform context specific type detection - for example detection
		     *     based on language settings such as using a comma for a decimal
		     *     place. Generally speaking the options from the settings will not
		     *     be required
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Data type detected, or null if unknown (and thus
			 *   pass it on to the other type detection functions.
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Currency type detection plug-in:
			 *    $.fn.dataTable.ext.type.detect.push(
			 *      function ( data, settings ) {
			 *        // Check the numeric part
			 *        if ( ! $.isNumeric( data.substring(1) ) ) {
			 *          return null;
			 *        }
			 *
			 *        // Check prefixed by currency
			 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
			 *          return 'currency';
			 *        }
			 *        return null;
			 *      }
			 *    );
			 */
      detect: [],

      /**
			 * Type based search formatting.
			 *
			 * The type based searching functions can be used to pre-format the
			 * data to be search on. For example, it can be used to strip HTML
			 * tags or to de-format telephone numbers for numeric only searching.
			 *
			 * Note that is a search is not defined for a column of a given type,
			 * no search formatting will be performed.
			 *
			 * Pre-processing of searching data plug-ins - When you assign the sType
			 * for a column (or have it automatically detected for you by DataTables
			 * or a type detection plug-in), you will typically be using this for
			 * custom sorting, but it can also be used to provide custom searching
			 * by allowing you to pre-processing the data and returning the data in
			 * the format that should be searched upon. This is done by adding
			 * functions this object with a parameter name which matches the sType
			 * for that target column. This is the corollary of <i>afnSortData</i>
			 * for searching data.
			 *
			 * The functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for searching
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Formatted string that will be used for the searching.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
			 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
			 *    }
			 */
      search: {},

      /**
			 * Type based ordering.
			 *
			 * The column type tells DataTables what ordering to apply to the table
			 * when a column is sorted upon. The order for each type that is defined,
			 * is defined by the functions available in this object.
			 *
			 * Each ordering option can be described by three properties added to
			 * this object:
			 *
			 * * `{type}-pre` - Pre-formatting function
			 * * `{type}-asc` - Ascending order function
			 * * `{type}-desc` - Descending order function
			 *
			 * All three can be used together, only `{type}-pre` or only
			 * `{type}-asc` and `{type}-desc` together. It is generally recommended
			 * that only `{type}-pre` is used, as this provides the optimal
			 * implementation in terms of speed, although the others are provided
			 * for compatibility with existing Javascript sort functions.
			 *
			 * `{type}-pre`: Functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for ordering
			 *
			 * And return:
			 *
			 * * `{*}` Data to be sorted upon
			 *
			 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
			 * functions, taking two parameters:
			 *
		     *  1. `{*}` Data to compare to the second parameter
		     *  2. `{*}` Data to compare to the first parameter
			 *
			 * And returning:
			 *
			 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
			 *   than the second parameter, ===0 if the two parameters are equal and
			 *   >0 if the first parameter should be sorted height than the second
			 *   parameter.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Numeric ordering of formatted numbers with a pre-formatter
			 *    $.extend( $.fn.dataTable.ext.type.order, {
			 *      "string-pre": function(x) {
			 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
			 *        return parseFloat( a );
			 *      }
			 *    } );
			 *
			 *  @example
			 *    // Case-sensitive string ordering, with no pre-formatting method
			 *    $.extend( $.fn.dataTable.ext.order, {
			 *      "string-case-asc": function(x,y) {
			 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			 *      },
			 *      "string-case-desc": function(x,y) {
			 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			 *      }
			 *    } );
			 */
      order: {}
    },

    /**
		 * Unique DataTables instance counter
		 *
		 * @type int
		 * @private
		 */
    _unique: 0,

    //
    // Depreciated
    // The following properties are retained for backwards compatiblity only.
    // The should not be used in new projects and will be removed in a future
    // version
    //

    /**
		 * Version check function.
		 *  @type function
		 *  @depreciated Since 1.10
		 */
    fnVersionCheck: DataTable.fnVersionCheck,

    /**
		 * Index for what 'this' index API functions should use
		 *  @type int
		 *  @deprecated Since v1.10
		 */
    iApiIndex: 0,

    /**
		 * jQuery UI class container
		 *  @type object
		 *  @deprecated Since v1.10
		 */
    oJUIClasses: {},

    /**
		 * Software version
		 *  @type string
		 *  @deprecated Since v1.10
		 */
    sVersion: DataTable.version
  };

  //
  // Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
  //
  $.extend( _ext, {
    afnFiltering: _ext.search,
    aTypes: _ext.type.detect,
    ofnSearch: _ext.type.search,
    oSort: _ext.type.order,
    afnSortData: _ext.order,
    aoFeatures: _ext.feature,
    oApi: _ext.internal,
    oStdClasses: _ext.classes,
    oPagination: _ext.pager
  } );

  $.extend( DataTable.ext.classes, {
    "sTable": "dataTable",
    "sNoFooter": "no-footer",

    /* Paging buttons */
    "sPageButton": "paginate_button",
    "sPageButtonActive": "current",
    "sPageButtonDisabled": "disabled",

    /* Striping classes */
    "sStripeOdd": "odd",
    "sStripeEven": "even",

    /* Empty row */
    "sRowEmpty": "dataTables_empty",

    /* Features */
    "sWrapper": "dataTables_wrapper",
    "sFilter": "dataTables_filter",
    "sInfo": "dataTables_info",
    "sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
    "sLength": "dataTables_length",
    "sProcessing": "dataTables_processing",

    /* Sorting */
    "sSortAsc": "sorting_asc",
    "sSortDesc": "sorting_desc",
    "sSortable": "sorting", /* Sortable in both directions */
    "sSortableAsc": "sorting_asc_disabled",
    "sSortableDesc": "sorting_desc_disabled",
    "sSortableNone": "sorting_disabled",
    "sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */

    /* Filtering */
    "sFilterInput": "",

    /* Page length */
    "sLengthSelect": "",

    /* Scrolling */
    "sScrollWrapper": "dataTables_scroll",
    "sScrollHead": "dataTables_scrollHead",
    "sScrollHeadInner": "dataTables_scrollHeadInner",
    "sScrollBody": "dataTables_scrollBody",
    "sScrollFoot": "dataTables_scrollFoot",
    "sScrollFootInner": "dataTables_scrollFootInner",

    /* Misc */
    "sHeaderTH": "",
    "sFooterTH": "",

    // Deprecated
    "sSortJUIAsc": "",
    "sSortJUIDesc": "",
    "sSortJUI": "",
    "sSortJUIAscAllowed": "",
    "sSortJUIDescAllowed": "",
    "sSortJUIWrapper": "",
    "sSortIcon": "",
    "sJUIHeader": "",
    "sJUIFooter": ""
  } );

  var extPagination = DataTable.ext.pager;

  function _numbers( page, pages ) {
    var
      numbers = [],
      buttons = extPagination.numbers_length,
      half = Math.floor( buttons / 2 ),
      i = 1;

    if ( pages <= buttons ) {
      numbers = _range( 0, pages );
    }
    else if ( page <= half ) {
      numbers = _range( 0, buttons - 2 );
      numbers.push( "ellipsis" );
      numbers.push( pages - 1 );
    }
    else if ( page >= pages - 1 - half ) {
      numbers = _range( pages - (buttons - 2), pages );
      numbers.splice( 0, 0, "ellipsis" ); // no unshift in ie6
      numbers.splice( 0, 0, 0 );
    }
    else {
      numbers = _range( page - half + 2, page + half - 1 );
      numbers.push( "ellipsis" );
      numbers.push( pages - 1 );
      numbers.splice( 0, 0, "ellipsis" );
      numbers.splice( 0, 0, 0 );
    }

    numbers.DT_el = "span";
    return numbers;
  }

  $.extend( extPagination, {
    simple: function ( page, pages ) {
      return [ "previous", "next" ];
    },

    full: function ( page, pages ) {
      return [ "first", "previous", "next", "last" ];
    },

    numbers: function ( page, pages ) {
      return [ _numbers(page, pages) ];
    },

    simple_numbers: function ( page, pages ) {
      return [ "previous", _numbers(page, pages), "next" ];
    },

    full_numbers: function ( page, pages ) {
      return [ "first", "previous", _numbers(page, pages), "next", "last" ];
    },

    first_last_numbers: function (page, pages) {
	 		return ["first", _numbers(page, pages), "last"];
	 	},

    // For testing and plug-ins to use
    _numbers: _numbers,

    // Number of number buttons (including ellipsis) to show. _Must be odd!_
    numbers_length: 7
  } );

  $.extend( true, DataTable.ext.renderer, {
    pageButton: {
      _: function ( settings, host, idx, buttons, page, pages ) {
        var classes = settings.oClasses;
        var lang = settings.oLanguage.oPaginate;
        var aria = settings.oLanguage.oAria.paginate || {};
        var btnDisplay, btnClass, counter = 0;

        var attach = function ( container, buttons ) {
          var i, ien, node, button;
          var clickHandler = function ( e ) {
            _fnPageChange( settings, e.data.action, true );
          };

          for ( i = 0, ien = buttons.length ; i < ien ; i++ ) {
            button = buttons[i];

            if ( $.isArray( button ) ) {
              var inner = $( "<" + (button.DT_el || "div") + "/>" )
                .appendTo( container );
              attach( inner, button );
            }
            else {
              btnDisplay = null;
              btnClass = "";

              switch ( button ) {
                case "ellipsis":
                  container.append("<span class=\"ellipsis\">&#x2026;</span>");
                  break;

                case "first":
                  btnDisplay = lang.sFirst;
                  btnClass = button + (page > 0 ?
                    "" : " " + classes.sPageButtonDisabled);
                  break;

                case "previous":
                  btnDisplay = lang.sPrevious;
                  btnClass = button + (page > 0 ?
                    "" : " " + classes.sPageButtonDisabled);
                  break;

                case "next":
                  btnDisplay = lang.sNext;
                  btnClass = button + (page < pages - 1 ?
                    "" : " " + classes.sPageButtonDisabled);
                  break;

                case "last":
                  btnDisplay = lang.sLast;
                  btnClass = button + (page < pages - 1 ?
                    "" : " " + classes.sPageButtonDisabled);
                  break;

                default:
                  btnDisplay = button + 1;
                  btnClass = page === button ?
                    classes.sPageButtonActive : "";
                  break;
              }

              if ( btnDisplay !== null ) {
                node = $("<a>", {
                  "class": classes.sPageButton + " " + btnClass,
                  "aria-controls": settings.sTableId,
                  "aria-label": aria[ button ],
                  "data-dt-idx": counter,
                  "tabindex": settings.iTabIndex,
                  "id": idx === 0 && typeof button === "string" ?
                    settings.sTableId + "_" + button :
                    null
                } )
                  .html( btnDisplay )
                  .appendTo( container );

                _fnBindAction(
                  node, { action: button }, clickHandler
                );

                counter++;
              }
            }
          }
        };

        // IE9 throws an 'unknown error' if document.activeElement is used
        // inside an iframe or frame. Try / catch the error. Not good for
        // accessibility, but neither are frames.
        var activeEl;

        try {
          // Because this approach is destroying and recreating the paging
          // elements, focus is lost on the select button which is bad for
          // accessibility. So we want to restore focus once the draw has
          // completed
          activeEl = $(host).find(document.activeElement).data("dt-idx");
        }
        catch (e) {}

        attach( $(host).empty(), buttons );

        if ( activeEl !== undefined ) {
          $(host).find( "[data-dt-idx=" + activeEl + "]" ).focus();
        }
      }
    }
  } );

  // Built in type detection. See model.ext.aTypes for information about
  // what is required from this methods.
  $.extend( DataTable.ext.type.detect, [
    // Plain numbers - first since V8 detects some plain numbers as dates
    // e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
    function ( d, settings )
    {
      var decimal = settings.oLanguage.sDecimal;
      return _isNumber( d, decimal ) ? "num" + decimal : null;
    },

    // Dates (only those recognised by the browser's Date.parse)
    function ( d, settings )
    {
      // V8 tries _very_ hard to make a string passed into `Date.parse()`
      // valid, so we need to use a regex to restrict date formats. Use a
      // plug-in for anything other than ISO8601 style strings
      if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
        return null;
      }
      var parsed = Date.parse(d);
      return (parsed !== null && !isNaN(parsed)) || _empty(d) ? "date" : null;
    },

    // Formatted numbers
    function ( d, settings )
    {
      var decimal = settings.oLanguage.sDecimal;
      return _isNumber( d, decimal, true ) ? "num-fmt" + decimal : null;
    },

    // HTML numeric
    function ( d, settings )
    {
      var decimal = settings.oLanguage.sDecimal;
      return _htmlNumeric( d, decimal ) ? "html-num" + decimal : null;
    },

    // HTML numeric, formatted
    function ( d, settings )
    {
      var decimal = settings.oLanguage.sDecimal;
      return _htmlNumeric( d, decimal, true ) ? "html-num-fmt" + decimal : null;
    },

    // HTML (this is strict checking - there must be html)
    function ( d, settings )
    {
      return _empty( d ) || (typeof d === "string" && d.indexOf("<") !== -1) ?
        "html" : null;
    }
  ] );

  // Filter formatting functions. See model.ext.ofnSearch for information about
  // what is required from these methods.
  //
  // Note that additional search methods are added for the html numbers and
  // html formatted numbers by `_addNumericSort()` when we know what the decimal
  // place is

  $.extend( DataTable.ext.type.search, {
    html: function ( data ) {
      return _empty(data) ?
        data :
        typeof data === "string" ?
          data
            .replace( _re_new_lines, " " )
            .replace( _re_html, "" ) :
          "";
    },

    string: function ( data ) {
      return _empty(data) ?
        data :
        typeof data === "string" ?
          data.replace( _re_new_lines, " " ) :
          data;
    }
  } );

  var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
    if ( d !== 0 && (!d || d === "-") ) {
      return -Infinity;
    }

    // If a decimal place other than `.` is used, it needs to be given to the
    // function so we can detect it and replace with a `.` which is the only
    // decimal place Javascript recognises - it is not locale aware.
    if ( decimalPlace ) {
      d = _numToDecimal( d, decimalPlace );
    }

    if ( d.replace ) {
      if ( re1 ) {
        d = d.replace( re1, "" );
      }

      if ( re2 ) {
        d = d.replace( re2, "" );
      }
    }

    return d * 1;
  };

  // Add the numeric 'deformatting' functions for sorting and search. This is done
  // in a function to provide an easy ability for the language options to add
  // additional methods if a non-period decimal place is used.
  function _addNumericSort( decimalPlace ) {
    $.each(
      {
        // Plain numbers
        "num": function ( d ) {
          return __numericReplace( d, decimalPlace );
        },

        // Formatted numbers
        "num-fmt": function ( d ) {
          return __numericReplace( d, decimalPlace, _re_formatted_numeric );
        },

        // HTML numeric
        "html-num": function ( d ) {
          return __numericReplace( d, decimalPlace, _re_html );
        },

        // HTML numeric, formatted
        "html-num-fmt": function ( d ) {
          return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
        }
      },
      function ( key, fn ) {
        // Add the ordering method
        _ext.type.order[ key + decimalPlace + "-pre" ] = fn;

        // For HTML types add a search formatter that will strip the HTML
        if ( key.match(/^html\-/) ) {
          _ext.type.search[ key + decimalPlace ] = _ext.type.search.html;
        }
      }
    );
  }

  // Default sort methods
  $.extend( _ext.type.order, {
    // Dates
    "date-pre": function ( d ) {
      return Date.parse( d ) || -Infinity;
    },

    // html
    "html-pre": function ( a ) {
      return _empty(a) ?
        "" :
        a.replace ?
          a.replace( /<.*?>/g, "" ).toLowerCase() :
          a + "";
    },

    // string
    "string-pre": function ( a ) {
      // This is a little complex, but faster than always calling toString,
      // http://jsperf.com/tostring-v-check
      return _empty(a) ?
        "" :
        typeof a === "string" ?
          a.toLowerCase() :
          ! a.toString ?
            "" :
            a.toString();
    },

    // string-asc and -desc are retained only for compatibility with the old
    // sort methods
    "string-asc": function ( x, y ) {
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    },

    "string-desc": function ( x, y ) {
      return ((x < y) ? 1 : ((x > y) ? -1 : 0));
    }
  } );

  // Numeric sorting types - order doesn't matter here
  _addNumericSort( "" );

  $.extend( true, DataTable.ext.renderer, {
    header: {
      _: function ( settings, cell, column, classes ) {
        // No additional mark-up required
        // Attach a sort listener to update on sort - note that using the
        // `DT` namespace will allow the event to be removed automatically
        // on destroy, while the `dt` namespaced event is the one we are
        // listening for
        $(settings.nTable).on( "order.dt.DT", function ( e, ctx, sorting, columns ) {
          if ( settings !== ctx ) { // need to check this this is the host
            return; // table, not a nested one
          }

          var colIdx = column.idx;

          cell
            .removeClass(
              column.sSortingClass + " " +
							classes.sSortAsc + " " +
							classes.sSortDesc
            )
            .addClass( columns[ colIdx ] == "asc" ?
              classes.sSortAsc : columns[ colIdx ] == "desc" ?
                classes.sSortDesc :
                column.sSortingClass
            );
        } );
      },

      jqueryui: function ( settings, cell, column, classes ) {
        $("<div/>")
          .addClass( classes.sSortJUIWrapper )
          .append( cell.contents() )
          .append( $("<span/>")
            .addClass( classes.sSortIcon + " " + column.sSortingClassJUI )
          )
          .appendTo( cell );

        // Attach a sort listener to update on sort
        $(settings.nTable).on( "order.dt.DT", function ( e, ctx, sorting, columns ) {
          if ( settings !== ctx ) {
            return;
          }

          var colIdx = column.idx;

          cell
            .removeClass( classes.sSortAsc + " " + classes.sSortDesc )
            .addClass( columns[ colIdx ] == "asc" ?
              classes.sSortAsc : columns[ colIdx ] == "desc" ?
                classes.sSortDesc :
                column.sSortingClass
            );

          cell
            .find( "span." + classes.sSortIcon )
            .removeClass(
              classes.sSortJUIAsc + " " +
							classes.sSortJUIDesc + " " +
							classes.sSortJUI + " " +
							classes.sSortJUIAscAllowed + " " +
							classes.sSortJUIDescAllowed
            )
            .addClass( columns[ colIdx ] == "asc" ?
              classes.sSortJUIAsc : columns[ colIdx ] == "desc" ?
                classes.sSortJUIDesc :
                column.sSortingClassJUI
            );
        } );
      }
    }
  } );

  /*
	 * Public helper functions. These aren't used internally by DataTables, or
	 * called by any of the options passed into DataTables, but they can be used
	 * externally by developers working with DataTables. They are helper functions
	 * to make working with DataTables a little bit easier.
	 */

  var __htmlEscapeEntities = function ( d ) {
    return typeof d === "string" ?
      d.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;") :
      d;
  };

  /**
	 * Helpers for `columns.render`.
	 *
	 * The options defined here can be used with the `columns.render` initialisation
	 * option to provide a display renderer. The following functions are defined:
	 *
	 * * `number` - Will format numeric data (defined by `columns.data`) for
	 *   display, retaining the original unformatted data for sorting and filtering.
	 *   It takes 5 parameters:
	 *   * `string` - Thousands grouping separator
	 *   * `string` - Decimal point indicator
	 *   * `integer` - Number of decimal points to show
	 *   * `string` (optional) - Prefix.
	 *   * `string` (optional) - Postfix (/suffix).
	 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
	 *   parameters.
	 *
	 * @example
	 *   // Column definition using the number renderer
	 *   {
	 *     data: "salary",
	 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
	 *   }
	 *
	 * @namespace
	 */
  DataTable.render = {
    number: function ( thousands, decimal, precision, prefix, postfix ) {
      return {
        display: function ( d ) {
          if ( typeof d !== "number" && typeof d !== "string" ) {
            return d;
          }

          var negative = d < 0 ? "-" : "";
          var flo = parseFloat( d );

          // If NaN then there isn't much formatting that we can do - just
          // return immediately, escaping any HTML (this was supposed to
          // be a number after all)
          if ( isNaN( flo ) ) {
            return __htmlEscapeEntities( d );
          }

          flo = flo.toFixed( precision );
          d = Math.abs( flo );

          var intPart = parseInt( d, 10 );
          var floatPart = precision ?
            decimal + (d - intPart).toFixed( precision ).substring( 2 ) :
            "";

          return negative + (prefix || "") +
						intPart.toString().replace(
						  /\B(?=(\d{3})+(?!\d))/g, thousands
						) +
						floatPart +
						(postfix || "");
        }
      };
    },

    text: function () {
      return {
        display: __htmlEscapeEntities
      };
    }
  };

  /*
	 * This is really a good bit rubbish this method of exposing the internal methods
	 * publicly... - To be fixed in 2.0 using methods on the prototype
	 */

  /**
	 * Create a wrapper function for exporting an internal functions to an external API.
	 *  @param {string} fn API function name
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#internal
	 */
  function _fnExternApiFunc(fn)
  {
    return function () {
      var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
        Array.prototype.slice.call(arguments)
      );
      return DataTable.ext.internal[fn].apply( this, args );
    };
  }

  /**
	 * Reference to internal functions for use by plug-in developers. Note that
	 * these methods are references to internal functions and are considered to be
	 * private. If you use these methods, be aware that they are liable to change
	 * between versions.
	 *  @namespace
	 */
  $.extend( DataTable.ext.internal, {
    _fnExternApiFunc: _fnExternApiFunc,
    _fnBuildAjax: _fnBuildAjax,
    _fnAjaxUpdate: _fnAjaxUpdate,
    _fnAjaxParameters: _fnAjaxParameters,
    _fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
    _fnAjaxDataSrc: _fnAjaxDataSrc,
    _fnAddColumn: _fnAddColumn,
    _fnColumnOptions: _fnColumnOptions,
    _fnAdjustColumnSizing: _fnAdjustColumnSizing,
    _fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
    _fnColumnIndexToVisible: _fnColumnIndexToVisible,
    _fnVisbleColumns: _fnVisbleColumns,
    _fnGetColumns: _fnGetColumns,
    _fnColumnTypes: _fnColumnTypes,
    _fnApplyColumnDefs: _fnApplyColumnDefs,
    _fnHungarianMap: _fnHungarianMap,
    _fnCamelToHungarian: _fnCamelToHungarian,
    _fnLanguageCompat: _fnLanguageCompat,
    _fnBrowserDetect: _fnBrowserDetect,
    _fnAddData: _fnAddData,
    _fnAddTr: _fnAddTr,
    _fnNodeToDataIndex: _fnNodeToDataIndex,
    _fnNodeToColumnIndex: _fnNodeToColumnIndex,
    _fnGetCellData: _fnGetCellData,
    _fnSetCellData: _fnSetCellData,
    _fnSplitObjNotation: _fnSplitObjNotation,
    _fnGetObjectDataFn: _fnGetObjectDataFn,
    _fnSetObjectDataFn: _fnSetObjectDataFn,
    _fnGetDataMaster: _fnGetDataMaster,
    _fnClearTable: _fnClearTable,
    _fnDeleteIndex: _fnDeleteIndex,
    _fnInvalidate: _fnInvalidate,
    _fnGetRowElements: _fnGetRowElements,
    _fnCreateTr: _fnCreateTr,
    _fnBuildHead: _fnBuildHead,
    _fnDrawHead: _fnDrawHead,
    _fnDraw: _fnDraw,
    _fnReDraw: _fnReDraw,
    _fnAddOptionsHtml: _fnAddOptionsHtml,
    _fnDetectHeader: _fnDetectHeader,
    _fnGetUniqueThs: _fnGetUniqueThs,
    _fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
    _fnFilterComplete: _fnFilterComplete,
    _fnFilterCustom: _fnFilterCustom,
    _fnFilterColumn: _fnFilterColumn,
    _fnFilter: _fnFilter,
    _fnFilterCreateSearch: _fnFilterCreateSearch,
    _fnEscapeRegex: _fnEscapeRegex,
    _fnFilterData: _fnFilterData,
    _fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
    _fnUpdateInfo: _fnUpdateInfo,
    _fnInfoMacros: _fnInfoMacros,
    _fnInitialise: _fnInitialise,
    _fnInitComplete: _fnInitComplete,
    _fnLengthChange: _fnLengthChange,
    _fnFeatureHtmlLength: _fnFeatureHtmlLength,
    _fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
    _fnPageChange: _fnPageChange,
    _fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
    _fnProcessingDisplay: _fnProcessingDisplay,
    _fnFeatureHtmlTable: _fnFeatureHtmlTable,
    _fnScrollDraw: _fnScrollDraw,
    _fnApplyToChildren: _fnApplyToChildren,
    _fnCalculateColumnWidths: _fnCalculateColumnWidths,
    _fnThrottle: _fnThrottle,
    _fnConvertToWidth: _fnConvertToWidth,
    _fnGetWidestNode: _fnGetWidestNode,
    _fnGetMaxLenString: _fnGetMaxLenString,
    _fnStringToCss: _fnStringToCss,
    _fnSortFlatten: _fnSortFlatten,
    _fnSort: _fnSort,
    _fnSortAria: _fnSortAria,
    _fnSortListener: _fnSortListener,
    _fnSortAttachListener: _fnSortAttachListener,
    _fnSortingClasses: _fnSortingClasses,
    _fnSortData: _fnSortData,
    _fnSaveState: _fnSaveState,
    _fnLoadState: _fnLoadState,
    _fnSettingsFromNode: _fnSettingsFromNode,
    _fnLog: _fnLog,
    _fnMap: _fnMap,
    _fnBindAction: _fnBindAction,
    _fnCallbackReg: _fnCallbackReg,
    _fnCallbackFire: _fnCallbackFire,
    _fnLengthOverflow: _fnLengthOverflow,
    _fnRenderer: _fnRenderer,
    _fnDataSource: _fnDataSource,
    _fnRowAttributes: _fnRowAttributes,
    _fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
		                                // in 1.10, so this dead-end function is
		                                // added to prevent errors
  } );

  // jQuery access
  $.fn.dataTable = DataTable;

  // Provide access to the host jQuery object (circular reference)
  DataTable.$ = $;

  // Legacy aliases
  $.fn.dataTableSettings = DataTable.settings;
  $.fn.dataTableExt = DataTable.ext;

  // With a capital `D` we return a DataTables API instance rather than a
  // jQuery object
  $.fn.DataTable = function ( opts ) {
    return $(this).dataTable( opts ).api();
  };

  // All properties that are available to $.fn.dataTable should also be
  // available on $.fn.DataTable
  $.each( DataTable, function ( prop, val ) {
    $.fn.DataTable[ prop ] = val;
  } );

  // Information about events fired by DataTables - for documentation.
  /**
	 * Draw event, fired whenever the table is redrawn on the page, at the same
	 * point as fnDrawCallback. This may be useful for binding events or
	 * performing calculations when the table is altered at all.
	 *  @name DataTable#draw.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

  /**
	 * Search event, fired when the searching applied to the table (using the
	 * built-in global search, or column filters) is altered.
	 *  @name DataTable#search.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

  /**
	 * Page change event, fired when the paging of the table is altered.
	 *  @name DataTable#page.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

  /**
	 * Order event, fired when the ordering applied to the table is altered.
	 *  @name DataTable#order.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

  /**
	 * DataTables initialisation complete event, fired when the table is fully
	 * drawn, including Ajax data loaded, if Ajax data is required.
	 *  @name DataTable#init.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The JSON object request from the server - only
	 *    present if client-side Ajax sourced data is used</li></ol>
	 */

  /**
	 * State save event, fired when the table has changed state a new state save
	 * is required. This event allows modification of the state saving object
	 * prior to actually doing the save, including addition or other state
	 * properties (for plug-ins) or modification of a DataTables core property.
	 *  @name DataTable#stateSaveParams.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The state information to be saved
	 */

  /**
	 * State load event, fired when the table is loading state from the stored
	 * data, but prior to the settings object being modified by the saved state
	 * - allowing modification of the saved state is required or loading of
	 * state for a plug-in.
	 *  @name DataTable#stateLoadParams.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The saved state information
	 */

  /**
	 * State loaded event, fired when state has been loaded from stored data and
	 * the settings object has been modified by the loaded data.
	 *  @name DataTable#stateLoaded.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The saved state information
	 */

  /**
	 * Processing event, fired when DataTables is doing some kind of processing
	 * (be it, order, searcg or anything else). It can be used to indicate to
	 * the end user that there is something happening, or that something has
	 * finished.
	 *  @name DataTable#processing.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {boolean} bShow Flag for if DataTables is doing processing or not
	 */

  /**
	 * Ajax (XHR) event, fired whenever an Ajax request is completed from a
	 * request to made to the server for new data. This event is called before
	 * DataTables processed the returned data, so it can also be used to pre-
	 * process the data returned from the server, if needed.
	 *
	 * Note that this trigger is called in `fnServerData`, if you override
	 * `fnServerData` and which to use this event, you need to trigger it in you
	 * success function.
	 *  @name DataTable#xhr.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {object} json JSON returned from the server
	 *
	 *  @example
	 *     // Use a custom property returned from the server in another DOM element
	 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	 *       $('#status').html( json.status );
	 *     } );
	 *
	 *  @example
	 *     // Pre-process the data returned from the server
	 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	 *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
	 *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
	 *       }
	 *       // Note no return - manipulate the data directly in the JSON object.
	 *     } );
	 */

  /**
	 * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
	 * or passing the bDestroy:true parameter in the initialisation object. This
	 * can be used to remove bound events, added DOM nodes, etc.
	 *  @name DataTable#destroy.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

  /**
	 * Page length change event, fired when number of records to show on each
	 * page (the length) is changed.
	 *  @name DataTable#length.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {integer} len New length
	 */

  /**
	 * Column sizing has changed.
	 *  @name DataTable#column-sizing.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

  /**
	 * Column visibility has changed.
	 *  @name DataTable#column-visibility.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {int} column Column index
	 *  @param {bool} vis `false` if column now hidden, or `true` if visible
	 */

  return $.fn.dataTable;
}));

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  angular.module("datatables.directive", ["datatables.instances", "datatables.renderer", "datatables.options", "datatables.util"])
    .directive("datatable", dataTable);

  /* @ngInject */
  function dataTable($q, $http, DTRendererFactory, DTRendererService, DTPropertyUtil) {
    compileDirective.$inject = ["tElm"];
    ControllerDirective.$inject = ["$scope"];
    return {
      restrict: "A",
      scope: {
        dtOptions: "=",
        dtColumns: "=",
        dtColumnDefs: "=",
        datatable: "@",
        dtInstance: "="
      },
      compile: compileDirective,
      controller: ControllerDirective
    };

    /* @ngInject */
    function compileDirective(tElm) {
      var _staticHTML = tElm[0].innerHTML;

      return function postLink($scope, $elem, iAttrs, ctrl) {
        function handleChanges(newVal, oldVal) {
          if (newVal !== oldVal) {
            ctrl.render($elem, ctrl.buildOptionsPromise(), _staticHTML);
          }
        }

        // Options can hold heavy data, and other deep/large objects.
        // watchcollection can improve this by only watching shallowly
        var watchFunction = iAttrs.dtDisableDeepWatchers ? "$watchCollection" : "$watch";
        angular.forEach(["dtColumns", "dtColumnDefs", "dtOptions"], function (tableDefField) {
          $scope[watchFunction].call($scope, tableDefField, handleChanges, true);
        });
        DTRendererService.showLoading($elem);
        ctrl.render($elem, ctrl.buildOptionsPromise(), _staticHTML);
      };
    }

    /* @ngInject */
    function ControllerDirective($scope) {
      var _dtInstance;
      var vm = this;
      vm.buildOptionsPromise = buildOptionsPromise;
      vm.render = render;

      function buildOptionsPromise() {
        var defer = $q.defer();
        // Build options
        $q.all([
          $q.when($scope.dtOptions),
          $q.when($scope.dtColumns),
          $q.when($scope.dtColumnDefs)
        ]).then(function (results) {
          var dtOptions = results[0],
            dtColumns = results[1],
            dtColumnDefs = results[2];
          // Since Angular 1.3, the promise throws a "Maximum call stack size exceeded" when cloning
          // See https://github.com/l-lin/angular-datatables/issues/110
          DTPropertyUtil.deleteProperty(dtOptions, "$promise");
          DTPropertyUtil.deleteProperty(dtColumns, "$promise");
          DTPropertyUtil.deleteProperty(dtColumnDefs, "$promise");
          var options;
          if (angular.isDefined(dtOptions)) {
            options = {};
            angular.extend(options, dtOptions);
            // Set the columns
            if (angular.isArray(dtColumns)) {
              options.aoColumns = dtColumns;
            }

            // Set the column defs
            if (angular.isArray(dtColumnDefs)) {
              options.aoColumnDefs = dtColumnDefs;
            }

            // HACK to resolve the language source manually instead of DT
            // See https://github.com/l-lin/angular-datatables/issues/181
            if (options.language && options.language.url) {
              var languageDefer = $q.defer();
              $http.get(options.language.url).success(function (language) {
                languageDefer.resolve(language);
              });
              options.language = languageDefer.promise;
            }

          }
          return DTPropertyUtil.resolveObjectPromises(options, ["data", "aaData", "fnPromise"]);
        }).then(function (options) {
          defer.resolve(options);
        });
        return defer.promise;
      }

      function render($elem, optionsPromise, staticHTML) {
        optionsPromise.then(function (options) {
          DTRendererService.preRender(options);

          var isNgDisplay = $scope.datatable && $scope.datatable === "ng";
          // Render dataTable
          if (_dtInstance && _dtInstance._renderer) {
            _dtInstance._renderer.withOptions(options)
              .render($elem, $scope, staticHTML).then(function (dtInstance) {
                _dtInstance = dtInstance;
                _setDTInstance(dtInstance);
              });
          } else {
            DTRendererFactory.fromOptions(options, isNgDisplay)
              .render($elem, $scope, staticHTML).then(function (dtInstance) {
                _dtInstance = dtInstance;
                _setDTInstance(dtInstance);
              });
          }
        });
      }

      function _setDTInstance(dtInstance) {
        if (angular.isFunction($scope.dtInstance)) {
          $scope.dtInstance(dtInstance);
        } else if (angular.isDefined($scope.dtInstance)) {
          $scope.dtInstance = dtInstance;
        }
      }
    }
  }

  dataTable.$inject = ["$q", "$http", "DTRendererFactory", "DTRendererService", "DTPropertyUtil"];

  "use strict";
  angular.module("datatables.factory", [])
    .factory("DTOptionsBuilder", dtOptionsBuilder)
    .factory("DTColumnBuilder", dtColumnBuilder)
    .factory("DTColumnDefBuilder", dtColumnDefBuilder)
    .factory("DTLoadingTemplate", dtLoadingTemplate);

  /* @ngInject */
  function dtOptionsBuilder() {
    /**
     * The wrapped datatables options class
     * @param sAjaxSource the ajax source to fetch the data
     * @param fnPromise the function that returns a promise to fetch the data
     */
    var DTOptions = {
      hasOverrideDom: false,

      /**
       * Add the option to the datatables optoins
       * @param key the key of the option
       * @param value an object or a function of the option
       * @returns {DTOptions} the options
       */
      withOption: function (key, value) {
        if (angular.isString(key)) {
          this[key] = value;
        }
        return this;
      },

      /**
       * Add the Ajax source to the options.
       * This corresponds to the "ajax" option
       * @param ajax the ajax source
       * @returns {DTOptions} the options
       */
      withSource: function (ajax) {
        this.ajax = ajax;
        return this;
      },

      /**
       * Add the ajax data properties.
       * @param sAjaxDataProp the ajax data property
       * @returns {DTOptions} the options
       */
      withDataProp: function (sAjaxDataProp) {
        this.sAjaxDataProp = sAjaxDataProp;
        return this;
      },

      /**
       * Set the server data function.
       * @param fn the function of the server retrieval
       * @returns {DTOptions} the options
       */
      withFnServerData: function (fn) {
        if (!angular.isFunction(fn)) {
          throw new Error("The parameter must be a function");
        }
        this.fnServerData = fn;
        return this;
      },

      /**
       * Set the pagination type.
       * @param sPaginationType the pagination type
       * @returns {DTOptions} the options
       */
      withPaginationType: function (sPaginationType) {
        if (angular.isString(sPaginationType)) {
          this.sPaginationType = sPaginationType;
        } else {
          throw new Error("The pagination type must be provided");
        }
        return this;
      },

      /**
       * Set the language of the datatables
       * @param language the language
       * @returns {DTOptions} the options
       */
      withLanguage: function (language) {
        this.language = language;
        return this;
      },

      /**
       * Set the language source
       * @param languageSource the language source
       * @returns {DTOptions} the options
       */
      withLanguageSource: function (languageSource) {
        return this.withLanguage({
          url: languageSource
        });
      },

      /**
       * Set default number of items per page to display
       * @param iDisplayLength the number of items per page
       * @returns {DTOptions} the options
       */
      withDisplayLength: function (iDisplayLength) {
        this.iDisplayLength = iDisplayLength;
        return this;
      },

      /**
       * Set the promise to fetch the data
       * @param fnPromise the function that returns a promise
       * @returns {DTOptions} the options
       */
      withFnPromise: function (fnPromise) {
        this.fnPromise = fnPromise;
        return this;
      },

      /**
       * Set the Dom of the DataTables.
       * @param dom the dom
       * @returns {DTOptions} the options
       */
      withDOM: function (dom) {
        this.dom = dom;
        return this;
      }
    };

    return {
      /**
       * Create a wrapped datatables options
       * @returns {DTOptions} a wrapped datatables option
       */
      newOptions: function () {
        return Object.create(DTOptions);
      },
      /**
       * Create a wrapped datatables options with the ajax source setted
       * @param ajax the ajax source
       * @returns {DTOptions} a wrapped datatables option
       */
      fromSource: function (ajax) {
        var options = Object.create(DTOptions);
        options.ajax = ajax;
        return options;
      },
      /**
       * Create a wrapped datatables options with the data promise.
       * @param fnPromise the function that returns a promise to fetch the data
       * @returns {DTOptions} a wrapped datatables option
       */
      fromFnPromise: function (fnPromise) {
        var options = Object.create(DTOptions);
        options.fnPromise = fnPromise;
        return options;
      }
    };
  }

  function dtColumnBuilder() {
    /**
     * The wrapped datatables column
     * @param mData the data to display of the column
     * @param sTitle the sTitle of the column title to display in the DOM
     */
    var DTColumn = {
      /**
       * Add the option of the column
       * @param key the key of the option
       * @param value an object or a function of the option
       * @returns {DTColumn} the wrapped datatables column
       */
      withOption: function (key, value) {
        if (angular.isString(key)) {
          this[key] = value;
        }
        return this;
      },

      /**
       * Set the title of the colum
       * @param sTitle the sTitle of the column
       * @returns {DTColumn} the wrapped datatables column
       */
      withTitle: function (sTitle) {
        this.sTitle = sTitle;
        return this;
      },

      /**
       * Set the CSS class of the column
       * @param sClass the CSS class
       * @returns {DTColumn} the wrapped datatables column
       */
      withClass: function (sClass) {
        this.sClass = sClass;
        return this;
      },

      /**
       * Hide the column
       * @returns {DTColumn} the wrapped datatables column
       */
      notVisible: function () {
        this.bVisible = false;
        return this;
      },

      /**
       * Set the column as not sortable
       * @returns {DTColumn} the wrapped datatables column
       */
      notSortable: function () {
        this.bSortable = false;
        return this;
      },

      /**
       * Render each cell with the given parameter
       * @mRender mRender the function/string to render the data
       * @returns {DTColumn} the wrapped datatables column
       */
      renderWith: function (mRender) {
        this.mRender = mRender;
        return this;
      }
    };

    return {
      /**
       * Create a new wrapped datatables column
       * @param mData the data of the column to display
       * @param sTitle the sTitle of the column title to display in the DOM
       * @returns {DTColumn} the wrapped datatables column
       */
      newColumn: function (mData, sTitle) {
        if (angular.isUndefined(mData)) {
          throw new Error("The parameter \"mData\" is not defined!");
        }
        var column = Object.create(DTColumn);
        column.mData = mData;
        column.sTitle = sTitle || "";
        return column;
      },
      DTColumn: DTColumn
    };
  }

  /* @ngInject */
  function dtColumnDefBuilder(DTColumnBuilder) {
    return {
      newColumnDef: function (targets) {
        if (angular.isUndefined(targets)) {
          throw new Error("The parameter \"targets\" must be defined! See https://datatables.net/reference/option/columnDefs.targets");
        }
        var column = Object.create(DTColumnBuilder.DTColumn);
        if (angular.isArray(targets)) {
          column.aTargets = targets;
        } else {
          column.aTargets = [targets];
        }
        return column;
      }
    };
  }

  dtColumnDefBuilder.$inject = ["DTColumnBuilder"];

  function dtLoadingTemplate() {
    return {
      html: "<h3 class=\"dt-loading\">Loading...</h3>"
    };
  }

  "use strict";

  angular.module("datatables.instances", ["datatables.util"])
    .factory("DTInstances", dtInstances)
    .factory("DTInstanceFactory", dtInstanceFactory);

  /* @ngInject */
  function dtInstances($q, failzQ, $timeout, $log) {
    var TIME_BEFORE_CLEANING = 1000;
    var _instances = {};
    var _lastInstance = {};
    // Promise for fetching the last DT instance
    var _deferLastDTInstances = null;
    var _lastDTInstance = null;
    // Promise for fetching the list of DT instances
    var _deferDTInstances = null;
    var _dtInstances = null;

    return {
      register: register,
      getLast: getLast,
      getList: getList,
      getI: getI
    };

    function getI() {
      return _instances;
    }

    function register(dtInstance, result) {
      dtInstance.id = result.id;
      dtInstance.DataTable = result.DataTable;
      dtInstance.dataTable = result.dataTable;

      _cleanInstances();

      _instances[dtInstance.id] = dtInstance;

      _lastInstance = dtInstance;
      if (_deferLastDTInstances) {
        _deferLastDTInstances.resolve(_lastInstance);
      }
      if (_deferDTInstances) {
        _deferDTInstances.resolve(_instances);
      }

      return dtInstance;
    }

    function getLast() {
      $log.warn("\"DTInstances.getLast()\" and \"DTInstances.getList()\" are deprecated! Use the \"dt-instance\" to provide the datatables instance. See https://l-lin.github.com/angular-datatables/#/manipulatingDTInstances for more information.");
      var defer = $q.defer();
      if (!_lastDTInstance) {
        _deferLastDTInstances = $q.defer();
        _lastDTInstance = _deferLastDTInstances.promise;
      }
      failzQ(_lastDTInstance).then(function (dtInstance) {
        defer.resolve(dtInstance);
        // Reset the promise
        _deferLastDTInstances = null;
        _lastDTInstance = null;
      }, function () {
        // In case we are trying to fetch the last instance again
        defer.resolve(_lastInstance);
      });
      return defer.promise;
    }

    function getList() {

      $log.warn("\"DTInstances.getLast()\" and \"DTInstances.getList()\" are deprecated! Use the \"dt-instance\" to provide the datatables instance. See https://l-lin.github.com/angular-datatables/#/manipulatingDTInstances for more information.");
      var defer = $q.defer();

      console.log(defer);

      if (!_dtInstances) {

        _deferDTInstances = $q.defer();
        _dtInstances = _deferDTInstances.promise;
      }
      console.log("this one", _dtInstances);
      failzQ(_dtInstances).then(function (instances) {

        defer.resolve(instances);
        // Reset the promise
        _deferDTInstances = null;
        _dtInstances = null;
      }, function (err) {
        console.log(err);
        // In case we are trying to fetch the instances again
        console.log("instances are", _instances);
        defer.resolve(_instances);
      });

      return defer.promise;
    }

    function _cleanInstances() {
      $timeout(function () {
        var newInstances = {};
        for (var attr in _instances) {
          if (_instances.hasOwnProperty(attr)) {
            if ($.fn.DataTable.isDataTable(_instances[attr].dataTable)) {

              newInstances[attr] = _instances[attr];
            } else {
              console.log(_instances[attr].dataTable, "is not a data table");
            }
          }
        }
        _instances = newInstances;
      }, TIME_BEFORE_CLEANING);
    }
  }

  dtInstances.$inject = ["$q", "failzQ", "$timeout", "$log"];

  function dtInstanceFactory() {
    var DTInstance = {
      reloadData: reloadData,
      changeData: changeData,
      rerender: rerender
    };
    return {
      newDTInstance: newDTInstance
    };

    function newDTInstance(renderer) {
      var dtInstance = Object.create(DTInstance);
      dtInstance._renderer = renderer;
      return dtInstance;
    }

    function reloadData(callback, resetPaging) {
      /* jshint validthis:true */
      this._renderer.reloadData(callback, resetPaging);
    }

    function changeData(data) {
      /* jshint validthis:true */
      this._renderer.changeData(data);
    }

    function rerender() {
      /* jshint validthis:true */
      this._renderer.rerender();
    }
  }

  angular.module("datatables", ["datatables.directive", "datatables.factory"])
    .run(initAngularDataTables);

  /* @ngInject */
  function initAngularDataTables($log) {
    if ($.fn.DataTable.Api) {
      /**
       * Register an API to destroy a DataTable without detaching the tbody so that we can add new data
       * when rendering with the "Angular way".
       */
      $.fn.DataTable.Api.register("ngDestroy()", function (remove) {
        remove = remove || false;

        return this.iterator("table", function (settings) {
          var orig = settings.nTableWrapper.parentNode;
          var classes = settings.oClasses;
          var table = settings.nTable;
          var tbody = settings.nTBody;
          var thead = settings.nTHead;
          var tfoot = settings.nTFoot;
          var jqTable = $(table);
          var jqTbody = $(tbody);
          var jqWrapper = $(settings.nTableWrapper);
          var rows = $.map(settings.aoData, function (r) {
            return r.nTr;
          });
          var ien;

          // Flag to note that the table is currently being destroyed - no action
          // should be taken
          settings.bDestroying = true;

          // Fire off the destroy callbacks for plug-ins etc
          $.fn.DataTable.ext.internal._fnCallbackFire(settings, "aoDestroyCallback", "destroy", [settings]);

          // If not being removed from the document, make all columns visible
          if (!remove) {
            new $.fn.DataTable.Api(settings).columns().visible(true);
          }

          // Blitz all `DT` namespaced events (these are internal events, the
          // lowercase, `dt` events are user subscribed and they are responsible
          // for removing them
          jqWrapper.unbind(".DT").find(":not(tbody *)").unbind(".DT");
          $(window).unbind(".DT-" + settings.sInstance);

          // When scrolling we had to break the table up - restore it
          if (table !== thead.parentNode) {
            jqTable.children("thead").detach();
            jqTable.append(thead);
          }

          if (tfoot && table !== tfoot.parentNode) {
            jqTable.children("tfoot").detach();
            jqTable.append(tfoot);
          }

          // Remove the DataTables generated nodes, events and classes
          jqTable.detach();
          jqWrapper.detach();

          settings.aaSorting = [];
          settings.aaSortingFixed = [];
          $.fn.DataTable.ext.internal._fnSortingClasses(settings);

          $(rows).removeClass(settings.asStripeClasses.join(" "));

          $("th, td", thead).removeClass(classes.sSortable + " " +
            classes.sSortableAsc + " " + classes.sSortableDesc + " " + classes.sSortableNone
          );

          if (settings.bJUI) {
            $("th span." + classes.sSortIcon + ", td span." + classes.sSortIcon, thead).detach();
            $("th, td", thead).each(function () {
              var wrapper = $("div." + classes.sSortJUIWrapper, this);
              $(this).append(wrapper.contents());
              wrapper.detach();
            });
          }

          // -------------------------------------------------------------------------
          // This is the only change with the "destroy()" API (with DT v1.10.1)
          // -------------------------------------------------------------------------
          if (!remove && orig) {
            // insertBefore acts like appendChild if !arg[1]
            try {
              orig.insertBefore(table, settings.nTableReinsertBefore);
            } catch (ex) {
              $log.warn(ex);
              orig.appendChild(table);
            }
          }
          // Add the TR elements back into the table in their original order
          // jqTbody.children().detach();
          // jqTbody.append( rows );
          // -------------------------------------------------------------------------

          // Restore the width of the original table - was read from the style property,
          // so we can restore directly to that
          jqTable
            .css("width", settings.sDestroyWidth)
            .removeClass(classes.sTable);

          // If the were originally stripe classes - then we add them back here.
          // Note this is not fool proof (for example if not all rows had stripe
          // classes - but it's a good effort without getting carried away
          ien = settings.asDestroyStripes.length;

          if (ien) {
            jqTbody.children().each(function (i) {
              $(this).addClass(settings.asDestroyStripes[i % ien]);
            });
          }

          /* Remove the settings object from the settings array */
          var idx = $.inArray(settings, $.fn.DataTable.settings);
          if (idx !== -1) {
            $.fn.DataTable.settings.splice(idx, 1);
          }
        });
      });
    }
  }

  initAngularDataTables.$inject = ["$log"];

  angular.module("datatables.options", [])
    .constant("DT_DEFAULT_OPTIONS", {
      // Default dom
      dom: "lfrtip",
      // Default ajax properties. See http://legacy.datatables.net/usage/options#sAjaxDataProp
      sAjaxDataProp: "",
      // Set default columns (used when none are provided)
      aoColumns: []
    })
    .service("DTDefaultOptions", dtDefaultOptions);

  function dtDefaultOptions() {
    var options = {
      bootstrapOptions: {},
      setLanguageSource: setLanguageSource,
      setLanguage: setLanguage,
      setDisplayLength: setDisplayLength,
      setBootstrapOptions: setBootstrapOptions
    };

    return options;

    /**
     * Set the default language source for all datatables
     * @param sLanguageSource the language source
     * @returns {DTDefaultOptions} the default option config
     */
    function setLanguageSource(sLanguageSource) {
      $.extend($.fn.dataTable.defaults, {
        oLanguage: {
          sUrl: sLanguageSource
        }
      });
      return options;
    }

    /**
     * Set the language for all datatables
     * @param oLanguage the language
     * @returns {DTDefaultOptions} the default option config
     */
    function setLanguage(oLanguage) {
      $.extend(true, $.fn.dataTable.defaults, {
        oLanguage: oLanguage
      });
      return options;
    }

    /**
     * Set the default number of items to display for all datatables
     * @param iDisplayLength the number of items to display
     * @returns {DTDefaultOptions} the default option config
     */
    function setDisplayLength(iDisplayLength) {
      $.extend($.fn.dataTable.defaults, {
        iDisplayLength: iDisplayLength
      });
      return options;
    }

    /**
     * Set the default options to be use for Bootstrap integration.
     * See https://github.com/l-lin/angular-datatables/blob/dev/src/angular-datatables.bootstrap.options.js to check
     * what default options Angular DataTables is using.
     * @param oBootstrapOptions an object containing the default options for Bootstreap integration
     * @returns {DTDefaultOptions} the default option config
     */
    function setBootstrapOptions(oBootstrapOptions) {
      options.bootstrapOptions = oBootstrapOptions;
      return options;
    }
  }

  "use strict";
  angular.module("datatables.renderer", ["datatables.instances", "datatables.factory", "datatables.options", "datatables.instances"])
    .factory("DTRendererService", dtRendererService)
    .factory("DTRenderer", dtRenderer)
    .factory("DTDefaultRenderer", dtDefaultRenderer)
    .factory("DTNGRenderer", dtNGRenderer)
    .factory("DTPromiseRenderer", dtPromiseRenderer)
    .factory("DTAjaxRenderer", dtAjaxRenderer)
    .factory("DTRendererFactory", dtRendererFactory);

  /* @ngInject */
  function dtRendererService(DTLoadingTemplate) {
    var $loading = angular.element(DTLoadingTemplate.html);
    var plugins = [];
    var rendererService = {
      getLoadingElem: getLoadingElem,
      showLoading: showLoading,
      hideLoading: hideLoading,
      renderDataTable: renderDataTable,
      hideLoadingAndRenderDataTable: hideLoadingAndRenderDataTable,
      registerPlugin: registerPlugin,
      postRender: postRender,
      preRender: preRender
    };
    return rendererService;

    function getLoadingElem() {
      return $loading;
    }

    function showLoading($elem) {
      $elem.after($loading);
      $elem.hide();
      $loading.show();
    }

    function hideLoading($elem) {
      $elem.show();
      $loading.hide();
    }

    function renderDataTable($elem, options) {
      var dtId = "#" + $elem.attr("id");
      if ($.fn.dataTable.isDataTable(dtId) && angular.isObject(options)) {
        options.destroy = true;
      }
      // See http://datatables.net/manual/api#Accessing-the-API to understand the difference between DataTable and dataTable
      var DT = $elem.DataTable(options);
      var dt = $elem.dataTable();

      var result = {
        id: $elem.attr("id"),
        DataTable: DT,
        dataTable: dt
      };

      postRender(options, result);

      return result;
    }

    function hideLoadingAndRenderDataTable($elem, options) {
      rendererService.hideLoading($elem);
      return rendererService.renderDataTable($elem, options);
    }

    function registerPlugin(plugin) {
      plugins.push(plugin);
    }

    function postRender(options, result) {
      angular.forEach(plugins, function (plugin) {
        if (angular.isFunction(plugin.postRender)) {
          plugin.postRender(options, result);
        }
      });
    }

    function preRender(options) {
      angular.forEach(plugins, function (plugin) {
        if (angular.isFunction(plugin.preRender)) {
          plugin.preRender(options);
        }
      });
    }
  }

  dtRendererService.$inject = ["DTLoadingTemplate"];

  function dtRenderer() {
    return {
      withOptions: function (options) {
        this.options = options;
        return this;
      }
    };
  }

  /* @ngInject */
  function dtDefaultRenderer($q, DTRenderer, DTRendererService, DTInstanceFactory, DTInstances) {
    return {
      create: create
    };

    function create(options) {
      var _oTable;
      var _$elem;
      var renderer = Object.create(DTRenderer);
      renderer.name = "DTDefaultRenderer";
      renderer.options = options;
      renderer.render = render;
      renderer.reloadData = reloadData;
      renderer.changeData = changeData;
      renderer.rerender = rerender;

      function render($elem) {
        _$elem = $elem;
        var dtInstance = DTInstanceFactory.newDTInstance(renderer);
        var result = DTRendererService.hideLoadingAndRenderDataTable($elem, renderer.options);
        _oTable = result.DataTable;
        return $q.when(DTInstances.register(dtInstance, result));
      }

      function reloadData() {
        // Do nothing
      }

      function changeData() {
        // Do nothing
      }

      function rerender() {
        _oTable.destroy();
        DTRendererService.showLoading(_$elem);
        render(_$elem);
      }

      return renderer;
    }
  }

  dtDefaultRenderer.$inject = ["$q", "DTRenderer", "DTRendererService", "DTInstanceFactory", "DTInstances"];

  /* @ngInject */
  function dtNGRenderer($log, $q, $compile, $timeout, DTRenderer, DTRendererService, DTInstances, DTInstanceFactory) {
    /**
     * Renderer for displaying the Angular way
     * @param options
     * @returns {{options: *}} the renderer
     * @constructor
     */
    return {
      create: create
    };

    function create(options) {
      var _staticHTML;
      var _oTable;
      var _$elem;
      var _parentScope;
      var dtInstance;
      var renderer = Object.create(DTRenderer);
      renderer.name = "DTNGRenderer";
      renderer.options = options;
      renderer.render = render;
      renderer.reloadData = reloadData;
      renderer.changeData = changeData;
      renderer.rerender = rerender;
      return renderer;

      function render($elem, $scope, staticHTML) {

        _staticHTML = staticHTML;
        _$elem = $elem;
        _parentScope = $scope.$parent;
        dtInstance = DTInstanceFactory.newDTInstance(renderer);

        var defer = $q.defer();
        var _expression = $elem.find("tbody").html();
        // Find the resources from the comment <!-- ngRepeat: item in items --> displayed by angular in the DOM
        // This regexp is inspired by the one used in the "ngRepeat" directive
        var _match = _expression.match(/^\s*.+?\s+in\s+(\S*)\s*/m);

        if (!_match) {
          throw new Error("Expected expression in form of \"_item_ in _collection_[ track by _id_]\" but got \"{0}\".", _expression);
        }
        var _ngRepeatAttr = _match[1];

        var _alreadyRendered = false;

        _parentScope.$watchCollection(_ngRepeatAttr, function () {
          if (_oTable && _alreadyRendered) {
            _destroyAndCompile();
          }
          $timeout(function () {
            _alreadyRendered = true;
            var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
            _oTable = result.DataTable;
            defer.resolve(DTInstances.register(dtInstance, result));
          }, 0, false);
        }, true);
        return defer.promise;
      }

      function reloadData() {
        $log.warn("The Angular Renderer does not support reloading data. You need to do it directly on your model");
      }

      function changeData() {
        $log.warn("The Angular Renderer does not support changing the data. You need to change your model directly.");
      }

      function rerender() {

        _destroyAndCompile();
        DTRendererService.showLoading(_$elem);
        $timeout(function () {
          var result = DTRendererService.hideLoadingAndRenderDataTable(_$elem, renderer.options);
          _oTable = result.DataTable;
          dtInstance = DTInstances.register(dtInstance, result);
        }, 0, false);
      }

      function _destroyAndCompile() {
        _oTable.ngDestroy();
        // Re-compile because we lost the angular binding to the existing data
        _$elem.html(_staticHTML);
        $compile(_$elem.contents())(_parentScope);
      }
    }
  }

  dtNGRenderer.$inject = ["$log", "$q", "$compile", "$timeout", "DTRenderer", "DTRendererService", "DTInstances", "DTInstanceFactory"];

  /* @ngInject */
  function dtPromiseRenderer($q, $timeout, $log, DTRenderer, DTRendererService, DTInstances, DTInstanceFactory) {
    /**
     * Renderer for displaying with a promise
     * @param options the options
     * @returns {{options: *}} the renderer
     * @constructor
     */
    return {
      create: create
    };

    function create(options) {
      var _oTable;
      var _loadedPromise = null;
      var _$elem;

      var dtInstance;
      var renderer = Object.create(DTRenderer);
      renderer.name = "DTPromiseRenderer";
      renderer.options = options;
      renderer.render = render;
      renderer.reloadData = reloadData;
      renderer.changeData = changeData;
      renderer.rerender = rerender;
      return renderer;

      function render($elem) {
        var defer = $q.defer();
        dtInstance = DTInstanceFactory.newDTInstance(renderer);

        _$elem = $elem;
        _resolve(renderer.options.fnPromise, DTRendererService.renderDataTable).then(function (result) {
          _oTable = result.DataTable;

          defer.resolve(DTInstances.register(dtInstance, result));

        });

        return defer.promise;
      }

      function reloadData(callback, resetPaging) {
        var previousPage = _oTable && _oTable.page() ? _oTable.page() : 0;
        if (angular.isFunction(renderer.options.fnPromise)) {
          _resolve(renderer.options.fnPromise, _redrawRows).then(function (result) {
            if (angular.isFunction(callback)) {
              callback(result.DataTable.data());
            }
            if (resetPaging === false) {
              result.DataTable.page(previousPage).draw(false);
            }
          });
        } else {
          $log.warn("In order to use the reloadData functionality with a Promise renderer, you need to provide a function that returns a promise.");
        }
      }

      function changeData(fnPromise) {
        renderer.options.fnPromise = fnPromise;
        _resolve(renderer.options.fnPromise, _redrawRows);
      }

      function rerender() {
        _oTable.destroy();
        DTRendererService.showLoading(_$elem);
        render(_$elem);
      }

      function _resolve(fnPromise, callback) {
        var defer = $q.defer();
        if (angular.isUndefined(fnPromise)) {
          throw new Error("You must provide a promise or a function that returns a promise!");
        }
        if (_loadedPromise) {
          _loadedPromise.then(function () {
            defer.resolve(_startLoading(fnPromise, callback));
          });
        } else {
          defer.resolve(_startLoading(fnPromise, callback));
        }
        return defer.promise;
      }

      function _startLoading(fnPromise, callback) {
        var defer = $q.defer();
        if (angular.isFunction(fnPromise)) {
          _loadedPromise = fnPromise();
        } else {
          _loadedPromise = fnPromise;
        }
        _loadedPromise.then(function (result) {
          var data = result;
          // In case the data is nested in an object
          if (renderer.options.sAjaxDataProp) {
            var properties = renderer.options.sAjaxDataProp.split(".");
            while (properties.length) {
              var property = properties.shift();
              if (property in data) {
                data = data[property];
              }
            }
          }
          _loadedPromise = null;
          defer.resolve(_doRender(renderer.options, _$elem, data, callback));
        });
        return defer.promise;
      }

      function _doRender(options, $elem, data, callback) {
        var defer = $q.defer();
        // Since Angular 1.3, the promise renderer is throwing "Maximum call stack size exceeded"
        // By removing the $promise attribute, we avoid an infinite loop when jquery is cloning the data
        // See https://github.com/l-lin/angular-datatables/issues/110
        delete data.$promise;
        options.aaData = data;
        // Add $timeout to be sure that angular has finished rendering before calling datatables
        $timeout(function () {
          DTRendererService.hideLoading($elem);
          // Set it to true in order to be able to redraw the dataTable
          options.bDestroy = true;
          defer.resolve(callback($elem, options));
        }, 0, false);
        return defer.promise;
      }

      function _redrawRows() {
        _oTable.clear();
        _oTable.rows.add(options.aaData).draw(options.redraw);
        return {
          id: dtInstance.id,
          DataTable: dtInstance.DataTable,
          dataTable: dtInstance.dataTable
        };
      }
    }
  }

  dtPromiseRenderer.$inject = ["$q", "$timeout", "$log", "DTRenderer", "DTRendererService", "DTInstances", "DTInstanceFactory"];

  /* @ngInject */
  function dtAjaxRenderer($q, $timeout, DTRenderer, DTRendererService, DT_DEFAULT_OPTIONS, DTInstances, DTInstanceFactory) {
    /**
     * Renderer for displaying with Ajax
     * @param options the options
     * @returns {{options: *}} the renderer
     * @constructor
     */
    return {
      create: create
    };

    function create(options) {
      var _oTable;
      var _$elem;
      var renderer = Object.create(DTRenderer);
      renderer.name = "DTAjaxRenderer";
      renderer.options = options;
      renderer.render = render;
      renderer.reloadData = reloadData;
      renderer.changeData = changeData;
      renderer.rerender = rerender;
      return renderer;

      function render($elem) {
        _$elem = $elem;
        var defer = $q.defer();
        var dtInstance = DTInstanceFactory.newDTInstance(renderer);
        // Define default values in case it is an ajax datatables
        if (angular.isUndefined(renderer.options.sAjaxDataProp)) {
          renderer.options.sAjaxDataProp = DT_DEFAULT_OPTIONS.sAjaxDataProp;
        }
        if (angular.isUndefined(renderer.options.aoColumns)) {
          renderer.options.aoColumns = DT_DEFAULT_OPTIONS.aoColumns;
        }
        _doRender(renderer.options, $elem).then(function (result) {
          _oTable = result.DataTable;
          defer.resolve(DTInstances.register(dtInstance, result));
        });
        return defer.promise;
      }

      function reloadData(callback, resetPaging) {
        if (_oTable) {
          _oTable.ajax.reload(callback, resetPaging);
        }
      }

      function changeData(ajax) {
        renderer.options.ajax = ajax;
        if (_oTable) {
          var ajaxUrl = renderer.options.ajax.url || renderer.options.ajax;
          _oTable.ajax.url(ajaxUrl).load();
        }
      }

      function rerender() {
        _oTable.destroy();
        DTRendererService.showLoading(_$elem);
        render(_$elem);
      }

      function _doRender(options, $elem) {
        var defer = $q.defer();
        // Set it to true in order to be able to redraw the dataTable
        options.bDestroy = true;
        DTRendererService.hideLoading($elem);
        // Condition to refresh the dataTable
        if (_shouldDeferRender(options)) {
          $timeout(function () {
            defer.resolve(DTRendererService.renderDataTable($elem, options));
          }, 0, false);
        } else {
          defer.resolve(DTRendererService.renderDataTable($elem, options));
        }
        return defer.promise;
      }

      // See https://github.com/l-lin/angular-datatables/issues/147
      function _shouldDeferRender(options) {
        if (angular.isDefined(options) && angular.isDefined(options.dom)) {
          // S for scroller plugin
          return options.dom.indexOf("S") >= 0;
        }
        return false;
      }
    }
  }

  dtAjaxRenderer.$inject = ["$q", "$timeout", "DTRenderer", "DTRendererService", "DT_DEFAULT_OPTIONS", "DTInstances", "DTInstanceFactory"];

  /* @ngInject */
  function dtRendererFactory(DTDefaultRenderer, DTNGRenderer, DTPromiseRenderer, DTAjaxRenderer) {
    return {
      fromOptions: fromOptions
    };

    function fromOptions(options, isNgDisplay) {
      if (isNgDisplay) {
        return DTNGRenderer.create(options);
      }
      if (angular.isDefined(options)) {
        if (angular.isDefined(options.fnPromise) && options.fnPromise !== null) {
          return DTPromiseRenderer.create(options);
        }
        if (angular.isDefined(options.ajax) && options.ajax !== null ||
          angular.isDefined(options.ajax) && options.ajax !== null) {
          return DTAjaxRenderer.create(options);
        }
        return DTDefaultRenderer.create(options);
      }
      return DTDefaultRenderer.create();
    }
  }

  dtRendererFactory.$inject = ["DTDefaultRenderer", "DTNGRenderer", "DTPromiseRenderer", "DTAjaxRenderer"];

  "use strict";

  angular.module("datatables.util", [])
    .factory("DTPropertyUtil", dtPropertyUtil)
    // TODO: Remove this service when the DTInstances service is removed!
    .service("failzQ", failzQ);

  /* @ngInject */
  function dtPropertyUtil($q) {
    return {
      overrideProperties: overrideProperties,
      deleteProperty: deleteProperty,
      resolveObjectPromises: resolveObjectPromises,
      resolveArrayPromises: resolveArrayPromises
    };

    /**
     * Overrides the source property with the given target properties.
     * Source is not written. It's making a fresh copy of it in order to ensure that we do not change the parameters.
     * @param source the source properties to override
     * @param target the target properties
     * @returns {*} the object overrided
     */
    function overrideProperties(source, target) {
      var result = angular.copy(source);

      if (angular.isUndefined(result) || result === null) {
        result = {};
      }
      if (angular.isUndefined(target) || target === null) {
        return result;
      }
      if (angular.isObject(target)) {
        for (var prop in target) {
          if (target.hasOwnProperty(prop)) {
            result[prop] = overrideProperties(result[prop], target[prop]);
          }
        }
      } else {
        result = angular.copy(target);
      }
      return result;
    }

    /**
     * Delete the property from the given object
     * @param obj the object
     * @param propertyName the property name
     */
    function deleteProperty(obj, propertyName) {
      if (angular.isObject(obj)) {
        delete obj[propertyName];
      }
    }

    /**
     * Resolve any promises from a given object if there are any.
     * @param obj the object
     * @param excludedPropertiesName the list of properties to ignore
     * @returns {promise} the promise that the object attributes promises are all resolved
     */
    function resolveObjectPromises(obj, excludedPropertiesName) {
      var defer = $q.defer(),
        promises = [],
        resolvedObj = {},
        excludedProp = excludedPropertiesName || [];
      if (!angular.isObject(obj) || angular.isArray(obj)) {
        defer.resolve(obj);
      } else {
        resolvedObj = angular.extend(resolvedObj, obj);
        for (var prop in resolvedObj) {
          if (resolvedObj.hasOwnProperty(prop) && $.inArray(prop, excludedProp) === -1) {
            if (angular.isArray(resolvedObj[prop])) {
              promises.push(resolveArrayPromises(resolvedObj[prop]));
            } else {
              promises.push($q.when(resolvedObj[prop]));
            }
          }
        }
        $q.all(promises).then(function (result) {
          var index = 0;
          for (var prop in resolvedObj) {
            if (resolvedObj.hasOwnProperty(prop) && $.inArray(prop, excludedProp) === -1) {
              resolvedObj[prop] = result[index++];
            }
          }
          defer.resolve(resolvedObj);
        });
      }
      return defer.promise;
    }

    /**
     * Resolve the given array promises
     * @param array the array containing promise or not
     * @returns {promise} the promise that the array contains a list of objects/values promises that are resolved
     */
    function resolveArrayPromises(array) {
      var defer = $q.defer(),
        promises = [],
        resolveArray = [];
      if (!angular.isArray(array)) {
        defer.resolve(array);
      } else {
        angular.forEach(array, function (item) {
          if (angular.isObject(item)) {
            promises.push(resolveObjectPromises(item));
          } else {
            promises.push($q.when(item));
          }
        });
        $q.all(promises).then(function (result) {
          angular.forEach(result, function (item) {
            resolveArray.push(item);
          });
          defer.resolve(resolveArray);
        });
      }
      return defer.promise;
    }
  }

  dtPropertyUtil.$inject = ["$q"];

  /* @ngInject */
  function failzQ($q, $timeout) {

    var DEFAULT_TIME = 1000;
    /**
     * failzQ wrap a promise and reject the promise if not resolved with a given time
     */
    return function (promise, time) {
      var defer = $q.defer();
      var t = time || DEFAULT_TIME;

      $timeout(function () {
        defer.reject("Not resolved within " + t);
      }, t);

      $q.when(promise).then(function (result) {
        defer.resolve(result);
      }, function (failure) {
        defer.reject(failure);
      });
      return defer.promise;
    };
  }

  failzQ.$inject = ["$q", "$timeout"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";
  angular.module("datatables.bootstrap.colvis", ["datatables.bootstrap.options", "datatables.util"])
    .service("DTBootstrapColVis", dtBootstrapColVis);

  /* @ngInject */
  function dtBootstrapColVis(DTPropertyUtil, DTBootstrapDefaultOptions) {
    var _initializedColVis = false;
    return {
      integrate: integrate,
      deIntegrate: deIntegrate
    };

    function integrate(addDrawCallbackFunction, bootstrapOptions) {
      if (!_initializedColVis) {
        var colVisProperties = DTPropertyUtil.overrideProperties(
          DTBootstrapDefaultOptions.getOptions().ColVis,
          bootstrapOptions ? bootstrapOptions.ColVis : null
        );
        /* ColVis Bootstrap compatibility */
        if ($.fn.DataTable.ColVis) {
          addDrawCallbackFunction(function () {
            $(".ColVis_MasterButton").attr("class", "ColVis_MasterButton " + colVisProperties.classes.masterButton);
            $(".ColVis_Button").removeClass("ColVis_Button");
          });
        }

        _initializedColVis = true;
      }
    }

    function deIntegrate() {
      if (_initializedColVis && $.fn.DataTable.ColVis) {
        _initializedColVis = false;
      }
    }
  }
  dtBootstrapColVis.$inject = ["DTPropertyUtil", "DTBootstrapDefaultOptions"];

  "use strict";

  // See http://getbootstrap.com
  angular.module("datatables.bootstrap", [
    "datatables.bootstrap.options",
    "datatables.bootstrap.tabletools",
    "datatables.bootstrap.colvis"
  ])
    .config(dtBootstrapConfig)
    .run(initBootstrapPlugin)
    .service("DTBootstrap", dtBootstrap);

  /* @ngInject */
  function dtBootstrapConfig($provide) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withBootstrap = withBootstrap;
        options.withBootstrapOptions = withBootstrapOptions;
        return options;

        /**
             * Add bootstrap compatibility
             * @returns {DTOptions} the options
             */
        function withBootstrap() {
          options.hasBootstrap = true;
          // Override page button active CSS class
          if (angular.isObject(options.oClasses)) {
            options.oClasses.sPageButtonActive = "active";
          } else {
            options.oClasses = {
              sPageButtonActive: "active"
            };
          }
          return options;
        }

        /**
             * Add bootstrap options
             * @param bootstrapOptions the bootstrap options
             * @returns {DTOptions} the options
             */
        function withBootstrapOptions(bootstrapOptions) {
          options.bootstrap = bootstrapOptions;
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtBootstrapConfig.$inject = ["$provide"];

  /* @ngInject */
  function initBootstrapPlugin(DTRendererService, DTBootstrap) {
    var columnFilterPlugin = {
      preRender: preRender
    };
    DTRendererService.registerPlugin(columnFilterPlugin);

    function preRender(options) {
      // Integrate bootstrap (or not)
      if (options && options.hasBootstrap) {
        DTBootstrap.integrate(options);
      } else {
        DTBootstrap.deIntegrate();
      }
    }
  }
  initBootstrapPlugin.$inject = ["DTRendererService", "DTBootstrap"];

  /**
 * Source: https://editor.datatables.net/release/DataTables/extras/Editor/examples/bootstrap.html
 */
  /* @ngInject */
  function dtBootstrap(DTBootstrapTableTools, DTBootstrapColVis, DTBootstrapDefaultOptions, DTPropertyUtil, DT_DEFAULT_OPTIONS) {
    var _initialized = false,
      _drawCallbackFunctionList = [],
      _savedFn = {};

    return {
      integrate: integrate,
      deIntegrate: deIntegrate
    };

    function _saveFnToBeOverrided() {
      _savedFn.oStdClasses = angular.copy($.fn.dataTableExt.oStdClasses);
      _savedFn.fnPagingInfo = $.fn.dataTableExt.oApi.fnPagingInfo;
      _savedFn.renderer = angular.copy($.fn.DataTable.ext.renderer);
      if ($.fn.DataTable.TableTools) {
        _savedFn.TableTools = {
          classes: angular.copy($.fn.DataTable.TableTools.classes),
          oTags: angular.copy($.fn.DataTable.TableTools.DEFAULTS.oTags)
        };
      }
    }

    function _revertToDTFn() {
      $.extend($.fn.dataTableExt.oStdClasses, _savedFn.oStdClasses);
      $.fn.dataTableExt.oApi.fnPagingInfo = _savedFn.fnPagingInfo;
      $.extend(true, $.fn.DataTable.ext.renderer, _savedFn.renderer);
    }

    function _overrideClasses() {
      /* Default class modification */
      $.extend($.fn.dataTableExt.oStdClasses, {
        "sWrapper": "dataTables_wrapper form-inline",
        "sFilterInput": "form-control input-sm",
        "sLengthSelect": "form-control input-sm",
        "sFilter": "dataTables_filter",
        "sLength": "dataTables_length"
      });
    }

    function _overridePagingInfo() {
      /* API method to get paging information */
      $.fn.dataTableExt.oApi.fnPagingInfo = function (oSettings) {
        return {
          "iStart": oSettings._iDisplayStart,
          "iEnd": oSettings.fnDisplayEnd(),
          "iLength": oSettings._iDisplayLength,
          "iTotal": oSettings.fnRecordsTotal(),
          "iFilteredTotal": oSettings.fnRecordsDisplay(),
          "iPage": oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength),
          "iTotalPages": oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)
        };
      };
    }

    function _overridePagination(bootstrapOptions) {
      // Note: Copy paste with some changes from DataTables v1.10.1 source code
      $.extend(true, $.fn.DataTable.ext.renderer, {
        pageButton: {
          _: function (settings, host, idx, buttons, page, pages) {
            var classes = settings.oClasses;
            var lang = settings.language ? settings.language.oPaginate : settings.oLanguage.oPaginate;
            var btnDisplay, btnClass, counter = 0;
            var paginationClasses = DTPropertyUtil.overrideProperties(
              DTBootstrapDefaultOptions.getOptions().pagination,
              bootstrapOptions ? bootstrapOptions.pagination : null
            );
            var $paginationContainer = $("<ul></ul>", {
              "class": paginationClasses.classes.ul
            });

            var attach = function (container, buttons) {
              var i, ien, node, button;
              var clickHandler = function (e) {
                e.preventDefault();
                // IMPORTANT: Reference to internal functions of DT. It might change between versions
                $.fn.DataTable.ext.internal._fnPageChange(settings, e.data.action, true);
              };

              for (i = 0, ien = buttons.length; i < ien; i++) {
                button = buttons[i];

                if ($.isArray(button)) {
                  // Override DT element
                  button.DT_el = "li";
                  var inner = $("<" + (button.DT_el || "div") + "/>")
                    .appendTo($paginationContainer);
                  attach(inner, button);
                } else {
                  btnDisplay = "";
                  btnClass = "";
                  var $paginationBtn = $("<li></li>"),
                    isDisabled;

                  switch (button) {
                    case "ellipsis":
                      $paginationContainer.append("<li class=\"disabled\"><a href=\"#\" onClick=\"event.preventDefault()\">&hellip;</a></li>");
                      break;

                    case "first":
                      btnDisplay = lang.sFirst;
                      btnClass = button;
                      if (page <= 0) {
                        $paginationBtn.addClass(classes.sPageButtonDisabled);
                        isDisabled = true;
                      }
                      break;

                    case "previous":
                      btnDisplay = lang.sPrevious;
                      btnClass = button;
                      if (page <= 0) {
                        $paginationBtn.addClass(classes.sPageButtonDisabled);
                        isDisabled = true;
                      }
                      break;

                    case "next":
                      btnDisplay = lang.sNext;
                      btnClass = button;
                      if (page >= pages - 1) {
                        $paginationBtn.addClass(classes.sPageButtonDisabled);
                        isDisabled = true;
                      }
                      break;

                    case "last":
                      btnDisplay = lang.sLast;
                      btnClass = button;
                      if (page >= pages - 1) {
                        $paginationBtn.addClass(classes.sPageButtonDisabled);
                        isDisabled = true;
                      }
                      break;

                    default:
                      btnDisplay = button + 1;
                      btnClass = "";
                      if (page === button) {
                        $paginationBtn.addClass(classes.sPageButtonActive);
                      }
                      break;
                  }

                  if (btnDisplay) {
                    $paginationBtn.appendTo($paginationContainer);
                    node = $("<a>", {
                      "href": "#",
                      "class": btnClass,
                      "aria-controls": settings.sTableId,
                      "data-dt-idx": counter,
                      "tabindex": settings.iTabIndex,
                      "id": idx === 0 && typeof button === "string" ?
                        settings.sTableId + "_" + button : null
                    })
                      .html(btnDisplay)
                      .appendTo($paginationBtn);

                    // IMPORTANT: Reference to internal functions of DT. It might change between versions
                    $.fn.DataTable.ext.internal._fnBindAction(
                      node, {
                        action: button
                      }, clickHandler
                    );

                    counter++;
                  }
                }
              }
            };

            // IE9 throws an 'unknown error' if document.activeElement is used
            // inside an iframe or frame. Try / catch the error. Not good for
            // accessibility, but neither are frames.
            try {
              // Because this approach is destroying and recreating the paging
              // elements, focus is lost on the select button which is bad for
              // accessibility. So we want to restore focus once the draw has
              // completed
              var activeEl = $(document.activeElement).data("dt-idx");

              // Add <ul> to the pagination
              var container = $(host).empty();
              $paginationContainer.appendTo(container);
              attach(container, buttons);

              if (activeEl !== null) {
                $(host).find("[data-dt-idx=" + activeEl + "]").focus();
              }
            } catch (e) {}
          }
        }
      });
    }

    function _addDrawCallbackFunction(fn) {
      if (angular.isFunction(fn)) {
        _drawCallbackFunctionList.push(fn);
      }
    }

    function _init(bootstrapOptions) {
      if (!_initialized) {
        _saveFnToBeOverrided();
        _overrideClasses();
        _overridePagingInfo();
        _overridePagination(bootstrapOptions);

        _addDrawCallbackFunction(function () {
          $("div.dataTables_filter").find("input").addClass("form-control");
          $("div.dataTables_length").find("select").addClass("form-control");
        });

        _initialized = true;
      }
    }

    function _setDom(options) {
      if (!options.dom || options.dom === DT_DEFAULT_OPTIONS.dom) {
        return DTBootstrapDefaultOptions.getOptions().dom;
      }
      return options.dom;
    }
    /**
         * Integrate Bootstrap
         * @param options the datatables options
         */
    function integrate(options) {
      _init(options.bootstrap);
      DTBootstrapTableTools.integrate(options.bootstrap);
      DTBootstrapColVis.integrate(_addDrawCallbackFunction, options.bootstrap);

      options.dom = _setDom(options);
      if (angular.isUndefined(options.fnDrawCallback)) {
        // Call every drawcallback functions
        options.fnDrawCallback = function () {
          for (var index = 0; index < _drawCallbackFunctionList.length; index++) {
            _drawCallbackFunctionList[index]();
          }
        };
      }
    }

    function deIntegrate() {
      if (_initialized) {
        _revertToDTFn();
        DTBootstrapTableTools.deIntegrate();
        DTBootstrapColVis.deIntegrate();
        _initialized = false;
      }
    }
  }
  dtBootstrap.$inject = ["DTBootstrapTableTools", "DTBootstrapColVis", "DTBootstrapDefaultOptions", "DTPropertyUtil", "DT_DEFAULT_OPTIONS"];

  "use strict";
  angular.module("datatables.bootstrap.options", ["datatables.options", "datatables.util"])
    .constant("DT_BOOTSTRAP_DEFAULT_OPTIONS", {
      TableTools: {
        classes: {
          container: "DTTT btn-group",
          buttons: {
            normal: "btn btn-default",
            disabled: "disabled"
          },
          collection: {
            container: "DTTT_dropdown dropdown-menu",
            buttons: {
              normal: "",
              disabled: "disabled"
            }
          },
          print: {
            info: "DTTT_print_info modal"
          },
          select: {
            row: "active"
          }
        },
        DEFAULTS: {
          oTags: {
            collection: {
              container: "ul",
              button: "li",
              liner: "a"
            }
          }
        }
      },
      ColVis: {
        classes: {
          masterButton: "btn btn-default"
        }
      },
      pagination: {
        classes: {
          ul: "pagination"
        }
      },
      dom: "<'row'<'col-xs-6'l><'col-xs-6'f>r>t<'row'<'col-xs-6'i><'col-xs-6'p>>"
    })
    .factory("DTBootstrapDefaultOptions", dtBootstrapDefaultOptions);

  /* @ngInject */
  function dtBootstrapDefaultOptions(DTDefaultOptions, DTPropertyUtil, DT_BOOTSTRAP_DEFAULT_OPTIONS) {
    return {
      getOptions: getOptions
    };
    /**
     * Get the default options for bootstrap integration
     * @returns {*} the bootstrap default options
     */
    function getOptions() {
      return DTPropertyUtil.overrideProperties(DT_BOOTSTRAP_DEFAULT_OPTIONS, DTDefaultOptions.bootstrapOptions);
    }
  }
  dtBootstrapDefaultOptions.$inject = ["DTDefaultOptions", "DTPropertyUtil", "DT_BOOTSTRAP_DEFAULT_OPTIONS"];

  "use strict";

  angular.module("datatables.bootstrap.tabletools", ["datatables.bootstrap.options", "datatables.util"])
    .service("DTBootstrapTableTools", dtBootstrapTableTools);

  /* @ngInject */
  function dtBootstrapTableTools(DTPropertyUtil, DTBootstrapDefaultOptions) {
    var _initializedTableTools = false,
      _savedFn = {};

    return {
      integrate: integrate,
      deIntegrate: deIntegrate
    };

    function integrate(bootstrapOptions) {
      if (!_initializedTableTools) {
        _saveFnToBeOverrided();

        /*
             * TableTools Bootstrap compatibility
             * Required TableTools 2.1+
             */
        if ($.fn.DataTable.TableTools) {
          var tableToolsOptions = DTPropertyUtil.overrideProperties(
            DTBootstrapDefaultOptions.getOptions().TableTools,
            bootstrapOptions ? bootstrapOptions.TableTools : null
          );
          // Set the classes that TableTools uses to something suitable for Bootstrap
          $.extend(true, $.fn.DataTable.TableTools.classes, tableToolsOptions.classes);

          // Have the collection use a bootstrap compatible dropdown
          $.extend(true, $.fn.DataTable.TableTools.DEFAULTS.oTags, tableToolsOptions.DEFAULTS.oTags);
        }

        _initializedTableTools = true;
      }
    }

    function deIntegrate() {
      if (_initializedTableTools && $.fn.DataTable.TableTools && _savedFn.TableTools) {
        $.extend(true, $.fn.DataTable.TableTools.classes, _savedFn.TableTools.classes);
        $.extend(true, $.fn.DataTable.TableTools.DEFAULTS.oTags, _savedFn.TableTools.oTags);
        _initializedTableTools = false;
      }
    }

    function _saveFnToBeOverrided() {
      if ($.fn.DataTable.TableTools) {
        _savedFn.TableTools = {
          classes: angular.copy($.fn.DataTable.TableTools.classes),
          oTags: angular.copy($.fn.DataTable.TableTools.DEFAULTS.oTags)
        };
      }
    }
  }
  dtBootstrapTableTools.$inject = ["DTPropertyUtil", "DTBootstrapDefaultOptions"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See https://datatables.net/extras/colreorder/
  angular.module("datatables.colreorder", ["datatables"])
    .config(dtColReorderConfig);

  /* @ngInject */
  function dtColReorderConfig($provide, DT_DEFAULT_OPTIONS) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withColReorder = withColReorder;
        options.withColReorderOption = withColReorderOption;
        options.withColReorderOrder = withColReorderOrder;
        options.withColReorderCallback = withColReorderCallback;
        return options;

        /**
             * Add colReorder compatibility
             * @returns {DTOptions} the options
             */
        function withColReorder() {
          var colReorderPrefix = "R";
          options.dom = options.dom ? options.dom : DT_DEFAULT_OPTIONS.dom;
          if (options.dom.indexOf(colReorderPrefix) === -1) {
            options.dom = colReorderPrefix + options.dom;
          }
          options.hasColReorder = true;
          return options;
        }

        /**
             * Add option to "oColReorder" option
             * @param key the key of the option to add
             * @param value an object or a function of the function
             * @return {DTOptions} the options
             */
        function withColReorderOption(key, value) {
          if (angular.isString(key)) {
            options.oColReorder = options.oColReorder && options.oColReorder !== null ? options.oColReorder : {};
            options.oColReorder[key] = value;
          }
          return options;
        }

        /**
             * Set the default column order
             * @param aiOrder the column order
             * @returns {DTOptions} the options
             */
        function withColReorderOrder(aiOrder) {
          if (angular.isArray(aiOrder)) {
            options.withColReorderOption("aiOrder", aiOrder);
          }
          return options;
        }

        /**
             * Set the reorder callback function
             * @param fnReorderCallback the callback
             * @returns {DTOptions} the options
             */
        function withColReorderCallback(fnReorderCallback) {
          if (angular.isFunction(fnReorderCallback)) {
            options.withColReorderOption("fnReorderCallback", fnReorderCallback);
          } else {
            throw new Error("The reorder callback must be a function");
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtColReorderConfig.$inject = ["$provide", "DT_DEFAULT_OPTIONS"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See http://jquery-datatables-column-filter.googlecode.com/svn/trunk/index.html
  angular.module("datatables.columnfilter", ["datatables"])
    .config(dtColumnFilterConfig)
    .run(initColumnFilterPlugin);

  /* @ngInject */
  function dtColumnFilterConfig($provide) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withColumnFilter = withColumnFilter;
        return options;

        /**
             * Add column filter support
             * @param columnFilterOptions the plugins options
             * @returns {DTOptions} the options
             */
        function withColumnFilter(columnFilterOptions) {
          options.hasColumnFilter = true;
          if (columnFilterOptions) {
            options.columnFilterOptions = columnFilterOptions;
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtColumnFilterConfig.$inject = ["$provide"];

  /* @ngInject */
  function initColumnFilterPlugin(DTRendererService) {
    var columnFilterPlugin = {
      postRender: postRender
    };
    DTRendererService.registerPlugin(columnFilterPlugin);

    function postRender(options, result) {
      if (options && options.hasColumnFilter) {
        result.dataTable.columnFilter(options.columnFilterOptions);
      }
    }
  }
  initColumnFilterPlugin.$inject = ["DTRendererService"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See https://datatables.net/extras/colvis/
  angular.module("datatables.colvis", ["datatables"])
    .config(dtColVisConfig);

  /* @ngInject */
  function dtColVisConfig($provide, DT_DEFAULT_OPTIONS) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withColVis = withColVis;
        options.withColVisOption = withColVisOption;
        options.withColVisStateChange = withColVisStateChange;
        return options;

        /**
             * Add colVis compatibility
             * @returns {DTOptions} the options
             */
        function withColVis() {
          var colVisPrefix = "C";
          options.dom = options.dom ? options.dom : DT_DEFAULT_OPTIONS.dom;
          if (options.dom.indexOf(colVisPrefix) === -1) {
            options.dom = colVisPrefix + options.dom;
          }
          options.hasColVis = true;
          return options;
        }

        /**
             * Add option to "oColVis" option
             * @param key the key of the option to add
             * @param value an object or a function of the function
             * @returns {DTOptions} the options
             */
        function withColVisOption(key, value) {
          if (angular.isString(key)) {
            options.oColVis = options.oColVis && options.oColVis !== null ? options.oColVis : {};
            options.oColVis[key] = value;
          }
          return options;
        }

        /**
             * Set the state change function
             * @param fnStateChange  the state change function
             * @returns {DTOptions} the options
             */
        function withColVisStateChange(fnStateChange) {
          if (angular.isFunction(fnStateChange)) {
            options.withColVisOption("fnStateChange", fnStateChange);
          } else {
            throw new Error("The state change must be a function");
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtColVisConfig.$inject = ["$provide", "DT_DEFAULT_OPTIONS"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See https://datatables.net/extensions/fixedcolumns/
  angular.module("datatables.fixedcolumns", ["datatables"])
    .config(dtFixedColumnsConfig)
    .run(initFixedColumnsPlugin);

  /* @ngInject */
  function dtFixedColumnsConfig($provide) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withFixedColumns = withFixedColumns;
        return options;

        /**
             * Add fixed columns support
             * @param fixedColumnsOptions the plugin options
             * @returns {DTOptions} the options
             */
        function withFixedColumns(fixedColumnsOptions) {
          options.hasFixedColumns = true;
          if (fixedColumnsOptions) {
            options.fixedColumnsOptions = fixedColumnsOptions;
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtFixedColumnsConfig.$inject = ["$provide"];

  /* @ngInject */
  function initFixedColumnsPlugin(DTRendererService) {
    var fixedColumnsPlugin = {
      postRender: postRender
    };
    DTRendererService.registerPlugin(fixedColumnsPlugin);

    function postRender(options, result) {
      if (options && options.hasFixedColumns) {
        new $.fn.dataTable.FixedColumns(result.DataTable, options.fixedColumnsOptions);
      }
    }
  }
  initFixedColumnsPlugin.$inject = ["DTRendererService"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See https://datatables.net/extensions/fixedheader/
  angular.module("datatables.fixedheader", ["datatables"])
    .config(dtFixedHeaderConfig)
    .run(initFixedHeaderPlugin);

  /* @ngInject */
  function dtFixedHeaderConfig($provide) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withFixedHeader = withFixedHeader;
        return options;

        /**
             * Add fixed header support
             * @param fixedHeaderOptions the plugin options
             * @returns {DTOptions} the options
             */
        function withFixedHeader(fixedHeaderOptions) {
          options.hasFixedHeader = true;
          if (fixedHeaderOptions) {
            options.fixedHeaderOptions = fixedHeaderOptions;
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtFixedHeaderConfig.$inject = ["$provide"];

  /* @ngInject */
  function initFixedHeaderPlugin(DTRendererService) {
    var fixedHeaderPlugin = {
      postRender: postRender
    };
    DTRendererService.registerPlugin(fixedHeaderPlugin);

    function postRender(options, result) {
      if (options && options.hasFixedHeader) {
        new $.fn.dataTable.FixedHeader(result.DataTable, options.fixedHeaderOptions);
      }
    }
  }
  initFixedHeaderPlugin.$inject = ["DTRendererService"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See http://datatables.net/extensions/scroller/
  angular.module("datatables.scroller", ["datatables"])
    .config(dtScrollerConfig);

  /* @ngInject */
  function dtScrollerConfig($provide, DT_DEFAULT_OPTIONS) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withScroller = withScroller;
        return options;

        /**
             * Add scroller compatibility
             * @returns {DTOptions} the options
             */
        function withScroller() {
          var scrollerSuffix = "S";
          options.dom = options.dom ? options.dom : DT_DEFAULT_OPTIONS.dom;
          if (options.dom.indexOf(scrollerSuffix) === -1) {
            options.dom = options.dom + scrollerSuffix;
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtScrollerConfig.$inject = ["$provide", "DT_DEFAULT_OPTIONS"];

})(window, document, jQuery, angular);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
(function (window, document, $, angular) {

  "use strict";

  // See https://datatables.net/extras/tabletools/
  angular.module("datatables.tabletools", ["datatables"])
    .config(dtTableToolsConfig);

  /* @ngInject */
  function dtTableToolsConfig($provide, DT_DEFAULT_OPTIONS) {
    $provide.decorator("DTOptionsBuilder", dtOptionsBuilderDecorator);

    function dtOptionsBuilderDecorator($delegate) {
      var newOptions = $delegate.newOptions;
      var fromSource = $delegate.fromSource;
      var fromFnPromise = $delegate.fromFnPromise;

      $delegate.newOptions = function () {
        return _decorateOptions(newOptions);
      };
      $delegate.fromSource = function (ajax) {
        return _decorateOptions(fromSource, ajax);
      };
      $delegate.fromFnPromise = function (fnPromise) {
        return _decorateOptions(fromFnPromise, fnPromise);
      };

      return $delegate;

      function _decorateOptions(fn, params) {
        var options = fn(params);
        options.withTableTools = withTableTools;
        options.withTableToolsOption = withTableToolsOption;
        options.withTableToolsButtons = withTableToolsButtons;
        return options;

        /**
             * Add table tools compatibility
             * @param sSwfPath the path to the swf file to export in csv/xls
             * @returns {DTOptions} the options
             */
        function withTableTools(sSwfPath) {
          var tableToolsPrefix = "T";
          options.dom = options.dom ? options.dom : DT_DEFAULT_OPTIONS.dom;
          if (options.dom.indexOf(tableToolsPrefix) === -1) {
            options.dom = tableToolsPrefix + options.dom;
          }
          options.hasTableTools = true;
          if (angular.isString(sSwfPath)) {
            options.withTableToolsOption("sSwfPath", sSwfPath);
          }
          return options;
        }

        /**
             * Add option to "oTableTools" option
             * @param key the key of the option to add
             * @param value an object or a function of the function
             * @returns {DTOptions} the options
             */
        function withTableToolsOption(key, value) {
          if (angular.isString(key)) {
            options.oTableTools = options.oTableTools && options.oTableTools !== null ? options.oTableTools : {};
            options.oTableTools[key] = value;
          }
          return options;
        }

        /**
             * Set the table tools buttons to display
             * @param aButtons the array of buttons to display
             * @returns {DTOptions} the options
             */
        function withTableToolsButtons(aButtons) {
          if (angular.isArray(aButtons)) {
            options.withTableToolsOption("aButtons", aButtons);
          }
          return options;
        }
      }
    }
    dtOptionsBuilderDecorator.$inject = ["$delegate"];
  }
  dtTableToolsConfig.$inject = ["$provide", "DT_DEFAULT_OPTIONS"];

})(window, document, jQuery, angular);

/**
 * An Angular module that gives you access to the browsers local storage
 * @version v0.2.6 - 2016-03-16
 * @link https://github.com/grevory/angular-local-storage
 * @author grevory <greg@gregpike.ca>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (window, angular) {
  var isDefined = angular.isDefined,
    isUndefined = angular.isUndefined,
    isNumber = angular.isNumber,
    isObject = angular.isObject,
    isArray = angular.isArray,
    extend = angular.extend,
    toJson = angular.toJson;

  angular
    .module("LocalStorageModule", [])
    .provider("localStorageService", function () {
    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
    // With provider you can use config as this:
    // myApp.config(function (localStorageServiceProvider) {
    //    localStorageServiceProvider.prefix = 'yourAppName';
    // });
      this.prefix = "ls";

      // You could change web storage type localstorage or sessionStorage
      this.storageType = "localStorage";

      // Cookie options (usually in case of fallback)
      // expiry = Number of days before cookies expire // 0 = Does not expire
      // path = The web path the cookie represents
      this.cookie = {
        expiry: 30,
        path: "/"
      };

      // Send signals for each of the following actions?
      this.notify = {
        setItem: true,
        removeItem: false
      };

      // Setter for the prefix
      this.setPrefix = function (prefix) {
        this.prefix = prefix;
        return this;
      };

      // Setter for the storageType
      this.setStorageType = function (storageType) {
        this.storageType = storageType;
        return this;
      };

      // Setter for cookie config
      this.setStorageCookie = function (exp, path) {
        this.cookie.expiry = exp;
        this.cookie.path = path;
        return this;
      };

      // Setter for cookie domain
      this.setStorageCookieDomain = function (domain) {
        this.cookie.domain = domain;
        return this;
      };

      // Setter for notification config
      // itemSet & itemRemove should be booleans
      this.setNotify = function (itemSet, itemRemove) {
        this.notify = {
          setItem: itemSet,
          removeItem: itemRemove
        };
        return this;
      };

      this.$get = ["$rootScope", "$window", "$document", "$parse", function ($rootScope, $window, $document, $parse) {
        var self = this;
        var prefix = self.prefix;
        var cookie = self.cookie;
        var notify = self.notify;
        var storageType = self.storageType;
        var webStorage;

        // When Angular's $document is not available
        if (!$document) {
          $document = document;
        } else if ($document[0]) {
          $document = $document[0];
        }

        // If there is a prefix set in the config lets use that with an appended period for readability
        if (prefix.substr(-1) !== ".") {
          prefix = prefix ? prefix + "." : "";
        }
        var deriveQualifiedKey = function (key) {
          return prefix + key;
        };
        // Checks the browser to see if local storage is supported
        var browserSupportsLocalStorage = (function () {
          try {
            var supported = (storageType in $window && $window[storageType] !== null);

            // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
            // is available, but trying to call .setItem throws an exception.
            //
            // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
            // that exceeded the quota."
            var key = deriveQualifiedKey("__" + Math.round(Math.random() * 1e7));
            if (supported) {
              webStorage = $window[storageType];
              webStorage.setItem(key, "");
              webStorage.removeItem(key);
            }

            return supported;
          } catch (e) {
            storageType = "cookie";
            $rootScope.$broadcast("LocalStorageModule.notification.error", e.message);
            return false;
          }
        }());

        // Directly adds a value to local storage
        // If local storage is not available in the browser use cookies
        // Example use: localStorageService.add('library','angular');
        var addToLocalStorage = function (key, value) {
        // Let's convert undefined values to null to get the value consistent
          if (isUndefined(value)) {
            value = null;
          } else {
            value = toJson(value);
          }

          // If this browser does not support local storage use cookies
          if (!browserSupportsLocalStorage || self.storageType === "cookie") {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast("LocalStorageModule.notification.warning", "LOCAL_STORAGE_NOT_SUPPORTED");
            }

            if (notify.setItem) {
              $rootScope.$broadcast("LocalStorageModule.notification.setitem", { key: key, newvalue: value, storageType: "cookie" });
            }
            return addToCookies(key, value);
          }

          try {
            if (webStorage) {
              webStorage.setItem(deriveQualifiedKey(key), value);
            }
            if (notify.setItem) {
              $rootScope.$broadcast("LocalStorageModule.notification.setitem", { key: key, newvalue: value, storageType: self.storageType });
            }
          } catch (e) {
            $rootScope.$broadcast("LocalStorageModule.notification.error", e.message);
            return addToCookies(key, value);
          }
          return true;
        };

        // Directly get a value from local storage
        // Example use: localStorageService.get('library'); // returns 'angular'
        var getFromLocalStorage = function (key) {

          if (!browserSupportsLocalStorage || self.storageType === "cookie") {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast("LocalStorageModule.notification.warning", "LOCAL_STORAGE_NOT_SUPPORTED");
            }

            return getFromCookies(key);
          }

          var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
          // angular.toJson will convert null to 'null', so a proper conversion is needed
          // FIXME not a perfect solution, since a valid 'null' string can't be stored
          if (!item || item === "null") {
            return null;
          }

          try {
            return JSON.parse(item);
          } catch (e) {
            return item;
          }
        };

        // Remove an item from local storage
        // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
        var removeFromLocalStorage = function () {
          var i, key;
          for (i = 0; i < arguments.length; i++) {
            key = arguments[i];
            if (!browserSupportsLocalStorage || self.storageType === "cookie") {
              if (!browserSupportsLocalStorage) {
                $rootScope.$broadcast("LocalStorageModule.notification.warning", "LOCAL_STORAGE_NOT_SUPPORTED");
              }

              if (notify.removeItem) {
                $rootScope.$broadcast("LocalStorageModule.notification.removeitem", { key: key, storageType: "cookie" });
              }
              removeFromCookies(key);
            }
            else {
              try {
                webStorage.removeItem(deriveQualifiedKey(key));
                if (notify.removeItem) {
                  $rootScope.$broadcast("LocalStorageModule.notification.removeitem", {
                    key: key,
                    storageType: self.storageType
                  });
                }
              } catch (e) {
                $rootScope.$broadcast("LocalStorageModule.notification.error", e.message);
                removeFromCookies(key);
              }
            }
          }
        };

        // Return array of keys for local storage
        // Example use: var keys = localStorageService.keys()
        var getKeysForLocalStorage = function () {

          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast("LocalStorageModule.notification.warning", "LOCAL_STORAGE_NOT_SUPPORTED");
            return [];
          }

          var prefixLength = prefix.length;
          var keys = [];
          for (var key in webStorage) {
          // Only return keys that are for this app
            if (key.substr(0, prefixLength) === prefix) {
              try {
                keys.push(key.substr(prefixLength));
              } catch (e) {
                $rootScope.$broadcast("LocalStorageModule.notification.error", e.Description);
                return [];
              }
            }
          }
          return keys;
        };

        // Remove all data for this app from local storage
        // Also optionally takes a regular expression string and removes the matching key-value pairs
        // Example use: localStorageService.clearAll();
        // Should be used mostly for development purposes
        var clearAllFromLocalStorage = function (regularExpression) {

          // Setting both regular expressions independently
          // Empty strings result in catchall RegExp
          var prefixRegex = prefix ? new RegExp("^" + prefix) : new RegExp();
          var testRegex = regularExpression ? new RegExp(regularExpression) : new RegExp();

          if (!browserSupportsLocalStorage || self.storageType === "cookie") {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast("LocalStorageModule.notification.warning", "LOCAL_STORAGE_NOT_SUPPORTED");
            }
            return clearAllFromCookies();
          }

          var prefixLength = prefix.length;

          for (var key in webStorage) {
          // Only remove items that are for this app and match the regular expression
            if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
              try {
                removeFromLocalStorage(key.substr(prefixLength));
              } catch (e) {
                $rootScope.$broadcast("LocalStorageModule.notification.error", e.message);
                return clearAllFromCookies();
              }
            }
          }
          return true;
        };

        // Checks the browser to see if cookies are supported
        var browserSupportsCookies = (function () {
          try {
            return $window.navigator.cookieEnabled ||
          ("cookie" in $document && ($document.cookie.length > 0 ||
            ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
          } catch (e) {
            $rootScope.$broadcast("LocalStorageModule.notification.error", e.message);
            return false;
          }
        }());

        // Directly adds a value to cookies
        // Typically used as a fallback is local storage is not available in the browser
        // Example use: localStorageService.cookie.add('library','angular');
        var addToCookies = function (key, value, daysToExpiry) {

          if (isUndefined(value)) {
            return false;
          } else if (isArray(value) || isObject(value)) {
            value = toJson(value);
          }

          if (!browserSupportsCookies) {
            $rootScope.$broadcast("LocalStorageModule.notification.error", "COOKIES_NOT_SUPPORTED");
            return false;
          }

          try {
            var expiry = "",
              expiryDate = new Date(),
              cookieDomain = "";

            if (value === null) {
              // Mark that the cookie has expired one day ago
              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
              value = "";
            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
            } else if (cookie.expiry !== 0) {
              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
            }
            if (key) {
              var cookiePath = "; path=" + cookie.path;
              if (cookie.domain) {
                cookieDomain = "; domain=" + cookie.domain;
              }
              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
            }
          } catch (e) {
            $rootScope.$broadcast("LocalStorageModule.notification.error", e.message);
            return false;
          }
          return true;
        };

        // Directly get a value from a cookie
        // Example use: localStorageService.cookie.get('library'); // returns 'angular'
        var getFromCookies = function (key) {
          if (!browserSupportsCookies) {
            $rootScope.$broadcast("LocalStorageModule.notification.error", "COOKIES_NOT_SUPPORTED");
            return false;
          }

          var cookies = $document.cookie && $document.cookie.split(";") || [];
          for (var i = 0; i < cookies.length; i++) {
            var thisCookie = cookies[i];
            while (thisCookie.charAt(0) === " ") {
              thisCookie = thisCookie.substring(1, thisCookie.length);
            }
            if (thisCookie.indexOf(deriveQualifiedKey(key) + "=") === 0) {
              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
              try {
                return JSON.parse(storedValues);
              } catch (e) {
                return storedValues;
              }
            }
          }
          return null;
        };

        var removeFromCookies = function (key) {
          addToCookies(key, null);
        };

        var clearAllFromCookies = function () {
          var thisCookie = null, thisKey = null;
          var prefixLength = prefix.length;
          var cookies = $document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            thisCookie = cookies[i];

            while (thisCookie.charAt(0) === " ") {
              thisCookie = thisCookie.substring(1, thisCookie.length);
            }

            var key = thisCookie.substring(prefixLength, thisCookie.indexOf("="));
            removeFromCookies(key);
          }
        };

        var getStorageType = function () {
          return storageType;
        };

        // Add a listener on scope variable to save its changes to local storage
        // Return a function which when called cancels binding
        var bindToScope = function (scope, key, def, lsKey) {
          lsKey = lsKey || key;
          var value = getFromLocalStorage(lsKey);

          if (value === null && isDefined(def)) {
            value = def;
          } else if (isObject(value) && isObject(def)) {
            value = extend(value, def);
          }

          $parse(key).assign(scope, value);

          return scope.$watch(key, function (newVal) {
            addToLocalStorage(lsKey, newVal);
          }, isObject(scope[key]));
        };

        // Return localStorageService.length
        // ignore keys that not owned
        var lengthOfLocalStorage = function () {
          var count = 0;
          var storage = $window[storageType];
          for (var i = 0; i < storage.length; i++) {
            if (storage.key(i).indexOf(prefix) === 0 ) {
              count++;
            }
          }
          return count;
        };

        return {
          isSupported: browserSupportsLocalStorage,
          getStorageType: getStorageType,
          set: addToLocalStorage,
          add: addToLocalStorage, // DEPRECATED
          get: getFromLocalStorage,
          keys: getKeysForLocalStorage,
          remove: removeFromLocalStorage,
          clearAll: clearAllFromLocalStorage,
          bind: bindToScope,
          deriveKey: deriveQualifiedKey,
          length: lengthOfLocalStorage,
          cookie: {
            isSupported: browserSupportsCookies,
            set: addToCookies,
            add: addToCookies, // DEPRECATED
            get: getFromCookies,
            remove: removeFromCookies,
            clearAll: clearAllFromCookies
          }
        };
      }];
    });
})(window, window.angular);

/* angular-svg-round-progressbar@0.3.10 2016-01-23 */
"use strict";!function () {for (var a = 0, b = ["webkit", "moz"], c = 0;c < b.length && !window.requestAnimationFrame;++c)window.requestAnimationFrame = window[b[c] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[b[c] + "CancelAnimationFrame"] || window[b[c] + "CancelRequestAnimationFrame"];window.requestAnimationFrame || (window.requestAnimationFrame = function (b) {var c = (new Date).getTime(), d = Math.max(0, 16 - (c - a)), e = window.setTimeout(function () {b(c + d);}, d);return a = c + d, e;}), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (a) {window.clearTimeout(a);});}(), angular.module("angular-svg-round-progress", []), angular.module("angular-svg-round-progress").constant("roundProgressConfig", { max: 50, semi: !1, rounded: !1, responsive: !1, clockwise: !0, radius: 100, color: "#45ccce", bgcolor: "#eaeaea", stroke: 15, duration: 800, animation: "easeOutCubic", animationDelay: 0, offset: 0 }), angular.module("angular-svg-round-progress").service("roundProgressService", [function () {var a = {}, b = angular.isNumber, c = document.head.querySelector("base");a.resolveColor = c && c.href ? function (a) {var b = a.indexOf("#");return b > -1 && a.indexOf("url") > -1 ? a.slice(0, b) + window.location.href + a.slice(b) : a;} : function (a) {return a;}, a.isSupported = !(!document.createElementNS || !document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);var d = function (a, b, c, d) {var e = (d - 90) * Math.PI / 180;return { x: a + c * Math.cos(e), y: b + c * Math.sin(e) };};return a.toNumber = function (a) {return b(a) ? a : parseFloat((a + "").replace(",", "."));}, a.getOffset = function (b, c) {var d = +c.offset || 0;if ("inherit" === c.offset) for (var e, f = b;!f.hasClass("round-progress-wrapper");)a.isDirective(f) && (e = f.scope().$parent.getOptions(), d += (+e.offset || 0) + (+e.stroke || 0)), f = f.parent();return d;}, a.updateState = function (a, b, c, e, f, g) {if (!f) return e;var h = a > 0 ? Math.min(a, b) : 0, i = g ? 180 : 359.9999, j = 0 === b ? 0 : h / b * i, k = f / 2, l = d(k, k, c, j), m = d(k, k, c, 0), n = 180 >= j ? "0" : "1", o = ["M", l.x, l.y, "A", c, c, 0, n, 0, m.x, m.y].join(" ");return e.attr("d", o);}, a.isDirective = function (a) {return a && a.length ? "undefined" !== typeof a.attr("round-progress") || "round-progress" === a[0].nodeName.toLowerCase() : !1;}, a.animations = { linearEase: function (a, b, c, d) {return c * a / d + b;}, easeInQuad: function (a, b, c, d) {return c * (a /= d) * a + b;}, easeOutQuad: function (a, b, c, d) {return -c * (a /= d) * (a - 2) + b;}, easeInOutQuad: function (a, b, c, d) {return (a /= d / 2) < 1 ? c / 2 * a * a + b : -c / 2 * (--a * (a - 2) - 1) + b;}, easeInCubic: function (a, b, c, d) {return c * (a /= d) * a * a + b;}, easeOutCubic: function (a, b, c, d) {return c * ((a = a / d - 1) * a * a + 1) + b;}, easeInOutCubic: function (a, b, c, d) {return (a /= d / 2) < 1 ? c / 2 * a * a * a + b : c / 2 * ((a -= 2) * a * a + 2) + b;}, easeInQuart: function (a, b, c, d) {return c * (a /= d) * a * a * a + b;}, easeOutQuart: function (a, b, c, d) {return -c * ((a = a / d - 1) * a * a * a - 1) + b;}, easeInOutQuart: function (a, b, c, d) {return (a /= d / 2) < 1 ? c / 2 * a * a * a * a + b : -c / 2 * ((a -= 2) * a * a * a - 2) + b;}, easeInQuint: function (a, b, c, d) {return c * (a /= d) * a * a * a * a + b;}, easeOutQuint: function (a, b, c, d) {return c * ((a = a / d - 1) * a * a * a * a + 1) + b;}, easeInOutQuint: function (a, b, c, d) {return (a /= d / 2) < 1 ? c / 2 * a * a * a * a * a + b : c / 2 * ((a -= 2) * a * a * a * a + 2) + b;}, easeInSine: function (a, b, c, d) {return -c * Math.cos(a / d * (Math.PI / 2)) + c + b;}, easeOutSine: function (a, b, c, d) {return c * Math.sin(a / d * (Math.PI / 2)) + b;}, easeInOutSine: function (a, b, c, d) {return -c / 2 * (Math.cos(Math.PI * a / d) - 1) + b;}, easeInExpo: function (a, b, c, d) {return 0 == a ? b : c * Math.pow(2, 10 * (a / d - 1)) + b;}, easeOutExpo: function (a, b, c, d) {return a == d ? b + c : c * (-Math.pow(2, -10 * a / d) + 1) + b;}, easeInOutExpo: function (a, b, c, d) {return 0 == a ? b : a == d ? b + c : (a /= d / 2) < 1 ? c / 2 * Math.pow(2, 10 * (a - 1)) + b : c / 2 * (-Math.pow(2, -10 * --a) + 2) + b;}, easeInCirc: function (a, b, c, d) {return -c * (Math.sqrt(1 - (a /= d) * a) - 1) + b;}, easeOutCirc: function (a, b, c, d) {return c * Math.sqrt(1 - (a = a / d - 1) * a) + b;}, easeInOutCirc: function (a, b, c, d) {return (a /= d / 2) < 1 ? -c / 2 * (Math.sqrt(1 - a * a) - 1) + b : c / 2 * (Math.sqrt(1 - (a -= 2) * a) + 1) + b;}, easeInElastic: function (a, b, c, d) {var e = 1.70158, f = 0, g = c;return 0 == a ? b : 1 == (a /= d) ? b + c : (f || (f = .3 * d), g < Math.abs(c) ? (g = c, e = f / 4) : e = f / (2 * Math.PI) * Math.asin(c / g), -(g * Math.pow(2, 10 * (a -= 1)) * Math.sin((a * d - e) * (2 * Math.PI) / f)) + b);}, easeOutElastic: function (a, b, c, d) {var e = 1.70158, f = 0, g = c;return 0 == a ? b : 1 == (a /= d) ? b + c : (f || (f = .3 * d), g < Math.abs(c) ? (g = c, e = f / 4) : e = f / (2 * Math.PI) * Math.asin(c / g), g * Math.pow(2, -10 * a) * Math.sin((a * d - e) * (2 * Math.PI) / f) + c + b);}, easeInOutElastic: function (a, b, c, d) {var e = 1.70158, f = 0, g = c;return 0 == a ? b : 2 == (a /= d / 2) ? b + c : (f || (f = d * (.3 * 1.5)), g < Math.abs(c) ? (g = c, e = f / 4) : e = f / (2 * Math.PI) * Math.asin(c / g), 1 > a ? -.5 * (g * Math.pow(2, 10 * (a -= 1)) * Math.sin((a * d - e) * (2 * Math.PI) / f)) + b : g * Math.pow(2, -10 * (a -= 1)) * Math.sin((a * d - e) * (2 * Math.PI) / f) * .5 + c + b);}, easeInBack: function (a, b, c, d, e) {return void 0 == e && (e = 1.70158), c * (a /= d) * a * ((e + 1) * a - e) + b;}, easeOutBack: function (a, b, c, d, e) {return void 0 == e && (e = 1.70158), c * ((a = a / d - 1) * a * ((e + 1) * a + e) + 1) + b;}, easeInOutBack: function (a, b, c, d, e) {return void 0 == e && (e = 1.70158), (a /= d / 2) < 1 ? c / 2 * (a * a * (((e *= 1.525) + 1) * a - e)) + b : c / 2 * ((a -= 2) * a * (((e *= 1.525) + 1) * a + e) + 2) + b;}, easeInBounce: function (b, c, d, e) {return d - a.animations.easeOutBounce(e - b, 0, d, e) + c;}, easeOutBounce: function (a, b, c, d) {return (a /= d) < 1 / 2.75 ? c * (7.5625 * a * a) + b : 2 / 2.75 > a ? c * (7.5625 * (a -= 1.5 / 2.75) * a + .75) + b : 2.5 / 2.75 > a ? c * (7.5625 * (a -= 2.25 / 2.75) * a + .9375) + b : c * (7.5625 * (a -= 2.625 / 2.75) * a + .984375) + b;}, easeInOutBounce: function (b, c, d, e) {return e / 2 > b ? .5 * a.animations.easeInBounce(2 * b, 0, d, e) + c : .5 * a.animations.easeOutBounce(2 * b - e, 0, d, e) + .5 * d + c;} }, a;}]), angular.module("angular-svg-round-progress").directive("roundProgress", ["$window", "roundProgressService", "roundProgressConfig", function (a, b, c) {var d = { restrict: "EA", replace: !0, transclude: !0, scope: { current: "=", max: "=", semi: "=", rounded: "=", clockwise: "=", responsive: "=", onRender: "=", radius: "@", color: "@", bgcolor: "@", stroke: "@", duration: "@", animation: "@", offset: "@", animationDelay: "@" } };return b.isSupported ? angular.extend(d, { link: function (e, f) {var g, h, i = !f.hasClass("round-progress-wrapper"), j = i ? f : f.find("svg").eq(0), k = j.find("path").eq(0), l = j.find("circle").eq(0), m = angular.copy(c), n = 0;e.getOptions = function () {return m;};var o = function () {var a = m.semi, c = m.responsive, d = +m.radius || 0, e = +m.stroke, g = 2 * d, h = d - e / 2 - b.getOffset(f, m);j.css({ top: 0, left: 0, position: c ? "absolute" : "static", width: c ? "100%" : g + "px", height: c ? "100%" : (a ? d : g) + "px", overflow: "hidden" }), i || (j[0].setAttribute("viewBox", "0 0 " + g + " " + (a ? d : g)), f.css({ width: c ? "100%" : "auto", position: "relative", "padding-bottom": c ? a ? "50%" : "100%" : 0 })), f.css({ width: c ? "100%" : "auto", position: "relative", "padding-bottom": c ? a ? "50%" : "100%" : 0 }), k.css({ stroke: b.resolveColor(m.color), "stroke-width": e, "stroke-linecap": m.rounded ? "round" : "butt" }), a ? k.attr("transform", m.clockwise ? "translate(0," + g + ") rotate(-90)" : "translate(" + g + ", " + g + ") rotate(90) scale(-1, 1)") : k.attr("transform", m.clockwise ? "" : "scale(-1, 1) translate(" + -g + " 0)"), l.attr({ cx: d, cy: d, r: h >= 0 ? h : 0 }).css({ stroke: b.resolveColor(m.bgcolor), "stroke-width": e });}, p = function (c, d, e) {var h = b.toNumber(m.max || 0), i = c > 0 ? a.Math.min(c, h) : 0, j = d === i || 0 > d ? 0 : d || 0, l = i - j, o = b.animations[m.animation], p = +m.duration || 0, q = e || c > h && d > h || 0 > c && 0 > d || 25 > p, r = m.radius, s = r - m.stroke / 2 - b.getOffset(f, m), t = 2 * r, u = m.semi, v = function () {if (q)b.updateState(i, h, s, k, t, u), m.onRender && m.onRender(i, m, f);else {var c = new a.Date, d = ++n;!function e() {var g = a.Math.min(new Date - c, p), i = o(g, j, l, p);b.updateState(i, h, s, k, t, u), m.onRender && m.onRender(i, m, f), d === n && p > g && a.requestAnimationFrame(e);}();}};m.animationDelay > 0 ? (a.clearTimeout(g), a.setTimeout(v, m.animationDelay)) : v();}, q = Object.keys(d.scope).filter(function (a) {return "current" !== a;});e.$watchGroup(q, function (a) {for (var b = 0;b < a.length;b++)"undefined" !== typeof a[b] && (m[q[b]] = a[b]);o(), e.$broadcast("$parentOffsetChanged"), "inherit" !== m.offset || h ? "inherit" !== m.offset && h && h() : h = e.$on("$parentOffsetChanged", function () {p(e.current, e.current, !0), o();});}), e.$watchGroup(["current", "max", "radius", "stroke", "semi", "offset"], function (a, c) {p(b.toNumber(a[0]), b.toNumber(c[0]));});}, template: function (a) {for (var c = a.parent(), d = "round-progress", e = ["<svg class=\"" + d + "\" xmlns=\"http://www.w3.org/2000/svg\">", "<circle fill=\"none\"/>", "<path fill=\"none\"/>", "<g ng-transclude></g>", "</svg>"];c.length && !b.isDirective(c);)c = c.parent();return c && c.length || (e.unshift("<div class=\"round-progress-wrapper\">"), e.push("</div>")), e.join("\n");} }) : angular.extend(d, { template: "<div class=\"round-progress\" ng-transclude></div>" });}]);

/* !
 * jsonformatter
 *
 * Version: 0.4.1 - 2015-12-03T03:38:59.925Z
 * License: MIT
 */

"use strict";

angular.module("jsonFormatter", ["RecursionHelper"])

  .provider("JSONFormatterConfig", function JSONFormatterConfigProvider() {

    // Default values for hover preview config
    var hoverPreviewEnabled = false;
    var hoverPreviewArrayCount = 100;
    var hoverPreviewFieldCount = 5;

    return {
      get hoverPreviewEnabled() {
        return hoverPreviewEnabled;
      },
      set hoverPreviewEnabled(value) {
        hoverPreviewEnabled = !!value;
      },

      get hoverPreviewArrayCount() {
        return hoverPreviewArrayCount;
      },
      set hoverPreviewArrayCount(value) {
        hoverPreviewArrayCount = parseInt(value, 10);
      },

      get hoverPreviewFieldCount() {
        return hoverPreviewFieldCount;
      },
      set hoverPreviewFieldCount(value) {
        hoverPreviewFieldCount = parseInt(value, 10);
      },

      $get: function () {
        return {
          hoverPreviewEnabled: hoverPreviewEnabled,
          hoverPreviewArrayCount: hoverPreviewArrayCount,
          hoverPreviewFieldCount: hoverPreviewFieldCount
        };
      }
    };
  })

  .directive("jsonFormatter", ["RecursionHelper", "JSONFormatterConfig", function jsonFormatterDirective(RecursionHelper, JSONFormatterConfig) {
    function escapeString(str) {
      return str.replace("\"", "\"");
    }

    // From http://stackoverflow.com/a/332429
    function getObjectName(object) {
      if (object === undefined) {
        return "";
      }
      if (object === null) {
        return "Object";
      }
      if (typeof object === "object" && !object.constructor) {
        return "Object";
      }
      var funcNameRegex = /function (.{1,})\(/;
      var results = (funcNameRegex).exec((object).constructor.toString());
      if (results && results.length > 1) {
        return results[1];
      } else {
        return "";
      }
    }

    function getType(object) {
      if (object === null) { return "null"; }
      return typeof object;
    }

    function getValuePreview(object, value) {
      var type = getType(object);

      if (type === "null" || type === "undefined") { return type; }

      if (type === "string") {
        value = "\"" + escapeString(value) + "\"";
      }
      if (type === "function") {

        // Remove content of the function
        return object.toString()
          .replace(/[\r\n]/g, "")
          .replace(/\{.*\}/, "") + "{…}";

      }
      return value;
    }

    function getPreview(object) {
      var value = "";
      if (angular.isObject(object)) {
        value = getObjectName(object);
        if (angular.isArray(object))
          value += "[" + object.length + "]";
      } else {
        value = getValuePreview(object, object);
      }
      return value;
    }

    function link(scope) {
      scope.isArray = function () {
        return angular.isArray(scope.json);
      };

      scope.isObject = function () {
        return angular.isObject(scope.json);
      };

      scope.getKeys = function () {
        if (scope.isObject()) {
          return Object.keys(scope.json).map(function (key) {
            if (key === "") { return "\"\""; }
            return key;
          });
        }
      };
      scope.type = getType(scope.json);
      scope.hasKey = typeof scope.key !== "undefined";
      scope.getConstructorName = function () {
        return getObjectName(scope.json);
      };

      if (scope.type === "string") {

        // Add custom type for date
        if ((new Date(scope.json)).toString() !== "Invalid Date") {
          scope.isDate = true;
        }

        // Add custom type for URLs
        if (scope.json.indexOf("http") === 0) {
          scope.isUrl = true;
        }
      }

      scope.isEmptyObject = function () {
        return scope.getKeys() && !scope.getKeys().length &&
        scope.isOpen && !scope.isArray();
      };

      // If 'open' attribute is present
      scope.isOpen = !!scope.open;
      scope.toggleOpen = function () {
        scope.isOpen = !scope.isOpen;
      };
      scope.childrenOpen = function () {
        if (scope.open > 1) {
          return scope.open - 1;
        }
        return 0;
      };

      scope.openLink = function (isUrl) {
        if (isUrl) {
          window.location.href = scope.json;
        }
      };

      scope.parseValue = function (value) {
        return getValuePreview(scope.json, value);
      };

      scope.showThumbnail = function () {
        return !!JSONFormatterConfig.hoverPreviewEnabled && scope.isObject() && !scope.isOpen;
      };

      scope.getThumbnail = function () {
        if (scope.isArray()) {

          // if array length is greater then 100 it shows "Array[101]"
          if (scope.json.length > JSONFormatterConfig.hoverPreviewArrayCount) {
            return "Array[" + scope.json.length + "]";
          } else {
            return "[" + scope.json.map(getPreview).join(", ") + "]";
          }
        } else {

          var keys = scope.getKeys();

          // the first five keys (like Chrome Developer Tool)
          var narrowKeys = keys.slice(0, JSONFormatterConfig.hoverPreviewFieldCount);

          // json value schematic information
          var kvs = narrowKeys
            .map(function (key) { return key + ":" + getPreview(scope.json[key]); });

          // if keys count greater then 5 then show ellipsis
          var ellipsis = keys.length >= 5 ? "…" : "";

          return "{" + kvs.join(", ") + ellipsis + "}";
        }
      };
    }

    return {
      templateUrl: "json-formatter.html",
      restrict: "E",
      replace: true,
      scope: {
        json: "=",
        key: "=",
        open: "="
      },
      compile: function (element) {

        // Use the compile function from the RecursionHelper,
        // And return the linking function(s) which it returns
        return RecursionHelper.compile(element, link);
      }
    };
  }]);

// Export to CommonJS style imports. Exporting this string makes this valid:
// angular.module('myApp', [require('jsonformatter')]);
if (typeof module === "object") {
  module.exports = "jsonFormatter";
}
"use strict";

// from http://stackoverflow.com/a/18609594
angular.module("RecursionHelper", []).factory("RecursionHelper", ["$compile", function ($compile) {
  return {
    /**
     * Manually compiles the element, fixing the recursion loop.
     * @param element
     * @param [link] A post-link function, or an object with function(s)
     * registered via pre and post properties.
     * @returns An object containing the linking functions.
     */
    compile: function (element, link) {
      // Normalize the link parameter
      if (angular.isFunction(link)) {
        link = { post: link };
      }

      // Break the recursion loop by removing the contents
      var contents = element.contents().remove();
      var compiledContents;
      return {
        pre: (link && link.pre) ? link.pre : null,
        /**
         * Compiles and re-adds the contents
         */
        post: function (scope, element) {
          // Compile the contents
          if (!compiledContents) {
            compiledContents = $compile(contents);
          }
          // Re-add the compiled contents to the element
          compiledContents(scope, function (clone) {
            element.append(clone);
          });

          // Call the post-linking function, if any
          if (link && link.post) {
            link.post.apply(null, arguments);
          }
        }
      };
    }
  };
}]);

angular.module("jsonFormatter").run(["$templateCache", function ($templateCache) {$templateCache.put("json-formatter.html", "<div ng-init=\"isOpen = open && open > 0\" class=\"json-formatter-row\"><a ng-click=\"toggleOpen()\"><span class=\"toggler {{isOpen ? \'open\' : \'\'}}\" ng-if=\"isObject()\"></span> <span class=\"key\" ng-if=\"hasKey\"><span class=\"key-text\">{{key}}</span><span class=\"colon\">:</span></span> <span class=\"value\"><span ng-if=\"isObject()\"><span class=\"constructor-name\">{{getConstructorName(json)}}</span> <span ng-if=\"isArray()\"><span class=\"bracket\">[</span><span class=\"number\">{{json.length}}</span><span class=\"bracket\">]</span></span></span> <span ng-if=\"!isObject()\" ng-click=\"openLink(isUrl)\" class=\"{{type}}\" ng-class=\"{date: isDate, url: isUrl}\">{{parseValue(json)}}</span></span> <span ng-if=\"showThumbnail()\" class=\"thumbnail-text\">{{getThumbnail()}}</span></a><div class=\"children\" ng-if=\"getKeys().length && isOpen\"><json-formatter ng-repeat=\"key in getKeys() track by $index\" json=\"json[key]\" key=\"key\" open=\"childrenOpen()\"></json-formatter></div><div class=\"children empty object\" ng-if=\"isEmptyObject()\"></div><div class=\"children empty array\" ng-if=\"getKeys() && !getKeys().length && isOpen && isArray()\"></div></div>");}]);

/* global window */
/* global angular */
/* global module */

(function (module, window, angular) {
  "use strict";

  function test(string, regex) {
    if (typeof regex === "string" || regex instanceof String) {
      regex = new RegExp(regex);
    }

    if (regex instanceof RegExp) {
      return regex.test(string);
    }
    else if (regex && Array.isArray(regex.and)) {
      return regex.and.every(function (item) {
        return test(string, item);
      });
    }
    else if (regex && Array.isArray(regex.or)) {
      return regex.or.some(function (item) {
        return test(string, item);
      });
    }
    else if (regex && regex.not) {
      return !test(string, regex.not);
    }
    else {
      return false;
    }
  }

  function exec(string, regex) {
    if (typeof regex === "string" || regex instanceof String) {
      regex = new RegExp(regex);
    }

    if (regex instanceof RegExp) {
      return regex.exec(string);
    }
    else if (regex && Array.isArray(regex)) {
      return regex.reduce(function (res, item) {
        return (res) ? res : exec(string, item);
      }, null);
    }
    else {
      return null;
    }
  }

  if (angular) {
    angular.module("reTree", []).factory("reTree", [function () {
      return {
        test: test,
        exec: exec
      };
    }]);
  }

  if (window) {
    window.reTree = {
      test: test,
      exec: exec
    };
  }

  if (module) {
    module.exports = {
      test: test,
      exec: exec
    };
  }
})(typeof module === "undefined" ? null : module, typeof window === "undefined" ? null : window, typeof angular === "undefined" ? null : angular);

(function (angular) {
  "use strict";
  angular.module("ng.deviceDetector", ["reTree"])
    .constant("BROWSERS", {
      CHROME: "chrome",
      FIREFOX: "firefox",
      SAFARI: "safari",
      OPERA: "opera",
      IE: "ie",
      MS_EDGE: "ms-edge",
      PS4: "ps4",
      VITA: "vita",
      UNKNOWN: "unknown"
    })
    .constant("DEVICES", {
      ANDROID: "android",
      I_PAD: "ipad",
      IPHONE: "iphone",
      I_POD: "ipod",
      BLACKBERRY: "blackberry",
      FIREFOX_OS: "firefox-os",
      CHROME_BOOK: "chrome-book",
      WINDOWS_PHONE: "windows-phone",
      PS4: "ps4",
      VITA: "vita",
      UNKNOWN: "unknown"
    })
    .constant("OS", {
      WINDOWS: "windows",
      MAC: "mac",
      IOS: "ios",
      ANDROID: "android",
      LINUX: "linux",
      UNIX: "unix",
      FIREFOX_OS: "firefox-os",
      CHROME_OS: "chrome-os",
      WINDOWS_PHONE: "windows-phone",
      PS4: "ps4",
      VITA: "vita",
      UNKNOWN: "unknown"
    })
    .constant("OS_VERSIONS", {
      WINDOWS_3_11: "windows-3-11",
      WINDOWS_95: "windows-95",
      WINDOWS_ME: "windows-me",
      WINDOWS_98: "windows-98",
      WINDOWS_CE: "windows-ce",
      WINDOWS_2000: "windows-2000",
      WINDOWS_XP: "windows-xp",
      WINDOWS_SERVER_2003: "windows-server-2003",
      WINDOWS_VISTA: "windows-vista",
      WINDOWS_7: "windows-7",
      WINDOWS_8_1: "windows-8-1",
      WINDOWS_8: "windows-8",
      WINDOWS_10: "windows-10",
      WINDOWS_PHONE_7_5: "windows-phone-7-5",
      WINDOWS_PHONE_8_1: "windows-phone-8-1",
      WINDOWS_PHONE_10: "windows-phone-10",
      WINDOWS_NT_4_0: "windows-nt-4-0",
      UNKNOWN: "unknown"
    })
    .service("detectUtils", ["deviceDetector", "DEVICES", "BROWSERS", "OS",
      function (deviceDetector, DEVICES, BROWSERS, OS) {
        var deviceInfo = deviceDetector;

        this.isMobile = function () {
          return deviceInfo.device !== "unknown";
        };

        this.isAndroid = function () {
          return (deviceInfo.device === DEVICES.ANDROID || deviceInfo.OS === OS.ANDROID);
        };

        this.isIOS = function () {
          return (deviceInfo.os === OS.IOS || deviceInfo.device === DEVICES.I_POD || deviceInfo.device === DEVICES.IPHONE);
        };
      }
    ])
    .factory("deviceDetector", ["$window", "DEVICES", "BROWSERS", "OS", "OS_VERSIONS", "reTree",
      function ($window, DEVICES, BROWSERS, OS, OS_VERSIONS, reTree) {

        var OS_RE = {
          WINDOWS: { and: [{ or: [/\bWindows|(Win\d\d)\b/, /\bWin 9x\b/] }, { not: /\bWindows Phone\b/ }] },
          MAC: { and: [/\bMac OS\b/, { not: /Windows Phone/ }] },
          IOS: { and: [{ or: [/\biPad\b/, /\biPhone\b/, /\biPod\b/] }, { not: /Windows Phone/ }] },
          ANDROID: { and: [/\bAndroid\b/, { not: /Windows Phone/ }] },
          LINUX: /\bLinux\b/,
          UNIX: /\bUNIX\b/,
          FIREFOX_OS: { and: [/\bFirefox\b/, /Mobile\b/] },
          CHROME_OS: /\bCrOS\b/,
          WINDOWS_PHONE: { or: [/\bIEMobile\b/, /\bWindows Phone\b/] },
          PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
          VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
        };

        var BROWSERS_RE = {
          CHROME: { and: [{ or: [/\bChrome\b/, /\bCriOS\b/] }, { not: { or: [/\bOPR\b/, /\bEdge\b/] } }] },
          FIREFOX: /\bFirefox\b/,
          SAFARI: { and: [/^((?!CriOS).)*\Safari\b.*$/, { not: { or: [/\bOPR\b/, /\bEdge\b/, /Windows Phone/] } }] },
          OPERA: { or: [/Opera\b/, /\bOPR\b/] },
          IE: { or: [/\bMSIE\b/, /\bTrident\b/] },
          MS_EDGE: { or: [/\bEdge\b/] },
          PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
          VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
        };

        var DEVICES_RE = {
          ANDROID: { and: [/\bAndroid\b/, { not: /Windows Phone/ }] },
          I_PAD: /\biPad\b/,
          IPHONE: { and: [/\biPhone\b/, { not: /Windows Phone/ }] },
          I_POD: /\biPod\b/,
          BLACKBERRY: /\bblackberry\b/,
          FIREFOX_OS: { and: [/\bFirefox\b/, /\bMobile\b/] },
          CHROME_BOOK: /\bCrOS\b/,
          WINDOWS_PHONE: { or: [/\bIEMobile\b/, /\bWindows Phone\b/] },
          PS4: /\bMozilla\/5.0 \(PlayStation 4\b/,
          VITA: /\bMozilla\/5.0 \(Play(S|s)tation Vita\b/
        };

        var OS_VERSIONS_RE = {
          WINDOWS_3_11: /Win16/,
          WINDOWS_95: /(Windows 95|Win95|Windows_95)/,
          WINDOWS_ME: /(Win 9x 4.90|Windows ME)/,
          WINDOWS_98: /(Windows 98|Win98)/,
          WINDOWS_CE: /Windows CE/,
          WINDOWS_2000: /(Windows NT 5.0|Windows 2000)/,
          WINDOWS_XP: /(Windows NT 5.1|Windows XP)/,
          WINDOWS_SERVER_2003: /Windows NT 5.2/,
          WINDOWS_VISTA: /Windows NT 6.0/,
          WINDOWS_7: /(Windows 7|Windows NT 6.1)/,
          WINDOWS_8_1: /(Windows 8.1|Windows NT 6.3)/,
          WINDOWS_8: /(Windows 8|Windows NT 6.2)/,
          WINDOWS_10: /(Windows NT 10.0)/,
          WINDOWS_PHONE_7_5: /(Windows Phone OS 7.5)/,
          WINDOWS_PHONE_8_1: /(Windows Phone 8.1)/,
          WINDOWS_PHONE_10: /(Windows Phone 10)/,
          WINDOWS_NT_4_0: { and: [/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/, { not: /Windows NT 10.0/ }] }
        };

        var BROWSER_VERSIONS_RE_MAP = {
          CHROME: [/\bChrome\/([\d\.]+)\b/, /\bCriOS\/([\d\.]+)\b/],
          FIREFOX: /\bFirefox\/([\d\.]+)\b/,
          SAFARI: /\bVersion\/([\d\.]+)\b/,
          OPERA: [/\bVersion\/([\d\.]+)\b/, /\bOPR\/([\d\.]+)\b/],
          IE: [/\bMSIE ([\d\.]+\w?)\b/, /\brv:([\d\.]+\w?)\b/],
          MS_EDGE: /\bEdge\/([\d\.]+)\b/
        };

        var BROWSER_VERSIONS_RE = Object.keys(BROWSER_VERSIONS_RE_MAP).reduce(function (obj, key) {
          obj[BROWSERS[key]] = BROWSER_VERSIONS_RE_MAP[key];
          return obj;
        }, {});

        var ua = $window.navigator.userAgent;

        var deviceInfo = {
          raw: {
            userAgent: ua,
            os: {},
            browser: {},
            device: {}
          }
        };

        deviceInfo.raw.os = Object.keys(OS).reduce(function (obj, item) {
          obj[OS[item]] = reTree.test(ua, OS_RE[item]);
          return obj;
        }, {});

        deviceInfo.raw.browser = Object.keys(BROWSERS).reduce(function (obj, item) {
          obj[BROWSERS[item]] = reTree.test(ua, BROWSERS_RE[item]);
          return obj;
        }, {});

        deviceInfo.raw.device = Object.keys(DEVICES).reduce(function (obj, item) {
          obj[DEVICES[item]] = reTree.test(ua, DEVICES_RE[item]);
          return obj;
        }, {});

        deviceInfo.raw.os_version = Object.keys(OS_VERSIONS).reduce(function (obj, item) {
          obj[OS_VERSIONS[item]] = reTree.test(ua, OS_VERSIONS_RE[item]);
          return obj;
        }, {});

        deviceInfo.os = [
          OS.WINDOWS,
          OS.IOS,
          OS.MAC,
          OS.ANDROID,
          OS.LINUX,
          OS.UNIX,
          OS.FIREFOX_OS,
          OS.CHROME_OS,
          OS.WINDOWS_PHONE,
          OS.PS4,
          OS.VITA
        ].reduce(function (previousValue, currentValue) {
          return (previousValue === OS.UNKNOWN && deviceInfo.raw.os[currentValue]) ? currentValue : previousValue;
        }, OS.UNKNOWN);

        deviceInfo.browser = [
          BROWSERS.CHROME,
          BROWSERS.FIREFOX,
          BROWSERS.SAFARI,
          BROWSERS.OPERA,
          BROWSERS.IE,
          BROWSERS.MS_EDGE,
          BROWSERS.PS4,
          BROWSERS.VITA
        ].reduce(function (previousValue, currentValue) {
          return (previousValue === BROWSERS.UNKNOWN && deviceInfo.raw.browser[currentValue]) ? currentValue : previousValue;
        }, BROWSERS.UNKNOWN);

        deviceInfo.device = [
          DEVICES.ANDROID,
          DEVICES.I_PAD,
          DEVICES.IPHONE,
          DEVICES.I_POD,
          DEVICES.BLACKBERRY,
          DEVICES.FIREFOX_OS,
          DEVICES.CHROME_BOOK,
          DEVICES.WINDOWS_PHONE,
          DEVICES.PS4,
          DEVICES.VITA
        ].reduce(function (previousValue, currentValue) {
          return (previousValue === DEVICES.UNKNOWN && deviceInfo.raw.device[currentValue]) ? currentValue : previousValue;
        }, DEVICES.UNKNOWN);

        deviceInfo.os_version = [
          OS_VERSIONS.WINDOWS_3_11,
          OS_VERSIONS.WINDOWS_95,
          OS_VERSIONS.WINDOWS_ME,
          OS_VERSIONS.WINDOWS_98,
          OS_VERSIONS.WINDOWS_CE,
          OS_VERSIONS.WINDOWS_2000,
          OS_VERSIONS.WINDOWS_XP,
          OS_VERSIONS.WINDOWS_SERVER_2003,
          OS_VERSIONS.WINDOWS_VISTA,
          OS_VERSIONS.WINDOWS_7,
          OS_VERSIONS.WINDOWS_8_1,
          OS_VERSIONS.WINDOWS_8,
          OS_VERSIONS.WINDOWS_10,
          OS_VERSIONS.WINDOWS_PHONE_7_5,
          OS_VERSIONS.WINDOWS_PHONE_8_1,
          OS_VERSIONS.WINDOWS_PHONE_10,
          OS_VERSIONS.WINDOWS_NT_4_0
        ].reduce(function (previousValue, currentValue) {
          return (previousValue === OS_VERSIONS.UNKNOWN && deviceInfo.raw.os_version[currentValue]) ? currentValue : previousValue;
        }, OS_VERSIONS.UNKNOWN);

        deviceInfo.browser_version = "0";
        if (deviceInfo.browser !== BROWSERS.UNKNOWN) {
          var re = BROWSER_VERSIONS_RE[deviceInfo.browser];
          var res = reTree.exec(ua, re);
          if (res) {
            deviceInfo.browser_version = res[1];
          }
        }

        deviceInfo.isMobile = function () {
          return [
            DEVICES.ANDROID,
            DEVICES.I_PAD,
            DEVICES.IPHONE,
            DEVICES.I_POD,
            DEVICES.BLACKBERRY,
            DEVICES.FIREFOX_OS,
            DEVICES.WINDOWS_PHONE,
            DEVICES.VITA
          ].some(function (item) {
            return deviceInfo.device == item;
          });
        };

        deviceInfo.isTablet = function () {
          return [
            DEVICES.I_PAD,
            DEVICES.FIREFOX_OS
          ].some(function (item) {
            return deviceInfo.device == item;
          });
        };

        deviceInfo.isDesktop = function () {
          return [
            DEVICES.PS4,
            DEVICES.CHROME_BOOK,
            DEVICES.UNKNOWN
          ].some(function (item) {
            return deviceInfo.device == item;
          });
        };

        return deviceInfo;
      }
    ])
    .directive("deviceDetector", ["deviceDetector", function (deviceDetector) {
      return {
        restrict: "A",
        link: function (scope, elm/* , attrs*/) {
          elm.addClass("os-" + deviceDetector.os);
          elm.addClass("browser-" + deviceDetector.browser);
          elm.addClass("device-" + deviceDetector.device);
        }
      };
    }]);
})(angular);

/**
 * Angular Google Analytics - Easy tracking for your AngularJS application
 * @version v0.0.18 - 2015-07-29
 * @link http://github.com/revolunet/angular-google-analytics
 * @author Julien Bouquillon <julien@revolunet.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (n, t, e) {"use strict";e.module("angular-google-analytics", []).provider("Analytics", function () {var i, a, c, r, o, s, u = !1, g = !0, d = "", l = !1, m = "$routeChangeSuccess", _ = "auto", f = !1, h = !1, p = !1, k = !1, v = !1, E = { allowLinker: !0 }, y = !1, w = !1;this._logs = [], this.setAccount = function (n) {return i = n, !0;}, this.trackPages = function (n) {return g = n, !0;}, this.trackPrefix = function (n) {return d = n, !0;}, this.setDomainName = function (n) {return c = n, !0;}, this.useDisplayFeatures = function (n) {return a = !!n, !0;}, this.useAnalytics = function (n) {return l = !!n, !0;}, this.useEnhancedLinkAttribution = function (n) {return p = !!n, !0;}, this.useCrossDomainLinker = function (n) {return v = !!n, !0;}, this.setCrossLinkDomains = function (n) {return s = n, !0;}, this.setPageEvent = function (n) {return m = n, !0;}, this.setCookieConfig = function (n) {return _ = n, !0;}, this.useECommerce = function (n, t) {return f = !!n, h = !!t, !0;}, this.setRemoveRegExp = function (n) {return n instanceof RegExp ? (r = n, !0) : !1;}, this.setExperimentId = function (n) {return o = n, !0;}, this.ignoreFirstPageLoad = function (n) {return k = !!n, !0;}, this.trackUrlParams = function (n) {return y = !!n, !0;}, this.delayScriptTag = function (n) {return w = !!n, !0;}, this.$get = ["$document", "$location", "$log", "$rootScope", "$window", function (T, A, P, b, q) {function C(n) {!l && q._gaq && "function" === typeof n && n();} function I(n) {l && q.ga && "function" === typeof n && n();} function j(n, t) {return !e.isUndefined(t) && "name" in t && t.name ? t.name + "." + n : n;} function L(n, t) {return n in t && t[n];} var S = this, x = function () {var n = y ? A.url() : A.path();return r ? n.replace(r, "") : n;}, D = function () {var n = { utm_source: "campaignSource", utm_medium: "campaignMedium", utm_term: "campaignTerm", utm_content: "campaignContent", utm_campaign: "campaignName" }, t = {};return e.forEach(A.search(), function (i, a) {var c = n[a];e.isDefined(c) && (t[c] = i);}), t;};return this._log = function () {arguments.length > 0 && (arguments.length > 1 && "warn" === arguments[0] && P.warn(Array.prototype.slice.call(arguments, 1)), this._logs.push(arguments));}, this._createScriptTag = function () {if (!i) return S._log("warn", "No account id set to create script tag"), undefined;if (u) return S._log("warn", "Script tag already created"), undefined;q._gaq = [], q._gaq.push(["_setAccount", i]), c && q._gaq.push(["_setDomainName", c]), p && q._gaq.push(["_require", "inpage_linkid", "//www.google-analytics.com/plugins/ga/inpage_linkid.js"]), g && !k && (r ? q._gaq.push(["_trackPageview", x()]) : q._gaq.push(["_trackPageview"]));var n;return n = a ? ("https:" === t.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js" : ("https:" === t.location.protocol ? "https://ssl" : "http://www") + ".google-analytics.com/ga.js", function () {var t = T[0], e = t.createElement("script");e.type = "text/javascript", e.async = !0, e.src = n;var i = t.getElementsByTagName("script")[0];i.parentNode.insertBefore(e, i);}(n), u = !0, !0;}, this._createAnalyticsScriptTag = function () {if (!i) return S._log("warn", "No account id set to create analytics script tag"), undefined;if (u) return S._log("warn", "Analytics script tag already created"), undefined;if (function (n, t, e, i, a, c, r) {n.GoogleAnalyticsObject = a, n[a] = n[a] || function () {(n[a].q = n[a].q || []).push(arguments);}, n[a].l = 1 * new Date, c = t.createElement(e), r = t.getElementsByTagName(e)[0], c.async = 1, c.src = i, r.parentNode.insertBefore(c, r);}(n, t, "script", "//www.google-analytics.com/analytics.js", "ga"), e.isArray(i) ? i.forEach(function (n) {var t, i = "cookieConfig" in n ? n.cookieConfig : _;L("crossDomainLinker", n) && (n.allowLinker = n.crossDomainLinker), e.forEach(["name", "allowLinker"], function (i) {i in n && (e.isUndefined(t) && (t = {}), t[i] = n[i]);}), e.isUndefined(t) ? q.ga("create", n.tracker, i) : q.ga("create", n.tracker, i, t), t && "allowLinker" in t && t.allowLinker && (q.ga(j("require", n), "linker"), L("crossLinkDomains", n) && q.ga(j("linker:autoLink", n), n.crossLinkDomains));}) : v ? (q.ga("create", i, _, E), q.ga("require", "linker"), s && q.ga("linker:autoLink", s)) : q.ga("create", i, _), a && q.ga("require", "displayfeatures"), g && !k && q.ga("send", "pageview", x()), q.ga && (f && (h ? q.ga("require", "ec", "ec.js") : q.ga("require", "ecommerce", "ecommerce.js")), p && q.ga("require", "linkid", "linkid.js"), o)) {var c = t.createElement("script"), r = t.getElementsByTagName("script")[0];c.src = "//www.google-analytics.com/cx/api.js?experiment=" + o, r.parentNode.insertBefore(c, r);} return u = !0, !0;}, this._ecommerceEnabled = function () {return f && !h;}, this._enhancedEcommerceEnabled = function () {return f && h;}, this._trackPage = function (n, t, a) {var c = this, r = arguments;n = n ? n : x(), t = t ? t : T[0].title, C(function () {q._gaq.push(["_set", "title", t]), q._gaq.push(["_trackPageview", d + n]), c._log("_trackPageview", n, t, r);}), I(function () {var o = { page: d + n, title: t };e.extend(o, D()), e.isObject(a) && e.extend(o, a), e.isArray(i) ? i.forEach(function (n) {q.ga(j("send", n), "pageview", o);}) : q.ga("send", "pageview", o), c._log("pageview", n, t, r);});}, this._trackEvent = function (n, t, a, c, r, o) {var s = this, u = arguments;C(function () {q._gaq.push(["_trackEvent", n, t, a, c, !!r]), s._log("trackEvent", u);}), I(function () {var g = {};e.isDefined(r) && (g.nonInteraction = !!r), e.isObject(o) && e.extend(g, o), e.isArray(i) ? i.forEach(function (e) {L("trackEvent", e) && q.ga(j("send", e), "event", n, t, a, c, g);}) : q.ga("send", "event", n, t, a, c, g), s._log("event", u);});}, this._addTrans = function (n, t, e, i, a, c, r, o, s) {var u = this, g = arguments;C(function () {q._gaq.push(["_addTrans", n, t, e, i, a, c, r, o]), u._log("_addTrans", g);}), I(function () {u._ecommerceEnabled() && (q.ga("ecommerce:addTransaction", { id: n, affiliation: t, revenue: e, tax: i, shipping: a, currency: s || "USD" }), u._log("ecommerce:addTransaction", g));});}, this._addItem = function (n, t, e, i, a, c) {var r = this, o = arguments;C(function () {q._gaq.push(["_addItem", n, t, e, i, a, c]), r._log("_addItem", o);}), I(function () {r._ecommerceEnabled() && (q.ga("ecommerce:addItem", { id: n, name: e, sku: t, category: i, price: a, quantity: c }), r._log("ecommerce:addItem", o));});}, this._trackTrans = function () {var n = this, t = arguments;C(function () {q._gaq.push(["_trackTrans"]), n._log("_trackTrans", t);}), I(function () {n._ecommerceEnabled() && (q.ga("ecommerce:send"), n._log("ecommerce:send", t));});}, this._clearTrans = function () {var n = this, t = arguments;I(function () {n._ecommerceEnabled() && (q.ga("ecommerce:clear"), n._log("ecommerce:clear", t));});}, this._addProduct = function (n, t, e, i, a, c, r, o, s) {var u = this, g = arguments;C(function () {q._gaq.push(["_addProduct", n, t, e, i, a, c, r, o, s]), u._log("_addProduct", g);}), I(function () {u._enhancedEcommerceEnabled() && (q.ga("ec:addProduct", { id: n, name: t, category: e, brand: i, variant: a, price: c, quantity: r, coupon: o, position: s }), u._log("ec:addProduct", g));});}, this._addImpression = function (n, t, e, i, a, c, r, o) {var s = this, u = arguments;C(function () {q._gaq.push(["_addImpression", n, t, e, i, a, c, r, o]), s._log("_addImpression", u);}), I(function () {s._enhancedEcommerceEnabled() && (q.ga("ec:addImpression", { id: n, name: t, category: a, brand: i, variant: c, list: e, position: r, price: o }), s._log("ec:addImpression", u));});}, this._addPromo = function (n, t, e, i) {var a = this, c = arguments;C(function () {q._gaq.push(["_addPromo", n, t, e, i]), a._log("_addPromo", arguments);}), I(function () {a._enhancedEcommerceEnabled() && (q.ga("ec:addPromo", { id: n, name: t, creative: e, position: i }), a._log("ec:addPromo", c));});}, this._getActionFieldObject = function (n, t, e, i, a, c, r, o, s) {var u = {};return n && (u.id = n), t && (u.affiliation = t), e && (u.revenue = e), i && (u.tax = i), a && (u.shipping = a), c && (u.coupon = c), r && (u.list = r), o && (u.step = o), s && (u.option = s), u;}, this._setAction = function (n, t) {var e = this, i = arguments;C(function () {q._gaq.push(["_setAction", n, t]), e._log("__setAction", i);}), I(function () {e._enhancedEcommerceEnabled() && (q.ga("ec:setAction", n, t), e._log("ec:setAction", i));});}, this._trackTransaction = function (n, t, e, i, a, c, r, o, s) {this._setAction("purchase", this._getActionFieldObject(n, t, e, i, a, c, r, o, s));}, this._trackRefund = function (n) {this._setAction("refund", this._getActionFieldObject(n));}, this._trackCheckOut = function (n, t) {this._setAction("checkout", this._getActionFieldObject(null, null, null, null, null, null, null, n, t));}, this._trackCart = function (n) {-1 !== ["add", "remove"].indexOf(n) && (this._setAction(n), this._send("event", "UX", "click", n + " to cart"));}, this._promoClick = function (n) {this._setAction("promo_click"), this._send("event", "Internal Promotions", "click", n);}, this._productClick = function (n) {this._setAction("click", this._getActionFieldObject(null, null, null, null, null, null, n, null, null)), this._send("event", "UX", "click", n);}, this._send = function () {var n = this, t = Array.prototype.slice.call(arguments);t.unshift("send"), I(function () {q.ga.apply(this, t), n._log(t);});}, this._pageView = function () {this._send("pageview");}, this._set = function (n, t) {var e = this;I(function () {q.ga("set", n, t), e._log("set", n, t);});}, w || (l ? this._createAnalyticsScriptTag() : this._createScriptTag()), g && b.$on(m, function () {S._trackPage();}), this._trackTimings = function (n, t, e, i) {this._send("timing", n, t, e, i);}, { _logs: S._logs, displayFeatures: a, ecommerce: f, enhancedEcommerce: h, enhancedLinkAttribution: p, getUrl: x, experimentId: o, ignoreFirstPageLoad: k, delayScriptTag: w, setCookieConfig: S._setCookieConfig, getCookieConfig: function () {return _;}, createAnalyticsScriptTag: function (n) {return n && (_ = n), S._createAnalyticsScriptTag();}, createScriptTag: function (n) {return n && (_ = n), S._createScriptTag();}, ecommerceEnabled: function () {return S._ecommerceEnabled();}, enhancedEcommerceEnabled: function () {return S._enhancedEcommerceEnabled();}, trackPage: function (n, t, e) {S._trackPage(n, t, e);}, trackEvent: function (n, t, e, i, a, c) {S._trackEvent(n, t, e, i, a, c);}, addTrans: function (n, t, e, i, a, c, r, o, s) {S._addTrans(n, t, e, i, a, c, r, o, s);}, addItem: function (n, t, e, i, a, c) {S._addItem(n, t, e, i, a, c);}, trackTrans: function () {S._trackTrans();}, clearTrans: function () {S._clearTrans();}, addProduct: function (n, t, e, i, a, c, r, o, s) {S._addProduct(n, t, e, i, a, c, r, o, s);}, addPromo: function (n, t, e, i) {S._addPromo(n, t, e, i);}, addImpression: function (n, t, e, i, a, c, r, o) {S._addImpression(n, t, e, i, a, c, r, o);}, productClick: function (n) {S._productClick(n);}, promoClick: function (n) {S._promoClick(n);}, trackDetail: function () {S._setAction("detail"), S._pageView();}, trackCart: function (n) {S._trackCart(n);}, trackCheckout: function (n, t) {S._trackCheckOut(n, t);}, trackTimings: function (n, t, e, i) {S._trackTimings(n, t, e, i);}, trackTransaction: function (n, t, e, i, a, c, r, o, s) {S._trackTransaction(n, t, e, i, a, c, r, o, s);}, setAction: function (n, t) {S._setAction(n, t);}, send: function (n) {S._send(n);}, pageView: function () {S._pageView();}, set: function (n, t) {S._set(n, t);} };}];}).directive("gaTrackEvent", ["Analytics", "$parse", function (n, t) {return { restrict: "A", link: function (e, i, a) {var c = t(a.gaTrackEvent);i.bind("click", function () {(!a.gaTrackEventIf || e.$eval(a.gaTrackEventIf)) && c.length > 1 && n.trackEvent.apply(n, c(e));});} };}]);})(window, document, window.angular);

/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === "object" && typeof module === "object")
    module.exports = factory();
  else if (typeof define === "function" && define.amd)
    define("pdfjs-dist/build/pdf", [], factory);
  else if (typeof exports === "object")
    exports["pdfjs-dist/build/pdf"] = factory();
  else
    root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
})(this, function () {
  return /** ****/ (function (modules) { // webpackBootstrap
    /** ****/ 	// The module cache
    /** ****/ 	var installedModules = {};
    /** ****/
    /** ****/ 	// The require function
    /** ****/ 	function __w_pdfjs_require__(moduleId) {
      /** ****/
      /** ****/ 		// Check if module is in cache
      /** ****/ 		if (installedModules[moduleId]) {
        /** ****/ 			return installedModules[moduleId].exports;
        /** ****/ 		}
      /** ****/ 		// Create a new module (and put it into the cache)
      /** ****/ 		var module = installedModules[moduleId] = {
        /** ****/ 			i: moduleId,
        /** ****/ 			l: false,
        /** ****/ 			exports: {}
        /** ****/ 		};
      /** ****/
      /** ****/ 		// Execute the module function
      /** ****/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
      /** ****/
      /** ****/ 		// Flag the module as loaded
      /** ****/ 		module.l = true;
      /** ****/
      /** ****/ 		// Return the exports of the module
      /** ****/ 		return module.exports;
      /** ****/ 	}
    /** ****/
    /** ****/
    /** ****/ 	// expose the modules object (__webpack_modules__)
    /** ****/ 	__w_pdfjs_require__.m = modules;
    /** ****/
    /** ****/ 	// expose the module cache
    /** ****/ 	__w_pdfjs_require__.c = installedModules;
    /** ****/
    /** ****/ 	// define getter function for harmony exports
    /** ****/ 	__w_pdfjs_require__.d = function (exports, name, getter) {
      /** ****/ 		if (!__w_pdfjs_require__.o(exports, name)) {
        /** ****/ 			Object.defineProperty(exports, name, {
          /** ****/ 				configurable: false,
          /** ****/ 				enumerable: true,
          /** ****/ 				get: getter
          /** ****/ 			});
        /** ****/ 		}
      /** ****/ 	};
    /** ****/
    /** ****/ 	// getDefaultExport function for compatibility with non-harmony modules
    /** ****/ 	__w_pdfjs_require__.n = function (module) {
      /** ****/ 		var getter = module && module.__esModule ?
      /** ****/ 			function getDefault() { return module["default"]; } :
      /** ****/ 			function getModuleExports() { return module; };
      /** ****/ 		__w_pdfjs_require__.d(getter, "a", getter);
      /** ****/ 		return getter;
      /** ****/ 	};
    /** ****/
    /** ****/ 	// Object.prototype.hasOwnProperty.call
    /** ****/ 	__w_pdfjs_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
    /** ****/
    /** ****/ 	// __webpack_public_path__
    /** ****/ 	__w_pdfjs_require__.p = "";
    /** ****/
    /** ****/ 	// Load entry module and return exports
    /** ****/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 75);
    /** ****/ })
  /** **********************************************************************/
  /** ****/ ([
    /* 0 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      __w_pdfjs_require__(76);

      var _streams_polyfill = __w_pdfjs_require__(115);

      var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
      var NativeImageDecoding = {
        NONE: "none",
        DECODE: "decode",
        DISPLAY: "display"
      };
      var TextRenderingMode = {
        FILL: 0,
        STROKE: 1,
        FILL_STROKE: 2,
        INVISIBLE: 3,
        FILL_ADD_TO_PATH: 4,
        STROKE_ADD_TO_PATH: 5,
        FILL_STROKE_ADD_TO_PATH: 6,
        ADD_TO_PATH: 7,
        FILL_STROKE_MASK: 3,
        ADD_TO_PATH_FLAG: 4
      };
      var ImageKind = {
        GRAYSCALE_1BPP: 1,
        RGB_24BPP: 2,
        RGBA_32BPP: 3
      };
      var AnnotationType = {
        TEXT: 1,
        LINK: 2,
        FREETEXT: 3,
        LINE: 4,
        SQUARE: 5,
        CIRCLE: 6,
        POLYGON: 7,
        POLYLINE: 8,
        HIGHLIGHT: 9,
        UNDERLINE: 10,
        SQUIGGLY: 11,
        STRIKEOUT: 12,
        STAMP: 13,
        CARET: 14,
        INK: 15,
        POPUP: 16,
        FILEATTACHMENT: 17,
        SOUND: 18,
        MOVIE: 19,
        WIDGET: 20,
        SCREEN: 21,
        PRINTERMARK: 22,
        TRAPNET: 23,
        WATERMARK: 24,
        THREED: 25,
        REDACT: 26
      };
      var AnnotationFlag = {
        INVISIBLE: 0x01,
        HIDDEN: 0x02,
        PRINT: 0x04,
        NOZOOM: 0x08,
        NOROTATE: 0x10,
        NOVIEW: 0x20,
        READONLY: 0x40,
        LOCKED: 0x80,
        TOGGLENOVIEW: 0x100,
        LOCKEDCONTENTS: 0x200
      };
      var AnnotationFieldFlag = {
        READONLY: 0x0000001,
        REQUIRED: 0x0000002,
        NOEXPORT: 0x0000004,
        MULTILINE: 0x0001000,
        PASSWORD: 0x0002000,
        NOTOGGLETOOFF: 0x0004000,
        RADIO: 0x0008000,
        PUSHBUTTON: 0x0010000,
        COMBO: 0x0020000,
        EDIT: 0x0040000,
        SORT: 0x0080000,
        FILESELECT: 0x0100000,
        MULTISELECT: 0x0200000,
        DONOTSPELLCHECK: 0x0400000,
        DONOTSCROLL: 0x0800000,
        COMB: 0x1000000,
        RICHTEXT: 0x2000000,
        RADIOSINUNISON: 0x2000000,
        COMMITONSELCHANGE: 0x4000000
      };
      var AnnotationBorderStyleType = {
        SOLID: 1,
        DASHED: 2,
        BEVELED: 3,
        INSET: 4,
        UNDERLINE: 5
      };
      var StreamType = {
        UNKNOWN: 0,
        FLATE: 1,
        LZW: 2,
        DCT: 3,
        JPX: 4,
        JBIG: 5,
        A85: 6,
        AHX: 7,
        CCF: 8,
        RL: 9
      };
      var FontType = {
        UNKNOWN: 0,
        TYPE1: 1,
        TYPE1C: 2,
        CIDFONTTYPE0: 3,
        CIDFONTTYPE0C: 4,
        TRUETYPE: 5,
        CIDFONTTYPE2: 6,
        TYPE3: 7,
        OPENTYPE: 8,
        TYPE0: 9,
        MMTYPE1: 10
      };
      var VERBOSITY_LEVELS = {
        errors: 0,
        warnings: 1,
        infos: 5
      };
      var CMapCompressionType = {
        NONE: 0,
        BINARY: 1,
        STREAM: 2
      };
      var OPS = {
        dependency: 1,
        setLineWidth: 2,
        setLineCap: 3,
        setLineJoin: 4,
        setMiterLimit: 5,
        setDash: 6,
        setRenderingIntent: 7,
        setFlatness: 8,
        setGState: 9,
        save: 10,
        restore: 11,
        transform: 12,
        moveTo: 13,
        lineTo: 14,
        curveTo: 15,
        curveTo2: 16,
        curveTo3: 17,
        closePath: 18,
        rectangle: 19,
        stroke: 20,
        closeStroke: 21,
        fill: 22,
        eoFill: 23,
        fillStroke: 24,
        eoFillStroke: 25,
        closeFillStroke: 26,
        closeEOFillStroke: 27,
        endPath: 28,
        clip: 29,
        eoClip: 30,
        beginText: 31,
        endText: 32,
        setCharSpacing: 33,
        setWordSpacing: 34,
        setHScale: 35,
        setLeading: 36,
        setFont: 37,
        setTextRenderingMode: 38,
        setTextRise: 39,
        moveText: 40,
        setLeadingMoveText: 41,
        setTextMatrix: 42,
        nextLine: 43,
        showText: 44,
        showSpacedText: 45,
        nextLineShowText: 46,
        nextLineSetSpacingShowText: 47,
        setCharWidth: 48,
        setCharWidthAndBounds: 49,
        setStrokeColorSpace: 50,
        setFillColorSpace: 51,
        setStrokeColor: 52,
        setStrokeColorN: 53,
        setFillColor: 54,
        setFillColorN: 55,
        setStrokeGray: 56,
        setFillGray: 57,
        setStrokeRGBColor: 58,
        setFillRGBColor: 59,
        setStrokeCMYKColor: 60,
        setFillCMYKColor: 61,
        shadingFill: 62,
        beginInlineImage: 63,
        beginImageData: 64,
        endInlineImage: 65,
        paintXObject: 66,
        markPoint: 67,
        markPointProps: 68,
        beginMarkedContent: 69,
        beginMarkedContentProps: 70,
        endMarkedContent: 71,
        beginCompat: 72,
        endCompat: 73,
        paintFormXObjectBegin: 74,
        paintFormXObjectEnd: 75,
        beginGroup: 76,
        endGroup: 77,
        beginAnnotations: 78,
        endAnnotations: 79,
        beginAnnotation: 80,
        endAnnotation: 81,
        paintJpegXObject: 82,
        paintImageMaskXObject: 83,
        paintImageMaskXObjectGroup: 84,
        paintImageXObject: 85,
        paintInlineImageXObject: 86,
        paintInlineImageXObjectGroup: 87,
        paintImageXObjectRepeat: 88,
        paintImageMaskXObjectRepeat: 89,
        paintSolidColorImageMask: 90,
        constructPath: 91
      };
      var verbosity = VERBOSITY_LEVELS.warnings;
      function setVerbosityLevel(level) {
        verbosity = level;
      }
      function getVerbosityLevel() {
        return verbosity;
      }
      function info(msg) {
        if (verbosity >= VERBOSITY_LEVELS.infos) {
          console.log("Info: " + msg);
        }
      }
      function warn(msg) {
        if (verbosity >= VERBOSITY_LEVELS.warnings) {
          console.log("Warning: " + msg);
        }
      }
      function deprecated(details) {
        console.log("Deprecated API usage: " + details);
      }
      function unreachable(msg) {
        throw new Error(msg);
      }
      function assert(cond, msg) {
        if (!cond) {
          unreachable(msg);
        }
      }
      var UNSUPPORTED_FEATURES = {
        unknown: "unknown",
        forms: "forms",
        javaScript: "javaScript",
        smask: "smask",
        shadingPattern: "shadingPattern",
        font: "font"
      };
      function isSameOrigin(baseUrl, otherUrl) {
        try {
          var base = new URL(baseUrl);
          if (!base.origin || base.origin === "null") {
            return false;
          }
        } catch (e) {
          return false;
        }
        var other = new URL(otherUrl, base);
        return base.origin === other.origin;
      }
      function isValidProtocol(url) {
        if (!url) {
          return false;
        }
        switch (url.protocol) {
          case "http:":
          case "https:":
          case "ftp:":
          case "mailto:":
          case "tel:":
            return true;
          default:
            return false;
        }
      }
      function createValidAbsoluteUrl(url, baseUrl) {
        if (!url) {
          return null;
        }
        try {
          var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
          if (isValidProtocol(absoluteUrl)) {
            return absoluteUrl;
          }
        } catch (ex) {}
        return null;
      }
      function shadow(obj, prop, value) {
        Object.defineProperty(obj, prop, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: false
        });
        return value;
      }
      function getLookupTableFactory(initializer) {
        var lookup;
        return function () {
          if (initializer) {
            lookup = Object.create(null);
            initializer(lookup);
            initializer = null;
          }
          return lookup;
        };
      }
      var PasswordResponses = {
        NEED_PASSWORD: 1,
        INCORRECT_PASSWORD: 2
      };
      var PasswordException = function PasswordExceptionClosure() {
        function PasswordException(msg, code) {
          this.name = "PasswordException";
          this.message = msg;
          this.code = code;
        }
        PasswordException.prototype = new Error();
        PasswordException.constructor = PasswordException;
        return PasswordException;
      }();
      var UnknownErrorException = function UnknownErrorExceptionClosure() {
        function UnknownErrorException(msg, details) {
          this.name = "UnknownErrorException";
          this.message = msg;
          this.details = details;
        }
        UnknownErrorException.prototype = new Error();
        UnknownErrorException.constructor = UnknownErrorException;
        return UnknownErrorException;
      }();
      var InvalidPDFException = function InvalidPDFExceptionClosure() {
        function InvalidPDFException(msg) {
          this.name = "InvalidPDFException";
          this.message = msg;
        }
        InvalidPDFException.prototype = new Error();
        InvalidPDFException.constructor = InvalidPDFException;
        return InvalidPDFException;
      }();
      var MissingPDFException = function MissingPDFExceptionClosure() {
        function MissingPDFException(msg) {
          this.name = "MissingPDFException";
          this.message = msg;
        }
        MissingPDFException.prototype = new Error();
        MissingPDFException.constructor = MissingPDFException;
        return MissingPDFException;
      }();
      var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
        function UnexpectedResponseException(msg, status) {
          this.name = "UnexpectedResponseException";
          this.message = msg;
          this.status = status;
        }
        UnexpectedResponseException.prototype = new Error();
        UnexpectedResponseException.constructor = UnexpectedResponseException;
        return UnexpectedResponseException;
      }();
      var NotImplementedException = function NotImplementedExceptionClosure() {
        function NotImplementedException(msg) {
          this.message = msg;
        }
        NotImplementedException.prototype = new Error();
        NotImplementedException.prototype.name = "NotImplementedException";
        NotImplementedException.constructor = NotImplementedException;
        return NotImplementedException;
      }();
      var MissingDataException = function MissingDataExceptionClosure() {
        function MissingDataException(begin, end) {
          this.begin = begin;
          this.end = end;
          this.message = "Missing data [" + begin + ", " + end + ")";
        }
        MissingDataException.prototype = new Error();
        MissingDataException.prototype.name = "MissingDataException";
        MissingDataException.constructor = MissingDataException;
        return MissingDataException;
      }();
      var XRefParseException = function XRefParseExceptionClosure() {
        function XRefParseException(msg) {
          this.message = msg;
        }
        XRefParseException.prototype = new Error();
        XRefParseException.prototype.name = "XRefParseException";
        XRefParseException.constructor = XRefParseException;
        return XRefParseException;
      }();
      var FormatError = function FormatErrorClosure() {
        function FormatError(msg) {
          this.message = msg;
        }
        FormatError.prototype = new Error();
        FormatError.prototype.name = "FormatError";
        FormatError.constructor = FormatError;
        return FormatError;
      }();
      var AbortException = function AbortExceptionClosure() {
        function AbortException(msg) {
          this.name = "AbortException";
          this.message = msg;
        }
        AbortException.prototype = new Error();
        AbortException.constructor = AbortException;
        return AbortException;
      }();
      var NullCharactersRegExp = /\x00/g;
      function removeNullCharacters(str) {
        if (typeof str !== "string") {
          warn("The argument for removeNullCharacters must be a string.");
          return str;
        }
        return str.replace(NullCharactersRegExp, "");
      }
      function bytesToString(bytes) {
        assert(bytes !== null && (typeof bytes === "undefined" ? "undefined" : _typeof(bytes)) === "object" && bytes.length !== undefined, "Invalid argument for bytesToString");
        var length = bytes.length;
        var MAX_ARGUMENT_COUNT = 8192;
        if (length < MAX_ARGUMENT_COUNT) {
          return String.fromCharCode.apply(null, bytes);
        }
        var strBuf = [];
        for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
          var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
          var chunk = bytes.subarray(i, chunkEnd);
          strBuf.push(String.fromCharCode.apply(null, chunk));
        }
        return strBuf.join("");
      }
      function stringToBytes(str) {
        assert(typeof str === "string", "Invalid argument for stringToBytes");
        var length = str.length;
        var bytes = new Uint8Array(length);
        for (var i = 0; i < length; ++i) {
          bytes[i] = str.charCodeAt(i) & 0xFF;
        }
        return bytes;
      }
      function arrayByteLength(arr) {
        if (arr.length !== undefined) {
          return arr.length;
        }
        assert(arr.byteLength !== undefined);
        return arr.byteLength;
      }
      function arraysToBytes(arr) {
        if (arr.length === 1 && arr[0] instanceof Uint8Array) {
          return arr[0];
        }
        var resultLength = 0;
        var i,
          ii = arr.length;
        var item, itemLength;
        for (i = 0; i < ii; i++) {
          item = arr[i];
          itemLength = arrayByteLength(item);
          resultLength += itemLength;
        }
        var pos = 0;
        var data = new Uint8Array(resultLength);
        for (i = 0; i < ii; i++) {
          item = arr[i];
          if (!(item instanceof Uint8Array)) {
            if (typeof item === "string") {
              item = stringToBytes(item);
            } else {
              item = new Uint8Array(item);
            }
          }
          itemLength = item.byteLength;
          data.set(item, pos);
          pos += itemLength;
        }
        return data;
      }
      function string32(value) {
        return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
      }
      function log2(x) {
        var n = 1,
          i = 0;
        while (x > n) {
          n <<= 1;
          i++;
        }
        return i;
      }
      function readInt8(data, start) {
        return data[start] << 24 >> 24;
      }
      function readUint16(data, offset) {
        return data[offset] << 8 | data[offset + 1];
      }
      function readUint32(data, offset) {
        return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
      }
      function isLittleEndian() {
        var buffer8 = new Uint8Array(4);
        buffer8[0] = 1;
        var view32 = new Uint32Array(buffer8.buffer, 0, 1);
        return view32[0] === 1;
      }
      function isEvalSupported() {
        try {
          new Function("");
          return true;
        } catch (e) {
          return false;
        }
      }
      var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
      var Util = function UtilClosure() {
        function Util() {}
        var rgbBuf = ["rgb(", 0, ",", 0, ",", 0, ")"];
        Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
          rgbBuf[1] = r;
          rgbBuf[3] = g;
          rgbBuf[5] = b;
          return rgbBuf.join("");
        };
        Util.transform = function Util_transform(m1, m2) {
          return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
        };
        Util.applyTransform = function Util_applyTransform(p, m) {
          var xt = p[0] * m[0] + p[1] * m[2] + m[4];
          var yt = p[0] * m[1] + p[1] * m[3] + m[5];
          return [xt, yt];
        };
        Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
          var d = m[0] * m[3] - m[1] * m[2];
          var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
          var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
          return [xt, yt];
        };
        Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
          var p1 = Util.applyTransform(r, m);
          var p2 = Util.applyTransform(r.slice(2, 4), m);
          var p3 = Util.applyTransform([r[0], r[3]], m);
          var p4 = Util.applyTransform([r[2], r[1]], m);
          return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
        };
        Util.inverseTransform = function Util_inverseTransform(m) {
          var d = m[0] * m[3] - m[1] * m[2];
          return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
        };
        Util.apply3dTransform = function Util_apply3dTransform(m, v) {
          return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
        };
        Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
          var transpose = [m[0], m[2], m[1], m[3]];
          var a = m[0] * transpose[0] + m[1] * transpose[2];
          var b = m[0] * transpose[1] + m[1] * transpose[3];
          var c = m[2] * transpose[0] + m[3] * transpose[2];
          var d = m[2] * transpose[1] + m[3] * transpose[3];
          var first = (a + d) / 2;
          var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
          var sx = first + second || 1;
          var sy = first - second || 1;
          return [Math.sqrt(sx), Math.sqrt(sy)];
        };
        Util.normalizeRect = function Util_normalizeRect(rect) {
          var r = rect.slice(0);
          if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
          }
          if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
          }
          return r;
        };
        Util.intersect = function Util_intersect(rect1, rect2) {
          function compare(a, b) {
            return a - b;
          }
          var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
            orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
            result = [];
          rect1 = Util.normalizeRect(rect1);
          rect2 = Util.normalizeRect(rect2);
          if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
            result[0] = orderedX[1];
            result[2] = orderedX[2];
          } else {
            return false;
          }
          if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
            result[1] = orderedY[1];
            result[3] = orderedY[2];
          } else {
            return false;
          }
          return result;
        };
        var ROMAN_NUMBER_MAP = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
        Util.toRoman = function Util_toRoman(number, lowerCase) {
          assert(Number.isInteger(number) && number > 0, "The number should be a positive integer.");
          var pos,
            romanBuf = [];
          while (number >= 1000) {
            number -= 1000;
            romanBuf.push("M");
          }
          pos = number / 100 | 0;
          number %= 100;
          romanBuf.push(ROMAN_NUMBER_MAP[pos]);
          pos = number / 10 | 0;
          number %= 10;
          romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
          romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
          var romanStr = romanBuf.join("");
          return lowerCase ? romanStr.toLowerCase() : romanStr;
        };
        Util.appendToArray = function Util_appendToArray(arr1, arr2) {
          Array.prototype.push.apply(arr1, arr2);
        };
        Util.prependToArray = function Util_prependToArray(arr1, arr2) {
          Array.prototype.unshift.apply(arr1, arr2);
        };
        Util.extendObj = function extendObj(obj1, obj2) {
          for (var key in obj2) {
            obj1[key] = obj2[key];
          }
        };
        Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
          while (dict && !dict.has(name)) {
            dict = dict.get("Parent");
          }
          if (!dict) {
            return null;
          }
          return getArray ? dict.getArray(name) : dict.get(name);
        };
        Util.inherit = function Util_inherit(sub, base, prototype) {
          sub.prototype = Object.create(base.prototype);
          sub.prototype.constructor = sub;
          for (var prop in prototype) {
            sub.prototype[prop] = prototype[prop];
          }
        };
        Util.loadScript = function Util_loadScript(src, callback) {
          var script = document.createElement("script");
          var loaded = false;
          script.setAttribute("src", src);
          if (callback) {
            script.onload = function () {
              if (!loaded) {
                callback();
              }
              loaded = true;
            };
          }
          document.getElementsByTagName("head")[0].appendChild(script);
        };
        return Util;
      }();
      var PageViewport = function PageViewportClosure() {
        function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
          this.viewBox = viewBox;
          this.scale = scale;
          this.rotation = rotation;
          this.offsetX = offsetX;
          this.offsetY = offsetY;
          var centerX = (viewBox[2] + viewBox[0]) / 2;
          var centerY = (viewBox[3] + viewBox[1]) / 2;
          var rotateA, rotateB, rotateC, rotateD;
          rotation = rotation % 360;
          rotation = rotation < 0 ? rotation + 360 : rotation;
          switch (rotation) {
            case 180:
              rotateA = -1;
              rotateB = 0;
              rotateC = 0;
              rotateD = 1;
              break;
            case 90:
              rotateA = 0;
              rotateB = 1;
              rotateC = 1;
              rotateD = 0;
              break;
            case 270:
              rotateA = 0;
              rotateB = -1;
              rotateC = -1;
              rotateD = 0;
              break;
            default:
              rotateA = 1;
              rotateB = 0;
              rotateC = 0;
              rotateD = -1;
              break;
          }
          if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
          }
          var offsetCanvasX, offsetCanvasY;
          var width, height;
          if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = Math.abs(viewBox[3] - viewBox[1]) * scale;
            height = Math.abs(viewBox[2] - viewBox[0]) * scale;
          } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = Math.abs(viewBox[2] - viewBox[0]) * scale;
            height = Math.abs(viewBox[3] - viewBox[1]) * scale;
          }
          this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
          this.width = width;
          this.height = height;
          this.fontScale = scale;
        }
        PageViewport.prototype = {
          clone: function PageViewPort_clone(args) {
            args = args || {};
            var scale = "scale" in args ? args.scale : this.scale;
            var rotation = "rotation" in args ? args.rotation : this.rotation;
            return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
          },
          convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
            return Util.applyTransform([x, y], this.transform);
          },
          convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
            var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
            var br = Util.applyTransform([rect[2], rect[3]], this.transform);
            return [tl[0], tl[1], br[0], br[1]];
          },
          convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
            return Util.applyInverseTransform([x, y], this.transform);
          }
        };
        return PageViewport;
      }();
      var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
      function stringToPDFString(str) {
        var i,
          n = str.length,
          strBuf = [];
        if (str[0] === "\xFE" && str[1] === "\xFF") {
          for (i = 2; i < n; i += 2) {
            strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
          }
        } else {
          for (i = 0; i < n; ++i) {
            var code = PDFStringTranslateTable[str.charCodeAt(i)];
            strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
          }
        }
        return strBuf.join("");
      }
      function stringToUTF8String(str) {
        return decodeURIComponent(escape(str));
      }
      function utf8StringToString(str) {
        return unescape(encodeURIComponent(str));
      }
      function isEmptyObj(obj) {
        for (var key in obj) {
          return false;
        }
        return true;
      }
      function isBool(v) {
        return typeof v === "boolean";
      }
      function isNum(v) {
        return typeof v === "number";
      }
      function isString(v) {
        return typeof v === "string";
      }
      function isArrayBuffer(v) {
        return (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v !== null && v.byteLength !== undefined;
      }
      function isSpace(ch) {
        return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
      }
      function isNodeJS() {
        return (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process + "" === "[object process]";
      }
      function createPromiseCapability() {
        var capability = {};
        capability.promise = new Promise(function (resolve, reject) {
          capability.resolve = resolve;
          capability.reject = reject;
        });
        return capability;
      }
      var StatTimer = function StatTimerClosure() {
        function rpad(str, pad, length) {
          while (str.length < length) {
            str += pad;
          }
          return str;
        }
        function StatTimer() {
          this.started = Object.create(null);
          this.times = [];
          this.enabled = true;
        }
        StatTimer.prototype = {
          time: function StatTimer_time(name) {
            if (!this.enabled) {
              return;
            }
            if (name in this.started) {
              warn("Timer is already running for " + name);
            }
            this.started[name] = Date.now();
          },
          timeEnd: function StatTimer_timeEnd(name) {
            if (!this.enabled) {
              return;
            }
            if (!(name in this.started)) {
              warn("Timer has not been started for " + name);
            }
            this.times.push({
              "name": name,
              "start": this.started[name],
              "end": Date.now()
            });
            delete this.started[name];
          },
          toString: function StatTimer_toString() {
            var i, ii;
            var times = this.times;
            var out = "";
            var longest = 0;
            for (i = 0, ii = times.length; i < ii; ++i) {
              var name = times[i]["name"];
              if (name.length > longest) {
                longest = name.length;
              }
            }
            for (i = 0, ii = times.length; i < ii; ++i) {
              var span = times[i];
              var duration = span.end - span.start;
              out += rpad(span["name"], " ", longest) + " " + duration + "ms\n";
            }
            return out;
          }
        };
        return StatTimer;
      }();
      var createBlob = function createBlob(data, contentType) {
        if (typeof Blob !== "undefined") {
          return new Blob([data], { type: contentType });
        }
        throw new Error("The \"Blob\" constructor is not supported.");
      };
      var createObjectURL = function createObjectURLClosure() {
        var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        return function createObjectURL(data, contentType) {
          var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (!forceDataSchema && URL.createObjectURL) {
            var blob = createBlob(data, contentType);
            return URL.createObjectURL(blob);
          }
          var buffer = "data:" + contentType + ";base64,";
          for (var i = 0, ii = data.length; i < ii; i += 3) {
            var b1 = data[i] & 0xFF;
            var b2 = data[i + 1] & 0xFF;
            var b3 = data[i + 2] & 0xFF;
            var d1 = b1 >> 2,
              d2 = (b1 & 3) << 4 | b2 >> 4;
            var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
            var d4 = i + 2 < ii ? b3 & 0x3F : 64;
            buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
          }
          return buffer;
        };
      }();
      function resolveCall(fn, args) {
        var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (!fn) {
          return Promise.resolve(undefined);
        }
        return new Promise(function (resolve, reject) {
          resolve(fn.apply(thisArg, args));
        });
      }
      function wrapReason(reason) {
        if ((typeof reason === "undefined" ? "undefined" : _typeof(reason)) !== "object") {
          return reason;
        }
        switch (reason.name) {
          case "AbortException":
            return new AbortException(reason.message);
          case "MissingPDFException":
            return new MissingPDFException(reason.message);
          case "UnexpectedResponseException":
            return new UnexpectedResponseException(reason.message, reason.status);
          default:
            return new UnknownErrorException(reason.message, reason.details);
        }
      }
      function makeReasonSerializable(reason) {
        if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
          return reason;
        }
        return new UnknownErrorException(reason.message, reason.toString());
      }
      function resolveOrReject(capability, success, reason) {
        if (success) {
          capability.resolve();
        } else {
          capability.reject(reason);
        }
      }
      function finalize(promise) {
        return Promise.resolve(promise).catch(function () {});
      }
      function MessageHandler(sourceName, targetName, comObj) {
        var _this = this;

        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.postMessageTransfers = true;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
        var ah = this.actionHandler = Object.create(null);
        this._onComObjOnMessage = function (event) {
          var data = event.data;
          if (data.targetName !== _this.sourceName) {
            return;
          }
          if (data.stream) {
            _this._processStreamMessage(data);
          } else if (data.isReply) {
            var callbackId = data.callbackId;
            if (data.callbackId in callbacksCapabilities) {
              var callback = callbacksCapabilities[callbackId];
              delete callbacksCapabilities[callbackId];
              if ("error" in data) {
                callback.reject(wrapReason(data.error));
              } else {
                callback.resolve(data.data);
              }
            } else {
              throw new Error("Cannot resolve callback " + callbackId);
            }
          } else if (data.action in ah) {
            var action = ah[data.action];
            if (data.callbackId) {
              var _sourceName = _this.sourceName;
              var _targetName = data.sourceName;
              Promise.resolve().then(function () {
                return action[0].call(action[1], data.data);
              }).then(function (result) {
                comObj.postMessage({
                  sourceName: _sourceName,
                  targetName: _targetName,
                  isReply: true,
                  callbackId: data.callbackId,
                  data: result
                });
              }, function (reason) {
                comObj.postMessage({
                  sourceName: _sourceName,
                  targetName: _targetName,
                  isReply: true,
                  callbackId: data.callbackId,
                  error: makeReasonSerializable(reason)
                });
              });
            } else if (data.streamId) {
              _this._createStreamSink(data);
            } else {
              action[0].call(action[1], data.data);
            }
          } else {
            throw new Error("Unknown action from worker: " + data.action);
          }
        };
        comObj.addEventListener("message", this._onComObjOnMessage);
      }
      MessageHandler.prototype = {
        on: function on(actionName, handler, scope) {
          var ah = this.actionHandler;
          if (ah[actionName]) {
            throw new Error("There is already an actionName called \"" + actionName + "\"");
          }
          ah[actionName] = [handler, scope];
        },
        send: function send(actionName, data, transfers) {
          var message = {
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
          };
          this.postMessage(message, transfers);
        },
        sendWithPromise: function sendWithPromise(actionName, data, transfers) {
          var callbackId = this.callbackId++;
          var message = {
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data,
            callbackId: callbackId
          };
          var capability = createPromiseCapability();
          this.callbacksCapabilities[callbackId] = capability;
          try {
            this.postMessage(message, transfers);
          } catch (e) {
            capability.reject(e);
          }
          return capability.promise;
        },
        sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
          var _this2 = this;

          var streamId = this.streamId++;
          var sourceName = this.sourceName;
          var targetName = this.targetName;
          return new _streams_polyfill.ReadableStream({
            start: function start(controller) {
              var startCapability = createPromiseCapability();
              _this2.streamControllers[streamId] = {
                controller: controller,
                startCall: startCapability,
                isClosed: false
              };
              _this2.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                action: actionName,
                streamId: streamId,
                data: data,
                desiredSize: controller.desiredSize
              });
              return startCapability.promise;
            },
            pull: function pull(controller) {
              var pullCapability = createPromiseCapability();
              _this2.streamControllers[streamId].pullCall = pullCapability;
              _this2.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: "pull",
                streamId: streamId,
                desiredSize: controller.desiredSize
              });
              return pullCapability.promise;
            },
            cancel: function cancel(reason) {
              var cancelCapability = createPromiseCapability();
              _this2.streamControllers[streamId].cancelCall = cancelCapability;
              _this2.streamControllers[streamId].isClosed = true;
              _this2.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: "cancel",
                reason: reason,
                streamId: streamId
              });
              return cancelCapability.promise;
            }
          }, queueingStrategy);
        },
        _createStreamSink: function _createStreamSink(data) {
          var _this3 = this;

          var self = this;
          var action = this.actionHandler[data.action];
          var streamId = data.streamId;
          var desiredSize = data.desiredSize;
          var sourceName = this.sourceName;
          var targetName = data.sourceName;
          var capability = createPromiseCapability();
          var sendStreamRequest = function sendStreamRequest(_ref) {
            var stream = _ref.stream,
              chunk = _ref.chunk,
              transfers = _ref.transfers,
              success = _ref.success,
              reason = _ref.reason;

            _this3.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: stream,
              streamId: streamId,
              chunk: chunk,
              success: success,
              reason: reason
            }, transfers);
          };
          var streamSink = {
            enqueue: function enqueue(chunk) {
              var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var transfers = arguments[2];

              if (this.isCancelled) {
                return;
              }
              var lastDesiredSize = this.desiredSize;
              this.desiredSize -= size;
              if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                this.sinkCapability = createPromiseCapability();
                this.ready = this.sinkCapability.promise;
              }
              sendStreamRequest({
                stream: "enqueue",
                chunk: chunk,
                transfers: transfers
              });
            },
            close: function close() {
              if (this.isCancelled) {
                return;
              }
              this.isCancelled = true;
              sendStreamRequest({ stream: "close" });
              delete self.streamSinks[streamId];
            },
            error: function error(reason) {
              if (this.isCancelled) {
                return;
              }
              this.isCancelled = true;
              sendStreamRequest({
                stream: "error",
                reason: reason
              });
            },

            sinkCapability: capability,
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: desiredSize,
            ready: null
          };
          streamSink.sinkCapability.resolve();
          streamSink.ready = streamSink.sinkCapability.promise;
          this.streamSinks[streamId] = streamSink;
          resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
            sendStreamRequest({
              stream: "start_complete",
              success: true
            });
          }, function (reason) {
            sendStreamRequest({
              stream: "start_complete",
              success: false,
              reason: reason
            });
          });
        },
        _processStreamMessage: function _processStreamMessage(data) {
          var _this4 = this;

          var sourceName = this.sourceName;
          var targetName = data.sourceName;
          var streamId = data.streamId;
          var sendStreamResponse = function sendStreamResponse(_ref2) {
            var stream = _ref2.stream,
              success = _ref2.success,
              reason = _ref2.reason;

            _this4.comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: stream,
              success: success,
              streamId: streamId,
              reason: reason
            });
          };
          var deleteStreamController = function deleteStreamController() {
            Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
              return capability && finalize(capability.promise);
            })).then(function () {
              delete _this4.streamControllers[data.streamId];
            });
          };
          switch (data.stream) {
            case "start_complete":
              resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
              break;
            case "pull_complete":
              resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
              break;
            case "pull":
              if (!this.streamSinks[data.streamId]) {
                sendStreamResponse({
                  stream: "pull_complete",
                  success: true
                });
                break;
              }
              if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
                this.streamSinks[data.streamId].sinkCapability.resolve();
              }
              this.streamSinks[data.streamId].desiredSize = data.desiredSize;
              resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
                sendStreamResponse({
                  stream: "pull_complete",
                  success: true
                });
              }, function (reason) {
                sendStreamResponse({
                  stream: "pull_complete",
                  success: false,
                  reason: reason
                });
              });
              break;
            case "enqueue":
              assert(this.streamControllers[data.streamId], "enqueue should have stream controller");
              if (!this.streamControllers[data.streamId].isClosed) {
                this.streamControllers[data.streamId].controller.enqueue(data.chunk);
              }
              break;
            case "close":
              assert(this.streamControllers[data.streamId], "close should have stream controller");
              if (this.streamControllers[data.streamId].isClosed) {
                break;
              }
              this.streamControllers[data.streamId].isClosed = true;
              this.streamControllers[data.streamId].controller.close();
              deleteStreamController();
              break;
            case "error":
              assert(this.streamControllers[data.streamId], "error should have stream controller");
              this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
              deleteStreamController();
              break;
            case "cancel_complete":
              resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
              deleteStreamController();
              break;
            case "cancel":
              if (!this.streamSinks[data.streamId]) {
                break;
              }
              resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
                sendStreamResponse({
                  stream: "cancel_complete",
                  success: true
                });
              }, function (reason) {
                sendStreamResponse({
                  stream: "cancel_complete",
                  success: false,
                  reason: reason
                });
              });
              this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
              this.streamSinks[data.streamId].isCancelled = true;
              delete this.streamSinks[data.streamId];
              break;
            default:
              throw new Error("Unexpected stream case");
          }
        },
        postMessage: function postMessage(message, transfers) {
          if (transfers && this.postMessageTransfers) {
            this.comObj.postMessage(message, transfers);
          } else {
            this.comObj.postMessage(message);
          }
        },
        destroy: function destroy() {
          this.comObj.removeEventListener("message", this._onComObjOnMessage);
        }
      };
      function loadJpegStream(id, imageUrl, objs) {
        var img = new Image();
        img.onload = function loadJpegStream_onloadClosure() {
          objs.resolve(id, img);
        };
        img.onerror = function loadJpegStream_onerrorClosure() {
          objs.resolve(id, null);
          warn("Error during JPEG image loading");
        };
        img.src = imageUrl;
      }
      exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
      exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
      exports.OPS = OPS;
      exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
      exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
      exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
      exports.AnnotationFieldFlag = AnnotationFieldFlag;
      exports.AnnotationFlag = AnnotationFlag;
      exports.AnnotationType = AnnotationType;
      exports.FontType = FontType;
      exports.ImageKind = ImageKind;
      exports.CMapCompressionType = CMapCompressionType;
      exports.AbortException = AbortException;
      exports.InvalidPDFException = InvalidPDFException;
      exports.MessageHandler = MessageHandler;
      exports.MissingDataException = MissingDataException;
      exports.MissingPDFException = MissingPDFException;
      exports.NativeImageDecoding = NativeImageDecoding;
      exports.NotImplementedException = NotImplementedException;
      exports.PageViewport = PageViewport;
      exports.PasswordException = PasswordException;
      exports.PasswordResponses = PasswordResponses;
      exports.StatTimer = StatTimer;
      exports.StreamType = StreamType;
      exports.TextRenderingMode = TextRenderingMode;
      exports.UnexpectedResponseException = UnexpectedResponseException;
      exports.UnknownErrorException = UnknownErrorException;
      exports.Util = Util;
      exports.XRefParseException = XRefParseException;
      exports.FormatError = FormatError;
      exports.arrayByteLength = arrayByteLength;
      exports.arraysToBytes = arraysToBytes;
      exports.assert = assert;
      exports.bytesToString = bytesToString;
      exports.createBlob = createBlob;
      exports.createPromiseCapability = createPromiseCapability;
      exports.createObjectURL = createObjectURL;
      exports.deprecated = deprecated;
      exports.getLookupTableFactory = getLookupTableFactory;
      exports.getVerbosityLevel = getVerbosityLevel;
      exports.info = info;
      exports.isArrayBuffer = isArrayBuffer;
      exports.isBool = isBool;
      exports.isEmptyObj = isEmptyObj;
      exports.isNum = isNum;
      exports.isString = isString;
      exports.isSpace = isSpace;
      exports.isNodeJS = isNodeJS;
      exports.isSameOrigin = isSameOrigin;
      exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
      exports.isLittleEndian = isLittleEndian;
      exports.isEvalSupported = isEvalSupported;
      exports.loadJpegStream = loadJpegStream;
      exports.log2 = log2;
      exports.readInt8 = readInt8;
      exports.readUint16 = readUint16;
      exports.readUint32 = readUint32;
      exports.removeNullCharacters = removeNullCharacters;
      exports.ReadableStream = _streams_polyfill.ReadableStream;
      exports.setVerbosityLevel = setVerbosityLevel;
      exports.shadow = shadow;
      exports.string32 = string32;
      exports.stringToBytes = stringToBytes;
      exports.stringToPDFString = stringToPDFString;
      exports.stringToUTF8String = stringToUTF8String;
      exports.utf8StringToString = utf8StringToString;
      exports.warn = warn;
      exports.unreachable = unreachable;

      /***/ }),
    /* 1 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = module.exports = typeof window !== "undefined" && window.Math == Math ? window : typeof self !== "undefined" && self.Math == Math ? self : Function("return this")();
      if (typeof __g === "number") __g = global;

      /***/ }),
    /* 2 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      module.exports = function (it) {
        return (typeof it === "undefined" ? "undefined" : _typeof(it)) === "object" ? it !== null : typeof it === "function";
      };

      /***/ }),
    /* 3 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var store = __w_pdfjs_require__(51)("wks");
      var uid = __w_pdfjs_require__(16);
      var _Symbol = __w_pdfjs_require__(1).Symbol;
      var USE_SYMBOL = typeof _Symbol === "function";
      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)("Symbol." + name));
      };
      $exports.store = store;

      /***/ }),
    /* 4 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var core = __w_pdfjs_require__(5);
      var hide = __w_pdfjs_require__(6);
      var redefine = __w_pdfjs_require__(15);
      var ctx = __w_pdfjs_require__(11);
      var PROTOTYPE = "prototype";
      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          own = !IS_FORCED && target && target[key] !== undefined;
          out = (own ? target : source)[key];
          exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out === "function" ? ctx(Function.call, out) : out;
          if (target) redefine(target, key, out, type & $export.U);
          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global.core = core;
      $export.F = 1;
      $export.G = 2;
      $export.S = 4;
      $export.P = 8;
      $export.B = 16;
      $export.W = 32;
      $export.U = 64;
      $export.R = 128;
      module.exports = $export;

      /***/ }),
    /* 5 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var core = module.exports = { version: "2.5.1" };
      if (typeof __e === "number") __e = core;

      /***/ }),
    /* 6 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var dP = __w_pdfjs_require__(14);
      var createDesc = __w_pdfjs_require__(27);
      module.exports = __w_pdfjs_require__(9) ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };

      /***/ }),
    /* 7 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + " is not an object!");
        return it;
      };

      /***/ }),
    /* 8 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/ }),
    /* 9 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = !__w_pdfjs_require__(10)(function () {
        return Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/ }),
    /* 10 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/ }),
    /* 11 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var aFunction = __w_pdfjs_require__(21);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function () {
          return fn.apply(that, arguments);
        };
      };

      /***/ }),
    /* 12 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(17);
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
      };

      /***/ }),
    /* 13 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SimpleXMLParser = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _util = __w_pdfjs_require__(0);

      var _global_scope = __w_pdfjs_require__(20);

      var _global_scope2 = _interopRequireDefault(_global_scope);

      function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
      var SVG_NS = "http://www.w3.org/2000/svg";

      var DOMCanvasFactory = function () {
        function DOMCanvasFactory() {
          _classCallCheck(this, DOMCanvasFactory);
        }

        _createClass(DOMCanvasFactory, [{
          key: "create",
          value: function create(width, height) {
            if (width <= 0 || height <= 0) {
              throw new Error("invalid canvas size");
            }
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = height;
            return {
              canvas: canvas,
              context: context
            };
          }
        }, {
          key: "reset",
          value: function reset(canvasAndContext, width, height) {
            if (!canvasAndContext.canvas) {
              throw new Error("canvas is not specified");
            }
            if (width <= 0 || height <= 0) {
              throw new Error("invalid canvas size");
            }
            canvasAndContext.canvas.width = width;
            canvasAndContext.canvas.height = height;
          }
        }, {
          key: "destroy",
          value: function destroy(canvasAndContext) {
            if (!canvasAndContext.canvas) {
              throw new Error("canvas is not specified");
            }
            canvasAndContext.canvas.width = 0;
            canvasAndContext.canvas.height = 0;
            canvasAndContext.canvas = null;
            canvasAndContext.context = null;
          }
        }]);

        return DOMCanvasFactory;
      }();

      var DOMCMapReaderFactory = function () {
        function DOMCMapReaderFactory(_ref) {
          var _ref$baseUrl = _ref.baseUrl,
            baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
            _ref$isCompressed = _ref.isCompressed,
            isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;

          _classCallCheck(this, DOMCMapReaderFactory);

          this.baseUrl = baseUrl;
          this.isCompressed = isCompressed;
        }

        _createClass(DOMCMapReaderFactory, [{
          key: "fetch",
          value: function fetch(_ref2) {
            var _this = this;

            var name = _ref2.name;

            if (!this.baseUrl) {
              return Promise.reject(new Error("CMap baseUrl must be specified, " + "see \"PDFJS.cMapUrl\" (and also \"PDFJS.cMapPacked\")."));
            }
            if (!name) {
              return Promise.reject(new Error("CMap name must be specified."));
            }
            return new Promise(function (resolve, reject) {
              var url = _this.baseUrl + name + (_this.isCompressed ? ".bcmap" : "");
              var request = new XMLHttpRequest();
              request.open("GET", url, true);
              if (_this.isCompressed) {
                request.responseType = "arraybuffer";
              }
              request.onreadystatechange = function () {
                if (request.readyState !== XMLHttpRequest.DONE) {
                  return;
                }
                if (request.status === 200 || request.status === 0) {
                  var data = void 0;
                  if (_this.isCompressed && request.response) {
                    data = new Uint8Array(request.response);
                  } else if (!_this.isCompressed && request.responseText) {
                    data = (0, _util.stringToBytes)(request.responseText);
                  }
                  if (data) {
                    resolve({
                      cMapData: data,
                      compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
                    });
                    return;
                  }
                }
                reject(new Error("Unable to load " + (_this.isCompressed ? "binary " : "") + "CMap at: " + url));
              };
              request.send(null);
            });
          }
        }]);

        return DOMCMapReaderFactory;
      }();

      var DOMSVGFactory = function () {
        function DOMSVGFactory() {
          _classCallCheck(this, DOMSVGFactory);
        }

        _createClass(DOMSVGFactory, [{
          key: "create",
          value: function create(width, height) {
            (0, _util.assert)(width > 0 && height > 0, "Invalid SVG dimensions");
            var svg = document.createElementNS(SVG_NS, "svg:svg");
            svg.setAttribute("version", "1.1");
            svg.setAttribute("width", width + "px");
            svg.setAttribute("height", height + "px");
            svg.setAttribute("preserveAspectRatio", "none");
            svg.setAttribute("viewBox", "0 0 " + width + " " + height);
            return svg;
          }
        }, {
          key: "createElement",
          value: function createElement(type) {
            (0, _util.assert)(typeof type === "string", "Invalid SVG element type");
            return document.createElementNS(SVG_NS, type);
          }
        }]);

        return DOMSVGFactory;
      }();

      var SimpleDOMNode = function () {
        function SimpleDOMNode(nodeName, nodeValue) {
          _classCallCheck(this, SimpleDOMNode);

          this.nodeName = nodeName;
          this.nodeValue = nodeValue;
          Object.defineProperty(this, "parentNode", {
            value: null,
            writable: true
          });
        }

        _createClass(SimpleDOMNode, [{
          key: "hasChildNodes",
          value: function hasChildNodes() {
            return this.childNodes && this.childNodes.length > 0;
          }
        }, {
          key: "firstChild",
          get: function get() {
            return this.childNodes[0];
          }
        }, {
          key: "nextSibling",
          get: function get() {
            var index = this.parentNode.childNodes.indexOf(this);
            return this.parentNode.childNodes[index + 1];
          }
        }, {
          key: "textContent",
          get: function get() {
            if (!this.childNodes) {
              return this.nodeValue || "";
            }
            return this.childNodes.map(function (child) {
              return child.textContent;
            }).join("");
          }
        }]);

        return SimpleDOMNode;
      }();

      var SimpleXMLParser = function () {
        function SimpleXMLParser() {
          _classCallCheck(this, SimpleXMLParser);
        }

        _createClass(SimpleXMLParser, [{
          key: "parseFromString",
          value: function parseFromString(data) {
            var _this2 = this;

            var nodes = [];
            data = data.replace(/<\?[\s\S]*?\?>|<!--[\s\S]*?-->/g, "").trim();
            data = data.replace(/<!DOCTYPE[^>\[]+(\[[^\]]+)?[^>]+>/g, "").trim();
            data = data.replace(/>([^<][\s\S]*?)</g, function (all, text) {
              var length = nodes.length;
              var node = new SimpleDOMNode("#text", _this2._decodeXML(text));
              nodes.push(node);
              if (node.textContent.trim().length === 0) {
                return "><";
              }
              return ">" + length + ",<";
            });
            data = data.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, function (all, text) {
              var length = nodes.length;
              var node = new SimpleDOMNode("#text", text);
              nodes.push(node);
              return length + ",";
            });
            var regex = /<([\w\:]+)((?:[\s\w:=]|'[^']*'|"[^"]*")*)(?:\/>|>([\d,]*)<\/[^>]+>)/g;
            var lastLength = void 0;
            do {
              lastLength = nodes.length;
              data = data.replace(regex, function (all, name, attrs, data) {
                var length = nodes.length;
                var node = new SimpleDOMNode(name);
                var children = [];
                if (data) {
                  data = data.split(",");
                  data.pop();
                  data.forEach(function (child) {
                    var childNode = nodes[+child];
                    childNode.parentNode = node;
                    children.push(childNode);
                  });
                }
                node.childNodes = children;
                nodes.push(node);
                return length + ",";
              });
            } while (lastLength < nodes.length);
            return { documentElement: nodes.pop() };
          }
        }, {
          key: "_decodeXML",
          value: function _decodeXML(text) {
            if (text.indexOf("&") < 0) {
              return text;
            }
            return text.replace(/&(#(x[0-9a-f]+|\d+)|\w+);/gi, function (all, entityName, number) {
              if (number) {
                if (number[0] === "x") {
                  number = parseInt(number.substring(1), 16);
                } else {
                  number = +number;
                }
                return String.fromCharCode(number);
              }
              switch (entityName) {
                case "amp":
                  return "&";
                case "lt":
                  return "<";
                case "gt":
                  return ">";
                case "quot":
                  return "\"";
                case "apos":
                  return "'";
              }
              return "&" + entityName + ";";
            });
          }
        }]);

        return SimpleXMLParser;
      }();

      var CustomStyle = function CustomStyleClosure() {
        var prefixes = ["ms", "Moz", "Webkit", "O"];
        var _cache = Object.create(null);
        function CustomStyle() {}
        CustomStyle.getProp = function get(propName, element) {
          if (arguments.length === 1 && typeof _cache[propName] === "string") {
            return _cache[propName];
          }
          element = element || document.documentElement;
          var style = element.style,
            prefixed,
            uPropName;
          if (typeof style[propName] === "string") {
            return _cache[propName] = propName;
          }
          uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
          for (var i = 0, l = prefixes.length; i < l; i++) {
            prefixed = prefixes[i] + uPropName;
            if (typeof style[prefixed] === "string") {
              return _cache[propName] = prefixed;
            }
          }
          return _cache[propName] = "undefined";
        };
        CustomStyle.setProp = function set(propName, element, str) {
          var prop = this.getProp(propName);
          if (prop !== "undefined") {
            element.style[prop] = str;
          }
        };
        return CustomStyle;
      }();
      var RenderingCancelledException = function RenderingCancelledException() {
        function RenderingCancelledException(msg, type) {
          this.message = msg;
          this.type = type;
        }
        RenderingCancelledException.prototype = new Error();
        RenderingCancelledException.prototype.name = "RenderingCancelledException";
        RenderingCancelledException.constructor = RenderingCancelledException;
        return RenderingCancelledException;
      }();
      var LinkTarget = {
        NONE: 0,
        SELF: 1,
        BLANK: 2,
        PARENT: 3,
        TOP: 4
      };
      var LinkTargetStringMap = ["", "_self", "_blank", "_parent", "_top"];
      function addLinkAttributes(link, params) {
        var url = params && params.url;
        link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : "";
        if (url) {
          var target = params.target;
          if (typeof target === "undefined") {
            target = getDefaultSetting("externalLinkTarget");
          }
          link.target = LinkTargetStringMap[target];
          var rel = params.rel;
          if (typeof rel === "undefined") {
            rel = getDefaultSetting("externalLinkRel");
          }
          link.rel = rel;
        }
      }
      function getFilenameFromUrl(url) {
        var anchor = url.indexOf("#");
        var query = url.indexOf("?");
        var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
        return url.substring(url.lastIndexOf("/", end) + 1, end);
      }
      function getDefaultSetting(id) {
        var globalSettings = _global_scope2.default.PDFJS;
        switch (id) {
          case "pdfBug":
            return globalSettings ? globalSettings.pdfBug : false;
          case "disableAutoFetch":
            return globalSettings ? globalSettings.disableAutoFetch : false;
          case "disableStream":
            return globalSettings ? globalSettings.disableStream : false;
          case "disableRange":
            return globalSettings ? globalSettings.disableRange : false;
          case "disableFontFace":
            return globalSettings ? globalSettings.disableFontFace : false;
          case "disableCreateObjectURL":
            return globalSettings ? globalSettings.disableCreateObjectURL : false;
          case "disableWebGL":
            return globalSettings ? globalSettings.disableWebGL : true;
          case "cMapUrl":
            return globalSettings ? globalSettings.cMapUrl : null;
          case "cMapPacked":
            return globalSettings ? globalSettings.cMapPacked : false;
          case "postMessageTransfers":
            return globalSettings ? globalSettings.postMessageTransfers : true;
          case "workerPort":
            return globalSettings ? globalSettings.workerPort : null;
          case "workerSrc":
            return globalSettings ? globalSettings.workerSrc : null;
          case "disableWorker":
            return globalSettings ? globalSettings.disableWorker : false;
          case "maxImageSize":
            return globalSettings ? globalSettings.maxImageSize : -1;
          case "imageResourcesPath":
            return globalSettings ? globalSettings.imageResourcesPath : "";
          case "isEvalSupported":
            return globalSettings ? globalSettings.isEvalSupported : true;
          case "externalLinkTarget":
            if (!globalSettings) {
              return LinkTarget.NONE;
            }
            switch (globalSettings.externalLinkTarget) {
              case LinkTarget.NONE:
              case LinkTarget.SELF:
              case LinkTarget.BLANK:
              case LinkTarget.PARENT:
              case LinkTarget.TOP:
                return globalSettings.externalLinkTarget;
            }
            (0, _util.warn)("PDFJS.externalLinkTarget is invalid: " + globalSettings.externalLinkTarget);
            globalSettings.externalLinkTarget = LinkTarget.NONE;
            return LinkTarget.NONE;
          case "externalLinkRel":
            return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
          case "enableStats":
            return !!(globalSettings && globalSettings.enableStats);
          case "pdfjsNext":
            return !!(globalSettings && globalSettings.pdfjsNext);
          default:
            throw new Error("Unknown default setting: " + id);
        }
      }
      function isExternalLinkTargetSet() {
        var externalLinkTarget = getDefaultSetting("externalLinkTarget");
        switch (externalLinkTarget) {
          case LinkTarget.NONE:
            return false;
          case LinkTarget.SELF:
          case LinkTarget.BLANK:
          case LinkTarget.PARENT:
          case LinkTarget.TOP:
            return true;
        }
      }
      function isValidUrl(url, allowRelative) {
        (0, _util.deprecated)("isValidUrl(), please use createValidAbsoluteUrl() instead.");
        var baseUrl = allowRelative ? "http://example.com" : null;
        return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
      }
      exports.CustomStyle = CustomStyle;
      exports.RenderingCancelledException = RenderingCancelledException;
      exports.addLinkAttributes = addLinkAttributes;
      exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
      exports.isValidUrl = isValidUrl;
      exports.getFilenameFromUrl = getFilenameFromUrl;
      exports.LinkTarget = LinkTarget;
      exports.getDefaultSetting = getDefaultSetting;
      exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
      exports.DOMCanvasFactory = DOMCanvasFactory;
      exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
      exports.DOMSVGFactory = DOMSVGFactory;
      exports.SimpleXMLParser = SimpleXMLParser;

      /***/ }),
    /* 14 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(7);
      var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
      var toPrimitive = __w_pdfjs_require__(33);
      var dP = Object.defineProperty;
      exports.f = __w_pdfjs_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {}
        if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
        if ("value" in Attributes) O[P] = Attributes.value;
        return O;
      };

      /***/ }),
    /* 15 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var hide = __w_pdfjs_require__(6);
      var has = __w_pdfjs_require__(8);
      var SRC = __w_pdfjs_require__(16)("src");
      var TO_STRING = "toString";
      var $toString = Function[TO_STRING];
      var TPL = ("" + $toString).split(TO_STRING);
      __w_pdfjs_require__(5).inspectSource = function (it) {
        return $toString.call(it);
      };
      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val === "function";
        if (isFunction) has(val, "name") || hide(val, "name", key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? "" + O[key] : TPL.join(String(key)));
        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
      })(Function.prototype, TO_STRING, function toString() {
        return typeof this === "function" && this[SRC] || $toString.call(this);
      });

      /***/ }),
    /* 16 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return "Symbol(".concat(key === undefined ? "" : key, ")_", (++id + px).toString(36));
      };

      /***/ }),
    /* 17 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/ }),
    /* 18 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var defined = __w_pdfjs_require__(35);
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/ }),
    /* 19 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = {};

      /***/ }),
    /* 20 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = typeof window !== "undefined" && window.Math === Math ? window : typeof global !== "undefined" && global.Math === Math ? global : typeof self !== "undefined" && self.Math === Math ? self : {};

      /***/ }),
    /* 21 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (it) {
        if (typeof it !== "function") throw TypeError(it + " is not a function!");
        return it;
      };

      /***/ }),
    /* 22 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var redefine = __w_pdfjs_require__(15);
      module.exports = function (target, src, safe) {
        for (var key in src) {
          redefine(target, key, src[key], safe);
        } return target;
      };

      /***/ }),
    /* 23 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
          throw TypeError(name + ": incorrect invocation!");
        }
        return it;
      };

      /***/ }),
    /* 24 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toString = {}.toString;
      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/ }),
    /* 25 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var def = __w_pdfjs_require__(14).f;
      var has = __w_pdfjs_require__(8);
      var TAG = __w_pdfjs_require__(3)("toStringTag");
      module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
          configurable: true,
          value: tag
        });
      };

      /***/ }),
    /* 26 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = false;

      /***/ }),
    /* 27 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/ }),
    /* 28 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var IObject = __w_pdfjs_require__(34);
      var defined = __w_pdfjs_require__(35);
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/ }),
    /* 29 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(17);
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/ }),
    /* 30 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var cof = __w_pdfjs_require__(24);
      var TAG = __w_pdfjs_require__(3)("toStringTag");
      var ARG = cof(function () {
        return arguments;
      }()) == "Arguments";
      var tryGet = function tryGet(it, key) {
        try {
          return it[key];
        } catch (e) {}
      };
      module.exports = function (it) {
        var O, T, B;
        return it === undefined ? "Undefined" : it === null ? "Null" : typeof (T = tryGet(O = Object(it), TAG)) === "string" ? T : ARG ? cof(O) : (B = cof(O)) == "Object" && typeof O.callee === "function" ? "Arguments" : B;
      };

      /***/ }),
    /* 31 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ctx = __w_pdfjs_require__(11);
      var call = __w_pdfjs_require__(98);
      var isArrayIter = __w_pdfjs_require__(53);
      var anObject = __w_pdfjs_require__(7);
      var toLength = __w_pdfjs_require__(12);
      var getIterFn = __w_pdfjs_require__(57);
      var BREAK = {};
      var RETURN = {};
      var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR ? function () {
          return iterable;
        } : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn !== "function") throw TypeError(iterable + " is not iterable!");
        if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
          result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
          if (result === BREAK || result === RETURN) return result;
        } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
          result = call(iterator, f, step.value, entries);
          if (result === BREAK || result === RETURN) return result;
        }
      };
      _exports.BREAK = BREAK;
      _exports.RETURN = RETURN;

      /***/ }),
    /* 32 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      var document = __w_pdfjs_require__(1).document;
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/ }),
    /* 33 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) === "function" && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) === "function" && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) === "function" && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/ }),
    /* 34 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var cof = __w_pdfjs_require__(24);
      module.exports = Object("z").propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == "String" ? it.split("") : Object(it);
      };

      /***/ }),
    /* 35 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/ }),
    /* 36 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var shared = __w_pdfjs_require__(51)("keys");
      var uid = __w_pdfjs_require__(16);
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/ }),
    /* 37 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

      /***/ }),
    /* 38 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $keys = __w_pdfjs_require__(49);
      var enumBugKeys = __w_pdfjs_require__(37);
      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };

      /***/ }),
    /* 39 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ctx = __w_pdfjs_require__(11);
      var IObject = __w_pdfjs_require__(34);
      var toObject = __w_pdfjs_require__(18);
      var toLength = __w_pdfjs_require__(12);
      var asc = __w_pdfjs_require__(82);
      module.exports = function (TYPE, $create) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = $create || asc;
        return function ($this, callbackfn, that) {
          var O = toObject($this);
          var self = IObject(O);
          var f = ctx(callbackfn, that, 3);
          var length = toLength(self.length);
          var index = 0;
          var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
          var val, res;
          for (; length > index; index++) {
            if (NO_HOLES || index in self) {
              val = self[index];
              res = f(val, index, O);
              if (TYPE) {
                if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
                  case 3:
                    return true;
                  case 5:
                    return val;
                  case 6:
                    return index;
                  case 2:
                    result.push(val);
                } else if (IS_EVERY) return false;
              }
            }
          } return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
      };

      /***/ }),
    /* 40 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(7);
      var aFunction = __w_pdfjs_require__(21);
      var SPECIES = __w_pdfjs_require__(3)("species");
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };

      /***/ }),
    /* 41 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ITERATOR = __w_pdfjs_require__(3)("iterator");
      var SAFE_CLOSING = false;
      try {
        var riter = [7][ITERATOR]();
        riter["return"] = function () {
          SAFE_CLOSING = true;
        };
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {}
      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return { done: safe = true };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {}
        return safe;
      };

      /***/ }),
    /* 42 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var aFunction = __w_pdfjs_require__(21);
      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }
      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };

      /***/ }),
    /* 43 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var META = __w_pdfjs_require__(16)("meta");
      var isObject = __w_pdfjs_require__(2);
      var has = __w_pdfjs_require__(8);
      var setDesc = __w_pdfjs_require__(14).f;
      var id = 0;
      var isExtensible = Object.isExtensible || function () {
        return true;
      };
      var FREEZE = !__w_pdfjs_require__(10)(function () {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function setMeta(it) {
        setDesc(it, META, {
          value: {
            i: "O" + ++id,
            w: {}
          }
        });
      };
      var fastKey = function fastKey(it, create) {
        if (!isObject(it)) return (typeof it === "undefined" ? "undefined" : _typeof(it)) == "symbol" ? it : (typeof it === "string" ? "S" : "P") + it;
        if (!has(it, META)) {
          if (!isExtensible(it)) return "F";
          if (!create) return "E";
          setMeta(it);
        }
        return it[META].i;
      };
      var getWeak = function getWeak(it, create) {
        if (!has(it, META)) {
          if (!isExtensible(it)) return true;
          if (!create) return false;
          setMeta(it);
        }
        return it[META].w;
      };
      var onFreeze = function onFreeze(it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };
      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      };

      /***/ }),
    /* 44 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.createResponseStatusError = undefined;

      var _util = __w_pdfjs_require__(0);

      function validateRangeRequestCapabilities(_ref) {
        var getResponseHeader = _ref.getResponseHeader,
          isHttp = _ref.isHttp,
          rangeChunkSize = _ref.rangeChunkSize,
          disableRange = _ref.disableRange;

        (0, _util.assert)(rangeChunkSize > 0);
        var returnValues = {
          allowRangeRequests: false,
          suggestedLength: undefined
        };
        if (disableRange || !isHttp) {
          return returnValues;
        }
        if (getResponseHeader("Accept-Ranges") !== "bytes") {
          return returnValues;
        }
        var contentEncoding = getResponseHeader("Content-Encoding") || "identity";
        if (contentEncoding !== "identity") {
          return returnValues;
        }
        var length = parseInt(getResponseHeader("Content-Length"), 10);
        if (!Number.isInteger(length)) {
          return returnValues;
        }
        returnValues.suggestedLength = length;
        if (length <= 2 * rangeChunkSize) {
          return returnValues;
        }
        returnValues.allowRangeRequests = true;
        return returnValues;
      }
      function createResponseStatusError(status, url) {
        if (status === 404 || status === 0 && /^file:/.test(url)) {
          return new _util.MissingPDFException("Missing PDF \"" + url + "\".");
        }
        return new _util.UnexpectedResponseException("Unexpected server response (" + status + ") while retrieving PDF \"" + url + "\".", status);
      }
      function validateResponseStatus(status) {
        return status === 200 || status === 206;
      }
      exports.createResponseStatusError = createResponseStatusError;
      exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
      exports.validateResponseStatus = validateResponseStatus;

      /***/ }),
    /* 45 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = !__w_pdfjs_require__(9) && !__w_pdfjs_require__(10)(function () {
        return Object.defineProperty(__w_pdfjs_require__(32)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/ }),
    /* 46 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var hide = __w_pdfjs_require__(6);
      var uid = __w_pdfjs_require__(16);
      var TYPED = uid("typed_array");
      var VIEW = uid("view");
      var ABV = !!(global.ArrayBuffer && global.DataView);
      var CONSTR = ABV;
      var i = 0;
      var l = 9;
      var Typed;
      var TypedArrayConstructors = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");
      while (i < l) {
        if (Typed = global[TypedArrayConstructors[i++]]) {
          hide(Typed.prototype, TYPED, true);
          hide(Typed.prototype, VIEW, true);
        } else CONSTR = false;
      }
      module.exports = {
        ABV: ABV,
        CONSTR: CONSTR,
        TYPED: TYPED,
        VIEW: VIEW
      };

      /***/ }),
    /* 47 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(17);
      var toLength = __w_pdfjs_require__(12);
      module.exports = function (it) {
        if (it === undefined) return 0;
        var number = toInteger(it);
        var length = toLength(number);
        if (number !== length) throw RangeError("Wrong length!");
        return length;
      };

      /***/ }),
    /* 48 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $keys = __w_pdfjs_require__(49);
      var hiddenKeys = __w_pdfjs_require__(37).concat("length", "prototype");
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };

      /***/ }),
    /* 49 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var has = __w_pdfjs_require__(8);
      var toIObject = __w_pdfjs_require__(28);
      var arrayIndexOf = __w_pdfjs_require__(50)(false);
      var IE_PROTO = __w_pdfjs_require__(36)("IE_PROTO");
      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) {
          if (key != IE_PROTO) has(O, key) && result.push(key);
        } while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        } return result;
      };

      /***/ }),
    /* 50 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toIObject = __w_pdfjs_require__(28);
      var toLength = __w_pdfjs_require__(12);
      var toAbsoluteIndex = __w_pdfjs_require__(29);
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            if (value != value) return true;
          } else for (; length > index; index++) {
            if (IS_INCLUDES || index in O) {
              if (O[index] === el) return IS_INCLUDES || index || 0;
            }
          } return !IS_INCLUDES && -1;
        };
      };

      /***/ }),
    /* 51 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var SHARED = "__core-js_shared__";
      var store = global[SHARED] || (global[SHARED] = {});
      module.exports = function (key) {
        return store[key] || (store[key] = {});
      };

      /***/ }),
    /* 52 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toObject = __w_pdfjs_require__(18);
      var toAbsoluteIndex = __w_pdfjs_require__(29);
      var toLength = __w_pdfjs_require__(12);
      module.exports = function fill(value) {
        var O = toObject(this);
        var length = toLength(O.length);
        var aLen = arguments.length;
        var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
        var end = aLen > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
        while (endPos > index) {
          O[index++] = value;
        } return O;
      };

      /***/ }),
    /* 53 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var Iterators = __w_pdfjs_require__(19);
      var ITERATOR = __w_pdfjs_require__(3)("iterator");
      var ArrayProto = Array.prototype;
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };

      /***/ }),
    /* 54 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(7);
      var dPs = __w_pdfjs_require__(81);
      var enumBugKeys = __w_pdfjs_require__(37);
      var IE_PROTO = __w_pdfjs_require__(36)("IE_PROTO");
      var Empty = function Empty() {};
      var PROTOTYPE = "prototype";
      var _createDict = function createDict() {
        var iframe = __w_pdfjs_require__(32)("iframe");
        var i = enumBugKeys.length;
        var lt = "<";
        var gt = ">";
        var iframeDocument;
        iframe.style.display = "none";
        __w_pdfjs_require__(55).appendChild(iframe);
        iframe.src = "javascript:";
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
        iframeDocument.close();
        _createDict = iframeDocument.F;
        while (i--) {
          delete _createDict[PROTOTYPE][enumBugKeys[i]];
        } return _createDict();
      };
      module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null;
          result[IE_PROTO] = O;
        } else result = _createDict();
        return Properties === undefined ? result : dPs(result, Properties);
      };

      /***/ }),
    /* 55 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var document = __w_pdfjs_require__(1).document;
      module.exports = document && document.documentElement;

      /***/ }),
    /* 56 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var has = __w_pdfjs_require__(8);
      var toObject = __w_pdfjs_require__(18);
      var IE_PROTO = __w_pdfjs_require__(36)("IE_PROTO");
      var ObjectProto = Object.prototype;
      module.exports = Object.getPrototypeOf || function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor === "function" && O instanceof O.constructor) {
          return O.constructor.prototype;
        }
        return O instanceof Object ? ObjectProto : null;
      };

      /***/ }),
    /* 57 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var classof = __w_pdfjs_require__(30);
      var ITERATOR = __w_pdfjs_require__(3)("iterator");
      var Iterators = __w_pdfjs_require__(19);
      module.exports = __w_pdfjs_require__(5).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
      };

      /***/ }),
    /* 58 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var addToUnscopables = __w_pdfjs_require__(85);
      var step = __w_pdfjs_require__(86);
      var Iterators = __w_pdfjs_require__(19);
      var toIObject = __w_pdfjs_require__(28);
      module.exports = __w_pdfjs_require__(59)(Array, "Array", function (iterated, kind) {
        this._t = toIObject(iterated);
        this._i = 0;
        this._k = kind;
      }, function () {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
          this._t = undefined;
          return step(1);
        }
        if (kind == "keys") return step(0, index);
        if (kind == "values") return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, "values");
      Iterators.Arguments = Iterators.Array;
      addToUnscopables("keys");
      addToUnscopables("values");
      addToUnscopables("entries");

      /***/ }),
    /* 59 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var LIBRARY = __w_pdfjs_require__(26);
      var $export = __w_pdfjs_require__(4);
      var redefine = __w_pdfjs_require__(15);
      var hide = __w_pdfjs_require__(6);
      var has = __w_pdfjs_require__(8);
      var Iterators = __w_pdfjs_require__(19);
      var $iterCreate = __w_pdfjs_require__(87);
      var setToStringTag = __w_pdfjs_require__(25);
      var getPrototypeOf = __w_pdfjs_require__(56);
      var ITERATOR = __w_pdfjs_require__(3)("iterator");
      var BUGGY = !([].keys && "next" in [].keys());
      var FF_ITERATOR = "@@iterator";
      var KEYS = "keys";
      var VALUES = "values";
      var returnThis = function returnThis() {
        return this;
      };
      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function getMethod(kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + " Iterator";
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
        var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            setToStringTag(IteratorPrototype, TAG, true);
            if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };

      /***/ }),
    /* 60 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var dP = __w_pdfjs_require__(14);
      var DESCRIPTORS = __w_pdfjs_require__(9);
      var SPECIES = __w_pdfjs_require__(3)("species");
      module.exports = function (KEY) {
        var C = global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
          configurable: true,
          get: function get() {
            return this;
          }
        });
      };

      /***/ }),
    /* 61 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var pIE = __w_pdfjs_require__(62);
      var createDesc = __w_pdfjs_require__(27);
      var toIObject = __w_pdfjs_require__(28);
      var toPrimitive = __w_pdfjs_require__(33);
      var has = __w_pdfjs_require__(8);
      var IE8_DOM_DEFINE = __w_pdfjs_require__(45);
      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = __w_pdfjs_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {}
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };

      /***/ }),
    /* 62 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      exports.f = {}.propertyIsEnumerable;

      /***/ }),
    /* 63 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var classof = __w_pdfjs_require__(30);
      var test = {};
      test[__w_pdfjs_require__(3)("toStringTag")] = "z";
      if (test + "" != "[object z]") {
        __w_pdfjs_require__(15)(Object.prototype, "toString", function toString() {
          return "[object " + classof(this) + "]";
        }, true);
      }

      /***/ }),
    /* 64 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $iterators = __w_pdfjs_require__(58);
      var getKeys = __w_pdfjs_require__(38);
      var redefine = __w_pdfjs_require__(15);
      var global = __w_pdfjs_require__(1);
      var hide = __w_pdfjs_require__(6);
      var Iterators = __w_pdfjs_require__(19);
      var wks = __w_pdfjs_require__(3);
      var ITERATOR = wks("iterator");
      var TO_STRING_TAG = wks("toStringTag");
      var ArrayValues = Iterators.Array;
      var DOMIterables = {
        CSSRuleList: true,
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true,
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true,
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false
      };
      for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
        var NAME = collections[i];
        var explicit = DOMIterables[NAME];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        var key;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit) for (key in $iterators) {
            if (!proto[key]) redefine(proto, key, $iterators[key], true);
          }
        }
      }

      /***/ }),
    /* 65 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ctx = __w_pdfjs_require__(11);
      var invoke = __w_pdfjs_require__(99);
      var html = __w_pdfjs_require__(55);
      var cel = __w_pdfjs_require__(32);
      var global = __w_pdfjs_require__(1);
      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = "onreadystatechange";
      var defer, channel, port;
      var run = function run() {
        var id = +this;
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function listener(event) {
        run.call(event.data);
      };
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) {
            args.push(arguments[i++]);
          }queue[++counter] = function () {
            invoke(typeof fn === "function" ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        if (__w_pdfjs_require__(24)(process) == "process") {
          defer = function defer(id) {
            process.nextTick(ctx(run, id, 1));
          };
        } else if (Dispatch && Dispatch.now) {
          defer = function defer(id) {
            Dispatch.now(ctx(run, id, 1));
          };
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
        } else if (global.addEventListener && typeof postMessage === "function" && !global.importScripts) {
          defer = function defer(id) {
            global.postMessage(id + "", "*");
          };
          global.addEventListener("message", listener, false);
        } else if (ONREADYSTATECHANGE in cel("script")) {
          defer = function defer(id) {
            html.appendChild(cel("script"))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          };
        } else {
          defer = function defer(id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask
      };

      /***/ }),
    /* 66 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (exec) {
        try {
          return {
            e: false,
            v: exec()
          };
        } catch (e) {
          return {
            e: true,
            v: e
          };
        }
      };

      /***/ }),
    /* 67 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(7);
      var isObject = __w_pdfjs_require__(2);
      var newPromiseCapability = __w_pdfjs_require__(42);
      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };

      /***/ }),
    /* 68 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      module.exports = function (it, TYPE) {
        if (!isObject(it) || it._t !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required!");
        return it;
      };

      /***/ }),
    /* 69 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.build = exports.version = exports._UnsupportedManager = exports.setPDFNetworkStreamClass = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var _util = __w_pdfjs_require__(0);

      var _dom_utils = __w_pdfjs_require__(13);

      var _font_loader = __w_pdfjs_require__(118);

      var _canvas = __w_pdfjs_require__(119);

      var _global_scope = __w_pdfjs_require__(20);

      var _global_scope2 = _interopRequireDefault(_global_scope);

      var _metadata = __w_pdfjs_require__(71);

      var _transport_stream = __w_pdfjs_require__(121);

      function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var DEFAULT_RANGE_CHUNK_SIZE = 65536;
      var isWorkerDisabled = false;
      var workerSrc;
      var isPostMessageTransfersDisabled = false;
      var pdfjsFilePath = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : null;
      var fakeWorkerFilesLoader = null;
      var useRequireEnsure = false;
      {
        if (typeof window === "undefined") {
          isWorkerDisabled = true;
          if (typeof require.ensure === "undefined") {
            require.ensure = require("node-ensure");
          }
          useRequireEnsure = true;
        } else if (typeof require !== "undefined" && typeof require.ensure === "function") {
          useRequireEnsure = true;
        }
        if (typeof requirejs !== "undefined" && requirejs.toUrl) {
          workerSrc = requirejs.toUrl("pdfjs-dist/build/pdf.worker.js");
        }
        var dynamicLoaderSupported = typeof requirejs !== "undefined" && requirejs.load;
        fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
          require.ensure([], function () {
            var worker;
            worker = require("./pdf.worker.js");
            callback(worker.WorkerMessageHandler);
          });
        } : dynamicLoaderSupported ? function (callback) {
          requirejs(["pdfjs-dist/build/pdf.worker"], function (worker) {
            callback(worker.WorkerMessageHandler);
          });
        } : null;
      }
      var PDFNetworkStream;
      function setPDFNetworkStreamClass(cls) {
        PDFNetworkStream = cls;
      }
      function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
        var task = new PDFDocumentLoadingTask();
        if (arguments.length > 1) {
          (0, _util.deprecated)("getDocument is called with pdfDataRangeTransport, " + "passwordCallback or progressCallback argument");
        }
        if (pdfDataRangeTransport) {
          if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
            pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
            pdfDataRangeTransport.length = src.length;
            pdfDataRangeTransport.initialData = src.initialData;
            if (!pdfDataRangeTransport.abort) {
              pdfDataRangeTransport.abort = function () {};
            }
          }
          src = Object.create(src);
          src.range = pdfDataRangeTransport;
        }
        task.onPassword = passwordCallback || null;
        task.onProgress = progressCallback || null;
        var source;
        if (typeof src === "string") {
          source = { url: src };
        } else if ((0, _util.isArrayBuffer)(src)) {
          source = { data: src };
        } else if (src instanceof PDFDataRangeTransport) {
          source = { range: src };
        } else {
          if ((typeof src === "undefined" ? "undefined" : _typeof(src)) !== "object") {
            throw new Error("Invalid parameter in getDocument, " + "need either Uint8Array, string or a parameter object");
          }
          if (!src.url && !src.data && !src.range) {
            throw new Error("Invalid parameter object: need either .data, .range or .url");
          }
          source = src;
        }
        var params = {};
        var rangeTransport = null;
        var worker = null;
        var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
        for (var key in source) {
          if (key === "url" && typeof window !== "undefined") {
            params[key] = new URL(source[key], window.location).href;
            continue;
          } else if (key === "range") {
            rangeTransport = source[key];
            continue;
          } else if (key === "worker") {
            worker = source[key];
            continue;
          } else if (key === "data" && !(source[key] instanceof Uint8Array)) {
            var pdfBytes = source[key];
            if (typeof pdfBytes === "string") {
              params[key] = (0, _util.stringToBytes)(pdfBytes);
            } else if ((typeof pdfBytes === "undefined" ? "undefined" : _typeof(pdfBytes)) === "object" && pdfBytes !== null && !isNaN(pdfBytes.length)) {
              params[key] = new Uint8Array(pdfBytes);
            } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
              params[key] = new Uint8Array(pdfBytes);
            } else {
              throw new Error("Invalid PDF binary data: either typed array, " + "string or array-like object is expected in the " + "data property.");
            }
            continue;
          } else if (key === "CMapReaderFactory") {
            CMapReaderFactory = source[key];
            continue;
          }
          params[key] = source[key];
        }
        params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
        params.ignoreErrors = params.stopAtErrors !== true;
        if (params.disableNativeImageDecoder !== undefined) {
          (0, _util.deprecated)("parameter disableNativeImageDecoder, " + "use nativeImageDecoderSupport instead");
        }
        params.nativeImageDecoderSupport = params.nativeImageDecoderSupport || (params.disableNativeImageDecoder === true ? _util.NativeImageDecoding.NONE : _util.NativeImageDecoding.DECODE);
        if (params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DECODE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DISPLAY) {
          (0, _util.warn)("Invalid parameter nativeImageDecoderSupport: " + "need a state of enum {NativeImageDecoding}");
          params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
        }
        if (!worker) {
          var workerPort = (0, _dom_utils.getDefaultSetting)("workerPort");
          worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
          task._worker = worker;
        }
        var docId = task.docId;
        worker.promise.then(function () {
          if (task.destroyed) {
            throw new Error("Loading aborted");
          }
          return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
            if (task.destroyed) {
              throw new Error("Loading aborted");
            }
            var networkStream = void 0;
            if (rangeTransport) {
              networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
            } else if (!params.data) {
              networkStream = new PDFNetworkStream({
                source: params,
                disableRange: (0, _dom_utils.getDefaultSetting)("disableRange")
              });
            }
            var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
            messageHandler.postMessageTransfers = worker.postMessageTransfers;
            var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
            task._transport = transport;
            messageHandler.send("Ready", null);
          });
        }).catch(task._capability.reject);
        return task;
      }
      function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
        if (worker.destroyed) {
          return Promise.reject(new Error("Worker was destroyed"));
        }
        var apiVersion = "1.10.97";
        source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)("disableAutoFetch");
        source.disableStream = (0, _dom_utils.getDefaultSetting)("disableStream");
        source.chunkedViewerLoading = !!pdfDataRangeTransport;
        if (pdfDataRangeTransport) {
          source.length = pdfDataRangeTransport.length;
          source.initialData = pdfDataRangeTransport.initialData;
        }
        return worker.messageHandler.sendWithPromise("GetDocRequest", {
          docId: docId,
          apiVersion: apiVersion,
          source: {
            data: source.data,
            url: source.url,
            password: source.password,
            disableAutoFetch: source.disableAutoFetch,
            rangeChunkSize: source.rangeChunkSize,
            length: source.length
          },
          maxImageSize: (0, _dom_utils.getDefaultSetting)("maxImageSize"),
          disableFontFace: (0, _dom_utils.getDefaultSetting)("disableFontFace"),
          disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)("disableCreateObjectURL"),
          postMessageTransfers: (0, _dom_utils.getDefaultSetting)("postMessageTransfers") && !isPostMessageTransfersDisabled,
          docBaseUrl: source.docBaseUrl,
          nativeImageDecoderSupport: source.nativeImageDecoderSupport,
          ignoreErrors: source.ignoreErrors,
          isEvalSupported: (0, _dom_utils.getDefaultSetting)("isEvalSupported")
        }).then(function (workerId) {
          if (worker.destroyed) {
            throw new Error("Worker was destroyed");
          }
          return workerId;
        });
      }
      var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
        var nextDocumentId = 0;
        function PDFDocumentLoadingTask() {
          this._capability = (0, _util.createPromiseCapability)();
          this._transport = null;
          this._worker = null;
          this.docId = "d" + nextDocumentId++;
          this.destroyed = false;
          this.onPassword = null;
          this.onProgress = null;
          this.onUnsupportedFeature = null;
        }
        PDFDocumentLoadingTask.prototype = {
          get promise() {
            return this._capability.promise;
          },
          destroy: function destroy() {
            var _this = this;

            this.destroyed = true;
            var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
            return transportDestroyed.then(function () {
              _this._transport = null;
              if (_this._worker) {
                _this._worker.destroy();
                _this._worker = null;
              }
            });
          },

          then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
            return this.promise.then.apply(this.promise, arguments);
          }
        };
        return PDFDocumentLoadingTask;
      }();
      var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
        function PDFDataRangeTransport(length, initialData) {
          this.length = length;
          this.initialData = initialData;
          this._rangeListeners = [];
          this._progressListeners = [];
          this._progressiveReadListeners = [];
          this._readyCapability = (0, _util.createPromiseCapability)();
        }
        PDFDataRangeTransport.prototype = {
          addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
            this._rangeListeners.push(listener);
          },
          addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
            this._progressListeners.push(listener);
          },
          addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
            this._progressiveReadListeners.push(listener);
          },
          onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
            var listeners = this._rangeListeners;
            for (var i = 0, n = listeners.length; i < n; ++i) {
              listeners[i](begin, chunk);
            }
          },
          onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
            var _this2 = this;

            this._readyCapability.promise.then(function () {
              var listeners = _this2._progressListeners;
              for (var i = 0, n = listeners.length; i < n; ++i) {
                listeners[i](loaded);
              }
            });
          },
          onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
            var _this3 = this;

            this._readyCapability.promise.then(function () {
              var listeners = _this3._progressiveReadListeners;
              for (var i = 0, n = listeners.length; i < n; ++i) {
                listeners[i](chunk);
              }
            });
          },
          transportReady: function PDFDataRangeTransport_transportReady() {
            this._readyCapability.resolve();
          },
          requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
            throw new Error("Abstract method PDFDataRangeTransport.requestDataRange");
          },
          abort: function PDFDataRangeTransport_abort() {}
        };
        return PDFDataRangeTransport;
      }();
      var PDFDocumentProxy = function PDFDocumentProxyClosure() {
        function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
          this.pdfInfo = pdfInfo;
          this.transport = transport;
          this.loadingTask = loadingTask;
        }
        PDFDocumentProxy.prototype = {
          get numPages() {
            return this.pdfInfo.numPages;
          },
          get fingerprint() {
            return this.pdfInfo.fingerprint;
          },
          getPage: function PDFDocumentProxy_getPage(pageNumber) {
            return this.transport.getPage(pageNumber);
          },
          getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
            return this.transport.getPageIndex(ref);
          },
          getDestinations: function PDFDocumentProxy_getDestinations() {
            return this.transport.getDestinations();
          },
          getDestination: function PDFDocumentProxy_getDestination(id) {
            return this.transport.getDestination(id);
          },
          getPageLabels: function PDFDocumentProxy_getPageLabels() {
            return this.transport.getPageLabels();
          },
          getPageMode: function getPageMode() {
            return this.transport.getPageMode();
          },

          getAttachments: function PDFDocumentProxy_getAttachments() {
            return this.transport.getAttachments();
          },
          getJavaScript: function PDFDocumentProxy_getJavaScript() {
            return this.transport.getJavaScript();
          },
          getOutline: function PDFDocumentProxy_getOutline() {
            return this.transport.getOutline();
          },
          getMetadata: function PDFDocumentProxy_getMetadata() {
            return this.transport.getMetadata();
          },
          getData: function PDFDocumentProxy_getData() {
            return this.transport.getData();
          },
          getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
            return this.transport.downloadInfoCapability.promise;
          },
          getStats: function PDFDocumentProxy_getStats() {
            return this.transport.getStats();
          },
          cleanup: function PDFDocumentProxy_cleanup() {
            this.transport.startCleanup();
          },
          destroy: function PDFDocumentProxy_destroy() {
            return this.loadingTask.destroy();
          }
        };
        return PDFDocumentProxy;
      }();
      var PDFPageProxy = function PDFPageProxyClosure() {
        function PDFPageProxy(pageIndex, pageInfo, transport) {
          this.pageIndex = pageIndex;
          this.pageInfo = pageInfo;
          this.transport = transport;
          this.stats = new _util.StatTimer();
          this.stats.enabled = (0, _dom_utils.getDefaultSetting)("enableStats");
          this.commonObjs = transport.commonObjs;
          this.objs = new PDFObjects();
          this.cleanupAfterRender = false;
          this.pendingCleanup = false;
          this.intentStates = Object.create(null);
          this.destroyed = false;
        }
        PDFPageProxy.prototype = {
          get pageNumber() {
            return this.pageIndex + 1;
          },
          get rotate() {
            return this.pageInfo.rotate;
          },
          get ref() {
            return this.pageInfo.ref;
          },
          get userUnit() {
            return this.pageInfo.userUnit;
          },
          get view() {
            return this.pageInfo.view;
          },
          getViewport: function PDFPageProxy_getViewport(scale, rotate) {
            if (arguments.length < 2) {
              rotate = this.rotate;
            }
            return new _util.PageViewport(this.view, scale, rotate, 0, 0);
          },
          getAnnotations: function PDFPageProxy_getAnnotations(params) {
            var intent = params && params.intent || null;
            if (!this.annotationsPromise || this.annotationsIntent !== intent) {
              this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
              this.annotationsIntent = intent;
            }
            return this.annotationsPromise;
          },
          render: function PDFPageProxy_render(params) {
            var _this4 = this;

            var stats = this.stats;
            stats.time("Overall");
            this.pendingCleanup = false;
            var renderingIntent = params.intent === "print" ? "print" : "display";
            var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
            if (!this.intentStates[renderingIntent]) {
              this.intentStates[renderingIntent] = Object.create(null);
            }
            var intentState = this.intentStates[renderingIntent];
            if (!intentState.displayReadyCapability) {
              intentState.receivingOperatorList = true;
              intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
              intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false
              };
              this.stats.time("Page Request");
              this.transport.messageHandler.send("RenderPageRequest", {
                pageIndex: this.pageNumber - 1,
                intent: renderingIntent,
                renderInteractiveForms: params.renderInteractiveForms === true
              });
            }
            var complete = function complete(error) {
              var i = intentState.renderTasks.indexOf(internalRenderTask);
              if (i >= 0) {
                intentState.renderTasks.splice(i, 1);
              }
              if (_this4.cleanupAfterRender) {
                _this4.pendingCleanup = true;
              }
              _this4._tryCleanup();
              if (error) {
                internalRenderTask.capability.reject(error);
              } else {
                internalRenderTask.capability.resolve();
              }
              stats.timeEnd("Rendering");
              stats.timeEnd("Overall");
            };
            var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
            internalRenderTask.useRequestAnimationFrame = renderingIntent !== "print";
            if (!intentState.renderTasks) {
              intentState.renderTasks = [];
            }
            intentState.renderTasks.push(internalRenderTask);
            var renderTask = internalRenderTask.task;
            if (params.continueCallback) {
              (0, _util.deprecated)("render is used with continueCallback parameter");
              renderTask.onContinue = params.continueCallback;
            }
            intentState.displayReadyCapability.promise.then(function (transparency) {
              if (_this4.pendingCleanup) {
                complete();
                return;
              }
              stats.time("Rendering");
              internalRenderTask.initializeGraphics(transparency);
              internalRenderTask.operatorListChanged();
            }).catch(complete);
            return renderTask;
          },
          getOperatorList: function PDFPageProxy_getOperatorList() {
            function operatorListChanged() {
              if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                var i = intentState.renderTasks.indexOf(opListTask);
                if (i >= 0) {
                  intentState.renderTasks.splice(i, 1);
                }
              }
            }
            var renderingIntent = "oplist";
            if (!this.intentStates[renderingIntent]) {
              this.intentStates[renderingIntent] = Object.create(null);
            }
            var intentState = this.intentStates[renderingIntent];
            var opListTask;
            if (!intentState.opListReadCapability) {
              opListTask = {};
              opListTask.operatorListChanged = operatorListChanged;
              intentState.receivingOperatorList = true;
              intentState.opListReadCapability = (0, _util.createPromiseCapability)();
              intentState.renderTasks = [];
              intentState.renderTasks.push(opListTask);
              intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false
              };
              this.transport.messageHandler.send("RenderPageRequest", {
                pageIndex: this.pageIndex,
                intent: renderingIntent
              });
            }
            return intentState.opListReadCapability.promise;
          },
          streamTextContent: function streamTextContent() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var TEXT_CONTENT_CHUNK_SIZE = 100;
            return this.transport.messageHandler.sendWithStream("GetTextContent", {
              pageIndex: this.pageNumber - 1,
              normalizeWhitespace: params.normalizeWhitespace === true,
              combineTextItems: params.disableCombineTextItems !== true
            }, {
              highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
              size: function size(textContent) {
                return textContent.items.length;
              }
            });
          },

          getTextContent: function PDFPageProxy_getTextContent(params) {
            params = params || {};
            var readableStream = this.streamTextContent(params);
            return new Promise(function (resolve, reject) {
              function pump() {
                reader.read().then(function (_ref) {
                  var value = _ref.value,
                    done = _ref.done;

                  if (done) {
                    resolve(textContent);
                    return;
                  }
                  _util.Util.extendObj(textContent.styles, value.styles);
                  _util.Util.appendToArray(textContent.items, value.items);
                  pump();
                }, reject);
              }
              var reader = readableStream.getReader();
              var textContent = {
                items: [],
                styles: Object.create(null)
              };
              pump();
            });
          },
          _destroy: function PDFPageProxy_destroy() {
            this.destroyed = true;
            this.transport.pageCache[this.pageIndex] = null;
            var waitOn = [];
            Object.keys(this.intentStates).forEach(function (intent) {
              if (intent === "oplist") {
                return;
              }
              var intentState = this.intentStates[intent];
              intentState.renderTasks.forEach(function (renderTask) {
                var renderCompleted = renderTask.capability.promise.catch(function () {});
                waitOn.push(renderCompleted);
                renderTask.cancel();
              });
            }, this);
            this.objs.clear();
            this.annotationsPromise = null;
            this.pendingCleanup = false;
            return Promise.all(waitOn);
          },
          destroy: function destroy() {
            (0, _util.deprecated)("page destroy method, use cleanup() instead");
            this.cleanup();
          },

          cleanup: function PDFPageProxy_cleanup() {
            this.pendingCleanup = true;
            this._tryCleanup();
          },
          _tryCleanup: function PDFPageProxy_tryCleanup() {
            if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
              var intentState = this.intentStates[intent];
              return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
            }, this)) {
              return;
            }
            Object.keys(this.intentStates).forEach(function (intent) {
              delete this.intentStates[intent];
            }, this);
            this.objs.clear();
            this.annotationsPromise = null;
            this.pendingCleanup = false;
          },
          _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
            var intentState = this.intentStates[intent];
            if (intentState.displayReadyCapability) {
              intentState.displayReadyCapability.resolve(transparency);
            }
          },
          _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
            var intentState = this.intentStates[intent];
            var i, ii;
            for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
              intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
              intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
            }
            intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
            for (i = 0; i < intentState.renderTasks.length; i++) {
              intentState.renderTasks[i].operatorListChanged();
            }
            if (operatorListChunk.lastChunk) {
              intentState.receivingOperatorList = false;
              this._tryCleanup();
            }
          }
        };
        return PDFPageProxy;
      }();

      var LoopbackPort = function () {
        function LoopbackPort(defer) {
          _classCallCheck(this, LoopbackPort);

          this._listeners = [];
          this._defer = defer;
          this._deferred = Promise.resolve(undefined);
        }

        _createClass(LoopbackPort, [{
          key: "postMessage",
          value: function postMessage(obj, transfers) {
            var _this5 = this;

            function cloneValue(value) {
              if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object" || value === null) {
                return value;
              }
              if (cloned.has(value)) {
                return cloned.get(value);
              }
              var result;
              var buffer;
              if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
                var transferable = transfers && transfers.indexOf(buffer) >= 0;
                if (value === buffer) {
                  result = value;
                } else if (transferable) {
                  result = new value.constructor(buffer, value.byteOffset, value.byteLength);
                } else {
                  result = new value.constructor(value);
                }
                cloned.set(value, result);
                return result;
              }
              result = Array.isArray(value) ? [] : {};
              cloned.set(value, result);
              for (var i in value) {
                var desc,
                  p = value;
                while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
                  p = Object.getPrototypeOf(p);
                }
                if (typeof desc.value === "undefined" || typeof desc.value === "function") {
                  continue;
                }
                result[i] = cloneValue(desc.value);
              }
              return result;
            }
            if (!this._defer) {
              this._listeners.forEach(function (listener) {
                listener.call(this, { data: obj });
              }, this);
              return;
            }
            var cloned = new WeakMap();
            var e = { data: cloneValue(obj) };
            this._deferred.then(function () {
              _this5._listeners.forEach(function (listener) {
                listener.call(this, e);
              }, _this5);
            });
          }
        }, {
          key: "addEventListener",
          value: function addEventListener(name, listener) {
            this._listeners.push(listener);
          }
        }, {
          key: "removeEventListener",
          value: function removeEventListener(name, listener) {
            var i = this._listeners.indexOf(listener);
            this._listeners.splice(i, 1);
          }
        }, {
          key: "terminate",
          value: function terminate() {
            this._listeners = [];
          }
        }]);

        return LoopbackPort;
      }();

      var PDFWorker = function PDFWorkerClosure() {
        var nextFakeWorkerId = 0;
        function getWorkerSrc() {
          if (typeof workerSrc !== "undefined") {
            return workerSrc;
          }
          if ((0, _dom_utils.getDefaultSetting)("workerSrc")) {
            return (0, _dom_utils.getDefaultSetting)("workerSrc");
          }
          if (pdfjsFilePath) {
            return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
          }
          throw new Error("No PDFJS.workerSrc specified");
        }
        var fakeWorkerFilesLoadedCapability = void 0;
        function setupFakeWorkerGlobal() {
          var WorkerMessageHandler;
          if (fakeWorkerFilesLoadedCapability) {
            return fakeWorkerFilesLoadedCapability.promise;
          }
          fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
          var loader = fakeWorkerFilesLoader || function (callback) {
            _util.Util.loadScript(getWorkerSrc(), function () {
              callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
            });
          };
          loader(fakeWorkerFilesLoadedCapability.resolve);
          return fakeWorkerFilesLoadedCapability.promise;
        }
        function createCDNWrapper(url) {
          var wrapper = "importScripts('" + url + "');";
          return URL.createObjectURL(new Blob([wrapper]));
        }
        var pdfWorkerPorts = new WeakMap();
        function PDFWorker(name, port) {
          if (port && pdfWorkerPorts.has(port)) {
            throw new Error("Cannot use more than one PDFWorker per port");
          }
          this.name = name;
          this.destroyed = false;
          this.postMessageTransfers = true;
          this._readyCapability = (0, _util.createPromiseCapability)();
          this._port = null;
          this._webWorker = null;
          this._messageHandler = null;
          if (port) {
            pdfWorkerPorts.set(port, this);
            this._initializeFromPort(port);
            return;
          }
          this._initialize();
        }
        PDFWorker.prototype = {
          get promise() {
            return this._readyCapability.promise;
          },
          get port() {
            return this._port;
          },
          get messageHandler() {
            return this._messageHandler;
          },
          _initializeFromPort: function PDFWorker_initializeFromPort(port) {
            this._port = port;
            this._messageHandler = new _util.MessageHandler("main", "worker", port);
            this._messageHandler.on("ready", function () {});
            this._readyCapability.resolve();
          },
          _initialize: function PDFWorker_initialize() {
            var _this6 = this;

            if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)("disableWorker") && typeof Worker !== "undefined") {
              var workerSrc = getWorkerSrc();
              try {
                if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
                  workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
                }
                var worker = new Worker(workerSrc);
                var messageHandler = new _util.MessageHandler("main", "worker", worker);
                var terminateEarly = function terminateEarly() {
                  worker.removeEventListener("error", onWorkerError);
                  messageHandler.destroy();
                  worker.terminate();
                  if (_this6.destroyed) {
                    _this6._readyCapability.reject(new Error("Worker was destroyed"));
                  } else {
                    _this6._setupFakeWorker();
                  }
                };
                var onWorkerError = function onWorkerError() {
                  if (!_this6._webWorker) {
                    terminateEarly();
                  }
                };
                worker.addEventListener("error", onWorkerError);
                messageHandler.on("test", function (data) {
                  worker.removeEventListener("error", onWorkerError);
                  if (_this6.destroyed) {
                    terminateEarly();
                    return;
                  }
                  var supportTypedArray = data && data.supportTypedArray;
                  if (supportTypedArray) {
                    _this6._messageHandler = messageHandler;
                    _this6._port = worker;
                    _this6._webWorker = worker;
                    if (!data.supportTransfers) {
                      _this6.postMessageTransfers = false;
                      isPostMessageTransfersDisabled = true;
                    }
                    _this6._readyCapability.resolve();
                    messageHandler.send("configure", { verbosity: (0, _util.getVerbosityLevel)() });
                  } else {
                    _this6._setupFakeWorker();
                    messageHandler.destroy();
                    worker.terminate();
                  }
                });
                messageHandler.on("console_log", function (data) {
                  console.log.apply(console, data);
                });
                messageHandler.on("console_error", function (data) {
                  console.error.apply(console, data);
                });
                messageHandler.on("ready", function (data) {
                  worker.removeEventListener("error", onWorkerError);
                  if (_this6.destroyed) {
                    terminateEarly();
                    return;
                  }
                  try {
                    sendTest();
                  } catch (e) {
                    _this6._setupFakeWorker();
                  }
                });
                var sendTest = function sendTest() {
                  var postMessageTransfers = (0, _dom_utils.getDefaultSetting)("postMessageTransfers") && !isPostMessageTransfersDisabled;
                  var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
                  try {
                    messageHandler.send("test", testObj, [testObj.buffer]);
                  } catch (ex) {
                    (0, _util.info)("Cannot use postMessage transfers");
                    testObj[0] = 0;
                    messageHandler.send("test", testObj);
                  }
                };
                sendTest();
                return;
              } catch (e) {
                (0, _util.info)("The worker has been disabled.");
              }
            }
            this._setupFakeWorker();
          },
          _setupFakeWorker: function PDFWorker_setupFakeWorker() {
            var _this7 = this;

            if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)("disableWorker")) {
              (0, _util.warn)("Setting up fake worker.");
              isWorkerDisabled = true;
            }
            setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
              if (_this7.destroyed) {
                _this7._readyCapability.reject(new Error("Worker was destroyed"));
                return;
              }
              var isTypedArraysPresent = Uint8Array !== Float32Array;
              var port = new LoopbackPort(isTypedArraysPresent);
              _this7._port = port;
              var id = "fake" + nextFakeWorkerId++;
              var workerHandler = new _util.MessageHandler(id + "_worker", id, port);
              WorkerMessageHandler.setup(workerHandler, port);
              var messageHandler = new _util.MessageHandler(id, id + "_worker", port);
              _this7._messageHandler = messageHandler;
              _this7._readyCapability.resolve();
            });
          },
          destroy: function PDFWorker_destroy() {
            this.destroyed = true;
            if (this._webWorker) {
              this._webWorker.terminate();
              this._webWorker = null;
            }
            pdfWorkerPorts.delete(this._port);
            this._port = null;
            if (this._messageHandler) {
              this._messageHandler.destroy();
              this._messageHandler = null;
            }
          }
        };
        PDFWorker.fromPort = function (port) {
          if (pdfWorkerPorts.has(port)) {
            return pdfWorkerPorts.get(port);
          }
          return new PDFWorker(null, port);
        };
        return PDFWorker;
      }();
      var WorkerTransport = function WorkerTransportClosure() {
        function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
          this.messageHandler = messageHandler;
          this.loadingTask = loadingTask;
          this.commonObjs = new PDFObjects();
          this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
          this.CMapReaderFactory = new CMapReaderFactory({
            baseUrl: (0, _dom_utils.getDefaultSetting)("cMapUrl"),
            isCompressed: (0, _dom_utils.getDefaultSetting)("cMapPacked")
          });
          this.destroyed = false;
          this.destroyCapability = null;
          this._passwordCapability = null;
          this._networkStream = networkStream;
          this._fullReader = null;
          this._lastProgress = null;
          this.pageCache = [];
          this.pagePromises = [];
          this.downloadInfoCapability = (0, _util.createPromiseCapability)();
          this.setupMessageHandler();
        }
        WorkerTransport.prototype = {
          destroy: function WorkerTransport_destroy() {
            var _this8 = this;

            if (this.destroyCapability) {
              return this.destroyCapability.promise;
            }
            this.destroyed = true;
            this.destroyCapability = (0, _util.createPromiseCapability)();
            if (this._passwordCapability) {
              this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
            }
            var waitOn = [];
            this.pageCache.forEach(function (page) {
              if (page) {
                waitOn.push(page._destroy());
              }
            });
            this.pageCache = [];
            this.pagePromises = [];
            var terminated = this.messageHandler.sendWithPromise("Terminate", null);
            waitOn.push(terminated);
            Promise.all(waitOn).then(function () {
              _this8.fontLoader.clear();
              if (_this8._networkStream) {
                _this8._networkStream.cancelAllRequests();
              }
              if (_this8.messageHandler) {
                _this8.messageHandler.destroy();
                _this8.messageHandler = null;
              }
              _this8.destroyCapability.resolve();
            }, this.destroyCapability.reject);
            return this.destroyCapability.promise;
          },
          setupMessageHandler: function WorkerTransport_setupMessageHandler() {
            var messageHandler = this.messageHandler;
            var loadingTask = this.loadingTask;
            messageHandler.on("GetReader", function (data, sink) {
              var _this9 = this;

              (0, _util.assert)(this._networkStream);
              this._fullReader = this._networkStream.getFullReader();
              this._fullReader.onProgress = function (evt) {
                _this9._lastProgress = {
                  loaded: evt.loaded,
                  total: evt.total
                };
              };
              sink.onPull = function () {
                _this9._fullReader.read().then(function (_ref2) {
                  var value = _ref2.value,
                    done = _ref2.done;

                  if (done) {
                    sink.close();
                    return;
                  }
                  (0, _util.assert)((0, _util.isArrayBuffer)(value));
                  sink.enqueue(new Uint8Array(value), 1, [value]);
                }).catch(function (reason) {
                  sink.error(reason);
                });
              };
              sink.onCancel = function (reason) {
                _this9._fullReader.cancel(reason);
              };
            }, this);
            messageHandler.on("ReaderHeadersReady", function (data) {
              var _this10 = this;

              var headersCapability = (0, _util.createPromiseCapability)();
              var fullReader = this._fullReader;
              fullReader.headersReady.then(function () {
                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                  if (_this10._lastProgress) {
                    var _loadingTask = _this10.loadingTask;
                    if (_loadingTask.onProgress) {
                      _loadingTask.onProgress(_this10._lastProgress);
                    }
                  }
                  fullReader.onProgress = function (evt) {
                    var loadingTask = _this10.loadingTask;
                    if (loadingTask.onProgress) {
                      loadingTask.onProgress({
                        loaded: evt.loaded,
                        total: evt.total
                      });
                    }
                  };
                }
                headersCapability.resolve({
                  isStreamingSupported: fullReader.isStreamingSupported,
                  isRangeSupported: fullReader.isRangeSupported,
                  contentLength: fullReader.contentLength
                });
              }, headersCapability.reject);
              return headersCapability.promise;
            }, this);
            messageHandler.on("GetRangeReader", function (data, sink) {
              (0, _util.assert)(this._networkStream);
              var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
              sink.onPull = function () {
                _rangeReader.read().then(function (_ref3) {
                  var value = _ref3.value,
                    done = _ref3.done;

                  if (done) {
                    sink.close();
                    return;
                  }
                  (0, _util.assert)((0, _util.isArrayBuffer)(value));
                  sink.enqueue(new Uint8Array(value), 1, [value]);
                }).catch(function (reason) {
                  sink.error(reason);
                });
              };
              sink.onCancel = function (reason) {
                _rangeReader.cancel(reason);
              };
            }, this);
            messageHandler.on("GetDoc", function transportDoc(data) {
              var pdfInfo = data.pdfInfo;
              this.numPages = data.pdfInfo.numPages;
              var loadingTask = this.loadingTask;
              var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
              this.pdfDocument = pdfDocument;
              loadingTask._capability.resolve(pdfDocument);
            }, this);
            messageHandler.on("PasswordRequest", function transportPasswordRequest(exception) {
              var _this11 = this;

              this._passwordCapability = (0, _util.createPromiseCapability)();
              if (loadingTask.onPassword) {
                var updatePassword = function updatePassword(password) {
                  _this11._passwordCapability.resolve({ password: password });
                };
                loadingTask.onPassword(updatePassword, exception.code);
              } else {
                this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
              }
              return this._passwordCapability.promise;
            }, this);
            messageHandler.on("PasswordException", function transportPasswordException(exception) {
              loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
            }, this);
            messageHandler.on("InvalidPDF", function transportInvalidPDF(exception) {
              this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
            }, this);
            messageHandler.on("MissingPDF", function transportMissingPDF(exception) {
              this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
            }, this);
            messageHandler.on("UnexpectedResponse", function transportUnexpectedResponse(exception) {
              this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
            }, this);
            messageHandler.on("UnknownError", function transportUnknownError(exception) {
              this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
            }, this);
            messageHandler.on("DataLoaded", function transportPage(data) {
              this.downloadInfoCapability.resolve(data);
            }, this);
            messageHandler.on("PDFManagerReady", function transportPage(data) {}, this);
            messageHandler.on("StartRenderPage", function transportRender(data) {
              if (this.destroyed) {
                return;
              }
              var page = this.pageCache[data.pageIndex];
              page.stats.timeEnd("Page Request");
              page._startRenderPage(data.transparency, data.intent);
            }, this);
            messageHandler.on("RenderPageChunk", function transportRender(data) {
              if (this.destroyed) {
                return;
              }
              var page = this.pageCache[data.pageIndex];
              page._renderPageChunk(data.operatorList, data.intent);
            }, this);
            messageHandler.on("commonobj", function transportObj(data) {
              var _this12 = this;

              if (this.destroyed) {
                return;
              }
              var id = data[0];
              var type = data[1];
              if (this.commonObjs.hasData(id)) {
                return;
              }
              switch (type) {
                case "Font":
                  var exportedData = data[2];
                  if ("error" in exportedData) {
                    var exportedError = exportedData.error;
                    (0, _util.warn)("Error during font loading: " + exportedError);
                    this.commonObjs.resolve(id, exportedError);
                    break;
                  }
                  var fontRegistry = null;
                  if ((0, _dom_utils.getDefaultSetting)("pdfBug") && _global_scope2.default.FontInspector && _global_scope2.default["FontInspector"].enabled) {
                    fontRegistry = {
                      registerFont: function registerFont(font, url) {
                        _global_scope2.default["FontInspector"].fontAdded(font, url);
                      }
                    };
                  }
                  var font = new _font_loader.FontFaceObject(exportedData, {
                    isEvalSupported: (0, _dom_utils.getDefaultSetting)("isEvalSupported"),
                    disableFontFace: (0, _dom_utils.getDefaultSetting)("disableFontFace"),
                    fontRegistry: fontRegistry
                  });
                  var fontReady = function fontReady(fontObjs) {
                    _this12.commonObjs.resolve(id, font);
                  };
                  this.fontLoader.bind([font], fontReady);
                  break;
                case "FontPath":
                  this.commonObjs.resolve(id, data[2]);
                  break;
                default:
                  throw new Error("Got unknown common object type " + type);
              }
            }, this);
            messageHandler.on("obj", function transportObj(data) {
              if (this.destroyed) {
                return;
              }
              var id = data[0];
              var pageIndex = data[1];
              var type = data[2];
              var pageProxy = this.pageCache[pageIndex];
              var imageData;
              if (pageProxy.objs.hasData(id)) {
                return;
              }
              switch (type) {
                case "JpegStream":
                  imageData = data[3];
                  (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
                  break;
                case "Image":
                  imageData = data[3];
                  pageProxy.objs.resolve(id, imageData);
                  var MAX_IMAGE_SIZE_TO_STORE = 8000000;
                  if (imageData && "data" in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
                    pageProxy.cleanupAfterRender = true;
                  }
                  break;
                default:
                  throw new Error("Got unknown object type " + type);
              }
            }, this);
            messageHandler.on("DocProgress", function transportDocProgress(data) {
              if (this.destroyed) {
                return;
              }
              var loadingTask = this.loadingTask;
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: data.loaded,
                  total: data.total
                });
              }
            }, this);
            messageHandler.on("PageError", function transportError(data) {
              if (this.destroyed) {
                return;
              }
              var page = this.pageCache[data.pageNum - 1];
              var intentState = page.intentStates[data.intent];
              if (intentState.displayReadyCapability) {
                intentState.displayReadyCapability.reject(data.error);
              } else {
                throw new Error(data.error);
              }
              if (intentState.operatorList) {
                intentState.operatorList.lastChunk = true;
                for (var i = 0; i < intentState.renderTasks.length; i++) {
                  intentState.renderTasks[i].operatorListChanged();
                }
              }
            }, this);
            messageHandler.on("UnsupportedFeature", function transportUnsupportedFeature(data) {
              if (this.destroyed) {
                return;
              }
              var featureId = data.featureId;
              var loadingTask = this.loadingTask;
              if (loadingTask.onUnsupportedFeature) {
                loadingTask.onUnsupportedFeature(featureId);
              }
              _UnsupportedManager.notify(featureId);
            }, this);
            messageHandler.on("JpegDecode", function (data) {
              if (this.destroyed) {
                return Promise.reject(new Error("Worker was destroyed"));
              }
              if (typeof document === "undefined") {
                return Promise.reject(new Error("\"document\" is not defined."));
              }
              var imageUrl = data[0];
              var components = data[1];
              if (components !== 3 && components !== 1) {
                return Promise.reject(new Error("Only 3 components or 1 component can be returned"));
              }
              return new Promise(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                  var width = img.width;
                  var height = img.height;
                  var size = width * height;
                  var rgbaLength = size * 4;
                  var buf = new Uint8Array(size * components);
                  var tmpCanvas = document.createElement("canvas");
                  tmpCanvas.width = width;
                  tmpCanvas.height = height;
                  var tmpCtx = tmpCanvas.getContext("2d");
                  tmpCtx.drawImage(img, 0, 0);
                  var data = tmpCtx.getImageData(0, 0, width, height).data;
                  var i, j;
                  if (components === 3) {
                    for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                      buf[j] = data[i];
                      buf[j + 1] = data[i + 1];
                      buf[j + 2] = data[i + 2];
                    }
                  } else if (components === 1) {
                    for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
                      buf[j] = data[i];
                    }
                  }
                  resolve({
                    data: buf,
                    width: width,
                    height: height
                  });
                };
                img.onerror = function () {
                  reject(new Error("JpegDecode failed to load image"));
                };
                img.src = imageUrl;
              });
            }, this);
            messageHandler.on("FetchBuiltInCMap", function (data) {
              if (this.destroyed) {
                return Promise.reject(new Error("Worker was destroyed"));
              }
              return this.CMapReaderFactory.fetch({ name: data.name });
            }, this);
          },
          getData: function WorkerTransport_getData() {
            return this.messageHandler.sendWithPromise("GetData", null);
          },
          getPage: function WorkerTransport_getPage(pageNumber, capability) {
            var _this13 = this;

            if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
              return Promise.reject(new Error("Invalid page request"));
            }
            var pageIndex = pageNumber - 1;
            if (pageIndex in this.pagePromises) {
              return this.pagePromises[pageIndex];
            }
            var promise = this.messageHandler.sendWithPromise("GetPage", { pageIndex: pageIndex }).then(function (pageInfo) {
              if (_this13.destroyed) {
                throw new Error("Transport destroyed");
              }
              var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
              _this13.pageCache[pageIndex] = page;
              return page;
            });
            this.pagePromises[pageIndex] = promise;
            return promise;
          },
          getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
            return this.messageHandler.sendWithPromise("GetPageIndex", { ref: ref }).catch(function (reason) {
              return Promise.reject(new Error(reason));
            });
          },
          getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
            return this.messageHandler.sendWithPromise("GetAnnotations", {
              pageIndex: pageIndex,
              intent: intent
            });
          },
          getDestinations: function WorkerTransport_getDestinations() {
            return this.messageHandler.sendWithPromise("GetDestinations", null);
          },
          getDestination: function WorkerTransport_getDestination(id) {
            return this.messageHandler.sendWithPromise("GetDestination", { id: id });
          },
          getPageLabels: function WorkerTransport_getPageLabels() {
            return this.messageHandler.sendWithPromise("GetPageLabels", null);
          },
          getPageMode: function getPageMode() {
            return this.messageHandler.sendWithPromise("GetPageMode", null);
          },

          getAttachments: function WorkerTransport_getAttachments() {
            return this.messageHandler.sendWithPromise("GetAttachments", null);
          },
          getJavaScript: function WorkerTransport_getJavaScript() {
            return this.messageHandler.sendWithPromise("GetJavaScript", null);
          },
          getOutline: function WorkerTransport_getOutline() {
            return this.messageHandler.sendWithPromise("GetOutline", null);
          },
          getMetadata: function WorkerTransport_getMetadata() {
            return this.messageHandler.sendWithPromise("GetMetadata", null).then(function transportMetadata(results) {
              return {
                info: results[0],
                metadata: results[1] ? new _metadata.Metadata(results[1]) : null
              };
            });
          },
          getStats: function WorkerTransport_getStats() {
            return this.messageHandler.sendWithPromise("GetStats", null);
          },
          startCleanup: function WorkerTransport_startCleanup() {
            var _this14 = this;

            this.messageHandler.sendWithPromise("Cleanup", null).then(function () {
              for (var i = 0, ii = _this14.pageCache.length; i < ii; i++) {
                var page = _this14.pageCache[i];
                if (page) {
                  page.cleanup();
                }
              }
              _this14.commonObjs.clear();
              _this14.fontLoader.clear();
            });
          }
        };
        return WorkerTransport;
      }();
      var PDFObjects = function PDFObjectsClosure() {
        function PDFObjects() {
          this.objs = Object.create(null);
        }
        PDFObjects.prototype = {
          ensureObj: function PDFObjects_ensureObj(objId) {
            if (this.objs[objId]) {
              return this.objs[objId];
            }
            var obj = {
              capability: (0, _util.createPromiseCapability)(),
              data: null,
              resolved: false
            };
            this.objs[objId] = obj;
            return obj;
          },
          get: function PDFObjects_get(objId, callback) {
            if (callback) {
              this.ensureObj(objId).capability.promise.then(callback);
              return null;
            }
            var obj = this.objs[objId];
            if (!obj || !obj.resolved) {
              throw new Error("Requesting object that isn't resolved yet " + objId);
            }
            return obj.data;
          },
          resolve: function PDFObjects_resolve(objId, data) {
            var obj = this.ensureObj(objId);
            obj.resolved = true;
            obj.data = data;
            obj.capability.resolve(data);
          },
          isResolved: function PDFObjects_isResolved(objId) {
            var objs = this.objs;
            if (!objs[objId]) {
              return false;
            }
            return objs[objId].resolved;
          },
          hasData: function PDFObjects_hasData(objId) {
            return this.isResolved(objId);
          },
          getData: function PDFObjects_getData(objId) {
            var objs = this.objs;
            if (!objs[objId] || !objs[objId].resolved) {
              return null;
            }
            return objs[objId].data;
          },
          clear: function PDFObjects_clear() {
            this.objs = Object.create(null);
          }
        };
        return PDFObjects;
      }();
      var RenderTask = function RenderTaskClosure() {
        function RenderTask(internalRenderTask) {
          this._internalRenderTask = internalRenderTask;
          this.onContinue = null;
        }
        RenderTask.prototype = {
          get promise() {
            return this._internalRenderTask.capability.promise;
          },
          cancel: function RenderTask_cancel() {
            this._internalRenderTask.cancel();
          },
          then: function RenderTask_then(onFulfilled, onRejected) {
            return this.promise.then.apply(this.promise, arguments);
          }
        };
        return RenderTask;
      }();
      var InternalRenderTask = function InternalRenderTaskClosure() {
        var canvasInRendering = new WeakMap();
        function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
          this.callback = callback;
          this.params = params;
          this.objs = objs;
          this.commonObjs = commonObjs;
          this.operatorListIdx = null;
          this.operatorList = operatorList;
          this.pageNumber = pageNumber;
          this.canvasFactory = canvasFactory;
          this.running = false;
          this.graphicsReadyCallback = null;
          this.graphicsReady = false;
          this.useRequestAnimationFrame = false;
          this.cancelled = false;
          this.capability = (0, _util.createPromiseCapability)();
          this.task = new RenderTask(this);
          this._continueBound = this._continue.bind(this);
          this._scheduleNextBound = this._scheduleNext.bind(this);
          this._nextBound = this._next.bind(this);
          this._canvas = params.canvasContext.canvas;
        }
        InternalRenderTask.prototype = {
          initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
            if (this._canvas) {
              if (canvasInRendering.has(this._canvas)) {
                throw new Error("Cannot use the same canvas during multiple render() operations. " + "Use different canvas or ensure previous operations were " + "cancelled or completed.");
              }
              canvasInRendering.set(this._canvas, this);
            }
            if (this.cancelled) {
              return;
            }
            if ((0, _dom_utils.getDefaultSetting)("pdfBug") && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
              this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
              this.stepper.init(this.operatorList);
              this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
            }
            var params = this.params;
            this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
            this.gfx.beginDrawing({
              transform: params.transform,
              viewport: params.viewport,
              transparency: transparency,
              background: params.background
            });
            this.operatorListIdx = 0;
            this.graphicsReady = true;
            if (this.graphicsReadyCallback) {
              this.graphicsReadyCallback();
            }
          },
          cancel: function InternalRenderTask_cancel() {
            this.running = false;
            this.cancelled = true;
            if (this._canvas) {
              canvasInRendering.delete(this._canvas);
            }
            if ((0, _dom_utils.getDefaultSetting)("pdfjsNext")) {
              this.callback(new _dom_utils.RenderingCancelledException("Rendering cancelled, page " + this.pageNumber, "canvas"));
            } else {
              this.callback("cancelled");
            }
          },
          operatorListChanged: function InternalRenderTask_operatorListChanged() {
            if (!this.graphicsReady) {
              if (!this.graphicsReadyCallback) {
                this.graphicsReadyCallback = this._continueBound;
              }
              return;
            }
            if (this.stepper) {
              this.stepper.updateOperatorList(this.operatorList);
            }
            if (this.running) {
              return;
            }
            this._continue();
          },
          _continue: function InternalRenderTask__continue() {
            this.running = true;
            if (this.cancelled) {
              return;
            }
            if (this.task.onContinue) {
              this.task.onContinue(this._scheduleNextBound);
            } else {
              this._scheduleNext();
            }
          },
          _scheduleNext: function InternalRenderTask__scheduleNext() {
            if (this.useRequestAnimationFrame && typeof window !== "undefined") {
              window.requestAnimationFrame(this._nextBound);
            } else {
              Promise.resolve(undefined).then(this._nextBound);
            }
          },
          _next: function InternalRenderTask__next() {
            if (this.cancelled) {
              return;
            }
            this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
            if (this.operatorListIdx === this.operatorList.argsArray.length) {
              this.running = false;
              if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                if (this._canvas) {
                  canvasInRendering.delete(this._canvas);
                }
                this.callback();
              }
            }
          }
        };
        return InternalRenderTask;
      }();
      var _UnsupportedManager = function UnsupportedManagerClosure() {
        var listeners = [];
        return {
          listen: function listen(cb) {
            (0, _util.deprecated)("Global UnsupportedManager.listen is used: " + " use PDFDocumentLoadingTask.onUnsupportedFeature instead");
            listeners.push(cb);
          },
          notify: function notify(featureId) {
            for (var i = 0, ii = listeners.length; i < ii; i++) {
              listeners[i](featureId);
            }
          }
        };
      }();
      var version, build;
      {
        exports.version = version = "1.10.97";
        exports.build = build = "7d0fce73";
      }
      exports.getDocument = getDocument;
      exports.LoopbackPort = LoopbackPort;
      exports.PDFDataRangeTransport = PDFDataRangeTransport;
      exports.PDFWorker = PDFWorker;
      exports.PDFDocumentProxy = PDFDocumentProxy;
      exports.PDFPageProxy = PDFPageProxy;
      exports.setPDFNetworkStreamClass = setPDFNetworkStreamClass;
      exports._UnsupportedManager = _UnsupportedManager;
      exports.version = version;
      exports.build = build;

      /***/ }),
    /* 70 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.WebGLUtils = undefined;

      var _dom_utils = __w_pdfjs_require__(13);

      var _util = __w_pdfjs_require__(0);

      var WebGLUtils = function WebGLUtilsClosure() {
        function loadShader(gl, code, shaderType) {
          var shader = gl.createShader(shaderType);
          gl.shaderSource(shader, code);
          gl.compileShader(shader);
          var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
          if (!compiled) {
            var errorMsg = gl.getShaderInfoLog(shader);
            throw new Error("Error during shader compilation: " + errorMsg);
          }
          return shader;
        }
        function createVertexShader(gl, code) {
          return loadShader(gl, code, gl.VERTEX_SHADER);
        }
        function createFragmentShader(gl, code) {
          return loadShader(gl, code, gl.FRAGMENT_SHADER);
        }
        function createProgram(gl, shaders) {
          var program = gl.createProgram();
          for (var i = 0, ii = shaders.length; i < ii; ++i) {
            gl.attachShader(program, shaders[i]);
          }
          gl.linkProgram(program);
          var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
          if (!linked) {
            var errorMsg = gl.getProgramInfoLog(program);
            throw new Error("Error during program linking: " + errorMsg);
          }
          return program;
        }
        function createTexture(gl, image, textureId) {
          gl.activeTexture(textureId);
          var texture = gl.createTexture();
          gl.bindTexture(gl.TEXTURE_2D, texture);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
          return texture;
        }
        var currentGL, currentCanvas;
        function generateGL() {
          if (currentGL) {
            return;
          }
          currentCanvas = document.createElement("canvas");
          currentGL = currentCanvas.getContext("webgl", { premultipliedalpha: false });
        }
        var smaskVertexShaderCode = "\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ";
        var smaskFragmentShaderCode = "\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ";
        var smaskCache = null;
        function initSmaskGL() {
          var canvas, gl;
          generateGL();
          canvas = currentCanvas;
          currentCanvas = null;
          gl = currentGL;
          currentGL = null;
          var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
          var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
          var program = createProgram(gl, [vertexShader, fragmentShader]);
          gl.useProgram(program);
          var cache = {};
          cache.gl = gl;
          cache.canvas = canvas;
          cache.resolutionLocation = gl.getUniformLocation(program, "u_resolution");
          cache.positionLocation = gl.getAttribLocation(program, "a_position");
          cache.backdropLocation = gl.getUniformLocation(program, "u_backdrop");
          cache.subtypeLocation = gl.getUniformLocation(program, "u_subtype");
          var texCoordLocation = gl.getAttribLocation(program, "a_texCoord");
          var texLayerLocation = gl.getUniformLocation(program, "u_image");
          var texMaskLocation = gl.getUniformLocation(program, "u_mask");
          var texCoordBuffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
          gl.enableVertexAttribArray(texCoordLocation);
          gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
          gl.uniform1i(texLayerLocation, 0);
          gl.uniform1i(texMaskLocation, 1);
          smaskCache = cache;
        }
        function composeSMask(layer, mask, properties) {
          var width = layer.width,
            height = layer.height;
          if (!smaskCache) {
            initSmaskGL();
          }
          var cache = smaskCache,
            canvas = cache.canvas,
            gl = cache.gl;
          canvas.width = width;
          canvas.height = height;
          gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
          gl.uniform2f(cache.resolutionLocation, width, height);
          if (properties.backdrop) {
            gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
          } else {
            gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
          }
          gl.uniform1i(cache.subtypeLocation, properties.subtype === "Luminosity" ? 1 : 0);
          var texture = createTexture(gl, layer, gl.TEXTURE0);
          var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
          var buffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
          gl.enableVertexAttribArray(cache.positionLocation);
          gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
          gl.clearColor(0, 0, 0, 0);
          gl.enable(gl.BLEND);
          gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
          gl.clear(gl.COLOR_BUFFER_BIT);
          gl.drawArrays(gl.TRIANGLES, 0, 6);
          gl.flush();
          gl.deleteTexture(texture);
          gl.deleteTexture(maskTexture);
          gl.deleteBuffer(buffer);
          return canvas;
        }
        var figuresVertexShaderCode = "\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ";
        var figuresFragmentShaderCode = "\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ";
        var figuresCache = null;
        function initFiguresGL() {
          var canvas, gl;
          generateGL();
          canvas = currentCanvas;
          currentCanvas = null;
          gl = currentGL;
          currentGL = null;
          var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
          var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
          var program = createProgram(gl, [vertexShader, fragmentShader]);
          gl.useProgram(program);
          var cache = {};
          cache.gl = gl;
          cache.canvas = canvas;
          cache.resolutionLocation = gl.getUniformLocation(program, "u_resolution");
          cache.scaleLocation = gl.getUniformLocation(program, "u_scale");
          cache.offsetLocation = gl.getUniformLocation(program, "u_offset");
          cache.positionLocation = gl.getAttribLocation(program, "a_position");
          cache.colorLocation = gl.getAttribLocation(program, "a_color");
          figuresCache = cache;
        }
        function drawFigures(width, height, backgroundColor, figures, context) {
          if (!figuresCache) {
            initFiguresGL();
          }
          var cache = figuresCache,
            canvas = cache.canvas,
            gl = cache.gl;
          canvas.width = width;
          canvas.height = height;
          gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
          gl.uniform2f(cache.resolutionLocation, width, height);
          var count = 0;
          var i, ii, rows;
          for (i = 0, ii = figures.length; i < ii; i++) {
            switch (figures[i].type) {
              case "lattice":
                rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
                count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
                break;
              case "triangles":
                count += figures[i].coords.length;
                break;
            }
          }
          var coords = new Float32Array(count * 2);
          var colors = new Uint8Array(count * 3);
          var coordsMap = context.coords,
            colorsMap = context.colors;
          var pIndex = 0,
            cIndex = 0;
          for (i = 0, ii = figures.length; i < ii; i++) {
            var figure = figures[i],
              ps = figure.coords,
              cs = figure.colors;
            switch (figure.type) {
              case "lattice":
                var cols = figure.verticesPerRow;
                rows = ps.length / cols | 0;
                for (var row = 1; row < rows; row++) {
                  var offset = row * cols + 1;
                  for (var col = 1; col < cols; col++, offset++) {
                    coords[pIndex] = coordsMap[ps[offset - cols - 1]];
                    coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
                    coords[pIndex + 2] = coordsMap[ps[offset - cols]];
                    coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
                    coords[pIndex + 4] = coordsMap[ps[offset - 1]];
                    coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
                    colors[cIndex] = colorsMap[cs[offset - cols - 1]];
                    colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
                    colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
                    colors[cIndex + 3] = colorsMap[cs[offset - cols]];
                    colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
                    colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
                    colors[cIndex + 6] = colorsMap[cs[offset - 1]];
                    colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
                    colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
                    coords[pIndex + 6] = coords[pIndex + 2];
                    coords[pIndex + 7] = coords[pIndex + 3];
                    coords[pIndex + 8] = coords[pIndex + 4];
                    coords[pIndex + 9] = coords[pIndex + 5];
                    coords[pIndex + 10] = coordsMap[ps[offset]];
                    coords[pIndex + 11] = coordsMap[ps[offset] + 1];
                    colors[cIndex + 9] = colors[cIndex + 3];
                    colors[cIndex + 10] = colors[cIndex + 4];
                    colors[cIndex + 11] = colors[cIndex + 5];
                    colors[cIndex + 12] = colors[cIndex + 6];
                    colors[cIndex + 13] = colors[cIndex + 7];
                    colors[cIndex + 14] = colors[cIndex + 8];
                    colors[cIndex + 15] = colorsMap[cs[offset]];
                    colors[cIndex + 16] = colorsMap[cs[offset] + 1];
                    colors[cIndex + 17] = colorsMap[cs[offset] + 2];
                    pIndex += 12;
                    cIndex += 18;
                  }
                }
                break;
              case "triangles":
                for (var j = 0, jj = ps.length; j < jj; j++) {
                  coords[pIndex] = coordsMap[ps[j]];
                  coords[pIndex + 1] = coordsMap[ps[j] + 1];
                  colors[cIndex] = colorsMap[cs[j]];
                  colors[cIndex + 1] = colorsMap[cs[j] + 1];
                  colors[cIndex + 2] = colorsMap[cs[j] + 2];
                  pIndex += 2;
                  cIndex += 3;
                }
                break;
            }
          }
          if (backgroundColor) {
            gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
          } else {
            gl.clearColor(0, 0, 0, 0);
          }
          gl.clear(gl.COLOR_BUFFER_BIT);
          var coordsBuffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
          gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
          gl.enableVertexAttribArray(cache.positionLocation);
          gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
          var colorsBuffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
          gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
          gl.enableVertexAttribArray(cache.colorLocation);
          gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
          gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
          gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
          gl.drawArrays(gl.TRIANGLES, 0, count);
          gl.flush();
          gl.deleteBuffer(coordsBuffer);
          gl.deleteBuffer(colorsBuffer);
          return canvas;
        }
        function cleanup() {
          if (smaskCache && smaskCache.canvas) {
            smaskCache.canvas.width = 0;
            smaskCache.canvas.height = 0;
          }
          if (figuresCache && figuresCache.canvas) {
            figuresCache.canvas.width = 0;
            figuresCache.canvas.height = 0;
          }
          smaskCache = null;
          figuresCache = null;
        }
        return {
          get isEnabled() {
            if ((0, _dom_utils.getDefaultSetting)("disableWebGL")) {
              return false;
            }
            var enabled = false;
            try {
              generateGL();
              enabled = !!currentGL;
            } catch (e) {}
            return (0, _util.shadow)(this, "isEnabled", enabled);
          },
          composeSMask: composeSMask,
          drawFigures: drawFigures,
          clear: cleanup
        };
      }();
      exports.WebGLUtils = WebGLUtils;

      /***/ }),
    /* 71 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Metadata = undefined;

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _util = __w_pdfjs_require__(0);

      var _dom_utils = __w_pdfjs_require__(13);

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var Metadata = function () {
        function Metadata(data) {
          _classCallCheck(this, Metadata);

          (0, _util.assert)(typeof data === "string", "Metadata: input is not a string");
          data = this._repair(data);
          var parser = new _dom_utils.SimpleXMLParser();
          data = parser.parseFromString(data);
          this._metadata = Object.create(null);
          this._parse(data);
        }

        _createClass(Metadata, [{
          key: "_repair",
          value: function _repair(data) {
            return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
              var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
                return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
              });
              var chars = "";
              for (var i = 0, ii = bytes.length; i < ii; i += 2) {
                var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
                if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
                  chars += String.fromCharCode(code);
                } else {
                  chars += "&#x" + (0x10000 + code).toString(16).substring(1) + ";";
                }
              }
              return ">" + chars;
            });
          }
        }, {
          key: "_parse",
          value: function _parse(domDocument) {
            var rdf = domDocument.documentElement;
            if (rdf.nodeName.toLowerCase() !== "rdf:rdf") {
              rdf = rdf.firstChild;
              while (rdf && rdf.nodeName.toLowerCase() !== "rdf:rdf") {
                rdf = rdf.nextSibling;
              }
            }
            var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
            if (!rdf || nodeName !== "rdf:rdf" || !rdf.hasChildNodes()) {
              return;
            }
            var children = rdf.childNodes;
            for (var i = 0, ii = children.length; i < ii; i++) {
              var desc = children[i];
              if (desc.nodeName.toLowerCase() !== "rdf:description") {
                continue;
              }
              for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
                if (desc.childNodes[j].nodeName.toLowerCase() !== "#text") {
                  var entry = desc.childNodes[j];
                  var name = entry.nodeName.toLowerCase();
                  this._metadata[name] = entry.textContent.trim();
                }
              }
            }
          }
        }, {
          key: "get",
          value: function get(name) {
            return this._metadata[name] || null;
          }
        }, {
          key: "getAll",
          value: function getAll() {
            return this._metadata;
          }
        }, {
          key: "has",
          value: function has(name) {
            return typeof this._metadata[name] !== "undefined";
          }
        }, {
          key: "metadata",
          get: function get() {
            (0, _util.deprecated)("`metadata` getter; use `getAll()` instead.");
            return this.getAll();
          }
        }]);

        return Metadata;
      }();

      exports.Metadata = Metadata;

      /***/ }),
    /* 72 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AnnotationLayer = undefined;

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _dom_utils = __w_pdfjs_require__(13);

      var _util = __w_pdfjs_require__(0);

      function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

      function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var AnnotationElementFactory = function () {
        function AnnotationElementFactory() {
          _classCallCheck(this, AnnotationElementFactory);
        }

        _createClass(AnnotationElementFactory, null, [{
          key: "create",
          value: function create(parameters) {
            var subtype = parameters.data.annotationType;
            switch (subtype) {
              case _util.AnnotationType.LINK:
                return new LinkAnnotationElement(parameters);
              case _util.AnnotationType.TEXT:
                return new TextAnnotationElement(parameters);
              case _util.AnnotationType.WIDGET:
                var fieldType = parameters.data.fieldType;
                switch (fieldType) {
                  case "Tx":
                    return new TextWidgetAnnotationElement(parameters);
                  case "Btn":
                    if (parameters.data.radioButton) {
                      return new RadioButtonWidgetAnnotationElement(parameters);
                    } else if (parameters.data.checkBox) {
                      return new CheckboxWidgetAnnotationElement(parameters);
                    }
                    (0, _util.warn)("Unimplemented button widget annotation: pushbutton");
                    break;
                  case "Ch":
                    return new ChoiceWidgetAnnotationElement(parameters);
                }
                return new WidgetAnnotationElement(parameters);
              case _util.AnnotationType.POPUP:
                return new PopupAnnotationElement(parameters);
              case _util.AnnotationType.LINE:
                return new LineAnnotationElement(parameters);
              case _util.AnnotationType.SQUARE:
                return new SquareAnnotationElement(parameters);
              case _util.AnnotationType.CIRCLE:
                return new CircleAnnotationElement(parameters);
              case _util.AnnotationType.POLYLINE:
                return new PolylineAnnotationElement(parameters);
              case _util.AnnotationType.POLYGON:
                return new PolygonAnnotationElement(parameters);
              case _util.AnnotationType.HIGHLIGHT:
                return new HighlightAnnotationElement(parameters);
              case _util.AnnotationType.UNDERLINE:
                return new UnderlineAnnotationElement(parameters);
              case _util.AnnotationType.SQUIGGLY:
                return new SquigglyAnnotationElement(parameters);
              case _util.AnnotationType.STRIKEOUT:
                return new StrikeOutAnnotationElement(parameters);
              case _util.AnnotationType.STAMP:
                return new StampAnnotationElement(parameters);
              case _util.AnnotationType.FILEATTACHMENT:
                return new FileAttachmentAnnotationElement(parameters);
              default:
                return new AnnotationElement(parameters);
            }
          }
        }]);

        return AnnotationElementFactory;
      }();

      var AnnotationElement = function () {
        function AnnotationElement(parameters) {
          var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          _classCallCheck(this, AnnotationElement);

          this.isRenderable = isRenderable;
          this.data = parameters.data;
          this.layer = parameters.layer;
          this.page = parameters.page;
          this.viewport = parameters.viewport;
          this.linkService = parameters.linkService;
          this.downloadManager = parameters.downloadManager;
          this.imageResourcesPath = parameters.imageResourcesPath;
          this.renderInteractiveForms = parameters.renderInteractiveForms;
          this.svgFactory = parameters.svgFactory;
          if (isRenderable) {
            this.container = this._createContainer(ignoreBorder);
          }
        }

        _createClass(AnnotationElement, [{
          key: "_createContainer",
          value: function _createContainer() {
            var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var data = this.data,
              page = this.page,
              viewport = this.viewport;
            var container = document.createElement("section");
            var width = data.rect[2] - data.rect[0];
            var height = data.rect[3] - data.rect[1];
            container.setAttribute("data-annotation-id", data.id);
            var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
            _dom_utils.CustomStyle.setProp("transform", container, "matrix(" + viewport.transform.join(",") + ")");
            _dom_utils.CustomStyle.setProp("transformOrigin", container, -rect[0] + "px " + -rect[1] + "px");
            if (!ignoreBorder && data.borderStyle.width > 0) {
              container.style.borderWidth = data.borderStyle.width + "px";
              if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
                width = width - 2 * data.borderStyle.width;
                height = height - 2 * data.borderStyle.width;
              }
              var horizontalRadius = data.borderStyle.horizontalCornerRadius;
              var verticalRadius = data.borderStyle.verticalCornerRadius;
              if (horizontalRadius > 0 || verticalRadius > 0) {
                var radius = horizontalRadius + "px / " + verticalRadius + "px";
                _dom_utils.CustomStyle.setProp("borderRadius", container, radius);
              }
              switch (data.borderStyle.style) {
                case _util.AnnotationBorderStyleType.SOLID:
                  container.style.borderStyle = "solid";
                  break;
                case _util.AnnotationBorderStyleType.DASHED:
                  container.style.borderStyle = "dashed";
                  break;
                case _util.AnnotationBorderStyleType.BEVELED:
                  (0, _util.warn)("Unimplemented border style: beveled");
                  break;
                case _util.AnnotationBorderStyleType.INSET:
                  (0, _util.warn)("Unimplemented border style: inset");
                  break;
                case _util.AnnotationBorderStyleType.UNDERLINE:
                  container.style.borderBottomStyle = "solid";
                  break;
                default:
                  break;
              }
              if (data.color) {
                container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
              } else {
                container.style.borderWidth = 0;
              }
            }
            container.style.left = rect[0] + "px";
            container.style.top = rect[1] + "px";
            container.style.width = width + "px";
            container.style.height = height + "px";
            return container;
          }
        }, {
          key: "_createPopup",
          value: function _createPopup(container, trigger, data) {
            if (!trigger) {
              trigger = document.createElement("div");
              trigger.style.height = container.style.height;
              trigger.style.width = container.style.width;
              container.appendChild(trigger);
            }
            var popupElement = new PopupElement({
              container: container,
              trigger: trigger,
              color: data.color,
              title: data.title,
              contents: data.contents,
              hideWrapper: true
            });
            var popup = popupElement.render();
            popup.style.left = container.style.width;
            container.appendChild(popup);
          }
        }, {
          key: "render",
          value: function render() {
            throw new Error("Abstract method `AnnotationElement.render` called");
          }
        }]);

        return AnnotationElement;
      }();

      var LinkAnnotationElement = function (_AnnotationElement) {
        _inherits(LinkAnnotationElement, _AnnotationElement);

        function LinkAnnotationElement(parameters) {
          _classCallCheck(this, LinkAnnotationElement);

          var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
          return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
        }

        _createClass(LinkAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "linkAnnotation";
            var link = document.createElement("a");
            (0, _dom_utils.addLinkAttributes)(link, {
              url: this.data.url,
              target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
            });
            if (!this.data.url) {
              if (this.data.action) {
                this._bindNamedAction(link, this.data.action);
              } else {
                this._bindLink(link, this.data.dest);
              }
            }
            this.container.appendChild(link);
            return this.container;
          }
        }, {
          key: "_bindLink",
          value: function _bindLink(link, destination) {
            var _this2 = this;

            link.href = this.linkService.getDestinationHash(destination);
            link.onclick = function () {
              if (destination) {
                _this2.linkService.navigateTo(destination);
              }
              return false;
            };
            if (destination) {
              link.className = "internalLink";
            }
          }
        }, {
          key: "_bindNamedAction",
          value: function _bindNamedAction(link, action) {
            var _this3 = this;

            link.href = this.linkService.getAnchorUrl("");
            link.onclick = function () {
              _this3.linkService.executeNamedAction(action);
              return false;
            };
            link.className = "internalLink";
          }
        }]);

        return LinkAnnotationElement;
      }(AnnotationElement);

      var TextAnnotationElement = function (_AnnotationElement2) {
        _inherits(TextAnnotationElement, _AnnotationElement2);

        function TextAnnotationElement(parameters) {
          _classCallCheck(this, TextAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
        }

        _createClass(TextAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "textAnnotation";
            var image = document.createElement("img");
            image.style.height = this.container.style.height;
            image.style.width = this.container.style.width;
            image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
            image.alt = "[{{type}} Annotation]";
            image.dataset.l10nId = "text_annotation_type";
            image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
            if (!this.data.hasPopup) {
              this._createPopup(this.container, image, this.data);
            }
            this.container.appendChild(image);
            return this.container;
          }
        }]);

        return TextAnnotationElement;
      }(AnnotationElement);

      var WidgetAnnotationElement = function (_AnnotationElement3) {
        _inherits(WidgetAnnotationElement, _AnnotationElement3);

        function WidgetAnnotationElement() {
          _classCallCheck(this, WidgetAnnotationElement);

          return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
        }

        _createClass(WidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            return this.container;
          }
        }]);

        return WidgetAnnotationElement;
      }(AnnotationElement);

      var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
        _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);

        function TextWidgetAnnotationElement(parameters) {
          _classCallCheck(this, TextWidgetAnnotationElement);

          var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
          return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
        }

        _createClass(TextWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            var TEXT_ALIGNMENT = ["left", "center", "right"];
            this.container.className = "textWidgetAnnotation";
            var element = null;
            if (this.renderInteractiveForms) {
              if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = this.data.fieldValue;
              } else {
                element = document.createElement("input");
                element.type = "text";
                element.setAttribute("value", this.data.fieldValue);
              }
              element.disabled = this.data.readOnly;
              if (this.data.maxLen !== null) {
                element.maxLength = this.data.maxLen;
              }
              if (this.data.comb) {
                var fieldWidth = this.data.rect[2] - this.data.rect[0];
                var combWidth = fieldWidth / this.data.maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = "calc(" + combWidth + "px - 1ch)";
              }
            } else {
              element = document.createElement("div");
              element.textContent = this.data.fieldValue;
              element.style.verticalAlign = "middle";
              element.style.display = "table-cell";
              var font = null;
              if (this.data.fontRefName) {
                font = this.page.commonObjs.getData(this.data.fontRefName);
              }
              this._setTextStyle(element, font);
            }
            if (this.data.textAlignment !== null) {
              element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
            }
            this.container.appendChild(element);
            return this.container;
          }
        }, {
          key: "_setTextStyle",
          value: function _setTextStyle(element, font) {
            var style = element.style;
            style.fontSize = this.data.fontSize + "px";
            style.direction = this.data.fontDirection < 0 ? "rtl" : "ltr";
            if (!font) {
              return;
            }
            style.fontWeight = font.black ? font.bold ? "900" : "bold" : font.bold ? "bold" : "normal";
            style.fontStyle = font.italic ? "italic" : "normal";
            var fontFamily = font.loadedName ? "\"" + font.loadedName + "\", " : "";
            var fallbackName = font.fallbackName || "Helvetica, sans-serif";
            style.fontFamily = fontFamily + fallbackName;
          }
        }]);

        return TextWidgetAnnotationElement;
      }(WidgetAnnotationElement);

      var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
        _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);

        function CheckboxWidgetAnnotationElement(parameters) {
          _classCallCheck(this, CheckboxWidgetAnnotationElement);

          return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
        }

        _createClass(CheckboxWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "buttonWidgetAnnotation checkBox";
            var element = document.createElement("input");
            element.disabled = this.data.readOnly;
            element.type = "checkbox";
            if (this.data.fieldValue && this.data.fieldValue !== "Off") {
              element.setAttribute("checked", true);
            }
            this.container.appendChild(element);
            return this.container;
          }
        }]);

        return CheckboxWidgetAnnotationElement;
      }(WidgetAnnotationElement);

      var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
        _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);

        function RadioButtonWidgetAnnotationElement(parameters) {
          _classCallCheck(this, RadioButtonWidgetAnnotationElement);

          return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
        }

        _createClass(RadioButtonWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "buttonWidgetAnnotation radioButton";
            var element = document.createElement("input");
            element.disabled = this.data.readOnly;
            element.type = "radio";
            element.name = this.data.fieldName;
            if (this.data.fieldValue === this.data.buttonValue) {
              element.setAttribute("checked", true);
            }
            this.container.appendChild(element);
            return this.container;
          }
        }]);

        return RadioButtonWidgetAnnotationElement;
      }(WidgetAnnotationElement);

      var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
        _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);

        function ChoiceWidgetAnnotationElement(parameters) {
          _classCallCheck(this, ChoiceWidgetAnnotationElement);

          return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
        }

        _createClass(ChoiceWidgetAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "choiceWidgetAnnotation";
            var selectElement = document.createElement("select");
            selectElement.disabled = this.data.readOnly;
            if (!this.data.combo) {
              selectElement.size = this.data.options.length;
              if (this.data.multiSelect) {
                selectElement.multiple = true;
              }
            }
            for (var i = 0, ii = this.data.options.length; i < ii; i++) {
              var option = this.data.options[i];
              var optionElement = document.createElement("option");
              optionElement.textContent = option.displayValue;
              optionElement.value = option.exportValue;
              if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
                optionElement.setAttribute("selected", true);
              }
              selectElement.appendChild(optionElement);
            }
            this.container.appendChild(selectElement);
            return this.container;
          }
        }]);

        return ChoiceWidgetAnnotationElement;
      }(WidgetAnnotationElement);

      var PopupAnnotationElement = function (_AnnotationElement4) {
        _inherits(PopupAnnotationElement, _AnnotationElement4);

        function PopupAnnotationElement(parameters) {
          _classCallCheck(this, PopupAnnotationElement);

          var isRenderable = !!(parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
        }

        _createClass(PopupAnnotationElement, [{
          key: "render",
          value: function render() {
            var IGNORE_TYPES = ["Line", "Square", "Circle", "PolyLine", "Polygon"];
            this.container.className = "popupAnnotation";
            if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
              return this.container;
            }
            var selector = "[data-annotation-id=\"" + this.data.parentId + "\"]";
            var parentElement = this.layer.querySelector(selector);
            if (!parentElement) {
              return this.container;
            }
            var popup = new PopupElement({
              container: this.container,
              trigger: parentElement,
              color: this.data.color,
              title: this.data.title,
              contents: this.data.contents
            });
            var parentLeft = parseFloat(parentElement.style.left);
            var parentWidth = parseFloat(parentElement.style.width);
            _dom_utils.CustomStyle.setProp("transformOrigin", this.container, -(parentLeft + parentWidth) + "px -" + parentElement.style.top);
            this.container.style.left = parentLeft + parentWidth + "px";
            this.container.appendChild(popup.render());
            return this.container;
          }
        }]);

        return PopupAnnotationElement;
      }(AnnotationElement);

      var PopupElement = function () {
        function PopupElement(parameters) {
          _classCallCheck(this, PopupElement);

          this.container = parameters.container;
          this.trigger = parameters.trigger;
          this.color = parameters.color;
          this.title = parameters.title;
          this.contents = parameters.contents;
          this.hideWrapper = parameters.hideWrapper || false;
          this.pinned = false;
        }

        _createClass(PopupElement, [{
          key: "render",
          value: function render() {
            var BACKGROUND_ENLIGHT = 0.7;
            var wrapper = document.createElement("div");
            wrapper.className = "popupWrapper";
            this.hideElement = this.hideWrapper ? wrapper : this.container;
            this.hideElement.setAttribute("hidden", true);
            var popup = document.createElement("div");
            popup.className = "popup";
            var color = this.color;
            if (color) {
              var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
              var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
              var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
              popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
            }
            var contents = this._formatContents(this.contents);
            var title = document.createElement("h1");
            title.textContent = this.title;
            this.trigger.addEventListener("click", this._toggle.bind(this));
            this.trigger.addEventListener("mouseover", this._show.bind(this, false));
            this.trigger.addEventListener("mouseout", this._hide.bind(this, false));
            popup.addEventListener("click", this._hide.bind(this, true));
            popup.appendChild(title);
            popup.appendChild(contents);
            wrapper.appendChild(popup);
            return wrapper;
          }
        }, {
          key: "_formatContents",
          value: function _formatContents(contents) {
            var p = document.createElement("p");
            var lines = contents.split(/(?:\r\n?|\n)/);
            for (var i = 0, ii = lines.length; i < ii; ++i) {
              var line = lines[i];
              p.appendChild(document.createTextNode(line));
              if (i < ii - 1) {
                p.appendChild(document.createElement("br"));
              }
            }
            return p;
          }
        }, {
          key: "_toggle",
          value: function _toggle() {
            if (this.pinned) {
              this._hide(true);
            } else {
              this._show(true);
            }
          }
        }, {
          key: "_show",
          value: function _show() {
            var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (pin) {
              this.pinned = true;
            }
            if (this.hideElement.hasAttribute("hidden")) {
              this.hideElement.removeAttribute("hidden");
              this.container.style.zIndex += 1;
            }
          }
        }, {
          key: "_hide",
          value: function _hide() {
            var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (unpin) {
              this.pinned = false;
            }
            if (!this.hideElement.hasAttribute("hidden") && !this.pinned) {
              this.hideElement.setAttribute("hidden", true);
              this.container.style.zIndex -= 1;
            }
          }
        }]);

        return PopupElement;
      }();

      var LineAnnotationElement = function (_AnnotationElement5) {
        _inherits(LineAnnotationElement, _AnnotationElement5);

        function LineAnnotationElement(parameters) {
          _classCallCheck(this, LineAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(LineAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "lineAnnotation";
            var data = this.data;
            var width = data.rect[2] - data.rect[0];
            var height = data.rect[3] - data.rect[1];
            var svg = this.svgFactory.create(width, height);
            var line = this.svgFactory.createElement("svg:line");
            line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
            line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
            line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
            line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
            line.setAttribute("stroke-width", data.borderStyle.width);
            line.setAttribute("stroke", "transparent");
            svg.appendChild(line);
            this.container.append(svg);
            this._createPopup(this.container, line, data);
            return this.container;
          }
        }]);

        return LineAnnotationElement;
      }(AnnotationElement);

      var SquareAnnotationElement = function (_AnnotationElement6) {
        _inherits(SquareAnnotationElement, _AnnotationElement6);

        function SquareAnnotationElement(parameters) {
          _classCallCheck(this, SquareAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(SquareAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "squareAnnotation";
            var data = this.data;
            var width = data.rect[2] - data.rect[0];
            var height = data.rect[3] - data.rect[1];
            var svg = this.svgFactory.create(width, height);
            var borderWidth = data.borderStyle.width;
            var square = this.svgFactory.createElement("svg:rect");
            square.setAttribute("x", borderWidth / 2);
            square.setAttribute("y", borderWidth / 2);
            square.setAttribute("width", width - borderWidth);
            square.setAttribute("height", height - borderWidth);
            square.setAttribute("stroke-width", borderWidth);
            square.setAttribute("stroke", "transparent");
            square.setAttribute("fill", "none");
            svg.appendChild(square);
            this.container.append(svg);
            this._createPopup(this.container, square, data);
            return this.container;
          }
        }]);

        return SquareAnnotationElement;
      }(AnnotationElement);

      var CircleAnnotationElement = function (_AnnotationElement7) {
        _inherits(CircleAnnotationElement, _AnnotationElement7);

        function CircleAnnotationElement(parameters) {
          _classCallCheck(this, CircleAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(CircleAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "circleAnnotation";
            var data = this.data;
            var width = data.rect[2] - data.rect[0];
            var height = data.rect[3] - data.rect[1];
            var svg = this.svgFactory.create(width, height);
            var borderWidth = data.borderStyle.width;
            var circle = this.svgFactory.createElement("svg:ellipse");
            circle.setAttribute("cx", width / 2);
            circle.setAttribute("cy", height / 2);
            circle.setAttribute("rx", width / 2 - borderWidth / 2);
            circle.setAttribute("ry", height / 2 - borderWidth / 2);
            circle.setAttribute("stroke-width", borderWidth);
            circle.setAttribute("stroke", "transparent");
            circle.setAttribute("fill", "none");
            svg.appendChild(circle);
            this.container.append(svg);
            this._createPopup(this.container, circle, data);
            return this.container;
          }
        }]);

        return CircleAnnotationElement;
      }(AnnotationElement);

      var PolylineAnnotationElement = function (_AnnotationElement8) {
        _inherits(PolylineAnnotationElement, _AnnotationElement8);

        function PolylineAnnotationElement(parameters) {
          _classCallCheck(this, PolylineAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);

          var _this14 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));

          _this14.containerClassName = "polylineAnnotation";
          _this14.svgElementName = "svg:polyline";
          return _this14;
        }

        _createClass(PolylineAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = this.containerClassName;
            var data = this.data;
            var width = data.rect[2] - data.rect[0];
            var height = data.rect[3] - data.rect[1];
            var svg = this.svgFactory.create(width, height);
            var vertices = data.vertices;
            var points = [];
            for (var i = 0, ii = vertices.length; i < ii; i++) {
              var x = vertices[i].x - data.rect[0];
              var y = data.rect[3] - vertices[i].y;
              points.push(x + "," + y);
            }
            points = points.join(" ");
            var borderWidth = data.borderStyle.width;
            var polyline = this.svgFactory.createElement(this.svgElementName);
            polyline.setAttribute("points", points);
            polyline.setAttribute("stroke-width", borderWidth);
            polyline.setAttribute("stroke", "transparent");
            polyline.setAttribute("fill", "none");
            svg.appendChild(polyline);
            this.container.append(svg);
            this._createPopup(this.container, polyline, data);
            return this.container;
          }
        }]);

        return PolylineAnnotationElement;
      }(AnnotationElement);

      var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
        _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);

        function PolygonAnnotationElement(parameters) {
          _classCallCheck(this, PolygonAnnotationElement);

          var _this15 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));

          _this15.containerClassName = "polygonAnnotation";
          _this15.svgElementName = "svg:polygon";
          return _this15;
        }

        return PolygonAnnotationElement;
      }(PolylineAnnotationElement);

      var HighlightAnnotationElement = function (_AnnotationElement9) {
        _inherits(HighlightAnnotationElement, _AnnotationElement9);

        function HighlightAnnotationElement(parameters) {
          _classCallCheck(this, HighlightAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(HighlightAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "highlightAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data);
            }
            return this.container;
          }
        }]);

        return HighlightAnnotationElement;
      }(AnnotationElement);

      var UnderlineAnnotationElement = function (_AnnotationElement10) {
        _inherits(UnderlineAnnotationElement, _AnnotationElement10);

        function UnderlineAnnotationElement(parameters) {
          _classCallCheck(this, UnderlineAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(UnderlineAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "underlineAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data);
            }
            return this.container;
          }
        }]);

        return UnderlineAnnotationElement;
      }(AnnotationElement);

      var SquigglyAnnotationElement = function (_AnnotationElement11) {
        _inherits(SquigglyAnnotationElement, _AnnotationElement11);

        function SquigglyAnnotationElement(parameters) {
          _classCallCheck(this, SquigglyAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(SquigglyAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "squigglyAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data);
            }
            return this.container;
          }
        }]);

        return SquigglyAnnotationElement;
      }(AnnotationElement);

      var StrikeOutAnnotationElement = function (_AnnotationElement12) {
        _inherits(StrikeOutAnnotationElement, _AnnotationElement12);

        function StrikeOutAnnotationElement(parameters) {
          _classCallCheck(this, StrikeOutAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(StrikeOutAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "strikeoutAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data);
            }
            return this.container;
          }
        }]);

        return StrikeOutAnnotationElement;
      }(AnnotationElement);

      var StampAnnotationElement = function (_AnnotationElement13) {
        _inherits(StampAnnotationElement, _AnnotationElement13);

        function StampAnnotationElement(parameters) {
          _classCallCheck(this, StampAnnotationElement);

          var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
          return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
        }

        _createClass(StampAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "stampAnnotation";
            if (!this.data.hasPopup) {
              this._createPopup(this.container, null, this.data);
            }
            return this.container;
          }
        }]);

        return StampAnnotationElement;
      }(AnnotationElement);

      var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
        _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);

        function FileAttachmentAnnotationElement(parameters) {
          _classCallCheck(this, FileAttachmentAnnotationElement);

          var _this21 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));

          var file = _this21.data.file;
          _this21.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
          _this21.content = file.content;
          _this21.linkService.onFileAttachmentAnnotation({
            id: (0, _util.stringToPDFString)(file.filename),
            filename: file.filename,
            content: file.content
          });
          return _this21;
        }

        _createClass(FileAttachmentAnnotationElement, [{
          key: "render",
          value: function render() {
            this.container.className = "fileAttachmentAnnotation";
            var trigger = document.createElement("div");
            trigger.style.height = this.container.style.height;
            trigger.style.width = this.container.style.width;
            trigger.addEventListener("dblclick", this._download.bind(this));
            if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
              this._createPopup(this.container, trigger, this.data);
            }
            this.container.appendChild(trigger);
            return this.container;
          }
        }, {
          key: "_download",
          value: function _download() {
            if (!this.downloadManager) {
              (0, _util.warn)("Download cannot be started due to unavailable download manager");
              return;
            }
            this.downloadManager.downloadData(this.content, this.filename, "");
          }
        }]);

        return FileAttachmentAnnotationElement;
      }(AnnotationElement);

      var AnnotationLayer = function () {
        function AnnotationLayer() {
          _classCallCheck(this, AnnotationLayer);
        }

        _createClass(AnnotationLayer, null, [{
          key: "render",
          value: function render(parameters) {
            for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
              var data = parameters.annotations[i];
              if (!data) {
                continue;
              }
              var element = AnnotationElementFactory.create({
                data: data,
                layer: parameters.div,
                page: parameters.page,
                viewport: parameters.viewport,
                linkService: parameters.linkService,
                downloadManager: parameters.downloadManager,
                imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)("imageResourcesPath"),
                renderInteractiveForms: parameters.renderInteractiveForms || false,
                svgFactory: new _dom_utils.DOMSVGFactory()
              });
              if (element.isRenderable) {
                parameters.div.appendChild(element.render());
              }
            }
          }
        }, {
          key: "update",
          value: function update(parameters) {
            for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
              var data = parameters.annotations[i];
              var element = parameters.div.querySelector("[data-annotation-id=\"" + data.id + "\"]");
              if (element) {
                _dom_utils.CustomStyle.setProp("transform", element, "matrix(" + parameters.viewport.transform.join(",") + ")");
              }
            }
            parameters.div.removeAttribute("hidden");
          }
        }]);

        return AnnotationLayer;
      }();

      exports.AnnotationLayer = AnnotationLayer;

      /***/ }),
    /* 73 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.renderTextLayer = undefined;

      var _util = __w_pdfjs_require__(0);

      var _dom_utils = __w_pdfjs_require__(13);

      var renderTextLayer = function renderTextLayerClosure() {
        var MAX_TEXT_DIVS_TO_RENDER = 100000;
        var NonWhitespaceRegexp = /\S/;
        function isAllWhitespace(str) {
          return !NonWhitespaceRegexp.test(str);
        }
        var styleBuf = ["left: ", 0, "px; top: ", 0, "px; font-size: ", 0, "px; font-family: ", "", ";"];
        function appendText(task, geom, styles) {
          var textDiv = document.createElement("div");
          var textDivProperties = {
            style: null,
            angle: 0,
            canvasWidth: 0,
            isWhitespace: false,
            originalTransform: null,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0,
            scale: 1
          };
          task._textDivs.push(textDiv);
          if (isAllWhitespace(geom.str)) {
            textDivProperties.isWhitespace = true;
            task._textDivProperties.set(textDiv, textDivProperties);
            return;
          }
          var tx = _util.Util.transform(task._viewport.transform, geom.transform);
          var angle = Math.atan2(tx[1], tx[0]);
          var style = styles[geom.fontName];
          if (style.vertical) {
            angle += Math.PI / 2;
          }
          var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
          var fontAscent = fontHeight;
          if (style.ascent) {
            fontAscent = style.ascent * fontAscent;
          } else if (style.descent) {
            fontAscent = (1 + style.descent) * fontAscent;
          }
          var left;
          var top;
          if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
          } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
          }
          styleBuf[1] = left;
          styleBuf[3] = top;
          styleBuf[5] = fontHeight;
          styleBuf[7] = style.fontFamily;
          textDivProperties.style = styleBuf.join("");
          textDiv.setAttribute("style", textDivProperties.style);
          textDiv.textContent = geom.str;
          if ((0, _dom_utils.getDefaultSetting)("pdfBug")) {
            textDiv.dataset.fontName = geom.fontName;
          }
          if (angle !== 0) {
            textDivProperties.angle = angle * (180 / Math.PI);
          }
          if (geom.str.length > 1) {
            if (style.vertical) {
              textDivProperties.canvasWidth = geom.height * task._viewport.scale;
            } else {
              textDivProperties.canvasWidth = geom.width * task._viewport.scale;
            }
          }
          task._textDivProperties.set(textDiv, textDivProperties);
          if (task._textContentStream) {
            task._layoutText(textDiv);
          }
          if (task._enhanceTextSelection) {
            var angleCos = 1,
              angleSin = 0;
            if (angle !== 0) {
              angleCos = Math.cos(angle);
              angleSin = Math.sin(angle);
            }
            var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
            var divHeight = fontHeight;
            var m, b;
            if (angle !== 0) {
              m = [angleCos, angleSin, -angleSin, angleCos, left, top];
              b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
            } else {
              b = [left, top, left + divWidth, top + divHeight];
            }
            task._bounds.push({
              left: b[0],
              top: b[1],
              right: b[2],
              bottom: b[3],
              div: textDiv,
              size: [divWidth, divHeight],
              m: m
            });
          }
        }
        function render(task) {
          if (task._canceled) {
            return;
          }
          var textDivs = task._textDivs;
          var capability = task._capability;
          var textDivsLength = textDivs.length;
          if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
            task._renderingDone = true;
            capability.resolve();
            return;
          }
          if (!task._textContentStream) {
            for (var i = 0; i < textDivsLength; i++) {
              task._layoutText(textDivs[i]);
            }
          }
          task._renderingDone = true;
          capability.resolve();
        }
        function expand(task) {
          var bounds = task._bounds;
          var viewport = task._viewport;
          var expanded = expandBounds(viewport.width, viewport.height, bounds);
          for (var i = 0; i < expanded.length; i++) {
            var div = bounds[i].div;
            var divProperties = task._textDivProperties.get(div);
            if (divProperties.angle === 0) {
              divProperties.paddingLeft = bounds[i].left - expanded[i].left;
              divProperties.paddingTop = bounds[i].top - expanded[i].top;
              divProperties.paddingRight = expanded[i].right - bounds[i].right;
              divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
              task._textDivProperties.set(div, divProperties);
              continue;
            }
            var e = expanded[i],
              b = bounds[i];
            var m = b.m,
              c = m[0],
              s = m[1];
            var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
            var ts = new Float64Array(64);
            points.forEach(function (p, i) {
              var t = _util.Util.applyTransform(p, m);
              ts[i + 0] = c && (e.left - t[0]) / c;
              ts[i + 4] = s && (e.top - t[1]) / s;
              ts[i + 8] = c && (e.right - t[0]) / c;
              ts[i + 12] = s && (e.bottom - t[1]) / s;
              ts[i + 16] = s && (e.left - t[0]) / -s;
              ts[i + 20] = c && (e.top - t[1]) / c;
              ts[i + 24] = s && (e.right - t[0]) / -s;
              ts[i + 28] = c && (e.bottom - t[1]) / c;
              ts[i + 32] = c && (e.left - t[0]) / -c;
              ts[i + 36] = s && (e.top - t[1]) / -s;
              ts[i + 40] = c && (e.right - t[0]) / -c;
              ts[i + 44] = s && (e.bottom - t[1]) / -s;
              ts[i + 48] = s && (e.left - t[0]) / s;
              ts[i + 52] = c && (e.top - t[1]) / -c;
              ts[i + 56] = s && (e.right - t[0]) / s;
              ts[i + 60] = c && (e.bottom - t[1]) / -c;
            });
            var findPositiveMin = function findPositiveMin(ts, offset, count) {
              var result = 0;
              for (var i = 0; i < count; i++) {
                var t = ts[offset++];
                if (t > 0) {
                  result = result ? Math.min(t, result) : t;
                }
              }
              return result;
            };
            var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
            divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
            divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
            divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
            divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
            task._textDivProperties.set(div, divProperties);
          }
        }
        function expandBounds(width, height, boxes) {
          var bounds = boxes.map(function (box, i) {
            return {
              x1: box.left,
              y1: box.top,
              x2: box.right,
              y2: box.bottom,
              index: i,
              x1New: undefined,
              x2New: undefined
            };
          });
          expandBoundsLTR(width, bounds);
          var expanded = new Array(boxes.length);
          bounds.forEach(function (b) {
            var i = b.index;
            expanded[i] = {
              left: b.x1New,
              top: 0,
              right: b.x2New,
              bottom: 0
            };
          });
          boxes.map(function (box, i) {
            var e = expanded[i],
              b = bounds[i];
            b.x1 = box.top;
            b.y1 = width - e.right;
            b.x2 = box.bottom;
            b.y2 = width - e.left;
            b.index = i;
            b.x1New = undefined;
            b.x2New = undefined;
          });
          expandBoundsLTR(height, bounds);
          bounds.forEach(function (b) {
            var i = b.index;
            expanded[i].top = b.x1New;
            expanded[i].bottom = b.x2New;
          });
          return expanded;
        }
        function expandBoundsLTR(width, bounds) {
          bounds.sort(function (a, b) {
            return a.x1 - b.x1 || a.index - b.index;
          });
          var fakeBoundary = {
            x1: -Infinity,
            y1: -Infinity,
            x2: 0,
            y2: Infinity,
            index: -1,
            x1New: 0,
            x2New: 0
          };
          var horizon = [{
            start: -Infinity,
            end: Infinity,
            boundary: fakeBoundary
          }];
          bounds.forEach(function (boundary) {
            var i = 0;
            while (i < horizon.length && horizon[i].end <= boundary.y1) {
              i++;
            }
            var j = horizon.length - 1;
            while (j >= 0 && horizon[j].start >= boundary.y2) {
              j--;
            }
            var horizonPart, affectedBoundary;
            var q,
              k,
              maxXNew = -Infinity;
            for (q = i; q <= j; q++) {
              horizonPart = horizon[q];
              affectedBoundary = horizonPart.boundary;
              var xNew;
              if (affectedBoundary.x2 > boundary.x1) {
                xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
              } else if (affectedBoundary.x2New === undefined) {
                xNew = (affectedBoundary.x2 + boundary.x1) / 2;
              } else {
                xNew = affectedBoundary.x2New;
              }
              if (xNew > maxXNew) {
                maxXNew = xNew;
              }
            }
            boundary.x1New = maxXNew;
            for (q = i; q <= j; q++) {
              horizonPart = horizon[q];
              affectedBoundary = horizonPart.boundary;
              if (affectedBoundary.x2New === undefined) {
                if (affectedBoundary.x2 > boundary.x1) {
                  if (affectedBoundary.index > boundary.index) {
                    affectedBoundary.x2New = affectedBoundary.x2;
                  }
                } else {
                  affectedBoundary.x2New = maxXNew;
                }
              } else if (affectedBoundary.x2New > maxXNew) {
                affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
              }
            }
            var changedHorizon = [],
              lastBoundary = null;
            for (q = i; q <= j; q++) {
              horizonPart = horizon[q];
              affectedBoundary = horizonPart.boundary;
              var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
              if (lastBoundary === useBoundary) {
                changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
              } else {
                changedHorizon.push({
                  start: horizonPart.start,
                  end: horizonPart.end,
                  boundary: useBoundary
                });
                lastBoundary = useBoundary;
              }
            }
            if (horizon[i].start < boundary.y1) {
              changedHorizon[0].start = boundary.y1;
              changedHorizon.unshift({
                start: horizon[i].start,
                end: boundary.y1,
                boundary: horizon[i].boundary
              });
            }
            if (boundary.y2 < horizon[j].end) {
              changedHorizon[changedHorizon.length - 1].end = boundary.y2;
              changedHorizon.push({
                start: boundary.y2,
                end: horizon[j].end,
                boundary: horizon[j].boundary
              });
            }
            for (q = i; q <= j; q++) {
              horizonPart = horizon[q];
              affectedBoundary = horizonPart.boundary;
              if (affectedBoundary.x2New !== undefined) {
                continue;
              }
              var used = false;
              for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
                used = horizon[k].boundary === affectedBoundary;
              }
              for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
                used = horizon[k].boundary === affectedBoundary;
              }
              for (k = 0; !used && k < changedHorizon.length; k++) {
                used = changedHorizon[k].boundary === affectedBoundary;
              }
              if (!used) {
                affectedBoundary.x2New = maxXNew;
              }
            }
            Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
          });
          horizon.forEach(function (horizonPart) {
            var affectedBoundary = horizonPart.boundary;
            if (affectedBoundary.x2New === undefined) {
              affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
            }
          });
        }
        function TextLayerRenderTask(_ref) {
          var textContent = _ref.textContent,
            textContentStream = _ref.textContentStream,
            container = _ref.container,
            viewport = _ref.viewport,
            textDivs = _ref.textDivs,
            textContentItemsStr = _ref.textContentItemsStr,
            enhanceTextSelection = _ref.enhanceTextSelection;

          this._textContent = textContent;
          this._textContentStream = textContentStream;
          this._container = container;
          this._viewport = viewport;
          this._textDivs = textDivs || [];
          this._textContentItemsStr = textContentItemsStr || [];
          this._enhanceTextSelection = !!enhanceTextSelection;
          this._reader = null;
          this._layoutTextLastFontSize = null;
          this._layoutTextLastFontFamily = null;
          this._layoutTextCtx = null;
          this._textDivProperties = new WeakMap();
          this._renderingDone = false;
          this._canceled = false;
          this._capability = (0, _util.createPromiseCapability)();
          this._renderTimer = null;
          this._bounds = [];
        }
        TextLayerRenderTask.prototype = {
          get promise() {
            return this._capability.promise;
          },
          cancel: function TextLayer_cancel() {
            if (this._reader) {
              this._reader.cancel(new _util.AbortException("text layer task cancelled"));
              this._reader = null;
            }
            this._canceled = true;
            if (this._renderTimer !== null) {
              clearTimeout(this._renderTimer);
              this._renderTimer = null;
            }
            this._capability.reject("canceled");
          },
          _processItems: function _processItems(items, styleCache) {
            for (var i = 0, len = items.length; i < len; i++) {
              this._textContentItemsStr.push(items[i].str);
              appendText(this, items[i], styleCache);
            }
          },
          _layoutText: function _layoutText(textDiv) {
            var textLayerFrag = this._container;
            var textDivProperties = this._textDivProperties.get(textDiv);
            if (textDivProperties.isWhitespace) {
              return;
            }
            var fontSize = textDiv.style.fontSize;
            var fontFamily = textDiv.style.fontFamily;
            if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
              this._layoutTextCtx.font = fontSize + " " + fontFamily;
              this._lastFontSize = fontSize;
              this._lastFontFamily = fontFamily;
            }
            var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
            var transform = "";
            if (textDivProperties.canvasWidth !== 0 && width > 0) {
              textDivProperties.scale = textDivProperties.canvasWidth / width;
              transform = "scaleX(" + textDivProperties.scale + ")";
            }
            if (textDivProperties.angle !== 0) {
              transform = "rotate(" + textDivProperties.angle + "deg) " + transform;
            }
            if (transform !== "") {
              textDivProperties.originalTransform = transform;
              _dom_utils.CustomStyle.setProp("transform", textDiv, transform);
            }
            this._textDivProperties.set(textDiv, textDivProperties);
            textLayerFrag.appendChild(textDiv);
          },

          _render: function TextLayer_render(timeout) {
            var _this = this;

            var capability = (0, _util.createPromiseCapability)();
            var styleCache = Object.create(null);
            var canvas = document.createElement("canvas");
            canvas.mozOpaque = true;
            this._layoutTextCtx = canvas.getContext("2d", { alpha: false });
            if (this._textContent) {
              var textItems = this._textContent.items;
              var textStyles = this._textContent.styles;
              this._processItems(textItems, textStyles);
              capability.resolve();
            } else if (this._textContentStream) {
              var pump = function pump() {
                _this._reader.read().then(function (_ref2) {
                  var value = _ref2.value,
                    done = _ref2.done;

                  if (done) {
                    capability.resolve();
                    return;
                  }
                  _util.Util.extendObj(styleCache, value.styles);
                  _this._processItems(value.items, styleCache);
                  pump();
                }, capability.reject);
              };
              this._reader = this._textContentStream.getReader();
              pump();
            } else {
              throw new Error("Neither \"textContent\" nor \"textContentStream\"" + " parameters specified.");
            }
            capability.promise.then(function () {
              styleCache = null;
              if (!timeout) {
                render(_this);
              } else {
                _this._renderTimer = setTimeout(function () {
                  render(_this);
                  _this._renderTimer = null;
                }, timeout);
              }
            }, this._capability.reject);
          },
          expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
            if (!this._enhanceTextSelection || !this._renderingDone) {
              return;
            }
            if (this._bounds !== null) {
              expand(this);
              this._bounds = null;
            }
            for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
              var div = this._textDivs[i];
              var divProperties = this._textDivProperties.get(div);
              if (divProperties.isWhitespace) {
                continue;
              }
              if (expandDivs) {
                var transform = "",
                  padding = "";
                if (divProperties.scale !== 1) {
                  transform = "scaleX(" + divProperties.scale + ")";
                }
                if (divProperties.angle !== 0) {
                  transform = "rotate(" + divProperties.angle + "deg) " + transform;
                }
                if (divProperties.paddingLeft !== 0) {
                  padding += " padding-left: " + divProperties.paddingLeft / divProperties.scale + "px;";
                  transform += " translateX(" + -divProperties.paddingLeft / divProperties.scale + "px)";
                }
                if (divProperties.paddingTop !== 0) {
                  padding += " padding-top: " + divProperties.paddingTop + "px;";
                  transform += " translateY(" + -divProperties.paddingTop + "px)";
                }
                if (divProperties.paddingRight !== 0) {
                  padding += " padding-right: " + divProperties.paddingRight / divProperties.scale + "px;";
                }
                if (divProperties.paddingBottom !== 0) {
                  padding += " padding-bottom: " + divProperties.paddingBottom + "px;";
                }
                if (padding !== "") {
                  div.setAttribute("style", divProperties.style + padding);
                }
                if (transform !== "") {
                  _dom_utils.CustomStyle.setProp("transform", div, transform);
                }
              } else {
                div.style.padding = 0;
                _dom_utils.CustomStyle.setProp("transform", div, divProperties.originalTransform || "");
              }
            }
          }
        };
        function renderTextLayer(renderParameters) {
          var task = new TextLayerRenderTask({
            textContent: renderParameters.textContent,
            textContentStream: renderParameters.textContentStream,
            container: renderParameters.container,
            viewport: renderParameters.viewport,
            textDivs: renderParameters.textDivs,
            textContentItemsStr: renderParameters.textContentItemsStr,
            enhanceTextSelection: renderParameters.enhanceTextSelection
          });
          task._render(renderParameters.timeout);
          return task;
        }
        return renderTextLayer;
      }();
      exports.renderTextLayer = renderTextLayer;

      /***/ }),
    /* 74 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SVGGraphics = undefined;

      var _util = __w_pdfjs_require__(0);

      var _dom_utils = __w_pdfjs_require__(13);

      var SVGGraphics = function SVGGraphics() {
        throw new Error("Not implemented: SVGGraphics");
      };
      {
        var SVG_DEFAULTS = {
          fontStyle: "normal",
          fontWeight: "normal",
          fillColor: "#000000"
        };
        var convertImgDataToPng = function convertImgDataToPngClosure() {
          var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
          var CHUNK_WRAPPER_SIZE = 12;
          var crcTable = new Int32Array(256);
          for (var i = 0; i < 256; i++) {
            var c = i;
            for (var h = 0; h < 8; h++) {
              if (c & 1) {
                c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
              } else {
                c = c >> 1 & 0x7fffffff;
              }
            }
            crcTable[i] = c;
          }
          function crc32(data, start, end) {
            var crc = -1;
            for (var i = start; i < end; i++) {
              var a = (crc ^ data[i]) & 0xff;
              var b = crcTable[a];
              crc = crc >>> 8 ^ b;
            }
            return crc ^ -1;
          }
          function writePngChunk(type, body, data, offset) {
            var p = offset;
            var len = body.length;
            data[p] = len >> 24 & 0xff;
            data[p + 1] = len >> 16 & 0xff;
            data[p + 2] = len >> 8 & 0xff;
            data[p + 3] = len & 0xff;
            p += 4;
            data[p] = type.charCodeAt(0) & 0xff;
            data[p + 1] = type.charCodeAt(1) & 0xff;
            data[p + 2] = type.charCodeAt(2) & 0xff;
            data[p + 3] = type.charCodeAt(3) & 0xff;
            p += 4;
            data.set(body, p);
            p += body.length;
            var crc = crc32(data, offset + 4, p);
            data[p] = crc >> 24 & 0xff;
            data[p + 1] = crc >> 16 & 0xff;
            data[p + 2] = crc >> 8 & 0xff;
            data[p + 3] = crc & 0xff;
          }
          function adler32(data, start, end) {
            var a = 1;
            var b = 0;
            for (var i = start; i < end; ++i) {
              a = (a + (data[i] & 0xff)) % 65521;
              b = (b + a) % 65521;
            }
            return b << 16 | a;
          }
          function deflateSync(literals) {
            if (!(0, _util.isNodeJS)()) {
              return deflateSyncUncompressed(literals);
            }
            try {
              var input;
              if (parseInt(process.versions.node) >= 8) {
                input = literals;
              } else {
                input = new Buffer(literals);
              }
              var output = require("zlib").deflateSync(input, { level: 9 });
              return output instanceof Uint8Array ? output : new Uint8Array(output);
            } catch (e) {
              (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
            }
            return deflateSyncUncompressed(literals);
          }
          function deflateSyncUncompressed(literals) {
            var len = literals.length;
            var maxBlockLength = 0xFFFF;
            var deflateBlocks = Math.ceil(len / maxBlockLength);
            var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
            var pi = 0;
            idat[pi++] = 0x78;
            idat[pi++] = 0x9c;
            var pos = 0;
            while (len > maxBlockLength) {
              idat[pi++] = 0x00;
              idat[pi++] = 0xff;
              idat[pi++] = 0xff;
              idat[pi++] = 0x00;
              idat[pi++] = 0x00;
              idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
              pi += maxBlockLength;
              pos += maxBlockLength;
              len -= maxBlockLength;
            }
            idat[pi++] = 0x01;
            idat[pi++] = len & 0xff;
            idat[pi++] = len >> 8 & 0xff;
            idat[pi++] = ~len & 0xffff & 0xff;
            idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
            idat.set(literals.subarray(pos), pi);
            pi += literals.length - pos;
            var adler = adler32(literals, 0, literals.length);
            idat[pi++] = adler >> 24 & 0xff;
            idat[pi++] = adler >> 16 & 0xff;
            idat[pi++] = adler >> 8 & 0xff;
            idat[pi++] = adler & 0xff;
            return idat;
          }
          function encode(imgData, kind, forceDataSchema) {
            var width = imgData.width;
            var height = imgData.height;
            var bitDepth, colorType, lineSize;
            var bytes = imgData.data;
            switch (kind) {
              case _util.ImageKind.GRAYSCALE_1BPP:
                colorType = 0;
                bitDepth = 1;
                lineSize = width + 7 >> 3;
                break;
              case _util.ImageKind.RGB_24BPP:
                colorType = 2;
                bitDepth = 8;
                lineSize = width * 3;
                break;
              case _util.ImageKind.RGBA_32BPP:
                colorType = 6;
                bitDepth = 8;
                lineSize = width * 4;
                break;
              default:
                throw new Error("invalid format");
            }
            var literals = new Uint8Array((1 + lineSize) * height);
            var offsetLiterals = 0,
              offsetBytes = 0;
            var y, i;
            for (y = 0; y < height; ++y) {
              literals[offsetLiterals++] = 0;
              literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
              offsetBytes += lineSize;
              offsetLiterals += lineSize;
            }
            if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
              offsetLiterals = 0;
              for (y = 0; y < height; y++) {
                offsetLiterals++;
                for (i = 0; i < lineSize; i++) {
                  literals[offsetLiterals++] ^= 0xFF;
                }
              }
            }
            var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
            var idat = deflateSync(literals);
            var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
            var data = new Uint8Array(pngLength);
            var offset = 0;
            data.set(PNG_HEADER, offset);
            offset += PNG_HEADER.length;
            writePngChunk("IHDR", ihdr, data, offset);
            offset += CHUNK_WRAPPER_SIZE + ihdr.length;
            writePngChunk("IDATA", idat, data, offset);
            offset += CHUNK_WRAPPER_SIZE + idat.length;
            writePngChunk("IEND", new Uint8Array(0), data, offset);
            return (0, _util.createObjectURL)(data, "image/png", forceDataSchema);
          }
          return function convertImgDataToPng(imgData, forceDataSchema) {
            var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
            return encode(imgData, kind, forceDataSchema);
          };
        }();
        var SVGExtraState = function SVGExtraStateClosure() {
          function SVGExtraState() {
            this.fontSizeScale = 1;
            this.fontWeight = SVG_DEFAULTS.fontWeight;
            this.fontSize = 0;
            this.textMatrix = _util.IDENTITY_MATRIX;
            this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
            this.leading = 0;
            this.x = 0;
            this.y = 0;
            this.lineX = 0;
            this.lineY = 0;
            this.charSpacing = 0;
            this.wordSpacing = 0;
            this.textHScale = 1;
            this.textRise = 0;
            this.fillColor = SVG_DEFAULTS.fillColor;
            this.strokeColor = "#000000";
            this.fillAlpha = 1;
            this.strokeAlpha = 1;
            this.lineWidth = 1;
            this.lineJoin = "";
            this.lineCap = "";
            this.miterLimit = 0;
            this.dashArray = [];
            this.dashPhase = 0;
            this.dependencies = [];
            this.activeClipUrl = null;
            this.clipGroup = null;
            this.maskId = "";
          }
          SVGExtraState.prototype = {
            clone: function SVGExtraState_clone() {
              return Object.create(this);
            },
            setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
              this.x = x;
              this.y = y;
            }
          };
          return SVGExtraState;
        }();
        exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
          function opListToTree(opList) {
            var opTree = [];
            var tmp = [];
            var opListLen = opList.length;
            for (var x = 0; x < opListLen; x++) {
              if (opList[x].fn === "save") {
                opTree.push({
                  "fnId": 92,
                  "fn": "group",
                  "items": []
                });
                tmp.push(opTree);
                opTree = opTree[opTree.length - 1].items;
                continue;
              }
              if (opList[x].fn === "restore") {
                opTree = tmp.pop();
              } else {
                opTree.push(opList[x]);
              }
            }
            return opTree;
          }
          function pf(value) {
            if (Number.isInteger(value)) {
              return value.toString();
            }
            var s = value.toFixed(10);
            var i = s.length - 1;
            if (s[i] !== "0") {
              return s;
            }
            do {
              i--;
            } while (s[i] === "0");
            return s.substr(0, s[i] === "." ? i : i + 1);
          }
          function pm(m) {
            if (m[4] === 0 && m[5] === 0) {
              if (m[1] === 0 && m[2] === 0) {
                if (m[0] === 1 && m[3] === 1) {
                  return "";
                }
                return "scale(" + pf(m[0]) + " " + pf(m[3]) + ")";
              }
              if (m[0] === m[3] && m[1] === -m[2]) {
                var a = Math.acos(m[0]) * 180 / Math.PI;
                return "rotate(" + pf(a) + ")";
              }
            } else {
              if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
                return "translate(" + pf(m[4]) + " " + pf(m[5]) + ")";
              }
            }
            return "matrix(" + pf(m[0]) + " " + pf(m[1]) + " " + pf(m[2]) + " " + pf(m[3]) + " " + pf(m[4]) + " " + pf(m[5]) + ")";
          }
          function SVGGraphics(commonObjs, objs, forceDataSchema) {
            this.svgFactory = new _dom_utils.DOMSVGFactory();
            this.current = new SVGExtraState();
            this.transformMatrix = _util.IDENTITY_MATRIX;
            this.transformStack = [];
            this.extraStack = [];
            this.commonObjs = commonObjs;
            this.objs = objs;
            this.pendingClip = null;
            this.pendingEOFill = false;
            this.embedFonts = false;
            this.embeddedFonts = Object.create(null);
            this.cssStyle = null;
            this.forceDataSchema = !!forceDataSchema;
          }
          var XML_NS = "http://www.w3.org/XML/1998/namespace";
          var XLINK_NS = "http://www.w3.org/1999/xlink";
          var LINE_CAP_STYLES = ["butt", "round", "square"];
          var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
          var clipCount = 0;
          var maskCount = 0;
          SVGGraphics.prototype = {
            save: function SVGGraphics_save() {
              this.transformStack.push(this.transformMatrix);
              var old = this.current;
              this.extraStack.push(old);
              this.current = old.clone();
            },
            restore: function SVGGraphics_restore() {
              this.transformMatrix = this.transformStack.pop();
              this.current = this.extraStack.pop();
              this.pendingClip = null;
              this.tgrp = null;
            },
            group: function SVGGraphics_group(items) {
              this.save();
              this.executeOpTree(items);
              this.restore();
            },
            loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
              var _this = this;

              var fnArray = operatorList.fnArray;
              var fnArrayLen = fnArray.length;
              var argsArray = operatorList.argsArray;
              for (var i = 0; i < fnArrayLen; i++) {
                if (_util.OPS.dependency === fnArray[i]) {
                  var deps = argsArray[i];
                  for (var n = 0, nn = deps.length; n < nn; n++) {
                    var obj = deps[n];
                    var common = obj.substring(0, 2) === "g_";
                    var promise;
                    if (common) {
                      promise = new Promise(function (resolve) {
                        _this.commonObjs.get(obj, resolve);
                      });
                    } else {
                      promise = new Promise(function (resolve) {
                        _this.objs.get(obj, resolve);
                      });
                    }
                    this.current.dependencies.push(promise);
                  }
                }
              }
              return Promise.all(this.current.dependencies);
            },
            transform: function SVGGraphics_transform(a, b, c, d, e, f) {
              var transformMatrix = [a, b, c, d, e, f];
              this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
              this.tgrp = null;
            },
            getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
              var _this2 = this;

              this.viewport = viewport;
              var svgElement = this._initialize(viewport);
              return this.loadDependencies(operatorList).then(function () {
                _this2.transformMatrix = _util.IDENTITY_MATRIX;
                var opTree = _this2.convertOpList(operatorList);
                _this2.executeOpTree(opTree);
                return svgElement;
              });
            },
            convertOpList: function SVGGraphics_convertOpList(operatorList) {
              var argsArray = operatorList.argsArray;
              var fnArray = operatorList.fnArray;
              var fnArrayLen = fnArray.length;
              var REVOPS = [];
              var opList = [];
              for (var op in _util.OPS) {
                REVOPS[_util.OPS[op]] = op;
              }
              for (var x = 0; x < fnArrayLen; x++) {
                var fnId = fnArray[x];
                opList.push({
                  "fnId": fnId,
                  "fn": REVOPS[fnId],
                  "args": argsArray[x]
                });
              }
              return opListToTree(opList);
            },
            executeOpTree: function SVGGraphics_executeOpTree(opTree) {
              var opTreeLen = opTree.length;
              for (var x = 0; x < opTreeLen; x++) {
                var fn = opTree[x].fn;
                var fnId = opTree[x].fnId;
                var args = opTree[x].args;
                switch (fnId | 0) {
                  case _util.OPS.beginText:
                    this.beginText();
                    break;
                  case _util.OPS.setLeading:
                    this.setLeading(args);
                    break;
                  case _util.OPS.setLeadingMoveText:
                    this.setLeadingMoveText(args[0], args[1]);
                    break;
                  case _util.OPS.setFont:
                    this.setFont(args);
                    break;
                  case _util.OPS.showText:
                    this.showText(args[0]);
                    break;
                  case _util.OPS.showSpacedText:
                    this.showText(args[0]);
                    break;
                  case _util.OPS.endText:
                    this.endText();
                    break;
                  case _util.OPS.moveText:
                    this.moveText(args[0], args[1]);
                    break;
                  case _util.OPS.setCharSpacing:
                    this.setCharSpacing(args[0]);
                    break;
                  case _util.OPS.setWordSpacing:
                    this.setWordSpacing(args[0]);
                    break;
                  case _util.OPS.setHScale:
                    this.setHScale(args[0]);
                    break;
                  case _util.OPS.setTextMatrix:
                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                    break;
                  case _util.OPS.setTextRise:
                    this.setTextRise(args[0]);
                    break;
                  case _util.OPS.setLineWidth:
                    this.setLineWidth(args[0]);
                    break;
                  case _util.OPS.setLineJoin:
                    this.setLineJoin(args[0]);
                    break;
                  case _util.OPS.setLineCap:
                    this.setLineCap(args[0]);
                    break;
                  case _util.OPS.setMiterLimit:
                    this.setMiterLimit(args[0]);
                    break;
                  case _util.OPS.setFillRGBColor:
                    this.setFillRGBColor(args[0], args[1], args[2]);
                    break;
                  case _util.OPS.setStrokeRGBColor:
                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                    break;
                  case _util.OPS.setDash:
                    this.setDash(args[0], args[1]);
                    break;
                  case _util.OPS.setGState:
                    this.setGState(args[0]);
                    break;
                  case _util.OPS.fill:
                    this.fill();
                    break;
                  case _util.OPS.eoFill:
                    this.eoFill();
                    break;
                  case _util.OPS.stroke:
                    this.stroke();
                    break;
                  case _util.OPS.fillStroke:
                    this.fillStroke();
                    break;
                  case _util.OPS.eoFillStroke:
                    this.eoFillStroke();
                    break;
                  case _util.OPS.clip:
                    this.clip("nonzero");
                    break;
                  case _util.OPS.eoClip:
                    this.clip("evenodd");
                    break;
                  case _util.OPS.paintSolidColorImageMask:
                    this.paintSolidColorImageMask();
                    break;
                  case _util.OPS.paintJpegXObject:
                    this.paintJpegXObject(args[0], args[1], args[2]);
                    break;
                  case _util.OPS.paintImageXObject:
                    this.paintImageXObject(args[0]);
                    break;
                  case _util.OPS.paintInlineImageXObject:
                    this.paintInlineImageXObject(args[0]);
                    break;
                  case _util.OPS.paintImageMaskXObject:
                    this.paintImageMaskXObject(args[0]);
                    break;
                  case _util.OPS.paintFormXObjectBegin:
                    this.paintFormXObjectBegin(args[0], args[1]);
                    break;
                  case _util.OPS.paintFormXObjectEnd:
                    this.paintFormXObjectEnd();
                    break;
                  case _util.OPS.closePath:
                    this.closePath();
                    break;
                  case _util.OPS.closeStroke:
                    this.closeStroke();
                    break;
                  case _util.OPS.closeFillStroke:
                    this.closeFillStroke();
                    break;
                  case _util.OPS.nextLine:
                    this.nextLine();
                    break;
                  case _util.OPS.transform:
                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                    break;
                  case _util.OPS.constructPath:
                    this.constructPath(args[0], args[1]);
                    break;
                  case _util.OPS.endPath:
                    this.endPath();
                    break;
                  case 92:
                    this.group(opTree[x].items);
                    break;
                  default:
                    (0, _util.warn)("Unimplemented operator " + fn);
                    break;
                }
              }
            },
            setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
              this.current.wordSpacing = wordSpacing;
            },
            setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
              this.current.charSpacing = charSpacing;
            },
            nextLine: function SVGGraphics_nextLine() {
              this.moveText(0, this.current.leading);
            },
            setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
              var current = this.current;
              this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
              this.current.x = this.current.lineX = 0;
              this.current.y = this.current.lineY = 0;
              current.xcoords = [];
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
              current.tspan.setAttributeNS(null, "font-size", pf(current.fontSize) + "px");
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
              current.txtElement = this.svgFactory.createElement("svg:text");
              current.txtElement.appendChild(current.tspan);
            },
            beginText: function SVGGraphics_beginText() {
              this.current.x = this.current.lineX = 0;
              this.current.y = this.current.lineY = 0;
              this.current.textMatrix = _util.IDENTITY_MATRIX;
              this.current.lineMatrix = _util.IDENTITY_MATRIX;
              this.current.tspan = this.svgFactory.createElement("svg:tspan");
              this.current.txtElement = this.svgFactory.createElement("svg:text");
              this.current.txtgrp = this.svgFactory.createElement("svg:g");
              this.current.xcoords = [];
            },
            moveText: function SVGGraphics_moveText(x, y) {
              var current = this.current;
              this.current.x = this.current.lineX += x;
              this.current.y = this.current.lineY += y;
              current.xcoords = [];
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
              current.tspan.setAttributeNS(null, "font-size", pf(current.fontSize) + "px");
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
            },
            showText: function SVGGraphics_showText(glyphs) {
              var current = this.current;
              var font = current.font;
              var fontSize = current.fontSize;
              if (fontSize === 0) {
                return;
              }
              var charSpacing = current.charSpacing;
              var wordSpacing = current.wordSpacing;
              var fontDirection = current.fontDirection;
              var textHScale = current.textHScale * fontDirection;
              var glyphsLength = glyphs.length;
              var vertical = font.vertical;
              var widthAdvanceScale = fontSize * current.fontMatrix[0];
              var x = 0,
                i;
              for (i = 0; i < glyphsLength; ++i) {
                var glyph = glyphs[i];
                if (glyph === null) {
                  x += fontDirection * wordSpacing;
                  continue;
                } else if ((0, _util.isNum)(glyph)) {
                  x += -glyph * fontSize * 0.001;
                  continue;
                }
                var width = glyph.width;
                var character = glyph.fontChar;
                var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                var charWidth = width * widthAdvanceScale + spacing * fontDirection;
                if (!glyph.isInFont && !font.missingFile) {
                  x += charWidth;
                  continue;
                }
                current.xcoords.push(current.x + x * textHScale);
                current.tspan.textContent += character;
                x += charWidth;
              }
              if (vertical) {
                current.y -= x * textHScale;
              } else {
                current.x += x * textHScale;
              }
              current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
              current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
              current.tspan.setAttributeNS(null, "font-size", pf(current.fontSize) + "px");
              if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
                current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
              }
              if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
                current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
              }
              if (current.fillColor !== SVG_DEFAULTS.fillColor) {
                current.tspan.setAttributeNS(null, "fill", current.fillColor);
              }
              var textMatrix = current.textMatrix;
              if (current.textRise !== 0) {
                textMatrix = textMatrix.slice();
                textMatrix[5] += current.textRise;
              }
              current.txtElement.setAttributeNS(null, "transform", pm(textMatrix) + " scale(1, -1)");
              current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
              current.txtElement.appendChild(current.tspan);
              current.txtgrp.appendChild(current.txtElement);
              this._ensureTransformGroup().appendChild(current.txtElement);
            },
            setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
              this.setLeading(-y);
              this.moveText(x, y);
            },
            addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
              if (!this.cssStyle) {
                this.cssStyle = this.svgFactory.createElement("svg:style");
                this.cssStyle.setAttributeNS(null, "type", "text/css");
                this.defs.appendChild(this.cssStyle);
              }
              var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
              this.cssStyle.textContent += "@font-face { font-family: \"" + fontObj.loadedName + "\";" + " src: url(" + url + "); }\n";
            },
            setFont: function SVGGraphics_setFont(details) {
              var current = this.current;
              var fontObj = this.commonObjs.get(details[0]);
              var size = details[1];
              this.current.font = fontObj;
              if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
                this.addFontStyle(fontObj);
                this.embeddedFonts[fontObj.loadedName] = fontObj;
              }
              current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
              var bold = fontObj.black ? fontObj.bold ? "bolder" : "bold" : fontObj.bold ? "bold" : "normal";
              var italic = fontObj.italic ? "italic" : "normal";
              if (size < 0) {
                size = -size;
                current.fontDirection = -1;
              } else {
                current.fontDirection = 1;
              }
              current.fontSize = size;
              current.fontFamily = fontObj.loadedName;
              current.fontWeight = bold;
              current.fontStyle = italic;
              current.tspan = this.svgFactory.createElement("svg:tspan");
              current.tspan.setAttributeNS(null, "y", pf(-current.y));
              current.xcoords = [];
            },
            endText: function SVGGraphics_endText() {},
            setLineWidth: function SVGGraphics_setLineWidth(width) {
              this.current.lineWidth = width;
            },
            setLineCap: function SVGGraphics_setLineCap(style) {
              this.current.lineCap = LINE_CAP_STYLES[style];
            },
            setLineJoin: function SVGGraphics_setLineJoin(style) {
              this.current.lineJoin = LINE_JOIN_STYLES[style];
            },
            setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
              this.current.miterLimit = limit;
            },
            setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
              this.current.strokeAlpha = strokeAlpha;
            },
            setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
              var color = _util.Util.makeCssRgb(r, g, b);
              this.current.strokeColor = color;
            },
            setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
              this.current.fillAlpha = fillAlpha;
            },
            setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
              var color = _util.Util.makeCssRgb(r, g, b);
              this.current.fillColor = color;
              this.current.tspan = this.svgFactory.createElement("svg:tspan");
              this.current.xcoords = [];
            },
            setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
              this.current.dashArray = dashArray;
              this.current.dashPhase = dashPhase;
            },
            constructPath: function SVGGraphics_constructPath(ops, args) {
              var current = this.current;
              var x = current.x,
                y = current.y;
              current.path = this.svgFactory.createElement("svg:path");
              var d = [];
              var opLength = ops.length;
              for (var i = 0, j = 0; i < opLength; i++) {
                switch (ops[i] | 0) {
                  case _util.OPS.rectangle:
                    x = args[j++];
                    y = args[j++];
                    var width = args[j++];
                    var height = args[j++];
                    var xw = x + width;
                    var yh = y + height;
                    d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                    break;
                  case _util.OPS.moveTo:
                    x = args[j++];
                    y = args[j++];
                    d.push("M", pf(x), pf(y));
                    break;
                  case _util.OPS.lineTo:
                    x = args[j++];
                    y = args[j++];
                    d.push("L", pf(x), pf(y));
                    break;
                  case _util.OPS.curveTo:
                    x = args[j + 4];
                    y = args[j + 5];
                    d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                    j += 6;
                    break;
                  case _util.OPS.curveTo2:
                    x = args[j + 2];
                    y = args[j + 3];
                    d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                    j += 4;
                    break;
                  case _util.OPS.curveTo3:
                    x = args[j + 2];
                    y = args[j + 3];
                    d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                    j += 4;
                    break;
                  case _util.OPS.closePath:
                    d.push("Z");
                    break;
                }
              }
              current.path.setAttributeNS(null, "d", d.join(" "));
              current.path.setAttributeNS(null, "fill", "none");
              this._ensureTransformGroup().appendChild(current.path);
              current.element = current.path;
              current.setCurrentPoint(x, y);
            },
            endPath: function SVGGraphics_endPath() {
              if (!this.pendingClip) {
                return;
              }
              var current = this.current;
              var clipId = "clippath" + clipCount;
              clipCount++;
              var clipPath = this.svgFactory.createElement("svg:clipPath");
              clipPath.setAttributeNS(null, "id", clipId);
              clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
              var clipElement = current.element.cloneNode();
              if (this.pendingClip === "evenodd") {
                clipElement.setAttributeNS(null, "clip-rule", "evenodd");
              } else {
                clipElement.setAttributeNS(null, "clip-rule", "nonzero");
              }
              this.pendingClip = null;
              clipPath.appendChild(clipElement);
              this.defs.appendChild(clipPath);
              if (current.activeClipUrl) {
                current.clipGroup = null;
                this.extraStack.forEach(function (prev) {
                  prev.clipGroup = null;
                });
              }
              current.activeClipUrl = "url(#" + clipId + ")";
              this.tgrp = null;
            },
            clip: function SVGGraphics_clip(type) {
              this.pendingClip = type;
            },
            closePath: function SVGGraphics_closePath() {
              var current = this.current;
              var d = current.path.getAttributeNS(null, "d");
              d += "Z";
              current.path.setAttributeNS(null, "d", d);
            },
            setLeading: function SVGGraphics_setLeading(leading) {
              this.current.leading = -leading;
            },
            setTextRise: function SVGGraphics_setTextRise(textRise) {
              this.current.textRise = textRise;
            },
            setHScale: function SVGGraphics_setHScale(scale) {
              this.current.textHScale = scale / 100;
            },
            setGState: function SVGGraphics_setGState(states) {
              for (var i = 0, ii = states.length; i < ii; i++) {
                var state = states[i];
                var key = state[0];
                var value = state[1];
                switch (key) {
                  case "LW":
                    this.setLineWidth(value);
                    break;
                  case "LC":
                    this.setLineCap(value);
                    break;
                  case "LJ":
                    this.setLineJoin(value);
                    break;
                  case "ML":
                    this.setMiterLimit(value);
                    break;
                  case "D":
                    this.setDash(value[0], value[1]);
                    break;
                  case "Font":
                    this.setFont(value);
                    break;
                  case "CA":
                    this.setStrokeAlpha(value);
                    break;
                  case "ca":
                    this.setFillAlpha(value);
                    break;
                  default:
                    (0, _util.warn)("Unimplemented graphic state " + key);
                    break;
                }
              }
            },
            fill: function SVGGraphics_fill() {
              var current = this.current;
              current.element.setAttributeNS(null, "fill", current.fillColor);
              current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
            },
            stroke: function SVGGraphics_stroke() {
              var current = this.current;
              current.element.setAttributeNS(null, "stroke", current.strokeColor);
              current.element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
              current.element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
              current.element.setAttributeNS(null, "stroke-linecap", current.lineCap);
              current.element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
              current.element.setAttributeNS(null, "stroke-width", pf(current.lineWidth) + "px");
              current.element.setAttributeNS(null, "stroke-dasharray", current.dashArray.map(pf).join(" "));
              current.element.setAttributeNS(null, "stroke-dashoffset", pf(current.dashPhase) + "px");
              current.element.setAttributeNS(null, "fill", "none");
            },
            eoFill: function SVGGraphics_eoFill() {
              this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
              this.fill();
            },
            fillStroke: function SVGGraphics_fillStroke() {
              this.stroke();
              this.fill();
            },
            eoFillStroke: function SVGGraphics_eoFillStroke() {
              this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
              this.fillStroke();
            },
            closeStroke: function SVGGraphics_closeStroke() {
              this.closePath();
              this.stroke();
            },
            closeFillStroke: function SVGGraphics_closeFillStroke() {
              this.closePath();
              this.fillStroke();
            },
            paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
              var current = this.current;
              var rect = this.svgFactory.createElement("svg:rect");
              rect.setAttributeNS(null, "x", "0");
              rect.setAttributeNS(null, "y", "0");
              rect.setAttributeNS(null, "width", "1px");
              rect.setAttributeNS(null, "height", "1px");
              rect.setAttributeNS(null, "fill", current.fillColor);
              this._ensureTransformGroup().appendChild(rect);
            },
            paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
              var imgObj = this.objs.get(objId);
              var imgEl = this.svgFactory.createElement("svg:image");
              imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgObj.src);
              imgEl.setAttributeNS(null, "width", pf(w));
              imgEl.setAttributeNS(null, "height", pf(h));
              imgEl.setAttributeNS(null, "x", "0");
              imgEl.setAttributeNS(null, "y", pf(-h));
              imgEl.setAttributeNS(null, "transform", "scale(" + pf(1 / w) + " " + pf(-1 / h) + ")");
              this._ensureTransformGroup().appendChild(imgEl);
            },
            paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
              var imgData = this.objs.get(objId);
              if (!imgData) {
                (0, _util.warn)("Dependent image isn't ready yet");
                return;
              }
              this.paintInlineImageXObject(imgData);
            },
            paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
              var width = imgData.width;
              var height = imgData.height;
              var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
              var cliprect = this.svgFactory.createElement("svg:rect");
              cliprect.setAttributeNS(null, "x", "0");
              cliprect.setAttributeNS(null, "y", "0");
              cliprect.setAttributeNS(null, "width", pf(width));
              cliprect.setAttributeNS(null, "height", pf(height));
              this.current.element = cliprect;
              this.clip("nonzero");
              var imgEl = this.svgFactory.createElement("svg:image");
              imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
              imgEl.setAttributeNS(null, "x", "0");
              imgEl.setAttributeNS(null, "y", pf(-height));
              imgEl.setAttributeNS(null, "width", pf(width) + "px");
              imgEl.setAttributeNS(null, "height", pf(height) + "px");
              imgEl.setAttributeNS(null, "transform", "scale(" + pf(1 / width) + " " + pf(-1 / height) + ")");
              if (mask) {
                mask.appendChild(imgEl);
              } else {
                this._ensureTransformGroup().appendChild(imgEl);
              }
            },
            paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
              var current = this.current;
              var width = imgData.width;
              var height = imgData.height;
              var fillColor = current.fillColor;
              current.maskId = "mask" + maskCount++;
              var mask = this.svgFactory.createElement("svg:mask");
              mask.setAttributeNS(null, "id", current.maskId);
              var rect = this.svgFactory.createElement("svg:rect");
              rect.setAttributeNS(null, "x", "0");
              rect.setAttributeNS(null, "y", "0");
              rect.setAttributeNS(null, "width", pf(width));
              rect.setAttributeNS(null, "height", pf(height));
              rect.setAttributeNS(null, "fill", fillColor);
              rect.setAttributeNS(null, "mask", "url(#" + current.maskId + ")");
              this.defs.appendChild(mask);
              this._ensureTransformGroup().appendChild(rect);
              this.paintInlineImageXObject(imgData, mask);
            },
            paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
              if (Array.isArray(matrix) && matrix.length === 6) {
                this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
              }
              if (Array.isArray(bbox) && bbox.length === 4) {
                var width = bbox[2] - bbox[0];
                var height = bbox[3] - bbox[1];
                var cliprect = this.svgFactory.createElement("svg:rect");
                cliprect.setAttributeNS(null, "x", bbox[0]);
                cliprect.setAttributeNS(null, "y", bbox[1]);
                cliprect.setAttributeNS(null, "width", pf(width));
                cliprect.setAttributeNS(null, "height", pf(height));
                this.current.element = cliprect;
                this.clip("nonzero");
                this.endPath();
              }
            },
            paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
            _initialize: function _initialize(viewport) {
              var svg = this.svgFactory.create(viewport.width, viewport.height);
              var definitions = this.svgFactory.createElement("svg:defs");
              svg.appendChild(definitions);
              this.defs = definitions;
              var rootGroup = this.svgFactory.createElement("svg:g");
              rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
              svg.appendChild(rootGroup);
              this.svg = rootGroup;
              return svg;
            },

            _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
              if (!this.current.clipGroup) {
                var clipGroup = this.svgFactory.createElement("svg:g");
                clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                this.svg.appendChild(clipGroup);
                this.current.clipGroup = clipGroup;
              }
              return this.current.clipGroup;
            },
            _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
              if (!this.tgrp) {
                this.tgrp = this.svgFactory.createElement("svg:g");
                this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                if (this.current.activeClipUrl) {
                  this._ensureClipGroup().appendChild(this.tgrp);
                } else {
                  this.svg.appendChild(this.tgrp);
                }
              }
              return this.tgrp;
            }
          };
          return SVGGraphics;
        }();
      }
      exports.SVGGraphics = SVGGraphics;

      /***/ }),
    /* 75 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var pdfjsVersion = "1.10.97";
      var pdfjsBuild = "7d0fce73";
      var pdfjsSharedUtil = __w_pdfjs_require__(0);
      var pdfjsDisplayGlobal = __w_pdfjs_require__(117);
      var pdfjsDisplayAPI = __w_pdfjs_require__(69);
      var pdfjsDisplayTextLayer = __w_pdfjs_require__(73);
      var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(72);
      var pdfjsDisplayDOMUtils = __w_pdfjs_require__(13);
      var pdfjsDisplaySVG = __w_pdfjs_require__(74);
      {
        if (pdfjsSharedUtil.isNodeJS()) {
          var PDFNodeStream = __w_pdfjs_require__(122).PDFNodeStream;
          pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFNodeStream);
        } else if (typeof Response !== "undefined" && "body" in Response.prototype && typeof ReadableStream !== "undefined") {
          var PDFFetchStream = __w_pdfjs_require__(123).PDFFetchStream;
          pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFFetchStream);
        } else {
          var PDFNetworkStream = __w_pdfjs_require__(124).PDFNetworkStream;
          pdfjsDisplayAPI.setPDFNetworkStreamClass(PDFNetworkStream);
        }
      }
      exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
      exports.build = pdfjsDisplayAPI.build;
      exports.version = pdfjsDisplayAPI.version;
      exports.getDocument = pdfjsDisplayAPI.getDocument;
      exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
      exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
      exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
      exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
      exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
      exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
      exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
      exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
      exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
      exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
      exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
      exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
      exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
      exports.OPS = pdfjsSharedUtil.OPS;
      exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
      exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
      exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
      exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
      exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
      exports.shadow = pdfjsSharedUtil.shadow;
      exports.createBlob = pdfjsSharedUtil.createBlob;
      exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
      exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
      exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
      exports.StatTimer = pdfjsSharedUtil.StatTimer;

      /***/ }),
    /* 76 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      if (typeof PDFJS === "undefined" || !PDFJS.compatibilityChecked) {
        var globalScope = __w_pdfjs_require__(20);
        var userAgent = typeof navigator !== "undefined" && navigator.userAgent || "";
        var isAndroid = /Android/.test(userAgent);
        var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
        var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
        var isChrome = userAgent.indexOf("Chrom") >= 0;
        var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
        var isIOSChrome = userAgent.indexOf("CriOS") >= 0;
        var isIE = userAgent.indexOf("Trident") >= 0;
        var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
        var isOpera = userAgent.indexOf("Opera") >= 0;
        var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
        var hasDOM = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === "object";
        if (typeof PDFJS === "undefined") {
          globalScope.PDFJS = {};
        }
        PDFJS.compatibilityChecked = true;
        (function checkTypedArrayCompatibility() {
          if (typeof Uint8ClampedArray === "undefined") {
            globalScope.Uint8ClampedArray = __w_pdfjs_require__(77);
          }
          if (typeof Uint8Array !== "undefined") {
            if (typeof Uint8Array.prototype.subarray === "undefined") {
              Uint8Array.prototype.subarray = function subarray(start, end) {
                return new Uint8Array(this.slice(start, end));
              };
              Float32Array.prototype.subarray = function subarray(start, end) {
                return new Float32Array(this.slice(start, end));
              };
            }
            if (typeof Float64Array === "undefined") {
              globalScope.Float64Array = Float32Array;
            }
            return;
          }
          function subarray(start, end) {
            return new TypedArray(this.slice(start, end));
          }
          function setArrayOffset(array, offset) {
            if (arguments.length < 2) {
              offset = 0;
            }
            for (var i = 0, n = array.length; i < n; ++i, ++offset) {
              this[offset] = array[i] & 0xFF;
            }
          }
          function Uint32ArrayView(buffer, length) {
            this.buffer = buffer;
            this.byteLength = buffer.length;
            this.length = length;
            ensureUint32ArrayViewProps(this.length);
          }
          Uint32ArrayView.prototype = Object.create(null);
          var uint32ArrayViewSetters = 0;
          function createUint32ArrayProp(index) {
            return {
              get: function get() {
                var buffer = this.buffer,
                  offset = index << 2;
                return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
              },
              set: function set(value) {
                var buffer = this.buffer,
                  offset = index << 2;
                buffer[offset] = value & 255;
                buffer[offset + 1] = value >> 8 & 255;
                buffer[offset + 2] = value >> 16 & 255;
                buffer[offset + 3] = value >>> 24 & 255;
              }
            };
          }
          function ensureUint32ArrayViewProps(length) {
            while (uint32ArrayViewSetters < length) {
              Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
              uint32ArrayViewSetters++;
            }
          }
          function TypedArray(arg1) {
            var result, i, n;
            if (typeof arg1 === "number") {
              result = [];
              for (i = 0; i < arg1; ++i) {
                result[i] = 0;
              }
            } else if ("slice" in arg1) {
              result = arg1.slice(0);
            } else {
              result = [];
              for (i = 0, n = arg1.length; i < n; ++i) {
                result[i] = arg1[i];
              }
            }
            result.subarray = subarray;
            result.buffer = result;
            result.byteLength = result.length;
            result.set = setArrayOffset;
            if ((typeof arg1 === "undefined" ? "undefined" : _typeof(arg1)) === "object" && arg1.buffer) {
              result.buffer = arg1.buffer;
            }
            return result;
          }
          globalScope.Uint8Array = TypedArray;
          globalScope.Int8Array = TypedArray;
          globalScope.Int32Array = TypedArray;
          globalScope.Uint16Array = TypedArray;
          globalScope.Float32Array = TypedArray;
          globalScope.Float64Array = TypedArray;
          globalScope.Uint32Array = function () {
            if (arguments.length === 3) {
              if (arguments[1] !== 0) {
                throw new Error("offset !== 0 is not supported");
              }
              return new Uint32ArrayView(arguments[0], arguments[2]);
            }
            return TypedArray.apply(this, arguments);
          };
        })();
        (function canvasPixelArrayBuffer() {
          if (!hasDOM || !window.CanvasPixelArray) {
            return;
          }
          var cpaProto = window.CanvasPixelArray.prototype;
          if ("buffer" in cpaProto) {
            return;
          }
          Object.defineProperty(cpaProto, "buffer", {
            get: function get() {
              return this;
            },

            enumerable: false,
            configurable: true
          });
          Object.defineProperty(cpaProto, "byteLength", {
            get: function get() {
              return this.length;
            },

            enumerable: false,
            configurable: true
          });
        })();
        (function normalizeURLObject() {
          if (!globalScope.URL) {
            globalScope.URL = globalScope.webkitURL;
          }
        })();
        (function checkObjectDefinePropertyCompatibility() {
          if (typeof Object.defineProperty !== "undefined") {
            var definePropertyPossible = true;
            try {
              if (hasDOM) {
                Object.defineProperty(new Image(), "id", { value: "test" });
              }
              var Test = function Test() {};
              Test.prototype = {
                get id() {}
              };
              Object.defineProperty(new Test(), "id", {
                value: "",
                configurable: true,
                enumerable: true,
                writable: false
              });
            } catch (e) {
              definePropertyPossible = false;
            }
            if (definePropertyPossible) {
              return;
            }
          }
          Object.defineProperty = function objectDefineProperty(obj, name, def) {
            delete obj[name];
            if ("get" in def) {
              obj.__defineGetter__(name, def["get"]);
            }
            if ("set" in def) {
              obj.__defineSetter__(name, def["set"]);
            }
            if ("value" in def) {
              obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
                this.__defineGetter__(name, function objectDefinePropertyGetter() {
                  return value;
                });
                return value;
              });
              obj[name] = def.value;
            }
          };
        })();
        (function checkXMLHttpRequestResponseCompatibility() {
          if (typeof XMLHttpRequest === "undefined") {
            return;
          }
          var xhrPrototype = XMLHttpRequest.prototype;
          var xhr = new XMLHttpRequest();
          if (!("overrideMimeType" in xhr)) {
            Object.defineProperty(xhrPrototype, "overrideMimeType", {
              value: function xmlHttpRequestOverrideMimeType(mimeType) {}
            });
          }
          if ("responseType" in xhr) {
            return;
          }
          Object.defineProperty(xhrPrototype, "responseType", {
            get: function xmlHttpRequestGetResponseType() {
              return this._responseType || "text";
            },
            set: function xmlHttpRequestSetResponseType(value) {
              if (value === "text" || value === "arraybuffer") {
                this._responseType = value;
                if (value === "arraybuffer" && typeof this.overrideMimeType === "function") {
                  this.overrideMimeType("text/plain; charset=x-user-defined");
                }
              }
            }
          });
          if (typeof VBArray !== "undefined") {
            Object.defineProperty(xhrPrototype, "response", {
              get: function xmlHttpRequestResponseGet() {
                if (this.responseType === "arraybuffer") {
                  return new Uint8Array(new VBArray(this.responseBody).toArray());
                }
                return this.responseText;
              }
            });
            return;
          }
          Object.defineProperty(xhrPrototype, "response", {
            get: function xmlHttpRequestResponseGet() {
              if (this.responseType !== "arraybuffer") {
                return this.responseText;
              }
              var text = this.responseText;
              var i,
                n = text.length;
              var result = new Uint8Array(n);
              for (i = 0; i < n; ++i) {
                result[i] = text.charCodeAt(i) & 0xFF;
              }
              return result.buffer;
            }
          });
        })();
        (function checkWindowBtoaCompatibility() {
          if ("btoa" in globalScope) {
            return;
          }
          var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          globalScope.btoa = function (chars) {
            var buffer = "";
            var i, n;
            for (i = 0, n = chars.length; i < n; i += 3) {
              var b1 = chars.charCodeAt(i) & 0xFF;
              var b2 = chars.charCodeAt(i + 1) & 0xFF;
              var b3 = chars.charCodeAt(i + 2) & 0xFF;
              var d1 = b1 >> 2,
                d2 = (b1 & 3) << 4 | b2 >> 4;
              var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
              var d4 = i + 2 < n ? b3 & 0x3F : 64;
              buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
            }
            return buffer;
          };
        })();
        (function checkWindowAtobCompatibility() {
          if ("atob" in globalScope) {
            return;
          }
          var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          globalScope.atob = function (input) {
            input = input.replace(/=+$/, "");
            if (input.length % 4 === 1) {
              throw new Error("bad atob input");
            }
            for (var bc = 0, bs, buffer, idx = 0, output = ""; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
              buffer = digits.indexOf(buffer);
            }
            return output;
          };
        })();
        (function checkFunctionPrototypeBindCompatibility() {
          if (typeof Function.prototype.bind !== "undefined") {
            return;
          }
          Function.prototype.bind = function functionPrototypeBind(obj) {
            var fn = this,
              headArgs = Array.prototype.slice.call(arguments, 1);
            var bound = function functionPrototypeBindBound() {
              var args = headArgs.concat(Array.prototype.slice.call(arguments));
              return fn.apply(obj, args);
            };
            return bound;
          };
        })();
        (function checkDatasetProperty() {
          if (!hasDOM) {
            return;
          }
          var div = document.createElement("div");
          if ("dataset" in div) {
            return;
          }
          Object.defineProperty(HTMLElement.prototype, "dataset", {
            get: function get() {
              if (this._dataset) {
                return this._dataset;
              }
              var dataset = {};
              for (var j = 0, jj = this.attributes.length; j < jj; j++) {
                var attribute = this.attributes[j];
                if (attribute.name.substring(0, 5) !== "data-") {
                  continue;
                }
                var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
                  return ch.toUpperCase();
                });
                dataset[key] = attribute.value;
              }
              Object.defineProperty(this, "_dataset", {
                value: dataset,
                writable: false,
                enumerable: false
              });
              return dataset;
            },

            enumerable: true
          });
        })();
        (function checkClassListProperty() {
          function changeList(element, itemName, add, remove) {
            var s = element.className || "";
            var list = s.split(/\s+/g);
            if (list[0] === "") {
              list.shift();
            }
            var index = list.indexOf(itemName);
            if (index < 0 && add) {
              list.push(itemName);
            }
            if (index >= 0 && remove) {
              list.splice(index, 1);
            }
            element.className = list.join(" ");
            return index >= 0;
          }
          if (!hasDOM) {
            return;
          }
          var div = document.createElement("div");
          if ("classList" in div) {
            return;
          }
          var classListPrototype = {
            add: function add(name) {
              changeList(this.element, name, true, false);
            },
            contains: function contains(name) {
              return changeList(this.element, name, false, false);
            },
            remove: function remove(name) {
              changeList(this.element, name, false, true);
            },
            toggle: function toggle(name) {
              changeList(this.element, name, true, true);
            }
          };
          Object.defineProperty(HTMLElement.prototype, "classList", {
            get: function get() {
              if (this._classList) {
                return this._classList;
              }
              var classList = Object.create(classListPrototype, {
                element: {
                  value: this,
                  writable: false,
                  enumerable: true
                }
              });
              Object.defineProperty(this, "_classList", {
                value: classList,
                writable: false,
                enumerable: false
              });
              return classList;
            },

            enumerable: true
          });
        })();
        (function checkWorkerConsoleCompatibility() {
          if (typeof importScripts === "undefined" || "console" in globalScope) {
            return;
          }
          var consoleTimer = {};
          var workerConsole = {
            log: function log() {
              var args = Array.prototype.slice.call(arguments);
              globalScope.postMessage({
                targetName: "main",
                action: "console_log",
                data: args
              });
            },
            error: function error() {
              var args = Array.prototype.slice.call(arguments);
              globalScope.postMessage({
                targetName: "main",
                action: "console_error",
                data: args
              });
            },
            time: function time(name) {
              consoleTimer[name] = Date.now();
            },
            timeEnd: function timeEnd(name) {
              var time = consoleTimer[name];
              if (!time) {
                throw new Error("Unknown timer name " + name);
              }
              this.log("Timer:", name, Date.now() - time);
            }
          };
          globalScope.console = workerConsole;
        })();
        (function checkConsoleCompatibility() {
          if (!hasDOM) {
            return;
          }
          if (!("console" in window)) {
            window.console = {
              log: function log() {},
              error: function error() {},
              warn: function warn() {}
            };
            return;
          }
          if (!("bind" in console.log)) {
            console.log = function (fn) {
              return function (msg) {
                return fn(msg);
              };
            }(console.log);
            console.error = function (fn) {
              return function (msg) {
                return fn(msg);
              };
            }(console.error);
            console.warn = function (fn) {
              return function (msg) {
                return fn(msg);
              };
            }(console.warn);
            return;
          }
        })();
        (function checkOnClickCompatibility() {
          function ignoreIfTargetDisabled(event) {
            if (isDisabled(event.target)) {
              event.stopPropagation();
            }
          }
          function isDisabled(node) {
            return node.disabled || node.parentNode && isDisabled(node.parentNode);
          }
          if (isOpera) {
            document.addEventListener("click", ignoreIfTargetDisabled, true);
          }
        })();
        (function checkOnBlobSupport() {
          if (isIE || isIOSChrome) {
            PDFJS.disableCreateObjectURL = true;
          }
        })();
        (function checkNavigatorLanguage() {
          if (typeof navigator === "undefined") {
            return;
          }
          if ("language" in navigator) {
            return;
          }
          PDFJS.locale = navigator.userLanguage || "en-US";
        })();
        (function checkRangeRequests() {
          if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
            PDFJS.disableRange = true;
            PDFJS.disableStream = true;
          }
        })();
        (function checkHistoryManipulation() {
          if (!hasDOM) {
            return;
          }
          if (!history.pushState || isAndroidPre3) {
            PDFJS.disableHistory = true;
          }
        })();
        (function checkSetPresenceInImageData() {
          if (!hasDOM) {
            return;
          }
          if (window.CanvasPixelArray) {
            if (typeof window.CanvasPixelArray.prototype.set !== "function") {
              window.CanvasPixelArray.prototype.set = function (arr) {
                for (var i = 0, ii = this.length; i < ii; i++) {
                  this[i] = arr[i];
                }
              };
            }
          } else {
            var polyfill = false,
              versionMatch;
            if (isChrome) {
              versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
              polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
            } else if (isAndroid) {
              polyfill = isAndroidPre5;
            } else if (isSafari) {
              versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
              polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
            }
            if (polyfill) {
              var contextPrototype = window.CanvasRenderingContext2D.prototype;
              var createImageData = contextPrototype.createImageData;
              contextPrototype.createImageData = function (w, h) {
                var imageData = createImageData.call(this, w, h);
                imageData.data.set = function (arr) {
                  for (var i = 0, ii = this.length; i < ii; i++) {
                    this[i] = arr[i];
                  }
                };
                return imageData;
              };
              contextPrototype = null;
            }
          }
        })();
        (function checkRequestAnimationFrame() {
          function installFakeAnimationFrameFunctions() {
            window.requestAnimationFrame = function (callback) {
              return window.setTimeout(callback, 20);
            };
            window.cancelAnimationFrame = function (timeoutID) {
              window.clearTimeout(timeoutID);
            };
          }
          if (!hasDOM) {
            return;
          }
          if (isIOS) {
            installFakeAnimationFrameFunctions();
            return;
          }
          if ("requestAnimationFrame" in window) {
            return;
          }
          window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
          if (window.requestAnimationFrame) {
            return;
          }
          installFakeAnimationFrameFunctions();
        })();
        (function checkCanvasSizeLimitation() {
          if (isIOS || isAndroid) {
            PDFJS.maxCanvasPixels = 5242880;
          }
        })();
        (function checkFullscreenSupport() {
          if (!hasDOM) {
            return;
          }
          if (isIE && window.parent !== window) {
            PDFJS.disableFullscreen = true;
          }
        })();
        (function checkCurrentScript() {
          if (!hasDOM) {
            return;
          }
          if ("currentScript" in document) {
            return;
          }
          Object.defineProperty(document, "currentScript", {
            get: function get() {
              var scripts = document.getElementsByTagName("script");
              return scripts[scripts.length - 1];
            },

            enumerable: true,
            configurable: true
          });
        })();
        (function checkInputTypeNumberAssign() {
          if (!hasDOM) {
            return;
          }
          var el = document.createElement("input");
          try {
            el.type = "number";
          } catch (ex) {
            var inputProto = el.constructor.prototype;
            var typeProperty = Object.getOwnPropertyDescriptor(inputProto, "type");
            Object.defineProperty(inputProto, "type", {
              get: function get() {
                return typeProperty.get.call(this);
              },
              set: function set(value) {
                typeProperty.set.call(this, value === "number" ? "text" : value);
              },

              enumerable: true,
              configurable: true
            });
          }
        })();
        (function checkDocumentReadyState() {
          if (!hasDOM) {
            return;
          }
          if (!document.attachEvent) {
            return;
          }
          var documentProto = document.constructor.prototype;
          var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, "readyState");
          Object.defineProperty(documentProto, "readyState", {
            get: function get() {
              var value = readyStateProto.get.call(this);
              return value === "interactive" ? "loading" : value;
            },
            set: function set(value) {
              readyStateProto.set.call(this, value);
            },

            enumerable: true,
            configurable: true
          });
        })();
        (function checkChildNodeRemove() {
          if (!hasDOM) {
            return;
          }
          if (typeof Element.prototype.remove !== "undefined") {
            return;
          }
          Element.prototype.remove = function () {
            if (this.parentNode) {
              this.parentNode.removeChild(this);
            }
          };
        })();
        (function checkNumberIsNaN() {
          if (Number.isNaN) {
            return;
          }
          Number.isNaN = __w_pdfjs_require__(89);
        })();
        (function checkNumberIsInteger() {
          if (Number.isInteger) {
            return;
          }
          Number.isInteger = __w_pdfjs_require__(91);
        })();
        (function checkPromise() {
          if (globalScope.Promise) {
            return;
          }
          globalScope.Promise = __w_pdfjs_require__(94);
        })();
        (function checkWeakMap() {
          if (globalScope.WeakMap) {
            return;
          }
          globalScope.WeakMap = __w_pdfjs_require__(103);
        })();
        (function checkURLConstructor() {
          var hasWorkingUrl = false;
          try {
            if (typeof URL === "function" && _typeof(URL.prototype) === "object" && "origin" in URL.prototype) {
              var u = new URL("b", "http://a");
              u.pathname = "c%20d";
              hasWorkingUrl = u.href === "http://a/c%20d";
            }
          } catch (e) {}
          if (hasWorkingUrl) {
            return;
          }
          var relative = Object.create(null);
          relative["ftp"] = 21;
          relative["file"] = 0;
          relative["gopher"] = 70;
          relative["http"] = 80;
          relative["https"] = 443;
          relative["ws"] = 80;
          relative["wss"] = 443;
          var relativePathDotMapping = Object.create(null);
          relativePathDotMapping["%2e"] = ".";
          relativePathDotMapping[".%2e"] = "..";
          relativePathDotMapping["%2e."] = "..";
          relativePathDotMapping["%2e%2e"] = "..";
          function isRelativeScheme(scheme) {
            return relative[scheme] !== undefined;
          }
          function invalid() {
            clear.call(this);
            this._isInvalid = true;
          }
          function IDNAToASCII(h) {
            if (h === "") {
              invalid.call(this);
            }
            return h.toLowerCase();
          }
          function percentEscape(c) {
            var unicode = c.charCodeAt(0);
            if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
              return c;
            }
            return encodeURIComponent(c);
          }
          function percentEscapeQuery(c) {
            var unicode = c.charCodeAt(0);
            if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
              return c;
            }
            return encodeURIComponent(c);
          }
          var EOF,
            ALPHA = /[a-zA-Z]/,
            ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
          function parse(input, stateOverride, base) {
            function err(message) {
              errors.push(message);
            }
            var state = stateOverride || "scheme start",
              cursor = 0,
              buffer = "",
              seenAt = false,
              seenBracket = false,
              errors = [];
            loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
              var c = input[cursor];
              switch (state) {
                case "scheme start":
                  if (c && ALPHA.test(c)) {
                    buffer += c.toLowerCase();
                    state = "scheme";
                  } else if (!stateOverride) {
                    buffer = "";
                    state = "no scheme";
                    continue;
                  } else {
                    err("Invalid scheme.");
                    break loop;
                  }
                  break;
                case "scheme":
                  if (c && ALPHANUMERIC.test(c)) {
                    buffer += c.toLowerCase();
                  } else if (c === ":") {
                    this._scheme = buffer;
                    buffer = "";
                    if (stateOverride) {
                      break loop;
                    }
                    if (isRelativeScheme(this._scheme)) {
                      this._isRelative = true;
                    }
                    if (this._scheme === "file") {
                      state = "relative";
                    } else if (this._isRelative && base && base._scheme === this._scheme) {
                      state = "relative or authority";
                    } else if (this._isRelative) {
                      state = "authority first slash";
                    } else {
                      state = "scheme data";
                    }
                  } else if (!stateOverride) {
                    buffer = "";
                    cursor = 0;
                    state = "no scheme";
                    continue;
                  } else if (c === EOF) {
                    break loop;
                  } else {
                    err("Code point not allowed in scheme: " + c);
                    break loop;
                  }
                  break;
                case "scheme data":
                  if (c === "?") {
                    this._query = "?";
                    state = "query";
                  } else if (c === "#") {
                    this._fragment = "#";
                    state = "fragment";
                  } else {
                    if (c !== EOF && c !== "\t" && c !== "\n" && c !== "\r") {
                      this._schemeData += percentEscape(c);
                    }
                  }
                  break;
                case "no scheme":
                  if (!base || !isRelativeScheme(base._scheme)) {
                    err("Missing scheme.");
                    invalid.call(this);
                  } else {
                    state = "relative";
                    continue;
                  }
                  break;
                case "relative or authority":
                  if (c === "/" && input[cursor + 1] === "/") {
                    state = "authority ignore slashes";
                  } else {
                    err("Expected /, got: " + c);
                    state = "relative";
                    continue;
                  }
                  break;
                case "relative":
                  this._isRelative = true;
                  if (this._scheme !== "file") {
                    this._scheme = base._scheme;
                  }
                  if (c === EOF) {
                    this._host = base._host;
                    this._port = base._port;
                    this._path = base._path.slice();
                    this._query = base._query;
                    this._username = base._username;
                    this._password = base._password;
                    break loop;
                  } else if (c === "/" || c === "\\") {
                    if (c === "\\") {
                      err("\\ is an invalid code point.");
                    }
                    state = "relative slash";
                  } else if (c === "?") {
                    this._host = base._host;
                    this._port = base._port;
                    this._path = base._path.slice();
                    this._query = "?";
                    this._username = base._username;
                    this._password = base._password;
                    state = "query";
                  } else if (c === "#") {
                    this._host = base._host;
                    this._port = base._port;
                    this._path = base._path.slice();
                    this._query = base._query;
                    this._fragment = "#";
                    this._username = base._username;
                    this._password = base._password;
                    state = "fragment";
                  } else {
                    var nextC = input[cursor + 1];
                    var nextNextC = input[cursor + 2];
                    if (this._scheme !== "file" || !ALPHA.test(c) || nextC !== ":" && nextC !== "|" || nextNextC !== EOF && nextNextC !== "/" && nextNextC !== "\\" && nextNextC !== "?" && nextNextC !== "#") {
                      this._host = base._host;
                      this._port = base._port;
                      this._username = base._username;
                      this._password = base._password;
                      this._path = base._path.slice();
                      this._path.pop();
                    }
                    state = "relative path";
                    continue;
                  }
                  break;
                case "relative slash":
                  if (c === "/" || c === "\\") {
                    if (c === "\\") {
                      err("\\ is an invalid code point.");
                    }
                    if (this._scheme === "file") {
                      state = "file host";
                    } else {
                      state = "authority ignore slashes";
                    }
                  } else {
                    if (this._scheme !== "file") {
                      this._host = base._host;
                      this._port = base._port;
                      this._username = base._username;
                      this._password = base._password;
                    }
                    state = "relative path";
                    continue;
                  }
                  break;
                case "authority first slash":
                  if (c === "/") {
                    state = "authority second slash";
                  } else {
                    err("Expected '/', got: " + c);
                    state = "authority ignore slashes";
                    continue;
                  }
                  break;
                case "authority second slash":
                  state = "authority ignore slashes";
                  if (c !== "/") {
                    err("Expected '/', got: " + c);
                    continue;
                  }
                  break;
                case "authority ignore slashes":
                  if (c !== "/" && c !== "\\") {
                    state = "authority";
                    continue;
                  } else {
                    err("Expected authority, got: " + c);
                  }
                  break;
                case "authority":
                  if (c === "@") {
                    if (seenAt) {
                      err("@ already seen.");
                      buffer += "%40";
                    }
                    seenAt = true;
                    for (var i = 0; i < buffer.length; i++) {
                      var cp = buffer[i];
                      if (cp === "\t" || cp === "\n" || cp === "\r") {
                        err("Invalid whitespace in authority.");
                        continue;
                      }
                      if (cp === ":" && this._password === null) {
                        this._password = "";
                        continue;
                      }
                      var tempC = percentEscape(cp);
                      if (this._password !== null) {
                        this._password += tempC;
                      } else {
                        this._username += tempC;
                      }
                    }
                    buffer = "";
                  } else if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#") {
                    cursor -= buffer.length;
                    buffer = "";
                    state = "host";
                    continue;
                  } else {
                    buffer += c;
                  }
                  break;
                case "file host":
                  if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#") {
                    if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ":" || buffer[1] === "|")) {
                      state = "relative path";
                    } else if (buffer.length === 0) {
                      state = "relative path start";
                    } else {
                      this._host = IDNAToASCII.call(this, buffer);
                      buffer = "";
                      state = "relative path start";
                    }
                    continue;
                  } else if (c === "\t" || c === "\n" || c === "\r") {
                    err("Invalid whitespace in file host.");
                  } else {
                    buffer += c;
                  }
                  break;
                case "host":
                case "hostname":
                  if (c === ":" && !seenBracket) {
                    this._host = IDNAToASCII.call(this, buffer);
                    buffer = "";
                    state = "port";
                    if (stateOverride === "hostname") {
                      break loop;
                    }
                  } else if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#") {
                    this._host = IDNAToASCII.call(this, buffer);
                    buffer = "";
                    state = "relative path start";
                    if (stateOverride) {
                      break loop;
                    }
                    continue;
                  } else if (c !== "\t" && c !== "\n" && c !== "\r") {
                    if (c === "[") {
                      seenBracket = true;
                    } else if (c === "]") {
                      seenBracket = false;
                    }
                    buffer += c;
                  } else {
                    err("Invalid code point in host/hostname: " + c);
                  }
                  break;
                case "port":
                  if (/[0-9]/.test(c)) {
                    buffer += c;
                  } else if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#" || stateOverride) {
                    if (buffer !== "") {
                      var temp = parseInt(buffer, 10);
                      if (temp !== relative[this._scheme]) {
                        this._port = temp + "";
                      }
                      buffer = "";
                    }
                    if (stateOverride) {
                      break loop;
                    }
                    state = "relative path start";
                    continue;
                  } else if (c === "\t" || c === "\n" || c === "\r") {
                    err("Invalid code point in port: " + c);
                  } else {
                    invalid.call(this);
                  }
                  break;
                case "relative path start":
                  if (c === "\\") {
                    err("'\\' not allowed in path.");
                  }
                  state = "relative path";
                  if (c !== "/" && c !== "\\") {
                    continue;
                  }
                  break;
                case "relative path":
                  if (c === EOF || c === "/" || c === "\\" || !stateOverride && (c === "?" || c === "#")) {
                    if (c === "\\") {
                      err("\\ not allowed in relative path.");
                    }
                    var tmp;
                    if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                      buffer = tmp;
                    }
                    if (buffer === "..") {
                      this._path.pop();
                      if (c !== "/" && c !== "\\") {
                        this._path.push("");
                      }
                    } else if (buffer === "." && c !== "/" && c !== "\\") {
                      this._path.push("");
                    } else if (buffer !== ".") {
                      if (this._scheme === "file" && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === "|") {
                        buffer = buffer[0] + ":";
                      }
                      this._path.push(buffer);
                    }
                    buffer = "";
                    if (c === "?") {
                      this._query = "?";
                      state = "query";
                    } else if (c === "#") {
                      this._fragment = "#";
                      state = "fragment";
                    }
                  } else if (c !== "\t" && c !== "\n" && c !== "\r") {
                    buffer += percentEscape(c);
                  }
                  break;
                case "query":
                  if (!stateOverride && c === "#") {
                    this._fragment = "#";
                    state = "fragment";
                  } else if (c !== EOF && c !== "\t" && c !== "\n" && c !== "\r") {
                    this._query += percentEscapeQuery(c);
                  }
                  break;
                case "fragment":
                  if (c !== EOF && c !== "\t" && c !== "\n" && c !== "\r") {
                    this._fragment += c;
                  }
                  break;
              }
              cursor++;
            }
          }
          function clear() {
            this._scheme = "";
            this._schemeData = "";
            this._username = "";
            this._password = null;
            this._host = "";
            this._port = "";
            this._path = [];
            this._query = "";
            this._fragment = "";
            this._isInvalid = false;
            this._isRelative = false;
          }
          function JURL(url, base) {
            if (base !== undefined && !(base instanceof JURL)) {
              base = new JURL(String(base));
            }
            this._url = url;
            clear.call(this);
            var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, "");
            parse.call(this, input, null, base);
          }
          JURL.prototype = {
            toString: function toString() {
              return this.href;
            },

            get href() {
              if (this._isInvalid) {
                return this._url;
              }
              var authority = "";
              if (this._username !== "" || this._password !== null) {
                authority = this._username + (this._password !== null ? ":" + this._password : "") + "@";
              }
              return this.protocol + (this._isRelative ? "//" + authority + this.host : "") + this.pathname + this._query + this._fragment;
            },
            set href(value) {
              clear.call(this);
              parse.call(this, value);
            },
            get protocol() {
              return this._scheme + ":";
            },
            set protocol(value) {
              if (this._isInvalid) {
                return;
              }
              parse.call(this, value + ":", "scheme start");
            },
            get host() {
              return this._isInvalid ? "" : this._port ? this._host + ":" + this._port : this._host;
            },
            set host(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              parse.call(this, value, "host");
            },
            get hostname() {
              return this._host;
            },
            set hostname(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              parse.call(this, value, "hostname");
            },
            get port() {
              return this._port;
            },
            set port(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              parse.call(this, value, "port");
            },
            get pathname() {
              return this._isInvalid ? "" : this._isRelative ? "/" + this._path.join("/") : this._schemeData;
            },
            set pathname(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              this._path = [];
              parse.call(this, value, "relative path start");
            },
            get search() {
              return this._isInvalid || !this._query || this._query === "?" ? "" : this._query;
            },
            set search(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              this._query = "?";
              if (value[0] === "?") {
                value = value.slice(1);
              }
              parse.call(this, value, "query");
            },
            get hash() {
              return this._isInvalid || !this._fragment || this._fragment === "#" ? "" : this._fragment;
            },
            set hash(value) {
              if (this._isInvalid) {
                return;
              }
              this._fragment = "#";
              if (value[0] === "#") {
                value = value.slice(1);
              }
              parse.call(this, value, "fragment");
            },
            get origin() {
              var host;
              if (this._isInvalid || !this._scheme) {
                return "";
              }
              switch (this._scheme) {
                case "data":
                case "file":
                case "javascript":
                case "mailto":
                  return "null";
                case "blob":
                  try {
                    return new JURL(this._schemeData).origin || "null";
                  } catch (_) {}
                  return "null";
              }
              host = this.host;
              if (!host) {
                return "";
              }
              return this._scheme + "://" + host;
            }
          };
          var OriginalURL = globalScope.URL;
          if (OriginalURL) {
            JURL.createObjectURL = function (blob) {
              return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
            };
            JURL.revokeObjectURL = function (url) {
              OriginalURL.revokeObjectURL(url);
            };
          }
          globalScope.URL = JURL;
        })();
      }

      /***/ }),
    /* 77 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(78);
      module.exports = __w_pdfjs_require__(5).Uint8ClampedArray;

      /***/ }),
    /* 78 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(79)("Uint8", 1, function (init) {
        return function Uint8ClampedArray(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      }, true);

      /***/ }),
    /* 79 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      if (__w_pdfjs_require__(9)) {
        var LIBRARY = __w_pdfjs_require__(26);
        var global = __w_pdfjs_require__(1);
        var fails = __w_pdfjs_require__(10);
        var $export = __w_pdfjs_require__(4);
        var $typed = __w_pdfjs_require__(46);
        var $buffer = __w_pdfjs_require__(80);
        var ctx = __w_pdfjs_require__(11);
        var anInstance = __w_pdfjs_require__(23);
        var propertyDesc = __w_pdfjs_require__(27);
        var hide = __w_pdfjs_require__(6);
        var redefineAll = __w_pdfjs_require__(22);
        var toInteger = __w_pdfjs_require__(17);
        var toLength = __w_pdfjs_require__(12);
        var toIndex = __w_pdfjs_require__(47);
        var toAbsoluteIndex = __w_pdfjs_require__(29);
        var toPrimitive = __w_pdfjs_require__(33);
        var has = __w_pdfjs_require__(8);
        var classof = __w_pdfjs_require__(30);
        var isObject = __w_pdfjs_require__(2);
        var toObject = __w_pdfjs_require__(18);
        var isArrayIter = __w_pdfjs_require__(53);
        var create = __w_pdfjs_require__(54);
        var getPrototypeOf = __w_pdfjs_require__(56);
        var gOPN = __w_pdfjs_require__(48).f;
        var getIterFn = __w_pdfjs_require__(57);
        var uid = __w_pdfjs_require__(16);
        var wks = __w_pdfjs_require__(3);
        var createArrayMethod = __w_pdfjs_require__(39);
        var createArrayIncludes = __w_pdfjs_require__(50);
        var speciesConstructor = __w_pdfjs_require__(40);
        var ArrayIterators = __w_pdfjs_require__(58);
        var Iterators = __w_pdfjs_require__(19);
        var $iterDetect = __w_pdfjs_require__(41);
        var setSpecies = __w_pdfjs_require__(60);
        var arrayFill = __w_pdfjs_require__(52);
        var arrayCopyWithin = __w_pdfjs_require__(88);
        var $DP = __w_pdfjs_require__(14);
        var $GOPD = __w_pdfjs_require__(61);
        var dP = $DP.f;
        var gOPD = $GOPD.f;
        var RangeError = global.RangeError;
        var TypeError = global.TypeError;
        var Uint8Array = global.Uint8Array;
        var ARRAY_BUFFER = "ArrayBuffer";
        var SHARED_BUFFER = "Shared" + ARRAY_BUFFER;
        var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
        var PROTOTYPE = "prototype";
        var ArrayProto = Array[PROTOTYPE];
        var $ArrayBuffer = $buffer.ArrayBuffer;
        var $DataView = $buffer.DataView;
        var arrayForEach = createArrayMethod(0);
        var arrayFilter = createArrayMethod(2);
        var arraySome = createArrayMethod(3);
        var arrayEvery = createArrayMethod(4);
        var arrayFind = createArrayMethod(5);
        var arrayFindIndex = createArrayMethod(6);
        var arrayIncludes = createArrayIncludes(true);
        var arrayIndexOf = createArrayIncludes(false);
        var arrayValues = ArrayIterators.values;
        var arrayKeys = ArrayIterators.keys;
        var arrayEntries = ArrayIterators.entries;
        var arrayLastIndexOf = ArrayProto.lastIndexOf;
        var arrayReduce = ArrayProto.reduce;
        var arrayReduceRight = ArrayProto.reduceRight;
        var arrayJoin = ArrayProto.join;
        var arraySort = ArrayProto.sort;
        var arraySlice = ArrayProto.slice;
        var arrayToString = ArrayProto.toString;
        var arrayToLocaleString = ArrayProto.toLocaleString;
        var ITERATOR = wks("iterator");
        var TAG = wks("toStringTag");
        var TYPED_CONSTRUCTOR = uid("typed_constructor");
        var DEF_CONSTRUCTOR = uid("def_constructor");
        var ALL_CONSTRUCTORS = $typed.CONSTR;
        var TYPED_ARRAY = $typed.TYPED;
        var VIEW = $typed.VIEW;
        var WRONG_LENGTH = "Wrong length!";
        var $map = createArrayMethod(1, function (O, length) {
          return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
        });
        var LITTLE_ENDIAN = fails(function () {
          return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
        });
        var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
          new Uint8Array(1).set({});
        });
        var toOffset = function toOffset(it, BYTES) {
          var offset = toInteger(it);
          if (offset < 0 || offset % BYTES) throw RangeError("Wrong offset!");
          return offset;
        };
        var validate = function validate(it) {
          if (isObject(it) && TYPED_ARRAY in it) return it;
          throw TypeError(it + " is not a typed array!");
        };
        var allocate = function allocate(C, length) {
          if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
            throw TypeError("It is not a typed array constructor!");
          }
          return new C(length);
        };
        var speciesFromList = function speciesFromList(O, list) {
          return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
        };
        var fromList = function fromList(C, list) {
          var index = 0;
          var length = list.length;
          var result = allocate(C, length);
          while (length > index) {
            result[index] = list[index++];
          } return result;
        };
        var addGetter = function addGetter(it, key, internal) {
          dP(it, key, {
            get: function get() {
              return this._d[internal];
            }
          });
        };
        var $from = function from(source) {
          var O = toObject(source);
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var iterFn = getIterFn(O);
          var i, length, values, result, step, iterator;
          if (iterFn != undefined && !isArrayIter(iterFn)) {
            for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
              values.push(step.value);
            }
            O = values;
          }
          if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
          for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };
        var $of = function of() {
          var index = 0;
          var length = arguments.length;
          var result = allocate(this, length);
          while (length > index) {
            result[index] = arguments[index++];
          } return result;
        };
        var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
          arrayToLocaleString.call(new Uint8Array(1));
        });
        var $toLocaleString = function toLocaleString() {
          return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
        };
        var proto = {
          copyWithin: function copyWithin(target, start) {
            return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
          },
          every: function every(callbackfn) {
            return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          fill: function fill(value) {
            return arrayFill.apply(validate(this), arguments);
          },
          filter: function filter(callbackfn) {
            return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
          },
          find: function find(predicate) {
            return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          findIndex: function findIndex(predicate) {
            return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          forEach: function forEach(callbackfn) {
            arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          indexOf: function indexOf(searchElement) {
            return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          includes: function includes(searchElement) {
            return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          join: function join(separator) {
            return arrayJoin.apply(validate(this), arguments);
          },
          lastIndexOf: function lastIndexOf(searchElement) {
            return arrayLastIndexOf.apply(validate(this), arguments);
          },
          map: function map(mapfn) {
            return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          reduce: function reduce(callbackfn) {
            return arrayReduce.apply(validate(this), arguments);
          },
          reduceRight: function reduceRight(callbackfn) {
            return arrayReduceRight.apply(validate(this), arguments);
          },
          reverse: function reverse() {
            var that = this;
            var length = validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while (index < middle) {
              value = that[index];
              that[index++] = that[--length];
              that[length] = value;
            }
            return that;
          },
          some: function some(callbackfn) {
            return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          sort: function sort(comparefn) {
            return arraySort.call(validate(this), comparefn);
          },
          subarray: function subarray(begin, end) {
            var O = validate(this);
            var length = O.length;
            var $begin = toAbsoluteIndex(begin, length);
            return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
          }
        };
        var $slice = function slice(start, end) {
          return speciesFromList(this, arraySlice.call(validate(this), start, end));
        };
        var $set = function set(arrayLike) {
          validate(this);
          var offset = toOffset(arguments[1], 1);
          var length = this.length;
          var src = toObject(arrayLike);
          var len = toLength(src.length);
          var index = 0;
          if (len + offset > length) throw RangeError(WRONG_LENGTH);
          while (index < len) {
            this[offset + index] = src[index++];
          }
        };
        var $iterators = {
          entries: function entries() {
            return arrayEntries.call(validate(this));
          },
          keys: function keys() {
            return arrayKeys.call(validate(this));
          },
          values: function values() {
            return arrayValues.call(validate(this));
          }
        };
        var isTAIndex = function isTAIndex(target, key) {
          return isObject(target) && target[TYPED_ARRAY] && (typeof key === "undefined" ? "undefined" : _typeof(key)) != "symbol" && key in target && String(+key) == String(key);
        };
        var $getDesc = function getOwnPropertyDescriptor(target, key) {
          return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
        };
        var $setDesc = function defineProperty(target, key, desc) {
          if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, "value") && !has(desc, "get") && !has(desc, "set") && !desc.configurable && (!has(desc, "writable") || desc.writable) && (!has(desc, "enumerable") || desc.enumerable)) {
            target[key] = desc.value;
            return target;
          }
          return dP(target, key, desc);
        };
        if (!ALL_CONSTRUCTORS) {
          $GOPD.f = $getDesc;
          $DP.f = $setDesc;
        }
        $export($export.S + $export.F * !ALL_CONSTRUCTORS, "Object", {
          getOwnPropertyDescriptor: $getDesc,
          defineProperty: $setDesc
        });
        if (fails(function () {
          arrayToString.call({});
        })) {
          arrayToString = arrayToLocaleString = function toString() {
            return arrayJoin.call(this);
          };
        }
        var $TypedArrayPrototype$ = redefineAll({}, proto);
        redefineAll($TypedArrayPrototype$, $iterators);
        hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
        redefineAll($TypedArrayPrototype$, {
          slice: $slice,
          set: $set,
          constructor: function constructor() {},
          toString: arrayToString,
          toLocaleString: $toLocaleString
        });
        addGetter($TypedArrayPrototype$, "buffer", "b");
        addGetter($TypedArrayPrototype$, "byteOffset", "o");
        addGetter($TypedArrayPrototype$, "byteLength", "l");
        addGetter($TypedArrayPrototype$, "length", "e");
        dP($TypedArrayPrototype$, TAG, {
          get: function get() {
            return this[TYPED_ARRAY];
          }
        });
        module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
          CLAMPED = !!CLAMPED;
          var NAME = KEY + (CLAMPED ? "Clamped" : "") + "Array";
          var GETTER = "get" + KEY;
          var SETTER = "set" + KEY;
          var TypedArray = global[NAME];
          var Base = TypedArray || {};
          var TAC = TypedArray && getPrototypeOf(TypedArray);
          var FORCED = !TypedArray || !$typed.ABV;
          var O = {};
          var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
          var getter = function getter(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
          };
          var setter = function setter(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
          };
          var addElement = function addElement(that, index) {
            dP(that, index, {
              get: function get() {
                return getter(this, index);
              },
              set: function set(value) {
                return setter(this, index, value);
              },
              enumerable: true
            });
          };
          if (FORCED) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME, "_d");
              var index = 0;
              var offset = 0;
              var buffer, byteLength, length, klass;
              if (!isObject(data)) {
                length = toIndex(data);
                byteLength = length * BYTES;
                buffer = new $ArrayBuffer(byteLength);
              } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                buffer = data;
                offset = toOffset($offset, BYTES);
                var $len = data.byteLength;
                if ($length === undefined) {
                  if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                  byteLength = $len - offset;
                  if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                } else {
                  byteLength = toLength($length) * BYTES;
                  if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
                }
                length = byteLength / BYTES;
              } else if (TYPED_ARRAY in data) {
                return fromList(TypedArray, data);
              } else {
                return $from.call(TypedArray, data);
              }
              hide(that, "_d", {
                b: buffer,
                o: offset,
                l: byteLength,
                e: length,
                v: new $DataView(buffer)
              });
              while (index < length) {
                addElement(that, index++);
              }
            });
            TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
            hide(TypedArrayPrototype, "constructor", TypedArray);
          } else if (!fails(function () {
            TypedArray(1);
          }) || !fails(function () {
            new TypedArray(-1);
          }) || !$iterDetect(function (iter) {
            new TypedArray();
            new TypedArray(null);
            new TypedArray(1.5);
            new TypedArray(iter);
          }, true)) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME);
              var klass;
              if (!isObject(data)) return new Base(toIndex(data));
              if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
              }
              if (TYPED_ARRAY in data) return fromList(TypedArray, data);
              return $from.call(TypedArray, data);
            });
            arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
              if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
            });
            TypedArray[PROTOTYPE] = TypedArrayPrototype;
            if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
          }
          var $nativeIterator = TypedArrayPrototype[ITERATOR];
          var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == "values" || $nativeIterator.name == undefined);
          var $iterator = $iterators.values;
          hide(TypedArray, TYPED_CONSTRUCTOR, true);
          hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
          hide(TypedArrayPrototype, VIEW, true);
          hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
          if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
            dP(TypedArrayPrototype, TAG, {
              get: function get() {
                return NAME;
              }
            });
          }
          O[NAME] = TypedArray;
          $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
          $export($export.S, NAME, { BYTES_PER_ELEMENT: BYTES });
          $export($export.S + $export.F * fails(function () {
            Base.of.call(TypedArray, 1);
          }), NAME, {
            from: $from,
            of: $of
          });
          if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
          $export($export.P, NAME, proto);
          setSpecies(NAME);
          $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
          $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
          if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
          $export($export.P + $export.F * fails(function () {
            new TypedArray(1).slice();
          }), NAME, { slice: $slice });
          $export($export.P + $export.F * (fails(function () {
            return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
          }) || !fails(function () {
            TypedArrayPrototype.toLocaleString.call([1, 2]);
          })), NAME, { toLocaleString: $toLocaleString });
          Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
          if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
        };
      } else module.exports = function () {};

      /***/ }),
    /* 80 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var DESCRIPTORS = __w_pdfjs_require__(9);
      var LIBRARY = __w_pdfjs_require__(26);
      var $typed = __w_pdfjs_require__(46);
      var hide = __w_pdfjs_require__(6);
      var redefineAll = __w_pdfjs_require__(22);
      var fails = __w_pdfjs_require__(10);
      var anInstance = __w_pdfjs_require__(23);
      var toInteger = __w_pdfjs_require__(17);
      var toLength = __w_pdfjs_require__(12);
      var toIndex = __w_pdfjs_require__(47);
      var gOPN = __w_pdfjs_require__(48).f;
      var dP = __w_pdfjs_require__(14).f;
      var arrayFill = __w_pdfjs_require__(52);
      var setToStringTag = __w_pdfjs_require__(25);
      var ARRAY_BUFFER = "ArrayBuffer";
      var DATA_VIEW = "DataView";
      var PROTOTYPE = "prototype";
      var WRONG_LENGTH = "Wrong length!";
      var WRONG_INDEX = "Wrong index!";
      var $ArrayBuffer = global[ARRAY_BUFFER];
      var $DataView = global[DATA_VIEW];
      var Math = global.Math;
      var RangeError = global.RangeError;
      var Infinity = global.Infinity;
      var BaseBuffer = $ArrayBuffer;
      var abs = Math.abs;
      var pow = Math.pow;
      var floor = Math.floor;
      var log = Math.log;
      var LN2 = Math.LN2;
      var BUFFER = "buffer";
      var BYTE_LENGTH = "byteLength";
      var BYTE_OFFSET = "byteOffset";
      var $BUFFER = DESCRIPTORS ? "_b" : BUFFER;
      var $LENGTH = DESCRIPTORS ? "_l" : BYTE_LENGTH;
      var $OFFSET = DESCRIPTORS ? "_o" : BYTE_OFFSET;
      function packIEEE754(value, mLen, nBytes) {
        var buffer = Array(nBytes);
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
        var i = 0;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        var e, m, c;
        value = abs(value);
        if (value != value || value === Infinity) {
          m = value != value ? 1 : 0;
          e = eMax;
        } else {
          e = floor(log(value) / LN2);
          if (value * (c = pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * pow(2, eBias - 1) * pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
        e = e << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
        buffer[--i] |= s * 128;
        return buffer;
      }
      function unpackIEEE754(buffer, mLen, nBytes) {
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = eLen - 7;
        var i = nBytes - 1;
        var s = buffer[i--];
        var e = s & 127;
        var m;
        s >>= 7;
        for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : s ? -Infinity : Infinity;
        } else {
          m = m + pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * pow(2, e - mLen);
      }
      function unpackI32(bytes) {
        return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
      }
      function packI8(it) {
        return [it & 0xff];
      }
      function packI16(it) {
        return [it & 0xff, it >> 8 & 0xff];
      }
      function packI32(it) {
        return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
      }
      function packF64(it) {
        return packIEEE754(it, 52, 8);
      }
      function packF32(it) {
        return packIEEE754(it, 23, 4);
      }
      function addGetter(C, key, internal) {
        dP(C[PROTOTYPE], key, {
          get: function get() {
            return this[internal];
          }
        });
      }
      function get(view, bytes, index, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = store.slice(start, start + bytes);
        return isLittleEndian ? pack : pack.reverse();
      }
      function set(view, bytes, index, conversion, value, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = conversion(+value);
        for (var i = 0; i < bytes; i++) {
          store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
        }
      }
      if (!$typed.ABV) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
          var byteLength = toIndex(length);
          this._b = arrayFill.call(Array(byteLength), 0);
          this[$LENGTH] = byteLength;
        };
        $DataView = function DataView(buffer, byteOffset, byteLength) {
          anInstance(this, $DataView, DATA_VIEW);
          anInstance(buffer, $ArrayBuffer, DATA_VIEW);
          var bufferLength = buffer[$LENGTH];
          var offset = toInteger(byteOffset);
          if (offset < 0 || offset > bufferLength) throw RangeError("Wrong offset!");
          byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
          if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
          this[$BUFFER] = buffer;
          this[$OFFSET] = offset;
          this[$LENGTH] = byteLength;
        };
        if (DESCRIPTORS) {
          addGetter($ArrayBuffer, BYTE_LENGTH, "_l");
          addGetter($DataView, BUFFER, "_b");
          addGetter($DataView, BYTE_LENGTH, "_l");
          addGetter($DataView, BYTE_OFFSET, "_o");
        }
        redefineAll($DataView[PROTOTYPE], {
          getInt8: function getInt8(byteOffset) {
            return get(this, 1, byteOffset)[0] << 24 >> 24;
          },
          getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
          },
          getInt16: function getInt16(byteOffset) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
          },
          getUint16: function getUint16(byteOffset) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
          },
          getInt32: function getInt32(byteOffset) {
            return unpackI32(get(this, 4, byteOffset, arguments[1]));
          },
          getUint32: function getUint32(byteOffset) {
            return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
          },
          getFloat32: function getFloat32(byteOffset) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
          },
          getFloat64: function getFloat64(byteOffset) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
          },
          setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setInt16: function setInt16(byteOffset, value) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setUint16: function setUint16(byteOffset, value) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setInt32: function setInt32(byteOffset, value) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setUint32: function setUint32(byteOffset, value) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setFloat32: function setFloat32(byteOffset, value) {
            set(this, 4, byteOffset, packF32, value, arguments[2]);
          },
          setFloat64: function setFloat64(byteOffset, value) {
            set(this, 8, byteOffset, packF64, value, arguments[2]);
          }
        });
      } else {
        if (!fails(function () {
          $ArrayBuffer(1);
        }) || !fails(function () {
          new $ArrayBuffer(-1);
        }) || fails(function () {
          new $ArrayBuffer();
          new $ArrayBuffer(1.5);
          new $ArrayBuffer(NaN);
          return $ArrayBuffer.name != ARRAY_BUFFER;
        })) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, $ArrayBuffer);
            return new BaseBuffer(toIndex(length));
          };
          var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
          for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
            if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
          }
          if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
        }
        var view = new $DataView(new $ArrayBuffer(2));
        var $setInt8 = $DataView[PROTOTYPE].setInt8;
        view.setInt8(0, 2147483648);
        view.setInt8(1, 2147483649);
        if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
          setInt8: function setInt8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          },
          setUint8: function setUint8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          }
        }, true);
      }
      setToStringTag($ArrayBuffer, ARRAY_BUFFER);
      setToStringTag($DataView, DATA_VIEW);
      hide($DataView[PROTOTYPE], $typed.VIEW, true);
      exports[ARRAY_BUFFER] = $ArrayBuffer;
      exports[DATA_VIEW] = $DataView;

      /***/ }),
    /* 81 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var dP = __w_pdfjs_require__(14);
      var anObject = __w_pdfjs_require__(7);
      var getKeys = __w_pdfjs_require__(38);
      module.exports = __w_pdfjs_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while (length > i) {
          dP.f(O, P = keys[i++], Properties[P]);
        } return O;
      };

      /***/ }),
    /* 82 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var speciesConstructor = __w_pdfjs_require__(83);
      module.exports = function (original, length) {
        return new (speciesConstructor(original))(length);
      };

      /***/ }),
    /* 83 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      var isArray = __w_pdfjs_require__(84);
      var SPECIES = __w_pdfjs_require__(3)("species");
      module.exports = function (original) {
        var C;
        if (isArray(original)) {
          C = original.constructor;
          if (typeof C === "function" && (C === Array || isArray(C.prototype))) C = undefined;
          if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
          }
        }
        return C === undefined ? Array : C;
      };

      /***/ }),
    /* 84 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var cof = __w_pdfjs_require__(24);
      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == "Array";
      };

      /***/ }),
    /* 85 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var UNSCOPABLES = __w_pdfjs_require__(3)("unscopables");
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(6)(ArrayProto, UNSCOPABLES, {});
      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };

      /***/ }),
    /* 86 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (done, value) {
        return {
          value: value,
          done: !!done
        };
      };

      /***/ }),
    /* 87 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var create = __w_pdfjs_require__(54);
      var descriptor = __w_pdfjs_require__(27);
      var setToStringTag = __w_pdfjs_require__(25);
      var IteratorPrototype = {};
      __w_pdfjs_require__(6)(IteratorPrototype, __w_pdfjs_require__(3)("iterator"), function () {
        return this;
      });
      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
        setToStringTag(Constructor, NAME + " Iterator");
      };

      /***/ }),
    /* 88 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toObject = __w_pdfjs_require__(18);
      var toAbsoluteIndex = __w_pdfjs_require__(29);
      var toLength = __w_pdfjs_require__(12);
      module.exports = [].copyWithin || function copyWithin(target, start) {
        var O = toObject(this);
        var len = toLength(O.length);
        var to = toAbsoluteIndex(target, len);
        var from = toAbsoluteIndex(start, len);
        var end = arguments.length > 2 ? arguments[2] : undefined;
        var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
        var inc = 1;
        if (from < to && to < from + count) {
          inc = -1;
          from += count - 1;
          to += count - 1;
        }
        while (count-- > 0) {
          if (from in O) O[to] = O[from];else delete O[to];
          to += inc;
          from += inc;
        }
        return O;
      };

      /***/ }),
    /* 89 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(90);
      module.exports = __w_pdfjs_require__(5).Number.isNaN;

      /***/ }),
    /* 90 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(4);
      $export($export.S, "Number", {
        isNaN: function isNaN(number) {
          return number != number;
        }
      });

      /***/ }),
    /* 91 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(92);
      module.exports = __w_pdfjs_require__(5).Number.isInteger;

      /***/ }),
    /* 92 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(4);
      $export($export.S, "Number", { isInteger: __w_pdfjs_require__(93) });

      /***/ }),
    /* 93 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      var floor = Math.floor;
      module.exports = function isInteger(it) {
        return !isObject(it) && isFinite(it) && floor(it) === it;
      };

      /***/ }),
    /* 94 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(63);
      __w_pdfjs_require__(95);
      __w_pdfjs_require__(64);
      __w_pdfjs_require__(97);
      __w_pdfjs_require__(101);
      __w_pdfjs_require__(102);
      module.exports = __w_pdfjs_require__(5).Promise;

      /***/ }),
    /* 95 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $at = __w_pdfjs_require__(96)(true);
      __w_pdfjs_require__(59)(String, "String", function (iterated) {
        this._t = String(iterated);
        this._i = 0;
      }, function () {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
          value: undefined,
          done: true
        };
        point = $at(O, index);
        this._i += point.length;
        return {
          value: point,
          done: false
        };
      });

      /***/ }),
    /* 96 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(17);
      var defined = __w_pdfjs_require__(35);
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/ }),
    /* 97 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var LIBRARY = __w_pdfjs_require__(26);
      var global = __w_pdfjs_require__(1);
      var ctx = __w_pdfjs_require__(11);
      var classof = __w_pdfjs_require__(30);
      var $export = __w_pdfjs_require__(4);
      var isObject = __w_pdfjs_require__(2);
      var aFunction = __w_pdfjs_require__(21);
      var anInstance = __w_pdfjs_require__(23);
      var forOf = __w_pdfjs_require__(31);
      var speciesConstructor = __w_pdfjs_require__(40);
      var task = __w_pdfjs_require__(65).set;
      var microtask = __w_pdfjs_require__(100)();
      var newPromiseCapabilityModule = __w_pdfjs_require__(42);
      var perform = __w_pdfjs_require__(66);
      var promiseResolve = __w_pdfjs_require__(67);
      var PROMISE = "Promise";
      var TypeError = global.TypeError;
      var process = global.process;
      var $Promise = global[PROMISE];
      var isNode = classof(process) == "process";
      var empty = function empty() {};
      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
      var USE_NATIVE = !!function () {
        try {
          var promise = $Promise.resolve(1);
          var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(3)("species")] = function (exec) {
            exec(empty, empty);
          };
          return (isNode || typeof PromiseRejectionEvent === "function") && promise.then(empty) instanceof FakePromise;
        } catch (e) {}
      }();
      var isThenable = function isThenable(it) {
        var then;
        return isObject(it) && typeof (then = it.then) === "function" ? then : false;
      };
      var notify = function notify(promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function run(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;else {
                  if (domain) domain.enter();
                  result = handler(value);
                  if (domain) domain.exit();
                }
                if (result === reaction.promise) {
                  reject(TypeError("Promise-chain cycle"));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              reject(e);
            }
          };
          while (chain.length > i) {
            run(chain[i++]);
          }promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function onUnhandled(promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;
          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit("unhandledRejection", value, promise);
              } else if (handler = global.onunhandledrejection) {
                handler({
                  promise: promise,
                  reason: value
                });
              } else if ((console = global.console) && console.error) {
                console.error("Unhandled promise rejection", value);
              }
            });
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function isUnhandled(promise) {
        if (promise._h == 1) return false;
        var chain = promise._a || promise._c;
        var i = 0;
        var reaction;
        while (chain.length > i) {
          reaction = chain[i++];
          if (reaction.fail || !isUnhandled(reaction.promise)) return false;
        }
        return true;
      };
      var onHandleUnhandled = function onHandleUnhandled(promise) {
        task.call(global, function () {
          var handler;
          if (isNode) {
            process.emit("rejectionHandled", promise);
          } else if (handler = global.onrejectionhandled) {
            handler({
              promise: promise,
              reason: promise._v
            });
          }
        });
      };
      var $reject = function $reject(value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function $resolve(value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");
          if (then = isThenable(value)) {
            microtask(function () {
              var wrapper = {
                _w: promise,
                _d: false
              };
              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({
            _w: promise,
            _d: false
          }, e);
        }
      };
      if (!USE_NATIVE) {
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, "_h");
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        Internal = function Promise(executor) {
          this._c = [];
          this._a = undefined;
          this._s = 0;
          this._d = false;
          this._v = undefined;
          this._h = 0;
          this._n = false;
        };
        Internal.prototype = __w_pdfjs_require__(22)($Promise.prototype, {
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled === "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected === "function" && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          "catch": function _catch(onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function OwnPromiseCapability() {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
      __w_pdfjs_require__(25)($Promise, PROMISE);
      __w_pdfjs_require__(60)(PROMISE);
      Wrapper = __w_pdfjs_require__(5)[PROMISE];
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(41)(function (iter) {
        $Promise.all(iter)["catch"](empty);
      })), PROMISE, {
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var values = [];
            var index = 0;
            var remaining = 1;
            forOf(iterable, false, function (promise) {
              var $index = index++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              C.resolve(promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[$index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.e) reject(result.v);
          return capability.promise;
        },
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function () {
            forOf(iterable, false, function (promise) {
              C.resolve(promise).then(capability.resolve, reject);
            });
          });
          if (result.e) reject(result.v);
          return capability.promise;
        }
      });

      /***/ }),
    /* 98 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(7);
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (e) {
          var ret = iterator["return"];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/ }),
    /* 99 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (fn, args, that) {
        var un = that === undefined;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };

      /***/ }),
    /* 100 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var macrotask = __w_pdfjs_require__(65).set;
      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __w_pdfjs_require__(24)(process) == "process";
      module.exports = function () {
        var head, last, notify;
        var flush = function flush() {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();else last = undefined;
              throw e;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };
        if (isNode) {
          notify = function notify() {
            process.nextTick(flush);
          };
        } else if (Observer) {
          var toggle = true;
          var node = document.createTextNode("");
          new Observer(flush).observe(node, { characterData: true });
          notify = function notify() {
            node.data = toggle = !toggle;
          };
        } else if (Promise && Promise.resolve) {
          var promise = Promise.resolve();
          notify = function notify() {
            promise.then(flush);
          };
        } else {
          notify = function notify() {
            macrotask.call(global, flush);
          };
        }
        return function (fn) {
          var task = {
            fn: fn,
            next: undefined
          };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };

      /***/ }),
    /* 101 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(4);
      var core = __w_pdfjs_require__(5);
      var global = __w_pdfjs_require__(1);
      var speciesConstructor = __w_pdfjs_require__(40);
      var promiseResolve = __w_pdfjs_require__(67);
      $export($export.P + $export.R, "Promise", {
        "finally": function _finally(onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally === "function";
          return this.then(isFunction ? function (x) {
            return promiseResolve(C, onFinally()).then(function () {
              return x;
            });
          } : onFinally, isFunction ? function (e) {
            return promiseResolve(C, onFinally()).then(function () {
              throw e;
            });
          } : onFinally);
        }
      });

      /***/ }),
    /* 102 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(4);
      var newPromiseCapability = __w_pdfjs_require__(42);
      var perform = __w_pdfjs_require__(66);
      $export($export.S, "Promise", {
        "try": function _try(callbackfn) {
          var promiseCapability = newPromiseCapability.f(this);
          var result = perform(callbackfn);
          (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
          return promiseCapability.promise;
        }
      });

      /***/ }),
    /* 103 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(63);
      __w_pdfjs_require__(64);
      __w_pdfjs_require__(104);
      __w_pdfjs_require__(111);
      __w_pdfjs_require__(113);
      module.exports = __w_pdfjs_require__(5).WeakMap;

      /***/ }),
    /* 104 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var each = __w_pdfjs_require__(39)(0);
      var redefine = __w_pdfjs_require__(15);
      var meta = __w_pdfjs_require__(43);
      var assign = __w_pdfjs_require__(105);
      var weak = __w_pdfjs_require__(107);
      var isObject = __w_pdfjs_require__(2);
      var fails = __w_pdfjs_require__(10);
      var validate = __w_pdfjs_require__(68);
      var WEAK_MAP = "WeakMap";
      var getWeak = meta.getWeak;
      var isExtensible = Object.isExtensible;
      var uncaughtFrozenStore = weak.ufstore;
      var tmp = {};
      var InternalMap;
      var wrapper = function wrapper(get) {
        return function WeakMap() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      };
      var methods = {
        get: function get(key) {
          if (isObject(key)) {
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
          }
        },
        set: function set(key, value) {
          return weak.def(validate(this, WEAK_MAP), key, value);
        }
      };
      var $WeakMap = module.exports = __w_pdfjs_require__(108)(WEAK_MAP, wrapper, methods, weak, true, true);
      if (fails(function () {
        return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
      })) {
        InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
        assign(InternalMap.prototype, methods);
        meta.NEED = true;
        each(["delete", "has", "get", "set"], function (key) {
          var proto = $WeakMap.prototype;
          var method = proto[key];
          redefine(proto, key, function (a, b) {
            if (isObject(a) && !isExtensible(a)) {
              if (!this._f) this._f = new InternalMap();
              var result = this._f[key](a, b);
              return key == "set" ? this : result;
            }
            return method.call(this, a, b);
          });
        });
      }

      /***/ }),
    /* 105 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var getKeys = __w_pdfjs_require__(38);
      var gOPS = __w_pdfjs_require__(106);
      var pIE = __w_pdfjs_require__(62);
      var toObject = __w_pdfjs_require__(18);
      var IObject = __w_pdfjs_require__(34);
      var $assign = Object.assign;
      module.exports = !$assign || __w_pdfjs_require__(10)(function () {
        var A = {};
        var B = {};
        var S = Symbol();
        var K = "abcdefghijklmnopqrst";
        A[S] = 7;
        K.split("").forEach(function (k) {
          B[k] = k;
        });
        return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
      }) ? function assign(target, source) {
          var T = toObject(target);
          var aLen = arguments.length;
          var index = 1;
          var getSymbols = gOPS.f;
          var isEnum = pIE.f;
          while (aLen > index) {
            var S = IObject(arguments[index++]);
            var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
            var length = keys.length;
            var j = 0;
            var key;
            while (length > j) {
              if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
            }
          }
          return T;
        } : $assign;

      /***/ }),
    /* 106 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      exports.f = Object.getOwnPropertySymbols;

      /***/ }),
    /* 107 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var redefineAll = __w_pdfjs_require__(22);
      var getWeak = __w_pdfjs_require__(43).getWeak;
      var anObject = __w_pdfjs_require__(7);
      var isObject = __w_pdfjs_require__(2);
      var anInstance = __w_pdfjs_require__(23);
      var forOf = __w_pdfjs_require__(31);
      var createArrayMethod = __w_pdfjs_require__(39);
      var $has = __w_pdfjs_require__(8);
      var validate = __w_pdfjs_require__(68);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var id = 0;
      var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
        return that._l || (that._l = new UncaughtFrozenStore());
      };
      var UncaughtFrozenStore = function UncaughtFrozenStore() {
        this.a = [];
      };
      var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
        return arrayFind(store.a, function (it) {
          return it[0] === key;
        });
      };
      UncaughtFrozenStore.prototype = {
        get: function get(key) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) return entry[1];
        },
        has: function has(key) {
          return !!findUncaughtFrozen(this, key);
        },
        set: function set(key, value) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) entry[1] = value;else this.a.push([key, value]);
        },
        "delete": function _delete(key) {
          var index = arrayFindIndex(this.a, function (it) {
            return it[0] === key;
          });
          if (~index) this.a.splice(index, 1);
          return !!~index;
        }
      };
      module.exports = {
        getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, "_i");
            that._t = NAME;
            that._i = id++;
            that._l = undefined;
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            "delete": function _delete(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME))["delete"](key);
              return data && $has(data, this._i) && delete data[this._i];
            },
            has: function has(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
              return data && $has(data, this._i);
            }
          });
          return C;
        },
        def: function def(that, key, value) {
          var data = getWeak(anObject(key), true);
          if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
          return that;
        },
        ufstore: uncaughtFrozenStore
      };

      /***/ }),
    /* 108 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var $export = __w_pdfjs_require__(4);
      var redefine = __w_pdfjs_require__(15);
      var redefineAll = __w_pdfjs_require__(22);
      var meta = __w_pdfjs_require__(43);
      var forOf = __w_pdfjs_require__(31);
      var anInstance = __w_pdfjs_require__(23);
      var isObject = __w_pdfjs_require__(2);
      var fails = __w_pdfjs_require__(10);
      var $iterDetect = __w_pdfjs_require__(41);
      var setToStringTag = __w_pdfjs_require__(25);
      var inheritIfRequired = __w_pdfjs_require__(109);
      module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
        var Base = global[NAME];
        var C = Base;
        var ADDER = IS_MAP ? "set" : "add";
        var proto = C && C.prototype;
        var O = {};
        var fixMethod = function fixMethod(KEY) {
          var fn = proto[KEY];
          redefine(proto, KEY, KEY == "delete" ? function (a) {
            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
          } : KEY == "has" ? function has(a) {
            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
          } : KEY == "get" ? function get(a) {
            return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
          } : KEY == "add" ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
          } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
          });
        };
        if (typeof C !== "function" || !(IS_WEAK || proto.forEach && !fails(function () {
          new C().entries().next();
        }))) {
          C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
          redefineAll(C.prototype, methods);
          meta.NEED = true;
        } else {
          var instance = new C();
          var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          var THROWS_ON_PRIMITIVES = fails(function () {
            instance.has(1);
          });
          var ACCEPT_ITERABLES = $iterDetect(function (iter) {
            new C(iter);
          });
          var BUGGY_ZERO = !IS_WEAK && fails(function () {
            var $instance = new C();
            var index = 5;
            while (index--) {
              $instance[ADDER](index, index);
            } return !$instance.has(-0);
          });
          if (!ACCEPT_ITERABLES) {
            C = wrapper(function (target, iterable) {
              anInstance(target, C, NAME);
              var that = inheritIfRequired(new Base(), target, C);
              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
              return that;
            });
            C.prototype = proto;
            proto.constructor = C;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
          }
          if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
          if (IS_WEAK && proto.clear) delete proto.clear;
        }
        setToStringTag(C, NAME);
        O[NAME] = C;
        $export($export.G + $export.W + $export.F * (C != Base), O);
        if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
        return C;
      };

      /***/ }),
    /* 109 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      var setPrototypeOf = __w_pdfjs_require__(110).set;
      module.exports = function (that, target, C) {
        var S = target.constructor;
        var P;
        if (S !== C && typeof S === "function" && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
          setPrototypeOf(that, P);
        }
        return that;
      };

      /***/ }),
    /* 110 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(2);
      var anObject = __w_pdfjs_require__(7);
      var check = function check(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };
      module.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (test, buggy, set) {
          try {
            set = __w_pdfjs_require__(11)(Function.call, __w_pdfjs_require__(61).f(Object.prototype, "__proto__").set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
          } catch (e) {
            buggy = true;
          }
          return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;else set(O, proto);
            return O;
          };
        }({}, false) : undefined),
        check: check
      };

      /***/ }),
    /* 111 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(112)("WeakMap");

      /***/ }),
    /* 112 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(4);
      module.exports = function (COLLECTION) {
        $export($export.S, COLLECTION, {
          of: function of() {
            var length = arguments.length;
            var A = Array(length);
            while (length--) {
              A[length] = arguments[length];
            } return new this(A);
          }
        });
      };

      /***/ }),
    /* 113 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(114)("WeakMap");

      /***/ }),
    /* 114 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(4);
      var aFunction = __w_pdfjs_require__(21);
      var ctx = __w_pdfjs_require__(11);
      var forOf = __w_pdfjs_require__(31);
      module.exports = function (COLLECTION) {
        $export($export.S, COLLECTION, {
          from: function from(source) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            aFunction(this);
            mapping = mapFn !== undefined;
            if (mapping) aFunction(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
              n = 0;
              cb = ctx(mapFn, arguments[2], 2);
              forOf(source, false, function (nextItem) {
                A.push(cb(nextItem, n++));
              });
            } else {
              forOf(source, false, A.push, A);
            }
            return new this(A);
          }
        });
      };

      /***/ }),
    /* 115 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isReadableStreamSupported = false;
      if (typeof ReadableStream !== "undefined") {
        try {
          new ReadableStream({
            start: function start(controller) {
              controller.close();
            }
          });
          isReadableStreamSupported = true;
        } catch (e) {}
      }
      if (isReadableStreamSupported) {
        exports.ReadableStream = ReadableStream;
      } else {
        exports.ReadableStream = __w_pdfjs_require__(116).ReadableStream;
      }

      /***/ }),
    /* 116 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      (function (e, a) {
        for (var i in a) {
          e[i] = a[i];
        }
      })(exports, function (modules) {
        var installedModules = {};
        function __w_pdfjs_require__(moduleId) {
          if (installedModules[moduleId]) return installedModules[moduleId].exports;
          var module = installedModules[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
          };
          modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
          module.l = true;
          return module.exports;
        }
        __w_pdfjs_require__.m = modules;
        __w_pdfjs_require__.c = installedModules;
        __w_pdfjs_require__.i = function (value) {
          return value;
        };
        __w_pdfjs_require__.d = function (exports, name, getter) {
          if (!__w_pdfjs_require__.o(exports, name)) {
            Object.defineProperty(exports, name, {
              configurable: false,
              enumerable: true,
              get: getter
            });
          }
        };
        __w_pdfjs_require__.n = function (module) {
          var getter = module && module.__esModule ? function getDefault() {
            return module["default"];
          } : function getModuleExports() {
            return module;
          };
          __w_pdfjs_require__.d(getter, "a", getter);
          return getter;
        };
        __w_pdfjs_require__.o = function (object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        __w_pdfjs_require__.p = "";
        return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
      }([function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
          return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
        };
        var _require = __w_pdfjs_require__(1),
          assert = _require.assert;
        function IsPropertyKey(argument) {
          return typeof argument === "string" || (typeof argument === "undefined" ? "undefined" : _typeof(argument)) === "symbol";
        }
        exports.typeIsObject = function (x) {
          return (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object" && x !== null || typeof x === "function";
        };
        exports.createDataProperty = function (o, p, v) {
          assert(exports.typeIsObject(o));
          Object.defineProperty(o, p, {
            value: v,
            writable: true,
            enumerable: true,
            configurable: true
          });
        };
        exports.createArrayFromList = function (elements) {
          return elements.slice();
        };
        exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
          new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
        };
        exports.CreateIterResultObject = function (value, done) {
          assert(typeof done === "boolean");
          var obj = {};
          Object.defineProperty(obj, "value", {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
          });
          Object.defineProperty(obj, "done", {
            value: done,
            enumerable: true,
            writable: true,
            configurable: true
          });
          return obj;
        };
        exports.IsFiniteNonNegativeNumber = function (v) {
          if (Number.isNaN(v)) {
            return false;
          }
          if (v === Infinity) {
            return false;
          }
          if (v < 0) {
            return false;
          }
          return true;
        };
        function Call(F, V, args) {
          if (typeof F !== "function") {
            throw new TypeError("Argument is not a function");
          }
          return Function.prototype.apply.call(F, V, args);
        }
        exports.InvokeOrNoop = function (O, P, args) {
          assert(O !== undefined);
          assert(IsPropertyKey(P));
          assert(Array.isArray(args));
          var method = O[P];
          if (method === undefined) {
            return undefined;
          }
          return Call(method, O, args);
        };
        exports.PromiseInvokeOrNoop = function (O, P, args) {
          assert(O !== undefined);
          assert(IsPropertyKey(P));
          assert(Array.isArray(args));
          try {
            return Promise.resolve(exports.InvokeOrNoop(O, P, args));
          } catch (returnValueE) {
            return Promise.reject(returnValueE);
          }
        };
        exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
          assert(O !== undefined);
          assert(IsPropertyKey(P));
          assert(Array.isArray(args));
          assert(Array.isArray(argsF));
          var method = void 0;
          try {
            method = O[P];
          } catch (methodE) {
            return Promise.reject(methodE);
          }
          if (method === undefined) {
            return F.apply(null, argsF);
          }
          try {
            return Promise.resolve(Call(method, O, args));
          } catch (e) {
            return Promise.reject(e);
          }
        };
        exports.TransferArrayBuffer = function (O) {
          return O.slice();
        };
        exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
          highWaterMark = Number(highWaterMark);
          if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
            throw new RangeError("highWaterMark property of a queuing strategy must be non-negative and non-NaN");
          }
          return highWaterMark;
        };
        exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
          if (size !== undefined && typeof size !== "function") {
            throw new TypeError("size property of a queuing strategy must be a function");
          }
          highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
          return {
            size: size,
            highWaterMark: highWaterMark
          };
        };
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        function rethrowAssertionErrorRejection(e) {
          if (e && e.constructor === AssertionError) {
            setTimeout(function () {
              throw e;
            }, 0);
          }
        }
        function AssertionError(message) {
          this.name = "AssertionError";
          this.message = message || "";
          this.stack = new Error().stack;
        }
        AssertionError.prototype = Object.create(Error.prototype);
        AssertionError.prototype.constructor = AssertionError;
        function assert(value, message) {
          if (!value) {
            throw new AssertionError(message);
          }
        }
        module.exports = {
          rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
          AssertionError: AssertionError,
          assert: assert
        };
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var _require = __w_pdfjs_require__(0),
          InvokeOrNoop = _require.InvokeOrNoop,
          PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
          ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
          typeIsObject = _require.typeIsObject;
        var _require2 = __w_pdfjs_require__(1),
          assert = _require2.assert,
          rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
        var _require3 = __w_pdfjs_require__(3),
          DequeueValue = _require3.DequeueValue,
          EnqueueValueWithSize = _require3.EnqueueValueWithSize,
          PeekQueueValue = _require3.PeekQueueValue,
          ResetQueue = _require3.ResetQueue;
        var WritableStream = function () {
          function WritableStream() {
            var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              size = _ref.size,
              _ref$highWaterMark = _ref.highWaterMark,
              highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
            _classCallCheck(this, WritableStream);
            this._state = "writable";
            this._storedError = undefined;
            this._writer = undefined;
            this._writableStreamController = undefined;
            this._writeRequests = [];
            this._inFlightWriteRequest = undefined;
            this._closeRequest = undefined;
            this._inFlightCloseRequest = undefined;
            this._pendingAbortRequest = undefined;
            this._backpressure = false;
            var type = underlyingSink.type;
            if (type !== undefined) {
              throw new RangeError("Invalid type is specified");
            }
            this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
            this._writableStreamController.__startSteps();
          }
          _createClass(WritableStream, [{
            key: "abort",
            value: function abort(reason) {
              if (IsWritableStream(this) === false) {
                return Promise.reject(streamBrandCheckException("abort"));
              }
              if (IsWritableStreamLocked(this) === true) {
                return Promise.reject(new TypeError("Cannot abort a stream that already has a writer"));
              }
              return WritableStreamAbort(this, reason);
            }
          }, {
            key: "getWriter",
            value: function getWriter() {
              if (IsWritableStream(this) === false) {
                throw streamBrandCheckException("getWriter");
              }
              return AcquireWritableStreamDefaultWriter(this);
            }
          }, {
            key: "locked",
            get: function get() {
              if (IsWritableStream(this) === false) {
                throw streamBrandCheckException("locked");
              }
              return IsWritableStreamLocked(this);
            }
          }]);
          return WritableStream;
        }();
        module.exports = {
          AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
          IsWritableStream: IsWritableStream,
          IsWritableStreamLocked: IsWritableStreamLocked,
          WritableStream: WritableStream,
          WritableStreamAbort: WritableStreamAbort,
          WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
          WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
          WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
          WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
          WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
        };
        function AcquireWritableStreamDefaultWriter(stream) {
          return new WritableStreamDefaultWriter(stream);
        }
        function IsWritableStream(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_writableStreamController")) {
            return false;
          }
          return true;
        }
        function IsWritableStreamLocked(stream) {
          assert(IsWritableStream(stream) === true, "IsWritableStreamLocked should only be used on known writable streams");
          if (stream._writer === undefined) {
            return false;
          }
          return true;
        }
        function WritableStreamAbort(stream, reason) {
          var state = stream._state;
          if (state === "closed") {
            return Promise.resolve(undefined);
          }
          if (state === "errored") {
            return Promise.reject(stream._storedError);
          }
          var error = new TypeError("Requested to abort");
          if (stream._pendingAbortRequest !== undefined) {
            return Promise.reject(error);
          }
          assert(state === "writable" || state === "erroring", "state must be writable or erroring");
          var wasAlreadyErroring = false;
          if (state === "erroring") {
            wasAlreadyErroring = true;
            reason = undefined;
          }
          var promise = new Promise(function (resolve, reject) {
            stream._pendingAbortRequest = {
              _resolve: resolve,
              _reject: reject,
              _reason: reason,
              _wasAlreadyErroring: wasAlreadyErroring
            };
          });
          if (wasAlreadyErroring === false) {
            WritableStreamStartErroring(stream, error);
          }
          return promise;
        }
        function WritableStreamAddWriteRequest(stream) {
          assert(IsWritableStreamLocked(stream) === true);
          assert(stream._state === "writable");
          var promise = new Promise(function (resolve, reject) {
            var writeRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._writeRequests.push(writeRequest);
          });
          return promise;
        }
        function WritableStreamDealWithRejection(stream, error) {
          var state = stream._state;
          if (state === "writable") {
            WritableStreamStartErroring(stream, error);
            return;
          }
          assert(state === "erroring");
          WritableStreamFinishErroring(stream);
        }
        function WritableStreamStartErroring(stream, reason) {
          assert(stream._storedError === undefined, "stream._storedError === undefined");
          assert(stream._state === "writable", "state must be writable");
          var controller = stream._writableStreamController;
          assert(controller !== undefined, "controller must not be undefined");
          stream._state = "erroring";
          stream._storedError = reason;
          var writer = stream._writer;
          if (writer !== undefined) {
            WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
          }
          if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
            WritableStreamFinishErroring(stream);
          }
        }
        function WritableStreamFinishErroring(stream) {
          assert(stream._state === "erroring", "stream._state === erroring");
          assert(WritableStreamHasOperationMarkedInFlight(stream) === false, "WritableStreamHasOperationMarkedInFlight(stream) === false");
          stream._state = "errored";
          stream._writableStreamController.__errorSteps();
          var storedError = stream._storedError;
          for (var i = 0; i < stream._writeRequests.length; i++) {
            var writeRequest = stream._writeRequests[i];
            writeRequest._reject(storedError);
          }
          stream._writeRequests = [];
          if (stream._pendingAbortRequest === undefined) {
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
            return;
          }
          var abortRequest = stream._pendingAbortRequest;
          stream._pendingAbortRequest = undefined;
          if (abortRequest._wasAlreadyErroring === true) {
            abortRequest._reject(storedError);
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
            return;
          }
          var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
          promise.then(function () {
            abortRequest._resolve();
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
          }, function (reason) {
            abortRequest._reject(reason);
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
          });
        }
        function WritableStreamFinishInFlightWrite(stream) {
          assert(stream._inFlightWriteRequest !== undefined);
          stream._inFlightWriteRequest._resolve(undefined);
          stream._inFlightWriteRequest = undefined;
        }
        function WritableStreamFinishInFlightWriteWithError(stream, error) {
          assert(stream._inFlightWriteRequest !== undefined);
          stream._inFlightWriteRequest._reject(error);
          stream._inFlightWriteRequest = undefined;
          assert(stream._state === "writable" || stream._state === "erroring");
          WritableStreamDealWithRejection(stream, error);
        }
        function WritableStreamFinishInFlightClose(stream) {
          assert(stream._inFlightCloseRequest !== undefined);
          stream._inFlightCloseRequest._resolve(undefined);
          stream._inFlightCloseRequest = undefined;
          var state = stream._state;
          assert(state === "writable" || state === "erroring");
          if (state === "erroring") {
            stream._storedError = undefined;
            if (stream._pendingAbortRequest !== undefined) {
              stream._pendingAbortRequest._resolve();
              stream._pendingAbortRequest = undefined;
            }
          }
          stream._state = "closed";
          var writer = stream._writer;
          if (writer !== undefined) {
            defaultWriterClosedPromiseResolve(writer);
          }
          assert(stream._pendingAbortRequest === undefined, "stream._pendingAbortRequest === undefined");
          assert(stream._storedError === undefined, "stream._storedError === undefined");
        }
        function WritableStreamFinishInFlightCloseWithError(stream, error) {
          assert(stream._inFlightCloseRequest !== undefined);
          stream._inFlightCloseRequest._reject(error);
          stream._inFlightCloseRequest = undefined;
          assert(stream._state === "writable" || stream._state === "erroring");
          if (stream._pendingAbortRequest !== undefined) {
            stream._pendingAbortRequest._reject(error);
            stream._pendingAbortRequest = undefined;
          }
          WritableStreamDealWithRejection(stream, error);
        }
        function WritableStreamCloseQueuedOrInFlight(stream) {
          if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
            return false;
          }
          return true;
        }
        function WritableStreamHasOperationMarkedInFlight(stream) {
          if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
            return false;
          }
          return true;
        }
        function WritableStreamMarkCloseRequestInFlight(stream) {
          assert(stream._inFlightCloseRequest === undefined);
          assert(stream._closeRequest !== undefined);
          stream._inFlightCloseRequest = stream._closeRequest;
          stream._closeRequest = undefined;
        }
        function WritableStreamMarkFirstWriteRequestInFlight(stream) {
          assert(stream._inFlightWriteRequest === undefined, "there must be no pending write request");
          assert(stream._writeRequests.length !== 0, "writeRequests must not be empty");
          stream._inFlightWriteRequest = stream._writeRequests.shift();
        }
        function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
          assert(stream._state === "errored", "_stream_.[[state]] is `\"errored\"`");
          if (stream._closeRequest !== undefined) {
            assert(stream._inFlightCloseRequest === undefined);
            stream._closeRequest._reject(stream._storedError);
            stream._closeRequest = undefined;
          }
          var writer = stream._writer;
          if (writer !== undefined) {
            defaultWriterClosedPromiseReject(writer, stream._storedError);
            writer._closedPromise.catch(function () {});
          }
        }
        function WritableStreamUpdateBackpressure(stream, backpressure) {
          assert(stream._state === "writable");
          assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
          var writer = stream._writer;
          if (writer !== undefined && backpressure !== stream._backpressure) {
            if (backpressure === true) {
              defaultWriterReadyPromiseReset(writer);
            } else {
              assert(backpressure === false);
              defaultWriterReadyPromiseResolve(writer);
            }
          }
          stream._backpressure = backpressure;
        }
        var WritableStreamDefaultWriter = function () {
          function WritableStreamDefaultWriter(stream) {
            _classCallCheck(this, WritableStreamDefaultWriter);
            if (IsWritableStream(stream) === false) {
              throw new TypeError("WritableStreamDefaultWriter can only be constructed with a WritableStream instance");
            }
            if (IsWritableStreamLocked(stream) === true) {
              throw new TypeError("This stream has already been locked for exclusive writing by another writer");
            }
            this._ownerWritableStream = stream;
            stream._writer = this;
            var state = stream._state;
            if (state === "writable") {
              if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
                defaultWriterReadyPromiseInitialize(this);
              } else {
                defaultWriterReadyPromiseInitializeAsResolved(this);
              }
              defaultWriterClosedPromiseInitialize(this);
            } else if (state === "erroring") {
              defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
              this._readyPromise.catch(function () {});
              defaultWriterClosedPromiseInitialize(this);
            } else if (state === "closed") {
              defaultWriterReadyPromiseInitializeAsResolved(this);
              defaultWriterClosedPromiseInitializeAsResolved(this);
            } else {
              assert(state === "errored", "state must be errored");
              var storedError = stream._storedError;
              defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
              this._readyPromise.catch(function () {});
              defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
              this._closedPromise.catch(function () {});
            }
          }
          _createClass(WritableStreamDefaultWriter, [{
            key: "abort",
            value: function abort(reason) {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("abort"));
              }
              if (this._ownerWritableStream === undefined) {
                return Promise.reject(defaultWriterLockException("abort"));
              }
              return WritableStreamDefaultWriterAbort(this, reason);
            }
          }, {
            key: "close",
            value: function close() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("close"));
              }
              var stream = this._ownerWritableStream;
              if (stream === undefined) {
                return Promise.reject(defaultWriterLockException("close"));
              }
              if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
                return Promise.reject(new TypeError("cannot close an already-closing stream"));
              }
              return WritableStreamDefaultWriterClose(this);
            }
          }, {
            key: "releaseLock",
            value: function releaseLock() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                throw defaultWriterBrandCheckException("releaseLock");
              }
              var stream = this._ownerWritableStream;
              if (stream === undefined) {
                return;
              }
              assert(stream._writer !== undefined);
              WritableStreamDefaultWriterRelease(this);
            }
          }, {
            key: "write",
            value: function write(chunk) {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("write"));
              }
              if (this._ownerWritableStream === undefined) {
                return Promise.reject(defaultWriterLockException("write to"));
              }
              return WritableStreamDefaultWriterWrite(this, chunk);
            }
          }, {
            key: "closed",
            get: function get() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("closed"));
              }
              return this._closedPromise;
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                throw defaultWriterBrandCheckException("desiredSize");
              }
              if (this._ownerWritableStream === undefined) {
                throw defaultWriterLockException("desiredSize");
              }
              return WritableStreamDefaultWriterGetDesiredSize(this);
            }
          }, {
            key: "ready",
            get: function get() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("ready"));
              }
              return this._readyPromise;
            }
          }]);
          return WritableStreamDefaultWriter;
        }();
        function IsWritableStreamDefaultWriter(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_ownerWritableStream")) {
            return false;
          }
          return true;
        }
        function WritableStreamDefaultWriterAbort(writer, reason) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          return WritableStreamAbort(stream, reason);
        }
        function WritableStreamDefaultWriterClose(writer) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          var state = stream._state;
          if (state === "closed" || state === "errored") {
            return Promise.reject(new TypeError("The stream (in " + state + " state) is not in the writable state and cannot be closed"));
          }
          assert(state === "writable" || state === "erroring");
          assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
          var promise = new Promise(function (resolve, reject) {
            var closeRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._closeRequest = closeRequest;
          });
          if (stream._backpressure === true && state === "writable") {
            defaultWriterReadyPromiseResolve(writer);
          }
          WritableStreamDefaultControllerClose(stream._writableStreamController);
          return promise;
        }
        function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          var state = stream._state;
          if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === "closed") {
            return Promise.resolve();
          }
          if (state === "errored") {
            return Promise.reject(stream._storedError);
          }
          assert(state === "writable" || state === "erroring");
          return WritableStreamDefaultWriterClose(writer);
        }
        function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
          if (writer._closedPromiseState === "pending") {
            defaultWriterClosedPromiseReject(writer, error);
          } else {
            defaultWriterClosedPromiseResetToRejected(writer, error);
          }
          writer._closedPromise.catch(function () {});
        }
        function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
          if (writer._readyPromiseState === "pending") {
            defaultWriterReadyPromiseReject(writer, error);
          } else {
            defaultWriterReadyPromiseResetToRejected(writer, error);
          }
          writer._readyPromise.catch(function () {});
        }
        function WritableStreamDefaultWriterGetDesiredSize(writer) {
          var stream = writer._ownerWritableStream;
          var state = stream._state;
          if (state === "errored" || state === "erroring") {
            return null;
          }
          if (state === "closed") {
            return 0;
          }
          return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
        }
        function WritableStreamDefaultWriterRelease(writer) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          assert(stream._writer === writer);
          var releasedError = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
          WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
          WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
          stream._writer = undefined;
          writer._ownerWritableStream = undefined;
        }
        function WritableStreamDefaultWriterWrite(writer, chunk) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          var controller = stream._writableStreamController;
          var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
          if (stream !== writer._ownerWritableStream) {
            return Promise.reject(defaultWriterLockException("write to"));
          }
          var state = stream._state;
          if (state === "errored") {
            return Promise.reject(stream._storedError);
          }
          if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === "closed") {
            return Promise.reject(new TypeError("The stream is closing or closed and cannot be written to"));
          }
          if (state === "erroring") {
            return Promise.reject(stream._storedError);
          }
          assert(state === "writable");
          var promise = WritableStreamAddWriteRequest(stream);
          WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
          return promise;
        }
        var WritableStreamDefaultController = function () {
          function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
            _classCallCheck(this, WritableStreamDefaultController);
            if (IsWritableStream(stream) === false) {
              throw new TypeError("WritableStreamDefaultController can only be constructed with a WritableStream instance");
            }
            if (stream._writableStreamController !== undefined) {
              throw new TypeError("WritableStreamDefaultController instances can only be created by the WritableStream constructor");
            }
            this._controlledWritableStream = stream;
            this._underlyingSink = underlyingSink;
            this._queue = undefined;
            this._queueTotalSize = undefined;
            ResetQueue(this);
            this._started = false;
            var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
            this._strategySize = normalizedStrategy.size;
            this._strategyHWM = normalizedStrategy.highWaterMark;
            var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
            WritableStreamUpdateBackpressure(stream, backpressure);
          }
          _createClass(WritableStreamDefaultController, [{
            key: "error",
            value: function error(e) {
              if (IsWritableStreamDefaultController(this) === false) {
                throw new TypeError("WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController");
              }
              var state = this._controlledWritableStream._state;
              if (state !== "writable") {
                return;
              }
              WritableStreamDefaultControllerError(this, e);
            }
          }, {
            key: "__abortSteps",
            value: function __abortSteps(reason) {
              return PromiseInvokeOrNoop(this._underlyingSink, "abort", [reason]);
            }
          }, {
            key: "__errorSteps",
            value: function __errorSteps() {
              ResetQueue(this);
            }
          }, {
            key: "__startSteps",
            value: function __startSteps() {
              var _this = this;
              var startResult = InvokeOrNoop(this._underlyingSink, "start", [this]);
              var stream = this._controlledWritableStream;
              Promise.resolve(startResult).then(function () {
                assert(stream._state === "writable" || stream._state === "erroring");
                _this._started = true;
                WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
              }, function (r) {
                assert(stream._state === "writable" || stream._state === "erroring");
                _this._started = true;
                WritableStreamDealWithRejection(stream, r);
              }).catch(rethrowAssertionErrorRejection);
            }
          }]);
          return WritableStreamDefaultController;
        }();
        function WritableStreamDefaultControllerClose(controller) {
          EnqueueValueWithSize(controller, "close", 0);
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
        }
        function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
          var strategySize = controller._strategySize;
          if (strategySize === undefined) {
            return 1;
          }
          try {
            return strategySize(chunk);
          } catch (chunkSizeE) {
            WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
            return 1;
          }
        }
        function WritableStreamDefaultControllerGetDesiredSize(controller) {
          return controller._strategyHWM - controller._queueTotalSize;
        }
        function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
          var writeRecord = { chunk: chunk };
          try {
            EnqueueValueWithSize(controller, writeRecord, chunkSize);
          } catch (enqueueE) {
            WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
            return;
          }
          var stream = controller._controlledWritableStream;
          if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === "writable") {
            var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
            WritableStreamUpdateBackpressure(stream, backpressure);
          }
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
        }
        function IsWritableStreamDefaultController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_underlyingSink")) {
            return false;
          }
          return true;
        }
        function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
          var stream = controller._controlledWritableStream;
          if (controller._started === false) {
            return;
          }
          if (stream._inFlightWriteRequest !== undefined) {
            return;
          }
          var state = stream._state;
          if (state === "closed" || state === "errored") {
            return;
          }
          if (state === "erroring") {
            WritableStreamFinishErroring(stream);
            return;
          }
          if (controller._queue.length === 0) {
            return;
          }
          var writeRecord = PeekQueueValue(controller);
          if (writeRecord === "close") {
            WritableStreamDefaultControllerProcessClose(controller);
          } else {
            WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
          }
        }
        function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
          if (controller._controlledWritableStream._state === "writable") {
            WritableStreamDefaultControllerError(controller, error);
          }
        }
        function WritableStreamDefaultControllerProcessClose(controller) {
          var stream = controller._controlledWritableStream;
          WritableStreamMarkCloseRequestInFlight(stream);
          DequeueValue(controller);
          assert(controller._queue.length === 0, "queue must be empty once the final write record is dequeued");
          var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, "close", []);
          sinkClosePromise.then(function () {
            WritableStreamFinishInFlightClose(stream);
          }, function (reason) {
            WritableStreamFinishInFlightCloseWithError(stream, reason);
          }).catch(rethrowAssertionErrorRejection);
        }
        function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
          var stream = controller._controlledWritableStream;
          WritableStreamMarkFirstWriteRequestInFlight(stream);
          var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, "write", [chunk, controller]);
          sinkWritePromise.then(function () {
            WritableStreamFinishInFlightWrite(stream);
            var state = stream._state;
            assert(state === "writable" || state === "erroring");
            DequeueValue(controller);
            if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === "writable") {
              var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
              WritableStreamUpdateBackpressure(stream, backpressure);
            }
            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
          }, function (reason) {
            WritableStreamFinishInFlightWriteWithError(stream, reason);
          }).catch(rethrowAssertionErrorRejection);
        }
        function WritableStreamDefaultControllerGetBackpressure(controller) {
          var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
          return desiredSize <= 0;
        }
        function WritableStreamDefaultControllerError(controller, error) {
          var stream = controller._controlledWritableStream;
          assert(stream._state === "writable");
          WritableStreamStartErroring(stream, error);
        }
        function streamBrandCheckException(name) {
          return new TypeError("WritableStream.prototype." + name + " can only be used on a WritableStream");
        }
        function defaultWriterBrandCheckException(name) {
          return new TypeError("WritableStreamDefaultWriter.prototype." + name + " can only be used on a WritableStreamDefaultWriter");
        }
        function defaultWriterLockException(name) {
          return new TypeError("Cannot " + name + " a stream using a released writer");
        }
        function defaultWriterClosedPromiseInitialize(writer) {
          writer._closedPromise = new Promise(function (resolve, reject) {
            writer._closedPromise_resolve = resolve;
            writer._closedPromise_reject = reject;
            writer._closedPromiseState = "pending";
          });
        }
        function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
          writer._closedPromise = Promise.reject(reason);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "rejected";
        }
        function defaultWriterClosedPromiseInitializeAsResolved(writer) {
          writer._closedPromise = Promise.resolve(undefined);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "resolved";
        }
        function defaultWriterClosedPromiseReject(writer, reason) {
          assert(writer._closedPromise_resolve !== undefined, "writer._closedPromise_resolve !== undefined");
          assert(writer._closedPromise_reject !== undefined, "writer._closedPromise_reject !== undefined");
          assert(writer._closedPromiseState === "pending", "writer._closedPromiseState is pending");
          writer._closedPromise_reject(reason);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "rejected";
        }
        function defaultWriterClosedPromiseResetToRejected(writer, reason) {
          assert(writer._closedPromise_resolve === undefined, "writer._closedPromise_resolve === undefined");
          assert(writer._closedPromise_reject === undefined, "writer._closedPromise_reject === undefined");
          assert(writer._closedPromiseState !== "pending", "writer._closedPromiseState is not pending");
          writer._closedPromise = Promise.reject(reason);
          writer._closedPromiseState = "rejected";
        }
        function defaultWriterClosedPromiseResolve(writer) {
          assert(writer._closedPromise_resolve !== undefined, "writer._closedPromise_resolve !== undefined");
          assert(writer._closedPromise_reject !== undefined, "writer._closedPromise_reject !== undefined");
          assert(writer._closedPromiseState === "pending", "writer._closedPromiseState is pending");
          writer._closedPromise_resolve(undefined);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "resolved";
        }
        function defaultWriterReadyPromiseInitialize(writer) {
          writer._readyPromise = new Promise(function (resolve, reject) {
            writer._readyPromise_resolve = resolve;
            writer._readyPromise_reject = reject;
          });
          writer._readyPromiseState = "pending";
        }
        function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
          writer._readyPromise = Promise.reject(reason);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "rejected";
        }
        function defaultWriterReadyPromiseInitializeAsResolved(writer) {
          writer._readyPromise = Promise.resolve(undefined);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "fulfilled";
        }
        function defaultWriterReadyPromiseReject(writer, reason) {
          assert(writer._readyPromise_resolve !== undefined, "writer._readyPromise_resolve !== undefined");
          assert(writer._readyPromise_reject !== undefined, "writer._readyPromise_reject !== undefined");
          writer._readyPromise_reject(reason);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "rejected";
        }
        function defaultWriterReadyPromiseReset(writer) {
          assert(writer._readyPromise_resolve === undefined, "writer._readyPromise_resolve === undefined");
          assert(writer._readyPromise_reject === undefined, "writer._readyPromise_reject === undefined");
          writer._readyPromise = new Promise(function (resolve, reject) {
            writer._readyPromise_resolve = resolve;
            writer._readyPromise_reject = reject;
          });
          writer._readyPromiseState = "pending";
        }
        function defaultWriterReadyPromiseResetToRejected(writer, reason) {
          assert(writer._readyPromise_resolve === undefined, "writer._readyPromise_resolve === undefined");
          assert(writer._readyPromise_reject === undefined, "writer._readyPromise_reject === undefined");
          writer._readyPromise = Promise.reject(reason);
          writer._readyPromiseState = "rejected";
        }
        function defaultWriterReadyPromiseResolve(writer) {
          assert(writer._readyPromise_resolve !== undefined, "writer._readyPromise_resolve !== undefined");
          assert(writer._readyPromise_reject !== undefined, "writer._readyPromise_reject !== undefined");
          writer._readyPromise_resolve(undefined);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "fulfilled";
        }
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _require = __w_pdfjs_require__(0),
          IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
        var _require2 = __w_pdfjs_require__(1),
          assert = _require2.assert;
        exports.DequeueValue = function (container) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].");
          assert(container._queue.length > 0, "Spec-level failure: should never dequeue from an empty queue.");
          var pair = container._queue.shift();
          container._queueTotalSize -= pair.size;
          if (container._queueTotalSize < 0) {
            container._queueTotalSize = 0;
          }
          return pair.value;
        };
        exports.EnqueueValueWithSize = function (container, value, size) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and " + "[[queueTotalSize]].");
          size = Number(size);
          if (!IsFiniteNonNegativeNumber(size)) {
            throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
          }
          container._queue.push({
            value: value,
            size: size
          });
          container._queueTotalSize += size;
        };
        exports.PeekQueueValue = function (container) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].");
          assert(container._queue.length > 0, "Spec-level failure: should never peek at an empty queue.");
          var pair = container._queue[0];
          return pair.value;
        };
        exports.ResetQueue = function (container) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].");
          container._queue = [];
          container._queueTotalSize = 0;
        };
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var _require = __w_pdfjs_require__(0),
          ArrayBufferCopy = _require.ArrayBufferCopy,
          CreateIterResultObject = _require.CreateIterResultObject,
          IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
          InvokeOrNoop = _require.InvokeOrNoop,
          PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
          TransferArrayBuffer = _require.TransferArrayBuffer,
          ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
          ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
        var _require2 = __w_pdfjs_require__(0),
          createArrayFromList = _require2.createArrayFromList,
          createDataProperty = _require2.createDataProperty,
          typeIsObject = _require2.typeIsObject;
        var _require3 = __w_pdfjs_require__(1),
          assert = _require3.assert,
          rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
        var _require4 = __w_pdfjs_require__(3),
          DequeueValue = _require4.DequeueValue,
          EnqueueValueWithSize = _require4.EnqueueValueWithSize,
          ResetQueue = _require4.ResetQueue;
        var _require5 = __w_pdfjs_require__(2),
          AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
          IsWritableStream = _require5.IsWritableStream,
          IsWritableStreamLocked = _require5.IsWritableStreamLocked,
          WritableStreamAbort = _require5.WritableStreamAbort,
          WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
          WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
          WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
          WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
        var ReadableStream = function () {
          function ReadableStream() {
            var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              size = _ref.size,
              highWaterMark = _ref.highWaterMark;
            _classCallCheck(this, ReadableStream);
            this._state = "readable";
            this._reader = undefined;
            this._storedError = undefined;
            this._disturbed = false;
            this._readableStreamController = undefined;
            var type = underlyingSource.type;
            var typeString = String(type);
            if (typeString === "bytes") {
              if (highWaterMark === undefined) {
                highWaterMark = 0;
              }
              this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
            } else if (type === undefined) {
              if (highWaterMark === undefined) {
                highWaterMark = 1;
              }
              this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
            } else {
              throw new RangeError("Invalid type is specified");
            }
          }
          _createClass(ReadableStream, [{
            key: "cancel",
            value: function cancel(reason) {
              if (IsReadableStream(this) === false) {
                return Promise.reject(streamBrandCheckException("cancel"));
              }
              if (IsReadableStreamLocked(this) === true) {
                return Promise.reject(new TypeError("Cannot cancel a stream that already has a reader"));
              }
              return ReadableStreamCancel(this, reason);
            }
          }, {
            key: "getReader",
            value: function getReader() {
              var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                mode = _ref2.mode;
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException("getReader");
              }
              if (mode === undefined) {
                return AcquireReadableStreamDefaultReader(this);
              }
              mode = String(mode);
              if (mode === "byob") {
                return AcquireReadableStreamBYOBReader(this);
              }
              throw new RangeError("Invalid mode is specified");
            }
          }, {
            key: "pipeThrough",
            value: function pipeThrough(_ref3, options) {
              var writable = _ref3.writable,
                readable = _ref3.readable;
              var promise = this.pipeTo(writable, options);
              ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
              return readable;
            }
          }, {
            key: "pipeTo",
            value: function pipeTo(dest) {
              var _this = this;
              var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                preventClose = _ref4.preventClose,
                preventAbort = _ref4.preventAbort,
                preventCancel = _ref4.preventCancel;
              if (IsReadableStream(this) === false) {
                return Promise.reject(streamBrandCheckException("pipeTo"));
              }
              if (IsWritableStream(dest) === false) {
                return Promise.reject(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
              }
              preventClose = Boolean(preventClose);
              preventAbort = Boolean(preventAbort);
              preventCancel = Boolean(preventCancel);
              if (IsReadableStreamLocked(this) === true) {
                return Promise.reject(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream"));
              }
              if (IsWritableStreamLocked(dest) === true) {
                return Promise.reject(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream"));
              }
              var reader = AcquireReadableStreamDefaultReader(this);
              var writer = AcquireWritableStreamDefaultWriter(dest);
              var shuttingDown = false;
              var currentWrite = Promise.resolve();
              return new Promise(function (resolve, reject) {
                function pipeLoop() {
                  currentWrite = Promise.resolve();
                  if (shuttingDown === true) {
                    return Promise.resolve();
                  }
                  return writer._readyPromise.then(function () {
                    return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                      var value = _ref5.value,
                        done = _ref5.done;
                      if (done === true) {
                        return;
                      }
                      currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
                    });
                  }).then(pipeLoop);
                }
                isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
                  if (preventAbort === false) {
                    shutdownWithAction(function () {
                      return WritableStreamAbort(dest, storedError);
                    }, true, storedError);
                  } else {
                    shutdown(true, storedError);
                  }
                });
                isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
                  if (preventCancel === false) {
                    shutdownWithAction(function () {
                      return ReadableStreamCancel(_this, storedError);
                    }, true, storedError);
                  } else {
                    shutdown(true, storedError);
                  }
                });
                isOrBecomesClosed(_this, reader._closedPromise, function () {
                  if (preventClose === false) {
                    shutdownWithAction(function () {
                      return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
                    });
                  } else {
                    shutdown();
                  }
                });
                if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === "closed") {
                  var destClosed = new TypeError("the destination writable stream closed before all data could be piped to it");
                  if (preventCancel === false) {
                    shutdownWithAction(function () {
                      return ReadableStreamCancel(_this, destClosed);
                    }, true, destClosed);
                  } else {
                    shutdown(true, destClosed);
                  }
                }
                pipeLoop().catch(function (err) {
                  currentWrite = Promise.resolve();
                  rethrowAssertionErrorRejection(err);
                });
                function waitForWritesToFinish() {
                  var oldCurrentWrite = currentWrite;
                  return currentWrite.then(function () {
                    return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
                  });
                }
                function isOrBecomesErrored(stream, promise, action) {
                  if (stream._state === "errored") {
                    action(stream._storedError);
                  } else {
                    promise.catch(action).catch(rethrowAssertionErrorRejection);
                  }
                }
                function isOrBecomesClosed(stream, promise, action) {
                  if (stream._state === "closed") {
                    action();
                  } else {
                    promise.then(action).catch(rethrowAssertionErrorRejection);
                  }
                }
                function shutdownWithAction(action, originalIsError, originalError) {
                  if (shuttingDown === true) {
                    return;
                  }
                  shuttingDown = true;
                  if (dest._state === "writable" && WritableStreamCloseQueuedOrInFlight(dest) === false) {
                    waitForWritesToFinish().then(doTheRest);
                  } else {
                    doTheRest();
                  }
                  function doTheRest() {
                    action().then(function () {
                      return finalize(originalIsError, originalError);
                    }, function (newError) {
                      return finalize(true, newError);
                    }).catch(rethrowAssertionErrorRejection);
                  }
                }
                function shutdown(isError, error) {
                  if (shuttingDown === true) {
                    return;
                  }
                  shuttingDown = true;
                  if (dest._state === "writable" && WritableStreamCloseQueuedOrInFlight(dest) === false) {
                    waitForWritesToFinish().then(function () {
                      return finalize(isError, error);
                    }).catch(rethrowAssertionErrorRejection);
                  } else {
                    finalize(isError, error);
                  }
                }
                function finalize(isError, error) {
                  WritableStreamDefaultWriterRelease(writer);
                  ReadableStreamReaderGenericRelease(reader);
                  if (isError) {
                    reject(error);
                  } else {
                    resolve(undefined);
                  }
                }
              });
            }
          }, {
            key: "tee",
            value: function tee() {
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException("tee");
              }
              var branches = ReadableStreamTee(this, false);
              return createArrayFromList(branches);
            }
          }, {
            key: "locked",
            get: function get() {
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException("locked");
              }
              return IsReadableStreamLocked(this);
            }
          }]);
          return ReadableStream;
        }();
        module.exports = {
          ReadableStream: ReadableStream,
          IsReadableStreamDisturbed: IsReadableStreamDisturbed,
          ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
          ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
          ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
          ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
        };
        function AcquireReadableStreamBYOBReader(stream) {
          return new ReadableStreamBYOBReader(stream);
        }
        function AcquireReadableStreamDefaultReader(stream) {
          return new ReadableStreamDefaultReader(stream);
        }
        function IsReadableStream(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_readableStreamController")) {
            return false;
          }
          return true;
        }
        function IsReadableStreamDisturbed(stream) {
          assert(IsReadableStream(stream) === true, "IsReadableStreamDisturbed should only be used on known readable streams");
          return stream._disturbed;
        }
        function IsReadableStreamLocked(stream) {
          assert(IsReadableStream(stream) === true, "IsReadableStreamLocked should only be used on known readable streams");
          if (stream._reader === undefined) {
            return false;
          }
          return true;
        }
        function ReadableStreamTee(stream, cloneForBranch2) {
          assert(IsReadableStream(stream) === true);
          assert(typeof cloneForBranch2 === "boolean");
          var reader = AcquireReadableStreamDefaultReader(stream);
          var teeState = {
            closedOrErrored: false,
            canceled1: false,
            canceled2: false,
            reason1: undefined,
            reason2: undefined
          };
          teeState.promise = new Promise(function (resolve) {
            teeState._resolve = resolve;
          });
          var pull = create_ReadableStreamTeePullFunction();
          pull._reader = reader;
          pull._teeState = teeState;
          pull._cloneForBranch2 = cloneForBranch2;
          var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
          cancel1._stream = stream;
          cancel1._teeState = teeState;
          var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
          cancel2._stream = stream;
          cancel2._teeState = teeState;
          var underlyingSource1 = Object.create(Object.prototype);
          createDataProperty(underlyingSource1, "pull", pull);
          createDataProperty(underlyingSource1, "cancel", cancel1);
          var branch1Stream = new ReadableStream(underlyingSource1);
          var underlyingSource2 = Object.create(Object.prototype);
          createDataProperty(underlyingSource2, "pull", pull);
          createDataProperty(underlyingSource2, "cancel", cancel2);
          var branch2Stream = new ReadableStream(underlyingSource2);
          pull._branch1 = branch1Stream._readableStreamController;
          pull._branch2 = branch2Stream._readableStreamController;
          reader._closedPromise.catch(function (r) {
            if (teeState.closedOrErrored === true) {
              return;
            }
            ReadableStreamDefaultControllerError(pull._branch1, r);
            ReadableStreamDefaultControllerError(pull._branch2, r);
            teeState.closedOrErrored = true;
          });
          return [branch1Stream, branch2Stream];
        }
        function create_ReadableStreamTeePullFunction() {
          function f() {
            var reader = f._reader,
              branch1 = f._branch1,
              branch2 = f._branch2,
              teeState = f._teeState;
            return ReadableStreamDefaultReaderRead(reader).then(function (result) {
              assert(typeIsObject(result));
              var value = result.value;
              var done = result.done;
              assert(typeof done === "boolean");
              if (done === true && teeState.closedOrErrored === false) {
                if (teeState.canceled1 === false) {
                  ReadableStreamDefaultControllerClose(branch1);
                }
                if (teeState.canceled2 === false) {
                  ReadableStreamDefaultControllerClose(branch2);
                }
                teeState.closedOrErrored = true;
              }
              if (teeState.closedOrErrored === true) {
                return;
              }
              var value1 = value;
              var value2 = value;
              if (teeState.canceled1 === false) {
                ReadableStreamDefaultControllerEnqueue(branch1, value1);
              }
              if (teeState.canceled2 === false) {
                ReadableStreamDefaultControllerEnqueue(branch2, value2);
              }
            });
          }
          return f;
        }
        function create_ReadableStreamTeeBranch1CancelFunction() {
          function f(reason) {
            var stream = f._stream,
              teeState = f._teeState;
            teeState.canceled1 = true;
            teeState.reason1 = reason;
            if (teeState.canceled2 === true) {
              var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
              var cancelResult = ReadableStreamCancel(stream, compositeReason);
              teeState._resolve(cancelResult);
            }
            return teeState.promise;
          }
          return f;
        }
        function create_ReadableStreamTeeBranch2CancelFunction() {
          function f(reason) {
            var stream = f._stream,
              teeState = f._teeState;
            teeState.canceled2 = true;
            teeState.reason2 = reason;
            if (teeState.canceled1 === true) {
              var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
              var cancelResult = ReadableStreamCancel(stream, compositeReason);
              teeState._resolve(cancelResult);
            }
            return teeState.promise;
          }
          return f;
        }
        function ReadableStreamAddReadIntoRequest(stream) {
          assert(IsReadableStreamBYOBReader(stream._reader) === true);
          assert(stream._state === "readable" || stream._state === "closed");
          var promise = new Promise(function (resolve, reject) {
            var readIntoRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._reader._readIntoRequests.push(readIntoRequest);
          });
          return promise;
        }
        function ReadableStreamAddReadRequest(stream) {
          assert(IsReadableStreamDefaultReader(stream._reader) === true);
          assert(stream._state === "readable");
          var promise = new Promise(function (resolve, reject) {
            var readRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._reader._readRequests.push(readRequest);
          });
          return promise;
        }
        function ReadableStreamCancel(stream, reason) {
          stream._disturbed = true;
          if (stream._state === "closed") {
            return Promise.resolve(undefined);
          }
          if (stream._state === "errored") {
            return Promise.reject(stream._storedError);
          }
          ReadableStreamClose(stream);
          var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
          return sourceCancelPromise.then(function () {
            return undefined;
          });
        }
        function ReadableStreamClose(stream) {
          assert(stream._state === "readable");
          stream._state = "closed";
          var reader = stream._reader;
          if (reader === undefined) {
            return undefined;
          }
          if (IsReadableStreamDefaultReader(reader) === true) {
            for (var i = 0; i < reader._readRequests.length; i++) {
              var _resolve = reader._readRequests[i]._resolve;
              _resolve(CreateIterResultObject(undefined, true));
            }
            reader._readRequests = [];
          }
          defaultReaderClosedPromiseResolve(reader);
          return undefined;
        }
        function ReadableStreamError(stream, e) {
          assert(IsReadableStream(stream) === true, "stream must be ReadableStream");
          assert(stream._state === "readable", "state must be readable");
          stream._state = "errored";
          stream._storedError = e;
          var reader = stream._reader;
          if (reader === undefined) {
            return undefined;
          }
          if (IsReadableStreamDefaultReader(reader) === true) {
            for (var i = 0; i < reader._readRequests.length; i++) {
              var readRequest = reader._readRequests[i];
              readRequest._reject(e);
            }
            reader._readRequests = [];
          } else {
            assert(IsReadableStreamBYOBReader(reader), "reader must be ReadableStreamBYOBReader");
            for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
              var readIntoRequest = reader._readIntoRequests[_i];
              readIntoRequest._reject(e);
            }
            reader._readIntoRequests = [];
          }
          defaultReaderClosedPromiseReject(reader, e);
          reader._closedPromise.catch(function () {});
        }
        function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
          var reader = stream._reader;
          assert(reader._readIntoRequests.length > 0);
          var readIntoRequest = reader._readIntoRequests.shift();
          readIntoRequest._resolve(CreateIterResultObject(chunk, done));
        }
        function ReadableStreamFulfillReadRequest(stream, chunk, done) {
          var reader = stream._reader;
          assert(reader._readRequests.length > 0);
          var readRequest = reader._readRequests.shift();
          readRequest._resolve(CreateIterResultObject(chunk, done));
        }
        function ReadableStreamGetNumReadIntoRequests(stream) {
          return stream._reader._readIntoRequests.length;
        }
        function ReadableStreamGetNumReadRequests(stream) {
          return stream._reader._readRequests.length;
        }
        function ReadableStreamHasBYOBReader(stream) {
          var reader = stream._reader;
          if (reader === undefined) {
            return false;
          }
          if (IsReadableStreamBYOBReader(reader) === false) {
            return false;
          }
          return true;
        }
        function ReadableStreamHasDefaultReader(stream) {
          var reader = stream._reader;
          if (reader === undefined) {
            return false;
          }
          if (IsReadableStreamDefaultReader(reader) === false) {
            return false;
          }
          return true;
        }
        var ReadableStreamDefaultReader = function () {
          function ReadableStreamDefaultReader(stream) {
            _classCallCheck(this, ReadableStreamDefaultReader);
            if (IsReadableStream(stream) === false) {
              throw new TypeError("ReadableStreamDefaultReader can only be constructed with a ReadableStream instance");
            }
            if (IsReadableStreamLocked(stream) === true) {
              throw new TypeError("This stream has already been locked for exclusive reading by another reader");
            }
            ReadableStreamReaderGenericInitialize(this, stream);
            this._readRequests = [];
          }
          _createClass(ReadableStreamDefaultReader, [{
            key: "cancel",
            value: function cancel(reason) {
              if (IsReadableStreamDefaultReader(this) === false) {
                return Promise.reject(defaultReaderBrandCheckException("cancel"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("cancel"));
              }
              return ReadableStreamReaderGenericCancel(this, reason);
            }
          }, {
            key: "read",
            value: function read() {
              if (IsReadableStreamDefaultReader(this) === false) {
                return Promise.reject(defaultReaderBrandCheckException("read"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("read from"));
              }
              return ReadableStreamDefaultReaderRead(this);
            }
          }, {
            key: "releaseLock",
            value: function releaseLock() {
              if (IsReadableStreamDefaultReader(this) === false) {
                throw defaultReaderBrandCheckException("releaseLock");
              }
              if (this._ownerReadableStream === undefined) {
                return;
              }
              if (this._readRequests.length > 0) {
                throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
              }
              ReadableStreamReaderGenericRelease(this);
            }
          }, {
            key: "closed",
            get: function get() {
              if (IsReadableStreamDefaultReader(this) === false) {
                return Promise.reject(defaultReaderBrandCheckException("closed"));
              }
              return this._closedPromise;
            }
          }]);
          return ReadableStreamDefaultReader;
        }();
        var ReadableStreamBYOBReader = function () {
          function ReadableStreamBYOBReader(stream) {
            _classCallCheck(this, ReadableStreamBYOBReader);
            if (!IsReadableStream(stream)) {
              throw new TypeError("ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a " + "byte source");
            }
            if (IsReadableByteStreamController(stream._readableStreamController) === false) {
              throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte " + "source");
            }
            if (IsReadableStreamLocked(stream)) {
              throw new TypeError("This stream has already been locked for exclusive reading by another reader");
            }
            ReadableStreamReaderGenericInitialize(this, stream);
            this._readIntoRequests = [];
          }
          _createClass(ReadableStreamBYOBReader, [{
            key: "cancel",
            value: function cancel(reason) {
              if (!IsReadableStreamBYOBReader(this)) {
                return Promise.reject(byobReaderBrandCheckException("cancel"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("cancel"));
              }
              return ReadableStreamReaderGenericCancel(this, reason);
            }
          }, {
            key: "read",
            value: function read(view) {
              if (!IsReadableStreamBYOBReader(this)) {
                return Promise.reject(byobReaderBrandCheckException("read"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("read from"));
              }
              if (!ArrayBuffer.isView(view)) {
                return Promise.reject(new TypeError("view must be an array buffer view"));
              }
              if (view.byteLength === 0) {
                return Promise.reject(new TypeError("view must have non-zero byteLength"));
              }
              return ReadableStreamBYOBReaderRead(this, view);
            }
          }, {
            key: "releaseLock",
            value: function releaseLock() {
              if (!IsReadableStreamBYOBReader(this)) {
                throw byobReaderBrandCheckException("releaseLock");
              }
              if (this._ownerReadableStream === undefined) {
                return;
              }
              if (this._readIntoRequests.length > 0) {
                throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
              }
              ReadableStreamReaderGenericRelease(this);
            }
          }, {
            key: "closed",
            get: function get() {
              if (!IsReadableStreamBYOBReader(this)) {
                return Promise.reject(byobReaderBrandCheckException("closed"));
              }
              return this._closedPromise;
            }
          }]);
          return ReadableStreamBYOBReader;
        }();
        function IsReadableStreamBYOBReader(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_readIntoRequests")) {
            return false;
          }
          return true;
        }
        function IsReadableStreamDefaultReader(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_readRequests")) {
            return false;
          }
          return true;
        }
        function ReadableStreamReaderGenericInitialize(reader, stream) {
          reader._ownerReadableStream = stream;
          stream._reader = reader;
          if (stream._state === "readable") {
            defaultReaderClosedPromiseInitialize(reader);
          } else if (stream._state === "closed") {
            defaultReaderClosedPromiseInitializeAsResolved(reader);
          } else {
            assert(stream._state === "errored", "state must be errored");
            defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
            reader._closedPromise.catch(function () {});
          }
        }
        function ReadableStreamReaderGenericCancel(reader, reason) {
          var stream = reader._ownerReadableStream;
          assert(stream !== undefined);
          return ReadableStreamCancel(stream, reason);
        }
        function ReadableStreamReaderGenericRelease(reader) {
          assert(reader._ownerReadableStream !== undefined);
          assert(reader._ownerReadableStream._reader === reader);
          if (reader._ownerReadableStream._state === "readable") {
            defaultReaderClosedPromiseReject(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
          } else {
            defaultReaderClosedPromiseResetToRejected(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
          }
          reader._closedPromise.catch(function () {});
          reader._ownerReadableStream._reader = undefined;
          reader._ownerReadableStream = undefined;
        }
        function ReadableStreamBYOBReaderRead(reader, view) {
          var stream = reader._ownerReadableStream;
          assert(stream !== undefined);
          stream._disturbed = true;
          if (stream._state === "errored") {
            return Promise.reject(stream._storedError);
          }
          return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
        }
        function ReadableStreamDefaultReaderRead(reader) {
          var stream = reader._ownerReadableStream;
          assert(stream !== undefined);
          stream._disturbed = true;
          if (stream._state === "closed") {
            return Promise.resolve(CreateIterResultObject(undefined, true));
          }
          if (stream._state === "errored") {
            return Promise.reject(stream._storedError);
          }
          assert(stream._state === "readable");
          return stream._readableStreamController.__pullSteps();
        }
        var ReadableStreamDefaultController = function () {
          function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
            _classCallCheck(this, ReadableStreamDefaultController);
            if (IsReadableStream(stream) === false) {
              throw new TypeError("ReadableStreamDefaultController can only be constructed with a ReadableStream instance");
            }
            if (stream._readableStreamController !== undefined) {
              throw new TypeError("ReadableStreamDefaultController instances can only be created by the ReadableStream constructor");
            }
            this._controlledReadableStream = stream;
            this._underlyingSource = underlyingSource;
            this._queue = undefined;
            this._queueTotalSize = undefined;
            ResetQueue(this);
            this._started = false;
            this._closeRequested = false;
            this._pullAgain = false;
            this._pulling = false;
            var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
            this._strategySize = normalizedStrategy.size;
            this._strategyHWM = normalizedStrategy.highWaterMark;
            var controller = this;
            var startResult = InvokeOrNoop(underlyingSource, "start", [this]);
            Promise.resolve(startResult).then(function () {
              controller._started = true;
              assert(controller._pulling === false);
              assert(controller._pullAgain === false);
              ReadableStreamDefaultControllerCallPullIfNeeded(controller);
            }, function (r) {
              ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
            }).catch(rethrowAssertionErrorRejection);
          }
          _createClass(ReadableStreamDefaultController, [{
            key: "close",
            value: function close() {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("close");
              }
              if (this._closeRequested === true) {
                throw new TypeError("The stream has already been closed; do not close it again!");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
              }
              ReadableStreamDefaultControllerClose(this);
            }
          }, {
            key: "enqueue",
            value: function enqueue(chunk) {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("enqueue");
              }
              if (this._closeRequested === true) {
                throw new TypeError("stream is closed or draining");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
              }
              return ReadableStreamDefaultControllerEnqueue(this, chunk);
            }
          }, {
            key: "error",
            value: function error(e) {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("error");
              }
              var stream = this._controlledReadableStream;
              if (stream._state !== "readable") {
                throw new TypeError("The stream is " + stream._state + " and so cannot be errored");
              }
              ReadableStreamDefaultControllerError(this, e);
            }
          }, {
            key: "__cancelSteps",
            value: function __cancelSteps(reason) {
              ResetQueue(this);
              return PromiseInvokeOrNoop(this._underlyingSource, "cancel", [reason]);
            }
          }, {
            key: "__pullSteps",
            value: function __pullSteps() {
              var stream = this._controlledReadableStream;
              if (this._queue.length > 0) {
                var chunk = DequeueValue(this);
                if (this._closeRequested === true && this._queue.length === 0) {
                  ReadableStreamClose(stream);
                } else {
                  ReadableStreamDefaultControllerCallPullIfNeeded(this);
                }
                return Promise.resolve(CreateIterResultObject(chunk, false));
              }
              var pendingPromise = ReadableStreamAddReadRequest(stream);
              ReadableStreamDefaultControllerCallPullIfNeeded(this);
              return pendingPromise;
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("desiredSize");
              }
              return ReadableStreamDefaultControllerGetDesiredSize(this);
            }
          }]);
          return ReadableStreamDefaultController;
        }();
        function IsReadableStreamDefaultController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_underlyingSource")) {
            return false;
          }
          return true;
        }
        function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
          var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
          if (shouldPull === false) {
            return undefined;
          }
          if (controller._pulling === true) {
            controller._pullAgain = true;
            return undefined;
          }
          assert(controller._pullAgain === false);
          controller._pulling = true;
          var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, "pull", [controller]);
          pullPromise.then(function () {
            controller._pulling = false;
            if (controller._pullAgain === true) {
              controller._pullAgain = false;
              return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
            }
            return undefined;
          }, function (e) {
            ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
          }).catch(rethrowAssertionErrorRejection);
          return undefined;
        }
        function ReadableStreamDefaultControllerShouldCallPull(controller) {
          var stream = controller._controlledReadableStream;
          if (stream._state === "closed" || stream._state === "errored") {
            return false;
          }
          if (controller._closeRequested === true) {
            return false;
          }
          if (controller._started === false) {
            return false;
          }
          if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            return true;
          }
          var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
          if (desiredSize > 0) {
            return true;
          }
          return false;
        }
        function ReadableStreamDefaultControllerClose(controller) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          controller._closeRequested = true;
          if (controller._queue.length === 0) {
            ReadableStreamClose(stream);
          }
        }
        function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            ReadableStreamFulfillReadRequest(stream, chunk, false);
          } else {
            var chunkSize = 1;
            if (controller._strategySize !== undefined) {
              var strategySize = controller._strategySize;
              try {
                chunkSize = strategySize(chunk);
              } catch (chunkSizeE) {
                ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
                throw chunkSizeE;
              }
            }
            try {
              EnqueueValueWithSize(controller, chunk, chunkSize);
            } catch (enqueueE) {
              ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
              throw enqueueE;
            }
          }
          ReadableStreamDefaultControllerCallPullIfNeeded(controller);
          return undefined;
        }
        function ReadableStreamDefaultControllerError(controller, e) {
          var stream = controller._controlledReadableStream;
          assert(stream._state === "readable");
          ResetQueue(controller);
          ReadableStreamError(stream, e);
        }
        function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
          if (controller._controlledReadableStream._state === "readable") {
            ReadableStreamDefaultControllerError(controller, e);
          }
        }
        function ReadableStreamDefaultControllerGetDesiredSize(controller) {
          var stream = controller._controlledReadableStream;
          var state = stream._state;
          if (state === "errored") {
            return null;
          }
          if (state === "closed") {
            return 0;
          }
          return controller._strategyHWM - controller._queueTotalSize;
        }
        var ReadableStreamBYOBRequest = function () {
          function ReadableStreamBYOBRequest(controller, view) {
            _classCallCheck(this, ReadableStreamBYOBRequest);
            this._associatedReadableByteStreamController = controller;
            this._view = view;
          }
          _createClass(ReadableStreamBYOBRequest, [{
            key: "respond",
            value: function respond(bytesWritten) {
              if (IsReadableStreamBYOBRequest(this) === false) {
                throw byobRequestBrandCheckException("respond");
              }
              if (this._associatedReadableByteStreamController === undefined) {
                throw new TypeError("This BYOB request has been invalidated");
              }
              ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
            }
          }, {
            key: "respondWithNewView",
            value: function respondWithNewView(view) {
              if (IsReadableStreamBYOBRequest(this) === false) {
                throw byobRequestBrandCheckException("respond");
              }
              if (this._associatedReadableByteStreamController === undefined) {
                throw new TypeError("This BYOB request has been invalidated");
              }
              if (!ArrayBuffer.isView(view)) {
                throw new TypeError("You can only respond with array buffer views");
              }
              ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
            }
          }, {
            key: "view",
            get: function get() {
              return this._view;
            }
          }]);
          return ReadableStreamBYOBRequest;
        }();
        var ReadableByteStreamController = function () {
          function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
            _classCallCheck(this, ReadableByteStreamController);
            if (IsReadableStream(stream) === false) {
              throw new TypeError("ReadableByteStreamController can only be constructed with a ReadableStream instance given " + "a byte source");
            }
            if (stream._readableStreamController !== undefined) {
              throw new TypeError("ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte " + "source");
            }
            this._controlledReadableStream = stream;
            this._underlyingByteSource = underlyingByteSource;
            this._pullAgain = false;
            this._pulling = false;
            ReadableByteStreamControllerClearPendingPullIntos(this);
            this._queue = this._queueTotalSize = undefined;
            ResetQueue(this);
            this._closeRequested = false;
            this._started = false;
            this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
            var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
            if (autoAllocateChunkSize !== undefined) {
              if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
                throw new RangeError("autoAllocateChunkSize must be a positive integer");
              }
            }
            this._autoAllocateChunkSize = autoAllocateChunkSize;
            this._pendingPullIntos = [];
            var controller = this;
            var startResult = InvokeOrNoop(underlyingByteSource, "start", [this]);
            Promise.resolve(startResult).then(function () {
              controller._started = true;
              assert(controller._pulling === false);
              assert(controller._pullAgain === false);
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }, function (r) {
              if (stream._state === "readable") {
                ReadableByteStreamControllerError(controller, r);
              }
            }).catch(rethrowAssertionErrorRejection);
          }
          _createClass(ReadableByteStreamController, [{
            key: "close",
            value: function close() {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("close");
              }
              if (this._closeRequested === true) {
                throw new TypeError("The stream has already been closed; do not close it again!");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
              }
              ReadableByteStreamControllerClose(this);
            }
          }, {
            key: "enqueue",
            value: function enqueue(chunk) {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("enqueue");
              }
              if (this._closeRequested === true) {
                throw new TypeError("stream is closed or draining");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
              }
              if (!ArrayBuffer.isView(chunk)) {
                throw new TypeError("You can only enqueue array buffer views when using a ReadableByteStreamController");
              }
              ReadableByteStreamControllerEnqueue(this, chunk);
            }
          }, {
            key: "error",
            value: function error(e) {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("error");
              }
              var stream = this._controlledReadableStream;
              if (stream._state !== "readable") {
                throw new TypeError("The stream is " + stream._state + " and so cannot be errored");
              }
              ReadableByteStreamControllerError(this, e);
            }
          }, {
            key: "__cancelSteps",
            value: function __cancelSteps(reason) {
              if (this._pendingPullIntos.length > 0) {
                var firstDescriptor = this._pendingPullIntos[0];
                firstDescriptor.bytesFilled = 0;
              }
              ResetQueue(this);
              return PromiseInvokeOrNoop(this._underlyingByteSource, "cancel", [reason]);
            }
          }, {
            key: "__pullSteps",
            value: function __pullSteps() {
              var stream = this._controlledReadableStream;
              assert(ReadableStreamHasDefaultReader(stream) === true);
              if (this._queueTotalSize > 0) {
                assert(ReadableStreamGetNumReadRequests(stream) === 0);
                var entry = this._queue.shift();
                this._queueTotalSize -= entry.byteLength;
                ReadableByteStreamControllerHandleQueueDrain(this);
                var view = void 0;
                try {
                  view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
                } catch (viewE) {
                  return Promise.reject(viewE);
                }
                return Promise.resolve(CreateIterResultObject(view, false));
              }
              var autoAllocateChunkSize = this._autoAllocateChunkSize;
              if (autoAllocateChunkSize !== undefined) {
                var buffer = void 0;
                try {
                  buffer = new ArrayBuffer(autoAllocateChunkSize);
                } catch (bufferE) {
                  return Promise.reject(bufferE);
                }
                var pullIntoDescriptor = {
                  buffer: buffer,
                  byteOffset: 0,
                  byteLength: autoAllocateChunkSize,
                  bytesFilled: 0,
                  elementSize: 1,
                  ctor: Uint8Array,
                  readerType: "default"
                };
                this._pendingPullIntos.push(pullIntoDescriptor);
              }
              var promise = ReadableStreamAddReadRequest(stream);
              ReadableByteStreamControllerCallPullIfNeeded(this);
              return promise;
            }
          }, {
            key: "byobRequest",
            get: function get() {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("byobRequest");
              }
              if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
                var firstDescriptor = this._pendingPullIntos[0];
                var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
                this._byobRequest = new ReadableStreamBYOBRequest(this, view);
              }
              return this._byobRequest;
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("desiredSize");
              }
              return ReadableByteStreamControllerGetDesiredSize(this);
            }
          }]);
          return ReadableByteStreamController;
        }();
        function IsReadableByteStreamController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_underlyingByteSource")) {
            return false;
          }
          return true;
        }
        function IsReadableStreamBYOBRequest(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_associatedReadableByteStreamController")) {
            return false;
          }
          return true;
        }
        function ReadableByteStreamControllerCallPullIfNeeded(controller) {
          var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
          if (shouldPull === false) {
            return undefined;
          }
          if (controller._pulling === true) {
            controller._pullAgain = true;
            return undefined;
          }
          assert(controller._pullAgain === false);
          controller._pulling = true;
          var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, "pull", [controller]);
          pullPromise.then(function () {
            controller._pulling = false;
            if (controller._pullAgain === true) {
              controller._pullAgain = false;
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }
          }, function (e) {
            if (controller._controlledReadableStream._state === "readable") {
              ReadableByteStreamControllerError(controller, e);
            }
          }).catch(rethrowAssertionErrorRejection);
          return undefined;
        }
        function ReadableByteStreamControllerClearPendingPullIntos(controller) {
          ReadableByteStreamControllerInvalidateBYOBRequest(controller);
          controller._pendingPullIntos = [];
        }
        function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
          assert(stream._state !== "errored", "state must not be errored");
          var done = false;
          if (stream._state === "closed") {
            assert(pullIntoDescriptor.bytesFilled === 0);
            done = true;
          }
          var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
          if (pullIntoDescriptor.readerType === "default") {
            ReadableStreamFulfillReadRequest(stream, filledView, done);
          } else {
            assert(pullIntoDescriptor.readerType === "byob");
            ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
          }
        }
        function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
          var bytesFilled = pullIntoDescriptor.bytesFilled;
          var elementSize = pullIntoDescriptor.elementSize;
          assert(bytesFilled <= pullIntoDescriptor.byteLength);
          assert(bytesFilled % elementSize === 0);
          return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
        }
        function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
          controller._queue.push({
            buffer: buffer,
            byteOffset: byteOffset,
            byteLength: byteLength
          });
          controller._queueTotalSize += byteLength;
        }
        function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
          var elementSize = pullIntoDescriptor.elementSize;
          var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
          var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
          var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
          var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
          var totalBytesToCopyRemaining = maxBytesToCopy;
          var ready = false;
          if (maxAlignedBytes > currentAlignedBytes) {
            totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
            ready = true;
          }
          var queue = controller._queue;
          while (totalBytesToCopyRemaining > 0) {
            var headOfQueue = queue[0];
            var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
            var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
            ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
            if (headOfQueue.byteLength === bytesToCopy) {
              queue.shift();
            } else {
              headOfQueue.byteOffset += bytesToCopy;
              headOfQueue.byteLength -= bytesToCopy;
            }
            controller._queueTotalSize -= bytesToCopy;
            ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
            totalBytesToCopyRemaining -= bytesToCopy;
          }
          if (ready === false) {
            assert(controller._queueTotalSize === 0, "queue must be empty");
            assert(pullIntoDescriptor.bytesFilled > 0);
            assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
          }
          return ready;
        }
        function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
          assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
          ReadableByteStreamControllerInvalidateBYOBRequest(controller);
          pullIntoDescriptor.bytesFilled += size;
        }
        function ReadableByteStreamControllerHandleQueueDrain(controller) {
          assert(controller._controlledReadableStream._state === "readable");
          if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
            ReadableStreamClose(controller._controlledReadableStream);
          } else {
            ReadableByteStreamControllerCallPullIfNeeded(controller);
          }
        }
        function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
          if (controller._byobRequest === undefined) {
            return;
          }
          controller._byobRequest._associatedReadableByteStreamController = undefined;
          controller._byobRequest._view = undefined;
          controller._byobRequest = undefined;
        }
        function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
          assert(controller._closeRequested === false);
          while (controller._pendingPullIntos.length > 0) {
            if (controller._queueTotalSize === 0) {
              return;
            }
            var pullIntoDescriptor = controller._pendingPullIntos[0];
            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
              ReadableByteStreamControllerShiftPendingPullInto(controller);
              ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
            }
          }
        }
        function ReadableByteStreamControllerPullInto(controller, view) {
          var stream = controller._controlledReadableStream;
          var elementSize = 1;
          if (view.constructor !== DataView) {
            elementSize = view.constructor.BYTES_PER_ELEMENT;
          }
          var ctor = view.constructor;
          var pullIntoDescriptor = {
            buffer: view.buffer,
            byteOffset: view.byteOffset,
            byteLength: view.byteLength,
            bytesFilled: 0,
            elementSize: elementSize,
            ctor: ctor,
            readerType: "byob"
          };
          if (controller._pendingPullIntos.length > 0) {
            pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
            controller._pendingPullIntos.push(pullIntoDescriptor);
            return ReadableStreamAddReadIntoRequest(stream);
          }
          if (stream._state === "closed") {
            var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
            return Promise.resolve(CreateIterResultObject(emptyView, true));
          }
          if (controller._queueTotalSize > 0) {
            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
              var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
              ReadableByteStreamControllerHandleQueueDrain(controller);
              return Promise.resolve(CreateIterResultObject(filledView, false));
            }
            if (controller._closeRequested === true) {
              var e = new TypeError("Insufficient bytes to fill elements in the given buffer");
              ReadableByteStreamControllerError(controller, e);
              return Promise.reject(e);
            }
          }
          pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
          controller._pendingPullIntos.push(pullIntoDescriptor);
          var promise = ReadableStreamAddReadIntoRequest(stream);
          ReadableByteStreamControllerCallPullIfNeeded(controller);
          return promise;
        }
        function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
          firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
          assert(firstDescriptor.bytesFilled === 0, "bytesFilled must be 0");
          var stream = controller._controlledReadableStream;
          if (ReadableStreamHasBYOBReader(stream) === true) {
            while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
              var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
              ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
            }
          }
        }
        function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
          if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
            throw new RangeError("bytesWritten out of range");
          }
          ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
          if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
            return;
          }
          ReadableByteStreamControllerShiftPendingPullInto(controller);
          var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
          if (remainderSize > 0) {
            var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
            var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
          }
          pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
          pullIntoDescriptor.bytesFilled -= remainderSize;
          ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
          ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
        }
        function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
          var firstDescriptor = controller._pendingPullIntos[0];
          var stream = controller._controlledReadableStream;
          if (stream._state === "closed") {
            if (bytesWritten !== 0) {
              throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
            }
            ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
          } else {
            assert(stream._state === "readable");
            ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
          }
        }
        function ReadableByteStreamControllerShiftPendingPullInto(controller) {
          var descriptor = controller._pendingPullIntos.shift();
          ReadableByteStreamControllerInvalidateBYOBRequest(controller);
          return descriptor;
        }
        function ReadableByteStreamControllerShouldCallPull(controller) {
          var stream = controller._controlledReadableStream;
          if (stream._state !== "readable") {
            return false;
          }
          if (controller._closeRequested === true) {
            return false;
          }
          if (controller._started === false) {
            return false;
          }
          if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            return true;
          }
          if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
            return true;
          }
          if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
            return true;
          }
          return false;
        }
        function ReadableByteStreamControllerClose(controller) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          if (controller._queueTotalSize > 0) {
            controller._closeRequested = true;
            return;
          }
          if (controller._pendingPullIntos.length > 0) {
            var firstPendingPullInto = controller._pendingPullIntos[0];
            if (firstPendingPullInto.bytesFilled > 0) {
              var e = new TypeError("Insufficient bytes to fill elements in the given buffer");
              ReadableByteStreamControllerError(controller, e);
              throw e;
            }
          }
          ReadableStreamClose(stream);
        }
        function ReadableByteStreamControllerEnqueue(controller, chunk) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          var buffer = chunk.buffer;
          var byteOffset = chunk.byteOffset;
          var byteLength = chunk.byteLength;
          var transferredBuffer = TransferArrayBuffer(buffer);
          if (ReadableStreamHasDefaultReader(stream) === true) {
            if (ReadableStreamGetNumReadRequests(stream) === 0) {
              ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
            } else {
              assert(controller._queue.length === 0);
              var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
              ReadableStreamFulfillReadRequest(stream, transferredView, false);
            }
          } else if (ReadableStreamHasBYOBReader(stream) === true) {
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
            ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
          } else {
            assert(IsReadableStreamLocked(stream) === false, "stream must not be locked");
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
          }
        }
        function ReadableByteStreamControllerError(controller, e) {
          var stream = controller._controlledReadableStream;
          assert(stream._state === "readable");
          ReadableByteStreamControllerClearPendingPullIntos(controller);
          ResetQueue(controller);
          ReadableStreamError(stream, e);
        }
        function ReadableByteStreamControllerGetDesiredSize(controller) {
          var stream = controller._controlledReadableStream;
          var state = stream._state;
          if (state === "errored") {
            return null;
          }
          if (state === "closed") {
            return 0;
          }
          return controller._strategyHWM - controller._queueTotalSize;
        }
        function ReadableByteStreamControllerRespond(controller, bytesWritten) {
          bytesWritten = Number(bytesWritten);
          if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
            throw new RangeError("bytesWritten must be a finite");
          }
          assert(controller._pendingPullIntos.length > 0);
          ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
        }
        function ReadableByteStreamControllerRespondWithNewView(controller, view) {
          assert(controller._pendingPullIntos.length > 0);
          var firstDescriptor = controller._pendingPullIntos[0];
          if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
            throw new RangeError("The region specified by view does not match byobRequest");
          }
          if (firstDescriptor.byteLength !== view.byteLength) {
            throw new RangeError("The buffer of view has different capacity than byobRequest");
          }
          firstDescriptor.buffer = view.buffer;
          ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
        }
        function streamBrandCheckException(name) {
          return new TypeError("ReadableStream.prototype." + name + " can only be used on a ReadableStream");
        }
        function readerLockException(name) {
          return new TypeError("Cannot " + name + " a stream using a released reader");
        }
        function defaultReaderBrandCheckException(name) {
          return new TypeError("ReadableStreamDefaultReader.prototype." + name + " can only be used on a ReadableStreamDefaultReader");
        }
        function defaultReaderClosedPromiseInitialize(reader) {
          reader._closedPromise = new Promise(function (resolve, reject) {
            reader._closedPromise_resolve = resolve;
            reader._closedPromise_reject = reject;
          });
        }
        function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
          reader._closedPromise = Promise.reject(reason);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function defaultReaderClosedPromiseInitializeAsResolved(reader) {
          reader._closedPromise = Promise.resolve(undefined);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function defaultReaderClosedPromiseReject(reader, reason) {
          assert(reader._closedPromise_resolve !== undefined);
          assert(reader._closedPromise_reject !== undefined);
          reader._closedPromise_reject(reason);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function defaultReaderClosedPromiseResetToRejected(reader, reason) {
          assert(reader._closedPromise_resolve === undefined);
          assert(reader._closedPromise_reject === undefined);
          reader._closedPromise = Promise.reject(reason);
        }
        function defaultReaderClosedPromiseResolve(reader) {
          assert(reader._closedPromise_resolve !== undefined);
          assert(reader._closedPromise_reject !== undefined);
          reader._closedPromise_resolve(undefined);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function byobReaderBrandCheckException(name) {
          return new TypeError("ReadableStreamBYOBReader.prototype." + name + " can only be used on a ReadableStreamBYOBReader");
        }
        function defaultControllerBrandCheckException(name) {
          return new TypeError("ReadableStreamDefaultController.prototype." + name + " can only be used on a ReadableStreamDefaultController");
        }
        function byobRequestBrandCheckException(name) {
          return new TypeError("ReadableStreamBYOBRequest.prototype." + name + " can only be used on a ReadableStreamBYOBRequest");
        }
        function byteStreamControllerBrandCheckException(name) {
          return new TypeError("ReadableByteStreamController.prototype." + name + " can only be used on a ReadableByteStreamController");
        }
        function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
          try {
            Promise.prototype.then.call(promise, undefined, function () {});
          } catch (e) {}
        }
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var transformStream = __w_pdfjs_require__(6);
        var readableStream = __w_pdfjs_require__(4);
        var writableStream = __w_pdfjs_require__(2);
        exports.TransformStream = transformStream.TransformStream;
        exports.ReadableStream = readableStream.ReadableStream;
        exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
        exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
        exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
        exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
        exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
        exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
        exports.IsWritableStream = writableStream.IsWritableStream;
        exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
        exports.WritableStream = writableStream.WritableStream;
        exports.WritableStreamAbort = writableStream.WritableStreamAbort;
        exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
        exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
        exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
        exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var _require = __w_pdfjs_require__(1),
          assert = _require.assert;
        var _require2 = __w_pdfjs_require__(0),
          InvokeOrNoop = _require2.InvokeOrNoop,
          PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
          PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
          typeIsObject = _require2.typeIsObject;
        var _require3 = __w_pdfjs_require__(4),
          ReadableStream = _require3.ReadableStream,
          ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
          ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
          ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
          ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
        var _require4 = __w_pdfjs_require__(2),
          WritableStream = _require4.WritableStream,
          WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
        function TransformStreamCloseReadable(transformStream) {
          if (transformStream._errored === true) {
            throw new TypeError("TransformStream is already errored");
          }
          if (transformStream._readableClosed === true) {
            throw new TypeError("Readable side is already closed");
          }
          TransformStreamCloseReadableInternal(transformStream);
        }
        function TransformStreamEnqueueToReadable(transformStream, chunk) {
          if (transformStream._errored === true) {
            throw new TypeError("TransformStream is already errored");
          }
          if (transformStream._readableClosed === true) {
            throw new TypeError("Readable side is already closed");
          }
          var controller = transformStream._readableController;
          try {
            ReadableStreamDefaultControllerEnqueue(controller, chunk);
          } catch (e) {
            transformStream._readableClosed = true;
            TransformStreamErrorIfNeeded(transformStream, e);
            throw transformStream._storedError;
          }
          var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
          var maybeBackpressure = desiredSize <= 0;
          if (maybeBackpressure === true && transformStream._backpressure === false) {
            TransformStreamSetBackpressure(transformStream, true);
          }
        }
        function TransformStreamError(transformStream, e) {
          if (transformStream._errored === true) {
            throw new TypeError("TransformStream is already errored");
          }
          TransformStreamErrorInternal(transformStream, e);
        }
        function TransformStreamCloseReadableInternal(transformStream) {
          assert(transformStream._errored === false);
          assert(transformStream._readableClosed === false);
          try {
            ReadableStreamDefaultControllerClose(transformStream._readableController);
          } catch (e) {
            assert(false);
          }
          transformStream._readableClosed = true;
        }
        function TransformStreamErrorIfNeeded(transformStream, e) {
          if (transformStream._errored === false) {
            TransformStreamErrorInternal(transformStream, e);
          }
        }
        function TransformStreamErrorInternal(transformStream, e) {
          assert(transformStream._errored === false);
          transformStream._errored = true;
          transformStream._storedError = e;
          if (transformStream._writableDone === false) {
            WritableStreamDefaultControllerError(transformStream._writableController, e);
          }
          if (transformStream._readableClosed === false) {
            ReadableStreamDefaultControllerError(transformStream._readableController, e);
          }
        }
        function TransformStreamReadableReadyPromise(transformStream) {
          assert(transformStream._backpressureChangePromise !== undefined, "_backpressureChangePromise should have been initialized");
          if (transformStream._backpressure === false) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === true, "_backpressure should have been initialized");
          return transformStream._backpressureChangePromise;
        }
        function TransformStreamSetBackpressure(transformStream, backpressure) {
          assert(transformStream._backpressure !== backpressure, "TransformStreamSetBackpressure() should be called only when backpressure is changed");
          if (transformStream._backpressureChangePromise !== undefined) {
            transformStream._backpressureChangePromise_resolve(backpressure);
          }
          transformStream._backpressureChangePromise = new Promise(function (resolve) {
            transformStream._backpressureChangePromise_resolve = resolve;
          });
          transformStream._backpressureChangePromise.then(function (resolution) {
            assert(resolution !== backpressure, "_backpressureChangePromise should be fulfilled only when backpressure is changed");
          });
          transformStream._backpressure = backpressure;
        }
        function TransformStreamDefaultTransform(chunk, transformStreamController) {
          var transformStream = transformStreamController._controlledTransformStream;
          TransformStreamEnqueueToReadable(transformStream, chunk);
          return Promise.resolve();
        }
        function TransformStreamTransform(transformStream, chunk) {
          assert(transformStream._errored === false);
          assert(transformStream._transforming === false);
          assert(transformStream._backpressure === false);
          transformStream._transforming = true;
          var transformer = transformStream._transformer;
          var controller = transformStream._transformStreamController;
          var transformPromise = PromiseInvokeOrPerformFallback(transformer, "transform", [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
          return transformPromise.then(function () {
            transformStream._transforming = false;
            return TransformStreamReadableReadyPromise(transformStream);
          }, function (e) {
            TransformStreamErrorIfNeeded(transformStream, e);
            return Promise.reject(e);
          });
        }
        function IsTransformStreamDefaultController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_controlledTransformStream")) {
            return false;
          }
          return true;
        }
        function IsTransformStream(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_transformStreamController")) {
            return false;
          }
          return true;
        }
        var TransformStreamSink = function () {
          function TransformStreamSink(transformStream, startPromise) {
            _classCallCheck(this, TransformStreamSink);
            this._transformStream = transformStream;
            this._startPromise = startPromise;
          }
          _createClass(TransformStreamSink, [{
            key: "start",
            value: function start(c) {
              var transformStream = this._transformStream;
              transformStream._writableController = c;
              return this._startPromise.then(function () {
                return TransformStreamReadableReadyPromise(transformStream);
              });
            }
          }, {
            key: "write",
            value: function write(chunk) {
              var transformStream = this._transformStream;
              return TransformStreamTransform(transformStream, chunk);
            }
          }, {
            key: "abort",
            value: function abort() {
              var transformStream = this._transformStream;
              transformStream._writableDone = true;
              TransformStreamErrorInternal(transformStream, new TypeError("Writable side aborted"));
            }
          }, {
            key: "close",
            value: function close() {
              var transformStream = this._transformStream;
              assert(transformStream._transforming === false);
              transformStream._writableDone = true;
              var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, "flush", [transformStream._transformStreamController]);
              return flushPromise.then(function () {
                if (transformStream._errored === true) {
                  return Promise.reject(transformStream._storedError);
                }
                if (transformStream._readableClosed === false) {
                  TransformStreamCloseReadableInternal(transformStream);
                }
                return Promise.resolve();
              }).catch(function (r) {
                TransformStreamErrorIfNeeded(transformStream, r);
                return Promise.reject(transformStream._storedError);
              });
            }
          }]);
          return TransformStreamSink;
        }();
        var TransformStreamSource = function () {
          function TransformStreamSource(transformStream, startPromise) {
            _classCallCheck(this, TransformStreamSource);
            this._transformStream = transformStream;
            this._startPromise = startPromise;
          }
          _createClass(TransformStreamSource, [{
            key: "start",
            value: function start(c) {
              var transformStream = this._transformStream;
              transformStream._readableController = c;
              return this._startPromise.then(function () {
                assert(transformStream._backpressureChangePromise !== undefined, "_backpressureChangePromise should have been initialized");
                if (transformStream._backpressure === true) {
                  return Promise.resolve();
                }
                assert(transformStream._backpressure === false, "_backpressure should have been initialized");
                return transformStream._backpressureChangePromise;
              });
            }
          }, {
            key: "pull",
            value: function pull() {
              var transformStream = this._transformStream;
              assert(transformStream._backpressure === true, "pull() should be never called while _backpressure is false");
              assert(transformStream._backpressureChangePromise !== undefined, "_backpressureChangePromise should have been initialized");
              TransformStreamSetBackpressure(transformStream, false);
              return transformStream._backpressureChangePromise;
            }
          }, {
            key: "cancel",
            value: function cancel() {
              var transformStream = this._transformStream;
              transformStream._readableClosed = true;
              TransformStreamErrorInternal(transformStream, new TypeError("Readable side canceled"));
            }
          }]);
          return TransformStreamSource;
        }();
        var TransformStreamDefaultController = function () {
          function TransformStreamDefaultController(transformStream) {
            _classCallCheck(this, TransformStreamDefaultController);
            if (IsTransformStream(transformStream) === false) {
              throw new TypeError("TransformStreamDefaultController can only be " + "constructed with a TransformStream instance");
            }
            if (transformStream._transformStreamController !== undefined) {
              throw new TypeError("TransformStreamDefaultController instances can " + "only be created by the TransformStream constructor");
            }
            this._controlledTransformStream = transformStream;
          }
          _createClass(TransformStreamDefaultController, [{
            key: "enqueue",
            value: function enqueue(chunk) {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("enqueue");
              }
              TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
            }
          }, {
            key: "close",
            value: function close() {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("close");
              }
              TransformStreamCloseReadable(this._controlledTransformStream);
            }
          }, {
            key: "error",
            value: function error(reason) {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("error");
              }
              TransformStreamError(this._controlledTransformStream, reason);
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("desiredSize");
              }
              var transformStream = this._controlledTransformStream;
              var readableController = transformStream._readableController;
              return ReadableStreamDefaultControllerGetDesiredSize(readableController);
            }
          }]);
          return TransformStreamDefaultController;
        }();
        var TransformStream = function () {
          function TransformStream() {
            var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, TransformStream);
            this._transformer = transformer;
            var readableStrategy = transformer.readableStrategy,
              writableStrategy = transformer.writableStrategy;
            this._transforming = false;
            this._errored = false;
            this._storedError = undefined;
            this._writableController = undefined;
            this._readableController = undefined;
            this._transformStreamController = undefined;
            this._writableDone = false;
            this._readableClosed = false;
            this._backpressure = undefined;
            this._backpressureChangePromise = undefined;
            this._backpressureChangePromise_resolve = undefined;
            this._transformStreamController = new TransformStreamDefaultController(this);
            var startPromise_resolve = void 0;
            var startPromise = new Promise(function (resolve) {
              startPromise_resolve = resolve;
            });
            var source = new TransformStreamSource(this, startPromise);
            this._readable = new ReadableStream(source, readableStrategy);
            var sink = new TransformStreamSink(this, startPromise);
            this._writable = new WritableStream(sink, writableStrategy);
            assert(this._writableController !== undefined);
            assert(this._readableController !== undefined);
            var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
            TransformStreamSetBackpressure(this, desiredSize <= 0);
            var transformStream = this;
            var startResult = InvokeOrNoop(transformer, "start", [transformStream._transformStreamController]);
            startPromise_resolve(startResult);
            startPromise.catch(function (e) {
              if (transformStream._errored === false) {
                transformStream._errored = true;
                transformStream._storedError = e;
              }
            });
          }
          _createClass(TransformStream, [{
            key: "readable",
            get: function get() {
              if (IsTransformStream(this) === false) {
                throw streamBrandCheckException("readable");
              }
              return this._readable;
            }
          }, {
            key: "writable",
            get: function get() {
              if (IsTransformStream(this) === false) {
                throw streamBrandCheckException("writable");
              }
              return this._writable;
            }
          }]);
          return TransformStream;
        }();
        module.exports = { TransformStream: TransformStream };
        function defaultControllerBrandCheckException(name) {
          return new TypeError("TransformStreamDefaultController.prototype." + name + " can only be used on a TransformStreamDefaultController");
        }
        function streamBrandCheckException(name) {
          return new TypeError("TransformStream.prototype." + name + " can only be used on a TransformStream");
        }
      }, function (module, exports, __w_pdfjs_require__) {
        module.exports = __w_pdfjs_require__(5);
      }]));

      /***/ }),
    /* 117 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFJS = exports.globalScope = undefined;

      var _api = __w_pdfjs_require__(69);

      var _dom_utils = __w_pdfjs_require__(13);

      var _util = __w_pdfjs_require__(0);

      var _annotation_layer = __w_pdfjs_require__(72);

      var _global_scope = __w_pdfjs_require__(20);

      var _global_scope2 = _interopRequireDefault(_global_scope);

      var _metadata = __w_pdfjs_require__(71);

      var _text_layer = __w_pdfjs_require__(73);

      var _svg = __w_pdfjs_require__(74);

      function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

      if (!_global_scope2.default.PDFJS) {
        _global_scope2.default.PDFJS = {};
      }
      var PDFJS = _global_scope2.default.PDFJS;
      {
        PDFJS.version = "1.10.97";
        PDFJS.build = "7d0fce73";
      }
      PDFJS.pdfBug = false;
      if (PDFJS.verbosity !== undefined) {
        (0, _util.setVerbosityLevel)(PDFJS.verbosity);
      }
      delete PDFJS.verbosity;
      Object.defineProperty(PDFJS, "verbosity", {
        get: function get() {
          return (0, _util.getVerbosityLevel)();
        },
        set: function set(level) {
          (0, _util.setVerbosityLevel)(level);
        },

        enumerable: true,
        configurable: true
      });
      PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
      PDFJS.OPS = _util.OPS;
      PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
      PDFJS.isValidUrl = _dom_utils.isValidUrl;
      PDFJS.shadow = _util.shadow;
      PDFJS.createBlob = _util.createBlob;
      PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
        return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
      };
      Object.defineProperty(PDFJS, "isLittleEndian", {
        configurable: true,
        get: function PDFJS_isLittleEndian() {
          return (0, _util.shadow)(PDFJS, "isLittleEndian", (0, _util.isLittleEndian)());
        }
      });
      PDFJS.removeNullCharacters = _util.removeNullCharacters;
      PDFJS.PasswordResponses = _util.PasswordResponses;
      PDFJS.PasswordException = _util.PasswordException;
      PDFJS.UnknownErrorException = _util.UnknownErrorException;
      PDFJS.InvalidPDFException = _util.InvalidPDFException;
      PDFJS.MissingPDFException = _util.MissingPDFException;
      PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
      PDFJS.Util = _util.Util;
      PDFJS.PageViewport = _util.PageViewport;
      PDFJS.createPromiseCapability = _util.createPromiseCapability;
      PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
      PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
      PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
      PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
      PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? "" : PDFJS.imageResourcesPath;
      PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
      PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
      PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
      PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
      PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
      PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
      PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
      PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
      PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
      PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
      PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
      PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
      PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
      PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
      {
        var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
        delete PDFJS.openExternalLinksInNewWindow;
        Object.defineProperty(PDFJS, "openExternalLinksInNewWindow", {
          get: function get() {
            return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
          },
          set: function set(value) {
            if (value) {
              (0, _util.deprecated)("PDFJS.openExternalLinksInNewWindow, please use " + "\"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK\" instead.");
            }
            if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
              (0, _util.warn)("PDFJS.externalLinkTarget is already initialized");
              return;
            }
            PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
          },

          enumerable: true,
          configurable: true
        });
        if (savedOpenExternalLinksInNewWindow) {
          PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
        }
      }
      PDFJS.getDocument = _api.getDocument;
      PDFJS.LoopbackPort = _api.LoopbackPort;
      PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
      PDFJS.PDFWorker = _api.PDFWorker;
      PDFJS.hasCanvasTypedArrays = true;
      PDFJS.CustomStyle = _dom_utils.CustomStyle;
      PDFJS.LinkTarget = _dom_utils.LinkTarget;
      PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
      PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
      PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
      PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
      PDFJS.renderTextLayer = _text_layer.renderTextLayer;
      PDFJS.Metadata = _metadata.Metadata;
      PDFJS.SVGGraphics = _svg.SVGGraphics;
      PDFJS.UnsupportedManager = _api._UnsupportedManager;
      exports.globalScope = _global_scope2.default;
      exports.PDFJS = PDFJS;

      /***/ }),
    /* 118 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FontLoader = exports.FontFaceObject = undefined;

      var _util = __w_pdfjs_require__(0);

      function FontLoader(docId) {
        this.docId = docId;
        this.styleElement = null;
        this.nativeFontFaces = [];
        this.loadTestFontId = 0;
        this.loadingContext = {
          requests: [],
          nextRequestId: 0
        };
      }
      FontLoader.prototype = {
        insertRule: function fontLoaderInsertRule(rule) {
          var styleElement = this.styleElement;
          if (!styleElement) {
            styleElement = this.styleElement = document.createElement("style");
            styleElement.id = "PDFJS_FONT_STYLE_TAG_" + this.docId;
            document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
          }
          var styleSheet = styleElement.sheet;
          styleSheet.insertRule(rule, styleSheet.cssRules.length);
        },
        clear: function fontLoaderClear() {
          if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
          }
          this.nativeFontFaces.forEach(function (nativeFontFace) {
            document.fonts.delete(nativeFontFace);
          });
          this.nativeFontFaces.length = 0;
        }
      };
      {
        var getLoadTestFont = function getLoadTestFont() {
          return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ" + "AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA" + "AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm" + "FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA" + "AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A" + "ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA" + "MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA" + "AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA" + "AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ" + "AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA" + "AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA" + "EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA" + "AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA" + "AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc" + "A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF" + "hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA" + "AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg" + "ABAAAAAAAAAAAD6AAAAAAAAA==");
        };
        Object.defineProperty(FontLoader.prototype, "loadTestFont", {
          get: function get() {
            return (0, _util.shadow)(this, "loadTestFont", getLoadTestFont());
          },

          configurable: true
        });
        FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
          this.nativeFontFaces.push(nativeFontFace);
          document.fonts.add(nativeFontFace);
        };
        FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
          var rules = [];
          var fontsToLoad = [];
          var fontLoadPromises = [];
          var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
            return nativeFontFace.loaded.catch(function (e) {
              (0, _util.warn)("Failed to load font \"" + nativeFontFace.family + "\": " + e);
            });
          };
          var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
          for (var i = 0, ii = fonts.length; i < ii; i++) {
            var font = fonts[i];
            if (font.attached || font.loading === false) {
              continue;
            }
            font.attached = true;
            if (isFontLoadingAPISupported) {
              var nativeFontFace = font.createNativeFontFace();
              if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
              }
            } else {
              var rule = font.createFontFaceRule();
              if (rule) {
                this.insertRule(rule);
                rules.push(rule);
                fontsToLoad.push(font);
              }
            }
          }
          var request = this.queueLoadingCallback(callback);
          if (isFontLoadingAPISupported) {
            Promise.all(fontLoadPromises).then(function () {
              request.complete();
            });
          } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
            this.prepareFontLoadEvent(rules, fontsToLoad, request);
          } else {
            request.complete();
          }
        };
        FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
          function LoadLoader_completeRequest() {
            (0, _util.assert)(!request.end, "completeRequest() cannot be called twice");
            request.end = Date.now();
            while (context.requests.length > 0 && context.requests[0].end) {
              var otherRequest = context.requests.shift();
              setTimeout(otherRequest.callback, 0);
            }
          }
          var context = this.loadingContext;
          var requestId = "pdfjs-font-loading-" + context.nextRequestId++;
          var request = {
            id: requestId,
            complete: LoadLoader_completeRequest,
            callback: callback,
            started: Date.now()
          };
          context.requests.push(request);
          return request;
        };
        FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
          function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
          }
          function spliceString(s, offset, remove, insert) {
            var chunk1 = s.substr(0, offset);
            var chunk2 = s.substr(offset + remove);
            return chunk1 + insert + chunk2;
          }
          var i, ii;
          var canvas = document.createElement("canvas");
          canvas.width = 1;
          canvas.height = 1;
          var ctx = canvas.getContext("2d");
          var called = 0;
          function isFontReady(name, callback) {
            called++;
            if (called > 30) {
              (0, _util.warn)("Load test font never loaded.");
              callback();
              return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            var imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
              callback();
              return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
          }
          var loadTestFontId = "lt" + Date.now() + this.loadTestFontId++;
          var data = this.loadTestFont;
          var COMMENT_OFFSET = 976;
          data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
          var CFF_CHECKSUM_OFFSET = 16;
          var XXXX_VALUE = 0x58585858;
          var checksum = int32(data, CFF_CHECKSUM_OFFSET);
          for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
            checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
          }
          if (i < loadTestFontId.length) {
            checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
          }
          data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
          var url = "url(data:font/opentype;base64," + btoa(data) + ");";
          var rule = "@font-face { font-family:\"" + loadTestFontId + "\";src:" + url + "}";
          this.insertRule(rule);
          var names = [];
          for (i = 0, ii = fonts.length; i < ii; i++) {
            names.push(fonts[i].loadedName);
          }
          names.push(loadTestFontId);
          var div = document.createElement("div");
          div.setAttribute("style", "visibility: hidden;" + "width: 10px; height: 10px;" + "position: absolute; top: 0px; left: 0px;");
          for (i = 0, ii = names.length; i < ii; ++i) {
            var span = document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = names[i];
            div.appendChild(span);
          }
          document.body.appendChild(div);
          isFontReady(loadTestFontId, function () {
            document.body.removeChild(div);
            request.complete();
          });
        };
      }
      {
        FontLoader.isFontLoadingAPISupported = typeof document !== "undefined" && !!document.fonts;
      }
      {
        var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
          if (typeof navigator === "undefined") {
            return true;
          }
          var supported = false;
          var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
          if (m && m[1] >= 14) {
            supported = true;
          }
          return supported;
        };
        Object.defineProperty(FontLoader, "isSyncFontLoadingSupported", {
          get: function get() {
            return (0, _util.shadow)(FontLoader, "isSyncFontLoadingSupported", isSyncFontLoadingSupported());
          },

          enumerable: true,
          configurable: true
        });
      }
      var IsEvalSupportedCached = {
        get value() {
          return (0, _util.shadow)(this, "value", (0, _util.isEvalSupported)());
        }
      };
      var FontFaceObject = function FontFaceObjectClosure() {
        function FontFaceObject(translatedData, options) {
          this.compiledGlyphs = Object.create(null);
          for (var i in translatedData) {
            this[i] = translatedData[i];
          }
          this.options = options;
        }
        FontFaceObject.prototype = {
          createNativeFontFace: function FontFaceObject_createNativeFontFace() {
            if (!this.data) {
              return null;
            }
            if (this.options.disableFontFace) {
              this.disableFontFace = true;
              return null;
            }
            var nativeFontFace = new FontFace(this.loadedName, this.data, {});
            if (this.options.fontRegistry) {
              this.options.fontRegistry.registerFont(this);
            }
            return nativeFontFace;
          },
          createFontFaceRule: function FontFaceObject_createFontFaceRule() {
            if (!this.data) {
              return null;
            }
            if (this.options.disableFontFace) {
              this.disableFontFace = true;
              return null;
            }
            var data = (0, _util.bytesToString)(new Uint8Array(this.data));
            var fontName = this.loadedName;
            var url = "url(data:" + this.mimetype + ";base64," + btoa(data) + ");";
            var rule = "@font-face { font-family:\"" + fontName + "\";src:" + url + "}";
            if (this.options.fontRegistry) {
              this.options.fontRegistry.registerFont(this, url);
            }
            return rule;
          },
          getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
            if (!(character in this.compiledGlyphs)) {
              var cmds = objs.get(this.loadedName + "_path_" + character);
              var current, i, len;
              if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
                var args,
                  js = "";
                for (i = 0, len = cmds.length; i < len; i++) {
                  current = cmds[i];
                  if (current.args !== undefined) {
                    args = current.args.join(",");
                  } else {
                    args = "";
                  }
                  js += "c." + current.cmd + "(" + args + ");\n";
                }
                this.compiledGlyphs[character] = new Function("c", "size", js);
              } else {
                this.compiledGlyphs[character] = function (c, size) {
                  for (i = 0, len = cmds.length; i < len; i++) {
                    current = cmds[i];
                    if (current.cmd === "scale") {
                      current.args = [size, -size];
                    }
                    c[current.cmd].apply(c, current.args);
                  }
                };
              }
            }
            return this.compiledGlyphs[character];
          }
        };
        return FontFaceObject;
      }();
      exports.FontFaceObject = FontFaceObject;
      exports.FontLoader = FontLoader;

      /***/ }),
    /* 119 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CanvasGraphics = undefined;

      var _util = __w_pdfjs_require__(0);

      var _pattern_helper = __w_pdfjs_require__(120);

      var _webgl = __w_pdfjs_require__(70);

      var MIN_FONT_SIZE = 16;
      var MAX_FONT_SIZE = 100;
      var MAX_GROUP_SIZE = 4096;
      var MIN_WIDTH_FACTOR = 0.65;
      var COMPILE_TYPE3_GLYPHS = true;
      var MAX_SIZE_TO_COMPILE = 1000;
      var FULL_CHUNK_HEIGHT = 16;
      var IsLittleEndianCached = {
        get value() {
          return (0, _util.shadow)(IsLittleEndianCached, "value", (0, _util.isLittleEndian)());
        }
      };
      function addContextCurrentTransform(ctx) {
        if (!ctx.mozCurrentTransform) {
          ctx._originalSave = ctx.save;
          ctx._originalRestore = ctx.restore;
          ctx._originalRotate = ctx.rotate;
          ctx._originalScale = ctx.scale;
          ctx._originalTranslate = ctx.translate;
          ctx._originalTransform = ctx.transform;
          ctx._originalSetTransform = ctx.setTransform;
          ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
          ctx._transformStack = [];
          Object.defineProperty(ctx, "mozCurrentTransform", {
            get: function getCurrentTransform() {
              return this._transformMatrix;
            }
          });
          Object.defineProperty(ctx, "mozCurrentTransformInverse", {
            get: function getCurrentTransformInverse() {
              var m = this._transformMatrix;
              var a = m[0],
                b = m[1],
                c = m[2],
                d = m[3],
                e = m[4],
                f = m[5];
              var ad_bc = a * d - b * c;
              var bc_ad = b * c - a * d;
              return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
            }
          });
          ctx.save = function ctxSave() {
            var old = this._transformMatrix;
            this._transformStack.push(old);
            this._transformMatrix = old.slice(0, 6);
            this._originalSave();
          };
          ctx.restore = function ctxRestore() {
            var prev = this._transformStack.pop();
            if (prev) {
              this._transformMatrix = prev;
              this._originalRestore();
            }
          };
          ctx.translate = function ctxTranslate(x, y) {
            var m = this._transformMatrix;
            m[4] = m[0] * x + m[2] * y + m[4];
            m[5] = m[1] * x + m[3] * y + m[5];
            this._originalTranslate(x, y);
          };
          ctx.scale = function ctxScale(x, y) {
            var m = this._transformMatrix;
            m[0] = m[0] * x;
            m[1] = m[1] * x;
            m[2] = m[2] * y;
            m[3] = m[3] * y;
            this._originalScale(x, y);
          };
          ctx.transform = function ctxTransform(a, b, c, d, e, f) {
            var m = this._transformMatrix;
            this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
            ctx._originalTransform(a, b, c, d, e, f);
          };
          ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
            this._transformMatrix = [a, b, c, d, e, f];
            ctx._originalSetTransform(a, b, c, d, e, f);
          };
          ctx.rotate = function ctxRotate(angle) {
            var cosValue = Math.cos(angle);
            var sinValue = Math.sin(angle);
            var m = this._transformMatrix;
            this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
            this._originalRotate(angle);
          };
        }
      }
      var CachedCanvases = function CachedCanvasesClosure() {
        function CachedCanvases(canvasFactory) {
          this.canvasFactory = canvasFactory;
          this.cache = Object.create(null);
        }
        CachedCanvases.prototype = {
          getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
            var canvasEntry;
            if (this.cache[id] !== undefined) {
              canvasEntry = this.cache[id];
              this.canvasFactory.reset(canvasEntry, width, height);
              canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
            } else {
              canvasEntry = this.canvasFactory.create(width, height);
              this.cache[id] = canvasEntry;
            }
            if (trackTransform) {
              addContextCurrentTransform(canvasEntry.context);
            }
            return canvasEntry;
          },
          clear: function clear() {
            for (var id in this.cache) {
              var canvasEntry = this.cache[id];
              this.canvasFactory.destroy(canvasEntry);
              delete this.cache[id];
            }
          }
        };
        return CachedCanvases;
      }();
      function compileType3Glyph(imgData) {
        var POINT_TO_PROCESS_LIMIT = 1000;
        var width = imgData.width,
          height = imgData.height;
        var i,
          j,
          j0,
          width1 = width + 1;
        var points = new Uint8Array(width1 * (height + 1));
        var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
        var lineSize = width + 7 & ~7,
          data0 = imgData.data;
        var data = new Uint8Array(lineSize * height),
          pos = 0,
          ii;
        for (i = 0, ii = data0.length; i < ii; i++) {
          var mask = 128,
            elem = data0[i];
          while (mask > 0) {
            data[pos++] = elem & mask ? 0 : 255;
            mask >>= 1;
          }
        }
        var count = 0;
        pos = 0;
        if (data[pos] !== 0) {
          points[0] = 1;
          ++count;
        }
        for (j = 1; j < width; j++) {
          if (data[pos] !== data[pos + 1]) {
            points[j] = data[pos] ? 2 : 1;
            ++count;
          }
          pos++;
        }
        if (data[pos] !== 0) {
          points[j] = 2;
          ++count;
        }
        for (i = 1; i < height; i++) {
          pos = i * lineSize;
          j0 = i * width1;
          if (data[pos - lineSize] !== data[pos]) {
            points[j0] = data[pos] ? 1 : 8;
            ++count;
          }
          var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
          for (j = 1; j < width; j++) {
            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
            if (POINT_TYPES[sum]) {
              points[j0 + j] = POINT_TYPES[sum];
              ++count;
            }
            pos++;
          }
          if (data[pos - lineSize] !== data[pos]) {
            points[j0 + j] = data[pos] ? 2 : 4;
            ++count;
          }
          if (count > POINT_TO_PROCESS_LIMIT) {
            return null;
          }
        }
        pos = lineSize * (height - 1);
        j0 = i * width1;
        if (data[pos] !== 0) {
          points[j0] = 8;
          ++count;
        }
        for (j = 1; j < width; j++) {
          if (data[pos] !== data[pos + 1]) {
            points[j0 + j] = data[pos] ? 4 : 8;
            ++count;
          }
          pos++;
        }
        if (data[pos] !== 0) {
          points[j0 + j] = 4;
          ++count;
        }
        if (count > POINT_TO_PROCESS_LIMIT) {
          return null;
        }
        var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
        var outlines = [];
        for (i = 0; count && i <= height; i++) {
          var p = i * width1;
          var end = p + width;
          while (p < end && !points[p]) {
            p++;
          }
          if (p === end) {
            continue;
          }
          var coords = [p % width1, i];
          var type = points[p],
            p0 = p,
            pp;
          do {
            var step = steps[type];
            do {
              p += step;
            } while (!points[p]);
            pp = points[p];
            if (pp !== 5 && pp !== 10) {
              type = pp;
              points[p] = 0;
            } else {
              type = pp & 0x33 * type >> 4;
              points[p] &= type >> 2 | type << 2;
            }
            coords.push(p % width1);
            coords.push(p / width1 | 0);
            --count;
          } while (p0 !== p);
          outlines.push(coords);
          --i;
        }
        var drawOutline = function drawOutline(c) {
          c.save();
          c.scale(1 / width, -1 / height);
          c.translate(0, -height);
          c.beginPath();
          for (var i = 0, ii = outlines.length; i < ii; i++) {
            var o = outlines[i];
            c.moveTo(o[0], o[1]);
            for (var j = 2, jj = o.length; j < jj; j += 2) {
              c.lineTo(o[j], o[j + 1]);
            }
          }
          c.fill();
          c.beginPath();
          c.restore();
        };
        return drawOutline;
      }
      var CanvasExtraState = function CanvasExtraStateClosure() {
        function CanvasExtraState() {
          this.alphaIsShape = false;
          this.fontSize = 0;
          this.fontSizeScale = 1;
          this.textMatrix = _util.IDENTITY_MATRIX;
          this.textMatrixScale = 1;
          this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
          this.leading = 0;
          this.x = 0;
          this.y = 0;
          this.lineX = 0;
          this.lineY = 0;
          this.charSpacing = 0;
          this.wordSpacing = 0;
          this.textHScale = 1;
          this.textRenderingMode = _util.TextRenderingMode.FILL;
          this.textRise = 0;
          this.fillColor = "#000000";
          this.strokeColor = "#000000";
          this.patternFill = false;
          this.fillAlpha = 1;
          this.strokeAlpha = 1;
          this.lineWidth = 1;
          this.activeSMask = null;
          this.resumeSMaskCtx = null;
        }
        CanvasExtraState.prototype = {
          clone: function CanvasExtraState_clone() {
            return Object.create(this);
          },
          setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
            this.x = x;
            this.y = y;
          }
        };
        return CanvasExtraState;
      }();
      var CanvasGraphics = function CanvasGraphicsClosure() {
        var EXECUTION_TIME = 15;
        var EXECUTION_STEPS = 10;
        function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
          this.ctx = canvasCtx;
          this.current = new CanvasExtraState();
          this.stateStack = [];
          this.pendingClip = null;
          this.pendingEOFill = false;
          this.res = null;
          this.xobjs = null;
          this.commonObjs = commonObjs;
          this.objs = objs;
          this.canvasFactory = canvasFactory;
          this.imageLayer = imageLayer;
          this.groupStack = [];
          this.processingType3 = null;
          this.baseTransform = null;
          this.baseTransformStack = [];
          this.groupLevel = 0;
          this.smaskStack = [];
          this.smaskCounter = 0;
          this.tempSMask = null;
          this.cachedCanvases = new CachedCanvases(this.canvasFactory);
          if (canvasCtx) {
            addContextCurrentTransform(canvasCtx);
          }
          this.cachedGetSinglePixelWidth = null;
        }
        function putBinaryImageData(ctx, imgData) {
          if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
            ctx.putImageData(imgData, 0, 0);
            return;
          }
          var height = imgData.height,
            width = imgData.width;
          var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
          var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
          var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
          var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
          var srcPos = 0,
            destPos;
          var src = imgData.data;
          var dest = chunkImgData.data;
          var i, j, thisChunkHeight, elemsInThisChunk;
          if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
            var srcLength = src.byteLength;
            var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
            var dest32DataLength = dest32.length;
            var fullSrcDiff = width + 7 >> 3;
            var white = 0xFFFFFFFF;
            var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
            for (i = 0; i < totalChunks; i++) {
              thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
              destPos = 0;
              for (j = 0; j < thisChunkHeight; j++) {
                var srcDiff = srcLength - srcPos;
                var k = 0;
                var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                var kEndUnrolled = kEnd & ~7;
                var mask = 0;
                var srcByte = 0;
                for (; k < kEndUnrolled; k += 8) {
                  srcByte = src[srcPos++];
                  dest32[destPos++] = srcByte & 128 ? white : black;
                  dest32[destPos++] = srcByte & 64 ? white : black;
                  dest32[destPos++] = srcByte & 32 ? white : black;
                  dest32[destPos++] = srcByte & 16 ? white : black;
                  dest32[destPos++] = srcByte & 8 ? white : black;
                  dest32[destPos++] = srcByte & 4 ? white : black;
                  dest32[destPos++] = srcByte & 2 ? white : black;
                  dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for (; k < kEnd; k++) {
                  if (mask === 0) {
                    srcByte = src[srcPos++];
                    mask = 128;
                  }
                  dest32[destPos++] = srcByte & mask ? white : black;
                  mask >>= 1;
                }
              }
              while (destPos < dest32DataLength) {
                dest32[destPos++] = 0;
              }
              ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
            }
          } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
            j = 0;
            elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
            for (i = 0; i < fullChunks; i++) {
              dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
              srcPos += elemsInThisChunk;
              ctx.putImageData(chunkImgData, 0, j);
              j += FULL_CHUNK_HEIGHT;
            }
            if (i < totalChunks) {
              elemsInThisChunk = width * partialChunkHeight * 4;
              dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
              ctx.putImageData(chunkImgData, 0, j);
            }
          } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
            thisChunkHeight = FULL_CHUNK_HEIGHT;
            elemsInThisChunk = width * thisChunkHeight;
            for (i = 0; i < totalChunks; i++) {
              if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
              }
              destPos = 0;
              for (j = elemsInThisChunk; j--;) {
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
              }
              ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
            }
          } else {
            throw new Error("bad image kind: " + imgData.kind);
          }
        }
        function putBinaryImageMask(ctx, imgData) {
          var height = imgData.height,
            width = imgData.width;
          var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
          var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
          var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
          var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
          var srcPos = 0;
          var src = imgData.data;
          var dest = chunkImgData.data;
          for (var i = 0; i < totalChunks; i++) {
            var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
            var destPos = 3;
            for (var j = 0; j < thisChunkHeight; j++) {
              var mask = 0;
              for (var k = 0; k < width; k++) {
                if (!mask) {
                  var elem = src[srcPos++];
                  mask = 128;
                }
                dest[destPos] = elem & mask ? 0 : 255;
                destPos += 4;
                mask >>= 1;
              }
            }
            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
          }
        }
        function copyCtxState(sourceCtx, destCtx) {
          var properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
          for (var i = 0, ii = properties.length; i < ii; i++) {
            var property = properties[i];
            if (sourceCtx[property] !== undefined) {
              destCtx[property] = sourceCtx[property];
            }
          }
          if (sourceCtx.setLineDash !== undefined) {
            destCtx.setLineDash(sourceCtx.getLineDash());
            destCtx.lineDashOffset = sourceCtx.lineDashOffset;
          }
        }
        function resetCtxToDefault(ctx) {
          ctx.strokeStyle = "#000000";
          ctx.fillStyle = "#000000";
          ctx.fillRule = "nonzero";
          ctx.globalAlpha = 1;
          ctx.lineWidth = 1;
          ctx.lineCap = "butt";
          ctx.lineJoin = "miter";
          ctx.miterLimit = 10;
          ctx.globalCompositeOperation = "source-over";
          ctx.font = "10px sans-serif";
          if (ctx.setLineDash !== undefined) {
            ctx.setLineDash([]);
            ctx.lineDashOffset = 0;
          }
        }
        function composeSMaskBackdrop(bytes, r0, g0, b0) {
          var length = bytes.length;
          for (var i = 3; i < length; i += 4) {
            var alpha = bytes[i];
            if (alpha === 0) {
              bytes[i - 3] = r0;
              bytes[i - 2] = g0;
              bytes[i - 1] = b0;
            } else if (alpha < 255) {
              var alpha_ = 255 - alpha;
              bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
              bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
              bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
            }
          }
        }
        function composeSMaskAlpha(maskData, layerData, transferMap) {
          var length = maskData.length;
          var scale = 1 / 255;
          for (var i = 3; i < length; i += 4) {
            var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
            layerData[i] = layerData[i] * alpha * scale | 0;
          }
        }
        function composeSMaskLuminosity(maskData, layerData, transferMap) {
          var length = maskData.length;
          for (var i = 3; i < length; i += 4) {
            var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
            layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
          }
        }
        function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
          var hasBackdrop = !!backdrop;
          var r0 = hasBackdrop ? backdrop[0] : 0;
          var g0 = hasBackdrop ? backdrop[1] : 0;
          var b0 = hasBackdrop ? backdrop[2] : 0;
          var composeFn;
          if (subtype === "Luminosity") {
            composeFn = composeSMaskLuminosity;
          } else {
            composeFn = composeSMaskAlpha;
          }
          var PIXELS_TO_PROCESS = 1048576;
          var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
          for (var row = 0; row < height; row += chunkSize) {
            var chunkHeight = Math.min(chunkSize, height - row);
            var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
            var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
            if (hasBackdrop) {
              composeSMaskBackdrop(maskData.data, r0, g0, b0);
            }
            composeFn(maskData.data, layerData.data, transferMap);
            maskCtx.putImageData(layerData, 0, row);
          }
        }
        function composeSMask(ctx, smask, layerCtx) {
          var mask = smask.canvas;
          var maskCtx = smask.context;
          ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
          var backdrop = smask.backdrop || null;
          if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
            var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
              subtype: smask.subtype,
              backdrop: backdrop
            });
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.drawImage(composed, smask.offsetX, smask.offsetY);
            return;
          }
          genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
          ctx.drawImage(mask, 0, 0);
        }
        var LINE_CAP_STYLES = ["butt", "round", "square"];
        var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
        var NORMAL_CLIP = {};
        var EO_CLIP = {};
        CanvasGraphics.prototype = {
          beginDrawing: function beginDrawing(_ref) {
            var transform = _ref.transform,
              viewport = _ref.viewport,
              transparency = _ref.transparency,
              _ref$background = _ref.background,
              background = _ref$background === undefined ? null : _ref$background;

            var width = this.ctx.canvas.width;
            var height = this.ctx.canvas.height;
            this.ctx.save();
            this.ctx.fillStyle = background || "rgb(255, 255, 255)";
            this.ctx.fillRect(0, 0, width, height);
            this.ctx.restore();
            if (transparency) {
              var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height, true);
              this.compositeCtx = this.ctx;
              this.transparentCanvas = transparentCanvas.canvas;
              this.ctx = transparentCanvas.context;
              this.ctx.save();
              this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
            }
            this.ctx.save();
            resetCtxToDefault(this.ctx);
            if (transform) {
              this.ctx.transform.apply(this.ctx, transform);
            }
            this.ctx.transform.apply(this.ctx, viewport.transform);
            this.baseTransform = this.ctx.mozCurrentTransform.slice();
            if (this.imageLayer) {
              this.imageLayer.beginLayout();
            }
          },

          executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
            var argsArray = operatorList.argsArray;
            var fnArray = operatorList.fnArray;
            var i = executionStartIdx || 0;
            var argsArrayLen = argsArray.length;
            if (argsArrayLen === i) {
              return i;
            }
            var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
            var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
            var steps = 0;
            var commonObjs = this.commonObjs;
            var objs = this.objs;
            var fnId;
            while (true) {
              if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback);
                return i;
              }
              fnId = fnArray[i];
              if (fnId !== _util.OPS.dependency) {
                this[fnId].apply(this, argsArray[i]);
              } else {
                var deps = argsArray[i];
                for (var n = 0, nn = deps.length; n < nn; n++) {
                  var depObjId = deps[n];
                  var common = depObjId[0] === "g" && depObjId[1] === "_";
                  var objsPool = common ? commonObjs : objs;
                  if (!objsPool.isResolved(depObjId)) {
                    objsPool.get(depObjId, continueCallback);
                    return i;
                  }
                }
              }
              i++;
              if (i === argsArrayLen) {
                return i;
              }
              if (chunkOperations && ++steps > EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                  continueCallback();
                  return i;
                }
                steps = 0;
              }
            }
          },
          endDrawing: function CanvasGraphics_endDrawing() {
            if (this.current.activeSMask !== null) {
              this.endSMaskGroup();
            }
            this.ctx.restore();
            if (this.transparentCanvas) {
              this.ctx = this.compositeCtx;
              this.ctx.save();
              this.ctx.setTransform(1, 0, 0, 1, 0, 0);
              this.ctx.drawImage(this.transparentCanvas, 0, 0);
              this.ctx.restore();
              this.transparentCanvas = null;
            }
            this.cachedCanvases.clear();
            _webgl.WebGLUtils.clear();
            if (this.imageLayer) {
              this.imageLayer.endLayout();
            }
          },
          setLineWidth: function CanvasGraphics_setLineWidth(width) {
            this.current.lineWidth = width;
            this.ctx.lineWidth = width;
          },
          setLineCap: function CanvasGraphics_setLineCap(style) {
            this.ctx.lineCap = LINE_CAP_STYLES[style];
          },
          setLineJoin: function CanvasGraphics_setLineJoin(style) {
            this.ctx.lineJoin = LINE_JOIN_STYLES[style];
          },
          setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
            this.ctx.miterLimit = limit;
          },
          setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
            var ctx = this.ctx;
            if (ctx.setLineDash !== undefined) {
              ctx.setLineDash(dashArray);
              ctx.lineDashOffset = dashPhase;
            }
          },
          setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
          setFlatness: function CanvasGraphics_setFlatness(flatness) {},
          setGState: function CanvasGraphics_setGState(states) {
            for (var i = 0, ii = states.length; i < ii; i++) {
              var state = states[i];
              var key = state[0];
              var value = state[1];
              switch (key) {
                case "LW":
                  this.setLineWidth(value);
                  break;
                case "LC":
                  this.setLineCap(value);
                  break;
                case "LJ":
                  this.setLineJoin(value);
                  break;
                case "ML":
                  this.setMiterLimit(value);
                  break;
                case "D":
                  this.setDash(value[0], value[1]);
                  break;
                case "RI":
                  this.setRenderingIntent(value);
                  break;
                case "FL":
                  this.setFlatness(value);
                  break;
                case "Font":
                  this.setFont(value[0], value[1]);
                  break;
                case "CA":
                  this.current.strokeAlpha = state[1];
                  break;
                case "ca":
                  this.current.fillAlpha = state[1];
                  this.ctx.globalAlpha = state[1];
                  break;
                case "BM":
                  this.ctx.globalCompositeOperation = value;
                  break;
                case "SMask":
                  if (this.current.activeSMask) {
                    if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                      this.suspendSMaskGroup();
                    } else {
                      this.endSMaskGroup();
                    }
                  }
                  this.current.activeSMask = value ? this.tempSMask : null;
                  if (this.current.activeSMask) {
                    this.beginSMaskGroup();
                  }
                  this.tempSMask = null;
                  break;
              }
            }
          },
          beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
            var activeSMask = this.current.activeSMask;
            var drawnWidth = activeSMask.canvas.width;
            var drawnHeight = activeSMask.canvas.height;
            var cacheId = "smaskGroupAt" + this.groupLevel;
            var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
            var currentCtx = this.ctx;
            var currentTransform = currentCtx.mozCurrentTransform;
            this.ctx.save();
            var groupCtx = scratchCanvas.context;
            groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
            groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
            groupCtx.transform.apply(groupCtx, currentTransform);
            activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
            copyCtxState(currentCtx, groupCtx);
            this.ctx = groupCtx;
            this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
            this.groupStack.push(currentCtx);
            this.groupLevel++;
          },
          suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
            var groupCtx = this.ctx;
            this.groupLevel--;
            this.ctx = this.groupStack.pop();
            composeSMask(this.ctx, this.current.activeSMask, groupCtx);
            this.ctx.restore();
            this.ctx.save();
            copyCtxState(groupCtx, this.ctx);
            this.current.resumeSMaskCtx = groupCtx;
            var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
            this.ctx.transform.apply(this.ctx, deltaTransform);
            groupCtx.save();
            groupCtx.setTransform(1, 0, 0, 1, 0, 0);
            groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
            groupCtx.restore();
          },
          resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
            var groupCtx = this.current.resumeSMaskCtx;
            var currentCtx = this.ctx;
            this.ctx = groupCtx;
            this.groupStack.push(currentCtx);
            this.groupLevel++;
          },
          endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
            var groupCtx = this.ctx;
            this.groupLevel--;
            this.ctx = this.groupStack.pop();
            composeSMask(this.ctx, this.current.activeSMask, groupCtx);
            this.ctx.restore();
            copyCtxState(groupCtx, this.ctx);
            var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
            this.ctx.transform.apply(this.ctx, deltaTransform);
          },
          save: function CanvasGraphics_save() {
            this.ctx.save();
            var old = this.current;
            this.stateStack.push(old);
            this.current = old.clone();
            this.current.resumeSMaskCtx = null;
          },
          restore: function CanvasGraphics_restore() {
            if (this.current.resumeSMaskCtx) {
              this.resumeSMaskGroup();
            }
            if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
              this.endSMaskGroup();
            }
            if (this.stateStack.length !== 0) {
              this.current = this.stateStack.pop();
              this.ctx.restore();
              this.pendingClip = null;
              this.cachedGetSinglePixelWidth = null;
            }
          },
          transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
            this.ctx.transform(a, b, c, d, e, f);
            this.cachedGetSinglePixelWidth = null;
          },
          constructPath: function CanvasGraphics_constructPath(ops, args) {
            var ctx = this.ctx;
            var current = this.current;
            var x = current.x,
              y = current.y;
            for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
              switch (ops[i] | 0) {
                case _util.OPS.rectangle:
                  x = args[j++];
                  y = args[j++];
                  var width = args[j++];
                  var height = args[j++];
                  if (width === 0) {
                    width = this.getSinglePixelWidth();
                  }
                  if (height === 0) {
                    height = this.getSinglePixelWidth();
                  }
                  var xw = x + width;
                  var yh = y + height;
                  this.ctx.moveTo(x, y);
                  this.ctx.lineTo(xw, y);
                  this.ctx.lineTo(xw, yh);
                  this.ctx.lineTo(x, yh);
                  this.ctx.lineTo(x, y);
                  this.ctx.closePath();
                  break;
                case _util.OPS.moveTo:
                  x = args[j++];
                  y = args[j++];
                  ctx.moveTo(x, y);
                  break;
                case _util.OPS.lineTo:
                  x = args[j++];
                  y = args[j++];
                  ctx.lineTo(x, y);
                  break;
                case _util.OPS.curveTo:
                  x = args[j + 4];
                  y = args[j + 5];
                  ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                  j += 6;
                  break;
                case _util.OPS.curveTo2:
                  ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                  x = args[j + 2];
                  y = args[j + 3];
                  j += 4;
                  break;
                case _util.OPS.curveTo3:
                  x = args[j + 2];
                  y = args[j + 3];
                  ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                  j += 4;
                  break;
                case _util.OPS.closePath:
                  ctx.closePath();
                  break;
              }
            }
            current.setCurrentPoint(x, y);
          },
          closePath: function CanvasGraphics_closePath() {
            this.ctx.closePath();
          },
          stroke: function CanvasGraphics_stroke(consumePath) {
            consumePath = typeof consumePath !== "undefined" ? consumePath : true;
            var ctx = this.ctx;
            var strokeColor = this.current.strokeColor;
            ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
            ctx.globalAlpha = this.current.strokeAlpha;
            if (strokeColor && strokeColor.hasOwnProperty("type") && strokeColor.type === "Pattern") {
              ctx.save();
              ctx.strokeStyle = strokeColor.getPattern(ctx, this);
              ctx.stroke();
              ctx.restore();
            } else {
              ctx.stroke();
            }
            if (consumePath) {
              this.consumePath();
            }
            ctx.globalAlpha = this.current.fillAlpha;
          },
          closeStroke: function CanvasGraphics_closeStroke() {
            this.closePath();
            this.stroke();
          },
          fill: function CanvasGraphics_fill(consumePath) {
            consumePath = typeof consumePath !== "undefined" ? consumePath : true;
            var ctx = this.ctx;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            var needRestore = false;
            if (isPatternFill) {
              ctx.save();
              if (this.baseTransform) {
                ctx.setTransform.apply(ctx, this.baseTransform);
              }
              ctx.fillStyle = fillColor.getPattern(ctx, this);
              needRestore = true;
            }
            if (this.pendingEOFill) {
              ctx.fill("evenodd");
              this.pendingEOFill = false;
            } else {
              ctx.fill();
            }
            if (needRestore) {
              ctx.restore();
            }
            if (consumePath) {
              this.consumePath();
            }
          },
          eoFill: function CanvasGraphics_eoFill() {
            this.pendingEOFill = true;
            this.fill();
          },
          fillStroke: function CanvasGraphics_fillStroke() {
            this.fill(false);
            this.stroke(false);
            this.consumePath();
          },
          eoFillStroke: function CanvasGraphics_eoFillStroke() {
            this.pendingEOFill = true;
            this.fillStroke();
          },
          closeFillStroke: function CanvasGraphics_closeFillStroke() {
            this.closePath();
            this.fillStroke();
          },
          closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
            this.pendingEOFill = true;
            this.closePath();
            this.fillStroke();
          },
          endPath: function CanvasGraphics_endPath() {
            this.consumePath();
          },
          clip: function CanvasGraphics_clip() {
            this.pendingClip = NORMAL_CLIP;
          },
          eoClip: function CanvasGraphics_eoClip() {
            this.pendingClip = EO_CLIP;
          },
          beginText: function CanvasGraphics_beginText() {
            this.current.textMatrix = _util.IDENTITY_MATRIX;
            this.current.textMatrixScale = 1;
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
          },
          endText: function CanvasGraphics_endText() {
            var paths = this.pendingTextPaths;
            var ctx = this.ctx;
            if (paths === undefined) {
              ctx.beginPath();
              return;
            }
            ctx.save();
            ctx.beginPath();
            for (var i = 0; i < paths.length; i++) {
              var path = paths[i];
              ctx.setTransform.apply(ctx, path.transform);
              ctx.translate(path.x, path.y);
              path.addToPath(ctx, path.fontSize);
            }
            ctx.restore();
            ctx.clip();
            ctx.beginPath();
            delete this.pendingTextPaths;
          },
          setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
            this.current.charSpacing = spacing;
          },
          setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
            this.current.wordSpacing = spacing;
          },
          setHScale: function CanvasGraphics_setHScale(scale) {
            this.current.textHScale = scale / 100;
          },
          setLeading: function CanvasGraphics_setLeading(leading) {
            this.current.leading = -leading;
          },
          setFont: function CanvasGraphics_setFont(fontRefName, size) {
            var fontObj = this.commonObjs.get(fontRefName);
            var current = this.current;
            if (!fontObj) {
              throw new Error("Can't find font for " + fontRefName);
            }
            current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
            if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
              (0, _util.warn)("Invalid font matrix for font " + fontRefName);
            }
            if (size < 0) {
              size = -size;
              current.fontDirection = -1;
            } else {
              current.fontDirection = 1;
            }
            this.current.font = fontObj;
            this.current.fontSize = size;
            if (fontObj.isType3Font) {
              return;
            }
            var name = fontObj.loadedName || "sans-serif";
            var bold = fontObj.black ? "900" : fontObj.bold ? "bold" : "normal";
            var italic = fontObj.italic ? "italic" : "normal";
            var typeface = "\"" + name + "\", " + fontObj.fallbackName;
            var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
            this.current.fontSizeScale = size / browserFontSize;
            var rule = italic + " " + bold + " " + browserFontSize + "px " + typeface;
            this.ctx.font = rule;
          },
          setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
            this.current.textRenderingMode = mode;
          },
          setTextRise: function CanvasGraphics_setTextRise(rise) {
            this.current.textRise = rise;
          },
          moveText: function CanvasGraphics_moveText(x, y) {
            this.current.x = this.current.lineX += x;
            this.current.y = this.current.lineY += y;
          },
          setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
            this.setLeading(-y);
            this.moveText(x, y);
          },
          setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
            this.current.textMatrix = [a, b, c, d, e, f];
            this.current.textMatrixScale = Math.sqrt(a * a + b * b);
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
          },
          nextLine: function CanvasGraphics_nextLine() {
            this.moveText(0, this.current.leading);
          },
          paintChar: function CanvasGraphics_paintChar(character, x, y) {
            var ctx = this.ctx;
            var current = this.current;
            var font = current.font;
            var textRenderingMode = current.textRenderingMode;
            var fontSize = current.fontSize / current.fontSizeScale;
            var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
            var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
            var addToPath;
            if (font.disableFontFace || isAddToPathSet) {
              addToPath = font.getPathGenerator(this.commonObjs, character);
            }
            if (font.disableFontFace) {
              ctx.save();
              ctx.translate(x, y);
              ctx.beginPath();
              addToPath(ctx, fontSize);
              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.fill();
              }
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.stroke();
              }
              ctx.restore();
            } else {
              if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
              }
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                ctx.strokeText(character, x, y);
              }
            }
            if (isAddToPathSet) {
              var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
              paths.push({
                transform: ctx.mozCurrentTransform,
                x: x,
                y: y,
                fontSize: fontSize,
                addToPath: addToPath
              });
            }
          },
          get isFontSubpixelAAEnabled() {
            var ctx = this.canvasFactory.create(10, 10).context;
            ctx.scale(1.5, 1);
            ctx.fillText("I", 0, 10);
            var data = ctx.getImageData(0, 0, 10, 10).data;
            var enabled = false;
            for (var i = 3; i < data.length; i += 4) {
              if (data[i] > 0 && data[i] < 255) {
                enabled = true;
                break;
              }
            }
            return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
          },
          showText: function CanvasGraphics_showText(glyphs) {
            var current = this.current;
            var font = current.font;
            if (font.isType3Font) {
              return this.showType3Text(glyphs);
            }
            var fontSize = current.fontSize;
            if (fontSize === 0) {
              return;
            }
            var ctx = this.ctx;
            var fontSizeScale = current.fontSizeScale;
            var charSpacing = current.charSpacing;
            var wordSpacing = current.wordSpacing;
            var fontDirection = current.fontDirection;
            var textHScale = current.textHScale * fontDirection;
            var glyphsLength = glyphs.length;
            var vertical = font.vertical;
            var spacingDir = vertical ? 1 : -1;
            var defaultVMetrics = font.defaultVMetrics;
            var widthAdvanceScale = fontSize * current.fontMatrix[0];
            var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
            ctx.save();
            ctx.transform.apply(ctx, current.textMatrix);
            ctx.translate(current.x, current.y + current.textRise);
            if (current.patternFill) {
              ctx.fillStyle = current.fillColor.getPattern(ctx, this);
            }
            if (fontDirection > 0) {
              ctx.scale(textHScale, -1);
            } else {
              ctx.scale(textHScale, 1);
            }
            var lineWidth = current.lineWidth;
            var scale = current.textMatrixScale;
            if (scale === 0 || lineWidth === 0) {
              var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
              if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                this.cachedGetSinglePixelWidth = null;
                lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
              }
            } else {
              lineWidth /= scale;
            }
            if (fontSizeScale !== 1.0) {
              ctx.scale(fontSizeScale, fontSizeScale);
              lineWidth /= fontSizeScale;
            }
            ctx.lineWidth = lineWidth;
            var x = 0,
              i;
            for (i = 0; i < glyphsLength; ++i) {
              var glyph = glyphs[i];
              if ((0, _util.isNum)(glyph)) {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
              }
              var restoreNeeded = false;
              var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
              var character = glyph.fontChar;
              var accent = glyph.accent;
              var scaledX, scaledY, scaledAccentX, scaledAccentY;
              var width = glyph.width;
              if (vertical) {
                var vmetric, vx, vy;
                vmetric = glyph.vmetric || defaultVMetrics;
                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                vx = -vx * widthAdvanceScale;
                vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
              } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
              }
              if (font.remeasure && width > 0) {
                var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                  var characterScaleX = width / measuredWidth;
                  restoreNeeded = true;
                  ctx.save();
                  ctx.scale(characterScaleX, 1);
                  scaledX /= characterScaleX;
                } else if (width !== measuredWidth) {
                  scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                }
              }
              if (glyph.isInFont || font.missingFile) {
                if (simpleFillText && !accent) {
                  ctx.fillText(character, scaledX, scaledY);
                } else {
                  this.paintChar(character, scaledX, scaledY);
                  if (accent) {
                    scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
                    scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
                    this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
                  }
                }
              }
              var charWidth = width * widthAdvanceScale + spacing * fontDirection;
              x += charWidth;
              if (restoreNeeded) {
                ctx.restore();
              }
            }
            if (vertical) {
              current.y -= x * textHScale;
            } else {
              current.x += x * textHScale;
            }
            ctx.restore();
          },
          showType3Text: function CanvasGraphics_showType3Text(glyphs) {
            var ctx = this.ctx;
            var current = this.current;
            var font = current.font;
            var fontSize = current.fontSize;
            var fontDirection = current.fontDirection;
            var spacingDir = font.vertical ? 1 : -1;
            var charSpacing = current.charSpacing;
            var wordSpacing = current.wordSpacing;
            var textHScale = current.textHScale * fontDirection;
            var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
            var glyphsLength = glyphs.length;
            var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
            var i, glyph, width, spacingLength;
            if (isTextInvisible || fontSize === 0) {
              return;
            }
            this.cachedGetSinglePixelWidth = null;
            ctx.save();
            ctx.transform.apply(ctx, current.textMatrix);
            ctx.translate(current.x, current.y);
            ctx.scale(textHScale, fontDirection);
            for (i = 0; i < glyphsLength; ++i) {
              glyph = glyphs[i];
              if ((0, _util.isNum)(glyph)) {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
              }
              var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
              var operatorList = font.charProcOperatorList[glyph.operatorListId];
              if (!operatorList) {
                (0, _util.warn)("Type3 character \"" + glyph.operatorListId + "\" is not available.");
                continue;
              }
              this.processingType3 = glyph;
              this.save();
              ctx.scale(fontSize, fontSize);
              ctx.transform.apply(ctx, fontMatrix);
              this.executeOperatorList(operatorList);
              this.restore();
              var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
              width = transformed[0] * fontSize + spacing;
              ctx.translate(width, 0);
              current.x += width * textHScale;
            }
            ctx.restore();
            this.processingType3 = null;
          },
          setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
          setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
            this.ctx.rect(llx, lly, urx - llx, ury - lly);
            this.clip();
            this.endPath();
          },
          getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
            var _this = this;

            var pattern;
            if (IR[0] === "TilingPattern") {
              var color = IR[1];
              var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
              var canvasGraphicsFactory = {
                createCanvasGraphics: function createCanvasGraphics(ctx) {
                  return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
                }
              };
              pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
            } else {
              pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
            }
            return pattern;
          },
          setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
            this.current.strokeColor = this.getColorN_Pattern(arguments);
          },
          setFillColorN: function CanvasGraphics_setFillColorN() {
            this.current.fillColor = this.getColorN_Pattern(arguments);
            this.current.patternFill = true;
          },
          setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
            var color = _util.Util.makeCssRgb(r, g, b);
            this.ctx.strokeStyle = color;
            this.current.strokeColor = color;
          },
          setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
            var color = _util.Util.makeCssRgb(r, g, b);
            this.ctx.fillStyle = color;
            this.current.fillColor = color;
            this.current.patternFill = false;
          },
          shadingFill: function CanvasGraphics_shadingFill(patternIR) {
            var ctx = this.ctx;
            this.save();
            var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
            ctx.fillStyle = pattern.getPattern(ctx, this, true);
            var inv = ctx.mozCurrentTransformInverse;
            if (inv) {
              var canvas = ctx.canvas;
              var width = canvas.width;
              var height = canvas.height;
              var bl = _util.Util.applyTransform([0, 0], inv);
              var br = _util.Util.applyTransform([0, height], inv);
              var ul = _util.Util.applyTransform([width, 0], inv);
              var ur = _util.Util.applyTransform([width, height], inv);
              var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
              var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
              var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
              var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
              this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
            } else {
              this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
            }
            this.restore();
          },
          beginInlineImage: function CanvasGraphics_beginInlineImage() {
            throw new Error("Should not call beginInlineImage");
          },
          beginImageData: function CanvasGraphics_beginImageData() {
            throw new Error("Should not call beginImageData");
          },
          paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
            this.save();
            this.baseTransformStack.push(this.baseTransform);
            if (Array.isArray(matrix) && matrix.length === 6) {
              this.transform.apply(this, matrix);
            }
            this.baseTransform = this.ctx.mozCurrentTransform;
            if (Array.isArray(bbox) && bbox.length === 4) {
              var width = bbox[2] - bbox[0];
              var height = bbox[3] - bbox[1];
              this.ctx.rect(bbox[0], bbox[1], width, height);
              this.clip();
              this.endPath();
            }
          },
          paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
            this.restore();
            this.baseTransform = this.baseTransformStack.pop();
          },
          beginGroup: function CanvasGraphics_beginGroup(group) {
            this.save();
            var currentCtx = this.ctx;
            if (!group.isolated) {
              (0, _util.info)("TODO: Support non-isolated groups.");
            }
            if (group.knockout) {
              (0, _util.warn)("Knockout groups not supported.");
            }
            var currentTransform = currentCtx.mozCurrentTransform;
            if (group.matrix) {
              currentCtx.transform.apply(currentCtx, group.matrix);
            }
            if (!group.bbox) {
              throw new Error("Bounding box is required.");
            }
            var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
            var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
            bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
            var offsetX = Math.floor(bounds[0]);
            var offsetY = Math.floor(bounds[1]);
            var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
            var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
            var scaleX = 1,
              scaleY = 1;
            if (drawnWidth > MAX_GROUP_SIZE) {
              scaleX = drawnWidth / MAX_GROUP_SIZE;
              drawnWidth = MAX_GROUP_SIZE;
            }
            if (drawnHeight > MAX_GROUP_SIZE) {
              scaleY = drawnHeight / MAX_GROUP_SIZE;
              drawnHeight = MAX_GROUP_SIZE;
            }
            var cacheId = "groupAt" + this.groupLevel;
            if (group.smask) {
              cacheId += "_smask_" + this.smaskCounter++ % 2;
            }
            var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
            var groupCtx = scratchCanvas.context;
            groupCtx.scale(1 / scaleX, 1 / scaleY);
            groupCtx.translate(-offsetX, -offsetY);
            groupCtx.transform.apply(groupCtx, currentTransform);
            if (group.smask) {
              this.smaskStack.push({
                canvas: scratchCanvas.canvas,
                context: groupCtx,
                offsetX: offsetX,
                offsetY: offsetY,
                scaleX: scaleX,
                scaleY: scaleY,
                subtype: group.smask.subtype,
                backdrop: group.smask.backdrop,
                transferMap: group.smask.transferMap || null,
                startTransformInverse: null
              });
            } else {
              currentCtx.setTransform(1, 0, 0, 1, 0, 0);
              currentCtx.translate(offsetX, offsetY);
              currentCtx.scale(scaleX, scaleY);
            }
            copyCtxState(currentCtx, groupCtx);
            this.ctx = groupCtx;
            this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
            this.groupStack.push(currentCtx);
            this.groupLevel++;
            this.current.activeSMask = null;
          },
          endGroup: function CanvasGraphics_endGroup(group) {
            this.groupLevel--;
            var groupCtx = this.ctx;
            this.ctx = this.groupStack.pop();
            if (this.ctx.imageSmoothingEnabled !== undefined) {
              this.ctx.imageSmoothingEnabled = false;
            } else {
              this.ctx.mozImageSmoothingEnabled = false;
            }
            if (group.smask) {
              this.tempSMask = this.smaskStack.pop();
            } else {
              this.ctx.drawImage(groupCtx.canvas, 0, 0);
            }
            this.restore();
          },
          beginAnnotations: function CanvasGraphics_beginAnnotations() {
            this.save();
            if (this.baseTransform) {
              this.ctx.setTransform.apply(this.ctx, this.baseTransform);
            }
          },
          endAnnotations: function CanvasGraphics_endAnnotations() {
            this.restore();
          },
          beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
            this.save();
            resetCtxToDefault(this.ctx);
            this.current = new CanvasExtraState();
            if (Array.isArray(rect) && rect.length === 4) {
              var width = rect[2] - rect[0];
              var height = rect[3] - rect[1];
              this.ctx.rect(rect[0], rect[1], width, height);
              this.clip();
              this.endPath();
            }
            this.transform.apply(this, transform);
            this.transform.apply(this, matrix);
          },
          endAnnotation: function CanvasGraphics_endAnnotation() {
            this.restore();
          },
          paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
            var domImage = this.objs.get(objId);
            if (!domImage) {
              (0, _util.warn)("Dependent image isn't ready yet");
              return;
            }
            this.save();
            var ctx = this.ctx;
            ctx.scale(1 / w, -1 / h);
            ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
            if (this.imageLayer) {
              var currentTransform = ctx.mozCurrentTransformInverse;
              var position = this.getCanvasPosition(0, 0);
              this.imageLayer.appendImage({
                objId: objId,
                left: position[0],
                top: position[1],
                width: w / currentTransform[0],
                height: h / currentTransform[3]
              });
            }
            this.restore();
          },
          paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
            var ctx = this.ctx;
            var width = img.width,
              height = img.height;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            var glyph = this.processingType3;
            if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
              if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
                glyph.compiled = compileType3Glyph({
                  data: img.data,
                  width: width,
                  height: height
                });
              } else {
                glyph.compiled = null;
              }
            }
            if (glyph && glyph.compiled) {
              glyph.compiled(ctx);
              return;
            }
            var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            var maskCtx = maskCanvas.context;
            maskCtx.save();
            putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            this.paintInlineImageXObject(maskCanvas.canvas);
          },
          paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
            var width = imgData.width;
            var height = imgData.height;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            var maskCtx = maskCanvas.context;
            maskCtx.save();
            putBinaryImageMask(maskCtx, imgData);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            var ctx = this.ctx;
            for (var i = 0, ii = positions.length; i < ii; i += 2) {
              ctx.save();
              ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
              ctx.scale(1, -1);
              ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
              ctx.restore();
            }
          },
          paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
            var ctx = this.ctx;
            var fillColor = this.current.fillColor;
            var isPatternFill = this.current.patternFill;
            for (var i = 0, ii = images.length; i < ii; i++) {
              var image = images[i];
              var width = image.width,
                height = image.height;
              var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
              var maskCtx = maskCanvas.context;
              maskCtx.save();
              putBinaryImageMask(maskCtx, image);
              maskCtx.globalCompositeOperation = "source-in";
              maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
              maskCtx.fillRect(0, 0, width, height);
              maskCtx.restore();
              ctx.save();
              ctx.transform.apply(ctx, image.transform);
              ctx.scale(1, -1);
              ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
              ctx.restore();
            }
          },
          paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
            var imgData = this.objs.get(objId);
            if (!imgData) {
              (0, _util.warn)("Dependent image isn't ready yet");
              return;
            }
            this.paintInlineImageXObject(imgData);
          },
          paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
            var imgData = this.objs.get(objId);
            if (!imgData) {
              (0, _util.warn)("Dependent image isn't ready yet");
              return;
            }
            var width = imgData.width;
            var height = imgData.height;
            var map = [];
            for (var i = 0, ii = positions.length; i < ii; i += 2) {
              map.push({
                transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
                x: 0,
                y: 0,
                w: width,
                h: height
              });
            }
            this.paintInlineImageXObjectGroup(imgData, map);
          },
          paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
            var width = imgData.width;
            var height = imgData.height;
            var ctx = this.ctx;
            this.save();
            ctx.scale(1 / width, -1 / height);
            var currentTransform = ctx.mozCurrentTransformInverse;
            var a = currentTransform[0],
              b = currentTransform[1];
            var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
            var c = currentTransform[2],
              d = currentTransform[3];
            var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
            var imgToPaint, tmpCanvas;
            if (imgData instanceof HTMLElement || !imgData.data) {
              imgToPaint = imgData;
            } else {
              tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
              var tmpCtx = tmpCanvas.context;
              putBinaryImageData(tmpCtx, imgData);
              imgToPaint = tmpCanvas.canvas;
            }
            var paintWidth = width,
              paintHeight = height;
            var tmpCanvasId = "prescale1";
            while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
              var newWidth = paintWidth,
                newHeight = paintHeight;
              if (widthScale > 2 && paintWidth > 1) {
                newWidth = Math.ceil(paintWidth / 2);
                widthScale /= paintWidth / newWidth;
              }
              if (heightScale > 2 && paintHeight > 1) {
                newHeight = Math.ceil(paintHeight / 2);
                heightScale /= paintHeight / newHeight;
              }
              tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
              tmpCtx = tmpCanvas.context;
              tmpCtx.clearRect(0, 0, newWidth, newHeight);
              tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
              imgToPaint = tmpCanvas.canvas;
              paintWidth = newWidth;
              paintHeight = newHeight;
              tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
            }
            ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
            if (this.imageLayer) {
              var position = this.getCanvasPosition(0, -height);
              this.imageLayer.appendImage({
                imgData: imgData,
                left: position[0],
                top: position[1],
                width: width / currentTransform[0],
                height: height / currentTransform[3]
              });
            }
            this.restore();
          },
          paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
            var ctx = this.ctx;
            var w = imgData.width;
            var h = imgData.height;
            var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
            var tmpCtx = tmpCanvas.context;
            putBinaryImageData(tmpCtx, imgData);
            for (var i = 0, ii = map.length; i < ii; i++) {
              var entry = map[i];
              ctx.save();
              ctx.transform.apply(ctx, entry.transform);
              ctx.scale(1, -1);
              ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
              if (this.imageLayer) {
                var position = this.getCanvasPosition(entry.x, entry.y);
                this.imageLayer.appendImage({
                  imgData: imgData,
                  left: position[0],
                  top: position[1],
                  width: w,
                  height: h
                });
              }
              ctx.restore();
            }
          },
          paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
            this.ctx.fillRect(0, 0, 1, 1);
          },
          paintXObject: function CanvasGraphics_paintXObject() {
            (0, _util.warn)("Unsupported 'paintXObject' command.");
          },
          markPoint: function CanvasGraphics_markPoint(tag) {},
          markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
          beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
          beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
          endMarkedContent: function CanvasGraphics_endMarkedContent() {},
          beginCompat: function CanvasGraphics_beginCompat() {},
          endCompat: function CanvasGraphics_endCompat() {},
          consumePath: function CanvasGraphics_consumePath() {
            var ctx = this.ctx;
            if (this.pendingClip) {
              if (this.pendingClip === EO_CLIP) {
                ctx.clip("evenodd");
              } else {
                ctx.clip();
              }
              this.pendingClip = null;
            }
            ctx.beginPath();
          },
          getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
            if (this.cachedGetSinglePixelWidth === null) {
              this.ctx.save();
              var inverse = this.ctx.mozCurrentTransformInverse;
              this.ctx.restore();
              this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
            }
            return this.cachedGetSinglePixelWidth;
          },
          getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
            var transform = this.ctx.mozCurrentTransform;
            return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
          }
        };
        for (var op in _util.OPS) {
          CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
        }
        return CanvasGraphics;
      }();
      exports.CanvasGraphics = CanvasGraphics;

      /***/ }),
    /* 120 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TilingPattern = exports.getShadingPatternFromIR = undefined;

      var _util = __w_pdfjs_require__(0);

      var _webgl = __w_pdfjs_require__(70);

      var ShadingIRs = {};
      ShadingIRs.RadialAxial = {
        fromIR: function RadialAxial_fromIR(raw) {
          var type = raw[1];
          var colorStops = raw[2];
          var p0 = raw[3];
          var p1 = raw[4];
          var r0 = raw[5];
          var r1 = raw[6];
          return {
            type: "Pattern",
            getPattern: function RadialAxial_getPattern(ctx) {
              var grad;
              if (type === "axial") {
                grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
              } else if (type === "radial") {
                grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
              }
              for (var i = 0, ii = colorStops.length; i < ii; ++i) {
                var c = colorStops[i];
                grad.addColorStop(c[0], c[1]);
              }
              return grad;
            }
          };
        }
      };
      var createMeshCanvas = function createMeshCanvasClosure() {
        function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
          var coords = context.coords,
            colors = context.colors;
          var bytes = data.data,
            rowSize = data.width * 4;
          var tmp;
          if (coords[p1 + 1] > coords[p2 + 1]) {
            tmp = p1;
            p1 = p2;
            p2 = tmp;
            tmp = c1;
            c1 = c2;
            c2 = tmp;
          }
          if (coords[p2 + 1] > coords[p3 + 1]) {
            tmp = p2;
            p2 = p3;
            p3 = tmp;
            tmp = c2;
            c2 = c3;
            c3 = tmp;
          }
          if (coords[p1 + 1] > coords[p2 + 1]) {
            tmp = p1;
            p1 = p2;
            p2 = tmp;
            tmp = c1;
            c1 = c2;
            c2 = tmp;
          }
          var x1 = (coords[p1] + context.offsetX) * context.scaleX;
          var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
          var x2 = (coords[p2] + context.offsetX) * context.scaleX;
          var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
          var x3 = (coords[p3] + context.offsetX) * context.scaleX;
          var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
          if (y1 >= y3) {
            return;
          }
          var c1r = colors[c1],
            c1g = colors[c1 + 1],
            c1b = colors[c1 + 2];
          var c2r = colors[c2],
            c2g = colors[c2 + 1],
            c2b = colors[c2 + 2];
          var c3r = colors[c3],
            c3g = colors[c3 + 1],
            c3b = colors[c3 + 2];
          var minY = Math.round(y1),
            maxY = Math.round(y3);
          var xa, car, cag, cab;
          var xb, cbr, cbg, cbb;
          var k;
          for (var y = minY; y <= maxY; y++) {
            if (y < y2) {
              k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
              xa = x1 - (x1 - x2) * k;
              car = c1r - (c1r - c2r) * k;
              cag = c1g - (c1g - c2g) * k;
              cab = c1b - (c1b - c2b) * k;
            } else {
              k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
              xa = x2 - (x2 - x3) * k;
              car = c2r - (c2r - c3r) * k;
              cag = c2g - (c2g - c3g) * k;
              cab = c2b - (c2b - c3b) * k;
            }
            k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
            xb = x1 - (x1 - x3) * k;
            cbr = c1r - (c1r - c3r) * k;
            cbg = c1g - (c1g - c3g) * k;
            cbb = c1b - (c1b - c3b) * k;
            var x1_ = Math.round(Math.min(xa, xb));
            var x2_ = Math.round(Math.max(xa, xb));
            var j = rowSize * y + x1_ * 4;
            for (var x = x1_; x <= x2_; x++) {
              k = (xa - x) / (xa - xb);
              k = k < 0 ? 0 : k > 1 ? 1 : k;
              bytes[j++] = car - (car - cbr) * k | 0;
              bytes[j++] = cag - (cag - cbg) * k | 0;
              bytes[j++] = cab - (cab - cbb) * k | 0;
              bytes[j++] = 255;
            }
          }
        }
        function drawFigure(data, figure, context) {
          var ps = figure.coords;
          var cs = figure.colors;
          var i, ii;
          switch (figure.type) {
            case "lattice":
              var verticesPerRow = figure.verticesPerRow;
              var rows = Math.floor(ps.length / verticesPerRow) - 1;
              var cols = verticesPerRow - 1;
              for (i = 0; i < rows; i++) {
                var q = i * verticesPerRow;
                for (var j = 0; j < cols; j++, q++) {
                  drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                  drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                }
              }
              break;
            case "triangles":
              for (i = 0, ii = ps.length; i < ii; i += 3) {
                drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
              }
              break;
            default:
              throw new Error("illegal figure");
          }
        }
        function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
          var EXPECTED_SCALE = 1.1;
          var MAX_PATTERN_SIZE = 3000;
          var BORDER_SIZE = 2;
          var offsetX = Math.floor(bounds[0]);
          var offsetY = Math.floor(bounds[1]);
          var boundsWidth = Math.ceil(bounds[2]) - offsetX;
          var boundsHeight = Math.ceil(bounds[3]) - offsetY;
          var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
          var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
          var scaleX = boundsWidth / width;
          var scaleY = boundsHeight / height;
          var context = {
            coords: coords,
            colors: colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
          };
          var paddedWidth = width + BORDER_SIZE * 2;
          var paddedHeight = height + BORDER_SIZE * 2;
          var canvas, tmpCanvas, i, ii;
          if (_webgl.WebGLUtils.isEnabled) {
            canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
            tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
            tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
            canvas = tmpCanvas.canvas;
          } else {
            tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
            var tmpCtx = tmpCanvas.context;
            var data = tmpCtx.createImageData(width, height);
            if (backgroundColor) {
              var bytes = data.data;
              for (i = 0, ii = bytes.length; i < ii; i += 4) {
                bytes[i] = backgroundColor[0];
                bytes[i + 1] = backgroundColor[1];
                bytes[i + 2] = backgroundColor[2];
                bytes[i + 3] = 255;
              }
            }
            for (i = 0; i < figures.length; i++) {
              drawFigure(data, figures[i], context);
            }
            tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
            canvas = tmpCanvas.canvas;
          }
          return {
            canvas: canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
          };
        }
        return createMeshCanvas;
      }();
      ShadingIRs.Mesh = {
        fromIR: function Mesh_fromIR(raw) {
          var coords = raw[2];
          var colors = raw[3];
          var figures = raw[4];
          var bounds = raw[5];
          var matrix = raw[6];
          var background = raw[8];
          return {
            type: "Pattern",
            getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
              var scale;
              if (shadingFill) {
                scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
              } else {
                scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                if (matrix) {
                  var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
                  scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
                }
              }
              var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
              if (!shadingFill) {
                ctx.setTransform.apply(ctx, owner.baseTransform);
                if (matrix) {
                  ctx.transform.apply(ctx, matrix);
                }
              }
              ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
              ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
              return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
            }
          };
        }
      };
      ShadingIRs.Dummy = {
        fromIR: function Dummy_fromIR() {
          return {
            type: "Pattern",
            getPattern: function Dummy_fromIR_getPattern() {
              return "hotpink";
            }
          };
        }
      };
      function getShadingPatternFromIR(raw) {
        var shadingIR = ShadingIRs[raw[0]];
        if (!shadingIR) {
          throw new Error("Unknown IR type: " + raw[0]);
        }
        return shadingIR.fromIR(raw);
      }
      var TilingPattern = function TilingPatternClosure() {
        var PaintType = {
          COLORED: 1,
          UNCOLORED: 2
        };
        var MAX_PATTERN_SIZE = 3000;
        function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
          this.operatorList = IR[2];
          this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
          this.bbox = IR[4];
          this.xstep = IR[5];
          this.ystep = IR[6];
          this.paintType = IR[7];
          this.tilingType = IR[8];
          this.color = color;
          this.canvasGraphicsFactory = canvasGraphicsFactory;
          this.baseTransform = baseTransform;
          this.type = "Pattern";
          this.ctx = ctx;
        }
        TilingPattern.prototype = {
          createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
            var operatorList = this.operatorList;
            var bbox = this.bbox;
            var xstep = this.xstep;
            var ystep = this.ystep;
            var paintType = this.paintType;
            var tilingType = this.tilingType;
            var color = this.color;
            var canvasGraphicsFactory = this.canvasGraphicsFactory;
            (0, _util.info)("TilingType: " + tilingType);
            var x0 = bbox[0],
              y0 = bbox[1],
              x1 = bbox[2],
              y1 = bbox[3];
            var topLeft = [x0, y0];
            var botRight = [x0 + xstep, y0 + ystep];
            var width = botRight[0] - topLeft[0];
            var height = botRight[1] - topLeft[1];
            var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
            var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
            var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
            width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
            height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
            var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
            var tmpCtx = tmpCanvas.context;
            var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
            graphics.groupLevel = owner.groupLevel;
            this.setFillAndStrokeStyleToContext(graphics, paintType, color);
            this.setScale(width, height, xstep, ystep);
            this.transformToScale(graphics);
            var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
            graphics.transform.apply(graphics, tmpTranslate);
            this.clipBbox(graphics, bbox, x0, y0, x1, y1);
            graphics.executeOperatorList(operatorList);
            return tmpCanvas.canvas;
          },
          setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
            this.scale = [width / xstep, height / ystep];
          },
          transformToScale: function TilingPattern_transformToScale(graphics) {
            var scale = this.scale;
            var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
            graphics.transform.apply(graphics, tmpScale);
          },
          scaleToContext: function TilingPattern_scaleToContext() {
            var scale = this.scale;
            this.ctx.scale(1 / scale[0], 1 / scale[1]);
          },
          clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
            if (Array.isArray(bbox) && bbox.length === 4) {
              var bboxWidth = x1 - x0;
              var bboxHeight = y1 - y0;
              graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
              graphics.clip();
              graphics.endPath();
            }
          },
          setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
            var context = graphics.ctx,
              current = graphics.current;
            switch (paintType) {
              case PaintType.COLORED:
                var ctx = this.ctx;
                context.fillStyle = ctx.fillStyle;
                context.strokeStyle = ctx.strokeStyle;
                current.fillColor = ctx.fillStyle;
                current.strokeColor = ctx.strokeStyle;
                break;
              case PaintType.UNCOLORED:
                var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
                context.fillStyle = cssColor;
                context.strokeStyle = cssColor;
                current.fillColor = cssColor;
                current.strokeColor = cssColor;
                break;
              default:
                throw new _util.FormatError("Unsupported paint type: " + paintType);
            }
          },
          getPattern: function TilingPattern_getPattern(ctx, owner) {
            var temporaryPatternCanvas = this.createPatternCanvas(owner);
            ctx = this.ctx;
            ctx.setTransform.apply(ctx, this.baseTransform);
            ctx.transform.apply(ctx, this.matrix);
            this.scaleToContext();
            return ctx.createPattern(temporaryPatternCanvas, "repeat");
          }
        };
        return TilingPattern;
      }();
      exports.getShadingPatternFromIR = getShadingPatternFromIR;
      exports.TilingPattern = TilingPattern;

      /***/ }),
    /* 121 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFDataTransportStream = undefined;

      var _util = __w_pdfjs_require__(0);

      var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
        function PDFDataTransportStream(params, pdfDataRangeTransport) {
          var _this = this;

          (0, _util.assert)(pdfDataRangeTransport);
          this._queuedChunks = [];
          var initialData = params.initialData;
          if (initialData && initialData.length > 0) {
            var buffer = new Uint8Array(initialData).buffer;
            this._queuedChunks.push(buffer);
          }
          this._pdfDataRangeTransport = pdfDataRangeTransport;
          this._isRangeSupported = !params.disableRange;
          this._isStreamingSupported = !params.disableStream;
          this._contentLength = params.length;
          this._fullRequestReader = null;
          this._rangeReaders = [];
          this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
            _this._onReceiveData({
              begin: begin,
              chunk: chunk
            });
          });
          this._pdfDataRangeTransport.addProgressListener(function (loaded) {
            _this._onProgress({ loaded: loaded });
          });
          this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
            _this._onReceiveData({ chunk: chunk });
          });
          this._pdfDataRangeTransport.transportReady();
        }
        PDFDataTransportStream.prototype = {
          _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
            var buffer = new Uint8Array(args.chunk).buffer;
            if (args.begin === undefined) {
              if (this._fullRequestReader) {
                this._fullRequestReader._enqueue(buffer);
              } else {
                this._queuedChunks.push(buffer);
              }
            } else {
              var found = this._rangeReaders.some(function (rangeReader) {
                if (rangeReader._begin !== args.begin) {
                  return false;
                }
                rangeReader._enqueue(buffer);
                return true;
              });
              (0, _util.assert)(found);
            }
          },
          _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
            if (this._rangeReaders.length > 0) {
              var firstReader = this._rangeReaders[0];
              if (firstReader.onProgress) {
                firstReader.onProgress({ loaded: evt.loaded });
              }
            }
          },
          _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
            var i = this._rangeReaders.indexOf(reader);
            if (i >= 0) {
              this._rangeReaders.splice(i, 1);
            }
          },
          getFullReader: function PDFDataTransportStream_getFullReader() {
            (0, _util.assert)(!this._fullRequestReader);
            var queuedChunks = this._queuedChunks;
            this._queuedChunks = null;
            return new PDFDataTransportStreamReader(this, queuedChunks);
          },
          getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
            var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
            this._pdfDataRangeTransport.requestDataRange(begin, end);
            this._rangeReaders.push(reader);
            return reader;
          },
          cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason);
            }
            var readers = this._rangeReaders.slice(0);
            readers.forEach(function (rangeReader) {
              rangeReader.cancel(reason);
            });
            this._pdfDataRangeTransport.abort();
          }
        };
        function PDFDataTransportStreamReader(stream, queuedChunks) {
          this._stream = stream;
          this._done = false;
          this._queuedChunks = queuedChunks || [];
          this._requests = [];
          this._headersReady = Promise.resolve();
          stream._fullRequestReader = this;
          this.onProgress = null;
        }
        PDFDataTransportStreamReader.prototype = {
          _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
            if (this._done) {
              return;
            }
            if (this._requests.length > 0) {
              var requestCapability = this._requests.shift();
              requestCapability.resolve({
                value: chunk,
                done: false
              });
              return;
            }
            this._queuedChunks.push(chunk);
          },
          get headersReady() {
            return this._headersReady;
          },
          get isRangeSupported() {
            return this._stream._isRangeSupported;
          },
          get isStreamingSupported() {
            return this._stream._isStreamingSupported;
          },
          get contentLength() {
            return this._stream._contentLength;
          },
          read: function PDFDataTransportStreamReader_read() {
            if (this._queuedChunks.length > 0) {
              var chunk = this._queuedChunks.shift();
              return Promise.resolve({
                value: chunk,
                done: false
              });
            }
            if (this._done) {
              return Promise.resolve({
                value: undefined,
                done: true
              });
            }
            var requestCapability = (0, _util.createPromiseCapability)();
            this._requests.push(requestCapability);
            return requestCapability.promise;
          },
          cancel: function PDFDataTransportStreamReader_cancel(reason) {
            this._done = true;
            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              });
            });
            this._requests = [];
          }
        };
        function PDFDataTransportStreamRangeReader(stream, begin, end) {
          this._stream = stream;
          this._begin = begin;
          this._end = end;
          this._queuedChunk = null;
          this._requests = [];
          this._done = false;
          this.onProgress = null;
        }
        PDFDataTransportStreamRangeReader.prototype = {
          _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
            if (this._done) {
              return;
            }
            if (this._requests.length === 0) {
              this._queuedChunk = chunk;
            } else {
              var requestsCapability = this._requests.shift();
              requestsCapability.resolve({
                value: chunk,
                done: false
              });
              this._requests.forEach(function (requestCapability) {
                requestCapability.resolve({
                  value: undefined,
                  done: true
                });
              });
              this._requests = [];
            }
            this._done = true;
            this._stream._removeRangeReader(this);
          },
          get isStreamingSupported() {
            return false;
          },
          read: function PDFDataTransportStreamRangeReader_read() {
            if (this._queuedChunk) {
              var chunk = this._queuedChunk;
              this._queuedChunk = null;
              return Promise.resolve({
                value: chunk,
                done: false
              });
            }
            if (this._done) {
              return Promise.resolve({
                value: undefined,
                done: true
              });
            }
            var requestCapability = (0, _util.createPromiseCapability)();
            this._requests.push(requestCapability);
            return requestCapability.promise;
          },
          cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
            this._done = true;
            this._requests.forEach(function (requestCapability) {
              requestCapability.resolve({
                value: undefined,
                done: true
              });
            });
            this._requests = [];
            this._stream._removeRangeReader(this);
          }
        };
        return PDFDataTransportStream;
      }();
      exports.PDFDataTransportStream = PDFDataTransportStream;

      /***/ }),
    /* 122 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFNodeStream = undefined;

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _util = __w_pdfjs_require__(0);

      var _network_utils = __w_pdfjs_require__(44);

      function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

      function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var fs = require("fs");
      var http = require("http");
      var https = require("https");
      var url = require("url");

      var PDFNodeStream = function () {
        function PDFNodeStream(options) {
          _classCallCheck(this, PDFNodeStream);

          this.options = options;
          this.source = options.source;
          this.url = url.parse(this.source.url);
          this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
          this.isFsUrl = this.url.protocol === "file:" || !this.url.host;
          this.httpHeaders = this.isHttp && this.source.httpHeaders || {};
          this._fullRequest = null;
          this._rangeRequestReaders = [];
        }

        _createClass(PDFNodeStream, [{
          key: "getFullReader",
          value: function getFullReader() {
            (0, _util.assert)(!this._fullRequest);
            this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
            return this._fullRequest;
          }
        }, {
          key: "getRangeReader",
          value: function getRangeReader(start, end) {
            var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
            this._rangeRequestReaders.push(rangeReader);
            return rangeReader;
          }
        }, {
          key: "cancelAllRequests",
          value: function cancelAllRequests(reason) {
            if (this._fullRequest) {
              this._fullRequest.cancel(reason);
            }
            var readers = this._rangeRequestReaders.slice(0);
            readers.forEach(function (reader) {
              reader.cancel(reason);
            });
          }
        }]);

        return PDFNodeStream;
      }();

      var BaseFullReader = function () {
        function BaseFullReader(stream) {
          _classCallCheck(this, BaseFullReader);

          this._url = stream.url;
          this._done = false;
          this._errored = false;
          this._reason = null;
          this.onProgress = null;
          this._contentLength = stream.source.length;
          this._loaded = 0;
          this._disableRange = stream.options.disableRange || false;
          this._rangeChunkSize = stream.source.rangeChunkSize;
          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
          }
          this._isStreamingSupported = !stream.source.disableStream;
          this._isRangeSupported = !stream.options.disableRange;
          this._readableStream = null;
          this._readCapability = (0, _util.createPromiseCapability)();
          this._headersCapability = (0, _util.createPromiseCapability)();
        }

        _createClass(BaseFullReader, [{
          key: "read",
          value: function read() {
            var _this = this;

            return this._readCapability.promise.then(function () {
              if (_this._done) {
                return Promise.resolve({
                  value: undefined,
                  done: true
                });
              }
              if (_this._errored) {
                return Promise.reject(_this._reason);
              }
              var chunk = _this._readableStream.read();
              if (chunk === null) {
                _this._readCapability = (0, _util.createPromiseCapability)();
                return _this.read();
              }
              _this._loaded += chunk.length;
              if (_this.onProgress) {
                _this.onProgress({
                  loaded: _this._loaded,
                  total: _this._contentLength
                });
              }
              var buffer = new Uint8Array(chunk).buffer;
              return Promise.resolve({
                value: buffer,
                done: false
              });
            });
          }
        }, {
          key: "cancel",
          value: function cancel(reason) {
            if (!this._readableStream) {
              this._error(reason);
              return;
            }
            this._readableStream.destroy(reason);
          }
        }, {
          key: "_error",
          value: function _error(reason) {
            this._errored = true;
            this._reason = reason;
            this._readCapability.resolve();
          }
        }, {
          key: "_setReadableStream",
          value: function _setReadableStream(readableStream) {
            var _this2 = this;

            this._readableStream = readableStream;
            readableStream.on("readable", function () {
              _this2._readCapability.resolve();
            });
            readableStream.on("end", function () {
              readableStream.destroy();
              _this2._done = true;
              _this2._readCapability.resolve();
            });
            readableStream.on("error", function (reason) {
              _this2._error(reason);
            });
            if (!this._isStreamingSupported && this._isRangeSupported) {
              this._error(new _util.AbortException("streaming is disabled"));
            }
            if (this._errored) {
              this._readableStream.destroy(this._reason);
            }
          }
        }, {
          key: "headersReady",
          get: function get() {
            return this._headersCapability.promise;
          }
        }, {
          key: "contentLength",
          get: function get() {
            return this._contentLength;
          }
        }, {
          key: "isRangeSupported",
          get: function get() {
            return this._isRangeSupported;
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }]);

        return BaseFullReader;
      }();

      var BaseRangeReader = function () {
        function BaseRangeReader(stream) {
          _classCallCheck(this, BaseRangeReader);

          this._url = stream.url;
          this._done = false;
          this._errored = false;
          this._reason = null;
          this.onProgress = null;
          this._loaded = 0;
          this._readableStream = null;
          this._readCapability = (0, _util.createPromiseCapability)();
          this._isStreamingSupported = !stream.source.disableStream;
        }

        _createClass(BaseRangeReader, [{
          key: "read",
          value: function read() {
            var _this3 = this;

            return this._readCapability.promise.then(function () {
              if (_this3._done) {
                return Promise.resolve({
                  value: undefined,
                  done: true
                });
              }
              if (_this3._errored) {
                return Promise.reject(_this3._reason);
              }
              var chunk = _this3._readableStream.read();
              if (chunk === null) {
                _this3._readCapability = (0, _util.createPromiseCapability)();
                return _this3.read();
              }
              _this3._loaded += chunk.length;
              if (_this3.onProgress) {
                _this3.onProgress({ loaded: _this3._loaded });
              }
              var buffer = new Uint8Array(chunk).buffer;
              return Promise.resolve({
                value: buffer,
                done: false
              });
            });
          }
        }, {
          key: "cancel",
          value: function cancel(reason) {
            if (!this._readableStream) {
              this._error(reason);
              return;
            }
            this._readableStream.destroy(reason);
          }
        }, {
          key: "_error",
          value: function _error(reason) {
            this._errored = true;
            this._reason = reason;
            this._readCapability.resolve();
          }
        }, {
          key: "_setReadableStream",
          value: function _setReadableStream(readableStream) {
            var _this4 = this;

            this._readableStream = readableStream;
            readableStream.on("readable", function () {
              _this4._readCapability.resolve();
            });
            readableStream.on("end", function () {
              readableStream.destroy();
              _this4._done = true;
              _this4._readCapability.resolve();
            });
            readableStream.on("error", function (reason) {
              _this4._error(reason);
            });
            if (this._errored) {
              this._readableStream.destroy(this._reason);
            }
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }]);

        return BaseRangeReader;
      }();

      function createRequestOptions(url, headers) {
        return {
          protocol: url.protocol,
          auth: url.auth,
          host: url.hostname,
          port: url.port,
          path: url.path,
          method: "GET",
          headers: headers
        };
      }

      var PDFNodeStreamFullReader = function (_BaseFullReader) {
        _inherits(PDFNodeStreamFullReader, _BaseFullReader);

        function PDFNodeStreamFullReader(stream) {
          _classCallCheck(this, PDFNodeStreamFullReader);

          var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));

          var handleResponse = function handleResponse(response) {
            _this5._headersCapability.resolve();
            _this5._setReadableStream(response);

            var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                getResponseHeader: function getResponseHeader(name) {
                  return _this5._readableStream.headers[name.toLowerCase()];
                },
                isHttp: stream.isHttp,
                rangeChunkSize: _this5._rangeChunkSize,
                disableRange: _this5._disableRange
              }),
              allowRangeRequests = _validateRangeRequest.allowRangeRequests,
              suggestedLength = _validateRangeRequest.suggestedLength;

            if (allowRangeRequests) {
              _this5._isRangeSupported = true;
            }
            _this5._contentLength = suggestedLength;
          };
          _this5._request = null;
          if (_this5._url.protocol === "http:") {
            _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
          } else {
            _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
          }
          _this5._request.on("error", function (reason) {
            _this5._errored = true;
            _this5._reason = reason;
            _this5._headersCapability.reject(reason);
          });
          _this5._request.end();
          return _this5;
        }

        return PDFNodeStreamFullReader;
      }(BaseFullReader);

      var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
        _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);

        function PDFNodeStreamRangeReader(stream, start, end) {
          _classCallCheck(this, PDFNodeStreamRangeReader);

          var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));

          _this6._httpHeaders = {};
          for (var property in stream.httpHeaders) {
            var value = stream.httpHeaders[property];
            if (typeof value === "undefined") {
              continue;
            }
            _this6._httpHeaders[property] = value;
          }
          _this6._httpHeaders["Range"] = "bytes=" + start + "-" + (end - 1);
          _this6._request = null;
          if (_this6._url.protocol === "http:") {
            _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
              _this6._setReadableStream(response);
            });
          } else {
            _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
              _this6._setReadableStream(response);
            });
          }
          _this6._request.on("error", function (reason) {
            _this6._errored = true;
            _this6._reason = reason;
          });
          _this6._request.end();
          return _this6;
        }

        return PDFNodeStreamRangeReader;
      }(BaseRangeReader);

      var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
        _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);

        function PDFNodeStreamFsFullReader(stream) {
          _classCallCheck(this, PDFNodeStreamFsFullReader);

          var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));

          var path = decodeURI(_this7._url.path);
          fs.lstat(path, function (error, stat) {
            if (error) {
              _this7._errored = true;
              _this7._reason = error;
              _this7._headersCapability.reject(error);
              return;
            }
            _this7._contentLength = stat.size;
            _this7._setReadableStream(fs.createReadStream(path));
            _this7._headersCapability.resolve();
          });
          return _this7;
        }

        return PDFNodeStreamFsFullReader;
      }(BaseFullReader);

      var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
        _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);

        function PDFNodeStreamFsRangeReader(stream, start, end) {
          _classCallCheck(this, PDFNodeStreamFsRangeReader);

          var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));

          _this8._setReadableStream(fs.createReadStream(decodeURI(_this8._url.path), {
            start: start,
            end: end - 1
          }));
          return _this8;
        }

        return PDFNodeStreamFsRangeReader;
      }(BaseRangeReader);

      exports.PDFNodeStream = PDFNodeStream;

      /***/ }),
    /* 123 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFFetchStream = undefined;

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _util = __w_pdfjs_require__(0);

      var _network_utils = __w_pdfjs_require__(44);

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      function createFetchOptions(headers, withCredentials) {
        return {
          method: "GET",
          headers: headers,
          mode: "cors",
          credentials: withCredentials ? "include" : "same-origin",
          redirect: "follow"
        };
      }

      var PDFFetchStream = function () {
        function PDFFetchStream(options) {
          _classCallCheck(this, PDFFetchStream);

          this.options = options;
          this.source = options.source;
          this.isHttp = /^https?:/i.test(this.source.url);
          this.httpHeaders = this.isHttp && this.source.httpHeaders || {};
          this._fullRequestReader = null;
          this._rangeRequestReaders = [];
        }

        _createClass(PDFFetchStream, [{
          key: "getFullReader",
          value: function getFullReader() {
            (0, _util.assert)(!this._fullRequestReader);
            this._fullRequestReader = new PDFFetchStreamReader(this);
            return this._fullRequestReader;
          }
        }, {
          key: "getRangeReader",
          value: function getRangeReader(begin, end) {
            var reader = new PDFFetchStreamRangeReader(this, begin, end);
            this._rangeRequestReaders.push(reader);
            return reader;
          }
        }, {
          key: "cancelAllRequests",
          value: function cancelAllRequests(reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason);
            }
            var readers = this._rangeRequestReaders.slice(0);
            readers.forEach(function (reader) {
              reader.cancel(reason);
            });
          }
        }]);

        return PDFFetchStream;
      }();

      var PDFFetchStreamReader = function () {
        function PDFFetchStreamReader(stream) {
          var _this = this;

          _classCallCheck(this, PDFFetchStreamReader);

          this._stream = stream;
          this._reader = null;
          this._loaded = 0;
          this._withCredentials = stream.source.withCredentials;
          this._contentLength = this._stream.source.length;
          this._headersCapability = (0, _util.createPromiseCapability)();
          this._disableRange = this._stream.options.disableRange;
          this._rangeChunkSize = this._stream.source.rangeChunkSize;
          if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
          }
          this._isRangeSupported = !this._stream.options.disableRange;
          this._isStreamingSupported = !this._stream.source.disableStream;
          this._headers = new Headers();
          for (var property in this._stream.httpHeaders) {
            var value = this._stream.httpHeaders[property];
            if (typeof value === "undefined") {
              continue;
            }
            this._headers.append(property, value);
          }
          var url = this._stream.source.url;
          fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
            if (!(0, _network_utils.validateResponseStatus)(response.status)) {
              throw (0, _network_utils.createResponseStatusError)(response.status, url);
            }
            _this._reader = response.body.getReader();
            _this._headersCapability.resolve();

            var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
                getResponseHeader: function getResponseHeader(name) {
                  return response.headers.get(name);
                },
                isHttp: _this._stream.isHttp,
                rangeChunkSize: _this._rangeChunkSize,
                disableRange: _this._disableRange
              }),
              allowRangeRequests = _validateRangeRequest.allowRangeRequests,
              suggestedLength = _validateRangeRequest.suggestedLength;

            _this._contentLength = suggestedLength;
            _this._isRangeSupported = allowRangeRequests;
            if (!_this._isStreamingSupported && _this._isRangeSupported) {
              _this.cancel(new _util.AbortException("streaming is disabled"));
            }
          }).catch(this._headersCapability.reject);
          this.onProgress = null;
        }

        _createClass(PDFFetchStreamReader, [{
          key: "read",
          value: function read() {
            var _this2 = this;

            return this._headersCapability.promise.then(function () {
              return _this2._reader.read().then(function (_ref) {
                var value = _ref.value,
                  done = _ref.done;

                if (done) {
                  return Promise.resolve({
                    value: value,
                    done: done
                  });
                }
                _this2._loaded += value.byteLength;
                if (_this2.onProgress) {
                  _this2.onProgress({
                    loaded: _this2._loaded,
                    total: _this2._contentLength
                  });
                }
                var buffer = new Uint8Array(value).buffer;
                return Promise.resolve({
                  value: buffer,
                  done: false
                });
              });
            });
          }
        }, {
          key: "cancel",
          value: function cancel(reason) {
            if (this._reader) {
              this._reader.cancel(reason);
            }
          }
        }, {
          key: "headersReady",
          get: function get() {
            return this._headersCapability.promise;
          }
        }, {
          key: "contentLength",
          get: function get() {
            return this._contentLength;
          }
        }, {
          key: "isRangeSupported",
          get: function get() {
            return this._isRangeSupported;
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }]);

        return PDFFetchStreamReader;
      }();

      var PDFFetchStreamRangeReader = function () {
        function PDFFetchStreamRangeReader(stream, begin, end) {
          var _this3 = this;

          _classCallCheck(this, PDFFetchStreamRangeReader);

          this._stream = stream;
          this._reader = null;
          this._loaded = 0;
          this._withCredentials = stream.source.withCredentials;
          this._readCapability = (0, _util.createPromiseCapability)();
          this._isStreamingSupported = !stream.source.disableStream;
          this._headers = new Headers();
          for (var property in this._stream.httpHeaders) {
            var value = this._stream.httpHeaders[property];
            if (typeof value === "undefined") {
              continue;
            }
            this._headers.append(property, value);
          }
          var rangeStr = begin + "-" + (end - 1);
          this._headers.append("Range", "bytes=" + rangeStr);
          var url = this._stream.source.url;
          fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
            if (!(0, _network_utils.validateResponseStatus)(response.status)) {
              throw (0, _network_utils.createResponseStatusError)(response.status, url);
            }
            _this3._readCapability.resolve();
            _this3._reader = response.body.getReader();
          });
          this.onProgress = null;
        }

        _createClass(PDFFetchStreamRangeReader, [{
          key: "read",
          value: function read() {
            var _this4 = this;

            return this._readCapability.promise.then(function () {
              return _this4._reader.read().then(function (_ref2) {
                var value = _ref2.value,
                  done = _ref2.done;

                if (done) {
                  return Promise.resolve({
                    value: value,
                    done: done
                  });
                }
                _this4._loaded += value.byteLength;
                if (_this4.onProgress) {
                  _this4.onProgress({ loaded: _this4._loaded });
                }
                var buffer = new Uint8Array(value).buffer;
                return Promise.resolve({
                  value: buffer,
                  done: false
                });
              });
            });
          }
        }, {
          key: "cancel",
          value: function cancel(reason) {
            if (this._reader) {
              this._reader.cancel(reason);
            }
          }
        }, {
          key: "isStreamingSupported",
          get: function get() {
            return this._isStreamingSupported;
          }
        }]);

        return PDFFetchStreamRangeReader;
      }();

      exports.PDFFetchStream = PDFFetchStream;

      /***/ }),
    /* 124 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.NetworkManager = exports.PDFNetworkStream = undefined;

      var _util = __w_pdfjs_require__(0);

      var _network_utils = __w_pdfjs_require__(44);

      var _global_scope = __w_pdfjs_require__(20);

      var _global_scope2 = _interopRequireDefault(_global_scope);

      function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

      var OK_RESPONSE = 200;
      var PARTIAL_CONTENT_RESPONSE = 206;
      function NetworkManager(url, args) {
        this.url = url;
        args = args || {};
        this.isHttp = /^https?:/i.test(url);
        this.httpHeaders = this.isHttp && args.httpHeaders || {};
        this.withCredentials = args.withCredentials || false;
        this.getXhr = args.getXhr || function NetworkManager_getXhr() {
          return new XMLHttpRequest();
        };
        this.currXhrId = 0;
        this.pendingRequests = Object.create(null);
        this.loadedRequests = Object.create(null);
      }
      function getArrayBuffer(xhr) {
        var data = xhr.response;
        if (typeof data !== "string") {
          return data;
        }
        var array = (0, _util.stringToBytes)(data);
        return array.buffer;
      }
      var supportsMozChunked = function supportsMozChunkedClosure() {
        try {
          var x = new XMLHttpRequest();
          x.open("GET", _global_scope2.default.location.href);
          x.responseType = "moz-chunked-arraybuffer";
          return x.responseType === "moz-chunked-arraybuffer";
        } catch (e) {
          return false;
        }
      }();
      NetworkManager.prototype = {
        requestRange: function NetworkManager_requestRange(begin, end, listeners) {
          var args = {
            begin: begin,
            end: end
          };
          for (var prop in listeners) {
            args[prop] = listeners[prop];
          }
          return this.request(args);
        },
        requestFull: function NetworkManager_requestFull(listeners) {
          return this.request(listeners);
        },
        request: function NetworkManager_request(args) {
          var xhr = this.getXhr();
          var xhrId = this.currXhrId++;
          var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
          xhr.open("GET", this.url);
          xhr.withCredentials = this.withCredentials;
          for (var property in this.httpHeaders) {
            var value = this.httpHeaders[property];
            if (typeof value === "undefined") {
              continue;
            }
            xhr.setRequestHeader(property, value);
          }
          if (this.isHttp && "begin" in args && "end" in args) {
            var rangeStr = args.begin + "-" + (args.end - 1);
            xhr.setRequestHeader("Range", "bytes=" + rangeStr);
            pendingRequest.expectedStatus = 206;
          } else {
            pendingRequest.expectedStatus = 200;
          }
          var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
          if (useMozChunkedLoading) {
            xhr.responseType = "moz-chunked-arraybuffer";
            pendingRequest.onProgressiveData = args.onProgressiveData;
            pendingRequest.mozChunked = true;
          } else {
            xhr.responseType = "arraybuffer";
          }
          if (args.onError) {
            xhr.onerror = function (evt) {
              args.onError(xhr.status);
            };
          }
          xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
          xhr.onprogress = this.onProgress.bind(this, xhrId);
          pendingRequest.onHeadersReceived = args.onHeadersReceived;
          pendingRequest.onDone = args.onDone;
          pendingRequest.onError = args.onError;
          pendingRequest.onProgress = args.onProgress;
          xhr.send(null);
          return xhrId;
        },
        onProgress: function NetworkManager_onProgress(xhrId, evt) {
          var pendingRequest = this.pendingRequests[xhrId];
          if (!pendingRequest) {
            return;
          }
          if (pendingRequest.mozChunked) {
            var chunk = getArrayBuffer(pendingRequest.xhr);
            pendingRequest.onProgressiveData(chunk);
          }
          var onProgress = pendingRequest.onProgress;
          if (onProgress) {
            onProgress(evt);
          }
        },
        onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
          var pendingRequest = this.pendingRequests[xhrId];
          if (!pendingRequest) {
            return;
          }
          var xhr = pendingRequest.xhr;
          if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          if (!(xhrId in this.pendingRequests)) {
            return;
          }
          delete this.pendingRequests[xhrId];
          if (xhr.status === 0 && this.isHttp) {
            if (pendingRequest.onError) {
              pendingRequest.onError(xhr.status);
            }
            return;
          }
          var xhrStatus = xhr.status || OK_RESPONSE;
          var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
          if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
            if (pendingRequest.onError) {
              pendingRequest.onError(xhr.status);
            }
            return;
          }
          this.loadedRequests[xhrId] = true;
          var chunk = getArrayBuffer(xhr);
          if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
            var rangeHeader = xhr.getResponseHeader("Content-Range");
            var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
            var begin = parseInt(matches[1], 10);
            pendingRequest.onDone({
              begin: begin,
              chunk: chunk
            });
          } else if (pendingRequest.onProgressiveData) {
            pendingRequest.onDone(null);
          } else if (chunk) {
            pendingRequest.onDone({
              begin: 0,
              chunk: chunk
            });
          } else if (pendingRequest.onError) {
            pendingRequest.onError(xhr.status);
          }
        },
        hasPendingRequests: function NetworkManager_hasPendingRequests() {
          for (var xhrId in this.pendingRequests) {
            return true;
          }
          return false;
        },
        getRequestXhr: function NetworkManager_getXhr(xhrId) {
          return this.pendingRequests[xhrId].xhr;
        },
        isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
          return !!this.pendingRequests[xhrId].onProgressiveData;
        },
        isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
          return xhrId in this.pendingRequests;
        },
        isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
          return xhrId in this.loadedRequests;
        },
        abortAllRequests: function NetworkManager_abortAllRequests() {
          for (var xhrId in this.pendingRequests) {
            this.abortRequest(xhrId | 0);
          }
        },
        abortRequest: function NetworkManager_abortRequest(xhrId) {
          var xhr = this.pendingRequests[xhrId].xhr;
          delete this.pendingRequests[xhrId];
          xhr.abort();
        }
      };
      function PDFNetworkStream(options) {
        this._options = options;
        var source = options.source;
        this._manager = new NetworkManager(source.url, {
          httpHeaders: source.httpHeaders,
          withCredentials: source.withCredentials
        });
        this._rangeChunkSize = source.rangeChunkSize;
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
      }
      PDFNetworkStream.prototype = {
        _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
          var i = this._rangeRequestReaders.indexOf(reader);
          if (i >= 0) {
            this._rangeRequestReaders.splice(i, 1);
          }
        },
        getFullReader: function PDFNetworkStream_getFullReader() {
          (0, _util.assert)(!this._fullRequestReader);
          this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._options);
          return this._fullRequestReader;
        },
        getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
          var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
          reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
          this._rangeRequestReaders.push(reader);
          return reader;
        },
        cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
          if (this._fullRequestReader) {
            this._fullRequestReader.cancel(reason);
          }
          var readers = this._rangeRequestReaders.slice(0);
          readers.forEach(function (reader) {
            reader.cancel(reason);
          });
        }
      };
      function PDFNetworkStreamFullRequestReader(manager, options) {
        this._manager = manager;
        var source = options.source;
        var args = {
          onHeadersReceived: this._onHeadersReceived.bind(this),
          onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
          onDone: this._onDone.bind(this),
          onError: this._onError.bind(this),
          onProgress: this._onProgress.bind(this)
        };
        this._url = source.url;
        this._fullRequestId = manager.requestFull(args);
        this._headersReceivedCapability = (0, _util.createPromiseCapability)();
        this._disableRange = options.disableRange || false;
        this._contentLength = source.length;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) {
          this._disableRange = true;
        }
        this._isStreamingSupported = false;
        this._isRangeSupported = false;
        this._cachedChunks = [];
        this._requests = [];
        this._done = false;
        this._storedError = undefined;
        this.onProgress = null;
      }
      PDFNetworkStreamFullRequestReader.prototype = {
        _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
          var fullRequestXhrId = this._fullRequestId;
          var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);

          var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
              getResponseHeader: function getResponseHeader(name) {
                return fullRequestXhr.getResponseHeader(name);
              },
              isHttp: this._manager.isHttp,
              rangeChunkSize: this._rangeChunkSize,
              disableRange: this._disableRange
            }),
            allowRangeRequests = _validateRangeRequest.allowRangeRequests,
            suggestedLength = _validateRangeRequest.suggestedLength;

          this._contentLength = suggestedLength || this._contentLength;
          if (allowRangeRequests) {
            this._isRangeSupported = true;
          }
          var networkManager = this._manager;
          if (networkManager.isStreamingRequest(fullRequestXhrId)) {
            this._isStreamingSupported = true;
          } else if (this._isRangeSupported) {
            networkManager.abortRequest(fullRequestXhrId);
          }
          this._headersReceivedCapability.resolve();
        },
        _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
          if (this._requests.length > 0) {
            var requestCapability = this._requests.shift();
            requestCapability.resolve({
              value: chunk,
              done: false
            });
          } else {
            this._cachedChunks.push(chunk);
          }
        },
        _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
          if (args) {
            this._onProgressiveData(args.chunk);
          }
          this._done = true;
          if (this._cachedChunks.length > 0) {
            return;
          }
          this._requests.forEach(function (requestCapability) {
            requestCapability.resolve({
              value: undefined,
              done: true
            });
          });
          this._requests = [];
        },
        _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
          var url = this._url;
          var exception = (0, _network_utils.createResponseStatusError)(status, url);
          this._storedError = exception;
          this._headersReceivedCapability.reject(exception);
          this._requests.forEach(function (requestCapability) {
            requestCapability.reject(exception);
          });
          this._requests = [];
          this._cachedChunks = [];
        },
        _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
          if (this.onProgress) {
            this.onProgress({
              loaded: data.loaded,
              total: data.lengthComputable ? data.total : this._contentLength
            });
          }
        },
        get isRangeSupported() {
          return this._isRangeSupported;
        },
        get isStreamingSupported() {
          return this._isStreamingSupported;
        },
        get contentLength() {
          return this._contentLength;
        },
        get headersReady() {
          return this._headersReceivedCapability.promise;
        },
        read: function PDFNetworkStreamFullRequestReader_read() {
          if (this._storedError) {
            return Promise.reject(this._storedError);
          }
          if (this._cachedChunks.length > 0) {
            var chunk = this._cachedChunks.shift();
            return Promise.resolve({
              value: chunk,
              done: false
            });
          }
          if (this._done) {
            return Promise.resolve({
              value: undefined,
              done: true
            });
          }
          var requestCapability = (0, _util.createPromiseCapability)();
          this._requests.push(requestCapability);
          return requestCapability.promise;
        },
        cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
          this._done = true;
          this._headersReceivedCapability.reject(reason);
          this._requests.forEach(function (requestCapability) {
            requestCapability.resolve({
              value: undefined,
              done: true
            });
          });
          this._requests = [];
          if (this._manager.isPendingRequest(this._fullRequestId)) {
            this._manager.abortRequest(this._fullRequestId);
          }
          this._fullRequestReader = null;
        }
      };
      function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
        this._manager = manager;
        var args = {
          onDone: this._onDone.bind(this),
          onProgress: this._onProgress.bind(this)
        };
        this._requestId = manager.requestRange(begin, end, args);
        this._requests = [];
        this._queuedChunk = null;
        this._done = false;
        this.onProgress = null;
        this.onClosed = null;
      }
      PDFNetworkStreamRangeRequestReader.prototype = {
        _close: function PDFNetworkStreamRangeRequestReader_close() {
          if (this.onClosed) {
            this.onClosed(this);
          }
        },
        _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
          var chunk = data.chunk;
          if (this._requests.length > 0) {
            var requestCapability = this._requests.shift();
            requestCapability.resolve({
              value: chunk,
              done: false
            });
          } else {
            this._queuedChunk = chunk;
          }
          this._done = true;
          this._requests.forEach(function (requestCapability) {
            requestCapability.resolve({
              value: undefined,
              done: true
            });
          });
          this._requests = [];
          this._close();
        },
        _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
          if (!this.isStreamingSupported && this.onProgress) {
            this.onProgress({ loaded: evt.loaded });
          }
        },
        get isStreamingSupported() {
          return false;
        },
        read: function PDFNetworkStreamRangeRequestReader_read() {
          if (this._queuedChunk !== null) {
            var chunk = this._queuedChunk;
            this._queuedChunk = null;
            return Promise.resolve({
              value: chunk,
              done: false
            });
          }
          if (this._done) {
            return Promise.resolve({
              value: undefined,
              done: true
            });
          }
          var requestCapability = (0, _util.createPromiseCapability)();
          this._requests.push(requestCapability);
          return requestCapability.promise;
        },
        cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
          this._done = true;
          this._requests.forEach(function (requestCapability) {
            requestCapability.resolve({
              value: undefined,
              done: true
            });
          });
          this._requests = [];
          if (this._manager.isPendingRequest(this._requestId)) {
            this._manager.abortRequest(this._requestId);
          }
          this._close();
        }
      };
      exports.PDFNetworkStream = PDFNetworkStream;
      exports.NetworkManager = NetworkManager;

      /***/ })
    /** ****/ ]);
});
// # sourceMappingURL=pdf.js.map

/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === "object" && typeof module === "object")
    module.exports = factory();
  else if (typeof define === "function" && define.amd)
    define("pdfjs-dist/build/pdf.worker", [], factory);
  else if (typeof exports === "object")
    exports["pdfjs-dist/build/pdf.worker"] = factory();
  else
    root["pdfjs-dist/build/pdf.worker"] = root.pdfjsDistBuildPdfWorker = factory();
})(this, function () {
  return /** ****/ (function (modules) { // webpackBootstrap
    /** ****/ 	// The module cache
    /** ****/ 	var installedModules = {};
    /** ****/
    /** ****/ 	// The require function
    /** ****/ 	function __w_pdfjs_require__(moduleId) {
      /** ****/
      /** ****/ 		// Check if module is in cache
      /** ****/ 		if (installedModules[moduleId]) {
        /** ****/ 			return installedModules[moduleId].exports;
        /** ****/ 		}
      /** ****/ 		// Create a new module (and put it into the cache)
      /** ****/ 		var module = installedModules[moduleId] = {
        /** ****/ 			i: moduleId,
        /** ****/ 			l: false,
        /** ****/ 			exports: {}
        /** ****/ 		};
      /** ****/
      /** ****/ 		// Execute the module function
      /** ****/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
      /** ****/
      /** ****/ 		// Flag the module as loaded
      /** ****/ 		module.l = true;
      /** ****/
      /** ****/ 		// Return the exports of the module
      /** ****/ 		return module.exports;
      /** ****/ 	}
    /** ****/
    /** ****/
    /** ****/ 	// expose the modules object (__webpack_modules__)
    /** ****/ 	__w_pdfjs_require__.m = modules;
    /** ****/
    /** ****/ 	// expose the module cache
    /** ****/ 	__w_pdfjs_require__.c = installedModules;
    /** ****/
    /** ****/ 	// define getter function for harmony exports
    /** ****/ 	__w_pdfjs_require__.d = function (exports, name, getter) {
      /** ****/ 		if (!__w_pdfjs_require__.o(exports, name)) {
        /** ****/ 			Object.defineProperty(exports, name, {
          /** ****/ 				configurable: false,
          /** ****/ 				enumerable: true,
          /** ****/ 				get: getter
          /** ****/ 			});
        /** ****/ 		}
      /** ****/ 	};
    /** ****/
    /** ****/ 	// getDefaultExport function for compatibility with non-harmony modules
    /** ****/ 	__w_pdfjs_require__.n = function (module) {
      /** ****/ 		var getter = module && module.__esModule ?
      /** ****/ 			function getDefault() { return module["default"]; } :
      /** ****/ 			function getModuleExports() { return module; };
      /** ****/ 		__w_pdfjs_require__.d(getter, "a", getter);
      /** ****/ 		return getter;
      /** ****/ 	};
    /** ****/
    /** ****/ 	// Object.prototype.hasOwnProperty.call
    /** ****/ 	__w_pdfjs_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
    /** ****/
    /** ****/ 	// __webpack_public_path__
    /** ****/ 	__w_pdfjs_require__.p = "";
    /** ****/
    /** ****/ 	// Load entry module and return exports
    /** ****/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 82);
    /** ****/ })
  /** **********************************************************************/
  /** ****/ ([
    /* 0 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      __w_pdfjs_require__(84);

      var _streams_polyfill = __w_pdfjs_require__(124);

      var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
      var NativeImageDecoding = {
        NONE: "none",
        DECODE: "decode",
        DISPLAY: "display"
      };
      var TextRenderingMode = {
        FILL: 0,
        STROKE: 1,
        FILL_STROKE: 2,
        INVISIBLE: 3,
        FILL_ADD_TO_PATH: 4,
        STROKE_ADD_TO_PATH: 5,
        FILL_STROKE_ADD_TO_PATH: 6,
        ADD_TO_PATH: 7,
        FILL_STROKE_MASK: 3,
        ADD_TO_PATH_FLAG: 4
      };
      var ImageKind = {
        GRAYSCALE_1BPP: 1,
        RGB_24BPP: 2,
        RGBA_32BPP: 3
      };
      var AnnotationType = {
        TEXT: 1,
        LINK: 2,
        FREETEXT: 3,
        LINE: 4,
        SQUARE: 5,
        CIRCLE: 6,
        POLYGON: 7,
        POLYLINE: 8,
        HIGHLIGHT: 9,
        UNDERLINE: 10,
        SQUIGGLY: 11,
        STRIKEOUT: 12,
        STAMP: 13,
        CARET: 14,
        INK: 15,
        POPUP: 16,
        FILEATTACHMENT: 17,
        SOUND: 18,
        MOVIE: 19,
        WIDGET: 20,
        SCREEN: 21,
        PRINTERMARK: 22,
        TRAPNET: 23,
        WATERMARK: 24,
        THREED: 25,
        REDACT: 26
      };
      var AnnotationFlag = {
        INVISIBLE: 0x01,
        HIDDEN: 0x02,
        PRINT: 0x04,
        NOZOOM: 0x08,
        NOROTATE: 0x10,
        NOVIEW: 0x20,
        READONLY: 0x40,
        LOCKED: 0x80,
        TOGGLENOVIEW: 0x100,
        LOCKEDCONTENTS: 0x200
      };
      var AnnotationFieldFlag = {
        READONLY: 0x0000001,
        REQUIRED: 0x0000002,
        NOEXPORT: 0x0000004,
        MULTILINE: 0x0001000,
        PASSWORD: 0x0002000,
        NOTOGGLETOOFF: 0x0004000,
        RADIO: 0x0008000,
        PUSHBUTTON: 0x0010000,
        COMBO: 0x0020000,
        EDIT: 0x0040000,
        SORT: 0x0080000,
        FILESELECT: 0x0100000,
        MULTISELECT: 0x0200000,
        DONOTSPELLCHECK: 0x0400000,
        DONOTSCROLL: 0x0800000,
        COMB: 0x1000000,
        RICHTEXT: 0x2000000,
        RADIOSINUNISON: 0x2000000,
        COMMITONSELCHANGE: 0x4000000
      };
      var AnnotationBorderStyleType = {
        SOLID: 1,
        DASHED: 2,
        BEVELED: 3,
        INSET: 4,
        UNDERLINE: 5
      };
      var StreamType = {
        UNKNOWN: 0,
        FLATE: 1,
        LZW: 2,
        DCT: 3,
        JPX: 4,
        JBIG: 5,
        A85: 6,
        AHX: 7,
        CCF: 8,
        RL: 9
      };
      var FontType = {
        UNKNOWN: 0,
        TYPE1: 1,
        TYPE1C: 2,
        CIDFONTTYPE0: 3,
        CIDFONTTYPE0C: 4,
        TRUETYPE: 5,
        CIDFONTTYPE2: 6,
        TYPE3: 7,
        OPENTYPE: 8,
        TYPE0: 9,
        MMTYPE1: 10
      };
      var VERBOSITY_LEVELS = {
        errors: 0,
        warnings: 1,
        infos: 5
      };
      var CMapCompressionType = {
        NONE: 0,
        BINARY: 1,
        STREAM: 2
      };
      var OPS = {
        dependency: 1,
        setLineWidth: 2,
        setLineCap: 3,
        setLineJoin: 4,
        setMiterLimit: 5,
        setDash: 6,
        setRenderingIntent: 7,
        setFlatness: 8,
        setGState: 9,
        save: 10,
        restore: 11,
        transform: 12,
        moveTo: 13,
        lineTo: 14,
        curveTo: 15,
        curveTo2: 16,
        curveTo3: 17,
        closePath: 18,
        rectangle: 19,
        stroke: 20,
        closeStroke: 21,
        fill: 22,
        eoFill: 23,
        fillStroke: 24,
        eoFillStroke: 25,
        closeFillStroke: 26,
        closeEOFillStroke: 27,
        endPath: 28,
        clip: 29,
        eoClip: 30,
        beginText: 31,
        endText: 32,
        setCharSpacing: 33,
        setWordSpacing: 34,
        setHScale: 35,
        setLeading: 36,
        setFont: 37,
        setTextRenderingMode: 38,
        setTextRise: 39,
        moveText: 40,
        setLeadingMoveText: 41,
        setTextMatrix: 42,
        nextLine: 43,
        showText: 44,
        showSpacedText: 45,
        nextLineShowText: 46,
        nextLineSetSpacingShowText: 47,
        setCharWidth: 48,
        setCharWidthAndBounds: 49,
        setStrokeColorSpace: 50,
        setFillColorSpace: 51,
        setStrokeColor: 52,
        setStrokeColorN: 53,
        setFillColor: 54,
        setFillColorN: 55,
        setStrokeGray: 56,
        setFillGray: 57,
        setStrokeRGBColor: 58,
        setFillRGBColor: 59,
        setStrokeCMYKColor: 60,
        setFillCMYKColor: 61,
        shadingFill: 62,
        beginInlineImage: 63,
        beginImageData: 64,
        endInlineImage: 65,
        paintXObject: 66,
        markPoint: 67,
        markPointProps: 68,
        beginMarkedContent: 69,
        beginMarkedContentProps: 70,
        endMarkedContent: 71,
        beginCompat: 72,
        endCompat: 73,
        paintFormXObjectBegin: 74,
        paintFormXObjectEnd: 75,
        beginGroup: 76,
        endGroup: 77,
        beginAnnotations: 78,
        endAnnotations: 79,
        beginAnnotation: 80,
        endAnnotation: 81,
        paintJpegXObject: 82,
        paintImageMaskXObject: 83,
        paintImageMaskXObjectGroup: 84,
        paintImageXObject: 85,
        paintInlineImageXObject: 86,
        paintInlineImageXObjectGroup: 87,
        paintImageXObjectRepeat: 88,
        paintImageMaskXObjectRepeat: 89,
        paintSolidColorImageMask: 90,
        constructPath: 91
      };
      var verbosity = VERBOSITY_LEVELS.warnings;
      function setVerbosityLevel(level) {
        verbosity = level;
      }
      function getVerbosityLevel() {
        return verbosity;
      }
      function info(msg) {
        if (verbosity >= VERBOSITY_LEVELS.infos) {
          console.log("Info: " + msg);
        }
      }
      function warn(msg) {
        if (verbosity >= VERBOSITY_LEVELS.warnings) {
          console.log("Warning: " + msg);
        }
      }
      function deprecated(details) {
        console.log("Deprecated API usage: " + details);
      }
      function unreachable(msg) {
        throw new Error(msg);
      }
      function assert(cond, msg) {
        if (!cond) {
          unreachable(msg);
        }
      }
      var UNSUPPORTED_FEATURES = {
        unknown: "unknown",
        forms: "forms",
        javaScript: "javaScript",
        smask: "smask",
        shadingPattern: "shadingPattern",
        font: "font"
      };
      function isSameOrigin(baseUrl, otherUrl) {
        try {
          var base = new URL(baseUrl);
          if (!base.origin || base.origin === "null") {
            return false;
          }
        } catch (e) {
          return false;
        }
        var other = new URL(otherUrl, base);
        return base.origin === other.origin;
      }
      function isValidProtocol(url) {
        if (!url) {
          return false;
        }
        switch (url.protocol) {
          case "http:":
          case "https:":
          case "ftp:":
          case "mailto:":
          case "tel:":
            return true;
          default:
            return false;
        }
      }
      function createValidAbsoluteUrl(url, baseUrl) {
        if (!url) {
          return null;
        }
        try {
          var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
          if (isValidProtocol(absoluteUrl)) {
            return absoluteUrl;
          }
        } catch (ex) {}
        return null;
      }
      function shadow(obj, prop, value) {
        Object.defineProperty(obj, prop, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: false
        });
        return value;
      }
      function getLookupTableFactory(initializer) {
        var lookup;
        return function () {
          if (initializer) {
            lookup = Object.create(null);
            initializer(lookup);
            initializer = null;
          }
          return lookup;
        };
      }
      var PasswordResponses = {
        NEED_PASSWORD: 1,
        INCORRECT_PASSWORD: 2
      };
      var PasswordException = function PasswordExceptionClosure() {
        function PasswordException(msg, code) {
          this.name = "PasswordException";
          this.message = msg;
          this.code = code;
        }
        PasswordException.prototype = new Error();
        PasswordException.constructor = PasswordException;
        return PasswordException;
      }();
      var UnknownErrorException = function UnknownErrorExceptionClosure() {
        function UnknownErrorException(msg, details) {
          this.name = "UnknownErrorException";
          this.message = msg;
          this.details = details;
        }
        UnknownErrorException.prototype = new Error();
        UnknownErrorException.constructor = UnknownErrorException;
        return UnknownErrorException;
      }();
      var InvalidPDFException = function InvalidPDFExceptionClosure() {
        function InvalidPDFException(msg) {
          this.name = "InvalidPDFException";
          this.message = msg;
        }
        InvalidPDFException.prototype = new Error();
        InvalidPDFException.constructor = InvalidPDFException;
        return InvalidPDFException;
      }();
      var MissingPDFException = function MissingPDFExceptionClosure() {
        function MissingPDFException(msg) {
          this.name = "MissingPDFException";
          this.message = msg;
        }
        MissingPDFException.prototype = new Error();
        MissingPDFException.constructor = MissingPDFException;
        return MissingPDFException;
      }();
      var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
        function UnexpectedResponseException(msg, status) {
          this.name = "UnexpectedResponseException";
          this.message = msg;
          this.status = status;
        }
        UnexpectedResponseException.prototype = new Error();
        UnexpectedResponseException.constructor = UnexpectedResponseException;
        return UnexpectedResponseException;
      }();
      var NotImplementedException = function NotImplementedExceptionClosure() {
        function NotImplementedException(msg) {
          this.message = msg;
        }
        NotImplementedException.prototype = new Error();
        NotImplementedException.prototype.name = "NotImplementedException";
        NotImplementedException.constructor = NotImplementedException;
        return NotImplementedException;
      }();
      var MissingDataException = function MissingDataExceptionClosure() {
        function MissingDataException(begin, end) {
          this.begin = begin;
          this.end = end;
          this.message = "Missing data [" + begin + ", " + end + ")";
        }
        MissingDataException.prototype = new Error();
        MissingDataException.prototype.name = "MissingDataException";
        MissingDataException.constructor = MissingDataException;
        return MissingDataException;
      }();
      var XRefParseException = function XRefParseExceptionClosure() {
        function XRefParseException(msg) {
          this.message = msg;
        }
        XRefParseException.prototype = new Error();
        XRefParseException.prototype.name = "XRefParseException";
        XRefParseException.constructor = XRefParseException;
        return XRefParseException;
      }();
      var FormatError = function FormatErrorClosure() {
        function FormatError(msg) {
          this.message = msg;
        }
        FormatError.prototype = new Error();
        FormatError.prototype.name = "FormatError";
        FormatError.constructor = FormatError;
        return FormatError;
      }();
      var AbortException = function AbortExceptionClosure() {
        function AbortException(msg) {
          this.name = "AbortException";
          this.message = msg;
        }
        AbortException.prototype = new Error();
        AbortException.constructor = AbortException;
        return AbortException;
      }();
      var NullCharactersRegExp = /\x00/g;
      function removeNullCharacters(str) {
        if (typeof str !== "string") {
          warn("The argument for removeNullCharacters must be a string.");
          return str;
        }
        return str.replace(NullCharactersRegExp, "");
      }
      function bytesToString(bytes) {
        assert(bytes !== null && (typeof bytes === "undefined" ? "undefined" : _typeof(bytes)) === "object" && bytes.length !== undefined, "Invalid argument for bytesToString");
        var length = bytes.length;
        var MAX_ARGUMENT_COUNT = 8192;
        if (length < MAX_ARGUMENT_COUNT) {
          return String.fromCharCode.apply(null, bytes);
        }
        var strBuf = [];
        for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
          var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
          var chunk = bytes.subarray(i, chunkEnd);
          strBuf.push(String.fromCharCode.apply(null, chunk));
        }
        return strBuf.join("");
      }
      function stringToBytes(str) {
        assert(typeof str === "string", "Invalid argument for stringToBytes");
        var length = str.length;
        var bytes = new Uint8Array(length);
        for (var i = 0; i < length; ++i) {
          bytes[i] = str.charCodeAt(i) & 0xFF;
        }
        return bytes;
      }
      function arrayByteLength(arr) {
        if (arr.length !== undefined) {
          return arr.length;
        }
        assert(arr.byteLength !== undefined);
        return arr.byteLength;
      }
      function arraysToBytes(arr) {
        if (arr.length === 1 && arr[0] instanceof Uint8Array) {
          return arr[0];
        }
        var resultLength = 0;
        var i,
          ii = arr.length;
        var item, itemLength;
        for (i = 0; i < ii; i++) {
          item = arr[i];
          itemLength = arrayByteLength(item);
          resultLength += itemLength;
        }
        var pos = 0;
        var data = new Uint8Array(resultLength);
        for (i = 0; i < ii; i++) {
          item = arr[i];
          if (!(item instanceof Uint8Array)) {
            if (typeof item === "string") {
              item = stringToBytes(item);
            } else {
              item = new Uint8Array(item);
            }
          }
          itemLength = item.byteLength;
          data.set(item, pos);
          pos += itemLength;
        }
        return data;
      }
      function string32(value) {
        return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
      }
      function log2(x) {
        var n = 1,
          i = 0;
        while (x > n) {
          n <<= 1;
          i++;
        }
        return i;
      }
      function readInt8(data, start) {
        return data[start] << 24 >> 24;
      }
      function readUint16(data, offset) {
        return data[offset] << 8 | data[offset + 1];
      }
      function readUint32(data, offset) {
        return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
      }
      function isLittleEndian() {
        var buffer8 = new Uint8Array(4);
        buffer8[0] = 1;
        var view32 = new Uint32Array(buffer8.buffer, 0, 1);
        return view32[0] === 1;
      }
      function isEvalSupported() {
        try {
          new Function("");
          return true;
        } catch (e) {
          return false;
        }
      }
      var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
      var Util = function UtilClosure() {
        function Util() {}
        var rgbBuf = ["rgb(", 0, ",", 0, ",", 0, ")"];
        Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
          rgbBuf[1] = r;
          rgbBuf[3] = g;
          rgbBuf[5] = b;
          return rgbBuf.join("");
        };
        Util.transform = function Util_transform(m1, m2) {
          return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
        };
        Util.applyTransform = function Util_applyTransform(p, m) {
          var xt = p[0] * m[0] + p[1] * m[2] + m[4];
          var yt = p[0] * m[1] + p[1] * m[3] + m[5];
          return [xt, yt];
        };
        Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
          var d = m[0] * m[3] - m[1] * m[2];
          var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
          var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
          return [xt, yt];
        };
        Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
          var p1 = Util.applyTransform(r, m);
          var p2 = Util.applyTransform(r.slice(2, 4), m);
          var p3 = Util.applyTransform([r[0], r[3]], m);
          var p4 = Util.applyTransform([r[2], r[1]], m);
          return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
        };
        Util.inverseTransform = function Util_inverseTransform(m) {
          var d = m[0] * m[3] - m[1] * m[2];
          return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
        };
        Util.apply3dTransform = function Util_apply3dTransform(m, v) {
          return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
        };
        Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
          var transpose = [m[0], m[2], m[1], m[3]];
          var a = m[0] * transpose[0] + m[1] * transpose[2];
          var b = m[0] * transpose[1] + m[1] * transpose[3];
          var c = m[2] * transpose[0] + m[3] * transpose[2];
          var d = m[2] * transpose[1] + m[3] * transpose[3];
          var first = (a + d) / 2;
          var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
          var sx = first + second || 1;
          var sy = first - second || 1;
          return [Math.sqrt(sx), Math.sqrt(sy)];
        };
        Util.normalizeRect = function Util_normalizeRect(rect) {
          var r = rect.slice(0);
          if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
          }
          if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
          }
          return r;
        };
        Util.intersect = function Util_intersect(rect1, rect2) {
          function compare(a, b) {
            return a - b;
          }
          var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
            orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
            result = [];
          rect1 = Util.normalizeRect(rect1);
          rect2 = Util.normalizeRect(rect2);
          if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
            result[0] = orderedX[1];
            result[2] = orderedX[2];
          } else {
            return false;
          }
          if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
            result[1] = orderedY[1];
            result[3] = orderedY[2];
          } else {
            return false;
          }
          return result;
        };
        var ROMAN_NUMBER_MAP = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
        Util.toRoman = function Util_toRoman(number, lowerCase) {
          assert(Number.isInteger(number) && number > 0, "The number should be a positive integer.");
          var pos,
            romanBuf = [];
          while (number >= 1000) {
            number -= 1000;
            romanBuf.push("M");
          }
          pos = number / 100 | 0;
          number %= 100;
          romanBuf.push(ROMAN_NUMBER_MAP[pos]);
          pos = number / 10 | 0;
          number %= 10;
          romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
          romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
          var romanStr = romanBuf.join("");
          return lowerCase ? romanStr.toLowerCase() : romanStr;
        };
        Util.appendToArray = function Util_appendToArray(arr1, arr2) {
          Array.prototype.push.apply(arr1, arr2);
        };
        Util.prependToArray = function Util_prependToArray(arr1, arr2) {
          Array.prototype.unshift.apply(arr1, arr2);
        };
        Util.extendObj = function extendObj(obj1, obj2) {
          for (var key in obj2) {
            obj1[key] = obj2[key];
          }
        };
        Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
          while (dict && !dict.has(name)) {
            dict = dict.get("Parent");
          }
          if (!dict) {
            return null;
          }
          return getArray ? dict.getArray(name) : dict.get(name);
        };
        Util.inherit = function Util_inherit(sub, base, prototype) {
          sub.prototype = Object.create(base.prototype);
          sub.prototype.constructor = sub;
          for (var prop in prototype) {
            sub.prototype[prop] = prototype[prop];
          }
        };
        Util.loadScript = function Util_loadScript(src, callback) {
          var script = document.createElement("script");
          var loaded = false;
          script.setAttribute("src", src);
          if (callback) {
            script.onload = function () {
              if (!loaded) {
                callback();
              }
              loaded = true;
            };
          }
          document.getElementsByTagName("head")[0].appendChild(script);
        };
        return Util;
      }();
      var PageViewport = function PageViewportClosure() {
        function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
          this.viewBox = viewBox;
          this.scale = scale;
          this.rotation = rotation;
          this.offsetX = offsetX;
          this.offsetY = offsetY;
          var centerX = (viewBox[2] + viewBox[0]) / 2;
          var centerY = (viewBox[3] + viewBox[1]) / 2;
          var rotateA, rotateB, rotateC, rotateD;
          rotation = rotation % 360;
          rotation = rotation < 0 ? rotation + 360 : rotation;
          switch (rotation) {
            case 180:
              rotateA = -1;
              rotateB = 0;
              rotateC = 0;
              rotateD = 1;
              break;
            case 90:
              rotateA = 0;
              rotateB = 1;
              rotateC = 1;
              rotateD = 0;
              break;
            case 270:
              rotateA = 0;
              rotateB = -1;
              rotateC = -1;
              rotateD = 0;
              break;
            default:
              rotateA = 1;
              rotateB = 0;
              rotateC = 0;
              rotateD = -1;
              break;
          }
          if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
          }
          var offsetCanvasX, offsetCanvasY;
          var width, height;
          if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = Math.abs(viewBox[3] - viewBox[1]) * scale;
            height = Math.abs(viewBox[2] - viewBox[0]) * scale;
          } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = Math.abs(viewBox[2] - viewBox[0]) * scale;
            height = Math.abs(viewBox[3] - viewBox[1]) * scale;
          }
          this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
          this.width = width;
          this.height = height;
          this.fontScale = scale;
        }
        PageViewport.prototype = {
          clone: function PageViewPort_clone(args) {
            args = args || {};
            var scale = "scale" in args ? args.scale : this.scale;
            var rotation = "rotation" in args ? args.rotation : this.rotation;
            return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
          },
          convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
            return Util.applyTransform([x, y], this.transform);
          },
          convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
            var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
            var br = Util.applyTransform([rect[2], rect[3]], this.transform);
            return [tl[0], tl[1], br[0], br[1]];
          },
          convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
            return Util.applyInverseTransform([x, y], this.transform);
          }
        };
        return PageViewport;
      }();
      var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
      function stringToPDFString(str) {
        var i,
          n = str.length,
          strBuf = [];
        if (str[0] === "\xFE" && str[1] === "\xFF") {
          for (i = 2; i < n; i += 2) {
            strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
          }
        } else {
          for (i = 0; i < n; ++i) {
            var code = PDFStringTranslateTable[str.charCodeAt(i)];
            strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
          }
        }
        return strBuf.join("");
      }
      function stringToUTF8String(str) {
        return decodeURIComponent(escape(str));
      }
      function utf8StringToString(str) {
        return unescape(encodeURIComponent(str));
      }
      function isEmptyObj(obj) {
        for (var key in obj) {
          return false;
        }
        return true;
      }
      function isBool(v) {
        return typeof v === "boolean";
      }
      function isNum(v) {
        return typeof v === "number";
      }
      function isString(v) {
        return typeof v === "string";
      }
      function isArrayBuffer(v) {
        return (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v !== null && v.byteLength !== undefined;
      }
      function isSpace(ch) {
        return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
      }
      function isNodeJS() {
        return (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process + "" === "[object process]";
      }
      function createPromiseCapability() {
        var capability = {};
        capability.promise = new Promise(function (resolve, reject) {
          capability.resolve = resolve;
          capability.reject = reject;
        });
        return capability;
      }
      var StatTimer = function StatTimerClosure() {
        function rpad(str, pad, length) {
          while (str.length < length) {
            str += pad;
          }
          return str;
        }
        function StatTimer() {
          this.started = Object.create(null);
          this.times = [];
          this.enabled = true;
        }
        StatTimer.prototype = {
          time: function StatTimer_time(name) {
            if (!this.enabled) {
              return;
            }
            if (name in this.started) {
              warn("Timer is already running for " + name);
            }
            this.started[name] = Date.now();
          },
          timeEnd: function StatTimer_timeEnd(name) {
            if (!this.enabled) {
              return;
            }
            if (!(name in this.started)) {
              warn("Timer has not been started for " + name);
            }
            this.times.push({
              "name": name,
              "start": this.started[name],
              "end": Date.now()
            });
            delete this.started[name];
          },
          toString: function StatTimer_toString() {
            var i, ii;
            var times = this.times;
            var out = "";
            var longest = 0;
            for (i = 0, ii = times.length; i < ii; ++i) {
              var name = times[i]["name"];
              if (name.length > longest) {
                longest = name.length;
              }
            }
            for (i = 0, ii = times.length; i < ii; ++i) {
              var span = times[i];
              var duration = span.end - span.start;
              out += rpad(span["name"], " ", longest) + " " + duration + "ms\n";
            }
            return out;
          }
        };
        return StatTimer;
      }();
      var createBlob = function createBlob(data, contentType) {
        if (typeof Blob !== "undefined") {
          return new Blob([data], { type: contentType });
        }
        throw new Error("The \"Blob\" constructor is not supported.");
      };
      var createObjectURL = function createObjectURLClosure() {
        var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        return function createObjectURL(data, contentType) {
          var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

          if (!forceDataSchema && URL.createObjectURL) {
            var blob = createBlob(data, contentType);
            return URL.createObjectURL(blob);
          }
          var buffer = "data:" + contentType + ";base64,";
          for (var i = 0, ii = data.length; i < ii; i += 3) {
            var b1 = data[i] & 0xFF;
            var b2 = data[i + 1] & 0xFF;
            var b3 = data[i + 2] & 0xFF;
            var d1 = b1 >> 2,
              d2 = (b1 & 3) << 4 | b2 >> 4;
            var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
            var d4 = i + 2 < ii ? b3 & 0x3F : 64;
            buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
          }
          return buffer;
        };
      }();
      function resolveCall(fn, args) {
        var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (!fn) {
          return Promise.resolve(undefined);
        }
        return new Promise(function (resolve, reject) {
          resolve(fn.apply(thisArg, args));
        });
      }
      function wrapReason(reason) {
        if ((typeof reason === "undefined" ? "undefined" : _typeof(reason)) !== "object") {
          return reason;
        }
        switch (reason.name) {
          case "AbortException":
            return new AbortException(reason.message);
          case "MissingPDFException":
            return new MissingPDFException(reason.message);
          case "UnexpectedResponseException":
            return new UnexpectedResponseException(reason.message, reason.status);
          default:
            return new UnknownErrorException(reason.message, reason.details);
        }
      }
      function makeReasonSerializable(reason) {
        if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
          return reason;
        }
        return new UnknownErrorException(reason.message, reason.toString());
      }
      function resolveOrReject(capability, success, reason) {
        if (success) {
          capability.resolve();
        } else {
          capability.reject(reason);
        }
      }
      function finalize(promise) {
        return Promise.resolve(promise).catch(function () {});
      }
      function MessageHandler(sourceName, targetName, comObj) {
        var _this = this;

        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.postMessageTransfers = true;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
        var ah = this.actionHandler = Object.create(null);
        this._onComObjOnMessage = function (event) {
          var data = event.data;
          if (data.targetName !== _this.sourceName) {
            return;
          }
          if (data.stream) {
            _this._processStreamMessage(data);
          } else if (data.isReply) {
            var callbackId = data.callbackId;
            if (data.callbackId in callbacksCapabilities) {
              var callback = callbacksCapabilities[callbackId];
              delete callbacksCapabilities[callbackId];
              if ("error" in data) {
                callback.reject(wrapReason(data.error));
              } else {
                callback.resolve(data.data);
              }
            } else {
              throw new Error("Cannot resolve callback " + callbackId);
            }
          } else if (data.action in ah) {
            var action = ah[data.action];
            if (data.callbackId) {
              var _sourceName = _this.sourceName;
              var _targetName = data.sourceName;
              Promise.resolve().then(function () {
                return action[0].call(action[1], data.data);
              }).then(function (result) {
                comObj.postMessage({
                  sourceName: _sourceName,
                  targetName: _targetName,
                  isReply: true,
                  callbackId: data.callbackId,
                  data: result
                });
              }, function (reason) {
                comObj.postMessage({
                  sourceName: _sourceName,
                  targetName: _targetName,
                  isReply: true,
                  callbackId: data.callbackId,
                  error: makeReasonSerializable(reason)
                });
              });
            } else if (data.streamId) {
              _this._createStreamSink(data);
            } else {
              action[0].call(action[1], data.data);
            }
          } else {
            throw new Error("Unknown action from worker: " + data.action);
          }
        };
        comObj.addEventListener("message", this._onComObjOnMessage);
      }
      MessageHandler.prototype = {
        on: function on(actionName, handler, scope) {
          var ah = this.actionHandler;
          if (ah[actionName]) {
            throw new Error("There is already an actionName called \"" + actionName + "\"");
          }
          ah[actionName] = [handler, scope];
        },
        send: function send(actionName, data, transfers) {
          var message = {
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
          };
          this.postMessage(message, transfers);
        },
        sendWithPromise: function sendWithPromise(actionName, data, transfers) {
          var callbackId = this.callbackId++;
          var message = {
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data,
            callbackId: callbackId
          };
          var capability = createPromiseCapability();
          this.callbacksCapabilities[callbackId] = capability;
          try {
            this.postMessage(message, transfers);
          } catch (e) {
            capability.reject(e);
          }
          return capability.promise;
        },
        sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
          var _this2 = this;

          var streamId = this.streamId++;
          var sourceName = this.sourceName;
          var targetName = this.targetName;
          return new _streams_polyfill.ReadableStream({
            start: function start(controller) {
              var startCapability = createPromiseCapability();
              _this2.streamControllers[streamId] = {
                controller: controller,
                startCall: startCapability,
                isClosed: false
              };
              _this2.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                action: actionName,
                streamId: streamId,
                data: data,
                desiredSize: controller.desiredSize
              });
              return startCapability.promise;
            },
            pull: function pull(controller) {
              var pullCapability = createPromiseCapability();
              _this2.streamControllers[streamId].pullCall = pullCapability;
              _this2.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: "pull",
                streamId: streamId,
                desiredSize: controller.desiredSize
              });
              return pullCapability.promise;
            },
            cancel: function cancel(reason) {
              var cancelCapability = createPromiseCapability();
              _this2.streamControllers[streamId].cancelCall = cancelCapability;
              _this2.streamControllers[streamId].isClosed = true;
              _this2.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: "cancel",
                reason: reason,
                streamId: streamId
              });
              return cancelCapability.promise;
            }
          }, queueingStrategy);
        },
        _createStreamSink: function _createStreamSink(data) {
          var _this3 = this;

          var self = this;
          var action = this.actionHandler[data.action];
          var streamId = data.streamId;
          var desiredSize = data.desiredSize;
          var sourceName = this.sourceName;
          var targetName = data.sourceName;
          var capability = createPromiseCapability();
          var sendStreamRequest = function sendStreamRequest(_ref) {
            var stream = _ref.stream,
              chunk = _ref.chunk,
              transfers = _ref.transfers,
              success = _ref.success,
              reason = _ref.reason;

            _this3.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: stream,
              streamId: streamId,
              chunk: chunk,
              success: success,
              reason: reason
            }, transfers);
          };
          var streamSink = {
            enqueue: function enqueue(chunk) {
              var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var transfers = arguments[2];

              if (this.isCancelled) {
                return;
              }
              var lastDesiredSize = this.desiredSize;
              this.desiredSize -= size;
              if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                this.sinkCapability = createPromiseCapability();
                this.ready = this.sinkCapability.promise;
              }
              sendStreamRequest({
                stream: "enqueue",
                chunk: chunk,
                transfers: transfers
              });
            },
            close: function close() {
              if (this.isCancelled) {
                return;
              }
              this.isCancelled = true;
              sendStreamRequest({ stream: "close" });
              delete self.streamSinks[streamId];
            },
            error: function error(reason) {
              if (this.isCancelled) {
                return;
              }
              this.isCancelled = true;
              sendStreamRequest({
                stream: "error",
                reason: reason
              });
            },

            sinkCapability: capability,
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: desiredSize,
            ready: null
          };
          streamSink.sinkCapability.resolve();
          streamSink.ready = streamSink.sinkCapability.promise;
          this.streamSinks[streamId] = streamSink;
          resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
            sendStreamRequest({
              stream: "start_complete",
              success: true
            });
          }, function (reason) {
            sendStreamRequest({
              stream: "start_complete",
              success: false,
              reason: reason
            });
          });
        },
        _processStreamMessage: function _processStreamMessage(data) {
          var _this4 = this;

          var sourceName = this.sourceName;
          var targetName = data.sourceName;
          var streamId = data.streamId;
          var sendStreamResponse = function sendStreamResponse(_ref2) {
            var stream = _ref2.stream,
              success = _ref2.success,
              reason = _ref2.reason;

            _this4.comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: stream,
              success: success,
              streamId: streamId,
              reason: reason
            });
          };
          var deleteStreamController = function deleteStreamController() {
            Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
              return capability && finalize(capability.promise);
            })).then(function () {
              delete _this4.streamControllers[data.streamId];
            });
          };
          switch (data.stream) {
            case "start_complete":
              resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
              break;
            case "pull_complete":
              resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
              break;
            case "pull":
              if (!this.streamSinks[data.streamId]) {
                sendStreamResponse({
                  stream: "pull_complete",
                  success: true
                });
                break;
              }
              if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
                this.streamSinks[data.streamId].sinkCapability.resolve();
              }
              this.streamSinks[data.streamId].desiredSize = data.desiredSize;
              resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
                sendStreamResponse({
                  stream: "pull_complete",
                  success: true
                });
              }, function (reason) {
                sendStreamResponse({
                  stream: "pull_complete",
                  success: false,
                  reason: reason
                });
              });
              break;
            case "enqueue":
              assert(this.streamControllers[data.streamId], "enqueue should have stream controller");
              if (!this.streamControllers[data.streamId].isClosed) {
                this.streamControllers[data.streamId].controller.enqueue(data.chunk);
              }
              break;
            case "close":
              assert(this.streamControllers[data.streamId], "close should have stream controller");
              if (this.streamControllers[data.streamId].isClosed) {
                break;
              }
              this.streamControllers[data.streamId].isClosed = true;
              this.streamControllers[data.streamId].controller.close();
              deleteStreamController();
              break;
            case "error":
              assert(this.streamControllers[data.streamId], "error should have stream controller");
              this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
              deleteStreamController();
              break;
            case "cancel_complete":
              resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
              deleteStreamController();
              break;
            case "cancel":
              if (!this.streamSinks[data.streamId]) {
                break;
              }
              resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
                sendStreamResponse({
                  stream: "cancel_complete",
                  success: true
                });
              }, function (reason) {
                sendStreamResponse({
                  stream: "cancel_complete",
                  success: false,
                  reason: reason
                });
              });
              this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
              this.streamSinks[data.streamId].isCancelled = true;
              delete this.streamSinks[data.streamId];
              break;
            default:
              throw new Error("Unexpected stream case");
          }
        },
        postMessage: function postMessage(message, transfers) {
          if (transfers && this.postMessageTransfers) {
            this.comObj.postMessage(message, transfers);
          } else {
            this.comObj.postMessage(message);
          }
        },
        destroy: function destroy() {
          this.comObj.removeEventListener("message", this._onComObjOnMessage);
        }
      };
      function loadJpegStream(id, imageUrl, objs) {
        var img = new Image();
        img.onload = function loadJpegStream_onloadClosure() {
          objs.resolve(id, img);
        };
        img.onerror = function loadJpegStream_onerrorClosure() {
          objs.resolve(id, null);
          warn("Error during JPEG image loading");
        };
        img.src = imageUrl;
      }
      exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
      exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
      exports.OPS = OPS;
      exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
      exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
      exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
      exports.AnnotationFieldFlag = AnnotationFieldFlag;
      exports.AnnotationFlag = AnnotationFlag;
      exports.AnnotationType = AnnotationType;
      exports.FontType = FontType;
      exports.ImageKind = ImageKind;
      exports.CMapCompressionType = CMapCompressionType;
      exports.AbortException = AbortException;
      exports.InvalidPDFException = InvalidPDFException;
      exports.MessageHandler = MessageHandler;
      exports.MissingDataException = MissingDataException;
      exports.MissingPDFException = MissingPDFException;
      exports.NativeImageDecoding = NativeImageDecoding;
      exports.NotImplementedException = NotImplementedException;
      exports.PageViewport = PageViewport;
      exports.PasswordException = PasswordException;
      exports.PasswordResponses = PasswordResponses;
      exports.StatTimer = StatTimer;
      exports.StreamType = StreamType;
      exports.TextRenderingMode = TextRenderingMode;
      exports.UnexpectedResponseException = UnexpectedResponseException;
      exports.UnknownErrorException = UnknownErrorException;
      exports.Util = Util;
      exports.XRefParseException = XRefParseException;
      exports.FormatError = FormatError;
      exports.arrayByteLength = arrayByteLength;
      exports.arraysToBytes = arraysToBytes;
      exports.assert = assert;
      exports.bytesToString = bytesToString;
      exports.createBlob = createBlob;
      exports.createPromiseCapability = createPromiseCapability;
      exports.createObjectURL = createObjectURL;
      exports.deprecated = deprecated;
      exports.getLookupTableFactory = getLookupTableFactory;
      exports.getVerbosityLevel = getVerbosityLevel;
      exports.info = info;
      exports.isArrayBuffer = isArrayBuffer;
      exports.isBool = isBool;
      exports.isEmptyObj = isEmptyObj;
      exports.isNum = isNum;
      exports.isString = isString;
      exports.isSpace = isSpace;
      exports.isNodeJS = isNodeJS;
      exports.isSameOrigin = isSameOrigin;
      exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
      exports.isLittleEndian = isLittleEndian;
      exports.isEvalSupported = isEvalSupported;
      exports.loadJpegStream = loadJpegStream;
      exports.log2 = log2;
      exports.readInt8 = readInt8;
      exports.readUint16 = readUint16;
      exports.readUint32 = readUint32;
      exports.removeNullCharacters = removeNullCharacters;
      exports.ReadableStream = _streams_polyfill.ReadableStream;
      exports.setVerbosityLevel = setVerbosityLevel;
      exports.shadow = shadow;
      exports.string32 = string32;
      exports.stringToBytes = stringToBytes;
      exports.stringToPDFString = stringToPDFString;
      exports.stringToUTF8String = stringToUTF8String;
      exports.utf8StringToString = utf8StringToString;
      exports.warn = warn;
      exports.unreachable = unreachable;

      /***/ }),
    /* 1 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = module.exports = typeof window !== "undefined" && window.Math == Math ? window : typeof self !== "undefined" && self.Math == Math ? self : Function("return this")();
      if (typeof __g === "number") __g = global;

      /***/ }),
    /* 2 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var EOF = {};
      var Name = function NameClosure() {
        function Name(name) {
          this.name = name;
        }
        Name.prototype = {};
        var nameCache = Object.create(null);
        Name.get = function Name_get(name) {
          var nameValue = nameCache[name];
          return nameValue ? nameValue : nameCache[name] = new Name(name);
        };
        return Name;
      }();
      var Cmd = function CmdClosure() {
        function Cmd(cmd) {
          this.cmd = cmd;
        }
        Cmd.prototype = {};
        var cmdCache = Object.create(null);
        Cmd.get = function Cmd_get(cmd) {
          var cmdValue = cmdCache[cmd];
          return cmdValue ? cmdValue : cmdCache[cmd] = new Cmd(cmd);
        };
        return Cmd;
      }();
      var Dict = function DictClosure() {
        var nonSerializable = function nonSerializableClosure() {
          return nonSerializable;
        };
        function Dict(xref) {
          this._map = Object.create(null);
          this.xref = xref;
          this.objId = null;
          this.suppressEncryption = false;
          this.__nonSerializable__ = nonSerializable;
        }
        Dict.prototype = {
          assignXref: function Dict_assignXref(newXref) {
            this.xref = newXref;
          },
          get: function Dict_get(key1, key2, key3) {
            var value;
            var xref = this.xref,
              suppressEncryption = this.suppressEncryption;
            if (typeof (value = this._map[key1]) !== "undefined" || key1 in this._map || typeof key2 === "undefined") {
              return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
            }
            if (typeof (value = this._map[key2]) !== "undefined" || key2 in this._map || typeof key3 === "undefined") {
              return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
            }
            value = this._map[key3] || null;
            return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
          },
          getAsync: function Dict_getAsync(key1, key2, key3) {
            var value;
            var xref = this.xref,
              suppressEncryption = this.suppressEncryption;
            if (typeof (value = this._map[key1]) !== "undefined" || key1 in this._map || typeof key2 === "undefined") {
              if (xref) {
                return xref.fetchIfRefAsync(value, suppressEncryption);
              }
              return Promise.resolve(value);
            }
            if (typeof (value = this._map[key2]) !== "undefined" || key2 in this._map || typeof key3 === "undefined") {
              if (xref) {
                return xref.fetchIfRefAsync(value, suppressEncryption);
              }
              return Promise.resolve(value);
            }
            value = this._map[key3] || null;
            if (xref) {
              return xref.fetchIfRefAsync(value, suppressEncryption);
            }
            return Promise.resolve(value);
          },
          getArray: function Dict_getArray(key1, key2, key3) {
            var value = this.get(key1, key2, key3);
            var xref = this.xref,
              suppressEncryption = this.suppressEncryption;
            if (!Array.isArray(value) || !xref) {
              return value;
            }
            value = value.slice();
            for (var i = 0, ii = value.length; i < ii; i++) {
              if (!isRef(value[i])) {
                continue;
              }
              value[i] = xref.fetch(value[i], suppressEncryption);
            }
            return value;
          },
          getRaw: function Dict_getRaw(key) {
            return this._map[key];
          },
          getKeys: function Dict_getKeys() {
            return Object.keys(this._map);
          },
          set: function Dict_set(key, value) {
            this._map[key] = value;
          },
          has: function Dict_has(key) {
            return key in this._map;
          },
          forEach: function Dict_forEach(callback) {
            for (var key in this._map) {
              callback(key, this.get(key));
            }
          }
        };
        Dict.empty = new Dict(null);
        Dict.merge = function (xref, dictArray) {
          var mergedDict = new Dict(xref);
          for (var i = 0, ii = dictArray.length; i < ii; i++) {
            var dict = dictArray[i];
            if (!isDict(dict)) {
              continue;
            }
            for (var keyName in dict._map) {
              if (mergedDict._map[keyName] !== undefined) {
                continue;
              }
              mergedDict._map[keyName] = dict._map[keyName];
            }
          }
          return mergedDict;
        };
        return Dict;
      }();
      var Ref = function RefClosure() {
        function Ref(num, gen) {
          this.num = num;
          this.gen = gen;
        }
        Ref.prototype = {
          toString: function Ref_toString() {
            var str = this.num + "R";
            if (this.gen !== 0) {
              str += this.gen;
            }
            return str;
          }
        };
        return Ref;
      }();
      var RefSet = function RefSetClosure() {
        function RefSet() {
          this.dict = Object.create(null);
        }
        RefSet.prototype = {
          has: function RefSet_has(ref) {
            return ref.toString() in this.dict;
          },
          put: function RefSet_put(ref) {
            this.dict[ref.toString()] = true;
          },
          remove: function RefSet_remove(ref) {
            delete this.dict[ref.toString()];
          }
        };
        return RefSet;
      }();
      var RefSetCache = function RefSetCacheClosure() {
        function RefSetCache() {
          this.dict = Object.create(null);
        }
        RefSetCache.prototype = {
          get: function RefSetCache_get(ref) {
            return this.dict[ref.toString()];
          },
          has: function RefSetCache_has(ref) {
            return ref.toString() in this.dict;
          },
          put: function RefSetCache_put(ref, obj) {
            this.dict[ref.toString()] = obj;
          },
          putAlias: function RefSetCache_putAlias(ref, aliasRef) {
            this.dict[ref.toString()] = this.get(aliasRef);
          },
          forEach: function RefSetCache_forEach(fn, thisArg) {
            for (var i in this.dict) {
              fn.call(thisArg, this.dict[i]);
            }
          },
          clear: function RefSetCache_clear() {
            this.dict = Object.create(null);
          }
        };
        return RefSetCache;
      }();
      function isEOF(v) {
        return v === EOF;
      }
      function isName(v, name) {
        return v instanceof Name && (name === undefined || v.name === name);
      }
      function isCmd(v, cmd) {
        return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
      }
      function isDict(v, type) {
        return v instanceof Dict && (type === undefined || isName(v.get("Type"), type));
      }
      function isRef(v) {
        return v instanceof Ref;
      }
      function isRefsEqual(v1, v2) {
        return v1.num === v2.num && v1.gen === v2.gen;
      }
      function isStream(v) {
        return (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v !== null && v.getBytes !== undefined;
      }
      exports.EOF = EOF;
      exports.Cmd = Cmd;
      exports.Dict = Dict;
      exports.Name = Name;
      exports.Ref = Ref;
      exports.RefSet = RefSet;
      exports.RefSetCache = RefSetCache;
      exports.isEOF = isEOF;
      exports.isCmd = isCmd;
      exports.isDict = isDict;
      exports.isName = isName;
      exports.isRef = isRef;
      exports.isRefsEqual = isRefsEqual;
      exports.isStream = isStream;

      /***/ }),
    /* 3 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      module.exports = function (it) {
        return (typeof it === "undefined" ? "undefined" : _typeof(it)) === "object" ? it !== null : typeof it === "function";
      };

      /***/ }),
    /* 4 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var store = __w_pdfjs_require__(54)("wks");
      var uid = __w_pdfjs_require__(17);
      var _Symbol = __w_pdfjs_require__(1).Symbol;
      var USE_SYMBOL = typeof _Symbol === "function";
      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)("Symbol." + name));
      };
      $exports.store = store;

      /***/ }),
    /* 5 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.LZWStream = exports.StringStream = exports.StreamsSequenceStream = exports.Stream = exports.RunLengthStream = exports.PredictorStream = exports.NullStream = exports.JpxStream = exports.JpegStream = exports.FlateStream = exports.DecodeStream = exports.DecryptStream = exports.AsciiHexStream = exports.Ascii85Stream = undefined;

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var _jpg = __w_pdfjs_require__(128);

      var _jpx = __w_pdfjs_require__(74);

      var Stream = function StreamClosure() {
        function Stream(arrayBuffer, start, length, dict) {
          this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
          this.start = start || 0;
          this.pos = this.start;
          this.end = start + length || this.bytes.length;
          this.dict = dict;
        }
        Stream.prototype = {
          get length() {
            return this.end - this.start;
          },
          get isEmpty() {
            return this.length === 0;
          },
          getByte: function Stream_getByte() {
            if (this.pos >= this.end) {
              return -1;
            }
            return this.bytes[this.pos++];
          },
          getUint16: function Stream_getUint16() {
            var b0 = this.getByte();
            var b1 = this.getByte();
            if (b0 === -1 || b1 === -1) {
              return -1;
            }
            return (b0 << 8) + b1;
          },
          getInt32: function Stream_getInt32() {
            var b0 = this.getByte();
            var b1 = this.getByte();
            var b2 = this.getByte();
            var b3 = this.getByte();
            return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
          },
          getBytes: function Stream_getBytes(length) {
            var bytes = this.bytes;
            var pos = this.pos;
            var strEnd = this.end;
            if (!length) {
              return bytes.subarray(pos, strEnd);
            }
            var end = pos + length;
            if (end > strEnd) {
              end = strEnd;
            }
            this.pos = end;
            return bytes.subarray(pos, end);
          },
          peekByte: function Stream_peekByte() {
            var peekedByte = this.getByte();
            this.pos--;
            return peekedByte;
          },
          peekBytes: function Stream_peekBytes(length) {
            var bytes = this.getBytes(length);
            this.pos -= bytes.length;
            return bytes;
          },
          skip: function Stream_skip(n) {
            if (!n) {
              n = 1;
            }
            this.pos += n;
          },
          reset: function Stream_reset() {
            this.pos = this.start;
          },
          moveStart: function Stream_moveStart() {
            this.start = this.pos;
          },
          makeSubStream: function Stream_makeSubStream(start, length, dict) {
            return new Stream(this.bytes.buffer, start, length, dict);
          }
        };
        return Stream;
      }();
      var StringStream = function StringStreamClosure() {
        function StringStream(str) {
          var bytes = (0, _util.stringToBytes)(str);
          Stream.call(this, bytes);
        }
        StringStream.prototype = Stream.prototype;
        return StringStream;
      }();
      var DecodeStream = function DecodeStreamClosure() {
        var emptyBuffer = new Uint8Array(0);
        function DecodeStream(maybeMinBufferLength) {
          this.pos = 0;
          this.bufferLength = 0;
          this.eof = false;
          this.buffer = emptyBuffer;
          this.minBufferLength = 512;
          if (maybeMinBufferLength) {
            while (this.minBufferLength < maybeMinBufferLength) {
              this.minBufferLength *= 2;
            }
          }
        }
        DecodeStream.prototype = {
          get isEmpty() {
            while (!this.eof && this.bufferLength === 0) {
              this.readBlock();
            }
            return this.bufferLength === 0;
          },
          ensureBuffer: function DecodeStream_ensureBuffer(requested) {
            var buffer = this.buffer;
            if (requested <= buffer.byteLength) {
              return buffer;
            }
            var size = this.minBufferLength;
            while (size < requested) {
              size *= 2;
            }
            var buffer2 = new Uint8Array(size);
            buffer2.set(buffer);
            return this.buffer = buffer2;
          },
          getByte: function DecodeStream_getByte() {
            var pos = this.pos;
            while (this.bufferLength <= pos) {
              if (this.eof) {
                return -1;
              }
              this.readBlock();
            }
            return this.buffer[this.pos++];
          },
          getUint16: function DecodeStream_getUint16() {
            var b0 = this.getByte();
            var b1 = this.getByte();
            if (b0 === -1 || b1 === -1) {
              return -1;
            }
            return (b0 << 8) + b1;
          },
          getInt32: function DecodeStream_getInt32() {
            var b0 = this.getByte();
            var b1 = this.getByte();
            var b2 = this.getByte();
            var b3 = this.getByte();
            return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
          },
          getBytes: function DecodeStream_getBytes(length) {
            var end,
              pos = this.pos;
            if (length) {
              this.ensureBuffer(pos + length);
              end = pos + length;
              while (!this.eof && this.bufferLength < end) {
                this.readBlock();
              }
              var bufEnd = this.bufferLength;
              if (end > bufEnd) {
                end = bufEnd;
              }
            } else {
              while (!this.eof) {
                this.readBlock();
              }
              end = this.bufferLength;
            }
            this.pos = end;
            return this.buffer.subarray(pos, end);
          },
          peekByte: function DecodeStream_peekByte() {
            var peekedByte = this.getByte();
            this.pos--;
            return peekedByte;
          },
          peekBytes: function DecodeStream_peekBytes(length) {
            var bytes = this.getBytes(length);
            this.pos -= bytes.length;
            return bytes;
          },
          makeSubStream: function DecodeStream_makeSubStream(start, length, dict) {
            var end = start + length;
            while (this.bufferLength <= end && !this.eof) {
              this.readBlock();
            }
            return new Stream(this.buffer, start, length, dict);
          },
          skip: function DecodeStream_skip(n) {
            if (!n) {
              n = 1;
            }
            this.pos += n;
          },
          reset: function DecodeStream_reset() {
            this.pos = 0;
          },
          getBaseStreams: function DecodeStream_getBaseStreams() {
            if (this.str && this.str.getBaseStreams) {
              return this.str.getBaseStreams();
            }
            return [];
          }
        };
        return DecodeStream;
      }();
      var StreamsSequenceStream = function StreamsSequenceStreamClosure() {
        function StreamsSequenceStream(streams) {
          this.streams = streams;
          DecodeStream.call(this, null);
        }
        StreamsSequenceStream.prototype = Object.create(DecodeStream.prototype);
        StreamsSequenceStream.prototype.readBlock = function streamSequenceStreamReadBlock() {
          var streams = this.streams;
          if (streams.length === 0) {
            this.eof = true;
            return;
          }
          var stream = streams.shift();
          var chunk = stream.getBytes();
          var bufferLength = this.bufferLength;
          var newLength = bufferLength + chunk.length;
          var buffer = this.ensureBuffer(newLength);
          buffer.set(chunk, bufferLength);
          this.bufferLength = newLength;
        };
        StreamsSequenceStream.prototype.getBaseStreams = function StreamsSequenceStream_getBaseStreams() {
          var baseStreams = [];
          for (var i = 0, ii = this.streams.length; i < ii; i++) {
            var stream = this.streams[i];
            if (stream.getBaseStreams) {
              _util.Util.appendToArray(baseStreams, stream.getBaseStreams());
            }
          }
          return baseStreams;
        };
        return StreamsSequenceStream;
      }();
      var FlateStream = function FlateStreamClosure() {
        var codeLenCodeMap = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        var lengthDecode = new Int32Array([0x00003, 0x00004, 0x00005, 0x00006, 0x00007, 0x00008, 0x00009, 0x0000a, 0x1000b, 0x1000d, 0x1000f, 0x10011, 0x20013, 0x20017, 0x2001b, 0x2001f, 0x30023, 0x3002b, 0x30033, 0x3003b, 0x40043, 0x40053, 0x40063, 0x40073, 0x50083, 0x500a3, 0x500c3, 0x500e3, 0x00102, 0x00102, 0x00102]);
        var distDecode = new Int32Array([0x00001, 0x00002, 0x00003, 0x00004, 0x10005, 0x10007, 0x20009, 0x2000d, 0x30011, 0x30019, 0x40021, 0x40031, 0x50041, 0x50061, 0x60081, 0x600c1, 0x70101, 0x70181, 0x80201, 0x80301, 0x90401, 0x90601, 0xa0801, 0xa0c01, 0xb1001, 0xb1801, 0xc2001, 0xc3001, 0xd4001, 0xd6001]);
        var fixedLitCodeTab = [new Int32Array([0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c0, 0x70108, 0x80060, 0x80020, 0x900a0, 0x80000, 0x80080, 0x80040, 0x900e0, 0x70104, 0x80058, 0x80018, 0x90090, 0x70114, 0x80078, 0x80038, 0x900d0, 0x7010c, 0x80068, 0x80028, 0x900b0, 0x80008, 0x80088, 0x80048, 0x900f0, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c8, 0x7010a, 0x80064, 0x80024, 0x900a8, 0x80004, 0x80084, 0x80044, 0x900e8, 0x70106, 0x8005c, 0x8001c, 0x90098, 0x70116, 0x8007c, 0x8003c, 0x900d8, 0x7010e, 0x8006c, 0x8002c, 0x900b8, 0x8000c, 0x8008c, 0x8004c, 0x900f8, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c4, 0x70109, 0x80062, 0x80022, 0x900a4, 0x80002, 0x80082, 0x80042, 0x900e4, 0x70105, 0x8005a, 0x8001a, 0x90094, 0x70115, 0x8007a, 0x8003a, 0x900d4, 0x7010d, 0x8006a, 0x8002a, 0x900b4, 0x8000a, 0x8008a, 0x8004a, 0x900f4, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cc, 0x7010b, 0x80066, 0x80026, 0x900ac, 0x80006, 0x80086, 0x80046, 0x900ec, 0x70107, 0x8005e, 0x8001e, 0x9009c, 0x70117, 0x8007e, 0x8003e, 0x900dc, 0x7010f, 0x8006e, 0x8002e, 0x900bc, 0x8000e, 0x8008e, 0x8004e, 0x900fc, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c2, 0x70108, 0x80061, 0x80021, 0x900a2, 0x80001, 0x80081, 0x80041, 0x900e2, 0x70104, 0x80059, 0x80019, 0x90092, 0x70114, 0x80079, 0x80039, 0x900d2, 0x7010c, 0x80069, 0x80029, 0x900b2, 0x80009, 0x80089, 0x80049, 0x900f2, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900ca, 0x7010a, 0x80065, 0x80025, 0x900aa, 0x80005, 0x80085, 0x80045, 0x900ea, 0x70106, 0x8005d, 0x8001d, 0x9009a, 0x70116, 0x8007d, 0x8003d, 0x900da, 0x7010e, 0x8006d, 0x8002d, 0x900ba, 0x8000d, 0x8008d, 0x8004d, 0x900fa, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c6, 0x70109, 0x80063, 0x80023, 0x900a6, 0x80003, 0x80083, 0x80043, 0x900e6, 0x70105, 0x8005b, 0x8001b, 0x90096, 0x70115, 0x8007b, 0x8003b, 0x900d6, 0x7010d, 0x8006b, 0x8002b, 0x900b6, 0x8000b, 0x8008b, 0x8004b, 0x900f6, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900ce, 0x7010b, 0x80067, 0x80027, 0x900ae, 0x80007, 0x80087, 0x80047, 0x900ee, 0x70107, 0x8005f, 0x8001f, 0x9009e, 0x70117, 0x8007f, 0x8003f, 0x900de, 0x7010f, 0x8006f, 0x8002f, 0x900be, 0x8000f, 0x8008f, 0x8004f, 0x900fe, 0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c1, 0x70108, 0x80060, 0x80020, 0x900a1, 0x80000, 0x80080, 0x80040, 0x900e1, 0x70104, 0x80058, 0x80018, 0x90091, 0x70114, 0x80078, 0x80038, 0x900d1, 0x7010c, 0x80068, 0x80028, 0x900b1, 0x80008, 0x80088, 0x80048, 0x900f1, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c9, 0x7010a, 0x80064, 0x80024, 0x900a9, 0x80004, 0x80084, 0x80044, 0x900e9, 0x70106, 0x8005c, 0x8001c, 0x90099, 0x70116, 0x8007c, 0x8003c, 0x900d9, 0x7010e, 0x8006c, 0x8002c, 0x900b9, 0x8000c, 0x8008c, 0x8004c, 0x900f9, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c5, 0x70109, 0x80062, 0x80022, 0x900a5, 0x80002, 0x80082, 0x80042, 0x900e5, 0x70105, 0x8005a, 0x8001a, 0x90095, 0x70115, 0x8007a, 0x8003a, 0x900d5, 0x7010d, 0x8006a, 0x8002a, 0x900b5, 0x8000a, 0x8008a, 0x8004a, 0x900f5, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cd, 0x7010b, 0x80066, 0x80026, 0x900ad, 0x80006, 0x80086, 0x80046, 0x900ed, 0x70107, 0x8005e, 0x8001e, 0x9009d, 0x70117, 0x8007e, 0x8003e, 0x900dd, 0x7010f, 0x8006e, 0x8002e, 0x900bd, 0x8000e, 0x8008e, 0x8004e, 0x900fd, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c3, 0x70108, 0x80061, 0x80021, 0x900a3, 0x80001, 0x80081, 0x80041, 0x900e3, 0x70104, 0x80059, 0x80019, 0x90093, 0x70114, 0x80079, 0x80039, 0x900d3, 0x7010c, 0x80069, 0x80029, 0x900b3, 0x80009, 0x80089, 0x80049, 0x900f3, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900cb, 0x7010a, 0x80065, 0x80025, 0x900ab, 0x80005, 0x80085, 0x80045, 0x900eb, 0x70106, 0x8005d, 0x8001d, 0x9009b, 0x70116, 0x8007d, 0x8003d, 0x900db, 0x7010e, 0x8006d, 0x8002d, 0x900bb, 0x8000d, 0x8008d, 0x8004d, 0x900fb, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c7, 0x70109, 0x80063, 0x80023, 0x900a7, 0x80003, 0x80083, 0x80043, 0x900e7, 0x70105, 0x8005b, 0x8001b, 0x90097, 0x70115, 0x8007b, 0x8003b, 0x900d7, 0x7010d, 0x8006b, 0x8002b, 0x900b7, 0x8000b, 0x8008b, 0x8004b, 0x900f7, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900cf, 0x7010b, 0x80067, 0x80027, 0x900af, 0x80007, 0x80087, 0x80047, 0x900ef, 0x70107, 0x8005f, 0x8001f, 0x9009f, 0x70117, 0x8007f, 0x8003f, 0x900df, 0x7010f, 0x8006f, 0x8002f, 0x900bf, 0x8000f, 0x8008f, 0x8004f, 0x900ff]), 9];
        var fixedDistCodeTab = [new Int32Array([0x50000, 0x50010, 0x50008, 0x50018, 0x50004, 0x50014, 0x5000c, 0x5001c, 0x50002, 0x50012, 0x5000a, 0x5001a, 0x50006, 0x50016, 0x5000e, 0x00000, 0x50001, 0x50011, 0x50009, 0x50019, 0x50005, 0x50015, 0x5000d, 0x5001d, 0x50003, 0x50013, 0x5000b, 0x5001b, 0x50007, 0x50017, 0x5000f, 0x00000]), 5];
        function FlateStream(str, maybeLength) {
          this.str = str;
          this.dict = str.dict;
          var cmf = str.getByte();
          var flg = str.getByte();
          if (cmf === -1 || flg === -1) {
            throw new _util.FormatError("Invalid header in flate stream: " + cmf + ", " + flg);
          }
          if ((cmf & 0x0f) !== 0x08) {
            throw new _util.FormatError("Unknown compression method in flate stream: " + cmf + ", " + flg);
          }
          if (((cmf << 8) + flg) % 31 !== 0) {
            throw new _util.FormatError("Bad FCHECK in flate stream: " + cmf + ", " + flg);
          }
          if (flg & 0x20) {
            throw new _util.FormatError("FDICT bit set in flate stream: " + cmf + ", " + flg);
          }
          this.codeSize = 0;
          this.codeBuf = 0;
          DecodeStream.call(this, maybeLength);
        }
        FlateStream.prototype = Object.create(DecodeStream.prototype);
        FlateStream.prototype.getBits = function FlateStream_getBits(bits) {
          var str = this.str;
          var codeSize = this.codeSize;
          var codeBuf = this.codeBuf;
          var b;
          while (codeSize < bits) {
            if ((b = str.getByte()) === -1) {
              throw new _util.FormatError("Bad encoding in flate stream");
            }
            codeBuf |= b << codeSize;
            codeSize += 8;
          }
          b = codeBuf & (1 << bits) - 1;
          this.codeBuf = codeBuf >> bits;
          this.codeSize = codeSize -= bits;
          return b;
        };
        FlateStream.prototype.getCode = function FlateStream_getCode(table) {
          var str = this.str;
          var codes = table[0];
          var maxLen = table[1];
          var codeSize = this.codeSize;
          var codeBuf = this.codeBuf;
          var b;
          while (codeSize < maxLen) {
            if ((b = str.getByte()) === -1) {
              break;
            }
            codeBuf |= b << codeSize;
            codeSize += 8;
          }
          var code = codes[codeBuf & (1 << maxLen) - 1];
          var codeLen = code >> 16;
          var codeVal = code & 0xffff;
          if (codeLen < 1 || codeSize < codeLen) {
            throw new _util.FormatError("Bad encoding in flate stream");
          }
          this.codeBuf = codeBuf >> codeLen;
          this.codeSize = codeSize - codeLen;
          return codeVal;
        };
        FlateStream.prototype.generateHuffmanTable = function flateStreamGenerateHuffmanTable(lengths) {
          var n = lengths.length;
          var maxLen = 0;
          var i;
          for (i = 0; i < n; ++i) {
            if (lengths[i] > maxLen) {
              maxLen = lengths[i];
            }
          }
          var size = 1 << maxLen;
          var codes = new Int32Array(size);
          for (var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1) {
            for (var val = 0; val < n; ++val) {
              if (lengths[val] === len) {
                var code2 = 0;
                var t = code;
                for (i = 0; i < len; ++i) {
                  code2 = code2 << 1 | t & 1;
                  t >>= 1;
                }
                for (i = code2; i < size; i += skip) {
                  codes[i] = len << 16 | val;
                }
                ++code;
              }
            }
          }
          return [codes, maxLen];
        };
        FlateStream.prototype.readBlock = function FlateStream_readBlock() {
          var buffer, len;
          var str = this.str;
          var hdr = this.getBits(3);
          if (hdr & 1) {
            this.eof = true;
          }
          hdr >>= 1;
          if (hdr === 0) {
            var b;
            if ((b = str.getByte()) === -1) {
              throw new _util.FormatError("Bad block header in flate stream");
            }
            var blockLen = b;
            if ((b = str.getByte()) === -1) {
              throw new _util.FormatError("Bad block header in flate stream");
            }
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) {
              throw new _util.FormatError("Bad block header in flate stream");
            }
            var check = b;
            if ((b = str.getByte()) === -1) {
              throw new _util.FormatError("Bad block header in flate stream");
            }
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) {
              throw new _util.FormatError("Bad uncompressed block length in flate stream");
            }
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
              if (str.peekByte() === -1) {
                this.eof = true;
              }
            } else {
              for (var n = bufferLength; n < end; ++n) {
                if ((b = str.getByte()) === -1) {
                  this.eof = true;
                  break;
                }
                buffer[n] = b;
              }
            }
            return;
          }
          var litCodeTable;
          var distCodeTable;
          if (hdr === 1) {
            litCodeTable = fixedLitCodeTab;
            distCodeTable = fixedDistCodeTab;
          } else if (hdr === 2) {
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            var codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
            var i;
            for (i = 0; i < numCodeLenCodes; ++i) {
              codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
            }
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength, bitsOffset, what;
            while (i < codes) {
              var code = this.getCode(codeLenCodeTab);
              if (code === 16) {
                bitsLength = 2;
                bitsOffset = 3;
                what = len;
              } else if (code === 17) {
                bitsLength = 3;
                bitsOffset = 3;
                what = len = 0;
              } else if (code === 18) {
                bitsLength = 7;
                bitsOffset = 11;
                what = len = 0;
              } else {
                codeLengths[i++] = len = code;
                continue;
              }
              var repeatLength = this.getBits(bitsLength) + bitsOffset;
              while (repeatLength-- > 0) {
                codeLengths[i++] = what;
              }
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
          } else {
            throw new _util.FormatError("Unknown block type in flate stream");
          }
          buffer = this.buffer;
          var limit = buffer ? buffer.length : 0;
          var pos = this.bufferLength;
          while (true) {
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
              if (pos + 1 >= limit) {
                buffer = this.ensureBuffer(pos + 1);
                limit = buffer.length;
              }
              buffer[pos++] = code1;
              continue;
            }
            if (code1 === 256) {
              this.bufferLength = pos;
              return;
            }
            code1 -= 257;
            code1 = lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) {
              code2 = this.getBits(code2);
            }
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) {
              code2 = this.getBits(code2);
            }
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
              buffer = this.ensureBuffer(pos + len);
              limit = buffer.length;
            }
            for (var k = 0; k < len; ++k, ++pos) {
              buffer[pos] = buffer[pos - dist];
            }
          }
        };
        return FlateStream;
      }();
      var PredictorStream = function PredictorStreamClosure() {
        function PredictorStream(str, maybeLength, params) {
          if (!(0, _primitives.isDict)(params)) {
            return str;
          }
          var predictor = this.predictor = params.get("Predictor") || 1;
          if (predictor <= 1) {
            return str;
          }
          if (predictor !== 2 && (predictor < 10 || predictor > 15)) {
            throw new _util.FormatError("Unsupported predictor: " + predictor);
          }
          if (predictor === 2) {
            this.readBlock = this.readBlockTiff;
          } else {
            this.readBlock = this.readBlockPng;
          }
          this.str = str;
          this.dict = str.dict;
          var colors = this.colors = params.get("Colors") || 1;
          var bits = this.bits = params.get("BitsPerComponent") || 8;
          var columns = this.columns = params.get("Columns") || 1;
          this.pixBytes = colors * bits + 7 >> 3;
          this.rowBytes = columns * colors * bits + 7 >> 3;
          DecodeStream.call(this, maybeLength);
          return this;
        }
        PredictorStream.prototype = Object.create(DecodeStream.prototype);
        PredictorStream.prototype.readBlockTiff = function predictorStreamReadBlockTiff() {
          var rowBytes = this.rowBytes;
          var bufferLength = this.bufferLength;
          var buffer = this.ensureBuffer(bufferLength + rowBytes);
          var bits = this.bits;
          var colors = this.colors;
          var rawBytes = this.str.getBytes(rowBytes);
          this.eof = !rawBytes.length;
          if (this.eof) {
            return;
          }
          var inbuf = 0,
            outbuf = 0;
          var inbits = 0,
            outbits = 0;
          var pos = bufferLength;
          var i;
          if (bits === 1 && colors === 1) {
            for (i = 0; i < rowBytes; ++i) {
              var c = rawBytes[i] ^ inbuf;
              c ^= c >> 1;
              c ^= c >> 2;
              c ^= c >> 4;
              inbuf = (c & 1) << 7;
              buffer[pos++] = c;
            }
          } else if (bits === 8) {
            for (i = 0; i < colors; ++i) {
              buffer[pos++] = rawBytes[i];
            }
            for (; i < rowBytes; ++i) {
              buffer[pos] = buffer[pos - colors] + rawBytes[i];
              pos++;
            }
          } else if (bits === 16) {
            var bytesPerPixel = colors * 2;
            for (i = 0; i < bytesPerPixel; ++i) {
              buffer[pos++] = rawBytes[i];
            }
            for (; i < rowBytes; i += 2) {
              var sum = ((rawBytes[i] & 0xFF) << 8) + (rawBytes[i + 1] & 0xFF) + ((buffer[pos - bytesPerPixel] & 0xFF) << 8) + (buffer[pos - bytesPerPixel + 1] & 0xFF);
              buffer[pos++] = sum >> 8 & 0xFF;
              buffer[pos++] = sum & 0xFF;
            }
          } else {
            var compArray = new Uint8Array(colors + 1);
            var bitMask = (1 << bits) - 1;
            var j = 0,
              k = bufferLength;
            var columns = this.columns;
            for (i = 0; i < columns; ++i) {
              for (var kk = 0; kk < colors; ++kk) {
                if (inbits < bits) {
                  inbuf = inbuf << 8 | rawBytes[j++] & 0xFF;
                  inbits += 8;
                }
                compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
                inbits -= bits;
                outbuf = outbuf << bits | compArray[kk];
                outbits += bits;
                if (outbits >= 8) {
                  buffer[k++] = outbuf >> outbits - 8 & 0xFF;
                  outbits -= 8;
                }
              }
            }
            if (outbits > 0) {
              buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
            }
          }
          this.bufferLength += rowBytes;
        };
        PredictorStream.prototype.readBlockPng = function predictorStreamReadBlockPng() {
          var rowBytes = this.rowBytes;
          var pixBytes = this.pixBytes;
          var predictor = this.str.getByte();
          var rawBytes = this.str.getBytes(rowBytes);
          this.eof = !rawBytes.length;
          if (this.eof) {
            return;
          }
          var bufferLength = this.bufferLength;
          var buffer = this.ensureBuffer(bufferLength + rowBytes);
          var prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
          if (prevRow.length === 0) {
            prevRow = new Uint8Array(rowBytes);
          }
          var i,
            j = bufferLength,
            up,
            c;
          switch (predictor) {
            case 0:
              for (i = 0; i < rowBytes; ++i) {
                buffer[j++] = rawBytes[i];
              }
              break;
            case 1:
              for (i = 0; i < pixBytes; ++i) {
                buffer[j++] = rawBytes[i];
              }
              for (; i < rowBytes; ++i) {
                buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xFF;
                j++;
              }
              break;
            case 2:
              for (i = 0; i < rowBytes; ++i) {
                buffer[j++] = prevRow[i] + rawBytes[i] & 0xFF;
              }
              break;
            case 3:
              for (i = 0; i < pixBytes; ++i) {
                buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
              }
              for (; i < rowBytes; ++i) {
                buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xFF;
                j++;
              }
              break;
            case 4:
              for (i = 0; i < pixBytes; ++i) {
                up = prevRow[i];
                c = rawBytes[i];
                buffer[j++] = up + c;
              }
              for (; i < rowBytes; ++i) {
                up = prevRow[i];
                var upLeft = prevRow[i - pixBytes];
                var left = buffer[j - pixBytes];
                var p = left + up - upLeft;
                var pa = p - left;
                if (pa < 0) {
                  pa = -pa;
                }
                var pb = p - up;
                if (pb < 0) {
                  pb = -pb;
                }
                var pc = p - upLeft;
                if (pc < 0) {
                  pc = -pc;
                }
                c = rawBytes[i];
                if (pa <= pb && pa <= pc) {
                  buffer[j++] = left + c;
                } else if (pb <= pc) {
                  buffer[j++] = up + c;
                } else {
                  buffer[j++] = upLeft + c;
                }
              }
              break;
            default:
              throw new _util.FormatError("Unsupported predictor: " + predictor);
          }
          this.bufferLength += rowBytes;
        };
        return PredictorStream;
      }();
      var JpegStream = function JpegStreamClosure() {
        function JpegStream(stream, maybeLength, dict, params) {
          var ch;
          while ((ch = stream.getByte()) !== -1) {
            if (ch === 0xFF) {
              stream.skip(-1);
              break;
            }
          }
          this.stream = stream;
          this.maybeLength = maybeLength;
          this.dict = dict;
          this.params = params;
          DecodeStream.call(this, maybeLength);
        }
        JpegStream.prototype = Object.create(DecodeStream.prototype);
        Object.defineProperty(JpegStream.prototype, "bytes", {
          get: function JpegStream_bytes() {
            return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
          },
          configurable: true
        });
        JpegStream.prototype.ensureBuffer = function JpegStream_ensureBuffer(req) {
          if (this.bufferLength) {
            return;
          }
          var jpegImage = new _jpg.JpegImage();
          var decodeArr = this.dict.getArray("Decode", "D");
          if (this.forceRGB && Array.isArray(decodeArr)) {
            var bitsPerComponent = this.dict.get("BitsPerComponent") || 8;
            var decodeArrLength = decodeArr.length;
            var transform = new Int32Array(decodeArrLength);
            var transformNeeded = false;
            var maxValue = (1 << bitsPerComponent) - 1;
            for (var i = 0; i < decodeArrLength; i += 2) {
              transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
              transform[i + 1] = decodeArr[i] * maxValue | 0;
              if (transform[i] !== 256 || transform[i + 1] !== 0) {
                transformNeeded = true;
              }
            }
            if (transformNeeded) {
              jpegImage.decodeTransform = transform;
            }
          }
          if ((0, _primitives.isDict)(this.params)) {
            var colorTransform = this.params.get("ColorTransform");
            if (Number.isInteger(colorTransform)) {
              jpegImage.colorTransform = colorTransform;
            }
          }
          jpegImage.parse(this.bytes);
          var data = jpegImage.getData(this.drawWidth, this.drawHeight, this.forceRGB);
          this.buffer = data;
          this.bufferLength = data.length;
          this.eof = true;
        };
        JpegStream.prototype.getBytes = function JpegStream_getBytes(length) {
          this.ensureBuffer();
          return this.buffer;
        };
        JpegStream.prototype.getIR = function JpegStream_getIR(forceDataSchema) {
          return (0, _util.createObjectURL)(this.bytes, "image/jpeg", forceDataSchema);
        };
        return JpegStream;
      }();
      var JpxStream = function JpxStreamClosure() {
        function JpxStream(stream, maybeLength, dict, params) {
          this.stream = stream;
          this.maybeLength = maybeLength;
          this.dict = dict;
          this.params = params;
          DecodeStream.call(this, maybeLength);
        }
        JpxStream.prototype = Object.create(DecodeStream.prototype);
        Object.defineProperty(JpxStream.prototype, "bytes", {
          get: function JpxStream_bytes() {
            return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
          },
          configurable: true
        });
        JpxStream.prototype.ensureBuffer = function JpxStream_ensureBuffer(req) {
          if (this.bufferLength) {
            return;
          }
          var jpxImage = new _jpx.JpxImage();
          jpxImage.parse(this.bytes);
          var width = jpxImage.width;
          var height = jpxImage.height;
          var componentsCount = jpxImage.componentsCount;
          var tileCount = jpxImage.tiles.length;
          if (tileCount === 1) {
            this.buffer = jpxImage.tiles[0].items;
          } else {
            var data = new Uint8ClampedArray(width * height * componentsCount);
            for (var k = 0; k < tileCount; k++) {
              var tileComponents = jpxImage.tiles[k];
              var tileWidth = tileComponents.width;
              var tileHeight = tileComponents.height;
              var tileLeft = tileComponents.left;
              var tileTop = tileComponents.top;
              var src = tileComponents.items;
              var srcPosition = 0;
              var dataPosition = (width * tileTop + tileLeft) * componentsCount;
              var imgRowSize = width * componentsCount;
              var tileRowSize = tileWidth * componentsCount;
              for (var j = 0; j < tileHeight; j++) {
                var rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
                data.set(rowBytes, dataPosition);
                srcPosition += tileRowSize;
                dataPosition += imgRowSize;
              }
            }
            this.buffer = data;
          }
          this.bufferLength = this.buffer.length;
          this.eof = true;
        };
        return JpxStream;
      }();
      var DecryptStream = function DecryptStreamClosure() {
        function DecryptStream(str, maybeLength, decrypt) {
          this.str = str;
          this.dict = str.dict;
          this.decrypt = decrypt;
          this.nextChunk = null;
          this.initialized = false;
          DecodeStream.call(this, maybeLength);
        }
        var chunkSize = 512;
        DecryptStream.prototype = Object.create(DecodeStream.prototype);
        DecryptStream.prototype.readBlock = function DecryptStream_readBlock() {
          var chunk;
          if (this.initialized) {
            chunk = this.nextChunk;
          } else {
            chunk = this.str.getBytes(chunkSize);
            this.initialized = true;
          }
          if (!chunk || chunk.length === 0) {
            this.eof = true;
            return;
          }
          this.nextChunk = this.str.getBytes(chunkSize);
          var hasMoreData = this.nextChunk && this.nextChunk.length > 0;
          var decrypt = this.decrypt;
          chunk = decrypt(chunk, !hasMoreData);
          var bufferLength = this.bufferLength;
          var i,
            n = chunk.length;
          var buffer = this.ensureBuffer(bufferLength + n);
          for (i = 0; i < n; i++) {
            buffer[bufferLength++] = chunk[i];
          }
          this.bufferLength = bufferLength;
        };
        return DecryptStream;
      }();
      var Ascii85Stream = function Ascii85StreamClosure() {
        function Ascii85Stream(str, maybeLength) {
          this.str = str;
          this.dict = str.dict;
          this.input = new Uint8Array(5);
          if (maybeLength) {
            maybeLength = 0.8 * maybeLength;
          }
          DecodeStream.call(this, maybeLength);
        }
        Ascii85Stream.prototype = Object.create(DecodeStream.prototype);
        Ascii85Stream.prototype.readBlock = function Ascii85Stream_readBlock() {
          var TILDA_CHAR = 0x7E;
          var Z_LOWER_CHAR = 0x7A;
          var EOF = -1;
          var str = this.str;
          var c = str.getByte();
          while ((0, _util.isSpace)(c)) {
            c = str.getByte();
          }
          if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
          }
          var bufferLength = this.bufferLength,
            buffer;
          var i;
          if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for (i = 0; i < 4; ++i) {
              buffer[bufferLength + i] = 0;
            }
            this.bufferLength += 4;
          } else {
            var input = this.input;
            input[0] = c;
            for (i = 1; i < 5; ++i) {
              c = str.getByte();
              while ((0, _util.isSpace)(c)) {
                c = str.getByte();
              }
              input[i] = c;
              if (c === EOF || c === TILDA_CHAR) {
                break;
              }
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            if (i < 5) {
              for (; i < 5; ++i) {
                input[i] = 0x21 + 84;
              }
              this.eof = true;
            }
            var t = 0;
            for (i = 0; i < 5; ++i) {
              t = t * 85 + (input[i] - 0x21);
            }
            for (i = 3; i >= 0; --i) {
              buffer[bufferLength + i] = t & 0xFF;
              t >>= 8;
            }
          }
        };
        return Ascii85Stream;
      }();
      var AsciiHexStream = function AsciiHexStreamClosure() {
        function AsciiHexStream(str, maybeLength) {
          this.str = str;
          this.dict = str.dict;
          this.firstDigit = -1;
          if (maybeLength) {
            maybeLength = 0.5 * maybeLength;
          }
          DecodeStream.call(this, maybeLength);
        }
        AsciiHexStream.prototype = Object.create(DecodeStream.prototype);
        AsciiHexStream.prototype.readBlock = function AsciiHexStream_readBlock() {
          var UPSTREAM_BLOCK_SIZE = 8000;
          var bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
          if (!bytes.length) {
            this.eof = true;
            return;
          }
          var maxDecodeLength = bytes.length + 1 >> 1;
          var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
          var bufferLength = this.bufferLength;
          var firstDigit = this.firstDigit;
          for (var i = 0, ii = bytes.length; i < ii; i++) {
            var ch = bytes[i],
              digit;
            if (ch >= 0x30 && ch <= 0x39) {
              digit = ch & 0x0F;
            } else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
              digit = (ch & 0x0F) + 9;
            } else if (ch === 0x3E) {
              this.eof = true;
              break;
            } else {
              continue;
            }
            if (firstDigit < 0) {
              firstDigit = digit;
            } else {
              buffer[bufferLength++] = firstDigit << 4 | digit;
              firstDigit = -1;
            }
          }
          if (firstDigit >= 0 && this.eof) {
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
          }
          this.firstDigit = firstDigit;
          this.bufferLength = bufferLength;
        };
        return AsciiHexStream;
      }();
      var RunLengthStream = function RunLengthStreamClosure() {
        function RunLengthStream(str, maybeLength) {
          this.str = str;
          this.dict = str.dict;
          DecodeStream.call(this, maybeLength);
        }
        RunLengthStream.prototype = Object.create(DecodeStream.prototype);
        RunLengthStream.prototype.readBlock = function RunLengthStream_readBlock() {
          var repeatHeader = this.str.getBytes(2);
          if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
          }
          var buffer;
          var bufferLength = this.bufferLength;
          var n = repeatHeader[0];
          if (n < 128) {
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
              var source = this.str.getBytes(n);
              buffer.set(source, bufferLength);
              bufferLength += n;
            }
          } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for (var i = 0; i < n; i++) {
              buffer[bufferLength++] = b;
            }
          }
          this.bufferLength = bufferLength;
        };
        return RunLengthStream;
      }();
      var LZWStream = function LZWStreamClosure() {
        function LZWStream(str, maybeLength, earlyChange) {
          this.str = str;
          this.dict = str.dict;
          this.cachedData = 0;
          this.bitsCached = 0;
          var maxLzwDictionarySize = 4096;
          var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
          };
          for (var i = 0; i < 256; ++i) {
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
          }
          this.lzwState = lzwState;
          DecodeStream.call(this, maybeLength);
        }
        LZWStream.prototype = Object.create(DecodeStream.prototype);
        LZWStream.prototype.readBits = function LZWStream_readBits(n) {
          var bitsCached = this.bitsCached;
          var cachedData = this.cachedData;
          while (bitsCached < n) {
            var c = this.str.getByte();
            if (c === -1) {
              this.eof = true;
              return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
          }
          this.bitsCached = bitsCached -= n;
          this.cachedData = cachedData;
          this.lastCode = null;
          return cachedData >>> bitsCached & (1 << n) - 1;
        };
        LZWStream.prototype.readBlock = function LZWStream_readBlock() {
          var blockSize = 512;
          var estimatedDecodedSize = blockSize * 2,
            decodedSizeDelta = blockSize;
          var i, j, q;
          var lzwState = this.lzwState;
          if (!lzwState) {
            return;
          }
          var earlyChange = lzwState.earlyChange;
          var nextCode = lzwState.nextCode;
          var dictionaryValues = lzwState.dictionaryValues;
          var dictionaryLengths = lzwState.dictionaryLengths;
          var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
          var codeLength = lzwState.codeLength;
          var prevCode = lzwState.prevCode;
          var currentSequence = lzwState.currentSequence;
          var currentSequenceLength = lzwState.currentSequenceLength;
          var decodedLength = 0;
          var currentBufferLength = this.bufferLength;
          var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
          for (i = 0; i < blockSize; i++) {
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (code < 256) {
              currentSequence[0] = code;
              currentSequenceLength = 1;
            } else if (code >= 258) {
              if (code < nextCode) {
                currentSequenceLength = dictionaryLengths[code];
                for (j = currentSequenceLength - 1, q = code; j >= 0; j--) {
                  currentSequence[j] = dictionaryValues[q];
                  q = dictionaryPrevCodes[q];
                }
              } else {
                currentSequence[currentSequenceLength++] = currentSequence[0];
              }
            } else if (code === 256) {
              codeLength = 9;
              nextCode = 258;
              currentSequenceLength = 0;
              continue;
            } else {
              this.eof = true;
              delete this.lzwState;
              break;
            }
            if (hasPrev) {
              dictionaryPrevCodes[nextCode] = prevCode;
              dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
              dictionaryValues[nextCode] = currentSequence[0];
              nextCode++;
              codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
              do {
                estimatedDecodedSize += decodedSizeDelta;
              } while (estimatedDecodedSize < decodedLength);
              buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for (j = 0; j < currentSequenceLength; j++) {
              buffer[currentBufferLength++] = currentSequence[j];
            }
          }
          lzwState.nextCode = nextCode;
          lzwState.codeLength = codeLength;
          lzwState.prevCode = prevCode;
          lzwState.currentSequenceLength = currentSequenceLength;
          this.bufferLength = currentBufferLength;
        };
        return LZWStream;
      }();
      var NullStream = function NullStreamClosure() {
        function NullStream() {
          Stream.call(this, new Uint8Array(0));
        }
        NullStream.prototype = Stream.prototype;
        return NullStream;
      }();
      exports.Ascii85Stream = Ascii85Stream;
      exports.AsciiHexStream = AsciiHexStream;
      exports.DecryptStream = DecryptStream;
      exports.DecodeStream = DecodeStream;
      exports.FlateStream = FlateStream;
      exports.JpegStream = JpegStream;
      exports.JpxStream = JpxStream;
      exports.NullStream = NullStream;
      exports.PredictorStream = PredictorStream;
      exports.RunLengthStream = RunLengthStream;
      exports.Stream = Stream;
      exports.StreamsSequenceStream = StreamsSequenceStream;
      exports.StringStream = StringStream;
      exports.LZWStream = LZWStream;

      /***/ }),
    /* 6 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var core = __w_pdfjs_require__(7);
      var hide = __w_pdfjs_require__(8);
      var redefine = __w_pdfjs_require__(16);
      var ctx = __w_pdfjs_require__(13);
      var PROTOTYPE = "prototype";
      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          own = !IS_FORCED && target && target[key] !== undefined;
          out = (own ? target : source)[key];
          exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out === "function" ? ctx(Function.call, out) : out;
          if (target) redefine(target, key, out, type & $export.U);
          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global.core = core;
      $export.F = 1;
      $export.G = 2;
      $export.S = 4;
      $export.P = 8;
      $export.B = 16;
      $export.W = 32;
      $export.U = 64;
      $export.R = 128;
      module.exports = $export;

      /***/ }),
    /* 7 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var core = module.exports = { version: "2.5.1" };
      if (typeof __e === "number") __e = core;

      /***/ }),
    /* 8 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var dP = __w_pdfjs_require__(15);
      var createDesc = __w_pdfjs_require__(29);
      module.exports = __w_pdfjs_require__(11) ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };

      /***/ }),
    /* 9 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + " is not an object!");
        return it;
      };

      /***/ }),
    /* 10 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/ }),
    /* 11 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = !__w_pdfjs_require__(12)(function () {
        return Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/ }),
    /* 12 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/ }),
    /* 13 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var aFunction = __w_pdfjs_require__(21);
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function () {
          return fn.apply(that, arguments);
        };
      };

      /***/ }),
    /* 14 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(18);
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
      };

      /***/ }),
    /* 15 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(9);
      var IE8_DOM_DEFINE = __w_pdfjs_require__(48);
      var toPrimitive = __w_pdfjs_require__(36);
      var dP = Object.defineProperty;
      exports.f = __w_pdfjs_require__(11) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {}
        if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
        if ("value" in Attributes) O[P] = Attributes.value;
        return O;
      };

      /***/ }),
    /* 16 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var hide = __w_pdfjs_require__(8);
      var has = __w_pdfjs_require__(10);
      var SRC = __w_pdfjs_require__(17)("src");
      var TO_STRING = "toString";
      var $toString = Function[TO_STRING];
      var TPL = ("" + $toString).split(TO_STRING);
      __w_pdfjs_require__(7).inspectSource = function (it) {
        return $toString.call(it);
      };
      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val === "function";
        if (isFunction) has(val, "name") || hide(val, "name", key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? "" + O[key] : TPL.join(String(key)));
        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
      })(Function.prototype, TO_STRING, function toString() {
        return typeof this === "function" && this[SRC] || $toString.call(this);
      });

      /***/ }),
    /* 17 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return "Symbol(".concat(key === undefined ? "" : key, ")_", (++id + px).toString(36));
      };

      /***/ }),
    /* 18 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/ }),
    /* 19 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var defined = __w_pdfjs_require__(38);
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/ }),
    /* 20 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = {};

      /***/ }),
    /* 21 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (it) {
        if (typeof it !== "function") throw TypeError(it + " is not a function!");
        return it;
      };

      /***/ }),
    /* 22 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var redefine = __w_pdfjs_require__(16);
      module.exports = function (target, src, safe) {
        for (var key in src) {
          redefine(target, key, src[key], safe);
        } return target;
      };

      /***/ }),
    /* 23 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
          throw TypeError(name + ": incorrect invocation!");
        }
        return it;
      };

      /***/ }),
    /* 24 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toString = {}.toString;
      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/ }),
    /* 25 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var def = __w_pdfjs_require__(15).f;
      var has = __w_pdfjs_require__(10);
      var TAG = __w_pdfjs_require__(4)("toStringTag");
      module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
          configurable: true,
          value: tag
        });
      };

      /***/ }),
    /* 26 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ColorSpace = undefined;

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var ColorSpace = function ColorSpaceClosure() {
        function resizeRgbImage(src, bpc, w1, h1, w2, h2, alpha01, dest) {
          var COMPONENTS = 3;
          alpha01 = alpha01 !== 1 ? 0 : alpha01;
          var xRatio = w1 / w2;
          var yRatio = h1 / h2;
          var i,
            j,
            py,
            newIndex = 0,
            oldIndex;
          var xScaled = new Uint16Array(w2);
          var w1Scanline = w1 * COMPONENTS;
          for (i = 0; i < w2; i++) {
            xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
          }
          for (i = 0; i < h2; i++) {
            py = Math.floor(i * yRatio) * w1Scanline;
            for (j = 0; j < w2; j++) {
              oldIndex = py + xScaled[j];
              dest[newIndex++] = src[oldIndex++];
              dest[newIndex++] = src[oldIndex++];
              dest[newIndex++] = src[oldIndex++];
              newIndex += alpha01;
            }
          }
        }
        function ColorSpace() {
          throw new Error("should not call ColorSpace constructor");
        }
        ColorSpace.prototype = {
          getRgb: function ColorSpace_getRgb(src, srcOffset) {
            var rgb = new Uint8Array(3);
            this.getRgbItem(src, srcOffset, rgb, 0);
            return rgb;
          },
          getRgbItem: function ColorSpace_getRgbItem(src, srcOffset, dest, destOffset) {
            throw new Error("Should not call ColorSpace.getRgbItem");
          },
          getRgbBuffer: function ColorSpace_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            throw new Error("Should not call ColorSpace.getRgbBuffer");
          },
          getOutputLength: function ColorSpace_getOutputLength(inputLength, alpha01) {
            throw new Error("Should not call ColorSpace.getOutputLength");
          },
          isPassthrough: function ColorSpace_isPassthrough(bits) {
            return false;
          },
          fillRgb: function ColorSpace_fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
            var count = originalWidth * originalHeight;
            var rgbBuf = null;
            var numComponentColors = 1 << bpc;
            var needsResizing = originalHeight !== height || originalWidth !== width;
            var i, ii;
            if (this.isPassthrough(bpc)) {
              rgbBuf = comps;
            } else if (this.numComps === 1 && count > numComponentColors && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
              var allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
              var key;
              for (i = 0; i < numComponentColors; i++) {
                allColors[i] = i;
              }
              var colorMap = new Uint8Array(numComponentColors * 3);
              this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
              var destPos, rgbPos;
              if (!needsResizing) {
                destPos = 0;
                for (i = 0; i < count; ++i) {
                  key = comps[i] * 3;
                  dest[destPos++] = colorMap[key];
                  dest[destPos++] = colorMap[key + 1];
                  dest[destPos++] = colorMap[key + 2];
                  destPos += alpha01;
                }
              } else {
                rgbBuf = new Uint8Array(count * 3);
                rgbPos = 0;
                for (i = 0; i < count; ++i) {
                  key = comps[i] * 3;
                  rgbBuf[rgbPos++] = colorMap[key];
                  rgbBuf[rgbPos++] = colorMap[key + 1];
                  rgbBuf[rgbPos++] = colorMap[key + 2];
                }
              }
            } else {
              if (!needsResizing) {
                this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
              } else {
                rgbBuf = new Uint8Array(count * 3);
                this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
              }
            }
            if (rgbBuf) {
              if (needsResizing) {
                resizeRgbImage(rgbBuf, bpc, originalWidth, originalHeight, width, height, alpha01, dest);
              } else {
                rgbPos = 0;
                destPos = 0;
                for (i = 0, ii = width * actualHeight; i < ii; i++) {
                  dest[destPos++] = rgbBuf[rgbPos++];
                  dest[destPos++] = rgbBuf[rgbPos++];
                  dest[destPos++] = rgbBuf[rgbPos++];
                  destPos += alpha01;
                }
              }
            }
          },
          usesZeroToOneRange: true
        };
        ColorSpace.parse = function (cs, xref, res, pdfFunctionFactory) {
          var IR = ColorSpace.parseToIR(cs, xref, res, pdfFunctionFactory);
          return ColorSpace.fromIR(IR, pdfFunctionFactory);
        };
        ColorSpace.fromIR = function (IR, pdfFunctionFactory) {
          var name = Array.isArray(IR) ? IR[0] : IR;
          var whitePoint, blackPoint, gamma;
          switch (name) {
            case "DeviceGrayCS":
              return this.singletons.gray;
            case "DeviceRgbCS":
              return this.singletons.rgb;
            case "DeviceCmykCS":
              return this.singletons.cmyk;
            case "CalGrayCS":
              whitePoint = IR[1];
              blackPoint = IR[2];
              gamma = IR[3];
              return new CalGrayCS(whitePoint, blackPoint, gamma);
            case "CalRGBCS":
              whitePoint = IR[1];
              blackPoint = IR[2];
              gamma = IR[3];
              var matrix = IR[4];
              return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
            case "PatternCS":
              var basePatternCS = IR[1];
              if (basePatternCS) {
                basePatternCS = ColorSpace.fromIR(basePatternCS, pdfFunctionFactory);
              }
              return new PatternCS(basePatternCS);
            case "IndexedCS":
              var baseIndexedCS = IR[1];
              var hiVal = IR[2];
              var lookup = IR[3];
              return new IndexedCS(ColorSpace.fromIR(baseIndexedCS, pdfFunctionFactory), hiVal, lookup);
            case "AlternateCS":
              var numComps = IR[1];
              var alt = IR[2];
              var tintFnIR = IR[3];
              return new AlternateCS(numComps, ColorSpace.fromIR(alt, pdfFunctionFactory), pdfFunctionFactory.createFromIR(tintFnIR));
            case "LabCS":
              whitePoint = IR[1];
              blackPoint = IR[2];
              var range = IR[3];
              return new LabCS(whitePoint, blackPoint, range);
            default:
              throw new _util.FormatError("Unknown colorspace name: " + name);
          }
        };
        ColorSpace.parseToIR = function (cs, xref, res, pdfFunctionFactory) {
          if ((0, _primitives.isName)(cs)) {
            var colorSpaces = res.get("ColorSpace");
            if ((0, _primitives.isDict)(colorSpaces)) {
              var refcs = colorSpaces.get(cs.name);
              if (refcs) {
                cs = refcs;
              }
            }
          }
          cs = xref.fetchIfRef(cs);
          if ((0, _primitives.isName)(cs)) {
            switch (cs.name) {
              case "DeviceGray":
              case "G":
                return "DeviceGrayCS";
              case "DeviceRGB":
              case "RGB":
                return "DeviceRgbCS";
              case "DeviceCMYK":
              case "CMYK":
                return "DeviceCmykCS";
              case "Pattern":
                return ["PatternCS", null];
              default:
                throw new _util.FormatError("unrecognized colorspace " + cs.name);
            }
          }
          if (Array.isArray(cs)) {
            var mode = xref.fetchIfRef(cs[0]).name;
            var numComps, params, alt, whitePoint, blackPoint, gamma;
            switch (mode) {
              case "DeviceGray":
              case "G":
                return "DeviceGrayCS";
              case "DeviceRGB":
              case "RGB":
                return "DeviceRgbCS";
              case "DeviceCMYK":
              case "CMYK":
                return "DeviceCmykCS";
              case "CalGray":
                params = xref.fetchIfRef(cs[1]);
                whitePoint = params.getArray("WhitePoint");
                blackPoint = params.getArray("BlackPoint");
                gamma = params.get("Gamma");
                return ["CalGrayCS", whitePoint, blackPoint, gamma];
              case "CalRGB":
                params = xref.fetchIfRef(cs[1]);
                whitePoint = params.getArray("WhitePoint");
                blackPoint = params.getArray("BlackPoint");
                gamma = params.getArray("Gamma");
                var matrix = params.getArray("Matrix");
                return ["CalRGBCS", whitePoint, blackPoint, gamma, matrix];
              case "ICCBased":
                var stream = xref.fetchIfRef(cs[1]);
                var dict = stream.dict;
                numComps = dict.get("N");
                alt = dict.get("Alternate");
                if (alt) {
                  var altIR = ColorSpace.parseToIR(alt, xref, res, pdfFunctionFactory);
                  var altCS = ColorSpace.fromIR(altIR, pdfFunctionFactory);
                  if (altCS.numComps === numComps) {
                    return altIR;
                  }
                  (0, _util.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                }
                if (numComps === 1) {
                  return "DeviceGrayCS";
                } else if (numComps === 3) {
                  return "DeviceRgbCS";
                } else if (numComps === 4) {
                  return "DeviceCmykCS";
                }
                break;
              case "Pattern":
                var basePatternCS = cs[1] || null;
                if (basePatternCS) {
                  basePatternCS = ColorSpace.parseToIR(basePatternCS, xref, res, pdfFunctionFactory);
                }
                return ["PatternCS", basePatternCS];
              case "Indexed":
              case "I":
                var baseIndexedCS = ColorSpace.parseToIR(cs[1], xref, res, pdfFunctionFactory);
                var hiVal = xref.fetchIfRef(cs[2]) + 1;
                var lookup = xref.fetchIfRef(cs[3]);
                if ((0, _primitives.isStream)(lookup)) {
                  lookup = lookup.getBytes();
                }
                return ["IndexedCS", baseIndexedCS, hiVal, lookup];
              case "Separation":
              case "DeviceN":
                var name = xref.fetchIfRef(cs[1]);
                numComps = Array.isArray(name) ? name.length : 1;
                alt = ColorSpace.parseToIR(cs[2], xref, res, pdfFunctionFactory);
                var tintFnIR = pdfFunctionFactory.createIR(xref.fetchIfRef(cs[3]));
                return ["AlternateCS", numComps, alt, tintFnIR];
              case "Lab":
                params = xref.fetchIfRef(cs[1]);
                whitePoint = params.getArray("WhitePoint");
                blackPoint = params.getArray("BlackPoint");
                var range = params.getArray("Range");
                return ["LabCS", whitePoint, blackPoint, range];
              default:
                throw new _util.FormatError("unimplemented color space object \"" + mode + "\"");
            }
          }
          throw new _util.FormatError("unrecognized color space object: \"" + cs + "\"");
        };
        ColorSpace.isDefaultDecode = function ColorSpace_isDefaultDecode(decode, n) {
          if (!Array.isArray(decode)) {
            return true;
          }
          if (n * 2 !== decode.length) {
            (0, _util.warn)("The decode map is not the correct length");
            return true;
          }
          for (var i = 0, ii = decode.length; i < ii; i += 2) {
            if (decode[i] !== 0 || decode[i + 1] !== 1) {
              return false;
            }
          }
          return true;
        };
        ColorSpace.singletons = {
          get gray() {
            return (0, _util.shadow)(this, "gray", new DeviceGrayCS());
          },
          get rgb() {
            return (0, _util.shadow)(this, "rgb", new DeviceRgbCS());
          },
          get cmyk() {
            return (0, _util.shadow)(this, "cmyk", new DeviceCmykCS());
          }
        };
        return ColorSpace;
      }();
      var AlternateCS = function AlternateCSClosure() {
        function AlternateCS(numComps, base, tintFn) {
          this.name = "Alternate";
          this.numComps = numComps;
          this.defaultColor = new Float32Array(numComps);
          for (var i = 0; i < numComps; ++i) {
            this.defaultColor[i] = 1;
          }
          this.base = base;
          this.tintFn = tintFn;
          this.tmpBuf = new Float32Array(base.numComps);
        }
        AlternateCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function AlternateCS_getRgbItem(src, srcOffset, dest, destOffset) {
            var tmpBuf = this.tmpBuf;
            this.tintFn(src, srcOffset, tmpBuf, 0);
            this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
          },
          getRgbBuffer: function AlternateCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var tintFn = this.tintFn;
            var base = this.base;
            var scale = 1 / ((1 << bits) - 1);
            var baseNumComps = base.numComps;
            var usesZeroToOneRange = base.usesZeroToOneRange;
            var isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
            var pos = isPassthrough ? destOffset : 0;
            var baseBuf = isPassthrough ? dest : new Uint8Array(baseNumComps * count);
            var numComps = this.numComps;
            var scaled = new Float32Array(numComps);
            var tinted = new Float32Array(baseNumComps);
            var i, j;
            for (i = 0; i < count; i++) {
              for (j = 0; j < numComps; j++) {
                scaled[j] = src[srcOffset++] * scale;
              }
              tintFn(scaled, 0, tinted, 0);
              if (usesZeroToOneRange) {
                for (j = 0; j < baseNumComps; j++) {
                  baseBuf[pos++] = tinted[j] * 255;
                }
              } else {
                base.getRgbItem(tinted, 0, baseBuf, pos);
                pos += baseNumComps;
              }
            }
            if (!isPassthrough) {
              base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
            }
          },
          getOutputLength: function AlternateCS_getOutputLength(inputLength, alpha01) {
            return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function AlternateCS_isDefaultDecode(decodeMap) {
            return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
          },
          usesZeroToOneRange: true
        };
        return AlternateCS;
      }();
      var PatternCS = function PatternCSClosure() {
        function PatternCS(baseCS) {
          this.name = "Pattern";
          this.base = baseCS;
        }
        PatternCS.prototype = {};
        return PatternCS;
      }();
      var IndexedCS = function IndexedCSClosure() {
        function IndexedCS(base, highVal, lookup) {
          this.name = "Indexed";
          this.numComps = 1;
          this.defaultColor = new Uint8Array(this.numComps);
          this.base = base;
          this.highVal = highVal;
          var baseNumComps = base.numComps;
          var length = baseNumComps * highVal;
          if ((0, _primitives.isStream)(lookup)) {
            this.lookup = new Uint8Array(length);
            var bytes = lookup.getBytes(length);
            this.lookup.set(bytes);
          } else if ((0, _util.isString)(lookup)) {
            this.lookup = new Uint8Array(length);
            for (var i = 0; i < length; ++i) {
              this.lookup[i] = lookup.charCodeAt(i);
            }
          } else if (lookup instanceof Uint8Array || lookup instanceof Array) {
            this.lookup = lookup;
          } else {
            throw new _util.FormatError("Unrecognized lookup table: " + lookup);
          }
        }
        IndexedCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function IndexedCS_getRgbItem(src, srcOffset, dest, destOffset) {
            var numComps = this.base.numComps;
            var start = src[srcOffset] * numComps;
            this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
          },
          getRgbBuffer: function IndexedCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var base = this.base;
            var numComps = base.numComps;
            var outputDelta = base.getOutputLength(numComps, alpha01);
            var lookup = this.lookup;
            for (var i = 0; i < count; ++i) {
              var lookupPos = src[srcOffset++] * numComps;
              base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
              destOffset += outputDelta;
            }
          },
          getOutputLength: function IndexedCS_getOutputLength(inputLength, alpha01) {
            return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function IndexedCS_isDefaultDecode(decodeMap) {
            return true;
          },
          usesZeroToOneRange: true
        };
        return IndexedCS;
      }();
      var DeviceGrayCS = function DeviceGrayCSClosure() {
        function DeviceGrayCS() {
          this.name = "DeviceGray";
          this.numComps = 1;
          this.defaultColor = new Float32Array(this.numComps);
        }
        DeviceGrayCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function DeviceGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
            var c = src[srcOffset] * 255 | 0;
            c = c < 0 ? 0 : c > 255 ? 255 : c;
            dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
          },
          getRgbBuffer: function DeviceGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var scale = 255 / ((1 << bits) - 1);
            var j = srcOffset,
              q = destOffset;
            for (var i = 0; i < count; ++i) {
              var c = scale * src[j++] | 0;
              dest[q++] = c;
              dest[q++] = c;
              dest[q++] = c;
              q += alpha01;
            }
          },
          getOutputLength: function DeviceGrayCS_getOutputLength(inputLength, alpha01) {
            return inputLength * (3 + alpha01);
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function DeviceGrayCS_isDefaultDecode(decodeMap) {
            return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
          },
          usesZeroToOneRange: true
        };
        return DeviceGrayCS;
      }();
      var DeviceRgbCS = function DeviceRgbCSClosure() {
        function DeviceRgbCS() {
          this.name = "DeviceRGB";
          this.numComps = 3;
          this.defaultColor = new Float32Array(this.numComps);
        }
        DeviceRgbCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function DeviceRgbCS_getRgbItem(src, srcOffset, dest, destOffset) {
            var r = src[srcOffset] * 255 | 0;
            var g = src[srcOffset + 1] * 255 | 0;
            var b = src[srcOffset + 2] * 255 | 0;
            dest[destOffset] = r < 0 ? 0 : r > 255 ? 255 : r;
            dest[destOffset + 1] = g < 0 ? 0 : g > 255 ? 255 : g;
            dest[destOffset + 2] = b < 0 ? 0 : b > 255 ? 255 : b;
          },
          getRgbBuffer: function DeviceRgbCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            if (bits === 8 && alpha01 === 0) {
              dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
              return;
            }
            var scale = 255 / ((1 << bits) - 1);
            var j = srcOffset,
              q = destOffset;
            for (var i = 0; i < count; ++i) {
              dest[q++] = scale * src[j++] | 0;
              dest[q++] = scale * src[j++] | 0;
              dest[q++] = scale * src[j++] | 0;
              q += alpha01;
            }
          },
          getOutputLength: function DeviceRgbCS_getOutputLength(inputLength, alpha01) {
            return inputLength * (3 + alpha01) / 3 | 0;
          },
          isPassthrough: function DeviceRgbCS_isPassthrough(bits) {
            return bits === 8;
          },
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function DeviceRgbCS_isDefaultDecode(decodeMap) {
            return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
          },
          usesZeroToOneRange: true
        };
        return DeviceRgbCS;
      }();
      var DeviceCmykCS = function DeviceCmykCSClosure() {
        function convertToRgb(src, srcOffset, srcScale, dest, destOffset) {
          var c = src[srcOffset + 0] * srcScale;
          var m = src[srcOffset + 1] * srcScale;
          var y = src[srcOffset + 2] * srcScale;
          var k = src[srcOffset + 3] * srcScale;
          var r = c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747) + 255 | 0;
          var g = c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578) + 255 | 0;
          var b = c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367) + 255 | 0;
          dest[destOffset] = r > 255 ? 255 : r < 0 ? 0 : r;
          dest[destOffset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
          dest[destOffset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
        }
        function DeviceCmykCS() {
          this.name = "DeviceCMYK";
          this.numComps = 4;
          this.defaultColor = new Float32Array(this.numComps);
          this.defaultColor[3] = 1;
        }
        DeviceCmykCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function DeviceCmykCS_getRgbItem(src, srcOffset, dest, destOffset) {
            convertToRgb(src, srcOffset, 1, dest, destOffset);
          },
          getRgbBuffer: function DeviceCmykCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var scale = 1 / ((1 << bits) - 1);
            for (var i = 0; i < count; i++) {
              convertToRgb(src, srcOffset, scale, dest, destOffset);
              srcOffset += 4;
              destOffset += 3 + alpha01;
            }
          },
          getOutputLength: function DeviceCmykCS_getOutputLength(inputLength, alpha01) {
            return inputLength / 4 * (3 + alpha01) | 0;
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function DeviceCmykCS_isDefaultDecode(decodeMap) {
            return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
          },
          usesZeroToOneRange: true
        };
        return DeviceCmykCS;
      }();
      var CalGrayCS = function CalGrayCSClosure() {
        function CalGrayCS(whitePoint, blackPoint, gamma) {
          this.name = "CalGray";
          this.numComps = 1;
          this.defaultColor = new Float32Array(this.numComps);
          if (!whitePoint) {
            throw new _util.FormatError("WhitePoint missing - required for color space CalGray");
          }
          blackPoint = blackPoint || [0, 0, 0];
          gamma = gamma || 1;
          this.XW = whitePoint[0];
          this.YW = whitePoint[1];
          this.ZW = whitePoint[2];
          this.XB = blackPoint[0];
          this.YB = blackPoint[1];
          this.ZB = blackPoint[2];
          this.G = gamma;
          if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
            throw new _util.FormatError("Invalid WhitePoint components for " + this.name + ", no fallback available");
          }
          if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
            (0, _util.info)("Invalid BlackPoint for " + this.name + ", falling back to default");
            this.XB = this.YB = this.ZB = 0;
          }
          if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) {
            (0, _util.warn)(this.name + ", BlackPoint: XB: " + this.XB + ", YB: " + this.YB + ", ZB: " + this.ZB + ", only default values are supported.");
          }
          if (this.G < 1) {
            (0, _util.info)("Invalid Gamma: " + this.G + " for " + this.name + ", falling back to default");
            this.G = 1;
          }
        }
        function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
          var A = src[srcOffset] * scale;
          var AG = Math.pow(A, cs.G);
          var L = cs.YW * AG;
          var val = Math.max(295.8 * Math.pow(L, 0.333333333333333333) - 40.8, 0) | 0;
          dest[destOffset] = val;
          dest[destOffset + 1] = val;
          dest[destOffset + 2] = val;
        }
        CalGrayCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function CalGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
            convertToRgb(this, src, srcOffset, dest, destOffset, 1);
          },
          getRgbBuffer: function CalGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var scale = 1 / ((1 << bits) - 1);
            for (var i = 0; i < count; ++i) {
              convertToRgb(this, src, srcOffset, dest, destOffset, scale);
              srcOffset += 1;
              destOffset += 3 + alpha01;
            }
          },
          getOutputLength: function CalGrayCS_getOutputLength(inputLength, alpha01) {
            return inputLength * (3 + alpha01);
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function CalGrayCS_isDefaultDecode(decodeMap) {
            return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
          },
          usesZeroToOneRange: true
        };
        return CalGrayCS;
      }();
      var CalRGBCS = function CalRGBCSClosure() {
        var BRADFORD_SCALE_MATRIX = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]);
        var BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -0.0085287, 0.0400428, 0.9684867]);
        var SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.9692660, 1.8760108, 0.0415560, 0.0556434, -0.2040259, 1.0572252]);
        var FLAT_WHITEPOINT_MATRIX = new Float32Array([1, 1, 1]);
        var tempNormalizeMatrix = new Float32Array(3);
        var tempConvertMatrix1 = new Float32Array(3);
        var tempConvertMatrix2 = new Float32Array(3);
        var DECODE_L_CONSTANT = Math.pow((8 + 16) / 116, 3) / 8.0;
        function CalRGBCS(whitePoint, blackPoint, gamma, matrix) {
          this.name = "CalRGB";
          this.numComps = 3;
          this.defaultColor = new Float32Array(this.numComps);
          if (!whitePoint) {
            throw new _util.FormatError("WhitePoint missing - required for color space CalRGB");
          }
          blackPoint = blackPoint || new Float32Array(3);
          gamma = gamma || new Float32Array([1, 1, 1]);
          matrix = matrix || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
          var XW = whitePoint[0];
          var YW = whitePoint[1];
          var ZW = whitePoint[2];
          this.whitePoint = whitePoint;
          var XB = blackPoint[0];
          var YB = blackPoint[1];
          var ZB = blackPoint[2];
          this.blackPoint = blackPoint;
          this.GR = gamma[0];
          this.GG = gamma[1];
          this.GB = gamma[2];
          this.MXA = matrix[0];
          this.MYA = matrix[1];
          this.MZA = matrix[2];
          this.MXB = matrix[3];
          this.MYB = matrix[4];
          this.MZB = matrix[5];
          this.MXC = matrix[6];
          this.MYC = matrix[7];
          this.MZC = matrix[8];
          if (XW < 0 || ZW < 0 || YW !== 1) {
            throw new _util.FormatError("Invalid WhitePoint components for " + this.name + ", no fallback available");
          }
          if (XB < 0 || YB < 0 || ZB < 0) {
            (0, _util.info)("Invalid BlackPoint for " + this.name + " [" + XB + ", " + YB + ", " + ZB + "], falling back to default");
            this.blackPoint = new Float32Array(3);
          }
          if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
            (0, _util.info)("Invalid Gamma [" + this.GR + ", " + this.GG + ", " + this.GB + "] for " + this.name + ", falling back to default");
            this.GR = this.GG = this.GB = 1;
          }
          if (this.MXA < 0 || this.MYA < 0 || this.MZA < 0 || this.MXB < 0 || this.MYB < 0 || this.MZB < 0 || this.MXC < 0 || this.MYC < 0 || this.MZC < 0) {
            (0, _util.info)("Invalid Matrix for " + this.name + " [" + this.MXA + ", " + this.MYA + ", " + this.MZA + this.MXB + ", " + this.MYB + ", " + this.MZB + this.MXC + ", " + this.MYC + ", " + this.MZC + "], falling back to default");
            this.MXA = this.MYB = this.MZC = 1;
            this.MXB = this.MYA = this.MZA = this.MXC = this.MYC = this.MZB = 0;
          }
        }
        function matrixProduct(a, b, result) {
          result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
          result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
          result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
        }
        function convertToFlat(sourceWhitePoint, LMS, result) {
          result[0] = LMS[0] * 1 / sourceWhitePoint[0];
          result[1] = LMS[1] * 1 / sourceWhitePoint[1];
          result[2] = LMS[2] * 1 / sourceWhitePoint[2];
        }
        function convertToD65(sourceWhitePoint, LMS, result) {
          var D65X = 0.95047;
          var D65Y = 1;
          var D65Z = 1.08883;
          result[0] = LMS[0] * D65X / sourceWhitePoint[0];
          result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
          result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
        }
        function sRGBTransferFunction(color) {
          if (color <= 0.0031308) {
            return adjustToRange(0, 1, 12.92 * color);
          }
          return adjustToRange(0, 1, (1 + 0.055) * Math.pow(color, 1 / 2.4) - 0.055);
        }
        function adjustToRange(min, max, value) {
          return Math.max(min, Math.min(max, value));
        }
        function decodeL(L) {
          if (L < 0) {
            return -decodeL(-L);
          }
          if (L > 8.0) {
            return Math.pow((L + 16) / 116, 3);
          }
          return L * DECODE_L_CONSTANT;
        }
        function compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
          if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
            result[0] = XYZ_Flat[0];
            result[1] = XYZ_Flat[1];
            result[2] = XYZ_Flat[2];
            return;
          }
          var zeroDecodeL = decodeL(0);
          var X_DST = zeroDecodeL;
          var X_SRC = decodeL(sourceBlackPoint[0]);
          var Y_DST = zeroDecodeL;
          var Y_SRC = decodeL(sourceBlackPoint[1]);
          var Z_DST = zeroDecodeL;
          var Z_SRC = decodeL(sourceBlackPoint[2]);
          var X_Scale = (1 - X_DST) / (1 - X_SRC);
          var X_Offset = 1 - X_Scale;
          var Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
          var Y_Offset = 1 - Y_Scale;
          var Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
          var Z_Offset = 1 - Z_Scale;
          result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
          result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
          result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
        }
        function normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
          if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
            result[0] = XYZ_In[0];
            result[1] = XYZ_In[1];
            result[2] = XYZ_In[2];
            return;
          }
          var LMS = result;
          matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
          var LMS_Flat = tempNormalizeMatrix;
          convertToFlat(sourceWhitePoint, LMS, LMS_Flat);
          matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
        }
        function normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
          var LMS = result;
          matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
          var LMS_D65 = tempNormalizeMatrix;
          convertToD65(sourceWhitePoint, LMS, LMS_D65);
          matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
        }
        function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
          var A = adjustToRange(0, 1, src[srcOffset] * scale);
          var B = adjustToRange(0, 1, src[srcOffset + 1] * scale);
          var C = adjustToRange(0, 1, src[srcOffset + 2] * scale);
          var AGR = Math.pow(A, cs.GR);
          var BGG = Math.pow(B, cs.GG);
          var CGB = Math.pow(C, cs.GB);
          var X = cs.MXA * AGR + cs.MXB * BGG + cs.MXC * CGB;
          var Y = cs.MYA * AGR + cs.MYB * BGG + cs.MYC * CGB;
          var Z = cs.MZA * AGR + cs.MZB * BGG + cs.MZC * CGB;
          var XYZ = tempConvertMatrix1;
          XYZ[0] = X;
          XYZ[1] = Y;
          XYZ[2] = Z;
          var XYZ_Flat = tempConvertMatrix2;
          normalizeWhitePointToFlat(cs.whitePoint, XYZ, XYZ_Flat);
          var XYZ_Black = tempConvertMatrix1;
          compensateBlackPoint(cs.blackPoint, XYZ_Flat, XYZ_Black);
          var XYZ_D65 = tempConvertMatrix2;
          normalizeWhitePointToD65(FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
          var SRGB = tempConvertMatrix1;
          matrixProduct(SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
          var sR = sRGBTransferFunction(SRGB[0]);
          var sG = sRGBTransferFunction(SRGB[1]);
          var sB = sRGBTransferFunction(SRGB[2]);
          dest[destOffset] = Math.round(sR * 255);
          dest[destOffset + 1] = Math.round(sG * 255);
          dest[destOffset + 2] = Math.round(sB * 255);
        }
        CalRGBCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function CalRGBCS_getRgbItem(src, srcOffset, dest, destOffset) {
            convertToRgb(this, src, srcOffset, dest, destOffset, 1);
          },
          getRgbBuffer: function CalRGBCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var scale = 1 / ((1 << bits) - 1);
            for (var i = 0; i < count; ++i) {
              convertToRgb(this, src, srcOffset, dest, destOffset, scale);
              srcOffset += 3;
              destOffset += 3 + alpha01;
            }
          },
          getOutputLength: function CalRGBCS_getOutputLength(inputLength, alpha01) {
            return inputLength * (3 + alpha01) / 3 | 0;
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function CalRGBCS_isDefaultDecode(decodeMap) {
            return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
          },
          usesZeroToOneRange: true
        };
        return CalRGBCS;
      }();
      var LabCS = function LabCSClosure() {
        function LabCS(whitePoint, blackPoint, range) {
          this.name = "Lab";
          this.numComps = 3;
          this.defaultColor = new Float32Array(this.numComps);
          if (!whitePoint) {
            throw new _util.FormatError("WhitePoint missing - required for color space Lab");
          }
          blackPoint = blackPoint || [0, 0, 0];
          range = range || [-100, 100, -100, 100];
          this.XW = whitePoint[0];
          this.YW = whitePoint[1];
          this.ZW = whitePoint[2];
          this.amin = range[0];
          this.amax = range[1];
          this.bmin = range[2];
          this.bmax = range[3];
          this.XB = blackPoint[0];
          this.YB = blackPoint[1];
          this.ZB = blackPoint[2];
          if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
            throw new _util.FormatError("Invalid WhitePoint components, no fallback available");
          }
          if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
            (0, _util.info)("Invalid BlackPoint, falling back to default");
            this.XB = this.YB = this.ZB = 0;
          }
          if (this.amin > this.amax || this.bmin > this.bmax) {
            (0, _util.info)("Invalid Range, falling back to defaults");
            this.amin = -100;
            this.amax = 100;
            this.bmin = -100;
            this.bmax = 100;
          }
        }
        function fn_g(x) {
          var result;
          if (x >= 6 / 29) {
            result = x * x * x;
          } else {
            result = 108 / 841 * (x - 4 / 29);
          }
          return result;
        }
        function decode(value, high1, low2, high2) {
          return low2 + value * (high2 - low2) / high1;
        }
        function convertToRgb(cs, src, srcOffset, maxVal, dest, destOffset) {
          var Ls = src[srcOffset];
          var as = src[srcOffset + 1];
          var bs = src[srcOffset + 2];
          if (maxVal !== false) {
            Ls = decode(Ls, maxVal, 0, 100);
            as = decode(as, maxVal, cs.amin, cs.amax);
            bs = decode(bs, maxVal, cs.bmin, cs.bmax);
          }
          as = as > cs.amax ? cs.amax : as < cs.amin ? cs.amin : as;
          bs = bs > cs.bmax ? cs.bmax : bs < cs.bmin ? cs.bmin : bs;
          var M = (Ls + 16) / 116;
          var L = M + as / 500;
          var N = M - bs / 200;
          var X = cs.XW * fn_g(L);
          var Y = cs.YW * fn_g(M);
          var Z = cs.ZW * fn_g(N);
          var r, g, b;
          if (cs.ZW < 1) {
            r = X * 3.1339 + Y * -1.6170 + Z * -0.4906;
            g = X * -0.9785 + Y * 1.9160 + Z * 0.0333;
            b = X * 0.0720 + Y * -0.2290 + Z * 1.4057;
          } else {
            r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
            g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
            b = X * 0.0557 + Y * -0.2040 + Z * 1.0570;
          }
          dest[destOffset] = r <= 0 ? 0 : r >= 1 ? 255 : Math.sqrt(r) * 255 | 0;
          dest[destOffset + 1] = g <= 0 ? 0 : g >= 1 ? 255 : Math.sqrt(g) * 255 | 0;
          dest[destOffset + 2] = b <= 0 ? 0 : b >= 1 ? 255 : Math.sqrt(b) * 255 | 0;
        }
        LabCS.prototype = {
          getRgb: ColorSpace.prototype.getRgb,
          getRgbItem: function LabCS_getRgbItem(src, srcOffset, dest, destOffset) {
            convertToRgb(this, src, srcOffset, false, dest, destOffset);
          },
          getRgbBuffer: function LabCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
            var maxVal = (1 << bits) - 1;
            for (var i = 0; i < count; i++) {
              convertToRgb(this, src, srcOffset, maxVal, dest, destOffset);
              srcOffset += 3;
              destOffset += 3 + alpha01;
            }
          },
          getOutputLength: function LabCS_getOutputLength(inputLength, alpha01) {
            return inputLength * (3 + alpha01) / 3 | 0;
          },
          isPassthrough: ColorSpace.prototype.isPassthrough,
          fillRgb: ColorSpace.prototype.fillRgb,
          isDefaultDecode: function LabCS_isDefaultDecode(decodeMap) {
            return true;
          },
          usesZeroToOneRange: false
        };
        return LabCS;
      }();
      exports.ColorSpace = ColorSpace;

      /***/ }),
    /* 27 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var ExpertEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
      var MacExpertEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall"];
      var MacRomanEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
      var StandardEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls"];
      var WinAnsiEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
      var SymbolSetEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt"];
      var ZapfDingbatsEncoding = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191"];
      function getEncoding(encodingName) {
        switch (encodingName) {
          case "WinAnsiEncoding":
            return WinAnsiEncoding;
          case "StandardEncoding":
            return StandardEncoding;
          case "MacRomanEncoding":
            return MacRomanEncoding;
          case "SymbolSetEncoding":
            return SymbolSetEncoding;
          case "ZapfDingbatsEncoding":
            return ZapfDingbatsEncoding;
          case "ExpertEncoding":
            return ExpertEncoding;
          case "MacExpertEncoding":
            return MacExpertEncoding;
          default:
            return null;
        }
      }
      exports.WinAnsiEncoding = WinAnsiEncoding;
      exports.StandardEncoding = StandardEncoding;
      exports.MacRomanEncoding = MacRomanEncoding;
      exports.SymbolSetEncoding = SymbolSetEncoding;
      exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
      exports.ExpertEncoding = ExpertEncoding;
      exports.getEncoding = getEncoding;

      /***/ }),
    /* 28 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = false;

      /***/ }),
    /* 29 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/ }),
    /* 30 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var IObject = __w_pdfjs_require__(37);
      var defined = __w_pdfjs_require__(38);
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/ }),
    /* 31 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(18);
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/ }),
    /* 32 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var cof = __w_pdfjs_require__(24);
      var TAG = __w_pdfjs_require__(4)("toStringTag");
      var ARG = cof(function () {
        return arguments;
      }()) == "Arguments";
      var tryGet = function tryGet(it, key) {
        try {
          return it[key];
        } catch (e) {}
      };
      module.exports = function (it) {
        var O, T, B;
        return it === undefined ? "Undefined" : it === null ? "Null" : typeof (T = tryGet(O = Object(it), TAG)) === "string" ? T : ARG ? cof(O) : (B = cof(O)) == "Object" && typeof O.callee === "function" ? "Arguments" : B;
      };

      /***/ }),
    /* 33 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ctx = __w_pdfjs_require__(13);
      var call = __w_pdfjs_require__(107);
      var isArrayIter = __w_pdfjs_require__(56);
      var anObject = __w_pdfjs_require__(9);
      var toLength = __w_pdfjs_require__(14);
      var getIterFn = __w_pdfjs_require__(60);
      var BREAK = {};
      var RETURN = {};
      var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR ? function () {
          return iterable;
        } : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn !== "function") throw TypeError(iterable + " is not iterable!");
        if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
          result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
          if (result === BREAK || result === RETURN) return result;
        } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
          result = call(iterator, f, step.value, entries);
          if (result === BREAK || result === RETURN) return result;
        }
      };
      _exports.BREAK = BREAK;
      _exports.RETURN = RETURN;

      /***/ }),
    /* 34 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Parser = exports.Linearization = exports.Lexer = undefined;

      var _stream = __w_pdfjs_require__(5);

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var _ccitt_stream = __w_pdfjs_require__(129);

      var _jbig2_stream = __w_pdfjs_require__(131);

      var MAX_LENGTH_TO_CACHE = 1000;
      var Parser = function ParserClosure() {
        function Parser(lexer, allowStreams, xref, recoveryMode) {
          this.lexer = lexer;
          this.allowStreams = allowStreams;
          this.xref = xref;
          this.recoveryMode = recoveryMode || false;
          this.imageCache = Object.create(null);
          this.refill();
        }
        Parser.prototype = {
          refill: function Parser_refill() {
            this.buf1 = this.lexer.getObj();
            this.buf2 = this.lexer.getObj();
          },
          shift: function Parser_shift() {
            if ((0, _primitives.isCmd)(this.buf2, "ID")) {
              this.buf1 = this.buf2;
              this.buf2 = null;
            } else {
              this.buf1 = this.buf2;
              this.buf2 = this.lexer.getObj();
            }
          },
          tryShift: function Parser_tryShift() {
            try {
              this.shift();
              return true;
            } catch (e) {
              if (e instanceof _util.MissingDataException) {
                throw e;
              }
              return false;
            }
          },
          getObj: function Parser_getObj(cipherTransform) {
            var buf1 = this.buf1;
            this.shift();
            if (buf1 instanceof _primitives.Cmd) {
              switch (buf1.cmd) {
                case "BI":
                  return this.makeInlineImage(cipherTransform);
                case "[":
                  var array = [];
                  while (!(0, _primitives.isCmd)(this.buf1, "]") && !(0, _primitives.isEOF)(this.buf1)) {
                    array.push(this.getObj(cipherTransform));
                  }
                  if ((0, _primitives.isEOF)(this.buf1)) {
                    if (!this.recoveryMode) {
                      throw new _util.FormatError("End of file inside array");
                    }
                    return array;
                  }
                  this.shift();
                  return array;
                case "<<":
                  var dict = new _primitives.Dict(this.xref);
                  while (!(0, _primitives.isCmd)(this.buf1, ">>") && !(0, _primitives.isEOF)(this.buf1)) {
                    if (!(0, _primitives.isName)(this.buf1)) {
                      (0, _util.info)("Malformed dictionary: key must be a name object");
                      this.shift();
                      continue;
                    }
                    var key = this.buf1.name;
                    this.shift();
                    if ((0, _primitives.isEOF)(this.buf1)) {
                      break;
                    }
                    dict.set(key, this.getObj(cipherTransform));
                  }
                  if ((0, _primitives.isEOF)(this.buf1)) {
                    if (!this.recoveryMode) {
                      throw new _util.FormatError("End of file inside dictionary");
                    }
                    return dict;
                  }
                  if ((0, _primitives.isCmd)(this.buf2, "stream")) {
                    return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
                  }
                  this.shift();
                  return dict;
                default:
                  return buf1;
              }
            }
            if (Number.isInteger(buf1)) {
              var num = buf1;
              if (Number.isInteger(this.buf1) && (0, _primitives.isCmd)(this.buf2, "R")) {
                var ref = new _primitives.Ref(num, this.buf1);
                this.shift();
                this.shift();
                return ref;
              }
              return num;
            }
            if ((0, _util.isString)(buf1)) {
              var str = buf1;
              if (cipherTransform) {
                str = cipherTransform.decryptString(str);
              }
              return str;
            }
            return buf1;
          },
          findDefaultInlineStreamEnd: function findDefaultInlineStreamEnd(stream) {
            var E = 0x45,
              I = 0x49,
              SPACE = 0x20,
              LF = 0xA,
              CR = 0xD;
            var n = 10,
              NUL = 0x0;
            var startPos = stream.pos,
              state = 0,
              ch = void 0,
              maybeEIPos = void 0;
            while ((ch = stream.getByte()) !== -1) {
              if (state === 0) {
                state = ch === E ? 1 : 0;
              } else if (state === 1) {
                state = ch === I ? 2 : 0;
              } else {
                (0, _util.assert)(state === 2);
                if (ch === SPACE || ch === LF || ch === CR) {
                  maybeEIPos = stream.pos;
                  var followingBytes = stream.peekBytes(n);
                  for (var i = 0, ii = followingBytes.length; i < ii; i++) {
                    ch = followingBytes[i];
                    if (ch === NUL && followingBytes[i + 1] !== NUL) {
                      continue;
                    }
                    if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7F)) {
                      state = 0;
                      break;
                    }
                  }
                  if (state === 2) {
                    break;
                  }
                } else {
                  state = 0;
                }
              }
            }
            if (ch === -1) {
              (0, _util.warn)("findDefaultInlineStreamEnd: " + "Reached the end of the stream without finding a valid EI marker");
              if (maybeEIPos) {
                (0, _util.warn)("... trying to recover by using the last \"EI\" occurrence.");
                stream.skip(-(stream.pos - maybeEIPos));
              }
            }
            return stream.pos - 4 - startPos;
          },

          findDCTDecodeInlineStreamEnd: function Parser_findDCTDecodeInlineStreamEnd(stream) {
            var startPos = stream.pos,
              foundEOI = false,
              b,
              markerLength,
              length;
            while ((b = stream.getByte()) !== -1) {
              if (b !== 0xFF) {
                continue;
              }
              switch (stream.getByte()) {
                case 0x00:
                  break;
                case 0xFF:
                  stream.skip(-1);
                  break;
                case 0xD9:
                  foundEOI = true;
                  break;
                case 0xC0:
                case 0xC1:
                case 0xC2:
                case 0xC3:
                case 0xC5:
                case 0xC6:
                case 0xC7:
                case 0xC9:
                case 0xCA:
                case 0xCB:
                case 0xCD:
                case 0xCE:
                case 0xCF:
                case 0xC4:
                case 0xCC:
                case 0xDA:
                case 0xDB:
                case 0xDC:
                case 0xDD:
                case 0xDE:
                case 0xDF:
                case 0xE0:
                case 0xE1:
                case 0xE2:
                case 0xE3:
                case 0xE4:
                case 0xE5:
                case 0xE6:
                case 0xE7:
                case 0xE8:
                case 0xE9:
                case 0xEA:
                case 0xEB:
                case 0xEC:
                case 0xED:
                case 0xEE:
                case 0xEF:
                case 0xFE:
                  markerLength = stream.getUint16();
                  if (markerLength > 2) {
                    stream.skip(markerLength - 2);
                  } else {
                    stream.skip(-2);
                  }
                  break;
              }
              if (foundEOI) {
                break;
              }
            }
            length = stream.pos - startPos;
            if (b === -1) {
              (0, _util.warn)("Inline DCTDecode image stream: " + "EOI marker not found, searching for /EI/ instead.");
              stream.skip(-length);
              return this.findDefaultInlineStreamEnd(stream);
            }
            this.inlineStreamSkipEI(stream);
            return length;
          },
          findASCII85DecodeInlineStreamEnd: function Parser_findASCII85DecodeInlineStreamEnd(stream) {
            var TILDE = 0x7E,
              GT = 0x3E;
            var startPos = stream.pos,
              ch,
              length;
            while ((ch = stream.getByte()) !== -1) {
              if (ch === TILDE && stream.peekByte() === GT) {
                stream.skip();
                break;
              }
            }
            length = stream.pos - startPos;
            if (ch === -1) {
              (0, _util.warn)("Inline ASCII85Decode image stream: " + "EOD marker not found, searching for /EI/ instead.");
              stream.skip(-length);
              return this.findDefaultInlineStreamEnd(stream);
            }
            this.inlineStreamSkipEI(stream);
            return length;
          },
          findASCIIHexDecodeInlineStreamEnd: function Parser_findASCIIHexDecodeInlineStreamEnd(stream) {
            var GT = 0x3E;
            var startPos = stream.pos,
              ch,
              length;
            while ((ch = stream.getByte()) !== -1) {
              if (ch === GT) {
                break;
              }
            }
            length = stream.pos - startPos;
            if (ch === -1) {
              (0, _util.warn)("Inline ASCIIHexDecode image stream: " + "EOD marker not found, searching for /EI/ instead.");
              stream.skip(-length);
              return this.findDefaultInlineStreamEnd(stream);
            }
            this.inlineStreamSkipEI(stream);
            return length;
          },
          inlineStreamSkipEI: function Parser_inlineStreamSkipEI(stream) {
            var E = 0x45,
              I = 0x49;
            var state = 0,
              ch;
            while ((ch = stream.getByte()) !== -1) {
              if (state === 0) {
                state = ch === E ? 1 : 0;
              } else if (state === 1) {
                state = ch === I ? 2 : 0;
              } else if (state === 2) {
                break;
              }
            }
          },
          makeInlineImage: function Parser_makeInlineImage(cipherTransform) {
            var lexer = this.lexer;
            var stream = lexer.stream;
            var dict = new _primitives.Dict(this.xref);
            while (!(0, _primitives.isCmd)(this.buf1, "ID") && !(0, _primitives.isEOF)(this.buf1)) {
              if (!(0, _primitives.isName)(this.buf1)) {
                throw new _util.FormatError("Dictionary key must be a name object");
              }
              var key = this.buf1.name;
              this.shift();
              if ((0, _primitives.isEOF)(this.buf1)) {
                break;
              }
              dict.set(key, this.getObj(cipherTransform));
            }
            var filter = dict.get("Filter", "F"),
              filterName;
            if ((0, _primitives.isName)(filter)) {
              filterName = filter.name;
            } else if (Array.isArray(filter)) {
              var filterZero = this.xref.fetchIfRef(filter[0]);
              if ((0, _primitives.isName)(filterZero)) {
                filterName = filterZero.name;
              }
            }
            var startPos = stream.pos,
              length,
              i,
              ii;
            if (filterName === "DCTDecode" || filterName === "DCT") {
              length = this.findDCTDecodeInlineStreamEnd(stream);
            } else if (filterName === "ASCII85Decode" || filterName === "A85") {
              length = this.findASCII85DecodeInlineStreamEnd(stream);
            } else if (filterName === "ASCIIHexDecode" || filterName === "AHx") {
              length = this.findASCIIHexDecodeInlineStreamEnd(stream);
            } else {
              length = this.findDefaultInlineStreamEnd(stream);
            }
            var imageStream = stream.makeSubStream(startPos, length, dict);
            var adler32;
            if (length < MAX_LENGTH_TO_CACHE) {
              var imageBytes = imageStream.getBytes();
              imageStream.reset();
              var a = 1;
              var b = 0;
              for (i = 0, ii = imageBytes.length; i < ii; ++i) {
                a += imageBytes[i] & 0xff;
                b += a;
              }
              adler32 = b % 65521 << 16 | a % 65521;
              var cacheEntry = this.imageCache[adler32];
              if (cacheEntry !== undefined) {
                this.buf2 = _primitives.Cmd.get("EI");
                this.shift();
                cacheEntry.reset();
                return cacheEntry;
              }
            }
            if (cipherTransform) {
              imageStream = cipherTransform.createStream(imageStream, length);
            }
            imageStream = this.filter(imageStream, dict, length);
            imageStream.dict = dict;
            if (adler32 !== undefined) {
              imageStream.cacheKey = "inline_" + length + "_" + adler32;
              this.imageCache[adler32] = imageStream;
            }
            this.buf2 = _primitives.Cmd.get("EI");
            this.shift();
            return imageStream;
          },
          makeStream: function Parser_makeStream(dict, cipherTransform) {
            var lexer = this.lexer;
            var stream = lexer.stream;
            lexer.skipToNextLine();
            var pos = stream.pos - 1;
            var length = dict.get("Length");
            if (!Number.isInteger(length)) {
              (0, _util.info)("Bad " + length + " attribute in stream");
              length = 0;
            }
            stream.pos = pos + length;
            lexer.nextChar();
            if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, "endstream")) {
              this.shift();
            } else {
              stream.pos = pos;
              var SCAN_BLOCK_SIZE = 2048;
              var ENDSTREAM_SIGNATURE_LENGTH = 9;
              var ENDSTREAM_SIGNATURE = [0x65, 0x6E, 0x64, 0x73, 0x74, 0x72, 0x65, 0x61, 0x6D];
              var skipped = 0,
                found = false,
                i,
                j;
              while (stream.pos < stream.end) {
                var scanBytes = stream.peekBytes(SCAN_BLOCK_SIZE);
                var scanLength = scanBytes.length - ENDSTREAM_SIGNATURE_LENGTH;
                if (scanLength <= 0) {
                  break;
                }
                found = false;
                i = 0;
                while (i < scanLength) {
                  j = 0;
                  while (j < ENDSTREAM_SIGNATURE_LENGTH && scanBytes[i + j] === ENDSTREAM_SIGNATURE[j]) {
                    j++;
                  }
                  if (j >= ENDSTREAM_SIGNATURE_LENGTH) {
                    found = true;
                    break;
                  }
                  i++;
                }
                if (found) {
                  skipped += i;
                  stream.pos += i;
                  break;
                }
                skipped += scanLength;
                stream.pos += scanLength;
              }
              if (!found) {
                throw new _util.FormatError("Missing endstream");
              }
              length = skipped;
              lexer.nextChar();
              this.shift();
              this.shift();
            }
            this.shift();
            stream = stream.makeSubStream(pos, length, dict);
            if (cipherTransform) {
              stream = cipherTransform.createStream(stream, length);
            }
            stream = this.filter(stream, dict, length);
            stream.dict = dict;
            return stream;
          },
          filter: function Parser_filter(stream, dict, length) {
            var filter = dict.get("Filter", "F");
            var params = dict.get("DecodeParms", "DP");
            if ((0, _primitives.isName)(filter)) {
              if (Array.isArray(params)) {
                (0, _util.warn)("/DecodeParms should not contain an Array, " + "when /Filter contains a Name.");
              }
              return this.makeFilter(stream, filter.name, length, params);
            }
            var maybeLength = length;
            if (Array.isArray(filter)) {
              var filterArray = filter;
              var paramsArray = params;
              for (var i = 0, ii = filterArray.length; i < ii; ++i) {
                filter = this.xref.fetchIfRef(filterArray[i]);
                if (!(0, _primitives.isName)(filter)) {
                  throw new _util.FormatError("Bad filter name: " + filter);
                }
                params = null;
                if (Array.isArray(paramsArray) && i in paramsArray) {
                  params = this.xref.fetchIfRef(paramsArray[i]);
                }
                stream = this.makeFilter(stream, filter.name, maybeLength, params);
                maybeLength = null;
              }
            }
            return stream;
          },
          makeFilter: function Parser_makeFilter(stream, name, maybeLength, params) {
            if (maybeLength === 0) {
              (0, _util.warn)("Empty \"" + name + "\" stream.");
              return new _stream.NullStream(stream);
            }
            try {
              var xrefStreamStats = this.xref.stats.streamTypes;
              if (name === "FlateDecode" || name === "Fl") {
                xrefStreamStats[_util.StreamType.FLATE] = true;
                if (params) {
                  return new _stream.PredictorStream(new _stream.FlateStream(stream, maybeLength), maybeLength, params);
                }
                return new _stream.FlateStream(stream, maybeLength);
              }
              if (name === "LZWDecode" || name === "LZW") {
                xrefStreamStats[_util.StreamType.LZW] = true;
                var earlyChange = 1;
                if (params) {
                  if (params.has("EarlyChange")) {
                    earlyChange = params.get("EarlyChange");
                  }
                  return new _stream.PredictorStream(new _stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
                }
                return new _stream.LZWStream(stream, maybeLength, earlyChange);
              }
              if (name === "DCTDecode" || name === "DCT") {
                xrefStreamStats[_util.StreamType.DCT] = true;
                return new _stream.JpegStream(stream, maybeLength, stream.dict, params);
              }
              if (name === "JPXDecode" || name === "JPX") {
                xrefStreamStats[_util.StreamType.JPX] = true;
                return new _stream.JpxStream(stream, maybeLength, stream.dict, params);
              }
              if (name === "ASCII85Decode" || name === "A85") {
                xrefStreamStats[_util.StreamType.A85] = true;
                return new _stream.Ascii85Stream(stream, maybeLength);
              }
              if (name === "ASCIIHexDecode" || name === "AHx") {
                xrefStreamStats[_util.StreamType.AHX] = true;
                return new _stream.AsciiHexStream(stream, maybeLength);
              }
              if (name === "CCITTFaxDecode" || name === "CCF") {
                xrefStreamStats[_util.StreamType.CCF] = true;
                return new _ccitt_stream.CCITTFaxStream(stream, maybeLength, params);
              }
              if (name === "RunLengthDecode" || name === "RL") {
                xrefStreamStats[_util.StreamType.RL] = true;
                return new _stream.RunLengthStream(stream, maybeLength);
              }
              if (name === "JBIG2Decode") {
                xrefStreamStats[_util.StreamType.JBIG] = true;
                return new _jbig2_stream.Jbig2Stream(stream, maybeLength, stream.dict, params);
              }
              (0, _util.warn)("filter \"" + name + "\" not supported yet");
              return stream;
            } catch (ex) {
              if (ex instanceof _util.MissingDataException) {
                throw ex;
              }
              (0, _util.warn)("Invalid stream: \"" + ex + "\"");
              return new _stream.NullStream(stream);
            }
          }
        };
        return Parser;
      }();
      var Lexer = function LexerClosure() {
        function Lexer(stream, knownCommands) {
          this.stream = stream;
          this.nextChar();
          this.strBuf = [];
          this.knownCommands = knownCommands;
        }
        var specialChars = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        function toHexDigit(ch) {
          if (ch >= 0x30 && ch <= 0x39) {
            return ch & 0x0F;
          }
          if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
            return (ch & 0x0F) + 9;
          }
          return -1;
        }
        Lexer.prototype = {
          nextChar: function Lexer_nextChar() {
            return this.currentChar = this.stream.getByte();
          },
          peekChar: function Lexer_peekChar() {
            return this.stream.peekByte();
          },
          getNumber: function Lexer_getNumber() {
            var ch = this.currentChar;
            var eNotation = false;
            var divideBy = 0;
            var sign = 1;
            if (ch === 0x2D) {
              sign = -1;
              ch = this.nextChar();
              if (ch === 0x2D) {
                ch = this.nextChar();
              }
            } else if (ch === 0x2B) {
              ch = this.nextChar();
            }
            if (ch === 0x2E) {
              divideBy = 10;
              ch = this.nextChar();
            }
            if (ch === 0x0A || ch === 0x0D) {
              do {
                ch = this.nextChar();
              } while (ch === 0x0A || ch === 0x0D);
            }
            if (ch < 0x30 || ch > 0x39) {
              throw new _util.FormatError("Invalid number: " + String.fromCharCode(ch) + " (charCode " + ch + ")");
            }
            var baseValue = ch - 0x30;
            var powerValue = 0;
            var powerValueSign = 1;
            while ((ch = this.nextChar()) >= 0) {
              if (0x30 <= ch && ch <= 0x39) {
                var currentDigit = ch - 0x30;
                if (eNotation) {
                  powerValue = powerValue * 10 + currentDigit;
                } else {
                  if (divideBy !== 0) {
                    divideBy *= 10;
                  }
                  baseValue = baseValue * 10 + currentDigit;
                }
              } else if (ch === 0x2E) {
                if (divideBy === 0) {
                  divideBy = 1;
                } else {
                  break;
                }
              } else if (ch === 0x2D) {
                (0, _util.warn)("Badly formatted number");
              } else if (ch === 0x45 || ch === 0x65) {
                ch = this.peekChar();
                if (ch === 0x2B || ch === 0x2D) {
                  powerValueSign = ch === 0x2D ? -1 : 1;
                  this.nextChar();
                } else if (ch < 0x30 || ch > 0x39) {
                  break;
                }
                eNotation = true;
              } else {
                break;
              }
            }
            if (divideBy !== 0) {
              baseValue /= divideBy;
            }
            if (eNotation) {
              baseValue *= Math.pow(10, powerValueSign * powerValue);
            }
            return sign * baseValue;
          },
          getString: function Lexer_getString() {
            var numParen = 1;
            var done = false;
            var strBuf = this.strBuf;
            strBuf.length = 0;
            var ch = this.nextChar();
            while (true) {
              var charBuffered = false;
              switch (ch | 0) {
                case -1:
                  (0, _util.warn)("Unterminated string");
                  done = true;
                  break;
                case 0x28:
                  ++numParen;
                  strBuf.push("(");
                  break;
                case 0x29:
                  if (--numParen === 0) {
                    this.nextChar();
                    done = true;
                  } else {
                    strBuf.push(")");
                  }
                  break;
                case 0x5C:
                  ch = this.nextChar();
                  switch (ch) {
                    case -1:
                      (0, _util.warn)("Unterminated string");
                      done = true;
                      break;
                    case 0x6E:
                      strBuf.push("\n");
                      break;
                    case 0x72:
                      strBuf.push("\r");
                      break;
                    case 0x74:
                      strBuf.push("\t");
                      break;
                    case 0x62:
                      strBuf.push("\b");
                      break;
                    case 0x66:
                      strBuf.push("\f");
                      break;
                    case 0x5C:
                    case 0x28:
                    case 0x29:
                      strBuf.push(String.fromCharCode(ch));
                      break;
                    case 0x30:
                    case 0x31:
                    case 0x32:
                    case 0x33:
                    case 0x34:
                    case 0x35:
                    case 0x36:
                    case 0x37:
                      var x = ch & 0x0F;
                      ch = this.nextChar();
                      charBuffered = true;
                      if (ch >= 0x30 && ch <= 0x37) {
                        x = (x << 3) + (ch & 0x0F);
                        ch = this.nextChar();
                        if (ch >= 0x30 && ch <= 0x37) {
                          charBuffered = false;
                          x = (x << 3) + (ch & 0x0F);
                        }
                      }
                      strBuf.push(String.fromCharCode(x));
                      break;
                    case 0x0D:
                      if (this.peekChar() === 0x0A) {
                        this.nextChar();
                      }
                      break;
                    case 0x0A:
                      break;
                    default:
                      strBuf.push(String.fromCharCode(ch));
                      break;
                  }
                  break;
                default:
                  strBuf.push(String.fromCharCode(ch));
                  break;
              }
              if (done) {
                break;
              }
              if (!charBuffered) {
                ch = this.nextChar();
              }
            }
            return strBuf.join("");
          },
          getName: function Lexer_getName() {
            var ch, previousCh;
            var strBuf = this.strBuf;
            strBuf.length = 0;
            while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
              if (ch === 0x23) {
                ch = this.nextChar();
                if (specialChars[ch]) {
                  (0, _util.warn)("Lexer_getName: " + "NUMBER SIGN (#) should be followed by a hexadecimal number.");
                  strBuf.push("#");
                  break;
                }
                var x = toHexDigit(ch);
                if (x !== -1) {
                  previousCh = ch;
                  ch = this.nextChar();
                  var x2 = toHexDigit(ch);
                  if (x2 === -1) {
                    (0, _util.warn)("Lexer_getName: Illegal digit (" + String.fromCharCode(ch) + ") in hexadecimal number.");
                    strBuf.push("#", String.fromCharCode(previousCh));
                    if (specialChars[ch]) {
                      break;
                    }
                    strBuf.push(String.fromCharCode(ch));
                    continue;
                  }
                  strBuf.push(String.fromCharCode(x << 4 | x2));
                } else {
                  strBuf.push("#", String.fromCharCode(ch));
                }
              } else {
                strBuf.push(String.fromCharCode(ch));
              }
            }
            if (strBuf.length > 127) {
              (0, _util.warn)("name token is longer than allowed by the spec: " + strBuf.length);
            }
            return _primitives.Name.get(strBuf.join(""));
          },
          getHexString: function Lexer_getHexString() {
            var strBuf = this.strBuf;
            strBuf.length = 0;
            var ch = this.currentChar;
            var isFirstHex = true;
            var firstDigit;
            var secondDigit;
            while (true) {
              if (ch < 0) {
                (0, _util.warn)("Unterminated hex string");
                break;
              } else if (ch === 0x3E) {
                this.nextChar();
                break;
              } else if (specialChars[ch] === 1) {
                ch = this.nextChar();
                continue;
              } else {
                if (isFirstHex) {
                  firstDigit = toHexDigit(ch);
                  if (firstDigit === -1) {
                    (0, _util.warn)("Ignoring invalid character \"" + ch + "\" in hex string");
                    ch = this.nextChar();
                    continue;
                  }
                } else {
                  secondDigit = toHexDigit(ch);
                  if (secondDigit === -1) {
                    (0, _util.warn)("Ignoring invalid character \"" + ch + "\" in hex string");
                    ch = this.nextChar();
                    continue;
                  }
                  strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
                }
                isFirstHex = !isFirstHex;
                ch = this.nextChar();
              }
            }
            return strBuf.join("");
          },
          getObj: function Lexer_getObj() {
            var comment = false;
            var ch = this.currentChar;
            while (true) {
              if (ch < 0) {
                return _primitives.EOF;
              }
              if (comment) {
                if (ch === 0x0A || ch === 0x0D) {
                  comment = false;
                }
              } else if (ch === 0x25) {
                comment = true;
              } else if (specialChars[ch] !== 1) {
                break;
              }
              ch = this.nextChar();
            }
            switch (ch | 0) {
              case 0x30:
              case 0x31:
              case 0x32:
              case 0x33:
              case 0x34:
              case 0x35:
              case 0x36:
              case 0x37:
              case 0x38:
              case 0x39:
              case 0x2B:
              case 0x2D:
              case 0x2E:
                return this.getNumber();
              case 0x28:
                return this.getString();
              case 0x2F:
                return this.getName();
              case 0x5B:
                this.nextChar();
                return _primitives.Cmd.get("[");
              case 0x5D:
                this.nextChar();
                return _primitives.Cmd.get("]");
              case 0x3C:
                ch = this.nextChar();
                if (ch === 0x3C) {
                  this.nextChar();
                  return _primitives.Cmd.get("<<");
                }
                return this.getHexString();
              case 0x3E:
                ch = this.nextChar();
                if (ch === 0x3E) {
                  this.nextChar();
                  return _primitives.Cmd.get(">>");
                }
                return _primitives.Cmd.get(">");
              case 0x7B:
                this.nextChar();
                return _primitives.Cmd.get("{");
              case 0x7D:
                this.nextChar();
                return _primitives.Cmd.get("}");
              case 0x29:
                this.nextChar();
                throw new _util.FormatError("Illegal character: " + ch);
            }
            var str = String.fromCharCode(ch);
            var knownCommands = this.knownCommands;
            var knownCommandFound = knownCommands && knownCommands[str] !== undefined;
            while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
              var possibleCommand = str + String.fromCharCode(ch);
              if (knownCommandFound && knownCommands[possibleCommand] === undefined) {
                break;
              }
              if (str.length === 128) {
                throw new _util.FormatError("Command token too long: " + str.length);
              }
              str = possibleCommand;
              knownCommandFound = knownCommands && knownCommands[str] !== undefined;
            }
            if (str === "true") {
              return true;
            }
            if (str === "false") {
              return false;
            }
            if (str === "null") {
              return null;
            }
            return _primitives.Cmd.get(str);
          },
          skipToNextLine: function Lexer_skipToNextLine() {
            var ch = this.currentChar;
            while (ch >= 0) {
              if (ch === 0x0D) {
                ch = this.nextChar();
                if (ch === 0x0A) {
                  this.nextChar();
                }
                break;
              } else if (ch === 0x0A) {
                this.nextChar();
                break;
              }
              ch = this.nextChar();
            }
          }
        };
        return Lexer;
      }();
      var Linearization = {
        create: function LinearizationCreate(stream) {
          function getInt(name, allowZeroValue) {
            var obj = linDict.get(name);
            if (Number.isInteger(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) {
              return obj;
            }
            throw new Error("The \"" + name + "\" parameter in the linearization " + "dictionary is invalid.");
          }
          function getHints() {
            var hints = linDict.get("H"),
              hintsLength,
              item;
            if (Array.isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
              for (var index = 0; index < hintsLength; index++) {
                if (!(Number.isInteger(item = hints[index]) && item > 0)) {
                  throw new Error("Hint (" + index + ") in the linearization dictionary is invalid.");
                }
              }
              return hints;
            }
            throw new Error("Hint array in the linearization dictionary is invalid.");
          }
          var parser = new Parser(new Lexer(stream), false, null);
          var obj1 = parser.getObj();
          var obj2 = parser.getObj();
          var obj3 = parser.getObj();
          var linDict = parser.getObj();
          var obj, length;
          if (!(Number.isInteger(obj1) && Number.isInteger(obj2) && (0, _primitives.isCmd)(obj3, "obj") && (0, _primitives.isDict)(linDict) && (0, _util.isNum)(obj = linDict.get("Linearized")) && obj > 0)) {
            return null;
          } else if ((length = getInt("L")) !== stream.length) {
            throw new Error("The \"L\" parameter in the linearization dictionary " + "does not equal the stream length.");
          }
          return {
            length: length,
            hints: getHints(),
            objectNumberFirst: getInt("O"),
            endFirst: getInt("E"),
            numPages: getInt("N"),
            mainXRefEntriesOffset: getInt("T"),
            pageFirst: linDict.has("P") ? getInt("P", true) : 0
          };
        }
      };
      exports.Lexer = Lexer;
      exports.Linearization = Linearization;
      exports.Parser = Parser;

      /***/ }),
    /* 35 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      var document = __w_pdfjs_require__(1).document;
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/ }),
    /* 36 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) === "function" && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) === "function" && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) === "function" && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/ }),
    /* 37 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var cof = __w_pdfjs_require__(24);
      module.exports = Object("z").propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == "String" ? it.split("") : Object(it);
      };

      /***/ }),
    /* 38 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/ }),
    /* 39 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var shared = __w_pdfjs_require__(54)("keys");
      var uid = __w_pdfjs_require__(17);
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/ }),
    /* 40 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

      /***/ }),
    /* 41 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $keys = __w_pdfjs_require__(52);
      var enumBugKeys = __w_pdfjs_require__(40);
      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };

      /***/ }),
    /* 42 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ctx = __w_pdfjs_require__(13);
      var IObject = __w_pdfjs_require__(37);
      var toObject = __w_pdfjs_require__(19);
      var toLength = __w_pdfjs_require__(14);
      var asc = __w_pdfjs_require__(91);
      module.exports = function (TYPE, $create) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        var create = $create || asc;
        return function ($this, callbackfn, that) {
          var O = toObject($this);
          var self = IObject(O);
          var f = ctx(callbackfn, that, 3);
          var length = toLength(self.length);
          var index = 0;
          var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
          var val, res;
          for (; length > index; index++) {
            if (NO_HOLES || index in self) {
              val = self[index];
              res = f(val, index, O);
              if (TYPE) {
                if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
                  case 3:
                    return true;
                  case 5:
                    return val;
                  case 6:
                    return index;
                  case 2:
                    result.push(val);
                } else if (IS_EVERY) return false;
              }
            }
          } return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
        };
      };

      /***/ }),
    /* 43 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(9);
      var aFunction = __w_pdfjs_require__(21);
      var SPECIES = __w_pdfjs_require__(4)("species");
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };

      /***/ }),
    /* 44 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ITERATOR = __w_pdfjs_require__(4)("iterator");
      var SAFE_CLOSING = false;
      try {
        var riter = [7][ITERATOR]();
        riter["return"] = function () {
          SAFE_CLOSING = true;
        };
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {}
      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return { done: safe = true };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {}
        return safe;
      };

      /***/ }),
    /* 45 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var aFunction = __w_pdfjs_require__(21);
      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }
      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };

      /***/ }),
    /* 46 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var META = __w_pdfjs_require__(17)("meta");
      var isObject = __w_pdfjs_require__(3);
      var has = __w_pdfjs_require__(10);
      var setDesc = __w_pdfjs_require__(15).f;
      var id = 0;
      var isExtensible = Object.isExtensible || function () {
        return true;
      };
      var FREEZE = !__w_pdfjs_require__(12)(function () {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function setMeta(it) {
        setDesc(it, META, {
          value: {
            i: "O" + ++id,
            w: {}
          }
        });
      };
      var fastKey = function fastKey(it, create) {
        if (!isObject(it)) return (typeof it === "undefined" ? "undefined" : _typeof(it)) == "symbol" ? it : (typeof it === "string" ? "S" : "P") + it;
        if (!has(it, META)) {
          if (!isExtensible(it)) return "F";
          if (!create) return "E";
          setMeta(it);
        }
        return it[META].i;
      };
      var getWeak = function getWeak(it, create) {
        if (!has(it, META)) {
          if (!isExtensible(it)) return true;
          if (!create) return false;
          setMeta(it);
        }
        return it[META].w;
      };
      var onFreeze = function onFreeze(it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };
      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      };

      /***/ }),
    /* 47 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var getLookupTableFactory = __w_pdfjs_require__(0).getLookupTableFactory;
      var getGlyphsUnicode = getLookupTableFactory(function (t) {
        t["A"] = 0x0041;
        t["AE"] = 0x00C6;
        t["AEacute"] = 0x01FC;
        t["AEmacron"] = 0x01E2;
        t["AEsmall"] = 0xF7E6;
        t["Aacute"] = 0x00C1;
        t["Aacutesmall"] = 0xF7E1;
        t["Abreve"] = 0x0102;
        t["Abreveacute"] = 0x1EAE;
        t["Abrevecyrillic"] = 0x04D0;
        t["Abrevedotbelow"] = 0x1EB6;
        t["Abrevegrave"] = 0x1EB0;
        t["Abrevehookabove"] = 0x1EB2;
        t["Abrevetilde"] = 0x1EB4;
        t["Acaron"] = 0x01CD;
        t["Acircle"] = 0x24B6;
        t["Acircumflex"] = 0x00C2;
        t["Acircumflexacute"] = 0x1EA4;
        t["Acircumflexdotbelow"] = 0x1EAC;
        t["Acircumflexgrave"] = 0x1EA6;
        t["Acircumflexhookabove"] = 0x1EA8;
        t["Acircumflexsmall"] = 0xF7E2;
        t["Acircumflextilde"] = 0x1EAA;
        t["Acute"] = 0xF6C9;
        t["Acutesmall"] = 0xF7B4;
        t["Acyrillic"] = 0x0410;
        t["Adblgrave"] = 0x0200;
        t["Adieresis"] = 0x00C4;
        t["Adieresiscyrillic"] = 0x04D2;
        t["Adieresismacron"] = 0x01DE;
        t["Adieresissmall"] = 0xF7E4;
        t["Adotbelow"] = 0x1EA0;
        t["Adotmacron"] = 0x01E0;
        t["Agrave"] = 0x00C0;
        t["Agravesmall"] = 0xF7E0;
        t["Ahookabove"] = 0x1EA2;
        t["Aiecyrillic"] = 0x04D4;
        t["Ainvertedbreve"] = 0x0202;
        t["Alpha"] = 0x0391;
        t["Alphatonos"] = 0x0386;
        t["Amacron"] = 0x0100;
        t["Amonospace"] = 0xFF21;
        t["Aogonek"] = 0x0104;
        t["Aring"] = 0x00C5;
        t["Aringacute"] = 0x01FA;
        t["Aringbelow"] = 0x1E00;
        t["Aringsmall"] = 0xF7E5;
        t["Asmall"] = 0xF761;
        t["Atilde"] = 0x00C3;
        t["Atildesmall"] = 0xF7E3;
        t["Aybarmenian"] = 0x0531;
        t["B"] = 0x0042;
        t["Bcircle"] = 0x24B7;
        t["Bdotaccent"] = 0x1E02;
        t["Bdotbelow"] = 0x1E04;
        t["Becyrillic"] = 0x0411;
        t["Benarmenian"] = 0x0532;
        t["Beta"] = 0x0392;
        t["Bhook"] = 0x0181;
        t["Blinebelow"] = 0x1E06;
        t["Bmonospace"] = 0xFF22;
        t["Brevesmall"] = 0xF6F4;
        t["Bsmall"] = 0xF762;
        t["Btopbar"] = 0x0182;
        t["C"] = 0x0043;
        t["Caarmenian"] = 0x053E;
        t["Cacute"] = 0x0106;
        t["Caron"] = 0xF6CA;
        t["Caronsmall"] = 0xF6F5;
        t["Ccaron"] = 0x010C;
        t["Ccedilla"] = 0x00C7;
        t["Ccedillaacute"] = 0x1E08;
        t["Ccedillasmall"] = 0xF7E7;
        t["Ccircle"] = 0x24B8;
        t["Ccircumflex"] = 0x0108;
        t["Cdot"] = 0x010A;
        t["Cdotaccent"] = 0x010A;
        t["Cedillasmall"] = 0xF7B8;
        t["Chaarmenian"] = 0x0549;
        t["Cheabkhasiancyrillic"] = 0x04BC;
        t["Checyrillic"] = 0x0427;
        t["Chedescenderabkhasiancyrillic"] = 0x04BE;
        t["Chedescendercyrillic"] = 0x04B6;
        t["Chedieresiscyrillic"] = 0x04F4;
        t["Cheharmenian"] = 0x0543;
        t["Chekhakassiancyrillic"] = 0x04CB;
        t["Cheverticalstrokecyrillic"] = 0x04B8;
        t["Chi"] = 0x03A7;
        t["Chook"] = 0x0187;
        t["Circumflexsmall"] = 0xF6F6;
        t["Cmonospace"] = 0xFF23;
        t["Coarmenian"] = 0x0551;
        t["Csmall"] = 0xF763;
        t["D"] = 0x0044;
        t["DZ"] = 0x01F1;
        t["DZcaron"] = 0x01C4;
        t["Daarmenian"] = 0x0534;
        t["Dafrican"] = 0x0189;
        t["Dcaron"] = 0x010E;
        t["Dcedilla"] = 0x1E10;
        t["Dcircle"] = 0x24B9;
        t["Dcircumflexbelow"] = 0x1E12;
        t["Dcroat"] = 0x0110;
        t["Ddotaccent"] = 0x1E0A;
        t["Ddotbelow"] = 0x1E0C;
        t["Decyrillic"] = 0x0414;
        t["Deicoptic"] = 0x03EE;
        t["Delta"] = 0x2206;
        t["Deltagreek"] = 0x0394;
        t["Dhook"] = 0x018A;
        t["Dieresis"] = 0xF6CB;
        t["DieresisAcute"] = 0xF6CC;
        t["DieresisGrave"] = 0xF6CD;
        t["Dieresissmall"] = 0xF7A8;
        t["Digammagreek"] = 0x03DC;
        t["Djecyrillic"] = 0x0402;
        t["Dlinebelow"] = 0x1E0E;
        t["Dmonospace"] = 0xFF24;
        t["Dotaccentsmall"] = 0xF6F7;
        t["Dslash"] = 0x0110;
        t["Dsmall"] = 0xF764;
        t["Dtopbar"] = 0x018B;
        t["Dz"] = 0x01F2;
        t["Dzcaron"] = 0x01C5;
        t["Dzeabkhasiancyrillic"] = 0x04E0;
        t["Dzecyrillic"] = 0x0405;
        t["Dzhecyrillic"] = 0x040F;
        t["E"] = 0x0045;
        t["Eacute"] = 0x00C9;
        t["Eacutesmall"] = 0xF7E9;
        t["Ebreve"] = 0x0114;
        t["Ecaron"] = 0x011A;
        t["Ecedillabreve"] = 0x1E1C;
        t["Echarmenian"] = 0x0535;
        t["Ecircle"] = 0x24BA;
        t["Ecircumflex"] = 0x00CA;
        t["Ecircumflexacute"] = 0x1EBE;
        t["Ecircumflexbelow"] = 0x1E18;
        t["Ecircumflexdotbelow"] = 0x1EC6;
        t["Ecircumflexgrave"] = 0x1EC0;
        t["Ecircumflexhookabove"] = 0x1EC2;
        t["Ecircumflexsmall"] = 0xF7EA;
        t["Ecircumflextilde"] = 0x1EC4;
        t["Ecyrillic"] = 0x0404;
        t["Edblgrave"] = 0x0204;
        t["Edieresis"] = 0x00CB;
        t["Edieresissmall"] = 0xF7EB;
        t["Edot"] = 0x0116;
        t["Edotaccent"] = 0x0116;
        t["Edotbelow"] = 0x1EB8;
        t["Efcyrillic"] = 0x0424;
        t["Egrave"] = 0x00C8;
        t["Egravesmall"] = 0xF7E8;
        t["Eharmenian"] = 0x0537;
        t["Ehookabove"] = 0x1EBA;
        t["Eightroman"] = 0x2167;
        t["Einvertedbreve"] = 0x0206;
        t["Eiotifiedcyrillic"] = 0x0464;
        t["Elcyrillic"] = 0x041B;
        t["Elevenroman"] = 0x216A;
        t["Emacron"] = 0x0112;
        t["Emacronacute"] = 0x1E16;
        t["Emacrongrave"] = 0x1E14;
        t["Emcyrillic"] = 0x041C;
        t["Emonospace"] = 0xFF25;
        t["Encyrillic"] = 0x041D;
        t["Endescendercyrillic"] = 0x04A2;
        t["Eng"] = 0x014A;
        t["Enghecyrillic"] = 0x04A4;
        t["Enhookcyrillic"] = 0x04C7;
        t["Eogonek"] = 0x0118;
        t["Eopen"] = 0x0190;
        t["Epsilon"] = 0x0395;
        t["Epsilontonos"] = 0x0388;
        t["Ercyrillic"] = 0x0420;
        t["Ereversed"] = 0x018E;
        t["Ereversedcyrillic"] = 0x042D;
        t["Escyrillic"] = 0x0421;
        t["Esdescendercyrillic"] = 0x04AA;
        t["Esh"] = 0x01A9;
        t["Esmall"] = 0xF765;
        t["Eta"] = 0x0397;
        t["Etarmenian"] = 0x0538;
        t["Etatonos"] = 0x0389;
        t["Eth"] = 0x00D0;
        t["Ethsmall"] = 0xF7F0;
        t["Etilde"] = 0x1EBC;
        t["Etildebelow"] = 0x1E1A;
        t["Euro"] = 0x20AC;
        t["Ezh"] = 0x01B7;
        t["Ezhcaron"] = 0x01EE;
        t["Ezhreversed"] = 0x01B8;
        t["F"] = 0x0046;
        t["Fcircle"] = 0x24BB;
        t["Fdotaccent"] = 0x1E1E;
        t["Feharmenian"] = 0x0556;
        t["Feicoptic"] = 0x03E4;
        t["Fhook"] = 0x0191;
        t["Fitacyrillic"] = 0x0472;
        t["Fiveroman"] = 0x2164;
        t["Fmonospace"] = 0xFF26;
        t["Fourroman"] = 0x2163;
        t["Fsmall"] = 0xF766;
        t["G"] = 0x0047;
        t["GBsquare"] = 0x3387;
        t["Gacute"] = 0x01F4;
        t["Gamma"] = 0x0393;
        t["Gammaafrican"] = 0x0194;
        t["Gangiacoptic"] = 0x03EA;
        t["Gbreve"] = 0x011E;
        t["Gcaron"] = 0x01E6;
        t["Gcedilla"] = 0x0122;
        t["Gcircle"] = 0x24BC;
        t["Gcircumflex"] = 0x011C;
        t["Gcommaaccent"] = 0x0122;
        t["Gdot"] = 0x0120;
        t["Gdotaccent"] = 0x0120;
        t["Gecyrillic"] = 0x0413;
        t["Ghadarmenian"] = 0x0542;
        t["Ghemiddlehookcyrillic"] = 0x0494;
        t["Ghestrokecyrillic"] = 0x0492;
        t["Gheupturncyrillic"] = 0x0490;
        t["Ghook"] = 0x0193;
        t["Gimarmenian"] = 0x0533;
        t["Gjecyrillic"] = 0x0403;
        t["Gmacron"] = 0x1E20;
        t["Gmonospace"] = 0xFF27;
        t["Grave"] = 0xF6CE;
        t["Gravesmall"] = 0xF760;
        t["Gsmall"] = 0xF767;
        t["Gsmallhook"] = 0x029B;
        t["Gstroke"] = 0x01E4;
        t["H"] = 0x0048;
        t["H18533"] = 0x25CF;
        t["H18543"] = 0x25AA;
        t["H18551"] = 0x25AB;
        t["H22073"] = 0x25A1;
        t["HPsquare"] = 0x33CB;
        t["Haabkhasiancyrillic"] = 0x04A8;
        t["Hadescendercyrillic"] = 0x04B2;
        t["Hardsigncyrillic"] = 0x042A;
        t["Hbar"] = 0x0126;
        t["Hbrevebelow"] = 0x1E2A;
        t["Hcedilla"] = 0x1E28;
        t["Hcircle"] = 0x24BD;
        t["Hcircumflex"] = 0x0124;
        t["Hdieresis"] = 0x1E26;
        t["Hdotaccent"] = 0x1E22;
        t["Hdotbelow"] = 0x1E24;
        t["Hmonospace"] = 0xFF28;
        t["Hoarmenian"] = 0x0540;
        t["Horicoptic"] = 0x03E8;
        t["Hsmall"] = 0xF768;
        t["Hungarumlaut"] = 0xF6CF;
        t["Hungarumlautsmall"] = 0xF6F8;
        t["Hzsquare"] = 0x3390;
        t["I"] = 0x0049;
        t["IAcyrillic"] = 0x042F;
        t["IJ"] = 0x0132;
        t["IUcyrillic"] = 0x042E;
        t["Iacute"] = 0x00CD;
        t["Iacutesmall"] = 0xF7ED;
        t["Ibreve"] = 0x012C;
        t["Icaron"] = 0x01CF;
        t["Icircle"] = 0x24BE;
        t["Icircumflex"] = 0x00CE;
        t["Icircumflexsmall"] = 0xF7EE;
        t["Icyrillic"] = 0x0406;
        t["Idblgrave"] = 0x0208;
        t["Idieresis"] = 0x00CF;
        t["Idieresisacute"] = 0x1E2E;
        t["Idieresiscyrillic"] = 0x04E4;
        t["Idieresissmall"] = 0xF7EF;
        t["Idot"] = 0x0130;
        t["Idotaccent"] = 0x0130;
        t["Idotbelow"] = 0x1ECA;
        t["Iebrevecyrillic"] = 0x04D6;
        t["Iecyrillic"] = 0x0415;
        t["Ifraktur"] = 0x2111;
        t["Igrave"] = 0x00CC;
        t["Igravesmall"] = 0xF7EC;
        t["Ihookabove"] = 0x1EC8;
        t["Iicyrillic"] = 0x0418;
        t["Iinvertedbreve"] = 0x020A;
        t["Iishortcyrillic"] = 0x0419;
        t["Imacron"] = 0x012A;
        t["Imacroncyrillic"] = 0x04E2;
        t["Imonospace"] = 0xFF29;
        t["Iniarmenian"] = 0x053B;
        t["Iocyrillic"] = 0x0401;
        t["Iogonek"] = 0x012E;
        t["Iota"] = 0x0399;
        t["Iotaafrican"] = 0x0196;
        t["Iotadieresis"] = 0x03AA;
        t["Iotatonos"] = 0x038A;
        t["Ismall"] = 0xF769;
        t["Istroke"] = 0x0197;
        t["Itilde"] = 0x0128;
        t["Itildebelow"] = 0x1E2C;
        t["Izhitsacyrillic"] = 0x0474;
        t["Izhitsadblgravecyrillic"] = 0x0476;
        t["J"] = 0x004A;
        t["Jaarmenian"] = 0x0541;
        t["Jcircle"] = 0x24BF;
        t["Jcircumflex"] = 0x0134;
        t["Jecyrillic"] = 0x0408;
        t["Jheharmenian"] = 0x054B;
        t["Jmonospace"] = 0xFF2A;
        t["Jsmall"] = 0xF76A;
        t["K"] = 0x004B;
        t["KBsquare"] = 0x3385;
        t["KKsquare"] = 0x33CD;
        t["Kabashkircyrillic"] = 0x04A0;
        t["Kacute"] = 0x1E30;
        t["Kacyrillic"] = 0x041A;
        t["Kadescendercyrillic"] = 0x049A;
        t["Kahookcyrillic"] = 0x04C3;
        t["Kappa"] = 0x039A;
        t["Kastrokecyrillic"] = 0x049E;
        t["Kaverticalstrokecyrillic"] = 0x049C;
        t["Kcaron"] = 0x01E8;
        t["Kcedilla"] = 0x0136;
        t["Kcircle"] = 0x24C0;
        t["Kcommaaccent"] = 0x0136;
        t["Kdotbelow"] = 0x1E32;
        t["Keharmenian"] = 0x0554;
        t["Kenarmenian"] = 0x053F;
        t["Khacyrillic"] = 0x0425;
        t["Kheicoptic"] = 0x03E6;
        t["Khook"] = 0x0198;
        t["Kjecyrillic"] = 0x040C;
        t["Klinebelow"] = 0x1E34;
        t["Kmonospace"] = 0xFF2B;
        t["Koppacyrillic"] = 0x0480;
        t["Koppagreek"] = 0x03DE;
        t["Ksicyrillic"] = 0x046E;
        t["Ksmall"] = 0xF76B;
        t["L"] = 0x004C;
        t["LJ"] = 0x01C7;
        t["LL"] = 0xF6BF;
        t["Lacute"] = 0x0139;
        t["Lambda"] = 0x039B;
        t["Lcaron"] = 0x013D;
        t["Lcedilla"] = 0x013B;
        t["Lcircle"] = 0x24C1;
        t["Lcircumflexbelow"] = 0x1E3C;
        t["Lcommaaccent"] = 0x013B;
        t["Ldot"] = 0x013F;
        t["Ldotaccent"] = 0x013F;
        t["Ldotbelow"] = 0x1E36;
        t["Ldotbelowmacron"] = 0x1E38;
        t["Liwnarmenian"] = 0x053C;
        t["Lj"] = 0x01C8;
        t["Ljecyrillic"] = 0x0409;
        t["Llinebelow"] = 0x1E3A;
        t["Lmonospace"] = 0xFF2C;
        t["Lslash"] = 0x0141;
        t["Lslashsmall"] = 0xF6F9;
        t["Lsmall"] = 0xF76C;
        t["M"] = 0x004D;
        t["MBsquare"] = 0x3386;
        t["Macron"] = 0xF6D0;
        t["Macronsmall"] = 0xF7AF;
        t["Macute"] = 0x1E3E;
        t["Mcircle"] = 0x24C2;
        t["Mdotaccent"] = 0x1E40;
        t["Mdotbelow"] = 0x1E42;
        t["Menarmenian"] = 0x0544;
        t["Mmonospace"] = 0xFF2D;
        t["Msmall"] = 0xF76D;
        t["Mturned"] = 0x019C;
        t["Mu"] = 0x039C;
        t["N"] = 0x004E;
        t["NJ"] = 0x01CA;
        t["Nacute"] = 0x0143;
        t["Ncaron"] = 0x0147;
        t["Ncedilla"] = 0x0145;
        t["Ncircle"] = 0x24C3;
        t["Ncircumflexbelow"] = 0x1E4A;
        t["Ncommaaccent"] = 0x0145;
        t["Ndotaccent"] = 0x1E44;
        t["Ndotbelow"] = 0x1E46;
        t["Nhookleft"] = 0x019D;
        t["Nineroman"] = 0x2168;
        t["Nj"] = 0x01CB;
        t["Njecyrillic"] = 0x040A;
        t["Nlinebelow"] = 0x1E48;
        t["Nmonospace"] = 0xFF2E;
        t["Nowarmenian"] = 0x0546;
        t["Nsmall"] = 0xF76E;
        t["Ntilde"] = 0x00D1;
        t["Ntildesmall"] = 0xF7F1;
        t["Nu"] = 0x039D;
        t["O"] = 0x004F;
        t["OE"] = 0x0152;
        t["OEsmall"] = 0xF6FA;
        t["Oacute"] = 0x00D3;
        t["Oacutesmall"] = 0xF7F3;
        t["Obarredcyrillic"] = 0x04E8;
        t["Obarreddieresiscyrillic"] = 0x04EA;
        t["Obreve"] = 0x014E;
        t["Ocaron"] = 0x01D1;
        t["Ocenteredtilde"] = 0x019F;
        t["Ocircle"] = 0x24C4;
        t["Ocircumflex"] = 0x00D4;
        t["Ocircumflexacute"] = 0x1ED0;
        t["Ocircumflexdotbelow"] = 0x1ED8;
        t["Ocircumflexgrave"] = 0x1ED2;
        t["Ocircumflexhookabove"] = 0x1ED4;
        t["Ocircumflexsmall"] = 0xF7F4;
        t["Ocircumflextilde"] = 0x1ED6;
        t["Ocyrillic"] = 0x041E;
        t["Odblacute"] = 0x0150;
        t["Odblgrave"] = 0x020C;
        t["Odieresis"] = 0x00D6;
        t["Odieresiscyrillic"] = 0x04E6;
        t["Odieresissmall"] = 0xF7F6;
        t["Odotbelow"] = 0x1ECC;
        t["Ogoneksmall"] = 0xF6FB;
        t["Ograve"] = 0x00D2;
        t["Ogravesmall"] = 0xF7F2;
        t["Oharmenian"] = 0x0555;
        t["Ohm"] = 0x2126;
        t["Ohookabove"] = 0x1ECE;
        t["Ohorn"] = 0x01A0;
        t["Ohornacute"] = 0x1EDA;
        t["Ohorndotbelow"] = 0x1EE2;
        t["Ohorngrave"] = 0x1EDC;
        t["Ohornhookabove"] = 0x1EDE;
        t["Ohorntilde"] = 0x1EE0;
        t["Ohungarumlaut"] = 0x0150;
        t["Oi"] = 0x01A2;
        t["Oinvertedbreve"] = 0x020E;
        t["Omacron"] = 0x014C;
        t["Omacronacute"] = 0x1E52;
        t["Omacrongrave"] = 0x1E50;
        t["Omega"] = 0x2126;
        t["Omegacyrillic"] = 0x0460;
        t["Omegagreek"] = 0x03A9;
        t["Omegaroundcyrillic"] = 0x047A;
        t["Omegatitlocyrillic"] = 0x047C;
        t["Omegatonos"] = 0x038F;
        t["Omicron"] = 0x039F;
        t["Omicrontonos"] = 0x038C;
        t["Omonospace"] = 0xFF2F;
        t["Oneroman"] = 0x2160;
        t["Oogonek"] = 0x01EA;
        t["Oogonekmacron"] = 0x01EC;
        t["Oopen"] = 0x0186;
        t["Oslash"] = 0x00D8;
        t["Oslashacute"] = 0x01FE;
        t["Oslashsmall"] = 0xF7F8;
        t["Osmall"] = 0xF76F;
        t["Ostrokeacute"] = 0x01FE;
        t["Otcyrillic"] = 0x047E;
        t["Otilde"] = 0x00D5;
        t["Otildeacute"] = 0x1E4C;
        t["Otildedieresis"] = 0x1E4E;
        t["Otildesmall"] = 0xF7F5;
        t["P"] = 0x0050;
        t["Pacute"] = 0x1E54;
        t["Pcircle"] = 0x24C5;
        t["Pdotaccent"] = 0x1E56;
        t["Pecyrillic"] = 0x041F;
        t["Peharmenian"] = 0x054A;
        t["Pemiddlehookcyrillic"] = 0x04A6;
        t["Phi"] = 0x03A6;
        t["Phook"] = 0x01A4;
        t["Pi"] = 0x03A0;
        t["Piwrarmenian"] = 0x0553;
        t["Pmonospace"] = 0xFF30;
        t["Psi"] = 0x03A8;
        t["Psicyrillic"] = 0x0470;
        t["Psmall"] = 0xF770;
        t["Q"] = 0x0051;
        t["Qcircle"] = 0x24C6;
        t["Qmonospace"] = 0xFF31;
        t["Qsmall"] = 0xF771;
        t["R"] = 0x0052;
        t["Raarmenian"] = 0x054C;
        t["Racute"] = 0x0154;
        t["Rcaron"] = 0x0158;
        t["Rcedilla"] = 0x0156;
        t["Rcircle"] = 0x24C7;
        t["Rcommaaccent"] = 0x0156;
        t["Rdblgrave"] = 0x0210;
        t["Rdotaccent"] = 0x1E58;
        t["Rdotbelow"] = 0x1E5A;
        t["Rdotbelowmacron"] = 0x1E5C;
        t["Reharmenian"] = 0x0550;
        t["Rfraktur"] = 0x211C;
        t["Rho"] = 0x03A1;
        t["Ringsmall"] = 0xF6FC;
        t["Rinvertedbreve"] = 0x0212;
        t["Rlinebelow"] = 0x1E5E;
        t["Rmonospace"] = 0xFF32;
        t["Rsmall"] = 0xF772;
        t["Rsmallinverted"] = 0x0281;
        t["Rsmallinvertedsuperior"] = 0x02B6;
        t["S"] = 0x0053;
        t["SF010000"] = 0x250C;
        t["SF020000"] = 0x2514;
        t["SF030000"] = 0x2510;
        t["SF040000"] = 0x2518;
        t["SF050000"] = 0x253C;
        t["SF060000"] = 0x252C;
        t["SF070000"] = 0x2534;
        t["SF080000"] = 0x251C;
        t["SF090000"] = 0x2524;
        t["SF100000"] = 0x2500;
        t["SF110000"] = 0x2502;
        t["SF190000"] = 0x2561;
        t["SF200000"] = 0x2562;
        t["SF210000"] = 0x2556;
        t["SF220000"] = 0x2555;
        t["SF230000"] = 0x2563;
        t["SF240000"] = 0x2551;
        t["SF250000"] = 0x2557;
        t["SF260000"] = 0x255D;
        t["SF270000"] = 0x255C;
        t["SF280000"] = 0x255B;
        t["SF360000"] = 0x255E;
        t["SF370000"] = 0x255F;
        t["SF380000"] = 0x255A;
        t["SF390000"] = 0x2554;
        t["SF400000"] = 0x2569;
        t["SF410000"] = 0x2566;
        t["SF420000"] = 0x2560;
        t["SF430000"] = 0x2550;
        t["SF440000"] = 0x256C;
        t["SF450000"] = 0x2567;
        t["SF460000"] = 0x2568;
        t["SF470000"] = 0x2564;
        t["SF480000"] = 0x2565;
        t["SF490000"] = 0x2559;
        t["SF500000"] = 0x2558;
        t["SF510000"] = 0x2552;
        t["SF520000"] = 0x2553;
        t["SF530000"] = 0x256B;
        t["SF540000"] = 0x256A;
        t["Sacute"] = 0x015A;
        t["Sacutedotaccent"] = 0x1E64;
        t["Sampigreek"] = 0x03E0;
        t["Scaron"] = 0x0160;
        t["Scarondotaccent"] = 0x1E66;
        t["Scaronsmall"] = 0xF6FD;
        t["Scedilla"] = 0x015E;
        t["Schwa"] = 0x018F;
        t["Schwacyrillic"] = 0x04D8;
        t["Schwadieresiscyrillic"] = 0x04DA;
        t["Scircle"] = 0x24C8;
        t["Scircumflex"] = 0x015C;
        t["Scommaaccent"] = 0x0218;
        t["Sdotaccent"] = 0x1E60;
        t["Sdotbelow"] = 0x1E62;
        t["Sdotbelowdotaccent"] = 0x1E68;
        t["Seharmenian"] = 0x054D;
        t["Sevenroman"] = 0x2166;
        t["Shaarmenian"] = 0x0547;
        t["Shacyrillic"] = 0x0428;
        t["Shchacyrillic"] = 0x0429;
        t["Sheicoptic"] = 0x03E2;
        t["Shhacyrillic"] = 0x04BA;
        t["Shimacoptic"] = 0x03EC;
        t["Sigma"] = 0x03A3;
        t["Sixroman"] = 0x2165;
        t["Smonospace"] = 0xFF33;
        t["Softsigncyrillic"] = 0x042C;
        t["Ssmall"] = 0xF773;
        t["Stigmagreek"] = 0x03DA;
        t["T"] = 0x0054;
        t["Tau"] = 0x03A4;
        t["Tbar"] = 0x0166;
        t["Tcaron"] = 0x0164;
        t["Tcedilla"] = 0x0162;
        t["Tcircle"] = 0x24C9;
        t["Tcircumflexbelow"] = 0x1E70;
        t["Tcommaaccent"] = 0x0162;
        t["Tdotaccent"] = 0x1E6A;
        t["Tdotbelow"] = 0x1E6C;
        t["Tecyrillic"] = 0x0422;
        t["Tedescendercyrillic"] = 0x04AC;
        t["Tenroman"] = 0x2169;
        t["Tetsecyrillic"] = 0x04B4;
        t["Theta"] = 0x0398;
        t["Thook"] = 0x01AC;
        t["Thorn"] = 0x00DE;
        t["Thornsmall"] = 0xF7FE;
        t["Threeroman"] = 0x2162;
        t["Tildesmall"] = 0xF6FE;
        t["Tiwnarmenian"] = 0x054F;
        t["Tlinebelow"] = 0x1E6E;
        t["Tmonospace"] = 0xFF34;
        t["Toarmenian"] = 0x0539;
        t["Tonefive"] = 0x01BC;
        t["Tonesix"] = 0x0184;
        t["Tonetwo"] = 0x01A7;
        t["Tretroflexhook"] = 0x01AE;
        t["Tsecyrillic"] = 0x0426;
        t["Tshecyrillic"] = 0x040B;
        t["Tsmall"] = 0xF774;
        t["Twelveroman"] = 0x216B;
        t["Tworoman"] = 0x2161;
        t["U"] = 0x0055;
        t["Uacute"] = 0x00DA;
        t["Uacutesmall"] = 0xF7FA;
        t["Ubreve"] = 0x016C;
        t["Ucaron"] = 0x01D3;
        t["Ucircle"] = 0x24CA;
        t["Ucircumflex"] = 0x00DB;
        t["Ucircumflexbelow"] = 0x1E76;
        t["Ucircumflexsmall"] = 0xF7FB;
        t["Ucyrillic"] = 0x0423;
        t["Udblacute"] = 0x0170;
        t["Udblgrave"] = 0x0214;
        t["Udieresis"] = 0x00DC;
        t["Udieresisacute"] = 0x01D7;
        t["Udieresisbelow"] = 0x1E72;
        t["Udieresiscaron"] = 0x01D9;
        t["Udieresiscyrillic"] = 0x04F0;
        t["Udieresisgrave"] = 0x01DB;
        t["Udieresismacron"] = 0x01D5;
        t["Udieresissmall"] = 0xF7FC;
        t["Udotbelow"] = 0x1EE4;
        t["Ugrave"] = 0x00D9;
        t["Ugravesmall"] = 0xF7F9;
        t["Uhookabove"] = 0x1EE6;
        t["Uhorn"] = 0x01AF;
        t["Uhornacute"] = 0x1EE8;
        t["Uhorndotbelow"] = 0x1EF0;
        t["Uhorngrave"] = 0x1EEA;
        t["Uhornhookabove"] = 0x1EEC;
        t["Uhorntilde"] = 0x1EEE;
        t["Uhungarumlaut"] = 0x0170;
        t["Uhungarumlautcyrillic"] = 0x04F2;
        t["Uinvertedbreve"] = 0x0216;
        t["Ukcyrillic"] = 0x0478;
        t["Umacron"] = 0x016A;
        t["Umacroncyrillic"] = 0x04EE;
        t["Umacrondieresis"] = 0x1E7A;
        t["Umonospace"] = 0xFF35;
        t["Uogonek"] = 0x0172;
        t["Upsilon"] = 0x03A5;
        t["Upsilon1"] = 0x03D2;
        t["Upsilonacutehooksymbolgreek"] = 0x03D3;
        t["Upsilonafrican"] = 0x01B1;
        t["Upsilondieresis"] = 0x03AB;
        t["Upsilondieresishooksymbolgreek"] = 0x03D4;
        t["Upsilonhooksymbol"] = 0x03D2;
        t["Upsilontonos"] = 0x038E;
        t["Uring"] = 0x016E;
        t["Ushortcyrillic"] = 0x040E;
        t["Usmall"] = 0xF775;
        t["Ustraightcyrillic"] = 0x04AE;
        t["Ustraightstrokecyrillic"] = 0x04B0;
        t["Utilde"] = 0x0168;
        t["Utildeacute"] = 0x1E78;
        t["Utildebelow"] = 0x1E74;
        t["V"] = 0x0056;
        t["Vcircle"] = 0x24CB;
        t["Vdotbelow"] = 0x1E7E;
        t["Vecyrillic"] = 0x0412;
        t["Vewarmenian"] = 0x054E;
        t["Vhook"] = 0x01B2;
        t["Vmonospace"] = 0xFF36;
        t["Voarmenian"] = 0x0548;
        t["Vsmall"] = 0xF776;
        t["Vtilde"] = 0x1E7C;
        t["W"] = 0x0057;
        t["Wacute"] = 0x1E82;
        t["Wcircle"] = 0x24CC;
        t["Wcircumflex"] = 0x0174;
        t["Wdieresis"] = 0x1E84;
        t["Wdotaccent"] = 0x1E86;
        t["Wdotbelow"] = 0x1E88;
        t["Wgrave"] = 0x1E80;
        t["Wmonospace"] = 0xFF37;
        t["Wsmall"] = 0xF777;
        t["X"] = 0x0058;
        t["Xcircle"] = 0x24CD;
        t["Xdieresis"] = 0x1E8C;
        t["Xdotaccent"] = 0x1E8A;
        t["Xeharmenian"] = 0x053D;
        t["Xi"] = 0x039E;
        t["Xmonospace"] = 0xFF38;
        t["Xsmall"] = 0xF778;
        t["Y"] = 0x0059;
        t["Yacute"] = 0x00DD;
        t["Yacutesmall"] = 0xF7FD;
        t["Yatcyrillic"] = 0x0462;
        t["Ycircle"] = 0x24CE;
        t["Ycircumflex"] = 0x0176;
        t["Ydieresis"] = 0x0178;
        t["Ydieresissmall"] = 0xF7FF;
        t["Ydotaccent"] = 0x1E8E;
        t["Ydotbelow"] = 0x1EF4;
        t["Yericyrillic"] = 0x042B;
        t["Yerudieresiscyrillic"] = 0x04F8;
        t["Ygrave"] = 0x1EF2;
        t["Yhook"] = 0x01B3;
        t["Yhookabove"] = 0x1EF6;
        t["Yiarmenian"] = 0x0545;
        t["Yicyrillic"] = 0x0407;
        t["Yiwnarmenian"] = 0x0552;
        t["Ymonospace"] = 0xFF39;
        t["Ysmall"] = 0xF779;
        t["Ytilde"] = 0x1EF8;
        t["Yusbigcyrillic"] = 0x046A;
        t["Yusbigiotifiedcyrillic"] = 0x046C;
        t["Yuslittlecyrillic"] = 0x0466;
        t["Yuslittleiotifiedcyrillic"] = 0x0468;
        t["Z"] = 0x005A;
        t["Zaarmenian"] = 0x0536;
        t["Zacute"] = 0x0179;
        t["Zcaron"] = 0x017D;
        t["Zcaronsmall"] = 0xF6FF;
        t["Zcircle"] = 0x24CF;
        t["Zcircumflex"] = 0x1E90;
        t["Zdot"] = 0x017B;
        t["Zdotaccent"] = 0x017B;
        t["Zdotbelow"] = 0x1E92;
        t["Zecyrillic"] = 0x0417;
        t["Zedescendercyrillic"] = 0x0498;
        t["Zedieresiscyrillic"] = 0x04DE;
        t["Zeta"] = 0x0396;
        t["Zhearmenian"] = 0x053A;
        t["Zhebrevecyrillic"] = 0x04C1;
        t["Zhecyrillic"] = 0x0416;
        t["Zhedescendercyrillic"] = 0x0496;
        t["Zhedieresiscyrillic"] = 0x04DC;
        t["Zlinebelow"] = 0x1E94;
        t["Zmonospace"] = 0xFF3A;
        t["Zsmall"] = 0xF77A;
        t["Zstroke"] = 0x01B5;
        t["a"] = 0x0061;
        t["aabengali"] = 0x0986;
        t["aacute"] = 0x00E1;
        t["aadeva"] = 0x0906;
        t["aagujarati"] = 0x0A86;
        t["aagurmukhi"] = 0x0A06;
        t["aamatragurmukhi"] = 0x0A3E;
        t["aarusquare"] = 0x3303;
        t["aavowelsignbengali"] = 0x09BE;
        t["aavowelsigndeva"] = 0x093E;
        t["aavowelsigngujarati"] = 0x0ABE;
        t["abbreviationmarkarmenian"] = 0x055F;
        t["abbreviationsigndeva"] = 0x0970;
        t["abengali"] = 0x0985;
        t["abopomofo"] = 0x311A;
        t["abreve"] = 0x0103;
        t["abreveacute"] = 0x1EAF;
        t["abrevecyrillic"] = 0x04D1;
        t["abrevedotbelow"] = 0x1EB7;
        t["abrevegrave"] = 0x1EB1;
        t["abrevehookabove"] = 0x1EB3;
        t["abrevetilde"] = 0x1EB5;
        t["acaron"] = 0x01CE;
        t["acircle"] = 0x24D0;
        t["acircumflex"] = 0x00E2;
        t["acircumflexacute"] = 0x1EA5;
        t["acircumflexdotbelow"] = 0x1EAD;
        t["acircumflexgrave"] = 0x1EA7;
        t["acircumflexhookabove"] = 0x1EA9;
        t["acircumflextilde"] = 0x1EAB;
        t["acute"] = 0x00B4;
        t["acutebelowcmb"] = 0x0317;
        t["acutecmb"] = 0x0301;
        t["acutecomb"] = 0x0301;
        t["acutedeva"] = 0x0954;
        t["acutelowmod"] = 0x02CF;
        t["acutetonecmb"] = 0x0341;
        t["acyrillic"] = 0x0430;
        t["adblgrave"] = 0x0201;
        t["addakgurmukhi"] = 0x0A71;
        t["adeva"] = 0x0905;
        t["adieresis"] = 0x00E4;
        t["adieresiscyrillic"] = 0x04D3;
        t["adieresismacron"] = 0x01DF;
        t["adotbelow"] = 0x1EA1;
        t["adotmacron"] = 0x01E1;
        t["ae"] = 0x00E6;
        t["aeacute"] = 0x01FD;
        t["aekorean"] = 0x3150;
        t["aemacron"] = 0x01E3;
        t["afii00208"] = 0x2015;
        t["afii08941"] = 0x20A4;
        t["afii10017"] = 0x0410;
        t["afii10018"] = 0x0411;
        t["afii10019"] = 0x0412;
        t["afii10020"] = 0x0413;
        t["afii10021"] = 0x0414;
        t["afii10022"] = 0x0415;
        t["afii10023"] = 0x0401;
        t["afii10024"] = 0x0416;
        t["afii10025"] = 0x0417;
        t["afii10026"] = 0x0418;
        t["afii10027"] = 0x0419;
        t["afii10028"] = 0x041A;
        t["afii10029"] = 0x041B;
        t["afii10030"] = 0x041C;
        t["afii10031"] = 0x041D;
        t["afii10032"] = 0x041E;
        t["afii10033"] = 0x041F;
        t["afii10034"] = 0x0420;
        t["afii10035"] = 0x0421;
        t["afii10036"] = 0x0422;
        t["afii10037"] = 0x0423;
        t["afii10038"] = 0x0424;
        t["afii10039"] = 0x0425;
        t["afii10040"] = 0x0426;
        t["afii10041"] = 0x0427;
        t["afii10042"] = 0x0428;
        t["afii10043"] = 0x0429;
        t["afii10044"] = 0x042A;
        t["afii10045"] = 0x042B;
        t["afii10046"] = 0x042C;
        t["afii10047"] = 0x042D;
        t["afii10048"] = 0x042E;
        t["afii10049"] = 0x042F;
        t["afii10050"] = 0x0490;
        t["afii10051"] = 0x0402;
        t["afii10052"] = 0x0403;
        t["afii10053"] = 0x0404;
        t["afii10054"] = 0x0405;
        t["afii10055"] = 0x0406;
        t["afii10056"] = 0x0407;
        t["afii10057"] = 0x0408;
        t["afii10058"] = 0x0409;
        t["afii10059"] = 0x040A;
        t["afii10060"] = 0x040B;
        t["afii10061"] = 0x040C;
        t["afii10062"] = 0x040E;
        t["afii10063"] = 0xF6C4;
        t["afii10064"] = 0xF6C5;
        t["afii10065"] = 0x0430;
        t["afii10066"] = 0x0431;
        t["afii10067"] = 0x0432;
        t["afii10068"] = 0x0433;
        t["afii10069"] = 0x0434;
        t["afii10070"] = 0x0435;
        t["afii10071"] = 0x0451;
        t["afii10072"] = 0x0436;
        t["afii10073"] = 0x0437;
        t["afii10074"] = 0x0438;
        t["afii10075"] = 0x0439;
        t["afii10076"] = 0x043A;
        t["afii10077"] = 0x043B;
        t["afii10078"] = 0x043C;
        t["afii10079"] = 0x043D;
        t["afii10080"] = 0x043E;
        t["afii10081"] = 0x043F;
        t["afii10082"] = 0x0440;
        t["afii10083"] = 0x0441;
        t["afii10084"] = 0x0442;
        t["afii10085"] = 0x0443;
        t["afii10086"] = 0x0444;
        t["afii10087"] = 0x0445;
        t["afii10088"] = 0x0446;
        t["afii10089"] = 0x0447;
        t["afii10090"] = 0x0448;
        t["afii10091"] = 0x0449;
        t["afii10092"] = 0x044A;
        t["afii10093"] = 0x044B;
        t["afii10094"] = 0x044C;
        t["afii10095"] = 0x044D;
        t["afii10096"] = 0x044E;
        t["afii10097"] = 0x044F;
        t["afii10098"] = 0x0491;
        t["afii10099"] = 0x0452;
        t["afii10100"] = 0x0453;
        t["afii10101"] = 0x0454;
        t["afii10102"] = 0x0455;
        t["afii10103"] = 0x0456;
        t["afii10104"] = 0x0457;
        t["afii10105"] = 0x0458;
        t["afii10106"] = 0x0459;
        t["afii10107"] = 0x045A;
        t["afii10108"] = 0x045B;
        t["afii10109"] = 0x045C;
        t["afii10110"] = 0x045E;
        t["afii10145"] = 0x040F;
        t["afii10146"] = 0x0462;
        t["afii10147"] = 0x0472;
        t["afii10148"] = 0x0474;
        t["afii10192"] = 0xF6C6;
        t["afii10193"] = 0x045F;
        t["afii10194"] = 0x0463;
        t["afii10195"] = 0x0473;
        t["afii10196"] = 0x0475;
        t["afii10831"] = 0xF6C7;
        t["afii10832"] = 0xF6C8;
        t["afii10846"] = 0x04D9;
        t["afii299"] = 0x200E;
        t["afii300"] = 0x200F;
        t["afii301"] = 0x200D;
        t["afii57381"] = 0x066A;
        t["afii57388"] = 0x060C;
        t["afii57392"] = 0x0660;
        t["afii57393"] = 0x0661;
        t["afii57394"] = 0x0662;
        t["afii57395"] = 0x0663;
        t["afii57396"] = 0x0664;
        t["afii57397"] = 0x0665;
        t["afii57398"] = 0x0666;
        t["afii57399"] = 0x0667;
        t["afii57400"] = 0x0668;
        t["afii57401"] = 0x0669;
        t["afii57403"] = 0x061B;
        t["afii57407"] = 0x061F;
        t["afii57409"] = 0x0621;
        t["afii57410"] = 0x0622;
        t["afii57411"] = 0x0623;
        t["afii57412"] = 0x0624;
        t["afii57413"] = 0x0625;
        t["afii57414"] = 0x0626;
        t["afii57415"] = 0x0627;
        t["afii57416"] = 0x0628;
        t["afii57417"] = 0x0629;
        t["afii57418"] = 0x062A;
        t["afii57419"] = 0x062B;
        t["afii57420"] = 0x062C;
        t["afii57421"] = 0x062D;
        t["afii57422"] = 0x062E;
        t["afii57423"] = 0x062F;
        t["afii57424"] = 0x0630;
        t["afii57425"] = 0x0631;
        t["afii57426"] = 0x0632;
        t["afii57427"] = 0x0633;
        t["afii57428"] = 0x0634;
        t["afii57429"] = 0x0635;
        t["afii57430"] = 0x0636;
        t["afii57431"] = 0x0637;
        t["afii57432"] = 0x0638;
        t["afii57433"] = 0x0639;
        t["afii57434"] = 0x063A;
        t["afii57440"] = 0x0640;
        t["afii57441"] = 0x0641;
        t["afii57442"] = 0x0642;
        t["afii57443"] = 0x0643;
        t["afii57444"] = 0x0644;
        t["afii57445"] = 0x0645;
        t["afii57446"] = 0x0646;
        t["afii57448"] = 0x0648;
        t["afii57449"] = 0x0649;
        t["afii57450"] = 0x064A;
        t["afii57451"] = 0x064B;
        t["afii57452"] = 0x064C;
        t["afii57453"] = 0x064D;
        t["afii57454"] = 0x064E;
        t["afii57455"] = 0x064F;
        t["afii57456"] = 0x0650;
        t["afii57457"] = 0x0651;
        t["afii57458"] = 0x0652;
        t["afii57470"] = 0x0647;
        t["afii57505"] = 0x06A4;
        t["afii57506"] = 0x067E;
        t["afii57507"] = 0x0686;
        t["afii57508"] = 0x0698;
        t["afii57509"] = 0x06AF;
        t["afii57511"] = 0x0679;
        t["afii57512"] = 0x0688;
        t["afii57513"] = 0x0691;
        t["afii57514"] = 0x06BA;
        t["afii57519"] = 0x06D2;
        t["afii57534"] = 0x06D5;
        t["afii57636"] = 0x20AA;
        t["afii57645"] = 0x05BE;
        t["afii57658"] = 0x05C3;
        t["afii57664"] = 0x05D0;
        t["afii57665"] = 0x05D1;
        t["afii57666"] = 0x05D2;
        t["afii57667"] = 0x05D3;
        t["afii57668"] = 0x05D4;
        t["afii57669"] = 0x05D5;
        t["afii57670"] = 0x05D6;
        t["afii57671"] = 0x05D7;
        t["afii57672"] = 0x05D8;
        t["afii57673"] = 0x05D9;
        t["afii57674"] = 0x05DA;
        t["afii57675"] = 0x05DB;
        t["afii57676"] = 0x05DC;
        t["afii57677"] = 0x05DD;
        t["afii57678"] = 0x05DE;
        t["afii57679"] = 0x05DF;
        t["afii57680"] = 0x05E0;
        t["afii57681"] = 0x05E1;
        t["afii57682"] = 0x05E2;
        t["afii57683"] = 0x05E3;
        t["afii57684"] = 0x05E4;
        t["afii57685"] = 0x05E5;
        t["afii57686"] = 0x05E6;
        t["afii57687"] = 0x05E7;
        t["afii57688"] = 0x05E8;
        t["afii57689"] = 0x05E9;
        t["afii57690"] = 0x05EA;
        t["afii57694"] = 0xFB2A;
        t["afii57695"] = 0xFB2B;
        t["afii57700"] = 0xFB4B;
        t["afii57705"] = 0xFB1F;
        t["afii57716"] = 0x05F0;
        t["afii57717"] = 0x05F1;
        t["afii57718"] = 0x05F2;
        t["afii57723"] = 0xFB35;
        t["afii57793"] = 0x05B4;
        t["afii57794"] = 0x05B5;
        t["afii57795"] = 0x05B6;
        t["afii57796"] = 0x05BB;
        t["afii57797"] = 0x05B8;
        t["afii57798"] = 0x05B7;
        t["afii57799"] = 0x05B0;
        t["afii57800"] = 0x05B2;
        t["afii57801"] = 0x05B1;
        t["afii57802"] = 0x05B3;
        t["afii57803"] = 0x05C2;
        t["afii57804"] = 0x05C1;
        t["afii57806"] = 0x05B9;
        t["afii57807"] = 0x05BC;
        t["afii57839"] = 0x05BD;
        t["afii57841"] = 0x05BF;
        t["afii57842"] = 0x05C0;
        t["afii57929"] = 0x02BC;
        t["afii61248"] = 0x2105;
        t["afii61289"] = 0x2113;
        t["afii61352"] = 0x2116;
        t["afii61573"] = 0x202C;
        t["afii61574"] = 0x202D;
        t["afii61575"] = 0x202E;
        t["afii61664"] = 0x200C;
        t["afii63167"] = 0x066D;
        t["afii64937"] = 0x02BD;
        t["agrave"] = 0x00E0;
        t["agujarati"] = 0x0A85;
        t["agurmukhi"] = 0x0A05;
        t["ahiragana"] = 0x3042;
        t["ahookabove"] = 0x1EA3;
        t["aibengali"] = 0x0990;
        t["aibopomofo"] = 0x311E;
        t["aideva"] = 0x0910;
        t["aiecyrillic"] = 0x04D5;
        t["aigujarati"] = 0x0A90;
        t["aigurmukhi"] = 0x0A10;
        t["aimatragurmukhi"] = 0x0A48;
        t["ainarabic"] = 0x0639;
        t["ainfinalarabic"] = 0xFECA;
        t["aininitialarabic"] = 0xFECB;
        t["ainmedialarabic"] = 0xFECC;
        t["ainvertedbreve"] = 0x0203;
        t["aivowelsignbengali"] = 0x09C8;
        t["aivowelsigndeva"] = 0x0948;
        t["aivowelsigngujarati"] = 0x0AC8;
        t["akatakana"] = 0x30A2;
        t["akatakanahalfwidth"] = 0xFF71;
        t["akorean"] = 0x314F;
        t["alef"] = 0x05D0;
        t["alefarabic"] = 0x0627;
        t["alefdageshhebrew"] = 0xFB30;
        t["aleffinalarabic"] = 0xFE8E;
        t["alefhamzaabovearabic"] = 0x0623;
        t["alefhamzaabovefinalarabic"] = 0xFE84;
        t["alefhamzabelowarabic"] = 0x0625;
        t["alefhamzabelowfinalarabic"] = 0xFE88;
        t["alefhebrew"] = 0x05D0;
        t["aleflamedhebrew"] = 0xFB4F;
        t["alefmaddaabovearabic"] = 0x0622;
        t["alefmaddaabovefinalarabic"] = 0xFE82;
        t["alefmaksuraarabic"] = 0x0649;
        t["alefmaksurafinalarabic"] = 0xFEF0;
        t["alefmaksurainitialarabic"] = 0xFEF3;
        t["alefmaksuramedialarabic"] = 0xFEF4;
        t["alefpatahhebrew"] = 0xFB2E;
        t["alefqamatshebrew"] = 0xFB2F;
        t["aleph"] = 0x2135;
        t["allequal"] = 0x224C;
        t["alpha"] = 0x03B1;
        t["alphatonos"] = 0x03AC;
        t["amacron"] = 0x0101;
        t["amonospace"] = 0xFF41;
        t["ampersand"] = 0x0026;
        t["ampersandmonospace"] = 0xFF06;
        t["ampersandsmall"] = 0xF726;
        t["amsquare"] = 0x33C2;
        t["anbopomofo"] = 0x3122;
        t["angbopomofo"] = 0x3124;
        t["angbracketleft"] = 0x3008;
        t["angbracketright"] = 0x3009;
        t["angkhankhuthai"] = 0x0E5A;
        t["angle"] = 0x2220;
        t["anglebracketleft"] = 0x3008;
        t["anglebracketleftvertical"] = 0xFE3F;
        t["anglebracketright"] = 0x3009;
        t["anglebracketrightvertical"] = 0xFE40;
        t["angleleft"] = 0x2329;
        t["angleright"] = 0x232A;
        t["angstrom"] = 0x212B;
        t["anoteleia"] = 0x0387;
        t["anudattadeva"] = 0x0952;
        t["anusvarabengali"] = 0x0982;
        t["anusvaradeva"] = 0x0902;
        t["anusvaragujarati"] = 0x0A82;
        t["aogonek"] = 0x0105;
        t["apaatosquare"] = 0x3300;
        t["aparen"] = 0x249C;
        t["apostrophearmenian"] = 0x055A;
        t["apostrophemod"] = 0x02BC;
        t["apple"] = 0xF8FF;
        t["approaches"] = 0x2250;
        t["approxequal"] = 0x2248;
        t["approxequalorimage"] = 0x2252;
        t["approximatelyequal"] = 0x2245;
        t["araeaekorean"] = 0x318E;
        t["araeakorean"] = 0x318D;
        t["arc"] = 0x2312;
        t["arighthalfring"] = 0x1E9A;
        t["aring"] = 0x00E5;
        t["aringacute"] = 0x01FB;
        t["aringbelow"] = 0x1E01;
        t["arrowboth"] = 0x2194;
        t["arrowdashdown"] = 0x21E3;
        t["arrowdashleft"] = 0x21E0;
        t["arrowdashright"] = 0x21E2;
        t["arrowdashup"] = 0x21E1;
        t["arrowdblboth"] = 0x21D4;
        t["arrowdbldown"] = 0x21D3;
        t["arrowdblleft"] = 0x21D0;
        t["arrowdblright"] = 0x21D2;
        t["arrowdblup"] = 0x21D1;
        t["arrowdown"] = 0x2193;
        t["arrowdownleft"] = 0x2199;
        t["arrowdownright"] = 0x2198;
        t["arrowdownwhite"] = 0x21E9;
        t["arrowheaddownmod"] = 0x02C5;
        t["arrowheadleftmod"] = 0x02C2;
        t["arrowheadrightmod"] = 0x02C3;
        t["arrowheadupmod"] = 0x02C4;
        t["arrowhorizex"] = 0xF8E7;
        t["arrowleft"] = 0x2190;
        t["arrowleftdbl"] = 0x21D0;
        t["arrowleftdblstroke"] = 0x21CD;
        t["arrowleftoverright"] = 0x21C6;
        t["arrowleftwhite"] = 0x21E6;
        t["arrowright"] = 0x2192;
        t["arrowrightdblstroke"] = 0x21CF;
        t["arrowrightheavy"] = 0x279E;
        t["arrowrightoverleft"] = 0x21C4;
        t["arrowrightwhite"] = 0x21E8;
        t["arrowtableft"] = 0x21E4;
        t["arrowtabright"] = 0x21E5;
        t["arrowup"] = 0x2191;
        t["arrowupdn"] = 0x2195;
        t["arrowupdnbse"] = 0x21A8;
        t["arrowupdownbase"] = 0x21A8;
        t["arrowupleft"] = 0x2196;
        t["arrowupleftofdown"] = 0x21C5;
        t["arrowupright"] = 0x2197;
        t["arrowupwhite"] = 0x21E7;
        t["arrowvertex"] = 0xF8E6;
        t["asciicircum"] = 0x005E;
        t["asciicircummonospace"] = 0xFF3E;
        t["asciitilde"] = 0x007E;
        t["asciitildemonospace"] = 0xFF5E;
        t["ascript"] = 0x0251;
        t["ascriptturned"] = 0x0252;
        t["asmallhiragana"] = 0x3041;
        t["asmallkatakana"] = 0x30A1;
        t["asmallkatakanahalfwidth"] = 0xFF67;
        t["asterisk"] = 0x002A;
        t["asteriskaltonearabic"] = 0x066D;
        t["asteriskarabic"] = 0x066D;
        t["asteriskmath"] = 0x2217;
        t["asteriskmonospace"] = 0xFF0A;
        t["asterisksmall"] = 0xFE61;
        t["asterism"] = 0x2042;
        t["asuperior"] = 0xF6E9;
        t["asymptoticallyequal"] = 0x2243;
        t["at"] = 0x0040;
        t["atilde"] = 0x00E3;
        t["atmonospace"] = 0xFF20;
        t["atsmall"] = 0xFE6B;
        t["aturned"] = 0x0250;
        t["aubengali"] = 0x0994;
        t["aubopomofo"] = 0x3120;
        t["audeva"] = 0x0914;
        t["augujarati"] = 0x0A94;
        t["augurmukhi"] = 0x0A14;
        t["aulengthmarkbengali"] = 0x09D7;
        t["aumatragurmukhi"] = 0x0A4C;
        t["auvowelsignbengali"] = 0x09CC;
        t["auvowelsigndeva"] = 0x094C;
        t["auvowelsigngujarati"] = 0x0ACC;
        t["avagrahadeva"] = 0x093D;
        t["aybarmenian"] = 0x0561;
        t["ayin"] = 0x05E2;
        t["ayinaltonehebrew"] = 0xFB20;
        t["ayinhebrew"] = 0x05E2;
        t["b"] = 0x0062;
        t["babengali"] = 0x09AC;
        t["backslash"] = 0x005C;
        t["backslashmonospace"] = 0xFF3C;
        t["badeva"] = 0x092C;
        t["bagujarati"] = 0x0AAC;
        t["bagurmukhi"] = 0x0A2C;
        t["bahiragana"] = 0x3070;
        t["bahtthai"] = 0x0E3F;
        t["bakatakana"] = 0x30D0;
        t["bar"] = 0x007C;
        t["barmonospace"] = 0xFF5C;
        t["bbopomofo"] = 0x3105;
        t["bcircle"] = 0x24D1;
        t["bdotaccent"] = 0x1E03;
        t["bdotbelow"] = 0x1E05;
        t["beamedsixteenthnotes"] = 0x266C;
        t["because"] = 0x2235;
        t["becyrillic"] = 0x0431;
        t["beharabic"] = 0x0628;
        t["behfinalarabic"] = 0xFE90;
        t["behinitialarabic"] = 0xFE91;
        t["behiragana"] = 0x3079;
        t["behmedialarabic"] = 0xFE92;
        t["behmeeminitialarabic"] = 0xFC9F;
        t["behmeemisolatedarabic"] = 0xFC08;
        t["behnoonfinalarabic"] = 0xFC6D;
        t["bekatakana"] = 0x30D9;
        t["benarmenian"] = 0x0562;
        t["bet"] = 0x05D1;
        t["beta"] = 0x03B2;
        t["betasymbolgreek"] = 0x03D0;
        t["betdagesh"] = 0xFB31;
        t["betdageshhebrew"] = 0xFB31;
        t["bethebrew"] = 0x05D1;
        t["betrafehebrew"] = 0xFB4C;
        t["bhabengali"] = 0x09AD;
        t["bhadeva"] = 0x092D;
        t["bhagujarati"] = 0x0AAD;
        t["bhagurmukhi"] = 0x0A2D;
        t["bhook"] = 0x0253;
        t["bihiragana"] = 0x3073;
        t["bikatakana"] = 0x30D3;
        t["bilabialclick"] = 0x0298;
        t["bindigurmukhi"] = 0x0A02;
        t["birusquare"] = 0x3331;
        t["blackcircle"] = 0x25CF;
        t["blackdiamond"] = 0x25C6;
        t["blackdownpointingtriangle"] = 0x25BC;
        t["blackleftpointingpointer"] = 0x25C4;
        t["blackleftpointingtriangle"] = 0x25C0;
        t["blacklenticularbracketleft"] = 0x3010;
        t["blacklenticularbracketleftvertical"] = 0xFE3B;
        t["blacklenticularbracketright"] = 0x3011;
        t["blacklenticularbracketrightvertical"] = 0xFE3C;
        t["blacklowerlefttriangle"] = 0x25E3;
        t["blacklowerrighttriangle"] = 0x25E2;
        t["blackrectangle"] = 0x25AC;
        t["blackrightpointingpointer"] = 0x25BA;
        t["blackrightpointingtriangle"] = 0x25B6;
        t["blacksmallsquare"] = 0x25AA;
        t["blacksmilingface"] = 0x263B;
        t["blacksquare"] = 0x25A0;
        t["blackstar"] = 0x2605;
        t["blackupperlefttriangle"] = 0x25E4;
        t["blackupperrighttriangle"] = 0x25E5;
        t["blackuppointingsmalltriangle"] = 0x25B4;
        t["blackuppointingtriangle"] = 0x25B2;
        t["blank"] = 0x2423;
        t["blinebelow"] = 0x1E07;
        t["block"] = 0x2588;
        t["bmonospace"] = 0xFF42;
        t["bobaimaithai"] = 0x0E1A;
        t["bohiragana"] = 0x307C;
        t["bokatakana"] = 0x30DC;
        t["bparen"] = 0x249D;
        t["bqsquare"] = 0x33C3;
        t["braceex"] = 0xF8F4;
        t["braceleft"] = 0x007B;
        t["braceleftbt"] = 0xF8F3;
        t["braceleftmid"] = 0xF8F2;
        t["braceleftmonospace"] = 0xFF5B;
        t["braceleftsmall"] = 0xFE5B;
        t["bracelefttp"] = 0xF8F1;
        t["braceleftvertical"] = 0xFE37;
        t["braceright"] = 0x007D;
        t["bracerightbt"] = 0xF8FE;
        t["bracerightmid"] = 0xF8FD;
        t["bracerightmonospace"] = 0xFF5D;
        t["bracerightsmall"] = 0xFE5C;
        t["bracerighttp"] = 0xF8FC;
        t["bracerightvertical"] = 0xFE38;
        t["bracketleft"] = 0x005B;
        t["bracketleftbt"] = 0xF8F0;
        t["bracketleftex"] = 0xF8EF;
        t["bracketleftmonospace"] = 0xFF3B;
        t["bracketlefttp"] = 0xF8EE;
        t["bracketright"] = 0x005D;
        t["bracketrightbt"] = 0xF8FB;
        t["bracketrightex"] = 0xF8FA;
        t["bracketrightmonospace"] = 0xFF3D;
        t["bracketrighttp"] = 0xF8F9;
        t["breve"] = 0x02D8;
        t["brevebelowcmb"] = 0x032E;
        t["brevecmb"] = 0x0306;
        t["breveinvertedbelowcmb"] = 0x032F;
        t["breveinvertedcmb"] = 0x0311;
        t["breveinverteddoublecmb"] = 0x0361;
        t["bridgebelowcmb"] = 0x032A;
        t["bridgeinvertedbelowcmb"] = 0x033A;
        t["brokenbar"] = 0x00A6;
        t["bstroke"] = 0x0180;
        t["bsuperior"] = 0xF6EA;
        t["btopbar"] = 0x0183;
        t["buhiragana"] = 0x3076;
        t["bukatakana"] = 0x30D6;
        t["bullet"] = 0x2022;
        t["bulletinverse"] = 0x25D8;
        t["bulletoperator"] = 0x2219;
        t["bullseye"] = 0x25CE;
        t["c"] = 0x0063;
        t["caarmenian"] = 0x056E;
        t["cabengali"] = 0x099A;
        t["cacute"] = 0x0107;
        t["cadeva"] = 0x091A;
        t["cagujarati"] = 0x0A9A;
        t["cagurmukhi"] = 0x0A1A;
        t["calsquare"] = 0x3388;
        t["candrabindubengali"] = 0x0981;
        t["candrabinducmb"] = 0x0310;
        t["candrabindudeva"] = 0x0901;
        t["candrabindugujarati"] = 0x0A81;
        t["capslock"] = 0x21EA;
        t["careof"] = 0x2105;
        t["caron"] = 0x02C7;
        t["caronbelowcmb"] = 0x032C;
        t["caroncmb"] = 0x030C;
        t["carriagereturn"] = 0x21B5;
        t["cbopomofo"] = 0x3118;
        t["ccaron"] = 0x010D;
        t["ccedilla"] = 0x00E7;
        t["ccedillaacute"] = 0x1E09;
        t["ccircle"] = 0x24D2;
        t["ccircumflex"] = 0x0109;
        t["ccurl"] = 0x0255;
        t["cdot"] = 0x010B;
        t["cdotaccent"] = 0x010B;
        t["cdsquare"] = 0x33C5;
        t["cedilla"] = 0x00B8;
        t["cedillacmb"] = 0x0327;
        t["cent"] = 0x00A2;
        t["centigrade"] = 0x2103;
        t["centinferior"] = 0xF6DF;
        t["centmonospace"] = 0xFFE0;
        t["centoldstyle"] = 0xF7A2;
        t["centsuperior"] = 0xF6E0;
        t["chaarmenian"] = 0x0579;
        t["chabengali"] = 0x099B;
        t["chadeva"] = 0x091B;
        t["chagujarati"] = 0x0A9B;
        t["chagurmukhi"] = 0x0A1B;
        t["chbopomofo"] = 0x3114;
        t["cheabkhasiancyrillic"] = 0x04BD;
        t["checkmark"] = 0x2713;
        t["checyrillic"] = 0x0447;
        t["chedescenderabkhasiancyrillic"] = 0x04BF;
        t["chedescendercyrillic"] = 0x04B7;
        t["chedieresiscyrillic"] = 0x04F5;
        t["cheharmenian"] = 0x0573;
        t["chekhakassiancyrillic"] = 0x04CC;
        t["cheverticalstrokecyrillic"] = 0x04B9;
        t["chi"] = 0x03C7;
        t["chieuchacirclekorean"] = 0x3277;
        t["chieuchaparenkorean"] = 0x3217;
        t["chieuchcirclekorean"] = 0x3269;
        t["chieuchkorean"] = 0x314A;
        t["chieuchparenkorean"] = 0x3209;
        t["chochangthai"] = 0x0E0A;
        t["chochanthai"] = 0x0E08;
        t["chochingthai"] = 0x0E09;
        t["chochoethai"] = 0x0E0C;
        t["chook"] = 0x0188;
        t["cieucacirclekorean"] = 0x3276;
        t["cieucaparenkorean"] = 0x3216;
        t["cieuccirclekorean"] = 0x3268;
        t["cieuckorean"] = 0x3148;
        t["cieucparenkorean"] = 0x3208;
        t["cieucuparenkorean"] = 0x321C;
        t["circle"] = 0x25CB;
        t["circlecopyrt"] = 0x00A9;
        t["circlemultiply"] = 0x2297;
        t["circleot"] = 0x2299;
        t["circleplus"] = 0x2295;
        t["circlepostalmark"] = 0x3036;
        t["circlewithlefthalfblack"] = 0x25D0;
        t["circlewithrighthalfblack"] = 0x25D1;
        t["circumflex"] = 0x02C6;
        t["circumflexbelowcmb"] = 0x032D;
        t["circumflexcmb"] = 0x0302;
        t["clear"] = 0x2327;
        t["clickalveolar"] = 0x01C2;
        t["clickdental"] = 0x01C0;
        t["clicklateral"] = 0x01C1;
        t["clickretroflex"] = 0x01C3;
        t["club"] = 0x2663;
        t["clubsuitblack"] = 0x2663;
        t["clubsuitwhite"] = 0x2667;
        t["cmcubedsquare"] = 0x33A4;
        t["cmonospace"] = 0xFF43;
        t["cmsquaredsquare"] = 0x33A0;
        t["coarmenian"] = 0x0581;
        t["colon"] = 0x003A;
        t["colonmonetary"] = 0x20A1;
        t["colonmonospace"] = 0xFF1A;
        t["colonsign"] = 0x20A1;
        t["colonsmall"] = 0xFE55;
        t["colontriangularhalfmod"] = 0x02D1;
        t["colontriangularmod"] = 0x02D0;
        t["comma"] = 0x002C;
        t["commaabovecmb"] = 0x0313;
        t["commaaboverightcmb"] = 0x0315;
        t["commaaccent"] = 0xF6C3;
        t["commaarabic"] = 0x060C;
        t["commaarmenian"] = 0x055D;
        t["commainferior"] = 0xF6E1;
        t["commamonospace"] = 0xFF0C;
        t["commareversedabovecmb"] = 0x0314;
        t["commareversedmod"] = 0x02BD;
        t["commasmall"] = 0xFE50;
        t["commasuperior"] = 0xF6E2;
        t["commaturnedabovecmb"] = 0x0312;
        t["commaturnedmod"] = 0x02BB;
        t["compass"] = 0x263C;
        t["congruent"] = 0x2245;
        t["contourintegral"] = 0x222E;
        t["control"] = 0x2303;
        t["controlACK"] = 0x0006;
        t["controlBEL"] = 0x0007;
        t["controlBS"] = 0x0008;
        t["controlCAN"] = 0x0018;
        t["controlCR"] = 0x000D;
        t["controlDC1"] = 0x0011;
        t["controlDC2"] = 0x0012;
        t["controlDC3"] = 0x0013;
        t["controlDC4"] = 0x0014;
        t["controlDEL"] = 0x007F;
        t["controlDLE"] = 0x0010;
        t["controlEM"] = 0x0019;
        t["controlENQ"] = 0x0005;
        t["controlEOT"] = 0x0004;
        t["controlESC"] = 0x001B;
        t["controlETB"] = 0x0017;
        t["controlETX"] = 0x0003;
        t["controlFF"] = 0x000C;
        t["controlFS"] = 0x001C;
        t["controlGS"] = 0x001D;
        t["controlHT"] = 0x0009;
        t["controlLF"] = 0x000A;
        t["controlNAK"] = 0x0015;
        t["controlNULL"] = 0x0000;
        t["controlRS"] = 0x001E;
        t["controlSI"] = 0x000F;
        t["controlSO"] = 0x000E;
        t["controlSOT"] = 0x0002;
        t["controlSTX"] = 0x0001;
        t["controlSUB"] = 0x001A;
        t["controlSYN"] = 0x0016;
        t["controlUS"] = 0x001F;
        t["controlVT"] = 0x000B;
        t["copyright"] = 0x00A9;
        t["copyrightsans"] = 0xF8E9;
        t["copyrightserif"] = 0xF6D9;
        t["cornerbracketleft"] = 0x300C;
        t["cornerbracketlefthalfwidth"] = 0xFF62;
        t["cornerbracketleftvertical"] = 0xFE41;
        t["cornerbracketright"] = 0x300D;
        t["cornerbracketrighthalfwidth"] = 0xFF63;
        t["cornerbracketrightvertical"] = 0xFE42;
        t["corporationsquare"] = 0x337F;
        t["cosquare"] = 0x33C7;
        t["coverkgsquare"] = 0x33C6;
        t["cparen"] = 0x249E;
        t["cruzeiro"] = 0x20A2;
        t["cstretched"] = 0x0297;
        t["curlyand"] = 0x22CF;
        t["curlyor"] = 0x22CE;
        t["currency"] = 0x00A4;
        t["cyrBreve"] = 0xF6D1;
        t["cyrFlex"] = 0xF6D2;
        t["cyrbreve"] = 0xF6D4;
        t["cyrflex"] = 0xF6D5;
        t["d"] = 0x0064;
        t["daarmenian"] = 0x0564;
        t["dabengali"] = 0x09A6;
        t["dadarabic"] = 0x0636;
        t["dadeva"] = 0x0926;
        t["dadfinalarabic"] = 0xFEBE;
        t["dadinitialarabic"] = 0xFEBF;
        t["dadmedialarabic"] = 0xFEC0;
        t["dagesh"] = 0x05BC;
        t["dageshhebrew"] = 0x05BC;
        t["dagger"] = 0x2020;
        t["daggerdbl"] = 0x2021;
        t["dagujarati"] = 0x0AA6;
        t["dagurmukhi"] = 0x0A26;
        t["dahiragana"] = 0x3060;
        t["dakatakana"] = 0x30C0;
        t["dalarabic"] = 0x062F;
        t["dalet"] = 0x05D3;
        t["daletdagesh"] = 0xFB33;
        t["daletdageshhebrew"] = 0xFB33;
        t["dalethebrew"] = 0x05D3;
        t["dalfinalarabic"] = 0xFEAA;
        t["dammaarabic"] = 0x064F;
        t["dammalowarabic"] = 0x064F;
        t["dammatanaltonearabic"] = 0x064C;
        t["dammatanarabic"] = 0x064C;
        t["danda"] = 0x0964;
        t["dargahebrew"] = 0x05A7;
        t["dargalefthebrew"] = 0x05A7;
        t["dasiapneumatacyrilliccmb"] = 0x0485;
        t["dblGrave"] = 0xF6D3;
        t["dblanglebracketleft"] = 0x300A;
        t["dblanglebracketleftvertical"] = 0xFE3D;
        t["dblanglebracketright"] = 0x300B;
        t["dblanglebracketrightvertical"] = 0xFE3E;
        t["dblarchinvertedbelowcmb"] = 0x032B;
        t["dblarrowleft"] = 0x21D4;
        t["dblarrowright"] = 0x21D2;
        t["dbldanda"] = 0x0965;
        t["dblgrave"] = 0xF6D6;
        t["dblgravecmb"] = 0x030F;
        t["dblintegral"] = 0x222C;
        t["dbllowline"] = 0x2017;
        t["dbllowlinecmb"] = 0x0333;
        t["dbloverlinecmb"] = 0x033F;
        t["dblprimemod"] = 0x02BA;
        t["dblverticalbar"] = 0x2016;
        t["dblverticallineabovecmb"] = 0x030E;
        t["dbopomofo"] = 0x3109;
        t["dbsquare"] = 0x33C8;
        t["dcaron"] = 0x010F;
        t["dcedilla"] = 0x1E11;
        t["dcircle"] = 0x24D3;
        t["dcircumflexbelow"] = 0x1E13;
        t["dcroat"] = 0x0111;
        t["ddabengali"] = 0x09A1;
        t["ddadeva"] = 0x0921;
        t["ddagujarati"] = 0x0AA1;
        t["ddagurmukhi"] = 0x0A21;
        t["ddalarabic"] = 0x0688;
        t["ddalfinalarabic"] = 0xFB89;
        t["dddhadeva"] = 0x095C;
        t["ddhabengali"] = 0x09A2;
        t["ddhadeva"] = 0x0922;
        t["ddhagujarati"] = 0x0AA2;
        t["ddhagurmukhi"] = 0x0A22;
        t["ddotaccent"] = 0x1E0B;
        t["ddotbelow"] = 0x1E0D;
        t["decimalseparatorarabic"] = 0x066B;
        t["decimalseparatorpersian"] = 0x066B;
        t["decyrillic"] = 0x0434;
        t["degree"] = 0x00B0;
        t["dehihebrew"] = 0x05AD;
        t["dehiragana"] = 0x3067;
        t["deicoptic"] = 0x03EF;
        t["dekatakana"] = 0x30C7;
        t["deleteleft"] = 0x232B;
        t["deleteright"] = 0x2326;
        t["delta"] = 0x03B4;
        t["deltaturned"] = 0x018D;
        t["denominatorminusonenumeratorbengali"] = 0x09F8;
        t["dezh"] = 0x02A4;
        t["dhabengali"] = 0x09A7;
        t["dhadeva"] = 0x0927;
        t["dhagujarati"] = 0x0AA7;
        t["dhagurmukhi"] = 0x0A27;
        t["dhook"] = 0x0257;
        t["dialytikatonos"] = 0x0385;
        t["dialytikatonoscmb"] = 0x0344;
        t["diamond"] = 0x2666;
        t["diamondsuitwhite"] = 0x2662;
        t["dieresis"] = 0x00A8;
        t["dieresisacute"] = 0xF6D7;
        t["dieresisbelowcmb"] = 0x0324;
        t["dieresiscmb"] = 0x0308;
        t["dieresisgrave"] = 0xF6D8;
        t["dieresistonos"] = 0x0385;
        t["dihiragana"] = 0x3062;
        t["dikatakana"] = 0x30C2;
        t["dittomark"] = 0x3003;
        t["divide"] = 0x00F7;
        t["divides"] = 0x2223;
        t["divisionslash"] = 0x2215;
        t["djecyrillic"] = 0x0452;
        t["dkshade"] = 0x2593;
        t["dlinebelow"] = 0x1E0F;
        t["dlsquare"] = 0x3397;
        t["dmacron"] = 0x0111;
        t["dmonospace"] = 0xFF44;
        t["dnblock"] = 0x2584;
        t["dochadathai"] = 0x0E0E;
        t["dodekthai"] = 0x0E14;
        t["dohiragana"] = 0x3069;
        t["dokatakana"] = 0x30C9;
        t["dollar"] = 0x0024;
        t["dollarinferior"] = 0xF6E3;
        t["dollarmonospace"] = 0xFF04;
        t["dollaroldstyle"] = 0xF724;
        t["dollarsmall"] = 0xFE69;
        t["dollarsuperior"] = 0xF6E4;
        t["dong"] = 0x20AB;
        t["dorusquare"] = 0x3326;
        t["dotaccent"] = 0x02D9;
        t["dotaccentcmb"] = 0x0307;
        t["dotbelowcmb"] = 0x0323;
        t["dotbelowcomb"] = 0x0323;
        t["dotkatakana"] = 0x30FB;
        t["dotlessi"] = 0x0131;
        t["dotlessj"] = 0xF6BE;
        t["dotlessjstrokehook"] = 0x0284;
        t["dotmath"] = 0x22C5;
        t["dottedcircle"] = 0x25CC;
        t["doubleyodpatah"] = 0xFB1F;
        t["doubleyodpatahhebrew"] = 0xFB1F;
        t["downtackbelowcmb"] = 0x031E;
        t["downtackmod"] = 0x02D5;
        t["dparen"] = 0x249F;
        t["dsuperior"] = 0xF6EB;
        t["dtail"] = 0x0256;
        t["dtopbar"] = 0x018C;
        t["duhiragana"] = 0x3065;
        t["dukatakana"] = 0x30C5;
        t["dz"] = 0x01F3;
        t["dzaltone"] = 0x02A3;
        t["dzcaron"] = 0x01C6;
        t["dzcurl"] = 0x02A5;
        t["dzeabkhasiancyrillic"] = 0x04E1;
        t["dzecyrillic"] = 0x0455;
        t["dzhecyrillic"] = 0x045F;
        t["e"] = 0x0065;
        t["eacute"] = 0x00E9;
        t["earth"] = 0x2641;
        t["ebengali"] = 0x098F;
        t["ebopomofo"] = 0x311C;
        t["ebreve"] = 0x0115;
        t["ecandradeva"] = 0x090D;
        t["ecandragujarati"] = 0x0A8D;
        t["ecandravowelsigndeva"] = 0x0945;
        t["ecandravowelsigngujarati"] = 0x0AC5;
        t["ecaron"] = 0x011B;
        t["ecedillabreve"] = 0x1E1D;
        t["echarmenian"] = 0x0565;
        t["echyiwnarmenian"] = 0x0587;
        t["ecircle"] = 0x24D4;
        t["ecircumflex"] = 0x00EA;
        t["ecircumflexacute"] = 0x1EBF;
        t["ecircumflexbelow"] = 0x1E19;
        t["ecircumflexdotbelow"] = 0x1EC7;
        t["ecircumflexgrave"] = 0x1EC1;
        t["ecircumflexhookabove"] = 0x1EC3;
        t["ecircumflextilde"] = 0x1EC5;
        t["ecyrillic"] = 0x0454;
        t["edblgrave"] = 0x0205;
        t["edeva"] = 0x090F;
        t["edieresis"] = 0x00EB;
        t["edot"] = 0x0117;
        t["edotaccent"] = 0x0117;
        t["edotbelow"] = 0x1EB9;
        t["eegurmukhi"] = 0x0A0F;
        t["eematragurmukhi"] = 0x0A47;
        t["efcyrillic"] = 0x0444;
        t["egrave"] = 0x00E8;
        t["egujarati"] = 0x0A8F;
        t["eharmenian"] = 0x0567;
        t["ehbopomofo"] = 0x311D;
        t["ehiragana"] = 0x3048;
        t["ehookabove"] = 0x1EBB;
        t["eibopomofo"] = 0x311F;
        t["eight"] = 0x0038;
        t["eightarabic"] = 0x0668;
        t["eightbengali"] = 0x09EE;
        t["eightcircle"] = 0x2467;
        t["eightcircleinversesansserif"] = 0x2791;
        t["eightdeva"] = 0x096E;
        t["eighteencircle"] = 0x2471;
        t["eighteenparen"] = 0x2485;
        t["eighteenperiod"] = 0x2499;
        t["eightgujarati"] = 0x0AEE;
        t["eightgurmukhi"] = 0x0A6E;
        t["eighthackarabic"] = 0x0668;
        t["eighthangzhou"] = 0x3028;
        t["eighthnotebeamed"] = 0x266B;
        t["eightideographicparen"] = 0x3227;
        t["eightinferior"] = 0x2088;
        t["eightmonospace"] = 0xFF18;
        t["eightoldstyle"] = 0xF738;
        t["eightparen"] = 0x247B;
        t["eightperiod"] = 0x248F;
        t["eightpersian"] = 0x06F8;
        t["eightroman"] = 0x2177;
        t["eightsuperior"] = 0x2078;
        t["eightthai"] = 0x0E58;
        t["einvertedbreve"] = 0x0207;
        t["eiotifiedcyrillic"] = 0x0465;
        t["ekatakana"] = 0x30A8;
        t["ekatakanahalfwidth"] = 0xFF74;
        t["ekonkargurmukhi"] = 0x0A74;
        t["ekorean"] = 0x3154;
        t["elcyrillic"] = 0x043B;
        t["element"] = 0x2208;
        t["elevencircle"] = 0x246A;
        t["elevenparen"] = 0x247E;
        t["elevenperiod"] = 0x2492;
        t["elevenroman"] = 0x217A;
        t["ellipsis"] = 0x2026;
        t["ellipsisvertical"] = 0x22EE;
        t["emacron"] = 0x0113;
        t["emacronacute"] = 0x1E17;
        t["emacrongrave"] = 0x1E15;
        t["emcyrillic"] = 0x043C;
        t["emdash"] = 0x2014;
        t["emdashvertical"] = 0xFE31;
        t["emonospace"] = 0xFF45;
        t["emphasismarkarmenian"] = 0x055B;
        t["emptyset"] = 0x2205;
        t["enbopomofo"] = 0x3123;
        t["encyrillic"] = 0x043D;
        t["endash"] = 0x2013;
        t["endashvertical"] = 0xFE32;
        t["endescendercyrillic"] = 0x04A3;
        t["eng"] = 0x014B;
        t["engbopomofo"] = 0x3125;
        t["enghecyrillic"] = 0x04A5;
        t["enhookcyrillic"] = 0x04C8;
        t["enspace"] = 0x2002;
        t["eogonek"] = 0x0119;
        t["eokorean"] = 0x3153;
        t["eopen"] = 0x025B;
        t["eopenclosed"] = 0x029A;
        t["eopenreversed"] = 0x025C;
        t["eopenreversedclosed"] = 0x025E;
        t["eopenreversedhook"] = 0x025D;
        t["eparen"] = 0x24A0;
        t["epsilon"] = 0x03B5;
        t["epsilontonos"] = 0x03AD;
        t["equal"] = 0x003D;
        t["equalmonospace"] = 0xFF1D;
        t["equalsmall"] = 0xFE66;
        t["equalsuperior"] = 0x207C;
        t["equivalence"] = 0x2261;
        t["erbopomofo"] = 0x3126;
        t["ercyrillic"] = 0x0440;
        t["ereversed"] = 0x0258;
        t["ereversedcyrillic"] = 0x044D;
        t["escyrillic"] = 0x0441;
        t["esdescendercyrillic"] = 0x04AB;
        t["esh"] = 0x0283;
        t["eshcurl"] = 0x0286;
        t["eshortdeva"] = 0x090E;
        t["eshortvowelsigndeva"] = 0x0946;
        t["eshreversedloop"] = 0x01AA;
        t["eshsquatreversed"] = 0x0285;
        t["esmallhiragana"] = 0x3047;
        t["esmallkatakana"] = 0x30A7;
        t["esmallkatakanahalfwidth"] = 0xFF6A;
        t["estimated"] = 0x212E;
        t["esuperior"] = 0xF6EC;
        t["eta"] = 0x03B7;
        t["etarmenian"] = 0x0568;
        t["etatonos"] = 0x03AE;
        t["eth"] = 0x00F0;
        t["etilde"] = 0x1EBD;
        t["etildebelow"] = 0x1E1B;
        t["etnahtafoukhhebrew"] = 0x0591;
        t["etnahtafoukhlefthebrew"] = 0x0591;
        t["etnahtahebrew"] = 0x0591;
        t["etnahtalefthebrew"] = 0x0591;
        t["eturned"] = 0x01DD;
        t["eukorean"] = 0x3161;
        t["euro"] = 0x20AC;
        t["evowelsignbengali"] = 0x09C7;
        t["evowelsigndeva"] = 0x0947;
        t["evowelsigngujarati"] = 0x0AC7;
        t["exclam"] = 0x0021;
        t["exclamarmenian"] = 0x055C;
        t["exclamdbl"] = 0x203C;
        t["exclamdown"] = 0x00A1;
        t["exclamdownsmall"] = 0xF7A1;
        t["exclammonospace"] = 0xFF01;
        t["exclamsmall"] = 0xF721;
        t["existential"] = 0x2203;
        t["ezh"] = 0x0292;
        t["ezhcaron"] = 0x01EF;
        t["ezhcurl"] = 0x0293;
        t["ezhreversed"] = 0x01B9;
        t["ezhtail"] = 0x01BA;
        t["f"] = 0x0066;
        t["fadeva"] = 0x095E;
        t["fagurmukhi"] = 0x0A5E;
        t["fahrenheit"] = 0x2109;
        t["fathaarabic"] = 0x064E;
        t["fathalowarabic"] = 0x064E;
        t["fathatanarabic"] = 0x064B;
        t["fbopomofo"] = 0x3108;
        t["fcircle"] = 0x24D5;
        t["fdotaccent"] = 0x1E1F;
        t["feharabic"] = 0x0641;
        t["feharmenian"] = 0x0586;
        t["fehfinalarabic"] = 0xFED2;
        t["fehinitialarabic"] = 0xFED3;
        t["fehmedialarabic"] = 0xFED4;
        t["feicoptic"] = 0x03E5;
        t["female"] = 0x2640;
        t["ff"] = 0xFB00;
        t["ffi"] = 0xFB03;
        t["ffl"] = 0xFB04;
        t["fi"] = 0xFB01;
        t["fifteencircle"] = 0x246E;
        t["fifteenparen"] = 0x2482;
        t["fifteenperiod"] = 0x2496;
        t["figuredash"] = 0x2012;
        t["filledbox"] = 0x25A0;
        t["filledrect"] = 0x25AC;
        t["finalkaf"] = 0x05DA;
        t["finalkafdagesh"] = 0xFB3A;
        t["finalkafdageshhebrew"] = 0xFB3A;
        t["finalkafhebrew"] = 0x05DA;
        t["finalmem"] = 0x05DD;
        t["finalmemhebrew"] = 0x05DD;
        t["finalnun"] = 0x05DF;
        t["finalnunhebrew"] = 0x05DF;
        t["finalpe"] = 0x05E3;
        t["finalpehebrew"] = 0x05E3;
        t["finaltsadi"] = 0x05E5;
        t["finaltsadihebrew"] = 0x05E5;
        t["firsttonechinese"] = 0x02C9;
        t["fisheye"] = 0x25C9;
        t["fitacyrillic"] = 0x0473;
        t["five"] = 0x0035;
        t["fivearabic"] = 0x0665;
        t["fivebengali"] = 0x09EB;
        t["fivecircle"] = 0x2464;
        t["fivecircleinversesansserif"] = 0x278E;
        t["fivedeva"] = 0x096B;
        t["fiveeighths"] = 0x215D;
        t["fivegujarati"] = 0x0AEB;
        t["fivegurmukhi"] = 0x0A6B;
        t["fivehackarabic"] = 0x0665;
        t["fivehangzhou"] = 0x3025;
        t["fiveideographicparen"] = 0x3224;
        t["fiveinferior"] = 0x2085;
        t["fivemonospace"] = 0xFF15;
        t["fiveoldstyle"] = 0xF735;
        t["fiveparen"] = 0x2478;
        t["fiveperiod"] = 0x248C;
        t["fivepersian"] = 0x06F5;
        t["fiveroman"] = 0x2174;
        t["fivesuperior"] = 0x2075;
        t["fivethai"] = 0x0E55;
        t["fl"] = 0xFB02;
        t["florin"] = 0x0192;
        t["fmonospace"] = 0xFF46;
        t["fmsquare"] = 0x3399;
        t["fofanthai"] = 0x0E1F;
        t["fofathai"] = 0x0E1D;
        t["fongmanthai"] = 0x0E4F;
        t["forall"] = 0x2200;
        t["four"] = 0x0034;
        t["fourarabic"] = 0x0664;
        t["fourbengali"] = 0x09EA;
        t["fourcircle"] = 0x2463;
        t["fourcircleinversesansserif"] = 0x278D;
        t["fourdeva"] = 0x096A;
        t["fourgujarati"] = 0x0AEA;
        t["fourgurmukhi"] = 0x0A6A;
        t["fourhackarabic"] = 0x0664;
        t["fourhangzhou"] = 0x3024;
        t["fourideographicparen"] = 0x3223;
        t["fourinferior"] = 0x2084;
        t["fourmonospace"] = 0xFF14;
        t["fournumeratorbengali"] = 0x09F7;
        t["fouroldstyle"] = 0xF734;
        t["fourparen"] = 0x2477;
        t["fourperiod"] = 0x248B;
        t["fourpersian"] = 0x06F4;
        t["fourroman"] = 0x2173;
        t["foursuperior"] = 0x2074;
        t["fourteencircle"] = 0x246D;
        t["fourteenparen"] = 0x2481;
        t["fourteenperiod"] = 0x2495;
        t["fourthai"] = 0x0E54;
        t["fourthtonechinese"] = 0x02CB;
        t["fparen"] = 0x24A1;
        t["fraction"] = 0x2044;
        t["franc"] = 0x20A3;
        t["g"] = 0x0067;
        t["gabengali"] = 0x0997;
        t["gacute"] = 0x01F5;
        t["gadeva"] = 0x0917;
        t["gafarabic"] = 0x06AF;
        t["gaffinalarabic"] = 0xFB93;
        t["gafinitialarabic"] = 0xFB94;
        t["gafmedialarabic"] = 0xFB95;
        t["gagujarati"] = 0x0A97;
        t["gagurmukhi"] = 0x0A17;
        t["gahiragana"] = 0x304C;
        t["gakatakana"] = 0x30AC;
        t["gamma"] = 0x03B3;
        t["gammalatinsmall"] = 0x0263;
        t["gammasuperior"] = 0x02E0;
        t["gangiacoptic"] = 0x03EB;
        t["gbopomofo"] = 0x310D;
        t["gbreve"] = 0x011F;
        t["gcaron"] = 0x01E7;
        t["gcedilla"] = 0x0123;
        t["gcircle"] = 0x24D6;
        t["gcircumflex"] = 0x011D;
        t["gcommaaccent"] = 0x0123;
        t["gdot"] = 0x0121;
        t["gdotaccent"] = 0x0121;
        t["gecyrillic"] = 0x0433;
        t["gehiragana"] = 0x3052;
        t["gekatakana"] = 0x30B2;
        t["geometricallyequal"] = 0x2251;
        t["gereshaccenthebrew"] = 0x059C;
        t["gereshhebrew"] = 0x05F3;
        t["gereshmuqdamhebrew"] = 0x059D;
        t["germandbls"] = 0x00DF;
        t["gershayimaccenthebrew"] = 0x059E;
        t["gershayimhebrew"] = 0x05F4;
        t["getamark"] = 0x3013;
        t["ghabengali"] = 0x0998;
        t["ghadarmenian"] = 0x0572;
        t["ghadeva"] = 0x0918;
        t["ghagujarati"] = 0x0A98;
        t["ghagurmukhi"] = 0x0A18;
        t["ghainarabic"] = 0x063A;
        t["ghainfinalarabic"] = 0xFECE;
        t["ghaininitialarabic"] = 0xFECF;
        t["ghainmedialarabic"] = 0xFED0;
        t["ghemiddlehookcyrillic"] = 0x0495;
        t["ghestrokecyrillic"] = 0x0493;
        t["gheupturncyrillic"] = 0x0491;
        t["ghhadeva"] = 0x095A;
        t["ghhagurmukhi"] = 0x0A5A;
        t["ghook"] = 0x0260;
        t["ghzsquare"] = 0x3393;
        t["gihiragana"] = 0x304E;
        t["gikatakana"] = 0x30AE;
        t["gimarmenian"] = 0x0563;
        t["gimel"] = 0x05D2;
        t["gimeldagesh"] = 0xFB32;
        t["gimeldageshhebrew"] = 0xFB32;
        t["gimelhebrew"] = 0x05D2;
        t["gjecyrillic"] = 0x0453;
        t["glottalinvertedstroke"] = 0x01BE;
        t["glottalstop"] = 0x0294;
        t["glottalstopinverted"] = 0x0296;
        t["glottalstopmod"] = 0x02C0;
        t["glottalstopreversed"] = 0x0295;
        t["glottalstopreversedmod"] = 0x02C1;
        t["glottalstopreversedsuperior"] = 0x02E4;
        t["glottalstopstroke"] = 0x02A1;
        t["glottalstopstrokereversed"] = 0x02A2;
        t["gmacron"] = 0x1E21;
        t["gmonospace"] = 0xFF47;
        t["gohiragana"] = 0x3054;
        t["gokatakana"] = 0x30B4;
        t["gparen"] = 0x24A2;
        t["gpasquare"] = 0x33AC;
        t["gradient"] = 0x2207;
        t["grave"] = 0x0060;
        t["gravebelowcmb"] = 0x0316;
        t["gravecmb"] = 0x0300;
        t["gravecomb"] = 0x0300;
        t["gravedeva"] = 0x0953;
        t["gravelowmod"] = 0x02CE;
        t["gravemonospace"] = 0xFF40;
        t["gravetonecmb"] = 0x0340;
        t["greater"] = 0x003E;
        t["greaterequal"] = 0x2265;
        t["greaterequalorless"] = 0x22DB;
        t["greatermonospace"] = 0xFF1E;
        t["greaterorequivalent"] = 0x2273;
        t["greaterorless"] = 0x2277;
        t["greateroverequal"] = 0x2267;
        t["greatersmall"] = 0xFE65;
        t["gscript"] = 0x0261;
        t["gstroke"] = 0x01E5;
        t["guhiragana"] = 0x3050;
        t["guillemotleft"] = 0x00AB;
        t["guillemotright"] = 0x00BB;
        t["guilsinglleft"] = 0x2039;
        t["guilsinglright"] = 0x203A;
        t["gukatakana"] = 0x30B0;
        t["guramusquare"] = 0x3318;
        t["gysquare"] = 0x33C9;
        t["h"] = 0x0068;
        t["haabkhasiancyrillic"] = 0x04A9;
        t["haaltonearabic"] = 0x06C1;
        t["habengali"] = 0x09B9;
        t["hadescendercyrillic"] = 0x04B3;
        t["hadeva"] = 0x0939;
        t["hagujarati"] = 0x0AB9;
        t["hagurmukhi"] = 0x0A39;
        t["haharabic"] = 0x062D;
        t["hahfinalarabic"] = 0xFEA2;
        t["hahinitialarabic"] = 0xFEA3;
        t["hahiragana"] = 0x306F;
        t["hahmedialarabic"] = 0xFEA4;
        t["haitusquare"] = 0x332A;
        t["hakatakana"] = 0x30CF;
        t["hakatakanahalfwidth"] = 0xFF8A;
        t["halantgurmukhi"] = 0x0A4D;
        t["hamzaarabic"] = 0x0621;
        t["hamzalowarabic"] = 0x0621;
        t["hangulfiller"] = 0x3164;
        t["hardsigncyrillic"] = 0x044A;
        t["harpoonleftbarbup"] = 0x21BC;
        t["harpoonrightbarbup"] = 0x21C0;
        t["hasquare"] = 0x33CA;
        t["hatafpatah"] = 0x05B2;
        t["hatafpatah16"] = 0x05B2;
        t["hatafpatah23"] = 0x05B2;
        t["hatafpatah2f"] = 0x05B2;
        t["hatafpatahhebrew"] = 0x05B2;
        t["hatafpatahnarrowhebrew"] = 0x05B2;
        t["hatafpatahquarterhebrew"] = 0x05B2;
        t["hatafpatahwidehebrew"] = 0x05B2;
        t["hatafqamats"] = 0x05B3;
        t["hatafqamats1b"] = 0x05B3;
        t["hatafqamats28"] = 0x05B3;
        t["hatafqamats34"] = 0x05B3;
        t["hatafqamatshebrew"] = 0x05B3;
        t["hatafqamatsnarrowhebrew"] = 0x05B3;
        t["hatafqamatsquarterhebrew"] = 0x05B3;
        t["hatafqamatswidehebrew"] = 0x05B3;
        t["hatafsegol"] = 0x05B1;
        t["hatafsegol17"] = 0x05B1;
        t["hatafsegol24"] = 0x05B1;
        t["hatafsegol30"] = 0x05B1;
        t["hatafsegolhebrew"] = 0x05B1;
        t["hatafsegolnarrowhebrew"] = 0x05B1;
        t["hatafsegolquarterhebrew"] = 0x05B1;
        t["hatafsegolwidehebrew"] = 0x05B1;
        t["hbar"] = 0x0127;
        t["hbopomofo"] = 0x310F;
        t["hbrevebelow"] = 0x1E2B;
        t["hcedilla"] = 0x1E29;
        t["hcircle"] = 0x24D7;
        t["hcircumflex"] = 0x0125;
        t["hdieresis"] = 0x1E27;
        t["hdotaccent"] = 0x1E23;
        t["hdotbelow"] = 0x1E25;
        t["he"] = 0x05D4;
        t["heart"] = 0x2665;
        t["heartsuitblack"] = 0x2665;
        t["heartsuitwhite"] = 0x2661;
        t["hedagesh"] = 0xFB34;
        t["hedageshhebrew"] = 0xFB34;
        t["hehaltonearabic"] = 0x06C1;
        t["heharabic"] = 0x0647;
        t["hehebrew"] = 0x05D4;
        t["hehfinalaltonearabic"] = 0xFBA7;
        t["hehfinalalttwoarabic"] = 0xFEEA;
        t["hehfinalarabic"] = 0xFEEA;
        t["hehhamzaabovefinalarabic"] = 0xFBA5;
        t["hehhamzaaboveisolatedarabic"] = 0xFBA4;
        t["hehinitialaltonearabic"] = 0xFBA8;
        t["hehinitialarabic"] = 0xFEEB;
        t["hehiragana"] = 0x3078;
        t["hehmedialaltonearabic"] = 0xFBA9;
        t["hehmedialarabic"] = 0xFEEC;
        t["heiseierasquare"] = 0x337B;
        t["hekatakana"] = 0x30D8;
        t["hekatakanahalfwidth"] = 0xFF8D;
        t["hekutaarusquare"] = 0x3336;
        t["henghook"] = 0x0267;
        t["herutusquare"] = 0x3339;
        t["het"] = 0x05D7;
        t["hethebrew"] = 0x05D7;
        t["hhook"] = 0x0266;
        t["hhooksuperior"] = 0x02B1;
        t["hieuhacirclekorean"] = 0x327B;
        t["hieuhaparenkorean"] = 0x321B;
        t["hieuhcirclekorean"] = 0x326D;
        t["hieuhkorean"] = 0x314E;
        t["hieuhparenkorean"] = 0x320D;
        t["hihiragana"] = 0x3072;
        t["hikatakana"] = 0x30D2;
        t["hikatakanahalfwidth"] = 0xFF8B;
        t["hiriq"] = 0x05B4;
        t["hiriq14"] = 0x05B4;
        t["hiriq21"] = 0x05B4;
        t["hiriq2d"] = 0x05B4;
        t["hiriqhebrew"] = 0x05B4;
        t["hiriqnarrowhebrew"] = 0x05B4;
        t["hiriqquarterhebrew"] = 0x05B4;
        t["hiriqwidehebrew"] = 0x05B4;
        t["hlinebelow"] = 0x1E96;
        t["hmonospace"] = 0xFF48;
        t["hoarmenian"] = 0x0570;
        t["hohipthai"] = 0x0E2B;
        t["hohiragana"] = 0x307B;
        t["hokatakana"] = 0x30DB;
        t["hokatakanahalfwidth"] = 0xFF8E;
        t["holam"] = 0x05B9;
        t["holam19"] = 0x05B9;
        t["holam26"] = 0x05B9;
        t["holam32"] = 0x05B9;
        t["holamhebrew"] = 0x05B9;
        t["holamnarrowhebrew"] = 0x05B9;
        t["holamquarterhebrew"] = 0x05B9;
        t["holamwidehebrew"] = 0x05B9;
        t["honokhukthai"] = 0x0E2E;
        t["hookabovecomb"] = 0x0309;
        t["hookcmb"] = 0x0309;
        t["hookpalatalizedbelowcmb"] = 0x0321;
        t["hookretroflexbelowcmb"] = 0x0322;
        t["hoonsquare"] = 0x3342;
        t["horicoptic"] = 0x03E9;
        t["horizontalbar"] = 0x2015;
        t["horncmb"] = 0x031B;
        t["hotsprings"] = 0x2668;
        t["house"] = 0x2302;
        t["hparen"] = 0x24A3;
        t["hsuperior"] = 0x02B0;
        t["hturned"] = 0x0265;
        t["huhiragana"] = 0x3075;
        t["huiitosquare"] = 0x3333;
        t["hukatakana"] = 0x30D5;
        t["hukatakanahalfwidth"] = 0xFF8C;
        t["hungarumlaut"] = 0x02DD;
        t["hungarumlautcmb"] = 0x030B;
        t["hv"] = 0x0195;
        t["hyphen"] = 0x002D;
        t["hypheninferior"] = 0xF6E5;
        t["hyphenmonospace"] = 0xFF0D;
        t["hyphensmall"] = 0xFE63;
        t["hyphensuperior"] = 0xF6E6;
        t["hyphentwo"] = 0x2010;
        t["i"] = 0x0069;
        t["iacute"] = 0x00ED;
        t["iacyrillic"] = 0x044F;
        t["ibengali"] = 0x0987;
        t["ibopomofo"] = 0x3127;
        t["ibreve"] = 0x012D;
        t["icaron"] = 0x01D0;
        t["icircle"] = 0x24D8;
        t["icircumflex"] = 0x00EE;
        t["icyrillic"] = 0x0456;
        t["idblgrave"] = 0x0209;
        t["ideographearthcircle"] = 0x328F;
        t["ideographfirecircle"] = 0x328B;
        t["ideographicallianceparen"] = 0x323F;
        t["ideographiccallparen"] = 0x323A;
        t["ideographiccentrecircle"] = 0x32A5;
        t["ideographicclose"] = 0x3006;
        t["ideographiccomma"] = 0x3001;
        t["ideographiccommaleft"] = 0xFF64;
        t["ideographiccongratulationparen"] = 0x3237;
        t["ideographiccorrectcircle"] = 0x32A3;
        t["ideographicearthparen"] = 0x322F;
        t["ideographicenterpriseparen"] = 0x323D;
        t["ideographicexcellentcircle"] = 0x329D;
        t["ideographicfestivalparen"] = 0x3240;
        t["ideographicfinancialcircle"] = 0x3296;
        t["ideographicfinancialparen"] = 0x3236;
        t["ideographicfireparen"] = 0x322B;
        t["ideographichaveparen"] = 0x3232;
        t["ideographichighcircle"] = 0x32A4;
        t["ideographiciterationmark"] = 0x3005;
        t["ideographiclaborcircle"] = 0x3298;
        t["ideographiclaborparen"] = 0x3238;
        t["ideographicleftcircle"] = 0x32A7;
        t["ideographiclowcircle"] = 0x32A6;
        t["ideographicmedicinecircle"] = 0x32A9;
        t["ideographicmetalparen"] = 0x322E;
        t["ideographicmoonparen"] = 0x322A;
        t["ideographicnameparen"] = 0x3234;
        t["ideographicperiod"] = 0x3002;
        t["ideographicprintcircle"] = 0x329E;
        t["ideographicreachparen"] = 0x3243;
        t["ideographicrepresentparen"] = 0x3239;
        t["ideographicresourceparen"] = 0x323E;
        t["ideographicrightcircle"] = 0x32A8;
        t["ideographicsecretcircle"] = 0x3299;
        t["ideographicselfparen"] = 0x3242;
        t["ideographicsocietyparen"] = 0x3233;
        t["ideographicspace"] = 0x3000;
        t["ideographicspecialparen"] = 0x3235;
        t["ideographicstockparen"] = 0x3231;
        t["ideographicstudyparen"] = 0x323B;
        t["ideographicsunparen"] = 0x3230;
        t["ideographicsuperviseparen"] = 0x323C;
        t["ideographicwaterparen"] = 0x322C;
        t["ideographicwoodparen"] = 0x322D;
        t["ideographiczero"] = 0x3007;
        t["ideographmetalcircle"] = 0x328E;
        t["ideographmooncircle"] = 0x328A;
        t["ideographnamecircle"] = 0x3294;
        t["ideographsuncircle"] = 0x3290;
        t["ideographwatercircle"] = 0x328C;
        t["ideographwoodcircle"] = 0x328D;
        t["ideva"] = 0x0907;
        t["idieresis"] = 0x00EF;
        t["idieresisacute"] = 0x1E2F;
        t["idieresiscyrillic"] = 0x04E5;
        t["idotbelow"] = 0x1ECB;
        t["iebrevecyrillic"] = 0x04D7;
        t["iecyrillic"] = 0x0435;
        t["ieungacirclekorean"] = 0x3275;
        t["ieungaparenkorean"] = 0x3215;
        t["ieungcirclekorean"] = 0x3267;
        t["ieungkorean"] = 0x3147;
        t["ieungparenkorean"] = 0x3207;
        t["igrave"] = 0x00EC;
        t["igujarati"] = 0x0A87;
        t["igurmukhi"] = 0x0A07;
        t["ihiragana"] = 0x3044;
        t["ihookabove"] = 0x1EC9;
        t["iibengali"] = 0x0988;
        t["iicyrillic"] = 0x0438;
        t["iideva"] = 0x0908;
        t["iigujarati"] = 0x0A88;
        t["iigurmukhi"] = 0x0A08;
        t["iimatragurmukhi"] = 0x0A40;
        t["iinvertedbreve"] = 0x020B;
        t["iishortcyrillic"] = 0x0439;
        t["iivowelsignbengali"] = 0x09C0;
        t["iivowelsigndeva"] = 0x0940;
        t["iivowelsigngujarati"] = 0x0AC0;
        t["ij"] = 0x0133;
        t["ikatakana"] = 0x30A4;
        t["ikatakanahalfwidth"] = 0xFF72;
        t["ikorean"] = 0x3163;
        t["ilde"] = 0x02DC;
        t["iluyhebrew"] = 0x05AC;
        t["imacron"] = 0x012B;
        t["imacroncyrillic"] = 0x04E3;
        t["imageorapproximatelyequal"] = 0x2253;
        t["imatragurmukhi"] = 0x0A3F;
        t["imonospace"] = 0xFF49;
        t["increment"] = 0x2206;
        t["infinity"] = 0x221E;
        t["iniarmenian"] = 0x056B;
        t["integral"] = 0x222B;
        t["integralbottom"] = 0x2321;
        t["integralbt"] = 0x2321;
        t["integralex"] = 0xF8F5;
        t["integraltop"] = 0x2320;
        t["integraltp"] = 0x2320;
        t["intersection"] = 0x2229;
        t["intisquare"] = 0x3305;
        t["invbullet"] = 0x25D8;
        t["invcircle"] = 0x25D9;
        t["invsmileface"] = 0x263B;
        t["iocyrillic"] = 0x0451;
        t["iogonek"] = 0x012F;
        t["iota"] = 0x03B9;
        t["iotadieresis"] = 0x03CA;
        t["iotadieresistonos"] = 0x0390;
        t["iotalatin"] = 0x0269;
        t["iotatonos"] = 0x03AF;
        t["iparen"] = 0x24A4;
        t["irigurmukhi"] = 0x0A72;
        t["ismallhiragana"] = 0x3043;
        t["ismallkatakana"] = 0x30A3;
        t["ismallkatakanahalfwidth"] = 0xFF68;
        t["issharbengali"] = 0x09FA;
        t["istroke"] = 0x0268;
        t["isuperior"] = 0xF6ED;
        t["iterationhiragana"] = 0x309D;
        t["iterationkatakana"] = 0x30FD;
        t["itilde"] = 0x0129;
        t["itildebelow"] = 0x1E2D;
        t["iubopomofo"] = 0x3129;
        t["iucyrillic"] = 0x044E;
        t["ivowelsignbengali"] = 0x09BF;
        t["ivowelsigndeva"] = 0x093F;
        t["ivowelsigngujarati"] = 0x0ABF;
        t["izhitsacyrillic"] = 0x0475;
        t["izhitsadblgravecyrillic"] = 0x0477;
        t["j"] = 0x006A;
        t["jaarmenian"] = 0x0571;
        t["jabengali"] = 0x099C;
        t["jadeva"] = 0x091C;
        t["jagujarati"] = 0x0A9C;
        t["jagurmukhi"] = 0x0A1C;
        t["jbopomofo"] = 0x3110;
        t["jcaron"] = 0x01F0;
        t["jcircle"] = 0x24D9;
        t["jcircumflex"] = 0x0135;
        t["jcrossedtail"] = 0x029D;
        t["jdotlessstroke"] = 0x025F;
        t["jecyrillic"] = 0x0458;
        t["jeemarabic"] = 0x062C;
        t["jeemfinalarabic"] = 0xFE9E;
        t["jeeminitialarabic"] = 0xFE9F;
        t["jeemmedialarabic"] = 0xFEA0;
        t["jeharabic"] = 0x0698;
        t["jehfinalarabic"] = 0xFB8B;
        t["jhabengali"] = 0x099D;
        t["jhadeva"] = 0x091D;
        t["jhagujarati"] = 0x0A9D;
        t["jhagurmukhi"] = 0x0A1D;
        t["jheharmenian"] = 0x057B;
        t["jis"] = 0x3004;
        t["jmonospace"] = 0xFF4A;
        t["jparen"] = 0x24A5;
        t["jsuperior"] = 0x02B2;
        t["k"] = 0x006B;
        t["kabashkircyrillic"] = 0x04A1;
        t["kabengali"] = 0x0995;
        t["kacute"] = 0x1E31;
        t["kacyrillic"] = 0x043A;
        t["kadescendercyrillic"] = 0x049B;
        t["kadeva"] = 0x0915;
        t["kaf"] = 0x05DB;
        t["kafarabic"] = 0x0643;
        t["kafdagesh"] = 0xFB3B;
        t["kafdageshhebrew"] = 0xFB3B;
        t["kaffinalarabic"] = 0xFEDA;
        t["kafhebrew"] = 0x05DB;
        t["kafinitialarabic"] = 0xFEDB;
        t["kafmedialarabic"] = 0xFEDC;
        t["kafrafehebrew"] = 0xFB4D;
        t["kagujarati"] = 0x0A95;
        t["kagurmukhi"] = 0x0A15;
        t["kahiragana"] = 0x304B;
        t["kahookcyrillic"] = 0x04C4;
        t["kakatakana"] = 0x30AB;
        t["kakatakanahalfwidth"] = 0xFF76;
        t["kappa"] = 0x03BA;
        t["kappasymbolgreek"] = 0x03F0;
        t["kapyeounmieumkorean"] = 0x3171;
        t["kapyeounphieuphkorean"] = 0x3184;
        t["kapyeounpieupkorean"] = 0x3178;
        t["kapyeounssangpieupkorean"] = 0x3179;
        t["karoriisquare"] = 0x330D;
        t["kashidaautoarabic"] = 0x0640;
        t["kashidaautonosidebearingarabic"] = 0x0640;
        t["kasmallkatakana"] = 0x30F5;
        t["kasquare"] = 0x3384;
        t["kasraarabic"] = 0x0650;
        t["kasratanarabic"] = 0x064D;
        t["kastrokecyrillic"] = 0x049F;
        t["katahiraprolongmarkhalfwidth"] = 0xFF70;
        t["kaverticalstrokecyrillic"] = 0x049D;
        t["kbopomofo"] = 0x310E;
        t["kcalsquare"] = 0x3389;
        t["kcaron"] = 0x01E9;
        t["kcedilla"] = 0x0137;
        t["kcircle"] = 0x24DA;
        t["kcommaaccent"] = 0x0137;
        t["kdotbelow"] = 0x1E33;
        t["keharmenian"] = 0x0584;
        t["kehiragana"] = 0x3051;
        t["kekatakana"] = 0x30B1;
        t["kekatakanahalfwidth"] = 0xFF79;
        t["kenarmenian"] = 0x056F;
        t["kesmallkatakana"] = 0x30F6;
        t["kgreenlandic"] = 0x0138;
        t["khabengali"] = 0x0996;
        t["khacyrillic"] = 0x0445;
        t["khadeva"] = 0x0916;
        t["khagujarati"] = 0x0A96;
        t["khagurmukhi"] = 0x0A16;
        t["khaharabic"] = 0x062E;
        t["khahfinalarabic"] = 0xFEA6;
        t["khahinitialarabic"] = 0xFEA7;
        t["khahmedialarabic"] = 0xFEA8;
        t["kheicoptic"] = 0x03E7;
        t["khhadeva"] = 0x0959;
        t["khhagurmukhi"] = 0x0A59;
        t["khieukhacirclekorean"] = 0x3278;
        t["khieukhaparenkorean"] = 0x3218;
        t["khieukhcirclekorean"] = 0x326A;
        t["khieukhkorean"] = 0x314B;
        t["khieukhparenkorean"] = 0x320A;
        t["khokhaithai"] = 0x0E02;
        t["khokhonthai"] = 0x0E05;
        t["khokhuatthai"] = 0x0E03;
        t["khokhwaithai"] = 0x0E04;
        t["khomutthai"] = 0x0E5B;
        t["khook"] = 0x0199;
        t["khorakhangthai"] = 0x0E06;
        t["khzsquare"] = 0x3391;
        t["kihiragana"] = 0x304D;
        t["kikatakana"] = 0x30AD;
        t["kikatakanahalfwidth"] = 0xFF77;
        t["kiroguramusquare"] = 0x3315;
        t["kiromeetorusquare"] = 0x3316;
        t["kirosquare"] = 0x3314;
        t["kiyeokacirclekorean"] = 0x326E;
        t["kiyeokaparenkorean"] = 0x320E;
        t["kiyeokcirclekorean"] = 0x3260;
        t["kiyeokkorean"] = 0x3131;
        t["kiyeokparenkorean"] = 0x3200;
        t["kiyeoksioskorean"] = 0x3133;
        t["kjecyrillic"] = 0x045C;
        t["klinebelow"] = 0x1E35;
        t["klsquare"] = 0x3398;
        t["kmcubedsquare"] = 0x33A6;
        t["kmonospace"] = 0xFF4B;
        t["kmsquaredsquare"] = 0x33A2;
        t["kohiragana"] = 0x3053;
        t["kohmsquare"] = 0x33C0;
        t["kokaithai"] = 0x0E01;
        t["kokatakana"] = 0x30B3;
        t["kokatakanahalfwidth"] = 0xFF7A;
        t["kooposquare"] = 0x331E;
        t["koppacyrillic"] = 0x0481;
        t["koreanstandardsymbol"] = 0x327F;
        t["koroniscmb"] = 0x0343;
        t["kparen"] = 0x24A6;
        t["kpasquare"] = 0x33AA;
        t["ksicyrillic"] = 0x046F;
        t["ktsquare"] = 0x33CF;
        t["kturned"] = 0x029E;
        t["kuhiragana"] = 0x304F;
        t["kukatakana"] = 0x30AF;
        t["kukatakanahalfwidth"] = 0xFF78;
        t["kvsquare"] = 0x33B8;
        t["kwsquare"] = 0x33BE;
        t["l"] = 0x006C;
        t["labengali"] = 0x09B2;
        t["lacute"] = 0x013A;
        t["ladeva"] = 0x0932;
        t["lagujarati"] = 0x0AB2;
        t["lagurmukhi"] = 0x0A32;
        t["lakkhangyaothai"] = 0x0E45;
        t["lamaleffinalarabic"] = 0xFEFC;
        t["lamalefhamzaabovefinalarabic"] = 0xFEF8;
        t["lamalefhamzaaboveisolatedarabic"] = 0xFEF7;
        t["lamalefhamzabelowfinalarabic"] = 0xFEFA;
        t["lamalefhamzabelowisolatedarabic"] = 0xFEF9;
        t["lamalefisolatedarabic"] = 0xFEFB;
        t["lamalefmaddaabovefinalarabic"] = 0xFEF6;
        t["lamalefmaddaaboveisolatedarabic"] = 0xFEF5;
        t["lamarabic"] = 0x0644;
        t["lambda"] = 0x03BB;
        t["lambdastroke"] = 0x019B;
        t["lamed"] = 0x05DC;
        t["lameddagesh"] = 0xFB3C;
        t["lameddageshhebrew"] = 0xFB3C;
        t["lamedhebrew"] = 0x05DC;
        t["lamfinalarabic"] = 0xFEDE;
        t["lamhahinitialarabic"] = 0xFCCA;
        t["laminitialarabic"] = 0xFEDF;
        t["lamjeeminitialarabic"] = 0xFCC9;
        t["lamkhahinitialarabic"] = 0xFCCB;
        t["lamlamhehisolatedarabic"] = 0xFDF2;
        t["lammedialarabic"] = 0xFEE0;
        t["lammeemhahinitialarabic"] = 0xFD88;
        t["lammeeminitialarabic"] = 0xFCCC;
        t["largecircle"] = 0x25EF;
        t["lbar"] = 0x019A;
        t["lbelt"] = 0x026C;
        t["lbopomofo"] = 0x310C;
        t["lcaron"] = 0x013E;
        t["lcedilla"] = 0x013C;
        t["lcircle"] = 0x24DB;
        t["lcircumflexbelow"] = 0x1E3D;
        t["lcommaaccent"] = 0x013C;
        t["ldot"] = 0x0140;
        t["ldotaccent"] = 0x0140;
        t["ldotbelow"] = 0x1E37;
        t["ldotbelowmacron"] = 0x1E39;
        t["leftangleabovecmb"] = 0x031A;
        t["lefttackbelowcmb"] = 0x0318;
        t["less"] = 0x003C;
        t["lessequal"] = 0x2264;
        t["lessequalorgreater"] = 0x22DA;
        t["lessmonospace"] = 0xFF1C;
        t["lessorequivalent"] = 0x2272;
        t["lessorgreater"] = 0x2276;
        t["lessoverequal"] = 0x2266;
        t["lesssmall"] = 0xFE64;
        t["lezh"] = 0x026E;
        t["lfblock"] = 0x258C;
        t["lhookretroflex"] = 0x026D;
        t["lira"] = 0x20A4;
        t["liwnarmenian"] = 0x056C;
        t["lj"] = 0x01C9;
        t["ljecyrillic"] = 0x0459;
        t["ll"] = 0xF6C0;
        t["lladeva"] = 0x0933;
        t["llagujarati"] = 0x0AB3;
        t["llinebelow"] = 0x1E3B;
        t["llladeva"] = 0x0934;
        t["llvocalicbengali"] = 0x09E1;
        t["llvocalicdeva"] = 0x0961;
        t["llvocalicvowelsignbengali"] = 0x09E3;
        t["llvocalicvowelsigndeva"] = 0x0963;
        t["lmiddletilde"] = 0x026B;
        t["lmonospace"] = 0xFF4C;
        t["lmsquare"] = 0x33D0;
        t["lochulathai"] = 0x0E2C;
        t["logicaland"] = 0x2227;
        t["logicalnot"] = 0x00AC;
        t["logicalnotreversed"] = 0x2310;
        t["logicalor"] = 0x2228;
        t["lolingthai"] = 0x0E25;
        t["longs"] = 0x017F;
        t["lowlinecenterline"] = 0xFE4E;
        t["lowlinecmb"] = 0x0332;
        t["lowlinedashed"] = 0xFE4D;
        t["lozenge"] = 0x25CA;
        t["lparen"] = 0x24A7;
        t["lslash"] = 0x0142;
        t["lsquare"] = 0x2113;
        t["lsuperior"] = 0xF6EE;
        t["ltshade"] = 0x2591;
        t["luthai"] = 0x0E26;
        t["lvocalicbengali"] = 0x098C;
        t["lvocalicdeva"] = 0x090C;
        t["lvocalicvowelsignbengali"] = 0x09E2;
        t["lvocalicvowelsigndeva"] = 0x0962;
        t["lxsquare"] = 0x33D3;
        t["m"] = 0x006D;
        t["mabengali"] = 0x09AE;
        t["macron"] = 0x00AF;
        t["macronbelowcmb"] = 0x0331;
        t["macroncmb"] = 0x0304;
        t["macronlowmod"] = 0x02CD;
        t["macronmonospace"] = 0xFFE3;
        t["macute"] = 0x1E3F;
        t["madeva"] = 0x092E;
        t["magujarati"] = 0x0AAE;
        t["magurmukhi"] = 0x0A2E;
        t["mahapakhhebrew"] = 0x05A4;
        t["mahapakhlefthebrew"] = 0x05A4;
        t["mahiragana"] = 0x307E;
        t["maichattawalowleftthai"] = 0xF895;
        t["maichattawalowrightthai"] = 0xF894;
        t["maichattawathai"] = 0x0E4B;
        t["maichattawaupperleftthai"] = 0xF893;
        t["maieklowleftthai"] = 0xF88C;
        t["maieklowrightthai"] = 0xF88B;
        t["maiekthai"] = 0x0E48;
        t["maiekupperleftthai"] = 0xF88A;
        t["maihanakatleftthai"] = 0xF884;
        t["maihanakatthai"] = 0x0E31;
        t["maitaikhuleftthai"] = 0xF889;
        t["maitaikhuthai"] = 0x0E47;
        t["maitholowleftthai"] = 0xF88F;
        t["maitholowrightthai"] = 0xF88E;
        t["maithothai"] = 0x0E49;
        t["maithoupperleftthai"] = 0xF88D;
        t["maitrilowleftthai"] = 0xF892;
        t["maitrilowrightthai"] = 0xF891;
        t["maitrithai"] = 0x0E4A;
        t["maitriupperleftthai"] = 0xF890;
        t["maiyamokthai"] = 0x0E46;
        t["makatakana"] = 0x30DE;
        t["makatakanahalfwidth"] = 0xFF8F;
        t["male"] = 0x2642;
        t["mansyonsquare"] = 0x3347;
        t["maqafhebrew"] = 0x05BE;
        t["mars"] = 0x2642;
        t["masoracirclehebrew"] = 0x05AF;
        t["masquare"] = 0x3383;
        t["mbopomofo"] = 0x3107;
        t["mbsquare"] = 0x33D4;
        t["mcircle"] = 0x24DC;
        t["mcubedsquare"] = 0x33A5;
        t["mdotaccent"] = 0x1E41;
        t["mdotbelow"] = 0x1E43;
        t["meemarabic"] = 0x0645;
        t["meemfinalarabic"] = 0xFEE2;
        t["meeminitialarabic"] = 0xFEE3;
        t["meemmedialarabic"] = 0xFEE4;
        t["meemmeeminitialarabic"] = 0xFCD1;
        t["meemmeemisolatedarabic"] = 0xFC48;
        t["meetorusquare"] = 0x334D;
        t["mehiragana"] = 0x3081;
        t["meizierasquare"] = 0x337E;
        t["mekatakana"] = 0x30E1;
        t["mekatakanahalfwidth"] = 0xFF92;
        t["mem"] = 0x05DE;
        t["memdagesh"] = 0xFB3E;
        t["memdageshhebrew"] = 0xFB3E;
        t["memhebrew"] = 0x05DE;
        t["menarmenian"] = 0x0574;
        t["merkhahebrew"] = 0x05A5;
        t["merkhakefulahebrew"] = 0x05A6;
        t["merkhakefulalefthebrew"] = 0x05A6;
        t["merkhalefthebrew"] = 0x05A5;
        t["mhook"] = 0x0271;
        t["mhzsquare"] = 0x3392;
        t["middledotkatakanahalfwidth"] = 0xFF65;
        t["middot"] = 0x00B7;
        t["mieumacirclekorean"] = 0x3272;
        t["mieumaparenkorean"] = 0x3212;
        t["mieumcirclekorean"] = 0x3264;
        t["mieumkorean"] = 0x3141;
        t["mieumpansioskorean"] = 0x3170;
        t["mieumparenkorean"] = 0x3204;
        t["mieumpieupkorean"] = 0x316E;
        t["mieumsioskorean"] = 0x316F;
        t["mihiragana"] = 0x307F;
        t["mikatakana"] = 0x30DF;
        t["mikatakanahalfwidth"] = 0xFF90;
        t["minus"] = 0x2212;
        t["minusbelowcmb"] = 0x0320;
        t["minuscircle"] = 0x2296;
        t["minusmod"] = 0x02D7;
        t["minusplus"] = 0x2213;
        t["minute"] = 0x2032;
        t["miribaarusquare"] = 0x334A;
        t["mirisquare"] = 0x3349;
        t["mlonglegturned"] = 0x0270;
        t["mlsquare"] = 0x3396;
        t["mmcubedsquare"] = 0x33A3;
        t["mmonospace"] = 0xFF4D;
        t["mmsquaredsquare"] = 0x339F;
        t["mohiragana"] = 0x3082;
        t["mohmsquare"] = 0x33C1;
        t["mokatakana"] = 0x30E2;
        t["mokatakanahalfwidth"] = 0xFF93;
        t["molsquare"] = 0x33D6;
        t["momathai"] = 0x0E21;
        t["moverssquare"] = 0x33A7;
        t["moverssquaredsquare"] = 0x33A8;
        t["mparen"] = 0x24A8;
        t["mpasquare"] = 0x33AB;
        t["mssquare"] = 0x33B3;
        t["msuperior"] = 0xF6EF;
        t["mturned"] = 0x026F;
        t["mu"] = 0x00B5;
        t["mu1"] = 0x00B5;
        t["muasquare"] = 0x3382;
        t["muchgreater"] = 0x226B;
        t["muchless"] = 0x226A;
        t["mufsquare"] = 0x338C;
        t["mugreek"] = 0x03BC;
        t["mugsquare"] = 0x338D;
        t["muhiragana"] = 0x3080;
        t["mukatakana"] = 0x30E0;
        t["mukatakanahalfwidth"] = 0xFF91;
        t["mulsquare"] = 0x3395;
        t["multiply"] = 0x00D7;
        t["mumsquare"] = 0x339B;
        t["munahhebrew"] = 0x05A3;
        t["munahlefthebrew"] = 0x05A3;
        t["musicalnote"] = 0x266A;
        t["musicalnotedbl"] = 0x266B;
        t["musicflatsign"] = 0x266D;
        t["musicsharpsign"] = 0x266F;
        t["mussquare"] = 0x33B2;
        t["muvsquare"] = 0x33B6;
        t["muwsquare"] = 0x33BC;
        t["mvmegasquare"] = 0x33B9;
        t["mvsquare"] = 0x33B7;
        t["mwmegasquare"] = 0x33BF;
        t["mwsquare"] = 0x33BD;
        t["n"] = 0x006E;
        t["nabengali"] = 0x09A8;
        t["nabla"] = 0x2207;
        t["nacute"] = 0x0144;
        t["nadeva"] = 0x0928;
        t["nagujarati"] = 0x0AA8;
        t["nagurmukhi"] = 0x0A28;
        t["nahiragana"] = 0x306A;
        t["nakatakana"] = 0x30CA;
        t["nakatakanahalfwidth"] = 0xFF85;
        t["napostrophe"] = 0x0149;
        t["nasquare"] = 0x3381;
        t["nbopomofo"] = 0x310B;
        t["nbspace"] = 0x00A0;
        t["ncaron"] = 0x0148;
        t["ncedilla"] = 0x0146;
        t["ncircle"] = 0x24DD;
        t["ncircumflexbelow"] = 0x1E4B;
        t["ncommaaccent"] = 0x0146;
        t["ndotaccent"] = 0x1E45;
        t["ndotbelow"] = 0x1E47;
        t["nehiragana"] = 0x306D;
        t["nekatakana"] = 0x30CD;
        t["nekatakanahalfwidth"] = 0xFF88;
        t["newsheqelsign"] = 0x20AA;
        t["nfsquare"] = 0x338B;
        t["ngabengali"] = 0x0999;
        t["ngadeva"] = 0x0919;
        t["ngagujarati"] = 0x0A99;
        t["ngagurmukhi"] = 0x0A19;
        t["ngonguthai"] = 0x0E07;
        t["nhiragana"] = 0x3093;
        t["nhookleft"] = 0x0272;
        t["nhookretroflex"] = 0x0273;
        t["nieunacirclekorean"] = 0x326F;
        t["nieunaparenkorean"] = 0x320F;
        t["nieuncieuckorean"] = 0x3135;
        t["nieuncirclekorean"] = 0x3261;
        t["nieunhieuhkorean"] = 0x3136;
        t["nieunkorean"] = 0x3134;
        t["nieunpansioskorean"] = 0x3168;
        t["nieunparenkorean"] = 0x3201;
        t["nieunsioskorean"] = 0x3167;
        t["nieuntikeutkorean"] = 0x3166;
        t["nihiragana"] = 0x306B;
        t["nikatakana"] = 0x30CB;
        t["nikatakanahalfwidth"] = 0xFF86;
        t["nikhahitleftthai"] = 0xF899;
        t["nikhahitthai"] = 0x0E4D;
        t["nine"] = 0x0039;
        t["ninearabic"] = 0x0669;
        t["ninebengali"] = 0x09EF;
        t["ninecircle"] = 0x2468;
        t["ninecircleinversesansserif"] = 0x2792;
        t["ninedeva"] = 0x096F;
        t["ninegujarati"] = 0x0AEF;
        t["ninegurmukhi"] = 0x0A6F;
        t["ninehackarabic"] = 0x0669;
        t["ninehangzhou"] = 0x3029;
        t["nineideographicparen"] = 0x3228;
        t["nineinferior"] = 0x2089;
        t["ninemonospace"] = 0xFF19;
        t["nineoldstyle"] = 0xF739;
        t["nineparen"] = 0x247C;
        t["nineperiod"] = 0x2490;
        t["ninepersian"] = 0x06F9;
        t["nineroman"] = 0x2178;
        t["ninesuperior"] = 0x2079;
        t["nineteencircle"] = 0x2472;
        t["nineteenparen"] = 0x2486;
        t["nineteenperiod"] = 0x249A;
        t["ninethai"] = 0x0E59;
        t["nj"] = 0x01CC;
        t["njecyrillic"] = 0x045A;
        t["nkatakana"] = 0x30F3;
        t["nkatakanahalfwidth"] = 0xFF9D;
        t["nlegrightlong"] = 0x019E;
        t["nlinebelow"] = 0x1E49;
        t["nmonospace"] = 0xFF4E;
        t["nmsquare"] = 0x339A;
        t["nnabengali"] = 0x09A3;
        t["nnadeva"] = 0x0923;
        t["nnagujarati"] = 0x0AA3;
        t["nnagurmukhi"] = 0x0A23;
        t["nnnadeva"] = 0x0929;
        t["nohiragana"] = 0x306E;
        t["nokatakana"] = 0x30CE;
        t["nokatakanahalfwidth"] = 0xFF89;
        t["nonbreakingspace"] = 0x00A0;
        t["nonenthai"] = 0x0E13;
        t["nonuthai"] = 0x0E19;
        t["noonarabic"] = 0x0646;
        t["noonfinalarabic"] = 0xFEE6;
        t["noonghunnaarabic"] = 0x06BA;
        t["noonghunnafinalarabic"] = 0xFB9F;
        t["nooninitialarabic"] = 0xFEE7;
        t["noonjeeminitialarabic"] = 0xFCD2;
        t["noonjeemisolatedarabic"] = 0xFC4B;
        t["noonmedialarabic"] = 0xFEE8;
        t["noonmeeminitialarabic"] = 0xFCD5;
        t["noonmeemisolatedarabic"] = 0xFC4E;
        t["noonnoonfinalarabic"] = 0xFC8D;
        t["notcontains"] = 0x220C;
        t["notelement"] = 0x2209;
        t["notelementof"] = 0x2209;
        t["notequal"] = 0x2260;
        t["notgreater"] = 0x226F;
        t["notgreaternorequal"] = 0x2271;
        t["notgreaternorless"] = 0x2279;
        t["notidentical"] = 0x2262;
        t["notless"] = 0x226E;
        t["notlessnorequal"] = 0x2270;
        t["notparallel"] = 0x2226;
        t["notprecedes"] = 0x2280;
        t["notsubset"] = 0x2284;
        t["notsucceeds"] = 0x2281;
        t["notsuperset"] = 0x2285;
        t["nowarmenian"] = 0x0576;
        t["nparen"] = 0x24A9;
        t["nssquare"] = 0x33B1;
        t["nsuperior"] = 0x207F;
        t["ntilde"] = 0x00F1;
        t["nu"] = 0x03BD;
        t["nuhiragana"] = 0x306C;
        t["nukatakana"] = 0x30CC;
        t["nukatakanahalfwidth"] = 0xFF87;
        t["nuktabengali"] = 0x09BC;
        t["nuktadeva"] = 0x093C;
        t["nuktagujarati"] = 0x0ABC;
        t["nuktagurmukhi"] = 0x0A3C;
        t["numbersign"] = 0x0023;
        t["numbersignmonospace"] = 0xFF03;
        t["numbersignsmall"] = 0xFE5F;
        t["numeralsigngreek"] = 0x0374;
        t["numeralsignlowergreek"] = 0x0375;
        t["numero"] = 0x2116;
        t["nun"] = 0x05E0;
        t["nundagesh"] = 0xFB40;
        t["nundageshhebrew"] = 0xFB40;
        t["nunhebrew"] = 0x05E0;
        t["nvsquare"] = 0x33B5;
        t["nwsquare"] = 0x33BB;
        t["nyabengali"] = 0x099E;
        t["nyadeva"] = 0x091E;
        t["nyagujarati"] = 0x0A9E;
        t["nyagurmukhi"] = 0x0A1E;
        t["o"] = 0x006F;
        t["oacute"] = 0x00F3;
        t["oangthai"] = 0x0E2D;
        t["obarred"] = 0x0275;
        t["obarredcyrillic"] = 0x04E9;
        t["obarreddieresiscyrillic"] = 0x04EB;
        t["obengali"] = 0x0993;
        t["obopomofo"] = 0x311B;
        t["obreve"] = 0x014F;
        t["ocandradeva"] = 0x0911;
        t["ocandragujarati"] = 0x0A91;
        t["ocandravowelsigndeva"] = 0x0949;
        t["ocandravowelsigngujarati"] = 0x0AC9;
        t["ocaron"] = 0x01D2;
        t["ocircle"] = 0x24DE;
        t["ocircumflex"] = 0x00F4;
        t["ocircumflexacute"] = 0x1ED1;
        t["ocircumflexdotbelow"] = 0x1ED9;
        t["ocircumflexgrave"] = 0x1ED3;
        t["ocircumflexhookabove"] = 0x1ED5;
        t["ocircumflextilde"] = 0x1ED7;
        t["ocyrillic"] = 0x043E;
        t["odblacute"] = 0x0151;
        t["odblgrave"] = 0x020D;
        t["odeva"] = 0x0913;
        t["odieresis"] = 0x00F6;
        t["odieresiscyrillic"] = 0x04E7;
        t["odotbelow"] = 0x1ECD;
        t["oe"] = 0x0153;
        t["oekorean"] = 0x315A;
        t["ogonek"] = 0x02DB;
        t["ogonekcmb"] = 0x0328;
        t["ograve"] = 0x00F2;
        t["ogujarati"] = 0x0A93;
        t["oharmenian"] = 0x0585;
        t["ohiragana"] = 0x304A;
        t["ohookabove"] = 0x1ECF;
        t["ohorn"] = 0x01A1;
        t["ohornacute"] = 0x1EDB;
        t["ohorndotbelow"] = 0x1EE3;
        t["ohorngrave"] = 0x1EDD;
        t["ohornhookabove"] = 0x1EDF;
        t["ohorntilde"] = 0x1EE1;
        t["ohungarumlaut"] = 0x0151;
        t["oi"] = 0x01A3;
        t["oinvertedbreve"] = 0x020F;
        t["okatakana"] = 0x30AA;
        t["okatakanahalfwidth"] = 0xFF75;
        t["okorean"] = 0x3157;
        t["olehebrew"] = 0x05AB;
        t["omacron"] = 0x014D;
        t["omacronacute"] = 0x1E53;
        t["omacrongrave"] = 0x1E51;
        t["omdeva"] = 0x0950;
        t["omega"] = 0x03C9;
        t["omega1"] = 0x03D6;
        t["omegacyrillic"] = 0x0461;
        t["omegalatinclosed"] = 0x0277;
        t["omegaroundcyrillic"] = 0x047B;
        t["omegatitlocyrillic"] = 0x047D;
        t["omegatonos"] = 0x03CE;
        t["omgujarati"] = 0x0AD0;
        t["omicron"] = 0x03BF;
        t["omicrontonos"] = 0x03CC;
        t["omonospace"] = 0xFF4F;
        t["one"] = 0x0031;
        t["onearabic"] = 0x0661;
        t["onebengali"] = 0x09E7;
        t["onecircle"] = 0x2460;
        t["onecircleinversesansserif"] = 0x278A;
        t["onedeva"] = 0x0967;
        t["onedotenleader"] = 0x2024;
        t["oneeighth"] = 0x215B;
        t["onefitted"] = 0xF6DC;
        t["onegujarati"] = 0x0AE7;
        t["onegurmukhi"] = 0x0A67;
        t["onehackarabic"] = 0x0661;
        t["onehalf"] = 0x00BD;
        t["onehangzhou"] = 0x3021;
        t["oneideographicparen"] = 0x3220;
        t["oneinferior"] = 0x2081;
        t["onemonospace"] = 0xFF11;
        t["onenumeratorbengali"] = 0x09F4;
        t["oneoldstyle"] = 0xF731;
        t["oneparen"] = 0x2474;
        t["oneperiod"] = 0x2488;
        t["onepersian"] = 0x06F1;
        t["onequarter"] = 0x00BC;
        t["oneroman"] = 0x2170;
        t["onesuperior"] = 0x00B9;
        t["onethai"] = 0x0E51;
        t["onethird"] = 0x2153;
        t["oogonek"] = 0x01EB;
        t["oogonekmacron"] = 0x01ED;
        t["oogurmukhi"] = 0x0A13;
        t["oomatragurmukhi"] = 0x0A4B;
        t["oopen"] = 0x0254;
        t["oparen"] = 0x24AA;
        t["openbullet"] = 0x25E6;
        t["option"] = 0x2325;
        t["ordfeminine"] = 0x00AA;
        t["ordmasculine"] = 0x00BA;
        t["orthogonal"] = 0x221F;
        t["oshortdeva"] = 0x0912;
        t["oshortvowelsigndeva"] = 0x094A;
        t["oslash"] = 0x00F8;
        t["oslashacute"] = 0x01FF;
        t["osmallhiragana"] = 0x3049;
        t["osmallkatakana"] = 0x30A9;
        t["osmallkatakanahalfwidth"] = 0xFF6B;
        t["ostrokeacute"] = 0x01FF;
        t["osuperior"] = 0xF6F0;
        t["otcyrillic"] = 0x047F;
        t["otilde"] = 0x00F5;
        t["otildeacute"] = 0x1E4D;
        t["otildedieresis"] = 0x1E4F;
        t["oubopomofo"] = 0x3121;
        t["overline"] = 0x203E;
        t["overlinecenterline"] = 0xFE4A;
        t["overlinecmb"] = 0x0305;
        t["overlinedashed"] = 0xFE49;
        t["overlinedblwavy"] = 0xFE4C;
        t["overlinewavy"] = 0xFE4B;
        t["overscore"] = 0x00AF;
        t["ovowelsignbengali"] = 0x09CB;
        t["ovowelsigndeva"] = 0x094B;
        t["ovowelsigngujarati"] = 0x0ACB;
        t["p"] = 0x0070;
        t["paampssquare"] = 0x3380;
        t["paasentosquare"] = 0x332B;
        t["pabengali"] = 0x09AA;
        t["pacute"] = 0x1E55;
        t["padeva"] = 0x092A;
        t["pagedown"] = 0x21DF;
        t["pageup"] = 0x21DE;
        t["pagujarati"] = 0x0AAA;
        t["pagurmukhi"] = 0x0A2A;
        t["pahiragana"] = 0x3071;
        t["paiyannoithai"] = 0x0E2F;
        t["pakatakana"] = 0x30D1;
        t["palatalizationcyrilliccmb"] = 0x0484;
        t["palochkacyrillic"] = 0x04C0;
        t["pansioskorean"] = 0x317F;
        t["paragraph"] = 0x00B6;
        t["parallel"] = 0x2225;
        t["parenleft"] = 0x0028;
        t["parenleftaltonearabic"] = 0xFD3E;
        t["parenleftbt"] = 0xF8ED;
        t["parenleftex"] = 0xF8EC;
        t["parenleftinferior"] = 0x208D;
        t["parenleftmonospace"] = 0xFF08;
        t["parenleftsmall"] = 0xFE59;
        t["parenleftsuperior"] = 0x207D;
        t["parenlefttp"] = 0xF8EB;
        t["parenleftvertical"] = 0xFE35;
        t["parenright"] = 0x0029;
        t["parenrightaltonearabic"] = 0xFD3F;
        t["parenrightbt"] = 0xF8F8;
        t["parenrightex"] = 0xF8F7;
        t["parenrightinferior"] = 0x208E;
        t["parenrightmonospace"] = 0xFF09;
        t["parenrightsmall"] = 0xFE5A;
        t["parenrightsuperior"] = 0x207E;
        t["parenrighttp"] = 0xF8F6;
        t["parenrightvertical"] = 0xFE36;
        t["partialdiff"] = 0x2202;
        t["paseqhebrew"] = 0x05C0;
        t["pashtahebrew"] = 0x0599;
        t["pasquare"] = 0x33A9;
        t["patah"] = 0x05B7;
        t["patah11"] = 0x05B7;
        t["patah1d"] = 0x05B7;
        t["patah2a"] = 0x05B7;
        t["patahhebrew"] = 0x05B7;
        t["patahnarrowhebrew"] = 0x05B7;
        t["patahquarterhebrew"] = 0x05B7;
        t["patahwidehebrew"] = 0x05B7;
        t["pazerhebrew"] = 0x05A1;
        t["pbopomofo"] = 0x3106;
        t["pcircle"] = 0x24DF;
        t["pdotaccent"] = 0x1E57;
        t["pe"] = 0x05E4;
        t["pecyrillic"] = 0x043F;
        t["pedagesh"] = 0xFB44;
        t["pedageshhebrew"] = 0xFB44;
        t["peezisquare"] = 0x333B;
        t["pefinaldageshhebrew"] = 0xFB43;
        t["peharabic"] = 0x067E;
        t["peharmenian"] = 0x057A;
        t["pehebrew"] = 0x05E4;
        t["pehfinalarabic"] = 0xFB57;
        t["pehinitialarabic"] = 0xFB58;
        t["pehiragana"] = 0x307A;
        t["pehmedialarabic"] = 0xFB59;
        t["pekatakana"] = 0x30DA;
        t["pemiddlehookcyrillic"] = 0x04A7;
        t["perafehebrew"] = 0xFB4E;
        t["percent"] = 0x0025;
        t["percentarabic"] = 0x066A;
        t["percentmonospace"] = 0xFF05;
        t["percentsmall"] = 0xFE6A;
        t["period"] = 0x002E;
        t["periodarmenian"] = 0x0589;
        t["periodcentered"] = 0x00B7;
        t["periodhalfwidth"] = 0xFF61;
        t["periodinferior"] = 0xF6E7;
        t["periodmonospace"] = 0xFF0E;
        t["periodsmall"] = 0xFE52;
        t["periodsuperior"] = 0xF6E8;
        t["perispomenigreekcmb"] = 0x0342;
        t["perpendicular"] = 0x22A5;
        t["perthousand"] = 0x2030;
        t["peseta"] = 0x20A7;
        t["pfsquare"] = 0x338A;
        t["phabengali"] = 0x09AB;
        t["phadeva"] = 0x092B;
        t["phagujarati"] = 0x0AAB;
        t["phagurmukhi"] = 0x0A2B;
        t["phi"] = 0x03C6;
        t["phi1"] = 0x03D5;
        t["phieuphacirclekorean"] = 0x327A;
        t["phieuphaparenkorean"] = 0x321A;
        t["phieuphcirclekorean"] = 0x326C;
        t["phieuphkorean"] = 0x314D;
        t["phieuphparenkorean"] = 0x320C;
        t["philatin"] = 0x0278;
        t["phinthuthai"] = 0x0E3A;
        t["phisymbolgreek"] = 0x03D5;
        t["phook"] = 0x01A5;
        t["phophanthai"] = 0x0E1E;
        t["phophungthai"] = 0x0E1C;
        t["phosamphaothai"] = 0x0E20;
        t["pi"] = 0x03C0;
        t["pieupacirclekorean"] = 0x3273;
        t["pieupaparenkorean"] = 0x3213;
        t["pieupcieuckorean"] = 0x3176;
        t["pieupcirclekorean"] = 0x3265;
        t["pieupkiyeokkorean"] = 0x3172;
        t["pieupkorean"] = 0x3142;
        t["pieupparenkorean"] = 0x3205;
        t["pieupsioskiyeokkorean"] = 0x3174;
        t["pieupsioskorean"] = 0x3144;
        t["pieupsiostikeutkorean"] = 0x3175;
        t["pieupthieuthkorean"] = 0x3177;
        t["pieuptikeutkorean"] = 0x3173;
        t["pihiragana"] = 0x3074;
        t["pikatakana"] = 0x30D4;
        t["pisymbolgreek"] = 0x03D6;
        t["piwrarmenian"] = 0x0583;
        t["plus"] = 0x002B;
        t["plusbelowcmb"] = 0x031F;
        t["pluscircle"] = 0x2295;
        t["plusminus"] = 0x00B1;
        t["plusmod"] = 0x02D6;
        t["plusmonospace"] = 0xFF0B;
        t["plussmall"] = 0xFE62;
        t["plussuperior"] = 0x207A;
        t["pmonospace"] = 0xFF50;
        t["pmsquare"] = 0x33D8;
        t["pohiragana"] = 0x307D;
        t["pointingindexdownwhite"] = 0x261F;
        t["pointingindexleftwhite"] = 0x261C;
        t["pointingindexrightwhite"] = 0x261E;
        t["pointingindexupwhite"] = 0x261D;
        t["pokatakana"] = 0x30DD;
        t["poplathai"] = 0x0E1B;
        t["postalmark"] = 0x3012;
        t["postalmarkface"] = 0x3020;
        t["pparen"] = 0x24AB;
        t["precedes"] = 0x227A;
        t["prescription"] = 0x211E;
        t["primemod"] = 0x02B9;
        t["primereversed"] = 0x2035;
        t["product"] = 0x220F;
        t["projective"] = 0x2305;
        t["prolongedkana"] = 0x30FC;
        t["propellor"] = 0x2318;
        t["propersubset"] = 0x2282;
        t["propersuperset"] = 0x2283;
        t["proportion"] = 0x2237;
        t["proportional"] = 0x221D;
        t["psi"] = 0x03C8;
        t["psicyrillic"] = 0x0471;
        t["psilipneumatacyrilliccmb"] = 0x0486;
        t["pssquare"] = 0x33B0;
        t["puhiragana"] = 0x3077;
        t["pukatakana"] = 0x30D7;
        t["pvsquare"] = 0x33B4;
        t["pwsquare"] = 0x33BA;
        t["q"] = 0x0071;
        t["qadeva"] = 0x0958;
        t["qadmahebrew"] = 0x05A8;
        t["qafarabic"] = 0x0642;
        t["qaffinalarabic"] = 0xFED6;
        t["qafinitialarabic"] = 0xFED7;
        t["qafmedialarabic"] = 0xFED8;
        t["qamats"] = 0x05B8;
        t["qamats10"] = 0x05B8;
        t["qamats1a"] = 0x05B8;
        t["qamats1c"] = 0x05B8;
        t["qamats27"] = 0x05B8;
        t["qamats29"] = 0x05B8;
        t["qamats33"] = 0x05B8;
        t["qamatsde"] = 0x05B8;
        t["qamatshebrew"] = 0x05B8;
        t["qamatsnarrowhebrew"] = 0x05B8;
        t["qamatsqatanhebrew"] = 0x05B8;
        t["qamatsqatannarrowhebrew"] = 0x05B8;
        t["qamatsqatanquarterhebrew"] = 0x05B8;
        t["qamatsqatanwidehebrew"] = 0x05B8;
        t["qamatsquarterhebrew"] = 0x05B8;
        t["qamatswidehebrew"] = 0x05B8;
        t["qarneyparahebrew"] = 0x059F;
        t["qbopomofo"] = 0x3111;
        t["qcircle"] = 0x24E0;
        t["qhook"] = 0x02A0;
        t["qmonospace"] = 0xFF51;
        t["qof"] = 0x05E7;
        t["qofdagesh"] = 0xFB47;
        t["qofdageshhebrew"] = 0xFB47;
        t["qofhebrew"] = 0x05E7;
        t["qparen"] = 0x24AC;
        t["quarternote"] = 0x2669;
        t["qubuts"] = 0x05BB;
        t["qubuts18"] = 0x05BB;
        t["qubuts25"] = 0x05BB;
        t["qubuts31"] = 0x05BB;
        t["qubutshebrew"] = 0x05BB;
        t["qubutsnarrowhebrew"] = 0x05BB;
        t["qubutsquarterhebrew"] = 0x05BB;
        t["qubutswidehebrew"] = 0x05BB;
        t["question"] = 0x003F;
        t["questionarabic"] = 0x061F;
        t["questionarmenian"] = 0x055E;
        t["questiondown"] = 0x00BF;
        t["questiondownsmall"] = 0xF7BF;
        t["questiongreek"] = 0x037E;
        t["questionmonospace"] = 0xFF1F;
        t["questionsmall"] = 0xF73F;
        t["quotedbl"] = 0x0022;
        t["quotedblbase"] = 0x201E;
        t["quotedblleft"] = 0x201C;
        t["quotedblmonospace"] = 0xFF02;
        t["quotedblprime"] = 0x301E;
        t["quotedblprimereversed"] = 0x301D;
        t["quotedblright"] = 0x201D;
        t["quoteleft"] = 0x2018;
        t["quoteleftreversed"] = 0x201B;
        t["quotereversed"] = 0x201B;
        t["quoteright"] = 0x2019;
        t["quoterightn"] = 0x0149;
        t["quotesinglbase"] = 0x201A;
        t["quotesingle"] = 0x0027;
        t["quotesinglemonospace"] = 0xFF07;
        t["r"] = 0x0072;
        t["raarmenian"] = 0x057C;
        t["rabengali"] = 0x09B0;
        t["racute"] = 0x0155;
        t["radeva"] = 0x0930;
        t["radical"] = 0x221A;
        t["radicalex"] = 0xF8E5;
        t["radoverssquare"] = 0x33AE;
        t["radoverssquaredsquare"] = 0x33AF;
        t["radsquare"] = 0x33AD;
        t["rafe"] = 0x05BF;
        t["rafehebrew"] = 0x05BF;
        t["ragujarati"] = 0x0AB0;
        t["ragurmukhi"] = 0x0A30;
        t["rahiragana"] = 0x3089;
        t["rakatakana"] = 0x30E9;
        t["rakatakanahalfwidth"] = 0xFF97;
        t["ralowerdiagonalbengali"] = 0x09F1;
        t["ramiddlediagonalbengali"] = 0x09F0;
        t["ramshorn"] = 0x0264;
        t["ratio"] = 0x2236;
        t["rbopomofo"] = 0x3116;
        t["rcaron"] = 0x0159;
        t["rcedilla"] = 0x0157;
        t["rcircle"] = 0x24E1;
        t["rcommaaccent"] = 0x0157;
        t["rdblgrave"] = 0x0211;
        t["rdotaccent"] = 0x1E59;
        t["rdotbelow"] = 0x1E5B;
        t["rdotbelowmacron"] = 0x1E5D;
        t["referencemark"] = 0x203B;
        t["reflexsubset"] = 0x2286;
        t["reflexsuperset"] = 0x2287;
        t["registered"] = 0x00AE;
        t["registersans"] = 0xF8E8;
        t["registerserif"] = 0xF6DA;
        t["reharabic"] = 0x0631;
        t["reharmenian"] = 0x0580;
        t["rehfinalarabic"] = 0xFEAE;
        t["rehiragana"] = 0x308C;
        t["rekatakana"] = 0x30EC;
        t["rekatakanahalfwidth"] = 0xFF9A;
        t["resh"] = 0x05E8;
        t["reshdageshhebrew"] = 0xFB48;
        t["reshhebrew"] = 0x05E8;
        t["reversedtilde"] = 0x223D;
        t["reviahebrew"] = 0x0597;
        t["reviamugrashhebrew"] = 0x0597;
        t["revlogicalnot"] = 0x2310;
        t["rfishhook"] = 0x027E;
        t["rfishhookreversed"] = 0x027F;
        t["rhabengali"] = 0x09DD;
        t["rhadeva"] = 0x095D;
        t["rho"] = 0x03C1;
        t["rhook"] = 0x027D;
        t["rhookturned"] = 0x027B;
        t["rhookturnedsuperior"] = 0x02B5;
        t["rhosymbolgreek"] = 0x03F1;
        t["rhotichookmod"] = 0x02DE;
        t["rieulacirclekorean"] = 0x3271;
        t["rieulaparenkorean"] = 0x3211;
        t["rieulcirclekorean"] = 0x3263;
        t["rieulhieuhkorean"] = 0x3140;
        t["rieulkiyeokkorean"] = 0x313A;
        t["rieulkiyeoksioskorean"] = 0x3169;
        t["rieulkorean"] = 0x3139;
        t["rieulmieumkorean"] = 0x313B;
        t["rieulpansioskorean"] = 0x316C;
        t["rieulparenkorean"] = 0x3203;
        t["rieulphieuphkorean"] = 0x313F;
        t["rieulpieupkorean"] = 0x313C;
        t["rieulpieupsioskorean"] = 0x316B;
        t["rieulsioskorean"] = 0x313D;
        t["rieulthieuthkorean"] = 0x313E;
        t["rieultikeutkorean"] = 0x316A;
        t["rieulyeorinhieuhkorean"] = 0x316D;
        t["rightangle"] = 0x221F;
        t["righttackbelowcmb"] = 0x0319;
        t["righttriangle"] = 0x22BF;
        t["rihiragana"] = 0x308A;
        t["rikatakana"] = 0x30EA;
        t["rikatakanahalfwidth"] = 0xFF98;
        t["ring"] = 0x02DA;
        t["ringbelowcmb"] = 0x0325;
        t["ringcmb"] = 0x030A;
        t["ringhalfleft"] = 0x02BF;
        t["ringhalfleftarmenian"] = 0x0559;
        t["ringhalfleftbelowcmb"] = 0x031C;
        t["ringhalfleftcentered"] = 0x02D3;
        t["ringhalfright"] = 0x02BE;
        t["ringhalfrightbelowcmb"] = 0x0339;
        t["ringhalfrightcentered"] = 0x02D2;
        t["rinvertedbreve"] = 0x0213;
        t["rittorusquare"] = 0x3351;
        t["rlinebelow"] = 0x1E5F;
        t["rlongleg"] = 0x027C;
        t["rlonglegturned"] = 0x027A;
        t["rmonospace"] = 0xFF52;
        t["rohiragana"] = 0x308D;
        t["rokatakana"] = 0x30ED;
        t["rokatakanahalfwidth"] = 0xFF9B;
        t["roruathai"] = 0x0E23;
        t["rparen"] = 0x24AD;
        t["rrabengali"] = 0x09DC;
        t["rradeva"] = 0x0931;
        t["rragurmukhi"] = 0x0A5C;
        t["rreharabic"] = 0x0691;
        t["rrehfinalarabic"] = 0xFB8D;
        t["rrvocalicbengali"] = 0x09E0;
        t["rrvocalicdeva"] = 0x0960;
        t["rrvocalicgujarati"] = 0x0AE0;
        t["rrvocalicvowelsignbengali"] = 0x09C4;
        t["rrvocalicvowelsigndeva"] = 0x0944;
        t["rrvocalicvowelsigngujarati"] = 0x0AC4;
        t["rsuperior"] = 0xF6F1;
        t["rtblock"] = 0x2590;
        t["rturned"] = 0x0279;
        t["rturnedsuperior"] = 0x02B4;
        t["ruhiragana"] = 0x308B;
        t["rukatakana"] = 0x30EB;
        t["rukatakanahalfwidth"] = 0xFF99;
        t["rupeemarkbengali"] = 0x09F2;
        t["rupeesignbengali"] = 0x09F3;
        t["rupiah"] = 0xF6DD;
        t["ruthai"] = 0x0E24;
        t["rvocalicbengali"] = 0x098B;
        t["rvocalicdeva"] = 0x090B;
        t["rvocalicgujarati"] = 0x0A8B;
        t["rvocalicvowelsignbengali"] = 0x09C3;
        t["rvocalicvowelsigndeva"] = 0x0943;
        t["rvocalicvowelsigngujarati"] = 0x0AC3;
        t["s"] = 0x0073;
        t["sabengali"] = 0x09B8;
        t["sacute"] = 0x015B;
        t["sacutedotaccent"] = 0x1E65;
        t["sadarabic"] = 0x0635;
        t["sadeva"] = 0x0938;
        t["sadfinalarabic"] = 0xFEBA;
        t["sadinitialarabic"] = 0xFEBB;
        t["sadmedialarabic"] = 0xFEBC;
        t["sagujarati"] = 0x0AB8;
        t["sagurmukhi"] = 0x0A38;
        t["sahiragana"] = 0x3055;
        t["sakatakana"] = 0x30B5;
        t["sakatakanahalfwidth"] = 0xFF7B;
        t["sallallahoualayhewasallamarabic"] = 0xFDFA;
        t["samekh"] = 0x05E1;
        t["samekhdagesh"] = 0xFB41;
        t["samekhdageshhebrew"] = 0xFB41;
        t["samekhhebrew"] = 0x05E1;
        t["saraaathai"] = 0x0E32;
        t["saraaethai"] = 0x0E41;
        t["saraaimaimalaithai"] = 0x0E44;
        t["saraaimaimuanthai"] = 0x0E43;
        t["saraamthai"] = 0x0E33;
        t["saraathai"] = 0x0E30;
        t["saraethai"] = 0x0E40;
        t["saraiileftthai"] = 0xF886;
        t["saraiithai"] = 0x0E35;
        t["saraileftthai"] = 0xF885;
        t["saraithai"] = 0x0E34;
        t["saraothai"] = 0x0E42;
        t["saraueeleftthai"] = 0xF888;
        t["saraueethai"] = 0x0E37;
        t["saraueleftthai"] = 0xF887;
        t["sarauethai"] = 0x0E36;
        t["sarauthai"] = 0x0E38;
        t["sarauuthai"] = 0x0E39;
        t["sbopomofo"] = 0x3119;
        t["scaron"] = 0x0161;
        t["scarondotaccent"] = 0x1E67;
        t["scedilla"] = 0x015F;
        t["schwa"] = 0x0259;
        t["schwacyrillic"] = 0x04D9;
        t["schwadieresiscyrillic"] = 0x04DB;
        t["schwahook"] = 0x025A;
        t["scircle"] = 0x24E2;
        t["scircumflex"] = 0x015D;
        t["scommaaccent"] = 0x0219;
        t["sdotaccent"] = 0x1E61;
        t["sdotbelow"] = 0x1E63;
        t["sdotbelowdotaccent"] = 0x1E69;
        t["seagullbelowcmb"] = 0x033C;
        t["second"] = 0x2033;
        t["secondtonechinese"] = 0x02CA;
        t["section"] = 0x00A7;
        t["seenarabic"] = 0x0633;
        t["seenfinalarabic"] = 0xFEB2;
        t["seeninitialarabic"] = 0xFEB3;
        t["seenmedialarabic"] = 0xFEB4;
        t["segol"] = 0x05B6;
        t["segol13"] = 0x05B6;
        t["segol1f"] = 0x05B6;
        t["segol2c"] = 0x05B6;
        t["segolhebrew"] = 0x05B6;
        t["segolnarrowhebrew"] = 0x05B6;
        t["segolquarterhebrew"] = 0x05B6;
        t["segoltahebrew"] = 0x0592;
        t["segolwidehebrew"] = 0x05B6;
        t["seharmenian"] = 0x057D;
        t["sehiragana"] = 0x305B;
        t["sekatakana"] = 0x30BB;
        t["sekatakanahalfwidth"] = 0xFF7E;
        t["semicolon"] = 0x003B;
        t["semicolonarabic"] = 0x061B;
        t["semicolonmonospace"] = 0xFF1B;
        t["semicolonsmall"] = 0xFE54;
        t["semivoicedmarkkana"] = 0x309C;
        t["semivoicedmarkkanahalfwidth"] = 0xFF9F;
        t["sentisquare"] = 0x3322;
        t["sentosquare"] = 0x3323;
        t["seven"] = 0x0037;
        t["sevenarabic"] = 0x0667;
        t["sevenbengali"] = 0x09ED;
        t["sevencircle"] = 0x2466;
        t["sevencircleinversesansserif"] = 0x2790;
        t["sevendeva"] = 0x096D;
        t["seveneighths"] = 0x215E;
        t["sevengujarati"] = 0x0AED;
        t["sevengurmukhi"] = 0x0A6D;
        t["sevenhackarabic"] = 0x0667;
        t["sevenhangzhou"] = 0x3027;
        t["sevenideographicparen"] = 0x3226;
        t["seveninferior"] = 0x2087;
        t["sevenmonospace"] = 0xFF17;
        t["sevenoldstyle"] = 0xF737;
        t["sevenparen"] = 0x247A;
        t["sevenperiod"] = 0x248E;
        t["sevenpersian"] = 0x06F7;
        t["sevenroman"] = 0x2176;
        t["sevensuperior"] = 0x2077;
        t["seventeencircle"] = 0x2470;
        t["seventeenparen"] = 0x2484;
        t["seventeenperiod"] = 0x2498;
        t["seventhai"] = 0x0E57;
        t["sfthyphen"] = 0x00AD;
        t["shaarmenian"] = 0x0577;
        t["shabengali"] = 0x09B6;
        t["shacyrillic"] = 0x0448;
        t["shaddaarabic"] = 0x0651;
        t["shaddadammaarabic"] = 0xFC61;
        t["shaddadammatanarabic"] = 0xFC5E;
        t["shaddafathaarabic"] = 0xFC60;
        t["shaddakasraarabic"] = 0xFC62;
        t["shaddakasratanarabic"] = 0xFC5F;
        t["shade"] = 0x2592;
        t["shadedark"] = 0x2593;
        t["shadelight"] = 0x2591;
        t["shademedium"] = 0x2592;
        t["shadeva"] = 0x0936;
        t["shagujarati"] = 0x0AB6;
        t["shagurmukhi"] = 0x0A36;
        t["shalshelethebrew"] = 0x0593;
        t["shbopomofo"] = 0x3115;
        t["shchacyrillic"] = 0x0449;
        t["sheenarabic"] = 0x0634;
        t["sheenfinalarabic"] = 0xFEB6;
        t["sheeninitialarabic"] = 0xFEB7;
        t["sheenmedialarabic"] = 0xFEB8;
        t["sheicoptic"] = 0x03E3;
        t["sheqel"] = 0x20AA;
        t["sheqelhebrew"] = 0x20AA;
        t["sheva"] = 0x05B0;
        t["sheva115"] = 0x05B0;
        t["sheva15"] = 0x05B0;
        t["sheva22"] = 0x05B0;
        t["sheva2e"] = 0x05B0;
        t["shevahebrew"] = 0x05B0;
        t["shevanarrowhebrew"] = 0x05B0;
        t["shevaquarterhebrew"] = 0x05B0;
        t["shevawidehebrew"] = 0x05B0;
        t["shhacyrillic"] = 0x04BB;
        t["shimacoptic"] = 0x03ED;
        t["shin"] = 0x05E9;
        t["shindagesh"] = 0xFB49;
        t["shindageshhebrew"] = 0xFB49;
        t["shindageshshindot"] = 0xFB2C;
        t["shindageshshindothebrew"] = 0xFB2C;
        t["shindageshsindot"] = 0xFB2D;
        t["shindageshsindothebrew"] = 0xFB2D;
        t["shindothebrew"] = 0x05C1;
        t["shinhebrew"] = 0x05E9;
        t["shinshindot"] = 0xFB2A;
        t["shinshindothebrew"] = 0xFB2A;
        t["shinsindot"] = 0xFB2B;
        t["shinsindothebrew"] = 0xFB2B;
        t["shook"] = 0x0282;
        t["sigma"] = 0x03C3;
        t["sigma1"] = 0x03C2;
        t["sigmafinal"] = 0x03C2;
        t["sigmalunatesymbolgreek"] = 0x03F2;
        t["sihiragana"] = 0x3057;
        t["sikatakana"] = 0x30B7;
        t["sikatakanahalfwidth"] = 0xFF7C;
        t["siluqhebrew"] = 0x05BD;
        t["siluqlefthebrew"] = 0x05BD;
        t["similar"] = 0x223C;
        t["sindothebrew"] = 0x05C2;
        t["siosacirclekorean"] = 0x3274;
        t["siosaparenkorean"] = 0x3214;
        t["sioscieuckorean"] = 0x317E;
        t["sioscirclekorean"] = 0x3266;
        t["sioskiyeokkorean"] = 0x317A;
        t["sioskorean"] = 0x3145;
        t["siosnieunkorean"] = 0x317B;
        t["siosparenkorean"] = 0x3206;
        t["siospieupkorean"] = 0x317D;
        t["siostikeutkorean"] = 0x317C;
        t["six"] = 0x0036;
        t["sixarabic"] = 0x0666;
        t["sixbengali"] = 0x09EC;
        t["sixcircle"] = 0x2465;
        t["sixcircleinversesansserif"] = 0x278F;
        t["sixdeva"] = 0x096C;
        t["sixgujarati"] = 0x0AEC;
        t["sixgurmukhi"] = 0x0A6C;
        t["sixhackarabic"] = 0x0666;
        t["sixhangzhou"] = 0x3026;
        t["sixideographicparen"] = 0x3225;
        t["sixinferior"] = 0x2086;
        t["sixmonospace"] = 0xFF16;
        t["sixoldstyle"] = 0xF736;
        t["sixparen"] = 0x2479;
        t["sixperiod"] = 0x248D;
        t["sixpersian"] = 0x06F6;
        t["sixroman"] = 0x2175;
        t["sixsuperior"] = 0x2076;
        t["sixteencircle"] = 0x246F;
        t["sixteencurrencydenominatorbengali"] = 0x09F9;
        t["sixteenparen"] = 0x2483;
        t["sixteenperiod"] = 0x2497;
        t["sixthai"] = 0x0E56;
        t["slash"] = 0x002F;
        t["slashmonospace"] = 0xFF0F;
        t["slong"] = 0x017F;
        t["slongdotaccent"] = 0x1E9B;
        t["smileface"] = 0x263A;
        t["smonospace"] = 0xFF53;
        t["sofpasuqhebrew"] = 0x05C3;
        t["softhyphen"] = 0x00AD;
        t["softsigncyrillic"] = 0x044C;
        t["sohiragana"] = 0x305D;
        t["sokatakana"] = 0x30BD;
        t["sokatakanahalfwidth"] = 0xFF7F;
        t["soliduslongoverlaycmb"] = 0x0338;
        t["solidusshortoverlaycmb"] = 0x0337;
        t["sorusithai"] = 0x0E29;
        t["sosalathai"] = 0x0E28;
        t["sosothai"] = 0x0E0B;
        t["sosuathai"] = 0x0E2A;
        t["space"] = 0x0020;
        t["spacehackarabic"] = 0x0020;
        t["spade"] = 0x2660;
        t["spadesuitblack"] = 0x2660;
        t["spadesuitwhite"] = 0x2664;
        t["sparen"] = 0x24AE;
        t["squarebelowcmb"] = 0x033B;
        t["squarecc"] = 0x33C4;
        t["squarecm"] = 0x339D;
        t["squarediagonalcrosshatchfill"] = 0x25A9;
        t["squarehorizontalfill"] = 0x25A4;
        t["squarekg"] = 0x338F;
        t["squarekm"] = 0x339E;
        t["squarekmcapital"] = 0x33CE;
        t["squareln"] = 0x33D1;
        t["squarelog"] = 0x33D2;
        t["squaremg"] = 0x338E;
        t["squaremil"] = 0x33D5;
        t["squaremm"] = 0x339C;
        t["squaremsquared"] = 0x33A1;
        t["squareorthogonalcrosshatchfill"] = 0x25A6;
        t["squareupperlefttolowerrightfill"] = 0x25A7;
        t["squareupperrighttolowerleftfill"] = 0x25A8;
        t["squareverticalfill"] = 0x25A5;
        t["squarewhitewithsmallblack"] = 0x25A3;
        t["srsquare"] = 0x33DB;
        t["ssabengali"] = 0x09B7;
        t["ssadeva"] = 0x0937;
        t["ssagujarati"] = 0x0AB7;
        t["ssangcieuckorean"] = 0x3149;
        t["ssanghieuhkorean"] = 0x3185;
        t["ssangieungkorean"] = 0x3180;
        t["ssangkiyeokkorean"] = 0x3132;
        t["ssangnieunkorean"] = 0x3165;
        t["ssangpieupkorean"] = 0x3143;
        t["ssangsioskorean"] = 0x3146;
        t["ssangtikeutkorean"] = 0x3138;
        t["ssuperior"] = 0xF6F2;
        t["sterling"] = 0x00A3;
        t["sterlingmonospace"] = 0xFFE1;
        t["strokelongoverlaycmb"] = 0x0336;
        t["strokeshortoverlaycmb"] = 0x0335;
        t["subset"] = 0x2282;
        t["subsetnotequal"] = 0x228A;
        t["subsetorequal"] = 0x2286;
        t["succeeds"] = 0x227B;
        t["suchthat"] = 0x220B;
        t["suhiragana"] = 0x3059;
        t["sukatakana"] = 0x30B9;
        t["sukatakanahalfwidth"] = 0xFF7D;
        t["sukunarabic"] = 0x0652;
        t["summation"] = 0x2211;
        t["sun"] = 0x263C;
        t["superset"] = 0x2283;
        t["supersetnotequal"] = 0x228B;
        t["supersetorequal"] = 0x2287;
        t["svsquare"] = 0x33DC;
        t["syouwaerasquare"] = 0x337C;
        t["t"] = 0x0074;
        t["tabengali"] = 0x09A4;
        t["tackdown"] = 0x22A4;
        t["tackleft"] = 0x22A3;
        t["tadeva"] = 0x0924;
        t["tagujarati"] = 0x0AA4;
        t["tagurmukhi"] = 0x0A24;
        t["taharabic"] = 0x0637;
        t["tahfinalarabic"] = 0xFEC2;
        t["tahinitialarabic"] = 0xFEC3;
        t["tahiragana"] = 0x305F;
        t["tahmedialarabic"] = 0xFEC4;
        t["taisyouerasquare"] = 0x337D;
        t["takatakana"] = 0x30BF;
        t["takatakanahalfwidth"] = 0xFF80;
        t["tatweelarabic"] = 0x0640;
        t["tau"] = 0x03C4;
        t["tav"] = 0x05EA;
        t["tavdages"] = 0xFB4A;
        t["tavdagesh"] = 0xFB4A;
        t["tavdageshhebrew"] = 0xFB4A;
        t["tavhebrew"] = 0x05EA;
        t["tbar"] = 0x0167;
        t["tbopomofo"] = 0x310A;
        t["tcaron"] = 0x0165;
        t["tccurl"] = 0x02A8;
        t["tcedilla"] = 0x0163;
        t["tcheharabic"] = 0x0686;
        t["tchehfinalarabic"] = 0xFB7B;
        t["tchehinitialarabic"] = 0xFB7C;
        t["tchehmedialarabic"] = 0xFB7D;
        t["tcircle"] = 0x24E3;
        t["tcircumflexbelow"] = 0x1E71;
        t["tcommaaccent"] = 0x0163;
        t["tdieresis"] = 0x1E97;
        t["tdotaccent"] = 0x1E6B;
        t["tdotbelow"] = 0x1E6D;
        t["tecyrillic"] = 0x0442;
        t["tedescendercyrillic"] = 0x04AD;
        t["teharabic"] = 0x062A;
        t["tehfinalarabic"] = 0xFE96;
        t["tehhahinitialarabic"] = 0xFCA2;
        t["tehhahisolatedarabic"] = 0xFC0C;
        t["tehinitialarabic"] = 0xFE97;
        t["tehiragana"] = 0x3066;
        t["tehjeeminitialarabic"] = 0xFCA1;
        t["tehjeemisolatedarabic"] = 0xFC0B;
        t["tehmarbutaarabic"] = 0x0629;
        t["tehmarbutafinalarabic"] = 0xFE94;
        t["tehmedialarabic"] = 0xFE98;
        t["tehmeeminitialarabic"] = 0xFCA4;
        t["tehmeemisolatedarabic"] = 0xFC0E;
        t["tehnoonfinalarabic"] = 0xFC73;
        t["tekatakana"] = 0x30C6;
        t["tekatakanahalfwidth"] = 0xFF83;
        t["telephone"] = 0x2121;
        t["telephoneblack"] = 0x260E;
        t["telishagedolahebrew"] = 0x05A0;
        t["telishaqetanahebrew"] = 0x05A9;
        t["tencircle"] = 0x2469;
        t["tenideographicparen"] = 0x3229;
        t["tenparen"] = 0x247D;
        t["tenperiod"] = 0x2491;
        t["tenroman"] = 0x2179;
        t["tesh"] = 0x02A7;
        t["tet"] = 0x05D8;
        t["tetdagesh"] = 0xFB38;
        t["tetdageshhebrew"] = 0xFB38;
        t["tethebrew"] = 0x05D8;
        t["tetsecyrillic"] = 0x04B5;
        t["tevirhebrew"] = 0x059B;
        t["tevirlefthebrew"] = 0x059B;
        t["thabengali"] = 0x09A5;
        t["thadeva"] = 0x0925;
        t["thagujarati"] = 0x0AA5;
        t["thagurmukhi"] = 0x0A25;
        t["thalarabic"] = 0x0630;
        t["thalfinalarabic"] = 0xFEAC;
        t["thanthakhatlowleftthai"] = 0xF898;
        t["thanthakhatlowrightthai"] = 0xF897;
        t["thanthakhatthai"] = 0x0E4C;
        t["thanthakhatupperleftthai"] = 0xF896;
        t["theharabic"] = 0x062B;
        t["thehfinalarabic"] = 0xFE9A;
        t["thehinitialarabic"] = 0xFE9B;
        t["thehmedialarabic"] = 0xFE9C;
        t["thereexists"] = 0x2203;
        t["therefore"] = 0x2234;
        t["theta"] = 0x03B8;
        t["theta1"] = 0x03D1;
        t["thetasymbolgreek"] = 0x03D1;
        t["thieuthacirclekorean"] = 0x3279;
        t["thieuthaparenkorean"] = 0x3219;
        t["thieuthcirclekorean"] = 0x326B;
        t["thieuthkorean"] = 0x314C;
        t["thieuthparenkorean"] = 0x320B;
        t["thirteencircle"] = 0x246C;
        t["thirteenparen"] = 0x2480;
        t["thirteenperiod"] = 0x2494;
        t["thonangmonthothai"] = 0x0E11;
        t["thook"] = 0x01AD;
        t["thophuthaothai"] = 0x0E12;
        t["thorn"] = 0x00FE;
        t["thothahanthai"] = 0x0E17;
        t["thothanthai"] = 0x0E10;
        t["thothongthai"] = 0x0E18;
        t["thothungthai"] = 0x0E16;
        t["thousandcyrillic"] = 0x0482;
        t["thousandsseparatorarabic"] = 0x066C;
        t["thousandsseparatorpersian"] = 0x066C;
        t["three"] = 0x0033;
        t["threearabic"] = 0x0663;
        t["threebengali"] = 0x09E9;
        t["threecircle"] = 0x2462;
        t["threecircleinversesansserif"] = 0x278C;
        t["threedeva"] = 0x0969;
        t["threeeighths"] = 0x215C;
        t["threegujarati"] = 0x0AE9;
        t["threegurmukhi"] = 0x0A69;
        t["threehackarabic"] = 0x0663;
        t["threehangzhou"] = 0x3023;
        t["threeideographicparen"] = 0x3222;
        t["threeinferior"] = 0x2083;
        t["threemonospace"] = 0xFF13;
        t["threenumeratorbengali"] = 0x09F6;
        t["threeoldstyle"] = 0xF733;
        t["threeparen"] = 0x2476;
        t["threeperiod"] = 0x248A;
        t["threepersian"] = 0x06F3;
        t["threequarters"] = 0x00BE;
        t["threequartersemdash"] = 0xF6DE;
        t["threeroman"] = 0x2172;
        t["threesuperior"] = 0x00B3;
        t["threethai"] = 0x0E53;
        t["thzsquare"] = 0x3394;
        t["tihiragana"] = 0x3061;
        t["tikatakana"] = 0x30C1;
        t["tikatakanahalfwidth"] = 0xFF81;
        t["tikeutacirclekorean"] = 0x3270;
        t["tikeutaparenkorean"] = 0x3210;
        t["tikeutcirclekorean"] = 0x3262;
        t["tikeutkorean"] = 0x3137;
        t["tikeutparenkorean"] = 0x3202;
        t["tilde"] = 0x02DC;
        t["tildebelowcmb"] = 0x0330;
        t["tildecmb"] = 0x0303;
        t["tildecomb"] = 0x0303;
        t["tildedoublecmb"] = 0x0360;
        t["tildeoperator"] = 0x223C;
        t["tildeoverlaycmb"] = 0x0334;
        t["tildeverticalcmb"] = 0x033E;
        t["timescircle"] = 0x2297;
        t["tipehahebrew"] = 0x0596;
        t["tipehalefthebrew"] = 0x0596;
        t["tippigurmukhi"] = 0x0A70;
        t["titlocyrilliccmb"] = 0x0483;
        t["tiwnarmenian"] = 0x057F;
        t["tlinebelow"] = 0x1E6F;
        t["tmonospace"] = 0xFF54;
        t["toarmenian"] = 0x0569;
        t["tohiragana"] = 0x3068;
        t["tokatakana"] = 0x30C8;
        t["tokatakanahalfwidth"] = 0xFF84;
        t["tonebarextrahighmod"] = 0x02E5;
        t["tonebarextralowmod"] = 0x02E9;
        t["tonebarhighmod"] = 0x02E6;
        t["tonebarlowmod"] = 0x02E8;
        t["tonebarmidmod"] = 0x02E7;
        t["tonefive"] = 0x01BD;
        t["tonesix"] = 0x0185;
        t["tonetwo"] = 0x01A8;
        t["tonos"] = 0x0384;
        t["tonsquare"] = 0x3327;
        t["topatakthai"] = 0x0E0F;
        t["tortoiseshellbracketleft"] = 0x3014;
        t["tortoiseshellbracketleftsmall"] = 0xFE5D;
        t["tortoiseshellbracketleftvertical"] = 0xFE39;
        t["tortoiseshellbracketright"] = 0x3015;
        t["tortoiseshellbracketrightsmall"] = 0xFE5E;
        t["tortoiseshellbracketrightvertical"] = 0xFE3A;
        t["totaothai"] = 0x0E15;
        t["tpalatalhook"] = 0x01AB;
        t["tparen"] = 0x24AF;
        t["trademark"] = 0x2122;
        t["trademarksans"] = 0xF8EA;
        t["trademarkserif"] = 0xF6DB;
        t["tretroflexhook"] = 0x0288;
        t["triagdn"] = 0x25BC;
        t["triaglf"] = 0x25C4;
        t["triagrt"] = 0x25BA;
        t["triagup"] = 0x25B2;
        t["ts"] = 0x02A6;
        t["tsadi"] = 0x05E6;
        t["tsadidagesh"] = 0xFB46;
        t["tsadidageshhebrew"] = 0xFB46;
        t["tsadihebrew"] = 0x05E6;
        t["tsecyrillic"] = 0x0446;
        t["tsere"] = 0x05B5;
        t["tsere12"] = 0x05B5;
        t["tsere1e"] = 0x05B5;
        t["tsere2b"] = 0x05B5;
        t["tserehebrew"] = 0x05B5;
        t["tserenarrowhebrew"] = 0x05B5;
        t["tserequarterhebrew"] = 0x05B5;
        t["tserewidehebrew"] = 0x05B5;
        t["tshecyrillic"] = 0x045B;
        t["tsuperior"] = 0xF6F3;
        t["ttabengali"] = 0x099F;
        t["ttadeva"] = 0x091F;
        t["ttagujarati"] = 0x0A9F;
        t["ttagurmukhi"] = 0x0A1F;
        t["tteharabic"] = 0x0679;
        t["ttehfinalarabic"] = 0xFB67;
        t["ttehinitialarabic"] = 0xFB68;
        t["ttehmedialarabic"] = 0xFB69;
        t["tthabengali"] = 0x09A0;
        t["tthadeva"] = 0x0920;
        t["tthagujarati"] = 0x0AA0;
        t["tthagurmukhi"] = 0x0A20;
        t["tturned"] = 0x0287;
        t["tuhiragana"] = 0x3064;
        t["tukatakana"] = 0x30C4;
        t["tukatakanahalfwidth"] = 0xFF82;
        t["tusmallhiragana"] = 0x3063;
        t["tusmallkatakana"] = 0x30C3;
        t["tusmallkatakanahalfwidth"] = 0xFF6F;
        t["twelvecircle"] = 0x246B;
        t["twelveparen"] = 0x247F;
        t["twelveperiod"] = 0x2493;
        t["twelveroman"] = 0x217B;
        t["twentycircle"] = 0x2473;
        t["twentyhangzhou"] = 0x5344;
        t["twentyparen"] = 0x2487;
        t["twentyperiod"] = 0x249B;
        t["two"] = 0x0032;
        t["twoarabic"] = 0x0662;
        t["twobengali"] = 0x09E8;
        t["twocircle"] = 0x2461;
        t["twocircleinversesansserif"] = 0x278B;
        t["twodeva"] = 0x0968;
        t["twodotenleader"] = 0x2025;
        t["twodotleader"] = 0x2025;
        t["twodotleadervertical"] = 0xFE30;
        t["twogujarati"] = 0x0AE8;
        t["twogurmukhi"] = 0x0A68;
        t["twohackarabic"] = 0x0662;
        t["twohangzhou"] = 0x3022;
        t["twoideographicparen"] = 0x3221;
        t["twoinferior"] = 0x2082;
        t["twomonospace"] = 0xFF12;
        t["twonumeratorbengali"] = 0x09F5;
        t["twooldstyle"] = 0xF732;
        t["twoparen"] = 0x2475;
        t["twoperiod"] = 0x2489;
        t["twopersian"] = 0x06F2;
        t["tworoman"] = 0x2171;
        t["twostroke"] = 0x01BB;
        t["twosuperior"] = 0x00B2;
        t["twothai"] = 0x0E52;
        t["twothirds"] = 0x2154;
        t["u"] = 0x0075;
        t["uacute"] = 0x00FA;
        t["ubar"] = 0x0289;
        t["ubengali"] = 0x0989;
        t["ubopomofo"] = 0x3128;
        t["ubreve"] = 0x016D;
        t["ucaron"] = 0x01D4;
        t["ucircle"] = 0x24E4;
        t["ucircumflex"] = 0x00FB;
        t["ucircumflexbelow"] = 0x1E77;
        t["ucyrillic"] = 0x0443;
        t["udattadeva"] = 0x0951;
        t["udblacute"] = 0x0171;
        t["udblgrave"] = 0x0215;
        t["udeva"] = 0x0909;
        t["udieresis"] = 0x00FC;
        t["udieresisacute"] = 0x01D8;
        t["udieresisbelow"] = 0x1E73;
        t["udieresiscaron"] = 0x01DA;
        t["udieresiscyrillic"] = 0x04F1;
        t["udieresisgrave"] = 0x01DC;
        t["udieresismacron"] = 0x01D6;
        t["udotbelow"] = 0x1EE5;
        t["ugrave"] = 0x00F9;
        t["ugujarati"] = 0x0A89;
        t["ugurmukhi"] = 0x0A09;
        t["uhiragana"] = 0x3046;
        t["uhookabove"] = 0x1EE7;
        t["uhorn"] = 0x01B0;
        t["uhornacute"] = 0x1EE9;
        t["uhorndotbelow"] = 0x1EF1;
        t["uhorngrave"] = 0x1EEB;
        t["uhornhookabove"] = 0x1EED;
        t["uhorntilde"] = 0x1EEF;
        t["uhungarumlaut"] = 0x0171;
        t["uhungarumlautcyrillic"] = 0x04F3;
        t["uinvertedbreve"] = 0x0217;
        t["ukatakana"] = 0x30A6;
        t["ukatakanahalfwidth"] = 0xFF73;
        t["ukcyrillic"] = 0x0479;
        t["ukorean"] = 0x315C;
        t["umacron"] = 0x016B;
        t["umacroncyrillic"] = 0x04EF;
        t["umacrondieresis"] = 0x1E7B;
        t["umatragurmukhi"] = 0x0A41;
        t["umonospace"] = 0xFF55;
        t["underscore"] = 0x005F;
        t["underscoredbl"] = 0x2017;
        t["underscoremonospace"] = 0xFF3F;
        t["underscorevertical"] = 0xFE33;
        t["underscorewavy"] = 0xFE4F;
        t["union"] = 0x222A;
        t["universal"] = 0x2200;
        t["uogonek"] = 0x0173;
        t["uparen"] = 0x24B0;
        t["upblock"] = 0x2580;
        t["upperdothebrew"] = 0x05C4;
        t["upsilon"] = 0x03C5;
        t["upsilondieresis"] = 0x03CB;
        t["upsilondieresistonos"] = 0x03B0;
        t["upsilonlatin"] = 0x028A;
        t["upsilontonos"] = 0x03CD;
        t["uptackbelowcmb"] = 0x031D;
        t["uptackmod"] = 0x02D4;
        t["uragurmukhi"] = 0x0A73;
        t["uring"] = 0x016F;
        t["ushortcyrillic"] = 0x045E;
        t["usmallhiragana"] = 0x3045;
        t["usmallkatakana"] = 0x30A5;
        t["usmallkatakanahalfwidth"] = 0xFF69;
        t["ustraightcyrillic"] = 0x04AF;
        t["ustraightstrokecyrillic"] = 0x04B1;
        t["utilde"] = 0x0169;
        t["utildeacute"] = 0x1E79;
        t["utildebelow"] = 0x1E75;
        t["uubengali"] = 0x098A;
        t["uudeva"] = 0x090A;
        t["uugujarati"] = 0x0A8A;
        t["uugurmukhi"] = 0x0A0A;
        t["uumatragurmukhi"] = 0x0A42;
        t["uuvowelsignbengali"] = 0x09C2;
        t["uuvowelsigndeva"] = 0x0942;
        t["uuvowelsigngujarati"] = 0x0AC2;
        t["uvowelsignbengali"] = 0x09C1;
        t["uvowelsigndeva"] = 0x0941;
        t["uvowelsigngujarati"] = 0x0AC1;
        t["v"] = 0x0076;
        t["vadeva"] = 0x0935;
        t["vagujarati"] = 0x0AB5;
        t["vagurmukhi"] = 0x0A35;
        t["vakatakana"] = 0x30F7;
        t["vav"] = 0x05D5;
        t["vavdagesh"] = 0xFB35;
        t["vavdagesh65"] = 0xFB35;
        t["vavdageshhebrew"] = 0xFB35;
        t["vavhebrew"] = 0x05D5;
        t["vavholam"] = 0xFB4B;
        t["vavholamhebrew"] = 0xFB4B;
        t["vavvavhebrew"] = 0x05F0;
        t["vavyodhebrew"] = 0x05F1;
        t["vcircle"] = 0x24E5;
        t["vdotbelow"] = 0x1E7F;
        t["vecyrillic"] = 0x0432;
        t["veharabic"] = 0x06A4;
        t["vehfinalarabic"] = 0xFB6B;
        t["vehinitialarabic"] = 0xFB6C;
        t["vehmedialarabic"] = 0xFB6D;
        t["vekatakana"] = 0x30F9;
        t["venus"] = 0x2640;
        t["verticalbar"] = 0x007C;
        t["verticallineabovecmb"] = 0x030D;
        t["verticallinebelowcmb"] = 0x0329;
        t["verticallinelowmod"] = 0x02CC;
        t["verticallinemod"] = 0x02C8;
        t["vewarmenian"] = 0x057E;
        t["vhook"] = 0x028B;
        t["vikatakana"] = 0x30F8;
        t["viramabengali"] = 0x09CD;
        t["viramadeva"] = 0x094D;
        t["viramagujarati"] = 0x0ACD;
        t["visargabengali"] = 0x0983;
        t["visargadeva"] = 0x0903;
        t["visargagujarati"] = 0x0A83;
        t["vmonospace"] = 0xFF56;
        t["voarmenian"] = 0x0578;
        t["voicediterationhiragana"] = 0x309E;
        t["voicediterationkatakana"] = 0x30FE;
        t["voicedmarkkana"] = 0x309B;
        t["voicedmarkkanahalfwidth"] = 0xFF9E;
        t["vokatakana"] = 0x30FA;
        t["vparen"] = 0x24B1;
        t["vtilde"] = 0x1E7D;
        t["vturned"] = 0x028C;
        t["vuhiragana"] = 0x3094;
        t["vukatakana"] = 0x30F4;
        t["w"] = 0x0077;
        t["wacute"] = 0x1E83;
        t["waekorean"] = 0x3159;
        t["wahiragana"] = 0x308F;
        t["wakatakana"] = 0x30EF;
        t["wakatakanahalfwidth"] = 0xFF9C;
        t["wakorean"] = 0x3158;
        t["wasmallhiragana"] = 0x308E;
        t["wasmallkatakana"] = 0x30EE;
        t["wattosquare"] = 0x3357;
        t["wavedash"] = 0x301C;
        t["wavyunderscorevertical"] = 0xFE34;
        t["wawarabic"] = 0x0648;
        t["wawfinalarabic"] = 0xFEEE;
        t["wawhamzaabovearabic"] = 0x0624;
        t["wawhamzaabovefinalarabic"] = 0xFE86;
        t["wbsquare"] = 0x33DD;
        t["wcircle"] = 0x24E6;
        t["wcircumflex"] = 0x0175;
        t["wdieresis"] = 0x1E85;
        t["wdotaccent"] = 0x1E87;
        t["wdotbelow"] = 0x1E89;
        t["wehiragana"] = 0x3091;
        t["weierstrass"] = 0x2118;
        t["wekatakana"] = 0x30F1;
        t["wekorean"] = 0x315E;
        t["weokorean"] = 0x315D;
        t["wgrave"] = 0x1E81;
        t["whitebullet"] = 0x25E6;
        t["whitecircle"] = 0x25CB;
        t["whitecircleinverse"] = 0x25D9;
        t["whitecornerbracketleft"] = 0x300E;
        t["whitecornerbracketleftvertical"] = 0xFE43;
        t["whitecornerbracketright"] = 0x300F;
        t["whitecornerbracketrightvertical"] = 0xFE44;
        t["whitediamond"] = 0x25C7;
        t["whitediamondcontainingblacksmalldiamond"] = 0x25C8;
        t["whitedownpointingsmalltriangle"] = 0x25BF;
        t["whitedownpointingtriangle"] = 0x25BD;
        t["whiteleftpointingsmalltriangle"] = 0x25C3;
        t["whiteleftpointingtriangle"] = 0x25C1;
        t["whitelenticularbracketleft"] = 0x3016;
        t["whitelenticularbracketright"] = 0x3017;
        t["whiterightpointingsmalltriangle"] = 0x25B9;
        t["whiterightpointingtriangle"] = 0x25B7;
        t["whitesmallsquare"] = 0x25AB;
        t["whitesmilingface"] = 0x263A;
        t["whitesquare"] = 0x25A1;
        t["whitestar"] = 0x2606;
        t["whitetelephone"] = 0x260F;
        t["whitetortoiseshellbracketleft"] = 0x3018;
        t["whitetortoiseshellbracketright"] = 0x3019;
        t["whiteuppointingsmalltriangle"] = 0x25B5;
        t["whiteuppointingtriangle"] = 0x25B3;
        t["wihiragana"] = 0x3090;
        t["wikatakana"] = 0x30F0;
        t["wikorean"] = 0x315F;
        t["wmonospace"] = 0xFF57;
        t["wohiragana"] = 0x3092;
        t["wokatakana"] = 0x30F2;
        t["wokatakanahalfwidth"] = 0xFF66;
        t["won"] = 0x20A9;
        t["wonmonospace"] = 0xFFE6;
        t["wowaenthai"] = 0x0E27;
        t["wparen"] = 0x24B2;
        t["wring"] = 0x1E98;
        t["wsuperior"] = 0x02B7;
        t["wturned"] = 0x028D;
        t["wynn"] = 0x01BF;
        t["x"] = 0x0078;
        t["xabovecmb"] = 0x033D;
        t["xbopomofo"] = 0x3112;
        t["xcircle"] = 0x24E7;
        t["xdieresis"] = 0x1E8D;
        t["xdotaccent"] = 0x1E8B;
        t["xeharmenian"] = 0x056D;
        t["xi"] = 0x03BE;
        t["xmonospace"] = 0xFF58;
        t["xparen"] = 0x24B3;
        t["xsuperior"] = 0x02E3;
        t["y"] = 0x0079;
        t["yaadosquare"] = 0x334E;
        t["yabengali"] = 0x09AF;
        t["yacute"] = 0x00FD;
        t["yadeva"] = 0x092F;
        t["yaekorean"] = 0x3152;
        t["yagujarati"] = 0x0AAF;
        t["yagurmukhi"] = 0x0A2F;
        t["yahiragana"] = 0x3084;
        t["yakatakana"] = 0x30E4;
        t["yakatakanahalfwidth"] = 0xFF94;
        t["yakorean"] = 0x3151;
        t["yamakkanthai"] = 0x0E4E;
        t["yasmallhiragana"] = 0x3083;
        t["yasmallkatakana"] = 0x30E3;
        t["yasmallkatakanahalfwidth"] = 0xFF6C;
        t["yatcyrillic"] = 0x0463;
        t["ycircle"] = 0x24E8;
        t["ycircumflex"] = 0x0177;
        t["ydieresis"] = 0x00FF;
        t["ydotaccent"] = 0x1E8F;
        t["ydotbelow"] = 0x1EF5;
        t["yeharabic"] = 0x064A;
        t["yehbarreearabic"] = 0x06D2;
        t["yehbarreefinalarabic"] = 0xFBAF;
        t["yehfinalarabic"] = 0xFEF2;
        t["yehhamzaabovearabic"] = 0x0626;
        t["yehhamzaabovefinalarabic"] = 0xFE8A;
        t["yehhamzaaboveinitialarabic"] = 0xFE8B;
        t["yehhamzaabovemedialarabic"] = 0xFE8C;
        t["yehinitialarabic"] = 0xFEF3;
        t["yehmedialarabic"] = 0xFEF4;
        t["yehmeeminitialarabic"] = 0xFCDD;
        t["yehmeemisolatedarabic"] = 0xFC58;
        t["yehnoonfinalarabic"] = 0xFC94;
        t["yehthreedotsbelowarabic"] = 0x06D1;
        t["yekorean"] = 0x3156;
        t["yen"] = 0x00A5;
        t["yenmonospace"] = 0xFFE5;
        t["yeokorean"] = 0x3155;
        t["yeorinhieuhkorean"] = 0x3186;
        t["yerahbenyomohebrew"] = 0x05AA;
        t["yerahbenyomolefthebrew"] = 0x05AA;
        t["yericyrillic"] = 0x044B;
        t["yerudieresiscyrillic"] = 0x04F9;
        t["yesieungkorean"] = 0x3181;
        t["yesieungpansioskorean"] = 0x3183;
        t["yesieungsioskorean"] = 0x3182;
        t["yetivhebrew"] = 0x059A;
        t["ygrave"] = 0x1EF3;
        t["yhook"] = 0x01B4;
        t["yhookabove"] = 0x1EF7;
        t["yiarmenian"] = 0x0575;
        t["yicyrillic"] = 0x0457;
        t["yikorean"] = 0x3162;
        t["yinyang"] = 0x262F;
        t["yiwnarmenian"] = 0x0582;
        t["ymonospace"] = 0xFF59;
        t["yod"] = 0x05D9;
        t["yoddagesh"] = 0xFB39;
        t["yoddageshhebrew"] = 0xFB39;
        t["yodhebrew"] = 0x05D9;
        t["yodyodhebrew"] = 0x05F2;
        t["yodyodpatahhebrew"] = 0xFB1F;
        t["yohiragana"] = 0x3088;
        t["yoikorean"] = 0x3189;
        t["yokatakana"] = 0x30E8;
        t["yokatakanahalfwidth"] = 0xFF96;
        t["yokorean"] = 0x315B;
        t["yosmallhiragana"] = 0x3087;
        t["yosmallkatakana"] = 0x30E7;
        t["yosmallkatakanahalfwidth"] = 0xFF6E;
        t["yotgreek"] = 0x03F3;
        t["yoyaekorean"] = 0x3188;
        t["yoyakorean"] = 0x3187;
        t["yoyakthai"] = 0x0E22;
        t["yoyingthai"] = 0x0E0D;
        t["yparen"] = 0x24B4;
        t["ypogegrammeni"] = 0x037A;
        t["ypogegrammenigreekcmb"] = 0x0345;
        t["yr"] = 0x01A6;
        t["yring"] = 0x1E99;
        t["ysuperior"] = 0x02B8;
        t["ytilde"] = 0x1EF9;
        t["yturned"] = 0x028E;
        t["yuhiragana"] = 0x3086;
        t["yuikorean"] = 0x318C;
        t["yukatakana"] = 0x30E6;
        t["yukatakanahalfwidth"] = 0xFF95;
        t["yukorean"] = 0x3160;
        t["yusbigcyrillic"] = 0x046B;
        t["yusbigiotifiedcyrillic"] = 0x046D;
        t["yuslittlecyrillic"] = 0x0467;
        t["yuslittleiotifiedcyrillic"] = 0x0469;
        t["yusmallhiragana"] = 0x3085;
        t["yusmallkatakana"] = 0x30E5;
        t["yusmallkatakanahalfwidth"] = 0xFF6D;
        t["yuyekorean"] = 0x318B;
        t["yuyeokorean"] = 0x318A;
        t["yyabengali"] = 0x09DF;
        t["yyadeva"] = 0x095F;
        t["z"] = 0x007A;
        t["zaarmenian"] = 0x0566;
        t["zacute"] = 0x017A;
        t["zadeva"] = 0x095B;
        t["zagurmukhi"] = 0x0A5B;
        t["zaharabic"] = 0x0638;
        t["zahfinalarabic"] = 0xFEC6;
        t["zahinitialarabic"] = 0xFEC7;
        t["zahiragana"] = 0x3056;
        t["zahmedialarabic"] = 0xFEC8;
        t["zainarabic"] = 0x0632;
        t["zainfinalarabic"] = 0xFEB0;
        t["zakatakana"] = 0x30B6;
        t["zaqefgadolhebrew"] = 0x0595;
        t["zaqefqatanhebrew"] = 0x0594;
        t["zarqahebrew"] = 0x0598;
        t["zayin"] = 0x05D6;
        t["zayindagesh"] = 0xFB36;
        t["zayindageshhebrew"] = 0xFB36;
        t["zayinhebrew"] = 0x05D6;
        t["zbopomofo"] = 0x3117;
        t["zcaron"] = 0x017E;
        t["zcircle"] = 0x24E9;
        t["zcircumflex"] = 0x1E91;
        t["zcurl"] = 0x0291;
        t["zdot"] = 0x017C;
        t["zdotaccent"] = 0x017C;
        t["zdotbelow"] = 0x1E93;
        t["zecyrillic"] = 0x0437;
        t["zedescendercyrillic"] = 0x0499;
        t["zedieresiscyrillic"] = 0x04DF;
        t["zehiragana"] = 0x305C;
        t["zekatakana"] = 0x30BC;
        t["zero"] = 0x0030;
        t["zeroarabic"] = 0x0660;
        t["zerobengali"] = 0x09E6;
        t["zerodeva"] = 0x0966;
        t["zerogujarati"] = 0x0AE6;
        t["zerogurmukhi"] = 0x0A66;
        t["zerohackarabic"] = 0x0660;
        t["zeroinferior"] = 0x2080;
        t["zeromonospace"] = 0xFF10;
        t["zerooldstyle"] = 0xF730;
        t["zeropersian"] = 0x06F0;
        t["zerosuperior"] = 0x2070;
        t["zerothai"] = 0x0E50;
        t["zerowidthjoiner"] = 0xFEFF;
        t["zerowidthnonjoiner"] = 0x200C;
        t["zerowidthspace"] = 0x200B;
        t["zeta"] = 0x03B6;
        t["zhbopomofo"] = 0x3113;
        t["zhearmenian"] = 0x056A;
        t["zhebrevecyrillic"] = 0x04C2;
        t["zhecyrillic"] = 0x0436;
        t["zhedescendercyrillic"] = 0x0497;
        t["zhedieresiscyrillic"] = 0x04DD;
        t["zihiragana"] = 0x3058;
        t["zikatakana"] = 0x30B8;
        t["zinorhebrew"] = 0x05AE;
        t["zlinebelow"] = 0x1E95;
        t["zmonospace"] = 0xFF5A;
        t["zohiragana"] = 0x305E;
        t["zokatakana"] = 0x30BE;
        t["zparen"] = 0x24B5;
        t["zretroflexhook"] = 0x0290;
        t["zstroke"] = 0x01B6;
        t["zuhiragana"] = 0x305A;
        t["zukatakana"] = 0x30BA;
        t[".notdef"] = 0x0000;
        t["angbracketleftbig"] = 0x2329;
        t["angbracketleftBig"] = 0x2329;
        t["angbracketleftbigg"] = 0x2329;
        t["angbracketleftBigg"] = 0x2329;
        t["angbracketrightBig"] = 0x232A;
        t["angbracketrightbig"] = 0x232A;
        t["angbracketrightBigg"] = 0x232A;
        t["angbracketrightbigg"] = 0x232A;
        t["arrowhookleft"] = 0x21AA;
        t["arrowhookright"] = 0x21A9;
        t["arrowlefttophalf"] = 0x21BC;
        t["arrowleftbothalf"] = 0x21BD;
        t["arrownortheast"] = 0x2197;
        t["arrownorthwest"] = 0x2196;
        t["arrowrighttophalf"] = 0x21C0;
        t["arrowrightbothalf"] = 0x21C1;
        t["arrowsoutheast"] = 0x2198;
        t["arrowsouthwest"] = 0x2199;
        t["backslashbig"] = 0x2216;
        t["backslashBig"] = 0x2216;
        t["backslashBigg"] = 0x2216;
        t["backslashbigg"] = 0x2216;
        t["bardbl"] = 0x2016;
        t["bracehtipdownleft"] = 0xFE37;
        t["bracehtipdownright"] = 0xFE37;
        t["bracehtipupleft"] = 0xFE38;
        t["bracehtipupright"] = 0xFE38;
        t["braceleftBig"] = 0x007B;
        t["braceleftbig"] = 0x007B;
        t["braceleftbigg"] = 0x007B;
        t["braceleftBigg"] = 0x007B;
        t["bracerightBig"] = 0x007D;
        t["bracerightbig"] = 0x007D;
        t["bracerightbigg"] = 0x007D;
        t["bracerightBigg"] = 0x007D;
        t["bracketleftbig"] = 0x005B;
        t["bracketleftBig"] = 0x005B;
        t["bracketleftbigg"] = 0x005B;
        t["bracketleftBigg"] = 0x005B;
        t["bracketrightBig"] = 0x005D;
        t["bracketrightbig"] = 0x005D;
        t["bracketrightbigg"] = 0x005D;
        t["bracketrightBigg"] = 0x005D;
        t["ceilingleftbig"] = 0x2308;
        t["ceilingleftBig"] = 0x2308;
        t["ceilingleftBigg"] = 0x2308;
        t["ceilingleftbigg"] = 0x2308;
        t["ceilingrightbig"] = 0x2309;
        t["ceilingrightBig"] = 0x2309;
        t["ceilingrightbigg"] = 0x2309;
        t["ceilingrightBigg"] = 0x2309;
        t["circledotdisplay"] = 0x2299;
        t["circledottext"] = 0x2299;
        t["circlemultiplydisplay"] = 0x2297;
        t["circlemultiplytext"] = 0x2297;
        t["circleplusdisplay"] = 0x2295;
        t["circleplustext"] = 0x2295;
        t["contintegraldisplay"] = 0x222E;
        t["contintegraltext"] = 0x222E;
        t["coproductdisplay"] = 0x2210;
        t["coproducttext"] = 0x2210;
        t["floorleftBig"] = 0x230A;
        t["floorleftbig"] = 0x230A;
        t["floorleftbigg"] = 0x230A;
        t["floorleftBigg"] = 0x230A;
        t["floorrightbig"] = 0x230B;
        t["floorrightBig"] = 0x230B;
        t["floorrightBigg"] = 0x230B;
        t["floorrightbigg"] = 0x230B;
        t["hatwide"] = 0x0302;
        t["hatwider"] = 0x0302;
        t["hatwidest"] = 0x0302;
        t["intercal"] = 0x1D40;
        t["integraldisplay"] = 0x222B;
        t["integraltext"] = 0x222B;
        t["intersectiondisplay"] = 0x22C2;
        t["intersectiontext"] = 0x22C2;
        t["logicalanddisplay"] = 0x2227;
        t["logicalandtext"] = 0x2227;
        t["logicalordisplay"] = 0x2228;
        t["logicalortext"] = 0x2228;
        t["parenleftBig"] = 0x0028;
        t["parenleftbig"] = 0x0028;
        t["parenleftBigg"] = 0x0028;
        t["parenleftbigg"] = 0x0028;
        t["parenrightBig"] = 0x0029;
        t["parenrightbig"] = 0x0029;
        t["parenrightBigg"] = 0x0029;
        t["parenrightbigg"] = 0x0029;
        t["prime"] = 0x2032;
        t["productdisplay"] = 0x220F;
        t["producttext"] = 0x220F;
        t["radicalbig"] = 0x221A;
        t["radicalBig"] = 0x221A;
        t["radicalBigg"] = 0x221A;
        t["radicalbigg"] = 0x221A;
        t["radicalbt"] = 0x221A;
        t["radicaltp"] = 0x221A;
        t["radicalvertex"] = 0x221A;
        t["slashbig"] = 0x002F;
        t["slashBig"] = 0x002F;
        t["slashBigg"] = 0x002F;
        t["slashbigg"] = 0x002F;
        t["summationdisplay"] = 0x2211;
        t["summationtext"] = 0x2211;
        t["tildewide"] = 0x02DC;
        t["tildewider"] = 0x02DC;
        t["tildewidest"] = 0x02DC;
        t["uniondisplay"] = 0x22C3;
        t["unionmultidisplay"] = 0x228E;
        t["unionmultitext"] = 0x228E;
        t["unionsqdisplay"] = 0x2294;
        t["unionsqtext"] = 0x2294;
        t["uniontext"] = 0x22C3;
        t["vextenddouble"] = 0x2225;
        t["vextendsingle"] = 0x2223;
      });
      var getDingbatsGlyphsUnicode = getLookupTableFactory(function (t) {
        t["space"] = 0x0020;
        t["a1"] = 0x2701;
        t["a2"] = 0x2702;
        t["a202"] = 0x2703;
        t["a3"] = 0x2704;
        t["a4"] = 0x260E;
        t["a5"] = 0x2706;
        t["a119"] = 0x2707;
        t["a118"] = 0x2708;
        t["a117"] = 0x2709;
        t["a11"] = 0x261B;
        t["a12"] = 0x261E;
        t["a13"] = 0x270C;
        t["a14"] = 0x270D;
        t["a15"] = 0x270E;
        t["a16"] = 0x270F;
        t["a105"] = 0x2710;
        t["a17"] = 0x2711;
        t["a18"] = 0x2712;
        t["a19"] = 0x2713;
        t["a20"] = 0x2714;
        t["a21"] = 0x2715;
        t["a22"] = 0x2716;
        t["a23"] = 0x2717;
        t["a24"] = 0x2718;
        t["a25"] = 0x2719;
        t["a26"] = 0x271A;
        t["a27"] = 0x271B;
        t["a28"] = 0x271C;
        t["a6"] = 0x271D;
        t["a7"] = 0x271E;
        t["a8"] = 0x271F;
        t["a9"] = 0x2720;
        t["a10"] = 0x2721;
        t["a29"] = 0x2722;
        t["a30"] = 0x2723;
        t["a31"] = 0x2724;
        t["a32"] = 0x2725;
        t["a33"] = 0x2726;
        t["a34"] = 0x2727;
        t["a35"] = 0x2605;
        t["a36"] = 0x2729;
        t["a37"] = 0x272A;
        t["a38"] = 0x272B;
        t["a39"] = 0x272C;
        t["a40"] = 0x272D;
        t["a41"] = 0x272E;
        t["a42"] = 0x272F;
        t["a43"] = 0x2730;
        t["a44"] = 0x2731;
        t["a45"] = 0x2732;
        t["a46"] = 0x2733;
        t["a47"] = 0x2734;
        t["a48"] = 0x2735;
        t["a49"] = 0x2736;
        t["a50"] = 0x2737;
        t["a51"] = 0x2738;
        t["a52"] = 0x2739;
        t["a53"] = 0x273A;
        t["a54"] = 0x273B;
        t["a55"] = 0x273C;
        t["a56"] = 0x273D;
        t["a57"] = 0x273E;
        t["a58"] = 0x273F;
        t["a59"] = 0x2740;
        t["a60"] = 0x2741;
        t["a61"] = 0x2742;
        t["a62"] = 0x2743;
        t["a63"] = 0x2744;
        t["a64"] = 0x2745;
        t["a65"] = 0x2746;
        t["a66"] = 0x2747;
        t["a67"] = 0x2748;
        t["a68"] = 0x2749;
        t["a69"] = 0x274A;
        t["a70"] = 0x274B;
        t["a71"] = 0x25CF;
        t["a72"] = 0x274D;
        t["a73"] = 0x25A0;
        t["a74"] = 0x274F;
        t["a203"] = 0x2750;
        t["a75"] = 0x2751;
        t["a204"] = 0x2752;
        t["a76"] = 0x25B2;
        t["a77"] = 0x25BC;
        t["a78"] = 0x25C6;
        t["a79"] = 0x2756;
        t["a81"] = 0x25D7;
        t["a82"] = 0x2758;
        t["a83"] = 0x2759;
        t["a84"] = 0x275A;
        t["a97"] = 0x275B;
        t["a98"] = 0x275C;
        t["a99"] = 0x275D;
        t["a100"] = 0x275E;
        t["a101"] = 0x2761;
        t["a102"] = 0x2762;
        t["a103"] = 0x2763;
        t["a104"] = 0x2764;
        t["a106"] = 0x2765;
        t["a107"] = 0x2766;
        t["a108"] = 0x2767;
        t["a112"] = 0x2663;
        t["a111"] = 0x2666;
        t["a110"] = 0x2665;
        t["a109"] = 0x2660;
        t["a120"] = 0x2460;
        t["a121"] = 0x2461;
        t["a122"] = 0x2462;
        t["a123"] = 0x2463;
        t["a124"] = 0x2464;
        t["a125"] = 0x2465;
        t["a126"] = 0x2466;
        t["a127"] = 0x2467;
        t["a128"] = 0x2468;
        t["a129"] = 0x2469;
        t["a130"] = 0x2776;
        t["a131"] = 0x2777;
        t["a132"] = 0x2778;
        t["a133"] = 0x2779;
        t["a134"] = 0x277A;
        t["a135"] = 0x277B;
        t["a136"] = 0x277C;
        t["a137"] = 0x277D;
        t["a138"] = 0x277E;
        t["a139"] = 0x277F;
        t["a140"] = 0x2780;
        t["a141"] = 0x2781;
        t["a142"] = 0x2782;
        t["a143"] = 0x2783;
        t["a144"] = 0x2784;
        t["a145"] = 0x2785;
        t["a146"] = 0x2786;
        t["a147"] = 0x2787;
        t["a148"] = 0x2788;
        t["a149"] = 0x2789;
        t["a150"] = 0x278A;
        t["a151"] = 0x278B;
        t["a152"] = 0x278C;
        t["a153"] = 0x278D;
        t["a154"] = 0x278E;
        t["a155"] = 0x278F;
        t["a156"] = 0x2790;
        t["a157"] = 0x2791;
        t["a158"] = 0x2792;
        t["a159"] = 0x2793;
        t["a160"] = 0x2794;
        t["a161"] = 0x2192;
        t["a163"] = 0x2194;
        t["a164"] = 0x2195;
        t["a196"] = 0x2798;
        t["a165"] = 0x2799;
        t["a192"] = 0x279A;
        t["a166"] = 0x279B;
        t["a167"] = 0x279C;
        t["a168"] = 0x279D;
        t["a169"] = 0x279E;
        t["a170"] = 0x279F;
        t["a171"] = 0x27A0;
        t["a172"] = 0x27A1;
        t["a173"] = 0x27A2;
        t["a162"] = 0x27A3;
        t["a174"] = 0x27A4;
        t["a175"] = 0x27A5;
        t["a176"] = 0x27A6;
        t["a177"] = 0x27A7;
        t["a178"] = 0x27A8;
        t["a179"] = 0x27A9;
        t["a193"] = 0x27AA;
        t["a180"] = 0x27AB;
        t["a199"] = 0x27AC;
        t["a181"] = 0x27AD;
        t["a200"] = 0x27AE;
        t["a182"] = 0x27AF;
        t["a201"] = 0x27B1;
        t["a183"] = 0x27B2;
        t["a184"] = 0x27B3;
        t["a197"] = 0x27B4;
        t["a185"] = 0x27B5;
        t["a194"] = 0x27B6;
        t["a198"] = 0x27B7;
        t["a186"] = 0x27B8;
        t["a195"] = 0x27B9;
        t["a187"] = 0x27BA;
        t["a188"] = 0x27BB;
        t["a189"] = 0x27BC;
        t["a190"] = 0x27BD;
        t["a191"] = 0x27BE;
        t["a89"] = 0x2768;
        t["a90"] = 0x2769;
        t["a93"] = 0x276A;
        t["a94"] = 0x276B;
        t["a91"] = 0x276C;
        t["a92"] = 0x276D;
        t["a205"] = 0x276E;
        t["a85"] = 0x276F;
        t["a206"] = 0x2770;
        t["a86"] = 0x2771;
        t["a87"] = 0x2772;
        t["a88"] = 0x2773;
        t["a95"] = 0x2774;
        t["a96"] = 0x2775;
        t[".notdef"] = 0x0000;
      });
      exports.getGlyphsUnicode = getGlyphsUnicode;
      exports.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;

      /***/ }),
    /* 48 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = !__w_pdfjs_require__(11) && !__w_pdfjs_require__(12)(function () {
        return Object.defineProperty(__w_pdfjs_require__(35)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });

      /***/ }),
    /* 49 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var hide = __w_pdfjs_require__(8);
      var uid = __w_pdfjs_require__(17);
      var TYPED = uid("typed_array");
      var VIEW = uid("view");
      var ABV = !!(global.ArrayBuffer && global.DataView);
      var CONSTR = ABV;
      var i = 0;
      var l = 9;
      var Typed;
      var TypedArrayConstructors = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");
      while (i < l) {
        if (Typed = global[TypedArrayConstructors[i++]]) {
          hide(Typed.prototype, TYPED, true);
          hide(Typed.prototype, VIEW, true);
        } else CONSTR = false;
      }
      module.exports = {
        ABV: ABV,
        CONSTR: CONSTR,
        TYPED: TYPED,
        VIEW: VIEW
      };

      /***/ }),
    /* 50 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(18);
      var toLength = __w_pdfjs_require__(14);
      module.exports = function (it) {
        if (it === undefined) return 0;
        var number = toInteger(it);
        var length = toLength(number);
        if (number !== length) throw RangeError("Wrong length!");
        return length;
      };

      /***/ }),
    /* 51 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $keys = __w_pdfjs_require__(52);
      var hiddenKeys = __w_pdfjs_require__(40).concat("length", "prototype");
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };

      /***/ }),
    /* 52 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var has = __w_pdfjs_require__(10);
      var toIObject = __w_pdfjs_require__(30);
      var arrayIndexOf = __w_pdfjs_require__(53)(false);
      var IE_PROTO = __w_pdfjs_require__(39)("IE_PROTO");
      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) {
          if (key != IE_PROTO) has(O, key) && result.push(key);
        } while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        } return result;
      };

      /***/ }),
    /* 53 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toIObject = __w_pdfjs_require__(30);
      var toLength = __w_pdfjs_require__(14);
      var toAbsoluteIndex = __w_pdfjs_require__(31);
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            if (value != value) return true;
          } else for (; length > index; index++) {
            if (IS_INCLUDES || index in O) {
              if (O[index] === el) return IS_INCLUDES || index || 0;
            }
          } return !IS_INCLUDES && -1;
        };
      };

      /***/ }),
    /* 54 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var SHARED = "__core-js_shared__";
      var store = global[SHARED] || (global[SHARED] = {});
      module.exports = function (key) {
        return store[key] || (store[key] = {});
      };

      /***/ }),
    /* 55 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toObject = __w_pdfjs_require__(19);
      var toAbsoluteIndex = __w_pdfjs_require__(31);
      var toLength = __w_pdfjs_require__(14);
      module.exports = function fill(value) {
        var O = toObject(this);
        var length = toLength(O.length);
        var aLen = arguments.length;
        var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
        var end = aLen > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
        while (endPos > index) {
          O[index++] = value;
        } return O;
      };

      /***/ }),
    /* 56 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var Iterators = __w_pdfjs_require__(20);
      var ITERATOR = __w_pdfjs_require__(4)("iterator");
      var ArrayProto = Array.prototype;
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };

      /***/ }),
    /* 57 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(9);
      var dPs = __w_pdfjs_require__(90);
      var enumBugKeys = __w_pdfjs_require__(40);
      var IE_PROTO = __w_pdfjs_require__(39)("IE_PROTO");
      var Empty = function Empty() {};
      var PROTOTYPE = "prototype";
      var _createDict = function createDict() {
        var iframe = __w_pdfjs_require__(35)("iframe");
        var i = enumBugKeys.length;
        var lt = "<";
        var gt = ">";
        var iframeDocument;
        iframe.style.display = "none";
        __w_pdfjs_require__(58).appendChild(iframe);
        iframe.src = "javascript:";
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
        iframeDocument.close();
        _createDict = iframeDocument.F;
        while (i--) {
          delete _createDict[PROTOTYPE][enumBugKeys[i]];
        } return _createDict();
      };
      module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null;
          result[IE_PROTO] = O;
        } else result = _createDict();
        return Properties === undefined ? result : dPs(result, Properties);
      };

      /***/ }),
    /* 58 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var document = __w_pdfjs_require__(1).document;
      module.exports = document && document.documentElement;

      /***/ }),
    /* 59 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var has = __w_pdfjs_require__(10);
      var toObject = __w_pdfjs_require__(19);
      var IE_PROTO = __w_pdfjs_require__(39)("IE_PROTO");
      var ObjectProto = Object.prototype;
      module.exports = Object.getPrototypeOf || function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor === "function" && O instanceof O.constructor) {
          return O.constructor.prototype;
        }
        return O instanceof Object ? ObjectProto : null;
      };

      /***/ }),
    /* 60 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var classof = __w_pdfjs_require__(32);
      var ITERATOR = __w_pdfjs_require__(4)("iterator");
      var Iterators = __w_pdfjs_require__(20);
      module.exports = __w_pdfjs_require__(7).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
      };

      /***/ }),
    /* 61 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var addToUnscopables = __w_pdfjs_require__(94);
      var step = __w_pdfjs_require__(95);
      var Iterators = __w_pdfjs_require__(20);
      var toIObject = __w_pdfjs_require__(30);
      module.exports = __w_pdfjs_require__(62)(Array, "Array", function (iterated, kind) {
        this._t = toIObject(iterated);
        this._i = 0;
        this._k = kind;
      }, function () {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
          this._t = undefined;
          return step(1);
        }
        if (kind == "keys") return step(0, index);
        if (kind == "values") return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, "values");
      Iterators.Arguments = Iterators.Array;
      addToUnscopables("keys");
      addToUnscopables("values");
      addToUnscopables("entries");

      /***/ }),
    /* 62 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var LIBRARY = __w_pdfjs_require__(28);
      var $export = __w_pdfjs_require__(6);
      var redefine = __w_pdfjs_require__(16);
      var hide = __w_pdfjs_require__(8);
      var has = __w_pdfjs_require__(10);
      var Iterators = __w_pdfjs_require__(20);
      var $iterCreate = __w_pdfjs_require__(96);
      var setToStringTag = __w_pdfjs_require__(25);
      var getPrototypeOf = __w_pdfjs_require__(59);
      var ITERATOR = __w_pdfjs_require__(4)("iterator");
      var BUGGY = !([].keys && "next" in [].keys());
      var FF_ITERATOR = "@@iterator";
      var KEYS = "keys";
      var VALUES = "values";
      var returnThis = function returnThis() {
        return this;
      };
      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function getMethod(kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + " Iterator";
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
        var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            setToStringTag(IteratorPrototype, TAG, true);
            if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };

      /***/ }),
    /* 63 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var dP = __w_pdfjs_require__(15);
      var DESCRIPTORS = __w_pdfjs_require__(11);
      var SPECIES = __w_pdfjs_require__(4)("species");
      module.exports = function (KEY) {
        var C = global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
          configurable: true,
          get: function get() {
            return this;
          }
        });
      };

      /***/ }),
    /* 64 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var pIE = __w_pdfjs_require__(65);
      var createDesc = __w_pdfjs_require__(29);
      var toIObject = __w_pdfjs_require__(30);
      var toPrimitive = __w_pdfjs_require__(36);
      var has = __w_pdfjs_require__(10);
      var IE8_DOM_DEFINE = __w_pdfjs_require__(48);
      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = __w_pdfjs_require__(11) ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {}
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };

      /***/ }),
    /* 65 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      exports.f = {}.propertyIsEnumerable;

      /***/ }),
    /* 66 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var classof = __w_pdfjs_require__(32);
      var test = {};
      test[__w_pdfjs_require__(4)("toStringTag")] = "z";
      if (test + "" != "[object z]") {
        __w_pdfjs_require__(16)(Object.prototype, "toString", function toString() {
          return "[object " + classof(this) + "]";
        }, true);
      }

      /***/ }),
    /* 67 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $iterators = __w_pdfjs_require__(61);
      var getKeys = __w_pdfjs_require__(41);
      var redefine = __w_pdfjs_require__(16);
      var global = __w_pdfjs_require__(1);
      var hide = __w_pdfjs_require__(8);
      var Iterators = __w_pdfjs_require__(20);
      var wks = __w_pdfjs_require__(4);
      var ITERATOR = wks("iterator");
      var TO_STRING_TAG = wks("toStringTag");
      var ArrayValues = Iterators.Array;
      var DOMIterables = {
        CSSRuleList: true,
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true,
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true,
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false
      };
      for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
        var NAME = collections[i];
        var explicit = DOMIterables[NAME];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        var key;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit) for (key in $iterators) {
            if (!proto[key]) redefine(proto, key, $iterators[key], true);
          }
        }
      }

      /***/ }),
    /* 68 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var ctx = __w_pdfjs_require__(13);
      var invoke = __w_pdfjs_require__(108);
      var html = __w_pdfjs_require__(58);
      var cel = __w_pdfjs_require__(35);
      var global = __w_pdfjs_require__(1);
      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = "onreadystatechange";
      var defer, channel, port;
      var run = function run() {
        var id = +this;
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var listener = function listener(event) {
        run.call(event.data);
      };
      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) {
            args.push(arguments[i++]);
          }queue[++counter] = function () {
            invoke(typeof fn === "function" ? fn : Function(fn), args);
          };
          defer(counter);
          return counter;
        };
        clearTask = function clearImmediate(id) {
          delete queue[id];
        };
        if (__w_pdfjs_require__(24)(process) == "process") {
          defer = function defer(id) {
            process.nextTick(ctx(run, id, 1));
          };
        } else if (Dispatch && Dispatch.now) {
          defer = function defer(id) {
            Dispatch.now(ctx(run, id, 1));
          };
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1);
        } else if (global.addEventListener && typeof postMessage === "function" && !global.importScripts) {
          defer = function defer(id) {
            global.postMessage(id + "", "*");
          };
          global.addEventListener("message", listener, false);
        } else if (ONREADYSTATECHANGE in cel("script")) {
          defer = function defer(id) {
            html.appendChild(cel("script"))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          };
        } else {
          defer = function defer(id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }
      module.exports = {
        set: setTask,
        clear: clearTask
      };

      /***/ }),
    /* 69 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (exec) {
        try {
          return {
            e: false,
            v: exec()
          };
        } catch (e) {
          return {
            e: true,
            v: e
          };
        }
      };

      /***/ }),
    /* 70 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(9);
      var isObject = __w_pdfjs_require__(3);
      var newPromiseCapability = __w_pdfjs_require__(45);
      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };

      /***/ }),
    /* 71 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      module.exports = function (it, TYPE) {
        if (!isObject(it) || it._t !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required!");
        return it;
      };

      /***/ }),
    /* 72 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ChunkedStreamManager = exports.ChunkedStream = undefined;

      var _util = __w_pdfjs_require__(0);

      var ChunkedStream = function ChunkedStreamClosure() {
        function ChunkedStream(length, chunkSize, manager) {
          this.bytes = new Uint8Array(length);
          this.start = 0;
          this.pos = 0;
          this.end = length;
          this.chunkSize = chunkSize;
          this.loadedChunks = [];
          this.numChunksLoaded = 0;
          this.numChunks = Math.ceil(length / chunkSize);
          this.manager = manager;
          this.progressiveDataLength = 0;
          this.lastSuccessfulEnsureByteChunk = -1;
        }
        ChunkedStream.prototype = {
          getMissingChunks: function ChunkedStream_getMissingChunks() {
            var chunks = [];
            for (var chunk = 0, n = this.numChunks; chunk < n; ++chunk) {
              if (!this.loadedChunks[chunk]) {
                chunks.push(chunk);
              }
            }
            return chunks;
          },
          getBaseStreams: function ChunkedStream_getBaseStreams() {
            return [this];
          },
          allChunksLoaded: function ChunkedStream_allChunksLoaded() {
            return this.numChunksLoaded === this.numChunks;
          },
          onReceiveData: function ChunkedStream_onReceiveData(begin, chunk) {
            var end = begin + chunk.byteLength;
            if (begin % this.chunkSize !== 0) {
              throw new Error("Bad begin offset: " + begin);
            }
            var length = this.bytes.length;
            if (end % this.chunkSize !== 0 && end !== length) {
              throw new Error("Bad end offset: " + end);
            }
            this.bytes.set(new Uint8Array(chunk), begin);
            var chunkSize = this.chunkSize;
            var beginChunk = Math.floor(begin / chunkSize);
            var endChunk = Math.floor((end - 1) / chunkSize) + 1;
            var curChunk;
            for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
              if (!this.loadedChunks[curChunk]) {
                this.loadedChunks[curChunk] = true;
                ++this.numChunksLoaded;
              }
            }
          },
          onReceiveProgressiveData: function ChunkedStream_onReceiveProgressiveData(data) {
            var position = this.progressiveDataLength;
            var beginChunk = Math.floor(position / this.chunkSize);
            this.bytes.set(new Uint8Array(data), position);
            position += data.byteLength;
            this.progressiveDataLength = position;
            var endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
            var curChunk;
            for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
              if (!this.loadedChunks[curChunk]) {
                this.loadedChunks[curChunk] = true;
                ++this.numChunksLoaded;
              }
            }
          },
          ensureByte: function ChunkedStream_ensureByte(pos) {
            var chunk = Math.floor(pos / this.chunkSize);
            if (chunk === this.lastSuccessfulEnsureByteChunk) {
              return;
            }
            if (!this.loadedChunks[chunk]) {
              throw new _util.MissingDataException(pos, pos + 1);
            }
            this.lastSuccessfulEnsureByteChunk = chunk;
          },
          ensureRange: function ChunkedStream_ensureRange(begin, end) {
            if (begin >= end) {
              return;
            }
            if (end <= this.progressiveDataLength) {
              return;
            }
            var chunkSize = this.chunkSize;
            var beginChunk = Math.floor(begin / chunkSize);
            var endChunk = Math.floor((end - 1) / chunkSize) + 1;
            for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
              if (!this.loadedChunks[chunk]) {
                throw new _util.MissingDataException(begin, end);
              }
            }
          },
          nextEmptyChunk: function ChunkedStream_nextEmptyChunk(beginChunk) {
            var chunk,
              numChunks = this.numChunks;
            for (var i = 0; i < numChunks; ++i) {
              chunk = (beginChunk + i) % numChunks;
              if (!this.loadedChunks[chunk]) {
                return chunk;
              }
            }
            return null;
          },
          hasChunk: function ChunkedStream_hasChunk(chunk) {
            return !!this.loadedChunks[chunk];
          },
          get length() {
            return this.end - this.start;
          },
          get isEmpty() {
            return this.length === 0;
          },
          getByte: function ChunkedStream_getByte() {
            var pos = this.pos;
            if (pos >= this.end) {
              return -1;
            }
            this.ensureByte(pos);
            return this.bytes[this.pos++];
          },
          getUint16: function ChunkedStream_getUint16() {
            var b0 = this.getByte();
            var b1 = this.getByte();
            if (b0 === -1 || b1 === -1) {
              return -1;
            }
            return (b0 << 8) + b1;
          },
          getInt32: function ChunkedStream_getInt32() {
            var b0 = this.getByte();
            var b1 = this.getByte();
            var b2 = this.getByte();
            var b3 = this.getByte();
            return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
          },
          getBytes: function ChunkedStream_getBytes(length) {
            var bytes = this.bytes;
            var pos = this.pos;
            var strEnd = this.end;
            if (!length) {
              this.ensureRange(pos, strEnd);
              return bytes.subarray(pos, strEnd);
            }
            var end = pos + length;
            if (end > strEnd) {
              end = strEnd;
            }
            this.ensureRange(pos, end);
            this.pos = end;
            return bytes.subarray(pos, end);
          },
          peekByte: function ChunkedStream_peekByte() {
            var peekedByte = this.getByte();
            this.pos--;
            return peekedByte;
          },
          peekBytes: function ChunkedStream_peekBytes(length) {
            var bytes = this.getBytes(length);
            this.pos -= bytes.length;
            return bytes;
          },
          getByteRange: function ChunkedStream_getBytes(begin, end) {
            this.ensureRange(begin, end);
            return this.bytes.subarray(begin, end);
          },
          skip: function ChunkedStream_skip(n) {
            if (!n) {
              n = 1;
            }
            this.pos += n;
          },
          reset: function ChunkedStream_reset() {
            this.pos = this.start;
          },
          moveStart: function ChunkedStream_moveStart() {
            this.start = this.pos;
          },
          makeSubStream: function ChunkedStream_makeSubStream(start, length, dict) {
            this.ensureRange(start, start + length);
            function ChunkedStreamSubstream() {}
            ChunkedStreamSubstream.prototype = Object.create(this);
            ChunkedStreamSubstream.prototype.getMissingChunks = function () {
              var chunkSize = this.chunkSize;
              var beginChunk = Math.floor(this.start / chunkSize);
              var endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
              var missingChunks = [];
              for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
                if (!this.loadedChunks[chunk]) {
                  missingChunks.push(chunk);
                }
              }
              return missingChunks;
            };
            var subStream = new ChunkedStreamSubstream();
            subStream.pos = subStream.start = start;
            subStream.end = start + length || this.end;
            subStream.dict = dict;
            return subStream;
          }
        };
        return ChunkedStream;
      }();
      var ChunkedStreamManager = function ChunkedStreamManagerClosure() {
        function ChunkedStreamManager(pdfNetworkStream, args) {
          var chunkSize = args.rangeChunkSize;
          var length = args.length;
          this.stream = new ChunkedStream(length, chunkSize, this);
          this.length = length;
          this.chunkSize = chunkSize;
          this.pdfNetworkStream = pdfNetworkStream;
          this.url = args.url;
          this.disableAutoFetch = args.disableAutoFetch;
          this.msgHandler = args.msgHandler;
          this.currRequestId = 0;
          this.chunksNeededByRequest = Object.create(null);
          this.requestsByChunk = Object.create(null);
          this.promisesByRequest = Object.create(null);
          this.progressiveDataLength = 0;
          this.aborted = false;
          this._loadedStreamCapability = (0, _util.createPromiseCapability)();
        }
        ChunkedStreamManager.prototype = {
          onLoadedStream: function ChunkedStreamManager_getLoadedStream() {
            return this._loadedStreamCapability.promise;
          },
          sendRequest: function ChunkedStreamManager_sendRequest(begin, end) {
            var _this = this;

            var rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
            if (!rangeReader.isStreamingSupported) {
              rangeReader.onProgress = this.onProgress.bind(this);
            }
            var chunks = [],
              loaded = 0;
            var manager = this;
            var promise = new Promise(function (resolve, reject) {
              var readChunk = function readChunk(chunk) {
                try {
                  if (!chunk.done) {
                    var data = chunk.value;
                    chunks.push(data);
                    loaded += (0, _util.arrayByteLength)(data);
                    if (rangeReader.isStreamingSupported) {
                      manager.onProgress({ loaded: loaded });
                    }
                    rangeReader.read().then(readChunk, reject);
                    return;
                  }
                  var chunkData = (0, _util.arraysToBytes)(chunks);
                  chunks = null;
                  resolve(chunkData);
                } catch (e) {
                  reject(e);
                }
              };
              rangeReader.read().then(readChunk, reject);
            });
            promise.then(function (data) {
              if (_this.aborted) {
                return;
              }
              _this.onReceiveData({
                chunk: data,
                begin: begin
              });
            });
          },
          requestAllChunks: function ChunkedStreamManager_requestAllChunks() {
            var missingChunks = this.stream.getMissingChunks();
            this._requestChunks(missingChunks);
            return this._loadedStreamCapability.promise;
          },
          _requestChunks: function ChunkedStreamManager_requestChunks(chunks) {
            var requestId = this.currRequestId++;
            var i, ii;
            var chunksNeeded = Object.create(null);
            this.chunksNeededByRequest[requestId] = chunksNeeded;
            for (i = 0, ii = chunks.length; i < ii; i++) {
              if (!this.stream.hasChunk(chunks[i])) {
                chunksNeeded[chunks[i]] = true;
              }
            }
            if ((0, _util.isEmptyObj)(chunksNeeded)) {
              return Promise.resolve();
            }
            var capability = (0, _util.createPromiseCapability)();
            this.promisesByRequest[requestId] = capability;
            var chunksToRequest = [];
            for (var chunk in chunksNeeded) {
              chunk = chunk | 0;
              if (!(chunk in this.requestsByChunk)) {
                this.requestsByChunk[chunk] = [];
                chunksToRequest.push(chunk);
              }
              this.requestsByChunk[chunk].push(requestId);
            }
            if (!chunksToRequest.length) {
              return capability.promise;
            }
            var groupedChunksToRequest = this.groupChunks(chunksToRequest);
            for (i = 0; i < groupedChunksToRequest.length; ++i) {
              var groupedChunk = groupedChunksToRequest[i];
              var begin = groupedChunk.beginChunk * this.chunkSize;
              var end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
              this.sendRequest(begin, end);
            }
            return capability.promise;
          },
          getStream: function ChunkedStreamManager_getStream() {
            return this.stream;
          },
          requestRange: function ChunkedStreamManager_requestRange(begin, end) {
            end = Math.min(end, this.length);
            var beginChunk = this.getBeginChunk(begin);
            var endChunk = this.getEndChunk(end);
            var chunks = [];
            for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
              chunks.push(chunk);
            }
            return this._requestChunks(chunks);
          },
          requestRanges: function ChunkedStreamManager_requestRanges(ranges) {
            ranges = ranges || [];
            var chunksToRequest = [];
            for (var i = 0; i < ranges.length; i++) {
              var beginChunk = this.getBeginChunk(ranges[i].begin);
              var endChunk = this.getEndChunk(ranges[i].end);
              for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
                if (chunksToRequest.indexOf(chunk) < 0) {
                  chunksToRequest.push(chunk);
                }
              }
            }
            chunksToRequest.sort(function (a, b) {
              return a - b;
            });
            return this._requestChunks(chunksToRequest);
          },
          groupChunks: function ChunkedStreamManager_groupChunks(chunks) {
            var groupedChunks = [];
            var beginChunk = -1;
            var prevChunk = -1;
            for (var i = 0; i < chunks.length; ++i) {
              var chunk = chunks[i];
              if (beginChunk < 0) {
                beginChunk = chunk;
              }
              if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
                groupedChunks.push({
                  beginChunk: beginChunk,
                  endChunk: prevChunk + 1
                });
                beginChunk = chunk;
              }
              if (i + 1 === chunks.length) {
                groupedChunks.push({
                  beginChunk: beginChunk,
                  endChunk: chunk + 1
                });
              }
              prevChunk = chunk;
            }
            return groupedChunks;
          },
          onProgress: function ChunkedStreamManager_onProgress(args) {
            var bytesLoaded = this.stream.numChunksLoaded * this.chunkSize + args.loaded;
            this.msgHandler.send("DocProgress", {
              loaded: bytesLoaded,
              total: this.length
            });
          },
          onReceiveData: function ChunkedStreamManager_onReceiveData(args) {
            var chunk = args.chunk;
            var isProgressive = args.begin === undefined;
            var begin = isProgressive ? this.progressiveDataLength : args.begin;
            var end = begin + chunk.byteLength;
            var beginChunk = Math.floor(begin / this.chunkSize);
            var endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
            if (isProgressive) {
              this.stream.onReceiveProgressiveData(chunk);
              this.progressiveDataLength = end;
            } else {
              this.stream.onReceiveData(begin, chunk);
            }
            if (this.stream.allChunksLoaded()) {
              this._loadedStreamCapability.resolve(this.stream);
            }
            var loadedRequests = [];
            var i, requestId;
            for (chunk = beginChunk; chunk < endChunk; ++chunk) {
              var requestIds = this.requestsByChunk[chunk] || [];
              delete this.requestsByChunk[chunk];
              for (i = 0; i < requestIds.length; ++i) {
                requestId = requestIds[i];
                var chunksNeeded = this.chunksNeededByRequest[requestId];
                if (chunk in chunksNeeded) {
                  delete chunksNeeded[chunk];
                }
                if (!(0, _util.isEmptyObj)(chunksNeeded)) {
                  continue;
                }
                loadedRequests.push(requestId);
              }
            }
            if (!this.disableAutoFetch && (0, _util.isEmptyObj)(this.requestsByChunk)) {
              var nextEmptyChunk;
              if (this.stream.numChunksLoaded === 1) {
                var lastChunk = this.stream.numChunks - 1;
                if (!this.stream.hasChunk(lastChunk)) {
                  nextEmptyChunk = lastChunk;
                }
              } else {
                nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
              }
              if (Number.isInteger(nextEmptyChunk)) {
                this._requestChunks([nextEmptyChunk]);
              }
            }
            for (i = 0; i < loadedRequests.length; ++i) {
              requestId = loadedRequests[i];
              var capability = this.promisesByRequest[requestId];
              delete this.promisesByRequest[requestId];
              capability.resolve();
            }
            this.msgHandler.send("DocProgress", {
              loaded: this.stream.numChunksLoaded * this.chunkSize,
              total: this.length
            });
          },
          onError: function ChunkedStreamManager_onError(err) {
            this._loadedStreamCapability.reject(err);
          },
          getBeginChunk: function ChunkedStreamManager_getBeginChunk(begin) {
            var chunk = Math.floor(begin / this.chunkSize);
            return chunk;
          },
          getEndChunk: function ChunkedStreamManager_getEndChunk(end) {
            var chunk = Math.floor((end - 1) / this.chunkSize) + 1;
            return chunk;
          },
          abort: function ChunkedStreamManager_abort() {
            this.aborted = true;
            if (this.pdfNetworkStream) {
              this.pdfNetworkStream.cancelAllRequests("abort");
            }
            for (var requestId in this.promisesByRequest) {
              var capability = this.promisesByRequest[requestId];
              capability.reject(new Error("Request was aborted"));
            }
          }
        };
        return ChunkedStreamManager;
      }();
      exports.ChunkedStream = ChunkedStream;
      exports.ChunkedStreamManager = ChunkedStreamManager;

      /***/ }),
    /* 73 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FileSpec = exports.XRef = exports.ObjectLoader = exports.Catalog = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var _parser = __w_pdfjs_require__(34);

      var _chunked_stream = __w_pdfjs_require__(72);

      var _crypto = __w_pdfjs_require__(76);

      var _colorspace = __w_pdfjs_require__(26);

      var Catalog = function CatalogClosure() {
        function Catalog(pdfManager, xref, pageFactory) {
          this.pdfManager = pdfManager;
          this.xref = xref;
          this.catDict = xref.getCatalogObj();
          if (!(0, _primitives.isDict)(this.catDict)) {
            throw new _util.FormatError("catalog object is not a dictionary");
          }
          this.fontCache = new _primitives.RefSetCache();
          this.builtInCMapCache = Object.create(null);
          this.pageKidsCountCache = new _primitives.RefSetCache();
          this.pageFactory = pageFactory;
          this.pagePromises = [];
        }
        Catalog.prototype = {
          get metadata() {
            var streamRef = this.catDict.getRaw("Metadata");
            if (!(0, _primitives.isRef)(streamRef)) {
              return (0, _util.shadow)(this, "metadata", null);
            }
            var encryptMetadata = !this.xref.encrypt ? false : this.xref.encrypt.encryptMetadata;
            var stream = this.xref.fetch(streamRef, !encryptMetadata);
            var metadata;
            if (stream && (0, _primitives.isDict)(stream.dict)) {
              var type = stream.dict.get("Type");
              var subtype = stream.dict.get("Subtype");
              if ((0, _primitives.isName)(type, "Metadata") && (0, _primitives.isName)(subtype, "XML")) {
                try {
                  metadata = (0, _util.stringToUTF8String)((0, _util.bytesToString)(stream.getBytes()));
                } catch (e) {
                  if (e instanceof _util.MissingDataException) {
                    throw e;
                  }
                  (0, _util.info)("Skipping invalid metadata.");
                }
              }
            }
            return (0, _util.shadow)(this, "metadata", metadata);
          },
          get toplevelPagesDict() {
            var pagesObj = this.catDict.get("Pages");
            if (!(0, _primitives.isDict)(pagesObj)) {
              throw new _util.FormatError("invalid top-level pages dictionary");
            }
            return (0, _util.shadow)(this, "toplevelPagesDict", pagesObj);
          },
          get documentOutline() {
            var obj = null;
            try {
              obj = this.readDocumentOutline();
            } catch (ex) {
              if (ex instanceof _util.MissingDataException) {
                throw ex;
              }
              (0, _util.warn)("Unable to read document outline");
            }
            return (0, _util.shadow)(this, "documentOutline", obj);
          },
          readDocumentOutline: function Catalog_readDocumentOutline() {
            var obj = this.catDict.get("Outlines");
            if (!(0, _primitives.isDict)(obj)) {
              return null;
            }
            obj = obj.getRaw("First");
            if (!(0, _primitives.isRef)(obj)) {
              return null;
            }
            var root = { items: [] };
            var queue = [{
              obj: obj,
              parent: root
            }];
            var processed = new _primitives.RefSet();
            processed.put(obj);
            var xref = this.xref,
              blackColor = new Uint8Array(3);
            while (queue.length > 0) {
              var i = queue.shift();
              var outlineDict = xref.fetchIfRef(i.obj);
              if (outlineDict === null) {
                continue;
              }
              if (!outlineDict.has("Title")) {
                throw new _util.FormatError("Invalid outline item");
              }
              var data = {
                url: null,
                dest: null
              };
              Catalog.parseDestDictionary({
                destDict: outlineDict,
                resultObj: data,
                docBaseUrl: this.pdfManager.docBaseUrl
              });
              var title = outlineDict.get("Title");
              var flags = outlineDict.get("F") || 0;
              var color = outlineDict.getArray("C"),
                rgbColor = blackColor;
              if (Array.isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) {
                rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
              }
              var outlineItem = {
                dest: data.dest,
                url: data.url,
                unsafeUrl: data.unsafeUrl,
                newWindow: data.newWindow,
                title: (0, _util.stringToPDFString)(title),
                color: rgbColor,
                count: outlineDict.get("Count"),
                bold: !!(flags & 2),
                italic: !!(flags & 1),
                items: []
              };
              i.parent.items.push(outlineItem);
              obj = outlineDict.getRaw("First");
              if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
                queue.push({
                  obj: obj,
                  parent: outlineItem
                });
                processed.put(obj);
              }
              obj = outlineDict.getRaw("Next");
              if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
                queue.push({
                  obj: obj,
                  parent: i.parent
                });
                processed.put(obj);
              }
            }
            return root.items.length > 0 ? root.items : null;
          },
          get numPages() {
            var obj = this.toplevelPagesDict.get("Count");
            if (!Number.isInteger(obj)) {
              throw new _util.FormatError("page count in top level pages object is not an integer");
            }
            return (0, _util.shadow)(this, "numPages", obj);
          },
          get destinations() {
            function fetchDestination(dest) {
              return (0, _primitives.isDict)(dest) ? dest.get("D") : dest;
            }
            var xref = this.xref;
            var dests = {},
              nameTreeRef,
              nameDictionaryRef;
            var obj = this.catDict.get("Names");
            if (obj && obj.has("Dests")) {
              nameTreeRef = obj.getRaw("Dests");
            } else if (this.catDict.has("Dests")) {
              nameDictionaryRef = this.catDict.get("Dests");
            }
            if (nameDictionaryRef) {
              obj = nameDictionaryRef;
              obj.forEach(function catalogForEach(key, value) {
                if (!value) {
                  return;
                }
                dests[key] = fetchDestination(value);
              });
            }
            if (nameTreeRef) {
              var nameTree = new NameTree(nameTreeRef, xref);
              var names = nameTree.getAll();
              for (var name in names) {
                dests[name] = fetchDestination(names[name]);
              }
            }
            return (0, _util.shadow)(this, "destinations", dests);
          },
          getDestination: function Catalog_getDestination(destinationId) {
            function fetchDestination(dest) {
              return (0, _primitives.isDict)(dest) ? dest.get("D") : dest;
            }
            var xref = this.xref;
            var dest = null,
              nameTreeRef,
              nameDictionaryRef;
            var obj = this.catDict.get("Names");
            if (obj && obj.has("Dests")) {
              nameTreeRef = obj.getRaw("Dests");
            } else if (this.catDict.has("Dests")) {
              nameDictionaryRef = this.catDict.get("Dests");
            }
            if (nameDictionaryRef) {
              var value = nameDictionaryRef.get(destinationId);
              if (value) {
                dest = fetchDestination(value);
              }
            }
            if (nameTreeRef) {
              var nameTree = new NameTree(nameTreeRef, xref);
              dest = fetchDestination(nameTree.get(destinationId));
            }
            return dest;
          },
          get pageLabels() {
            var obj = null;
            try {
              obj = this.readPageLabels();
            } catch (ex) {
              if (ex instanceof _util.MissingDataException) {
                throw ex;
              }
              (0, _util.warn)("Unable to read page labels.");
            }
            return (0, _util.shadow)(this, "pageLabels", obj);
          },
          readPageLabels: function Catalog_readPageLabels() {
            var obj = this.catDict.getRaw("PageLabels");
            if (!obj) {
              return null;
            }
            var pageLabels = new Array(this.numPages);
            var style = null;
            var prefix = "";
            var numberTree = new NumberTree(obj, this.xref);
            var nums = numberTree.getAll();
            var currentLabel = "",
              currentIndex = 1;
            for (var i = 0, ii = this.numPages; i < ii; i++) {
              if (i in nums) {
                var labelDict = nums[i];
                if (!(0, _primitives.isDict)(labelDict)) {
                  throw new _util.FormatError("The PageLabel is not a dictionary.");
                }
                var type = labelDict.get("Type");
                if (type && !(0, _primitives.isName)(type, "PageLabel")) {
                  throw new _util.FormatError("Invalid type in PageLabel dictionary.");
                }
                var s = labelDict.get("S");
                if (s && !(0, _primitives.isName)(s)) {
                  throw new _util.FormatError("Invalid style in PageLabel dictionary.");
                }
                style = s ? s.name : null;
                var p = labelDict.get("P");
                if (p && !(0, _util.isString)(p)) {
                  throw new _util.FormatError("Invalid prefix in PageLabel dictionary.");
                }
                prefix = p ? (0, _util.stringToPDFString)(p) : "";
                var st = labelDict.get("St");
                if (st && !(Number.isInteger(st) && st >= 1)) {
                  throw new _util.FormatError("Invalid start in PageLabel dictionary.");
                }
                currentIndex = st || 1;
              }
              switch (style) {
                case "D":
                  currentLabel = currentIndex;
                  break;
                case "R":
                case "r":
                  currentLabel = _util.Util.toRoman(currentIndex, style === "r");
                  break;
                case "A":
                case "a":
                  var LIMIT = 26;
                  var A_UPPER_CASE = 0x41,
                    A_LOWER_CASE = 0x61;
                  var baseCharCode = style === "a" ? A_LOWER_CASE : A_UPPER_CASE;
                  var letterIndex = currentIndex - 1;
                  var character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
                  var charBuf = [];
                  for (var j = 0, jj = letterIndex / LIMIT | 0; j <= jj; j++) {
                    charBuf.push(character);
                  }
                  currentLabel = charBuf.join("");
                  break;
                default:
                  if (style) {
                    throw new _util.FormatError("Invalid style \"" + style + "\" in PageLabel dictionary.");
                  }
              }
              pageLabels[i] = prefix + currentLabel;
              currentLabel = "";
              currentIndex++;
            }
            return pageLabels;
          },
          get pageMode() {
            var obj = this.catDict.get("PageMode");
            var pageMode = "UseNone";
            if ((0, _primitives.isName)(obj)) {
              switch (obj.name) {
                case "UseNone":
                case "UseOutlines":
                case "UseThumbs":
                case "FullScreen":
                case "UseOC":
                case "UseAttachments":
                  pageMode = obj.name;
              }
            }
            return (0, _util.shadow)(this, "pageMode", pageMode);
          },
          get attachments() {
            var xref = this.xref;
            var attachments = null,
              nameTreeRef;
            var obj = this.catDict.get("Names");
            if (obj) {
              nameTreeRef = obj.getRaw("EmbeddedFiles");
            }
            if (nameTreeRef) {
              var nameTree = new NameTree(nameTreeRef, xref);
              var names = nameTree.getAll();
              for (var name in names) {
                var fs = new FileSpec(names[name], xref);
                if (!attachments) {
                  attachments = Object.create(null);
                }
                attachments[(0, _util.stringToPDFString)(name)] = fs.serializable;
              }
            }
            return (0, _util.shadow)(this, "attachments", attachments);
          },
          get javaScript() {
            var xref = this.xref;
            var obj = this.catDict.get("Names");
            var javaScript = [];
            function appendIfJavaScriptDict(jsDict) {
              var type = jsDict.get("S");
              if (!(0, _primitives.isName)(type, "JavaScript")) {
                return;
              }
              var js = jsDict.get("JS");
              if ((0, _primitives.isStream)(js)) {
                js = (0, _util.bytesToString)(js.getBytes());
              } else if (!(0, _util.isString)(js)) {
                return;
              }
              javaScript.push((0, _util.stringToPDFString)(js));
            }
            if (obj && obj.has("JavaScript")) {
              var nameTree = new NameTree(obj.getRaw("JavaScript"), xref);
              var names = nameTree.getAll();
              for (var name in names) {
                var jsDict = names[name];
                if ((0, _primitives.isDict)(jsDict)) {
                  appendIfJavaScriptDict(jsDict);
                }
              }
            }
            var openactionDict = this.catDict.get("OpenAction");
            if ((0, _primitives.isDict)(openactionDict, "Action")) {
              var actionType = openactionDict.get("S");
              if ((0, _primitives.isName)(actionType, "Named")) {
                var action = openactionDict.get("N");
                if ((0, _primitives.isName)(action, "Print")) {
                  javaScript.push("print({});");
                }
              } else {
                appendIfJavaScriptDict(openactionDict);
              }
            }
            return (0, _util.shadow)(this, "javaScript", javaScript);
          },
          cleanup: function Catalog_cleanup() {
            var _this = this;

            this.pageKidsCountCache.clear();
            var promises = [];
            this.fontCache.forEach(function (promise) {
              promises.push(promise);
            });
            return Promise.all(promises).then(function (translatedFonts) {
              for (var i = 0, ii = translatedFonts.length; i < ii; i++) {
                var font = translatedFonts[i].dict;
                delete font.translated;
              }
              _this.fontCache.clear();
              _this.builtInCMapCache = Object.create(null);
            });
          },
          getPage: function Catalog_getPage(pageIndex) {
            var _this2 = this;

            if (!(pageIndex in this.pagePromises)) {
              this.pagePromises[pageIndex] = this.getPageDict(pageIndex).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  dict = _ref2[0],
                  ref = _ref2[1];

                return _this2.pageFactory.createPage(pageIndex, dict, ref, _this2.fontCache, _this2.builtInCMapCache);
              });
            }
            return this.pagePromises[pageIndex];
          },
          getPageDict: function Catalog_getPageDict(pageIndex) {
            var capability = (0, _util.createPromiseCapability)();
            var nodesToVisit = [this.catDict.getRaw("Pages")];
            var count,
              currentPageIndex = 0;
            var xref = this.xref,
              pageKidsCountCache = this.pageKidsCountCache;
            function next() {
              while (nodesToVisit.length) {
                var currentNode = nodesToVisit.pop();
                if ((0, _primitives.isRef)(currentNode)) {
                  count = pageKidsCountCache.get(currentNode);
                  if (count > 0 && currentPageIndex + count < pageIndex) {
                    currentPageIndex += count;
                    continue;
                  }
                  xref.fetchAsync(currentNode).then(function (obj) {
                    if ((0, _primitives.isDict)(obj, "Page") || (0, _primitives.isDict)(obj) && !obj.has("Kids")) {
                      if (pageIndex === currentPageIndex) {
                        if (currentNode && !pageKidsCountCache.has(currentNode)) {
                          pageKidsCountCache.put(currentNode, 1);
                        }
                        capability.resolve([obj, currentNode]);
                      } else {
                        currentPageIndex++;
                        next();
                      }
                      return;
                    }
                    nodesToVisit.push(obj);
                    next();
                  }, capability.reject);
                  return;
                }
                if (!(0, _primitives.isDict)(currentNode)) {
                  capability.reject(new _util.FormatError("page dictionary kid reference points to wrong type of object"));
                  return;
                }
                count = currentNode.get("Count");
                var objId = currentNode.objId;
                if (objId && !pageKidsCountCache.has(objId)) {
                  pageKidsCountCache.put(objId, count);
                }
                if (currentPageIndex + count <= pageIndex) {
                  currentPageIndex += count;
                  continue;
                }
                var kids = currentNode.get("Kids");
                if (!Array.isArray(kids)) {
                  capability.reject(new _util.FormatError("page dictionary kids object is not an array"));
                  return;
                }
                for (var last = kids.length - 1; last >= 0; last--) {
                  nodesToVisit.push(kids[last]);
                }
              }
              capability.reject(new Error("Page index " + pageIndex + " not found."));
            }
            next();
            return capability.promise;
          },
          getPageIndex: function Catalog_getPageIndex(pageRef) {
            var xref = this.xref;
            function pagesBeforeRef(kidRef) {
              var total = 0;
              var parentRef;
              return xref.fetchAsync(kidRef).then(function (node) {
                if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node, "Page") && !((0, _primitives.isDict)(node) && !node.has("Type") && node.has("Contents"))) {
                  throw new _util.FormatError("The reference does not point to a /Page Dict.");
                }
                if (!node) {
                  return null;
                }
                if (!(0, _primitives.isDict)(node)) {
                  throw new _util.FormatError("node must be a Dict.");
                }
                parentRef = node.getRaw("Parent");
                return node.getAsync("Parent");
              }).then(function (parent) {
                if (!parent) {
                  return null;
                }
                if (!(0, _primitives.isDict)(parent)) {
                  throw new _util.FormatError("parent must be a Dict.");
                }
                return parent.getAsync("Kids");
              }).then(function (kids) {
                if (!kids) {
                  return null;
                }
                var kidPromises = [];
                var found = false;
                for (var i = 0; i < kids.length; i++) {
                  var kid = kids[i];
                  if (!(0, _primitives.isRef)(kid)) {
                    throw new _util.FormatError("kid must be a Ref.");
                  }
                  if (kid.num === kidRef.num) {
                    found = true;
                    break;
                  }
                  kidPromises.push(xref.fetchAsync(kid).then(function (kid) {
                    if (kid.has("Count")) {
                      var count = kid.get("Count");
                      total += count;
                    } else {
                      total++;
                    }
                  }));
                }
                if (!found) {
                  throw new _util.FormatError("kid ref not found in parents kids");
                }
                return Promise.all(kidPromises).then(function () {
                  return [total, parentRef];
                });
              });
            }
            var total = 0;
            function next(ref) {
              return pagesBeforeRef(ref).then(function (args) {
                if (!args) {
                  return total;
                }
                var count = args[0];
                var parentRef = args[1];
                total += count;
                return next(parentRef);
              });
            }
            return next(pageRef);
          }
        };
        Catalog.parseDestDictionary = function Catalog_parseDestDictionary(params) {
          function addDefaultProtocolToUrl(url) {
            if (url.indexOf("www.") === 0) {
              return "http://" + url;
            }
            return url;
          }
          function tryConvertUrlEncoding(url) {
            try {
              return (0, _util.stringToUTF8String)(url);
            } catch (e) {
              return url;
            }
          }
          var destDict = params.destDict;
          if (!(0, _primitives.isDict)(destDict)) {
            (0, _util.warn)("parseDestDictionary: \"destDict\" must be a dictionary.");
            return;
          }
          var resultObj = params.resultObj;
          if ((typeof resultObj === "undefined" ? "undefined" : _typeof(resultObj)) !== "object") {
            (0, _util.warn)("parseDestDictionary: \"resultObj\" must be an object.");
            return;
          }
          var docBaseUrl = params.docBaseUrl || null;
          var action = destDict.get("A"),
            url,
            dest;
          if (!(0, _primitives.isDict)(action) && destDict.has("Dest")) {
            action = destDict.get("Dest");
          }
          if ((0, _primitives.isDict)(action)) {
            var actionType = action.get("S");
            if (!(0, _primitives.isName)(actionType)) {
              (0, _util.warn)("parseDestDictionary: Invalid type in Action dictionary.");
              return;
            }
            var actionName = actionType.name;
            switch (actionName) {
              case "URI":
                url = action.get("URI");
                if ((0, _primitives.isName)(url)) {
                  url = "/" + url.name;
                } else if ((0, _util.isString)(url)) {
                  url = addDefaultProtocolToUrl(url);
                }
                break;
              case "GoTo":
                dest = action.get("D");
                break;
              case "Launch":
              case "GoToR":
                var urlDict = action.get("F");
                if ((0, _primitives.isDict)(urlDict)) {
                  url = urlDict.get("F") || null;
                } else if ((0, _util.isString)(urlDict)) {
                  url = urlDict;
                }
                var remoteDest = action.get("D");
                if (remoteDest) {
                  if ((0, _primitives.isName)(remoteDest)) {
                    remoteDest = remoteDest.name;
                  }
                  if ((0, _util.isString)(url)) {
                    var baseUrl = url.split("#")[0];
                    if ((0, _util.isString)(remoteDest)) {
                      url = baseUrl + "#" + remoteDest;
                    } else if (Array.isArray(remoteDest)) {
                      url = baseUrl + "#" + JSON.stringify(remoteDest);
                    }
                  }
                }
                var newWindow = action.get("NewWindow");
                if ((0, _util.isBool)(newWindow)) {
                  resultObj.newWindow = newWindow;
                }
                break;
              case "Named":
                var namedAction = action.get("N");
                if ((0, _primitives.isName)(namedAction)) {
                  resultObj.action = namedAction.name;
                }
                break;
              case "JavaScript":
                var jsAction = action.get("JS"),
                  js;
                if ((0, _primitives.isStream)(jsAction)) {
                  js = (0, _util.bytesToString)(jsAction.getBytes());
                } else if ((0, _util.isString)(jsAction)) {
                  js = jsAction;
                }
                if (js) {
                  var URL_OPEN_METHODS = ["app.launchURL", "window.open"];
                  var regex = new RegExp("^\\s*(" + URL_OPEN_METHODS.join("|").split(".").join("\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i");
                  var jsUrl = regex.exec((0, _util.stringToPDFString)(js));
                  if (jsUrl && jsUrl[2]) {
                    url = jsUrl[2];
                    if (jsUrl[3] === "true" && jsUrl[1] === "app.launchURL") {
                      resultObj.newWindow = true;
                    }
                    break;
                  }
                }
              default:
                (0, _util.warn)("parseDestDictionary: Unsupported Action type \"" + actionName + "\".");
                break;
            }
          } else if (destDict.has("Dest")) {
            dest = destDict.get("Dest");
          }
          if ((0, _util.isString)(url)) {
            url = tryConvertUrlEncoding(url);
            var absoluteUrl = (0, _util.createValidAbsoluteUrl)(url, docBaseUrl);
            if (absoluteUrl) {
              resultObj.url = absoluteUrl.href;
            }
            resultObj.unsafeUrl = url;
          }
          if (dest) {
            if ((0, _primitives.isName)(dest)) {
              dest = dest.name;
            }
            if ((0, _util.isString)(dest) || Array.isArray(dest)) {
              resultObj.dest = dest;
            }
          }
        };
        return Catalog;
      }();
      var XRef = function XRefClosure() {
        function XRef(stream, pdfManager) {
          this.stream = stream;
          this.pdfManager = pdfManager;
          this.entries = [];
          this.xrefstms = Object.create(null);
          this.cache = [];
          this.stats = {
            streamTypes: [],
            fontTypes: []
          };
        }
        XRef.prototype = {
          setStartXRef: function XRef_setStartXRef(startXRef) {
            this.startXRefQueue = [startXRef];
          },
          parse: function XRef_parse(recoveryMode) {
            var trailerDict;
            if (!recoveryMode) {
              trailerDict = this.readXRef();
            } else {
              (0, _util.warn)("Indexing all PDF objects");
              trailerDict = this.indexObjects();
            }
            trailerDict.assignXref(this);
            this.trailer = trailerDict;
            var encrypt = trailerDict.get("Encrypt");
            if ((0, _primitives.isDict)(encrypt)) {
              var ids = trailerDict.get("ID");
              var fileId = ids && ids.length ? ids[0] : "";
              encrypt.suppressEncryption = true;
              this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
            }
            if (!(this.root = trailerDict.get("Root"))) {
              throw new _util.FormatError("Invalid root reference");
            }
          },
          processXRefTable: function XRef_processXRefTable(parser) {
            if (!("tableState" in this)) {
              this.tableState = {
                entryNum: 0,
                streamPos: parser.lexer.stream.pos,
                parserBuf1: parser.buf1,
                parserBuf2: parser.buf2
              };
            }
            var obj = this.readXRefTable(parser);
            if (!(0, _primitives.isCmd)(obj, "trailer")) {
              throw new _util.FormatError("Invalid XRef table: could not find trailer dictionary");
            }
            var dict = parser.getObj();
            if (!(0, _primitives.isDict)(dict) && dict.dict) {
              dict = dict.dict;
            }
            if (!(0, _primitives.isDict)(dict)) {
              throw new _util.FormatError("Invalid XRef table: could not parse trailer dictionary");
            }
            delete this.tableState;
            return dict;
          },
          readXRefTable: function XRef_readXRefTable(parser) {
            var stream = parser.lexer.stream;
            var tableState = this.tableState;
            stream.pos = tableState.streamPos;
            parser.buf1 = tableState.parserBuf1;
            parser.buf2 = tableState.parserBuf2;
            var obj;
            while (true) {
              if (!("firstEntryNum" in tableState) || !("entryCount" in tableState)) {
                if ((0, _primitives.isCmd)(obj = parser.getObj(), "trailer")) {
                  break;
                }
                tableState.firstEntryNum = obj;
                tableState.entryCount = parser.getObj();
              }
              var first = tableState.firstEntryNum;
              var count = tableState.entryCount;
              if (!Number.isInteger(first) || !Number.isInteger(count)) {
                throw new _util.FormatError("Invalid XRef table: wrong types in subsection header");
              }
              for (var i = tableState.entryNum; i < count; i++) {
                tableState.streamPos = stream.pos;
                tableState.entryNum = i;
                tableState.parserBuf1 = parser.buf1;
                tableState.parserBuf2 = parser.buf2;
                var entry = {};
                entry.offset = parser.getObj();
                entry.gen = parser.getObj();
                var type = parser.getObj();
                if ((0, _primitives.isCmd)(type, "f")) {
                  entry.free = true;
                } else if ((0, _primitives.isCmd)(type, "n")) {
                  entry.uncompressed = true;
                }
                if (!Number.isInteger(entry.offset) || !Number.isInteger(entry.gen) || !(entry.free || entry.uncompressed)) {
                  throw new _util.FormatError("Invalid entry in XRef subsection: " + first + ", " + count);
                }
                if (i === 0 && entry.free && first === 1) {
                  first = 0;
                }
                if (!this.entries[i + first]) {
                  this.entries[i + first] = entry;
                }
              }
              tableState.entryNum = 0;
              tableState.streamPos = stream.pos;
              tableState.parserBuf1 = parser.buf1;
              tableState.parserBuf2 = parser.buf2;
              delete tableState.firstEntryNum;
              delete tableState.entryCount;
            }
            if (this.entries[0] && !this.entries[0].free) {
              throw new _util.FormatError("Invalid XRef table: unexpected first object");
            }
            return obj;
          },
          processXRefStream: function XRef_processXRefStream(stream) {
            if (!("streamState" in this)) {
              var streamParameters = stream.dict;
              var byteWidths = streamParameters.get("W");
              var range = streamParameters.get("Index");
              if (!range) {
                range = [0, streamParameters.get("Size")];
              }
              this.streamState = {
                entryRanges: range,
                byteWidths: byteWidths,
                entryNum: 0,
                streamPos: stream.pos
              };
            }
            this.readXRefStream(stream);
            delete this.streamState;
            return stream.dict;
          },
          readXRefStream: function XRef_readXRefStream(stream) {
            var i, j;
            var streamState = this.streamState;
            stream.pos = streamState.streamPos;
            var byteWidths = streamState.byteWidths;
            var typeFieldWidth = byteWidths[0];
            var offsetFieldWidth = byteWidths[1];
            var generationFieldWidth = byteWidths[2];
            var entryRanges = streamState.entryRanges;
            while (entryRanges.length > 0) {
              var first = entryRanges[0];
              var n = entryRanges[1];
              if (!Number.isInteger(first) || !Number.isInteger(n)) {
                throw new _util.FormatError("Invalid XRef range fields: " + first + ", " + n);
              }
              if (!Number.isInteger(typeFieldWidth) || !Number.isInteger(offsetFieldWidth) || !Number.isInteger(generationFieldWidth)) {
                throw new _util.FormatError("Invalid XRef entry fields length: " + first + ", " + n);
              }
              for (i = streamState.entryNum; i < n; ++i) {
                streamState.entryNum = i;
                streamState.streamPos = stream.pos;
                var type = 0,
                  offset = 0,
                  generation = 0;
                for (j = 0; j < typeFieldWidth; ++j) {
                  type = type << 8 | stream.getByte();
                }
                if (typeFieldWidth === 0) {
                  type = 1;
                }
                for (j = 0; j < offsetFieldWidth; ++j) {
                  offset = offset << 8 | stream.getByte();
                }
                for (j = 0; j < generationFieldWidth; ++j) {
                  generation = generation << 8 | stream.getByte();
                }
                var entry = {};
                entry.offset = offset;
                entry.gen = generation;
                switch (type) {
                  case 0:
                    entry.free = true;
                    break;
                  case 1:
                    entry.uncompressed = true;
                    break;
                  case 2:
                    break;
                  default:
                    throw new _util.FormatError("Invalid XRef entry type: " + type);
                }
                if (!this.entries[first + i]) {
                  this.entries[first + i] = entry;
                }
              }
              streamState.entryNum = 0;
              streamState.streamPos = stream.pos;
              entryRanges.splice(0, 2);
            }
          },
          indexObjects: function XRef_indexObjects() {
            var TAB = 0x9,
              LF = 0xA,
              CR = 0xD,
              SPACE = 0x20;
            var PERCENT = 0x25,
              LT = 0x3C;
            function readToken(data, offset) {
              var token = "",
                ch = data[offset];
              while (ch !== LF && ch !== CR && ch !== LT) {
                if (++offset >= data.length) {
                  break;
                }
                token += String.fromCharCode(ch);
                ch = data[offset];
              }
              return token;
            }
            function skipUntil(data, offset, what) {
              var length = what.length,
                dataLength = data.length;
              var skipped = 0;
              while (offset < dataLength) {
                var i = 0;
                while (i < length && data[offset + i] === what[i]) {
                  ++i;
                }
                if (i >= length) {
                  break;
                }
                offset++;
                skipped++;
              }
              return skipped;
            }
            var objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
            var trailerBytes = new Uint8Array([116, 114, 97, 105, 108, 101, 114]);
            var startxrefBytes = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]);
            var endobjBytes = new Uint8Array([101, 110, 100, 111, 98, 106]);
            var xrefBytes = new Uint8Array([47, 88, 82, 101, 102]);
            this.entries.length = 0;
            var stream = this.stream;
            stream.pos = 0;
            var buffer = stream.getBytes();
            var position = stream.start,
              length = buffer.length;
            var trailers = [],
              xrefStms = [];
            while (position < length) {
              var ch = buffer[position];
              if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
                ++position;
                continue;
              }
              if (ch === PERCENT) {
                do {
                  ++position;
                  if (position >= length) {
                    break;
                  }
                  ch = buffer[position];
                } while (ch !== LF && ch !== CR);
                continue;
              }
              var token = readToken(buffer, position);
              var m;
              if (token.indexOf("xref") === 0 && (token.length === 4 || /\s/.test(token[4]))) {
                position += skipUntil(buffer, position, trailerBytes);
                trailers.push(position);
                position += skipUntil(buffer, position, startxrefBytes);
              } else if (m = objRegExp.exec(token)) {
                if (typeof this.entries[m[1]] === "undefined") {
                  this.entries[m[1]] = {
                    offset: position - stream.start,
                    gen: m[2] | 0,
                    uncompressed: true
                  };
                }
                var contentLength = skipUntil(buffer, position, endobjBytes) + 7;
                var content = buffer.subarray(position, position + contentLength);
                var xrefTagOffset = skipUntil(content, 0, xrefBytes);
                if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
                  xrefStms.push(position - stream.start);
                  this.xrefstms[position - stream.start] = 1;
                }
                position += contentLength;
              } else if (token.indexOf("trailer") === 0 && (token.length === 7 || /\s/.test(token[7]))) {
                trailers.push(position);
                position += skipUntil(buffer, position, startxrefBytes);
              } else {
                position += token.length + 1;
              }
            }
            var i, ii;
            for (i = 0, ii = xrefStms.length; i < ii; ++i) {
              this.startXRefQueue.push(xrefStms[i]);
              this.readXRef(true);
            }
            var dict;
            for (i = 0, ii = trailers.length; i < ii; ++i) {
              stream.pos = trailers[i];
              var parser = new _parser.Parser(new _parser.Lexer(stream), true, this, true);
              var obj = parser.getObj();
              if (!(0, _primitives.isCmd)(obj, "trailer")) {
                continue;
              }
              dict = parser.getObj();
              if (!(0, _primitives.isDict)(dict)) {
                continue;
              }
              if (dict.has("ID")) {
                return dict;
              }
            }
            if (dict) {
              return dict;
            }
            throw new _util.InvalidPDFException("Invalid PDF structure");
          },
          readXRef: function XRef_readXRef(recoveryMode) {
            var stream = this.stream;
            var startXRefParsedCache = Object.create(null);
            try {
              while (this.startXRefQueue.length) {
                var startXRef = this.startXRefQueue[0];
                if (startXRefParsedCache[startXRef]) {
                  (0, _util.warn)("readXRef - skipping XRef table since it was already parsed.");
                  this.startXRefQueue.shift();
                  continue;
                }
                startXRefParsedCache[startXRef] = true;
                stream.pos = startXRef + stream.start;
                var parser = new _parser.Parser(new _parser.Lexer(stream), true, this);
                var obj = parser.getObj();
                var dict;
                if ((0, _primitives.isCmd)(obj, "xref")) {
                  dict = this.processXRefTable(parser);
                  if (!this.topDict) {
                    this.topDict = dict;
                  }
                  obj = dict.get("XRefStm");
                  if (Number.isInteger(obj)) {
                    var pos = obj;
                    if (!(pos in this.xrefstms)) {
                      this.xrefstms[pos] = 1;
                      this.startXRefQueue.push(pos);
                    }
                  }
                } else if (Number.isInteger(obj)) {
                  if (!Number.isInteger(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), "obj") || !(0, _primitives.isStream)(obj = parser.getObj())) {
                    throw new _util.FormatError("Invalid XRef stream");
                  }
                  dict = this.processXRefStream(obj);
                  if (!this.topDict) {
                    this.topDict = dict;
                  }
                  if (!dict) {
                    throw new _util.FormatError("Failed to read XRef stream");
                  }
                } else {
                  throw new _util.FormatError("Invalid XRef stream header");
                }
                obj = dict.get("Prev");
                if (Number.isInteger(obj)) {
                  this.startXRefQueue.push(obj);
                } else if ((0, _primitives.isRef)(obj)) {
                  this.startXRefQueue.push(obj.num);
                }
                this.startXRefQueue.shift();
              }
              return this.topDict;
            } catch (e) {
              if (e instanceof _util.MissingDataException) {
                throw e;
              }
              (0, _util.info)("(while reading XRef): " + e);
            }
            if (recoveryMode) {
              return;
            }
            throw new _util.XRefParseException();
          },
          getEntry: function XRef_getEntry(i) {
            var xrefEntry = this.entries[i];
            if (xrefEntry && !xrefEntry.free && xrefEntry.offset) {
              return xrefEntry;
            }
            return null;
          },
          fetchIfRef: function XRef_fetchIfRef(obj, suppressEncryption) {
            if (!(0, _primitives.isRef)(obj)) {
              return obj;
            }
            return this.fetch(obj, suppressEncryption);
          },
          fetch: function XRef_fetch(ref, suppressEncryption) {
            if (!(0, _primitives.isRef)(ref)) {
              throw new Error("ref object is not a reference");
            }
            var num = ref.num;
            if (num in this.cache) {
              var cacheEntry = this.cache[num];
              if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) {
                cacheEntry.objId = ref.toString();
              }
              return cacheEntry;
            }
            var xrefEntry = this.getEntry(num);
            if (xrefEntry === null) {
              return this.cache[num] = null;
            }
            if (xrefEntry.uncompressed) {
              xrefEntry = this.fetchUncompressed(ref, xrefEntry, suppressEncryption);
            } else {
              xrefEntry = this.fetchCompressed(xrefEntry, suppressEncryption);
            }
            if ((0, _primitives.isDict)(xrefEntry)) {
              xrefEntry.objId = ref.toString();
            } else if ((0, _primitives.isStream)(xrefEntry)) {
              xrefEntry.dict.objId = ref.toString();
            }
            return xrefEntry;
          },
          fetchUncompressed: function XRef_fetchUncompressed(ref, xrefEntry, suppressEncryption) {
            var gen = ref.gen;
            var num = ref.num;
            if (xrefEntry.gen !== gen) {
              throw new _util.FormatError("inconsistent generation in XRef");
            }
            var stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
            var parser = new _parser.Parser(new _parser.Lexer(stream), true, this);
            var obj1 = parser.getObj();
            var obj2 = parser.getObj();
            var obj3 = parser.getObj();
            if (!Number.isInteger(obj1)) {
              obj1 = parseInt(obj1, 10);
            }
            if (!Number.isInteger(obj2)) {
              obj2 = parseInt(obj2, 10);
            }
            if (obj1 !== num || obj2 !== gen || !(0, _primitives.isCmd)(obj3)) {
              throw new _util.FormatError("bad XRef entry");
            }
            if (obj3.cmd !== "obj") {
              if (obj3.cmd.indexOf("obj") === 0) {
                num = parseInt(obj3.cmd.substring(3), 10);
                if (!Number.isNaN(num)) {
                  return num;
                }
              }
              throw new _util.FormatError("bad XRef entry");
            }
            if (this.encrypt && !suppressEncryption) {
              xrefEntry = parser.getObj(this.encrypt.createCipherTransform(num, gen));
            } else {
              xrefEntry = parser.getObj();
            }
            if (!(0, _primitives.isStream)(xrefEntry)) {
              this.cache[num] = xrefEntry;
            }
            return xrefEntry;
          },
          fetchCompressed: function XRef_fetchCompressed(xrefEntry, suppressEncryption) {
            var tableOffset = xrefEntry.offset;
            var stream = this.fetch(new _primitives.Ref(tableOffset, 0));
            if (!(0, _primitives.isStream)(stream)) {
              throw new _util.FormatError("bad ObjStm stream");
            }
            var first = stream.dict.get("First");
            var n = stream.dict.get("N");
            if (!Number.isInteger(first) || !Number.isInteger(n)) {
              throw new _util.FormatError("invalid first and n parameters for ObjStm stream");
            }
            var parser = new _parser.Parser(new _parser.Lexer(stream), false, this);
            parser.allowStreams = true;
            var i,
              entries = [],
              num,
              nums = [];
            for (i = 0; i < n; ++i) {
              num = parser.getObj();
              if (!Number.isInteger(num)) {
                throw new _util.FormatError("invalid object number in the ObjStm stream: " + num);
              }
              nums.push(num);
              var offset = parser.getObj();
              if (!Number.isInteger(offset)) {
                throw new _util.FormatError("invalid object offset in the ObjStm stream: " + offset);
              }
            }
            for (i = 0; i < n; ++i) {
              entries.push(parser.getObj());
              if ((0, _primitives.isCmd)(parser.buf1, "endobj")) {
                parser.shift();
              }
              num = nums[i];
              var entry = this.entries[num];
              if (entry && entry.offset === tableOffset && entry.gen === i) {
                this.cache[num] = entries[i];
              }
            }
            xrefEntry = entries[xrefEntry.gen];
            if (xrefEntry === undefined) {
              throw new _util.FormatError("bad XRef entry for compressed object");
            }
            return xrefEntry;
          },
          fetchIfRefAsync: function XRef_fetchIfRefAsync(obj, suppressEncryption) {
            if (!(0, _primitives.isRef)(obj)) {
              return Promise.resolve(obj);
            }
            return this.fetchAsync(obj, suppressEncryption);
          },
          fetchAsync: function XRef_fetchAsync(ref, suppressEncryption) {
            var streamManager = this.stream.manager;
            var xref = this;
            return new Promise(function tryFetch(resolve, reject) {
              try {
                resolve(xref.fetch(ref, suppressEncryption));
              } catch (e) {
                if (e instanceof _util.MissingDataException) {
                  streamManager.requestRange(e.begin, e.end).then(function () {
                    tryFetch(resolve, reject);
                  }, reject);
                  return;
                }
                reject(e);
              }
            });
          },
          getCatalogObj: function XRef_getCatalogObj() {
            return this.root;
          }
        };
        return XRef;
      }();
      var NameOrNumberTree = function NameOrNumberTreeClosure() {
        function NameOrNumberTree(root, xref) {
          throw new Error("Cannot initialize NameOrNumberTree.");
        }
        NameOrNumberTree.prototype = {
          getAll: function NameOrNumberTree_getAll() {
            var dict = Object.create(null);
            if (!this.root) {
              return dict;
            }
            var xref = this.xref;
            var processed = new _primitives.RefSet();
            processed.put(this.root);
            var queue = [this.root];
            while (queue.length > 0) {
              var i, n;
              var obj = xref.fetchIfRef(queue.shift());
              if (!(0, _primitives.isDict)(obj)) {
                continue;
              }
              if (obj.has("Kids")) {
                var kids = obj.get("Kids");
                for (i = 0, n = kids.length; i < n; i++) {
                  var kid = kids[i];
                  if (processed.has(kid)) {
                    throw new _util.FormatError("Duplicate entry in \"" + this._type + "\" tree.");
                  }
                  queue.push(kid);
                  processed.put(kid);
                }
                continue;
              }
              var entries = obj.get(this._type);
              if (Array.isArray(entries)) {
                for (i = 0, n = entries.length; i < n; i += 2) {
                  dict[xref.fetchIfRef(entries[i])] = xref.fetchIfRef(entries[i + 1]);
                }
              }
            }
            return dict;
          },
          get: function NameOrNumberTree_get(key) {
            if (!this.root) {
              return null;
            }
            var xref = this.xref;
            var kidsOrEntries = xref.fetchIfRef(this.root);
            var loopCount = 0;
            var MAX_LEVELS = 10;
            var l, r, m;
            while (kidsOrEntries.has("Kids")) {
              if (++loopCount > MAX_LEVELS) {
                (0, _util.warn)("Search depth limit reached for \"" + this._type + "\" tree.");
                return null;
              }
              var kids = kidsOrEntries.get("Kids");
              if (!Array.isArray(kids)) {
                return null;
              }
              l = 0;
              r = kids.length - 1;
              while (l <= r) {
                m = l + r >> 1;
                var kid = xref.fetchIfRef(kids[m]);
                var limits = kid.get("Limits");
                if (key < xref.fetchIfRef(limits[0])) {
                  r = m - 1;
                } else if (key > xref.fetchIfRef(limits[1])) {
                  l = m + 1;
                } else {
                  kidsOrEntries = xref.fetchIfRef(kids[m]);
                  break;
                }
              }
              if (l > r) {
                return null;
              }
            }
            var entries = kidsOrEntries.get(this._type);
            if (Array.isArray(entries)) {
              l = 0;
              r = entries.length - 2;
              while (l <= r) {
                m = l + r & ~1;
                var currentKey = xref.fetchIfRef(entries[m]);
                if (key < currentKey) {
                  r = m - 2;
                } else if (key > currentKey) {
                  l = m + 2;
                } else {
                  return xref.fetchIfRef(entries[m + 1]);
                }
              }
            }
            return null;
          }
        };
        return NameOrNumberTree;
      }();
      var NameTree = function NameTreeClosure() {
        function NameTree(root, xref) {
          this.root = root;
          this.xref = xref;
          this._type = "Names";
        }
        _util.Util.inherit(NameTree, NameOrNumberTree, {});
        return NameTree;
      }();
      var NumberTree = function NumberTreeClosure() {
        function NumberTree(root, xref) {
          this.root = root;
          this.xref = xref;
          this._type = "Nums";
        }
        _util.Util.inherit(NumberTree, NameOrNumberTree, {});
        return NumberTree;
      }();
      var FileSpec = function FileSpecClosure() {
        function FileSpec(root, xref) {
          if (!root || !(0, _primitives.isDict)(root)) {
            return;
          }
          this.xref = xref;
          this.root = root;
          if (root.has("FS")) {
            this.fs = root.get("FS");
          }
          this.description = root.has("Desc") ? (0, _util.stringToPDFString)(root.get("Desc")) : "";
          if (root.has("RF")) {
            (0, _util.warn)("Related file specifications are not supported");
          }
          this.contentAvailable = true;
          if (!root.has("EF")) {
            this.contentAvailable = false;
            (0, _util.warn)("Non-embedded file specifications are not supported");
          }
        }
        function pickPlatformItem(dict) {
          if (dict.has("UF")) {
            return dict.get("UF");
          } else if (dict.has("F")) {
            return dict.get("F");
          } else if (dict.has("Unix")) {
            return dict.get("Unix");
          } else if (dict.has("Mac")) {
            return dict.get("Mac");
          } else if (dict.has("DOS")) {
            return dict.get("DOS");
          }
          return null;
        }
        FileSpec.prototype = {
          get filename() {
            if (!this._filename && this.root) {
              var filename = pickPlatformItem(this.root) || "unnamed";
              this._filename = (0, _util.stringToPDFString)(filename).replace(/\\\\/g, "\\").replace(/\\\//g, "/").replace(/\\/g, "/");
            }
            return this._filename;
          },
          get content() {
            if (!this.contentAvailable) {
              return null;
            }
            if (!this.contentRef && this.root) {
              this.contentRef = pickPlatformItem(this.root.get("EF"));
            }
            var content = null;
            if (this.contentRef) {
              var xref = this.xref;
              var fileObj = xref.fetchIfRef(this.contentRef);
              if (fileObj && (0, _primitives.isStream)(fileObj)) {
                content = fileObj.getBytes();
              } else {
                (0, _util.warn)("Embedded file specification points to non-existing/invalid " + "content");
              }
            } else {
              (0, _util.warn)("Embedded file specification does not have a content");
            }
            return content;
          },
          get serializable() {
            return {
              filename: this.filename,
              content: this.content
            };
          }
        };
        return FileSpec;
      }();
      var ObjectLoader = function () {
        function mayHaveChildren(value) {
          return (0, _primitives.isRef)(value) || (0, _primitives.isDict)(value) || Array.isArray(value) || (0, _primitives.isStream)(value);
        }
        function addChildren(node, nodesToVisit) {
          if ((0, _primitives.isDict)(node) || (0, _primitives.isStream)(node)) {
            var dict = (0, _primitives.isDict)(node) ? node : node.dict;
            var dictKeys = dict.getKeys();
            for (var i = 0, ii = dictKeys.length; i < ii; i++) {
              var rawValue = dict.getRaw(dictKeys[i]);
              if (mayHaveChildren(rawValue)) {
                nodesToVisit.push(rawValue);
              }
            }
          } else if (Array.isArray(node)) {
            for (var _i = 0, _ii = node.length; _i < _ii; _i++) {
              var value = node[_i];
              if (mayHaveChildren(value)) {
                nodesToVisit.push(value);
              }
            }
          }
        }
        function ObjectLoader(dict, keys, xref) {
          this.dict = dict;
          this.keys = keys;
          this.xref = xref;
          this.refSet = null;
          this.capability = null;
        }
        ObjectLoader.prototype = {
          load: function load() {
            this.capability = (0, _util.createPromiseCapability)();
            if (!(this.xref.stream instanceof _chunked_stream.ChunkedStream) || this.xref.stream.getMissingChunks().length === 0) {
              this.capability.resolve();
              return this.capability.promise;
            }
            var keys = this.keys,
              dict = this.dict;

            this.refSet = new _primitives.RefSet();
            var nodesToVisit = [];
            for (var i = 0, ii = keys.length; i < ii; i++) {
              var rawValue = dict.getRaw(keys[i]);
              if (rawValue !== undefined) {
                nodesToVisit.push(rawValue);
              }
            }
            this._walk(nodesToVisit);
            return this.capability.promise;
          },
          _walk: function _walk(nodesToVisit) {
            var _this3 = this;

            var nodesToRevisit = [];
            var pendingRequests = [];
            while (nodesToVisit.length) {
              var currentNode = nodesToVisit.pop();
              if ((0, _primitives.isRef)(currentNode)) {
                if (this.refSet.has(currentNode)) {
                  continue;
                }
                try {
                  this.refSet.put(currentNode);
                  currentNode = this.xref.fetch(currentNode);
                } catch (ex) {
                  if (!(ex instanceof _util.MissingDataException)) {
                    throw ex;
                  }
                  nodesToRevisit.push(currentNode);
                  pendingRequests.push({
                    begin: ex.begin,
                    end: ex.end
                  });
                }
              }
              if (currentNode && currentNode.getBaseStreams) {
                var baseStreams = currentNode.getBaseStreams();
                var foundMissingData = false;
                for (var i = 0, ii = baseStreams.length; i < ii; i++) {
                  var stream = baseStreams[i];
                  if (stream.getMissingChunks && stream.getMissingChunks().length) {
                    foundMissingData = true;
                    pendingRequests.push({
                      begin: stream.start,
                      end: stream.end
                    });
                  }
                }
                if (foundMissingData) {
                  nodesToRevisit.push(currentNode);
                }
              }
              addChildren(currentNode, nodesToVisit);
            }
            if (pendingRequests.length) {
              this.xref.stream.manager.requestRanges(pendingRequests).then(function () {
                for (var _i2 = 0, _ii2 = nodesToRevisit.length; _i2 < _ii2; _i2++) {
                  var node = nodesToRevisit[_i2];
                  if ((0, _primitives.isRef)(node)) {
                    _this3.refSet.remove(node);
                  }
                }
                _this3._walk(nodesToRevisit);
              }, this.capability.reject);
              return;
            }
            this.refSet = null;
            this.capability.resolve();
          }
        };
        return ObjectLoader;
      }();
      exports.Catalog = Catalog;
      exports.ObjectLoader = ObjectLoader;
      exports.XRef = XRef;
      exports.FileSpec = FileSpec;

      /***/ }),
    /* 74 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.JpxImage = undefined;

      var _util = __w_pdfjs_require__(0);

      var _arithmetic_decoder = __w_pdfjs_require__(75);

      var JpxError = function JpxErrorClosure() {
        function JpxError(msg) {
          this.message = "JPX error: " + msg;
        }
        JpxError.prototype = new Error();
        JpxError.prototype.name = "JpxError";
        JpxError.constructor = JpxError;
        return JpxError;
      }();
      var JpxImage = function JpxImageClosure() {
        var SubbandsGainLog2 = {
          "LL": 0,
          "LH": 1,
          "HL": 1,
          "HH": 2
        };
        function JpxImage() {
          this.failOnCorruptedImage = false;
        }
        JpxImage.prototype = {
          parse: function JpxImage_parse(data) {
            var head = (0, _util.readUint16)(data, 0);
            if (head === 0xFF4F) {
              this.parseCodestream(data, 0, data.length);
              return;
            }
            var position = 0,
              length = data.length;
            while (position < length) {
              var headerSize = 8;
              var lbox = (0, _util.readUint32)(data, position);
              var tbox = (0, _util.readUint32)(data, position + 4);
              position += headerSize;
              if (lbox === 1) {
                lbox = (0, _util.readUint32)(data, position) * 4294967296 + (0, _util.readUint32)(data, position + 4);
                position += 8;
                headerSize += 8;
              }
              if (lbox === 0) {
                lbox = length - position + headerSize;
              }
              if (lbox < headerSize) {
                throw new JpxError("Invalid box field size");
              }
              var dataLength = lbox - headerSize;
              var jumpDataLength = true;
              switch (tbox) {
                case 0x6A703268:
                  jumpDataLength = false;
                  break;
                case 0x636F6C72:
                  var method = data[position];
                  if (method === 1) {
                    var colorspace = (0, _util.readUint32)(data, position + 3);
                    switch (colorspace) {
                      case 16:
                      case 17:
                      case 18:
                        break;
                      default:
                        (0, _util.warn)("Unknown colorspace " + colorspace);
                        break;
                    }
                  } else if (method === 2) {
                    (0, _util.info)("ICC profile not supported");
                  }
                  break;
                case 0x6A703263:
                  this.parseCodestream(data, position, position + dataLength);
                  break;
                case 0x6A502020:
                  if ((0, _util.readUint32)(data, position) !== 0x0d0a870a) {
                    (0, _util.warn)("Invalid JP2 signature");
                  }
                  break;
                case 0x6A501A1A:
                case 0x66747970:
                case 0x72726571:
                case 0x72657320:
                case 0x69686472:
                  break;
                default:
                  var headerType = String.fromCharCode(tbox >> 24 & 0xFF, tbox >> 16 & 0xFF, tbox >> 8 & 0xFF, tbox & 0xFF);
                  (0, _util.warn)("Unsupported header type " + tbox + " (" + headerType + ")");
                  break;
              }
              if (jumpDataLength) {
                position += dataLength;
              }
            }
          },
          parseImageProperties: function JpxImage_parseImageProperties(stream) {
            var newByte = stream.getByte();
            while (newByte >= 0) {
              var oldByte = newByte;
              newByte = stream.getByte();
              var code = oldByte << 8 | newByte;
              if (code === 0xFF51) {
                stream.skip(4);
                var Xsiz = stream.getInt32() >>> 0;
                var Ysiz = stream.getInt32() >>> 0;
                var XOsiz = stream.getInt32() >>> 0;
                var YOsiz = stream.getInt32() >>> 0;
                stream.skip(16);
                var Csiz = stream.getUint16();
                this.width = Xsiz - XOsiz;
                this.height = Ysiz - YOsiz;
                this.componentsCount = Csiz;
                this.bitsPerComponent = 8;
                return;
              }
            }
            throw new JpxError("No size marker found in JPX stream");
          },
          parseCodestream: function JpxImage_parseCodestream(data, start, end) {
            var context = {};
            var doNotRecover = false;
            try {
              var position = start;
              while (position + 1 < end) {
                var code = (0, _util.readUint16)(data, position);
                position += 2;
                var length = 0,
                  j,
                  sqcd,
                  spqcds,
                  spqcdSize,
                  scalarExpounded,
                  tile;
                switch (code) {
                  case 0xFF4F:
                    context.mainHeader = true;
                    break;
                  case 0xFFD9:
                    break;
                  case 0xFF51:
                    length = (0, _util.readUint16)(data, position);
                    var siz = {};
                    siz.Xsiz = (0, _util.readUint32)(data, position + 4);
                    siz.Ysiz = (0, _util.readUint32)(data, position + 8);
                    siz.XOsiz = (0, _util.readUint32)(data, position + 12);
                    siz.YOsiz = (0, _util.readUint32)(data, position + 16);
                    siz.XTsiz = (0, _util.readUint32)(data, position + 20);
                    siz.YTsiz = (0, _util.readUint32)(data, position + 24);
                    siz.XTOsiz = (0, _util.readUint32)(data, position + 28);
                    siz.YTOsiz = (0, _util.readUint32)(data, position + 32);
                    var componentsCount = (0, _util.readUint16)(data, position + 36);
                    siz.Csiz = componentsCount;
                    var components = [];
                    j = position + 38;
                    for (var i = 0; i < componentsCount; i++) {
                      var component = {
                        precision: (data[j] & 0x7F) + 1,
                        isSigned: !!(data[j] & 0x80),
                        XRsiz: data[j + 1],
                        YRsiz: data[j + 1]
                      };
                      calculateComponentDimensions(component, siz);
                      components.push(component);
                    }
                    context.SIZ = siz;
                    context.components = components;
                    calculateTileGrids(context, components);
                    context.QCC = [];
                    context.COC = [];
                    break;
                  case 0xFF5C:
                    length = (0, _util.readUint16)(data, position);
                    var qcd = {};
                    j = position + 2;
                    sqcd = data[j++];
                    switch (sqcd & 0x1F) {
                      case 0:
                        spqcdSize = 8;
                        scalarExpounded = true;
                        break;
                      case 1:
                        spqcdSize = 16;
                        scalarExpounded = false;
                        break;
                      case 2:
                        spqcdSize = 16;
                        scalarExpounded = true;
                        break;
                      default:
                        throw new Error("Invalid SQcd value " + sqcd);
                    }
                    qcd.noQuantization = spqcdSize === 8;
                    qcd.scalarExpounded = scalarExpounded;
                    qcd.guardBits = sqcd >> 5;
                    spqcds = [];
                    while (j < length + position) {
                      var spqcd = {};
                      if (spqcdSize === 8) {
                        spqcd.epsilon = data[j++] >> 3;
                        spqcd.mu = 0;
                      } else {
                        spqcd.epsilon = data[j] >> 3;
                        spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                        j += 2;
                      }
                      spqcds.push(spqcd);
                    }
                    qcd.SPqcds = spqcds;
                    if (context.mainHeader) {
                      context.QCD = qcd;
                    } else {
                      context.currentTile.QCD = qcd;
                      context.currentTile.QCC = [];
                    }
                    break;
                  case 0xFF5D:
                    length = (0, _util.readUint16)(data, position);
                    var qcc = {};
                    j = position + 2;
                    var cqcc;
                    if (context.SIZ.Csiz < 257) {
                      cqcc = data[j++];
                    } else {
                      cqcc = (0, _util.readUint16)(data, j);
                      j += 2;
                    }
                    sqcd = data[j++];
                    switch (sqcd & 0x1F) {
                      case 0:
                        spqcdSize = 8;
                        scalarExpounded = true;
                        break;
                      case 1:
                        spqcdSize = 16;
                        scalarExpounded = false;
                        break;
                      case 2:
                        spqcdSize = 16;
                        scalarExpounded = true;
                        break;
                      default:
                        throw new Error("Invalid SQcd value " + sqcd);
                    }
                    qcc.noQuantization = spqcdSize === 8;
                    qcc.scalarExpounded = scalarExpounded;
                    qcc.guardBits = sqcd >> 5;
                    spqcds = [];
                    while (j < length + position) {
                      spqcd = {};
                      if (spqcdSize === 8) {
                        spqcd.epsilon = data[j++] >> 3;
                        spqcd.mu = 0;
                      } else {
                        spqcd.epsilon = data[j] >> 3;
                        spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                        j += 2;
                      }
                      spqcds.push(spqcd);
                    }
                    qcc.SPqcds = spqcds;
                    if (context.mainHeader) {
                      context.QCC[cqcc] = qcc;
                    } else {
                      context.currentTile.QCC[cqcc] = qcc;
                    }
                    break;
                  case 0xFF52:
                    length = (0, _util.readUint16)(data, position);
                    var cod = {};
                    j = position + 2;
                    var scod = data[j++];
                    cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
                    cod.sopMarkerUsed = !!(scod & 2);
                    cod.ephMarkerUsed = !!(scod & 4);
                    cod.progressionOrder = data[j++];
                    cod.layersCount = (0, _util.readUint16)(data, j);
                    j += 2;
                    cod.multipleComponentTransform = data[j++];
                    cod.decompositionLevelsCount = data[j++];
                    cod.xcb = (data[j++] & 0xF) + 2;
                    cod.ycb = (data[j++] & 0xF) + 2;
                    var blockStyle = data[j++];
                    cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
                    cod.resetContextProbabilities = !!(blockStyle & 2);
                    cod.terminationOnEachCodingPass = !!(blockStyle & 4);
                    cod.verticalyStripe = !!(blockStyle & 8);
                    cod.predictableTermination = !!(blockStyle & 16);
                    cod.segmentationSymbolUsed = !!(blockStyle & 32);
                    cod.reversibleTransformation = data[j++];
                    if (cod.entropyCoderWithCustomPrecincts) {
                      var precinctsSizes = [];
                      while (j < length + position) {
                        var precinctsSize = data[j++];
                        precinctsSizes.push({
                          PPx: precinctsSize & 0xF,
                          PPy: precinctsSize >> 4
                        });
                      }
                      cod.precinctsSizes = precinctsSizes;
                    }
                    var unsupported = [];
                    if (cod.selectiveArithmeticCodingBypass) {
                      unsupported.push("selectiveArithmeticCodingBypass");
                    }
                    if (cod.resetContextProbabilities) {
                      unsupported.push("resetContextProbabilities");
                    }
                    if (cod.terminationOnEachCodingPass) {
                      unsupported.push("terminationOnEachCodingPass");
                    }
                    if (cod.verticalyStripe) {
                      unsupported.push("verticalyStripe");
                    }
                    if (cod.predictableTermination) {
                      unsupported.push("predictableTermination");
                    }
                    if (unsupported.length > 0) {
                      doNotRecover = true;
                      throw new Error("Unsupported COD options (" + unsupported.join(", ") + ")");
                    }
                    if (context.mainHeader) {
                      context.COD = cod;
                    } else {
                      context.currentTile.COD = cod;
                      context.currentTile.COC = [];
                    }
                    break;
                  case 0xFF90:
                    length = (0, _util.readUint16)(data, position);
                    tile = {};
                    tile.index = (0, _util.readUint16)(data, position + 2);
                    tile.length = (0, _util.readUint32)(data, position + 4);
                    tile.dataEnd = tile.length + position - 2;
                    tile.partIndex = data[position + 8];
                    tile.partsCount = data[position + 9];
                    context.mainHeader = false;
                    if (tile.partIndex === 0) {
                      tile.COD = context.COD;
                      tile.COC = context.COC.slice(0);
                      tile.QCD = context.QCD;
                      tile.QCC = context.QCC.slice(0);
                    }
                    context.currentTile = tile;
                    break;
                  case 0xFF93:
                    tile = context.currentTile;
                    if (tile.partIndex === 0) {
                      initializeTile(context, tile.index);
                      buildPackets(context);
                    }
                    length = tile.dataEnd - position;
                    parseTilePackets(context, data, position, length);
                    break;
                  case 0xFF55:
                  case 0xFF57:
                  case 0xFF58:
                  case 0xFF64:
                    length = (0, _util.readUint16)(data, position);
                    break;
                  case 0xFF53:
                    throw new Error("Codestream code 0xFF53 (COC) is " + "not implemented");
                  default:
                    throw new Error("Unknown codestream code: " + code.toString(16));
                }
                position += length;
              }
            } catch (e) {
              if (doNotRecover || this.failOnCorruptedImage) {
                throw new JpxError(e.message);
              } else {
                (0, _util.warn)("JPX: Trying to recover from: " + e.message);
              }
            }
            this.tiles = transformComponents(context);
            this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
            this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
            this.componentsCount = context.SIZ.Csiz;
          }
        };
        function calculateComponentDimensions(component, siz) {
          component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
          component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
          component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
          component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
          component.width = component.x1 - component.x0;
          component.height = component.y1 - component.y0;
        }
        function calculateTileGrids(context, components) {
          var siz = context.SIZ;
          var tile,
            tiles = [];
          var numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
          var numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
          for (var q = 0; q < numYtiles; q++) {
            for (var p = 0; p < numXtiles; p++) {
              tile = {};
              tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
              tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
              tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
              tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
              tile.width = tile.tx1 - tile.tx0;
              tile.height = tile.ty1 - tile.ty0;
              tile.components = [];
              tiles.push(tile);
            }
          }
          context.tiles = tiles;
          var componentsCount = siz.Csiz;
          for (var i = 0, ii = componentsCount; i < ii; i++) {
            var component = components[i];
            for (var j = 0, jj = tiles.length; j < jj; j++) {
              var tileComponent = {};
              tile = tiles[j];
              tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
              tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
              tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
              tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
              tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
              tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
              tile.components[i] = tileComponent;
            }
          }
        }
        function getBlocksDimensions(context, component, r) {
          var codOrCoc = component.codingStyleParameters;
          var result = {};
          if (!codOrCoc.entropyCoderWithCustomPrecincts) {
            result.PPx = 15;
            result.PPy = 15;
          } else {
            result.PPx = codOrCoc.precinctsSizes[r].PPx;
            result.PPy = codOrCoc.precinctsSizes[r].PPy;
          }
          result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
          result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
          return result;
        }
        function buildPrecincts(context, resolution, dimensions) {
          var precinctWidth = 1 << dimensions.PPx;
          var precinctHeight = 1 << dimensions.PPy;
          var isZeroRes = resolution.resLevel === 0;
          var precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
          var precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
          var numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
          var numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
          var numprecincts = numprecinctswide * numprecinctshigh;
          resolution.precinctParameters = {
            precinctWidth: precinctWidth,
            precinctHeight: precinctHeight,
            numprecinctswide: numprecinctswide,
            numprecinctshigh: numprecinctshigh,
            numprecincts: numprecincts,
            precinctWidthInSubband: precinctWidthInSubband,
            precinctHeightInSubband: precinctHeightInSubband
          };
        }
        function buildCodeblocks(context, subband, dimensions) {
          var xcb_ = dimensions.xcb_;
          var ycb_ = dimensions.ycb_;
          var codeblockWidth = 1 << xcb_;
          var codeblockHeight = 1 << ycb_;
          var cbx0 = subband.tbx0 >> xcb_;
          var cby0 = subband.tby0 >> ycb_;
          var cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
          var cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
          var precinctParameters = subband.resolution.precinctParameters;
          var codeblocks = [];
          var precincts = [];
          var i, j, codeblock, precinctNumber;
          for (j = cby0; j < cby1; j++) {
            for (i = cbx0; i < cbx1; i++) {
              codeblock = {
                cbx: i,
                cby: j,
                tbx0: codeblockWidth * i,
                tby0: codeblockHeight * j,
                tbx1: codeblockWidth * (i + 1),
                tby1: codeblockHeight * (j + 1)
              };
              codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
              codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
              codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
              codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
              var pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
              var pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
              precinctNumber = pi + pj * precinctParameters.numprecinctswide;
              codeblock.precinctNumber = precinctNumber;
              codeblock.subbandType = subband.type;
              codeblock.Lblock = 3;
              if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) {
                continue;
              }
              codeblocks.push(codeblock);
              var precinct = precincts[precinctNumber];
              if (precinct !== undefined) {
                if (i < precinct.cbxMin) {
                  precinct.cbxMin = i;
                } else if (i > precinct.cbxMax) {
                  precinct.cbxMax = i;
                }
                if (j < precinct.cbyMin) {
                  precinct.cbxMin = j;
                } else if (j > precinct.cbyMax) {
                  precinct.cbyMax = j;
                }
              } else {
                precincts[precinctNumber] = precinct = {
                  cbxMin: i,
                  cbyMin: j,
                  cbxMax: i,
                  cbyMax: j
                };
              }
              codeblock.precinct = precinct;
            }
          }
          subband.codeblockParameters = {
            codeblockWidth: xcb_,
            codeblockHeight: ycb_,
            numcodeblockwide: cbx1 - cbx0 + 1,
            numcodeblockhigh: cby1 - cby0 + 1
          };
          subband.codeblocks = codeblocks;
          subband.precincts = precincts;
        }
        function createPacket(resolution, precinctNumber, layerNumber) {
          var precinctCodeblocks = [];
          var subbands = resolution.subbands;
          for (var i = 0, ii = subbands.length; i < ii; i++) {
            var subband = subbands[i];
            var codeblocks = subband.codeblocks;
            for (var j = 0, jj = codeblocks.length; j < jj; j++) {
              var codeblock = codeblocks[j];
              if (codeblock.precinctNumber !== precinctNumber) {
                continue;
              }
              precinctCodeblocks.push(codeblock);
            }
          }
          return {
            layerNumber: layerNumber,
            codeblocks: precinctCodeblocks
          };
        }
        function LayerResolutionComponentPositionIterator(context) {
          var siz = context.SIZ;
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var layersCount = tile.codingStyleDefaultParameters.layersCount;
          var componentsCount = siz.Csiz;
          var maxDecompositionLevelsCount = 0;
          for (var q = 0; q < componentsCount; q++) {
            maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
          }
          var l = 0,
            r = 0,
            i = 0,
            k = 0;
          this.nextPacket = function JpxImage_nextPacket() {
            for (; l < layersCount; l++) {
              for (; r <= maxDecompositionLevelsCount; r++) {
                for (; i < componentsCount; i++) {
                  var component = tile.components[i];
                  if (r > component.codingStyleParameters.decompositionLevelsCount) {
                    continue;
                  }
                  var resolution = component.resolutions[r];
                  var numprecincts = resolution.precinctParameters.numprecincts;
                  for (; k < numprecincts;) {
                    var packet = createPacket(resolution, k, l);
                    k++;
                    return packet;
                  }
                  k = 0;
                }
                i = 0;
              }
              r = 0;
            }
            throw new JpxError("Out of packets");
          };
        }
        function ResolutionLayerComponentPositionIterator(context) {
          var siz = context.SIZ;
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var layersCount = tile.codingStyleDefaultParameters.layersCount;
          var componentsCount = siz.Csiz;
          var maxDecompositionLevelsCount = 0;
          for (var q = 0; q < componentsCount; q++) {
            maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
          }
          var r = 0,
            l = 0,
            i = 0,
            k = 0;
          this.nextPacket = function JpxImage_nextPacket() {
            for (; r <= maxDecompositionLevelsCount; r++) {
              for (; l < layersCount; l++) {
                for (; i < componentsCount; i++) {
                  var component = tile.components[i];
                  if (r > component.codingStyleParameters.decompositionLevelsCount) {
                    continue;
                  }
                  var resolution = component.resolutions[r];
                  var numprecincts = resolution.precinctParameters.numprecincts;
                  for (; k < numprecincts;) {
                    var packet = createPacket(resolution, k, l);
                    k++;
                    return packet;
                  }
                  k = 0;
                }
                i = 0;
              }
              l = 0;
            }
            throw new JpxError("Out of packets");
          };
        }
        function ResolutionPositionComponentLayerIterator(context) {
          var siz = context.SIZ;
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var layersCount = tile.codingStyleDefaultParameters.layersCount;
          var componentsCount = siz.Csiz;
          var l, r, c, p;
          var maxDecompositionLevelsCount = 0;
          for (c = 0; c < componentsCount; c++) {
            var component = tile.components[c];
            maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
          }
          var maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
          for (r = 0; r <= maxDecompositionLevelsCount; ++r) {
            var maxNumPrecincts = 0;
            for (c = 0; c < componentsCount; ++c) {
              var resolutions = tile.components[c].resolutions;
              if (r < resolutions.length) {
                maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
              }
            }
            maxNumPrecinctsInLevel[r] = maxNumPrecincts;
          }
          l = 0;
          r = 0;
          c = 0;
          p = 0;
          this.nextPacket = function JpxImage_nextPacket() {
            for (; r <= maxDecompositionLevelsCount; r++) {
              for (; p < maxNumPrecinctsInLevel[r]; p++) {
                for (; c < componentsCount; c++) {
                  var component = tile.components[c];
                  if (r > component.codingStyleParameters.decompositionLevelsCount) {
                    continue;
                  }
                  var resolution = component.resolutions[r];
                  var numprecincts = resolution.precinctParameters.numprecincts;
                  if (p >= numprecincts) {
                    continue;
                  }
                  for (; l < layersCount;) {
                    var packet = createPacket(resolution, p, l);
                    l++;
                    return packet;
                  }
                  l = 0;
                }
                c = 0;
              }
              p = 0;
            }
            throw new JpxError("Out of packets");
          };
        }
        function PositionComponentResolutionLayerIterator(context) {
          var siz = context.SIZ;
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var layersCount = tile.codingStyleDefaultParameters.layersCount;
          var componentsCount = siz.Csiz;
          var precinctsSizes = getPrecinctSizesInImageScale(tile);
          var precinctsIterationSizes = precinctsSizes;
          var l = 0,
            r = 0,
            c = 0,
            px = 0,
            py = 0;
          this.nextPacket = function JpxImage_nextPacket() {
            for (; py < precinctsIterationSizes.maxNumHigh; py++) {
              for (; px < precinctsIterationSizes.maxNumWide; px++) {
                for (; c < componentsCount; c++) {
                  var component = tile.components[c];
                  var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                  for (; r <= decompositionLevelsCount; r++) {
                    var resolution = component.resolutions[r];
                    var sizeInImageScale = precinctsSizes.components[c].resolutions[r];
                    var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                    if (k === null) {
                      continue;
                    }
                    for (; l < layersCount;) {
                      var packet = createPacket(resolution, k, l);
                      l++;
                      return packet;
                    }
                    l = 0;
                  }
                  r = 0;
                }
                c = 0;
              }
              px = 0;
            }
            throw new JpxError("Out of packets");
          };
        }
        function ComponentPositionResolutionLayerIterator(context) {
          var siz = context.SIZ;
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var layersCount = tile.codingStyleDefaultParameters.layersCount;
          var componentsCount = siz.Csiz;
          var precinctsSizes = getPrecinctSizesInImageScale(tile);
          var l = 0,
            r = 0,
            c = 0,
            px = 0,
            py = 0;
          this.nextPacket = function JpxImage_nextPacket() {
            for (; c < componentsCount; ++c) {
              var component = tile.components[c];
              var precinctsIterationSizes = precinctsSizes.components[c];
              var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
              for (; py < precinctsIterationSizes.maxNumHigh; py++) {
                for (; px < precinctsIterationSizes.maxNumWide; px++) {
                  for (; r <= decompositionLevelsCount; r++) {
                    var resolution = component.resolutions[r];
                    var sizeInImageScale = precinctsIterationSizes.resolutions[r];
                    var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                    if (k === null) {
                      continue;
                    }
                    for (; l < layersCount;) {
                      var packet = createPacket(resolution, k, l);
                      l++;
                      return packet;
                    }
                    l = 0;
                  }
                  r = 0;
                }
                px = 0;
              }
              py = 0;
            }
            throw new JpxError("Out of packets");
          };
        }
        function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
          var posX = pxIndex * precinctIterationSizes.minWidth;
          var posY = pyIndex * precinctIterationSizes.minHeight;
          if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) {
            return null;
          }
          var startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
          return posX / sizeInImageScale.height + startPrecinctRowIndex;
        }
        function getPrecinctSizesInImageScale(tile) {
          var componentsCount = tile.components.length;
          var minWidth = Number.MAX_VALUE;
          var minHeight = Number.MAX_VALUE;
          var maxNumWide = 0;
          var maxNumHigh = 0;
          var sizePerComponent = new Array(componentsCount);
          for (var c = 0; c < componentsCount; c++) {
            var component = tile.components[c];
            var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
            var sizePerResolution = new Array(decompositionLevelsCount + 1);
            var minWidthCurrentComponent = Number.MAX_VALUE;
            var minHeightCurrentComponent = Number.MAX_VALUE;
            var maxNumWideCurrentComponent = 0;
            var maxNumHighCurrentComponent = 0;
            var scale = 1;
            for (var r = decompositionLevelsCount; r >= 0; --r) {
              var resolution = component.resolutions[r];
              var widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
              var heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
              minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
              minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
              maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
              maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
              sizePerResolution[r] = {
                width: widthCurrentResolution,
                height: heightCurrentResolution
              };
              scale <<= 1;
            }
            minWidth = Math.min(minWidth, minWidthCurrentComponent);
            minHeight = Math.min(minHeight, minHeightCurrentComponent);
            maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
            maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
            sizePerComponent[c] = {
              resolutions: sizePerResolution,
              minWidth: minWidthCurrentComponent,
              minHeight: minHeightCurrentComponent,
              maxNumWide: maxNumWideCurrentComponent,
              maxNumHigh: maxNumHighCurrentComponent
            };
          }
          return {
            components: sizePerComponent,
            minWidth: minWidth,
            minHeight: minHeight,
            maxNumWide: maxNumWide,
            maxNumHigh: maxNumHigh
          };
        }
        function buildPackets(context) {
          var siz = context.SIZ;
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var componentsCount = siz.Csiz;
          for (var c = 0; c < componentsCount; c++) {
            var component = tile.components[c];
            var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
            var resolutions = [];
            var subbands = [];
            for (var r = 0; r <= decompositionLevelsCount; r++) {
              var blocksDimensions = getBlocksDimensions(context, component, r);
              var resolution = {};
              var scale = 1 << decompositionLevelsCount - r;
              resolution.trx0 = Math.ceil(component.tcx0 / scale);
              resolution.try0 = Math.ceil(component.tcy0 / scale);
              resolution.trx1 = Math.ceil(component.tcx1 / scale);
              resolution.try1 = Math.ceil(component.tcy1 / scale);
              resolution.resLevel = r;
              buildPrecincts(context, resolution, blocksDimensions);
              resolutions.push(resolution);
              var subband;
              if (r === 0) {
                subband = {};
                subband.type = "LL";
                subband.tbx0 = Math.ceil(component.tcx0 / scale);
                subband.tby0 = Math.ceil(component.tcy0 / scale);
                subband.tbx1 = Math.ceil(component.tcx1 / scale);
                subband.tby1 = Math.ceil(component.tcy1 / scale);
                subband.resolution = resolution;
                buildCodeblocks(context, subband, blocksDimensions);
                subbands.push(subband);
                resolution.subbands = [subband];
              } else {
                var bscale = 1 << decompositionLevelsCount - r + 1;
                var resolutionSubbands = [];
                subband = {};
                subband.type = "HL";
                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                subband.tby0 = Math.ceil(component.tcy0 / bscale);
                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                subband.tby1 = Math.ceil(component.tcy1 / bscale);
                subband.resolution = resolution;
                buildCodeblocks(context, subband, blocksDimensions);
                subbands.push(subband);
                resolutionSubbands.push(subband);
                subband = {};
                subband.type = "LH";
                subband.tbx0 = Math.ceil(component.tcx0 / bscale);
                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                subband.tbx1 = Math.ceil(component.tcx1 / bscale);
                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                subband.resolution = resolution;
                buildCodeblocks(context, subband, blocksDimensions);
                subbands.push(subband);
                resolutionSubbands.push(subband);
                subband = {};
                subband.type = "HH";
                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                subband.resolution = resolution;
                buildCodeblocks(context, subband, blocksDimensions);
                subbands.push(subband);
                resolutionSubbands.push(subband);
                resolution.subbands = resolutionSubbands;
              }
            }
            component.resolutions = resolutions;
            component.subbands = subbands;
          }
          var progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
          switch (progressionOrder) {
            case 0:
              tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
              break;
            case 1:
              tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
              break;
            case 2:
              tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
              break;
            case 3:
              tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
              break;
            case 4:
              tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
              break;
            default:
              throw new JpxError("Unsupported progression order " + progressionOrder);
          }
        }
        function parseTilePackets(context, data, offset, dataLength) {
          var position = 0;
          var buffer,
            bufferSize = 0,
            skipNextBit = false;
          function readBits(count) {
            while (bufferSize < count) {
              var b = data[offset + position];
              position++;
              if (skipNextBit) {
                buffer = buffer << 7 | b;
                bufferSize += 7;
                skipNextBit = false;
              } else {
                buffer = buffer << 8 | b;
                bufferSize += 8;
              }
              if (b === 0xFF) {
                skipNextBit = true;
              }
            }
            bufferSize -= count;
            return buffer >>> bufferSize & (1 << count) - 1;
          }
          function skipMarkerIfEqual(value) {
            if (data[offset + position - 1] === 0xFF && data[offset + position] === value) {
              skipBytes(1);
              return true;
            } else if (data[offset + position] === 0xFF && data[offset + position + 1] === value) {
              skipBytes(2);
              return true;
            }
            return false;
          }
          function skipBytes(count) {
            position += count;
          }
          function alignToByte() {
            bufferSize = 0;
            if (skipNextBit) {
              position++;
              skipNextBit = false;
            }
          }
          function readCodingpasses() {
            if (readBits(1) === 0) {
              return 1;
            }
            if (readBits(1) === 0) {
              return 2;
            }
            var value = readBits(2);
            if (value < 3) {
              return value + 3;
            }
            value = readBits(5);
            if (value < 31) {
              return value + 6;
            }
            value = readBits(7);
            return value + 37;
          }
          var tileIndex = context.currentTile.index;
          var tile = context.tiles[tileIndex];
          var sopMarkerUsed = context.COD.sopMarkerUsed;
          var ephMarkerUsed = context.COD.ephMarkerUsed;
          var packetsIterator = tile.packetsIterator;
          while (position < dataLength) {
            alignToByte();
            if (sopMarkerUsed && skipMarkerIfEqual(0x91)) {
              skipBytes(4);
            }
            var packet = packetsIterator.nextPacket();
            if (!readBits(1)) {
              continue;
            }
            var layerNumber = packet.layerNumber;
            var queue = [],
              codeblock;
            for (var i = 0, ii = packet.codeblocks.length; i < ii; i++) {
              codeblock = packet.codeblocks[i];
              var precinct = codeblock.precinct;
              var codeblockColumn = codeblock.cbx - precinct.cbxMin;
              var codeblockRow = codeblock.cby - precinct.cbyMin;
              var codeblockIncluded = false;
              var firstTimeInclusion = false;
              var valueReady;
              if (codeblock["included"] !== undefined) {
                codeblockIncluded = !!readBits(1);
              } else {
                precinct = codeblock.precinct;
                var inclusionTree, zeroBitPlanesTree;
                if (precinct["inclusionTree"] !== undefined) {
                  inclusionTree = precinct.inclusionTree;
                } else {
                  var width = precinct.cbxMax - precinct.cbxMin + 1;
                  var height = precinct.cbyMax - precinct.cbyMin + 1;
                  inclusionTree = new InclusionTree(width, height, layerNumber);
                  zeroBitPlanesTree = new TagTree(width, height);
                  precinct.inclusionTree = inclusionTree;
                  precinct.zeroBitPlanesTree = zeroBitPlanesTree;
                }
                if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
                  while (true) {
                    if (readBits(1)) {
                      valueReady = !inclusionTree.nextLevel();
                      if (valueReady) {
                        codeblock.included = true;
                        codeblockIncluded = firstTimeInclusion = true;
                        break;
                      }
                    } else {
                      inclusionTree.incrementValue(layerNumber);
                      break;
                    }
                  }
                }
              }
              if (!codeblockIncluded) {
                continue;
              }
              if (firstTimeInclusion) {
                zeroBitPlanesTree = precinct.zeroBitPlanesTree;
                zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
                while (true) {
                  if (readBits(1)) {
                    valueReady = !zeroBitPlanesTree.nextLevel();
                    if (valueReady) {
                      break;
                    }
                  } else {
                    zeroBitPlanesTree.incrementValue();
                  }
                }
                codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
              }
              var codingpasses = readCodingpasses();
              while (readBits(1)) {
                codeblock.Lblock++;
              }
              var codingpassesLog2 = (0, _util.log2)(codingpasses);
              var bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
              var codedDataLength = readBits(bits);
              queue.push({
                codeblock: codeblock,
                codingpasses: codingpasses,
                dataLength: codedDataLength
              });
            }
            alignToByte();
            if (ephMarkerUsed) {
              skipMarkerIfEqual(0x92);
            }
            while (queue.length > 0) {
              var packetItem = queue.shift();
              codeblock = packetItem.codeblock;
              if (codeblock["data"] === undefined) {
                codeblock.data = [];
              }
              codeblock.data.push({
                data: data,
                start: offset + position,
                end: offset + position + packetItem.dataLength,
                codingpasses: packetItem.codingpasses
              });
              position += packetItem.dataLength;
            }
          }
          return position;
        }
        function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed) {
          var x0 = subband.tbx0;
          var y0 = subband.tby0;
          var width = subband.tbx1 - subband.tbx0;
          var codeblocks = subband.codeblocks;
          var right = subband.type.charAt(0) === "H" ? 1 : 0;
          var bottom = subband.type.charAt(1) === "H" ? levelWidth : 0;
          for (var i = 0, ii = codeblocks.length; i < ii; ++i) {
            var codeblock = codeblocks[i];
            var blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
            var blockHeight = codeblock.tby1_ - codeblock.tby0_;
            if (blockWidth === 0 || blockHeight === 0) {
              continue;
            }
            if (codeblock["data"] === undefined) {
              continue;
            }
            var bitModel, currentCodingpassType;
            bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
            currentCodingpassType = 2;
            var data = codeblock.data,
              totalLength = 0,
              codingpasses = 0;
            var j, jj, dataItem;
            for (j = 0, jj = data.length; j < jj; j++) {
              dataItem = data[j];
              totalLength += dataItem.end - dataItem.start;
              codingpasses += dataItem.codingpasses;
            }
            var encodedData = new Uint8Array(totalLength);
            var position = 0;
            for (j = 0, jj = data.length; j < jj; j++) {
              dataItem = data[j];
              var chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
              encodedData.set(chunk, position);
              position += chunk.length;
            }
            var decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
            bitModel.setDecoder(decoder);
            for (j = 0; j < codingpasses; j++) {
              switch (currentCodingpassType) {
                case 0:
                  bitModel.runSignificancePropagationPass();
                  break;
                case 1:
                  bitModel.runMagnitudeRefinementPass();
                  break;
                case 2:
                  bitModel.runCleanupPass();
                  if (segmentationSymbolUsed) {
                    bitModel.checkSegmentationSymbol();
                  }
                  break;
              }
              currentCodingpassType = (currentCodingpassType + 1) % 3;
            }
            var offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
            var sign = bitModel.coefficentsSign;
            var magnitude = bitModel.coefficentsMagnitude;
            var bitsDecoded = bitModel.bitsDecoded;
            var magnitudeCorrection = reversible ? 0 : 0.5;
            var k, n, nb;
            position = 0;
            var interleave = subband.type !== "LL";
            for (j = 0; j < blockHeight; j++) {
              var row = offset / width | 0;
              var levelOffset = 2 * row * (levelWidth - width) + right + bottom;
              for (k = 0; k < blockWidth; k++) {
                n = magnitude[position];
                if (n !== 0) {
                  n = (n + magnitudeCorrection) * delta;
                  if (sign[position] !== 0) {
                    n = -n;
                  }
                  nb = bitsDecoded[position];
                  var pos = interleave ? levelOffset + (offset << 1) : offset;
                  if (reversible && nb >= mb) {
                    coefficients[pos] = n;
                  } else {
                    coefficients[pos] = n * (1 << mb - nb);
                  }
                }
                offset++;
                position++;
              }
              offset += width - blockWidth;
            }
          }
        }
        function transformTile(context, tile, c) {
          var component = tile.components[c];
          var codingStyleParameters = component.codingStyleParameters;
          var quantizationParameters = component.quantizationParameters;
          var decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
          var spqcds = quantizationParameters.SPqcds;
          var scalarExpounded = quantizationParameters.scalarExpounded;
          var guardBits = quantizationParameters.guardBits;
          var segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
          var precision = context.components[c].precision;
          var reversible = codingStyleParameters.reversibleTransformation;
          var transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
          var subbandCoefficients = [];
          var b = 0;
          for (var i = 0; i <= decompositionLevelsCount; i++) {
            var resolution = component.resolutions[i];
            var width = resolution.trx1 - resolution.trx0;
            var height = resolution.try1 - resolution.try0;
            var coefficients = new Float32Array(width * height);
            for (var j = 0, jj = resolution.subbands.length; j < jj; j++) {
              var mu, epsilon;
              if (!scalarExpounded) {
                mu = spqcds[0].mu;
                epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
              } else {
                mu = spqcds[b].mu;
                epsilon = spqcds[b].epsilon;
                b++;
              }
              var subband = resolution.subbands[j];
              var gainLog2 = SubbandsGainLog2[subband.type];
              var delta = reversible ? 1 : Math.pow(2, precision + gainLog2 - epsilon) * (1 + mu / 2048);
              var mb = guardBits + epsilon - 1;
              copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed);
            }
            subbandCoefficients.push({
              width: width,
              height: height,
              items: coefficients
            });
          }
          var result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
          return {
            left: component.tcx0,
            top: component.tcy0,
            width: result.width,
            height: result.height,
            items: result.items
          };
        }
        function transformComponents(context) {
          var siz = context.SIZ;
          var components = context.components;
          var componentsCount = siz.Csiz;
          var resultImages = [];
          for (var i = 0, ii = context.tiles.length; i < ii; i++) {
            var tile = context.tiles[i];
            var transformedTiles = [];
            var c;
            for (c = 0; c < componentsCount; c++) {
              transformedTiles[c] = transformTile(context, tile, c);
            }
            var tile0 = transformedTiles[0];
            var out = new Uint8ClampedArray(tile0.items.length * componentsCount);
            var result = {
              left: tile0.left,
              top: tile0.top,
              width: tile0.width,
              height: tile0.height,
              items: out
            };
            var shift, offset;
            var pos = 0,
              j,
              jj,
              y0,
              y1,
              y2;
            if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
              var fourComponents = componentsCount === 4;
              var y0items = transformedTiles[0].items;
              var y1items = transformedTiles[1].items;
              var y2items = transformedTiles[2].items;
              var y3items = fourComponents ? transformedTiles[3].items : null;
              shift = components[0].precision - 8;
              offset = (128 << shift) + 0.5;
              var component0 = tile.components[0];
              var alpha01 = componentsCount - 3;
              jj = y0items.length;
              if (!component0.codingStyleParameters.reversibleTransformation) {
                for (j = 0; j < jj; j++, pos += alpha01) {
                  y0 = y0items[j] + offset;
                  y1 = y1items[j];
                  y2 = y2items[j];
                  out[pos++] = y0 + 1.402 * y2 >> shift;
                  out[pos++] = y0 - 0.34413 * y1 - 0.71414 * y2 >> shift;
                  out[pos++] = y0 + 1.772 * y1 >> shift;
                }
              } else {
                for (j = 0; j < jj; j++, pos += alpha01) {
                  y0 = y0items[j] + offset;
                  y1 = y1items[j];
                  y2 = y2items[j];
                  var g = y0 - (y2 + y1 >> 2);
                  out[pos++] = g + y2 >> shift;
                  out[pos++] = g >> shift;
                  out[pos++] = g + y1 >> shift;
                }
              }
              if (fourComponents) {
                for (j = 0, pos = 3; j < jj; j++, pos += 4) {
                  out[pos] = y3items[j] + offset >> shift;
                }
              }
            } else {
              for (c = 0; c < componentsCount; c++) {
                var items = transformedTiles[c].items;
                shift = components[c].precision - 8;
                offset = (128 << shift) + 0.5;
                for (pos = c, j = 0, jj = items.length; j < jj; j++) {
                  out[pos] = items[j] + offset >> shift;
                  pos += componentsCount;
                }
              }
            }
            resultImages.push(result);
          }
          return resultImages;
        }
        function initializeTile(context, tileIndex) {
          var siz = context.SIZ;
          var componentsCount = siz.Csiz;
          var tile = context.tiles[tileIndex];
          for (var c = 0; c < componentsCount; c++) {
            var component = tile.components[c];
            var qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
            component.quantizationParameters = qcdOrQcc;
            var codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
            component.codingStyleParameters = codOrCoc;
          }
          tile.codingStyleDefaultParameters = context.currentTile.COD;
        }
        var TagTree = function TagTreeClosure() {
          function TagTree(width, height) {
            var levelsLength = (0, _util.log2)(Math.max(width, height)) + 1;
            this.levels = [];
            for (var i = 0; i < levelsLength; i++) {
              var level = {
                width: width,
                height: height,
                items: []
              };
              this.levels.push(level);
              width = Math.ceil(width / 2);
              height = Math.ceil(height / 2);
            }
          }
          TagTree.prototype = {
            reset: function TagTree_reset(i, j) {
              var currentLevel = 0,
                value = 0,
                level;
              while (currentLevel < this.levels.length) {
                level = this.levels[currentLevel];
                var index = i + j * level.width;
                if (level.items[index] !== undefined) {
                  value = level.items[index];
                  break;
                }
                level.index = index;
                i >>= 1;
                j >>= 1;
                currentLevel++;
              }
              currentLevel--;
              level = this.levels[currentLevel];
              level.items[level.index] = value;
              this.currentLevel = currentLevel;
              delete this.value;
            },
            incrementValue: function TagTree_incrementValue() {
              var level = this.levels[this.currentLevel];
              level.items[level.index]++;
            },
            nextLevel: function TagTree_nextLevel() {
              var currentLevel = this.currentLevel;
              var level = this.levels[currentLevel];
              var value = level.items[level.index];
              currentLevel--;
              if (currentLevel < 0) {
                this.value = value;
                return false;
              }
              this.currentLevel = currentLevel;
              level = this.levels[currentLevel];
              level.items[level.index] = value;
              return true;
            }
          };
          return TagTree;
        }();
        var InclusionTree = function InclusionTreeClosure() {
          function InclusionTree(width, height, defaultValue) {
            var levelsLength = (0, _util.log2)(Math.max(width, height)) + 1;
            this.levels = [];
            for (var i = 0; i < levelsLength; i++) {
              var items = new Uint8Array(width * height);
              for (var j = 0, jj = items.length; j < jj; j++) {
                items[j] = defaultValue;
              }
              var level = {
                width: width,
                height: height,
                items: items
              };
              this.levels.push(level);
              width = Math.ceil(width / 2);
              height = Math.ceil(height / 2);
            }
          }
          InclusionTree.prototype = {
            reset: function InclusionTree_reset(i, j, stopValue) {
              var currentLevel = 0;
              while (currentLevel < this.levels.length) {
                var level = this.levels[currentLevel];
                var index = i + j * level.width;
                level.index = index;
                var value = level.items[index];
                if (value === 0xFF) {
                  break;
                }
                if (value > stopValue) {
                  this.currentLevel = currentLevel;
                  this.propagateValues();
                  return false;
                }
                i >>= 1;
                j >>= 1;
                currentLevel++;
              }
              this.currentLevel = currentLevel - 1;
              return true;
            },
            incrementValue: function InclusionTree_incrementValue(stopValue) {
              var level = this.levels[this.currentLevel];
              level.items[level.index] = stopValue + 1;
              this.propagateValues();
            },
            propagateValues: function InclusionTree_propagateValues() {
              var levelIndex = this.currentLevel;
              var level = this.levels[levelIndex];
              var currentValue = level.items[level.index];
              while (--levelIndex >= 0) {
                level = this.levels[levelIndex];
                level.items[level.index] = currentValue;
              }
            },
            nextLevel: function InclusionTree_nextLevel() {
              var currentLevel = this.currentLevel;
              var level = this.levels[currentLevel];
              var value = level.items[level.index];
              level.items[level.index] = 0xFF;
              currentLevel--;
              if (currentLevel < 0) {
                return false;
              }
              this.currentLevel = currentLevel;
              level = this.levels[currentLevel];
              level.items[level.index] = value;
              return true;
            }
          };
          return InclusionTree;
        }();
        var BitModel = function BitModelClosure() {
          var UNIFORM_CONTEXT = 17;
          var RUNLENGTH_CONTEXT = 18;
          var LLAndLHContextsLabel = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]);
          var HLContextLabel = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]);
          var HHContextLabel = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
          function BitModel(width, height, subband, zeroBitPlanes, mb) {
            this.width = width;
            this.height = height;
            this.contextLabelTable = subband === "HH" ? HHContextLabel : subband === "HL" ? HLContextLabel : LLAndLHContextsLabel;
            var coefficientCount = width * height;
            this.neighborsSignificance = new Uint8Array(coefficientCount);
            this.coefficentsSign = new Uint8Array(coefficientCount);
            this.coefficentsMagnitude = mb > 14 ? new Uint32Array(coefficientCount) : mb > 6 ? new Uint16Array(coefficientCount) : new Uint8Array(coefficientCount);
            this.processingFlags = new Uint8Array(coefficientCount);
            var bitsDecoded = new Uint8Array(coefficientCount);
            if (zeroBitPlanes !== 0) {
              for (var i = 0; i < coefficientCount; i++) {
                bitsDecoded[i] = zeroBitPlanes;
              }
            }
            this.bitsDecoded = bitsDecoded;
            this.reset();
          }
          BitModel.prototype = {
            setDecoder: function BitModel_setDecoder(decoder) {
              this.decoder = decoder;
            },
            reset: function BitModel_reset() {
              this.contexts = new Int8Array(19);
              this.contexts[0] = 4 << 1 | 0;
              this.contexts[UNIFORM_CONTEXT] = 46 << 1 | 0;
              this.contexts[RUNLENGTH_CONTEXT] = 3 << 1 | 0;
            },
            setNeighborsSignificance: function BitModel_setNeighborsSignificance(row, column, index) {
              var neighborsSignificance = this.neighborsSignificance;
              var width = this.width,
                height = this.height;
              var left = column > 0;
              var right = column + 1 < width;
              var i;
              if (row > 0) {
                i = index - width;
                if (left) {
                  neighborsSignificance[i - 1] += 0x10;
                }
                if (right) {
                  neighborsSignificance[i + 1] += 0x10;
                }
                neighborsSignificance[i] += 0x04;
              }
              if (row + 1 < height) {
                i = index + width;
                if (left) {
                  neighborsSignificance[i - 1] += 0x10;
                }
                if (right) {
                  neighborsSignificance[i + 1] += 0x10;
                }
                neighborsSignificance[i] += 0x04;
              }
              if (left) {
                neighborsSignificance[index - 1] += 0x01;
              }
              if (right) {
                neighborsSignificance[index + 1] += 0x01;
              }
              neighborsSignificance[index] |= 0x80;
            },
            runSignificancePropagationPass: function BitModel_runSignificancePropagationPass() {
              var decoder = this.decoder;
              var width = this.width,
                height = this.height;
              var coefficentsMagnitude = this.coefficentsMagnitude;
              var coefficentsSign = this.coefficentsSign;
              var neighborsSignificance = this.neighborsSignificance;
              var processingFlags = this.processingFlags;
              var contexts = this.contexts;
              var labels = this.contextLabelTable;
              var bitsDecoded = this.bitsDecoded;
              var processedInverseMask = ~1;
              var processedMask = 1;
              var firstMagnitudeBitMask = 2;
              for (var i0 = 0; i0 < height; i0 += 4) {
                for (var j = 0; j < width; j++) {
                  var index = i0 * width + j;
                  for (var i1 = 0; i1 < 4; i1++, index += width) {
                    var i = i0 + i1;
                    if (i >= height) {
                      break;
                    }
                    processingFlags[index] &= processedInverseMask;
                    if (coefficentsMagnitude[index] || !neighborsSignificance[index]) {
                      continue;
                    }
                    var contextLabel = labels[neighborsSignificance[index]];
                    var decision = decoder.readBit(contexts, contextLabel);
                    if (decision) {
                      var sign = this.decodeSignBit(i, j, index);
                      coefficentsSign[index] = sign;
                      coefficentsMagnitude[index] = 1;
                      this.setNeighborsSignificance(i, j, index);
                      processingFlags[index] |= firstMagnitudeBitMask;
                    }
                    bitsDecoded[index]++;
                    processingFlags[index] |= processedMask;
                  }
                }
              }
            },
            decodeSignBit: function BitModel_decodeSignBit(row, column, index) {
              var width = this.width,
                height = this.height;
              var coefficentsMagnitude = this.coefficentsMagnitude;
              var coefficentsSign = this.coefficentsSign;
              var contribution, sign0, sign1, significance1;
              var contextLabel, decoded;
              significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
              if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
                sign1 = coefficentsSign[index + 1];
                if (significance1) {
                  sign0 = coefficentsSign[index - 1];
                  contribution = 1 - sign1 - sign0;
                } else {
                  contribution = 1 - sign1 - sign1;
                }
              } else if (significance1) {
                sign0 = coefficentsSign[index - 1];
                contribution = 1 - sign0 - sign0;
              } else {
                contribution = 0;
              }
              var horizontalContribution = 3 * contribution;
              significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
              if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
                sign1 = coefficentsSign[index + width];
                if (significance1) {
                  sign0 = coefficentsSign[index - width];
                  contribution = 1 - sign1 - sign0 + horizontalContribution;
                } else {
                  contribution = 1 - sign1 - sign1 + horizontalContribution;
                }
              } else if (significance1) {
                sign0 = coefficentsSign[index - width];
                contribution = 1 - sign0 - sign0 + horizontalContribution;
              } else {
                contribution = horizontalContribution;
              }
              if (contribution >= 0) {
                contextLabel = 9 + contribution;
                decoded = this.decoder.readBit(this.contexts, contextLabel);
              } else {
                contextLabel = 9 - contribution;
                decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
              }
              return decoded;
            },
            runMagnitudeRefinementPass: function BitModel_runMagnitudeRefinementPass() {
              var decoder = this.decoder;
              var width = this.width,
                height = this.height;
              var coefficentsMagnitude = this.coefficentsMagnitude;
              var neighborsSignificance = this.neighborsSignificance;
              var contexts = this.contexts;
              var bitsDecoded = this.bitsDecoded;
              var processingFlags = this.processingFlags;
              var processedMask = 1;
              var firstMagnitudeBitMask = 2;
              var length = width * height;
              var width4 = width * 4;
              for (var index0 = 0, indexNext; index0 < length; index0 = indexNext) {
                indexNext = Math.min(length, index0 + width4);
                for (var j = 0; j < width; j++) {
                  for (var index = index0 + j; index < indexNext; index += width) {
                    if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
                      continue;
                    }
                    var contextLabel = 16;
                    if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
                      processingFlags[index] ^= firstMagnitudeBitMask;
                      var significance = neighborsSignificance[index] & 127;
                      contextLabel = significance === 0 ? 15 : 14;
                    }
                    var bit = decoder.readBit(contexts, contextLabel);
                    coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
                    bitsDecoded[index]++;
                    processingFlags[index] |= processedMask;
                  }
                }
              }
            },
            runCleanupPass: function BitModel_runCleanupPass() {
              var decoder = this.decoder;
              var width = this.width,
                height = this.height;
              var neighborsSignificance = this.neighborsSignificance;
              var coefficentsMagnitude = this.coefficentsMagnitude;
              var coefficentsSign = this.coefficentsSign;
              var contexts = this.contexts;
              var labels = this.contextLabelTable;
              var bitsDecoded = this.bitsDecoded;
              var processingFlags = this.processingFlags;
              var processedMask = 1;
              var firstMagnitudeBitMask = 2;
              var oneRowDown = width;
              var twoRowsDown = width * 2;
              var threeRowsDown = width * 3;
              var iNext;
              for (var i0 = 0; i0 < height; i0 = iNext) {
                iNext = Math.min(i0 + 4, height);
                var indexBase = i0 * width;
                var checkAllEmpty = i0 + 3 < height;
                for (var j = 0; j < width; j++) {
                  var index0 = indexBase + j;
                  var allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
                  var i1 = 0,
                    index = index0;
                  var i = i0,
                    sign;
                  if (allEmpty) {
                    var hasSignificantCoefficent = decoder.readBit(contexts, RUNLENGTH_CONTEXT);
                    if (!hasSignificantCoefficent) {
                      bitsDecoded[index0]++;
                      bitsDecoded[index0 + oneRowDown]++;
                      bitsDecoded[index0 + twoRowsDown]++;
                      bitsDecoded[index0 + threeRowsDown]++;
                      continue;
                    }
                    i1 = decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
                    if (i1 !== 0) {
                      i = i0 + i1;
                      index += i1 * width;
                    }
                    sign = this.decodeSignBit(i, j, index);
                    coefficentsSign[index] = sign;
                    coefficentsMagnitude[index] = 1;
                    this.setNeighborsSignificance(i, j, index);
                    processingFlags[index] |= firstMagnitudeBitMask;
                    index = index0;
                    for (var i2 = i0; i2 <= i; i2++, index += width) {
                      bitsDecoded[index]++;
                    }
                    i1++;
                  }
                  for (i = i0 + i1; i < iNext; i++, index += width) {
                    if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
                      continue;
                    }
                    var contextLabel = labels[neighborsSignificance[index]];
                    var decision = decoder.readBit(contexts, contextLabel);
                    if (decision === 1) {
                      sign = this.decodeSignBit(i, j, index);
                      coefficentsSign[index] = sign;
                      coefficentsMagnitude[index] = 1;
                      this.setNeighborsSignificance(i, j, index);
                      processingFlags[index] |= firstMagnitudeBitMask;
                    }
                    bitsDecoded[index]++;
                  }
                }
              }
            },
            checkSegmentationSymbol: function BitModel_checkSegmentationSymbol() {
              var decoder = this.decoder;
              var contexts = this.contexts;
              var symbol = decoder.readBit(contexts, UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
              if (symbol !== 0xA) {
                throw new JpxError("Invalid segmentation symbol");
              }
            }
          };
          return BitModel;
        }();
        var Transform = function TransformClosure() {
          function Transform() {}
          Transform.prototype.calculate = function transformCalculate(subbands, u0, v0) {
            var ll = subbands[0];
            for (var i = 1, ii = subbands.length; i < ii; i++) {
              ll = this.iterate(ll, subbands[i], u0, v0);
            }
            return ll;
          };
          Transform.prototype.extend = function extend(buffer, offset, size) {
            var i1 = offset - 1,
              j1 = offset + 1;
            var i2 = offset + size - 2,
              j2 = offset + size;
            buffer[i1--] = buffer[j1++];
            buffer[j2++] = buffer[i2--];
            buffer[i1--] = buffer[j1++];
            buffer[j2++] = buffer[i2--];
            buffer[i1--] = buffer[j1++];
            buffer[j2++] = buffer[i2--];
            buffer[i1] = buffer[j1];
            buffer[j2] = buffer[i2];
          };
          Transform.prototype.iterate = function Transform_iterate(ll, hl_lh_hh, u0, v0) {
            var llWidth = ll.width,
              llHeight = ll.height,
              llItems = ll.items;
            var width = hl_lh_hh.width;
            var height = hl_lh_hh.height;
            var items = hl_lh_hh.items;
            var i, j, k, l, u, v;
            for (k = 0, i = 0; i < llHeight; i++) {
              l = i * 2 * width;
              for (j = 0; j < llWidth; j++, k++, l += 2) {
                items[l] = llItems[k];
              }
            }
            llItems = ll.items = null;
            var bufferPadding = 4;
            var rowBuffer = new Float32Array(width + 2 * bufferPadding);
            if (width === 1) {
              if ((u0 & 1) !== 0) {
                for (v = 0, k = 0; v < height; v++, k += width) {
                  items[k] *= 0.5;
                }
              }
            } else {
              for (v = 0, k = 0; v < height; v++, k += width) {
                rowBuffer.set(items.subarray(k, k + width), bufferPadding);
                this.extend(rowBuffer, bufferPadding, width);
                this.filter(rowBuffer, bufferPadding, width);
                items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
              }
            }
            var numBuffers = 16;
            var colBuffers = [];
            for (i = 0; i < numBuffers; i++) {
              colBuffers.push(new Float32Array(height + 2 * bufferPadding));
            }
            var b,
              currentBuffer = 0;
            ll = bufferPadding + height;
            if (height === 1) {
              if ((v0 & 1) !== 0) {
                for (u = 0; u < width; u++) {
                  items[u] *= 0.5;
                }
              }
            } else {
              for (u = 0; u < width; u++) {
                if (currentBuffer === 0) {
                  numBuffers = Math.min(width - u, numBuffers);
                  for (k = u, l = bufferPadding; l < ll; k += width, l++) {
                    for (b = 0; b < numBuffers; b++) {
                      colBuffers[b][l] = items[k + b];
                    }
                  }
                  currentBuffer = numBuffers;
                }
                currentBuffer--;
                var buffer = colBuffers[currentBuffer];
                this.extend(buffer, bufferPadding, height);
                this.filter(buffer, bufferPadding, height);
                if (currentBuffer === 0) {
                  k = u - numBuffers + 1;
                  for (l = bufferPadding; l < ll; k += width, l++) {
                    for (b = 0; b < numBuffers; b++) {
                      items[k + b] = colBuffers[b][l];
                    }
                  }
                }
              }
            }
            return {
              width: width,
              height: height,
              items: items
            };
          };
          return Transform;
        }();
        var IrreversibleTransform = function IrreversibleTransformClosure() {
          function IrreversibleTransform() {
            Transform.call(this);
          }
          IrreversibleTransform.prototype = Object.create(Transform.prototype);
          IrreversibleTransform.prototype.filter = function irreversibleTransformFilter(x, offset, length) {
            var len = length >> 1;
            offset = offset | 0;
            var j, n, current, next;
            var alpha = -1.586134342059924;
            var beta = -0.052980118572961;
            var gamma = 0.882911075530934;
            var delta = 0.443506852043971;
            var K = 1.230174104914001;
            var K_ = 1 / K;
            j = offset - 3;
            for (n = len + 4; n--; j += 2) {
              x[j] *= K_;
            }
            j = offset - 2;
            current = delta * x[j - 1];
            for (n = len + 3; n--; j += 2) {
              next = delta * x[j + 1];
              x[j] = K * x[j] - current - next;
              if (n--) {
                j += 2;
                current = delta * x[j + 1];
                x[j] = K * x[j] - current - next;
              } else {
                break;
              }
            }
            j = offset - 1;
            current = gamma * x[j - 1];
            for (n = len + 2; n--; j += 2) {
              next = gamma * x[j + 1];
              x[j] -= current + next;
              if (n--) {
                j += 2;
                current = gamma * x[j + 1];
                x[j] -= current + next;
              } else {
                break;
              }
            }
            j = offset;
            current = beta * x[j - 1];
            for (n = len + 1; n--; j += 2) {
              next = beta * x[j + 1];
              x[j] -= current + next;
              if (n--) {
                j += 2;
                current = beta * x[j + 1];
                x[j] -= current + next;
              } else {
                break;
              }
            }
            if (len !== 0) {
              j = offset + 1;
              current = alpha * x[j - 1];
              for (n = len; n--; j += 2) {
                next = alpha * x[j + 1];
                x[j] -= current + next;
                if (n--) {
                  j += 2;
                  current = alpha * x[j + 1];
                  x[j] -= current + next;
                } else {
                  break;
                }
              }
            }
          };
          return IrreversibleTransform;
        }();
        var ReversibleTransform = function ReversibleTransformClosure() {
          function ReversibleTransform() {
            Transform.call(this);
          }
          ReversibleTransform.prototype = Object.create(Transform.prototype);
          ReversibleTransform.prototype.filter = function reversibleTransformFilter(x, offset, length) {
            var len = length >> 1;
            offset = offset | 0;
            var j, n;
            for (j = offset, n = len + 1; n--; j += 2) {
              x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
            }
            for (j = offset + 1, n = len; n--; j += 2) {
              x[j] += x[j - 1] + x[j + 1] >> 1;
            }
          };
          return ReversibleTransform;
        }();
        return JpxImage;
      }();
      exports.JpxImage = JpxImage;

      /***/ }),
    /* 75 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var ArithmeticDecoder = function ArithmeticDecoderClosure() {
        var QeTable = [{
          qe: 0x5601,
          nmps: 1,
          nlps: 1,
          switchFlag: 1
        }, {
          qe: 0x3401,
          nmps: 2,
          nlps: 6,
          switchFlag: 0
        }, {
          qe: 0x1801,
          nmps: 3,
          nlps: 9,
          switchFlag: 0
        }, {
          qe: 0x0AC1,
          nmps: 4,
          nlps: 12,
          switchFlag: 0
        }, {
          qe: 0x0521,
          nmps: 5,
          nlps: 29,
          switchFlag: 0
        }, {
          qe: 0x0221,
          nmps: 38,
          nlps: 33,
          switchFlag: 0
        }, {
          qe: 0x5601,
          nmps: 7,
          nlps: 6,
          switchFlag: 1
        }, {
          qe: 0x5401,
          nmps: 8,
          nlps: 14,
          switchFlag: 0
        }, {
          qe: 0x4801,
          nmps: 9,
          nlps: 14,
          switchFlag: 0
        }, {
          qe: 0x3801,
          nmps: 10,
          nlps: 14,
          switchFlag: 0
        }, {
          qe: 0x3001,
          nmps: 11,
          nlps: 17,
          switchFlag: 0
        }, {
          qe: 0x2401,
          nmps: 12,
          nlps: 18,
          switchFlag: 0
        }, {
          qe: 0x1C01,
          nmps: 13,
          nlps: 20,
          switchFlag: 0
        }, {
          qe: 0x1601,
          nmps: 29,
          nlps: 21,
          switchFlag: 0
        }, {
          qe: 0x5601,
          nmps: 15,
          nlps: 14,
          switchFlag: 1
        }, {
          qe: 0x5401,
          nmps: 16,
          nlps: 14,
          switchFlag: 0
        }, {
          qe: 0x5101,
          nmps: 17,
          nlps: 15,
          switchFlag: 0
        }, {
          qe: 0x4801,
          nmps: 18,
          nlps: 16,
          switchFlag: 0
        }, {
          qe: 0x3801,
          nmps: 19,
          nlps: 17,
          switchFlag: 0
        }, {
          qe: 0x3401,
          nmps: 20,
          nlps: 18,
          switchFlag: 0
        }, {
          qe: 0x3001,
          nmps: 21,
          nlps: 19,
          switchFlag: 0
        }, {
          qe: 0x2801,
          nmps: 22,
          nlps: 19,
          switchFlag: 0
        }, {
          qe: 0x2401,
          nmps: 23,
          nlps: 20,
          switchFlag: 0
        }, {
          qe: 0x2201,
          nmps: 24,
          nlps: 21,
          switchFlag: 0
        }, {
          qe: 0x1C01,
          nmps: 25,
          nlps: 22,
          switchFlag: 0
        }, {
          qe: 0x1801,
          nmps: 26,
          nlps: 23,
          switchFlag: 0
        }, {
          qe: 0x1601,
          nmps: 27,
          nlps: 24,
          switchFlag: 0
        }, {
          qe: 0x1401,
          nmps: 28,
          nlps: 25,
          switchFlag: 0
        }, {
          qe: 0x1201,
          nmps: 29,
          nlps: 26,
          switchFlag: 0
        }, {
          qe: 0x1101,
          nmps: 30,
          nlps: 27,
          switchFlag: 0
        }, {
          qe: 0x0AC1,
          nmps: 31,
          nlps: 28,
          switchFlag: 0
        }, {
          qe: 0x09C1,
          nmps: 32,
          nlps: 29,
          switchFlag: 0
        }, {
          qe: 0x08A1,
          nmps: 33,
          nlps: 30,
          switchFlag: 0
        }, {
          qe: 0x0521,
          nmps: 34,
          nlps: 31,
          switchFlag: 0
        }, {
          qe: 0x0441,
          nmps: 35,
          nlps: 32,
          switchFlag: 0
        }, {
          qe: 0x02A1,
          nmps: 36,
          nlps: 33,
          switchFlag: 0
        }, {
          qe: 0x0221,
          nmps: 37,
          nlps: 34,
          switchFlag: 0
        }, {
          qe: 0x0141,
          nmps: 38,
          nlps: 35,
          switchFlag: 0
        }, {
          qe: 0x0111,
          nmps: 39,
          nlps: 36,
          switchFlag: 0
        }, {
          qe: 0x0085,
          nmps: 40,
          nlps: 37,
          switchFlag: 0
        }, {
          qe: 0x0049,
          nmps: 41,
          nlps: 38,
          switchFlag: 0
        }, {
          qe: 0x0025,
          nmps: 42,
          nlps: 39,
          switchFlag: 0
        }, {
          qe: 0x0015,
          nmps: 43,
          nlps: 40,
          switchFlag: 0
        }, {
          qe: 0x0009,
          nmps: 44,
          nlps: 41,
          switchFlag: 0
        }, {
          qe: 0x0005,
          nmps: 45,
          nlps: 42,
          switchFlag: 0
        }, {
          qe: 0x0001,
          nmps: 45,
          nlps: 43,
          switchFlag: 0
        }, {
          qe: 0x5601,
          nmps: 46,
          nlps: 46,
          switchFlag: 0
        }];
        function ArithmeticDecoder(data, start, end) {
          this.data = data;
          this.bp = start;
          this.dataEnd = end;
          this.chigh = data[start];
          this.clow = 0;
          this.byteIn();
          this.chigh = this.chigh << 7 & 0xFFFF | this.clow >> 9 & 0x7F;
          this.clow = this.clow << 7 & 0xFFFF;
          this.ct -= 7;
          this.a = 0x8000;
        }
        ArithmeticDecoder.prototype = {
          byteIn: function ArithmeticDecoder_byteIn() {
            var data = this.data;
            var bp = this.bp;
            if (data[bp] === 0xFF) {
              var b1 = data[bp + 1];
              if (b1 > 0x8F) {
                this.clow += 0xFF00;
                this.ct = 8;
              } else {
                bp++;
                this.clow += data[bp] << 9;
                this.ct = 7;
                this.bp = bp;
              }
            } else {
              bp++;
              this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xFF00;
              this.ct = 8;
              this.bp = bp;
            }
            if (this.clow > 0xFFFF) {
              this.chigh += this.clow >> 16;
              this.clow &= 0xFFFF;
            }
          },
          readBit: function ArithmeticDecoder_readBit(contexts, pos) {
            var cx_index = contexts[pos] >> 1,
              cx_mps = contexts[pos] & 1;
            var qeTableIcx = QeTable[cx_index];
            var qeIcx = qeTableIcx.qe;
            var d;
            var a = this.a - qeIcx;
            if (this.chigh < qeIcx) {
              if (a < qeIcx) {
                a = qeIcx;
                d = cx_mps;
                cx_index = qeTableIcx.nmps;
              } else {
                a = qeIcx;
                d = 1 ^ cx_mps;
                if (qeTableIcx.switchFlag === 1) {
                  cx_mps = d;
                }
                cx_index = qeTableIcx.nlps;
              }
            } else {
              this.chigh -= qeIcx;
              if ((a & 0x8000) !== 0) {
                this.a = a;
                return cx_mps;
              }
              if (a < qeIcx) {
                d = 1 ^ cx_mps;
                if (qeTableIcx.switchFlag === 1) {
                  cx_mps = d;
                }
                cx_index = qeTableIcx.nlps;
              } else {
                d = cx_mps;
                cx_index = qeTableIcx.nmps;
              }
            }
            do {
              if (this.ct === 0) {
                this.byteIn();
              }
              a <<= 1;
              this.chigh = this.chigh << 1 & 0xFFFF | this.clow >> 15 & 1;
              this.clow = this.clow << 1 & 0xFFFF;
              this.ct--;
            } while ((a & 0x8000) === 0);
            this.a = a;
            contexts[pos] = cx_index << 1 | cx_mps;
            return d;
          }
        };
        return ArithmeticDecoder;
      }();
      exports.ArithmeticDecoder = ArithmeticDecoder;

      /***/ }),
    /* 76 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.calculateSHA512 = exports.calculateSHA384 = exports.calculateSHA256 = exports.calculateMD5 = exports.PDF20 = exports.PDF17 = exports.CipherTransformFactory = exports.ARCFourCipher = exports.AES256Cipher = exports.AES128Cipher = undefined;

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var _stream = __w_pdfjs_require__(5);

      var ARCFourCipher = function ARCFourCipherClosure() {
        function ARCFourCipher(key) {
          this.a = 0;
          this.b = 0;
          var s = new Uint8Array(256);
          var i,
            j = 0,
            tmp,
            keyLength = key.length;
          for (i = 0; i < 256; ++i) {
            s[i] = i;
          }
          for (i = 0; i < 256; ++i) {
            tmp = s[i];
            j = j + tmp + key[i % keyLength] & 0xFF;
            s[i] = s[j];
            s[j] = tmp;
          }
          this.s = s;
        }
        ARCFourCipher.prototype = {
          encryptBlock: function ARCFourCipher_encryptBlock(data) {
            var i,
              n = data.length,
              tmp,
              tmp2;
            var a = this.a,
              b = this.b,
              s = this.s;
            var output = new Uint8Array(n);
            for (i = 0; i < n; ++i) {
              a = a + 1 & 0xFF;
              tmp = s[a];
              b = b + tmp & 0xFF;
              tmp2 = s[b];
              s[a] = tmp2;
              s[b] = tmp;
              output[i] = data[i] ^ s[tmp + tmp2 & 0xFF];
            }
            this.a = a;
            this.b = b;
            return output;
          }
        };
        ARCFourCipher.prototype.decryptBlock = ARCFourCipher.prototype.encryptBlock;
        return ARCFourCipher;
      }();
      var calculateMD5 = function calculateMD5Closure() {
        var r = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
        var k = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
        function hash(data, offset, length) {
          var h0 = 1732584193,
            h1 = -271733879,
            h2 = -1732584194,
            h3 = 271733878;
          var paddedLength = length + 72 & ~63;
          var padded = new Uint8Array(paddedLength);
          var i, j, n;
          for (i = 0; i < length; ++i) {
            padded[i] = data[offset++];
          }
          padded[i++] = 0x80;
          n = paddedLength - 8;
          while (i < n) {
            padded[i++] = 0;
          }
          padded[i++] = length << 3 & 0xFF;
          padded[i++] = length >> 5 & 0xFF;
          padded[i++] = length >> 13 & 0xFF;
          padded[i++] = length >> 21 & 0xFF;
          padded[i++] = length >>> 29 & 0xFF;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          var w = new Int32Array(16);
          for (i = 0; i < paddedLength;) {
            for (j = 0; j < 16; ++j, i += 4) {
              w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
            }
            var a = h0,
              b = h1,
              c = h2,
              d = h3,
              f,
              g;
            for (j = 0; j < 64; ++j) {
              if (j < 16) {
                f = b & c | ~b & d;
                g = j;
              } else if (j < 32) {
                f = d & b | ~d & c;
                g = 5 * j + 1 & 15;
              } else if (j < 48) {
                f = b ^ c ^ d;
                g = 3 * j + 5 & 15;
              } else {
                f = c ^ (b | ~d);
                g = 7 * j & 15;
              }
              var tmp = d,
                rotateArg = a + f + k[j] + w[g] | 0,
                rotate = r[j];
              d = c;
              c = b;
              b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
              a = tmp;
            }
            h0 = h0 + a | 0;
            h1 = h1 + b | 0;
            h2 = h2 + c | 0;
            h3 = h3 + d | 0;
          }
          return new Uint8Array([h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >>> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >>> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >>> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >>> 24 & 0xFF]);
        }
        return hash;
      }();
      var Word64 = function Word64Closure() {
        function Word64(highInteger, lowInteger) {
          this.high = highInteger | 0;
          this.low = lowInteger | 0;
        }
        Word64.prototype = {
          and: function Word64_and(word) {
            this.high &= word.high;
            this.low &= word.low;
          },
          xor: function Word64_xor(word) {
            this.high ^= word.high;
            this.low ^= word.low;
          },
          or: function Word64_or(word) {
            this.high |= word.high;
            this.low |= word.low;
          },
          shiftRight: function Word64_shiftRight(places) {
            if (places >= 32) {
              this.low = this.high >>> places - 32 | 0;
              this.high = 0;
            } else {
              this.low = this.low >>> places | this.high << 32 - places;
              this.high = this.high >>> places | 0;
            }
          },
          shiftLeft: function Word64_shiftLeft(places) {
            if (places >= 32) {
              this.high = this.low << places - 32;
              this.low = 0;
            } else {
              this.high = this.high << places | this.low >>> 32 - places;
              this.low = this.low << places;
            }
          },
          rotateRight: function Word64_rotateRight(places) {
            var low, high;
            if (places & 32) {
              high = this.low;
              low = this.high;
            } else {
              low = this.low;
              high = this.high;
            }
            places &= 31;
            this.low = low >>> places | high << 32 - places;
            this.high = high >>> places | low << 32 - places;
          },
          not: function Word64_not() {
            this.high = ~this.high;
            this.low = ~this.low;
          },
          add: function Word64_add(word) {
            var lowAdd = (this.low >>> 0) + (word.low >>> 0);
            var highAdd = (this.high >>> 0) + (word.high >>> 0);
            if (lowAdd > 0xFFFFFFFF) {
              highAdd += 1;
            }
            this.low = lowAdd | 0;
            this.high = highAdd | 0;
          },
          copyTo: function Word64_copyTo(bytes, offset) {
            bytes[offset] = this.high >>> 24 & 0xFF;
            bytes[offset + 1] = this.high >> 16 & 0xFF;
            bytes[offset + 2] = this.high >> 8 & 0xFF;
            bytes[offset + 3] = this.high & 0xFF;
            bytes[offset + 4] = this.low >>> 24 & 0xFF;
            bytes[offset + 5] = this.low >> 16 & 0xFF;
            bytes[offset + 6] = this.low >> 8 & 0xFF;
            bytes[offset + 7] = this.low & 0xFF;
          },
          assign: function Word64_assign(word) {
            this.high = word.high;
            this.low = word.low;
          }
        };
        return Word64;
      }();
      var calculateSHA256 = function calculateSHA256Closure() {
        function rotr(x, n) {
          return x >>> n | x << 32 - n;
        }
        function ch(x, y, z) {
          return x & y ^ ~x & z;
        }
        function maj(x, y, z) {
          return x & y ^ x & z ^ y & z;
        }
        function sigma(x) {
          return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
        }
        function sigmaPrime(x) {
          return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
        }
        function littleSigma(x) {
          return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
        }
        function littleSigmaPrime(x) {
          return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
        }
        var k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
        function hash(data, offset, length) {
          var h0 = 0x6a09e667,
            h1 = 0xbb67ae85,
            h2 = 0x3c6ef372,
            h3 = 0xa54ff53a,
            h4 = 0x510e527f,
            h5 = 0x9b05688c,
            h6 = 0x1f83d9ab,
            h7 = 0x5be0cd19;
          var paddedLength = Math.ceil((length + 9) / 64) * 64;
          var padded = new Uint8Array(paddedLength);
          var i, j, n;
          for (i = 0; i < length; ++i) {
            padded[i] = data[offset++];
          }
          padded[i++] = 0x80;
          n = paddedLength - 8;
          while (i < n) {
            padded[i++] = 0;
          }
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = length >>> 29 & 0xFF;
          padded[i++] = length >> 21 & 0xFF;
          padded[i++] = length >> 13 & 0xFF;
          padded[i++] = length >> 5 & 0xFF;
          padded[i++] = length << 3 & 0xFF;
          var w = new Uint32Array(64);
          for (i = 0; i < paddedLength;) {
            for (j = 0; j < 16; ++j) {
              w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
              i += 4;
            }
            for (j = 16; j < 64; ++j) {
              w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
            }
            var a = h0,
              b = h1,
              c = h2,
              d = h3,
              e = h4,
              f = h5,
              g = h6,
              h = h7,
              t1,
              t2;
            for (j = 0; j < 64; ++j) {
              t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
              t2 = sigma(a) + maj(a, b, c);
              h = g;
              g = f;
              f = e;
              e = d + t1 | 0;
              d = c;
              c = b;
              b = a;
              a = t1 + t2 | 0;
            }
            h0 = h0 + a | 0;
            h1 = h1 + b | 0;
            h2 = h2 + c | 0;
            h3 = h3 + d | 0;
            h4 = h4 + e | 0;
            h5 = h5 + f | 0;
            h6 = h6 + g | 0;
            h7 = h7 + h | 0;
          }
          return new Uint8Array([h0 >> 24 & 0xFF, h0 >> 16 & 0xFF, h0 >> 8 & 0xFF, h0 & 0xFF, h1 >> 24 & 0xFF, h1 >> 16 & 0xFF, h1 >> 8 & 0xFF, h1 & 0xFF, h2 >> 24 & 0xFF, h2 >> 16 & 0xFF, h2 >> 8 & 0xFF, h2 & 0xFF, h3 >> 24 & 0xFF, h3 >> 16 & 0xFF, h3 >> 8 & 0xFF, h3 & 0xFF, h4 >> 24 & 0xFF, h4 >> 16 & 0xFF, h4 >> 8 & 0xFF, h4 & 0xFF, h5 >> 24 & 0xFF, h5 >> 16 & 0xFF, h5 >> 8 & 0xFF, h5 & 0xFF, h6 >> 24 & 0xFF, h6 >> 16 & 0xFF, h6 >> 8 & 0xFF, h6 & 0xFF, h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF]);
        }
        return hash;
      }();
      var calculateSHA512 = function calculateSHA512Closure() {
        function ch(result, x, y, z, tmp) {
          result.assign(x);
          result.and(y);
          tmp.assign(x);
          tmp.not();
          tmp.and(z);
          result.xor(tmp);
        }
        function maj(result, x, y, z, tmp) {
          result.assign(x);
          result.and(y);
          tmp.assign(x);
          tmp.and(z);
          result.xor(tmp);
          tmp.assign(y);
          tmp.and(z);
          result.xor(tmp);
        }
        function sigma(result, x, tmp) {
          result.assign(x);
          result.rotateRight(28);
          tmp.assign(x);
          tmp.rotateRight(34);
          result.xor(tmp);
          tmp.assign(x);
          tmp.rotateRight(39);
          result.xor(tmp);
        }
        function sigmaPrime(result, x, tmp) {
          result.assign(x);
          result.rotateRight(14);
          tmp.assign(x);
          tmp.rotateRight(18);
          result.xor(tmp);
          tmp.assign(x);
          tmp.rotateRight(41);
          result.xor(tmp);
        }
        function littleSigma(result, x, tmp) {
          result.assign(x);
          result.rotateRight(1);
          tmp.assign(x);
          tmp.rotateRight(8);
          result.xor(tmp);
          tmp.assign(x);
          tmp.shiftRight(7);
          result.xor(tmp);
        }
        function littleSigmaPrime(result, x, tmp) {
          result.assign(x);
          result.rotateRight(19);
          tmp.assign(x);
          tmp.rotateRight(61);
          result.xor(tmp);
          tmp.assign(x);
          tmp.shiftRight(6);
          result.xor(tmp);
        }
        var k = [new Word64(0x428a2f98, 0xd728ae22), new Word64(0x71374491, 0x23ef65cd), new Word64(0xb5c0fbcf, 0xec4d3b2f), new Word64(0xe9b5dba5, 0x8189dbbc), new Word64(0x3956c25b, 0xf348b538), new Word64(0x59f111f1, 0xb605d019), new Word64(0x923f82a4, 0xaf194f9b), new Word64(0xab1c5ed5, 0xda6d8118), new Word64(0xd807aa98, 0xa3030242), new Word64(0x12835b01, 0x45706fbe), new Word64(0x243185be, 0x4ee4b28c), new Word64(0x550c7dc3, 0xd5ffb4e2), new Word64(0x72be5d74, 0xf27b896f), new Word64(0x80deb1fe, 0x3b1696b1), new Word64(0x9bdc06a7, 0x25c71235), new Word64(0xc19bf174, 0xcf692694), new Word64(0xe49b69c1, 0x9ef14ad2), new Word64(0xefbe4786, 0x384f25e3), new Word64(0x0fc19dc6, 0x8b8cd5b5), new Word64(0x240ca1cc, 0x77ac9c65), new Word64(0x2de92c6f, 0x592b0275), new Word64(0x4a7484aa, 0x6ea6e483), new Word64(0x5cb0a9dc, 0xbd41fbd4), new Word64(0x76f988da, 0x831153b5), new Word64(0x983e5152, 0xee66dfab), new Word64(0xa831c66d, 0x2db43210), new Word64(0xb00327c8, 0x98fb213f), new Word64(0xbf597fc7, 0xbeef0ee4), new Word64(0xc6e00bf3, 0x3da88fc2), new Word64(0xd5a79147, 0x930aa725), new Word64(0x06ca6351, 0xe003826f), new Word64(0x14292967, 0x0a0e6e70), new Word64(0x27b70a85, 0x46d22ffc), new Word64(0x2e1b2138, 0x5c26c926), new Word64(0x4d2c6dfc, 0x5ac42aed), new Word64(0x53380d13, 0x9d95b3df), new Word64(0x650a7354, 0x8baf63de), new Word64(0x766a0abb, 0x3c77b2a8), new Word64(0x81c2c92e, 0x47edaee6), new Word64(0x92722c85, 0x1482353b), new Word64(0xa2bfe8a1, 0x4cf10364), new Word64(0xa81a664b, 0xbc423001), new Word64(0xc24b8b70, 0xd0f89791), new Word64(0xc76c51a3, 0x0654be30), new Word64(0xd192e819, 0xd6ef5218), new Word64(0xd6990624, 0x5565a910), new Word64(0xf40e3585, 0x5771202a), new Word64(0x106aa070, 0x32bbd1b8), new Word64(0x19a4c116, 0xb8d2d0c8), new Word64(0x1e376c08, 0x5141ab53), new Word64(0x2748774c, 0xdf8eeb99), new Word64(0x34b0bcb5, 0xe19b48a8), new Word64(0x391c0cb3, 0xc5c95a63), new Word64(0x4ed8aa4a, 0xe3418acb), new Word64(0x5b9cca4f, 0x7763e373), new Word64(0x682e6ff3, 0xd6b2b8a3), new Word64(0x748f82ee, 0x5defb2fc), new Word64(0x78a5636f, 0x43172f60), new Word64(0x84c87814, 0xa1f0ab72), new Word64(0x8cc70208, 0x1a6439ec), new Word64(0x90befffa, 0x23631e28), new Word64(0xa4506ceb, 0xde82bde9), new Word64(0xbef9a3f7, 0xb2c67915), new Word64(0xc67178f2, 0xe372532b), new Word64(0xca273ece, 0xea26619c), new Word64(0xd186b8c7, 0x21c0c207), new Word64(0xeada7dd6, 0xcde0eb1e), new Word64(0xf57d4f7f, 0xee6ed178), new Word64(0x06f067aa, 0x72176fba), new Word64(0x0a637dc5, 0xa2c898a6), new Word64(0x113f9804, 0xbef90dae), new Word64(0x1b710b35, 0x131c471b), new Word64(0x28db77f5, 0x23047d84), new Word64(0x32caab7b, 0x40c72493), new Word64(0x3c9ebe0a, 0x15c9bebc), new Word64(0x431d67c4, 0x9c100d4c), new Word64(0x4cc5d4be, 0xcb3e42b6), new Word64(0x597f299c, 0xfc657e2a), new Word64(0x5fcb6fab, 0x3ad6faec), new Word64(0x6c44198c, 0x4a475817)];
        function hash(data, offset, length, mode384) {
          mode384 = !!mode384;
          var h0, h1, h2, h3, h4, h5, h6, h7;
          if (!mode384) {
            h0 = new Word64(0x6a09e667, 0xf3bcc908);
            h1 = new Word64(0xbb67ae85, 0x84caa73b);
            h2 = new Word64(0x3c6ef372, 0xfe94f82b);
            h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
            h4 = new Word64(0x510e527f, 0xade682d1);
            h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
            h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
            h7 = new Word64(0x5be0cd19, 0x137e2179);
          } else {
            h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
            h1 = new Word64(0x629a292a, 0x367cd507);
            h2 = new Word64(0x9159015a, 0x3070dd17);
            h3 = new Word64(0x152fecd8, 0xf70e5939);
            h4 = new Word64(0x67332667, 0xffc00b31);
            h5 = new Word64(0x8eb44a87, 0x68581511);
            h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
            h7 = new Word64(0x47b5481d, 0xbefa4fa4);
          }
          var paddedLength = Math.ceil((length + 17) / 128) * 128;
          var padded = new Uint8Array(paddedLength);
          var i, j, n;
          for (i = 0; i < length; ++i) {
            padded[i] = data[offset++];
          }
          padded[i++] = 0x80;
          n = paddedLength - 16;
          while (i < n) {
            padded[i++] = 0;
          }
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = 0;
          padded[i++] = length >>> 29 & 0xFF;
          padded[i++] = length >> 21 & 0xFF;
          padded[i++] = length >> 13 & 0xFF;
          padded[i++] = length >> 5 & 0xFF;
          padded[i++] = length << 3 & 0xFF;
          var w = new Array(80);
          for (i = 0; i < 80; i++) {
            w[i] = new Word64(0, 0);
          }
          var a = new Word64(0, 0),
            b = new Word64(0, 0),
            c = new Word64(0, 0);
          var d = new Word64(0, 0),
            e = new Word64(0, 0),
            f = new Word64(0, 0);
          var g = new Word64(0, 0),
            h = new Word64(0, 0);
          var t1 = new Word64(0, 0),
            t2 = new Word64(0, 0);
          var tmp1 = new Word64(0, 0),
            tmp2 = new Word64(0, 0),
            tmp3;
          for (i = 0; i < paddedLength;) {
            for (j = 0; j < 16; ++j) {
              w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
              w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
              i += 8;
            }
            for (j = 16; j < 80; ++j) {
              tmp3 = w[j];
              littleSigmaPrime(tmp3, w[j - 2], tmp2);
              tmp3.add(w[j - 7]);
              littleSigma(tmp1, w[j - 15], tmp2);
              tmp3.add(tmp1);
              tmp3.add(w[j - 16]);
            }
            a.assign(h0);
            b.assign(h1);
            c.assign(h2);
            d.assign(h3);
            e.assign(h4);
            f.assign(h5);
            g.assign(h6);
            h.assign(h7);
            for (j = 0; j < 80; ++j) {
              t1.assign(h);
              sigmaPrime(tmp1, e, tmp2);
              t1.add(tmp1);
              ch(tmp1, e, f, g, tmp2);
              t1.add(tmp1);
              t1.add(k[j]);
              t1.add(w[j]);
              sigma(t2, a, tmp2);
              maj(tmp1, a, b, c, tmp2);
              t2.add(tmp1);
              tmp3 = h;
              h = g;
              g = f;
              f = e;
              d.add(t1);
              e = d;
              d = c;
              c = b;
              b = a;
              tmp3.assign(t1);
              tmp3.add(t2);
              a = tmp3;
            }
            h0.add(a);
            h1.add(b);
            h2.add(c);
            h3.add(d);
            h4.add(e);
            h5.add(f);
            h6.add(g);
            h7.add(h);
          }
          var result;
          if (!mode384) {
            result = new Uint8Array(64);
            h0.copyTo(result, 0);
            h1.copyTo(result, 8);
            h2.copyTo(result, 16);
            h3.copyTo(result, 24);
            h4.copyTo(result, 32);
            h5.copyTo(result, 40);
            h6.copyTo(result, 48);
            h7.copyTo(result, 56);
          } else {
            result = new Uint8Array(48);
            h0.copyTo(result, 0);
            h1.copyTo(result, 8);
            h2.copyTo(result, 16);
            h3.copyTo(result, 24);
            h4.copyTo(result, 32);
            h5.copyTo(result, 40);
          }
          return result;
        }
        return hash;
      }();
      var calculateSHA384 = function calculateSHA384Closure() {
        function hash(data, offset, length) {
          return calculateSHA512(data, offset, length, true);
        }
        return hash;
      }();
      var NullCipher = function NullCipherClosure() {
        function NullCipher() {}
        NullCipher.prototype = {
          decryptBlock: function NullCipher_decryptBlock(data) {
            return data;
          }
        };
        return NullCipher;
      }();
      var AES128Cipher = function AES128CipherClosure() {
        var rcon = new Uint8Array([0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d]);
        var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
        var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
        var mixCol = new Uint8Array(256);
        for (var i = 0; i < 256; i++) {
          if (i < 128) {
            mixCol[i] = i << 1;
          } else {
            mixCol[i] = i << 1 ^ 0x1b;
          }
        }
        var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
        function expandKey128(cipherKey) {
          var b = 176,
            result = new Uint8Array(b);
          result.set(cipherKey);
          for (var j = 16, i = 1; j < b; ++i) {
            var t1 = result[j - 3],
              t2 = result[j - 2],
              t3 = result[j - 1],
              t4 = result[j - 4];
            t1 = s[t1];
            t2 = s[t2];
            t3 = s[t3];
            t4 = s[t4];
            t1 = t1 ^ rcon[i];
            for (var n = 0; n < 4; ++n) {
              result[j] = t1 ^= result[j - 16];
              j++;
              result[j] = t2 ^= result[j - 16];
              j++;
              result[j] = t3 ^= result[j - 16];
              j++;
              result[j] = t4 ^= result[j - 16];
              j++;
            }
          }
          return result;
        }
        function decrypt128(input, key) {
          var state = new Uint8Array(16);
          state.set(input);
          var i, j, k;
          var t, u, v;
          for (j = 0, k = 160; j < 16; ++j, ++k) {
            state[j] ^= key[k];
          }
          for (i = 9; i >= 1; --i) {
            t = state[13];
            state[13] = state[9];
            state[9] = state[5];
            state[5] = state[1];
            state[1] = t;
            t = state[14];
            u = state[10];
            state[14] = state[6];
            state[10] = state[2];
            state[6] = t;
            state[2] = u;
            t = state[15];
            u = state[11];
            v = state[7];
            state[15] = state[3];
            state[11] = t;
            state[7] = u;
            state[3] = v;
            for (j = 0; j < 16; ++j) {
              state[j] = inv_s[state[j]];
            }
            for (j = 0, k = i * 16; j < 16; ++j, ++k) {
              state[j] ^= key[k];
            }
            for (j = 0; j < 16; j += 4) {
              var s0 = mix[state[j]],
                s1 = mix[state[j + 1]],
                s2 = mix[state[j + 2]],
                s3 = mix[state[j + 3]];
              t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
              state[j] = t >>> 24 & 0xFF;
              state[j + 1] = t >> 16 & 0xFF;
              state[j + 2] = t >> 8 & 0xFF;
              state[j + 3] = t & 0xFF;
            }
          }
          t = state[13];
          state[13] = state[9];
          state[9] = state[5];
          state[5] = state[1];
          state[1] = t;
          t = state[14];
          u = state[10];
          state[14] = state[6];
          state[10] = state[2];
          state[6] = t;
          state[2] = u;
          t = state[15];
          u = state[11];
          v = state[7];
          state[15] = state[3];
          state[11] = t;
          state[7] = u;
          state[3] = v;
          for (j = 0; j < 16; ++j) {
            state[j] = inv_s[state[j]];
            state[j] ^= key[j];
          }
          return state;
        }
        function encrypt128(input, key) {
          var t, u, v, k;
          var state = new Uint8Array(16);
          state.set(input);
          for (j = 0; j < 16; ++j) {
            state[j] ^= key[j];
          }
          for (i = 1; i < 10; i++) {
            for (j = 0; j < 16; ++j) {
              state[j] = s[state[j]];
            }
            v = state[1];
            state[1] = state[5];
            state[5] = state[9];
            state[9] = state[13];
            state[13] = v;
            v = state[2];
            u = state[6];
            state[2] = state[10];
            state[6] = state[14];
            state[10] = v;
            state[14] = u;
            v = state[3];
            u = state[7];
            t = state[11];
            state[3] = state[15];
            state[7] = v;
            state[11] = u;
            state[15] = t;
            for (var j = 0; j < 16; j += 4) {
              var s0 = state[j + 0],
                s1 = state[j + 1];
              var s2 = state[j + 2],
                s3 = state[j + 3];
              t = s0 ^ s1 ^ s2 ^ s3;
              state[j + 0] ^= t ^ mixCol[s0 ^ s1];
              state[j + 1] ^= t ^ mixCol[s1 ^ s2];
              state[j + 2] ^= t ^ mixCol[s2 ^ s3];
              state[j + 3] ^= t ^ mixCol[s3 ^ s0];
            }
            for (j = 0, k = i * 16; j < 16; ++j, ++k) {
              state[j] ^= key[k];
            }
          }
          for (j = 0; j < 16; ++j) {
            state[j] = s[state[j]];
          }
          v = state[1];
          state[1] = state[5];
          state[5] = state[9];
          state[9] = state[13];
          state[13] = v;
          v = state[2];
          u = state[6];
          state[2] = state[10];
          state[6] = state[14];
          state[10] = v;
          state[14] = u;
          v = state[3];
          u = state[7];
          t = state[11];
          state[3] = state[15];
          state[7] = v;
          state[11] = u;
          state[15] = t;
          for (j = 0, k = 160; j < 16; ++j, ++k) {
            state[j] ^= key[k];
          }
          return state;
        }
        function AES128Cipher(key) {
          this.key = expandKey128(key);
          this.buffer = new Uint8Array(16);
          this.bufferPosition = 0;
        }
        function decryptBlock2(data, finalize) {
          var i,
            j,
            ii,
            sourceLength = data.length,
            buffer = this.buffer,
            bufferLength = this.bufferPosition,
            result = [],
            iv = this.iv;
          for (i = 0; i < sourceLength; ++i) {
            buffer[bufferLength] = data[i];
            ++bufferLength;
            if (bufferLength < 16) {
              continue;
            }
            var plain = decrypt128(buffer, this.key);
            for (j = 0; j < 16; ++j) {
              plain[j] ^= iv[j];
            }
            iv = buffer;
            result.push(plain);
            buffer = new Uint8Array(16);
            bufferLength = 0;
          }
          this.buffer = buffer;
          this.bufferLength = bufferLength;
          this.iv = iv;
          if (result.length === 0) {
            return new Uint8Array([]);
          }
          var outputLength = 16 * result.length;
          if (finalize) {
            var lastBlock = result[result.length - 1];
            var psLen = lastBlock[15];
            if (psLen <= 16) {
              for (i = 15, ii = 16 - psLen; i >= ii; --i) {
                if (lastBlock[i] !== psLen) {
                  psLen = 0;
                  break;
                }
              }
              outputLength -= psLen;
              result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
            }
          }
          var output = new Uint8Array(outputLength);
          for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
            output.set(result[i], j);
          }
          return output;
        }
        AES128Cipher.prototype = {
          decryptBlock: function AES128Cipher_decryptBlock(data, finalize) {
            var i,
              sourceLength = data.length;
            var buffer = this.buffer,
              bufferLength = this.bufferPosition;
            for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
              buffer[bufferLength] = data[i];
            }
            if (bufferLength < 16) {
              this.bufferLength = bufferLength;
              return new Uint8Array([]);
            }
            this.iv = buffer;
            this.buffer = new Uint8Array(16);
            this.bufferLength = 0;
            this.decryptBlock = decryptBlock2;
            return this.decryptBlock(data.subarray(16), finalize);
          },
          encrypt: function AES128Cipher_encrypt(data, iv) {
            var i,
              j,
              ii,
              sourceLength = data.length,
              buffer = this.buffer,
              bufferLength = this.bufferPosition,
              result = [];
            if (!iv) {
              iv = new Uint8Array(16);
            }
            for (i = 0; i < sourceLength; ++i) {
              buffer[bufferLength] = data[i];
              ++bufferLength;
              if (bufferLength < 16) {
                continue;
              }
              for (j = 0; j < 16; ++j) {
                buffer[j] ^= iv[j];
              }
              var cipher = encrypt128(buffer, this.key);
              iv = cipher;
              result.push(cipher);
              buffer = new Uint8Array(16);
              bufferLength = 0;
            }
            this.buffer = buffer;
            this.bufferLength = bufferLength;
            this.iv = iv;
            if (result.length === 0) {
              return new Uint8Array([]);
            }
            var outputLength = 16 * result.length;
            var output = new Uint8Array(outputLength);
            for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
              output.set(result[i], j);
            }
            return output;
          }
        };
        return AES128Cipher;
      }();
      var AES256Cipher = function AES256CipherClosure() {
        var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
        var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
        var mixCol = new Uint8Array(256);
        for (var i = 0; i < 256; i++) {
          if (i < 128) {
            mixCol[i] = i << 1;
          } else {
            mixCol[i] = i << 1 ^ 0x1b;
          }
        }
        var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
        function expandKey256(cipherKey) {
          var b = 240,
            result = new Uint8Array(b);
          var r = 1;
          result.set(cipherKey);
          for (var j = 32, i = 1; j < b; ++i) {
            if (j % 32 === 16) {
              t1 = s[t1];
              t2 = s[t2];
              t3 = s[t3];
              t4 = s[t4];
            } else if (j % 32 === 0) {
              var t1 = result[j - 3],
                t2 = result[j - 2],
                t3 = result[j - 1],
                t4 = result[j - 4];
              t1 = s[t1];
              t2 = s[t2];
              t3 = s[t3];
              t4 = s[t4];
              t1 = t1 ^ r;
              if ((r <<= 1) >= 256) {
                r = (r ^ 0x1b) & 0xFF;
              }
            }
            for (var n = 0; n < 4; ++n) {
              result[j] = t1 ^= result[j - 32];
              j++;
              result[j] = t2 ^= result[j - 32];
              j++;
              result[j] = t3 ^= result[j - 32];
              j++;
              result[j] = t4 ^= result[j - 32];
              j++;
            }
          }
          return result;
        }
        function decrypt256(input, key) {
          var state = new Uint8Array(16);
          state.set(input);
          var i, j, k;
          var t, u, v;
          for (j = 0, k = 224; j < 16; ++j, ++k) {
            state[j] ^= key[k];
          }
          for (i = 13; i >= 1; --i) {
            t = state[13];
            state[13] = state[9];
            state[9] = state[5];
            state[5] = state[1];
            state[1] = t;
            t = state[14];
            u = state[10];
            state[14] = state[6];
            state[10] = state[2];
            state[6] = t;
            state[2] = u;
            t = state[15];
            u = state[11];
            v = state[7];
            state[15] = state[3];
            state[11] = t;
            state[7] = u;
            state[3] = v;
            for (j = 0; j < 16; ++j) {
              state[j] = inv_s[state[j]];
            }
            for (j = 0, k = i * 16; j < 16; ++j, ++k) {
              state[j] ^= key[k];
            }
            for (j = 0; j < 16; j += 4) {
              var s0 = mix[state[j]],
                s1 = mix[state[j + 1]],
                s2 = mix[state[j + 2]],
                s3 = mix[state[j + 3]];
              t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
              state[j] = t >>> 24 & 0xFF;
              state[j + 1] = t >> 16 & 0xFF;
              state[j + 2] = t >> 8 & 0xFF;
              state[j + 3] = t & 0xFF;
            }
          }
          t = state[13];
          state[13] = state[9];
          state[9] = state[5];
          state[5] = state[1];
          state[1] = t;
          t = state[14];
          u = state[10];
          state[14] = state[6];
          state[10] = state[2];
          state[6] = t;
          state[2] = u;
          t = state[15];
          u = state[11];
          v = state[7];
          state[15] = state[3];
          state[11] = t;
          state[7] = u;
          state[3] = v;
          for (j = 0; j < 16; ++j) {
            state[j] = inv_s[state[j]];
            state[j] ^= key[j];
          }
          return state;
        }
        function encrypt256(input, key) {
          var t, u, v, k;
          var state = new Uint8Array(16);
          state.set(input);
          for (j = 0; j < 16; ++j) {
            state[j] ^= key[j];
          }
          for (i = 1; i < 14; i++) {
            for (j = 0; j < 16; ++j) {
              state[j] = s[state[j]];
            }
            v = state[1];
            state[1] = state[5];
            state[5] = state[9];
            state[9] = state[13];
            state[13] = v;
            v = state[2];
            u = state[6];
            state[2] = state[10];
            state[6] = state[14];
            state[10] = v;
            state[14] = u;
            v = state[3];
            u = state[7];
            t = state[11];
            state[3] = state[15];
            state[7] = v;
            state[11] = u;
            state[15] = t;
            for (var j = 0; j < 16; j += 4) {
              var s0 = state[j + 0],
                s1 = state[j + 1];
              var s2 = state[j + 2],
                s3 = state[j + 3];
              t = s0 ^ s1 ^ s2 ^ s3;
              state[j + 0] ^= t ^ mixCol[s0 ^ s1];
              state[j + 1] ^= t ^ mixCol[s1 ^ s2];
              state[j + 2] ^= t ^ mixCol[s2 ^ s3];
              state[j + 3] ^= t ^ mixCol[s3 ^ s0];
            }
            for (j = 0, k = i * 16; j < 16; ++j, ++k) {
              state[j] ^= key[k];
            }
          }
          for (j = 0; j < 16; ++j) {
            state[j] = s[state[j]];
          }
          v = state[1];
          state[1] = state[5];
          state[5] = state[9];
          state[9] = state[13];
          state[13] = v;
          v = state[2];
          u = state[6];
          state[2] = state[10];
          state[6] = state[14];
          state[10] = v;
          state[14] = u;
          v = state[3];
          u = state[7];
          t = state[11];
          state[3] = state[15];
          state[7] = v;
          state[11] = u;
          state[15] = t;
          for (j = 0, k = 224; j < 16; ++j, ++k) {
            state[j] ^= key[k];
          }
          return state;
        }
        function AES256Cipher(key) {
          this.key = expandKey256(key);
          this.buffer = new Uint8Array(16);
          this.bufferPosition = 0;
        }
        function decryptBlock2(data, finalize) {
          var i,
            j,
            ii,
            sourceLength = data.length,
            buffer = this.buffer,
            bufferLength = this.bufferPosition,
            result = [],
            iv = this.iv;
          for (i = 0; i < sourceLength; ++i) {
            buffer[bufferLength] = data[i];
            ++bufferLength;
            if (bufferLength < 16) {
              continue;
            }
            var plain = decrypt256(buffer, this.key);
            for (j = 0; j < 16; ++j) {
              plain[j] ^= iv[j];
            }
            iv = buffer;
            result.push(plain);
            buffer = new Uint8Array(16);
            bufferLength = 0;
          }
          this.buffer = buffer;
          this.bufferLength = bufferLength;
          this.iv = iv;
          if (result.length === 0) {
            return new Uint8Array([]);
          }
          var outputLength = 16 * result.length;
          if (finalize) {
            var lastBlock = result[result.length - 1];
            var psLen = lastBlock[15];
            if (psLen <= 16) {
              for (i = 15, ii = 16 - psLen; i >= ii; --i) {
                if (lastBlock[i] !== psLen) {
                  psLen = 0;
                  break;
                }
              }
              outputLength -= psLen;
              result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
            }
          }
          var output = new Uint8Array(outputLength);
          for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
            output.set(result[i], j);
          }
          return output;
        }
        AES256Cipher.prototype = {
          decryptBlock: function AES256Cipher_decryptBlock(data, finalize, iv) {
            var i,
              sourceLength = data.length;
            var buffer = this.buffer,
              bufferLength = this.bufferPosition;
            if (iv) {
              this.iv = iv;
            } else {
              for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
                buffer[bufferLength] = data[i];
              }
              if (bufferLength < 16) {
                this.bufferLength = bufferLength;
                return new Uint8Array([]);
              }
              this.iv = buffer;
              data = data.subarray(16);
            }
            this.buffer = new Uint8Array(16);
            this.bufferLength = 0;
            this.decryptBlock = decryptBlock2;
            return this.decryptBlock(data, finalize);
          },
          encrypt: function AES256Cipher_encrypt(data, iv) {
            var i,
              j,
              ii,
              sourceLength = data.length,
              buffer = this.buffer,
              bufferLength = this.bufferPosition,
              result = [];
            if (!iv) {
              iv = new Uint8Array(16);
            }
            for (i = 0; i < sourceLength; ++i) {
              buffer[bufferLength] = data[i];
              ++bufferLength;
              if (bufferLength < 16) {
                continue;
              }
              for (j = 0; j < 16; ++j) {
                buffer[j] ^= iv[j];
              }
              var cipher = encrypt256(buffer, this.key);
              this.iv = cipher;
              result.push(cipher);
              buffer = new Uint8Array(16);
              bufferLength = 0;
            }
            this.buffer = buffer;
            this.bufferLength = bufferLength;
            this.iv = iv;
            if (result.length === 0) {
              return new Uint8Array([]);
            }
            var outputLength = 16 * result.length;
            var output = new Uint8Array(outputLength);
            for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
              output.set(result[i], j);
            }
            return output;
          }
        };
        return AES256Cipher;
      }();
      var PDF17 = function PDF17Closure() {
        function compareByteArrays(array1, array2) {
          if (array1.length !== array2.length) {
            return false;
          }
          for (var i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
              return false;
            }
          }
          return true;
        }
        function PDF17() {}
        PDF17.prototype = {
          checkOwnerPassword: function PDF17_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
            var hashData = new Uint8Array(password.length + 56);
            hashData.set(password, 0);
            hashData.set(ownerValidationSalt, password.length);
            hashData.set(userBytes, password.length + ownerValidationSalt.length);
            var result = calculateSHA256(hashData, 0, hashData.length);
            return compareByteArrays(result, ownerPassword);
          },
          checkUserPassword: function PDF17_checkUserPassword(password, userValidationSalt, userPassword) {
            var hashData = new Uint8Array(password.length + 8);
            hashData.set(password, 0);
            hashData.set(userValidationSalt, password.length);
            var result = calculateSHA256(hashData, 0, hashData.length);
            return compareByteArrays(result, userPassword);
          },
          getOwnerKey: function PDF17_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
            var hashData = new Uint8Array(password.length + 56);
            hashData.set(password, 0);
            hashData.set(ownerKeySalt, password.length);
            hashData.set(userBytes, password.length + ownerKeySalt.length);
            var key = calculateSHA256(hashData, 0, hashData.length);
            var cipher = new AES256Cipher(key);
            return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
          },
          getUserKey: function PDF17_getUserKey(password, userKeySalt, userEncryption) {
            var hashData = new Uint8Array(password.length + 8);
            hashData.set(password, 0);
            hashData.set(userKeySalt, password.length);
            var key = calculateSHA256(hashData, 0, hashData.length);
            var cipher = new AES256Cipher(key);
            return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
          }
        };
        return PDF17;
      }();
      var PDF20 = function PDF20Closure() {
        function concatArrays(array1, array2) {
          var t = new Uint8Array(array1.length + array2.length);
          t.set(array1, 0);
          t.set(array2, array1.length);
          return t;
        }
        function calculatePDF20Hash(password, input, userBytes) {
          var k = calculateSHA256(input, 0, input.length).subarray(0, 32);
          var e = [0];
          var i = 0;
          while (i < 64 || e[e.length - 1] > i - 32) {
            var arrayLength = password.length + k.length + userBytes.length;
            var k1 = new Uint8Array(arrayLength * 64);
            var array = concatArrays(password, k);
            array = concatArrays(array, userBytes);
            for (var j = 0, pos = 0; j < 64; j++, pos += arrayLength) {
              k1.set(array, pos);
            }
            var cipher = new AES128Cipher(k.subarray(0, 16));
            e = cipher.encrypt(k1, k.subarray(16, 32));
            var remainder = 0;
            for (var z = 0; z < 16; z++) {
              remainder *= 256 % 3;
              remainder %= 3;
              remainder += (e[z] >>> 0) % 3;
              remainder %= 3;
            }
            if (remainder === 0) {
              k = calculateSHA256(e, 0, e.length);
            } else if (remainder === 1) {
              k = calculateSHA384(e, 0, e.length);
            } else if (remainder === 2) {
              k = calculateSHA512(e, 0, e.length);
            }
            i++;
          }
          return k.subarray(0, 32);
        }
        function PDF20() {}
        function compareByteArrays(array1, array2) {
          if (array1.length !== array2.length) {
            return false;
          }
          for (var i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
              return false;
            }
          }
          return true;
        }
        PDF20.prototype = {
          hash: function PDF20_hash(password, concatBytes, userBytes) {
            return calculatePDF20Hash(password, concatBytes, userBytes);
          },
          checkOwnerPassword: function PDF20_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
            var hashData = new Uint8Array(password.length + 56);
            hashData.set(password, 0);
            hashData.set(ownerValidationSalt, password.length);
            hashData.set(userBytes, password.length + ownerValidationSalt.length);
            var result = calculatePDF20Hash(password, hashData, userBytes);
            return compareByteArrays(result, ownerPassword);
          },
          checkUserPassword: function PDF20_checkUserPassword(password, userValidationSalt, userPassword) {
            var hashData = new Uint8Array(password.length + 8);
            hashData.set(password, 0);
            hashData.set(userValidationSalt, password.length);
            var result = calculatePDF20Hash(password, hashData, []);
            return compareByteArrays(result, userPassword);
          },
          getOwnerKey: function PDF20_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
            var hashData = new Uint8Array(password.length + 56);
            hashData.set(password, 0);
            hashData.set(ownerKeySalt, password.length);
            hashData.set(userBytes, password.length + ownerKeySalt.length);
            var key = calculatePDF20Hash(password, hashData, userBytes);
            var cipher = new AES256Cipher(key);
            return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
          },
          getUserKey: function PDF20_getUserKey(password, userKeySalt, userEncryption) {
            var hashData = new Uint8Array(password.length + 8);
            hashData.set(password, 0);
            hashData.set(userKeySalt, password.length);
            var key = calculatePDF20Hash(password, hashData, []);
            var cipher = new AES256Cipher(key);
            return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
          }
        };
        return PDF20;
      }();
      var CipherTransform = function CipherTransformClosure() {
        function CipherTransform(stringCipherConstructor, streamCipherConstructor) {
          this.StringCipherConstructor = stringCipherConstructor;
          this.StreamCipherConstructor = streamCipherConstructor;
        }
        CipherTransform.prototype = {
          createStream: function CipherTransform_createStream(stream, length) {
            var cipher = new this.StreamCipherConstructor();
            return new _stream.DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
              return cipher.decryptBlock(data, finalize);
            });
          },
          decryptString: function CipherTransform_decryptString(s) {
            var cipher = new this.StringCipherConstructor();
            var data = (0, _util.stringToBytes)(s);
            data = cipher.decryptBlock(data, true);
            return (0, _util.bytesToString)(data);
          }
        };
        return CipherTransform;
      }();
      var CipherTransformFactory = function CipherTransformFactoryClosure() {
        var defaultPasswordBytes = new Uint8Array([0x28, 0xBF, 0x4E, 0x5E, 0x4E, 0x75, 0x8A, 0x41, 0x64, 0x00, 0x4E, 0x56, 0xFF, 0xFA, 0x01, 0x08, 0x2E, 0x2E, 0x00, 0xB6, 0xD0, 0x68, 0x3E, 0x80, 0x2F, 0x0C, 0xA9, 0xFE, 0x64, 0x53, 0x69, 0x7A]);
        function createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
          if (password) {
            var passwordLength = Math.min(127, password.length);
            password = password.subarray(0, passwordLength);
          } else {
            password = [];
          }
          var pdfAlgorithm;
          if (revision === 6) {
            pdfAlgorithm = new PDF20();
          } else {
            pdfAlgorithm = new PDF17();
          }
          if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) {
            return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
          } else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) {
            return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
          }
          return null;
        }
        function prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
          var hashDataSize = 40 + ownerPassword.length + fileId.length;
          var hashData = new Uint8Array(hashDataSize),
            i = 0,
            j,
            n;
          if (password) {
            n = Math.min(32, password.length);
            for (; i < n; ++i) {
              hashData[i] = password[i];
            }
          }
          j = 0;
          while (i < 32) {
            hashData[i++] = defaultPasswordBytes[j++];
          }
          for (j = 0, n = ownerPassword.length; j < n; ++j) {
            hashData[i++] = ownerPassword[j];
          }
          hashData[i++] = flags & 0xFF;
          hashData[i++] = flags >> 8 & 0xFF;
          hashData[i++] = flags >> 16 & 0xFF;
          hashData[i++] = flags >>> 24 & 0xFF;
          for (j = 0, n = fileId.length; j < n; ++j) {
            hashData[i++] = fileId[j];
          }
          if (revision >= 4 && !encryptMetadata) {
            hashData[i++] = 0xFF;
            hashData[i++] = 0xFF;
            hashData[i++] = 0xFF;
            hashData[i++] = 0xFF;
          }
          var hash = calculateMD5(hashData, 0, i);
          var keyLengthInBytes = keyLength >> 3;
          if (revision >= 3) {
            for (j = 0; j < 50; ++j) {
              hash = calculateMD5(hash, 0, keyLengthInBytes);
            }
          }
          var encryptionKey = hash.subarray(0, keyLengthInBytes);
          var cipher, checkData;
          if (revision >= 3) {
            for (i = 0; i < 32; ++i) {
              hashData[i] = defaultPasswordBytes[i];
            }
            for (j = 0, n = fileId.length; j < n; ++j) {
              hashData[i++] = fileId[j];
            }
            cipher = new ARCFourCipher(encryptionKey);
            checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
            n = encryptionKey.length;
            var derivedKey = new Uint8Array(n),
              k;
            for (j = 1; j <= 19; ++j) {
              for (k = 0; k < n; ++k) {
                derivedKey[k] = encryptionKey[k] ^ j;
              }
              cipher = new ARCFourCipher(derivedKey);
              checkData = cipher.encryptBlock(checkData);
            }
            for (j = 0, n = checkData.length; j < n; ++j) {
              if (userPassword[j] !== checkData[j]) {
                return null;
              }
            }
          } else {
            cipher = new ARCFourCipher(encryptionKey);
            checkData = cipher.encryptBlock(defaultPasswordBytes);
            for (j = 0, n = checkData.length; j < n; ++j) {
              if (userPassword[j] !== checkData[j]) {
                return null;
              }
            }
          }
          return encryptionKey;
        }
        function decodeUserPassword(password, ownerPassword, revision, keyLength) {
          var hashData = new Uint8Array(32),
            i = 0,
            j,
            n;
          n = Math.min(32, password.length);
          for (; i < n; ++i) {
            hashData[i] = password[i];
          }
          j = 0;
          while (i < 32) {
            hashData[i++] = defaultPasswordBytes[j++];
          }
          var hash = calculateMD5(hashData, 0, i);
          var keyLengthInBytes = keyLength >> 3;
          if (revision >= 3) {
            for (j = 0; j < 50; ++j) {
              hash = calculateMD5(hash, 0, hash.length);
            }
          }
          var cipher, userPassword;
          if (revision >= 3) {
            userPassword = ownerPassword;
            var derivedKey = new Uint8Array(keyLengthInBytes),
              k;
            for (j = 19; j >= 0; j--) {
              for (k = 0; k < keyLengthInBytes; ++k) {
                derivedKey[k] = hash[k] ^ j;
              }
              cipher = new ARCFourCipher(derivedKey);
              userPassword = cipher.encryptBlock(userPassword);
            }
          } else {
            cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
            userPassword = cipher.encryptBlock(ownerPassword);
          }
          return userPassword;
        }
        var identityName = _primitives.Name.get("Identity");
        function CipherTransformFactory(dict, fileId, password) {
          var filter = dict.get("Filter");
          if (!(0, _primitives.isName)(filter, "Standard")) {
            throw new _util.FormatError("unknown encryption method");
          }
          this.dict = dict;
          var algorithm = dict.get("V");
          if (!Number.isInteger(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) {
            throw new _util.FormatError("unsupported encryption algorithm");
          }
          this.algorithm = algorithm;
          var keyLength = dict.get("Length");
          if (!keyLength) {
            if (algorithm <= 3) {
              keyLength = 40;
            } else {
              var cfDict = dict.get("CF");
              var streamCryptoName = dict.get("StmF");
              if ((0, _primitives.isDict)(cfDict) && (0, _primitives.isName)(streamCryptoName)) {
                cfDict.suppressEncryption = true;
                var handlerDict = cfDict.get(streamCryptoName.name);
                keyLength = handlerDict && handlerDict.get("Length") || 128;
                if (keyLength < 40) {
                  keyLength <<= 3;
                }
              }
            }
          }
          if (!Number.isInteger(keyLength) || keyLength < 40 || keyLength % 8 !== 0) {
            throw new _util.FormatError("invalid key length");
          }
          var ownerPassword = (0, _util.stringToBytes)(dict.get("O")).subarray(0, 32);
          var userPassword = (0, _util.stringToBytes)(dict.get("U")).subarray(0, 32);
          var flags = dict.get("P");
          var revision = dict.get("R");
          var encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get("EncryptMetadata") !== false;
          this.encryptMetadata = encryptMetadata;
          var fileIdBytes = (0, _util.stringToBytes)(fileId);
          var passwordBytes;
          if (password) {
            if (revision === 6) {
              try {
                password = (0, _util.utf8StringToString)(password);
              } catch (ex) {
                (0, _util.warn)("CipherTransformFactory: " + "Unable to convert UTF8 encoded password.");
              }
            }
            passwordBytes = (0, _util.stringToBytes)(password);
          }
          var encryptionKey;
          if (algorithm !== 5) {
            encryptionKey = prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
          } else {
            var ownerValidationSalt = (0, _util.stringToBytes)(dict.get("O")).subarray(32, 40);
            var ownerKeySalt = (0, _util.stringToBytes)(dict.get("O")).subarray(40, 48);
            var uBytes = (0, _util.stringToBytes)(dict.get("U")).subarray(0, 48);
            var userValidationSalt = (0, _util.stringToBytes)(dict.get("U")).subarray(32, 40);
            var userKeySalt = (0, _util.stringToBytes)(dict.get("U")).subarray(40, 48);
            var ownerEncryption = (0, _util.stringToBytes)(dict.get("OE"));
            var userEncryption = (0, _util.stringToBytes)(dict.get("UE"));
            var perms = (0, _util.stringToBytes)(dict.get("Perms"));
            encryptionKey = createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
          }
          if (!encryptionKey && !password) {
            throw new _util.PasswordException("No password given", _util.PasswordResponses.NEED_PASSWORD);
          } else if (!encryptionKey && password) {
            var decodedPassword = decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
            encryptionKey = prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
          }
          if (!encryptionKey) {
            throw new _util.PasswordException("Incorrect Password", _util.PasswordResponses.INCORRECT_PASSWORD);
          }
          this.encryptionKey = encryptionKey;
          if (algorithm >= 4) {
            var cf = dict.get("CF");
            if ((0, _primitives.isDict)(cf)) {
              cf.suppressEncryption = true;
            }
            this.cf = cf;
            this.stmf = dict.get("StmF") || identityName;
            this.strf = dict.get("StrF") || identityName;
            this.eff = dict.get("EFF") || this.stmf;
          }
        }
        function buildObjectKey(num, gen, encryptionKey, isAes) {
          var key = new Uint8Array(encryptionKey.length + 9),
            i,
            n;
          for (i = 0, n = encryptionKey.length; i < n; ++i) {
            key[i] = encryptionKey[i];
          }
          key[i++] = num & 0xFF;
          key[i++] = num >> 8 & 0xFF;
          key[i++] = num >> 16 & 0xFF;
          key[i++] = gen & 0xFF;
          key[i++] = gen >> 8 & 0xFF;
          if (isAes) {
            key[i++] = 0x73;
            key[i++] = 0x41;
            key[i++] = 0x6C;
            key[i++] = 0x54;
          }
          var hash = calculateMD5(key, 0, i);
          return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
        }
        function buildCipherConstructor(cf, name, num, gen, key) {
          if (!(0, _primitives.isName)(name)) {
            throw new _util.FormatError("Invalid crypt filter name.");
          }
          var cryptFilter = cf.get(name.name);
          var cfm;
          if (cryptFilter !== null && cryptFilter !== undefined) {
            cfm = cryptFilter.get("CFM");
          }
          if (!cfm || cfm.name === "None") {
            return function cipherTransformFactoryBuildCipherConstructorNone() {
              return new NullCipher();
            };
          }
          if (cfm.name === "V2") {
            return function cipherTransformFactoryBuildCipherConstructorV2() {
              return new ARCFourCipher(buildObjectKey(num, gen, key, false));
            };
          }
          if (cfm.name === "AESV2") {
            return function cipherTransformFactoryBuildCipherConstructorAESV2() {
              return new AES128Cipher(buildObjectKey(num, gen, key, true));
            };
          }
          if (cfm.name === "AESV3") {
            return function cipherTransformFactoryBuildCipherConstructorAESV3() {
              return new AES256Cipher(key);
            };
          }
          throw new _util.FormatError("Unknown crypto method");
        }
        CipherTransformFactory.prototype = {
          createCipherTransform: function CipherTransformFactory_createCipherTransform(num, gen) {
            if (this.algorithm === 4 || this.algorithm === 5) {
              return new CipherTransform(buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey), buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey));
            }
            var key = buildObjectKey(num, gen, this.encryptionKey, false);
            var cipherConstructor = function buildCipherCipherConstructor() {
              return new ARCFourCipher(key);
            };
            return new CipherTransform(cipherConstructor, cipherConstructor);
          }
        };
        return CipherTransformFactory;
      }();
      exports.AES128Cipher = AES128Cipher;
      exports.AES256Cipher = AES256Cipher;
      exports.ARCFourCipher = ARCFourCipher;
      exports.CipherTransformFactory = CipherTransformFactory;
      exports.PDF17 = PDF17;
      exports.PDF20 = PDF20;
      exports.calculateMD5 = calculateMD5;
      exports.calculateSHA256 = calculateSHA256;
      exports.calculateSHA384 = calculateSHA384;
      exports.calculateSHA512 = calculateSHA512;

      /***/ }),
    /* 77 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PartialEvaluator = exports.OperatorList = undefined;

      var _util = __w_pdfjs_require__(0);

      var _cmap = __w_pdfjs_require__(133);

      var _stream = __w_pdfjs_require__(5);

      var _primitives = __w_pdfjs_require__(2);

      var _fonts = __w_pdfjs_require__(134);

      var _encodings = __w_pdfjs_require__(27);

      var _unicode = __w_pdfjs_require__(80);

      var _standard_fonts = __w_pdfjs_require__(79);

      var _pattern = __w_pdfjs_require__(138);

      var _parser = __w_pdfjs_require__(34);

      var _bidi = __w_pdfjs_require__(139);

      var _colorspace = __w_pdfjs_require__(26);

      var _glyphlist = __w_pdfjs_require__(47);

      var _metrics = __w_pdfjs_require__(140);

      var _function = __w_pdfjs_require__(81);

      var _murmurhash = __w_pdfjs_require__(142);

      var _image = __w_pdfjs_require__(143);

      var PartialEvaluator = function PartialEvaluatorClosure() {
        var DefaultPartialEvaluatorOptions = {
          forceDataSchema: false,
          maxImageSize: -1,
          disableFontFace: false,
          nativeImageDecoderSupport: _util.NativeImageDecoding.DECODE,
          ignoreErrors: false,
          isEvalSupported: true
        };
        function NativeImageDecoder(_ref) {
          var xref = _ref.xref,
            resources = _ref.resources,
            handler = _ref.handler,
            _ref$forceDataSchema = _ref.forceDataSchema,
            forceDataSchema = _ref$forceDataSchema === undefined ? false : _ref$forceDataSchema,
            pdfFunctionFactory = _ref.pdfFunctionFactory;

          this.xref = xref;
          this.resources = resources;
          this.handler = handler;
          this.forceDataSchema = forceDataSchema;
          this.pdfFunctionFactory = pdfFunctionFactory;
        }
        NativeImageDecoder.prototype = {
          canDecode: function canDecode(image) {
            return image instanceof _stream.JpegStream && NativeImageDecoder.isDecodable(image, this.xref, this.resources, this.pdfFunctionFactory);
          },
          decode: function decode(image) {
            var dict = image.dict;
            var colorSpace = dict.get("ColorSpace", "CS");
            colorSpace = _colorspace.ColorSpace.parse(colorSpace, this.xref, this.resources, this.pdfFunctionFactory);
            var numComps = colorSpace.numComps;
            var decodePromise = this.handler.sendWithPromise("JpegDecode", [image.getIR(this.forceDataSchema), numComps]);
            return decodePromise.then(function (message) {
              var data = message.data;
              return new _stream.Stream(data, 0, data.length, image.dict);
            });
          }
        };
        NativeImageDecoder.isSupported = function (image, xref, res, pdfFunctionFactory) {
          var dict = image.dict;
          if (dict.has("DecodeParms") || dict.has("DP")) {
            return false;
          }
          var cs = _colorspace.ColorSpace.parse(dict.get("ColorSpace", "CS"), xref, res, pdfFunctionFactory);
          return (cs.name === "DeviceGray" || cs.name === "DeviceRGB") && cs.isDefaultDecode(dict.getArray("Decode", "D"));
        };
        NativeImageDecoder.isDecodable = function (image, xref, res, pdfFunctionFactory) {
          var dict = image.dict;
          if (dict.has("DecodeParms") || dict.has("DP")) {
            return false;
          }
          var cs = _colorspace.ColorSpace.parse(dict.get("ColorSpace", "CS"), xref, res, pdfFunctionFactory);
          return (cs.numComps === 1 || cs.numComps === 3) && cs.isDefaultDecode(dict.getArray("Decode", "D"));
        };
        function PartialEvaluator(_ref2) {
          var _this = this;

          var pdfManager = _ref2.pdfManager,
            xref = _ref2.xref,
            handler = _ref2.handler,
            pageIndex = _ref2.pageIndex,
            idFactory = _ref2.idFactory,
            fontCache = _ref2.fontCache,
            builtInCMapCache = _ref2.builtInCMapCache,
            _ref2$options = _ref2.options,
            options = _ref2$options === undefined ? null : _ref2$options,
            pdfFunctionFactory = _ref2.pdfFunctionFactory;

          this.pdfManager = pdfManager;
          this.xref = xref;
          this.handler = handler;
          this.pageIndex = pageIndex;
          this.idFactory = idFactory;
          this.fontCache = fontCache;
          this.builtInCMapCache = builtInCMapCache;
          this.options = options || DefaultPartialEvaluatorOptions;
          this.pdfFunctionFactory = pdfFunctionFactory;
          this.fetchBuiltInCMap = function (name) {
            var cachedCMap = _this.builtInCMapCache[name];
            if (cachedCMap) {
              return Promise.resolve(cachedCMap);
            }
            return _this.handler.sendWithPromise("FetchBuiltInCMap", { name: name }).then(function (data) {
              if (data.compressionType !== _util.CMapCompressionType.NONE) {
                _this.builtInCMapCache[name] = data;
              }
              return data;
            });
          };
        }
        var TIME_SLOT_DURATION_MS = 20;
        var CHECK_TIME_EVERY = 100;
        function TimeSlotManager() {
          this.reset();
        }
        TimeSlotManager.prototype = {
          check: function TimeSlotManager_check() {
            if (++this.checked < CHECK_TIME_EVERY) {
              return false;
            }
            this.checked = 0;
            return this.endTime <= Date.now();
          },
          reset: function TimeSlotManager_reset() {
            this.endTime = Date.now() + TIME_SLOT_DURATION_MS;
            this.checked = 0;
          }
        };
        function normalizeBlendMode(value) {
          if (!(0, _primitives.isName)(value)) {
            return "source-over";
          }
          switch (value.name) {
            case "Normal":
            case "Compatible":
              return "source-over";
            case "Multiply":
              return "multiply";
            case "Screen":
              return "screen";
            case "Overlay":
              return "overlay";
            case "Darken":
              return "darken";
            case "Lighten":
              return "lighten";
            case "ColorDodge":
              return "color-dodge";
            case "ColorBurn":
              return "color-burn";
            case "HardLight":
              return "hard-light";
            case "SoftLight":
              return "soft-light";
            case "Difference":
              return "difference";
            case "Exclusion":
              return "exclusion";
            case "Hue":
              return "hue";
            case "Saturation":
              return "saturation";
            case "Color":
              return "color";
            case "Luminosity":
              return "luminosity";
          }
          (0, _util.warn)("Unsupported blend mode: " + value.name);
          return "source-over";
        }
        var deferred = Promise.resolve();
        var TILING_PATTERN = 1,
          SHADING_PATTERN = 2;
        PartialEvaluator.prototype = {
          clone: function clone() {
            var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultPartialEvaluatorOptions;

            var newEvaluator = Object.create(this);
            newEvaluator.options = newOptions;
            return newEvaluator;
          },

          hasBlendModes: function PartialEvaluator_hasBlendModes(resources) {
            if (!(0, _primitives.isDict)(resources)) {
              return false;
            }
            var processed = Object.create(null);
            if (resources.objId) {
              processed[resources.objId] = true;
            }
            var nodes = [resources],
              xref = this.xref;
            while (nodes.length) {
              var key, i, ii;
              var node = nodes.shift();
              var graphicStates = node.get("ExtGState");
              if ((0, _primitives.isDict)(graphicStates)) {
                var graphicStatesKeys = graphicStates.getKeys();
                for (i = 0, ii = graphicStatesKeys.length; i < ii; i++) {
                  key = graphicStatesKeys[i];
                  var graphicState = graphicStates.get(key);
                  var bm = graphicState.get("BM");
                  if ((0, _primitives.isName)(bm) && bm.name !== "Normal") {
                    return true;
                  }
                }
              }
              var xObjects = node.get("XObject");
              if (!(0, _primitives.isDict)(xObjects)) {
                continue;
              }
              var xObjectsKeys = xObjects.getKeys();
              for (i = 0, ii = xObjectsKeys.length; i < ii; i++) {
                key = xObjectsKeys[i];
                var xObject = xObjects.getRaw(key);
                if ((0, _primitives.isRef)(xObject)) {
                  if (processed[xObject.toString()]) {
                    continue;
                  }
                  xObject = xref.fetch(xObject);
                }
                if (!(0, _primitives.isStream)(xObject)) {
                  continue;
                }
                if (xObject.dict.objId) {
                  if (processed[xObject.dict.objId]) {
                    continue;
                  }
                  processed[xObject.dict.objId] = true;
                }
                var xResources = xObject.dict.get("Resources");
                if ((0, _primitives.isDict)(xResources) && (!xResources.objId || !processed[xResources.objId])) {
                  nodes.push(xResources);
                  if (xResources.objId) {
                    processed[xResources.objId] = true;
                  }
                }
              }
            }
            return false;
          },
          buildFormXObject: function PartialEvaluator_buildFormXObject(resources, xobj, smask, operatorList, task, initialState) {
            var dict = xobj.dict;
            var matrix = dict.getArray("Matrix");
            var bbox = dict.getArray("BBox");
            var group = dict.get("Group");
            if (group) {
              var groupOptions = {
                matrix: matrix,
                bbox: bbox,
                smask: smask,
                isolated: false,
                knockout: false
              };
              var groupSubtype = group.get("S");
              var colorSpace = null;
              if ((0, _primitives.isName)(groupSubtype, "Transparency")) {
                groupOptions.isolated = group.get("I") || false;
                groupOptions.knockout = group.get("K") || false;
                if (group.has("CS")) {
                  colorSpace = _colorspace.ColorSpace.parse(group.get("CS"), this.xref, resources, this.pdfFunctionFactory);
                }
              }
              if (smask && smask.backdrop) {
                colorSpace = colorSpace || _colorspace.ColorSpace.singletons.rgb;
                smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
              }
              operatorList.addOp(_util.OPS.beginGroup, [groupOptions]);
            }
            operatorList.addOp(_util.OPS.paintFormXObjectBegin, [matrix, bbox]);
            return this.getOperatorList({
              stream: xobj,
              task: task,
              resources: dict.get("Resources") || resources,
              operatorList: operatorList,
              initialState: initialState
            }).then(function () {
              operatorList.addOp(_util.OPS.paintFormXObjectEnd, []);
              if (group) {
                operatorList.addOp(_util.OPS.endGroup, [groupOptions]);
              }
            });
          },
          buildPaintImageXObject: function PartialEvaluator_buildPaintImageXObject(resources, image, inline, operatorList, cacheKey, imageCache) {
            var _this2 = this;

            var dict = image.dict;
            var w = dict.get("Width", "W");
            var h = dict.get("Height", "H");
            if (!(w && (0, _util.isNum)(w)) || !(h && (0, _util.isNum)(h))) {
              (0, _util.warn)("Image dimensions are missing, or not numbers.");
              return;
            }
            var maxImageSize = this.options.maxImageSize;
            if (maxImageSize !== -1 && w * h > maxImageSize) {
              (0, _util.warn)("Image exceeded maximum allowed size and was removed.");
              return;
            }
            var imageMask = dict.get("ImageMask", "IM") || false;
            var imgData, args;
            if (imageMask) {
              var width = dict.get("Width", "W");
              var height = dict.get("Height", "H");
              var bitStrideLength = width + 7 >> 3;
              var imgArray = image.getBytes(bitStrideLength * height);
              var decode = dict.getArray("Decode", "D");
              imgData = _image.PDFImage.createMask({
                imgArray: imgArray,
                width: width,
                height: height,
                imageIsFromDecodeStream: image instanceof _stream.DecodeStream,
                inverseDecode: !!decode && decode[0] > 0
              });
              imgData.cached = true;
              args = [imgData];
              operatorList.addOp(_util.OPS.paintImageMaskXObject, args);
              if (cacheKey) {
                imageCache[cacheKey] = {
                  fn: _util.OPS.paintImageMaskXObject,
                  args: args
                };
              }
              return;
            }
            var softMask = dict.get("SMask", "SM") || false;
            var mask = dict.get("Mask") || false;
            var SMALL_IMAGE_DIMENSIONS = 200;
            if (inline && !softMask && !mask && !(image instanceof _stream.JpegStream) && w + h < SMALL_IMAGE_DIMENSIONS) {
              var imageObj = new _image.PDFImage({
                xref: this.xref,
                res: resources,
                image: image,
                pdfFunctionFactory: this.pdfFunctionFactory
              });
              imgData = imageObj.createImageData(true);
              operatorList.addOp(_util.OPS.paintInlineImageXObject, [imgData]);
              return;
            }
            var nativeImageDecoderSupport = this.options.nativeImageDecoderSupport;
            var objId = "img_" + this.idFactory.createObjId();
            operatorList.addDependency(objId);
            args = [objId, w, h];
            if (nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && !softMask && !mask && image instanceof _stream.JpegStream && NativeImageDecoder.isSupported(image, this.xref, resources, this.pdfFunctionFactory)) {
              operatorList.addOp(_util.OPS.paintJpegXObject, args);
              this.handler.send("obj", [objId, this.pageIndex, "JpegStream", image.getIR(this.options.forceDataSchema)]);
              if (cacheKey) {
                imageCache[cacheKey] = {
                  fn: _util.OPS.paintJpegXObject,
                  args: args
                };
              }
              return;
            }
            var nativeImageDecoder = null;
            if (nativeImageDecoderSupport === _util.NativeImageDecoding.DECODE && (image instanceof _stream.JpegStream || mask instanceof _stream.JpegStream || softMask instanceof _stream.JpegStream)) {
              nativeImageDecoder = new NativeImageDecoder({
                xref: this.xref,
                resources: resources,
                handler: this.handler,
                forceDataSchema: this.options.forceDataSchema,
                pdfFunctionFactory: this.pdfFunctionFactory
              });
            }
            _image.PDFImage.buildImage({
              handler: this.handler,
              xref: this.xref,
              res: resources,
              image: image,
              nativeDecoder: nativeImageDecoder,
              pdfFunctionFactory: this.pdfFunctionFactory
            }).then(function (imageObj) {
              var imgData = imageObj.createImageData(false);
              _this2.handler.send("obj", [objId, _this2.pageIndex, "Image", imgData], [imgData.data.buffer]);
            }).catch(function (reason) {
              (0, _util.warn)("Unable to decode image: " + reason);
              _this2.handler.send("obj", [objId, _this2.pageIndex, "Image", null]);
            });
            operatorList.addOp(_util.OPS.paintImageXObject, args);
            if (cacheKey) {
              imageCache[cacheKey] = {
                fn: _util.OPS.paintImageXObject,
                args: args
              };
            }
          },
          handleSMask: function PartialEvaluator_handleSmask(smask, resources, operatorList, task, stateManager) {
            var smaskContent = smask.get("G");
            var smaskOptions = {
              subtype: smask.get("S").name,
              backdrop: smask.get("BC")
            };
            var transferObj = smask.get("TR");
            if ((0, _function.isPDFFunction)(transferObj)) {
              var transferFn = this.pdfFunctionFactory.create(transferObj);
              var transferMap = new Uint8Array(256);
              var tmp = new Float32Array(1);
              for (var i = 0; i < 256; i++) {
                tmp[0] = i / 255;
                transferFn(tmp, 0, tmp, 0);
                transferMap[i] = tmp[0] * 255 | 0;
              }
              smaskOptions.transferMap = transferMap;
            }
            return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone());
          },
          handleTilingType: function handleTilingType(fn, args, resources, pattern, patternDict, operatorList, task) {
            var _this3 = this;

            var tilingOpList = new OperatorList();
            var resourcesArray = [patternDict.get("Resources"), resources];
            var patternResources = _primitives.Dict.merge(this.xref, resourcesArray);
            return this.getOperatorList({
              stream: pattern,
              task: task,
              resources: patternResources,
              operatorList: tilingOpList
            }).then(function () {
              return (0, _pattern.getTilingPatternIR)({
                fnArray: tilingOpList.fnArray,
                argsArray: tilingOpList.argsArray
              }, patternDict, args);
            }).then(function (tilingPatternIR) {
              operatorList.addDependencies(tilingOpList.dependencies);
              operatorList.addOp(fn, tilingPatternIR);
            }, function (reason) {
              if (_this3.options.ignoreErrors) {
                _this3.handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.unknown });
                (0, _util.warn)("handleTilingType - ignoring pattern: \"" + reason + "\".");
                return;
              }
              throw reason;
            });
          },

          handleSetFont: function PartialEvaluator_handleSetFont(resources, fontArgs, fontRef, operatorList, task, state) {
            var _this4 = this;

            var fontName;
            if (fontArgs) {
              fontArgs = fontArgs.slice();
              fontName = fontArgs[0].name;
            }
            return this.loadFont(fontName, fontRef, resources).then(function (translated) {
              if (!translated.font.isType3Font) {
                return translated;
              }
              return translated.loadType3Data(_this4, resources, operatorList, task).then(function () {
                return translated;
              }).catch(function (reason) {
                _this4.handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.font });
                return new TranslatedFont("g_font_error", new _fonts.ErrorFont("Type3 font load error: " + reason), translated.font);
              });
            }).then(function (translated) {
              state.font = translated.font;
              translated.send(_this4.handler);
              return translated.loadedName;
            });
          },
          handleText: function PartialEvaluator_handleText(chars, state) {
            var _this5 = this;

            var font = state.font;
            var glyphs = font.charsToGlyphs(chars);
            var isAddToPathSet = !!(state.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
            if (font.data && (isAddToPathSet || this.options.disableFontFace)) {
              var buildPath = function buildPath(fontChar) {
                if (!font.renderer.hasBuiltPath(fontChar)) {
                  var path = font.renderer.getPathJs(fontChar);
                  _this5.handler.send("commonobj", [font.loadedName + "_path_" + fontChar, "FontPath", path]);
                }
              };
              for (var i = 0, ii = glyphs.length; i < ii; i++) {
                var glyph = glyphs[i];
                buildPath(glyph.fontChar);
                var accent = glyph.accent;
                if (accent && accent.fontChar) {
                  buildPath(accent.fontChar);
                }
              }
            }
            return glyphs;
          },
          setGState: function PartialEvaluator_setGState(resources, gState, operatorList, task, stateManager) {
            var _this6 = this;

            var gStateObj = [];
            var gStateKeys = gState.getKeys();
            var promise = Promise.resolve();

            var _loop = function _loop() {
              var key = gStateKeys[i];
              var value = gState.get(key);
              switch (key) {
                case "Type":
                  break;
                case "LW":
                case "LC":
                case "LJ":
                case "ML":
                case "D":
                case "RI":
                case "FL":
                case "CA":
                case "ca":
                  gStateObj.push([key, value]);
                  break;
                case "Font":
                  promise = promise.then(function () {
                    return _this6.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function (loadedName) {
                      operatorList.addDependency(loadedName);
                      gStateObj.push([key, [loadedName, value[1]]]);
                    });
                  });
                  break;
                case "BM":
                  gStateObj.push([key, normalizeBlendMode(value)]);
                  break;
                case "SMask":
                  if ((0, _primitives.isName)(value, "None")) {
                    gStateObj.push([key, false]);
                    break;
                  }
                  if ((0, _primitives.isDict)(value)) {
                    promise = promise.then(function () {
                      return _this6.handleSMask(value, resources, operatorList, task, stateManager);
                    });
                    gStateObj.push([key, true]);
                  } else {
                    (0, _util.warn)("Unsupported SMask type");
                  }
                  break;
                case "OP":
                case "op":
                case "OPM":
                case "BG":
                case "BG2":
                case "UCR":
                case "UCR2":
                case "TR":
                case "TR2":
                case "HT":
                case "SM":
                case "SA":
                case "AIS":
                case "TK":
                  (0, _util.info)("graphic state operator " + key);
                  break;
                default:
                  (0, _util.info)("Unknown graphic state operator " + key);
                  break;
              }
            };

            for (var i = 0, ii = gStateKeys.length; i < ii; i++) {
              _loop();
            }
            return promise.then(function () {
              if (gStateObj.length > 0) {
                operatorList.addOp(_util.OPS.setGState, [gStateObj]);
              }
            });
          },
          loadFont: function PartialEvaluator_loadFont(fontName, font, resources) {
            var _this7 = this;

            function errorFont() {
              return Promise.resolve(new TranslatedFont("g_font_error", new _fonts.ErrorFont("Font " + fontName + " is not available"), font));
            }
            var fontRef,
              xref = this.xref;
            if (font) {
              if (!(0, _primitives.isRef)(font)) {
                throw new Error("The \"font\" object should be a reference.");
              }
              fontRef = font;
            } else {
              var fontRes = resources.get("Font");
              if (fontRes) {
                fontRef = fontRes.getRaw(fontName);
              } else {
                (0, _util.warn)("fontRes not available");
                return errorFont();
              }
            }
            if (!fontRef) {
              (0, _util.warn)("fontRef not available");
              return errorFont();
            }
            if (this.fontCache.has(fontRef)) {
              return this.fontCache.get(fontRef);
            }
            font = xref.fetchIfRef(fontRef);
            if (!(0, _primitives.isDict)(font)) {
              return errorFont();
            }
            if (font.translated) {
              return font.translated;
            }
            var fontCapability = (0, _util.createPromiseCapability)();
            var preEvaluatedFont = this.preEvaluateFont(font);
            var descriptor = preEvaluatedFont.descriptor;
            var fontRefIsRef = (0, _primitives.isRef)(fontRef),
              fontID;
            if (fontRefIsRef) {
              fontID = fontRef.toString();
            }
            if ((0, _primitives.isDict)(descriptor)) {
              if (!descriptor.fontAliases) {
                descriptor.fontAliases = Object.create(null);
              }
              var fontAliases = descriptor.fontAliases;
              var hash = preEvaluatedFont.hash;
              if (fontAliases[hash]) {
                var aliasFontRef = fontAliases[hash].aliasRef;
                if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
                  this.fontCache.putAlias(fontRef, aliasFontRef);
                  return this.fontCache.get(fontRef);
                }
              } else {
                fontAliases[hash] = { fontID: _fonts.Font.getFontID() };
              }
              if (fontRefIsRef) {
                fontAliases[hash].aliasRef = fontRef;
              }
              fontID = fontAliases[hash].fontID;
            }
            if (fontRefIsRef) {
              this.fontCache.put(fontRef, fontCapability.promise);
            } else {
              if (!fontID) {
                fontID = this.idFactory.createObjId();
              }
              this.fontCache.put("id_" + fontID, fontCapability.promise);
            }
            (0, _util.assert)(fontID, "The \"fontID\" must be defined.");
            font.loadedName = "g_" + this.pdfManager.docId + "_f" + fontID;
            font.translated = fontCapability.promise;
            var translatedPromise;
            try {
              translatedPromise = this.translateFont(preEvaluatedFont);
            } catch (e) {
              translatedPromise = Promise.reject(e);
            }
            translatedPromise.then(function (translatedFont) {
              if (translatedFont.fontType !== undefined) {
                var xrefFontStats = xref.stats.fontTypes;
                xrefFontStats[translatedFont.fontType] = true;
              }
              fontCapability.resolve(new TranslatedFont(font.loadedName, translatedFont, font));
            }).catch(function (reason) {
              _this7.handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.font });
              try {
                var descriptor = preEvaluatedFont.descriptor;
                var fontFile3 = descriptor && descriptor.get("FontFile3");
                var subtype = fontFile3 && fontFile3.get("Subtype");
                var fontType = (0, _fonts.getFontType)(preEvaluatedFont.type, subtype && subtype.name);
                var xrefFontStats = xref.stats.fontTypes;
                xrefFontStats[fontType] = true;
              } catch (ex) {}
              fontCapability.resolve(new TranslatedFont(font.loadedName, new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason), font));
            });
            return fontCapability.promise;
          },
          buildPath: function PartialEvaluator_buildPath(operatorList, fn, args) {
            var lastIndex = operatorList.length - 1;
            if (!args) {
              args = [];
            }
            if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util.OPS.constructPath) {
              operatorList.addOp(_util.OPS.constructPath, [[fn], args]);
            } else {
              var opArgs = operatorList.argsArray[lastIndex];
              opArgs[0].push(fn);
              Array.prototype.push.apply(opArgs[1], args);
            }
          },
          handleColorN: function PartialEvaluator_handleColorN(operatorList, fn, args, cs, patterns, resources, task) {
            var patternName = args[args.length - 1];
            var pattern;
            if ((0, _primitives.isName)(patternName) && (pattern = patterns.get(patternName.name))) {
              var dict = (0, _primitives.isStream)(pattern) ? pattern.dict : pattern;
              var typeNum = dict.get("PatternType");
              if (typeNum === TILING_PATTERN) {
                var color = cs.base ? cs.base.getRgb(args, 0) : null;
                return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task);
              } else if (typeNum === SHADING_PATTERN) {
                var shading = dict.get("Shading");
                var matrix = dict.getArray("Matrix");
                pattern = _pattern.Pattern.parseShading(shading, matrix, this.xref, resources, this.handler, this.pdfFunctionFactory);
                operatorList.addOp(fn, pattern.getIR());
                return Promise.resolve();
              }
              return Promise.reject(new Error("Unknown PatternType: " + typeNum));
            }
            operatorList.addOp(fn, args);
            return Promise.resolve();
          },
          getOperatorList: function getOperatorList(_ref3) {
            var _this8 = this;

            var stream = _ref3.stream,
              task = _ref3.task,
              resources = _ref3.resources,
              operatorList = _ref3.operatorList,
              _ref3$initialState = _ref3.initialState,
              initialState = _ref3$initialState === undefined ? null : _ref3$initialState;

            resources = resources || _primitives.Dict.empty;
            initialState = initialState || new EvalState();
            if (!operatorList) {
              throw new Error("getOperatorList: missing \"operatorList\" parameter");
            }
            var self = this;
            var xref = this.xref;
            var imageCache = Object.create(null);
            var xobjs = resources.get("XObject") || _primitives.Dict.empty;
            var patterns = resources.get("Pattern") || _primitives.Dict.empty;
            var stateManager = new StateManager(initialState);
            var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
            var timeSlotManager = new TimeSlotManager();
            function closePendingRestoreOPS(argument) {
              for (var i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++) {
                operatorList.addOp(_util.OPS.restore, []);
              }
            }
            return new Promise(function promiseBody(resolve, reject) {
              var next = function next(promise) {
                promise.then(function () {
                  try {
                    promiseBody(resolve, reject);
                  } catch (ex) {
                    reject(ex);
                  }
                }, reject);
              };
              task.ensureNotTerminated();
              timeSlotManager.reset();
              var stop,
                operation = {},
                i,
                ii,
                cs;
              while (!(stop = timeSlotManager.check())) {
                operation.args = null;
                if (!preprocessor.read(operation)) {
                  break;
                }
                var args = operation.args;
                var fn = operation.fn;
                switch (fn | 0) {
                  case _util.OPS.paintXObject:
                    var name = args[0].name;
                    if (name && imageCache[name] !== undefined) {
                      operatorList.addOp(imageCache[name].fn, imageCache[name].args);
                      args = null;
                      continue;
                    }
                    next(new Promise(function (resolveXObject, rejectXObject) {
                      if (!name) {
                        throw new _util.FormatError("XObject must be referred to by name.");
                      }
                      var xobj = xobjs.get(name);
                      if (!xobj) {
                        operatorList.addOp(fn, args);
                        resolveXObject();
                        return;
                      }
                      if (!(0, _primitives.isStream)(xobj)) {
                        throw new _util.FormatError("XObject should be a stream");
                      }
                      var type = xobj.dict.get("Subtype");
                      if (!(0, _primitives.isName)(type)) {
                        throw new _util.FormatError("XObject should have a Name subtype");
                      }
                      if (type.name === "Form") {
                        stateManager.save();
                        self.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone()).then(function () {
                          stateManager.restore();
                          resolveXObject();
                        }, rejectXObject);
                        return;
                      } else if (type.name === "Image") {
                        self.buildPaintImageXObject(resources, xobj, false, operatorList, name, imageCache);
                      } else if (type.name === "PS") {
                        (0, _util.info)("Ignored XObject subtype PS");
                      } else {
                        throw new _util.FormatError("Unhandled XObject subtype " + type.name);
                      }
                      resolveXObject();
                    }).catch(function (reason) {
                      if (self.options.ignoreErrors) {
                        self.handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.unknown });
                        (0, _util.warn)("getOperatorList - ignoring XObject: \"" + reason + "\".");
                        return;
                      }
                      throw reason;
                    }));
                    return;
                  case _util.OPS.setFont:
                    var fontSize = args[1];
                    next(self.handleSetFont(resources, args, null, operatorList, task, stateManager.state).then(function (loadedName) {
                      operatorList.addDependency(loadedName);
                      operatorList.addOp(_util.OPS.setFont, [loadedName, fontSize]);
                    }));
                    return;
                  case _util.OPS.endInlineImage:
                    var cacheKey = args[0].cacheKey;
                    if (cacheKey) {
                      var cacheEntry = imageCache[cacheKey];
                      if (cacheEntry !== undefined) {
                        operatorList.addOp(cacheEntry.fn, cacheEntry.args);
                        args = null;
                        continue;
                      }
                    }
                    self.buildPaintImageXObject(resources, args[0], true, operatorList, cacheKey, imageCache);
                    args = null;
                    continue;
                  case _util.OPS.showText:
                    args[0] = self.handleText(args[0], stateManager.state);
                    break;
                  case _util.OPS.showSpacedText:
                    var arr = args[0];
                    var combinedGlyphs = [];
                    var arrLength = arr.length;
                    var state = stateManager.state;
                    for (i = 0; i < arrLength; ++i) {
                      var arrItem = arr[i];
                      if ((0, _util.isString)(arrItem)) {
                        Array.prototype.push.apply(combinedGlyphs, self.handleText(arrItem, state));
                      } else if ((0, _util.isNum)(arrItem)) {
                        combinedGlyphs.push(arrItem);
                      }
                    }
                    args[0] = combinedGlyphs;
                    fn = _util.OPS.showText;
                    break;
                  case _util.OPS.nextLineShowText:
                    operatorList.addOp(_util.OPS.nextLine);
                    args[0] = self.handleText(args[0], stateManager.state);
                    fn = _util.OPS.showText;
                    break;
                  case _util.OPS.nextLineSetSpacingShowText:
                    operatorList.addOp(_util.OPS.nextLine);
                    operatorList.addOp(_util.OPS.setWordSpacing, [args.shift()]);
                    operatorList.addOp(_util.OPS.setCharSpacing, [args.shift()]);
                    args[0] = self.handleText(args[0], stateManager.state);
                    fn = _util.OPS.showText;
                    break;
                  case _util.OPS.setTextRenderingMode:
                    stateManager.state.textRenderingMode = args[0];
                    break;
                  case _util.OPS.setFillColorSpace:
                    stateManager.state.fillColorSpace = _colorspace.ColorSpace.parse(args[0], xref, resources, self.pdfFunctionFactory);
                    continue;
                  case _util.OPS.setStrokeColorSpace:
                    stateManager.state.strokeColorSpace = _colorspace.ColorSpace.parse(args[0], xref, resources, self.pdfFunctionFactory);
                    continue;
                  case _util.OPS.setFillColor:
                    cs = stateManager.state.fillColorSpace;
                    args = cs.getRgb(args, 0);
                    fn = _util.OPS.setFillRGBColor;
                    break;
                  case _util.OPS.setStrokeColor:
                    cs = stateManager.state.strokeColorSpace;
                    args = cs.getRgb(args, 0);
                    fn = _util.OPS.setStrokeRGBColor;
                    break;
                  case _util.OPS.setFillGray:
                    stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                    args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                    fn = _util.OPS.setFillRGBColor;
                    break;
                  case _util.OPS.setStrokeGray:
                    stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                    args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                    fn = _util.OPS.setStrokeRGBColor;
                    break;
                  case _util.OPS.setFillCMYKColor:
                    stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                    args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                    fn = _util.OPS.setFillRGBColor;
                    break;
                  case _util.OPS.setStrokeCMYKColor:
                    stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                    args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                    fn = _util.OPS.setStrokeRGBColor;
                    break;
                  case _util.OPS.setFillRGBColor:
                    stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
                    args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                    break;
                  case _util.OPS.setStrokeRGBColor:
                    stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
                    args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                    break;
                  case _util.OPS.setFillColorN:
                    cs = stateManager.state.fillColorSpace;
                    if (cs.name === "Pattern") {
                      next(self.handleColorN(operatorList, _util.OPS.setFillColorN, args, cs, patterns, resources, task));
                      return;
                    }
                    args = cs.getRgb(args, 0);
                    fn = _util.OPS.setFillRGBColor;
                    break;
                  case _util.OPS.setStrokeColorN:
                    cs = stateManager.state.strokeColorSpace;
                    if (cs.name === "Pattern") {
                      next(self.handleColorN(operatorList, _util.OPS.setStrokeColorN, args, cs, patterns, resources, task));
                      return;
                    }
                    args = cs.getRgb(args, 0);
                    fn = _util.OPS.setStrokeRGBColor;
                    break;
                  case _util.OPS.shadingFill:
                    var shadingRes = resources.get("Shading");
                    if (!shadingRes) {
                      throw new _util.FormatError("No shading resource found");
                    }
                    var shading = shadingRes.get(args[0].name);
                    if (!shading) {
                      throw new _util.FormatError("No shading object found");
                    }
                    var shadingFill = _pattern.Pattern.parseShading(shading, null, xref, resources, self.handler, self.pdfFunctionFactory);
                    var patternIR = shadingFill.getIR();
                    args = [patternIR];
                    fn = _util.OPS.shadingFill;
                    break;
                  case _util.OPS.setGState:
                    var dictName = args[0];
                    var extGState = resources.get("ExtGState");
                    if (!(0, _primitives.isDict)(extGState) || !extGState.has(dictName.name)) {
                      break;
                    }
                    var gState = extGState.get(dictName.name);
                    next(self.setGState(resources, gState, operatorList, task, stateManager));
                    return;
                  case _util.OPS.moveTo:
                  case _util.OPS.lineTo:
                  case _util.OPS.curveTo:
                  case _util.OPS.curveTo2:
                  case _util.OPS.curveTo3:
                  case _util.OPS.closePath:
                    self.buildPath(operatorList, fn, args);
                    continue;
                  case _util.OPS.rectangle:
                    self.buildPath(operatorList, fn, args);
                    continue;
                  case _util.OPS.markPoint:
                  case _util.OPS.markPointProps:
                  case _util.OPS.beginMarkedContent:
                  case _util.OPS.beginMarkedContentProps:
                  case _util.OPS.endMarkedContent:
                  case _util.OPS.beginCompat:
                  case _util.OPS.endCompat:
                    continue;
                  default:
                    if (args !== null) {
                      for (i = 0, ii = args.length; i < ii; i++) {
                        if (args[i] instanceof _primitives.Dict) {
                          break;
                        }
                      }
                      if (i < ii) {
                        (0, _util.warn)("getOperatorList - ignoring operator: " + fn);
                        continue;
                      }
                    }
                }
                operatorList.addOp(fn, args);
              }
              if (stop) {
                next(deferred);
                return;
              }
              closePendingRestoreOPS();
              resolve();
            }).catch(function (reason) {
              if (_this8.options.ignoreErrors) {
                _this8.handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.unknown });
                (0, _util.warn)("getOperatorList - ignoring errors during task: " + task.name);
                closePendingRestoreOPS();
                return;
              }
              throw reason;
            });
          },
          getTextContent: function getTextContent(_ref4) {
            var _this9 = this;

            var stream = _ref4.stream,
              task = _ref4.task,
              resources = _ref4.resources,
              _ref4$stateManager = _ref4.stateManager,
              stateManager = _ref4$stateManager === undefined ? null : _ref4$stateManager,
              _ref4$normalizeWhites = _ref4.normalizeWhitespace,
              normalizeWhitespace = _ref4$normalizeWhites === undefined ? false : _ref4$normalizeWhites,
              _ref4$combineTextItem = _ref4.combineTextItems,
              combineTextItems = _ref4$combineTextItem === undefined ? false : _ref4$combineTextItem,
              sink = _ref4.sink,
              _ref4$seenStyles = _ref4.seenStyles,
              seenStyles = _ref4$seenStyles === undefined ? Object.create(null) : _ref4$seenStyles;

            resources = resources || _primitives.Dict.empty;
            stateManager = stateManager || new StateManager(new TextState());
            var WhitespaceRegexp = /\s/g;
            var textContent = {
              items: [],
              styles: Object.create(null)
            };
            var textContentItem = {
              initialized: false,
              str: [],
              width: 0,
              height: 0,
              vertical: false,
              lastAdvanceWidth: 0,
              lastAdvanceHeight: 0,
              textAdvanceScale: 0,
              spaceWidth: 0,
              fakeSpaceMin: Infinity,
              fakeMultiSpaceMin: Infinity,
              fakeMultiSpaceMax: -0,
              textRunBreakAllowed: false,
              transform: null,
              fontName: null
            };
            var SPACE_FACTOR = 0.3;
            var MULTI_SPACE_FACTOR = 1.5;
            var MULTI_SPACE_FACTOR_MAX = 4;
            var self = this;
            var xref = this.xref;
            var xobjs = null;
            var skipEmptyXObjs = Object.create(null);
            var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
            var textState;
            function ensureTextContentItem() {
              if (textContentItem.initialized) {
                return textContentItem;
              }
              var font = textState.font;
              if (!(font.loadedName in seenStyles)) {
                seenStyles[font.loadedName] = true;
                textContent.styles[font.loadedName] = {
                  fontFamily: font.fallbackName,
                  ascent: font.ascent,
                  descent: font.descent,
                  vertical: font.vertical
                };
              }
              textContentItem.fontName = font.loadedName;
              var tsm = [textState.fontSize * textState.textHScale, 0, 0, textState.fontSize, 0, textState.textRise];
              if (font.isType3Font && textState.fontMatrix !== _util.FONT_IDENTITY_MATRIX && textState.fontSize === 1) {
                var glyphHeight = font.bbox[3] - font.bbox[1];
                if (glyphHeight > 0) {
                  glyphHeight = glyphHeight * textState.fontMatrix[3];
                  tsm[3] *= glyphHeight;
                }
              }
              var trm = _util.Util.transform(textState.ctm, _util.Util.transform(textState.textMatrix, tsm));
              textContentItem.transform = trm;
              if (!font.vertical) {
                textContentItem.width = 0;
                textContentItem.height = Math.sqrt(trm[2] * trm[2] + trm[3] * trm[3]);
                textContentItem.vertical = false;
              } else {
                textContentItem.width = Math.sqrt(trm[0] * trm[0] + trm[1] * trm[1]);
                textContentItem.height = 0;
                textContentItem.vertical = true;
              }
              var a = textState.textLineMatrix[0];
              var b = textState.textLineMatrix[1];
              var scaleLineX = Math.sqrt(a * a + b * b);
              a = textState.ctm[0];
              b = textState.ctm[1];
              var scaleCtmX = Math.sqrt(a * a + b * b);
              textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
              textContentItem.lastAdvanceWidth = 0;
              textContentItem.lastAdvanceHeight = 0;
              var spaceWidth = font.spaceWidth / 1000 * textState.fontSize;
              if (spaceWidth) {
                textContentItem.spaceWidth = spaceWidth;
                textContentItem.fakeSpaceMin = spaceWidth * SPACE_FACTOR;
                textContentItem.fakeMultiSpaceMin = spaceWidth * MULTI_SPACE_FACTOR;
                textContentItem.fakeMultiSpaceMax = spaceWidth * MULTI_SPACE_FACTOR_MAX;
                textContentItem.textRunBreakAllowed = !font.isMonospace;
              } else {
                textContentItem.spaceWidth = 0;
                textContentItem.fakeSpaceMin = Infinity;
                textContentItem.fakeMultiSpaceMin = Infinity;
                textContentItem.fakeMultiSpaceMax = 0;
                textContentItem.textRunBreakAllowed = false;
              }
              textContentItem.initialized = true;
              return textContentItem;
            }
            function replaceWhitespace(str) {
              var i = 0,
                ii = str.length,
                code;
              while (i < ii && (code = str.charCodeAt(i)) >= 0x20 && code <= 0x7F) {
                i++;
              }
              return i < ii ? str.replace(WhitespaceRegexp, " ") : str;
            }
            function runBidiTransform(textChunk) {
              var str = textChunk.str.join("");
              var bidiResult = (0, _bidi.bidi)(str, -1, textChunk.vertical);
              return {
                str: normalizeWhitespace ? replaceWhitespace(bidiResult.str) : bidiResult.str,
                dir: bidiResult.dir,
                width: textChunk.width,
                height: textChunk.height,
                transform: textChunk.transform,
                fontName: textChunk.fontName
              };
            }
            function handleSetFont(fontName, fontRef) {
              return self.loadFont(fontName, fontRef, resources).then(function (translated) {
                textState.font = translated.font;
                textState.fontMatrix = translated.font.fontMatrix || _util.FONT_IDENTITY_MATRIX;
              });
            }
            function buildTextContentItem(chars) {
              var font = textState.font;
              var textChunk = ensureTextContentItem();
              var width = 0;
              var height = 0;
              var glyphs = font.charsToGlyphs(chars);
              for (var i = 0; i < glyphs.length; i++) {
                var glyph = glyphs[i];
                var glyphWidth = null;
                if (font.vertical && glyph.vmetric) {
                  glyphWidth = glyph.vmetric[0];
                } else {
                  glyphWidth = glyph.width;
                }
                var glyphUnicode = glyph.unicode;
                var NormalizedUnicodes = (0, _unicode.getNormalizedUnicodes)();
                if (NormalizedUnicodes[glyphUnicode] !== undefined) {
                  glyphUnicode = NormalizedUnicodes[glyphUnicode];
                }
                glyphUnicode = (0, _unicode.reverseIfRtl)(glyphUnicode);
                var charSpacing = textState.charSpacing;
                if (glyph.isSpace) {
                  var wordSpacing = textState.wordSpacing;
                  charSpacing += wordSpacing;
                  if (wordSpacing > 0) {
                    addFakeSpaces(wordSpacing, textChunk.str);
                  }
                }
                var tx = 0;
                var ty = 0;
                if (!font.vertical) {
                  var w0 = glyphWidth * textState.fontMatrix[0];
                  tx = (w0 * textState.fontSize + charSpacing) * textState.textHScale;
                  width += tx;
                } else {
                  var w1 = glyphWidth * textState.fontMatrix[0];
                  ty = w1 * textState.fontSize + charSpacing;
                  height += ty;
                }
                textState.translateTextMatrix(tx, ty);
                textChunk.str.push(glyphUnicode);
              }
              if (!font.vertical) {
                textChunk.lastAdvanceWidth = width;
                textChunk.width += width;
              } else {
                textChunk.lastAdvanceHeight = height;
                textChunk.height += Math.abs(height);
              }
              return textChunk;
            }
            function addFakeSpaces(width, strBuf) {
              if (width < textContentItem.fakeSpaceMin) {
                return;
              }
              if (width < textContentItem.fakeMultiSpaceMin) {
                strBuf.push(" ");
                return;
              }
              var fakeSpaces = Math.round(width / textContentItem.spaceWidth);
              while (fakeSpaces-- > 0) {
                strBuf.push(" ");
              }
            }
            function flushTextContentItem() {
              if (!textContentItem.initialized) {
                return;
              }
              textContentItem.width *= textContentItem.textAdvanceScale;
              textContentItem.height *= textContentItem.textAdvanceScale;
              textContent.items.push(runBidiTransform(textContentItem));
              textContentItem.initialized = false;
              textContentItem.str.length = 0;
            }
            function enqueueChunk() {
              var length = textContent.items.length;
              if (length > 0) {
                sink.enqueue(textContent, length);
                textContent.items = [];
                textContent.styles = Object.create(null);
              }
            }
            var timeSlotManager = new TimeSlotManager();
            return new Promise(function promiseBody(resolve, reject) {
              var next = function next(promise) {
                enqueueChunk();
                Promise.all([promise, sink.ready]).then(function () {
                  try {
                    promiseBody(resolve, reject);
                  } catch (ex) {
                    reject(ex);
                  }
                }, reject);
              };
              task.ensureNotTerminated();
              timeSlotManager.reset();
              var stop,
                operation = {},
                args = [];
              while (!(stop = timeSlotManager.check())) {
                args.length = 0;
                operation.args = args;
                if (!preprocessor.read(operation)) {
                  break;
                }
                textState = stateManager.state;
                var fn = operation.fn;
                args = operation.args;
                var advance, diff;
                switch (fn | 0) {
                  case _util.OPS.setFont:
                    var fontNameArg = args[0].name,
                      fontSizeArg = args[1];
                    if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) {
                      break;
                    }
                    flushTextContentItem();
                    textState.fontName = fontNameArg;
                    textState.fontSize = fontSizeArg;
                    next(handleSetFont(fontNameArg, null));
                    return;
                  case _util.OPS.setTextRise:
                    flushTextContentItem();
                    textState.textRise = args[0];
                    break;
                  case _util.OPS.setHScale:
                    flushTextContentItem();
                    textState.textHScale = args[0] / 100;
                    break;
                  case _util.OPS.setLeading:
                    flushTextContentItem();
                    textState.leading = args[0];
                    break;
                  case _util.OPS.moveText:
                    var isSameTextLine = !textState.font ? false : (textState.font.vertical ? args[0] : args[1]) === 0;
                    advance = args[0] - args[1];
                    if (combineTextItems && isSameTextLine && textContentItem.initialized && advance > 0 && advance <= textContentItem.fakeMultiSpaceMax) {
                      textState.translateTextLineMatrix(args[0], args[1]);
                      textContentItem.width += args[0] - textContentItem.lastAdvanceWidth;
                      textContentItem.height += args[1] - textContentItem.lastAdvanceHeight;
                      diff = args[0] - textContentItem.lastAdvanceWidth - (args[1] - textContentItem.lastAdvanceHeight);
                      addFakeSpaces(diff, textContentItem.str);
                      break;
                    }
                    flushTextContentItem();
                    textState.translateTextLineMatrix(args[0], args[1]);
                    textState.textMatrix = textState.textLineMatrix.slice();
                    break;
                  case _util.OPS.setLeadingMoveText:
                    flushTextContentItem();
                    textState.leading = -args[1];
                    textState.translateTextLineMatrix(args[0], args[1]);
                    textState.textMatrix = textState.textLineMatrix.slice();
                    break;
                  case _util.OPS.nextLine:
                    flushTextContentItem();
                    textState.carriageReturn();
                    break;
                  case _util.OPS.setTextMatrix:
                    advance = textState.calcTextLineMatrixAdvance(args[0], args[1], args[2], args[3], args[4], args[5]);
                    if (combineTextItems && advance !== null && textContentItem.initialized && advance.value > 0 && advance.value <= textContentItem.fakeMultiSpaceMax) {
                      textState.translateTextLineMatrix(advance.width, advance.height);
                      textContentItem.width += advance.width - textContentItem.lastAdvanceWidth;
                      textContentItem.height += advance.height - textContentItem.lastAdvanceHeight;
                      diff = advance.width - textContentItem.lastAdvanceWidth - (advance.height - textContentItem.lastAdvanceHeight);
                      addFakeSpaces(diff, textContentItem.str);
                      break;
                    }
                    flushTextContentItem();
                    textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                    textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                    break;
                  case _util.OPS.setCharSpacing:
                    textState.charSpacing = args[0];
                    break;
                  case _util.OPS.setWordSpacing:
                    textState.wordSpacing = args[0];
                    break;
                  case _util.OPS.beginText:
                    flushTextContentItem();
                    textState.textMatrix = _util.IDENTITY_MATRIX.slice();
                    textState.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                    break;
                  case _util.OPS.showSpacedText:
                    var items = args[0];
                    var offset;
                    for (var j = 0, jj = items.length; j < jj; j++) {
                      if (typeof items[j] === "string") {
                        buildTextContentItem(items[j]);
                      } else if ((0, _util.isNum)(items[j])) {
                        ensureTextContentItem();
                        advance = items[j] * textState.fontSize / 1000;
                        var breakTextRun = false;
                        if (textState.font.vertical) {
                          offset = advance;
                          textState.translateTextMatrix(0, offset);
                          breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
                          if (!breakTextRun) {
                            textContentItem.height += offset;
                          }
                        } else {
                          advance = -advance;
                          offset = advance * textState.textHScale;
                          textState.translateTextMatrix(offset, 0);
                          breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
                          if (!breakTextRun) {
                            textContentItem.width += offset;
                          }
                        }
                        if (breakTextRun) {
                          flushTextContentItem();
                        } else if (advance > 0) {
                          addFakeSpaces(advance, textContentItem.str);
                        }
                      }
                    }
                    break;
                  case _util.OPS.showText:
                    buildTextContentItem(args[0]);
                    break;
                  case _util.OPS.nextLineShowText:
                    flushTextContentItem();
                    textState.carriageReturn();
                    buildTextContentItem(args[0]);
                    break;
                  case _util.OPS.nextLineSetSpacingShowText:
                    flushTextContentItem();
                    textState.wordSpacing = args[0];
                    textState.charSpacing = args[1];
                    textState.carriageReturn();
                    buildTextContentItem(args[2]);
                    break;
                  case _util.OPS.paintXObject:
                    flushTextContentItem();
                    if (!xobjs) {
                      xobjs = resources.get("XObject") || _primitives.Dict.empty;
                    }
                    var name = args[0].name;
                    if (name && skipEmptyXObjs[name] !== undefined) {
                      break;
                    }
                    next(new Promise(function (resolveXObject, rejectXObject) {
                      if (!name) {
                        throw new _util.FormatError("XObject must be referred to by name.");
                      }
                      var xobj = xobjs.get(name);
                      if (!xobj) {
                        resolveXObject();
                        return;
                      }
                      if (!(0, _primitives.isStream)(xobj)) {
                        throw new _util.FormatError("XObject should be a stream");
                      }
                      var type = xobj.dict.get("Subtype");
                      if (!(0, _primitives.isName)(type)) {
                        throw new _util.FormatError("XObject should have a Name subtype");
                      }
                      if (type.name !== "Form") {
                        skipEmptyXObjs[name] = true;
                        resolveXObject();
                        return;
                      }
                      var currentState = stateManager.state.clone();
                      var xObjStateManager = new StateManager(currentState);
                      var matrix = xobj.dict.getArray("Matrix");
                      if (Array.isArray(matrix) && matrix.length === 6) {
                        xObjStateManager.transform(matrix);
                      }
                      enqueueChunk();
                      var sinkWrapper = {
                        enqueueInvoked: false,
                        enqueue: function enqueue(chunk, size) {
                          this.enqueueInvoked = true;
                          sink.enqueue(chunk, size);
                        },

                        get desiredSize() {
                          return sink.desiredSize;
                        },
                        get ready() {
                          return sink.ready;
                        }
                      };
                      self.getTextContent({
                        stream: xobj,
                        task: task,
                        resources: xobj.dict.get("Resources") || resources,
                        stateManager: xObjStateManager,
                        normalizeWhitespace: normalizeWhitespace,
                        combineTextItems: combineTextItems,
                        sink: sinkWrapper,
                        seenStyles: seenStyles
                      }).then(function () {
                        if (!sinkWrapper.enqueueInvoked) {
                          skipEmptyXObjs[name] = true;
                        }
                        resolveXObject();
                      }, rejectXObject);
                    }).catch(function (reason) {
                      if (reason instanceof _util.AbortException) {
                        return;
                      }
                      if (self.options.ignoreErrors) {
                        (0, _util.warn)("getTextContent - ignoring XObject: \"" + reason + "\".");
                        return;
                      }
                      throw reason;
                    }));
                    return;
                  case _util.OPS.setGState:
                    flushTextContentItem();
                    var dictName = args[0];
                    var extGState = resources.get("ExtGState");
                    if (!(0, _primitives.isDict)(extGState) || !(0, _primitives.isName)(dictName)) {
                      break;
                    }
                    var gState = extGState.get(dictName.name);
                    if (!(0, _primitives.isDict)(gState)) {
                      break;
                    }
                    var gStateFont = gState.get("Font");
                    if (gStateFont) {
                      textState.fontName = null;
                      textState.fontSize = gStateFont[1];
                      next(handleSetFont(null, gStateFont[0]));
                      return;
                    }
                    break;
                }
                if (textContent.items.length >= sink.desiredSize) {
                  stop = true;
                  break;
                }
              }
              if (stop) {
                next(deferred);
                return;
              }
              flushTextContentItem();
              enqueueChunk();
              resolve();
            }).catch(function (reason) {
              if (reason instanceof _util.AbortException) {
                return;
              }
              if (_this9.options.ignoreErrors) {
                (0, _util.warn)("getTextContent - ignoring errors during task: " + task.name);
                flushTextContentItem();
                enqueueChunk();
                return;
              }
              throw reason;
            });
          },

          extractDataStructures: function PartialEvaluator_extractDataStructures(dict, baseDict, properties) {
            var _this10 = this;

            var xref = this.xref;
            var toUnicode = dict.get("ToUnicode") || baseDict.get("ToUnicode");
            var toUnicodePromise = toUnicode ? this.readToUnicode(toUnicode) : Promise.resolve(undefined);
            if (properties.composite) {
              var cidSystemInfo = dict.get("CIDSystemInfo");
              if ((0, _primitives.isDict)(cidSystemInfo)) {
                properties.cidSystemInfo = {
                  registry: cidSystemInfo.get("Registry"),
                  ordering: cidSystemInfo.get("Ordering"),
                  supplement: cidSystemInfo.get("Supplement")
                };
              }
              var cidToGidMap = dict.get("CIDToGIDMap");
              if ((0, _primitives.isStream)(cidToGidMap)) {
                properties.cidToGidMap = this.readCidToGidMap(cidToGidMap);
              }
            }
            var differences = [];
            var baseEncodingName = null;
            var encoding;
            if (dict.has("Encoding")) {
              encoding = dict.get("Encoding");
              if ((0, _primitives.isDict)(encoding)) {
                baseEncodingName = encoding.get("BaseEncoding");
                baseEncodingName = (0, _primitives.isName)(baseEncodingName) ? baseEncodingName.name : null;
                if (encoding.has("Differences")) {
                  var diffEncoding = encoding.get("Differences");
                  var index = 0;
                  for (var j = 0, jj = diffEncoding.length; j < jj; j++) {
                    var data = xref.fetchIfRef(diffEncoding[j]);
                    if ((0, _util.isNum)(data)) {
                      index = data;
                    } else if ((0, _primitives.isName)(data)) {
                      differences[index++] = data.name;
                    } else {
                      throw new _util.FormatError("Invalid entry in 'Differences' array: " + data);
                    }
                  }
                }
              } else if ((0, _primitives.isName)(encoding)) {
                baseEncodingName = encoding.name;
              } else {
                throw new _util.FormatError("Encoding is not a Name nor a Dict");
              }
              if (baseEncodingName !== "MacRomanEncoding" && baseEncodingName !== "MacExpertEncoding" && baseEncodingName !== "WinAnsiEncoding") {
                baseEncodingName = null;
              }
            }
            if (baseEncodingName) {
              properties.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName).slice();
            } else {
              var isSymbolicFont = !!(properties.flags & _fonts.FontFlags.Symbolic);
              var isNonsymbolicFont = !!(properties.flags & _fonts.FontFlags.Nonsymbolic);
              encoding = _encodings.StandardEncoding;
              if (properties.type === "TrueType" && !isNonsymbolicFont) {
                encoding = _encodings.WinAnsiEncoding;
              }
              if (isSymbolicFont) {
                encoding = _encodings.MacRomanEncoding;
                if (!properties.file) {
                  if (/Symbol/i.test(properties.name)) {
                    encoding = _encodings.SymbolSetEncoding;
                  } else if (/Dingbats/i.test(properties.name)) {
                    encoding = _encodings.ZapfDingbatsEncoding;
                  }
                }
              }
              properties.defaultEncoding = encoding;
            }
            properties.differences = differences;
            properties.baseEncodingName = baseEncodingName;
            properties.hasEncoding = !!baseEncodingName || differences.length > 0;
            properties.dict = dict;
            return toUnicodePromise.then(function (toUnicode) {
              properties.toUnicode = toUnicode;
              return _this10.buildToUnicode(properties);
            }).then(function (toUnicode) {
              properties.toUnicode = toUnicode;
              return properties;
            });
          },
          buildToUnicode: function PartialEvaluator_buildToUnicode(properties) {
            properties.hasIncludedToUnicodeMap = !!properties.toUnicode && properties.toUnicode.length > 0;
            if (properties.hasIncludedToUnicodeMap) {
              return Promise.resolve(properties.toUnicode);
            }
            var toUnicode, charcode, glyphName;
            if (!properties.composite) {
              toUnicode = [];
              var encoding = properties.defaultEncoding.slice();
              var baseEncodingName = properties.baseEncodingName;
              var differences = properties.differences;
              for (charcode in differences) {
                glyphName = differences[charcode];
                if (glyphName === ".notdef") {
                  continue;
                }
                encoding[charcode] = glyphName;
              }
              var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
              for (charcode in encoding) {
                glyphName = encoding[charcode];
                if (glyphName === "") {
                  continue;
                } else if (glyphsUnicodeMap[glyphName] === undefined) {
                  var code = 0;
                  switch (glyphName[0]) {
                    case "G":
                      if (glyphName.length === 3) {
                        code = parseInt(glyphName.substr(1), 16);
                      }
                      break;
                    case "g":
                      if (glyphName.length === 5) {
                        code = parseInt(glyphName.substr(1), 16);
                      }
                      break;
                    case "C":
                    case "c":
                      if (glyphName.length >= 3) {
                        code = +glyphName.substr(1);
                      }
                      break;
                    default:
                      var unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                      if (unicode !== -1) {
                        code = unicode;
                      }
                  }
                  if (code) {
                    if (baseEncodingName && code === +charcode) {
                      var baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                      if (baseEncoding && (glyphName = baseEncoding[charcode])) {
                        toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                        continue;
                      }
                    }
                    toUnicode[charcode] = String.fromCharCode(code);
                  }
                  continue;
                }
                toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
              }
              return Promise.resolve(new _fonts.ToUnicodeMap(toUnicode));
            }
            if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof _cmap.IdentityCMap) || properties.cidSystemInfo.registry === "Adobe" && (properties.cidSystemInfo.ordering === "GB1" || properties.cidSystemInfo.ordering === "CNS1" || properties.cidSystemInfo.ordering === "Japan1" || properties.cidSystemInfo.ordering === "Korea1"))) {
              var registry = properties.cidSystemInfo.registry;
              var ordering = properties.cidSystemInfo.ordering;
              var ucs2CMapName = _primitives.Name.get(registry + "-" + ordering + "-UCS2");
              return _cmap.CMapFactory.create({
                encoding: ucs2CMapName,
                fetchBuiltInCMap: this.fetchBuiltInCMap,
                useCMap: null
              }).then(function (ucs2CMap) {
                var cMap = properties.cMap;
                toUnicode = [];
                cMap.forEach(function (charcode, cid) {
                  if (cid > 0xffff) {
                    throw new _util.FormatError("Max size of CID is 65,535");
                  }
                  var ucs2 = ucs2CMap.lookup(cid);
                  if (ucs2) {
                    toUnicode[charcode] = String.fromCharCode((ucs2.charCodeAt(0) << 8) + ucs2.charCodeAt(1));
                  }
                });
                return new _fonts.ToUnicodeMap(toUnicode);
              });
            }
            return Promise.resolve(new _fonts.IdentityToUnicodeMap(properties.firstChar, properties.lastChar));
          },
          readToUnicode: function PartialEvaluator_readToUnicode(toUnicode) {
            var cmapObj = toUnicode;
            if ((0, _primitives.isName)(cmapObj)) {
              return _cmap.CMapFactory.create({
                encoding: cmapObj,
                fetchBuiltInCMap: this.fetchBuiltInCMap,
                useCMap: null
              }).then(function (cmap) {
                if (cmap instanceof _cmap.IdentityCMap) {
                  return new _fonts.IdentityToUnicodeMap(0, 0xFFFF);
                }
                return new _fonts.ToUnicodeMap(cmap.getMap());
              });
            } else if ((0, _primitives.isStream)(cmapObj)) {
              return _cmap.CMapFactory.create({
                encoding: cmapObj,
                fetchBuiltInCMap: this.fetchBuiltInCMap,
                useCMap: null
              }).then(function (cmap) {
                if (cmap instanceof _cmap.IdentityCMap) {
                  return new _fonts.IdentityToUnicodeMap(0, 0xFFFF);
                }
                var map = new Array(cmap.length);
                cmap.forEach(function (charCode, token) {
                  var str = [];
                  for (var k = 0; k < token.length; k += 2) {
                    var w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                    if ((w1 & 0xF800) !== 0xD800) {
                      str.push(w1);
                      continue;
                    }
                    k += 2;
                    var w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                    str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
                  }
                  map[charCode] = String.fromCharCode.apply(String, str);
                });
                return new _fonts.ToUnicodeMap(map);
              });
            }
            return Promise.resolve(null);
          },
          readCidToGidMap: function PartialEvaluator_readCidToGidMap(cidToGidStream) {
            var glyphsData = cidToGidStream.getBytes();
            var result = [];
            for (var j = 0, jj = glyphsData.length; j < jj; j++) {
              var glyphID = glyphsData[j++] << 8 | glyphsData[j];
              if (glyphID === 0) {
                continue;
              }
              var code = j >> 1;
              result[code] = glyphID;
            }
            return result;
          },
          extractWidths: function PartialEvaluator_extractWidths(dict, descriptor, properties) {
            var xref = this.xref;
            var glyphsWidths = [];
            var defaultWidth = 0;
            var glyphsVMetrics = [];
            var defaultVMetrics;
            var i, ii, j, jj, start, code, widths;
            if (properties.composite) {
              defaultWidth = dict.has("DW") ? dict.get("DW") : 1000;
              widths = dict.get("W");
              if (widths) {
                for (i = 0, ii = widths.length; i < ii; i++) {
                  start = xref.fetchIfRef(widths[i++]);
                  code = xref.fetchIfRef(widths[i]);
                  if (Array.isArray(code)) {
                    for (j = 0, jj = code.length; j < jj; j++) {
                      glyphsWidths[start++] = xref.fetchIfRef(code[j]);
                    }
                  } else {
                    var width = xref.fetchIfRef(widths[++i]);
                    for (j = start; j <= code; j++) {
                      glyphsWidths[j] = width;
                    }
                  }
                }
              }
              if (properties.vertical) {
                var vmetrics = dict.getArray("DW2") || [880, -1000];
                defaultVMetrics = [vmetrics[1], defaultWidth * 0.5, vmetrics[0]];
                vmetrics = dict.get("W2");
                if (vmetrics) {
                  for (i = 0, ii = vmetrics.length; i < ii; i++) {
                    start = xref.fetchIfRef(vmetrics[i++]);
                    code = xref.fetchIfRef(vmetrics[i]);
                    if (Array.isArray(code)) {
                      for (j = 0, jj = code.length; j < jj; j++) {
                        glyphsVMetrics[start++] = [xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j])];
                      }
                    } else {
                      var vmetric = [xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i])];
                      for (j = start; j <= code; j++) {
                        glyphsVMetrics[j] = vmetric;
                      }
                    }
                  }
                }
              }
            } else {
              var firstChar = properties.firstChar;
              widths = dict.get("Widths");
              if (widths) {
                j = firstChar;
                for (i = 0, ii = widths.length; i < ii; i++) {
                  glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
                }
                defaultWidth = parseFloat(descriptor.get("MissingWidth")) || 0;
              } else {
                var baseFontName = dict.get("BaseFont");
                if ((0, _primitives.isName)(baseFontName)) {
                  var metrics = this.getBaseFontMetrics(baseFontName.name);
                  glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
                  defaultWidth = metrics.defaultWidth;
                }
              }
            }
            var isMonospace = true;
            var firstWidth = defaultWidth;
            for (var glyph in glyphsWidths) {
              var glyphWidth = glyphsWidths[glyph];
              if (!glyphWidth) {
                continue;
              }
              if (!firstWidth) {
                firstWidth = glyphWidth;
                continue;
              }
              if (firstWidth !== glyphWidth) {
                isMonospace = false;
                break;
              }
            }
            if (isMonospace) {
              properties.flags |= _fonts.FontFlags.FixedPitch;
            }
            properties.defaultWidth = defaultWidth;
            properties.widths = glyphsWidths;
            properties.defaultVMetrics = defaultVMetrics;
            properties.vmetrics = glyphsVMetrics;
          },
          isSerifFont: function PartialEvaluator_isSerifFont(baseFontName) {
            var fontNameWoStyle = baseFontName.split("-")[0];
            return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || fontNameWoStyle.search(/serif/gi) !== -1;
          },
          getBaseFontMetrics: function PartialEvaluator_getBaseFontMetrics(name) {
            var defaultWidth = 0;
            var widths = [];
            var monospace = false;
            var stdFontMap = (0, _standard_fonts.getStdFontMap)();
            var lookupName = stdFontMap[name] || name;
            var Metrics = (0, _metrics.getMetrics)();
            if (!(lookupName in Metrics)) {
              if (this.isSerifFont(name)) {
                lookupName = "Times-Roman";
              } else {
                lookupName = "Helvetica";
              }
            }
            var glyphWidths = Metrics[lookupName];
            if ((0, _util.isNum)(glyphWidths)) {
              defaultWidth = glyphWidths;
              monospace = true;
            } else {
              widths = glyphWidths();
            }
            return {
              defaultWidth: defaultWidth,
              monospace: monospace,
              widths: widths
            };
          },
          buildCharCodeToWidth: function PartialEvaluator_bulildCharCodeToWidth(widthsByGlyphName, properties) {
            var widths = Object.create(null);
            var differences = properties.differences;
            var encoding = properties.defaultEncoding;
            for (var charCode = 0; charCode < 256; charCode++) {
              if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
                widths[charCode] = widthsByGlyphName[differences[charCode]];
                continue;
              }
              if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
                widths[charCode] = widthsByGlyphName[encoding[charCode]];
                continue;
              }
            }
            return widths;
          },
          preEvaluateFont: function PartialEvaluator_preEvaluateFont(dict) {
            var baseDict = dict;
            var type = dict.get("Subtype");
            if (!(0, _primitives.isName)(type)) {
              throw new _util.FormatError("invalid font Subtype");
            }
            var composite = false;
            var uint8array;
            if (type.name === "Type0") {
              var df = dict.get("DescendantFonts");
              if (!df) {
                throw new _util.FormatError("Descendant fonts are not specified");
              }
              dict = Array.isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
              type = dict.get("Subtype");
              if (!(0, _primitives.isName)(type)) {
                throw new _util.FormatError("invalid font Subtype");
              }
              composite = true;
            }
            var descriptor = dict.get("FontDescriptor");
            if (descriptor) {
              var hash = new _murmurhash.MurmurHash3_64();
              var encoding = baseDict.getRaw("Encoding");
              if ((0, _primitives.isName)(encoding)) {
                hash.update(encoding.name);
              } else if ((0, _primitives.isRef)(encoding)) {
                hash.update(encoding.toString());
              } else if ((0, _primitives.isDict)(encoding)) {
                var keys = encoding.getKeys();
                for (var i = 0, ii = keys.length; i < ii; i++) {
                  var entry = encoding.getRaw(keys[i]);
                  if ((0, _primitives.isName)(entry)) {
                    hash.update(entry.name);
                  } else if ((0, _primitives.isRef)(entry)) {
                    hash.update(entry.toString());
                  } else if (Array.isArray(entry)) {
                    var diffLength = entry.length,
                      diffBuf = new Array(diffLength);
                    for (var j = 0; j < diffLength; j++) {
                      var diffEntry = entry[j];
                      if ((0, _primitives.isName)(diffEntry)) {
                        diffBuf[j] = diffEntry.name;
                      } else if ((0, _util.isNum)(diffEntry) || (0, _primitives.isRef)(diffEntry)) {
                        diffBuf[j] = diffEntry.toString();
                      }
                    }
                    hash.update(diffBuf.join());
                  }
                }
              }
              var toUnicode = dict.get("ToUnicode") || baseDict.get("ToUnicode");
              if ((0, _primitives.isStream)(toUnicode)) {
                var stream = toUnicode.str || toUnicode;
                uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
                hash.update(uint8array);
              } else if ((0, _primitives.isName)(toUnicode)) {
                hash.update(toUnicode.name);
              }
              var widths = dict.get("Widths") || baseDict.get("Widths");
              if (widths) {
                uint8array = new Uint8Array(new Uint32Array(widths).buffer);
                hash.update(uint8array);
              }
            }
            return {
              descriptor: descriptor,
              dict: dict,
              baseDict: baseDict,
              composite: composite,
              type: type.name,
              hash: hash ? hash.hexdigest() : ""
            };
          },
          translateFont: function PartialEvaluator_translateFont(preEvaluatedFont) {
            var _this11 = this;

            var baseDict = preEvaluatedFont.baseDict;
            var dict = preEvaluatedFont.dict;
            var composite = preEvaluatedFont.composite;
            var descriptor = preEvaluatedFont.descriptor;
            var type = preEvaluatedFont.type;
            var maxCharIndex = composite ? 0xFFFF : 0xFF;
            var properties;
            if (!descriptor) {
              if (type === "Type3") {
                descriptor = new _primitives.Dict(null);
                descriptor.set("FontName", _primitives.Name.get(type));
                descriptor.set("FontBBox", dict.getArray("FontBBox"));
              } else {
                var baseFontName = dict.get("BaseFont");
                if (!(0, _primitives.isName)(baseFontName)) {
                  throw new _util.FormatError("Base font is not specified");
                }
                baseFontName = baseFontName.name.replace(/[,_]/g, "-");
                var metrics = this.getBaseFontMetrics(baseFontName);
                var fontNameWoStyle = baseFontName.split("-")[0];
                var flags = (this.isSerifFont(fontNameWoStyle) ? _fonts.FontFlags.Serif : 0) | (metrics.monospace ? _fonts.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts.FontFlags.Symbolic : _fonts.FontFlags.Nonsymbolic);
                properties = {
                  type: type,
                  name: baseFontName,
                  widths: metrics.widths,
                  defaultWidth: metrics.defaultWidth,
                  flags: flags,
                  firstChar: 0,
                  lastChar: maxCharIndex
                };
                return this.extractDataStructures(dict, dict, properties).then(function (properties) {
                  properties.widths = _this11.buildCharCodeToWidth(metrics.widths, properties);
                  return new _fonts.Font(baseFontName, null, properties);
                });
              }
            }
            var firstChar = dict.get("FirstChar") || 0;
            var lastChar = dict.get("LastChar") || maxCharIndex;
            var fontName = descriptor.get("FontName");
            var baseFont = dict.get("BaseFont");
            if ((0, _util.isString)(fontName)) {
              fontName = _primitives.Name.get(fontName);
            }
            if ((0, _util.isString)(baseFont)) {
              baseFont = _primitives.Name.get(baseFont);
            }
            if (type !== "Type3") {
              var fontNameStr = fontName && fontName.name;
              var baseFontStr = baseFont && baseFont.name;
              if (fontNameStr !== baseFontStr) {
                (0, _util.info)("The FontDescriptor's FontName is \"" + fontNameStr + "\" but should be the same as the Font's BaseFont \"" + baseFontStr + "\"");
                if (fontNameStr && baseFontStr && baseFontStr.indexOf(fontNameStr) === 0) {
                  fontName = baseFont;
                }
              }
            }
            fontName = fontName || baseFont;
            if (!(0, _primitives.isName)(fontName)) {
              throw new _util.FormatError("invalid font name");
            }
            var fontFile = descriptor.get("FontFile", "FontFile2", "FontFile3");
            if (fontFile) {
              if (fontFile.dict) {
                var subtype = fontFile.dict.get("Subtype");
                if (subtype) {
                  subtype = subtype.name;
                }
                var length1 = fontFile.dict.get("Length1");
                var length2 = fontFile.dict.get("Length2");
                var length3 = fontFile.dict.get("Length3");
              }
            }
            properties = {
              type: type,
              name: fontName.name,
              subtype: subtype,
              file: fontFile,
              length1: length1,
              length2: length2,
              length3: length3,
              loadedName: baseDict.loadedName,
              composite: composite,
              wideChars: composite,
              fixedPitch: false,
              fontMatrix: dict.getArray("FontMatrix") || _util.FONT_IDENTITY_MATRIX,
              firstChar: firstChar || 0,
              lastChar: lastChar || maxCharIndex,
              bbox: descriptor.getArray("FontBBox"),
              ascent: descriptor.get("Ascent"),
              descent: descriptor.get("Descent"),
              xHeight: descriptor.get("XHeight"),
              capHeight: descriptor.get("CapHeight"),
              flags: descriptor.get("Flags"),
              italicAngle: descriptor.get("ItalicAngle"),
              isType3Font: false
            };
            var cMapPromise;
            if (composite) {
              var cidEncoding = baseDict.get("Encoding");
              if ((0, _primitives.isName)(cidEncoding)) {
                properties.cidEncoding = cidEncoding.name;
              }
              cMapPromise = _cmap.CMapFactory.create({
                encoding: cidEncoding,
                fetchBuiltInCMap: this.fetchBuiltInCMap,
                useCMap: null
              }).then(function (cMap) {
                properties.cMap = cMap;
                properties.vertical = properties.cMap.vertical;
              });
            } else {
              cMapPromise = Promise.resolve(undefined);
            }
            return cMapPromise.then(function () {
              return _this11.extractDataStructures(dict, baseDict, properties);
            }).then(function (properties) {
              _this11.extractWidths(dict, descriptor, properties);
              if (type === "Type3") {
                properties.isType3Font = true;
              }
              return new _fonts.Font(fontName.name, fontFile, properties);
            });
          }
        };
        return PartialEvaluator;
      }();
      var TranslatedFont = function TranslatedFontClosure() {
        function TranslatedFont(loadedName, font, dict) {
          this.loadedName = loadedName;
          this.font = font;
          this.dict = dict;
          this.type3Loaded = null;
          this.sent = false;
        }
        TranslatedFont.prototype = {
          send: function send(handler) {
            if (this.sent) {
              return;
            }
            var fontData = this.font.exportData();
            handler.send("commonobj", [this.loadedName, "Font", fontData]);
            this.sent = true;
          },
          loadType3Data: function loadType3Data(evaluator, resources, parentOperatorList, task) {
            if (!this.font.isType3Font) {
              throw new Error("Must be a Type3 font.");
            }
            if (this.type3Loaded) {
              return this.type3Loaded;
            }
            var type3Options = Object.create(evaluator.options);
            type3Options.ignoreErrors = false;
            var type3Evaluator = evaluator.clone(type3Options);
            var translatedFont = this.font;
            var loadCharProcsPromise = Promise.resolve();
            var charProcs = this.dict.get("CharProcs");
            var fontResources = this.dict.get("Resources") || resources;
            var charProcKeys = charProcs.getKeys();
            var charProcOperatorList = Object.create(null);

            var _loop2 = function _loop2() {
              var key = charProcKeys[i];
              loadCharProcsPromise = loadCharProcsPromise.then(function () {
                var glyphStream = charProcs.get(key);
                var operatorList = new OperatorList();
                return type3Evaluator.getOperatorList({
                  stream: glyphStream,
                  task: task,
                  resources: fontResources,
                  operatorList: operatorList
                }).then(function () {
                  charProcOperatorList[key] = operatorList.getIR();
                  parentOperatorList.addDependencies(operatorList.dependencies);
                }).catch(function (reason) {
                  (0, _util.warn)("Type3 font resource \"" + key + "\" is not available.");
                  var operatorList = new OperatorList();
                  charProcOperatorList[key] = operatorList.getIR();
                });
              });
            };

            for (var i = 0, n = charProcKeys.length; i < n; ++i) {
              _loop2();
            }
            this.type3Loaded = loadCharProcsPromise.then(function () {
              translatedFont.charProcOperatorList = charProcOperatorList;
            });
            return this.type3Loaded;
          }
        };
        return TranslatedFont;
      }();
      var OperatorList = function OperatorListClosure() {
        var CHUNK_SIZE = 1000;
        var CHUNK_SIZE_ABOUT = CHUNK_SIZE - 5;
        function getTransfers(queue) {
          var transfers = [];
          var fnArray = queue.fnArray,
            argsArray = queue.argsArray;
          for (var i = 0, ii = queue.length; i < ii; i++) {
            switch (fnArray[i]) {
              case _util.OPS.paintInlineImageXObject:
              case _util.OPS.paintInlineImageXObjectGroup:
              case _util.OPS.paintImageMaskXObject:
                var arg = argsArray[i][0];
                if (!arg.cached) {
                  transfers.push(arg.data.buffer);
                }
                break;
            }
          }
          return transfers;
        }
        function OperatorList(intent, messageHandler, pageIndex) {
          this.messageHandler = messageHandler;
          this.fnArray = [];
          this.argsArray = [];
          this.dependencies = Object.create(null);
          this._totalLength = 0;
          this.pageIndex = pageIndex;
          this.intent = intent;
        }
        OperatorList.prototype = {
          get length() {
            return this.argsArray.length;
          },
          get totalLength() {
            return this._totalLength + this.length;
          },
          addOp: function addOp(fn, args) {
            this.fnArray.push(fn);
            this.argsArray.push(args);
            if (this.messageHandler) {
              if (this.fnArray.length >= CHUNK_SIZE) {
                this.flush();
              } else if (this.fnArray.length >= CHUNK_SIZE_ABOUT && (fn === _util.OPS.restore || fn === _util.OPS.endText)) {
                this.flush();
              }
            }
          },
          addDependency: function addDependency(dependency) {
            if (dependency in this.dependencies) {
              return;
            }
            this.dependencies[dependency] = true;
            this.addOp(_util.OPS.dependency, [dependency]);
          },
          addDependencies: function addDependencies(dependencies) {
            for (var key in dependencies) {
              this.addDependency(key);
            }
          },
          addOpList: function addOpList(opList) {
            _util.Util.extendObj(this.dependencies, opList.dependencies);
            for (var i = 0, ii = opList.length; i < ii; i++) {
              this.addOp(opList.fnArray[i], opList.argsArray[i]);
            }
          },
          getIR: function getIR() {
            return {
              fnArray: this.fnArray,
              argsArray: this.argsArray,
              length: this.length
            };
          },
          flush: function flush(lastChunk) {
            if (this.intent !== "oplist") {
              new QueueOptimizer().optimize(this);
            }
            var transfers = getTransfers(this);
            var length = this.length;
            this._totalLength += length;
            this.messageHandler.send("RenderPageChunk", {
              operatorList: {
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                lastChunk: lastChunk,
                length: length
              },
              pageIndex: this.pageIndex,
              intent: this.intent
            }, transfers);
            this.dependencies = Object.create(null);
            this.fnArray.length = 0;
            this.argsArray.length = 0;
          }
        };
        return OperatorList;
      }();
      var StateManager = function StateManagerClosure() {
        function StateManager(initialState) {
          this.state = initialState;
          this.stateStack = [];
        }
        StateManager.prototype = {
          save: function save() {
            var old = this.state;
            this.stateStack.push(this.state);
            this.state = old.clone();
          },
          restore: function restore() {
            var prev = this.stateStack.pop();
            if (prev) {
              this.state = prev;
            }
          },
          transform: function transform(args) {
            this.state.ctm = _util.Util.transform(this.state.ctm, args);
          }
        };
        return StateManager;
      }();
      var TextState = function TextStateClosure() {
        function TextState() {
          this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
          this.fontName = null;
          this.fontSize = 0;
          this.font = null;
          this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
          this.textMatrix = _util.IDENTITY_MATRIX.slice();
          this.textLineMatrix = _util.IDENTITY_MATRIX.slice();
          this.charSpacing = 0;
          this.wordSpacing = 0;
          this.leading = 0;
          this.textHScale = 1;
          this.textRise = 0;
        }
        TextState.prototype = {
          setTextMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
            var m = this.textMatrix;
            m[0] = a;
            m[1] = b;
            m[2] = c;
            m[3] = d;
            m[4] = e;
            m[5] = f;
          },
          setTextLineMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
            var m = this.textLineMatrix;
            m[0] = a;
            m[1] = b;
            m[2] = c;
            m[3] = d;
            m[4] = e;
            m[5] = f;
          },
          translateTextMatrix: function TextState_translateTextMatrix(x, y) {
            var m = this.textMatrix;
            m[4] = m[0] * x + m[2] * y + m[4];
            m[5] = m[1] * x + m[3] * y + m[5];
          },
          translateTextLineMatrix: function TextState_translateTextMatrix(x, y) {
            var m = this.textLineMatrix;
            m[4] = m[0] * x + m[2] * y + m[4];
            m[5] = m[1] * x + m[3] * y + m[5];
          },
          calcTextLineMatrixAdvance: function TextState_calcTextLineMatrixAdvance(a, b, c, d, e, f) {
            var font = this.font;
            if (!font) {
              return null;
            }
            var m = this.textLineMatrix;
            if (!(a === m[0] && b === m[1] && c === m[2] && d === m[3])) {
              return null;
            }
            var txDiff = e - m[4],
              tyDiff = f - m[5];
            if (font.vertical && txDiff !== 0 || !font.vertical && tyDiff !== 0) {
              return null;
            }
            var tx,
              ty,
              denominator = a * d - b * c;
            if (font.vertical) {
              tx = -tyDiff * c / denominator;
              ty = tyDiff * a / denominator;
            } else {
              tx = txDiff * d / denominator;
              ty = -txDiff * b / denominator;
            }
            return {
              width: tx,
              height: ty,
              value: font.vertical ? ty : tx
            };
          },
          calcRenderMatrix: function TextState_calcRendeMatrix(ctm) {
            var tsm = [this.fontSize * this.textHScale, 0, 0, this.fontSize, 0, this.textRise];
            return _util.Util.transform(ctm, _util.Util.transform(this.textMatrix, tsm));
          },
          carriageReturn: function TextState_carriageReturn() {
            this.translateTextLineMatrix(0, -this.leading);
            this.textMatrix = this.textLineMatrix.slice();
          },
          clone: function TextState_clone() {
            var clone = Object.create(this);
            clone.textMatrix = this.textMatrix.slice();
            clone.textLineMatrix = this.textLineMatrix.slice();
            clone.fontMatrix = this.fontMatrix.slice();
            return clone;
          }
        };
        return TextState;
      }();
      var EvalState = function EvalStateClosure() {
        function EvalState() {
          this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
          this.font = null;
          this.textRenderingMode = _util.TextRenderingMode.FILL;
          this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
          this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
        }
        EvalState.prototype = {
          clone: function CanvasExtraState_clone() {
            return Object.create(this);
          }
        };
        return EvalState;
      }();
      var EvaluatorPreprocessor = function EvaluatorPreprocessorClosure() {
        var getOPMap = (0, _util.getLookupTableFactory)(function (t) {
          t["w"] = {
            id: _util.OPS.setLineWidth,
            numArgs: 1,
            variableArgs: false
          };
          t["J"] = {
            id: _util.OPS.setLineCap,
            numArgs: 1,
            variableArgs: false
          };
          t["j"] = {
            id: _util.OPS.setLineJoin,
            numArgs: 1,
            variableArgs: false
          };
          t["M"] = {
            id: _util.OPS.setMiterLimit,
            numArgs: 1,
            variableArgs: false
          };
          t["d"] = {
            id: _util.OPS.setDash,
            numArgs: 2,
            variableArgs: false
          };
          t["ri"] = {
            id: _util.OPS.setRenderingIntent,
            numArgs: 1,
            variableArgs: false
          };
          t["i"] = {
            id: _util.OPS.setFlatness,
            numArgs: 1,
            variableArgs: false
          };
          t["gs"] = {
            id: _util.OPS.setGState,
            numArgs: 1,
            variableArgs: false
          };
          t["q"] = {
            id: _util.OPS.save,
            numArgs: 0,
            variableArgs: false
          };
          t["Q"] = {
            id: _util.OPS.restore,
            numArgs: 0,
            variableArgs: false
          };
          t["cm"] = {
            id: _util.OPS.transform,
            numArgs: 6,
            variableArgs: false
          };
          t["m"] = {
            id: _util.OPS.moveTo,
            numArgs: 2,
            variableArgs: false
          };
          t["l"] = {
            id: _util.OPS.lineTo,
            numArgs: 2,
            variableArgs: false
          };
          t["c"] = {
            id: _util.OPS.curveTo,
            numArgs: 6,
            variableArgs: false
          };
          t["v"] = {
            id: _util.OPS.curveTo2,
            numArgs: 4,
            variableArgs: false
          };
          t["y"] = {
            id: _util.OPS.curveTo3,
            numArgs: 4,
            variableArgs: false
          };
          t["h"] = {
            id: _util.OPS.closePath,
            numArgs: 0,
            variableArgs: false
          };
          t["re"] = {
            id: _util.OPS.rectangle,
            numArgs: 4,
            variableArgs: false
          };
          t["S"] = {
            id: _util.OPS.stroke,
            numArgs: 0,
            variableArgs: false
          };
          t["s"] = {
            id: _util.OPS.closeStroke,
            numArgs: 0,
            variableArgs: false
          };
          t["f"] = {
            id: _util.OPS.fill,
            numArgs: 0,
            variableArgs: false
          };
          t["F"] = {
            id: _util.OPS.fill,
            numArgs: 0,
            variableArgs: false
          };
          t["f*"] = {
            id: _util.OPS.eoFill,
            numArgs: 0,
            variableArgs: false
          };
          t["B"] = {
            id: _util.OPS.fillStroke,
            numArgs: 0,
            variableArgs: false
          };
          t["B*"] = {
            id: _util.OPS.eoFillStroke,
            numArgs: 0,
            variableArgs: false
          };
          t["b"] = {
            id: _util.OPS.closeFillStroke,
            numArgs: 0,
            variableArgs: false
          };
          t["b*"] = {
            id: _util.OPS.closeEOFillStroke,
            numArgs: 0,
            variableArgs: false
          };
          t["n"] = {
            id: _util.OPS.endPath,
            numArgs: 0,
            variableArgs: false
          };
          t["W"] = {
            id: _util.OPS.clip,
            numArgs: 0,
            variableArgs: false
          };
          t["W*"] = {
            id: _util.OPS.eoClip,
            numArgs: 0,
            variableArgs: false
          };
          t["BT"] = {
            id: _util.OPS.beginText,
            numArgs: 0,
            variableArgs: false
          };
          t["ET"] = {
            id: _util.OPS.endText,
            numArgs: 0,
            variableArgs: false
          };
          t["Tc"] = {
            id: _util.OPS.setCharSpacing,
            numArgs: 1,
            variableArgs: false
          };
          t["Tw"] = {
            id: _util.OPS.setWordSpacing,
            numArgs: 1,
            variableArgs: false
          };
          t["Tz"] = {
            id: _util.OPS.setHScale,
            numArgs: 1,
            variableArgs: false
          };
          t["TL"] = {
            id: _util.OPS.setLeading,
            numArgs: 1,
            variableArgs: false
          };
          t["Tf"] = {
            id: _util.OPS.setFont,
            numArgs: 2,
            variableArgs: false
          };
          t["Tr"] = {
            id: _util.OPS.setTextRenderingMode,
            numArgs: 1,
            variableArgs: false
          };
          t["Ts"] = {
            id: _util.OPS.setTextRise,
            numArgs: 1,
            variableArgs: false
          };
          t["Td"] = {
            id: _util.OPS.moveText,
            numArgs: 2,
            variableArgs: false
          };
          t["TD"] = {
            id: _util.OPS.setLeadingMoveText,
            numArgs: 2,
            variableArgs: false
          };
          t["Tm"] = {
            id: _util.OPS.setTextMatrix,
            numArgs: 6,
            variableArgs: false
          };
          t["T*"] = {
            id: _util.OPS.nextLine,
            numArgs: 0,
            variableArgs: false
          };
          t["Tj"] = {
            id: _util.OPS.showText,
            numArgs: 1,
            variableArgs: false
          };
          t["TJ"] = {
            id: _util.OPS.showSpacedText,
            numArgs: 1,
            variableArgs: false
          };
          t["'"] = {
            id: _util.OPS.nextLineShowText,
            numArgs: 1,
            variableArgs: false
          };
          t["\""] = {
            id: _util.OPS.nextLineSetSpacingShowText,
            numArgs: 3,
            variableArgs: false
          };
          t["d0"] = {
            id: _util.OPS.setCharWidth,
            numArgs: 2,
            variableArgs: false
          };
          t["d1"] = {
            id: _util.OPS.setCharWidthAndBounds,
            numArgs: 6,
            variableArgs: false
          };
          t["CS"] = {
            id: _util.OPS.setStrokeColorSpace,
            numArgs: 1,
            variableArgs: false
          };
          t["cs"] = {
            id: _util.OPS.setFillColorSpace,
            numArgs: 1,
            variableArgs: false
          };
          t["SC"] = {
            id: _util.OPS.setStrokeColor,
            numArgs: 4,
            variableArgs: true
          };
          t["SCN"] = {
            id: _util.OPS.setStrokeColorN,
            numArgs: 33,
            variableArgs: true
          };
          t["sc"] = {
            id: _util.OPS.setFillColor,
            numArgs: 4,
            variableArgs: true
          };
          t["scn"] = {
            id: _util.OPS.setFillColorN,
            numArgs: 33,
            variableArgs: true
          };
          t["G"] = {
            id: _util.OPS.setStrokeGray,
            numArgs: 1,
            variableArgs: false
          };
          t["g"] = {
            id: _util.OPS.setFillGray,
            numArgs: 1,
            variableArgs: false
          };
          t["RG"] = {
            id: _util.OPS.setStrokeRGBColor,
            numArgs: 3,
            variableArgs: false
          };
          t["rg"] = {
            id: _util.OPS.setFillRGBColor,
            numArgs: 3,
            variableArgs: false
          };
          t["K"] = {
            id: _util.OPS.setStrokeCMYKColor,
            numArgs: 4,
            variableArgs: false
          };
          t["k"] = {
            id: _util.OPS.setFillCMYKColor,
            numArgs: 4,
            variableArgs: false
          };
          t["sh"] = {
            id: _util.OPS.shadingFill,
            numArgs: 1,
            variableArgs: false
          };
          t["BI"] = {
            id: _util.OPS.beginInlineImage,
            numArgs: 0,
            variableArgs: false
          };
          t["ID"] = {
            id: _util.OPS.beginImageData,
            numArgs: 0,
            variableArgs: false
          };
          t["EI"] = {
            id: _util.OPS.endInlineImage,
            numArgs: 1,
            variableArgs: false
          };
          t["Do"] = {
            id: _util.OPS.paintXObject,
            numArgs: 1,
            variableArgs: false
          };
          t["MP"] = {
            id: _util.OPS.markPoint,
            numArgs: 1,
            variableArgs: false
          };
          t["DP"] = {
            id: _util.OPS.markPointProps,
            numArgs: 2,
            variableArgs: false
          };
          t["BMC"] = {
            id: _util.OPS.beginMarkedContent,
            numArgs: 1,
            variableArgs: false
          };
          t["BDC"] = {
            id: _util.OPS.beginMarkedContentProps,
            numArgs: 2,
            variableArgs: false
          };
          t["EMC"] = {
            id: _util.OPS.endMarkedContent,
            numArgs: 0,
            variableArgs: false
          };
          t["BX"] = {
            id: _util.OPS.beginCompat,
            numArgs: 0,
            variableArgs: false
          };
          t["EX"] = {
            id: _util.OPS.endCompat,
            numArgs: 0,
            variableArgs: false
          };
          t["BM"] = null;
          t["BD"] = null;
          t["true"] = null;
          t["fa"] = null;
          t["fal"] = null;
          t["fals"] = null;
          t["false"] = null;
          t["nu"] = null;
          t["nul"] = null;
          t["null"] = null;
        });
        function EvaluatorPreprocessor(stream, xref, stateManager) {
          this.opMap = getOPMap();
          this.parser = new _parser.Parser(new _parser.Lexer(stream, this.opMap), false, xref);
          this.stateManager = stateManager;
          this.nonProcessedArgs = [];
        }
        EvaluatorPreprocessor.prototype = {
          get savedStatesDepth() {
            return this.stateManager.stateStack.length;
          },
          read: function EvaluatorPreprocessor_read(operation) {
            var args = operation.args;
            while (true) {
              var obj = this.parser.getObj();
              if ((0, _primitives.isCmd)(obj)) {
                var cmd = obj.cmd;
                var opSpec = this.opMap[cmd];
                if (!opSpec) {
                  (0, _util.warn)("Unknown command \"" + cmd + "\"");
                  continue;
                }
                var fn = opSpec.id;
                var numArgs = opSpec.numArgs;
                var argsLength = args !== null ? args.length : 0;
                if (!opSpec.variableArgs) {
                  if (argsLength !== numArgs) {
                    var nonProcessedArgs = this.nonProcessedArgs;
                    while (argsLength > numArgs) {
                      nonProcessedArgs.push(args.shift());
                      argsLength--;
                    }
                    while (argsLength < numArgs && nonProcessedArgs.length !== 0) {
                      if (args === null) {
                        args = [];
                      }
                      args.unshift(nonProcessedArgs.pop());
                      argsLength++;
                    }
                  }
                  if (argsLength < numArgs) {
                    (0, _util.warn)("Skipping command " + fn + ": expected " + numArgs + " args, but received " + argsLength + " args.");
                    if (args !== null) {
                      args.length = 0;
                    }
                    continue;
                  }
                } else if (argsLength > numArgs) {
                  (0, _util.info)("Command " + fn + ": expected [0," + numArgs + "] args, but received " + argsLength + " args.");
                }
                this.preprocessCommand(fn, args);
                operation.fn = fn;
                operation.args = args;
                return true;
              }
              if ((0, _primitives.isEOF)(obj)) {
                return false;
              }
              if (obj !== null) {
                if (args === null) {
                  args = [];
                }
                args.push(obj);
                if (args.length > 33) {
                  throw new _util.FormatError("Too many arguments");
                }
              }
            }
          },
          preprocessCommand: function EvaluatorPreprocessor_preprocessCommand(fn, args) {
            switch (fn | 0) {
              case _util.OPS.save:
                this.stateManager.save();
                break;
              case _util.OPS.restore:
                this.stateManager.restore();
                break;
              case _util.OPS.transform:
                this.stateManager.transform(args);
                break;
            }
          }
        };
        return EvaluatorPreprocessor;
      }();
      var QueueOptimizer = function QueueOptimizerClosure() {
        function addState(parentState, pattern, fn) {
          var state = parentState;
          for (var i = 0, ii = pattern.length - 1; i < ii; i++) {
            var item = pattern[i];
            state = state[item] || (state[item] = []);
          }
          state[pattern[pattern.length - 1]] = fn;
        }
        function handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray) {
          var iFirstPIMXO = iFirstSave + 2;
          for (var i = 0; i < count; i++) {
            var arg = argsArray[iFirstPIMXO + 4 * i];
            var imageMask = arg.length === 1 && arg[0];
            if (imageMask && imageMask.width === 1 && imageMask.height === 1 && (!imageMask.data.length || imageMask.data.length === 1 && imageMask.data[0] === 0)) {
              fnArray[iFirstPIMXO + 4 * i] = _util.OPS.paintSolidColorImageMask;
              continue;
            }
            break;
          }
          return count - i;
        }
        var InitialState = [];
        addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintInlineImageXObject, _util.OPS.restore], function foundInlineImageGroup(context) {
          var MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
          var MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
          var MAX_WIDTH = 1000;
          var IMAGE_PADDING = 1;
          var fnArray = context.fnArray,
            argsArray = context.argsArray;
          var curr = context.iCurr;
          var iFirstSave = curr - 3;
          var iFirstTransform = curr - 2;
          var iFirstPIIXO = curr - 1;
          var i = iFirstSave + 4;
          var ii = fnArray.length;
          while (i + 3 < ii) {
            if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintInlineImageXObject || fnArray[i + 3] !== _util.OPS.restore) {
              break;
            }
            i += 4;
          }
          var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
          if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) {
            return i;
          }
          var maxX = 0;
          var map = [],
            maxLineHeight = 0;
          var currentX = IMAGE_PADDING,
            currentY = IMAGE_PADDING;
          var q;
          for (q = 0; q < count; q++) {
            var transform = argsArray[iFirstTransform + (q << 2)];
            var img = argsArray[iFirstPIIXO + (q << 2)][0];
            if (currentX + img.width > MAX_WIDTH) {
              maxX = Math.max(maxX, currentX);
              currentY += maxLineHeight + 2 * IMAGE_PADDING;
              currentX = 0;
              maxLineHeight = 0;
            }
            map.push({
              transform: transform,
              x: currentX,
              y: currentY,
              w: img.width,
              h: img.height
            });
            currentX += img.width + 2 * IMAGE_PADDING;
            maxLineHeight = Math.max(maxLineHeight, img.height);
          }
          var imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
          var imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
          var imgData = new Uint8Array(imgWidth * imgHeight * 4);
          var imgRowSize = imgWidth << 2;
          for (q = 0; q < count; q++) {
            var data = argsArray[iFirstPIIXO + (q << 2)][0].data;
            var rowSize = map[q].w << 2;
            var dataOffset = 0;
            var offset = map[q].x + map[q].y * imgWidth << 2;
            imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
            for (var k = 0, kk = map[q].h; k < kk; k++) {
              imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
              dataOffset += rowSize;
              offset += imgRowSize;
            }
            imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
            while (offset >= 0) {
              data[offset - 4] = data[offset];
              data[offset - 3] = data[offset + 1];
              data[offset - 2] = data[offset + 2];
              data[offset - 1] = data[offset + 3];
              data[offset + rowSize] = data[offset + rowSize - 4];
              data[offset + rowSize + 1] = data[offset + rowSize - 3];
              data[offset + rowSize + 2] = data[offset + rowSize - 2];
              data[offset + rowSize + 3] = data[offset + rowSize - 1];
              offset -= imgRowSize;
            }
          }
          fnArray.splice(iFirstSave, count * 4, _util.OPS.paintInlineImageXObjectGroup);
          argsArray.splice(iFirstSave, count * 4, [{
            width: imgWidth,
            height: imgHeight,
            kind: _util.ImageKind.RGBA_32BPP,
            data: imgData
          }, map]);
          return iFirstSave + 1;
        });
        addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintImageMaskXObject, _util.OPS.restore], function foundImageMaskGroup(context) {
          var MIN_IMAGES_IN_MASKS_BLOCK = 10;
          var MAX_IMAGES_IN_MASKS_BLOCK = 100;
          var MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
          var fnArray = context.fnArray,
            argsArray = context.argsArray;
          var curr = context.iCurr;
          var iFirstSave = curr - 3;
          var iFirstTransform = curr - 2;
          var iFirstPIMXO = curr - 1;
          var i = iFirstSave + 4;
          var ii = fnArray.length;
          while (i + 3 < ii) {
            if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintImageMaskXObject || fnArray[i + 3] !== _util.OPS.restore) {
              break;
            }
            i += 4;
          }
          var count = (i - iFirstSave) / 4;
          count = handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray);
          if (count < MIN_IMAGES_IN_MASKS_BLOCK) {
            return i;
          }
          var q;
          var isSameImage = false;
          var iTransform, transformArgs;
          var firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
          if (argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0) {
            isSameImage = true;
            var firstTransformArg0 = argsArray[iFirstTransform][0];
            var firstTransformArg3 = argsArray[iFirstTransform][3];
            iTransform = iFirstTransform + 4;
            var iPIMXO = iFirstPIMXO + 4;
            for (q = 1; q < count; q++, iTransform += 4, iPIMXO += 4) {
              transformArgs = argsArray[iTransform];
              if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== 0 || transformArgs[2] !== 0 || transformArgs[3] !== firstTransformArg3) {
                if (q < MIN_IMAGES_IN_MASKS_BLOCK) {
                  isSameImage = false;
                } else {
                  count = q;
                }
                break;
              }
            }
          }
          if (isSameImage) {
            count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
            var positions = new Float32Array(count * 2);
            iTransform = iFirstTransform;
            for (q = 0; q < count; q++, iTransform += 4) {
              transformArgs = argsArray[iTransform];
              positions[q << 1] = transformArgs[4];
              positions[(q << 1) + 1] = transformArgs[5];
            }
            fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectRepeat);
            argsArray.splice(iFirstSave, count * 4, [firstPIMXOArg0, firstTransformArg0, firstTransformArg3, positions]);
          } else {
            count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
            var images = [];
            for (q = 0; q < count; q++) {
              transformArgs = argsArray[iFirstTransform + (q << 2)];
              var maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
              images.push({
                data: maskParams.data,
                width: maskParams.width,
                height: maskParams.height,
                transform: transformArgs
              });
            }
            fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectGroup);
            argsArray.splice(iFirstSave, count * 4, [images]);
          }
          return iFirstSave + 1;
        });
        addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintImageXObject, _util.OPS.restore], function (context) {
          var MIN_IMAGES_IN_BLOCK = 3;
          var MAX_IMAGES_IN_BLOCK = 1000;
          var fnArray = context.fnArray,
            argsArray = context.argsArray;
          var curr = context.iCurr;
          var iFirstSave = curr - 3;
          var iFirstTransform = curr - 2;
          var iFirstPIXO = curr - 1;
          var iFirstRestore = curr;
          if (argsArray[iFirstTransform][1] !== 0 || argsArray[iFirstTransform][2] !== 0) {
            return iFirstRestore + 1;
          }
          var firstPIXOArg0 = argsArray[iFirstPIXO][0];
          var firstTransformArg0 = argsArray[iFirstTransform][0];
          var firstTransformArg3 = argsArray[iFirstTransform][3];
          var i = iFirstSave + 4;
          var ii = fnArray.length;
          while (i + 3 < ii) {
            if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintImageXObject || fnArray[i + 3] !== _util.OPS.restore) {
              break;
            }
            if (argsArray[i + 1][0] !== firstTransformArg0 || argsArray[i + 1][1] !== 0 || argsArray[i + 1][2] !== 0 || argsArray[i + 1][3] !== firstTransformArg3) {
              break;
            }
            if (argsArray[i + 2][0] !== firstPIXOArg0) {
              break;
            }
            i += 4;
          }
          var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_BLOCK);
          if (count < MIN_IMAGES_IN_BLOCK) {
            return i;
          }
          var positions = new Float32Array(count * 2);
          var iTransform = iFirstTransform;
          for (var q = 0; q < count; q++, iTransform += 4) {
            var transformArgs = argsArray[iTransform];
            positions[q << 1] = transformArgs[4];
            positions[(q << 1) + 1] = transformArgs[5];
          }
          var args = [firstPIXOArg0, firstTransformArg0, firstTransformArg3, positions];
          fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageXObjectRepeat);
          argsArray.splice(iFirstSave, count * 4, args);
          return iFirstSave + 1;
        });
        addState(InitialState, [_util.OPS.beginText, _util.OPS.setFont, _util.OPS.setTextMatrix, _util.OPS.showText, _util.OPS.endText], function (context) {
          var MIN_CHARS_IN_BLOCK = 3;
          var MAX_CHARS_IN_BLOCK = 1000;
          var fnArray = context.fnArray,
            argsArray = context.argsArray;
          var curr = context.iCurr;
          var iFirstBeginText = curr - 4;
          var iFirstSetFont = curr - 3;
          var iFirstSetTextMatrix = curr - 2;
          var iFirstShowText = curr - 1;
          var iFirstEndText = curr;
          var firstSetFontArg0 = argsArray[iFirstSetFont][0];
          var firstSetFontArg1 = argsArray[iFirstSetFont][1];
          var i = iFirstBeginText + 5;
          var ii = fnArray.length;
          while (i + 4 < ii) {
            if (fnArray[i] !== _util.OPS.beginText || fnArray[i + 1] !== _util.OPS.setFont || fnArray[i + 2] !== _util.OPS.setTextMatrix || fnArray[i + 3] !== _util.OPS.showText || fnArray[i + 4] !== _util.OPS.endText) {
              break;
            }
            if (argsArray[i + 1][0] !== firstSetFontArg0 || argsArray[i + 1][1] !== firstSetFontArg1) {
              break;
            }
            i += 5;
          }
          var count = Math.min((i - iFirstBeginText) / 5, MAX_CHARS_IN_BLOCK);
          if (count < MIN_CHARS_IN_BLOCK) {
            return i;
          }
          var iFirst = iFirstBeginText;
          if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
            count++;
            iFirst -= 5;
          }
          var iEndText = iFirst + 4;
          for (var q = 1; q < count; q++) {
            fnArray.splice(iEndText, 3);
            argsArray.splice(iEndText, 3);
            iEndText += 2;
          }
          return iEndText + 1;
        });
        function QueueOptimizer() {}
        QueueOptimizer.prototype = {
          optimize: function QueueOptimizer_optimize(queue) {
            var fnArray = queue.fnArray,
              argsArray = queue.argsArray;
            var context = {
              iCurr: 0,
              fnArray: fnArray,
              argsArray: argsArray
            };
            var state;
            var i = 0,
              ii = fnArray.length;
            while (i < ii) {
              state = (state || InitialState)[fnArray[i]];
              if (typeof state === "function") {
                context.iCurr = i;
                i = state(context);
                state = undefined;
                ii = context.fnArray.length;
              } else {
                i++;
              }
            }
          }
        };
        return QueueOptimizer;
      }();
      exports.OperatorList = OperatorList;
      exports.PartialEvaluator = PartialEvaluator;

      /***/ }),
    /* 78 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CFFCompiler = exports.CFFPrivateDict = exports.CFFTopDict = exports.CFFCharset = exports.CFFIndex = exports.CFFStrings = exports.CFFHeader = exports.CFF = exports.CFFParser = exports.CFFStandardStrings = undefined;

      var _util = __w_pdfjs_require__(0);

      var _charsets = __w_pdfjs_require__(135);

      var _encodings = __w_pdfjs_require__(27);

      var MAX_SUBR_NESTING = 10;
      var CFFStandardStrings = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
      var CFFParser = function CFFParserClosure() {
        var CharstringValidationData = [null, {
          id: "hstem",
          min: 2,
          stackClearing: true,
          stem: true
        }, null, {
          id: "vstem",
          min: 2,
          stackClearing: true,
          stem: true
        }, {
          id: "vmoveto",
          min: 1,
          stackClearing: true
        }, {
          id: "rlineto",
          min: 2,
          resetStack: true
        }, {
          id: "hlineto",
          min: 1,
          resetStack: true
        }, {
          id: "vlineto",
          min: 1,
          resetStack: true
        }, {
          id: "rrcurveto",
          min: 6,
          resetStack: true
        }, null, {
          id: "callsubr",
          min: 1,
          undefStack: true
        }, {
          id: "return",
          min: 0,
          undefStack: true
        }, null, null, {
          id: "endchar",
          min: 0,
          stackClearing: true
        }, null, null, null, {
          id: "hstemhm",
          min: 2,
          stackClearing: true,
          stem: true
        }, {
          id: "hintmask",
          min: 0,
          stackClearing: true
        }, {
          id: "cntrmask",
          min: 0,
          stackClearing: true
        }, {
          id: "rmoveto",
          min: 2,
          stackClearing: true
        }, {
          id: "hmoveto",
          min: 1,
          stackClearing: true
        }, {
          id: "vstemhm",
          min: 2,
          stackClearing: true,
          stem: true
        }, {
          id: "rcurveline",
          min: 8,
          resetStack: true
        }, {
          id: "rlinecurve",
          min: 8,
          resetStack: true
        }, {
          id: "vvcurveto",
          min: 4,
          resetStack: true
        }, {
          id: "hhcurveto",
          min: 4,
          resetStack: true
        }, null, {
          id: "callgsubr",
          min: 1,
          undefStack: true
        }, {
          id: "vhcurveto",
          min: 4,
          resetStack: true
        }, {
          id: "hvcurveto",
          min: 4,
          resetStack: true
        }];
        var CharstringValidationData12 = [null, null, null, {
          id: "and",
          min: 2,
          stackDelta: -1
        }, {
          id: "or",
          min: 2,
          stackDelta: -1
        }, {
          id: "not",
          min: 1,
          stackDelta: 0
        }, null, null, null, {
          id: "abs",
          min: 1,
          stackDelta: 0
        }, {
          id: "add",
          min: 2,
          stackDelta: -1,
          stackFn: function stack_div(stack, index) {
            stack[index - 2] = stack[index - 2] + stack[index - 1];
          }
        }, {
          id: "sub",
          min: 2,
          stackDelta: -1,
          stackFn: function stack_div(stack, index) {
            stack[index - 2] = stack[index - 2] - stack[index - 1];
          }
        }, {
          id: "div",
          min: 2,
          stackDelta: -1,
          stackFn: function stack_div(stack, index) {
            stack[index - 2] = stack[index - 2] / stack[index - 1];
          }
        }, null, {
          id: "neg",
          min: 1,
          stackDelta: 0,
          stackFn: function stack_div(stack, index) {
            stack[index - 1] = -stack[index - 1];
          }
        }, {
          id: "eq",
          min: 2,
          stackDelta: -1
        }, null, null, {
          id: "drop",
          min: 1,
          stackDelta: -1
        }, null, {
          id: "put",
          min: 2,
          stackDelta: -2
        }, {
          id: "get",
          min: 1,
          stackDelta: 0
        }, {
          id: "ifelse",
          min: 4,
          stackDelta: -3
        }, {
          id: "random",
          min: 0,
          stackDelta: 1
        }, {
          id: "mul",
          min: 2,
          stackDelta: -1,
          stackFn: function stack_div(stack, index) {
            stack[index - 2] = stack[index - 2] * stack[index - 1];
          }
        }, null, {
          id: "sqrt",
          min: 1,
          stackDelta: 0
        }, {
          id: "dup",
          min: 1,
          stackDelta: 1
        }, {
          id: "exch",
          min: 2,
          stackDelta: 0
        }, {
          id: "index",
          min: 2,
          stackDelta: 0
        }, {
          id: "roll",
          min: 3,
          stackDelta: -2
        }, null, null, null, {
          id: "hflex",
          min: 7,
          resetStack: true
        }, {
          id: "flex",
          min: 13,
          resetStack: true
        }, {
          id: "hflex1",
          min: 9,
          resetStack: true
        }, {
          id: "flex1",
          min: 11,
          resetStack: true
        }];
        function CFFParser(file, properties, seacAnalysisEnabled) {
          this.bytes = file.getBytes();
          this.properties = properties;
          this.seacAnalysisEnabled = !!seacAnalysisEnabled;
        }
        CFFParser.prototype = {
          parse: function CFFParser_parse() {
            var properties = this.properties;
            var cff = new CFF();
            this.cff = cff;
            var header = this.parseHeader();
            var nameIndex = this.parseIndex(header.endPos);
            var topDictIndex = this.parseIndex(nameIndex.endPos);
            var stringIndex = this.parseIndex(topDictIndex.endPos);
            var globalSubrIndex = this.parseIndex(stringIndex.endPos);
            var topDictParsed = this.parseDict(topDictIndex.obj.get(0));
            var topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
            cff.header = header.obj;
            cff.names = this.parseNameIndex(nameIndex.obj);
            cff.strings = this.parseStringIndex(stringIndex.obj);
            cff.topDict = topDict;
            cff.globalSubrIndex = globalSubrIndex.obj;
            this.parsePrivateDict(cff.topDict);
            cff.isCIDFont = topDict.hasName("ROS");
            var charStringOffset = topDict.getByName("CharStrings");
            var charStringIndex = this.parseIndex(charStringOffset).obj;
            var fontMatrix = topDict.getByName("FontMatrix");
            if (fontMatrix) {
              properties.fontMatrix = fontMatrix;
            }
            var fontBBox = topDict.getByName("FontBBox");
            if (fontBBox) {
              properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
              properties.descent = Math.min(fontBBox[1], fontBBox[3]);
              properties.ascentScaled = true;
            }
            var charset, encoding;
            if (cff.isCIDFont) {
              var fdArrayIndex = this.parseIndex(topDict.getByName("FDArray")).obj;
              for (var i = 0, ii = fdArrayIndex.count; i < ii; ++i) {
                var dictRaw = fdArrayIndex.get(i);
                var fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
                this.parsePrivateDict(fontDict);
                cff.fdArray.push(fontDict);
              }
              encoding = null;
              charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, true);
              cff.fdSelect = this.parseFDSelect(topDict.getByName("FDSelect"), charStringIndex.count);
            } else {
              charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, false);
              encoding = this.parseEncoding(topDict.getByName("Encoding"), properties, cff.strings, charset.charset);
            }
            cff.charset = charset;
            cff.encoding = encoding;
            var charStringsAndSeacs = this.parseCharStrings({
              charStrings: charStringIndex,
              localSubrIndex: topDict.privateDict.subrsIndex,
              globalSubrIndex: globalSubrIndex.obj,
              fdSelect: cff.fdSelect,
              fdArray: cff.fdArray,
              privateDict: topDict.privateDict
            });
            cff.charStrings = charStringsAndSeacs.charStrings;
            cff.seacs = charStringsAndSeacs.seacs;
            cff.widths = charStringsAndSeacs.widths;
            return cff;
          },
          parseHeader: function CFFParser_parseHeader() {
            var bytes = this.bytes;
            var bytesLength = bytes.length;
            var offset = 0;
            while (offset < bytesLength && bytes[offset] !== 1) {
              ++offset;
            }
            if (offset >= bytesLength) {
              throw new _util.FormatError("Invalid CFF header");
            }
            if (offset !== 0) {
              (0, _util.info)("cff data is shifted");
              bytes = bytes.subarray(offset);
              this.bytes = bytes;
            }
            var major = bytes[0];
            var minor = bytes[1];
            var hdrSize = bytes[2];
            var offSize = bytes[3];
            var header = new CFFHeader(major, minor, hdrSize, offSize);
            return {
              obj: header,
              endPos: hdrSize
            };
          },
          parseDict: function CFFParser_parseDict(dict) {
            var pos = 0;
            function parseOperand() {
              var value = dict[pos++];
              if (value === 30) {
                return parseFloatOperand();
              } else if (value === 28) {
                value = dict[pos++];
                value = (value << 24 | dict[pos++] << 16) >> 16;
                return value;
              } else if (value === 29) {
                value = dict[pos++];
                value = value << 8 | dict[pos++];
                value = value << 8 | dict[pos++];
                value = value << 8 | dict[pos++];
                return value;
              } else if (value >= 32 && value <= 246) {
                return value - 139;
              } else if (value >= 247 && value <= 250) {
                return (value - 247) * 256 + dict[pos++] + 108;
              } else if (value >= 251 && value <= 254) {
                return -((value - 251) * 256) - dict[pos++] - 108;
              }
              (0, _util.warn)("CFFParser_parseDict: \"" + value + "\" is a reserved command.");
              return NaN;
            }
            function parseFloatOperand() {
              var str = "";
              var eof = 15;
              var lookup = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"];
              var length = dict.length;
              while (pos < length) {
                var b = dict[pos++];
                var b1 = b >> 4;
                var b2 = b & 15;
                if (b1 === eof) {
                  break;
                }
                str += lookup[b1];
                if (b2 === eof) {
                  break;
                }
                str += lookup[b2];
              }
              return parseFloat(str);
            }
            var operands = [];
            var entries = [];
            pos = 0;
            var end = dict.length;
            while (pos < end) {
              var b = dict[pos];
              if (b <= 21) {
                if (b === 12) {
                  b = b << 8 | dict[++pos];
                }
                entries.push([b, operands]);
                operands = [];
                ++pos;
              } else {
                operands.push(parseOperand());
              }
            }
            return entries;
          },
          parseIndex: function CFFParser_parseIndex(pos) {
            var cffIndex = new CFFIndex();
            var bytes = this.bytes;
            var count = bytes[pos++] << 8 | bytes[pos++];
            var offsets = [];
            var end = pos;
            var i, ii;
            if (count !== 0) {
              var offsetSize = bytes[pos++];
              var startPos = pos + (count + 1) * offsetSize - 1;
              for (i = 0, ii = count + 1; i < ii; ++i) {
                var offset = 0;
                for (var j = 0; j < offsetSize; ++j) {
                  offset <<= 8;
                  offset += bytes[pos++];
                }
                offsets.push(startPos + offset);
              }
              end = offsets[count];
            }
            for (i = 0, ii = offsets.length - 1; i < ii; ++i) {
              var offsetStart = offsets[i];
              var offsetEnd = offsets[i + 1];
              cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
            }
            return {
              obj: cffIndex,
              endPos: end
            };
          },
          parseNameIndex: function CFFParser_parseNameIndex(index) {
            var names = [];
            for (var i = 0, ii = index.count; i < ii; ++i) {
              var name = index.get(i);
              names.push((0, _util.bytesToString)(name));
            }
            return names;
          },
          parseStringIndex: function CFFParser_parseStringIndex(index) {
            var strings = new CFFStrings();
            for (var i = 0, ii = index.count; i < ii; ++i) {
              var data = index.get(i);
              strings.add((0, _util.bytesToString)(data));
            }
            return strings;
          },
          createDict: function CFFParser_createDict(Type, dict, strings) {
            var cffDict = new Type(strings);
            for (var i = 0, ii = dict.length; i < ii; ++i) {
              var pair = dict[i];
              var key = pair[0];
              var value = pair[1];
              cffDict.setByKey(key, value);
            }
            return cffDict;
          },
          parseCharString: function CFFParser_parseCharString(state, data, localSubrIndex, globalSubrIndex) {
            if (!data || state.callDepth > MAX_SUBR_NESTING) {
              return false;
            }
            var stackSize = state.stackSize;
            var stack = state.stack;
            var length = data.length;
            for (var j = 0; j < length;) {
              var value = data[j++];
              var validationCommand = null;
              if (value === 12) {
                var q = data[j++];
                if (q === 0) {
                  data[j - 2] = 139;
                  data[j - 1] = 22;
                  stackSize = 0;
                } else {
                  validationCommand = CharstringValidationData12[q];
                }
              } else if (value === 28) {
                stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
                j += 2;
                stackSize++;
              } else if (value === 14) {
                if (stackSize >= 4) {
                  stackSize -= 4;
                  if (this.seacAnalysisEnabled) {
                    state.seac = stack.slice(stackSize, stackSize + 4);
                    return false;
                  }
                }
                validationCommand = CharstringValidationData[value];
              } else if (value >= 32 && value <= 246) {
                stack[stackSize] = value - 139;
                stackSize++;
              } else if (value >= 247 && value <= 254) {
                stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
                j++;
                stackSize++;
              } else if (value === 255) {
                stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
                j += 4;
                stackSize++;
              } else if (value === 19 || value === 20) {
                state.hints += stackSize >> 1;
                j += state.hints + 7 >> 3;
                stackSize %= 2;
                validationCommand = CharstringValidationData[value];
              } else if (value === 10 || value === 29) {
                var subrsIndex;
                if (value === 10) {
                  subrsIndex = localSubrIndex;
                } else {
                  subrsIndex = globalSubrIndex;
                }
                if (!subrsIndex) {
                  validationCommand = CharstringValidationData[value];
                  (0, _util.warn)("Missing subrsIndex for " + validationCommand.id);
                  return false;
                }
                var bias = 32768;
                if (subrsIndex.count < 1240) {
                  bias = 107;
                } else if (subrsIndex.count < 33900) {
                  bias = 1131;
                }
                var subrNumber = stack[--stackSize] + bias;
                if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
                  validationCommand = CharstringValidationData[value];
                  (0, _util.warn)("Out of bounds subrIndex for " + validationCommand.id);
                  return false;
                }
                state.stackSize = stackSize;
                state.callDepth++;
                var valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
                if (!valid) {
                  return false;
                }
                state.callDepth--;
                stackSize = state.stackSize;
                continue;
              } else if (value === 11) {
                state.stackSize = stackSize;
                return true;
              } else {
                validationCommand = CharstringValidationData[value];
              }
              if (validationCommand) {
                if (validationCommand.stem) {
                  state.hints += stackSize >> 1;
                }
                if ("min" in validationCommand) {
                  if (!state.undefStack && stackSize < validationCommand.min) {
                    (0, _util.warn)("Not enough parameters for " + validationCommand.id + "; actual: " + stackSize + ", expected: " + validationCommand.min);
                    return false;
                  }
                }
                if (state.firstStackClearing && validationCommand.stackClearing) {
                  state.firstStackClearing = false;
                  stackSize -= validationCommand.min;
                  if (stackSize >= 2 && validationCommand.stem) {
                    stackSize %= 2;
                  } else if (stackSize > 1) {
                    (0, _util.warn)("Found too many parameters for stack-clearing command");
                  }
                  if (stackSize > 0 && stack[stackSize - 1] >= 0) {
                    state.width = stack[stackSize - 1];
                  }
                }
                if ("stackDelta" in validationCommand) {
                  if ("stackFn" in validationCommand) {
                    validationCommand.stackFn(stack, stackSize);
                  }
                  stackSize += validationCommand.stackDelta;
                } else if (validationCommand.stackClearing) {
                  stackSize = 0;
                } else if (validationCommand.resetStack) {
                  stackSize = 0;
                  state.undefStack = false;
                } else if (validationCommand.undefStack) {
                  stackSize = 0;
                  state.undefStack = true;
                  state.firstStackClearing = false;
                }
              }
            }
            state.stackSize = stackSize;
            return true;
          },
          parseCharStrings: function parseCharStrings(_ref) {
            var charStrings = _ref.charStrings,
              localSubrIndex = _ref.localSubrIndex,
              globalSubrIndex = _ref.globalSubrIndex,
              fdSelect = _ref.fdSelect,
              fdArray = _ref.fdArray,
              privateDict = _ref.privateDict;

            var seacs = [];
            var widths = [];
            var count = charStrings.count;
            for (var i = 0; i < count; i++) {
              var charstring = charStrings.get(i);
              var state = {
                callDepth: 0,
                stackSize: 0,
                stack: [],
                undefStack: true,
                hints: 0,
                firstStackClearing: true,
                seac: null,
                width: null
              };
              var valid = true;
              var localSubrToUse = null;
              var privateDictToUse = privateDict;
              if (fdSelect && fdArray.length) {
                var fdIndex = fdSelect.getFDIndex(i);
                if (fdIndex === -1) {
                  (0, _util.warn)("Glyph index is not in fd select.");
                  valid = false;
                }
                if (fdIndex >= fdArray.length) {
                  (0, _util.warn)("Invalid fd index for glyph index.");
                  valid = false;
                }
                if (valid) {
                  privateDictToUse = fdArray[fdIndex].privateDict;
                  localSubrToUse = privateDictToUse.subrsIndex;
                }
              } else if (localSubrIndex) {
                localSubrToUse = localSubrIndex;
              }
              if (valid) {
                valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
              }
              if (state.width !== null) {
                var nominalWidth = privateDictToUse.getByName("nominalWidthX");
                widths[i] = nominalWidth + state.width;
              } else {
                var defaultWidth = privateDictToUse.getByName("defaultWidthX");
                widths[i] = defaultWidth;
              }
              if (state.seac !== null) {
                seacs[i] = state.seac;
              }
              if (!valid) {
                charStrings.set(i, new Uint8Array([14]));
              }
            }
            return {
              charStrings: charStrings,
              seacs: seacs,
              widths: widths
            };
          },

          emptyPrivateDictionary: function CFFParser_emptyPrivateDictionary(parentDict) {
            var privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
            parentDict.setByKey(18, [0, 0]);
            parentDict.privateDict = privateDict;
          },
          parsePrivateDict: function CFFParser_parsePrivateDict(parentDict) {
            if (!parentDict.hasName("Private")) {
              this.emptyPrivateDictionary(parentDict);
              return;
            }
            var privateOffset = parentDict.getByName("Private");
            if (!Array.isArray(privateOffset) || privateOffset.length !== 2) {
              parentDict.removeByName("Private");
              return;
            }
            var size = privateOffset[0];
            var offset = privateOffset[1];
            if (size === 0 || offset >= this.bytes.length) {
              this.emptyPrivateDictionary(parentDict);
              return;
            }
            var privateDictEnd = offset + size;
            var dictData = this.bytes.subarray(offset, privateDictEnd);
            var dict = this.parseDict(dictData);
            var privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
            parentDict.privateDict = privateDict;
            if (!privateDict.getByName("Subrs")) {
              return;
            }
            var subrsOffset = privateDict.getByName("Subrs");
            var relativeOffset = offset + subrsOffset;
            if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
              this.emptyPrivateDictionary(parentDict);
              return;
            }
            var subrsIndex = this.parseIndex(relativeOffset);
            privateDict.subrsIndex = subrsIndex.obj;
          },
          parseCharsets: function CFFParser_parseCharsets(pos, length, strings, cid) {
            if (pos === 0) {
              return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
            } else if (pos === 1) {
              return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
            } else if (pos === 2) {
              return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
            }
            var bytes = this.bytes;
            var start = pos;
            var format = bytes[pos++];
            var charset = [".notdef"];
            var id, count, i;
            length -= 1;
            switch (format) {
              case 0:
                for (i = 0; i < length; i++) {
                  id = bytes[pos++] << 8 | bytes[pos++];
                  charset.push(cid ? id : strings.get(id));
                }
                break;
              case 1:
                while (charset.length <= length) {
                  id = bytes[pos++] << 8 | bytes[pos++];
                  count = bytes[pos++];
                  for (i = 0; i <= count; i++) {
                    charset.push(cid ? id++ : strings.get(id++));
                  }
                }
                break;
              case 2:
                while (charset.length <= length) {
                  id = bytes[pos++] << 8 | bytes[pos++];
                  count = bytes[pos++] << 8 | bytes[pos++];
                  for (i = 0; i <= count; i++) {
                    charset.push(cid ? id++ : strings.get(id++));
                  }
                }
                break;
              default:
                throw new _util.FormatError("Unknown charset format");
            }
            var end = pos;
            var raw = bytes.subarray(start, end);
            return new CFFCharset(false, format, charset, raw);
          },
          parseEncoding: function CFFParser_parseEncoding(pos, properties, strings, charset) {
            var encoding = Object.create(null);
            var bytes = this.bytes;
            var predefined = false;
            var format, i, ii;
            var raw = null;
            function readSupplement() {
              var supplementsCount = bytes[pos++];
              for (i = 0; i < supplementsCount; i++) {
                var code = bytes[pos++];
                var sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
                encoding[code] = charset.indexOf(strings.get(sid));
              }
            }
            if (pos === 0 || pos === 1) {
              predefined = true;
              format = pos;
              var baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
              for (i = 0, ii = charset.length; i < ii; i++) {
                var index = baseEncoding.indexOf(charset[i]);
                if (index !== -1) {
                  encoding[index] = i;
                }
              }
            } else {
              var dataStart = pos;
              format = bytes[pos++];
              switch (format & 0x7f) {
                case 0:
                  var glyphsCount = bytes[pos++];
                  for (i = 1; i <= glyphsCount; i++) {
                    encoding[bytes[pos++]] = i;
                  }
                  break;
                case 1:
                  var rangesCount = bytes[pos++];
                  var gid = 1;
                  for (i = 0; i < rangesCount; i++) {
                    var start = bytes[pos++];
                    var left = bytes[pos++];
                    for (var j = start; j <= start + left; j++) {
                      encoding[j] = gid++;
                    }
                  }
                  break;
                default:
                  throw new _util.FormatError("Unknown encoding format: " + format + " in CFF");
              }
              var dataEnd = pos;
              if (format & 0x80) {
                bytes[dataStart] &= 0x7f;
                readSupplement();
              }
              raw = bytes.subarray(dataStart, dataEnd);
            }
            format = format & 0x7f;
            return new CFFEncoding(predefined, format, encoding, raw);
          },
          parseFDSelect: function CFFParser_parseFDSelect(pos, length) {
            var start = pos;
            var bytes = this.bytes;
            var format = bytes[pos++];
            var fdSelect = [],
              rawBytes;
            var i,
              invalidFirstGID = false;
            switch (format) {
              case 0:
                for (i = 0; i < length; ++i) {
                  var id = bytes[pos++];
                  fdSelect.push(id);
                }
                rawBytes = bytes.subarray(start, pos);
                break;
              case 3:
                var rangesCount = bytes[pos++] << 8 | bytes[pos++];
                for (i = 0; i < rangesCount; ++i) {
                  var first = bytes[pos++] << 8 | bytes[pos++];
                  if (i === 0 && first !== 0) {
                    (0, _util.warn)("parseFDSelect: The first range must have a first GID of 0" + " -- trying to recover.");
                    invalidFirstGID = true;
                    first = 0;
                  }
                  var fdIndex = bytes[pos++];
                  var next = bytes[pos] << 8 | bytes[pos + 1];
                  for (var j = first; j < next; ++j) {
                    fdSelect.push(fdIndex);
                  }
                }
                pos += 2;
                rawBytes = bytes.subarray(start, pos);
                if (invalidFirstGID) {
                  rawBytes[3] = rawBytes[4] = 0;
                }
                break;
              default:
                throw new _util.FormatError("parseFDSelect: Unknown format \"" + format + "\".");
            }
            if (fdSelect.length !== length) {
              throw new _util.FormatError("parseFDSelect: Invalid font data.");
            }
            return new CFFFDSelect(fdSelect, rawBytes);
          }
        };
        return CFFParser;
      }();
      var CFF = function CFFClosure() {
        function CFF() {
          this.header = null;
          this.names = [];
          this.topDict = null;
          this.strings = new CFFStrings();
          this.globalSubrIndex = null;
          this.encoding = null;
          this.charset = null;
          this.charStrings = null;
          this.fdArray = [];
          this.fdSelect = null;
          this.isCIDFont = false;
        }
        return CFF;
      }();
      var CFFHeader = function CFFHeaderClosure() {
        function CFFHeader(major, minor, hdrSize, offSize) {
          this.major = major;
          this.minor = minor;
          this.hdrSize = hdrSize;
          this.offSize = offSize;
        }
        return CFFHeader;
      }();
      var CFFStrings = function CFFStringsClosure() {
        function CFFStrings() {
          this.strings = [];
        }
        CFFStrings.prototype = {
          get: function CFFStrings_get(index) {
            if (index >= 0 && index <= 390) {
              return CFFStandardStrings[index];
            }
            if (index - 391 <= this.strings.length) {
              return this.strings[index - 391];
            }
            return CFFStandardStrings[0];
          },
          add: function CFFStrings_add(value) {
            this.strings.push(value);
          },
          get count() {
            return this.strings.length;
          }
        };
        return CFFStrings;
      }();
      var CFFIndex = function CFFIndexClosure() {
        function CFFIndex() {
          this.objects = [];
          this.length = 0;
        }
        CFFIndex.prototype = {
          add: function CFFIndex_add(data) {
            this.length += data.length;
            this.objects.push(data);
          },
          set: function CFFIndex_set(index, data) {
            this.length += data.length - this.objects[index].length;
            this.objects[index] = data;
          },
          get: function CFFIndex_get(index) {
            return this.objects[index];
          },
          get count() {
            return this.objects.length;
          }
        };
        return CFFIndex;
      }();
      var CFFDict = function CFFDictClosure() {
        function CFFDict(tables, strings) {
          this.keyToNameMap = tables.keyToNameMap;
          this.nameToKeyMap = tables.nameToKeyMap;
          this.defaults = tables.defaults;
          this.types = tables.types;
          this.opcodes = tables.opcodes;
          this.order = tables.order;
          this.strings = strings;
          this.values = Object.create(null);
        }
        CFFDict.prototype = {
          setByKey: function CFFDict_setByKey(key, value) {
            if (!(key in this.keyToNameMap)) {
              return false;
            }
            var valueLength = value.length;
            if (valueLength === 0) {
              return true;
            }
            for (var i = 0; i < valueLength; i++) {
              if (isNaN(value[i])) {
                (0, _util.warn)("Invalid CFFDict value: \"" + value + "\" for key \"" + key + "\".");
                return true;
              }
            }
            var type = this.types[key];
            if (type === "num" || type === "sid" || type === "offset") {
              value = value[0];
            }
            this.values[key] = value;
            return true;
          },
          setByName: function CFFDict_setByName(name, value) {
            if (!(name in this.nameToKeyMap)) {
              throw new _util.FormatError("Invalid dictionary name \"" + name + "\"");
            }
            this.values[this.nameToKeyMap[name]] = value;
          },
          hasName: function CFFDict_hasName(name) {
            return this.nameToKeyMap[name] in this.values;
          },
          getByName: function CFFDict_getByName(name) {
            if (!(name in this.nameToKeyMap)) {
              throw new _util.FormatError("Invalid dictionary name " + name + "\"");
            }
            var key = this.nameToKeyMap[name];
            if (!(key in this.values)) {
              return this.defaults[key];
            }
            return this.values[key];
          },
          removeByName: function CFFDict_removeByName(name) {
            delete this.values[this.nameToKeyMap[name]];
          }
        };
        CFFDict.createTables = function CFFDict_createTables(layout) {
          var tables = {
            keyToNameMap: {},
            nameToKeyMap: {},
            defaults: {},
            types: {},
            opcodes: {},
            order: []
          };
          for (var i = 0, ii = layout.length; i < ii; ++i) {
            var entry = layout[i];
            var key = Array.isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
            tables.keyToNameMap[key] = entry[1];
            tables.nameToKeyMap[entry[1]] = key;
            tables.types[key] = entry[2];
            tables.defaults[key] = entry[3];
            tables.opcodes[key] = Array.isArray(entry[0]) ? entry[0] : [entry[0]];
            tables.order.push(key);
          }
          return tables;
        };
        return CFFDict;
      }();
      var CFFTopDict = function CFFTopDictClosure() {
        var layout = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [0.001, 0, 0, 0.001, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
        var tables = null;
        function CFFTopDict(strings) {
          if (tables === null) {
            tables = CFFDict.createTables(layout);
          }
          CFFDict.call(this, tables, strings);
          this.privateDict = null;
        }
        CFFTopDict.prototype = Object.create(CFFDict.prototype);
        return CFFTopDict;
      }();
      var CFFPrivateDict = function CFFPrivateDictClosure() {
        var layout = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
        var tables = null;
        function CFFPrivateDict(strings) {
          if (tables === null) {
            tables = CFFDict.createTables(layout);
          }
          CFFDict.call(this, tables, strings);
          this.subrsIndex = null;
        }
        CFFPrivateDict.prototype = Object.create(CFFDict.prototype);
        return CFFPrivateDict;
      }();
      var CFFCharsetPredefinedTypes = {
        ISO_ADOBE: 0,
        EXPERT: 1,
        EXPERT_SUBSET: 2
      };
      var CFFCharset = function CFFCharsetClosure() {
        function CFFCharset(predefined, format, charset, raw) {
          this.predefined = predefined;
          this.format = format;
          this.charset = charset;
          this.raw = raw;
        }
        return CFFCharset;
      }();
      var CFFEncoding = function CFFEncodingClosure() {
        function CFFEncoding(predefined, format, encoding, raw) {
          this.predefined = predefined;
          this.format = format;
          this.encoding = encoding;
          this.raw = raw;
        }
        return CFFEncoding;
      }();
      var CFFFDSelect = function CFFFDSelectClosure() {
        function CFFFDSelect(fdSelect, raw) {
          this.fdSelect = fdSelect;
          this.raw = raw;
        }
        CFFFDSelect.prototype = {
          getFDIndex: function CFFFDSelect_get(glyphIndex) {
            if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) {
              return -1;
            }
            return this.fdSelect[glyphIndex];
          }
        };
        return CFFFDSelect;
      }();
      var CFFOffsetTracker = function CFFOffsetTrackerClosure() {
        function CFFOffsetTracker() {
          this.offsets = Object.create(null);
        }
        CFFOffsetTracker.prototype = {
          isTracking: function CFFOffsetTracker_isTracking(key) {
            return key in this.offsets;
          },
          track: function CFFOffsetTracker_track(key, location) {
            if (key in this.offsets) {
              throw new _util.FormatError("Already tracking location of " + key);
            }
            this.offsets[key] = location;
          },
          offset: function CFFOffsetTracker_offset(value) {
            for (var key in this.offsets) {
              this.offsets[key] += value;
            }
          },
          setEntryLocation: function CFFOffsetTracker_setEntryLocation(key, values, output) {
            if (!(key in this.offsets)) {
              throw new _util.FormatError("Not tracking location of " + key);
            }
            var data = output.data;
            var dataOffset = this.offsets[key];
            var size = 5;
            for (var i = 0, ii = values.length; i < ii; ++i) {
              var offset0 = i * size + dataOffset;
              var offset1 = offset0 + 1;
              var offset2 = offset0 + 2;
              var offset3 = offset0 + 3;
              var offset4 = offset0 + 4;
              if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) {
                throw new _util.FormatError("writing to an offset that is not empty");
              }
              var value = values[i];
              data[offset0] = 0x1d;
              data[offset1] = value >> 24 & 0xFF;
              data[offset2] = value >> 16 & 0xFF;
              data[offset3] = value >> 8 & 0xFF;
              data[offset4] = value & 0xFF;
            }
          }
        };
        return CFFOffsetTracker;
      }();
      var CFFCompiler = function CFFCompilerClosure() {
        function CFFCompiler(cff) {
          this.cff = cff;
        }
        CFFCompiler.prototype = {
          compile: function CFFCompiler_compile() {
            var cff = this.cff;
            var output = {
              data: [],
              length: 0,
              add: function CFFCompiler_add(data) {
                this.data = this.data.concat(data);
                this.length = this.data.length;
              }
            };
            var header = this.compileHeader(cff.header);
            output.add(header);
            var nameIndex = this.compileNameIndex(cff.names);
            output.add(nameIndex);
            if (cff.isCIDFont) {
              if (cff.topDict.hasName("FontMatrix")) {
                var base = cff.topDict.getByName("FontMatrix");
                cff.topDict.removeByName("FontMatrix");
                for (var i = 0, ii = cff.fdArray.length; i < ii; i++) {
                  var subDict = cff.fdArray[i];
                  var matrix = base.slice(0);
                  if (subDict.hasName("FontMatrix")) {
                    matrix = _util.Util.transform(matrix, subDict.getByName("FontMatrix"));
                  }
                  subDict.setByName("FontMatrix", matrix);
                }
              }
            }
            var compiled = this.compileTopDicts([cff.topDict], output.length, cff.isCIDFont);
            output.add(compiled.output);
            var topDictTracker = compiled.trackers[0];
            var stringIndex = this.compileStringIndex(cff.strings.strings);
            output.add(stringIndex);
            var globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
            output.add(globalSubrIndex);
            if (cff.encoding && cff.topDict.hasName("Encoding")) {
              if (cff.encoding.predefined) {
                topDictTracker.setEntryLocation("Encoding", [cff.encoding.format], output);
              } else {
                var encoding = this.compileEncoding(cff.encoding);
                topDictTracker.setEntryLocation("Encoding", [output.length], output);
                output.add(encoding);
              }
            }
            if (cff.charset && cff.topDict.hasName("charset")) {
              if (cff.charset.predefined) {
                topDictTracker.setEntryLocation("charset", [cff.charset.format], output);
              } else {
                var charset = this.compileCharset(cff.charset);
                topDictTracker.setEntryLocation("charset", [output.length], output);
                output.add(charset);
              }
            }
            var charStrings = this.compileCharStrings(cff.charStrings);
            topDictTracker.setEntryLocation("CharStrings", [output.length], output);
            output.add(charStrings);
            if (cff.isCIDFont) {
              topDictTracker.setEntryLocation("FDSelect", [output.length], output);
              var fdSelect = this.compileFDSelect(cff.fdSelect.raw);
              output.add(fdSelect);
              compiled = this.compileTopDicts(cff.fdArray, output.length, true);
              topDictTracker.setEntryLocation("FDArray", [output.length], output);
              output.add(compiled.output);
              var fontDictTrackers = compiled.trackers;
              this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
            }
            this.compilePrivateDicts([cff.topDict], [topDictTracker], output);
            output.add([0]);
            return output.data;
          },
          encodeNumber: function CFFCompiler_encodeNumber(value) {
            if (parseFloat(value) === parseInt(value, 10) && !isNaN(value)) {
              return this.encodeInteger(value);
            }
            return this.encodeFloat(value);
          },
          encodeFloat: function CFFCompiler_encodeFloat(num) {
            var value = num.toString();
            var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
            if (m) {
              var epsilon = parseFloat("1e" + ((m[2] ? +m[2] : 0) + m[1].length));
              value = (Math.round(num * epsilon) / epsilon).toString();
            }
            var nibbles = "";
            var i, ii;
            for (i = 0, ii = value.length; i < ii; ++i) {
              var a = value[i];
              if (a === "e") {
                nibbles += value[++i] === "-" ? "c" : "b";
              } else if (a === ".") {
                nibbles += "a";
              } else if (a === "-") {
                nibbles += "e";
              } else {
                nibbles += a;
              }
            }
            nibbles += nibbles.length & 1 ? "f" : "ff";
            var out = [30];
            for (i = 0, ii = nibbles.length; i < ii; i += 2) {
              out.push(parseInt(nibbles.substr(i, 2), 16));
            }
            return out;
          },
          encodeInteger: function CFFCompiler_encodeInteger(value) {
            var code;
            if (value >= -107 && value <= 107) {
              code = [value + 139];
            } else if (value >= 108 && value <= 1131) {
              value = value - 108;
              code = [(value >> 8) + 247, value & 0xFF];
            } else if (value >= -1131 && value <= -108) {
              value = -value - 108;
              code = [(value >> 8) + 251, value & 0xFF];
            } else if (value >= -32768 && value <= 32767) {
              code = [0x1c, value >> 8 & 0xFF, value & 0xFF];
            } else {
              code = [0x1d, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF];
            }
            return code;
          },
          compileHeader: function CFFCompiler_compileHeader(header) {
            return [header.major, header.minor, header.hdrSize, header.offSize];
          },
          compileNameIndex: function CFFCompiler_compileNameIndex(names) {
            var nameIndex = new CFFIndex();
            for (var i = 0, ii = names.length; i < ii; ++i) {
              var name = names[i];
              var length = Math.min(name.length, 127);
              var sanitizedName = new Array(length);
              for (var j = 0; j < length; j++) {
                var char = name[j];
                if (char < "!" || char > "~" || char === "[" || char === "]" || char === "(" || char === ")" || char === "{" || char === "}" || char === "<" || char === ">" || char === "/" || char === "%") {
                  char = "_";
                }
                sanitizedName[j] = char;
              }
              sanitizedName = sanitizedName.join("");
              if (sanitizedName === "") {
                sanitizedName = "Bad_Font_Name";
              }
              nameIndex.add((0, _util.stringToBytes)(sanitizedName));
            }
            return this.compileIndex(nameIndex);
          },
          compileTopDicts: function CFFCompiler_compileTopDicts(dicts, length, removeCidKeys) {
            var fontDictTrackers = [];
            var fdArrayIndex = new CFFIndex();
            for (var i = 0, ii = dicts.length; i < ii; ++i) {
              var fontDict = dicts[i];
              if (removeCidKeys) {
                fontDict.removeByName("CIDFontVersion");
                fontDict.removeByName("CIDFontRevision");
                fontDict.removeByName("CIDFontType");
                fontDict.removeByName("CIDCount");
                fontDict.removeByName("UIDBase");
              }
              var fontDictTracker = new CFFOffsetTracker();
              var fontDictData = this.compileDict(fontDict, fontDictTracker);
              fontDictTrackers.push(fontDictTracker);
              fdArrayIndex.add(fontDictData);
              fontDictTracker.offset(length);
            }
            fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
            return {
              trackers: fontDictTrackers,
              output: fdArrayIndex
            };
          },
          compilePrivateDicts: function CFFCompiler_compilePrivateDicts(dicts, trackers, output) {
            for (var i = 0, ii = dicts.length; i < ii; ++i) {
              var fontDict = dicts[i];
              var privateDict = fontDict.privateDict;
              if (!privateDict || !fontDict.hasName("Private")) {
                throw new _util.FormatError("There must be a private dictionary.");
              }
              var privateDictTracker = new CFFOffsetTracker();
              var privateDictData = this.compileDict(privateDict, privateDictTracker);
              var outputLength = output.length;
              privateDictTracker.offset(outputLength);
              if (!privateDictData.length) {
                outputLength = 0;
              }
              trackers[i].setEntryLocation("Private", [privateDictData.length, outputLength], output);
              output.add(privateDictData);
              if (privateDict.subrsIndex && privateDict.hasName("Subrs")) {
                var subrs = this.compileIndex(privateDict.subrsIndex);
                privateDictTracker.setEntryLocation("Subrs", [privateDictData.length], output);
                output.add(subrs);
              }
            }
          },
          compileDict: function CFFCompiler_compileDict(dict, offsetTracker) {
            var out = [];
            var order = dict.order;
            for (var i = 0; i < order.length; ++i) {
              var key = order[i];
              if (!(key in dict.values)) {
                continue;
              }
              var values = dict.values[key];
              var types = dict.types[key];
              if (!Array.isArray(types)) {
                types = [types];
              }
              if (!Array.isArray(values)) {
                values = [values];
              }
              if (values.length === 0) {
                continue;
              }
              for (var j = 0, jj = types.length; j < jj; ++j) {
                var type = types[j];
                var value = values[j];
                switch (type) {
                  case "num":
                  case "sid":
                    out = out.concat(this.encodeNumber(value));
                    break;
                  case "offset":
                    var name = dict.keyToNameMap[key];
                    if (!offsetTracker.isTracking(name)) {
                      offsetTracker.track(name, out.length);
                    }
                    out = out.concat([0x1d, 0, 0, 0, 0]);
                    break;
                  case "array":
                  case "delta":
                    out = out.concat(this.encodeNumber(value));
                    for (var k = 1, kk = values.length; k < kk; ++k) {
                      out = out.concat(this.encodeNumber(values[k]));
                    }
                    break;
                  default:
                    throw new _util.FormatError("Unknown data type of " + type);
                }
              }
              out = out.concat(dict.opcodes[key]);
            }
            return out;
          },
          compileStringIndex: function CFFCompiler_compileStringIndex(strings) {
            var stringIndex = new CFFIndex();
            for (var i = 0, ii = strings.length; i < ii; ++i) {
              stringIndex.add((0, _util.stringToBytes)(strings[i]));
            }
            return this.compileIndex(stringIndex);
          },
          compileGlobalSubrIndex: function CFFCompiler_compileGlobalSubrIndex() {
            var globalSubrIndex = this.cff.globalSubrIndex;
            this.out.writeByteArray(this.compileIndex(globalSubrIndex));
          },
          compileCharStrings: function CFFCompiler_compileCharStrings(charStrings) {
            return this.compileIndex(charStrings);
          },
          compileCharset: function CFFCompiler_compileCharset(charset) {
            return this.compileTypedArray(charset.raw);
          },
          compileEncoding: function CFFCompiler_compileEncoding(encoding) {
            return this.compileTypedArray(encoding.raw);
          },
          compileFDSelect: function CFFCompiler_compileFDSelect(fdSelect) {
            return this.compileTypedArray(fdSelect);
          },
          compileTypedArray: function CFFCompiler_compileTypedArray(data) {
            var out = [];
            for (var i = 0, ii = data.length; i < ii; ++i) {
              out[i] = data[i];
            }
            return out;
          },
          compileIndex: function CFFCompiler_compileIndex(index, trackers) {
            trackers = trackers || [];
            var objects = index.objects;
            var count = objects.length;
            if (count === 0) {
              return [0, 0, 0];
            }
            var data = [count >> 8 & 0xFF, count & 0xff];
            var lastOffset = 1,
              i;
            for (i = 0; i < count; ++i) {
              lastOffset += objects[i].length;
            }
            var offsetSize;
            if (lastOffset < 0x100) {
              offsetSize = 1;
            } else if (lastOffset < 0x10000) {
              offsetSize = 2;
            } else if (lastOffset < 0x1000000) {
              offsetSize = 3;
            } else {
              offsetSize = 4;
            }
            data.push(offsetSize);
            var relativeOffset = 1;
            for (i = 0; i < count + 1; i++) {
              if (offsetSize === 1) {
                data.push(relativeOffset & 0xFF);
              } else if (offsetSize === 2) {
                data.push(relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
              } else if (offsetSize === 3) {
                data.push(relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
              } else {
                data.push(relativeOffset >>> 24 & 0xFF, relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
              }
              if (objects[i]) {
                relativeOffset += objects[i].length;
              }
            }
            for (i = 0; i < count; i++) {
              if (trackers[i]) {
                trackers[i].offset(data.length);
              }
              for (var j = 0, jj = objects[i].length; j < jj; j++) {
                data.push(objects[i][j]);
              }
            }
            return data;
          }
        };
        return CFFCompiler;
      }();
      exports.CFFStandardStrings = CFFStandardStrings;
      exports.CFFParser = CFFParser;
      exports.CFF = CFF;
      exports.CFFHeader = CFFHeader;
      exports.CFFStrings = CFFStrings;
      exports.CFFIndex = CFFIndex;
      exports.CFFCharset = CFFCharset;
      exports.CFFTopDict = CFFTopDict;
      exports.CFFPrivateDict = CFFPrivateDict;
      exports.CFFCompiler = CFFCompiler;

      /***/ }),
    /* 79 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getSupplementalGlyphMapForArialBlack = exports.getGlyphMapForStandardFonts = exports.getSymbolsFonts = exports.getSerifFonts = exports.getNonStdFontMap = exports.getStdFontMap = undefined;

      var _util = __w_pdfjs_require__(0);

      var getStdFontMap = (0, _util.getLookupTableFactory)(function (t) {
        t["ArialNarrow"] = "Helvetica";
        t["ArialNarrow-Bold"] = "Helvetica-Bold";
        t["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
        t["ArialNarrow-Italic"] = "Helvetica-Oblique";
        t["ArialBlack"] = "Helvetica";
        t["ArialBlack-Bold"] = "Helvetica-Bold";
        t["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
        t["ArialBlack-Italic"] = "Helvetica-Oblique";
        t["Arial-Black"] = "Helvetica";
        t["Arial-Black-Bold"] = "Helvetica-Bold";
        t["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
        t["Arial-Black-Italic"] = "Helvetica-Oblique";
        t["Arial"] = "Helvetica";
        t["Arial-Bold"] = "Helvetica-Bold";
        t["Arial-BoldItalic"] = "Helvetica-BoldOblique";
        t["Arial-Italic"] = "Helvetica-Oblique";
        t["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
        t["Arial-BoldMT"] = "Helvetica-Bold";
        t["Arial-ItalicMT"] = "Helvetica-Oblique";
        t["ArialMT"] = "Helvetica";
        t["Courier-Bold"] = "Courier-Bold";
        t["Courier-BoldItalic"] = "Courier-BoldOblique";
        t["Courier-Italic"] = "Courier-Oblique";
        t["CourierNew"] = "Courier";
        t["CourierNew-Bold"] = "Courier-Bold";
        t["CourierNew-BoldItalic"] = "Courier-BoldOblique";
        t["CourierNew-Italic"] = "Courier-Oblique";
        t["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
        t["CourierNewPS-BoldMT"] = "Courier-Bold";
        t["CourierNewPS-ItalicMT"] = "Courier-Oblique";
        t["CourierNewPSMT"] = "Courier";
        t["Helvetica"] = "Helvetica";
        t["Helvetica-Bold"] = "Helvetica-Bold";
        t["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
        t["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
        t["Helvetica-Italic"] = "Helvetica-Oblique";
        t["Helvetica-Oblique"] = "Helvetica-Oblique";
        t["SegoeUISymbol"] = "Helvetica";
        t["Symbol-Bold"] = "Symbol";
        t["Symbol-BoldItalic"] = "Symbol";
        t["Symbol-Italic"] = "Symbol";
        t["TimesNewRoman"] = "Times-Roman";
        t["TimesNewRoman-Bold"] = "Times-Bold";
        t["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
        t["TimesNewRoman-Italic"] = "Times-Italic";
        t["TimesNewRomanPS"] = "Times-Roman";
        t["TimesNewRomanPS-Bold"] = "Times-Bold";
        t["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
        t["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
        t["TimesNewRomanPS-BoldMT"] = "Times-Bold";
        t["TimesNewRomanPS-Italic"] = "Times-Italic";
        t["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
        t["TimesNewRomanPSMT"] = "Times-Roman";
        t["TimesNewRomanPSMT-Bold"] = "Times-Bold";
        t["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
        t["TimesNewRomanPSMT-Italic"] = "Times-Italic";
      });
      var getNonStdFontMap = (0, _util.getLookupTableFactory)(function (t) {
        t["CenturyGothic"] = "Helvetica";
        t["CenturyGothic-Bold"] = "Helvetica-Bold";
        t["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
        t["CenturyGothic-Italic"] = "Helvetica-Oblique";
        t["ComicSansMS"] = "Comic Sans MS";
        t["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
        t["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
        t["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
        t["LucidaConsole"] = "Courier";
        t["LucidaConsole-Bold"] = "Courier-Bold";
        t["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
        t["LucidaConsole-Italic"] = "Courier-Oblique";
        t["MS-Gothic"] = "MS Gothic";
        t["MS-Gothic-Bold"] = "MS Gothic-Bold";
        t["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
        t["MS-Gothic-Italic"] = "MS Gothic-Italic";
        t["MS-Mincho"] = "MS Mincho";
        t["MS-Mincho-Bold"] = "MS Mincho-Bold";
        t["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
        t["MS-Mincho-Italic"] = "MS Mincho-Italic";
        t["MS-PGothic"] = "MS PGothic";
        t["MS-PGothic-Bold"] = "MS PGothic-Bold";
        t["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
        t["MS-PGothic-Italic"] = "MS PGothic-Italic";
        t["MS-PMincho"] = "MS PMincho";
        t["MS-PMincho-Bold"] = "MS PMincho-Bold";
        t["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
        t["MS-PMincho-Italic"] = "MS PMincho-Italic";
        t["NuptialScript"] = "Times-Italic";
        t["Wingdings"] = "ZapfDingbats";
      });
      var getSerifFonts = (0, _util.getLookupTableFactory)(function (t) {
        t["Adobe Jenson"] = true;
        t["Adobe Text"] = true;
        t["Albertus"] = true;
        t["Aldus"] = true;
        t["Alexandria"] = true;
        t["Algerian"] = true;
        t["American Typewriter"] = true;
        t["Antiqua"] = true;
        t["Apex"] = true;
        t["Arno"] = true;
        t["Aster"] = true;
        t["Aurora"] = true;
        t["Baskerville"] = true;
        t["Bell"] = true;
        t["Bembo"] = true;
        t["Bembo Schoolbook"] = true;
        t["Benguiat"] = true;
        t["Berkeley Old Style"] = true;
        t["Bernhard Modern"] = true;
        t["Berthold City"] = true;
        t["Bodoni"] = true;
        t["Bauer Bodoni"] = true;
        t["Book Antiqua"] = true;
        t["Bookman"] = true;
        t["Bordeaux Roman"] = true;
        t["Californian FB"] = true;
        t["Calisto"] = true;
        t["Calvert"] = true;
        t["Capitals"] = true;
        t["Cambria"] = true;
        t["Cartier"] = true;
        t["Caslon"] = true;
        t["Catull"] = true;
        t["Centaur"] = true;
        t["Century Old Style"] = true;
        t["Century Schoolbook"] = true;
        t["Chaparral"] = true;
        t["Charis SIL"] = true;
        t["Cheltenham"] = true;
        t["Cholla Slab"] = true;
        t["Clarendon"] = true;
        t["Clearface"] = true;
        t["Cochin"] = true;
        t["Colonna"] = true;
        t["Computer Modern"] = true;
        t["Concrete Roman"] = true;
        t["Constantia"] = true;
        t["Cooper Black"] = true;
        t["Corona"] = true;
        t["Ecotype"] = true;
        t["Egyptienne"] = true;
        t["Elephant"] = true;
        t["Excelsior"] = true;
        t["Fairfield"] = true;
        t["FF Scala"] = true;
        t["Folkard"] = true;
        t["Footlight"] = true;
        t["FreeSerif"] = true;
        t["Friz Quadrata"] = true;
        t["Garamond"] = true;
        t["Gentium"] = true;
        t["Georgia"] = true;
        t["Gloucester"] = true;
        t["Goudy Old Style"] = true;
        t["Goudy Schoolbook"] = true;
        t["Goudy Pro Font"] = true;
        t["Granjon"] = true;
        t["Guardian Egyptian"] = true;
        t["Heather"] = true;
        t["Hercules"] = true;
        t["High Tower Text"] = true;
        t["Hiroshige"] = true;
        t["Hoefler Text"] = true;
        t["Humana Serif"] = true;
        t["Imprint"] = true;
        t["Ionic No. 5"] = true;
        t["Janson"] = true;
        t["Joanna"] = true;
        t["Korinna"] = true;
        t["Lexicon"] = true;
        t["Liberation Serif"] = true;
        t["Linux Libertine"] = true;
        t["Literaturnaya"] = true;
        t["Lucida"] = true;
        t["Lucida Bright"] = true;
        t["Melior"] = true;
        t["Memphis"] = true;
        t["Miller"] = true;
        t["Minion"] = true;
        t["Modern"] = true;
        t["Mona Lisa"] = true;
        t["Mrs Eaves"] = true;
        t["MS Serif"] = true;
        t["Museo Slab"] = true;
        t["New York"] = true;
        t["Nimbus Roman"] = true;
        t["NPS Rawlinson Roadway"] = true;
        t["NuptialScript"] = true;
        t["Palatino"] = true;
        t["Perpetua"] = true;
        t["Plantin"] = true;
        t["Plantin Schoolbook"] = true;
        t["Playbill"] = true;
        t["Poor Richard"] = true;
        t["Rawlinson Roadway"] = true;
        t["Renault"] = true;
        t["Requiem"] = true;
        t["Rockwell"] = true;
        t["Roman"] = true;
        t["Rotis Serif"] = true;
        t["Sabon"] = true;
        t["Scala"] = true;
        t["Seagull"] = true;
        t["Sistina"] = true;
        t["Souvenir"] = true;
        t["STIX"] = true;
        t["Stone Informal"] = true;
        t["Stone Serif"] = true;
        t["Sylfaen"] = true;
        t["Times"] = true;
        t["Trajan"] = true;
        t["Trinité"] = true;
        t["Trump Mediaeval"] = true;
        t["Utopia"] = true;
        t["Vale Type"] = true;
        t["Bitstream Vera"] = true;
        t["Vera Serif"] = true;
        t["Versailles"] = true;
        t["Wanted"] = true;
        t["Weiss"] = true;
        t["Wide Latin"] = true;
        t["Windsor"] = true;
        t["XITS"] = true;
      });
      var getSymbolsFonts = (0, _util.getLookupTableFactory)(function (t) {
        t["Dingbats"] = true;
        t["Symbol"] = true;
        t["ZapfDingbats"] = true;
      });
      var getGlyphMapForStandardFonts = (0, _util.getLookupTableFactory)(function (t) {
        t[2] = 10;
        t[3] = 32;
        t[4] = 33;
        t[5] = 34;
        t[6] = 35;
        t[7] = 36;
        t[8] = 37;
        t[9] = 38;
        t[10] = 39;
        t[11] = 40;
        t[12] = 41;
        t[13] = 42;
        t[14] = 43;
        t[15] = 44;
        t[16] = 45;
        t[17] = 46;
        t[18] = 47;
        t[19] = 48;
        t[20] = 49;
        t[21] = 50;
        t[22] = 51;
        t[23] = 52;
        t[24] = 53;
        t[25] = 54;
        t[26] = 55;
        t[27] = 56;
        t[28] = 57;
        t[29] = 58;
        t[30] = 894;
        t[31] = 60;
        t[32] = 61;
        t[33] = 62;
        t[34] = 63;
        t[35] = 64;
        t[36] = 65;
        t[37] = 66;
        t[38] = 67;
        t[39] = 68;
        t[40] = 69;
        t[41] = 70;
        t[42] = 71;
        t[43] = 72;
        t[44] = 73;
        t[45] = 74;
        t[46] = 75;
        t[47] = 76;
        t[48] = 77;
        t[49] = 78;
        t[50] = 79;
        t[51] = 80;
        t[52] = 81;
        t[53] = 82;
        t[54] = 83;
        t[55] = 84;
        t[56] = 85;
        t[57] = 86;
        t[58] = 87;
        t[59] = 88;
        t[60] = 89;
        t[61] = 90;
        t[62] = 91;
        t[63] = 92;
        t[64] = 93;
        t[65] = 94;
        t[66] = 95;
        t[67] = 96;
        t[68] = 97;
        t[69] = 98;
        t[70] = 99;
        t[71] = 100;
        t[72] = 101;
        t[73] = 102;
        t[74] = 103;
        t[75] = 104;
        t[76] = 105;
        t[77] = 106;
        t[78] = 107;
        t[79] = 108;
        t[80] = 109;
        t[81] = 110;
        t[82] = 111;
        t[83] = 112;
        t[84] = 113;
        t[85] = 114;
        t[86] = 115;
        t[87] = 116;
        t[88] = 117;
        t[89] = 118;
        t[90] = 119;
        t[91] = 120;
        t[92] = 121;
        t[93] = 122;
        t[94] = 123;
        t[95] = 124;
        t[96] = 125;
        t[97] = 126;
        t[98] = 196;
        t[99] = 197;
        t[100] = 199;
        t[101] = 201;
        t[102] = 209;
        t[103] = 214;
        t[104] = 220;
        t[105] = 225;
        t[106] = 224;
        t[107] = 226;
        t[108] = 228;
        t[109] = 227;
        t[110] = 229;
        t[111] = 231;
        t[112] = 233;
        t[113] = 232;
        t[114] = 234;
        t[115] = 235;
        t[116] = 237;
        t[117] = 236;
        t[118] = 238;
        t[119] = 239;
        t[120] = 241;
        t[121] = 243;
        t[122] = 242;
        t[123] = 244;
        t[124] = 246;
        t[125] = 245;
        t[126] = 250;
        t[127] = 249;
        t[128] = 251;
        t[129] = 252;
        t[130] = 8224;
        t[131] = 176;
        t[132] = 162;
        t[133] = 163;
        t[134] = 167;
        t[135] = 8226;
        t[136] = 182;
        t[137] = 223;
        t[138] = 174;
        t[139] = 169;
        t[140] = 8482;
        t[141] = 180;
        t[142] = 168;
        t[143] = 8800;
        t[144] = 198;
        t[145] = 216;
        t[146] = 8734;
        t[147] = 177;
        t[148] = 8804;
        t[149] = 8805;
        t[150] = 165;
        t[151] = 181;
        t[152] = 8706;
        t[153] = 8721;
        t[154] = 8719;
        t[156] = 8747;
        t[157] = 170;
        t[158] = 186;
        t[159] = 8486;
        t[160] = 230;
        t[161] = 248;
        t[162] = 191;
        t[163] = 161;
        t[164] = 172;
        t[165] = 8730;
        t[166] = 402;
        t[167] = 8776;
        t[168] = 8710;
        t[169] = 171;
        t[170] = 187;
        t[171] = 8230;
        t[210] = 218;
        t[223] = 711;
        t[224] = 321;
        t[225] = 322;
        t[227] = 353;
        t[229] = 382;
        t[234] = 253;
        t[252] = 263;
        t[253] = 268;
        t[254] = 269;
        t[258] = 258;
        t[260] = 260;
        t[261] = 261;
        t[265] = 280;
        t[266] = 281;
        t[268] = 283;
        t[269] = 313;
        t[275] = 323;
        t[276] = 324;
        t[278] = 328;
        t[284] = 345;
        t[285] = 346;
        t[286] = 347;
        t[292] = 367;
        t[295] = 377;
        t[296] = 378;
        t[298] = 380;
        t[305] = 963;
        t[306] = 964;
        t[307] = 966;
        t[308] = 8215;
        t[309] = 8252;
        t[310] = 8319;
        t[311] = 8359;
        t[312] = 8592;
        t[313] = 8593;
        t[337] = 9552;
        t[493] = 1039;
        t[494] = 1040;
        t[705] = 1524;
        t[706] = 8362;
        t[710] = 64288;
        t[711] = 64298;
        t[759] = 1617;
        t[761] = 1776;
        t[763] = 1778;
        t[775] = 1652;
        t[777] = 1764;
        t[778] = 1780;
        t[779] = 1781;
        t[780] = 1782;
        t[782] = 771;
        t[783] = 64726;
        t[786] = 8363;
        t[788] = 8532;
        t[790] = 768;
        t[791] = 769;
        t[792] = 768;
        t[795] = 803;
        t[797] = 64336;
        t[798] = 64337;
        t[799] = 64342;
        t[800] = 64343;
        t[801] = 64344;
        t[802] = 64345;
        t[803] = 64362;
        t[804] = 64363;
        t[805] = 64364;
        t[2424] = 7821;
        t[2425] = 7822;
        t[2426] = 7823;
        t[2427] = 7824;
        t[2428] = 7825;
        t[2429] = 7826;
        t[2430] = 7827;
        t[2433] = 7682;
        t[2678] = 8045;
        t[2679] = 8046;
        t[2830] = 1552;
        t[2838] = 686;
        t[2840] = 751;
        t[2842] = 753;
        t[2843] = 754;
        t[2844] = 755;
        t[2846] = 757;
        t[2856] = 767;
        t[2857] = 848;
        t[2858] = 849;
        t[2862] = 853;
        t[2863] = 854;
        t[2864] = 855;
        t[2865] = 861;
        t[2866] = 862;
        t[2906] = 7460;
        t[2908] = 7462;
        t[2909] = 7463;
        t[2910] = 7464;
        t[2912] = 7466;
        t[2913] = 7467;
        t[2914] = 7468;
        t[2916] = 7470;
        t[2917] = 7471;
        t[2918] = 7472;
        t[2920] = 7474;
        t[2921] = 7475;
        t[2922] = 7476;
        t[2924] = 7478;
        t[2925] = 7479;
        t[2926] = 7480;
        t[2928] = 7482;
        t[2929] = 7483;
        t[2930] = 7484;
        t[2932] = 7486;
        t[2933] = 7487;
        t[2934] = 7488;
        t[2936] = 7490;
        t[2937] = 7491;
        t[2938] = 7492;
        t[2940] = 7494;
        t[2941] = 7495;
        t[2942] = 7496;
        t[2944] = 7498;
        t[2946] = 7500;
        t[2948] = 7502;
        t[2950] = 7504;
        t[2951] = 7505;
        t[2952] = 7506;
        t[2954] = 7508;
        t[2955] = 7509;
        t[2956] = 7510;
        t[2958] = 7512;
        t[2959] = 7513;
        t[2960] = 7514;
        t[2962] = 7516;
        t[2963] = 7517;
        t[2964] = 7518;
        t[2966] = 7520;
        t[2967] = 7521;
        t[2968] = 7522;
        t[2970] = 7524;
        t[2971] = 7525;
        t[2972] = 7526;
        t[2974] = 7528;
        t[2975] = 7529;
        t[2976] = 7530;
        t[2978] = 1537;
        t[2979] = 1538;
        t[2980] = 1539;
        t[2982] = 1549;
        t[2983] = 1551;
        t[2984] = 1552;
        t[2986] = 1554;
        t[2987] = 1555;
        t[2988] = 1556;
        t[2990] = 1623;
        t[2991] = 1624;
        t[2995] = 1775;
        t[2999] = 1791;
        t[3002] = 64290;
        t[3003] = 64291;
        t[3004] = 64292;
        t[3006] = 64294;
        t[3007] = 64295;
        t[3008] = 64296;
        t[3011] = 1900;
        t[3014] = 8223;
        t[3015] = 8244;
        t[3017] = 7532;
        t[3018] = 7533;
        t[3019] = 7534;
        t[3075] = 7590;
        t[3076] = 7591;
        t[3079] = 7594;
        t[3080] = 7595;
        t[3083] = 7598;
        t[3084] = 7599;
        t[3087] = 7602;
        t[3088] = 7603;
        t[3091] = 7606;
        t[3092] = 7607;
        t[3095] = 7610;
        t[3096] = 7611;
        t[3099] = 7614;
        t[3100] = 7615;
        t[3103] = 7618;
        t[3104] = 7619;
        t[3107] = 8337;
        t[3108] = 8338;
        t[3116] = 1884;
        t[3119] = 1885;
        t[3120] = 1885;
        t[3123] = 1886;
        t[3124] = 1886;
        t[3127] = 1887;
        t[3128] = 1887;
        t[3131] = 1888;
        t[3132] = 1888;
        t[3135] = 1889;
        t[3136] = 1889;
        t[3139] = 1890;
        t[3140] = 1890;
        t[3143] = 1891;
        t[3144] = 1891;
        t[3147] = 1892;
        t[3148] = 1892;
        t[3153] = 580;
        t[3154] = 581;
        t[3157] = 584;
        t[3158] = 585;
        t[3161] = 588;
        t[3162] = 589;
        t[3165] = 891;
        t[3166] = 892;
        t[3169] = 1274;
        t[3170] = 1275;
        t[3173] = 1278;
        t[3174] = 1279;
        t[3181] = 7622;
        t[3182] = 7623;
        t[3282] = 11799;
        t[3316] = 578;
        t[3379] = 42785;
        t[3393] = 1159;
        t[3416] = 8377;
      });
      var getSupplementalGlyphMapForArialBlack = (0, _util.getLookupTableFactory)(function (t) {
        t[227] = 322;
        t[264] = 261;
        t[291] = 346;
      });
      exports.getStdFontMap = getStdFontMap;
      exports.getNonStdFontMap = getNonStdFontMap;
      exports.getSerifFonts = getSerifFonts;
      exports.getSymbolsFonts = getSymbolsFonts;
      exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
      exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;

      /***/ }),
    /* 80 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var getLookupTableFactory = __w_pdfjs_require__(0).getLookupTableFactory;
      var getSpecialPUASymbols = getLookupTableFactory(function (t) {
        t[63721] = 0x00A9;
        t[63193] = 0x00A9;
        t[63720] = 0x00AE;
        t[63194] = 0x00AE;
        t[63722] = 0x2122;
        t[63195] = 0x2122;
        t[63729] = 0x23A7;
        t[63730] = 0x23A8;
        t[63731] = 0x23A9;
        t[63740] = 0x23AB;
        t[63741] = 0x23AC;
        t[63742] = 0x23AD;
        t[63726] = 0x23A1;
        t[63727] = 0x23A2;
        t[63728] = 0x23A3;
        t[63737] = 0x23A4;
        t[63738] = 0x23A5;
        t[63739] = 0x23A6;
        t[63723] = 0x239B;
        t[63724] = 0x239C;
        t[63725] = 0x239D;
        t[63734] = 0x239E;
        t[63735] = 0x239F;
        t[63736] = 0x23A0;
      });
      function mapSpecialUnicodeValues(code) {
        if (code >= 0xFFF0 && code <= 0xFFFF) {
          return 0;
        } else if (code >= 0xF600 && code <= 0xF8FF) {
          return getSpecialPUASymbols()[code] || code;
        } else if (code === 0x00AD) {
          return 0x002D;
        }
        return code;
      }
      function getUnicodeForGlyph(name, glyphsUnicodeMap) {
        var unicode = glyphsUnicodeMap[name];
        if (unicode !== undefined) {
          return unicode;
        }
        if (!name) {
          return -1;
        }
        if (name[0] === "u") {
          var nameLen = name.length,
            hexStr;
          if (nameLen === 7 && name[1] === "n" && name[2] === "i") {
            hexStr = name.substr(3);
          } else if (nameLen >= 5 && nameLen <= 7) {
            hexStr = name.substr(1);
          } else {
            return -1;
          }
          if (hexStr === hexStr.toUpperCase()) {
            unicode = parseInt(hexStr, 16);
            if (unicode >= 0) {
              return unicode;
            }
          }
        }
        return -1;
      }
      var UnicodeRanges = [{
        "begin": 0x0000,
        "end": 0x007F
      }, {
        "begin": 0x0080,
        "end": 0x00FF
      }, {
        "begin": 0x0100,
        "end": 0x017F
      }, {
        "begin": 0x0180,
        "end": 0x024F
      }, {
        "begin": 0x0250,
        "end": 0x02AF
      }, {
        "begin": 0x02B0,
        "end": 0x02FF
      }, {
        "begin": 0x0300,
        "end": 0x036F
      }, {
        "begin": 0x0370,
        "end": 0x03FF
      }, {
        "begin": 0x2C80,
        "end": 0x2CFF
      }, {
        "begin": 0x0400,
        "end": 0x04FF
      }, {
        "begin": 0x0530,
        "end": 0x058F
      }, {
        "begin": 0x0590,
        "end": 0x05FF
      }, {
        "begin": 0xA500,
        "end": 0xA63F
      }, {
        "begin": 0x0600,
        "end": 0x06FF
      }, {
        "begin": 0x07C0,
        "end": 0x07FF
      }, {
        "begin": 0x0900,
        "end": 0x097F
      }, {
        "begin": 0x0980,
        "end": 0x09FF
      }, {
        "begin": 0x0A00,
        "end": 0x0A7F
      }, {
        "begin": 0x0A80,
        "end": 0x0AFF
      }, {
        "begin": 0x0B00,
        "end": 0x0B7F
      }, {
        "begin": 0x0B80,
        "end": 0x0BFF
      }, {
        "begin": 0x0C00,
        "end": 0x0C7F
      }, {
        "begin": 0x0C80,
        "end": 0x0CFF
      }, {
        "begin": 0x0D00,
        "end": 0x0D7F
      }, {
        "begin": 0x0E00,
        "end": 0x0E7F
      }, {
        "begin": 0x0E80,
        "end": 0x0EFF
      }, {
        "begin": 0x10A0,
        "end": 0x10FF
      }, {
        "begin": 0x1B00,
        "end": 0x1B7F
      }, {
        "begin": 0x1100,
        "end": 0x11FF
      }, {
        "begin": 0x1E00,
        "end": 0x1EFF
      }, {
        "begin": 0x1F00,
        "end": 0x1FFF
      }, {
        "begin": 0x2000,
        "end": 0x206F
      }, {
        "begin": 0x2070,
        "end": 0x209F
      }, {
        "begin": 0x20A0,
        "end": 0x20CF
      }, {
        "begin": 0x20D0,
        "end": 0x20FF
      }, {
        "begin": 0x2100,
        "end": 0x214F
      }, {
        "begin": 0x2150,
        "end": 0x218F
      }, {
        "begin": 0x2190,
        "end": 0x21FF
      }, {
        "begin": 0x2200,
        "end": 0x22FF
      }, {
        "begin": 0x2300,
        "end": 0x23FF
      }, {
        "begin": 0x2400,
        "end": 0x243F
      }, {
        "begin": 0x2440,
        "end": 0x245F
      }, {
        "begin": 0x2460,
        "end": 0x24FF
      }, {
        "begin": 0x2500,
        "end": 0x257F
      }, {
        "begin": 0x2580,
        "end": 0x259F
      }, {
        "begin": 0x25A0,
        "end": 0x25FF
      }, {
        "begin": 0x2600,
        "end": 0x26FF
      }, {
        "begin": 0x2700,
        "end": 0x27BF
      }, {
        "begin": 0x3000,
        "end": 0x303F
      }, {
        "begin": 0x3040,
        "end": 0x309F
      }, {
        "begin": 0x30A0,
        "end": 0x30FF
      }, {
        "begin": 0x3100,
        "end": 0x312F
      }, {
        "begin": 0x3130,
        "end": 0x318F
      }, {
        "begin": 0xA840,
        "end": 0xA87F
      }, {
        "begin": 0x3200,
        "end": 0x32FF
      }, {
        "begin": 0x3300,
        "end": 0x33FF
      }, {
        "begin": 0xAC00,
        "end": 0xD7AF
      }, {
        "begin": 0xD800,
        "end": 0xDFFF
      }, {
        "begin": 0x10900,
        "end": 0x1091F
      }, {
        "begin": 0x4E00,
        "end": 0x9FFF
      }, {
        "begin": 0xE000,
        "end": 0xF8FF
      }, {
        "begin": 0x31C0,
        "end": 0x31EF
      }, {
        "begin": 0xFB00,
        "end": 0xFB4F
      }, {
        "begin": 0xFB50,
        "end": 0xFDFF
      }, {
        "begin": 0xFE20,
        "end": 0xFE2F
      }, {
        "begin": 0xFE10,
        "end": 0xFE1F
      }, {
        "begin": 0xFE50,
        "end": 0xFE6F
      }, {
        "begin": 0xFE70,
        "end": 0xFEFF
      }, {
        "begin": 0xFF00,
        "end": 0xFFEF
      }, {
        "begin": 0xFFF0,
        "end": 0xFFFF
      }, {
        "begin": 0x0F00,
        "end": 0x0FFF
      }, {
        "begin": 0x0700,
        "end": 0x074F
      }, {
        "begin": 0x0780,
        "end": 0x07BF
      }, {
        "begin": 0x0D80,
        "end": 0x0DFF
      }, {
        "begin": 0x1000,
        "end": 0x109F
      }, {
        "begin": 0x1200,
        "end": 0x137F
      }, {
        "begin": 0x13A0,
        "end": 0x13FF
      }, {
        "begin": 0x1400,
        "end": 0x167F
      }, {
        "begin": 0x1680,
        "end": 0x169F
      }, {
        "begin": 0x16A0,
        "end": 0x16FF
      }, {
        "begin": 0x1780,
        "end": 0x17FF
      }, {
        "begin": 0x1800,
        "end": 0x18AF
      }, {
        "begin": 0x2800,
        "end": 0x28FF
      }, {
        "begin": 0xA000,
        "end": 0xA48F
      }, {
        "begin": 0x1700,
        "end": 0x171F
      }, {
        "begin": 0x10300,
        "end": 0x1032F
      }, {
        "begin": 0x10330,
        "end": 0x1034F
      }, {
        "begin": 0x10400,
        "end": 0x1044F
      }, {
        "begin": 0x1D000,
        "end": 0x1D0FF
      }, {
        "begin": 0x1D400,
        "end": 0x1D7FF
      }, {
        "begin": 0xFF000,
        "end": 0xFFFFD
      }, {
        "begin": 0xFE00,
        "end": 0xFE0F
      }, {
        "begin": 0xE0000,
        "end": 0xE007F
      }, {
        "begin": 0x1900,
        "end": 0x194F
      }, {
        "begin": 0x1950,
        "end": 0x197F
      }, {
        "begin": 0x1980,
        "end": 0x19DF
      }, {
        "begin": 0x1A00,
        "end": 0x1A1F
      }, {
        "begin": 0x2C00,
        "end": 0x2C5F
      }, {
        "begin": 0x2D30,
        "end": 0x2D7F
      }, {
        "begin": 0x4DC0,
        "end": 0x4DFF
      }, {
        "begin": 0xA800,
        "end": 0xA82F
      }, {
        "begin": 0x10000,
        "end": 0x1007F
      }, {
        "begin": 0x10140,
        "end": 0x1018F
      }, {
        "begin": 0x10380,
        "end": 0x1039F
      }, {
        "begin": 0x103A0,
        "end": 0x103DF
      }, {
        "begin": 0x10450,
        "end": 0x1047F
      }, {
        "begin": 0x10480,
        "end": 0x104AF
      }, {
        "begin": 0x10800,
        "end": 0x1083F
      }, {
        "begin": 0x10A00,
        "end": 0x10A5F
      }, {
        "begin": 0x1D300,
        "end": 0x1D35F
      }, {
        "begin": 0x12000,
        "end": 0x123FF
      }, {
        "begin": 0x1D360,
        "end": 0x1D37F
      }, {
        "begin": 0x1B80,
        "end": 0x1BBF
      }, {
        "begin": 0x1C00,
        "end": 0x1C4F
      }, {
        "begin": 0x1C50,
        "end": 0x1C7F
      }, {
        "begin": 0xA880,
        "end": 0xA8DF
      }, {
        "begin": 0xA900,
        "end": 0xA92F
      }, {
        "begin": 0xA930,
        "end": 0xA95F
      }, {
        "begin": 0xAA00,
        "end": 0xAA5F
      }, {
        "begin": 0x10190,
        "end": 0x101CF
      }, {
        "begin": 0x101D0,
        "end": 0x101FF
      }, {
        "begin": 0x102A0,
        "end": 0x102DF
      }, {
        "begin": 0x1F030,
        "end": 0x1F09F
      }];
      function getUnicodeRangeFor(value) {
        for (var i = 0, ii = UnicodeRanges.length; i < ii; i++) {
          var range = UnicodeRanges[i];
          if (value >= range.begin && value < range.end) {
            return i;
          }
        }
        return -1;
      }
      function isRTLRangeFor(value) {
        var range = UnicodeRanges[13];
        if (value >= range.begin && value < range.end) {
          return true;
        }
        range = UnicodeRanges[11];
        if (value >= range.begin && value < range.end) {
          return true;
        }
        return false;
      }
      var getNormalizedUnicodes = getLookupTableFactory(function (t) {
        t["\xA8"] = " \u0308";
        t["\xAF"] = " \u0304";
        t["\xB4"] = " \u0301";
        t["\xB5"] = "\u03BC";
        t["\xB8"] = " \u0327";
        t["\u0132"] = "IJ";
        t["\u0133"] = "ij";
        t["\u013F"] = "L\xB7";
        t["\u0140"] = "l\xB7";
        t["\u0149"] = "\u02BCn";
        t["\u017F"] = "s";
        t["\u01C4"] = "D\u017D";
        t["\u01C5"] = "D\u017E";
        t["\u01C6"] = "d\u017E";
        t["\u01C7"] = "LJ";
        t["\u01C8"] = "Lj";
        t["\u01C9"] = "lj";
        t["\u01CA"] = "NJ";
        t["\u01CB"] = "Nj";
        t["\u01CC"] = "nj";
        t["\u01F1"] = "DZ";
        t["\u01F2"] = "Dz";
        t["\u01F3"] = "dz";
        t["\u02D8"] = " \u0306";
        t["\u02D9"] = " \u0307";
        t["\u02DA"] = " \u030A";
        t["\u02DB"] = " \u0328";
        t["\u02DC"] = " \u0303";
        t["\u02DD"] = " \u030B";
        t["\u037A"] = " \u0345";
        t["\u0384"] = " \u0301";
        t["\u03D0"] = "\u03B2";
        t["\u03D1"] = "\u03B8";
        t["\u03D2"] = "\u03A5";
        t["\u03D5"] = "\u03C6";
        t["\u03D6"] = "\u03C0";
        t["\u03F0"] = "\u03BA";
        t["\u03F1"] = "\u03C1";
        t["\u03F2"] = "\u03C2";
        t["\u03F4"] = "\u0398";
        t["\u03F5"] = "\u03B5";
        t["\u03F9"] = "\u03A3";
        t["\u0587"] = "\u0565\u0582";
        t["\u0675"] = "\u0627\u0674";
        t["\u0676"] = "\u0648\u0674";
        t["\u0677"] = "\u06C7\u0674";
        t["\u0678"] = "\u064A\u0674";
        t["\u0E33"] = "\u0E4D\u0E32";
        t["\u0EB3"] = "\u0ECD\u0EB2";
        t["\u0EDC"] = "\u0EAB\u0E99";
        t["\u0EDD"] = "\u0EAB\u0EA1";
        t["\u0F77"] = "\u0FB2\u0F81";
        t["\u0F79"] = "\u0FB3\u0F81";
        t["\u1E9A"] = "a\u02BE";
        t["\u1FBD"] = " \u0313";
        t["\u1FBF"] = " \u0313";
        t["\u1FC0"] = " \u0342";
        t["\u1FFE"] = " \u0314";
        t["\u2002"] = " ";
        t["\u2003"] = " ";
        t["\u2004"] = " ";
        t["\u2005"] = " ";
        t["\u2006"] = " ";
        t["\u2008"] = " ";
        t["\u2009"] = " ";
        t["\u200A"] = " ";
        t["\u2017"] = " \u0333";
        t["\u2024"] = ".";
        t["\u2025"] = "..";
        t["\u2026"] = "...";
        t["\u2033"] = "\u2032\u2032";
        t["\u2034"] = "\u2032\u2032\u2032";
        t["\u2036"] = "\u2035\u2035";
        t["\u2037"] = "\u2035\u2035\u2035";
        t["\u203C"] = "!!";
        t["\u203E"] = " \u0305";
        t["\u2047"] = "??";
        t["\u2048"] = "?!";
        t["\u2049"] = "!?";
        t["\u2057"] = "\u2032\u2032\u2032\u2032";
        t["\u205F"] = " ";
        t["\u20A8"] = "Rs";
        t["\u2100"] = "a/c";
        t["\u2101"] = "a/s";
        t["\u2103"] = "\xB0C";
        t["\u2105"] = "c/o";
        t["\u2106"] = "c/u";
        t["\u2107"] = "\u0190";
        t["\u2109"] = "\xB0F";
        t["\u2116"] = "No";
        t["\u2121"] = "TEL";
        t["\u2135"] = "\u05D0";
        t["\u2136"] = "\u05D1";
        t["\u2137"] = "\u05D2";
        t["\u2138"] = "\u05D3";
        t["\u213B"] = "FAX";
        t["\u2160"] = "I";
        t["\u2161"] = "II";
        t["\u2162"] = "III";
        t["\u2163"] = "IV";
        t["\u2164"] = "V";
        t["\u2165"] = "VI";
        t["\u2166"] = "VII";
        t["\u2167"] = "VIII";
        t["\u2168"] = "IX";
        t["\u2169"] = "X";
        t["\u216A"] = "XI";
        t["\u216B"] = "XII";
        t["\u216C"] = "L";
        t["\u216D"] = "C";
        t["\u216E"] = "D";
        t["\u216F"] = "M";
        t["\u2170"] = "i";
        t["\u2171"] = "ii";
        t["\u2172"] = "iii";
        t["\u2173"] = "iv";
        t["\u2174"] = "v";
        t["\u2175"] = "vi";
        t["\u2176"] = "vii";
        t["\u2177"] = "viii";
        t["\u2178"] = "ix";
        t["\u2179"] = "x";
        t["\u217A"] = "xi";
        t["\u217B"] = "xii";
        t["\u217C"] = "l";
        t["\u217D"] = "c";
        t["\u217E"] = "d";
        t["\u217F"] = "m";
        t["\u222C"] = "\u222B\u222B";
        t["\u222D"] = "\u222B\u222B\u222B";
        t["\u222F"] = "\u222E\u222E";
        t["\u2230"] = "\u222E\u222E\u222E";
        t["\u2474"] = "(1)";
        t["\u2475"] = "(2)";
        t["\u2476"] = "(3)";
        t["\u2477"] = "(4)";
        t["\u2478"] = "(5)";
        t["\u2479"] = "(6)";
        t["\u247A"] = "(7)";
        t["\u247B"] = "(8)";
        t["\u247C"] = "(9)";
        t["\u247D"] = "(10)";
        t["\u247E"] = "(11)";
        t["\u247F"] = "(12)";
        t["\u2480"] = "(13)";
        t["\u2481"] = "(14)";
        t["\u2482"] = "(15)";
        t["\u2483"] = "(16)";
        t["\u2484"] = "(17)";
        t["\u2485"] = "(18)";
        t["\u2486"] = "(19)";
        t["\u2487"] = "(20)";
        t["\u2488"] = "1.";
        t["\u2489"] = "2.";
        t["\u248A"] = "3.";
        t["\u248B"] = "4.";
        t["\u248C"] = "5.";
        t["\u248D"] = "6.";
        t["\u248E"] = "7.";
        t["\u248F"] = "8.";
        t["\u2490"] = "9.";
        t["\u2491"] = "10.";
        t["\u2492"] = "11.";
        t["\u2493"] = "12.";
        t["\u2494"] = "13.";
        t["\u2495"] = "14.";
        t["\u2496"] = "15.";
        t["\u2497"] = "16.";
        t["\u2498"] = "17.";
        t["\u2499"] = "18.";
        t["\u249A"] = "19.";
        t["\u249B"] = "20.";
        t["\u249C"] = "(a)";
        t["\u249D"] = "(b)";
        t["\u249E"] = "(c)";
        t["\u249F"] = "(d)";
        t["\u24A0"] = "(e)";
        t["\u24A1"] = "(f)";
        t["\u24A2"] = "(g)";
        t["\u24A3"] = "(h)";
        t["\u24A4"] = "(i)";
        t["\u24A5"] = "(j)";
        t["\u24A6"] = "(k)";
        t["\u24A7"] = "(l)";
        t["\u24A8"] = "(m)";
        t["\u24A9"] = "(n)";
        t["\u24AA"] = "(o)";
        t["\u24AB"] = "(p)";
        t["\u24AC"] = "(q)";
        t["\u24AD"] = "(r)";
        t["\u24AE"] = "(s)";
        t["\u24AF"] = "(t)";
        t["\u24B0"] = "(u)";
        t["\u24B1"] = "(v)";
        t["\u24B2"] = "(w)";
        t["\u24B3"] = "(x)";
        t["\u24B4"] = "(y)";
        t["\u24B5"] = "(z)";
        t["\u2A0C"] = "\u222B\u222B\u222B\u222B";
        t["\u2A74"] = "::=";
        t["\u2A75"] = "==";
        t["\u2A76"] = "===";
        t["\u2E9F"] = "\u6BCD";
        t["\u2EF3"] = "\u9F9F";
        t["\u2F00"] = "\u4E00";
        t["\u2F01"] = "\u4E28";
        t["\u2F02"] = "\u4E36";
        t["\u2F03"] = "\u4E3F";
        t["\u2F04"] = "\u4E59";
        t["\u2F05"] = "\u4E85";
        t["\u2F06"] = "\u4E8C";
        t["\u2F07"] = "\u4EA0";
        t["\u2F08"] = "\u4EBA";
        t["\u2F09"] = "\u513F";
        t["\u2F0A"] = "\u5165";
        t["\u2F0B"] = "\u516B";
        t["\u2F0C"] = "\u5182";
        t["\u2F0D"] = "\u5196";
        t["\u2F0E"] = "\u51AB";
        t["\u2F0F"] = "\u51E0";
        t["\u2F10"] = "\u51F5";
        t["\u2F11"] = "\u5200";
        t["\u2F12"] = "\u529B";
        t["\u2F13"] = "\u52F9";
        t["\u2F14"] = "\u5315";
        t["\u2F15"] = "\u531A";
        t["\u2F16"] = "\u5338";
        t["\u2F17"] = "\u5341";
        t["\u2F18"] = "\u535C";
        t["\u2F19"] = "\u5369";
        t["\u2F1A"] = "\u5382";
        t["\u2F1B"] = "\u53B6";
        t["\u2F1C"] = "\u53C8";
        t["\u2F1D"] = "\u53E3";
        t["\u2F1E"] = "\u56D7";
        t["\u2F1F"] = "\u571F";
        t["\u2F20"] = "\u58EB";
        t["\u2F21"] = "\u5902";
        t["\u2F22"] = "\u590A";
        t["\u2F23"] = "\u5915";
        t["\u2F24"] = "\u5927";
        t["\u2F25"] = "\u5973";
        t["\u2F26"] = "\u5B50";
        t["\u2F27"] = "\u5B80";
        t["\u2F28"] = "\u5BF8";
        t["\u2F29"] = "\u5C0F";
        t["\u2F2A"] = "\u5C22";
        t["\u2F2B"] = "\u5C38";
        t["\u2F2C"] = "\u5C6E";
        t["\u2F2D"] = "\u5C71";
        t["\u2F2E"] = "\u5DDB";
        t["\u2F2F"] = "\u5DE5";
        t["\u2F30"] = "\u5DF1";
        t["\u2F31"] = "\u5DFE";
        t["\u2F32"] = "\u5E72";
        t["\u2F33"] = "\u5E7A";
        t["\u2F34"] = "\u5E7F";
        t["\u2F35"] = "\u5EF4";
        t["\u2F36"] = "\u5EFE";
        t["\u2F37"] = "\u5F0B";
        t["\u2F38"] = "\u5F13";
        t["\u2F39"] = "\u5F50";
        t["\u2F3A"] = "\u5F61";
        t["\u2F3B"] = "\u5F73";
        t["\u2F3C"] = "\u5FC3";
        t["\u2F3D"] = "\u6208";
        t["\u2F3E"] = "\u6236";
        t["\u2F3F"] = "\u624B";
        t["\u2F40"] = "\u652F";
        t["\u2F41"] = "\u6534";
        t["\u2F42"] = "\u6587";
        t["\u2F43"] = "\u6597";
        t["\u2F44"] = "\u65A4";
        t["\u2F45"] = "\u65B9";
        t["\u2F46"] = "\u65E0";
        t["\u2F47"] = "\u65E5";
        t["\u2F48"] = "\u66F0";
        t["\u2F49"] = "\u6708";
        t["\u2F4A"] = "\u6728";
        t["\u2F4B"] = "\u6B20";
        t["\u2F4C"] = "\u6B62";
        t["\u2F4D"] = "\u6B79";
        t["\u2F4E"] = "\u6BB3";
        t["\u2F4F"] = "\u6BCB";
        t["\u2F50"] = "\u6BD4";
        t["\u2F51"] = "\u6BDB";
        t["\u2F52"] = "\u6C0F";
        t["\u2F53"] = "\u6C14";
        t["\u2F54"] = "\u6C34";
        t["\u2F55"] = "\u706B";
        t["\u2F56"] = "\u722A";
        t["\u2F57"] = "\u7236";
        t["\u2F58"] = "\u723B";
        t["\u2F59"] = "\u723F";
        t["\u2F5A"] = "\u7247";
        t["\u2F5B"] = "\u7259";
        t["\u2F5C"] = "\u725B";
        t["\u2F5D"] = "\u72AC";
        t["\u2F5E"] = "\u7384";
        t["\u2F5F"] = "\u7389";
        t["\u2F60"] = "\u74DC";
        t["\u2F61"] = "\u74E6";
        t["\u2F62"] = "\u7518";
        t["\u2F63"] = "\u751F";
        t["\u2F64"] = "\u7528";
        t["\u2F65"] = "\u7530";
        t["\u2F66"] = "\u758B";
        t["\u2F67"] = "\u7592";
        t["\u2F68"] = "\u7676";
        t["\u2F69"] = "\u767D";
        t["\u2F6A"] = "\u76AE";
        t["\u2F6B"] = "\u76BF";
        t["\u2F6C"] = "\u76EE";
        t["\u2F6D"] = "\u77DB";
        t["\u2F6E"] = "\u77E2";
        t["\u2F6F"] = "\u77F3";
        t["\u2F70"] = "\u793A";
        t["\u2F71"] = "\u79B8";
        t["\u2F72"] = "\u79BE";
        t["\u2F73"] = "\u7A74";
        t["\u2F74"] = "\u7ACB";
        t["\u2F75"] = "\u7AF9";
        t["\u2F76"] = "\u7C73";
        t["\u2F77"] = "\u7CF8";
        t["\u2F78"] = "\u7F36";
        t["\u2F79"] = "\u7F51";
        t["\u2F7A"] = "\u7F8A";
        t["\u2F7B"] = "\u7FBD";
        t["\u2F7C"] = "\u8001";
        t["\u2F7D"] = "\u800C";
        t["\u2F7E"] = "\u8012";
        t["\u2F7F"] = "\u8033";
        t["\u2F80"] = "\u807F";
        t["\u2F81"] = "\u8089";
        t["\u2F82"] = "\u81E3";
        t["\u2F83"] = "\u81EA";
        t["\u2F84"] = "\u81F3";
        t["\u2F85"] = "\u81FC";
        t["\u2F86"] = "\u820C";
        t["\u2F87"] = "\u821B";
        t["\u2F88"] = "\u821F";
        t["\u2F89"] = "\u826E";
        t["\u2F8A"] = "\u8272";
        t["\u2F8B"] = "\u8278";
        t["\u2F8C"] = "\u864D";
        t["\u2F8D"] = "\u866B";
        t["\u2F8E"] = "\u8840";
        t["\u2F8F"] = "\u884C";
        t["\u2F90"] = "\u8863";
        t["\u2F91"] = "\u897E";
        t["\u2F92"] = "\u898B";
        t["\u2F93"] = "\u89D2";
        t["\u2F94"] = "\u8A00";
        t["\u2F95"] = "\u8C37";
        t["\u2F96"] = "\u8C46";
        t["\u2F97"] = "\u8C55";
        t["\u2F98"] = "\u8C78";
        t["\u2F99"] = "\u8C9D";
        t["\u2F9A"] = "\u8D64";
        t["\u2F9B"] = "\u8D70";
        t["\u2F9C"] = "\u8DB3";
        t["\u2F9D"] = "\u8EAB";
        t["\u2F9E"] = "\u8ECA";
        t["\u2F9F"] = "\u8F9B";
        t["\u2FA0"] = "\u8FB0";
        t["\u2FA1"] = "\u8FB5";
        t["\u2FA2"] = "\u9091";
        t["\u2FA3"] = "\u9149";
        t["\u2FA4"] = "\u91C6";
        t["\u2FA5"] = "\u91CC";
        t["\u2FA6"] = "\u91D1";
        t["\u2FA7"] = "\u9577";
        t["\u2FA8"] = "\u9580";
        t["\u2FA9"] = "\u961C";
        t["\u2FAA"] = "\u96B6";
        t["\u2FAB"] = "\u96B9";
        t["\u2FAC"] = "\u96E8";
        t["\u2FAD"] = "\u9751";
        t["\u2FAE"] = "\u975E";
        t["\u2FAF"] = "\u9762";
        t["\u2FB0"] = "\u9769";
        t["\u2FB1"] = "\u97CB";
        t["\u2FB2"] = "\u97ED";
        t["\u2FB3"] = "\u97F3";
        t["\u2FB4"] = "\u9801";
        t["\u2FB5"] = "\u98A8";
        t["\u2FB6"] = "\u98DB";
        t["\u2FB7"] = "\u98DF";
        t["\u2FB8"] = "\u9996";
        t["\u2FB9"] = "\u9999";
        t["\u2FBA"] = "\u99AC";
        t["\u2FBB"] = "\u9AA8";
        t["\u2FBC"] = "\u9AD8";
        t["\u2FBD"] = "\u9ADF";
        t["\u2FBE"] = "\u9B25";
        t["\u2FBF"] = "\u9B2F";
        t["\u2FC0"] = "\u9B32";
        t["\u2FC1"] = "\u9B3C";
        t["\u2FC2"] = "\u9B5A";
        t["\u2FC3"] = "\u9CE5";
        t["\u2FC4"] = "\u9E75";
        t["\u2FC5"] = "\u9E7F";
        t["\u2FC6"] = "\u9EA5";
        t["\u2FC7"] = "\u9EBB";
        t["\u2FC8"] = "\u9EC3";
        t["\u2FC9"] = "\u9ECD";
        t["\u2FCA"] = "\u9ED1";
        t["\u2FCB"] = "\u9EF9";
        t["\u2FCC"] = "\u9EFD";
        t["\u2FCD"] = "\u9F0E";
        t["\u2FCE"] = "\u9F13";
        t["\u2FCF"] = "\u9F20";
        t["\u2FD0"] = "\u9F3B";
        t["\u2FD1"] = "\u9F4A";
        t["\u2FD2"] = "\u9F52";
        t["\u2FD3"] = "\u9F8D";
        t["\u2FD4"] = "\u9F9C";
        t["\u2FD5"] = "\u9FA0";
        t["\u3036"] = "\u3012";
        t["\u3038"] = "\u5341";
        t["\u3039"] = "\u5344";
        t["\u303A"] = "\u5345";
        t["\u309B"] = " \u3099";
        t["\u309C"] = " \u309A";
        t["\u3131"] = "\u1100";
        t["\u3132"] = "\u1101";
        t["\u3133"] = "\u11AA";
        t["\u3134"] = "\u1102";
        t["\u3135"] = "\u11AC";
        t["\u3136"] = "\u11AD";
        t["\u3137"] = "\u1103";
        t["\u3138"] = "\u1104";
        t["\u3139"] = "\u1105";
        t["\u313A"] = "\u11B0";
        t["\u313B"] = "\u11B1";
        t["\u313C"] = "\u11B2";
        t["\u313D"] = "\u11B3";
        t["\u313E"] = "\u11B4";
        t["\u313F"] = "\u11B5";
        t["\u3140"] = "\u111A";
        t["\u3141"] = "\u1106";
        t["\u3142"] = "\u1107";
        t["\u3143"] = "\u1108";
        t["\u3144"] = "\u1121";
        t["\u3145"] = "\u1109";
        t["\u3146"] = "\u110A";
        t["\u3147"] = "\u110B";
        t["\u3148"] = "\u110C";
        t["\u3149"] = "\u110D";
        t["\u314A"] = "\u110E";
        t["\u314B"] = "\u110F";
        t["\u314C"] = "\u1110";
        t["\u314D"] = "\u1111";
        t["\u314E"] = "\u1112";
        t["\u314F"] = "\u1161";
        t["\u3150"] = "\u1162";
        t["\u3151"] = "\u1163";
        t["\u3152"] = "\u1164";
        t["\u3153"] = "\u1165";
        t["\u3154"] = "\u1166";
        t["\u3155"] = "\u1167";
        t["\u3156"] = "\u1168";
        t["\u3157"] = "\u1169";
        t["\u3158"] = "\u116A";
        t["\u3159"] = "\u116B";
        t["\u315A"] = "\u116C";
        t["\u315B"] = "\u116D";
        t["\u315C"] = "\u116E";
        t["\u315D"] = "\u116F";
        t["\u315E"] = "\u1170";
        t["\u315F"] = "\u1171";
        t["\u3160"] = "\u1172";
        t["\u3161"] = "\u1173";
        t["\u3162"] = "\u1174";
        t["\u3163"] = "\u1175";
        t["\u3164"] = "\u1160";
        t["\u3165"] = "\u1114";
        t["\u3166"] = "\u1115";
        t["\u3167"] = "\u11C7";
        t["\u3168"] = "\u11C8";
        t["\u3169"] = "\u11CC";
        t["\u316A"] = "\u11CE";
        t["\u316B"] = "\u11D3";
        t["\u316C"] = "\u11D7";
        t["\u316D"] = "\u11D9";
        t["\u316E"] = "\u111C";
        t["\u316F"] = "\u11DD";
        t["\u3170"] = "\u11DF";
        t["\u3171"] = "\u111D";
        t["\u3172"] = "\u111E";
        t["\u3173"] = "\u1120";
        t["\u3174"] = "\u1122";
        t["\u3175"] = "\u1123";
        t["\u3176"] = "\u1127";
        t["\u3177"] = "\u1129";
        t["\u3178"] = "\u112B";
        t["\u3179"] = "\u112C";
        t["\u317A"] = "\u112D";
        t["\u317B"] = "\u112E";
        t["\u317C"] = "\u112F";
        t["\u317D"] = "\u1132";
        t["\u317E"] = "\u1136";
        t["\u317F"] = "\u1140";
        t["\u3180"] = "\u1147";
        t["\u3181"] = "\u114C";
        t["\u3182"] = "\u11F1";
        t["\u3183"] = "\u11F2";
        t["\u3184"] = "\u1157";
        t["\u3185"] = "\u1158";
        t["\u3186"] = "\u1159";
        t["\u3187"] = "\u1184";
        t["\u3188"] = "\u1185";
        t["\u3189"] = "\u1188";
        t["\u318A"] = "\u1191";
        t["\u318B"] = "\u1192";
        t["\u318C"] = "\u1194";
        t["\u318D"] = "\u119E";
        t["\u318E"] = "\u11A1";
        t["\u3200"] = "(\u1100)";
        t["\u3201"] = "(\u1102)";
        t["\u3202"] = "(\u1103)";
        t["\u3203"] = "(\u1105)";
        t["\u3204"] = "(\u1106)";
        t["\u3205"] = "(\u1107)";
        t["\u3206"] = "(\u1109)";
        t["\u3207"] = "(\u110B)";
        t["\u3208"] = "(\u110C)";
        t["\u3209"] = "(\u110E)";
        t["\u320A"] = "(\u110F)";
        t["\u320B"] = "(\u1110)";
        t["\u320C"] = "(\u1111)";
        t["\u320D"] = "(\u1112)";
        t["\u320E"] = "(\u1100\u1161)";
        t["\u320F"] = "(\u1102\u1161)";
        t["\u3210"] = "(\u1103\u1161)";
        t["\u3211"] = "(\u1105\u1161)";
        t["\u3212"] = "(\u1106\u1161)";
        t["\u3213"] = "(\u1107\u1161)";
        t["\u3214"] = "(\u1109\u1161)";
        t["\u3215"] = "(\u110B\u1161)";
        t["\u3216"] = "(\u110C\u1161)";
        t["\u3217"] = "(\u110E\u1161)";
        t["\u3218"] = "(\u110F\u1161)";
        t["\u3219"] = "(\u1110\u1161)";
        t["\u321A"] = "(\u1111\u1161)";
        t["\u321B"] = "(\u1112\u1161)";
        t["\u321C"] = "(\u110C\u116E)";
        t["\u321D"] = "(\u110B\u1169\u110C\u1165\u11AB)";
        t["\u321E"] = "(\u110B\u1169\u1112\u116E)";
        t["\u3220"] = "(\u4E00)";
        t["\u3221"] = "(\u4E8C)";
        t["\u3222"] = "(\u4E09)";
        t["\u3223"] = "(\u56DB)";
        t["\u3224"] = "(\u4E94)";
        t["\u3225"] = "(\u516D)";
        t["\u3226"] = "(\u4E03)";
        t["\u3227"] = "(\u516B)";
        t["\u3228"] = "(\u4E5D)";
        t["\u3229"] = "(\u5341)";
        t["\u322A"] = "(\u6708)";
        t["\u322B"] = "(\u706B)";
        t["\u322C"] = "(\u6C34)";
        t["\u322D"] = "(\u6728)";
        t["\u322E"] = "(\u91D1)";
        t["\u322F"] = "(\u571F)";
        t["\u3230"] = "(\u65E5)";
        t["\u3231"] = "(\u682A)";
        t["\u3232"] = "(\u6709)";
        t["\u3233"] = "(\u793E)";
        t["\u3234"] = "(\u540D)";
        t["\u3235"] = "(\u7279)";
        t["\u3236"] = "(\u8CA1)";
        t["\u3237"] = "(\u795D)";
        t["\u3238"] = "(\u52B4)";
        t["\u3239"] = "(\u4EE3)";
        t["\u323A"] = "(\u547C)";
        t["\u323B"] = "(\u5B66)";
        t["\u323C"] = "(\u76E3)";
        t["\u323D"] = "(\u4F01)";
        t["\u323E"] = "(\u8CC7)";
        t["\u323F"] = "(\u5354)";
        t["\u3240"] = "(\u796D)";
        t["\u3241"] = "(\u4F11)";
        t["\u3242"] = "(\u81EA)";
        t["\u3243"] = "(\u81F3)";
        t["\u32C0"] = "1\u6708";
        t["\u32C1"] = "2\u6708";
        t["\u32C2"] = "3\u6708";
        t["\u32C3"] = "4\u6708";
        t["\u32C4"] = "5\u6708";
        t["\u32C5"] = "6\u6708";
        t["\u32C6"] = "7\u6708";
        t["\u32C7"] = "8\u6708";
        t["\u32C8"] = "9\u6708";
        t["\u32C9"] = "10\u6708";
        t["\u32CA"] = "11\u6708";
        t["\u32CB"] = "12\u6708";
        t["\u3358"] = "0\u70B9";
        t["\u3359"] = "1\u70B9";
        t["\u335A"] = "2\u70B9";
        t["\u335B"] = "3\u70B9";
        t["\u335C"] = "4\u70B9";
        t["\u335D"] = "5\u70B9";
        t["\u335E"] = "6\u70B9";
        t["\u335F"] = "7\u70B9";
        t["\u3360"] = "8\u70B9";
        t["\u3361"] = "9\u70B9";
        t["\u3362"] = "10\u70B9";
        t["\u3363"] = "11\u70B9";
        t["\u3364"] = "12\u70B9";
        t["\u3365"] = "13\u70B9";
        t["\u3366"] = "14\u70B9";
        t["\u3367"] = "15\u70B9";
        t["\u3368"] = "16\u70B9";
        t["\u3369"] = "17\u70B9";
        t["\u336A"] = "18\u70B9";
        t["\u336B"] = "19\u70B9";
        t["\u336C"] = "20\u70B9";
        t["\u336D"] = "21\u70B9";
        t["\u336E"] = "22\u70B9";
        t["\u336F"] = "23\u70B9";
        t["\u3370"] = "24\u70B9";
        t["\u33E0"] = "1\u65E5";
        t["\u33E1"] = "2\u65E5";
        t["\u33E2"] = "3\u65E5";
        t["\u33E3"] = "4\u65E5";
        t["\u33E4"] = "5\u65E5";
        t["\u33E5"] = "6\u65E5";
        t["\u33E6"] = "7\u65E5";
        t["\u33E7"] = "8\u65E5";
        t["\u33E8"] = "9\u65E5";
        t["\u33E9"] = "10\u65E5";
        t["\u33EA"] = "11\u65E5";
        t["\u33EB"] = "12\u65E5";
        t["\u33EC"] = "13\u65E5";
        t["\u33ED"] = "14\u65E5";
        t["\u33EE"] = "15\u65E5";
        t["\u33EF"] = "16\u65E5";
        t["\u33F0"] = "17\u65E5";
        t["\u33F1"] = "18\u65E5";
        t["\u33F2"] = "19\u65E5";
        t["\u33F3"] = "20\u65E5";
        t["\u33F4"] = "21\u65E5";
        t["\u33F5"] = "22\u65E5";
        t["\u33F6"] = "23\u65E5";
        t["\u33F7"] = "24\u65E5";
        t["\u33F8"] = "25\u65E5";
        t["\u33F9"] = "26\u65E5";
        t["\u33FA"] = "27\u65E5";
        t["\u33FB"] = "28\u65E5";
        t["\u33FC"] = "29\u65E5";
        t["\u33FD"] = "30\u65E5";
        t["\u33FE"] = "31\u65E5";
        t["\uFB00"] = "ff";
        t["\uFB01"] = "fi";
        t["\uFB02"] = "fl";
        t["\uFB03"] = "ffi";
        t["\uFB04"] = "ffl";
        t["\uFB05"] = "\u017Ft";
        t["\uFB06"] = "st";
        t["\uFB13"] = "\u0574\u0576";
        t["\uFB14"] = "\u0574\u0565";
        t["\uFB15"] = "\u0574\u056B";
        t["\uFB16"] = "\u057E\u0576";
        t["\uFB17"] = "\u0574\u056D";
        t["\uFB4F"] = "\u05D0\u05DC";
        t["\uFB50"] = "\u0671";
        t["\uFB51"] = "\u0671";
        t["\uFB52"] = "\u067B";
        t["\uFB53"] = "\u067B";
        t["\uFB54"] = "\u067B";
        t["\uFB55"] = "\u067B";
        t["\uFB56"] = "\u067E";
        t["\uFB57"] = "\u067E";
        t["\uFB58"] = "\u067E";
        t["\uFB59"] = "\u067E";
        t["\uFB5A"] = "\u0680";
        t["\uFB5B"] = "\u0680";
        t["\uFB5C"] = "\u0680";
        t["\uFB5D"] = "\u0680";
        t["\uFB5E"] = "\u067A";
        t["\uFB5F"] = "\u067A";
        t["\uFB60"] = "\u067A";
        t["\uFB61"] = "\u067A";
        t["\uFB62"] = "\u067F";
        t["\uFB63"] = "\u067F";
        t["\uFB64"] = "\u067F";
        t["\uFB65"] = "\u067F";
        t["\uFB66"] = "\u0679";
        t["\uFB67"] = "\u0679";
        t["\uFB68"] = "\u0679";
        t["\uFB69"] = "\u0679";
        t["\uFB6A"] = "\u06A4";
        t["\uFB6B"] = "\u06A4";
        t["\uFB6C"] = "\u06A4";
        t["\uFB6D"] = "\u06A4";
        t["\uFB6E"] = "\u06A6";
        t["\uFB6F"] = "\u06A6";
        t["\uFB70"] = "\u06A6";
        t["\uFB71"] = "\u06A6";
        t["\uFB72"] = "\u0684";
        t["\uFB73"] = "\u0684";
        t["\uFB74"] = "\u0684";
        t["\uFB75"] = "\u0684";
        t["\uFB76"] = "\u0683";
        t["\uFB77"] = "\u0683";
        t["\uFB78"] = "\u0683";
        t["\uFB79"] = "\u0683";
        t["\uFB7A"] = "\u0686";
        t["\uFB7B"] = "\u0686";
        t["\uFB7C"] = "\u0686";
        t["\uFB7D"] = "\u0686";
        t["\uFB7E"] = "\u0687";
        t["\uFB7F"] = "\u0687";
        t["\uFB80"] = "\u0687";
        t["\uFB81"] = "\u0687";
        t["\uFB82"] = "\u068D";
        t["\uFB83"] = "\u068D";
        t["\uFB84"] = "\u068C";
        t["\uFB85"] = "\u068C";
        t["\uFB86"] = "\u068E";
        t["\uFB87"] = "\u068E";
        t["\uFB88"] = "\u0688";
        t["\uFB89"] = "\u0688";
        t["\uFB8A"] = "\u0698";
        t["\uFB8B"] = "\u0698";
        t["\uFB8C"] = "\u0691";
        t["\uFB8D"] = "\u0691";
        t["\uFB8E"] = "\u06A9";
        t["\uFB8F"] = "\u06A9";
        t["\uFB90"] = "\u06A9";
        t["\uFB91"] = "\u06A9";
        t["\uFB92"] = "\u06AF";
        t["\uFB93"] = "\u06AF";
        t["\uFB94"] = "\u06AF";
        t["\uFB95"] = "\u06AF";
        t["\uFB96"] = "\u06B3";
        t["\uFB97"] = "\u06B3";
        t["\uFB98"] = "\u06B3";
        t["\uFB99"] = "\u06B3";
        t["\uFB9A"] = "\u06B1";
        t["\uFB9B"] = "\u06B1";
        t["\uFB9C"] = "\u06B1";
        t["\uFB9D"] = "\u06B1";
        t["\uFB9E"] = "\u06BA";
        t["\uFB9F"] = "\u06BA";
        t["\uFBA0"] = "\u06BB";
        t["\uFBA1"] = "\u06BB";
        t["\uFBA2"] = "\u06BB";
        t["\uFBA3"] = "\u06BB";
        t["\uFBA4"] = "\u06C0";
        t["\uFBA5"] = "\u06C0";
        t["\uFBA6"] = "\u06C1";
        t["\uFBA7"] = "\u06C1";
        t["\uFBA8"] = "\u06C1";
        t["\uFBA9"] = "\u06C1";
        t["\uFBAA"] = "\u06BE";
        t["\uFBAB"] = "\u06BE";
        t["\uFBAC"] = "\u06BE";
        t["\uFBAD"] = "\u06BE";
        t["\uFBAE"] = "\u06D2";
        t["\uFBAF"] = "\u06D2";
        t["\uFBB0"] = "\u06D3";
        t["\uFBB1"] = "\u06D3";
        t["\uFBD3"] = "\u06AD";
        t["\uFBD4"] = "\u06AD";
        t["\uFBD5"] = "\u06AD";
        t["\uFBD6"] = "\u06AD";
        t["\uFBD7"] = "\u06C7";
        t["\uFBD8"] = "\u06C7";
        t["\uFBD9"] = "\u06C6";
        t["\uFBDA"] = "\u06C6";
        t["\uFBDB"] = "\u06C8";
        t["\uFBDC"] = "\u06C8";
        t["\uFBDD"] = "\u0677";
        t["\uFBDE"] = "\u06CB";
        t["\uFBDF"] = "\u06CB";
        t["\uFBE0"] = "\u06C5";
        t["\uFBE1"] = "\u06C5";
        t["\uFBE2"] = "\u06C9";
        t["\uFBE3"] = "\u06C9";
        t["\uFBE4"] = "\u06D0";
        t["\uFBE5"] = "\u06D0";
        t["\uFBE6"] = "\u06D0";
        t["\uFBE7"] = "\u06D0";
        t["\uFBE8"] = "\u0649";
        t["\uFBE9"] = "\u0649";
        t["\uFBEA"] = "\u0626\u0627";
        t["\uFBEB"] = "\u0626\u0627";
        t["\uFBEC"] = "\u0626\u06D5";
        t["\uFBED"] = "\u0626\u06D5";
        t["\uFBEE"] = "\u0626\u0648";
        t["\uFBEF"] = "\u0626\u0648";
        t["\uFBF0"] = "\u0626\u06C7";
        t["\uFBF1"] = "\u0626\u06C7";
        t["\uFBF2"] = "\u0626\u06C6";
        t["\uFBF3"] = "\u0626\u06C6";
        t["\uFBF4"] = "\u0626\u06C8";
        t["\uFBF5"] = "\u0626\u06C8";
        t["\uFBF6"] = "\u0626\u06D0";
        t["\uFBF7"] = "\u0626\u06D0";
        t["\uFBF8"] = "\u0626\u06D0";
        t["\uFBF9"] = "\u0626\u0649";
        t["\uFBFA"] = "\u0626\u0649";
        t["\uFBFB"] = "\u0626\u0649";
        t["\uFBFC"] = "\u06CC";
        t["\uFBFD"] = "\u06CC";
        t["\uFBFE"] = "\u06CC";
        t["\uFBFF"] = "\u06CC";
        t["\uFC00"] = "\u0626\u062C";
        t["\uFC01"] = "\u0626\u062D";
        t["\uFC02"] = "\u0626\u0645";
        t["\uFC03"] = "\u0626\u0649";
        t["\uFC04"] = "\u0626\u064A";
        t["\uFC05"] = "\u0628\u062C";
        t["\uFC06"] = "\u0628\u062D";
        t["\uFC07"] = "\u0628\u062E";
        t["\uFC08"] = "\u0628\u0645";
        t["\uFC09"] = "\u0628\u0649";
        t["\uFC0A"] = "\u0628\u064A";
        t["\uFC0B"] = "\u062A\u062C";
        t["\uFC0C"] = "\u062A\u062D";
        t["\uFC0D"] = "\u062A\u062E";
        t["\uFC0E"] = "\u062A\u0645";
        t["\uFC0F"] = "\u062A\u0649";
        t["\uFC10"] = "\u062A\u064A";
        t["\uFC11"] = "\u062B\u062C";
        t["\uFC12"] = "\u062B\u0645";
        t["\uFC13"] = "\u062B\u0649";
        t["\uFC14"] = "\u062B\u064A";
        t["\uFC15"] = "\u062C\u062D";
        t["\uFC16"] = "\u062C\u0645";
        t["\uFC17"] = "\u062D\u062C";
        t["\uFC18"] = "\u062D\u0645";
        t["\uFC19"] = "\u062E\u062C";
        t["\uFC1A"] = "\u062E\u062D";
        t["\uFC1B"] = "\u062E\u0645";
        t["\uFC1C"] = "\u0633\u062C";
        t["\uFC1D"] = "\u0633\u062D";
        t["\uFC1E"] = "\u0633\u062E";
        t["\uFC1F"] = "\u0633\u0645";
        t["\uFC20"] = "\u0635\u062D";
        t["\uFC21"] = "\u0635\u0645";
        t["\uFC22"] = "\u0636\u062C";
        t["\uFC23"] = "\u0636\u062D";
        t["\uFC24"] = "\u0636\u062E";
        t["\uFC25"] = "\u0636\u0645";
        t["\uFC26"] = "\u0637\u062D";
        t["\uFC27"] = "\u0637\u0645";
        t["\uFC28"] = "\u0638\u0645";
        t["\uFC29"] = "\u0639\u062C";
        t["\uFC2A"] = "\u0639\u0645";
        t["\uFC2B"] = "\u063A\u062C";
        t["\uFC2C"] = "\u063A\u0645";
        t["\uFC2D"] = "\u0641\u062C";
        t["\uFC2E"] = "\u0641\u062D";
        t["\uFC2F"] = "\u0641\u062E";
        t["\uFC30"] = "\u0641\u0645";
        t["\uFC31"] = "\u0641\u0649";
        t["\uFC32"] = "\u0641\u064A";
        t["\uFC33"] = "\u0642\u062D";
        t["\uFC34"] = "\u0642\u0645";
        t["\uFC35"] = "\u0642\u0649";
        t["\uFC36"] = "\u0642\u064A";
        t["\uFC37"] = "\u0643\u0627";
        t["\uFC38"] = "\u0643\u062C";
        t["\uFC39"] = "\u0643\u062D";
        t["\uFC3A"] = "\u0643\u062E";
        t["\uFC3B"] = "\u0643\u0644";
        t["\uFC3C"] = "\u0643\u0645";
        t["\uFC3D"] = "\u0643\u0649";
        t["\uFC3E"] = "\u0643\u064A";
        t["\uFC3F"] = "\u0644\u062C";
        t["\uFC40"] = "\u0644\u062D";
        t["\uFC41"] = "\u0644\u062E";
        t["\uFC42"] = "\u0644\u0645";
        t["\uFC43"] = "\u0644\u0649";
        t["\uFC44"] = "\u0644\u064A";
        t["\uFC45"] = "\u0645\u062C";
        t["\uFC46"] = "\u0645\u062D";
        t["\uFC47"] = "\u0645\u062E";
        t["\uFC48"] = "\u0645\u0645";
        t["\uFC49"] = "\u0645\u0649";
        t["\uFC4A"] = "\u0645\u064A";
        t["\uFC4B"] = "\u0646\u062C";
        t["\uFC4C"] = "\u0646\u062D";
        t["\uFC4D"] = "\u0646\u062E";
        t["\uFC4E"] = "\u0646\u0645";
        t["\uFC4F"] = "\u0646\u0649";
        t["\uFC50"] = "\u0646\u064A";
        t["\uFC51"] = "\u0647\u062C";
        t["\uFC52"] = "\u0647\u0645";
        t["\uFC53"] = "\u0647\u0649";
        t["\uFC54"] = "\u0647\u064A";
        t["\uFC55"] = "\u064A\u062C";
        t["\uFC56"] = "\u064A\u062D";
        t["\uFC57"] = "\u064A\u062E";
        t["\uFC58"] = "\u064A\u0645";
        t["\uFC59"] = "\u064A\u0649";
        t["\uFC5A"] = "\u064A\u064A";
        t["\uFC5B"] = "\u0630\u0670";
        t["\uFC5C"] = "\u0631\u0670";
        t["\uFC5D"] = "\u0649\u0670";
        t["\uFC5E"] = " \u064C\u0651";
        t["\uFC5F"] = " \u064D\u0651";
        t["\uFC60"] = " \u064E\u0651";
        t["\uFC61"] = " \u064F\u0651";
        t["\uFC62"] = " \u0650\u0651";
        t["\uFC63"] = " \u0651\u0670";
        t["\uFC64"] = "\u0626\u0631";
        t["\uFC65"] = "\u0626\u0632";
        t["\uFC66"] = "\u0626\u0645";
        t["\uFC67"] = "\u0626\u0646";
        t["\uFC68"] = "\u0626\u0649";
        t["\uFC69"] = "\u0626\u064A";
        t["\uFC6A"] = "\u0628\u0631";
        t["\uFC6B"] = "\u0628\u0632";
        t["\uFC6C"] = "\u0628\u0645";
        t["\uFC6D"] = "\u0628\u0646";
        t["\uFC6E"] = "\u0628\u0649";
        t["\uFC6F"] = "\u0628\u064A";
        t["\uFC70"] = "\u062A\u0631";
        t["\uFC71"] = "\u062A\u0632";
        t["\uFC72"] = "\u062A\u0645";
        t["\uFC73"] = "\u062A\u0646";
        t["\uFC74"] = "\u062A\u0649";
        t["\uFC75"] = "\u062A\u064A";
        t["\uFC76"] = "\u062B\u0631";
        t["\uFC77"] = "\u062B\u0632";
        t["\uFC78"] = "\u062B\u0645";
        t["\uFC79"] = "\u062B\u0646";
        t["\uFC7A"] = "\u062B\u0649";
        t["\uFC7B"] = "\u062B\u064A";
        t["\uFC7C"] = "\u0641\u0649";
        t["\uFC7D"] = "\u0641\u064A";
        t["\uFC7E"] = "\u0642\u0649";
        t["\uFC7F"] = "\u0642\u064A";
        t["\uFC80"] = "\u0643\u0627";
        t["\uFC81"] = "\u0643\u0644";
        t["\uFC82"] = "\u0643\u0645";
        t["\uFC83"] = "\u0643\u0649";
        t["\uFC84"] = "\u0643\u064A";
        t["\uFC85"] = "\u0644\u0645";
        t["\uFC86"] = "\u0644\u0649";
        t["\uFC87"] = "\u0644\u064A";
        t["\uFC88"] = "\u0645\u0627";
        t["\uFC89"] = "\u0645\u0645";
        t["\uFC8A"] = "\u0646\u0631";
        t["\uFC8B"] = "\u0646\u0632";
        t["\uFC8C"] = "\u0646\u0645";
        t["\uFC8D"] = "\u0646\u0646";
        t["\uFC8E"] = "\u0646\u0649";
        t["\uFC8F"] = "\u0646\u064A";
        t["\uFC90"] = "\u0649\u0670";
        t["\uFC91"] = "\u064A\u0631";
        t["\uFC92"] = "\u064A\u0632";
        t["\uFC93"] = "\u064A\u0645";
        t["\uFC94"] = "\u064A\u0646";
        t["\uFC95"] = "\u064A\u0649";
        t["\uFC96"] = "\u064A\u064A";
        t["\uFC97"] = "\u0626\u062C";
        t["\uFC98"] = "\u0626\u062D";
        t["\uFC99"] = "\u0626\u062E";
        t["\uFC9A"] = "\u0626\u0645";
        t["\uFC9B"] = "\u0626\u0647";
        t["\uFC9C"] = "\u0628\u062C";
        t["\uFC9D"] = "\u0628\u062D";
        t["\uFC9E"] = "\u0628\u062E";
        t["\uFC9F"] = "\u0628\u0645";
        t["\uFCA0"] = "\u0628\u0647";
        t["\uFCA1"] = "\u062A\u062C";
        t["\uFCA2"] = "\u062A\u062D";
        t["\uFCA3"] = "\u062A\u062E";
        t["\uFCA4"] = "\u062A\u0645";
        t["\uFCA5"] = "\u062A\u0647";
        t["\uFCA6"] = "\u062B\u0645";
        t["\uFCA7"] = "\u062C\u062D";
        t["\uFCA8"] = "\u062C\u0645";
        t["\uFCA9"] = "\u062D\u062C";
        t["\uFCAA"] = "\u062D\u0645";
        t["\uFCAB"] = "\u062E\u062C";
        t["\uFCAC"] = "\u062E\u0645";
        t["\uFCAD"] = "\u0633\u062C";
        t["\uFCAE"] = "\u0633\u062D";
        t["\uFCAF"] = "\u0633\u062E";
        t["\uFCB0"] = "\u0633\u0645";
        t["\uFCB1"] = "\u0635\u062D";
        t["\uFCB2"] = "\u0635\u062E";
        t["\uFCB3"] = "\u0635\u0645";
        t["\uFCB4"] = "\u0636\u062C";
        t["\uFCB5"] = "\u0636\u062D";
        t["\uFCB6"] = "\u0636\u062E";
        t["\uFCB7"] = "\u0636\u0645";
        t["\uFCB8"] = "\u0637\u062D";
        t["\uFCB9"] = "\u0638\u0645";
        t["\uFCBA"] = "\u0639\u062C";
        t["\uFCBB"] = "\u0639\u0645";
        t["\uFCBC"] = "\u063A\u062C";
        t["\uFCBD"] = "\u063A\u0645";
        t["\uFCBE"] = "\u0641\u062C";
        t["\uFCBF"] = "\u0641\u062D";
        t["\uFCC0"] = "\u0641\u062E";
        t["\uFCC1"] = "\u0641\u0645";
        t["\uFCC2"] = "\u0642\u062D";
        t["\uFCC3"] = "\u0642\u0645";
        t["\uFCC4"] = "\u0643\u062C";
        t["\uFCC5"] = "\u0643\u062D";
        t["\uFCC6"] = "\u0643\u062E";
        t["\uFCC7"] = "\u0643\u0644";
        t["\uFCC8"] = "\u0643\u0645";
        t["\uFCC9"] = "\u0644\u062C";
        t["\uFCCA"] = "\u0644\u062D";
        t["\uFCCB"] = "\u0644\u062E";
        t["\uFCCC"] = "\u0644\u0645";
        t["\uFCCD"] = "\u0644\u0647";
        t["\uFCCE"] = "\u0645\u062C";
        t["\uFCCF"] = "\u0645\u062D";
        t["\uFCD0"] = "\u0645\u062E";
        t["\uFCD1"] = "\u0645\u0645";
        t["\uFCD2"] = "\u0646\u062C";
        t["\uFCD3"] = "\u0646\u062D";
        t["\uFCD4"] = "\u0646\u062E";
        t["\uFCD5"] = "\u0646\u0645";
        t["\uFCD6"] = "\u0646\u0647";
        t["\uFCD7"] = "\u0647\u062C";
        t["\uFCD8"] = "\u0647\u0645";
        t["\uFCD9"] = "\u0647\u0670";
        t["\uFCDA"] = "\u064A\u062C";
        t["\uFCDB"] = "\u064A\u062D";
        t["\uFCDC"] = "\u064A\u062E";
        t["\uFCDD"] = "\u064A\u0645";
        t["\uFCDE"] = "\u064A\u0647";
        t["\uFCDF"] = "\u0626\u0645";
        t["\uFCE0"] = "\u0626\u0647";
        t["\uFCE1"] = "\u0628\u0645";
        t["\uFCE2"] = "\u0628\u0647";
        t["\uFCE3"] = "\u062A\u0645";
        t["\uFCE4"] = "\u062A\u0647";
        t["\uFCE5"] = "\u062B\u0645";
        t["\uFCE6"] = "\u062B\u0647";
        t["\uFCE7"] = "\u0633\u0645";
        t["\uFCE8"] = "\u0633\u0647";
        t["\uFCE9"] = "\u0634\u0645";
        t["\uFCEA"] = "\u0634\u0647";
        t["\uFCEB"] = "\u0643\u0644";
        t["\uFCEC"] = "\u0643\u0645";
        t["\uFCED"] = "\u0644\u0645";
        t["\uFCEE"] = "\u0646\u0645";
        t["\uFCEF"] = "\u0646\u0647";
        t["\uFCF0"] = "\u064A\u0645";
        t["\uFCF1"] = "\u064A\u0647";
        t["\uFCF2"] = "\u0640\u064E\u0651";
        t["\uFCF3"] = "\u0640\u064F\u0651";
        t["\uFCF4"] = "\u0640\u0650\u0651";
        t["\uFCF5"] = "\u0637\u0649";
        t["\uFCF6"] = "\u0637\u064A";
        t["\uFCF7"] = "\u0639\u0649";
        t["\uFCF8"] = "\u0639\u064A";
        t["\uFCF9"] = "\u063A\u0649";
        t["\uFCFA"] = "\u063A\u064A";
        t["\uFCFB"] = "\u0633\u0649";
        t["\uFCFC"] = "\u0633\u064A";
        t["\uFCFD"] = "\u0634\u0649";
        t["\uFCFE"] = "\u0634\u064A";
        t["\uFCFF"] = "\u062D\u0649";
        t["\uFD00"] = "\u062D\u064A";
        t["\uFD01"] = "\u062C\u0649";
        t["\uFD02"] = "\u062C\u064A";
        t["\uFD03"] = "\u062E\u0649";
        t["\uFD04"] = "\u062E\u064A";
        t["\uFD05"] = "\u0635\u0649";
        t["\uFD06"] = "\u0635\u064A";
        t["\uFD07"] = "\u0636\u0649";
        t["\uFD08"] = "\u0636\u064A";
        t["\uFD09"] = "\u0634\u062C";
        t["\uFD0A"] = "\u0634\u062D";
        t["\uFD0B"] = "\u0634\u062E";
        t["\uFD0C"] = "\u0634\u0645";
        t["\uFD0D"] = "\u0634\u0631";
        t["\uFD0E"] = "\u0633\u0631";
        t["\uFD0F"] = "\u0635\u0631";
        t["\uFD10"] = "\u0636\u0631";
        t["\uFD11"] = "\u0637\u0649";
        t["\uFD12"] = "\u0637\u064A";
        t["\uFD13"] = "\u0639\u0649";
        t["\uFD14"] = "\u0639\u064A";
        t["\uFD15"] = "\u063A\u0649";
        t["\uFD16"] = "\u063A\u064A";
        t["\uFD17"] = "\u0633\u0649";
        t["\uFD18"] = "\u0633\u064A";
        t["\uFD19"] = "\u0634\u0649";
        t["\uFD1A"] = "\u0634\u064A";
        t["\uFD1B"] = "\u062D\u0649";
        t["\uFD1C"] = "\u062D\u064A";
        t["\uFD1D"] = "\u062C\u0649";
        t["\uFD1E"] = "\u062C\u064A";
        t["\uFD1F"] = "\u062E\u0649";
        t["\uFD20"] = "\u062E\u064A";
        t["\uFD21"] = "\u0635\u0649";
        t["\uFD22"] = "\u0635\u064A";
        t["\uFD23"] = "\u0636\u0649";
        t["\uFD24"] = "\u0636\u064A";
        t["\uFD25"] = "\u0634\u062C";
        t["\uFD26"] = "\u0634\u062D";
        t["\uFD27"] = "\u0634\u062E";
        t["\uFD28"] = "\u0634\u0645";
        t["\uFD29"] = "\u0634\u0631";
        t["\uFD2A"] = "\u0633\u0631";
        t["\uFD2B"] = "\u0635\u0631";
        t["\uFD2C"] = "\u0636\u0631";
        t["\uFD2D"] = "\u0634\u062C";
        t["\uFD2E"] = "\u0634\u062D";
        t["\uFD2F"] = "\u0634\u062E";
        t["\uFD30"] = "\u0634\u0645";
        t["\uFD31"] = "\u0633\u0647";
        t["\uFD32"] = "\u0634\u0647";
        t["\uFD33"] = "\u0637\u0645";
        t["\uFD34"] = "\u0633\u062C";
        t["\uFD35"] = "\u0633\u062D";
        t["\uFD36"] = "\u0633\u062E";
        t["\uFD37"] = "\u0634\u062C";
        t["\uFD38"] = "\u0634\u062D";
        t["\uFD39"] = "\u0634\u062E";
        t["\uFD3A"] = "\u0637\u0645";
        t["\uFD3B"] = "\u0638\u0645";
        t["\uFD3C"] = "\u0627\u064B";
        t["\uFD3D"] = "\u0627\u064B";
        t["\uFD50"] = "\u062A\u062C\u0645";
        t["\uFD51"] = "\u062A\u062D\u062C";
        t["\uFD52"] = "\u062A\u062D\u062C";
        t["\uFD53"] = "\u062A\u062D\u0645";
        t["\uFD54"] = "\u062A\u062E\u0645";
        t["\uFD55"] = "\u062A\u0645\u062C";
        t["\uFD56"] = "\u062A\u0645\u062D";
        t["\uFD57"] = "\u062A\u0645\u062E";
        t["\uFD58"] = "\u062C\u0645\u062D";
        t["\uFD59"] = "\u062C\u0645\u062D";
        t["\uFD5A"] = "\u062D\u0645\u064A";
        t["\uFD5B"] = "\u062D\u0645\u0649";
        t["\uFD5C"] = "\u0633\u062D\u062C";
        t["\uFD5D"] = "\u0633\u062C\u062D";
        t["\uFD5E"] = "\u0633\u062C\u0649";
        t["\uFD5F"] = "\u0633\u0645\u062D";
        t["\uFD60"] = "\u0633\u0645\u062D";
        t["\uFD61"] = "\u0633\u0645\u062C";
        t["\uFD62"] = "\u0633\u0645\u0645";
        t["\uFD63"] = "\u0633\u0645\u0645";
        t["\uFD64"] = "\u0635\u062D\u062D";
        t["\uFD65"] = "\u0635\u062D\u062D";
        t["\uFD66"] = "\u0635\u0645\u0645";
        t["\uFD67"] = "\u0634\u062D\u0645";
        t["\uFD68"] = "\u0634\u062D\u0645";
        t["\uFD69"] = "\u0634\u062C\u064A";
        t["\uFD6A"] = "\u0634\u0645\u062E";
        t["\uFD6B"] = "\u0634\u0645\u062E";
        t["\uFD6C"] = "\u0634\u0645\u0645";
        t["\uFD6D"] = "\u0634\u0645\u0645";
        t["\uFD6E"] = "\u0636\u062D\u0649";
        t["\uFD6F"] = "\u0636\u062E\u0645";
        t["\uFD70"] = "\u0636\u062E\u0645";
        t["\uFD71"] = "\u0637\u0645\u062D";
        t["\uFD72"] = "\u0637\u0645\u062D";
        t["\uFD73"] = "\u0637\u0645\u0645";
        t["\uFD74"] = "\u0637\u0645\u064A";
        t["\uFD75"] = "\u0639\u062C\u0645";
        t["\uFD76"] = "\u0639\u0645\u0645";
        t["\uFD77"] = "\u0639\u0645\u0645";
        t["\uFD78"] = "\u0639\u0645\u0649";
        t["\uFD79"] = "\u063A\u0645\u0645";
        t["\uFD7A"] = "\u063A\u0645\u064A";
        t["\uFD7B"] = "\u063A\u0645\u0649";
        t["\uFD7C"] = "\u0641\u062E\u0645";
        t["\uFD7D"] = "\u0641\u062E\u0645";
        t["\uFD7E"] = "\u0642\u0645\u062D";
        t["\uFD7F"] = "\u0642\u0645\u0645";
        t["\uFD80"] = "\u0644\u062D\u0645";
        t["\uFD81"] = "\u0644\u062D\u064A";
        t["\uFD82"] = "\u0644\u062D\u0649";
        t["\uFD83"] = "\u0644\u062C\u062C";
        t["\uFD84"] = "\u0644\u062C\u062C";
        t["\uFD85"] = "\u0644\u062E\u0645";
        t["\uFD86"] = "\u0644\u062E\u0645";
        t["\uFD87"] = "\u0644\u0645\u062D";
        t["\uFD88"] = "\u0644\u0645\u062D";
        t["\uFD89"] = "\u0645\u062D\u062C";
        t["\uFD8A"] = "\u0645\u062D\u0645";
        t["\uFD8B"] = "\u0645\u062D\u064A";
        t["\uFD8C"] = "\u0645\u062C\u062D";
        t["\uFD8D"] = "\u0645\u062C\u0645";
        t["\uFD8E"] = "\u0645\u062E\u062C";
        t["\uFD8F"] = "\u0645\u062E\u0645";
        t["\uFD92"] = "\u0645\u062C\u062E";
        t["\uFD93"] = "\u0647\u0645\u062C";
        t["\uFD94"] = "\u0647\u0645\u0645";
        t["\uFD95"] = "\u0646\u062D\u0645";
        t["\uFD96"] = "\u0646\u062D\u0649";
        t["\uFD97"] = "\u0646\u062C\u0645";
        t["\uFD98"] = "\u0646\u062C\u0645";
        t["\uFD99"] = "\u0646\u062C\u0649";
        t["\uFD9A"] = "\u0646\u0645\u064A";
        t["\uFD9B"] = "\u0646\u0645\u0649";
        t["\uFD9C"] = "\u064A\u0645\u0645";
        t["\uFD9D"] = "\u064A\u0645\u0645";
        t["\uFD9E"] = "\u0628\u062E\u064A";
        t["\uFD9F"] = "\u062A\u062C\u064A";
        t["\uFDA0"] = "\u062A\u062C\u0649";
        t["\uFDA1"] = "\u062A\u062E\u064A";
        t["\uFDA2"] = "\u062A\u062E\u0649";
        t["\uFDA3"] = "\u062A\u0645\u064A";
        t["\uFDA4"] = "\u062A\u0645\u0649";
        t["\uFDA5"] = "\u062C\u0645\u064A";
        t["\uFDA6"] = "\u062C\u062D\u0649";
        t["\uFDA7"] = "\u062C\u0645\u0649";
        t["\uFDA8"] = "\u0633\u062E\u0649";
        t["\uFDA9"] = "\u0635\u062D\u064A";
        t["\uFDAA"] = "\u0634\u062D\u064A";
        t["\uFDAB"] = "\u0636\u062D\u064A";
        t["\uFDAC"] = "\u0644\u062C\u064A";
        t["\uFDAD"] = "\u0644\u0645\u064A";
        t["\uFDAE"] = "\u064A\u062D\u064A";
        t["\uFDAF"] = "\u064A\u062C\u064A";
        t["\uFDB0"] = "\u064A\u0645\u064A";
        t["\uFDB1"] = "\u0645\u0645\u064A";
        t["\uFDB2"] = "\u0642\u0645\u064A";
        t["\uFDB3"] = "\u0646\u062D\u064A";
        t["\uFDB4"] = "\u0642\u0645\u062D";
        t["\uFDB5"] = "\u0644\u062D\u0645";
        t["\uFDB6"] = "\u0639\u0645\u064A";
        t["\uFDB7"] = "\u0643\u0645\u064A";
        t["\uFDB8"] = "\u0646\u062C\u062D";
        t["\uFDB9"] = "\u0645\u062E\u064A";
        t["\uFDBA"] = "\u0644\u062C\u0645";
        t["\uFDBB"] = "\u0643\u0645\u0645";
        t["\uFDBC"] = "\u0644\u062C\u0645";
        t["\uFDBD"] = "\u0646\u062C\u062D";
        t["\uFDBE"] = "\u062C\u062D\u064A";
        t["\uFDBF"] = "\u062D\u062C\u064A";
        t["\uFDC0"] = "\u0645\u062C\u064A";
        t["\uFDC1"] = "\u0641\u0645\u064A";
        t["\uFDC2"] = "\u0628\u062D\u064A";
        t["\uFDC3"] = "\u0643\u0645\u0645";
        t["\uFDC4"] = "\u0639\u062C\u0645";
        t["\uFDC5"] = "\u0635\u0645\u0645";
        t["\uFDC6"] = "\u0633\u062E\u064A";
        t["\uFDC7"] = "\u0646\u062C\u064A";
        t["\uFE49"] = "\u203E";
        t["\uFE4A"] = "\u203E";
        t["\uFE4B"] = "\u203E";
        t["\uFE4C"] = "\u203E";
        t["\uFE4D"] = "_";
        t["\uFE4E"] = "_";
        t["\uFE4F"] = "_";
        t["\uFE80"] = "\u0621";
        t["\uFE81"] = "\u0622";
        t["\uFE82"] = "\u0622";
        t["\uFE83"] = "\u0623";
        t["\uFE84"] = "\u0623";
        t["\uFE85"] = "\u0624";
        t["\uFE86"] = "\u0624";
        t["\uFE87"] = "\u0625";
        t["\uFE88"] = "\u0625";
        t["\uFE89"] = "\u0626";
        t["\uFE8A"] = "\u0626";
        t["\uFE8B"] = "\u0626";
        t["\uFE8C"] = "\u0626";
        t["\uFE8D"] = "\u0627";
        t["\uFE8E"] = "\u0627";
        t["\uFE8F"] = "\u0628";
        t["\uFE90"] = "\u0628";
        t["\uFE91"] = "\u0628";
        t["\uFE92"] = "\u0628";
        t["\uFE93"] = "\u0629";
        t["\uFE94"] = "\u0629";
        t["\uFE95"] = "\u062A";
        t["\uFE96"] = "\u062A";
        t["\uFE97"] = "\u062A";
        t["\uFE98"] = "\u062A";
        t["\uFE99"] = "\u062B";
        t["\uFE9A"] = "\u062B";
        t["\uFE9B"] = "\u062B";
        t["\uFE9C"] = "\u062B";
        t["\uFE9D"] = "\u062C";
        t["\uFE9E"] = "\u062C";
        t["\uFE9F"] = "\u062C";
        t["\uFEA0"] = "\u062C";
        t["\uFEA1"] = "\u062D";
        t["\uFEA2"] = "\u062D";
        t["\uFEA3"] = "\u062D";
        t["\uFEA4"] = "\u062D";
        t["\uFEA5"] = "\u062E";
        t["\uFEA6"] = "\u062E";
        t["\uFEA7"] = "\u062E";
        t["\uFEA8"] = "\u062E";
        t["\uFEA9"] = "\u062F";
        t["\uFEAA"] = "\u062F";
        t["\uFEAB"] = "\u0630";
        t["\uFEAC"] = "\u0630";
        t["\uFEAD"] = "\u0631";
        t["\uFEAE"] = "\u0631";
        t["\uFEAF"] = "\u0632";
        t["\uFEB0"] = "\u0632";
        t["\uFEB1"] = "\u0633";
        t["\uFEB2"] = "\u0633";
        t["\uFEB3"] = "\u0633";
        t["\uFEB4"] = "\u0633";
        t["\uFEB5"] = "\u0634";
        t["\uFEB6"] = "\u0634";
        t["\uFEB7"] = "\u0634";
        t["\uFEB8"] = "\u0634";
        t["\uFEB9"] = "\u0635";
        t["\uFEBA"] = "\u0635";
        t["\uFEBB"] = "\u0635";
        t["\uFEBC"] = "\u0635";
        t["\uFEBD"] = "\u0636";
        t["\uFEBE"] = "\u0636";
        t["\uFEBF"] = "\u0636";
        t["\uFEC0"] = "\u0636";
        t["\uFEC1"] = "\u0637";
        t["\uFEC2"] = "\u0637";
        t["\uFEC3"] = "\u0637";
        t["\uFEC4"] = "\u0637";
        t["\uFEC5"] = "\u0638";
        t["\uFEC6"] = "\u0638";
        t["\uFEC7"] = "\u0638";
        t["\uFEC8"] = "\u0638";
        t["\uFEC9"] = "\u0639";
        t["\uFECA"] = "\u0639";
        t["\uFECB"] = "\u0639";
        t["\uFECC"] = "\u0639";
        t["\uFECD"] = "\u063A";
        t["\uFECE"] = "\u063A";
        t["\uFECF"] = "\u063A";
        t["\uFED0"] = "\u063A";
        t["\uFED1"] = "\u0641";
        t["\uFED2"] = "\u0641";
        t["\uFED3"] = "\u0641";
        t["\uFED4"] = "\u0641";
        t["\uFED5"] = "\u0642";
        t["\uFED6"] = "\u0642";
        t["\uFED7"] = "\u0642";
        t["\uFED8"] = "\u0642";
        t["\uFED9"] = "\u0643";
        t["\uFEDA"] = "\u0643";
        t["\uFEDB"] = "\u0643";
        t["\uFEDC"] = "\u0643";
        t["\uFEDD"] = "\u0644";
        t["\uFEDE"] = "\u0644";
        t["\uFEDF"] = "\u0644";
        t["\uFEE0"] = "\u0644";
        t["\uFEE1"] = "\u0645";
        t["\uFEE2"] = "\u0645";
        t["\uFEE3"] = "\u0645";
        t["\uFEE4"] = "\u0645";
        t["\uFEE5"] = "\u0646";
        t["\uFEE6"] = "\u0646";
        t["\uFEE7"] = "\u0646";
        t["\uFEE8"] = "\u0646";
        t["\uFEE9"] = "\u0647";
        t["\uFEEA"] = "\u0647";
        t["\uFEEB"] = "\u0647";
        t["\uFEEC"] = "\u0647";
        t["\uFEED"] = "\u0648";
        t["\uFEEE"] = "\u0648";
        t["\uFEEF"] = "\u0649";
        t["\uFEF0"] = "\u0649";
        t["\uFEF1"] = "\u064A";
        t["\uFEF2"] = "\u064A";
        t["\uFEF3"] = "\u064A";
        t["\uFEF4"] = "\u064A";
        t["\uFEF5"] = "\u0644\u0622";
        t["\uFEF6"] = "\u0644\u0622";
        t["\uFEF7"] = "\u0644\u0623";
        t["\uFEF8"] = "\u0644\u0623";
        t["\uFEF9"] = "\u0644\u0625";
        t["\uFEFA"] = "\u0644\u0625";
        t["\uFEFB"] = "\u0644\u0627";
        t["\uFEFC"] = "\u0644\u0627";
      });
      function reverseIfRtl(chars) {
        var charsLength = chars.length;
        if (charsLength <= 1 || !isRTLRangeFor(chars.charCodeAt(0))) {
          return chars;
        }
        var s = "";
        for (var ii = charsLength - 1; ii >= 0; ii--) {
          s += chars[ii];
        }
        return s;
      }
      exports.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
      exports.reverseIfRtl = reverseIfRtl;
      exports.getUnicodeRangeFor = getUnicodeRangeFor;
      exports.getNormalizedUnicodes = getNormalizedUnicodes;
      exports.getUnicodeForGlyph = getUnicodeForGlyph;

      /***/ }),
    /* 81 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PostScriptCompiler = exports.PostScriptEvaluator = exports.PDFFunctionFactory = exports.isPDFFunction = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var _ps_parser = __w_pdfjs_require__(141);

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var IsEvalSupportedCached = {
        get value() {
          return (0, _util.shadow)(this, "value", (0, _util.isEvalSupported)());
        }
      };

      var PDFFunctionFactory = function () {
        function PDFFunctionFactory(_ref) {
          var xref = _ref.xref,
            _ref$isEvalSupported = _ref.isEvalSupported,
            isEvalSupported = _ref$isEvalSupported === undefined ? true : _ref$isEvalSupported;

          _classCallCheck(this, PDFFunctionFactory);

          this.xref = xref;
          this.isEvalSupported = isEvalSupported !== false;
        }

        _createClass(PDFFunctionFactory, [{
          key: "create",
          value: function create(fn) {
            return PDFFunction.parse({
              xref: this.xref,
              isEvalSupported: this.isEvalSupported,
              fn: fn
            });
          }
        }, {
          key: "createFromArray",
          value: function createFromArray(fnObj) {
            return PDFFunction.parseArray({
              xref: this.xref,
              isEvalSupported: this.isEvalSupported,
              fnObj: fnObj
            });
          }
        }, {
          key: "createFromIR",
          value: function createFromIR(IR) {
            return PDFFunction.fromIR({
              xref: this.xref,
              isEvalSupported: this.isEvalSupported,
              IR: IR
            });
          }
        }, {
          key: "createIR",
          value: function createIR(fn) {
            return PDFFunction.getIR({
              xref: this.xref,
              isEvalSupported: this.isEvalSupported,
              fn: fn
            });
          }
        }]);

        return PDFFunctionFactory;
      }();

      var PDFFunction = function PDFFunctionClosure() {
        var CONSTRUCT_SAMPLED = 0;
        var CONSTRUCT_INTERPOLATED = 2;
        var CONSTRUCT_STICHED = 3;
        var CONSTRUCT_POSTSCRIPT = 4;
        return {
          getSampleArray: function getSampleArray(size, outputSize, bps, stream) {
            var i, ii;
            var length = 1;
            for (i = 0, ii = size.length; i < ii; i++) {
              length *= size[i];
            }
            length *= outputSize;
            var array = new Array(length);
            var codeSize = 0;
            var codeBuf = 0;
            var sampleMul = 1.0 / (Math.pow(2.0, bps) - 1);
            var strBytes = stream.getBytes((length * bps + 7) / 8);
            var strIdx = 0;
            for (i = 0; i < length; i++) {
              while (codeSize < bps) {
                codeBuf <<= 8;
                codeBuf |= strBytes[strIdx++];
                codeSize += 8;
              }
              codeSize -= bps;
              array[i] = (codeBuf >> codeSize) * sampleMul;
              codeBuf &= (1 << codeSize) - 1;
            }
            return array;
          },
          getIR: function getIR(_ref2) {
            var xref = _ref2.xref,
              isEvalSupported = _ref2.isEvalSupported,
              fn = _ref2.fn;

            var dict = fn.dict;
            if (!dict) {
              dict = fn;
            }
            var types = [this.constructSampled, null, this.constructInterpolated, this.constructStiched, this.constructPostScript];
            var typeNum = dict.get("FunctionType");
            var typeFn = types[typeNum];
            if (!typeFn) {
              throw new _util.FormatError("Unknown type of function");
            }
            return typeFn.call(this, {
              xref: xref,
              isEvalSupported: isEvalSupported,
              fn: fn,
              dict: dict
            });
          },
          fromIR: function fromIR(_ref3) {
            var xref = _ref3.xref,
              isEvalSupported = _ref3.isEvalSupported,
              IR = _ref3.IR;

            var type = IR[0];
            switch (type) {
              case CONSTRUCT_SAMPLED:
                return this.constructSampledFromIR({
                  xref: xref,
                  isEvalSupported: isEvalSupported,
                  IR: IR
                });
              case CONSTRUCT_INTERPOLATED:
                return this.constructInterpolatedFromIR({
                  xref: xref,
                  isEvalSupported: isEvalSupported,
                  IR: IR
                });
              case CONSTRUCT_STICHED:
                return this.constructStichedFromIR({
                  xref: xref,
                  isEvalSupported: isEvalSupported,
                  IR: IR
                });
              default:
                return this.constructPostScriptFromIR({
                  xref: xref,
                  isEvalSupported: isEvalSupported,
                  IR: IR
                });
            }
          },
          parse: function parse(_ref4) {
            var xref = _ref4.xref,
              isEvalSupported = _ref4.isEvalSupported,
              fn = _ref4.fn;

            var IR = this.getIR({
              xref: xref,
              isEvalSupported: isEvalSupported,
              fn: fn
            });
            return this.fromIR({
              xref: xref,
              isEvalSupported: isEvalSupported,
              IR: IR
            });
          },
          parseArray: function parseArray(_ref5) {
            var xref = _ref5.xref,
              isEvalSupported = _ref5.isEvalSupported,
              fnObj = _ref5.fnObj;

            if (!Array.isArray(fnObj)) {
              return this.parse({
                xref: xref,
                isEvalSupported: isEvalSupported,
                fn: fnObj
              });
            }
            var fnArray = [];
            for (var j = 0, jj = fnObj.length; j < jj; j++) {
              fnArray.push(this.parse({
                xref: xref,
                isEvalSupported: isEvalSupported,
                fn: xref.fetchIfRef(fnObj[j])
              }));
            }
            return function (src, srcOffset, dest, destOffset) {
              for (var i = 0, ii = fnArray.length; i < ii; i++) {
                fnArray[i](src, srcOffset, dest, destOffset + i);
              }
            };
          },
          constructSampled: function constructSampled(_ref6) {
            var xref = _ref6.xref,
              isEvalSupported = _ref6.isEvalSupported,
              fn = _ref6.fn,
              dict = _ref6.dict;

            function toMultiArray(arr) {
              var inputLength = arr.length;
              var out = [];
              var index = 0;
              for (var i = 0; i < inputLength; i += 2) {
                out[index] = [arr[i], arr[i + 1]];
                ++index;
              }
              return out;
            }
            var domain = dict.getArray("Domain");
            var range = dict.getArray("Range");
            if (!domain || !range) {
              throw new _util.FormatError("No domain or range");
            }
            var inputSize = domain.length / 2;
            var outputSize = range.length / 2;
            domain = toMultiArray(domain);
            range = toMultiArray(range);
            var size = dict.get("Size");
            var bps = dict.get("BitsPerSample");
            var order = dict.get("Order") || 1;
            if (order !== 1) {
              (0, _util.info)("No support for cubic spline interpolation: " + order);
            }
            var encode = dict.getArray("Encode");
            if (!encode) {
              encode = [];
              for (var i = 0; i < inputSize; ++i) {
                encode.push(0);
                encode.push(size[i] - 1);
              }
            }
            encode = toMultiArray(encode);
            var decode = dict.getArray("Decode");
            if (!decode) {
              decode = range;
            } else {
              decode = toMultiArray(decode);
            }
            var samples = this.getSampleArray(size, outputSize, bps, fn);
            return [CONSTRUCT_SAMPLED, inputSize, domain, encode, decode, samples, size, outputSize, Math.pow(2, bps) - 1, range];
          },
          constructSampledFromIR: function constructSampledFromIR(_ref7) {
            var xref = _ref7.xref,
              isEvalSupported = _ref7.isEvalSupported,
              IR = _ref7.IR;

            function interpolate(x, xmin, xmax, ymin, ymax) {
              return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
            }
            return function constructSampledFromIRResult(src, srcOffset, dest, destOffset) {
              var m = IR[1];
              var domain = IR[2];
              var encode = IR[3];
              var decode = IR[4];
              var samples = IR[5];
              var size = IR[6];
              var n = IR[7];
              var range = IR[9];
              var cubeVertices = 1 << m;
              var cubeN = new Float64Array(cubeVertices);
              var cubeVertex = new Uint32Array(cubeVertices);
              var i, j;
              for (j = 0; j < cubeVertices; j++) {
                cubeN[j] = 1;
              }
              var k = n,
                pos = 1;
              for (i = 0; i < m; ++i) {
                var domain_2i = domain[i][0];
                var domain_2i_1 = domain[i][1];
                var xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
                var e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
                var size_i = size[i];
                e = Math.min(Math.max(e, 0), size_i - 1);
                var e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
                var n0 = e0 + 1 - e;
                var n1 = e - e0;
                var offset0 = e0 * k;
                var offset1 = offset0 + k;
                for (j = 0; j < cubeVertices; j++) {
                  if (j & pos) {
                    cubeN[j] *= n1;
                    cubeVertex[j] += offset1;
                  } else {
                    cubeN[j] *= n0;
                    cubeVertex[j] += offset0;
                  }
                }
                k *= size_i;
                pos <<= 1;
              }
              for (j = 0; j < n; ++j) {
                var rj = 0;
                for (i = 0; i < cubeVertices; i++) {
                  rj += samples[cubeVertex[i] + j] * cubeN[i];
                }
                rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
                dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
              }
            };
          },
          constructInterpolated: function constructInterpolated(_ref8) {
            var xref = _ref8.xref,
              isEvalSupported = _ref8.isEvalSupported,
              fn = _ref8.fn,
              dict = _ref8.dict;

            var c0 = dict.getArray("C0") || [0];
            var c1 = dict.getArray("C1") || [1];
            var n = dict.get("N");
            if (!Array.isArray(c0) || !Array.isArray(c1)) {
              throw new _util.FormatError("Illegal dictionary for interpolated function");
            }
            var length = c0.length;
            var diff = [];
            for (var i = 0; i < length; ++i) {
              diff.push(c1[i] - c0[i]);
            }
            return [CONSTRUCT_INTERPOLATED, c0, diff, n];
          },
          constructInterpolatedFromIR: function constructInterpolatedFromIR(_ref9) {
            var xref = _ref9.xref,
              isEvalSupported = _ref9.isEvalSupported,
              IR = _ref9.IR;

            var c0 = IR[1];
            var diff = IR[2];
            var n = IR[3];
            var length = diff.length;
            return function constructInterpolatedFromIRResult(src, srcOffset, dest, destOffset) {
              var x = n === 1 ? src[srcOffset] : Math.pow(src[srcOffset], n);
              for (var j = 0; j < length; ++j) {
                dest[destOffset + j] = c0[j] + x * diff[j];
              }
            };
          },
          constructStiched: function constructStiched(_ref10) {
            var xref = _ref10.xref,
              isEvalSupported = _ref10.isEvalSupported,
              fn = _ref10.fn,
              dict = _ref10.dict;

            var domain = dict.getArray("Domain");
            if (!domain) {
              throw new _util.FormatError("No domain");
            }
            var inputSize = domain.length / 2;
            if (inputSize !== 1) {
              throw new _util.FormatError("Bad domain for stiched function");
            }
            var fnRefs = dict.get("Functions");
            var fns = [];
            for (var i = 0, ii = fnRefs.length; i < ii; ++i) {
              fns.push(this.getIR({
                xref: xref,
                isEvalSupported: isEvalSupported,
                fn: xref.fetchIfRef(fnRefs[i])
              }));
            }
            var bounds = dict.getArray("Bounds");
            var encode = dict.getArray("Encode");
            return [CONSTRUCT_STICHED, domain, bounds, encode, fns];
          },
          constructStichedFromIR: function constructStichedFromIR(_ref11) {
            var xref = _ref11.xref,
              isEvalSupported = _ref11.isEvalSupported,
              IR = _ref11.IR;

            var domain = IR[1];
            var bounds = IR[2];
            var encode = IR[3];
            var fnsIR = IR[4];
            var fns = [];
            var tmpBuf = new Float32Array(1);
            for (var i = 0, ii = fnsIR.length; i < ii; i++) {
              fns.push(this.fromIR({
                xref: xref,
                isEvalSupported: isEvalSupported,
                IR: fnsIR[i]
              }));
            }
            return function constructStichedFromIRResult(src, srcOffset, dest, destOffset) {
              var clip = function constructStichedFromIRClip(v, min, max) {
                if (v > max) {
                  v = max;
                } else if (v < min) {
                  v = min;
                }
                return v;
              };
              var v = clip(src[srcOffset], domain[0], domain[1]);
              for (var i = 0, ii = bounds.length; i < ii; ++i) {
                if (v < bounds[i]) {
                  break;
                }
              }
              var dmin = domain[0];
              if (i > 0) {
                dmin = bounds[i - 1];
              }
              var dmax = domain[1];
              if (i < bounds.length) {
                dmax = bounds[i];
              }
              var rmin = encode[2 * i];
              var rmax = encode[2 * i + 1];
              tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
              fns[i](tmpBuf, 0, dest, destOffset);
            };
          },
          constructPostScript: function constructPostScript(_ref12) {
            var xref = _ref12.xref,
              isEvalSupported = _ref12.isEvalSupported,
              fn = _ref12.fn,
              dict = _ref12.dict;

            var domain = dict.getArray("Domain");
            var range = dict.getArray("Range");
            if (!domain) {
              throw new _util.FormatError("No domain.");
            }
            if (!range) {
              throw new _util.FormatError("No range.");
            }
            var lexer = new _ps_parser.PostScriptLexer(fn);
            var parser = new _ps_parser.PostScriptParser(lexer);
            var code = parser.parse();
            return [CONSTRUCT_POSTSCRIPT, domain, range, code];
          },
          constructPostScriptFromIR: function constructPostScriptFromIR(_ref13) {
            var xref = _ref13.xref,
              isEvalSupported = _ref13.isEvalSupported,
              IR = _ref13.IR;

            var domain = IR[1];
            var range = IR[2];
            var code = IR[3];
            if (isEvalSupported && IsEvalSupportedCached.value) {
              var compiled = new PostScriptCompiler().compile(code, domain, range);
              if (compiled) {
                return new Function("src", "srcOffset", "dest", "destOffset", compiled);
              }
            }
            (0, _util.info)("Unable to compile PS function");
            var numOutputs = range.length >> 1;
            var numInputs = domain.length >> 1;
            var evaluator = new PostScriptEvaluator(code);
            var cache = Object.create(null);
            var MAX_CACHE_SIZE = 2048 * 4;
            var cache_available = MAX_CACHE_SIZE;
            var tmpBuf = new Float32Array(numInputs);
            return function constructPostScriptFromIRResult(src, srcOffset, dest, destOffset) {
              var i, value;
              var key = "";
              var input = tmpBuf;
              for (i = 0; i < numInputs; i++) {
                value = src[srcOffset + i];
                input[i] = value;
                key += value + "_";
              }
              var cachedValue = cache[key];
              if (cachedValue !== undefined) {
                dest.set(cachedValue, destOffset);
                return;
              }
              var output = new Float32Array(numOutputs);
              var stack = evaluator.execute(input);
              var stackIndex = stack.length - numOutputs;
              for (i = 0; i < numOutputs; i++) {
                value = stack[stackIndex + i];
                var bound = range[i * 2];
                if (value < bound) {
                  value = bound;
                } else {
                  bound = range[i * 2 + 1];
                  if (value > bound) {
                    value = bound;
                  }
                }
                output[i] = value;
              }
              if (cache_available > 0) {
                cache_available--;
                cache[key] = output;
              }
              dest.set(output, destOffset);
            };
          }
        };
      }();
      function isPDFFunction(v) {
        var fnDict;
        if ((typeof v === "undefined" ? "undefined" : _typeof(v)) !== "object") {
          return false;
        } else if ((0, _primitives.isDict)(v)) {
          fnDict = v;
        } else if ((0, _primitives.isStream)(v)) {
          fnDict = v.dict;
        } else {
          return false;
        }
        return fnDict.has("FunctionType");
      }
      var PostScriptStack = function PostScriptStackClosure() {
        var MAX_STACK_SIZE = 100;
        function PostScriptStack(initialStack) {
          this.stack = !initialStack ? [] : Array.prototype.slice.call(initialStack, 0);
        }
        PostScriptStack.prototype = {
          push: function PostScriptStack_push(value) {
            if (this.stack.length >= MAX_STACK_SIZE) {
              throw new Error("PostScript function stack overflow.");
            }
            this.stack.push(value);
          },
          pop: function PostScriptStack_pop() {
            if (this.stack.length <= 0) {
              throw new Error("PostScript function stack underflow.");
            }
            return this.stack.pop();
          },
          copy: function PostScriptStack_copy(n) {
            if (this.stack.length + n >= MAX_STACK_SIZE) {
              throw new Error("PostScript function stack overflow.");
            }
            var stack = this.stack;
            for (var i = stack.length - n, j = n - 1; j >= 0; j--, i++) {
              stack.push(stack[i]);
            }
          },
          index: function PostScriptStack_index(n) {
            this.push(this.stack[this.stack.length - n - 1]);
          },
          roll: function PostScriptStack_roll(n, p) {
            var stack = this.stack;
            var l = stack.length - n;
            var r = stack.length - 1,
              c = l + (p - Math.floor(p / n) * n),
              i,
              j,
              t;
            for (i = l, j = r; i < j; i++, j--) {
              t = stack[i];
              stack[i] = stack[j];
              stack[j] = t;
            }
            for (i = l, j = c - 1; i < j; i++, j--) {
              t = stack[i];
              stack[i] = stack[j];
              stack[j] = t;
            }
            for (i = c, j = r; i < j; i++, j--) {
              t = stack[i];
              stack[i] = stack[j];
              stack[j] = t;
            }
          }
        };
        return PostScriptStack;
      }();
      var PostScriptEvaluator = function PostScriptEvaluatorClosure() {
        function PostScriptEvaluator(operators) {
          this.operators = operators;
        }
        PostScriptEvaluator.prototype = {
          execute: function PostScriptEvaluator_execute(initialStack) {
            var stack = new PostScriptStack(initialStack);
            var counter = 0;
            var operators = this.operators;
            var length = operators.length;
            var operator, a, b;
            while (counter < length) {
              operator = operators[counter++];
              if (typeof operator === "number") {
                stack.push(operator);
                continue;
              }
              switch (operator) {
                case "jz":
                  b = stack.pop();
                  a = stack.pop();
                  if (!a) {
                    counter = b;
                  }
                  break;
                case "j":
                  a = stack.pop();
                  counter = a;
                  break;
                case "abs":
                  a = stack.pop();
                  stack.push(Math.abs(a));
                  break;
                case "add":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a + b);
                  break;
                case "and":
                  b = stack.pop();
                  a = stack.pop();
                  if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
                    stack.push(a && b);
                  } else {
                    stack.push(a & b);
                  }
                  break;
                case "atan":
                  a = stack.pop();
                  stack.push(Math.atan(a));
                  break;
                case "bitshift":
                  b = stack.pop();
                  a = stack.pop();
                  if (a > 0) {
                    stack.push(a << b);
                  } else {
                    stack.push(a >> b);
                  }
                  break;
                case "ceiling":
                  a = stack.pop();
                  stack.push(Math.ceil(a));
                  break;
                case "copy":
                  a = stack.pop();
                  stack.copy(a);
                  break;
                case "cos":
                  a = stack.pop();
                  stack.push(Math.cos(a));
                  break;
                case "cvi":
                  a = stack.pop() | 0;
                  stack.push(a);
                  break;
                case "cvr":
                  break;
                case "div":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a / b);
                  break;
                case "dup":
                  stack.copy(1);
                  break;
                case "eq":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a === b);
                  break;
                case "exch":
                  stack.roll(2, 1);
                  break;
                case "exp":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(Math.pow(a, b));
                  break;
                case "false":
                  stack.push(false);
                  break;
                case "floor":
                  a = stack.pop();
                  stack.push(Math.floor(a));
                  break;
                case "ge":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a >= b);
                  break;
                case "gt":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a > b);
                  break;
                case "idiv":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a / b | 0);
                  break;
                case "index":
                  a = stack.pop();
                  stack.index(a);
                  break;
                case "le":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a <= b);
                  break;
                case "ln":
                  a = stack.pop();
                  stack.push(Math.log(a));
                  break;
                case "log":
                  a = stack.pop();
                  stack.push(Math.log(a) / Math.LN10);
                  break;
                case "lt":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a < b);
                  break;
                case "mod":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a % b);
                  break;
                case "mul":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a * b);
                  break;
                case "ne":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a !== b);
                  break;
                case "neg":
                  a = stack.pop();
                  stack.push(-a);
                  break;
                case "not":
                  a = stack.pop();
                  if ((0, _util.isBool)(a)) {
                    stack.push(!a);
                  } else {
                    stack.push(~a);
                  }
                  break;
                case "or":
                  b = stack.pop();
                  a = stack.pop();
                  if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
                    stack.push(a || b);
                  } else {
                    stack.push(a | b);
                  }
                  break;
                case "pop":
                  stack.pop();
                  break;
                case "roll":
                  b = stack.pop();
                  a = stack.pop();
                  stack.roll(a, b);
                  break;
                case "round":
                  a = stack.pop();
                  stack.push(Math.round(a));
                  break;
                case "sin":
                  a = stack.pop();
                  stack.push(Math.sin(a));
                  break;
                case "sqrt":
                  a = stack.pop();
                  stack.push(Math.sqrt(a));
                  break;
                case "sub":
                  b = stack.pop();
                  a = stack.pop();
                  stack.push(a - b);
                  break;
                case "true":
                  stack.push(true);
                  break;
                case "truncate":
                  a = stack.pop();
                  a = a < 0 ? Math.ceil(a) : Math.floor(a);
                  stack.push(a);
                  break;
                case "xor":
                  b = stack.pop();
                  a = stack.pop();
                  if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
                    stack.push(a !== b);
                  } else {
                    stack.push(a ^ b);
                  }
                  break;
                default:
                  throw new _util.FormatError("Unknown operator " + operator);
              }
            }
            return stack.stack;
          }
        };
        return PostScriptEvaluator;
      }();
      var PostScriptCompiler = function PostScriptCompilerClosure() {
        function AstNode(type) {
          this.type = type;
        }
        AstNode.prototype.visit = function (visitor) {
          throw new Error("abstract method");
        };
        function AstArgument(index, min, max) {
          AstNode.call(this, "args");
          this.index = index;
          this.min = min;
          this.max = max;
        }
        AstArgument.prototype = Object.create(AstNode.prototype);
        AstArgument.prototype.visit = function (visitor) {
          visitor.visitArgument(this);
        };
        function AstLiteral(number) {
          AstNode.call(this, "literal");
          this.number = number;
          this.min = number;
          this.max = number;
        }
        AstLiteral.prototype = Object.create(AstNode.prototype);
        AstLiteral.prototype.visit = function (visitor) {
          visitor.visitLiteral(this);
        };
        function AstBinaryOperation(op, arg1, arg2, min, max) {
          AstNode.call(this, "binary");
          this.op = op;
          this.arg1 = arg1;
          this.arg2 = arg2;
          this.min = min;
          this.max = max;
        }
        AstBinaryOperation.prototype = Object.create(AstNode.prototype);
        AstBinaryOperation.prototype.visit = function (visitor) {
          visitor.visitBinaryOperation(this);
        };
        function AstMin(arg, max) {
          AstNode.call(this, "max");
          this.arg = arg;
          this.min = arg.min;
          this.max = max;
        }
        AstMin.prototype = Object.create(AstNode.prototype);
        AstMin.prototype.visit = function (visitor) {
          visitor.visitMin(this);
        };
        function AstVariable(index, min, max) {
          AstNode.call(this, "var");
          this.index = index;
          this.min = min;
          this.max = max;
        }
        AstVariable.prototype = Object.create(AstNode.prototype);
        AstVariable.prototype.visit = function (visitor) {
          visitor.visitVariable(this);
        };
        function AstVariableDefinition(variable, arg) {
          AstNode.call(this, "definition");
          this.variable = variable;
          this.arg = arg;
        }
        AstVariableDefinition.prototype = Object.create(AstNode.prototype);
        AstVariableDefinition.prototype.visit = function (visitor) {
          visitor.visitVariableDefinition(this);
        };
        function ExpressionBuilderVisitor() {
          this.parts = [];
        }
        ExpressionBuilderVisitor.prototype = {
          visitArgument: function visitArgument(arg) {
            this.parts.push("Math.max(", arg.min, ", Math.min(", arg.max, ", src[srcOffset + ", arg.index, "]))");
          },
          visitVariable: function visitVariable(variable) {
            this.parts.push("v", variable.index);
          },
          visitLiteral: function visitLiteral(literal) {
            this.parts.push(literal.number);
          },
          visitBinaryOperation: function visitBinaryOperation(operation) {
            this.parts.push("(");
            operation.arg1.visit(this);
            this.parts.push(" ", operation.op, " ");
            operation.arg2.visit(this);
            this.parts.push(")");
          },
          visitVariableDefinition: function visitVariableDefinition(definition) {
            this.parts.push("var ");
            definition.variable.visit(this);
            this.parts.push(" = ");
            definition.arg.visit(this);
            this.parts.push(";");
          },
          visitMin: function visitMin(max) {
            this.parts.push("Math.min(");
            max.arg.visit(this);
            this.parts.push(", ", max.max, ")");
          },
          toString: function toString() {
            return this.parts.join("");
          }
        };
        function buildAddOperation(num1, num2) {
          if (num2.type === "literal" && num2.number === 0) {
            return num1;
          }
          if (num1.type === "literal" && num1.number === 0) {
            return num2;
          }
          if (num2.type === "literal" && num1.type === "literal") {
            return new AstLiteral(num1.number + num2.number);
          }
          return new AstBinaryOperation("+", num1, num2, num1.min + num2.min, num1.max + num2.max);
        }
        function buildMulOperation(num1, num2) {
          if (num2.type === "literal") {
            if (num2.number === 0) {
              return new AstLiteral(0);
            } else if (num2.number === 1) {
              return num1;
            } else if (num1.type === "literal") {
              return new AstLiteral(num1.number * num2.number);
            }
          }
          if (num1.type === "literal") {
            if (num1.number === 0) {
              return new AstLiteral(0);
            } else if (num1.number === 1) {
              return num2;
            }
          }
          var min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
          var max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
          return new AstBinaryOperation("*", num1, num2, min, max);
        }
        function buildSubOperation(num1, num2) {
          if (num2.type === "literal") {
            if (num2.number === 0) {
              return num1;
            } else if (num1.type === "literal") {
              return new AstLiteral(num1.number - num2.number);
            }
          }
          if (num2.type === "binary" && num2.op === "-" && num1.type === "literal" && num1.number === 1 && num2.arg1.type === "literal" && num2.arg1.number === 1) {
            return num2.arg2;
          }
          return new AstBinaryOperation("-", num1, num2, num1.min - num2.max, num1.max - num2.min);
        }
        function buildMinOperation(num1, max) {
          if (num1.min >= max) {
            return new AstLiteral(max);
          } else if (num1.max <= max) {
            return num1;
          }
          return new AstMin(num1, max);
        }
        function PostScriptCompiler() {}
        PostScriptCompiler.prototype = {
          compile: function PostScriptCompiler_compile(code, domain, range) {
            var stack = [];
            var i, ii;
            var instructions = [];
            var inputSize = domain.length >> 1,
              outputSize = range.length >> 1;
            var lastRegister = 0;
            var n, j;
            var num1, num2, ast1, ast2, tmpVar, item;
            for (i = 0; i < inputSize; i++) {
              stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
            }
            for (i = 0, ii = code.length; i < ii; i++) {
              item = code[i];
              if (typeof item === "number") {
                stack.push(new AstLiteral(item));
                continue;
              }
              switch (item) {
                case "add":
                  if (stack.length < 2) {
                    return null;
                  }
                  num2 = stack.pop();
                  num1 = stack.pop();
                  stack.push(buildAddOperation(num1, num2));
                  break;
                case "cvr":
                  if (stack.length < 1) {
                    return null;
                  }
                  break;
                case "mul":
                  if (stack.length < 2) {
                    return null;
                  }
                  num2 = stack.pop();
                  num1 = stack.pop();
                  stack.push(buildMulOperation(num1, num2));
                  break;
                case "sub":
                  if (stack.length < 2) {
                    return null;
                  }
                  num2 = stack.pop();
                  num1 = stack.pop();
                  stack.push(buildSubOperation(num1, num2));
                  break;
                case "exch":
                  if (stack.length < 2) {
                    return null;
                  }
                  ast1 = stack.pop();
                  ast2 = stack.pop();
                  stack.push(ast1, ast2);
                  break;
                case "pop":
                  if (stack.length < 1) {
                    return null;
                  }
                  stack.pop();
                  break;
                case "index":
                  if (stack.length < 1) {
                    return null;
                  }
                  num1 = stack.pop();
                  if (num1.type !== "literal") {
                    return null;
                  }
                  n = num1.number;
                  if (n < 0 || !Number.isInteger(n) || stack.length < n) {
                    return null;
                  }
                  ast1 = stack[stack.length - n - 1];
                  if (ast1.type === "literal" || ast1.type === "var") {
                    stack.push(ast1);
                    break;
                  }
                  tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                  stack[stack.length - n - 1] = tmpVar;
                  stack.push(tmpVar);
                  instructions.push(new AstVariableDefinition(tmpVar, ast1));
                  break;
                case "dup":
                  if (stack.length < 1) {
                    return null;
                  }
                  if (typeof code[i + 1] === "number" && code[i + 2] === "gt" && code[i + 3] === i + 7 && code[i + 4] === "jz" && code[i + 5] === "pop" && code[i + 6] === code[i + 1]) {
                    num1 = stack.pop();
                    stack.push(buildMinOperation(num1, code[i + 1]));
                    i += 6;
                    break;
                  }
                  ast1 = stack[stack.length - 1];
                  if (ast1.type === "literal" || ast1.type === "var") {
                    stack.push(ast1);
                    break;
                  }
                  tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                  stack[stack.length - 1] = tmpVar;
                  stack.push(tmpVar);
                  instructions.push(new AstVariableDefinition(tmpVar, ast1));
                  break;
                case "roll":
                  if (stack.length < 2) {
                    return null;
                  }
                  num2 = stack.pop();
                  num1 = stack.pop();
                  if (num2.type !== "literal" || num1.type !== "literal") {
                    return null;
                  }
                  j = num2.number;
                  n = num1.number;
                  if (n <= 0 || !Number.isInteger(n) || !Number.isInteger(j) || stack.length < n) {
                    return null;
                  }
                  j = (j % n + n) % n;
                  if (j === 0) {
                    break;
                  }
                  Array.prototype.push.apply(stack, stack.splice(stack.length - n, n - j));
                  break;
                default:
                  return null;
              }
            }
            if (stack.length !== outputSize) {
              return null;
            }
            var result = [];
            instructions.forEach(function (instruction) {
              var statementBuilder = new ExpressionBuilderVisitor();
              instruction.visit(statementBuilder);
              result.push(statementBuilder.toString());
            });
            stack.forEach(function (expr, i) {
              var statementBuilder = new ExpressionBuilderVisitor();
              expr.visit(statementBuilder);
              var min = range[i * 2],
                max = range[i * 2 + 1];
              var out = [statementBuilder.toString()];
              if (min > expr.min) {
                out.unshift("Math.max(", min, ", ");
                out.push(")");
              }
              if (max < expr.max) {
                out.unshift("Math.min(", max, ", ");
                out.push(")");
              }
              out.unshift("dest[destOffset + ", i, "] = ");
              out.push(";");
              result.push(out.join(""));
            });
            return result.join("\n");
          }
        };
        return PostScriptCompiler;
      }();
      exports.isPDFFunction = isPDFFunction;
      exports.PDFFunctionFactory = PDFFunctionFactory;
      exports.PostScriptEvaluator = PostScriptEvaluator;
      exports.PostScriptCompiler = PostScriptCompiler;

      /***/ }),
    /* 82 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var pdfjsVersion = "1.10.97";
      var pdfjsBuild = "7d0fce73";
      var pdfjsCoreWorker = __w_pdfjs_require__(83);
      exports.WorkerMessageHandler = pdfjsCoreWorker.WorkerMessageHandler;

      /***/ }),
    /* 83 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.WorkerMessageHandler = exports.WorkerTask = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var _util = __w_pdfjs_require__(0);

      var _pdf_manager = __w_pdfjs_require__(126);

      var _primitives = __w_pdfjs_require__(2);

      var WorkerTask = function WorkerTaskClosure() {
        function WorkerTask(name) {
          this.name = name;
          this.terminated = false;
          this._capability = (0, _util.createPromiseCapability)();
        }
        WorkerTask.prototype = {
          get finished() {
            return this._capability.promise;
          },
          finish: function finish() {
            this._capability.resolve();
          },
          terminate: function terminate() {
            this.terminated = true;
          },
          ensureNotTerminated: function ensureNotTerminated() {
            if (this.terminated) {
              throw new Error("Worker task was terminated");
            }
          }
        };
        return WorkerTask;
      }();

      var PDFWorkerStream = function PDFWorkerStreamClosure() {
        function PDFWorkerStream(msgHandler) {
          this._msgHandler = msgHandler;
          this._contentLength = null;
          this._fullRequestReader = null;
          this._rangeRequestReaders = [];
        }
        PDFWorkerStream.prototype = {
          getFullReader: function getFullReader() {
            (0, _util.assert)(!this._fullRequestReader);
            this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
            return this._fullRequestReader;
          },
          getRangeReader: function getRangeReader(begin, end) {
            var reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
            this._rangeRequestReaders.push(reader);
            return reader;
          },
          cancelAllRequests: function cancelAllRequests(reason) {
            if (this._fullRequestReader) {
              this._fullRequestReader.cancel(reason);
            }
            var readers = this._rangeRequestReaders.slice(0);
            readers.forEach(function (reader) {
              reader.cancel(reason);
            });
          }
        };
        function PDFWorkerStreamReader(msgHandler) {
          var _this = this;

          this._msgHandler = msgHandler;
          this._contentLength = null;
          this._isRangeSupported = false;
          this._isStreamingSupported = false;
          var readableStream = this._msgHandler.sendWithStream("GetReader");
          this._reader = readableStream.getReader();
          this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then(function (data) {
            _this._isStreamingSupported = data.isStreamingSupported;
            _this._isRangeSupported = data.isRangeSupported;
            _this._contentLength = data.contentLength;
          });
        }
        PDFWorkerStreamReader.prototype = {
          get headersReady() {
            return this._headersReady;
          },
          get contentLength() {
            return this._contentLength;
          },
          get isStreamingSupported() {
            return this._isStreamingSupported;
          },
          get isRangeSupported() {
            return this._isRangeSupported;
          },
          read: function read() {
            return this._reader.read().then(function (_ref) {
              var value = _ref.value,
                done = _ref.done;

              if (done) {
                return {
                  value: undefined,
                  done: true
                };
              }
              return {
                value: value.buffer,
                done: false
              };
            });
          },
          cancel: function cancel(reason) {
            this._reader.cancel(reason);
          }
        };
        function PDFWorkerStreamRangeReader(begin, end, msgHandler) {
          this._msgHandler = msgHandler;
          this.onProgress = null;
          var readableStream = this._msgHandler.sendWithStream("GetRangeReader", {
            begin: begin,
            end: end
          });
          this._reader = readableStream.getReader();
        }
        PDFWorkerStreamRangeReader.prototype = {
          get isStreamingSupported() {
            return false;
          },
          read: function read() {
            return this._reader.read().then(function (_ref2) {
              var value = _ref2.value,
                done = _ref2.done;

              if (done) {
                return {
                  value: undefined,
                  done: true
                };
              }
              return {
                value: value.buffer,
                done: false
              };
            });
          },
          cancel: function cancel(reason) {
            this._reader.cancel(reason);
          }
        };
        return PDFWorkerStream;
      }();
      var WorkerMessageHandler = {
        setup: function setup(handler, port) {
          var testMessageProcessed = false;
          handler.on("test", function wphSetupTest(data) {
            if (testMessageProcessed) {
              return;
            }
            testMessageProcessed = true;
            if (!(data instanceof Uint8Array)) {
              handler.send("test", "main", false);
              return;
            }
            var supportTransfers = data[0] === 255;
            handler.postMessageTransfers = supportTransfers;
            var xhr = new XMLHttpRequest();
            var responseExists = "response" in xhr;
            try {
              xhr.responseType;
            } catch (e) {
              responseExists = false;
            }
            if (!responseExists) {
              handler.send("test", false);
              return;
            }
            handler.send("test", {
              supportTypedArray: true,
              supportTransfers: supportTransfers
            });
          });
          handler.on("configure", function wphConfigure(data) {
            (0, _util.setVerbosityLevel)(data.verbosity);
          });
          handler.on("GetDocRequest", function wphSetupDoc(data) {
            return WorkerMessageHandler.createDocumentHandler(data, port);
          });
        },
        createDocumentHandler: function createDocumentHandler(docParams, port) {
          var pdfManager;
          var terminated = false;
          var cancelXHRs = null;
          var WorkerTasks = [];
          var apiVersion = docParams.apiVersion;
          var workerVersion = "1.10.97";
          if (apiVersion !== null && apiVersion !== workerVersion) {
            throw new Error("The API version \"" + apiVersion + "\" does not match " + ("the Worker version \"" + workerVersion + "\"."));
          }
          var docId = docParams.docId;
          var docBaseUrl = docParams.docBaseUrl;
          var workerHandlerName = docParams.docId + "_worker";
          var handler = new _util.MessageHandler(workerHandlerName, docId, port);
          handler.postMessageTransfers = docParams.postMessageTransfers;
          function ensureNotTerminated() {
            if (terminated) {
              throw new Error("Worker was terminated");
            }
          }
          function startWorkerTask(task) {
            WorkerTasks.push(task);
          }
          function finishWorkerTask(task) {
            task.finish();
            var i = WorkerTasks.indexOf(task);
            WorkerTasks.splice(i, 1);
          }
          function loadDocument(recoveryMode) {
            var loadDocumentCapability = (0, _util.createPromiseCapability)();
            var parseSuccess = function parseSuccess() {
              var numPagesPromise = pdfManager.ensureDoc("numPages");
              var fingerprintPromise = pdfManager.ensureDoc("fingerprint");
              var encryptedPromise = pdfManager.ensureXRef("encrypt");
              Promise.all([numPagesPromise, fingerprintPromise, encryptedPromise]).then(function onDocReady(results) {
                var doc = {
                  numPages: results[0],
                  fingerprint: results[1],
                  encrypted: !!results[2]
                };
                loadDocumentCapability.resolve(doc);
              }, parseFailure);
            };
            var parseFailure = function parseFailure(e) {
              loadDocumentCapability.reject(e);
            };
            pdfManager.ensureDoc("checkHeader", []).then(function () {
              pdfManager.ensureDoc("parseStartXRef", []).then(function () {
                pdfManager.ensureDoc("parse", [recoveryMode]).then(parseSuccess, parseFailure);
              }, parseFailure);
            }, parseFailure);
            return loadDocumentCapability.promise;
          }
          function getPdfManager(data, evaluatorOptions) {
            var pdfManagerCapability = (0, _util.createPromiseCapability)();
            var pdfManager;
            var source = data.source;
            if (source.data) {
              try {
                pdfManager = new _pdf_manager.LocalPdfManager(docId, source.data, source.password, evaluatorOptions, docBaseUrl);
                pdfManagerCapability.resolve(pdfManager);
              } catch (ex) {
                pdfManagerCapability.reject(ex);
              }
              return pdfManagerCapability.promise;
            }
            var pdfStream,
              cachedChunks = [];
            try {
              pdfStream = new PDFWorkerStream(handler);
            } catch (ex) {
              pdfManagerCapability.reject(ex);
              return pdfManagerCapability.promise;
            }
            var fullRequest = pdfStream.getFullReader();
            fullRequest.headersReady.then(function () {
              if (!fullRequest.isRangeSupported) {
                return;
              }
              var disableAutoFetch = source.disableAutoFetch || fullRequest.isStreamingSupported;
              pdfManager = new _pdf_manager.NetworkPdfManager(docId, pdfStream, {
                msgHandler: handler,
                url: source.url,
                password: source.password,
                length: fullRequest.contentLength,
                disableAutoFetch: disableAutoFetch,
                rangeChunkSize: source.rangeChunkSize
              }, evaluatorOptions, docBaseUrl);
              for (var i = 0; i < cachedChunks.length; i++) {
                pdfManager.sendProgressiveData(cachedChunks[i]);
              }
              cachedChunks = [];
              pdfManagerCapability.resolve(pdfManager);
              cancelXHRs = null;
            }).catch(function (reason) {
              pdfManagerCapability.reject(reason);
              cancelXHRs = null;
            });
            var loaded = 0;
            var flushChunks = function flushChunks() {
              var pdfFile = (0, _util.arraysToBytes)(cachedChunks);
              if (source.length && pdfFile.length !== source.length) {
                (0, _util.warn)("reported HTTP length is different from actual");
              }
              try {
                pdfManager = new _pdf_manager.LocalPdfManager(docId, pdfFile, source.password, evaluatorOptions, docBaseUrl);
                pdfManagerCapability.resolve(pdfManager);
              } catch (ex) {
                pdfManagerCapability.reject(ex);
              }
              cachedChunks = [];
            };
            var readPromise = new Promise(function (resolve, reject) {
              var readChunk = function readChunk(chunk) {
                try {
                  ensureNotTerminated();
                  if (chunk.done) {
                    if (!pdfManager) {
                      flushChunks();
                    }
                    cancelXHRs = null;
                    return;
                  }
                  var data = chunk.value;
                  loaded += (0, _util.arrayByteLength)(data);
                  if (!fullRequest.isStreamingSupported) {
                    handler.send("DocProgress", {
                      loaded: loaded,
                      total: Math.max(loaded, fullRequest.contentLength || 0)
                    });
                  }
                  if (pdfManager) {
                    pdfManager.sendProgressiveData(data);
                  } else {
                    cachedChunks.push(data);
                  }
                  fullRequest.read().then(readChunk, reject);
                } catch (e) {
                  reject(e);
                }
              };
              fullRequest.read().then(readChunk, reject);
            });
            readPromise.catch(function (e) {
              pdfManagerCapability.reject(e);
              cancelXHRs = null;
            });
            cancelXHRs = function cancelXHRs() {
              pdfStream.cancelAllRequests("abort");
            };
            return pdfManagerCapability.promise;
          }
          function setupDoc(data) {
            function onSuccess(doc) {
              ensureNotTerminated();
              handler.send("GetDoc", { pdfInfo: doc });
            }
            function onFailure(e) {
              ensureNotTerminated();
              if (e instanceof _util.PasswordException) {
                var task = new WorkerTask("PasswordException: response " + e.code);
                startWorkerTask(task);
                handler.sendWithPromise("PasswordRequest", e).then(function (data) {
                  finishWorkerTask(task);
                  pdfManager.updatePassword(data.password);
                  pdfManagerReady();
                }).catch(function (ex) {
                  finishWorkerTask(task);
                  handler.send("PasswordException", ex);
                }.bind(null, e));
              } else if (e instanceof _util.InvalidPDFException) {
                handler.send("InvalidPDF", e);
              } else if (e instanceof _util.MissingPDFException) {
                handler.send("MissingPDF", e);
              } else if (e instanceof _util.UnexpectedResponseException) {
                handler.send("UnexpectedResponse", e);
              } else {
                handler.send("UnknownError", new _util.UnknownErrorException(e.message, e.toString()));
              }
            }
            function pdfManagerReady() {
              ensureNotTerminated();
              loadDocument(false).then(onSuccess, function loadFailure(ex) {
                ensureNotTerminated();
                if (!(ex instanceof _util.XRefParseException)) {
                  onFailure(ex);
                  return;
                }
                pdfManager.requestLoadedStream();
                pdfManager.onLoadedStream().then(function () {
                  ensureNotTerminated();
                  loadDocument(true).then(onSuccess, onFailure);
                });
              }, onFailure);
            }
            ensureNotTerminated();
            var evaluatorOptions = {
              forceDataSchema: data.disableCreateObjectURL,
              maxImageSize: data.maxImageSize === undefined ? -1 : data.maxImageSize,
              disableFontFace: data.disableFontFace,
              nativeImageDecoderSupport: data.nativeImageDecoderSupport,
              ignoreErrors: data.ignoreErrors,
              isEvalSupported: data.isEvalSupported
            };
            getPdfManager(data, evaluatorOptions).then(function (newPdfManager) {
              if (terminated) {
                newPdfManager.terminate();
                throw new Error("Worker was terminated");
              }
              pdfManager = newPdfManager;
              handler.send("PDFManagerReady", null);
              pdfManager.onLoadedStream().then(function (stream) {
                handler.send("DataLoaded", { length: stream.bytes.byteLength });
              });
            }).then(pdfManagerReady, onFailure);
          }
          handler.on("GetPage", function wphSetupGetPage(data) {
            return pdfManager.getPage(data.pageIndex).then(function (page) {
              var rotatePromise = pdfManager.ensure(page, "rotate");
              var refPromise = pdfManager.ensure(page, "ref");
              var userUnitPromise = pdfManager.ensure(page, "userUnit");
              var viewPromise = pdfManager.ensure(page, "view");
              return Promise.all([rotatePromise, refPromise, userUnitPromise, viewPromise]).then(function (results) {
                return {
                  rotate: results[0],
                  ref: results[1],
                  userUnit: results[2],
                  view: results[3]
                };
              });
            });
          });
          handler.on("GetPageIndex", function wphSetupGetPageIndex(data) {
            var ref = new _primitives.Ref(data.ref.num, data.ref.gen);
            var catalog = pdfManager.pdfDocument.catalog;
            return catalog.getPageIndex(ref);
          });
          handler.on("GetDestinations", function wphSetupGetDestinations(data) {
            return pdfManager.ensureCatalog("destinations");
          });
          handler.on("GetDestination", function wphSetupGetDestination(data) {
            return pdfManager.ensureCatalog("getDestination", [data.id]);
          });
          handler.on("GetPageLabels", function wphSetupGetPageLabels(data) {
            return pdfManager.ensureCatalog("pageLabels");
          });
          handler.on("GetPageMode", function wphSetupGetPageMode(data) {
            return pdfManager.ensureCatalog("pageMode");
          });
          handler.on("GetAttachments", function wphSetupGetAttachments(data) {
            return pdfManager.ensureCatalog("attachments");
          });
          handler.on("GetJavaScript", function wphSetupGetJavaScript(data) {
            return pdfManager.ensureCatalog("javaScript");
          });
          handler.on("GetOutline", function wphSetupGetOutline(data) {
            return pdfManager.ensureCatalog("documentOutline");
          });
          handler.on("GetMetadata", function wphSetupGetMetadata(data) {
            return Promise.all([pdfManager.ensureDoc("documentInfo"), pdfManager.ensureCatalog("metadata")]);
          });
          handler.on("GetData", function wphSetupGetData(data) {
            pdfManager.requestLoadedStream();
            return pdfManager.onLoadedStream().then(function (stream) {
              return stream.bytes;
            });
          });
          handler.on("GetStats", function wphSetupGetStats(data) {
            return pdfManager.pdfDocument.xref.stats;
          });
          handler.on("GetAnnotations", function wphSetupGetAnnotations(data) {
            return pdfManager.getPage(data.pageIndex).then(function (page) {
              return pdfManager.ensure(page, "getAnnotationsData", [data.intent]);
            });
          });
          handler.on("RenderPageRequest", function wphSetupRenderPage(data) {
            var pageIndex = data.pageIndex;
            pdfManager.getPage(pageIndex).then(function (page) {
              var task = new WorkerTask("RenderPageRequest: page " + pageIndex);
              startWorkerTask(task);
              var pageNum = pageIndex + 1;
              var start = Date.now();
              page.getOperatorList({
                handler: handler,
                task: task,
                intent: data.intent,
                renderInteractiveForms: data.renderInteractiveForms
              }).then(function (operatorList) {
                finishWorkerTask(task);
                (0, _util.info)("page=" + pageNum + " - getOperatorList: time=" + (Date.now() - start) + "ms, len=" + operatorList.totalLength);
              }, function (e) {
                finishWorkerTask(task);
                if (task.terminated) {
                  return;
                }
                handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.unknown });
                var minimumStackMessage = "worker.js: while trying to getPage() and getOperatorList()";
                var wrappedException;
                if (typeof e === "string") {
                  wrappedException = {
                    message: e,
                    stack: minimumStackMessage
                  };
                } else if ((typeof e === "undefined" ? "undefined" : _typeof(e)) === "object") {
                  wrappedException = {
                    message: e.message || e.toString(),
                    stack: e.stack || minimumStackMessage
                  };
                } else {
                  wrappedException = {
                    message: "Unknown exception type: " + (typeof e === "undefined" ? "undefined" : _typeof(e)),
                    stack: minimumStackMessage
                  };
                }
                handler.send("PageError", {
                  pageNum: pageNum,
                  error: wrappedException,
                  intent: data.intent
                });
              });
            });
          }, this);
          handler.on("GetTextContent", function wphExtractText(data, sink) {
            var pageIndex = data.pageIndex;
            sink.onPull = function (desiredSize) {};
            sink.onCancel = function (reason) {};
            pdfManager.getPage(pageIndex).then(function (page) {
              var task = new WorkerTask("GetTextContent: page " + pageIndex);
              startWorkerTask(task);
              var pageNum = pageIndex + 1;
              var start = Date.now();
              page.extractTextContent({
                handler: handler,
                task: task,
                sink: sink,
                normalizeWhitespace: data.normalizeWhitespace,
                combineTextItems: data.combineTextItems
              }).then(function () {
                finishWorkerTask(task);
                (0, _util.info)("text indexing: page=" + pageNum + " - time=" + (Date.now() - start) + "ms");
                sink.close();
              }, function (reason) {
                finishWorkerTask(task);
                if (task.terminated) {
                  return;
                }
                sink.error(reason);
                throw reason;
              });
            });
          });
          handler.on("Cleanup", function wphCleanup(data) {
            return pdfManager.cleanup();
          });
          handler.on("Terminate", function wphTerminate(data) {
            terminated = true;
            if (pdfManager) {
              pdfManager.terminate();
              pdfManager = null;
            }
            if (cancelXHRs) {
              cancelXHRs();
            }
            var waitOn = [];
            WorkerTasks.forEach(function (task) {
              waitOn.push(task.finished);
              task.terminate();
            });
            return Promise.all(waitOn).then(function () {
              handler.destroy();
              handler = null;
            });
          });
          handler.on("Ready", function wphReady(data) {
            setupDoc(docParams);
            docParams = null;
          });
          return workerHandlerName;
        },
        initializeFromPort: function initializeFromPort(port) {
          var handler = new _util.MessageHandler("worker", "main", port);
          WorkerMessageHandler.setup(handler, port);
          handler.send("ready", null);
        }
      };
      function isMessagePort(maybePort) {
        return typeof maybePort.postMessage === "function" && "onmessage" in maybePort;
      }
      if (typeof window === "undefined" && !(0, _util.isNodeJS)() && typeof self !== "undefined" && isMessagePort(self)) {
        WorkerMessageHandler.initializeFromPort(self);
      }
      exports.WorkerTask = WorkerTask;
      exports.WorkerMessageHandler = WorkerMessageHandler;

      /***/ }),
    /* 84 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      if (typeof PDFJS === "undefined" || !PDFJS.compatibilityChecked) {
        var globalScope = __w_pdfjs_require__(85);
        var userAgent = typeof navigator !== "undefined" && navigator.userAgent || "";
        var isAndroid = /Android/.test(userAgent);
        var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
        var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
        var isChrome = userAgent.indexOf("Chrom") >= 0;
        var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
        var isIOSChrome = userAgent.indexOf("CriOS") >= 0;
        var isIE = userAgent.indexOf("Trident") >= 0;
        var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
        var isOpera = userAgent.indexOf("Opera") >= 0;
        var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
        var hasDOM = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === "object";
        if (typeof PDFJS === "undefined") {
          globalScope.PDFJS = {};
        }
        PDFJS.compatibilityChecked = true;
        (function checkTypedArrayCompatibility() {
          if (typeof Uint8ClampedArray === "undefined") {
            globalScope.Uint8ClampedArray = __w_pdfjs_require__(86);
          }
          if (typeof Uint8Array !== "undefined") {
            if (typeof Uint8Array.prototype.subarray === "undefined") {
              Uint8Array.prototype.subarray = function subarray(start, end) {
                return new Uint8Array(this.slice(start, end));
              };
              Float32Array.prototype.subarray = function subarray(start, end) {
                return new Float32Array(this.slice(start, end));
              };
            }
            if (typeof Float64Array === "undefined") {
              globalScope.Float64Array = Float32Array;
            }
            return;
          }
          function subarray(start, end) {
            return new TypedArray(this.slice(start, end));
          }
          function setArrayOffset(array, offset) {
            if (arguments.length < 2) {
              offset = 0;
            }
            for (var i = 0, n = array.length; i < n; ++i, ++offset) {
              this[offset] = array[i] & 0xFF;
            }
          }
          function Uint32ArrayView(buffer, length) {
            this.buffer = buffer;
            this.byteLength = buffer.length;
            this.length = length;
            ensureUint32ArrayViewProps(this.length);
          }
          Uint32ArrayView.prototype = Object.create(null);
          var uint32ArrayViewSetters = 0;
          function createUint32ArrayProp(index) {
            return {
              get: function get() {
                var buffer = this.buffer,
                  offset = index << 2;
                return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
              },
              set: function set(value) {
                var buffer = this.buffer,
                  offset = index << 2;
                buffer[offset] = value & 255;
                buffer[offset + 1] = value >> 8 & 255;
                buffer[offset + 2] = value >> 16 & 255;
                buffer[offset + 3] = value >>> 24 & 255;
              }
            };
          }
          function ensureUint32ArrayViewProps(length) {
            while (uint32ArrayViewSetters < length) {
              Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
              uint32ArrayViewSetters++;
            }
          }
          function TypedArray(arg1) {
            var result, i, n;
            if (typeof arg1 === "number") {
              result = [];
              for (i = 0; i < arg1; ++i) {
                result[i] = 0;
              }
            } else if ("slice" in arg1) {
              result = arg1.slice(0);
            } else {
              result = [];
              for (i = 0, n = arg1.length; i < n; ++i) {
                result[i] = arg1[i];
              }
            }
            result.subarray = subarray;
            result.buffer = result;
            result.byteLength = result.length;
            result.set = setArrayOffset;
            if ((typeof arg1 === "undefined" ? "undefined" : _typeof(arg1)) === "object" && arg1.buffer) {
              result.buffer = arg1.buffer;
            }
            return result;
          }
          globalScope.Uint8Array = TypedArray;
          globalScope.Int8Array = TypedArray;
          globalScope.Int32Array = TypedArray;
          globalScope.Uint16Array = TypedArray;
          globalScope.Float32Array = TypedArray;
          globalScope.Float64Array = TypedArray;
          globalScope.Uint32Array = function () {
            if (arguments.length === 3) {
              if (arguments[1] !== 0) {
                throw new Error("offset !== 0 is not supported");
              }
              return new Uint32ArrayView(arguments[0], arguments[2]);
            }
            return TypedArray.apply(this, arguments);
          };
        })();
        (function canvasPixelArrayBuffer() {
          if (!hasDOM || !window.CanvasPixelArray) {
            return;
          }
          var cpaProto = window.CanvasPixelArray.prototype;
          if ("buffer" in cpaProto) {
            return;
          }
          Object.defineProperty(cpaProto, "buffer", {
            get: function get() {
              return this;
            },

            enumerable: false,
            configurable: true
          });
          Object.defineProperty(cpaProto, "byteLength", {
            get: function get() {
              return this.length;
            },

            enumerable: false,
            configurable: true
          });
        })();
        (function normalizeURLObject() {
          if (!globalScope.URL) {
            globalScope.URL = globalScope.webkitURL;
          }
        })();
        (function checkObjectDefinePropertyCompatibility() {
          if (typeof Object.defineProperty !== "undefined") {
            var definePropertyPossible = true;
            try {
              if (hasDOM) {
                Object.defineProperty(new Image(), "id", { value: "test" });
              }
              var Test = function Test() {};
              Test.prototype = {
                get id() {}
              };
              Object.defineProperty(new Test(), "id", {
                value: "",
                configurable: true,
                enumerable: true,
                writable: false
              });
            } catch (e) {
              definePropertyPossible = false;
            }
            if (definePropertyPossible) {
              return;
            }
          }
          Object.defineProperty = function objectDefineProperty(obj, name, def) {
            delete obj[name];
            if ("get" in def) {
              obj.__defineGetter__(name, def["get"]);
            }
            if ("set" in def) {
              obj.__defineSetter__(name, def["set"]);
            }
            if ("value" in def) {
              obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
                this.__defineGetter__(name, function objectDefinePropertyGetter() {
                  return value;
                });
                return value;
              });
              obj[name] = def.value;
            }
          };
        })();
        (function checkXMLHttpRequestResponseCompatibility() {
          if (typeof XMLHttpRequest === "undefined") {
            return;
          }
          var xhrPrototype = XMLHttpRequest.prototype;
          var xhr = new XMLHttpRequest();
          if (!("overrideMimeType" in xhr)) {
            Object.defineProperty(xhrPrototype, "overrideMimeType", {
              value: function xmlHttpRequestOverrideMimeType(mimeType) {}
            });
          }
          if ("responseType" in xhr) {
            return;
          }
          Object.defineProperty(xhrPrototype, "responseType", {
            get: function xmlHttpRequestGetResponseType() {
              return this._responseType || "text";
            },
            set: function xmlHttpRequestSetResponseType(value) {
              if (value === "text" || value === "arraybuffer") {
                this._responseType = value;
                if (value === "arraybuffer" && typeof this.overrideMimeType === "function") {
                  this.overrideMimeType("text/plain; charset=x-user-defined");
                }
              }
            }
          });
          if (typeof VBArray !== "undefined") {
            Object.defineProperty(xhrPrototype, "response", {
              get: function xmlHttpRequestResponseGet() {
                if (this.responseType === "arraybuffer") {
                  return new Uint8Array(new VBArray(this.responseBody).toArray());
                }
                return this.responseText;
              }
            });
            return;
          }
          Object.defineProperty(xhrPrototype, "response", {
            get: function xmlHttpRequestResponseGet() {
              if (this.responseType !== "arraybuffer") {
                return this.responseText;
              }
              var text = this.responseText;
              var i,
                n = text.length;
              var result = new Uint8Array(n);
              for (i = 0; i < n; ++i) {
                result[i] = text.charCodeAt(i) & 0xFF;
              }
              return result.buffer;
            }
          });
        })();
        (function checkWindowBtoaCompatibility() {
          if ("btoa" in globalScope) {
            return;
          }
          var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          globalScope.btoa = function (chars) {
            var buffer = "";
            var i, n;
            for (i = 0, n = chars.length; i < n; i += 3) {
              var b1 = chars.charCodeAt(i) & 0xFF;
              var b2 = chars.charCodeAt(i + 1) & 0xFF;
              var b3 = chars.charCodeAt(i + 2) & 0xFF;
              var d1 = b1 >> 2,
                d2 = (b1 & 3) << 4 | b2 >> 4;
              var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
              var d4 = i + 2 < n ? b3 & 0x3F : 64;
              buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
            }
            return buffer;
          };
        })();
        (function checkWindowAtobCompatibility() {
          if ("atob" in globalScope) {
            return;
          }
          var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          globalScope.atob = function (input) {
            input = input.replace(/=+$/, "");
            if (input.length % 4 === 1) {
              throw new Error("bad atob input");
            }
            for (var bc = 0, bs, buffer, idx = 0, output = ""; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
              buffer = digits.indexOf(buffer);
            }
            return output;
          };
        })();
        (function checkFunctionPrototypeBindCompatibility() {
          if (typeof Function.prototype.bind !== "undefined") {
            return;
          }
          Function.prototype.bind = function functionPrototypeBind(obj) {
            var fn = this,
              headArgs = Array.prototype.slice.call(arguments, 1);
            var bound = function functionPrototypeBindBound() {
              var args = headArgs.concat(Array.prototype.slice.call(arguments));
              return fn.apply(obj, args);
            };
            return bound;
          };
        })();
        (function checkDatasetProperty() {
          if (!hasDOM) {
            return;
          }
          var div = document.createElement("div");
          if ("dataset" in div) {
            return;
          }
          Object.defineProperty(HTMLElement.prototype, "dataset", {
            get: function get() {
              if (this._dataset) {
                return this._dataset;
              }
              var dataset = {};
              for (var j = 0, jj = this.attributes.length; j < jj; j++) {
                var attribute = this.attributes[j];
                if (attribute.name.substring(0, 5) !== "data-") {
                  continue;
                }
                var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
                  return ch.toUpperCase();
                });
                dataset[key] = attribute.value;
              }
              Object.defineProperty(this, "_dataset", {
                value: dataset,
                writable: false,
                enumerable: false
              });
              return dataset;
            },

            enumerable: true
          });
        })();
        (function checkClassListProperty() {
          function changeList(element, itemName, add, remove) {
            var s = element.className || "";
            var list = s.split(/\s+/g);
            if (list[0] === "") {
              list.shift();
            }
            var index = list.indexOf(itemName);
            if (index < 0 && add) {
              list.push(itemName);
            }
            if (index >= 0 && remove) {
              list.splice(index, 1);
            }
            element.className = list.join(" ");
            return index >= 0;
          }
          if (!hasDOM) {
            return;
          }
          var div = document.createElement("div");
          if ("classList" in div) {
            return;
          }
          var classListPrototype = {
            add: function add(name) {
              changeList(this.element, name, true, false);
            },
            contains: function contains(name) {
              return changeList(this.element, name, false, false);
            },
            remove: function remove(name) {
              changeList(this.element, name, false, true);
            },
            toggle: function toggle(name) {
              changeList(this.element, name, true, true);
            }
          };
          Object.defineProperty(HTMLElement.prototype, "classList", {
            get: function get() {
              if (this._classList) {
                return this._classList;
              }
              var classList = Object.create(classListPrototype, {
                element: {
                  value: this,
                  writable: false,
                  enumerable: true
                }
              });
              Object.defineProperty(this, "_classList", {
                value: classList,
                writable: false,
                enumerable: false
              });
              return classList;
            },

            enumerable: true
          });
        })();
        (function checkWorkerConsoleCompatibility() {
          if (typeof importScripts === "undefined" || "console" in globalScope) {
            return;
          }
          var consoleTimer = {};
          var workerConsole = {
            log: function log() {
              var args = Array.prototype.slice.call(arguments);
              globalScope.postMessage({
                targetName: "main",
                action: "console_log",
                data: args
              });
            },
            error: function error() {
              var args = Array.prototype.slice.call(arguments);
              globalScope.postMessage({
                targetName: "main",
                action: "console_error",
                data: args
              });
            },
            time: function time(name) {
              consoleTimer[name] = Date.now();
            },
            timeEnd: function timeEnd(name) {
              var time = consoleTimer[name];
              if (!time) {
                throw new Error("Unknown timer name " + name);
              }
              this.log("Timer:", name, Date.now() - time);
            }
          };
          globalScope.console = workerConsole;
        })();
        (function checkConsoleCompatibility() {
          if (!hasDOM) {
            return;
          }
          if (!("console" in window)) {
            window.console = {
              log: function log() {},
              error: function error() {},
              warn: function warn() {}
            };
            return;
          }
          if (!("bind" in console.log)) {
            console.log = function (fn) {
              return function (msg) {
                return fn(msg);
              };
            }(console.log);
            console.error = function (fn) {
              return function (msg) {
                return fn(msg);
              };
            }(console.error);
            console.warn = function (fn) {
              return function (msg) {
                return fn(msg);
              };
            }(console.warn);
            return;
          }
        })();
        (function checkOnClickCompatibility() {
          function ignoreIfTargetDisabled(event) {
            if (isDisabled(event.target)) {
              event.stopPropagation();
            }
          }
          function isDisabled(node) {
            return node.disabled || node.parentNode && isDisabled(node.parentNode);
          }
          if (isOpera) {
            document.addEventListener("click", ignoreIfTargetDisabled, true);
          }
        })();
        (function checkOnBlobSupport() {
          if (isIE || isIOSChrome) {
            PDFJS.disableCreateObjectURL = true;
          }
        })();
        (function checkNavigatorLanguage() {
          if (typeof navigator === "undefined") {
            return;
          }
          if ("language" in navigator) {
            return;
          }
          PDFJS.locale = navigator.userLanguage || "en-US";
        })();
        (function checkRangeRequests() {
          if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
            PDFJS.disableRange = true;
            PDFJS.disableStream = true;
          }
        })();
        (function checkHistoryManipulation() {
          if (!hasDOM) {
            return;
          }
          if (!history.pushState || isAndroidPre3) {
            PDFJS.disableHistory = true;
          }
        })();
        (function checkSetPresenceInImageData() {
          if (!hasDOM) {
            return;
          }
          if (window.CanvasPixelArray) {
            if (typeof window.CanvasPixelArray.prototype.set !== "function") {
              window.CanvasPixelArray.prototype.set = function (arr) {
                for (var i = 0, ii = this.length; i < ii; i++) {
                  this[i] = arr[i];
                }
              };
            }
          } else {
            var polyfill = false,
              versionMatch;
            if (isChrome) {
              versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
              polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
            } else if (isAndroid) {
              polyfill = isAndroidPre5;
            } else if (isSafari) {
              versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
              polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
            }
            if (polyfill) {
              var contextPrototype = window.CanvasRenderingContext2D.prototype;
              var createImageData = contextPrototype.createImageData;
              contextPrototype.createImageData = function (w, h) {
                var imageData = createImageData.call(this, w, h);
                imageData.data.set = function (arr) {
                  for (var i = 0, ii = this.length; i < ii; i++) {
                    this[i] = arr[i];
                  }
                };
                return imageData;
              };
              contextPrototype = null;
            }
          }
        })();
        (function checkRequestAnimationFrame() {
          function installFakeAnimationFrameFunctions() {
            window.requestAnimationFrame = function (callback) {
              return window.setTimeout(callback, 20);
            };
            window.cancelAnimationFrame = function (timeoutID) {
              window.clearTimeout(timeoutID);
            };
          }
          if (!hasDOM) {
            return;
          }
          if (isIOS) {
            installFakeAnimationFrameFunctions();
            return;
          }
          if ("requestAnimationFrame" in window) {
            return;
          }
          window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
          if (window.requestAnimationFrame) {
            return;
          }
          installFakeAnimationFrameFunctions();
        })();
        (function checkCanvasSizeLimitation() {
          if (isIOS || isAndroid) {
            PDFJS.maxCanvasPixels = 5242880;
          }
        })();
        (function checkFullscreenSupport() {
          if (!hasDOM) {
            return;
          }
          if (isIE && window.parent !== window) {
            PDFJS.disableFullscreen = true;
          }
        })();
        (function checkCurrentScript() {
          if (!hasDOM) {
            return;
          }
          if ("currentScript" in document) {
            return;
          }
          Object.defineProperty(document, "currentScript", {
            get: function get() {
              var scripts = document.getElementsByTagName("script");
              return scripts[scripts.length - 1];
            },

            enumerable: true,
            configurable: true
          });
        })();
        (function checkInputTypeNumberAssign() {
          if (!hasDOM) {
            return;
          }
          var el = document.createElement("input");
          try {
            el.type = "number";
          } catch (ex) {
            var inputProto = el.constructor.prototype;
            var typeProperty = Object.getOwnPropertyDescriptor(inputProto, "type");
            Object.defineProperty(inputProto, "type", {
              get: function get() {
                return typeProperty.get.call(this);
              },
              set: function set(value) {
                typeProperty.set.call(this, value === "number" ? "text" : value);
              },

              enumerable: true,
              configurable: true
            });
          }
        })();
        (function checkDocumentReadyState() {
          if (!hasDOM) {
            return;
          }
          if (!document.attachEvent) {
            return;
          }
          var documentProto = document.constructor.prototype;
          var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, "readyState");
          Object.defineProperty(documentProto, "readyState", {
            get: function get() {
              var value = readyStateProto.get.call(this);
              return value === "interactive" ? "loading" : value;
            },
            set: function set(value) {
              readyStateProto.set.call(this, value);
            },

            enumerable: true,
            configurable: true
          });
        })();
        (function checkChildNodeRemove() {
          if (!hasDOM) {
            return;
          }
          if (typeof Element.prototype.remove !== "undefined") {
            return;
          }
          Element.prototype.remove = function () {
            if (this.parentNode) {
              this.parentNode.removeChild(this);
            }
          };
        })();
        (function checkNumberIsNaN() {
          if (Number.isNaN) {
            return;
          }
          Number.isNaN = __w_pdfjs_require__(98);
        })();
        (function checkNumberIsInteger() {
          if (Number.isInteger) {
            return;
          }
          Number.isInteger = __w_pdfjs_require__(100);
        })();
        (function checkPromise() {
          if (globalScope.Promise) {
            return;
          }
          globalScope.Promise = __w_pdfjs_require__(103);
        })();
        (function checkWeakMap() {
          if (globalScope.WeakMap) {
            return;
          }
          globalScope.WeakMap = __w_pdfjs_require__(112);
        })();
        (function checkURLConstructor() {
          var hasWorkingUrl = false;
          try {
            if (typeof URL === "function" && _typeof(URL.prototype) === "object" && "origin" in URL.prototype) {
              var u = new URL("b", "http://a");
              u.pathname = "c%20d";
              hasWorkingUrl = u.href === "http://a/c%20d";
            }
          } catch (e) {}
          if (hasWorkingUrl) {
            return;
          }
          var relative = Object.create(null);
          relative["ftp"] = 21;
          relative["file"] = 0;
          relative["gopher"] = 70;
          relative["http"] = 80;
          relative["https"] = 443;
          relative["ws"] = 80;
          relative["wss"] = 443;
          var relativePathDotMapping = Object.create(null);
          relativePathDotMapping["%2e"] = ".";
          relativePathDotMapping[".%2e"] = "..";
          relativePathDotMapping["%2e."] = "..";
          relativePathDotMapping["%2e%2e"] = "..";
          function isRelativeScheme(scheme) {
            return relative[scheme] !== undefined;
          }
          function invalid() {
            clear.call(this);
            this._isInvalid = true;
          }
          function IDNAToASCII(h) {
            if (h === "") {
              invalid.call(this);
            }
            return h.toLowerCase();
          }
          function percentEscape(c) {
            var unicode = c.charCodeAt(0);
            if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
              return c;
            }
            return encodeURIComponent(c);
          }
          function percentEscapeQuery(c) {
            var unicode = c.charCodeAt(0);
            if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
              return c;
            }
            return encodeURIComponent(c);
          }
          var EOF,
            ALPHA = /[a-zA-Z]/,
            ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
          function parse(input, stateOverride, base) {
            function err(message) {
              errors.push(message);
            }
            var state = stateOverride || "scheme start",
              cursor = 0,
              buffer = "",
              seenAt = false,
              seenBracket = false,
              errors = [];
            loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
              var c = input[cursor];
              switch (state) {
                case "scheme start":
                  if (c && ALPHA.test(c)) {
                    buffer += c.toLowerCase();
                    state = "scheme";
                  } else if (!stateOverride) {
                    buffer = "";
                    state = "no scheme";
                    continue;
                  } else {
                    err("Invalid scheme.");
                    break loop;
                  }
                  break;
                case "scheme":
                  if (c && ALPHANUMERIC.test(c)) {
                    buffer += c.toLowerCase();
                  } else if (c === ":") {
                    this._scheme = buffer;
                    buffer = "";
                    if (stateOverride) {
                      break loop;
                    }
                    if (isRelativeScheme(this._scheme)) {
                      this._isRelative = true;
                    }
                    if (this._scheme === "file") {
                      state = "relative";
                    } else if (this._isRelative && base && base._scheme === this._scheme) {
                      state = "relative or authority";
                    } else if (this._isRelative) {
                      state = "authority first slash";
                    } else {
                      state = "scheme data";
                    }
                  } else if (!stateOverride) {
                    buffer = "";
                    cursor = 0;
                    state = "no scheme";
                    continue;
                  } else if (c === EOF) {
                    break loop;
                  } else {
                    err("Code point not allowed in scheme: " + c);
                    break loop;
                  }
                  break;
                case "scheme data":
                  if (c === "?") {
                    this._query = "?";
                    state = "query";
                  } else if (c === "#") {
                    this._fragment = "#";
                    state = "fragment";
                  } else {
                    if (c !== EOF && c !== "\t" && c !== "\n" && c !== "\r") {
                      this._schemeData += percentEscape(c);
                    }
                  }
                  break;
                case "no scheme":
                  if (!base || !isRelativeScheme(base._scheme)) {
                    err("Missing scheme.");
                    invalid.call(this);
                  } else {
                    state = "relative";
                    continue;
                  }
                  break;
                case "relative or authority":
                  if (c === "/" && input[cursor + 1] === "/") {
                    state = "authority ignore slashes";
                  } else {
                    err("Expected /, got: " + c);
                    state = "relative";
                    continue;
                  }
                  break;
                case "relative":
                  this._isRelative = true;
                  if (this._scheme !== "file") {
                    this._scheme = base._scheme;
                  }
                  if (c === EOF) {
                    this._host = base._host;
                    this._port = base._port;
                    this._path = base._path.slice();
                    this._query = base._query;
                    this._username = base._username;
                    this._password = base._password;
                    break loop;
                  } else if (c === "/" || c === "\\") {
                    if (c === "\\") {
                      err("\\ is an invalid code point.");
                    }
                    state = "relative slash";
                  } else if (c === "?") {
                    this._host = base._host;
                    this._port = base._port;
                    this._path = base._path.slice();
                    this._query = "?";
                    this._username = base._username;
                    this._password = base._password;
                    state = "query";
                  } else if (c === "#") {
                    this._host = base._host;
                    this._port = base._port;
                    this._path = base._path.slice();
                    this._query = base._query;
                    this._fragment = "#";
                    this._username = base._username;
                    this._password = base._password;
                    state = "fragment";
                  } else {
                    var nextC = input[cursor + 1];
                    var nextNextC = input[cursor + 2];
                    if (this._scheme !== "file" || !ALPHA.test(c) || nextC !== ":" && nextC !== "|" || nextNextC !== EOF && nextNextC !== "/" && nextNextC !== "\\" && nextNextC !== "?" && nextNextC !== "#") {
                      this._host = base._host;
                      this._port = base._port;
                      this._username = base._username;
                      this._password = base._password;
                      this._path = base._path.slice();
                      this._path.pop();
                    }
                    state = "relative path";
                    continue;
                  }
                  break;
                case "relative slash":
                  if (c === "/" || c === "\\") {
                    if (c === "\\") {
                      err("\\ is an invalid code point.");
                    }
                    if (this._scheme === "file") {
                      state = "file host";
                    } else {
                      state = "authority ignore slashes";
                    }
                  } else {
                    if (this._scheme !== "file") {
                      this._host = base._host;
                      this._port = base._port;
                      this._username = base._username;
                      this._password = base._password;
                    }
                    state = "relative path";
                    continue;
                  }
                  break;
                case "authority first slash":
                  if (c === "/") {
                    state = "authority second slash";
                  } else {
                    err("Expected '/', got: " + c);
                    state = "authority ignore slashes";
                    continue;
                  }
                  break;
                case "authority second slash":
                  state = "authority ignore slashes";
                  if (c !== "/") {
                    err("Expected '/', got: " + c);
                    continue;
                  }
                  break;
                case "authority ignore slashes":
                  if (c !== "/" && c !== "\\") {
                    state = "authority";
                    continue;
                  } else {
                    err("Expected authority, got: " + c);
                  }
                  break;
                case "authority":
                  if (c === "@") {
                    if (seenAt) {
                      err("@ already seen.");
                      buffer += "%40";
                    }
                    seenAt = true;
                    for (var i = 0; i < buffer.length; i++) {
                      var cp = buffer[i];
                      if (cp === "\t" || cp === "\n" || cp === "\r") {
                        err("Invalid whitespace in authority.");
                        continue;
                      }
                      if (cp === ":" && this._password === null) {
                        this._password = "";
                        continue;
                      }
                      var tempC = percentEscape(cp);
                      if (this._password !== null) {
                        this._password += tempC;
                      } else {
                        this._username += tempC;
                      }
                    }
                    buffer = "";
                  } else if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#") {
                    cursor -= buffer.length;
                    buffer = "";
                    state = "host";
                    continue;
                  } else {
                    buffer += c;
                  }
                  break;
                case "file host":
                  if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#") {
                    if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ":" || buffer[1] === "|")) {
                      state = "relative path";
                    } else if (buffer.length === 0) {
                      state = "relative path start";
                    } else {
                      this._host = IDNAToASCII.call(this, buffer);
                      buffer = "";
                      state = "relative path start";
                    }
                    continue;
                  } else if (c === "\t" || c === "\n" || c === "\r") {
                    err("Invalid whitespace in file host.");
                  } else {
                    buffer += c;
                  }
                  break;
                case "host":
                case "hostname":
                  if (c === ":" && !seenBracket) {
                    this._host = IDNAToASCII.call(this, buffer);
                    buffer = "";
                    state = "port";
                    if (stateOverride === "hostname") {
                      break loop;
                    }
                  } else if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#") {
                    this._host = IDNAToASCII.call(this, buffer);
                    buffer = "";
                    state = "relative path start";
                    if (stateOverride) {
                      break loop;
                    }
                    continue;
                  } else if (c !== "\t" && c !== "\n" && c !== "\r") {
                    if (c === "[") {
                      seenBracket = true;
                    } else if (c === "]") {
                      seenBracket = false;
                    }
                    buffer += c;
                  } else {
                    err("Invalid code point in host/hostname: " + c);
                  }
                  break;
                case "port":
                  if (/[0-9]/.test(c)) {
                    buffer += c;
                  } else if (c === EOF || c === "/" || c === "\\" || c === "?" || c === "#" || stateOverride) {
                    if (buffer !== "") {
                      var temp = parseInt(buffer, 10);
                      if (temp !== relative[this._scheme]) {
                        this._port = temp + "";
                      }
                      buffer = "";
                    }
                    if (stateOverride) {
                      break loop;
                    }
                    state = "relative path start";
                    continue;
                  } else if (c === "\t" || c === "\n" || c === "\r") {
                    err("Invalid code point in port: " + c);
                  } else {
                    invalid.call(this);
                  }
                  break;
                case "relative path start":
                  if (c === "\\") {
                    err("'\\' not allowed in path.");
                  }
                  state = "relative path";
                  if (c !== "/" && c !== "\\") {
                    continue;
                  }
                  break;
                case "relative path":
                  if (c === EOF || c === "/" || c === "\\" || !stateOverride && (c === "?" || c === "#")) {
                    if (c === "\\") {
                      err("\\ not allowed in relative path.");
                    }
                    var tmp;
                    if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                      buffer = tmp;
                    }
                    if (buffer === "..") {
                      this._path.pop();
                      if (c !== "/" && c !== "\\") {
                        this._path.push("");
                      }
                    } else if (buffer === "." && c !== "/" && c !== "\\") {
                      this._path.push("");
                    } else if (buffer !== ".") {
                      if (this._scheme === "file" && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === "|") {
                        buffer = buffer[0] + ":";
                      }
                      this._path.push(buffer);
                    }
                    buffer = "";
                    if (c === "?") {
                      this._query = "?";
                      state = "query";
                    } else if (c === "#") {
                      this._fragment = "#";
                      state = "fragment";
                    }
                  } else if (c !== "\t" && c !== "\n" && c !== "\r") {
                    buffer += percentEscape(c);
                  }
                  break;
                case "query":
                  if (!stateOverride && c === "#") {
                    this._fragment = "#";
                    state = "fragment";
                  } else if (c !== EOF && c !== "\t" && c !== "\n" && c !== "\r") {
                    this._query += percentEscapeQuery(c);
                  }
                  break;
                case "fragment":
                  if (c !== EOF && c !== "\t" && c !== "\n" && c !== "\r") {
                    this._fragment += c;
                  }
                  break;
              }
              cursor++;
            }
          }
          function clear() {
            this._scheme = "";
            this._schemeData = "";
            this._username = "";
            this._password = null;
            this._host = "";
            this._port = "";
            this._path = [];
            this._query = "";
            this._fragment = "";
            this._isInvalid = false;
            this._isRelative = false;
          }
          function JURL(url, base) {
            if (base !== undefined && !(base instanceof JURL)) {
              base = new JURL(String(base));
            }
            this._url = url;
            clear.call(this);
            var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, "");
            parse.call(this, input, null, base);
          }
          JURL.prototype = {
            toString: function toString() {
              return this.href;
            },

            get href() {
              if (this._isInvalid) {
                return this._url;
              }
              var authority = "";
              if (this._username !== "" || this._password !== null) {
                authority = this._username + (this._password !== null ? ":" + this._password : "") + "@";
              }
              return this.protocol + (this._isRelative ? "//" + authority + this.host : "") + this.pathname + this._query + this._fragment;
            },
            set href(value) {
              clear.call(this);
              parse.call(this, value);
            },
            get protocol() {
              return this._scheme + ":";
            },
            set protocol(value) {
              if (this._isInvalid) {
                return;
              }
              parse.call(this, value + ":", "scheme start");
            },
            get host() {
              return this._isInvalid ? "" : this._port ? this._host + ":" + this._port : this._host;
            },
            set host(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              parse.call(this, value, "host");
            },
            get hostname() {
              return this._host;
            },
            set hostname(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              parse.call(this, value, "hostname");
            },
            get port() {
              return this._port;
            },
            set port(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              parse.call(this, value, "port");
            },
            get pathname() {
              return this._isInvalid ? "" : this._isRelative ? "/" + this._path.join("/") : this._schemeData;
            },
            set pathname(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              this._path = [];
              parse.call(this, value, "relative path start");
            },
            get search() {
              return this._isInvalid || !this._query || this._query === "?" ? "" : this._query;
            },
            set search(value) {
              if (this._isInvalid || !this._isRelative) {
                return;
              }
              this._query = "?";
              if (value[0] === "?") {
                value = value.slice(1);
              }
              parse.call(this, value, "query");
            },
            get hash() {
              return this._isInvalid || !this._fragment || this._fragment === "#" ? "" : this._fragment;
            },
            set hash(value) {
              if (this._isInvalid) {
                return;
              }
              this._fragment = "#";
              if (value[0] === "#") {
                value = value.slice(1);
              }
              parse.call(this, value, "fragment");
            },
            get origin() {
              var host;
              if (this._isInvalid || !this._scheme) {
                return "";
              }
              switch (this._scheme) {
                case "data":
                case "file":
                case "javascript":
                case "mailto":
                  return "null";
                case "blob":
                  try {
                    return new JURL(this._schemeData).origin || "null";
                  } catch (_) {}
                  return "null";
              }
              host = this.host;
              if (!host) {
                return "";
              }
              return this._scheme + "://" + host;
            }
          };
          var OriginalURL = globalScope.URL;
          if (OriginalURL) {
            JURL.createObjectURL = function (blob) {
              return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
            };
            JURL.revokeObjectURL = function (url) {
              OriginalURL.revokeObjectURL(url);
            };
          }
          globalScope.URL = JURL;
        })();
      }

      /***/ }),
    /* 85 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = typeof window !== "undefined" && window.Math === Math ? window : typeof global !== "undefined" && global.Math === Math ? global : typeof self !== "undefined" && self.Math === Math ? self : {};

      /***/ }),
    /* 86 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(87);
      module.exports = __w_pdfjs_require__(7).Uint8ClampedArray;

      /***/ }),
    /* 87 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(88)("Uint8", 1, function (init) {
        return function Uint8ClampedArray(data, byteOffset, length) {
          return init(this, data, byteOffset, length);
        };
      }, true);

      /***/ }),
    /* 88 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      if (__w_pdfjs_require__(11)) {
        var LIBRARY = __w_pdfjs_require__(28);
        var global = __w_pdfjs_require__(1);
        var fails = __w_pdfjs_require__(12);
        var $export = __w_pdfjs_require__(6);
        var $typed = __w_pdfjs_require__(49);
        var $buffer = __w_pdfjs_require__(89);
        var ctx = __w_pdfjs_require__(13);
        var anInstance = __w_pdfjs_require__(23);
        var propertyDesc = __w_pdfjs_require__(29);
        var hide = __w_pdfjs_require__(8);
        var redefineAll = __w_pdfjs_require__(22);
        var toInteger = __w_pdfjs_require__(18);
        var toLength = __w_pdfjs_require__(14);
        var toIndex = __w_pdfjs_require__(50);
        var toAbsoluteIndex = __w_pdfjs_require__(31);
        var toPrimitive = __w_pdfjs_require__(36);
        var has = __w_pdfjs_require__(10);
        var classof = __w_pdfjs_require__(32);
        var isObject = __w_pdfjs_require__(3);
        var toObject = __w_pdfjs_require__(19);
        var isArrayIter = __w_pdfjs_require__(56);
        var create = __w_pdfjs_require__(57);
        var getPrototypeOf = __w_pdfjs_require__(59);
        var gOPN = __w_pdfjs_require__(51).f;
        var getIterFn = __w_pdfjs_require__(60);
        var uid = __w_pdfjs_require__(17);
        var wks = __w_pdfjs_require__(4);
        var createArrayMethod = __w_pdfjs_require__(42);
        var createArrayIncludes = __w_pdfjs_require__(53);
        var speciesConstructor = __w_pdfjs_require__(43);
        var ArrayIterators = __w_pdfjs_require__(61);
        var Iterators = __w_pdfjs_require__(20);
        var $iterDetect = __w_pdfjs_require__(44);
        var setSpecies = __w_pdfjs_require__(63);
        var arrayFill = __w_pdfjs_require__(55);
        var arrayCopyWithin = __w_pdfjs_require__(97);
        var $DP = __w_pdfjs_require__(15);
        var $GOPD = __w_pdfjs_require__(64);
        var dP = $DP.f;
        var gOPD = $GOPD.f;
        var RangeError = global.RangeError;
        var TypeError = global.TypeError;
        var Uint8Array = global.Uint8Array;
        var ARRAY_BUFFER = "ArrayBuffer";
        var SHARED_BUFFER = "Shared" + ARRAY_BUFFER;
        var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
        var PROTOTYPE = "prototype";
        var ArrayProto = Array[PROTOTYPE];
        var $ArrayBuffer = $buffer.ArrayBuffer;
        var $DataView = $buffer.DataView;
        var arrayForEach = createArrayMethod(0);
        var arrayFilter = createArrayMethod(2);
        var arraySome = createArrayMethod(3);
        var arrayEvery = createArrayMethod(4);
        var arrayFind = createArrayMethod(5);
        var arrayFindIndex = createArrayMethod(6);
        var arrayIncludes = createArrayIncludes(true);
        var arrayIndexOf = createArrayIncludes(false);
        var arrayValues = ArrayIterators.values;
        var arrayKeys = ArrayIterators.keys;
        var arrayEntries = ArrayIterators.entries;
        var arrayLastIndexOf = ArrayProto.lastIndexOf;
        var arrayReduce = ArrayProto.reduce;
        var arrayReduceRight = ArrayProto.reduceRight;
        var arrayJoin = ArrayProto.join;
        var arraySort = ArrayProto.sort;
        var arraySlice = ArrayProto.slice;
        var arrayToString = ArrayProto.toString;
        var arrayToLocaleString = ArrayProto.toLocaleString;
        var ITERATOR = wks("iterator");
        var TAG = wks("toStringTag");
        var TYPED_CONSTRUCTOR = uid("typed_constructor");
        var DEF_CONSTRUCTOR = uid("def_constructor");
        var ALL_CONSTRUCTORS = $typed.CONSTR;
        var TYPED_ARRAY = $typed.TYPED;
        var VIEW = $typed.VIEW;
        var WRONG_LENGTH = "Wrong length!";
        var $map = createArrayMethod(1, function (O, length) {
          return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
        });
        var LITTLE_ENDIAN = fails(function () {
          return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
        });
        var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
          new Uint8Array(1).set({});
        });
        var toOffset = function toOffset(it, BYTES) {
          var offset = toInteger(it);
          if (offset < 0 || offset % BYTES) throw RangeError("Wrong offset!");
          return offset;
        };
        var validate = function validate(it) {
          if (isObject(it) && TYPED_ARRAY in it) return it;
          throw TypeError(it + " is not a typed array!");
        };
        var allocate = function allocate(C, length) {
          if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
            throw TypeError("It is not a typed array constructor!");
          }
          return new C(length);
        };
        var speciesFromList = function speciesFromList(O, list) {
          return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
        };
        var fromList = function fromList(C, list) {
          var index = 0;
          var length = list.length;
          var result = allocate(C, length);
          while (length > index) {
            result[index] = list[index++];
          } return result;
        };
        var addGetter = function addGetter(it, key, internal) {
          dP(it, key, {
            get: function get() {
              return this._d[internal];
            }
          });
        };
        var $from = function from(source) {
          var O = toObject(source);
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var iterFn = getIterFn(O);
          var i, length, values, result, step, iterator;
          if (iterFn != undefined && !isArrayIter(iterFn)) {
            for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
              values.push(step.value);
            }
            O = values;
          }
          if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
          for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
            result[i] = mapping ? mapfn(O[i], i) : O[i];
          }
          return result;
        };
        var $of = function of() {
          var index = 0;
          var length = arguments.length;
          var result = allocate(this, length);
          while (length > index) {
            result[index] = arguments[index++];
          } return result;
        };
        var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
          arrayToLocaleString.call(new Uint8Array(1));
        });
        var $toLocaleString = function toLocaleString() {
          return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
        };
        var proto = {
          copyWithin: function copyWithin(target, start) {
            return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
          },
          every: function every(callbackfn) {
            return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          fill: function fill(value) {
            return arrayFill.apply(validate(this), arguments);
          },
          filter: function filter(callbackfn) {
            return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
          },
          find: function find(predicate) {
            return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          findIndex: function findIndex(predicate) {
            return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
          },
          forEach: function forEach(callbackfn) {
            arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          indexOf: function indexOf(searchElement) {
            return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          includes: function includes(searchElement) {
            return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
          },
          join: function join(separator) {
            return arrayJoin.apply(validate(this), arguments);
          },
          lastIndexOf: function lastIndexOf(searchElement) {
            return arrayLastIndexOf.apply(validate(this), arguments);
          },
          map: function map(mapfn) {
            return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          reduce: function reduce(callbackfn) {
            return arrayReduce.apply(validate(this), arguments);
          },
          reduceRight: function reduceRight(callbackfn) {
            return arrayReduceRight.apply(validate(this), arguments);
          },
          reverse: function reverse() {
            var that = this;
            var length = validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while (index < middle) {
              value = that[index];
              that[index++] = that[--length];
              that[length] = value;
            }
            return that;
          },
          some: function some(callbackfn) {
            return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          },
          sort: function sort(comparefn) {
            return arraySort.call(validate(this), comparefn);
          },
          subarray: function subarray(begin, end) {
            var O = validate(this);
            var length = O.length;
            var $begin = toAbsoluteIndex(begin, length);
            return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
          }
        };
        var $slice = function slice(start, end) {
          return speciesFromList(this, arraySlice.call(validate(this), start, end));
        };
        var $set = function set(arrayLike) {
          validate(this);
          var offset = toOffset(arguments[1], 1);
          var length = this.length;
          var src = toObject(arrayLike);
          var len = toLength(src.length);
          var index = 0;
          if (len + offset > length) throw RangeError(WRONG_LENGTH);
          while (index < len) {
            this[offset + index] = src[index++];
          }
        };
        var $iterators = {
          entries: function entries() {
            return arrayEntries.call(validate(this));
          },
          keys: function keys() {
            return arrayKeys.call(validate(this));
          },
          values: function values() {
            return arrayValues.call(validate(this));
          }
        };
        var isTAIndex = function isTAIndex(target, key) {
          return isObject(target) && target[TYPED_ARRAY] && (typeof key === "undefined" ? "undefined" : _typeof(key)) != "symbol" && key in target && String(+key) == String(key);
        };
        var $getDesc = function getOwnPropertyDescriptor(target, key) {
          return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
        };
        var $setDesc = function defineProperty(target, key, desc) {
          if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, "value") && !has(desc, "get") && !has(desc, "set") && !desc.configurable && (!has(desc, "writable") || desc.writable) && (!has(desc, "enumerable") || desc.enumerable)) {
            target[key] = desc.value;
            return target;
          }
          return dP(target, key, desc);
        };
        if (!ALL_CONSTRUCTORS) {
          $GOPD.f = $getDesc;
          $DP.f = $setDesc;
        }
        $export($export.S + $export.F * !ALL_CONSTRUCTORS, "Object", {
          getOwnPropertyDescriptor: $getDesc,
          defineProperty: $setDesc
        });
        if (fails(function () {
          arrayToString.call({});
        })) {
          arrayToString = arrayToLocaleString = function toString() {
            return arrayJoin.call(this);
          };
        }
        var $TypedArrayPrototype$ = redefineAll({}, proto);
        redefineAll($TypedArrayPrototype$, $iterators);
        hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
        redefineAll($TypedArrayPrototype$, {
          slice: $slice,
          set: $set,
          constructor: function constructor() {},
          toString: arrayToString,
          toLocaleString: $toLocaleString
        });
        addGetter($TypedArrayPrototype$, "buffer", "b");
        addGetter($TypedArrayPrototype$, "byteOffset", "o");
        addGetter($TypedArrayPrototype$, "byteLength", "l");
        addGetter($TypedArrayPrototype$, "length", "e");
        dP($TypedArrayPrototype$, TAG, {
          get: function get() {
            return this[TYPED_ARRAY];
          }
        });
        module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
          CLAMPED = !!CLAMPED;
          var NAME = KEY + (CLAMPED ? "Clamped" : "") + "Array";
          var GETTER = "get" + KEY;
          var SETTER = "set" + KEY;
          var TypedArray = global[NAME];
          var Base = TypedArray || {};
          var TAC = TypedArray && getPrototypeOf(TypedArray);
          var FORCED = !TypedArray || !$typed.ABV;
          var O = {};
          var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
          var getter = function getter(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
          };
          var setter = function setter(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
          };
          var addElement = function addElement(that, index) {
            dP(that, index, {
              get: function get() {
                return getter(this, index);
              },
              set: function set(value) {
                return setter(this, index, value);
              },
              enumerable: true
            });
          };
          if (FORCED) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME, "_d");
              var index = 0;
              var offset = 0;
              var buffer, byteLength, length, klass;
              if (!isObject(data)) {
                length = toIndex(data);
                byteLength = length * BYTES;
                buffer = new $ArrayBuffer(byteLength);
              } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                buffer = data;
                offset = toOffset($offset, BYTES);
                var $len = data.byteLength;
                if ($length === undefined) {
                  if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                  byteLength = $len - offset;
                  if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                } else {
                  byteLength = toLength($length) * BYTES;
                  if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
                }
                length = byteLength / BYTES;
              } else if (TYPED_ARRAY in data) {
                return fromList(TypedArray, data);
              } else {
                return $from.call(TypedArray, data);
              }
              hide(that, "_d", {
                b: buffer,
                o: offset,
                l: byteLength,
                e: length,
                v: new $DataView(buffer)
              });
              while (index < length) {
                addElement(that, index++);
              }
            });
            TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
            hide(TypedArrayPrototype, "constructor", TypedArray);
          } else if (!fails(function () {
            TypedArray(1);
          }) || !fails(function () {
            new TypedArray(-1);
          }) || !$iterDetect(function (iter) {
            new TypedArray();
            new TypedArray(null);
            new TypedArray(1.5);
            new TypedArray(iter);
          }, true)) {
            TypedArray = wrapper(function (that, data, $offset, $length) {
              anInstance(that, TypedArray, NAME);
              var klass;
              if (!isObject(data)) return new Base(toIndex(data));
              if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
              }
              if (TYPED_ARRAY in data) return fromList(TypedArray, data);
              return $from.call(TypedArray, data);
            });
            arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
              if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
            });
            TypedArray[PROTOTYPE] = TypedArrayPrototype;
            if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
          }
          var $nativeIterator = TypedArrayPrototype[ITERATOR];
          var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == "values" || $nativeIterator.name == undefined);
          var $iterator = $iterators.values;
          hide(TypedArray, TYPED_CONSTRUCTOR, true);
          hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
          hide(TypedArrayPrototype, VIEW, true);
          hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
          if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
            dP(TypedArrayPrototype, TAG, {
              get: function get() {
                return NAME;
              }
            });
          }
          O[NAME] = TypedArray;
          $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
          $export($export.S, NAME, { BYTES_PER_ELEMENT: BYTES });
          $export($export.S + $export.F * fails(function () {
            Base.of.call(TypedArray, 1);
          }), NAME, {
            from: $from,
            of: $of
          });
          if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
          $export($export.P, NAME, proto);
          setSpecies(NAME);
          $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
          $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
          if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
          $export($export.P + $export.F * fails(function () {
            new TypedArray(1).slice();
          }), NAME, { slice: $slice });
          $export($export.P + $export.F * (fails(function () {
            return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
          }) || !fails(function () {
            TypedArrayPrototype.toLocaleString.call([1, 2]);
          })), NAME, { toLocaleString: $toLocaleString });
          Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
          if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
        };
      } else module.exports = function () {};

      /***/ }),
    /* 89 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var DESCRIPTORS = __w_pdfjs_require__(11);
      var LIBRARY = __w_pdfjs_require__(28);
      var $typed = __w_pdfjs_require__(49);
      var hide = __w_pdfjs_require__(8);
      var redefineAll = __w_pdfjs_require__(22);
      var fails = __w_pdfjs_require__(12);
      var anInstance = __w_pdfjs_require__(23);
      var toInteger = __w_pdfjs_require__(18);
      var toLength = __w_pdfjs_require__(14);
      var toIndex = __w_pdfjs_require__(50);
      var gOPN = __w_pdfjs_require__(51).f;
      var dP = __w_pdfjs_require__(15).f;
      var arrayFill = __w_pdfjs_require__(55);
      var setToStringTag = __w_pdfjs_require__(25);
      var ARRAY_BUFFER = "ArrayBuffer";
      var DATA_VIEW = "DataView";
      var PROTOTYPE = "prototype";
      var WRONG_LENGTH = "Wrong length!";
      var WRONG_INDEX = "Wrong index!";
      var $ArrayBuffer = global[ARRAY_BUFFER];
      var $DataView = global[DATA_VIEW];
      var Math = global.Math;
      var RangeError = global.RangeError;
      var Infinity = global.Infinity;
      var BaseBuffer = $ArrayBuffer;
      var abs = Math.abs;
      var pow = Math.pow;
      var floor = Math.floor;
      var log = Math.log;
      var LN2 = Math.LN2;
      var BUFFER = "buffer";
      var BYTE_LENGTH = "byteLength";
      var BYTE_OFFSET = "byteOffset";
      var $BUFFER = DESCRIPTORS ? "_b" : BUFFER;
      var $LENGTH = DESCRIPTORS ? "_l" : BYTE_LENGTH;
      var $OFFSET = DESCRIPTORS ? "_o" : BYTE_OFFSET;
      function packIEEE754(value, mLen, nBytes) {
        var buffer = Array(nBytes);
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
        var i = 0;
        var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        var e, m, c;
        value = abs(value);
        if (value != value || value === Infinity) {
          m = value != value ? 1 : 0;
          e = eMax;
        } else {
          e = floor(log(value) / LN2);
          if (value * (c = pow(2, -e)) < 1) {
            e--;
            c *= 2;
          }
          if (e + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e++;
            c /= 2;
          }
          if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
          } else if (e + eBias >= 1) {
            m = (value * c - 1) * pow(2, mLen);
            e = e + eBias;
          } else {
            m = value * pow(2, eBias - 1) * pow(2, mLen);
            e = 0;
          }
        }
        for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
        e = e << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
        buffer[--i] |= s * 128;
        return buffer;
      }
      function unpackIEEE754(buffer, mLen, nBytes) {
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = eLen - 7;
        var i = nBytes - 1;
        var s = buffer[i--];
        var e = s & 127;
        var m;
        s >>= 7;
        for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
        m = e & (1 << -nBits) - 1;
        e >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
        if (e === 0) {
          e = 1 - eBias;
        } else if (e === eMax) {
          return m ? NaN : s ? -Infinity : Infinity;
        } else {
          m = m + pow(2, mLen);
          e = e - eBias;
        }
        return (s ? -1 : 1) * m * pow(2, e - mLen);
      }
      function unpackI32(bytes) {
        return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
      }
      function packI8(it) {
        return [it & 0xff];
      }
      function packI16(it) {
        return [it & 0xff, it >> 8 & 0xff];
      }
      function packI32(it) {
        return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
      }
      function packF64(it) {
        return packIEEE754(it, 52, 8);
      }
      function packF32(it) {
        return packIEEE754(it, 23, 4);
      }
      function addGetter(C, key, internal) {
        dP(C[PROTOTYPE], key, {
          get: function get() {
            return this[internal];
          }
        });
      }
      function get(view, bytes, index, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = store.slice(start, start + bytes);
        return isLittleEndian ? pack : pack.reverse();
      }
      function set(view, bytes, index, conversion, value, isLittleEndian) {
        var numIndex = +index;
        var intIndex = toIndex(numIndex);
        if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
        var store = view[$BUFFER]._b;
        var start = intIndex + view[$OFFSET];
        var pack = conversion(+value);
        for (var i = 0; i < bytes; i++) {
          store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
        }
      }
      if (!$typed.ABV) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
          var byteLength = toIndex(length);
          this._b = arrayFill.call(Array(byteLength), 0);
          this[$LENGTH] = byteLength;
        };
        $DataView = function DataView(buffer, byteOffset, byteLength) {
          anInstance(this, $DataView, DATA_VIEW);
          anInstance(buffer, $ArrayBuffer, DATA_VIEW);
          var bufferLength = buffer[$LENGTH];
          var offset = toInteger(byteOffset);
          if (offset < 0 || offset > bufferLength) throw RangeError("Wrong offset!");
          byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
          if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
          this[$BUFFER] = buffer;
          this[$OFFSET] = offset;
          this[$LENGTH] = byteLength;
        };
        if (DESCRIPTORS) {
          addGetter($ArrayBuffer, BYTE_LENGTH, "_l");
          addGetter($DataView, BUFFER, "_b");
          addGetter($DataView, BYTE_LENGTH, "_l");
          addGetter($DataView, BYTE_OFFSET, "_o");
        }
        redefineAll($DataView[PROTOTYPE], {
          getInt8: function getInt8(byteOffset) {
            return get(this, 1, byteOffset)[0] << 24 >> 24;
          },
          getUint8: function getUint8(byteOffset) {
            return get(this, 1, byteOffset)[0];
          },
          getInt16: function getInt16(byteOffset) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
          },
          getUint16: function getUint16(byteOffset) {
            var bytes = get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
          },
          getInt32: function getInt32(byteOffset) {
            return unpackI32(get(this, 4, byteOffset, arguments[1]));
          },
          getUint32: function getUint32(byteOffset) {
            return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
          },
          getFloat32: function getFloat32(byteOffset) {
            return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
          },
          getFloat64: function getFloat64(byteOffset) {
            return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
          },
          setInt8: function setInt8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setUint8: function setUint8(byteOffset, value) {
            set(this, 1, byteOffset, packI8, value);
          },
          setInt16: function setInt16(byteOffset, value) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setUint16: function setUint16(byteOffset, value) {
            set(this, 2, byteOffset, packI16, value, arguments[2]);
          },
          setInt32: function setInt32(byteOffset, value) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setUint32: function setUint32(byteOffset, value) {
            set(this, 4, byteOffset, packI32, value, arguments[2]);
          },
          setFloat32: function setFloat32(byteOffset, value) {
            set(this, 4, byteOffset, packF32, value, arguments[2]);
          },
          setFloat64: function setFloat64(byteOffset, value) {
            set(this, 8, byteOffset, packF64, value, arguments[2]);
          }
        });
      } else {
        if (!fails(function () {
          $ArrayBuffer(1);
        }) || !fails(function () {
          new $ArrayBuffer(-1);
        }) || fails(function () {
          new $ArrayBuffer();
          new $ArrayBuffer(1.5);
          new $ArrayBuffer(NaN);
          return $ArrayBuffer.name != ARRAY_BUFFER;
        })) {
          $ArrayBuffer = function ArrayBuffer(length) {
            anInstance(this, $ArrayBuffer);
            return new BaseBuffer(toIndex(length));
          };
          var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
          for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
            if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
          }
          if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
        }
        var view = new $DataView(new $ArrayBuffer(2));
        var $setInt8 = $DataView[PROTOTYPE].setInt8;
        view.setInt8(0, 2147483648);
        view.setInt8(1, 2147483649);
        if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
          setInt8: function setInt8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          },
          setUint8: function setUint8(byteOffset, value) {
            $setInt8.call(this, byteOffset, value << 24 >> 24);
          }
        }, true);
      }
      setToStringTag($ArrayBuffer, ARRAY_BUFFER);
      setToStringTag($DataView, DATA_VIEW);
      hide($DataView[PROTOTYPE], $typed.VIEW, true);
      exports[ARRAY_BUFFER] = $ArrayBuffer;
      exports[DATA_VIEW] = $DataView;

      /***/ }),
    /* 90 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var dP = __w_pdfjs_require__(15);
      var anObject = __w_pdfjs_require__(9);
      var getKeys = __w_pdfjs_require__(41);
      module.exports = __w_pdfjs_require__(11) ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while (length > i) {
          dP.f(O, P = keys[i++], Properties[P]);
        } return O;
      };

      /***/ }),
    /* 91 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var speciesConstructor = __w_pdfjs_require__(92);
      module.exports = function (original, length) {
        return new (speciesConstructor(original))(length);
      };

      /***/ }),
    /* 92 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      var isArray = __w_pdfjs_require__(93);
      var SPECIES = __w_pdfjs_require__(4)("species");
      module.exports = function (original) {
        var C;
        if (isArray(original)) {
          C = original.constructor;
          if (typeof C === "function" && (C === Array || isArray(C.prototype))) C = undefined;
          if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
          }
        }
        return C === undefined ? Array : C;
      };

      /***/ }),
    /* 93 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var cof = __w_pdfjs_require__(24);
      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == "Array";
      };

      /***/ }),
    /* 94 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var UNSCOPABLES = __w_pdfjs_require__(4)("unscopables");
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(8)(ArrayProto, UNSCOPABLES, {});
      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };

      /***/ }),
    /* 95 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (done, value) {
        return {
          value: value,
          done: !!done
        };
      };

      /***/ }),
    /* 96 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var create = __w_pdfjs_require__(57);
      var descriptor = __w_pdfjs_require__(29);
      var setToStringTag = __w_pdfjs_require__(25);
      var IteratorPrototype = {};
      __w_pdfjs_require__(8)(IteratorPrototype, __w_pdfjs_require__(4)("iterator"), function () {
        return this;
      });
      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
        setToStringTag(Constructor, NAME + " Iterator");
      };

      /***/ }),
    /* 97 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toObject = __w_pdfjs_require__(19);
      var toAbsoluteIndex = __w_pdfjs_require__(31);
      var toLength = __w_pdfjs_require__(14);
      module.exports = [].copyWithin || function copyWithin(target, start) {
        var O = toObject(this);
        var len = toLength(O.length);
        var to = toAbsoluteIndex(target, len);
        var from = toAbsoluteIndex(start, len);
        var end = arguments.length > 2 ? arguments[2] : undefined;
        var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
        var inc = 1;
        if (from < to && to < from + count) {
          inc = -1;
          from += count - 1;
          to += count - 1;
        }
        while (count-- > 0) {
          if (from in O) O[to] = O[from];else delete O[to];
          to += inc;
          from += inc;
        }
        return O;
      };

      /***/ }),
    /* 98 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(99);
      module.exports = __w_pdfjs_require__(7).Number.isNaN;

      /***/ }),
    /* 99 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(6);
      $export($export.S, "Number", {
        isNaN: function isNaN(number) {
          return number != number;
        }
      });

      /***/ }),
    /* 100 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(101);
      module.exports = __w_pdfjs_require__(7).Number.isInteger;

      /***/ }),
    /* 101 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(6);
      $export($export.S, "Number", { isInteger: __w_pdfjs_require__(102) });

      /***/ }),
    /* 102 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      var floor = Math.floor;
      module.exports = function isInteger(it) {
        return !isObject(it) && isFinite(it) && floor(it) === it;
      };

      /***/ }),
    /* 103 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(66);
      __w_pdfjs_require__(104);
      __w_pdfjs_require__(67);
      __w_pdfjs_require__(106);
      __w_pdfjs_require__(110);
      __w_pdfjs_require__(111);
      module.exports = __w_pdfjs_require__(7).Promise;

      /***/ }),
    /* 104 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $at = __w_pdfjs_require__(105)(true);
      __w_pdfjs_require__(62)(String, "String", function (iterated) {
        this._t = String(iterated);
        this._i = 0;
      }, function () {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
          value: undefined,
          done: true
        };
        point = $at(O, index);
        this._i += point.length;
        return {
          value: point,
          done: false
        };
      });

      /***/ }),
    /* 105 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var toInteger = __w_pdfjs_require__(18);
      var defined = __w_pdfjs_require__(38);
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/ }),
    /* 106 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var LIBRARY = __w_pdfjs_require__(28);
      var global = __w_pdfjs_require__(1);
      var ctx = __w_pdfjs_require__(13);
      var classof = __w_pdfjs_require__(32);
      var $export = __w_pdfjs_require__(6);
      var isObject = __w_pdfjs_require__(3);
      var aFunction = __w_pdfjs_require__(21);
      var anInstance = __w_pdfjs_require__(23);
      var forOf = __w_pdfjs_require__(33);
      var speciesConstructor = __w_pdfjs_require__(43);
      var task = __w_pdfjs_require__(68).set;
      var microtask = __w_pdfjs_require__(109)();
      var newPromiseCapabilityModule = __w_pdfjs_require__(45);
      var perform = __w_pdfjs_require__(69);
      var promiseResolve = __w_pdfjs_require__(70);
      var PROMISE = "Promise";
      var TypeError = global.TypeError;
      var process = global.process;
      var $Promise = global[PROMISE];
      var isNode = classof(process) == "process";
      var empty = function empty() {};
      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
      var USE_NATIVE = !!function () {
        try {
          var promise = $Promise.resolve(1);
          var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(4)("species")] = function (exec) {
            exec(empty, empty);
          };
          return (isNode || typeof PromiseRejectionEvent === "function") && promise.then(empty) instanceof FakePromise;
        } catch (e) {}
      }();
      var isThenable = function isThenable(it) {
        var then;
        return isObject(it) && typeof (then = it.then) === "function" ? then : false;
      };
      var notify = function notify(promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;
          var run = function run(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then;
            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }
                if (handler === true) result = value;else {
                  if (domain) domain.enter();
                  result = handler(value);
                  if (domain) domain.exit();
                }
                if (result === reaction.promise) {
                  reject(TypeError("Promise-chain cycle"));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              reject(e);
            }
          };
          while (chain.length > i) {
            run(chain[i++]);
          }promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };
      var onUnhandled = function onUnhandled(promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;
          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit("unhandledRejection", value, promise);
              } else if (handler = global.onunhandledrejection) {
                handler({
                  promise: promise,
                  reason: value
                });
              } else if ((console = global.console) && console.error) {
                console.error("Unhandled promise rejection", value);
              }
            });
            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }
          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };
      var isUnhandled = function isUnhandled(promise) {
        if (promise._h == 1) return false;
        var chain = promise._a || promise._c;
        var i = 0;
        var reaction;
        while (chain.length > i) {
          reaction = chain[i++];
          if (reaction.fail || !isUnhandled(reaction.promise)) return false;
        }
        return true;
      };
      var onHandleUnhandled = function onHandleUnhandled(promise) {
        task.call(global, function () {
          var handler;
          if (isNode) {
            process.emit("rejectionHandled", promise);
          } else if (handler = global.onrejectionhandled) {
            handler({
              promise: promise,
              reason: promise._v
            });
          }
        });
      };
      var $reject = function $reject(value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };
      var $resolve = function $resolve(value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");
          if (then = isThenable(value)) {
            microtask(function () {
              var wrapper = {
                _w: promise,
                _d: false
              };
              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({
            _w: promise,
            _d: false
          }, e);
        }
      };
      if (!USE_NATIVE) {
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, "_h");
          aFunction(executor);
          Internal.call(this);
          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        };
        Internal = function Promise(executor) {
          this._c = [];
          this._a = undefined;
          this._s = 0;
          this._d = false;
          this._v = undefined;
          this._h = 0;
          this._n = false;
        };
        Internal.prototype = __w_pdfjs_require__(22)($Promise.prototype, {
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled === "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected === "function" && onRejected;
            reaction.domain = isNode ? process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          "catch": function _catch(onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function OwnPromiseCapability() {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
      __w_pdfjs_require__(25)($Promise, PROMISE);
      __w_pdfjs_require__(63)(PROMISE);
      Wrapper = __w_pdfjs_require__(7)[PROMISE];
      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(44)(function (iter) {
        $Promise.all(iter)["catch"](empty);
      })), PROMISE, {
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var values = [];
            var index = 0;
            var remaining = 1;
            forOf(iterable, false, function (promise) {
              var $index = index++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              C.resolve(promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[$index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.e) reject(result.v);
          return capability.promise;
        },
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function () {
            forOf(iterable, false, function (promise) {
              C.resolve(promise).then(capability.resolve, reject);
            });
          });
          if (result.e) reject(result.v);
          return capability.promise;
        }
      });

      /***/ }),
    /* 107 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var anObject = __w_pdfjs_require__(9);
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (e) {
          var ret = iterator["return"];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/ }),
    /* 108 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      module.exports = function (fn, args, that) {
        var un = that === undefined;
        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);
          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
      };

      /***/ }),
    /* 109 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var macrotask = __w_pdfjs_require__(68).set;
      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __w_pdfjs_require__(24)(process) == "process";
      module.exports = function () {
        var head, last, notify;
        var flush = function flush() {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (e) {
              if (head) notify();else last = undefined;
              throw e;
            }
          }
          last = undefined;
          if (parent) parent.enter();
        };
        if (isNode) {
          notify = function notify() {
            process.nextTick(flush);
          };
        } else if (Observer) {
          var toggle = true;
          var node = document.createTextNode("");
          new Observer(flush).observe(node, { characterData: true });
          notify = function notify() {
            node.data = toggle = !toggle;
          };
        } else if (Promise && Promise.resolve) {
          var promise = Promise.resolve();
          notify = function notify() {
            promise.then(flush);
          };
        } else {
          notify = function notify() {
            macrotask.call(global, flush);
          };
        }
        return function (fn) {
          var task = {
            fn: fn,
            next: undefined
          };
          if (last) last.next = task;
          if (!head) {
            head = task;
            notify();
          }
          last = task;
        };
      };

      /***/ }),
    /* 110 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(6);
      var core = __w_pdfjs_require__(7);
      var global = __w_pdfjs_require__(1);
      var speciesConstructor = __w_pdfjs_require__(43);
      var promiseResolve = __w_pdfjs_require__(70);
      $export($export.P + $export.R, "Promise", {
        "finally": function _finally(onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally === "function";
          return this.then(isFunction ? function (x) {
            return promiseResolve(C, onFinally()).then(function () {
              return x;
            });
          } : onFinally, isFunction ? function (e) {
            return promiseResolve(C, onFinally()).then(function () {
              throw e;
            });
          } : onFinally);
        }
      });

      /***/ }),
    /* 111 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(6);
      var newPromiseCapability = __w_pdfjs_require__(45);
      var perform = __w_pdfjs_require__(69);
      $export($export.S, "Promise", {
        "try": function _try(callbackfn) {
          var promiseCapability = newPromiseCapability.f(this);
          var result = perform(callbackfn);
          (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
          return promiseCapability.promise;
        }
      });

      /***/ }),
    /* 112 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(66);
      __w_pdfjs_require__(67);
      __w_pdfjs_require__(113);
      __w_pdfjs_require__(120);
      __w_pdfjs_require__(122);
      module.exports = __w_pdfjs_require__(7).WeakMap;

      /***/ }),
    /* 113 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var each = __w_pdfjs_require__(42)(0);
      var redefine = __w_pdfjs_require__(16);
      var meta = __w_pdfjs_require__(46);
      var assign = __w_pdfjs_require__(114);
      var weak = __w_pdfjs_require__(116);
      var isObject = __w_pdfjs_require__(3);
      var fails = __w_pdfjs_require__(12);
      var validate = __w_pdfjs_require__(71);
      var WEAK_MAP = "WeakMap";
      var getWeak = meta.getWeak;
      var isExtensible = Object.isExtensible;
      var uncaughtFrozenStore = weak.ufstore;
      var tmp = {};
      var InternalMap;
      var wrapper = function wrapper(get) {
        return function WeakMap() {
          return get(this, arguments.length > 0 ? arguments[0] : undefined);
        };
      };
      var methods = {
        get: function get(key) {
          if (isObject(key)) {
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
          }
        },
        set: function set(key, value) {
          return weak.def(validate(this, WEAK_MAP), key, value);
        }
      };
      var $WeakMap = module.exports = __w_pdfjs_require__(117)(WEAK_MAP, wrapper, methods, weak, true, true);
      if (fails(function () {
        return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
      })) {
        InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
        assign(InternalMap.prototype, methods);
        meta.NEED = true;
        each(["delete", "has", "get", "set"], function (key) {
          var proto = $WeakMap.prototype;
          var method = proto[key];
          redefine(proto, key, function (a, b) {
            if (isObject(a) && !isExtensible(a)) {
              if (!this._f) this._f = new InternalMap();
              var result = this._f[key](a, b);
              return key == "set" ? this : result;
            }
            return method.call(this, a, b);
          });
        });
      }

      /***/ }),
    /* 114 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var getKeys = __w_pdfjs_require__(41);
      var gOPS = __w_pdfjs_require__(115);
      var pIE = __w_pdfjs_require__(65);
      var toObject = __w_pdfjs_require__(19);
      var IObject = __w_pdfjs_require__(37);
      var $assign = Object.assign;
      module.exports = !$assign || __w_pdfjs_require__(12)(function () {
        var A = {};
        var B = {};
        var S = Symbol();
        var K = "abcdefghijklmnopqrst";
        A[S] = 7;
        K.split("").forEach(function (k) {
          B[k] = k;
        });
        return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
      }) ? function assign(target, source) {
          var T = toObject(target);
          var aLen = arguments.length;
          var index = 1;
          var getSymbols = gOPS.f;
          var isEnum = pIE.f;
          while (aLen > index) {
            var S = IObject(arguments[index++]);
            var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
            var length = keys.length;
            var j = 0;
            var key;
            while (length > j) {
              if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
            }
          }
          return T;
        } : $assign;

      /***/ }),
    /* 115 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      exports.f = Object.getOwnPropertySymbols;

      /***/ }),
    /* 116 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var redefineAll = __w_pdfjs_require__(22);
      var getWeak = __w_pdfjs_require__(46).getWeak;
      var anObject = __w_pdfjs_require__(9);
      var isObject = __w_pdfjs_require__(3);
      var anInstance = __w_pdfjs_require__(23);
      var forOf = __w_pdfjs_require__(33);
      var createArrayMethod = __w_pdfjs_require__(42);
      var $has = __w_pdfjs_require__(10);
      var validate = __w_pdfjs_require__(71);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var id = 0;
      var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
        return that._l || (that._l = new UncaughtFrozenStore());
      };
      var UncaughtFrozenStore = function UncaughtFrozenStore() {
        this.a = [];
      };
      var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
        return arrayFind(store.a, function (it) {
          return it[0] === key;
        });
      };
      UncaughtFrozenStore.prototype = {
        get: function get(key) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) return entry[1];
        },
        has: function has(key) {
          return !!findUncaughtFrozen(this, key);
        },
        set: function set(key, value) {
          var entry = findUncaughtFrozen(this, key);
          if (entry) entry[1] = value;else this.a.push([key, value]);
        },
        "delete": function _delete(key) {
          var index = arrayFindIndex(this.a, function (it) {
            return it[0] === key;
          });
          if (~index) this.a.splice(index, 1);
          return !!~index;
        }
      };
      module.exports = {
        getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
          var C = wrapper(function (that, iterable) {
            anInstance(that, C, NAME, "_i");
            that._t = NAME;
            that._i = id++;
            that._l = undefined;
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
          });
          redefineAll(C.prototype, {
            "delete": function _delete(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME))["delete"](key);
              return data && $has(data, this._i) && delete data[this._i];
            },
            has: function has(key) {
              if (!isObject(key)) return false;
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
              return data && $has(data, this._i);
            }
          });
          return C;
        },
        def: function def(that, key, value) {
          var data = getWeak(anObject(key), true);
          if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
          return that;
        },
        ufstore: uncaughtFrozenStore
      };

      /***/ }),
    /* 117 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var global = __w_pdfjs_require__(1);
      var $export = __w_pdfjs_require__(6);
      var redefine = __w_pdfjs_require__(16);
      var redefineAll = __w_pdfjs_require__(22);
      var meta = __w_pdfjs_require__(46);
      var forOf = __w_pdfjs_require__(33);
      var anInstance = __w_pdfjs_require__(23);
      var isObject = __w_pdfjs_require__(3);
      var fails = __w_pdfjs_require__(12);
      var $iterDetect = __w_pdfjs_require__(44);
      var setToStringTag = __w_pdfjs_require__(25);
      var inheritIfRequired = __w_pdfjs_require__(118);
      module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
        var Base = global[NAME];
        var C = Base;
        var ADDER = IS_MAP ? "set" : "add";
        var proto = C && C.prototype;
        var O = {};
        var fixMethod = function fixMethod(KEY) {
          var fn = proto[KEY];
          redefine(proto, KEY, KEY == "delete" ? function (a) {
            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
          } : KEY == "has" ? function has(a) {
            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
          } : KEY == "get" ? function get(a) {
            return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
          } : KEY == "add" ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
          } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
          });
        };
        if (typeof C !== "function" || !(IS_WEAK || proto.forEach && !fails(function () {
          new C().entries().next();
        }))) {
          C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
          redefineAll(C.prototype, methods);
          meta.NEED = true;
        } else {
          var instance = new C();
          var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          var THROWS_ON_PRIMITIVES = fails(function () {
            instance.has(1);
          });
          var ACCEPT_ITERABLES = $iterDetect(function (iter) {
            new C(iter);
          });
          var BUGGY_ZERO = !IS_WEAK && fails(function () {
            var $instance = new C();
            var index = 5;
            while (index--) {
              $instance[ADDER](index, index);
            } return !$instance.has(-0);
          });
          if (!ACCEPT_ITERABLES) {
            C = wrapper(function (target, iterable) {
              anInstance(target, C, NAME);
              var that = inheritIfRequired(new Base(), target, C);
              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
              return that;
            });
            C.prototype = proto;
            proto.constructor = C;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
          }
          if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
          if (IS_WEAK && proto.clear) delete proto.clear;
        }
        setToStringTag(C, NAME);
        O[NAME] = C;
        $export($export.G + $export.W + $export.F * (C != Base), O);
        if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
        return C;
      };

      /***/ }),
    /* 118 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      var setPrototypeOf = __w_pdfjs_require__(119).set;
      module.exports = function (that, target, C) {
        var S = target.constructor;
        var P;
        if (S !== C && typeof S === "function" && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
          setPrototypeOf(that, P);
        }
        return that;
      };

      /***/ }),
    /* 119 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isObject = __w_pdfjs_require__(3);
      var anObject = __w_pdfjs_require__(9);
      var check = function check(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };
      module.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (test, buggy, set) {
          try {
            set = __w_pdfjs_require__(13)(Function.call, __w_pdfjs_require__(64).f(Object.prototype, "__proto__").set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
          } catch (e) {
            buggy = true;
          }
          return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;else set(O, proto);
            return O;
          };
        }({}, false) : undefined),
        check: check
      };

      /***/ }),
    /* 120 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(121)("WeakMap");

      /***/ }),
    /* 121 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(6);
      module.exports = function (COLLECTION) {
        $export($export.S, COLLECTION, {
          of: function of() {
            var length = arguments.length;
            var A = Array(length);
            while (length--) {
              A[length] = arguments[length];
            } return new this(A);
          }
        });
      };

      /***/ }),
    /* 122 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      __w_pdfjs_require__(123)("WeakMap");

      /***/ }),
    /* 123 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var $export = __w_pdfjs_require__(6);
      var aFunction = __w_pdfjs_require__(21);
      var ctx = __w_pdfjs_require__(13);
      var forOf = __w_pdfjs_require__(33);
      module.exports = function (COLLECTION) {
        $export($export.S, COLLECTION, {
          from: function from(source) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            aFunction(this);
            mapping = mapFn !== undefined;
            if (mapping) aFunction(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
              n = 0;
              cb = ctx(mapFn, arguments[2], 2);
              forOf(source, false, function (nextItem) {
                A.push(cb(nextItem, n++));
              });
            } else {
              forOf(source, false, A.push, A);
            }
            return new this(A);
          }
        });
      };

      /***/ }),
    /* 124 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var isReadableStreamSupported = false;
      if (typeof ReadableStream !== "undefined") {
        try {
          new ReadableStream({
            start: function start(controller) {
              controller.close();
            }
          });
          isReadableStreamSupported = true;
        } catch (e) {}
      }
      if (isReadableStreamSupported) {
        exports.ReadableStream = ReadableStream;
      } else {
        exports.ReadableStream = __w_pdfjs_require__(125).ReadableStream;
      }

      /***/ }),
    /* 125 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      (function (e, a) {
        for (var i in a) {
          e[i] = a[i];
        }
      })(exports, function (modules) {
        var installedModules = {};
        function __w_pdfjs_require__(moduleId) {
          if (installedModules[moduleId]) return installedModules[moduleId].exports;
          var module = installedModules[moduleId] = {
            i: moduleId,
            l: false,
            exports: {}
          };
          modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
          module.l = true;
          return module.exports;
        }
        __w_pdfjs_require__.m = modules;
        __w_pdfjs_require__.c = installedModules;
        __w_pdfjs_require__.i = function (value) {
          return value;
        };
        __w_pdfjs_require__.d = function (exports, name, getter) {
          if (!__w_pdfjs_require__.o(exports, name)) {
            Object.defineProperty(exports, name, {
              configurable: false,
              enumerable: true,
              get: getter
            });
          }
        };
        __w_pdfjs_require__.n = function (module) {
          var getter = module && module.__esModule ? function getDefault() {
            return module["default"];
          } : function getModuleExports() {
            return module;
          };
          __w_pdfjs_require__.d(getter, "a", getter);
          return getter;
        };
        __w_pdfjs_require__.o = function (object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        __w_pdfjs_require__.p = "";
        return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
      }([function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
          return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
        };
        var _require = __w_pdfjs_require__(1),
          assert = _require.assert;
        function IsPropertyKey(argument) {
          return typeof argument === "string" || (typeof argument === "undefined" ? "undefined" : _typeof(argument)) === "symbol";
        }
        exports.typeIsObject = function (x) {
          return (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object" && x !== null || typeof x === "function";
        };
        exports.createDataProperty = function (o, p, v) {
          assert(exports.typeIsObject(o));
          Object.defineProperty(o, p, {
            value: v,
            writable: true,
            enumerable: true,
            configurable: true
          });
        };
        exports.createArrayFromList = function (elements) {
          return elements.slice();
        };
        exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
          new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
        };
        exports.CreateIterResultObject = function (value, done) {
          assert(typeof done === "boolean");
          var obj = {};
          Object.defineProperty(obj, "value", {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
          });
          Object.defineProperty(obj, "done", {
            value: done,
            enumerable: true,
            writable: true,
            configurable: true
          });
          return obj;
        };
        exports.IsFiniteNonNegativeNumber = function (v) {
          if (Number.isNaN(v)) {
            return false;
          }
          if (v === Infinity) {
            return false;
          }
          if (v < 0) {
            return false;
          }
          return true;
        };
        function Call(F, V, args) {
          if (typeof F !== "function") {
            throw new TypeError("Argument is not a function");
          }
          return Function.prototype.apply.call(F, V, args);
        }
        exports.InvokeOrNoop = function (O, P, args) {
          assert(O !== undefined);
          assert(IsPropertyKey(P));
          assert(Array.isArray(args));
          var method = O[P];
          if (method === undefined) {
            return undefined;
          }
          return Call(method, O, args);
        };
        exports.PromiseInvokeOrNoop = function (O, P, args) {
          assert(O !== undefined);
          assert(IsPropertyKey(P));
          assert(Array.isArray(args));
          try {
            return Promise.resolve(exports.InvokeOrNoop(O, P, args));
          } catch (returnValueE) {
            return Promise.reject(returnValueE);
          }
        };
        exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
          assert(O !== undefined);
          assert(IsPropertyKey(P));
          assert(Array.isArray(args));
          assert(Array.isArray(argsF));
          var method = void 0;
          try {
            method = O[P];
          } catch (methodE) {
            return Promise.reject(methodE);
          }
          if (method === undefined) {
            return F.apply(null, argsF);
          }
          try {
            return Promise.resolve(Call(method, O, args));
          } catch (e) {
            return Promise.reject(e);
          }
        };
        exports.TransferArrayBuffer = function (O) {
          return O.slice();
        };
        exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
          highWaterMark = Number(highWaterMark);
          if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
            throw new RangeError("highWaterMark property of a queuing strategy must be non-negative and non-NaN");
          }
          return highWaterMark;
        };
        exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
          if (size !== undefined && typeof size !== "function") {
            throw new TypeError("size property of a queuing strategy must be a function");
          }
          highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
          return {
            size: size,
            highWaterMark: highWaterMark
          };
        };
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        function rethrowAssertionErrorRejection(e) {
          if (e && e.constructor === AssertionError) {
            setTimeout(function () {
              throw e;
            }, 0);
          }
        }
        function AssertionError(message) {
          this.name = "AssertionError";
          this.message = message || "";
          this.stack = new Error().stack;
        }
        AssertionError.prototype = Object.create(Error.prototype);
        AssertionError.prototype.constructor = AssertionError;
        function assert(value, message) {
          if (!value) {
            throw new AssertionError(message);
          }
        }
        module.exports = {
          rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
          AssertionError: AssertionError,
          assert: assert
        };
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var _require = __w_pdfjs_require__(0),
          InvokeOrNoop = _require.InvokeOrNoop,
          PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
          ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
          typeIsObject = _require.typeIsObject;
        var _require2 = __w_pdfjs_require__(1),
          assert = _require2.assert,
          rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
        var _require3 = __w_pdfjs_require__(3),
          DequeueValue = _require3.DequeueValue,
          EnqueueValueWithSize = _require3.EnqueueValueWithSize,
          PeekQueueValue = _require3.PeekQueueValue,
          ResetQueue = _require3.ResetQueue;
        var WritableStream = function () {
          function WritableStream() {
            var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              size = _ref.size,
              _ref$highWaterMark = _ref.highWaterMark,
              highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
            _classCallCheck(this, WritableStream);
            this._state = "writable";
            this._storedError = undefined;
            this._writer = undefined;
            this._writableStreamController = undefined;
            this._writeRequests = [];
            this._inFlightWriteRequest = undefined;
            this._closeRequest = undefined;
            this._inFlightCloseRequest = undefined;
            this._pendingAbortRequest = undefined;
            this._backpressure = false;
            var type = underlyingSink.type;
            if (type !== undefined) {
              throw new RangeError("Invalid type is specified");
            }
            this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
            this._writableStreamController.__startSteps();
          }
          _createClass(WritableStream, [{
            key: "abort",
            value: function abort(reason) {
              if (IsWritableStream(this) === false) {
                return Promise.reject(streamBrandCheckException("abort"));
              }
              if (IsWritableStreamLocked(this) === true) {
                return Promise.reject(new TypeError("Cannot abort a stream that already has a writer"));
              }
              return WritableStreamAbort(this, reason);
            }
          }, {
            key: "getWriter",
            value: function getWriter() {
              if (IsWritableStream(this) === false) {
                throw streamBrandCheckException("getWriter");
              }
              return AcquireWritableStreamDefaultWriter(this);
            }
          }, {
            key: "locked",
            get: function get() {
              if (IsWritableStream(this) === false) {
                throw streamBrandCheckException("locked");
              }
              return IsWritableStreamLocked(this);
            }
          }]);
          return WritableStream;
        }();
        module.exports = {
          AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
          IsWritableStream: IsWritableStream,
          IsWritableStreamLocked: IsWritableStreamLocked,
          WritableStream: WritableStream,
          WritableStreamAbort: WritableStreamAbort,
          WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
          WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
          WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
          WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
          WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
        };
        function AcquireWritableStreamDefaultWriter(stream) {
          return new WritableStreamDefaultWriter(stream);
        }
        function IsWritableStream(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_writableStreamController")) {
            return false;
          }
          return true;
        }
        function IsWritableStreamLocked(stream) {
          assert(IsWritableStream(stream) === true, "IsWritableStreamLocked should only be used on known writable streams");
          if (stream._writer === undefined) {
            return false;
          }
          return true;
        }
        function WritableStreamAbort(stream, reason) {
          var state = stream._state;
          if (state === "closed") {
            return Promise.resolve(undefined);
          }
          if (state === "errored") {
            return Promise.reject(stream._storedError);
          }
          var error = new TypeError("Requested to abort");
          if (stream._pendingAbortRequest !== undefined) {
            return Promise.reject(error);
          }
          assert(state === "writable" || state === "erroring", "state must be writable or erroring");
          var wasAlreadyErroring = false;
          if (state === "erroring") {
            wasAlreadyErroring = true;
            reason = undefined;
          }
          var promise = new Promise(function (resolve, reject) {
            stream._pendingAbortRequest = {
              _resolve: resolve,
              _reject: reject,
              _reason: reason,
              _wasAlreadyErroring: wasAlreadyErroring
            };
          });
          if (wasAlreadyErroring === false) {
            WritableStreamStartErroring(stream, error);
          }
          return promise;
        }
        function WritableStreamAddWriteRequest(stream) {
          assert(IsWritableStreamLocked(stream) === true);
          assert(stream._state === "writable");
          var promise = new Promise(function (resolve, reject) {
            var writeRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._writeRequests.push(writeRequest);
          });
          return promise;
        }
        function WritableStreamDealWithRejection(stream, error) {
          var state = stream._state;
          if (state === "writable") {
            WritableStreamStartErroring(stream, error);
            return;
          }
          assert(state === "erroring");
          WritableStreamFinishErroring(stream);
        }
        function WritableStreamStartErroring(stream, reason) {
          assert(stream._storedError === undefined, "stream._storedError === undefined");
          assert(stream._state === "writable", "state must be writable");
          var controller = stream._writableStreamController;
          assert(controller !== undefined, "controller must not be undefined");
          stream._state = "erroring";
          stream._storedError = reason;
          var writer = stream._writer;
          if (writer !== undefined) {
            WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
          }
          if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
            WritableStreamFinishErroring(stream);
          }
        }
        function WritableStreamFinishErroring(stream) {
          assert(stream._state === "erroring", "stream._state === erroring");
          assert(WritableStreamHasOperationMarkedInFlight(stream) === false, "WritableStreamHasOperationMarkedInFlight(stream) === false");
          stream._state = "errored";
          stream._writableStreamController.__errorSteps();
          var storedError = stream._storedError;
          for (var i = 0; i < stream._writeRequests.length; i++) {
            var writeRequest = stream._writeRequests[i];
            writeRequest._reject(storedError);
          }
          stream._writeRequests = [];
          if (stream._pendingAbortRequest === undefined) {
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
            return;
          }
          var abortRequest = stream._pendingAbortRequest;
          stream._pendingAbortRequest = undefined;
          if (abortRequest._wasAlreadyErroring === true) {
            abortRequest._reject(storedError);
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
            return;
          }
          var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
          promise.then(function () {
            abortRequest._resolve();
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
          }, function (reason) {
            abortRequest._reject(reason);
            WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
          });
        }
        function WritableStreamFinishInFlightWrite(stream) {
          assert(stream._inFlightWriteRequest !== undefined);
          stream._inFlightWriteRequest._resolve(undefined);
          stream._inFlightWriteRequest = undefined;
        }
        function WritableStreamFinishInFlightWriteWithError(stream, error) {
          assert(stream._inFlightWriteRequest !== undefined);
          stream._inFlightWriteRequest._reject(error);
          stream._inFlightWriteRequest = undefined;
          assert(stream._state === "writable" || stream._state === "erroring");
          WritableStreamDealWithRejection(stream, error);
        }
        function WritableStreamFinishInFlightClose(stream) {
          assert(stream._inFlightCloseRequest !== undefined);
          stream._inFlightCloseRequest._resolve(undefined);
          stream._inFlightCloseRequest = undefined;
          var state = stream._state;
          assert(state === "writable" || state === "erroring");
          if (state === "erroring") {
            stream._storedError = undefined;
            if (stream._pendingAbortRequest !== undefined) {
              stream._pendingAbortRequest._resolve();
              stream._pendingAbortRequest = undefined;
            }
          }
          stream._state = "closed";
          var writer = stream._writer;
          if (writer !== undefined) {
            defaultWriterClosedPromiseResolve(writer);
          }
          assert(stream._pendingAbortRequest === undefined, "stream._pendingAbortRequest === undefined");
          assert(stream._storedError === undefined, "stream._storedError === undefined");
        }
        function WritableStreamFinishInFlightCloseWithError(stream, error) {
          assert(stream._inFlightCloseRequest !== undefined);
          stream._inFlightCloseRequest._reject(error);
          stream._inFlightCloseRequest = undefined;
          assert(stream._state === "writable" || stream._state === "erroring");
          if (stream._pendingAbortRequest !== undefined) {
            stream._pendingAbortRequest._reject(error);
            stream._pendingAbortRequest = undefined;
          }
          WritableStreamDealWithRejection(stream, error);
        }
        function WritableStreamCloseQueuedOrInFlight(stream) {
          if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
            return false;
          }
          return true;
        }
        function WritableStreamHasOperationMarkedInFlight(stream) {
          if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
            return false;
          }
          return true;
        }
        function WritableStreamMarkCloseRequestInFlight(stream) {
          assert(stream._inFlightCloseRequest === undefined);
          assert(stream._closeRequest !== undefined);
          stream._inFlightCloseRequest = stream._closeRequest;
          stream._closeRequest = undefined;
        }
        function WritableStreamMarkFirstWriteRequestInFlight(stream) {
          assert(stream._inFlightWriteRequest === undefined, "there must be no pending write request");
          assert(stream._writeRequests.length !== 0, "writeRequests must not be empty");
          stream._inFlightWriteRequest = stream._writeRequests.shift();
        }
        function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
          assert(stream._state === "errored", "_stream_.[[state]] is `\"errored\"`");
          if (stream._closeRequest !== undefined) {
            assert(stream._inFlightCloseRequest === undefined);
            stream._closeRequest._reject(stream._storedError);
            stream._closeRequest = undefined;
          }
          var writer = stream._writer;
          if (writer !== undefined) {
            defaultWriterClosedPromiseReject(writer, stream._storedError);
            writer._closedPromise.catch(function () {});
          }
        }
        function WritableStreamUpdateBackpressure(stream, backpressure) {
          assert(stream._state === "writable");
          assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
          var writer = stream._writer;
          if (writer !== undefined && backpressure !== stream._backpressure) {
            if (backpressure === true) {
              defaultWriterReadyPromiseReset(writer);
            } else {
              assert(backpressure === false);
              defaultWriterReadyPromiseResolve(writer);
            }
          }
          stream._backpressure = backpressure;
        }
        var WritableStreamDefaultWriter = function () {
          function WritableStreamDefaultWriter(stream) {
            _classCallCheck(this, WritableStreamDefaultWriter);
            if (IsWritableStream(stream) === false) {
              throw new TypeError("WritableStreamDefaultWriter can only be constructed with a WritableStream instance");
            }
            if (IsWritableStreamLocked(stream) === true) {
              throw new TypeError("This stream has already been locked for exclusive writing by another writer");
            }
            this._ownerWritableStream = stream;
            stream._writer = this;
            var state = stream._state;
            if (state === "writable") {
              if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
                defaultWriterReadyPromiseInitialize(this);
              } else {
                defaultWriterReadyPromiseInitializeAsResolved(this);
              }
              defaultWriterClosedPromiseInitialize(this);
            } else if (state === "erroring") {
              defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
              this._readyPromise.catch(function () {});
              defaultWriterClosedPromiseInitialize(this);
            } else if (state === "closed") {
              defaultWriterReadyPromiseInitializeAsResolved(this);
              defaultWriterClosedPromiseInitializeAsResolved(this);
            } else {
              assert(state === "errored", "state must be errored");
              var storedError = stream._storedError;
              defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
              this._readyPromise.catch(function () {});
              defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
              this._closedPromise.catch(function () {});
            }
          }
          _createClass(WritableStreamDefaultWriter, [{
            key: "abort",
            value: function abort(reason) {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("abort"));
              }
              if (this._ownerWritableStream === undefined) {
                return Promise.reject(defaultWriterLockException("abort"));
              }
              return WritableStreamDefaultWriterAbort(this, reason);
            }
          }, {
            key: "close",
            value: function close() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("close"));
              }
              var stream = this._ownerWritableStream;
              if (stream === undefined) {
                return Promise.reject(defaultWriterLockException("close"));
              }
              if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
                return Promise.reject(new TypeError("cannot close an already-closing stream"));
              }
              return WritableStreamDefaultWriterClose(this);
            }
          }, {
            key: "releaseLock",
            value: function releaseLock() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                throw defaultWriterBrandCheckException("releaseLock");
              }
              var stream = this._ownerWritableStream;
              if (stream === undefined) {
                return;
              }
              assert(stream._writer !== undefined);
              WritableStreamDefaultWriterRelease(this);
            }
          }, {
            key: "write",
            value: function write(chunk) {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("write"));
              }
              if (this._ownerWritableStream === undefined) {
                return Promise.reject(defaultWriterLockException("write to"));
              }
              return WritableStreamDefaultWriterWrite(this, chunk);
            }
          }, {
            key: "closed",
            get: function get() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("closed"));
              }
              return this._closedPromise;
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                throw defaultWriterBrandCheckException("desiredSize");
              }
              if (this._ownerWritableStream === undefined) {
                throw defaultWriterLockException("desiredSize");
              }
              return WritableStreamDefaultWriterGetDesiredSize(this);
            }
          }, {
            key: "ready",
            get: function get() {
              if (IsWritableStreamDefaultWriter(this) === false) {
                return Promise.reject(defaultWriterBrandCheckException("ready"));
              }
              return this._readyPromise;
            }
          }]);
          return WritableStreamDefaultWriter;
        }();
        function IsWritableStreamDefaultWriter(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_ownerWritableStream")) {
            return false;
          }
          return true;
        }
        function WritableStreamDefaultWriterAbort(writer, reason) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          return WritableStreamAbort(stream, reason);
        }
        function WritableStreamDefaultWriterClose(writer) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          var state = stream._state;
          if (state === "closed" || state === "errored") {
            return Promise.reject(new TypeError("The stream (in " + state + " state) is not in the writable state and cannot be closed"));
          }
          assert(state === "writable" || state === "erroring");
          assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
          var promise = new Promise(function (resolve, reject) {
            var closeRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._closeRequest = closeRequest;
          });
          if (stream._backpressure === true && state === "writable") {
            defaultWriterReadyPromiseResolve(writer);
          }
          WritableStreamDefaultControllerClose(stream._writableStreamController);
          return promise;
        }
        function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          var state = stream._state;
          if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === "closed") {
            return Promise.resolve();
          }
          if (state === "errored") {
            return Promise.reject(stream._storedError);
          }
          assert(state === "writable" || state === "erroring");
          return WritableStreamDefaultWriterClose(writer);
        }
        function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
          if (writer._closedPromiseState === "pending") {
            defaultWriterClosedPromiseReject(writer, error);
          } else {
            defaultWriterClosedPromiseResetToRejected(writer, error);
          }
          writer._closedPromise.catch(function () {});
        }
        function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
          if (writer._readyPromiseState === "pending") {
            defaultWriterReadyPromiseReject(writer, error);
          } else {
            defaultWriterReadyPromiseResetToRejected(writer, error);
          }
          writer._readyPromise.catch(function () {});
        }
        function WritableStreamDefaultWriterGetDesiredSize(writer) {
          var stream = writer._ownerWritableStream;
          var state = stream._state;
          if (state === "errored" || state === "erroring") {
            return null;
          }
          if (state === "closed") {
            return 0;
          }
          return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
        }
        function WritableStreamDefaultWriterRelease(writer) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          assert(stream._writer === writer);
          var releasedError = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
          WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
          WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
          stream._writer = undefined;
          writer._ownerWritableStream = undefined;
        }
        function WritableStreamDefaultWriterWrite(writer, chunk) {
          var stream = writer._ownerWritableStream;
          assert(stream !== undefined);
          var controller = stream._writableStreamController;
          var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
          if (stream !== writer._ownerWritableStream) {
            return Promise.reject(defaultWriterLockException("write to"));
          }
          var state = stream._state;
          if (state === "errored") {
            return Promise.reject(stream._storedError);
          }
          if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === "closed") {
            return Promise.reject(new TypeError("The stream is closing or closed and cannot be written to"));
          }
          if (state === "erroring") {
            return Promise.reject(stream._storedError);
          }
          assert(state === "writable");
          var promise = WritableStreamAddWriteRequest(stream);
          WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
          return promise;
        }
        var WritableStreamDefaultController = function () {
          function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
            _classCallCheck(this, WritableStreamDefaultController);
            if (IsWritableStream(stream) === false) {
              throw new TypeError("WritableStreamDefaultController can only be constructed with a WritableStream instance");
            }
            if (stream._writableStreamController !== undefined) {
              throw new TypeError("WritableStreamDefaultController instances can only be created by the WritableStream constructor");
            }
            this._controlledWritableStream = stream;
            this._underlyingSink = underlyingSink;
            this._queue = undefined;
            this._queueTotalSize = undefined;
            ResetQueue(this);
            this._started = false;
            var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
            this._strategySize = normalizedStrategy.size;
            this._strategyHWM = normalizedStrategy.highWaterMark;
            var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
            WritableStreamUpdateBackpressure(stream, backpressure);
          }
          _createClass(WritableStreamDefaultController, [{
            key: "error",
            value: function error(e) {
              if (IsWritableStreamDefaultController(this) === false) {
                throw new TypeError("WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController");
              }
              var state = this._controlledWritableStream._state;
              if (state !== "writable") {
                return;
              }
              WritableStreamDefaultControllerError(this, e);
            }
          }, {
            key: "__abortSteps",
            value: function __abortSteps(reason) {
              return PromiseInvokeOrNoop(this._underlyingSink, "abort", [reason]);
            }
          }, {
            key: "__errorSteps",
            value: function __errorSteps() {
              ResetQueue(this);
            }
          }, {
            key: "__startSteps",
            value: function __startSteps() {
              var _this = this;
              var startResult = InvokeOrNoop(this._underlyingSink, "start", [this]);
              var stream = this._controlledWritableStream;
              Promise.resolve(startResult).then(function () {
                assert(stream._state === "writable" || stream._state === "erroring");
                _this._started = true;
                WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
              }, function (r) {
                assert(stream._state === "writable" || stream._state === "erroring");
                _this._started = true;
                WritableStreamDealWithRejection(stream, r);
              }).catch(rethrowAssertionErrorRejection);
            }
          }]);
          return WritableStreamDefaultController;
        }();
        function WritableStreamDefaultControllerClose(controller) {
          EnqueueValueWithSize(controller, "close", 0);
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
        }
        function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
          var strategySize = controller._strategySize;
          if (strategySize === undefined) {
            return 1;
          }
          try {
            return strategySize(chunk);
          } catch (chunkSizeE) {
            WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
            return 1;
          }
        }
        function WritableStreamDefaultControllerGetDesiredSize(controller) {
          return controller._strategyHWM - controller._queueTotalSize;
        }
        function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
          var writeRecord = { chunk: chunk };
          try {
            EnqueueValueWithSize(controller, writeRecord, chunkSize);
          } catch (enqueueE) {
            WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
            return;
          }
          var stream = controller._controlledWritableStream;
          if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === "writable") {
            var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
            WritableStreamUpdateBackpressure(stream, backpressure);
          }
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
        }
        function IsWritableStreamDefaultController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_underlyingSink")) {
            return false;
          }
          return true;
        }
        function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
          var stream = controller._controlledWritableStream;
          if (controller._started === false) {
            return;
          }
          if (stream._inFlightWriteRequest !== undefined) {
            return;
          }
          var state = stream._state;
          if (state === "closed" || state === "errored") {
            return;
          }
          if (state === "erroring") {
            WritableStreamFinishErroring(stream);
            return;
          }
          if (controller._queue.length === 0) {
            return;
          }
          var writeRecord = PeekQueueValue(controller);
          if (writeRecord === "close") {
            WritableStreamDefaultControllerProcessClose(controller);
          } else {
            WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
          }
        }
        function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
          if (controller._controlledWritableStream._state === "writable") {
            WritableStreamDefaultControllerError(controller, error);
          }
        }
        function WritableStreamDefaultControllerProcessClose(controller) {
          var stream = controller._controlledWritableStream;
          WritableStreamMarkCloseRequestInFlight(stream);
          DequeueValue(controller);
          assert(controller._queue.length === 0, "queue must be empty once the final write record is dequeued");
          var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, "close", []);
          sinkClosePromise.then(function () {
            WritableStreamFinishInFlightClose(stream);
          }, function (reason) {
            WritableStreamFinishInFlightCloseWithError(stream, reason);
          }).catch(rethrowAssertionErrorRejection);
        }
        function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
          var stream = controller._controlledWritableStream;
          WritableStreamMarkFirstWriteRequestInFlight(stream);
          var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, "write", [chunk, controller]);
          sinkWritePromise.then(function () {
            WritableStreamFinishInFlightWrite(stream);
            var state = stream._state;
            assert(state === "writable" || state === "erroring");
            DequeueValue(controller);
            if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === "writable") {
              var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
              WritableStreamUpdateBackpressure(stream, backpressure);
            }
            WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
          }, function (reason) {
            WritableStreamFinishInFlightWriteWithError(stream, reason);
          }).catch(rethrowAssertionErrorRejection);
        }
        function WritableStreamDefaultControllerGetBackpressure(controller) {
          var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
          return desiredSize <= 0;
        }
        function WritableStreamDefaultControllerError(controller, error) {
          var stream = controller._controlledWritableStream;
          assert(stream._state === "writable");
          WritableStreamStartErroring(stream, error);
        }
        function streamBrandCheckException(name) {
          return new TypeError("WritableStream.prototype." + name + " can only be used on a WritableStream");
        }
        function defaultWriterBrandCheckException(name) {
          return new TypeError("WritableStreamDefaultWriter.prototype." + name + " can only be used on a WritableStreamDefaultWriter");
        }
        function defaultWriterLockException(name) {
          return new TypeError("Cannot " + name + " a stream using a released writer");
        }
        function defaultWriterClosedPromiseInitialize(writer) {
          writer._closedPromise = new Promise(function (resolve, reject) {
            writer._closedPromise_resolve = resolve;
            writer._closedPromise_reject = reject;
            writer._closedPromiseState = "pending";
          });
        }
        function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
          writer._closedPromise = Promise.reject(reason);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "rejected";
        }
        function defaultWriterClosedPromiseInitializeAsResolved(writer) {
          writer._closedPromise = Promise.resolve(undefined);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "resolved";
        }
        function defaultWriterClosedPromiseReject(writer, reason) {
          assert(writer._closedPromise_resolve !== undefined, "writer._closedPromise_resolve !== undefined");
          assert(writer._closedPromise_reject !== undefined, "writer._closedPromise_reject !== undefined");
          assert(writer._closedPromiseState === "pending", "writer._closedPromiseState is pending");
          writer._closedPromise_reject(reason);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "rejected";
        }
        function defaultWriterClosedPromiseResetToRejected(writer, reason) {
          assert(writer._closedPromise_resolve === undefined, "writer._closedPromise_resolve === undefined");
          assert(writer._closedPromise_reject === undefined, "writer._closedPromise_reject === undefined");
          assert(writer._closedPromiseState !== "pending", "writer._closedPromiseState is not pending");
          writer._closedPromise = Promise.reject(reason);
          writer._closedPromiseState = "rejected";
        }
        function defaultWriterClosedPromiseResolve(writer) {
          assert(writer._closedPromise_resolve !== undefined, "writer._closedPromise_resolve !== undefined");
          assert(writer._closedPromise_reject !== undefined, "writer._closedPromise_reject !== undefined");
          assert(writer._closedPromiseState === "pending", "writer._closedPromiseState is pending");
          writer._closedPromise_resolve(undefined);
          writer._closedPromise_resolve = undefined;
          writer._closedPromise_reject = undefined;
          writer._closedPromiseState = "resolved";
        }
        function defaultWriterReadyPromiseInitialize(writer) {
          writer._readyPromise = new Promise(function (resolve, reject) {
            writer._readyPromise_resolve = resolve;
            writer._readyPromise_reject = reject;
          });
          writer._readyPromiseState = "pending";
        }
        function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
          writer._readyPromise = Promise.reject(reason);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "rejected";
        }
        function defaultWriterReadyPromiseInitializeAsResolved(writer) {
          writer._readyPromise = Promise.resolve(undefined);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "fulfilled";
        }
        function defaultWriterReadyPromiseReject(writer, reason) {
          assert(writer._readyPromise_resolve !== undefined, "writer._readyPromise_resolve !== undefined");
          assert(writer._readyPromise_reject !== undefined, "writer._readyPromise_reject !== undefined");
          writer._readyPromise_reject(reason);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "rejected";
        }
        function defaultWriterReadyPromiseReset(writer) {
          assert(writer._readyPromise_resolve === undefined, "writer._readyPromise_resolve === undefined");
          assert(writer._readyPromise_reject === undefined, "writer._readyPromise_reject === undefined");
          writer._readyPromise = new Promise(function (resolve, reject) {
            writer._readyPromise_resolve = resolve;
            writer._readyPromise_reject = reject;
          });
          writer._readyPromiseState = "pending";
        }
        function defaultWriterReadyPromiseResetToRejected(writer, reason) {
          assert(writer._readyPromise_resolve === undefined, "writer._readyPromise_resolve === undefined");
          assert(writer._readyPromise_reject === undefined, "writer._readyPromise_reject === undefined");
          writer._readyPromise = Promise.reject(reason);
          writer._readyPromiseState = "rejected";
        }
        function defaultWriterReadyPromiseResolve(writer) {
          assert(writer._readyPromise_resolve !== undefined, "writer._readyPromise_resolve !== undefined");
          assert(writer._readyPromise_reject !== undefined, "writer._readyPromise_reject !== undefined");
          writer._readyPromise_resolve(undefined);
          writer._readyPromise_resolve = undefined;
          writer._readyPromise_reject = undefined;
          writer._readyPromiseState = "fulfilled";
        }
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _require = __w_pdfjs_require__(0),
          IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
        var _require2 = __w_pdfjs_require__(1),
          assert = _require2.assert;
        exports.DequeueValue = function (container) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].");
          assert(container._queue.length > 0, "Spec-level failure: should never dequeue from an empty queue.");
          var pair = container._queue.shift();
          container._queueTotalSize -= pair.size;
          if (container._queueTotalSize < 0) {
            container._queueTotalSize = 0;
          }
          return pair.value;
        };
        exports.EnqueueValueWithSize = function (container, value, size) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and " + "[[queueTotalSize]].");
          size = Number(size);
          if (!IsFiniteNonNegativeNumber(size)) {
            throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
          }
          container._queue.push({
            value: value,
            size: size
          });
          container._queueTotalSize += size;
        };
        exports.PeekQueueValue = function (container) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].");
          assert(container._queue.length > 0, "Spec-level failure: should never peek at an empty queue.");
          var pair = container._queue[0];
          return pair.value;
        };
        exports.ResetQueue = function (container) {
          assert("_queue" in container && "_queueTotalSize" in container, "Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].");
          container._queue = [];
          container._queueTotalSize = 0;
        };
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var _require = __w_pdfjs_require__(0),
          ArrayBufferCopy = _require.ArrayBufferCopy,
          CreateIterResultObject = _require.CreateIterResultObject,
          IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
          InvokeOrNoop = _require.InvokeOrNoop,
          PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
          TransferArrayBuffer = _require.TransferArrayBuffer,
          ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
          ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
        var _require2 = __w_pdfjs_require__(0),
          createArrayFromList = _require2.createArrayFromList,
          createDataProperty = _require2.createDataProperty,
          typeIsObject = _require2.typeIsObject;
        var _require3 = __w_pdfjs_require__(1),
          assert = _require3.assert,
          rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
        var _require4 = __w_pdfjs_require__(3),
          DequeueValue = _require4.DequeueValue,
          EnqueueValueWithSize = _require4.EnqueueValueWithSize,
          ResetQueue = _require4.ResetQueue;
        var _require5 = __w_pdfjs_require__(2),
          AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
          IsWritableStream = _require5.IsWritableStream,
          IsWritableStreamLocked = _require5.IsWritableStreamLocked,
          WritableStreamAbort = _require5.WritableStreamAbort,
          WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
          WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
          WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
          WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
        var ReadableStream = function () {
          function ReadableStream() {
            var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              size = _ref.size,
              highWaterMark = _ref.highWaterMark;
            _classCallCheck(this, ReadableStream);
            this._state = "readable";
            this._reader = undefined;
            this._storedError = undefined;
            this._disturbed = false;
            this._readableStreamController = undefined;
            var type = underlyingSource.type;
            var typeString = String(type);
            if (typeString === "bytes") {
              if (highWaterMark === undefined) {
                highWaterMark = 0;
              }
              this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
            } else if (type === undefined) {
              if (highWaterMark === undefined) {
                highWaterMark = 1;
              }
              this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
            } else {
              throw new RangeError("Invalid type is specified");
            }
          }
          _createClass(ReadableStream, [{
            key: "cancel",
            value: function cancel(reason) {
              if (IsReadableStream(this) === false) {
                return Promise.reject(streamBrandCheckException("cancel"));
              }
              if (IsReadableStreamLocked(this) === true) {
                return Promise.reject(new TypeError("Cannot cancel a stream that already has a reader"));
              }
              return ReadableStreamCancel(this, reason);
            }
          }, {
            key: "getReader",
            value: function getReader() {
              var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                mode = _ref2.mode;
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException("getReader");
              }
              if (mode === undefined) {
                return AcquireReadableStreamDefaultReader(this);
              }
              mode = String(mode);
              if (mode === "byob") {
                return AcquireReadableStreamBYOBReader(this);
              }
              throw new RangeError("Invalid mode is specified");
            }
          }, {
            key: "pipeThrough",
            value: function pipeThrough(_ref3, options) {
              var writable = _ref3.writable,
                readable = _ref3.readable;
              var promise = this.pipeTo(writable, options);
              ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
              return readable;
            }
          }, {
            key: "pipeTo",
            value: function pipeTo(dest) {
              var _this = this;
              var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                preventClose = _ref4.preventClose,
                preventAbort = _ref4.preventAbort,
                preventCancel = _ref4.preventCancel;
              if (IsReadableStream(this) === false) {
                return Promise.reject(streamBrandCheckException("pipeTo"));
              }
              if (IsWritableStream(dest) === false) {
                return Promise.reject(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
              }
              preventClose = Boolean(preventClose);
              preventAbort = Boolean(preventAbort);
              preventCancel = Boolean(preventCancel);
              if (IsReadableStreamLocked(this) === true) {
                return Promise.reject(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream"));
              }
              if (IsWritableStreamLocked(dest) === true) {
                return Promise.reject(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream"));
              }
              var reader = AcquireReadableStreamDefaultReader(this);
              var writer = AcquireWritableStreamDefaultWriter(dest);
              var shuttingDown = false;
              var currentWrite = Promise.resolve();
              return new Promise(function (resolve, reject) {
                function pipeLoop() {
                  currentWrite = Promise.resolve();
                  if (shuttingDown === true) {
                    return Promise.resolve();
                  }
                  return writer._readyPromise.then(function () {
                    return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                      var value = _ref5.value,
                        done = _ref5.done;
                      if (done === true) {
                        return;
                      }
                      currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
                    });
                  }).then(pipeLoop);
                }
                isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
                  if (preventAbort === false) {
                    shutdownWithAction(function () {
                      return WritableStreamAbort(dest, storedError);
                    }, true, storedError);
                  } else {
                    shutdown(true, storedError);
                  }
                });
                isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
                  if (preventCancel === false) {
                    shutdownWithAction(function () {
                      return ReadableStreamCancel(_this, storedError);
                    }, true, storedError);
                  } else {
                    shutdown(true, storedError);
                  }
                });
                isOrBecomesClosed(_this, reader._closedPromise, function () {
                  if (preventClose === false) {
                    shutdownWithAction(function () {
                      return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
                    });
                  } else {
                    shutdown();
                  }
                });
                if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === "closed") {
                  var destClosed = new TypeError("the destination writable stream closed before all data could be piped to it");
                  if (preventCancel === false) {
                    shutdownWithAction(function () {
                      return ReadableStreamCancel(_this, destClosed);
                    }, true, destClosed);
                  } else {
                    shutdown(true, destClosed);
                  }
                }
                pipeLoop().catch(function (err) {
                  currentWrite = Promise.resolve();
                  rethrowAssertionErrorRejection(err);
                });
                function waitForWritesToFinish() {
                  var oldCurrentWrite = currentWrite;
                  return currentWrite.then(function () {
                    return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
                  });
                }
                function isOrBecomesErrored(stream, promise, action) {
                  if (stream._state === "errored") {
                    action(stream._storedError);
                  } else {
                    promise.catch(action).catch(rethrowAssertionErrorRejection);
                  }
                }
                function isOrBecomesClosed(stream, promise, action) {
                  if (stream._state === "closed") {
                    action();
                  } else {
                    promise.then(action).catch(rethrowAssertionErrorRejection);
                  }
                }
                function shutdownWithAction(action, originalIsError, originalError) {
                  if (shuttingDown === true) {
                    return;
                  }
                  shuttingDown = true;
                  if (dest._state === "writable" && WritableStreamCloseQueuedOrInFlight(dest) === false) {
                    waitForWritesToFinish().then(doTheRest);
                  } else {
                    doTheRest();
                  }
                  function doTheRest() {
                    action().then(function () {
                      return finalize(originalIsError, originalError);
                    }, function (newError) {
                      return finalize(true, newError);
                    }).catch(rethrowAssertionErrorRejection);
                  }
                }
                function shutdown(isError, error) {
                  if (shuttingDown === true) {
                    return;
                  }
                  shuttingDown = true;
                  if (dest._state === "writable" && WritableStreamCloseQueuedOrInFlight(dest) === false) {
                    waitForWritesToFinish().then(function () {
                      return finalize(isError, error);
                    }).catch(rethrowAssertionErrorRejection);
                  } else {
                    finalize(isError, error);
                  }
                }
                function finalize(isError, error) {
                  WritableStreamDefaultWriterRelease(writer);
                  ReadableStreamReaderGenericRelease(reader);
                  if (isError) {
                    reject(error);
                  } else {
                    resolve(undefined);
                  }
                }
              });
            }
          }, {
            key: "tee",
            value: function tee() {
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException("tee");
              }
              var branches = ReadableStreamTee(this, false);
              return createArrayFromList(branches);
            }
          }, {
            key: "locked",
            get: function get() {
              if (IsReadableStream(this) === false) {
                throw streamBrandCheckException("locked");
              }
              return IsReadableStreamLocked(this);
            }
          }]);
          return ReadableStream;
        }();
        module.exports = {
          ReadableStream: ReadableStream,
          IsReadableStreamDisturbed: IsReadableStreamDisturbed,
          ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
          ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
          ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
          ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
        };
        function AcquireReadableStreamBYOBReader(stream) {
          return new ReadableStreamBYOBReader(stream);
        }
        function AcquireReadableStreamDefaultReader(stream) {
          return new ReadableStreamDefaultReader(stream);
        }
        function IsReadableStream(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_readableStreamController")) {
            return false;
          }
          return true;
        }
        function IsReadableStreamDisturbed(stream) {
          assert(IsReadableStream(stream) === true, "IsReadableStreamDisturbed should only be used on known readable streams");
          return stream._disturbed;
        }
        function IsReadableStreamLocked(stream) {
          assert(IsReadableStream(stream) === true, "IsReadableStreamLocked should only be used on known readable streams");
          if (stream._reader === undefined) {
            return false;
          }
          return true;
        }
        function ReadableStreamTee(stream, cloneForBranch2) {
          assert(IsReadableStream(stream) === true);
          assert(typeof cloneForBranch2 === "boolean");
          var reader = AcquireReadableStreamDefaultReader(stream);
          var teeState = {
            closedOrErrored: false,
            canceled1: false,
            canceled2: false,
            reason1: undefined,
            reason2: undefined
          };
          teeState.promise = new Promise(function (resolve) {
            teeState._resolve = resolve;
          });
          var pull = create_ReadableStreamTeePullFunction();
          pull._reader = reader;
          pull._teeState = teeState;
          pull._cloneForBranch2 = cloneForBranch2;
          var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
          cancel1._stream = stream;
          cancel1._teeState = teeState;
          var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
          cancel2._stream = stream;
          cancel2._teeState = teeState;
          var underlyingSource1 = Object.create(Object.prototype);
          createDataProperty(underlyingSource1, "pull", pull);
          createDataProperty(underlyingSource1, "cancel", cancel1);
          var branch1Stream = new ReadableStream(underlyingSource1);
          var underlyingSource2 = Object.create(Object.prototype);
          createDataProperty(underlyingSource2, "pull", pull);
          createDataProperty(underlyingSource2, "cancel", cancel2);
          var branch2Stream = new ReadableStream(underlyingSource2);
          pull._branch1 = branch1Stream._readableStreamController;
          pull._branch2 = branch2Stream._readableStreamController;
          reader._closedPromise.catch(function (r) {
            if (teeState.closedOrErrored === true) {
              return;
            }
            ReadableStreamDefaultControllerError(pull._branch1, r);
            ReadableStreamDefaultControllerError(pull._branch2, r);
            teeState.closedOrErrored = true;
          });
          return [branch1Stream, branch2Stream];
        }
        function create_ReadableStreamTeePullFunction() {
          function f() {
            var reader = f._reader,
              branch1 = f._branch1,
              branch2 = f._branch2,
              teeState = f._teeState;
            return ReadableStreamDefaultReaderRead(reader).then(function (result) {
              assert(typeIsObject(result));
              var value = result.value;
              var done = result.done;
              assert(typeof done === "boolean");
              if (done === true && teeState.closedOrErrored === false) {
                if (teeState.canceled1 === false) {
                  ReadableStreamDefaultControllerClose(branch1);
                }
                if (teeState.canceled2 === false) {
                  ReadableStreamDefaultControllerClose(branch2);
                }
                teeState.closedOrErrored = true;
              }
              if (teeState.closedOrErrored === true) {
                return;
              }
              var value1 = value;
              var value2 = value;
              if (teeState.canceled1 === false) {
                ReadableStreamDefaultControllerEnqueue(branch1, value1);
              }
              if (teeState.canceled2 === false) {
                ReadableStreamDefaultControllerEnqueue(branch2, value2);
              }
            });
          }
          return f;
        }
        function create_ReadableStreamTeeBranch1CancelFunction() {
          function f(reason) {
            var stream = f._stream,
              teeState = f._teeState;
            teeState.canceled1 = true;
            teeState.reason1 = reason;
            if (teeState.canceled2 === true) {
              var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
              var cancelResult = ReadableStreamCancel(stream, compositeReason);
              teeState._resolve(cancelResult);
            }
            return teeState.promise;
          }
          return f;
        }
        function create_ReadableStreamTeeBranch2CancelFunction() {
          function f(reason) {
            var stream = f._stream,
              teeState = f._teeState;
            teeState.canceled2 = true;
            teeState.reason2 = reason;
            if (teeState.canceled1 === true) {
              var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
              var cancelResult = ReadableStreamCancel(stream, compositeReason);
              teeState._resolve(cancelResult);
            }
            return teeState.promise;
          }
          return f;
        }
        function ReadableStreamAddReadIntoRequest(stream) {
          assert(IsReadableStreamBYOBReader(stream._reader) === true);
          assert(stream._state === "readable" || stream._state === "closed");
          var promise = new Promise(function (resolve, reject) {
            var readIntoRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._reader._readIntoRequests.push(readIntoRequest);
          });
          return promise;
        }
        function ReadableStreamAddReadRequest(stream) {
          assert(IsReadableStreamDefaultReader(stream._reader) === true);
          assert(stream._state === "readable");
          var promise = new Promise(function (resolve, reject) {
            var readRequest = {
              _resolve: resolve,
              _reject: reject
            };
            stream._reader._readRequests.push(readRequest);
          });
          return promise;
        }
        function ReadableStreamCancel(stream, reason) {
          stream._disturbed = true;
          if (stream._state === "closed") {
            return Promise.resolve(undefined);
          }
          if (stream._state === "errored") {
            return Promise.reject(stream._storedError);
          }
          ReadableStreamClose(stream);
          var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
          return sourceCancelPromise.then(function () {
            return undefined;
          });
        }
        function ReadableStreamClose(stream) {
          assert(stream._state === "readable");
          stream._state = "closed";
          var reader = stream._reader;
          if (reader === undefined) {
            return undefined;
          }
          if (IsReadableStreamDefaultReader(reader) === true) {
            for (var i = 0; i < reader._readRequests.length; i++) {
              var _resolve = reader._readRequests[i]._resolve;
              _resolve(CreateIterResultObject(undefined, true));
            }
            reader._readRequests = [];
          }
          defaultReaderClosedPromiseResolve(reader);
          return undefined;
        }
        function ReadableStreamError(stream, e) {
          assert(IsReadableStream(stream) === true, "stream must be ReadableStream");
          assert(stream._state === "readable", "state must be readable");
          stream._state = "errored";
          stream._storedError = e;
          var reader = stream._reader;
          if (reader === undefined) {
            return undefined;
          }
          if (IsReadableStreamDefaultReader(reader) === true) {
            for (var i = 0; i < reader._readRequests.length; i++) {
              var readRequest = reader._readRequests[i];
              readRequest._reject(e);
            }
            reader._readRequests = [];
          } else {
            assert(IsReadableStreamBYOBReader(reader), "reader must be ReadableStreamBYOBReader");
            for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
              var readIntoRequest = reader._readIntoRequests[_i];
              readIntoRequest._reject(e);
            }
            reader._readIntoRequests = [];
          }
          defaultReaderClosedPromiseReject(reader, e);
          reader._closedPromise.catch(function () {});
        }
        function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
          var reader = stream._reader;
          assert(reader._readIntoRequests.length > 0);
          var readIntoRequest = reader._readIntoRequests.shift();
          readIntoRequest._resolve(CreateIterResultObject(chunk, done));
        }
        function ReadableStreamFulfillReadRequest(stream, chunk, done) {
          var reader = stream._reader;
          assert(reader._readRequests.length > 0);
          var readRequest = reader._readRequests.shift();
          readRequest._resolve(CreateIterResultObject(chunk, done));
        }
        function ReadableStreamGetNumReadIntoRequests(stream) {
          return stream._reader._readIntoRequests.length;
        }
        function ReadableStreamGetNumReadRequests(stream) {
          return stream._reader._readRequests.length;
        }
        function ReadableStreamHasBYOBReader(stream) {
          var reader = stream._reader;
          if (reader === undefined) {
            return false;
          }
          if (IsReadableStreamBYOBReader(reader) === false) {
            return false;
          }
          return true;
        }
        function ReadableStreamHasDefaultReader(stream) {
          var reader = stream._reader;
          if (reader === undefined) {
            return false;
          }
          if (IsReadableStreamDefaultReader(reader) === false) {
            return false;
          }
          return true;
        }
        var ReadableStreamDefaultReader = function () {
          function ReadableStreamDefaultReader(stream) {
            _classCallCheck(this, ReadableStreamDefaultReader);
            if (IsReadableStream(stream) === false) {
              throw new TypeError("ReadableStreamDefaultReader can only be constructed with a ReadableStream instance");
            }
            if (IsReadableStreamLocked(stream) === true) {
              throw new TypeError("This stream has already been locked for exclusive reading by another reader");
            }
            ReadableStreamReaderGenericInitialize(this, stream);
            this._readRequests = [];
          }
          _createClass(ReadableStreamDefaultReader, [{
            key: "cancel",
            value: function cancel(reason) {
              if (IsReadableStreamDefaultReader(this) === false) {
                return Promise.reject(defaultReaderBrandCheckException("cancel"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("cancel"));
              }
              return ReadableStreamReaderGenericCancel(this, reason);
            }
          }, {
            key: "read",
            value: function read() {
              if (IsReadableStreamDefaultReader(this) === false) {
                return Promise.reject(defaultReaderBrandCheckException("read"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("read from"));
              }
              return ReadableStreamDefaultReaderRead(this);
            }
          }, {
            key: "releaseLock",
            value: function releaseLock() {
              if (IsReadableStreamDefaultReader(this) === false) {
                throw defaultReaderBrandCheckException("releaseLock");
              }
              if (this._ownerReadableStream === undefined) {
                return;
              }
              if (this._readRequests.length > 0) {
                throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
              }
              ReadableStreamReaderGenericRelease(this);
            }
          }, {
            key: "closed",
            get: function get() {
              if (IsReadableStreamDefaultReader(this) === false) {
                return Promise.reject(defaultReaderBrandCheckException("closed"));
              }
              return this._closedPromise;
            }
          }]);
          return ReadableStreamDefaultReader;
        }();
        var ReadableStreamBYOBReader = function () {
          function ReadableStreamBYOBReader(stream) {
            _classCallCheck(this, ReadableStreamBYOBReader);
            if (!IsReadableStream(stream)) {
              throw new TypeError("ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a " + "byte source");
            }
            if (IsReadableByteStreamController(stream._readableStreamController) === false) {
              throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte " + "source");
            }
            if (IsReadableStreamLocked(stream)) {
              throw new TypeError("This stream has already been locked for exclusive reading by another reader");
            }
            ReadableStreamReaderGenericInitialize(this, stream);
            this._readIntoRequests = [];
          }
          _createClass(ReadableStreamBYOBReader, [{
            key: "cancel",
            value: function cancel(reason) {
              if (!IsReadableStreamBYOBReader(this)) {
                return Promise.reject(byobReaderBrandCheckException("cancel"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("cancel"));
              }
              return ReadableStreamReaderGenericCancel(this, reason);
            }
          }, {
            key: "read",
            value: function read(view) {
              if (!IsReadableStreamBYOBReader(this)) {
                return Promise.reject(byobReaderBrandCheckException("read"));
              }
              if (this._ownerReadableStream === undefined) {
                return Promise.reject(readerLockException("read from"));
              }
              if (!ArrayBuffer.isView(view)) {
                return Promise.reject(new TypeError("view must be an array buffer view"));
              }
              if (view.byteLength === 0) {
                return Promise.reject(new TypeError("view must have non-zero byteLength"));
              }
              return ReadableStreamBYOBReaderRead(this, view);
            }
          }, {
            key: "releaseLock",
            value: function releaseLock() {
              if (!IsReadableStreamBYOBReader(this)) {
                throw byobReaderBrandCheckException("releaseLock");
              }
              if (this._ownerReadableStream === undefined) {
                return;
              }
              if (this._readIntoRequests.length > 0) {
                throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
              }
              ReadableStreamReaderGenericRelease(this);
            }
          }, {
            key: "closed",
            get: function get() {
              if (!IsReadableStreamBYOBReader(this)) {
                return Promise.reject(byobReaderBrandCheckException("closed"));
              }
              return this._closedPromise;
            }
          }]);
          return ReadableStreamBYOBReader;
        }();
        function IsReadableStreamBYOBReader(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_readIntoRequests")) {
            return false;
          }
          return true;
        }
        function IsReadableStreamDefaultReader(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_readRequests")) {
            return false;
          }
          return true;
        }
        function ReadableStreamReaderGenericInitialize(reader, stream) {
          reader._ownerReadableStream = stream;
          stream._reader = reader;
          if (stream._state === "readable") {
            defaultReaderClosedPromiseInitialize(reader);
          } else if (stream._state === "closed") {
            defaultReaderClosedPromiseInitializeAsResolved(reader);
          } else {
            assert(stream._state === "errored", "state must be errored");
            defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
            reader._closedPromise.catch(function () {});
          }
        }
        function ReadableStreamReaderGenericCancel(reader, reason) {
          var stream = reader._ownerReadableStream;
          assert(stream !== undefined);
          return ReadableStreamCancel(stream, reason);
        }
        function ReadableStreamReaderGenericRelease(reader) {
          assert(reader._ownerReadableStream !== undefined);
          assert(reader._ownerReadableStream._reader === reader);
          if (reader._ownerReadableStream._state === "readable") {
            defaultReaderClosedPromiseReject(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
          } else {
            defaultReaderClosedPromiseResetToRejected(reader, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
          }
          reader._closedPromise.catch(function () {});
          reader._ownerReadableStream._reader = undefined;
          reader._ownerReadableStream = undefined;
        }
        function ReadableStreamBYOBReaderRead(reader, view) {
          var stream = reader._ownerReadableStream;
          assert(stream !== undefined);
          stream._disturbed = true;
          if (stream._state === "errored") {
            return Promise.reject(stream._storedError);
          }
          return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
        }
        function ReadableStreamDefaultReaderRead(reader) {
          var stream = reader._ownerReadableStream;
          assert(stream !== undefined);
          stream._disturbed = true;
          if (stream._state === "closed") {
            return Promise.resolve(CreateIterResultObject(undefined, true));
          }
          if (stream._state === "errored") {
            return Promise.reject(stream._storedError);
          }
          assert(stream._state === "readable");
          return stream._readableStreamController.__pullSteps();
        }
        var ReadableStreamDefaultController = function () {
          function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
            _classCallCheck(this, ReadableStreamDefaultController);
            if (IsReadableStream(stream) === false) {
              throw new TypeError("ReadableStreamDefaultController can only be constructed with a ReadableStream instance");
            }
            if (stream._readableStreamController !== undefined) {
              throw new TypeError("ReadableStreamDefaultController instances can only be created by the ReadableStream constructor");
            }
            this._controlledReadableStream = stream;
            this._underlyingSource = underlyingSource;
            this._queue = undefined;
            this._queueTotalSize = undefined;
            ResetQueue(this);
            this._started = false;
            this._closeRequested = false;
            this._pullAgain = false;
            this._pulling = false;
            var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
            this._strategySize = normalizedStrategy.size;
            this._strategyHWM = normalizedStrategy.highWaterMark;
            var controller = this;
            var startResult = InvokeOrNoop(underlyingSource, "start", [this]);
            Promise.resolve(startResult).then(function () {
              controller._started = true;
              assert(controller._pulling === false);
              assert(controller._pullAgain === false);
              ReadableStreamDefaultControllerCallPullIfNeeded(controller);
            }, function (r) {
              ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
            }).catch(rethrowAssertionErrorRejection);
          }
          _createClass(ReadableStreamDefaultController, [{
            key: "close",
            value: function close() {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("close");
              }
              if (this._closeRequested === true) {
                throw new TypeError("The stream has already been closed; do not close it again!");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
              }
              ReadableStreamDefaultControllerClose(this);
            }
          }, {
            key: "enqueue",
            value: function enqueue(chunk) {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("enqueue");
              }
              if (this._closeRequested === true) {
                throw new TypeError("stream is closed or draining");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
              }
              return ReadableStreamDefaultControllerEnqueue(this, chunk);
            }
          }, {
            key: "error",
            value: function error(e) {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("error");
              }
              var stream = this._controlledReadableStream;
              if (stream._state !== "readable") {
                throw new TypeError("The stream is " + stream._state + " and so cannot be errored");
              }
              ReadableStreamDefaultControllerError(this, e);
            }
          }, {
            key: "__cancelSteps",
            value: function __cancelSteps(reason) {
              ResetQueue(this);
              return PromiseInvokeOrNoop(this._underlyingSource, "cancel", [reason]);
            }
          }, {
            key: "__pullSteps",
            value: function __pullSteps() {
              var stream = this._controlledReadableStream;
              if (this._queue.length > 0) {
                var chunk = DequeueValue(this);
                if (this._closeRequested === true && this._queue.length === 0) {
                  ReadableStreamClose(stream);
                } else {
                  ReadableStreamDefaultControllerCallPullIfNeeded(this);
                }
                return Promise.resolve(CreateIterResultObject(chunk, false));
              }
              var pendingPromise = ReadableStreamAddReadRequest(stream);
              ReadableStreamDefaultControllerCallPullIfNeeded(this);
              return pendingPromise;
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsReadableStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("desiredSize");
              }
              return ReadableStreamDefaultControllerGetDesiredSize(this);
            }
          }]);
          return ReadableStreamDefaultController;
        }();
        function IsReadableStreamDefaultController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_underlyingSource")) {
            return false;
          }
          return true;
        }
        function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
          var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
          if (shouldPull === false) {
            return undefined;
          }
          if (controller._pulling === true) {
            controller._pullAgain = true;
            return undefined;
          }
          assert(controller._pullAgain === false);
          controller._pulling = true;
          var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, "pull", [controller]);
          pullPromise.then(function () {
            controller._pulling = false;
            if (controller._pullAgain === true) {
              controller._pullAgain = false;
              return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
            }
            return undefined;
          }, function (e) {
            ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
          }).catch(rethrowAssertionErrorRejection);
          return undefined;
        }
        function ReadableStreamDefaultControllerShouldCallPull(controller) {
          var stream = controller._controlledReadableStream;
          if (stream._state === "closed" || stream._state === "errored") {
            return false;
          }
          if (controller._closeRequested === true) {
            return false;
          }
          if (controller._started === false) {
            return false;
          }
          if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            return true;
          }
          var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
          if (desiredSize > 0) {
            return true;
          }
          return false;
        }
        function ReadableStreamDefaultControllerClose(controller) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          controller._closeRequested = true;
          if (controller._queue.length === 0) {
            ReadableStreamClose(stream);
          }
        }
        function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            ReadableStreamFulfillReadRequest(stream, chunk, false);
          } else {
            var chunkSize = 1;
            if (controller._strategySize !== undefined) {
              var strategySize = controller._strategySize;
              try {
                chunkSize = strategySize(chunk);
              } catch (chunkSizeE) {
                ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
                throw chunkSizeE;
              }
            }
            try {
              EnqueueValueWithSize(controller, chunk, chunkSize);
            } catch (enqueueE) {
              ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
              throw enqueueE;
            }
          }
          ReadableStreamDefaultControllerCallPullIfNeeded(controller);
          return undefined;
        }
        function ReadableStreamDefaultControllerError(controller, e) {
          var stream = controller._controlledReadableStream;
          assert(stream._state === "readable");
          ResetQueue(controller);
          ReadableStreamError(stream, e);
        }
        function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
          if (controller._controlledReadableStream._state === "readable") {
            ReadableStreamDefaultControllerError(controller, e);
          }
        }
        function ReadableStreamDefaultControllerGetDesiredSize(controller) {
          var stream = controller._controlledReadableStream;
          var state = stream._state;
          if (state === "errored") {
            return null;
          }
          if (state === "closed") {
            return 0;
          }
          return controller._strategyHWM - controller._queueTotalSize;
        }
        var ReadableStreamBYOBRequest = function () {
          function ReadableStreamBYOBRequest(controller, view) {
            _classCallCheck(this, ReadableStreamBYOBRequest);
            this._associatedReadableByteStreamController = controller;
            this._view = view;
          }
          _createClass(ReadableStreamBYOBRequest, [{
            key: "respond",
            value: function respond(bytesWritten) {
              if (IsReadableStreamBYOBRequest(this) === false) {
                throw byobRequestBrandCheckException("respond");
              }
              if (this._associatedReadableByteStreamController === undefined) {
                throw new TypeError("This BYOB request has been invalidated");
              }
              ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
            }
          }, {
            key: "respondWithNewView",
            value: function respondWithNewView(view) {
              if (IsReadableStreamBYOBRequest(this) === false) {
                throw byobRequestBrandCheckException("respond");
              }
              if (this._associatedReadableByteStreamController === undefined) {
                throw new TypeError("This BYOB request has been invalidated");
              }
              if (!ArrayBuffer.isView(view)) {
                throw new TypeError("You can only respond with array buffer views");
              }
              ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
            }
          }, {
            key: "view",
            get: function get() {
              return this._view;
            }
          }]);
          return ReadableStreamBYOBRequest;
        }();
        var ReadableByteStreamController = function () {
          function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
            _classCallCheck(this, ReadableByteStreamController);
            if (IsReadableStream(stream) === false) {
              throw new TypeError("ReadableByteStreamController can only be constructed with a ReadableStream instance given " + "a byte source");
            }
            if (stream._readableStreamController !== undefined) {
              throw new TypeError("ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte " + "source");
            }
            this._controlledReadableStream = stream;
            this._underlyingByteSource = underlyingByteSource;
            this._pullAgain = false;
            this._pulling = false;
            ReadableByteStreamControllerClearPendingPullIntos(this);
            this._queue = this._queueTotalSize = undefined;
            ResetQueue(this);
            this._closeRequested = false;
            this._started = false;
            this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
            var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
            if (autoAllocateChunkSize !== undefined) {
              if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
                throw new RangeError("autoAllocateChunkSize must be a positive integer");
              }
            }
            this._autoAllocateChunkSize = autoAllocateChunkSize;
            this._pendingPullIntos = [];
            var controller = this;
            var startResult = InvokeOrNoop(underlyingByteSource, "start", [this]);
            Promise.resolve(startResult).then(function () {
              controller._started = true;
              assert(controller._pulling === false);
              assert(controller._pullAgain === false);
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }, function (r) {
              if (stream._state === "readable") {
                ReadableByteStreamControllerError(controller, r);
              }
            }).catch(rethrowAssertionErrorRejection);
          }
          _createClass(ReadableByteStreamController, [{
            key: "close",
            value: function close() {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("close");
              }
              if (this._closeRequested === true) {
                throw new TypeError("The stream has already been closed; do not close it again!");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
              }
              ReadableByteStreamControllerClose(this);
            }
          }, {
            key: "enqueue",
            value: function enqueue(chunk) {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("enqueue");
              }
              if (this._closeRequested === true) {
                throw new TypeError("stream is closed or draining");
              }
              var state = this._controlledReadableStream._state;
              if (state !== "readable") {
                throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
              }
              if (!ArrayBuffer.isView(chunk)) {
                throw new TypeError("You can only enqueue array buffer views when using a ReadableByteStreamController");
              }
              ReadableByteStreamControllerEnqueue(this, chunk);
            }
          }, {
            key: "error",
            value: function error(e) {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("error");
              }
              var stream = this._controlledReadableStream;
              if (stream._state !== "readable") {
                throw new TypeError("The stream is " + stream._state + " and so cannot be errored");
              }
              ReadableByteStreamControllerError(this, e);
            }
          }, {
            key: "__cancelSteps",
            value: function __cancelSteps(reason) {
              if (this._pendingPullIntos.length > 0) {
                var firstDescriptor = this._pendingPullIntos[0];
                firstDescriptor.bytesFilled = 0;
              }
              ResetQueue(this);
              return PromiseInvokeOrNoop(this._underlyingByteSource, "cancel", [reason]);
            }
          }, {
            key: "__pullSteps",
            value: function __pullSteps() {
              var stream = this._controlledReadableStream;
              assert(ReadableStreamHasDefaultReader(stream) === true);
              if (this._queueTotalSize > 0) {
                assert(ReadableStreamGetNumReadRequests(stream) === 0);
                var entry = this._queue.shift();
                this._queueTotalSize -= entry.byteLength;
                ReadableByteStreamControllerHandleQueueDrain(this);
                var view = void 0;
                try {
                  view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
                } catch (viewE) {
                  return Promise.reject(viewE);
                }
                return Promise.resolve(CreateIterResultObject(view, false));
              }
              var autoAllocateChunkSize = this._autoAllocateChunkSize;
              if (autoAllocateChunkSize !== undefined) {
                var buffer = void 0;
                try {
                  buffer = new ArrayBuffer(autoAllocateChunkSize);
                } catch (bufferE) {
                  return Promise.reject(bufferE);
                }
                var pullIntoDescriptor = {
                  buffer: buffer,
                  byteOffset: 0,
                  byteLength: autoAllocateChunkSize,
                  bytesFilled: 0,
                  elementSize: 1,
                  ctor: Uint8Array,
                  readerType: "default"
                };
                this._pendingPullIntos.push(pullIntoDescriptor);
              }
              var promise = ReadableStreamAddReadRequest(stream);
              ReadableByteStreamControllerCallPullIfNeeded(this);
              return promise;
            }
          }, {
            key: "byobRequest",
            get: function get() {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("byobRequest");
              }
              if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
                var firstDescriptor = this._pendingPullIntos[0];
                var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
                this._byobRequest = new ReadableStreamBYOBRequest(this, view);
              }
              return this._byobRequest;
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsReadableByteStreamController(this) === false) {
                throw byteStreamControllerBrandCheckException("desiredSize");
              }
              return ReadableByteStreamControllerGetDesiredSize(this);
            }
          }]);
          return ReadableByteStreamController;
        }();
        function IsReadableByteStreamController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_underlyingByteSource")) {
            return false;
          }
          return true;
        }
        function IsReadableStreamBYOBRequest(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_associatedReadableByteStreamController")) {
            return false;
          }
          return true;
        }
        function ReadableByteStreamControllerCallPullIfNeeded(controller) {
          var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
          if (shouldPull === false) {
            return undefined;
          }
          if (controller._pulling === true) {
            controller._pullAgain = true;
            return undefined;
          }
          assert(controller._pullAgain === false);
          controller._pulling = true;
          var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, "pull", [controller]);
          pullPromise.then(function () {
            controller._pulling = false;
            if (controller._pullAgain === true) {
              controller._pullAgain = false;
              ReadableByteStreamControllerCallPullIfNeeded(controller);
            }
          }, function (e) {
            if (controller._controlledReadableStream._state === "readable") {
              ReadableByteStreamControllerError(controller, e);
            }
          }).catch(rethrowAssertionErrorRejection);
          return undefined;
        }
        function ReadableByteStreamControllerClearPendingPullIntos(controller) {
          ReadableByteStreamControllerInvalidateBYOBRequest(controller);
          controller._pendingPullIntos = [];
        }
        function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
          assert(stream._state !== "errored", "state must not be errored");
          var done = false;
          if (stream._state === "closed") {
            assert(pullIntoDescriptor.bytesFilled === 0);
            done = true;
          }
          var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
          if (pullIntoDescriptor.readerType === "default") {
            ReadableStreamFulfillReadRequest(stream, filledView, done);
          } else {
            assert(pullIntoDescriptor.readerType === "byob");
            ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
          }
        }
        function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
          var bytesFilled = pullIntoDescriptor.bytesFilled;
          var elementSize = pullIntoDescriptor.elementSize;
          assert(bytesFilled <= pullIntoDescriptor.byteLength);
          assert(bytesFilled % elementSize === 0);
          return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
        }
        function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
          controller._queue.push({
            buffer: buffer,
            byteOffset: byteOffset,
            byteLength: byteLength
          });
          controller._queueTotalSize += byteLength;
        }
        function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
          var elementSize = pullIntoDescriptor.elementSize;
          var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
          var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
          var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
          var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
          var totalBytesToCopyRemaining = maxBytesToCopy;
          var ready = false;
          if (maxAlignedBytes > currentAlignedBytes) {
            totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
            ready = true;
          }
          var queue = controller._queue;
          while (totalBytesToCopyRemaining > 0) {
            var headOfQueue = queue[0];
            var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
            var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
            ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
            if (headOfQueue.byteLength === bytesToCopy) {
              queue.shift();
            } else {
              headOfQueue.byteOffset += bytesToCopy;
              headOfQueue.byteLength -= bytesToCopy;
            }
            controller._queueTotalSize -= bytesToCopy;
            ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
            totalBytesToCopyRemaining -= bytesToCopy;
          }
          if (ready === false) {
            assert(controller._queueTotalSize === 0, "queue must be empty");
            assert(pullIntoDescriptor.bytesFilled > 0);
            assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
          }
          return ready;
        }
        function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
          assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
          ReadableByteStreamControllerInvalidateBYOBRequest(controller);
          pullIntoDescriptor.bytesFilled += size;
        }
        function ReadableByteStreamControllerHandleQueueDrain(controller) {
          assert(controller._controlledReadableStream._state === "readable");
          if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
            ReadableStreamClose(controller._controlledReadableStream);
          } else {
            ReadableByteStreamControllerCallPullIfNeeded(controller);
          }
        }
        function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
          if (controller._byobRequest === undefined) {
            return;
          }
          controller._byobRequest._associatedReadableByteStreamController = undefined;
          controller._byobRequest._view = undefined;
          controller._byobRequest = undefined;
        }
        function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
          assert(controller._closeRequested === false);
          while (controller._pendingPullIntos.length > 0) {
            if (controller._queueTotalSize === 0) {
              return;
            }
            var pullIntoDescriptor = controller._pendingPullIntos[0];
            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
              ReadableByteStreamControllerShiftPendingPullInto(controller);
              ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
            }
          }
        }
        function ReadableByteStreamControllerPullInto(controller, view) {
          var stream = controller._controlledReadableStream;
          var elementSize = 1;
          if (view.constructor !== DataView) {
            elementSize = view.constructor.BYTES_PER_ELEMENT;
          }
          var ctor = view.constructor;
          var pullIntoDescriptor = {
            buffer: view.buffer,
            byteOffset: view.byteOffset,
            byteLength: view.byteLength,
            bytesFilled: 0,
            elementSize: elementSize,
            ctor: ctor,
            readerType: "byob"
          };
          if (controller._pendingPullIntos.length > 0) {
            pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
            controller._pendingPullIntos.push(pullIntoDescriptor);
            return ReadableStreamAddReadIntoRequest(stream);
          }
          if (stream._state === "closed") {
            var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
            return Promise.resolve(CreateIterResultObject(emptyView, true));
          }
          if (controller._queueTotalSize > 0) {
            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
              var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
              ReadableByteStreamControllerHandleQueueDrain(controller);
              return Promise.resolve(CreateIterResultObject(filledView, false));
            }
            if (controller._closeRequested === true) {
              var e = new TypeError("Insufficient bytes to fill elements in the given buffer");
              ReadableByteStreamControllerError(controller, e);
              return Promise.reject(e);
            }
          }
          pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
          controller._pendingPullIntos.push(pullIntoDescriptor);
          var promise = ReadableStreamAddReadIntoRequest(stream);
          ReadableByteStreamControllerCallPullIfNeeded(controller);
          return promise;
        }
        function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
          firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
          assert(firstDescriptor.bytesFilled === 0, "bytesFilled must be 0");
          var stream = controller._controlledReadableStream;
          if (ReadableStreamHasBYOBReader(stream) === true) {
            while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
              var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
              ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
            }
          }
        }
        function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
          if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
            throw new RangeError("bytesWritten out of range");
          }
          ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
          if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
            return;
          }
          ReadableByteStreamControllerShiftPendingPullInto(controller);
          var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
          if (remainderSize > 0) {
            var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
            var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
          }
          pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
          pullIntoDescriptor.bytesFilled -= remainderSize;
          ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
          ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
        }
        function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
          var firstDescriptor = controller._pendingPullIntos[0];
          var stream = controller._controlledReadableStream;
          if (stream._state === "closed") {
            if (bytesWritten !== 0) {
              throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
            }
            ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
          } else {
            assert(stream._state === "readable");
            ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
          }
        }
        function ReadableByteStreamControllerShiftPendingPullInto(controller) {
          var descriptor = controller._pendingPullIntos.shift();
          ReadableByteStreamControllerInvalidateBYOBRequest(controller);
          return descriptor;
        }
        function ReadableByteStreamControllerShouldCallPull(controller) {
          var stream = controller._controlledReadableStream;
          if (stream._state !== "readable") {
            return false;
          }
          if (controller._closeRequested === true) {
            return false;
          }
          if (controller._started === false) {
            return false;
          }
          if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
            return true;
          }
          if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
            return true;
          }
          if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
            return true;
          }
          return false;
        }
        function ReadableByteStreamControllerClose(controller) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          if (controller._queueTotalSize > 0) {
            controller._closeRequested = true;
            return;
          }
          if (controller._pendingPullIntos.length > 0) {
            var firstPendingPullInto = controller._pendingPullIntos[0];
            if (firstPendingPullInto.bytesFilled > 0) {
              var e = new TypeError("Insufficient bytes to fill elements in the given buffer");
              ReadableByteStreamControllerError(controller, e);
              throw e;
            }
          }
          ReadableStreamClose(stream);
        }
        function ReadableByteStreamControllerEnqueue(controller, chunk) {
          var stream = controller._controlledReadableStream;
          assert(controller._closeRequested === false);
          assert(stream._state === "readable");
          var buffer = chunk.buffer;
          var byteOffset = chunk.byteOffset;
          var byteLength = chunk.byteLength;
          var transferredBuffer = TransferArrayBuffer(buffer);
          if (ReadableStreamHasDefaultReader(stream) === true) {
            if (ReadableStreamGetNumReadRequests(stream) === 0) {
              ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
            } else {
              assert(controller._queue.length === 0);
              var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
              ReadableStreamFulfillReadRequest(stream, transferredView, false);
            }
          } else if (ReadableStreamHasBYOBReader(stream) === true) {
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
            ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
          } else {
            assert(IsReadableStreamLocked(stream) === false, "stream must not be locked");
            ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
          }
        }
        function ReadableByteStreamControllerError(controller, e) {
          var stream = controller._controlledReadableStream;
          assert(stream._state === "readable");
          ReadableByteStreamControllerClearPendingPullIntos(controller);
          ResetQueue(controller);
          ReadableStreamError(stream, e);
        }
        function ReadableByteStreamControllerGetDesiredSize(controller) {
          var stream = controller._controlledReadableStream;
          var state = stream._state;
          if (state === "errored") {
            return null;
          }
          if (state === "closed") {
            return 0;
          }
          return controller._strategyHWM - controller._queueTotalSize;
        }
        function ReadableByteStreamControllerRespond(controller, bytesWritten) {
          bytesWritten = Number(bytesWritten);
          if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
            throw new RangeError("bytesWritten must be a finite");
          }
          assert(controller._pendingPullIntos.length > 0);
          ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
        }
        function ReadableByteStreamControllerRespondWithNewView(controller, view) {
          assert(controller._pendingPullIntos.length > 0);
          var firstDescriptor = controller._pendingPullIntos[0];
          if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
            throw new RangeError("The region specified by view does not match byobRequest");
          }
          if (firstDescriptor.byteLength !== view.byteLength) {
            throw new RangeError("The buffer of view has different capacity than byobRequest");
          }
          firstDescriptor.buffer = view.buffer;
          ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
        }
        function streamBrandCheckException(name) {
          return new TypeError("ReadableStream.prototype." + name + " can only be used on a ReadableStream");
        }
        function readerLockException(name) {
          return new TypeError("Cannot " + name + " a stream using a released reader");
        }
        function defaultReaderBrandCheckException(name) {
          return new TypeError("ReadableStreamDefaultReader.prototype." + name + " can only be used on a ReadableStreamDefaultReader");
        }
        function defaultReaderClosedPromiseInitialize(reader) {
          reader._closedPromise = new Promise(function (resolve, reject) {
            reader._closedPromise_resolve = resolve;
            reader._closedPromise_reject = reject;
          });
        }
        function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
          reader._closedPromise = Promise.reject(reason);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function defaultReaderClosedPromiseInitializeAsResolved(reader) {
          reader._closedPromise = Promise.resolve(undefined);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function defaultReaderClosedPromiseReject(reader, reason) {
          assert(reader._closedPromise_resolve !== undefined);
          assert(reader._closedPromise_reject !== undefined);
          reader._closedPromise_reject(reason);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function defaultReaderClosedPromiseResetToRejected(reader, reason) {
          assert(reader._closedPromise_resolve === undefined);
          assert(reader._closedPromise_reject === undefined);
          reader._closedPromise = Promise.reject(reason);
        }
        function defaultReaderClosedPromiseResolve(reader) {
          assert(reader._closedPromise_resolve !== undefined);
          assert(reader._closedPromise_reject !== undefined);
          reader._closedPromise_resolve(undefined);
          reader._closedPromise_resolve = undefined;
          reader._closedPromise_reject = undefined;
        }
        function byobReaderBrandCheckException(name) {
          return new TypeError("ReadableStreamBYOBReader.prototype." + name + " can only be used on a ReadableStreamBYOBReader");
        }
        function defaultControllerBrandCheckException(name) {
          return new TypeError("ReadableStreamDefaultController.prototype." + name + " can only be used on a ReadableStreamDefaultController");
        }
        function byobRequestBrandCheckException(name) {
          return new TypeError("ReadableStreamBYOBRequest.prototype." + name + " can only be used on a ReadableStreamBYOBRequest");
        }
        function byteStreamControllerBrandCheckException(name) {
          return new TypeError("ReadableByteStreamController.prototype." + name + " can only be used on a ReadableByteStreamController");
        }
        function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
          try {
            Promise.prototype.then.call(promise, undefined, function () {});
          } catch (e) {}
        }
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var transformStream = __w_pdfjs_require__(6);
        var readableStream = __w_pdfjs_require__(4);
        var writableStream = __w_pdfjs_require__(2);
        exports.TransformStream = transformStream.TransformStream;
        exports.ReadableStream = readableStream.ReadableStream;
        exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
        exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
        exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
        exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
        exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
        exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
        exports.IsWritableStream = writableStream.IsWritableStream;
        exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
        exports.WritableStream = writableStream.WritableStream;
        exports.WritableStreamAbort = writableStream.WritableStreamAbort;
        exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
        exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
        exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
        exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
      }, function (module, exports, __w_pdfjs_require__) {
        "use strict";

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        var _require = __w_pdfjs_require__(1),
          assert = _require.assert;
        var _require2 = __w_pdfjs_require__(0),
          InvokeOrNoop = _require2.InvokeOrNoop,
          PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
          PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
          typeIsObject = _require2.typeIsObject;
        var _require3 = __w_pdfjs_require__(4),
          ReadableStream = _require3.ReadableStream,
          ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
          ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
          ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
          ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
        var _require4 = __w_pdfjs_require__(2),
          WritableStream = _require4.WritableStream,
          WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
        function TransformStreamCloseReadable(transformStream) {
          if (transformStream._errored === true) {
            throw new TypeError("TransformStream is already errored");
          }
          if (transformStream._readableClosed === true) {
            throw new TypeError("Readable side is already closed");
          }
          TransformStreamCloseReadableInternal(transformStream);
        }
        function TransformStreamEnqueueToReadable(transformStream, chunk) {
          if (transformStream._errored === true) {
            throw new TypeError("TransformStream is already errored");
          }
          if (transformStream._readableClosed === true) {
            throw new TypeError("Readable side is already closed");
          }
          var controller = transformStream._readableController;
          try {
            ReadableStreamDefaultControllerEnqueue(controller, chunk);
          } catch (e) {
            transformStream._readableClosed = true;
            TransformStreamErrorIfNeeded(transformStream, e);
            throw transformStream._storedError;
          }
          var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
          var maybeBackpressure = desiredSize <= 0;
          if (maybeBackpressure === true && transformStream._backpressure === false) {
            TransformStreamSetBackpressure(transformStream, true);
          }
        }
        function TransformStreamError(transformStream, e) {
          if (transformStream._errored === true) {
            throw new TypeError("TransformStream is already errored");
          }
          TransformStreamErrorInternal(transformStream, e);
        }
        function TransformStreamCloseReadableInternal(transformStream) {
          assert(transformStream._errored === false);
          assert(transformStream._readableClosed === false);
          try {
            ReadableStreamDefaultControllerClose(transformStream._readableController);
          } catch (e) {
            assert(false);
          }
          transformStream._readableClosed = true;
        }
        function TransformStreamErrorIfNeeded(transformStream, e) {
          if (transformStream._errored === false) {
            TransformStreamErrorInternal(transformStream, e);
          }
        }
        function TransformStreamErrorInternal(transformStream, e) {
          assert(transformStream._errored === false);
          transformStream._errored = true;
          transformStream._storedError = e;
          if (transformStream._writableDone === false) {
            WritableStreamDefaultControllerError(transformStream._writableController, e);
          }
          if (transformStream._readableClosed === false) {
            ReadableStreamDefaultControllerError(transformStream._readableController, e);
          }
        }
        function TransformStreamReadableReadyPromise(transformStream) {
          assert(transformStream._backpressureChangePromise !== undefined, "_backpressureChangePromise should have been initialized");
          if (transformStream._backpressure === false) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === true, "_backpressure should have been initialized");
          return transformStream._backpressureChangePromise;
        }
        function TransformStreamSetBackpressure(transformStream, backpressure) {
          assert(transformStream._backpressure !== backpressure, "TransformStreamSetBackpressure() should be called only when backpressure is changed");
          if (transformStream._backpressureChangePromise !== undefined) {
            transformStream._backpressureChangePromise_resolve(backpressure);
          }
          transformStream._backpressureChangePromise = new Promise(function (resolve) {
            transformStream._backpressureChangePromise_resolve = resolve;
          });
          transformStream._backpressureChangePromise.then(function (resolution) {
            assert(resolution !== backpressure, "_backpressureChangePromise should be fulfilled only when backpressure is changed");
          });
          transformStream._backpressure = backpressure;
        }
        function TransformStreamDefaultTransform(chunk, transformStreamController) {
          var transformStream = transformStreamController._controlledTransformStream;
          TransformStreamEnqueueToReadable(transformStream, chunk);
          return Promise.resolve();
        }
        function TransformStreamTransform(transformStream, chunk) {
          assert(transformStream._errored === false);
          assert(transformStream._transforming === false);
          assert(transformStream._backpressure === false);
          transformStream._transforming = true;
          var transformer = transformStream._transformer;
          var controller = transformStream._transformStreamController;
          var transformPromise = PromiseInvokeOrPerformFallback(transformer, "transform", [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
          return transformPromise.then(function () {
            transformStream._transforming = false;
            return TransformStreamReadableReadyPromise(transformStream);
          }, function (e) {
            TransformStreamErrorIfNeeded(transformStream, e);
            return Promise.reject(e);
          });
        }
        function IsTransformStreamDefaultController(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_controlledTransformStream")) {
            return false;
          }
          return true;
        }
        function IsTransformStream(x) {
          if (!typeIsObject(x)) {
            return false;
          }
          if (!Object.prototype.hasOwnProperty.call(x, "_transformStreamController")) {
            return false;
          }
          return true;
        }
        var TransformStreamSink = function () {
          function TransformStreamSink(transformStream, startPromise) {
            _classCallCheck(this, TransformStreamSink);
            this._transformStream = transformStream;
            this._startPromise = startPromise;
          }
          _createClass(TransformStreamSink, [{
            key: "start",
            value: function start(c) {
              var transformStream = this._transformStream;
              transformStream._writableController = c;
              return this._startPromise.then(function () {
                return TransformStreamReadableReadyPromise(transformStream);
              });
            }
          }, {
            key: "write",
            value: function write(chunk) {
              var transformStream = this._transformStream;
              return TransformStreamTransform(transformStream, chunk);
            }
          }, {
            key: "abort",
            value: function abort() {
              var transformStream = this._transformStream;
              transformStream._writableDone = true;
              TransformStreamErrorInternal(transformStream, new TypeError("Writable side aborted"));
            }
          }, {
            key: "close",
            value: function close() {
              var transformStream = this._transformStream;
              assert(transformStream._transforming === false);
              transformStream._writableDone = true;
              var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, "flush", [transformStream._transformStreamController]);
              return flushPromise.then(function () {
                if (transformStream._errored === true) {
                  return Promise.reject(transformStream._storedError);
                }
                if (transformStream._readableClosed === false) {
                  TransformStreamCloseReadableInternal(transformStream);
                }
                return Promise.resolve();
              }).catch(function (r) {
                TransformStreamErrorIfNeeded(transformStream, r);
                return Promise.reject(transformStream._storedError);
              });
            }
          }]);
          return TransformStreamSink;
        }();
        var TransformStreamSource = function () {
          function TransformStreamSource(transformStream, startPromise) {
            _classCallCheck(this, TransformStreamSource);
            this._transformStream = transformStream;
            this._startPromise = startPromise;
          }
          _createClass(TransformStreamSource, [{
            key: "start",
            value: function start(c) {
              var transformStream = this._transformStream;
              transformStream._readableController = c;
              return this._startPromise.then(function () {
                assert(transformStream._backpressureChangePromise !== undefined, "_backpressureChangePromise should have been initialized");
                if (transformStream._backpressure === true) {
                  return Promise.resolve();
                }
                assert(transformStream._backpressure === false, "_backpressure should have been initialized");
                return transformStream._backpressureChangePromise;
              });
            }
          }, {
            key: "pull",
            value: function pull() {
              var transformStream = this._transformStream;
              assert(transformStream._backpressure === true, "pull() should be never called while _backpressure is false");
              assert(transformStream._backpressureChangePromise !== undefined, "_backpressureChangePromise should have been initialized");
              TransformStreamSetBackpressure(transformStream, false);
              return transformStream._backpressureChangePromise;
            }
          }, {
            key: "cancel",
            value: function cancel() {
              var transformStream = this._transformStream;
              transformStream._readableClosed = true;
              TransformStreamErrorInternal(transformStream, new TypeError("Readable side canceled"));
            }
          }]);
          return TransformStreamSource;
        }();
        var TransformStreamDefaultController = function () {
          function TransformStreamDefaultController(transformStream) {
            _classCallCheck(this, TransformStreamDefaultController);
            if (IsTransformStream(transformStream) === false) {
              throw new TypeError("TransformStreamDefaultController can only be " + "constructed with a TransformStream instance");
            }
            if (transformStream._transformStreamController !== undefined) {
              throw new TypeError("TransformStreamDefaultController instances can " + "only be created by the TransformStream constructor");
            }
            this._controlledTransformStream = transformStream;
          }
          _createClass(TransformStreamDefaultController, [{
            key: "enqueue",
            value: function enqueue(chunk) {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("enqueue");
              }
              TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
            }
          }, {
            key: "close",
            value: function close() {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("close");
              }
              TransformStreamCloseReadable(this._controlledTransformStream);
            }
          }, {
            key: "error",
            value: function error(reason) {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("error");
              }
              TransformStreamError(this._controlledTransformStream, reason);
            }
          }, {
            key: "desiredSize",
            get: function get() {
              if (IsTransformStreamDefaultController(this) === false) {
                throw defaultControllerBrandCheckException("desiredSize");
              }
              var transformStream = this._controlledTransformStream;
              var readableController = transformStream._readableController;
              return ReadableStreamDefaultControllerGetDesiredSize(readableController);
            }
          }]);
          return TransformStreamDefaultController;
        }();
        var TransformStream = function () {
          function TransformStream() {
            var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _classCallCheck(this, TransformStream);
            this._transformer = transformer;
            var readableStrategy = transformer.readableStrategy,
              writableStrategy = transformer.writableStrategy;
            this._transforming = false;
            this._errored = false;
            this._storedError = undefined;
            this._writableController = undefined;
            this._readableController = undefined;
            this._transformStreamController = undefined;
            this._writableDone = false;
            this._readableClosed = false;
            this._backpressure = undefined;
            this._backpressureChangePromise = undefined;
            this._backpressureChangePromise_resolve = undefined;
            this._transformStreamController = new TransformStreamDefaultController(this);
            var startPromise_resolve = void 0;
            var startPromise = new Promise(function (resolve) {
              startPromise_resolve = resolve;
            });
            var source = new TransformStreamSource(this, startPromise);
            this._readable = new ReadableStream(source, readableStrategy);
            var sink = new TransformStreamSink(this, startPromise);
            this._writable = new WritableStream(sink, writableStrategy);
            assert(this._writableController !== undefined);
            assert(this._readableController !== undefined);
            var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
            TransformStreamSetBackpressure(this, desiredSize <= 0);
            var transformStream = this;
            var startResult = InvokeOrNoop(transformer, "start", [transformStream._transformStreamController]);
            startPromise_resolve(startResult);
            startPromise.catch(function (e) {
              if (transformStream._errored === false) {
                transformStream._errored = true;
                transformStream._storedError = e;
              }
            });
          }
          _createClass(TransformStream, [{
            key: "readable",
            get: function get() {
              if (IsTransformStream(this) === false) {
                throw streamBrandCheckException("readable");
              }
              return this._readable;
            }
          }, {
            key: "writable",
            get: function get() {
              if (IsTransformStream(this) === false) {
                throw streamBrandCheckException("writable");
              }
              return this._writable;
            }
          }]);
          return TransformStream;
        }();
        module.exports = { TransformStream: TransformStream };
        function defaultControllerBrandCheckException(name) {
          return new TypeError("TransformStreamDefaultController.prototype." + name + " can only be used on a TransformStreamDefaultController");
        }
        function streamBrandCheckException(name) {
          return new TypeError("TransformStream.prototype." + name + " can only be used on a TransformStream");
        }
      }, function (module, exports, __w_pdfjs_require__) {
        module.exports = __w_pdfjs_require__(5);
      }]));

      /***/ }),
    /* 126 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.NetworkPdfManager = exports.LocalPdfManager = undefined;

      var _util = __w_pdfjs_require__(0);

      var _chunked_stream = __w_pdfjs_require__(72);

      var _document = __w_pdfjs_require__(127);

      var _stream = __w_pdfjs_require__(5);

      var BasePdfManager = function BasePdfManagerClosure() {
        function BasePdfManager() {
          throw new Error("Cannot initialize BaseManagerManager");
        }
        BasePdfManager.prototype = {
          get docId() {
            return this._docId;
          },
          get password() {
            return this._password;
          },
          get docBaseUrl() {
            var docBaseUrl = null;
            if (this._docBaseUrl) {
              var absoluteUrl = (0, _util.createValidAbsoluteUrl)(this._docBaseUrl);
              if (absoluteUrl) {
                docBaseUrl = absoluteUrl.href;
              } else {
                (0, _util.warn)("Invalid absolute docBaseUrl: \"" + this._docBaseUrl + "\".");
              }
            }
            return (0, _util.shadow)(this, "docBaseUrl", docBaseUrl);
          },
          onLoadedStream: function BasePdfManager_onLoadedStream() {
            throw new _util.NotImplementedException();
          },
          ensureDoc: function BasePdfManager_ensureDoc(prop, args) {
            return this.ensure(this.pdfDocument, prop, args);
          },
          ensureXRef: function BasePdfManager_ensureXRef(prop, args) {
            return this.ensure(this.pdfDocument.xref, prop, args);
          },
          ensureCatalog: function BasePdfManager_ensureCatalog(prop, args) {
            return this.ensure(this.pdfDocument.catalog, prop, args);
          },
          getPage: function BasePdfManager_getPage(pageIndex) {
            return this.pdfDocument.getPage(pageIndex);
          },
          cleanup: function BasePdfManager_cleanup() {
            return this.pdfDocument.cleanup();
          },
          ensure: function BasePdfManager_ensure(obj, prop, args) {
            return new _util.NotImplementedException();
          },
          requestRange: function BasePdfManager_requestRange(begin, end) {
            return new _util.NotImplementedException();
          },
          requestLoadedStream: function BasePdfManager_requestLoadedStream() {
            return new _util.NotImplementedException();
          },
          sendProgressiveData: function BasePdfManager_sendProgressiveData(chunk) {
            return new _util.NotImplementedException();
          },
          updatePassword: function BasePdfManager_updatePassword(password) {
            this._password = password;
          },
          terminate: function BasePdfManager_terminate() {
            return new _util.NotImplementedException();
          }
        };
        return BasePdfManager;
      }();
      var LocalPdfManager = function LocalPdfManagerClosure() {
        function LocalPdfManager(docId, data, password, evaluatorOptions, docBaseUrl) {
          this._docId = docId;
          this._password = password;
          this._docBaseUrl = docBaseUrl;
          this.evaluatorOptions = evaluatorOptions;
          var stream = new _stream.Stream(data);
          this.pdfDocument = new _document.PDFDocument(this, stream);
          this._loadedStreamCapability = (0, _util.createPromiseCapability)();
          this._loadedStreamCapability.resolve(stream);
        }
        _util.Util.inherit(LocalPdfManager, BasePdfManager, {
          ensure: function LocalPdfManager_ensure(obj, prop, args) {
            return new Promise(function (resolve, reject) {
              try {
                var value = obj[prop];
                var result;
                if (typeof value === "function") {
                  result = value.apply(obj, args);
                } else {
                  result = value;
                }
                resolve(result);
              } catch (e) {
                reject(e);
              }
            });
          },
          requestRange: function LocalPdfManager_requestRange(begin, end) {
            return Promise.resolve();
          },
          requestLoadedStream: function LocalPdfManager_requestLoadedStream() {},
          onLoadedStream: function LocalPdfManager_onLoadedStream() {
            return this._loadedStreamCapability.promise;
          },
          terminate: function LocalPdfManager_terminate() {}
        });
        return LocalPdfManager;
      }();
      var NetworkPdfManager = function NetworkPdfManagerClosure() {
        function NetworkPdfManager(docId, pdfNetworkStream, args, evaluatorOptions, docBaseUrl) {
          this._docId = docId;
          this._password = args.password;
          this._docBaseUrl = docBaseUrl;
          this.msgHandler = args.msgHandler;
          this.evaluatorOptions = evaluatorOptions;
          var params = {
            msgHandler: args.msgHandler,
            url: args.url,
            length: args.length,
            disableAutoFetch: args.disableAutoFetch,
            rangeChunkSize: args.rangeChunkSize
          };
          this.streamManager = new _chunked_stream.ChunkedStreamManager(pdfNetworkStream, params);
          this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
        }
        _util.Util.inherit(NetworkPdfManager, BasePdfManager, {
          ensure: function NetworkPdfManager_ensure(obj, prop, args) {
            var pdfManager = this;
            return new Promise(function (resolve, reject) {
              function ensureHelper() {
                try {
                  var result;
                  var value = obj[prop];
                  if (typeof value === "function") {
                    result = value.apply(obj, args);
                  } else {
                    result = value;
                  }
                  resolve(result);
                } catch (e) {
                  if (!(e instanceof _util.MissingDataException)) {
                    reject(e);
                    return;
                  }
                  pdfManager.streamManager.requestRange(e.begin, e.end).then(ensureHelper, reject);
                }
              }
              ensureHelper();
            });
          },
          requestRange: function NetworkPdfManager_requestRange(begin, end) {
            return this.streamManager.requestRange(begin, end);
          },
          requestLoadedStream: function NetworkPdfManager_requestLoadedStream() {
            this.streamManager.requestAllChunks();
          },
          sendProgressiveData: function NetworkPdfManager_sendProgressiveData(chunk) {
            this.streamManager.onReceiveData({ chunk: chunk });
          },
          onLoadedStream: function NetworkPdfManager_onLoadedStream() {
            return this.streamManager.onLoadedStream();
          },
          terminate: function NetworkPdfManager_terminate() {
            this.streamManager.abort();
          }
        });
        return NetworkPdfManager;
      }();
      exports.LocalPdfManager = LocalPdfManager;
      exports.NetworkPdfManager = NetworkPdfManager;

      /***/ }),
    /* 127 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFDocument = exports.Page = undefined;

      var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

      var _obj = __w_pdfjs_require__(73);

      var _primitives = __w_pdfjs_require__(2);

      var _util = __w_pdfjs_require__(0);

      var _stream = __w_pdfjs_require__(5);

      var _evaluator = __w_pdfjs_require__(77);

      var _annotation = __w_pdfjs_require__(144);

      var _crypto = __w_pdfjs_require__(76);

      var _parser = __w_pdfjs_require__(34);

      var _function = __w_pdfjs_require__(81);

      var Page = function PageClosure() {
        var DEFAULT_USER_UNIT = 1.0;
        var LETTER_SIZE_MEDIABOX = [0, 0, 612, 792];
        function isAnnotationRenderable(annotation, intent) {
          return intent === "display" && annotation.viewable || intent === "print" && annotation.printable;
        }
        function Page(_ref) {
          var pdfManager = _ref.pdfManager,
            xref = _ref.xref,
            pageIndex = _ref.pageIndex,
            pageDict = _ref.pageDict,
            ref = _ref.ref,
            fontCache = _ref.fontCache,
            builtInCMapCache = _ref.builtInCMapCache,
            pdfFunctionFactory = _ref.pdfFunctionFactory;

          this.pdfManager = pdfManager;
          this.pageIndex = pageIndex;
          this.pageDict = pageDict;
          this.xref = xref;
          this.ref = ref;
          this.fontCache = fontCache;
          this.builtInCMapCache = builtInCMapCache;
          this.pdfFunctionFactory = pdfFunctionFactory;
          this.evaluatorOptions = pdfManager.evaluatorOptions;
          this.resourcesPromise = null;
          var uniquePrefix = "p" + this.pageIndex + "_";
          var idCounters = { obj: 0 };
          this.idFactory = {
            createObjId: function createObjId() {
              return uniquePrefix + ++idCounters.obj;
            }
          };
        }
        Page.prototype = {
          getPageProp: function Page_getPageProp(key) {
            return this.pageDict.get(key);
          },
          getInheritedPageProp: function Page_getInheritedPageProp(key, getArray) {
            var dict = this.pageDict,
              valueArray = null,
              loopCount = 0;
            var MAX_LOOP_COUNT = 100;
            getArray = getArray || false;
            while (dict) {
              var value = getArray ? dict.getArray(key) : dict.get(key);
              if (value !== undefined) {
                if (!valueArray) {
                  valueArray = [];
                }
                valueArray.push(value);
              }
              if (++loopCount > MAX_LOOP_COUNT) {
                (0, _util.warn)("getInheritedPageProp: maximum loop count exceeded for " + key);
                return valueArray ? valueArray[0] : undefined;
              }
              dict = dict.get("Parent");
            }
            if (!valueArray) {
              return undefined;
            }
            if (valueArray.length === 1 || !(0, _primitives.isDict)(valueArray[0])) {
              return valueArray[0];
            }
            return _primitives.Dict.merge(this.xref, valueArray);
          },
          get content() {
            return this.getPageProp("Contents");
          },
          get resources() {
            return (0, _util.shadow)(this, "resources", this.getInheritedPageProp("Resources") || _primitives.Dict.empty);
          },
          get mediaBox() {
            var mediaBox = this.getInheritedPageProp("MediaBox", true);
            if (!Array.isArray(mediaBox) || mediaBox.length !== 4) {
              return (0, _util.shadow)(this, "mediaBox", LETTER_SIZE_MEDIABOX);
            }
            return (0, _util.shadow)(this, "mediaBox", mediaBox);
          },
          get cropBox() {
            var cropBox = this.getInheritedPageProp("CropBox", true);
            if (!Array.isArray(cropBox) || cropBox.length !== 4) {
              return (0, _util.shadow)(this, "cropBox", this.mediaBox);
            }
            return (0, _util.shadow)(this, "cropBox", cropBox);
          },
          get userUnit() {
            var obj = this.getPageProp("UserUnit");
            if (!(0, _util.isNum)(obj) || obj <= 0) {
              obj = DEFAULT_USER_UNIT;
            }
            return (0, _util.shadow)(this, "userUnit", obj);
          },
          get view() {
            var mediaBox = this.mediaBox,
              cropBox = this.cropBox;
            if (mediaBox === cropBox) {
              return (0, _util.shadow)(this, "view", mediaBox);
            }
            var intersection = _util.Util.intersect(cropBox, mediaBox);
            return (0, _util.shadow)(this, "view", intersection || mediaBox);
          },
          get rotate() {
            var rotate = this.getInheritedPageProp("Rotate") || 0;
            if (rotate % 90 !== 0) {
              rotate = 0;
            } else if (rotate >= 360) {
              rotate = rotate % 360;
            } else if (rotate < 0) {
              rotate = (rotate % 360 + 360) % 360;
            }
            return (0, _util.shadow)(this, "rotate", rotate);
          },
          getContentStream: function Page_getContentStream() {
            var content = this.content;
            var stream;
            if (Array.isArray(content)) {
              var xref = this.xref;
              var i,
                n = content.length;
              var streams = [];
              for (i = 0; i < n; ++i) {
                streams.push(xref.fetchIfRef(content[i]));
              }
              stream = new _stream.StreamsSequenceStream(streams);
            } else if ((0, _primitives.isStream)(content)) {
              stream = content;
            } else {
              stream = new _stream.NullStream();
            }
            return stream;
          },
          loadResources: function Page_loadResources(keys) {
            var _this = this;

            if (!this.resourcesPromise) {
              this.resourcesPromise = this.pdfManager.ensure(this, "resources");
            }
            return this.resourcesPromise.then(function () {
              var objectLoader = new _obj.ObjectLoader(_this.resources, keys, _this.xref);
              return objectLoader.load();
            });
          },
          getOperatorList: function getOperatorList(_ref2) {
            var _this2 = this;

            var handler = _ref2.handler,
              task = _ref2.task,
              intent = _ref2.intent,
              renderInteractiveForms = _ref2.renderInteractiveForms;

            var contentStreamPromise = this.pdfManager.ensure(this, "getContentStream");
            var resourcesPromise = this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"]);
            var partialEvaluator = new _evaluator.PartialEvaluator({
              pdfManager: this.pdfManager,
              xref: this.xref,
              handler: handler,
              pageIndex: this.pageIndex,
              idFactory: this.idFactory,
              fontCache: this.fontCache,
              builtInCMapCache: this.builtInCMapCache,
              options: this.evaluatorOptions,
              pdfFunctionFactory: this.pdfFunctionFactory
            });
            var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
            var pageListPromise = dataPromises.then(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 1),
                contentStream = _ref4[0];

              var opList = new _evaluator.OperatorList(intent, handler, _this2.pageIndex);
              handler.send("StartRenderPage", {
                transparency: partialEvaluator.hasBlendModes(_this2.resources),
                pageIndex: _this2.pageIndex,
                intent: intent
              });
              return partialEvaluator.getOperatorList({
                stream: contentStream,
                task: task,
                resources: _this2.resources,
                operatorList: opList
              }).then(function () {
                return opList;
              });
            });
            var annotationsPromise = this.pdfManager.ensure(this, "annotations");
            return Promise.all([pageListPromise, annotationsPromise]).then(function (_ref5) {
              var _ref6 = _slicedToArray(_ref5, 2),
                pageOpList = _ref6[0],
                annotations = _ref6[1];

              if (annotations.length === 0) {
                pageOpList.flush(true);
                return pageOpList;
              }
              var i,
                ii,
                opListPromises = [];
              for (i = 0, ii = annotations.length; i < ii; i++) {
                if (isAnnotationRenderable(annotations[i], intent)) {
                  opListPromises.push(annotations[i].getOperatorList(partialEvaluator, task, renderInteractiveForms));
                }
              }
              return Promise.all(opListPromises).then(function (opLists) {
                pageOpList.addOp(_util.OPS.beginAnnotations, []);
                for (i = 0, ii = opLists.length; i < ii; i++) {
                  pageOpList.addOpList(opLists[i]);
                }
                pageOpList.addOp(_util.OPS.endAnnotations, []);
                pageOpList.flush(true);
                return pageOpList;
              });
            });
          },
          extractTextContent: function extractTextContent(_ref7) {
            var _this3 = this;

            var handler = _ref7.handler,
              task = _ref7.task,
              normalizeWhitespace = _ref7.normalizeWhitespace,
              sink = _ref7.sink,
              combineTextItems = _ref7.combineTextItems;

            var contentStreamPromise = this.pdfManager.ensure(this, "getContentStream");
            var resourcesPromise = this.loadResources(["ExtGState", "XObject", "Font"]);
            var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
            return dataPromises.then(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 1),
                contentStream = _ref9[0];

              var partialEvaluator = new _evaluator.PartialEvaluator({
                pdfManager: _this3.pdfManager,
                xref: _this3.xref,
                handler: handler,
                pageIndex: _this3.pageIndex,
                idFactory: _this3.idFactory,
                fontCache: _this3.fontCache,
                builtInCMapCache: _this3.builtInCMapCache,
                options: _this3.evaluatorOptions,
                pdfFunctionFactory: _this3.pdfFunctionFactory
              });
              return partialEvaluator.getTextContent({
                stream: contentStream,
                task: task,
                resources: _this3.resources,
                normalizeWhitespace: normalizeWhitespace,
                combineTextItems: combineTextItems,
                sink: sink
              });
            });
          },

          getAnnotationsData: function Page_getAnnotationsData(intent) {
            var annotations = this.annotations;
            var annotationsData = [];
            for (var i = 0, n = annotations.length; i < n; ++i) {
              if (!intent || isAnnotationRenderable(annotations[i], intent)) {
                annotationsData.push(annotations[i].data);
              }
            }
            return annotationsData;
          },
          get annotations() {
            var annotations = [];
            var annotationRefs = this.getInheritedPageProp("Annots") || [];
            for (var i = 0, n = annotationRefs.length; i < n; ++i) {
              var annotationRef = annotationRefs[i];
              var annotation = _annotation.AnnotationFactory.create(this.xref, annotationRef, this.pdfManager, this.idFactory);
              if (annotation) {
                annotations.push(annotation);
              }
            }
            return (0, _util.shadow)(this, "annotations", annotations);
          }
        };
        return Page;
      }();
      var PDFDocument = function PDFDocumentClosure() {
        var FINGERPRINT_FIRST_BYTES = 1024;
        var EMPTY_FINGERPRINT = "\x00\x00\x00\x00\x00\x00\x00" + "\x00\x00\x00\x00\x00\x00\x00\x00\x00";
        function PDFDocument(pdfManager, arg) {
          var stream;
          if ((0, _primitives.isStream)(arg)) {
            stream = arg;
          } else if ((0, _util.isArrayBuffer)(arg)) {
            stream = new _stream.Stream(arg);
          } else {
            throw new Error("PDFDocument: Unknown argument type");
          }
          if (stream.length <= 0) {
            throw new Error("PDFDocument: stream must have data");
          }
          this.pdfManager = pdfManager;
          this.stream = stream;
          this.xref = new _obj.XRef(stream, pdfManager);
          var evaluatorOptions = pdfManager.evaluatorOptions;
          this.pdfFunctionFactory = new _function.PDFFunctionFactory({
            xref: this.xref,
            isEvalSupported: evaluatorOptions.isEvalSupported
          });
        }
        function find(stream, needle, limit, backwards) {
          var pos = stream.pos;
          var end = stream.end;
          var strBuf = [];
          if (pos + limit > end) {
            limit = end - pos;
          }
          for (var n = 0; n < limit; ++n) {
            strBuf.push(String.fromCharCode(stream.getByte()));
          }
          var str = strBuf.join("");
          stream.pos = pos;
          var index = backwards ? str.lastIndexOf(needle) : str.indexOf(needle);
          if (index === -1) {
            return false;
          }
          stream.pos += index;
          return true;
        }
        var DocumentInfoValidators = {
          get entries() {
            return (0, _util.shadow)(this, "entries", {
              Title: _util.isString,
              Author: _util.isString,
              Subject: _util.isString,
              Keywords: _util.isString,
              Creator: _util.isString,
              Producer: _util.isString,
              CreationDate: _util.isString,
              ModDate: _util.isString,
              Trapped: _primitives.isName
            });
          }
        };
        PDFDocument.prototype = {
          parse: function PDFDocument_parse(recoveryMode) {
            this.setup(recoveryMode);
            var version = this.catalog.catDict.get("Version");
            if ((0, _primitives.isName)(version)) {
              this.pdfFormatVersion = version.name;
            }
            try {
              this.acroForm = this.catalog.catDict.get("AcroForm");
              if (this.acroForm) {
                this.xfa = this.acroForm.get("XFA");
                var fields = this.acroForm.get("Fields");
                if ((!fields || !Array.isArray(fields) || fields.length === 0) && !this.xfa) {
                  this.acroForm = null;
                }
              }
            } catch (ex) {
              if (ex instanceof _util.MissingDataException) {
                throw ex;
              }
              (0, _util.info)("Something wrong with AcroForm entry");
              this.acroForm = null;
            }
          },
          get linearization() {
            var linearization = null;
            if (this.stream.length) {
              try {
                linearization = _parser.Linearization.create(this.stream);
              } catch (err) {
                if (err instanceof _util.MissingDataException) {
                  throw err;
                }
                (0, _util.info)(err);
              }
            }
            return (0, _util.shadow)(this, "linearization", linearization);
          },
          get startXRef() {
            var stream = this.stream;
            var startXRef = 0;
            var linearization = this.linearization;
            if (linearization) {
              stream.reset();
              if (find(stream, "endobj", 1024)) {
                startXRef = stream.pos + 6;
              }
            } else {
              var step = 1024;
              var found = false,
                pos = stream.end;
              while (!found && pos > 0) {
                pos -= step - "startxref".length;
                if (pos < 0) {
                  pos = 0;
                }
                stream.pos = pos;
                found = find(stream, "startxref", step, true);
              }
              if (found) {
                stream.skip(9);
                var ch;
                do {
                  ch = stream.getByte();
                } while ((0, _util.isSpace)(ch));
                var str = "";
                while (ch >= 0x20 && ch <= 0x39) {
                  str += String.fromCharCode(ch);
                  ch = stream.getByte();
                }
                startXRef = parseInt(str, 10);
                if (isNaN(startXRef)) {
                  startXRef = 0;
                }
              }
            }
            return (0, _util.shadow)(this, "startXRef", startXRef);
          },
          get mainXRefEntriesOffset() {
            var mainXRefEntriesOffset = 0;
            var linearization = this.linearization;
            if (linearization) {
              mainXRefEntriesOffset = linearization.mainXRefEntriesOffset;
            }
            return (0, _util.shadow)(this, "mainXRefEntriesOffset", mainXRefEntriesOffset);
          },
          checkHeader: function PDFDocument_checkHeader() {
            var stream = this.stream;
            stream.reset();
            if (find(stream, "%PDF-", 1024)) {
              stream.moveStart();
              var MAX_VERSION_LENGTH = 12;
              var version = "",
                ch;
              while ((ch = stream.getByte()) > 0x20) {
                if (version.length >= MAX_VERSION_LENGTH) {
                  break;
                }
                version += String.fromCharCode(ch);
              }
              if (!this.pdfFormatVersion) {
                this.pdfFormatVersion = version.substring(5);
              }
              return;
            }
          },
          parseStartXRef: function PDFDocument_parseStartXRef() {
            var startXRef = this.startXRef;
            this.xref.setStartXRef(startXRef);
          },
          setup: function PDFDocument_setup(recoveryMode) {
            var _this4 = this;

            this.xref.parse(recoveryMode);
            var pageFactory = {
              createPage: function createPage(pageIndex, dict, ref, fontCache, builtInCMapCache) {
                return new Page({
                  pdfManager: _this4.pdfManager,
                  xref: _this4.xref,
                  pageIndex: pageIndex,
                  pageDict: dict,
                  ref: ref,
                  fontCache: fontCache,
                  builtInCMapCache: builtInCMapCache,
                  pdfFunctionFactory: _this4.pdfFunctionFactory
                });
              }
            };
            this.catalog = new _obj.Catalog(this.pdfManager, this.xref, pageFactory);
          },
          get numPages() {
            var linearization = this.linearization;
            var num = linearization ? linearization.numPages : this.catalog.numPages;
            return (0, _util.shadow)(this, "numPages", num);
          },
          get documentInfo() {
            var docInfo = {
              PDFFormatVersion: this.pdfFormatVersion,
              IsAcroFormPresent: !!this.acroForm,
              IsXFAPresent: !!this.xfa
            };
            var infoDict;
            try {
              infoDict = this.xref.trailer.get("Info");
            } catch (err) {
              if (err instanceof _util.MissingDataException) {
                throw err;
              }
              (0, _util.info)("The document information dictionary is invalid.");
            }
            if (infoDict) {
              var validEntries = DocumentInfoValidators.entries;
              for (var key in validEntries) {
                if (infoDict.has(key)) {
                  var value = infoDict.get(key);
                  if (validEntries[key](value)) {
                    docInfo[key] = typeof value !== "string" ? value : (0, _util.stringToPDFString)(value);
                  } else {
                    (0, _util.info)("Bad value in document info for \"" + key + "\"");
                  }
                }
              }
            }
            return (0, _util.shadow)(this, "documentInfo", docInfo);
          },
          get fingerprint() {
            var xref = this.xref,
              hash,
              fileID = "";
            var idArray = xref.trailer.get("ID");
            if (Array.isArray(idArray) && idArray[0] && (0, _util.isString)(idArray[0]) && idArray[0] !== EMPTY_FINGERPRINT) {
              hash = (0, _util.stringToBytes)(idArray[0]);
            } else {
              if (this.stream.ensureRange) {
                this.stream.ensureRange(0, Math.min(FINGERPRINT_FIRST_BYTES, this.stream.end));
              }
              hash = (0, _crypto.calculateMD5)(this.stream.bytes.subarray(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
            }
            for (var i = 0, n = hash.length; i < n; i++) {
              var hex = hash[i].toString(16);
              fileID += hex.length === 1 ? "0" + hex : hex;
            }
            return (0, _util.shadow)(this, "fingerprint", fileID);
          },
          getPage: function PDFDocument_getPage(pageIndex) {
            return this.catalog.getPage(pageIndex);
          },
          cleanup: function PDFDocument_cleanup() {
            return this.catalog.cleanup();
          }
        };
        return PDFDocument;
      }();
      exports.Page = Page;
      exports.PDFDocument = PDFDocument;

      /***/ }),
    /* 128 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.JpegImage = undefined;

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var _util = __w_pdfjs_require__(0);

      var JpegError = function JpegErrorClosure() {
        function JpegError(msg) {
          this.message = "JPEG error: " + msg;
        }
        JpegError.prototype = new Error();
        JpegError.prototype.name = "JpegError";
        JpegError.constructor = JpegError;
        return JpegError;
      }();
      var JpegImage = function JpegImageClosure() {
        var dctZigZag = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
        var dctCos1 = 4017;
        var dctSin1 = 799;
        var dctCos3 = 3406;
        var dctSin3 = 2276;
        var dctCos6 = 1567;
        var dctSin6 = 3784;
        var dctSqrt2 = 5793;
        var dctSqrt1d2 = 2896;
        function JpegImage() {
          this.decodeTransform = null;
          this.colorTransform = -1;
        }
        function buildHuffmanTable(codeLengths, values) {
          var k = 0,
            code = [],
            i,
            j,
            length = 16;
          while (length > 0 && !codeLengths[length - 1]) {
            length--;
          }
          code.push({
            children: [],
            index: 0
          });
          var p = code[0],
            q;
          for (i = 0; i < length; i++) {
            for (j = 0; j < codeLengths[i]; j++) {
              p = code.pop();
              p.children[p.index] = values[k];
              while (p.index > 0) {
                p = code.pop();
              }
              p.index++;
              code.push(p);
              while (code.length <= i) {
                code.push(q = {
                  children: [],
                  index: 0
                });
                p.children[p.index] = q.children;
                p = q;
              }
              k++;
            }
            if (i + 1 < length) {
              code.push(q = {
                children: [],
                index: 0
              });
              p.children[p.index] = q.children;
              p = q;
            }
          }
          return code[0].children;
        }
        function getBlockBufferOffset(component, row, col) {
          return 64 * ((component.blocksPerLine + 1) * row + col);
        }
        function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive) {
          var mcusPerLine = frame.mcusPerLine;
          var progressive = frame.progressive;
          var startOffset = offset,
            bitsData = 0,
            bitsCount = 0;
          function readBit() {
            if (bitsCount > 0) {
              bitsCount--;
              return bitsData >> bitsCount & 1;
            }
            bitsData = data[offset++];
            if (bitsData === 0xFF) {
              var nextByte = data[offset++];
              if (nextByte) {
                throw new JpegError("unexpected marker " + (bitsData << 8 | nextByte).toString(16));
              }
            }
            bitsCount = 7;
            return bitsData >>> 7;
          }
          function decodeHuffman(tree) {
            var node = tree;
            while (true) {
              node = node[readBit()];
              if (typeof node === "number") {
                return node;
              }
              if ((typeof node === "undefined" ? "undefined" : _typeof(node)) !== "object") {
                throw new JpegError("invalid huffman sequence");
              }
            }
          }
          function receive(length) {
            var n = 0;
            while (length > 0) {
              n = n << 1 | readBit();
              length--;
            }
            return n;
          }
          function receiveAndExtend(length) {
            if (length === 1) {
              return readBit() === 1 ? 1 : -1;
            }
            var n = receive(length);
            if (n >= 1 << length - 1) {
              return n;
            }
            return n + (-1 << length) + 1;
          }
          function decodeBaseline(component, offset) {
            var t = decodeHuffman(component.huffmanTableDC);
            var diff = t === 0 ? 0 : receiveAndExtend(t);
            component.blockData[offset] = component.pred += diff;
            var k = 1;
            while (k < 64) {
              var rs = decodeHuffman(component.huffmanTableAC);
              var s = rs & 15,
                r = rs >> 4;
              if (s === 0) {
                if (r < 15) {
                  break;
                }
                k += 16;
                continue;
              }
              k += r;
              var z = dctZigZag[k];
              component.blockData[offset + z] = receiveAndExtend(s);
              k++;
            }
          }
          function decodeDCFirst(component, offset) {
            var t = decodeHuffman(component.huffmanTableDC);
            var diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
            component.blockData[offset] = component.pred += diff;
          }
          function decodeDCSuccessive(component, offset) {
            component.blockData[offset] |= readBit() << successive;
          }
          var eobrun = 0;
          function decodeACFirst(component, offset) {
            if (eobrun > 0) {
              eobrun--;
              return;
            }
            var k = spectralStart,
              e = spectralEnd;
            while (k <= e) {
              var rs = decodeHuffman(component.huffmanTableAC);
              var s = rs & 15,
                r = rs >> 4;
              if (s === 0) {
                if (r < 15) {
                  eobrun = receive(r) + (1 << r) - 1;
                  break;
                }
                k += 16;
                continue;
              }
              k += r;
              var z = dctZigZag[k];
              component.blockData[offset + z] = receiveAndExtend(s) * (1 << successive);
              k++;
            }
          }
          var successiveACState = 0,
            successiveACNextValue;
          function decodeACSuccessive(component, offset) {
            var k = spectralStart;
            var e = spectralEnd;
            var r = 0;
            var s;
            var rs;
            while (k <= e) {
              var z = dctZigZag[k];
              switch (successiveACState) {
                case 0:
                  rs = decodeHuffman(component.huffmanTableAC);
                  s = rs & 15;
                  r = rs >> 4;
                  if (s === 0) {
                    if (r < 15) {
                      eobrun = receive(r) + (1 << r);
                      successiveACState = 4;
                    } else {
                      r = 16;
                      successiveACState = 1;
                    }
                  } else {
                    if (s !== 1) {
                      throw new JpegError("invalid ACn encoding");
                    }
                    successiveACNextValue = receiveAndExtend(s);
                    successiveACState = r ? 2 : 3;
                  }
                  continue;
                case 1:
                case 2:
                  if (component.blockData[offset + z]) {
                    component.blockData[offset + z] += readBit() << successive;
                  } else {
                    r--;
                    if (r === 0) {
                      successiveACState = successiveACState === 2 ? 3 : 0;
                    }
                  }
                  break;
                case 3:
                  if (component.blockData[offset + z]) {
                    component.blockData[offset + z] += readBit() << successive;
                  } else {
                    component.blockData[offset + z] = successiveACNextValue << successive;
                    successiveACState = 0;
                  }
                  break;
                case 4:
                  if (component.blockData[offset + z]) {
                    component.blockData[offset + z] += readBit() << successive;
                  }
                  break;
              }
              k++;
            }
            if (successiveACState === 4) {
              eobrun--;
              if (eobrun === 0) {
                successiveACState = 0;
              }
            }
          }
          function decodeMcu(component, decode, mcu, row, col) {
            var mcuRow = mcu / mcusPerLine | 0;
            var mcuCol = mcu % mcusPerLine;
            var blockRow = mcuRow * component.v + row;
            var blockCol = mcuCol * component.h + col;
            var offset = getBlockBufferOffset(component, blockRow, blockCol);
            decode(component, offset);
          }
          function decodeBlock(component, decode, mcu) {
            var blockRow = mcu / component.blocksPerLine | 0;
            var blockCol = mcu % component.blocksPerLine;
            var offset = getBlockBufferOffset(component, blockRow, blockCol);
            decode(component, offset);
          }
          var componentsLength = components.length;
          var component, i, j, k, n;
          var decodeFn;
          if (progressive) {
            if (spectralStart === 0) {
              decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
            } else {
              decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
            }
          } else {
            decodeFn = decodeBaseline;
          }
          var mcu = 0,
            fileMarker;
          var mcuExpected;
          if (componentsLength === 1) {
            mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
          } else {
            mcuExpected = mcusPerLine * frame.mcusPerColumn;
          }
          var h, v;
          while (mcu < mcuExpected) {
            var mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
            for (i = 0; i < componentsLength; i++) {
              components[i].pred = 0;
            }
            eobrun = 0;
            if (componentsLength === 1) {
              component = components[0];
              for (n = 0; n < mcuToRead; n++) {
                decodeBlock(component, decodeFn, mcu);
                mcu++;
              }
            } else {
              for (n = 0; n < mcuToRead; n++) {
                for (i = 0; i < componentsLength; i++) {
                  component = components[i];
                  h = component.h;
                  v = component.v;
                  for (j = 0; j < v; j++) {
                    for (k = 0; k < h; k++) {
                      decodeMcu(component, decodeFn, mcu, j, k);
                    }
                  }
                }
                mcu++;
              }
            }
            bitsCount = 0;
            fileMarker = findNextFileMarker(data, offset);
            if (fileMarker && fileMarker.invalid) {
              (0, _util.warn)("decodeScan - unexpected MCU data, next marker is: " + fileMarker.invalid);
              offset = fileMarker.offset;
            }
            var marker = fileMarker && fileMarker.marker;
            if (!marker || marker <= 0xFF00) {
              throw new JpegError("marker was not found");
            }
            if (marker >= 0xFFD0 && marker <= 0xFFD7) {
              offset += 2;
            } else {
              break;
            }
          }
          fileMarker = findNextFileMarker(data, offset);
          if (fileMarker && fileMarker.invalid) {
            (0, _util.warn)("decodeScan - unexpected Scan data, next marker is: " + fileMarker.invalid);
            offset = fileMarker.offset;
          }
          return offset - startOffset;
        }
        function quantizeAndInverse(component, blockBufferOffset, p) {
          var qt = component.quantizationTable,
            blockData = component.blockData;
          var v0, v1, v2, v3, v4, v5, v6, v7;
          var p0, p1, p2, p3, p4, p5, p6, p7;
          var t;
          if (!qt) {
            throw new JpegError("missing required Quantization Table.");
          }
          for (var row = 0; row < 64; row += 8) {
            p0 = blockData[blockBufferOffset + row];
            p1 = blockData[blockBufferOffset + row + 1];
            p2 = blockData[blockBufferOffset + row + 2];
            p3 = blockData[blockBufferOffset + row + 3];
            p4 = blockData[blockBufferOffset + row + 4];
            p5 = blockData[blockBufferOffset + row + 5];
            p6 = blockData[blockBufferOffset + row + 6];
            p7 = blockData[blockBufferOffset + row + 7];
            p0 *= qt[row];
            if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
              t = dctSqrt2 * p0 + 512 >> 10;
              p[row] = t;
              p[row + 1] = t;
              p[row + 2] = t;
              p[row + 3] = t;
              p[row + 4] = t;
              p[row + 5] = t;
              p[row + 6] = t;
              p[row + 7] = t;
              continue;
            }
            p1 *= qt[row + 1];
            p2 *= qt[row + 2];
            p3 *= qt[row + 3];
            p4 *= qt[row + 4];
            p5 *= qt[row + 5];
            p6 *= qt[row + 6];
            p7 *= qt[row + 7];
            v0 = dctSqrt2 * p0 + 128 >> 8;
            v1 = dctSqrt2 * p4 + 128 >> 8;
            v2 = p2;
            v3 = p6;
            v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
            v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
            v5 = p3 << 4;
            v6 = p5 << 4;
            v0 = v0 + v1 + 1 >> 1;
            v1 = v0 - v1;
            t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
            v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
            v3 = t;
            v4 = v4 + v6 + 1 >> 1;
            v6 = v4 - v6;
            v7 = v7 + v5 + 1 >> 1;
            v5 = v7 - v5;
            v0 = v0 + v3 + 1 >> 1;
            v3 = v0 - v3;
            v1 = v1 + v2 + 1 >> 1;
            v2 = v1 - v2;
            t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
            v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
            v7 = t;
            t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
            v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
            v6 = t;
            p[row] = v0 + v7;
            p[row + 7] = v0 - v7;
            p[row + 1] = v1 + v6;
            p[row + 6] = v1 - v6;
            p[row + 2] = v2 + v5;
            p[row + 5] = v2 - v5;
            p[row + 3] = v3 + v4;
            p[row + 4] = v3 - v4;
          }
          for (var col = 0; col < 8; ++col) {
            p0 = p[col];
            p1 = p[col + 8];
            p2 = p[col + 16];
            p3 = p[col + 24];
            p4 = p[col + 32];
            p5 = p[col + 40];
            p6 = p[col + 48];
            p7 = p[col + 56];
            if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
              t = dctSqrt2 * p0 + 8192 >> 14;
              t = t < -2040 ? 0 : t >= 2024 ? 255 : t + 2056 >> 4;
              blockData[blockBufferOffset + col] = t;
              blockData[blockBufferOffset + col + 8] = t;
              blockData[blockBufferOffset + col + 16] = t;
              blockData[blockBufferOffset + col + 24] = t;
              blockData[blockBufferOffset + col + 32] = t;
              blockData[blockBufferOffset + col + 40] = t;
              blockData[blockBufferOffset + col + 48] = t;
              blockData[blockBufferOffset + col + 56] = t;
              continue;
            }
            v0 = dctSqrt2 * p0 + 2048 >> 12;
            v1 = dctSqrt2 * p4 + 2048 >> 12;
            v2 = p2;
            v3 = p6;
            v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
            v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
            v5 = p3;
            v6 = p5;
            v0 = (v0 + v1 + 1 >> 1) + 4112;
            v1 = v0 - v1;
            t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
            v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
            v3 = t;
            v4 = v4 + v6 + 1 >> 1;
            v6 = v4 - v6;
            v7 = v7 + v5 + 1 >> 1;
            v5 = v7 - v5;
            v0 = v0 + v3 + 1 >> 1;
            v3 = v0 - v3;
            v1 = v1 + v2 + 1 >> 1;
            v2 = v1 - v2;
            t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
            v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
            v7 = t;
            t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
            v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
            v6 = t;
            p0 = v0 + v7;
            p7 = v0 - v7;
            p1 = v1 + v6;
            p6 = v1 - v6;
            p2 = v2 + v5;
            p5 = v2 - v5;
            p3 = v3 + v4;
            p4 = v3 - v4;
            p0 = p0 < 16 ? 0 : p0 >= 4080 ? 255 : p0 >> 4;
            p1 = p1 < 16 ? 0 : p1 >= 4080 ? 255 : p1 >> 4;
            p2 = p2 < 16 ? 0 : p2 >= 4080 ? 255 : p2 >> 4;
            p3 = p3 < 16 ? 0 : p3 >= 4080 ? 255 : p3 >> 4;
            p4 = p4 < 16 ? 0 : p4 >= 4080 ? 255 : p4 >> 4;
            p5 = p5 < 16 ? 0 : p5 >= 4080 ? 255 : p5 >> 4;
            p6 = p6 < 16 ? 0 : p6 >= 4080 ? 255 : p6 >> 4;
            p7 = p7 < 16 ? 0 : p7 >= 4080 ? 255 : p7 >> 4;
            blockData[blockBufferOffset + col] = p0;
            blockData[blockBufferOffset + col + 8] = p1;
            blockData[blockBufferOffset + col + 16] = p2;
            blockData[blockBufferOffset + col + 24] = p3;
            blockData[blockBufferOffset + col + 32] = p4;
            blockData[blockBufferOffset + col + 40] = p5;
            blockData[blockBufferOffset + col + 48] = p6;
            blockData[blockBufferOffset + col + 56] = p7;
          }
        }
        function buildComponentData(frame, component) {
          var blocksPerLine = component.blocksPerLine;
          var blocksPerColumn = component.blocksPerColumn;
          var computationBuffer = new Int16Array(64);
          for (var blockRow = 0; blockRow < blocksPerColumn; blockRow++) {
            for (var blockCol = 0; blockCol < blocksPerLine; blockCol++) {
              var offset = getBlockBufferOffset(component, blockRow, blockCol);
              quantizeAndInverse(component, offset, computationBuffer);
            }
          }
          return component.blockData;
        }
        function findNextFileMarker(data, currentPos, startPos) {
          function peekUint16(pos) {
            return data[pos] << 8 | data[pos + 1];
          }
          var maxPos = data.length - 1;
          var newPos = startPos < currentPos ? startPos : currentPos;
          if (currentPos >= maxPos) {
            return null;
          }
          var currentMarker = peekUint16(currentPos);
          if (currentMarker >= 0xFFC0 && currentMarker <= 0xFFFE) {
            return {
              invalid: null,
              marker: currentMarker,
              offset: currentPos
            };
          }
          var newMarker = peekUint16(newPos);
          while (!(newMarker >= 0xFFC0 && newMarker <= 0xFFFE)) {
            if (++newPos >= maxPos) {
              return null;
            }
            newMarker = peekUint16(newPos);
          }
          return {
            invalid: currentMarker.toString(16),
            marker: newMarker,
            offset: newPos
          };
        }
        JpegImage.prototype = {
          parse: function parse(data) {
            function readUint16() {
              var value = data[offset] << 8 | data[offset + 1];
              offset += 2;
              return value;
            }
            function readDataBlock() {
              var length = readUint16();
              var endOffset = offset + length - 2;
              var fileMarker = findNextFileMarker(data, endOffset, offset);
              if (fileMarker && fileMarker.invalid) {
                (0, _util.warn)("readDataBlock - incorrect length, next marker is: " + fileMarker.invalid);
                endOffset = fileMarker.offset;
              }
              var array = data.subarray(offset, endOffset);
              offset += array.length;
              return array;
            }
            function prepareComponents(frame) {
              var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
              var mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
              for (var i = 0; i < frame.components.length; i++) {
                component = frame.components[i];
                var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
                var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
                var blocksPerLineForMcu = mcusPerLine * component.h;
                var blocksPerColumnForMcu = mcusPerColumn * component.v;
                var blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
                component.blockData = new Int16Array(blocksBufferSize);
                component.blocksPerLine = blocksPerLine;
                component.blocksPerColumn = blocksPerColumn;
              }
              frame.mcusPerLine = mcusPerLine;
              frame.mcusPerColumn = mcusPerColumn;
            }
            var offset = 0;
            var jfif = null;
            var adobe = null;
            var frame, resetInterval;
            var quantizationTables = [];
            var huffmanTablesAC = [],
              huffmanTablesDC = [];
            var fileMarker = readUint16();
            if (fileMarker !== 0xFFD8) {
              throw new JpegError("SOI not found");
            }
            fileMarker = readUint16();
            while (fileMarker !== 0xFFD9) {
              var i, j, l;
              switch (fileMarker) {
                case 0xFFE0:
                case 0xFFE1:
                case 0xFFE2:
                case 0xFFE3:
                case 0xFFE4:
                case 0xFFE5:
                case 0xFFE6:
                case 0xFFE7:
                case 0xFFE8:
                case 0xFFE9:
                case 0xFFEA:
                case 0xFFEB:
                case 0xFFEC:
                case 0xFFED:
                case 0xFFEE:
                case 0xFFEF:
                case 0xFFFE:
                  var appData = readDataBlock();
                  if (fileMarker === 0xFFE0) {
                    if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) {
                      jfif = {
                        version: {
                          major: appData[5],
                          minor: appData[6]
                        },
                        densityUnits: appData[7],
                        xDensity: appData[8] << 8 | appData[9],
                        yDensity: appData[10] << 8 | appData[11],
                        thumbWidth: appData[12],
                        thumbHeight: appData[13],
                        thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                      };
                    }
                  }
                  if (fileMarker === 0xFFEE) {
                    if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F && appData[3] === 0x62 && appData[4] === 0x65) {
                      adobe = {
                        version: appData[5] << 8 | appData[6],
                        flags0: appData[7] << 8 | appData[8],
                        flags1: appData[9] << 8 | appData[10],
                        transformCode: appData[11]
                      };
                    }
                  }
                  break;
                case 0xFFDB:
                  var quantizationTablesLength = readUint16();
                  var quantizationTablesEnd = quantizationTablesLength + offset - 2;
                  var z;
                  while (offset < quantizationTablesEnd) {
                    var quantizationTableSpec = data[offset++];
                    var tableData = new Uint16Array(64);
                    if (quantizationTableSpec >> 4 === 0) {
                      for (j = 0; j < 64; j++) {
                        z = dctZigZag[j];
                        tableData[z] = data[offset++];
                      }
                    } else if (quantizationTableSpec >> 4 === 1) {
                      for (j = 0; j < 64; j++) {
                        z = dctZigZag[j];
                        tableData[z] = readUint16();
                      }
                    } else {
                      throw new JpegError("DQT - invalid table spec");
                    }
                    quantizationTables[quantizationTableSpec & 15] = tableData;
                  }
                  break;
                case 0xFFC0:
                case 0xFFC1:
                case 0xFFC2:
                  if (frame) {
                    throw new JpegError("Only single frame JPEGs supported");
                  }
                  readUint16();
                  frame = {};
                  frame.extended = fileMarker === 0xFFC1;
                  frame.progressive = fileMarker === 0xFFC2;
                  frame.precision = data[offset++];
                  frame.scanLines = readUint16();
                  frame.samplesPerLine = readUint16();
                  frame.components = [];
                  frame.componentIds = {};
                  var componentsCount = data[offset++],
                    componentId;
                  var maxH = 0,
                    maxV = 0;
                  for (i = 0; i < componentsCount; i++) {
                    componentId = data[offset];
                    var h = data[offset + 1] >> 4;
                    var v = data[offset + 1] & 15;
                    if (maxH < h) {
                      maxH = h;
                    }
                    if (maxV < v) {
                      maxV = v;
                    }
                    var qId = data[offset + 2];
                    l = frame.components.push({
                      h: h,
                      v: v,
                      quantizationId: qId,
                      quantizationTable: null
                    });
                    frame.componentIds[componentId] = l - 1;
                    offset += 3;
                  }
                  frame.maxH = maxH;
                  frame.maxV = maxV;
                  prepareComponents(frame);
                  break;
                case 0xFFC4:
                  var huffmanLength = readUint16();
                  for (i = 2; i < huffmanLength;) {
                    var huffmanTableSpec = data[offset++];
                    var codeLengths = new Uint8Array(16);
                    var codeLengthSum = 0;
                    for (j = 0; j < 16; j++, offset++) {
                      codeLengthSum += codeLengths[j] = data[offset];
                    }
                    var huffmanValues = new Uint8Array(codeLengthSum);
                    for (j = 0; j < codeLengthSum; j++, offset++) {
                      huffmanValues[j] = data[offset];
                    }
                    i += 17 + codeLengthSum;
                    (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                  }
                  break;
                case 0xFFDD:
                  readUint16();
                  resetInterval = readUint16();
                  break;
                case 0xFFDA:
                  readUint16();
                  var selectorsCount = data[offset++];
                  var components = [],
                    component;
                  for (i = 0; i < selectorsCount; i++) {
                    var componentIndex = frame.componentIds[data[offset++]];
                    component = frame.components[componentIndex];
                    var tableSpec = data[offset++];
                    component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
                    component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
                    components.push(component);
                  }
                  var spectralStart = data[offset++];
                  var spectralEnd = data[offset++];
                  var successiveApproximation = data[offset++];
                  var processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15);
                  offset += processed;
                  break;
                case 0xFFFF:
                  if (data[offset] !== 0xFF) {
                    offset--;
                  }
                  break;
                default:
                  if (data[offset - 3] === 0xFF && data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
                    offset -= 3;
                    break;
                  }
                  throw new JpegError("unknown marker " + fileMarker.toString(16));
              }
              fileMarker = readUint16();
            }
            this.width = frame.samplesPerLine;
            this.height = frame.scanLines;
            this.jfif = jfif;
            this.adobe = adobe;
            this.components = [];
            for (i = 0; i < frame.components.length; i++) {
              component = frame.components[i];
              var quantizationTable = quantizationTables[component.quantizationId];
              if (quantizationTable) {
                component.quantizationTable = quantizationTable;
              }
              this.components.push({
                output: buildComponentData(frame, component),
                scaleX: component.h / frame.maxH,
                scaleY: component.v / frame.maxV,
                blocksPerLine: component.blocksPerLine,
                blocksPerColumn: component.blocksPerColumn
              });
            }
            this.numComponents = this.components.length;
          },
          _getLinearizedBlockData: function getLinearizedBlockData(width, height) {
            var scaleX = this.width / width,
              scaleY = this.height / height;
            var component, componentScaleX, componentScaleY, blocksPerScanline;
            var x, y, i, j, k;
            var index;
            var offset = 0;
            var output;
            var numComponents = this.components.length;
            var dataLength = width * height * numComponents;
            var data = new Uint8ClampedArray(dataLength);
            var xScaleBlockOffset = new Uint32Array(width);
            var mask3LSB = 0xfffffff8;
            for (i = 0; i < numComponents; i++) {
              component = this.components[i];
              componentScaleX = component.scaleX * scaleX;
              componentScaleY = component.scaleY * scaleY;
              offset = i;
              output = component.output;
              blocksPerScanline = component.blocksPerLine + 1 << 3;
              for (x = 0; x < width; x++) {
                j = 0 | x * componentScaleX;
                xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
              }
              for (y = 0; y < height; y++) {
                j = 0 | y * componentScaleY;
                index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
                for (x = 0; x < width; x++) {
                  data[offset] = output[index + xScaleBlockOffset[x]];
                  offset += numComponents;
                }
              }
            }
            var transform = this.decodeTransform;
            if (transform) {
              for (i = 0; i < dataLength;) {
                for (j = 0, k = 0; j < numComponents; j++, i++, k += 2) {
                  data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
                }
              }
            }
            return data;
          },
          _isColorConversionNeeded: function _isColorConversionNeeded() {
            if (this.adobe) {
              return !!this.adobe.transformCode;
            }
            if (this.numComponents === 3) {
              if (this.colorTransform === 0) {
                return false;
              }
              return true;
            }
            if (this.colorTransform === 1) {
              return true;
            }
            return false;
          },

          _convertYccToRgb: function convertYccToRgb(data) {
            var Y, Cb, Cr;
            for (var i = 0, length = data.length; i < length; i += 3) {
              Y = data[i];
              Cb = data[i + 1];
              Cr = data[i + 2];
              data[i] = Y - 179.456 + 1.402 * Cr;
              data[i + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
              data[i + 2] = Y - 226.816 + 1.772 * Cb;
            }
            return data;
          },
          _convertYcckToRgb: function convertYcckToRgb(data) {
            var Y, Cb, Cr, k;
            var offset = 0;
            for (var i = 0, length = data.length; i < length; i += 4) {
              Y = data[i];
              Cb = data[i + 1];
              Cr = data[i + 2];
              k = data[i + 3];
              data[offset++] = -122.67195406894 + Cb * (-6.60635669420364e-5 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
              data[offset++] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
              data[offset++] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-1.53496057440975e-5 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
            }
            return data;
          },
          _convertYcckToCmyk: function convertYcckToCmyk(data) {
            var Y, Cb, Cr;
            for (var i = 0, length = data.length; i < length; i += 4) {
              Y = data[i];
              Cb = data[i + 1];
              Cr = data[i + 2];
              data[i] = 434.456 - Y - 1.402 * Cr;
              data[i + 1] = 119.541 - Y + 0.344 * Cb + 0.714 * Cr;
              data[i + 2] = 481.816 - Y - 1.772 * Cb;
            }
            return data;
          },
          _convertCmykToRgb: function convertCmykToRgb(data) {
            var c, m, y, k;
            var offset = 0;
            var scale = 1 / 255;
            for (var i = 0, length = data.length; i < length; i += 4) {
              c = data[i] * scale;
              m = data[i + 1] * scale;
              y = data[i + 2] * scale;
              k = data[i + 3] * scale;
              data[offset++] = 255 + c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k - 285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y - 17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) - k * (21.86122147463605 * k + 189.48180835922747);
              data[offset++] = 255 + c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k - 79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) - k * (20.737325471181034 * k + 187.80453709719578);
              data[offset++] = 255 + c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k - 14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k - 193.58209356861505) - k * (22.33816807309886 * k + 180.12613974708367);
            }
            return data;
          },
          getData: function getData(width, height, forceRGBoutput) {
            if (this.numComponents > 4) {
              throw new JpegError("Unsupported color mode");
            }
            var data = this._getLinearizedBlockData(width, height);
            if (this.numComponents === 1 && forceRGBoutput) {
              var dataLength = data.length;
              var rgbData = new Uint8ClampedArray(dataLength * 3);
              var offset = 0;
              for (var i = 0; i < dataLength; i++) {
                var grayColor = data[i];
                rgbData[offset++] = grayColor;
                rgbData[offset++] = grayColor;
                rgbData[offset++] = grayColor;
              }
              return rgbData;
            } else if (this.numComponents === 3 && this._isColorConversionNeeded()) {
              return this._convertYccToRgb(data);
            } else if (this.numComponents === 4) {
              if (this._isColorConversionNeeded()) {
                if (forceRGBoutput) {
                  return this._convertYcckToRgb(data);
                }
                return this._convertYcckToCmyk(data);
              } else if (forceRGBoutput) {
                return this._convertCmykToRgb(data);
              }
            }
            return data;
          }
        };
        return JpegImage;
      }();
      exports.JpegImage = JpegImage;

      /***/ }),
    /* 129 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CCITTFaxStream = undefined;

      var _primitives = __w_pdfjs_require__(2);

      var _ccitt = __w_pdfjs_require__(130);

      var _stream = __w_pdfjs_require__(5);

      var CCITTFaxStream = function CCITTFaxStreamClosure() {
        function CCITTFaxStream(str, maybeLength, params) {
          this.str = str;
          this.dict = str.dict;
          if (!(0, _primitives.isDict)(params)) {
            params = _primitives.Dict.empty;
          }
          var source = {
            next: function next() {
              return str.getByte();
            }
          };
          this.ccittFaxDecoder = new _ccitt.CCITTFaxDecoder(source, {
            K: params.get("K"),
            EndOfLine: params.get("EndOfLine"),
            EncodedByteAlign: params.get("EncodedByteAlign"),
            Columns: params.get("Columns"),
            Rows: params.get("Rows"),
            EndOfBlock: params.get("EndOfBlock"),
            BlackIs1: params.get("BlackIs1")
          });
          _stream.DecodeStream.call(this, maybeLength);
        }
        CCITTFaxStream.prototype = Object.create(_stream.DecodeStream.prototype);
        CCITTFaxStream.prototype.readBlock = function () {
          while (!this.eof) {
            var c = this.ccittFaxDecoder.readNextChar();
            if (c === -1) {
              this.eof = true;
              return;
            }
            this.ensureBuffer(this.bufferLength + 1);
            this.buffer[this.bufferLength++] = c;
          }
        };
        return CCITTFaxStream;
      }();
      exports.CCITTFaxStream = CCITTFaxStream;

      /***/ }),
    /* 130 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CCITTFaxDecoder = undefined;

      var _util = __w_pdfjs_require__(0);

      var CCITTFaxDecoder = function CCITTFaxDecoder() {
        var ccittEOL = -2;
        var ccittEOF = -1;
        var twoDimPass = 0;
        var twoDimHoriz = 1;
        var twoDimVert0 = 2;
        var twoDimVertR1 = 3;
        var twoDimVertL1 = 4;
        var twoDimVertR2 = 5;
        var twoDimVertL2 = 6;
        var twoDimVertR3 = 7;
        var twoDimVertL3 = 8;
        var twoDimTable = [[-1, -1], [-1, -1], [7, twoDimVertL3], [7, twoDimVertR3], [6, twoDimVertL2], [6, twoDimVertL2], [6, twoDimVertR2], [6, twoDimVertR2], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0]];
        var whiteTable1 = [[-1, -1], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]];
        var whiteTable2 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]];
        var blackTable1 = [[-1, -1], [-1, -1], [12, ccittEOL], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]];
        var blackTable2 = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]];
        var blackTable3 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
        function CCITTFaxDecoder(source) {
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (!source || typeof source.next !== "function") {
            throw new Error("CCITTFaxDecoder - invalid \"source\" parameter.");
          }
          this.source = source;
          this.eof = false;
          this.encoding = options["K"] || 0;
          this.eoline = options["EndOfLine"] || false;
          this.byteAlign = options["EncodedByteAlign"] || false;
          this.columns = options["Columns"] || 1728;
          this.rows = options["Rows"] || 0;
          var eoblock = options["EndOfBlock"];
          if (eoblock === null || eoblock === undefined) {
            eoblock = true;
          }
          this.eoblock = eoblock;
          this.black = options["BlackIs1"] || false;
          this.codingLine = new Uint32Array(this.columns + 1);
          this.refLine = new Uint32Array(this.columns + 2);
          this.codingLine[0] = this.columns;
          this.codingPos = 0;
          this.row = 0;
          this.nextLine2D = this.encoding < 0;
          this.inputBits = 0;
          this.inputBuf = 0;
          this.outputBits = 0;
          this.rowsDone = false;
          var code1 = void 0;
          while ((code1 = this._lookBits(12)) === 0) {
            this._eatBits(1);
          }
          if (code1 === 1) {
            this._eatBits(12);
          }
          if (this.encoding > 0) {
            this.nextLine2D = !this._lookBits(1);
            this._eatBits(1);
          }
        }
        CCITTFaxDecoder.prototype = {
          readNextChar: function readNextChar() {
            if (this.eof) {
              return -1;
            }
            var refLine = this.refLine;
            var codingLine = this.codingLine;
            var columns = this.columns;
            var refPos = void 0,
              blackPixels = void 0,
              bits = void 0,
              i = void 0;
            if (this.outputBits === 0) {
              if (this.rowsDone) {
                this.eof = true;
              }
              if (this.eof) {
                return -1;
              }
              this.err = false;
              var code1 = void 0,
                code2 = void 0,
                code3 = void 0;
              if (this.nextLine2D) {
                for (i = 0; codingLine[i] < columns; ++i) {
                  refLine[i] = codingLine[i];
                }
                refLine[i++] = columns;
                refLine[i] = columns;
                codingLine[0] = 0;
                this.codingPos = 0;
                refPos = 0;
                blackPixels = 0;
                while (codingLine[this.codingPos] < columns) {
                  code1 = this._getTwoDimCode();
                  switch (code1) {
                    case twoDimPass:
                      this._addPixels(refLine[refPos + 1], blackPixels);
                      if (refLine[refPos + 1] < columns) {
                        refPos += 2;
                      }
                      break;
                    case twoDimHoriz:
                      code1 = code2 = 0;
                      if (blackPixels) {
                        do {
                          code1 += code3 = this._getBlackCode();
                        } while (code3 >= 64);
                        do {
                          code2 += code3 = this._getWhiteCode();
                        } while (code3 >= 64);
                      } else {
                        do {
                          code1 += code3 = this._getWhiteCode();
                        } while (code3 >= 64);
                        do {
                          code2 += code3 = this._getBlackCode();
                        } while (code3 >= 64);
                      }
                      this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                      if (codingLine[this.codingPos] < columns) {
                        this._addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
                      }
                      while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                        refPos += 2;
                      }
                      break;
                    case twoDimVertR3:
                      this._addPixels(refLine[refPos] + 3, blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        ++refPos;
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case twoDimVertR2:
                      this._addPixels(refLine[refPos] + 2, blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        ++refPos;
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case twoDimVertR1:
                      this._addPixels(refLine[refPos] + 1, blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        ++refPos;
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case twoDimVert0:
                      this._addPixels(refLine[refPos], blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        ++refPos;
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case twoDimVertL3:
                      this._addPixelsNeg(refLine[refPos] - 3, blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        if (refPos > 0) {
                          --refPos;
                        } else {
                          ++refPos;
                        }
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case twoDimVertL2:
                      this._addPixelsNeg(refLine[refPos] - 2, blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        if (refPos > 0) {
                          --refPos;
                        } else {
                          ++refPos;
                        }
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case twoDimVertL1:
                      this._addPixelsNeg(refLine[refPos] - 1, blackPixels);
                      blackPixels ^= 1;
                      if (codingLine[this.codingPos] < columns) {
                        if (refPos > 0) {
                          --refPos;
                        } else {
                          ++refPos;
                        }
                        while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                          refPos += 2;
                        }
                      }
                      break;
                    case ccittEOF:
                      this._addPixels(columns, 0);
                      this.eof = true;
                      break;
                    default:
                      (0, _util.info)("bad 2d code");
                      this._addPixels(columns, 0);
                      this.err = true;
                  }
                }
              } else {
                codingLine[0] = 0;
                this.codingPos = 0;
                blackPixels = 0;
                while (codingLine[this.codingPos] < columns) {
                  code1 = 0;
                  if (blackPixels) {
                    do {
                      code1 += code3 = this._getBlackCode();
                    } while (code3 >= 64);
                  } else {
                    do {
                      code1 += code3 = this._getWhiteCode();
                    } while (code3 >= 64);
                  }
                  this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                  blackPixels ^= 1;
                }
              }
              var gotEOL = false;
              if (this.byteAlign) {
                this.inputBits &= ~7;
              }
              if (!this.eoblock && this.row === this.rows - 1) {
                this.rowsDone = true;
              } else {
                code1 = this._lookBits(12);
                if (this.eoline) {
                  while (code1 !== ccittEOF && code1 !== 1) {
                    this._eatBits(1);
                    code1 = this._lookBits(12);
                  }
                } else {
                  while (code1 === 0) {
                    this._eatBits(1);
                    code1 = this._lookBits(12);
                  }
                }
                if (code1 === 1) {
                  this._eatBits(12);
                  gotEOL = true;
                } else if (code1 === ccittEOF) {
                  this.eof = true;
                }
              }
              if (!this.eof && this.encoding > 0 && !this.rowsDone) {
                this.nextLine2D = !this._lookBits(1);
                this._eatBits(1);
              }
              if (this.eoblock && gotEOL && this.byteAlign) {
                code1 = this._lookBits(12);
                if (code1 === 1) {
                  this._eatBits(12);
                  if (this.encoding > 0) {
                    this._lookBits(1);
                    this._eatBits(1);
                  }
                  if (this.encoding >= 0) {
                    for (i = 0; i < 4; ++i) {
                      code1 = this._lookBits(12);
                      if (code1 !== 1) {
                        (0, _util.info)("bad rtc code: " + code1);
                      }
                      this._eatBits(12);
                      if (this.encoding > 0) {
                        this._lookBits(1);
                        this._eatBits(1);
                      }
                    }
                  }
                  this.eof = true;
                }
              } else if (this.err && this.eoline) {
                while (true) {
                  code1 = this._lookBits(13);
                  if (code1 === ccittEOF) {
                    this.eof = true;
                    return -1;
                  }
                  if (code1 >> 1 === 1) {
                    break;
                  }
                  this._eatBits(1);
                }
                this._eatBits(12);
                if (this.encoding > 0) {
                  this._eatBits(1);
                  this.nextLine2D = !(code1 & 1);
                }
              }
              if (codingLine[0] > 0) {
                this.outputBits = codingLine[this.codingPos = 0];
              } else {
                this.outputBits = codingLine[this.codingPos = 1];
              }
              this.row++;
            }
            var c = void 0;
            if (this.outputBits >= 8) {
              c = this.codingPos & 1 ? 0 : 0xFF;
              this.outputBits -= 8;
              if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
                this.codingPos++;
                this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
              }
            } else {
              bits = 8;
              c = 0;
              do {
                if (this.outputBits > bits) {
                  c <<= bits;
                  if (!(this.codingPos & 1)) {
                    c |= 0xFF >> 8 - bits;
                  }
                  this.outputBits -= bits;
                  bits = 0;
                } else {
                  c <<= this.outputBits;
                  if (!(this.codingPos & 1)) {
                    c |= 0xFF >> 8 - this.outputBits;
                  }
                  bits -= this.outputBits;
                  this.outputBits = 0;
                  if (codingLine[this.codingPos] < columns) {
                    this.codingPos++;
                    this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                  } else if (bits > 0) {
                    c <<= bits;
                    bits = 0;
                  }
                }
              } while (bits);
            }
            if (this.black) {
              c ^= 0xFF;
            }
            return c;
          },
          _addPixels: function _addPixels(a1, blackPixels) {
            var codingLine = this.codingLine;
            var codingPos = this.codingPos;
            if (a1 > codingLine[codingPos]) {
              if (a1 > this.columns) {
                (0, _util.info)("row is wrong length");
                this.err = true;
                a1 = this.columns;
              }
              if (codingPos & 1 ^ blackPixels) {
                ++codingPos;
              }
              codingLine[codingPos] = a1;
            }
            this.codingPos = codingPos;
          },
          _addPixelsNeg: function _addPixelsNeg(a1, blackPixels) {
            var codingLine = this.codingLine;
            var codingPos = this.codingPos;
            if (a1 > codingLine[codingPos]) {
              if (a1 > this.columns) {
                (0, _util.info)("row is wrong length");
                this.err = true;
                a1 = this.columns;
              }
              if (codingPos & 1 ^ blackPixels) {
                ++codingPos;
              }
              codingLine[codingPos] = a1;
            } else if (a1 < codingLine[codingPos]) {
              if (a1 < 0) {
                (0, _util.info)("invalid code");
                this.err = true;
                a1 = 0;
              }
              while (codingPos > 0 && a1 < codingLine[codingPos - 1]) {
                --codingPos;
              }
              codingLine[codingPos] = a1;
            }
            this.codingPos = codingPos;
          },
          _findTableCode: function _findTableCode(start, end, table, limit) {
            var limitValue = limit || 0;
            for (var i = start; i <= end; ++i) {
              var code = this._lookBits(i);
              if (code === ccittEOF) {
                return [true, 1, false];
              }
              if (i < end) {
                code <<= end - i;
              }
              if (!limitValue || code >= limitValue) {
                var p = table[code - limitValue];
                if (p[0] === i) {
                  this._eatBits(i);
                  return [true, p[1], true];
                }
              }
            }
            return [false, 0, false];
          },
          _getTwoDimCode: function _getTwoDimCode() {
            var code = 0;
            var p = void 0;
            if (this.eoblock) {
              code = this._lookBits(7);
              p = twoDimTable[code];
              if (p && p[0] > 0) {
                this._eatBits(p[0]);
                return p[1];
              }
            } else {
              var result = this._findTableCode(1, 7, twoDimTable);
              if (result[0] && result[2]) {
                return result[1];
              }
            }
            (0, _util.info)("Bad two dim code");
            return ccittEOF;
          },
          _getWhiteCode: function _getWhiteCode() {
            var code = 0;
            var p = void 0;
            if (this.eoblock) {
              code = this._lookBits(12);
              if (code === ccittEOF) {
                return 1;
              }
              if (code >> 5 === 0) {
                p = whiteTable1[code];
              } else {
                p = whiteTable2[code >> 3];
              }
              if (p[0] > 0) {
                this._eatBits(p[0]);
                return p[1];
              }
            } else {
              var result = this._findTableCode(1, 9, whiteTable2);
              if (result[0]) {
                return result[1];
              }
              result = this._findTableCode(11, 12, whiteTable1);
              if (result[0]) {
                return result[1];
              }
            }
            (0, _util.info)("bad white code");
            this._eatBits(1);
            return 1;
          },
          _getBlackCode: function _getBlackCode() {
            var code = void 0,
              p = void 0;
            if (this.eoblock) {
              code = this._lookBits(13);
              if (code === ccittEOF) {
                return 1;
              }
              if (code >> 7 === 0) {
                p = blackTable1[code];
              } else if (code >> 9 === 0 && code >> 7 !== 0) {
                p = blackTable2[(code >> 1) - 64];
              } else {
                p = blackTable3[code >> 7];
              }
              if (p[0] > 0) {
                this._eatBits(p[0]);
                return p[1];
              }
            } else {
              var result = this._findTableCode(2, 6, blackTable3);
              if (result[0]) {
                return result[1];
              }
              result = this._findTableCode(7, 12, blackTable2, 64);
              if (result[0]) {
                return result[1];
              }
              result = this._findTableCode(10, 13, blackTable1);
              if (result[0]) {
                return result[1];
              }
            }
            (0, _util.info)("bad black code");
            this._eatBits(1);
            return 1;
          },
          _lookBits: function _lookBits(n) {
            var c = void 0;
            while (this.inputBits < n) {
              if ((c = this.source.next()) === -1) {
                if (this.inputBits === 0) {
                  return ccittEOF;
                }
                return this.inputBuf << n - this.inputBits & 0xFFFF >> 16 - n;
              }
              this.inputBuf = this.inputBuf << 8 | c;
              this.inputBits += 8;
            }
            return this.inputBuf >> this.inputBits - n & 0xFFFF >> 16 - n;
          },
          _eatBits: function _eatBits(n) {
            if ((this.inputBits -= n) < 0) {
              this.inputBits = 0;
            }
          }
        };
        return CCITTFaxDecoder;
      }();
      exports.CCITTFaxDecoder = CCITTFaxDecoder;

      /***/ }),
    /* 131 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Jbig2Stream = undefined;

      var _primitives = __w_pdfjs_require__(2);

      var _stream = __w_pdfjs_require__(5);

      var _jbig = __w_pdfjs_require__(132);

      var _util = __w_pdfjs_require__(0);

      var Jbig2Stream = function Jbig2StreamClosure() {
        function Jbig2Stream(stream, maybeLength, dict, params) {
          this.stream = stream;
          this.maybeLength = maybeLength;
          this.dict = dict;
          this.params = params;
          _stream.DecodeStream.call(this, maybeLength);
        }
        Jbig2Stream.prototype = Object.create(_stream.DecodeStream.prototype);
        Object.defineProperty(Jbig2Stream.prototype, "bytes", {
          get: function get() {
            return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
          },

          configurable: true
        });
        Jbig2Stream.prototype.ensureBuffer = function (req) {
          if (this.bufferLength) {
            return;
          }
          var jbig2Image = new _jbig.Jbig2Image();
          var chunks = [];
          if ((0, _primitives.isDict)(this.params)) {
            var globalsStream = this.params.get("JBIG2Globals");
            if ((0, _primitives.isStream)(globalsStream)) {
              var globals = globalsStream.getBytes();
              chunks.push({
                data: globals,
                start: 0,
                end: globals.length
              });
            }
          }
          chunks.push({
            data: this.bytes,
            start: 0,
            end: this.bytes.length
          });
          var data = jbig2Image.parseChunks(chunks);
          var dataLength = data.length;
          for (var i = 0; i < dataLength; i++) {
            data[i] ^= 0xFF;
          }
          this.buffer = data;
          this.bufferLength = dataLength;
          this.eof = true;
        };
        return Jbig2Stream;
      }();
      exports.Jbig2Stream = Jbig2Stream;

      /***/ }),
    /* 132 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Jbig2Image = undefined;

      var _util = __w_pdfjs_require__(0);

      var _arithmetic_decoder = __w_pdfjs_require__(75);

      var Jbig2Error = function Jbig2ErrorClosure() {
        function Jbig2Error(msg) {
          this.message = "JBIG2 error: " + msg;
        }
        Jbig2Error.prototype = new Error();
        Jbig2Error.prototype.name = "Jbig2Error";
        Jbig2Error.constructor = Jbig2Error;
        return Jbig2Error;
      }();
      var Jbig2Image = function Jbig2ImageClosure() {
        function ContextCache() {}
        ContextCache.prototype = {
          getContexts: function getContexts(id) {
            if (id in this) {
              return this[id];
            }
            return this[id] = new Int8Array(1 << 16);
          }
        };
        function DecodingContext(data, start, end) {
          this.data = data;
          this.start = start;
          this.end = end;
        }
        DecodingContext.prototype = {
          get decoder() {
            var decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
            return (0, _util.shadow)(this, "decoder", decoder);
          },
          get contextCache() {
            var cache = new ContextCache();
            return (0, _util.shadow)(this, "contextCache", cache);
          }
        };
        function decodeInteger(contextCache, procedure, decoder) {
          var contexts = contextCache.getContexts(procedure);
          var prev = 1;
          function readBits(length) {
            var v = 0;
            for (var i = 0; i < length; i++) {
              var bit = decoder.readBit(contexts, prev);
              prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
              v = v << 1 | bit;
            }
            return v >>> 0;
          }
          var sign = readBits(1);
          var value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
          return sign === 0 ? value : value > 0 ? -value : null;
        }
        function decodeIAID(contextCache, decoder, codeLength) {
          var contexts = contextCache.getContexts("IAID");
          var prev = 1;
          for (var i = 0; i < codeLength; i++) {
            var bit = decoder.readBit(contexts, prev);
            prev = prev << 1 | bit;
          }
          if (codeLength < 31) {
            return prev & (1 << codeLength) - 1;
          }
          return prev & 0x7FFFFFFF;
        }
        var SegmentTypes = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"];
        var CodingTemplates = [[{
          x: -1,
          y: -2
        }, {
          x: 0,
          y: -2
        }, {
          x: 1,
          y: -2
        }, {
          x: -2,
          y: -1
        }, {
          x: -1,
          y: -1
        }, {
          x: 0,
          y: -1
        }, {
          x: 1,
          y: -1
        }, {
          x: 2,
          y: -1
        }, {
          x: -4,
          y: 0
        }, {
          x: -3,
          y: 0
        }, {
          x: -2,
          y: 0
        }, {
          x: -1,
          y: 0
        }], [{
          x: -1,
          y: -2
        }, {
          x: 0,
          y: -2
        }, {
          x: 1,
          y: -2
        }, {
          x: 2,
          y: -2
        }, {
          x: -2,
          y: -1
        }, {
          x: -1,
          y: -1
        }, {
          x: 0,
          y: -1
        }, {
          x: 1,
          y: -1
        }, {
          x: 2,
          y: -1
        }, {
          x: -3,
          y: 0
        }, {
          x: -2,
          y: 0
        }, {
          x: -1,
          y: 0
        }], [{
          x: -1,
          y: -2
        }, {
          x: 0,
          y: -2
        }, {
          x: 1,
          y: -2
        }, {
          x: -2,
          y: -1
        }, {
          x: -1,
          y: -1
        }, {
          x: 0,
          y: -1
        }, {
          x: 1,
          y: -1
        }, {
          x: -2,
          y: 0
        }, {
          x: -1,
          y: 0
        }], [{
          x: -3,
          y: -1
        }, {
          x: -2,
          y: -1
        }, {
          x: -1,
          y: -1
        }, {
          x: 0,
          y: -1
        }, {
          x: 1,
          y: -1
        }, {
          x: -4,
          y: 0
        }, {
          x: -3,
          y: 0
        }, {
          x: -2,
          y: 0
        }, {
          x: -1,
          y: 0
        }]];
        var RefinementTemplates = [{
          coding: [{
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -1,
            y: 0
          }],
          reference: [{
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -1,
            y: 0
          }, {
            x: 0,
            y: 0
          }, {
            x: 1,
            y: 0
          }, {
            x: -1,
            y: 1
          }, {
            x: 0,
            y: 1
          }, {
            x: 1,
            y: 1
          }]
        }, {
          coding: [{
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -1,
            y: 0
          }],
          reference: [{
            x: 0,
            y: -1
          }, {
            x: -1,
            y: 0
          }, {
            x: 0,
            y: 0
          }, {
            x: 1,
            y: 0
          }, {
            x: 0,
            y: 1
          }, {
            x: 1,
            y: 1
          }]
        }];
        var ReusedContexts = [0x9B25, 0x0795, 0x00E5, 0x0195];
        var RefinementReusedContexts = [0x0020, 0x0008];
        function decodeBitmapTemplate0(width, height, decodingContext) {
          var decoder = decodingContext.decoder;
          var contexts = decodingContext.contextCache.getContexts("GB");
          var contextLabel,
            i,
            j,
            pixel,
            row,
            row1,
            row2,
            bitmap = [];
          var OLD_PIXEL_MASK = 0x7BF7;
          for (i = 0; i < height; i++) {
            row = bitmap[i] = new Uint8Array(width);
            row1 = i < 1 ? row : bitmap[i - 1];
            row2 = i < 2 ? row : bitmap[i - 2];
            contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
            for (j = 0; j < width; j++) {
              row[j] = pixel = decoder.readBit(contexts, contextLabel);
              contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
            }
          }
          return bitmap;
        }
        function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
          if (mmr) {
            throw new Jbig2Error("MMR encoding is not supported");
          }
          if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) {
            return decodeBitmapTemplate0(width, height, decodingContext);
          }
          var useskip = !!skip;
          var template = CodingTemplates[templateIndex].concat(at);
          template.sort(function (a, b) {
            return a.y - b.y || a.x - b.x;
          });
          var templateLength = template.length;
          var templateX = new Int8Array(templateLength);
          var templateY = new Int8Array(templateLength);
          var changingTemplateEntries = [];
          var reuseMask = 0,
            minX = 0,
            maxX = 0,
            minY = 0;
          var c, k;
          for (k = 0; k < templateLength; k++) {
            templateX[k] = template[k].x;
            templateY[k] = template[k].y;
            minX = Math.min(minX, template[k].x);
            maxX = Math.max(maxX, template[k].x);
            minY = Math.min(minY, template[k].y);
            if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) {
              reuseMask |= 1 << templateLength - 1 - k;
            } else {
              changingTemplateEntries.push(k);
            }
          }
          var changingEntriesLength = changingTemplateEntries.length;
          var changingTemplateX = new Int8Array(changingEntriesLength);
          var changingTemplateY = new Int8Array(changingEntriesLength);
          var changingTemplateBit = new Uint16Array(changingEntriesLength);
          for (c = 0; c < changingEntriesLength; c++) {
            k = changingTemplateEntries[c];
            changingTemplateX[c] = template[k].x;
            changingTemplateY[c] = template[k].y;
            changingTemplateBit[c] = 1 << templateLength - 1 - k;
          }
          var sbb_left = -minX;
          var sbb_top = -minY;
          var sbb_right = width - maxX;
          var pseudoPixelContext = ReusedContexts[templateIndex];
          var row = new Uint8Array(width);
          var bitmap = [];
          var decoder = decodingContext.decoder;
          var contexts = decodingContext.contextCache.getContexts("GB");
          var ltp = 0,
            j,
            i0,
            j0,
            contextLabel = 0,
            bit,
            shift;
          for (var i = 0; i < height; i++) {
            if (prediction) {
              var sltp = decoder.readBit(contexts, pseudoPixelContext);
              ltp ^= sltp;
              if (ltp) {
                bitmap.push(row);
                continue;
              }
            }
            row = new Uint8Array(row);
            bitmap.push(row);
            for (j = 0; j < width; j++) {
              if (useskip && skip[i][j]) {
                row[j] = 0;
                continue;
              }
              if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
                contextLabel = contextLabel << 1 & reuseMask;
                for (k = 0; k < changingEntriesLength; k++) {
                  i0 = i + changingTemplateY[k];
                  j0 = j + changingTemplateX[k];
                  bit = bitmap[i0][j0];
                  if (bit) {
                    bit = changingTemplateBit[k];
                    contextLabel |= bit;
                  }
                }
              } else {
                contextLabel = 0;
                shift = templateLength - 1;
                for (k = 0; k < templateLength; k++, shift--) {
                  j0 = j + templateX[k];
                  if (j0 >= 0 && j0 < width) {
                    i0 = i + templateY[k];
                    if (i0 >= 0) {
                      bit = bitmap[i0][j0];
                      if (bit) {
                        contextLabel |= bit << shift;
                      }
                    }
                  }
                }
              }
              var pixel = decoder.readBit(contexts, contextLabel);
              row[j] = pixel;
            }
          }
          return bitmap;
        }
        function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
          var codingTemplate = RefinementTemplates[templateIndex].coding;
          if (templateIndex === 0) {
            codingTemplate = codingTemplate.concat([at[0]]);
          }
          var codingTemplateLength = codingTemplate.length;
          var codingTemplateX = new Int32Array(codingTemplateLength);
          var codingTemplateY = new Int32Array(codingTemplateLength);
          var k;
          for (k = 0; k < codingTemplateLength; k++) {
            codingTemplateX[k] = codingTemplate[k].x;
            codingTemplateY[k] = codingTemplate[k].y;
          }
          var referenceTemplate = RefinementTemplates[templateIndex].reference;
          if (templateIndex === 0) {
            referenceTemplate = referenceTemplate.concat([at[1]]);
          }
          var referenceTemplateLength = referenceTemplate.length;
          var referenceTemplateX = new Int32Array(referenceTemplateLength);
          var referenceTemplateY = new Int32Array(referenceTemplateLength);
          for (k = 0; k < referenceTemplateLength; k++) {
            referenceTemplateX[k] = referenceTemplate[k].x;
            referenceTemplateY[k] = referenceTemplate[k].y;
          }
          var referenceWidth = referenceBitmap[0].length;
          var referenceHeight = referenceBitmap.length;
          var pseudoPixelContext = RefinementReusedContexts[templateIndex];
          var bitmap = [];
          var decoder = decodingContext.decoder;
          var contexts = decodingContext.contextCache.getContexts("GR");
          var ltp = 0;
          for (var i = 0; i < height; i++) {
            if (prediction) {
              var sltp = decoder.readBit(contexts, pseudoPixelContext);
              ltp ^= sltp;
              if (ltp) {
                throw new Jbig2Error("prediction is not supported");
              }
            }
            var row = new Uint8Array(width);
            bitmap.push(row);
            for (var j = 0; j < width; j++) {
              var i0, j0;
              var contextLabel = 0;
              for (k = 0; k < codingTemplateLength; k++) {
                i0 = i + codingTemplateY[k];
                j0 = j + codingTemplateX[k];
                if (i0 < 0 || j0 < 0 || j0 >= width) {
                  contextLabel <<= 1;
                } else {
                  contextLabel = contextLabel << 1 | bitmap[i0][j0];
                }
              }
              for (k = 0; k < referenceTemplateLength; k++) {
                i0 = i + referenceTemplateY[k] - offsetY;
                j0 = j + referenceTemplateX[k] - offsetX;
                if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) {
                  contextLabel <<= 1;
                } else {
                  contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
                }
              }
              var pixel = decoder.readBit(contexts, contextLabel);
              row[j] = pixel;
            }
          }
          return bitmap;
        }
        function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext) {
          if (huffman) {
            throw new Jbig2Error("huffman is not supported");
          }
          var newSymbols = [];
          var currentHeight = 0;
          var symbolCodeLength = (0, _util.log2)(symbols.length + numberOfNewSymbols);
          var decoder = decodingContext.decoder;
          var contextCache = decodingContext.contextCache;
          while (newSymbols.length < numberOfNewSymbols) {
            var deltaHeight = decodeInteger(contextCache, "IADH", decoder);
            currentHeight += deltaHeight;
            var currentWidth = 0;
            while (true) {
              var deltaWidth = decodeInteger(contextCache, "IADW", decoder);
              if (deltaWidth === null) {
                break;
              }
              currentWidth += deltaWidth;
              var bitmap;
              if (refinement) {
                var numberOfInstances = decodeInteger(contextCache, "IAAI", decoder);
                if (numberOfInstances > 1) {
                  bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext);
                } else {
                  var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
                  var rdx = decodeInteger(contextCache, "IARDX", decoder);
                  var rdy = decodeInteger(contextCache, "IARDY", decoder);
                  var symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
                  bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
                }
              } else {
                bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
              }
              newSymbols.push(bitmap);
            }
          }
          var exportedSymbols = [];
          var flags = [],
            currentFlag = false;
          var totalSymbolsLength = symbols.length + numberOfNewSymbols;
          while (flags.length < totalSymbolsLength) {
            var runLength = decodeInteger(contextCache, "IAEX", decoder);
            while (runLength--) {
              flags.push(currentFlag);
            }
            currentFlag = !currentFlag;
          }
          for (var i = 0, ii = symbols.length; i < ii; i++) {
            if (flags[i]) {
              exportedSymbols.push(symbols[i]);
            }
          }
          for (var j = 0; j < numberOfNewSymbols; i++, j++) {
            if (flags[i]) {
              exportedSymbols.push(newSymbols[j]);
            }
          }
          return exportedSymbols;
        }
        function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext) {
          if (huffman) {
            throw new Jbig2Error("huffman is not supported");
          }
          var bitmap = [];
          var i, row;
          for (i = 0; i < height; i++) {
            row = new Uint8Array(width);
            if (defaultPixelValue) {
              for (var j = 0; j < width; j++) {
                row[j] = defaultPixelValue;
              }
            }
            bitmap.push(row);
          }
          var decoder = decodingContext.decoder;
          var contextCache = decodingContext.contextCache;
          var stripT = -decodeInteger(contextCache, "IADT", decoder);
          var firstS = 0;
          i = 0;
          while (i < numberOfSymbolInstances) {
            var deltaT = decodeInteger(contextCache, "IADT", decoder);
            stripT += deltaT;
            var deltaFirstS = decodeInteger(contextCache, "IAFS", decoder);
            firstS += deltaFirstS;
            var currentS = firstS;
            do {
              var currentT = stripSize === 1 ? 0 : decodeInteger(contextCache, "IAIT", decoder);
              var t = stripSize * stripT + currentT;
              var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
              var applyRefinement = refinement && decodeInteger(contextCache, "IARI", decoder);
              var symbolBitmap = inputSymbols[symbolId];
              var symbolWidth = symbolBitmap[0].length;
              var symbolHeight = symbolBitmap.length;
              if (applyRefinement) {
                var rdw = decodeInteger(contextCache, "IARDW", decoder);
                var rdh = decodeInteger(contextCache, "IARDH", decoder);
                var rdx = decodeInteger(contextCache, "IARDX", decoder);
                var rdy = decodeInteger(contextCache, "IARDY", decoder);
                symbolWidth += rdw;
                symbolHeight += rdh;
                symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
              }
              var offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight - 1);
              var offsetS = currentS - (referenceCorner & 2 ? symbolWidth - 1 : 0);
              var s2, t2, symbolRow;
              if (transposed) {
                for (s2 = 0; s2 < symbolHeight; s2++) {
                  row = bitmap[offsetS + s2];
                  if (!row) {
                    continue;
                  }
                  symbolRow = symbolBitmap[s2];
                  var maxWidth = Math.min(width - offsetT, symbolWidth);
                  switch (combinationOperator) {
                    case 0:
                      for (t2 = 0; t2 < maxWidth; t2++) {
                        row[offsetT + t2] |= symbolRow[t2];
                      }
                      break;
                    case 2:
                      for (t2 = 0; t2 < maxWidth; t2++) {
                        row[offsetT + t2] ^= symbolRow[t2];
                      }
                      break;
                    default:
                      throw new Jbig2Error("operator " + combinationOperator + " is not supported");
                  }
                }
                currentS += symbolHeight - 1;
              } else {
                for (t2 = 0; t2 < symbolHeight; t2++) {
                  row = bitmap[offsetT + t2];
                  if (!row) {
                    continue;
                  }
                  symbolRow = symbolBitmap[t2];
                  switch (combinationOperator) {
                    case 0:
                      for (s2 = 0; s2 < symbolWidth; s2++) {
                        row[offsetS + s2] |= symbolRow[s2];
                      }
                      break;
                    case 2:
                      for (s2 = 0; s2 < symbolWidth; s2++) {
                        row[offsetS + s2] ^= symbolRow[s2];
                      }
                      break;
                    default:
                      throw new Jbig2Error("operator " + combinationOperator + " is not supported");
                  }
                }
                currentS += symbolWidth - 1;
              }
              i++;
              var deltaS = decodeInteger(contextCache, "IADS", decoder);
              if (deltaS === null) {
                break;
              }
              currentS += deltaS + dsOffset;
            } while (true);
          }
          return bitmap;
        }
        function decodePatternDictionary(mmr, patternWidth, patternHeight, maxPatternIndex, template, decodingContext) {
          var at = [];
          at.push({
            x: -patternWidth,
            y: 0
          });
          if (template === 0) {
            at.push({
              x: -3,
              y: -1
            });
            at.push({
              x: 2,
              y: -2
            });
            at.push({
              x: -2,
              y: -2
            });
          }
          var collectiveWidth = (maxPatternIndex + 1) * patternWidth;
          var collectiveBitmap = decodeBitmap(mmr, collectiveWidth, patternHeight, template, false, null, at, decodingContext);
          var patterns = [],
            i = 0,
            patternBitmap = void 0,
            xMin = void 0,
            xMax = void 0,
            y = void 0;
          while (i <= maxPatternIndex) {
            patternBitmap = [];
            xMin = patternWidth * i;
            xMax = xMin + patternWidth;
            for (y = 0; y < patternHeight; y++) {
              patternBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
            }
            patterns.push(patternBitmap);
            i++;
          }
          return patterns;
        }
        function decodeHalftoneRegion(mmr, patterns, template, regionWidth, regionHeight, defaultPixelValue, enableSkip, combinationOperator, gridWidth, gridHeight, gridOffsetX, gridOffsetY, gridVectorX, gridVectorY, decodingContext) {
          var skip = null;
          if (enableSkip) {
            throw new Jbig2Error("skip is not supported");
          }
          if (combinationOperator !== 0) {
            throw new Jbig2Error("operator " + combinationOperator + " is not supported in halftone region");
          }
          var regionBitmap = [];
          var i = void 0,
            j = void 0,
            row = void 0;
          for (i = 0; i < regionHeight; i++) {
            row = new Uint8Array(regionWidth);
            if (defaultPixelValue) {
              for (j = 0; j < regionWidth; j++) {
                row[j] = defaultPixelValue;
              }
            }
            regionBitmap.push(row);
          }
          var numberOfPatterns = patterns.length;
          var pattern0 = patterns[0];
          var patternWidth = pattern0[0].length,
            patternHeight = pattern0.length;
          var bitsPerValue = (0, _util.log2)(numberOfPatterns);
          var at = [];
          at.push({
            x: template <= 1 ? 3 : 2,
            y: -1
          });
          if (template === 0) {
            at.push({
              x: -3,
              y: -1
            });
            at.push({
              x: 2,
              y: -2
            });
            at.push({
              x: -2,
              y: -2
            });
          }
          var grayScaleBitPlanes = [];
          for (i = bitsPerValue - 1; i >= 0; i--) {
            grayScaleBitPlanes[i] = decodeBitmap(mmr, gridWidth, gridHeight, template, false, skip, at, decodingContext);
          }
          var mg = void 0,
            ng = void 0,
            bit = void 0,
            patternIndex = void 0,
            patternBitmap = void 0,
            x = void 0,
            y = void 0,
            patternRow = void 0,
            regionRow = void 0;
          for (mg = 0; mg < gridHeight; mg++) {
            for (ng = 0; ng < gridWidth; ng++) {
              bit = 0;
              patternIndex = 0;
              for (j = bitsPerValue - 1; j >= 0; j--) {
                bit = grayScaleBitPlanes[j][mg][ng] ^ bit;
                patternIndex |= bit << j;
              }
              patternBitmap = patterns[patternIndex];
              x = gridOffsetX + mg * gridVectorY + ng * gridVectorX >> 8;
              y = gridOffsetY + mg * gridVectorX - ng * gridVectorY >> 8;
              if (x >= 0 && x + patternWidth <= regionWidth && y >= 0 && y + patternHeight <= regionHeight) {
                for (i = 0; i < patternHeight; i++) {
                  regionRow = regionBitmap[y + i];
                  patternRow = patternBitmap[i];
                  for (j = 0; j < patternWidth; j++) {
                    regionRow[x + j] |= patternRow[j];
                  }
                }
              } else {
                var regionX = void 0,
                  regionY = void 0;
                for (i = 0; i < patternHeight; i++) {
                  regionY = y + i;
                  if (regionY < 0 || regionY >= regionHeight) {
                    continue;
                  }
                  regionRow = regionBitmap[regionY];
                  patternRow = patternBitmap[i];
                  for (j = 0; j < patternWidth; j++) {
                    regionX = x + j;
                    if (regionX >= 0 && regionX < regionWidth) {
                      regionRow[regionX] |= patternRow[j];
                    }
                  }
                }
              }
            }
          }
          return regionBitmap;
        }
        function readSegmentHeader(data, start) {
          var segmentHeader = {};
          segmentHeader.number = (0, _util.readUint32)(data, start);
          var flags = data[start + 4];
          var segmentType = flags & 0x3F;
          if (!SegmentTypes[segmentType]) {
            throw new Jbig2Error("invalid segment type: " + segmentType);
          }
          segmentHeader.type = segmentType;
          segmentHeader.typeName = SegmentTypes[segmentType];
          segmentHeader.deferredNonRetain = !!(flags & 0x80);
          var pageAssociationFieldSize = !!(flags & 0x40);
          var referredFlags = data[start + 5];
          var referredToCount = referredFlags >> 5 & 7;
          var retainBits = [referredFlags & 31];
          var position = start + 6;
          if (referredFlags === 7) {
            referredToCount = (0, _util.readUint32)(data, position - 1) & 0x1FFFFFFF;
            position += 3;
            var bytes = referredToCount + 7 >> 3;
            retainBits[0] = data[position++];
            while (--bytes > 0) {
              retainBits.push(data[position++]);
            }
          } else if (referredFlags === 5 || referredFlags === 6) {
            throw new Jbig2Error("invalid referred-to flags");
          }
          segmentHeader.retainBits = retainBits;
          var referredToSegmentNumberSize = segmentHeader.number <= 256 ? 1 : segmentHeader.number <= 65536 ? 2 : 4;
          var referredTo = [];
          var i, ii;
          for (i = 0; i < referredToCount; i++) {
            var number = referredToSegmentNumberSize === 1 ? data[position] : referredToSegmentNumberSize === 2 ? (0, _util.readUint16)(data, position) : (0, _util.readUint32)(data, position);
            referredTo.push(number);
            position += referredToSegmentNumberSize;
          }
          segmentHeader.referredTo = referredTo;
          if (!pageAssociationFieldSize) {
            segmentHeader.pageAssociation = data[position++];
          } else {
            segmentHeader.pageAssociation = (0, _util.readUint32)(data, position);
            position += 4;
          }
          segmentHeader.length = (0, _util.readUint32)(data, position);
          position += 4;
          if (segmentHeader.length === 0xFFFFFFFF) {
            if (segmentType === 38) {
              var genericRegionInfo = readRegionSegmentInformation(data, position);
              var genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
              var genericRegionMmr = !!(genericRegionSegmentFlags & 1);
              var searchPatternLength = 6;
              var searchPattern = new Uint8Array(searchPatternLength);
              if (!genericRegionMmr) {
                searchPattern[0] = 0xFF;
                searchPattern[1] = 0xAC;
              }
              searchPattern[2] = genericRegionInfo.height >>> 24 & 0xFF;
              searchPattern[3] = genericRegionInfo.height >> 16 & 0xFF;
              searchPattern[4] = genericRegionInfo.height >> 8 & 0xFF;
              searchPattern[5] = genericRegionInfo.height & 0xFF;
              for (i = position, ii = data.length; i < ii; i++) {
                var j = 0;
                while (j < searchPatternLength && searchPattern[j] === data[i + j]) {
                  j++;
                }
                if (j === searchPatternLength) {
                  segmentHeader.length = i + searchPatternLength;
                  break;
                }
              }
              if (segmentHeader.length === 0xFFFFFFFF) {
                throw new Jbig2Error("segment end was not found");
              }
            } else {
              throw new Jbig2Error("invalid unknown segment length");
            }
          }
          segmentHeader.headerEnd = position;
          return segmentHeader;
        }
        function readSegments(header, data, start, end) {
          var segments = [];
          var position = start;
          while (position < end) {
            var segmentHeader = readSegmentHeader(data, position);
            position = segmentHeader.headerEnd;
            var segment = {
              header: segmentHeader,
              data: data
            };
            if (!header.randomAccess) {
              segment.start = position;
              position += segmentHeader.length;
              segment.end = position;
            }
            segments.push(segment);
            if (segmentHeader.type === 51) {
              break;
            }
          }
          if (header.randomAccess) {
            for (var i = 0, ii = segments.length; i < ii; i++) {
              segments[i].start = position;
              position += segments[i].header.length;
              segments[i].end = position;
            }
          }
          return segments;
        }
        function readRegionSegmentInformation(data, start) {
          return {
            width: (0, _util.readUint32)(data, start),
            height: (0, _util.readUint32)(data, start + 4),
            x: (0, _util.readUint32)(data, start + 8),
            y: (0, _util.readUint32)(data, start + 12),
            combinationOperator: data[start + 16] & 7
          };
        }
        var RegionSegmentInformationFieldLength = 17;
        function processSegment(segment, visitor) {
          var header = segment.header;
          var data = segment.data,
            position = segment.start,
            end = segment.end;
          var args, at, i, atLength;
          switch (header.type) {
            case 0:
              var dictionary = {};
              var dictionaryFlags = (0, _util.readUint16)(data, position);
              dictionary.huffman = !!(dictionaryFlags & 1);
              dictionary.refinement = !!(dictionaryFlags & 2);
              dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
              dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
              dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
              dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
              dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
              dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
              dictionary.template = dictionaryFlags >> 10 & 3;
              dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
              position += 2;
              if (!dictionary.huffman) {
                atLength = dictionary.template === 0 ? 4 : 1;
                at = [];
                for (i = 0; i < atLength; i++) {
                  at.push({
                    x: (0, _util.readInt8)(data, position),
                    y: (0, _util.readInt8)(data, position + 1)
                  });
                  position += 2;
                }
                dictionary.at = at;
              }
              if (dictionary.refinement && !dictionary.refinementTemplate) {
                at = [];
                for (i = 0; i < 2; i++) {
                  at.push({
                    x: (0, _util.readInt8)(data, position),
                    y: (0, _util.readInt8)(data, position + 1)
                  });
                  position += 2;
                }
                dictionary.refinementAt = at;
              }
              dictionary.numberOfExportedSymbols = (0, _util.readUint32)(data, position);
              position += 4;
              dictionary.numberOfNewSymbols = (0, _util.readUint32)(data, position);
              position += 4;
              args = [dictionary, header.number, header.referredTo, data, position, end];
              break;
            case 6:
            case 7:
              var textRegion = {};
              textRegion.info = readRegionSegmentInformation(data, position);
              position += RegionSegmentInformationFieldLength;
              var textRegionSegmentFlags = (0, _util.readUint16)(data, position);
              position += 2;
              textRegion.huffman = !!(textRegionSegmentFlags & 1);
              textRegion.refinement = !!(textRegionSegmentFlags & 2);
              textRegion.stripSize = 1 << (textRegionSegmentFlags >> 2 & 3);
              textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
              textRegion.transposed = !!(textRegionSegmentFlags & 64);
              textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
              textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
              textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
              textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
              if (textRegion.huffman) {
                var textRegionHuffmanFlags = (0, _util.readUint16)(data, position);
                position += 2;
                textRegion.huffmanFS = textRegionHuffmanFlags & 3;
                textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
                textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
                textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
                textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
                textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
                textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
                textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 14);
              }
              if (textRegion.refinement && !textRegion.refinementTemplate) {
                at = [];
                for (i = 0; i < 2; i++) {
                  at.push({
                    x: (0, _util.readInt8)(data, position),
                    y: (0, _util.readInt8)(data, position + 1)
                  });
                  position += 2;
                }
                textRegion.refinementAt = at;
              }
              textRegion.numberOfSymbolInstances = (0, _util.readUint32)(data, position);
              position += 4;
              if (textRegion.huffman) {
                throw new Jbig2Error("huffman is not supported");
              }
              args = [textRegion, header.referredTo, data, position, end];
              break;
            case 16:
              var patternDictionary = {};
              var patternDictionaryFlags = data[position++];
              patternDictionary.mmr = !!(patternDictionaryFlags & 1);
              patternDictionary.template = patternDictionaryFlags >> 1 & 3;
              patternDictionary.patternWidth = data[position++];
              patternDictionary.patternHeight = data[position++];
              patternDictionary.maxPatternIndex = (0, _util.readUint32)(data, position);
              position += 4;
              args = [patternDictionary, header.number, data, position, end];
              break;
            case 22:
            case 23:
              var halftoneRegion = {};
              halftoneRegion.info = readRegionSegmentInformation(data, position);
              position += RegionSegmentInformationFieldLength;
              var halftoneRegionFlags = data[position++];
              halftoneRegion.mmr = !!(halftoneRegionFlags & 1);
              halftoneRegion.template = halftoneRegionFlags >> 1 & 3;
              halftoneRegion.enableSkip = !!(halftoneRegionFlags & 8);
              halftoneRegion.combinationOperator = halftoneRegionFlags >> 4 & 7;
              halftoneRegion.defaultPixelValue = halftoneRegionFlags >> 7 & 1;
              halftoneRegion.gridWidth = (0, _util.readUint32)(data, position);
              position += 4;
              halftoneRegion.gridHeight = (0, _util.readUint32)(data, position);
              position += 4;
              halftoneRegion.gridOffsetX = (0, _util.readUint32)(data, position) & 0xFFFFFFFF;
              position += 4;
              halftoneRegion.gridOffsetY = (0, _util.readUint32)(data, position) & 0xFFFFFFFF;
              position += 4;
              halftoneRegion.gridVectorX = (0, _util.readUint16)(data, position);
              position += 2;
              halftoneRegion.gridVectorY = (0, _util.readUint16)(data, position);
              position += 2;
              args = [halftoneRegion, header.referredTo, data, position, end];
              break;
            case 38:
            case 39:
              var genericRegion = {};
              genericRegion.info = readRegionSegmentInformation(data, position);
              position += RegionSegmentInformationFieldLength;
              var genericRegionSegmentFlags = data[position++];
              genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
              genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
              genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
              if (!genericRegion.mmr) {
                atLength = genericRegion.template === 0 ? 4 : 1;
                at = [];
                for (i = 0; i < atLength; i++) {
                  at.push({
                    x: (0, _util.readInt8)(data, position),
                    y: (0, _util.readInt8)(data, position + 1)
                  });
                  position += 2;
                }
                genericRegion.at = at;
              }
              args = [genericRegion, data, position, end];
              break;
            case 48:
              var pageInfo = {
                width: (0, _util.readUint32)(data, position),
                height: (0, _util.readUint32)(data, position + 4),
                resolutionX: (0, _util.readUint32)(data, position + 8),
                resolutionY: (0, _util.readUint32)(data, position + 12)
              };
              if (pageInfo.height === 0xFFFFFFFF) {
                delete pageInfo.height;
              }
              var pageSegmentFlags = data[position + 16];
              (0, _util.readUint16)(data, position + 17);
              pageInfo.lossless = !!(pageSegmentFlags & 1);
              pageInfo.refinement = !!(pageSegmentFlags & 2);
              pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
              pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
              pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
              pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
              args = [pageInfo];
              break;
            case 49:
              break;
            case 50:
              break;
            case 51:
              break;
            case 62:
              break;
            default:
              throw new Jbig2Error("segment type " + header.typeName + "(" + header.type + ")" + " is not implemented");
          }
          var callbackName = "on" + header.typeName;
          if (callbackName in visitor) {
            visitor[callbackName].apply(visitor, args);
          }
        }
        function processSegments(segments, visitor) {
          for (var i = 0, ii = segments.length; i < ii; i++) {
            processSegment(segments[i], visitor);
          }
        }
        function parseJbig2(data, start, end) {
          var position = start;
          if (data[position] !== 0x97 || data[position + 1] !== 0x4A || data[position + 2] !== 0x42 || data[position + 3] !== 0x32 || data[position + 4] !== 0x0D || data[position + 5] !== 0x0A || data[position + 6] !== 0x1A || data[position + 7] !== 0x0A) {
            throw new Jbig2Error("invalid header");
          }
          var header = {};
          position += 8;
          var flags = data[position++];
          header.randomAccess = !(flags & 1);
          if (!(flags & 2)) {
            header.numberOfPages = (0, _util.readUint32)(data, position);
            position += 4;
          }
          readSegments(header, data, position, end);
          throw new Error("Not implemented");
        }
        function parseJbig2Chunks(chunks) {
          var visitor = new SimpleSegmentVisitor();
          for (var i = 0, ii = chunks.length; i < ii; i++) {
            var chunk = chunks[i];
            var segments = readSegments({}, chunk.data, chunk.start, chunk.end);
            processSegments(segments, visitor);
          }
          return visitor.buffer;
        }
        function SimpleSegmentVisitor() {}
        SimpleSegmentVisitor.prototype = {
          onPageInformation: function SimpleSegmentVisitor_onPageInformation(info) {
            this.currentPageInfo = info;
            var rowSize = info.width + 7 >> 3;
            var buffer = new Uint8ClampedArray(rowSize * info.height);
            if (info.defaultPixelValue) {
              for (var i = 0, ii = buffer.length; i < ii; i++) {
                buffer[i] = 0xFF;
              }
            }
            this.buffer = buffer;
          },
          drawBitmap: function SimpleSegmentVisitor_drawBitmap(regionInfo, bitmap) {
            var pageInfo = this.currentPageInfo;
            var width = regionInfo.width,
              height = regionInfo.height;
            var rowSize = pageInfo.width + 7 >> 3;
            var combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
            var buffer = this.buffer;
            var mask0 = 128 >> (regionInfo.x & 7);
            var offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
            var i, j, mask, offset;
            switch (combinationOperator) {
              case 0:
                for (i = 0; i < height; i++) {
                  mask = mask0;
                  offset = offset0;
                  for (j = 0; j < width; j++) {
                    if (bitmap[i][j]) {
                      buffer[offset] |= mask;
                    }
                    mask >>= 1;
                    if (!mask) {
                      mask = 128;
                      offset++;
                    }
                  }
                  offset0 += rowSize;
                }
                break;
              case 2:
                for (i = 0; i < height; i++) {
                  mask = mask0;
                  offset = offset0;
                  for (j = 0; j < width; j++) {
                    if (bitmap[i][j]) {
                      buffer[offset] ^= mask;
                    }
                    mask >>= 1;
                    if (!mask) {
                      mask = 128;
                      offset++;
                    }
                  }
                  offset0 += rowSize;
                }
                break;
              default:
                throw new Jbig2Error("operator " + combinationOperator + " is not supported");
            }
          },
          onImmediateGenericRegion: function SimpleSegmentVisitor_onImmediateGenericRegion(region, data, start, end) {
            var regionInfo = region.info;
            var decodingContext = new DecodingContext(data, start, end);
            var bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
            this.drawBitmap(regionInfo, bitmap);
          },
          onImmediateLosslessGenericRegion: function SimpleSegmentVisitor_onImmediateLosslessGenericRegion() {
            this.onImmediateGenericRegion.apply(this, arguments);
          },
          onSymbolDictionary: function SimpleSegmentVisitor_onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
            var huffmanTables;
            if (dictionary.huffman) {
              throw new Jbig2Error("huffman is not supported");
            }
            var symbols = this.symbols;
            if (!symbols) {
              this.symbols = symbols = {};
            }
            var inputSymbols = [];
            for (var i = 0, ii = referredSegments.length; i < ii; i++) {
              inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
            }
            var decodingContext = new DecodingContext(data, start, end);
            symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext);
          },
          onImmediateTextRegion: function SimpleSegmentVisitor_onImmediateTextRegion(region, referredSegments, data, start, end) {
            var regionInfo = region.info;
            var huffmanTables;
            var symbols = this.symbols;
            var inputSymbols = [];
            for (var i = 0, ii = referredSegments.length; i < ii; i++) {
              inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
            }
            var symbolCodeLength = (0, _util.log2)(inputSymbols.length);
            var decodingContext = new DecodingContext(data, start, end);
            var bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext);
            this.drawBitmap(regionInfo, bitmap);
          },
          onImmediateLosslessTextRegion: function SimpleSegmentVisitor_onImmediateLosslessTextRegion() {
            this.onImmediateTextRegion.apply(this, arguments);
          },
          onPatternDictionary: function onPatternDictionary(dictionary, currentSegment, data, start, end) {
            var patterns = this.patterns;
            if (!patterns) {
              this.patterns = patterns = {};
            }
            var decodingContext = new DecodingContext(data, start, end);
            patterns[currentSegment] = decodePatternDictionary(dictionary.mmr, dictionary.patternWidth, dictionary.patternHeight, dictionary.maxPatternIndex, dictionary.template, decodingContext);
          },
          onImmediateHalftoneRegion: function onImmediateHalftoneRegion(region, referredSegments, data, start, end) {
            var patterns = this.patterns[referredSegments[0]];
            var regionInfo = region.info;
            var decodingContext = new DecodingContext(data, start, end);
            var bitmap = decodeHalftoneRegion(region.mmr, patterns, region.template, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.enableSkip, region.combinationOperator, region.gridWidth, region.gridHeight, region.gridOffsetX, region.gridOffsetY, region.gridVectorX, region.gridVectorY, decodingContext);
            this.drawBitmap(regionInfo, bitmap);
          },
          onImmediateLosslessHalftoneRegion: function onImmediateLosslessHalftoneRegion() {
            this.onImmediateHalftoneRegion.apply(this, arguments);
          }
        };
        function Jbig2Image() {}
        Jbig2Image.prototype = {
          parseChunks: function Jbig2Image_parseChunks(chunks) {
            return parseJbig2Chunks(chunks);
          }
        };
        return Jbig2Image;
      }();
      exports.Jbig2Image = Jbig2Image;

      /***/ }),
    /* 133 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.CMapFactory = exports.IdentityCMap = exports.CMap = undefined;

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var _parser = __w_pdfjs_require__(34);

      var _stream = __w_pdfjs_require__(5);

      var BUILT_IN_CMAPS = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"];
      var CMap = function CMapClosure() {
        function CMap(builtInCMap) {
          this.codespaceRanges = [[], [], [], []];
          this.numCodespaceRanges = 0;
          this._map = [];
          this.name = "";
          this.vertical = false;
          this.useCMap = null;
          this.builtInCMap = builtInCMap;
        }
        CMap.prototype = {
          addCodespaceRange: function addCodespaceRange(n, low, high) {
            this.codespaceRanges[n - 1].push(low, high);
            this.numCodespaceRanges++;
          },
          mapCidRange: function mapCidRange(low, high, dstLow) {
            while (low <= high) {
              this._map[low++] = dstLow++;
            }
          },
          mapBfRange: function mapBfRange(low, high, dstLow) {
            var lastByte = dstLow.length - 1;
            while (low <= high) {
              this._map[low++] = dstLow;
              dstLow = dstLow.substr(0, lastByte) + String.fromCharCode(dstLow.charCodeAt(lastByte) + 1);
            }
          },
          mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
            var i = 0,
              ii = array.length;
            while (low <= high && i < ii) {
              this._map[low] = array[i++];
              ++low;
            }
          },
          mapOne: function mapOne(src, dst) {
            this._map[src] = dst;
          },
          lookup: function lookup(code) {
            return this._map[code];
          },
          contains: function contains(code) {
            return this._map[code] !== undefined;
          },
          forEach: function forEach(callback) {
            var map = this._map;
            var length = map.length;
            if (length <= 0x10000) {
              for (var i = 0; i < length; i++) {
                if (map[i] !== undefined) {
                  callback(i, map[i]);
                }
              }
            } else {
              for (var _i in map) {
                callback(_i, map[_i]);
              }
            }
          },
          charCodeOf: function charCodeOf(value) {
            var map = this._map;
            if (map.length <= 0x10000) {
              return map.indexOf(value);
            }
            for (var charCode in map) {
              if (map[charCode] === value) {
                return charCode | 0;
              }
            }
            return -1;
          },
          getMap: function getMap() {
            return this._map;
          },
          readCharCode: function readCharCode(str, offset, out) {
            var c = 0;
            var codespaceRanges = this.codespaceRanges;
            var codespaceRangesLen = this.codespaceRanges.length;
            for (var n = 0; n < codespaceRangesLen; n++) {
              c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
              var codespaceRange = codespaceRanges[n];
              for (var k = 0, kk = codespaceRange.length; k < kk;) {
                var low = codespaceRange[k++];
                var high = codespaceRange[k++];
                if (c >= low && c <= high) {
                  out.charcode = c;
                  out.length = n + 1;
                  return;
                }
              }
            }
            out.charcode = 0;
            out.length = 1;
          },

          get length() {
            return this._map.length;
          },
          get isIdentityCMap() {
            if (!(this.name === "Identity-H" || this.name === "Identity-V")) {
              return false;
            }
            if (this._map.length !== 0x10000) {
              return false;
            }
            for (var i = 0; i < 0x10000; i++) {
              if (this._map[i] !== i) {
                return false;
              }
            }
            return true;
          }
        };
        return CMap;
      }();
      var IdentityCMap = function IdentityCMapClosure() {
        function IdentityCMap(vertical, n) {
          CMap.call(this);
          this.vertical = vertical;
          this.addCodespaceRange(n, 0, 0xffff);
        }
        _util.Util.inherit(IdentityCMap, CMap, {});
        IdentityCMap.prototype = {
          addCodespaceRange: CMap.prototype.addCodespaceRange,
          mapCidRange: function mapCidRange(low, high, dstLow) {
            throw new Error("should not call mapCidRange");
          },
          mapBfRange: function mapBfRange(low, high, dstLow) {
            throw new Error("should not call mapBfRange");
          },
          mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
            throw new Error("should not call mapBfRangeToArray");
          },
          mapOne: function mapOne(src, dst) {
            throw new Error("should not call mapCidOne");
          },
          lookup: function lookup(code) {
            return Number.isInteger(code) && code <= 0xffff ? code : undefined;
          },
          contains: function contains(code) {
            return Number.isInteger(code) && code <= 0xffff;
          },
          forEach: function forEach(callback) {
            for (var i = 0; i <= 0xffff; i++) {
              callback(i, i);
            }
          },
          charCodeOf: function charCodeOf(value) {
            return Number.isInteger(value) && value <= 0xffff ? value : -1;
          },
          getMap: function getMap() {
            var map = new Array(0x10000);
            for (var i = 0; i <= 0xffff; i++) {
              map[i] = i;
            }
            return map;
          },

          readCharCode: CMap.prototype.readCharCode,
          get length() {
            return 0x10000;
          },
          get isIdentityCMap() {
            throw new Error("should not access .isIdentityCMap");
          }
        };
        return IdentityCMap;
      }();
      var BinaryCMapReader = function BinaryCMapReaderClosure() {
        function hexToInt(a, size) {
          var n = 0;
          for (var i = 0; i <= size; i++) {
            n = n << 8 | a[i];
          }
          return n >>> 0;
        }
        function hexToStr(a, size) {
          if (size === 1) {
            return String.fromCharCode(a[0], a[1]);
          }
          if (size === 3) {
            return String.fromCharCode(a[0], a[1], a[2], a[3]);
          }
          return String.fromCharCode.apply(null, a.subarray(0, size + 1));
        }
        function addHex(a, b, size) {
          var c = 0;
          for (var i = size; i >= 0; i--) {
            c += a[i] + b[i];
            a[i] = c & 255;
            c >>= 8;
          }
        }
        function incHex(a, size) {
          var c = 1;
          for (var i = size; i >= 0 && c > 0; i--) {
            c += a[i];
            a[i] = c & 255;
            c >>= 8;
          }
        }
        var MAX_NUM_SIZE = 16;
        var MAX_ENCODED_NUM_SIZE = 19;
        function BinaryCMapStream(data) {
          this.buffer = data;
          this.pos = 0;
          this.end = data.length;
          this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
        }
        BinaryCMapStream.prototype = {
          readByte: function readByte() {
            if (this.pos >= this.end) {
              return -1;
            }
            return this.buffer[this.pos++];
          },
          readNumber: function readNumber() {
            var n = 0;
            var last;
            do {
              var b = this.readByte();
              if (b < 0) {
                throw new _util.FormatError("unexpected EOF in bcmap");
              }
              last = !(b & 0x80);
              n = n << 7 | b & 0x7F;
            } while (!last);
            return n;
          },
          readSigned: function readSigned() {
            var n = this.readNumber();
            return n & 1 ? ~(n >>> 1) : n >>> 1;
          },
          readHex: function readHex(num, size) {
            num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
            this.pos += size + 1;
          },
          readHexNumber: function readHexNumber(num, size) {
            var last;
            var stack = this.tmpBuf,
              sp = 0;
            do {
              var b = this.readByte();
              if (b < 0) {
                throw new _util.FormatError("unexpected EOF in bcmap");
              }
              last = !(b & 0x80);
              stack[sp++] = b & 0x7F;
            } while (!last);
            var i = size,
              buffer = 0,
              bufferSize = 0;
            while (i >= 0) {
              while (bufferSize < 8 && stack.length > 0) {
                buffer = stack[--sp] << bufferSize | buffer;
                bufferSize += 7;
              }
              num[i] = buffer & 255;
              i--;
              buffer >>= 8;
              bufferSize -= 8;
            }
          },
          readHexSigned: function readHexSigned(num, size) {
            this.readHexNumber(num, size);
            var sign = num[size] & 1 ? 255 : 0;
            var c = 0;
            for (var i = 0; i <= size; i++) {
              c = (c & 1) << 8 | num[i];
              num[i] = c >> 1 ^ sign;
            }
          },
          readString: function readString() {
            var len = this.readNumber();
            var s = "";
            for (var i = 0; i < len; i++) {
              s += String.fromCharCode(this.readNumber());
            }
            return s;
          }
        };
        function processBinaryCMap(data, cMap, extend) {
          return new Promise(function (resolve, reject) {
            var stream = new BinaryCMapStream(data);
            var header = stream.readByte();
            cMap.vertical = !!(header & 1);
            var useCMap = null;
            var start = new Uint8Array(MAX_NUM_SIZE);
            var end = new Uint8Array(MAX_NUM_SIZE);
            var char = new Uint8Array(MAX_NUM_SIZE);
            var charCode = new Uint8Array(MAX_NUM_SIZE);
            var tmp = new Uint8Array(MAX_NUM_SIZE);
            var code;
            var b;
            while ((b = stream.readByte()) >= 0) {
              var type = b >> 5;
              if (type === 7) {
                switch (b & 0x1F) {
                  case 0:
                    stream.readString();
                    break;
                  case 1:
                    useCMap = stream.readString();
                    break;
                }
                continue;
              }
              var sequence = !!(b & 0x10);
              var dataSize = b & 15;
              if (dataSize + 1 > MAX_NUM_SIZE) {
                throw new Error("processBinaryCMap: Invalid dataSize.");
              }
              var ucs2DataSize = 1;
              var subitemsCount = stream.readNumber();
              var i;
              switch (type) {
                case 0:
                  stream.readHex(start, dataSize);
                  stream.readHexNumber(end, dataSize);
                  addHex(end, start, dataSize);
                  cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                  for (i = 1; i < subitemsCount; i++) {
                    incHex(end, dataSize);
                    stream.readHexNumber(start, dataSize);
                    addHex(start, end, dataSize);
                    stream.readHexNumber(end, dataSize);
                    addHex(end, start, dataSize);
                    cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                  }
                  break;
                case 1:
                  stream.readHex(start, dataSize);
                  stream.readHexNumber(end, dataSize);
                  addHex(end, start, dataSize);
                  code = stream.readNumber();
                  for (i = 1; i < subitemsCount; i++) {
                    incHex(end, dataSize);
                    stream.readHexNumber(start, dataSize);
                    addHex(start, end, dataSize);
                    stream.readHexNumber(end, dataSize);
                    addHex(end, start, dataSize);
                    code = stream.readNumber();
                  }
                  break;
                case 2:
                  stream.readHex(char, dataSize);
                  code = stream.readNumber();
                  cMap.mapOne(hexToInt(char, dataSize), code);
                  for (i = 1; i < subitemsCount; i++) {
                    incHex(char, dataSize);
                    if (!sequence) {
                      stream.readHexNumber(tmp, dataSize);
                      addHex(char, tmp, dataSize);
                    }
                    code = stream.readSigned() + (code + 1);
                    cMap.mapOne(hexToInt(char, dataSize), code);
                  }
                  break;
                case 3:
                  stream.readHex(start, dataSize);
                  stream.readHexNumber(end, dataSize);
                  addHex(end, start, dataSize);
                  code = stream.readNumber();
                  cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                  for (i = 1; i < subitemsCount; i++) {
                    incHex(end, dataSize);
                    if (!sequence) {
                      stream.readHexNumber(start, dataSize);
                      addHex(start, end, dataSize);
                    } else {
                      start.set(end);
                    }
                    stream.readHexNumber(end, dataSize);
                    addHex(end, start, dataSize);
                    code = stream.readNumber();
                    cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                  }
                  break;
                case 4:
                  stream.readHex(char, ucs2DataSize);
                  stream.readHex(charCode, dataSize);
                  cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                  for (i = 1; i < subitemsCount; i++) {
                    incHex(char, ucs2DataSize);
                    if (!sequence) {
                      stream.readHexNumber(tmp, ucs2DataSize);
                      addHex(char, tmp, ucs2DataSize);
                    }
                    incHex(charCode, dataSize);
                    stream.readHexSigned(tmp, dataSize);
                    addHex(charCode, tmp, dataSize);
                    cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                  }
                  break;
                case 5:
                  stream.readHex(start, ucs2DataSize);
                  stream.readHexNumber(end, ucs2DataSize);
                  addHex(end, start, ucs2DataSize);
                  stream.readHex(charCode, dataSize);
                  cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                  for (i = 1; i < subitemsCount; i++) {
                    incHex(end, ucs2DataSize);
                    if (!sequence) {
                      stream.readHexNumber(start, ucs2DataSize);
                      addHex(start, end, ucs2DataSize);
                    } else {
                      start.set(end);
                    }
                    stream.readHexNumber(end, ucs2DataSize);
                    addHex(end, start, ucs2DataSize);
                    stream.readHex(charCode, dataSize);
                    cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                  }
                  break;
                default:
                  reject(new Error("processBinaryCMap: Unknown type: " + type));
                  return;
              }
            }
            if (useCMap) {
              resolve(extend(useCMap));
              return;
            }
            resolve(cMap);
          });
        }
        function BinaryCMapReader() {}
        BinaryCMapReader.prototype = { process: processBinaryCMap };
        return BinaryCMapReader;
      }();
      var CMapFactory = function CMapFactoryClosure() {
        function strToInt(str) {
          var a = 0;
          for (var i = 0; i < str.length; i++) {
            a = a << 8 | str.charCodeAt(i);
          }
          return a >>> 0;
        }
        function expectString(obj) {
          if (!(0, _util.isString)(obj)) {
            throw new _util.FormatError("Malformed CMap: expected string.");
          }
        }
        function expectInt(obj) {
          if (!Number.isInteger(obj)) {
            throw new _util.FormatError("Malformed CMap: expected int.");
          }
        }
        function parseBfChar(cMap, lexer) {
          while (true) {
            var obj = lexer.getObj();
            if ((0, _primitives.isEOF)(obj)) {
              break;
            }
            if ((0, _primitives.isCmd)(obj, "endbfchar")) {
              return;
            }
            expectString(obj);
            var src = strToInt(obj);
            obj = lexer.getObj();
            expectString(obj);
            var dst = obj;
            cMap.mapOne(src, dst);
          }
        }
        function parseBfRange(cMap, lexer) {
          while (true) {
            var obj = lexer.getObj();
            if ((0, _primitives.isEOF)(obj)) {
              break;
            }
            if ((0, _primitives.isCmd)(obj, "endbfrange")) {
              return;
            }
            expectString(obj);
            var low = strToInt(obj);
            obj = lexer.getObj();
            expectString(obj);
            var high = strToInt(obj);
            obj = lexer.getObj();
            if (Number.isInteger(obj) || (0, _util.isString)(obj)) {
              var dstLow = Number.isInteger(obj) ? String.fromCharCode(obj) : obj;
              cMap.mapBfRange(low, high, dstLow);
            } else if ((0, _primitives.isCmd)(obj, "[")) {
              obj = lexer.getObj();
              var array = [];
              while (!(0, _primitives.isCmd)(obj, "]") && !(0, _primitives.isEOF)(obj)) {
                array.push(obj);
                obj = lexer.getObj();
              }
              cMap.mapBfRangeToArray(low, high, array);
            } else {
              break;
            }
          }
          throw new _util.FormatError("Invalid bf range.");
        }
        function parseCidChar(cMap, lexer) {
          while (true) {
            var obj = lexer.getObj();
            if ((0, _primitives.isEOF)(obj)) {
              break;
            }
            if ((0, _primitives.isCmd)(obj, "endcidchar")) {
              return;
            }
            expectString(obj);
            var src = strToInt(obj);
            obj = lexer.getObj();
            expectInt(obj);
            var dst = obj;
            cMap.mapOne(src, dst);
          }
        }
        function parseCidRange(cMap, lexer) {
          while (true) {
            var obj = lexer.getObj();
            if ((0, _primitives.isEOF)(obj)) {
              break;
            }
            if ((0, _primitives.isCmd)(obj, "endcidrange")) {
              return;
            }
            expectString(obj);
            var low = strToInt(obj);
            obj = lexer.getObj();
            expectString(obj);
            var high = strToInt(obj);
            obj = lexer.getObj();
            expectInt(obj);
            var dstLow = obj;
            cMap.mapCidRange(low, high, dstLow);
          }
        }
        function parseCodespaceRange(cMap, lexer) {
          while (true) {
            var obj = lexer.getObj();
            if ((0, _primitives.isEOF)(obj)) {
              break;
            }
            if ((0, _primitives.isCmd)(obj, "endcodespacerange")) {
              return;
            }
            if (!(0, _util.isString)(obj)) {
              break;
            }
            var low = strToInt(obj);
            obj = lexer.getObj();
            if (!(0, _util.isString)(obj)) {
              break;
            }
            var high = strToInt(obj);
            cMap.addCodespaceRange(obj.length, low, high);
          }
          throw new _util.FormatError("Invalid codespace range.");
        }
        function parseWMode(cMap, lexer) {
          var obj = lexer.getObj();
          if (Number.isInteger(obj)) {
            cMap.vertical = !!obj;
          }
        }
        function parseCMapName(cMap, lexer) {
          var obj = lexer.getObj();
          if ((0, _primitives.isName)(obj) && (0, _util.isString)(obj.name)) {
            cMap.name = obj.name;
          }
        }
        function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
          var previous;
          var embededUseCMap;
          objLoop: while (true) {
            try {
              var obj = lexer.getObj();
              if ((0, _primitives.isEOF)(obj)) {
                break;
              } else if ((0, _primitives.isName)(obj)) {
                if (obj.name === "WMode") {
                  parseWMode(cMap, lexer);
                } else if (obj.name === "CMapName") {
                  parseCMapName(cMap, lexer);
                }
                previous = obj;
              } else if ((0, _primitives.isCmd)(obj)) {
                switch (obj.cmd) {
                  case "endcmap":
                    break objLoop;
                  case "usecmap":
                    if ((0, _primitives.isName)(previous)) {
                      embededUseCMap = previous.name;
                    }
                    break;
                  case "begincodespacerange":
                    parseCodespaceRange(cMap, lexer);
                    break;
                  case "beginbfchar":
                    parseBfChar(cMap, lexer);
                    break;
                  case "begincidchar":
                    parseCidChar(cMap, lexer);
                    break;
                  case "beginbfrange":
                    parseBfRange(cMap, lexer);
                    break;
                  case "begincidrange":
                    parseCidRange(cMap, lexer);
                    break;
                }
              }
            } catch (ex) {
              if (ex instanceof _util.MissingDataException) {
                throw ex;
              }
              (0, _util.warn)("Invalid cMap data: " + ex);
              continue;
            }
          }
          if (!useCMap && embededUseCMap) {
            useCMap = embededUseCMap;
          }
          if (useCMap) {
            return extendCMap(cMap, fetchBuiltInCMap, useCMap);
          }
          return Promise.resolve(cMap);
        }
        function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
          return createBuiltInCMap(useCMap, fetchBuiltInCMap).then(function (newCMap) {
            cMap.useCMap = newCMap;
            if (cMap.numCodespaceRanges === 0) {
              var useCodespaceRanges = cMap.useCMap.codespaceRanges;
              for (var i = 0; i < useCodespaceRanges.length; i++) {
                cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
              }
              cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
            }
            cMap.useCMap.forEach(function (key, value) {
              if (!cMap.contains(key)) {
                cMap.mapOne(key, cMap.useCMap.lookup(key));
              }
            });
            return cMap;
          });
        }
        function createBuiltInCMap(name, fetchBuiltInCMap) {
          if (name === "Identity-H") {
            return Promise.resolve(new IdentityCMap(false, 2));
          } else if (name === "Identity-V") {
            return Promise.resolve(new IdentityCMap(true, 2));
          }
          if (BUILT_IN_CMAPS.indexOf(name) === -1) {
            return Promise.reject(new Error("Unknown CMap name: " + name));
          }
          if (!fetchBuiltInCMap) {
            return Promise.reject(new Error("Built-in CMap parameters are not provided."));
          }
          return fetchBuiltInCMap(name).then(function (data) {
            var cMapData = data.cMapData,
              compressionType = data.compressionType;
            var cMap = new CMap(true);
            if (compressionType === _util.CMapCompressionType.BINARY) {
              return new BinaryCMapReader().process(cMapData, cMap, function (useCMap) {
                return extendCMap(cMap, fetchBuiltInCMap, useCMap);
              });
            }
            if (compressionType === _util.CMapCompressionType.NONE) {
              var lexer = new _parser.Lexer(new _stream.Stream(cMapData));
              return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
            }
            return Promise.reject(new Error("TODO: Only BINARY/NONE CMap compression is currently supported."));
          });
        }
        return {
          create: function create(params) {
            var encoding = params.encoding;
            var fetchBuiltInCMap = params.fetchBuiltInCMap;
            var useCMap = params.useCMap;
            if ((0, _primitives.isName)(encoding)) {
              return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
            } else if ((0, _primitives.isStream)(encoding)) {
              var cMap = new CMap();
              var lexer = new _parser.Lexer(encoding);
              return parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap).then(function (parsedCMap) {
                if (parsedCMap.isIdentityCMap) {
                  return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
                }
                return parsedCMap;
              });
            }
            return Promise.reject(new Error("Encoding required."));
          }
        };
      }();
      exports.CMap = CMap;
      exports.IdentityCMap = IdentityCMap;
      exports.CMapFactory = CMapFactory;

      /***/ }),
    /* 134 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getFontType = exports.ProblematicCharRanges = exports.IdentityToUnicodeMap = exports.ToUnicodeMap = exports.FontFlags = exports.Font = exports.ErrorFont = exports.PRIVATE_USE_OFFSET_END = exports.PRIVATE_USE_OFFSET_START = exports.SEAC_ANALYSIS_ENABLED = undefined;

      var _util = __w_pdfjs_require__(0);

      var _cff_parser = __w_pdfjs_require__(78);

      var _glyphlist = __w_pdfjs_require__(47);

      var _encodings = __w_pdfjs_require__(27);

      var _standard_fonts = __w_pdfjs_require__(79);

      var _unicode = __w_pdfjs_require__(80);

      var _font_renderer = __w_pdfjs_require__(136);

      var _stream = __w_pdfjs_require__(5);

      var _type1_parser = __w_pdfjs_require__(137);

      var PRIVATE_USE_OFFSET_START = 0xE000;
      var PRIVATE_USE_OFFSET_END = 0xF8FF;
      var SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = false;
      var PDF_GLYPH_SPACE_UNITS = 1000;
      var SEAC_ANALYSIS_ENABLED = false;
      var FontFlags = {
        FixedPitch: 1,
        Serif: 2,
        Symbolic: 4,
        Script: 8,
        Nonsymbolic: 32,
        Italic: 64,
        AllCap: 65536,
        SmallCap: 131072,
        ForceBold: 262144
      };
      var MacStandardGlyphOrdering = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
      function adjustWidths(properties) {
        if (!properties.fontMatrix) {
          return;
        }
        if (properties.fontMatrix[0] === _util.FONT_IDENTITY_MATRIX[0]) {
          return;
        }
        var scale = 0.001 / properties.fontMatrix[0];
        var glyphsWidths = properties.widths;
        for (var glyph in glyphsWidths) {
          glyphsWidths[glyph] *= scale;
        }
        properties.defaultWidth *= scale;
      }
      function adjustToUnicode(properties, builtInEncoding) {
        if (properties.hasIncludedToUnicodeMap) {
          return;
        }
        if (properties.hasEncoding) {
          return;
        }
        if (builtInEncoding === properties.defaultEncoding) {
          return;
        }
        if (properties.toUnicode instanceof IdentityToUnicodeMap) {
          return;
        }
        var toUnicode = [],
          glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
        for (var charCode in builtInEncoding) {
          var glyphName = builtInEncoding[charCode];
          var unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
          if (unicode !== -1) {
            toUnicode[charCode] = String.fromCharCode(unicode);
          }
        }
        properties.toUnicode.amend(toUnicode);
      }
      function getFontType(type, subtype) {
        switch (type) {
          case "Type1":
            return subtype === "Type1C" ? _util.FontType.TYPE1C : _util.FontType.TYPE1;
          case "CIDFontType0":
            return subtype === "CIDFontType0C" ? _util.FontType.CIDFONTTYPE0C : _util.FontType.CIDFONTTYPE0;
          case "OpenType":
            return _util.FontType.OPENTYPE;
          case "TrueType":
            return _util.FontType.TRUETYPE;
          case "CIDFontType2":
            return _util.FontType.CIDFONTTYPE2;
          case "MMType1":
            return _util.FontType.MMTYPE1;
          case "Type0":
            return _util.FontType.TYPE0;
          default:
            return _util.FontType.UNKNOWN;
        }
      }
      function recoverGlyphName(name, glyphsUnicodeMap) {
        if (glyphsUnicodeMap[name] !== undefined) {
          return name;
        }
        var unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
        if (unicode !== -1) {
          for (var key in glyphsUnicodeMap) {
            if (glyphsUnicodeMap[key] === unicode) {
              return key;
            }
          }
        }
        (0, _util.info)("Unable to recover a standard glyph name for: " + name);
        return name;
      }
      var Glyph = function GlyphClosure() {
        function Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
          this.fontChar = fontChar;
          this.unicode = unicode;
          this.accent = accent;
          this.width = width;
          this.vmetric = vmetric;
          this.operatorListId = operatorListId;
          this.isSpace = isSpace;
          this.isInFont = isInFont;
        }
        Glyph.prototype.matchesForCache = function (fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
          return this.fontChar === fontChar && this.unicode === unicode && this.accent === accent && this.width === width && this.vmetric === vmetric && this.operatorListId === operatorListId && this.isSpace === isSpace && this.isInFont === isInFont;
        };
        return Glyph;
      }();
      var ToUnicodeMap = function ToUnicodeMapClosure() {
        function ToUnicodeMap(cmap) {
          this._map = cmap;
        }
        ToUnicodeMap.prototype = {
          get length() {
            return this._map.length;
          },
          forEach: function forEach(callback) {
            for (var charCode in this._map) {
              callback(charCode, this._map[charCode].charCodeAt(0));
            }
          },
          has: function has(i) {
            return this._map[i] !== undefined;
          },
          get: function get(i) {
            return this._map[i];
          },
          charCodeOf: function charCodeOf(value) {
            var map = this._map;
            if (map.length <= 0x10000) {
              return map.indexOf(value);
            }
            for (var charCode in map) {
              if (map[charCode] === value) {
                return charCode | 0;
              }
            }
            return -1;
          },
          amend: function amend(map) {
            for (var charCode in map) {
              this._map[charCode] = map[charCode];
            }
          }
        };
        return ToUnicodeMap;
      }();
      var IdentityToUnicodeMap = function IdentityToUnicodeMapClosure() {
        function IdentityToUnicodeMap(firstChar, lastChar) {
          this.firstChar = firstChar;
          this.lastChar = lastChar;
        }
        IdentityToUnicodeMap.prototype = {
          get length() {
            return this.lastChar + 1 - this.firstChar;
          },
          forEach: function forEach(callback) {
            for (var i = this.firstChar, ii = this.lastChar; i <= ii; i++) {
              callback(i, i);
            }
          },
          has: function has(i) {
            return this.firstChar <= i && i <= this.lastChar;
          },
          get: function get(i) {
            if (this.firstChar <= i && i <= this.lastChar) {
              return String.fromCharCode(i);
            }
            return undefined;
          },
          charCodeOf: function charCodeOf(v) {
            return Number.isInteger(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
          },
          amend: function amend(map) {
            throw new Error("Should not call amend()");
          }
        };
        return IdentityToUnicodeMap;
      }();
      var OpenTypeFileBuilder = function OpenTypeFileBuilderClosure() {
        function writeInt16(dest, offset, num) {
          dest[offset] = num >> 8 & 0xFF;
          dest[offset + 1] = num & 0xFF;
        }
        function writeInt32(dest, offset, num) {
          dest[offset] = num >> 24 & 0xFF;
          dest[offset + 1] = num >> 16 & 0xFF;
          dest[offset + 2] = num >> 8 & 0xFF;
          dest[offset + 3] = num & 0xFF;
        }
        function writeData(dest, offset, data) {
          var i, ii;
          if (data instanceof Uint8Array) {
            dest.set(data, offset);
          } else if (typeof data === "string") {
            for (i = 0, ii = data.length; i < ii; i++) {
              dest[offset++] = data.charCodeAt(i) & 0xFF;
            }
          } else {
            for (i = 0, ii = data.length; i < ii; i++) {
              dest[offset++] = data[i] & 0xFF;
            }
          }
        }
        function OpenTypeFileBuilder(sfnt) {
          this.sfnt = sfnt;
          this.tables = Object.create(null);
        }
        OpenTypeFileBuilder.getSearchParams = function OpenTypeFileBuilder_getSearchParams(entriesCount, entrySize) {
          var maxPower2 = 1,
            log2 = 0;
          while ((maxPower2 ^ entriesCount) > maxPower2) {
            maxPower2 <<= 1;
            log2++;
          }
          var searchRange = maxPower2 * entrySize;
          return {
            range: searchRange,
            entry: log2,
            rangeShift: entrySize * entriesCount - searchRange
          };
        };
        var OTF_HEADER_SIZE = 12;
        var OTF_TABLE_ENTRY_SIZE = 16;
        OpenTypeFileBuilder.prototype = {
          toArray: function OpenTypeFileBuilder_toArray() {
            var sfnt = this.sfnt;
            var tables = this.tables;
            var tablesNames = Object.keys(tables);
            tablesNames.sort();
            var numTables = tablesNames.length;
            var i, j, jj, table, tableName;
            var offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
            var tableOffsets = [offset];
            for (i = 0; i < numTables; i++) {
              table = tables[tablesNames[i]];
              var paddedLength = (table.length + 3 & ~3) >>> 0;
              offset += paddedLength;
              tableOffsets.push(offset);
            }
            var file = new Uint8Array(offset);
            for (i = 0; i < numTables; i++) {
              table = tables[tablesNames[i]];
              writeData(file, tableOffsets[i], table);
            }
            if (sfnt === "true") {
              sfnt = (0, _util.string32)(0x00010000);
            }
            file[0] = sfnt.charCodeAt(0) & 0xFF;
            file[1] = sfnt.charCodeAt(1) & 0xFF;
            file[2] = sfnt.charCodeAt(2) & 0xFF;
            file[3] = sfnt.charCodeAt(3) & 0xFF;
            writeInt16(file, 4, numTables);
            var searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
            writeInt16(file, 6, searchParams.range);
            writeInt16(file, 8, searchParams.entry);
            writeInt16(file, 10, searchParams.rangeShift);
            offset = OTF_HEADER_SIZE;
            for (i = 0; i < numTables; i++) {
              tableName = tablesNames[i];
              file[offset] = tableName.charCodeAt(0) & 0xFF;
              file[offset + 1] = tableName.charCodeAt(1) & 0xFF;
              file[offset + 2] = tableName.charCodeAt(2) & 0xFF;
              file[offset + 3] = tableName.charCodeAt(3) & 0xFF;
              var checksum = 0;
              for (j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4) {
                var quad = (0, _util.readUint32)(file, j);
                checksum = checksum + quad >>> 0;
              }
              writeInt32(file, offset + 4, checksum);
              writeInt32(file, offset + 8, tableOffsets[i]);
              writeInt32(file, offset + 12, tables[tableName].length);
              offset += OTF_TABLE_ENTRY_SIZE;
            }
            return file;
          },
          addTable: function OpenTypeFileBuilder_addTable(tag, data) {
            if (tag in this.tables) {
              throw new Error("Table " + tag + " already exists");
            }
            this.tables[tag] = data;
          }
        };
        return OpenTypeFileBuilder;
      }();
      var ProblematicCharRanges = new Int32Array([0x0000, 0x0020, 0x007F, 0x00A1, 0x00AD, 0x00AE, 0x0600, 0x0780, 0x08A0, 0x10A0, 0x1780, 0x1800, 0x1C00, 0x1C50, 0x2000, 0x2010, 0x2011, 0x2012, 0x2028, 0x2030, 0x205F, 0x2070, 0x25CC, 0x25CD, 0x3000, 0x3001, 0x3164, 0x3165, 0xAA60, 0xAA80, 0xFFF0, 0x10000]);
      var Font = function FontClosure() {
        function Font(name, file, properties) {
          var charCode;
          this.name = name;
          this.loadedName = properties.loadedName;
          this.isType3Font = properties.isType3Font;
          this.sizes = [];
          this.missingFile = false;
          this.glyphCache = Object.create(null);
          this.isSerifFont = !!(properties.flags & FontFlags.Serif);
          this.isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
          this.isMonospace = !!(properties.flags & FontFlags.FixedPitch);
          var type = properties.type;
          var subtype = properties.subtype;
          this.type = type;
          this.subtype = subtype;
          this.fallbackName = this.isMonospace ? "monospace" : this.isSerifFont ? "serif" : "sans-serif";
          this.differences = properties.differences;
          this.widths = properties.widths;
          this.defaultWidth = properties.defaultWidth;
          this.composite = properties.composite;
          this.wideChars = properties.wideChars;
          this.cMap = properties.cMap;
          this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
          this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
          this.fontMatrix = properties.fontMatrix;
          this.bbox = properties.bbox;
          this.defaultEncoding = properties.defaultEncoding;
          this.toUnicode = properties.toUnicode;
          this.toFontChar = [];
          if (properties.type === "Type3") {
            for (charCode = 0; charCode < 256; charCode++) {
              this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
            }
            this.fontType = _util.FontType.TYPE3;
            return;
          }
          this.cidEncoding = properties.cidEncoding;
          this.vertical = properties.vertical;
          if (this.vertical) {
            this.vmetrics = properties.vmetrics;
            this.defaultVMetrics = properties.defaultVMetrics;
          }
          if (!file || file.isEmpty) {
            if (file) {
              (0, _util.warn)("Font file is empty in \"" + name + "\" (" + this.loadedName + ")");
            }
            this.fallbackToSystemFont();
            return;
          }
          if (subtype === "Type1C") {
            if (type !== "Type1" && type !== "MMType1") {
              if (isTrueTypeFile(file)) {
                subtype = "TrueType";
              } else {
                type = "Type1";
              }
            } else if (isOpenTypeFile(file)) {
              subtype = "OpenType";
            }
          }
          if (subtype === "CIDFontType0C" && type !== "CIDFontType0") {
            type = "CIDFontType0";
          }
          if (type === "CIDFontType0") {
            if (isType1File(file)) {
              subtype = "CIDFontType0";
            } else if (isOpenTypeFile(file)) {
              subtype = "OpenType";
            } else {
              subtype = "CIDFontType0C";
            }
          }
          if (subtype === "OpenType" && type !== "OpenType") {
            type = "OpenType";
          }
          try {
            var data;
            switch (type) {
              case "MMType1":
                (0, _util.info)("MMType1 font (" + name + "), falling back to Type1.");
              case "Type1":
              case "CIDFontType0":
                this.mimetype = "font/opentype";
                var cff = subtype === "Type1C" || subtype === "CIDFontType0C" ? new CFFFont(file, properties) : new Type1Font(name, file, properties);
                adjustWidths(properties);
                data = this.convert(name, cff, properties);
                break;
              case "OpenType":
              case "TrueType":
              case "CIDFontType2":
                this.mimetype = "font/opentype";
                data = this.checkAndRepair(name, file, properties);
                if (this.isOpenType) {
                  adjustWidths(properties);
                  type = "OpenType";
                }
                break;
              default:
                throw new _util.FormatError("Font " + type + " is not supported");
            }
          } catch (e) {
            if (!(e instanceof _util.FormatError)) {
              throw e;
            }
            (0, _util.warn)(e);
            this.fallbackToSystemFont();
            return;
          }
          this.data = data;
          this.fontType = getFontType(type, subtype);
          this.fontMatrix = properties.fontMatrix;
          this.widths = properties.widths;
          this.defaultWidth = properties.defaultWidth;
          this.toUnicode = properties.toUnicode;
          this.encoding = properties.baseEncoding;
          this.seacMap = properties.seacMap;
          this.loading = true;
        }
        Font.getFontID = function () {
          var ID = 1;
          return function Font_getFontID() {
            return String(ID++);
          };
        }();
        function int16(b0, b1) {
          return (b0 << 8) + b1;
        }
        function writeSignedInt16(bytes, index, value) {
          bytes[index + 1] = value;
          bytes[index] = value >>> 8;
        }
        function signedInt16(b0, b1) {
          var value = (b0 << 8) + b1;
          return value & 1 << 15 ? value - 0x10000 : value;
        }
        function int32(b0, b1, b2, b3) {
          return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
        }
        function string16(value) {
          return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
        }
        function safeString16(value) {
          value = value > 0x7FFF ? 0x7FFF : value < -0x8000 ? -0x8000 : value;
          return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
        }
        function isTrueTypeFile(file) {
          var header = file.peekBytes(4);
          return (0, _util.readUint32)(header, 0) === 0x00010000;
        }
        function isOpenTypeFile(file) {
          var header = file.peekBytes(4);
          return (0, _util.bytesToString)(header) === "OTTO";
        }
        function isType1File(file) {
          var header = file.peekBytes(2);
          if (header[0] === 0x25 && header[1] === 0x21) {
            return true;
          }
          if (header[0] === 0x80 && header[1] === 0x01) {
            return true;
          }
          return false;
        }
        function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
          var toFontChar = [],
            unicode;
          for (var i = 0, ii = encoding.length; i < ii; i++) {
            unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
            if (unicode !== -1) {
              toFontChar[i] = unicode;
            }
          }
          for (var charCode in differences) {
            unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
            if (unicode !== -1) {
              toFontChar[+charCode] = unicode;
            }
          }
          return toFontChar;
        }
        function isProblematicUnicodeLocation(code) {
          var i = 0,
            j = ProblematicCharRanges.length - 1;
          while (i < j) {
            var c = i + j + 1 >> 1;
            if (code < ProblematicCharRanges[c]) {
              j = c - 1;
            } else {
              i = c;
            }
          }
          return !(i & 1);
        }
        function adjustMapping(charCodeToGlyphId, properties, missingGlyphs) {
          var toUnicode = properties.toUnicode;
          var isSymbolic = !!(properties.flags & FontFlags.Symbolic);
          var isIdentityUnicode = properties.toUnicode instanceof IdentityToUnicodeMap;
          var newMap = Object.create(null);
          var toFontChar = [];
          var usedFontCharCodes = [];
          var nextAvailableFontCharCode = PRIVATE_USE_OFFSET_START;
          for (var originalCharCode in charCodeToGlyphId) {
            originalCharCode |= 0;
            var glyphId = charCodeToGlyphId[originalCharCode];
            if (missingGlyphs[glyphId]) {
              continue;
            }
            var fontCharCode = originalCharCode;
            var hasUnicodeValue = false;
            if (!isIdentityUnicode && toUnicode.has(originalCharCode)) {
              hasUnicodeValue = true;
              var unicode = toUnicode.get(fontCharCode);
              if (unicode.length === 1) {
                fontCharCode = unicode.charCodeAt(0);
              }
            }
            if (usedFontCharCodes[fontCharCode] !== undefined || isProblematicUnicodeLocation(fontCharCode) || isSymbolic && !hasUnicodeValue) {
              do {
                if (nextAvailableFontCharCode > PRIVATE_USE_OFFSET_END) {
                  (0, _util.warn)("Ran out of space in font private use area.");
                  break;
                }
                fontCharCode = nextAvailableFontCharCode++;
                if (SKIP_PRIVATE_USE_RANGE_F000_TO_F01F && fontCharCode === 0xF000) {
                  fontCharCode = 0xF020;
                  nextAvailableFontCharCode = fontCharCode + 1;
                }
              } while (usedFontCharCodes[fontCharCode] !== undefined);
            }
            newMap[fontCharCode] = glyphId;
            toFontChar[originalCharCode] = fontCharCode;
            usedFontCharCodes[fontCharCode] = true;
          }
          return {
            toFontChar: toFontChar,
            charCodeToGlyphId: newMap,
            nextAvailableFontCharCode: nextAvailableFontCharCode
          };
        }
        function getRanges(glyphs, numGlyphs) {
          var codes = [];
          for (var charCode in glyphs) {
            if (glyphs[charCode] >= numGlyphs) {
              continue;
            }
            codes.push({
              fontCharCode: charCode | 0,
              glyphId: glyphs[charCode]
            });
          }
          if (codes.length === 0) {
            codes.push({
              fontCharCode: 0,
              glyphId: 0
            });
          }
          codes.sort(function fontGetRangesSort(a, b) {
            return a.fontCharCode - b.fontCharCode;
          });
          var ranges = [];
          var length = codes.length;
          for (var n = 0; n < length;) {
            var start = codes[n].fontCharCode;
            var codeIndices = [codes[n].glyphId];
            ++n;
            var end = start;
            while (n < length && end + 1 === codes[n].fontCharCode) {
              codeIndices.push(codes[n].glyphId);
              ++end;
              ++n;
              if (end === 0xFFFF) {
                break;
              }
            }
            ranges.push([start, end, codeIndices]);
          }
          return ranges;
        }
        function createCmapTable(glyphs, numGlyphs) {
          var ranges = getRanges(glyphs, numGlyphs);
          var numTables = ranges[ranges.length - 1][1] > 0xFFFF ? 2 : 1;
          var cmap = "\x00\x00" + string16(numTables) + "\x00\x03" + "\x00\x01" + (0, _util.string32)(4 + numTables * 8);
          var i, ii, j, jj;
          for (i = ranges.length - 1; i >= 0; --i) {
            if (ranges[i][0] <= 0xFFFF) {
              break;
            }
          }
          var bmpLength = i + 1;
          if (ranges[i][0] < 0xFFFF && ranges[i][1] === 0xFFFF) {
            ranges[i][1] = 0xFFFE;
          }
          var trailingRangesCount = ranges[i][1] < 0xFFFF ? 1 : 0;
          var segCount = bmpLength + trailingRangesCount;
          var searchParams = OpenTypeFileBuilder.getSearchParams(segCount, 2);
          var startCount = "";
          var endCount = "";
          var idDeltas = "";
          var idRangeOffsets = "";
          var glyphsIds = "";
          var bias = 0;
          var range, start, end, codes;
          for (i = 0, ii = bmpLength; i < ii; i++) {
            range = ranges[i];
            start = range[0];
            end = range[1];
            startCount += string16(start);
            endCount += string16(end);
            codes = range[2];
            var contiguous = true;
            for (j = 1, jj = codes.length; j < jj; ++j) {
              if (codes[j] !== codes[j - 1] + 1) {
                contiguous = false;
                break;
              }
            }
            if (!contiguous) {
              var offset = (segCount - i) * 2 + bias * 2;
              bias += end - start + 1;
              idDeltas += string16(0);
              idRangeOffsets += string16(offset);
              for (j = 0, jj = codes.length; j < jj; ++j) {
                glyphsIds += string16(codes[j]);
              }
            } else {
              var startCode = codes[0];
              idDeltas += string16(startCode - start & 0xFFFF);
              idRangeOffsets += string16(0);
            }
          }
          if (trailingRangesCount > 0) {
            endCount += "\xFF\xFF";
            startCount += "\xFF\xFF";
            idDeltas += "\x00\x01";
            idRangeOffsets += "\x00\x00";
          }
          var format314 = "\x00\x00" + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + "\x00\x00" + startCount + idDeltas + idRangeOffsets + glyphsIds;
          var format31012 = "";
          var header31012 = "";
          if (numTables > 1) {
            cmap += "\x00\x03" + "\x00\x0A" + (0, _util.string32)(4 + numTables * 8 + 4 + format314.length);
            format31012 = "";
            for (i = 0, ii = ranges.length; i < ii; i++) {
              range = ranges[i];
              start = range[0];
              codes = range[2];
              var code = codes[0];
              for (j = 1, jj = codes.length; j < jj; ++j) {
                if (codes[j] !== codes[j - 1] + 1) {
                  end = range[0] + j - 1;
                  format31012 += (0, _util.string32)(start) + (0, _util.string32)(end) + (0, _util.string32)(code);
                  start = end + 1;
                  code = codes[j];
                }
              }
              format31012 += (0, _util.string32)(start) + (0, _util.string32)(range[1]) + (0, _util.string32)(code);
            }
            header31012 = "\x00\x0C" + "\x00\x00" + (0, _util.string32)(format31012.length + 16) + "\x00\x00\x00\x00" + (0, _util.string32)(format31012.length / 12);
          }
          return cmap + "\x00\x04" + string16(format314.length + 4) + format314 + header31012 + format31012;
        }
        function validateOS2Table(os2) {
          var stream = new _stream.Stream(os2.data);
          var version = stream.getUint16();
          stream.getBytes(60);
          var selection = stream.getUint16();
          if (version < 4 && selection & 0x0300) {
            return false;
          }
          var firstChar = stream.getUint16();
          var lastChar = stream.getUint16();
          if (firstChar > lastChar) {
            return false;
          }
          stream.getBytes(6);
          var usWinAscent = stream.getUint16();
          if (usWinAscent === 0) {
            return false;
          }
          os2.data[8] = os2.data[9] = 0;
          return true;
        }
        function createOS2Table(properties, charstrings, override) {
          override = override || {
            unitsPerEm: 0,
            yMax: 0,
            yMin: 0,
            ascent: 0,
            descent: 0
          };
          var ulUnicodeRange1 = 0;
          var ulUnicodeRange2 = 0;
          var ulUnicodeRange3 = 0;
          var ulUnicodeRange4 = 0;
          var firstCharIndex = null;
          var lastCharIndex = 0;
          if (charstrings) {
            for (var code in charstrings) {
              code |= 0;
              if (firstCharIndex > code || !firstCharIndex) {
                firstCharIndex = code;
              }
              if (lastCharIndex < code) {
                lastCharIndex = code;
              }
              var position = (0, _unicode.getUnicodeRangeFor)(code);
              if (position < 32) {
                ulUnicodeRange1 |= 1 << position;
              } else if (position < 64) {
                ulUnicodeRange2 |= 1 << position - 32;
              } else if (position < 96) {
                ulUnicodeRange3 |= 1 << position - 64;
              } else if (position < 123) {
                ulUnicodeRange4 |= 1 << position - 96;
              } else {
                throw new _util.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
              }
            }
          } else {
            firstCharIndex = 0;
            lastCharIndex = 255;
          }
          var bbox = properties.bbox || [0, 0, 0, 0];
          var unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
          var scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
          var typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
          var typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
          if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) {
            typoDescent = -typoDescent;
          }
          var winAscent = override.yMax || typoAscent;
          var winDescent = -override.yMin || -typoDescent;
          return "\x00\x03" + "\x02\x24" + "\x01\xF4" + "\x00\x05" + "\x00\x00" + "\x02\x8A" + "\x02\xBB" + "\x00\x00" + "\x00\x8C" + "\x02\x8A" + "\x02\xBB" + "\x00\x00" + "\x01\xDF" + "\x00\x31" + "\x01\x02" + "\x00\x00" + "\x00\x00\x06" + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + "\x00\x00\x00\x00\x00\x00" + (0, _util.string32)(ulUnicodeRange1) + (0, _util.string32)(ulUnicodeRange2) + (0, _util.string32)(ulUnicodeRange3) + (0, _util.string32)(ulUnicodeRange4) + "\x2A\x32\x31\x2A" + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + "\x00\x64" + string16(winAscent) + string16(winDescent) + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + "\x00\x03";
        }
        function createPostTable(properties) {
          var angle = Math.floor(properties.italicAngle * Math.pow(2, 16));
          return "\x00\x03\x00\x00" + (0, _util.string32)(angle) + "\x00\x00" + "\x00\x00" + (0, _util.string32)(properties.fixedPitch) + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + "\x00\x00\x00\x00";
        }
        function createNameTable(name, proto) {
          if (!proto) {
            proto = [[], []];
          }
          var strings = [proto[0][0] || "Original licence", proto[0][1] || name, proto[0][2] || "Unknown", proto[0][3] || "uniqueID", proto[0][4] || name, proto[0][5] || "Version 0.11", proto[0][6] || "", proto[0][7] || "Unknown", proto[0][8] || "Unknown", proto[0][9] || "Unknown"];
          var stringsUnicode = [];
          var i, ii, j, jj, str;
          for (i = 0, ii = strings.length; i < ii; i++) {
            str = proto[1][i] || strings[i];
            var strBufUnicode = [];
            for (j = 0, jj = str.length; j < jj; j++) {
              strBufUnicode.push(string16(str.charCodeAt(j)));
            }
            stringsUnicode.push(strBufUnicode.join(""));
          }
          var names = [strings, stringsUnicode];
          var platforms = ["\x00\x01", "\x00\x03"];
          var encodings = ["\x00\x00", "\x00\x01"];
          var languages = ["\x00\x00", "\x04\x09"];
          var namesRecordCount = strings.length * platforms.length;
          var nameTable = "\x00\x00" + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
          var strOffset = 0;
          for (i = 0, ii = platforms.length; i < ii; i++) {
            var strs = names[i];
            for (j = 0, jj = strs.length; j < jj; j++) {
              str = strs[j];
              var nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
              nameTable += nameRecord;
              strOffset += str.length;
            }
          }
          nameTable += strings.join("") + stringsUnicode.join("");
          return nameTable;
        }
        Font.prototype = {
          name: null,
          font: null,
          mimetype: null,
          encoding: null,
          get renderer() {
            var renderer = _font_renderer.FontRendererFactory.create(this, SEAC_ANALYSIS_ENABLED);
            return (0, _util.shadow)(this, "renderer", renderer);
          },
          exportData: function Font_exportData() {
            var data = {};
            for (var i in this) {
              if (this.hasOwnProperty(i)) {
                data[i] = this[i];
              }
            }
            return data;
          },
          fallbackToSystemFont: function Font_fallbackToSystemFont() {
            var _this = this;

            this.missingFile = true;
            var charCode, unicode;
            var name = this.name;
            var type = this.type;
            var subtype = this.subtype;
            var fontName = name.replace(/[,_]/g, "-");
            var stdFontMap = (0, _standard_fonts.getStdFontMap)(),
              nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
            var isStandardFont = !!stdFontMap[fontName] || !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
            fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
            this.bold = fontName.search(/bold/gi) !== -1;
            this.italic = fontName.search(/oblique/gi) !== -1 || fontName.search(/italic/gi) !== -1;
            this.black = name.search(/Black/g) !== -1;
            this.remeasure = Object.keys(this.widths).length > 0;
            if (isStandardFont && type === "CIDFontType2" && this.cidEncoding.indexOf("Identity-") === 0) {
              var GlyphMapForStandardFonts = (0, _standard_fonts.getGlyphMapForStandardFonts)();
              var map = [];
              for (charCode in GlyphMapForStandardFonts) {
                map[+charCode] = GlyphMapForStandardFonts[charCode];
              }
              if (/Arial-?Black/i.test(name)) {
                var SupplementalGlyphMapForArialBlack = (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)();
                for (charCode in SupplementalGlyphMapForArialBlack) {
                  map[+charCode] = SupplementalGlyphMapForArialBlack[charCode];
                }
              }
              var isIdentityUnicode = this.toUnicode instanceof IdentityToUnicodeMap;
              if (!isIdentityUnicode) {
                this.toUnicode.forEach(function (charCode, unicodeCharCode) {
                  map[+charCode] = unicodeCharCode;
                });
              }
              this.toFontChar = map;
              this.toUnicode = new ToUnicodeMap(map);
            } else if (/Symbol/i.test(fontName)) {
              this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
            } else if (/Dingbats/i.test(fontName)) {
              if (/Wingdings/i.test(name)) {
                (0, _util.warn)("Non-embedded Wingdings font, falling back to ZapfDingbats.");
              }
              this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
            } else if (isStandardFont) {
              this.toFontChar = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
            } else {
              var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
              this.toUnicode.forEach(function (charCode, unicodeCharCode) {
                if (!_this.composite) {
                  var glyphName = _this.differences[charCode] || _this.defaultEncoding[charCode];
                  unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                  if (unicode !== -1) {
                    unicodeCharCode = unicode;
                  }
                }
                _this.toFontChar[charCode] = unicodeCharCode;
              });
            }
            this.loadedName = fontName.split("-")[0];
            this.loading = false;
            this.fontType = getFontType(type, subtype);
          },
          checkAndRepair: function Font_checkAndRepair(name, font, properties) {
            function readTableEntry(file) {
              var tag = (0, _util.bytesToString)(file.getBytes(4));
              var checksum = file.getInt32() >>> 0;
              var offset = file.getInt32() >>> 0;
              var length = file.getInt32() >>> 0;
              var previousPosition = file.pos;
              file.pos = file.start ? file.start : 0;
              file.skip(offset);
              var data = file.getBytes(length);
              file.pos = previousPosition;
              if (tag === "head") {
                data[8] = data[9] = data[10] = data[11] = 0;
                data[17] |= 0x20;
              }
              return {
                tag: tag,
                checksum: checksum,
                length: length,
                offset: offset,
                data: data
              };
            }
            function readOpenTypeHeader(ttf) {
              return {
                version: (0, _util.bytesToString)(ttf.getBytes(4)),
                numTables: ttf.getUint16(),
                searchRange: ttf.getUint16(),
                entrySelector: ttf.getUint16(),
                rangeShift: ttf.getUint16()
              };
            }
            function readCmapTable(cmap, font, isSymbolicFont, hasEncoding) {
              if (!cmap) {
                (0, _util.warn)("No cmap table available.");
                return {
                  platformId: -1,
                  encodingId: -1,
                  mappings: [],
                  hasShortCmap: false
                };
              }
              var segment;
              var start = (font.start ? font.start : 0) + cmap.offset;
              font.pos = start;
              font.getUint16();
              var numTables = font.getUint16();
              var potentialTable;
              var canBreak = false;
              for (var i = 0; i < numTables; i++) {
                var platformId = font.getUint16();
                var encodingId = font.getUint16();
                var offset = font.getInt32() >>> 0;
                var useTable = false;
                if (potentialTable && potentialTable.platformId === platformId && potentialTable.encodingId === encodingId) {
                  continue;
                }
                if (platformId === 0 && encodingId === 0) {
                  useTable = true;
                } else if (platformId === 1 && encodingId === 0) {
                  useTable = true;
                } else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
                  useTable = true;
                  if (!isSymbolicFont) {
                    canBreak = true;
                  }
                } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
                  useTable = true;
                  canBreak = true;
                }
                if (useTable) {
                  potentialTable = {
                    platformId: platformId,
                    encodingId: encodingId,
                    offset: offset
                  };
                }
                if (canBreak) {
                  break;
                }
              }
              if (potentialTable) {
                font.pos = start + potentialTable.offset;
              }
              if (!potentialTable || font.peekByte() === -1) {
                (0, _util.warn)("Could not find a preferred cmap table.");
                return {
                  platformId: -1,
                  encodingId: -1,
                  mappings: [],
                  hasShortCmap: false
                };
              }
              var format = font.getUint16();
              font.getUint16();
              font.getUint16();
              var hasShortCmap = false;
              var mappings = [];
              var j, glyphId;
              if (format === 0) {
                for (j = 0; j < 256; j++) {
                  var index = font.getByte();
                  if (!index) {
                    continue;
                  }
                  mappings.push({
                    charCode: j,
                    glyphId: index
                  });
                }
                hasShortCmap = true;
              } else if (format === 4) {
                var segCount = font.getUint16() >> 1;
                font.getBytes(6);
                var segIndex,
                  segments = [];
                for (segIndex = 0; segIndex < segCount; segIndex++) {
                  segments.push({ end: font.getUint16() });
                }
                font.getUint16();
                for (segIndex = 0; segIndex < segCount; segIndex++) {
                  segments[segIndex].start = font.getUint16();
                }
                for (segIndex = 0; segIndex < segCount; segIndex++) {
                  segments[segIndex].delta = font.getUint16();
                }
                var offsetsCount = 0;
                for (segIndex = 0; segIndex < segCount; segIndex++) {
                  segment = segments[segIndex];
                  var rangeOffset = font.getUint16();
                  if (!rangeOffset) {
                    segment.offsetIndex = -1;
                    continue;
                  }
                  var offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
                  segment.offsetIndex = offsetIndex;
                  offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
                }
                var offsets = [];
                for (j = 0; j < offsetsCount; j++) {
                  offsets.push(font.getUint16());
                }
                for (segIndex = 0; segIndex < segCount; segIndex++) {
                  segment = segments[segIndex];
                  start = segment.start;
                  var end = segment.end;
                  var delta = segment.delta;
                  offsetIndex = segment.offsetIndex;
                  for (j = start; j <= end; j++) {
                    if (j === 0xFFFF) {
                      continue;
                    }
                    glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
                    glyphId = glyphId + delta & 0xFFFF;
                    mappings.push({
                      charCode: j,
                      glyphId: glyphId
                    });
                  }
                }
              } else if (format === 6) {
                var firstCode = font.getUint16();
                var entryCount = font.getUint16();
                for (j = 0; j < entryCount; j++) {
                  glyphId = font.getUint16();
                  var charCode = firstCode + j;
                  mappings.push({
                    charCode: charCode,
                    glyphId: glyphId
                  });
                }
              } else {
                (0, _util.warn)("cmap table has unsupported format: " + format);
                return {
                  platformId: -1,
                  encodingId: -1,
                  mappings: [],
                  hasShortCmap: false
                };
              }
              mappings.sort(function (a, b) {
                return a.charCode - b.charCode;
              });
              for (i = 1; i < mappings.length; i++) {
                if (mappings[i - 1].charCode === mappings[i].charCode) {
                  mappings.splice(i, 1);
                  i--;
                }
              }
              return {
                platformId: potentialTable.platformId,
                encodingId: potentialTable.encodingId,
                mappings: mappings,
                hasShortCmap: hasShortCmap
              };
            }
            function sanitizeMetrics(font, header, metrics, numGlyphs) {
              if (!header) {
                if (metrics) {
                  metrics.data = null;
                }
                return;
              }
              font.pos = (font.start ? font.start : 0) + header.offset;
              font.pos += header.length - 2;
              var numOfMetrics = font.getUint16();
              if (numOfMetrics > numGlyphs) {
                (0, _util.info)("The numOfMetrics (" + numOfMetrics + ") should not be " + "greater than the numGlyphs (" + numGlyphs + ")");
                numOfMetrics = numGlyphs;
                header.data[34] = (numOfMetrics & 0xff00) >> 8;
                header.data[35] = numOfMetrics & 0x00ff;
              }
              var numOfSidebearings = numGlyphs - numOfMetrics;
              var numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
              if (numMissing > 0) {
                var entries = new Uint8Array(metrics.length + numMissing * 2);
                entries.set(metrics.data);
                metrics.data = entries;
              }
            }
            function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
              var glyphProfile = {
                length: 0,
                sizeOfInstructions: 0
              };
              if (sourceEnd - sourceStart <= 12) {
                return glyphProfile;
              }
              var glyf = source.subarray(sourceStart, sourceEnd);
              var contoursCount = signedInt16(glyf[0], glyf[1]);
              if (contoursCount < 0) {
                contoursCount = -1;
                writeSignedInt16(glyf, 0, contoursCount);
                dest.set(glyf, destStart);
                glyphProfile.length = glyf.length;
                return glyphProfile;
              }
              var i,
                j = 10,
                flagsCount = 0;
              for (i = 0; i < contoursCount; i++) {
                var endPoint = glyf[j] << 8 | glyf[j + 1];
                flagsCount = endPoint + 1;
                j += 2;
              }
              var instructionsStart = j;
              var instructionsLength = glyf[j] << 8 | glyf[j + 1];
              glyphProfile.sizeOfInstructions = instructionsLength;
              j += 2 + instructionsLength;
              var instructionsEnd = j;
              var coordinatesLength = 0;
              for (i = 0; i < flagsCount; i++) {
                var flag = glyf[j++];
                if (flag & 0xC0) {
                  glyf[j - 1] = flag & 0x3F;
                }
                var xyLength = (flag & 2 ? 1 : flag & 16 ? 0 : 2) + (flag & 4 ? 1 : flag & 32 ? 0 : 2);
                coordinatesLength += xyLength;
                if (flag & 8) {
                  var repeat = glyf[j++];
                  i += repeat;
                  coordinatesLength += repeat * xyLength;
                }
              }
              if (coordinatesLength === 0) {
                return glyphProfile;
              }
              var glyphDataLength = j + coordinatesLength;
              if (glyphDataLength > glyf.length) {
                return glyphProfile;
              }
              if (!hintsValid && instructionsLength > 0) {
                dest.set(glyf.subarray(0, instructionsStart), destStart);
                dest.set([0, 0], destStart + instructionsStart);
                dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
                glyphDataLength -= instructionsLength;
                if (glyf.length - glyphDataLength > 3) {
                  glyphDataLength = glyphDataLength + 3 & ~3;
                }
                glyphProfile.length = glyphDataLength;
                return glyphProfile;
              }
              if (glyf.length - glyphDataLength > 3) {
                glyphDataLength = glyphDataLength + 3 & ~3;
                dest.set(glyf.subarray(0, glyphDataLength), destStart);
                glyphProfile.length = glyphDataLength;
                return glyphProfile;
              }
              dest.set(glyf, destStart);
              glyphProfile.length = glyf.length;
              return glyphProfile;
            }
            function sanitizeHead(head, numGlyphs, locaLength) {
              var data = head.data;
              var version = int32(data[0], data[1], data[2], data[3]);
              if (version >> 16 !== 1) {
                (0, _util.info)("Attempting to fix invalid version in head table: " + version);
                data[0] = 0;
                data[1] = 1;
                data[2] = 0;
                data[3] = 0;
              }
              var indexToLocFormat = int16(data[50], data[51]);
              if (indexToLocFormat < 0 || indexToLocFormat > 1) {
                (0, _util.info)("Attempting to fix invalid indexToLocFormat in head table: " + indexToLocFormat);
                var numGlyphsPlusOne = numGlyphs + 1;
                if (locaLength === numGlyphsPlusOne << 1) {
                  data[50] = 0;
                  data[51] = 0;
                } else if (locaLength === numGlyphsPlusOne << 2) {
                  data[50] = 0;
                  data[51] = 1;
                } else {
                  throw new _util.FormatError("Could not fix indexToLocFormat: " + indexToLocFormat);
                }
              }
            }
            function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions) {
              var itemSize, itemDecode, itemEncode;
              if (isGlyphLocationsLong) {
                itemSize = 4;
                itemDecode = function fontItemDecodeLong(data, offset) {
                  return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
                };
                itemEncode = function fontItemEncodeLong(data, offset, value) {
                  data[offset] = value >>> 24 & 0xFF;
                  data[offset + 1] = value >> 16 & 0xFF;
                  data[offset + 2] = value >> 8 & 0xFF;
                  data[offset + 3] = value & 0xFF;
                };
              } else {
                itemSize = 2;
                itemDecode = function fontItemDecode(data, offset) {
                  return data[offset] << 9 | data[offset + 1] << 1;
                };
                itemEncode = function fontItemEncode(data, offset, value) {
                  data[offset] = value >> 9 & 0xFF;
                  data[offset + 1] = value >> 1 & 0xFF;
                };
              }
              var locaData = loca.data;
              var locaDataSize = itemSize * (1 + numGlyphs);
              if (locaData.length !== locaDataSize) {
                locaData = new Uint8Array(locaDataSize);
                locaData.set(loca.data.subarray(0, locaDataSize));
                loca.data = locaData;
              }
              var oldGlyfData = glyf.data;
              var oldGlyfDataLength = oldGlyfData.length;
              var newGlyfData = new Uint8Array(oldGlyfDataLength);
              var startOffset = itemDecode(locaData, 0);
              var writeOffset = 0;
              var missingGlyphs = Object.create(null);
              itemEncode(locaData, 0, writeOffset);
              var i, j;
              var locaCount = dupFirstEntry ? numGlyphs - 1 : numGlyphs;
              for (i = 0, j = itemSize; i < locaCount; i++, j += itemSize) {
                var endOffset = itemDecode(locaData, j);
                if (endOffset > oldGlyfDataLength && (oldGlyfDataLength + 3 & ~3) === endOffset) {
                  endOffset = oldGlyfDataLength;
                }
                if (endOffset > oldGlyfDataLength) {
                  startOffset = endOffset;
                }
                var glyphProfile = sanitizeGlyph(oldGlyfData, startOffset, endOffset, newGlyfData, writeOffset, hintsValid);
                var newLength = glyphProfile.length;
                if (newLength === 0) {
                  missingGlyphs[i] = true;
                }
                if (glyphProfile.sizeOfInstructions > maxSizeOfInstructions) {
                  maxSizeOfInstructions = glyphProfile.sizeOfInstructions;
                }
                writeOffset += newLength;
                itemEncode(locaData, j, writeOffset);
                startOffset = endOffset;
              }
              if (writeOffset === 0) {
                var simpleGlyph = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                for (i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize) {
                  itemEncode(locaData, j, simpleGlyph.length);
                }
                glyf.data = simpleGlyph;
              } else if (dupFirstEntry) {
                var firstEntryLength = itemDecode(locaData, itemSize);
                if (newGlyfData.length > firstEntryLength + writeOffset) {
                  glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
                } else {
                  glyf.data = new Uint8Array(firstEntryLength + writeOffset);
                  glyf.data.set(newGlyfData.subarray(0, writeOffset));
                }
                glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
                itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
              } else {
                glyf.data = newGlyfData.subarray(0, writeOffset);
              }
              return {
                missingGlyphs: missingGlyphs,
                maxSizeOfInstructions: maxSizeOfInstructions
              };
            }
            function readPostScriptTable(post, properties, maxpNumGlyphs) {
              var start = (font.start ? font.start : 0) + post.offset;
              font.pos = start;
              var length = post.length,
                end = start + length;
              var version = font.getInt32();
              font.getBytes(28);
              var glyphNames;
              var valid = true;
              var i;
              switch (version) {
                case 0x00010000:
                  glyphNames = MacStandardGlyphOrdering;
                  break;
                case 0x00020000:
                  var numGlyphs = font.getUint16();
                  if (numGlyphs !== maxpNumGlyphs) {
                    valid = false;
                    break;
                  }
                  var glyphNameIndexes = [];
                  for (i = 0; i < numGlyphs; ++i) {
                    var index = font.getUint16();
                    if (index >= 32768) {
                      valid = false;
                      break;
                    }
                    glyphNameIndexes.push(index);
                  }
                  if (!valid) {
                    break;
                  }
                  var customNames = [];
                  var strBuf = [];
                  while (font.pos < end) {
                    var stringLength = font.getByte();
                    strBuf.length = stringLength;
                    for (i = 0; i < stringLength; ++i) {
                      strBuf[i] = String.fromCharCode(font.getByte());
                    }
                    customNames.push(strBuf.join(""));
                  }
                  glyphNames = [];
                  for (i = 0; i < numGlyphs; ++i) {
                    var j = glyphNameIndexes[i];
                    if (j < 258) {
                      glyphNames.push(MacStandardGlyphOrdering[j]);
                      continue;
                    }
                    glyphNames.push(customNames[j - 258]);
                  }
                  break;
                case 0x00030000:
                  break;
                default:
                  (0, _util.warn)("Unknown/unsupported post table version " + version);
                  valid = false;
                  if (properties.defaultEncoding) {
                    glyphNames = properties.defaultEncoding;
                  }
                  break;
              }
              properties.glyphNames = glyphNames;
              return valid;
            }
            function readNameTable(nameTable) {
              var start = (font.start ? font.start : 0) + nameTable.offset;
              font.pos = start;
              var names = [[], []];
              var length = nameTable.length,
                end = start + length;
              var format = font.getUint16();
              var FORMAT_0_HEADER_LENGTH = 6;
              if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) {
                return names;
              }
              var numRecords = font.getUint16();
              var stringsStart = font.getUint16();
              var records = [];
              var NAME_RECORD_LENGTH = 12;
              var i, ii;
              for (i = 0; i < numRecords && font.pos + NAME_RECORD_LENGTH <= end; i++) {
                var r = {
                  platform: font.getUint16(),
                  encoding: font.getUint16(),
                  language: font.getUint16(),
                  name: font.getUint16(),
                  length: font.getUint16(),
                  offset: font.getUint16()
                };
                if (r.platform === 1 && r.encoding === 0 && r.language === 0 || r.platform === 3 && r.encoding === 1 && r.language === 0x409) {
                  records.push(r);
                }
              }
              for (i = 0, ii = records.length; i < ii; i++) {
                var record = records[i];
                if (record.length <= 0) {
                  continue;
                }
                var pos = start + stringsStart + record.offset;
                if (pos + record.length > end) {
                  continue;
                }
                font.pos = pos;
                var nameIndex = record.name;
                if (record.encoding) {
                  var str = "";
                  for (var j = 0, jj = record.length; j < jj; j += 2) {
                    str += String.fromCharCode(font.getUint16());
                  }
                  names[1][nameIndex] = str;
                } else {
                  names[0][nameIndex] = (0, _util.bytesToString)(font.getBytes(record.length));
                }
              }
              return names;
            }
            var TTOpsStackDeltas = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
            function sanitizeTTProgram(table, ttContext) {
              var data = table.data;
              var i = 0,
                j,
                n,
                b,
                funcId,
                pc,
                lastEndf = 0,
                lastDeff = 0;
              var stack = [];
              var callstack = [];
              var functionsCalled = [];
              var tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
              var inFDEF = false,
                ifLevel = 0,
                inELSE = 0;
              for (var ii = data.length; i < ii;) {
                var op = data[i++];
                if (op === 0x40) {
                  n = data[i++];
                  if (inFDEF || inELSE) {
                    i += n;
                  } else {
                    for (j = 0; j < n; j++) {
                      stack.push(data[i++]);
                    }
                  }
                } else if (op === 0x41) {
                  n = data[i++];
                  if (inFDEF || inELSE) {
                    i += n * 2;
                  } else {
                    for (j = 0; j < n; j++) {
                      b = data[i++];
                      stack.push(b << 8 | data[i++]);
                    }
                  }
                } else if ((op & 0xF8) === 0xB0) {
                  n = op - 0xB0 + 1;
                  if (inFDEF || inELSE) {
                    i += n;
                  } else {
                    for (j = 0; j < n; j++) {
                      stack.push(data[i++]);
                    }
                  }
                } else if ((op & 0xF8) === 0xB8) {
                  n = op - 0xB8 + 1;
                  if (inFDEF || inELSE) {
                    i += n * 2;
                  } else {
                    for (j = 0; j < n; j++) {
                      b = data[i++];
                      stack.push(b << 8 | data[i++]);
                    }
                  }
                } else if (op === 0x2B && !tooComplexToFollowFunctions) {
                  if (!inFDEF && !inELSE) {
                    funcId = stack[stack.length - 1];
                    ttContext.functionsUsed[funcId] = true;
                    if (funcId in ttContext.functionsStackDeltas) {
                      stack.length += ttContext.functionsStackDeltas[funcId];
                    } else if (funcId in ttContext.functionsDefined && functionsCalled.indexOf(funcId) < 0) {
                      callstack.push({
                        data: data,
                        i: i,
                        stackTop: stack.length - 1
                      });
                      functionsCalled.push(funcId);
                      pc = ttContext.functionsDefined[funcId];
                      if (!pc) {
                        (0, _util.warn)("TT: CALL non-existent function");
                        ttContext.hintsValid = false;
                        return;
                      }
                      data = pc.data;
                      i = pc.i;
                    }
                  }
                } else if (op === 0x2C && !tooComplexToFollowFunctions) {
                  if (inFDEF || inELSE) {
                    (0, _util.warn)("TT: nested FDEFs not allowed");
                    tooComplexToFollowFunctions = true;
                  }
                  inFDEF = true;
                  lastDeff = i;
                  funcId = stack.pop();
                  ttContext.functionsDefined[funcId] = {
                    data: data,
                    i: i
                  };
                } else if (op === 0x2D) {
                  if (inFDEF) {
                    inFDEF = false;
                    lastEndf = i;
                  } else {
                    pc = callstack.pop();
                    if (!pc) {
                      (0, _util.warn)("TT: ENDF bad stack");
                      ttContext.hintsValid = false;
                      return;
                    }
                    funcId = functionsCalled.pop();
                    data = pc.data;
                    i = pc.i;
                    ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
                  }
                } else if (op === 0x89) {
                  if (inFDEF || inELSE) {
                    (0, _util.warn)("TT: nested IDEFs not allowed");
                    tooComplexToFollowFunctions = true;
                  }
                  inFDEF = true;
                  lastDeff = i;
                } else if (op === 0x58) {
                  ++ifLevel;
                } else if (op === 0x1B) {
                  inELSE = ifLevel;
                } else if (op === 0x59) {
                  if (inELSE === ifLevel) {
                    inELSE = 0;
                  }
                  --ifLevel;
                } else if (op === 0x1C) {
                  if (!inFDEF && !inELSE) {
                    var offset = stack[stack.length - 1];
                    if (offset > 0) {
                      i += offset - 1;
                    }
                  }
                }
                if (!inFDEF && !inELSE) {
                  var stackDelta = op <= 0x8E ? TTOpsStackDeltas[op] : op >= 0xC0 && op <= 0xDF ? -1 : op >= 0xE0 ? -2 : 0;
                  if (op >= 0x71 && op <= 0x75) {
                    n = stack.pop();
                    if (!isNaN(n)) {
                      stackDelta = -n * 2;
                    }
                  }
                  while (stackDelta < 0 && stack.length > 0) {
                    stack.pop();
                    stackDelta++;
                  }
                  while (stackDelta > 0) {
                    stack.push(NaN);
                    stackDelta--;
                  }
                }
              }
              ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
              var content = [data];
              if (i > data.length) {
                content.push(new Uint8Array(i - data.length));
              }
              if (lastDeff > lastEndf) {
                (0, _util.warn)("TT: complementing a missing function tail");
                content.push(new Uint8Array([0x22, 0x2D]));
              }
              foldTTTable(table, content);
            }
            function checkInvalidFunctions(ttContext, maxFunctionDefs) {
              if (ttContext.tooComplexToFollowFunctions) {
                return;
              }
              if (ttContext.functionsDefined.length > maxFunctionDefs) {
                (0, _util.warn)("TT: more functions defined than expected");
                ttContext.hintsValid = false;
                return;
              }
              for (var j = 0, jj = ttContext.functionsUsed.length; j < jj; j++) {
                if (j > maxFunctionDefs) {
                  (0, _util.warn)("TT: invalid function id: " + j);
                  ttContext.hintsValid = false;
                  return;
                }
                if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
                  (0, _util.warn)("TT: undefined function: " + j);
                  ttContext.hintsValid = false;
                  return;
                }
              }
            }
            function foldTTTable(table, content) {
              if (content.length > 1) {
                var newLength = 0;
                var j, jj;
                for (j = 0, jj = content.length; j < jj; j++) {
                  newLength += content[j].length;
                }
                newLength = newLength + 3 & ~3;
                var result = new Uint8Array(newLength);
                var pos = 0;
                for (j = 0, jj = content.length; j < jj; j++) {
                  result.set(content[j], pos);
                  pos += content[j].length;
                }
                table.data = result;
                table.length = newLength;
              }
            }
            function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
              var ttContext = {
                functionsDefined: [],
                functionsUsed: [],
                functionsStackDeltas: [],
                tooComplexToFollowFunctions: false,
                hintsValid: true
              };
              if (fpgm) {
                sanitizeTTProgram(fpgm, ttContext);
              }
              if (prep) {
                sanitizeTTProgram(prep, ttContext);
              }
              if (fpgm) {
                checkInvalidFunctions(ttContext, maxFunctionDefs);
              }
              if (cvt && cvt.length & 1) {
                var cvtData = new Uint8Array(cvt.length + 1);
                cvtData.set(cvt.data);
                cvt.data = cvtData;
              }
              return ttContext.hintsValid;
            }
            font = new _stream.Stream(new Uint8Array(font.getBytes()));
            var VALID_TABLES = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
            var header = readOpenTypeHeader(font);
            var numTables = header.numTables;
            var cff, cffFile;
            var tables = Object.create(null);
            tables["OS/2"] = null;
            tables["cmap"] = null;
            tables["head"] = null;
            tables["hhea"] = null;
            tables["hmtx"] = null;
            tables["maxp"] = null;
            tables["name"] = null;
            tables["post"] = null;
            var table;
            for (var i = 0; i < numTables; i++) {
              table = readTableEntry(font);
              if (VALID_TABLES.indexOf(table.tag) < 0) {
                continue;
              }
              if (table.length === 0) {
                continue;
              }
              tables[table.tag] = table;
            }
            var isTrueType = !tables["CFF "];
            if (!isTrueType) {
              if (header.version === "OTTO" && !(properties.composite && properties.cidToGidMap) || !tables["head"] || !tables["hhea"] || !tables["maxp"] || !tables["post"]) {
                cffFile = new _stream.Stream(tables["CFF "].data);
                cff = new CFFFont(cffFile, properties);
                adjustWidths(properties);
                return this.convert(name, cff, properties);
              }
              delete tables["glyf"];
              delete tables["loca"];
              delete tables["fpgm"];
              delete tables["prep"];
              delete tables["cvt "];
              this.isOpenType = true;
            } else {
              if (!tables["loca"]) {
                throw new _util.FormatError("Required \"loca\" table is not found");
              }
              if (!tables["glyf"]) {
                (0, _util.warn)("Required \"glyf\" table is not found -- trying to recover.");
                tables["glyf"] = {
                  tag: "glyf",
                  data: new Uint8Array(0)
                };
              }
              this.isOpenType = false;
            }
            if (!tables["maxp"]) {
              throw new _util.FormatError("Required \"maxp\" table is not found");
            }
            font.pos = (font.start || 0) + tables["maxp"].offset;
            var version = font.getInt32();
            var numGlyphs = font.getUint16();
            var maxFunctionDefs = 0;
            var maxSizeOfInstructions = 0;
            if (version >= 0x00010000 && tables["maxp"].length >= 22) {
              font.pos += 8;
              var maxZones = font.getUint16();
              if (maxZones > 2) {
                tables["maxp"].data[14] = 0;
                tables["maxp"].data[15] = 2;
              }
              font.pos += 4;
              maxFunctionDefs = font.getUint16();
              font.pos += 6;
              maxSizeOfInstructions = font.getUint16();
            }
            var dupFirstEntry = false;
            if (properties.type === "CIDFontType2" && properties.toUnicode && properties.toUnicode.get(0) > "\0") {
              dupFirstEntry = true;
              numGlyphs++;
              tables["maxp"].data[4] = numGlyphs >> 8;
              tables["maxp"].data[5] = numGlyphs & 255;
            }
            var hintsValid = sanitizeTTPrograms(tables["fpgm"], tables["prep"], tables["cvt "], maxFunctionDefs);
            if (!hintsValid) {
              delete tables["fpgm"];
              delete tables["prep"];
              delete tables["cvt "];
            }
            sanitizeMetrics(font, tables["hhea"], tables["hmtx"], numGlyphs);
            if (!tables["head"]) {
              throw new _util.FormatError("Required \"head\" table is not found");
            }
            sanitizeHead(tables["head"], numGlyphs, isTrueType ? tables["loca"].length : 0);
            var missingGlyphs = Object.create(null);
            if (isTrueType) {
              var isGlyphLocationsLong = int16(tables["head"].data[50], tables["head"].data[51]);
              var glyphsInfo = sanitizeGlyphLocations(tables["loca"], tables["glyf"], numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions);
              missingGlyphs = glyphsInfo.missingGlyphs;
              if (version >= 0x00010000 && tables["maxp"].length >= 22) {
                tables["maxp"].data[26] = glyphsInfo.maxSizeOfInstructions >> 8;
                tables["maxp"].data[27] = glyphsInfo.maxSizeOfInstructions & 255;
              }
            }
            if (!tables["hhea"]) {
              throw new _util.FormatError("Required \"hhea\" table is not found");
            }
            if (tables["hhea"].data[10] === 0 && tables["hhea"].data[11] === 0) {
              tables["hhea"].data[10] = 0xFF;
              tables["hhea"].data[11] = 0xFF;
            }
            var metricsOverride = {
              unitsPerEm: int16(tables["head"].data[18], tables["head"].data[19]),
              yMax: int16(tables["head"].data[42], tables["head"].data[43]),
              yMin: signedInt16(tables["head"].data[38], tables["head"].data[39]),
              ascent: int16(tables["hhea"].data[4], tables["hhea"].data[5]),
              descent: signedInt16(tables["hhea"].data[6], tables["hhea"].data[7])
            };
            this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
            this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
            if (tables["post"]) {
              var valid = readPostScriptTable(tables["post"], properties, numGlyphs);
              if (!valid) {
                tables["post"] = null;
              }
            }
            var charCodeToGlyphId = [],
              charCode;
            function hasGlyph(glyphId) {
              return !missingGlyphs[glyphId];
            }
            if (properties.composite) {
              var cidToGidMap = properties.cidToGidMap || [];
              var isCidToGidMapEmpty = cidToGidMap.length === 0;
              properties.cMap.forEach(function (charCode, cid) {
                if (cid > 0xffff) {
                  throw new _util.FormatError("Max size of CID is 65,535");
                }
                var glyphId = -1;
                if (isCidToGidMapEmpty) {
                  glyphId = cid;
                } else if (cidToGidMap[cid] !== undefined) {
                  glyphId = cidToGidMap[cid];
                }
                if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) {
                  charCodeToGlyphId[charCode] = glyphId;
                }
              });
              if (dupFirstEntry && (isCidToGidMapEmpty || !charCodeToGlyphId[0])) {
                charCodeToGlyphId[0] = numGlyphs - 1;
              }
            } else {
              var cmapTable = readCmapTable(tables["cmap"], font, this.isSymbolicFont, properties.hasEncoding);
              var cmapPlatformId = cmapTable.platformId;
              var cmapEncodingId = cmapTable.encodingId;
              var cmapMappings = cmapTable.mappings;
              var cmapMappingsLength = cmapMappings.length;
              if (properties.hasEncoding && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0) || cmapPlatformId === -1 && cmapEncodingId === -1 && !!(0, _encodings.getEncoding)(properties.baseEncodingName)) {
                var baseEncoding = [];
                if (properties.baseEncodingName === "MacRomanEncoding" || properties.baseEncodingName === "WinAnsiEncoding") {
                  baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                }
                var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                for (charCode = 0; charCode < 256; charCode++) {
                  var glyphName, standardGlyphName;
                  if (this.differences && charCode in this.differences) {
                    glyphName = this.differences[charCode];
                  } else if (charCode in baseEncoding && baseEncoding[charCode] !== "") {
                    glyphName = baseEncoding[charCode];
                  } else {
                    glyphName = _encodings.StandardEncoding[charCode];
                  }
                  if (!glyphName) {
                    continue;
                  }
                  standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
                  var unicodeOrCharCode;
                  if (cmapPlatformId === 3 && cmapEncodingId === 1) {
                    unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
                  } else if (cmapPlatformId === 1 && cmapEncodingId === 0) {
                    unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
                  }
                  var found = false;
                  for (i = 0; i < cmapMappingsLength; ++i) {
                    if (cmapMappings[i].charCode !== unicodeOrCharCode) {
                      continue;
                    }
                    charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
                    found = true;
                    break;
                  }
                  if (!found && properties.glyphNames) {
                    var glyphId = properties.glyphNames.indexOf(glyphName);
                    if (glyphId === -1 && standardGlyphName !== glyphName) {
                      glyphId = properties.glyphNames.indexOf(standardGlyphName);
                    }
                    if (glyphId > 0 && hasGlyph(glyphId)) {
                      charCodeToGlyphId[charCode] = glyphId;
                      found = true;
                    }
                  }
                }
              } else if (cmapPlatformId === 0 && cmapEncodingId === 0) {
                for (i = 0; i < cmapMappingsLength; ++i) {
                  charCodeToGlyphId[cmapMappings[i].charCode] = cmapMappings[i].glyphId;
                }
              } else {
                for (i = 0; i < cmapMappingsLength; ++i) {
                  charCode = cmapMappings[i].charCode;
                  if (cmapPlatformId === 3 && charCode >= 0xF000 && charCode <= 0xF0FF) {
                    charCode &= 0xFF;
                  }
                  charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
                }
              }
            }
            if (charCodeToGlyphId.length === 0) {
              charCodeToGlyphId[0] = 0;
            }
            var newMapping = adjustMapping(charCodeToGlyphId, properties, missingGlyphs);
            this.toFontChar = newMapping.toFontChar;
            tables["cmap"] = {
              tag: "cmap",
              data: createCmapTable(newMapping.charCodeToGlyphId, numGlyphs)
            };
            if (!tables["OS/2"] || !validateOS2Table(tables["OS/2"])) {
              tables["OS/2"] = {
                tag: "OS/2",
                data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
              };
            }
            if (!tables["post"]) {
              tables["post"] = {
                tag: "post",
                data: createPostTable(properties)
              };
            }
            if (!isTrueType) {
              try {
                cffFile = new _stream.Stream(tables["CFF "].data);
                var parser = new _cff_parser.CFFParser(cffFile, properties, SEAC_ANALYSIS_ENABLED);
                cff = parser.parse();
                var compiler = new _cff_parser.CFFCompiler(cff);
                tables["CFF "].data = compiler.compile();
              } catch (e) {
                (0, _util.warn)("Failed to compile font " + properties.loadedName);
              }
            }
            if (!tables["name"]) {
              tables["name"] = {
                tag: "name",
                data: createNameTable(this.name)
              };
            } else {
              var namePrototype = readNameTable(tables["name"]);
              tables["name"].data = createNameTable(name, namePrototype);
            }
            var builder = new OpenTypeFileBuilder(header.version);
            for (var tableTag in tables) {
              builder.addTable(tableTag, tables[tableTag].data);
            }
            return builder.toArray();
          },
          convert: function Font_convert(fontName, font, properties) {
            properties.fixedPitch = false;
            if (properties.builtInEncoding) {
              adjustToUnicode(properties, properties.builtInEncoding);
            }
            var mapping = font.getGlyphMapping(properties);
            var newMapping = adjustMapping(mapping, properties, Object.create(null));
            this.toFontChar = newMapping.toFontChar;
            var numGlyphs = font.numGlyphs;
            function getCharCodes(charCodeToGlyphId, glyphId) {
              var charCodes = null;
              for (var charCode in charCodeToGlyphId) {
                if (glyphId === charCodeToGlyphId[charCode]) {
                  if (!charCodes) {
                    charCodes = [];
                  }
                  charCodes.push(charCode | 0);
                }
              }
              return charCodes;
            }
            function createCharCode(charCodeToGlyphId, glyphId) {
              for (var charCode in charCodeToGlyphId) {
                if (glyphId === charCodeToGlyphId[charCode]) {
                  return charCode | 0;
                }
              }
              newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
              return newMapping.nextAvailableFontCharCode++;
            }
            var seacs = font.seacs;
            if (SEAC_ANALYSIS_ENABLED && seacs && seacs.length) {
              var matrix = properties.fontMatrix || _util.FONT_IDENTITY_MATRIX;
              var charset = font.getCharset();
              var seacMap = Object.create(null);
              for (var glyphId in seacs) {
                glyphId |= 0;
                var seac = seacs[glyphId];
                var baseGlyphName = _encodings.StandardEncoding[seac[2]];
                var accentGlyphName = _encodings.StandardEncoding[seac[3]];
                var baseGlyphId = charset.indexOf(baseGlyphName);
                var accentGlyphId = charset.indexOf(accentGlyphName);
                if (baseGlyphId < 0 || accentGlyphId < 0) {
                  continue;
                }
                var accentOffset = {
                  x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
                  y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
                };
                var charCodes = getCharCodes(mapping, glyphId);
                if (!charCodes) {
                  continue;
                }
                for (var i = 0, ii = charCodes.length; i < ii; i++) {
                  var charCode = charCodes[i];
                  var charCodeToGlyphId = newMapping.charCodeToGlyphId;
                  var baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
                  var accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
                  seacMap[charCode] = {
                    baseFontCharCode: baseFontCharCode,
                    accentFontCharCode: accentFontCharCode,
                    accentOffset: accentOffset
                  };
                }
              }
              properties.seacMap = seacMap;
            }
            var unitsPerEm = 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
            var builder = new OpenTypeFileBuilder("\x4F\x54\x54\x4F");
            builder.addTable("CFF ", font.data);
            builder.addTable("OS/2", createOS2Table(properties, newMapping.charCodeToGlyphId));
            builder.addTable("cmap", createCmapTable(newMapping.charCodeToGlyphId, numGlyphs));
            builder.addTable("head", "\x00\x01\x00\x00" + "\x00\x00\x10\x00" + "\x00\x00\x00\x00" + "\x5F\x0F\x3C\xF5" + "\x00\x00" + safeString16(unitsPerEm) + "\x00\x00\x00\x00\x9e\x0b\x7e\x27" + "\x00\x00\x00\x00\x9e\x0b\x7e\x27" + "\x00\x00" + safeString16(properties.descent) + "\x0F\xFF" + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + "\x00\x11" + "\x00\x00" + "\x00\x00" + "\x00\x00");
            builder.addTable("hhea", "\x00\x01\x00\x00" + safeString16(properties.ascent) + safeString16(properties.descent) + "\x00\x00" + "\xFF\xFF" + "\x00\x00" + "\x00\x00" + "\x00\x00" + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + string16(numGlyphs));
            builder.addTable("hmtx", function fontFieldsHmtx() {
              var charstrings = font.charstrings;
              var cffWidths = font.cff ? font.cff.widths : null;
              var hmtx = "\x00\x00\x00\x00";
              for (var i = 1, ii = numGlyphs; i < ii; i++) {
                var width = 0;
                if (charstrings) {
                  var charstring = charstrings[i - 1];
                  width = "width" in charstring ? charstring.width : 0;
                } else if (cffWidths) {
                  width = Math.ceil(cffWidths[i] || 0);
                }
                hmtx += string16(width) + string16(0);
              }
              return hmtx;
            }());
            builder.addTable("maxp", "\x00\x00\x50\x00" + string16(numGlyphs));
            builder.addTable("name", createNameTable(fontName));
            builder.addTable("post", createPostTable(properties));
            return builder.toArray();
          },
          get spaceWidth() {
            if ("_shadowWidth" in this) {
              return this._shadowWidth;
            }
            var possibleSpaceReplacements = ["space", "minus", "one", "i", "I"];
            var width;
            for (var i = 0, ii = possibleSpaceReplacements.length; i < ii; i++) {
              var glyphName = possibleSpaceReplacements[i];
              if (glyphName in this.widths) {
                width = this.widths[glyphName];
                break;
              }
              var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
              var glyphUnicode = glyphsUnicodeMap[glyphName];
              var charcode = 0;
              if (this.composite) {
                if (this.cMap.contains(glyphUnicode)) {
                  charcode = this.cMap.lookup(glyphUnicode);
                }
              }
              if (!charcode && this.toUnicode) {
                charcode = this.toUnicode.charCodeOf(glyphUnicode);
              }
              if (charcode <= 0) {
                charcode = glyphUnicode;
              }
              width = this.widths[charcode];
              if (width) {
                break;
              }
            }
            width = width || this.defaultWidth;
            this._shadowWidth = width;
            return width;
          },
          charToGlyph: function Font_charToGlyph(charcode, isSpace) {
            var fontCharCode, width, operatorListId;
            var widthCode = charcode;
            if (this.cMap && this.cMap.contains(charcode)) {
              widthCode = this.cMap.lookup(charcode);
            }
            width = this.widths[widthCode];
            width = (0, _util.isNum)(width) ? width : this.defaultWidth;
            var vmetric = this.vmetrics && this.vmetrics[widthCode];
            var unicode = this.toUnicode.get(charcode) || charcode;
            if (typeof unicode === "number") {
              unicode = String.fromCharCode(unicode);
            }
            var isInFont = charcode in this.toFontChar;
            fontCharCode = this.toFontChar[charcode] || charcode;
            if (this.missingFile) {
              fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
            }
            if (this.isType3Font) {
              operatorListId = fontCharCode;
            }
            var accent = null;
            if (this.seacMap && this.seacMap[charcode]) {
              isInFont = true;
              var seac = this.seacMap[charcode];
              fontCharCode = seac.baseFontCharCode;
              accent = {
                fontChar: String.fromCharCode(seac.accentFontCharCode),
                offset: seac.accentOffset
              };
            }
            var fontChar = String.fromCharCode(fontCharCode);
            var glyph = this.glyphCache[charcode];
            if (!glyph || !glyph.matchesForCache(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont)) {
              glyph = new Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
              this.glyphCache[charcode] = glyph;
            }
            return glyph;
          },
          charsToGlyphs: function Font_charsToGlyphs(chars) {
            var charsCache = this.charsCache;
            var glyphs, glyph, charcode;
            if (charsCache) {
              glyphs = charsCache[chars];
              if (glyphs) {
                return glyphs;
              }
            }
            if (!charsCache) {
              charsCache = this.charsCache = Object.create(null);
            }
            glyphs = [];
            var charsCacheKey = chars;
            var i = 0,
              ii;
            if (this.cMap) {
              var c = Object.create(null);
              while (i < chars.length) {
                this.cMap.readCharCode(chars, i, c);
                charcode = c.charcode;
                var length = c.length;
                i += length;
                var isSpace = length === 1 && chars.charCodeAt(i - 1) === 0x20;
                glyph = this.charToGlyph(charcode, isSpace);
                glyphs.push(glyph);
              }
            } else {
              for (i = 0, ii = chars.length; i < ii; ++i) {
                charcode = chars.charCodeAt(i);
                glyph = this.charToGlyph(charcode, charcode === 0x20);
                glyphs.push(glyph);
              }
            }
            return charsCache[charsCacheKey] = glyphs;
          }
        };
        return Font;
      }();
      var ErrorFont = function ErrorFontClosure() {
        function ErrorFont(error) {
          this.error = error;
          this.loadedName = "g_font_error";
          this.loading = false;
        }
        ErrorFont.prototype = {
          charsToGlyphs: function ErrorFont_charsToGlyphs() {
            return [];
          },
          exportData: function ErrorFont_exportData() {
            return { error: this.error };
          }
        };
        return ErrorFont;
      }();
      function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
        var charCodeToGlyphId = Object.create(null);
        var glyphId, charCode, baseEncoding;
        var isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
        if (properties.baseEncodingName) {
          baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
          for (charCode = 0; charCode < baseEncoding.length; charCode++) {
            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
            if (glyphId >= 0) {
              charCodeToGlyphId[charCode] = glyphId;
            } else {
              charCodeToGlyphId[charCode] = 0;
            }
          }
        } else if (isSymbolicFont) {
          for (charCode in builtInEncoding) {
            charCodeToGlyphId[charCode] = builtInEncoding[charCode];
          }
        } else {
          baseEncoding = _encodings.StandardEncoding;
          for (charCode = 0; charCode < baseEncoding.length; charCode++) {
            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
            if (glyphId >= 0) {
              charCodeToGlyphId[charCode] = glyphId;
            } else {
              charCodeToGlyphId[charCode] = 0;
            }
          }
        }
        var differences = properties.differences,
          glyphsUnicodeMap;
        if (differences) {
          for (charCode in differences) {
            var glyphName = differences[charCode];
            glyphId = glyphNames.indexOf(glyphName);
            if (glyphId === -1) {
              if (!glyphsUnicodeMap) {
                glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
              }
              var standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
              if (standardGlyphName !== glyphName) {
                glyphId = glyphNames.indexOf(standardGlyphName);
              }
            }
            if (glyphId >= 0) {
              charCodeToGlyphId[charCode] = glyphId;
            } else {
              charCodeToGlyphId[charCode] = 0;
            }
          }
        }
        return charCodeToGlyphId;
      }
      var Type1Font = function Type1FontClosure() {
        function findBlock(streamBytes, signature, startIndex) {
          var streamBytesLength = streamBytes.length;
          var signatureLength = signature.length;
          var scanLength = streamBytesLength - signatureLength;
          var i = startIndex,
            j,
            found = false;
          while (i < scanLength) {
            j = 0;
            while (j < signatureLength && streamBytes[i + j] === signature[j]) {
              j++;
            }
            if (j >= signatureLength) {
              i += j;
              while (i < streamBytesLength && (0, _util.isSpace)(streamBytes[i])) {
                i++;
              }
              found = true;
              break;
            }
            i++;
          }
          return {
            found: found,
            length: i
          };
        }
        function getHeaderBlock(stream, suggestedLength) {
          var EEXEC_SIGNATURE = [0x65, 0x65, 0x78, 0x65, 0x63];
          var streamStartPos = stream.pos;
          var headerBytes, headerBytesLength, block;
          try {
            headerBytes = stream.getBytes(suggestedLength);
            headerBytesLength = headerBytes.length;
          } catch (ex) {
            if (ex instanceof _util.MissingDataException) {
              throw ex;
            }
          }
          if (headerBytesLength === suggestedLength) {
            block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
            if (block.found && block.length === suggestedLength) {
              return {
                stream: new _stream.Stream(headerBytes),
                length: suggestedLength
              };
            }
          }
          (0, _util.warn)("Invalid \"Length1\" property in Type1 font -- trying to recover.");
          stream.pos = streamStartPos;
          var SCAN_BLOCK_LENGTH = 2048;
          var actualLength;
          while (true) {
            var scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
            block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
            if (block.length === 0) {
              break;
            }
            stream.pos += block.length;
            if (block.found) {
              actualLength = stream.pos - streamStartPos;
              break;
            }
          }
          stream.pos = streamStartPos;
          if (actualLength) {
            return {
              stream: new _stream.Stream(stream.getBytes(actualLength)),
              length: actualLength
            };
          }
          (0, _util.warn)("Unable to recover \"Length1\" property in Type1 font -- using as is.");
          return {
            stream: new _stream.Stream(stream.getBytes(suggestedLength)),
            length: suggestedLength
          };
        }
        function getEexecBlock(stream, suggestedLength) {
          var eexecBytes = stream.getBytes();
          return {
            stream: new _stream.Stream(eexecBytes),
            length: eexecBytes.length
          };
        }
        function Type1Font(name, file, properties) {
          var PFB_HEADER_SIZE = 6;
          var headerBlockLength = properties.length1;
          var eexecBlockLength = properties.length2;
          var pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
          var pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
          if (pfbHeaderPresent) {
            file.skip(PFB_HEADER_SIZE);
            headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
          }
          var headerBlock = getHeaderBlock(file, headerBlockLength);
          headerBlockLength = headerBlock.length;
          var headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, SEAC_ANALYSIS_ENABLED);
          headerBlockParser.extractFontHeader(properties);
          if (pfbHeaderPresent) {
            pfbHeader = file.getBytes(PFB_HEADER_SIZE);
            eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
          }
          var eexecBlock = getEexecBlock(file, eexecBlockLength);
          eexecBlockLength = eexecBlock.length;
          var eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, SEAC_ANALYSIS_ENABLED);
          var data = eexecBlockParser.extractFontProgram();
          for (var info in data.properties) {
            properties[info] = data.properties[info];
          }
          var charstrings = data.charstrings;
          var type2Charstrings = this.getType2Charstrings(charstrings);
          var subrs = this.getType2Subrs(data.subrs);
          this.charstrings = charstrings;
          this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
          this.seacs = this.getSeacs(data.charstrings);
        }
        Type1Font.prototype = {
          get numGlyphs() {
            return this.charstrings.length + 1;
          },
          getCharset: function Type1Font_getCharset() {
            var charset = [".notdef"];
            var charstrings = this.charstrings;
            for (var glyphId = 0; glyphId < charstrings.length; glyphId++) {
              charset.push(charstrings[glyphId].glyphName);
            }
            return charset;
          },
          getGlyphMapping: function Type1Font_getGlyphMapping(properties) {
            var charstrings = this.charstrings;
            var glyphNames = [".notdef"],
              glyphId;
            for (glyphId = 0; glyphId < charstrings.length; glyphId++) {
              glyphNames.push(charstrings[glyphId].glyphName);
            }
            var encoding = properties.builtInEncoding;
            if (encoding) {
              var builtInEncoding = Object.create(null);
              for (var charCode in encoding) {
                glyphId = glyphNames.indexOf(encoding[charCode]);
                if (glyphId >= 0) {
                  builtInEncoding[charCode] = glyphId;
                }
              }
            }
            return type1FontGlyphMapping(properties, builtInEncoding, glyphNames);
          },
          getSeacs: function Type1Font_getSeacs(charstrings) {
            var i, ii;
            var seacMap = [];
            for (i = 0, ii = charstrings.length; i < ii; i++) {
              var charstring = charstrings[i];
              if (charstring.seac) {
                seacMap[i + 1] = charstring.seac;
              }
            }
            return seacMap;
          },
          getType2Charstrings: function Type1Font_getType2Charstrings(type1Charstrings) {
            var type2Charstrings = [];
            for (var i = 0, ii = type1Charstrings.length; i < ii; i++) {
              type2Charstrings.push(type1Charstrings[i].charstring);
            }
            return type2Charstrings;
          },
          getType2Subrs: function Type1Font_getType2Subrs(type1Subrs) {
            var bias = 0;
            var count = type1Subrs.length;
            if (count < 1133) {
              bias = 107;
            } else if (count < 33769) {
              bias = 1131;
            } else {
              bias = 32768;
            }
            var type2Subrs = [];
            var i;
            for (i = 0; i < bias; i++) {
              type2Subrs.push([0x0B]);
            }
            for (i = 0; i < count; i++) {
              type2Subrs.push(type1Subrs[i]);
            }
            return type2Subrs;
          },
          wrap: function Type1Font_wrap(name, glyphs, charstrings, subrs, properties) {
            var cff = new _cff_parser.CFF();
            cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
            cff.names = [name];
            var topDict = new _cff_parser.CFFTopDict();
            topDict.setByName("version", 391);
            topDict.setByName("Notice", 392);
            topDict.setByName("FullName", 393);
            topDict.setByName("FamilyName", 394);
            topDict.setByName("Weight", 395);
            topDict.setByName("Encoding", null);
            topDict.setByName("FontMatrix", properties.fontMatrix);
            topDict.setByName("FontBBox", properties.bbox);
            topDict.setByName("charset", null);
            topDict.setByName("CharStrings", null);
            topDict.setByName("Private", null);
            cff.topDict = topDict;
            var strings = new _cff_parser.CFFStrings();
            strings.add("Version 0.11");
            strings.add("See original notice");
            strings.add(name);
            strings.add(name);
            strings.add("Medium");
            cff.strings = strings;
            cff.globalSubrIndex = new _cff_parser.CFFIndex();
            var count = glyphs.length;
            var charsetArray = [0];
            var i, ii;
            for (i = 0; i < count; i++) {
              var index = _cff_parser.CFFStandardStrings.indexOf(charstrings[i].glyphName);
              if (index === -1) {
                index = 0;
              }
              charsetArray.push(index >> 8 & 0xff, index & 0xff);
            }
            cff.charset = new _cff_parser.CFFCharset(false, 0, [], charsetArray);
            var charStringsIndex = new _cff_parser.CFFIndex();
            charStringsIndex.add([0x8B, 0x0E]);
            for (i = 0; i < count; i++) {
              var glyph = glyphs[i];
              if (glyph.length === 0) {
                charStringsIndex.add([0x8B, 0x0E]);
                continue;
              }
              charStringsIndex.add(glyph);
            }
            cff.charStrings = charStringsIndex;
            var privateDict = new _cff_parser.CFFPrivateDict();
            privateDict.setByName("Subrs", null);
            var fields = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
            for (i = 0, ii = fields.length; i < ii; i++) {
              var field = fields[i];
              if (!(field in properties.privateData)) {
                continue;
              }
              var value = properties.privateData[field];
              if (Array.isArray(value)) {
                for (var j = value.length - 1; j > 0; j--) {
                  value[j] -= value[j - 1];
                }
              }
              privateDict.setByName(field, value);
            }
            cff.topDict.privateDict = privateDict;
            var subrIndex = new _cff_parser.CFFIndex();
            for (i = 0, ii = subrs.length; i < ii; i++) {
              subrIndex.add(subrs[i]);
            }
            privateDict.subrsIndex = subrIndex;
            var compiler = new _cff_parser.CFFCompiler(cff);
            return compiler.compile();
          }
        };
        return Type1Font;
      }();
      var CFFFont = function CFFFontClosure() {
        function CFFFont(file, properties) {
          this.properties = properties;
          var parser = new _cff_parser.CFFParser(file, properties, SEAC_ANALYSIS_ENABLED);
          this.cff = parser.parse();
          var compiler = new _cff_parser.CFFCompiler(this.cff);
          this.seacs = this.cff.seacs;
          try {
            this.data = compiler.compile();
          } catch (e) {
            (0, _util.warn)("Failed to compile font " + properties.loadedName);
            this.data = file;
          }
        }
        CFFFont.prototype = {
          get numGlyphs() {
            return this.cff.charStrings.count;
          },
          getCharset: function CFFFont_getCharset() {
            return this.cff.charset.charset;
          },
          getGlyphMapping: function CFFFont_getGlyphMapping() {
            var cff = this.cff;
            var properties = this.properties;
            var charsets = cff.charset.charset;
            var charCodeToGlyphId;
            var glyphId;
            if (properties.composite) {
              charCodeToGlyphId = Object.create(null);
              if (cff.isCIDFont) {
                for (glyphId = 0; glyphId < charsets.length; glyphId++) {
                  var cid = charsets[glyphId];
                  var charCode = properties.cMap.charCodeOf(cid);
                  charCodeToGlyphId[charCode] = glyphId;
                }
              } else {
                for (glyphId = 0; glyphId < cff.charStrings.count; glyphId++) {
                  charCodeToGlyphId[glyphId] = glyphId;
                }
              }
              return charCodeToGlyphId;
            }
            var encoding = cff.encoding ? cff.encoding.encoding : null;
            charCodeToGlyphId = type1FontGlyphMapping(properties, encoding, charsets);
            return charCodeToGlyphId;
          }
        };
        return CFFFont;
      }();
      (function checkSeacSupport() {
        if (typeof navigator !== "undefined" && /Windows/.test(navigator.userAgent)) {
          exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED = true;
        }
      })();
      (function checkChromeWindows() {
        if (typeof navigator !== "undefined" && /Windows.*Chrome/.test(navigator.userAgent)) {
          SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = true;
        }
      })();
      exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
      exports.PRIVATE_USE_OFFSET_START = PRIVATE_USE_OFFSET_START;
      exports.PRIVATE_USE_OFFSET_END = PRIVATE_USE_OFFSET_END;
      exports.ErrorFont = ErrorFont;
      exports.Font = Font;
      exports.FontFlags = FontFlags;
      exports.ToUnicodeMap = ToUnicodeMap;
      exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
      exports.ProblematicCharRanges = ProblematicCharRanges;
      exports.getFontType = getFontType;

      /***/ }),
    /* 135 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var ISOAdobeCharset = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"];
      var ExpertCharset = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
      var ExpertSubsetCharset = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
      exports.ISOAdobeCharset = ISOAdobeCharset;
      exports.ExpertCharset = ExpertCharset;
      exports.ExpertSubsetCharset = ExpertSubsetCharset;

      /***/ }),
    /* 136 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FontRendererFactory = undefined;

      var _util = __w_pdfjs_require__(0);

      var _cff_parser = __w_pdfjs_require__(78);

      var _glyphlist = __w_pdfjs_require__(47);

      var _encodings = __w_pdfjs_require__(27);

      var _stream = __w_pdfjs_require__(5);

      var FontRendererFactory = function FontRendererFactoryClosure() {
        function getLong(data, offset) {
          return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
        }
        function getUshort(data, offset) {
          return data[offset] << 8 | data[offset + 1];
        }
        function parseCmap(data, start, end) {
          var offset = getUshort(data, start + 2) === 1 ? getLong(data, start + 8) : getLong(data, start + 16);
          var format = getUshort(data, start + offset);
          var ranges, p, i;
          if (format === 4) {
            getUshort(data, start + offset + 2);
            var segCount = getUshort(data, start + offset + 6) >> 1;
            p = start + offset + 14;
            ranges = [];
            for (i = 0; i < segCount; i++, p += 2) {
              ranges[i] = { end: getUshort(data, p) };
            }
            p += 2;
            for (i = 0; i < segCount; i++, p += 2) {
              ranges[i].start = getUshort(data, p);
            }
            for (i = 0; i < segCount; i++, p += 2) {
              ranges[i].idDelta = getUshort(data, p);
            }
            for (i = 0; i < segCount; i++, p += 2) {
              var idOffset = getUshort(data, p);
              if (idOffset === 0) {
                continue;
              }
              ranges[i].ids = [];
              for (var j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++) {
                ranges[i].ids[j] = getUshort(data, p + idOffset);
                idOffset += 2;
              }
            }
            return ranges;
          } else if (format === 12) {
            getLong(data, start + offset + 4);
            var groups = getLong(data, start + offset + 12);
            p = start + offset + 16;
            ranges = [];
            for (i = 0; i < groups; i++) {
              ranges.push({
                start: getLong(data, p),
                end: getLong(data, p + 4),
                idDelta: getLong(data, p + 8) - getLong(data, p)
              });
              p += 12;
            }
            return ranges;
          }
          throw new _util.FormatError("unsupported cmap: " + format);
        }
        function parseCff(data, start, end, seacAnalysisEnabled) {
          var properties = {};
          var parser = new _cff_parser.CFFParser(new _stream.Stream(data, start, end - start), properties, seacAnalysisEnabled);
          var cff = parser.parse();
          return {
            glyphs: cff.charStrings.objects,
            subrs: cff.topDict.privateDict && cff.topDict.privateDict.subrsIndex && cff.topDict.privateDict.subrsIndex.objects,
            gsubrs: cff.globalSubrIndex && cff.globalSubrIndex.objects
          };
        }
        function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
          var itemSize, itemDecode;
          if (isGlyphLocationsLong) {
            itemSize = 4;
            itemDecode = function fontItemDecodeLong(data, offset) {
              return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
            };
          } else {
            itemSize = 2;
            itemDecode = function fontItemDecode(data, offset) {
              return data[offset] << 9 | data[offset + 1] << 1;
            };
          }
          var glyphs = [];
          var startOffset = itemDecode(loca, 0);
          for (var j = itemSize; j < loca.length; j += itemSize) {
            var endOffset = itemDecode(loca, j);
            glyphs.push(glyf.subarray(startOffset, endOffset));
            startOffset = endOffset;
          }
          return glyphs;
        }
        function lookupCmap(ranges, unicode) {
          var code = unicode.charCodeAt(0),
            gid = 0;
          var l = 0,
            r = ranges.length - 1;
          while (l < r) {
            var c = l + r + 1 >> 1;
            if (code < ranges[c].start) {
              r = c - 1;
            } else {
              l = c;
            }
          }
          if (ranges[l].start <= code && code <= ranges[l].end) {
            gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xFFFF;
          }
          return {
            charCode: code,
            glyphId: gid
          };
        }
        function compileGlyf(code, cmds, font) {
          function moveTo(x, y) {
            cmds.push({
              cmd: "moveTo",
              args: [x, y]
            });
          }
          function lineTo(x, y) {
            cmds.push({
              cmd: "lineTo",
              args: [x, y]
            });
          }
          function quadraticCurveTo(xa, ya, x, y) {
            cmds.push({
              cmd: "quadraticCurveTo",
              args: [xa, ya, x, y]
            });
          }
          var i = 0;
          var numberOfContours = (code[i] << 24 | code[i + 1] << 16) >> 16;
          var flags;
          var x = 0,
            y = 0;
          i += 10;
          if (numberOfContours < 0) {
            do {
              flags = code[i] << 8 | code[i + 1];
              var glyphIndex = code[i + 2] << 8 | code[i + 3];
              i += 4;
              var arg1, arg2;
              if (flags & 0x01) {
                arg1 = (code[i] << 24 | code[i + 1] << 16) >> 16;
                arg2 = (code[i + 2] << 24 | code[i + 3] << 16) >> 16;
                i += 4;
              } else {
                arg1 = code[i++];
                arg2 = code[i++];
              }
              if (flags & 0x02) {
                x = arg1;
                y = arg2;
              } else {
                x = 0;
                y = 0;
              }
              var scaleX = 1,
                scaleY = 1,
                scale01 = 0,
                scale10 = 0;
              if (flags & 0x08) {
                scaleX = scaleY = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
                i += 2;
              } else if (flags & 0x40) {
                scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
                scaleY = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
                i += 4;
              } else if (flags & 0x80) {
                scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
                scale01 = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
                scale10 = (code[i + 4] << 24 | code[i + 5] << 16) / 1073741824;
                scaleY = (code[i + 6] << 24 | code[i + 7] << 16) / 1073741824;
                i += 8;
              }
              var subglyph = font.glyphs[glyphIndex];
              if (subglyph) {
                cmds.push({ cmd: "save" });
                cmds.push({
                  cmd: "transform",
                  args: [scaleX, scale01, scale10, scaleY, x, y]
                });
                compileGlyf(subglyph, cmds, font);
                cmds.push({ cmd: "restore" });
              }
            } while (flags & 0x20);
          } else {
            var endPtsOfContours = [];
            var j, jj;
            for (j = 0; j < numberOfContours; j++) {
              endPtsOfContours.push(code[i] << 8 | code[i + 1]);
              i += 2;
            }
            var instructionLength = code[i] << 8 | code[i + 1];
            i += 2 + instructionLength;
            var numberOfPoints = endPtsOfContours[endPtsOfContours.length - 1] + 1;
            var points = [];
            while (points.length < numberOfPoints) {
              flags = code[i++];
              var repeat = 1;
              if (flags & 0x08) {
                repeat += code[i++];
              }
              while (repeat-- > 0) {
                points.push({ flags: flags });
              }
            }
            for (j = 0; j < numberOfPoints; j++) {
              switch (points[j].flags & 0x12) {
                case 0x00:
                  x += (code[i] << 24 | code[i + 1] << 16) >> 16;
                  i += 2;
                  break;
                case 0x02:
                  x -= code[i++];
                  break;
                case 0x12:
                  x += code[i++];
                  break;
              }
              points[j].x = x;
            }
            for (j = 0; j < numberOfPoints; j++) {
              switch (points[j].flags & 0x24) {
                case 0x00:
                  y += (code[i] << 24 | code[i + 1] << 16) >> 16;
                  i += 2;
                  break;
                case 0x04:
                  y -= code[i++];
                  break;
                case 0x24:
                  y += code[i++];
                  break;
              }
              points[j].y = y;
            }
            var startPoint = 0;
            for (i = 0; i < numberOfContours; i++) {
              var endPoint = endPtsOfContours[i];
              var contour = points.slice(startPoint, endPoint + 1);
              if (contour[0].flags & 1) {
                contour.push(contour[0]);
              } else if (contour[contour.length - 1].flags & 1) {
                contour.unshift(contour[contour.length - 1]);
              } else {
                var p = {
                  flags: 1,
                  x: (contour[0].x + contour[contour.length - 1].x) / 2,
                  y: (contour[0].y + contour[contour.length - 1].y) / 2
                };
                contour.unshift(p);
                contour.push(p);
              }
              moveTo(contour[0].x, contour[0].y);
              for (j = 1, jj = contour.length; j < jj; j++) {
                if (contour[j].flags & 1) {
                  lineTo(contour[j].x, contour[j].y);
                } else if (contour[j + 1].flags & 1) {
                  quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
                  j++;
                } else {
                  quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
                }
              }
              startPoint = endPoint + 1;
            }
          }
        }
        function compileCharString(code, cmds, font) {
          var stack = [];
          var x = 0,
            y = 0;
          var stems = 0;
          function moveTo(x, y) {
            cmds.push({
              cmd: "moveTo",
              args: [x, y]
            });
          }
          function lineTo(x, y) {
            cmds.push({
              cmd: "lineTo",
              args: [x, y]
            });
          }
          function bezierCurveTo(x1, y1, x2, y2, x, y) {
            cmds.push({
              cmd: "bezierCurveTo",
              args: [x1, y1, x2, y2, x, y]
            });
          }
          function parse(code) {
            var i = 0;
            while (i < code.length) {
              var stackClean = false;
              var v = code[i++];
              var xa, xb, ya, yb, y1, y2, y3, n, subrCode;
              switch (v) {
                case 1:
                  stems += stack.length >> 1;
                  stackClean = true;
                  break;
                case 3:
                  stems += stack.length >> 1;
                  stackClean = true;
                  break;
                case 4:
                  y += stack.pop();
                  moveTo(x, y);
                  stackClean = true;
                  break;
                case 5:
                  while (stack.length > 0) {
                    x += stack.shift();
                    y += stack.shift();
                    lineTo(x, y);
                  }
                  break;
                case 6:
                  while (stack.length > 0) {
                    x += stack.shift();
                    lineTo(x, y);
                    if (stack.length === 0) {
                      break;
                    }
                    y += stack.shift();
                    lineTo(x, y);
                  }
                  break;
                case 7:
                  while (stack.length > 0) {
                    y += stack.shift();
                    lineTo(x, y);
                    if (stack.length === 0) {
                      break;
                    }
                    x += stack.shift();
                    lineTo(x, y);
                  }
                  break;
                case 8:
                  while (stack.length > 0) {
                    xa = x + stack.shift();
                    ya = y + stack.shift();
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    x = xb + stack.shift();
                    y = yb + stack.shift();
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                  }
                  break;
                case 10:
                  n = stack.pop() + font.subrsBias;
                  subrCode = font.subrs[n];
                  if (subrCode) {
                    parse(subrCode);
                  }
                  break;
                case 11:
                  return;
                case 12:
                  v = code[i++];
                  switch (v) {
                    case 34:
                      xa = x + stack.shift();
                      xb = xa + stack.shift();
                      y1 = y + stack.shift();
                      x = xb + stack.shift();
                      bezierCurveTo(xa, y, xb, y1, x, y1);
                      xa = x + stack.shift();
                      xb = xa + stack.shift();
                      x = xb + stack.shift();
                      bezierCurveTo(xa, y1, xb, y, x, y);
                      break;
                    case 35:
                      xa = x + stack.shift();
                      ya = y + stack.shift();
                      xb = xa + stack.shift();
                      yb = ya + stack.shift();
                      x = xb + stack.shift();
                      y = yb + stack.shift();
                      bezierCurveTo(xa, ya, xb, yb, x, y);
                      xa = x + stack.shift();
                      ya = y + stack.shift();
                      xb = xa + stack.shift();
                      yb = ya + stack.shift();
                      x = xb + stack.shift();
                      y = yb + stack.shift();
                      bezierCurveTo(xa, ya, xb, yb, x, y);
                      stack.pop();
                      break;
                    case 36:
                      xa = x + stack.shift();
                      y1 = y + stack.shift();
                      xb = xa + stack.shift();
                      y2 = y1 + stack.shift();
                      x = xb + stack.shift();
                      bezierCurveTo(xa, y1, xb, y2, x, y2);
                      xa = x + stack.shift();
                      xb = xa + stack.shift();
                      y3 = y2 + stack.shift();
                      x = xb + stack.shift();
                      bezierCurveTo(xa, y2, xb, y3, x, y);
                      break;
                    case 37:
                      var x0 = x,
                        y0 = y;
                      xa = x + stack.shift();
                      ya = y + stack.shift();
                      xb = xa + stack.shift();
                      yb = ya + stack.shift();
                      x = xb + stack.shift();
                      y = yb + stack.shift();
                      bezierCurveTo(xa, ya, xb, yb, x, y);
                      xa = x + stack.shift();
                      ya = y + stack.shift();
                      xb = xa + stack.shift();
                      yb = ya + stack.shift();
                      x = xb;
                      y = yb;
                      if (Math.abs(x - x0) > Math.abs(y - y0)) {
                        x += stack.shift();
                      } else {
                        y += stack.shift();
                      }
                      bezierCurveTo(xa, ya, xb, yb, x, y);
                      break;
                    default:
                      throw new _util.FormatError("unknown operator: 12 " + v);
                  }
                  break;
                case 14:
                  if (stack.length >= 4) {
                    var achar = stack.pop();
                    var bchar = stack.pop();
                    y = stack.pop();
                    x = stack.pop();
                    cmds.push({ cmd: "save" });
                    cmds.push({
                      cmd: "translate",
                      args: [x, y]
                    });
                    var cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[achar]]));
                    compileCharString(font.glyphs[cmap.glyphId], cmds, font);
                    cmds.push({ cmd: "restore" });
                    cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[bchar]]));
                    compileCharString(font.glyphs[cmap.glyphId], cmds, font);
                  }
                  return;
                case 18:
                  stems += stack.length >> 1;
                  stackClean = true;
                  break;
                case 19:
                  stems += stack.length >> 1;
                  i += stems + 7 >> 3;
                  stackClean = true;
                  break;
                case 20:
                  stems += stack.length >> 1;
                  i += stems + 7 >> 3;
                  stackClean = true;
                  break;
                case 21:
                  y += stack.pop();
                  x += stack.pop();
                  moveTo(x, y);
                  stackClean = true;
                  break;
                case 22:
                  x += stack.pop();
                  moveTo(x, y);
                  stackClean = true;
                  break;
                case 23:
                  stems += stack.length >> 1;
                  stackClean = true;
                  break;
                case 24:
                  while (stack.length > 2) {
                    xa = x + stack.shift();
                    ya = y + stack.shift();
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    x = xb + stack.shift();
                    y = yb + stack.shift();
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                  }
                  x += stack.shift();
                  y += stack.shift();
                  lineTo(x, y);
                  break;
                case 25:
                  while (stack.length > 6) {
                    x += stack.shift();
                    y += stack.shift();
                    lineTo(x, y);
                  }
                  xa = x + stack.shift();
                  ya = y + stack.shift();
                  xb = xa + stack.shift();
                  yb = ya + stack.shift();
                  x = xb + stack.shift();
                  y = yb + stack.shift();
                  bezierCurveTo(xa, ya, xb, yb, x, y);
                  break;
                case 26:
                  if (stack.length % 2) {
                    x += stack.shift();
                  }
                  while (stack.length > 0) {
                    xa = x;
                    ya = y + stack.shift();
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    x = xb;
                    y = yb + stack.shift();
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                  }
                  break;
                case 27:
                  if (stack.length % 2) {
                    y += stack.shift();
                  }
                  while (stack.length > 0) {
                    xa = x + stack.shift();
                    ya = y;
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    x = xb + stack.shift();
                    y = yb;
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                  }
                  break;
                case 28:
                  stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
                  i += 2;
                  break;
                case 29:
                  n = stack.pop() + font.gsubrsBias;
                  subrCode = font.gsubrs[n];
                  if (subrCode) {
                    parse(subrCode);
                  }
                  break;
                case 30:
                  while (stack.length > 0) {
                    xa = x;
                    ya = y + stack.shift();
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    x = xb + stack.shift();
                    y = yb + (stack.length === 1 ? stack.shift() : 0);
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                    if (stack.length === 0) {
                      break;
                    }
                    xa = x + stack.shift();
                    ya = y;
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    y = yb + stack.shift();
                    x = xb + (stack.length === 1 ? stack.shift() : 0);
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                  }
                  break;
                case 31:
                  while (stack.length > 0) {
                    xa = x + stack.shift();
                    ya = y;
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    y = yb + stack.shift();
                    x = xb + (stack.length === 1 ? stack.shift() : 0);
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                    if (stack.length === 0) {
                      break;
                    }
                    xa = x;
                    ya = y + stack.shift();
                    xb = xa + stack.shift();
                    yb = ya + stack.shift();
                    x = xb + stack.shift();
                    y = yb + (stack.length === 1 ? stack.shift() : 0);
                    bezierCurveTo(xa, ya, xb, yb, x, y);
                  }
                  break;
                default:
                  if (v < 32) {
                    throw new _util.FormatError("unknown operator: " + v);
                  }
                  if (v < 247) {
                    stack.push(v - 139);
                  } else if (v < 251) {
                    stack.push((v - 247) * 256 + code[i++] + 108);
                  } else if (v < 255) {
                    stack.push(-(v - 251) * 256 - code[i++] - 108);
                  } else {
                    stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
                    i += 4;
                  }
                  break;
              }
              if (stackClean) {
                stack.length = 0;
              }
            }
          }
          parse(code);
        }
        var noop = "";
        function CompiledFont(fontMatrix) {
          this.compiledGlyphs = Object.create(null);
          this.compiledCharCodeToGlyphId = Object.create(null);
          this.fontMatrix = fontMatrix;
        }
        CompiledFont.prototype = {
          getPathJs: function getPathJs(unicode) {
            var cmap = lookupCmap(this.cmap, unicode);
            var fn = this.compiledGlyphs[cmap.glyphId];
            if (!fn) {
              fn = this.compileGlyph(this.glyphs[cmap.glyphId]);
              this.compiledGlyphs[cmap.glyphId] = fn;
            }
            if (this.compiledCharCodeToGlyphId[cmap.charCode] === undefined) {
              this.compiledCharCodeToGlyphId[cmap.charCode] = cmap.glyphId;
            }
            return fn;
          },
          compileGlyph: function compileGlyph(code) {
            if (!code || code.length === 0 || code[0] === 14) {
              return noop;
            }
            var cmds = [];
            cmds.push({ cmd: "save" });
            cmds.push({
              cmd: "transform",
              args: this.fontMatrix.slice()
            });
            cmds.push({
              cmd: "scale",
              args: ["size", "-size"]
            });
            this.compileGlyphImpl(code, cmds);
            cmds.push({ cmd: "restore" });
            return cmds;
          },
          compileGlyphImpl: function compileGlyphImpl() {
            throw new Error("Children classes should implement this.");
          },
          hasBuiltPath: function hasBuiltPath(unicode) {
            var cmap = lookupCmap(this.cmap, unicode);
            return this.compiledGlyphs[cmap.glyphId] !== undefined && this.compiledCharCodeToGlyphId[cmap.charCode] !== undefined;
          }
        };
        function TrueTypeCompiled(glyphs, cmap, fontMatrix) {
          fontMatrix = fontMatrix || [0.000488, 0, 0, 0.000488, 0, 0];
          CompiledFont.call(this, fontMatrix);
          this.glyphs = glyphs;
          this.cmap = cmap;
        }
        _util.Util.inherit(TrueTypeCompiled, CompiledFont, {
          compileGlyphImpl: function compileGlyphImpl(code, cmds) {
            compileGlyf(code, cmds, this);
          }
        });
        function Type2Compiled(cffInfo, cmap, fontMatrix, glyphNameMap) {
          fontMatrix = fontMatrix || [0.001, 0, 0, 0.001, 0, 0];
          CompiledFont.call(this, fontMatrix);
          this.glyphs = cffInfo.glyphs;
          this.gsubrs = cffInfo.gsubrs || [];
          this.subrs = cffInfo.subrs || [];
          this.cmap = cmap;
          this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
          this.gsubrsBias = this.gsubrs.length < 1240 ? 107 : this.gsubrs.length < 33900 ? 1131 : 32768;
          this.subrsBias = this.subrs.length < 1240 ? 107 : this.subrs.length < 33900 ? 1131 : 32768;
        }
        _util.Util.inherit(Type2Compiled, CompiledFont, {
          compileGlyphImpl: function compileGlyphImpl(code, cmds) {
            compileCharString(code, cmds, this);
          }
        });
        return {
          create: function FontRendererFactory_create(font, seacAnalysisEnabled) {
            var data = new Uint8Array(font.data);
            var cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
            var numTables = getUshort(data, 4);
            for (var i = 0, p = 12; i < numTables; i++, p += 16) {
              var tag = (0, _util.bytesToString)(data.subarray(p, p + 4));
              var offset = getLong(data, p + 8);
              var length = getLong(data, p + 12);
              switch (tag) {
                case "cmap":
                  cmap = parseCmap(data, offset, offset + length);
                  break;
                case "glyf":
                  glyf = data.subarray(offset, offset + length);
                  break;
                case "loca":
                  loca = data.subarray(offset, offset + length);
                  break;
                case "head":
                  unitsPerEm = getUshort(data, offset + 18);
                  indexToLocFormat = getUshort(data, offset + 50);
                  break;
                case "CFF ":
                  cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
                  break;
              }
            }
            if (glyf) {
              var fontMatrix = !unitsPerEm ? font.fontMatrix : [1 / unitsPerEm, 0, 0, 1 / unitsPerEm, 0, 0];
              return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
            }
            return new Type2Compiled(cff, cmap, font.fontMatrix, font.glyphNameMap);
          }
        };
      }();
      exports.FontRendererFactory = FontRendererFactory;

      /***/ }),
    /* 137 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Type1Parser = undefined;

      var _util = __w_pdfjs_require__(0);

      var _encodings = __w_pdfjs_require__(27);

      var _stream = __w_pdfjs_require__(5);

      var HINTING_ENABLED = false;
      var Type1CharString = function Type1CharStringClosure() {
        var COMMAND_MAP = {
          "hstem": [1],
          "vstem": [3],
          "vmoveto": [4],
          "rlineto": [5],
          "hlineto": [6],
          "vlineto": [7],
          "rrcurveto": [8],
          "callsubr": [10],
          "flex": [12, 35],
          "drop": [12, 18],
          "endchar": [14],
          "rmoveto": [21],
          "hmoveto": [22],
          "vhcurveto": [30],
          "hvcurveto": [31]
        };
        function Type1CharString() {
          this.width = 0;
          this.lsb = 0;
          this.flexing = false;
          this.output = [];
          this.stack = [];
        }
        Type1CharString.prototype = {
          convert: function Type1CharString_convert(encoded, subrs, seacAnalysisEnabled) {
            var count = encoded.length;
            var error = false;
            var wx, sbx, subrNumber;
            for (var i = 0; i < count; i++) {
              var value = encoded[i];
              if (value < 32) {
                if (value === 12) {
                  value = (value << 8) + encoded[++i];
                }
                switch (value) {
                  case 1:
                    if (!HINTING_ENABLED) {
                      this.stack = [];
                      break;
                    }
                    error = this.executeCommand(2, COMMAND_MAP.hstem);
                    break;
                  case 3:
                    if (!HINTING_ENABLED) {
                      this.stack = [];
                      break;
                    }
                    error = this.executeCommand(2, COMMAND_MAP.vstem);
                    break;
                  case 4:
                    if (this.flexing) {
                      if (this.stack.length < 1) {
                        error = true;
                        break;
                      }
                      var dy = this.stack.pop();
                      this.stack.push(0, dy);
                      break;
                    }
                    error = this.executeCommand(1, COMMAND_MAP.vmoveto);
                    break;
                  case 5:
                    error = this.executeCommand(2, COMMAND_MAP.rlineto);
                    break;
                  case 6:
                    error = this.executeCommand(1, COMMAND_MAP.hlineto);
                    break;
                  case 7:
                    error = this.executeCommand(1, COMMAND_MAP.vlineto);
                    break;
                  case 8:
                    error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
                    break;
                  case 9:
                    this.stack = [];
                    break;
                  case 10:
                    if (this.stack.length < 1) {
                      error = true;
                      break;
                    }
                    subrNumber = this.stack.pop();
                    if (!subrs[subrNumber]) {
                      error = true;
                      break;
                    }
                    error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
                    break;
                  case 11:
                    return error;
                  case 13:
                    if (this.stack.length < 2) {
                      error = true;
                      break;
                    }
                    wx = this.stack.pop();
                    sbx = this.stack.pop();
                    this.lsb = sbx;
                    this.width = wx;
                    this.stack.push(wx, sbx);
                    error = this.executeCommand(2, COMMAND_MAP.hmoveto);
                    break;
                  case 14:
                    this.output.push(COMMAND_MAP.endchar[0]);
                    break;
                  case 21:
                    if (this.flexing) {
                      break;
                    }
                    error = this.executeCommand(2, COMMAND_MAP.rmoveto);
                    break;
                  case 22:
                    if (this.flexing) {
                      this.stack.push(0);
                      break;
                    }
                    error = this.executeCommand(1, COMMAND_MAP.hmoveto);
                    break;
                  case 30:
                    error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
                    break;
                  case 31:
                    error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
                    break;
                  case (12 << 8) + 0:
                    this.stack = [];
                    break;
                  case (12 << 8) + 1:
                    if (!HINTING_ENABLED) {
                      this.stack = [];
                      break;
                    }
                    error = this.executeCommand(2, COMMAND_MAP.vstem);
                    break;
                  case (12 << 8) + 2:
                    if (!HINTING_ENABLED) {
                      this.stack = [];
                      break;
                    }
                    error = this.executeCommand(2, COMMAND_MAP.hstem);
                    break;
                  case (12 << 8) + 6:
                    if (seacAnalysisEnabled) {
                      this.seac = this.stack.splice(-4, 4);
                      error = this.executeCommand(0, COMMAND_MAP.endchar);
                    } else {
                      error = this.executeCommand(4, COMMAND_MAP.endchar);
                    }
                    break;
                  case (12 << 8) + 7:
                    if (this.stack.length < 4) {
                      error = true;
                      break;
                    }
                    this.stack.pop();
                    wx = this.stack.pop();
                    var sby = this.stack.pop();
                    sbx = this.stack.pop();
                    this.lsb = sbx;
                    this.width = wx;
                    this.stack.push(wx, sbx, sby);
                    error = this.executeCommand(3, COMMAND_MAP.rmoveto);
                    break;
                  case (12 << 8) + 12:
                    if (this.stack.length < 2) {
                      error = true;
                      break;
                    }
                    var num2 = this.stack.pop();
                    var num1 = this.stack.pop();
                    this.stack.push(num1 / num2);
                    break;
                  case (12 << 8) + 16:
                    if (this.stack.length < 2) {
                      error = true;
                      break;
                    }
                    subrNumber = this.stack.pop();
                    var numArgs = this.stack.pop();
                    if (subrNumber === 0 && numArgs === 3) {
                      var flexArgs = this.stack.splice(this.stack.length - 17, 17);
                      this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
                      error = this.executeCommand(13, COMMAND_MAP.flex, true);
                      this.flexing = false;
                      this.stack.push(flexArgs[15], flexArgs[16]);
                    } else if (subrNumber === 1 && numArgs === 0) {
                      this.flexing = true;
                    }
                    break;
                  case (12 << 8) + 17:
                    break;
                  case (12 << 8) + 33:
                    this.stack = [];
                    break;
                  default:
                    (0, _util.warn)("Unknown type 1 charstring command of \"" + value + "\"");
                    break;
                }
                if (error) {
                  break;
                }
                continue;
              } else if (value <= 246) {
                value = value - 139;
              } else if (value <= 250) {
                value = (value - 247) * 256 + encoded[++i] + 108;
              } else if (value <= 254) {
                value = -((value - 251) * 256) - encoded[++i] - 108;
              } else {
                value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
              }
              this.stack.push(value);
            }
            return error;
          },
          executeCommand: function executeCommand(howManyArgs, command, keepStack) {
            var stackLength = this.stack.length;
            if (howManyArgs > stackLength) {
              return true;
            }
            var start = stackLength - howManyArgs;
            for (var i = start; i < stackLength; i++) {
              var value = this.stack[i];
              if (Number.isInteger(value)) {
                this.output.push(28, value >> 8 & 0xff, value & 0xff);
              } else {
                value = 65536 * value | 0;
                this.output.push(255, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF);
              }
            }
            this.output.push.apply(this.output, command);
            if (keepStack) {
              this.stack.splice(start, howManyArgs);
            } else {
              this.stack.length = 0;
            }
            return false;
          }
        };
        return Type1CharString;
      }();
      var Type1Parser = function Type1ParserClosure() {
        var EEXEC_ENCRYPT_KEY = 55665;
        var CHAR_STRS_ENCRYPT_KEY = 4330;
        function isHexDigit(code) {
          return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
        }
        function decrypt(data, key, discardNumber) {
          if (discardNumber >= data.length) {
            return new Uint8Array(0);
          }
          var r = key | 0,
            c1 = 52845,
            c2 = 22719,
            i,
            j;
          for (i = 0; i < discardNumber; i++) {
            r = (data[i] + r) * c1 + c2 & (1 << 16) - 1;
          }
          var count = data.length - discardNumber;
          var decrypted = new Uint8Array(count);
          for (i = discardNumber, j = 0; j < count; i++, j++) {
            var value = data[i];
            decrypted[j] = value ^ r >> 8;
            r = (value + r) * c1 + c2 & (1 << 16) - 1;
          }
          return decrypted;
        }
        function decryptAscii(data, key, discardNumber) {
          var r = key | 0,
            c1 = 52845,
            c2 = 22719;
          var count = data.length,
            maybeLength = count >>> 1;
          var decrypted = new Uint8Array(maybeLength);
          var i, j;
          for (i = 0, j = 0; i < count; i++) {
            var digit1 = data[i];
            if (!isHexDigit(digit1)) {
              continue;
            }
            i++;
            var digit2;
            while (i < count && !isHexDigit(digit2 = data[i])) {
              i++;
            }
            if (i < count) {
              var value = parseInt(String.fromCharCode(digit1, digit2), 16);
              decrypted[j++] = value ^ r >> 8;
              r = (value + r) * c1 + c2 & (1 << 16) - 1;
            }
          }
          return Array.prototype.slice.call(decrypted, discardNumber, j);
        }
        function isSpecial(c) {
          return c === 0x2F || c === 0x5B || c === 0x5D || c === 0x7B || c === 0x7D || c === 0x28 || c === 0x29;
        }
        function Type1Parser(stream, encrypted, seacAnalysisEnabled) {
          if (encrypted) {
            var data = stream.getBytes();
            var isBinary = !(isHexDigit(data[0]) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]));
            stream = new _stream.Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
          }
          this.seacAnalysisEnabled = !!seacAnalysisEnabled;
          this.stream = stream;
          this.nextChar();
        }
        Type1Parser.prototype = {
          readNumberArray: function Type1Parser_readNumberArray() {
            this.getToken();
            var array = [];
            while (true) {
              var token = this.getToken();
              if (token === null || token === "]" || token === "}") {
                break;
              }
              array.push(parseFloat(token || 0));
            }
            return array;
          },
          readNumber: function Type1Parser_readNumber() {
            var token = this.getToken();
            return parseFloat(token || 0);
          },
          readInt: function Type1Parser_readInt() {
            var token = this.getToken();
            return parseInt(token || 0, 10) | 0;
          },
          readBoolean: function Type1Parser_readBoolean() {
            var token = this.getToken();
            return token === "true" ? 1 : 0;
          },
          nextChar: function Type1_nextChar() {
            return this.currentChar = this.stream.getByte();
          },
          getToken: function Type1Parser_getToken() {
            var comment = false;
            var ch = this.currentChar;
            while (true) {
              if (ch === -1) {
                return null;
              }
              if (comment) {
                if (ch === 0x0A || ch === 0x0D) {
                  comment = false;
                }
              } else if (ch === 0x25) {
                comment = true;
              } else if (!(0, _util.isSpace)(ch)) {
                break;
              }
              ch = this.nextChar();
            }
            if (isSpecial(ch)) {
              this.nextChar();
              return String.fromCharCode(ch);
            }
            var token = "";
            do {
              token += String.fromCharCode(ch);
              ch = this.nextChar();
            } while (ch >= 0 && !(0, _util.isSpace)(ch) && !isSpecial(ch));
            return token;
          },
          readCharStrings: function Type1Parser_readCharStrings(bytes, lenIV) {
            if (lenIV === -1) {
              return bytes;
            }
            return decrypt(bytes, CHAR_STRS_ENCRYPT_KEY, lenIV);
          },
          extractFontProgram: function Type1Parser_extractFontProgram() {
            var stream = this.stream;
            var subrs = [],
              charstrings = [];
            var privateData = Object.create(null);
            privateData["lenIV"] = 4;
            var program = {
              subrs: [],
              charstrings: [],
              properties: { "privateData": privateData }
            };
            var token, length, data, lenIV, encoded;
            while ((token = this.getToken()) !== null) {
              if (token !== "/") {
                continue;
              }
              token = this.getToken();
              switch (token) {
                case "CharStrings":
                  this.getToken();
                  this.getToken();
                  this.getToken();
                  this.getToken();
                  while (true) {
                    token = this.getToken();
                    if (token === null || token === "end") {
                      break;
                    }
                    if (token !== "/") {
                      continue;
                    }
                    var glyph = this.getToken();
                    length = this.readInt();
                    this.getToken();
                    data = stream.makeSubStream(stream.pos, length);
                    lenIV = program.properties.privateData["lenIV"];
                    encoded = this.readCharStrings(data.getBytes(), lenIV);
                    stream.skip(length);
                    this.nextChar();
                    token = this.getToken();
                    if (token === "noaccess") {
                      this.getToken();
                    }
                    charstrings.push({
                      glyph: glyph,
                      encoded: encoded
                    });
                  }
                  break;
                case "Subrs":
                  this.readInt();
                  this.getToken();
                  while ((token = this.getToken()) === "dup") {
                    var index = this.readInt();
                    length = this.readInt();
                    this.getToken();
                    data = stream.makeSubStream(stream.pos, length);
                    lenIV = program.properties.privateData["lenIV"];
                    encoded = this.readCharStrings(data.getBytes(), lenIV);
                    stream.skip(length);
                    this.nextChar();
                    token = this.getToken();
                    if (token === "noaccess") {
                      this.getToken();
                    }
                    subrs[index] = encoded;
                  }
                  break;
                case "BlueValues":
                case "OtherBlues":
                case "FamilyBlues":
                case "FamilyOtherBlues":
                  var blueArray = this.readNumberArray();
                  if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) {
                    program.properties.privateData[token] = blueArray;
                  }
                  break;
                case "StemSnapH":
                case "StemSnapV":
                  program.properties.privateData[token] = this.readNumberArray();
                  break;
                case "StdHW":
                case "StdVW":
                  program.properties.privateData[token] = this.readNumberArray()[0];
                  break;
                case "BlueShift":
                case "lenIV":
                case "BlueFuzz":
                case "BlueScale":
                case "LanguageGroup":
                case "ExpansionFactor":
                  program.properties.privateData[token] = this.readNumber();
                  break;
                case "ForceBold":
                  program.properties.privateData[token] = this.readBoolean();
                  break;
              }
            }
            for (var i = 0; i < charstrings.length; i++) {
              glyph = charstrings[i].glyph;
              encoded = charstrings[i].encoded;
              var charString = new Type1CharString();
              var error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
              var output = charString.output;
              if (error) {
                output = [14];
              }
              program.charstrings.push({
                glyphName: glyph,
                charstring: output,
                width: charString.width,
                lsb: charString.lsb,
                seac: charString.seac
              });
            }
            return program;
          },
          extractFontHeader: function Type1Parser_extractFontHeader(properties) {
            var token;
            while ((token = this.getToken()) !== null) {
              if (token !== "/") {
                continue;
              }
              token = this.getToken();
              switch (token) {
                case "FontMatrix":
                  var matrix = this.readNumberArray();
                  properties.fontMatrix = matrix;
                  break;
                case "Encoding":
                  var encodingArg = this.getToken();
                  var encoding;
                  if (!/^\d+$/.test(encodingArg)) {
                    encoding = (0, _encodings.getEncoding)(encodingArg);
                  } else {
                    encoding = [];
                    var size = parseInt(encodingArg, 10) | 0;
                    this.getToken();
                    for (var j = 0; j < size; j++) {
                      token = this.getToken();
                      while (token !== "dup" && token !== "def") {
                        token = this.getToken();
                        if (token === null) {
                          return;
                        }
                      }
                      if (token === "def") {
                        break;
                      }
                      var index = this.readInt();
                      this.getToken();
                      var glyph = this.getToken();
                      encoding[index] = glyph;
                      this.getToken();
                    }
                  }
                  properties.builtInEncoding = encoding;
                  break;
                case "FontBBox":
                  var fontBBox = this.readNumberArray();
                  properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                  properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                  properties.ascentScaled = true;
                  break;
              }
            }
          }
        };
        return Type1Parser;
      }();
      exports.Type1Parser = Type1Parser;

      /***/ }),
    /* 138 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getTilingPatternIR = exports.Pattern = undefined;

      var _util = __w_pdfjs_require__(0);

      var _colorspace = __w_pdfjs_require__(26);

      var _primitives = __w_pdfjs_require__(2);

      var ShadingType = {
        FUNCTION_BASED: 1,
        AXIAL: 2,
        RADIAL: 3,
        FREE_FORM_MESH: 4,
        LATTICE_FORM_MESH: 5,
        COONS_PATCH_MESH: 6,
        TENSOR_PATCH_MESH: 7
      };
      var Pattern = function PatternClosure() {
        function Pattern() {
          throw new Error("should not call Pattern constructor");
        }
        Pattern.prototype = {
          getPattern: function Pattern_getPattern(ctx) {
            throw new Error("Should not call Pattern.getStyle: " + ctx);
          }
        };
        Pattern.parseShading = function (shading, matrix, xref, res, handler, pdfFunctionFactory) {
          var dict = (0, _primitives.isStream)(shading) ? shading.dict : shading;
          var type = dict.get("ShadingType");
          try {
            switch (type) {
              case ShadingType.AXIAL:
              case ShadingType.RADIAL:
                return new Shadings.RadialAxial(dict, matrix, xref, res, pdfFunctionFactory);
              case ShadingType.FREE_FORM_MESH:
              case ShadingType.LATTICE_FORM_MESH:
              case ShadingType.COONS_PATCH_MESH:
              case ShadingType.TENSOR_PATCH_MESH:
                return new Shadings.Mesh(shading, matrix, xref, res, pdfFunctionFactory);
              default:
                throw new _util.FormatError("Unsupported ShadingType: " + type);
            }
          } catch (ex) {
            if (ex instanceof _util.MissingDataException) {
              throw ex;
            }
            handler.send("UnsupportedFeature", { featureId: _util.UNSUPPORTED_FEATURES.shadingPattern });
            (0, _util.warn)(ex);
            return new Shadings.Dummy();
          }
        };
        return Pattern;
      }();
      var Shadings = {};
      Shadings.SMALL_NUMBER = 1e-6;
      Shadings.RadialAxial = function RadialAxialClosure() {
        function RadialAxial(dict, matrix, xref, res, pdfFunctionFactory) {
          this.matrix = matrix;
          this.coordsArr = dict.getArray("Coords");
          this.shadingType = dict.get("ShadingType");
          this.type = "Pattern";
          var cs = dict.get("ColorSpace", "CS");
          cs = _colorspace.ColorSpace.parse(cs, xref, res, pdfFunctionFactory);
          this.cs = cs;
          var t0 = 0.0,
            t1 = 1.0;
          if (dict.has("Domain")) {
            var domainArr = dict.getArray("Domain");
            t0 = domainArr[0];
            t1 = domainArr[1];
          }
          var extendStart = false,
            extendEnd = false;
          if (dict.has("Extend")) {
            var extendArr = dict.getArray("Extend");
            extendStart = extendArr[0];
            extendEnd = extendArr[1];
          }
          if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
            var x1 = this.coordsArr[0];
            var y1 = this.coordsArr[1];
            var r1 = this.coordsArr[2];
            var x2 = this.coordsArr[3];
            var y2 = this.coordsArr[4];
            var r2 = this.coordsArr[5];
            var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
            if (r1 <= r2 + distance && r2 <= r1 + distance) {
              (0, _util.warn)("Unsupported radial gradient.");
            }
          }
          this.extendStart = extendStart;
          this.extendEnd = extendEnd;
          var fnObj = dict.get("Function");
          var fn = pdfFunctionFactory.createFromArray(fnObj);
          var diff = t1 - t0;
          var step = diff / 10;
          var colorStops = this.colorStops = [];
          if (t0 >= t1 || step <= 0) {
            (0, _util.info)("Bad shading domain.");
            return;
          }
          var color = new Float32Array(cs.numComps),
            ratio = new Float32Array(1);
          var rgbColor;
          for (var i = t0; i <= t1; i += step) {
            ratio[0] = i;
            fn(ratio, 0, color, 0);
            rgbColor = cs.getRgb(color, 0);
            var cssColor = _util.Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
            colorStops.push([(i - t0) / diff, cssColor]);
          }
          var background = "transparent";
          if (dict.has("Background")) {
            rgbColor = cs.getRgb(dict.get("Background"), 0);
            background = _util.Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
          }
          if (!extendStart) {
            colorStops.unshift([0, background]);
            colorStops[1][0] += Shadings.SMALL_NUMBER;
          }
          if (!extendEnd) {
            colorStops[colorStops.length - 1][0] -= Shadings.SMALL_NUMBER;
            colorStops.push([1, background]);
          }
          this.colorStops = colorStops;
        }
        RadialAxial.prototype = {
          getIR: function RadialAxial_getIR() {
            var coordsArr = this.coordsArr;
            var shadingType = this.shadingType;
            var type, p0, p1, r0, r1;
            if (shadingType === ShadingType.AXIAL) {
              p0 = [coordsArr[0], coordsArr[1]];
              p1 = [coordsArr[2], coordsArr[3]];
              r0 = null;
              r1 = null;
              type = "axial";
            } else if (shadingType === ShadingType.RADIAL) {
              p0 = [coordsArr[0], coordsArr[1]];
              p1 = [coordsArr[3], coordsArr[4]];
              r0 = coordsArr[2];
              r1 = coordsArr[5];
              type = "radial";
            } else {
              (0, _util.unreachable)("getPattern type unknown: " + shadingType);
            }
            var matrix = this.matrix;
            if (matrix) {
              p0 = _util.Util.applyTransform(p0, matrix);
              p1 = _util.Util.applyTransform(p1, matrix);
              if (shadingType === ShadingType.RADIAL) {
                var scale = _util.Util.singularValueDecompose2dScale(matrix);
                r0 *= scale[0];
                r1 *= scale[1];
              }
            }
            return ["RadialAxial", type, this.colorStops, p0, p1, r0, r1];
          }
        };
        return RadialAxial;
      }();
      Shadings.Mesh = function MeshClosure() {
        function MeshStreamReader(stream, context) {
          this.stream = stream;
          this.context = context;
          this.buffer = 0;
          this.bufferLength = 0;
          var numComps = context.numComps;
          this.tmpCompsBuf = new Float32Array(numComps);
          var csNumComps = context.colorSpace.numComps;
          this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
        }
        MeshStreamReader.prototype = {
          get hasData() {
            if (this.stream.end) {
              return this.stream.pos < this.stream.end;
            }
            if (this.bufferLength > 0) {
              return true;
            }
            var nextByte = this.stream.getByte();
            if (nextByte < 0) {
              return false;
            }
            this.buffer = nextByte;
            this.bufferLength = 8;
            return true;
          },
          readBits: function MeshStreamReader_readBits(n) {
            var buffer = this.buffer;
            var bufferLength = this.bufferLength;
            if (n === 32) {
              if (bufferLength === 0) {
                return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
              }
              buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
              var nextByte = this.stream.getByte();
              this.buffer = nextByte & (1 << bufferLength) - 1;
              return (buffer << 8 - bufferLength | (nextByte & 0xFF) >> bufferLength) >>> 0;
            }
            if (n === 8 && bufferLength === 0) {
              return this.stream.getByte();
            }
            while (bufferLength < n) {
              buffer = buffer << 8 | this.stream.getByte();
              bufferLength += 8;
            }
            bufferLength -= n;
            this.bufferLength = bufferLength;
            this.buffer = buffer & (1 << bufferLength) - 1;
            return buffer >> bufferLength;
          },
          align: function MeshStreamReader_align() {
            this.buffer = 0;
            this.bufferLength = 0;
          },
          readFlag: function MeshStreamReader_readFlag() {
            return this.readBits(this.context.bitsPerFlag);
          },
          readCoordinate: function MeshStreamReader_readCoordinate() {
            var bitsPerCoordinate = this.context.bitsPerCoordinate;
            var xi = this.readBits(bitsPerCoordinate);
            var yi = this.readBits(bitsPerCoordinate);
            var decode = this.context.decode;
            var scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
            return [xi * scale * (decode[1] - decode[0]) + decode[0], yi * scale * (decode[3] - decode[2]) + decode[2]];
          },
          readComponents: function MeshStreamReader_readComponents() {
            var numComps = this.context.numComps;
            var bitsPerComponent = this.context.bitsPerComponent;
            var scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
            var decode = this.context.decode;
            var components = this.tmpCompsBuf;
            for (var i = 0, j = 4; i < numComps; i++, j += 2) {
              var ci = this.readBits(bitsPerComponent);
              components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
            }
            var color = this.tmpCsCompsBuf;
            if (this.context.colorFn) {
              this.context.colorFn(components, 0, color, 0);
            }
            return this.context.colorSpace.getRgb(color, 0);
          }
        };
        function decodeType4Shading(mesh, reader) {
          var coords = mesh.coords;
          var colors = mesh.colors;
          var operators = [];
          var ps = [];
          var verticesLeft = 0;
          while (reader.hasData) {
            var f = reader.readFlag();
            var coord = reader.readCoordinate();
            var color = reader.readComponents();
            if (verticesLeft === 0) {
              if (!(0 <= f && f <= 2)) {
                throw new _util.FormatError("Unknown type4 flag");
              }
              switch (f) {
                case 0:
                  verticesLeft = 3;
                  break;
                case 1:
                  ps.push(ps[ps.length - 2], ps[ps.length - 1]);
                  verticesLeft = 1;
                  break;
                case 2:
                  ps.push(ps[ps.length - 3], ps[ps.length - 1]);
                  verticesLeft = 1;
                  break;
              }
              operators.push(f);
            }
            ps.push(coords.length);
            coords.push(coord);
            colors.push(color);
            verticesLeft--;
            reader.align();
          }
          mesh.figures.push({
            type: "triangles",
            coords: new Int32Array(ps),
            colors: new Int32Array(ps)
          });
        }
        function decodeType5Shading(mesh, reader, verticesPerRow) {
          var coords = mesh.coords;
          var colors = mesh.colors;
          var ps = [];
          while (reader.hasData) {
            var coord = reader.readCoordinate();
            var color = reader.readComponents();
            ps.push(coords.length);
            coords.push(coord);
            colors.push(color);
          }
          mesh.figures.push({
            type: "lattice",
            coords: new Int32Array(ps),
            colors: new Int32Array(ps),
            verticesPerRow: verticesPerRow
          });
        }
        var MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
        var MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
        var TRIANGLE_DENSITY = 20;
        var getB = function getBClosure() {
          function buildB(count) {
            var lut = [];
            for (var i = 0; i <= count; i++) {
              var t = i / count,
                t_ = 1 - t;
              lut.push(new Float32Array([t_ * t_ * t_, 3 * t * t_ * t_, 3 * t * t * t_, t * t * t]));
            }
            return lut;
          }
          var cache = [];
          return function getB(count) {
            if (!cache[count]) {
              cache[count] = buildB(count);
            }
            return cache[count];
          };
        }();
        function buildFigureFromPatch(mesh, index) {
          var figure = mesh.figures[index];
          (0, _util.assert)(figure.type === "patch", "Unexpected patch mesh figure");
          var coords = mesh.coords,
            colors = mesh.colors;
          var pi = figure.coords;
          var ci = figure.colors;
          var figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
          var figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
          var figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
          var figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
          var splitXBy = Math.ceil((figureMaxX - figureMinX) * TRIANGLE_DENSITY / (mesh.bounds[2] - mesh.bounds[0]));
          splitXBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
          var splitYBy = Math.ceil((figureMaxY - figureMinY) * TRIANGLE_DENSITY / (mesh.bounds[3] - mesh.bounds[1]));
          splitYBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
          var verticesPerRow = splitXBy + 1;
          var figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
          var figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
          var k = 0;
          var cl = new Uint8Array(3),
            cr = new Uint8Array(3);
          var c0 = colors[ci[0]],
            c1 = colors[ci[1]],
            c2 = colors[ci[2]],
            c3 = colors[ci[3]];
          var bRow = getB(splitYBy),
            bCol = getB(splitXBy);
          for (var row = 0; row <= splitYBy; row++) {
            cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
            cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
            cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
            cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
            cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
            cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
            for (var col = 0; col <= splitXBy; col++, k++) {
              if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) {
                continue;
              }
              var x = 0,
                y = 0;
              var q = 0;
              for (var i = 0; i <= 3; i++) {
                for (var j = 0; j <= 3; j++, q++) {
                  var m = bRow[row][i] * bCol[col][j];
                  x += coords[pi[q]][0] * m;
                  y += coords[pi[q]][1] * m;
                }
              }
              figureCoords[k] = coords.length;
              coords.push([x, y]);
              figureColors[k] = colors.length;
              var newColor = new Uint8Array(3);
              newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
              newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
              newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
              colors.push(newColor);
            }
          }
          figureCoords[0] = pi[0];
          figureColors[0] = ci[0];
          figureCoords[splitXBy] = pi[3];
          figureColors[splitXBy] = ci[1];
          figureCoords[verticesPerRow * splitYBy] = pi[12];
          figureColors[verticesPerRow * splitYBy] = ci[2];
          figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
          figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
          mesh.figures[index] = {
            type: "lattice",
            coords: figureCoords,
            colors: figureColors,
            verticesPerRow: verticesPerRow
          };
        }
        function decodeType6Shading(mesh, reader) {
          var coords = mesh.coords;
          var colors = mesh.colors;
          var ps = new Int32Array(16);
          var cs = new Int32Array(4);
          while (reader.hasData) {
            var f = reader.readFlag();
            if (!(0 <= f && f <= 3)) {
              throw new _util.FormatError("Unknown type6 flag");
            }
            var i, ii;
            var pi = coords.length;
            for (i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++) {
              coords.push(reader.readCoordinate());
            }
            var ci = colors.length;
            for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
              colors.push(reader.readComponents());
            }
            var tmp1, tmp2, tmp3, tmp4;
            switch (f) {
              case 0:
                ps[12] = pi + 3;
                ps[13] = pi + 4;
                ps[14] = pi + 5;
                ps[15] = pi + 6;
                ps[8] = pi + 2;
                ps[11] = pi + 7;
                ps[4] = pi + 1;
                ps[7] = pi + 8;
                ps[0] = pi;
                ps[1] = pi + 11;
                ps[2] = pi + 10;
                ps[3] = pi + 9;
                cs[2] = ci + 1;
                cs[3] = ci + 2;
                cs[0] = ci;
                cs[1] = ci + 3;
                break;
              case 1:
                tmp1 = ps[12];
                tmp2 = ps[13];
                tmp3 = ps[14];
                tmp4 = ps[15];
                ps[12] = tmp4;
                ps[13] = pi + 0;
                ps[14] = pi + 1;
                ps[15] = pi + 2;
                ps[8] = tmp3;
                ps[11] = pi + 3;
                ps[4] = tmp2;
                ps[7] = pi + 4;
                ps[0] = tmp1;
                ps[1] = pi + 7;
                ps[2] = pi + 6;
                ps[3] = pi + 5;
                tmp1 = cs[2];
                tmp2 = cs[3];
                cs[2] = tmp2;
                cs[3] = ci;
                cs[0] = tmp1;
                cs[1] = ci + 1;
                break;
              case 2:
                tmp1 = ps[15];
                tmp2 = ps[11];
                ps[12] = ps[3];
                ps[13] = pi + 0;
                ps[14] = pi + 1;
                ps[15] = pi + 2;
                ps[8] = ps[7];
                ps[11] = pi + 3;
                ps[4] = tmp2;
                ps[7] = pi + 4;
                ps[0] = tmp1;
                ps[1] = pi + 7;
                ps[2] = pi + 6;
                ps[3] = pi + 5;
                tmp1 = cs[3];
                cs[2] = cs[1];
                cs[3] = ci;
                cs[0] = tmp1;
                cs[1] = ci + 1;
                break;
              case 3:
                ps[12] = ps[0];
                ps[13] = pi + 0;
                ps[14] = pi + 1;
                ps[15] = pi + 2;
                ps[8] = ps[1];
                ps[11] = pi + 3;
                ps[4] = ps[2];
                ps[7] = pi + 4;
                ps[0] = ps[3];
                ps[1] = pi + 7;
                ps[2] = pi + 6;
                ps[3] = pi + 5;
                cs[2] = cs[0];
                cs[3] = ci;
                cs[0] = cs[1];
                cs[1] = ci + 1;
                break;
            }
            ps[5] = coords.length;
            coords.push([(-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9, (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9]);
            ps[6] = coords.length;
            coords.push([(-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9, (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9]);
            ps[9] = coords.length;
            coords.push([(-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9, (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9]);
            ps[10] = coords.length;
            coords.push([(-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9, (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9]);
            mesh.figures.push({
              type: "patch",
              coords: new Int32Array(ps),
              colors: new Int32Array(cs)
            });
          }
        }
        function decodeType7Shading(mesh, reader) {
          var coords = mesh.coords;
          var colors = mesh.colors;
          var ps = new Int32Array(16);
          var cs = new Int32Array(4);
          while (reader.hasData) {
            var f = reader.readFlag();
            if (!(0 <= f && f <= 3)) {
              throw new _util.FormatError("Unknown type7 flag");
            }
            var i, ii;
            var pi = coords.length;
            for (i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++) {
              coords.push(reader.readCoordinate());
            }
            var ci = colors.length;
            for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
              colors.push(reader.readComponents());
            }
            var tmp1, tmp2, tmp3, tmp4;
            switch (f) {
              case 0:
                ps[12] = pi + 3;
                ps[13] = pi + 4;
                ps[14] = pi + 5;
                ps[15] = pi + 6;
                ps[8] = pi + 2;
                ps[9] = pi + 13;
                ps[10] = pi + 14;
                ps[11] = pi + 7;
                ps[4] = pi + 1;
                ps[5] = pi + 12;
                ps[6] = pi + 15;
                ps[7] = pi + 8;
                ps[0] = pi;
                ps[1] = pi + 11;
                ps[2] = pi + 10;
                ps[3] = pi + 9;
                cs[2] = ci + 1;
                cs[3] = ci + 2;
                cs[0] = ci;
                cs[1] = ci + 3;
                break;
              case 1:
                tmp1 = ps[12];
                tmp2 = ps[13];
                tmp3 = ps[14];
                tmp4 = ps[15];
                ps[12] = tmp4;
                ps[13] = pi + 0;
                ps[14] = pi + 1;
                ps[15] = pi + 2;
                ps[8] = tmp3;
                ps[9] = pi + 9;
                ps[10] = pi + 10;
                ps[11] = pi + 3;
                ps[4] = tmp2;
                ps[5] = pi + 8;
                ps[6] = pi + 11;
                ps[7] = pi + 4;
                ps[0] = tmp1;
                ps[1] = pi + 7;
                ps[2] = pi + 6;
                ps[3] = pi + 5;
                tmp1 = cs[2];
                tmp2 = cs[3];
                cs[2] = tmp2;
                cs[3] = ci;
                cs[0] = tmp1;
                cs[1] = ci + 1;
                break;
              case 2:
                tmp1 = ps[15];
                tmp2 = ps[11];
                ps[12] = ps[3];
                ps[13] = pi + 0;
                ps[14] = pi + 1;
                ps[15] = pi + 2;
                ps[8] = ps[7];
                ps[9] = pi + 9;
                ps[10] = pi + 10;
                ps[11] = pi + 3;
                ps[4] = tmp2;
                ps[5] = pi + 8;
                ps[6] = pi + 11;
                ps[7] = pi + 4;
                ps[0] = tmp1;
                ps[1] = pi + 7;
                ps[2] = pi + 6;
                ps[3] = pi + 5;
                tmp1 = cs[3];
                cs[2] = cs[1];
                cs[3] = ci;
                cs[0] = tmp1;
                cs[1] = ci + 1;
                break;
              case 3:
                ps[12] = ps[0];
                ps[13] = pi + 0;
                ps[14] = pi + 1;
                ps[15] = pi + 2;
                ps[8] = ps[1];
                ps[9] = pi + 9;
                ps[10] = pi + 10;
                ps[11] = pi + 3;
                ps[4] = ps[2];
                ps[5] = pi + 8;
                ps[6] = pi + 11;
                ps[7] = pi + 4;
                ps[0] = ps[3];
                ps[1] = pi + 7;
                ps[2] = pi + 6;
                ps[3] = pi + 5;
                cs[2] = cs[0];
                cs[3] = ci;
                cs[0] = cs[1];
                cs[1] = ci + 1;
                break;
            }
            mesh.figures.push({
              type: "patch",
              coords: new Int32Array(ps),
              colors: new Int32Array(cs)
            });
          }
        }
        function updateBounds(mesh) {
          var minX = mesh.coords[0][0],
            minY = mesh.coords[0][1],
            maxX = minX,
            maxY = minY;
          for (var i = 1, ii = mesh.coords.length; i < ii; i++) {
            var x = mesh.coords[i][0],
              y = mesh.coords[i][1];
            minX = minX > x ? x : minX;
            minY = minY > y ? y : minY;
            maxX = maxX < x ? x : maxX;
            maxY = maxY < y ? y : maxY;
          }
          mesh.bounds = [minX, minY, maxX, maxY];
        }
        function packData(mesh) {
          var i, ii, j, jj;
          var coords = mesh.coords;
          var coordsPacked = new Float32Array(coords.length * 2);
          for (i = 0, j = 0, ii = coords.length; i < ii; i++) {
            var xy = coords[i];
            coordsPacked[j++] = xy[0];
            coordsPacked[j++] = xy[1];
          }
          mesh.coords = coordsPacked;
          var colors = mesh.colors;
          var colorsPacked = new Uint8Array(colors.length * 3);
          for (i = 0, j = 0, ii = colors.length; i < ii; i++) {
            var c = colors[i];
            colorsPacked[j++] = c[0];
            colorsPacked[j++] = c[1];
            colorsPacked[j++] = c[2];
          }
          mesh.colors = colorsPacked;
          var figures = mesh.figures;
          for (i = 0, ii = figures.length; i < ii; i++) {
            var figure = figures[i],
              ps = figure.coords,
              cs = figure.colors;
            for (j = 0, jj = ps.length; j < jj; j++) {
              ps[j] *= 2;
              cs[j] *= 3;
            }
          }
        }
        function Mesh(stream, matrix, xref, res, pdfFunctionFactory) {
          if (!(0, _primitives.isStream)(stream)) {
            throw new _util.FormatError("Mesh data is not a stream");
          }
          var dict = stream.dict;
          this.matrix = matrix;
          this.shadingType = dict.get("ShadingType");
          this.type = "Pattern";
          this.bbox = dict.getArray("BBox");
          var cs = dict.get("ColorSpace", "CS");
          cs = _colorspace.ColorSpace.parse(cs, xref, res, pdfFunctionFactory);
          this.cs = cs;
          this.background = dict.has("Background") ? cs.getRgb(dict.get("Background"), 0) : null;
          var fnObj = dict.get("Function");
          var fn = fnObj ? pdfFunctionFactory.createFromArray(fnObj) : null;
          this.coords = [];
          this.colors = [];
          this.figures = [];
          var decodeContext = {
            bitsPerCoordinate: dict.get("BitsPerCoordinate"),
            bitsPerComponent: dict.get("BitsPerComponent"),
            bitsPerFlag: dict.get("BitsPerFlag"),
            decode: dict.getArray("Decode"),
            colorFn: fn,
            colorSpace: cs,
            numComps: fn ? 1 : cs.numComps
          };
          var reader = new MeshStreamReader(stream, decodeContext);
          var patchMesh = false;
          switch (this.shadingType) {
            case ShadingType.FREE_FORM_MESH:
              decodeType4Shading(this, reader);
              break;
            case ShadingType.LATTICE_FORM_MESH:
              var verticesPerRow = dict.get("VerticesPerRow") | 0;
              if (verticesPerRow < 2) {
                throw new _util.FormatError("Invalid VerticesPerRow");
              }
              decodeType5Shading(this, reader, verticesPerRow);
              break;
            case ShadingType.COONS_PATCH_MESH:
              decodeType6Shading(this, reader);
              patchMesh = true;
              break;
            case ShadingType.TENSOR_PATCH_MESH:
              decodeType7Shading(this, reader);
              patchMesh = true;
              break;
            default:
              (0, _util.unreachable)("Unsupported mesh type.");
              break;
          }
          if (patchMesh) {
            updateBounds(this);
            for (var i = 0, ii = this.figures.length; i < ii; i++) {
              buildFigureFromPatch(this, i);
            }
          }
          updateBounds(this);
          packData(this);
        }
        Mesh.prototype = {
          getIR: function Mesh_getIR() {
            return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.matrix, this.bbox, this.background];
          }
        };
        return Mesh;
      }();
      Shadings.Dummy = function DummyClosure() {
        function Dummy() {
          this.type = "Pattern";
        }
        Dummy.prototype = {
          getIR: function Dummy_getIR() {
            return ["Dummy"];
          }
        };
        return Dummy;
      }();
      function getTilingPatternIR(operatorList, dict, args) {
        var matrix = dict.getArray("Matrix");
        var bbox = _util.Util.normalizeRect(dict.getArray("BBox"));
        var xstep = dict.get("XStep");
        var ystep = dict.get("YStep");
        var paintType = dict.get("PaintType");
        var tilingType = dict.get("TilingType");
        if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) {
          throw new _util.FormatError("Invalid getTilingPatternIR /BBox array: [" + bbox + "].");
        }
        return ["TilingPattern", args, operatorList, matrix, bbox, xstep, ystep, paintType, tilingType];
      }
      exports.Pattern = Pattern;
      exports.getTilingPatternIR = getTilingPatternIR;

      /***/ }),
    /* 139 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.bidi = undefined;

      var _util = __w_pdfjs_require__(0);

      var baseTypes = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"];
      var arabicTypes = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
      function isOdd(i) {
        return (i & 1) !== 0;
      }
      function isEven(i) {
        return (i & 1) === 0;
      }
      function findUnequal(arr, start, value) {
        for (var j = start, jj = arr.length; j < jj; ++j) {
          if (arr[j] !== value) {
            return j;
          }
        }
        return j;
      }
      function setValues(arr, start, end, value) {
        for (var j = start; j < end; ++j) {
          arr[j] = value;
        }
      }
      function reverseValues(arr, start, end) {
        for (var i = start, j = end - 1; i < j; ++i, --j) {
          var temp = arr[i];
          arr[i] = arr[j];
          arr[j] = temp;
        }
      }
      function createBidiText(str, isLTR, vertical) {
        return {
          str: str,
          dir: vertical ? "ttb" : isLTR ? "ltr" : "rtl"
        };
      }
      var chars = [];
      var types = [];
      function bidi(str, startLevel, vertical) {
        var isLTR = true;
        var strLength = str.length;
        if (strLength === 0 || vertical) {
          return createBidiText(str, isLTR, vertical);
        }
        chars.length = strLength;
        types.length = strLength;
        var numBidi = 0;
        var i, ii;
        for (i = 0; i < strLength; ++i) {
          chars[i] = str.charAt(i);
          var charCode = str.charCodeAt(i);
          var charType = "L";
          if (charCode <= 0x00ff) {
            charType = baseTypes[charCode];
          } else if (0x0590 <= charCode && charCode <= 0x05f4) {
            charType = "R";
          } else if (0x0600 <= charCode && charCode <= 0x06ff) {
            charType = arabicTypes[charCode & 0xff];
            if (!charType) {
              (0, _util.warn)("Bidi: invalid Unicode character " + charCode.toString(16));
            }
          } else if (0x0700 <= charCode && charCode <= 0x08AC) {
            charType = "AL";
          }
          if (charType === "R" || charType === "AL" || charType === "AN") {
            numBidi++;
          }
          types[i] = charType;
        }
        if (numBidi === 0) {
          isLTR = true;
          return createBidiText(str, isLTR);
        }
        if (startLevel === -1) {
          if (numBidi / strLength < 0.3) {
            isLTR = true;
            startLevel = 0;
          } else {
            isLTR = false;
            startLevel = 1;
          }
        }
        var levels = [];
        for (i = 0; i < strLength; ++i) {
          levels[i] = startLevel;
        }
        var e = isOdd(startLevel) ? "R" : "L";
        var sor = e;
        var eor = sor;
        var lastType = sor;
        for (i = 0; i < strLength; ++i) {
          if (types[i] === "NSM") {
            types[i] = lastType;
          } else {
            lastType = types[i];
          }
        }
        lastType = sor;
        var t;
        for (i = 0; i < strLength; ++i) {
          t = types[i];
          if (t === "EN") {
            types[i] = lastType === "AL" ? "AN" : "EN";
          } else if (t === "R" || t === "L" || t === "AL") {
            lastType = t;
          }
        }
        for (i = 0; i < strLength; ++i) {
          t = types[i];
          if (t === "AL") {
            types[i] = "R";
          }
        }
        for (i = 1; i < strLength - 1; ++i) {
          if (types[i] === "ES" && types[i - 1] === "EN" && types[i + 1] === "EN") {
            types[i] = "EN";
          }
          if (types[i] === "CS" && (types[i - 1] === "EN" || types[i - 1] === "AN") && types[i + 1] === types[i - 1]) {
            types[i] = types[i - 1];
          }
        }
        for (i = 0; i < strLength; ++i) {
          if (types[i] === "EN") {
            var j;
            for (j = i - 1; j >= 0; --j) {
              if (types[j] !== "ET") {
                break;
              }
              types[j] = "EN";
            }
            for (j = i + 1; j < strLength; ++j) {
              if (types[j] !== "ET") {
                break;
              }
              types[j] = "EN";
            }
          }
        }
        for (i = 0; i < strLength; ++i) {
          t = types[i];
          if (t === "WS" || t === "ES" || t === "ET" || t === "CS") {
            types[i] = "ON";
          }
        }
        lastType = sor;
        for (i = 0; i < strLength; ++i) {
          t = types[i];
          if (t === "EN") {
            types[i] = lastType === "L" ? "L" : "EN";
          } else if (t === "R" || t === "L") {
            lastType = t;
          }
        }
        for (i = 0; i < strLength; ++i) {
          if (types[i] === "ON") {
            var end = findUnequal(types, i + 1, "ON");
            var before = sor;
            if (i > 0) {
              before = types[i - 1];
            }
            var after = eor;
            if (end + 1 < strLength) {
              after = types[end + 1];
            }
            if (before !== "L") {
              before = "R";
            }
            if (after !== "L") {
              after = "R";
            }
            if (before === after) {
              setValues(types, i, end, before);
            }
            i = end - 1;
          }
        }
        for (i = 0; i < strLength; ++i) {
          if (types[i] === "ON") {
            types[i] = e;
          }
        }
        for (i = 0; i < strLength; ++i) {
          t = types[i];
          if (isEven(levels[i])) {
            if (t === "R") {
              levels[i] += 1;
            } else if (t === "AN" || t === "EN") {
              levels[i] += 2;
            }
          } else {
            if (t === "L" || t === "AN" || t === "EN") {
              levels[i] += 1;
            }
          }
        }
        var highestLevel = -1;
        var lowestOddLevel = 99;
        var level;
        for (i = 0, ii = levels.length; i < ii; ++i) {
          level = levels[i];
          if (highestLevel < level) {
            highestLevel = level;
          }
          if (lowestOddLevel > level && isOdd(level)) {
            lowestOddLevel = level;
          }
        }
        for (level = highestLevel; level >= lowestOddLevel; --level) {
          var start = -1;
          for (i = 0, ii = levels.length; i < ii; ++i) {
            if (levels[i] < level) {
              if (start >= 0) {
                reverseValues(chars, start, i);
                start = -1;
              }
            } else if (start < 0) {
              start = i;
            }
          }
          if (start >= 0) {
            reverseValues(chars, start, levels.length);
          }
        }
        for (i = 0, ii = chars.length; i < ii; ++i) {
          var ch = chars[i];
          if (ch === "<" || ch === ">") {
            chars[i] = "";
          }
        }
        return createBidiText(chars.join(""), isLTR);
      }
      exports.bidi = bidi;

      /***/ }),
    /* 140 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getMetrics = undefined;

      var _util = __w_pdfjs_require__(0);

      var getMetrics = (0, _util.getLookupTableFactory)(function (t) {
        t["Courier"] = 600;
        t["Courier-Bold"] = 600;
        t["Courier-BoldOblique"] = 600;
        t["Courier-Oblique"] = 600;
        t["Helvetica"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 278;
          t["exclam"] = 278;
          t["quotedbl"] = 355;
          t["numbersign"] = 556;
          t["dollar"] = 556;
          t["percent"] = 889;
          t["ampersand"] = 667;
          t["quoteright"] = 222;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 389;
          t["plus"] = 584;
          t["comma"] = 278;
          t["hyphen"] = 333;
          t["period"] = 278;
          t["slash"] = 278;
          t["zero"] = 556;
          t["one"] = 556;
          t["two"] = 556;
          t["three"] = 556;
          t["four"] = 556;
          t["five"] = 556;
          t["six"] = 556;
          t["seven"] = 556;
          t["eight"] = 556;
          t["nine"] = 556;
          t["colon"] = 278;
          t["semicolon"] = 278;
          t["less"] = 584;
          t["equal"] = 584;
          t["greater"] = 584;
          t["question"] = 556;
          t["at"] = 1015;
          t["A"] = 667;
          t["B"] = 667;
          t["C"] = 722;
          t["D"] = 722;
          t["E"] = 667;
          t["F"] = 611;
          t["G"] = 778;
          t["H"] = 722;
          t["I"] = 278;
          t["J"] = 500;
          t["K"] = 667;
          t["L"] = 556;
          t["M"] = 833;
          t["N"] = 722;
          t["O"] = 778;
          t["P"] = 667;
          t["Q"] = 778;
          t["R"] = 722;
          t["S"] = 667;
          t["T"] = 611;
          t["U"] = 722;
          t["V"] = 667;
          t["W"] = 944;
          t["X"] = 667;
          t["Y"] = 667;
          t["Z"] = 611;
          t["bracketleft"] = 278;
          t["backslash"] = 278;
          t["bracketright"] = 278;
          t["asciicircum"] = 469;
          t["underscore"] = 556;
          t["quoteleft"] = 222;
          t["a"] = 556;
          t["b"] = 556;
          t["c"] = 500;
          t["d"] = 556;
          t["e"] = 556;
          t["f"] = 278;
          t["g"] = 556;
          t["h"] = 556;
          t["i"] = 222;
          t["j"] = 222;
          t["k"] = 500;
          t["l"] = 222;
          t["m"] = 833;
          t["n"] = 556;
          t["o"] = 556;
          t["p"] = 556;
          t["q"] = 556;
          t["r"] = 333;
          t["s"] = 500;
          t["t"] = 278;
          t["u"] = 556;
          t["v"] = 500;
          t["w"] = 722;
          t["x"] = 500;
          t["y"] = 500;
          t["z"] = 500;
          t["braceleft"] = 334;
          t["bar"] = 260;
          t["braceright"] = 334;
          t["asciitilde"] = 584;
          t["exclamdown"] = 333;
          t["cent"] = 556;
          t["sterling"] = 556;
          t["fraction"] = 167;
          t["yen"] = 556;
          t["florin"] = 556;
          t["section"] = 556;
          t["currency"] = 556;
          t["quotesingle"] = 191;
          t["quotedblleft"] = 333;
          t["guillemotleft"] = 556;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 500;
          t["fl"] = 500;
          t["endash"] = 556;
          t["dagger"] = 556;
          t["daggerdbl"] = 556;
          t["periodcentered"] = 278;
          t["paragraph"] = 537;
          t["bullet"] = 350;
          t["quotesinglbase"] = 222;
          t["quotedblbase"] = 333;
          t["quotedblright"] = 333;
          t["guillemotright"] = 556;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 611;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 1000;
          t["ordfeminine"] = 370;
          t["Lslash"] = 556;
          t["Oslash"] = 778;
          t["OE"] = 1000;
          t["ordmasculine"] = 365;
          t["ae"] = 889;
          t["dotlessi"] = 278;
          t["lslash"] = 222;
          t["oslash"] = 611;
          t["oe"] = 944;
          t["germandbls"] = 611;
          t["Idieresis"] = 278;
          t["eacute"] = 556;
          t["abreve"] = 556;
          t["uhungarumlaut"] = 556;
          t["ecaron"] = 556;
          t["Ydieresis"] = 667;
          t["divide"] = 584;
          t["Yacute"] = 667;
          t["Acircumflex"] = 667;
          t["aacute"] = 556;
          t["Ucircumflex"] = 722;
          t["yacute"] = 500;
          t["scommaaccent"] = 500;
          t["ecircumflex"] = 556;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 556;
          t["Uacute"] = 722;
          t["uogonek"] = 556;
          t["Edieresis"] = 667;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 737;
          t["Emacron"] = 667;
          t["ccaron"] = 500;
          t["aring"] = 556;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 222;
          t["agrave"] = 556;
          t["Tcommaaccent"] = 611;
          t["Cacute"] = 722;
          t["atilde"] = 556;
          t["Edotaccent"] = 667;
          t["scaron"] = 500;
          t["scedilla"] = 500;
          t["iacute"] = 278;
          t["lozenge"] = 471;
          t["Rcaron"] = 722;
          t["Gcommaaccent"] = 778;
          t["ucircumflex"] = 556;
          t["acircumflex"] = 556;
          t["Amacron"] = 667;
          t["rcaron"] = 333;
          t["ccedilla"] = 500;
          t["Zdotaccent"] = 611;
          t["Thorn"] = 667;
          t["Omacron"] = 778;
          t["Racute"] = 722;
          t["Sacute"] = 667;
          t["dcaron"] = 643;
          t["Umacron"] = 722;
          t["uring"] = 556;
          t["threesuperior"] = 333;
          t["Ograve"] = 778;
          t["Agrave"] = 667;
          t["Abreve"] = 667;
          t["multiply"] = 584;
          t["uacute"] = 556;
          t["Tcaron"] = 611;
          t["partialdiff"] = 476;
          t["ydieresis"] = 500;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 667;
          t["adieresis"] = 556;
          t["edieresis"] = 556;
          t["cacute"] = 500;
          t["nacute"] = 556;
          t["umacron"] = 556;
          t["Ncaron"] = 722;
          t["Iacute"] = 278;
          t["plusminus"] = 584;
          t["brokenbar"] = 260;
          t["registered"] = 737;
          t["Gbreve"] = 778;
          t["Idotaccent"] = 278;
          t["summation"] = 600;
          t["Egrave"] = 667;
          t["racute"] = 333;
          t["omacron"] = 556;
          t["Zacute"] = 611;
          t["Zcaron"] = 611;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 722;
          t["lcommaaccent"] = 222;
          t["tcaron"] = 317;
          t["eogonek"] = 556;
          t["Uogonek"] = 722;
          t["Aacute"] = 667;
          t["Adieresis"] = 667;
          t["egrave"] = 556;
          t["zacute"] = 500;
          t["iogonek"] = 222;
          t["Oacute"] = 778;
          t["oacute"] = 556;
          t["amacron"] = 556;
          t["sacute"] = 500;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 778;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 556;
          t["twosuperior"] = 333;
          t["Odieresis"] = 778;
          t["mu"] = 556;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 556;
          t["Eogonek"] = 667;
          t["dcroat"] = 556;
          t["threequarters"] = 834;
          t["Scedilla"] = 667;
          t["lcaron"] = 299;
          t["Kcommaaccent"] = 667;
          t["Lacute"] = 556;
          t["trademark"] = 1000;
          t["edotaccent"] = 556;
          t["Igrave"] = 278;
          t["Imacron"] = 278;
          t["Lcaron"] = 556;
          t["onehalf"] = 834;
          t["lessequal"] = 549;
          t["ocircumflex"] = 556;
          t["ntilde"] = 556;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 667;
          t["emacron"] = 556;
          t["gbreve"] = 556;
          t["onequarter"] = 834;
          t["Scaron"] = 667;
          t["Scommaaccent"] = 667;
          t["Ohungarumlaut"] = 778;
          t["degree"] = 400;
          t["ograve"] = 556;
          t["Ccaron"] = 722;
          t["ugrave"] = 556;
          t["radical"] = 453;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 333;
          t["Ntilde"] = 722;
          t["otilde"] = 556;
          t["Rcommaaccent"] = 722;
          t["Lcommaaccent"] = 556;
          t["Atilde"] = 667;
          t["Aogonek"] = 667;
          t["Aring"] = 667;
          t["Otilde"] = 778;
          t["zdotaccent"] = 500;
          t["Ecaron"] = 667;
          t["Iogonek"] = 278;
          t["kcommaaccent"] = 500;
          t["minus"] = 584;
          t["Icircumflex"] = 278;
          t["ncaron"] = 556;
          t["tcommaaccent"] = 278;
          t["logicalnot"] = 584;
          t["odieresis"] = 556;
          t["udieresis"] = 556;
          t["notequal"] = 549;
          t["gcommaaccent"] = 556;
          t["eth"] = 556;
          t["zcaron"] = 500;
          t["ncommaaccent"] = 556;
          t["onesuperior"] = 333;
          t["imacron"] = 278;
          t["Euro"] = 556;
        });
        t["Helvetica-Bold"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 278;
          t["exclam"] = 333;
          t["quotedbl"] = 474;
          t["numbersign"] = 556;
          t["dollar"] = 556;
          t["percent"] = 889;
          t["ampersand"] = 722;
          t["quoteright"] = 278;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 389;
          t["plus"] = 584;
          t["comma"] = 278;
          t["hyphen"] = 333;
          t["period"] = 278;
          t["slash"] = 278;
          t["zero"] = 556;
          t["one"] = 556;
          t["two"] = 556;
          t["three"] = 556;
          t["four"] = 556;
          t["five"] = 556;
          t["six"] = 556;
          t["seven"] = 556;
          t["eight"] = 556;
          t["nine"] = 556;
          t["colon"] = 333;
          t["semicolon"] = 333;
          t["less"] = 584;
          t["equal"] = 584;
          t["greater"] = 584;
          t["question"] = 611;
          t["at"] = 975;
          t["A"] = 722;
          t["B"] = 722;
          t["C"] = 722;
          t["D"] = 722;
          t["E"] = 667;
          t["F"] = 611;
          t["G"] = 778;
          t["H"] = 722;
          t["I"] = 278;
          t["J"] = 556;
          t["K"] = 722;
          t["L"] = 611;
          t["M"] = 833;
          t["N"] = 722;
          t["O"] = 778;
          t["P"] = 667;
          t["Q"] = 778;
          t["R"] = 722;
          t["S"] = 667;
          t["T"] = 611;
          t["U"] = 722;
          t["V"] = 667;
          t["W"] = 944;
          t["X"] = 667;
          t["Y"] = 667;
          t["Z"] = 611;
          t["bracketleft"] = 333;
          t["backslash"] = 278;
          t["bracketright"] = 333;
          t["asciicircum"] = 584;
          t["underscore"] = 556;
          t["quoteleft"] = 278;
          t["a"] = 556;
          t["b"] = 611;
          t["c"] = 556;
          t["d"] = 611;
          t["e"] = 556;
          t["f"] = 333;
          t["g"] = 611;
          t["h"] = 611;
          t["i"] = 278;
          t["j"] = 278;
          t["k"] = 556;
          t["l"] = 278;
          t["m"] = 889;
          t["n"] = 611;
          t["o"] = 611;
          t["p"] = 611;
          t["q"] = 611;
          t["r"] = 389;
          t["s"] = 556;
          t["t"] = 333;
          t["u"] = 611;
          t["v"] = 556;
          t["w"] = 778;
          t["x"] = 556;
          t["y"] = 556;
          t["z"] = 500;
          t["braceleft"] = 389;
          t["bar"] = 280;
          t["braceright"] = 389;
          t["asciitilde"] = 584;
          t["exclamdown"] = 333;
          t["cent"] = 556;
          t["sterling"] = 556;
          t["fraction"] = 167;
          t["yen"] = 556;
          t["florin"] = 556;
          t["section"] = 556;
          t["currency"] = 556;
          t["quotesingle"] = 238;
          t["quotedblleft"] = 500;
          t["guillemotleft"] = 556;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 611;
          t["fl"] = 611;
          t["endash"] = 556;
          t["dagger"] = 556;
          t["daggerdbl"] = 556;
          t["periodcentered"] = 278;
          t["paragraph"] = 556;
          t["bullet"] = 350;
          t["quotesinglbase"] = 278;
          t["quotedblbase"] = 500;
          t["quotedblright"] = 500;
          t["guillemotright"] = 556;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 611;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 1000;
          t["ordfeminine"] = 370;
          t["Lslash"] = 611;
          t["Oslash"] = 778;
          t["OE"] = 1000;
          t["ordmasculine"] = 365;
          t["ae"] = 889;
          t["dotlessi"] = 278;
          t["lslash"] = 278;
          t["oslash"] = 611;
          t["oe"] = 944;
          t["germandbls"] = 611;
          t["Idieresis"] = 278;
          t["eacute"] = 556;
          t["abreve"] = 556;
          t["uhungarumlaut"] = 611;
          t["ecaron"] = 556;
          t["Ydieresis"] = 667;
          t["divide"] = 584;
          t["Yacute"] = 667;
          t["Acircumflex"] = 722;
          t["aacute"] = 556;
          t["Ucircumflex"] = 722;
          t["yacute"] = 556;
          t["scommaaccent"] = 556;
          t["ecircumflex"] = 556;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 556;
          t["Uacute"] = 722;
          t["uogonek"] = 611;
          t["Edieresis"] = 667;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 737;
          t["Emacron"] = 667;
          t["ccaron"] = 556;
          t["aring"] = 556;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 278;
          t["agrave"] = 556;
          t["Tcommaaccent"] = 611;
          t["Cacute"] = 722;
          t["atilde"] = 556;
          t["Edotaccent"] = 667;
          t["scaron"] = 556;
          t["scedilla"] = 556;
          t["iacute"] = 278;
          t["lozenge"] = 494;
          t["Rcaron"] = 722;
          t["Gcommaaccent"] = 778;
          t["ucircumflex"] = 611;
          t["acircumflex"] = 556;
          t["Amacron"] = 722;
          t["rcaron"] = 389;
          t["ccedilla"] = 556;
          t["Zdotaccent"] = 611;
          t["Thorn"] = 667;
          t["Omacron"] = 778;
          t["Racute"] = 722;
          t["Sacute"] = 667;
          t["dcaron"] = 743;
          t["Umacron"] = 722;
          t["uring"] = 611;
          t["threesuperior"] = 333;
          t["Ograve"] = 778;
          t["Agrave"] = 722;
          t["Abreve"] = 722;
          t["multiply"] = 584;
          t["uacute"] = 611;
          t["Tcaron"] = 611;
          t["partialdiff"] = 494;
          t["ydieresis"] = 556;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 667;
          t["adieresis"] = 556;
          t["edieresis"] = 556;
          t["cacute"] = 556;
          t["nacute"] = 611;
          t["umacron"] = 611;
          t["Ncaron"] = 722;
          t["Iacute"] = 278;
          t["plusminus"] = 584;
          t["brokenbar"] = 280;
          t["registered"] = 737;
          t["Gbreve"] = 778;
          t["Idotaccent"] = 278;
          t["summation"] = 600;
          t["Egrave"] = 667;
          t["racute"] = 389;
          t["omacron"] = 611;
          t["Zacute"] = 611;
          t["Zcaron"] = 611;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 722;
          t["lcommaaccent"] = 278;
          t["tcaron"] = 389;
          t["eogonek"] = 556;
          t["Uogonek"] = 722;
          t["Aacute"] = 722;
          t["Adieresis"] = 722;
          t["egrave"] = 556;
          t["zacute"] = 500;
          t["iogonek"] = 278;
          t["Oacute"] = 778;
          t["oacute"] = 611;
          t["amacron"] = 556;
          t["sacute"] = 556;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 778;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 611;
          t["twosuperior"] = 333;
          t["Odieresis"] = 778;
          t["mu"] = 611;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 611;
          t["Eogonek"] = 667;
          t["dcroat"] = 611;
          t["threequarters"] = 834;
          t["Scedilla"] = 667;
          t["lcaron"] = 400;
          t["Kcommaaccent"] = 722;
          t["Lacute"] = 611;
          t["trademark"] = 1000;
          t["edotaccent"] = 556;
          t["Igrave"] = 278;
          t["Imacron"] = 278;
          t["Lcaron"] = 611;
          t["onehalf"] = 834;
          t["lessequal"] = 549;
          t["ocircumflex"] = 611;
          t["ntilde"] = 611;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 667;
          t["emacron"] = 556;
          t["gbreve"] = 611;
          t["onequarter"] = 834;
          t["Scaron"] = 667;
          t["Scommaaccent"] = 667;
          t["Ohungarumlaut"] = 778;
          t["degree"] = 400;
          t["ograve"] = 611;
          t["Ccaron"] = 722;
          t["ugrave"] = 611;
          t["radical"] = 549;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 389;
          t["Ntilde"] = 722;
          t["otilde"] = 611;
          t["Rcommaaccent"] = 722;
          t["Lcommaaccent"] = 611;
          t["Atilde"] = 722;
          t["Aogonek"] = 722;
          t["Aring"] = 722;
          t["Otilde"] = 778;
          t["zdotaccent"] = 500;
          t["Ecaron"] = 667;
          t["Iogonek"] = 278;
          t["kcommaaccent"] = 556;
          t["minus"] = 584;
          t["Icircumflex"] = 278;
          t["ncaron"] = 611;
          t["tcommaaccent"] = 333;
          t["logicalnot"] = 584;
          t["odieresis"] = 611;
          t["udieresis"] = 611;
          t["notequal"] = 549;
          t["gcommaaccent"] = 611;
          t["eth"] = 611;
          t["zcaron"] = 500;
          t["ncommaaccent"] = 611;
          t["onesuperior"] = 333;
          t["imacron"] = 278;
          t["Euro"] = 556;
        });
        t["Helvetica-BoldOblique"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 278;
          t["exclam"] = 333;
          t["quotedbl"] = 474;
          t["numbersign"] = 556;
          t["dollar"] = 556;
          t["percent"] = 889;
          t["ampersand"] = 722;
          t["quoteright"] = 278;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 389;
          t["plus"] = 584;
          t["comma"] = 278;
          t["hyphen"] = 333;
          t["period"] = 278;
          t["slash"] = 278;
          t["zero"] = 556;
          t["one"] = 556;
          t["two"] = 556;
          t["three"] = 556;
          t["four"] = 556;
          t["five"] = 556;
          t["six"] = 556;
          t["seven"] = 556;
          t["eight"] = 556;
          t["nine"] = 556;
          t["colon"] = 333;
          t["semicolon"] = 333;
          t["less"] = 584;
          t["equal"] = 584;
          t["greater"] = 584;
          t["question"] = 611;
          t["at"] = 975;
          t["A"] = 722;
          t["B"] = 722;
          t["C"] = 722;
          t["D"] = 722;
          t["E"] = 667;
          t["F"] = 611;
          t["G"] = 778;
          t["H"] = 722;
          t["I"] = 278;
          t["J"] = 556;
          t["K"] = 722;
          t["L"] = 611;
          t["M"] = 833;
          t["N"] = 722;
          t["O"] = 778;
          t["P"] = 667;
          t["Q"] = 778;
          t["R"] = 722;
          t["S"] = 667;
          t["T"] = 611;
          t["U"] = 722;
          t["V"] = 667;
          t["W"] = 944;
          t["X"] = 667;
          t["Y"] = 667;
          t["Z"] = 611;
          t["bracketleft"] = 333;
          t["backslash"] = 278;
          t["bracketright"] = 333;
          t["asciicircum"] = 584;
          t["underscore"] = 556;
          t["quoteleft"] = 278;
          t["a"] = 556;
          t["b"] = 611;
          t["c"] = 556;
          t["d"] = 611;
          t["e"] = 556;
          t["f"] = 333;
          t["g"] = 611;
          t["h"] = 611;
          t["i"] = 278;
          t["j"] = 278;
          t["k"] = 556;
          t["l"] = 278;
          t["m"] = 889;
          t["n"] = 611;
          t["o"] = 611;
          t["p"] = 611;
          t["q"] = 611;
          t["r"] = 389;
          t["s"] = 556;
          t["t"] = 333;
          t["u"] = 611;
          t["v"] = 556;
          t["w"] = 778;
          t["x"] = 556;
          t["y"] = 556;
          t["z"] = 500;
          t["braceleft"] = 389;
          t["bar"] = 280;
          t["braceright"] = 389;
          t["asciitilde"] = 584;
          t["exclamdown"] = 333;
          t["cent"] = 556;
          t["sterling"] = 556;
          t["fraction"] = 167;
          t["yen"] = 556;
          t["florin"] = 556;
          t["section"] = 556;
          t["currency"] = 556;
          t["quotesingle"] = 238;
          t["quotedblleft"] = 500;
          t["guillemotleft"] = 556;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 611;
          t["fl"] = 611;
          t["endash"] = 556;
          t["dagger"] = 556;
          t["daggerdbl"] = 556;
          t["periodcentered"] = 278;
          t["paragraph"] = 556;
          t["bullet"] = 350;
          t["quotesinglbase"] = 278;
          t["quotedblbase"] = 500;
          t["quotedblright"] = 500;
          t["guillemotright"] = 556;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 611;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 1000;
          t["ordfeminine"] = 370;
          t["Lslash"] = 611;
          t["Oslash"] = 778;
          t["OE"] = 1000;
          t["ordmasculine"] = 365;
          t["ae"] = 889;
          t["dotlessi"] = 278;
          t["lslash"] = 278;
          t["oslash"] = 611;
          t["oe"] = 944;
          t["germandbls"] = 611;
          t["Idieresis"] = 278;
          t["eacute"] = 556;
          t["abreve"] = 556;
          t["uhungarumlaut"] = 611;
          t["ecaron"] = 556;
          t["Ydieresis"] = 667;
          t["divide"] = 584;
          t["Yacute"] = 667;
          t["Acircumflex"] = 722;
          t["aacute"] = 556;
          t["Ucircumflex"] = 722;
          t["yacute"] = 556;
          t["scommaaccent"] = 556;
          t["ecircumflex"] = 556;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 556;
          t["Uacute"] = 722;
          t["uogonek"] = 611;
          t["Edieresis"] = 667;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 737;
          t["Emacron"] = 667;
          t["ccaron"] = 556;
          t["aring"] = 556;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 278;
          t["agrave"] = 556;
          t["Tcommaaccent"] = 611;
          t["Cacute"] = 722;
          t["atilde"] = 556;
          t["Edotaccent"] = 667;
          t["scaron"] = 556;
          t["scedilla"] = 556;
          t["iacute"] = 278;
          t["lozenge"] = 494;
          t["Rcaron"] = 722;
          t["Gcommaaccent"] = 778;
          t["ucircumflex"] = 611;
          t["acircumflex"] = 556;
          t["Amacron"] = 722;
          t["rcaron"] = 389;
          t["ccedilla"] = 556;
          t["Zdotaccent"] = 611;
          t["Thorn"] = 667;
          t["Omacron"] = 778;
          t["Racute"] = 722;
          t["Sacute"] = 667;
          t["dcaron"] = 743;
          t["Umacron"] = 722;
          t["uring"] = 611;
          t["threesuperior"] = 333;
          t["Ograve"] = 778;
          t["Agrave"] = 722;
          t["Abreve"] = 722;
          t["multiply"] = 584;
          t["uacute"] = 611;
          t["Tcaron"] = 611;
          t["partialdiff"] = 494;
          t["ydieresis"] = 556;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 667;
          t["adieresis"] = 556;
          t["edieresis"] = 556;
          t["cacute"] = 556;
          t["nacute"] = 611;
          t["umacron"] = 611;
          t["Ncaron"] = 722;
          t["Iacute"] = 278;
          t["plusminus"] = 584;
          t["brokenbar"] = 280;
          t["registered"] = 737;
          t["Gbreve"] = 778;
          t["Idotaccent"] = 278;
          t["summation"] = 600;
          t["Egrave"] = 667;
          t["racute"] = 389;
          t["omacron"] = 611;
          t["Zacute"] = 611;
          t["Zcaron"] = 611;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 722;
          t["lcommaaccent"] = 278;
          t["tcaron"] = 389;
          t["eogonek"] = 556;
          t["Uogonek"] = 722;
          t["Aacute"] = 722;
          t["Adieresis"] = 722;
          t["egrave"] = 556;
          t["zacute"] = 500;
          t["iogonek"] = 278;
          t["Oacute"] = 778;
          t["oacute"] = 611;
          t["amacron"] = 556;
          t["sacute"] = 556;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 778;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 611;
          t["twosuperior"] = 333;
          t["Odieresis"] = 778;
          t["mu"] = 611;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 611;
          t["Eogonek"] = 667;
          t["dcroat"] = 611;
          t["threequarters"] = 834;
          t["Scedilla"] = 667;
          t["lcaron"] = 400;
          t["Kcommaaccent"] = 722;
          t["Lacute"] = 611;
          t["trademark"] = 1000;
          t["edotaccent"] = 556;
          t["Igrave"] = 278;
          t["Imacron"] = 278;
          t["Lcaron"] = 611;
          t["onehalf"] = 834;
          t["lessequal"] = 549;
          t["ocircumflex"] = 611;
          t["ntilde"] = 611;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 667;
          t["emacron"] = 556;
          t["gbreve"] = 611;
          t["onequarter"] = 834;
          t["Scaron"] = 667;
          t["Scommaaccent"] = 667;
          t["Ohungarumlaut"] = 778;
          t["degree"] = 400;
          t["ograve"] = 611;
          t["Ccaron"] = 722;
          t["ugrave"] = 611;
          t["radical"] = 549;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 389;
          t["Ntilde"] = 722;
          t["otilde"] = 611;
          t["Rcommaaccent"] = 722;
          t["Lcommaaccent"] = 611;
          t["Atilde"] = 722;
          t["Aogonek"] = 722;
          t["Aring"] = 722;
          t["Otilde"] = 778;
          t["zdotaccent"] = 500;
          t["Ecaron"] = 667;
          t["Iogonek"] = 278;
          t["kcommaaccent"] = 556;
          t["minus"] = 584;
          t["Icircumflex"] = 278;
          t["ncaron"] = 611;
          t["tcommaaccent"] = 333;
          t["logicalnot"] = 584;
          t["odieresis"] = 611;
          t["udieresis"] = 611;
          t["notequal"] = 549;
          t["gcommaaccent"] = 611;
          t["eth"] = 611;
          t["zcaron"] = 500;
          t["ncommaaccent"] = 611;
          t["onesuperior"] = 333;
          t["imacron"] = 278;
          t["Euro"] = 556;
        });
        t["Helvetica-Oblique"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 278;
          t["exclam"] = 278;
          t["quotedbl"] = 355;
          t["numbersign"] = 556;
          t["dollar"] = 556;
          t["percent"] = 889;
          t["ampersand"] = 667;
          t["quoteright"] = 222;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 389;
          t["plus"] = 584;
          t["comma"] = 278;
          t["hyphen"] = 333;
          t["period"] = 278;
          t["slash"] = 278;
          t["zero"] = 556;
          t["one"] = 556;
          t["two"] = 556;
          t["three"] = 556;
          t["four"] = 556;
          t["five"] = 556;
          t["six"] = 556;
          t["seven"] = 556;
          t["eight"] = 556;
          t["nine"] = 556;
          t["colon"] = 278;
          t["semicolon"] = 278;
          t["less"] = 584;
          t["equal"] = 584;
          t["greater"] = 584;
          t["question"] = 556;
          t["at"] = 1015;
          t["A"] = 667;
          t["B"] = 667;
          t["C"] = 722;
          t["D"] = 722;
          t["E"] = 667;
          t["F"] = 611;
          t["G"] = 778;
          t["H"] = 722;
          t["I"] = 278;
          t["J"] = 500;
          t["K"] = 667;
          t["L"] = 556;
          t["M"] = 833;
          t["N"] = 722;
          t["O"] = 778;
          t["P"] = 667;
          t["Q"] = 778;
          t["R"] = 722;
          t["S"] = 667;
          t["T"] = 611;
          t["U"] = 722;
          t["V"] = 667;
          t["W"] = 944;
          t["X"] = 667;
          t["Y"] = 667;
          t["Z"] = 611;
          t["bracketleft"] = 278;
          t["backslash"] = 278;
          t["bracketright"] = 278;
          t["asciicircum"] = 469;
          t["underscore"] = 556;
          t["quoteleft"] = 222;
          t["a"] = 556;
          t["b"] = 556;
          t["c"] = 500;
          t["d"] = 556;
          t["e"] = 556;
          t["f"] = 278;
          t["g"] = 556;
          t["h"] = 556;
          t["i"] = 222;
          t["j"] = 222;
          t["k"] = 500;
          t["l"] = 222;
          t["m"] = 833;
          t["n"] = 556;
          t["o"] = 556;
          t["p"] = 556;
          t["q"] = 556;
          t["r"] = 333;
          t["s"] = 500;
          t["t"] = 278;
          t["u"] = 556;
          t["v"] = 500;
          t["w"] = 722;
          t["x"] = 500;
          t["y"] = 500;
          t["z"] = 500;
          t["braceleft"] = 334;
          t["bar"] = 260;
          t["braceright"] = 334;
          t["asciitilde"] = 584;
          t["exclamdown"] = 333;
          t["cent"] = 556;
          t["sterling"] = 556;
          t["fraction"] = 167;
          t["yen"] = 556;
          t["florin"] = 556;
          t["section"] = 556;
          t["currency"] = 556;
          t["quotesingle"] = 191;
          t["quotedblleft"] = 333;
          t["guillemotleft"] = 556;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 500;
          t["fl"] = 500;
          t["endash"] = 556;
          t["dagger"] = 556;
          t["daggerdbl"] = 556;
          t["periodcentered"] = 278;
          t["paragraph"] = 537;
          t["bullet"] = 350;
          t["quotesinglbase"] = 222;
          t["quotedblbase"] = 333;
          t["quotedblright"] = 333;
          t["guillemotright"] = 556;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 611;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 1000;
          t["ordfeminine"] = 370;
          t["Lslash"] = 556;
          t["Oslash"] = 778;
          t["OE"] = 1000;
          t["ordmasculine"] = 365;
          t["ae"] = 889;
          t["dotlessi"] = 278;
          t["lslash"] = 222;
          t["oslash"] = 611;
          t["oe"] = 944;
          t["germandbls"] = 611;
          t["Idieresis"] = 278;
          t["eacute"] = 556;
          t["abreve"] = 556;
          t["uhungarumlaut"] = 556;
          t["ecaron"] = 556;
          t["Ydieresis"] = 667;
          t["divide"] = 584;
          t["Yacute"] = 667;
          t["Acircumflex"] = 667;
          t["aacute"] = 556;
          t["Ucircumflex"] = 722;
          t["yacute"] = 500;
          t["scommaaccent"] = 500;
          t["ecircumflex"] = 556;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 556;
          t["Uacute"] = 722;
          t["uogonek"] = 556;
          t["Edieresis"] = 667;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 737;
          t["Emacron"] = 667;
          t["ccaron"] = 500;
          t["aring"] = 556;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 222;
          t["agrave"] = 556;
          t["Tcommaaccent"] = 611;
          t["Cacute"] = 722;
          t["atilde"] = 556;
          t["Edotaccent"] = 667;
          t["scaron"] = 500;
          t["scedilla"] = 500;
          t["iacute"] = 278;
          t["lozenge"] = 471;
          t["Rcaron"] = 722;
          t["Gcommaaccent"] = 778;
          t["ucircumflex"] = 556;
          t["acircumflex"] = 556;
          t["Amacron"] = 667;
          t["rcaron"] = 333;
          t["ccedilla"] = 500;
          t["Zdotaccent"] = 611;
          t["Thorn"] = 667;
          t["Omacron"] = 778;
          t["Racute"] = 722;
          t["Sacute"] = 667;
          t["dcaron"] = 643;
          t["Umacron"] = 722;
          t["uring"] = 556;
          t["threesuperior"] = 333;
          t["Ograve"] = 778;
          t["Agrave"] = 667;
          t["Abreve"] = 667;
          t["multiply"] = 584;
          t["uacute"] = 556;
          t["Tcaron"] = 611;
          t["partialdiff"] = 476;
          t["ydieresis"] = 500;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 667;
          t["adieresis"] = 556;
          t["edieresis"] = 556;
          t["cacute"] = 500;
          t["nacute"] = 556;
          t["umacron"] = 556;
          t["Ncaron"] = 722;
          t["Iacute"] = 278;
          t["plusminus"] = 584;
          t["brokenbar"] = 260;
          t["registered"] = 737;
          t["Gbreve"] = 778;
          t["Idotaccent"] = 278;
          t["summation"] = 600;
          t["Egrave"] = 667;
          t["racute"] = 333;
          t["omacron"] = 556;
          t["Zacute"] = 611;
          t["Zcaron"] = 611;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 722;
          t["lcommaaccent"] = 222;
          t["tcaron"] = 317;
          t["eogonek"] = 556;
          t["Uogonek"] = 722;
          t["Aacute"] = 667;
          t["Adieresis"] = 667;
          t["egrave"] = 556;
          t["zacute"] = 500;
          t["iogonek"] = 222;
          t["Oacute"] = 778;
          t["oacute"] = 556;
          t["amacron"] = 556;
          t["sacute"] = 500;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 778;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 556;
          t["twosuperior"] = 333;
          t["Odieresis"] = 778;
          t["mu"] = 556;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 556;
          t["Eogonek"] = 667;
          t["dcroat"] = 556;
          t["threequarters"] = 834;
          t["Scedilla"] = 667;
          t["lcaron"] = 299;
          t["Kcommaaccent"] = 667;
          t["Lacute"] = 556;
          t["trademark"] = 1000;
          t["edotaccent"] = 556;
          t["Igrave"] = 278;
          t["Imacron"] = 278;
          t["Lcaron"] = 556;
          t["onehalf"] = 834;
          t["lessequal"] = 549;
          t["ocircumflex"] = 556;
          t["ntilde"] = 556;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 667;
          t["emacron"] = 556;
          t["gbreve"] = 556;
          t["onequarter"] = 834;
          t["Scaron"] = 667;
          t["Scommaaccent"] = 667;
          t["Ohungarumlaut"] = 778;
          t["degree"] = 400;
          t["ograve"] = 556;
          t["Ccaron"] = 722;
          t["ugrave"] = 556;
          t["radical"] = 453;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 333;
          t["Ntilde"] = 722;
          t["otilde"] = 556;
          t["Rcommaaccent"] = 722;
          t["Lcommaaccent"] = 556;
          t["Atilde"] = 667;
          t["Aogonek"] = 667;
          t["Aring"] = 667;
          t["Otilde"] = 778;
          t["zdotaccent"] = 500;
          t["Ecaron"] = 667;
          t["Iogonek"] = 278;
          t["kcommaaccent"] = 500;
          t["minus"] = 584;
          t["Icircumflex"] = 278;
          t["ncaron"] = 556;
          t["tcommaaccent"] = 278;
          t["logicalnot"] = 584;
          t["odieresis"] = 556;
          t["udieresis"] = 556;
          t["notequal"] = 549;
          t["gcommaaccent"] = 556;
          t["eth"] = 556;
          t["zcaron"] = 500;
          t["ncommaaccent"] = 556;
          t["onesuperior"] = 333;
          t["imacron"] = 278;
          t["Euro"] = 556;
        });
        t["Symbol"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 250;
          t["exclam"] = 333;
          t["universal"] = 713;
          t["numbersign"] = 500;
          t["existential"] = 549;
          t["percent"] = 833;
          t["ampersand"] = 778;
          t["suchthat"] = 439;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asteriskmath"] = 500;
          t["plus"] = 549;
          t["comma"] = 250;
          t["minus"] = 549;
          t["period"] = 250;
          t["slash"] = 278;
          t["zero"] = 500;
          t["one"] = 500;
          t["two"] = 500;
          t["three"] = 500;
          t["four"] = 500;
          t["five"] = 500;
          t["six"] = 500;
          t["seven"] = 500;
          t["eight"] = 500;
          t["nine"] = 500;
          t["colon"] = 278;
          t["semicolon"] = 278;
          t["less"] = 549;
          t["equal"] = 549;
          t["greater"] = 549;
          t["question"] = 444;
          t["congruent"] = 549;
          t["Alpha"] = 722;
          t["Beta"] = 667;
          t["Chi"] = 722;
          t["Delta"] = 612;
          t["Epsilon"] = 611;
          t["Phi"] = 763;
          t["Gamma"] = 603;
          t["Eta"] = 722;
          t["Iota"] = 333;
          t["theta1"] = 631;
          t["Kappa"] = 722;
          t["Lambda"] = 686;
          t["Mu"] = 889;
          t["Nu"] = 722;
          t["Omicron"] = 722;
          t["Pi"] = 768;
          t["Theta"] = 741;
          t["Rho"] = 556;
          t["Sigma"] = 592;
          t["Tau"] = 611;
          t["Upsilon"] = 690;
          t["sigma1"] = 439;
          t["Omega"] = 768;
          t["Xi"] = 645;
          t["Psi"] = 795;
          t["Zeta"] = 611;
          t["bracketleft"] = 333;
          t["therefore"] = 863;
          t["bracketright"] = 333;
          t["perpendicular"] = 658;
          t["underscore"] = 500;
          t["radicalex"] = 500;
          t["alpha"] = 631;
          t["beta"] = 549;
          t["chi"] = 549;
          t["delta"] = 494;
          t["epsilon"] = 439;
          t["phi"] = 521;
          t["gamma"] = 411;
          t["eta"] = 603;
          t["iota"] = 329;
          t["phi1"] = 603;
          t["kappa"] = 549;
          t["lambda"] = 549;
          t["mu"] = 576;
          t["nu"] = 521;
          t["omicron"] = 549;
          t["pi"] = 549;
          t["theta"] = 521;
          t["rho"] = 549;
          t["sigma"] = 603;
          t["tau"] = 439;
          t["upsilon"] = 576;
          t["omega1"] = 713;
          t["omega"] = 686;
          t["xi"] = 493;
          t["psi"] = 686;
          t["zeta"] = 494;
          t["braceleft"] = 480;
          t["bar"] = 200;
          t["braceright"] = 480;
          t["similar"] = 549;
          t["Euro"] = 750;
          t["Upsilon1"] = 620;
          t["minute"] = 247;
          t["lessequal"] = 549;
          t["fraction"] = 167;
          t["infinity"] = 713;
          t["florin"] = 500;
          t["club"] = 753;
          t["diamond"] = 753;
          t["heart"] = 753;
          t["spade"] = 753;
          t["arrowboth"] = 1042;
          t["arrowleft"] = 987;
          t["arrowup"] = 603;
          t["arrowright"] = 987;
          t["arrowdown"] = 603;
          t["degree"] = 400;
          t["plusminus"] = 549;
          t["second"] = 411;
          t["greaterequal"] = 549;
          t["multiply"] = 549;
          t["proportional"] = 713;
          t["partialdiff"] = 494;
          t["bullet"] = 460;
          t["divide"] = 549;
          t["notequal"] = 549;
          t["equivalence"] = 549;
          t["approxequal"] = 549;
          t["ellipsis"] = 1000;
          t["arrowvertex"] = 603;
          t["arrowhorizex"] = 1000;
          t["carriagereturn"] = 658;
          t["aleph"] = 823;
          t["Ifraktur"] = 686;
          t["Rfraktur"] = 795;
          t["weierstrass"] = 987;
          t["circlemultiply"] = 768;
          t["circleplus"] = 768;
          t["emptyset"] = 823;
          t["intersection"] = 768;
          t["union"] = 768;
          t["propersuperset"] = 713;
          t["reflexsuperset"] = 713;
          t["notsubset"] = 713;
          t["propersubset"] = 713;
          t["reflexsubset"] = 713;
          t["element"] = 713;
          t["notelement"] = 713;
          t["angle"] = 768;
          t["gradient"] = 713;
          t["registerserif"] = 790;
          t["copyrightserif"] = 790;
          t["trademarkserif"] = 890;
          t["product"] = 823;
          t["radical"] = 549;
          t["dotmath"] = 250;
          t["logicalnot"] = 713;
          t["logicaland"] = 603;
          t["logicalor"] = 603;
          t["arrowdblboth"] = 1042;
          t["arrowdblleft"] = 987;
          t["arrowdblup"] = 603;
          t["arrowdblright"] = 987;
          t["arrowdbldown"] = 603;
          t["lozenge"] = 494;
          t["angleleft"] = 329;
          t["registersans"] = 790;
          t["copyrightsans"] = 790;
          t["trademarksans"] = 786;
          t["summation"] = 713;
          t["parenlefttp"] = 384;
          t["parenleftex"] = 384;
          t["parenleftbt"] = 384;
          t["bracketlefttp"] = 384;
          t["bracketleftex"] = 384;
          t["bracketleftbt"] = 384;
          t["bracelefttp"] = 494;
          t["braceleftmid"] = 494;
          t["braceleftbt"] = 494;
          t["braceex"] = 494;
          t["angleright"] = 329;
          t["integral"] = 274;
          t["integraltp"] = 686;
          t["integralex"] = 686;
          t["integralbt"] = 686;
          t["parenrighttp"] = 384;
          t["parenrightex"] = 384;
          t["parenrightbt"] = 384;
          t["bracketrighttp"] = 384;
          t["bracketrightex"] = 384;
          t["bracketrightbt"] = 384;
          t["bracerighttp"] = 494;
          t["bracerightmid"] = 494;
          t["bracerightbt"] = 494;
          t["apple"] = 790;
        });
        t["Times-Roman"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 250;
          t["exclam"] = 333;
          t["quotedbl"] = 408;
          t["numbersign"] = 500;
          t["dollar"] = 500;
          t["percent"] = 833;
          t["ampersand"] = 778;
          t["quoteright"] = 333;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 500;
          t["plus"] = 564;
          t["comma"] = 250;
          t["hyphen"] = 333;
          t["period"] = 250;
          t["slash"] = 278;
          t["zero"] = 500;
          t["one"] = 500;
          t["two"] = 500;
          t["three"] = 500;
          t["four"] = 500;
          t["five"] = 500;
          t["six"] = 500;
          t["seven"] = 500;
          t["eight"] = 500;
          t["nine"] = 500;
          t["colon"] = 278;
          t["semicolon"] = 278;
          t["less"] = 564;
          t["equal"] = 564;
          t["greater"] = 564;
          t["question"] = 444;
          t["at"] = 921;
          t["A"] = 722;
          t["B"] = 667;
          t["C"] = 667;
          t["D"] = 722;
          t["E"] = 611;
          t["F"] = 556;
          t["G"] = 722;
          t["H"] = 722;
          t["I"] = 333;
          t["J"] = 389;
          t["K"] = 722;
          t["L"] = 611;
          t["M"] = 889;
          t["N"] = 722;
          t["O"] = 722;
          t["P"] = 556;
          t["Q"] = 722;
          t["R"] = 667;
          t["S"] = 556;
          t["T"] = 611;
          t["U"] = 722;
          t["V"] = 722;
          t["W"] = 944;
          t["X"] = 722;
          t["Y"] = 722;
          t["Z"] = 611;
          t["bracketleft"] = 333;
          t["backslash"] = 278;
          t["bracketright"] = 333;
          t["asciicircum"] = 469;
          t["underscore"] = 500;
          t["quoteleft"] = 333;
          t["a"] = 444;
          t["b"] = 500;
          t["c"] = 444;
          t["d"] = 500;
          t["e"] = 444;
          t["f"] = 333;
          t["g"] = 500;
          t["h"] = 500;
          t["i"] = 278;
          t["j"] = 278;
          t["k"] = 500;
          t["l"] = 278;
          t["m"] = 778;
          t["n"] = 500;
          t["o"] = 500;
          t["p"] = 500;
          t["q"] = 500;
          t["r"] = 333;
          t["s"] = 389;
          t["t"] = 278;
          t["u"] = 500;
          t["v"] = 500;
          t["w"] = 722;
          t["x"] = 500;
          t["y"] = 500;
          t["z"] = 444;
          t["braceleft"] = 480;
          t["bar"] = 200;
          t["braceright"] = 480;
          t["asciitilde"] = 541;
          t["exclamdown"] = 333;
          t["cent"] = 500;
          t["sterling"] = 500;
          t["fraction"] = 167;
          t["yen"] = 500;
          t["florin"] = 500;
          t["section"] = 500;
          t["currency"] = 500;
          t["quotesingle"] = 180;
          t["quotedblleft"] = 444;
          t["guillemotleft"] = 500;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 556;
          t["fl"] = 556;
          t["endash"] = 500;
          t["dagger"] = 500;
          t["daggerdbl"] = 500;
          t["periodcentered"] = 250;
          t["paragraph"] = 453;
          t["bullet"] = 350;
          t["quotesinglbase"] = 333;
          t["quotedblbase"] = 444;
          t["quotedblright"] = 444;
          t["guillemotright"] = 500;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 444;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 889;
          t["ordfeminine"] = 276;
          t["Lslash"] = 611;
          t["Oslash"] = 722;
          t["OE"] = 889;
          t["ordmasculine"] = 310;
          t["ae"] = 667;
          t["dotlessi"] = 278;
          t["lslash"] = 278;
          t["oslash"] = 500;
          t["oe"] = 722;
          t["germandbls"] = 500;
          t["Idieresis"] = 333;
          t["eacute"] = 444;
          t["abreve"] = 444;
          t["uhungarumlaut"] = 500;
          t["ecaron"] = 444;
          t["Ydieresis"] = 722;
          t["divide"] = 564;
          t["Yacute"] = 722;
          t["Acircumflex"] = 722;
          t["aacute"] = 444;
          t["Ucircumflex"] = 722;
          t["yacute"] = 500;
          t["scommaaccent"] = 389;
          t["ecircumflex"] = 444;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 444;
          t["Uacute"] = 722;
          t["uogonek"] = 500;
          t["Edieresis"] = 611;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 760;
          t["Emacron"] = 611;
          t["ccaron"] = 444;
          t["aring"] = 444;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 278;
          t["agrave"] = 444;
          t["Tcommaaccent"] = 611;
          t["Cacute"] = 667;
          t["atilde"] = 444;
          t["Edotaccent"] = 611;
          t["scaron"] = 389;
          t["scedilla"] = 389;
          t["iacute"] = 278;
          t["lozenge"] = 471;
          t["Rcaron"] = 667;
          t["Gcommaaccent"] = 722;
          t["ucircumflex"] = 500;
          t["acircumflex"] = 444;
          t["Amacron"] = 722;
          t["rcaron"] = 333;
          t["ccedilla"] = 444;
          t["Zdotaccent"] = 611;
          t["Thorn"] = 556;
          t["Omacron"] = 722;
          t["Racute"] = 667;
          t["Sacute"] = 556;
          t["dcaron"] = 588;
          t["Umacron"] = 722;
          t["uring"] = 500;
          t["threesuperior"] = 300;
          t["Ograve"] = 722;
          t["Agrave"] = 722;
          t["Abreve"] = 722;
          t["multiply"] = 564;
          t["uacute"] = 500;
          t["Tcaron"] = 611;
          t["partialdiff"] = 476;
          t["ydieresis"] = 500;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 611;
          t["adieresis"] = 444;
          t["edieresis"] = 444;
          t["cacute"] = 444;
          t["nacute"] = 500;
          t["umacron"] = 500;
          t["Ncaron"] = 722;
          t["Iacute"] = 333;
          t["plusminus"] = 564;
          t["brokenbar"] = 200;
          t["registered"] = 760;
          t["Gbreve"] = 722;
          t["Idotaccent"] = 333;
          t["summation"] = 600;
          t["Egrave"] = 611;
          t["racute"] = 333;
          t["omacron"] = 500;
          t["Zacute"] = 611;
          t["Zcaron"] = 611;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 667;
          t["lcommaaccent"] = 278;
          t["tcaron"] = 326;
          t["eogonek"] = 444;
          t["Uogonek"] = 722;
          t["Aacute"] = 722;
          t["Adieresis"] = 722;
          t["egrave"] = 444;
          t["zacute"] = 444;
          t["iogonek"] = 278;
          t["Oacute"] = 722;
          t["oacute"] = 500;
          t["amacron"] = 444;
          t["sacute"] = 389;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 722;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 500;
          t["twosuperior"] = 300;
          t["Odieresis"] = 722;
          t["mu"] = 500;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 500;
          t["Eogonek"] = 611;
          t["dcroat"] = 500;
          t["threequarters"] = 750;
          t["Scedilla"] = 556;
          t["lcaron"] = 344;
          t["Kcommaaccent"] = 722;
          t["Lacute"] = 611;
          t["trademark"] = 980;
          t["edotaccent"] = 444;
          t["Igrave"] = 333;
          t["Imacron"] = 333;
          t["Lcaron"] = 611;
          t["onehalf"] = 750;
          t["lessequal"] = 549;
          t["ocircumflex"] = 500;
          t["ntilde"] = 500;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 611;
          t["emacron"] = 444;
          t["gbreve"] = 500;
          t["onequarter"] = 750;
          t["Scaron"] = 556;
          t["Scommaaccent"] = 556;
          t["Ohungarumlaut"] = 722;
          t["degree"] = 400;
          t["ograve"] = 500;
          t["Ccaron"] = 667;
          t["ugrave"] = 500;
          t["radical"] = 453;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 333;
          t["Ntilde"] = 722;
          t["otilde"] = 500;
          t["Rcommaaccent"] = 667;
          t["Lcommaaccent"] = 611;
          t["Atilde"] = 722;
          t["Aogonek"] = 722;
          t["Aring"] = 722;
          t["Otilde"] = 722;
          t["zdotaccent"] = 444;
          t["Ecaron"] = 611;
          t["Iogonek"] = 333;
          t["kcommaaccent"] = 500;
          t["minus"] = 564;
          t["Icircumflex"] = 333;
          t["ncaron"] = 500;
          t["tcommaaccent"] = 278;
          t["logicalnot"] = 564;
          t["odieresis"] = 500;
          t["udieresis"] = 500;
          t["notequal"] = 549;
          t["gcommaaccent"] = 500;
          t["eth"] = 500;
          t["zcaron"] = 444;
          t["ncommaaccent"] = 500;
          t["onesuperior"] = 300;
          t["imacron"] = 278;
          t["Euro"] = 500;
        });
        t["Times-Bold"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 250;
          t["exclam"] = 333;
          t["quotedbl"] = 555;
          t["numbersign"] = 500;
          t["dollar"] = 500;
          t["percent"] = 1000;
          t["ampersand"] = 833;
          t["quoteright"] = 333;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 500;
          t["plus"] = 570;
          t["comma"] = 250;
          t["hyphen"] = 333;
          t["period"] = 250;
          t["slash"] = 278;
          t["zero"] = 500;
          t["one"] = 500;
          t["two"] = 500;
          t["three"] = 500;
          t["four"] = 500;
          t["five"] = 500;
          t["six"] = 500;
          t["seven"] = 500;
          t["eight"] = 500;
          t["nine"] = 500;
          t["colon"] = 333;
          t["semicolon"] = 333;
          t["less"] = 570;
          t["equal"] = 570;
          t["greater"] = 570;
          t["question"] = 500;
          t["at"] = 930;
          t["A"] = 722;
          t["B"] = 667;
          t["C"] = 722;
          t["D"] = 722;
          t["E"] = 667;
          t["F"] = 611;
          t["G"] = 778;
          t["H"] = 778;
          t["I"] = 389;
          t["J"] = 500;
          t["K"] = 778;
          t["L"] = 667;
          t["M"] = 944;
          t["N"] = 722;
          t["O"] = 778;
          t["P"] = 611;
          t["Q"] = 778;
          t["R"] = 722;
          t["S"] = 556;
          t["T"] = 667;
          t["U"] = 722;
          t["V"] = 722;
          t["W"] = 1000;
          t["X"] = 722;
          t["Y"] = 722;
          t["Z"] = 667;
          t["bracketleft"] = 333;
          t["backslash"] = 278;
          t["bracketright"] = 333;
          t["asciicircum"] = 581;
          t["underscore"] = 500;
          t["quoteleft"] = 333;
          t["a"] = 500;
          t["b"] = 556;
          t["c"] = 444;
          t["d"] = 556;
          t["e"] = 444;
          t["f"] = 333;
          t["g"] = 500;
          t["h"] = 556;
          t["i"] = 278;
          t["j"] = 333;
          t["k"] = 556;
          t["l"] = 278;
          t["m"] = 833;
          t["n"] = 556;
          t["o"] = 500;
          t["p"] = 556;
          t["q"] = 556;
          t["r"] = 444;
          t["s"] = 389;
          t["t"] = 333;
          t["u"] = 556;
          t["v"] = 500;
          t["w"] = 722;
          t["x"] = 500;
          t["y"] = 500;
          t["z"] = 444;
          t["braceleft"] = 394;
          t["bar"] = 220;
          t["braceright"] = 394;
          t["asciitilde"] = 520;
          t["exclamdown"] = 333;
          t["cent"] = 500;
          t["sterling"] = 500;
          t["fraction"] = 167;
          t["yen"] = 500;
          t["florin"] = 500;
          t["section"] = 500;
          t["currency"] = 500;
          t["quotesingle"] = 278;
          t["quotedblleft"] = 500;
          t["guillemotleft"] = 500;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 556;
          t["fl"] = 556;
          t["endash"] = 500;
          t["dagger"] = 500;
          t["daggerdbl"] = 500;
          t["periodcentered"] = 250;
          t["paragraph"] = 540;
          t["bullet"] = 350;
          t["quotesinglbase"] = 333;
          t["quotedblbase"] = 500;
          t["quotedblright"] = 500;
          t["guillemotright"] = 500;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 500;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 1000;
          t["ordfeminine"] = 300;
          t["Lslash"] = 667;
          t["Oslash"] = 778;
          t["OE"] = 1000;
          t["ordmasculine"] = 330;
          t["ae"] = 722;
          t["dotlessi"] = 278;
          t["lslash"] = 278;
          t["oslash"] = 500;
          t["oe"] = 722;
          t["germandbls"] = 556;
          t["Idieresis"] = 389;
          t["eacute"] = 444;
          t["abreve"] = 500;
          t["uhungarumlaut"] = 556;
          t["ecaron"] = 444;
          t["Ydieresis"] = 722;
          t["divide"] = 570;
          t["Yacute"] = 722;
          t["Acircumflex"] = 722;
          t["aacute"] = 500;
          t["Ucircumflex"] = 722;
          t["yacute"] = 500;
          t["scommaaccent"] = 389;
          t["ecircumflex"] = 444;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 500;
          t["Uacute"] = 722;
          t["uogonek"] = 556;
          t["Edieresis"] = 667;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 747;
          t["Emacron"] = 667;
          t["ccaron"] = 444;
          t["aring"] = 500;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 278;
          t["agrave"] = 500;
          t["Tcommaaccent"] = 667;
          t["Cacute"] = 722;
          t["atilde"] = 500;
          t["Edotaccent"] = 667;
          t["scaron"] = 389;
          t["scedilla"] = 389;
          t["iacute"] = 278;
          t["lozenge"] = 494;
          t["Rcaron"] = 722;
          t["Gcommaaccent"] = 778;
          t["ucircumflex"] = 556;
          t["acircumflex"] = 500;
          t["Amacron"] = 722;
          t["rcaron"] = 444;
          t["ccedilla"] = 444;
          t["Zdotaccent"] = 667;
          t["Thorn"] = 611;
          t["Omacron"] = 778;
          t["Racute"] = 722;
          t["Sacute"] = 556;
          t["dcaron"] = 672;
          t["Umacron"] = 722;
          t["uring"] = 556;
          t["threesuperior"] = 300;
          t["Ograve"] = 778;
          t["Agrave"] = 722;
          t["Abreve"] = 722;
          t["multiply"] = 570;
          t["uacute"] = 556;
          t["Tcaron"] = 667;
          t["partialdiff"] = 494;
          t["ydieresis"] = 500;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 667;
          t["adieresis"] = 500;
          t["edieresis"] = 444;
          t["cacute"] = 444;
          t["nacute"] = 556;
          t["umacron"] = 556;
          t["Ncaron"] = 722;
          t["Iacute"] = 389;
          t["plusminus"] = 570;
          t["brokenbar"] = 220;
          t["registered"] = 747;
          t["Gbreve"] = 778;
          t["Idotaccent"] = 389;
          t["summation"] = 600;
          t["Egrave"] = 667;
          t["racute"] = 444;
          t["omacron"] = 500;
          t["Zacute"] = 667;
          t["Zcaron"] = 667;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 722;
          t["lcommaaccent"] = 278;
          t["tcaron"] = 416;
          t["eogonek"] = 444;
          t["Uogonek"] = 722;
          t["Aacute"] = 722;
          t["Adieresis"] = 722;
          t["egrave"] = 444;
          t["zacute"] = 444;
          t["iogonek"] = 278;
          t["Oacute"] = 778;
          t["oacute"] = 500;
          t["amacron"] = 500;
          t["sacute"] = 389;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 778;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 556;
          t["twosuperior"] = 300;
          t["Odieresis"] = 778;
          t["mu"] = 556;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 500;
          t["Eogonek"] = 667;
          t["dcroat"] = 556;
          t["threequarters"] = 750;
          t["Scedilla"] = 556;
          t["lcaron"] = 394;
          t["Kcommaaccent"] = 778;
          t["Lacute"] = 667;
          t["trademark"] = 1000;
          t["edotaccent"] = 444;
          t["Igrave"] = 389;
          t["Imacron"] = 389;
          t["Lcaron"] = 667;
          t["onehalf"] = 750;
          t["lessequal"] = 549;
          t["ocircumflex"] = 500;
          t["ntilde"] = 556;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 667;
          t["emacron"] = 444;
          t["gbreve"] = 500;
          t["onequarter"] = 750;
          t["Scaron"] = 556;
          t["Scommaaccent"] = 556;
          t["Ohungarumlaut"] = 778;
          t["degree"] = 400;
          t["ograve"] = 500;
          t["Ccaron"] = 722;
          t["ugrave"] = 556;
          t["radical"] = 549;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 444;
          t["Ntilde"] = 722;
          t["otilde"] = 500;
          t["Rcommaaccent"] = 722;
          t["Lcommaaccent"] = 667;
          t["Atilde"] = 722;
          t["Aogonek"] = 722;
          t["Aring"] = 722;
          t["Otilde"] = 778;
          t["zdotaccent"] = 444;
          t["Ecaron"] = 667;
          t["Iogonek"] = 389;
          t["kcommaaccent"] = 556;
          t["minus"] = 570;
          t["Icircumflex"] = 389;
          t["ncaron"] = 556;
          t["tcommaaccent"] = 333;
          t["logicalnot"] = 570;
          t["odieresis"] = 500;
          t["udieresis"] = 556;
          t["notequal"] = 549;
          t["gcommaaccent"] = 500;
          t["eth"] = 500;
          t["zcaron"] = 444;
          t["ncommaaccent"] = 556;
          t["onesuperior"] = 300;
          t["imacron"] = 278;
          t["Euro"] = 500;
        });
        t["Times-BoldItalic"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 250;
          t["exclam"] = 389;
          t["quotedbl"] = 555;
          t["numbersign"] = 500;
          t["dollar"] = 500;
          t["percent"] = 833;
          t["ampersand"] = 778;
          t["quoteright"] = 333;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 500;
          t["plus"] = 570;
          t["comma"] = 250;
          t["hyphen"] = 333;
          t["period"] = 250;
          t["slash"] = 278;
          t["zero"] = 500;
          t["one"] = 500;
          t["two"] = 500;
          t["three"] = 500;
          t["four"] = 500;
          t["five"] = 500;
          t["six"] = 500;
          t["seven"] = 500;
          t["eight"] = 500;
          t["nine"] = 500;
          t["colon"] = 333;
          t["semicolon"] = 333;
          t["less"] = 570;
          t["equal"] = 570;
          t["greater"] = 570;
          t["question"] = 500;
          t["at"] = 832;
          t["A"] = 667;
          t["B"] = 667;
          t["C"] = 667;
          t["D"] = 722;
          t["E"] = 667;
          t["F"] = 667;
          t["G"] = 722;
          t["H"] = 778;
          t["I"] = 389;
          t["J"] = 500;
          t["K"] = 667;
          t["L"] = 611;
          t["M"] = 889;
          t["N"] = 722;
          t["O"] = 722;
          t["P"] = 611;
          t["Q"] = 722;
          t["R"] = 667;
          t["S"] = 556;
          t["T"] = 611;
          t["U"] = 722;
          t["V"] = 667;
          t["W"] = 889;
          t["X"] = 667;
          t["Y"] = 611;
          t["Z"] = 611;
          t["bracketleft"] = 333;
          t["backslash"] = 278;
          t["bracketright"] = 333;
          t["asciicircum"] = 570;
          t["underscore"] = 500;
          t["quoteleft"] = 333;
          t["a"] = 500;
          t["b"] = 500;
          t["c"] = 444;
          t["d"] = 500;
          t["e"] = 444;
          t["f"] = 333;
          t["g"] = 500;
          t["h"] = 556;
          t["i"] = 278;
          t["j"] = 278;
          t["k"] = 500;
          t["l"] = 278;
          t["m"] = 778;
          t["n"] = 556;
          t["o"] = 500;
          t["p"] = 500;
          t["q"] = 500;
          t["r"] = 389;
          t["s"] = 389;
          t["t"] = 278;
          t["u"] = 556;
          t["v"] = 444;
          t["w"] = 667;
          t["x"] = 500;
          t["y"] = 444;
          t["z"] = 389;
          t["braceleft"] = 348;
          t["bar"] = 220;
          t["braceright"] = 348;
          t["asciitilde"] = 570;
          t["exclamdown"] = 389;
          t["cent"] = 500;
          t["sterling"] = 500;
          t["fraction"] = 167;
          t["yen"] = 500;
          t["florin"] = 500;
          t["section"] = 500;
          t["currency"] = 500;
          t["quotesingle"] = 278;
          t["quotedblleft"] = 500;
          t["guillemotleft"] = 500;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 556;
          t["fl"] = 556;
          t["endash"] = 500;
          t["dagger"] = 500;
          t["daggerdbl"] = 500;
          t["periodcentered"] = 250;
          t["paragraph"] = 500;
          t["bullet"] = 350;
          t["quotesinglbase"] = 333;
          t["quotedblbase"] = 500;
          t["quotedblright"] = 500;
          t["guillemotright"] = 500;
          t["ellipsis"] = 1000;
          t["perthousand"] = 1000;
          t["questiondown"] = 500;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 1000;
          t["AE"] = 944;
          t["ordfeminine"] = 266;
          t["Lslash"] = 611;
          t["Oslash"] = 722;
          t["OE"] = 944;
          t["ordmasculine"] = 300;
          t["ae"] = 722;
          t["dotlessi"] = 278;
          t["lslash"] = 278;
          t["oslash"] = 500;
          t["oe"] = 722;
          t["germandbls"] = 500;
          t["Idieresis"] = 389;
          t["eacute"] = 444;
          t["abreve"] = 500;
          t["uhungarumlaut"] = 556;
          t["ecaron"] = 444;
          t["Ydieresis"] = 611;
          t["divide"] = 570;
          t["Yacute"] = 611;
          t["Acircumflex"] = 667;
          t["aacute"] = 500;
          t["Ucircumflex"] = 722;
          t["yacute"] = 444;
          t["scommaaccent"] = 389;
          t["ecircumflex"] = 444;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 500;
          t["Uacute"] = 722;
          t["uogonek"] = 556;
          t["Edieresis"] = 667;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 747;
          t["Emacron"] = 667;
          t["ccaron"] = 444;
          t["aring"] = 500;
          t["Ncommaaccent"] = 722;
          t["lacute"] = 278;
          t["agrave"] = 500;
          t["Tcommaaccent"] = 611;
          t["Cacute"] = 667;
          t["atilde"] = 500;
          t["Edotaccent"] = 667;
          t["scaron"] = 389;
          t["scedilla"] = 389;
          t["iacute"] = 278;
          t["lozenge"] = 494;
          t["Rcaron"] = 667;
          t["Gcommaaccent"] = 722;
          t["ucircumflex"] = 556;
          t["acircumflex"] = 500;
          t["Amacron"] = 667;
          t["rcaron"] = 389;
          t["ccedilla"] = 444;
          t["Zdotaccent"] = 611;
          t["Thorn"] = 611;
          t["Omacron"] = 722;
          t["Racute"] = 667;
          t["Sacute"] = 556;
          t["dcaron"] = 608;
          t["Umacron"] = 722;
          t["uring"] = 556;
          t["threesuperior"] = 300;
          t["Ograve"] = 722;
          t["Agrave"] = 667;
          t["Abreve"] = 667;
          t["multiply"] = 570;
          t["uacute"] = 556;
          t["Tcaron"] = 611;
          t["partialdiff"] = 494;
          t["ydieresis"] = 444;
          t["Nacute"] = 722;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 667;
          t["adieresis"] = 500;
          t["edieresis"] = 444;
          t["cacute"] = 444;
          t["nacute"] = 556;
          t["umacron"] = 556;
          t["Ncaron"] = 722;
          t["Iacute"] = 389;
          t["plusminus"] = 570;
          t["brokenbar"] = 220;
          t["registered"] = 747;
          t["Gbreve"] = 722;
          t["Idotaccent"] = 389;
          t["summation"] = 600;
          t["Egrave"] = 667;
          t["racute"] = 389;
          t["omacron"] = 500;
          t["Zacute"] = 611;
          t["Zcaron"] = 611;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 667;
          t["lcommaaccent"] = 278;
          t["tcaron"] = 366;
          t["eogonek"] = 444;
          t["Uogonek"] = 722;
          t["Aacute"] = 667;
          t["Adieresis"] = 667;
          t["egrave"] = 444;
          t["zacute"] = 389;
          t["iogonek"] = 278;
          t["Oacute"] = 722;
          t["oacute"] = 500;
          t["amacron"] = 500;
          t["sacute"] = 389;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 722;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 500;
          t["twosuperior"] = 300;
          t["Odieresis"] = 722;
          t["mu"] = 576;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 500;
          t["Eogonek"] = 667;
          t["dcroat"] = 500;
          t["threequarters"] = 750;
          t["Scedilla"] = 556;
          t["lcaron"] = 382;
          t["Kcommaaccent"] = 667;
          t["Lacute"] = 611;
          t["trademark"] = 1000;
          t["edotaccent"] = 444;
          t["Igrave"] = 389;
          t["Imacron"] = 389;
          t["Lcaron"] = 611;
          t["onehalf"] = 750;
          t["lessequal"] = 549;
          t["ocircumflex"] = 500;
          t["ntilde"] = 556;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 667;
          t["emacron"] = 444;
          t["gbreve"] = 500;
          t["onequarter"] = 750;
          t["Scaron"] = 556;
          t["Scommaaccent"] = 556;
          t["Ohungarumlaut"] = 722;
          t["degree"] = 400;
          t["ograve"] = 500;
          t["Ccaron"] = 667;
          t["ugrave"] = 556;
          t["radical"] = 549;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 389;
          t["Ntilde"] = 722;
          t["otilde"] = 500;
          t["Rcommaaccent"] = 667;
          t["Lcommaaccent"] = 611;
          t["Atilde"] = 667;
          t["Aogonek"] = 667;
          t["Aring"] = 667;
          t["Otilde"] = 722;
          t["zdotaccent"] = 389;
          t["Ecaron"] = 667;
          t["Iogonek"] = 389;
          t["kcommaaccent"] = 500;
          t["minus"] = 606;
          t["Icircumflex"] = 389;
          t["ncaron"] = 556;
          t["tcommaaccent"] = 278;
          t["logicalnot"] = 606;
          t["odieresis"] = 500;
          t["udieresis"] = 556;
          t["notequal"] = 549;
          t["gcommaaccent"] = 500;
          t["eth"] = 500;
          t["zcaron"] = 389;
          t["ncommaaccent"] = 556;
          t["onesuperior"] = 300;
          t["imacron"] = 278;
          t["Euro"] = 500;
        });
        t["Times-Italic"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 250;
          t["exclam"] = 333;
          t["quotedbl"] = 420;
          t["numbersign"] = 500;
          t["dollar"] = 500;
          t["percent"] = 833;
          t["ampersand"] = 778;
          t["quoteright"] = 333;
          t["parenleft"] = 333;
          t["parenright"] = 333;
          t["asterisk"] = 500;
          t["plus"] = 675;
          t["comma"] = 250;
          t["hyphen"] = 333;
          t["period"] = 250;
          t["slash"] = 278;
          t["zero"] = 500;
          t["one"] = 500;
          t["two"] = 500;
          t["three"] = 500;
          t["four"] = 500;
          t["five"] = 500;
          t["six"] = 500;
          t["seven"] = 500;
          t["eight"] = 500;
          t["nine"] = 500;
          t["colon"] = 333;
          t["semicolon"] = 333;
          t["less"] = 675;
          t["equal"] = 675;
          t["greater"] = 675;
          t["question"] = 500;
          t["at"] = 920;
          t["A"] = 611;
          t["B"] = 611;
          t["C"] = 667;
          t["D"] = 722;
          t["E"] = 611;
          t["F"] = 611;
          t["G"] = 722;
          t["H"] = 722;
          t["I"] = 333;
          t["J"] = 444;
          t["K"] = 667;
          t["L"] = 556;
          t["M"] = 833;
          t["N"] = 667;
          t["O"] = 722;
          t["P"] = 611;
          t["Q"] = 722;
          t["R"] = 611;
          t["S"] = 500;
          t["T"] = 556;
          t["U"] = 722;
          t["V"] = 611;
          t["W"] = 833;
          t["X"] = 611;
          t["Y"] = 556;
          t["Z"] = 556;
          t["bracketleft"] = 389;
          t["backslash"] = 278;
          t["bracketright"] = 389;
          t["asciicircum"] = 422;
          t["underscore"] = 500;
          t["quoteleft"] = 333;
          t["a"] = 500;
          t["b"] = 500;
          t["c"] = 444;
          t["d"] = 500;
          t["e"] = 444;
          t["f"] = 278;
          t["g"] = 500;
          t["h"] = 500;
          t["i"] = 278;
          t["j"] = 278;
          t["k"] = 444;
          t["l"] = 278;
          t["m"] = 722;
          t["n"] = 500;
          t["o"] = 500;
          t["p"] = 500;
          t["q"] = 500;
          t["r"] = 389;
          t["s"] = 389;
          t["t"] = 278;
          t["u"] = 500;
          t["v"] = 444;
          t["w"] = 667;
          t["x"] = 444;
          t["y"] = 444;
          t["z"] = 389;
          t["braceleft"] = 400;
          t["bar"] = 275;
          t["braceright"] = 400;
          t["asciitilde"] = 541;
          t["exclamdown"] = 389;
          t["cent"] = 500;
          t["sterling"] = 500;
          t["fraction"] = 167;
          t["yen"] = 500;
          t["florin"] = 500;
          t["section"] = 500;
          t["currency"] = 500;
          t["quotesingle"] = 214;
          t["quotedblleft"] = 556;
          t["guillemotleft"] = 500;
          t["guilsinglleft"] = 333;
          t["guilsinglright"] = 333;
          t["fi"] = 500;
          t["fl"] = 500;
          t["endash"] = 500;
          t["dagger"] = 500;
          t["daggerdbl"] = 500;
          t["periodcentered"] = 250;
          t["paragraph"] = 523;
          t["bullet"] = 350;
          t["quotesinglbase"] = 333;
          t["quotedblbase"] = 556;
          t["quotedblright"] = 556;
          t["guillemotright"] = 500;
          t["ellipsis"] = 889;
          t["perthousand"] = 1000;
          t["questiondown"] = 500;
          t["grave"] = 333;
          t["acute"] = 333;
          t["circumflex"] = 333;
          t["tilde"] = 333;
          t["macron"] = 333;
          t["breve"] = 333;
          t["dotaccent"] = 333;
          t["dieresis"] = 333;
          t["ring"] = 333;
          t["cedilla"] = 333;
          t["hungarumlaut"] = 333;
          t["ogonek"] = 333;
          t["caron"] = 333;
          t["emdash"] = 889;
          t["AE"] = 889;
          t["ordfeminine"] = 276;
          t["Lslash"] = 556;
          t["Oslash"] = 722;
          t["OE"] = 944;
          t["ordmasculine"] = 310;
          t["ae"] = 667;
          t["dotlessi"] = 278;
          t["lslash"] = 278;
          t["oslash"] = 500;
          t["oe"] = 667;
          t["germandbls"] = 500;
          t["Idieresis"] = 333;
          t["eacute"] = 444;
          t["abreve"] = 500;
          t["uhungarumlaut"] = 500;
          t["ecaron"] = 444;
          t["Ydieresis"] = 556;
          t["divide"] = 675;
          t["Yacute"] = 556;
          t["Acircumflex"] = 611;
          t["aacute"] = 500;
          t["Ucircumflex"] = 722;
          t["yacute"] = 444;
          t["scommaaccent"] = 389;
          t["ecircumflex"] = 444;
          t["Uring"] = 722;
          t["Udieresis"] = 722;
          t["aogonek"] = 500;
          t["Uacute"] = 722;
          t["uogonek"] = 500;
          t["Edieresis"] = 611;
          t["Dcroat"] = 722;
          t["commaaccent"] = 250;
          t["copyright"] = 760;
          t["Emacron"] = 611;
          t["ccaron"] = 444;
          t["aring"] = 500;
          t["Ncommaaccent"] = 667;
          t["lacute"] = 278;
          t["agrave"] = 500;
          t["Tcommaaccent"] = 556;
          t["Cacute"] = 667;
          t["atilde"] = 500;
          t["Edotaccent"] = 611;
          t["scaron"] = 389;
          t["scedilla"] = 389;
          t["iacute"] = 278;
          t["lozenge"] = 471;
          t["Rcaron"] = 611;
          t["Gcommaaccent"] = 722;
          t["ucircumflex"] = 500;
          t["acircumflex"] = 500;
          t["Amacron"] = 611;
          t["rcaron"] = 389;
          t["ccedilla"] = 444;
          t["Zdotaccent"] = 556;
          t["Thorn"] = 611;
          t["Omacron"] = 722;
          t["Racute"] = 611;
          t["Sacute"] = 500;
          t["dcaron"] = 544;
          t["Umacron"] = 722;
          t["uring"] = 500;
          t["threesuperior"] = 300;
          t["Ograve"] = 722;
          t["Agrave"] = 611;
          t["Abreve"] = 611;
          t["multiply"] = 675;
          t["uacute"] = 500;
          t["Tcaron"] = 556;
          t["partialdiff"] = 476;
          t["ydieresis"] = 444;
          t["Nacute"] = 667;
          t["icircumflex"] = 278;
          t["Ecircumflex"] = 611;
          t["adieresis"] = 500;
          t["edieresis"] = 444;
          t["cacute"] = 444;
          t["nacute"] = 500;
          t["umacron"] = 500;
          t["Ncaron"] = 667;
          t["Iacute"] = 333;
          t["plusminus"] = 675;
          t["brokenbar"] = 275;
          t["registered"] = 760;
          t["Gbreve"] = 722;
          t["Idotaccent"] = 333;
          t["summation"] = 600;
          t["Egrave"] = 611;
          t["racute"] = 389;
          t["omacron"] = 500;
          t["Zacute"] = 556;
          t["Zcaron"] = 556;
          t["greaterequal"] = 549;
          t["Eth"] = 722;
          t["Ccedilla"] = 667;
          t["lcommaaccent"] = 278;
          t["tcaron"] = 300;
          t["eogonek"] = 444;
          t["Uogonek"] = 722;
          t["Aacute"] = 611;
          t["Adieresis"] = 611;
          t["egrave"] = 444;
          t["zacute"] = 389;
          t["iogonek"] = 278;
          t["Oacute"] = 722;
          t["oacute"] = 500;
          t["amacron"] = 500;
          t["sacute"] = 389;
          t["idieresis"] = 278;
          t["Ocircumflex"] = 722;
          t["Ugrave"] = 722;
          t["Delta"] = 612;
          t["thorn"] = 500;
          t["twosuperior"] = 300;
          t["Odieresis"] = 722;
          t["mu"] = 500;
          t["igrave"] = 278;
          t["ohungarumlaut"] = 500;
          t["Eogonek"] = 611;
          t["dcroat"] = 500;
          t["threequarters"] = 750;
          t["Scedilla"] = 500;
          t["lcaron"] = 300;
          t["Kcommaaccent"] = 667;
          t["Lacute"] = 556;
          t["trademark"] = 980;
          t["edotaccent"] = 444;
          t["Igrave"] = 333;
          t["Imacron"] = 333;
          t["Lcaron"] = 611;
          t["onehalf"] = 750;
          t["lessequal"] = 549;
          t["ocircumflex"] = 500;
          t["ntilde"] = 500;
          t["Uhungarumlaut"] = 722;
          t["Eacute"] = 611;
          t["emacron"] = 444;
          t["gbreve"] = 500;
          t["onequarter"] = 750;
          t["Scaron"] = 500;
          t["Scommaaccent"] = 500;
          t["Ohungarumlaut"] = 722;
          t["degree"] = 400;
          t["ograve"] = 500;
          t["Ccaron"] = 667;
          t["ugrave"] = 500;
          t["radical"] = 453;
          t["Dcaron"] = 722;
          t["rcommaaccent"] = 389;
          t["Ntilde"] = 667;
          t["otilde"] = 500;
          t["Rcommaaccent"] = 611;
          t["Lcommaaccent"] = 556;
          t["Atilde"] = 611;
          t["Aogonek"] = 611;
          t["Aring"] = 611;
          t["Otilde"] = 722;
          t["zdotaccent"] = 389;
          t["Ecaron"] = 611;
          t["Iogonek"] = 333;
          t["kcommaaccent"] = 444;
          t["minus"] = 675;
          t["Icircumflex"] = 333;
          t["ncaron"] = 500;
          t["tcommaaccent"] = 278;
          t["logicalnot"] = 675;
          t["odieresis"] = 500;
          t["udieresis"] = 500;
          t["notequal"] = 549;
          t["gcommaaccent"] = 500;
          t["eth"] = 500;
          t["zcaron"] = 389;
          t["ncommaaccent"] = 500;
          t["onesuperior"] = 300;
          t["imacron"] = 278;
          t["Euro"] = 500;
        });
        t["ZapfDingbats"] = (0, _util.getLookupTableFactory)(function (t) {
          t["space"] = 278;
          t["a1"] = 974;
          t["a2"] = 961;
          t["a202"] = 974;
          t["a3"] = 980;
          t["a4"] = 719;
          t["a5"] = 789;
          t["a119"] = 790;
          t["a118"] = 791;
          t["a117"] = 690;
          t["a11"] = 960;
          t["a12"] = 939;
          t["a13"] = 549;
          t["a14"] = 855;
          t["a15"] = 911;
          t["a16"] = 933;
          t["a105"] = 911;
          t["a17"] = 945;
          t["a18"] = 974;
          t["a19"] = 755;
          t["a20"] = 846;
          t["a21"] = 762;
          t["a22"] = 761;
          t["a23"] = 571;
          t["a24"] = 677;
          t["a25"] = 763;
          t["a26"] = 760;
          t["a27"] = 759;
          t["a28"] = 754;
          t["a6"] = 494;
          t["a7"] = 552;
          t["a8"] = 537;
          t["a9"] = 577;
          t["a10"] = 692;
          t["a29"] = 786;
          t["a30"] = 788;
          t["a31"] = 788;
          t["a32"] = 790;
          t["a33"] = 793;
          t["a34"] = 794;
          t["a35"] = 816;
          t["a36"] = 823;
          t["a37"] = 789;
          t["a38"] = 841;
          t["a39"] = 823;
          t["a40"] = 833;
          t["a41"] = 816;
          t["a42"] = 831;
          t["a43"] = 923;
          t["a44"] = 744;
          t["a45"] = 723;
          t["a46"] = 749;
          t["a47"] = 790;
          t["a48"] = 792;
          t["a49"] = 695;
          t["a50"] = 776;
          t["a51"] = 768;
          t["a52"] = 792;
          t["a53"] = 759;
          t["a54"] = 707;
          t["a55"] = 708;
          t["a56"] = 682;
          t["a57"] = 701;
          t["a58"] = 826;
          t["a59"] = 815;
          t["a60"] = 789;
          t["a61"] = 789;
          t["a62"] = 707;
          t["a63"] = 687;
          t["a64"] = 696;
          t["a65"] = 689;
          t["a66"] = 786;
          t["a67"] = 787;
          t["a68"] = 713;
          t["a69"] = 791;
          t["a70"] = 785;
          t["a71"] = 791;
          t["a72"] = 873;
          t["a73"] = 761;
          t["a74"] = 762;
          t["a203"] = 762;
          t["a75"] = 759;
          t["a204"] = 759;
          t["a76"] = 892;
          t["a77"] = 892;
          t["a78"] = 788;
          t["a79"] = 784;
          t["a81"] = 438;
          t["a82"] = 138;
          t["a83"] = 277;
          t["a84"] = 415;
          t["a97"] = 392;
          t["a98"] = 392;
          t["a99"] = 668;
          t["a100"] = 668;
          t["a89"] = 390;
          t["a90"] = 390;
          t["a93"] = 317;
          t["a94"] = 317;
          t["a91"] = 276;
          t["a92"] = 276;
          t["a205"] = 509;
          t["a85"] = 509;
          t["a206"] = 410;
          t["a86"] = 410;
          t["a87"] = 234;
          t["a88"] = 234;
          t["a95"] = 334;
          t["a96"] = 334;
          t["a101"] = 732;
          t["a102"] = 544;
          t["a103"] = 544;
          t["a104"] = 910;
          t["a106"] = 667;
          t["a107"] = 760;
          t["a108"] = 760;
          t["a112"] = 776;
          t["a111"] = 595;
          t["a110"] = 694;
          t["a109"] = 626;
          t["a120"] = 788;
          t["a121"] = 788;
          t["a122"] = 788;
          t["a123"] = 788;
          t["a124"] = 788;
          t["a125"] = 788;
          t["a126"] = 788;
          t["a127"] = 788;
          t["a128"] = 788;
          t["a129"] = 788;
          t["a130"] = 788;
          t["a131"] = 788;
          t["a132"] = 788;
          t["a133"] = 788;
          t["a134"] = 788;
          t["a135"] = 788;
          t["a136"] = 788;
          t["a137"] = 788;
          t["a138"] = 788;
          t["a139"] = 788;
          t["a140"] = 788;
          t["a141"] = 788;
          t["a142"] = 788;
          t["a143"] = 788;
          t["a144"] = 788;
          t["a145"] = 788;
          t["a146"] = 788;
          t["a147"] = 788;
          t["a148"] = 788;
          t["a149"] = 788;
          t["a150"] = 788;
          t["a151"] = 788;
          t["a152"] = 788;
          t["a153"] = 788;
          t["a154"] = 788;
          t["a155"] = 788;
          t["a156"] = 788;
          t["a157"] = 788;
          t["a158"] = 788;
          t["a159"] = 788;
          t["a160"] = 894;
          t["a161"] = 838;
          t["a163"] = 1016;
          t["a164"] = 458;
          t["a196"] = 748;
          t["a165"] = 924;
          t["a192"] = 748;
          t["a166"] = 918;
          t["a167"] = 927;
          t["a168"] = 928;
          t["a169"] = 928;
          t["a170"] = 834;
          t["a171"] = 873;
          t["a172"] = 828;
          t["a173"] = 924;
          t["a162"] = 924;
          t["a174"] = 917;
          t["a175"] = 930;
          t["a176"] = 931;
          t["a177"] = 463;
          t["a178"] = 883;
          t["a179"] = 836;
          t["a193"] = 836;
          t["a180"] = 867;
          t["a199"] = 867;
          t["a181"] = 696;
          t["a200"] = 696;
          t["a182"] = 874;
          t["a201"] = 874;
          t["a183"] = 760;
          t["a184"] = 946;
          t["a197"] = 771;
          t["a185"] = 865;
          t["a194"] = 771;
          t["a198"] = 888;
          t["a186"] = 967;
          t["a195"] = 888;
          t["a187"] = 831;
          t["a188"] = 873;
          t["a189"] = 927;
          t["a190"] = 970;
          t["a191"] = 918;
        });
      });
      exports.getMetrics = getMetrics;

      /***/ }),
    /* 141 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PostScriptParser = exports.PostScriptLexer = undefined;

      var _util = __w_pdfjs_require__(0);

      var _primitives = __w_pdfjs_require__(2);

      var PostScriptParser = function PostScriptParserClosure() {
        function PostScriptParser(lexer) {
          this.lexer = lexer;
          this.operators = [];
          this.token = null;
          this.prev = null;
        }
        PostScriptParser.prototype = {
          nextToken: function PostScriptParser_nextToken() {
            this.prev = this.token;
            this.token = this.lexer.getToken();
          },
          accept: function PostScriptParser_accept(type) {
            if (this.token.type === type) {
              this.nextToken();
              return true;
            }
            return false;
          },
          expect: function PostScriptParser_expect(type) {
            if (this.accept(type)) {
              return true;
            }
            throw new _util.FormatError("Unexpected symbol: found " + this.token.type + " expected " + type + ".");
          },
          parse: function PostScriptParser_parse() {
            this.nextToken();
            this.expect(PostScriptTokenTypes.LBRACE);
            this.parseBlock();
            this.expect(PostScriptTokenTypes.RBRACE);
            return this.operators;
          },
          parseBlock: function PostScriptParser_parseBlock() {
            while (true) {
              if (this.accept(PostScriptTokenTypes.NUMBER)) {
                this.operators.push(this.prev.value);
              } else if (this.accept(PostScriptTokenTypes.OPERATOR)) {
                this.operators.push(this.prev.value);
              } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
                this.parseCondition();
              } else {
                return;
              }
            }
          },
          parseCondition: function PostScriptParser_parseCondition() {
            var conditionLocation = this.operators.length;
            this.operators.push(null, null);
            this.parseBlock();
            this.expect(PostScriptTokenTypes.RBRACE);
            if (this.accept(PostScriptTokenTypes.IF)) {
              this.operators[conditionLocation] = this.operators.length;
              this.operators[conditionLocation + 1] = "jz";
            } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
              var jumpLocation = this.operators.length;
              this.operators.push(null, null);
              var endOfTrue = this.operators.length;
              this.parseBlock();
              this.expect(PostScriptTokenTypes.RBRACE);
              this.expect(PostScriptTokenTypes.IFELSE);
              this.operators[jumpLocation] = this.operators.length;
              this.operators[jumpLocation + 1] = "j";
              this.operators[conditionLocation] = endOfTrue;
              this.operators[conditionLocation + 1] = "jz";
            } else {
              throw new _util.FormatError("PS Function: error parsing conditional.");
            }
          }
        };
        return PostScriptParser;
      }();
      var PostScriptTokenTypes = {
        LBRACE: 0,
        RBRACE: 1,
        NUMBER: 2,
        OPERATOR: 3,
        IF: 4,
        IFELSE: 5
      };
      var PostScriptToken = function PostScriptTokenClosure() {
        function PostScriptToken(type, value) {
          this.type = type;
          this.value = value;
        }
        var opCache = Object.create(null);
        PostScriptToken.getOperator = function PostScriptToken_getOperator(op) {
          var opValue = opCache[op];
          if (opValue) {
            return opValue;
          }
          return opCache[op] = new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
        };
        PostScriptToken.LBRACE = new PostScriptToken(PostScriptTokenTypes.LBRACE, "{");
        PostScriptToken.RBRACE = new PostScriptToken(PostScriptTokenTypes.RBRACE, "}");
        PostScriptToken.IF = new PostScriptToken(PostScriptTokenTypes.IF, "IF");
        PostScriptToken.IFELSE = new PostScriptToken(PostScriptTokenTypes.IFELSE, "IFELSE");
        return PostScriptToken;
      }();
      var PostScriptLexer = function PostScriptLexerClosure() {
        function PostScriptLexer(stream) {
          this.stream = stream;
          this.nextChar();
          this.strBuf = [];
        }
        PostScriptLexer.prototype = {
          nextChar: function PostScriptLexer_nextChar() {
            return this.currentChar = this.stream.getByte();
          },
          getToken: function PostScriptLexer_getToken() {
            var comment = false;
            var ch = this.currentChar;
            while (true) {
              if (ch < 0) {
                return _primitives.EOF;
              }
              if (comment) {
                if (ch === 0x0A || ch === 0x0D) {
                  comment = false;
                }
              } else if (ch === 0x25) {
                comment = true;
              } else if (!(0, _util.isSpace)(ch)) {
                break;
              }
              ch = this.nextChar();
            }
            switch (ch | 0) {
              case 0x30:
              case 0x31:
              case 0x32:
              case 0x33:
              case 0x34:
              case 0x35:
              case 0x36:
              case 0x37:
              case 0x38:
              case 0x39:
              case 0x2B:
              case 0x2D:
              case 0x2E:
                return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
              case 0x7B:
                this.nextChar();
                return PostScriptToken.LBRACE;
              case 0x7D:
                this.nextChar();
                return PostScriptToken.RBRACE;
            }
            var strBuf = this.strBuf;
            strBuf.length = 0;
            strBuf[0] = String.fromCharCode(ch);
            while ((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5A || ch >= 0x61 && ch <= 0x7A)) {
              strBuf.push(String.fromCharCode(ch));
            }
            var str = strBuf.join("");
            switch (str.toLowerCase()) {
              case "if":
                return PostScriptToken.IF;
              case "ifelse":
                return PostScriptToken.IFELSE;
              default:
                return PostScriptToken.getOperator(str);
            }
          },
          getNumber: function PostScriptLexer_getNumber() {
            var ch = this.currentChar;
            var strBuf = this.strBuf;
            strBuf.length = 0;
            strBuf[0] = String.fromCharCode(ch);
            while ((ch = this.nextChar()) >= 0) {
              if (ch >= 0x30 && ch <= 0x39 || ch === 0x2D || ch === 0x2E) {
                strBuf.push(String.fromCharCode(ch));
              } else {
                break;
              }
            }
            var value = parseFloat(strBuf.join(""));
            if (isNaN(value)) {
              throw new _util.FormatError("Invalid floating point number: " + value);
            }
            return value;
          }
        };
        return PostScriptLexer;
      }();
      exports.PostScriptLexer = PostScriptLexer;
      exports.PostScriptParser = PostScriptParser;

      /***/ }),
    /* 142 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

      var MurmurHash3_64 = function MurmurHash3_64Closure(seed) {
        var MASK_HIGH = 0xffff0000;
        var MASK_LOW = 0xffff;
        function MurmurHash3_64(seed) {
          var SEED = 0xc3d2e1f0;
          this.h1 = seed ? seed & 0xffffffff : SEED;
          this.h2 = seed ? seed & 0xffffffff : SEED;
        }
        MurmurHash3_64.prototype = {
          update: function MurmurHash3_64_update(input) {
            var i;
            if (typeof input === "string") {
              var data = new Uint8Array(input.length * 2);
              var length = 0;
              for (i = 0; i < input.length; i++) {
                var code = input.charCodeAt(i);
                if (code <= 0xff) {
                  data[length++] = code;
                } else {
                  data[length++] = code >>> 8;
                  data[length++] = code & 0xff;
                }
              }
            } else if ((typeof input === "undefined" ? "undefined" : _typeof(input)) === "object" && "byteLength" in input) {
              data = input;
              length = data.byteLength;
            } else {
              throw new Error("Wrong data format in MurmurHash3_64_update. " + "Input must be a string or array.");
            }
            var blockCounts = length >> 2;
            var tailLength = length - blockCounts * 4;
            var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
            var k1 = 0;
            var k2 = 0;
            var h1 = this.h1;
            var h2 = this.h2;
            var C1 = 0xcc9e2d51;
            var C2 = 0x1b873593;
            var C1_LOW = C1 & MASK_LOW;
            var C2_LOW = C2 & MASK_LOW;
            for (i = 0; i < blockCounts; i++) {
              if (i & 1) {
                k1 = dataUint32[i];
                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                h1 ^= k1;
                h1 = h1 << 13 | h1 >>> 19;
                h1 = h1 * 5 + 0xe6546b64;
              } else {
                k2 = dataUint32[i];
                k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                k2 = k2 << 15 | k2 >>> 17;
                k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                h2 ^= k2;
                h2 = h2 << 13 | h2 >>> 19;
                h2 = h2 * 5 + 0xe6546b64;
              }
            }
            k1 = 0;
            switch (tailLength) {
              case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
              case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
              case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                if (blockCounts & 1) {
                  h1 ^= k1;
                } else {
                  h2 ^= k1;
                }
            }
            this.h1 = h1;
            this.h2 = h2;
            return this;
          },
          hexdigest: function MurmurHash3_64_hexdigest() {
            var h1 = this.h1;
            var h2 = this.h2;
            h1 ^= h2 >>> 1;
            h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
            h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
            h1 ^= h2 >>> 1;
            h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
            h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
            h1 ^= h2 >>> 1;
            for (var i = 0, arr = [h1, h2], str = ""; i < arr.length; i++) {
              var hex = (arr[i] >>> 0).toString(16);
              while (hex.length < 8) {
                hex = "0" + hex;
              }
              str += hex;
            }
            return str;
          }
        };
        return MurmurHash3_64;
      }();
      exports.MurmurHash3_64 = MurmurHash3_64;

      /***/ }),
    /* 143 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PDFImage = undefined;

      var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

      var _util = __w_pdfjs_require__(0);

      var _stream = __w_pdfjs_require__(5);

      var _primitives = __w_pdfjs_require__(2);

      var _colorspace = __w_pdfjs_require__(26);

      var _jpx = __w_pdfjs_require__(74);

      var PDFImage = function PDFImageClosure() {
        function handleImageData(image, nativeDecoder) {
          if (nativeDecoder && nativeDecoder.canDecode(image)) {
            return nativeDecoder.decode(image);
          }
          return Promise.resolve(image);
        }
        function decodeAndClamp(value, addend, coefficient, max) {
          value = addend + value * coefficient;
          return value < 0 ? 0 : value > max ? max : value;
        }
        function resizeImageMask(src, bpc, w1, h1, w2, h2) {
          var length = w2 * h2;
          var dest = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
          var xRatio = w1 / w2;
          var yRatio = h1 / h2;
          var i,
            j,
            py,
            newIndex = 0,
            oldIndex;
          var xScaled = new Uint16Array(w2);
          var w1Scanline = w1;
          for (i = 0; i < w2; i++) {
            xScaled[i] = Math.floor(i * xRatio);
          }
          for (i = 0; i < h2; i++) {
            py = Math.floor(i * yRatio) * w1Scanline;
            for (j = 0; j < w2; j++) {
              oldIndex = py + xScaled[j];
              dest[newIndex++] = src[oldIndex];
            }
          }
          return dest;
        }
        function PDFImage(_ref) {
          var xref = _ref.xref,
            res = _ref.res,
            image = _ref.image,
            _ref$smask = _ref.smask,
            smask = _ref$smask === undefined ? null : _ref$smask,
            _ref$mask = _ref.mask,
            mask = _ref$mask === undefined ? null : _ref$mask,
            _ref$isMask = _ref.isMask,
            isMask = _ref$isMask === undefined ? false : _ref$isMask,
            pdfFunctionFactory = _ref.pdfFunctionFactory;

          this.image = image;
          var dict = image.dict;
          if (dict.has("Filter")) {
            var filter = dict.get("Filter").name;
            if (filter === "JPXDecode") {
              var jpxImage = new _jpx.JpxImage();
              jpxImage.parseImageProperties(image.stream);
              image.stream.reset();
              image.bitsPerComponent = jpxImage.bitsPerComponent;
              image.numComps = jpxImage.componentsCount;
            } else if (filter === "JBIG2Decode") {
              image.bitsPerComponent = 1;
              image.numComps = 1;
            }
          }
          this.width = dict.get("Width", "W");
          this.height = dict.get("Height", "H");
          if (this.width < 1 || this.height < 1) {
            throw new _util.FormatError("Invalid image width: " + this.width + " or " + ("height: " + this.height));
          }
          this.interpolate = dict.get("Interpolate", "I") || false;
          this.imageMask = dict.get("ImageMask", "IM") || false;
          this.matte = dict.get("Matte") || false;
          var bitsPerComponent = image.bitsPerComponent;
          if (!bitsPerComponent) {
            bitsPerComponent = dict.get("BitsPerComponent", "BPC");
            if (!bitsPerComponent) {
              if (this.imageMask) {
                bitsPerComponent = 1;
              } else {
                throw new _util.FormatError("Bits per component missing in image: " + this.imageMask);
              }
            }
          }
          this.bpc = bitsPerComponent;
          if (!this.imageMask) {
            var colorSpace = dict.get("ColorSpace", "CS");
            if (!colorSpace) {
              (0, _util.info)("JPX images (which do not require color spaces)");
              switch (image.numComps) {
                case 1:
                  colorSpace = _primitives.Name.get("DeviceGray");
                  break;
                case 3:
                  colorSpace = _primitives.Name.get("DeviceRGB");
                  break;
                case 4:
                  colorSpace = _primitives.Name.get("DeviceCMYK");
                  break;
                default:
                  throw new Error("JPX images with " + this.numComps + " " + "color components not supported.");
              }
            }
            this.colorSpace = _colorspace.ColorSpace.parse(colorSpace, xref, res, pdfFunctionFactory);
            this.numComps = this.colorSpace.numComps;
          }
          this.decode = dict.getArray("Decode", "D");
          this.needsDecode = false;
          if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
            this.needsDecode = true;
            var max = (1 << bitsPerComponent) - 1;
            this.decodeCoefficients = [];
            this.decodeAddends = [];
            for (var i = 0, j = 0; i < this.decode.length; i += 2, ++j) {
              var dmin = this.decode[i];
              var dmax = this.decode[i + 1];
              this.decodeCoefficients[j] = dmax - dmin;
              this.decodeAddends[j] = max * dmin;
            }
          }
          if (smask) {
            this.smask = new PDFImage({
              xref: xref,
              res: res,
              image: smask,
              pdfFunctionFactory: pdfFunctionFactory
            });
          } else if (mask) {
            if ((0, _primitives.isStream)(mask)) {
              var maskDict = mask.dict,
                imageMask = maskDict.get("ImageMask", "IM");
              if (!imageMask) {
                (0, _util.warn)("Ignoring /Mask in image without /ImageMask.");
              } else {
                this.mask = new PDFImage({
                  xref: xref,
                  res: res,
                  image: mask,
                  isMask: true,
                  pdfFunctionFactory: pdfFunctionFactory
                });
              }
            } else {
              this.mask = mask;
            }
          }
        }
        PDFImage.buildImage = function (_ref2) {
          var handler = _ref2.handler,
            xref = _ref2.xref,
            res = _ref2.res,
            image = _ref2.image,
            _ref2$nativeDecoder = _ref2.nativeDecoder,
            nativeDecoder = _ref2$nativeDecoder === undefined ? null : _ref2$nativeDecoder,
            pdfFunctionFactory = _ref2.pdfFunctionFactory;

          var imagePromise = handleImageData(image, nativeDecoder);
          var smaskPromise;
          var maskPromise;
          var smask = image.dict.get("SMask");
          var mask = image.dict.get("Mask");
          if (smask) {
            smaskPromise = handleImageData(smask, nativeDecoder);
            maskPromise = Promise.resolve(null);
          } else {
            smaskPromise = Promise.resolve(null);
            if (mask) {
              if ((0, _primitives.isStream)(mask)) {
                maskPromise = handleImageData(mask, nativeDecoder);
              } else if (Array.isArray(mask)) {
                maskPromise = Promise.resolve(mask);
              } else {
                (0, _util.warn)("Unsupported mask format.");
                maskPromise = Promise.resolve(null);
              }
            } else {
              maskPromise = Promise.resolve(null);
            }
          }
          return Promise.all([imagePromise, smaskPromise, maskPromise]).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 3),
              imageData = _ref4[0],
              smaskData = _ref4[1],
              maskData = _ref4[2];

            return new PDFImage({
              xref: xref,
              res: res,
              image: imageData,
              smask: smaskData,
              mask: maskData,
              pdfFunctionFactory: pdfFunctionFactory
            });
          });
        };
        PDFImage.createMask = function (_ref5) {
          var imgArray = _ref5.imgArray,
            width = _ref5.width,
            height = _ref5.height,
            imageIsFromDecodeStream = _ref5.imageIsFromDecodeStream,
            inverseDecode = _ref5.inverseDecode;

          var computedLength = (width + 7 >> 3) * height;
          var actualLength = imgArray.byteLength;
          var haveFullData = computedLength === actualLength;
          var data, i;
          if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) {
            data = imgArray;
          } else if (!inverseDecode) {
            data = new Uint8Array(actualLength);
            data.set(imgArray);
          } else {
            data = new Uint8Array(computedLength);
            data.set(imgArray);
            for (i = actualLength; i < computedLength; i++) {
              data[i] = 0xff;
            }
          }
          if (inverseDecode) {
            for (i = 0; i < actualLength; i++) {
              data[i] ^= 0xFF;
            }
          }
          return {
            data: data,
            width: width,
            height: height
          };
        };
        PDFImage.prototype = {
          get drawWidth() {
            return Math.max(this.width, this.smask && this.smask.width || 0, this.mask && this.mask.width || 0);
          },
          get drawHeight() {
            return Math.max(this.height, this.smask && this.smask.height || 0, this.mask && this.mask.height || 0);
          },
          decodeBuffer: function decodeBuffer(buffer) {
            var bpc = this.bpc;
            var numComps = this.numComps;
            var decodeAddends = this.decodeAddends;
            var decodeCoefficients = this.decodeCoefficients;
            var max = (1 << bpc) - 1;
            var i, ii;
            if (bpc === 1) {
              for (i = 0, ii = buffer.length; i < ii; i++) {
                buffer[i] = +!buffer[i];
              }
              return;
            }
            var index = 0;
            for (i = 0, ii = this.width * this.height; i < ii; i++) {
              for (var j = 0; j < numComps; j++) {
                buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
                index++;
              }
            }
          },
          getComponents: function getComponents(buffer) {
            var bpc = this.bpc;
            if (bpc === 8) {
              return buffer;
            }
            var width = this.width;
            var height = this.height;
            var numComps = this.numComps;
            var length = width * height * numComps;
            var bufferPos = 0;
            var output = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
            var rowComps = width * numComps;
            var max = (1 << bpc) - 1;
            var i = 0,
              ii,
              buf;
            if (bpc === 1) {
              var mask, loop1End, loop2End;
              for (var j = 0; j < height; j++) {
                loop1End = i + (rowComps & ~7);
                loop2End = i + rowComps;
                while (i < loop1End) {
                  buf = buffer[bufferPos++];
                  output[i] = buf >> 7 & 1;
                  output[i + 1] = buf >> 6 & 1;
                  output[i + 2] = buf >> 5 & 1;
                  output[i + 3] = buf >> 4 & 1;
                  output[i + 4] = buf >> 3 & 1;
                  output[i + 5] = buf >> 2 & 1;
                  output[i + 6] = buf >> 1 & 1;
                  output[i + 7] = buf & 1;
                  i += 8;
                }
                if (i < loop2End) {
                  buf = buffer[bufferPos++];
                  mask = 128;
                  while (i < loop2End) {
                    output[i++] = +!!(buf & mask);
                    mask >>= 1;
                  }
                }
              }
            } else {
              var bits = 0;
              buf = 0;
              for (i = 0, ii = length; i < ii; ++i) {
                if (i % rowComps === 0) {
                  buf = 0;
                  bits = 0;
                }
                while (bits < bpc) {
                  buf = buf << 8 | buffer[bufferPos++];
                  bits += 8;
                }
                var remainingBits = bits - bpc;
                var value = buf >> remainingBits;
                output[i] = value < 0 ? 0 : value > max ? max : value;
                buf = buf & (1 << remainingBits) - 1;
                bits = remainingBits;
              }
            }
            return output;
          },
          fillOpacity: function fillOpacity(rgbaBuf, width, height, actualHeight, image) {
            var smask = this.smask;
            var mask = this.mask;
            var alphaBuf, sw, sh, i, ii, j;
            if (smask) {
              sw = smask.width;
              sh = smask.height;
              alphaBuf = new Uint8Array(sw * sh);
              smask.fillGrayBuffer(alphaBuf);
              if (sw !== width || sh !== height) {
                alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
              }
            } else if (mask) {
              if (mask instanceof PDFImage) {
                sw = mask.width;
                sh = mask.height;
                alphaBuf = new Uint8Array(sw * sh);
                mask.numComps = 1;
                mask.fillGrayBuffer(alphaBuf);
                for (i = 0, ii = sw * sh; i < ii; ++i) {
                  alphaBuf[i] = 255 - alphaBuf[i];
                }
                if (sw !== width || sh !== height) {
                  alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
                }
              } else if (Array.isArray(mask)) {
                alphaBuf = new Uint8Array(width * height);
                var numComps = this.numComps;
                for (i = 0, ii = width * height; i < ii; ++i) {
                  var opacity = 0;
                  var imageOffset = i * numComps;
                  for (j = 0; j < numComps; ++j) {
                    var color = image[imageOffset + j];
                    var maskOffset = j * 2;
                    if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
                      opacity = 255;
                      break;
                    }
                  }
                  alphaBuf[i] = opacity;
                }
              } else {
                throw new _util.FormatError("Unknown mask format.");
              }
            }
            if (alphaBuf) {
              for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
                rgbaBuf[j] = alphaBuf[i];
              }
            } else {
              for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
                rgbaBuf[j] = 255;
              }
            }
          },
          undoPreblend: function undoPreblend(buffer, width, height) {
            var matte = this.smask && this.smask.matte;
            if (!matte) {
              return;
            }
            var matteRgb = this.colorSpace.getRgb(matte, 0);
            var matteR = matteRgb[0];
            var matteG = matteRgb[1];
            var matteB = matteRgb[2];
            var length = width * height * 4;
            var r, g, b;
            for (var i = 0; i < length; i += 4) {
              var alpha = buffer[i + 3];
              if (alpha === 0) {
                buffer[i] = 255;
                buffer[i + 1] = 255;
                buffer[i + 2] = 255;
                continue;
              }
              var k = 255 / alpha;
              r = (buffer[i] - matteR) * k + matteR;
              g = (buffer[i + 1] - matteG) * k + matteG;
              b = (buffer[i + 2] - matteB) * k + matteB;
              buffer[i] = r <= 0 ? 0 : r >= 255 ? 255 : r | 0;
              buffer[i + 1] = g <= 0 ? 0 : g >= 255 ? 255 : g | 0;
              buffer[i + 2] = b <= 0 ? 0 : b >= 255 ? 255 : b | 0;
            }
          },
          createImageData: function createImageData() {
            var forceRGBA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var drawWidth = this.drawWidth;
            var drawHeight = this.drawHeight;
            var imgData = {
              width: drawWidth,
              height: drawHeight
            };
            var numComps = this.numComps;
            var originalWidth = this.width;
            var originalHeight = this.height;
            var bpc = this.bpc;
            var rowBytes = originalWidth * numComps * bpc + 7 >> 3;
            var imgArray;
            if (!forceRGBA) {
              var kind;
              if (this.colorSpace.name === "DeviceGray" && bpc === 1) {
                kind = _util.ImageKind.GRAYSCALE_1BPP;
              } else if (this.colorSpace.name === "DeviceRGB" && bpc === 8 && !this.needsDecode) {
                kind = _util.ImageKind.RGB_24BPP;
              }
              if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
                imgData.kind = kind;
                imgArray = this.getImageBytes(originalHeight * rowBytes);
                if (this.image instanceof _stream.DecodeStream) {
                  imgData.data = imgArray;
                } else {
                  var newArray = new Uint8Array(imgArray.length);
                  newArray.set(imgArray);
                  imgData.data = newArray;
                }
                if (this.needsDecode) {
                  (0, _util.assert)(kind === _util.ImageKind.GRAYSCALE_1BPP);
                  var buffer = imgData.data;
                  for (var i = 0, ii = buffer.length; i < ii; i++) {
                    buffer[i] ^= 0xff;
                  }
                }
                return imgData;
              }
              if (this.image instanceof _stream.JpegStream && !this.smask && !this.mask && (this.colorSpace.name === "DeviceGray" || this.colorSpace.name === "DeviceRGB" || this.colorSpace.name === "DeviceCMYK")) {
                imgData.kind = _util.ImageKind.RGB_24BPP;
                imgData.data = this.getImageBytes(originalHeight * rowBytes, drawWidth, drawHeight, true);
                return imgData;
              }
            }
            imgArray = this.getImageBytes(originalHeight * rowBytes);
            var actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
            var comps = this.getComponents(imgArray);
            var alpha01, maybeUndoPreblend;
            if (!forceRGBA && !this.smask && !this.mask) {
              imgData.kind = _util.ImageKind.RGB_24BPP;
              imgData.data = new Uint8Array(drawWidth * drawHeight * 3);
              alpha01 = 0;
              maybeUndoPreblend = false;
            } else {
              imgData.kind = _util.ImageKind.RGBA_32BPP;
              imgData.data = new Uint8Array(drawWidth * drawHeight * 4);
              alpha01 = 1;
              maybeUndoPreblend = true;
              this.fillOpacity(imgData.data, drawWidth, drawHeight, actualHeight, comps);
            }
            if (this.needsDecode) {
              this.decodeBuffer(comps);
            }
            this.colorSpace.fillRgb(imgData.data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
            if (maybeUndoPreblend) {
              this.undoPreblend(imgData.data, drawWidth, actualHeight);
            }
            return imgData;
          },
          fillGrayBuffer: function fillGrayBuffer(buffer) {
            var numComps = this.numComps;
            if (numComps !== 1) {
              throw new _util.FormatError("Reading gray scale from a color image: " + numComps);
            }
            var width = this.width;
            var height = this.height;
            var bpc = this.bpc;
            var rowBytes = width * numComps * bpc + 7 >> 3;
            var imgArray = this.getImageBytes(height * rowBytes);
            var comps = this.getComponents(imgArray);
            var i, length;
            if (bpc === 1) {
              length = width * height;
              if (this.needsDecode) {
                for (i = 0; i < length; ++i) {
                  buffer[i] = comps[i] - 1 & 255;
                }
              } else {
                for (i = 0; i < length; ++i) {
                  buffer[i] = -comps[i] & 255;
                }
              }
              return;
            }
            if (this.needsDecode) {
              this.decodeBuffer(comps);
            }
            length = width * height;
            var scale = 255 / ((1 << bpc) - 1);
            for (i = 0; i < length; ++i) {
              buffer[i] = scale * comps[i] | 0;
            }
          },
          getImageBytes: function getImageBytes(length, drawWidth, drawHeight) {
            var forceRGB = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            this.image.reset();
            this.image.drawWidth = drawWidth || this.width;
            this.image.drawHeight = drawHeight || this.height;
            this.image.forceRGB = !!forceRGB;
            return this.image.getBytes(length);
          }
        };
        return PDFImage;
      }();
      exports.PDFImage = PDFImage;

      /***/ }),
    /* 144 */
    /***/ (function (module, exports, __w_pdfjs_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AnnotationFactory = exports.AnnotationBorderStyle = exports.Annotation = undefined;

      var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

      var _util = __w_pdfjs_require__(0);

      var _obj = __w_pdfjs_require__(73);

      var _primitives = __w_pdfjs_require__(2);

      var _colorspace = __w_pdfjs_require__(26);

      var _evaluator = __w_pdfjs_require__(77);

      var _stream = __w_pdfjs_require__(5);

      function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

      function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      var AnnotationFactory = function () {
        function AnnotationFactory() {
          _classCallCheck(this, AnnotationFactory);
        }

        _createClass(AnnotationFactory, null, [{
          key: "create",
          value: function create(xref, ref, pdfManager, idFactory) {
            var dict = xref.fetchIfRef(ref);
            if (!(0, _primitives.isDict)(dict)) {
              return;
            }
            var id = (0, _primitives.isRef)(ref) ? ref.toString() : "annot_" + idFactory.createObjId();
            var subtype = dict.get("Subtype");
            subtype = (0, _primitives.isName)(subtype) ? subtype.name : null;
            var parameters = {
              xref: xref,
              dict: dict,
              ref: (0, _primitives.isRef)(ref) ? ref : null,
              subtype: subtype,
              id: id,
              pdfManager: pdfManager
            };
            switch (subtype) {
              case "Link":
                return new LinkAnnotation(parameters);
              case "Text":
                return new TextAnnotation(parameters);
              case "Widget":
                var fieldType = _util.Util.getInheritableProperty(dict, "FT");
                fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
                switch (fieldType) {
                  case "Tx":
                    return new TextWidgetAnnotation(parameters);
                  case "Btn":
                    return new ButtonWidgetAnnotation(parameters);
                  case "Ch":
                    return new ChoiceWidgetAnnotation(parameters);
                }
                (0, _util.warn)("Unimplemented widget field type \"" + fieldType + "\", " + "falling back to base field type.");
                return new WidgetAnnotation(parameters);
              case "Popup":
                return new PopupAnnotation(parameters);
              case "Line":
                return new LineAnnotation(parameters);
              case "Square":
                return new SquareAnnotation(parameters);
              case "Circle":
                return new CircleAnnotation(parameters);
              case "PolyLine":
                return new PolylineAnnotation(parameters);
              case "Polygon":
                return new PolygonAnnotation(parameters);
              case "Highlight":
                return new HighlightAnnotation(parameters);
              case "Underline":
                return new UnderlineAnnotation(parameters);
              case "Squiggly":
                return new SquigglyAnnotation(parameters);
              case "StrikeOut":
                return new StrikeOutAnnotation(parameters);
              case "Stamp":
                return new StampAnnotation(parameters);
              case "FileAttachment":
                return new FileAttachmentAnnotation(parameters);
              default:
                if (!subtype) {
                  (0, _util.warn)("Annotation is missing the required /Subtype.");
                } else {
                  (0, _util.warn)("Unimplemented annotation type \"" + subtype + "\", " + "falling back to base annotation.");
                }
                return new Annotation(parameters);
            }
          }
        }]);

        return AnnotationFactory;
      }();

      function getTransformMatrix(rect, bbox, matrix) {
        var bounds = _util.Util.getAxialAlignedBoundingBox(bbox, matrix);
        var minX = bounds[0];
        var minY = bounds[1];
        var maxX = bounds[2];
        var maxY = bounds[3];
        if (minX === maxX || minY === maxY) {
          return [1, 0, 0, 1, rect[0], rect[1]];
        }
        var xRatio = (rect[2] - rect[0]) / (maxX - minX);
        var yRatio = (rect[3] - rect[1]) / (maxY - minY);
        return [xRatio, 0, 0, yRatio, rect[0] - minX * xRatio, rect[1] - minY * yRatio];
      }

      var Annotation = function () {
        function Annotation(params) {
          _classCallCheck(this, Annotation);

          var dict = params.dict;
          this.setFlags(dict.get("F"));
          this.setRectangle(dict.getArray("Rect"));
          this.setColor(dict.getArray("C"));
          this.setBorderStyle(dict);
          this.setAppearance(dict);
          this.data = {
            annotationFlags: this.flags,
            borderStyle: this.borderStyle,
            color: this.color,
            hasAppearance: !!this.appearance,
            id: params.id,
            rect: this.rectangle,
            subtype: params.subtype
          };
        }

        _createClass(Annotation, [{
          key: "_hasFlag",
          value: function _hasFlag(flags, flag) {
            return !!(flags & flag);
          }
        }, {
          key: "_isViewable",
          value: function _isViewable(flags) {
            return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN) && !this._hasFlag(flags, _util.AnnotationFlag.NOVIEW);
          }
        }, {
          key: "_isPrintable",
          value: function _isPrintable(flags) {
            return this._hasFlag(flags, _util.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN);
          }
        }, {
          key: "setFlags",
          value: function setFlags(flags) {
            this.flags = Number.isInteger(flags) && flags > 0 ? flags : 0;
          }
        }, {
          key: "hasFlag",
          value: function hasFlag(flag) {
            return this._hasFlag(this.flags, flag);
          }
        }, {
          key: "setRectangle",
          value: function setRectangle(rectangle) {
            if (Array.isArray(rectangle) && rectangle.length === 4) {
              this.rectangle = _util.Util.normalizeRect(rectangle);
            } else {
              this.rectangle = [0, 0, 0, 0];
            }
          }
        }, {
          key: "setColor",
          value: function setColor(color) {
            var rgbColor = new Uint8Array(3);
            if (!Array.isArray(color)) {
              this.color = rgbColor;
              return;
            }
            switch (color.length) {
              case 0:
                this.color = null;
                break;
              case 1:
                _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
                this.color = rgbColor;
                break;
              case 3:
                _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
                this.color = rgbColor;
                break;
              case 4:
                _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
                this.color = rgbColor;
                break;
              default:
                this.color = rgbColor;
                break;
            }
          }
        }, {
          key: "setBorderStyle",
          value: function setBorderStyle(borderStyle) {
            this.borderStyle = new AnnotationBorderStyle();
            if (!(0, _primitives.isDict)(borderStyle)) {
              return;
            }
            if (borderStyle.has("BS")) {
              var dict = borderStyle.get("BS");
              var dictType = dict.get("Type");
              if (!dictType || (0, _primitives.isName)(dictType, "Border")) {
                this.borderStyle.setWidth(dict.get("W"));
                this.borderStyle.setStyle(dict.get("S"));
                this.borderStyle.setDashArray(dict.getArray("D"));
              }
            } else if (borderStyle.has("Border")) {
              var array = borderStyle.getArray("Border");
              if (Array.isArray(array) && array.length >= 3) {
                this.borderStyle.setHorizontalCornerRadius(array[0]);
                this.borderStyle.setVerticalCornerRadius(array[1]);
                this.borderStyle.setWidth(array[2]);
                if (array.length === 4) {
                  this.borderStyle.setDashArray(array[3]);
                }
              }
            } else {
              this.borderStyle.setWidth(0);
            }
          }
        }, {
          key: "setAppearance",
          value: function setAppearance(dict) {
            this.appearance = null;
            var appearanceStates = dict.get("AP");
            if (!(0, _primitives.isDict)(appearanceStates)) {
              return;
            }
            var normalAppearanceState = appearanceStates.get("N");
            if ((0, _primitives.isStream)(normalAppearanceState)) {
              this.appearance = normalAppearanceState;
              return;
            }
            if (!(0, _primitives.isDict)(normalAppearanceState)) {
              return;
            }
            var as = dict.get("AS");
            if (!(0, _primitives.isName)(as) || !normalAppearanceState.has(as.name)) {
              return;
            }
            this.appearance = normalAppearanceState.get(as.name);
          }
        }, {
          key: "_preparePopup",
          value: function _preparePopup(dict) {
            if (!dict.has("C")) {
              this.data.color = null;
            }
            this.data.hasPopup = dict.has("Popup");
            this.data.title = (0, _util.stringToPDFString)(dict.get("T") || "");
            this.data.contents = (0, _util.stringToPDFString)(dict.get("Contents") || "");
          }
        }, {
          key: "loadResources",
          value: function loadResources(keys) {
            return this.appearance.dict.getAsync("Resources").then(function (resources) {
              if (!resources) {
                return;
              }
              var objectLoader = new _obj.ObjectLoader(resources, keys, resources.xref);
              return objectLoader.load().then(function () {
                return resources;
              });
            });
          }
        }, {
          key: "getOperatorList",
          value: function getOperatorList(evaluator, task, renderForms) {
            var _this = this;

            if (!this.appearance) {
              return Promise.resolve(new _evaluator.OperatorList());
            }
            var data = this.data;
            var appearanceDict = this.appearance.dict;
            var resourcesPromise = this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"]);
            var bbox = appearanceDict.getArray("BBox") || [0, 0, 1, 1];
            var matrix = appearanceDict.getArray("Matrix") || [1, 0, 0, 1, 0, 0];
            var transform = getTransformMatrix(data.rect, bbox, matrix);
            return resourcesPromise.then(function (resources) {
              var opList = new _evaluator.OperatorList();
              opList.addOp(_util.OPS.beginAnnotation, [data.rect, transform, matrix]);
              return evaluator.getOperatorList({
                stream: _this.appearance,
                task: task,
                resources: resources,
                operatorList: opList
              }).then(function () {
                opList.addOp(_util.OPS.endAnnotation, []);
                _this.appearance.reset();
                return opList;
              });
            });
          }
        }, {
          key: "viewable",
          get: function get() {
            if (this.flags === 0) {
              return true;
            }
            return this._isViewable(this.flags);
          }
        }, {
          key: "printable",
          get: function get() {
            if (this.flags === 0) {
              return false;
            }
            return this._isPrintable(this.flags);
          }
        }]);

        return Annotation;
      }();

      var AnnotationBorderStyle = function () {
        function AnnotationBorderStyle() {
          _classCallCheck(this, AnnotationBorderStyle);

          this.width = 1;
          this.style = _util.AnnotationBorderStyleType.SOLID;
          this.dashArray = [3];
          this.horizontalCornerRadius = 0;
          this.verticalCornerRadius = 0;
        }

        _createClass(AnnotationBorderStyle, [{
          key: "setWidth",
          value: function setWidth(width) {
            if (Number.isInteger(width)) {
              this.width = width;
            }
          }
        }, {
          key: "setStyle",
          value: function setStyle(style) {
            if (!style) {
              return;
            }
            switch (style.name) {
              case "S":
                this.style = _util.AnnotationBorderStyleType.SOLID;
                break;
              case "D":
                this.style = _util.AnnotationBorderStyleType.DASHED;
                break;
              case "B":
                this.style = _util.AnnotationBorderStyleType.BEVELED;
                break;
              case "I":
                this.style = _util.AnnotationBorderStyleType.INSET;
                break;
              case "U":
                this.style = _util.AnnotationBorderStyleType.UNDERLINE;
                break;
              default:
                break;
            }
          }
        }, {
          key: "setDashArray",
          value: function setDashArray(dashArray) {
            if (Array.isArray(dashArray) && dashArray.length > 0) {
              var isValid = true;
              var allZeros = true;
              for (var i = 0, len = dashArray.length; i < len; i++) {
                var element = dashArray[i];
                var validNumber = +element >= 0;
                if (!validNumber) {
                  isValid = false;
                  break;
                } else if (element > 0) {
                  allZeros = false;
                }
              }
              if (isValid && !allZeros) {
                this.dashArray = dashArray;
              } else {
                this.width = 0;
              }
            } else if (dashArray) {
              this.width = 0;
            }
          }
        }, {
          key: "setHorizontalCornerRadius",
          value: function setHorizontalCornerRadius(radius) {
            if (Number.isInteger(radius)) {
              this.horizontalCornerRadius = radius;
            }
          }
        }, {
          key: "setVerticalCornerRadius",
          value: function setVerticalCornerRadius(radius) {
            if (Number.isInteger(radius)) {
              this.verticalCornerRadius = radius;
            }
          }
        }]);

        return AnnotationBorderStyle;
      }();

      var WidgetAnnotation = function (_Annotation) {
        _inherits(WidgetAnnotation, _Annotation);

        function WidgetAnnotation(params) {
          _classCallCheck(this, WidgetAnnotation);

          var _this2 = _possibleConstructorReturn(this, (WidgetAnnotation.__proto__ || Object.getPrototypeOf(WidgetAnnotation)).call(this, params));

          var dict = params.dict;
          var data = _this2.data;
          data.annotationType = _util.AnnotationType.WIDGET;
          data.fieldName = _this2._constructFieldName(dict);
          data.fieldValue = _util.Util.getInheritableProperty(dict, "V", true);
          data.alternativeText = (0, _util.stringToPDFString)(dict.get("TU") || "");
          data.defaultAppearance = _util.Util.getInheritableProperty(dict, "DA") || "";
          var fieldType = _util.Util.getInheritableProperty(dict, "FT");
          data.fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
          _this2.fieldResources = _util.Util.getInheritableProperty(dict, "DR") || _primitives.Dict.empty;
          data.fieldFlags = _util.Util.getInheritableProperty(dict, "Ff");
          if (!Number.isInteger(data.fieldFlags) || data.fieldFlags < 0) {
            data.fieldFlags = 0;
          }
          data.readOnly = _this2.hasFieldFlag(_util.AnnotationFieldFlag.READONLY);
          if (data.fieldType === "Sig") {
            _this2.setFlags(_util.AnnotationFlag.HIDDEN);
          }
          return _this2;
        }

        _createClass(WidgetAnnotation, [{
          key: "_constructFieldName",
          value: function _constructFieldName(dict) {
            if (!dict.has("T") && !dict.has("Parent")) {
              (0, _util.warn)("Unknown field name, falling back to empty field name.");
              return "";
            }
            if (!dict.has("Parent")) {
              return (0, _util.stringToPDFString)(dict.get("T"));
            }
            var fieldName = [];
            if (dict.has("T")) {
              fieldName.unshift((0, _util.stringToPDFString)(dict.get("T")));
            }
            var loopDict = dict;
            while (loopDict.has("Parent")) {
              loopDict = loopDict.get("Parent");
              if (!(0, _primitives.isDict)(loopDict)) {
                break;
              }
              if (loopDict.has("T")) {
                fieldName.unshift((0, _util.stringToPDFString)(loopDict.get("T")));
              }
            }
            return fieldName.join(".");
          }
        }, {
          key: "hasFieldFlag",
          value: function hasFieldFlag(flag) {
            return !!(this.data.fieldFlags & flag);
          }
        }, {
          key: "getOperatorList",
          value: function getOperatorList(evaluator, task, renderForms) {
            if (renderForms) {
              return Promise.resolve(new _evaluator.OperatorList());
            }
            return _get(WidgetAnnotation.prototype.__proto__ || Object.getPrototypeOf(WidgetAnnotation.prototype), "getOperatorList", this).call(this, evaluator, task, renderForms);
          }
        }]);

        return WidgetAnnotation;
      }(Annotation);

      var TextWidgetAnnotation = function (_WidgetAnnotation) {
        _inherits(TextWidgetAnnotation, _WidgetAnnotation);

        function TextWidgetAnnotation(params) {
          _classCallCheck(this, TextWidgetAnnotation);

          var _this3 = _possibleConstructorReturn(this, (TextWidgetAnnotation.__proto__ || Object.getPrototypeOf(TextWidgetAnnotation)).call(this, params));

          _this3.data.fieldValue = (0, _util.stringToPDFString)(_this3.data.fieldValue || "");
          var alignment = _util.Util.getInheritableProperty(params.dict, "Q");
          if (!Number.isInteger(alignment) || alignment < 0 || alignment > 2) {
            alignment = null;
          }
          _this3.data.textAlignment = alignment;
          var maximumLength = _util.Util.getInheritableProperty(params.dict, "MaxLen");
          if (!Number.isInteger(maximumLength) || maximumLength < 0) {
            maximumLength = null;
          }
          _this3.data.maxLen = maximumLength;
          _this3.data.multiLine = _this3.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE);
          _this3.data.comb = _this3.hasFieldFlag(_util.AnnotationFieldFlag.COMB) && !_this3.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE) && !_this3.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD) && !_this3.hasFieldFlag(_util.AnnotationFieldFlag.FILESELECT) && _this3.data.maxLen !== null;
          return _this3;
        }

        _createClass(TextWidgetAnnotation, [{
          key: "getOperatorList",
          value: function getOperatorList(evaluator, task, renderForms) {
            if (renderForms || this.appearance) {
              return _get(TextWidgetAnnotation.prototype.__proto__ || Object.getPrototypeOf(TextWidgetAnnotation.prototype), "getOperatorList", this).call(this, evaluator, task, renderForms);
            }
            var operatorList = new _evaluator.OperatorList();
            if (!this.data.defaultAppearance) {
              return Promise.resolve(operatorList);
            }
            var stream = new _stream.Stream((0, _util.stringToBytes)(this.data.defaultAppearance));
            return evaluator.getOperatorList({
              stream: stream,
              task: task,
              resources: this.fieldResources,
              operatorList: operatorList
            }).then(function () {
              return operatorList;
            });
          }
        }]);

        return TextWidgetAnnotation;
      }(WidgetAnnotation);

      var ButtonWidgetAnnotation = function (_WidgetAnnotation2) {
        _inherits(ButtonWidgetAnnotation, _WidgetAnnotation2);

        function ButtonWidgetAnnotation(params) {
          _classCallCheck(this, ButtonWidgetAnnotation);

          var _this4 = _possibleConstructorReturn(this, (ButtonWidgetAnnotation.__proto__ || Object.getPrototypeOf(ButtonWidgetAnnotation)).call(this, params));

          _this4.data.checkBox = !_this4.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !_this4.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
          if (_this4.data.checkBox) {
            if (!(0, _primitives.isName)(_this4.data.fieldValue)) {
              return _possibleConstructorReturn(_this4);
            }
            _this4.data.fieldValue = _this4.data.fieldValue.name;
          }
          _this4.data.radioButton = _this4.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !_this4.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
          if (_this4.data.radioButton) {
            _this4.data.fieldValue = _this4.data.buttonValue = null;
            var fieldParent = params.dict.get("Parent");
            if ((0, _primitives.isDict)(fieldParent) && fieldParent.has("V")) {
              var fieldParentValue = fieldParent.get("V");
              if ((0, _primitives.isName)(fieldParentValue)) {
                _this4.data.fieldValue = fieldParentValue.name;
              }
            }
            var appearanceStates = params.dict.get("AP");
            if (!(0, _primitives.isDict)(appearanceStates)) {
              return _possibleConstructorReturn(_this4);
            }
            var normalAppearanceState = appearanceStates.get("N");
            if (!(0, _primitives.isDict)(normalAppearanceState)) {
              return _possibleConstructorReturn(_this4);
            }
            var keys = normalAppearanceState.getKeys();
            for (var i = 0, ii = keys.length; i < ii; i++) {
              if (keys[i] !== "Off") {
                _this4.data.buttonValue = keys[i];
                break;
              }
            }
          }
          return _this4;
        }

        return ButtonWidgetAnnotation;
      }(WidgetAnnotation);

      var ChoiceWidgetAnnotation = function (_WidgetAnnotation3) {
        _inherits(ChoiceWidgetAnnotation, _WidgetAnnotation3);

        function ChoiceWidgetAnnotation(params) {
          _classCallCheck(this, ChoiceWidgetAnnotation);

          var _this5 = _possibleConstructorReturn(this, (ChoiceWidgetAnnotation.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotation)).call(this, params));

          _this5.data.options = [];
          var options = _util.Util.getInheritableProperty(params.dict, "Opt");
          if (Array.isArray(options)) {
            var xref = params.xref;
            for (var i = 0, ii = options.length; i < ii; i++) {
              var option = xref.fetchIfRef(options[i]);
              var isOptionArray = Array.isArray(option);
              _this5.data.options[i] = {
                exportValue: isOptionArray ? xref.fetchIfRef(option[0]) : option,
                displayValue: isOptionArray ? xref.fetchIfRef(option[1]) : option
              };
            }
          }
          if (!Array.isArray(_this5.data.fieldValue)) {
            _this5.data.fieldValue = [_this5.data.fieldValue];
          }
          _this5.data.combo = _this5.hasFieldFlag(_util.AnnotationFieldFlag.COMBO);
          _this5.data.multiSelect = _this5.hasFieldFlag(_util.AnnotationFieldFlag.MULTISELECT);
          return _this5;
        }

        return ChoiceWidgetAnnotation;
      }(WidgetAnnotation);

      var TextAnnotation = function (_Annotation2) {
        _inherits(TextAnnotation, _Annotation2);

        function TextAnnotation(parameters) {
          _classCallCheck(this, TextAnnotation);

          var DEFAULT_ICON_SIZE = 22;

          var _this6 = _possibleConstructorReturn(this, (TextAnnotation.__proto__ || Object.getPrototypeOf(TextAnnotation)).call(this, parameters));

          _this6.data.annotationType = _util.AnnotationType.TEXT;
          if (_this6.data.hasAppearance) {
            _this6.data.name = "NoIcon";
          } else {
            _this6.data.rect[1] = _this6.data.rect[3] - DEFAULT_ICON_SIZE;
            _this6.data.rect[2] = _this6.data.rect[0] + DEFAULT_ICON_SIZE;
            _this6.data.name = parameters.dict.has("Name") ? parameters.dict.get("Name").name : "Note";
          }
          _this6._preparePopup(parameters.dict);
          return _this6;
        }

        return TextAnnotation;
      }(Annotation);

      var LinkAnnotation = function (_Annotation3) {
        _inherits(LinkAnnotation, _Annotation3);

        function LinkAnnotation(params) {
          _classCallCheck(this, LinkAnnotation);

          var _this7 = _possibleConstructorReturn(this, (LinkAnnotation.__proto__ || Object.getPrototypeOf(LinkAnnotation)).call(this, params));

          _this7.data.annotationType = _util.AnnotationType.LINK;
          _obj.Catalog.parseDestDictionary({
            destDict: params.dict,
            resultObj: _this7.data,
            docBaseUrl: params.pdfManager.docBaseUrl
          });
          return _this7;
        }

        return LinkAnnotation;
      }(Annotation);

      var PopupAnnotation = function (_Annotation4) {
        _inherits(PopupAnnotation, _Annotation4);

        function PopupAnnotation(parameters) {
          _classCallCheck(this, PopupAnnotation);

          var _this8 = _possibleConstructorReturn(this, (PopupAnnotation.__proto__ || Object.getPrototypeOf(PopupAnnotation)).call(this, parameters));

          _this8.data.annotationType = _util.AnnotationType.POPUP;
          var dict = parameters.dict;
          var parentItem = dict.get("Parent");
          if (!parentItem) {
            (0, _util.warn)("Popup annotation has a missing or invalid parent annotation.");
            return _possibleConstructorReturn(_this8);
          }
          var parentSubtype = parentItem.get("Subtype");
          _this8.data.parentType = (0, _primitives.isName)(parentSubtype) ? parentSubtype.name : null;
          _this8.data.parentId = dict.getRaw("Parent").toString();
          _this8.data.title = (0, _util.stringToPDFString)(parentItem.get("T") || "");
          _this8.data.contents = (0, _util.stringToPDFString)(parentItem.get("Contents") || "");
          if (!parentItem.has("C")) {
            _this8.data.color = null;
          } else {
            _this8.setColor(parentItem.getArray("C"));
            _this8.data.color = _this8.color;
          }
          if (!_this8.viewable) {
            var parentFlags = parentItem.get("F");
            if (_this8._isViewable(parentFlags)) {
              _this8.setFlags(parentFlags);
            }
          }
          return _this8;
        }

        return PopupAnnotation;
      }(Annotation);

      var LineAnnotation = function (_Annotation5) {
        _inherits(LineAnnotation, _Annotation5);

        function LineAnnotation(parameters) {
          _classCallCheck(this, LineAnnotation);

          var _this9 = _possibleConstructorReturn(this, (LineAnnotation.__proto__ || Object.getPrototypeOf(LineAnnotation)).call(this, parameters));

          _this9.data.annotationType = _util.AnnotationType.LINE;
          var dict = parameters.dict;
          _this9.data.lineCoordinates = _util.Util.normalizeRect(dict.getArray("L"));
          _this9._preparePopup(dict);
          return _this9;
        }

        return LineAnnotation;
      }(Annotation);

      var SquareAnnotation = function (_Annotation6) {
        _inherits(SquareAnnotation, _Annotation6);

        function SquareAnnotation(parameters) {
          _classCallCheck(this, SquareAnnotation);

          var _this10 = _possibleConstructorReturn(this, (SquareAnnotation.__proto__ || Object.getPrototypeOf(SquareAnnotation)).call(this, parameters));

          _this10.data.annotationType = _util.AnnotationType.SQUARE;
          _this10._preparePopup(parameters.dict);
          return _this10;
        }

        return SquareAnnotation;
      }(Annotation);

      var CircleAnnotation = function (_Annotation7) {
        _inherits(CircleAnnotation, _Annotation7);

        function CircleAnnotation(parameters) {
          _classCallCheck(this, CircleAnnotation);

          var _this11 = _possibleConstructorReturn(this, (CircleAnnotation.__proto__ || Object.getPrototypeOf(CircleAnnotation)).call(this, parameters));

          _this11.data.annotationType = _util.AnnotationType.CIRCLE;
          _this11._preparePopup(parameters.dict);
          return _this11;
        }

        return CircleAnnotation;
      }(Annotation);

      var PolylineAnnotation = function (_Annotation8) {
        _inherits(PolylineAnnotation, _Annotation8);

        function PolylineAnnotation(parameters) {
          _classCallCheck(this, PolylineAnnotation);

          var _this12 = _possibleConstructorReturn(this, (PolylineAnnotation.__proto__ || Object.getPrototypeOf(PolylineAnnotation)).call(this, parameters));

          _this12.data.annotationType = _util.AnnotationType.POLYLINE;
          var dict = parameters.dict;
          var rawVertices = dict.getArray("Vertices");
          _this12.data.vertices = [];
          for (var i = 0, ii = rawVertices.length; i < ii; i += 2) {
            _this12.data.vertices.push({
              x: rawVertices[i],
              y: rawVertices[i + 1]
            });
          }
          _this12._preparePopup(dict);
          return _this12;
        }

        return PolylineAnnotation;
      }(Annotation);

      var PolygonAnnotation = function (_PolylineAnnotation) {
        _inherits(PolygonAnnotation, _PolylineAnnotation);

        function PolygonAnnotation(parameters) {
          _classCallCheck(this, PolygonAnnotation);

          var _this13 = _possibleConstructorReturn(this, (PolygonAnnotation.__proto__ || Object.getPrototypeOf(PolygonAnnotation)).call(this, parameters));

          _this13.data.annotationType = _util.AnnotationType.POLYGON;
          return _this13;
        }

        return PolygonAnnotation;
      }(PolylineAnnotation);

      var HighlightAnnotation = function (_Annotation9) {
        _inherits(HighlightAnnotation, _Annotation9);

        function HighlightAnnotation(parameters) {
          _classCallCheck(this, HighlightAnnotation);

          var _this14 = _possibleConstructorReturn(this, (HighlightAnnotation.__proto__ || Object.getPrototypeOf(HighlightAnnotation)).call(this, parameters));

          _this14.data.annotationType = _util.AnnotationType.HIGHLIGHT;
          _this14._preparePopup(parameters.dict);
          return _this14;
        }

        return HighlightAnnotation;
      }(Annotation);

      var UnderlineAnnotation = function (_Annotation10) {
        _inherits(UnderlineAnnotation, _Annotation10);

        function UnderlineAnnotation(parameters) {
          _classCallCheck(this, UnderlineAnnotation);

          var _this15 = _possibleConstructorReturn(this, (UnderlineAnnotation.__proto__ || Object.getPrototypeOf(UnderlineAnnotation)).call(this, parameters));

          _this15.data.annotationType = _util.AnnotationType.UNDERLINE;
          _this15._preparePopup(parameters.dict);
          return _this15;
        }

        return UnderlineAnnotation;
      }(Annotation);

      var SquigglyAnnotation = function (_Annotation11) {
        _inherits(SquigglyAnnotation, _Annotation11);

        function SquigglyAnnotation(parameters) {
          _classCallCheck(this, SquigglyAnnotation);

          var _this16 = _possibleConstructorReturn(this, (SquigglyAnnotation.__proto__ || Object.getPrototypeOf(SquigglyAnnotation)).call(this, parameters));

          _this16.data.annotationType = _util.AnnotationType.SQUIGGLY;
          _this16._preparePopup(parameters.dict);
          return _this16;
        }

        return SquigglyAnnotation;
      }(Annotation);

      var StrikeOutAnnotation = function (_Annotation12) {
        _inherits(StrikeOutAnnotation, _Annotation12);

        function StrikeOutAnnotation(parameters) {
          _classCallCheck(this, StrikeOutAnnotation);

          var _this17 = _possibleConstructorReturn(this, (StrikeOutAnnotation.__proto__ || Object.getPrototypeOf(StrikeOutAnnotation)).call(this, parameters));

          _this17.data.annotationType = _util.AnnotationType.STRIKEOUT;
          _this17._preparePopup(parameters.dict);
          return _this17;
        }

        return StrikeOutAnnotation;
      }(Annotation);

      var StampAnnotation = function (_Annotation13) {
        _inherits(StampAnnotation, _Annotation13);

        function StampAnnotation(parameters) {
          _classCallCheck(this, StampAnnotation);

          var _this18 = _possibleConstructorReturn(this, (StampAnnotation.__proto__ || Object.getPrototypeOf(StampAnnotation)).call(this, parameters));

          _this18.data.annotationType = _util.AnnotationType.STAMP;
          _this18._preparePopup(parameters.dict);
          return _this18;
        }

        return StampAnnotation;
      }(Annotation);

      var FileAttachmentAnnotation = function (_Annotation14) {
        _inherits(FileAttachmentAnnotation, _Annotation14);

        function FileAttachmentAnnotation(parameters) {
          _classCallCheck(this, FileAttachmentAnnotation);

          var _this19 = _possibleConstructorReturn(this, (FileAttachmentAnnotation.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotation)).call(this, parameters));

          var file = new _obj.FileSpec(parameters.dict.get("FS"), parameters.xref);
          _this19.data.annotationType = _util.AnnotationType.FILEATTACHMENT;
          _this19.data.file = file.serializable;
          _this19._preparePopup(parameters.dict);
          return _this19;
        }

        return FileAttachmentAnnotation;
      }(Annotation);

      exports.Annotation = Annotation;
      exports.AnnotationBorderStyle = AnnotationBorderStyle;
      exports.AnnotationFactory = AnnotationFactory;

      /***/ })
    /** ****/ ]);
});
// # sourceMappingURL=pdf.worker.js.map

/**
 * angular-recaptcha build:2016-07-19
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2016 VividCortex
**/

/* global angular, Recaptcha */
(function (ng) {
  "use strict";

  ng.module("vcRecaptcha", []);

}(angular));

/* global angular */
(function (ng) {
  "use strict";

  function throwNoKeyException() {
    throw new Error("You need to set the \"key\" attribute to your public reCaptcha key. If you don't have a key, please get one from https://www.google.com/recaptcha/admin/create");
  }

  var app = ng.module("vcRecaptcha");

  /**
     * An angular service to wrap the reCaptcha API
     */
  app.provider("vcRecaptchaService", function () {
    var provider = this;
    var config = {};
    provider.onLoadFunctionName = "vcRecaptchaApiLoaded";

    /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param defaults  object which overrides the current defaults object.
         */
    provider.setDefaults = function (defaults) {
      ng.copy(defaults, config);
    };

    /**
         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
         */
    provider.setSiteKey = function (siteKey) {
      config.key = siteKey;
    };

    /**
         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param theme  The reCaptcha theme.
         */
    provider.setTheme = function (theme) {
      config.theme = theme;
    };

    /**
         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param stoken  The reCaptcha stoken.
         */
    provider.setStoken = function (stoken) {
      config.stoken = stoken;
    };

    /**
         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param size  The reCaptcha size.
         */
    provider.setSize = function (size) {
      config.size = size;
    };

    /**
         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param type  The reCaptcha type.
         */
    provider.setType = function (type) {
      config.type = type;
    };

    /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
         */
    provider.setOnLoadFunctionName = function (onLoadFunctionName) {
      provider.onLoadFunctionName = onLoadFunctionName;
    };

    provider.$get = ["$rootScope", "$window", "$q", function ($rootScope, $window, $q) {
      var deferred = $q.defer(), promise = deferred.promise, recaptcha;

      $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];

      var callback = function () {
        recaptcha = $window.grecaptcha;

        deferred.resolve(recaptcha);
      };

      $window.vcRecaptchaApiLoadedCallback.push(callback);

      $window[provider.onLoadFunctionName] = function () {
        $window.vcRecaptchaApiLoadedCallback.forEach(function (callback) {
          callback();
        });
      };

      function getRecaptcha() {
        if (recaptcha) {
          return $q.when(recaptcha);
        }

        return promise;
      }

      function validateRecaptchaInstance() {
        if (!recaptcha) {
          throw new Error("reCaptcha has not been loaded yet.");
        }
      }

      // Check if grecaptcha is not defined already.
      if (ng.isDefined($window.grecaptcha)) {
        callback();
      }

      return {

        /**
                 * Creates a new reCaptcha object
                 *
                 * @param elm  the DOM element where to put the captcha
                 * @param conf the captcha object configuration
                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
                 */
        create: function (elm, conf) {

          conf.sitekey = conf.key || config.key;
          conf.theme = conf.theme || config.theme;
          conf.stoken = conf.stoken || config.stoken;
          conf.size = conf.size || config.size;
          conf.type = conf.type || config.type;

          if (!conf.sitekey || conf.sitekey.length !== 40) {
            throwNoKeyException();
          }
          return getRecaptcha().then(function (recaptcha) {
            return recaptcha.render(elm, conf);
          });
        },

        /**
                 * Reloads the reCaptcha
                 */
        reload: function (widgetId) {
          validateRecaptchaInstance();

          // $log.info('Reloading captcha');
          recaptcha.reset(widgetId);

          // Let everyone know this widget has been reset.
          $rootScope.$broadcast("reCaptchaReset", widgetId);
        },

        /**
                 * Gets the response from the reCaptcha widget.
                 *
                 * @see https://developers.google.com/recaptcha/docs/display#js_api
                 *
                 * @returns {String}
                 */
        getResponse: function (widgetId) {
          validateRecaptchaInstance();

          return recaptcha.getResponse(widgetId);
        }
      };

    }];
  });

}(angular));

/* global angular, Recaptcha */
(function (ng) {
  "use strict";

  var app = ng.module("vcRecaptcha");

  app.directive("vcRecaptcha", ["$document", "$timeout", "vcRecaptchaService", function ($document, $timeout, vcRecaptcha) {

    return {
      restrict: "A",
      require: "?^^form",
      scope: {
        response: "=?ngModel",
        key: "=?",
        stoken: "=?",
        theme: "=?",
        size: "=?",
        type: "=?",
        tabindex: "=?",
        required: "=?",
        onCreate: "&",
        onSuccess: "&",
        onExpire: "&"
      },
      link: function (scope, elm, attrs, ctrl) {
        scope.widgetId = null;

        if (ctrl && ng.isDefined(attrs.required)) {
          scope.$watch("required", validate);
        }

        var removeCreationListener = scope.$watch("key", function (key) {
          var callback = function (gRecaptchaResponse) {
            // Safe $apply
            $timeout(function () {
              scope.response = gRecaptchaResponse;
              validate();

              // Notify about the response availability
              scope.onSuccess({ response: gRecaptchaResponse, widgetId: scope.widgetId });
            });
          };

          vcRecaptcha.create(elm[0], {

            callback: callback,
            key: key,
            stoken: scope.stoken || attrs.stoken || null,
            theme: scope.theme || attrs.theme || null,
            type: scope.type || attrs.type || null,
            tabindex: scope.tabindex || attrs.tabindex || null,
            size: scope.size || attrs.size || null,
            "expired-callback": expired

          }).then(function (widgetId) {
            // The widget has been created
            validate();
            scope.widgetId = widgetId;
            scope.onCreate({ widgetId: widgetId });

            scope.$on("$destroy", destroy);

            scope.$on("reCaptchaReset", function (event, resetWidgetId) {
              if (ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId) {
                scope.response = "";
                validate();
              }
            });

          });

          // Remove this listener to avoid creating the widget more than once.
          removeCreationListener();
        });

        function destroy() {
          if (ctrl) {
            // reset the validity of the form if we were removed
            ctrl.$setValidity("recaptcha", null);
          }

          cleanup();
        }

        function expired() {
          // Safe $apply
          $timeout(function () {
            scope.response = "";
            validate();

            // Notify about the response availability
            scope.onExpire({ widgetId: scope.widgetId });
          });
        }

        function validate() {
          if (ctrl) {
            ctrl.$setValidity("recaptcha", scope.required === false ? null : Boolean(scope.response));
          }
        }

        function cleanup() {
          // removes elements reCaptcha added.
          ng.element($document[0].querySelectorAll(".pls-container")).parent().remove();
        }
      }
    };
  }]);

}(angular));

// ! moment.js
// ! version : 2.14.2
// ! authors : Tim Wood, Iskren Chernev, Moment.js contributors
// ! license : MIT
// ! momentjs.com

(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() :
    typeof define === "function" && define.amd ? define(factory) :
      global.moment = factory();
}(this, function () { "use strict";

  var hookCallback;

  function utils_hooks__hooks() {
    return hookCallback.apply(null, arguments);
  }

  // This is done to register the method called with moment()
  // without creating circular dependencies.
  function setHookCallback(callback) {
    hookCallback = callback;
  }

  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
  }

  function isObject(input) {
    return Object.prototype.toString.call(input) === "[object Object]";
  }

  function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
      // even if its not own property I'd still call it non-empty
      return false;
    }
    return true;
  }

  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
  }

  function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
      res.push(fn(arr[i], i));
    }
    return res;
  }

  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }

    if (hasOwnProp(b, "toString")) {
      a.toString = b.toString;
    }

    if (hasOwnProp(b, "valueOf")) {
      a.valueOf = b.valueOf;
    }

    return a;
  }

  function create_utc__createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }

  function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      meridiem: null
    };
  }

  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }
    return m._pf;
  }

  var some;
  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function (fun) {
      var t = Object(this);
      var len = t.length >>> 0;

      for (var i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }

      return false;
    };
  }

  function valid__isValid(m) {
    if (m._isValid == null) {
      var flags = getParsingFlags(m);
      var parsedParts = some.call(flags.parsedDateParts, function (i) {
        return i != null;
      });
      m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

      if (m._strict) {
        m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
      }
    }
    return m._isValid;
  }

  function valid__createInvalid(flags) {
    var m = create_utc__createUTC(NaN);
    if (flags != null) {
      extend(getParsingFlags(m), flags);
    }
    else {
      getParsingFlags(m).userInvalidated = true;
    }

    return m;
  }

  function isUndefined(input) {
    return input === void 0;
  }

  // Plugins that add properties should also add the key here (null value),
  // so we can properly clone ourselves.
  var momentProperties = utils_hooks__hooks.momentProperties = [];

  function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
      to._i = from._i;
    }
    if (!isUndefined(from._f)) {
      to._f = from._f;
    }
    if (!isUndefined(from._l)) {
      to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
      for (i in momentProperties) {
        prop = momentProperties[i];
        val = from[prop];
        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }

    return to;
  }

  var updateInProgress = false;

  // Moment prototype object
  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
      updateInProgress = true;
      utils_hooks__hooks.updateOffset(this);
      updateInProgress = false;
    }
  }

  function isMoment(obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
  }

  function absFloor(number) {
    if (number < 0) {
      // -0 -> 0
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }

  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
      value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }

    return value;
  }

  // compare two arrays, return the number of differences
  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
      lengthDiff = Math.abs(array1.length - array2.length),
      diffs = 0,
      i;
    for (i = 0; i < len; i++) {
      if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
        diffs++;
      }
    }
    return diffs + lengthDiff;
  }

  function warn(msg) {
    if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
                (typeof console !== "undefined") && console.warn) {
      console.warn("Deprecation warning: " + msg);
    }
  }

  function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
      if (utils_hooks__hooks.deprecationHandler != null) {
        utils_hooks__hooks.deprecationHandler(null, msg);
      }
      if (firstTime) {
        warn(msg + "\nArguments: " + Array.prototype.slice.call(arguments).join(", ") + "\n" + (new Error()).stack);
        firstTime = false;
      }
      return fn.apply(this, arguments);
    }, fn);
  }

  var deprecations = {};

  function deprecateSimple(name, msg) {
    if (utils_hooks__hooks.deprecationHandler != null) {
      utils_hooks__hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }

  utils_hooks__hooks.suppressDeprecationWarnings = false;
  utils_hooks__hooks.deprecationHandler = null;

  function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
  }

  function locale_set__set(config) {
    var prop, i;
    for (i in config) {
      prop = config[i];
      if (isFunction(prop)) {
        this[i] = prop;
      } else {
        this["_" + i] = prop;
      }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _ordinalParseLenient.
    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + "|" + (/\d{1,2}/).source);
  }

  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }
    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
        // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
      }
    }
    return res;
  }

  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }

  var keys;

  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function (obj) {
      var i, res = [];
      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }
      return res;
    };
  }

  var defaultCalendar = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: "dddd [at] LT",
    lastDay: "[Yesterday at] LT",
    lastWeek: "[Last] dddd [at] LT",
    sameElse: "L"
  };

  function locale_calendar__calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar["sameElse"];
    return isFunction(output) ? output.call(mom, now) : output;
  }

  var defaultLongDateFormat = {
    LTS: "h:mm:ss A",
    LT: "h:mm A",
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A"
  };

  function longDateFormat(key) {
    var format = this._longDateFormat[key],
      formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
      return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
      return val.slice(1);
    });

    return this._longDateFormat[key];
  }

  var defaultInvalidDate = "Invalid date";

  function invalidDate() {
    return this._invalidDate;
  }

  var defaultOrdinal = "%d";
  var defaultOrdinalParse = /\d{1,2}/;

  function ordinal(number) {
    return this._ordinal.replace("%d", number);
  }

  var defaultRelativeTime = {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  };

  function relative__relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
      output(number, withoutSuffix, string, isFuture) :
      output.replace(/%d/i, number);
  }

  function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? "future" : "past"];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }

  var aliases = {};

  function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
  }

  function normalizeUnits(units) {
    return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }

  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
      normalizedProp,
      prop;

    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);
        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }

    return normalizedInput;
  }

  var priorities = {};

  function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
  }

  function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
      units.push({ unit: u, priority: priorities[u] });
    }
    units.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return units;
  }

  function makeGetSet(unit, keepTime) {
    return function (value) {
      if (value != null) {
        get_set__set(this, unit, value);
        utils_hooks__hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get_set__get(this, unit);
      }
    };
  }

  function get_set__get(mom, unit) {
    return mom.isValid() ?
      mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
  }

  function get_set__set(mom, unit, value) {
    if (mom.isValid()) {
      mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
    }
  }

  // MOMENTS

  function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units]();
    }
    return this;
  }

  function stringSet(units, value) {
    if (typeof units === "object") {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units);
      for (var i = 0; i < prioritized.length; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units](value);
      }
    }
    return this;
  }

  function zeroFill(number, targetLength, forceSign) {
    var absNumber = "" + Math.abs(number),
      zerosToFill = targetLength - absNumber.length,
      sign = number >= 0;
    return (sign ? (forceSign ? "+" : "") : "-") +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }

  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

  var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

  var formatFunctions = {};

  var formatTokenFunctions = {};

  // token:    'M'
  // padded:   ['MM', 2]
  // ordinal:  'Mo'
  // callback: function () { this.month() + 1 }
  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === "string") {
      func = function () {
        return this[callback]();
      };
    }
    if (token) {
      formatTokenFunctions[token] = func;
    }
    if (padded) {
      formatTokenFunctions[padded[0]] = function () {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }
    if (ordinal) {
      formatTokenFunctions[ordinal] = function () {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }

  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, "");
    }
    return input.replace(/\\/g, "");
  }

  function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }

    return function (mom) {
      var output = "", i;
      for (i = 0; i < length; i++) {
        output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
      }
      return output;
    };
  }

  // format date using native date object
  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
  }

  function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }

    return format;
  }

  var match1 = /\d/; //       0 - 9
  var match2 = /\d\d/; //      00 - 99
  var match3 = /\d{3}/; //     000 - 999
  var match4 = /\d{4}/; //    0000 - 9999
  var match6 = /[+-]?\d{6}/; // -999999 - 999999
  var match1to2 = /\d\d?/; //       0 - 99
  var match3to4 = /\d\d\d\d?/; //     999 - 9999
  var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
  var match1to3 = /\d{1,3}/; //       0 - 999
  var match1to4 = /\d{1,4}/; //       0 - 9999
  var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

  var matchUnsigned = /\d+/; //       0 - inf
  var matchSigned = /[+-]?\d+/; //    -inf - inf

  var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
  var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

  var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

  // any word (or two) characters or numbers including two/three word month in arabic.
  // includes scottish gaelic two word and hyphenated months
  var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

  var regexes = {};

  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
      return (isStrict && strictRegex) ? strictRegex : regex;
    };
  }

  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
  }

  // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
  function unescapeFormat(s) {
    return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }

  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }

  var tokens = {};

  function addParseToken(token, callback) {
    var i, func = callback;
    if (typeof token === "string") {
      token = [token];
    }
    if (typeof callback === "number") {
      func = function (input, array) {
        array[callback] = toInt(input);
      };
    }
    for (i = 0; i < token.length; i++) {
      tokens[token[i]] = func;
    }
  }

  function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }

  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }

  var YEAR = 0;
  var MONTH = 1;
  var DATE = 2;
  var HOUR = 3;
  var MINUTE = 4;
  var SECOND = 5;
  var MILLISECOND = 6;
  var WEEK = 7;
  var WEEKDAY = 8;

  var indexOf;

  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function (o) {
      // I know
      var i;
      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }
      return -1;
    };
  }

  function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  }

  // FORMATTING

  addFormatToken("M", ["MM", 2], "Mo", function () {
    return this.month() + 1;
  });

  addFormatToken("MMM", 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
  });

  addFormatToken("MMMM", 0, 0, function (format) {
    return this.localeData().months(this, format);
  });

  // ALIASES

  addUnitAlias("month", "M");

  // PRIORITY

  addUnitPriority("month", 8);

  // PARSING

  addRegexToken("M", match1to2);
  addRegexToken("MM", match1to2, match2);
  addRegexToken("MMM", function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken("MMMM", function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });

  addParseToken(["M", "MM"], function (input, array) {
    array[MONTH] = toInt(input) - 1;
  });

  addParseToken(["MMM", "MMMM"], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  });

  // LOCALES

  var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
  var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_");
  function localeMonths(m, format) {
    return isArray(this._months) ? this._months[m.month()] :
      this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
  }

  var defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
  function localeMonthsShort(m, format) {
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
      this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
  }

  function units_month__handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
      // this is not used
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
      for (i = 0; i < 12; ++i) {
        mom = create_utc__createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === "MMM") {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === "MMM") {
        ii = indexOf.call(this._shortMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
      return units_month__handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = create_utc__createUTC([2000, i]);
      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
        this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
      }
      if (!strict && !this._monthsParse[i]) {
        regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
        this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
      }
      // test the regex
      if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  }

  // MOMENTS

  function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
      // No op
      return mom;
    }

    if (typeof value === "string") {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value);
        // TODO: Another silent failure?
        if (typeof value !== "number") {
          return mom;
        }
      }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
    return mom;
  }

  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      utils_hooks__hooks.updateOffset(this, true);
      return this;
    } else {
      return get_set__get(this, "Month");
    }
  }

  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }

  var defaultMonthsShortRegex = matchWord;
  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, "_monthsRegex")) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, "_monthsShortRegex")) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }
      return this._monthsShortStrictRegex && isStrict ?
        this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }

  var defaultMonthsRegex = matchWord;
  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, "_monthsRegex")) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, "_monthsRegex")) {
        this._monthsRegex = defaultMonthsRegex;
      }
      return this._monthsStrictRegex && isStrict ?
        this._monthsStrictRegex : this._monthsRegex;
    }
  }

  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
      i, mom;
    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = create_utc__createUTC([2000, i]);
      shortPieces.push(this.monthsShort(mom, ""));
      longPieces.push(this.months(mom, ""));
      mixedPieces.push(this.months(mom, ""));
      mixedPieces.push(this.monthsShort(mom, ""));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
    this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
  }

  // FORMATTING

  addFormatToken("Y", 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? "" + y : "+" + y;
  });

  addFormatToken(0, ["YY", 2], 0, function () {
    return this.year() % 100;
  });

  addFormatToken(0, ["YYYY", 4], 0, "year");
  addFormatToken(0, ["YYYYY", 5], 0, "year");
  addFormatToken(0, ["YYYYYY", 6, true], 0, "year");

  // ALIASES

  addUnitAlias("year", "y");

  // PRIORITIES

  addUnitPriority("year", 1);

  // PARSING

  addRegexToken("Y", matchSigned);
  addRegexToken("YY", match1to2, match2);
  addRegexToken("YYYY", match1to4, match4);
  addRegexToken("YYYYY", match1to6, match6);
  addRegexToken("YYYYYY", match1to6, match6);

  addParseToken(["YYYYY", "YYYYYY"], YEAR);
  addParseToken("YYYY", function (input, array) {
    array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken("YY", function (input, array) {
    array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
  });
  addParseToken("Y", function (input, array) {
    array[YEAR] = parseInt(input, 10);
  });

  // HELPERS

  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  }

  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  // HOOKS

  utils_hooks__hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  };

  // MOMENTS

  var getSetYear = makeGetSet("FullYear", true);

  function getIsLeapYear() {
    return isLeapYear(this.year());
  }

  function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
    return date;
  }

  function createUTCDate(y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
    return date;
  }

  // start-of-first-week - start-of-year
  function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
      // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
  }

  // http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
      weekOffset = firstWeekOffset(year, dow, doy),
      dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
      resYear, resDayOfYear;

    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }

    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }

  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
      week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
      resWeek, resYear;

    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }

    return {
      week: resWeek,
      year: resYear
    };
  }

  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
      weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  }

  // FORMATTING

  addFormatToken("w", ["ww", 2], "wo", "week");
  addFormatToken("W", ["WW", 2], "Wo", "isoWeek");

  // ALIASES

  addUnitAlias("week", "w");
  addUnitAlias("isoWeek", "W");

  // PRIORITIES

  addUnitPriority("week", 5);
  addUnitPriority("isoWeek", 5);

  // PARSING

  addRegexToken("w", match1to2);
  addRegexToken("ww", match1to2, match2);
  addRegexToken("W", match1to2);
  addRegexToken("WW", match1to2, match2);

  addWeekParseToken(["w", "ww", "W", "WW"], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  });

  // HELPERS

  // LOCALES

  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }

  var defaultLocaleWeek = {
    dow: 0, // Sunday is the first day of the week.
    doy: 6 // The week that contains Jan 1st is the first week of the year.
  };

  function localeFirstDayOfWeek() {
    return this._week.dow;
  }

  function localeFirstDayOfYear() {
    return this._week.doy;
  }

  // MOMENTS

  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, "d");
  }

  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, "d");
  }

  // FORMATTING

  addFormatToken("d", 0, "do", "day");

  addFormatToken("dd", 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
  });

  addFormatToken("ddd", 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
  });

  addFormatToken("dddd", 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
  });

  addFormatToken("e", 0, 0, "weekday");
  addFormatToken("E", 0, 0, "isoWeekday");

  // ALIASES

  addUnitAlias("day", "d");
  addUnitAlias("weekday", "e");
  addUnitAlias("isoWeekday", "E");

  // PRIORITY
  addUnitPriority("day", 11);
  addUnitPriority("weekday", 11);
  addUnitPriority("isoWeekday", 11);

  // PARSING

  addRegexToken("d", match1to2);
  addRegexToken("e", match1to2);
  addRegexToken("E", match1to2);
  addRegexToken("dd", function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken("ddd", function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken("dddd", function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });

  addWeekParseToken(["dd", "ddd", "dddd"], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });

  addWeekParseToken(["d", "e", "E"], function (input, week, config, token) {
    week[token] = toInt(input);
  });

  // HELPERS

  function parseWeekday(input, locale) {
    if (typeof input !== "string") {
      return input;
    }

    if (!isNaN(input)) {
      return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === "number") {
      return input;
    }

    return null;
  }

  function parseIsoWeekday(input, locale) {
    if (typeof input === "string") {
      return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
  }

  // LOCALES

  var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");
  function localeWeekdays(m, format) {
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
      this._weekdays[this._weekdays.isFormat.test(format) ? "format" : "standalone"][m.day()];
  }

  var defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
  function localeWeekdaysShort(m) {
    return this._weekdaysShort[m.day()];
  }

  var defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
  function localeWeekdaysMin(m) {
    return this._weekdaysMin[m.day()];
  }

  function day_of_week__handleStrictParse(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];

      for (i = 0; i < 7; ++i) {
        mom = create_utc__createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
      }
    }

    if (strict) {
      if (format === "dddd") {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === "ddd") {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === "dddd") {
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === "ddd") {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }

  function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
      return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already

      mom = create_utc__createUTC([2000, 1]).day(i);
      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\.?") + "$", "i");
        this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\.?") + "$", "i");
        this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\.?") + "$", "i");
      }
      if (!this._weekdaysParse[i]) {
        regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
        this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
      }
      // test the regex
      if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  }

  // MOMENTS

  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, "d");
    } else {
      return day;
    }
  }

  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, "d");
  }

  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }

  var defaultWeekdaysRegex = matchWord;
  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }
      return this._weekdaysStrictRegex && isStrict ?
        this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }

  var defaultWeekdaysShortRegex = matchWord;
  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, "_weekdaysShortRegex")) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }
      return this._weekdaysShortStrictRegex && isStrict ?
        this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }

  var defaultWeekdaysMinRegex = matchWord;
  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, "_weekdaysMinRegex")) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }
      return this._weekdaysMinStrictRegex && isStrict ?
        this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }

  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
      i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = create_utc__createUTC([2000, 1]).day(i);
      minp = this.weekdaysMin(mom, "");
      shortp = this.weekdaysShort(mom, "");
      longp = this.weekdays(mom, "");
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
      shortPieces[i] = regexEscape(shortPieces[i]);
      longPieces[i] = regexEscape(longPieces[i]);
      mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
    this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
  }

  // FORMATTING

  function hFormat() {
    return this.hours() % 12 || 12;
  }

  function kFormat() {
    return this.hours() || 24;
  }

  addFormatToken("H", ["HH", 2], 0, "hour");
  addFormatToken("h", ["hh", 2], 0, hFormat);
  addFormatToken("k", ["kk", 2], 0, kFormat);

  addFormatToken("hmm", 0, 0, function () {
    return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });

  addFormatToken("hmmss", 0, 0, function () {
    return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
  });

  addFormatToken("Hmm", 0, 0, function () {
    return "" + this.hours() + zeroFill(this.minutes(), 2);
  });

  addFormatToken("Hmmss", 0, 0, function () {
    return "" + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
  });

  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }

  meridiem("a", true);
  meridiem("A", false);

  // ALIASES

  addUnitAlias("hour", "h");

  // PRIORITY
  addUnitPriority("hour", 13);

  // PARSING

  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }

  addRegexToken("a", matchMeridiem);
  addRegexToken("A", matchMeridiem);
  addRegexToken("H", match1to2);
  addRegexToken("h", match1to2);
  addRegexToken("HH", match1to2, match2);
  addRegexToken("hh", match1to2, match2);

  addRegexToken("hmm", match3to4);
  addRegexToken("hmmss", match5to6);
  addRegexToken("Hmm", match3to4);
  addRegexToken("Hmmss", match5to6);

  addParseToken(["H", "HH"], HOUR);
  addParseToken(["a", "A"], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(["h", "hh"], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken("hmm", function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken("hmmss", function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken("Hmm", function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken("Hmmss", function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  });

  // LOCALES

  function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + "").toLowerCase().charAt(0) === "p");
  }

  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? "pm" : "PM";
    } else {
      return isLower ? "am" : "AM";
    }
  }

  // MOMENTS

  // Setting the hour should keep the time, because the user explicitly
  // specified which hour he wants. So trying to maintain the same hour (in
  // a new timezone) makes sense. Adding/subtracting hours does not follow
  // this rule.
  var getSetHour = makeGetSet("Hours", true);

  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    ordinalParse: defaultOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
  };

  // internal storage for locale config files
  var locales = {};
  var globalLocale;

  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace("_", "-") : key;
  }

  // pick the locale from the array
  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
  function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
      split = normalizeLocale(names[i]).split("-");
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split("-") : null;
      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join("-"));
        if (locale) {
          return locale;
        }
        if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
          // the next array item is better than a shallower substring of this one
          break;
        }
        j--;
      }
      i++;
    }
    return null;
  }

  function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== "undefined") &&
                module && module.exports) {
      try {
        oldLocale = globalLocale._abbr;
        require("./locale/" + name);
        // because defineLocale currently also sets the global locale, we
        // want to undo that for lazy loaded locales
        locale_locales__getSetGlobalLocale(oldLocale);
      } catch (e) { }
    }
    return locales[name];
  }

  // This function will load locale and then set the global locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.
  function locale_locales__getSetGlobalLocale(key, values) {
    var data;
    if (key) {
      if (isUndefined(values)) {
        data = locale_locales__getLocale(key);
      }
      else {
        data = defineLocale(key, values);
      }

      if (data) {
        // moment.duration._locale = moment._locale = data;
        globalLocale = data;
      }
    }

    return globalLocale._abbr;
  }

  function defineLocale(name, config) {
    if (config !== null) {
      var parentConfig = baseConfig;
      config.abbr = name;
      if (locales[name] != null) {
        deprecateSimple("defineLocaleOverride",
          "use moment.updateLocale(localeName, config) to change " +
                        "an existing locale. moment.defineLocale(localeName, " +
                        "config) should only be used for creating a new locale " +
                        "See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          // treat as if there is no base config
          deprecateSimple("parentLocaleUndefined",
            "specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/");
        }
      }
      locales[name] = new Locale(mergeConfigs(parentConfig, config));

      // backwards compat for now: also set the locale
      locale_locales__getSetGlobalLocale(name);

      return locales[name];
    } else {
      // useful for testing
      delete locales[name];
      return null;
    }
  }

  function updateLocale(name, config) {
    if (config != null) {
      var locale, parentConfig = baseConfig;
      // MERGE
      if (locales[name] != null) {
        parentConfig = locales[name]._config;
      }
      config = mergeConfigs(parentConfig, config);
      locale = new Locale(config);
      locale.parentLocale = locales[name];
      locales[name] = locale;

      // backwards compat for now: also set the locale
      locale_locales__getSetGlobalLocale(name);
    } else {
      // pass null for config to unupdate, useful for tests
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }
    return locales[name];
  }

  // returns locale data
  function locale_locales__getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }

    if (!key) {
      return globalLocale;
    }

    if (!isArray(key)) {
      // short-circuit everything else
      locale = loadLocale(key);
      if (locale) {
        return locale;
      }
      key = [key];
    }

    return chooseLocale(key);
  }

  function locale_locales__listLocales() {
    return keys(locales);
  }

  function checkOverflow(m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
      overflow =
                a[MONTH] < 0 || a[MONTH] > 11 ? MONTH :
                  a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                    a[HOUR] < 0 || a[HOUR] > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                      a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE :
                        a[SECOND] < 0 || a[SECOND] > 59 ? SECOND :
                          a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                            -1;

      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }
      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }
      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }

      getParsingFlags(m).overflow = overflow;
    }

    return m;
  }

  // iso 8601 regex
  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
  var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

  var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

  var isoDates = [
    ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
    ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
    ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
    ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
    ["YYYY-DDD", /\d{4}-\d{3}/],
    ["YYYY-MM", /\d{4}-\d\d/, false],
    ["YYYYYYMMDD", /[+-]\d{10}/],
    ["YYYYMMDD", /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ["GGGG[W]WWE", /\d{4}W\d{3}/],
    ["GGGG[W]WW", /\d{4}W\d{2}/, false],
    ["YYYYDDD", /\d{7}/]
  ];

  // iso time formats and regexes
  var isoTimes = [
    ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
    ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
    ["HH:mm:ss", /\d\d:\d\d:\d\d/],
    ["HH:mm", /\d\d:\d\d/],
    ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
    ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
    ["HHmmss", /\d\d\d\d\d\d/],
    ["HHmm", /\d\d\d\d/],
    ["HH", /\d\d/]
  ];

  var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

  // date from iso format
  function configFromISO(config) {
    var i, l,
      string = config._i,
      match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
      allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
      getParsingFlags(config).iso = true;

      for (i = 0, l = isoDates.length; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }
      if (dateFormat == null) {
        config._isValid = false;
        return;
      }
      if (match[3]) {
        for (i = 0, l = isoTimes.length; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            // match[2] should be 'T' or space
            timeFormat = (match[2] || " ") + isoTimes[i][0];
            break;
          }
        }
        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }
      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }
      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = "Z";
        } else {
          config._isValid = false;
          return;
        }
      }
      config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }

  // date from iso format or fallback
  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }

    configFromISO(config);
    if (config._isValid === false) {
      delete config._isValid;
      utils_hooks__hooks.createFromInputFallback(config);
    }
  }

  utils_hooks__hooks.createFromInputFallback = deprecate(
    "moment construction falls back to js Date. This is " +
        "discouraged and will be removed in upcoming major " +
        "release. Please refer to " +
        "http://momentjs.com/guides/#/warnings/js-date/ for more info.",
    function (config) {
      config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    }
  );

  // Pick the first defined of two or three arguments.
  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }
    if (b != null) {
      return b;
    }
    return c;
  }

  function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(utils_hooks__hooks.now());
    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  }

  // convert an array to a date.
  // the array should mirror the parameters below
  // note: all values past the year are optional and will default to the lowest possible value.
  // [year, month, day , hour, minute, second, millisecond]
  function configFromArray(config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
      return;
    }

    currentDate = currentDateArray(config);

    // compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    }

    // if the day of the year is set, figure out what it is
    if (config._dayOfYear) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

      if (config._dayOfYear > daysInYear(yearToUse)) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }

      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
      config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
      config._a[HOUR] = 24;
    }
  }

  function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4;

      // TODO: We need to take the current isoWeekYear, but that depends on
      // how we interpret now (local, utc, fixed offset). So create
      // a now version of current config (take local/utc/offset flags, and
      // create now).
      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);
      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;

      weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
      week = defaults(w.w, 1);

      if (w.d != null) {
        // weekday -- low day numbers are considered next week
        weekday = w.d;
        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        // local weekday -- counting starts from begining of week
        weekday = w.e + dow;
        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        // default to begining of week
        weekday = dow;
      }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  }

  // constant that refers to the ISO standard
  utils_hooks__hooks.ISO_8601 = function () {};

  // date from string and format string
  function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === utils_hooks__hooks.ISO_8601) {
      configFromISO(config);
      return;
    }

    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = "" + config._i,
      i, parsedInput, tokens, token, skipped,
      stringLength = string.length,
      totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
      // console.log('token', token, 'parsedInput', parsedInput,
      //         'regex', getParseRegexForToken(token, config));
      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));
        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }
        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      }
      // don't parse if it's not a known token
      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        }
        else {
          getParsingFlags(config).unusedTokens.push(token);
        }
        addTimeToArrayFromToken(token, parsedInput, config);
      }
      else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
  }

  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
      // nothing to do
      return hour;
    }
    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      // Fallback
      isPm = locale.isPM(meridiem);
      if (isPm && hour < 12) {
        hour += 12;
      }
      if (!isPm && hour === 12) {
        hour = 0;
      }
      return hour;
    } else {
      // this is not supposed to happen
      return hour;
    }
  }

  // date from string and array of format strings
  function configFromStringAndArray(config) {
    var tempConfig,
      bestMoment,

      scoreToBeat,
      i,
      currentScore;

    if (config._f.length === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }

    for (i = 0; i < config._f.length; i++) {
      currentScore = 0;
      tempConfig = copyConfig({}, config);
      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }
      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);

      if (!valid__isValid(tempConfig)) {
        continue;
      }

      // if there is any input that was not parsed add a penalty for that format
      currentScore += getParsingFlags(tempConfig).charsLeftOver;

      // or tokens
      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

      getParsingFlags(tempConfig).score = currentScore;

      if (scoreToBeat == null || currentScore < scoreToBeat) {
        scoreToBeat = currentScore;
        bestMoment = tempConfig;
      }
    }

    extend(config, bestMoment || tempConfig);
  }

  function configFromObject(config) {
    if (config._d) {
      return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
      return obj && parseInt(obj, 10);
    });

    configFromArray(config);
  }

  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
      // Adding is smart enough around DST
      res.add(1, "d");
      res._nextDay = undefined;
    }

    return res;
  }

  function prepareConfig(config) {
    var input = config._i,
      format = config._f;

    config._locale = config._locale || locale_locales__getLocale(config._l);

    if (input === null || (format === undefined && input === "")) {
      return valid__createInvalid({ nullInput: true });
    }

    if (typeof input === "string") {
      config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (isDate(input)) {
      config._d = input;
    } else if (format) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }

    if (!valid__isValid(config)) {
      config._d = null;
    }

    return config;
  }

  function configFromInput(config) {
    var input = config._i;
    if (input === undefined) {
      config._d = new Date(utils_hooks__hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === "string") {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function (obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (typeof(input) === "object") {
      configFromObject(config);
    } else if (typeof(input) === "number") {
      // from milliseconds
      config._d = new Date(input);
    } else {
      utils_hooks__hooks.createFromInputFallback(config);
    }
  }

  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (typeof(locale) === "boolean") {
      strict = locale;
      locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
      input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
  }

  function local__createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }

  var prototypeMin = deprecate(
    "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
    function () {
      var other = local__createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return valid__createInvalid();
      }
    }
  );

  var prototypeMax = deprecate(
    "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
    function () {
      var other = local__createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return valid__createInvalid();
      }
    }
  );

  // Pick a moment m from moments so that m[fn](other) is true for all
  // other. This relies on the function fn to be transitive.
  //
  // moments should either be an array of moment objects or an array, whose
  // first element is an array of moment objects.
  function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }
    if (!moments.length) {
      return local__createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }
    return res;
  }

  // TODO: Use [].sort instead?
  function min() {
    var args = [].slice.call(arguments, 0);

    return pickBy("isBefore", args);
  }

  function max() {
    var args = [].slice.call(arguments, 0);

    return pickBy("isAfter", args);
  }

  var now = function () {
    return Date.now ? Date.now() : +(new Date());
  };

  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
      years = normalizedInput.year || 0,
      quarters = normalizedInput.quarter || 0,
      months = normalizedInput.month || 0,
      weeks = normalizedInput.week || 0,
      days = normalizedInput.day || 0,
      hours = normalizedInput.hour || 0,
      minutes = normalizedInput.minute || 0,
      seconds = normalizedInput.second || 0,
      milliseconds = normalizedInput.millisecond || 0;

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; // using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
            weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
            quarters * 3 +
            years * 12;

    this._data = {};

    this._locale = locale_locales__getLocale();

    this._bubble();
  }

  function isDuration(obj) {
    return obj instanceof Duration;
  }

  // FORMATTING

  function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
      var offset = this.utcOffset();
      var sign = "+";
      if (offset < 0) {
        offset = -offset;
        sign = "-";
      }
      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
  }

  offset("Z", ":");
  offset("ZZ", "");

  // PARSING

  addRegexToken("Z", matchShortOffset);
  addRegexToken("ZZ", matchShortOffset);
  addParseToken(["Z", "ZZ"], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  });

  // HELPERS

  // timezone chunker
  // '+10:00' > ['10',  '00']
  // '-1530'  > ['-15', '30']
  var chunkOffset = /([\+\-]|\d\d)/gi;

  function offsetFromString(matcher, string) {
    var matches = ((string || "").match(matcher) || []);
    var chunk = matches[matches.length - 1] || [];
    var parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return parts[0] === "+" ? minutes : -minutes;
  }

  // Return a moment from input, that is local/utc/zone equivalent to model.
  function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
      // Use low-level api, because this fn is low-level api.
      res._d.setTime(res._d.valueOf() + diff);
      utils_hooks__hooks.updateOffset(res, false);
      return res;
    } else {
      return local__createLocal(input).local();
    }
  }

  function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
  }

  // HOOKS

  // This function will be called whenever a moment is mutated.
  // It is intended to keep the offset in sync with the timezone.
  utils_hooks__hooks.updateOffset = function () {};

  // MOMENTS

  // keepLocalTime = true means only change the timezone, without
  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
  // +0200, so we adjust the time as needed, to be valid.
  //
  // Keeping the time actually adds/subtracts (one hour)
  // from the actual represented time. That is why we call updateOffset
  // a second time. In case it wants us to change the offset again
  // _changeInProgress == true case, then we have to adjust, because
  // there is no such time in the given timezone.
  function getSetOffset(input, keepLocalTime) {
    var offset = this._offset || 0,
      localAdjust;
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    if (input != null) {
      if (typeof input === "string") {
        input = offsetFromString(matchShortOffset, input);
      } else if (Math.abs(input) < 16) {
        input = input * 60;
      }
      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }
      this._offset = input;
      this._isUTC = true;
      if (localAdjust != null) {
        this.add(localAdjust, "m");
      }
      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          add_subtract__addSubtract(this, create__createDuration(input - offset, "m"), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          utils_hooks__hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }
      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }

  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== "string") {
        input = -input;
      }

      this.utcOffset(input, keepLocalTime);

      return this;
    } else {
      return -this.utcOffset();
    }
  }

  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }

  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;

      if (keepLocalTime) {
        this.subtract(getDateOffset(this), "m");
      }
    }
    return this;
  }

  function setOffsetToParsedOffset() {
    if (this._tzm) {
      this.utcOffset(this._tzm);
    } else if (typeof this._i === "string") {
      this.utcOffset(offsetFromString(matchOffset, this._i));
    }
    return this;
  }

  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }
    input = input ? local__createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
  }

  function isDaylightSavingTime() {
    return (
      this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
    );
  }

  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
      var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
      this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }

    return this._isDSTShifted;
  }

  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }

  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }

  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  }

  // ASP.NET json date format regex
  var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;

  // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
  // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
  // and further modified to allow for strings containing both week and day
  var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

  function create__createDuration(input, key) {
    var duration = input,
      // matching against regexp is expensive, do it on demand
      match = null,
      sign,
      ret,
      diffRes;

    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (typeof input === "number") {
      duration = {};
      if (key) {
        duration[key] = input;
      } else {
        duration.milliseconds = input;
      }
    } else if (match = aspNetRegex.exec(input)) {
      sign = (match[1] === "-") ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(match[MILLISECOND]) * sign
      };
    } else if (match = isoRegex.exec(input)) {
      sign = (match[1] === "-") ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {// checks for null or undefined
      duration = {};
    } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
      diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, "_locale")) {
      ret._locale = input._locale;
    }

    return ret;
  }

  create__createDuration.fn = Duration.prototype;

  function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(",", "."));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
  }

  function positiveMomentsDifference(base, other) {
    var res = { milliseconds: 0, months: 0 };

    res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, "M").isAfter(other)) {
      --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, "M"));

    return res;
  }

  function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
      return { milliseconds: 0, months: 0 };
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }

    return res;
  }

  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  }

  // TODO: remove 'name' arg after deprecation is removed
  function createAdder(direction, name) {
    return function (val, period) {
      var dur, tmp;
      // invert the arguments, but complain about it
      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " +
                "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
        tmp = val; val = period; period = tmp;
      }

      val = typeof val === "string" ? +val : val;
      dur = create__createDuration(val, period);
      add_subtract__addSubtract(this, dur, direction);
      return this;
    };
  }

  function add_subtract__addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
      days = absRound(duration._days),
      months = absRound(duration._months);

    if (!mom.isValid()) {
      // No op
      return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
      get_set__set(mom, "Date", get_set__get(mom, "Date") + days * isAdding);
    }
    if (months) {
      setMonth(mom, get_set__get(mom, "Month") + months * isAdding);
    }
    if (updateOffset) {
      utils_hooks__hooks.updateOffset(mom, days || months);
    }
  }

  var add_subtract__add = createAdder(1, "add");
  var add_subtract__subtract = createAdder(-1, "subtract");

  function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, "days", true);
    return diff < -6 ? "sameElse" :
      diff < -1 ? "lastWeek" :
        diff < 0 ? "lastDay" :
          diff < 1 ? "sameDay" :
            diff < 2 ? "nextDay" :
              diff < 7 ? "nextWeek" : "sameElse";
  }

  function moment_calendar__calendar(time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || local__createLocal(),
      sod = cloneWithOffset(now, this).startOf("day"),
      format = utils_hooks__hooks.calendarFormat(this, sod) || "sameElse";

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
  }

  function clone() {
    return new Moment(this);
  }

  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : local__createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
    if (units === "millisecond") {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }

  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : local__createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
    if (units === "millisecond") {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }

  function isBetween(from, to, units, inclusivity) {
    inclusivity = inclusivity || "()";
    return (inclusivity[0] === "(" ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ")" ? this.isBefore(to, units) : !this.isAfter(to, units));
  }

  function isSame(input, units) {
    var localInput = isMoment(input) ? input : local__createLocal(input),
      inputMs;
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units || "millisecond");
    if (units === "millisecond") {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }

  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }

  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }

  function diff(input, units, asFloat) {
    var that,
      zoneDelta,
      delta, output;

    if (!this.isValid()) {
      return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
      return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === "year" || units === "month" || units === "quarter") {
      output = monthDiff(this, that);
      if (units === "quarter") {
        output = output / 3;
      } else if (units === "year") {
        output = output / 12;
      }
    } else {
      delta = this - that;
      output = units === "second" ? delta / 1e3 : // 1000
        units === "minute" ? delta / 6e4 : // 1000 * 60
          units === "hour" ? delta / 36e5 : // 1000 * 60 * 60
            units === "day" ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
              units === "week" ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
    }
    return asFloat ? output : absFloor(output);
  }

  function monthDiff(a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
      // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, "months"),
      anchor2, adjust;

    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
      // linear across the month
      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
      // linear across the month
      adjust = (b - anchor) / (anchor2 - anchor);
    }

    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
  }

  utils_hooks__hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
  utils_hooks__hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";

  function toString() {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  }

  function moment_format__toISOString() {
    var m = this.clone().utc();
    if (0 < m.year() && m.year() <= 9999) {
      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
      } else {
        return formatMoment(m, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
      }
    } else {
      return formatMoment(m, "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
    }
  }

  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }

  function from(time, withoutSuffix) {
    if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
      return create__createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function fromNow(withoutSuffix) {
    return this.from(local__createLocal(), withoutSuffix);
  }

  function to(time, withoutSuffix) {
    if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 local__createLocal(time).isValid())) {
      return create__createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }

  function toNow(withoutSuffix) {
    return this.to(local__createLocal(), withoutSuffix);
  }

  // If passed a locale key, it will set the locale for this
  // instance.  Otherwise, it will return the locale configuration
  // variables for this instance.
  function locale(key) {
    var newLocaleData;

    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = locale_locales__getLocale(key);
      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }
      return this;
    }
  }

  var lang = deprecate(
    "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
    function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    }
  );

  function localeData() {
    return this._locale;
  }

  function startOf(units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
      case "year":
        this.month(0);
        /* falls through */
      case "quarter":
      case "month":
        this.date(1);
        /* falls through */
      case "week":
      case "isoWeek":
      case "day":
      case "date":
        this.hours(0);
        /* falls through */
      case "hour":
        this.minutes(0);
        /* falls through */
      case "minute":
        this.seconds(0);
        /* falls through */
      case "second":
        this.milliseconds(0);
    }

    // weeks are a special case
    if (units === "week") {
      this.weekday(0);
    }
    if (units === "isoWeek") {
      this.isoWeekday(1);
    }

    // quarters are also special
    if (units === "quarter") {
      this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
  }

  function endOf(units) {
    units = normalizeUnits(units);
    if (units === undefined || units === "millisecond") {
      return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === "date") {
      units = "day";
    }

    return this.startOf(units).add(1, (units === "isoWeek" ? "week" : units)).subtract(1, "ms");
  }

  function to_type__valueOf() {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
  }

  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }

  function toDate() {
    return new Date(this.valueOf());
  }

  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }

  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }

  function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
  }

  function moment_valid__isValid() {
    return valid__isValid(this);
  }

  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }

  function invalidAt() {
    return getParsingFlags(this).overflow;
  }

  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }

  // FORMATTING

  addFormatToken(0, ["gg", 2], 0, function () {
    return this.weekYear() % 100;
  });

  addFormatToken(0, ["GG", 2], 0, function () {
    return this.isoWeekYear() % 100;
  });

  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }

  addWeekYearFormatToken("gggg", "weekYear");
  addWeekYearFormatToken("ggggg", "weekYear");
  addWeekYearFormatToken("GGGG", "isoWeekYear");
  addWeekYearFormatToken("GGGGG", "isoWeekYear");

  // ALIASES

  addUnitAlias("weekYear", "gg");
  addUnitAlias("isoWeekYear", "GG");

  // PRIORITY

  addUnitPriority("weekYear", 1);
  addUnitPriority("isoWeekYear", 1);

  // PARSING

  addRegexToken("G", matchSigned);
  addRegexToken("g", matchSigned);
  addRegexToken("GG", match1to2, match2);
  addRegexToken("gg", match1to2, match2);
  addRegexToken("GGGG", match1to4, match4);
  addRegexToken("gggg", match1to4, match4);
  addRegexToken("GGGGG", match1to6, match6);
  addRegexToken("ggggg", match1to6, match6);

  addWeekParseToken(["gggg", "ggggg", "GGGG", "GGGGG"], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });

  addWeekParseToken(["gg", "GG"], function (input, week, config, token) {
    week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
  });

  // MOMENTS

  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this,
      input,
      this.week(),
      this.weekday(),
      this.localeData()._week.dow,
      this.localeData()._week.doy);
  }

  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this,
      input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }

  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }

  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }

  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);
      if (week > weeksTarget) {
        week = weeksTarget;
      }
      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }

  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
      date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  }

  // FORMATTING

  addFormatToken("Q", 0, "Qo", "quarter");

  // ALIASES

  addUnitAlias("quarter", "Q");

  // PRIORITY

  addUnitPriority("quarter", 7);

  // PARSING

  addRegexToken("Q", match1);
  addParseToken("Q", function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  });

  // MOMENTS

  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  }

  // FORMATTING

  addFormatToken("D", ["DD", 2], "Do", "date");

  // ALIASES

  addUnitAlias("date", "D");

  // PRIOROITY
  addUnitPriority("date", 9);

  // PARSING

  addRegexToken("D", match1to2);
  addRegexToken("DD", match1to2, match2);
  addRegexToken("Do", function (isStrict, locale) {
    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
  });

  addParseToken(["D", "DD"], DATE);
  addParseToken("Do", function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
  });

  // MOMENTS

  var getSetDayOfMonth = makeGetSet("Date", true);

  // FORMATTING

  addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");

  // ALIASES

  addUnitAlias("dayOfYear", "DDD");

  // PRIORITY
  addUnitPriority("dayOfYear", 4);

  // PARSING

  addRegexToken("DDD", match1to3);
  addRegexToken("DDDD", match3);
  addParseToken(["DDD", "DDDD"], function (input, array, config) {
    config._dayOfYear = toInt(input);
  });

  // HELPERS

  // MOMENTS

  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), "d");
  }

  // FORMATTING

  addFormatToken("m", ["mm", 2], 0, "minute");

  // ALIASES

  addUnitAlias("minute", "m");

  // PRIORITY

  addUnitPriority("minute", 14);

  // PARSING

  addRegexToken("m", match1to2);
  addRegexToken("mm", match1to2, match2);
  addParseToken(["m", "mm"], MINUTE);

  // MOMENTS

  var getSetMinute = makeGetSet("Minutes", false);

  // FORMATTING

  addFormatToken("s", ["ss", 2], 0, "second");

  // ALIASES

  addUnitAlias("second", "s");

  // PRIORITY

  addUnitPriority("second", 15);

  // PARSING

  addRegexToken("s", match1to2);
  addRegexToken("ss", match1to2, match2);
  addParseToken(["s", "ss"], SECOND);

  // MOMENTS

  var getSetSecond = makeGetSet("Seconds", false);

  // FORMATTING

  addFormatToken("S", 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });

  addFormatToken(0, ["SS", 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });

  addFormatToken(0, ["SSS", 3], 0, "millisecond");
  addFormatToken(0, ["SSSS", 4], 0, function () {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ["SSSSS", 5], 0, function () {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ["SSSSSS", 6], 0, function () {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ["SSSSSSS", 7], 0, function () {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ["SSSSSSSS", 8], 0, function () {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ["SSSSSSSSS", 9], 0, function () {
    return this.millisecond() * 1000000;
  });

  // ALIASES

  addUnitAlias("millisecond", "ms");

  // PRIORITY

  addUnitPriority("millisecond", 16);

  // PARSING

  addRegexToken("S", match1to3, match1);
  addRegexToken("SS", match1to3, match2);
  addRegexToken("SSS", match1to3, match3);

  var token;
  for (token = "SSSS"; token.length <= 9; token += "S") {
    addRegexToken(token, matchUnsigned);
  }

  function parseMs(input, array) {
    array[MILLISECOND] = toInt(("0." + input) * 1000);
  }

  for (token = "S"; token.length <= 9; token += "S") {
    addParseToken(token, parseMs);
  }
  // MOMENTS

  var getSetMillisecond = makeGetSet("Milliseconds", false);

  // FORMATTING

  addFormatToken("z", 0, 0, "zoneAbbr");
  addFormatToken("zz", 0, 0, "zoneName");

  // MOMENTS

  function getZoneAbbr() {
    return this._isUTC ? "UTC" : "";
  }

  function getZoneName() {
    return this._isUTC ? "Coordinated Universal Time" : "";
  }

  var momentPrototype__proto = Moment.prototype;

  momentPrototype__proto.add = add_subtract__add;
  momentPrototype__proto.calendar = moment_calendar__calendar;
  momentPrototype__proto.clone = clone;
  momentPrototype__proto.diff = diff;
  momentPrototype__proto.endOf = endOf;
  momentPrototype__proto.format = format;
  momentPrototype__proto.from = from;
  momentPrototype__proto.fromNow = fromNow;
  momentPrototype__proto.to = to;
  momentPrototype__proto.toNow = toNow;
  momentPrototype__proto.get = stringGet;
  momentPrototype__proto.invalidAt = invalidAt;
  momentPrototype__proto.isAfter = isAfter;
  momentPrototype__proto.isBefore = isBefore;
  momentPrototype__proto.isBetween = isBetween;
  momentPrototype__proto.isSame = isSame;
  momentPrototype__proto.isSameOrAfter = isSameOrAfter;
  momentPrototype__proto.isSameOrBefore = isSameOrBefore;
  momentPrototype__proto.isValid = moment_valid__isValid;
  momentPrototype__proto.lang = lang;
  momentPrototype__proto.locale = locale;
  momentPrototype__proto.localeData = localeData;
  momentPrototype__proto.max = prototypeMax;
  momentPrototype__proto.min = prototypeMin;
  momentPrototype__proto.parsingFlags = parsingFlags;
  momentPrototype__proto.set = stringSet;
  momentPrototype__proto.startOf = startOf;
  momentPrototype__proto.subtract = add_subtract__subtract;
  momentPrototype__proto.toArray = toArray;
  momentPrototype__proto.toObject = toObject;
  momentPrototype__proto.toDate = toDate;
  momentPrototype__proto.toISOString = moment_format__toISOString;
  momentPrototype__proto.toJSON = toJSON;
  momentPrototype__proto.toString = toString;
  momentPrototype__proto.unix = unix;
  momentPrototype__proto.valueOf = to_type__valueOf;
  momentPrototype__proto.creationData = creationData;

  // Year
  momentPrototype__proto.year = getSetYear;
  momentPrototype__proto.isLeapYear = getIsLeapYear;

  // Week Year
  momentPrototype__proto.weekYear = getSetWeekYear;
  momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

  // Quarter
  momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

  // Month
  momentPrototype__proto.month = getSetMonth;
  momentPrototype__proto.daysInMonth = getDaysInMonth;

  // Week
  momentPrototype__proto.week = momentPrototype__proto.weeks = getSetWeek;
  momentPrototype__proto.isoWeek = momentPrototype__proto.isoWeeks = getSetISOWeek;
  momentPrototype__proto.weeksInYear = getWeeksInYear;
  momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

  // Day
  momentPrototype__proto.date = getSetDayOfMonth;
  momentPrototype__proto.day = momentPrototype__proto.days = getSetDayOfWeek;
  momentPrototype__proto.weekday = getSetLocaleDayOfWeek;
  momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
  momentPrototype__proto.dayOfYear = getSetDayOfYear;

  // Hour
  momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

  // Minute
  momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

  // Second
  momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

  // Millisecond
  momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

  // Offset
  momentPrototype__proto.utcOffset = getSetOffset;
  momentPrototype__proto.utc = setOffsetToUTC;
  momentPrototype__proto.local = setOffsetToLocal;
  momentPrototype__proto.parseZone = setOffsetToParsedOffset;
  momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
  momentPrototype__proto.isDST = isDaylightSavingTime;
  momentPrototype__proto.isLocal = isLocal;
  momentPrototype__proto.isUtcOffset = isUtcOffset;
  momentPrototype__proto.isUtc = isUtc;
  momentPrototype__proto.isUTC = isUtc;

  // Timezone
  momentPrototype__proto.zoneAbbr = getZoneAbbr;
  momentPrototype__proto.zoneName = getZoneName;

  // Deprecations
  momentPrototype__proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
  momentPrototype__proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
  momentPrototype__proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
  momentPrototype__proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
  momentPrototype__proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);

  var momentPrototype = momentPrototype__proto;

  function moment__createUnix(input) {
    return local__createLocal(input * 1000);
  }

  function moment__createInZone() {
    return local__createLocal.apply(null, arguments).parseZone();
  }

  function preParsePostFormat(string) {
    return string;
  }

  var prototype__proto = Locale.prototype;

  prototype__proto.calendar = locale_calendar__calendar;
  prototype__proto.longDateFormat = longDateFormat;
  prototype__proto.invalidDate = invalidDate;
  prototype__proto.ordinal = ordinal;
  prototype__proto.preparse = preParsePostFormat;
  prototype__proto.postformat = preParsePostFormat;
  prototype__proto.relativeTime = relative__relativeTime;
  prototype__proto.pastFuture = pastFuture;
  prototype__proto.set = locale_set__set;

  // Month
  prototype__proto.months = localeMonths;
  prototype__proto.monthsShort = localeMonthsShort;
  prototype__proto.monthsParse = localeMonthsParse;
  prototype__proto.monthsRegex = monthsRegex;
  prototype__proto.monthsShortRegex = monthsShortRegex;

  // Week
  prototype__proto.week = localeWeek;
  prototype__proto.firstDayOfYear = localeFirstDayOfYear;
  prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

  // Day of Week
  prototype__proto.weekdays = localeWeekdays;
  prototype__proto.weekdaysMin = localeWeekdaysMin;
  prototype__proto.weekdaysShort = localeWeekdaysShort;
  prototype__proto.weekdaysParse = localeWeekdaysParse;

  prototype__proto.weekdaysRegex = weekdaysRegex;
  prototype__proto.weekdaysShortRegex = weekdaysShortRegex;
  prototype__proto.weekdaysMinRegex = weekdaysMinRegex;

  // Hours
  prototype__proto.isPM = localeIsPM;
  prototype__proto.meridiem = localeMeridiem;

  function lists__get(format, index, field, setter) {
    var locale = locale_locales__getLocale();
    var utc = create_utc__createUTC().set(setter, index);
    return locale[field](utc, format);
  }

  function listMonthsImpl(format, index, field) {
    if (typeof format === "number") {
      index = format;
      format = undefined;
    }

    format = format || "";

    if (index != null) {
      return lists__get(format, index, field, "month");
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
      out[i] = lists__get(format, i, field, "month");
    }
    return out;
  }

  // ()
  // (5)
  // (fmt, 5)
  // (fmt)
  // (true)
  // (true, 5)
  // (true, fmt, 5)
  // (true, fmt)
  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === "boolean") {
      if (typeof format === "number") {
        index = format;
        format = undefined;
      }

      format = format || "";
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;

      if (typeof format === "number") {
        index = format;
        format = undefined;
      }

      format = format || "";
    }

    var locale = locale_locales__getLocale(),
      shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
      return lists__get(format, (index + shift) % 7, field, "day");
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
      out[i] = lists__get(format, (i + shift) % 7, field, "day");
    }
    return out;
  }

  function lists__listMonths(format, index) {
    return listMonthsImpl(format, index, "months");
  }

  function lists__listMonthsShort(format, index) {
    return listMonthsImpl(format, index, "monthsShort");
  }

  function lists__listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, "weekdays");
  }

  function lists__listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
  }

  function lists__listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
  }

  locale_locales__getSetGlobalLocale("en", {
    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
      var b = number % 10,
        output = (toInt(number % 100 / 10) === 1) ? "th" :
          (b === 1) ? "st" :
            (b === 2) ? "nd" :
              (b === 3) ? "rd" : "th";
      return number + output;
    }
  });

  // Side effect imports
  utils_hooks__hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", locale_locales__getSetGlobalLocale);
  utils_hooks__hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", locale_locales__getLocale);

  var mathAbs = Math.abs;

  function duration_abs__abs() {
    var data = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);

    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);

    return this;
  }

  function duration_add_subtract__addSubtract(duration, input, value, direction) {
    var other = create__createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;

    return duration._bubble();
  }

  // supports only 2.0-style add(1, 's') or add(duration)
  function duration_add_subtract__add(input, value) {
    return duration_add_subtract__addSubtract(this, input, value, 1);
  }

  // supports only 2.0-style subtract(1, 's') or subtract(duration)
  function duration_add_subtract__subtract(input, value) {
    return duration_add_subtract__addSubtract(this, input, value, -1);
  }

  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }

  function bubble() {
    var milliseconds = this._milliseconds;
    var days = this._days;
    var months = this._months;
    var data = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;

    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;

    hours = absFloor(minutes / 60);
    data.hours = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days = days;
    data.months = months;
    data.years = years;

    return this;
  }

  function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
  }

  function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
  }

  function as(units) {
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === "month" || units === "year") {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);
      return units === "month" ? months : months / 12;
    } else {
      // handle milliseconds separately because of floating point math errors (issue #1867)
      days = this._days + Math.round(monthsToDays(this._months));
      switch (units) {
        case "week" : return days / 7 + milliseconds / 6048e5;
        case "day" : return days + milliseconds / 864e5;
        case "hour" : return days * 24 + milliseconds / 36e5;
        case "minute" : return days * 1440 + milliseconds / 6e4;
        case "second" : return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here
        case "millisecond": return Math.floor(days * 864e5) + milliseconds;
        default: throw new Error("Unknown unit " + units);
      }
    }
  }

  // TODO: Use this.as('ms')?
  function duration_as__valueOf() {
    return (
      this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
    );
  }

  function makeAs(alias) {
    return function () {
      return this.as(alias);
    };
  }

  var asMilliseconds = makeAs("ms");
  var asSeconds = makeAs("s");
  var asMinutes = makeAs("m");
  var asHours = makeAs("h");
  var asDays = makeAs("d");
  var asWeeks = makeAs("w");
  var asMonths = makeAs("M");
  var asYears = makeAs("y");

  function duration_get__get(units) {
    units = normalizeUnits(units);
    return this[units + "s"]();
  }

  function makeGetter(name) {
    return function () {
      return this._data[name];
    };
  }

  var milliseconds = makeGetter("milliseconds");
  var seconds = makeGetter("seconds");
  var minutes = makeGetter("minutes");
  var hours = makeGetter("hours");
  var days = makeGetter("days");
  var months = makeGetter("months");
  var years = makeGetter("years");

  function weeks() {
    return absFloor(this.days() / 7);
  }

  var round = Math.round;
  var thresholds = {
    s: 45, // seconds to minute
    m: 45, // minutes to hour
    h: 22, // hours to day
    d: 26, // days to month
    M: 11 // months to year
  };

  // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }

  function duration_humanize__relativeTime(posNegDuration, withoutSuffix, locale) {
    var duration = create__createDuration(posNegDuration).abs();
    var seconds = round(duration.as("s"));
    var minutes = round(duration.as("m"));
    var hours = round(duration.as("h"));
    var days = round(duration.as("d"));
    var months = round(duration.as("M"));
    var years = round(duration.as("y"));

    var a = seconds < thresholds.s && ["s", seconds] ||
                minutes <= 1 && ["m"] ||
                minutes < thresholds.m && ["mm", minutes] ||
                hours <= 1 && ["h"] ||
                hours < thresholds.h && ["hh", hours] ||
                days <= 1 && ["d"] ||
                days < thresholds.d && ["dd", days] ||
                months <= 1 && ["M"] ||
                months < thresholds.M && ["MM", months] ||
                years <= 1 && ["y"] || ["yy", years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  }

  // This function allows you to set the rounding function for relative time strings
  function duration_humanize__getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
      return round;
    }
    if (typeof(roundingFunction) === "function") {
      round = roundingFunction;
      return true;
    }
    return false;
  }

  // This function allows you to set a threshold for relative time strings
  function duration_humanize__getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }
    if (limit === undefined) {
      return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    return true;
  }

  function humanize(withSuffix) {
    var locale = this.localeData();
    var output = duration_humanize__relativeTime(this, !withSuffix, locale);

    if (withSuffix) {
      output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
  }

  var iso_string__abs = Math.abs;

  function iso_string__toISOString() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    var seconds = iso_string__abs(this._milliseconds) / 1000;
    var days = iso_string__abs(this._days);
    var months = iso_string__abs(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
      // this is the same as C#'s (Noda) and python (isodate)...
      // but not other JS (goog.date)
      return "P0D";
    }

    return (total < 0 ? "-" : "") +
            "P" +
            (Y ? Y + "Y" : "") +
            (M ? M + "M" : "") +
            (D ? D + "D" : "") +
            ((h || m || s) ? "T" : "") +
            (h ? h + "H" : "") +
            (m ? m + "M" : "") +
            (s ? s + "S" : "");
  }

  var duration_prototype__proto = Duration.prototype;

  duration_prototype__proto.abs = duration_abs__abs;
  duration_prototype__proto.add = duration_add_subtract__add;
  duration_prototype__proto.subtract = duration_add_subtract__subtract;
  duration_prototype__proto.as = as;
  duration_prototype__proto.asMilliseconds = asMilliseconds;
  duration_prototype__proto.asSeconds = asSeconds;
  duration_prototype__proto.asMinutes = asMinutes;
  duration_prototype__proto.asHours = asHours;
  duration_prototype__proto.asDays = asDays;
  duration_prototype__proto.asWeeks = asWeeks;
  duration_prototype__proto.asMonths = asMonths;
  duration_prototype__proto.asYears = asYears;
  duration_prototype__proto.valueOf = duration_as__valueOf;
  duration_prototype__proto._bubble = bubble;
  duration_prototype__proto.get = duration_get__get;
  duration_prototype__proto.milliseconds = milliseconds;
  duration_prototype__proto.seconds = seconds;
  duration_prototype__proto.minutes = minutes;
  duration_prototype__proto.hours = hours;
  duration_prototype__proto.days = days;
  duration_prototype__proto.weeks = weeks;
  duration_prototype__proto.months = months;
  duration_prototype__proto.years = years;
  duration_prototype__proto.humanize = humanize;
  duration_prototype__proto.toISOString = iso_string__toISOString;
  duration_prototype__proto.toString = iso_string__toISOString;
  duration_prototype__proto.toJSON = iso_string__toISOString;
  duration_prototype__proto.locale = locale;
  duration_prototype__proto.localeData = localeData;

  // Deprecations
  duration_prototype__proto.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", iso_string__toISOString);
  duration_prototype__proto.lang = lang;

  // Side effect imports

  // FORMATTING

  addFormatToken("X", 0, 0, "unix");
  addFormatToken("x", 0, 0, "valueOf");

  // PARSING

  addRegexToken("x", matchSigned);
  addRegexToken("X", matchTimestamp);
  addParseToken("X", function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
  });
  addParseToken("x", function (input, array, config) {
    config._d = new Date(toInt(input));
  });

  // Side effect imports

  utils_hooks__hooks.version = "2.14.2";

  setHookCallback(local__createLocal);

  utils_hooks__hooks.fn = momentPrototype;
  utils_hooks__hooks.min = min;
  utils_hooks__hooks.max = max;
  utils_hooks__hooks.now = now;
  utils_hooks__hooks.utc = create_utc__createUTC;
  utils_hooks__hooks.unix = moment__createUnix;
  utils_hooks__hooks.months = lists__listMonths;
  utils_hooks__hooks.isDate = isDate;
  utils_hooks__hooks.locale = locale_locales__getSetGlobalLocale;
  utils_hooks__hooks.invalid = valid__createInvalid;
  utils_hooks__hooks.duration = create__createDuration;
  utils_hooks__hooks.isMoment = isMoment;
  utils_hooks__hooks.weekdays = lists__listWeekdays;
  utils_hooks__hooks.parseZone = moment__createInZone;
  utils_hooks__hooks.localeData = locale_locales__getLocale;
  utils_hooks__hooks.isDuration = isDuration;
  utils_hooks__hooks.monthsShort = lists__listMonthsShort;
  utils_hooks__hooks.weekdaysMin = lists__listWeekdaysMin;
  utils_hooks__hooks.defineLocale = defineLocale;
  utils_hooks__hooks.updateLocale = updateLocale;
  utils_hooks__hooks.locales = locale_locales__listLocales;
  utils_hooks__hooks.weekdaysShort = lists__listWeekdaysShort;
  utils_hooks__hooks.normalizeUnits = normalizeUnits;
  utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
  utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
  utils_hooks__hooks.calendarFormat = getCalendarFormat;
  utils_hooks__hooks.prototype = momentPrototype;

  var _moment = utils_hooks__hooks;

  return _moment;

}));

/**
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

/**
 * Implementing Drag and Drop functionality in AngularJS is easier than ever.
 * Demo: http://codef0rmer.github.com/angular-dragdrop/
 *
 * @version 1.0.13
 *
 * (c) 2013 Amit Gharat a.k.a codef0rmer <amit.2006.it@gmail.com> - amitgharat.wordpress.com
 */

(function (window, angular, $, undefined) {
  "use strict";

  var jqyoui = angular.module("ngDragDrop", []).service("ngDragDropService", ["$timeout", "$parse", "$q", function ($timeout, $parse, $q) {
    this.draggableScope = null;
    this.droppableScope = null;

    $("head").prepend("<style type=\"text/css\">@charset \"UTF-8\";.angular-dragdrop-hide{display: none !important;}</style>");

    this.callEventCallback = function (scope, callbackName, event, ui) {
      if (!callbackName) return;

      var objExtract = extract(callbackName),
        callback = objExtract.callback,
        constructor = objExtract.constructor,
        args = [event, ui].concat(objExtract.args);

      // call either $scoped method i.e. $scope.dropCallback or constructor's method i.e. this.dropCallback.
      // Removing scope.$apply call that was performance intensive (especially onDrag) and does not require it
      // always. So call it within the callback if needed.
      return (scope[callback] || scope[constructor][callback]).apply(scope[callback] ? scope : scope[constructor], args);

      function extract(callbackName) {
        var atStartBracket = callbackName.indexOf("(") !== -1 ? callbackName.indexOf("(") : callbackName.length,
          atEndBracket = callbackName.lastIndexOf(")") !== -1 ? callbackName.lastIndexOf(")") : callbackName.length,
          args = callbackName.substring(atStartBracket + 1, atEndBracket), // matching function arguments inside brackets
          constructor = callbackName.indexOf(".") !== -1 ? callbackName.substr(0, callbackName.indexOf(".")) : null; // matching a string upto a dot to check ctrl as syntax
        constructor = scope[constructor] && typeof scope[constructor].constructor === "function" ? constructor : null;

        return {
          callback: callbackName.substring(constructor && constructor.length + 1 || 0, atStartBracket),
          args: $.map(args && args.split(",") || [], function (item) { return [$parse(item)(scope)]; }),
          constructor: constructor
        };
      }
    };

    this.invokeDrop = function ($draggable, $droppable, event, ui) {
      var dragModel = "",
        dropModel = "",
        dragSettings = {},
        dropSettings = {},
        jqyoui_pos = null,
        dragItem = {},
        dropItem = {},
        dragModelValue,
        dropModelValue,
        $droppableDraggable = null,
        droppableScope = this.droppableScope,
        draggableScope = this.draggableScope,
        $helper = null,
        promises = [],
        temp;

      dragModel = $draggable.ngattr("ng-model");
      dropModel = $droppable.ngattr("ng-model");
      dragModelValue = draggableScope.$eval(dragModel);
      dropModelValue = droppableScope.$eval(dropModel);

      $droppableDraggable = $droppable.find("[jqyoui-draggable]:last,[data-jqyoui-draggable]:last");
      dropSettings = droppableScope.$eval($droppable.attr("jqyoui-droppable") || $droppable.attr("data-jqyoui-droppable")) || [];
      dragSettings = draggableScope.$eval($draggable.attr("jqyoui-draggable") || $draggable.attr("data-jqyoui-draggable")) || [];

      // Helps pick up the right item
      dragSettings.index = this.fixIndex(draggableScope, dragSettings, dragModelValue);
      dropSettings.index = this.fixIndex(droppableScope, dropSettings, dropModelValue);

      jqyoui_pos = angular.isArray(dragModelValue) ? dragSettings.index : null;
      dragItem = angular.isArray(dragModelValue) ? dragModelValue[jqyoui_pos] : dragModelValue;

      if (dragSettings.deepCopy) {
        dragItem = angular.copy(dragItem);
      }

      if (angular.isArray(dropModelValue) && dropSettings && dropSettings.index !== undefined) {
        dropItem = dropModelValue[dropSettings.index];
      } else if (!angular.isArray(dropModelValue)) {
        dropItem = dropModelValue;
      } else {
        dropItem = {};
      }

      if (dropSettings.deepCopy) {
        dropItem = angular.copy(dropItem);
      }

      if (dragSettings.beforeDrop) {
        promises.push(this.callEventCallback(draggableScope, dragSettings.beforeDrop, event, ui));
      }

      $q.all(promises).then(angular.bind(this, function () {
        if (dragSettings.insertInline && dragModel === dropModel) {
          if (dragSettings.index > dropSettings.index) {
            temp = dragModelValue[dragSettings.index];
            for (var i = dragSettings.index; i > dropSettings.index; i--) {
              dropModelValue[i] = angular.copy(dropModelValue[i - 1]);
              dropModelValue[i - 1] = {};
              dropModelValue[i][dragSettings.direction] = "left";
            }
            dropModelValue[dropSettings.index] = temp;
          } else {
            temp = dragModelValue[dragSettings.index];
            for (var i = dragSettings.index; i < dropSettings.index; i++) {
              dropModelValue[i] = angular.copy(dropModelValue[i + 1]);
              dropModelValue[i + 1] = {};
              dropModelValue[i][dragSettings.direction] = "right";
            }
            dropModelValue[dropSettings.index] = temp;
          }
          this.callEventCallback(droppableScope, dropSettings.onDrop, event, ui);
        } else if (dragSettings.animate === true) {
          // be nice with absolutely positioned brethren :-)
          $helper = $draggable.clone();
          $helper.css({ "position": "absolute" }).css($draggable.offset());
          $("body").append($helper);
          $draggable.addClass("angular-dragdrop-hide");

          this.move($helper, $droppableDraggable.length > 0 ? $droppableDraggable : $droppable, null, "fast", dropSettings, function () { $helper.remove(); });
          this.move($droppableDraggable.length > 0 && !dropSettings.multiple ? $droppableDraggable : [], $draggable.parent("[jqyoui-droppable],[data-jqyoui-droppable]"), jqyoui.startXY, "fast", dropSettings, angular.bind(this, function () {
            $timeout(angular.bind(this, function () {
              // Do not move this into move() to avoid flickering issue
              $draggable.css({ "position": "relative", "left": "", "top": "" }).removeClass("angular-dragdrop-hide");
              // Angular v1.2 uses ng-hide to hide an element not display property
              // so we've to manually remove display:none set in this.move()
              $droppableDraggable.css({ "position": "relative", "left": "", "top": "", "display": $droppableDraggable.css("display") === "none" ? "" : $droppableDraggable.css("display") });

              this.mutateDraggable(draggableScope, dropSettings, dragSettings, dragModel, dropModel, dropItem, $draggable);
              this.mutateDroppable(droppableScope, dropSettings, dragSettings, dropModel, dragItem, jqyoui_pos);
              this.callEventCallback(droppableScope, dropSettings.onDrop, event, ui);
            }));
          }));
        } else {
          $timeout(angular.bind(this, function () {
            this.mutateDraggable(draggableScope, dropSettings, dragSettings, dragModel, dropModel, dropItem, $draggable);
            this.mutateDroppable(droppableScope, dropSettings, dragSettings, dropModel, dragItem, jqyoui_pos);
            this.callEventCallback(droppableScope, dropSettings.onDrop, event, ui);
          }));
        }
      })).finally(angular.bind(this, function () {
        this.restore($draggable);
      }));
    };

    this.move = function ($fromEl, $toEl, toPos, duration, dropSettings, callback) {
      if ($fromEl.length === 0) {
        if (callback) {
          window.setTimeout(function () {
            callback();
          }, 300);
        }
        return false;
      }

      var zIndex = $fromEl.css("z-index"),
        fromPos = $fromEl[dropSettings.containment || "offset"](),
        displayProperty = $toEl.css("display"), // sometimes `display` is other than `block`
        hadNgHideCls = $toEl.hasClass("ng-hide"),
        hadDNDHideCls = $toEl.hasClass("angular-dragdrop-hide");

      if (toPos === null && $toEl.length > 0) {
        if (($toEl.attr("jqyoui-draggable") || $toEl.attr("data-jqyoui-draggable")) !== undefined && $toEl.ngattr("ng-model") !== undefined && $toEl.is(":visible") && dropSettings && dropSettings.multiple) {
          toPos = $toEl[dropSettings.containment || "offset"]();
          if (dropSettings.stack === false) {
            toPos.left += $toEl.outerWidth(true);
          } else {
            toPos.top += $toEl.outerHeight(true);
          }
        } else {
          // Angular v1.2 uses ng-hide to hide an element
          // so we've to remove it in order to grab its position
          if (hadNgHideCls) $toEl.removeClass("ng-hide");
          if (hadDNDHideCls) $toEl.removeClass("angular-dragdrop-hide");
          toPos = $toEl.css({ "visibility": "hidden", "display": "block" })[dropSettings.containment || "offset"]();
          $toEl.css({ "visibility": "", "display": displayProperty });
        }
      }

      $fromEl.css({ "position": "absolute", "z-index": 9999 })
        .css(fromPos)
        .animate(toPos, duration, function () {
          // Angular v1.2 uses ng-hide to hide an element
          // and as we remove it above, we've to put it back to
          // hide the element (while swapping) if it was hidden already
          // because we remove the display:none in this.invokeDrop()
          if (hadNgHideCls) $toEl.addClass("ng-hide");
          if (hadDNDHideCls) $toEl.addClass("angular-dragdrop-hide");
          $fromEl.css("z-index", zIndex);
          if (callback) callback();
        });
    };

    this.mutateDroppable = function (scope, dropSettings, dragSettings, dropModel, dragItem, jqyoui_pos) {
      var dropModelValue = scope.$eval(dropModel);

      scope.dndDragItem = dragItem;

      if (angular.isArray(dropModelValue)) {
        if (dropSettings && dropSettings.index >= 0) {
          dropModelValue[dropSettings.index] = dragItem;
        } else {
          dropModelValue.push(dragItem);
        }
        if (dragSettings && dragSettings.placeholder === true) {
          dropModelValue[dropModelValue.length - 1]["jqyoui_pos"] = jqyoui_pos;
        }
      } else {
        $parse(dropModel + " = dndDragItem")(scope);
        if (dragSettings && dragSettings.placeholder === true) {
          dropModelValue["jqyoui_pos"] = jqyoui_pos;
        }
      }
    };

    this.mutateDraggable = function (scope, dropSettings, dragSettings, dragModel, dropModel, dropItem, $draggable) {
      var isEmpty = angular.equals(dropItem, {}) || !dropItem,
        dragModelValue = scope.$eval(dragModel);

      scope.dndDropItem = dropItem;

      if (dragSettings && dragSettings.placeholder) {
        if (dragSettings.placeholder != "keep") {
          if (angular.isArray(dragModelValue) && dragSettings.index !== undefined) {
            dragModelValue[dragSettings.index] = dropItem;
          } else {
            $parse(dragModel + " = dndDropItem")(scope);
          }
        }
      } else {
        if (angular.isArray(dragModelValue)) {
          if (isEmpty) {
            if (dragSettings && ( dragSettings.placeholder !== true && dragSettings.placeholder !== "keep" )) {
              dragModelValue.splice(dragSettings.index, 1);
            }
          } else {
            dragModelValue[dragSettings.index] = dropItem;
          }
        } else {
          // Fix: LIST(object) to LIST(array) - model does not get updated using just scope[dragModel] = {...}
          // P.S.: Could not figure out why it happened
          $parse(dragModel + " = dndDropItem")(scope);
          if (scope.$parent) {
            $parse(dragModel + " = dndDropItem")(scope.$parent);
          }
        }
      }

      this.restore($draggable);
    };

    this.restore = function ($draggable) {
      $draggable.css({ "z-index": "", "left": "", "top": "" });
    };

    this.fixIndex = function (scope, settings, modelValue) {
      if (settings.applyFilter && angular.isArray(modelValue) && modelValue.length > 0) {
        var dragModelValueFiltered = scope[settings.applyFilter](),
          lookup = dragModelValueFiltered[settings.index],
          actualIndex = undefined;

        modelValue.forEach(function (item, i) {
          if (angular.equals(item, lookup)) {
            actualIndex = i;
          }
        });

        return actualIndex;
      }

      return settings.index;
    };
  }]).directive("jqyouiDraggable", ["ngDragDropService", function (ngDragDropService) {
    return {
      require: "?jqyouiDroppable",
      restrict: "A",
      link: function (scope, elem, attrs) {
        var element = $(elem);
        var dragSettings, jqyouiOptions, zIndex, killWatcher;
        var updateDraggable = function (newValue, oldValue) {
          if (newValue) {
            dragSettings = scope.$eval(element.attr("jqyoui-draggable") || element.attr("data-jqyoui-draggable")) || {};
            jqyouiOptions = scope.$eval(attrs.jqyouiOptions) || {};
            element
              .draggable({ disabled: false })
              .draggable(jqyouiOptions)
              .draggable({
                start: function (event, ui) {
                  ngDragDropService.draggableScope = scope;
                  zIndex = $(jqyouiOptions.helper ? ui.helper : this).css("z-index");
                  $(jqyouiOptions.helper ? ui.helper : this).css("z-index", 9999);
                  jqyoui.startXY = $(this)[dragSettings.containment || "offset"]();
                  ngDragDropService.callEventCallback(scope, dragSettings.onStart, event, ui);
                },
                stop: function (event, ui) {
                  $(jqyouiOptions.helper ? ui.helper : this).css("z-index", zIndex);
                  ngDragDropService.callEventCallback(scope, dragSettings.onStop, event, ui);
                },
                drag: function (event, ui) {
                  ngDragDropService.callEventCallback(scope, dragSettings.onDrag, event, ui);
                }
              });
          } else {
            element.draggable({ disabled: true });
          }

          if (killWatcher && angular.isDefined(newValue) && (angular.equals(attrs.drag, "true") || angular.equals(attrs.drag, "false"))) {
            killWatcher();
            killWatcher = null;
          }
        };

        killWatcher = scope.$watch(function () { return scope.$eval(attrs.drag); }, updateDraggable);
        updateDraggable();

        element.on("$destroy", function () {
          element.draggable({ disabled: true }).draggable("destroy");
        });
      }
    };
  }]).directive("jqyouiDroppable", ["ngDragDropService", "$q", function (ngDragDropService, $q) {
    return {
      restrict: "A",
      priority: 1,
      link: function (scope, elem, attrs) {
        var element = $(elem);
        var dropSettings, jqyouiOptions, killWatcher;
        var updateDroppable = function (newValue, oldValue) {
          if (newValue) {
            dropSettings = scope.$eval($(element).attr("jqyoui-droppable") || $(element).attr("data-jqyoui-droppable")) || {};
            jqyouiOptions = scope.$eval(attrs.jqyouiOptions) || {};
            element
              .droppable({ disabled: false })
              .droppable(jqyouiOptions)
              .droppable({
                over: function (event, ui) {
                  ngDragDropService.callEventCallback(scope, dropSettings.onOver, event, ui);
                },
                out: function (event, ui) {
                  ngDragDropService.callEventCallback(scope, dropSettings.onOut, event, ui);
                },
                drop: function (event, ui) {
                  var beforeDropPromise = null;

                  if (dropSettings.beforeDrop) {
                    beforeDropPromise = ngDragDropService.callEventCallback(scope, dropSettings.beforeDrop, event, ui);
                  } else {
                    beforeDropPromise = (function () {
                      var deferred = $q.defer();
                      deferred.resolve();
                      return deferred.promise;
                    })();
                  }

                  beforeDropPromise.then(angular.bind(this, function () {
                    if ($(ui.draggable).ngattr("ng-model") && attrs.ngModel) {
                      ngDragDropService.droppableScope = scope;
                      ngDragDropService.invokeDrop($(ui.draggable), $(this), event, ui);
                    } else {
                      ngDragDropService.callEventCallback(scope, dropSettings.onDrop, event, ui);
                    }
                  }), function () {
                    ui.draggable.animate({ left: "", top: "" }, jqyouiOptions.revertDuration || 0);
                  });
                }
              });
          } else {
            element.droppable({ disabled: true });
          }

          if (killWatcher && angular.isDefined(newValue) && (angular.equals(attrs.drop, "true") || angular.equals(attrs.drop, "false"))) {
            killWatcher();
            killWatcher = null;
          }
        };

        killWatcher = scope.$watch(function () { return scope.$eval(attrs.drop); }, updateDroppable);
        updateDroppable();

        element.on("$destroy", function () {
          element.droppable({ disabled: true }).droppable("destroy");
        });
      }
    };
  }]);

  $.fn.ngattr = function (name, value) {
    var element = this[0];

    return element.getAttribute(name) || element.getAttribute("data-" + name);
  };
})(window, window.angular, window.jQuery);

/* !
 * angular-datatables - v0.4.3
 * https://github.com/l-lin/angular-datatables
 * License: MIT
 */
!function (a, b, c, d) {"use strict";function e(a, b) {function d(d, e) {if (!f) {var g = a.overrideProperties(b.getOptions().ColVis, e ? e.ColVis : null);c.fn.DataTable.ColVis && d(function () {c(".ColVis_MasterButton").attr("class", "ColVis_MasterButton " + g.classes.masterButton), c(".ColVis_Button").removeClass("ColVis_Button");}), f = !0;}} function e() {f && c.fn.DataTable.ColVis && (f = !1);} var f = !1;return { integrate: d, deIntegrate: e };} function f(a) {function b(a) {function b(a, b) {function c() {return f.hasBootstrap = !0, d.isObject(f.oClasses) ? f.oClasses.sPageButtonActive = "active" : f.oClasses = { sPageButtonActive: "active" }, f;} function e(a) {return f.bootstrap = a, f;} var f = a(b);return f.withBootstrap = c, f.withBootstrapOptions = e, f;} var c = a.newOptions, e = a.fromSource, f = a.fromFnPromise;return a.newOptions = function () {return b(c);}, a.fromSource = function (a) {return b(e, a);}, a.fromFnPromise = function (a) {return b(f, a);}, a;}a.decorator("DTOptionsBuilder", b), b.$inject = ["$delegate"];} function g(a, b) {function c(a) {a && a.hasBootstrap ? b.integrate(a) : b.deIntegrate();} var d = { preRender: c };a.registerPlugin(d);} function h(a, e, f, g, h) {function i() {u.oStdClasses = d.copy(c.fn.dataTableExt.oStdClasses), u.fnPagingInfo = c.fn.dataTableExt.oApi.fnPagingInfo, u.renderer = d.copy(c.fn.DataTable.ext.renderer), c.fn.DataTable.TableTools && (u.TableTools = { classes: d.copy(c.fn.DataTable.TableTools.classes), oTags: d.copy(c.fn.DataTable.TableTools.DEFAULTS.oTags) });} function j() {c.extend(c.fn.dataTableExt.oStdClasses, u.oStdClasses), c.fn.dataTableExt.oApi.fnPagingInfo = u.fnPagingInfo, c.extend(!0, c.fn.DataTable.ext.renderer, u.renderer);} function k() {c.extend(c.fn.dataTableExt.oStdClasses, { sWrapper: "dataTables_wrapper form-inline", sFilterInput: "form-control input-sm", sLengthSelect: "form-control input-sm", sFilter: "dataTables_filter", sLength: "dataTables_length" });} function l() {c.fn.dataTableExt.oApi.fnPagingInfo = function (a) {return { iStart: a._iDisplayStart, iEnd: a.fnDisplayEnd(), iLength: a._iDisplayLength, iTotal: a.fnRecordsTotal(), iFilteredTotal: a.fnRecordsDisplay(), iPage: -1 === a._iDisplayLength ? 0 : Math.ceil(a._iDisplayStart / a._iDisplayLength), iTotalPages: -1 === a._iDisplayLength ? 0 : Math.ceil(a.fnRecordsDisplay() / a._iDisplayLength) };};} function m(a) {c.extend(!0, c.fn.DataTable.ext.renderer, { pageButton: { _: function (d, e, h, i, j, k) {var l, m, n = d.oClasses, o = d.language ? d.language.oPaginate : d.oLanguage.oPaginate, p = 0, q = g.overrideProperties(f.getOptions().pagination, a ? a.pagination : null), r = c("<ul></ul>", { "class": q.classes.ul }), s = function (a, b) {var e, f, g, i, q = function (a) {a.preventDefault(), c.fn.DataTable.ext.internal._fnPageChange(d, a.data.action, !0);};for (e = 0, f = b.length;f > e;e++) if (i = b[e], c.isArray(i)) {i.DT_el = "li";var t = c("<" + (i.DT_el || "div") + "/>").appendTo(r);s(t, i);} else {l = "", m = "";var u, v = c("<li></li>");switch (i) {case "ellipsis":r.append("<li class=\"disabled\"><a href=\"#\" onClick=\"event.preventDefault()\">&hellip;</a></li>");break;case "first":l = o.sFirst, m = i, 0 >= j && (v.addClass(n.sPageButtonDisabled), u = !0);break;case "previous":l = o.sPrevious, m = i, 0 >= j && (v.addClass(n.sPageButtonDisabled), u = !0);break;case "next":l = o.sNext, m = i, j >= k - 1 && (v.addClass(n.sPageButtonDisabled), u = !0);break;case "last":l = o.sLast, m = i, j >= k - 1 && (v.addClass(n.sPageButtonDisabled), u = !0);break;default:l = i + 1, m = "", j === i && v.addClass(n.sPageButtonActive);}l && (v.appendTo(r), g = c("<a>", { href: "#", "class": m, "aria-controls": d.sTableId, "data-dt-idx": p, tabindex: d.iTabIndex, id: 0 === h && "string" === typeof i ? d.sTableId + "_" + i : null }).html(l).appendTo(v), c.fn.DataTable.ext.internal._fnBindAction(g, { action: i }, q), p++);}};try {var t = c(b.activeElement).data("dt-idx"), u = c(e).empty();r.appendTo(u), s(u, i), null !== t && c(e).find("[data-dt-idx=" + t + "]").focus();} catch (v) {}} } });} function n(a) {d.isFunction(a) && t.push(a);} function o(a) {s || (i(), k(), l(), m(a), n(function () {c("div.dataTables_filter").find("input").addClass("form-control"), c("div.dataTables_length").find("select").addClass("form-control");}), s = !0);} function p(a) {return a.dom && a.dom !== h.dom ? a.dom : f.getOptions().dom;} function q(b) {o(b.bootstrap), a.integrate(b.bootstrap), e.integrate(n, b.bootstrap), b.dom = p(b), d.isUndefined(b.fnDrawCallback) && (b.fnDrawCallback = function () {for (var a = 0;a < t.length;a++)t[a]();});} function r() {s && (j(), a.deIntegrate(), e.deIntegrate(), s = !1);} var s = !1, t = [], u = {};return { integrate: q, deIntegrate: r };} function i(a, b, c) {function d() {return b.overrideProperties(c, a.bootstrapOptions);} return { getOptions: d };} function j(a, b) {function e(d) {if (!h) {if (g(), c.fn.DataTable.TableTools) {var e = a.overrideProperties(b.getOptions().TableTools, d ? d.TableTools : null);c.extend(!0, c.fn.DataTable.TableTools.classes, e.classes), c.extend(!0, c.fn.DataTable.TableTools.DEFAULTS.oTags, e.DEFAULTS.oTags);}h = !0;}} function f() {h && c.fn.DataTable.TableTools && i.TableTools && (c.extend(!0, c.fn.DataTable.TableTools.classes, i.TableTools.classes), c.extend(!0, c.fn.DataTable.TableTools.DEFAULTS.oTags, i.TableTools.oTags), h = !1);} function g() {c.fn.DataTable.TableTools && (i.TableTools = { classes: d.copy(c.fn.DataTable.TableTools.classes), oTags: d.copy(c.fn.DataTable.TableTools.DEFAULTS.oTags) });} var h = !1, i = {};return { integrate: e, deIntegrate: f };}d.module("datatables.bootstrap.colvis", ["datatables.bootstrap.options", "datatables.util"]).service("DTBootstrapColVis", e), e.$inject = ["DTPropertyUtil", "DTBootstrapDefaultOptions"], d.module("datatables.bootstrap", ["datatables.bootstrap.options", "datatables.bootstrap.tabletools", "datatables.bootstrap.colvis"]).config(f).run(g).service("DTBootstrap", h), f.$inject = ["$provide"], g.$inject = ["DTRendererService", "DTBootstrap"], h.$inject = ["DTBootstrapTableTools", "DTBootstrapColVis", "DTBootstrapDefaultOptions", "DTPropertyUtil", "DT_DEFAULT_OPTIONS"], d.module("datatables.bootstrap.options", ["datatables.options", "datatables.util"]).constant("DT_BOOTSTRAP_DEFAULT_OPTIONS", { TableTools: { classes: { container: "DTTT btn-group", buttons: { normal: "btn btn-default", disabled: "disabled" }, collection: { container: "DTTT_dropdown dropdown-menu", buttons: { normal: "", disabled: "disabled" } }, print: { info: "DTTT_print_info modal" }, select: { row: "active" } }, DEFAULTS: { oTags: { collection: { container: "ul", button: "li", liner: "a" } } } }, ColVis: { classes: { masterButton: "btn btn-default" } }, pagination: { classes: { ul: "pagination" } }, dom: "<'row'<'col-xs-6'l><'col-xs-6'f>r>t<'row'<'col-xs-6'i><'col-xs-6'p>>" }).factory("DTBootstrapDefaultOptions", i), i.$inject = ["DTDefaultOptions", "DTPropertyUtil", "DT_BOOTSTRAP_DEFAULT_OPTIONS"], d.module("datatables.bootstrap.tabletools", ["datatables.bootstrap.options", "datatables.util"]).service("DTBootstrapTableTools", j), j.$inject = ["DTPropertyUtil", "DTBootstrapDefaultOptions"];}(window, document, jQuery, angular);

/**
 * @license Angular UI Tree v2.22.6
 * (c) 2010-2017. https://github.com/angular-ui-tree/angular-ui-tree
 * License: MIT
 */
(function () {
  "use strict";

  angular.module("ui.tree", [])
    .constant("treeConfig", {
      treeClass: "angular-ui-tree",
      emptyTreeClass: "angular-ui-tree-empty",
      dropzoneClass: "angular-ui-tree-dropzone",
      hiddenClass: "angular-ui-tree-hidden",
      nodesClass: "angular-ui-tree-nodes",
      nodeClass: "angular-ui-tree-node",
      handleClass: "angular-ui-tree-handle",
      placeholderClass: "angular-ui-tree-placeholder",
      dragClass: "angular-ui-tree-drag",
      dragThreshold: 3,
      defaultCollapsed: false,
      appendChildOnHover: true
    });

})();

(function () {
  "use strict";

  angular.module("ui.tree")

    .controller("TreeHandleController", ["$scope", "$element",
      function ($scope, $element) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$nodeScope = null;
        $scope.$type = "uiTreeHandle";

      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")
    .controller("TreeNodeController", ["$scope", "$element",
      function ($scope, $element) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$modelValue = null; // Model value for node;
        $scope.$parentNodeScope = null; // uiTreeNode Scope of parent node;
        $scope.$childNodesScope = null; // uiTreeNodes Scope of child nodes.
        $scope.$parentNodesScope = null; // uiTreeNodes Scope of parent nodes.
        $scope.$treeScope = null; // uiTree scope
        $scope.$handleScope = null; // it's handle scope
        $scope.$type = "uiTreeNode";
        $scope.$$allowNodeDrop = false;
        $scope.collapsed = false;
        $scope.expandOnHover = false;

        // Called by uiTreeNode Directive on load.
        $scope.init = function (controllersArr) {
          var treeNodesCtrl = controllersArr[0];
          $scope.$treeScope = controllersArr[1] ? controllersArr[1].scope : null;

          // Find the scope of it's parent node.
          $scope.$parentNodeScope = treeNodesCtrl.scope.$nodeScope;

          // modelValue for current node.
          $scope.$modelValue = treeNodesCtrl.scope.$modelValue[$scope.$index];
          $scope.$parentNodesScope = treeNodesCtrl.scope;

          // Init sub nodes.
          treeNodesCtrl.scope.initSubNode($scope);

          $element.on("$destroy", function () {

            // Destroy sub nodes.
            treeNodesCtrl.scope.destroySubNode($scope);
          });
        };

        // Return the index of child node in parent node (nodesScope).
        $scope.index = function () {
          return $scope.$parentNodesScope.$modelValue.indexOf($scope.$modelValue);
        };

        $scope.dragEnabled = function () {
          return !($scope.$treeScope && !$scope.$treeScope.dragEnabled);
        };

        $scope.isSibling = function (targetNode) {
          return $scope.$parentNodesScope == targetNode.$parentNodesScope;
        };

        $scope.isChild = function (targetNode) {
          var nodes = $scope.childNodes();
          return nodes && nodes.indexOf(targetNode) > -1;
        };

        // TODO(jcarter): This method is on uiTreeHelper already.
        $scope.prev = function () {
          var index = $scope.index();
          if (index > 0) {
            return $scope.siblings()[index - 1];
          }
          return null;
        };

        // Calls childNodes on parent.
        $scope.siblings = function () {
          return $scope.$parentNodesScope.childNodes();
        };

        $scope.childNodesCount = function () {
          return $scope.childNodes() ? $scope.childNodes().length : 0;
        };

        $scope.hasChild = function () {
          return $scope.childNodesCount() > 0;
        };

        $scope.childNodes = function () {
          return $scope.$childNodesScope && $scope.$childNodesScope.$modelValue ?
            $scope.$childNodesScope.childNodes() :
            null;
        };

        $scope.accept = function (sourceNode, destIndex) {
          return $scope.$childNodesScope &&
            $scope.$childNodesScope.$modelValue &&
            $scope.$childNodesScope.accept(sourceNode, destIndex);
        };

        $scope.remove = function () {
          return $scope.$parentNodesScope.removeNode($scope);
        };

        $scope.toggle = function () {
          $scope.collapsed = !$scope.collapsed;
          $scope.$treeScope.$callbacks.toggle($scope.collapsed, $scope);
        };

        $scope.collapse = function () {
          $scope.collapsed = true;
        };

        $scope.expand = function () {
          $scope.collapsed = false;
        };

        $scope.depth = function () {
          var parentNode = $scope.$parentNodeScope;
          if (parentNode) {
            return parentNode.depth() + 1;
          }
          return 1;
        };

        /**
        * Returns the depth of the deepest subtree under this node
        * @param scope a TreeNodesController scope object
        * @returns Depth of all nodes *beneath* this node. If scope belongs to a leaf node, the
        *   result is 0 (it has no subtree).
        */
        function countSubTreeDepth(scope) {
          if (!scope) {
            return 0;
          }
          var thisLevelDepth = 0,
            childNodes = scope.childNodes(),
            childNode,
            childDepth,
            i;
          if (!childNodes || childNodes.length === 0) {
            return 0;
          }
          for (i = childNodes.length - 1; i >= 0 ; i--) {
            childNode = childNodes[i],
            childDepth = 1 + countSubTreeDepth(childNode);
            thisLevelDepth = Math.max(thisLevelDepth, childDepth);
          }
          return thisLevelDepth;
        }

        $scope.maxSubDepth = function () {
          return $scope.$childNodesScope ? countSubTreeDepth($scope.$childNodesScope) : 0;
        };
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")

    .controller("TreeNodesController", ["$scope", "$element", "$timeout",
      function ($scope, $element, $timeout) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$modelValue = null;
        $scope.$nodeScope = null; // the scope of node which the nodes belongs to
        $scope.$treeScope = null;
        $scope.$type = "uiTreeNodes";
        $scope.$nodesMap = {};

        $scope.nodropEnabled = false;
        $scope.maxDepth = 0;
        $scope.cloneEnabled = false;

        $scope.initSubNode = function (subNode) {
          if (!subNode.$modelValue) {
            return null;
          }
          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = subNode;
        };

        $scope.destroySubNode = function (subNode) {
          if (!subNode.$modelValue) {
            return null;
          }
          $scope.$nodesMap[subNode.$modelValue.$$hashKey] = null;
        };

        $scope.accept = function (sourceNode, destIndex) {
          return $scope.$treeScope.$callbacks.accept(sourceNode, $scope, destIndex);
        };

        $scope.beforeDrag = function (sourceNode) {
          return $scope.$treeScope.$callbacks.beforeDrag(sourceNode);
        };

        $scope.isParent = function (node) {
          return node.$parentNodesScope == $scope;
        };

        $scope.hasChild = function () {
          return $scope.$modelValue.length > 0;
        };

        // Called in apply method of UiTreeHelper.dragInfo.
        $scope.removeNode = function (node) {
          var index = $scope.$modelValue.indexOf(node.$modelValue);
          if (index > -1) {
            $timeout(function () {
              $scope.$modelValue.splice(index, 1)[0];
            });
            return $scope.$treeScope.$callbacks.removed(node);
          }
          return null;
        };

        // Called in apply method of UiTreeHelper.dragInfo.
        $scope.insertNode = function (index, nodeData) {
          $timeout(function () {
            $scope.$modelValue.splice(index, 0, nodeData);
          });
        };

        $scope.childNodes = function () {
          var i, nodes = [];
          if ($scope.$modelValue) {
            for (i = 0; i < $scope.$modelValue.length; i++) {
              nodes.push($scope.$nodesMap[$scope.$modelValue[i].$$hashKey]);
            }
          }
          return nodes;
        };

        $scope.depth = function () {
          if ($scope.$nodeScope) {
            return $scope.$nodeScope.depth();
          }
          return 0; // if it has no $nodeScope, it's root
        };

        // check if depth limit has reached
        $scope.outOfDepth = function (sourceNode) {
          var maxDepth = $scope.maxDepth || $scope.$treeScope.maxDepth;
          if (maxDepth > 0) {
            return $scope.depth() + sourceNode.maxSubDepth() + 1 > maxDepth;
          }
          return false;
        };

      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")

    .controller("TreeController", ["$scope", "$element",
      function ($scope, $element) {
        this.scope = $scope;

        $scope.$element = $element;
        $scope.$nodesScope = null; // root nodes
        $scope.$type = "uiTree";
        $scope.$emptyElm = null;
        $scope.$dropzoneElm = null;
        $scope.$callbacks = null;

        $scope.dragEnabled = true;
        $scope.emptyPlaceholderEnabled = true;
        $scope.maxDepth = 0;
        $scope.dragDelay = 0;
        $scope.cloneEnabled = false;
        $scope.nodropEnabled = false;
        $scope.dropzoneEnabled = false;

        // Check if it's a empty tree
        $scope.isEmpty = function () {
          return ($scope.$nodesScope && $scope.$nodesScope.$modelValue
          && $scope.$nodesScope.$modelValue.length === 0);
        };

        // add placeholder to empty tree
        $scope.place = function (placeElm) {
          $scope.$nodesScope.$element.append(placeElm);
          $scope.$emptyElm.remove();
        };

        this.resetEmptyElement = function () {
          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length === 0) &&
            $scope.emptyPlaceholderEnabled) {
            $element.append($scope.$emptyElm);
          } else {
            $scope.$emptyElm.remove();
          }
        };

        this.resetDropzoneElement = function () {
          if ((!$scope.$nodesScope.$modelValue || $scope.$nodesScope.$modelValue.length !== 0) &&
            $scope.dropzoneEnabled) {
            $element.append($scope.$dropzoneElm);
          } else {
            $scope.$dropzoneElm.remove();
          }
        };

        $scope.resetEmptyElement = this.resetEmptyElement;
        $scope.resetDropzoneElement = this.resetDropzoneElement;
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")
    .directive("uiTree", ["treeConfig", "$window",
      function (treeConfig, $window) {
        return {
          restrict: "A",
          scope: true,
          controller: "TreeController",
          link: function (scope, element, attrs, ctrl) {
            var callbacks = {
                accept: null,
                beforeDrag: null
              },
              config = {},
              tdElm,
              $trElm,
              emptyElmColspan;

            // Adding configured class to uiTree.
            angular.extend(config, treeConfig);

            if (config.treeClass) {
              element.addClass(config.treeClass);
            }

            // Determining if uiTree is on a table.
            if (element.prop("tagName").toLowerCase() === "table") {
              scope.$emptyElm = angular.element($window.document.createElement("tr"));
              $trElm = element.find("tr");

              // If we can find a tr, then we can use its td children as the empty element colspan.
              if ($trElm.length > 0) {
                emptyElmColspan = angular.element($trElm).children().length;
              } else {

                // If not, by setting a huge colspan we make sure it takes full width.
                // TODO(jcarter): Check for negative side effects.
                emptyElmColspan = 1000000;
              }
              tdElm = angular.element($window.document.createElement("td"))
                .attr("colspan", emptyElmColspan);
              scope.$emptyElm.append(tdElm);
            } else {
              scope.$emptyElm = angular.element($window.document.createElement("div"));
              scope.$dropzoneElm = angular.element($window.document.createElement("div"));
            }

            if (config.emptyTreeClass) {
              scope.$emptyElm.addClass(config.emptyTreeClass);
            }
            if (config.dropzoneClass) {
              scope.$dropzoneElm.addClass(config.dropzoneClass);
            }

            scope.$watch("$nodesScope.$modelValue.length", function (val) {
              if (!angular.isNumber(val)) {
                return;
              }

              ctrl.resetEmptyElement();
              ctrl.resetDropzoneElement();
            }, true);

            scope.$watch(attrs.dragEnabled, function (val) {
              if ((typeof val) === "boolean") {
                scope.dragEnabled = val;
              }
            });

            scope.$watch(attrs.emptyPlaceholderEnabled, function (val) {
              if ((typeof val) === "boolean") {
                scope.emptyPlaceholderEnabled = val;
                ctrl.resetEmptyElement();
              }
            });

            scope.$watch(attrs.nodropEnabled, function (val) {
              if ((typeof val) === "boolean") {
                scope.nodropEnabled = val;
              }
            });

            scope.$watch(attrs.dropzoneEnabled, function (val) {
              if ((typeof val) === "boolean") {
                scope.dropzoneEnabled = val;
                ctrl.resetDropzoneElement();
              }
            });

            scope.$watch(attrs.cloneEnabled, function (val) {
              if ((typeof val) === "boolean") {
                scope.cloneEnabled = val;
              }
            });

            scope.$watch(attrs.maxDepth, function (val) {
              if ((typeof val) === "number") {
                scope.maxDepth = val;
              }
            });

            scope.$watch(attrs.dragDelay, function (val) {
              if ((typeof val) === "number") {
                scope.dragDelay = val;
              }
            });

            /**
             * Callback checks if the destination node can accept the dragged node.
             * By default, ui-tree will check that 'data-nodrop-enabled' is not set for the
             * destination ui-tree-nodes, and that the 'max-depth' attribute will not be exceeded
             * if it is set on the ui-tree or ui-tree-nodes.
             * This callback can be overridden, but callers must manually enforce nodrop and max-depth
             * themselves if they need those to be enforced.
             * @param sourceNodeScope Scope of the ui-tree-node being dragged
             * @param destNodesScope Scope of the ui-tree-nodes where the node is hovering
             * @param destIndex Index in the destination nodes array where the source node will drop
             * @returns {boolean} True if the node is permitted to be dropped here
             */
            callbacks.accept = function (sourceNodeScope, destNodesScope, destIndex) {
              return !(destNodesScope.nodropEnabled || destNodesScope.$treeScope.nodropEnabled || destNodesScope.outOfDepth(sourceNodeScope));
            };

            callbacks.beforeDrag = function (sourceNodeScope) {
              return true;
            };

            callbacks.expandTimeoutStart = function ()
            {

            };

            callbacks.expandTimeoutCancel = function ()
            {

            };

            callbacks.expandTimeoutEnd = function ()
            {

            };

            callbacks.removed = function (node) {

            };

            /**
             * Callback is fired when a node is successfully dropped in a new location
             * @param event
             */
            callbacks.dropped = function (event) {

            };

            /**
             * Callback is fired each time the user starts dragging a node
             * @param event
             */
            callbacks.dragStart = function (event) {

            };

            /**
             * Callback is fired each time a dragged node is moved with the mouse/touch.
             * @param event
             */
            callbacks.dragMove = function (event) {

            };

            /**
             * Callback is fired when the tree exits drag mode. If the user dropped a node, the drop may have been
             * accepted or reverted.
             * @param event
             */
            callbacks.dragStop = function (event) {

            };

            /**
             * Callback is fired when a user drops a node (but prior to processing the drop action)
             * beforeDrop can return a Promise, truthy, or falsy (returning nothing is falsy).
             * If it returns falsy, or a resolve Promise, the node move is accepted
             * If it returns truthy, or a rejected Promise, the node move is reverted
             * @param event
             * @returns {Boolean|Promise} Truthy (or rejected Promise) to cancel node move; falsy (or resolved promise)
             */
            callbacks.beforeDrop = function (event) {

            };

            /**
             * Callback is fired when a user toggles node (but after processing the toggle action)
             * @param sourceNodeScope
             * @param collapsed
             */
            callbacks.toggle = function (collapsed, sourceNodeScope) {

            };

            scope.$watch(attrs.uiTree, function (newVal, oldVal) {
              angular.forEach(newVal, function (value, key) {
                if (callbacks[key]) {
                  if (typeof value === "function") {
                    callbacks[key] = value;
                  }
                }
              });

              scope.$callbacks = callbacks;
            }, true);

          }
        };
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")
    .directive("uiTreeHandle", ["treeConfig",
      function (treeConfig) {
        return {
          require: "^uiTreeNode",
          restrict: "A",
          scope: true,
          controller: "TreeHandleController",
          link: function (scope, element, attrs, treeNodeCtrl) {
            var config = {};
            angular.extend(config, treeConfig);
            if (config.handleClass) {
              element.addClass(config.handleClass);
            }
            // connect with the tree node.
            if (scope != treeNodeCtrl.scope) {
              scope.$nodeScope = treeNodeCtrl.scope;
              treeNodeCtrl.scope.$handleScope = scope;
            }
          }
        };
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")

    .directive("uiTreeNode", ["treeConfig", "UiTreeHelper", "$window", "$document", "$timeout", "$q",
      function (treeConfig, UiTreeHelper, $window, $document, $timeout, $q) {
        return {
          require: ["^uiTreeNodes", "^uiTree"],
          restrict: "A",
          controller: "TreeNodeController",
          link: function (scope, element, attrs, controllersArr) {
            var config = {},
              hasTouch = "ontouchstart" in window,
              firstMoving,
              dragInfo,
              pos,
              placeElm,
              hiddenPlaceElm,
              dragElm,
              scrollContainerElm,
              unhover,
              treeScope = null,
              elements, // As a parameter for callbacks
              dragDelaying = true,
              dragStarted = false,
              dragTimer = null,
              body = document.body,
              html = document.documentElement,
              document_height,
              document_width,
              dragStart,
              tagName,
              dragMove,
              dragEnd,
              dragStartEvent,
              dragMoveEvent,
              dragEndEvent,
              dragCancelEvent,
              dragDelay,
              bindDragStartEvents,
              bindDragMoveEvents,
              unbindDragMoveEvents,
              keydownHandler,
              isHandleChild,
              el,
              isUiTreeRoot,
              treeOfOrigin;

            // Adding configured class to ui-tree-node.
            angular.extend(config, treeConfig);

            if (config.nodeClass) {
              element.addClass(config.nodeClass);
            }

            // Call init function in nodeCtrl, sets parent node and sets up sub nodes.
            scope.init(controllersArr);

            scope.collapsed = !!UiTreeHelper.getNodeAttribute(scope, "collapsed") || treeConfig.defaultCollapsed;
            scope.expandOnHover = !!UiTreeHelper.getNodeAttribute(scope, "expandOnHover");
            scope.scrollContainer = UiTreeHelper.getNodeAttribute(scope, "scrollContainer") || attrs.scrollContainer || null;
            scope.sourceOnly = scope.nodropEnabled || scope.$treeScope.nodropEnabled;

            scope.$watch(attrs.collapsed, function (val) {
              if ((typeof val) === "boolean") {
                scope.collapsed = val;
              }
            });

            // Watches to trigger behavior based on actions and settings.
            scope.$watch("collapsed", function (val) {
              UiTreeHelper.setNodeAttribute(scope, "collapsed", val);
              attrs.$set("collapsed", val);
            });

            scope.$watch(attrs.expandOnHover, function (val) {
              if ((typeof val) === "boolean" || (typeof val) === "number") {
                scope.expandOnHover = val;
              }
            });

            scope.$watch("expandOnHover", function (val) {
              UiTreeHelper.setNodeAttribute(scope, "expandOnHover", val);
              attrs.$set("expandOnHover", val);
            });

            attrs.$observe("scrollContainer", function (val) {
              if ((typeof val) === "string") {
                scope.scrollContainer = val;
              }
            });

            scope.$watch("scrollContainer", function (val) {
              UiTreeHelper.setNodeAttribute(scope, "scrollContainer", val);
              attrs.$set("scrollContainer", val);
              scrollContainerElm = document.querySelector(val);
            });

            scope.$on("angular-ui-tree:collapse-all", function () {
              scope.collapsed = true;
            });

            scope.$on("angular-ui-tree:expand-all", function () {
              scope.collapsed = false;
            });

            /**
             * Called when the user has grabbed a node and started dragging it.
             *
             * @param {MouseEvent} e event that is triggered by DOM.
             * @return undefined?
             */
            dragStart = function (e) {

              // Disable right click.
              if (!hasTouch && (e.button === 2 || e.which === 3)) {
                return;
              }

              // Event has already fired in other scope.
              if (e.uiTreeDragging || (e.originalEvent && e.originalEvent.uiTreeDragging)) {
                return;
              }

              // The node being dragged.
              var eventElm = angular.element(e.target),
                isHandleChild,
                cloneElm,
                eventElmTagName,
                tagName,
                eventObj,
                tdElm,
                hStyle,
                isTreeNode,
                isTreeNodeHandle;

              // If the target element is a child element of a ui-tree-handle,
              // use the containing handle element as target element.
              isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(eventElm);
              if (isHandleChild) {
                eventElm = angular.element(isHandleChild);
              }

              cloneElm = element.clone();
              isTreeNode = UiTreeHelper.elementIsTreeNode(eventElm);
              isTreeNodeHandle = UiTreeHelper.elementIsTreeNodeHandle(eventElm);

              // If we are not triggering mousedown on our uiTree or any of it's parts, return.
              if (!isTreeNode && !isTreeNodeHandle) {
                return;
              }

              // If we are not triggering mousedown on our uiTree or any of it's parts, return.
              if (isTreeNode && UiTreeHelper.elementContainsTreeNodeHandler(eventElm)) {
                return;
              }

              // Dragging not allowed on inputs or buttons.
              eventElmTagName = eventElm.prop("tagName").toLowerCase();
              if (eventElmTagName == "input" ||
                  eventElmTagName == "textarea" ||
                  eventElmTagName == "button" ||
                  eventElmTagName == "select") {
                return;
              }

              // Check if it or it's parents has a 'data-nodrag' attribute
              el = angular.element(e.target);
              isUiTreeRoot = el[0].attributes["ui-tree"];
              while (el && el[0] && el[0] !== element && !isUiTreeRoot) {

                // Checking that I can access attributes.
                if (el[0].attributes) {
                  isUiTreeRoot = el[0].attributes["ui-tree"];
                }

                // If the node mark as `nodrag`, DONOT drag it.
                if (UiTreeHelper.nodrag(el)) {
                  return;
                }
                el = el.parent();
              }

              // If users beforeDrag calback returns falsey, do not initiate.
              if (!scope.beforeDrag(scope)) {
                return;
              }

              // Set property checked at start of function to prevent running logic again.
              e.uiTreeDragging = true;
              if (e.originalEvent) {
                e.originalEvent.uiTreeDragging = true;
              }
              e.preventDefault();

              // Get original event if TouchEvent.
              eventObj = UiTreeHelper.eventObj(e);

              // Set boolean used to specify beginning of move.
              firstMoving = true;

              // Setting drag info properties and methods in scope of node being moved.
              dragInfo = UiTreeHelper.dragInfo(scope);

              // Setting original tree to adjust horizontal behavior in drag move.
              treeOfOrigin = dragInfo.source.$treeScope.$id;

              // Determine tage name of element ui-tree-node is on.
              tagName = element.prop("tagName");

              if (tagName.toLowerCase() === "tr") {

                // Create a new table column as placeholder.
                placeElm = angular.element($window.document.createElement(tagName));

                // Create a column placeholder and set colspan to whole row length.
                tdElm = angular.element($window.document.createElement("td"))
                  .addClass(config.placeholderClass)
                  .attr("colspan", element[0].children.length);
                placeElm.append(tdElm);
              } else {

                // If not a table just duplicate element and add placeholder class.
                placeElm = angular.element($window.document.createElement(tagName))
                  .addClass(config.placeholderClass);
              }

              // Create a hidden placeholder and add class from config.
              hiddenPlaceElm = angular.element($window.document.createElement(tagName));
              if (config.hiddenClass) {
                hiddenPlaceElm.addClass(config.hiddenClass);
              }

              // Getting starting position of element being moved.
              pos = UiTreeHelper.positionStarted(eventObj, element);
              placeElm.css("height", element.prop("offsetHeight") + "px");

              // Creating drag element to represent node.
              dragElm = angular.element($window.document.createElement(scope.$parentNodesScope.$element.prop("tagName")))
                .addClass(scope.$parentNodesScope.$element.attr("class")).addClass(config.dragClass);
              dragElm.css("width", UiTreeHelper.width(element) + "px");
              dragElm.css("z-index", 9999);

              // Prevents cursor to change rapidly in Opera 12.16 and IE when dragging an element.
              hStyle = (element[0].querySelector(".angular-ui-tree-handle") || element[0]).currentStyle;
              if (hStyle) {
                document.body.setAttribute("ui-tree-cursor", $document.find("body").css("cursor") || "");
                $document.find("body").css({ "cursor": hStyle.cursor + "!important" });
              }

              // If tree is sourceOnly (noDragDrop) don't show placeholder when moving about it.
              if (scope.sourceOnly) {
                placeElm.css("display", "none");
              }

              // Insert placeholder.
              element.after(placeElm);
              element.after(hiddenPlaceElm);
              if (dragInfo.isClone() && scope.sourceOnly) {
                dragElm.append(cloneElm);
              } else {
                dragElm.append(element);
              }

              // Create drag element.
              $document.find("body").append(dragElm);

              // Set drag elements position on screen.
              dragElm.css({
                "left": eventObj.pageX - pos.offsetX + "px",
                "top": eventObj.pageY - pos.offsetY + "px"
              });
              elements = {
                placeholder: placeElm,
                dragging: dragElm
              };

              // Create all drag/move bindings.
              bindDragMoveEvents();

              // Fire dragStart callback.
              scope.$apply(function () {
                scope.$treeScope.$callbacks.dragStart(dragInfo.eventArgs(elements, pos));
              });

              // Get bounds of document.
              document_height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
              document_width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
            };

            dragMove = function (e) {
              var eventObj = UiTreeHelper.eventObj(e),
                prev,
                next,
                leftElmPos,
                topElmPos,
                top_scroll,
                bottom_scroll,
                scrollContainerElmRect,
                target,
                targetX,
                targetY,
                displayElm,
                targetNode,
                targetElm,
                isEmpty,
                scrollDownBy,
                scrollUpBy,
                targetOffset,
                targetBefore,
                moveWithinTree,
                targetBeforeBuffer,
                targetHeight,
                targetChildElm,
                targetChildHeight,
                isDropzone;

              // If check ensures that drag element was created.
              if (dragElm) {
                e.preventDefault();

                // Deselect anything (text, etc.) that was selected when move began.
                if ($window.getSelection) {
                  $window.getSelection().removeAllRanges();
                } else if ($window.document.selection) {
                  $window.document.selection.empty();
                }

                // Get top left positioning of element being moved.
                leftElmPos = eventObj.pageX - pos.offsetX;
                topElmPos = eventObj.pageY - pos.offsetY;

                // dragElm can't leave the screen on the left.
                if (leftElmPos < 0) {
                  leftElmPos = 0;
                }

                // dragElm can't leave the screen on the top.
                if (topElmPos < 0) {
                  topElmPos = 0;
                }

                // dragElm can't leave the screen on the bottom.
                if ((topElmPos + 10) > document_height) {
                  topElmPos = document_height - 10;
                }

                // dragElm can't leave the screen on the right.
                if ((leftElmPos + 10) > document_width) {
                  leftElmPos = document_width - 10;
                }

                // Updating element being moved css.
                dragElm.css({
                  "left": leftElmPos + "px",
                  "top": topElmPos + "px"
                });

                if (scrollContainerElm) {
                  // Getting position to top and bottom of container element.
                  scrollContainerElmRect = scrollContainerElm.getBoundingClientRect();
                  top_scroll = scrollContainerElm.scrollTop;
                  bottom_scroll = top_scroll + scrollContainerElm.clientHeight;

                  // To scroll down if cursor y-position is greater than the bottom position of the container vertical scroll
                  if (scrollContainerElmRect.bottom < eventObj.clientY && bottom_scroll < scrollContainerElm.scrollHeight) {
                    scrollDownBy = Math.min(scrollContainerElm.scrollHeight - bottom_scroll, 10);
                    scrollContainerElm.scrollTop += scrollDownBy;
                  }

                  // To scroll top if cursor y-position is less than the top position of the container vertical scroll
                  if (scrollContainerElmRect.top > eventObj.clientY && top_scroll > 0) {
                    scrollUpBy = Math.min(top_scroll, 10);
                    scrollContainerElm.scrollTop -= scrollUpBy;
                  }
                } else {
                  // Getting position to top and bottom of page.
                  top_scroll = window.pageYOffset || $window.document.documentElement.scrollTop;
                  bottom_scroll = top_scroll + (window.innerHeight || $window.document.clientHeight || $window.document.clientHeight);

                  // To scroll down if cursor y-position is greater than the bottom position of the window vertical scroll
                  if (bottom_scroll < eventObj.pageY && bottom_scroll < document_height) {
                    scrollDownBy = Math.min(document_height - bottom_scroll, 10);
                    window.scrollBy(0, scrollDownBy);
                  }

                  // To scroll top if cursor y-position is less than the top position of the window vertical scroll
                  if (top_scroll > eventObj.pageY) {
                    scrollUpBy = Math.min(top_scroll, 10);
                    window.scrollBy(0, -scrollUpBy);
                  }
                }

                // Calling service to update position coordinates based on move.
                UiTreeHelper.positionMoved(e, pos, firstMoving);
                if (firstMoving) {
                  firstMoving = false;
                  return;
                }

                // Setting X point for elementFromPoint.
                targetX = eventObj.pageX - ($window.pageXOffset ||
                    $window.document.body.scrollLeft ||
                    $window.document.documentElement.scrollLeft) -
                    ($window.document.documentElement.clientLeft || 0);

                targetY = eventObj.pageY - ($window.pageYOffset ||
                    $window.document.body.scrollTop ||
                    $window.document.documentElement.scrollTop) -
                    ($window.document.documentElement.clientTop || 0);

                // Select the drag target. Because IE does not support CSS 'pointer-events: none', it will always
                // pick the drag element itself as the target. To prevent this, we hide the drag element while
                // selecting the target.
                if (angular.isFunction(dragElm.hide)) {
                  dragElm.hide();
                } else {
                  displayElm = dragElm[0].style.display;
                  dragElm[0].style.display = "none";
                }

                // When using elementFromPoint() inside an iframe, you have to call
                // elementFromPoint() twice to make sure IE8 returns the correct value
                // MDN: The elementFromPoint() method of the Document interface returns the topmost element at the specified coordinates.
                $window.document.elementFromPoint(targetX, targetY);

                // Set target element (element in specified x/y coordinates).
                targetElm = angular.element($window.document.elementFromPoint(targetX, targetY));

                // If the target element is a child element of a ui-tree-handle,
                // use the containing handle element as target element
                isHandleChild = UiTreeHelper.treeNodeHandlerContainerOfElement(targetElm);
                if (isHandleChild) {
                  targetElm = angular.element(isHandleChild);
                }

                if (angular.isFunction(dragElm.show)) {
                  dragElm.show();
                } else {
                  dragElm[0].style.display = displayElm;
                }

                // Assigning scope to target you are moving draggable over.
                if (UiTreeHelper.elementIsTree(targetElm)) {
                  targetNode = targetElm.controller("uiTree").scope;
                } else if (UiTreeHelper.elementIsTreeNodeHandle(targetElm)) {
                  targetNode = targetElm.controller("uiTreeHandle").scope;
                } else if (UiTreeHelper.elementIsTreeNode(targetElm)) {
                  targetNode = targetElm.controller("uiTreeNode").scope;
                } else if (UiTreeHelper.elementIsTreeNodes(targetElm)) {
                  targetNode = targetElm.controller("uiTreeNodes").scope;
                } else if (UiTreeHelper.elementIsPlaceholder(targetElm)) {
                  targetNode = targetElm.controller("uiTreeNodes").scope;
                } else if (UiTreeHelper.elementIsDropzone(targetElm)) {
                  targetNode = targetElm.controller("uiTree").scope;
                  isDropzone = true;
                } else if (targetElm.controller("uiTreeNode")) {
                  // Is a child element of a node.
                  targetNode = targetElm.controller("uiTreeNode").scope;
                }

                moveWithinTree = (targetNode && targetNode.$treeScope && targetNode.$treeScope.$id && targetNode.$treeScope.$id === treeOfOrigin);

                /* (jcarter) Notes to developers:
                 *  pos.dirAx is either 0 or 1
                 *  1 means horizontal movement is happening
                 *  0 means vertical movement is happening
                 */

                // Move nodes up and down in nesting level.
                if (moveWithinTree && pos.dirAx) {

                  // increase horizontal level if previous sibling exists and is not collapsed
                  // example 1.1.1 becomes 1.2
                  if (pos.distX > 0) {
                    prev = dragInfo.prev();
                    if (prev && !prev.collapsed
                      && prev.accept(scope, prev.childNodesCount())) {
                      prev.$childNodesScope.$element.append(placeElm);
                      dragInfo.moveTo(prev.$childNodesScope, prev.childNodes(), prev.childNodesCount());
                    }
                  }

                  // decrease horizontal level
                  // example 1.2 become 1.1.1
                  if (pos.distX < 0) {
                    // we can't decrease a level if an item preceeds the current one
                    next = dragInfo.next();
                    if (!next) {
                      target = dragInfo.parentNode(); // As a sibling of it's parent node
                      if (target
                        && target.$parentNodesScope.accept(scope, target.index() + 1)) {
                        target.$element.after(placeElm);
                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
                      }
                    }
                  }
                } else { // Either in origin tree and moving horizontally OR you are moving within a new tree.

                  // Check it's new position.
                  isEmpty = false;

                  // Exit if target is not a uiTree or child of one.
                  if (!targetNode) {
                    return;
                  }

                  // Show the placeholder if it was hidden for nodrop-enabled and this is a new tree
                  if (targetNode.$treeScope && !targetNode.$parent.nodropEnabled && !targetNode.$treeScope.nodropEnabled) {
                    placeElm.css("display", "");
                  }

                  // Set whether target tree is empty or not.
                  if (targetNode.$type === "uiTree" && targetNode.dragEnabled) {
                    isEmpty = targetNode.isEmpty();
                  }

                  // If target is a handle set new target to handle's node.
                  if (targetNode.$type === "uiTreeHandle") {
                    targetNode = targetNode.$nodeScope;
                  }

                  // Check if it is a uiTreeNode or it's an empty tree or it's a dropzone.
                  if (targetNode.$type !== "uiTreeNode" && !isEmpty && !isDropzone) {

                    // Allow node to return to its original position if no longer hovering over target
                    if (config.appendChildOnHover) {
                      next = dragInfo.next();
                      if (!next && unhover) {
                        target = dragInfo.parentNode();
                        target.$element.after(placeElm);
                        dragInfo.moveTo(target.$parentNodesScope, target.siblings(), target.index() + 1);
                        unhover = false;
                      }
                    }
                    return;
                  }

                  // If placeholder move from empty tree, reset it.
                  if (treeScope && placeElm.parent()[0] != treeScope.$element[0]) {
                    treeScope.resetEmptyElement();
                    treeScope.resetDropzoneElement();
                    treeScope = null;
                  }

                  // It's an empty tree
                  if (isEmpty) {
                    treeScope = targetNode;
                    if (targetNode.$nodesScope.accept(scope, 0)) {
                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), 0);
                    }
                  // It's a dropzone
                  } else if (isDropzone) {
                    treeScope = targetNode;
                    if (targetNode.$nodesScope.accept(scope, targetNode.$nodesScope.childNodes().length)) {
                      dragInfo.moveTo(targetNode.$nodesScope, targetNode.$nodesScope.childNodes(), targetNode.$nodesScope.childNodes().length);
                    }
                  // Not empty and drag enabled.
                  } else if (targetNode.dragEnabled()) {

                    // Setting/Resetting data for exanding on hover.
                    if (angular.isDefined(scope.expandTimeoutOn) && scope.expandTimeoutOn !== targetNode.id) {
                      $timeout.cancel(scope.expandTimeout);
                      delete scope.expandTimeout;
                      delete scope.expandTimeoutOn;

                      scope.$callbacks.expandTimeoutCancel();
                    }

                    // Determining if expansion is needed.
                    if (targetNode.collapsed) {
                      if (scope.expandOnHover === true || (angular.isNumber(scope.expandOnHover) && scope.expandOnHover === 0)) {
                        targetNode.collapsed = false;
                        targetNode.$treeScope.$callbacks.toggle(false, targetNode);
                      } else if (scope.expandOnHover !== false && angular.isNumber(scope.expandOnHover) && scope.expandOnHover > 0) {

                        // Triggering expansion.
                        if (angular.isUndefined(scope.expandTimeoutOn)) {
                          scope.expandTimeoutOn = targetNode.$id;

                          scope.$callbacks.expandTimeoutStart();
                          scope.expandTimeout = $timeout(function ()
                          {
                            scope.$callbacks.expandTimeoutEnd();
                            targetNode.collapsed = false;
                            targetNode.$treeScope.$callbacks.toggle(false, targetNode);
                          }, scope.expandOnHover);
                        }
                      }
                    }

                    // Get the element of ui-tree-node
                    targetElm = targetNode.$element;
                    targetOffset = UiTreeHelper.offset(targetElm);
                    targetHeight = UiTreeHelper.height(targetElm);
                    targetChildElm = targetNode.$childNodesScope ? targetNode.$childNodesScope.$element : null;
                    targetChildHeight = targetChildElm ? UiTreeHelper.height(targetChildElm) : 0;
                    targetHeight -= targetChildHeight;
                    targetBeforeBuffer = config.appendChildOnHover ? targetHeight * 0.25 : UiTreeHelper.height(targetElm) / 2;
                    targetBefore = eventObj.pageY < (targetOffset.top + targetBeforeBuffer);

                    if (targetNode.$parentNodesScope.accept(scope, targetNode.index())) {
                      if (targetBefore) {
                        targetElm[0].parentNode.insertBefore(placeElm[0], targetElm[0]);
                        dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index());
                      } else {
                        // Try to append as a child if dragged upwards onto targetNode
                        if (config.appendChildOnHover && targetNode.accept(scope, targetNode.childNodesCount())) {
                          targetNode.$childNodesScope.$element.prepend(placeElm);
                          dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), 0);
                          unhover = true;
                        } else {
                          targetElm.after(placeElm);
                          dragInfo.moveTo(targetNode.$parentNodesScope, targetNode.siblings(), targetNode.index() + 1);
                        }
                      }

                    // We have to check if it can add the dragging node as a child.
                    } else if (!targetBefore && targetNode.accept(scope, targetNode.childNodesCount())) {
                      targetNode.$childNodesScope.$element.append(placeElm);
                      dragInfo.moveTo(targetNode.$childNodesScope, targetNode.childNodes(), targetNode.childNodesCount());
                    }
                  }
                }

                // Triggering dragMove callback.
                scope.$apply(function () {
                  scope.$treeScope.$callbacks.dragMove(dragInfo.eventArgs(elements, pos));
                });
              }
            };

            dragEnd = function (e) {

              var dragEventArgs = dragInfo.eventArgs(elements, pos);

              e.preventDefault();

              // TODO(jcarter): Is dragStart need to be unbound?
              unbindDragMoveEvents();

              // This cancel the collapse/expand login running.
              $timeout.cancel(scope.expandTimeout);

              scope.$treeScope.$apply(function () {
                $q.when(scope.$treeScope.$callbacks.beforeDrop(dragEventArgs))

                // Promise resolved (or callback didn't return false)
                  .then(function (allowDrop) {
                    if (allowDrop !== false && scope.$$allowNodeDrop) {
                      // Node drop accepted.
                      dragInfo.apply();

                      // Fire the dropped callback only if the move was successful.
                      scope.$treeScope.$callbacks.dropped(dragEventArgs);
                    } else {
                      // Drop canceled - revert the node to its original position.
                      bindDragStartEvents();
                    }
                  })

                // Promise rejected - revert the node to its original position.
                  .catch(function () {
                    bindDragStartEvents();
                  })
                  .finally(function () {

                    // Replace placeholder with newly dropped element.
                    hiddenPlaceElm.replaceWith(scope.$element);
                    placeElm.remove();

                    // Remove drag element if still in DOM.
                    if (dragElm) {
                      dragElm.remove();
                      dragElm = null;
                    }

                    // Fire dragStope callback.
                    scope.$treeScope.$callbacks.dragStop(dragEventArgs);
                    scope.$$allowNodeDrop = false;
                    dragInfo = null;

                    // Restore cursor in Opera 12.16 and IE
                    var oldCur = document.body.getAttribute("ui-tree-cursor");
                    if (oldCur !== null) {
                      $document.find("body").css({ "cursor": oldCur });
                      document.body.removeAttribute("ui-tree-cursor");
                    }
                  });
              });
            };

            dragStartEvent = function (e) {
              if (scope.dragEnabled()) {
                dragStart(e);
              }
            };

            dragMoveEvent = function (e) {
              dragMove(e);
            };

            dragEndEvent = function (e) {
              scope.$$allowNodeDrop = true;
              dragEnd(e);
            };

            dragCancelEvent = function (e) {
              dragEnd(e);
            };

            dragDelay = (function () {
              var to;

              return {
                exec: function (fn, ms) {
                  if (!ms) {
                    ms = 0;
                  }
                  this.cancel();
                  to = $timeout(fn, ms);
                },
                cancel: function () {
                  $timeout.cancel(to);
                }
              };
            })();

            keydownHandler = function (e) {
              if (e.keyCode === 27) {
                dragEndEvent(e);
              }
            };

            /**
             * Binds the mouse/touch events to enable drag start for this node.
             */
            // This is outside of bindDragMoveEvents because of the potential for a delay setting.
            bindDragStartEvents = function () {
              element.bind("touchstart mousedown", function (e) {
                // Don't call drag delay if no delay was specified.
                if (scope.dragDelay > 0) {
                  dragDelay.exec(function () {
                    dragStartEvent(e);
                  }, scope.dragDelay);
                } else {
                  dragStartEvent(e);
                }
              });
              element.bind("touchend touchcancel mouseup", function () {
                if (scope.dragDelay > 0) {
                  dragDelay.cancel();
                }
              });
            };
            bindDragStartEvents();

            /**
             * Binds mouse/touch events that handle moving/dropping this dragged node
             */
            bindDragMoveEvents = function () {
              angular.element($document).bind("touchend", dragEndEvent);
              angular.element($document).bind("touchcancel", dragEndEvent);
              angular.element($document).bind("touchmove", dragMoveEvent);
              angular.element($document).bind("mouseup", dragEndEvent);
              angular.element($document).bind("mousemove", dragMoveEvent);
              angular.element($document).bind("mouseleave", dragCancelEvent);
              angular.element($document).bind("keydown", keydownHandler);
            };

            /**
             * Unbinds mouse/touch events that handle moving/dropping this dragged node.
             */
            unbindDragMoveEvents = function () {
              angular.element($document).unbind("touchend", dragEndEvent);
              angular.element($document).unbind("touchcancel", dragEndEvent);
              angular.element($document).unbind("touchmove", dragMoveEvent);
              angular.element($document).unbind("mouseup", dragEndEvent);
              angular.element($document).unbind("mousemove", dragMoveEvent);
              angular.element($document).unbind("mouseleave", dragCancelEvent);
              angular.element($document).unbind("keydown", keydownHandler);
            };
          }
        };
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")
    .directive("uiTreeNodes", ["treeConfig", "$window",
      function (treeConfig) {
        return {
          require: ["ngModel", "?^uiTreeNode", "^uiTree"],
          restrict: "A",
          scope: true,
          controller: "TreeNodesController",
          link: function (scope, element, attrs, controllersArr) {

            var config = {},
              ngModel = controllersArr[0],
              treeNodeCtrl = controllersArr[1],
              treeCtrl = controllersArr[2];

            angular.extend(config, treeConfig);
            if (config.nodesClass) {
              element.addClass(config.nodesClass);
            }

            if (treeNodeCtrl) {
              treeNodeCtrl.scope.$childNodesScope = scope;
              scope.$nodeScope = treeNodeCtrl.scope;
            } else {
              // find the root nodes if there is no parent node and have a parent ui-tree
              treeCtrl.scope.$nodesScope = scope;
            }
            scope.$treeScope = treeCtrl.scope;

            if (ngModel) {
              ngModel.$render = function () {
                scope.$modelValue = ngModel.$modelValue;
              };
            }

            scope.$watch(function () {
              return attrs.maxDepth;
            }, function (val) {
              if ((typeof val) === "number") {
                scope.maxDepth = val;
              }
            });

            scope.$watch(function () {
              return attrs.nodropEnabled;
            }, function (newVal) {
              if ((typeof newVal) !== "undefined") {
                scope.nodropEnabled = true;
              }
            }, true);

          }
        };
      }
    ]);
})();

(function () {
  "use strict";

  angular.module("ui.tree")

  /**
   * @ngdoc service
   * @name ui.tree.service:UiTreeHelper
   * @requires ng.$document
   * @requires ng.$window
   *
   * @description
   * angular-ui-tree.
   */
    .factory("UiTreeHelper", ["$document", "$window", "treeConfig",
      function ($document, $window, treeConfig) {
        return {

          /**
           * A hashtable used to storage data of nodes
           * @type {Object}
           */
          nodesData: {},

          setNodeAttribute: function (scope, attrName, val) {
            if (!scope.$modelValue) {
              return null;
            }
            var data = this.nodesData[scope.$modelValue.$$hashKey];
            if (!data) {
              data = {};
              this.nodesData[scope.$modelValue.$$hashKey] = data;
            }
            data[attrName] = val;
          },

          getNodeAttribute: function (scope, attrName) {
            if (!scope.$modelValue) {
              return null;
            }
            var data = this.nodesData[scope.$modelValue.$$hashKey];
            if (data) {
              return data[attrName];
            }
            return null;
          },

          /**
           * @ngdoc method
           * @methodOf ui.tree.service:$nodrag
           * @param  {Object} targetElm angular element
           * @return {Bool} check if the node can be dragged.
           */
          nodrag: function (targetElm) {
            if (typeof targetElm.attr("data-nodrag") !== "undefined") {
              return targetElm.attr("data-nodrag") !== "false";
            }
            return false;
          },

          /**
           * Get the event object for touches.
           *
           * @param  {MouseEvent|TouchEvent} e MouseEvent or TouchEvent that kicked off dragX method.
           * @return {MouseEvent|TouchEvent} Object returned as original event object.
           */
          eventObj: function (e) {
            var obj = e;
            if (e.targetTouches !== undefined) {
              // Set obj equal to the first Touch object in the TouchList.
              obj = e.targetTouches.item(0);
            // Logic to set obj to original TouchEvent.
            } else if (e.originalEvent !== undefined && e.originalEvent.targetTouches !== undefined) {
              obj = e.originalEvent.targetTouches.item(0);
            }
            return obj;
          },

          /**
           * Generate object used to store data about node being moved.
           *
           * {angular.$scope} node Scope of the node that is being moved.
           */
          dragInfo: function (node) {
            return {
              source: node,
              sourceInfo: {
                cloneModel: node.$treeScope.cloneEnabled === true ? angular.copy(node.$modelValue) : undefined,
                nodeScope: node,
                index: node.index(),
                nodesScope: node.$parentNodesScope
              },
              index: node.index(),

              // Slice(0) just duplicates an array.
              siblings: node.siblings().slice(0),
              parent: node.$parentNodesScope,

              // Reset parent to source parent.
              resetParent: function () {
                this.parent = node.$parentNodesScope;
              },

              // Move the node to a new position, determining where the node will be inserted to when dropped happens here.
              moveTo: function (parent, siblings, index) {
                this.parent = parent;

                // Duplicate siblings array.
                this.siblings = siblings.slice(0);

                // If source node is in the target nodes
                var i = this.siblings.indexOf(this.source);
                if (i > -1) {
                  this.siblings.splice(i, 1);
                  if (this.source.index() < index) {
                    index--;
                  }
                }

                this.siblings.splice(index, 0, this.source);
                this.index = index;
              },

              // Get parent nodes nodeScope.
              parentNode: function () {
                return this.parent.$nodeScope;
              },

              // Get previous sibling node.
              prev: function () {
                if (this.index > 0) {
                  return this.siblings[this.index - 1];
                }

                return null;
              },

              // Get next sibling node.
              next: function () {
                if (this.index < this.siblings.length - 1) {
                  return this.siblings[this.index + 1];
                }

                return null;
              },

              // Return what cloneEnabled is set to on uiTree.
              isClone: function () {
                return this.source.$treeScope.cloneEnabled === true;
              },

              // Returns a copy of node passed in.
              clonedNode: function (node) {
                return angular.copy(node);
              },

              // Returns true if parent or index have changed (move happened within any uiTree).
              isDirty: function () {
                return this.source.$parentNodesScope != this.parent ||
                  this.source.index() != this.index;
              },

              // Return whether node has a new parent (set on moveTo method).
              isForeign: function () {
                return this.source.$treeScope !== this.parent.$treeScope;
              },

              // Sets arguments passed to user callbacks.
              eventArgs: function (elements, pos) {
                return {
                  source: this.sourceInfo,
                  dest: {
                    index: this.index,
                    nodesScope: this.parent
                  },
                  elements: elements,
                  pos: pos
                };
              },

              // Method that actually manipulates the node being moved.
              apply: function () {

                var nodeData = this.source.$modelValue;

                // Nodrop enabled on tree or parent
                if (this.parent.nodropEnabled || this.parent.$treeScope.nodropEnabled) {
                  return;
                }

                // Node was dropped in the same place - do nothing.
                if (!this.isDirty()) {
                  return;
                }

                // CloneEnabled and cross-tree so copy and do not remove from source.
                if (this.isClone() && this.isForeign()) {
                  this.parent.insertNode(this.index, this.sourceInfo.cloneModel);
                // Any other case, remove and reinsert.
                } else {
                  this.source.remove();
                  this.parent.insertNode(this.index, nodeData);
                }
              }
            };
          },

          /**
           * @ngdoc method
           * @name ui.tree#height
           * @methodOf ui.tree.service:UiTreeHelper
           *
           * @description
           * Get the height of an element.
           *
           * @param {Object} element Angular element.
           * @returns {String} Height
           */
          height: function (element) {
            return element.prop("scrollHeight");
          },

          /**
           * @ngdoc method
           * @name ui.tree#width
           * @methodOf ui.tree.service:UiTreeHelper
           *
           * @description
           * Get the width of an element.
           *
           * @param {Object} element Angular element.
           * @returns {String} Width
           */
          width: function (element) {
            return element.prop("scrollWidth");
          },

          /**
           * @ngdoc method
           * @name ui.tree#offset
           * @methodOf ui.nestedSortable.service:UiTreeHelper
           *
           * @description
           * Get the offset values of an element.
           *
           * @param {Object} element Angular element.
           * @returns {Object} Object with properties width, height, top and left
           */
          offset: function (element) {
            var boundingClientRect = element[0].getBoundingClientRect();

            return {
              width: element.prop("offsetWidth"),
              height: element.prop("offsetHeight"),
              top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
              left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
            };
          },

          /**
           * @ngdoc method
           * @name ui.tree#positionStarted
           * @methodOf ui.tree.service:UiTreeHelper
           *
           * @description
           * Get the start position of the target element according to the provided event properties.
           *
           * @param {Object} e Event
           * @param {Object} target Target element
           * @returns {Object} Object with properties offsetX, offsetY, startX, startY, nowX and dirX.
           */
          positionStarted: function (e, target) {
            var pos = {},
              pageX = e.pageX,
              pageY = e.pageY;

            // Check to set correct data for TouchEvents
            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
              pageX = e.originalEvent.touches[0].pageX;
              pageY = e.originalEvent.touches[0].pageY;
            }
            pos.offsetX = pageX - this.offset(target).left;
            pos.offsetY = pageY - this.offset(target).top;
            pos.startX = pos.lastX = pageX;
            pos.startY = pos.lastY = pageY;
            pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
            pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
            return pos;
          },

          positionMoved: function (e, pos, firstMoving) {

            var pageX = e.pageX,
              pageY = e.pageY,
              newAx;

            // If there are multiple touch points, choose one to use as X and Y.
            if (e.originalEvent && e.originalEvent.touches && (e.originalEvent.touches.length > 0)) {
              pageX = e.originalEvent.touches[0].pageX;
              pageY = e.originalEvent.touches[0].pageY;
            }

            // Mouse position last event.
            pos.lastX = pos.nowX;
            pos.lastY = pos.nowY;

            // Mouse position this event.
            pos.nowX = pageX;
            pos.nowY = pageY;

            // Distance mouse moved between events.
            pos.distX = pos.nowX - pos.lastX;
            pos.distY = pos.nowY - pos.lastY;

            // Direction mouse was moving.
            pos.lastDirX = pos.dirX;
            pos.lastDirY = pos.dirY;

            // Direction mouse is now moving (on both axis).
            pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
            pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

            // Axis mouse is now moving on.
            newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

            // Do nothing on first move.
            if (firstMoving) {
              pos.dirAx = newAx;
              pos.moving = true;
              return;
            }

            // Calc distance moved on this axis (and direction).
            if (pos.dirAx !== newAx) {
              pos.distAxX = 0;
              pos.distAxY = 0;
            } else {
              pos.distAxX += Math.abs(pos.distX);
              if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
                pos.distAxX = 0;
              }
              pos.distAxY += Math.abs(pos.distY);
              if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
                pos.distAxY = 0;
              }
            }
            pos.dirAx = newAx;
          },

          elementIsTreeNode: function (element) {
            return typeof element.attr("ui-tree-node") !== "undefined";
          },

          elementIsTreeNodeHandle: function (element) {
            return typeof element.attr("ui-tree-handle") !== "undefined";
          },
          elementIsTree: function (element) {
            return typeof element.attr("ui-tree") !== "undefined";
          },
          elementIsTreeNodes: function (element) {
            return typeof element.attr("ui-tree-nodes") !== "undefined";
          },
          elementIsPlaceholder: function (element) {
            return element.hasClass(treeConfig.placeholderClass);
          },
          elementIsDropzone: function (element) {
            return element.hasClass(treeConfig.dropzoneClass);
          },
          elementContainsTreeNodeHandler: function (element) {
            return element[0].querySelectorAll("[ui-tree-handle]").length >= 1;
          },
          treeNodeHandlerContainerOfElement: function (element) {
            return findFirstParentElementWithAttribute("ui-tree-handle", element[0]);
          }
        };
      }
    ]);

  // TODO: optimize this loop
  // (Jcarter): Suggest adding a parent element property on uiTree, then all these bubble
  // to <html> can trigger to stop when they reach the parent.
  function findFirstParentElementWithAttribute(attributeName, childObj) {
    // Undefined if the mouse leaves the browser window
    if (childObj === undefined) {
      return null;
    }
    var testObj = childObj.parentNode,
      count = 1,
      // Check for setAttribute due to exception thrown by Firefox when a node is dragged outside the browser window
      res = (typeof testObj.setAttribute === "function" && testObj.hasAttribute(attributeName)) ? testObj : null;
    while (testObj && typeof testObj.setAttribute === "function" && !testObj.hasAttribute(attributeName)) {
      testObj = testObj.parentNode;
      res = testObj;
      // Stop once we reach top of page.
      if (testObj === document.documentElement) {
        res = null;
        break;
      }
      count++;
    }
    return res;
  }

})();

